
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("inVNu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IssueCreateAppWithApolloProviderEntrypoint", () => $558a346803bb9c9a$export$bdacb64dcf3c214f);
$parcel$export(module.exports, "default", () => $558a346803bb9c9a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ApolloClientProvider", () => (parcelRequire("AeWM3")).ApolloClientProvider);
$parcel$export(module.exports, "IssueCreateModal", () => (parcelRequire("iiKA1")).default);
$parcel$export(module.exports, "messages", () => (parcelRequire("4Ju2T")).default);

var $5uXOq = parcelRequire("5uXOq");


var $AeWM3 = parcelRequire("AeWM3");

var $kErdU = parcelRequire("kErdU");

var $k8U9V = parcelRequire("k8U9V");

var $aCgtf = parcelRequire("aCgtf");

var $5rzqz = parcelRequire("5rzqz");

var $3bmti = parcelRequire("3bmti");

var $4R6GH = parcelRequire("4R6GH");

var $4Ju2T = parcelRequire("4Ju2T");

var $9U8fV = parcelRequire("9U8fV");

var $bvFAf = parcelRequire("bvFAf");

var $4dA66 = parcelRequire("4dA66");

var $dVtn1 = parcelRequire("dVtn1");

var $iiKA1 = parcelRequire("iiKA1");
const $558a346803bb9c9a$var$onResetApolloCache = ()=>(0, $AeWM3.resetCache)((0, $0f49084c2859db45$export$9c9ee93e509f8666));
const $558a346803bb9c9a$var$IssueCreateAppWithApolloProvider = ({ onError: onError, shouldForceCheckIsModalOpen: shouldForceCheckIsModalOpen = false })=>{
    const [{ isModalOpen: isModalOpen }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { deleteIssueRestoreMeta: deleteIssueRestoreMeta } = (0, $aCgtf.useIssueRestoreMetaService)();
    const issueCreateMeta = (0, $3bmti.getAdditionalAttributes)();
    const _onError = (0, $5uXOq.useCallback)(()=>{
        onError?.();
        deleteIssueRestoreMeta();
    }, [
        onError,
        deleteIssueRestoreMeta
    ]);
    const { giraClient: giraClient } = (0, $bvFAf.useIssueCreateFromAnywhereContext)();
    (0, $4dA66.usePublishUseTriggerIssueCreateModalChange)();
    (0, $k8U9V.usePublishFormContext)();
    const renderIssueCreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore } = {})=>{
        if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iiKA1.default), {
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestore,
            onResetApolloCache: $558a346803bb9c9a$var$onResetApolloCache
        });
        return null;
    };
    const attributes = (0, $5uXOq.useMemo)(()=>({
            isModalOpen: isModalOpen,
            shouldForceCheckIsModalOpen: shouldForceCheckIsModalOpen
        }), [
        isModalOpen,
        shouldForceCheckIsModalOpen
    ]);
    if (// don't render IssueCreate unless the modal is open
    // this fixes problems with loading the correct data for pre-selected sites
    // this is a hot fix to prevent the modal from not opening when it should (you read that right, see HOT-113496)
    shouldForceCheckIsModalOpen && !isModalOpen) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "issue-create-app",
        packageName: "jiraIssueCreate",
        fallback: "flag",
        onError: _onError,
        sendToPrivacyUnsafeSplunk: true,
        attributes: ()=>({
                ...(0, $4R6GH.fg)('additional_metric_attributes_issue_create') ? issueCreateMeta : {},
                ...(0, $4R6GH.fg)('jira-issue-create-error-boundary-enabled') ? attributes : {}
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: giraClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9U8fV.NavigationDiscardChangesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVtn1.IssueRestoreWrapper), null, ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
            id: "issue-create-app-children",
            packageName: "jiraIssueCreate",
            fallback: "flag",
            onError: _onError,
            sendToPrivacyUnsafeSplunk: true,
            attributes: ()=>({
                    ...(0, $4R6GH.fg)('additional_metric_attributes_issue_create') ? issueCreateMeta : {},
                    ...(0, $4R6GH.fg)('jira-issue-create-error-boundary-enabled') ? attributes : {}
                })
        }, renderIssueCreateModal({
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestore
        }))))));
};
const $558a346803bb9c9a$export$bdacb64dcf3c214f = ({ props: props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($558a346803bb9c9a$var$IssueCreateAppWithApolloProvider, props);
};
var $558a346803bb9c9a$export$2e2bcd8739ae039 = $558a346803bb9c9a$var$IssueCreateAppWithApolloProvider;

});
const $0f49084c2859db45$export$2eeebb625d70ae49 = 'SWAG';
const $0f49084c2859db45$export$9c9ee93e509f8666 = 'gira';
const $0f49084c2859db45$export$14a05c678c2af272 = 'REST';
const $0f49084c2859db45$export$b19c7b383ca04a4d = 'POLARIS';

parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("k8U9V", function(module, exports) {

$parcel$export(module.exports, "usePublishFormContext", () => $84720143e12f0bf1$export$9454401a65fa3f6c);

var $5uXOq = parcelRequire("5uXOq");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $45Cy1 = parcelRequire("45Cy1");
const $84720143e12f0bf1$export$9454401a65fa3f6c = ()=>{
    const [state] = (0, $45Cy1.useFormContext)();
    const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
    (0, $5uXOq.useEffect)(()=>{
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, state);
    }, [
        publish,
        state
    ]);
};

});
parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("45Cy1", function(module, exports) {

$parcel$export(module.exports, "useCreateFormState", () => $fb3a5d31230745bd$export$64ff4e8b244effca);
$parcel$export(module.exports, "useFormContext", () => $fb3a5d31230745bd$export$4d957a5e1be13b03);
$parcel$export(module.exports, "useFormContextActions", () => $fb3a5d31230745bd$export$8b2a836c011f987c);
$parcel$export(module.exports, "useFormContextInteractedFields", () => $fb3a5d31230745bd$export$43c5716796c2329e);
$parcel$export(module.exports, "useIsCollapsedAreaExpanded", () => $fb3a5d31230745bd$export$ee8f126c0e25d653);
$parcel$export(module.exports, "useIsSmartFieldsNew", () => $fb3a5d31230745bd$export$52b9b0c902b0ae2b);
$parcel$export(module.exports, "useIssueType", () => $fb3a5d31230745bd$export$6c4c9b3e84687e41);

var $fr1K2 = parcelRequire("fr1K2");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $fb3a5d31230745bd$export$d4c72bab9d6cc13a = {
    selectedProject: null,
    selectedIssueType: null,
    requestBackedIssueType: null,
    isEpicLinkSelected: false,
    isSubmitting: false,
    isOperationInProgress: false,
    shouldShowConfigureFieldModal: false,
    shouldShowFindFieldModal: false,
    meta: {
        areRequiredFieldsSupported: true,
        queryErrorMessage: '',
        submitErrorMessage: '',
        submitFieldwiseErrors: {},
        inlineCreateError: null
    },
    dataFetchError: null,
    isFormDirty: false,
    areConfiguredFieldsModified: false,
    timeTrackingValue: '',
    ecosystem: {
        forge: {
            customFields: [],
            filteredOutModules: [],
            issueAdjustmentModules: [],
            hasFinishedLoading: false
        }
    },
    currentActiveTabIndex: 0,
    shouldAutoFocus: true,
    resetFormAction: null,
    isForgeFieldsDetected: false,
    canCreateAnotherIssue: false,
    createdIssues: [],
    watchers: [],
    interactedFields: {},
    expandedCollapsedAreas: [],
    isSmartFieldsNew: undefined,
    isSmartFieldsToggled: false,
    isFormLoaded: false
};
const $fb3a5d31230745bd$export$e324594224ef24da = {
    restoreState: (state)=>({ setState: setState })=>{
            setState((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state, [
                'isSubmitting',
                'isOperationInProgress'
            ]));
        },
    setCurrentActiveTabIndex: (tabIndex)=>({ setState: setState, getState: getState })=>{
            const { currentActiveTabIndex: currentActiveTabIndex } = getState();
            if (tabIndex >= 0 && currentActiveTabIndex !== tabIndex) setState({
                currentActiveTabIndex: tabIndex
            });
        },
    // To enable/disable autofocus of the "create issue" form element - https://a11y.atlassian.net/browse/JCA11Y-318
    setShouldAutoFocus: (shouldAutoFocus)=>({ setState: setState })=>{
            setState({
                shouldAutoFocus: shouldAutoFocus
            });
        },
    setSelectedProject: (project)=>({ setState: setState })=>{
            setState({
                selectedProject: project
            });
        },
    setSelectedIssueType: (issueType)=>({ setState: setState })=>{
            setState({
                selectedIssueType: issueType
            });
        },
    setRequestBackedIssueType: (issueType)=>({ setState: setState })=>{
            setState({
                requestBackedIssueType: issueType
            });
        },
    setIsEpicLinkSelected: (isEpicLinkSelected)=>({ setState: setState })=>{
            setState({
                isEpicLinkSelected: isEpicLinkSelected
            });
        },
    setMeta: (meta)=>({ setState: setState })=>{
            setState({
                meta: meta
            });
        },
    setSubmitErrorMessage: (submitErrorMessage)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    submitErrorMessage: submitErrorMessage
                }
            });
        },
    setTimeTrackingValue: (timeTrackingValue)=>({ setState: setState })=>{
            setState({
                timeTrackingValue: timeTrackingValue
            });
        },
    setSubmitFieldwiseErrors: (fieldwiseErrors)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    submitFieldwiseErrors: fieldwiseErrors
                }
            });
        },
    setInlineErrorMessage: (inlineCreateError)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    inlineCreateError: inlineCreateError
                }
            });
        },
    setSubmitting: (isSubmitting)=>({ setState: setState })=>{
            setState({
                isSubmitting: isSubmitting
            });
        },
    setIsOperationInProgress: (isOperationInProgress)=>({ setState: setState })=>{
            setState({
                isOperationInProgress: isOperationInProgress
            });
        },
    toggleConfigureFieldsModalVisibility: (shouldShowConfigureFieldModal)=>({ setState: setState })=>{
            setState({
                shouldShowConfigureFieldModal: shouldShowConfigureFieldModal
            });
        },
    toggleFindFieldsModalVisibility: (shouldShowFindFieldModal)=>({ setState: setState })=>{
            setState({
                shouldShowFindFieldModal: shouldShowFindFieldModal
            });
        },
    resetFormContext: ()=>({ setState: setState })=>{
            setState({
                ...$fb3a5d31230745bd$export$d4c72bab9d6cc13a
            });
        },
    setDataFetchError: (error)=>({ setState: setState })=>{
            setState({
                dataFetchError: error
            });
        },
    setIsFormDirty: (isFormDirty)=>({ setState: setState })=>{
            setState({
                isFormDirty: isFormDirty
            });
        },
    setAreConfiguredFieldsModified: (areConfiguredFieldsModified)=>({ setState: setState })=>{
            setState({
                areConfiguredFieldsModified: areConfiguredFieldsModified
            });
        },
    setForgeModules: (customFields, issueAdjustmentModules, filteredOutModules, hasFinishedLoading)=>({ setState: setState, getState: getState })=>{
            const { ecosystem: ecosystem } = getState();
            setState({
                ecosystem: {
                    ...ecosystem,
                    forge: {
                        customFields: customFields,
                        issueAdjustmentModules: issueAdjustmentModules,
                        hasFinishedLoading: !!hasFinishedLoading,
                        filteredOutModules: filteredOutModules
                    }
                }
            });
        },
    setResetFormAction: (resetFormAction)=>({ setState: setState })=>{
            setState({
                resetFormAction: resetFormAction
            });
        },
    setIsForgeFieldsDetected: (isForgeFieldsDetected)=>({ setState: setState })=>{
            setState({
                isForgeFieldsDetected: isForgeFieldsDetected
            });
        },
    setCanCreateAnotherIssue: (canCreateAnotherIssue)=>({ setState: setState })=>{
            setState({
                canCreateAnotherIssue: canCreateAnotherIssue
            });
        },
    addCreatedIssue: (createdIssue)=>({ getState: getState, setState: setState })=>{
            const { createdIssues: createdIssues } = getState();
            const mergedCreatedIssues = [
                ...createdIssues,
                createdIssue
            ];
            setState({
                createdIssues: mergedCreatedIssues
            });
            return mergedCreatedIssues;
        },
    setWatchers: (watchers)=>({ setState: setState })=>{
            setState({
                watchers: watchers
            });
        },
    setInteractedWithField: (fieldId)=>({ setState: setState, getState: getState })=>{
            const { interactedFields: interactedFields } = getState();
            setState({
                interactedFields: {
                    ...interactedFields,
                    [fieldId]: true
                }
            });
        },
    setExpandedCollapsedArea: (index, shouldExpand)=>({ setState: setState, getState: getState })=>{
            const { expandedCollapsedAreas: expandedCollapsedAreas } = getState();
            const newExpandedCollapsedAreas = expandedCollapsedAreas.slice(0);
            const isCurrentExpanded = expandedCollapsedAreas.includes(index);
            let shouldUpdate = false;
            if (!isCurrentExpanded && shouldExpand) {
                newExpandedCollapsedAreas.push(index);
                shouldUpdate = true;
            }
            if (isCurrentExpanded && !shouldExpand) {
                newExpandedCollapsedAreas.splice(newExpandedCollapsedAreas.indexOf(index), 1);
                shouldUpdate = true;
            }
            if (shouldUpdate) setState({
                expandedCollapsedAreas: newExpandedCollapsedAreas
            });
        },
    resetExpandedCollapsedArea: ()=>({ setState: setState })=>{
            setState({
                expandedCollapsedAreas: []
            });
        },
    setIsSmartFieldsNew: (isSmartFieldsNew)=>({ setState: setState })=>{
            setState({
                isSmartFieldsNew: isSmartFieldsNew
            });
        },
    setIsSmartFieldsToggled: (isSmartFieldsToggled)=>({ setState: setState })=>{
            setState({
                isSmartFieldsToggled: isSmartFieldsToggled
            });
        },
    setIsFormLoaded: (isFormLoaded)=>({ setState: setState })=>{
            setState({
                isFormLoaded: isFormLoaded
            });
        }
};
const $fb3a5d31230745bd$var$store = (0, $iXqE5.createStore)({
    name: 'issue-create.issue-create-form.form-context',
    initialState: $fb3a5d31230745bd$export$d4c72bab9d6cc13a,
    actions: $fb3a5d31230745bd$export$e324594224ef24da
});
const $fb3a5d31230745bd$export$e6a162613d6e6e63 = (state)=>{
    const { selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, areConfiguredFieldsModified: areConfiguredFieldsModified, requestBackedIssueType: requestBackedIssueType, isFormDirty: isFormDirty } = state;
    return {
        selectedProject: selectedProject,
        selectedIssueType: selectedIssueType,
        requestBackedIssueType: requestBackedIssueType,
        meta: meta,
        areConfiguredFieldsModified: areConfiguredFieldsModified,
        isFormDirty: isFormDirty
    };
};
const $fb3a5d31230745bd$export$64ff4e8b244effca = (0, $3sQ5x.createHook)($fb3a5d31230745bd$var$store, {
    selector: $fb3a5d31230745bd$export$e6a162613d6e6e63
});
const $fb3a5d31230745bd$export$4d957a5e1be13b03 = (0, $3sQ5x.createHook)($fb3a5d31230745bd$var$store);
const $fb3a5d31230745bd$export$8b2a836c011f987c = (0, $3sQ5x.createActionsHook)($fb3a5d31230745bd$var$store);
const $fb3a5d31230745bd$var$getInteractedFieldsSelector = (state)=>state.interactedFields;
const $fb3a5d31230745bd$export$43c5716796c2329e = (0, $3sQ5x.createHook)($fb3a5d31230745bd$var$store, {
    selector: $fb3a5d31230745bd$var$getInteractedFieldsSelector
});
const $fb3a5d31230745bd$var$getIsCollapsedAreaExpandedSelector = (state, index)=>state.expandedCollapsedAreas.includes(index);
const $fb3a5d31230745bd$export$ee8f126c0e25d653 = (0, $3sQ5x.createHook)($fb3a5d31230745bd$var$store, {
    selector: (state, index)=>$fb3a5d31230745bd$var$getIsCollapsedAreaExpandedSelector(state, index)
});
const $fb3a5d31230745bd$export$52b9b0c902b0ae2b = (0, $3sQ5x.createHook)($fb3a5d31230745bd$var$store, {
    selector: (state)=>state.isSmartFieldsNew
});
const $fb3a5d31230745bd$export$6c4c9b3e84687e41 = (0, $3sQ5x.createHook)($fb3a5d31230745bd$var$store, {
    selector: (state)=>state.selectedIssueType
});

});


parcelRegister("aCgtf", function(module, exports) {

$parcel$export(module.exports, "useIssueRestoreMetaService", () => $bffd0385d7f4b21c$export$8f688cfe533ab228);

var $5uXOq = parcelRequire("5uXOq");

var $eNf8a = parcelRequire("eNf8a");

const $bffd0385d7f4b21c$var$KEY = 'issue-restore-meta';
const $bffd0385d7f4b21c$export$8f688cfe533ab228 = ()=>{
    const [storage] = (0, $5uXOq.useState)((0, $eNf8a.createSessionStorageProvider)(`${(0, $9a94166e56e4a9e2$export$8fa5032778cf7801)}`));
    return {
        getIssueRestoreMeta: async ()=>storage.get($bffd0385d7f4b21c$var$KEY),
        createIssueRestoreMeta: async (data)=>{
            storage.set($bffd0385d7f4b21c$var$KEY, data);
            return data;
        },
        updateIssueRestoreMeta: async (data)=>{
            storage.set($bffd0385d7f4b21c$var$KEY, data);
            return data;
        },
        deleteIssueRestoreMeta: async ()=>{
            storage.remove($bffd0385d7f4b21c$var$KEY);
        }
    };
};

});
const $9a94166e56e4a9e2$export$8fa5032778cf7801 = 'jira-issue-create-restore-';


parcelRegister("3bmti", function(module, exports) {

$parcel$export(module.exports, "getAdditionalAttributes", () => $da9b705068ae445e$export$f10870c4dfdab6a9);

var $j8DrX = parcelRequire("j8DrX");

var $aIZdc = parcelRequire("aIZdc");
const $da9b705068ae445e$export$f10870c4dfdab6a9 = ()=>{
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $aIZdc.isFedRamp)()
    };
};

});

parcelRegister("4Ju2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $617513ebca448608$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $617513ebca448608$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noSummary: {
        "id": "issue-create.common.no-summary",
        "defaultMessage": "(No summary)"
    },
    noSummaryWithIssueType: {
        "id": "issue-create.common.no-summary-with-issue-type",
        "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
    },
    resizeSpotlightMessage: {
        "id": "issue-create.common.resize-spotlight-message",
        "defaultMessage": "Resize or minimize your issue to pause editing and navigate around Jira."
    },
    resizeSpotlightMessageIssueTermRefresh: {
        "id": "issue-create.common.resize-spotlight-message-issue-term-refresh",
        "defaultMessage": "Resize or minimize your work item to pause editing and navigate around Jira."
    },
    miniModalSpotlightMessage: {
        "id": "issue-create.common.mini-modal-spotlight-message",
        "defaultMessage": "Create work in context and navigate your project without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later. "
    },
    miniModalSpotlightActionMessage: {
        "id": "issue-create.common.mini-modal-spotlight-action-message",
        "defaultMessage": "Got it"
    },
    miniModalSpotlightHeading: {
        "id": "issue-create.common.mini-modal-spotlight-heading",
        "defaultMessage": "Multitasking made easy"
    },
    noSummaryWithIssueTypeIssueTermRefresh: {
        "id": "issue-create.common.no-summary-with-issue-type-issue-term-refresh",
        "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
    }
});

});

parcelRegister("9U8fV", function(module, exports) {

$parcel$export(module.exports, "NavigationDiscardChangesContainer", () => $2f9e452bf52b998a$export$6b9c176805b3c455);
$parcel$export(module.exports, "useNavigationDiscardChanges", () => $2f9e452bf52b998a$export$bf0dbeb75772072);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $lzF8p = parcelRequire("lzF8p");
const $2f9e452bf52b998a$export$d4c72bab9d6cc13a = {
    deferredNavigationLink: ''
};
const $2f9e452bf52b998a$var$store = (0, $iXqE5.createStore)({
    name: 'NavigationDiscardChanges',
    initialState: $2f9e452bf52b998a$export$d4c72bab9d6cc13a,
    actions: $lzF8p.actions
});
const $2f9e452bf52b998a$export$6b9c176805b3c455 = (0, $gg7kZ.createContainer)($2f9e452bf52b998a$var$store);
const $2f9e452bf52b998a$export$bf0dbeb75772072 = (0, $3sQ5x.createHook)($2f9e452bf52b998a$var$store);
const $2f9e452bf52b998a$export$9f61952484b5dffe = (0, $3sQ5x.createActionsHook)($2f9e452bf52b998a$var$store);

});
parcelRegister("lzF8p", function(module, exports) {

$parcel$export(module.exports, "actions", () => $67f9388310602af9$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $67f9388310602af9$export$a750007c2edb3b26 = (deferredNavigationLink)=>({ setState: setState })=>setState({
            deferredNavigationLink: deferredNavigationLink
        });
const $67f9388310602af9$export$e324594224ef24da = {
    setDeferredNavigationLink: $67f9388310602af9$export$a750007c2edb3b26
};

});


parcelRegister("bvFAf", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateFromAnywhereContext", () => $2c596761855a9e54$export$f99899ced542f49a);

var $5uXOq = parcelRequire("5uXOq");

var $aXhsp = parcelRequire("aXhsp");

var $3M1CO = parcelRequire("3M1CO");

var $cKWWX = parcelRequire("cKWWX");
const $2c596761855a9e54$export$4cea60a165c59df0 = ()=>(0, $aXhsp.default);
const $2c596761855a9e54$export$f99899ced542f49a = ()=>{
    const cloudIdRef = (0, $5uXOq.useRef)('');
    const [{ selectedCloudId: selectedCloudId }] = (0, $cKWWX.useSitePickerContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (selectedCloudId && cloudIdRef.current !== selectedCloudId) cloudIdRef.current = selectedCloudId;
    }, [
        selectedCloudId
    ]);
    const originUrl = (0, $5uXOq.useMemo)(()=>(0, $3M1CO.transformOriginUrl)(selectedCloudId), [
        selectedCloudId
    ]);
    return {
        giraClient: {
            ...$2c596761855a9e54$export$4cea60a165c59df0(),
            ...originUrl && {
                clientCreator: ()=>$2c596761855a9e54$export$4cea60a165c59df0()?.clientCreator(originUrl)
            }
        },
        resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId
    };
};

});
parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("3M1CO", function(module, exports) {

$parcel$export(module.exports, "transformStargateUrl", () => $3e143aeba8894d55$export$96f8b7181eacc12a);
$parcel$export(module.exports, "transformCreateIssueUrl", () => $3e143aeba8894d55$export$3092c86dfb3d9d95);
$parcel$export(module.exports, "transformOriginUrl", () => $3e143aeba8894d55$export$e32687a94f0c0d0c);
const $3e143aeba8894d55$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};
const $3e143aeba8894d55$export$3092c86dfb3d9d95 = ({ issueUrl: issueUrl, selectedCloudId: selectedCloudId })=>{
    if (!selectedCloudId) return issueUrl;
    return `/gateway/api/ex/jira/${selectedCloudId}${issueUrl}`;
};
const $3e143aeba8894d55$export$e32687a94f0c0d0c = (selectedCloudId)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    selectedCloudId ? `${window.origin}/gateway/api/ex/jira/${selectedCloudId}` : null;

});


parcelRegister("4dA66", function(module, exports) {

$parcel$export(module.exports, "usePublishUseTriggerIssueCreateModalChange", () => $5a87e27a6d56ef3a$export$def8d994aa8d00f4);

var $5uXOq = parcelRequire("5uXOq");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $5rzqz = parcelRequire("5rzqz");
const $5a87e27a6d56ef3a$export$def8d994aa8d00f4 = ()=>{
    const [state] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
    (0, $5uXOq.useEffect)(()=>publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, state), [
        publish,
        state
    ]);
};

});

parcelRegister("dVtn1", function(module, exports) {

$parcel$export(module.exports, "IssueRestoreWrapper", () => $0f8c284342b05b30$export$c5abd224bc075aa5);

var $5uXOq = parcelRequire("5uXOq");

var $45Cy1 = parcelRequire("45Cy1");

var $9qNYv = parcelRequire("9qNYv");

var $5rzqz = parcelRequire("5rzqz");

var $1n4jA = parcelRequire("1n4jA");

var $ieDtd = parcelRequire("ieDtd");
const $0f8c284342b05b30$export$c5abd224bc075aa5 = ({ children: children })=>{
    const [, { restoreState: restoreTriggerIssueCreateModalState }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [, { restoreState: restoreFormContext }] = (0, $45Cy1.useFormContext)();
    const isEmbedded = (0, $1n4jA.useIsEmbedded)();
    const [createIncidentModalState] = (0, $ieDtd.useQueryParam)('open_create_incident_modal');
    const isCreateIncidentModal = createIncidentModalState !== undefined;
    return isEmbedded || isCreateIncidentModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children?.({})) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9qNYv.IssueRestore), {
        onRestoreTriggerIssueCreateModalState: restoreTriggerIssueCreateModalState,
        onRestoreFormContext: restoreFormContext
    }, children);
};

});
parcelRegister("9qNYv", function(module, exports) {

$parcel$export(module.exports, "IssueRestore", () => $f14610e697536670$export$20995982965fe5e9);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4fT7I = parcelRequire("4fT7I");

var $gIPBO = parcelRequire("gIPBO");

var $67QNo = parcelRequire("67QNo");

var $aCgtf = parcelRequire("aCgtf");

var $5TOSQ = parcelRequire("5TOSQ");

var $fujGs = parcelRequire("fujGs");
const $f14610e697536670$var$IssueRestoreInner = ({ children: children, ...rest })=>{
    const [{ inProgressIssueMetas: inProgressIssueMetas, isInitialised: isInitialised }, { init: init }] = (0, $gIPBO.useIssueRestoreMeta)();
    const inProgressIssueService = (0, $67QNo.useInProgressIssueService)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialised) init();
    }, [
        isInitialised,
        init
    ]);
    // To future proof for bulk issue create
    const activeInProgressIssueID = inProgressIssueMetas?.[0]?.inProgressIssueID;
    const activeShouldRestore = inProgressIssueMetas?.[0]?.shouldRestore;
    if (isInitialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4fT7I.InProgressIssueStoreContainer), {
        inProgressIssueService: inProgressIssueService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5TOSQ.InProgressIssueInitialiser), {
        inProgressIssueID: activeInProgressIssueID,
        shouldRestore: activeShouldRestore,
        ...rest
    }, children));
    return null;
};
const $f14610e697536670$export$20995982965fe5e9 = ({ children: children, ...rest })=>{
    const issueRestoreMetaService = (0, $aCgtf.useIssueRestoreMetaService)();
    const [indexedDBAvailable] = (0, $5uXOq.useState)((0, $fujGs.isIndexedDBAvailable)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!indexedDBAvailable) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'indexedDB missing');
    }, [
        createAnalyticsEvent,
        indexedDBAvailable
    ]);
    if (!indexedDBAvailable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children?.({}));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIPBO.IssueRestoreMetaContainer), {
        issueRestoreMetaService: issueRestoreMetaService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f14610e697536670$var$IssueRestoreInner, rest, children));
};

});
parcelRegister("4fT7I", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssue", () => $3210c3aeb4604a51$export$4b6bb26ceba91de6);
$parcel$export(module.exports, "InProgressIssueStoreContainer", () => $3210c3aeb4604a51$export$bd3e62a8e8bf35);
$parcel$export(module.exports, "useInProgressIssueActions", () => $3210c3aeb4604a51$export$74b9a754a809ff62);
$parcel$export(module.exports, "useIsFormDirty", () => $3210c3aeb4604a51$export$99feafa9b9955d05);
$parcel$export(module.exports, "useIsModalOpen", () => $3210c3aeb4604a51$export$c09953967ff9ffea);

var $ajpes = parcelRequire("ajpes");

var $6paOF = parcelRequire("6paOF");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $2XPw9 = parcelRequire("2XPw9");
const $3210c3aeb4604a51$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    isSavingCounter: 0,
    id: '',
    formData: {},
    formDataDefaultValues: {},
    formContext: {},
    triggerIssueCreateModalState: undefined,
    statusField: {},
    restoreError: undefined
};
let $3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics = false;
const $3210c3aeb4604a51$export$2cd70be39fa29781 = ()=>{
    $3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics = false;
};
const $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics = (eventName, state)=>{
    // Prevent errors from firing too often, otherwise we mind fire this on each keypress of field update by accident
    if ($3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics) return;
    $3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics = true;
    (0, $6paOF.fireIssueCreateErrorAnalytics)({
        meta: {
            id: 'useInProgressIssueService',
            packageName: 'jiraIssueCreateRestore'
        },
        attributes: {
            inProgressIssueID: state?.id,
            isModalOpen: state?.triggerIssueCreateModalState?.isModalOpen,
            wasStateRestored: state?.triggerIssueCreateModalState?.wasStateRestored,
            minimizableModalView: state?.triggerIssueCreateModalState?.minimizableModalView,
            eventName: eventName
        },
        error: new Error('InProgressIssue - unexpected event fired'),
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: true
    });
};
const $3210c3aeb4604a51$var$THROTTLE_DELAY = 250;
const $3210c3aeb4604a51$export$e324594224ef24da = {
    onTriggerIssueCreateModalStateChange: (triggerIssueCreateModalState)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!(currentState.id || triggerIssueCreateModalState.inProgressIssueID) || !(currentState?.triggerIssueCreateModalState?.isModalOpen || triggerIssueCreateModalState?.isModalOpen)) return;
            // Preventing Project, Issue type and Request type from being updated
            const overridePayload = {
                project: currentState?.triggerIssueCreateModalState?.payload?.project,
                issueType: currentState?.triggerIssueCreateModalState?.payload?.issueType,
                requestType: currentState?.triggerIssueCreateModalState?.payload?.requestType
            };
            const newPayload = {
                ...triggerIssueCreateModalState.payload || {},
                ...overridePayload
            };
            setState({
                id: triggerIssueCreateModalState.inProgressIssueID,
                isSavingCounter: currentState.isSavingCounter + 1,
                triggerIssueCreateModalState: {
                    ...triggerIssueCreateModalState,
                    payload: newPayload
                }
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onTriggerIssueCreateModalStateChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onFormFieldUpdate: ({ fieldId: fieldId, value: value })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics(`onFormFieldUpdate - ${fieldId}`, currentState);
                return;
            }
            const newFormData = {
                ...currentState.formData,
                [fieldId]: value
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formData: newFormData
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFormFieldUpdate'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            // Resetting is saving counter should be delayed until after throttle
            // execution to allow us to show a prompt if page unloads in between
            // invocations
            setTimeout(()=>{
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            }, $3210c3aeb4604a51$var$THROTTLE_DELAY + 1);
        },
    onClassificationLevelFieldChange: (classificationLevelField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onClassificationLevelFieldChange', currentState);
                return;
            }
            setState({
                isSavingCounter: getState().isSavingCounter + 1,
                classificationLevelField: classificationLevelField
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onClassificationLevelFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onStatusFieldChange: (statusField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onStatusFieldChange', currentState);
                return;
            }
            setState({
                isSavingCounter: getState().isSavingCounter + 1,
                statusField: statusField
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onStatusFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onFormContextUpdate: (formContext)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            const { id: id, triggerIssueCreateModalState: triggerIssueCreateModalState, isSavingCounter: isSavingCounter } = currentState;
            if (!id || !triggerIssueCreateModalState || !triggerIssueCreateModalState.isModalOpen) return;
            const currentFormContext = currentState.formContext;
            const newFormContext = formContext;
            if (triggerIssueCreateModalState && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newFormContext, currentFormContext)) {
                const currentPayload = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerIssueCreateModalState.payload;
                const selectedIssueAndRequestType = newFormContext.selectedIssueType ? {
                    issueType: {
                        issueTypeId: (0, $2XPw9.isRequestType)(newFormContext.selectedIssueType) ? newFormContext.selectedIssueType.issueTypeId : newFormContext.selectedIssueType?.value
                    },
                    requestType: (0, $2XPw9.isRequestType)(newFormContext.selectedIssueType) ? {
                        key: newFormContext.selectedIssueType.requestTypeKey
                    } : undefined
                } : undefined;
                const newTriggerIssueCreateModalState = {
                    ...triggerIssueCreateModalState,
                    payload: {
                        ...currentPayload,
                        project: {
                            projectId: newFormContext.selectedProject?.value
                        },
                        ...selectedIssueAndRequestType
                    }
                };
                const newState = {
                    isSavingCounter: isSavingCounter + 1,
                    formContext: newFormContext,
                    triggerIssueCreateModalState: newTriggerIssueCreateModalState
                };
                setState(newState);
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $6paOF.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onFormContextUpdate'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            }
        },
    onModalOpened: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
            const newState = {
                ...getState(),
                id: inProgressIssueID
            };
            setState(newState);
            try {
                await createInProgressIssue(inProgressIssueID, (0, $2XPw9.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalOpened'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
        },
    onModalClosed: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            if (inProgressIssueID === getState().id) {
                setState({
                    ...$3210c3aeb4604a51$export$d4c72bab9d6cc13a,
                    isInitialised: true,
                    restoreError: undefined
                });
                const { deleteInProgressIssue: deleteInProgressIssue } = inProgressIssueService;
                try {
                    await deleteInProgressIssue(inProgressIssueID);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $6paOF.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onModalClosed'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
            }
        },
    onModalDiscardExistingInProgressIssue: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const state = getState();
            setState({
                ...$3210c3aeb4604a51$export$d4c72bab9d6cc13a,
                isSavingCounter: state.isSavingCounter + 1,
                id: state.id,
                triggerIssueCreateModalState: state.triggerIssueCreateModalState,
                formContext: state.formContext,
                isInitialised: true,
                restoreError: undefined
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(state.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalDiscardExistingInProgressIssue'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onResetFormFieldsForCreateAnother: (fieldsReset)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onResetFormFieldsForCreateAnother', currentState);
                return;
            }
            const newFormData = {
                ...currentState.formData,
                ...fieldsReset.fieldsReset
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formData: newFormData
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onResetFormFieldsForCreateAnother'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onReinsertIntoBrowserStorage: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onReinsertIntoBrowserStorage', currentState);
                return;
            }
            setState({
                isSavingCounter: currentState.isSavingCounter + 1
            });
            const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
            try {
                await createInProgressIssue(currentState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(currentState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onReinsertIntoBrowserStorage'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    init: (inProgressIssueID)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            if (inProgressIssueID) {
                // Get useTriggerIssueCreateModalState from storage
                const { getInProgressIssue: getInProgressIssue } = inProgressIssueService;
                try {
                    const inProgressIssue = await getInProgressIssue(inProgressIssueID);
                    setState({
                        ...inProgressIssue,
                        triggerIssueCreateModalState: inProgressIssue?.triggerIssueCreateModalState ? {
                            ...inProgressIssue?.triggerIssueCreateModalState,
                            wasStateRestored: true
                        } : undefined,
                        isInitialised: true
                    });
                } catch (error) {
                    setState({
                        restoreError: error
                    });
                }
                return getState();
            }
            setState({
                isInitialised: true
            });
            return getState();
        },
    onFormFieldConfigUpdate: ({ fieldConfig: fieldConfig })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState.id) return;
            let newFormDataDefaultValues = {};
            Object.values(fieldConfig).forEach((fieldData)=>{
                const { fieldId: fieldId, defaultValue: defaultValue } = fieldData;
                newFormDataDefaultValues = {
                    ...newFormDataDefaultValues,
                    [fieldId]: defaultValue
                };
            });
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFormFieldConfigUpdate'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onIssueTypeChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onIssueTypeChange', currentState);
                return;
            }
            // reset form fields default values
            const newFormDataDefaultValues = {};
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onIssueTypeChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onProjectFieldChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onProjectFieldChange', currentState);
                return;
            }
            // reset form fields default values
            const newFormDataDefaultValues = {};
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $2XPw9.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onProjectFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    setRestoreError: (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    restoreError)=>async ({ setState: setState })=>{
            setState({
                restoreError: restoreError
            });
        }
};
const $3210c3aeb4604a51$var$Store = (0, $iXqE5.createStore)({
    initialState: $3210c3aeb4604a51$export$d4c72bab9d6cc13a,
    actions: $3210c3aeb4604a51$export$e324594224ef24da
});
const $3210c3aeb4604a51$export$4b6bb26ceba91de6 = (0, $3sQ5x.createHook)($3210c3aeb4604a51$var$Store);
const $3210c3aeb4604a51$export$bd3e62a8e8bf35 = (0, $gg7kZ.createContainer)($3210c3aeb4604a51$var$Store);
const $3210c3aeb4604a51$export$74b9a754a809ff62 = (0, $3sQ5x.createActionsHook)($3210c3aeb4604a51$var$Store);
// Selectors
const $3210c3aeb4604a51$var$getIsFormDirty = (state)=>state?.formContext?.isFormDirty;
const $3210c3aeb4604a51$export$99feafa9b9955d05 = (0, $3sQ5x.createHook)($3210c3aeb4604a51$var$Store, {
    selector: $3210c3aeb4604a51$var$getIsFormDirty
});
const $3210c3aeb4604a51$var$getIsModalOpen = (state)=>Boolean(state?.id && state?.triggerIssueCreateModalState?.isModalOpen);
const $3210c3aeb4604a51$export$c09953967ff9ffea = (0, $3sQ5x.createHook)($3210c3aeb4604a51$var$Store, {
    selector: $3210c3aeb4604a51$var$getIsModalOpen
});

});
parcelRegister("6paOF", function(module, exports) {

$parcel$export(module.exports, "fireIssueCreateErrorAnalytics", () => $5496d757147bd1bc$export$fffbd8c0e67dbb84);

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fukJp = parcelRequire("fukJp");

var $7UP1Y = parcelRequire("7UP1Y");
const $5496d757147bd1bc$export$fffbd8c0e67dbb84 = (payload)=>{
    if (!(0, $4R6GH.fg)('issue-create-fire-error-analytics-refactor')) return (0, $jcw0u.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $fukJp.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...error && (0, $e3a3O.isApolloError)(error) ? {
                errorType: (0, $7UP1Y.handleApolloError)(error)
            } : {}
        },
        error: error
    });
};

});
parcelRegister("7UP1Y", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $a482c5a4e339a75c$export$31b755cdc25616f2);
const $a482c5a4e339a75c$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});


parcelRegister("2XPw9", function(module, exports) {

$parcel$export(module.exports, "convertStateToInProgressIssueForStorage", () => $105ebbc716803e7a$export$2f809a820073cf71);
$parcel$export(module.exports, "isRequestType", () => $105ebbc716803e7a$export$ff3afd1b5536cfed);

var $fr1K2 = parcelRequire("fr1K2");

var $4R6GH = parcelRequire("4R6GH");
function $105ebbc716803e7a$export$2f809a820073cf71(state) {
    try {
        return {
            // removing these since they are only in InProgressIssueControllerState not InProgressIssue
            ...(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state, [
                'isInitialised',
                'isSavingCounter'
            ]),
            // We need to do this to remove fields that are functions etc that we can't store in indexed-db
            formContext: state?.formContext ? JSON.parse(JSON.stringify(state.formContext)) : undefined,
            ...(0, $4R6GH.fg)('fix-gryf-a11y-issues') ? {
                triggerIssueCreateModalState: state?.triggerIssueCreateModalState ? JSON.parse(JSON.stringify({
                    ...state.triggerIssueCreateModalState,
                    triggerButtonRef: null
                })) : undefined
            } : {
                triggerIssueCreateModalState: state?.triggerIssueCreateModalState ? JSON.parse(JSON.stringify(state.triggerIssueCreateModalState)) : undefined
            }
        };
    } catch  {
        return state;
    }
}
function $105ebbc716803e7a$export$ff3afd1b5536cfed(type) {
    if (!type) return false;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return type.issueTypeId !== undefined;
}

});


parcelRegister("gIPBO", function(module, exports) {

$parcel$export(module.exports, "useIssueRestoreMeta", () => $19a15b767cc88c7a$export$bad3a2f4726801fb);
$parcel$export(module.exports, "IssueRestoreMetaContainer", () => $19a15b767cc88c7a$export$e670c4748122991);
$parcel$export(module.exports, "useIssueRestoreMetaActions", () => $19a15b767cc88c7a$export$2a548b3d17373434);
$parcel$export(module.exports, "useIssueRestoreMetaSubscriptions", () => $19a15b767cc88c7a$export$270e0095f4e57380);

var $5uXOq = parcelRequire("5uXOq");

var $6paOF = parcelRequire("6paOF");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $jnVBq = parcelRequire("jnVBq");
const $19a15b767cc88c7a$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    isSavingCounter: 0,
    inProgressIssueMetas: [],
    restoreMetaError: undefined
};
const $19a15b767cc88c7a$export$e324594224ef24da = {
    init: ()=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            if (!getState().isInitialised) try {
                const { getIssueRestoreMeta: getIssueRestoreMeta, createIssueRestoreMeta: createIssueRestoreMeta } = issueRestoreMetaService;
                let issueRestoreMeta = await getIssueRestoreMeta();
                if (!issueRestoreMeta) issueRestoreMeta = await createIssueRestoreMeta({
                    inProgressIssueMetas: []
                });
                if (issueRestoreMeta.inProgressIssueMetas !== undefined) {
                    // filter out inProgressIssueMetas that shouldn't be restored
                    const filteredinProgressIssueMetas = issueRestoreMeta.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore === true);
                    issueRestoreMeta.inProgressIssueMetas = filteredinProgressIssueMetas;
                }
                setState({
                    ...issueRestoreMeta,
                    isInitialised: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    onModalOpened: ({ inProgressIssueID: inProgressIssueID, analyticsEvent: analyticsEvent })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            if (currentState.inProgressIssueMetas !== undefined) {
                if (!currentState.isInitialised || currentState.inProgressIssueMetas.map((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID).includes(inProgressIssueID)) return;
                // TODO this needs to be updated for bulk create
                if (currentState.inProgressIssueMetas.find((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore)) analyticsEvent ? (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'ExistingInProgressIssue onModalOpened', {
                    id: 'issueRestoreMetaOnModalOpened',
                    packageName: 'jiraIssueCreateRestore'
                }) : (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    error: new Error('Existing inProgressIssue onModalOpened'),
                    meta: {
                        id: 'issueRestoreMetaOnModalOpened',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    inProgressIssueMetas: [
                        {
                            inProgressIssueID: inProgressIssueID,
                            shouldRestore: true
                        }
                    ]
                });
            }
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $jnVBq.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    onModalClosed: ({ inProgressIssueID: inProgressIssueIDToBeRemoved })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            const newInProgressIssueMetas = currentState.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID !== inProgressIssueIDToBeRemoved);
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                restoreMetaError: undefined,
                inProgressIssueMetas: newInProgressIssueMetas
            });
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $jnVBq.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    setShouldRestore: (inProgressIssueID, newShouldRestore)=>async ({ getState: getState, setState: setState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            const inProgressIssueMetaIndex = currentState.inProgressIssueMetas.findIndex((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID === inProgressIssueID);
            if (inProgressIssueMetaIndex < 0) return;
            const newInProgressIssueMetas = [
                ...currentState.inProgressIssueMetas
            ];
            newInProgressIssueMetas[inProgressIssueMetaIndex] = {
                ...newInProgressIssueMetas[inProgressIssueMetaIndex],
                shouldRestore: newShouldRestore
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                inProgressIssueMetas: newInProgressIssueMetas
            });
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $jnVBq.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        }
};
const $19a15b767cc88c7a$var$Store = (0, $iXqE5.createStore)({
    initialState: $19a15b767cc88c7a$export$d4c72bab9d6cc13a,
    actions: $19a15b767cc88c7a$export$e324594224ef24da
});
const $19a15b767cc88c7a$export$bad3a2f4726801fb = (0, $3sQ5x.createHook)($19a15b767cc88c7a$var$Store);
const $19a15b767cc88c7a$export$e670c4748122991 = (0, $gg7kZ.createContainer)($19a15b767cc88c7a$var$Store);
const $19a15b767cc88c7a$export$2a548b3d17373434 = (0, $3sQ5x.createActionsHook)($19a15b767cc88c7a$var$Store);
const $19a15b767cc88c7a$export$270e0095f4e57380 = ()=>{
    const { onModalOpened: onModalOpened, onModalClosed: onModalClosed } = $19a15b767cc88c7a$export$2a548b3d17373434();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        const onOpenModal = (params)=>onModalOpened({
                ...params,
                analyticsEvent: analyticsEvent
            });
        return subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onOpenModal);
    }, [
        createAnalyticsEvent,
        onModalOpened,
        subscribe
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
        onModalClosed,
        subscribe
    ]);
};

});
parcelRegister("jnVBq", function(module, exports) {

$parcel$export(module.exports, "convertStateToIssueRestoreMeta", () => $0bce6dae01864809$export$4494f626031edfc9);

var $fr1K2 = parcelRequire("fr1K2");
function $0bce6dae01864809$export$4494f626031edfc9(state) {
    // removing these since they are only in IssueRestoreMetaControllerState not IssueRestoreMeta
    return (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state, [
        'isInitialised',
        'isSavingCounter',
        'restoreMetaError'
    ]);
}

});


parcelRegister("67QNo", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssueService", () => $19b5b427f27c6cac$export$6fc1ebae2c6a92c1);

var $5uXOq = parcelRequire("5uXOq");

var $sn9QA = parcelRequire("sn9QA");

var $6paOF = parcelRequire("6paOF");

const $19b5b427f27c6cac$export$6fc1ebae2c6a92c1 = ()=>{
    const [storage] = (0, $5uXOq.useState)(()=>(0, $sn9QA.createIndexedDBStorageProvider)(`${(0, $9a94166e56e4a9e2$export$8fa5032778cf7801)}in-progress-issue`, {
            shouldAutoReconnect: true
        }));
    return {
        getInProgressIssue: async (inProgressIssueID)=>storage.get(inProgressIssueID),
        createInProgressIssue: async (inProgressIssueID, data)=>{
            await storage.set(inProgressIssueID, data);
            return data;
        },
        updateInProgressIssue: async (inProgressIssueID, data)=>{
            if (await storage.get(inProgressIssueID)) await storage.set(inProgressIssueID, data);
            else {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'updateInProgressIssue',
                        packageName: 'jiraIssueCreateRestore',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        message: "Tried to updateInProgressIssue with an inProgressIssueID that doesn't exist in indexed-db"
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return data;
            }
            return data;
        },
        deleteInProgressIssue: async (inProgressIssueID)=>{
            await storage.remove(inProgressIssueID);
        }
    };
};

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});




parcelRegister("5TOSQ", function(module, exports) {

$parcel$export(module.exports, "InProgressIssueInitialiser", () => $866e80c7de6a476b$export$ee6dd146d425cafc);

var $5uXOq = parcelRequire("5uXOq");

var $4fT7I = parcelRequire("4fT7I");

var $gIPBO = parcelRequire("gIPBO");

var $cOppp = parcelRequire("cOppp");

var $2JnMT = parcelRequire("2JnMT");
const $866e80c7de6a476b$export$ee6dd146d425cafc = ({ onRestoreTriggerIssueCreateModalState: onRestoreTriggerIssueCreateModalState, onRestoreFormContext: onRestoreFormContext, inProgressIssueID: inProgressIssueID, shouldRestore: shouldRestore, children: children })=>{
    const { init: init } = (0, $4fT7I.useInProgressIssueActions)();
    const [isInitialised, setIsInitialised] = (0, $5uXOq.useState)(false);
    const { setShouldRestore: setShouldRestore } = (0, $gIPBO.useIssueRestoreMetaActions)();
    /**
	 * We are storing initialInProgressIssue in state and passing it to IssueModalWrapper to reduce re-renders
	 * so that we don't get a re-render when the InProgressIssueController state changes
	 */ const [initialInProgressIssue, setInitialInProgressIssue] = (0, $5uXOq.useState)();
    const initialiseInProgressIssues = (0, $5uXOq.useCallback)(async ()=>{
        if (!isInitialised) {
            const inProgressIssue = await init(inProgressIssueID);
            if (shouldRestore) {
                if (inProgressIssueID && inProgressIssue) {
                    const { triggerIssueCreateModalState: triggerIssueCreateModalState, formContext: formContext } = inProgressIssue;
                    if (triggerIssueCreateModalState) onRestoreTriggerIssueCreateModalState(triggerIssueCreateModalState);
                    if (formContext) onRestoreFormContext(formContext);
                    setInitialInProgressIssue(inProgressIssue);
                }
            }
            setIsInitialised(true);
        }
    }, [
        isInitialised,
        shouldRestore,
        init,
        inProgressIssueID,
        onRestoreTriggerIssueCreateModalState,
        onRestoreFormContext
    ]);
    const setShouldRestoreForInProgressIssue = (0, $5uXOq.useCallback)((newShouldRestore)=>{
        inProgressIssueID && setShouldRestore(inProgressIssueID, newShouldRestore);
    }, [
        inProgressIssueID,
        setShouldRestore
    ]);
    (0, $5uXOq.useEffect)(()=>{
        initialiseInProgressIssues();
    }, [
        initialiseInProgressIssues
    ]);
    // transform create form props in order to set new default values
    const { onTransformCreateFormProps: onTransformCreateFormProps } = (0, $cOppp.useRestoreFormFields)(initialInProgressIssue);
    if (!isInitialised) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JnMT.BackgroundActions), null), children?.({
        onTransformCreateFormProps: onTransformCreateFormProps,
        setShouldRestore: setShouldRestoreForInProgressIssue
    }));
};

});
parcelRegister("cOppp", function(module, exports) {

$parcel$export(module.exports, "useRestoreFormFields", () => $499e757ef3621f84$export$c698b427f6c94ae8);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $eLuo5 = parcelRequire("eLuo5");
function $499e757ef3621f84$export$c698b427f6c94ae8(initialInProgressIssue) {
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const inProgressIssue = (0, $5uXOq.useRef)();
    const fieldConfig = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        inProgressIssue.current = initialInProgressIssue;
    }, [
        initialInProgressIssue
    ]);
    const onTransformCreateFormProps = (0, $5uXOq.useCallback)((createFormProps)=>{
        if (!inProgressIssue?.current) return createFormProps;
        if (inProgressIssue?.current?.formData && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(fieldConfig.current)) {
            const transformedData = (0, $eLuo5.transformFieldConfigAndDirtyFieldsCurrentSession)(inProgressIssue?.current?.formData, inProgressIssue?.current?.formDataDefaultValues, createFormProps);
            fieldConfig.current = transformedData?.fieldConfig;
        }
        return {
            ...createFormProps,
            fieldConfig: fieldConfig.current || createFormProps.fieldConfig,
            classificationFieldProps: (0, $eLuo5.transformClassificationLevelFieldProps)(inProgressIssue?.current?.classificationLevelField, createFormProps?.classificationFieldProps),
            statusFieldProps: (0, $eLuo5.transformStatusFieldProps)(inProgressIssue?.current?.statusField, createFormProps?.statusFieldProps)
        };
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>{
        inProgressIssue.current = undefined;
        fieldConfig.current = undefined;
    }, []);
    // TODO handle for multiple GIC
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onReset), [
        onReset,
        subscribe
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onReset), [
        onReset,
        subscribe
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onReset), [
        onReset,
        subscribe
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onReset), [
        onReset,
        subscribe
    ]);
    const resp = (0, $5uXOq.useMemo)(()=>({
            onTransformCreateFormProps: onTransformCreateFormProps
        }), [
        onTransformCreateFormProps
    ]);
    return resp;
}

});
parcelRegister("eLuo5", function(module, exports) {

$parcel$export(module.exports, "transformFieldConfigAndDirtyFieldsCurrentSession", () => $490010337e155767$export$9c7389800790524c);
$parcel$export(module.exports, "transformStatusFieldProps", () => $490010337e155767$export$561febabfe3c6361);
$parcel$export(module.exports, "transformClassificationLevelFieldProps", () => $490010337e155767$export$6c4d1d5181504079);
const $490010337e155767$export$9c7389800790524c = (formData, formDataDefaultValues, createFormProps)=>{
    const { fieldConfig: fieldConfig = {}, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession } = createFormProps;
    const newFieldConfig = {
        ...fieldConfig
    };
    const newDirtyFieldsCurrentSession = {
        ...dirtyFieldsCurrentSession?.current || {}
    };
    if (formDataDefaultValues) // adding all default values that don't already exist to the field config - defaultValueDontTransform false
    Object.keys(formDataDefaultValues).forEach((key)=>{
        // TODO what do if fieldConfig doesn't have the key? eg schema change
        if (newFieldConfig[key]) newFieldConfig[key] = {
            ...newFieldConfig[key],
            defaultValue: formDataDefaultValues[key],
            defaultValueDontTransform: false
        };
    });
    if (formData) // adding/overwriting all changed field values to the field config - defaultValueDontTransform true
    Object.keys(formData).forEach((key)=>{
        // TODO what do if fieldConfig doesn't have the key? eg schema change
        if (newFieldConfig[key]) {
            newFieldConfig[key] = {
                ...newFieldConfig[key],
                defaultValue: formData[key],
                defaultValueDontTransform: true
            };
            newDirtyFieldsCurrentSession[key] = true;
        }
    });
    dirtyFieldsCurrentSession.current = newDirtyFieldsCurrentSession;
    return {
        fieldConfig: newFieldConfig,
        dirtyFieldsCurrentSession: dirtyFieldsCurrentSession
    };
};
const $490010337e155767$export$561febabfe3c6361 = (statusField, statusFieldProps)=>{
    if (statusField?.selectedTransition) {
        const newStatusFieldProps = {
            ...statusFieldProps
        };
        newStatusFieldProps.initialTransition = statusField.selectedTransition;
        return newStatusFieldProps;
    }
    return statusFieldProps;
};
const $490010337e155767$export$6c4d1d5181504079 = (classificationLevelField, classificationFieldProps)=>{
    if (classificationLevelField?.selectedClassification) {
        const newClassificationFieldProps = {
            ...classificationFieldProps
        };
        newClassificationFieldProps.initialClassification = classificationLevelField.selectedClassification;
        return newClassificationFieldProps;
    }
    return classificationFieldProps;
};

});


parcelRegister("2JnMT", function(module, exports) {

$parcel$export(module.exports, "BackgroundActions", () => $7971009a47ab2c97$export$30e6eb305b44f25b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3zUT3 = parcelRequire("3zUT3");

var $4Yfcs = parcelRequire("4Yfcs");

var $gIPBO = parcelRequire("gIPBO");

var $4TnIy = parcelRequire("4TnIy");

var $6i3Qj = parcelRequire("6i3Qj");
const $7971009a47ab2c97$export$30e6eb305b44f25b = ()=>{
    // Initialise subscriptions
    (0, $6i3Qj.useInProgressIssueSubscriptions)();
    (0, $gIPBO.useIssueRestoreMetaSubscriptions)();
    (0, $3zUT3.useBrowserStorageCleanup)();
    (0, $4TnIy.useShouldShowBrowserWarning)();
    const isSaving = (0, $4Yfcs.useIsIssueRestoreSaving)();
    /**
   * This invisible div is to allow cypress tests to know whether or not we are saving data
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7971009a47ab2c97$var$InvisibleDiv, {
        "data-testid": isSaving ? 'issue-create-restore.ui.issue-restore.in-progress-initialiser.saving' : 'issue-create-restore.ui.issue-restore.in-progress-initialiser.not-saving'
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7971009a47ab2c97$var$InvisibleDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3zUT3", function(module, exports) {

$parcel$export(module.exports, "useBrowserStorageCleanup", () => $bc2fceb92f63e4a1$export$bbca530fb1561128);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");

var $6paOF = parcelRequire("6paOF");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gucQ5 = parcelRequire("gucQ5");

var $67QNo = parcelRequire("67QNo");

var $4fT7I = parcelRequire("4fT7I");

var $gIPBO = parcelRequire("gIPBO");

var $6hAZF = parcelRequire("6hAZF");
function $bc2fceb92f63e4a1$export$95b1d08316d5a401() {
    const browserStorageCleanupService = (0, $gucQ5.useBrowserStorageCleanupService)();
    const [{ inProgressIssueMetas: inProgressIssueMetas }] = (0, $gIPBO.useIssueRestoreMeta)();
    const { setRestoreError: setRestoreError } = (0, $4fT7I.useInProgressIssueActions)();
    const sessionInProgressIssueIDs = (0, $5uXOq.useMemo)(()=>inProgressIssueMetas?.filter((item)=>item.shouldRestore).map((item)=>item.inProgressIssueID) || [], [
        inProgressIssueMetas
    ]);
    const [, { onReinsertIntoBrowserStorage: onReinsertIntoBrowserStorage }] = (0, $4fT7I.useInProgressIssue)();
    const inProgressIssueService = (0, $67QNo.useInProgressIssueService)();
    const [isOpen] = (0, $4fT7I.useIsModalOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onModalOpened = (0, $5uXOq.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        const newBrowserStorageCleanup = {
            ...browserStorageCleanup || {},
            inProgressIssueIDs: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...browserStorageCleanup?.inProgressIssueIDs || [],
                inProgressIssueID
            ])
        };
        if (browserStorageCleanup) await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'updateBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        else await browserStorageCleanupService.createBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'createBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
    }, [
        browserStorageCleanupService,
        setRestoreError
    ]);
    const onModalClosed = (0, $5uXOq.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalClosed',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        if (!browserStorageCleanup) return;
        const newBrowserStorageCleanup = {
            ...browserStorageCleanup,
            inProgressIssueIDs: sessionInProgressIssueIDs.filter((id)=>id !== inProgressIssueID)
        };
        // The inProgressIssueID from the onModalClosed event will be cleaned up by the standard in-progress-issue onModalClosed
        const inProgressIssueIDsToRemove = browserStorageCleanup.inProgressIssueIDs.filter((id)=>!sessionInProgressIssueIDs.includes(id));
        await Promise.all([
            browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup),
            ...inProgressIssueIDsToRemove.map((id)=>inProgressIssueService.deleteInProgressIssue(id))
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalClosed',
                    stage: 'promiseAll'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onModalClosed', {
            inProgressIssueIDsToRemoveLength: inProgressIssueIDsToRemove.length
        });
    }, [
        browserStorageCleanupService,
        createAnalyticsEvent,
        inProgressIssueService,
        sessionInProgressIssueIDs,
        setRestoreError
    ]);
    const onFocusWindow = (0, $5uXOq.useCallback)(async ()=>{
        if (!isOpen) return;
        // Bulk Create will need to update this for multiple
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup().catch((error)=>{
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onFocusWindow',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        const missingInProgressIssueIDs = browserStorageCleanup && sessionInProgressIssueIDs.length ? sessionInProgressIssueIDs.filter((id)=>!browserStorageCleanup.inProgressIssueIDs.includes(id)) : [];
        if (missingInProgressIssueIDs.length) {
            await onReinsertIntoBrowserStorage();
            const newBrowserStorageCleanup = {
                ...browserStorageCleanup,
                inProgressIssueIDs: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...browserStorageCleanup?.inProgressIssueIDs || [],
                    ...missingInProgressIssueIDs
                ])
            };
            await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((error)=>{
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFocusWindow',
                        stage: 'updateBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
        }
        if (missingInProgressIssueIDs.length) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onFocusWindow', {
            missingInProgressIssueIDsLength: missingInProgressIssueIDs.length
        });
    }, [
        browserStorageCleanupService,
        sessionInProgressIssueIDs,
        setRestoreError,
        onReinsertIntoBrowserStorage,
        createAnalyticsEvent,
        isOpen
    ]);
    return {
        onModalOpened: onModalOpened,
        onModalClosed: onModalClosed,
        onFocusWindow: onFocusWindow
    };
}
function $bc2fceb92f63e4a1$export$bbca530fb1561128() {
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const { onModalOpened: onModalOpened, onModalClosed: onModalClosed, onFocusWindow: onFocusWindow } = $bc2fceb92f63e4a1$export$95b1d08316d5a401();
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened), [
        onModalOpened,
        subscribe
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
        onModalClosed,
        subscribe
    ]);
    (0, $6hAZF.useOnWindowFocus)(onFocusWindow);
}

});
parcelRegister("gucQ5", function(module, exports) {

$parcel$export(module.exports, "useBrowserStorageCleanupService", () => $06b0ebeb30b89a35$export$7129d99907775838);

var $5uXOq = parcelRequire("5uXOq");

var $sn9QA = parcelRequire("sn9QA");

const $06b0ebeb30b89a35$var$KEY = 'browser-storage-cleanup';
const $06b0ebeb30b89a35$export$7129d99907775838 = ()=>{
    const [storage] = (0, $5uXOq.useState)((0, $sn9QA.createIndexedDBStorageProvider)(`${(0, $9a94166e56e4a9e2$export$8fa5032778cf7801)}${$06b0ebeb30b89a35$var$KEY}`, {
        shouldAutoReconnect: true
    }));
    return {
        getBrowserStorageCleanup: async ()=>storage.get($06b0ebeb30b89a35$var$KEY),
        createBrowserStorageCleanup: async (data)=>{
            await storage.set($06b0ebeb30b89a35$var$KEY, data);
            return data;
        },
        updateBrowserStorageCleanup: async (data)=>{
            await storage.set($06b0ebeb30b89a35$var$KEY, data);
            return data;
        },
        deleteBrowserStorageCleanup: async ()=>{
            await storage.remove($06b0ebeb30b89a35$var$KEY);
        }
    };
};

});

parcelRegister("6hAZF", function(module, exports) {

$parcel$export(module.exports, "useOnWindowFocus", () => $9475392ebc83c7f2$export$921321d14c966d8f);

var $5uXOq = parcelRequire("5uXOq");
function $9475392ebc83c7f2$export$921321d14c966d8f(onFocus) {
    const onVisibilityChange = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.visibilityState === 'visible') onFocus();
    }, [
        onFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window?.addEventListener) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('visibilitychange', onVisibilityChange, false);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('focus', onFocus, false);
        }
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window?.removeEventListener) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.removeEventListener('visibilitychange', onVisibilityChange);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.removeEventListener('focus', onFocus);
            }
        };
    });
}

});


parcelRegister("4Yfcs", function(module, exports) {

$parcel$export(module.exports, "useIsIssueRestoreSaving", () => $e13d81d2073fcf5c$export$c3cd53fd21626217);

var $4fT7I = parcelRequire("4fT7I");

var $gIPBO = parcelRequire("gIPBO");
const $e13d81d2073fcf5c$export$c3cd53fd21626217 = ()=>{
    const [{ isSavingCounter: isSavingCounterInProgressIssue }] = (0, $4fT7I.useInProgressIssue)();
    const [{ isSavingCounter: isSavingCounterIssueRestoreMeta }] = (0, $gIPBO.useIssueRestoreMeta)();
    return !(isSavingCounterInProgressIssue === 0 && isSavingCounterIssueRestoreMeta === 0);
};

});

parcelRegister("4TnIy", function(module, exports) {

$parcel$export(module.exports, "useShouldShowBrowserWarning", () => $d7857bd1d483352b$export$b44a00b70df66767);

var $dl69W = parcelRequire("dl69W");

var $4fT7I = parcelRequire("4fT7I");

var $4Yfcs = parcelRequire("4Yfcs");

var $8UVKs = parcelRequire("8UVKs");
const $d7857bd1d483352b$export$b44a00b70df66767 = ()=>{
    const [isModalOpen] = (0, $4fT7I.useIsModalOpen)();
    const [isFormDirty] = (0, $4fT7I.useIsFormDirty)();
    const isFormSavingIssueRestore = (0, $4Yfcs.useIsIssueRestoreSaving)();
    const hasRestoreFailed = (0, $dl69W.useHasRestoreFailed)();
    const shouldForceBlock = isModalOpen && (hasRestoreFailed || isFormSavingIssueRestore);
    (0, $8UVKs.useNavigationBlock)({
        forceBlock: shouldForceBlock,
        shouldAttemptNavigationBlock: Boolean(isModalOpen && isFormDirty)
    });
};

});
parcelRegister("dl69W", function(module, exports) {

$parcel$export(module.exports, "useHasRestoreFailed", () => $e2abd52300870bb9$export$2f3853c4298a8e98);

var $4fT7I = parcelRequire("4fT7I");

var $gIPBO = parcelRequire("gIPBO");
const $e2abd52300870bb9$export$2f3853c4298a8e98 = ()=>{
    const [{ restoreError: restoreError }] = (0, $4fT7I.useInProgressIssue)();
    const [{ restoreMetaError: restoreMetaError }] = (0, $gIPBO.useIssueRestoreMeta)();
    return Boolean(restoreError || restoreMetaError);
};

});

parcelRegister("8UVKs", function(module, exports) {

$parcel$export(module.exports, "useNavigationBlock", () => $393bd6724ad5ea22$export$6948be8e76411f59);
/**
 * See https://hello.atlassian.net/wiki/spaces/JSDee/pages/2143585806/Faux+Spa+-+Closing+the+tab
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
function $393bd6724ad5ea22$var$isSameOrigin(destination) {
    const destinationOrigin = new URL(destination).origin;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.origin === destinationOrigin;
}
const $393bd6724ad5ea22$var$useIsSameOriginNavigationAPI = ({ isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin, isEnabled: isEnabled })=>{
    const onNavigate = (0, $5uXOq.useCallback)((e)=>{
        if (e.destination.sameDocument) // when we navigate through the same document (spa -> spa) onBeforeUnload won't be called, so we can instead reset isNavigatingWithinSameOrigin
        // eslint-disable-next-line no-param-reassign
        isNavigatingWithinSameOrigin.current = false; // reset
        else // eslint-disable-next-line no-param-reassign
        isNavigatingWithinSameOrigin.current = $393bd6724ad5ea22$var$isSameOrigin(e.destination.url);
        return isNavigatingWithinSameOrigin.current;
    }, [
        isNavigatingWithinSameOrigin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // only available in newer versions of chrome, opera, and edge
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const { navigation: navigation } = window;
        if (isEnabled && navigation) {
            navigation.addEventListener('navigate', onNavigate);
            return ()=>navigation.removeEventListener('navigate', onNavigate);
        }
        return undefined;
    }, [
        isEnabled,
        onNavigate
    ]);
    // for testing
    return {
        onNavigate: onNavigate
    };
};
const $393bd6724ad5ea22$export$6948be8e76411f59 = ({ forceBlock: forceBlock = false, shouldAttemptNavigationBlock: shouldAttemptNavigationBlock })=>{
    const isNavigatingWithinSameOrigin = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const hasNavigationApi = Boolean(window.navigation);
    const { onNavigate: onNavigate } = $393bd6724ad5ea22$var$useIsSameOriginNavigationAPI({
        isEnabled: hasNavigationApi,
        isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin
    });
    const onBeforeUnload = (0, $5uXOq.useCallback)((e)=>{
        const analyticsPayload = {
            hasNavigationApi: hasNavigationApi,
            forceBlock: forceBlock,
            isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin.current,
            shouldAttemptNavigationBlock: shouldAttemptNavigationBlock
        };
        const shouldBlockNavigation = forceBlock || shouldAttemptNavigationBlock && !isNavigatingWithinSameOrigin.current;
        isNavigatingWithinSameOrigin.current = false; // reset
        if (shouldBlockNavigation) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock showBrowserUnloadPrompt', analyticsPayload);
            e.preventDefault(); // Firefox
            const message = '';
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean'.
            e.returnValue = message; // Chrome
            return message; // IE
        }
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock dontShowBrowserUnloadPrompt', analyticsPayload);
        return undefined;
    }, [
        createAnalyticsEvent,
        forceBlock,
        hasNavigationApi,
        shouldAttemptNavigationBlock
    ]);
    /**
	 * Note: beforeunload will not block user closing the tab if
	 * the user has not interacted with the page
	 */ (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('beforeunload', onBeforeUnload);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window.removeEventListener('beforeunload', onBeforeUnload);
    }, [
        onBeforeUnload
    ]);
    /**
	 * Returning these functions to expose them for unit testing
	 */ return {
        onBeforeUnload: onBeforeUnload,
        onNavigate: onNavigate
    };
};

});


parcelRegister("6i3Qj", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssueSubscriptions", () => $5f6947b98a583af3$export$9b41c2cd5817917a);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $dl69W = parcelRequire("dl69W");

var $4fT7I = parcelRequire("4fT7I");
const $5f6947b98a583af3$var$THROTTLE_DELAY = 250;
const $5f6947b98a583af3$export$9b41c2cd5817917a = ()=>{
    const [, { onFormFieldUpdate: onFormFieldUpdate, onModalOpened: onModalOpened, onModalClosed: onModalClosed, onModalDiscardExistingInProgressIssue: onModalDiscardExistingInProgressIssue, onFormContextUpdate: onFormContextUpdate, onTriggerIssueCreateModalStateChange: onTriggerIssueCreateModalStateChange, onStatusFieldChange: onStatusFieldChange, onClassificationLevelFieldChange: onClassificationLevelFieldChange, onResetFormFieldsForCreateAnother: onResetFormFieldsForCreateAnother, onFormFieldConfigUpdate: onFormFieldConfigUpdate, onIssueTypeChange: onIssueTypeChange, onProjectFieldChange: onProjectFieldChange }] = (0, $4fT7I.useInProgressIssue)();
    const hasRestoreFailed = (0, $dl69W.useHasRestoreFailed)();
    const shouldSubscribe = !hasRestoreFailed;
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const throttledOnFormFieldUpdate = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(onFormFieldUpdate, $5f6947b98a583af3$var$THROTTLE_DELAY, {
            leading: true,
            trailing: true
        }), [
        onFormFieldUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, throttledOnFormFieldUpdate) : undefined, [
        throttledOnFormFieldUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, onFormContextUpdate) : undefined, [
        onFormContextUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened) : undefined, [
        onModalOpened,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed) : undefined, [
        onModalClosed,
        shouldSubscribe,
        subscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, onResetFormFieldsForCreateAnother) : undefined, [
        onResetFormFieldsForCreateAnother,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>{
        shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, onTriggerIssueCreateModalStateChange) : undefined;
    }, [
        onTriggerIssueCreateModalStateChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, onStatusFieldChange) : undefined, [
        onStatusFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, onClassificationLevelFieldChange) : undefined, [
        onClassificationLevelFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, onFormFieldConfigUpdate) : undefined, [
        onFormFieldConfigUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onIssueTypeChange) : undefined, [
        onIssueTypeChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onProjectFieldChange) : undefined, [
        onProjectFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onModalDiscardExistingInProgressIssue) : undefined, [
        onModalDiscardExistingInProgressIssue,
        shouldSubscribe,
        subscribe
    ]);
};

});



parcelRegister("fujGs", function(module, exports) {

$parcel$export(module.exports, "isIndexedDBAvailable", () => $9717920c4a4fae46$export$3865db50535c2055);
function $9717920c4a4fae46$export$3865db50535c2055() {
    try {
        // Do a indexedDB.databases check for Firefox incognito (indexedDB will exist but fail to open databases)
        return Boolean('indexedDB' in window) && Boolean(indexedDB?.databases());
    } catch (e) {
        return false;
    }
}

});


parcelRegister("1n4jA", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedded", () => $0eb03352cf5c3676$export$77140ffa938f9fd1);

var $doZTA = parcelRequire("doZTA");
const $0eb03352cf5c3676$export$77140ffa938f9fd1 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $doZTA.useRouter)();
    return pathname.endsWith('/embed');
};

});


parcelRegister("iiKA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d356530bb9d5bb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $7Jxgt = parcelRequire("7Jxgt");

var $bay8L = parcelRequire("bay8L");

var $6BZYo = parcelRequire("6BZYo");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $6ikhl = parcelRequire("6ikhl");

var $d6dC5 = parcelRequire("d6dC5");

var $gUfkD = parcelRequire("gUfkD");

var $gEaAu = parcelRequire("gEaAu");


var $bGrWH = parcelRequire("bGrWH");

var $c7ZNt = parcelRequire("c7ZNt");

var $2ntXc = parcelRequire("2ntXc");

var $9eKoH = parcelRequire("9eKoH");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $45Cy1 = parcelRequire("45Cy1");

var $c0dQj = parcelRequire("c0dQj");

var $2KAtx = parcelRequire("2KAtx");

var $cKWWX = parcelRequire("cKWWX");

var $5rzqz = parcelRequire("5rzqz");

var $6k7U1 = parcelRequire("6k7U1");

var $6jY6G = parcelRequire("6jY6G");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $cn7wb = parcelRequire("cn7wb");

var $5knXz = parcelRequire("5knXz");

var $9OXo1 = parcelRequire("9OXo1");

var $eyBYT = parcelRequire("eyBYT");

var $c9aLX = parcelRequire("c9aLX");

var $6s1PB = parcelRequire("6s1PB");

var $3bmti = parcelRequire("3bmti");

var $1xqgn = parcelRequire("1xqgn");

var $10zMF = parcelRequire("10zMF");

var $kHA0a = parcelRequire("kHA0a");

var $2K6wP = parcelRequire("2K6wP");

var $lr952 = parcelRequire("lr952");

var $6OTur = parcelRequire("6OTur");

var $6gjIc = parcelRequire("6gjIc");

var $9U8fV = parcelRequire("9U8fV");

var $hH1l8 = parcelRequire("hH1l8");

var $bvFAf = parcelRequire("bvFAf");

var $jP8gL = parcelRequire("jP8gL");

var $a2K6a = parcelRequire("a2K6a");

var $j3DvU = parcelRequire("j3DvU");

var $hFu8Z = parcelRequire("hFu8Z");

var $jagDx = parcelRequire("jagDx");

var $br2XI = parcelRequire("br2XI");

var $7qfv0 = parcelRequire("7qfv0");

var $lFNHi = parcelRequire("lFNHi");

var $hXutx = parcelRequire("hXutx");

var $eF4iR = parcelRequire("eF4iR");

var $7beZ9 = parcelRequire("7beZ9");

var $42ZoK = parcelRequire("42ZoK");

var $dXTIs = parcelRequire("dXTIs");
const $d356530bb9d5bb50$var$DisabledRestoreNavigationPrompt = ({ setShouldRestore: setShouldRestore })=>{
    const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, $9U8fV.useNavigationDiscardChanges)();
    const [{ isFormDirty: isFormDirty }] = (0, $45Cy1.useFormContext)();
    const onConfirmHandler = (0, $5uXOq.useCallback)(()=>{
        setShouldRestore && setShouldRestore(false);
    }, [
        setShouldRestore
    ]);
    const onCancelHandler = (0, $5uXOq.useCallback)(()=>{
        setDeferredNavigationLink('');
    }, [
        setDeferredNavigationLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $10zMF.navigationDiscardChangesPromptEntrypoint),
        entryPointProps: {
            navigateLink: isFormDirty ? deferredNavigationLink : '',
            onConfirm: onConfirmHandler,
            onCancel: onCancelHandler
        },
        interactionName: "navigateWithoutRestorePrompt",
        useInternalModal: false
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7beZ9.NavigateWithoutRestorePrompt), {
            setShouldRestore: setShouldRestore,
            ref: ref
        }));
};
const $d356530bb9d5bb50$var$DismissModalEntryPointWrapper = ({ children: children, entryPointProps: entryPointProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $hFu8Z.createIssueDismissModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "create-issue-dismiss-modal",
        modalProps: {
            width: 'small'
        },
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, children));
const $d356530bb9d5bb50$var$CreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore, onResetApolloCache: onResetApolloCache })=>{
    const sessionIdRef = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const [{ payload: triggerIssueCreatePayload, displayOnlyRequiredFields: displayOnlyRequiredFields, disableCreationSuccessFlag: disableCreationSuccessFlag, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, isModalLoadInContext: isModalLoadInContext, triggerPointKey: triggerPointKey, interactedWithModalChangerButtons: interactedWithModalChangerButtons, inProgressIssueID: inProgressIssueID, sessionId: sessionId, wasStateRestored: wasStateRestored, isCustomBoardWithIcc: isCustomBoardWithIcc, jqlSwimlaneId: jqlSwimlaneId, swimlaneMode: swimlaneMode, ecosystemCallback: ecosystemCallback, product: product, actionSource: actionSource, triggeredViaHotKey: triggeredViaHotKey }, { setSessionId: setSessionId }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    (0, $5uXOq.useEffect)(()=>{
        if (!sessionId) setSessionId(sessionIdRef.current);
    }, [
        sessionId,
        setSessionId
    ]);
    const { showEnforcementIfPendingToShow: showEnforcementIfPendingToShow } = (0, $5knXz.useStorageEnforcement)();
    const [{ isLoading: isModalLoading, fieldConfig: modalFieldConfig, fieldTabs: modalFieldTabs, contextFields: modalContextFields, meta: modalFieldsDataMeta, error: modalFieldsDataError, apiLatency: modalApiLatency, additionalServices: modalAdditionalServices }, fetchModalConfig] = (0, $j3DvU.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey,
        isSubTaskCreationOpen: isSubTaskCreationOpen,
        triggerIssueCreatePayload: triggerIssueCreatePayload,
        isModalLoadInContext: isModalLoadInContext,
        ...(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
            isCreateLinkedIssue: isCreateLinkedIssue
        } : {}
    });
    const classificationFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraDataClassificationField');
    const classificationFieldConfig = classificationFieldId ? modalFieldConfig[classificationFieldId] : undefined;
    const proformaConfiguration = modalAdditionalServices?.proformaConfiguration;
    const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
    const dirtyFieldsCurrentSession = (0, $5uXOq.useRef)({});
    const getFormState = (0, $5uXOq.useRef)(()=>null);
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const [{ isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, shouldShowConfigureFieldModal: shouldShowConfigureFieldModal, shouldShowFindFieldModal: shouldShowFindFieldModal, selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, dataFetchError: dataFetchError, isFormDirty: isCreateFormDirty, canCreateAnotherIssue: canCreateAnotherIssue, createdIssues: createdIssues }, { resetFormContext: resetFormContext, toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setForgeModules: setForgeModules, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setCanCreateAnotherIssue: setCanCreateAnotherIssue, addCreatedIssue: addCreatedIssue }] = (0, $45Cy1.useFormContext)();
    const [, { resetState: resetState }] = (0, $6ikhl.useInlineFieldsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    const { withMachineLearning: withMachineLearning } = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $lr952.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const issueCreateMeta = (0, $3bmti.getAdditionalAttributes)();
    const shouldDisableActions = dataFetchError !== null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldDisableActions && setShouldRestore) {
            if (selectedProject === null) {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'noselectedproject',
                    action: 'error'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssueViewError');
            }
            setShouldRestore(false);
        }
    }, [
        shouldDisableActions,
        setShouldRestore,
        selectedProject,
        createAnalyticsEvent
    ]);
    const initFetchConfig = (0, $5uXOq.useCallback)(()=>{
        // ideally the change should be for all queries, but limitting the scope of change for now. The variable is defaulted to "STANDARD" in the BE.
        const issueCreateType = isCreateLinkedIssue && isModalLoadInContext && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
            issueCreateType: isCreateLinkedIssue ? (0, $bGrWH.ISSUE_CREATE_TYPE).linkedIssue : (0, $bGrWH.ISSUE_CREATE_TYPE).standard
        } : {};
        if (!triggerIssueCreatePayload) fetchModalConfig({
            variables: (0, $br2XI.getQueryVariables)((0, $br2XI.getIssueCreateProjectForMount)(projectContext), null)
        });
        else {
            const { customFieldsToPreserveOnFormRecreation: customFieldsToPreserveOnFormRecreation = [], ...mainPayload } = triggerIssueCreatePayload;
            const parentId = mainPayload.parentId || null;
            const additionalContext = mainPayload.additionalContext || null;
            const projectPayload = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(mainPayload.project) ? null : mainPayload.project;
            fetchModalConfig({
                variables: {
                    project: projectPayload,
                    issueType: mainPayload.issueType || null,
                    requestType: mainPayload.requestType || null,
                    defaultValues: mainPayload.defaultValues || null,
                    issueTypes: mainPayload.issueTypes || null,
                    requestTypes: mainPayload.requestTypes || null,
                    parentId: parentId,
                    additionalContext: additionalContext,
                    ...issueCreateType
                }
            });
            dirtyFieldsCurrentSession.current = {
                ...dirtyFieldsCurrentSession.current,
                ...Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                customFieldsToPreserveOnFormRecreation.map((k)=>[
                        k,
                        true
                    ]))
            };
        }
    }, [
        isCreateLinkedIssue,
        isModalLoadInContext,
        triggerIssueCreatePayload,
        fetchModalConfig,
        projectContext
    ]);
    const [{ siteDomain: siteDomain, selectedCloudId: selectedCloudId }] = (0, $cKWWX.useSitePickerContext)();
    const [{ isLoading: isTransitionsLoading, error: transitionsError, transitions: transitions }, fetchTransitions] = (0, $a2K6a.default)();
    const shouldShowStatus = (0, $5uXOq.useMemo)(()=>(0, $br2XI.shouldShowStatusField)(selectedProject?.projectType, modalFieldConfig), [
        selectedProject,
        modalFieldConfig
    ]);
    const { resetAndReloadCreateForm: resetAndReloadCreateForm } = (0, $bvFAf.useIssueCreateFromAnywhereContext)();
    const refetchTransitions = (0, $5uXOq.useCallback)(async ()=>{
        if (shouldShowStatus && selectedProject && selectedIssueType && !resetAndReloadCreateForm) await fetchTransitions({
            projectId: selectedProject.value,
            issueTypeId: selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
            selectedCloudId: selectedCloudId
        });
    }, [
        fetchTransitions,
        resetAndReloadCreateForm,
        selectedCloudId,
        selectedIssueType,
        selectedProject,
        shouldShowStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        refetchTransitions();
    }, [
        fetchTransitions,
        selectedProject,
        selectedIssueType,
        shouldShowStatus,
        selectedCloudId,
        resetAndReloadCreateForm,
        refetchTransitions
    ]);
    const extraContext = (0, $5uXOq.useMemo)(()=>({
            issueType: selectedIssueType?.label,
            projectKey: selectedProject?.projectKey,
            classificationTags: selectedProject?.classificationTags
        }), [
        selectedProject,
        selectedIssueType
    ]);
    const { customFields: customFields, issueAdjustmentModules: issueAdjustmentModules, filteredOutModules: filteredOutModules, loadingStatus: loadingStatus } = (0, $jP8gL.useFetchForgeModules)(extraContext);
    const hasForgeFinishedLoading = loadingStatus === 'success' || loadingStatus === 'error';
    (0, $5uXOq.useEffect)(()=>{
        if (selectedProject && selectedIssueType) setForgeModules(customFields, issueAdjustmentModules, filteredOutModules, hasForgeFinishedLoading);
    }, [
        issueAdjustmentModules,
        setForgeModules,
        customFields,
        hasForgeFinishedLoading,
        filteredOutModules,
        selectedProject,
        selectedIssueType,
        shouldShowStatus
    ]);
    const [showIssuesCreated, setShowIssuesCreated] = (0, $5uXOq.useState)(false);
    const isApiCallTriggered = (0, $5uXOq.useRef)(false);
    if (!isApiCallTriggered.current) {
        initFetchConfig();
        inProgressIssueID && publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, {
            inProgressIssueID: inProgressIssueID
        });
        const restoredCreatedIssuesExists = createdIssues?.length > 0;
        restoredCreatedIssuesExists && setShowIssuesCreated(restoredCreatedIssuesExists);
        isApiCallTriggered.current = true;
    }
    const [{ globalEventNamespaces: globalEventNamespaces, fieldsToAddInPublishedData: fieldsToAddInPublishedData, alertsToBeLinked: alertsToBeLinked, onIssueCreate: onIssueCreate, onSiteSelection: onSiteSelection, onProjectSelection: onProjectSelection, onClose: onClose, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, callbackPayload: callbackPayload, triggerButtonRef: triggerButtonRef }, { closeIssueCreateModal: closeIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const isCompanyManagedBoard = route?.name === 'rapidboard-board' || route?.name === 'rapidboard-board-settings' || route?.name === 'rapidboard-user-board' || route?.name === 'rapidboard-user-board-settings' || route?.name === 'servicedesk-boards';
    const isCompanyManagedBacklog = route?.name === 'rapidboard-backlog';
    const isCompanyManagedBoardOrBacklog = (0, $4R6GH.fg)('show-create-success-flag-once-in-backlog-page') ? isCompanyManagedBoard || isCompanyManagedBacklog : isCompanyManagedBoard;
    const closeIssueCreateModalNew = (0, $5uXOq.useCallback)((issuesCreated)=>{
        closeIssueCreateModal(Boolean(issuesCreated?.length));
        inProgressIssueID && publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
            callbackPayload: callbackPayload,
            inProgressIssueID: inProgressIssueID,
            createdIssues: issuesCreated
        });
        if (isCompanyManagedBoardOrBacklog && (0, $4R6GH.fg)('fix-gryf-a11y-issues-2')) setTimeout(()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
            const activeElement = document.activeElement;
            if (activeElement) activeElement.blur();
        }, 0);
    }, [
        callbackPayload,
        closeIssueCreateModal,
        inProgressIssueID,
        isCompanyManagedBoardOrBacklog,
        publish
    ]);
    if (isGICPositioningEnabled()) {
        // combine hook with above when cleaning up gic-refetch-on-discard_cxard
        const [{ shouldInitFetchConfig: shouldInitFetchConfig }, { resetShouldInitFetchConfig: resetShouldInitFetchConfig }] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5rzqz.useTriggerIssueCreateModal)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (shouldInitFetchConfig || resetAndReloadCreateForm) {
                resetShouldInitFetchConfig();
                initFetchConfig();
            }
        }, [
            initFetchConfig,
            resetShouldInitFetchConfig,
            shouldInitFetchConfig,
            resetAndReloadCreateForm
        ]);
    }
    (0, $5uXOq.useEffect)(()=>{
        if (resetAndReloadCreateForm) resetFormContext();
    }, [
        resetAndReloadCreateForm,
        resetFormContext
    ]);
    const sourceThatFiredModalDismiss = (0, $5uXOq.useRef)(null);
    const [objectId, setObjectId] = (0, $5uXOq.useState)(undefined);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const showSuccessFlag = (0, $5uXOq.useCallback)((issueList, successFlagParams)=>{
        if (issueList?.length && !disableCreationSuccessFlag) {
            const flagId = (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
            const issueDiscoveryUrl = (0, $2K6wP.getIssueDiscoveryUrl)(issueList);
            showFlag({
                id: flagId,
                render: (flagProps)=>{
                    const successFlagProps = {
                        key: flagProps.key,
                        flagKey: flagProps.key,
                        id: flagId,
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42ZoK.default), {
                        ...successFlagProps,
                        successFlagParams: successFlagParams
                    });
                }
            });
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'flag',
                action: 'viewed'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssueSuccessNotification');
            if ((0, $4R6GH.fg)('fix-gryf-a11y-issues-2')) setTimeout(()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/consistent-type-assertions
                const succeessFlagDismissButton = document.querySelector('[data-testid="platform.ui.flags.common.ui.common-flag-v2-dismiss"]');
                succeessFlagDismissButton?.focus();
            }, 0);
        }
    }, [
        createAnalyticsEvent,
        disableCreationSuccessFlag,
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const api = {
            // @ts-expect-error - TS7006 - Parameter 'params' implicitly has an 'any' type.
            renderSuccessFlag: (params)=>{
                // @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
                const issueList = params.issues.map((issue)=>({
                        issueId: issue.issueId,
                        issueKey: issue.issueKey
                    }));
                (0, $gEaAu.successFlagDisplay).stop();
                showSuccessFlag(issueList, params);
            }
        };
        if (isCompanyManagedBoardOrBacklog) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $6BZYo.loadBridge)({
            name: 'jira-agile/rapid/ui/gic-success-flag/bridge'
        }).then((bridge)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(api));
    }, [
        showSuccessFlag,
        isCompanyManagedBoardOrBacklog
    ]);
    // combine this with above when cleaning up gic.positioning
    const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? (0, $5rzqz.useTriggerIssueCreateModal)() : [
        {
            minimizableModalView: undefined
        }
    ];
    const [{ shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { updateView: updateView } = (0, $cn7wb.usePersistentIssueCreateModalViewResource)();
    const performCleanUp = (0, $5uXOq.useCallback)((shouldPublishCreatedIssues = false, issuesCreated)=>{
        const issueList = issuesCreated ?? createdIssues ?? [];
        if (!isCompanyManagedBoardOrBacklog) showSuccessFlag(issueList);
        else (0, $gEaAu.successFlagDisplay).start();
        const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
        closeIssueCreateModalNew(issueList);
        if (issuesCreated && !isMobileExperienceEnabled) updateView(minimizableModalView === 'mini' ? 'mini' : 'modal');
        if (isCompanyManagedBoardOrBacklog && (0, $4R6GH.fg)('fix-gryf-a11y-issues-2')) setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/consistent-type-assertions
            const succeessFlagDismissButton = document.querySelector('[data-testid="platform.ui.flags.common.ui.common-flag-v2-dismiss"]');
            succeessFlagDismissButton?.focus();
        }, isCompanyManagedBoard ? 2000 : 1000);
        if (shouldPublishCreatedIssues) (0, $dXTIs.publishCreatedIssues)({
            createdIssues: issueList,
            globalEventNamespaces: globalEventNamespaces,
            fieldsToAddInPublishedData: fieldsToAddInPublishedData,
            alertsToBeLinked: alertsToBeLinked,
            isSessionComplete: true,
            onIssueCreate: null,
            onClose: onClose,
            triggerPointKey: triggerPointKey,
            publishGICLifecycle: publish,
            inProgressIssueID: inProgressIssueID,
            callbackPayload: callbackPayload,
            selectedCloudId: selectedCloudId,
            jqlSwimlaneId: jqlSwimlaneId,
            ecosystemCallback: ecosystemCallback
        });
    }, [
        createdIssues,
        isCompanyManagedBoardOrBacklog,
        closeIssueCreateModalNew,
        showSuccessFlag,
        updateView,
        minimizableModalView,
        isCompanyManagedBoard,
        globalEventNamespaces,
        fieldsToAddInPublishedData,
        alertsToBeLinked,
        onClose,
        triggerPointKey,
        publish,
        inProgressIssueID,
        callbackPayload,
        selectedCloudId,
        jqlSwimlaneId,
        ecosystemCallback
    ]);
    const onCreateAnotherChange = (_, analyticsEvent)=>{
        setCanCreateAnotherIssue(!canCreateAnotherIssue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createAnotherIssue', {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const handleTabIndexEmptyContainingRequiredField = ()=>{
        try {
            const fieldValues = getFormState.current()?.values || null;
            const tabIndex = (0, $dXTIs.getTabIndexWithError)(modalFieldTabs, fieldValues, modalFieldConfig);
            setCurrentActiveTabIndex(tabIndex);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'gicModalTabChangeOnSubmit',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const handleEmptyAndRequiredFields = ()=>{
        try {
            const fieldValues = getFormState.current()?.values || null;
            let emptyRequiredFields = [];
            if (modalFieldConfig) emptyRequiredFields = Object.keys(modalFieldConfig)?.filter((fieldId)=>Boolean(modalFieldConfig[fieldId].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(fieldValues[fieldId]));
            const firstFieldIdWithError = (0, $dXTIs.getFirstFieldIdWithError)({
                fields: Object.keys(fieldValues || {}),
                emptyRequiredFields: emptyRequiredFields
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $kHA0a.scrollToField)(firstFieldIdWithError);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'gicModalNextRequiredFieldFocusOnSubmit',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const onSubmit = (_, analyticsEvent)=>{
        handleTabIndexEmptyContainingRequiredField();
        handleEmptyAndRequiredFields();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssue', {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none',
            gicSessionId: sessionIdRef.current
        });
    };
    const showWatchersWarningOrErrorFlag = (0, $5uXOq.useCallback)((createdIssue, response)=>{
        const config = (0, $dXTIs.getWatchersFlagConfigFromResponse)(response, createdIssue.issueKey, selectedIssueType?.label);
        if (config) /**
				 * Showing the watchers warning/error flag slightly after the issue-create-success-flag
				 * so they visually appear one after another in order and the user would be able to
				 * actually see the success flag sliding in first and then being pushed down.
				 */ setTimeout(()=>{
            showFlag(config);
        }, 600);
    }, [
        showFlag,
        selectedIssueType
    ]);
    const onIssueCreateSuccess = (0, $5uXOq.useCallback)((createdIssue, watchersResponse)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const issuesCreated = addCreatedIssue(createdIssue);
        setObjectId(String(createdIssue?.issueId));
        setShowIssuesCreated(showIssuesCreated || canCreateAnotherIssue);
        (0, $dXTIs.publishCreatedIssues)({
            createdIssues: [
                createdIssue
            ],
            globalEventNamespaces: globalEventNamespaces,
            fieldsToAddInPublishedData: fieldsToAddInPublishedData,
            alertsToBeLinked: alertsToBeLinked,
            onIssueCreate: onIssueCreate,
            siteDomain: siteDomain,
            selectedCloudId: selectedCloudId,
            onClose: onClose,
            inProgressIssueID: inProgressIssueID,
            publishGICLifecycle: publish,
            isIssueCreateSuccess: true,
            callbackPayload: callbackPayload,
            jqlSwimlaneId: jqlSwimlaneId,
            ecosystemCallback: ecosystemCallback
        });
        if (!canCreateAnotherIssue) performCleanUp(true, issuesCreated);
        showWatchersWarningOrErrorFlag(createdIssue, watchersResponse);
    }, [
        addCreatedIssue,
        showIssuesCreated,
        canCreateAnotherIssue,
        globalEventNamespaces,
        fieldsToAddInPublishedData,
        alertsToBeLinked,
        onIssueCreate,
        siteDomain,
        selectedCloudId,
        onClose,
        inProgressIssueID,
        publish,
        callbackPayload,
        jqlSwimlaneId,
        ecosystemCallback,
        showWatchersWarningOrErrorFlag,
        performCleanUp
    ]);
    const showConfirmDismissModal = (source)=>{
        sourceThatFiredModalDismiss.current = source;
    };
    const hideConfirmDismissModal = ()=>{
        sourceThatFiredModalDismiss.current = null;
    };
    const onModalClose = (_, analyticsEvent, source)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, source, {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none'
        });
        showEnforcementIfPendingToShow();
        performCleanUp(true);
        resetState();
    };
    const onModalCloseWithConfirm = (source)=>(_, analyticsEvent)=>{
            if (!isCreateFormDirty) {
                if ((0, $4R6GH.fg)('jfp_a11y_team_global_create_issue_btn_focus')) setTimeout(()=>{
                    const activeElement = globalThis.document.activeElement;
                    if (activeElement instanceof HTMLElement) activeElement.blur();
                    triggerButtonRef?.focus();
                }, 500);
                onModalClose(_, analyticsEvent, source);
                return;
            }
            showConfirmDismissModal(source);
        };
    const onConfirmDismissModalCancel = ()=>{
        hideConfirmDismissModal();
    };
    const onConfirmDismissModalConfirm = (_, analyticsEvent)=>{
        const source = sourceThatFiredModalDismiss && sourceThatFiredModalDismiss.current || '';
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        onModalClose(_, analyticsEvent, source);
        if ((0, $4R6GH.fg)('fix-gryf-a11y-issues')) setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/consistent-type-assertions
            const activeElement = document.activeElement;
            if (activeElement) activeElement?.blur?.();
            triggerButtonRef?.focus?.();
        }, 500);
    };
    const [resetFormFieldsCounter, setResetFormFieldsCounter] = (0, $5uXOq.useState)(0);
    const incrementResetCounter = (0, $5uXOq.useCallback)(()=>{
        setResetFormFieldsCounter((n)=>n + 1);
    }, []);
    const hideConfigureFieldsModal = ()=>{
        toggleConfigureFieldsModalVisibility(false);
    };
    const hideFindFieldModal = ()=>{
        toggleFindFieldsModalVisibility(false);
    };
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'shouldShowChangerSpotlight' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'onOpenSpotlight' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'onCloseSpotlight' implicitly has an 'any' type.
    const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, onOpenSpotlight: onOpenSpotlight, onCloseSpotlight: onCloseSpotlight } = isGICPositioningEnabled() ? (0, $6OTur.useChangerSpotlight)(minimizableModalView) : {};
    // resetting form context should happen after the component is unmounted (if done before, certain components/fields were throwing error)
    // @ts-expect-error - TS2322 - Type '() => void | Promise<void>' is not assignable to type 'void | Destructor'.
    (0, $5uXOq.useEffect)(()=>resetFormContext, [
        resetFormContext
    ]);
    // add sprint field to published data to enable dynamic success flags for scrum projects
    (0, $5uXOq.useEffect)(()=>{
        const sprintFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraSprintField');
        if (sprintFieldId !== undefined) fieldsToAddInPublishedData.push(sprintFieldId);
    }, [
        fieldsToAddInPublishedData,
        modalFieldConfig
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fieldPropsExtensions = isGICPositioningEnabled() ? {
        description: {
            onFocus: onOpenSpotlight,
            onBlur: onCloseSpotlight
        }
    } : undefined;
    const preselectedStatus = triggerIssueCreatePayload?.status?.statusId;
    const classificationFieldProps = (0, $2ntXc.useClassificationFieldProps)(classificationFieldConfig);
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusConfigEnabled = expConfig.get('isInlineStatusConfigEnabled', false);
    const buildCreateFormProps = (0, $5uXOq.useCallback)(()=>({
            isLoading: isModalLoading,
            fieldConfig: modalFieldConfig,
            fieldTabs: modalFieldTabs,
            contextFields: modalContextFields,
            meta: modalFieldsDataMeta,
            error: modalFieldsDataError,
            apiLatency: modalApiLatency,
            onFetchConfig: fetchModalConfig,
            onIssueCreateSuccess: onIssueCreateSuccess,
            onSiteSelection: onSiteSelection,
            onProjectSelection: onProjectSelection,
            canCreateAnotherIssue: canCreateAnotherIssue,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            getFormState: getFormState,
            onFormFieldsReset: incrementResetCounter,
            fieldPropsExtensions: fieldPropsExtensions,
            onResetApolloCache: onResetApolloCache,
            filteredOutModules: filteredOutModules,
            ...classificationFieldConfig && Array.isArray(classificationFieldConfig?.allowedValues) && classificationFieldConfig.allowedValues.length > 0 ? {
                classificationFieldProps: classificationFieldProps
            } : {},
            ...shouldShowStatus ? {
                statusFieldProps: {
                    preselectedTransition: transitions?.find((transition)=>transition.to.id === preselectedStatus),
                    initialTransition: transitions?.find((it)=>it.isInitial),
                    availableTransitions: transitions,
                    isTransitionsLoading: isTransitionsLoading,
                    transitionsError: transitionsError
                }
            } : Object.freeze({}),
            proformaConfiguration: proformaConfiguration,
            watchersConfigurations: modalAdditionalServices.watchersConfigurations,
            onStatusCreatedOrUpdated: combinedInlineConfigurationExperiment.isEnabled || isInlineStatusConfigEnabled ? refetchTransitions : undefined
        }), [
        isModalLoading,
        modalFieldConfig,
        modalFieldTabs,
        modalContextFields,
        modalFieldsDataMeta,
        modalFieldsDataError,
        modalApiLatency,
        fetchModalConfig,
        onIssueCreateSuccess,
        onSiteSelection,
        onProjectSelection,
        canCreateAnotherIssue,
        incrementResetCounter,
        fieldPropsExtensions,
        onResetApolloCache,
        filteredOutModules,
        classificationFieldConfig,
        classificationFieldProps,
        shouldShowStatus,
        transitions,
        isTransitionsLoading,
        transitionsError,
        proformaConfiguration,
        modalAdditionalServices.watchersConfigurations,
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusConfigEnabled,
        refetchTransitions,
        preselectedStatus
    ]);
    const createFormProps = (0, $5uXOq.useMemo)(()=>{
        let formProps = buildCreateFormProps();
        if (onTransformCreateFormProps) formProps = onTransformCreateFormProps(formProps);
        return formProps;
    }, [
        buildCreateFormProps,
        onTransformCreateFormProps
    ]);
    const renderFormOrError = ()=>{
        if (shouldDisableActions) {
            if ((0, $4R6GH.fg)('issue_create_error_screen_error')) (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'errorScreenRendered',
                    teamName: 'gryffindor'
                },
                attributes: {
                    ...(0, $4R6GH.fg)('additional_metric_attributes_issue_create') ? issueCreateMeta : {}
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qfv0.default), null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jagDx.default), createFormProps);
    };
    const currentUIModificationsConsentState = (0, $d6dC5.useUIModificationsConsentStatus)();
    const getShouldDisableSubmit = ()=>currentUIModificationsConsentState === (0, $0659eefb602f8f84$export$d67d63332ce3ce38) || !meta.areRequiredFieldsSupported || shouldDisableActions || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(meta.queryErrorMessage);
    // initialise the request type fields layout preference on modal load
    // internally, this will not re-fetch if previously done
    const [{ data: isRequestTypeFieldsLayoutEnabled }, { initialise: initialise }] = (0, $hH1l8.useRequestTypeFieldsLayoutPreference)();
    (0, $5uXOq.useEffect)(()=>{
        if (atlassianAccountId) initialise(atlassianAccountId, createAnalyticsEvent);
    }, [
        atlassianAccountId,
        createAnalyticsEvent,
        initialise
    ]);
    const isRequestTypeSelected = selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44);
    const renderConfigureFieldsModal = ()=>shouldShowConfigureFieldModal && selectedProject && selectedIssueType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9eKoH.default), {
            onCancel: hideConfigureFieldsModal,
            project: {
                projectId: selectedProject.value,
                projectType: selectedProject.projectType
            },
            issueTypeId: isRequestTypeSelected ? selectedIssueType.issueTypeId : selectedIssueType.value,
            requestTypeKey: isRequestTypeSelected ? selectedIssueType.requestTypeKey : undefined,
            parentId: triggerIssueCreatePayload?.parentId?.parentId,
            setAreConfiguredFieldsModified: setAreConfiguredFieldsModified,
            onlyDisplayAllFieldsOption: isRequestTypeFieldsLayoutEnabled && isRequestTypeSelected,
            messageContent: isRequestTypeSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXutx.JsmRequestTypeFieldsChangeboarding), null) : undefined
        }) : null;
    const renderFindFieldModal = ()=>shouldShowFindFieldModal && selectedProject && selectedIssueType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUfkD.default), {
            project: {
                projectId: selectedProject.value,
                nextGenProject: selectedProject.isSimplified,
                projectType: selectedProject.projectType
            },
            issueTypeId: selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
            operation: "CREATE",
            onCancel: hideFindFieldModal
        }) : null;
    const renderExistingGicWarningModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFNHi.ExistingGICWarning), null);
    const renderDisabledRestoreNavigationPrompt = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d356530bb9d5bb50$var$DisabledRestoreNavigationPrompt, {
            setShouldRestore: setShouldRestore
        });
    const modalWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF4iR.ModalWrapper), {
        onModalCloseWithConfirm: onModalCloseWithConfirm,
        shouldDisableActions: shouldDisableActions,
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        getShouldDisableSubmit: getShouldDisableSubmit,
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        shouldShowChangerSpotlight: isGICPositioningEnabled() ? !interactedWithModalChangerButtons && shouldShowChangerSpotlight : undefined,
        showIssuesCreated: showIssuesCreated,
        initialSummaryValue: (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(createFormProps.fieldConfig) ? null : createFormProps.fieldConfig?.summary?.defaultValue || '',
        projectType: selectedProject?.projectType,
        selectedIssueType: selectedIssueType,
        setShouldRestore: setShouldRestore,
        watchersConfigurations: modalAdditionalServices.watchersConfigurations,
        ...isCreateFormDirty && selectedProject ? {
            dismissModalEntryPointWrapper: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d356530bb9d5bb50$var$DismissModalEntryPointWrapper, {
                    ...p,
                    entryPointProps: {
                        project: {
                            projectId: selectedProject.value,
                            projectType: selectedProject.projectType
                        },
                        sessionId: sessionIdRef.current,
                        onClose: onConfirmDismissModalCancel,
                        onConfirm: onConfirmDismissModalConfirm
                    }
                })
        } : {}
    }, !isGICPositioningEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bay8L.SmartCardProviderMigration), null, renderFormOrError()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9aLX.UiModificationsEntryPoint), {
        issueTypeFieldType: modalContextFields.issuetype?.type || '',
        modalFieldConfig: modalFieldConfig,
        modules: issueAdjustmentModules,
        resetFormFieldsCounter: resetFormFieldsCounter,
        selectedIssueType: selectedIssueType,
        selectedProject: selectedProject,
        triggerPointKey: triggerPointKey
    }), renderConfigureFieldsModal(), renderFindFieldModal(), isGICPositioningEnabled() && renderExistingGicWarningModal(), renderDisabledRestoreNavigationPrompt());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "createIssue",
        containerType: "project",
        objectType: "issue",
        objectId: objectId,
        containerId: selectedProject ? selectedProject.value : '',
        attributes: {
            isNewGIC: true,
            isCreatingAnotherIssue: canCreateAnotherIssue,
            isSubtask: isSubTaskCreationOpen,
            triggerPointKey: triggerPointKey,
            projectType: selectedProject?.projectType,
            ...selectedProject ? {
                nextGenProject: selectedProject.isSimplified
            } : {},
            ...isGICPositioningEnabled() ? {
                gicViewState: minimizableModalView
            } : {},
            ...(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                isCreateLinkedIssue: isCreateLinkedIssue
            } : {},
            hasProformaForm: !!proformaConfiguration?.hasProformaForm,
            wasStateRestored: wasStateRestored,
            isDiscoverabilityPush: !!shouldPushMiniModalDiscoverability && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(triggerPointKey),
            smartFieldsEnabled: withMachineLearning,
            sessionId: !sessionId ? sessionIdRef.current : sessionId,
            isCustomBoardWithIcc: isCustomBoardWithIcc,
            swimlaneMode: swimlaneMode,
            ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                triggeredViaHotKey: triggeredViaHotKey
            } : {},
            ...product ? {
                product: product
            } : {},
            ...actionSource ? {
                actionSource: actionSource
            } : {},
            ...(0, $4R6GH.fg)('additional_metric_attributes_issue_create') ? issueCreateMeta : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyBYT.UiModificationsContainer), null, modalWrapper));
};
var $d356530bb9d5bb50$export$2e2bcd8739ae039 = $d356530bb9d5bb50$var$CreateModal;

});
parcelRegister("bay8L", function(module, exports) {

$parcel$export(module.exports, "SmartCardProviderMigration", () => $bfd2a295419d11d6$export$c23cd4b65d8850b8);

var $5uXOq = parcelRequire("5uXOq");

var $8dO33 = parcelRequire("8dO33");

var $4R6GH = parcelRequire("4R6GH");
const $bfd2a295419d11d6$export$c23cd4b65d8850b8 = ({ children: children, product: product, client: client })=>(0, $4R6GH.fg)('fun-1689_single_root_smart_card_provider') ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        client: client
    }, children);

});

const $0659eefb602f8f84$export$39d15f3568f5a72c = 'unknown';
const $0659eefb602f8f84$export$d67d63332ce3ce38 = 'required';
const $0659eefb602f8f84$export$45ca911896c5084f = 'consented';

parcelRegister("d6dC5", function(module, exports) {

$parcel$export(module.exports, "useUIModificationsConsentStatus", () => $b15e66dd4943504c$export$e2c526d2c1843a0e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $b15e66dd4943504c$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $b15e66dd4943504c$export$2a5a8f1570c161c6);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $jrwZp = parcelRequire("jrwZp");

const $b15e66dd4943504c$var$selectOverallConsentStatus = (0, $6dDSs.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $0659eefb602f8f84$export$d67d63332ce3ce38)) ? (0, $0659eefb602f8f84$export$d67d63332ce3ce38) : (0, $0659eefb602f8f84$export$45ca911896c5084f));
const $b15e66dd4943504c$export$e2c526d2c1843a0e = (0, $3sQ5x.createStateHook)((0, $jrwZp.store), {
    selector: $b15e66dd4943504c$var$selectOverallConsentStatus
});
const $b15e66dd4943504c$export$7700bb22109a011e = (0, $3sQ5x.createStateHook)((0, $jrwZp.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $0659eefb602f8f84$export$39d15f3568f5a72c)
});
const $b15e66dd4943504c$export$2a5a8f1570c161c6 = (0, $3sQ5x.createStateHook)((0, $jrwZp.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});


parcelRegister("gUfkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b8d3b1683bb69c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kErdU = parcelRequire("kErdU");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7b8d3b1683bb69c2$var$FindFieldModal = (0, $kxZPA.lazy)(()=>(parcelRequire("iNzQ2")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/find-field/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b8d3b1683bb69c2$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "AsyncFindFieldModal",
        packageName: "jiraIssueConfigFindField",
        fallback: "flag",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "config-find-field-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b8d3b1683bb69c2$var$FindFieldModal, props)));

});
parcelRegister("iNzQ2", function(module, exports) {

let $daf89a5e02a271c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $daf89a5e02a271c7$var$load("cM9em"),
    $daf89a5e02a271c7$var$load("fr9NE"),
    $daf89a5e02a271c7$var$load("a3NGg")
]).then(()=>parcelRequire('gLfH6'));

});


// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("c7ZNt", function(module, exports) {

$parcel$export(module.exports, "transformProjectType", () => $ce1d90d73f191ff5$export$bd65219b3dd7789d);

var $2vSU6 = parcelRequire("2vSU6");
const $ce1d90d73f191ff5$export$bd65219b3dd7789d = (projectType)=>{
    if (!projectType) return 'none';
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return 'serviceManagement';
    if (projectType === (0, $2vSU6.CORE_PROJECT)) return 'workManagement';
    return projectType;
};

});

parcelRegister("2ntXc", function(module, exports) {

$parcel$export(module.exports, "useClassificationState", () => $b90b90d153a62455$export$4404b0743b8ee564);
$parcel$export(module.exports, "useClassificationFieldProps", () => $b90b90d153a62455$export$e2bccade312f8);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $54T03 = parcelRequire("54T03");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $52tuV = parcelRequire("52tuV");
const $b90b90d153a62455$export$4404b0743b8ee564 = (classificationOption)=>{
    const [selectedClassification, setSelectedClassification] = (0, $5uXOq.useState)(classificationOption);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
    const onClassificationOptionChange = (0, $5uXOq.useCallback)((option)=>{
        setSelectedClassification(option);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'ClassificationInGIC changed');
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, {
            selectedClassification: option
        });
    }, [
        createAnalyticsEvent,
        publish
    ]);
    return [
        selectedClassification,
        setSelectedClassification,
        onClassificationOptionChange
    ];
};
const $b90b90d153a62455$export$e2a389820b14b290 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((value)=>{
        if (!value) {
            const noClassificationOption = {
                id: undefined,
                definition: formatMessage((0, $52tuV.default).noClassificationOption),
                color: undefined,
                includeIcon: false
            };
            return noClassificationOption;
        }
        return (0, $54T03.getProjectDefaultClassificationOption)(formatMessage((0, $52tuV.default).projectDefaultClassificationOption), value);
    }, [
        formatMessage
    ]);
};
const $b90b90d153a62455$export$cdada88ebf1ccd9 = (classificationFieldConfig)=>{
    const allowedClassifications = classificationFieldConfig?.allowedValues?.map((value)=>$b90b90d153a62455$export$a30f3e09b4b8e281(value.node));
    return allowedClassifications;
};
const $b90b90d153a62455$export$a30f3e09b4b8e281 = (defaultValue)=>{
    const defaultClassification = defaultValue ? {
        id: defaultValue?.id,
        name: defaultValue?.name,
        definition: defaultValue?.definition,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: defaultValue?.color?.colorKey
    } : undefined;
    return defaultClassification;
};
const $b90b90d153a62455$export$e2bccade312f8 = (classificationFieldConfig)=>{
    const getCreateClassificationLevel = $b90b90d153a62455$export$e2a389820b14b290();
    return (0, $5uXOq.useMemo)(()=>{
        let classificationFieldProps = {
            availableClassifications: undefined,
            initialClassification: undefined,
            isDisabled: false,
            nonEditableMessage: undefined
        };
        const allowedClassifications = $b90b90d153a62455$export$cdada88ebf1ccd9(classificationFieldConfig);
        const initialDefaultClassification = $b90b90d153a62455$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[0]);
        const projectDefaultClassification = $b90b90d153a62455$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[1]);
        const projectLevelClassification = getCreateClassificationLevel(projectDefaultClassification);
        const isFieldEditable = classificationFieldConfig?.isEditable;
        if (allowedClassifications) classificationFieldProps = {
            availableClassifications: allowedClassifications.concat(projectLevelClassification),
            initialClassification: initialDefaultClassification || projectLevelClassification,
            isDisabled: isFieldEditable === false,
            nonEditableMessage: classificationFieldConfig?.nonEditableReason
        };
        return classificationFieldProps;
    }, [
        classificationFieldConfig,
        getCreateClassificationLevel
    ]);
};

});
parcelRegister("54T03", function(module, exports) {

$parcel$export(module.exports, "getProjectDefaultClassificationOption", () => $abed6bbea4a3fb86$export$1f0ddb93897fde19);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $74sEg = parcelRequire("74sEg");
const $abed6bbea4a3fb86$export$d890d332bbf5844a = (classifications)=>classifications ? {
        edges: classifications.map((classification)=>({
                node: {
                    id: classification.id,
                    name: classification.name,
                    definition: classification.definition,
                    color: {
                        colorKey: classification.color
                    }
                }
            }))
    } : classifications;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abed6bbea4a3fb86$var$OverflowWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $abed6bbea4a3fb86$var$ProjectDefaultTextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1i6y",
            __cmplp.className
        ])
    });
});
const $abed6bbea4a3fb86$export$1f0ddb93897fde19 = (message, defaultClassificationLevel)=>{
    const color = typeof defaultClassificationLevel?.color === 'string' ? defaultClassificationLevel?.color : defaultClassificationLevel?.color?.colorKey;
    return {
        id: undefined,
        nameFormatter: (classification)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abed6bbea4a3fb86$var$OverflowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abed6bbea4a3fb86$var$ProjectDefaultTextWrapper, null, message, " - "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74sEg.ClassificationLozenge), {
                ...classification,
                name: defaultClassificationLevel?.name || ''
            })),
        // The below lint error is because Color type expects string, whereas the graphQL type expects { colorKey: string }. This has been handled in variable definition for color.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: color,
        definition: ''
    };
};

});
parcelRegister("74sEg", function(module, exports) {

$parcel$export(module.exports, "ClassificationLozenge", () => $5a84988b432bf2ca$export$f31d135f91971ac4);
$parcel$export(module.exports, "DataClassificationDropdown", () => $5a84988b432bf2ca$export$37a6278f2f470b5e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $LpImS = parcelRequire("LpImS");

var $ajpes = parcelRequire("ajpes");

var $059q9 = parcelRequire("059q9");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $gmmpY = parcelRequire("gmmpY");

var $7Kq24 = parcelRequire("7Kq24");

var $bj9nc = parcelRequire("bj9nc");
/**
 * The options in the select dropdown are quite customizable, and achieves different use-cases.
 * Options are identified (i.e. how an option in the dropdown is selected) by the "name", "label", and "definition" properties.
 * Typeof "option" prop is "ClassificationOption", which has requires at least one of the properties to exist, therefore it is safe to assume that an option will always be identifiable.
 * Obviously there can be duplicates, but that is a user error.
 *
 * Since only one of these identifying properties is required, there are 7 different combinations of these properties that will render a different option.
 *
 * (1) name
 *    - renders: name with icon (if includeIcon is true) in the icon container
 * (2) name, label
 *    - renders: name with icon (if includeIcon is true) in the icon container, and an inline label outside of the icon container
 * (3) name, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, and a definition below the icon container
 * (4) name, label, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, an inline label outside of the icon container, and a definition below the icon container
 * (5) label
 *    - renders: icon container with only an icon, and an inline label outside of the icon container
 *    - note: if includeIcon is false, then the icon container will not render (i.e. only an inline label will render)
 * (6) label, definition
 *    - renders: similar to (5) but with a definition below the icon container
 * (7) definition
 *    - renders: icon container with only an icon (conditionally rendered based on includeIcon), and a definition below the icon container
 *
 * Use cases:
 *    For space/project defaults we don't want to render a name.
 *    Instead we want to render a label: "Use space/project default".
 *    We also want to render a definition defining what the space/project default is.
 *    In this case, we'll use (6).
 *
 *    For resetting a classification (i.e. selecting the "No classification" option), we don't want to render a name or label.
 *    Instead we want to render only a definition and without an icon.
 *    In this case, we'll use (7) and pass in includeIcon={false}.
 */ const $5a84988b432bf2ca$var$dangerTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text.danger',
    paddingInlineStart: 'space.025'
});
const $5a84988b432bf2ca$var$selectOptionStyles = {
    root: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $5a84988b432bf2ca$var$selectMenuPortalStyles = {
    root: "_1pbydx66"
};
const $5a84988b432bf2ca$var$CustomSingleValue = ({ children: children, ...props })=>{
    const { data: data } = props;
    const { name: name, nameLabel: nameLabel, definition: definition, color: color = 'GREY', includeIcon: includeIcon = true, classificationOverride: classificationOverride, nameFormatter: nameFormatter } = data || {};
    const inputName = classificationOverride?.name ?? name ?? nameLabel ?? definition;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.ContainerLabel), {
            children: nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bj9nc.ContainerIcon), {
                colorsConfig: (0, $gmmpY.colorsConfig)[color],
                isIconOnly: includeIcon && !inputName,
                children: [
                    includeIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Kq24.ClassificationIcon), {
                        width: 14,
                        height: 14,
                        isDisabled: false,
                        color: (0, $gmmpY.colorsConfig)[color].fontColor,
                        disabledColorConfig: (0, $gmmpY.disabledColorConfig)
                    }),
                    inputName && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.Name), {
                        children: inputName
                    })
                ]
            })
        })
    });
};
/**
 * CustomOption component is used to render each option in the dropdown.
 **/ const $5a84988b432bf2ca$var$CustomOption = (props)=>{
    const { data: data } = props;
    const { name: name, definition: definition, nameLabel: nameLabel, includeIcon: includeIcon = true, nameFormatter: nameFormatter } = data || {};
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Option, {
        ...props,
        xcss: $5a84988b432bf2ca$var$selectOptionStyles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
            space: "space.050",
            children: [
                (name || nameLabel || includeIcon) && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bj9nc.ContainerLabel), {
                    definitionExists: Boolean(definition),
                    children: [
                        nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, $2OMIu.jsx)($5a84988b432bf2ca$export$f31d135f91971ac4, {
                            ...data
                        }),
                        nameLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.NameLabel), {
                            children: nameLabel
                        })
                    ]
                }),
                definition && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.Definition), {
                    children: definition
                })
            ]
        })
    });
};
const $5a84988b432bf2ca$export$f31d135f91971ac4 = (data)=>{
    const { name: name, nameLabel: nameLabel, includeIcon: includeIcon = true, color: color = 'GREY', colorOnlyIconBackground: colorOnlyIconBackground = false } = data || {};
    // if name and label are both present, trim name to fit nameLabel in the same row
    const shouldTrimBothNameAndLabel = Boolean(name && nameLabel);
    const iconComponent = includeIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Kq24.ClassificationIcon), {
        width: 14,
        height: 14,
        isDisabled: false,
        color: (0, $gmmpY.colorsConfig)[color].fontColor,
        disabledColorConfig: (0, $gmmpY.disabledColorConfig)
    });
    /* name inside a lozenge will only be a string and not a reactNode */ const nameComponent = name && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.Name), {
        children: name.substring(0, (0, $gmmpY.nameMaxLength) / (shouldTrimBothNameAndLabel ? 2 : 1))
    });
    return colorOnlyIconBackground ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.ContainerIcon), {
                colorsConfig: (0, $gmmpY.colorsConfig)[color],
                isIconOnly: includeIcon && !name,
                children: iconComponent
            }),
            nameComponent
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bj9nc.ContainerIcon), {
        colorsConfig: (0, $gmmpY.colorsConfig)[color],
        isIconOnly: includeIcon && !name,
        children: [
            iconComponent,
            nameComponent
        ]
    });
};
const $5a84988b432bf2ca$export$37a6278f2f470b5e = ({ label: label, options: options, value: value, errorMessage: errorMessage, disabledTooltipMessage: disabledTooltipMessage, isDisabled: isDisabled, onChange: onChange, onInputChange: onInputChange, menuShouldScrollIntoView: menuShouldScrollIntoView })=>{
    // find selected classification in options
    const onSelectChange = (option)=>{
        // we want to identify the selected option by these properties
        const selectedOption = {
            name: option?.name,
            definition: option?.definition,
            label: option?.nameLabel
        };
        // find corresponding classification in options based on identifying properties
        const selectedClassification = options.find((opt)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))({
                name: opt.name,
                definition: opt.definition,
                label: opt.label
            }, selectedOption));
        if (!selectedOption || !selectedClassification) return;
        if (onChange) onChange(selectedClassification);
    };
    /*
     Since select component requires label & value props in list of options, we'll transform "options" prop to include these values.
   */ const transformToOptionType = (0, $5uXOq.useCallback)((classification)=>({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(classification),
            // either name, label, or definition must exist, so we can safely use ! here
            label: classification.name ?? classification.label ?? classification.definition,
            // Asserting this as a string to keep lint happy. This wont be an issue, since CustomOption component will handle scenarios where name is a ReactNode.
            value: classification.name ?? classification.label ?? classification.definition,
            nameLabel: classification.label // since label is reserved for an option, we'll use nameLabel
        }), []);
    const transformedOptions = (0, $5uXOq.useMemo)(()=>options.map(transformToOptionType), [
        options,
        transformToOptionType
    ]);
    const renderDropdown = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
            label: "data-classification-select",
            inputId: "data-classification-dropdown-input",
            options: transformedOptions,
            value: !value || errorMessage ? null : transformToOptionType(value),
            onChange: onSelectChange,
            onInputChange: onInputChange,
            isInvalid: Boolean(errorMessage),
            isDisabled: isDisabled,
            components: {
                Option: $5a84988b432bf2ca$var$CustomOption,
                SingleValue: $5a84988b432bf2ca$var$CustomSingleValue,
                MenuPortal: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).MenuPortal, {
                        ...props,
                        xcss: $5a84988b432bf2ca$var$selectMenuPortalStyles.root
                    })
            },
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: {
                option: (baseStyles)=>({
                        ...baseStyles,
                        padding: "var(--ds-space-200, 16px)"
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            menuPortalTarget: document.body
        });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.100",
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bj9nc.DropdownLabel), {
                htmlFor: "data-classification-dropdown-input",
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                space: "space.050",
                children: [
                    isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: disabledTooltipMessage,
                        children: renderDropdown()
                    }) : renderDropdown(),
                    errorMessage && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
                        alignItems: "center",
                        gap: "space.050",
                        xcss: $5a84988b432bf2ca$var$dangerTextStyles,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                                as: "p",
                                size: "small",
                                color: "inherit",
                                children: errorMessage
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("gmmpY", function(module, exports) {

$parcel$export(module.exports, "nameMaxLength", () => $2e622580cdfaa511$export$253bdad208569777);
$parcel$export(module.exports, "guidelineMaxLength", () => $2e622580cdfaa511$export$e1444e5b0a63d793);
$parcel$export(module.exports, "colorsConfig", () => $2e622580cdfaa511$export$fb2992e82b83582a);
$parcel$export(module.exports, "disabledColorConfig", () => $2e622580cdfaa511$export$9cdea53b8993b139);

var $i5FdW = parcelRequire("i5FdW");

var $lGSLk = parcelRequire("lGSLk");
const { formatMessage: $2e622580cdfaa511$var$formatMessage } = (0, $i5FdW.createIntl)({
    locale: 'en'
});
const $2e622580cdfaa511$export$89b67151eed9295a = {
    definition: $2e622580cdfaa511$var$formatMessage((0, $lGSLk.messages).noClassification),
    includeIcon: false
};
const $2e622580cdfaa511$export$253bdad208569777 = 50;
const $2e622580cdfaa511$export$cbc3cef853d1014b = 1000;
const $2e622580cdfaa511$export$e1444e5b0a63d793 = 1000;
const $2e622580cdfaa511$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        bgColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
        bgColorPressed: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
        bgColorFocused: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E56910)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
        bgColorHovered: "var(--ds-background-accent-orange-subtle-hovered, #FEC195)",
        bgColorPressed: "var(--ds-background-accent-orange-subtle-pressed, #FEDEC8)",
        bgColorFocused: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        bgColorHovered: "var(--ds-background-accent-red-subtler-hovered, #FD9891)",
        bgColorPressed: "var(--ds-background-accent-red-subtler-pressed, #F87168)",
        bgColorFocused: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        bgColorHovered: "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
        bgColorPressed: "var(--ds-background-accent-red-bolder-pressed, #5D1F1A)",
        bgColorFocused: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #8270DB)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        bgColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)",
        bgColorPressed: "var(--ds-background-accent-purple-subtlest-pressed, #B8ACF6)",
        bgColorFocused: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #1D7AFC)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        bgColorHovered: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)",
        bgColorPressed: "var(--ds-background-accent-blue-subtler-pressed, #579DFF)",
        bgColorFocused: "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        bgColorHovered: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)",
        bgColorPressed: "var(--ds-background-accent-teal-subtler-pressed, #6CC3E0)",
        bgColorFocused: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        bgColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
        bgColorPressed: "var(--ds-background-accent-green-subtlest-pressed, #7EE2B8)",
        bgColorFocused: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #758195)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        bgColorHovered: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)",
        bgColorPressed: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)",
        bgColorFocused: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        fontColor: "var(--ds-text, #172B4D)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        bgColorHovered: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
        bgColorPressed: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
        bgColorFocused: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    }
};
const $2e622580cdfaa511$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #091E424F)",
    fontColor: "var(--ds-text-disabled, #091E424F)",
    bgColor: "var(--ds-background-disabled, #091E4208)"
};

});
parcelRegister("lGSLk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8d9596bf354d4700$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8d9596bf354d4700$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    noClassification: {
        id: 'data-classification-level.no-classification',
        defaultMessage: 'No classification',
        description: 'Text for the no classification option'
    },
    classifyContent: {
        id: 'data-classification-level.edit-popup.classify-content',
        defaultMessage: 'Classify content',
        description: 'Text for the header of the edit popup'
    },
    selectClassification: {
        id: 'data-classification-level.edit-popup.select-classification',
        defaultMessage: 'Select classification',
        description: 'Text for the label of the select dropdown to select a classification'
    },
    updateButton: {
        id: 'data-classification-level.edit-popup.update-button',
        defaultMessage: 'Update',
        description: 'Text for the update button'
    },
    cancelButton: {
        id: 'data-classification-level.edit-popup.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button'
    },
    changeLevel: {
        id: 'data-classification-level.read-popup.change-level',
        defaultMessage: 'Change level',
        description: 'Text for the button that changes the level of the selected classification'
    },
    rules: {
        id: 'data-classification-level.rules',
        defaultMessage: '({associatedPoliciesCount, plural, one {# rule} other {# rules}})',
        description: 'Text next to the title of the classification describing the number of rules associated'
    },
    dataClassificationLevel: {
        id: 'data-classification-level.data-classification-level',
        defaultMessage: 'Data classification level',
        description: 'Aria label for data classification level'
    }
});

});


parcelRegister("7Kq24", function(module, exports) {

$parcel$export(module.exports, "ClassificationIcon", () => $ba755001a3eae43b$export$d2e14829910b9b7d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eL2cT = parcelRequire("eL2cT");
const $ba755001a3eae43b$export$d2e14829910b9b7d = ({ color: color, width: width, height: height, isDisabled: isDisabled, disabledColorConfig: disabledColorConfig })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eL2cT.SvgIcon), {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: isDisabled ? disabledColorConfig.fontColor : color
        })
    });
};

});
parcelRegister("eL2cT", function(module, exports) {

$parcel$export(module.exports, "SvgIcon", () => $6cbad74b302984de$export$dbcb8210e8a983ed);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $6cbad74b302984de$export$dbcb8210e8a983ed = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px"),
            "--_10ib6lf": (0, $lD23V.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91efm _1tket1jn",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bj9nc", function(module, exports) {

$parcel$export(module.exports, "DropdownLabel", () => $c00106226964da92$export$bef68440ec6a6159);
$parcel$export(module.exports, "NameLabel", () => $c00106226964da92$export$63077572f44eb437);
$parcel$export(module.exports, "ContainerLabel", () => $c00106226964da92$export$3944a9dffaf20407);
$parcel$export(module.exports, "ContainerIcon", () => $c00106226964da92$export$6d6da6edaddd5876);
$parcel$export(module.exports, "Name", () => $c00106226964da92$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Definition", () => $c00106226964da92$export$cf0290ef4b5a4f61);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c00106226964da92$export$bef68440ec6a6159 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _k48p1pd9",
            __cmplp.className
        ])
    });
});
const $c00106226964da92$export$63077572f44eb437 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _18u0u2gc _syaz15xy _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $c00106226964da92$export$3944a9dffaf20407 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { definitionExists: definitionExists, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t9f321": (0, $lD23V.default)(__cmplp.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _otyrmjfo",
            __cmplp.className
        ])
    });
});
const $c00106226964da92$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconOnly: isIconOnly, colorsConfig: colorsConfig, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_139b6h8": (0, $lD23V.default)(__cmplp.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)"),
            "--_1udd052": (0, $lD23V.default)(__cmplp.colorsConfig.fontColor),
            "--_s8jg64": (0, $lD23V.default)(__cmplp.colorsConfig.bgColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4v77o _2rko1sit _11q71iaf _1e0c116y _p12f1osq _o5721q9c _1bsb1wug _4cvr1h6o _u5f31gh9 _syaz1tdf _uiztglyw",
            __cmplp.className
        ])
    });
});
const $c00106226964da92$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _k48p19lj _vwz4dlk8 _18u0v77o _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $c00106226964da92$export$cf0290ef4b5a4f61 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz15xy _o5721jtm _1i4q1hna _slp31hna",
            __cmplp.className
        ])
    });
});

});



parcelRegister("52tuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb77fdfdd3b6ad9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bcb77fdfdd3b6ad9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    classificationFieldLabel: {
        "id": "issue-create-commons.data-classification-field.classification-field-label",
        "defaultMessage": "Classification level"
    },
    projectDefaultClassificationOption: {
        "id": "issue-create-commons.data-classification-field.project-default-classification-option",
        "defaultMessage": "Project default"
    },
    noClassificationOption: {
        "id": "issue-create-commons.data-classification-field.no-classification-option",
        "defaultMessage": "Project default - No classification"
    }
});

});


parcelRegister("9eKoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $448be576ffb80ea6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $448be576ffb80ea6$var$ConfigureFieldsModal = (0, $kxZPA.lazy)(()=>(parcelRequire("03KH0")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/configure-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$448be576ffb80ea6$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira.issue-create.configure-fields",
        packageName: "jiraIssueCreateConfigureFields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "create-configure-fields-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($448be576ffb80ea6$var$ConfigureFieldsModal, props)));

});
parcelRegister("03KH0", function(module, exports) {

let $00b48023c3df9fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00b48023c3df9fdc$var$load("5Ck3F").then(()=>parcelRequire('LAKPi'));

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5knXz", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $a61178001d7e3bbc$export$fa2c25e1ed13a1a8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $dAfqg = parcelRequire("dAfqg");


var $RnWyv = parcelRequire("RnWyv");

var $l2AwX = parcelRequire("l2AwX");
const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $l2AwX.useEnforceStorageModal)();
    const issueViewMode = (0, $2gCtH.useViewMode)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $RnWyv.localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("RnWyv", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $5fd7f3930a81124f$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('enforce-storage-limits');

});


parcelRegister("eyBYT", function(module, exports) {

$parcel$export(module.exports, "UiModificationsContainer", () => $36c9c0c91723b06d$export$1834060b93715de7);

var $5uXOq = parcelRequire("5uXOq");

var $4YkZL = parcelRequire("4YkZL");


var $egcPe = parcelRequire("egcPe");
const $36c9c0c91723b06d$export$1834060b93715de7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YkZL.BaseUiModificationsContainer), {
        scope: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
        viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
        viewConfiguration: (0, $egcPe.GICViewConfiguration)
    }, children);

});
parcelRegister("4YkZL", function(module, exports) {

$parcel$export(module.exports, "BaseUiModificationsContainer", () => $4c4fcc33bcca6eed$export$8b7a045f60eb9797);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $2NMNM = parcelRequire("2NMNM");

var $jrwZp = parcelRequire("jrwZp");

var $fyovx = parcelRequire("fyovx");

var $3OTqu = parcelRequire("3OTqu");
const $4c4fcc33bcca6eed$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
    (0, $gKZoD.di)((0, $fyovx.LoadedUiModificationsContainer), (0, $jrwZp.UiModificationContextContainer), (0, $2NMNM.useAnalyticsEvents));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $3OTqu.useLoadViewConfiguration)(viewType, viewConfiguration);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fyovx.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jrwZp.UiModificationContextContainer), {
            scope: scope,
            children: children
        })
    });
};

});
parcelRegister("fyovx", function(module, exports) {

$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $a2e43bf21add6fd4$export$b087a12fbb84e8ac);

var $gg7kZ = parcelRequire("gg7kZ");

var $1YewZ = parcelRequire("1YewZ");
const $a2e43bf21add6fd4$export$b087a12fbb84e8ac = (0, $gg7kZ.createContainer)((0, $1YewZ.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





const $380826ec5efdda82$export$e615b7e9b8fb4715 = 'GIC';

parcelRegister("egcPe", function(module, exports) {

$parcel$export(module.exports, "GICViewConfiguration", () => $9756b3802dbf6f61$export$99b59685fcab4ee);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");


var $hULKg = parcelRequire("hULKg");

var $5fc53 = parcelRequire("5fc53");

var $huY3x = parcelRequire("huY3x");

var $7AkCN = parcelRequire("7AkCN");

var $9fmMA = parcelRequire("9fmMA");

var $bwumX = parcelRequire("bwumX");

var $kUieP = parcelRequire("kUieP");

var $iPOW1 = parcelRequire("iPOW1");

var $ddViG = parcelRequire("ddViG");

var $a9FQD = parcelRequire("a9FQD");

var $1paNN = parcelRequire("1paNN");

var $fasDJ = parcelRequire("fasDJ");

var $4a9C5 = parcelRequire("4a9C5");

var $cn6WY = parcelRequire("cn6WY");

var $4Vy4a = parcelRequire("4Vy4a");

var $2V7xq = parcelRequire("2V7xq");

var $5CqLP = parcelRequire("5CqLP");

var $8HEBV = parcelRequire("8HEBV");

var $5a2jR = parcelRequire("5a2jR");

var $hHShv = parcelRequire("hHShv");

var $49Cpz = parcelRequire("49Cpz");

var $3fHwD = parcelRequire("3fHwD");

var $2UMtO = parcelRequire("2UMtO");

var $eCYWe = parcelRequire("eCYWe");

var $8eXWB = parcelRequire("8eXWB");

var $7Q9ye = parcelRequire("7Q9ye");

var $ekLmV = parcelRequire("ekLmV");

var $2xJRj = parcelRequire("2xJRj");

var $esYap = parcelRequire("esYap");

var $3xNCX = parcelRequire("3xNCX");

var $kNR0c = parcelRequire("kNR0c");

var $echHY = parcelRequire("echHY");

var $9bTKH = parcelRequire("9bTKH");

var $7ZP8L = parcelRequire("7ZP8L");

var $fPEV6 = parcelRequire("fPEV6");

var $2AQeg = parcelRequire("2AQeg");

var $lK4Eh = parcelRequire("lK4Eh");

var $ibFp9 = parcelRequire("ibFp9");

var $9icMi = parcelRequire("9icMi");
class $9756b3802dbf6f61$export$99b59685fcab4ee {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $8HEBV.getCommonFieldValidators)();
        return {
            [(0, $5fc53.SUMMARY_TYPE)]: {
                // It contains also supported field properties.
                // Validator MUST be added here to make given property supported.
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hHShv.validateSingleLineTextValue)
                },
                // Transformers are optional per property, if missing the value will be used as is
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $2AQeg.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $5fc53.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $4a9C5.validatePrioritySetValue),
                    optionsVisibility: (0, $5a2jR.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $echHY.prioritySetValueTransformer),
                    optionsVisibility: (0, $echHY.transformPrioritySetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $echHY.transformPriorityGetValue),
                    optionsVisibility: (0, $echHY.transformPriorityGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $5fc53.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $7AkCN.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $7AkCN.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $7AkCN.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$3a106242c8f57ac2)
            },
            [(0, $5fc53.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $2V7xq.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $lK4Eh.userPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $lK4Eh.userPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$3a106242c8f57ac2)
            },
            [(0, $5fc53.LABELS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $a9FQD.labelsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $a9FQD.labelsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $a9FQD.labelsGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $5fc53.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $eCYWe.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $eCYWe.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $eCYWe.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $5fc53.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $49Cpz.selectSetValueValidator),
                    optionsVisibility: (0, $5a2jR.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $fPEV6.selectSetValueTransformer),
                    optionsVisibility: (0, $fPEV6.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $fPEV6.selectGetValueTransformer),
                    optionsVisibility: (0, $fPEV6.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $5fc53.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $eCYWe.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $eCYWe.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $eCYWe.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $ekLmV.validateMultiSelectSetValue),
                    optionsVisibility: (0, $5a2jR.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $ekLmV.multiSelectSetValueTransformer),
                    optionsVisibility: (0, $ekLmV.transformMultiSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $ekLmV.multiSelectGetValueTransformer),
                    optionsVisibility: (0, $ekLmV.transformMultiSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $5fc53.PEOPLE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kNR0c.peopleSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kNR0c.peopleSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kNR0c.peopleGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$3a106242c8f57ac2)
            },
            [(0, $5fc53.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $2xJRj.multiUserPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $2xJRj.multiUserPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $2xJRj.multiUserPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$3a106242c8f57ac2)
            },
            [(0, $5fc53.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hHShv.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $2AQeg.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $7Q9ye.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $5a2jR.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $7Q9ye.multiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $7Q9ye.transformMultiCheckboxSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $7Q9ye.multiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $7Q9ye.transformMultiCheckboxGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $5fc53.COMPONENTS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $2UMtO.validateComponentsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $2UMtO.componentsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $2UMtO.componentsGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                requiredScopes: (0, $bwumX.componentsRequiredScopes)
            },
            [(0, $5fc53.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $4Vy4a.reporterSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $7ZP8L.reporterSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $7ZP8L.reporterGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$3a106242c8f57ac2)
            },
            [(0, $5fc53.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $ibFp9.fixVersionsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $ibFp9.transformVersionsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $ibFp9.transformVersionsGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                requiredScopes: (0, $ibFp9.versionsRequiredScopes)
            },
            [(0, $5fc53.ISSUE_TYPE)]: {
                publicShapeValidators: {
                    value: (0, $ddViG.issueTypeSetValueValidator),
                    optionsVisibility: (0, $5a2jR.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $8eXWB.issueTypeSetValueTransformer),
                    optionsVisibility: (0, $8eXWB.transformIssueTypeSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $8eXWB.issueTypeGetValueTransformer),
                    optionsVisibility: (0, $8eXWB.transformIssueTypeGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $5fc53.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hHShv.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $2AQeg.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $5fc53.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kUieP.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kUieP.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kUieP.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $5fc53.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $iPOW1.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $iPOW1.transformDateTimePickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $iPOW1.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change'
            },
            [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $cn6WY.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $5a2jR.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $9bTKH.radioButtonsSetValueTransformer),
                    optionsVisibility: (0, $9bTKH.transformRadioButtonsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $9bTKH.radioButtonsGetValueTransformer),
                    optionsVisibility: (0, $9bTKH.transformRadioButtonsGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $5fc53.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1paNN.validateNumberValue)
                },
                publicToInternalTransformers: {
                    value: (0, $esYap.transformNumberToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $esYap.transformNumberToPublicValue)
                },
                emitChangeOn: 'blur',
                requiredScopes: (0, $esYap.numberIssueGicScopes)
            },
            [(0, $5fc53.PARENT_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $fasDJ.validateParentWithAriSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $3xNCX.parentSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $3xNCX.parentGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9fmMA.validateCascadingSelectSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $3fHwD.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $3fHwD.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901)
            },
            [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $5CqLP.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $ibFp9.transformVersionsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $ibFp9.transformVersionsGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $80e7f3d73b333b84$export$a1cacdcf198da901),
                requiredScopes: (0, $ibFp9.versionsRequiredScopes)
            },
            [(0, $5fc53.DUE_DATE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kUieP.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kUieP.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kUieP.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $5fc53.BASELINE_START_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kUieP.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kUieP.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kUieP.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $5fc53.BASELINE_END_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kUieP.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kUieP.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kUieP.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $5fc53.SUMMARY_TYPE),
            (0, $5fc53.PRIORITY_TYPE),
            (0, $5fc53.ASSIGNEE_TYPE),
            (0, $5fc53.LABELS_TYPE),
            (0, $5fc53.DESCRIPTION_TYPE),
            (0, $5fc53.SELECT_CF_TYPE),
            (0, $5fc53.TEXT_AREA_CF_TYPE),
            (0, $5fc53.MULTI_SELECT_CF_TYPE),
            (0, $5fc53.USER_CF_TYPE),
            (0, $5fc53.TEXT_CF_TYPE),
            (0, $5fc53.MULTI_USER_CF_TYPE),
            (0, $5fc53.PEOPLE_CF_TYPE),
            (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
            (0, $5fc53.REPORTER_TYPE),
            (0, $5fc53.COMPONENTS_TYPE),
            (0, $5fc53.FIX_VERSIONS_TYPE),
            (0, $5fc53.ISSUE_TYPE),
            (0, $5fc53.DATE_CF_TYPE),
            (0, $5fc53.DATETIME_CF_TYPE),
            (0, $5fc53.URL_CF_TYPE),
            (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
            (0, $5fc53.NUMBER_CF_TYPE),
            (0, $5fc53.PARENT_TYPE),
            (0, $5fc53.AFFECTS_VERSIONS_TYPE),
            (0, $5fc53.DUE_DATE_TYPE),
            (0, $5fc53.BASELINE_START_CF_TYPE),
            (0, $5fc53.BASELINE_END_CF_TYPE),
            (0, $5fc53.CASCADING_SELECT_CF_TYPE)
        ];
        return supportedFieldTypes;
    }
    isExecutionContextSupported({ context: context }) {
        if (!context.project) return false;
        return this.supportedProjectTypes.includes(context.project.type);
    }
    getConsentMessage() {
        return (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9icMi.default).obligatoryUimGicConsentMessageIssueTermRefresh : (0, $9icMi.default).obligatoryUimGicConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        return new Set([
            (0, $hULKg.GENERIC_FORGE_USE_PRODUCT_MODALS),
            (0, $hULKg.GENERIC_GLOBAL_CREATE_BUTTON),
            (0, $hULKg.GENERIC_KEYBOARD_SHORTCUT),
            (0, $hULKg.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
            (0, $hULKg.JSW_CREATE_EPIC_ISSUE),
            (0, $hULKg.JSW_ISSUE_VIEW_CREATE_SUBTASK)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $huY3x.stopTTI,
            cancelTTI: $huY3x.cancelTTI,
            markIframeLoad: $huY3x.markIframeLoad,
            markFieldsRegistered: $huY3x.markFieldsRegistered,
            markOnInitResolved: $huY3x.markOnInitResolved
        };
        this.supportedProjectTypes = [
            (0, $2vSU6.SOFTWARE_PROJECT),
            (0, $2vSU6.CORE_PROJECT)
        ];
    }
}

});
parcelRegister("7AkCN", function(module, exports) {

$parcel$export(module.exports, "assigneeSetValueValidator", () => $868ea0af53443827$export$a1b37d5eeb401ad6);
$parcel$export(module.exports, "assigneeSetValueTransformer", () => $868ea0af53443827$export$d1aadee23fc64b9d);
$parcel$export(module.exports, "assigneeGetValueTransformer", () => $868ea0af53443827$export$166948efaac892d3);
$parcel$export(module.exports, "assigneeScopes", () => $868ea0af53443827$export$3c9d4db6ddd2a8e6);

var $1SFUi = parcelRequire("1SFUi");

var $7NDId = parcelRequire("7NDId");

var $fhSLy = parcelRequire("fhSLy");

var $jkotl = parcelRequire("jkotl");

var $frwJc = parcelRequire("frwJc");
const $868ea0af53443827$export$a1b37d5eeb401ad6 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value);
const $868ea0af53443827$export$d1aadee23fc64b9d = (value, lookupValues, context)=>{
    if (value === null) return null;
    const { intl: intl } = context;
    if (value === (0, $80e7f3d73b333b84$export$f5d5f6bb902f1027) && intl) {
        // @ts-expect-error deprecated intl shape in getAutomaticUserOption
        const automaticUserOption = (0, $fhSLy.getAutomaticUserOption)(intl);
        return {
            accountId: automaticUserOption.accountId ?? (0, $80e7f3d73b333b84$export$f5d5f6bb902f1027),
            displayName: automaticUserOption.displayName,
            avatarUrls: {
                '48x48': ''
            }
        };
    }
    const foundValue = (0, $frwJc.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $7NDId.FieldValueLookupError)();
    const { accountId: accountId, name: displayName, picture: picture } = foundValue;
    return {
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': picture
        }
    };
};
const $868ea0af53443827$export$166948efaac892d3 = (value)=>{
    if (value === null) return null;
    const { accountId: accountId } = value;
    return {
        accountId: accountId
    };
};
const $868ea0af53443827$export$3c9d4db6ddd2a8e6 = {
    ...(0, $1SFUi.baseScopesRequiredPerField),
    granular: [
        ...(0, $1SFUi.baseScopesRequiredPerField).granular,
        'read:user:jira'
    ],
    coarse: [
        ...(0, $1SFUi.baseScopesRequiredPerField).coarse,
        'read:jira-user'
    ]
};

});
parcelRegister("1SFUi", function(module, exports) {

$parcel$export(module.exports, "baseScopesRequiredPerField", () => $4e497d251fe65eb7$export$ec1ba7c44413935f);
const $4e497d251fe65eb7$export$ec1ba7c44413935f = {
    granular: [
        'read:field:jira',
        'write:field:jira',
        'read:field-configuration:jira',
        'write:field-configuration:jira'
    ],
    coarse: [
        'read:jira-work',
        'write:jira-work',
        'manage:jira-configuration'
    ]
};

});

parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $5i5DK = parcelRequire("5i5DK");

var $6s1PB = parcelRequire("6s1PB");

var $7lGt2 = parcelRequire("7lGt2");

var $12ZsE = parcelRequire("12ZsE");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>{
    const avatarUrls = (0, $6s1PB.expVal)('thor_unassigned_icon_update_milestone1_experiment', 'isUnassignedIconUpdated', false) ? {
        '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($5i5DK)))
    } : {};
    return {
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: avatarUrls
    };
};
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($12ZsE)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("5i5DK", function(module, exports) {
module.exports = new URL("unassignedAvatar.299fb7bf.svg", import.meta.url).toString();

});

parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("12ZsE", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});

const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';


parcelRegister("jkotl", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyString", () => $ee3536956fa72d81$export$582443c7ead02173);
const $ee3536956fa72d81$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});

parcelRegister("frwJc", function(module, exports) {

$parcel$export(module.exports, "singleValueLookup", () => $4913cef5f57acebe$export$93a99fc9939aad85);
/**
 * Finds a single entity from a provided list of entities
 *
 * @param value - the value search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $4913cef5f57acebe$export$93a99fc9939aad85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.find((option)=>option[lookupKey] === value);

});


parcelRegister("9fmMA", function(module, exports) {

$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $7c7c4bf4d7ff3eac$export$2d586ab6ce4d7126);
$parcel$export(module.exports, "validateCascadingSelectWithAriSetValue", () => $7c7c4bf4d7ff3eac$export$1e029e8cc721ad5e);

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");
const $7c7c4bf4d7ff3eac$export$2d586ab6ce4d7126 = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $jkotl.isNotEmptyString)(value.parentId) && ((0, $jkotl.isNotEmptyString)(value.childId) || value.childId === null);
const $7c7c4bf4d7ff3eac$export$1e029e8cc721ad5e = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $jkotl.isNotEmptyString)(value.parentId) && (0, $5t6mi.isAriResourceIdValid)(value.parentId) && (value.childId === null || (0, $jkotl.isNotEmptyString)(value.childId) && (0, $5t6mi.isAriResourceIdValid)(value.childId));

});
parcelRegister("5t6mi", function(module, exports) {

$parcel$export(module.exports, "isAriResourceIdValid", () => $c10800049bddf6a7$export$4d1e9901084f3bf6);

var $e9E9F = parcelRequire("e9E9F");
const $c10800049bddf6a7$var$CLOUD_ID_MOCK = 'cloud-id';
const $c10800049bddf6a7$var$ACTIVATION_ID_MOCK = 'activation-id';
const $c10800049bddf6a7$var$FIELD_ID_MOCK = 'field-1';
const $c10800049bddf6a7$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $e9E9F.JiraIssueFieldOptionAri).create({
            siteId: $c10800049bddf6a7$var$CLOUD_ID_MOCK,
            activationId: $c10800049bddf6a7$var$ACTIVATION_ID_MOCK,
            fieldId: $c10800049bddf6a7$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("e9E9F", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $a4e10de13cd7bf40$export$e3bc1ec22f941fbe);

var $aeXsV = parcelRequire("aeXsV");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issue-field-option/manifest.ts
var $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aeXsV.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $aeXsV.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $a4e10de13cd7bf40$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("aeXsV", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $774956c9da7baac8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $774956c9da7baac8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $774956c9da7baac8$export$eb4f4cf0880fe5a8 = "jira", $774956c9da7baac8$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("bwumX", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $f1e11025fd7745a7$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsRequiredScopes", () => $f1e11025fd7745a7$export$a818a96eabdabcb);

var $1SFUi = parcelRequire("1SFUi");

var $jkotl = parcelRequire("jkotl");
const $f1e11025fd7745a7$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.length <= (0, $80e7f3d73b333b84$export$106087dcfd4fb129) && value.every((0, $jkotl.isNotEmptyString));
const $f1e11025fd7745a7$export$a818a96eabdabcb = {
    ...(0, $1SFUi.baseScopesRequiredPerField),
    granular: [
        'read:project.component:jira',
        ...(0, $1SFUi.baseScopesRequiredPerField).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("kUieP", function(module, exports) {

$parcel$export(module.exports, "datePickerSetValueValidator", () => $376d7f259486e553$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $376d7f259486e553$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $376d7f259486e553$export$e844c6ac3a5cbef7);

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $2753q = parcelRequire("2753q");
var $eZDAP = parcelRequire("eZDAP");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $376d7f259486e553$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $2753q.default)(date, dateFormat, new Date());
    return (0, $jovBr.default)(parsedDate);
};
const $376d7f259486e553$export$c003579a97a2459e = (value)=>value === null || $376d7f259486e553$var$dateHasExpectedFormat(value);
const $376d7f259486e553$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $376d7f259486e553$export$e844c6ac3a5cbef7 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $eZDAP.default)(value);
    if ((0, $jovBr.default)(parsedDate)) return (0, $k7m40.default)(parsedDate, 'yyyy-MM-dd');
    return null;
};

});

parcelRegister("iPOW1", function(module, exports) {

$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $59f7b9f567d38b16$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $59f7b9f567d38b16$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $59f7b9f567d38b16$export$4cb6c79fda4a9c74);

var $k7m40 = parcelRequire("k7m40");
var $6NYhy = parcelRequire("6NYhy");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $59f7b9f567d38b16$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $59f7b9f567d38b16$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $6NYhy.default)(fullDate, $59f7b9f567d38b16$var$formatString) && (0, $jovBr.default)((0, $eZDAP.default)(fullDate));
};
const $59f7b9f567d38b16$export$7930ddff407505cc = (value)=>value === null || $59f7b9f567d38b16$export$a886f5166a4d311e(value);
const $59f7b9f567d38b16$export$e81204f19744e19f = (publicValue)=>publicValue === null ? '' : publicValue;
const $59f7b9f567d38b16$export$4cb6c79fda4a9c74 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $eZDAP.default)(value);
    if ((0, $jovBr.default)(parsedDate)) return (0, $k7m40.default)(parsedDate, $59f7b9f567d38b16$var$formatString);
    return null;
};

});

parcelRegister("ddViG", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueValidator", () => $463469cab0dbc32c$export$19e9b52e41260d79);
$parcel$export(module.exports, "validateIssueTypeWithAriSetValue", () => $463469cab0dbc32c$export$91780d7591f86a1d);

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");
const $463469cab0dbc32c$export$19e9b52e41260d79 = (value)=>(0, $jkotl.isNotEmptyString)(value);
const $463469cab0dbc32c$export$91780d7591f86a1d = (value)=>(0, $jkotl.isNotEmptyString)(value) && (0, $5t6mi.isAriResourceIdValid)(value);

});

parcelRegister("a9FQD", function(module, exports) {

$parcel$export(module.exports, "labelsRequiredScopes", () => $ab55693818f251d7$export$5397fc4189b6d690);
$parcel$export(module.exports, "labelsSetValueValidator", () => $ab55693818f251d7$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $ab55693818f251d7$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $ab55693818f251d7$export$b0b12fd0b1cd9d3a);

var $1SFUi = parcelRequire("1SFUi");
const $ab55693818f251d7$export$5397fc4189b6d690 = {
    granular: [
        ...(0, $1SFUi.baseScopesRequiredPerField).granular,
        'read:label:jira'
    ],
    coarse: [
        ...(0, $1SFUi.baseScopesRequiredPerField).coarse
    ]
};
const $ab55693818f251d7$export$e67b5652c846b5f = (value)=>typeof value === 'object' && value !== null && Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $ab55693818f251d7$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            value: label,
            label: label
        }));
const $ab55693818f251d7$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);

});

parcelRegister("1paNN", function(module, exports) {

$parcel$export(module.exports, "validateNumberValue", () => $a2073d4f18454e24$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "numberScopes", () => $a2073d4f18454e24$export$2ddc76933cd1391c);

var $1SFUi = parcelRequire("1SFUi");
const $a2073d4f18454e24$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $a2073d4f18454e24$export$2ddc76933cd1391c = (0, $1SFUi.baseScopesRequiredPerField);

});

parcelRegister("fasDJ", function(module, exports) {

$parcel$export(module.exports, "parentSetValueValidator", () => $17f5bb12fa4559f0$export$ada98fdbc0faa607);
$parcel$export(module.exports, "validateParentWithAriSetValue", () => $17f5bb12fa4559f0$export$e3aab6ae1b4e9174);
$parcel$export(module.exports, "validateParentSetOptionsVisibilityAri", () => $17f5bb12fa4559f0$export$8cdcca29a2b25e60);
$parcel$export(module.exports, "parentScopes", () => $17f5bb12fa4559f0$export$bdc8bd505789b6e8);

var $8S2Xh = parcelRequire("8S2Xh");

var $1SFUi = parcelRequire("1SFUi");

var $jkotl = parcelRequire("jkotl");

var $5a2jR = parcelRequire("5a2jR");
const $17f5bb12fa4559f0$var$CLOUD_ID_MOCK = 'cloud-id';
const $17f5bb12fa4559f0$export$9603e65f1e714629 = (optionId)=>{
    try {
        (0, $8S2Xh.JiraIssueAri).create({
            siteId: $17f5bb12fa4559f0$var$CLOUD_ID_MOCK,
            issueId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};
const $17f5bb12fa4559f0$export$ada98fdbc0faa607 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value);
const $17f5bb12fa4559f0$export$e3aab6ae1b4e9174 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value) && $17f5bb12fa4559f0$export$9603e65f1e714629(value);
const $17f5bb12fa4559f0$export$8cdcca29a2b25e60 = (optionsVisibility)=>(0, $5a2jR.validateSetOptionsVisibility)(optionsVisibility) && optionsVisibility.options.every((optionId)=>$17f5bb12fa4559f0$export$9603e65f1e714629(optionId));
const $17f5bb12fa4559f0$export$bdc8bd505789b6e8 = (0, $1SFUi.baseScopesRequiredPerField);

});
parcelRegister("8S2Xh", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $6755a8b1c7a21b87$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issue/manifest.ts
var $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $6755a8b1c7a21b87$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("5a2jR", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $990b12d5a8aaf054$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSetOptionsVisibilityForFrontendFilteringWithARIs", () => $990b12d5a8aaf054$export$19d00b5cfa21ccb4);
$parcel$export(module.exports, "transformOptionIdsToARI", () => $990b12d5a8aaf054$export$aaa1909c16b4bd2c);
$parcel$export(module.exports, "transformSetOptionsVisibilityAri", () => $990b12d5a8aaf054$export$a68e1c2d1192287c);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $990b12d5a8aaf054$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $990b12d5a8aaf054$export$cb8a43658ea03ec7);
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $990b12d5a8aaf054$export$973aead813665e25);
$parcel$export(module.exports, "validateSetOptionsVisibilityAri", () => $990b12d5a8aaf054$export$979d55c1d0a17c97);

var $e9E9F = parcelRequire("e9E9F");

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");

var $5s9fM = parcelRequire("5s9fM");
const $990b12d5a8aaf054$export$81990085f8ab114b = ({ isVisible: isVisible, options: options })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        ids: options
    });
const $990b12d5a8aaf054$export$19d00b5cfa21ccb4 = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        ids: $990b12d5a8aaf054$export$aaa1909c16b4bd2c(options, context)
    });
const $990b12d5a8aaf054$export$aaa1909c16b4bd2c = (optionIds, { tenantContext: tenantContext, fieldContext: fieldContext })=>optionIds.reduce((acc, optionId)=>{
        try {
            const optionAri = (0, $e9E9F.JiraIssueFieldOptionAri).create({
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId,
                fieldId: fieldContext.fieldId,
                optionId: optionId
            }).toString();
            acc.push(optionAri);
        } catch (e) {
        // do nothing
        }
        return acc;
    }, []);
const $990b12d5a8aaf054$export$a68e1c2d1192287c = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: $990b12d5a8aaf054$export$aaa1909c16b4bd2c(options, context)
    });
const $990b12d5a8aaf054$export$7c7ca81813eb0f65 = ({ isVisible: isVisible, options: options })=>({
        isVisible: isVisible,
        options: options
    });
const $990b12d5a8aaf054$export$cb8a43658ea03ec7 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
optionsVisibility)=>(0, $5s9fM.isObject)(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $jkotl.isNotEmptyString));
const $990b12d5a8aaf054$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $990b12d5a8aaf054$export$973aead813665e25 = (optionsVisibility)=>$990b12d5a8aaf054$export$cb8a43658ea03ec7(optionsVisibility) && $990b12d5a8aaf054$export$914c7f5212c4c649(optionsVisibility);
const $990b12d5a8aaf054$export$979d55c1d0a17c97 = (optionsVisibility)=>$990b12d5a8aaf054$export$973aead813665e25(optionsVisibility) && optionsVisibility.options.every((optionId)=>(0, $5t6mi.isAriResourceIdValid)(optionId));

});
parcelRegister("5s9fM", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $dff7f664be7fa904$export$a6cdc56e425d0d0a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dff7f664be7fa904$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;

});



parcelRegister("4a9C5", function(module, exports) {

$parcel$export(module.exports, "validatePrioritySetValue", () => $8cdcc768cc3441e4$export$feb916d6d9ca4953);
$parcel$export(module.exports, "validatePriorityWithAriSetValue", () => $8cdcc768cc3441e4$export$d41ad24763f49041);
$parcel$export(module.exports, "priorityScopes", () => $8cdcc768cc3441e4$export$de5c165bee5efef2);

var $1SFUi = parcelRequire("1SFUi");

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");
const $8cdcc768cc3441e4$export$feb916d6d9ca4953 = (value)=>(0, $jkotl.isNotEmptyString)(value);
const $8cdcc768cc3441e4$export$d41ad24763f49041 = (value)=>(0, $jkotl.isNotEmptyString)(value) && (0, $5t6mi.isAriResourceIdValid)(value);
const $8cdcc768cc3441e4$export$de5c165bee5efef2 = {
    ...(0, $1SFUi.baseScopesRequiredPerField),
    granular: [
        ...(0, $1SFUi.baseScopesRequiredPerField).granular,
        'read:priority:jira'
    ]
};

});

parcelRegister("cn6WY", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueValidator", () => $9075d0d4a1f38b3b$export$fd2e39ca7399c512);
$parcel$export(module.exports, "validateRadioButtonsWithAriSetValue", () => $9075d0d4a1f38b3b$export$5fe5484755d2d441);
$parcel$export(module.exports, "radioButtonsScopes", () => $9075d0d4a1f38b3b$export$baef9137cbf80a51);

var $1SFUi = parcelRequire("1SFUi");

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");
const $9075d0d4a1f38b3b$export$fd2e39ca7399c512 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value);
const $9075d0d4a1f38b3b$export$5fe5484755d2d441 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value) && (0, $5t6mi.isAriResourceIdValid)(value);
const $9075d0d4a1f38b3b$export$baef9137cbf80a51 = (0, $1SFUi.baseScopesRequiredPerField);

});

parcelRegister("4Vy4a", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueValidator", () => $c947d730922d8264$export$b8b018eb25bdb4d8);

var $gzOyY = parcelRequire("gzOyY");

var $jkotl = parcelRequire("jkotl");
const $c947d730922d8264$export$b8b018eb25bdb4d8 = (value)=>// We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $jkotl.isNotEmptyString)(value) && (0, $gzOyY.isNotAutomaticId)(value);

});
parcelRegister("gzOyY", function(module, exports) {

$parcel$export(module.exports, "isNotAutomaticId", () => $286ec0585e29371b$export$ab4c3a3c49d7add);

const $286ec0585e29371b$export$ab4c3a3c49d7add = (value)=>value !== (0, $80e7f3d73b333b84$export$f5d5f6bb902f1027);

});


parcelRegister("2V7xq", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueValidator", () => $7572c9e53dc6713b$export$e01dbe42b757ec);

var $gzOyY = parcelRequire("gzOyY");

var $jkotl = parcelRequire("jkotl");
const $7572c9e53dc6713b$export$e01dbe42b757ec = (value)=>// We should omit automatic id special value, so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $jkotl.isNotEmptyString)(value) && (0, $gzOyY.isNotAutomaticId)(value);

});

parcelRegister("5CqLP", function(module, exports) {

$parcel$export(module.exports, "validateVersionValue", () => $041fc6519dfbe928$export$f3e581e8b1e2479a);
$parcel$export(module.exports, "validateVersionWithAriSetValue", () => $041fc6519dfbe928$export$7b83966d45a2bceb);
$parcel$export(module.exports, "versionsRequiredScopes", () => $041fc6519dfbe928$export$60db61c485973ad9);

var $1SFUi = parcelRequire("1SFUi");

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");
const $041fc6519dfbe928$export$f3e581e8b1e2479a = (value)=>Array.isArray(value) && value.every((0, $jkotl.isNotEmptyString)) && value.length <= (0, $80e7f3d73b333b84$export$106087dcfd4fb129);
const $041fc6519dfbe928$export$7b83966d45a2bceb = (value)=>Array.isArray(value) && value.every((val)=>(0, $jkotl.isNotEmptyString)(val) && (0, $5t6mi.isAriResourceIdValid)(val)) && value.length <= (0, $80e7f3d73b333b84$export$106087dcfd4fb129);
const $041fc6519dfbe928$export$60db61c485973ad9 = {
    granular: [
        ...(0, $1SFUi.baseScopesRequiredPerField).granular,
        'read:project-version:jira'
    ],
    coarse: [
        ...(0, $1SFUi.baseScopesRequiredPerField).coarse
    ]
};

});

parcelRegister("8HEBV", function(module, exports) {

$parcel$export(module.exports, "getCommonFieldValidators", () => $17cf4b6df9a75fa7$export$68248012b0fecf7d);

var $l1C1k = parcelRequire("l1C1k");

var $lcm3J = parcelRequire("lcm3J");

var $3ivBz = parcelRequire("3ivBz");

var $cmmj3 = parcelRequire("cmmj3");

var $aNf5C = parcelRequire("aNf5C");
const $17cf4b6df9a75fa7$var$validateDescription = async (value)=>{
    if (typeof value !== 'string') return false;
    if (value === '') return true;
    // turn into ADF
    try {
        const adfValue = await (0, $3ivBz.convertWikiToAdfAsync)(value);
        if (!adfValue) return false;
        // find image nodes that contain external URLs.
        (0, $l1C1k.traverse)(adfValue, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs.url !== undefined) // ADF cannot contain external urls due to the possibility of data egress.
                throw new (0, $aNf5C.ExternalImageValidationError)('Cannot contain external images');
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // ExternalImageValidationError will be thrown if there is an external image
        if (!(err instanceof (0, $aNf5C.ExternalImageValidationError))) // TODO: use valid value of issueType instead of undefined in fireIAErrorAnalytics call. There is a task for it - https://ecosystem-platform.atlassian.net/browse/UIM-1651;
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'descriptionWikiValidationException',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
            viewType: undefined,
            attributes: {
                errorCause: err?.cause,
                message: err.message
            }
        });
        return false;
    }
    return true;
};
const $17cf4b6df9a75fa7$export$68248012b0fecf7d = ()=>({
        ...(0, $lcm3J.getCommonFieldValidators)(),
        description: $17cf4b6df9a75fa7$var$validateDescription
    });

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("lcm3J", function(module, exports) {

$parcel$export(module.exports, "getCommonFieldValidators", () => $186853d277761991$export$68248012b0fecf7d);
const $186853d277761991$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $186853d277761991$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $186853d277761991$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    return true;
};

});

parcelRegister("3ivBz", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdfAsync", () => $7769195ee47a7f4d$export$8e1b3b0130ee3556);



const $7769195ee47a7f4d$export$8e1b3b0130ee3556 = async (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return Promise.resolve(null);
    const wikiPromise = await Promise.resolve((parcelRequire("dN5CS")));
    const schemaPromise = await Promise.resolve((parcelRequire("kOFhM")));
    const jsonPromise = await Promise.resolve((parcelRequire("hYNZx")));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = wikiTransformer.parse(wiki);
    return adfTransformer.encode(pmNode);
};

});

parcelRegister("aNf5C", function(module, exports) {

$parcel$export(module.exports, "ExternalImageValidationError", () => $8debe13c9259f0a1$export$af6b052883945124);
class $8debe13c9259f0a1$export$af6b052883945124 extends Error {
}

});


parcelRegister("hHShv", function(module, exports) {

$parcel$export(module.exports, "validateSingleLineTextValue", () => $f6fe8da49a52b12e$export$88db43fe998a9953);
const $f6fe8da49a52b12e$export$88db43fe998a9953 = (value)=>typeof value === 'string';

});

parcelRegister("49Cpz", function(module, exports) {

$parcel$export(module.exports, "selectSetValueValidator", () => $c4c49c8d5226e2b7$export$c02b1c2a574ca4c7);
$parcel$export(module.exports, "selectWithAriSetValueValidator", () => $c4c49c8d5226e2b7$export$f22935386c756879);

var $5t6mi = parcelRequire("5t6mi");

var $jkotl = parcelRequire("jkotl");
const $c4c49c8d5226e2b7$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value);
const $c4c49c8d5226e2b7$export$f22935386c756879 = (value)=>value === null || (0, $jkotl.isNotEmptyString)(value) && (0, $5t6mi.isAriResourceIdValid)(value);

});

parcelRegister("3fHwD", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $1e3e134f6d96c80f$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $1e3e134f6d96c80f$export$47e9770ed0d1c344);

var $7NDId = parcelRequire("7NDId");

var $jkotl = parcelRequire("jkotl");

var $frwJc = parcelRequire("frwJc");
const $1e3e134f6d96c80f$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.parentOptionValue.id === parentId);
    if (!foundOption) throw new (0, $7NDId.FieldValueLookupError)();
    const value = {
        parent: foundOption.parentOptionValue,
        child: childId !== null ? (0, $frwJc.singleValueLookup)(childId, foundOption.childOptionValues, 'id') : childId
    };
    return value;
};
const $1e3e134f6d96c80f$export$905a8d55c641a71e = (value, allowedValues)=>{
    if (value === null) return null;
    const cascadingSelectValue = $1e3e134f6d96c80f$var$findCascadingSelectLookupValues(allowedValues, value.parentId, value.childId);
    if (!(0, $jkotl.isNotEmptyString)(cascadingSelectValue.parent.value)) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        label: cascadingSelectValue.parent.value,
        value: cascadingSelectValue.parent.id,
        child: cascadingSelectValue.child ? {
            label: cascadingSelectValue.child.value,
            value: cascadingSelectValue.child.id
        } : null
    };
};
const $1e3e134f6d96c80f$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue) return null;
    const { label: label, value: value, child: child } = cascadingValue;
    return child?.label && child?.value ? {
        parent: {
            id: value,
            value: label
        },
        child: {
            id: child.value,
            value: child.label
        }
    } : {
        parent: {
            id: value,
            value: label
        },
        child: null
    };
};

});

parcelRegister("2UMtO", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $09b0dd4b219b64a0$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsGetValueTransformer", () => $09b0dd4b219b64a0$export$b6f14754491cc7aa);
$parcel$export(module.exports, "componentsSetValueTransformer", () => $09b0dd4b219b64a0$export$777b614991f65d18);

var $7NDId = parcelRequire("7NDId");

var $9mqRh = parcelRequire("9mqRh");

var $jkotl = parcelRequire("jkotl");

var $fwvEZ = parcelRequire("fwvEZ");
const $09b0dd4b219b64a0$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.every((0, $jkotl.isNotEmptyString));
const $09b0dd4b219b64a0$export$b6f14754491cc7aa = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: id, label: name })=>({
            id: id,
            name: name
        }));
};
const $09b0dd4b219b64a0$export$777b614991f65d18 = (publicValue, lookupValues)=>{
    if (!publicValue.length) return [];
    const filteredLookupValues = (0, $fwvEZ.multiValueLookup)(publicValue, lookupValues, 'id');
    if (publicValue.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $9mqRh.getValueLookupValuesDiff)(publicValue, lookupValues, 'id');
        throw new (0, $7NDId.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ id: value, name: label })=>({
            value: value,
            label: label
        }));
};

});
parcelRegister("9mqRh", function(module, exports) {

$parcel$export(module.exports, "getValueLookupValuesDiff", () => $74662d637a90413e$export$6ebcd48e99f6b85);
/**
 * Finds the difference between provided ids and the list of available entities, by returning a list of
 * ids that weren't found in that entities list
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities with full information about all valid ids
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $74662d637a90413e$export$6ebcd48e99f6b85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>value.filter((id)=>!lookupValues.some((option)=>option[lookupKey] === id));

});

parcelRegister("fwvEZ", function(module, exports) {

$parcel$export(module.exports, "multiValueLookup", () => $aa2173a319ebb478$export$12a8af52bc9e513e);
/**
 * Finds multiple entities from a provided list of entities
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $aa2173a319ebb478$export$12a8af52bc9e513e = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.filter((option)=>value.includes(option[lookupKey]));

});


parcelRegister("eCYWe", function(module, exports) {

$parcel$export(module.exports, "validateDescriptionAndParagraphSetValue", () => $3b28326669e03dd9$export$55c0a47975b0f67);
$parcel$export(module.exports, "descriptionAndParagraphSetValueTransformer", () => $3b28326669e03dd9$export$8596d284a0b8650f);
$parcel$export(module.exports, "descriptionAndParagraphGetValueTransformer", () => $3b28326669e03dd9$export$736f124bc0a7d673);

var $fr1K2 = parcelRequire("fr1K2");

var $6LBEg = parcelRequire("6LBEg");

var $1K3Xb = parcelRequire("1K3Xb");
const $3b28326669e03dd9$export$95433ac963f4aebe = 'JiraTextAreaField';
const $3b28326669e03dd9$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $3b28326669e03dd9$export$55c0a47975b0f67 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    switch(fieldRenderer){
        case $3b28326669e03dd9$export$31a6c27df1f927b2:
            return (0, $6LBEg.isValidADF)({
                newValue: value,
                currentValue: extra.currentField?.value
            });
        case $3b28326669e03dd9$export$95433ac963f4aebe:
            return Promise.resolve(typeof value === 'string');
        default:
            return Promise.resolve(false);
    }
};
const $3b28326669e03dd9$export$8596d284a0b8650f = (value)=>{
    if (typeof value === 'string') return value;
    return {
        ...value,
        overrideRequired: true
    };
};
const $3b28326669e03dd9$export$736f124bc0a7d673 = (value, fieldRenderer)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === $3b28326669e03dd9$export$31a6c27df1f927b2 ? (0, $1K3Xb.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(value, 'overrideRequired');
};

});
parcelRegister("6LBEg", function(module, exports) {

$parcel$export(module.exports, "isValidADF", () => $f8b9baf18bf9b17b$export$94ea512f7afe62e4);

var $1vRrA = parcelRequire("1vRrA");

var $ajpes = parcelRequire("ajpes");

var $bPWvi = parcelRequire("bPWvi");

var $l1C1k = parcelRequire("l1C1k");

const $f8b9baf18bf9b17b$var$getADFValidator = async ()=>{
    const { validator: validator } = await (parcelRequire("8wmar"));
    return validator;
};
const $f8b9baf18bf9b17b$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $l1C1k.traverse)(adf, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs?.url !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $f8b9baf18bf9b17b$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $f8b9baf18bf9b17b$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($1vRrA)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $bPWvi.doc)(...foundDiffNodes);
    return $f8b9baf18bf9b17b$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $f8b9baf18bf9b17b$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue })=>{
    const validator = await $f8b9baf18bf9b17b$var$getADFValidator();
    const validate = validator();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $f8b9baf18bf9b17b$export$6f13dd7501a16a00(newValue, currentValue);
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("1vRrA", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $11a22487ca4cd1f5$var$differenceWith = $g7i7g(function(array, values) {
    var comparator = $hYfgW(values);
    if ($f3SOL(comparator)) comparator = undefined;
    return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true), undefined, comparator) : [];
});
module.exports = $11a22487ca4cd1f5$var$differenceWith;

});

parcelRegister("bPWvi", function(module, exports) {

$parcel$export(module.exports, "doc", () => $c17b5e301ceeeae8$export$2a111da947c407d2);
const $c17b5e301ceeeae8$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("8wmar", function(module, exports) {

let $634281e437b7f356$var$load = (parcelRequire("28QjX"))(4);
module.exports = $634281e437b7f356$var$load("eRd8e").then(()=>parcelRequire('d9FJW'));

});


parcelRegister("1K3Xb", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $903ba9c436cc186a$export$c10cf32c4acc1d57);

var $bPWvi = parcelRequire("bPWvi");
var $50sdg = parcelRequire("50sdg");

var $kz2lw = parcelRequire("kz2lw");
const $903ba9c436cc186a$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $kz2lw.getEmptyADF)();
    return (0, $bPWvi.doc)((0, $50sdg.paragraph)(text));
};

});
parcelRegister("50sdg", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $b5360ede7330200d$export$9c206ddddb32a9b);

var $3lRhe = parcelRequire("3lRhe");
const $b5360ede7330200d$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $3lRhe.createTextNodes)(content)
    });

});
parcelRegister("3lRhe", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4fbd120aea0a69b1$export$3a269a5941b62f04);

var $gBTcG = parcelRequire("gBTcG");
function $4fbd120aea0a69b1$export$3a269a5941b62f04(nodes) {
    return nodes.map($4fbd120aea0a69b1$export$72b9432ea0656b50);
}
function $4fbd120aea0a69b1$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $gBTcG.text)(str) : str;
}

});
parcelRegister("gBTcG", function(module, exports) {

$parcel$export(module.exports, "text", () => $9654feec8f8dd4ec$export$6f093cfa640b7166);
const $9654feec8f8dd4ec$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});





parcelRegister("8eXWB", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueTransformer", () => $fc5b994f4e030ea3$export$93e4fd33c48f4977);
$parcel$export(module.exports, "issueTypeGetValueTransformer", () => $fc5b994f4e030ea3$export$391657d4e7f81237);
$parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", () => $fc5b994f4e030ea3$export$db493bcecec5fb56);
$parcel$export(module.exports, "transformIssueTypeGetOptionsVisibility", () => $fc5b994f4e030ea3$export$3a886340b0f20858);

var $7NDId = parcelRequire("7NDId");

var $6aU71 = parcelRequire("6aU71");

var $nQYm2 = parcelRequire("nQYm2");

var $frwJc = parcelRequire("frwJc");
const $fc5b994f4e030ea3$export$93e4fd33c48f4977 = (value, lookupValues)=>{
    const lookupValue = (0, $frwJc.singleValueLookup)(value, lookupValues, 'value');
    if (!lookupValue) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        iconUrl: lookupValue.iconUrl,
        label: lookupValue.label,
        value: lookupValue.value
    };
};
const $fc5b994f4e030ea3$export$391657d4e7f81237 = (value)=>{
    /**
	 * Switching between projects with UIM context doesn't reset the IA context in a timely
	 * manner, that's why we still have `adjustmentsAreEnabled` resulting in `true` even
	 * though the context should have been reset and the undecorated component should have rendered first.
	 * As a result, issue type field sends `null` as a value to the value decorator just
	 * before the context reset is being triggered.
	 * `null` won't be sent to jira-bridge because after the context is reset, the actual issue type option is being set.
	 */ if (!value) return null;
    return {
        id: value.value,
        name: value.label
    };
};
const $fc5b994f4e030ea3$export$db493bcecec5fb56 = (optionsVisibility, lookupValues)=>(0, $6aU71.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $fc5b994f4e030ea3$export$3a886340b0f20858 = (optionsVisibility, lookupValues)=>(0, $nQYm2.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');

});
parcelRegister("6aU71", function(module, exports) {

$parcel$export(module.exports, "applyOptionsVisibilityRule", () => $f3275806245f2359$export$642f3f0b0177721e);
const $f3275806245f2359$export$642f3f0b0177721e = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>isVisible ? lookupValues.filter((value)=>options.includes(value[optionKey])) : lookupValues.filter((value)=>!options.includes(value[optionKey]));

});

parcelRegister("nQYm2", function(module, exports) {

$parcel$export(module.exports, "getAvailableOptionsVisibilityRule", () => $754cb1d9a51718dd$export$d614c43ae91f42cd);
const $754cb1d9a51718dd$export$d614c43ae91f42cd = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues.some((value)=>value[optionKey] === option))
    });

});


parcelRegister("7Q9ye", function(module, exports) {

$parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", () => $df05d6290ea41580$export$115a0b8c81087c2c);
$parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", () => $df05d6290ea41580$export$4471ab017a7abd7);
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $df05d6290ea41580$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $df05d6290ea41580$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $df05d6290ea41580$export$6d15ce1cc0bdffe7);

var $7NDId = parcelRequire("7NDId");

var $6aU71 = parcelRequire("6aU71");

var $nQYm2 = parcelRequire("nQYm2");

var $9mqRh = parcelRequire("9mqRh");

var $jkotl = parcelRequire("jkotl");

var $fwvEZ = parcelRequire("fwvEZ");
const $df05d6290ea41580$export$115a0b8c81087c2c = (optionsVisibility, lookupValues)=>(0, $6aU71.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $df05d6290ea41580$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, $nQYm2.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $df05d6290ea41580$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.every((0, $jkotl.isNotEmptyString));
const $df05d6290ea41580$export$9ba1ee83cc9456ba = (publicValue, allowedValues)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $fwvEZ.multiValueLookup)(publicValue, allowedValues, 'id');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $9mqRh.getValueLookupValuesDiff)(publicValue, foundValue, 'id');
        throw new (0, $7NDId.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue.map(({ value: value, id: id })=>({
            label: value,
            value: id
        }));
};
const $df05d6290ea41580$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("ekLmV", function(module, exports) {

$parcel$export(module.exports, "transformMultiSelectSetOptionsVisibility", () => $1e41cc0f0f684ca3$export$464f5c048bb44fae);
$parcel$export(module.exports, "transformMultiSelectGetOptionsVisibility", () => $1e41cc0f0f684ca3$export$16ec76c8ef15bfca);
$parcel$export(module.exports, "validateMultiSelectSetValue", () => $1e41cc0f0f684ca3$export$7002ea8d8a6dd444);
$parcel$export(module.exports, "multiSelectSetValueTransformer", () => $1e41cc0f0f684ca3$export$87ccfa5280a3288f);
$parcel$export(module.exports, "multiSelectGetValueTransformer", () => $1e41cc0f0f684ca3$export$9992ce1903b64c5);

var $7NDId = parcelRequire("7NDId");

var $6aU71 = parcelRequire("6aU71");

var $nQYm2 = parcelRequire("nQYm2");

var $9mqRh = parcelRequire("9mqRh");

var $jkotl = parcelRequire("jkotl");

var $fwvEZ = parcelRequire("fwvEZ");
const $1e41cc0f0f684ca3$export$464f5c048bb44fae = (optionsVisibility, lookupValues)=>(0, $6aU71.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $1e41cc0f0f684ca3$export$16ec76c8ef15bfca = (optionsVisibility, lookupValues)=>(0, $nQYm2.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $1e41cc0f0f684ca3$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.every((0, $jkotl.isNotEmptyString));
const $1e41cc0f0f684ca3$export$87ccfa5280a3288f = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredValues = (0, $fwvEZ.multiValueLookup)(values, lookupValues, 'id');
    if (filteredValues.length !== values.length) {
        const notFoundValues = (0, $9mqRh.getValueLookupValuesDiff)(values, filteredValues, 'id');
        throw new (0, $7NDId.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredValues.map((val)=>({
            label: val.value,
            value: val.id
        }));
};
const $1e41cc0f0f684ca3$export$9992ce1903b64c5 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("2xJRj", function(module, exports) {

$parcel$export(module.exports, "multiUserPickerSetValueValidator", () => $7dc4ebbf7b731405$export$161337c705ff4d65);
$parcel$export(module.exports, "multiUserPickerSetValueTransformer", () => $7dc4ebbf7b731405$export$206658c0c308733e);
$parcel$export(module.exports, "multiUserPickerGetValueTransformer", () => $7dc4ebbf7b731405$export$68e3fe5737fc7137);

var $7NDId = parcelRequire("7NDId");
var $gzOyY = parcelRequire("gzOyY");

var $9mqRh = parcelRequire("9mqRh");

var $jkotl = parcelRequire("jkotl");

var $fwvEZ = parcelRequire("fwvEZ");
const $7dc4ebbf7b731405$export$161337c705ff4d65 = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((option)=>(0, $jkotl.isNotEmptyString)(option) && (0, $gzOyY.isNotAutomaticId)(option));
const $7dc4ebbf7b731405$export$206658c0c308733e = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $fwvEZ.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $9mqRh.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $7NDId.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $7dc4ebbf7b731405$export$68e3fe5737fc7137 = (value)=>{
    if (!value) return [];
    return value.map(({ id: id })=>({
            accountId: id
        }));
};

});

parcelRegister("esYap", function(module, exports) {

$parcel$export(module.exports, "transformNumberToInternalValue", () => $dfcb58a867d3ce96$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $dfcb58a867d3ce96$export$8bdc28b51a4acc44);
$parcel$export(module.exports, "numberIssueGicScopes", () => $dfcb58a867d3ce96$export$b7e1c026b8f78970);

var $1paNN = parcelRequire("1paNN");
const $dfcb58a867d3ce96$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $dfcb58a867d3ce96$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);
const $dfcb58a867d3ce96$export$b7e1c026b8f78970 = {
    ...(0, $1paNN.numberScopes),
    granular: [
        ...(0, $1paNN.numberScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("3xNCX", function(module, exports) {

$parcel$export(module.exports, "parentSetValueTransformer", () => $5801cea69c174b0c$export$a65d296b5d388a59);
$parcel$export(module.exports, "parentGetValueTransformer", () => $5801cea69c174b0c$export$ea591224dc3a0141);

var $7NDId = parcelRequire("7NDId");

var $iHPnC = parcelRequire("iHPnC");


var $0Q1Cs = parcelRequire("0Q1Cs");
async function $5801cea69c174b0c$export$a65d296b5d388a59(value, _lookupValues, { tenantContext: tenantContext }) {
    if (value === null) return null;
    try {
        const parentIssueDetails = await (0, $0Q1Cs.fetchParentIssueDetails)(tenantContext.cloudId, value);
        if (!parentIssueDetails) throw new (0, $7NDId.FieldValueLookupError)(`Parent issue with issueId "${value}" not found`, {
            cause: (0, $0b20d04e9212d44f$export$4a4db137834138dd)
        });
        const issue = parentIssueDetails.jira?.issueById;
        const fields = issue?.fieldsById?.edges;
        if (!issue || !issue.issueId || !issue.key || !fields) throw new (0, $7NDId.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $0b20d04e9212d44f$export$aa7d91b2fd1ba261)
        });
        let issueTypeField = null;
        let summaryField = null;
        let statusField = null;
        for (const field of fields){
            if ((0, $0Q1Cs.isJiraIssueTypeFieldNode)(field?.node)) issueTypeField = field?.node ?? null;
            else if ((0, $0Q1Cs.isJiraSingleLineTextFieldNode)(field?.node)) summaryField = field?.node ?? null;
            else if ((0, $0Q1Cs.isJiraStatusFieldNode)(field?.node)) statusField = field?.node ?? null;
        }
        if (!issueTypeField || !summaryField || !statusField) throw new (0, $7NDId.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $0b20d04e9212d44f$export$aa7d91b2fd1ba261)
        });
        return {
            color: (0, $iHPnC.asColor)(parentIssueDetails.jira.issueById.issueColorField?.color?.colorKey) ?? undefined,
            value: parentIssueDetails.jira.issueById.issueId,
            isDone: (0, $0Q1Cs.checkParentIssueIsDone)(statusField),
            key: parentIssueDetails.jira.issueById.key,
            label: `${parentIssueDetails.jira.issueById.key} ${summaryField.text}`,
            fields: {
                summary: summaryField.text ?? '',
                issuetype: {
                    id: issueTypeField.issueType?.issueTypeId ?? undefined,
                    name: issueTypeField.issueType?.name ?? undefined,
                    iconUrl: issueTypeField.issueType?.avatar?.xsmall ?? ''
                }
            }
        };
    } catch (error) {
        if (error instanceof Error && !('cause' in error)) error.cause = (0, $0b20d04e9212d44f$export$494a54d93664524d);
        if (error instanceof Error) throw new (0, $7NDId.FieldValueLookupError)(error.message, {
            cause: error.cause
        });
        throw error;
    }
}
function $5801cea69c174b0c$export$ea591224dc3a0141(intervalValue) {
    if (!intervalValue) return null;
    return {
        id: intervalValue.value.toString(),
        key: intervalValue.key
    };
}

});
parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);

var $ggSx2 = parcelRequire("ggSx2");

var $7SCny = parcelRequire("7SCny");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $7SCny.Colors).PURPLE;
    if (color in (0, $7SCny.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $7SCny.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $7SCny.ServerColors).SERVER_PURPLE;
    if (color in (0, $7SCny.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $7SCny.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $7SCny.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $7SCny.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $7SCny.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});

parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $7SCny = parcelRequire("7SCny");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $7SCny.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7SCny.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7SCny.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7SCny.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7SCny.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7SCny.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7SCny.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7SCny.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7SCny.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7SCny.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7SCny.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7SCny.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7SCny.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7SCny.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $829f609a65d26a98$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $829f609a65d26a98$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $829f609a65d26a98$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $829f609a65d26a98$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $829f609a65d26a98$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $829f609a65d26a98$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $829f609a65d26a98$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $829f609a65d26a98$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $829f609a65d26a98$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $829f609a65d26a98$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $829f609a65d26a98$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $829f609a65d26a98$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $829f609a65d26a98$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $7SCny.SERVER_PURPLE)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.SERVER_DARK_PURPLE)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.SERVER_BLUE)]: (0, $7SCny.BLUE),
    [(0, $7SCny.SERVER_DARK_BLUE)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.SERVER_GREEN)]: (0, $7SCny.GREEN),
    [(0, $7SCny.SERVER_DARK_GREEN)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.SERVER_TEAL)]: (0, $7SCny.TEAL),
    [(0, $7SCny.SERVER_DARK_TEAL)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.SERVER_YELLOW)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.SERVER_DARK_YELLOW)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.SERVER_ORANGE)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.SERVER_DARK_ORANGE)]: (0, $7SCny.DARK_ORANGE),
    [(0, $7SCny.SERVER_GREY)]: (0, $7SCny.GREY),
    [(0, $7SCny.SERVER_DARK_GREY)]: (0, $7SCny.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $7SCny.AGILE_COLOR_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.AGILE_COLOR_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.AGILE_COLOR_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.AGILE_COLOR_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.AGILE_COLOR_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.AGILE_COLOR_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.AGILE_COLOR_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.AGILE_COLOR_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.AGILE_COLOR_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.AGILE_COLOR_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.AGILE_COLOR_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.AGILE_COLOR_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.AGILE_COLOR_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.AGILE_COLOR_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.AGILE_COLOR_1),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.AGILE_COLOR_2),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.AGILE_COLOR_3),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.AGILE_COLOR_4),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.AGILE_COLOR_5),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.AGILE_COLOR_6),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.AGILE_COLOR_7),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.AGILE_COLOR_8),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.AGILE_COLOR_9),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.AGILE_COLOR_10),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.AGILE_COLOR_11),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.AGILE_COLOR_12),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.AGILE_COLOR_13),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $7SCny.DARK_GREY)]: 'grey',
    [(0, $7SCny.DARK_YELLOW)]: 'yellow',
    [(0, $7SCny.YELLOW)]: 'yellowLight',
    [(0, $7SCny.DARK_BLUE)]: 'blue',
    [(0, $7SCny.DARK_TEAL)]: 'teal',
    [(0, $7SCny.GREEN)]: 'greenLight',
    [(0, $7SCny.PURPLE)]: 'purpleLight',
    [(0, $7SCny.DARK_PURPLE)]: 'purple',
    [(0, $7SCny.ORANGE)]: 'redLight',
    [(0, $7SCny.BLUE)]: 'blueLight',
    [(0, $7SCny.TEAL)]: 'tealLight',
    [(0, $7SCny.GREY)]: 'greyLight',
    [(0, $7SCny.DARK_GREEN)]: 'green',
    [(0, $7SCny.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $7SCny.AGILE_COLOR_1)]: 'grey',
    [(0, $7SCny.AGILE_COLOR_2)]: 'yellow',
    [(0, $7SCny.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $7SCny.AGILE_COLOR_4)]: 'blue',
    [(0, $7SCny.AGILE_COLOR_5)]: 'teal',
    [(0, $7SCny.AGILE_COLOR_6)]: 'greenLight',
    [(0, $7SCny.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $7SCny.AGILE_COLOR_8)]: 'purple',
    [(0, $7SCny.AGILE_COLOR_9)]: 'redLight',
    [(0, $7SCny.AGILE_COLOR_10)]: 'blueLight',
    [(0, $7SCny.AGILE_COLOR_11)]: 'tealLight',
    [(0, $7SCny.AGILE_COLOR_12)]: 'greyLight',
    [(0, $7SCny.AGILE_COLOR_13)]: 'green',
    [(0, $7SCny.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $7SCny.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


const $0b20d04e9212d44f$export$4a4db137834138dd = 'FETCH_PARENT_FIELD_NOT_FOUND';
const $0b20d04e9212d44f$export$aa7d91b2fd1ba261 = 'FETCH_PARENT_FIELD_DETAILS_MISSING_DATA';
const $0b20d04e9212d44f$export$494a54d93664524d = 'FETCH_PARENT_FIELD_UNKNOWN_ERROR';
const $0b20d04e9212d44f$export$db8af5ee2c36776e = 'FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED';

parcelRegister("0Q1Cs", function(module, exports) {

$parcel$export(module.exports, "isJiraIssueTypeFieldNode", () => $5c62f02a12edc836$export$57eda1f5ad7133c3);
$parcel$export(module.exports, "isJiraSingleLineTextFieldNode", () => $5c62f02a12edc836$export$ea2b75e2537cbccf);
$parcel$export(module.exports, "isJiraStatusFieldNode", () => $5c62f02a12edc836$export$1a148ec51054fc5a);
$parcel$export(module.exports, "fetchParentIssueDetails", () => $5c62f02a12edc836$export$ef5c4d73a6136d96);
$parcel$export(module.exports, "checkParentIssueIsDone", () => $5c62f02a12edc836$export$2b30e3fdda29f6);

var $8S2Xh = parcelRequire("8S2Xh");

var $gULOk = parcelRequire("gULOk");

var $92ECu = parcelRequire("92ECu");

var $iBOrg = parcelRequire("iBOrg");

const $5c62f02a12edc836$export$57eda1f5ad7133c3 = (node)=>node?.__typename === 'JiraIssueTypeField';
const $5c62f02a12edc836$export$ea2b75e2537cbccf = (node)=>node?.__typename === 'JiraSingleLineTextField';
const $5c62f02a12edc836$export$1a148ec51054fc5a = (node)=>node?.__typename === 'JiraStatusField';
const $5c62f02a12edc836$export$6ba84cffc20b9772 = (0, $92ECu.gqlTagGira)`
  query ParentIssueDetailsQuery($ari: ID!) {
    jira {
      issueById(id: $ari) {
        issueId
        key
        issueColorField {
          color {
            colorKey
          }
        }
        fieldsById(ids: ["summary", "issuetype", "status"]) {
          edges {
            node {
              __typename
              ... on JiraIssueTypeField {
                fieldId
                issueType {
                  issueTypeId
                  name
                  avatar {
                    xsmall
                  }
                }
              }
              ... on JiraSingleLineTextField {
                fieldId
                text
              }
              ... on JiraStatusField {
                fieldId
                status {
                  statusCategory {
                    statusCategoryId
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
async function $5c62f02a12edc836$export$ef5c4d73a6136d96(siteId, issueId) {
    try {
        const variables = {
            ari: (0, $8S2Xh.JiraIssueAri).create({
                siteId: siteId,
                issueId: issueId
            }).toString()
        };
        const { data: data } = await (0, $iBOrg.getClient)('').query({
            query: $5c62f02a12edc836$export$6ba84cffc20b9772,
            variables: variables,
            operationName: 'ParentIssueDetailsQuery'
        });
        return data;
    } catch (error) {
        throw new Error(`Error fetching data for parent issue with issueId "${issueId}"`, {
            cause: (0, $0b20d04e9212d44f$export$db8af5ee2c36776e)
        });
    }
}
const $5c62f02a12edc836$export$2b30e3fdda29f6 = (node)=>{
    const doneStatusCategoryId = (0, $gULOk).StatusCategoryIds[(0, $gULOk).StatusCategoryTypes.DONE];
    return doneStatusCategoryId && String(doneStatusCategoryId) === node.status?.statusCategory?.statusCategoryId;
};

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("iBOrg", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $3d6ab2890da8f9df$export$6bb76d6eba7e258c);

var $7f4tk = parcelRequire("7f4tk");

var $fqpdr = parcelRequire("fqpdr");
const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $7f4tk.default)((0, $fqpdr.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $3d6ab2890da8f9df$var$client;
const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
    return $3d6ab2890da8f9df$var$client;
};

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};

});
parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});

parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});





parcelRegister("kNR0c", function(module, exports) {

$parcel$export(module.exports, "peopleSetValueValidator", () => $27b85d932c2790f6$export$b553dcd60e54b2da);
$parcel$export(module.exports, "peopleSetValueTransformer", () => $27b85d932c2790f6$export$6262031046230bac);
$parcel$export(module.exports, "peopleGetValueTransformer", () => $27b85d932c2790f6$export$34e69b3ea0fd6308);

var $7NDId = parcelRequire("7NDId");
var $gzOyY = parcelRequire("gzOyY");

var $9mqRh = parcelRequire("9mqRh");

var $jkotl = parcelRequire("jkotl");

var $fwvEZ = parcelRequire("fwvEZ");
const $27b85d932c2790f6$export$b553dcd60e54b2da = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((userId)=>(0, $jkotl.isNotEmptyString)(userId) && (0, $gzOyY.isNotAutomaticId)(userId));
const $27b85d932c2790f6$export$6262031046230bac = (value, lookupValues)=>{
    if (!value.length) return [];
    const filteredLookupValues = (0, $fwvEZ.multiValueLookup)(value, lookupValues, 'accountId');
    if (value.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $9mqRh.getValueLookupValuesDiff)(value, filteredLookupValues, 'accountId');
        throw new (0, $7NDId.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $27b85d932c2790f6$export$34e69b3ea0fd6308 = (value)=>{
    if (!value) return [];
    // can be an object in case of people field with isMulti: false
    const valueArray = Array.isArray(value) ? value : [
        value
    ];
    return valueArray.map(({ id: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("echHY", function(module, exports) {

$parcel$export(module.exports, "transformPrioritySetOptionsVisibility", () => $6a918f4f260599f3$export$722da4484009d687);
$parcel$export(module.exports, "transformPriorityGetOptionsVisibility", () => $6a918f4f260599f3$export$3cc1c0d9b27ad517);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $6a918f4f260599f3$export$c6ef424ead917b72);
$parcel$export(module.exports, "transformPriorityGetValue", () => $6a918f4f260599f3$export$95a791a89befdf91);

var $7NDId = parcelRequire("7NDId");

var $6aU71 = parcelRequire("6aU71");

var $nQYm2 = parcelRequire("nQYm2");

var $frwJc = parcelRequire("frwJc");
const $6a918f4f260599f3$export$722da4484009d687 = (optionsVisibility, lookupValues)=>(0, $6aU71.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $6a918f4f260599f3$export$3cc1c0d9b27ad517 = (optionsVisibility, lookupValues)=>(0, $nQYm2.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $6a918f4f260599f3$export$c6ef424ead917b72 = (value, lookupValues)=>{
    const lookupValue = (0, $frwJc.singleValueLookup)(value, lookupValues, 'id');
    if (!lookupValue) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        label: lookupValue.name,
        value: lookupValue.id,
        iconUrl: lookupValue.iconUrl
    };
};
const $6a918f4f260599f3$export$95a791a89befdf91 = (priority)=>{
    if (!priority) return null;
    const { label: label, value: value, iconUrl: iconUrl } = priority;
    return {
        name: label,
        id: value,
        iconUrl: iconUrl
    };
};

});

parcelRegister("9bTKH", function(module, exports) {

$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", () => $b8c8c73851b6870b$export$825e2dc660c855a0);
$parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", () => $b8c8c73851b6870b$export$149e6a6e5e31219);
$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $b8c8c73851b6870b$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $b8c8c73851b6870b$export$624bfe758f4ad3c6);

var $7NDId = parcelRequire("7NDId");

var $6aU71 = parcelRequire("6aU71");

var $nQYm2 = parcelRequire("nQYm2");

var $frwJc = parcelRequire("frwJc");
const $b8c8c73851b6870b$export$825e2dc660c855a0 = (optionsVisibility, lookupValues)=>(0, $6aU71.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $b8c8c73851b6870b$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, $nQYm2.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $b8c8c73851b6870b$export$d23713245ea192a9 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $frwJc.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $b8c8c73851b6870b$export$624bfe758f4ad3c6 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("7ZP8L", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueTransformer", () => $08c5334065401b8b$export$610accc7edd3f281);
$parcel$export(module.exports, "reporterGetValueTransformer", () => $08c5334065401b8b$export$2c1706dd36f54bb3);

var $7NDId = parcelRequire("7NDId");

var $frwJc = parcelRequire("frwJc");
const $08c5334065401b8b$export$610accc7edd3f281 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $frwJc.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $08c5334065401b8b$export$2c1706dd36f54bb3 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("fPEV6", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $ba46be9263a3175c$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $ba46be9263a3175c$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $ba46be9263a3175c$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $ba46be9263a3175c$export$fd4db924c90bd0e2);

var $7NDId = parcelRequire("7NDId");

var $6aU71 = parcelRequire("6aU71");

var $nQYm2 = parcelRequire("nQYm2");

var $frwJc = parcelRequire("frwJc");
const $ba46be9263a3175c$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, $6aU71.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $ba46be9263a3175c$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, $nQYm2.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $ba46be9263a3175c$export$136c42b919fdec83 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $frwJc.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $ba46be9263a3175c$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("2AQeg", function(module, exports) {

$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $38b42e3ace3040e7$export$161c77b6b09fc494);
const $38b42e3ace3040e7$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("lK4Eh", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueTransformer", () => $a7314ca0000b10b6$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $a7314ca0000b10b6$export$e87b0f36be178543);

var $7NDId = parcelRequire("7NDId");

var $frwJc = parcelRequire("frwJc");
const $a7314ca0000b10b6$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $frwJc.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $7NDId.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $a7314ca0000b10b6$export$e87b0f36be178543 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("ibFp9", function(module, exports) {

$parcel$export(module.exports, "fixVersionsSetValueValidator", () => $15216c199cee160c$export$423303d5750f732c);
$parcel$export(module.exports, "transformVersionsSetValue", () => $15216c199cee160c$export$5706ac863a06e5ed);
$parcel$export(module.exports, "transformVersionsGetValue", () => $15216c199cee160c$export$360c4edb055d9cb4);
$parcel$export(module.exports, "versionsRequiredScopes", () => $15216c199cee160c$export$60db61c485973ad9);

var $7NDId = parcelRequire("7NDId");

var $5CqLP = parcelRequire("5CqLP");

var $9mqRh = parcelRequire("9mqRh");

var $jkotl = parcelRequire("jkotl");

var $fwvEZ = parcelRequire("fwvEZ");
const $15216c199cee160c$export$423303d5750f732c = (value)=>Array.isArray(value) && value.every((0, $jkotl.isNotEmptyString));
const $15216c199cee160c$export$5706ac863a06e5ed = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $fwvEZ.multiValueLookup)(values, lookupValues, 'id');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $9mqRh.getValueLookupValuesDiff)(values, filteredLookupValues, 'id');
        throw new (0, $7NDId.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));
};
const $15216c199cee160c$export$360c4edb055d9cb4 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            name: label
        }));
};
const $15216c199cee160c$export$60db61c485973ad9 = {
    ...(0, $5CqLP.versionsRequiredScopes),
    granular: [
        ...(0, $5CqLP.versionsRequiredScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("9icMi", function(module, exports) {

$parcel$export(module.exports, "default", () => $81653562247c03af$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81653562247c03af$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    obligatoryUimGicConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message",
        "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this issue."
    },
    obligatoryUimGicConsentMessageIssueTermRefresh: {
        "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message-issue-term-refresh",
        "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this work item."
    }
});

});



parcelRegister("c9aLX", function(module, exports) {

$parcel$export(module.exports, "UiModificationsEntryPoint", () => $6a0a573c5ab6bbf9$export$c89b83ae4e6840b3);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $dIjAl = parcelRequire("dIjAl");

var $5fc53 = parcelRequire("5fc53");

var $10UkC = parcelRequire("10UkC");
var $z11xo = parcelRequire("z11xo");

var $fjcgS = parcelRequire("fjcgS");

var $gr8O1 = parcelRequire("gr8O1");

var $koeKL = parcelRequire("koeKL");

var $eRxDC = parcelRequire("eRxDC");
var $j5YhT = parcelRequire("j5YhT");


var $4FeER = parcelRequire("4FeER");
const $6a0a573c5ab6bbf9$var$UiModificationsEntryPointLoaded = ({ issueTypeFieldType: issueTypeFieldType, modalFieldConfig: modalFieldConfig, resetFormFieldsCounter: resetFormFieldsCounter, selectedIssueType: selectedIssueType, selectedProject: selectedProject, triggerPointKey: triggerPointKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const executionContext = (0, $5uXOq.useMemo)(()=>{
        if (selectedProject && selectedIssueType) return {
            project: {
                id: selectedProject.value,
                key: selectedProject.projectKey,
                type: selectedProject.projectType
            },
            issueType: {
                id: selectedIssueType.value,
                name: selectedIssueType.label
            },
            viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715)
        };
        return null;
    }, [
        selectedIssueType,
        selectedProject
    ]);
    const fieldsCount = (0, $5uXOq.useMemo)(()=>(0, $4FeER.getSupportedFieldsCount)({
            ...modalFieldConfig,
            [(0, $5fc53.ISSUE_TYPE)]: {
                fieldType: issueTypeFieldType
            }
        }), [
        issueTypeFieldType,
        modalFieldConfig
    ]);
    const queryParams = (0, $5uXOq.useMemo)(()=>{
        if (!executionContext?.project.id || !executionContext?.issueType.id) return null;
        return {
            cloudId: cloudId,
            forgeExtensionRenderingContext: {
                projectKey: executionContext?.project.key
            },
            uiModificationsContext: {
                projectId: (0, $j5YhT.JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: executionContext?.project.id
                }).toString(),
                issueTypeId: (0, $eRxDC.JiraIssueTypeAri).create({
                    siteId: cloudId,
                    issueTypeId: executionContext?.issueType.id
                }).toString(),
                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715)
            },
            includeEgressOverridesForge: (0, $4R6GH.fg)('forge-ui-overrides-property-in-extension-list')
        };
    }, [
        cloudId,
        executionContext?.issueType.id,
        executionContext?.project.id,
        executionContext?.project.key
    ]);
    const executionContextKey = (0, $5uXOq.useMemo)(()=>selectedIssueType?.value && selectedProject?.value ? `${selectedProject.value}-${selectedIssueType.value}` : null, [
        selectedIssueType?.value,
        selectedProject?.value
    ]);
    if (!executionContext || !queryParams) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gr8O1.UiModificationsJiraRoot), {
        containerId: "uiModifications",
        containerPackageName: "jiraUiModificationsViewGic",
        queryParams: queryParams,
        resetFormFieldsCounter: resetFormFieldsCounter,
        executionContextKey: executionContextKey,
        executionContext: executionContext,
        numberOfSupportedFields: fieldsCount,
        triggerPointKey: triggerPointKey
    });
};
const $6a0a573c5ab6bbf9$export$c89b83ae4e6840b3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "uiModifications",
        packageName: "jiraUiModificationsViewGic",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null),
        attributes: (error)=>({
                errorType: (0, $z11xo.getErrorType)(error),
                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715)
            }),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10UkC.AnalyticsListener), {
        analyticsWebClient: (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a0a573c5ab6bbf9$var$UiModificationsEntryPointLoaded, props)));

});
parcelRegister("dIjAl", function(module, exports) {

$parcel$export(module.exports, "ErrorHandler", () => $95320a69efc876f6$export$f42bc933f51d0006);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1YewZ = parcelRequire("1YewZ");
const $95320a69efc876f6$export$f42bc933f51d0006 = ()=>{
    (0, $gKZoD.di)((0, $1YewZ.useIssueAdjustmentsActions));
    const { setError: setError, resetError: resetError } = (0, $1YewZ.useIssueAdjustmentsActions)();
    (0, $5uXOq.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});

parcelRegister("10UkC", function(module, exports) {

$parcel$export(module.exports, "AnalyticsListener", () => $5a540f0874acf87c$export$22edec767217cd60);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $kCVub = parcelRequire("kCVub");

var $1nF7O = parcelRequire("1nF7O");

const $5a540f0874acf87c$export$7329bcdc3edcd90e = (event, client)=>{
    switch(event.type){
        case 0, $6e65040b988c460f$export$12346a674644c156:
            Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
            break;
        case 0, $6e65040b988c460f$export$947dac6c72b26f81:
            Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
            break;
    }
};
const $5a540f0874acf87c$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
        const eventData = (0, $kCVub.extractAWCDataFromEvent)(event);
        $5a540f0874acf87c$export$7329bcdc3edcd90e({
            type: eventData.type,
            ...eventData.payload
        }, analyticsWebClient);
    };
const $5a540f0874acf87c$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
    const onEvent = (0, $5uXOq.useMemo)(()=>$5a540f0874acf87c$export$eee20638634729b3(analyticsWebClient), [
        analyticsWebClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const initClient = async ()=>{
            const client = await analyticsWebClient;
            (0, $1nF7O.initialiseErrorAnalyticsClient)(client);
        };
        initClient();
    }, [
        analyticsWebClient
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
        onEvent: onEvent,
        channel: (0, $aded369bac156944$export$8280e5c6104c5b40),
        children: children
    });
};

});

parcelRegister("gr8O1", function(module, exports) {

$parcel$export(module.exports, "UiModificationsJiraRoot", () => $77fbdd223bb388af$export$281f97be92d49a08);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $z11xo = parcelRequire("z11xo");

var $jrwZp = parcelRequire("jrwZp");

var $koeKL = parcelRequire("koeKL");

var $fY39E = parcelRequire("fY39E");

var $dIjAl = parcelRequire("dIjAl");

var $gL80q = parcelRequire("gL80q");

var $4R6GH = parcelRequire("4R6GH");

var $j6Tjl = parcelRequire("j6Tjl");

var $91vVC = parcelRequire("91vVC");
const $77fbdd223bb388af$var$defaultErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null);
const $77fbdd223bb388af$export$281f97be92d49a08 = ({ containerId: containerId, containerPackageName: containerPackageName, errorFallback: errorFallback, queryParams: queryParams, executionContextKey: executionContextKey, executionContext: executionContext, triggerPointKey: triggerPointKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $91vVC.uiModificationsRootEntrypoint), queryParams);
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $jrwZp.useAdjustmentsContextActions)();
    const shouldUiModificationsLoad = executionContext && (0, $gL80q.isExecutionContextSupported)(executionContext) && (0, $gL80q.isTriggerPointSupported)(queryParams.uiModificationsContext.viewType, triggerPointKey);
    // In case that the UI modifications are not supposed to load,
    // we need toset the shouldUiModificationsLoad to 'no' to have proper context state
    // otherwise the context state will be set to 'yes' by the root component
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('uim_setting_should_not_load_in_context')) shouldUiModificationsLoad ? entryPointActions.load() : setShouldUiModificationsLoad('no');
        else shouldUiModificationsLoad && entryPointActions.load();
    }, [
        entryPointActions,
        queryParams,
        executionContextKey,
        shouldUiModificationsLoad,
        setShouldUiModificationsLoad
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId,
            executionContextKey: executionContextKey,
            executionContext: executionContext,
            triggerPointKey: triggerPointKey,
            numberOfSupportedFields: numberOfSupportedFields,
            resetFormFieldsCounter: resetFormFieldsCounter,
            ForgeAppRenderer: $j6Tjl.ForgeAppRenderer
        }), [
        activationId,
        cloudId,
        executionContextKey,
        executionContext,
        triggerPointKey,
        numberOfSupportedFields,
        resetFormFieldsCounter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: containerId,
        packageName: containerPackageName,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        errorFallback: errorFallback ?? $77fbdd223bb388af$var$defaultErrorFallback,
        errorAttributes: (error)=>({
                errorType: (0, $z11xo.getErrorType)(error),
                viewType: queryParams.uiModificationsContext.viewType
            }),
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("j6Tjl", function(module, exports) {

$parcel$export(module.exports, "ForgeAppRenderer", () => $d8d7d5a7d77467bc$export$6eef17fe5fde390c);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $k2DRb = parcelRequire("k2DRb");

var $kxZPA = parcelRequire("kxZPA");

const $d8d7d5a7d77467bc$var$getModule = ()=>(parcelRequire("7FYp9"));
const $d8d7d5a7d77467bc$export$7ef2c8aa7b731b0c = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$d8d7d5a7d77467bc$var$getModule().then((module)=>module.ForgeUIExtension), {
    ssr: false
}));
const $d8d7d5a7d77467bc$export$6eef17fe5fde390c = ({ extension: extension, extensionData: extensionData, customBridgeMethods: customBridgeMethods, onIframeLoad: onIframeLoad, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, consentMessage: consentMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8d7d5a7d77467bc$export$7ef2c8aa7b731b0c, {
        contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA),
        module: (0, $k2DRb.UI_MODIFICATIONS_MODULE),
        extension: extension,
        customBridgeMethods: customBridgeMethods,
        onLoad: onIframeLoad,
        extensionData: extensionData,
        isIframeResizable: isIframeResizable,
        isIframeHidden: isIframeHidden,
        onConsentSuccess: onConsentSuccess,
        onConsentInitialization: onConsentInitialization,
        consentMessage: consentMessage
    });
};

});
parcelRegister("7FYp9", function(module, exports) {

let $596b37d4a62ae28c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $596b37d4a62ae28c$var$load("kWrFZ"),
    $596b37d4a62ae28c$var$load("cM9em"),
    $596b37d4a62ae28c$var$load("fr9NE"),
    $596b37d4a62ae28c$var$load("hPzOn"),
    $596b37d4a62ae28c$var$load("h2MrD"),
    $596b37d4a62ae28c$var$load("bYT2S"),
    $596b37d4a62ae28c$var$load("19rY6")
]).then(()=>parcelRequire('3twM3'));

});


parcelRegister("91vVC", function(module, exports) {

$parcel$export(module.exports, "uiModificationsRootEntrypoint", () => $a4ebfe0d510df310$export$a12f4912b9018c15);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");

var $1I2aa = parcelRequire("1I2aa");

const $a4ebfe0d510df310$export$a12f4912b9018c15 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("86xyk")).then((module)=>module.RootEntrypointWrapper), {
        moduleId: "3c08c19c"
    }),
    getPreloadProps: ({ cloudId: cloudId, forgeExtensionRenderingContext: forgeExtensionRenderingContext, uiModificationsContext: uiModificationsContext })=>{
        return {
            queries: {
                rootUiModificationsQuery: {
                    parameters: (0, $1I2aa.default),
                    variables: {
                        cloudId: cloudId,
                        forgeExtensionRenderingContext: forgeExtensionRenderingContext,
                        uiModificationsContext: uiModificationsContext,
                        includeEgressOverridesForge: (0, $4R6GH.fg)('forge-ui-overrides-property-in-extension-list')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("1I2aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b35ccc28f175067$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8aaaa2978a81f06f17e69c528ed513aa>>
 * @relayHash 8e1782ab00eaf4e2a62ca8165e4a53d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 349b62d9a2ae01177c6349397ef0a02533e916acd4be6638555d6ca5510bb207
const $6b35ccc28f175067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "forgeExtensionRenderingContext"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeEgressOverridesForge"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "uiModificationsContext"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "forgeExtensionRenderingContext",
                            "variableName": "forgeExtensionRenderingContext"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeEgressOverridesForge",
                            "variableName": "includeEgressOverridesForge"
                        },
                        {
                            "kind": "Variable",
                            "name": "uiModificationsContext",
                            "variableName": "uiModificationsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fragment_AtlassianUiModificationsCore_RootFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraForgeQuery",
                            "kind": "LinkedField",
                            "name": "forge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "condition": "includeEgressOverridesForge",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "inScopeEUD"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeEgressOverridesForge",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "overrides"
                                                },
                                                {
                                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                                    "kind": "LinkedField",
                                                    "name": "installationConfig",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "349b62d9a2ae01177c6349397ef0a02533e916acd4be6638555d6ca5510bb207",
            "metadata": {},
            "name": "rootUiModificationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6b35ccc28f175067$var$node.hash = "e9e68d25e9903be8d01585d94c33f309";
var $6b35ccc28f175067$export$2e2bcd8739ae039 = $6b35ccc28f175067$var$node;

});

parcelRegister("86xyk", function(module, exports) {

let $5e68e923e536c4bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e68e923e536c4bd$var$load("5GUMQ").then(()=>parcelRequire('5F2lh'));

});



parcelRegister("eRxDC", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAri", () => $ad201bc122f7bbf6$export$931e4419330c3862);

var $j1lUB = parcelRequire("j1lUB");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issue-type/manifest.ts
var $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $j1lUB.JiraIssueTypeAriResourceOwner),
    resourceType: (0, $j1lUB.JiraIssueTypeAriResourceType),
    resourceIdSlug: "{issueTypeId}",
    resourceIdSegmentFormats: {
        issueTypeId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-type/index.ts
var $ad201bc122f7bbf6$export$931e4419330c3862 = class _JiraIssueTypeAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueTypeId = opts.resourceIdSegmentValues.issueTypeId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueTypeId() {
        return this._issueTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts.qualifier,
            platformQualifier: $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts.resourceOwner,
            resourceType: $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts.resourceType,
            resourceId: `${opts.issueTypeId}`,
            resourceIdSegmentValues: {
                issueTypeId: opts.issueTypeId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $ad201bc122f7bbf6$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueTypeId: this.issueTypeId
        };
    }
};

});
parcelRegister("j1lUB", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAriResourceOwner", () => $dd8f1b935e25b1c3$export$a40271de8e7c8a70);
$parcel$export(module.exports, "JiraIssueTypeAriResourceType", () => $dd8f1b935e25b1c3$export$70e5e6fc47f1a2cc);
// src/jira/issue-type/types.ts
var $dd8f1b935e25b1c3$export$a40271de8e7c8a70 = "jira", $dd8f1b935e25b1c3$export$70e5e6fc47f1a2cc = "issue-type";

});


parcelRegister("4FeER", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldsCount", () => $7db90df2e35b2352$export$11f15170229125b6);

var $gL80q = parcelRequire("gL80q");

const $7db90df2e35b2352$export$11f15170229125b6 = (fields)=>{
    if (!fields) return 0;
    return Object.values(fields).filter(({ fieldType: fieldType })=>(0, $gL80q.isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType)).length;
};

});


parcelRegister("1xqgn", function(module, exports) {

$parcel$export(module.exports, "OptionComponent", () => $e4635a311355eecc$export$3e92eb7b7644ac65);
$parcel$export(module.exports, "useSelectOptions", () => $e4635a311355eecc$export$338e37f345f318fa);
$parcel$export(module.exports, "useCombinedInlineConfigurationExperiment", () => $e4635a311355eecc$export$f7858f4c698ccb67);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fJ83Q = parcelRequire("fJ83Q");

var $3LKEA = parcelRequire("3LKEA");

var $4Gswu = parcelRequire("4Gswu");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $k92cH = parcelRequire("k92cH");
const $e4635a311355eecc$export$3e92eb7b7644ac65 = ({ children: children, ...optionProps })=>{
    if ([
        (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
        (0, $4ffa16dc12cfa934$export$bc1622166baa0162),
        (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b)
    ].includes(optionProps.data.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), optionProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Gswu.OptionWithAutoKeyboardScroll), optionProps, children);
};
const $e4635a311355eecc$export$338e37f345f318fa = (targetOptions, hasFooter)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerOptions = (0, $5uXOq.useMemo)(()=>{
        return [
            {
                label: formatMessage((0, $k92cH.default).createStatus),
                type: (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
                value: (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3)
            },
            ...(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') ? [
                {
                    label: formatMessage((0, $k92cH.default).editStatus),
                    type: (0, $4ffa16dc12cfa934$export$bc1622166baa0162),
                    value: (0, $4ffa16dc12cfa934$export$bc1622166baa0162)
                }
            ] : [],
            {
                label: formatMessage((0, $k92cH.default).manageWorkflow),
                type: (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b),
                value: (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b)
            }
        ];
    }, [
        formatMessage
    ]);
    const optionsWithFooter = (0, $3LKEA.appendStickyFooterOptions)(targetOptions, footerOptions);
    if (hasFooter) return optionsWithFooter;
    return targetOptions;
};
const $e4635a311355eecc$export$f7858f4c698ccb67 = (isEligible = true)=>{
    const [combinedInlineConfigurationExperiment, fireCombinedInlineConfigurationExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure, jira/deprecations/ban-identifiers
    const [_, fireCombinedInlineConfigurationExperimentAAExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment_aa');
    const isEnabled = Boolean(isEligible && combinedInlineConfigurationExperiment.get('isEnabled', false));
    const fireExposure = ()=>{
        if (isEligible) {
            fireCombinedInlineConfigurationExperimentExposure();
            fireCombinedInlineConfigurationExperimentAAExposure();
        }
    };
    return {
        isEnabled: isEnabled,
        fireExposure: fireExposure
    };
};

});
parcelRegister("fJ83Q", function(module, exports) {

$parcel$export(module.exports, "OptionWithButtonStyle", () => $bb57911f4b9388b9$export$b3382093e45b6db9);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $dC5iT = parcelRequire("dC5iT");
const $bb57911f4b9388b9$export$b3382093e45b6db9 = ({ children: children, onHover: onHover, testId: testId, ...optionProps })=>{
    const customisedGetStyles = (propertyName, props)=>{
        return {
            ...optionProps.getStyles(propertyName, props),
            boxShadow: 'none',
            cursor: 'pointer',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onMouseOver: onHover,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...optionProps,
        getStyles: customisedGetStyles
    }, children));
};

});

parcelRegister("3LKEA", function(module, exports) {

$parcel$export(module.exports, "appendStickyFooterOptions", () => $cc9569724dc25e59$export$870da2f71d38aa94);
$parcel$export(module.exports, "useAppendStickyFooterOptions", () => $cc9569724dc25e59$export$9ef0653bfb9844e7);
$parcel$export(module.exports, "scrollIntoView", () => $cc9569724dc25e59$export$53a0910f038337bd);

var $5uXOq = parcelRequire("5uXOq");

const $cc9569724dc25e59$export$870da2f71d38aa94 = (options, footerOptions)=>{
    return [
        ...options,
        {
            options: footerOptions.map((footerOption)=>{
                return {
                    ...footerOption,
                    groupType: (0, $8109ad51236d2441$export$e13d614fc55c6ce9)
                };
            })
        }
    ];
};
const $cc9569724dc25e59$export$9ef0653bfb9844e7 = (options, footerOptions)=>{
    return (0, $5uXOq.useMemo)(()=>$cc9569724dc25e59$export$870da2f71d38aa94(options, footerOptions), [
        footerOptions,
        options
    ]);
};
function $cc9569724dc25e59$export$53a0910f038337bd(menuEl, focusedEl, bottomOffset = 0) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom - bottomOffset) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + bottomOffset + overScroll, menuEl.scrollHeight - bottomOffset);
    else if (focusedRect.top - overScroll < menuRect.top) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.max(focusedEl.offsetTop - overScroll, 0);
}

});
const $8109ad51236d2441$export$e13d614fc55c6ce9 = 'STICKY_FOOTER_GROUP_TYPE';
const $8109ad51236d2441$export$1ae91d219a8713ac = 'select-sticky-footer';


parcelRegister("4Gswu", function(module, exports) {

$parcel$export(module.exports, "OptionWithAutoKeyboardScroll", () => $615e8210cb21f219$export$39118cd824d8af0b);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $7mPT9 = parcelRequire("7mPT9");

var $3LKEA = parcelRequire("3LKEA");

const $615e8210cb21f219$export$39118cd824d8af0b = ({ children: children, containerRef: containerRef, ...optionProps })=>{
    const focusedOptionRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (optionProps.isFocused) {
            // We only auto scroll for focus with keyboard only, not for focus with mouse hover
            // because mouse users will manual scroll when browsing options
            if (!focusedOptionRef.current?.parentElement || focusedOptionRef.current?.matches(':hover')) return;
            // We need to add bottom offset when scrolling which is the current height of sticky footer options group
            const stickFooterBottomOffset = globalThis?.document.querySelector(`.${(0, $8109ad51236d2441$export$1ae91d219a8713ac)}`)?.clientHeight ?? 0;
            (0, $3LKEA.scrollIntoView)(containerRef?.current ?? focusedOptionRef.current.parentElement, focusedOptionRef.current, stickFooterBottomOffset);
        }
    }, [
        containerRef,
        optionProps.isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...optionProps,
        innerRef: (0, $7mPT9.mergeRefs)(optionProps.innerRef, focusedOptionRef)
    }, children);
};

});

const $4ffa16dc12cfa934$export$bbd08ee543ba8cc3 = 'createStatus';
const $4ffa16dc12cfa934$export$bc1622166baa0162 = 'editStatus';
const $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b = 'manageWorkflow';

parcelRegister("k92cH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d361f761a404638a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d361f761a404638a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    selectStatus: {
        "id": "issue-field-status.status-view.select-status",
        "defaultMessage": "Select status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    },
    noPermissionIssueTermRefresh: {
        "id": "issue-field-status.status-view.no-permission-issue-term-refresh",
        "defaultMessage": "You don't have permission to transition this work item"
    },
    createStatus: {
        "id": "issue-field-status.status-view.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.edit-status",
        "defaultMessage": "Edit status"
    },
    manageWorkflow: {
        "id": "issue-field-status.status-view.manage-workflow",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("10zMF", function(module, exports) {

$parcel$export(module.exports, "navigationDiscardChangesPromptEntrypoint", () => $d013535599c23ad0$export$e3fb8f8e2efee889);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d013535599c23ad0$export$e3fb8f8e2efee889 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("9AReS"))), {
        moduleId: "5b0a027b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9AReS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NavigationDiscardChangesPrompt", () => $630c46f8d9d76a94$export$80c1951973f41e27);
$parcel$export(module.exports, "default", () => $630c46f8d9d76a94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $2rqOp = parcelRequire("2rqOp");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $lVJAU = parcelRequire("lVJAU");

var $fEvvA = parcelRequire("fEvvA");
const $630c46f8d9d76a94$export$80c1951973f41e27 = ({ navigateLink: navigateLink, onConfirm: onConfirm, onCancel: onCancel })=>{
    const [isNavigating, setIsNavigating] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onCancelHandler = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelNavigationDisardChangesPrompt', {
            navigateLink: navigateLink
        });
        onCancel?.();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onConfirmHandler = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'confirmNavigationDisardChangesPrompt', {
            navigateLink: navigateLink
        });
        onConfirm && onConfirm();
        setIsNavigating(true);
        push(navigateLink);
    };
    if (!navigateLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "navigateWithoutRestore"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: onCancelHandler,
        width: "small",
        shouldCloseOnOverlayClick: !isNavigating,
        shouldCloseOnEscapePress: !isNavigating,
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.modal-dialog",
        messageId: "issue-create.common.ui.navigation-discard-changes-prompt.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $fEvvA.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $fEvvA.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.button",
        appearance: "subtle-link",
        onClick: onCancelHandler,
        isDisabled: isNavigating
    }, formatMessage((0, $fEvvA.default).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.loading-button",
        appearance: "primary",
        onClick: onConfirmHandler,
        isDisabled: isNavigating,
        isLoading: isNavigating
    }, formatMessage((0, $fEvvA.default).confirmLabel))))));
};
function $630c46f8d9d76a94$export$2e2bcd8739ae039({ props: props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($630c46f8d9d76a94$export$80c1951973f41e27, props);
}

});
parcelRegister("fEvvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f90df22bac189d3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f90df22bac189d3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-create.common.navigation-discard-changes-prompt.title",
        "defaultMessage": "Your changes won\u2019t be saved"
    },
    cancelButtonLabel: {
        "id": "issue-create.common.navigation-discard-changes-prompt.cancel-button-label",
        "defaultMessage": "Go back"
    },
    confirmLabel: {
        "id": "issue-create.common.navigation-discard-changes-prompt.confirm-label",
        "defaultMessage": "Discard"
    },
    description: {
        "id": "issue-create.common.navigation-discard-changes-prompt.description",
        "defaultMessage": "We won\u2019t be able to save your data if you move away from this page."
    }
});

});



parcelRegister("kHA0a", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", () => $3ba4865b52bac0cc$export$2353115f31f4d15);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $3ba4865b52bac0cc$export$feb08457bf70a411);
$parcel$export(module.exports, "scrollToField", () => $3ba4865b52bac0cc$export$a3f522e44642cd81);

var $k9tnV = parcelRequire("k9tnV");

var $bGrWH = parcelRequire("bGrWH");

var $06PEc = parcelRequire("06PEc");

var $aSoqm = parcelRequire("aSoqm");



const $3ba4865b52bac0cc$export$2353115f31f4d15 = (elementId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const fieldRef = document.getElementById(elementId);
    if (fieldRef) (0, $k9tnV.default)(fieldRef, (0, $bGrWH.DEFAULT_SCROLL_OPTIONS));
};
const $3ba4865b52bac0cc$export$feb08457bf70a411 = (event)=>{
    if (event?.keyCode === (0, $aSoqm.ESC_KEY_KEYCODE)) event?.nativeEvent?.stopImmediatePropagation();
};
const $3ba4865b52bac0cc$export$a3f522e44642cd81 = (fieldId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const fieldWithErrorRef = document.getElementById((0, $06PEc.getFieldContainerId)(fieldId));
    if (fieldWithErrorRef) (0, $k9tnV.default)(fieldWithErrorRef, (0, $bGrWH.DEFAULT_SCROLL_OPTIONS));
};

});
parcelRegister("06PEc", function(module, exports) {

$parcel$export(module.exports, "getFieldContainerId", () => $77cde28fab49b679$export$10904a5319f8077);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports








const $77cde28fab49b679$export$10904a5319f8077 = (fieldId)=>`${fieldId}-container`;

});

parcelRegister("aSoqm", function(module, exports) {

$parcel$export(module.exports, "FIELDS_LEARN_MORE_LINKS", () => $1d1e013afe0ab876$export$629cb7e52dfd594b);
$parcel$export(module.exports, "USER_GIC_POSITIONING_SPOTLIGHT", () => $1d1e013afe0ab876$export$1056c1e726f183f9);
$parcel$export(module.exports, "ESC_KEY_KEYCODE", () => $1d1e013afe0ab876$export$53016e09dd7d4dca);

const $1d1e013afe0ab876$export$483ce8a526ee009f = 'https://support.atlassian.com/jira-core-cloud/docs/create-and-work-with-issues/';
const $1d1e013afe0ab876$export$d807a38e79102eb0 = 'https://support.atlassian.com/jira-work-management/docs/what-is-the-new-jira-issue-create-experience/';
const $1d1e013afe0ab876$export$629cb7e52dfd594b = {
    [(0, $962656cd6986cb06$export$252fb981af0e2e4e)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#ResolutionTypes',
    [(0, $962656cd6986cb06$export$909ba97f4a791588)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#SecurityLevels',
    [(0, $962656cd6986cb06$export$de14210faa5f2099)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#PriorityLevels'
};
const $1d1e013afe0ab876$export$1056c1e726f183f9 = 'jira.user.gic.positioning.spotlight';
const $1d1e013afe0ab876$export$53016e09dd7d4dca = 27;

});
// graphql __typename
const $962656cd6986cb06$export$aa5680ad8f8be9fc = 'JiraProjectField';
const $962656cd6986cb06$export$2d5a62a3515ad4c6 = 'JiraIssueTypeField';
const $962656cd6986cb06$export$a12a4b25ab12710c = 'JsmRequestTypeField';
const $962656cd6986cb06$export$23ca38ad884e35f1 = 'JiraSingleLineTextField';
const $962656cd6986cb06$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $962656cd6986cb06$export$30b2c2de5e3007a4 = 'JiraComponentsField';
const $962656cd6986cb06$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $962656cd6986cb06$export$3849bb04b4eee607 = 'JiraSingleSelectUserPickerField';
const $962656cd6986cb06$export$eca94ae30cb92d8 = 'JiraMultipleSelectUserPickerField';
const $962656cd6986cb06$export$2bb9d057bad89bfa = 'JiraPeopleField';
const $962656cd6986cb06$export$b1ac879bb5cdf30a = 'JsmPeopleField';
const $962656cd6986cb06$export$e4d5e04bc56680dc = 'JiraNumberField';
const $962656cd6986cb06$export$d8312cdfa02c100d = 'JiraDateTimePickerField';
const $962656cd6986cb06$export$8723b724f0b3ac65 = 'JiraEpicLinkField';
const $962656cd6986cb06$export$64c7789e86344de5 = 'JiraLabelsField';
const $962656cd6986cb06$export$f4f101295d5cc151 = 'JiraSingleVersionPickerField';
const $962656cd6986cb06$export$5bb498d4f2f54799 = 'JiraMultipleVersionPickerField';
const $962656cd6986cb06$export$de14210faa5f2099 = 'JiraPriorityField';
const $962656cd6986cb06$export$47af4d6f62c134cf = 'JiraIssueLinkField';
const $962656cd6986cb06$export$e0b268941120d761 = 'JiraDatePickerField';
const $962656cd6986cb06$export$909ba97f4a791588 = 'JiraSecurityLevelField';
const $962656cd6986cb06$export$f2b56433dc0af401 = 'JiraUrlField';
const $962656cd6986cb06$export$d10237d945259f96 = 'JiraCheckboxesField';
const $962656cd6986cb06$export$27854f490d658fc4 = 'JiraRadioSelectField';
const $962656cd6986cb06$export$fb8861017089d392 = 'JiraSingleSelectField';
const $962656cd6986cb06$export$2055419ff013de79 = 'JiraMultipleSelectField';
const $962656cd6986cb06$export$16fe78a07e97f2ad = 'JiraSingleGroupPickerField';
const $962656cd6986cb06$export$3a1ae3e0f2d9b1b9 = 'JiraMultipleGroupPickerField';
const $962656cd6986cb06$export$64238d76a1dc0703 = 'JiraSprintField';
const $962656cd6986cb06$export$1070aada56fcaec9 = 'JiraColorField';
const $962656cd6986cb06$export$a9b3195cbef5c5ad = 'JiraAttachmentsField';
const $962656cd6986cb06$export$76d811609080a7aa = 'JiraIssueRestrictionField';
const $962656cd6986cb06$export$252fb981af0e2e4e = 'JiraResolutionField';
const $962656cd6986cb06$export$a36509fae9e84682 = 'JiraCascadingSelectField';
const $962656cd6986cb06$export$79443fedd031b437 = 'JiraTeamField';
const $962656cd6986cb06$export$5e56d79dfe9be3d = 'JiraAffectedServicesField';
const $962656cd6986cb06$export$d41ae99ff05f5cda = 'JsmMultipleSelectUserPickerField';
const $962656cd6986cb06$export$597fa240de2bfd92 = 'JiraCMDBField';
const $962656cd6986cb06$export$864384797e544339 = 'JsmOrganizationField';
const $962656cd6986cb06$export$7e5590c7c7a403c0 = 'JiraConnectTextField';
const $962656cd6986cb06$export$d854193d90dc547d = 'JiraConnectNumberField';
const $962656cd6986cb06$export$985c14eb8f3f0309 = 'JiraConnectSingleSelectField';
const $962656cd6986cb06$export$9f6f73ea02649f83 = 'JiraConnectMultipleSelectField';
const $962656cd6986cb06$export$aecc734a7c3591d7 = 'JiraTimeTrackingField';
const $962656cd6986cb06$export$d9861709f0b70c10 = 'JiraWorkLogField';
const $962656cd6986cb06$export$7a583e2ae9052377 = 'JiraConnectRichTextField';
const $962656cd6986cb06$export$8643f0b9cefed538 = 'JiraForgeStringField';
const $962656cd6986cb06$export$e0ece81bd398c799 = 'JiraForgeNumberField';
const $962656cd6986cb06$export$745c8245fea49a34 = 'JiraForgeUserField';
const $962656cd6986cb06$export$bbc6b85844b0ade5 = 'JiraForgeUsersField';
const $962656cd6986cb06$export$fd24d37af44fe736 = 'JiraForgeGroupField';
const $962656cd6986cb06$export$3027db6317a2a8ea = 'JiraForgeGroupsField';
const $962656cd6986cb06$export$f596336c24b128f5 = 'JiraForgeStringsField';
const $962656cd6986cb06$export$70ff025076e5fb13 = 'JiraForgeDatetimeField';
const $962656cd6986cb06$export$111f32c51678063a = 'JiraForgeDateField';
const $962656cd6986cb06$export$67aca33725b6a717 = 'JiraForgeObjectField';
const $962656cd6986cb06$export$1c7f7cfd2029442f = 'JiraAtlassianTeamField';
const $962656cd6986cb06$export$670384150af5f49e = 'JiraParentIssueField';
const $962656cd6986cb06$export$bf9df74e065af482 = 'JiraParentField';
const $962656cd6986cb06$export$33f8a9cb608132ba = 'JiraServiceManagementRespondersField';
const $962656cd6986cb06$export$fc69de49ba08ae77 = 'JiraServiceManagementEntitlementField';
const $962656cd6986cb06$export$ede7166f44cc4bd6 = 'JiraCustomerServiceOrganizationField';
const $962656cd6986cb06$export$a138d5648dda03f0 = 'JiraMessageEditField';
const $962656cd6986cb06$export$f7a08bf17a7ac661 = 'JiraAssigneeField';
const $962656cd6986cb06$export$d64150fd9c66969c = 'JiraReporterField';
const $962656cd6986cb06$export$95433ac963f4aebe = 'JiraTextAreaField';
const $962656cd6986cb06$export$f57941b9c1949a82 = 'JiraEpicColorField';
const $962656cd6986cb06$export$3e8dded8d83b5d95 = 'JiraAssetField';



parcelRegister("2K6wP", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $b2ea631f896ae096$export$852450339fdb3b37);
const $b2ea631f896ae096$export$852450339fdb3b37 = (createdIssues)=>{
    if (createdIssues.length > 1) {
        const issueKeys = createdIssues.map((issue)=>issue.issueKey).join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${createdIssues[0].issueKey}`;
};

});

parcelRegister("lr952", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsMachineLearning", () => $58cad0d162c177b0$export$2d70bc5538735402);

var $coW0O = parcelRequire("coW0O");
const $58cad0d162c177b0$export$2d70bc5538735402 = ()=>{
    const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } = (0, $coW0O.useSmartFieldsPreferenceResource)();
    const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;
    const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;
    return {
        withMachineLearning: withMachineLearning
    };
};

});
parcelRegister("coW0O", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsPreferenceResource", () => $7f9f79525cbc81c5$export$f66e1f764818b2e);
$parcel$export(module.exports, "SmartFieldsPreference", () => $7f9f79525cbc81c5$export$bccde3fe1fc453a0);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $dTlW6 = parcelRequire("dTlW6");

var $6s1PB = parcelRequire("6s1PB");

var $34Vv8 = parcelRequire("34Vv8");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $aA974 = parcelRequire("aA974");

var $2YP9W = parcelRequire("2YP9W");

var $3ep3z = parcelRequire("3ep3z");

var $6rdaE = parcelRequire("6rdaE");

var $gEEzS = parcelRequire("gEEzS");
const $7f9f79525cbc81c5$export$f66e1f764818b2e = ()=>(0, $2YP9W.useResource)((0, $aA974.gicSmartFieldsFeatureResource));
const $7f9f79525cbc81c5$export$bccde3fe1fc453a0 = (0, $34Vv8.default)((props)=>{
    (0, $gKZoD.di)(window);
    const { loading: loading, data: data, update: updateResource } = $7f9f79525cbc81c5$export$f66e1f764818b2e();
    const { updatePreferences: updatePreferences } = (0, $gEEzS.useSmartFieldsUpdateUserPreference)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { flagService: { showFlag: showFlag } } = props;
    const hasUserOptedOut = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserOptedOut === 'boolean' ? data.hasUserOptedOut : false, [
        data
    ]);
    const hasUserDismissedReadMore = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false, [
        data
    ]);
    const { openSmartFieldsFeedbackCollector: openSmartFieldsFeedbackCollector } = (0, $6rdaE.useSmartFieldsFeedbackCollector)();
    const successTitleOptingOutMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3ep3z.messages).successTitleOptingOutIssueTermRefresh : (0, $3ep3z.messages).successTitleOptingOut;
    const successTitleOptingInMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3ep3z.messages).successTitleOptingInIssueTermRefresh : (0, $3ep3z.messages).successTitleOptingIn;
    const onChange = (0, $5uXOq.useCallback)(async (_, analyticsEventUI)=>{
        const value = !hasUserOptedOut;
        updateResource(()=>({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false
            }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleLabsGicSmartFields', {
            isSmartFieldsOptOut: value
        });
        try {
            await updatePreferences({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false
            });
            showFlag({
                messageId: 'personal-settings-gic-smart-fields.ui.preference.show-flag.success',
                messageType: 'transactional',
                type: 'success',
                title: value ? successTitleOptingOutMessage : successTitleOptingInMessage
            });
            if (value) openSmartFieldsFeedbackCollector({
                feedbackTitle: formatMessage((0, $3ep3z.messages).feedbackOptOutTitle),
                feedbackContext: [
                    {
                        id: 'smart-fields-opt-out',
                        value: 'opted-out'
                    }
                ]
            });
        } catch (err) {
            updateResource(()=>({
                    hasUserOptedOut: hasUserOptedOut,
                    hasUserDismissedReadMore: hasUserDismissedReadMore
                }));
            const actions = [
                {
                    content: (0, $3ep3z.messages).refreshPageBtn,
                    onClick: ()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        window.location.reload();
                    }
                }
            ];
            showFlag({
                messageId: 'personal-settings-gic-smart-fields.ui.preference.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: value ? (0, $3ep3z.messages).errTitleOptingOut : (0, $3ep3z.messages).errTitleOptingIn,
                description: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3ep3z.messages).errDescriptionOptingInIssueTermRefresh : (0, $3ep3z.messages).errDescriptionOptingIn,
                actions: actions
            });
        }
    }, [
        hasUserDismissedReadMore,
        hasUserOptedOut,
        updateResource,
        updatePreferences,
        showFlag,
        openSmartFieldsFeedbackCollector,
        formatMessage,
        successTitleOptingInMessage,
        successTitleOptingOutMessage
    ]);
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        isChecked: !hasUserOptedOut,
        onChange: onChange,
        label: formatMessage((0, $3ep3z.messages).toggleAriaLabel)
    });
});

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("3ep3z", function(module, exports) {

$parcel$export(module.exports, "messages", () => $75e353f61e166a9d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $75e353f61e166a9d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    imgAltText: {
        "id": "personal-settings-gic-smart-fields.common.img-alt-text",
        "defaultMessage": "Hide unused fields when creating issues"
    },
    headerText: {
        "id": "personal-settings-gic-smart-fields.common.header-text",
        "defaultMessage": "Hide unused fields when creating issues"
    },
    descriptionText: {
        "id": "personal-settings-gic-smart-fields.common.description-text",
        "defaultMessage": "We\u2019ve implemented some smarts to make sure you have quick and easy access to the fields you actually use when you create issues. We\u2019re not removing the unused fields, you\u2019ll still be able to find them in a <strong>More fields</strong> section at the bottom of the issue create form. <link>Read more about the fields available when creating issues</link>"
    },
    loadingIndicatorAriaLabel: {
        "id": "personal-settings-gic-smart-fields.common.loading-indicator-aria-label",
        "defaultMessage": "Loading data for smart fields toggle button"
    },
    errTitleOptingOut: {
        "id": "personal-settings-gic-smart-fields.common.err-title-opting-out",
        "defaultMessage": "Failed to turn off"
    },
    errTitleOptingIn: {
        "id": "personal-settings-gic-smart-fields.common.err-title-opting-in",
        "defaultMessage": "Failed to turn on"
    },
    errDescriptionOptingIn: {
        "id": "personal-settings-gic-smart-fields.common.err-description-opting-in",
        "defaultMessage": "The issue should fix itself. You can try again in a few minutes, or refresh the page."
    },
    successTitleOptingIn: {
        "id": "personal-settings-gic-smart-fields.common.success-title-opting-in",
        "defaultMessage": "Now hiding unused fields when you create issues."
    },
    successTitleOptingOut: {
        "id": "personal-settings-gic-smart-fields.common.success-title-opting-out",
        "defaultMessage": "Unused fields now showing when you create issues."
    },
    refreshPageBtn: {
        "id": "personal-settings-gic-smart-fields.common.refresh-page-btn",
        "defaultMessage": "Refresh page"
    },
    feedbackTitle: {
        "id": "personal-settings-gic-smart-fields.common.feedback-title",
        "defaultMessage": "Share your feedback"
    },
    feedbackOptOutTitle: {
        "id": "personal-settings-gic-smart-fields.common.feedback-opt-out-title",
        "defaultMessage": "Before you go, help us improve the experience"
    },
    toggleAriaLabel: {
        "id": "personal-settings-gic-smart-fields.common.toggle-aria-label",
        "defaultMessage": "Toggle for hiding unused fields when creating issues"
    },
    imgAltTextIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.img-alt-text-issue-term-refresh",
        "defaultMessage": "Hide unused fields when creating work items"
    },
    headerTextIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.header-text-issue-term-refresh",
        "defaultMessage": "Hide unused fields when creating work items"
    },
    descriptionTextIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.description-text-issue-term-refresh",
        "defaultMessage": "We've moved fields you don't use when creating work to a <strong> More fields</strong> section below. <link>Read about the fields available when creating work</link>."
    },
    errDescriptionOptingInIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.err-description-opting-in-issue-term-refresh",
        "defaultMessage": "The issue should fix itself. You can try again in a few minutes, or refresh the page."
    },
    successTitleOptingInIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.success-title-opting-in-issue-term-refresh",
        "defaultMessage": "Now hiding unused fields when you create work items."
    },
    successTitleOptingOutIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.success-title-opting-out-issue-term-refresh",
        "defaultMessage": "Unused fields now showing when you create work items."
    },
    toggleAriaLabelIssueTermRefresh: {
        "id": "personal-settings-gic-smart-fields.common.toggle-aria-label-issue-term-refresh",
        "defaultMessage": "Toggle for hiding unused fields when creating work items"
    }
});

});

parcelRegister("6rdaE", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsFeedbackCollector", () => $3a2d0f7f67a54576$export$ffd83fb8be3279b);

var $5uXOq = parcelRequire("5uXOq");

var $dseDh = parcelRequire("dseDh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $3a2d0f7f67a54576$export$25dc0a1e75f58d8f = '980acd66-d10b-474a-9ff1-48928fc1c8ad';
const $3a2d0f7f67a54576$export$14b33d63628336c2 = 'gic.smart-fields';
const $3a2d0f7f67a54576$export$ffd83fb8be3279b = ()=>{
    const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, $dseDh.useFeedbackCollectorActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const openSmartFieldsFeedbackCollector = (0, $5uXOq.useCallback)((feedbackCollectorProps)=>{
        openFeedbackCollector({
            entrypointId: $3a2d0f7f67a54576$export$25dc0a1e75f58d8f,
            feedbackGroupId: $3a2d0f7f67a54576$export$14b33d63628336c2,
            onClose: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector closed');
                resetFeedbackCollectorState();
            },
            onSubmit: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector submitted');
            },
            ...feedbackCollectorProps
        });
    }, [
        openFeedbackCollector,
        createAnalyticsEvent,
        resetFeedbackCollectorState
    ]);
    return {
        openSmartFieldsFeedbackCollector: openSmartFieldsFeedbackCollector
    };
};

});

parcelRegister("gEEzS", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsUpdateUserPreference", () => $2a8bf66056b8c1ad$export$d7a60913673e28ef);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

const $2a8bf66056b8c1ad$export$d7a60913673e28ef = ()=>{
    const updatePreferences = (0, $5uXOq.useCallback)(async (payload)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $a11a54266737e598$export$b94951a11282ae6a), payload);
        } catch (err) {
            (0, $jcw0u.default)({
                error: err instanceof Error ? err : new Error('Unknown error'),
                meta: {
                    id: 'updateCommandPaletteOptInStatus',
                    packageName: 'jiraPersonalSettingsGicSmartFields',
                    teamName: 'gryffindor'
                }
            });
            throw err;
        }
    }, []);
    return {
        updatePreferences: updatePreferences
    };
};

});
const $a11a54266737e598$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $a11a54266737e598$export$5781c9f38e6a61fe = 'jira.create.smart.fields.is-enabled';




parcelRegister("6OTur", function(module, exports) {

$parcel$export(module.exports, "useChangerSpotlight", () => $f1295c4f9d1bf347$export$6e0f4554859c42e9);

var $5uXOq = parcelRequire("5uXOq");

var $c0dQj = parcelRequire("c0dQj");

var $aSoqm = parcelRequire("aSoqm");

var $9FXQH = parcelRequire("9FXQH");
const $f1295c4f9d1bf347$export$6e0f4554859c42e9 = (minimizableModalView)=>{
    const [allowShowingChangerSpotlight, setAllowShowingChangerSpotlight] = (0, $5uXOq.useState)(false);
    const [userPreferenceSpotlight, setUserPreferences] = (0, $9FXQH.useUserPreferences)((0, $aSoqm.USER_GIC_POSITIONING_SPOTLIGHT), false);
    const hasSeenGicPositioningSpotlight = userPreferenceSpotlight;
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const shouldShowChangerSpotlight = !hasSeenGicPositioningSpotlight && allowShowingChangerSpotlight && !isMobileExperienceEnabled;
    const onCloseChangerSpotlight = (0, $5uXOq.useCallback)(()=>{
        if (!hasSeenGicPositioningSpotlight) {
            setAllowShowingChangerSpotlight(false);
            setUserPreferences(true);
        }
    }, [
        setAllowShowingChangerSpotlight,
        hasSeenGicPositioningSpotlight,
        setUserPreferences
    ]);
    const isModalView = minimizableModalView === 'modal';
    (0, $5uXOq.useEffect)(()=>{
        if (!isModalView && shouldShowChangerSpotlight) onCloseChangerSpotlight();
    }, [
        onCloseChangerSpotlight,
        isModalView,
        shouldShowChangerSpotlight
    ]);
    const onOpenSpotlight = ()=>{
        if (isModalView) setAllowShowingChangerSpotlight(true);
    };
    const onCloseSpotlight = ()=>{
        if (isModalView) onCloseChangerSpotlight();
    };
    return {
        shouldShowChangerSpotlight: shouldShowChangerSpotlight,
        onOpenSpotlight: onOpenSpotlight,
        onCloseSpotlight: onCloseSpotlight
    };
};

});
parcelRegister("9FXQH", function(module, exports) {

$parcel$export(module.exports, "useUserPreferences", () => $c1d22704a79507d0$export$b6472e0d8983f5f5);

var $5uXOq = parcelRequire("5uXOq");

var $561FV = parcelRequire("561FV");

var $6paOF = parcelRequire("6paOF");

var $eusud = parcelRequire("eusud");
const $c1d22704a79507d0$var$setGICUserPreferences = async (key, value)=>{
    try {
        await (0, $eusud.performPutRequest)(`/rest/api/3/mypreferences?key=${key}`, {
            body: JSON.stringify({
                value: value
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6paOF.fireIssueCreateErrorAnalytics)({
            meta: {
                id: 'getAPI3MyPreferences',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $c1d22704a79507d0$export$b6472e0d8983f5f5 = (key, fallbackState)=>{
    const [state, setState] = (0, $5uXOq.useState)(fallbackState);
    (0, $5uXOq.useEffect)(()=>{
        const run = async ()=>{
            try {
                const apiResult = await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${key}`);
                if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, $6paOF.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'getAPI3MyPreferences',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    return;
                }
                setState(apiResult.value);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error.statusCode === 404) // Error 404 is acceptable as the first time the key does not exist in the user profile.
                return;
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'getAPI3MyPreferences',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        run();
    }, [
        key
    ]);
    const setUserPreferences = (0, $5uXOq.useCallback)((value)=>{
        $c1d22704a79507d0$var$setGICUserPreferences(key, value);
        setState(value);
    }, [
        key
    ]);
    return [
        state,
        setUserPreferences
    ];
};

});


parcelRegister("6gjIc", function(module, exports) {

$parcel$export(module.exports, "useIsGICPositioningEnabled", () => $f471b5e0614291f9$export$a782e9359ada4cd3);

var $5uXOq = parcelRequire("5uXOq");

var $PpuOf = parcelRequire("PpuOf");
const $f471b5e0614291f9$export$a782e9359ada4cd3 = ()=>{
    const [{ disableGICPositioning: disableGICPositioning }] = (0, $PpuOf.useGICPositioningEnabledController)();
    const isGICPositioningEnabled = (0, $5uXOq.useCallback)(()=>!disableGICPositioning, [
        disableGICPositioning
    ]);
    return isGICPositioningEnabled;
};

});
parcelRegister("PpuOf", function(module, exports) {

$parcel$export(module.exports, "useGICPositioningEnabledController", () => $51f8f3ede3c201de$export$9cc1c859181a0ff4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $51f8f3ede3c201de$var$initialState = {
    disableGICPositioning: false
};
const $51f8f3ede3c201de$var$actions = {
    setDisableGICPositioning: (disableGICPositioning)=>({ setState: setState })=>{
            setState({
                disableGICPositioning: disableGICPositioning
            });
        }
};
const $51f8f3ede3c201de$var$Store = (0, $iXqE5.createStore)({
    initialState: $51f8f3ede3c201de$var$initialState,
    actions: $51f8f3ede3c201de$var$actions,
    name: 'GICPositioningEnabledController'
});
const $51f8f3ede3c201de$export$4bfa4009172d242 = (0, $gg7kZ.createContainer)($51f8f3ede3c201de$var$Store);
const $51f8f3ede3c201de$export$9cc1c859181a0ff4 = (0, $3sQ5x.createHook)($51f8f3ede3c201de$var$Store);

});


parcelRegister("hH1l8", function(module, exports) {

$parcel$export(module.exports, "useRequestTypeFieldsLayoutPreference", () => $37c1188b073578b5$export$7f6ea71dfb4ea52b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6ailZ = parcelRequire("6ailZ");

var $co3D8 = parcelRequire("co3D8");
const $37c1188b073578b5$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    data: (0, $co3D8.fallbackValue),
    isLoading: false
};
const $37c1188b073578b5$var$store = (0, $iXqE5.createStore)({
    name: 'RequestTypeFieldsLayoutUserPreference',
    initialState: $37c1188b073578b5$export$d4c72bab9d6cc13a,
    actions: $6ailZ.actions
});
const $37c1188b073578b5$export$7f6ea71dfb4ea52b = (0, $3sQ5x.createHook)($37c1188b073578b5$var$store);

});
parcelRegister("6ailZ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7fbb4dca8594e31d$export$e324594224ef24da);


var $89SaW = parcelRequire("89SaW");

var $6paOF = parcelRequire("6paOF");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $co3D8 = parcelRequire("co3D8");
const $7fbb4dca8594e31d$var$initialise = (accountId, createAnalyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (!state.isInitialised && accountId !== null) {
            setState({
                isLoading: true
            });
            await (0, $89SaW.getUserProperty)(accountId, (0, $co3D8.propertyKey)).then((value)=>{
                setState({
                    isInitialised: true,
                    data: value === (0, $co3D8.UserPreference).RequestFormFields,
                    isLoading: false
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
            }).catch((error)=>{
                if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) {
                    // user preference has not been set
                    setState({
                        isLoading: false,
                        data: (0, $co3D8.fallbackValue)
                    });
                    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
                } else {
                    setState({
                        isLoading: false
                    });
                    (0, $6paOF.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'getRequestTypesLayoutPreference',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            isClientFetchError: (0, $fZneA.isClientFetchError)(error)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    };
const $7fbb4dca8594e31d$var$setPreference = (accountId, isEnabled, createAnalyticsEvent, callback)=>async ({ setState: setState, getState: getState })=>{
        const { isLoading: isLoading, data: oldValue } = getState();
        if (accountId && !isLoading) {
            setState({
                data: isEnabled,
                isLoading: true
            });
            await (0, $89SaW.setUserProperties)(accountId, (0, $co3D8.propertyKey), JSON.stringify(isEnabled ? (0, $co3D8.UserPreference).RequestFormFields : (0, $co3D8.UserPreference).ScreenFields)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $jJZqs.default)(res.status, errResp);
                });
                setState({
                    data: isEnabled,
                    isLoading: false
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'setRequestTypesLayoutPreference succeeded', {
                    isEnabled: isEnabled
                });
                return callback();
            }).catch((error)=>{
                setState({
                    data: oldValue,
                    isLoading: false
                });
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'setRequestTypesLayoutPreference',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        isClientFetchError: (0, $fZneA.isClientFetchError)(error)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
    };
const $7fbb4dca8594e31d$export$e324594224ef24da = {
    setPreference: $7fbb4dca8594e31d$var$setPreference,
    initialise: $7fbb4dca8594e31d$var$initialise
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("co3D8", function(module, exports) {

$parcel$export(module.exports, "fallbackValue", () => $9d1eec5baf6d3384$export$91cd7f5c38b6ba2);
$parcel$export(module.exports, "propertyKey", () => $9d1eec5baf6d3384$export$52266bfa96e3a752);
$parcel$export(module.exports, "UserPreference", () => $9d1eec5baf6d3384$export$9eb786c5fec4a558);
const $9d1eec5baf6d3384$export$91cd7f5c38b6ba2 = true;
const $9d1eec5baf6d3384$export$52266bfa96e3a752 = 'gic-jsm-fields-layout-preference';
const $9d1eec5baf6d3384$export$9eb786c5fec4a558 = {
    ScreenFields: 'SCREEN_FIELDS',
    RequestFormFields: 'REQUEST_FORM_FIELDS'
};

});



parcelRegister("jP8gL", function(module, exports) {

$parcel$export(module.exports, "useFetchForgeModules", () => $31a99a356003c61f$export$36c81308105ff728);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $fn8B5 = parcelRequire("fn8B5");

var $cuHs1 = parcelRequire("cuHs1");

var $1UikQ = parcelRequire("1UikQ");

var $5cmSg = parcelRequire("5cmSg");

var $ld2hZ = parcelRequire("ld2hZ");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $1MlDe = parcelRequire("1MlDe");

var $9OXo1 = parcelRequire("9OXo1");

var $1rCdP = parcelRequire("1rCdP");

var $4R6GH = parcelRequire("4R6GH");
const $31a99a356003c61f$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(module);
const $31a99a356003c61f$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$31a99a356003c61f$var$moduleToVariableKey(key)), (0, $k2DRb.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $1MlDe.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $k2DRb.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $k2DRb.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if ((0, $5cmSg.isExtensionHiddenByAppAccessRules)(moduleItem)) accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $31a99a356003c61f$export$281dc5a8fd9afe5a = async (cloudId, isAnonymous, projectKey)=>{
    const extensionsData = await (0, $iVaKa.fetchModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous,
        context: {
            projectKey: projectKey
        },
        includeHidden: true,
        includeScopes: true,
        types: [
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.UI_MODIFICATIONS_MODULE)
        ],
        source: (0, $k2DRb.SOURCE_GLOBAL_ISSUE_CREATE)
    });
    const extensionsFlat = Object.values(extensionsData).flat();
    return $31a99a356003c61f$export$44097e02a91cd11a(extensionsFlat);
};
const $31a99a356003c61f$export$36c81308105ff728 = (extraContext = {})=>{
    const { cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const request = (0, $5uXOq.useCallback)(()=>{
        return $31a99a356003c61f$export$281dc5a8fd9afe5a(cloudId, isAnonymous, extraContext.projectKey);
    }, [
        cloudId,
        isAnonymous,
        extraContext.projectKey
    ]);
    const { data: data, error: error, fetch: fetch, loadingStatus: loadingStatus } = (0, $ld2hZ.useLoadingStatusService)(request, {
        loading: true
    });
    (0, $5uXOq.useEffect)(()=>{
        if (extraContext.projectKey) fetch();
    }, [
        fetch,
        extraContext.projectKey
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        const customFields = [];
        const issueAdjustmentModules = [];
        const filteredOutModules = [];
        const modules = data?.extensions;
        const accessNarrowedModules = data?.accessNarrowedExtensions;
        accessNarrowedModules?.jiraCustomField?.forEach((module)=>{
            filteredOutModules.push(module);
        });
        accessNarrowedModules?.jiraCustomFieldType?.forEach((module)=>{
            filteredOutModules.push(module);
        });
        modules?.jiraCustomField?.forEach((module)=>{
            if ((0, $5cmSg.isExtensionVisible)(module)) {
                if ((0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
                    const transformedModule = (0, $1rCdP.transformExtension)(module);
                    if (transformedModule) customFields.push(transformedModule);
                } else customFields.push(module);
            } else filteredOutModules.push(module);
        });
        modules?.jiraCustomFieldType?.forEach((module)=>{
            if ((0, $5cmSg.isExtensionVisible)(module)) {
                if ((0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
                    const transformedModule = (0, $1rCdP.transformExtension)(module);
                    if (transformedModule) customFields.push(transformedModule);
                } else customFields.push(module);
            } else filteredOutModules.push(module);
        });
        modules?.jiraUiModifications?.forEach((module)=>{
            if ((0, $5cmSg.isExtensionVisible)(module)) issueAdjustmentModules.push(module);
        });
        return {
            customFields: customFields,
            issueAdjustmentModules: issueAdjustmentModules,
            filteredOutModules: filteredOutModules,
            error: error,
            loadingStatus: loadingStatus
        };
    }, [
        data,
        loadingStatus,
        error
    ]);
};

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});

parcelRegister("cuHs1", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $0258ef72e36fbfcb$var$mapKeys;

});

parcelRegister("1MlDe", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $11a6461020d3329a$export$e0393e97f15a28a5);

var $lbWm4 = parcelRequire("lbWm4");

var $k2DRb = parcelRequire("k2DRb");
const $11a6461020d3329a$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $k2DRb.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("1rCdP", function(module, exports) {

$parcel$export(module.exports, "transformExtension", () => $6316f08792ee6c82$export$39ee489473821fbd);

var $gccSB = parcelRequire("gccSB");
function $6316f08792ee6c82$var$isCustomFieldSchemaNew(obj) {
    if (typeof obj === 'object' && obj !== null && 'properties' in obj && typeof obj.properties === 'object' && obj.properties !== null) return 'view' in obj.properties || 'edit' in obj.properties && typeof obj.properties.edit === 'object' && obj.properties.edit !== null && ('validation' in obj.properties.edit || 'experience' in obj.properties.edit);
    return false;
}
function $6316f08792ee6c82$export$39ee489473821fbd(extension) {
    if (!extension) return null;
    if ($6316f08792ee6c82$var$isCustomFieldSchemaNew(extension)) return extension;
    const { key: key, type: type, name: name, description: description, readOnly: readOnly, collection: collection, resourceUploadId: resourceUploadId, formatter: formatter, validation: validation, edit: edit, value: value, render: render, resource: resource, function: viewFunction } = extension.properties;
    let newEdit;
    if (edit) {
        if ('resource' in edit) {
            const { resource: editResource, render: editRender, isInline: isInline } = edit;
            newEdit = {
                resource: editResource,
                ...editRender && {
                    render: editRender
                },
                ...validation && {
                    validation: validation
                },
                ...isInline && {
                    isInline: isInline
                }
            };
            newEdit.experience = [
                'issue-create',
                'issue-view',
                'issue-transition'
            ];
        } else {
            const { function: editFunction } = edit;
            newEdit = {
                ...editFunction && {
                    function: editFunction
                },
                ...validation && {
                    validation: validation
                }
            };
        }
    } else newEdit = {
        ...validation && {
            validation: validation
        }
    };
    let newView;
    if (viewFunction) newView = {
        function: viewFunction,
        ...formatter && {
            formatter: formatter
        },
        ...value && {
            value: value
        }
    };
    else {
        newView = {
            ...formatter && {
                formatter: formatter
            },
            ...value && {
                value: value
            },
            ...render && {
                render: render
            },
            ...resource && {
                resource: resource
            }
        };
        if (newView.resource) newView.experience = [
            'issue-view'
        ];
    }
    const transformed = {
        key: key,
        type: type,
        name: name,
        description: description,
        ...resourceUploadId && {
            resourceUploadId: resourceUploadId
        },
        ...readOnly && {
            readOnly: readOnly
        },
        ...collection && {
            collection: collection
        },
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newEdit) && {
            edit: newEdit
        },
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newView) && {
            view: newView
        }
    };
    const newExtension = {
        ...extension,
        properties: transformed
    };
    return newExtension;
}

});


parcelRegister("a2K6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a130ca0c11e0b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $9OXo1 = parcelRequire("9OXo1");

var $gJDCO = parcelRequire("gJDCO");
const $55a130ca0c11e0b2$var$useFetchTransitionsService = ()=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const fetchTransitions = (0, $5uXOq.useCallback)(({ projectId: projectId, issueTypeId: issueTypeId, selectedCloudId: selectedCloudId })=>(0, $gJDCO.default)(selectedCloudId || cloudId, projectId, issueTypeId), [
        cloudId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(fetchTransitions);
    return [
        {
            isLoading: loading,
            error: error,
            transitions: data
        },
        fetch
    ];
};
var $55a130ca0c11e0b2$export$2e2bcd8739ae039 = $55a130ca0c11e0b2$var$useFetchTransitionsService;

});
parcelRegister("gJDCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b007914d7cd1ca$export$2e2bcd8739ae039);

var $6paOF = parcelRequire("6paOF");

var $eusud = parcelRequire("eusud");

var $1Nspv = parcelRequire("1Nspv");

var $eDfCU = parcelRequire("eDfCU");
const $51b007914d7cd1ca$var$constructEndpoint = (cloudId)=>`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`;
const $51b007914d7cd1ca$var$getTransitions = async (cloudId, projectId, issueTypeId)=>{
    const url = $51b007914d7cd1ca$var$constructEndpoint(cloudId);
    (0, $1Nspv.StatusFieldLoad).start();
    try {
        const resp = await (0, $eusud.performPostRequest)(url, {
            body: JSON.stringify({
                projectId: projectId,
                issueTypeId: issueTypeId
            })
        });
        (0, $1Nspv.StatusFieldLoad).success();
        return (0, $eDfCU.transformData)(resp);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $1Nspv.StatusFieldLoad).failure();
        (0, $6paOF.fireIssueCreateErrorAnalytics)({
            meta: {
                id: 'getTransitions',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var $51b007914d7cd1ca$export$2e2bcd8739ae039 = $51b007914d7cd1ca$var$getTransitions;

});
parcelRegister("eDfCU", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $fae18921f3745176$export$3ceb62baab058c6b);
const $fae18921f3745176$var$shouldReplace = (existing, replacement)=>!existing.isInitial && replacement.isInitial || existing.isDisabled === true && !replacement.isDisabled;
const $fae18921f3745176$export$3ceb62baab058c6b = (data)=>{
    const transitionMap = data.reduce((acc, val)=>{
        if (acc.has(val.to.id) && !$fae18921f3745176$var$shouldReplace(acc.get(val.to.id), val)) return acc;
        return acc.set(val.to.id, val);
    }, new Map());
    return Array.from(transitionMap.values());
};

});



parcelRegister("j3DvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e59cb64c763a10e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $a6nj3 = parcelRequire("a6nj3");

var $fWhMc = parcelRequire("fWhMc");

var $gdlF6 = parcelRequire("gdlF6");

var $bVBVj = parcelRequire("bVBVj");
const $0e59cb64c763a10e$var$useModalLoadQuery = (props)=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isSubTaskCreationOpen: isSubTaskCreationOpen = false, triggerIssueCreatePayload: triggerIssueCreatePayload, isModalLoadInContext: isModalLoadInContext = false, isCreateLinkedIssue: isCreateLinkedIssue } = props;
    const [{ isLoading: isLoading, fieldConfig: fieldConfigInitial, fieldTabs: fieldTabs, contextFields: contextFields, meta: meta, error: error, apiLatency: apiLatency, additionalServices: additionalServices }, fetchConfig] = (0, $fWhMc.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const fieldConfig = (0, $bVBVj.usePrefillCustomFields)(fieldConfigInitial);
    const [{ isLoading: isSubtaskLoading, fieldConfig: subtaskFieldConfig, fieldTabs: subtaskFieldTabs, contextFields: subtaskContextFields, meta: subtaskFieldsDataMeta, error: subtaskFieldsDataError, apiLatency: subtaskApiLatency, additionalServices: subtaskAdditionalServices }, fetchSubtaskConfig] = (0, $gdlF6.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const [{ isLoading: isLoadingInContext, fieldConfig: fieldConfigInContext, fieldTabs: fieldTabsInContext, contextFields: contextFieldsInContext, meta: fieldsDataMetaInContext, error: fieldsDataErrorInContext, apiLatency: apiLatencyInContext, additionalServices: additionalServicesInContext }, fetchConfigInContext] = (0, $a6nj3.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey,
        ...(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
            isCreateLinkedIssue: isCreateLinkedIssue
        } : {}
    });
    const parentId = triggerIssueCreatePayload?.parentId || null;
    const additionalContext = triggerIssueCreatePayload?.additionalContext || null;
    if (isModalLoadInContext && additionalContext) return [
        {
            isLoading: isLoadingInContext,
            fieldConfig: fieldConfigInContext,
            fieldTabs: fieldTabsInContext,
            contextFields: contextFieldsInContext,
            meta: fieldsDataMetaInContext,
            error: fieldsDataErrorInContext,
            apiLatency: apiLatencyInContext,
            additionalServices: additionalServicesInContext
        },
        fetchConfigInContext
    ];
    if (isSubTaskCreationOpen && parentId) return [
        {
            isLoading: isSubtaskLoading,
            fieldConfig: subtaskFieldConfig,
            fieldTabs: subtaskFieldTabs,
            contextFields: subtaskContextFields,
            meta: subtaskFieldsDataMeta,
            error: subtaskFieldsDataError,
            apiLatency: subtaskApiLatency,
            additionalServices: subtaskAdditionalServices
        },
        fetchSubtaskConfig
    ];
    return [
        {
            isLoading: isLoading,
            fieldConfig: fieldConfig,
            fieldTabs: fieldTabs,
            contextFields: contextFields,
            meta: meta,
            error: error,
            apiLatency: apiLatency,
            additionalServices: additionalServices
        },
        fetchConfig
    ];
};
var $0e59cb64c763a10e$export$2e2bcd8739ae039 = $0e59cb64c763a10e$var$useModalLoadQuery;

});
parcelRegister("a6nj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8978445b67cbea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $8j2Ud = parcelRequire("8j2Ud");

var $fcZ0a = parcelRequire("fcZ0a");

var $lr952 = parcelRequire("lr952");

var $iT5Ia = parcelRequire("iT5Ia");

var $aHg9F = parcelRequire("aHg9F");

var $aK8En = parcelRequire("aK8En");

var $3MuWj = parcelRequire("3MuWj");
const $ad8978445b67cbea$var$useFetchCreateConfigQueryInContext = (props = {})=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue = false } = props;
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [fetchError, setFetchError] = (0, $5uXOq.useState)(null);
    const apiStartTime = (0, $5uXOq.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $5uXOq.useState)(0);
    const [data, setData] = (0, $5uXOq.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $lr952.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const oldFetchConfig = (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? (0, $aHg9F.getCreateConfigUserPreferredQueryInContextCLI)(isCreateLinkedIssue) : (0, $aK8En.CREATE_CONFIG_USER_PREFERRED_QUERY_IN_CONTEXT);
    const createConfigQuery = (0, $4R6GH.fg)('new-issue-create-fetch-config-query') ? (0, $iT5Ia.getCreateConfigQuery)({
        isInContext: true,
        withML: withMachineLearning,
        isCreateLinkedIssue: isCreateLinkedIssue,
        isCreateLinkedIssueFromIssueViewFGOn: !!(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view'),
        isJsmRespondersFieldEnabled: (0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui')
    }) : (0, $3MuWj.getCreateConfigUserPreferredQueryInContext)(withMachineLearning, isCreateLinkedIssue);
    const [fetchConfigInContext] = (0, $5tTFS.useLazyQuery)((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? createConfigQuery : oldFetchConfig, {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $fcZ0a.transformQueryResults)((0, $fcZ0a.tranformModalLoadDataInContext)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchCreateConfigQueryInContext',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    // TODO: clean up after rollout of FG issue-create-fire-error-analytics-refactor
                    errorType: (0, $8j2Ud.handleApolloError)(error),
                    triggerPointKey: // TODO: look to get this into common hook and populate it everywhere.
                    triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const handleFetch = (0, $5uXOq.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchConfigInContext(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $ad8978445b67cbea$export$2e2bcd8739ae039 = $ad8978445b67cbea$var$useFetchCreateConfigQueryInContext;

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("8j2Ud", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $8edb28f7df5f6239$export$31b755cdc25616f2);
const $8edb28f7df5f6239$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});

parcelRegister("fcZ0a", function(module, exports) {

$parcel$export(module.exports, "transformQueryResults", () => $c9cbf8470d7adb43$export$142cac81f59c4a2b);
$parcel$export(module.exports, "transformQueryData", () => $c9cbf8470d7adb43$export$e87b478b11690bbe);
$parcel$export(module.exports, "tranformSubtaskData", () => $c9cbf8470d7adb43$export$2406de70fd65131a);
$parcel$export(module.exports, "tranformModalLoadDataInContext", () => $c9cbf8470d7adb43$export$6f0b5e0a42086cba);

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $bGrWH = parcelRequire("bGrWH");

var $3M1CO = parcelRequire("3M1CO");

var $5fc53 = parcelRequire("5fc53");

var $gItVn = parcelRequire("gItVn");


var $do1Fc = parcelRequire("do1Fc");

var $cpg5L = parcelRequire("cpg5L");

var $ckBKW = parcelRequire("ckBKW");
const $c9cbf8470d7adb43$var$getTabLayoutInfoOld = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    const fieldTabs = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateLayout.contentSection.items', []).map(({ id: id, name: name, items: items, tabId: tabId })=>{
        if (onlyRequiredField) {
            // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
            const filteredItems = items.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId));
            return filteredItems.length === 0 ? null : {
                id: id,
                name: name,
                items: filteredItems.map(// @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
                ({ fieldId: fieldId })=>fieldId),
                tabId: tabId
            };
        }
        return {
            id: id,
            name: name,
            items: items// @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
            .filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId))// @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
            .map(({ fieldId: fieldId })=>fieldId),
            tabId: tabId
        };
    }).filter(Boolean);
    return fieldTabs;
};
const $c9cbf8470d7adb43$var$getTabLayoutInfoNew = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldTabs = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateLayout.contentSection.items', []);
    return fieldTabs.map(({ id: id, name: name, items: items, collapsedItems: collapsedItems, tabId: tabId })=>{
        const filterItems = (itemsToFilter)=>itemsToFilter.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId)).map(({ fieldId: fieldId })=>fieldId);
        const filteredItems = filterItems(items || []);
        const filteredCollapsedItems = filterItems(collapsedItems || []);
        const result = {
            id: id,
            name: name,
            items: filteredItems,
            tabId: tabId
        };
        result.collapsedItems = filteredCollapsedItems;
        if (onlyRequiredField && result.items.length === 0 && result.collapsedItems.length === 0) return null;
        return result;
    }).filter((tab)=>!!tab);
};
const $c9cbf8470d7adb43$export$1da66c24c878ae7 = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return $c9cbf8470d7adb43$var$getTabLayoutInfoNew({
        data: data,
        onlyRequiredField: onlyRequiredField,
        allFieldIds: allFieldIds
    });
    return $c9cbf8470d7adb43$var$getTabLayoutInfoOld({
        data: data,
        onlyRequiredField: onlyRequiredField,
        allFieldIds: allFieldIds
    });
};
const $c9cbf8470d7adb43$export$da99f019bcffa6fb = (timeTrackingSettings)=>{
    if (timeTrackingSettings) {
        const { defaultFormat: defaultFormat, workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultUnit: defaultUnit, isJiraConfiguredTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled } = timeTrackingSettings;
        let format = '';
        if (defaultFormat === 'DAYS') format = 'days';
        else if (defaultFormat === 'HOURS') format = 'hours';
        else format = 'pretty';
        let unit = '';
        if (defaultUnit === 'DAY') unit = 'day';
        else if (defaultUnit === 'HOUR') unit = 'hour';
        else if (defaultUnit === 'MINUTE') unit = 'minute';
        else unit = 'week';
        return {
            daysPerWeek: workingDaysPerWeek,
            hoursPerDay: workingHoursPerDay,
            format: // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Format | undefined'.
            format,
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'DefaultUnit'.
            defaultUnit: unit,
            isTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled
        };
    }
    return undefined;
};
const $c9cbf8470d7adb43$export$603097abf044854 = (data, onlyRequiredField = false)=>{
    const fields = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.fields.nodes', []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const contextFields = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfigData = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requiredFieldConfigData = {};
    let isRequiredFieldComponentSupported = true;
    let gqlTypeBeingProcessed;
    fields.forEach((fieldData)=>{
        try {
            const { __typename: gqlType, fieldId: fieldId, name: name, type: type, description: description, fieldConfig: fieldConfig = {}, searchUrl: searchUrl, mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig, isMulti: isMulti, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch, timeTrackingSettings: timeTrackingSettings, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize } = fieldData;
            gqlTypeBeingProcessed = gqlType;
            if (fieldId && !(0, $bGrWH.UNSUPPORTED_FIELD_TYPES_IN_GIC).includes(type)) {
                if ((0, $gItVn.CONTEXT_FIELD_TYPES).includes(gqlType) && type !== (0, $5fc53.PROJECT_PICKER_CF_TYPE)) {
                    let transformedData;
                    if (gqlType === (0, $962656cd6986cb06$export$aa5680ad8f8be9fc)) {
                        transformedData = (0, $do1Fc.transformProjectField)(fieldData);
                        contextFields[fieldId] = transformedData;
                    }
                    if (gqlType === (0, $962656cd6986cb06$export$2d5a62a3515ad4c6)) {
                        transformedData = (0, $do1Fc.transformIssueTypeField)(fieldData);
                        contextFields[fieldId] = transformedData;
                    }
                    if (gqlType === (0, $962656cd6986cb06$export$a12a4b25ab12710c)) {
                        const requestTypeFieldData = fieldData;
                        // @ts-expect-error - TS2339 Property 'requestType' does not exist on type 'never'.
                        if (requestTypeFieldData?.requestType?.issueType) // @ts-expect-error - TS2339 Property 'requestType' does not exist on type 'never'.
                        requestTypeFieldData.requestType.issueType.issueTypeName = contextFields?.issuetype?.selectedIssueType?.label;
                        transformedData = (0, $do1Fc.transformRequestTypeField)(requestTypeFieldData);
                        contextFields.requestType = transformedData;
                    }
                } else {
                    const gqlTypeWithOverride = (0, $ckBKW.overrideGqlTypes)(fieldData);
                    const gqlFieldConfig = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
                    (0, $gItVn.getGqlFieldMap)()[gqlTypeWithOverride] || {};
                    const { defaultValueKey: defaultValueKey, allowedValuesKey: allowedValuesKey } = gqlFieldConfig;
                    let defaultValue;
                    if (Array.isArray(defaultValueKey)) defaultValue = defaultValueKey.map((key)=>key && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldData, key, undefined));
                    else defaultValue = defaultValueKey && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldData, defaultValueKey, undefined);
                    const allowedValues = allowedValuesKey && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldData, allowedValuesKey, undefined);
                    // @ts-expect-error - TS2339 Property 'isRequired' does not exist on type '{}'.
                    const isRequired = fieldConfig?.isRequired || false;
                    // @ts-expect-error - TS2339 Property 'isEditable' does not exist on type '{}'.
                    const isEditable = fieldConfig?.isEditable;
                    // @ts-expect-error - TS2339 Property 'nonEditableReason' does not exist on type '{}'.
                    const nonEditableReason = fieldConfig?.nonEditableReason || {};
                    const copyLinksAndAttachments = gqlTypeWithOverride === (0, $962656cd6986cb06$export$47af4d6f62c134cf) && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? fieldData?.copyLinksAndAttachments : undefined;
                    fieldConfigData[fieldId] = {
                        gqlType: gqlTypeWithOverride,
                        fieldId: fieldId,
                        fieldName: name,
                        fieldType: type,
                        description: description,
                        isRequired: isRequired,
                        isEditable: isEditable,
                        nonEditableReason: nonEditableReason,
                        autoCompleteUrl: (0, $3M1CO.transformStargateUrl)(searchUrl || ''),
                        defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(defaultValue) ? undefined : defaultValue,
                        allowedValues: allowedValues,
                        additionalData: {
                            mediaContext: mediaContext,
                            isMulti: isMulti,
                            attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch,
                            timeTrackingSettings: $c9cbf8470d7adb43$export$da99f019bcffa6fb(timeTrackingSettings),
                            maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
                            ...(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                                copyLinksAndAttachments: copyLinksAndAttachments
                            } : {}
                        }
                    };
                    if (adminRichTextConfig) fieldConfigData[fieldId].additionalData.adminRichTextConfig = adminRichTextConfig;
                    if (onlyRequiredField && isRequired) requiredFieldConfigData[fieldId] = fieldConfigData[fieldId];
                    if (isRequired && !('Component' in gqlFieldConfig)) isRequiredFieldComponentSupported = false;
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'processingApiFieldData',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    error: `processing ${gqlTypeBeingProcessed} failed`
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    // process fields which are not supported in graphql layer
    const errors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.errors', []);
    const { unsupportedFields: unsupportedFields, isRequiredFieldTypeSupported: isRequiredFieldTypeSupported } = (0, $cpg5L.getGqlUnsupportedFields)(errors);
    return {
        fieldConfig: onlyRequiredField ? {
            ...requiredFieldConfigData
        } : {
            ...fieldConfigData,
            ...unsupportedFields
        },
        contextFields: contextFields,
        meta: {
            areRequiredFieldsSupported: isRequiredFieldTypeSupported && isRequiredFieldComponentSupported
        }
    };
};
const $c9cbf8470d7adb43$export$5fe007c334fc070a = (data)=>{
    const nodes = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateAdditionalServices.services.edges', []);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const services = {};
    nodes.forEach(({ node: node })=>{
        services[node.serviceId] = node;
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return services;
};
const $c9cbf8470d7adb43$export$142cac81f59c4a2b = (data, onlyRequiredField = false)=>{
    const fieldKeyedById = $c9cbf8470d7adb43$export$603097abf044854(data, onlyRequiredField);
    const { watchers: watchers, proforma: proforma } = $c9cbf8470d7adb43$export$5fe007c334fc070a(data);
    const result = {
        fieldTabs: $c9cbf8470d7adb43$export$1da66c24c878ae7({
            data: data,
            onlyRequiredField: onlyRequiredField,
            allFieldIds: Object.keys(fieldKeyedById.fieldConfig)
        }),
        ...fieldKeyedById,
        meta: {
            ...fieldKeyedById.meta,
            queryErrorMessage: (0, $cpg5L.getQueryErrorMessage)(data)
        },
        additionalServices: {
            watchersConfigurations: watchers?.permissions,
            proformaConfiguration: proforma?.proforma
        }
    };
    return $c9cbf8470d7adb43$var$validateRequiredFieldsFromTransformQueryResults(result);
};
const $c9cbf8470d7adb43$var$validateRequiredFieldsFromTransformQueryResults = (result)=>{
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig } = result;
    const newFieldTabs = fieldTabs.map((tab)=>{
        if (!tab.collapsedItems) return tab;
        const collapsedItems = tab.collapsedItems.filter((fieldId)=>{
            const field = fieldConfig[fieldId];
            if (field?.isRequired || fieldId === 'summary') return false;
            return true;
        });
        return {
            ...tab,
            collapsedItems: collapsedItems
        };
    });
    return {
        ...result,
        fieldTabs: newFieldTabs
    };
};
const $c9cbf8470d7adb43$export$e87b478b11690bbe = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFields
        },
        ...data.jiraIssueCreateAdditionalServices ? {
            jiraIssueCreateAdditionalServices: {
                ...data.jiraIssueCreateAdditionalServices
            }
        } : {},
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraIssueCreateLayoutWithML
        } : {
            ...data.jiraIssueCreateLayout
        }
    });
const $c9cbf8470d7adb43$var$tranformSubtaskDataOld = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraSubtaskCreationFields
        },
        jiraIssueCreateLayout: {
            ...data.jiraSubtaskCreationLayout
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraSubtaskCreationAdditionalServices
        }
    });
const $c9cbf8470d7adb43$var$tranformSubtaskDataNew = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraSubtaskCreationFields
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraSubtaskCreationAdditionalServices
        },
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraSubtaskCreationLayoutWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraSubtaskCreationLayoutWithML
        } : {
            ...data.jiraSubtaskCreationLayout
        }
    });
const $c9cbf8470d7adb43$export$2406de70fd65131a = (data)=>{
    if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return $c9cbf8470d7adb43$var$tranformSubtaskDataNew(data);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $c9cbf8470d7adb43$var$tranformSubtaskDataOld(data);
};
const $c9cbf8470d7adb43$export$3882cbedc41c0e0a = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFieldsInContext
        },
        jiraIssueCreateLayout: {
            ...data.jiraIssueCreateLayoutInContext
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraIssueCreateAdditionalServices
        }
    });
const $c9cbf8470d7adb43$export$9fb58334c8cb6162 = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFieldsInContext
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraIssueCreateAdditionalServices
        },
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutInContextWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraIssueCreateLayoutInContextWithML
        } : {
            ...data.jiraIssueCreateLayoutInContext
        }
    });
const $c9cbf8470d7adb43$export$6f0b5e0a42086cba = (data)=>{
    if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return $c9cbf8470d7adb43$export$9fb58334c8cb6162(data);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $c9cbf8470d7adb43$export$3882cbedc41c0e0a(data);
};

});
parcelRegister("gItVn", function(module, exports) {

$parcel$export(module.exports, "getGqlFieldMap", () => $e9926c7a0c5999db$export$472717ed4aec82f1);
$parcel$export(module.exports, "UPDATE_FIELDS_CREATE_LINKED_ISSUE", () => $e9926c7a0c5999db$export$aed6a8ebeb442f9);
$parcel$export(module.exports, "UPDATE_FIELDS", () => $e9926c7a0c5999db$export$e7c3e130e221f1f1);
$parcel$export(module.exports, "CONTEXT_FIELD_TYPES", () => $e9926c7a0c5999db$export$ccf7c75b07963f11);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");

var $5kDIl = parcelRequire("5kDIl");

var $b6sRp = parcelRequire("b6sRp");

var $ii6hB = parcelRequire("ii6hB");

var $aZJYe = parcelRequire("aZJYe");

var $iZNZ0 = parcelRequire("iZNZ0");

var $id3OI = parcelRequire("id3OI");

var $5FwUN = parcelRequire("5FwUN");

var $5rYSU = parcelRequire("5rYSU");

var $4kXb0 = parcelRequire("4kXb0");

var $icXkU = parcelRequire("icXkU");

var $bWtQ8 = parcelRequire("bWtQ8");

var $gbo8w = parcelRequire("gbo8w");

var $j0pqC = parcelRequire("j0pqC");

var $hy8Vj = parcelRequire("hy8Vj");

var $bN8Bv = parcelRequire("bN8Bv");

var $htVqS = parcelRequire("htVqS");

var $1bQJO = parcelRequire("1bQJO");

var $ilY3g = parcelRequire("ilY3g");

var $cUXq3 = parcelRequire("cUXq3");

var $776me = parcelRequire("776me");

var $6vh1Z = parcelRequire("6vh1Z");

var $iPfC3 = parcelRequire("iPfC3");

var $9K1c2 = parcelRequire("9K1c2");

var $2p4Te = parcelRequire("2p4Te");

var $iY8FG = parcelRequire("iY8FG");

var $cnfHu = parcelRequire("cnfHu");

var $fpis9 = parcelRequire("fpis9");

var $kEFc7 = parcelRequire("kEFc7");

var $kRBrp = parcelRequire("kRBrp");

var $2cChB = parcelRequire("2cChB");

var $h2h4F = parcelRequire("h2h4F");

var $8GQyc = parcelRequire("8GQyc");

var $evGBv = parcelRequire("evGBv");

var $9sq52 = parcelRequire("9sq52");

var $kdeLq = parcelRequire("kdeLq");

var $5sz86 = parcelRequire("5sz86");

var $1IlAr = parcelRequire("1IlAr");

var $g2djo = parcelRequire("g2djo");

var $eX2Td = parcelRequire("eX2Td");

var $gARR3 = parcelRequire("gARR3");

var $k5vQX = parcelRequire("k5vQX");

var $34EcD = parcelRequire("34EcD");

var $bo14T = parcelRequire("bo14T");

var $kU4qk = parcelRequire("kU4qk");

var $4oT51 = parcelRequire("4oT51");

var $jI6Lk = parcelRequire("jI6Lk");

var $8mBES = parcelRequire("8mBES");

var $eulr6 = parcelRequire("eulr6");

var $6GeOm = parcelRequire("6GeOm");

var $bNgRv = parcelRequire("bNgRv");

var $2QZDj = parcelRequire("2QZDj");

var $hnBts = parcelRequire("hnBts");

var $lomXS = parcelRequire("lomXS");

var $eWiSP = parcelRequire("eWiSP");

var $3mcIX = parcelRequire("3mcIX");

var $cOF52 = parcelRequire("cOF52");

var $5w5Vs = parcelRequire("5w5Vs");

var $aPEdI = parcelRequire("aPEdI");

var $7gcm4 = parcelRequire("7gcm4");

var $7Pdzq = parcelRequire("7Pdzq");

var $3Z98Z = parcelRequire("3Z98Z");

var $d8h6M = parcelRequire("d8h6M");

var $k4tyx = parcelRequire("k4tyx");

var $6HBPo = parcelRequire("6HBPo");

var $lfWSN = parcelRequire("lfWSN");

var $aQNfA = parcelRequire("aQNfA");

var $1AaWN = parcelRequire("1AaWN");

var $3pqs3 = parcelRequire("3pqs3");

var $aqMtW = parcelRequire("aqMtW");

var $7nQJF = parcelRequire("7nQJF");

var $bB4xD = parcelRequire("bB4xD");

var $9cNbb = parcelRequire("9cNbb");

var $7svvp = parcelRequire("7svvp");

var $b3x8f = parcelRequire("b3x8f");

var $d2fRu = parcelRequire("d2fRu");

var $iHPnC = parcelRequire("iHPnC");

var $2ngL6 = parcelRequire("2ngL6");

var $em1U0 = parcelRequire("em1U0");

var $exGcw = parcelRequire("exGcw");

var $6Fkzt = parcelRequire("6Fkzt");

var $jv74C = parcelRequire("jv74C");

var $feVbn = parcelRequire("feVbn");

var $arYvt = parcelRequire("arYvt");

var $6FMjJ = parcelRequire("6FMjJ");

var $2QTbq = parcelRequire("2QTbq");

var $UwVOJ = parcelRequire("UwVOJ");

var $deSKa = parcelRequire("deSKa");

var $iVcsU = parcelRequire("iVcsU");

var $4IxfP = parcelRequire("4IxfP");

var $1D0eh = parcelRequire("1D0eh");

var $8TLRF = parcelRequire("8TLRF");

var $66d24 = parcelRequire("66d24");

var $5pYli = parcelRequire("5pYli");

var $5pHXe = parcelRequire("5pHXe");

var $249dD = parcelRequire("249dD");

var $1K3Xb = parcelRequire("1K3Xb");

var $dTQPF = parcelRequire("dTQPF");

var $5fc53 = parcelRequire("5fc53");

var $162ej = parcelRequire("162ej");

var $aPcig = parcelRequire("aPcig");

var $4nSAG = parcelRequire("4nSAG");

var $57aXd = parcelRequire("57aXd");

var $7jsR9 = parcelRequire("7jsR9");

var $4vfKb = parcelRequire("4vfKb");

var $h0fZ7 = parcelRequire("h0fZ7");

var $qzRgG = parcelRequire("qzRgG");

var $aeHT9 = parcelRequire("aeHT9");

var $hPJET = parcelRequire("hPJET");

var $3gK8l = parcelRequire("3gK8l");

var $kpa4m = parcelRequire("kpa4m");

var $f1o4d = parcelRequire("f1o4d");

var $cf9Hx = parcelRequire("cf9Hx");

var $gsevN = parcelRequire("gsevN");

const $e9926c7a0c5999db$var$createFieldMapItems = ()=>({
        [(0, $962656cd6986cb06$export$5e56d79dfe9be3d)]: {
            Component: (0, $ii6hB.default),
            defaultValueKey: 'selectedAffectedServices',
            submitTransform: (0, $2ngL6.mapOptionsToServiceEntities),
            retainUserInputTransform: (0, $aZJYe.mutateAffectedServicesField)
        },
        [(0, $962656cd6986cb06$export$23ca38ad884e35f1)]: {
            Component: (0, $7nQJF.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $bB4xD.mutateTextField)
        },
        [(0, $962656cd6986cb06$export$7e5590c7c7a403c0)]: {
            Component: (0, $7nQJF.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $bB4xD.mutateTextField)
        },
        [(0, $962656cd6986cb06$export$8643f0b9cefed538)]: {
            Component: (0, $7nQJF.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $bB4xD.mutateTextField)
        },
        [(0, $962656cd6986cb06$export$31a6c27df1f927b2)]: {
            Component: (0, $4vfKb.default),
            defaultValueKey: 'richText.adfValue.json',
            submitTransform: (0, $h0fZ7.sanitizeADFField),
            retainUserInputTransform: (0, $h0fZ7.mutateADFField)
        },
        [(0, $962656cd6986cb06$export$30b2c2de5e3007a4)]: {
            Component: (0, $776me.default),
            defaultValueKey: 'selectedComponents',
            allowedValuesKey: 'components.nodes',
            submitTransform: (0, $6Fkzt.mapOptionsToData),
            retainUserInputTransform: (0, $6vh1Z.mutateComponentsField)
        },
        [(0, $962656cd6986cb06$export$f10e53e8928b61bd)]: {
            Component: (0, $2p4Te.default),
            defaultValueKey: [
                'classificationLevel',
                'defaultClassificationLevel'
            ],
            allowedValuesKey: 'classificationLevels.edges'
        },
        [(0, $962656cd6986cb06$export$3849bb04b4eee607)]: {
            Component: (0, $lfWSN.default),
            defaultValueKey: 'user',
            submitTransform: (0, $5kDIl.mapUserOptionsToIds),
            retainUserInputTransform: (0, $5kDIl.mutateSingleUserPicker)
        },
        [(0, $962656cd6986cb06$export$745c8245fea49a34)]: {
            Component: (0, $lfWSN.default),
            defaultValueKey: 'user',
            submitTransform: (0, $5kDIl.mapUserOptionsToAccountIds),
            retainUserInputTransform: (0, $5kDIl.mutateSingleUserPicker)
        },
        [(0, $962656cd6986cb06$export$eca94ae30cb92d8)]: {
            Component: (0, $gARR3.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $5kDIl.mapUserOptionsToIds),
            retainUserInputTransform: (0, $5kDIl.mutateMultiUserPicker)
        },
        [(0, $962656cd6986cb06$export$d41ae99ff05f5cda)]: {
            Component: (0, $gARR3.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $5kDIl.mapUserOptionsToIds),
            retainUserInputTransform: (0, $5kDIl.mutateMultiUserPicker)
        },
        [(0, $962656cd6986cb06$export$bbc6b85844b0ade5)]: {
            Component: (0, $gARR3.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $5kDIl.mapUserOptionsToAccountIds),
            retainUserInputTransform: (0, $5kDIl.mutateMultiUserPicker)
        },
        [(0, $962656cd6986cb06$export$2bb9d057bad89bfa)]: {
            Component: (0, $6GeOm.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bNgRv.mapUserOptionOrOptionsToIds),
            retainUserInputTransform: (0, $bNgRv.mutatePeopleField)
        },
        [(0, $962656cd6986cb06$export$b1ac879bb5cdf30a)]: {
            Component: (0, $6GeOm.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bNgRv.mapUserOptionOrOptionsToIds),
            retainUserInputTransform: (0, $bNgRv.mutatePeopleField)
        },
        [(0, $962656cd6986cb06$export$e4d5e04bc56680dc)]: {
            Component: (0, $bo14T.default),
            defaultValueKey: 'number',
            submitTransform: (0, $kU4qk.transformAsNumber),
            retainUserInputTransform: (0, $kU4qk.mutateNumberField)
        },
        [(0, $962656cd6986cb06$export$d854193d90dc547d)]: {
            Component: (0, $bo14T.default),
            defaultValueKey: 'number',
            submitTransform: (0, $kU4qk.transformAsNumber),
            retainUserInputTransform: (0, $kU4qk.mutateNumberField)
        },
        [(0, $962656cd6986cb06$export$e0ece81bd398c799)]: {
            Component: (0, $bo14T.default),
            defaultValueKey: 'number',
            submitTransform: (0, $kU4qk.transformAsNumber),
            retainUserInputTransform: (0, $kU4qk.mutateNumberField)
        },
        [(0, $962656cd6986cb06$export$d8312cdfa02c100d)]: {
            Component: (0, $fpis9.default),
            defaultValueKey: 'dateTime',
            submitTransform: (0, $cnfHu.transformDate),
            retainUserInputTransform: (0, $kEFc7.mutateDateTimeField)
        },
        [(0, $962656cd6986cb06$export$70ff025076e5fb13)]: {
            Component: (0, $fpis9.default),
            defaultValueKey: 'dateTime',
            submitTransform: (0, $cnfHu.transformDate),
            retainUserInputTransform: (0, $kEFc7.mutateDateTimeField)
        },
        [(0, $962656cd6986cb06$export$8723b724f0b3ac65)]: {
            Component: (0, $qzRgG.EpicLinkField),
            defaultValueKey: 'epic',
            submitTransform: (0, $feVbn.mapEpicLinkOptionToData),
            retainUserInputTransform: (0, $kRBrp.mutateEpicLinkField)
        },
        [(0, $962656cd6986cb06$export$64c7789e86344de5)]: {
            Component: (0, $8GQyc.default),
            defaultValueKey: 'selectedLabels',
            submitTransform: (0, $2QTbq.mapLabelOptionsToData),
            retainUserInputTransform: (0, $evGBv.mutateLabelsFields)
        },
        [(0, $962656cd6986cb06$export$f596336c24b128f5)]: {
            Component: (0, $8GQyc.ForgeLabelsField),
            defaultValueKey: 'selectedLabels',
            submitTransform: (0, $2QTbq.mapLabelOptionsToData),
            retainUserInputTransform: (0, $evGBv.mutateLabelsFields)
        },
        [(0, $962656cd6986cb06$export$3e8dded8d83b5d95)]: {
            Component: (0, $iZNZ0.default),
            defaultValueKey: 'selectedAssets',
            submitTransform: (0, $id3OI.mapAssetOptionsToAssetEntity),
            retainUserInputTransform: (0, $id3OI.mutateAssetsFields)
        },
        [(0, $962656cd6986cb06$export$f4f101295d5cc151)]: {
            Component: (0, $aQNfA.default),
            defaultValueKey: 'version',
            allowedValuesKey: 'versions.nodes',
            submitTransform: (0, $dTQPF.getVersionId),
            retainUserInputTransform: (0, $1AaWN.mutateSingleVersionField)
        },
        [(0, $962656cd6986cb06$export$5bb498d4f2f54799)]: {
            Component: (0, $k5vQX.default),
            defaultValueKey: 'selectedVersions',
            allowedValuesKey: 'versions.nodes',
            submitTransform: (0, $dTQPF.getVersionsIds),
            retainUserInputTransform: (0, $34EcD.mutateMultiVersionsField)
        },
        [(0, $962656cd6986cb06$export$de14210faa5f2099)]: {
            Component: (0, $2QZDj.default),
            defaultValueKey: 'priority',
            allowedValuesKey: 'priorities.nodes',
            submitTransform: (0, $4IxfP.mapOptionToData),
            retainUserInputTransform: (0, $hnBts.mutatePriorityField)
        },
        [(0, $962656cd6986cb06$export$e0b268941120d761)]: {
            Component: (0, $iY8FG.default),
            defaultValueKey: 'date',
            submitTransform: (0, $cnfHu.transformDate),
            retainUserInputTransform: (0, $cnfHu.mutateDateField)
        },
        [(0, $962656cd6986cb06$export$111f32c51678063a)]: {
            Component: (0, $iY8FG.default),
            defaultValueKey: 'date',
            submitTransform: (0, $cnfHu.transformDate),
            retainUserInputTransform: (0, $cnfHu.mutateDateField)
        },
        [(0, $962656cd6986cb06$export$909ba97f4a791588)]: {
            Component: (0, $kpa4m.default),
            defaultValueKey: 'securityLevel',
            allowedValuesKey: 'securityLevels.nodes',
            submitTransform: (0, $f1o4d.transformOnSubmit),
            retainUserInputTransform: (0, $f1o4d.mutateSecurityLevelField)
        },
        [(0, $962656cd6986cb06$export$76d811609080a7aa)]: {
            Component: (0, $aeHT9.default),
            defaultValueKey: 'selectedRoles',
            submitTransform: (0, $5pYli.mapRoleToRestrictionValue)
        },
        [(0, $962656cd6986cb06$export$f2b56433dc0af401)]: {
            Component: (0, $b3x8f.default),
            defaultValueKey: 'url',
            retainUserInputTransform: (0, $d2fRu.mutateUrlField)
        },
        [(0, $962656cd6986cb06$export$fb8861017089d392)]: {
            Component: (0, $k4tyx.default),
            defaultValueKey: 'fieldOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $5pHXe.mapSelectOptionsToData),
            retainUserInputTransform: (0, $6HBPo.mutateSingleSelectField)
        },
        [(0, $962656cd6986cb06$export$985c14eb8f3f0309)]: {
            Component: (0, $k4tyx.default),
            defaultValueKey: 'fieldOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $6HBPo.mapSelectOptionsToConnectData),
            retainUserInputTransform: (0, $6HBPo.mutateSingleSelectField)
        },
        [(0, $962656cd6986cb06$export$2055419ff013de79)]: {
            Component: (0, $g2djo.default),
            defaultValueKey: 'selectedFieldOptions',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $5pHXe.mapMultiSelectOptionsToData),
            retainUserInputTransform: (0, $eX2Td.mutateMultiSelectField)
        },
        [(0, $962656cd6986cb06$export$9f6f73ea02649f83)]: {
            Component: (0, $g2djo.default),
            defaultValueKey: 'selectedFieldOptions',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $eX2Td.mapMultiSelectOptionsToConnectData),
            retainUserInputTransform: (0, $eX2Td.mutateMultiSelectField)
        },
        [(0, $962656cd6986cb06$export$16fe78a07e97f2ad)]: {
            Component: (0, $3Z98Z.default),
            defaultValueKey: 'selectedGroup',
            submitTransform: (0, $arYvt.transformGroupToName),
            retainUserInputTransform: (0, $d8h6M.mutateSingleGroupPickerField)
        },
        [(0, $962656cd6986cb06$export$fd24d37af44fe736)]: {
            Component: (0, $3Z98Z.default),
            defaultValueKey: 'selectedGroup',
            submitTransform: (0, $arYvt.transformGroupToName),
            retainUserInputTransform: (0, $d8h6M.mutateSingleGroupPickerField)
        },
        [(0, $962656cd6986cb06$export$3a1ae3e0f2d9b1b9)]: {
            Component: (0, $5sz86.default),
            defaultValueKey: 'selectedGroups',
            submitTransform: (0, $arYvt.transformGroupsToNames),
            retainUserInputTransform: (0, $1IlAr.mutateMultipleGroupPickerField)
        },
        [(0, $962656cd6986cb06$export$3027db6317a2a8ea)]: {
            Component: (0, $5sz86.default),
            defaultValueKey: 'selectedGroups',
            submitTransform: (0, $arYvt.transformGroupsToNames),
            retainUserInputTransform: (0, $1IlAr.mutateMultipleGroupPickerField)
        },
        [(0, $962656cd6986cb06$export$64238d76a1dc0703)]: {
            Component: (0, $3pqs3.default),
            defaultValueKey: 'selectedSprints',
            submitTransform: (0, $249dD.mapSprintOptionToData),
            retainUserInputTransform: (0, $aqMtW.mutateJiraSprintField)
        },
        [(0, $962656cd6986cb06$export$47af4d6f62c134cf)]: {
            Component: (0, $2cChB.default),
            submitTransform: (0, $6FMjJ.mapOptionsToData),
            defaultValueKey: 'issueLinks',
            allowedValuesKey: 'issueLinkTypeRelations.nodes',
            retainUserInputTransform: (0, $h2h4F.mutateIssueLinksField)
        },
        [(0, $962656cd6986cb06$export$1070aada56fcaec9)]: {
            Component: (0, $ilY3g.default),
            defaultValueKey: 'color.colorKey',
            submitTransform: (0, $iHPnC.asServerColor),
            retainUserInputTransform: (0, $cUXq3.mutateIssueColorField)
        },
        [(0, $962656cd6986cb06$export$f57941b9c1949a82)]: {
            Component: (0, $ilY3g.default),
            defaultValueKey: 'color.colorKey',
            submitTransform: (0, $iHPnC.asClassicEpicColor),
            retainUserInputTransform: (0, $cUXq3.mutateEpicColorField)
        },
        [(0, $962656cd6986cb06$export$95433ac963f4aebe)]: {
            Component: (0, $9cNbb.default),
            defaultValueKey: 'richText.plainText',
            submitTransform: (0, $1K3Xb.convertTextToAdf),
            retainUserInputTransform: (0, $7svvp.mutateTextAreaField)
        },
        [(0, $962656cd6986cb06$export$67aca33725b6a717)]: {
            Component: (0, $9cNbb.default),
            defaultValueKey: 'object',
            submitTransform: (0, $b6sRp.transformJSONStringToObject),
            retainUserInputTransform: (0, $7svvp.mutateTextAreaField)
        },
        [(0, $962656cd6986cb06$export$f7a08bf17a7ac661)]: {
            Component: (0, $5FwUN.default),
            defaultValueKey: 'user',
            submitTransform: (0, $5rYSU.mapUserToAssigneeValue),
            retainUserInputTransform: (0, $5rYSU.mutateAssigneeUserPicker)
        },
        [(0, $962656cd6986cb06$export$d64150fd9c66969c)]: {
            Component: (0, $cOF52.default),
            defaultValueKey: 'user',
            submitTransform: (0, $5kDIl.mapUserOptionsToIds),
            retainUserInputTransform: (0, $5kDIl.mutateSingleUserPicker)
        },
        [(0, $962656cd6986cb06$export$252fb981af0e2e4e)]: {
            Component: (0, $5w5Vs.default),
            defaultValueKey: 'resolution',
            allowedValuesKey: 'resolutions.nodes',
            submitTransform: (0, $66d24.mapOptionToResolutionOption),
            retainUserInputTransform: (0, $aPEdI.mutateResolutionField)
        },
        [(0, $962656cd6986cb06$export$a9b3195cbef5c5ad)]: {
            Component: (0, $7jsR9.default),
            submitTransform: (0, $bWtQ8.getFileIdsFromFiles)
        },
        [(0, $962656cd6986cb06$export$a36509fae9e84682)]: {
            Component: (0, $gbo8w.default),
            defaultValueKey: 'cascadingOption',
            allowedValuesKey: 'cascadingOptions.nodes',
            submitTransform: (0, $em1U0.transformToServerValue),
            retainUserInputTransform: (0, $j0pqC.mutateCascadingSelectField)
        },
        [(0, $962656cd6986cb06$export$79443fedd031b437)]: {
            Component: (0, $iPfC3.default),
            defaultValueKey: 'selectedTeam',
            submitTransform: (0, $jv74C.transformTeamFieldTypeString),
            retainUserInputTransform: (0, $9K1c2.mutateTeamField)
        },
        [(0, $962656cd6986cb06$export$1c7f7cfd2029442f)]: {
            Component: (0, $4kXb0.default),
            defaultValueKey: 'JiraAtlassianTeamField',
            submitTransform: (0, $icXkU.transformAtlassianTeamFieldTypeString),
            retainUserInputTransform: (0, $icXkU.mutateAtlassianTeamField)
        },
        [(0, $962656cd6986cb06$export$597fa240de2bfd92)]: {
            Component: (0, $htVqS.default),
            defaultValueKey: 'selectedCmdbObjects',
            submitTransform: (0, $1bQJO.transformCmdbField),
            retainUserInputTransform: null
        },
        [(0, $962656cd6986cb06$export$864384797e544339)]: {
            Component: (0, $4oT51.default),
            defaultValueKey: 'selectedOrganizations',
            submitTransform: (0, $UwVOJ.mapOrganizationOptionsToData),
            retainUserInputTransform: (0, $jI6Lk.mutateOrganizationsField)
        },
        [(0, $962656cd6986cb06$export$a138d5648dda03f0)]: {
            Component: (0, $kdeLq.default),
            defaultValueKey: 'richText.adfValue.json'
        },
        [(0, $962656cd6986cb06$export$aa5680ad8f8be9fc)]: {
            Component: (0, $lomXS.default),
            defaultValueKey: 'project',
            submitTransform: (0, $1D0eh.mapOptionToData),
            retainUserInputTransform: (0, $eWiSP.mutateProjectField)
        },
        [(0, $962656cd6986cb06$export$aecc734a7c3591d7)]: {
            Component: (0, $cf9Hx.default),
            submitTransform: (0, $gsevN.transformTimeTrackingValueToSubmitFormat),
            retainUserInputTransform: (0, $gsevN.mutateTimeTrackingField),
            defaultValueKey: 'originalEstimate'
        },
        [(0, $962656cd6986cb06$export$d9861709f0b70c10)]: {
            Component: (0, $hPJET.default),
            submitTransform: (0, $9sq52.getLogWorkSubmitValue)
        },
        [(0, $962656cd6986cb06$export$d10237d945259f96)]: {
            Component: (0, $hy8Vj.default),
            allowedValuesKey: 'fieldOptions.nodes',
            defaultValueKey: 'selectedFieldOptions',
            submitTransform: (0, $exGcw.mapOptionsToData),
            retainUserInputTransform: (0, $bN8Bv.mutateCheckboxField)
        },
        [(0, $962656cd6986cb06$export$670384150af5f49e)]: {
            Component: (0, $3gK8l.ParentLinkField),
            defaultValueKey: 'parentIssue',
            submitTransform: (0, $deSKa.mapOptionToData)
        },
        [(0, $962656cd6986cb06$export$bf9df74e065af482)]: {
            Component: (0, $8mBES.default),
            defaultValueKey: 'parentIssue',
            submitTransform: (0, $iVcsU.mapOptionToData),
            retainUserInputTransform: (0, $eulr6.mutateParentField)
        },
        ...(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui') ? {
            [(0, $962656cd6986cb06$export$33f8a9cb608132ba)]: {
                Component: (0, $7gcm4.default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, $7Pdzq.mapUserOptionsToAris)
            }
        } : {},
        [(0, $962656cd6986cb06$export$27854f490d658fc4)]: {
            Component: (0, $3mcIX.default),
            defaultValueKey: 'selectedOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $8TLRF.mapOptionToData),
            retainUserInputTransform: (0, $6HBPo.mutateSingleSelectField)
        },
        [(0, $962656cd6986cb06$export$fc69de49ba08ae77)]: {
            Component: (0, $4nSAG.IssueCreateEntitlementField),
            defaultValueKey: 'selectedEntitlement',
            submitTransform: (0, $57aXd.mapEntitlementOptionToData),
            retainUserInputTransform: undefined
        },
        ...(0, $4R6GH.fg)('jcs_master_flag') ? {
            [(0, $962656cd6986cb06$export$ede7166f44cc4bd6)]: {
                Component: (0, $162ej.IssueCreateOrganizationField),
                defaultValueKey: 'selectedOrganization',
                submitTransform: (0, $aPcig.mapOrganizationOptionToData),
                retainUserInputTransform: undefined
            }
        } : {}
    });
const $e9926c7a0c5999db$export$472717ed4aec82f1 = (0, $8QpSo.default)($e9926c7a0c5999db$var$createFieldMapItems);
const $e9926c7a0c5999db$export$aed6a8ebeb442f9 = [
    (0, $5fc53.ISSUE_LINKS_TYPE),
    (0, $5fc53.WORK_LOG_TYPE),
    (0, $5fc53.ATTACHMENT_TYPE)
];
const $e9926c7a0c5999db$export$e7c3e130e221f1f1 = [
    (0, $5fc53.ISSUE_LINKS_TYPE),
    (0, $5fc53.WORK_LOG_TYPE)
];
const $e9926c7a0c5999db$export$ccf7c75b07963f11 = [
    (0, $962656cd6986cb06$export$aa5680ad8f8be9fc),
    (0, $962656cd6986cb06$export$2d5a62a3515ad4c6),
    (0, $962656cd6986cb06$export$a12a4b25ab12710c)
];

});
parcelRegister("5kDIl", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToUserOption", () => $5870d9a04b0eab40$export$3e406786572c35b0);
$parcel$export(module.exports, "transformDefaultUserValues", () => $5870d9a04b0eab40$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToIds", () => $5870d9a04b0eab40$export$2482a6858a4714ad);
$parcel$export(module.exports, "mapUserOptionsToAccountIds", () => $5870d9a04b0eab40$export$e4490ea0dfe4173f);
$parcel$export(module.exports, "mutateSingleUserPicker", () => $5870d9a04b0eab40$export$7937ee6404102aff);
$parcel$export(module.exports, "mutateMultiUserPicker", () => $5870d9a04b0eab40$export$53e350638c0acebc);

const $5870d9a04b0eab40$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $5870d9a04b0eab40$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($5870d9a04b0eab40$export$3e406786572c35b0);
    return $5870d9a04b0eab40$export$3e406786572c35b0(defaultValue);
};
const $5870d9a04b0eab40$export$2482a6858a4714ad = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return {
        id: userOption.id
    };
};
const $5870d9a04b0eab40$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $5870d9a04b0eab40$export$7937ee6404102aff = (selectedUser, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
        user: {
            accountId: selectedUser.id
        }
    });
const $5870d9a04b0eab40$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$52003ca9b6035e0c),
        users: selectedUsers.map((user)=>({
                accountId: user.id
            }))
    });

});
const $2b6d45687558f2b0$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $2b6d45687558f2b0$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';


parcelRegister("b6sRp", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $93a6cb355dd35a44$export$2de59005e10fd82);

var $agVdz = parcelRequire("agVdz");
const $93a6cb355dd35a44$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});

parcelRegister("ii6hB", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesField", () => $387f926e9d9168ff$export$dbde2fdac14e77d6);
$parcel$export(module.exports, "default", () => $387f926e9d9168ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $f0bro = parcelRequire("f0bro");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $aZJYe = parcelRequire("aZJYe");

const $387f926e9d9168ff$export$dbde2fdac14e77d6 = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
    const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, $aZJYe.useFetchAffectedServicesName)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
            const ids = defaultValue.map((service) => service.serviceId);
            Simply extracting serviceId above causes Flow error as 'service'
            is of type (JiraAffectedService | AffectedServiceOption).
            See TURTLE-89 for more details.
             */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ids = defaultValue.reduce((serviceIds, service)=>// @ts-expect-error - TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'. | TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'.
                service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
            if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAffectedServicesName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAffectedServicesEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0bro.default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getAffectedServicesEdit()) : getAffectedServicesEdit());
};
var $387f926e9d9168ff$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aZJYe.transformDefaultAffectedServices)
})($387f926e9d9168ff$export$dbde2fdac14e77d6);

});
parcelRegister("f0bro", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bb95b3ef8c5394$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $kEqrP = parcelRequire("kEqrP");

var $2WZSx = parcelRequire("2WZSx");

var $2ngL6 = parcelRequire("2ngL6");
const $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $64bb95b3ef8c5394$var$AffectedServicesPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const searchAffectedServices = async (query = '')=>{
        setLastFetchFailed(false);
        try {
            (0, $kEqrP.fetchAffectedServicesExperience).start();
            const affectedServices = await (0, $2ngL6.fetchAffectedServices)(query, autoCompleteUrl);
            (0, $kEqrP.fetchAffectedServicesExperience).success();
            return affectedServices;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLastFetchFailed(true);
            (0, $kEqrP.fetchAffectedServicesExperience).failure();
            return [];
        }
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAffectedServices();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $FtZX9.default)(searchAffectedServices, $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $2WZSx.default).failedFetch : (0, $2WZSx.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ...fieldProps,
        classNamePrefix: "affected-services-picker",
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(value: AffectedServiceOption[]) => void' is not assignable to type '(value: OptionsType<AffectedServiceOption>, action: ActionMeta<AffectedServiceOption>) => void'.
        onChange: onChange,
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        "data-testid": "issue-field-affected-services.ui.edit.async-select"
    });
};
var $64bb95b3ef8c5394$export$2e2bcd8739ae039 = $64bb95b3ef8c5394$var$AffectedServicesPickerEdit;

});
parcelRegister("FtZX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb46637e8f856b8$export$2e2bcd8739ae039);
const $ebb46637e8f856b8$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $ebb46637e8f856b8$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;

});

parcelRegister("kEqrP", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $92ce1ce82a42bb8a$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $92ce1ce82a42bb8a$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $92ce1ce82a42bb8a$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $92ce1ce82a42bb8a$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $92ce1ce82a42bb8a$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $92ce1ce82a42bb8a$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $92ce1ce82a42bb8a$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $92ce1ce82a42bb8a$export$3f1da23c065671d2);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, $duUGa.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });
const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("2WZSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a56352311f156b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9a56352311f156b3$var$messages = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-affected-services.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-affected-services.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});
var $9a56352311f156b3$export$2e2bcd8739ae039 = $9a56352311f156b3$var$messages;

});

parcelRegister("2ngL6", function(module, exports) {

$parcel$export(module.exports, "mapServiceEntitiesToOptions", () => $ee273b75b82219a4$export$23b96a30f377b741);
$parcel$export(module.exports, "mapOptionsToServiceEntities", () => $ee273b75b82219a4$export$7dcfc49587479fac);
$parcel$export(module.exports, "fetchAffectedServices", () => $ee273b75b82219a4$export$66d34216c85d32cb);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $ee273b75b82219a4$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $ee273b75b82219a4$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));
const $ee273b75b82219a4$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: inputValue
    });
    return (0, $eusud.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$ee273b75b82219a4$export$23b96a30f377b741(response.services)).catch((error)=>{
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchAffectedServices',
            packageName: 'jiraIssueFieldAffectedServices',
            logToSentry: !(0, $jJZqs.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorMessage: error.message
            }
        });
        throw error;
    });
};

});


parcelRegister("7C5S0", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "Description", () => $17c5ea94a7a7a600$export$393edc798c47379d);
$parcel$export(module.exports, "SelectContainer", () => $17c5ea94a7a7a600$export$446eebadefe1123b);
$parcel$export(module.exports, "Divider", () => $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c0dQj = parcelRequire("c0dQj");
const $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ebfkjq": (0, $lD23V.default)((()=>{
                return typeof (__cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)) === 'number' ? `${__cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)}px` : __cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350);
            })()),
            "--_1glwpqj": (0, $lD23V.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $lD23V.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbhi17 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$393edc798c47379d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$446eebadefe1123b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _1bsb1osq _bfhkmuej _19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("YSJPS", function(module, exports) {

$parcel$export(module.exports, "StyledFieldSkeleton", () => $f113eb09b8933f94$export$ed5de990fe261b7b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");
const $f113eb09b8933f94$export$ed5de990fe261b7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1bsb1edt _otyr12x7",
            __cmplp.className
        ])
    });
});
$f113eb09b8933f94$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';

});

parcelRegister("hpV4g", function(module, exports) {

$parcel$export(module.exports, "withFormField", () => $b3f935405140180d$export$17bf6386ac4a43ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7O4UO = parcelRequire("7O4UO");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kErdU = parcelRequire("kErdU");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $cyw6P = parcelRequire("cyw6P");

var $5pZ9g = parcelRequire("5pZ9g");

var $7Emtg = parcelRequire("7Emtg");

var $6cMZg = parcelRequire("6cMZg");

var $gifeQ = parcelRequire("gifeQ");

var $bPtOr = parcelRequire("bPtOr");

var $fl3Yy = parcelRequire("fl3Yy");

var $1MgIu = parcelRequire("1MgIu");

var $bCATC = parcelRequire("bCATC");
var $bv5he = parcelRequire("bv5he");
var $dIjAl = parcelRequire("dIjAl");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");


var $2eeg1 = parcelRequire("2eeg1");

var $dCm1o = parcelRequire("dCm1o");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");

var $aBZin = parcelRequire("aBZin");

var $45JN1 = parcelRequire("45JN1");

var $iblgc = parcelRequire("iblgc");

var $86fzT = parcelRequire("86fzT");
const $b3f935405140180d$export$17bf6386ac4a43ba = (options)=>(Component)=>// @ts-expect-error - TS2322 - Type '(ownProps: ReturnComponentProps<Config>) => JSX.Element | null' is not assignable to type 'AbstractComponent<ReturnComponentProps<Config>, any>'.
        (ownProps)=>{
            const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type '{ areUiModificationsBusy?: boolean | undefined; } & BaseField & { componentKey?: string | undefined; fieldType?: string | undefined; forge?: { selectedProject: SelectedProject; selectedIssueType: IssueOrRequestType; modules: ForgeModules; } | undefined; fieldHelpTextUrl?: string | undefined; onLayoutDone?: (() => vo...'.
            defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
            const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
            const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
            const description = (0, $gifeQ.isForgeCustomField)(fieldType) ? (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
            const hasSentTransformDefaultValueError = (0, $5uXOq.useRef)(false);
            let transformedDefaultValue;
            try {
                /**
     * The transformDefaultValue function is generally used to transform a defaultValue
     * that is passed from the backend, which is in a different data format to the
     * frontend data format.
     *
     * In some situations, we want to set the defaultValue using data that is already
     * in the frontend data format instead of the backend data format. In these cases
     * we want to ignore the transformDefaultValue and just use the defaultValue from props.
     *
     * To do this, we are using the defaultValueDontTransform prop to know that we
     * can safely not run transformDefaultValue.
     */ if (defaultValueDontTransform) transformedDefaultValue = defaultValue; // this can be merged into the below on ff cleanup
                else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (hasSentTransformDefaultValueError.current === false) {
                    hasSentTransformDefaultValueError.current = true;
                    (0, $6paOF.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'defaultValueTransformation',
                            packageName: 'jiraIssueCreateCommons',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            fieldType: fieldType
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            (0, $5uXOq.useLayoutEffect)(()=>{
                onLayoutDone && onLayoutDone();
            }, [
                onLayoutDone
            ]);
            const shouldSetWidth = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
            const renderComponent = (fieldProps, error)=>// @ts-expect-error Type 'Omit<ReturnComponentProps<Config>, "fieldId" | "fieldName" | "description" | "isRequired" | "defaultValue" | "areUiModificationsBusy" | "componentKey" | "fieldType" | "forge" | "fieldHelpTextUrl" | "onLayoutDone"> & { ...; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<ComponentProps<Config, FieldValue>> & RefAttributes<any> & { ...; }'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...ownPropsRest,
                    fieldId: fieldId,
                    fieldName: fieldName,
                    isRequired: isRequired,
                    fieldProps: fieldProps,
                    width: shouldSetWidth ? '100%' : undefined,
                    isMini: isMini,
                    description: description,
                    defaultValue: defaultValue,
                    error: error,
                    key: componentKey,
                    ariaLabelledBy: `${fieldId}-field-label`
                });
            const renderFieldMessage = (0, $5uXOq.useCallback)((error)=>{
                if (shouldRenderFieldMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
                    fieldId: fieldId,
                    description: description,
                    error: error,
                    fieldName: fieldName,
                    fieldHelpTextUrl: fieldHelpTextUrl,
                    onLinkClickEvent: onLinkClickEvent,
                    isMini: isMini
                });
                return null;
            }, [
                description,
                fieldHelpTextUrl,
                fieldId,
                fieldName,
                isMini,
                onLinkClickEvent,
                shouldRenderFieldMessage
            ]);
            const extension = (0, $5uXOq.useMemo)(()=>{
                if (typeof fieldType === 'string' && (0, $gifeQ.isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, $6cMZg.getExtension)(fieldType, forge?.modules);
                return null;
            }, [
                fieldType,
                forge?.modules,
                forge?.hasFinishedLoading
            ]);
            (0, $5uXOq.useEffect)(()=>{
                const shouldReportFailure = typeof fieldType === 'string' && (0, $gifeQ.isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                if (shouldReportFailure) (0, $7Emtg.reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
            }, [
                fieldType,
                extension,
                forge?.modules,
                forge?.filteredOutModules,
                forge?.hasFinishedLoading
            ]);
            let issueExtensionData;
            if ((0, $4R6GH.fg)('issue-create-new-forge-field')) issueExtensionData = (0, $5uXOq.useMemo)(()=>{
                if (!forge?.selectedProject || !forge?.selectedIssueType) return undefined;
                const { selectedProject: selectedProject, selectedIssueType: selectedIssueType } = forge;
                return {
                    project: {
                        id: selectedProject.value,
                        key: selectedProject.projectKey,
                        type: selectedProject.projectType
                    },
                    issue: {
                        type: selectedIssueType.label,
                        typeId: selectedIssueType.value
                    }
                };
            }, [
                forge
            ]);
            let isBuiltinEdit = false;
            if (extension && (0, $4R6GH.fg)('issue-create-new-forge-field')) isBuiltinEdit = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $gifeQ.isBuiltInJiraFieldRender)(extension, 'edit', 'issue-create') : !extension?.properties.edit;
            const renderFieldContent = (fieldProps, error)=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return null;
                const fieldPropsWithPublish = {
                    ...fieldProps,
                    onChange: (value, ...rest)=>{
                        fieldProps.onChange(value, ...rest);
                        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                            fieldId: fieldId,
                            fieldName: fieldName,
                            fieldType: fieldType,
                            value: (0, $aBZin.getValueFromEventOrValue)(value)
                        });
                    }
                };
                if (isBuiltinEdit && fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) && (0, $4R6GH.fg)('issue-create-new-forge-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldProps, error), renderFieldMessage(error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
                    attributes: {
                        renderContext: 'issue-create',
                        fieldType: extension?.properties.type,
                        module: extension?.type,
                        ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {},
                        renderMode: 'default'
                    }
                }));
                if (!(0, $4R6GH.fg)('issue-create-new-forge-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5pZ9g.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    error: error,
                    selectedProject: forge?.selectedProject,
                    selectedIssueType: forge?.selectedIssueType,
                    extension: extension,
                    renderFieldMessage: renderFieldMessage,
                    renderDefaultComponent: renderComponent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) && issueExtensionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyw6P.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    description: descriptionRaw,
                    issueExtensionData: issueExtensionData,
                    extension: extension ?? null,
                    renderContext: "issue-create",
                    experience: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? 'issue-create' : undefined
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
            };
            const renderFieldLabel = (0, $4R6GH.fg)('issue-create-new-forge-field') ? (0, $5uXOq.useCallback)(()=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return ''; // TODO Merge this condition with the one below when cleaning migrate_gic_smart_fields_jira_labs https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel || (0, $gifeQ.isForgeCustomField)(fieldType) && !isBuiltinEdit && (0, $4R6GH.fg)('issue-create-new-forge-field')) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gifeQ.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed,
                isBuiltinEdit
            ]) : (0, $5uXOq.useCallback)(()=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return ''; // TODO Merge this condition with the one below when cleaning migrate_gic_smart_fields_jira_labs https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gifeQ.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed
            ]);
            if ((0, $gifeQ.isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iblgc.FieldSkeleton), null);
            if ((0, $gifeQ.isForgeCustomField)(fieldType) && !extension) return null;
            const renderField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                id: `${fieldId}-field`,
                label: renderFieldLabel(),
                elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv5he.FieldBusyIndicator), {
                    fieldId: fieldId
                }) : undefined,
                isRequired: isRequired,
                name: fieldId,
                defaultValue: transformedDefaultValue,
                key: (0, $86fzT.generateKeyForRequiredFromUIM)({
                    fieldId: fieldId,
                    isRequiredFromUIM: isRequiredFromUIM === true
                }),
                validate: (value, _formState, { dirty: dirty })=>{
                    try {
                        const { type: type } = ownPropsRest;
                        if ((0, $gifeQ.isForgeCustomField)(fieldType) && isRequired) // Dirty check is required for the forge custom fields that haven't yet populated the value because it haven't lost a focus
                        return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $6paOF.fireIssueCreateErrorAnalytics)({
                            meta: {
                                id: 'fieldValidationIssue',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return undefined;
                    }
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                    id: "issueAdjustmentsFieldValueDecorator",
                    packageName: "jiraIssueCreateModal",
                    fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null), renderFieldContent(fieldProps, error)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (err)=>({
                            errorType: (0, $bPtOr.getErrorType)(err),
                            viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                            fieldId: fieldId,
                            fieldType: fieldType
                        })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eeg1.FieldValueDecoratorAsync), {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    fieldProps: fieldProps
                }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error))))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                id: "withFormField",
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    fieldId: fieldId,
                    fieldType: fieldType
                }
            }, (0, $dCm1o.isVisualRefreshEnabled)() && fieldId === 'assignee' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $b3f935405140180d$var$fieldStyles
            }, " ", renderField, " ") : renderField);
        };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3f935405140180d$var$ForgeLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8140y _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b3f935405140180d$var$fieldStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});

});
parcelRegister("cyw6P", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $a82314a415a204e2$export$34a15d6027142c62);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2RhPB = parcelRequire("2RhPB");

var $7Aezm = parcelRequire("7Aezm");

var $fl3Yy = parcelRequire("fl3Yy");

var $1MgIu = parcelRequire("1MgIu");

var $lEOGs = parcelRequire("lEOGs");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $cR6FI = parcelRequire("cR6FI");

var $lXxfQ = parcelRequire("lXxfQ");

var $2G1Qa = parcelRequire("2G1Qa");
const $a82314a415a204e2$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, issueExtensionData: issueExtensionData, renderContext: renderContext, extension: extension, description: rawDescription, experience: experience })=>{
    const { onChange: onChange, value: value, error: error } = fieldProps;
    const extensionPayload = (0, $5uXOq.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $2G1Qa.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: renderContext,
            experience: experience
        };
        if (!issueExtensionData) return defaultExtensionData;
        return {
            ...defaultExtensionData,
            ...issueExtensionData
        };
    }, [
        issueExtensionData,
        fieldId,
        fieldName,
        fieldType,
        renderContext,
        experience
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: renderContext
        };
        if (!issueExtensionData) return defaultExtensionData;
        return {
            ...defaultExtensionData,
            ...issueExtensionData
        };
    }, [
        issueExtensionData,
        fieldId,
        fieldName,
        fieldType,
        renderContext
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            renderContext: renderContext,
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension,
        renderContext
    ]);
    if (!extension) return null;
    const { environment: environment, description: description } = (0, $1MgIu.extractEnvFromFieldDescription)(rawDescription || '');
    const renderFieldMessage = (err)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lEOGs.FieldMessage), {
            description: description,
            error: err,
            fieldName: fieldName
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a82314a415a204e2$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
        environmentType: environment
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR6FI.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXxfQ.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    }));
};
const $a82314a415a204e2$export$34a15d6027142c62 = (props)=>{
    const { extension: extension } = props;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: props.renderContext,
            ...extension && (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension,
        props.renderContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.075",
        xcss: $a82314a415a204e2$var$fieldContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a82314a415a204e2$export$4f0175d9150f8767, props)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a82314a415a204e2$var$ForgeLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8140y _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a82314a415a204e2$var$fieldContainerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("7Aezm", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $f6c5a5a43a090916$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $f6c5a5a43a090916$export$947ae3996b2bc000);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");
const $f6c5a5a43a090916$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $f6c5a5a43a090916$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("1MgIu", function(module, exports) {

$parcel$export(module.exports, "extractEnvFromFieldDescription", () => $91f4ce51875a932d$export$dfa36573f3bd00af);
const $91f4ce51875a932d$var$DEV_PREFIX = '(DEVELOPMENT) ';
const $91f4ce51875a932d$var$STG_PREFIX = '(STAGING) ';
const $91f4ce51875a932d$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
    if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$DEV_PREFIX)) return {
        environment: 'DEVELOPMENT',
        description: descriptionWithEnv.replace($91f4ce51875a932d$var$DEV_PREFIX, '')
    };
    if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$STG_PREFIX)) return {
        environment: 'STAGING',
        description: descriptionWithEnv.replace($91f4ce51875a932d$var$STG_PREFIX, '')
    };
    return {
        environment: 'PRODUCTION',
        description: descriptionWithEnv ?? ''
    };
};

});

parcelRegister("lEOGs", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $d60be20b90d8ebba$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kOFhM = parcelRequire("kOFhM");

var $qfj8c = parcelRequire("qfj8c");

var $e4yMr = parcelRequire("e4yMr");

var $f5oqj = parcelRequire("f5oqj");

var $h17zy = parcelRequire("h17zy");

var $koVbs = parcelRequire("koVbs");

var $6a30R = parcelRequire("6a30R");

var $4L2MR = parcelRequire("4L2MR");
const $d60be20b90d8ebba$var$featureFlags = {
    codeBidiWarnings: true,
    'code-bidi-warnings': true,
    'renderer-tti-tracking': true,
    'allow-windowed-code-block': true
};
const $d60be20b90d8ebba$var$FieldHelpLink = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl, onLinkClickEvent: onLinkClickEvent })=>{
    const learnMoreMessage = (0, $4L2MR.getLearnMoreMessage)(fieldHelpTextUrl);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: fieldHelpTextUrl,
        target: "_blank",
        onClick: (e)=>onLinkClickEvent(e, fieldHelpTextUrl)
    }, formatMessage(learnMoreMessage));
});
const $d60be20b90d8ebba$export$eb5013679a5d3f69 = (props)=>{
    const emojiProvider = (0, $h17zy.useEmojiProvider)();
    const { error: error, fieldName: fieldName, description: description = '', fieldHelpTextUrl: fieldHelpTextUrl = '', onLinkClickEvent: onLinkClickEvent } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const eventHandlers = (0, $5uXOq.useMemo)(()=>({
            smartCard: {
                onClick: (0, $6a30R.onLinkClick)
            },
            link: {
                onClick: onLinkClickEvent || ((event, url)=>{
                    const eventTarget = event.target;
                    if ((0, $4L2MR.getLearnMoreMessage)(fieldHelpTextUrl) && url === fieldHelpTextUrl && eventTarget instanceof HTMLAnchorElement) {
                        eventTarget.target = '_blank';
                        return;
                    }
                    (0, $6a30R.onLinkClick)(event, url);
                })
            }
        }), [
        fieldHelpTextUrl,
        onLinkClickEvent
    ]);
    const document = (0, $5uXOq.useMemo)(()=>{
        if (error) return null;
         // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $4L2MR.adfDocument)({
            description: description
        });
    }, [
        description,
        error
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $4L2MR.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!document && !fieldHelpTextUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d60be20b90d8ebba$var$Description, {
        key: `${fieldName}-field-message`
    }, document && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ), {
        document: document,
        dataProviders: emojiProvider,
        schema: (0, $kOFhM.defaultSchema),
        disableHeadingIDs: true,
        featureFlags: $d60be20b90d8ebba$var$featureFlags,
        truncated: false,
        eventHandlers: eventHandlers,
        smartLinks: (0, $6a30R.smartLinksDefault)
    }), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d60be20b90d8ebba$var$FieldHelpLink, {
        fieldHelpTextUrl: fieldHelpTextUrl,
        onLinkClickEvent: eventHandlers.link.onClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d60be20b90d8ebba$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1hdcr7 _woio131l _13od1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kOFhM", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $f27880a8173018db$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f27880a8173018db$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f27880a8173018db$export$1db618b7b2275ea1);

var $8QpSo = parcelRequire("8QpSo");

var $7kC9H = parcelRequire("7kC9H");
var $47jug = parcelRequire("47jug");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $9UDEr = parcelRequire("9UDEr");

var $kBho7 = parcelRequire("kBho7");
const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
const $f27880a8173018db$export$fd147e7d448dea03 = (0, $8QpSo.default)((stage = 'final')=>{
    const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gZoER.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $47jug.multiBodiedExtension),
        extensionFrame: (0, $47jug.extensionFrame),
        expand: (0, $7kC9H.expandWithNestedExpand),
        listItem: (0, $2FIVU.listItemWithDecisionStage0),
        table: (0, $9UDEr.tableWithNestedTable),
        tableRow: (0, $9UDEr.tableRowWithNestedTable),
        tableCell: (0, $9UDEr.tableCellWithNestedTable),
        tableHeader: (0, $9UDEr.tableHeaderWithNestedTable)
    };
    return (0, $kBho7.createSchema)(defaultSchemaConfig);
});
const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();

});
parcelRegister("7kC9H", function(module, exports) {

$parcel$export(module.exports, "expand", () => $5567ff8f3f52f7a8$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $5567ff8f3f52f7a8$export$54fd2c36b5cc6731);

var $gthjq = parcelRequire("gthjq");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, $gthjq.expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, $gthjq.expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$32b1dde15f5fe85b);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$171e9ff2be159af7);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$15ebf236772fa336);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $bfdcc8a4590754dc$export$220c665c23b9541b);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$32b1dde15f5fe85b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$171e9ff2be159af7 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$15ebf236772fa336 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$220c665c23b9541b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("47jug", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $2ff6ee9baaedd4b6$export$c3c04d555a8b9013);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, $gthjq.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, $gthjq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("CWpyq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $0750dbf71b86cced$export$1765e2758fc47004);
const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("gZoER", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $c5e57867b1f8b9c7$export$4f9d8f623ff17117);

var $gthjq = parcelRequire("gthjq");
const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, $gthjq.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, $gthjq.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, $gthjq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2FIVU", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $1f2243de0d109562$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $1f2243de0d109562$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1f2243de0d109562$export$b2cd54d5ce935ddb);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $1f2243de0d109562$export$171e9ff2be159af7);

var $gthjq = parcelRequire("gthjq");
const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, $gthjq.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, $gthjq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$171e9ff2be159af7 = (0, $gthjq.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("9UDEr", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $737819f27951a815$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $737819f27951a815$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $737819f27951a815$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $737819f27951a815$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $737819f27951a815$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $737819f27951a815$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $737819f27951a815$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $737819f27951a815$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $737819f27951a815$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $737819f27951a815$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $737819f27951a815$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $737819f27951a815$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $737819f27951a815$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $737819f27951a815$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $737819f27951a815$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $737819f27951a815$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $737819f27951a815$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $737819f27951a815$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $737819f27951a815$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $737819f27951a815$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $737819f27951a815$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $737819f27951a815$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $737819f27951a815$export$2a5a518232fa1a97);

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $9IGaJ = parcelRequire("9IGaJ");

var $87j2U = parcelRequire("87j2U");

var $gthjq = parcelRequire("gthjq");
const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51H8P.N20).toLocaleLowerCase();
const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51H8P.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51H8P.isRgb)(backgroundColor)) {
        const result = (0, $51H8P.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $737819f27951a815$var$testGlobalTheme;
const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
    $737819f27951a815$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $737819f27951a815$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($737819f27951a815$var$testGlobalTheme) return {
        colorMode: $737819f27951a815$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51H8P.isRgb)(background) && (0, $51H8P.rgbToHex)(background) ? (0, $51H8P.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $daes7.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $87j2U.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
    else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
    return attrs;
};
const $737819f27951a815$export$219b7f492ad209f8 = new Map();
const $737819f27951a815$export$95e9c925fbf01d1c = (0, $51H8P.hexToRgba)((0, $51H8P.N800), 0.12) || (0, $51H8P.N0);
const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B50),
        'Light blue'
    ],
    [
        (0, $51H8P.T50),
        'Light teal'
    ],
    [
        (0, $51H8P.G50),
        'Light green'
    ],
    [
        (0, $51H8P.Y50),
        'Light yellow'
    ],
    [
        (0, $51H8P.R50),
        'Light red'
    ],
    [
        (0, $51H8P.P50),
        'Light purple'
    ],
    [
        (0, $51H8P.N20),
        'Light gray'
    ],
    [
        (0, $51H8P.B75),
        'Blue'
    ],
    [
        (0, $51H8P.T75),
        'Teal'
    ],
    [
        (0, $51H8P.G75),
        'Green'
    ],
    [
        (0, $51H8P.Y75),
        'Yellow'
    ],
    [
        (0, $51H8P.R75),
        'Red'
    ],
    [
        (0, $51H8P.P75),
        'Purple'
    ],
    [
        (0, $51H8P.N60),
        'Gray'
    ],
    [
        (0, $51H8P.B100),
        'Dark blue'
    ],
    [
        (0, $51H8P.T100),
        'Dark teal'
    ],
    [
        (0, $51H8P.G200),
        'Dark green'
    ],
    [
        (0, $51H8P.Y200),
        'Dark yellow'
    ],
    [
        (0, $51H8P.R100),
        'Dark red'
    ],
    [
        (0, $51H8P.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $737819f27951a815$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9IGaJ.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $737819f27951a815$var$createTableSpec = ()=>(0, $gthjq.table)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $737819f27951a815$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $737819f27951a815$export$ce666bf02318c957 = (0, $gthjq.tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $737819f27951a815$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$e1e720e5f4603e6a = (0, $gthjq.tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                    background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$48884d2a5190dc73 = (0, $gthjq.tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
const $737819f27951a815$export$ce086a560a1d05f5 = (0, $gthjq.tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$7d657479499397 = (0, $gthjq.tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$export$abf39ca178940ff3 = (0, $gthjq.tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2a5a518232fa1a97 = (0, $gthjq.tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);

});
parcelRegister("daes7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $99576b847e5fbb17$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $99576b847e5fbb17$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $99576b847e5fbb17$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99576b847e5fbb17$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99576b847e5fbb17$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9IGaJ", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $7138efa2a0163ee8$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $7138efa2a0163ee8$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7138efa2a0163ee8$var$staticValue = false;
const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7138efa2a0163ee8$var$staticValue = value;
    },
    generate () {
        return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("87j2U", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
    const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
    return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
};
const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    return lch.l;
};
const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kBho7", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $eff4c0443be4d23b$export$5f4ce795563f4211);

var $kCV8T = parcelRequire("kCV8T");


var $7P7H6 = parcelRequire("7P7H6");

var $aeGrH = parcelRequire("aeGrH");
var $88i6h = parcelRequire("88i6h");
var $8jJss = parcelRequire("8jJss");
var $14Vqw = parcelRequire("14Vqw");
var $zceQE = parcelRequire("zceQE");
var $lcXoV = parcelRequire("lcXoV");
var $71k4W = parcelRequire("71k4W");
var $cUwVZ = parcelRequire("cUwVZ");
var $l3Tmi = parcelRequire("l3Tmi");
var $29Vii = parcelRequire("29Vii");
var $fK6mK = parcelRequire("fK6mK");
var $8XeG6 = parcelRequire("8XeG6");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $c9aa1 = parcelRequire("c9aa1");
var $dtyqo = parcelRequire("dtyqo");
var $8EAPB = parcelRequire("8EAPB");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $21PS7 = parcelRequire("21PS7");
var $5AxYU = parcelRequire("5AxYU");
var $kjhhp = parcelRequire("kjhhp");
var $5JeV5 = parcelRequire("5JeV5");
var $8vlrc = parcelRequire("8vlrc");
var $6bbHe = parcelRequire("6bbHe");
var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $b2VmY = parcelRequire("b2VmY");
var $Khvpb = parcelRequire("Khvpb");
var $8gSD8 = parcelRequire("8gSD8");
var $xjCuM = parcelRequire("xjCuM");
var $kshOv = parcelRequire("kshOv");
var $7DoMR = parcelRequire("7DoMR");
var $7kC9H = parcelRequire("7kC9H");
var $aXBFx = parcelRequire("aXBFx");
var $bFtEE = parcelRequire("bFtEE");
var $hhN5g = parcelRequire("hhN5g");
var $47jug = parcelRequire("47jug");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");
var $7lRBh = parcelRequire("7lRBh");
var $cCBEe = parcelRequire("cCBEe");
var $5BOuQ = parcelRequire("5BOuQ");
var $4EbxI = parcelRequire("4EbxI");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $7agO8 = parcelRequire("7agO8");
var $92lix = parcelRequire("92lix");
var $7Xgp3 = parcelRequire("7Xgp3");
var $bIGZ7 = parcelRequire("bIGZ7");
var $g7Cky = parcelRequire("g7Cky");
var $dx5eC = parcelRequire("dx5eC");
var $dwptW = parcelRequire("dwptW");
var $abme3 = parcelRequire("abme3");
var $dgJoa = parcelRequire("dgJoa");
var $M4hHz = parcelRequire("M4hHz");
var $18bvk = parcelRequire("18bvk");
var $9UDEr = parcelRequire("9UDEr");
var $iThOL = parcelRequire("iThOL");
var $43mJF = parcelRequire("43mJF");
var $3DR6L = parcelRequire("3DR6L");
var $9X587 = parcelRequire("9X587");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $eff4c0443be4d23b$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $eff4c0443be4d23b$var$markGroupDeclarations = [
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
];
const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $eff4c0443be4d23b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $xjCuM.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $abme3.paragraph)
    },
    {
        name: 'text',
        spec: (0, $3DR6L.text)
    },
    {
        name: 'bulletList',
        spec: (0, $kjhhp.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $dwptW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2FIVU.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $lRTZM.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aXBFx.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $8vlrc.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bFtEE.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $M4hHz.rule)
    },
    {
        name: 'image',
        spec: (0, $7lRBh.image)
    },
    {
        name: 'mention',
        spec: (0, $g7Cky.mention)
    },
    {
        name: 'caption',
        spec: (0, $5JeV5.caption)
    },
    {
        name: 'media',
        spec: (0, $7agO8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $92lix.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bIGZ7.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $7Xgp3.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dgJoa.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $gZoER.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4EbxI.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $jnMM2.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $7DoMR.emoji)
    },
    {
        name: 'table',
        spec: (0, $9UDEr.table)
    },
    {
        name: 'tableCell',
        spec: (0, $9UDEr.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $9UDEr.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $9UDEr.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6bbHe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bd7A9.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5y0tR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $8gSD8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Khvpb.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $43mJF.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iThOL.taskItem)
    },
    {
        name: 'date',
        spec: (0, $b2VmY.date)
    },
    {
        name: 'status',
        spec: (0, $18bvk.status)
    },
    {
        name: 'expand',
        spec: (0, $7kC9H.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dx5eC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hhN5g.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5BOuQ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $5AxYU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $47jug.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $47jug.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $cCBEe.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $21PS7.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $kshOv.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9X587.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d1d6m.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $6kr5W.unsupportedInline)
    }
];
const $eff4c0443be4d23b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $8XeG6.link)
    },
    {
        name: 'em',
        spec: (0, $l3Tmi.em)
    },
    {
        name: 'strong',
        spec: (0, $hhtT8.strong)
    },
    {
        name: 'textColor',
        spec: (0, $c9aa1.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $8jJss.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $aUhe2.strike)
    },
    {
        name: 'subsup',
        spec: (0, $4NwJJ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8EAPB.underline)
    },
    {
        name: 'code',
        spec: (0, $lcXoV.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dtyqo.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $aeGrH.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $88i6h.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $71k4W.confluenceInlineComment)
    },
    ...$eff4c0443be4d23b$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $zceQE.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cUwVZ.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $29Vii.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $fK6mK.indentation)
    },
    {
        name: 'border',
        spec: (0, $14Vqw.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jxVez.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $lVmBd.unsupportedNodeAttribute)
    }
];
function $eff4c0443be4d23b$export$2d0c32a809131488() {
    const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
    let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $7P7H6.sanitizeNodes)(nodes, marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("7P7H6", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $5b2343b4eb27461c$export$daf54fed04c8fb77);
function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aeGrH", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $773c2309706a915e$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $773c2309706a915e$export$8e53000a4ec837);

var $2fTAU = parcelRequire("2fTAU");
const $773c2309706a915e$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $773c2309706a915e$export$8e53000a4ec837 = (0, $2fTAU.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("2fTAU", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $1a481b607696d815$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $1a481b607696d815$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $1a481b607696d815$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $1a481b607696d815$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $1a481b607696d815$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $1a481b607696d815$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $1a481b607696d815$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $1a481b607696d815$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $1a481b607696d815$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $1a481b607696d815$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $1a481b607696d815$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $1a481b607696d815$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $1a481b607696d815$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $1a481b607696d815$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $1a481b607696d815$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $1a481b607696d815$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $1a481b607696d815$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $1a481b607696d815$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $1a481b607696d815$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $1a481b607696d815$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $1a481b607696d815$export$8e53000a4ec837 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $1a481b607696d815$export$8512c9afa7b24c3b = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $1a481b607696d815$export$8c5a050822fd698c = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $1a481b607696d815$export$1edee58a52776cd9 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $1a481b607696d815$export$89015c65f1c75e3f = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $1a481b607696d815$export$6565f9f03506010b = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$3024f02c495408d6 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $1a481b607696d815$export$c63c6f932822f543 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$f00aeb236b6f05af = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$480c699bd4ec0d86 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $1a481b607696d815$export$9c30223ca0a664fb = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $1a481b607696d815$export$4899a95d70ec5056 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$59ae2c325a998f89 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$b3401ee80eb31041 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$32f78bffcd82ff28 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $1a481b607696d815$export$20af3dabbb5538df = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $1a481b607696d815$export$425327af25286e5e = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $1a481b607696d815$export$a316dc07ff5182a2 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("88i6h", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $5ebd1c6c912098fc$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $5ebd1c6c912098fc$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $5ebd1c6c912098fc$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $5ebd1c6c912098fc$export$8512c9afa7b24c3b);

var $2fTAU = parcelRequire("2fTAU");
let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $5ebd1c6c912098fc$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, $2fTAU.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("8jJss", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $60e35c16db44f137$export$8c5a050822fd698c);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $c9aa1 = parcelRequire("c9aa1");

var $87j2U = parcelRequire("87j2U");
/**
 * @name backgroundColor_mark
 */ const $60e35c16db44f137$var$colorArrayPalette = [
    [
        (0, $51H8P.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51H8P.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51H8P.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51H8P.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51H8P.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51H8P.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
$60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $60e35c16db44f137$export$8c5a050822fd698c = (0, $2fTAU.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $c9aa1.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("c9aa1", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $8d7e34fd69d04bb8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $8d7e34fd69d04bb8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $8d7e34fd69d04bb8$export$32f78bffcd82ff28);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $87j2U = parcelRequire("87j2U");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $8d7e34fd69d04bb8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51H8P.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51H8P.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51H8P.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51H8P.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51H8P.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51H8P.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51H8P.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51H8P.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51H8P.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51H8P.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51H8P.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51H8P.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51H8P.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51H8P.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51H8P.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51H8P.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51H8P.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51H8P.P50),
        'Light purple'
    ] // Lavender secret
];
const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
$8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $8d7e34fd69d04bb8$var$testGlobalTheme;
const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
    $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
};
const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
        colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, $2fTAU.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("14Vqw", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $0c92b5eb9dbe9377$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $0c92b5eb9dbe9377$export$1edee58a52776cd9);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
    [
        (0, $51H8P.N300A),
        'Subtle gray'
    ],
    [
        (0, $51H8P.N600),
        'Gray'
    ],
    [
        (0, $51H8P.N1000),
        'Bold gray'
    ]
];
const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
$0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, $2fTAU.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $daes7.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("zceQE", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $069cc34ec2ef025e$export$89015c65f1c75e3f);

var $2fTAU = parcelRequire("2fTAU");
const $069cc34ec2ef025e$var$allowedTypes = [
    'wide',
    'full-width'
];
const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, $2fTAU.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("lcXoV", function(module, exports) {

$parcel$export(module.exports, "code", () => $f708cbc93f02b120$export$6565f9f03506010b);

var $2fTAU = parcelRequire("2fTAU");
const $f708cbc93f02b120$export$6565f9f03506010b = (0, $2fTAU.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("71k4W", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $51c833981031ae17$export$f3b72f8fc4684ecd);

var $2fTAU = parcelRequire("2fTAU");
const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, $2fTAU.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cUwVZ", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $966443126bdc8969$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $966443126bdc8969$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $6VXbJ.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $966443126bdc8969$export$3024f02c495408d6 = (0, $2fTAU.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("6VXbJ", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $50c5fa8010b73128$export$c296e2d4365c37a5);
const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("l3Tmi", function(module, exports) {

$parcel$export(module.exports, "em", () => $f554d1dac524ac83$export$c63c6f932822f543);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name em_mark
 */ const $f554d1dac524ac83$var$emDOM = [
    'em'
];
const $f554d1dac524ac83$export$c63c6f932822f543 = (0, $2fTAU.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f554d1dac524ac83$var$emDOM;
    }
});

});

parcelRegister("29Vii", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $1928dd6d160b68a9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $1928dd6d160b68a9$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $6VXbJ.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, $2fTAU.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("fK6mK", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $b760170dcfe13435$export$480c699bd4ec0d86);

var $2fTAU = parcelRequire("2fTAU");
const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, $2fTAU.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8XeG6", function(module, exports) {

$parcel$export(module.exports, "link", () => $684f383282dda449$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $684f383282dda449$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $iZOJ9 = parcelRequire("iZOJ9");
const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iZOJ9.isSafeUrl)(href)) return false;
        if ((0, $iZOJ9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iZOJ9.normalizeUrl)(href);
        return attrs;
    };
const $684f383282dda449$export$9c30223ca0a664fb = (0, $2fTAU.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iZOJ9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $684f383282dda449$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("aUhe2", function(module, exports) {

$parcel$export(module.exports, "strike", () => $7f0c7ef7d4ef76e7$export$4899a95d70ec5056);

var $2fTAU = parcelRequire("2fTAU");
const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, $2fTAU.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hhtT8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c94b3560d4129743$export$59ae2c325a998f89);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name strong_mark
 */ const $c94b3560d4129743$var$strongDOM = [
    'strong'
];
const $c94b3560d4129743$export$59ae2c325a998f89 = (0, $2fTAU.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c94b3560d4129743$var$strongDOM;
    }
});

});

parcelRegister("4NwJJ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $37e521d9accf6615$export$b3401ee80eb31041);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name subsup_mark
 */ function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $37e521d9accf6615$export$b3401ee80eb31041 = (0, $2fTAU.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dtyqo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $9cf8afcff83743a0$export$20af3dabbb5538df);

var $2fTAU = parcelRequire("2fTAU");

var $51H8P = parcelRequire("51H8P");
const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, $2fTAU.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51H8P.B400)}`
            }
        ];
    }
});

});

parcelRegister("8EAPB", function(module, exports) {

$parcel$export(module.exports, "underline", () => $64cea1116bb0e8f8$export$425327af25286e5e);

var $2fTAU = parcelRequire("2fTAU");
const $64cea1116bb0e8f8$export$425327af25286e5e = (0, $2fTAU.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jxVez", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e3ad7edb6364f3b2$export$30d78d5eb6719bb8);

var $2fTAU = parcelRequire("2fTAU");
const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, $2fTAU.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("lVmBd", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ff60739479aa7be3$export$a316dc07ff5182a2);

var $2fTAU = parcelRequire("2fTAU");
const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, $2fTAU.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21PS7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $17a3e9738ed289c7$export$c4c2f833baaebdb8);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockCard_node
 */ const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, $gthjq.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("5AxYU", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $411aac89e34c8741$export$27903d543b563e39);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $411aac89e34c8741$export$27903d543b563e39 = (0, $gthjq.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kjhhp", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $ec92fc66e86ee824$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $ec92fc66e86ee824$export$a140c94e5ea26bee);

var $gthjq = parcelRequire("gthjq");
const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, $gthjq.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5JeV5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);

var $gthjq = parcelRequire("gthjq");
const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, $gthjq.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8vlrc", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $6311d90c8f0b12c7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6311d90c8f0b12c7$export$54fd2c36b5cc6731);

var $kCV8T = parcelRequire("kCV8T");

var $gthjq = parcelRequire("gthjq");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, $gthjq.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                return code ? (0, $kCV8T.Fragment).from(schema.text(code)) : (0, $kCV8T.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("6bbHe", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $47fcd7cf328a46ad$export$daf889beb5092f95);

var $gthjq = parcelRequire("gthjq");
const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, $gthjq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $47fcd7cf328a46ad$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5y0tR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $40a0802970c8dfd0$export$e6e4878f43c27cab);

var $gthjq = parcelRequire("gthjq");
const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, $gthjq.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $40a0802970c8dfd0$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bd7A9", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $8296ca40a4ed2ee7$export$3e6d667072febc87);

var $gthjq = parcelRequire("gthjq");
const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, $gthjq.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $8296ca40a4ed2ee7$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("b2VmY", function(module, exports) {

$parcel$export(module.exports, "date", () => $80ac620012a63cc1$export$324d90190a8b822a);

var $gthjq = parcelRequire("gthjq");
const $80ac620012a63cc1$export$324d90190a8b822a = (0, $gthjq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Khvpb", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $08b1e03a19cbdc24$export$6959e16eeff859b4);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, $gthjq.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8gSD8", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $605a31c9af2a8977$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $605a31c9af2a8977$export$62d45a65fb43d95e);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name decisionList_node
 */ const $605a31c9af2a8977$var$name = 'decisionList';
const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, $gthjq.decisionList)({
    parseDOM: [
        {
            tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $605a31c9af2a8977$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("xjCuM", function(module, exports) {

$parcel$export(module.exports, "doc", () => $06424d48e92613a9$export$2a111da947c407d2);

var $gthjq = parcelRequire("gthjq");
const $06424d48e92613a9$export$2a111da947c407d2 = (0, $gthjq.doc)({});

});

parcelRegister("kshOv", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $ee443d93678dbe0b$export$be4283d9a1cb1ff6);

var $gthjq = parcelRequire("gthjq");
const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, $gthjq.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7DoMR", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $58ef6723e99e5604$export$a19185d1233fc4b2);

var $4pzsz = parcelRequire("4pzsz");

var $gthjq = parcelRequire("gthjq");
const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, $gthjq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4pzsz.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4pzsz.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4pzsz", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $336500cbd1ca0f10$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $336500cbd1ca0f10$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $336500cbd1ca0f10$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $336500cbd1ca0f10$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
    const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
        if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
    }
    return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("aXBFx", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $7faca2534e4894a0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $7faca2534e4894a0$export$c4d50234112df933);
$parcel$export(module.exports, "extendedBlockquote", () => $7faca2534e4894a0$export$70a64939da3e8455);
$parcel$export(module.exports, "blockquoteWithList", () => $7faca2534e4894a0$export$9b4686c4b9672643);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $7faca2534e4894a0$export$32b1dde15f5fe85b);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockquote_node
 */ const $7faca2534e4894a0$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $7faca2534e4894a0$export$67dc04e652a298ca = (0, $gthjq.blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$c4d50234112df933 = (0, $gthjq.blockquoteWithoutNonBodiedMacros)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$70a64939da3e8455 = (0, $gthjq.blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, $gthjq.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});
const $7faca2534e4894a0$export$32b1dde15f5fe85b = (0, $gthjq.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $87ea86de426496d8$export$220c665c23b9541b);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>(0, $gthjq.panel)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));
const $87ea86de426496d8$export$220c665c23b9541b = (allowCustomPanel)=>(0, $gthjq.panelWithoutNestedNonBodiedMacros)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));

});

parcelRegister("hhN5g", function(module, exports) {

$parcel$export(module.exports, "extension", () => $c95a1940f4fa6aee$export$1b45514b112dd749);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, $gthjq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jnMM2", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $e1c5ffc4cc369fdc$export$371da9dd35aba193);

var $gthjq = parcelRequire("gthjq");
const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, $gthjq.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lRTZM", function(module, exports) {

$parcel$export(module.exports, "heading", () => $feb9fbb7aabe0cc7$export$46e4a324ac90507f);

var $gthjq = parcelRequire("gthjq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, $gthjq.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("7lRBh", function(module, exports) {

$parcel$export(module.exports, "image", () => $55a4127c569d3934$export$5c452ff88e35e47d);

var $gthjq = parcelRequire("gthjq");
const $55a4127c569d3934$export$5c452ff88e35e47d = (0, $gthjq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("cCBEe", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $93063cb7956d3766$export$cbf8224b64e0d942);

var $gthjq = parcelRequire("gthjq");
const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, $gthjq.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5BOuQ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4157940155363fee$export$16b353b2649bd8d9);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $4157940155363fee$export$16b353b2649bd8d9 = (0, $gthjq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4EbxI", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $3623d9fd8951cfd2$export$ab76e7c03cd6f650);

var $gthjq = parcelRequire("gthjq");
const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, $gthjq.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("7agO8", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $5376813d9b4ea07d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $5376813d9b4ea07d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $5376813d9b4ea07d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $5376813d9b4ea07d$export$54fd2c36b5cc6731);

var $51H8P = parcelRequire("51H8P");

var $gthjq = parcelRequire("gthjq");
const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, $gthjq.media)({}).attrs;
const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51H8P.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $gthjq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gthjq.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
    if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $5376813d9b4ea07d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $5376813d9b4ea07d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("92lix", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $6944d24b2c8b0dd9$export$2855e964765eac9);

var $gthjq = parcelRequire("gthjq");
const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, $gthjq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("7Xgp3", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $5caac46433adf3f0$export$38bab695e3f720f1);

var $7agO8 = parcelRequire("7agO8");

var $gthjq = parcelRequire("gthjq");
const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, $7agO8.createMediaSpec)((0, $gthjq.mediaInline)({}).attrs, true);

});

parcelRegister("bIGZ7", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $888525ada96954d1$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $888525ada96954d1$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $888525ada96954d1$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $888525ada96954d1$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $888525ada96954d1$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $888525ada96954d1$export$54fd2c36b5cc6731);

var $ITAJ1 = parcelRequire("ITAJ1");

var $6VXbJ = parcelRequire("6VXbJ");

var $gthjq = parcelRequire("gthjq");
const $888525ada96954d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $6VXbJ.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $ITAJ1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $ITAJ1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gthjq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gthjq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("ITAJ1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $086f3b754fef02e1$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $086f3b754fef02e1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("g7Cky", function(module, exports) {

$parcel$export(module.exports, "mention", () => $bbcb0873d657d42d$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $bbcb0873d657d42d$export$54fd2c36b5cc6731);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
let $bbcb0873d657d42d$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $bbcb0873d657d42d$export$db83999c14438df4 = (0, $gthjq.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9IGaJ.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $bbcb0873d657d42d$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dx5eC", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9da26af350402964$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $9da26af350402964$export$15ebf236772fa336);

var $gthjq = parcelRequire("gthjq");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9da26af350402964$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9da26af350402964$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$export$63cadbf5f4296627 = (0, $gthjq.nestedExpand)($9da26af350402964$var$nestedExpandFactoryOptions);
const $9da26af350402964$export$15ebf236772fa336 = (0, $gthjq.nestedExpandWithoutNonBodiedMacros)($9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("dwptW", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $9d8207b1e6c47527$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $9d8207b1e6c47527$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $9d8207b1e6c47527$export$b9ab759e8298198f);

var $gthjq = parcelRequire("gthjq");
const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $9d8207b1e6c47527$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("abme3", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $769c2c0b195d79f6$export$9c206ddddb32a9b);

var $gthjq = parcelRequire("gthjq");
const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, $gthjq.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dgJoa", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);

var $gthjq = parcelRequire("gthjq");
const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, $gthjq.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("M4hHz", function(module, exports) {

$parcel$export(module.exports, "rule", () => $0907ce9fea0294ca$export$fbeb3a3956e8a3c7);

var $gthjq = parcelRequire("gthjq");
/**
 * @name rule_node
 */ const $0907ce9fea0294ca$var$hrDOM = [
    'hr'
];
const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, $gthjq.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $0907ce9fea0294ca$var$hrDOM;
    }
});

});

parcelRegister("18bvk", function(module, exports) {

$parcel$export(module.exports, "status", () => $0d2f764e7fea7c00$export$471f7ae5c4103ae1);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, $gthjq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9IGaJ.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iThOL", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, $gthjq.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("43mJF", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $2f3914100d01687b$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $2f3914100d01687b$export$375b6afcc5f4d291);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name taskList_node
 */ const $2f3914100d01687b$var$name = 'actionList';
const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, $gthjq.taskList)({
    parseDOM: [
        {
            tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $2f3914100d01687b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3DR6L", function(module, exports) {

$parcel$export(module.exports, "text", () => $2a6e35cab1a01b8e$export$6f093cfa640b7166);

var $gthjq = parcelRequire("gthjq");
const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, $gthjq.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("9X587", function(module, exports) {

$parcel$export(module.exports, "default", () => $01deabc8204e5493$export$2e2bcd8739ae039);
const $01deabc8204e5493$var$name = 'unknownBlock';
var $01deabc8204e5493$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $01deabc8204e5493$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
        }
    ]
};

});

parcelRegister("d1d6m", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $97a5880db351ce36$export$44b79b0979d0f0f7);

var $gthjq = parcelRequire("gthjq");
const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, $gthjq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("6kr5W", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);

var $gthjq = parcelRequire("gthjq");
const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, $gthjq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("f5oqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de1eca32602d427$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $dGzaM = parcelRequire("dGzaM");
var $9S8fM = parcelRequire("9S8fM");

var $9Iju4 = parcelRequire("9Iju4");
var $fIJEx = parcelRequire("fIJEx");
var $iiXGq = parcelRequire("iiXGq");
var $4ceoy = parcelRequire("4ceoy");
var $2DpUZ = parcelRequire("2DpUZ");

var $gmhCD = parcelRequire("gmhCD");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $iN9lO = parcelRequire("iN9lO");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $4NUlu = parcelRequire("4NUlu");
var $fc6h8 = parcelRequire("fc6h8");

var $VSDnB = parcelRequire("VSDnB");

var $dWAZk = parcelRequire("dWAZk");

var $1PVpv = parcelRequire("1PVpv");

var $gkwXh = parcelRequire("gkwXh");

var $4zXba = parcelRequire("4zXba");

var $8QpSo = parcelRequire("8QpSo");

var $bXrHm = parcelRequire("bXrHm");

var $9gOVJ = parcelRequire("9gOVJ");
var $12yAL = parcelRequire("12yAL");

var $TM1uy = parcelRequire("TM1uy");

var $knXBU = parcelRequire("knXBU");

var $1urn6 = parcelRequire("1urn6");

var $3kKuL = parcelRequire("3kKuL");

var $dyURG = parcelRequire("dyURG");

var $K5Jsy = parcelRequire("K5Jsy");

var $fCNtA = parcelRequire("fCNtA");

var $4BsEy = parcelRequire("4BsEy");

var $1pTqN = parcelRequire("1pTqN");

var $4YrGg = parcelRequire("4YrGg");

var $8Eu7T = parcelRequire("8Eu7T");

var $jUVor = parcelRequire("jUVor");

var $TPpI8 = parcelRequire("TPpI8");

var $kgV4b = parcelRequire("kgV4b");

var $OxITw = parcelRequire("OxITw");

var $3lRy2 = parcelRequire("3lRy2");

var $1SqDw = parcelRequire("1SqDw");

var $glOdv = parcelRequire("glOdv");

var $aagOn = parcelRequire("aagOn");

var $dJPoO = parcelRequire("dJPoO");
function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
const $3de1eca32602d427$export$1b622068be977101 = 3000;
const $3de1eca32602d427$var$packageName = "platform-pkg";
const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
const $3de1eca32602d427$var$setAsQueryContainerStyles = {
    name: "isqlwl",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size;contain:layout style inline-size"
};
class $3de1eca32602d427$export$5161b00bb85c4267 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), /**
   * This is used in measuring the Renderer Mount time and is then
   * deleted once that measurement occurs.
   */ this.renderedMeasurementDistortedDurationMonitor = (0, $ap7h6.getDistortedDurationMonitor)(), this.createRendererContext = (0, $8QpSo.default)((featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                // The context is uninitialized at the top level. In nested levels it's all false
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }), this.fireAnalyticsEvent = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $dWAZk.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        }, this.getSchema = (0, $8QpSo.default)((schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        }), this.onMouseDownEditView = ()=>{
            // When the user is deselecting text on the screen by clicking, if they are clicking outside
            // the current selection, by the time the onclick handler is called the window.getSelection()
            // value will already be cleared.
            // The mousedown callback is called before the selection is cleared.
            const windowSelection = window.getSelection();
            this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
        }, this.handleMouseTripleClickInTables = (event)=>{
            if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
            const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
            const tripleClick = event.detail >= 3;
            if (!(badBrowser && tripleClick)) return;
            const selection = window.getSelection();
            if (!selection) return;
            const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
            const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
            if (!rangeSelection) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const tableCell = target.closest('td,th');
            const clickedInCell = Boolean(tableCell);
            if (!clickedInCell) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const anchorInCell = tableCell.contains(anchorNode);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const focusInCell = tableCell.contains(focusNode);
            const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
            if (!selectionStartsOrEndsOutsideClickedCell) return;
            // If selection starts or ends in a different cell than the clicked cell,
            // we select the node inside the clicked cell (or if both are in a different
            // cell, we select the cell's contents instead). We want to select the nearest
            // parent block, so that a whole line of text/content is selected (rather than
            // selecting a span that would select one specific chunk of text).
            const elementToSelect = anchorInCell ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            focusNode.parentElement?.closest('div,p') : tableCell;
            if (elementToSelect) selection.selectAllChildren(elementToSelect);
        };
        this.providerFactory = props.dataProviders || new (0, $dGzaM.default)();
        this.serializer = new (0, $9gOVJ.default)(this.deriveSerializerProps(props));
        this.editorRef = props.innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${this.id}`);
    }
    anchorLinkAnalytics() {
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const { disableHeadingIDs: disableHeadingIDs } = this.props;
        if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            // We are not use this.editorRef.querySelector here, instead we have this.editorRef.contains
            // because querySelector might fail if there are special characters in hash, and CSS.escape is still experimental.
            if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }
    componentDidMount() {
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).STARTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        });
        this.rafID = requestAnimationFrame(()=>{
            (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                // ED-16320: Check for explicit disable so that by default
                // it will still be enabled as it currently is. Then we can
                // progressively opt out synthetic tenants.
                const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).RENDERED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        duration: duration,
                        distortedDuration: // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                        ttfb: (0, $kFiBa.getResponseEndTime)(),
                        nodes: (0, $kgV4b.countNodes)(this.props.document),
                        severity: severity
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.renderedMeasurementDistortedDurationMonitor.cleanup();
                delete this.renderedMeasurementDistortedDurationMonitor;
            });
            this.anchorLinkAnalytics();
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextMedia = nextProps.media || {};
        const media = this.props.media || {};
        if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextProps.UNSTABLE_isPresentational !== this.props.UNSTABLE_isPresentational || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, $9gOVJ.default)(this.deriveSerializerProps(nextProps));
    }
    deriveSerializerProps(props) {
        // if just passed a boolean, change shape into object to simplify type
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = this.createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos,
            providers: this.providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            isPresentational: props.UNSTABLE_isPresentational,
            // does not currently support SSR, should not be enabled in environments where Renderer is SSR-ed
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }
    render() {
        const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, noOpSSRInlineScript: noOpSSRInlineScript, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media, skipValidation: skipValidation } = this.props;
        const rendererContext = this.createRendererContext(this.props.featureFlags, this.props.isTopLevelRenderer);
        const allowNestedHeaderLinks = (0, $3kKuL.isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
        /**
     * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
     * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
     * renderer out for the editor).
     * @param event Click event anywhere inside renderer
     */ const handleWrapperOnClick = (event)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const targetElement = event.target;
            // ED-14862: When a user triple clicks to select a line of content inside a
            // a table cell, but the browser incorrectly moves the selection start or end into
            // a different table cell, we manually set the selection back to within the original
            // table cell the user intended to target
            this.handleMouseTripleClickInTables(event);
            if (!this.props.eventHandlers?.onUnhandledClick) return;
            if (!(targetElement instanceof window.Element)) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const rendererWrapper = event.currentTarget;
            // Check if the click was on an interactive element
            const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
            if (isInteractiveElementInTree) return;
            // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
            // This logic originated in jira-frontend:
            // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
            // The selection is required to be checked in `onMouseDown` and here. If not here, a new
            // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
            // return an empty selection, which will erroneously fire onUnhandledClick.
            const windowSelection = window.getSelection();
            const selection = windowSelection !== null ? windowSelection.toString() : undefined;
            const hasSelection = selection && selection.length !== 0;
            const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
            const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
            if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
        };
        try {
            const schema = this.getSchema(this.props.schema, this.props.adfStage);
            const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(this.props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(adfDocument) : adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance, this.props.includeNodesCountInStats, skipValidation);
            if (onComplete) onComplete(stat);
            const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
                value: rendererContext
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
                value: (0, $3kKuL.getActiveHeadingId)(allowHeadingAnchorLinks)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
                value: {
                    fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                }
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
                value: this.providerFactory
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: allowColumnSorting,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowCustomPanels: allowCustomPanels,
                allowPlaceholderText: allowPlaceholderText,
                useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                innerRef: this.editorRef,
                onClick: handleWrapperOnClick,
                onMouseDown: this.onMouseDownEditView,
                ssr: media?.ssr,
                isInsideOfInlineExtension: this.props.isInsideOfInlineExtension,
                isTopLevelRenderer: rendererContext.isTopLevelRenderer
            }, enableSsrInlineScripts || noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
                noOpSSRInlineScript: Boolean(noOpSSRInlineScript)
            }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
                doc: pmDoc,
                schema: schema,
                onAnalyticsEvent: this.fireAnalyticsEvent
            }, result)))))));
            const rendererResult = truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
                height: maxHeight,
                fadeHeight: fadeOutHeight
            }, rendererOutput) : rendererOutput;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
        } catch (e) {
            if (onError) onError(e);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowPlaceholderText: allowPlaceholderText,
                allowColumnSorting: allowColumnSorting,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                onClick: handleWrapperOnClick,
                isTopLevelRenderer: rendererContext.isTopLevelRenderer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
        }
    }
    componentWillUnmount() {
        const { dataProviders: dataProviders } = this.props;
        if (this.rafID) window.cancelAnimationFrame(this.rafID);
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) this.providerFactory.destroy();
    }
}
const $3de1eca32602d427$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
    const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 */ const $3de1eca32602d427$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $3de1eca32602d427$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $3de1eca32602d427$var$RendererFunctionalComponent = (props)=>{
    const mouseDownSelection = (0, $5uXOq.useRef)(undefined);
    const providerFactory = (0, $5uXOq.useMemo)(()=>props.dataProviders || new (0, $dGzaM.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $5uXOq.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const deriveSerializerProps = (0, $5uXOq.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    const serializer = (0, $5uXOq.useMemo)(()=>new (0, $9gOVJ.default)(deriveSerializerProps({
            ...props,
            startPos: props.startPos ?? 0
        })), [
        deriveSerializerProps,
        props
    ]);
    const localRef = (0, $5uXOq.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $5uXOq.useMemo)(()=>(0, $ap7h6.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $5uXOq.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $5uXOq.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $5uXOq.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $5uXOq.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).STARTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).RENDERED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $knXBU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $kFiBa.getResponseEndTime)(),
                            nodes: (0, $kgV4b.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
            value: createRendererContext(props.featureFlags, props.isTopLevelRenderer)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
            value: (0, $3kKuL.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: createRendererContext(props.featureFlags, props.isTopLevelRenderer).featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: createRendererContext(props.featureFlags, props.isTopLevelRenderer).isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: createRendererContext(props.featureFlags, props.isTopLevelRenderer).featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: createRendererContext(props.featureFlags, props.isTopLevelRenderer).isTopLevelRenderer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
    }
};
function $3de1eca32602d427$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4YrGg.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { skipValidation: skipValidation } = (0, $5uXOq.useContext)((0, $1SqDw.ValidationContext)) || {};
    return (0, $VSDnB.fg)('platform_editor_react18_renderer') ? /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererFunctionalComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer,
        skipValidation: skipValidation
    }) : // eslint-disable-next-line react/jsx-pascal-case
    /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$5161b00bb85c4267, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer,
        skipValidation: skipValidation
    });
}
const $3de1eca32602d427$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            packageName: $3de1eca32602d427$var$packageName,
            packageVersion: $3de1eca32602d427$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2DpUZ.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Eu7T.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fIJEx.IntlErrorBoundary), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $3de1eca32602d427$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $OxITw.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    (0, $5uXOq.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $OxITw.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $OxITw.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Iju4.BaseTheme), {
        baseFontSize: (0, $aagOn.getBaseFontSize)(appearance)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1urn6.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $glOdv.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && (0, $VSDnB.fg)('platform-fix-table-ssr-resizing') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $3de1eca32602d427$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const rendererRef = (0, $5uXOq.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCNtA.RendererActionsContext), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YrGg.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;

});
parcelRegister("dGzaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $586c606cb83743fd$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $586c606cb83743fd$var$isUndefined(x) {
    return x === undefined;
}
class $586c606cb83743fd$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("9S8fM", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $d1ee541d73df1fcd$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $d1ee541d73df1fcd$export$693cdb10cec23617);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $dGzaM.default)());
const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("9Iju4", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $b0fd15d81ba0fb5a$export$a1a213d350ca51ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");

var $4ceoy = parcelRequire("4ceoy");
function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $VSDnB.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    if ((0, $VSDnB.fg)('live_pages_content_jump_mitigation')) return '2.188rem';
    return "var(--ds-space-500, 40px)";
};
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});
parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig?.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9qwvi = parcelRequire("9qwvi");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        // Note -- you need to set the type to boolean for the default value
        defaultValue: false
    },
    // Added 2024-08-08
    'example-multivariate': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        typeGuard: (0, $9qwvi.oneOf)([
            'one',
            'two',
            'three'
        ]),
        // Note -- you need to specify the type of the default value as the union of all possible values
        // This is used to provide type safety on consumption
        defaultValue: 'one'
    },
    // Added 2024-08-08
    'test-new-experiments-package': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-05
    support_table_in_comment: {
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: {
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: {
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-01
    comment_on_bodied_extensions: {
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: {
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: {
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-10-08
    support_table_in_comment_jira: {
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    'platform_editor_ai-prompts-placeholder': {
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': {
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: {
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: {
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: {
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-01-16
    live_pages_graceful_edit: {
        productKeys: {
            confluence: 'live_pages_graceful_edit'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'text-click-delayed',
            'text-click-no-delay',
            'initially-hide-toolbar'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: {
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-02-10
    platform_editor_controls: {
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'variant1'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-04-14
    platform_editor_controls_shadow: {
        productKeys: {
            confluence: 'platform_editor_controls_shadow'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'variant1'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-02-18
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_non_bodied_macros/setup
    platform_editor_nested_non_bodied_macros: {
        productKeys: {
            confluence: 'platform_editor_nested_non_bodied_macros'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 28-02-2025
    platform_editor_insertion: {
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'variant1'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-02-25
    platform_editor_inline_node_virtualization: {
        productKeys: {
            confluence: 'platform_editor_inline_node_virtualization'
        },
        param: 'variant',
        typeGuard: (0, $9qwvi.oneOf)([
            'off',
            'fallback-small',
            'fallback-large'
        ]),
        defaultValue: 'off'
    },
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: {
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-03-13
    editor_text_highlight_orange_to_yellow: {
        productKeys: {
            confluence: 'editor_text_highlight_orange_to_yellow'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: {
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'variant1'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: {
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-03-26
    platform_editor_markdown_next_media_plugin_exp: {
        productKeys: {
            confluence: 'platform_editor_markdown_next_media_plugin_exp'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: {
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        typeGuard: (0, $9qwvi.oneOf)([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: {
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-04-17
    platform_editor_tables_table_selector: {
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    },
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: {
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: false
    }
};

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});


parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});



parcelRegister("4ceoy", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $a2904bcfe480568e$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $a2904bcfe480568e$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $a2904bcfe480568e$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $a2904bcfe480568e$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $a2904bcfe480568e$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $gJlZe = parcelRequire("gJlZe");

var $1v3g5 = parcelRequire("1v3g5");
function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2904bcfe480568e$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
    };
}
const $a2904bcfe480568e$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, $8QpSo.default)(()=>{
    return (0, $1v3g5.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
    const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
    const widthRef = (0, $5uXOq.useRef)(width);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $5uXOq.useMemo)(()=>{
        return (0, $7nRxN.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a2904bcfe480568e$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($a2904bcfe480568e$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1v3g5", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $161da1f5bf80dbfb$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("fIJEx", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $f1eccfecc1c43fb5$export$7df0749115d18d19);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("iiXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $94120525d10931b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $94120525d10931b9$var$blockNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent, (0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $94120525d10931b9$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $94120525d10931b9$export$2e2bcd8739ae039 = (0, $8RXs9.default)($94120525d10931b9$var$UnsupportedBlockNode);

});
parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("7R1zM", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $757d518931aaa671$export$32ec96484dd3ba39);

var $7VHMR = parcelRequire("7VHMR");
const $757d518931aaa671$export$32ec96484dd3ba39 = (0, $7VHMR.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9tFGn", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("2DpUZ", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $10143a74d71d9da7$export$9ac3d19711324187);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
const $10143a74d71d9da7$export$9ac3d19711324187 = (0, $cb25w.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gE8f9", function(module, exports) {

$parcel$export(module.exports, "browser", () => $6911d91f679e4e6c$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("iN9lO", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $420059dd531814dc$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $420059dd531814dc$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $420059dd531814dc$export$6f766653554dac02);

var $b7gJe = parcelRequire("b7gJe");
const $420059dd531814dc$var$measureMap = new Map();
function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $420059dd531814dc$var$measureMap.set(measureName, performance.now());
}
function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $420059dd531814dc$export$6f766653554dac02(measureName);
    }
}
function $420059dd531814dc$export$6f766653554dac02(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    $420059dd531814dc$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $420059dd531814dc$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return false;
    return $420059dd531814dc$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("b7gJe", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $da51e67df7144cd5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $da51e67df7144cd5$export$48995af1e77d8643);
let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
    if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
}
function $da51e67df7144cd5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $da51e67df7144cd5$export$4370ec0f52022f66() {
    return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("ap7h6", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $3e05ce213e57560b$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $3e05ce213e57560b$export$267ed650a5d21ae6);

var $b7gJe = parcelRequire("b7gJe");
const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $3e05ce213e57560b$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("kFiBa", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $9d05c46136d117ff$export$92d097a1155bbe27);

var $b7gJe = parcelRequire("b7gJe");
function $9d05c46136d117ff$export$92d097a1155bbe27() {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $d9ce436f8d702318$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $d9ce436f8d702318$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $hFEwm.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("5r0mK", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $3f4fc20879d21ebe$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $3f4fc20879d21ebe$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $3f4fc20879d21ebe$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $3f4fc20879d21ebe$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $3f4fc20879d21ebe$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $3f4fc20879d21ebe$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $3f4fc20879d21ebe$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $3f4fc20879d21ebe$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $3f4fc20879d21ebe$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $3f4fc20879d21ebe$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $3f4fc20879d21ebe$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $3f4fc20879d21ebe$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $3f4fc20879d21ebe$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $3f4fc20879d21ebe$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $3f4fc20879d21ebe$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $3f4fc20879d21ebe$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $3f4fc20879d21ebe$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $3f4fc20879d21ebe$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $3f4fc20879d21ebe$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $3f4fc20879d21ebe$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $3f4fc20879d21ebe$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
    if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
    if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
};
var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
            }
        }
        if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $3f4fc20879d21ebe$var$cloneTr(tr);
        }
        return tr;
    };
var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
    };
var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
    };
var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
};
var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("hFEwm", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $451fe475e5e2c47a$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $6MNnJ = parcelRequire("6MNnJ");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");

var $6e6o8 = parcelRequire("6e6o8");

var $aKDxB = parcelRequire("aKDxB");

var $bQFBc = parcelRequire("bQFBc");
class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, $gZGBX.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $aKDxB.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $6hQQ3.pointsAtCell)($anchorCell) && (0, $6hQQ3.pointsAtCell)($headCell) && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $gZGBX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $6e6o8.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $6e6o8.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $kCV8T.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
        }
        const sel = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $uOUlv.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $6MNnJ.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $gZGBX.Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);

});
parcelRegister("6MNnJ", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $7bc56074adb266b5$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");

var $bQFBc = parcelRequire("bQFBc");
class $7bc56074adb266b5$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $gZGBX.Selection).fromJSON(doc, data);
        }
        return (0, $gZGBX.Selection).near($headCell, 1);
    }
}

});
parcelRegister("bQFBc", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e501ca8feab95168$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e501ca8feab95168$export$debd62b44eb7e281);
function $e501ca8feab95168$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("uOUlv", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $ca500cf7ecedd822$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $ca500cf7ecedd822$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $ca500cf7ecedd822$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $ca500cf7ecedd822$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $ca500cf7ecedd822$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $ca500cf7ecedd822$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
class $ca500cf7ecedd822$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
    }
}
// Compute a table map.
function $ca500cf7ecedd822$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $ca500cf7ecedd822$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $ca500cf7ecedd822$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca500cf7ecedd822$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("6hQQ3", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $6704a47d099ba366$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $6704a47d099ba366$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $6704a47d099ba366$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $6704a47d099ba366$export$172699367bb25225);

var $uOUlv = parcelRequire("uOUlv");
function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("6e6o8", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $44eb8577da1c519b$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $44eb8577da1c519b$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $44eb8577da1c519b$export$147ee78a1321ac36);
function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("aKDxB", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $d20b421410b3cfed$export$a60a444208fd5099);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");
function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $gZGBX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("fc6h8", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $d5e5ded83470406e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("4zXba", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $e819a2725d93345d$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $e819a2725d93345d$export$6d018dd0f6cbebcb);

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");
const $e819a2725d93345d$var$EMPTY = {};
function $e819a2725d93345d$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $e819a2725d93345d$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($e819a2725d93345d$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("9gOVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549b54270369c2c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kCV8T = parcelRequire("kCV8T");

var $gmhCD = parcelRequire("gmhCD");

var $3kKuL = parcelRequire("3kKuL");
parcelRequire("gJX6d");
var $5KNWO = parcelRequire("5KNWO");
var $gJX6d = parcelRequire("gJX6d");

var $5BLIh = parcelRequire("5BLIh");

var $cKKwC = parcelRequire("cKKwC");
var $GDkvY = parcelRequire("GDkvY");

var $eQNWQ = parcelRequire("eQNWQ");

var $5or39 = parcelRequire("5or39");

var $K5Jsy = parcelRequire("K5Jsy");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $bzwTW = parcelRequire("bzwTW");

var $bVGKe = parcelRequire("bVGKe");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kCV8T.MarkType) && prev && prev.type instanceof (0, $kCV8T.MarkType) && Array.isArray(prev.content) && (0, $eQNWQ.isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $a549b54270369c2c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gJX6d.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $GDkvY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $cKKwC.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $cKKwC.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bVGKe.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5KNWO.DocWithSelectAllTrap) : (0, $5KNWO.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gJX6d.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gJX6d.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $GDkvY.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5BLIh.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $h5tvG.segmentText)(mark.text, this.textHighlighter);
        return (0, $3VpWO.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $bzwTW.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $bzwTW.insideTable)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $bzwTW.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: // When allowTableResizing is enabled, the number of columns is required to render
            // the same scaling logic as editor. Some tables can have unequal rows, so the entire
            // table needs to be scanned.
            this.allowTableResizing && (0, $VSDnB.fg)('platform_editor_table_col_calculation_fix') ? (0, $5or39.getColumnWidths)(node) : (0, $5or39.calcTableColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $VSDnB.fg)('platform_renderer_isPresentational') ? this.isPresentational : false
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $K5Jsy.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gJX6d.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $eQNWQ.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("3kKuL", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $e845fca6b21fd822$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $e845fca6b21fd822$export$acb253d79d72af92);
function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gJX6d", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $2b5167c1d6aa176d$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $2b5167c1d6aa176d$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $2b5167c1d6aa176d$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $2b5167c1d6aa176d$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $2b5167c1d6aa176d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5KNWO")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5KNWO")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4qBtX = parcelRequire("4qBtX");

var $iiXGq = parcelRequire("iiXGq");
var $9kpKZ = parcelRequire("9kpKZ");

var $VSDnB = parcelRequire("VSDnB");

var $atrOQ = parcelRequire("atrOQ");

var $4dtZR = parcelRequire("4dtZR");

var $2SZph = parcelRequire("2SZph");

var $bQeYo = parcelRequire("bQeYo");

var $cOnYv = parcelRequire("cOnYv");

var $cWRvh = parcelRequire("cWRvh");

var $5KNWO = parcelRequire("5KNWO");

var $i8Zwf = parcelRequire("i8Zwf");

var $lKIDi = parcelRequire("lKIDi");

var $7AttJ = parcelRequire("7AttJ");

var $112O7 = parcelRequire("112O7");

var $ieJGA = parcelRequire("ieJGA");

var $3RqVz = parcelRequire("3RqVz");

var $qjsNK = parcelRequire("qjsNK");

var $jHa9U = parcelRequire("jHa9U");

var $6svWT = parcelRequire("6svWT");

var $9FXQX = parcelRequire("9FXQX");

var $hqBb9 = parcelRequire("hqBb9");

var $ixoQV = parcelRequire("ixoQV");

var $dkc63 = parcelRequire("dkc63");

var $cWojJ = parcelRequire("cWojJ");

var $i4Lgj = parcelRequire("i4Lgj");

var $gfMkN = parcelRequire("gfMkN");

const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("b7uH5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4nigH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jjsQN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("0K8mZ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("k7Zs2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aNesC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("57OMq")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bfPot")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7mtWi")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("cyYfQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bat28")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iyg8s")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gQJy5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7UIjK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("ftKE0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4kfHt")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hPQIC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3ceee")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bbv0R")).then((mod)=>mod.default),
    loading: ()=>null
});
const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
    blockquote: (0, $atrOQ.default),
    bulletList: (0, $cWRvh.default),
    blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
    caption: (0, $jHa9U.default),
    date: $2b5167c1d6aa176d$export$6341f9a885713487,
    decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
    decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
    doc: (0, $5KNWO.default),
    emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
    extension: (0, $i8Zwf.default),
    bodiedExtension: (0, $4dtZR.default),
    multiBodiedExtension: (0, $bQeYo.default),
    extensionFrame: (0, $cOnYv.default),
    hardBreak: (0, $lKIDi.default),
    heading: (0, $7AttJ.default),
    inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
    inlineExtension: (0, $112O7.default),
    layoutSection: (0, $ieJGA.default),
    layoutColumn: (0, $3RqVz.default),
    listItem: (0, $qjsNK.default),
    media: $2b5167c1d6aa176d$export$7fc53215244aec38,
    mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
    mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
    mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
    mention: $2b5167c1d6aa176d$export$e891316fea657d90,
    orderedList: (0, $6svWT.default),
    panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
    paragraph: (0, $9FXQX.default),
    placeholder: (0, $hqBb9.default),
    rule: (0, $ixoQV.default),
    status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
    taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
    taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
    table: (0, $dkc63.default),
    tableCell: (0, $cWojJ.TableCell),
    tableHeader: (0, $cWojJ.TableHeader),
    tableRow: (0, $i4Lgj.default),
    unknownBlock: (0, $gfMkN.default),
    unsupportedBlock: (0, $iiXGq.default),
    unsupportedInline: (0, $9kpKZ.default),
    expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
};
const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5KNWO.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
        return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $bQeYo.default) : (0, $2SZph.default);
    return nodes[node.type.name];
};
const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
};
const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("9kpKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b743bc5ccb58a13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $5b743bc5ccb58a13$var$inlineNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5b743bc5ccb58a13$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);

});

parcelRegister("atrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d51d57a125840f5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("blockquote", {
        children: props.children
    });
}

});

parcelRegister("4dtZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e9d2beaec6b895$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Zwf = parcelRequire("i8Zwf");

var $8Eu7T = parcelRequire("8Eu7T");

var $fAZXL = parcelRequire("fAZXL");

var $cWCI0 = parcelRequire("cWCI0");

var $gkwXh = parcelRequire("gkwXh");

var $4YrGg = parcelRequire("4YrGg");
const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Eu7T.ErrorBoundary), {
        component: (0, $cWCI0.ACTION_SUBJECT).RENDERER,
        componentId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4YrGg.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
                ...props,
                type: "bodiedExtension",
                children: ({ result: result })=>{
                    try {
                        if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                        return (0, $i8Zwf.renderExtension)(result, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                    } catch (e) {
                    /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                    // Always return default content if anything goes wrong
                    return (0, $i8Zwf.renderExtension)(children, layout, {
                        isTopLevel: path.length < 1
                    }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                }
            })
        })
    });
};
var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;

});
parcelRegister("i8Zwf", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $1a97cbb70a611ae8$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $1a97cbb70a611ae8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $l8Gxi = parcelRequire("l8Gxi");
const $1a97cbb70a611ae8$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $1a97cbb70a611ae8$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $1a97cbb70a611ae8$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $1a97cbb70a611ae8$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $1a97cbb70a611ae8$var$macroHeights[viewportSize];
    }
};
const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes)=>{
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    const viewportSize = $1a97cbb70a611ae8$var$getViewportSize(extensionId, extensionViewportSizes);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%',
                    minHeight: viewportSize
                },
                "data-layout": layout,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $1a97cbb70a611ae8$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes);
        }
    });
};
var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, $ajc8Z.default)($1a97cbb70a611ae8$var$Extension, {
    overflowSelector: `.${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("fAZXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cce7a6859f4709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9Egzu = parcelRequire("9Egzu");

var $2vGdQ = parcelRequire("2vGdQ");
const $45cce7a6859f4709$var$inlineExtensionStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2vGdQ.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)($45cce7a6859f4709$var$InlineNodeRendererWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $45cce7a6859f4709$var$InlineNodeRendererWrapper = ({ children: children })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: "inline-extension-renderer",
        css: $45cce7a6859f4709$var$inlineExtensionStyle
    }, children));
};

});
parcelRegister("gnH2s", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $36d4284a17bc60a0$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $36d4284a17bc60a0$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $36d4284a17bc60a0$export$67a7d49db68d30a0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $izxHQ = parcelRequire("izxHQ");
async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $36d4284a17bc60a0$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>{
            return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $izxHQ.resolveImport)(node.render()));
        },
        loading: $36d4284a17bc60a0$var$ExtensionLoading
    });
}

});
parcelRegister("izxHQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $23c4e3f9598df846$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $23c4e3f9598df846$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $23c4e3f9598df846$export$d69c9b451c47653b);
const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
}
const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("9Egzu", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $76144329c6f313cf$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");
class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("2vGdQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $f7ce50c6d2d400b7$export$9214452ef07eda7);
function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("ajc8Z", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $0d6cb6e0383d0ba0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bbl9Y = parcelRequire("bbl9Y");
const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $bbl9Y.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("bbl9Y", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $cd027df5593f4e8b$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $cd027df5593f4e8b$export$51a5b28e4fb2dba2);
var $cd027df5593f4e8b$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("eOOFp", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $081c5ce54850cd88$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $081c5ce54850cd88$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $081c5ce54850cd88$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $081c5ce54850cd88$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $081c5ce54850cd88$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $081c5ce54850cd88$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $081c5ce54850cd88$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $081c5ce54850cd88$export$70d1bf7729efff40);

var $iHYdz = parcelRequire("iHYdz");

var $8DYpW = parcelRequire("8DYpW");

var $9Iju4 = parcelRequire("9Iju4");

var $4ceoy = parcelRequire("4ceoy");

var $eQcNy = parcelRequire("eQcNy");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
    padding: (0, $iHYdz.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $iHYdz.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $iHYdz.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $iHYdz.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $iHYdz.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $9Iju4.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4ceoy.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                const wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcBreakoutWithCustomWidth: (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            // if below 0 then expect we're rendering in SSR
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(mode, editorContainerWidth);
    },
    calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $iHYdz.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
const $081c5ce54850cd88$export$ccc0a02edddeed39 = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth;
function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $eQcNy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $eQcNy.parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $8DYpW.default).layoutFixedWidth;
        case 'wide':
            return (0, $8DYpW.default).layoutFullWidth;
        default:
            return (0, $8DYpW.default).layoutWide;
    }
};

});
parcelRegister("8DYpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb832a3bfaa1d66d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7VHMR = parcelRequire("7VHMR");

var $l9HLU = parcelRequire("l9HLU");

var $8cp3a = parcelRequire("8cp3a");

var $1C4XH = parcelRequire("1C4XH");

var $9NKqk = parcelRequire("9NKqk");

var $fJyLQ = parcelRequire("fJyLQ");

var $gSYO9 = parcelRequire("gSYO9");

var $jDuvE = parcelRequire("jDuvE");


var $lQKNV = parcelRequire("lQKNV");

var $2i4K4 = parcelRequire("2i4K4");

var $eX53M = parcelRequire("eX53M");

var $80CM7 = parcelRequire("80CM7");

var $kXnoC = parcelRequire("kXnoC");

var $eDTMN = parcelRequire("eDTMN");

var $2V0EL = parcelRequire("2V0EL");

var $kFJBG = parcelRequire("kFJBG");

var $7S9ZN = parcelRequire("7S9ZN");

var $6OcHr = parcelRequire("6OcHr");

var $dbepQ = parcelRequire("dbepQ");

var $kANLZ = parcelRequire("kANLZ");

var $kmmxF = parcelRequire("kmmxF");

var $80TXs = parcelRequire("80TXs");

var $9QBHe = parcelRequire("9QBHe");

var $1IiUD = parcelRequire("1IiUD");

var $kAM3u = parcelRequire("kAM3u");

var $6lWmZ = parcelRequire("6lWmZ");

var $ixwvf = parcelRequire("ixwvf");

var $fJm1A = parcelRequire("fJm1A");

var $ecAvy = parcelRequire("ecAvy");

var $7ywdr = parcelRequire("7ywdr");

var $1ElKj = parcelRequire("1ElKj");



var $3AEXe = parcelRequire("3AEXe");


var $2y1kv = parcelRequire("2y1kv");
var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'View more options in toolbar'
    }
});

});
parcelRegister("l9HLU", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $c0194801a7a2c28d$export$5229ffea355cfdf6);

var $7VHMR = parcelRequire("7VHMR");
const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, $7VHMR.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("8cp3a", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $0f161f19f888f3d2$export$ff612ca71703201d);

var $7VHMR = parcelRequire("7VHMR");
const $0f161f19f888f3d2$export$ff612ca71703201d = (0, $7VHMR.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("1C4XH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11841756f48da98b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $11841756f48da98b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    }
});

});

parcelRegister("9NKqk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f845f8650b83fa4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f845f8650b83fa4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("fJyLQ", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $bc1b61e25b99393f$export$42bb270d1224182);

var $7VHMR = parcelRequire("7VHMR");
const $bc1b61e25b99393f$export$42bb270d1224182 = (0, $7VHMR.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("gSYO9", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $6ccabeb0d4490fe2$export$4ce3884394d6d9);

var $7VHMR = parcelRequire("7VHMR");
const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("jDuvE", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $8ffd20c106600435$export$2d7676d841c8ae9);

var $7VHMR = parcelRequire("7VHMR");
const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, $7VHMR.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'Go to link preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("lQKNV", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $20d0fb06aaa96548$export$74e304339778e94d);

var $7VHMR = parcelRequire("7VHMR");
const $20d0fb06aaa96548$export$74e304339778e94d = (0, $7VHMR.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("2i4K4", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $4423ee10317a70cf$export$70c8a7203d95247);

var $7VHMR = parcelRequire("7VHMR");
const $4423ee10317a70cf$export$70c8a7203d95247 = (0, $7VHMR.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("eX53M", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("80CM7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $402c787ddf19f01c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $402c787ddf19f01c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("kXnoC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19e3f2f865259995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19e3f2f865259995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("eDTMN", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ec9866e02d0168cb$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("2V0EL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcecf16097bd0035$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bcecf16097bd0035$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kFJBG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a872fd5a03f73724$export$defe85febe8b728c);
// Common Translations will live here

var $7VHMR = parcelRequire("7VHMR");
const $a872fd5a03f73724$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7S9ZN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9078664297972b18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9078664297972b18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("6OcHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b883afcc2fb8665e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b883afcc2fb8665e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("dbepQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19b9098ff265842b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19b9098ff265842b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("kANLZ", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $2ae4030e88533f57$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("kmmxF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4735e0a5cdca6f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("80TXs", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $cedd04a0024a64f8$export$8a0e7c3f8f5b8868);

var $7VHMR = parcelRequire("7VHMR");
const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, $7VHMR.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("9QBHe", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $b943fdad34912591$export$b46a930e1a386b2e);

var $7VHMR = parcelRequire("7VHMR");
const $b943fdad34912591$export$b46a930e1a386b2e = (0, $7VHMR.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("1IiUD", function(module, exports) {

$parcel$export(module.exports, "elementInsertSidePanel", () => $97dbccb0b0b981b3$export$276a218f93338b76);

var $7VHMR = parcelRequire("7VHMR");
const $97dbccb0b0b981b3$export$276a218f93338b76 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'fabric.editor.elementInsertSidePanel.title',
        defaultMessage: 'Insert',
        description: 'Title of a panel that opens on the side'
    }
});

});

parcelRegister("kAM3u", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $147c4cd461faf1fe$export$effb4ee8b6f74abe);

var $7VHMR = parcelRequire("7VHMR");
const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, $7VHMR.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("6lWmZ", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $65d46911a2519e83$export$273d864e9e6d0b1f);

var $7VHMR = parcelRequire("7VHMR");
const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, $7VHMR.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("ixwvf", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $358e275c47040b0e$export$ee8ab8a034b5a8bd);

var $7VHMR = parcelRequire("7VHMR");
const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, $7VHMR.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    }
});

});

parcelRegister("fJm1A", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $b0fedd2e9a93e39a$export$703e803e9cb0cea4);

var $7VHMR = parcelRequire("7VHMR");
const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, $7VHMR.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("ecAvy", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $e955dc2d97d725ff$export$7bb18eb6f9170174);

var $7VHMR = parcelRequire("7VHMR");
const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, $7VHMR.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("7ywdr", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a3d6d16f96d339d5$export$33aafd5ccbbbd00a);

var $7VHMR = parcelRequire("7VHMR");
const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, $7VHMR.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("1ElKj", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $691908dbd48d7aae$export$83c85447c71428ba);

var $7VHMR = parcelRequire("7VHMR");
const $691908dbd48d7aae$export$83c85447c71428ba = (0, $7VHMR.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("3AEXe", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $a755ba82139b4a7d$export$7eb9dc59242bbc45);

var $7VHMR = parcelRequire("7VHMR");
const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, $7VHMR.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("2y1kv", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarMessages", () => $14d5a3715e7fc293$export$b0226831bf5c0d3e);

var $7VHMR = parcelRequire("7VHMR");
const $14d5a3715e7fc293$export$b0226831bf5c0d3e = (0, $7VHMR.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    }
});

});


parcelRegister("eQcNy", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $ab609be3c0cbf6e9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $ab609be3c0cbf6e9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $ab609be3c0cbf6e9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $ab609be3c0cbf6e9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
    return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
}
function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
    return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("l8Gxi", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $ca55565f908e8e5d$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
    EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("8Eu7T", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $19f8e43ef61748ed$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $1KzE6 = parcelRequire("1KzE6");

var $knXBU = parcelRequire("knXBU");

var $7Jxgt = parcelRequire("7Jxgt");
class $19f8e43ef61748ed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("1KzE6", function(module, exports) {

$parcel$export(module.exports, "logException", () => $8cb678cf4830ec10$export$f86b2a1a2ce291b3);

var $8eFcy = parcelRequire("8eFcy");
const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8cb678cf4830ec10$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("7zlsW"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("flvpo"));
        const sentryOptions = {
            dsn: (0, $8eFcy.isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
            release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("8eFcy", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $1a8a754a294d51a4$export$64d6499adf9b2e51);
const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("7zlsW", function(module, exports) {

let $582c73f21a40a7b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $582c73f21a40a7b7$var$load("kfXhT"),
    $582c73f21a40a7b7$var$load("2Lfdl"),
    $582c73f21a40a7b7$var$load("56SDo")
]).then(()=>parcelRequire('hFoxV'));

});

parcelRegister("flvpo", function(module, exports) {

let $b2c12e3f5036cd41$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b2c12e3f5036cd41$var$load("kfXhT"),
    $b2c12e3f5036cd41$var$load("2Lfdl"),
    $b2c12e3f5036cd41$var$load("a12Xb")
]).then(()=>parcelRequire('1dEW4'));

});


parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});


parcelRegister("cWCI0", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $78ed418dcea0e38c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $78ed418dcea0e38c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $78ed418dcea0e38c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $78ed418dcea0e38c$export$9957974f8b4d8f74);
var $78ed418dcea0e38c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $78ed418dcea0e38c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $78ed418dcea0e38c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $78ed418dcea0e38c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("4YrGg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $5dd0541565473935$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $5dd0541565473935$export$cef0157dd42cbb3f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $eka68 = parcelRequire("eka68");

var $8Mz83 = parcelRequire("8Mz83");

var $iYAgE = parcelRequire("iYAgE");

var $joddd = parcelRequire("joddd");

var $1oOiu = parcelRequire("1oOiu");

var $2NMNM = parcelRequire("2NMNM");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $5dd0541565473935$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $joddd.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $5dd0541565473935$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    startPos: 1
});
const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1oOiu.useAnnotationStateByTypeEvent)({
        type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.InlineCommentsStateContext).Provider, {
            value: inlineCommentAnnotationsState,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2EsbE.AnnotationRangeProvider), {
                allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuusl.AnnotationHoverContext), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8Mz83.AnnotationsContextWrapper), {
                        createAnalyticsEvent: createAnalyticsEvent,
                        rendererRef: rendererRef,
                        isNestedRender: isNestedRender,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$var$LoadAnnotations, {
                                adfDocument: adfDocument,
                                isNestedRender: isNestedRender,
                                onLoadComplete: onLoadComplete
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eka68.AnnotationView), {
                                isNestedRender: isNestedRender,
                                createAnalyticsEvent: createAnalyticsEvent
                            }),
                            children
                        ]
                    })
                })
            })
        })
    });
};

});
parcelRegister("eka68", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $38b360e678e45e5a$export$41cd4a02859c2806);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $1oOiu = parcelRequire("1oOiu");

var $fCNtA = parcelRequire("fCNtA");
const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1oOiu.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("iYAgE", function(module, exports) {

$parcel$export(module.exports, "AnnotationsDraftContext", () => $1cf3b601714e6f28$export$365d1799d81a236d);
$parcel$export(module.exports, "ProvidersContext", () => $1cf3b601714e6f28$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1cf3b601714e6f28$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $1cf3b601714e6f28$export$153126608e00390);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $1cf3b601714e6f28$export$365d1799d81a236d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5uXOq.createContext)({});
class $1cf3b601714e6f28$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, isNestedRender: isNestedRender } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        /*
		 * If this is a nested render, we do not provide the draft context
		 * because it has already been provided higher up the component tree
		 * and we need the original context to create draft annotations on extensions.
		 */ return isNestedRender && (0, $VSDnB.fg)('confluence_frontend_fix_extension_draft_annotation') ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-testid": "context-wrapper-without-provider",
            children: children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)($1cf3b601714e6f28$export$365d1799d81a236d.Provider, {
            value: position,
            children: children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            position: null
        }, this.applyAnnotationDraftAt = (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        }, this.clearAnnotationDraft = ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        };
    }
}

});

parcelRegister("1oOiu", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $477334c02b9da473$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $477334c02b9da473$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $477334c02b9da473$export$26cf539704e444c1);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $88i6h = parcelRequire("88i6h");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");
const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        };
    }, [
        states,
        type,
        updateSubscriber
    ]);
    return states;
};
const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
        };
    }, [
        id,
        updateSubscriber
    ]);
    return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
        updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        return ()=>{
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        };
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender
    ]);
    return annotationClickEvent;
};

});
parcelRegister("dEtqo", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $916fd31c0363f129$export$c1c4b33b4e7b1c70);

var $6Oghe = parcelRequire("6Oghe");
var $916fd31c0363f129$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $916fd31c0363f129$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();
    }
}

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("fCNtA", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7e61ed70df2336e9$export$66feffbad722f9d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6pY1y = parcelRequire("6pY1y");
const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $6pY1y.default)());
function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $5uXOq.useMemo)(()=>new (0, $6pY1y.default)(true), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children)
    });
}
const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6pY1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7850a7dc1aaf7e$export$2e2bcd8739ae039);

var $88i6h = parcelRequire("88i6h");

var $h03xs = parcelRequire("h03xs");

var $hYNZx = parcelRequire("hYNZx");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $VSDnB = parcelRequire("VSDnB");

var $cMPbW = parcelRequire("cMPbW");

var $4apTl = parcelRequire("4apTl");

var $hAPWV = parcelRequire("hAPWV");
class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $hYNZx.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $gZGBX.TextSelection).create(this.doc, from, to);
        if ((0, $h03xs.isEmptyTextSelection)(currentSelection, this.schema)) return false;
        return (0, $h03xs.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eS2Dn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eS2Dn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).DELETED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eS2Dn.RemoveMarkStep) ? (0, $4apTl.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cMPbW.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $h03xs.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eS2Dn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cMPbW.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $4apTl.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $h03xs.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("h03xs", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $ccb20202dc8fa865$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $ccb20202dc8fa865$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $ccb20202dc8fa865$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $ccb20202dc8fa865$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $ccb20202dc8fa865$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $ccb20202dc8fa865$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $ccb20202dc8fa865$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $ccb20202dc8fa865$export$2efbc6d84ea0fbec);

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");
const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("hYNZx", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $c960adc5c7547145$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $c960adc5c7547145$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ajpes = parcelRequire("ajpes");

var $8vlrc = parcelRequire("8vlrc");
var $cUwVZ = parcelRequire("cUwVZ");
var $7kC9H = parcelRequire("7kC9H");
var $29Vii = parcelRequire("29Vii");
var $8XeG6 = parcelRequire("8XeG6");
var $bIGZ7 = parcelRequire("bIGZ7");
var $7agO8 = parcelRequire("7agO8");
var $g7Cky = parcelRequire("g7Cky");
var $9UDEr = parcelRequire("9UDEr");

var $kOFhM = parcelRequire("kOFhM");

var $fVI2q = parcelRequire("fVI2q");

var $0Cgjx = parcelRequire("0Cgjx");
var $c960adc5c7547145$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c960adc5c7547145$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
    }
    return output;
};
const $c960adc5c7547145$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, $bIGZ7.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, $g7Cky.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, $8vlrc.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, $9UDEr.tableToJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, $9UDEr.toJSONTableCell)(node).attrs;
    else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, $9UDEr.toJSONTableHeader)(node).attrs;
    else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, $7kC9H.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
    if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
    });
    if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, $8XeG6.toJSON)(mark);
            else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                const serialised = (0, $cUwVZ.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $29Vii.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fVI2q.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $c960adc5c7547145$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $kOFhM.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
        return $c960adc5c7547145$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $kOFhM.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("fVI2q", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $7f7cf8cf5d94f891$export$28e4e3c024cce988);
const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
        default:
            return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("0Cgjx", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $45db1c8142107da9$export$48b382180baf8e88);

var $aSk3Q = parcelRequire("aSk3Q");

var $l1C1k = parcelRequire("l1C1k");

var $VSDnB = parcelRequire("VSDnB");

var $hRZSy = parcelRequire("hRZSy");
const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $45db1c8142107da9$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $hRZSy.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $hRZSy.removeNonAnnotationMarks),
        mention: (0, $hRZSy.removeNonAnnotationMarks),
        date: (0, $hRZSy.removeNonAnnotationMarks),
        hardBreak: (0, $hRZSy.removeMarks),
        inlineCard: (0, $hRZSy.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("aSk3Q", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $2dd8f1bba9a54435$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $2dd8f1bba9a54435$export$8a334a7d9fe120ec);

var $l1C1k = parcelRequire("l1C1k");

var $gxbjN = parcelRequire("gxbjN");

var $8YCkv = parcelRequire("8YCkv");
const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $2dd8f1bba9a54435$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
function $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf, options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        extension: (node, parent)=>{
            if ($2dd8f1bba9a54435$export$f45e7335ec874bfe(node)) {
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent)) return undefined;
                isTransformed = true;
                return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $gxbjN.extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("gxbjN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $ec4576859225619a$export$1b45514b112dd749);
const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8YCkv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $b0271efedae2a0b7$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("hRZSy", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7e7bed7752b3d3e8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7e7bed7752b3d3e8$export$8cae9126fc577085);
function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("cMPbW", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $c9441534493a403f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $c9441534493a403f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $c9441534493a403f$export$74899f7e5acb5cd3);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
function $c9441534493a403f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
function $c9441534493a403f$var$isPositionPointer(element) {
    return $c9441534493a403f$var$getStartPos(element) > -1;
}
function $c9441534493a403f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
    return $c9441534493a403f$var$findParent(parentElement);
}
function $c9441534493a403f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $c9441534493a403f$var$findMediaParent(parentElement);
}
function $c9441534493a403f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
    return $c9441534493a403f$var$findParentBeforePointer(parentElement);
}
function $c9441534493a403f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $c9441534493a403f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $c9441534493a403f$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $c9441534493a403f$var$isNodeInlineMark(node) {
    return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $c9441534493a403f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $c9441534493a403f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
    if ($c9441534493a403f$var$isElementNode(node)) {
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $c9441534493a403f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if ((0, $VSDnB.fg)('platform_editor_annotation_position_comment_nodes')) {
            if (prev.nodeType === Node.COMMENT_NODE) {
                // Comment nodes should not result in the position being
                // incremented, so we skip them.
                prev = prev.previousSibling;
                continue;
            }
        }
        if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $c9441534493a403f$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $c9441534493a403f$var$getStartPos(node) + offset;
    }
    const parent = $c9441534493a403f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eS2Dn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("4apTl", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $3b0115c3167e4664$export$b0ea72d31617ccea);

var $h03xs = parcelRequire("h03xs");

var $VSDnB = parcelRequire("VSDnB");
function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $h03xs.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("hAPWV", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $8b6d6fb20e026dde$export$fb7dab895a0d310e);
function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});




parcelRegister("8Mz83", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $68c25c02b6872087$export$787af8a111ff3c03);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $6MIvG = parcelRequire("6MIvG");

var $iatcV = parcelRequire("iatcV");

var $2EsbE = parcelRequire("2EsbE");
const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children, isNestedRender: isNestedRender } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                children,
                !!hoverComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MIvG.RangeValidator), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    component: hoverComponent,
                    applyAnnotationDraftAt: applyAnnotationDraftAt,
                    clearAnnotationDraft: clearAnnotationDraft
                }),
                !!selectionComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iatcV.SelectionRangeValidator), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    selectionComponent: selectionComponent,
                    applyAnnotationDraftAt: applyAnnotationDraftAt,
                    clearAnnotationDraft: clearAnnotationDraft
                })
            ]
        });
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft,
        isNestedRender: isNestedRender,
        children: render
    });
};

});
parcelRegister("6MIvG", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $38d3fe2fadcf735b$export$6d8376a902cb8aa7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7g31n = parcelRequire("7g31n");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $kuusl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7g31n.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("7g31n", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $3da53cae08f8e9e6$export$2109cd350bcf6eda);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $fCNtA = parcelRequire("fCNtA");
const $3da53cae08f8e9e6$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $c2a45e53becb69f1$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $c2a45e53becb69f1$export$e14699d956e87e73);
const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
    const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});


parcelRegister("2EsbE", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $7c7af48337b91c7a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $7c7af48337b91c7a$export$708fc397e2b6f08d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $7c7af48337b91c7a$var$reducer(state, action) {
    switch(action.type){
        case 'clear':
            if (!!state.range || !!state.type) return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
}
const $7c7af48337b91c7a$var$AnnotationRangeStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    range: null,
    draftRange: null,
    type: null
});
const $7c7af48337b91c7a$var$AnnotationRangeDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearDraftRange: ()=>{},
    clearHoverRange: ()=>{},
    setRange: ()=>{},
    setDraftRange: ()=>{}
});
const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, {
        range: null,
        draftRange: null,
        type: null
    });
    const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setRange = (0, $5uXOq.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            range: range,
            draftRange: draftRange,
            type: type
        }), [
        range,
        draftRange,
        type
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setRange: setRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setRange,
        setDraftRange,
        setHoverTarget
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$var$AnnotationRangeStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeStateContext);
};
const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext);
};

});

parcelRegister("kuusl", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $b758d405b6d3becf$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $b758d405b6d3becf$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $b758d405b6d3becf$export$c288883964405c82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $b758d405b6d3becf$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWithinRange: false
});
const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
    const timeoutHandler = (0, $5uXOq.useRef)();
    const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
};
const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("iatcV", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d73a3647df6a8131$export$74435b85e23b84d9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWe7H = parcelRequire("jWe7H");

var $bZQ2Q = parcelRequire("bZQ2Q");

var $fCNtA = parcelRequire("fCNtA");
const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const [range, draftRange, clearRange] = (0, $jWe7H.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    if (!range && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bZQ2Q.SelectionInlineCommentMounter), {
        range: range,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("jWe7H", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $cd0f4805a1ba9aff$export$47201332e612f5a4);

var $5uXOq = parcelRequire("5uXOq");

var $2EsbE = parcelRequire("2EsbE");

var $jqO24 = parcelRequire("jqO24");

var $cMPbW = parcelRequire("cMPbW");

var $VSDnB = parcelRequire("VSDnB");
const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $5uXOq.useRef)();
    const { clearRange: clearRange, setRange: setRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, draftRange: draftRange, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const lastRangeRef = (0, $5uXOq.useRef)(null);
    const onSelectionChange = (0, $5uXOq.useCallback)((event)=>{
        if ((0, $VSDnB.fg)('platform_renderer_triple_click_selects_paragraph')) {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    lastRangeRef.current = null; // Clear last range if selection is invalid
                    return;
                }
                let _range = sel.getRangeAt(0);
                // Skip if the selection hasn’t changed
                if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer } = _range;
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    if (isTripleClick) {
                        let p = startContainer;
                        while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                        if (p && p.nodeName === 'P' && p instanceof Element) {
                            const range = document.createRange();
                            range.selectNodeContents(p);
                            sel.removeAllRanges();
                            sel.addRange(range);
                            _range = sel.getRangeAt(0);
                        }
                    }
                    setRange(_range.cloneRange());
                    lastRangeRef.current = _range;
                }
            }, 100);
        } else {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                    const parentNode = startContainer.parentNode;
                    // ED-23493
                    // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                    // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                    // Triple clicks are the only case that can cause the endContainer to be a non-text node
                    // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                    // platform/packages/editor/renderer/src/steps/index.ts Line 180
                    // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                    if (isTripleClick && commonAncestorContainer && commonAncestorContainer.nodeType === Node.ELEMENT_NODE && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $cMPbW.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                    ) {
                        const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                        _range.setEnd(lastChild, lastChild.length || 0);
                    }
                    setRange(_range.cloneRange());
                }
            }, 250);
        }
    }, [
        rendererDOM,
        setRange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearRange
    ]);
    return [
        type === 'selection' ? range : null,
        draftRange,
        clearRange
    ];
};

});
parcelRegister("jqO24", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $8373eb69e5c4287b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bZQ2Q", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $7e4c7bbc0d380e24$export$ca7741472ed8ba00);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $4apTl = parcelRequire("4apTl");

var $fCNtA = parcelRequire("fCNtA");
const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range,
        inlineNodeTypes
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("joddd", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9aa08f3110a2b008$export$39f7c1a861a0d41c);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $fCNtA = parcelRequire("fCNtA");
const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    (0, $5uXOq.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $VSDnB.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            updateSubscriberInlineComment.emit((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete
    ]);
};

});



parcelRegister("2SZph", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb082cddb2d59aba$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uXOq = parcelRequire("5uXOq");

var $i8Zwf = parcelRequire("i8Zwf");

var $fAZXL = parcelRequire("fAZXL");

var $edXiX = parcelRequire("edXiX");
var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");
const $fb082cddb2d59aba$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $fb082cddb2d59aba$var$navigationCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $fb082cddb2d59aba$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $fb082cddb2d59aba$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $edXiX.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $fb082cddb2d59aba$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fAZXL.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $i8Zwf.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $i8Zwf.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $fb082cddb2d59aba$export$2e2bcd8739ae039 = $fb082cddb2d59aba$var$MultiBodiedExtension;

});
parcelRegister("edXiX", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $a5dc814f02ba73ab$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $a5dc814f02ba73ab$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a5dc814f02ba73ab$var$mbeExtensionContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a5dc814f02ba73ab$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a5dc814f02ba73ab$var$extensionFrameContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
    mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
    extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
};

});


parcelRegister("bQeYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc6f3b113435da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                                                                   * @jsxRuntime classic
                                                                                                                   * @jsx jsx
                                                                                                                   * @jsxFrag
                                                                                                                   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");

var $dkSnq = parcelRequire("dkSnq");

var $e4NNv = parcelRequire("e4NNv");
function $c5dc6f3b113435da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c5dc6f3b113435da$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $e4NNv.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $dkSnq.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $f8Sb3.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        css: [
            $c5dc6f3b113435da$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;

});
parcelRegister("dkSnq", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $ef5b9c26278248e6$export$3c7139d93ecb4f1f);

var $5uXOq = parcelRequire("5uXOq");
const $ef5b9c26278248e6$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("e4NNv", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $9b12fab9f9c859c0$export$e55394818db35473);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9S8fM = parcelRequire("9S8fM");
const $9b12fab9f9c859c0$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerPromise = (0, $9S8fM.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $gnH2s.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("cOnYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf8f8318644b4cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $adf8f8318644b4cb$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $adf8f8318644b4cb$var$containerCSSNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? $adf8f8318644b4cb$var$containerCSSNew : $adf8f8318644b4cb$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;

});

parcelRegister("cWRvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4346c39a86c4f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kjhhp = parcelRequire("kjhhp");

var $503mU = parcelRequire("503mU");
function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kjhhp.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("503mU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $95f5719763d590de$export$75aa84e85754623e);
function $95f5719763d590de$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5KNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e507ebac88967e63$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $e507ebac88967e63$export$41121a410ca2f650);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l8Gxi = parcelRequire("l8Gxi");

var $bGnBY = parcelRequire("bGnBY");
function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $e507ebac88967e63$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (0, $bGnBY.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("bGnBY", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $08249876083d1eac$export$98871b245ee25215);

var $gkwXh = parcelRequire("gkwXh");

var $5uXOq = parcelRequire("5uXOq");

var $TM1uy = parcelRequire("TM1uy");

var $lb6Ua = parcelRequire("lb6Ua");
const $08249876083d1eac$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $TM1uy.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $lb6Ua.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("TM1uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e1e4f8cfab5159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $64e1e4f8cfab5159$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;

});

parcelRegister("lb6Ua", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $854590065f4073c9$export$6e6724d89f27411);
class $854590065f4073c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("lKIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a311e98fd838fb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("br", {});
};
var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;

});

parcelRegister("7AttJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20de8dc9c3ed0b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $VSDnB = parcelRequire("VSDnB");

var $bFU4G = parcelRequire("bFU4G");

var $3rouw = parcelRequire("3rouw");

var $gkwXh = parcelRequire("gkwXh");

var $TM1uy = parcelRequire("TM1uy");

var $jSk6P = parcelRequire("jSk6P");
const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $TM1uy.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3rouw.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).CLICKED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    });
                    return (0, $jSk6P.copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $e20de8dc9c3ed0b1$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $bFU4G.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(HX, {
                id: headingIdToUse,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link')
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link')
                        })
                    ]
                })
            }),
            (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;

});
parcelRegister("3rouw", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b36f5408031b5508$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b36f5408031b5508$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $VSDnB = parcelRequire("VSDnB");

var $jOyH3 = parcelRequire("jOyH3");

var $3bDjY = parcelRequire("3bDjY");

var $8RXs9 = parcelRequire("8RXs9");

var $1Bd5P = parcelRequire("1Bd5P");
const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b36f5408031b5508$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b36f5408031b5508$var$copyAnchorButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    cursor: 'pointer',
    right: 0
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b36f5408031b5508$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $1Bd5P.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $1Bd5P.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $1Bd5P.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": (0, $VSDnB.fg)('platform_editor_accessible_heading_copy_link') ? hideFromScreenReader ? undefined : headingId : undefined,
                type: "button"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? `var(--ds-icon-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            }));
        };
    }
}
var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b36f5408031b5508$var$HeadingAnchor);

});
parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("1Bd5P", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $bb2bb569629ca076$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $bb2bb569629ca076$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $bb2bb569629ca076$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7VHMR = parcelRequire("7VHMR");
const $bb2bb569629ca076$export$74bada844422036d = (0, $7VHMR.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, $7VHMR.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, $7VHMR.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});


parcelRegister("jSk6P", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2ff51d830678d63e$export$f980440e1ab4537d);
const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});


parcelRegister("112O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bc2ade6d275922$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");
const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;

});

parcelRegister("ieJGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fd1bc0570bfa35$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");
function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
    return (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "layout-section-container",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-layout-section": true,
        children: props.children
    });
}

});

parcelRegister("3RqVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f45378df34617d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iEGtv = parcelRequire("iEGtv");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");
function $93f45378df34617d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingMarginTopStyleNew = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyleNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $93f45378df34617d$var$layoutColumnClearMarginTopStyles = /*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $iEGtv.clearNextSiblingMarginTopStyle), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $iEGtv.clearNextSiblingBlockMarkMarginTopStyle));
function $93f45378df34617d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $VSDnB.fg)('platform_editor_emotion_refactor_renderer') ? [
            $93f45378df34617d$var$clearNextSiblingMarginTopStyleNew,
            $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyleNew
        ] : $93f45378df34617d$var$layoutColumnClearMarginTopStyles
    }), props.children));
}

});
parcelRegister("iEGtv", function(module, exports) {

$parcel$export(module.exports, "clearNextSiblingMarginTopStyle", () => $1f25160b5efdbc99$export$b15ec88fc1f2e843);
$parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", () => $1f25160b5efdbc99$export$eb3aaa9338936d44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $1f25160b5efdbc99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f25160b5efdbc99$export$b15ec88fc1f2e843 = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $1f25160b5efdbc99$var$textElements = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const $1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors = $1f25160b5efdbc99$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
const $1f25160b5efdbc99$export$eb3aaa9338936d44 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors}`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});

});


parcelRegister("qjsNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd334ef870d278c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("jHa9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce9f67e250185e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8hSwr = parcelRequire("8hSwr");
const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hSwr.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;

});
parcelRegister("8hSwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2c70aa755b661$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2AEnW = parcelRequire("2AEnW");
function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bb2c70aa755b661$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $5bb2c70aa755b661$var$placeholderStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $5bb2c70aa755b661$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $5bb2c70aa755b661$var$placeholderStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), null, formatMessage((0, $2AEnW.messages).placeholder))) : null, children);
    }
}
var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5bb2c70aa755b661$export$f7feb87190a94c76);

});
parcelRegister("2AEnW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa314c48a072d691$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa314c48a072d691$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("6svWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6654d29b704d772$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dwptW = parcelRequire("dwptW");

var $jlYLw = parcelRequire("jlYLw");

var $uTDrM = parcelRequire("uTDrM");

var $503mU = parcelRequire("503mU");
function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $uTDrM.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $jlYLw.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $uTDrM.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dwptW.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("jlYLw", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $6a64108c33d9274c$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $6a64108c33d9274c$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $6a64108c33d9274c$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $gE8f9 = parcelRequire("gE8f9");
const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
var $6a64108c33d9274c$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($6a64108c33d9274c$var$CSS_VAR_NAMES || {});
const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
    return style;
}
const $6a64108c33d9274c$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $f8Sb3.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $gE8f9.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $dwptW.orderedListSelector), ",", (0, $kjhhp.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("9FXQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d2961aa3d14cef$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $EGPjg = parcelRequire("EGPjg");
function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $EGPjg.default), {
            children: children
        })
    }));
}

});
parcelRegister("EGPjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $372a7010ecff9ba7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("hqBb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $add04eab04996fda$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $add04eab04996fda$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
}

});

parcelRegister("ixoQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb5022786e53a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("dkc63", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $7478efdfea2a60bf$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $7478efdfea2a60bf$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $7478efdfea2a60bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $fKLIs = parcelRequire("fKLIs");

var $gmhCD = parcelRequire("gmhCD");

var $OxITw = parcelRequire("OxITw");

var $cWojJ = parcelRequire("cWojJ");

var $4BsEy = parcelRequire("4BsEy");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");
const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7478efdfea2a60bf$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7478efdfea2a60bf$var$hasRowspan = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7478efdfea2a60bf$var$getRefTop = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7478efdfea2a60bf$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7478efdfea2a60bf$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7478efdfea2a60bf$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7478efdfea2a60bf$var$isHeaderRowEnabled = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $7478efdfea2a60bf$var$tableCanBeSticky = (node, children)=>{
    return $7478efdfea2a60bf$var$isHeaderRowEnabled(children) && node && node.firstChild && !$7478efdfea2a60bf$var$hasRowspan(node.firstChild);
};
class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $OxITw.FullPagePadding}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth),
                `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const fixTableSSRResizing = (0, $VSDnB.fg)('platform-fix-table-ssr-resizing');
        const tableWidthNew = fixTableSSRResizing ? (0, $fKLIs.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $7478efdfea2a60bf$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $7478efdfea2a60bf$var$getRefTop(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7478efdfea2a60bf$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7478efdfea2a60bf$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7478efdfea2a60bf$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $7478efdfea2a60bf$var$addSortableColumn($7478efdfea2a60bf$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7478efdfea2a60bf$var$isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
const $7478efdfea2a60bf$var$TableWithShadows = (0, $ajc8Z.default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
    // Remember, `width` will be 0 during SSR
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $OxITw.FullPagePadding) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, $4BsEy.withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);

});
parcelRegister("6gEe5", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $356bd8bd1d42bb7c$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $356bd8bd1d42bb7c$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $356bd8bd1d42bb7c$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $356bd8bd1d42bb7c$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $356bd8bd1d42bb7c$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $356bd8bd1d42bb7c$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $356bd8bd1d42bb7c$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $356bd8bd1d42bb7c$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");

var $gE8f9 = parcelRequire("gE8f9");

var $cYeQP = parcelRequire("cYeQP");

var $hgR8Y = parcelRequire("hgR8Y");
function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
const $356bd8bd1d42bb7c$export$e5ff276883773ffd = 8;
const $356bd8bd1d42bb7c$export$880976487022eb5 = $356bd8bd1d42bb7c$export$808015ab1dd6897a + $356bd8bd1d42bb7c$export$e5ff276883773ffd - $356bd8bd1d42bb7c$export$72aad729077aa0fb;
const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $9UDEr.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $9UDEr.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $9UDEr.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $356bd8bd1d42bb7c$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $356bd8bd1d42bb7c$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $hgR8Y.tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $gE8f9.browser).gecko || (0, $gE8f9.browser).ie || (0, $gE8f9.browser).mac && (0, $gE8f9.browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorWideLayoutWidth));
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("eluMF", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $b41fea6975363b1e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)();
};

});

parcelRegister("cYeQP", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $dca73d3fed5e4b1b$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");
const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $iHYdz.akEditorCodeFontFamily), ";min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $f8Sb3.css)("::before{content:' ';line-height:", (0, $iHYdz.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $iHYdz.akEditorLineHeight), "em!important;}");

});

parcelRegister("hgR8Y", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $hAs1r = parcelRequire("hAs1r");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $9UDEr.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());

});
parcelRegister("hAs1r", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $3966f91ec47ca318$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3966f91ec47ca318$export$a270511a0e7fd61a);
// This import will be stripped on build

var $kTHGn = parcelRequire("kTHGn");
function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $3966f91ec47ca318$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("5vnE9", function(module, exports) {

$parcel$export(module.exports, "compose", () => $8cb395a24b5942e2$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("5or39", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $a59f56ae192d20af$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $a59f56ae192d20af$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $a59f56ae192d20af$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a59f56ae192d20af$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $a59f56ae192d20af$export$889a8e446452be16);

var $VSDnB = parcelRequire("VSDnB");
function $a59f56ae192d20af$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: replaced with getColumnWidths, which correctly scans entire table for column widths
    if ((0, $VSDnB.fg)('platform_editor_table_row_span_fix')) {
        const firstRow = node.firstChild;
        const tableColumnWidths = [];
        if (firstRow) firstRow.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
            else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
            else tableColumnWidths.push(0);
        });
        return tableColumnWidths;
    }
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        const colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("5J0oM", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $c09b1d49576acabb$export$49215374a8bec29c);

var $9BYlQ = parcelRequire("9BYlQ");
var $c09b1d49576acabb$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $c09b1d49576acabb$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $c09b1d49576acabb$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, $9BYlQ.SortOrder).ASC)=>{
    const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $9BYlQ.SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("9BYlQ", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $42ab1316856d1585$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dEtqo = parcelRequire("dEtqo");

var $kXC89 = parcelRequire("kXC89");
var $42ab1316856d1585$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("kXC89", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $fa36a5395f686390$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $fa36a5395f686390$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $fa36a5395f686390$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $fa36a5395f686390$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $fa36a5395f686390$export$501a79d885598191);
var $fa36a5395f686390$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $fa36a5395f686390$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $fa36a5395f686390$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $fa36a5395f686390$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $fa36a5395f686390$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("fKLIs", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $78b5f00ff26d55fc$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $78b5f00ff26d55fc$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $78b5f00ff26d55fc$export$3930799be057b305);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $bQr2R = parcelRequire("bQr2R");

var $ejmVg = parcelRequire("ejmVg");

var $6gEe5 = parcelRequire("6gEe5");

var $eOOFp = parcelRequire("eOOFp");
const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $iHYdz.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $iHYdz.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $iHYdz.akEditorFullWidthLayoutWidth)
};
const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $ejmVg.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
            // padding left
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $6gEe5.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $eOOFp.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, $iHYdz.akEditorDefaultLayoutWidth);
};
const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
    return $78b5f00ff26d55fc$export$3930799be057b305(node);
};

});
parcelRegister("bQr2R", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $6a203c68476205e6$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $6a203c68476205e6$export$91624ec52c59c24c);
const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
const $6a203c68476205e6$export$91624ec52c59c24c = 12;

});

parcelRegister("ejmVg", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $16b49a7404f3316f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $16b49a7404f3316f$export$a1bb91aa2d5fcce8);
const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;

});


parcelRegister("OxITw", function(module, exports) {

$parcel$export(module.exports, "FullPagePadding", () => $19a4579e32968c00$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $19a4579e32968c00$export$74b525449cc7cbd1);
$parcel$export(module.exports, "rendererStyles", () => $19a4579e32968c00$export$1c4377249312209);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");


var $cSyk1 = parcelRequire("cSyk1");

var $9R9Rb = parcelRequire("9R9Rb");

var $1xqpZ = parcelRequire("1xqpZ");
var $cx4Bg = parcelRequire("cx4Bg");
var $kRRtM = parcelRequire("kRRtM");
var $cYeQP = parcelRequire("cYeQP");
var $7Acon = parcelRequire("7Acon");
var $719f3 = parcelRequire("719f3");
var $4E5wI = parcelRequire("4E5wI");
var $iJOES = parcelRequire("iJOES");
var $idytF = parcelRequire("idytF");
var $5fBxY = parcelRequire("5fBxY");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $4jyW9 = parcelRequire("4jyW9");
var $bv4Ps = parcelRequire("bv4Ps");
var $aSoqv = parcelRequire("aSoqv");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");
var $jRk4M = parcelRequire("jRk4M");
var $fwxzS = parcelRequire("fwxzS");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $iHYdz = parcelRequire("iHYdz");

var $l8Gxi = parcelRequire("l8Gxi");

var $3rouw = parcelRequire("3rouw");

var $2o2hu = parcelRequire("2o2hu");

var $dkc63 = parcelRequire("dkc63");


var $gmhCD = parcelRequire("gmhCD");
const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
const $19a4579e32968c00$var$tableShadowWidth = 32;
const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $19a4579e32968c00$var$telepointerStyles = /*#__PURE__*/ (0, $f8Sb3.css)("#", $19a4579e32968c00$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background-color:var(--ds-background-brand-bold, #0C66E4);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:var(--ds-font-weight-bold, 700);width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background-color:var(--ds-background-brand-bold, #0C66E4);}}");
/**
 * **DEPRECATED**
 *
 * Originally defined in `@atlaskit/theme/typography`, but moved here as it has since been deleted in favor of typography tokens.
 * This should be removed as part of editor token work. More info:
 * https://atlassian.slack.com/archives/C075G5D7ZP1/p1733449725865539?thread_ts=1732159801.409789&cid=C075G5D7ZP1
 * */ const $19a4579e32968c00$var$headingSizesImport = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
const $19a4579e32968c00$var$getLineHeight = (fontCode)=>$19a4579e32968c00$var$headingSizesImport[fontCode].lineHeight / $19a4579e32968c00$var$headingSizesImport[fontCode].size;
const $19a4579e32968c00$var$headingSizes = {
    h1: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h700')
    },
    h2: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h600')
    },
    h3: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h500')
    },
    h4: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h400')
    },
    h5: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h300')
    },
    h6: {
        lineHeight: $19a4579e32968c00$var$getLineHeight('h100')
    }
};
const $19a4579e32968c00$var$headingAnchorStyle = (headingTag)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $3rouw.HeadingAnchorWrapperClassName), "{position:absolute;height:", $19a4579e32968c00$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, $3rouw.HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, $3rouw.HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, $3rouw.HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
const $19a4579e32968c00$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowNestedHeaderLinks) return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, $3rouw.HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, $3rouw.HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
};
const $19a4579e32968c00$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowColumnSorting) return '';
    let headingsCss = '';
    if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, $3rouw.HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;", /*#__PURE__*/ (0, $f8Sb3.css)(">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}>.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(\n\t\t\t\t\t\t:has(\n\t\t\t\t\t\t\t\t.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "\n\t\t\t\t\t\t\t\t\t.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ":hover\n\t\t\t\t\t\t\t)\n\t\t\t\t\t)>.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, ">.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}"), ";.", (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $6gEe5.tableCellPadding), "px;border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";}}}}");
};
const $19a4579e32968c00$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
    if (appearance !== 'full-page') return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $19a4579e32968c00$export$12fd658e5eef0d79 : 0, "px;");
};
const $19a4579e32968c00$var$fullWidthStyles = ({ appearance: appearance })=>{
    if (appearance !== 'full-width') return '';
    return /*#__PURE__*/ (0, $f8Sb3.css)("max-width:", (0, $iHYdz.akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark:not([data-has-width='true']),.ak-renderer-extension{width:100%!important;}", (0, $dkc63.isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
};
const $19a4579e32968c00$var$breakoutWidthStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("*:not([data-mark-type='fragment']) .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
};
const $19a4579e32968c00$var$getShadowOverrides = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $ajc8Z.shadowClassNames).LEFT_SHADOW, "::before{width:", $19a4579e32968c00$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
};
function $19a4579e32968c00$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return '';
    if ((0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node]': {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
            paddingTop: "var(--ds-space-025, 2px)"
        }
    });
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
            cursor: 'pointer',
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
        }
    });
}
const $19a4579e32968c00$var$tableRowHeight = 44;
const $19a4579e32968c00$var$stickyScrollbarStyles = `
	position: relative;
	flex-direction: column;

	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
	  width: 100%;
	  display: block;
	  visibility: hidden;
	  overflow-x: auto;
	  position: sticky;
	  bottom: ${"var(--ds-space-0, 0px)"};
	  z-index: 1;
	}

	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
	> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   position: absolute;
	   width: 100%;
	   height: 1px;
	   margin-top: -1px;
	   // need this to avoid sentinel being focused via keyboard
	   // this still allows it to be detected by intersection observer
	   visibility: hidden;
	 }
	 > .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   top: ${$19a4579e32968c00$var$tableRowHeight * 3}px;
	 }
	 > .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
	   bottom:  ${"var(--ds-space-250, 20px)"}; // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
	 }
  `;
const $19a4579e32968c00$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
        const { typography: typography } = (0, $cSyk1.default)();
        // This is required to be compatible with styled-components prop structure.
        const themeProps = {
            theme: theme
        };
        const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, appearance: appearance } = wrapperProps;
        const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
        return /*#__PURE__*/ (0, $f8Sb3.css)("font-size:", (0, $iHYdz.editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $19a4579e32968c00$var$fullPageStyles(wrapperProps, themeProps), " ", $19a4579e32968c00$var$fullWidthStyles(wrapperProps), " .", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "{", (0, $9R9Rb.mediaInlineImageStyles), ";}& h1{", $19a4579e32968c00$var$headingAnchorStyle('h1'), ";}& h2{", $19a4579e32968c00$var$headingAnchorStyle('h2'), ";}& h3{", $19a4579e32968c00$var$headingAnchorStyle('h3'), ";}& h4{", $19a4579e32968c00$var$headingAnchorStyle('h4'), ";}& h5{", $19a4579e32968c00$var$headingAnchorStyle('h5'), ";}& h6{", $19a4579e32968c00$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";}", $19a4579e32968c00$var$telepointerStyles, " ", (0, $fwxzS.whitespaceSharedStyles), ";", (0, $kRRtM.blockquoteSharedStyles), ";", (0, $idytF.headingsSharedStyles)(typography), ";", (0, $bv4Ps.ruleSharedStyles)(), ";", (0, $4jyW9.paragraphSharedStyles)(typography), ";", (0, $jlYLw.listsSharedStyles), ";", (0, $5fBxY.indentationSharedStyles), ";", (0, $cx4Bg.blockMarksSharedStyles), ";", (0, $7Acon.codeMarkSharedStyles)(), ";", (0, $aSoqv.shadowSharedStyle), ";", (0, $4E5wI.dateSharedStyle), ";", (0, $jRk4M.textColorStyles), ";", (0, $1xqpZ.backgroundColorStyles)(), ";", (0, $1bQ0V.tasksAndDecisionsStyles), ";", (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? (0, $iJOES.getSmartCardSharedStyles)() : (0, $iJOES.smartCardSharedStyles), " ", $19a4579e32968c00$var$getAnnotationStyles(wrapperProps), " & .UnknownBlock{font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";font-weight:var(--ds-font-weight-regular, 400);white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$829f609a65d26a98$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+.", (0, $ceYEW.richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, $ceYEW.richMediaClassName), ".image-align-start,.", (0, $ceYEW.richMediaClassName), ".image-center,.", (0, $ceYEW.richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $19a4579e32968c00$var$alignedHeadingAnchorStyle(wrapperProps), (0, $ceYEW.mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">{", $19a4579e32968c00$var$breakoutWidthStyle(), " * .", (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, $l8Gxi.RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, $l8Gxi.RendererCssClassName).DOCUMENT, "{.", (0, $l8Gxi.RendererCssClassName).EXTENSION, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}.", (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, $6gEe5.tableSharedStyle)(), " .", (0, $l8Gxi.RendererCssClassName).DOCUMENT, " .", (0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, $ajc8Z.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $ajc8Z.shadowClassNames).LEFT_SHADOW, "::before{top:", (0, $6gEe5.tableMarginTop) - 1, "px;height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";}", $19a4579e32968c00$var$getShadowOverrides(), " ", (0, $dkc63.isStickyScrollbarEnabled)(appearance) ? $19a4579e32968c00$var$stickyScrollbarStyles : '', " & .", (0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table` : 'table', "{height:1px;", $19a4579e32968c00$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type` : 'table tr:first-of-type', "{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN, "{background-color:", (0, $VSDnB.fg)('platform_editor_tables_numbered_column_correction') ? "var(--ds-background-accent-gray-subtlest, #F1F2F4)" : `var(--ds-background-neutral, ${0, $iHYdz.akEditorTableToolbar})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";width:", (0, $iHYdz.akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";}.fixed .", (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $19a4579e32968c00$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, $2o2hu.getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", isAdvancedLayoutsOn ? (0, $719f3.columnLayoutResponsiveSharedStyle) : (0, $719f3.columnLayoutSharedStyle), ";", isAdvancedLayoutsOn && (0, $719f3.columnLayoutResponsiveRendererStyles), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:", isAdvancedLayoutsOn ? 0 : "var(--ds-space-400, 32px)", ";}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, $iHYdz.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $gE8f9.browser).safari ? (0, $cYeQP.codeBlockInListSafariFix) : '', ";}");
    };
const $19a4579e32968c00$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
    if (codeBlockRenderAsBlock) return '';
    return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
};

});
parcelRegister("9R9Rb", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c55873fb36219b19$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c55873fb36219b19$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c55873fb36219b19$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c55873fb36219b19$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $c55873fb36219b19$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $c55873fb36219b19$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c55873fb36219b19$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c55873fb36219b19$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dR3f5 = parcelRequire("dR3f5");
const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $f8Sb3.css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c55873fb36219b19$export$dee15762144889b7 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, $dR3f5.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h6'], -2), ";}");
const $c55873fb36219b19$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c55873fb36219b19$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $c55873fb36219b19$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dR3f5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $c9848698b53f0c39$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $c9848698b53f0c39$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $c9848698b53f0c39$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $c9848698b53f0c39$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $c9848698b53f0c39$export$c1317a9224e4d798);
const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
const $c9848698b53f0c39$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("1xqpZ", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $31831d84911fc513$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $31831d84911fc513$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $31831d84911fc513$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $31831d84911fc513$export$e4cca17cf56e99d = ()=>{
    return $31831d84911fc513$var$_ref;
};

});

parcelRegister("cx4Bg", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $e319ea6be2c09fe0$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e319ea6be2c09fe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e319ea6be2c09fe0$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("kRRtM", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: `${(0, $gmhCD.editorExperiment)('platform_editor_nested_non_bodied_macros', 'test')}` ? 'block' : 'inline-block'
        }
    }
});

});

parcelRegister("7Acon", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $4ae245bd686f7965$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $4ae245bd686f7965$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            display: 'inline',
            padding: '2px 0.5ch',
            backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
            borderRadius: "var(--ds-border-radius, 3px)",
            borderStyle: 'none',
            boxDecorationBreak: 'clone',
            color: "var(--ds-text, #172B4D)",
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '0.875em',
            fontWeight: "var(--ds-font-weight-regular, 400)",
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    });
};

});

parcelRegister("719f3", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $2e5d010f6440279f$export$6891a39948814a80);
$parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", () => $2e5d010f6440279f$export$3afcac98e7ca927d);
$parcel$export(module.exports, "columnLayoutResponsiveRendererStyles", () => $2e5d010f6440279f$export$f2451ec7aca7656c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
function $2e5d010f6440279f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e5d010f6440279f$export$6891a39948814a80 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2e5d010f6440279f$export$3afcac98e7ca927d = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $2e5d010f6440279f$export$f2451ec7aca7656c = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            gap: "var(--ds-space-600, 48px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`@container layout-area (max-width:${$2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
                flexDirection: 'column',
                gap: "var(--ds-space-400, 32px)"
            }
        }
    }
});

});

parcelRegister("4E5wI", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $174371b9df7208d5$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $174371b9df7208d5$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $174371b9df7208d5$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("iJOES", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bc13534612fcd0a2$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $bc13534612fcd0a2$export$83e107f0a431e184);
$parcel$export(module.exports, "getSmartCardSharedStyles", () => $bc13534612fcd0a2$export$fbd9b588230965e4);

var $iHYdz = parcelRequire("iHYdz");
const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $iHYdz.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
const $bc13534612fcd0a2$export$fbd9b588230965e4 = ()=>`
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${0, $iHYdz.blockNodesVerticalMargin} 0 0;
    max-width: ${760}px;
  }

  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.LOADER_WRAPPER} {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */
    ul, ol {
      padding-left: inherit;
    }
    /* EDM-11991: Fix list plugin add padding to ADS AvatarGroup end */
  }
`;

});

parcelRegister("idytF", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $152b62c033bbf99a$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $152b62c033bbf99a$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $152b62c033bbf99a$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            font: (0, $04VvC.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $04VvC.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $04VvC.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $04VvC.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $04VvC.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $04VvC.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
};

});
parcelRegister("04VvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f731000984869b$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $kqZva = parcelRequire("kqZva");
function $53f731000984869b$var$editorUGCToken(path) {
    let tokens;
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-dst-jira-web-fonts') || (0, $VSDnB.fg)('confluence_typography_refreshed') || (0, $VSDnB.fg)('atlas_editor_typography_refreshed')) tokens = (0, $kqZva.editorUGCTokensRefreshed);
        else tokens = (0, $kqZva.editorUGCTokensModernized);
    } else tokens = (0, $kqZva.editorUGCTokens);
    return tokens[path];
}
var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;

});
parcelRegister("kqZva", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $5558cddd9c1ce385$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensModernized", () => $5558cddd9c1ce385$export$95588e746468319e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $5558cddd9c1ce385$export$63adc0ebe3278d31);
const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});



parcelRegister("5fBxY", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $586c09e19d6f6d26$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $586c09e19d6f6d26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $586c09e19d6f6d26$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("ceYEW", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5c06afce66d8efef$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $5c06afce66d8efef$export$d031611b96ba4cf0);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $5c06afce66d8efef$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
const $5c06afce66d8efef$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $5c06afce66d8efef$export$b51dea84d928a378 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("4jyW9", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $0bce92e99beab9a0$export$2f49074d75b0e29f);
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $0bce92e99beab9a0$export$2f49074d75b0e29f = (typographyTheme)=>{
    return (0, $VSDnB.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            font: (0, $04VvC.default)('editor.font.body'),
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0
        }
    }) : /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            fontSize: '1em',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: (0, $iHYdz.akEditorLineHeight),
            fontWeight: "var(--ds-font-weight-regular, 400)",
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0,
            letterSpacing: '-0.005em'
        }
    });
};

});

parcelRegister("bv4Ps", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $f15d364691bf541f$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $f15d364691bf541f$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("aSoqv", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $0235d3a2f78ffda6$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $ajc8Z = parcelRequire("ajc8Z");

var $bbl9Y = parcelRequire("bbl9Y");
const $0235d3a2f78ffda6$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $0235d3a2f78ffda6$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: `${$0235d3a2f78ffda6$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("1bQ0V", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $2398d5ed497032ce$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $2398d5ed497032ce$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $2398d5ed497032ce$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $iHYdz.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $iHYdz.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("jRk4M", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $e9c9f96b9e0ca8df$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e9c9f96b9e0ca8df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e9c9f96b9e0ca8df$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("fwxzS", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $308dad73f97ce24c$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $308dad73f97ce24c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $308dad73f97ce24c$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("2o2hu", function(module, exports) {

$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $67d1fb0f1c6fc210$export$afbde0e7339bed51);
$parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", () => $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a);
$parcel$export(module.exports, "default", () => $67d1fb0f1c6fc210$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $cYeQP = parcelRequire("cYeQP");

var $23OJc = parcelRequire("23OJc");

var $l8Gxi = parcelRequire("l8Gxi");

var $bL5sD = parcelRequire("bL5sD");
const $67d1fb0f1c6fc210$var$codeBlockSharedStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            display: 'flex',
            borderRadius: "var(--ds-border-radius, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #172B4D)",
                borderRadius: "var(--ds-border-radius, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}");
};
const $67d1fb0f1c6fc210$var$LightWeightCodeBlockOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $cYeQP.codeBlockSharedStyles)(),
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStylesOld
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
const $67d1fb0f1c6fc210$var$LightWeightCodeBlockNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $67d1fb0f1c6fc210$var$codeBlockSharedStylesNew,
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStylesNew
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = (0, $bL5sD.componentWithFG)('platform_editor_emotion_refactor_renderer', $67d1fb0f1c6fc210$var$LightWeightCodeBlockNew, $67d1fb0f1c6fc210$var$LightWeightCodeBlockOld);
var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;

});
parcelRegister("23OJc", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $807954ab13bca9b8$export$9fb9fe546a188c7b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrHA4 = parcelRequire("lrHA4");

var $fJyLQ = parcelRequire("fJyLQ");

var $31cgS = parcelRequire("31cgS");
const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $koVbs.default)();
    const warningLabel = intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $31cgS.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $59fdc1b7b0ae96c9$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});


parcelRegister("bL5sD", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $fdd65d30971656f3$export$cf56d0f54cfcce4);

var $VSDnB = parcelRequire("VSDnB");

var $gmmd2 = parcelRequire("gmmd2");
const $fdd65d30971656f3$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $gmmd2.componentWithCondition)(()=>(0, $VSDnB.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("gmmd2", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $5b194bd8d7426f4b$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $5b194bd8d7426f4b$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});



const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;


parcelRegister("cWojJ", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $decaf4f5703baa00$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $decaf4f5703baa00$export$1e4baea7053fc0e3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");
var $9UDEr = parcelRequire("9UDEr");

var $hxoiH = parcelRequire("hxoiH");

var $9BYlQ = parcelRequire("9BYlQ");

var $hAs1r = parcelRequire("hAs1r");

var $hrpWq = parcelRequire("hrpWq");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $l8Gxi = parcelRequire("l8Gxi");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
const $decaf4f5703baa00$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return (0, $9BYlQ.SortOrder).ASC;
        case (0, $9BYlQ.SortOrder).ASC:
            return (0, $9BYlQ.SortOrder).DESC;
        case (0, $9BYlQ.SortOrder).DESC:
            return (0, $9BYlQ.SortOrder).NO_ORDER;
    }
    return (0, $9BYlQ.SortOrder).NO_ORDER;
};
const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $1Bd5P.tableCellMessages);
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $hAs1r.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $87j2U.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $hxoiH.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $9UDEr.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $decaf4f5703baa00$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $koVbs.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $9BYlQ.SortOrder).NO_ORDER ? (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $2OMIu.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrpWq.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).SORT_COLUMN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        mode: (0, $knXBU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            });
        }
    };
};
const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;

});
parcelRegister("hrpWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33846969f29997f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $9BYlQ = parcelRequire("9BYlQ");


var $3hakN = parcelRequire("3hakN");
function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d33846969f29997f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$iconWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $d33846969f29997f$var$iconStyles = {
    name: "14n17e4",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $9BYlQ.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $3hakN.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $3hakN.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": (0, $VSDnB.fg)('platform_renderer_table_sort_btn_aria_hidden') ? !isSortingAllowed : undefined,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $d33846969f29997f$var$iconStyles
        ]
    }))));
};
var $d33846969f29997f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d33846969f29997f$var$SortingIcon);

});
parcelRegister("3hakN", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $c1f584a2cfc01515$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $c1f584a2cfc01515$export$f142573f51a67577);

var $7VHMR = parcelRequire("7VHMR");
const $c1f584a2cfc01515$export$458c50917513cd1a = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $c1f584a2cfc01515$export$f142573f51a67577 = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4BsEy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3b927b61a8274f19$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $3b927b61a8274f19$export$65e2d5a272a382b0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $3b927b61a8274f19$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new Map());
const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("2aXGN", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $9b3e020198447653$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $9b3e020198447653$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $9b3e020198447653$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");

var $a4mor = parcelRequire("a4mor");

var $6cOrl = parcelRequire("6cOrl");

var $bL5sD = parcelRequire("bL5sD");
function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3e020198447653$export$3de6413b528017ca = 8;
const $9b3e020198447653$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $9b3e020198447653$var$fixedTableDivStaticStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
// TODO: DSP-4123 - Quality ticket
const $9b3e020198447653$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)(typeof top === 'number' && `top: ${top}px;`, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: stickyHeaderZIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            marginTop: 0,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            tr: {
                background: "var(--ds-surface, white)"
            }
        },
        borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
        background: "var(--ds-surface-overlay, white)",
        boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "div[data-expanded='false'] &": {
            display: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
            top: '0px',
            height: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&.fixed-table-div-custom-table-resizing[mode='stick']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: stickyHeaderZIndex
        }
    });
};
const $9b3e020198447653$var$FixedTableDivOld = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    const fixedTableCss = [
        $9b3e020198447653$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
        $9b3e020198447653$var$modeSpecficStyles?.[mode]
    ];
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: fixedTableCss
    }, props.children);
};
const $9b3e020198447653$var$FixedTableDivNew = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $9b3e020198447653$var$fixedTableDivStaticStylesNew,
            $9b3e020198447653$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: (0, $VSDnB.fg)('sticky_header_in_embedded_confluence_fix') ? typeof top === 'number' ? `${top}px` : undefined : top ? `${top}px` : undefined
        }
    }, props.children);
};
const $9b3e020198447653$var$FixedTableDiv = (0, $bL5sD.componentWithFG)('platform_editor_emotion_refactor_renderer', $9b3e020198447653$var$FixedTableDivNew, $9b3e020198447653$var$FixedTableDivOld);
const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9b3e020198447653$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4mor.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6cOrl.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 */ function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $9b3e020198447653$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    static fromElement(el, defaultScrollRootId) {
        return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    get isElement() {
        return this.ref instanceof HTMLElement;
    }
    get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("a4mor", function(module, exports) {

$parcel$export(module.exports, "Table", () => $40c6d2c88bc98a0d$export$54ec01a60f47d33d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3nHPA = parcelRequire("3nHPA");

var $fKLIs = parcelRequire("fKLIs");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational })=>{
    let tableWidth = tableNode ? (0, $fKLIs.getTableContainerWidth)(tableNode) : (0, $iHYdz.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("table", {
        ...(0, $VSDnB.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3nHPA.Colgroup), {
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("3nHPA", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $ae0cfecd7422435f$export$89efc2d0ceeaa030);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $fKLIs = parcelRequire("fKLIs");

var $9JDnL = parcelRequire("9JDnL");

var $dyURG = parcelRequire("dyURG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $6gEe5.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $6gEe5.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : (0, $6gEe5.tableCellMinWidth));
};
const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $iHYdz.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, $fKLIs.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $6gEe5.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $iHYdz.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $iHYdz.akEditorTableLegacyCellMinWidth) ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $9JDnL.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $iHYdz.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("9JDnL", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $7cc75954bd6ebac0$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dyURG = parcelRequire("dyURG");
const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, $dyURG.useRendererContext)()?.featureFlags;

});
parcelRegister("dyURG", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $6d8aa882825f4203$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6d8aa882825f4203$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5uXOq = parcelRequire("5uXOq");
const $6d8aa882825f4203$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;

});




parcelRegister("6cOrl", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $7a2ba32d880ccda8$export$40e12ce8e0a76b0c);

var $5uXOq = parcelRequire("5uXOq");
function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("kjIja", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $b5d34963b73650ed$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $b5d34963b73650ed$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $b5d34963b73650ed$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $b5d34963b73650ed$export$33331a99fac775a1);
const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);

});

parcelRegister("eIscD", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $ea0307076d72d83e$export$8c072780619cfc83);

var $6gEe5 = parcelRequire("6gEe5");

var $VSDnB = parcelRequire("VSDnB");
class $ea0307076d72d83e$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels?.item(bottomSentinels.length - 1) : this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});


parcelRegister("i4Lgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6cf54c99dd1cb3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5vnE9 = parcelRequire("5vnE9");

var $9BYlQ = parcelRequire("9BYlQ");

var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");
class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("td", {
                    className: (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $5vnE9.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && (!(0, $VSDnB.fg)('cc_complexit_fe_improve_table_sorting') || isHeaderRow)) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $9BYlQ.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if ((0, $VSDnB.fg)('platform_editor_table_column_group_width_check') ? this.state.colGroupWidths?.length : this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("gfMkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5be854e6b8cbd84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("b7uH5", function(module, exports) {

let $8188285c16b52cce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8188285c16b52cce$var$load("jv5OL").then(()=>parcelRequire('fyj1u'));

});

parcelRegister("4nigH", function(module, exports) {

let $32f77b20371be65f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32f77b20371be65f$var$load("27B3z").then(()=>parcelRequire('bO8HO'));

});

parcelRegister("jjsQN", function(module, exports) {

let $e0f62bc8730c7d05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0f62bc8730c7d05$var$load("wQW1L").then(()=>parcelRequire('iLXzZ'));

});

parcelRegister("0K8mZ", function(module, exports) {

let $0023c973e159b439$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0023c973e159b439$var$load("hY7zf").then(()=>parcelRequire('5Y7e4'));

});

parcelRegister("k7Zs2", function(module, exports) {

let $ea742102175705e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea742102175705e3$var$load("7lItE").then(()=>parcelRequire('h2Mqp'));

});

parcelRegister("aNesC", function(module, exports) {

let $7db9b28bd0545c2e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7db9b28bd0545c2e$var$load("6OdqE").then(()=>parcelRequire('sFJC1'));

});

parcelRegister("57OMq", function(module, exports) {

let $3bb4ff084aedf044$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3bb4ff084aedf044$var$load("8PYkX").then(()=>parcelRequire('4hMem'));

});

parcelRegister("bfPot", function(module, exports) {

let $8318f624fdf8cb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8318f624fdf8cb8b$var$load("aetML").then(()=>parcelRequire('c3ssB'));

});

parcelRegister("7mtWi", function(module, exports) {

let $55c1cfcbb6e43f4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $55c1cfcbb6e43f4a$var$load("cM9em"),
    $55c1cfcbb6e43f4a$var$load("fr9NE"),
    $55c1cfcbb6e43f4a$var$load("h2MrD"),
    $55c1cfcbb6e43f4a$var$load("bYT2S"),
    $55c1cfcbb6e43f4a$var$load("9VCdz")
]).then(()=>parcelRequire('hibqv'));

});

parcelRegister("cyYfQ", function(module, exports) {

let $92576655004e1c2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $92576655004e1c2c$var$load("cM9em"),
    $92576655004e1c2c$var$load("fr9NE"),
    $92576655004e1c2c$var$load("h2MrD"),
    $92576655004e1c2c$var$load("bYT2S"),
    $92576655004e1c2c$var$load("h0TDs")
]).then(()=>parcelRequire('1lkep'));

});

parcelRegister("bat28", function(module, exports) {

let $8217264db8cfcb2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8217264db8cfcb2d$var$load("dsiAd"),
    $8217264db8cfcb2d$var$load("cM9em"),
    $8217264db8cfcb2d$var$load("fr9NE"),
    $8217264db8cfcb2d$var$load("h2MrD"),
    $8217264db8cfcb2d$var$load("bYT2S"),
    $8217264db8cfcb2d$var$load("hPzOn"),
    $8217264db8cfcb2d$var$load("hLGxH")
]).then(()=>parcelRequire('fz1ZD'));

});

parcelRegister("iyg8s", function(module, exports) {

let $d817eb1ae1141039$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d817eb1ae1141039$var$load("dsiAd"),
    $d817eb1ae1141039$var$load("cM9em"),
    $d817eb1ae1141039$var$load("fr9NE"),
    $d817eb1ae1141039$var$load("h2MrD"),
    $d817eb1ae1141039$var$load("bYT2S"),
    $d817eb1ae1141039$var$load("hPzOn"),
    $d817eb1ae1141039$var$load("13w3s")
]).then(()=>parcelRequire('lD0Zb'));

});

parcelRegister("gQJy5", function(module, exports) {

let $032a668b1beb7866$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $032a668b1beb7866$var$load("dsiAd"),
    $032a668b1beb7866$var$load("cM9em"),
    $032a668b1beb7866$var$load("fr9NE"),
    $032a668b1beb7866$var$load("h2MrD"),
    $032a668b1beb7866$var$load("bYT2S"),
    $032a668b1beb7866$var$load("hPzOn"),
    $032a668b1beb7866$var$load("YsZeU")
]).then(()=>parcelRequire('gQwn3'));

});

parcelRegister("7UIjK", function(module, exports) {

let $5c3023ed13e23afa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5c3023ed13e23afa$var$load("cM9em"),
    $5c3023ed13e23afa$var$load("fr9NE"),
    $5c3023ed13e23afa$var$load("2Q2XH")
]).then(()=>parcelRequire('aPwmB'));

});

parcelRegister("ftKE0", function(module, exports) {

let $b44dbf08b7ae4157$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b44dbf08b7ae4157$var$load("4B3Pp").then(()=>parcelRequire('ebIkR'));

});

parcelRegister("4kfHt", function(module, exports) {

let $32653568d7020556$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $32653568d7020556$var$load("cM9em"),
    $32653568d7020556$var$load("fr9NE"),
    $32653568d7020556$var$load("c5BYw")
]).then(()=>parcelRequire('74PfD'));

});

parcelRegister("hPQIC", function(module, exports) {

let $cfc017ee8c8604ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfc017ee8c8604ba$var$load("8QV79").then(()=>parcelRequire('9jt2S'));

});

parcelRegister("3ceee", function(module, exports) {

let $253d87993a37a182$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $253d87993a37a182$var$load("h2MrD"),
    $253d87993a37a182$var$load("bYT2S"),
    $253d87993a37a182$var$load("cM9em"),
    $253d87993a37a182$var$load("fr9NE"),
    $253d87993a37a182$var$load("iJ6aZ")
]).then(()=>parcelRequire('V5Yjo'));

});

parcelRegister("bbv0R", function(module, exports) {

let $8248c74ba6db9df5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8248c74ba6db9df5$var$load("h2MrD"),
    $8248c74ba6db9df5$var$load("bYT2S"),
    $8248c74ba6db9df5$var$load("jcqJ9")
]).then(()=>parcelRequire('hA9EZ'));

});


parcelRegister("5BLIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1269296b575a9fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4dDLS = parcelRequire("4dDLS");
const $e1269296b575a9fc$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dDLS.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;

});
parcelRegister("4dDLS", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dLpur = parcelRequire("dLpur");

var $iYAgE = parcelRequire("iYAgE");

var $i9Z2i = parcelRequire("i9Z2i");

var $b60W1 = parcelRequire("b60W1");

var $fVTp8 = parcelRequire("fVTp8");

var $5Lu5s = parcelRequire("5Lu5s");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");

var $VSDnB = parcelRequire("VSDnB");
function $3c5c154ced085d7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $3c5c154ced085d7f$var$markStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $5Lu5s.AnnotationSharedCSSByState)().common, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $5Lu5s.AnnotationSharedCSSByState)().focus);
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $3c5c154ced085d7f$var$markStylesNew = {
    name: "ko40kj",
    styles: "color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;border-bottom:2px solid transparent;cursor:pointer;padding:1px 0 2px;&:has(.card), &:has([data-inline-card]){padding:5px 0 3px 0;}&:has(.date-lozenger-container){padding-top:var(--ds-space-025, 2px);}background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fVTp8.dataAttributes)(draftPosition),
        css: (0, $VSDnB.fg)('platform_editor_emotion_refactor_renderer') ? $3c5c154ced085d7f$var$markStylesNew : $3c5c154ced085d7f$var$markStyles
    }, children);
};
const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $h5tvG.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $iYAgE.AnnotationsDraftContext));
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $b60W1.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $i9Z2i.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dLpur.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $i9Z2i.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $i9Z2i.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $3c5c154ced085d7f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, components);
};

});
parcelRegister("dLpur", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $0808a380eaa6574c$export$c1bd4813440b4505);
var $0808a380eaa6574c$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("i9Z2i", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $b2e5f988c70f5313$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $b2e5f988c70f5313$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $b2e5f988c70f5313$export$1059bfc467f4f55d);

var $5uXOq = parcelRequire("5uXOq");
const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $b2e5f988c70f5313$var$isReactElement(child) {
    return !!child.type;
}
const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("b60W1", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $cc6d6765c9b34830$export$b1baddbd5f289877);

var $dLpur = parcelRequire("dLpur");
const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dLpur.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dLpur.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dLpur.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dLpur.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("5Lu5s", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $973d0f0bfe5e36b9$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $973d0f0bfe5e36b9$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $973d0f0bfe5e36b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $973d0f0bfe5e36b9$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c = {
    focus: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-draft`,
    hover: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-hover`
};
const $973d0f0bfe5e36b9$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $973d0f0bfe5e36b9$export$ac15f3ad21fefeac = {
    focus: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-draft`
};
var $973d0f0bfe5e36b9$var$_ref = {
    name: "1afe5d9",
    styles: "background:var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
};
var $973d0f0bfe5e36b9$var$_ref2 = {
    name: "kh65d",
    styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
};
var $973d0f0bfe5e36b9$var$_ref3 = {
    name: "1m36z9o",
    styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
};
const $973d0f0bfe5e36b9$export$261ebe180da42726 = ()=>{
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: $973d0f0bfe5e36b9$var$_ref3,
        blur: $973d0f0bfe5e36b9$var$_ref2,
        hover: $973d0f0bfe5e36b9$var$_ref
    };
    else return {
        focus: /*#__PURE__*/ (0, $f8Sb3.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $f8Sb3.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $973d0f0bfe5e36b9$export$5f72fe1d39f8129b = ()=>(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.hover, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";", $973d0f0bfe5e36b9$export$261ebe180da42726().hover, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("h5tvG", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("3VpWO", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $eefbbe172cfc7a10$export$8a20fd0614851c5f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("cKKwC", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $d006a5118aec07b0$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $d006a5118aec07b0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $5uoEK = parcelRequire("5uoEK");
const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $88i6h.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uoEK.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;

});
parcelRegister("5uoEK", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $97291021c9f24158$export$f3069f755c1eba0b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $8u8ms = parcelRequire("8u8ms");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $1oOiu = parcelRequire("1oOiu");

var $iYAgE = parcelRequire("iYAgE");

var $dEtqo = parcelRequire("dEtqo");
const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1oOiu.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const onClick = (0, $5uXOq.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel
    ]);
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8u8ms.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("8u8ms", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $c95b45af50ffb058$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5Lu5s = parcelRequire("5Lu5s");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState` is not object-safe
const $c95b45af50ffb058$var$markStylesOld = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, $88i6h.AnnotationMarkStates).ACTIVE, "']{", (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? (0, $5Lu5s.AnnotationSharedCSSByState)().common : '', " ", (0, $5Lu5s.AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, $5Lu5s.AnnotationSharedCSSByState)().focus, ";}&[data-is-hovered='true']:not([data-has-focus='true']){", (0, $VSDnB.fg)('confluence-frontend-comments-panel') ? (0, $5Lu5s.AnnotationSharedCSSByState)().hover : '', ";}}");
const $c95b45af50ffb058$var$markStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }
    }
});
const $c95b45af50ffb058$var$markStylesLayeringFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesNewWithInlineComments = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesNewWithCommentsPanel = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $c95b45af50ffb058$var$accessibilityStylesOld = (startMarker, endMarker)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        '&::before, &::after': {
            clipPath: 'inset(100%)',
            clip: 'rect(1px, 1px, 1px, 1px)',
            height: '1px',
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px'
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${startMarker}] '`
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${endMarker}] '`
        }
    });
const $c95b45af50ffb058$var$accessibilityStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $koVbs.default)();
    const annotationIds = (0, $5uXOq.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $88i6h.AnnotationMarkStates).ACTIVE) return;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $c95b45af50ffb058$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $88i6h.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    const getAccessibilityStylesOld = ()=>{
        if ($c95b45af50ffb058$var$isMobile()) return {};
        if (state !== (0, $88i6h.AnnotationMarkStates).RESOLVED) {
            const startMarker = intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart);
            const endMarker = intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
            return $c95b45af50ffb058$var$accessibilityStylesOld(startMarker, endMarker);
        } else return {};
    };
    if ((0, $VSDnB.fg)('platform_editor_emotion_refactor_renderer')) return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStylesNew,
                (0, $VSDnB.fg)('platform_renderer_nested_annotation_styling') && $c95b45af50ffb058$var$markStylesLayeringFix,
                (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $c95b45af50ffb058$var$markStylesNewWithInlineComments,
                (0, $VSDnB.fg)('confluence-frontend-comments-panel') && $c95b45af50ffb058$var$markStylesNewWithCommentsPanel,
                !$c95b45af50ffb058$var$isMobile() && $c95b45af50ffb058$var$accessibilityStylesNew,
                $c95b45af50ffb058$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
    return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStylesOld,
                getAccessibilityStylesOld()
            ]
        }
    }, children);
};

});

parcelRegister("6Oe8V", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $588f60613625d184$export$8e7d47f9e38ad4f1);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    return (0, $5uXOq.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("3N1TD", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $861d152b5ce122b2$export$b46737175cffd396);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("GDkvY", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $d1627eb50b8d1823$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bVGKe = parcelRequire("bVGKe");

var $lqKi3 = parcelRequire("lqKi3");

var $kgK5w = parcelRequire("kgK5w");

var $f14yv = parcelRequire("f14yv");

var $eVxaj = parcelRequire("eVxaj");

var $gUlHA = parcelRequire("gUlHA");

var $c15YI = parcelRequire("c15YI");

var $koUAb = parcelRequire("koUAb");

var $eESZY = parcelRequire("eESZY");

var $95Yll = parcelRequire("95Yll");

var $lbdLJ = parcelRequire("lbdLJ");

var $9xZ5X = parcelRequire("9xZ5X");

var $g5EjF = parcelRequire("g5EjF");

var $acz8Q = parcelRequire("acz8Q");

var $8DQfy = parcelRequire("8DQfy");

var $g9yqu = parcelRequire("g9yqu");

var $cKKwC = parcelRequire("cKKwC");

var $itF0z = parcelRequire("itF0z");

var $6EeUE = parcelRequire("6EeUE");
const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
    code: (0, $bVGKe.default),
    em: (0, $lqKi3.default),
    link: (0, $kgK5w.default),
    strike: (0, $f14yv.default),
    strong: (0, $eVxaj.default),
    subsup: (0, $gUlHA.default),
    textColor: (0, $c15YI.default),
    backgroundColor: (0, $koUAb.default),
    underline: (0, $eESZY.default),
    annotation: (0, $cKKwC.default),
    border: (0, $itF0z.default),
    // Stage0
    confluenceInlineComment: (0, $6EeUE.default),
    breakout: (0, $95Yll.default),
    alignment: (0, $lbdLJ.default),
    indentation: (0, $9xZ5X.default),
    unsupportedMark: (0, $g5EjF.default),
    unsupportedNodeAttribute: (0, $acz8Q.default),
    dataConsumer: (0, $8DQfy.default),
    fragment: (0, $g9yqu.default)
};
const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
    return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bVGKe", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $caa083dc61fd842d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $caa083dc61fd842d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $O2UjQ = parcelRequire("O2UjQ");

var $fJyLQ = parcelRequire("fJyLQ");
const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $O2UjQ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($caa083dc61fd842d$export$7cea6ffa7022e85f);

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

const $4c9c981a54265bdd$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rko1sit _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $bwpsq.default)([
            $4c9c981a54265bdd$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: replacedChildren
    });
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});


parcelRegister("lqKi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd21faba719ebab1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kgK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9900830cb94354be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $K5Jsy = parcelRequire("K5Jsy");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");

var $iHvAB = parcelRequire("iHvAB");

var $daJ0i = parcelRequire("daJ0i");
const $9900830cb94354be$var$anchorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    }
});
function $9900830cb94354be$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $K5Jsy.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHvAB.default), {
        css: $9900830cb94354be$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $VSDnB.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("iHvAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e7a399613e0863$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $994MI = parcelRequire("994MI");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $g2eZ6 = parcelRequire("g2eZ6");

var $66xOO = parcelRequire("66xOO");

var $hTTxJ = parcelRequire("hTTxJ");

var $cI2hq = parcelRequire("cI2hq");
const $65e7a399613e0863$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $65e7a399613e0863$var$Anchor = (0, $g2eZ6.withLinkClickedEvent)('a');
const $65e7a399613e0863$export$8c0773eab230d49e = (0, $g2eZ6.withLinkClickedEvent)((0, $e4yMr.default));
const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gKZoD.di)($65e7a399613e0863$export$8c0773eab230d49e, (0, $cI2hq.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $cI2hq.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $65e7a399613e0863$export$8c0773eab230d49e : $65e7a399613e0863$var$Anchor;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $66xOO.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTTxJ.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, $994MI.default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});


parcelRegister("66xOO", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $a51765c35bf0b052$export$9458cdec663b9ff1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("hTTxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef61591d3052acd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $7zaVw = parcelRequire("7zaVw");
const $6ef61591d3052acd$var$breakWordsCss = null;
const $6ef61591d3052acd$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: content
    });
};
var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6ef61591d3052acd$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});


parcelRegister("cI2hq", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $afd5dc953340b04b$export$32b76c003683c2ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $57Lhk = parcelRequire("57Lhk");

var $VSDnB = parcelRequire("VSDnB");

var $fzJZi = parcelRequire("fzJZi");
const $afd5dc953340b04b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
    const [url, setUrl] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $57Lhk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        if ((0, $VSDnB.fg)('do-not-show-link-mismatch-warning-for-same-origin')) {
            const currentAtlassianProductOrigin = window.location.origin;
            const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
            if (isSafeToIgnoreNonOriginDifferences) return true;
        }
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("57Lhk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $8f5c48f3a9939b0b$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $e2gHg = parcelRequire("e2gHg");
const $8f5c48f3a9939b0b$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
$8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
$8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
    const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
    if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("e2gHg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a37e3434b26d3f31$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a37e3434b26d3f31$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a37e3434b26d3f31$var$isString(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
}
function $a37e3434b26d3f31$var$isObject(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
}
function $a37e3434b26d3f31$var$isRegExp(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
}
function $a37e3434b26d3f31$var$isFunction(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
}
function $a37e3434b26d3f31$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a37e3434b26d3f31$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a37e3434b26d3f31$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a37e3434b26d3f31$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a37e3434b26d3f31$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a37e3434b26d3f31$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a37e3434b26d3f31$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a37e3434b26d3f31$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a37e3434b26d3f31$var$isObject(val)) {
            if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
            else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a37e3434b26d3f31$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a37e3434b26d3f31$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a37e3434b26d3f31$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a37e3434b26d3f31$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a37e3434b26d3f31$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a37e3434b26d3f31$var$createMatch(self, shift) {
    var match = new $a37e3434b26d3f31$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a37e3434b26d3f31$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a37e3434b26d3f31$var$LinkifyIt;

});
parcelRegister("d5qnw", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("f14yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31acef3336a9ea7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("eVxaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356ea5acdd73a43$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gUlHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c264e87eca3a3d05$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $c264e87eca3a3d05$var$isSub = (type)=>{
    return type === 'sub';
};
function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
    if ($c264e87eca3a3d05$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("c15YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904856eee164f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $lKA8N = parcelRequire("lKA8N");

var $hxoiH = parcelRequire("hxoiH");
function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("lKA8N", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $965e3166a7c18c5e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $965e3166a7c18c5e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("koUAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d139f843714a421$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $7dikW = parcelRequire("7dikW");

var $hxoiH = parcelRequire("hxoiH");
function $7d139f843714a421$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $7dikW.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("7dikW", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);

var $gmhCD = parcelRequire("gmhCD");
const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $gmhCD.editorExperiment)('editor_text_highlight_orange_to_yellow', 'test', {
        exposure: true
    })) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $b5a4f7ad3e4ae03c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("eESZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8016b636a69d58$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("95Yll", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f1f5242a99941b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $56f1f5242a99941b$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $56f1f5242a99941b$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            style: {
                width: (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("lbdLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b7090399d1e727$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aeGrH = parcelRequire("aeGrH");

var $bL5sD = parcelRequire("bL5sD");
const $d1b7090399d1e727$var$MarkWrapperOld = (props)=>{
    const styles = props['data-align'] ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("text-align:", (0, $aeGrH.alignmentPositionMap)[props['data-align']], ";") : '';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: styles,
        ...props
    }, props.children);
};
const $d1b7090399d1e727$var$MarkWrapperNew = (props)=>{
    const dataAlign = props['data-align'] ? (0, $aeGrH.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
const $d1b7090399d1e727$var$MarkWrapper = (0, $bL5sD.componentWithFG)('platform_editor_emotion_refactor_renderer', $d1b7090399d1e727$var$MarkWrapperNew, $d1b7090399d1e727$var$MarkWrapperOld);
function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d1b7090399d1e727$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("9xZ5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef073b46e3c6008$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("g5EjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1398622ac205fad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("acz8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04eeed03d14d0e78$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("8DQfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $009dff5e97619965$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $009dff5e97619965$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("g9yqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac6eff929f5b91e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("itF0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f200b42408cc462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6EeUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb661461ca3406$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("aXBFx")).extendedBlockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => (parcelRequire("aXBFx")).blockquoteWithoutNonBodiedMacros);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => (parcelRequire("2FIVU")).listItemWithoutNonBodiedMacros);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => (parcelRequire("bFtEE")).panelWithoutNestedNonBodiedMacros);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => (parcelRequire("dx5eC")).nestedExpandWithoutNonBodiedMacros);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("bzwTW", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $99a90b85f857f7e6$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $99a90b85f857f7e6$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $99a90b85f857f7e6$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $99a90b85f857f7e6$export$244bf4b32387ef62);
const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $99a90b85f857f7e6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer'
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $VSDnB.fg)('cc_complexit_fe_memoValidation_redundant_calls')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the fucntion returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, skipValidation] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, oldSkipValidation] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1urn6", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $d9518b7b87f036fd$export$77218b6ff680865f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $9S8fM = parcelRequire("9S8fM");
const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
    const mediaProvider = (0, $9S8fM.useProvider)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, $cEHh7.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5uXOq.useEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});

parcelRegister("1pTqN", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ae2d04c26b960a03$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ae2d04c26b960a03$export$cddc3c6ebe2d2cec);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae2d04c26b960a03$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("jUVor", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $5224f7c9e411dec4$export$cfc1361be0de4203);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eOOFp = parcelRequire("eOOFp");

var $VSDnB = parcelRequire("VSDnB");

var $OxITw = parcelRequire("OxITw");
function $5224f7c9e411dec4$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const context = $5224f7c9e411dec4$export$92859d13f30c883e(id);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $5224f7c9e411dec4$export$92859d13f30c883e(id) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${Boolean((0, $VSDnB.fg)('platform-fix-table-ssr-resizing'))});
  })(window);
`;
}
const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $eOOFp.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $eOOFp.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $eOOFp.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $eOOFp.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $eOOFp.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $OxITw.FullPagePadding).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (!shouldFixTableResizing) {
                    if (node.classList.contains('pm-table-container') && mode === 'custom') {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const rendererWidth = renderer.offsetWidth;
                        const effectiveWidth = rendererWidth - breakoutConsts.padding;
                        width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                    } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(mode, node.dataset.width || null, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderer.offsetWidth);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                    if (node.style.width === width) return;
                    node.style.width = width;
                    // Tables require some special logic, as they are not using common css transform approach,
                    // because it breaks with sticky headers. This logic is copied from a table node:
                    // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                    if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    !renderer.classList.contains('is-full-width')) {
                        const lineLength = breakoutConsts.calcLineLength();
                        const left = lineLength / 2 - parseInt(width) / 2;
                        if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                        else node.style.left = '';
                    }
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, $eOOFp.breakoutConsts).calcLineLength;

});

parcelRegister("TPpI8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $2d523c4d7c031fc5$export$3dee5e4542c672d9);


function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("3lRy2", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $de95a93fc343bd51$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");
const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $de95a93fc343bd51$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, children);
};
class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($de95a93fc343bd51$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("1SqDw", function(module, exports) {

$parcel$export(module.exports, "ValidationContext", () => $a1d6c169ab0ab071$export$d452675449e81987);

var $5uXOq = parcelRequire("5uXOq");
const $a1d6c169ab0ab071$export$d452675449e81987 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a1d6c169ab0ab071$export$5b655fe45447a548 = $a1d6c169ab0ab071$export$d452675449e81987.Provider;

});

parcelRegister("glOdv", function(module, exports) {

$parcel$export(module.exports, "RendererStyleContainer", () => $db1d99891a2fef87$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
                                                                                                                                                                                                                                                                           * @jsxRuntime classic
                                                                                                                                                                                                                                                                           * @jsx jsx
                                                                                                                                                                                                                                                                           */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");


var $OxITw = parcelRequire("OxITw");

var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");

var $iHYdz = parcelRequire("iHYdz");

var $9R9Rb = parcelRequire("9R9Rb");

var $3rouw = parcelRequire("3rouw");

var $cYeQP = parcelRequire("cYeQP");
var $4E5wI = parcelRequire("4E5wI");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $iJOES = parcelRequire("iJOES");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $gmhCD = parcelRequire("gmhCD");

var $dkc63 = parcelRequire("dkc63");


var $2o2hu = parcelRequire("2o2hu");

var $04VvC = parcelRequire("04VvC");

var $aagOn = parcelRequire("aagOn");
function $db1d99891a2fef87$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db1d99891a2fef87$var$wrappedMediaBreakoutPoint = 410;
const $db1d99891a2fef87$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $db1d99891a2fef87$var$tableShadowWidth = 32;
const $db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $db1d99891a2fef87$var$tableRowHeight = 44;
const $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded = ()=>(0, $gE8f9.browser).isGecko || (0, $gE8f9.browser).isIE || (0, $gE8f9.browser).isMac && (0, $gE8f9.browser).isChrome;
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $db1d99891a2fef87$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    }
});
const $db1d99891a2fef87$var$rendererFullPageStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $OxITw.FullPagePadding)}px`
});
const $db1d99891a2fef87$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $db1d99891a2fef87$var$telepointerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`#${$db1d99891a2fef87$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: '0px 2px 2px 0px',
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #0C66E4)"
        }
    }
});
const $db1d99891a2fef87$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $db1d99891a2fef87$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: `${(0, $gmhCD.editorExperiment)('platform_editor_nested_non_bodied_macros', 'test')}` ? 'block' : 'inline-block'
        }
    }
});
const $db1d99891a2fef87$var$headingsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $db1d99891a2fef87$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $db1d99891a2fef87$var$ruleSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: '1px'
    }
});
const $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $db1d99891a2fef87$var$paragraphSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $iHYdz.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $db1d99891a2fef87$var$listsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $jlYLw.listItemCounterPadding)}px)`
    },
    [`${0, $dwptW.orderedListSelector}, ${0, $kjhhp.bulletListSelector}`]: {
        /*
        Ensures list item content adheres to the list's margin instead
        of filling the entire block row. This is important to allow
        clicking interactive elements which are floated next to a list.
         For some history and context on this block, see PRs related to tickets.:
        @see ED-6551 - original issue.
        @see ED-7015 - follow up issue.
        @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
         @see https://css-tricks.com/display-flow-root/
      */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
         We support nested lists up to six levels deep.
     **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $db1d99891a2fef87$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $db1d99891a2fef87$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $db1d99891a2fef87$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`})`,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $db1d99891a2fef87$var$shadowSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $db1d99891a2fef87$var$dateSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $db1d99891a2fef87$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $db1d99891a2fef87$var$backgroundColorStyles = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $db1d99891a2fef87$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $iHYdz.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $iHYdz.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $iHYdz.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER}`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$baseOtherStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .${0, $ceYEW.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.image-align-start,
		.${0, $ceYEW.richMediaClassName}.image-center,
		.${0, $ceYEW.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $l8Gxi.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`
        },
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $db1d99891a2fef87$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $db1d99891a2fef87$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $ceYEW.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $ceYEW.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-right, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$db1d99891a2fef87$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $db1d99891a2fef87$var$tableSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $iHYdz.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $6gEe5.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $iHYdz.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // platform_editor_renderer_table_header_styles has already been launched, so assume it's on
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $6gEe5.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $6gEe5.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`,
            zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
            width: `${$db1d99891a2fef87$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`
        }
    }
});
const $db1d99891a2fef87$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$db1d99891a2fef87$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $db1d99891a2fef87$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $6gEe5.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`
                        }
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// TODO: ED-27229 - Cleanup with `platform_editor_tables_numbered_column_correction`
const $db1d99891a2fef87$var$rendererTableColumnStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${`var(--ds-background-neutral, ${(0, $iHYdz.akEditorTableToolbar)})`}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $db1d99891a2fef87$var$stickyHeaderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $db1d99891a2fef87$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}
		> .${(0, $2o2hu.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $iHYdz.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $iHYdz.blockNodesVerticalMargin)
        }
    }
});
const $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $db1d99891a2fef87$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $db1d99891a2fef87$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $iHYdz.akEditorLineHeight)}em !important`
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $db1d99891a2fef87$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, allowAnnotations: allowAnnotations, allowTableResizing: allowTableResizing, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
    if ((0, $VSDnB.fg)('platform_editor_emotion_refactor_renderer')) return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${(0, $aagOn.getBaseFontSize)(appearance)}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $04VvC.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $04VvC.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $04VvC.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $04VvC.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $04VvC.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $04VvC.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $04VvC.default)('editor.font.body')}`
        },
        css: [
            $db1d99891a2fef87$var$baseStyles,
            appearance === 'full-page' && $db1d99891a2fef87$var$rendererFullPageStyles,
            appearance === 'full-width' && $db1d99891a2fef87$var$rendererFullWidthStyles,
            !(0, $dkc63.isTableResizingEnabled)(appearance) && $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing,
            $db1d99891a2fef87$var$telepointerStyles,
            $db1d99891a2fef87$var$whitespaceSharedStyles,
            $db1d99891a2fef87$var$blockquoteSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC : $db1d99891a2fef87$var$headingsSharedStyles,
            $db1d99891a2fef87$var$headingWithAlignmentStyles,
            $db1d99891a2fef87$var$ruleSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC : $db1d99891a2fef87$var$paragraphSharedStyles,
            $db1d99891a2fef87$var$listsSharedStyles,
            (0, $gE8f9.browser).gecko && $db1d99891a2fef87$var$listsSharedStylesForGekko,
            $db1d99891a2fef87$var$indentationSharedStyles,
            $db1d99891a2fef87$var$blockMarksSharedStyles,
            $db1d99891a2fef87$var$codeMarkSharedStyles,
            $db1d99891a2fef87$var$shadowSharedStyle,
            $db1d99891a2fef87$var$dateSharedStyle,
            $db1d99891a2fef87$var$textColorStyles,
            $db1d99891a2fef87$var$backgroundColorStyles,
            $db1d99891a2fef87$var$tasksAndDecisionsStyles,
            $db1d99891a2fef87$var$smartCardStyles,
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $db1d99891a2fef87$var$smartCardStylesAvatarFix,
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $db1d99891a2fef87$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') && $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix,
            $db1d99891a2fef87$var$baseOtherStyles,
            allowNestedHeaderLinks && $db1d99891a2fef87$var$alignedHeadingAnchorStyle,
            $db1d99891a2fef87$var$mediaSingleSharedStyle,
            $db1d99891a2fef87$var$tableSharedStyle,
            $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly,
            $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded() && $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD : $db1d99891a2fef87$var$firstNodeWithNotMarginTop,
            $db1d99891a2fef87$var$rendererTableStyles,
            (0, $dkc63.isStickyScrollbarEnabled)(appearance) && $db1d99891a2fef87$var$stickyScrollbarStyles,
            $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $db1d99891a2fef87$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            (0, $VSDnB.fg)('platform_editor_tables_numbered_column_correction') ? $db1d99891a2fef87$var$rendererTableColumnStyles : $db1d99891a2fef87$var$rendererTableColumnStylesOld,
            $db1d99891a2fef87$var$stickyHeaderStyles,
            $db1d99891a2fef87$var$codeBlockAndLayoutStyles,
            $db1d99891a2fef87$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $db1d99891a2fef87$var$gridRenderForCodeBlockStyles,
            (0, $gE8f9.browser).safari && $db1d99891a2fef87$var$codeBlockInListSafariFixStyles
        ],
        "data-testid": testId
    }, children));
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $OxITw.rendererStyles)({
            appearance: appearance,
            allowNestedHeaderLinks: allowNestedHeaderLinks,
            allowColumnSorting: !!allowColumnSorting,
            useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
            allowAnnotations: allowAnnotations,
            allowTableResizing: allowTableResizing
        }),
        "data-testid": testId
    }, props.children));
};

});
parcelRegister("aagOn", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $1723ca6d969fec09$export$8e2864079bc476bd);

var $iHYdz = parcelRequire("iHYdz");
const $1723ca6d969fec09$export$8e2864079bc476bd = (appearance)=>{
    return appearance && appearance !== 'comment' ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : 14;
};

});


parcelRegister("dJPoO", function(module, exports) {

$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $364a1dd5fa66cb46$export$c94cfc0c675062a1);
const $364a1dd5fa66cb46$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});


parcelRegister("h17zy", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $502e0815e90e6f7b$export$d80cf6b7758b1c7e);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $hXRXz = parcelRequire("hXRXz");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $502e0815e90e6f7b$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const emojiProvider = (0, $5uXOq.useMemo)(()=>{
        const dataProviders = new (0, $dGzaM.default)();
        dataProviders.setProvider('emojiProvider', (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});

parcelRegister("6a30R", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $97cd92cd81dfd9ff$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $97cd92cd81dfd9ff$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $97cd92cd81dfd9ff$export$3f864e37674c79e7);
$parcel$export(module.exports, "useSmartCardIsAIEnabled", () => $97cd92cd81dfd9ff$export$af081b1242bfa300);
$parcel$export(module.exports, "SmartCardProviderWithAIHooks", () => $97cd92cd81dfd9ff$export$ca9fa6647337e334);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8dO33 = parcelRequire("8dO33");

var $dn5wJ = parcelRequire("dn5wJ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $iixvy = parcelRequire("iixvy");

var $93Yeu = parcelRequire("93Yeu");
const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
    (0, $gKZoD.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gKZoD.di)(window);
    if (!url) return;
    if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $dn5wJ.CardAction).ChangeStatusAction
        ]
    }
};
const $97cd92cd81dfd9ff$export$4761115a9e18aa47 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = (0, $5uXOq.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $97cd92cd81dfd9ff$export$4761115a9e18aa47(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};
const $97cd92cd81dfd9ff$export$af081b1242bfa300 = ()=>{
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    return isAiOptInEnabled && isPremium;
};
const $97cd92cd81dfd9ff$export$ca9fa6647337e334 = (props)=>{
    const product = $97cd92cd81dfd9ff$export$3f864e37674c79e7();
    const isAIEnabled = $97cd92cd81dfd9ff$export$af081b1242bfa300();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAIEnabled,
        ...props
    }, props.children);
};

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("iixvy", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $545133d1825caa45$export$1bb5840a003dc643);
$parcel$export(module.exports, "useOptInStatus", () => $545133d1825caa45$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $545133d1825caa45$export$49e57b9044cda91c);

var $5uXOq = parcelRequire("5uXOq");

var $kTK0a = parcelRequire("kTK0a");
var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $5NH95 = parcelRequire("5NH95");

var $93Yeu = parcelRequire("93Yeu");

var $14XJw = parcelRequire("14XJw");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $44KLa = parcelRequire("44KLa");
const $545133d1825caa45$var$DISABLED = 'disabled';
const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $545133d1825caa45$var$ENABLED = 'enabled';
const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return appEditions.core === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.STANDARD_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $aIZdc.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $aIZdc.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
    if ((0, $aIZdc.isFedRamp)()) return $545133d1825caa45$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $545133d1825caa45$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
    return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
};
const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $kTK0a.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljlOe.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $aIZdc.isFedRamp)()) return {
        optInStatus: $545133d1825caa45$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("5NH95", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $26b3b3762ac33b52$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $26b3b3762ac33b52$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aIZdc = parcelRequire("aIZdc");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $fmQtB = parcelRequire("fmQtB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $4SswE = parcelRequire("4SswE");

var $7xCut = parcelRequire("7xCut");
const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $2vSU6.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const supportedEdition = $26b3b3762ac33b52$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $ldyPw.FREE_EDITION) && isOrgAdmin && !(0, $aIZdc.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $5uXOq.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $7xCut.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmQtB.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isClicked = (0, $7xCut.getUpsellButtonWrapperClicked)();
    const hasFired = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFired.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $26b3b3762ac33b52$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $26b3b3762ac33b52$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fmQtB", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $2c23576aa5eb8dba$export$827041a383456a6a);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("d6LGc")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("d6LGc", function(module, exports) {

let $98b0d21b5b5937ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $98b0d21b5b5937ec$var$load("h2MrD"),
    $98b0d21b5b5937ec$var$load("bYT2S"),
    $98b0d21b5b5937ec$var$load("bQd01")
]).then(()=>parcelRequire('b738i'));

});


parcelRegister("7xCut", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$b595420beb43f9ce);

var $bSSG7 = parcelRequire("bSSG7");
const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
    return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
    $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("ljlOe", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $82777381236a0306$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $82777381236a0306$export$dd0a751f23b19473);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $b3Gth = parcelRequire("b3Gth");
const $82777381236a0306$export$77aa5ca661b0742c = (0, $l37qh.createUseEntryPointContext)();
const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("44KLa", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $bf7c19a18c627984$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $bf7c19a18c627984$export$bbf8d259a508a485);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $7NYq5 = parcelRequire("7NYq5");

var $4UN9Z = parcelRequire("4UN9Z");

var $7XluA = parcelRequire("7XluA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ljlOe = parcelRequire("ljlOe");

var $ejjdc = parcelRequire("ejjdc");
const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UN9Z.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-premium-trial-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ejjdc.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("4UN9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $498daaeb8cd4c6ec$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c0x54 = parcelRequire("c0x54");


var $ek69Y = parcelRequire("ek69Y");

var $lJhAv = parcelRequire("lJhAv");
const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $ek69Y.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $5uXOq.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($c0x54)))
        ]);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0x54))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                            xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $ek69Y.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;

});
parcelRegister("c0x54", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("ek69Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fe19a2c65ae0a6d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("lJhAv", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $1bcec8f5b168d85d$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $1bcec8f5b168d85d$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $1bcec8f5b168d85d$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $1bcec8f5b168d85d$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $1bcec8f5b168d85d$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1bcec8f5b168d85d$export$24c280970213bb11 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$14966827497f4695 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ejjdc", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $678322372bbc5cca$export$54e4ba490d2c6bb5);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $2jwCH = parcelRequire("2jwCH");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $gEusR = parcelRequire("gEusR");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2ogyS = parcelRequire("2ogyS");

var $iau6N = parcelRequire("iau6N");
const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $678322372bbc5cca$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignBlock: "stretch",
        xcss: $678322372bbc5cca$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $678322372bbc5cca$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $2ogyS.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEusR.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $678322372bbc5cca$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $2ogyS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $2ogyS.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iau6N.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $678322372bbc5cca$var$containerBorderStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${"var(--ds-background-accent-blue-subtle, #579DFF)"} 0%,
      ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"} 100%
    )`
});
const $678322372bbc5cca$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $678322372bbc5cca$var$headerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $678322372bbc5cca$var$textContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300'
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("gEusR", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf0e2023e742d66$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $8nOP6 = parcelRequire("8nOP6");

var $4aPxh = parcelRequire("4aPxh");
const $daf0e2023e742d66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4aPxh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8nOP6))
});
var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
// for advanced use only
const $daf0e2023e742d66$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("8nOP6", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("4aPxh", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("2ogyS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $703e8ca8733c69fc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $703e8ca8733c69fc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("iau6N", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d916fa2fae12e75a$export$a2651a739f515dd4);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $3ZC89 = parcelRequire("3ZC89");

var $bOVbW = parcelRequire("bOVbW");

var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $2ogyS = parcelRequire("2ogyS");
const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: (0, $4R6GH.fg)('issue-view-sparkle-icon-replacement-fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bOVbW))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $2ogyS.messages).tryItFreeButton));
};

});





parcelRegister("4L2MR", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $0d4861c69889f89e$export$2c1e5dc35269c547);
$parcel$export(module.exports, "adfDocument", () => $0d4861c69889f89e$export$754eb30ac7b536b8);
$parcel$export(module.exports, "getErrorMessage", () => $0d4861c69889f89e$export$82f46aa4e6535a45);


var $4IoOR = parcelRequire("4IoOR");

var $8Xls4 = parcelRequire("8Xls4");

var $5ewBi = parcelRequire("5ewBi");
const $0d4861c69889f89e$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    if (urlSuffix in (0, $8Xls4.LEARN_MORE_MESSAGES)) return (0, $8Xls4.LEARN_MORE_MESSAGES)[urlSuffix];
    return (0, $5ewBi.default).fieldHelpTextLabel;
};
const $0d4861c69889f89e$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
    const helperMessage = $0d4861c69889f89e$export$2c1e5dc35269c547(fieldHelpTextUrl) || (0, $5ewBi.default).fieldHelpTextLabel;
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $0d4861c69889f89e$export$754eb30ac7b536b8 = ({ description: description })=>(0, $4IoOR.convertWikiToAdf)(description);
const $0d4861c69889f89e$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $dccd0dbe975cd803$export$b1c05b34d317c074:
            return formatMessage((0, $5ewBi.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $dccd0dbe975cd803$export$618e922e89e8bcae:
            return formatMessage((0, $5ewBi.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $dccd0dbe975cd803$export$fe1a70381f6491b5))
            });
        case 0, $dccd0dbe975cd803$export$d2d79153ead377fe:
            return formatMessage((0, $5ewBi.default).urlInvalidErrorMessage, {
                fieldName: fieldName
            });
        default:
            return validationError;
    }
};

});
const $dccd0dbe975cd803$export$b1c05b34d317c074 = 'REQUIRED';
const $dccd0dbe975cd803$export$618e922e89e8bcae = 'STRING_INVALID';
const $dccd0dbe975cd803$export$fe1a70381f6491b5 = 255;
const $dccd0dbe975cd803$export$d2d79153ead377fe = 'URL_INVALID';

parcelRegister("4IoOR", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $7c8efe67867622a1$export$3dfdef94497f0395);

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");

var $dN5CS = parcelRequire("dN5CS");
const $7c8efe67867622a1$var$wikiTransformer = new (0, $dN5CS.WikiMarkupTransformer)((0, $kOFhM.defaultSchema));
const $7c8efe67867622a1$var$adfTransformer = new (0, $hYNZx.JSONTransformer)();
const $7c8efe67867622a1$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $7c8efe67867622a1$var$wikiTransformer.parse(wiki);
    return $7c8efe67867622a1$var$adfTransformer.encode(pmNode);
};

});
parcelRegister("dN5CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $4011ad83704160d6$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $4011ad83704160d6$export$2e2bcd8739ae039);

var $kOFhM = parcelRequire("kOFhM");

var $lxtC7 = parcelRequire("lxtC7");

var $djcbG = parcelRequire("djcbG");

var $bOMPB = parcelRequire("bOMPB");
class $4011ad83704160d6$export$caaa00407b56b900 {
    constructor(schema = (0, $kOFhM.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $lxtC7.encode)(node, $4011ad83704160d6$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $djcbG.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($4011ad83704160d6$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $bOMPB.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $4011ad83704160d6$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $4011ad83704160d6$export$2e2bcd8739ae039 = $4011ad83704160d6$export$caaa00407b56b900;

});
parcelRegister("lxtC7", function(module, exports) {

$parcel$export(module.exports, "encode", () => $f10f1fd2bcfd2732$export$c564cdbbe6da493);

var $03QYI = parcelRequire("03QYI");

var $6ises = parcelRequire("6ises");

var $hgytR = parcelRequire("hgytR");

var $b6sEJ = parcelRequire("b6sEJ");

var $73kPn = parcelRequire("73kPn");

var $1B6CN = parcelRequire("1B6CN");

var $8UMD2 = parcelRequire("8UMD2");

var $fIzNZ = parcelRequire("fIzNZ");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");

var $h9tzi = parcelRequire("h9tzi");

var $abXFq = parcelRequire("abXFq");

var $flJtr = parcelRequire("flJtr");

var $czgKo = parcelRequire("czgKo");

var $acqkf = parcelRequire("acqkf");

var $1Nefo = parcelRequire("1Nefo");

var $69N10 = parcelRequire("69N10");

var $12A17 = parcelRequire("12A17");

var $bsbI5 = parcelRequire("bsbI5");
const $f10f1fd2bcfd2732$var$nodeEncoderMapping = {
    blockquote: $03QYI.blockquote,
    bulletList: $6ises.bulletList,
    taskList: $hgytR.taskList,
    decisionList: $b6sEJ.decisionList,
    codeBlock: $73kPn.codeBlock,
    doc: $1B6CN.doc,
    heading: $fIzNZ.heading,
    caption: $bsbI5.caption,
    mediaGroup: $eTlm6.mediaGroup,
    mediaInline: $6obXI.mediaInline,
    mediaSingle: (0, $eTlm6.mediaGroup),
    orderedList: $h9tzi.orderedList,
    panel: $abXFq.panel,
    paragraph: $flJtr.paragraph,
    rule: $czgKo.rule,
    table: $acqkf.table,
    blockCard: $69N10.blockCard,
    embedCard: $12A17.embedCard,
    expand: $8UMD2.expand
};
function $f10f1fd2bcfd2732$export$c564cdbbe6da493(node, context) {
    const encoder = $f10f1fd2bcfd2732$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $1Nefo.unknown)(node);
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
}

});
parcelRegister("03QYI", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $f393e710d4117486$export$67dc04e652a298ca);

var $lxtC7 = parcelRequire("lxtC7");
const $f393e710d4117486$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("6ises", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $92e38ddcaccbcaf0$export$a140c94e5ea26bee);

var $bxtEu = parcelRequire("bxtEu");
const $92e38ddcaccbcaf0$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("bxtEu", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b39a87ae4fdec39c$export$76c7e83ecc9cdf05);

var $lxtC7 = parcelRequire("lxtC7");

var $flJtr = parcelRequire("flJtr");

var $1Nefo = parcelRequire("1Nefo");

var $73kPn = parcelRequire("73kPn");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");
const $b39a87ae4fdec39c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $flJtr.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $lxtC7.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $73kPn.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $6obXI.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $eTlm6.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $1Nefo.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("flJtr", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3fb83d21e304518d$export$9c206ddddb32a9b);

var $bK2QZ = parcelRequire("bK2QZ");
const $3fb83d21e304518d$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("bK2QZ", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $d36b73d9ad63ab63$export$96c94bfc00b85760);

var $91ILy = parcelRequire("91ILy");

var $e34Iq = parcelRequire("e34Iq");

var $6obXI = parcelRequire("6obXI");

var $7GCbZ = parcelRequire("7GCbZ");

var $6ayzl = parcelRequire("6ayzl");

var $5IuwX = parcelRequire("5IuwX");

var $1HDja = parcelRequire("1HDja");

var $1Nefo = parcelRequire("1Nefo");

var $c08Yp = parcelRequire("c08Yp");
const $d36b73d9ad63ab63$var$inlinesEncoderMapping = {
    emoji: $91ILy.emoji,
    hardBreak: $e34Iq.hardBreak,
    mediaInline: $6obXI.mediaInline,
    mention: $7GCbZ.mention,
    text: $6ayzl.text,
    inlineCard: $5IuwX.inlineCard,
    status: $1HDja.status,
    date: $c08Yp.date
};
const $d36b73d9ad63ab63$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $d36b73d9ad63ab63$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("91ILy", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $15d1256cf1644afa$export$a19185d1233fc4b2);

var $g5UJK = parcelRequire("g5UJK");

var $1Nefo = parcelRequire("1Nefo");
const $15d1256cf1644afa$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $g5UJK.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("g5UJK", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $c03ab45b5b0f3a2b$export$83e1f26587c4acd2);
const $c03ab45b5b0f3a2b$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("1Nefo", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $6e7c0aa132a04ffb$export$19282c40b967aec6);

var $hYNZx = parcelRequire("hYNZx");
const $6e7c0aa132a04ffb$var$jsonTransformer = new (0, $hYNZx.JSONTransformer)();
const $6e7c0aa132a04ffb$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($6e7c0aa132a04ffb$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("e34Iq", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $0b90673427e9e36d$export$371da9dd35aba193);
const $0b90673427e9e36d$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("6obXI", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $b266c76290bae2fd$export$38bab695e3f720f1);
const $b266c76290bae2fd$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    const fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("7GCbZ", function(module, exports) {

$parcel$export(module.exports, "mention", () => $276f00c4f54975e4$export$db83999c14438df4);
const $276f00c4f54975e4$var$PREFIX = 'accountid:';
const $276f00c4f54975e4$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $276f00c4f54975e4$var$addPrefix = (content)=>content.toLowerCase().startsWith($276f00c4f54975e4$var$PREFIX) ? content : `${$276f00c4f54975e4$var$PREFIX}${content}`;
const $276f00c4f54975e4$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $276f00c4f54975e4$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $276f00c4f54975e4$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("6ayzl", function(module, exports) {

$parcel$export(module.exports, "text", () => $774ee87c38efef1c$export$6f093cfa640b7166);

var $cG4PY = parcelRequire("cG4PY");

var $4yZSi = parcelRequire("4yZSi");

var $aDTWq = parcelRequire("aDTWq");

var $gdFeW = parcelRequire("gdFeW");

var $jo5YT = parcelRequire("jo5YT");

var $9fwgI = parcelRequire("9fwgI");

var $eKxrE = parcelRequire("eKxrE");

var $1x55I = parcelRequire("1x55I");

var $8tKGr = parcelRequire("8tKGr");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $774ee87c38efef1c$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $gdFeW.em)
    ],
    [
        'strike',
        (0, $9fwgI.strike)
    ],
    [
        'strong',
        (0, $eKxrE.strong)
    ],
    [
        'subsup',
        (0, $1x55I.subsup)
    ],
    [
        'underline',
        (0, $8tKGr.underline)
    ],
    [
        'textColor',
        (0, $aDTWq.textColor)
    ],
    [
        'link',
        (0, $jo5YT.link)
    ],
    [
        'code',
        (0, $4yZSi.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $774ee87c38efef1c$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $774ee87c38efef1c$var$escapingWikiFormatter(text) {
    const pattern = [
        $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN,
        ...(0, $cG4PY.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $774ee87c38efef1c$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $774ee87c38efef1c$var$isEscapeNeeded(node, parent) ? $774ee87c38efef1c$var$escapingWikiFormatter(node.text) : node.text;
    $774ee87c38efef1c$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("cG4PY", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $87fdd6b952f97dba$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $87fdd6b952f97dba$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $87fdd6b952f97dba$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $87fdd6b952f97dba$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $87fdd6b952f97dba$export$bcec6d03770b152c);

var $kSL4h = parcelRequire("kSL4h");

var $ayQVO = parcelRequire("ayQVO");
const $87fdd6b952f97dba$export$afcd7edeca61ca93 = [
    {
        type: (0, $kSL4h.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $kSL4h.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $kSL4h.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $kSL4h.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $kSL4h.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $kSL4h.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $kSL4h.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $87fdd6b952f97dba$var$keywordTokenMap = {
    '[': (0, $kSL4h.TokenType).LINK_FORMAT,
    http: (0, $kSL4h.TokenType).LINK_TEXT,
    ftp: (0, $kSL4h.TokenType).LINK_TEXT,
    jamfselfservice: (0, $kSL4h.TokenType).LINK_TEXT,
    irc: (0, $kSL4h.TokenType).LINK_TEXT,
    mailto: (0, $kSL4h.TokenType).LINK_TEXT,
    '\\\\': (0, $kSL4h.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $kSL4h.TokenType).HARD_BREAK,
    '\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '\r\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '!': (0, $kSL4h.TokenType).MEDIA,
    '----': (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $kSL4h.TokenType).DELETED,
    '{+}': (0, $kSL4h.TokenType).INSERTED,
    '{*}': (0, $kSL4h.TokenType).STRONG,
    '{^}': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '{~}': (0, $kSL4h.TokenType).SUBSCRIPT,
    '{_}': (0, $kSL4h.TokenType).EMPHASIS,
    '{{{}': (0, $kSL4h.TokenType).MONOSPACE,
    '{??}': (0, $kSL4h.TokenType).CITATION,
    '-': (0, $kSL4h.TokenType).DELETED,
    '+': (0, $kSL4h.TokenType).INSERTED,
    '*': (0, $kSL4h.TokenType).STRONG,
    '^': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '~': (0, $kSL4h.TokenType).SUBSCRIPT,
    _: (0, $kSL4h.TokenType).EMPHASIS,
    '{{': (0, $kSL4h.TokenType).MONOSPACE,
    '??': (0, $kSL4h.TokenType).CITATION
};
const $87fdd6b952f97dba$var$keywordTokenMapKeys = Object.keys($87fdd6b952f97dba$var$keywordTokenMap);
function $87fdd6b952f97dba$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $87fdd6b952f97dba$export$afcd7edeca61ca93.length; i++){
        const keyword = $87fdd6b952f97dba$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($87fdd6b952f97dba$var$keywordTokenMapKeys[i])) return {
            type: $87fdd6b952f97dba$var$keywordTokenMap[$87fdd6b952f97dba$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $kSL4h.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $87fdd6b952f97dba$var$leadingKeywordTokenMap = [
    {
        type: (0, $kSL4h.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $kSL4h.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $kSL4h.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $kSL4h.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $ayQVO.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $kSL4h.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $87fdd6b952f97dba$export$68162fc57528b560(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$leadingKeywordTokenMap.length; i++){
        const keyword = $87fdd6b952f97dba$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $kSL4h.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("kSL4h", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $160d182608400c84$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $160d182608400c84$export$af8f4e8328578827);

var $4Foyv = parcelRequire("4Foyv");

var $30Un5 = parcelRequire("30Un5");

var $coK8g = parcelRequire("coK8g");

var $5RdHN = parcelRequire("5RdHN");

var $55t1E = parcelRequire("55t1E");

var $jor5q = parcelRequire("jor5q");

var $hZ14o = parcelRequire("hZ14o");

var $6xaH8 = parcelRequire("6xaH8");

var $jMpI6 = parcelRequire("jMpI6");

var $iDsRr = parcelRequire("iDsRr");

var $7tIdE = parcelRequire("7tIdE");

var $1MGc3 = parcelRequire("1MGc3");

var $ayQVO = parcelRequire("ayQVO");

var $kPrK8 = parcelRequire("kPrK8");

var $4ZFIG = parcelRequire("4ZFIG");

var $91y57 = parcelRequire("91y57");

var $1Mtv8 = parcelRequire("1Mtv8");

var $77w3e = parcelRequire("77w3e");

var $lf0Nr = parcelRequire("lf0Nr");

var $4s89q = parcelRequire("4s89q");

var $ir9MO = parcelRequire("ir9MO");

var $7E14k = parcelRequire("7E14k");

var $9MeiU = parcelRequire("9MeiU");

var $f50H1 = parcelRequire("f50H1");

var $bSil4 = parcelRequire("bSil4");

var $4Dfwq = parcelRequire("4Dfwq");

var $cjZPi = parcelRequire("cjZPi");

var $8tGpW = parcelRequire("8tGpW");

var $lyI5i = parcelRequire("lyI5i");

var $bOMPB = parcelRequire("bOMPB");
var $160d182608400c84$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $160d182608400c84$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $55t1E.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $ir9MO.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $4ZFIG.quadrupleDashSymbol),
    ["RULER"]: (0, $91y57.ruler),
    ["STRONG"]: (0, $1Mtv8.strong),
    ["MONOSPACE"]: (0, $kPrK8.monospace),
    ["SUPERSCRIPT"]: (0, $lf0Nr.superscript),
    ["SUBSCRIPT"]: (0, $77w3e.subscript),
    ["EMPHASIS"]: (0, $hZ14o.emphasis),
    ["CITATION"]: (0, $coK8g.citation),
    ["DELETED"]: (0, $5RdHN.deleted),
    ["INSERTED"]: (0, $iDsRr.inserted),
    ["HARD_BREAK"]: (0, $6xaH8.hardbreak),
    ["LINK_FORMAT"]: (0, $7tIdE.linkFormat),
    ["LINK_TEXT"]: (0, $1MGc3.linkText),
    ["HEADING"]: (0, $jMpI6.heading),
    ["MEDIA"]: (0, $4Foyv.media),
    ["LIST"]: (0, $ayQVO.list),
    ["QUOTE"]: (0, $30Un5.blockquote),
    ["TABLE"]: (0, $4s89q.table),
    ["EMOJI"]: (0, $jor5q.emoji),
    ["ADF_MACRO"]: (0, $9MeiU.adfMacro),
    ["ANCHOR_MACRO"]: (0, $f50H1.anchorMacro),
    ["CODE_MACRO"]: (0, $bSil4.codeMacro),
    ["QUOTE_MACRO"]: (0, $4Dfwq.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $8tGpW.noformatMacro),
    ["PANEL_MACRO"]: (0, $7E14k.panelMacro),
    ["COLOR_MACRO"]: (0, $cjZPi.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $lyI5i.forceLineBreak),
    ["ISSUE_KEY"]: (0, $bOMPB.issueKey)
};
function $160d182608400c84$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $160d182608400c84$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $160d182608400c84$var$fallback(input, position);
    }
    return $160d182608400c84$var$fallback(input, position);
}
function $160d182608400c84$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Foyv", function(module, exports) {

$parcel$export(module.exports, "media", () => $8b246e16d82e8dde$export$987d49ffe1b0900f);

var $4V377 = parcelRequire("4V377");

var $4ZUg7 = parcelRequire("4ZUg7");

var $eyO0H = parcelRequire("eyO0H");
const $8b246e16d82e8dde$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $4V377.default)(schema, rawContent, (0, $4ZUg7.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("4V377", function(module, exports) {

$parcel$export(module.exports, "default", () => $2106e5f40786af56$export$2e2bcd8739ae039);

var $1MGc3 = parcelRequire("1MGc3");
const $2106e5f40786af56$var$defaultWidth = 200;
const $2106e5f40786af56$var$defaultHeight = 183;
const $2106e5f40786af56$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $2106e5f40786af56$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2106e5f40786af56$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2106e5f40786af56$var$defaultHeight;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $2106e5f40786af56$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $1MGc3.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("1MGc3", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $49f89f13b4b7c481$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $49f89f13b4b7c481$export$cb7bcf09a05b7705);

var $iZOJ9 = parcelRequire("iZOJ9");

var $iqYHB = parcelRequire("iqYHB");
const $49f89f13b4b7c481$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $49f89f13b4b7c481$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($49f89f13b4b7c481$export$f69d1dce349473aa);
    if (!matches) return $49f89f13b4b7c481$var$fallback(input, position);
    const match = $49f89f13b4b7c481$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $iqYHB.decode)($49f89f13b4b7c481$var$unescape(match[0]));
    if (!(0, $iZOJ9.isSafeUrl)(url)) return $49f89f13b4b7c481$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $49f89f13b4b7c481$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $49f89f13b4b7c481$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $49f89f13b4b7c481$var$trimBadEndChar(input) {
    return [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("iqYHB", function(module, exports) {

$parcel$export(module.exports, "decode", () => $c6b4ec3136742c55$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $c6b4ec3136742c55$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("4ZUg7", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $972abf9f01734b21$export$e1a9355cfd8f6c64);
function $972abf9f01734b21$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("eyO0H", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $dee2bdf3f1017b16$export$a71d57024d3da1c5);

var $kSL4h = parcelRequire("kSL4h");

var $7tIdE = parcelRequire("7tIdE");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $2weJO = parcelRequire("2weJO");
const $dee2bdf3f1017b16$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $dee2bdf3f1017b16$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $dee2bdf3f1017b16$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $dee2bdf3f1017b16$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && // Ignored via go/ees005
                        // eslint-disable-next-line require-unicode-regexp
                        /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $dee2bdf3f1017b16$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $dee2bdf3f1017b16$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $dee2bdf3f1017b16$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $dee2bdf3f1017b16$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $dee2bdf3f1017b16$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $dee2bdf3f1017b16$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $dee2bdf3f1017b16$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $dee2bdf3f1017b16$var$processState.INLINE_MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $kSL4h.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
}
function $dee2bdf3f1017b16$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("7tIdE", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $0412731f8f85cc95$export$e1f888a4b6f2ee53);

var $kSL4h = parcelRequire("kSL4h");

var $29zBb = parcelRequire("29zBb");

var $9jjzg = parcelRequire("9jjzg");

var $gGleW = parcelRequire("gGleW");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0412731f8f85cc95$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $0412731f8f85cc95$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0412731f8f85cc95$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        // We want to avoid recursion
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).LINK_FORMAT
    ];
    if (!match) return $0412731f8f85cc95$var$fallback();
    const content = (0, $gGleW.parseContentLink)(match[1]);
    const resolvedLink = (0, $9jjzg.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $0412731f8f85cc95$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("29zBb", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $e7a948cf285a18ed$export$960addfb9e5a0cde);

var $04cDS = parcelRequire("04cDS");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $2weJO = parcelRequire("2weJO");

var $20lXC = parcelRequire("20lXC");
const $e7a948cf285a18ed$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $e7a948cf285a18ed$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $e7a948cf285a18ed$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $kSL4h.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $e7a948cf285a18ed$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $eWAZI.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $cG4PY.parseLeadingKeyword)(substring) || (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                }
            case $e7a948cf285a18ed$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $cG4PY.parseOtherKeyword)(substring);
                    else match = (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $e7a948cf285a18ed$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $e7a948cf285a18ed$var$processState.TOKEN:
                {
                    const token = (0, $kSL4h.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $kSL4h.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $e7a948cf285a18ed$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $04cDS.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) state = $e7a948cf285a18ed$var$processState.NEWLINE;
                    else state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            case $e7a948cf285a18ed$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $04cDS.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $e7a948cf285a18ed$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("04cDS", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $e67b0538295ca231$export$b2ce9ad90858ed7a);
function $e67b0538295ca231$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("eWAZI", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $b3a19bb1e901f2d4$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $b3a19bb1e901f2d4$export$9c597b035e16623b);
function $b3a19bb1e901f2d4$export$877995a80ec11782(input) {
    const newlineLength = $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $b3a19bb1e901f2d4$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $b3a19bb1e901f2d4$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("2weJO", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $35d0c4c2d3000f41$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $35d0c4c2d3000f41$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $35d0c4c2d3000f41$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($35d0c4c2d3000f41$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("20lXC", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $50669f552f016dd9$export$e21f6b7efdaf8b5d);

var $4UJvN = parcelRequire("4UJvN");
function $50669f552f016dd9$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $50669f552f016dd9$var$normalizeMediaGroups,
        $50669f552f016dd9$export$2cef2a4c047f9887,
        $50669f552f016dd9$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $50669f552f016dd9$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($50669f552f016dd9$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $50669f552f016dd9$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $4UJvN.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $50669f552f016dd9$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $50669f552f016dd9$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) || !$50669f552f016dd9$var$isEmptyTextNode(n) || $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $50669f552f016dd9$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $50669f552f016dd9$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $50669f552f016dd9$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("4UJvN", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $4ae1f625ac901e34$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $4ae1f625ac901e34$export$f0eaed48ea684567);
function $4ae1f625ac901e34$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $4ae1f625ac901e34$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("9jjzg", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $c08b1d888f635e2c$export$c2baa561eb017101);

var $30RSK = parcelRequire("30RSK");

var $lRYXZ = parcelRequire("lRYXZ");

var $b0Iw2 = parcelRequire("b0Iw2");

var $k1MiS = parcelRequire("k1MiS");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $c08b1d888f635e2c$var$linkResolverStrategies = [
    (0, $lRYXZ.attachmentLinkResolver),
    (0, $30RSK.mentionLinkResolver),
    (0, $k1MiS.issueLinkResolver),
    (0, $b0Iw2.urlLinkResolver)
];
function $c08b1d888f635e2c$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $c08b1d888f635e2c$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("30RSK", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $bbe5fc702887fa8b$export$1da3b34e38fc6ca8);
function $bbe5fc702887fa8b$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("lRYXZ", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $2514090e6b8dffff$export$ce918f41a76b8445);

var $4vpto = parcelRequire("4vpto");
function $2514090e6b8dffff$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4vpto.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4vpto", function(module, exports) {

$parcel$export(module.exports, "default", () => $904a1bc635a5ad9a$export$2e2bcd8739ae039);
function $904a1bc635a5ad9a$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("b0Iw2", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $e20b005b86e07eab$export$b737d556d2167f9);

var $kSL4h = parcelRequire("kSL4h");

var $iZOJ9 = parcelRequire("iZOJ9");

var $29zBb = parcelRequire("29zBb");

var $gxAE9 = parcelRequire("gxAE9");
function $e20b005b86e07eab$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $iZOJ9.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$e20b005b86e07eab$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $e20b005b86e07eab$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("gxAE9", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $fd57502cc274f1df$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $fd57502cc274f1df$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $fd57502cc274f1df$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $fd57502cc274f1df$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $fd57502cc274f1df$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $fd57502cc274f1df$export$83347051c3437dc9);
function $fd57502cc274f1df$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $fd57502cc274f1df$export$727d9dbc4fbb948f(value) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!value.match(/^\d$/);
}
function $fd57502cc274f1df$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $fd57502cc274f1df$export$4d9e7a1c098df5e2(value) {
    return !$fd57502cc274f1df$export$7ee701e290d9865(value);
}
const $fd57502cc274f1df$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $fd57502cc274f1df$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("k1MiS", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $7a9a102a7215e3d4$export$f40ed0efa65d4e8);

var $bOMPB = parcelRequire("bOMPB");
function $7a9a102a7215e3d4$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Depricated should be removed in the next major release
    linkTitle === 'block-link') return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $bOMPB.getIssue)(context, originalLinkText);
    if (issue) return (0, $bOMPB.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("bOMPB", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $ce5ca7baa00e39d0$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $ce5ca7baa00e39d0$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $ce5ca7baa00e39d0$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $ce5ca7baa00e39d0$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $ce5ca7baa00e39d0$export$cd8701ad7512efee);

var $gxAE9 = parcelRequire("gxAE9");
const $ce5ca7baa00e39d0$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $ce5ca7baa00e39d0$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const issue = $ce5ca7baa00e39d0$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $gxAE9.isNotBlank)(charBefore) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charBefore) || (0, $gxAE9.isNotBlank)(charAfter) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charAfter)) return $ce5ca7baa00e39d0$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $ce5ca7baa00e39d0$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $ce5ca7baa00e39d0$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $ce5ca7baa00e39d0$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $ce5ca7baa00e39d0$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp = (issue)=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ce5ca7baa00e39d0$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $ce5ca7baa00e39d0$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("gGleW", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $57e1d7866034b37b$export$3a250a08d37b0eae);

var $gxAE9 = parcelRequire("gxAE9");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $57e1d7866034b37b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $57e1d7866034b37b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $57e1d7866034b37b$var$divideOn(buffer, '|');
    const body = new (0, $gxAE9.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $57e1d7866034b37b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $57e1d7866034b37b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $57e1d7866034b37b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $57e1d7866034b37b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $57e1d7866034b37b$var$extractNumber(buf) {
    const digits = new (0, $gxAE9.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $gxAE9.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $57e1d7866034b37b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $gxAE9.StringBuffer)(linkText);
    const linkBody = $57e1d7866034b37b$var$extractLinkBody(buf);
    const linkTitle = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $57e1d7866034b37b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $57e1d7866034b37b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $gxAE9.StringBuffer)(notLinkBody);
        shortcutName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $gxAE9.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $gxAE9.StringBuffer)(notLinkBody);
    if ((0, $gxAE9.isBlank)(shortcutName)) {
        spaceKey = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $57e1d7866034b37b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '^'));
        anchor = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("30Un5", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $0c863b8155c1a336$export$67dc04e652a298ca);

var $4Dfwq = parcelRequire("4Dfwq");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0c863b8155c1a336$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $0c863b8155c1a336$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0c863b8155c1a336$var$BLOCKQUOTE_REGEXP);
    if (!match) return $0c863b8155c1a336$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $4Dfwq.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $0c863b8155c1a336$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Dfwq", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $0723b4b23edf777c$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $0723b4b23edf777c$export$c2a5e4612254bfa);

var $3JW2n = parcelRequire("3JW2n");

var $gxAE9 = parcelRequire("gxAE9");

var $20lXC = parcelRequire("20lXC");

var $29zBb = parcelRequire("29zBb");
const $0723b4b23edf777c$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $0723b4b23edf777c$export$c2a5e4612254bfa,
        context: context
    });
};
const $0723b4b23edf777c$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $0723b4b23edf777c$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $0723b4b23edf777c$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $0723b4b23edf777c$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $0723b4b23edf777c$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($0723b4b23edf777c$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $0723b4b23edf777c$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("3JW2n", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $108725731ca4984f$export$b6a12943ac1bb1ba);
function $108725731ca4984f$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $108725731ca4984f$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $108725731ca4984f$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("coK8g", function(module, exports) {

$parcel$export(module.exports, "citation", () => $624cf9f0f9a0e4f4$export$258632c953c109e9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");

const $624cf9f0f9a0e4f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $0c0aa3654d545c29$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $0c0aa3654d545c29$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("5RdHN", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $b9ac580681c978af$export$bccbf0c716f226f4);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $b9ac580681c978af$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("55t1E", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $74a06c4540bbf40b$export$65e3ca7c95899a2d);

var $1rQjR = parcelRequire("1rQjR");
const $74a06c4540bbf40b$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $74a06c4540bbf40b$var$fallback = {
    ...$74a06c4540bbf40b$var$token,
    text: '--'
};
const $74a06c4540bbf40b$export$65e3ca7c95899a2d = (0, $1rQjR.createDashTokenParser)($74a06c4540bbf40b$var$token, $74a06c4540bbf40b$var$fallback);

});
parcelRegister("1rQjR", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $75f433a8b52a8173$export$d43b58865d429e3c);
const $75f433a8b52a8173$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$75f433a8b52a8173$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$75f433a8b52a8173$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $75f433a8b52a8173$var$isSpace = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\s/.test(char);
};

});


parcelRegister("jor5q", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $487b5ddb28312972$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $487b5ddb28312972$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $487b5ddb28312972$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $487b5ddb28312972$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $487b5ddb28312972$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($487b5ddb28312972$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $487b5ddb28312972$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $487b5ddb28312972$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("hZ14o", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $5100d4ec4f1b4884$export$bef81ba411953b51);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $5100d4ec4f1b4884$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("6xaH8", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $bc70e1090faff3e6$export$ac55bb44695749c1);

var $eWAZI = parcelRequire("eWAZI");
const $bc70e1090faff3e6$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jMpI6", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ed15d3e22c065f91$export$46e4a324ac90507f);

var $29zBb = parcelRequire("29zBb");

var $kSL4h = parcelRequire("kSL4h");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ed15d3e22c065f91$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $ed15d3e22c065f91$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($ed15d3e22c065f91$var$HEADING_REGEXP);
    if (!match) return $ed15d3e22c065f91$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $29zBb.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $ed15d3e22c065f91$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("iDsRr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $33f79eddf582429a$export$744ba74fb86b8ca7);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $33f79eddf582429a$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ayQVO", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $4813b87fbe6448cc$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $4813b87fbe6448cc$export$8837f4fc672e936d);

var $hnQWb = parcelRequire("hnQWb");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $gxAE9 = parcelRequire("gxAE9");
const $4813b87fbe6448cc$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$4813b87fbe6448cc$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $4813b87fbe6448cc$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $4813b87fbe6448cc$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE
    ];
    let index = position;
    let state = $4813b87fbe6448cc$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $4813b87fbe6448cc$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($4813b87fbe6448cc$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $4813b87fbe6448cc$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $29zBb.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $hnQWb.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $4813b87fbe6448cc$var$processState.END;
                        continue;
                    }
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $4813b87fbe6448cc$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $4813b87fbe6448cc$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $4813b87fbe6448cc$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.END:
                if (!builder) // Something is really wrong here
                return $4813b87fbe6448cc$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $29zBb.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $4813b87fbe6448cc$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $4813b87fbe6448cc$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("hnQWb", function(module, exports) {

$parcel$export(module.exports, "getType", () => $3303253e6091964c$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $3303253e6091964c$export$876cfa3161bef296);
const $3303253e6091964c$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $3303253e6091964c$export$e2b5c5db9e2009fd(bullets) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $3303253e6091964c$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($3303253e6091964c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $3303253e6091964c$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $3303253e6091964c$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kPrK8", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).ADF_MACRO,
        (0, $kSL4h.TokenType).ANCHOR_MACRO,
        (0, $kSL4h.TokenType).CODE_MACRO,
        (0, $kSL4h.TokenType).QUOTE_MACRO,
        (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        (0, $kSL4h.TokenType).PANEL_MACRO,
        (0, $kSL4h.TokenType).COLOR_MACRO,
        (0, $kSL4h.TokenType).LOREM_MACRO,
        (0, $kSL4h.TokenType).QUOTE,
        (0, $kSL4h.TokenType).STRING,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).LINK_FORMAT,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).MEDIA,
        (0, $kSL4h.TokenType).HEADING,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        (0, $kSL4h.TokenType).HARD_BREAK,
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).STRONG,
        (0, $kSL4h.TokenType).MONOSPACE,
        (0, $kSL4h.TokenType).SUPERSCRIPT,
        (0, $kSL4h.TokenType).SUBSCRIPT,
        (0, $kSL4h.TokenType).EMPHASIS,
        (0, $kSL4h.TokenType).CITATION,
        (0, $kSL4h.TokenType).DELETED,
        (0, $kSL4h.TokenType).INSERTED,
        (0, $kSL4h.TokenType).EMOJI,
        (0, $kSL4h.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4ZFIG", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $819171e80205fd1c$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $819171e80205fd1c$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $819171e80205fd1c$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($819171e80205fd1c$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("91y57", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $cf2c039554fba6e4$export$f9adada2013e846e);

var $i8dZb = parcelRequire("i8dZb");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cf2c039554fba6e4$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $cf2c039554fba6e4$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($cf2c039554fba6e4$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $i8dZb.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("i8dZb", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $d0cc271b2b6d9a56$export$4267f2e5716b018a);
const $d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $d0cc271b2b6d9a56$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $d0cc271b2b6d9a56$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("1Mtv8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $da489456937eda28$export$59ae2c325a998f89);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $da489456937eda28$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("77w3e", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $af8d85604a001a66$export$bc5390e4688d2822);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $af8d85604a001a66$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lf0Nr", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $6f4f331694cf9bb6$export$b4aab94a5fcfcead);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $6f4f331694cf9bb6$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4s89q", function(module, exports) {

$parcel$export(module.exports, "table", () => $8c7a9474c5649f43$export$9852986a3ec5f6a0);

var $48GZN = parcelRequire("48GZN");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $7tIdE = parcelRequire("7tIdE");

var $4Foyv = parcelRequire("4Foyv");

var $jor5q = parcelRequire("jor5q");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $gxAE9 = parcelRequire("gxAE9");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8c7a9474c5649f43$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $8c7a9474c5649f43$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $8c7a9474c5649f43$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $48GZN.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (cellMatch) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                    else currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP)) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                        else {
                            currentState = $8c7a9474c5649f43$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $8c7a9474c5649f43$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $8c7a9474c5649f43$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $8c7a9474c5649f43$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $8c7a9474c5649f43$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $8c7a9474c5649f43$var$processState.MEDIA:
                {
                    const token = (0, $4Foyv.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.EMOJI:
                {
                    const token = (0, $jor5q.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8c7a9474c5649f43$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $8c7a9474c5649f43$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $20lXC.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $8c7a9474c5649f43$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8c7a9474c5649f43$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $8c7a9474c5649f43$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $8c7a9474c5649f43$var$traverseContent(node, mark, schema);
}

});
parcelRegister("48GZN", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $75a71ab9390c3135$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $75a71ab9390c3135$var$getType(style) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $75a71ab9390c3135$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $75a71ab9390c3135$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("ir9MO", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $0a377f498827084a$export$edbcd749367de060);

var $1rQjR = parcelRequire("1rQjR");
const $0a377f498827084a$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $0a377f498827084a$var$fallback = {
    ...$0a377f498827084a$var$token,
    text: '---'
};
const $0a377f498827084a$export$edbcd749367de060 = (0, $1rQjR.createDashTokenParser)($0a377f498827084a$var$token, $0a377f498827084a$var$fallback);

});

parcelRegister("7E14k", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $fa58ef1a18570456$export$5d7bf7e31a674541);

var $3JW2n = parcelRequire("3JW2n");

var $29zBb = parcelRequire("29zBb");

var $4ZUg7 = parcelRequire("4ZUg7");

var $20lXC = parcelRequire("20lXC");

var $fQoRM = parcelRequire("fQoRM");

var $1agyv = parcelRequire("1agyv");
const $fa58ef1a18570456$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $fa58ef1a18570456$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $fa58ef1a18570456$var$rawContentProcessor
    });
};
const $fa58ef1a18570456$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $fQoRM.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $1agyv.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($fa58ef1a18570456$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $fa58ef1a18570456$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $fa58ef1a18570456$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("fQoRM", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $afb9d2bd4cb626dc$export$fa00fa3d6c22a747);

var $4PfBJ = parcelRequire("4PfBJ");
const $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $afb9d2bd4cb626dc$export$fa00fa3d6c22a747(attrs) {
    const rgb = $afb9d2bd4cb626dc$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $afb9d2bd4cb626dc$var$distanceOfRgb($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $afb9d2bd4cb626dc$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $afb9d2bd4cb626dc$var$generateRgb(color) {
    switch(true){
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort.test(color) || $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $afb9d2bd4cb626dc$var$parseHex(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $afb9d2bd4cb626dc$var$parseRgb(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $afb9d2bd4cb626dc$var$parsePrgb(color);
        default:
            return $afb9d2bd4cb626dc$var$parseColorName(color);
    }
}
function $afb9d2bd4cb626dc$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseRgb(rgb) {
    const result = rgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $afb9d2bd4cb626dc$var$parsePrgb(prgb) {
    const result = prgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseColorName(color) {
    return (0, $4PfBJ.default)[color];
}

});
parcelRegister("4PfBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6de0fe9d8acfe8$export$2e2bcd8739ae039);
const $fe6de0fe9d8acfe8$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $fe6de0fe9d8acfe8$export$2e2bcd8739ae039 = $fe6de0fe9d8acfe8$var$mapping;

});


parcelRegister("1agyv", function(module, exports) {

$parcel$export(module.exports, "title", () => $9eccd901f1df184b$export$fb184b623420d9be);
function $9eccd901f1df184b$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("9MeiU", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $39fb2727ee273b16$export$8fb4b58db8f664fb);

var $3JW2n = parcelRequire("3JW2n");
const $39fb2727ee273b16$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $39fb2727ee273b16$var$rawContentProcessor
    });
};
const $39fb2727ee273b16$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("f50H1", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $4b331e3d410cf176$export$e660dadc21580fa2);

var $3JW2n = parcelRequire("3JW2n");
const $4b331e3d410cf176$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $4b331e3d410cf176$var$rawContentProcessor
    });
};
const $4b331e3d410cf176$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("bSil4", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $38ee74463de0ec95$export$db6c131ac26c7700);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $38ee74463de0ec95$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $38ee74463de0ec95$var$rawContentProcessor
    });
};
const $38ee74463de0ec95$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $38ee74463de0ec95$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $38ee74463de0ec95$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cjZPi", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $2374771f8fbda9ef$export$b557be495948d995);

var $kSL4h = parcelRequire("kSL4h");

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $29zBb = parcelRequire("29zBb");

var $7p5zM = parcelRequire("7p5zM");

var $gxAE9 = parcelRequire("gxAE9");
const $2374771f8fbda9ef$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $2374771f8fbda9ef$var$rawContentProcessor
    });
};
const $2374771f8fbda9ef$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE
    ];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const content = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $7p5zM.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("7p5zM", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $dace0eb9654d7c1b$export$c0cfc6f23e0b7578);

var $51H8P = parcelRequire("51H8P");
function $dace0eb9654d7c1b$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $51H8P.normalizeHexColor)(keys[0]);
}

});


parcelRegister("8tGpW", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7fe042bf55811a5b$export$9199752eb9b2d5b4);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $7fe042bf55811a5b$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7fe042bf55811a5b$var$rawContentProcessor
    });
};
const $7fe042bf55811a5b$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("lyI5i", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $90e9f72be02de2ac$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $90e9f72be02de2ac$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $90e9f72be02de2ac$var$fallback(input, position);
    }
    const match = input.substring(position).match($90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $90e9f72be02de2ac$var$fallback(input, position);
};
function $90e9f72be02de2ac$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("4yZSi", function(module, exports) {

$parcel$export(module.exports, "code", () => $e115b67b9a7c1782$export$6565f9f03506010b);
const $e115b67b9a7c1782$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("aDTWq", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $ef3e88b1064ccc35$export$32f78bffcd82ff28);
const $ef3e88b1064ccc35$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("gdFeW", function(module, exports) {

$parcel$export(module.exports, "em", () => $e431017de2633455$export$c63c6f932822f543);

var $3ovek = parcelRequire("3ovek");
const $e431017de2633455$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $3ovek.baseMarkPattern)(text.substring(2), '??');
    return (0, $3ovek.baseMarkPattern)(text, '_');
};

});
parcelRegister("3ovek", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $7f6f940a63ef31a6$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $7f6f940a63ef31a6$export$3d8aed7830783c75 = (text, token)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("jo5YT", function(module, exports) {

$parcel$export(module.exports, "link", () => $5614ddd827a3bd70$export$9c30223ca0a664fb);
const $5614ddd827a3bd70$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("9fwgI", function(module, exports) {

$parcel$export(module.exports, "strike", () => $486b01102f007d8c$export$4899a95d70ec5056);

var $3ovek = parcelRequire("3ovek");
const $486b01102f007d8c$export$4899a95d70ec5056 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '-');
};

});

parcelRegister("eKxrE", function(module, exports) {

$parcel$export(module.exports, "strong", () => $5f94e33f4e7efc4b$export$59ae2c325a998f89);

var $3ovek = parcelRequire("3ovek");
const $5f94e33f4e7efc4b$export$59ae2c325a998f89 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '*');
};

});

parcelRegister("1x55I", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $de8ae0bb6a3c8a22$export$b3401ee80eb31041);

var $3ovek = parcelRequire("3ovek");
const $de8ae0bb6a3c8a22$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $3ovek.baseMarkPattern)(text, '~');
    else return (0, $3ovek.baseMarkPattern)(text, '^');
};

});

parcelRegister("8tKGr", function(module, exports) {

$parcel$export(module.exports, "underline", () => $bb8b641056119651$export$425327af25286e5e);

var $3ovek = parcelRequire("3ovek");
const $bb8b641056119651$export$425327af25286e5e = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '+');
};

});


parcelRegister("5IuwX", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $c6769d560338119d$export$cbf8224b64e0d942);

var $1Nefo = parcelRequire("1Nefo");

var $bOMPB = parcelRequire("bOMPB");
const $c6769d560338119d$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    const match = node.attrs.url.match((0, $bOMPB.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("1HDja", function(module, exports) {

$parcel$export(module.exports, "status", () => $d0c82c4f36685012$export$471f7ae5c4103ae1);

var $aDTWq = parcelRequire("aDTWq");

const $d0c82c4f36685012$var$color = {
    grey: (0, $829f609a65d26a98$export$eaa8c8a70ac22806),
    purple: (0, $829f609a65d26a98$export$b48405b95304b5a1),
    blue: (0, $829f609a65d26a98$export$9dc1ef0f3f48059b),
    red: (0, $829f609a65d26a98$export$4a7404f376229999),
    yellow: (0, $829f609a65d26a98$export$59619663aa6500fb),
    green: (0, $829f609a65d26a98$export$940e1f69e873f202)
};
const $d0c82c4f36685012$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($d0c82c4f36685012$var$color[node.attrs.color]) newAttrs.color = $d0c82c4f36685012$var$color[node.attrs.color];
    else newAttrs.color = $d0c82c4f36685012$var$color['grey'];
    return (0, $aDTWq.textColor)(text, newAttrs);
};

});

parcelRegister("c08Yp", function(module, exports) {

$parcel$export(module.exports, "date", () => $61a6161cda09885d$export$324d90190a8b822a);
const $61a6161cda09885d$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("73kPn", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $ef6a5d3a665df695$export$7bb0d5c671655cc4);

var $bK2QZ = parcelRequire("bK2QZ");
const $ef6a5d3a665df695$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $ef6a5d3a665df695$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            parent: node
        });
    });
    if ($ef6a5d3a665df695$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("eTlm6", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $b3a3fb1c58065f07$export$2855e964765eac9);

var $bsbI5 = parcelRequire("bsbI5");

var $48ot6 = parcelRequire("48ot6");

var $1Nefo = parcelRequire("1Nefo");
const $b3a3fb1c58065f07$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $48ot6.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $bsbI5.caption)(n, opts));
                break;
            default:
                result.push((0, $1Nefo.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("bsbI5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d);

var $bK2QZ = parcelRequire("bK2QZ");
const $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("48ot6", function(module, exports) {

$parcel$export(module.exports, "media", () => $df984bb2074676e8$export$987d49ffe1b0900f);
const $df984bb2074676e8$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("hgytR", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $1fb2a139f9f264bf$export$375b6afcc5f4d291);

var $4kMeo = parcelRequire("4kMeo");
const $1fb2a139f9f264bf$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($1fb2a139f9f264bf$var$nestedNode(item, depth + 1));
        else result.push((0, $4kMeo.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $1fb2a139f9f264bf$export$375b6afcc5f4d291 = (node)=>{
    return $1fb2a139f9f264bf$var$nestedNode(node);
};

});
parcelRegister("4kMeo", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $b96ea7b246afcc42$export$6d8b0ef52e2e6390);

var $bK2QZ = parcelRequire("bK2QZ");
const $b96ea7b246afcc42$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $bK2QZ.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("b6sEJ", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $9054c6d3a6a22504$export$62d45a65fb43d95e);

var $h0oA4 = parcelRequire("h0oA4");
const $9054c6d3a6a22504$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $h0oA4.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("h0oA4", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $6209b59f60b56dcd$export$6959e16eeff859b4);

var $bK2QZ = parcelRequire("bK2QZ");
const $6209b59f60b56dcd$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("1B6CN", function(module, exports) {

$parcel$export(module.exports, "doc", () => $5ce407caf0707589$export$2a111da947c407d2);

var $lxtC7 = parcelRequire("lxtC7");
const $5ce407caf0707589$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("8UMD2", function(module, exports) {

$parcel$export(module.exports, "expand", () => $dcda58106fc3b9ff$export$9f77e0932fb78f72);

var $lxtC7 = parcelRequire("lxtC7");
const $dcda58106fc3b9ff$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("fIzNZ", function(module, exports) {

$parcel$export(module.exports, "heading", () => $2a94cb79881b69b7$export$46e4a324ac90507f);

var $bK2QZ = parcelRequire("bK2QZ");
const $2a94cb79881b69b7$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("h9tzi", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $c2a8fd1ebb40e986$export$a5dc81035676e7a);

var $bxtEu = parcelRequire("bxtEu");
const $c2a8fd1ebb40e986$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("abXFq", function(module, exports) {

$parcel$export(module.exports, "panel", () => $d8008c2d580ced87$export$21f42ab9b6679f44);

var $lxtC7 = parcelRequire("lxtC7");
const $d8008c2d580ced87$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $d8008c2d580ced87$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{panel:bgColor=${$d8008c2d580ced87$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("czgKo", function(module, exports) {

$parcel$export(module.exports, "rule", () => $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7);
const $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("acqkf", function(module, exports) {

$parcel$export(module.exports, "table", () => $6deed74ceb5bf80f$export$9852986a3ec5f6a0);

var $lxtC7 = parcelRequire("lxtC7");

var $1Nefo = parcelRequire("1Nefo");
const $6deed74ceb5bf80f$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($6deed74ceb5bf80f$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
};
const $6deed74ceb5bf80f$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$6deed74ceb5bf80f$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $6deed74ceb5bf80f$var$tableCell = (node, { context: context } = {})=>{
    if ($6deed74ceb5bf80f$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $6deed74ceb5bf80f$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("69N10", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0c06383b3aca4143$export$c4c2f833baaebdb8);

var $1Nefo = parcelRequire("1Nefo");
const $0c06383b3aca4143$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("12A17", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $c9c7f4b278041854$export$be4283d9a1cb1ff6);

var $1Nefo = parcelRequire("1Nefo");
const $c9c7f4b278041854$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("djcbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f62fc9e2776603$export$2e2bcd8739ae039);

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");
class $74f62fc9e2776603$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $29zBb.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $20lXC.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



parcelRegister("8Xls4", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $2ddd56f412c59d37$export$eedb1bf75e1efb26);

var $5ewBi = parcelRequire("5ewBi");
const $2ddd56f412c59d37$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels',
    TimeTracking: '#TimeTracking',
    LogWork: '#LogWork'
};
const $2ddd56f412c59d37$export$eedb1bf75e1efb26 = {
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.IssueTypes]: (0, $5ewBi.default).fieldHelpIssueTypes,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $5ewBi.default).fieldHelpPriorityLevels,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $5ewBi.default).fieldHelpResolutionDefinitions,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $5ewBi.default).fieldHelpSecurityLevels,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.TimeTracking]: (0, $5ewBi.default).fieldHelpTimeTracking,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.LogWork]: (0, $5ewBi.default).fieldHelpLogWork
};

});
parcelRegister("5ewBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ce17f573bf38ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02ce17f573bf38ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-form-field-base.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    stringInvalidErrorMessage: {
        "id": "issue-form-field-base.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    urlInvalidErrorMessage: {
        "id": "issue-form-field-base.common.field-message.url-invalid-error-message",
        "defaultMessage": "{fieldName} is not a valid URL"
    },
    fieldHelpTextLabel: {
        "id": "issue-form-field-base.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-form-field-base.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-form-field-base.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpLogWork: {
        "id": "issue-form-field-base.common.field-message.field-help-log-work",
        "defaultMessage": "Learn about logging work"
    },
    fieldHelpTimeTracking: {
        "id": "issue-form-field-base.common.field-message.field-help-time-tracking",
        "defaultMessage": "Learn about time tracking"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-form-field-base.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-form-field-base.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldContentWithHelpText: {
        "id": "issue-form-field-base.common.field-message.field-content-with-help-text",
        "defaultMessage": "{fieldDescription} {fieldHelpText}"
    }
});

});




parcelRegister("gifeQ", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $89f92c26c7f930da$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $89f92c26c7f930da$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $89f92c26c7f930da$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $89f92c26c7f930da$export$f1a0ef98758e7a8a);
$parcel$export(module.exports, "isBuiltInJiraFieldRender", () => $89f92c26c7f930da$export$2909711775a2c267);

var $k2DRb = parcelRequire("k2DRb");

var $3eEiw = parcelRequire("3eEiw");
const $89f92c26c7f930da$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $k2DRb.FORGE_FIELD_TYPE_PREFIX)));
const $89f92c26c7f930da$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $89f92c26c7f930da$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $k2DRb.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $89f92c26c7f930da$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$89f92c26c7f930da$export$78cf1b56a8dede1f(field.fieldType));
const $89f92c26c7f930da$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};
function $89f92c26c7f930da$export$2909711775a2c267(extension, entryPoint, experience) {
    const edit = extension.properties?.edit;
    const view = 'view' in extension.properties ? extension.properties.view : undefined;
    const entry = entryPoint === 'edit' ? edit : view;
    let supportedExperience = false;
    if (entryPoint === 'edit') supportedExperience = edit && 'experience' in edit && edit.experience && (0, $3eEiw.isCustomFieldEditRenderContext)(experience) ? edit.experience.includes(experience) : false;
    else supportedExperience = view && 'experience' in view && view.experience && (0, $3eEiw.isCustomFieldViewRenderContext)(experience) ? view.experience.includes(experience) : false;
    const hasRenderFunction = entry && 'function' in entry;
    const hasSupportedResource = entry && 'resource' in entry && supportedExperience;
    const render = entry && 'render' in entry ? entry.render : null;
    return entryPoint === 'view' ? !hasRenderFunction && !(hasSupportedResource && render === 'native') : !hasRenderFunction && !hasSupportedResource;
}

});
parcelRegister("3eEiw", function(module, exports) {

$parcel$export(module.exports, "isCustomFieldEditRenderContext", () => $99ea418430558080$export$b562ffa4bbc21d4f);
$parcel$export(module.exports, "isCustomFieldViewRenderContext", () => $99ea418430558080$export$36376c9ff94a7fbd);
function $99ea418430558080$export$b562ffa4bbc21d4f(context) {
    return context === 'issue-view' || context === 'issue-create' || context === 'issue-transition';
}
function $99ea418430558080$export$36376c9ff94a7fbd(context) {
    return context === 'issue-view';
}

});


parcelRegister("cR6FI", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $9d6f926895360b65$export$5304145354a3bee9);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $2RhPB = parcelRequire("2RhPB");

var $4JpPl = parcelRequire("4JpPl");

var $7Aezm = parcelRequire("7Aezm");

var $9wJ66 = parcelRequire("9wJ66");

var $frltc = parcelRequire("frltc");

var $koVbs = parcelRequire("koVbs");

var $2G1Qa = parcelRequire("2G1Qa");

var $jhvTc = parcelRequire("jhvTc");
const $9d6f926895360b65$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
        onChange((0, $2G1Qa.transformValue)(newValue, extension));
        (0, $4JpPl.fireTrackEditedEvent)(analyticsAttributes.renderContext, analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit 1 version of 1.2.0 when inline edit is not supported
        // should be removed with removal of UI Kit 1
        const translatedError = {
            message: intl.formatMessage((0, $jhvTc.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $jhvTc.default).modalModeErrorDescription)
        };
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience with non-supported UI Kit 1', {
            extennsionId: extension.id
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frltc.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wJ66.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $9d6f926895360b65$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: (0, $2RhPB.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d6f926895360b65$export$ba588b5cce278e96, props));

});
parcelRegister("4JpPl", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $d80ee50440a72c0c$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $d80ee50440a72c0c$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $d80ee50440a72c0c$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $d80ee50440a72c0c$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $d80ee50440a72c0c$export$add44f896fb31ba3);

var $k2DRb = parcelRequire("k2DRb");

var $4R6GH = parcelRequire("4R6GH");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");
const $d80ee50440a72c0c$var$moduleEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $d80ee50440a72c0c$var$triggerEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $d80ee50440a72c0c$export$1798d320c6527c08 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).EDITED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$fc09afa3d0d5294c = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CANCELED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$762dee9e981de3e1 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
    (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $d80ee50440a72c0c$export$add44f896fb31ba3 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("9wJ66", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldInlineEdit", () => $05c72791f20b76f4$export$ca6c6772b322056d);

var $5uXOq = parcelRequire("5uXOq");

var $2G8Ll = parcelRequire("2G8Ll");

var $3oVvh = parcelRequire("3oVvh");
const $05c72791f20b76f4$var$isIssueViewProps = (props)=>props.extensionData.renderContext === 'issue-view';
const $05c72791f20b76f4$var$isIssueCreateOrTransitionProps = (props)=>props.extensionData.renderContext === 'issue-create' || props.extensionData.renderContext === 'issue-transition';
const $05c72791f20b76f4$export$980ea0297ad3a4c8 = (props)=>{
    if ($05c72791f20b76f4$var$isIssueViewProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oVvh.LazyCustomFieldInlineEditIssueView), props);
    if ($05c72791f20b76f4$var$isIssueCreateOrTransitionProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G8Ll.LazyCustomFieldInlineEditForm), props);
    return null;
};
const $05c72791f20b76f4$export$ca6c6772b322056d = $05c72791f20b76f4$export$980ea0297ad3a4c8;

});
parcelRegister("2G8Ll", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditForm", () => $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca);

var $5uXOq = parcelRequire("5uXOq");


var $6ikhl = parcelRequire("6ikhl");

var $4JpPl = parcelRequire("4JpPl");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

var $bLCKr = parcelRequire("bLCKr");

var $69dub = parcelRequire("69dub");

var $3OHUI = parcelRequire("3OHUI");
const $3e8d63ebec6f951f$var$skeletonConfig = [
    {
        width: 100
    }
];
const $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
    const requestsCount = (0, $5uXOq.useRef)(0);
    const [, { setFieldState: setFieldState }] = (0, $6ikhl.useInlineField)(restProps.extensionData.fieldId);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes } = restProps;
    const loadingComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLCKr.Skeleton), {
            skeletonConfig: $3e8d63ebec6f951f$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldId: extensionData.fieldId,
            fieldType: extensionData.fieldType,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext,
            ...(0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: extensionData.experience
            }
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension,
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const createRetryFunction = (0, $4R6GH.fg)('forge_missing_analytics_attributes_for_fcf') ? (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                });
                (0, $4JpPl.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    ...analyticsAttributes,
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState,
        analyticsAttributes
    ]) : (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                });
                (0, $4JpPl.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState
    ]);
    const submit = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ data: fieldValue })=>{
        const retryFunction = createRetryFunction(fieldValue);
        setFieldState({
            fieldId: extensionData.fieldId,
            retryFunction: retryFunction
        });
        await retryFunction();
        return undefined;
    }, [
        createRetryFunction,
        extensionData.fieldId,
        setFieldState
    ]);
    const bridge = (0, $5uXOq.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-inline-edit",
        fallback: loadingComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
};

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("bLCKr", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $e1da1ba1fdde315e$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 = [];
const $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1da1ba1fdde315e$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $e1da1ba1fdde315e$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $e1da1ba1fdde315e$var$layoutStyles
    }, children);
};
const $e1da1ba1fdde315e$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1da1ba1fdde315e$var$ForgeSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $lD23V.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $e1da1ba1fdde315e$var$layoutStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("69dub", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1d6031a605ad4b71$export$238f56c0891e9254);

var $5uXOq = parcelRequire("5uXOq");
const $1d6031a605ad4b71$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1d6031a605ad4b71$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d6031a605ad4b71$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("3OHUI", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditRenderer", () => $e47c1fd0d3acd296$export$eef5130ba28e0f4e);
$parcel$export(module.exports, "LazyCustomFieldInlineEditExtension", () => $e47c1fd0d3acd296$export$299b8ce8659dec8c);

var $1rTGO = parcelRequire("1rTGO");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $kxZPA = parcelRequire("kxZPA");

const $e47c1fd0d3acd296$var$getModule = ()=>(0, $8kVg1.measureInitialPageLoadAsyncResourcesTiming)((0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("ikTXu")));

const $e47c1fd0d3acd296$var$getForgeExtensionModule = ()=>(0, $8kVg1.measureInitialPageLoadAsyncResourcesTiming)((0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("jsnj4")));
const $e47c1fd0d3acd296$export$eef5130ba28e0f4e = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$e47c1fd0d3acd296$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));
const $e47c1fd0d3acd296$export$299b8ce8659dec8c = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$e47c1fd0d3acd296$var$getForgeExtensionModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));

});
parcelRegister("ikTXu", function(module, exports) {

let $d5958077960e8d0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d5958077960e8d0d$var$load("kWrFZ"),
    $d5958077960e8d0d$var$load("2AjeU")
]).then(()=>parcelRequire('lDRdH'));

});

parcelRegister("jsnj4", function(module, exports) {

let $e2a2b6115490d69f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e2a2b6115490d69f$var$load("cM9em"),
    $e2a2b6115490d69f$var$load("fr9NE"),
    $e2a2b6115490d69f$var$load("hPzOn"),
    $e2a2b6115490d69f$var$load("h2MrD"),
    $e2a2b6115490d69f$var$load("bYT2S"),
    $e2a2b6115490d69f$var$load("kWrFZ"),
    $e2a2b6115490d69f$var$load("2QVAD")
]).then(()=>parcelRequire('456zR'));

});



parcelRegister("3oVvh", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditIssueView", () => $46e0705763f3c3d0$export$9929b4973c13a82f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

var $bLCKr = parcelRequire("bLCKr");

var $69dub = parcelRequire("69dub");

var $7IjIj = parcelRequire("7IjIj");

var $3OHUI = parcelRequire("3OHUI");
const $46e0705763f3c3d0$var$skeletonConfig = [
    {
        width: 100
    }
];
const $46e0705763f3c3d0$export$9929b4973c13a82f = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const loadingComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLCKr.Skeleton), {
            skeletonConfig: $46e0705763f3c3d0$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext,
            ...(0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: extensionData.experience
            }
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const submit = (0, $5uXOq.useCallback)(({ data: fieldValue })=>(0, $7IjIj.onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $5uXOq.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onCancel: onCancel,
        onLoad: onRender,
        onRender: onRender,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onRender: onRender,
        onCancel: onCancel,
        bridge: bridge
    })));
};

});
parcelRegister("7IjIj", function(module, exports) {

$parcel$export(module.exports, "onCustomFieldSubmit", () => $7482280c9b50d561$export$fc8c2ed652969e74);

var $jJZqs = parcelRequire("jJZqs");

var $dGSK4 = parcelRequire("dGSK4");
const $7482280c9b50d561$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $dGSK4.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $jJZqs.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

});
parcelRegister("dGSK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60f776846cd27f9$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $eRDnE = parcelRequire("eRDnE");

var $ctOgQ = parcelRequire("ctOgQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b60f776846cd27f9$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $jJZqs.isValidationError)(error) ? (0, $ctOgQ.default)(error.errors) : (0, $eRDnE.default)();

});
parcelRegister("eRDnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e1a5ac6c28ff9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $41e1a5ac6c28ff9a$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e1a5ac6c28ff9a$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $41e1a5ac6c28ff9a$var$messages.title,
        isAutoDismiss: false,
        messageId: 'forge-ui.common.ui.flags.custom-field.edit-failed.generic-error',
        messageType: 'transactional'
    });

});

parcelRegister("ctOgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59eef974107568f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $59eef974107568f4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$59eef974107568f4$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $59eef974107568f4$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false,
        messageId: 'forge-ui.common.ui.flags.custom-field.edit-failed.validation-error',
        messageType: 'transactional'
    });

});





parcelRegister("frltc", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $a7cc7ee0610715db$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $lUtFZ = parcelRequire("lUtFZ");
const $a7cc7ee0610715db$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $a7cc7ee0610715db$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $5uXOq.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $lUtFZ.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$LoaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lUtFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0d2ab7d73abc3f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0c0d2ab7d73abc3f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("2G1Qa", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $aebdb8b330132ca4$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $aebdb8b330132ca4$export$b82f09291a00d8c1);

var $2QTbq = parcelRequire("2QTbq");

var $gifeQ = parcelRequire("gifeQ");

var $4ib94 = parcelRequire("4ib94");
const $aebdb8b330132ca4$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $2QTbq.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $aebdb8b330132ca4$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $aebdb8b330132ca4$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list') // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $2QTbq.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $4ib94.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $aebdb8b330132ca4$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $aebdb8b330132ca4$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $aebdb8b330132ca4$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $aebdb8b330132ca4$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $aebdb8b330132ca4$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($aebdb8b330132ca4$export$3e406786572c35b0);
    return $aebdb8b330132ca4$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("2QTbq", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $392cb309afc1042a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mapLabelOptionsToData", () => $392cb309afc1042a$export$1bf703d99c7bcef6);
$parcel$export(module.exports, "mapLabelsResponseToLabelOptions", () => $392cb309afc1042a$export$37f55c1f665c1221);
const $392cb309afc1042a$export$cd8e373d5b1325b1 = (data)=>{
    if (!data) return [];
    return data.map((value)=>({
            value: value,
            label: value
        }));
};
const $392cb309afc1042a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
const $392cb309afc1042a$export$37f55c1f665c1221 = (response)=>{
    const { suggestions: suggestions } = response;
    if (!suggestions) return [];
    return suggestions.map(({ label: label })=>({
            label: label,
            value: label
        }));
};

});

parcelRegister("4ib94", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $308c96a2eb70bd22$export$2de59005e10fd82);

var $agVdz = parcelRequire("agVdz");
const $308c96a2eb70bd22$export$2de59005e10fd82 = (value)=>{
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(value) ? JSON.parse(value) : value;
    } catch  {
        return value;
    }
};

});


parcelRegister("jhvTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $44857d6a8561de15$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44857d6a8561de15$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalModeErrorTitle: {
        "id": "forge-field-base.form.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "forge-field-base.form.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("lXxfQ", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $0cd01fba7525b674$export$1df6b326181f4cdf);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $1hWNm = parcelRequire("1hWNm");

var $hH7yT = parcelRequire("hH7yT");
const $0cd01fba7525b674$var$ErrorView = ({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineEnd: "space.050"
    }, formatMessage((0, $hH7yT.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hWNm.ForgeFieldDispatchButton), {
        fieldId: fieldId
    }));
};
const $0cd01fba7525b674$var$HelperView = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), formatMessage((0, $hH7yT.default).forgeFieldPendingTextLabel));
};
const $0cd01fba7525b674$var$SuccessView = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ValidMessage), null, formatMessage((0, $hH7yT.default).forgeFieldSuccessTextLabel));
};
const $0cd01fba7525b674$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
    const { fieldId: fieldId, renderFieldMessage: renderFieldMessage, error: error } = props;
    const [fieldState] = (0, $6ikhl.useInlineField)(fieldId);
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== null) return renderFieldMessage(error);
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage != null) switch(fieldState?.status){
            case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$ErrorView, {
                    fieldId: fieldId
                });
            case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$SuccessView, null);
            case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
            case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$HelperView, null);
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$ErrorView, {
            fieldId: fieldId
        });
    }
    return renderDefaultErrorMessage();
};

});
parcelRegister("1hWNm", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $1a4012e60992863b$export$59e3aafda495153);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $cYbH1 = parcelRequire("cYbH1");
const $1a4012e60992863b$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6ikhl.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, formatMessage((0, $cYbH1.default).forgeRetryButton));
        return null;
    };
    return renderRetryButton();
};

});
parcelRegister("cYbH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $556cb06afa89f1be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $556cb06afa89f1be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeRetryButton: {
        "id": "forge-field-base.form.field-message.field-dispatch-button.forge-retry-button",
        "defaultMessage": "Try again?"
    }
});

});


parcelRegister("hH7yT", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fc581ff13e86c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44fc581ff13e86c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});



parcelRegister("5pZ9g", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $297a009f70430225$export$34a15d6027142c62);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");

var $7Aezm = parcelRequire("7Aezm");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $gifeQ = parcelRequire("gifeQ");

var $ELVDL = parcelRequire("ELVDL");

var $j5sSv = parcelRequire("j5sSv");

var $7fjFA = parcelRequire("7fjFA");


var $6cMZg = parcelRequire("6cMZg");
const $297a009f70430225$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
    const { onChange: onChange, value: value } = fieldProps;
    const extensionPayload = (0, $5uXOq.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $6cMZg.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: 'issue-create',
            ...(0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: 'issue-create'
            }
        };
        if (!selectedProject || !selectedIssueType) return defaultExtensionData;
        const issueTypeId = (0, $g5X3G.toIssueTypeId)(selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
        return {
            ...defaultExtensionData,
            project: {
                id: (0, $g5X3G.toProjectId)(selectedProject.value),
                key: (0, $g5X3G.toProjectKey)(selectedProject.projectKey),
                type: selectedProject.projectType
            },
            issue: {
                type: selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                typeId: issueTypeId
            }
        };
    }, [
        selectedProject,
        selectedIssueType,
        fieldId,
        fieldName,
        fieldType
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            renderContext: 'issue-create',
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension
    ]);
    if (!extension) return null;
    const renderDefaultView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderDefaultComponent(fieldProps, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
            attributes: {
                ...analyticsAttributes,
                renderMode: 'default'
            }
        }));
    if ((0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
        if ((0, $gifeQ.isBuiltInJiraFieldRender)(extension, 'edit', 'issue-create')) return renderDefaultView();
    } else if (!extension.properties.edit) return renderDefaultView();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ELVDL.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    });
};
const $297a009f70430225$export$34a15d6027142c62 = (props)=>{
    const { renderFieldMessage: renderFieldMessage, ...rest } = props;
    const { fieldId: fieldId, extension: extension, error: error } = rest;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: 'issue-create',
            ...extension && (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5sSv.FieldContainer), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($297a009f70430225$export$4f0175d9150f8767, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7fjFA.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    })));
};

});
parcelRegister("ELVDL", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $ed405e89d26d258c$export$5304145354a3bee9);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $2RhPB = parcelRequire("2RhPB");

var $4JpPl = parcelRequire("4JpPl");

var $7Aezm = parcelRequire("7Aezm");

var $9wJ66 = parcelRequire("9wJ66");

var $frltc = parcelRequire("frltc");

var $koVbs = parcelRequire("koVbs");

var $6cMZg = parcelRequire("6cMZg");

var $gb8Pv = parcelRequire("gb8Pv");
const $ed405e89d26d258c$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
        onChange((0, $6cMZg.transformValue)(newValue, extension));
        (0, $4JpPl.fireTrackEditedEvent)('issue-create', analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit version of 1.2.0 when inline edit is not supported
        // will be fixed with https://ecosystem-platform.atlassian.net/browse/ARKEN-32
        const translatedError = {
            message: intl.formatMessage((0, $gb8Pv.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $gb8Pv.default).modalModeErrorDescription)
        };
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
            ...analyticsAttributes,
            extension: JSON.stringify(extension)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frltc.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wJ66.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $ed405e89d26d258c$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: (0, $2RhPB.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed405e89d26d258c$export$ba588b5cce278e96, props));

});
parcelRegister("6cMZg", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $856789955d192c4b$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $856789955d192c4b$export$b82f09291a00d8c1);
$parcel$export(module.exports, "getExtension", () => $856789955d192c4b$export$78d71f9ed5534abe);

var $2QTbq = parcelRequire("2QTbq");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $2pEv1 = parcelRequire("2pEv1");
const $856789955d192c4b$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $2QTbq.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            if ((0, $4R6GH.fg)('custom_field_null_object_transform')) {
                if (value != null) return JSON.stringify(value);
                return value;
            }
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $856789955d192c4b$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $856789955d192c4b$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list') // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $2QTbq.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $2pEv1.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $856789955d192c4b$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $856789955d192c4b$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $856789955d192c4b$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $856789955d192c4b$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $856789955d192c4b$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($856789955d192c4b$export$3e406786572c35b0);
    return $856789955d192c4b$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("2pEv1", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $ff7dce57394b1eb3$export$2de59005e10fd82);

var $agVdz = parcelRequire("agVdz");
const $ff7dce57394b1eb3$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});


parcelRegister("gb8Pv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c94c49b5b89ee482$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c94c49b5b89ee482$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalModeErrorTitle: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("j5sSv", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b);
/* FieldContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $lD23V.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $lD23V.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $lD23V.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7fjFA", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $111a3dd21aa999b8$export$1df6b326181f4cdf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $qfj8c = parcelRequire("qfj8c");

var $eZJjh = parcelRequire("eZJjh");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $jcuk9 = parcelRequire("jcuk9");

var $3EMIO = parcelRequire("3EMIO");
const $111a3dd21aa999b8$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
    const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
    const [fieldState] = (0, $6ikhl.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, formatMessage((0, $3EMIO.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcuk9.ForgeFieldDispatchButton), {
            fieldId: fieldId
        }));
    const renderSuccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ValidMessage), null, formatMessage((0, $3EMIO.default).forgeFieldSuccessTextLabel));
    const renderHelperMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })), formatMessage((0, $3EMIO.default).forgeFieldPendingTextLabel));
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderFieldMessage(error));
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
            case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                return renderErrorMessage();
            case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                return renderSuccessMessage();
            case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
            case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                return renderHelperMessage();
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return renderErrorMessage();
    }
    return renderDefaultErrorMessage();
};
// For now, it only gives some space between the spinner and the message
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $111a3dd21aa999b8$var$MessagePartsSeparationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jcuk9", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $354a8a5375650812$export$59e3aafda495153);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");


var $6ikhl = parcelRequire("6ikhl");
const $354a8a5375650812$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6ikhl.useInlineField)(fieldId);
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, "Try again?");
        return null;
    };
    return renderRetryButton();
};

});

parcelRegister("3EMIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $477739caf5b64c43$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $477739caf5b64c43$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});


// itsm practices - copied from src/packages/issue-create/issue-create-common-types/src/common/types/index.tsx
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$SERVICE_REQUEST = 'SERVICE_REQUEST';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$INCIDENT_MANAGEMENT = 'INCIDENT_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$PROBLEM_MANAGEMENT = 'PROBLEM_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$CHANGE_MANAGEMENT = 'CHANGE_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$POST_INCIDENT_REVIEW = 'POST_INCIDENT_REVIEW';
// cs practice
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$DEVELOPER_ESCALATION = 'DEVELOPER_ESCALATION';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$UNASSIGNED_REQUEST_TYPE = 'UNASSIGNED_REQUEST_TYPE';
const $5363dcf42759d41f$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$ISSUE_TYPE = 'ISSUE_TYPE';


parcelRegister("7Emtg", function(module, exports) {

$parcel$export(module.exports, "reportForgeFailure", () => $6c61c34a1b63244f$export$e95b9e5003024a9c);

var $4JpPl = parcelRequire("4JpPl");

var $gifeQ = parcelRequire("gifeQ");
const $6c61c34a1b63244f$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
    const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
    /*
        Not log error:
         * if the extensions is filtered out by display conditions or access narrowing
         * if the forge data is empty (when fetching error there is an excluded error, empty response is returned)
    */ if (isEmptyForgeData || isExtensionFilteredOut) return;
    (0, $4JpPl.fireOperationalFailedEvent)('issue-create', {
        error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
        renderContext: 'issue-create'
    });
};

});

parcelRegister("bCATC", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryBypassProvider", () => $8f20301774b6a173$export$a5feb4d632b53009);
$parcel$export(module.exports, "ErrorBoundaryBypassInput", () => $8f20301774b6a173$export$36798a6d5688c318);
$parcel$export(module.exports, "ErrorBoundaryBypassOutput", () => $8f20301774b6a173$export$775be62266860b86);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $8f20301774b6a173$var$ErrorBoundaryBypassApiContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8f20301774b6a173$var$ErrorBoundaryBypassErrorContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8f20301774b6a173$export$a5feb4d632b53009 = ({ children: children })=>{
    const [bypassedError, setBypassedError] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            swallowError: (error)=>{
                setBypassedError(error);
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8f20301774b6a173$var$ErrorBoundaryBypassErrorContext.Provider, {
        value: bypassedError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8f20301774b6a173$var$ErrorBoundaryBypassApiContext.Provider, {
            value: api,
            children: children
        })
    });
};
class $8f20301774b6a173$export$36798a6d5688c318 extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        if (this.context !== null) this.context.swallowError(error);
    }
    static{
        this.contextType = $8f20301774b6a173$var$ErrorBoundaryBypassApiContext;
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
const $8f20301774b6a173$export$775be62266860b86 = ()=>{
    const bypassedError = (0, $5uXOq.useContext)($8f20301774b6a173$var$ErrorBoundaryBypassErrorContext);
    if (bypassedError !== null) throw bypassedError;
    return null;
};

});

parcelRegister("bv5he", function(module, exports) {

$parcel$export(module.exports, "FieldBusyIndicator", () => $88ca25f0a40fdec1$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4eKbI = parcelRequire("4eKbI");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $3WXbV = parcelRequire("3WXbV");
const $88ca25f0a40fdec1$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadingMessage = formatMessage((0, $3WXbV.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($88ca25f0a40fdec1$export$4e31364808fb7483, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4eKbI.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    testId: indicatorId,
                    size: "small"
                })
            })
        })
    });
});
$88ca25f0a40fdec1$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $88ca25f0a40fdec1$export$4e31364808fb7483 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4eKbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3e682addb0cb4a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wxJn.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
}

});

parcelRegister("3WXbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ef3198f799e6a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0ef3198f799e6a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});

});


parcelRegister("2eeg1", function(module, exports) {

$parcel$export(module.exports, "FieldValueDecoratorAsync", () => $58ac5136636efa9f$export$24545fc29fe55980);

var $5uXOq = parcelRequire("5uXOq");

var $gL80q = parcelRequire("gL80q");
var $jrwZp = parcelRequire("jrwZp");


var $62s0B = parcelRequire("62s0B");
const $58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const undecoratedResult = children(fieldProps);
    if ((0, $gL80q.isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62s0B.EnabledFieldValueDecorator), {
        fieldProps: fieldProps,
        fieldId: fieldId,
        fieldType: fieldType
    }, children);
    return undecoratedResult;
};
const $58ac5136636efa9f$export$24545fc29fe55980 = /*#__PURE__*/ (0, $5uXOq.memo)($58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo);

});
parcelRegister("62s0B", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldValueDecorator", () => $f47b896eac91b738$export$9d96bb1f53295b76);

var $1YewZ = parcelRequire("1YewZ");

var $9QJ7Z = parcelRequire("9QJ7Z");
const $f47b896eac91b738$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldProps: fieldProps })=>{
    const { onBlur: onBlur, onChange: onChange } = fieldProps;
    const { getFieldValue: getFieldValue } = (0, $9QJ7Z.useFormApi)();
    const { processChange: processChange } = (0, $1YewZ.useIssueAdjustmentsActions)();
    const processChangeByType = (eventType)=>{
        processChange({
            fieldId: fieldId,
            fieldValue: getFieldValue(fieldId),
            eventType: eventType
        });
    };
    const interceptedFieldProps = {
        ...fieldProps,
        onChange: (modifiedValue)=>{
            // Order is important to pass the current value to the UIM
            onChange(modifiedValue);
            processChangeByType('change');
        },
        onBlur: ()=>{
            // Order is important to pass the current value to the UIM
            onBlur();
            processChangeByType('blur');
        }
    };
    return children(interceptedFieldProps);
};

});
parcelRegister("9QJ7Z", function(module, exports) {

$parcel$export(module.exports, "FormApiProvider", () => $33387961dd1f98b9$export$1e7be89a21d0c0ae);
$parcel$export(module.exports, "useFormApi", () => $33387961dd1f98b9$export$4607062597b2b4df);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $33387961dd1f98b9$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $33387961dd1f98b9$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
    const setFieldValueRef = (0, $5uXOq.useRef)(setFieldValue);
    setFieldValueRef.current = setFieldValue;
    const getFormStateRef = (0, $5uXOq.useRef)(getFormState);
    getFormStateRef.current = getFormState;
    const value = (0, $5uXOq.useMemo)(()=>({
            setFieldValue: (...args)=>setFieldValueRef.current(...args),
            getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId],
            ...(0, $4R6GH.fg)('support-assets-field-with-all-field-values') ? {
                getAllFieldValue: ()=>getFormStateRef.current().values
            } : {}
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33387961dd1f98b9$var$Context.Provider, {
        value: value
    }, children);
};
const $33387961dd1f98b9$export$4607062597b2b4df = ()=>{
    const context = (0, $5uXOq.useContext)($33387961dd1f98b9$var$Context);
    if (context === null) throw new Error('Missing FormApiProvider');
    return context;
};

});



parcelRegister("aBZin", function(module, exports) {

$parcel$export(module.exports, "getValueFromEventOrValue", () => $56aa95be299fa4e4$export$a59801673b41acfd);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $56aa95be299fa4e4$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $56aa95be299fa4e4$export$a59801673b41acfd(eventOrValue) {
    if ($56aa95be299fa4e4$var$isEvent(eventOrValue)) {
        const { currentTarget: currentTarget } = eventOrValue;
        if (currentTarget.type === 'checkbox') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (currentTarget.checked) return currentTarget.value || true;
            return currentTarget.value ? undefined : false;
        }
        if (currentTarget) return currentTarget.value;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return eventOrValue;
}

});

parcelRegister("45JN1", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $f046862319512079$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $kOFhM = parcelRequire("kOFhM");

var $qfj8c = parcelRequire("qfj8c");

var $e4yMr = parcelRequire("e4yMr");

var $f5oqj = parcelRequire("f5oqj");

var $3bDjY = parcelRequire("3bDjY");

var $h17zy = parcelRequire("h17zy");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $6a30R = parcelRequire("6a30R");

var $4IoOR = parcelRequire("4IoOR");

var $aQb3V = parcelRequire("aQb3V");
const $f046862319512079$var$FieldHelpLink = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl })=>{
    const learnMoreMessage = (0, $aQb3V.getLearnMoreMessage)(fieldHelpTextUrl ?? '');
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: fieldHelpTextUrl,
        target: "_blank"
    }, formatMessage(learnMoreMessage));
});
const $f046862319512079$var$FieldMessageBehaviour = (props)=>{
    const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    const maxHeight = 22;
    const emojiProvider = (0, $h17zy.useEmojiProvider)();
    const adfDocument = (0, $5uXOq.useMemo)(()=>{
        if (error) return null;
        return (0, $4IoOR.convertWikiToAdf)(description);
    }, [
        description,
        error
    ]);
    if (error !== undefined && error !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $aQb3V.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!adfDocument && !fieldHelpTextUrl) return null;
    const getRenderer = (isTruncated = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            document: adfDocument,
            schema: (0, $kOFhM.defaultSchema),
            dataProviders: emojiProvider,
            disableHeadingIDs: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $4R6GH.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            maxHeight: isTruncated ? maxHeight : undefined,
            truncated: isTruncated,
            fadeOutHeight: isTruncated ? 0 : undefined,
            eventHandlers: {
                smartCard: {
                    onClick: (0, $6a30R.onLinkClick)
                },
                link: {
                    onClick: onLinkClickEvent || (0, $6a30R.onLinkClick)
                }
            },
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    const getRenderedDescription = (truncatedRenderer = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$Description, {
            "data-testid": "issue-create-commons.common.ui.field-message.description",
            isMini: isMini,
            ...fieldId && {
                id: `${fieldId}-field-message`
            }
        }, adfDocument && getRenderer(truncatedRenderer), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldHelpLink, {
            fieldHelpTextUrl: fieldHelpTextUrl
        })));
    if (isMini) {
        if (adfDocument?.content[0]?.type === 'paragraph') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$TooltipContentContainer, null, getRenderer()),
            position: "bottom"
        }, getRenderedDescription(true));
        return null;
    }
    return getRenderedDescription();
};
const $f046862319512079$export$eb5013679a5d3f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldMessageBehaviour, {
        key: `field-message-${props.fieldId}`,
        ...props
    });
const $f046862319512079$var$TooltipContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1h1vhk _woio15cr _13odidpf _9j7z1j89",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $f046862319512079$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_162p546": (0, $lD23V.default)(__cmplp.isMini && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            })
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1hdcr7 _woio131l _13od1b66 _1pz31ynx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aQb3V", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $8cc68cbdef3ac4a4$export$2c1e5dc35269c547);
$parcel$export(module.exports, "getErrorMessage", () => $8cc68cbdef3ac4a4$export$82f46aa4e6535a45);

var $6s1PB = parcelRequire("6s1PB");

var $bGrWH = parcelRequire("bGrWH");


var $7vNya = parcelRequire("7vNya");

var $dOrZq = parcelRequire("dOrZq");
const $8cc68cbdef3ac4a4$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    const learnMoreMessages = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7vNya.LEARN_MORE_MESSAGES_WITH_ISSUE_TERM) : (0, $7vNya.LEARN_MORE_MESSAGES);
    if (urlSuffix in learnMoreMessages) return learnMoreMessages[urlSuffix];
    return (0, $dOrZq.default).fieldHelpTextLabel;
};
const $8cc68cbdef3ac4a4$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    const helperMessage = $8cc68cbdef3ac4a4$export$2c1e5dc35269c547(fieldHelpTextUrl);
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $8cc68cbdef3ac4a4$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $bGrWH.REQUIRED:
            return formatMessage((0, $dOrZq.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca:
            return formatMessage((0, $dOrZq.default).labelsMaxErrorMessage, {
                MAX_ALLOWED_LABELS: formatNumber((0, $d46ffa3990e23a4d$export$1fdf850c93de8bae))
            });
        case 0, $d46ffa3990e23a4d$export$e77d629cc732976d:
            return formatMessage((0, $dOrZq.default).labelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
            });
        case 0, $d46ffa3990e23a4d$export$618e922e89e8bcae:
            return formatMessage((0, $dOrZq.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$fe1a70381f6491b5))
            });
        case 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f:
            return formatMessage((0, $dOrZq.default).forgeLabelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
            });
        default:
            return validationError;
    }
};

});
const $d46ffa3990e23a4d$export$9151073f92820ff8 = 255;
const $d46ffa3990e23a4d$export$fe1a70381f6491b5 = 255;
const $d46ffa3990e23a4d$export$1fdf850c93de8bae = 55;
const $d46ffa3990e23a4d$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $d46ffa3990e23a4d$export$e77d629cc732976d = 'LABELS INVALID';
const $d46ffa3990e23a4d$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $d46ffa3990e23a4d$export$618e922e89e8bcae = 'STRING_INVALID';

parcelRegister("7vNya", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES_WITH_ISSUE_TERM", () => $6a6781d11d912198$export$1b2b0fc2cd5817de);
$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $6a6781d11d912198$export$eedb1bf75e1efb26);

var $dOrZq = parcelRequire("dOrZq");
const $6a6781d11d912198$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels'
};
const $6a6781d11d912198$export$1b2b0fc2cd5817de = {
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, $dOrZq.default).fieldHelpIssueTypesIssueTermRefresh,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $dOrZq.default).fieldHelpPriorityLevels,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $dOrZq.default).fieldHelpResolutionDefinitions,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $dOrZq.default).fieldHelpSecurityLevels
};
const $6a6781d11d912198$export$eedb1bf75e1efb26 = {
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, $dOrZq.default).fieldHelpIssueTypes,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $dOrZq.default).fieldHelpPriorityLevels,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $dOrZq.default).fieldHelpResolutionDefinitions,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $dOrZq.default).fieldHelpSecurityLevels
};

});
parcelRegister("dOrZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5d9a42d37b19ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c5d9a42d37b19ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-create-commons.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    labelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
        "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    stringInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    forgeLabelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
        "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    labelsMaxErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-max-error-message",
        "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
    },
    fieldHelpTextLabel: {
        "id": "issue-create-commons.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldHelpIssueTypesIssueTermRefresh: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types-issue-term-refresh",
        "defaultMessage": "Learn about work types"
    }
});

});




parcelRegister("iblgc", function(module, exports) {

$parcel$export(module.exports, "FieldSkeleton", () => $20aa6a3390c971a5$export$f102dad4aafe4ad4);
$parcel$export(module.exports, "default", () => $20aa6a3390c971a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");

var $YSJPS = parcelRequire("YSJPS");
const $20aa6a3390c971a5$export$f102dad4aafe4ad4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
        "data-testid": "issue-create-commons.common.ui.loader.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Label, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Description, null));
const $20aa6a3390c971a5$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, Array.from({
        length: skeletonCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$export$f102dad4aafe4ad4, {
            key: `field-skeleton-${index}`
        })));
var $20aa6a3390c971a5$export$2e2bcd8739ae039 = $20aa6a3390c971a5$var$IssueCreateLoader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20aa6a3390c971a5$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
            __cmplp.className
        ])
    });
});
$20aa6a3390c971a5$var$Label.displayName = 'LabelSkeleton';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20aa6a3390c971a5$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipxbi _1bsb1mjv",
            __cmplp.className
        ])
    });
});
$20aa6a3390c971a5$var$Description.displayName = 'DescriptionSkeleton';

});

parcelRegister("86fzT", function(module, exports) {

$parcel$export(module.exports, "generateKeyForRequiredFromUIM", () => $81f27e245685507d$export$920d96e4692b3d51);
const $81f27e245685507d$export$920d96e4692b3d51 = (parameters)=>{
    const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
    return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};

});


parcelRegister("gLdtQ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", () => $60f472fd3d28277e$export$7c7171667037b275);
$parcel$export(module.exports, "closeMenuOnScroll", () => $60f472fd3d28277e$export$fe334d83c6aac80f);
// keeping it here instead of jira-issue-create to avoid cyclic dependencies.
const $60f472fd3d28277e$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
const $60f472fd3d28277e$var$MENU_CLOSE_SELECTORS = [
    $60f472fd3d28277e$export$7c7171667037b275
];
const $60f472fd3d28277e$export$fe334d83c6aac80f = (e)=>{
    // @ts-expect-error - TS18047 -  'e.target' is possibly 'null'.
    if ($60f472fd3d28277e$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
    return false;
};

});

parcelRegister("aZJYe", function(module, exports) {

$parcel$export(module.exports, "mutateAffectedServicesField", () => $3cf4650743fd53da$export$c5ca3c9d905a51f0);
$parcel$export(module.exports, "transformDefaultAffectedServices", () => $3cf4650743fd53da$export$6f4e94c57a16128c);
$parcel$export(module.exports, "useFetchAffectedServicesName", () => $3cf4650743fd53da$export$9abe2f602f72a411);

var $5uXOq = parcelRequire("5uXOq");

var $6paOF = parcelRequire("6paOF");

var $7f4tk = parcelRequire("7f4tk");

var $2ngL6 = parcelRequire("2ngL6");
const $3cf4650743fd53da$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
        affectedServicesField: {
            fieldId: fieldId,
            affectedServices: selectedAffectedServices.map(({ value: value })=>({
                    serviceId: value
                }))
        }
    });
const $3cf4650743fd53da$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
            value: service.serviceId
        }));
const $3cf4650743fd53da$export$9abe2f602f72a411 = ()=>{
    const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
    const baseUrl = '';
    const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        (0, $7f4tk.default)(`${baseUrl}/rest/service-registry-api/service`, {
            method: 'POST',
            body: JSON.stringify({
                ids: ids
            })
        }).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $2ngL6.mapServiceEntitiesToOptions)(response.services));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchAffectedServicesName',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("iZNZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $edda9d683fcffdb7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");


var $cNmdz = parcelRequire("cNmdz");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $id3OI = parcelRequire("id3OI");

const $edda9d683fcffdb7$var$AssetsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, fieldProps: { value: value, onChange: onChange }, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, error: error, fieldId: fieldId, defaultValue: defaultValue, isEditable: isEditable = true, nonEditableReason: nonEditableReason, selectedProject: selectedProject, selectedIssueType: selectedIssueType, ariaLabelledBy: ariaLabelledBy } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
    const [{ isLoading: isLoading }, fetchAssetsName] = (0, $id3OI.useFetchAssetsWithId)();
    const projectId = selectedProject?.value || '';
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /*
	 * Fetch the asset names using the IDs from the default values that were saved
	 * */ (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
			 * defaultValue will be of type AssetEntityForServer but flow gives error
			 * when trying to typecast it
			 * */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const ids = defaultValue.map(({ serializedOrigin: serializedOrigin })=>serializedOrigin);
            fetchAssetsName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAssetsName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAssetsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNmdz.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            issueTypeId: issueTypeId,
            projectId: projectId,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getAssetsEdit()) : getAssetsEdit());
};
var $edda9d683fcffdb7$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $id3OI.transformDefaultAssets)
})($edda9d683fcffdb7$var$AssetsField);

});
parcelRegister("cNmdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0efd85d3b7b73672$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $hGU7l = parcelRequire("hGU7l");

var $46K19 = parcelRequire("46K19");
const $0efd85d3b7b73672$export$b7cbf126c81503e1 = 300;
// react-select with isMulti can return both null or an empty array for onChange depending on how
// it was cleared. Normalize this to an empty array https://github.com/JedWatson/react-select/issues/3632
const $0efd85d3b7b73672$var$normalizeOnChangeValues = (onChange)=>(updatedValues)=>onChange(updatedValues || []);
const $0efd85d3b7b73672$var$AssetsEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, isDisabled: isDisabled, issueTypeId: issueTypeId, projectId: projectId, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const [assetFilterName, setAssetFilterName] = (0, $5uXOq.useState)([]);
    const [, setAssetFilterConfigError] = (0, $5uXOq.useState)(false);
    const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    /*
   * 1. Use customFieldId (eg. customfield_10085) to get asset filter contextId (eg. 10025)
   * 2. Use asset filter contextId to get asset filter name (eg. com.atlassian.servicedesk.connect.test-bed/mac.type.id)
   * 3. Use asset filter name for doing query in fetchAssets when user types in name of asset
   * */ (0, $5uXOq.useEffect)(()=>{
        (0, $46K19.fetchFieldFilterNames)(createAnalyticsEvent({}), fieldId, projectId, issueTypeId).then((result)=>{
            setAssetFilterName(result.map((res)=>`${res.appKey}/${res.originId}`));
        }).catch(()=>{
            setAssetFilterConfigError(true);
        });
    }, [
        fieldId,
        projectId,
        issueTypeId,
        createAnalyticsEvent
    ]);
    const searchAssets = (0, $5uXOq.useCallback)(async (query)=>{
        setLastFetchFailed(false);
        return (0, $46K19.fetchAssets)(query, autoCompleteUrl, accountId, assetFilterName, createAnalyticsEvent({})).catch(()=>{
            setLastFetchFailed(true);
            return [];
        });
    }, [
        autoCompleteUrl,
        accountId,
        assetFilterName,
        createAnalyticsEvent
    ]);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAssets();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $FtZX9.default)(searchAssets, $0efd85d3b7b73672$export$b7cbf126c81503e1);
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $hGU7l.default).failedFetch : (0, $hGU7l.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(updatedValues: AssetOption[] | null) => void' is not assignable to type '(value: OptionsType<AssetOption>, action: ActionMeta<AssetOption>) => void'.
        onChange: $0efd85d3b7b73672$var$normalizeOnChangeValues(onChange),
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isDisabled,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-labelledby": ariaLabelledBy
    });
};
var $0efd85d3b7b73672$export$2e2bcd8739ae039 = $0efd85d3b7b73672$var$AssetsEdit;

});
parcelRegister("hGU7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $85aec46678298565$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $85aec46678298565$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-assets.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-assets.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});

});

parcelRegister("46K19", function(module, exports) {

$parcel$export(module.exports, "mapAssetEntityToAssetOptions", () => $3afecf084ac33106$export$65ae210119db9fc5);
$parcel$export(module.exports, "fetchFieldFilterNames", () => $3afecf084ac33106$export$668516cfbde240de);
$parcel$export(module.exports, "fetchAssets", () => $3afecf084ac33106$export$6411291ff3741ab1);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $eusud = parcelRequire("eusud");
const $3afecf084ac33106$export$65ae210119db9fc5 = (data)=>data.map(({ label: label, origin: origin })=>({
            label: label.value,
            value: `${origin.appKey}/${origin.originId}`
        }));
const $3afecf084ac33106$export$668516cfbde240de = async (analyticsEvent, customFieldId, projectId, issueTypeId)=>{
    const queryString = issueTypeId === null || issueTypeId === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        projectId: projectId
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        projectId: projectId,
        issueTypeId: issueTypeId
    });
    return (0, $7f4tk.default)(`/rest/assetinternalapi/latest/field/${customFieldId}/config?${queryString}`).then((response)=>response?.types || []).catch((error)=>{
        if (error.statusCode === 404) return Promise.resolve([]);
        (0, $jcw0u.default)({
            event: analyticsEvent,
            error: error,
            meta: {
                packageName: 'jiraIssueFieldAssets',
                id: 'fetchFieldFilterNames'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};
const $3afecf084ac33106$export$6411291ff3741ab1 = async (inputValue = '', autoCompleteUrl, accountId, assetTypesFilter, analyticsEvent)=>{
    const queryParams = {
        prioritizedAssignee: accountId,
        query: inputValue,
        type: assetTypesFilter
    };
    const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams);
    return (0, $eusud.performGetRequest)(`${autoCompleteUrl}?${queryString}`).then((response)=>$3afecf084ac33106$export$65ae210119db9fc5(response.values)).catch((error)=>{
        (0, $jcw0u.default)({
            event: analyticsEvent,
            error: error,
            meta: {
                packageName: 'jiraIssueFieldAssets',
                id: 'fetchAssets'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});


parcelRegister("id3OI", function(module, exports) {

$parcel$export(module.exports, "mapAssetOptionsToAssetEntity", () => $c1c03d516473406c$export$15c347a847be44f6);
$parcel$export(module.exports, "mutateAssetsFields", () => $c1c03d516473406c$export$9067b9149eea3adb);
$parcel$export(module.exports, "transformDefaultAssets", () => $c1c03d516473406c$export$42e188fe92589513);
$parcel$export(module.exports, "useFetchAssetsWithId", () => $c1c03d516473406c$export$aa4b3faecd2997ab);

var $5uXOq = parcelRequire("5uXOq");

var $6paOF = parcelRequire("6paOF");

var $7f4tk = parcelRequire("7f4tk");

var $46K19 = parcelRequire("46K19");
const $c1c03d516473406c$export$15c347a847be44f6 = (options)=>options.map(({ value: value })=>({
            appKey: value.split('/')[0],
            originId: value.split('/')[1],
            serializedOrigin: value,
            value: value
        }));
const $c1c03d516473406c$export$9067b9149eea3adb = (selectedAssets, fieldId)=>({
        assetsField: {
            fieldId: fieldId,
            assets: selectedAssets.map(({ value: value })=>({
                    appKey: value.split('/')[0],
                    originId: value.split('/')[1],
                    serializedOrigin: value,
                    value: value
                }))
        }
    });
const $c1c03d516473406c$export$42e188fe92589513 = (defaultAssets)=>defaultAssets.map(({ serializedOrigin: serializedOrigin })=>({
            value: serializedOrigin
        }));
const $c1c03d516473406c$export$aa4b3faecd2997ab = ()=>{
    const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
    const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        Promise.all(ids.map((id)=>(0, $7f4tk.default)(`/rest/assetapi/asset/${id}`))).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $46K19.mapAssetEntityToAssetOptions)(response));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchAssetsWithId',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("5FwUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $489f100aee3a6307$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $89S0t = parcelRequire("89S0t");

var $leRCk = parcelRequire("leRCk");

var $dCm1o = parcelRequire("dCm1o");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $bfnma = parcelRequire("bfnma");

var $5rYSU = parcelRequire("5rYSU");
const $489f100aee3a6307$export$7c52097ee36bd91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, $dCm1o.isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const onAssignToMeClick = ()=>{
        onChange(loggedInUser);
    };
    const onAddAssigneeKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (id && (event.key === 'Enter' || event.key === ' ')) {
            onChange(loggedInUser);
            // this focus was implemented with getElementById as there is problem here using ref in UserPicker
            // doesn't pass ref to input inside the component
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setTimeout(()=>document.getElementById(id)?.focus());
        }
    }, [
        id,
        loggedInUser,
        onChange
    ]);
    const showAssignToMe = loggedInUser && !isReadOnly;
    const assignToMeButton = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button",
        xcss: $489f100aee3a6307$var$assignToMeStyles
    }, formatMessage((0, $bfnma.default).assignToMe)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
    }, formatMessage((0, $bfnma.default).assignToMe));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($489f100aee3a6307$var$FieldContainer, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89S0t.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        shouldPreloadAssignToMe: true,
        autoCompleteUrl: autoCompleteUrl,
        enableAutomaticOption: true,
        autoFocus: autoFocus,
        isDisabled: isReadOnly,
        width: width,
        inputId: id,
        openMenuOnClick: true
    }), showAssignToMe && assignToMeButton);
};
var $489f100aee3a6307$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateAssigneeField),
    transformDefaultValue: (0, $5rYSU.transformDefaultAssigneeValue // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, UserValue>, any>'.
    )
})($489f100aee3a6307$export$7c52097ee36bd91);
const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7C5S0.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1v091b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7C5S0.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
            __cmplp.className
        ])
    });
});
const $489f100aee3a6307$var$assignToMeStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    color: 'color.link',
    cursor: 'pointer',
    marginTop: 'space.050',
    padding: 'space.0',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $489f100aee3a6307$var$FieldContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn, $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff);

});
parcelRegister("89S0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7ac4b7108cf6a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $aWse0 = parcelRequire("aWse0");

var $ecbCU = parcelRequire("ecbCU");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $4R6GH = parcelRequire("4R6GH");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");

var $h36wX = parcelRequire("h36wX");

var $kt8K4 = parcelRequire("kt8K4");
const $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience = new (0, $duUGa.UFOExperience)('inline-assignee-picker.field-options-load', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'inline-assignee-picker.field-options-load'
});
const $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ariaLabel: ariaLabel, isRequired: isRequired, ...fieldProps })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const self = (0, $5uXOq.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $kt8K4.default)(autoCompleteUrl || '');
    const [assigneeValue, assigneeOptions] = (0, $4R6GH.fg)('fix_a11y_issue_in_transition_form') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $h36wX.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption, undefined, undefined, isRequired) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $h36wX.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption);
    const [, { openDrawer: openDrawer }] = (0, $ecbCU.useInvitePeopleDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (loading) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loading'
            }), 'inlineAssigneeOptions loading');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'failed'
            }), 'inlineAssigneeOptions failed');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loaded'
            }), 'inlineAssigneeOptions loaded');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            /*
     * Added extra condition to skip search. it's getting called during onBlur because previousQuery is undefined and query is empty string
     * then query !== self.previousQuery will be true and fetchUsers getting called unnecessarily
     */ if (query === '' && self.previousQuery === undefined) return;
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        users,
        fetchUsers
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        self.previousQuery = undefined;
    }, [
        onBlur,
        self
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if (enablePeopleInvite && updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) {
            openDrawer(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        let newValue;
        if (updatedValue.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) || updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) newValue = null;
        else newValue = (0, $fhSLy.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
    }, [
        enablePeopleInvite,
        onChange,
        openDrawer,
        value,
        createAnalyticsEvent
    ]);
    /*
   * user picker default opens on focus, fetchUsers has to be called onFocus
   * when openMenuOnClick is enabled then fetchUsers should be called during onOpen rather than onFocus
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: handleOnFocus
    } : {
        onFocus: handleOnFocus
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        inputId: inputId,
        fieldId: (0, $5fc53.ASSIGNEE_TYPE),
        autoFocus: autoFocus,
        placeholder: intl.formatMessage((0, $7lGt2.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        value: assigneeValue,
        isMulti: false,
        isClearable: false,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        subtle: isSubtle,
        appearance: appearance,
        width: width,
        isDisabled: isDisabled,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        UNSAFE_hasDraggableParentComponent: true,
        ariaLabel: ariaLabel,
        ...controlProps
    });
};
var $3a7ac4b7108cf6a7$export$2e2bcd8739ae039 = $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit;

});
parcelRegister("h36wX", function(module, exports) {

$parcel$export(module.exports, "useAssigneeOptions", () => $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);

var $3OKtJ = parcelRequire("3OKtJ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $leRCk = parcelRequire("leRCk");

var $4R6GH = parcelRequire("4R6GH");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");
const $92b31ca8d85d4433$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign, shouldHideUnassigned)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const automaticOption = (0, $fhSLy.getAutomaticUserOption)(intl);
    const valueOption = (0, $fhSLy.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $fhSLy.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $7lGt2.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    const hideUnassigned = (0, $4R6GH.fg)('fix_a11y_issue_in_transition_form') && shouldHideUnassigned;
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = !hideUnassigned && (isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase()));
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $fhSLy.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
        } else {
            $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
            invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $fhSLy.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $fhSLy.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options
    ];
};

});
parcelRegister("3OKtJ", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $d369cb9a3149539e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $d369cb9a3149539e$export$34e0d98131b0b98a);

var $M0UM1 = parcelRequire("M0UM1");

var $ivhIb = parcelRequire("ivhIb");


var $eXneb = parcelRequire("eXneb");
const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $a56e5eac5897104f$export$18d36911c7f94286),
        (0, $a56e5eac5897104f$export$da1c529049028734)
    ].includes((0, $M0UM1.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $M0UM1.isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ivhIb))),
        byline: formatMessage((0, $eXneb.default).inviteAndAssign),
        isDisabled: (0, $M0UM1.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("ivhIb", function(module, exports) {
module.exports = new URL("email.very-specific-illu.3b6402e8.png", import.meta.url).toString();

});

const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("eXneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $31de51ead46cb5cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});



parcelRegister("kt8K4", function(module, exports) {

$parcel$export(module.exports, "default", () => $564a5b059c2a0fff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl, customFetchUsers)=>{
    const [users, setUsers] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchUsers = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        const fetchUsersMethod = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? customFetchUsers(query) : (0, $7f4tk.default)(usersFetchUrl);
        return fetchUsersMethod.then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            const errorMessage = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? 'Failed to fetch using custom user fetcher' : 'Failed to fetch users';
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.assigne', errorMessage, err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error,
        customFetchUsers
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;

});


parcelRegister("jGVMX", function(module, exports) {

$parcel$export(module.exports, "validateString", () => $e5b3b607ab8affce$export$d7b0a588f685ba7e);
$parcel$export(module.exports, "validateSelectField", () => $e5b3b607ab8affce$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateCascadingSelectField", () => $e5b3b607ab8affce$export$837294b8fc732f20);
$parcel$export(module.exports, "validateAssigneeField", () => $e5b3b607ab8affce$export$dd17aabe3f77b2ba);
$parcel$export(module.exports, "validateUserPickerField", () => $e5b3b607ab8affce$export$356346770aab95cb);
$parcel$export(module.exports, "validateCheckboxField", () => $e5b3b607ab8affce$export$7aa5e0976d0c384b);
$parcel$export(module.exports, "validateComponentField", () => $e5b3b607ab8affce$export$89943b0814df306d);
$parcel$export(module.exports, "validateCustomTeamsField", () => $e5b3b607ab8affce$export$364ea91bee38a994);
$parcel$export(module.exports, "validateGroupPickerField", () => $e5b3b607ab8affce$export$c6d4785f3f46f73a);
$parcel$export(module.exports, "validateMultiVersionsField", () => $e5b3b607ab8affce$export$727e23f536334715);
$parcel$export(module.exports, "validateOrganizationsField", () => $e5b3b607ab8affce$export$b97bb8e170430af8);
$parcel$export(module.exports, "validatePriorityField", () => $e5b3b607ab8affce$export$17fd881b060187f7);
$parcel$export(module.exports, "validateRadioSelectField", () => $e5b3b607ab8affce$export$f69029476f9179b);
$parcel$export(module.exports, "validateRadioGroupField", () => $e5b3b607ab8affce$export$d60dcaa093bca71d);
$parcel$export(module.exports, "validateResolutionField", () => $e5b3b607ab8affce$export$316feff8e636f81f);
$parcel$export(module.exports, "validateSingleVersionField", () => $e5b3b607ab8affce$export$45f7908dc93110fb);
$parcel$export(module.exports, "validateLabelField", () => $e5b3b607ab8affce$export$1a8caa895b9fda26);
$parcel$export(module.exports, "validateForgeLabelField", () => $e5b3b607ab8affce$export$bf4287ae453e2aab);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $bGrWH = parcelRequire("bGrWH");

// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
    if (isRequired && !value?.trim?.()) return 0, $bGrWH.REQUIRED;
    if (typeof value === 'string' && type === 'text' && value?.length > (0, $d46ffa3990e23a4d$export$fe1a70381f6491b5)) return 0, $d46ffa3990e23a4d$export$618e922e89e8bcae;
    return undefined;
};
const $e5b3b607ab8affce$export$53ded7ceec493f10 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$837294b8fc732f20 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$dd17aabe3f77b2ba = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$356346770aab95cb = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$7aa5e0976d0c384b = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$89943b0814df306d = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$364ea91bee38a994 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$c6d4785f3f46f73a = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$727e23f536334715 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (!value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$b97bb8e170430af8 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(data) && !data.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$17fd881b060187f7 = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$f69029476f9179b = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
const $e5b3b607ab8affce$export$d60dcaa093bca71d = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
const $e5b3b607ab8affce$export$316feff8e636f81f = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$45f7908dc93110fb = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$1a8caa895b9fda26 = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $bGrWH.REQUIRED;
    }
    if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.includes(' ') || value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$e77d629cc732976d;
    return undefined;
};
const $e5b3b607ab8affce$export$bf4287ae453e2aab = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $bGrWH.REQUIRED;
    }
    if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f;
    return undefined;
};

});

parcelRegister("bfnma", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd95939e2e05e754$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dd95939e2e05e754$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assignToMe: {
        "id": "issue-create-commons.assignee-field.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("5rYSU", function(module, exports) {

$parcel$export(module.exports, "transformDefaultAssigneeValue", () => $b31c169a5b4e6cfd$export$f5415de9103f1c69);
$parcel$export(module.exports, "mapUserToAssigneeValue", () => $b31c169a5b4e6cfd$export$c4dfa893fba82437);
$parcel$export(module.exports, "mutateAssigneeUserPicker", () => $b31c169a5b4e6cfd$export$a6706b2f4762043b);


const $b31c169a5b4e6cfd$export$f5415de9103f1c69 = (value)=>({
        accountId: (value.accountId === '-1' ? (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027) : value.accountId) || '',
        displayName: value.name || '',
        avatarUrls: value.picture !== undefined ? {
            '16x16': value.picture,
            '24x24': value.picture,
            '32x32': value.picture,
            '48x48': value.picture
        } : {}
    });
const $b31c169a5b4e6cfd$export$c4dfa893fba82437 = (value)=>{
    if (value === null) return null;
    if (value.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) return undefined;
    return {
        id: value.accountId
    };
};
const $b31c169a5b4e6cfd$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
    if (selectedUser === null || selectedUser.accountId === null) return null;
    return {
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
        user: {
            accountId: selectedUser.accountId
        }
    };
};

});


parcelRegister("4kXb0", function(module, exports) {

$parcel$export(module.exports, "AtlassianTeamsField", () => $2d376b3496c34d29$export$96c8ee98de63ec5b);
$parcel$export(module.exports, "default", () => $2d376b3496c34d29$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $b71gk = parcelRequire("b71gk");

var $8vFwj = parcelRequire("8vFwj");

var $4ajjx = parcelRequire("4ajjx");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $icXkU = parcelRequire("icXkU");

const $2d376b3496c34d29$var$overrideSelectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
    control: (base)=>({
            ...base,
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
        })
};
const $2d376b3496c34d29$var$stopFormPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $2d376b3496c34d29$export$96c8ee98de63ec5b = (props)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const siteId = tenantContext.cloudId;
    /**
   * The following is a hack to force the TeamPickerEdit to close after creating a team.
   * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
   * doesn't expose the select Ref.
   *  */ const [hackIsEditable, setHackIsEditable] = (0, $5uXOq.useState)(true);
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
    const onCreate = (0, $5uXOq.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                memberCount: team.memberCount
            });
            /**
       * The following is a hack to force the TeamPickerEdit to close after creating a team.
       * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
       * doesn't expose the select Ref.
       *  */ setHackIsEditable(false);
            // required wait for new created team to be available
            setTimeout(()=>{
                onChange(team);
                setHackIsEditable(true);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $8vFwj.useCreateTeamDialog)({
        onCreate: onCreate
    });
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-picker-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ajjx.AsyncTeamPickerEdit), {
            ...fieldProps,
            width: width,
            siteId: siteId,
            autoFocus: autoFocus,
            defaultValue: value,
            // @ts-expect-error - TS2322 - Type '(value: TeamValue) => void' is not assignable to type 'OnChange'.
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isEditable === false || !hackIsEditable,
            styles: $2d376b3496c34d29$var$overrideSelectStyles,
            createTeamDialogTrigger: createTeamDialogTrigger
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $2d376b3496c34d29$var$stopFormPropagation
    }, createTeamDialog)));
};
var $2d376b3496c34d29$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $icXkU.validateAtlassianTeamsField),
    transformDefaultValue: (0, $icXkU.transformDefaultAtlassianTeam)
})($2d376b3496c34d29$export$96c8ee98de63ec5b);

});
parcelRegister("4ajjx", function(module, exports) {

$parcel$export(module.exports, "AsyncTeamPickerEdit", () => $81014c0bebd525f2$export$7db2ade8dff2be91);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kxZPA = parcelRequire("kxZPA");

var $9n6Ty = parcelRequire("9n6Ty");
const $81014c0bebd525f2$var$EMPTY_OBJECT = {};

const $81014c0bebd525f2$export$eaed616868423e8a = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("hgQ4J"))), {
    moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
});
const $81014c0bebd525f2$export$7db2ade8dff2be91 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $9n6Ty.asyncTeamPickerEditEntryPoint), // use stable object reference to avoid re-renders
    $81014c0bebd525f2$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-atlassian-team-picker-edit",
        packageName: "jira-issue-field-team",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("9n6Ty", function(module, exports) {

$parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", () => $306b3712a4b90308$export$80ec8c2b96e9988);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $306b3712a4b90308$export$80ec8c2b96e9988 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("hgQ4J"))).then((module)=>module.TeamPickerEditEntryPointContent), {
        moduleId: "ce0fa7b5"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("bGEod", function(module, exports) {

$parcel$export(module.exports, "FieldLoader", () => $6a1003bb52c05df4$export$dbd27b551621740c);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");
const $6a1003bb52c05df4$export$dbd27b551621740c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        width: "350px",
        height: "40px"
    });

});

parcelRegister("icXkU", function(module, exports) {

$parcel$export(module.exports, "mutateAtlassianTeamField", () => $9b9cb321960b72df$export$c8b8a48d1ff67754);
$parcel$export(module.exports, "transformDefaultAtlassianTeam", () => $9b9cb321960b72df$export$3fee94ad0b9e180c);
$parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", () => $9b9cb321960b72df$export$450002773f9da0a4);
$parcel$export(module.exports, "validateAtlassianTeamsField", () => $9b9cb321960b72df$export$8222f94513c7d2e6);

var $bGrWH = parcelRequire("bGrWH");

const $9b9cb321960b72df$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $9f942793bea6ba7a$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.id
        }
    } : null;
const $9b9cb321960b72df$export$3fee94ad0b9e180c = (team)=>({
        name: team.name,
        id: team.teamId,
        avatarUrl: team?.avatar?.small
    });
const $9b9cb321960b72df$export$450002773f9da0a4 = (team)=>{
    if (team && team.id) return team.id;
    return null;
};
const $9b9cb321960b72df$export$8222f94513c7d2e6 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});
const $9f942793bea6ba7a$export$31fd86f8f183952c = 'atlassianTeamFields';



parcelRegister("bWtQ8", function(module, exports) {

$parcel$export(module.exports, "getFileIdsFromFiles", () => $7bad3ba374b5e258$export$90bf402b5b4274c7);
$parcel$export(module.exports, "validateAttachment", () => $7bad3ba374b5e258$export$8af997fabc69757a);
$parcel$export(module.exports, "getFieldDropZoneContainerID", () => $7bad3ba374b5e258$export$2fab292eea84487a);

var $bGrWH = parcelRequire("bGrWH");
const $7bad3ba374b5e258$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
const $7bad3ba374b5e258$export$8af997fabc69757a = (value, isRequired)=>{
    if (isRequired) {
        if (!value || value.length === 0) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $7bad3ba374b5e258$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;

});

parcelRegister("gbo8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $094c2ce3abc8686f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4zFcG = parcelRequire("4zFcG");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $j0pqC = parcelRequire("j0pqC");

const $094c2ce3abc8686f$var$CascadingSelectField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
    const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, $5uXOq.useMemo)(()=>(0, $j0pqC.transformToCascadingSelectOptions)(cascadingSelectOptions), [
        cascadingSelectOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zFcG.AsyncCascadingSelectEdit), {
        ...fieldProps,
        value: value,
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues,
        // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type '(e: SyntheticEvent<HTMLElement, Event>) => boolean'.
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        // @ts-expect-error - TS2322 - Type '(value: SelectedOption) => void' is not assignable to type '(value: SelectedOption, meta: null, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>'.
        onChange: onChange,
        isInvalid: false,
        autoFocus: autoFocus,
        areOptionsOnSameRow: false,
        isEditable: !isReadOnly && isEditable
    }));
};
var $094c2ce3abc8686f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCascadingSelectField),
    transformDefaultValue: $j0pqC.transformDefaultValue
})($094c2ce3abc8686f$var$CascadingSelectField);

});
parcelRegister("4zFcG", function(module, exports) {

$parcel$export(module.exports, "AsyncCascadingSelectEdit", () => $0a411cf33e78ceb6$export$7db21897d0716698);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kmnNN = parcelRequire("kmnNN");
const $0a411cf33e78ceb6$var$EMPTY_OBJECT = {};
const $0a411cf33e78ceb6$export$7db21897d0716698 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kmnNN.asyncCascadingSelectEditEntryPoint), // use stable object reference to avoid re-renders
    $0a411cf33e78ceb6$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-field-cascading-select-edit",
        packageName: "jira-issue-field-cascading-select",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("kmnNN", function(module, exports) {

$parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", () => $8f41019f840ae33a$export$336a3a4bd9539e41);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $8f41019f840ae33a$export$336a3a4bd9539e41 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eW4FG")).then((module)=>module.CascadingSelectViewEntryPointContent), {
        moduleId: "dba9fb26"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eW4FG", function(module, exports) {

let $adfa1b197796c7d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adfa1b197796c7d7$var$load("bhpAB").then(()=>parcelRequire('aKsI4'));

});



parcelRegister("j0pqC", function(module, exports) {

$parcel$export(module.exports, "transformToCascadingSelectOptions", () => $c7fead76ffb795b3$export$b06e6053830d7554);
$parcel$export(module.exports, "transformDefaultValue", () => $c7fead76ffb795b3$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutateCascadingSelectField", () => $c7fead76ffb795b3$export$f402e35d933d11b5);

const $c7fead76ffb795b3$export$facac75482a8e0c5 = (option)=>{
    const { value: value, id: id } = option || {};
    if (value && id) return {
        label: value,
        value: id
    };
    return null;
};
const $c7fead76ffb795b3$export$b06e6053830d7554 = (cascadingSelectData)=>{
    const allowedValues = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allowedChildValues = {};
    cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
        const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
        if (parentOptionValue !== null && transformedParentOption !== null) {
            allowedValues.push(transformedParentOption);
            allowedChildValues[parentOptionValue.id] = childOptionValues.map($c7fead76ffb795b3$export$facac75482a8e0c5);
        }
    });
    return {
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues
    };
};
const $c7fead76ffb795b3$export$e2f4e5d31db527cc = (defaultValue)=>{
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
    const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
    let transformedDefaultValue = null;
    if (transformedParentOption !== null) transformedDefaultValue = {
        ...transformedParentOption,
        child: childOptionValue ? $c7fead76ffb795b3$export$facac75482a8e0c5(childOptionValue) : undefined
    };
    return transformedDefaultValue;
};
const $c7fead76ffb795b3$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
        fieldId: fieldId,
        parentOptionValue: {
            optionId: selectedOption.value
        },
        // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
        childOptionValue: selectedOption.child ? {
            // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            optionId: selectedOption.child.value
        } : null,
        mutationGroup: (0, $4a7dfdb992f68644$export$31fd86f8f183952c)
    });

});
const $4a7dfdb992f68644$export$31fd86f8f183952c = 'cascadingSelectFields';



parcelRegister("hy8Vj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1139f036196a3fdd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6M0Pn = parcelRequire("6M0Pn");

var $exGcw = parcelRequire("exGcw");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

const $1139f036196a3fdd$var$CheckboxField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, error: error, allowedValues: allowedValues, fieldId: fieldId, isReadOnly: isReadOnly = false } = props;
    const options = (0, $exGcw.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6M0Pn.default), {
        options: options,
        values: value,
        onChange: onChange,
        isInvalid: Boolean(error),
        isDisabled: isReadOnly,
        fieldId: fieldId
    }));
};
var $1139f036196a3fdd$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCheckboxField),
    transformDefaultValue: (0, $exGcw.mapDataToOptions)
})($1139f036196a3fdd$var$CheckboxField);

});
parcelRegister("6M0Pn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9602fd0261806d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $hp1g9 = parcelRequire("hp1g9");

var $exGcw = parcelRequire("exGcw");
const $6a9602fd0261806d$var$CheckboxGroupEdit = (props)=>{
    const { values: values, options: options, isDisabled: isDisabled = false, onChange: onChange, isInvalid: isInvalid, fieldId: fieldId } = props;
    const onChangeCheckedItems = (event)=>{
        const itemValue = event.target.value;
        const retainValue = (0, $exGcw.setRetainValue)({
            options: options,
            itemValue: itemValue,
            values: values
        });
        onChange(retainValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, options?.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hp1g9.default), {
            name: fieldId,
            key: option.value
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
                ...fieldProps,
                key: option.value,
                value: option.value,
                label: option.label,
                isChecked: values?.some((data)=>data.value === option.value),
                onChange: onChangeCheckedItems,
                isInvalid: isInvalid,
                isDisabled: isDisabled
            }))));
};
var $6a9602fd0261806d$export$2e2bcd8739ae039 = $6a9602fd0261806d$var$CheckboxGroupEdit;

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = null; /**
                              * __Checkbox__
                              *
                              * A checkbox an input control that allows a user to select one or more options from a number of choices.
                              *
                              * - [Examples](https://atlassian.design/components/checkbox/examples)
                              * - [Code](https://atlassian.design/components/checkbox/code)
                              * - [Usage](https://atlassian.design/components/checkbox/usage)
                              */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt",
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("hp1g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccbe97401ecc0bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
$9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;

});

parcelRegister("exGcw", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $8df41448adf6bbfb$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $8df41448adf6bbfb$export$ffef3a401aef987b);
$parcel$export(module.exports, "setRetainValue", () => $8df41448adf6bbfb$export$7f2b89a121299348);
const $8df41448adf6bbfb$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $8df41448adf6bbfb$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));
const $8df41448adf6bbfb$export$7f2b89a121299348 = ({ options: options, itemValue: itemValue, values: values })=>{
    const selectedOption = options?.find((option)=>option.value === itemValue);
    let retainValue = [
        ...values || []
    ];
    let isElementAlreadyChecked = false;
    const newCheckedItems = values?.filter((item)=>{
        if (item.value === itemValue) isElementAlreadyChecked = true;
        return item.value !== itemValue;
    });
    if (isElementAlreadyChecked && newCheckedItems !== undefined) retainValue = newCheckedItems;
    else if (selectedOption) retainValue.push(selectedOption);
    return retainValue;
};

});



parcelRegister("bN8Bv", function(module, exports) {

$parcel$export(module.exports, "mutateCheckboxField", () => $48bc647953349865$export$23a688ac1e0973b5);

const $48bc647953349865$export$23a688ac1e0973b5 = (values, fieldId)=>{
    const transformedValues = values.map(({ value: value })=>({
            optionId: value
        }));
    return {
        fieldId: fieldId,
        mutationGroup: (0, $c120cee24f2c37b0$export$31fd86f8f183952c),
        options: transformedValues
    };
};

});
const $c120cee24f2c37b0$export$31fd86f8f183952c = 'multipleSelectFields';


parcelRegister("htVqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e8bfaa21e37b81$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iqVnL = parcelRequire("iqVnL");

var $7ZmbO = parcelRequire("7ZmbO");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");
const $f0e8bfaa21e37b81$var$CmdbField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, additionalData: { isMulti: isMulti = false, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch }, fieldProps: { value: value, onChange: onChange }, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, selectedProject: selectedProject, autoFocus: autoFocus = false, width: width, fieldId: fieldId, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ZmbO.LimitData), {
        limitProperty: (0, $7ZmbO.MAX_CMDB_OBJECTS_PER_FIELD)
    }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqVnL.CmdbFieldObjectPicker), {
            autoCompleteUrl: `${autoCompleteUrl}?`,
            displayedValues: value,
            selectedValues: value,
            attributesToDisplayInSearch: attributesIncludedInAutoCompleteSearch,
            multiple: isMulti,
            onChange: onChange,
            autoFocus: autoFocus,
            limit: limit,
            menuPosition: "fixed",
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll),
            contextAndValuesOfIssueBeingCreated: {
                ...contextAndValuesOfIssueBeingCreated,
                fieldId: fieldId,
                selectedProject: selectedProject
            },
            ariaLabelledBy: ariaLabelledBy
        })));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<CmdbFieldConfig, FieldValue>, any>'.
$f0e8bfaa21e37b81$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({})($f0e8bfaa21e37b81$var$CmdbField);

});
parcelRegister("iqVnL", function(module, exports) {

$parcel$export(module.exports, "CmdbFieldObjectPicker", () => $d3cb5af84ef48897$export$2c337ae5a2979962);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $lE3p8 = parcelRequire("lE3p8");

var $3j1Hg = parcelRequire("3j1Hg");

var $johYW = parcelRequire("johYW");

var $8K3pq = parcelRequire("8K3pq");

var $dVEoL = parcelRequire("dVEoL");

var $4EFpF = parcelRequire("4EFpF");

var $cwlnA = parcelRequire("cwlnA");

var $3FZpe = parcelRequire("3FZpe");

var $iPF9E = parcelRequire("iPF9E");
const $d3cb5af84ef48897$export$f3d4a8207a9d907f = (attributesToDisplayInSearch)=>(cmdbObject)=>{
        const getDisplayValuesFromAttribute = (attribute)=>attribute.objectAttributeValues.map((val)=>val.displayValue).join(' ');
        // This label is the string value that @atlaskit/select uses under the hood
        // to determine a 'match' when typing in the select field. Therefore, we need to
        // build a string that includes values for all the attributes marked as
        // 'searchable' within the Insight field configuration.
        const searchableLabel = cmdbObject.attributes.map((attribute)=>{
            if (// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            attributesToDisplayInSearch.includes(attribute.objectTypeAttribute.name) || attributesToDisplayInSearch.includes('Label') && attribute.objectTypeAttribute.label === true) return getDisplayValuesFromAttribute(attribute);
            return undefined;
        }).filter(Boolean).join(' ');
        // Label should fall back to the label attribute of the object if it doesn't contain any of the search attributes
        return {
            value: cmdbObject.id,
            label: searchableLabel || cmdbObject.label,
            rawData: cmdbObject
        };
    };
const $d3cb5af84ef48897$export$cc2466dccf2cb27d = (values)=>{
    if (!values) return values;
    return values.map((x)=>({
            label: x.label,
            value: x.objectId,
            rawData: x
        }));
};
const $d3cb5af84ef48897$export$2c337ae5a2979962 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasConfigError = !props.attributesToDisplayInSearch?.length; // null, undefined or empty is a config error
    const { autoCompleteUrl: autoCompleteUrl, attributesToDisplayInSearch: attributesToDisplayInSearch = [], multiple: multiple = false, displayedValues: displayedValues, selectedValues: selectedValues = [], onChange: propsOnChange, issueId: issueId, limit: limit, autoFocus: autoFocus, menuPosition: menuPosition = 'absolute', onCloseMenuOnScroll: onCloseMenuOnScroll, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const fetchCmdbObjects = (searchValue)=>{
        if (typeof autoCompleteUrl === 'string' && autoCompleteUrl) return (0, $8K3pq.searchCmdbObjects)(autoCompleteUrl, searchValue, issueId, (0, $lE3p8.extractFieldValueMap)(contextAndValuesOfIssueBeingCreated));
        throw new Error('Invalid URL');
    };
    const transformObjectToSelectOption = (0, $5uXOq.useMemo)(()=>$d3cb5af84ef48897$export$f3d4a8207a9d907f(attributesToDisplayInSearch), [
        attributesToDisplayInSearch
    ]);
    const { selectProps: selectProps, error: error, totalNumberOfResults: totalNumberOfResults } = (0, $3j1Hg.usePaginatedAutocomplete)(selectedValues, fetchCmdbObjects, transformObjectToSelectOption, contextAndValuesOfIssueBeingCreated);
    const numberOfSearchResults = (totalNumberOfResults ?? 0) >= (0, $johYW.MAX_OBJECT_COUNT_CUTOFF) ? `${0, $johYW.MAX_OBJECT_COUNT_CUTOFF}+` : totalNumberOfResults;
    const selectPropsWithLabel = selectProps && Object.keys(selectProps).length && {
        ...selectProps,
        options: [
            {
                label: formatMessage((0, $3FZpe.default).dropdownNumberOfSearchResultsLabel, {
                    numberOfSearchResults: numberOfSearchResults,
                    isLoading: selectProps.isLoading
                }),
                options: selectProps.options
            }
        ]
    };
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onChange = (0, $5uXOq.useCallback)((selectedOption)=>{
        if (!selectedOption) {
            propsOnChange([]);
            return;
        }
        if (Array.isArray(selectedOption)) propsOnChange(selectedOption.map((x)=>x.rawData));
        if (!Array.isArray(selectedOption)) propsOnChange([
            selectedOption.rawData
        ]);
    }, [
        propsOnChange
    ]);
    const showGenericErrorFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $3FZpe.default).errorTitleCmdbAssets),
            description: formatMessage((0, $3FZpe.default).errorMessage),
            isAutoDismiss: true,
            messageId: 'servicedesk-cmdb-field-object-picker.ui.show-flag.error.error-title-cmdb-assets',
            messageType: 'transactional'
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const responseErrorHandler = (0, $5uXOq.useMemo)(()=>({
            404: ()=>showGenericErrorFlag(),
            400: ()=>showFlag({
                    type: 'error',
                    title: formatMessage((0, $3FZpe.default).errorTitleCmdbFieldSearch),
                    description: formatMessage((0, $3FZpe.default).errorMessageCmdbFieldSearch),
                    isAutoDismiss: true,
                    messageId: 'servicedesk-cmdb-field-object-picker.ui.show-flag.error.error-title-cmdb-field-search',
                    messageType: 'transactional'
                })
        }), [
        formatMessage,
        showFlag,
        showGenericErrorFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) responseErrorHandler[error.statusCode] ? responseErrorHandler[error.statusCode]() : showGenericErrorFlag();
    }, [
        error,
        responseErrorHandler,
        showGenericErrorFlag
    ]);
    const { Option: Option } = (0, $bChGW.components);
    const customComponents = (0, $5uXOq.useMemo)(()=>({
            // @ts-expect-error - TS7006 - Parameter 'optionProps' implicitly has an 'any' type.
            Option: (optionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Option, optionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EFpF.CmdbSelectOption), {
                    label: optionProps.label,
                    data: optionProps.data,
                    selectProps: optionProps.selectProps,
                    attributesToDisplayInSearch: attributesToDisplayInSearch
                }))
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        attributesToDisplayInSearch
    ]);
    const singleObjectReached = !multiple && selectedValues.length === 1;
    const singleObjectExceeded = !multiple && selectedValues.length > 1;
    const objectLimitReached = selectedValues.length === limit;
    const objectLimitExceeded = selectedValues.length > limit;
    const shouldShowSelect = (multiple || selectedValues.length === 0) && selectedValues.length < limit;
    const getMessages = (objectLimit)=>{
        const validationMessages = [];
        singleObjectExceeded && validationMessages.push({
            label: 'warning',
            messageContent: formatMessage((0, $3FZpe.default).warningMultipleObjectsMessage)
        });
        objectLimitExceeded && validationMessages.push({
            label: 'warning',
            messageContent: formatMessage((0, $3FZpe.default).warningObjectLimitExceeded, {
                objectLimit: objectLimit
            })
        });
        singleObjectReached && validationMessages.push({
            label: 'info',
            messageContent: formatMessage((0, $3FZpe.default).infoSingleObjectMessage)
        });
        objectLimitReached && validationMessages.push({
            label: 'info',
            messageContent: formatMessage((0, $3FZpe.default).infoObjectLimitReached, {
                objectLimit: objectLimit
            })
        });
        return validationMessages.length > 0 ? [
            validationMessages[0]
        ] : [];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId
    }, hasConfigError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVEoL.CmdbFieldError), {
        fieldId: contextAndValuesOfIssueBeingCreated?.fieldId
    }), !hasConfigError && (displayedValues || shouldShowSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        // Setting a value of null causes the field to go back to being empty after a selection is made
        value: $d3cb5af84ef48897$export$cc2466dccf2cb27d(displayedValues),
        isMulti: multiple,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '(selectedOption: OptionsType<CmdbObject> | OptionsType<CmdbObject>[]) => void' is not assignable to type '(value: OptionsType<CmdbObject> | OptionsType<...> | null, action: ActionMeta<...>) => void'.
        onChange: onChange,
        placeholder: formatMessage((0, $3FZpe.default).searchPlaceholder),
        components: customComponents,
        isClearable: true,
        menuPlacement: "auto",
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'MenuPosition | undefined'.
        menuPosition: menuPosition,
        // @ts-expect-error - TS2322 - Type '{ readonly menu: (base: CSSProperties) => { zIndex: 510; accentColor?: string | undefined; alignContent?: string | undefined; alignItems?: string | undefined; alignSelf?: string | undefined; alignmentBaseline?: string | undefined; ... 446 more ...; setProperty?: ((property: string, value: string | null, priority?: s...' is not assignable to type 'Partial<Styles<OptionsType<CmdbObject>, boolean, GroupTypeBase<OptionsType<CmdbObject>>>>'.
        styles: (0, $iPF9E.customStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        ...selectPropsWithLabel,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwlnA.EditMessage), {
        messages: getMessages(limit)
    }));
};

});
parcelRegister("lE3p8", function(module, exports) {

$parcel$export(module.exports, "extractFieldValueMap", () => $bb48dc0efc8689b7$export$fb98c8002c9a4960);

var $5fc53 = parcelRequire("5fc53");
const $bb48dc0efc8689b7$var$getStringValue = (fieldValues)=>fieldValues;
const $bb48dc0efc8689b7$var$getJoinedArray = (fieldValues)=>fieldValues.map(({ value: value })=>value).join(',');
const $bb48dc0efc8689b7$var$extractFieldValueMethods = {
    [(0, $5fc53.SUMMARY_TYPE)]: $bb48dc0efc8689b7$var$getStringValue,
    [(0, $5fc53.DUE_DATE_TYPE)]: $bb48dc0efc8689b7$var$getStringValue,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $bb48dc0efc8689b7$var$getJoinedArray,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $bb48dc0efc8689b7$var$getJoinedArray,
    [(0, $5fc53.COMPONENTS_TYPE)]: $bb48dc0efc8689b7$var$getJoinedArray,
    [(0, $5fc53.ASSIGNEE_TYPE)]: ({ accountId: accountId })=>accountId,
    [(0, $5fc53.REPORTER_TYPE)]: ({ id: id })=>id,
    [(0, $5fc53.PRIORITY_TYPE)]: ({ value: value })=>value,
    [(0, $5fc53.RESOLUTION_TYPE)]: ({ value: value })=>value,
    [(0, $5fc53.CMDB_OBJECT_CF_TYPE)]: (fieldValues)=>fieldValues.map(({ workspaceId: workspaceId, objectId: objectId })=>`${workspaceId}:${objectId}`).join(',')
};
const $bb48dc0efc8689b7$var$extractIssueTypeValue = (selectedIssueType)=>selectedIssueType.type === 'REQUEST_TYPE' ? selectedIssueType.issueTypeId : selectedIssueType.value;
const $bb48dc0efc8689b7$export$fb98c8002c9a4960 = (contextAndValues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    if (contextAndValues) {
        const { getFormState: getFormState, fieldConfig: fieldConfig, selectedProject: selectedProject, selectedIssueType: selectedIssueType } = contextAndValues;
        const formData = getFormState().values;
        Object.keys(formData).forEach((fieldId)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: (fieldValues: string) => string; readonly duedate: (fieldValues: string) => string; readonly versions: (fieldValues: Options | VersionOption[]) => string; ... 6 more ...; readonly "com.atlassian.jira.plugins.cmdb:cmdb-object-cftype": (fieldValues: CmdbObject[]) => string; }'.
            const extractFieldValue = $bb48dc0efc8689b7$var$extractFieldValueMethods[fieldConfig[fieldId]?.fieldType];
            const fieldValues = formData[fieldId];
            if (extractFieldValue && fieldValues) result[fieldId] = extractFieldValue(fieldValues);
        });
        if (selectedProject) result.pid = selectedProject.value;
        if (selectedIssueType) result.issuetype = $bb48dc0efc8689b7$var$extractIssueTypeValue(selectedIssueType);
    }
    return result;
};

});

parcelRegister("3j1Hg", function(module, exports) {

$parcel$export(module.exports, "usePaginatedAutocomplete", () => $dd937729ff146f44$export$6e13ec0c80bdfaa8);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $kEqrP = parcelRequire("kEqrP");

var $lE3p8 = parcelRequire("lE3p8");

var $6xC0V = parcelRequire("6xC0V");
const $dd937729ff146f44$var$filterOutAlreadySelectedOptionFromAvailableOptions = (availableOptions, optionsToRemove)=>availableOptions.filter((optionFromRequest)=>!optionsToRemove.find((selectedOption)=>selectedOption.id === optionFromRequest.id));
const $dd937729ff146f44$var$addOrReplaceNewResults = (action, optionsToSave)=>(oldOptions)=>{
        switch(action){
            case (0, $6xC0V.Actions).APPEND:
                return [
                    ...oldOptions,
                    ...optionsToSave
                ];
            case (0, $6xC0V.Actions).REPLACE:
            default:
                return optionsToSave;
        }
    };
const $dd937729ff146f44$var$calculateNumberOfResults = (totalNumberOfResults, savedResultFromTheSearch, displayedOptions)=>{
    if (totalNumberOfResults) return totalNumberOfResults - (savedResultFromTheSearch.length - displayedOptions.length);
    return totalNumberOfResults;
};
const $dd937729ff146f44$export$6e13ec0c80bdfaa8 = (selectedResults, doFetch, transform, contextAndValuesOfIssueBeingCreated)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [savedResultFromTheSearch, setSavedResultFromTheSearch] = (0, $5uXOq.useState)([]);
    const [hasUserEnteredTextForLastSearch, setHasUserEnteredTextForLastSearch] = (0, $5uXOq.useState)(undefined);
    const [totalNumberOfResults, setTotalNumberOfResults] = (0, $5uXOq.useState)();
    const [error, setError] = (0, $5uXOq.useState)();
    const fetchNextPageRef = (0, $5uXOq.useRef)();
    const isMenuOpen = (0, $5uXOq.useRef)(false);
    const oldContextRef = (0, $5uXOq.useRef)();
    const fetchSearchResults = async (fetchFunction, action)=>{
        setIsLoading(true);
        try {
            const { results: results, fetchNextPage: nextPageFunction, total: total } = await fetchFunction();
            setTotalNumberOfResults(total);
            const newOptions = $dd937729ff146f44$var$filterOutAlreadySelectedOptionFromAvailableOptions(results, selectedResults);
            if (newOptions.length === 0 && nextPageFunction) await fetchSearchResults(nextPageFunction, (0, $6xC0V.Actions).APPEND);
            else fetchNextPageRef.current = nextPageFunction;
            setSavedResultFromTheSearch($dd937729ff146f44$var$addOrReplaceNewResults(action, results));
            (0, $kEqrP.autocompleteInsightFieldExperience).success();
            setIsLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            fetchNextPageRef.current = undefined;
            (0, $kEqrP.autocompleteInsightFieldExperience).failure();
            if (err && err.name === 'AbortError') return;
            setError(err);
            setIsLoading(false);
        }
    };
    const onInputChange = (searchValue, type)=>{
        // Fetch search results not triggered on selection of object
        if (type.action === 'input-change') {
            (0, $kEqrP.autocompleteInsightFieldExperience).start();
            setHasUserEnteredTextForLastSearch(searchValue !== '');
            fetchSearchResults(()=>doFetch(searchValue), (0, $6xC0V.Actions).REPLACE);
        }
    };
    const debouncedOnInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onInputChange, 400);
    const onMenuScrollToBottom = async ()=>{
        if (fetchNextPageRef.current) {
            (0, $kEqrP.autocompleteInsightFieldExperience).start();
            await fetchSearchResults(fetchNextPageRef.current, (0, $6xC0V.Actions).APPEND);
        }
    };
    const hasContextChanged = (currentContext)=>{
        const fieldId = contextAndValuesOfIssueBeingCreated?.fieldId;
        const oldContext = oldContextRef.current;
        if (!oldContext || !currentContext) return false;
        const currentContextKeys = Object.keys(currentContext);
        const oldContextKeys = Object.keys(oldContext);
        if (currentContextKeys.length !== oldContextKeys.length) return true;
        for(let i = 0; i < currentContextKeys.length; i += 1){
            const key = currentContextKeys[i];
            const value1 = currentContext[key];
            const value2 = oldContext[key];
            const isCheckingValueOfCurrentField = fieldId === key;
            if (!isCheckingValueOfCurrentField && value1 !== value2) return true;
        }
        return false;
    };
    const onMenuOpen = async ()=>{
        if (!isMenuOpen.current) {
            isMenuOpen.current = true;
            (0, $kEqrP.autocompleteInsightFieldExperience).start();
            const currentContext = (0, $lE3p8.extractFieldValueMap)(contextAndValuesOfIssueBeingCreated);
            if (hasUserEnteredTextForLastSearch !== false || hasContextChanged(currentContext)) {
                await fetchSearchResults(()=>doFetch(''), (0, $6xC0V.Actions).REPLACE);
                setHasUserEnteredTextForLastSearch(false);
                oldContextRef.current = currentContext;
            } else (0, $kEqrP.autocompleteInsightFieldExperience).success();
        }
    };
    const onMenuClose = ()=>{
        isMenuOpen.current = false;
    };
    const displayedOptions = (0, $5uXOq.useMemo)(()=>$dd937729ff146f44$var$filterOutAlreadySelectedOptionFromAvailableOptions(savedResultFromTheSearch, selectedResults).map(transform), [
        savedResultFromTheSearch,
        selectedResults,
        transform
    ]);
    return {
        error: error,
        selectProps: {
            isLoading: isLoading,
            options: displayedOptions,
            onInputChange: debouncedOnInputChange,
            onMenuScrollToBottom: onMenuScrollToBottom,
            onMenuOpen: onMenuOpen,
            onMenuClose: onMenuClose
        },
        totalNumberOfResults: $dd937729ff146f44$var$calculateNumberOfResults(totalNumberOfResults, savedResultFromTheSearch, displayedOptions)
    };
};

});
parcelRegister("6xC0V", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $660633281bd3e7e6$export$b52183d5cfb26dc9);
const $660633281bd3e7e6$export$b52183d5cfb26dc9 = Object.freeze({
    APPEND: 'APPEND',
    REPLACE: 'REPLACE'
});

});


parcelRegister("johYW", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS", () => $0761f987dd69a755$export$3d2246e48d9cfed3);
$parcel$export(module.exports, "DATE_VALUE_FORMAT", () => $0761f987dd69a755$export$d1fb6689cfa66d9b);
$parcel$export(module.exports, "TIME_VALUE_FORMAT", () => $0761f987dd69a755$export$5f2ab89513b5926a);
$parcel$export(module.exports, "ZONE_VALUE_FORMAT", () => $0761f987dd69a755$export$5c2d6de3ca9adcbe);
$parcel$export(module.exports, "GENERAL_DATE_TIME_FORMAT", () => $0761f987dd69a755$export$defafc11b2455f78);
$parcel$export(module.exports, "SCREEN_READER_DATE_TIME_FORMAT", () => $0761f987dd69a755$export$f61f3fa9ed38719a);
$parcel$export(module.exports, "globalErrorContexts", () => $0761f987dd69a755$export$b896d7bac8b72b0);
$parcel$export(module.exports, "MAX_OBJECT_COUNT_CUTOFF", () => $0761f987dd69a755$export$89b103afe26b1ad0);
/**
 * When there is a `textarea` type attribute on an object, the user can enter rich text that
 * is saved and transferred as raw HTML. Because of this, we need to sanitize the input
 * before rendering it to prevent XSS. The below is the allowlist of HTML tags we're expecting
 * to receieve from the editor. All other tags will be stripped out before rendering.
 */ const $0761f987dd69a755$export$3d2246e48d9cfed3 = [
    'p',
    'u',
    'a',
    'em',
    'strong',
    'span',
    'ol',
    'ul',
    'li',
    'pre',
    'code',
    'h2',
    'h3',
    'h4',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td'
];
const $0761f987dd69a755$export$d1fb6689cfa66d9b = 'yyyy-MM-dd';
const $0761f987dd69a755$export$5f2ab89513b5926a = 'HH:mm';
const $0761f987dd69a755$export$5c2d6de3ca9adcbe = 'XXX';
const $0761f987dd69a755$export$defafc11b2455f78 = 'dd/MMM/yy h:mm a';
const $0761f987dd69a755$export$f61f3fa9ed38719a = 'do MMMM Y h:mm a';
const $0761f987dd69a755$export$b896d7bac8b72b0 = [
    'objectsLimit',
    'objectTypeAttributesLimit',
    'objectSchemaLimit'
];
const $0761f987dd69a755$export$89b103afe26b1ad0 = 1000;

});

parcelRegister("8K3pq", function(module, exports) {

$parcel$export(module.exports, "searchCmdbObjects", () => $1ffad36294955285$export$24be3d709330b09);

var $7f4tk = parcelRequire("7f4tk");
const $1ffad36294955285$var$RESULTS_PER_PAGE = 50;
// @ts-expect-error - TS7031 - Binding element 'size' implicitly has an 'any' type. | TS7031 - Binding element 'hasNextPage' implicitly has an 'any' type. | TS7031 - Binding element 'results' implicitly has an 'any' type. | TS7031 - Binding element 'total' implicitly has an 'any' type.
const $1ffad36294955285$var$transform = ({ size: size, hasNextPage: hasNextPage, results: results, total: total })=>({
        size: size,
        hasNextPage: hasNextPage,
        // @ts-expect-error - TS7006 - Parameter 'entry' implicitly has an 'any' type.
        results: results.map((entry)=>({
                ...entry,
                // @ts-expect-error - TS7006 - Parameter 'att' implicitly has an 'any' type.
                attributes: entry.attributes.map((att)=>({
                        ...att,
                        type: att.objectTypeAttribute.type
                    }))
            })),
        total: total
    });
let $1ffad36294955285$var$abortController = null;
const $1ffad36294955285$export$24be3d709330b09 = async (autoCompleteUrl, query, issueId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldValueMap, page = 0)=>{
    if ($1ffad36294955285$var$abortController && $1ffad36294955285$var$abortController.abort) $1ffad36294955285$var$abortController.abort();
    $1ffad36294955285$var$abortController = new AbortController();
    const result = await (0, $7f4tk.default)(`${autoCompleteUrl}start=${$1ffad36294955285$var$RESULTS_PER_PAGE * page}&limit=${$1ffad36294955285$var$RESULTS_PER_PAGE}`, {
        method: 'POST',
        body: JSON.stringify({
            query: query,
            issueId: issueId,
            fieldValueMap: fieldValueMap
        }),
        signal: $1ffad36294955285$var$abortController.signal
    }).then($1ffad36294955285$var$transform);
    return {
        results: result.results,
        fetchNextPage: result.hasNextPage ? ()=>$1ffad36294955285$export$24be3d709330b09(autoCompleteUrl, query, issueId, fieldValueMap, page + 1) : undefined,
        total: result.total
    };
};

});

parcelRegister("dVEoL", function(module, exports) {

$parcel$export(module.exports, "CmdbFieldError", () => $852edac7ba234595$export$bd2288ff08a8a1d9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dD7Zc = parcelRequire("dD7Zc");

var $d2ta3 = parcelRequire("d2ta3");

var $koVbs = parcelRequire("koVbs");

var $ktP1V = parcelRequire("ktP1V");

var $04BO2 = parcelRequire("04BO2");

var $ahEft = parcelRequire("ahEft");

var $9OXo1 = parcelRequire("9OXo1");

var $3HIwk = parcelRequire("3HIwk");
const $852edac7ba234595$var$UpgradeToPremiumLink = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: (0, $04BO2.getJsmChangeEditionUrl)(),
        target: "_blank"
    }, chunks);
const $852edac7ba234595$export$cf18a118761851fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$var$InlineMessageContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, children));
const $852edac7ba234595$export$eb21c278059498f8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $3HIwk.default).errorInvalidFieldConfig));
};
const $852edac7ba234595$export$22a4392f7c676bd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $3HIwk.default).errorInvalidFieldConfigDisabledCmdbAssets));
};
const $852edac7ba234595$export$14493edb463e15ea = ({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $3HIwk.default).errorInvalidFieldConfigAdmin)), fieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-field-error.button",
        appearance: "link",
        href: (0, $d2ta3.getConfigureCustomFieldUrl)(fieldId),
        target: "_blank"
    }, formatMessage((0, $3HIwk.default).errorInvalidFieldConfigAdminLink)));
};
const $852edac7ba234595$export$3d5c9691c28d309d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const notPremiumErrorAdmin = formatMessage((0, $3HIwk.default).errorInvalidFieldConfigDowngradedAdminCmdbAssets, {
        a: $852edac7ba234595$var$UpgradeToPremiumLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "span"
    }, notPremiumErrorAdmin);
};
const $852edac7ba234595$export$192152d4765eff13 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $3HIwk.default).errorUnknown));
};
const $852edac7ba234595$export$bd2288ff08a8a1d9 = (props)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const hasPremium = (0, $ahEft.isPremiumInstance)(tenantContext);
    const isCmdbEnabled = (0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
    const { isAdmin: isAdmin } = tenantContext;
    const errorBody = (0, $5uXOq.useMemo)(()=>{
        if (!isCmdbEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$22a4392f7c676bd6, null);
        if (hasPremium && !isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$eb21c278059498f8, null);
        if (hasPremium && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$14493edb463e15ea, {
            fieldId: props.fieldId
        });
        if (!hasPremium && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$3d5c9691c28d309d, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$192152d4765eff13, null);
    }, [
        hasPremium,
        isAdmin,
        isCmdbEnabled,
        props.fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$cf18a118761851fd, null, errorBody);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $852edac7ba234595$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $852edac7ba234595$var$InlineMessageContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ep9tidpf _1oh2idpf _9r1zidpf _99ztidpf _f5gaidpf _1m2uidpf _hstcidpf _9n9oidpf _1vkjeo28",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d2ta3", function(module, exports) {

$parcel$export(module.exports, "getAssociateFieldToScreensUrl", () => $d0ff6fbc6d047529$export$23b03b7fae19e4d9);
$parcel$export(module.exports, "getScreenUrl", () => $d0ff6fbc6d047529$export$f7bdae1f819aa43b);
$parcel$export(module.exports, "getTranslateCustomFieldUrl", () => $d0ff6fbc6d047529$export$d190ce44f97f903);
$parcel$export(module.exports, "getConfigureCustomFieldUrl", () => $d0ff6fbc6d047529$export$6e2455bbc376835a);
$parcel$export(module.exports, "getEditCustomFieldUrl", () => $d0ff6fbc6d047529$export$16e5d0ee7be5b38f);
$parcel$export(module.exports, "getDeleteCustomFieldUrl", () => $d0ff6fbc6d047529$export$45ccfea6f6fbf3cc);
$parcel$export(module.exports, "defaultQuery", () => $d0ff6fbc6d047529$export$c08de3b5cc335eeb);
$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $d0ff6fbc6d047529$export$ec93a669a20aa982);
$parcel$export(module.exports, "CUSTOM_FIELDS_TYPE", () => $d0ff6fbc6d047529$export$49b8e5da9a1d0738);
$parcel$export(module.exports, "ATLASSIAN_TEAM_CF_TYPE", () => $d0ff6fbc6d047529$export$d5f572ebd2c1f0d1);

var $1AqFL = parcelRequire("1AqFL");

const $d0ff6fbc6d047529$export$23b03b7fae19e4d9 = (id)=>`/secure/admin/AssociateFieldToScreens!default.jspa?fieldId=${id}`;
const $d0ff6fbc6d047529$export$f7bdae1f819aa43b = (screenId)=>`/secure/admin/ConfigureFieldScreen.jspa?id=${screenId}`;
const $d0ff6fbc6d047529$export$d190ce44f97f903 = (id)=>`/secure/admin/TranslateCustomField!default.jspa?id=${(0, $1AqFL.getTrimId)(id)}`;
const $d0ff6fbc6d047529$export$6e2455bbc376835a = (id)=>`/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${(0, $1AqFL.getTrimId)(id)}`;
const $d0ff6fbc6d047529$export$16e5d0ee7be5b38f = (id)=>`/secure/admin/EditCustomField!default.jspa?id=${(0, $1AqFL.getTrimId)(id)}`;
const $d0ff6fbc6d047529$export$45ccfea6f6fbf3cc = (id)=>`/secure/admin/DeleteCustomField!default.jspa?id=${(0, $1AqFL.getTrimId)(id)}`;
const $d0ff6fbc6d047529$export$c08de3b5cc335eeb = {
    searchFilter: undefined,
    customFieldStatus: (0, $794f056043a7eb6b$export$2b35adb71b3f6143)
};
const $d0ff6fbc6d047529$export$ec93a669a20aa982 = 15;
const $d0ff6fbc6d047529$export$49b8e5da9a1d0738 = 'custom';
const $d0ff6fbc6d047529$export$d5f572ebd2c1f0d1 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';

});
parcelRegister("1AqFL", function(module, exports) {

$parcel$export(module.exports, "getTrimId", () => $ea8bf3cf6c912eab$export$4817065c39922b39);
const $ea8bf3cf6c912eab$export$4817065c39922b39 = (id)=>id.split('_').reverse()[0];

});

const $794f056043a7eb6b$export$3c5e605ca7ade9f2 = 'NAME';
const $794f056043a7eb6b$export$965630dc71fb3a05 = 'LAST_USED';
const $794f056043a7eb6b$export$d5a7f00a6a604217 = 'SCREENS_AND_CONTEXTS';
const $794f056043a7eb6b$export$44d67b522cbcce6d = 'PROJECTS';
const $794f056043a7eb6b$export$421090ea46f71c9c = 'DELETED_ON';
const $794f056043a7eb6b$export$a7cd2db90465ec68 = 'PERMANENTLY_DELETING';
const $794f056043a7eb6b$export$2b35adb71b3f6143 = 'Active';
const $794f056043a7eb6b$export$f1ded5eab7e819b3 = 'Trashed';


parcelRegister("04BO2", function(module, exports) {

$parcel$export(module.exports, "getProjectUrl", () => $27b6cf49cbe4c1ee$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $27b6cf49cbe4c1ee$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $27b6cf49cbe4c1ee$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $27b6cf49cbe4c1ee$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $27b6cf49cbe4c1ee$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $27b6cf49cbe4c1ee$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $27b6cf49cbe4c1ee$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $27b6cf49cbe4c1ee$export$13f39b40814e5f3e);

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $l3Iek = parcelRequire("l3Iek");

var $cmEH1 = parcelRequire("cmEH1");

var $2iuKi = parcelRequire("2iuKi");

var $9VXkC = parcelRequire("9VXkC");
const $27b6cf49cbe4c1ee$export$951b86b8e730b952 = (projectKey)=>(0, $9VXkC.generatePath)((0, $2iuKi.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $27b6cf49cbe4c1ee$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $27b6cf49cbe4c1ee$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : `${$27b6cf49cbe4c1ee$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $27b6cf49cbe4c1ee$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $27b6cf49cbe4c1ee$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $27b6cf49cbe4c1ee$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $l3Iek.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $27b6cf49cbe4c1ee$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $27b6cf49cbe4c1ee$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("l3Iek", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $31816b9f42bcb36a$export$b03606cedffdadf6);
const $31816b9f42bcb36a$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});

parcelRegister("2iuKi", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $3aa0370b36d3207d$export$e6bc3ea427ddafb8);
const $3aa0370b36d3207d$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("3HIwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44be5fc5fa441b4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f44be5fc5fa441b4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorInvalidFieldConfig: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config",
        "defaultMessage": "This field needs to be configured with an object schema. Please contact your admin to configure this field."
    },
    errorInvalidFieldConfigAdmin: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin",
        "defaultMessage": "This field needs to be configured with an object schema."
    },
    errorInvalidFieldConfigAdminLink: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin-link",
        "defaultMessage": "Configure this custom field"
    },
    errorInvalidFieldConfigDowngradedAdminCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-downgraded-admin-cmdb-assets",
        "defaultMessage": "Assets is not available in this Jira instance. <a>Upgrade to Premium</a> to re-enable Assets and see this data."
    },
    errorInvalidFieldConfigDisabledCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-disabled-cmdb-assets",
        "defaultMessage": "Assets is not available in this Jira instance."
    },
    errorUnknown: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-unknown",
        "defaultMessage": "Something went wrong. Please refresh the page or contact your admin if the problem persists."
    }
});

});


parcelRegister("4EFpF", function(module, exports) {

$parcel$export(module.exports, "CmdbSelectOption", () => $3013101aa5c29dc3$export$a7be07965a3ed09b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bUUmN = parcelRequire("bUUmN");

var $4R6GH = parcelRequire("4R6GH");
const $3013101aa5c29dc3$export$fee117cd50d6234b = ({ match: match, children: children })=>{
    if (match === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    // we need to escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.toLowerCase() === match.toLowerCase()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong",
            key: i
        }, part);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: i
        }, part);
    }));
};
const $3013101aa5c29dc3$export$cd0f2f750043f4bc = (attributes)=>attributes.map(({ objectAttributeValues: objectAttributeValues })=>objectAttributeValues.map(({ displayValue: displayValue })=>displayValue).join(', ')).join(' | ');
const $3013101aa5c29dc3$export$a7be07965a3ed09b = ({ attributesToDisplayInSearch: attributesToDisplayInSearch, data: data, selectProps: selectProps, label: label })=>{
    // Casting to CmdbObject as typing gets lost when passed through AK Select
    const object = data.rawData;
    const { inputValue: inputValue } = selectProps;
    const displayedAttributes = (0, $5uXOq.useMemo)(()=>attributesToDisplayInSearch.map((attrName)=>attrName === 'Label' ? object.attributes.find((attr)=>attr.objectTypeAttribute.label) : object.attributes.find((attr)=>attr.objectTypeAttribute.name === attrName)).filter(Boolean), [
        object,
        attributesToDisplayInSearch
    ]);
    const primaryAttributeString = displayedAttributes?.[0]?.objectAttributeValues // @ts-expect-error - TS2349 - This expression is not callable.
    ?.filter((v)=>v.displayValue) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map((v)=>v.displayValue) // eslint-disable-line @typescript-eslint/no-explicit-any
    .join(', ') || label;
    const attributesString = $3013101aa5c29dc3$export$cd0f2f750043f4bc(displayedAttributes.slice(1));
    return (0, $4R6GH.fg)('modern_issue_transition_field_support_cmdb') ? // Fix double hover issue and transformed to Box and Stack to avoid using styled-components
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3013101aa5c29dc3$var$outerBoxStyles,
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3013101aa5c29dc3$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.MemoizedInsightIcon), {
        mediaClientConfig: object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48,
        label: object.label,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3013101aa5c29dc3$var$objectNameStyles,
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.object-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, primaryAttributeString)), attributesString && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3013101aa5c29dc3$var$attributesStyles,
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.attributes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, attributesString)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$Outer, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.MemoizedInsightIcon), {
        mediaClientConfig: object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48,
        label: object.label,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$ObjectName, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.object-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, primaryAttributeString)), attributesString && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$Attributes, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.attributes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, attributesString))));
};
const $3013101aa5c29dc3$var$outerBoxStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingRight: 'space.200',
    paddingBottom: 'space.100',
    paddingLeft: 'space.200'
});
const $3013101aa5c29dc3$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.150',
    flexShrink: 0
});
const $3013101aa5c29dc3$var$objectNameStyles = (0, $8CUq3.xcss)({
    font: 'font.body'
});
const $3013101aa5c29dc3$var$attributesStyles = (0, $8CUq3.xcss)({
    font: 'font.body.UNSAFE_small'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3013101aa5c29dc3$var$Outer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi _irr3166n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3013101aa5c29dc3$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxutpp _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3013101aa5c29dc3$var$ObjectName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _vwz41tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3013101aa5c29dc3$var$Attributes = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bUUmN", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $91b4a14cfc200b23$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $91b4a14cfc200b23$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $91b4a14cfc200b23$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");
var $iDZjq = parcelRequire("iDZjq");

var $kOLg6 = parcelRequire("kOLg6");

var $xJtdX = parcelRequire("xJtdX");
const $91b4a14cfc200b23$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $91b4a14cfc200b23$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $91b4a14cfc200b23$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $91b4a14cfc200b23$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const sizeInPx = (0, $vIiRg.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ $5uXOq.createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $5uXOq.createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $91b4a14cfc200b23$export$55641517b59933d7 = /*#__PURE__*/ (0, $5uXOq.memo)($91b4a14cfc200b23$export$4f72cced31fa9b94);
const $91b4a14cfc200b23$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91b4a14cfc200b23$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _1e0c1txw _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iDZjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b6b09c530db49a$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $31b6b09c530db49a$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $31b6b09c530db49a$var$styles = {
    root: "_2rko1q5u _189e1bk5 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    strongOpacity: "_tzy4clii"
};
const $31b6b09c530db49a$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $31b6b09c530db49a$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $31b6b09c530db49a$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$31b6b09c530db49a$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $bwpsq.default)([
            $31b6b09c530db49a$var$styles.root,
            $31b6b09c530db49a$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && $31b6b09c530db49a$var$borderRadiusMap[size ?? 'medium'],
            weight === 'strong' && $31b6b09c530db49a$var$styles.strongOpacity
        ])
    });
var $31b6b09c530db49a$export$2e2bcd8739ae039 = $31b6b09c530db49a$var$Skeleton;

});

parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYKm8.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");

var $VSDnB = parcelRequire("VSDnB");
const $eecef2c1b93fb3db$var$copyDivStyles = null;
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $VSDnB.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $bwpsq.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});

parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $cEHh7 = parcelRequire("cEHh7");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $cEHh7 = parcelRequire("cEHh7");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("8iz07"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8iz07", function(module, exports) {

let $60ab27a2818ad2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60ab27a2818ad2da$var$load("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("8u6C4"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("8u6C4", function(module, exports) {

let $019819d3d04dcea8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $019819d3d04dcea8$var$load("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);

var $VSDnB = parcelRequire("VSDnB");
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>(0, $VSDnB.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("cwlnA", function(module, exports) {

$parcel$export(module.exports, "EditMessage", () => $d889bb2f85ca1ba9$export$1951eb47789629cd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6tRzQ = parcelRequire("6tRzQ");

var $gb7Oz = parcelRequire("gb7Oz");
const $d889bb2f85ca1ba9$export$1951eb47789629cd = (props)=>{
    const renderMessage = (message, index)=>{
        switch(message.label){
            case 'warning':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$MessageContainer, {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gb7Oz))), {
                    spacing: "spacious",
                    label: "warning",
                    color: "var(--ds-icon-warning, #E56910)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$Message, null, message.messageContent));
            case 'info':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$MessageContainer, {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                    spacing: "spacious",
                    label: "info"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$Message, null, message.messageContent));
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.messages.map(renderMessage));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d889bb2f85ca1ba9$var$MessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz1gjq _1e0c1txw _4cvr1h6o _vwz41cnx",
            __cmplp.className
        ])
    });
});
const $d889bb2f85ca1ba9$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gb7Oz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77723dece3c67bedf7bcbbec84e5d004>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc73bc3d72b7857d$var$_react = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc73bc3d72b7857d$var$_warning = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("34Rrn")));

var $bc73bc3d72b7857d$var$_warning2 = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("hD8l9")));
function $bc73bc3d72b7857d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc73bc3d72b7857d$var$WarningIcon = (props)=>/*#__PURE__*/ $bc73bc3d72b7857d$var$_react.default.createElement($bc73bc3d72b7857d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $bc73bc3d72b7857d$var$_warning2.default
    }, props));
$bc73bc3d72b7857d$var$WarningIcon.Name = 'WarningIconMigration';
var $bc73bc3d72b7857d$var$_default = module.exports.default = $bc73bc3d72b7857d$var$WarningIcon;

});


parcelRegister("3FZpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $61831286213bf4fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61831286213bf4fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchPlaceholder: {
        "id": "servicedesk-cmdb-field-object-picker.search-placeholder",
        "defaultMessage": "Select or search for objects"
    },
    errorTitleCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-assets",
        "defaultMessage": "Could not fetch Assets objects"
    },
    errorMessage: {
        "id": "servicedesk-cmdb-field-object-picker.error-message",
        "defaultMessage": "Please refresh the page and try again"
    },
    errorTitleCmdbFieldSearch: {
        "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-field-search",
        "defaultMessage": "We couldn't fetch any objects for this field"
    },
    errorMessageCmdbFieldSearch: {
        "id": "servicedesk-cmdb-field-object-picker.error-message-cmdb-field-search",
        "defaultMessage": "Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid."
    },
    infoSingleObjectMessage: {
        "id": "servicedesk-cmdb-field-object-picker.info-single-object-message",
        "defaultMessage": "This field can only store a single object"
    },
    warningMultipleObjectsMessage: {
        "id": "servicedesk-cmdb-field-object-picker.warning-multiple-objects-message",
        "defaultMessage": "This field is configured to store a single object. Remove some objects to save changes."
    },
    infoObjectLimitReached: {
        "id": "servicedesk-cmdb-field-object-picker.info-object-limit-reached",
        "defaultMessage": "This field can only store {objectLimit, plural, one {# object} other {# objects}}."
    },
    warningObjectLimitExceeded: {
        "id": "servicedesk-cmdb-field-object-picker.warning-object-limit-exceeded",
        "defaultMessage": "This field is configured to store {objectLimit, plural, one {# object} other {# objects}}. Remove some objects to save changes."
    },
    dropdownNumberOfSearchResultsLabel: {
        "id": "servicedesk-cmdb-field-object-picker.dropdown-number-of-search-results-label",
        "defaultMessage": "{numberOfSearchResults} search {numberOfSearchResults, plural, one {result} other {results}} {isLoading, select, true {(refreshing)} other {}}"
    }
});

});

parcelRegister("iPF9E", function(module, exports) {

$parcel$export(module.exports, "customStyles", () => $45ba3e86982e6cb6$export$edf5b2501a573922);

var $gwIPs = parcelRequire("gwIPs");
const $45ba3e86982e6cb6$export$edf5b2501a573922 = {
    menu: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        }),
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        })
};

});


parcelRegister("7ZmbO", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $92269289c1fdd627$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $92269289c1fdd627$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $92269289c1fdd627$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $92269289c1fdd627$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $92269289c1fdd627$export$cb3888a8c43147d2);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $92269289c1fdd627$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $92269289c1fdd627$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $92269289c1fdd627$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $92269289c1fdd627$export$c5d8aa8a650e690f);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $92269289c1fdd627$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $92269289c1fdd627$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $92269289c1fdd627$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $92269289c1fdd627$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $92269289c1fdd627$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $92269289c1fdd627$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $92269289c1fdd627$export$5ed1d2ac050e39d = {
    [$92269289c1fdd627$export$dca2c2105b681490]: 30,
    [$92269289c1fdd627$export$a48ac34d39e0fc22]: 30,
    [$92269289c1fdd627$export$2e0ba662d5bb7742]: 300,
    [$92269289c1fdd627$export$eb69982aa3a172b4]: 30,
    [$92269289c1fdd627$export$cb3888a8c43147d2]: 20,
    [$92269289c1fdd627$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $92269289c1fdd627$var$limitCache = {};
const $92269289c1fdd627$export$c419786abd6faaad = (limitProperty)=>{
    delete $92269289c1fdd627$var$limitCache[limitProperty];
};
const $92269289c1fdd627$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$92269289c1fdd627$var$limitCache[limitProperty]) $92269289c1fdd627$var$limitCache[limitProperty] = (0, $7f4tk.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $92269289c1fdd627$export$c419786abd6faaad(limitProperty);
        (0, $2YZCu.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $92269289c1fdd627$var$limitCache[limitProperty];
};
class $92269289c1fdd627$export$9989835030ecd317 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $92269289c1fdd627$export$5ed1d2ac050e39d[limitProperty];
        $92269289c1fdd627$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args), this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $92269289c1fdd627$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92269289c1fdd627$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});


parcelRegister("1bQJO", function(module, exports) {

$parcel$export(module.exports, "transformCmdbField", () => $839547a6a65d7df8$export$3c3af8d272413d1c);
const $839547a6a65d7df8$export$3c3af8d272413d1c = (options)=>options.map((option)=>({
            id: option.id,
            objectId: option.objectId,
            workspaceId: option.workspaceId
        }));

});

parcelRegister("ilY3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $b763cc6cea94fc6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5bATF = parcelRequire("5bATF");

var $iHPnC = parcelRequire("iHPnC");

var $hpV4g = parcelRequire("hpV4g");

const $b763cc6cea94fc6a$var$ColorPickerField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bATF.ColorPicker), {
        value: value,
        onChange: onChange,
        showColorName: true
    });
};
var $b763cc6cea94fc6a$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $iHPnC.asColor)
})($b763cc6cea94fc6a$var$ColorPickerField);

});
parcelRegister("5bATF", function(module, exports) {

$parcel$export(module.exports, "ColorPicker", () => $3ec05ed007c980a7$export$9feb1bc2e5f1ccb3);
$parcel$export(module.exports, "ColorPickerWrapper", () => $3ec05ed007c980a7$export$3144fa159460e52e);
$parcel$export(module.exports, "ColorName", () => $3ec05ed007c980a7$export$93f3fcc778132720);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3zNHM = parcelRequire("3zNHM");

var $aWse0 = parcelRequire("aWse0");

var $heWHN = parcelRequire("heWHN");

var $3f8iY = parcelRequire("3f8iY");

var $31AKf = parcelRequire("31AKf");
const $3ec05ed007c980a7$var$popperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    -10,
                    5
                ]
            }
        }
    ]
};
const $3ec05ed007c980a7$export$9feb1bc2e5f1ccb3 = ({ value: color, showColorName: showColorName, onChange: onChange })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const colorPalette = (0, $3f8iY.getI18nColorPalette)(intl);
    const colorString = (0, $heWHN.MAP_COLORS_TO_VALUE)[color];
    const maybeColorLabel = colorPalette.filter((pcol)=>pcol.value === colorString)[0];
    const colorLabel = maybeColorLabel && maybeColorLabel.label || ''; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChangeHandler = (changedTo)=>{
        // changedTo is a CSS value string like '#FF7452', so we have to map it back to Color
        onChange((0, $heWHN.MAP_VALUE_TO_COLOR)[changedTo]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ec05ed007c980a7$export$3144fa159460e52e, {
        "data-testid": (0, $3f8iY.colorFieldDataTestId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3zNHM.default), {
        label: intl.formatMessage((0, $31AKf.default).label),
        palette: colorPalette,
        selectedColor: colorString,
        cols: colorPalette.length / 2,
        onChange: onChangeHandler,
        popperProps: $3ec05ed007c980a7$var$popperProps
    }), showColorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ec05ed007c980a7$export$93f3fcc778132720, null, colorLabel));
};
var $3ec05ed007c980a7$export$2e2bcd8739ae039 // Move 2px to the left to align with other components
 = $3ec05ed007c980a7$export$9feb1bc2e5f1ccb3;
const $3ec05ed007c980a7$export$3144fa159460e52e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _18u01i6y _ca0qu2gc _u5f3u2gc _4t3izwfg _z29hglyw",
            __cmplp.className
        ])
    });
});
$3ec05ed007c980a7$export$3144fa159460e52e.displayName = 'ColorPickerWrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3ec05ed007c980a7$export$93f3fcc778132720 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});
$3ec05ed007c980a7$export$93f3fcc778132720.displayName = 'ColorName';

});
parcelRegister("3zNHM", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $06f62cb25bd09d8d$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $06f62cb25bd09d8d$export$2e2bcd8739ae039);

var $3PpqK = parcelRequire("3PpqK");

var $kD00A = parcelRequire("kD00A");

var $lGTQx = parcelRequire("lGTQx");
const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);

});
parcelRegister("3PpqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f994db29f75e4622$export$2e2bcd8739ae039);
/* ColorPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $b9dFI = parcelRequire("b9dFI");

var $1ErJq = parcelRequire("1ErJq");

var $jKrb6 = parcelRequire("jKrb6");


var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $5dAp2 = parcelRequire("5dAp2");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $7oXeG = parcelRequire("7oXeG");
const $f994db29f75e4622$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $f994db29f75e4622$var$packageName = "platform-pkg";
const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill' } = this.props;
        const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9dFI.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: ref,
                    className: (0, $bwpsq.default)([
                        "_1e0c1o8l"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })
                }),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            label: fullLabel,
            value: value,
            components: $jKrb6,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            variant: variant,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown,
            ...(0, $VSDnB.fg)('one_event_rules_them_all_fg') && {
                onMenuOpen: this.props.onMenuOpen
            }
        });
    }
    constructor(...args){
        super(...args), this.createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit'), this.state = {
            isTabbing: false
        }, this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $f994db29f75e4622$var$packageName,
                    packageVersion: $f994db29f75e4622$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        }, this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        }, this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        }, this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
        }, this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, $8RXs9.default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: $f994db29f75e4622$var$packageName,
    packageVersion: $f994db29f75e4622$var$packageVersion
})((0, $cb25w.default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
const $f994db29f75e4622$var$colorCardWrapperStyles = null;

});
parcelRegister("1ErJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $609735830782207d$export$2e2bcd8739ae039);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $VSDnB = parcelRequire("VSDnB");
const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        /**
     * The 'platform_dst_layer_observer_select' feature flag updates `PopupSelect` to close itself when
     * the internal Select's `onMenuClose` prop is called.
     *
     * By moving focus to the trigger element after the select menu is open, it causes the select
     * menu to think it is being closed, and call its `onMenuClose` prop.
     *
     * This results in the PopupSelect instantly closing when the user clicks to open it.
     */ if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const isOutlineVariant = variant === 'outline';
    const colorCardStyles = isOutlineVariant ? {
        borderColor: value || 'grey'
    } : {
        backgroundColor: value || 'transparent'
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id,
            className: (0, $bwpsq.default)([
                "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                swatchSize === 'small' ? "_1bsb1tcg _4t3i1tcg _154i1i6y" : "_1bsbzwfg _4t3izwfg",
                "_nt751r31 _gk8x1r31 _49pcglyw _24ueglyw _1hvw1o36 _b4yv1o36 _858u1l4g _rslm1l4g _4cvxtxrc",
                expanded && !(0, $VSDnB.fg)('platform-design-system-dsp-20821-color-pickr-focus') && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1l4g"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: colorCardStyles,
                    className: (0, $bwpsq.default)([
                        isOutlineVariant ? "_2rkosqtm _189e1bk5 _1dqonqa1" : "_2rkosqtm _16qs16qq",
                        swatchSize === 'small' ? "_1bsb7vkz _4t3i7vkz" : "_1bsb1tcg _4t3i1tcg"
                    ])
                })
            })
        })
    });
};
var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
const $609735830782207d$var$sharedColorContainerStyles = null;
const $609735830782207d$var$smallColorContainerSize = null;
const $609735830782207d$var$defaultColorContainerSize = null;
const $609735830782207d$var$colorCardButtonStyles = null;
const $609735830782207d$var$colorCardButtonFocusedStyles = null;
const $609735830782207d$var$colorCardWrapperStyles = null;
const $609735830782207d$var$colorCardContentStyles = null;
const $609735830782207d$var$colorCardContentStylesOutline = null;
const $609735830782207d$var$smallColorCardContentSize = null;
const $609735830782207d$var$defaultColorCardContentSize = null;

});

parcelRegister("jKrb6", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $b794a85d007e2dce$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $b794a85d007e2dce$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $b794a85d007e2dce$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $b794a85d007e2dce$export$84712d0562a614b8);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");


var $koVbs = parcelRequire("koVbs");

var $7oXeG = parcelRequire("7oXeG");
const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ]),
        children: children
    });
};
const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        role: "radio",
        "aria-checked": isSelected,
        "aria-selected": undefined,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        })
    });
};
const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
const $b794a85d007e2dce$var$colorCardWrapperStyles = null;
const $b794a85d007e2dce$var$colorPaletteContainerStyles = null;

});
parcelRegister("l0sd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d681a23420d49946$export$2e2bcd8739ae039);
/* ColorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eJbwP = parcelRequire("eJbwP");

var $3bDjY = parcelRequire("3bDjY");



var $bWn3s = parcelRequire("bWn3s");
const $d681a23420d49946$var$ColorCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const isInitialFocus = (0, $5uXOq.useRef)(true);
    const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(event, value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onClick(event, value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    const isOutlineVariant = variant === 'outline';
    const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown,
                className: (0, $bwpsq.default)([
                    "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _1bsbzwfg _4t3izwfg _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && "_858uvmul _4cvxvmul",
                    focused && (isColorPaletteMenu || !isTabbing) && "_1h6dvmul"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: isOutlineVariant ? {
                            borderColor: value || 'grey'
                        } : {
                            backgroundColor: value || 'transparent'
                        },
                        className: (0, $bwpsq.default)([
                            "_2rkosqtm _1bsb1tcg _4t3i1tcg _16qs16qq",
                            isOutlineVariant && "_189e1bk5 _1dqonqa1 _16qsglyw"
                        ]),
                        children: selected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                            color: newCheckmarkColor,
                            label: "",
                            spacing: "spacious",
                            LEGACY_margin: "1px"
                        })
                    })
                })
            });
        }
    });
});
var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
const $d681a23420d49946$var$colorCardOptionTabbingStyles = null;
const $d681a23420d49946$var$colorCardOptionFocusedStyles = null;
const $d681a23420d49946$var$sharedColorContainerStyles = null;
const $d681a23420d49946$var$colorCardWrapperStyles = null;
const $d681a23420d49946$var$colorCardContentStyles = null;
const $d681a23420d49946$var$colorCardContentStylesOutline = null;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});

const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';


parcelRegister("5dAp2", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $38874a93fb14a10d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $38874a93fb14a10d$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $k5uoT = parcelRequire("k5uoT");


var $8QpSo = parcelRequire("8QpSo");

var $kD00A = parcelRequire("kD00A");
const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, $k5uoT.gridSize)() / 2);
    return mode === (0, $kD00A.Mode).Standard ? width + (0, $k5uoT.gridSize)() : width;
};
const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});
parcelRegister("kD00A", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $e25de60b37efd75a$export$9484bbecc3c49a2e);
var $e25de60b37efd75a$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});


parcelRegister("7oXeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42a6da5a6d06680$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});



parcelRegister("lGTQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e30770a4da4328$export$2e2bcd8739ae039);
/* ColorPaletteMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kD00A = parcelRequire("kD00A");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");

const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
    const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
    const handleChange = (event, value)=>{
        onChange(event, value, changeAnalyticsCaller());
    };
    (0, $5uXOq.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
            case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
            case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-label": fullLabel,
        role: isInsideMenu ? 'menu' : 'radiogroup',
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhk1bhr",
            mode === (0, $kD00A.Mode).Standard && "_2rkosqtm _16qs1akw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
                mode === (0, $kD00A.Mode).Compact && "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
            ]),
            children: options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
                        type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                        label: label,
                        value: value,
                        checkMarkColor: checkMarkColor,
                        isOption: true,
                        selected: value === selectedValue.value,
                        onClick: handleChange,
                        ref: (ref)=>{
                            colorCardRefs[index] = ref;
                        },
                        autoFocus: autoFocus,
                        initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                        isInsideMenu: isInsideMenu,
                        onKeyDown: handleKeyDown,
                        variant: variant
                    })
                }, value))
        })
    });
};
var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $cb25w.default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
const $c5e30770a4da4328$var$colorCardWrapperStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = null;

});


parcelRegister("3f8iY", function(module, exports) {

$parcel$export(module.exports, "colorFieldDataTestId", () => $fc41f338de3fb481$export$d5ae1babf783fed9);
$parcel$export(module.exports, "getI18nColorPalette", () => $fc41f338de3fb481$export$9ceccb3244ae7dac);

var $8QpSo = parcelRequire("8QpSo");

var $iHPnC = parcelRequire("iHPnC");
const $fc41f338de3fb481$export$d5ae1babf783fed9 = 'issue.views.issue-base.foundation.color.color-picker-wrapper';
const $fc41f338de3fb481$export$9ceccb3244ae7dac = (0, $8QpSo.default)(({ formatMessage: formatMessage })=>(0, $iHPnC.getDefaultColorPalette)(formatMessage));

});

parcelRegister("31AKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ddc856d47f5246$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55ddc856d47f5246$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "color-picker.edit.label",
        "defaultMessage": "Change color"
    }
});

});



parcelRegister("cUXq3", function(module, exports) {

$parcel$export(module.exports, "mutateEpicColorField", () => $197093e9d83b1af7$export$80288f09329d6da0);
$parcel$export(module.exports, "mutateIssueColorField", () => $197093e9d83b1af7$export$9e0b17281ec856bc);

var $iHPnC = parcelRequire("iHPnC");

const $197093e9d83b1af7$export$80288f09329d6da0 = (selectedColor, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $bb4032e21dd9602d$export$31fd86f8f183952c),
        color: {
            name: (0, $iHPnC.asClassicEpicColor)(selectedColor)
        }
    });
const $197093e9d83b1af7$export$9e0b17281ec856bc = (selectedColor, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $bb4032e21dd9602d$export$31fd86f8f183952c),
        color: {
            name: (0, $iHPnC.asServerColor)(selectedColor)
        }
    });

});
const $bb4032e21dd9602d$export$31fd86f8f183952c = 'colorFields';


parcelRegister("776me", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c3a95c2efe6aba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $hFon0 = parcelRequire("hFon0");

var $koVbs = parcelRequire("koVbs");

var $as9La = parcelRequire("as9La");

var $6Fkzt = parcelRequire("6Fkzt");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $b399U = parcelRequire("b399U");

const $f6c3a95c2efe6aba$var$ComponentsField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isDisabled = allowedValues.length === 0;
    const options = (0, $6Fkzt.mapDataToOptions)(allowedValues);
    const { projectKey: projectKey } = selectedProject || {};
    const projectKeyStr = projectKey || '';
    const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, $hFon0.useGlobalComponentsProperty)(projectKeyStr);
    const getComponentSelectEdit = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $as9La.default), {
            ...fieldProps,
            options: options,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            showFooter: false,
            projectKey: projectKeyStr,
            placeholder: isDisabled ? formatMessage((0, $b399U.default).none) : '',
            isDisabled: isDisabled || isReadOnly,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            canCreateNewItem: !areGlobalComponentsEnabled,
            inputId: id,
            isRequired: isRequired
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $b399U.default).tooltipWhenDisabled)
    }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $f6c3a95c2efe6aba$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $6Fkzt.mapDataToOptions),
    validator: (0, $jGVMX.validateComponentField),
    shouldRenderFieldMessage: false
})($f6c3a95c2efe6aba$var$ComponentsField);

});
parcelRegister("hFon0", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $e88d764a116eddca$export$a070f388fcd93df0);

var $5uXOq = parcelRequire("5uXOq");

var $do78Z = parcelRequire("do78Z");

var $feQhf = parcelRequire("feQhf");
function $e88d764a116eddca$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [enabled, setEnabled] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $5uXOq.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $5uXOq.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $feQhf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $feQhf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $do78Z.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("do78Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b15e5e3de311da0$export$2e2bcd8739ae039);

var $c3jsi = parcelRequire("c3jsi");

var $1AJVB = parcelRequire("1AJVB");
var $2b15e5e3de311da0$export$2e2bcd8739ae039 = (0, $c3jsi.default)((0, $1AJVB.props));

});
parcelRegister("c3jsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdca2a0bd8756d7$export$2e2bcd8739ae039);

var $8Op28 = parcelRequire("8Op28");
const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $8Op28.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $ccdca2a0bd8756d7$var$pNothing,
        update: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $ccdca2a0bd8756d7$var$pNothing
    };
};

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $2YZCu = parcelRequire("2YZCu");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $2YZCu.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';



parcelRegister("1AJVB", function(module, exports) {

$parcel$export(module.exports, "props", () => $68c0e7b1e3ad3adb$export$8128bb6492cf3de7);

const $68c0e7b1e3ad3adb$var$MAX_RESULTS = 10;
const $68c0e7b1e3ad3adb$var$CACHE_SIZE = $68c0e7b1e3ad3adb$var$MAX_RESULTS * 2;
const $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY = 'components';
const $68c0e7b1e3ad3adb$export$8128bb6492cf3de7 = {
    size: $68c0e7b1e3ad3adb$var$CACHE_SIZE,
    cacheKey: $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
};

});


parcelRegister("feQhf", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $f3ade48088ec15c3$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $f3ade48088ec15c3$export$71702a5b14caff65);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $f3ade48088ec15c3$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $f3ade48088ec15c3$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $f3ade48088ec15c3$var$getProjectId = async (projectKey)=>{
    const project = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $f3ade48088ec15c3$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $eusud.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $f3ade48088ec15c3$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $eusud.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("as9La", function(module, exports) {

$parcel$export(module.exports, "default", () => $974a261702eec2af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iOwNT = parcelRequire("iOwNT");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $2Icx9 = parcelRequire("2Icx9");

var $lMeVa = parcelRequire("lMeVa");
const $974a261702eec2af$var$ComponentsSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getNewInlineComponentCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, $lMeVa.default).createNewItem)})`, [
        formatNewInlineComponentCreateLabel,
        formatMessage
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
        const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
        return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
    }, [
        canCreateNewItem,
        options
    ]);
    const handleInlineComponentCreate = (inputValue)=>{
        onChange([
            ...value || [],
            {
                label: inputValue,
                value: null
            }
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
        inputId: inputId,
        required: isRequired,
        ...fieldProps,
        value: value,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2322 - Type 'Options' is not assignable to type 'readonly (Options | GroupBase<Options>)[]
        options: options,
        placeholder: placeholder || formatMessage((0, $lMeVa.default).placeholder),
        // @ts-expect-error - TS2322 - Type '(arg1: Options) => void' is not assignable to type '(value: OptionsType<{ label: string; value: string; }>, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: (menuListProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Icx9.default), {
                    ...menuListProps,
                    showFooter: showFooter,
                    projectKey: projectKey
                })
        },
        isMulti: true,
        isDisabled: isDisabled,
        isValidNewOption: isValidNewOption,
        formatCreateLabel: getNewInlineComponentCreateLabel,
        onCreateOption: handleInlineComponentCreate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "components-field-select" // added this for testing purpose, it doesn't apply any style
        ,
        classNamePrefix: "components-field-select"
    });
};
var $974a261702eec2af$export$2e2bcd8739ae039 = $974a261702eec2af$var$ComponentsSelectEdit;

});
parcelRegister("2Icx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b255b0441ea615$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $99M5v = parcelRequire("99M5v");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $dyW5a = parcelRequire("dyW5a");
const $b5b255b0441ea615$var$MenuWithFooter = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, restProps, children), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$fd9000017733fabf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$500fb058ad7aeb1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$e0513c91be1318ca, {
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: "componentFooterAddIcon",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$var$LinkText, null, footerLabel ?? formatMessage((0, $dyW5a.default).componentLabel))))));
};
var $b5b255b0441ea615$export$2e2bcd8739ae039 = $b5b255b0441ea615$var$MenuWithFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5b255b0441ea615$var$LinkText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$fd9000017733fabf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _1e0c1txw _2lx2vrvc _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$500fb058ad7aeb1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp _1bsb1osq _irr3166n",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$e0513c91be1318ca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyW5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ca6088d964e72a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86ca6088d964e72a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    componentLabel: {
        "id": "issue-field-components-field.edit.menu.component-label",
        "defaultMessage": "Create new component"
    }
});

});


parcelRegister("lMeVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb020ac6d54b422f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb020ac6d54b422f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-components-field.edit.placeholder",
        "defaultMessage": "Select Component"
    },
    createNewItem: {
        "id": "issue-field-components-field.edit.create-new-item",
        "defaultMessage": "New Component"
    }
});

});


parcelRegister("6Fkzt", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $4d2c67350b914b81$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $4d2c67350b914b81$export$ffef3a401aef987b);
const $4d2c67350b914b81$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $4d2c67350b914b81$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));

});

parcelRegister("b399U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31bbe63abb7b51a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $f31bbe63abb7b51a$var$messages = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.components-field.none",
        "defaultMessage": "None"
    },
    tooltipWhenDisabled: {
        "id": "issue-create-commons.components-field.tooltip-when-disabled",
        "defaultMessage": "We couldn't find any components for this project"
    }
});
var $f31bbe63abb7b51a$export$2e2bcd8739ae039 = $f31bbe63abb7b51a$var$messages;

});


parcelRegister("6vh1Z", function(module, exports) {

$parcel$export(module.exports, "mutateComponentsField", () => $6f4dd9dc2621c172$export$499415d02c5db090);
const $6f4dd9dc2621c172$export$499415d02c5db090 = (selectedComponents)=>({
        components: selectedComponents.reduce((acc, { value: value })=>{
            if (value !== null) acc.push({
                componentId: value
            });
            return acc;
        }, [])
    });

});

parcelRegister("iPfC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cafe98c17438b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $eb5hX = parcelRequire("eb5hX");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $9K1c2 = parcelRequire("9K1c2");

const $35cafe98c17438b5$export$c3b8fa1b9560fb7e = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eb5hX.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit());
};
var $35cafe98c17438b5$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCustomTeamsField),
    transformDefaultValue: (0, $9K1c2.transformDefaultTeam)
})($35cafe98c17438b5$export$c3b8fa1b9560fb7e);

});
parcelRegister("eb5hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $762657ba3faad803$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $blh8O = parcelRequire("blh8O");

var $b6swk = parcelRequire("b6swk");

var $ibWtm = parcelRequire("ibWtm");

var $jv74C = parcelRequire("jv74C");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $762657ba3faad803$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6swk.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $762657ba3faad803$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibWtm.default), props);
const $762657ba3faad803$var$CustomTeamPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const handleSearch = (0, $FtZX9.default)(async (query)=>(0, $jv74C.fetchTeams)(query || '', autoCompleteUrl), 300);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await handleSearch();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $blh8O.default).noMatches), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        fieldId: fieldId,
        ...defaultOptionsProps(),
        loadOptions: handleSearch,
        onChange: onChange,
        autoFocus: autoFocus,
        isClearable: Boolean(value),
        isMulti: false,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: $762657ba3faad803$var$MenuList,
            Option: $762657ba3faad803$var$Option
        },
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $762657ba3faad803$export$2e2bcd8739ae039 = $762657ba3faad803$var$CustomTeamPickerEdit;

});
parcelRegister("blh8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $47204223650b9e34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47204223650b9e34$var$messages = (0, $7VHMR.defineMessages)({
    menuHeader: {
        "id": "issue-field-custom-team.menu-header",
        "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
    },
    noMatches: {
        "id": "issue-field-custom-team.no-matches",
        "defaultMessage": "No Matches"
    },
    menuFooter: {
        "id": "issue-field-custom-team.menu-footer",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $47204223650b9e34$export$2e2bcd8739ae039 = $47204223650b9e34$var$messages;

});

parcelRegister("b6swk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d58b272b039ad0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $blh8O = parcelRequire("blh8O");
const $b7d58b272b039ad0$var$MenuListComponent = (props)=>{
    const { options: options } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$MenuFooterText, null, formatMessage((0, $blh8O.default).menuFooter)) : null;
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$Container, null, formatMessage((0, $blh8O.default).menuHeader)), props.children, footer));
};
var $b7d58b272b039ad0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b7d58b272b039ad0$var$MenuListComponent;
const $b7d58b272b039ad0$var$MenuFooterText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz131l _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $b7d58b272b039ad0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ibWtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bc7e69d2cb0c6a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $7KPXo = parcelRequire("7KPXo");
const $82bc7e69d2cb0c6a$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl, label: label } = value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: TeamFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionWrapper, null, avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$Icon, {
            src: avatarUrl,
            alt: label
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $82bc7e69d2cb0c6a$var$boxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7KPXo.default), {
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionText, null, props.children))));
    }
    return null;
};
var $82bc7e69d2cb0c6a$export$2e2bcd8739ae039 = $82bc7e69d2cb0c6a$var$OptionComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82bc7e69d2cb0c6a$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahv2br _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$OptionText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$boxStyle = (0, $8CUq3.xcss)({
    height: '16px',
    width: '16px',
    marginRight: 'space.100'
});

});
parcelRegister("7KPXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6eecaecb2670c4$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $dCLgq = parcelRequire("dCLgq");

var $6oKGV = parcelRequire("6oKGV");
const $6f6eecaecb2670c4$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6oKGV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6oKGV))
});
var $6f6eecaecb2670c4$export$2e2bcd8739ae039 = $6f6eecaecb2670c4$var$Illustration;
// for advanced use only
const $6f6eecaecb2670c4$export$a179c88182cb9d56 = [
    0,
    0,
    596,
    596
];

});
parcelRegister("6oKGV", function(module, exports) {
module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();

});



parcelRegister("jv74C", function(module, exports) {

$parcel$export(module.exports, "transformTeamFieldTypeString", () => $dbbd6d0fcad033b6$export$f7d628c77d5447d0);
$parcel$export(module.exports, "fetchTeams", () => $dbbd6d0fcad033b6$export$a789e725ac68b08d);

var $eusud = parcelRequire("eusud");
const $dbbd6d0fcad033b6$export$4accbe1c2fbc55dd = (team)=>({
        label: team.title,
        value: team.id.toString(),
        isShared: team.shareable,
        avatarUrl: team.avatarUrl
    });
const $dbbd6d0fcad033b6$export$f7d628c77d5447d0 = (team)=>{
    if (team) return team.value.toString();
    return null;
};
const $dbbd6d0fcad033b6$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
    const response = await (0, $eusud.performPostRequest)(autoCompleteUrl, {
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 100,
            query: query
        })
    });
    if (response) {
        const teams = response.teams.map($dbbd6d0fcad033b6$export$4accbe1c2fbc55dd);
        return [
            {
                moreResultsAvailable: response.moreResultsAvailable,
                options: teams
            }
        ];
    }
    return [];
};

});


parcelRegister("9K1c2", function(module, exports) {

$parcel$export(module.exports, "mutateTeamField", () => $e945ecd21dcd5234$export$8db32a33b76e5823);
$parcel$export(module.exports, "transformDefaultTeam", () => $e945ecd21dcd5234$export$d2d64eb763c850a1);

const $e945ecd21dcd5234$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $0a8c3ec56489edc2$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.value
        }
    } : null;
const $e945ecd21dcd5234$export$d2d64eb763c850a1 = (team)=>({
        label: team.name,
        value: team.teamId,
        isShared: true
    });

});
const $0a8c3ec56489edc2$export$31fd86f8f183952c = 'teamFields';



parcelRegister("2p4Te", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca41b2b247877065$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2x3Cb = parcelRequire("2x3Cb");

var $kgoHi = parcelRequire("kgoHi");

var $74sEg = parcelRequire("74sEg");

var $gwIPs = parcelRequire("gwIPs");

var $kErdU = parcelRequire("kErdU");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $7C5S0 = parcelRequire("7C5S0");

var $52tuV = parcelRequire("52tuV");
const $ca41b2b247877065$var$DataClassificationField = (props)=>{
    const { width: width, value: value, onChange: onChange, allowedValues: allowedValues, errorMessage: errorMessage, isDisabled: isDisabled, nonEditableReason: nonEditableReason } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const attributes = (0, $5uXOq.useMemo)(()=>({
            isDisabled: isDisabled
        }), [
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "dataClassificationField",
        packageName: "jiraIssueCreateCommons",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true,
        ...(0, $4R6GH.fg)('jira-issue-create-error-boundary-enabled') ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width,
        marginTop: (0, $gwIPs.gridSize) * 2.25,
        paddingBottom: (0, $gwIPs.gridSize) * 2.25
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "data-classification-dropdown-input",
        id: "data-classification-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "start"
    }, formatMessage((0, $52tuV.default).classificationFieldLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74sEg.DataClassificationDropdown), {
        options: allowedValues,
        value: value,
        onChange: onChange,
        isDisabled: isDisabled,
        disabledTooltipMessage: nonEditableReason?.message,
        errorMessage: errorMessage
    })));
};
var $ca41b2b247877065$export$2e2bcd8739ae039 = $ca41b2b247877065$var$DataClassificationField;

});

parcelRegister("iY8FG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f022abefd67c0e3c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $cHapz = parcelRequire("cHapz");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $6yeNV = parcelRequire("6yeNV");

var $4R6GH = parcelRequire("4R6GH");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9FL4D = parcelRequire("9FL4D");

var $jGVMX = parcelRequire("jGVMX");

var $eVzdP = parcelRequire("eVzdP");

const $f022abefd67c0e3c$export$845e1054649a85c2 = 0;
const $f022abefd67c0e3c$var$DateField = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
    const localeControl = (0, $DVljb.useNativeLocale)();
    const localeExperiment = (0, $DVljb.useLocale)();
    const standardisedLocaleExperiment = (0, $6yeNV.standardizeLocale)(localeExperiment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const weekStartDayControl = (0, $1p96B.getLocale)(localeControl)?.options?.weekStartsOn;
    const weekStartDayExperiment = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $1p96B.getLocale)(localeExperiment), 'options.weekStartsOn', $f022abefd67c0e3c$export$845e1054649a85c2);
    const safeValue = value === null ? undefined : value;
    const locale = (0, $4R6GH.fg)('consistency_in_date_time_pickers_of_gic_and_its') ? standardisedLocaleExperiment : localeControl;
    const weekStartDay = (0, $4R6GH.fg)('consistency_in_date_time_pickers_of_gic_and_its') ? weekStartDayExperiment : weekStartDayControl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
        value: safeValue,
        isDisabled: isReadOnly,
        onChange: onChange,
        autoFocus: autoFocus,
        locale: locale,
        isInvalid: Boolean(error),
        selectProps: {
            /**
      	Temporary fix to prevent form submit on enter press on an open calendar.
      	Ideally this should either be handled by atlaskit or keypress enter event should only be supressed when calendar is open.
      	There is no way to know if the calendar is open in the current implementation
      		Side Effect: Form will not submit on enter keyPress even when calendar is not open.
      */ onKeyDown: (0, $9FL4D.preventFormSubmitOnEnterKeyPress)
        },
        weekStartDay: weekStartDay,
        label: formatMessage((0, $eVzdP.default).ariaLabel),
        "aria-describedby": `${id}-helper`,
        id: id,
        placeholder: formatMessage((0, $eVzdP.default).placeholder),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $eVzdP.default).ariaLabel)
    }));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateFieldConfig, FieldValue>, any>'.
$f022abefd67c0e3c$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})($f022abefd67c0e3c$var$DateField);

});
parcelRegister("cHapz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a844b50b385d50f7$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");
const $a844b50b385d50f7$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $19201d0a1f7d7d54$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $19201d0a1f7d7d54$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $bwpsq.default)([
                $19201d0a1f7d7d54$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $5RLF6.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($19201d0a1f7d7d54$var$styles.iconContainerStyles, value && !hideIcon ? $19201d0a1f7d7d54$var$styles.iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $is0Fy.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $3wYKB = parcelRequire("3wYKB");

var $lCAti = parcelRequire("lCAti");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});
parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $d73476b891de3e0c$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            showClearIndicator ? $d73476b891de3e0c$var$styles.calendarButtonInclusionStyles : $d73476b891de3e0c$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = null;
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $bwpsq.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1f0Hs.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4694b4334ad7c5c52e5a3aa3cac3904d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.31 6 3.97-3.97L5.22.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06zm4.75 0 3.97-3.97L9.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efb038f49280a8a959174d8021780f6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.78.97 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06L9.69 6 5.72 2.03zm-4.75 0 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5L.97 9.97 4.94 6 .97 2.03z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});


parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $48f5b21daaca02ab$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $bwpsq.default)([
            $48f5b21daaca02ab$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $5RLF6.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: (0, $3JT92.cx)($48f5b21daaca02ab$var$styles.iconContainerStyles, value && !hideIcon ? $48f5b21daaca02ab$var$styles.iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $2YZCu = parcelRequire("2YZCu");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $2YZCu.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("9FL4D", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", () => $ee02e7651d6a8221$export$9d2267fe165de4b6);
const $ee02e7651d6a8221$export$9d2267fe165de4b6 = (event)=>{
    event.key === 'Enter' && event.preventDefault();
};

});

parcelRegister("eVzdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $049ff715c3e8bf03$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $049ff715c3e8bf03$var$messages = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-create-commons.date-field.placeholder",
        "defaultMessage": "Select date"
    },
    ariaLabel: {
        "id": "issue-create-commons.date-field.aria-label",
        "defaultMessage": "Enter a Date"
    }
});
var $049ff715c3e8bf03$export$2e2bcd8739ae039 = $049ff715c3e8bf03$var$messages;

});


parcelRegister("cnfHu", function(module, exports) {

$parcel$export(module.exports, "mutateDateField", () => $b4588511439b4165$export$cc256064cc35499f);
$parcel$export(module.exports, "transformDate", () => $b4588511439b4165$export$57e73ea84b51baf0);

var $k7m40 = parcelRequire("k7m40");

var $eZDAP = parcelRequire("eZDAP");

const $b4588511439b4165$export$cc256064cc35499f = (date, fieldId)=>{
    const dateInputFormat = 'yyyy-MM-dd';
    return {
        fieldId: fieldId,
        date: {
            formattedDate: (0, $k7m40.default)((0, $eZDAP.default)(date), dateInputFormat)
        },
        mutationGroup: (0, $93652339ecfdbba1$export$31fd86f8f183952c)
    };
};
const $b4588511439b4165$export$57e73ea84b51baf0 = (date)=>date || null;

});
const $93652339ecfdbba1$export$31fd86f8f183952c = 'datePickerFields';


parcelRegister("fpis9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d01bc814484554$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cHu6v = parcelRequire("cHu6v");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9FL4D = parcelRequire("9FL4D");

var $jGVMX = parcelRequire("jGVMX");

var $lkRXf = parcelRequire("lkRXf");

const $a9d01bc814484554$export$ae1ced156568f0b0 = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleChange = (dateTimeValue)=>{
        onChange(dateTimeValue || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "date-time-field-edit-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHu6v.AsyncDateTimeFieldEditView), {
        label: fieldName,
        ...fieldProps,
        isDisabled: isDisabled || isReadOnly,
        autoFocus: autoFocus,
        value: value,
        onChange: handleChange,
        isInvalid: Boolean(error),
        datePickerProps: {
            selectProps: {
                onKeyDown: (0, $9FL4D.preventFormSubmitOnEnterKeyPress)
            },
            placeholder: formatMessage((0, $lkRXf.default).datePickerPlaceholder)
        },
        timePickerProps: {
            placeholder: formatMessage((0, $lkRXf.default).timePickerPlaceholder)
        }
    })));
};
var $a9d01bc814484554$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
$a9d01bc814484554$export$ae1ced156568f0b0);

});
parcelRegister("cHu6v", function(module, exports) {

$parcel$export(module.exports, "AsyncDateTimeFieldEditView", () => $f165d6e156b4ac02$export$657a1b8545a979b8);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $fwbTL = parcelRequire("fwbTL");
const $f165d6e156b4ac02$var$EMPTY_OBJECT = {};
const $f165d6e156b4ac02$export$657a1b8545a979b8 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fwbTL.asyncDateTimeFieldEditViewEntrypoint), // use stable reference to avoid re-renders
    $f165d6e156b4ac02$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-field-date-time-edit-view",
        packageName: "jira-issue-field-date-time",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("fwbTL", function(module, exports) {

$parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", () => $d8c60609c3da1617$export$971e82244ad6d423);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d8c60609c3da1617$export$971e82244ad6d423 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aVfp9")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
        moduleId: "267b9282"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aVfp9", function(module, exports) {

let $7f3b2d517bbc585a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f3b2d517bbc585a$var$load("hoRHv").then(()=>parcelRequire('7p4p7'));

});



parcelRegister("lkRXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6bff0fa93541ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bb6bff0fa93541ec$var$messages = (0, $7VHMR.defineMessages)({
    datePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.date-picker-placeholder",
        "defaultMessage": "Select date"
    },
    timePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.time-picker-placeholder",
        "defaultMessage": "Select time"
    }
});
var $bb6bff0fa93541ec$export$2e2bcd8739ae039 = $bb6bff0fa93541ec$var$messages;

});


parcelRegister("kEFc7", function(module, exports) {

$parcel$export(module.exports, "mutateDateTimeField", () => $6b040ff5d5a5d1fc$export$c17fd814c724a443);

var $k7m40 = parcelRequire("k7m40");

var $eZDAP = parcelRequire("eZDAP");

const $6b040ff5d5a5d1fc$export$c17fd814c724a443 = (date, fieldId)=>{
    const dateTimeInputFormat = "yyyy-MM-dd'T'HH:mm:ssXXX";
    return {
        fieldId: fieldId,
        dateTime: {
            formattedDateTime: (0, $k7m40.default)((0, $eZDAP.default)(date), dateTimeInputFormat)
        },
        mutationGroup: (0, $40767685c915f999$export$31fd86f8f183952c)
    };
};

});
const $40767685c915f999$export$31fd86f8f183952c = 'dateTimePickerFields';


parcelRegister("kRBrp", function(module, exports) {

$parcel$export(module.exports, "transformDefaultEpicValue", () => $d87b14be842e0226$export$d1fe9e25b0dbb9af);
$parcel$export(module.exports, "mutateEpicLinkField", () => $d87b14be842e0226$export$5e81faed0a30e719);
const $d87b14be842e0226$export$d1fe9e25b0dbb9af = ({ key: key, summary: summary })=>({
        label: summary,
        value: key
    });
const $d87b14be842e0226$export$5e81faed0a30e719 = ({ value: value }, fieldId)=>({
        epicLinkField: {
            fieldId: fieldId,
            epicLink: {
                issueKey: value
            }
        }
    });

});

parcelRegister("2cChB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f58a08bbf942e9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $7KR8k = parcelRequire("7KR8k");

var $6FMjJ = parcelRequire("6FMjJ");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $3IdTl = parcelRequire("3IdTl");

var $h2h4F = parcelRequire("h2h4F");
const $7f58a08bbf942e9a$export$5939eb0b0c440cdc = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, fieldId: fieldId, allowedValues: allowedValues, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isCreateLinkedIssue: isCreateLinkedIssue = false, additionalData: additionalData, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const options = (0, $6FMjJ.mapDataToOptions)(allowedValues);
    // According to the new implemented logic, the initial values of the checkboxes will be determined by the BE payload.
    // If the response from the BE is null, we wont display the checkbox
    // if it's false, we'll display it and mark it unchecked
    // it it's true, we'll display it and mark it checked
    const { copyLinks: copyLinks, copyAttachments: copyAttachments } = additionalData?.copyLinksAndAttachments || {};
    const hasUpdatedInitialLinks = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jira-concurrent-create-linked-issue')) {
            /**
       * With concurrent, onChange is changing every render and value is not updated,
       * so we get an infinite loop in this useEffect.
       *
       * This ref is used to avoid this infinite loop.
       */ if (hasUpdatedInitialLinks.current) return;
        }
        if (isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view')) {
            if (value?.includeAttachments === undefined && value?.includeLinks === undefined) {
                onChange({
                    ...value || {},
                    includeLinks: copyLinks || false,
                    includeAttachments: copyAttachments || false
                });
                if ((0, $4R6GH.fg)('jira-concurrent-create-linked-issue')) hasUpdatedInitialLinks.current = true;
            }
        }
    }, [
        copyAttachments,
        copyLinks,
        isCreateLinkedIssue,
        onChange,
        value
    ]);
    const onIssueLinksEditChange = (newValue)=>{
        value && onChange({
            ...value || {},
            ...newValue
        });
    };
    const onIncludeAttachmentsChange = (e)=>{
        value && onChange({
            ...value,
            includeAttachments: e.currentTarget.checked
        });
    };
    const onIncludeLinksChange = (e)=>{
        value && onChange({
            ...value,
            includeLinks: e.currentTarget.checked
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7KR8k.IssueLinksEdit), {
        linkTypeOptions: options,
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onChange: isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? onIssueLinksEditChange : onChange,
        fetchSuggestionsOnMount: false,
        value: value,
        fieldId: fieldId,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy,
        ariaLabel: formatMessage((0, $3IdTl.default).ariaLabel)
    }), isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f58a08bbf942e9a$var$CheckboxWrapper, null, additionalData?.copyLinksAndAttachments !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onChange: onIncludeLinksChange,
        label: formatMessage((0, $3IdTl.default).includeLinks),
        isChecked: value?.includeLinks || false
    }), additionalData?.copyLinksAndAttachments !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onChange: onIncludeAttachmentsChange,
        label: formatMessage((0, $3IdTl.default).includeAttachments),
        isChecked: value?.includeAttachments || false
    })));
};
var $7f58a08bbf942e9a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $h2h4F.transformDefaultIssueLinksValue),
    validator: (0, $h2h4F.validateIssueLinksField // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<IssueLinksFieldConfig, IssueLink>, any>'.
    )
})($7f58a08bbf942e9a$export$5939eb0b0c440cdc);
const $7f58a08bbf942e9a$var$CheckboxWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4 _ca0q1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7KR8k", function(module, exports) {

$parcel$export(module.exports, "IssueLinksEdit", () => $374357294b45f900$export$4db6edf6dd313d5a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dSKGh = parcelRequire("dSKGh");

var $9RIG1 = parcelRequire("9RIG1");
const $374357294b45f900$export$4db6edf6dd313d5a = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, onChange: onChange, linkTypeOptions: linkTypeOptions, autoFocus: autoFocus = false, value: value, fetchSuggestionsOnMount: fetchSuggestionsOnMount, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, isRequired: isRequired, inputId: inputId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const onLinkTypeChange = (val)=>{
        onChange({
            linkType: val,
            issues: value ? value.issues : []
        });
    };
    const onLinkSearchChange = (val)=>{
        if (value) onChange({
            linkType: value.linkType,
            issues: val
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($374357294b45f900$var$FlexColumn, {
        "data-testid": "issue-field-issue-links.ui.edit.issue-links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSKGh.default), {
        options: linkTypeOptions,
        autoFocus: autoFocus,
        value: value ? value.linkType : undefined,
        onChange: onLinkTypeChange,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled,
        inputId: inputId,
        isRequired: isRequired,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RIG1.default), {
        fieldId: fieldId,
        value: value ? value.issues : undefined,
        fetchSuggestionsOnMount: fetchSuggestionsOnMount,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onLinkSearchChange,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $374357294b45f900$var$FlexColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dSKGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $975001f6f923cec5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $lElIo = parcelRequire("lElIo");

var $4R6GH = parcelRequire("4R6GH");
const $975001f6f923cec5$var$IssueLinksTypeControl = (props)=>{
    const { options: options, value: value, onChange: onChange, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (value === undefined) onChange(options[0]);
    }, [
        value,
        onChange,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $975001f6f923cec5$var$linkTypeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: inputId,
        required: isRequired,
        options: options,
        value: value,
        // @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
        onChange: onChange,
        isMulti: false,
        autoFocus: autoFocus,
        defaultValue: options[0],
        closeMenuOnScroll: onCloseMenuOnScroll,
        styles: (0, $lElIo.defaultSelectStyles),
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isDisabled: isDisabled,
        classNamePrefix: "issue-link-type",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }));
};
const $975001f6f923cec5$var$IssueLinksTypeExperiment = (props)=>{
    const { options: options, value: value, onChange: onChange, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (value === undefined) onChange(options[0]);
    }, [
        value,
        onChange,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $975001f6f923cec5$var$linkTypeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: inputId,
        required: isRequired,
        options: options,
        value: value,
        // @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
        onChange: onChange,
        isMulti: false,
        autoFocus: autoFocus,
        defaultValue: options[0],
        closeMenuOnScroll: onCloseMenuOnScroll,
        styles: (0, $lElIo.defaultSelectStyles),
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isDisabled: isDisabled,
        classNamePrefix: "issue-link-type",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }));
};
const $975001f6f923cec5$var$IssueLinksType = (props)=>{
    if ((0, $4R6GH.fg)('create_another_issue_react_18_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($975001f6f923cec5$var$IssueLinksTypeExperiment, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($975001f6f923cec5$var$IssueLinksTypeControl, props);
};
var $975001f6f923cec5$export$2e2bcd8739ae039 = $975001f6f923cec5$var$IssueLinksType;
const $975001f6f923cec5$var$linkTypeWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});

parcelRegister("9RIG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a262362dcdda63df$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $koVbs = parcelRequire("koVbs");

var $j7RHF = parcelRequire("j7RHF");

var $h1XvK = parcelRequire("h1XvK");

var $2xATL = parcelRequire("2xATL");
const $a262362dcdda63df$var$IssueLinksSearchEdit = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [invalidSelections, setInValidSelections] = (0, $5uXOq.useState)([]);
    const [isInvalidState, setIsInvalidState] = (0, $5uXOq.useState)(false);
    const { fieldId: fieldId, onFocus: onFocus, onBlur: onBlur, value: value, options: options, onChange: onChange, autoCompleteUrl: autoCompleteUrl, loadingMessage: loadingMessage, getSuggestions: getSuggestions, useTransformSuggestions: useTransformSuggestions, noOptionsMessage: noOptionsMessage, fetchSuggestionsOnMount: fetchSuggestionsOnMount, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled } = props;
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query)=>{
        const response = await (0, $eusud.performGetRequest)(`${autoCompleteUrl}${query}`);
        return response;
    }, [
        autoCompleteUrl
    ]);
    /** returns the update invalid selection list that only contains values still present in the user selections */ const updateInvalidSelections = (0, $5uXOq.useCallback)((selectionValues)=>{
        const issueKeyValues = selectionValues ? selectionValues.map((v)=>v.value) : []; // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const updateSelections = invalidSelections.length ? // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'i' implicitly has an 'any' type.
        invalidSelections.filter((i)=>issueKeyValues.includes(i)) : [];
        if (updateSelections.length) setIsInvalidState(true);
        else setIsInvalidState(false);
        setInValidSelections(updateSelections);
    }, [
        invalidSelections
    ]);
    const onChangeSelectedValues = (0, $5uXOq.useCallback)((values, suggestions)=>{
        const currentHost = (0, $2xATL.getCurrentHostPattern)();
        updateInvalidSelections(values);
        const newIssueLinks = values !== null && values !== undefined ? values.map((issueLink)=>{
            const strippedIssueKey = (0, $2xATL.stripUrlToIssueKey)(currentHost, issueLink.value.toString());
            return {
                ...issueLink,
                iconUrl: issueLink.__isNew__ === true && suggestions && suggestions[0].options ? suggestions[0].options.find((option)=>option.value === issueLink.value)?.iconUrl : issueLink.iconUrl,
                label: strippedIssueKey,
                value: strippedIssueKey
            };
        }) : values;
        onChange(newIssueLinks);
    }, [
        onChange,
        updateInvalidSelections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a262362dcdda63df$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a262362dcdda63df$var$searchWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7RHF.SearchableSelect), {
        fieldId: fieldId,
        getSuggestions: getSuggestions !== undefined ? getSuggestions : fetchSuggestions,
        onChange: onChangeSelectedValues,
        isMulti: true,
        value: value,
        options: options,
        onBlur: onBlur,
        onFocus: onFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled,
        placeholder: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $h1XvK.default).placeholderIssueTermRefresh : (0, $h1XvK.default).placeholder),
        getTransformedSuggestions: useTransformSuggestions !== undefined ? useTransformSuggestions : (0, $2xATL.transformIssueSuggestionItems),
        canCreateNewItem: true,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        onChangeQueryValue: (0, $2xATL.stripQueryValueToIssueKey),
        isInvalid: isInvalid === true || isInvalidState,
        fetchSuggestionsOnMount: fetchSuggestionsOnMount,
        formatCreateLabel: formatMessage((0, $h1XvK.default).createNewIssueLink),
        ariaLabel: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $h1XvK.default).placeholderIssueTermRefresh : (0, $h1XvK.default).placeholder)
    })));
};
var $a262362dcdda63df$export$2e2bcd8739ae039 = $a262362dcdda63df$var$IssueLinksSearchEdit;
const $a262362dcdda63df$var$searchWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a262362dcdda63df$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7RHF", function(module, exports) {

$parcel$export(module.exports, "SearchableSelect", () => $7e27a772eb8ee65d$export$6037a18d4e29dfa9);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $qfj8c = parcelRequire("qfj8c");

var $iOwNT = parcelRequire("iOwNT");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $fh3sQ = parcelRequire("fh3sQ");
const $7e27a772eb8ee65d$export$251bdbdbce9550ea = 300;
const $7e27a772eb8ee65d$export$6037a18d4e29dfa9 = (props)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fieldId: fieldId, isMulti: isMulti, isInvalid: isInvalid, placeholder: placeholder, value: value, options: options, components: components, canCreateNewItem: canCreateNewItem, classNamePrefix: classNamePrefix, onChangeQueryValue: onChangeQueryValue, onChange: onChange, onFocus: onFocus, onBlur: onBlur, fetchSuggestionsOnMount: fetchSuggestionsOnMount, getSuggestions: getSuggestions, formatOptionLabel: formatOptionLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, componentsProps: componentsProps, getTransformedSuggestions: getTransformedSuggestions, errorMessagePosition: errorMessagePosition, invalidMessage: invalidMessage, onPostTransformSuggestions: onPostTransformSuggestions, formatCreateLabel: formatCreateLabel, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, ariaLabel: ariaLabel } = props;
    /** Fetching and transforming results logic below * */ const handleSuggestions = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'query' implicitly has an 'any' type.
    (results, query)=>{
        if (lastQuery.current === query) {
            const response = getTransformedSuggestions(results, formatMessage, query);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        getTransformedSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $fh3sQ.default).failedFetch)), [
        formatMessage
    ]);
    const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            const response = await getSuggestions(query, componentsProps);
            setIsLoading(false);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoading(false);
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        componentsProps,
        getFailedFetchMessage,
        getSuggestions,
        handleSuggestions
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoading(true);
                requestSuggestions();
            } else if (options) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoading(true);
                requestSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        componentsProps
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(requestSuggestions, $7e27a772eb8ee65d$export$251bdbdbce9550ea), []);
    /** Action handlers below * */ const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            const transformedQuery = onChangeQueryValue ? onChangeQueryValue(query) : query;
            lastQuery.current = transformedQuery;
            setIsLoading(true);
            debouncedRequestSuggestions(transformedQuery);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions,
        onChangeQueryValue
    ]);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        setMenuIsOpen(true);
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        setMenuIsOpen(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onChangeSelected = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
    (values)=>{
        onChange(values, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    /** Custom rendering through functions below * */ const getFormatOptionLabel = (0, $5uXOq.useCallback)((option, meta)=>{
        if (formatOptionLabel !== undefined) return formatOptionLabel(option, meta);
        if (option.iconUrl === undefined) return option.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.ImgSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            src: option.iconUrl,
            alt: "",
            width: 2 * (0, $gwIPs.gridSize),
            height: 2 * (0, $gwIPs.gridSize),
            role: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FlexSpan), null, option.label));
    }, [
        formatOptionLabel
    ]);
    const renderErrorMessage = (0, $5uXOq.useCallback)(()=>invalidMessage !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.ErrorMessageWrapper), {
            key: `${fieldId}-error-message`,
            errorMessagePosition: errorMessagePosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, invalidMessage)) : null, [
        errorMessagePosition,
        fieldId,
        invalidMessage
    ]);
    const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $fh3sQ.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $fh3sQ.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $fh3sQ.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
        if (canCreateNewItem && query !== '') return true;
        return false;
    }, [
        canCreateNewItem
    ]);
    /**  Rendering logic below * */ const renderSelectField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
            classNamePrefix: classNamePrefix,
            key: fieldId,
            options: suggestions,
            autoFocus: autoFocus,
            // @ts-expect-error TS2345: Argument of type '{ new <Option = OptionType, IsMulti extends boolean = false>(props: SelectProps<Option, IsMulti>): { components: Partial<SelectComponents<Option, IsMulti, GroupBase<Option>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; }; defaultProps: { ...' is not assignable to parameter of type 'ComponentType<SelectProps<unknown, boolean> | AsyncSelectProps<unknown, boolean> | CreatableSelectProps<unknown, boolean>>'.
            value: value,
            onBlur: onSelectBlur,
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            loadingMessage: getLoadingMessage,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, $lElIo.defaultSelectStyles),
            placeholder: placeholder !== undefined ? placeholder : formatMessage((0, $fh3sQ.default).placeholder),
            onInputChange: onQueryChange,
            onChange: onChangeSelected,
            isLoading: menuIsOpen && isLoading,
            filterOption: filterOption,
            isClearable: true,
            formatOptionLabel: getFormatOptionLabel,
            // @ts-expect-error - Type '{ Menu: ComponentType<MenuProps>; } | undefined' is not assignable to type 'Partial<SelectComponents<Option, boolean, GroupBase<Option>>> | undefined'
            components: components,
            componentsProps: componentsProps,
            isMulti: isMulti,
            isValidNewOption: isValidNewOption,
            // @ts-expect-error - null has to be changed to undefined
            validationState: isInvalid === true ? 'error' : null,
            formatCreateLabel: getCreateLabel,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isDisabled,
            "aria-label": ariaLabel
        });
    const componentList = [
        renderSelectField()
    ];
    errorMessagePosition === 'top' ? componentList.unshift(renderErrorMessage()) : componentList.push(renderErrorMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, componentList);
};
$7e27a772eb8ee65d$export$6037a18d4e29dfa9.defaultProps = {
    isMulti: false,
    canCreateNewItem: false,
    fetchSuggestionsOnMount: true
};
var $7e27a772eb8ee65d$export$2e2bcd8739ae039 = $7e27a772eb8ee65d$export$6037a18d4e29dfa9;

});
parcelRegister("6Vzc4", function(module, exports) {

$parcel$export(module.exports, "getFailedFetchSelectOptions", () => $9302f6c83ce60c04$export$6ed0d629c0656ce1);
$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $9302f6c83ce60c04$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $9302f6c83ce60c04$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $9302f6c83ce60c04$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $9302f6c83ce60c04$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $9302f6c83ce60c04$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $9302f6c83ce60c04$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $goAgE = parcelRequire("goAgE");
const $9302f6c83ce60c04$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: // @ts-expect-error ReactNode is not assignable to string (which is the only type in docs: https://atlassian.design/components/select/code). But it works
                    label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $9302f6c83ce60c04$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const failedFetchMessage = (0, $goAgE.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage(failedFetchMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $goAgE.default).reloadIssueIssueTermRefresh : (0, $goAgE.default).reloadIssue))));
};
const $9302f6c83ce60c04$export$aa3357fb0ebcdb2b = (query)=>$9302f6c83ce60c04$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $9302f6c83ce60c04$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$df67068a00dece12 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $9302f6c83ce60c04$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9302f6c83ce60c04$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("goAgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a2287a5c23e167$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b7a2287a5c23e167$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue-issue-term-refresh",
        "defaultMessage": "Try reloading"
    }
});

});


parcelRegister("3BhEA", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0eb6c4d40c779509$export$58bb91b619b113f6);

var $8QpSo = parcelRequire("8QpSo");

var $5JAlL = parcelRequire("5JAlL");
const $0eb6c4d40c779509$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal = (0, $8QpSo.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5JAlL.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues
    }));
const $0eb6c4d40c779509$export$58bb91b619b113f6 = (option, inputValue)=>$0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("fh3sQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a46539e6d04481b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1a46539e6d04481b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "searchable-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "searchable-select.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "searchable-select.placeholder",
        "defaultMessage": "Select an option"
    },
    loading: {
        "id": "searchable-select.loading",
        "defaultMessage": "Searching..."
    },
    createNewItem: {
        "id": "searchable-select.create-new-item",
        "defaultMessage": "Create"
    }
});

});


parcelRegister("h1XvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d11f601a4e5adff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4d11f601a4e5adff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-issue-links.edit.search.placeholder",
        "defaultMessage": "Select Issue"
    },
    openIssues: {
        "id": "issue-field-issue-links.edit.search.open-issues",
        "defaultMessage": "Open Issues"
    },
    noHistoryResults: {
        "id": "issue-field-issue-links.edit.search.no-history-results",
        "defaultMessage": "Type to search for an issue summary or key"
    },
    singleInvalidIssue: {
        "id": "issue-field-issue-links.edit.search.single-invalid-issue",
        "defaultMessage": "We can't find an issue with the key"
    },
    multipleInvalidIssues: {
        "id": "issue-field-issue-links.edit.search.multiple-invalid-issues",
        "defaultMessage": "We can't find issues with the keys"
    },
    createNewIssueLink: {
        "id": "issue-field-issue-links.edit.search.create-new-issue-link",
        "defaultMessage": "Exact key"
    },
    placeholderIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.placeholder-issue-term-refresh",
        "defaultMessage": "Select work item"
    },
    openIssuesIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    noHistoryResultsIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.no-history-results-issue-term-refresh",
        "defaultMessage": "Type to search for a work item or key"
    },
    singleInvalidIssueIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.single-invalid-issue-issue-term-refresh",
        "defaultMessage": "We can't find a work item with the key"
    },
    multipleInvalidIssuesIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.multiple-invalid-issues-issue-term-refresh",
        "defaultMessage": "We can't find work items with the keys"
    }
});

});

parcelRegister("2xATL", function(module, exports) {

$parcel$export(module.exports, "getCurrentHostPattern", () => $afdafd09cd63e727$export$47e10df7c3c19b6b);
$parcel$export(module.exports, "stripUrlToIssueKey", () => $afdafd09cd63e727$export$1f3c6284caef177b);
$parcel$export(module.exports, "stripQueryValueToIssueKey", () => $afdafd09cd63e727$export$a1fbc8ef5ec2d6e3);
$parcel$export(module.exports, "transformIssueSuggestionItems", () => $afdafd09cd63e727$export$41cc13f7ec7b4b3d);

var $4R6GH = parcelRequire("4R6GH");

var $h1XvK = parcelRequire("h1XvK");
// If the full URL supplied matches the Jira view issue pattern for the specified site then strip the URL
// to just the issue key. If the URL does not match the pattern then return it unchanged.
const $afdafd09cd63e727$var$ISSUE_BROWSE_PATH = 'browse/';
const $afdafd09cd63e727$var$ISSUE_KEY_REGEXP = /^(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $afdafd09cd63e727$export$47e10df7c3c19b6b = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.location.port !== '') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return `${window.location.protocol}//${window.location.hostname}`;
};
const $afdafd09cd63e727$export$1f3c6284caef177b = (tenantUrl, candidateUrl)=>{
    let tenantUrlPath = tenantUrl;
    if (tenantUrlPath === undefined || candidateUrl === undefined) return candidateUrl || '';
    if (!tenantUrlPath.endsWith('/')) tenantUrlPath += '/';
    tenantUrlPath += $afdafd09cd63e727$var$ISSUE_BROWSE_PATH;
    if (candidateUrl.indexOf(tenantUrlPath) !== 0) return candidateUrl;
    const candidatePath = candidateUrl.slice(tenantUrlPath.length);
    const match = candidatePath.match($afdafd09cd63e727$var$ISSUE_KEY_REGEXP);
    if (match === null) return candidateUrl;
    return match[1] || ''; // issue key is at index 1 (first capture group)
};
const $afdafd09cd63e727$export$a1fbc8ef5ec2d6e3 = (queryValue)=>{
    const currentHost = $afdafd09cd63e727$export$47e10df7c3c19b6b();
    return $afdafd09cd63e727$export$1f3c6284caef177b(currentHost, queryValue);
};
const $afdafd09cd63e727$export$41cc13f7ec7b4b3d = (results, formatMessage, query = '')=>{
    const { sections: sections } = results;
    const heading = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $h1XvK.default).openIssuesIssueTermRefresh : (0, $h1XvK.default).openIssues);
    const noSuggestionsMessage = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $h1XvK.default).noHistoryResultsIssueTermRefresh : (0, $h1XvK.default).noHistoryResults);
    const suggestions = sections.map((section)=>section.issues).filter((issues)=>!!issues) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((flatten, current)=>flatten.concat(current.map((issue)=>({
                label: `${issue.key} ${issue.summaryText}`,
                value: issue.key,
                id: issue.id ? issue.id.toString() : '',
                iconUrl: issue.img,
                // Allows us to force all items returned by the endpoint to be displayed.
                filterValues: [
                    query
                ]
            }))), []) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((uniq, current)=>uniq.findIndex((item)=>item.value === current.value) < 0 ? [
            ...uniq,
            current
        ] : uniq, []);
    if (suggestions.length) {
        const selectSuggestions = [
            {
                label: heading,
                options: suggestions
            }
        ];
        return selectSuggestions;
    }
    const noSuggestion = [
        {
            label: noSuggestionsMessage,
            isDisabled: true,
            value: ''
        }
    ];
    return noSuggestion;
};
const $afdafd09cd63e727$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);

});



parcelRegister("6FMjJ", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $0d4f0c1fecf67eac$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $0d4f0c1fecf67eac$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $0d4f0c1fecf67eac$export$ffef3a401aef987b);
const $0d4f0c1fecf67eac$export$5c1e24ea9ccb80aa = (linkType)=>({
        id: linkType.linkTypeId,
        label: linkType.relationName,
        value: linkType.relationName,
        name: linkType.linkTypeName,
        direction: linkType.direction
    });
const $0d4f0c1fecf67eac$export$99a866ffa3af7d8b = (linkTypes)=>linkTypes.map($0d4f0c1fecf67eac$export$5c1e24ea9ccb80aa);
const $0d4f0c1fecf67eac$export$ffef3a401aef987b = (option)=>{
    // handling the case where default value may get set in the process of setting the default value of link type dropdown but the user never selects any issues
    if (option.issues.length === 0) return undefined;
    const direction = option.linkType.direction === 'INWARD' ? 'inwardIssues' : 'outwardIssues';
    return [
        {
            add: {
                values: [
                    {
                        type: {
                            id: option.linkType.id
                        },
                        [direction]: option.issues.map((issue)=>({
                                key: issue.value
                            }))
                    }
                ]
            }
        }
    ];
};

});

parcelRegister("3IdTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a72be53e50da42c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7a72be53e50da42c$var$messages = (0, $7VHMR.defineMessages)({
    includeLinks: {
        "id": "issue-create-commons.issue-links-field.include-links",
        "defaultMessage": "Include links"
    },
    includeAttachments: {
        "id": "issue-create-commons.issue-links-field.include-attachments",
        "defaultMessage": "Include attachments"
    },
    ariaLabel: {
        "id": "issue-create-commons.issue-links-field.aria-label",
        "defaultMessage": "Select an action for linked work item"
    }
});
var $7a72be53e50da42c$export$2e2bcd8739ae039 = $7a72be53e50da42c$var$messages;

});

parcelRegister("h2h4F", function(module, exports) {

$parcel$export(module.exports, "transformDefaultIssueLinksValue", () => $4f5fb81cb5847464$export$acce6bb888b6838c);
$parcel$export(module.exports, "validateIssueLinksField", () => $4f5fb81cb5847464$export$542fc2dd23d5dbdc);
$parcel$export(module.exports, "mutateIssueLinksField", () => $4f5fb81cb5847464$export$c498672524a9f24d);

var $4R6GH = parcelRequire("4R6GH");

var $bGrWH = parcelRequire("bGrWH");

var $6FMjJ = parcelRequire("6FMjJ");
const $4f5fb81cb5847464$export$acce6bb888b6838c = (value)=>{
    if (value && value.length > 0) {
        const issues = [];
        value.forEach((issueLink)=>{
            if (issueLink.issue) issues.push({
                iconUrl: issueLink.issue.avatar?.small,
                id: issueLink.issue.issueId.toString(),
                label: issueLink.issue.key,
                value: issueLink.issue.key
            });
        });
        return (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
            linkType: (0, $6FMjJ.mapDataToOption)(value?.[0]?.relatedBy),
            issues: issues,
            includeAttachments: undefined,
            includeLinks: undefined
        } : {
            linkType: (0, $6FMjJ.mapDataToOption)(value?.[0]?.relatedBy),
            issues: issues
        };
    }
    return undefined;
};
const $4f5fb81cb5847464$export$542fc2dd23d5dbdc = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        // value can be null/undefined/{} or issues can be [] when default value is set for the link type select, check the default transformer for this field
        if (!value?.issues?.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $4f5fb81cb5847464$export$c498672524a9f24d = (value)=>({
        issueLinks: {
            linkTypeName: value.linkType.value,
            linkedIssueKeys: value?.issues?.map((issue)=>issue.value.toString()) || []
        }
    });

});


parcelRegister("8GQyc", function(module, exports) {

$parcel$export(module.exports, "ForgeLabelsField", () => $34600c8cb7aa4373$export$f77bab10d748bb71);
$parcel$export(module.exports, "default", () => $34600c8cb7aa4373$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $800rQ = parcelRequire("800rQ");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $evGBv = parcelRequire("evGBv");

const $34600c8cb7aa4373$var$LabelsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $800rQ.LabelsEdit), {
        isInvalid: Boolean(error),
        fetchSuggestionsOnMount: false,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired
    }));
};
const $34600c8cb7aa4373$export$f77bab10d748bb71 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateForgeLabelField),
    transformDefaultValue: (0, $evGBv.mapDataToLabelOptions)
})($34600c8cb7aa4373$var$LabelsField);
var $34600c8cb7aa4373$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateLabelField),
    transformDefaultValue: (0, $evGBv.mapDataToLabelOptions)
})($34600c8cb7aa4373$var$LabelsField);

});
parcelRegister("800rQ", function(module, exports) {

$parcel$export(module.exports, "LabelsEdit", () => $392f4ecadcf70f0f$export$23584166c0ffb901);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7Jxgt = parcelRequire("7Jxgt");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $5fc53 = parcelRequire("5fc53");

var $7ldcY = parcelRequire("7ldcY");

var $lpRLe = parcelRequire("lpRLe");

var $ek97b = parcelRequire("ek97b");

var $6s1PB = parcelRequire("6s1PB");

var $dCm1o = parcelRequire("dCm1o");

var $2QTbq = parcelRequire("2QTbq");

var $l2SvC = parcelRequire("l2SvC");

var $e3wnO = parcelRequire("e3wnO");

var $l5gEe = parcelRequire("l5gEe");
const $392f4ecadcf70f0f$export$251bdbdbce9550ea = 300;
const $392f4ecadcf70f0f$var$labelsValueStyles = {
    multiValue: (base, { data: data })=>{
        // @ts-expect-error - ts2345 - Argument of type 'ReactNode' is not assignable to parameter of type 'string | null | undefined'.
        const { backgroundColor: backgroundColor } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(data.label));
        return {
            ...base,
            border: `1px solid ${backgroundColor}`,
            '& > div > div > div': {
                paddingLeft: 0,
                paddingRight: 0
            },
            ...!(0, $dCm1o.isVisualRefreshEnabled)() ? {
                borderRadius: "var(--ds-border-radius-100, 4px)",
                backgroundColor: 'transparent',
                '& > div': {
                    paddingLeft: "var(--ds-space-050, 4px)",
                    paddingRight: 0,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            } : {}
        };
    },
    multiValueLabel: (base)=>({
            ...base,
            '& > div > div': {
                borderColor: 'transparent'
            }
        })
};
const $392f4ecadcf70f0f$var$labelsRemoveIconStyles = {
    multiValueRemove: (base)=>({
            ...base,
            '& > div > span > svg': {
                transform: 'scale(1.5)',
                fill: 'none'
            },
            '& > div > span > svg > g > path': {
                d: 'path("m 2 10 l 4 -4 m 4 -4 L 6 6 m 0 0 L 2 2 m 4 4 l 4 4")',
                transform: 'translate(5px, 6px)',
                stroke: "var(--ds-text, #172B4D)",
                strokeWidth: '1.5'
            }
        })
};
const $392f4ecadcf70f0f$export$23584166c0ffb901 = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $5fc53.LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $l2SvC.useLabelsSuggestions)({
        fieldId: fieldId,
        getSuggestions: getSuggestions
    });
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $l5gEe.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
            setIsLoadingSuggestions(false);
            if (lastQuery.current === query) {
                const results = (0, $2QTbq.mapLabelsResponseToLabelOptions)(response);
                setSuggestions(results);
                if (query === '') setDefaultSuggestions(results);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoadingSuggestions(false);
            setHasLastFetchFailed(true);
            setSuggestions([
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ]);
        }
    }, [
        autoCompleteUrl,
        getFailedFetchMessage,
        getLabelsSuggestions,
        lastQuery,
        sessionId,
        setHasLastFetchFailed,
        setIsLoadingSuggestions
    ]);
    if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupedSuggestions = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $l5gEe.default).recent),
                options: cachedOptions
            },
            {
                label: formatMessage((0, $l5gEe.default).all),
                options: suggestions || []
            }
        ], [
        cachedOptions,
        formatMessage,
        suggestions
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fetchSuggestions, $392f4ecadcf70f0f$export$251bdbdbce9550ea), []);
    const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $l5gEe.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $l5gEe.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $l5gEe.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        suggestions,
        onFocus,
        setIsLoadingSuggestions,
        fetchSuggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    const isLoading = isLoadingSuggestions;
    const styles = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
            if (!(0, $dCm1o.isVisualRefreshEnabled)()) return {
                ...(0, $lElIo.defaultSelectStyles),
                ...$392f4ecadcf70f0f$var$labelsValueStyles,
                ...$392f4ecadcf70f0f$var$labelsRemoveIconStyles
            };
            return {
                ...(0, $lElIo.defaultSelectStyles),
                ...$392f4ecadcf70f0f$var$labelsValueStyles
            };
        }
        return 0, $lElIo.defaultSelectStyles;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e3wnO.default), {
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: groupedSuggestions,
        value: value,
        isDisabled: isDisabled,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        styles: styles,
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $l5gEe.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onChange,
        spacing: spacing,
        isLoading: isLoading,
        filterOption: filterOption,
        formatCreateLabel: getCreateLabel,
        ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            formatOptionLabel: (option)=>$392f4ecadcf70f0f$var$SelectableOptions(option, `(${formatMessage((0, $l5gEe.default).createNewItem)})`)
        } : {},
        validationState: isInvalid === true ? 'error' : null,
        sessionId: sessionId.current,
        "aria-label": ariaLabel,
        inputId: inputId,
        isRequired: isRequired,
        openMenuOnFocus: openMenuOnFocus
    });
};
const $392f4ecadcf70f0f$var$SelectableOptions = (option, createNewLabelString)=>{
    // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
    const optionLabel = option.label;
    if (typeof optionLabel === 'string' && optionLabel.endsWith(createNewLabelString)) {
        const optionLabelWithoutNewLabel = optionLabel.slice(0, -createNewLabelString.length).trim();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            name: optionLabel,
            color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabelWithoutNewLabel)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
        name: optionLabel,
        color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabel)
    });
};
var $392f4ecadcf70f0f$export$2e2bcd8739ae039 = $392f4ecadcf70f0f$export$23584166c0ffb901;

});
parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);

var $9GtPC = parcelRequire("9GtPC");
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("lpRLe", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $7e21718d85b37a90$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ek97b = parcelRequire("ek97b");
const $7e21718d85b37a90$export$5991b62d89f5cc = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true }, ref)=>{
    const { backgroundColor: tagColor } = (0, $ek97b.getColorMetadata)(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $7e21718d85b37a90$var$tagWrapperStyles,
            isInteractive && $7e21718d85b37a90$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e21718d85b37a90$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
}));
const $7e21718d85b37a90$var$tagWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $7e21718d85b37a90$var$interactiveStyles = (0, $8CUq3.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e21718d85b37a90$var$StyledTagBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $7e21718d85b37a90$var$StyledTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7e21718d85b37a90$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});


parcelRegister("l2SvC", function(module, exports) {

$parcel$export(module.exports, "useLabelsSuggestions", () => $aed9af8029ae7a32$export$c5b80cd78ff71c5f);

var $5uXOq = parcelRequire("5uXOq");

var $6RCeq = parcelRequire("6RCeq");

var $eusud = parcelRequire("eusud");

var $8SCDp = parcelRequire("8SCDp");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");
const $aed9af8029ae7a32$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
    let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
    return (0, $eusud.performGetRequest)(url);
};
const $aed9af8029ae7a32$export$c5b80cd78ff71c5f = (props)=>{
    const { fieldId: fieldId, getSuggestions: getSuggestions = $aed9af8029ae7a32$export$343652b9755c68e7 } = props;
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getLabelsSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
        const startTime = (0, $6RCeq.default).now();
        const queryLength = query.length;
        try {
            const response = await getSuggestions(autoCompleteUrl, query, sessionId);
            if (fieldId === (0, $5fc53.LABELS_TYPE)) (0, $8SCDp.fireSuggestionsRequestSuccessEvent)((0, $5fc53.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (fieldId === (0, $5fc53.LABELS_TYPE)) (0, $8SCDp.fireSuggestionsRequestFailedEvent)((0, $5fc53.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fieldId,
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getLabelsSuggestions: getLabelsSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getLabelsSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
parcelRegister("8SCDp", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $305439819cb2bcec$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $305439819cb2bcec$export$a31ac580130dee62);

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
const $305439819cb2bcec$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $6RCeq.default).now() - startTime
    };
    createAnalyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $305439819cb2bcec$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $305439819cb2bcec$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $305439819cb2bcec$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $305439819cb2bcec$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});


parcelRegister("e3wnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $35584119a49c4bd8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $7Jxgt = parcelRequire("7Jxgt");

var $iOwNT = parcelRequire("iOwNT");

var $6RCeq = parcelRequire("6RCeq");

var $db8jg = parcelRequire("db8jg");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $biBfP = parcelRequire("biBfP");
const $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $35584119a49c4bd8$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $35584119a49c4bd8$export$53574ab050410077 = (0, $2OMDV.AnalyticsEventToProps)('select', $35584119a49c4bd8$var$analyticsProps)((0, $iOwNT.default));
const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
    const sessionId = (0, $5uXOq.useRef)(customSessionId);
    const sessionStartedAt = (0, $5uXOq.useRef)(0);
    const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, $biBfP.flattenOptions)(options));
    const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
    const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? value : [];
        let filteredOptions = (0, $biBfP.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $biBfP.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            isDisabled: isDisabled,
            optionsLength: optionsLength,
            componentName: 'select',
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $biBfP.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $db8jg.memoizedHashString)(query),
            selectedOptions: (0, $biBfP.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $biBfP.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading,
        isDisabled
    ]);
    const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $7Jxgt.v4)();
        sessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $5uXOq.useCallback)((interactionType)=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt !== 0 ? (0, $6RCeq.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime,
                interactionType: interactionType
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $5uXOq.useCallback)((interactionType)=>{
        endSession(interactionType);
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option created');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $biBfP.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $biBfP.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option selected');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $biBfP.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
        if (onChange) onChange(selectedValue, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange,
        isMulti
    ]);
    const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        startSession();
        fireInputChangedEvent('', {
            action: 'fake-action'
        }, createAnalyticsEvent({}));
        return ()=>{
            endSession();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // since due to multiple setState calls component is rerendered
        // added this change to reduce the number of setState call will be fixed,
        // wasn't able to replicate this issue in local so adding this change in feature flag.
        // sentry link: https://sentry.prod.atl-paas.net/atlassian/jira-frontend/issues/4943577/?query=is%3Aunresolved%20logger%3AjiraIssueCreateModal.withFormField
        const flattenedOption = (0, $biBfP.flattenOptions)(options);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$53574ab050410077, {
        ...props,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics
    });
};
var $35584119a49c4bd8$export$2e2bcd8739ae039 = $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("db8jg", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $6aa2f917648b2dec$export$c9e165da390f6283);

var $eb3tB = parcelRequire("eb3tB");

var $8QpSo = parcelRequire("8QpSo");

var $4Pf62 = parcelRequire("4Pf62");
const $6aa2f917648b2dec$export$fdd2c0ba94025c3c = (0, $8QpSo.default)(()=>{
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $6aa2f917648b2dec$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $6aa2f917648b2dec$export$fdd2c0ba94025c3c();
    const hash = (0, $eb3tB.sha256)(`${cloudId}_${attribute.trim()}`);
    return hash;
};

});
parcelRegister("eb3tB", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");


/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2024
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $6cAn5 === 'object' && $6cAn5.versions && $6cAn5.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("3gWwf"));
        var Buffer = (parcelRequire("3gWwf")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >>> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >>> 24 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 & 0xFF,
            h1 >>> 24 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 & 0xFF,
            h2 >>> 24 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 & 0xFF,
            h3 >>> 24 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 & 0xFF,
            h4 >>> 24 & 0xFF,
            h4 >>> 16 & 0xFF,
            h4 >>> 8 & 0xFF,
            h4 & 0xFF,
            h5 >>> 24 & 0xFF,
            h5 >>> 16 & 0xFF,
            h5 >>> 8 & 0xFF,
            h5 & 0xFF,
            h6 >>> 24 & 0xFF,
            h6 >>> 16 & 0xFF,
            h6 >>> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});


parcelRegister("biBfP", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $e31cfbdea683954a$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $e31cfbdea683954a$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $e31cfbdea683954a$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $e31cfbdea683954a$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $e31cfbdea683954a$export$60d56ed3961c839c);

var $chc6P = parcelRequire("chc6P");

var $db8jg = parcelRequire("db8jg");
const $e31cfbdea683954a$export$d05672fd1312a6d = (val)=>(0, $db8jg.memoizedHashString)(val.toString()).toString();
const $e31cfbdea683954a$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$e31cfbdea683954a$export$d05672fd1312a6d(value));
const $e31cfbdea683954a$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(optionGroups.map((group)=>group.options));
const $e31cfbdea683954a$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
const $e31cfbdea683954a$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});




parcelRegister("l5gEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8773284d2f300e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef8773284d2f300e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "issue-field-labels.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-labels.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-labels.edit.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue-field-labels.edit.create-new-item",
        "defaultMessage": "New label"
    },
    loading: {
        "id": "issue-field-labels.edit.loading",
        "defaultMessage": "Searching..."
    },
    recent: {
        "id": "issue-field-labels.edit.recent",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue-field-labels.edit.all",
        "defaultMessage": "All labels"
    }
});

});


parcelRegister("evGBv", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $df66270ab3f9af77$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mutateLabelsFields", () => $df66270ab3f9af77$export$f691a7c5b86be653);

const $df66270ab3f9af77$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name })=>({
            value: name,
            label: name
        }));
const $df66270ab3f9af77$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
        fieldId: fieldId,
        labels: selectedLabels.map(({ value: value })=>({
                name: value
            })),
        mutationGroup: (0, $fbaea1aecc52fe2c$export$31fd86f8f183952c)
    });

});
const $fbaea1aecc52fe2c$export$31fd86f8f183952c = 'labelsFields';



parcelRegister("9sq52", function(module, exports) {

$parcel$export(module.exports, "getIsTimeEstimateExceeded", () => $90724da7402a12e3$export$20e7052b315e94b);
$parcel$export(module.exports, "getCalculatedTimeRemainingIfAny", () => $90724da7402a12e3$export$51a45955a3207e1b);
$parcel$export(module.exports, "getLogWorkSubmitValue", () => $90724da7402a12e3$export$7d47ca3907f5addd);

var $k7m40 = parcelRequire("k7m40");

var $axdWJ = parcelRequire("axdWJ");

var $khZ39 = parcelRequire("khZ39");

var $jXTQd = parcelRequire("jXTQd");
const $90724da7402a12e3$export$20e7052b315e94b = (args)=>{
    const { config: config, timeTrackingValue: timeTrackingValue, timeSpent: timeSpent, timeRemaining: timeRemaining } = args;
    const isTimeRemainingValid = (0, $axdWJ.isValidTimeString)(config)(timeRemaining);
    const isTimeSpentValid = (0, $axdWJ.isValidTimeString)(config)(timeSpent);
    const isTimeTrackingValid = (0, $axdWJ.isValidTimeString)(config)(timeTrackingValue);
    if (isTimeTrackingValid && (isTimeRemainingValid || isTimeSpentValid)) {
        let timeSpentInSeconds = 0;
        let timeRemainingInSeconds = 0;
        const timeTrackingValueInSeconds = (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue);
        if (isTimeSpentValid) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        timeSpentInSeconds = (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeSpent);
        if (isTimeRemainingValid) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        timeRemainingInSeconds = (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeRemaining);
        timeRemainingInSeconds = typeof timeRemainingInSeconds !== 'number' ? 0 : timeRemainingInSeconds;
        timeSpentInSeconds = typeof timeSpentInSeconds !== 'number' ? 0 : timeSpentInSeconds;
        if (typeof timeTrackingValueInSeconds === 'number') {
            if (timeSpentInSeconds + timeRemainingInSeconds > timeTrackingValueInSeconds) return true;
        }
    }
    return false;
};
const $90724da7402a12e3$export$51a45955a3207e1b = (args)=>{
    let calculatedTimeRemaining = null;
    const { timeSpent: timeSpent, timeTrackingValue: timeTrackingValue, config: config } = args;
    const isValidTimeTrackingValue = (0, $axdWJ.isValidTimeString)(config)(timeTrackingValue);
    if (!timeSpent && isValidTimeTrackingValue) return timeTrackingValue;
    const isValidTimeSpent = (0, $axdWJ.isValidTimeString)(config)(timeSpent);
    if (isValidTimeTrackingValue && isValidTimeSpent) {
        const timeSpentInSeconds = (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeSpent) || 0;
        const timeTrackingInSeconds = (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue) || 0;
        if (timeTrackingInSeconds >= timeSpentInSeconds) calculatedTimeRemaining = (0, $khZ39.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingInSeconds - timeSpentInSeconds);
    }
    return calculatedTimeRemaining;
};
const $90724da7402a12e3$export$7d47ca3907f5addd = (value)=>{
    const { dateValue: dateValue, timeSpent: timeSpent, timeRemaining: timeRemaining, description: description } = value;
    const adjustEstimate = timeRemaining ? 'new' : 'leave';
    return [
        {
            add: {
                started: dateValue ? (0, $k7m40.default)(new Date(dateValue), "yyyy-MM-dd'T'HH:mm:ss.SSSxxxx") : undefined,
                timeSpent: timeSpent,
                adjustEstimate: adjustEstimate,
                newEstimate: timeRemaining,
                comment: description && JSON.stringify(description)
            }
        }
    ];
};

});
parcelRegister("axdWJ", function(module, exports) {

$parcel$export(module.exports, "formatTimeString", () => $3e1d4e008ffe7726$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $3e1d4e008ffe7726$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $3e1d4e008ffe7726$export$53148bfa4e677363);

var $caiLO = parcelRequire("caiLO");

var $khZ39 = parcelRequire("khZ39");

var $jXTQd = parcelRequire("jXTQd");

var $51HJa = parcelRequire("51HJa");

var $8KiHO = parcelRequire("8KiHO");

const $3e1d4e008ffe7726$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $khZ39.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $3e1d4e008ffe7726$export$5eb9d332712102eb = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = (0, $51HJa.isNumeric)(trimmedValue.replaceAll(',', '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $8KiHO.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $3e1d4e008ffe7726$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $3e1d4e008ffe7726$export$5eb9d332712102eb(config)(value);
        return timeString === '' || (0, $caiLO.default)(timeString);
    };
const $3e1d4e008ffe7726$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $3e1d4e008ffe7726$export$5eb9d332712102eb(config)(value);
        if (!$3e1d4e008ffe7726$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $jXTQd.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("caiLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8041043484b2005f$export$2e2bcd8739ae039);

var $D5mr3 = parcelRequire("D5mr3");

var $jXTQd = parcelRequire("jXTQd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8041043484b2005f$export$2e2bcd8739ae039 = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $jXTQd.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($D5mr3)))(result);
};

});
parcelRegister("D5mr3", function(module, exports) {

var $1V15E = parcelRequire("1V15E");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0757cd3024f91218$var$nativeIsFinite = $1V15E.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $0757cd3024f91218$var$isFinite(value) {
    return typeof value == 'number' && $0757cd3024f91218$var$nativeIsFinite(value);
}
module.exports = $0757cd3024f91218$var$isFinite;

});

parcelRegister("jXTQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $805a43ba842f3e63$export$2e2bcd8739ae039);
const $805a43ba842f3e63$var$MINUTES_PER_HOUR = 60;
const $805a43ba842f3e63$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $805a43ba842f3e63$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $805a43ba842f3e63$var$convertToUnitQuantity = (rawString)=>{
    const matches = $805a43ba842f3e63$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replaceAll(',', '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $805a43ba842f3e63$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $805a43ba842f3e63$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($805a43ba842f3e63$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $805a43ba842f3e63$export$2e2bcd8739ae039 = $805a43ba842f3e63$var$timeStringToSeconds;

});


parcelRegister("khZ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a56ddd74feeb1a3$export$2e2bcd8739ae039);
const $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR = 60;
const $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE = 60;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5a56ddd74feeb1a3$export$2e2bcd8739ae039 = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};

});

parcelRegister("51HJa", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $04c692f002b6b2cc$export$e90fb89750dba83f);
const $04c692f002b6b2cc$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));

});

parcelRegister("8KiHO", function(module, exports) {

$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $1cda22112bbc1ffb$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $1cda22112bbc1ffb$export$2b38dfc7401492ba = (serverDefaultUnit)=>$1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});



parcelRegister("kdeLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd2c82d962ad5471$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $f5oqj = parcelRequire("f5oqj");

var $4R6GH = parcelRequire("4R6GH");

var $6a30R = parcelRequire("6a30R");
const $bd2c82d962ad5471$var$MessageCFBehaviour = (props)=>{
    const { defaultValue: defaultValue } = props;
    if (defaultValue === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
        document: defaultValue,
        schema: (0, $kOFhM.defaultSchema),
        disableHeadingIDs: true,
        eventHandlers: {
            smartCard: {
                onClick: (0, $6a30R.onLinkClick)
            },
            link: {
                onClick: (0, $6a30R.onLinkClick)
            }
        },
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true,
            // enables sending analytics event with renderer specific tti measurement
            // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
            'renderer-tti-tracking': (0, $4R6GH.fg)('renderer_tti_tracking_jira')
        },
        smartLinks: (0, $6a30R.smartLinksDefault)
    });
};
const $bd2c82d962ad5471$var$MessageCF = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd2c82d962ad5471$var$MessageCFBehaviour, {
        key: "message-custom-field",
        ...props
    });
var $bd2c82d962ad5471$export$2e2bcd8739ae039 = $bd2c82d962ad5471$var$MessageCF;

});

parcelRegister("5sz86", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e92fcc13435d46$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9EuZf = parcelRequire("9EuZf");

var $5fnvk = parcelRequire("5fnvk");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $1IlAr = parcelRequire("1IlAr");

const $b0e92fcc13435d46$var$MultiGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isMulti: true,
        placeholder: " ",
        "aria-labelledby": ariaLabelledBy,
        ...getExtraProps()
    }));
};
var $b0e92fcc13435d46$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateGroupPickerField),
    transformDefaultValue: (0, $1IlAr.transformGroupDefaultValueToUserOption)
})($b0e92fcc13435d46$var$MultiGroupPickerField);

});
parcelRegister("9EuZf", function(module, exports) {

$parcel$export(module.exports, "defaultUserPickerStyles", () => $378ea0219a6c1ff7$export$ddd4b90ea2d7a329);

var $gwIPs = parcelRequire("gwIPs");
const $378ea0219a6c1ff7$export$ddd4b90ea2d7a329 = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $gwIPs.layers).modal)
        })
};

});

parcelRegister("5fnvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $81263082e0845513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $koVbs = parcelRequire("koVbs");

var $arYvt = parcelRequire("arYvt");

var $hSBXu = parcelRequire("hSBXu");

var $lGKF5 = parcelRequire("lGKF5");

var $3PgDR = parcelRequire("3PgDR");
const $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $81263082e0845513$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const previousQuery = (0, $5uXOq.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $hSBXu.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(false);
    const getUserPickerControlStyle = (0, $5uXOq.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $3PgDR.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $arYvt.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $lGKF5.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        closeMenuOnScroll: closeMenuOnScroll,
        open: isDropdownVisible,
        menuPosition: menuPosition,
        styles: {
            control: getUserPickerControlStyle,
            ...groupPickerStyles
        }
    });
};
var $81263082e0845513$export$2e2bcd8739ae039 = $81263082e0845513$var$GroupPicker;

});
parcelRegister("arYvt", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $70d728bf86d0ecee$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $70d728bf86d0ecee$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $70d728bf86d0ecee$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $70d728bf86d0ecee$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $70d728bf86d0ecee$export$705009f1a414da46);
const $70d728bf86d0ecee$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $70d728bf86d0ecee$export$285022bf9288513e = (groups)=>groups.map((group)=>$70d728bf86d0ecee$export$c76efe48b8ca8203(group));
const $70d728bf86d0ecee$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("hSBXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9613200b5cbe8cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");

var $arYvt = parcelRequire("arYvt");
const $b9613200b5cbe8cb$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchGroups = (0, $5uXOq.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $eusud.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $arYvt.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $b9613200b5cbe8cb$export$2e2bcd8739ae039 = $b9613200b5cbe8cb$var$useGroupsQuery;

});

parcelRegister("lGKF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d585cea41a3a80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82d585cea41a3a80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("3PgDR", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $2e61feb10eb63767$export$f204658c943efb85);
const $2e61feb10eb63767$export$f204658c943efb85 = {
    borderColor: "var(--ds-border-danger, #E2483D)"
};

});


parcelRegister("1IlAr", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $d2f2135dd78f2505$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateMultipleGroupPickerField", () => $d2f2135dd78f2505$export$8cb86783be488510);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $arYvt = parcelRequire("arYvt");

const $d2f2135dd78f2505$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    if (Array.isArray(group)) return group.map((groupItem)=>(0, $arYvt.transformGroupToUserOption)(groupItem));
    return (0, $arYvt.transformGroupToUserOption)(group);
};
const $d2f2135dd78f2505$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
        fieldId: fieldId,
        groups: selectedGroups.map(({ name: name })=>({
                groupName: name
            })),
        mutationGroup: (0, $795be18a4b521940$export$31fd86f8f183952c)
    });

});
const $795be18a4b521940$export$31fd86f8f183952c = 'multipleGroupPickerFields';



parcelRegister("g2djo", function(module, exports) {

$parcel$export(module.exports, "default", () => $970d61a7c1588270$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d3RWa = parcelRequire("d3RWa");

const $970d61a7c1588270$var$MultiSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3RWa.default), {
        ...props,
        isMulti: true
    });
var $970d61a7c1588270$export$2e2bcd8739ae039 = $970d61a7c1588270$var$MultiSelectField;

});
parcelRegister("d3RWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $da96ee86c52df1e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cOyAh = parcelRequire("cOyAh");

var $5pHXe = parcelRequire("5pHXe");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $7C5S0 = parcelRequire("7C5S0");

var $90YqS = parcelRequire("90YqS");
const $da96ee86c52df1e6$var$SelectField = (props)=>{
    const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, closeMenuOnSelect: closeMenuOnSelect = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOyAh.default), {
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        options: (0, $5pHXe.mapDataToSelectOptions)(allowedValues),
        value: value,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        classNamePrefix: `select-${fieldId}`,
        isMulti: isMulti,
        hideSelectedOptions: true,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isClearable: true,
        onFilterOption: (0, $90YqS.onFilterOption),
        isDisabled: isReadOnly,
        isRequired: isRequired,
        inputId: id,
        closeMenuOnSelect: closeMenuOnSelect
    }));
};
var $da96ee86c52df1e6$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $90YqS.transformDefaultSelectValues),
    validator: (0, $jGVMX.validateSelectField)
})($da96ee86c52df1e6$var$SelectField);

});
parcelRegister("cOyAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ff8480905da065$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $lElIo = parcelRequire("lElIo");

var $4R6GH = parcelRequire("4R6GH");
const $45ff8480905da065$var$SelectEdit = (props)=>{
    const { classNamePrefix: classNamePrefix, closeMenuOnSelect: closeMenuOnSelect = false, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, defaultMenuIsOpen: defaultMenuIsOpen } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: placeholder,
        options: options,
        value: value,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error - TS2322 - Type '(option: SelectOption) => void' is not assignable to type '(value: SelectOption | OptionsType<SelectOption> | null, action: ActionMeta<SelectOption>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        isMulti: isMulti,
        onFocus: onFocus,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        filterOption: onFilterOption,
        inputId: inputId,
        required: isRequired,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        closeMenuOnSelect: closeMenuOnSelect,
        ...(0, $4R6GH.fg)('bulk_ops_ktlo_fixes') && {
            defaultMenuIsOpen: defaultMenuIsOpen
        }
    });
};
var $45ff8480905da065$export$2e2bcd8739ae039 = $45ff8480905da065$var$SelectEdit;

});

parcelRegister("5pHXe", function(module, exports) {

$parcel$export(module.exports, "mapSelectOptionsToData", () => $aeaea2f472af8476$export$7cdfccbc726f6f22);
$parcel$export(module.exports, "mapMultiSelectOptionsToData", () => $aeaea2f472af8476$export$b91253d30be01e62);
$parcel$export(module.exports, "mapDataToSelectOption", () => $aeaea2f472af8476$export$8f475f1fdc96a964);
$parcel$export(module.exports, "mapDataToSelectOptions", () => $aeaea2f472af8476$export$dc22cde66e28d4af);
const $aeaea2f472af8476$export$7cdfccbc726f6f22 = (option)=>({
        id: option.value,
        value: option.label
    });
const $aeaea2f472af8476$export$b91253d30be01e62 = (options)=>options.map((option)=>({
            id: option.value,
            value: option.label
        }));
const $aeaea2f472af8476$export$8f475f1fdc96a964 = (optionExternal)=>({
        label: optionExternal.value,
        value: optionExternal.id
    });
const $aeaea2f472af8476$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$aeaea2f472af8476$export$8f475f1fdc96a964(optionExternal));

});

parcelRegister("90YqS", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSelectValues", () => $3a49366a4ffd7ccc$export$cfb7677fb5241257);
$parcel$export(module.exports, "onFilterOption", () => $3a49366a4ffd7ccc$export$5fde4483c43b93b);

var $5pHXe = parcelRequire("5pHXe");
const $3a49366a4ffd7ccc$export$cfb7677fb5241257 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return (0, $5pHXe.mapDataToSelectOptions)(defaultValue);
    return (0, $5pHXe.mapDataToSelectOption)(defaultValue);
};
const $3a49366a4ffd7ccc$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());

});



parcelRegister("eX2Td", function(module, exports) {

$parcel$export(module.exports, "mutateMultiSelectField", () => $12a9564789baecf3$export$3313ce8403b211b4);
$parcel$export(module.exports, "mapMultiSelectOptionsToConnectData", () => $12a9564789baecf3$export$a7431ac3899bcd4d);

const $12a9564789baecf3$export$3313ce8403b211b4 = (selectedValues, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $c31595b6f75564de$export$31fd86f8f183952c),
        options: selectedValues.map(({ value: value })=>({
                optionId: value
            }))
    });
const $12a9564789baecf3$export$a7431ac3899bcd4d = (options)=>options.map((option)=>option.value);

});
const $c31595b6f75564de$export$31fd86f8f183952c = 'multipleSelectFields';


parcelRegister("gARR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06543e5a7cef326e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lzCWA = parcelRequire("lzCWA");
const $06543e5a7cef326e$var$MultiUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...props,
        isMulti: true,
        context: "CustomMultiUserField"
    });
var $06543e5a7cef326e$export$2e2bcd8739ae039 = $06543e5a7cef326e$var$MultiUserPickerField;

});
parcelRegister("lzCWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02b9e46792852c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $dQLtU = parcelRequire("dQLtU");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $7C5S0 = parcelRequire("7C5S0");

var $5kDIl = parcelRequire("5kDIl");

const $a02b9e46792852c4$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: context,
        ...projectKey && {
            project: projectKey
        },
        ...fieldId && {
            fieldId: fieldId
        },
        query: ''
    })}`;
const $a02b9e46792852c4$var$UserPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject, projectKey: projectKey } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dQLtU.default), {
        autoCompleteUrl: $a02b9e46792852c4$var$getAutoCompleteUrl(context, fieldId, // this is for fixing an issue that the custom user picker doesn't show the right user group in form when the project key is missing
        (0, $4R6GH.fg)('jira_forms_fix_user_picker_missing_project_key') ? projectKey || selectedProject?.projectKey : selectedProject?.projectKey),
        placeholder: placeholder,
        isDisabled: isReadOnly || isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: isMulti,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true,
        width: width,
        inputId: id,
        onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    }));
};
var $a02b9e46792852c4$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateUserPickerField),
    transformDefaultValue: (0, $5kDIl.transformDefaultUserValues)
})($a02b9e46792852c4$var$UserPickerField);

});
parcelRegister("dQLtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d56a824ba419e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jOrdN = parcelRequire("jOrdN");

var $9EuZf = parcelRequire("9EuZf");
const $e4d56a824ba419e6$var$UserPickerEdit = (props)=>{
    const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
    const extraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            styles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        return {
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOrdN.default), {
        ...fieldProps,
        fieldId: fieldId,
        inputId: inputId,
        appearance: appearance,
        width: width,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        fetchSuggestions: fetchSuggestions,
        emptyOption: emptyOption,
        onSelection: onSelection,
        onDataLoaded: onDataLoaded,
        onDataRequest: onDataRequest,
        onCancel: onCancel,
        isDropdownVisibleByDefault: isDropdownVisibleByDefault,
        isClearable: isClearable,
        isBulkEdit: isBulkEdit,
        ...extraProps()
    });
};
var $e4d56a824ba419e6$export$2e2bcd8739ae039 = $e4d56a824ba419e6$var$UserPickerEdit;

});
parcelRegister("jOrdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3563054ff092b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $cr0SA = parcelRequire("cr0SA");

var $eusud = parcelRequire("eusud");

var $koVbs = parcelRequire("koVbs");


var $duvPR = parcelRequire("duvPR");

var $khYiH = parcelRequire("khYiH");
const $9f3563054ff092b8$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $9f3563054ff092b8$export$251bdbdbce9550ea = 400;
const $9f3563054ff092b8$var$UserPickerWrapper = (props)=>{
    const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSelection: onSelection = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDataRequest: onDataRequest = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDataLoaded: onDataLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, menuMinWidth: menuMinWidth, fetchSuggestions: fetchSuggestionsProps, ...fieldProps } = props;
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(Boolean(isDropdownVisibleByDefault));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // null instead of '' because:
    // 1. fetchSuggestions is called as part of useEffect with query as one of the dependencies
    // 2. we dont want to call fetchSuggestions on mount, so added a check query !== null
    // 3. we want to call fetchSuggestions when query is '' and when picker gets focused (we set query as '') when it gets focused
    const [query, setQueryString] = (0, $5uXOq.useState)(null);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [wasFocused, setWasFocused] = (0, $5uXOq.useState)(false);
    const [wasCleared, setWasCleared] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)([]);
    const [sessionId, setSessionId] = (0, $5uXOq.useState)('');
    const getEmptyValue = ()=>emptyOption ? {
            ...emptyOption,
            id: (0, $768a4f0fe483a263$export$61a0b64dfe00294c)
        } : null;
    const debounceTime = withoutDebounce ? 0 : $9f3563054ff092b8$export$251bdbdbce9550ea;
    const requestSuggestionsDebounced = (0, $5uXOq.useMemo)(()=>{
        const isCurrentValue = (userOptionValue)=>{
            if (!userOptionValue) return value === null;
            if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
            return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
        };
        const fetchSuggestions = async ()=>{
            let users = [];
            if (autoCompleteUrl !== undefined) {
                const autoCompleteResponse = await (0, $eusud.performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                users = (0, $khYiH.mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
            }
            return users.map((userData)=>(0, $khYiH.mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
        };
        const handleSuggestions = (newSuggestions)=>{
            if (!isDropdownVisible || !newSuggestions) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
            setIsLoading(false);
            setSuggestions(filteredSuggestions);
            onDataLoaded(!query, filteredSuggestions.length);
        };
        const handleError = ()=>{
            setIsLoading(false);
            setSuggestions([]);
        };
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const requestSuggestions = ()=>{
            onDataRequest(!query);
            if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                handleSuggestions(results);
            }).catch(handleError);
            return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            requestSuggestions();
        }, debounceTime);
    }, [
        debounceTime,
        value,
        autoCompleteUrl,
        query,
        isBulkEdit,
        shouldShowEmailInOptions,
        isDropdownVisible,
        wasFocused,
        onDataLoaded,
        onDataRequest,
        fetchSuggestionsProps,
        sessionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Added extra !isDropdownVisible condition - avoid query when dropdown is closed
        if (query === null || !isDropdownVisible) return;
        requestSuggestionsDebounced();
        return ()=>{
            requestSuggestionsDebounced.cancel();
        };
    }, [
        requestSuggestionsDebounced,
        query,
        isDropdownVisible
    ]);
    const onSelectedValueChangeMulti = (userOptionValue)=>{
        if (userOptionValue && userOptionValue.length === 0) onChange(null);
        else onChange(userOptionValue);
    };
    const onSelectedValueChangeSingle = (userOptionValue)=>{
        const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
        if (valueId === (0, $768a4f0fe483a263$export$61a0b64dfe00294c)) onChange(null);
        else onChange(userOptionValue);
    };
    const onSuggestionSelect = (userOptionValue, sId)=>{
        setSessionId(sId || '');
        setWasFocused(false);
        setWasCleared(false);
        setIsLoading(false);
        setSuggestions([]);
        onSelection(sessionId);
        if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
        else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelectedValueChangeSingle(userOptionValue);
    };
    const onBlur = ()=>{
        setIsDropdownVisible(false);
        setIsLoading(false);
        setWasFocused(false);
        setSuggestions([]);
        if (wasCleared) {
            onSuggestionSelect(getEmptyValue());
            return;
        }
        onCancel();
    };
    const onDropdownOpen = (sId)=>{
        setSessionId(sId || '');
        setQueryString('');
        setIsDropdownVisible(true);
        setIsLoading(true);
        setWasFocused(true);
        setWasCleared(false);
    };
    const onQueryChange = (queryStr, sId)=>{
        setSessionId(sId || '');
        setQueryString(queryStr || '');
        setIsLoading(!!queryStr);
        setWasFocused(false);
        setIsDropdownVisible(!!queryStr);
    };
    const onClear = ()=>{
        setWasCleared(true);
        onSuggestionSelect(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const closeMenuOnScroll = (e)=>{
        if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const isMatchingQuery = (suggestion)=>{
        // when feature flag is false the predict should allow all
        const { displayName: displayName, name: name } = suggestion;
        return !isLoading || $9f3563054ff092b8$var$stringContains(displayName, query) || $9f3563054ff092b8$var$stringContains(name, query);
    };
    const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
    const filteredSuggestions = getSuggestions();
    const pickerValue = value || getEmptyValue();
    const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, $duvPR.default).emptyQueryMessage) : undefined;
    /*
   * user picker default opens on focus, so most of the operations like loading, querying, dropdown open/close are modified during onFocus
   * when openMenuOnClick is true then dropdown state managed internally as like select then have to use onOpen to modify any state like loading, querying
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: onDropdownOpen
    } : {
        open: isDropdownVisible,
        onFocus: onDropdownOpen
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        value: pickerValue,
        options: filteredSuggestions,
        isMulti: isMulti,
        fieldId: fieldId,
        menuMinWidth: menuMinWidth,
        menuPortalTarget: portalElement,
        width: width,
        appearance: appearance,
        isClearable: isClearable,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        placeholder: placeholder,
        onBlur: onBlur,
        isLoading: isLoading && isDropdownVisible,
        onClear: onClear,
        onInputChange: onQueryChange,
        onChange: onSuggestionSelect,
        noBorder: noBorder,
        styles: styles,
        noOptionsMessage: getNoOptionsMessage,
        allowEmail: allowEmail,
        inputId: inputId,
        required: isRequired,
        ariaLabel: fieldProps['aria-label'],
        ariaLabelledBy: fieldProps['aria-labelledby'],
        closeMenuOnScroll: closeMenuOnScroll,
        menuPosition: menuPosition,
        ...controlProps
    });
};
var $9f3563054ff092b8$export$2e2bcd8739ae039 = $9f3563054ff092b8$var$UserPickerWrapper;

});
const $768a4f0fe483a263$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';

parcelRegister("duvPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyQueryMessage: {
        "id": "base-user-picker.empty-query-message",
        "defaultMessage": "Start typing to get a list of possible matches."
    }
});

});

parcelRegister("khYiH", function(module, exports) {

$parcel$export(module.exports, "mapUserObjectToUserOption", () => $5eec43efc9e4eafe$export$e11fc32dba4fe919);
$parcel$export(module.exports, "mapAutoCompleteResponseToUsers", () => $5eec43efc9e4eafe$export$ec325826d2bf6655);

var $jcw0u = parcelRequire("jcw0u");
const $5eec43efc9e4eafe$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
    let userOption = {
        id: userData.accountId || '',
        name: userData.displayName || '',
        avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    };
    if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) // @ts-expect-error - TS2322 - Type '{ byline: string; id: string; name: string; avatarUrl: string; }' is not assignable to type '{ id: string; name: string; avatarUrl: string; }'.
    userOption = {
        ...userOption,
        byline: userData.emailAddress
    };
    return userOption;
};
const $5eec43efc9e4eafe$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
    try {
        if (isBulkEdit) {
            if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return autoCompleteResponse.users;
        } else if (Array.isArray(autoCompleteResponse)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return autoCompleteResponse;
        throw Error('autoCompleteResponse is either null or not expected value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'mapAutoCompleteResponse',
                packageName: 'jiraBaseUserPicker',
                teamName: 'gryffindor'
            },
            error: error,
            skipSentry: true,
            attributes: {
                autoCompleteResponseIsNull: autoCompleteResponse === null
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return [];
};

});





parcelRegister("k5vQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $76983af27be6a3ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hTBEr = parcelRequire("hTBEr");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $cBHNh = parcelRequire("cBHNh");

var $34EcD = parcelRequire("34EcD");

const $76983af27be6a3ff$var$MultiVersionsField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const options = (0, $34EcD.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
    };
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTBEr.default), {
            options: options,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: true,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly || isDisabled,
            autoFocus: autoFocus,
            placeholder: isDisabled ? formatMessage((0, $cBHNh.default).none) : '',
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $cBHNh.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $76983af27be6a3ff$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateMultiVersionsField),
    transformDefaultValue: (0, $34EcD.transformVersionExternalOptionstoVersionOptions),
    shouldRenderFieldMessage: false
})($76983af27be6a3ff$var$MultiVersionsField);

});
parcelRegister("hTBEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c89427d751fd8d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $dTQPF = parcelRequire("dTQPF");
const $87c89427d751fd8d$var$Versions = (props)=>{
    const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, openMenuOnFocus: openMenuOnFocus = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getIsClearable = ()=>{
        if (!isClearable) return false;
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: placeholder,
        options: (0, $dTQPF.getGroupedOptions)((0, $dTQPF.removeArchivedOptions)(options), formatMessage),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        fieldId: fieldId,
        isMulti: isMulti,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(option: VersionOption | VersionOption[] | null) => void' is not assignable to type '(value: VersionOption | OptionsType<VersionOption> | null, action: ActionMeta<VersionOption>) => void'.
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isClearable: getIsClearable(),
        inputId: inputId,
        required: isRequired,
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $87c89427d751fd8d$export$2e2bcd8739ae039 = $87c89427d751fd8d$var$Versions;

});
parcelRegister("dTQPF", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalToVersion", () => $418fd006fc4a31c5$export$c1c38f7974aa8bed);
$parcel$export(module.exports, "removeArchivedOptions", () => $418fd006fc4a31c5$export$6f0b68b6e372a0e6);
$parcel$export(module.exports, "getGroupedOptions", () => $418fd006fc4a31c5$export$721c3d9226425f9c);
$parcel$export(module.exports, "getVersionsIds", () => $418fd006fc4a31c5$export$c96a1607e976ccc6);
$parcel$export(module.exports, "getVersionId", () => $418fd006fc4a31c5$export$d0a84488c5034e2b);

var $lCBBY = parcelRequire("lCBBY");
const $418fd006fc4a31c5$var$getStatusFromRestOption = (option)=>{
    if (option.released) return 'RELEASED';
    if (option.archived) return 'ARCHIVED';
    return 'UNRELEASED';
};
const $418fd006fc4a31c5$export$eb178ff2323a1ab3 = (option)=>({
        label: option.name,
        value: option.id,
        status: $418fd006fc4a31c5$var$getStatusFromRestOption(option)
    });
const $418fd006fc4a31c5$export$c1c38f7974aa8bed = (option)=>({
        label: option.name,
        value: option.id,
        status: option.status
    });
const $418fd006fc4a31c5$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
const $418fd006fc4a31c5$export$721c3d9226425f9c = (options, formatMessage)=>{
    const groupedOptions = [];
    // archived options are assumed to be filtered out already since we don't want to display them. Here, we are grouping according to 'status' being RELEASED or UNRELEASED
    if (options.length) {
        // the order of versions is decided from the first option since the API response follows the order
        const versionOrder = options.length && options[0].status === 'RELEASED' ? [
            'RELEASED',
            'UNRELEASED'
        ] : [
            'UNRELEASED',
            'RELEASED'
        ];
        // @ts-expect-error - TS2345 - Argument of type '(status: Status) => void' is not assignable to parameter of type '(value: string, index: number, array: string[]) => void'.
        versionOrder.forEach((status)=>{
            const statusOptions = options.filter((option)=>option.status === status);
            if (statusOptions.length) groupedOptions.push({
                options: statusOptions,
                label: status === 'RELEASED' ? formatMessage((0, $lCBBY.default).released) : formatMessage((0, $lCBBY.default).unreleased)
            });
        });
    }
    return groupedOptions;
};
const $418fd006fc4a31c5$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
            id: v.value
        }));
const $418fd006fc4a31c5$export$d0a84488c5034e2b = (selectedVersion)=>({
        id: selectedVersion.value
    });

});
parcelRegister("lCBBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958e5bb1549bd80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a958e5bb1549bd80$var$messages = (0, $7VHMR.defineMessages)({
    released: {
        "id": "issue-field-versions.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "issue-field-versions.unreleased",
        "defaultMessage": "Unreleased"
    }
});
var $a958e5bb1549bd80$export$2e2bcd8739ae039 = $a958e5bb1549bd80$var$messages;

});



parcelRegister("cBHNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40c0e93e07915fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b40c0e93e07915fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.multi-versions-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.multi-versions-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("34EcD", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $f99feaf445ed0ec0$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateMultiVersionsField", () => $f99feaf445ed0ec0$export$6999207a9642bd09);

var $dTQPF = parcelRequire("dTQPF");

const $f99feaf445ed0ec0$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dTQPF.transformVersionExternalToVersion)(option));
const $f99feaf445ed0ec0$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $a7d2b97eb2e0b950$export$31fd86f8f183952c),
        versions: selectedVersions.map(({ value: value })=>({
                versionId: value
            }))
    });

});
const $a7d2b97eb2e0b950$export$31fd86f8f183952c = 'multipleVersionPickerFields';



parcelRegister("bo14T", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dfdc9c56d4f0e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $kU4qk = parcelRequire("kU4qk");

const $69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.InputField), {
        type: "number",
        width: width,
        ...rest
    });
};
var $69dfdc9c56d4f0e9$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString),
    transformDefaultValue: (0, $kU4qk.transformAsString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e);

});
parcelRegister("hMKLn", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $c59ad84f24b74144$export$dd2171e2b7d3bc5b);
$parcel$export(module.exports, "default", () => $c59ad84f24b74144$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kY99m = parcelRequire("kY99m");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $lrbT7 = parcelRequire("lrbT7");
const $c59ad84f24b74144$export$dd2171e2b7d3bc5b = (props)=>{
    const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
        onChange: onChange,
        value: value,
        type: type,
        width: width,
        step: "any",
        testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        onWheel: (0, $lrbT7.preventMouseScrollForNumericFieldHandler),
        isDisabled: isReadOnly || rest.isDisabled
    });
};
var $c59ad84f24b74144$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$c59ad84f24b74144$export$dd2171e2b7d3bc5b);

});
parcelRegister("lrbT7", function(module, exports) {

$parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", () => $0fe71c1efa633a57$export$3fedcbfe1c53d8f);
const $0fe71c1efa633a57$export$3fedcbfe1c53d8f = (event)=>{
    if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
};

});


parcelRegister("kU4qk", function(module, exports) {

$parcel$export(module.exports, "transformAsNumber", () => $2648f8f88d1e9261$export$52c4e7404b9db862);
$parcel$export(module.exports, "mutateNumberField", () => $2648f8f88d1e9261$export$6701d4d68ea6db95);
$parcel$export(module.exports, "transformAsString", () => $2648f8f88d1e9261$export$afe59f8094df7220);

const $2648f8f88d1e9261$export$52c4e7404b9db862 = (value)=>{
    if (value) return Number(value);
    return undefined;
};
const $2648f8f88d1e9261$export$6701d4d68ea6db95 = (value, fieldId)=>({
        fieldId: fieldId,
        value: Number(value),
        mutationGroup: (0, $358fca2fc5354374$export$31fd86f8f183952c)
    });
const $2648f8f88d1e9261$export$afe59f8094df7220 = (value)=>{
    if (value !== undefined) return String(value);
    return undefined;
};

});
const $358fca2fc5354374$export$31fd86f8f183952c = 'numberFields';



parcelRegister("4oT51", function(module, exports) {

$parcel$export(module.exports, "default", () => $035663441f65b8aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $y9sir = parcelRequire("y9sir");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $jI6Lk = parcelRequire("jI6Lk");

const $035663441f65b8aa$var$OrganizationsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "organizations-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $y9sir.LazyOrganizationsEdit), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        fetchSuggestionsOnFocus: true
    })));
};
var $035663441f65b8aa$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateOrganizationsField),
    transformDefaultValue: (0, $jI6Lk.mapDataToOrganizationOptions)
})($035663441f65b8aa$var$OrganizationsField);

});
parcelRegister("y9sir", function(module, exports) {

$parcel$export(module.exports, "LazyOrganizationsEdit", () => $731c6e3fc7a471d9$export$f11d485f96c53cba);

var $kxZPA = parcelRequire("kxZPA");

const $731c6e3fc7a471d9$export$f11d485f96c53cba = (0, $kxZPA.lazy)(()=>(parcelRequire("8o08G")).then((module)=>module.OrganizationsEdit), {
    moduleId: "./src/packages/issue/fields/organizations/src/index.tsx"
});

});
parcelRegister("8o08G", function(module, exports) {

let $61b0ac3b237803de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61b0ac3b237803de$var$load("9VJux").then(()=>parcelRequire('brAq4'));

});


parcelRegister("jI6Lk", function(module, exports) {

$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $69c9df32c454e79e$export$bb720a783a78b0f4);
$parcel$export(module.exports, "mutateOrganizationsField", () => $69c9df32c454e79e$export$51fa85dc3b5fc461);
const $69c9df32c454e79e$export$bb720a783a78b0f4 = (data)=>data.map(({ organizationName: organizationName, organizationId: organizationId })=>({
            value: organizationId,
            label: organizationName
        }));
const $69c9df32c454e79e$export$51fa85dc3b5fc461 = (selectedOrganizations, fieldId)=>({
        organizationField: {
            fieldId: fieldId,
            organizations: selectedOrganizations.map(({ value: value })=>({
                    organizationId: value
                }))
        }
    });

});


parcelRegister("8mBES", function(module, exports) {

$parcel$export(module.exports, "default", () => $28698af5fbb25d8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $aIZdc = parcelRequire("aIZdc");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $1iKBB = parcelRequire("1iKBB");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $bA6nL = parcelRequire("bA6nL");

var $eulr6 = parcelRequire("eulr6");

const $28698af5fbb25d8a$export$96c87c0afbe06b37 = (props)=>{
    const { fieldId: fieldId, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /**
   * When creating a sub-task from the GIC modal, we:
   * - pre-populate the parent field in "src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/dropdown-menu-group/button-item/index"
   * - disable the parent field to prevent the user to change it
   *
   * This prevents the user to make a mistake or bump into potential edge cases.
   */ const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1iKBB.ParentFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isExistingIssue: isExistingIssue,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : undefined,
        selectedIssueTypeId: issueTypeId,
        fetchSuggestionsOnFocus: true,
        passedInIssueKey: (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $aIZdc.isFedRamp)() ? issueKey : undefined,
        spacing: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $28698af5fbb25d8a$var$fieldDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bA6nL.default).descriptionIssueTermRefresh : (0, $bA6nL.default).description))));
};
const $28698af5fbb25d8a$var$fieldDescriptionStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
var $28698af5fbb25d8a$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $eulr6.transformDefaultParentValue),
    validator: (0, $eulr6.validateParentField)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentFieldConfig, LegacyValue<Option>>, any>'.
$28698af5fbb25d8a$export$96c87c0afbe06b37);

});
parcelRegister("1iKBB", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $b89ca9fa2a80ab1b$export$55c2cccecfd24751);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck react-select unsupported props

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $koeKL = parcelRequire("koeKL");

var $iVcsU = parcelRequire("iVcsU");

var $inRSh = parcelRequire("inRSh");

var $3orGF = parcelRequire("3orGF");

var $1sPJ0 = parcelRequire("1sPJ0");

var $6v0ju = parcelRequire("6v0ju");
const $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $b89ca9fa2a80ab1b$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy, onSearchParents: onSearchParents, showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $5uXOq.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $5uXOq.useState)(true);
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const lastQuery = (0, $5uXOq.useRef)('');
    const cloudId = (0, $koeKL.useCloudId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const componentProps = (0, $5uXOq.useMemo)(()=>({
            onChange: (event)=>{
                setExcludeDone(!event.target.checked);
            },
            showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible
        }), [
        showDoneIssuesCheckboxVisible
    ]);
    const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sPJ0.default), {
            option: option
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, option.label || `${option.key} ${option.fields.summary}`);
    }, []);
    const searchParents = (0, $5uXOq.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = await (0, $6v0ju.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = await (0, $6v0ju.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        } catch  {
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        let response;
        if (onSearchParents && (0, $4R6GH.fg)('issue_view_in_program_board')) response = await onSearchParents(query);
        else response = await searchParents(query);
        if (lastQuery.current === query) {
            if (response.options !== undefined) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                setSuggestions([]);
                if (query === '') setDefaultSuggestions([]);
            }
            setIsLoading(false);
        }
    }, [
        searchParents,
        onSearchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(requestSuggestions, $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $5uXOq.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>{
        const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $3orGF.default).noMatches);
        // we now get the translated message from the backend, but will fall back to the old message if it's not there
        return hasLastFetchFailed ? formatMessage((0, $3orGF.default).failedFetch) : noOptions;
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $3orGF.default).loading), [
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $5uXOq.useMemo)(()=>spacingProps, [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $iVcsU.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $3orGF.default).placeholder),
        components: {
            Menu: $inRSh.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing,
        "aria-label": formatMessage((0, $3orGF.default).placeholder),
        "aria-labelledby": ariaLabelledBy,
        ...(0, $4R6GH.fg)('issue_view_in_program_board') && {
            menuPlacement: 'auto'
        }
    });
};

});
parcelRegister("iVcsU", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $608100d8bb869e55$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $608100d8bb869e55$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $608100d8bb869e55$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $608100d8bb869e55$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $608100d8bb869e55$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $heWHN = parcelRequire("heWHN");

var $iHPnC = parcelRequire("iHPnC");
const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $heWHN.MAP_COLORS_TO_VALUE)[color];
const $608100d8bb869e55$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
    return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        }));
};
const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $608100d8bb869e55$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $608100d8bb869e55$var$ColorPatch = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $lD23V.default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsbdlk8 _1ul9dlk8 _4t3idlk8 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("inRSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f1b6faa7238bb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $bChGW = parcelRequire("bChGW");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $drCen = parcelRequire("drCen");
const $bc8f1b6faa7238bb$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, ...restProps } = props;
    // note: "isDefaultChecked" is used for VR tests only, therefore it is defaulted to false in production
    const isDefaultChecked = props.selectProps?.componentsProps?.isDefaultChecked || false;
    // default to true if showDoneIssuesCheckboxVisible is undefined
    const showDoneIssuesCheckboxVisible = props.selectProps?.componentsProps?.showDoneIssuesCheckboxVisible !== undefined && (0, $4R6GH.fg)('issue_view_in_program_board') ? props.selectProps.componentsProps.showDoneIssuesCheckboxVisible : true;
    const label = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $drCen.default).checkboxLabelIssueTermRefresh : (0, $drCen.default).checkboxLabel);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Menu, restProps, showDoneIssuesCheckboxVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        defaultChecked: isDefaultChecked,
        onKeyDown: onKeyDown,
        label: label
    })), children);
};
var $bc8f1b6faa7238bb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bc8f1b6faa7238bb$var$Menu;
const $bc8f1b6faa7238bb$var$CheckboxWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _n7zludwz _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("drCen", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c6a6ed4bb83a84$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90c6a6ed4bb83a84$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    },
    checkboxLabelIssueTermRefresh: {
        "id": "issue-field-parent.edit.menu.checkbox-label-issue-term-refresh",
        "defaultMessage": "Show everything marked as done"
    }
});

});


parcelRegister("3orGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57b6631f3fbd470$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f57b6631f3fbd470$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("1sPJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aae186893156b3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eJbwP = parcelRequire("eJbwP");

var $koVbs = parcelRequire("koVbs");

var $iVcsU = parcelRequire("iVcsU");

var $hVITp = parcelRequire("hVITp");
const $3aae186893156b3c$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Description, null, option.description) : null);
const $3aae186893156b3c$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $iVcsU.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
        spacing: "spacious",
        color: "var(--ds-text-success, #216E4E)",
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $3aae186893156b3c$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, $3aae186893156b3c$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $hVITp.default).doneParentLabel), formatMessage((0, $hVITp.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, option.label), $3aae186893156b3c$var$renderOptionDescription(option)));
};
var $3aae186893156b3c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3aae186893156b3c$var$CustomOption;
const $3aae186893156b3c$var$IconWithColor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$DoneWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz131l _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hVITp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c6ab058a23c088$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c3c6ab058a23c088$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("6v0ju", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $2703467b5174b086$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForExisting", () => $2703467b5174b086$export$f995718992ca6c2f);

var $jcw0u = parcelRequire("jcw0u");

var $cWEsa = parcelRequire("cWEsa");

var $cAZGv = parcelRequire("cAZGv");

var $iVcsU = parcelRequire("iVcsU");
const $2703467b5174b086$export$cfeee2ee86ead336 = 'bento';
const $2703467b5174b086$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $cAZGv.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $iVcsU.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $2703467b5174b086$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $2703467b5174b086$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $cWEsa.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $iVcsU.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $2703467b5174b086$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("cWEsa", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $96b7190bd204920f$export$59a0f41a1d5dcee0);


var $jJZqs = parcelRequire("jJZqs");

var $d8JF2 = parcelRequire("d8JF2");

var $2t8So = parcelRequire("2t8So");

var $k90nh = parcelRequire("k90nh");

var $1aPWY = parcelRequire("1aPWY");
const $96b7190bd204920f$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $2t8So.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $k90nh.default)(new Error(message), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, $1aPWY.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};

});
parcelRegister("d8JF2", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $9b9ac42d3f1a3741$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5);

var $bItI4 = parcelRequire("bItI4");
const $9b9ac42d3f1a3741$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$9b9ac42d3f1a3741$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $bItI4.parentCandidatesForExistingIssueQuery)()}
    }
`;

});
parcelRegister("bItI4", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $a63b2f209c365c28$export$f63a6e3151b9dd82);
const $a63b2f209c365c28$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $a63b2f209c365c28$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $a63b2f209c365c28$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $a63b2f209c365c28$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $a63b2f209c365c28$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a63b2f209c365c28$var$issueType()}
      ${$a63b2f209c365c28$var$summary()}
      ${$a63b2f209c365c28$var$status()}
    }
  }
}`;
const $a63b2f209c365c28$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$a63b2f209c365c28$var$color()}
              ${$a63b2f209c365c28$var$fieldsById()}
            }
          }
        }
        message
      }
    }
`;

});


parcelRegister("2t8So", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07071af5f9e15eb$export$2e2bcd8739ae039);

var $d8JF2 = parcelRequire("d8JF2");

var $iBOrg = parcelRequire("iBOrg");
const $b07071af5f9e15eb$export$83bff8b82e36a9e9 = 20;
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$b07071af5f9e15eb$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $b07071af5f9e15eb$export$83bff8b82e36a9e9
    };
    const response = await (0, $iBOrg.getClient)('').query({
        query: (0, $d8JF2.buildParentCandidatesForExistingIssueQuery)(),
        variables: variables
    });
    return response;
};

});

parcelRegister("k90nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $602ab0b685964cde$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");
class $602ab0b685964cde$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $602ab0b685964cde$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $jJZqs.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("1aPWY", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9711633f84674efa$export$3ceb62baab058c6b);


var $gULOk = parcelRequire("gULOk");

var $jJZqs = parcelRequire("jJZqs");

var $heWHN = parcelRequire("heWHN");
const $9711633f84674efa$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (statusField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $gULOk).StatusCategoryIds[(0, $gULOk).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId);
        const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("cAZGv", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $e563dea4a8edeb6a$export$48a29a1313179c04);


var $jJZqs = parcelRequire("jJZqs");

var $78P89 = parcelRequire("78P89");

var $iveGN = parcelRequire("iveGN");

var $k90nh = parcelRequire("k90nh");

var $1aPWY = parcelRequire("1aPWY");
const $e563dea4a8edeb6a$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $iveGN.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $k90nh.default)(new Error(message), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, $1aPWY.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("78P89", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $cf42cbd052db3ab7$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $cf42cbd052db3ab7$export$453f3d2e0fac3592);

var $eVi6b = parcelRequire("eVi6b");
const $cf42cbd052db3ab7$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $cf42cbd052db3ab7$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$cf42cbd052db3ab7$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $eVi6b.parentCandidatesForNewIssueQuery)()}
    }
`;

});
parcelRegister("eVi6b", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $5f9b4891c9749af5$export$1dfd5c8a625d5960);
const $5f9b4891c9749af5$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $5f9b4891c9749af5$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $5f9b4891c9749af5$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $5f9b4891c9749af5$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $5f9b4891c9749af5$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$5f9b4891c9749af5$var$issueType()}
      ${$5f9b4891c9749af5$var$summary()}
      ${$5f9b4891c9749af5$var$status()}
    }
  }
}`;
const $5f9b4891c9749af5$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$5f9b4891c9749af5$var$color()}
                ${$5f9b4891c9749af5$var$fieldsById()}
              }
            }
          }
          message
        }
      }
`;

});


parcelRegister("iveGN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9969b12a843159$export$2e2bcd8739ae039);

var $78P89 = parcelRequire("78P89");

var $iBOrg = parcelRequire("iBOrg");
const $4b9969b12a843159$export$1fd3b40492f4ef9f = 20;
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b9969b12a843159$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $4b9969b12a843159$export$1fd3b40492f4ef9f
    };
    const response = await (0, $iBOrg.getClient)('').query({
        query: (0, $78P89.buildParentCandidatesForNewIssueQuery)(),
        variables: variables,
        operationName: `jira_parenting_${(0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
    });
    return response;
};

});




parcelRegister("bA6nL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53543067399a8c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b53543067399a8c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "issue-create-commons.parent-field.description",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    descriptionIssueTermRefresh: {
        "id": "issue-create-commons.parent-field.description-issue-term-refresh",
        "defaultMessage": "Your work type hierarchy determines the work items you can select here."
    }
});

});

parcelRegister("eulr6", function(module, exports) {

$parcel$export(module.exports, "transformDefaultParentValue", () => $ca97e2610eb77570$export$f38bec4d01c88544);
$parcel$export(module.exports, "validateParentField", () => $ca97e2610eb77570$export$656803053e0b9113);
$parcel$export(module.exports, "mutateParentField", () => $ca97e2610eb77570$export$15ec054c85ac7db1);

var $bGrWH = parcelRequire("bGrWH");

var $heWHN = parcelRequire("heWHN");
const $ca97e2610eb77570$export$f38bec4d01c88544 = (defaultValue)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
    const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
    const summary = summaryField?.node.text;
    const label = `${key} ${summary}`;
    return {
        label: label,
        value: issueId,
        key: key,
        color: issueColorField && issueColorField.color !== null ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
        fields: {
            summary: summary,
            issuetype: {
                name: issueTypeField?.node.issueType.name,
                iconUrl: issueTypeField?.node.issueType.avatar.xsmall
            }
        }
    };
};
const $ca97e2610eb77570$export$656803053e0b9113 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $ca97e2610eb77570$export$15ec054c85ac7db1 = ({ value: value })=>({
        parentField: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueId: value
        }
    });

});


parcelRegister("6GeOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cdc1d313fd94688$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $lzCWA = parcelRequire("lzCWA");

var $bNgRv = parcelRequire("bNgRv");

const $7cdc1d313fd94688$var$PeopleField = (props)=>{
    const { additionalData: { isMulti: isMulti }, autoCompleteUrl: autoCompleteUrl, selectedProject: selectedProject, ...rest } = props;
    const projectKey = selectedProject?.projectKey;
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query)=>{
        const autoCompleteResponse = await (0, $eusud.performGetRequest)(`/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'People',
            ...projectKey && {
                project: projectKey
            },
            query: query ?? ''
        })}`);
        return (autoCompleteResponse ?? []).map((0, $bNgRv.transformToUserOption));
    }, [
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...rest,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        onFetchSuggestions: fetchSuggestions
    });
};
var $7cdc1d313fd94688$export$2e2bcd8739ae039 = $7cdc1d313fd94688$var$PeopleField;

});
parcelRegister("bNgRv", function(module, exports) {

$parcel$export(module.exports, "mutatePeopleField", () => $d3f4b37ab9cd4018$export$62bbb242ba3788ab);
$parcel$export(module.exports, "mapUserOptionOrOptionsToIds", () => $d3f4b37ab9cd4018$export$2ebc7514b112dd56);
$parcel$export(module.exports, "transformToUserOption", () => $d3f4b37ab9cd4018$export$5924759166d7a225);

const $d3f4b37ab9cd4018$export$62bbb242ba3788ab = (selectedValue, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $c84af56c6a8d1839$export$34a73409a6330355),
        users: Array.isArray(selectedValue) ? selectedValue.map((user)=>({
                accountId: user.id
            })) : [
            {
                accountId: selectedValue.id
            }
        ]
    });
const $d3f4b37ab9cd4018$export$2ebc7514b112dd56 = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return [
        {
            id: userOption.id
        }
    ];
};
const $d3f4b37ab9cd4018$export$5924759166d7a225 = (userData)=>({
        id: userData.accountId,
        name: userData.displayName || '',
        avatarUrl: userData.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    });

});
const $c84af56c6a8d1839$export$34a73409a6330355 = 'peopleFields';



parcelRegister("2QZDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29a3848e499878f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4qOqP = parcelRequire("4qOqP");

var $4IxfP = parcelRequire("4IxfP");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hnBts = parcelRequire("hnBts");
const $b29a3848e499878f$var$PriorityField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $4IxfP.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qOqP.default), {
        options: options,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $b29a3848e499878f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validatePriorityField),
    transformDefaultValue: $hnBts.transformDefaultValue
})($b29a3848e499878f$var$PriorityField);

});
parcelRegister("4qOqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00acd3f7bdd60a4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");
const $00acd3f7bdd60a4f$var$PriorityEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, inputId: inputId, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isClearable: isClearable = false, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, menuIsOpen: menuIsOpen, menuPortalTarget: menuPortalTarget, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, styles: styles, formatOptionLabel: formatOptionLabel = (0, $9UhzQ.formatOptionLabel), onCloseMenuOnScroll: onCloseMenuOnScroll } = props;
    const stylesMemoized = (0, $5uXOq.useMemo)(()=>{
        return {
            ...(0, $lElIo.defaultSelectStyles),
            ...styles
        };
    }, [
        styles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: inputId,
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: stylesMemoized,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        formatOptionLabel: formatOptionLabel,
        menuIsOpen: menuIsOpen,
        menuPortalTarget: menuPortalTarget,
        hideSelectedOptions: true,
        closeMenuOnScroll: onCloseMenuOnScroll,
        required: isRequired,
        isClearable: isClearable,
        isDisabled: isDisabled,
        isSearchable: isSearchable,
        classNamePrefix: classNamePrefix,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $00acd3f7bdd60a4f$export$2e2bcd8739ae039 = $00acd3f7bdd60a4f$var$PriorityEdit;

});
parcelRegister("9UhzQ", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $7c6c645af44efe7b$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");
const $7c6c645af44efe7b$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
    }, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$Description, null, description)));
};
const $7c6c645af44efe7b$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c6c645af44efe7b$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$FlexColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4IxfP", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $ae732ed1951f68ed$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ae732ed1951f68ed$export$fc800909123977f3);
const $ae732ed1951f68ed$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        }));
const $ae732ed1951f68ed$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        id: value,
        name: label,
        iconUrl: iconUrl
    });

});

parcelRegister("hnBts", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $f6b5541ab69f5e0c$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutatePriorityField", () => $f6b5541ab69f5e0c$export$2c46dd13be598543);
const $f6b5541ab69f5e0c$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
        label: name,
        value: id,
        iconUrl: iconUrl
    });
const $f6b5541ab69f5e0c$export$2c46dd13be598543 = ({ value: value })=>({
        priority: {
            priorityId: value
        }
    });

});


parcelRegister("lomXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9db325d73e74e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6NfQh = parcelRequire("6NfQh");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $eWiSP = parcelRequire("eWiSP");

const $6a9db325d73e74e6$var$ProjectCF = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', fieldProps: { value: value = null, onChange: onChange, id: id }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NfQh.ProjectCustomFieldEdit), {
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        fetchSuggestionsOnFocus: true,
        "aria-labelledby": ariaLabelledBy,
        fieldId: id || fieldId
    }));
};
var $6a9db325d73e74e6$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $eWiSP.validateProjectField),
    transformDefaultValue: (0, $eWiSP.transformDefaultProjectValue)
})($6a9db325d73e74e6$var$ProjectCF);

});
parcelRegister("6NfQh", function(module, exports) {

$parcel$export(module.exports, "ProjectCustomFieldEdit", () => $6d7c2b47258fee64$export$8d413eb197febcb2);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $dGrdR = parcelRequire("dGrdR");

var $koVbs = parcelRequire("koVbs");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");

var $9kbEN = parcelRequire("9kbEN");

var $FtZX9 = parcelRequire("FtZX9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fFrY4 = parcelRequire("fFrY4");

var $8OYXe = parcelRequire("8OYXe");
const $6d7c2b47258fee64$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $6d7c2b47258fee64$var$PROJECT_OPTIONS_LOADED = 'issue-field-project-options-loaded';
const $6d7c2b47258fee64$var$projectOptionsLoadedMetric = (0, $dGrdR.metrics).custom({
    key: $6d7c2b47258fee64$var$PROJECT_OPTIONS_LOADED
});
const $6d7c2b47258fee64$export$8d413eb197febcb2 = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, blurInputOnSelect: blurInputOnSelect, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, hideSelectedOptions: hideSelectedOptions, onChange: onChange, onCloseMenuOnScroll: onCloseMenuOnScroll, openMenuOnFocus: openMenuOnFocus, spacing: spacing, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, isInvalid: isInvalid = false, value: value = null, onBlur: onBlur, 'aria-labelledby': ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const isInSampleAnalytics = (0, $5uXOq.useRef)((0, $9kbEN.isInSample)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOptionsLoadedAnalyticsEvent = (duration)=>{
        const action = 'loaded';
        const actionSubject = 'projectFieldOptions';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const attrs = {
            duration: duration
        };
        (0, $8zOmE.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
    };
    const searchProjects = async (query = '')=>{
        setLastFetchFailed(false);
        isInSampleAnalytics.current && $6d7c2b47258fee64$var$projectOptionsLoadedMetric.start();
        return (0, $8OYXe.fetchProjects)(query, autoCompleteUrl).then((projectsData)=>{
            if (isInSampleAnalytics.current) {
                $6d7c2b47258fee64$var$projectOptionsLoadedMetric.stop();
                const { start: start, stop: stop } = $6d7c2b47258fee64$var$projectOptionsLoadedMetric.getData();
                const duration = stop && start ? stop - start : null;
                fireOptionsLoadedAnalyticsEvent(duration);
            }
            return projectsData;
        }).catch(()=>{
            isInSampleAnalytics.current && $6d7c2b47258fee64$var$projectOptionsLoadedMetric.cancel();
            setLastFetchFailed(true);
            return [];
        });
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchProjects();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    // go/jfe-eslint
    const loadOptionsDebounced = (0, $FtZX9.default)(searchProjects, $6d7c2b47258fee64$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $fFrY4.default).failedFetch : (0, $fFrY4.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    // NOTE: Only used for drilling down `react-select` props!
    // See: https://react-select.com/props
    const additionalSelectProps = {
        blurInputOnSelect: blurInputOnSelect,
        hideSelectedOptions: hideSelectedOptions,
        openMenuOnFocus: openMenuOnFocus,
        spacing: spacing
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        fieldId: fieldId,
        autoFocus: autoFocus,
        ...defaultOptionsProps(),
        ...additionalSelectProps,
        isClearable: true,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
        loadOptions: loadOptionsDebounced,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $fFrY4.default).placeholder),
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        "aria-labelledby": ariaLabelledBy,
        inputId: fieldId
    });
};

});
parcelRegister("9kbEN", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $b9c2013a86366ec0$export$a994c91d08ead5ff);

const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $670519621927ccc4$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("fFrY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $54cd2640719875e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54cd2640719875e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-project.edit.async-project-cf.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-project.edit.async-project-cf.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-project.edit.async-project-cf.placeholder",
        "defaultMessage": "Select project"
    },
    loading: {
        "id": "issue-field-project.edit.async-project-cf.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("8OYXe", function(module, exports) {

$parcel$export(module.exports, "fetchProjects", () => $01b71453e2061823$export$f0d2ca471cdb99b0);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $1D0eh = parcelRequire("1D0eh");
const $01b71453e2061823$export$f0d2ca471cdb99b0 = async (inputValue, autoCompleteUrl)=>(0, $eusud.performGetRequest)(`${autoCompleteUrl}${inputValue}`).then((response)=>(0, $1D0eh.mapDataToOptions)(response.values)).catch((error)=>{
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchProjects',
            packageName: 'jiraIssueFieldProject',
            logToSentry: !(0, $jJZqs.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });

});
parcelRegister("1D0eh", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $ee5bde84b258a4cc$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $ee5bde84b258a4cc$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ee5bde84b258a4cc$export$fc800909123977f3);
const $ee5bde84b258a4cc$export$5c1e24ea9ccb80aa = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatarUrls['48x48'],
        projectId: data.id
    });
const $ee5bde84b258a4cc$export$99a866ffa3af7d8b = (data)=>data.map($ee5bde84b258a4cc$export$5c1e24ea9ccb80aa);
const $ee5bde84b258a4cc$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        key: value,
        name: label,
        avatarUrls: {
            '48x48': iconUrl
        }
    });

});



parcelRegister("eWiSP", function(module, exports) {

$parcel$export(module.exports, "mutateProjectField", () => $d63b347c9d814150$export$fb6480503bf79949);
$parcel$export(module.exports, "validateProjectField", () => $d63b347c9d814150$export$5c1e30a9f731caaf);
$parcel$export(module.exports, "transformDefaultProjectValue", () => $d63b347c9d814150$export$c77f86922e480ac0);

var $bGrWH = parcelRequire("bGrWH");
const $d63b347c9d814150$export$fb6480503bf79949 = (selectedProject, fieldId)=>({
        projectFields: [
            {
                fieldId: fieldId,
                project: {
                    projectId: selectedProject.projectId || ''
                }
            }
        ]
    });
const $d63b347c9d814150$export$5c1e30a9f731caaf = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $d63b347c9d814150$export$c77f86922e480ac0 = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatar.large,
        projectId: data.id
    });

});


parcelRegister("3mcIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b39b2f7e2adcce5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l8nrv = parcelRequire("l8nrv");

var $8TLRF = parcelRequire("8TLRF");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $8tTRx = parcelRequire("8tTRx");
const $0b39b2f7e2adcce5$export$a314277471067e8a = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false, ...fieldProps }, error: error, allowedValues: allowedValues, isReadOnly: isReadOnly = false } = props;
    const options = (0, $8TLRF.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8nrv.default), {
        ...fieldProps,
        options: options,
        isDisabled: isReadOnly || isDisabled,
        value: value,
        onChange: onChange,
        isInvalid: Boolean(error)
    }));
};
var $0b39b2f7e2adcce5$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateRadioGroupField),
    transformDefaultValue: $8tTRx.transformDefaultValue
})($0b39b2f7e2adcce5$export$a314277471067e8a);

});
parcelRegister("l8nrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b71e9e78a24d10c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3rLiX = parcelRequire("3rLiX");
const $8b71e9e78a24d10c$var$RadioGroupEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, isInvalid: isInvalid, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rLiX.default), {
        ...fieldProps,
        // radio group component handles undefined and null differently, pay attention when change value property
        value: value === null ? value : value?.value,
        options: options,
        isDisabled: isDisabled,
        onChange: (e)=>onChange(options.find((option)=>option.value === e?.target?.value) || null),
        isInvalid: isInvalid
    });
};
var $8b71e9e78a24d10c$export$2e2bcd8739ae039 = $8b71e9e78a24d10c$var$RadioGroupEdit;

});
parcelRegister("3rLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ca8b717dad009c8c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $jouoW = parcelRequire("jouoW");
const $ca8b717dad009c8c$var$noOptions = [];
function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $eGmKJ.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $9KnKW.useId)();
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $jouoW.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});



parcelRegister("8TLRF", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $cc42529534176e68$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $cc42529534176e68$export$fc800909123977f3);
const $cc42529534176e68$export$99a866ffa3af7d8b = (data)=>data?.map(({ id: id, value: value })=>({
            label: value,
            value: id,
            testId: id
        }));
const $cc42529534176e68$export$fc800909123977f3 = (option)=>({
        id: option?.value,
        value: option?.label
    });

});

parcelRegister("8tTRx", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $58a2b2055d1ede67$export$e2f4e5d31db527cc);
const $58a2b2055d1ede67$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
        label: value,
        value: id,
        testId: id
    });

});


parcelRegister("cOF52", function(module, exports) {

$parcel$export(module.exports, "default", () => $a350fdd513ab8bcb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $apGhO = parcelRequire("apGhO");

var $5kDIl = parcelRequire("5kDIl");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");
const $a350fdd513ab8bcb$var$ReporterField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, isRequired: isRequired, isReadOnly: isReadOnly = false, selectedProject: selectedProject } = props;
    const { projectType: projectType, projectKey: projectKey } = selectedProject || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apGhO.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        appearance: "normal",
        isDisabled: isReadOnly,
        autoCompleteUrl: `/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'Reporter',
            ...projectKey && {
                project: projectKey
            },
            query: ''
        })}`,
        isMulti: false,
        autoFocus: autoFocus,
        isClearable: !isRequired,
        allowEmail: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
        width: width,
        inputId: fieldProps.id,
        openMenuOnClick: true
    }));
};
var $a350fdd513ab8bcb$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateUserPickerField),
    transformDefaultValue: (0, $5kDIl.transformJiraUserToUserOption)
})($a350fdd513ab8bcb$var$ReporterField);

});
parcelRegister("apGhO", function(module, exports) {

$parcel$export(module.exports, "default", () => $657c7bee8e84f91c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jOrdN = parcelRequire("jOrdN");

var $khYiH = parcelRequire("khYiH");

var $5fc53 = parcelRequire("5fc53");

var $cYlk7 = parcelRequire("cYlk7");

var $1j4Sa = parcelRequire("1j4Sa");
const $657c7bee8e84f91c$var$ReporterEdit = (props)=>{
    const { allowEmail: allowEmail = false, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value = null, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, onCancel: onCancel, isClearable: isClearable = true, fetchSuggestions: fetchSuggestionsProps, shouldSetDefaultValue: shouldSetDefaultValueProp = true, openMenuOnClick: openMenuOnClick = false, ...fieldProps } = props;
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const shouldSetDefaultValue = (0, $5uXOq.useRef)(!value && shouldSetDefaultValueProp);
    // to store default value in form field wrapper if value is not set
    (0, $5uXOq.useEffect)(()=>{
        if (shouldSetDefaultValue.current && user && !value) {
            shouldSetDefaultValue.current = false;
            onChange((0, $khYiH.mapUserObjectToUserOption)(user, true));
        }
    }, [
        onChange,
        user,
        value
    ]);
    const fetchSuggestionsCallback = (0, $5uXOq.useCallback)(async (query)=>(0, $1j4Sa.fetchSuggestions)(autoCompleteUrl, query), [
        autoCompleteUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOrdN.default), {
        ...fieldProps,
        appearance: appearance,
        width: width,
        fieldId: (0, $5fc53.REPORTER_TYPE),
        autoCompleteUrl: autoCompleteUrl,
        // @ts-expect-error TS2322: Type (arg1: UserOption) => void is not assignable to type (arg1: UserOption | UserOption[]) => void
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        fetchSuggestions: fetchSuggestionsProps || fetchSuggestionsCallback,
        onSelection: onSelection,
        onCancel: onCancel,
        isClearable: isClearable,
        allowEmail: allowEmail,
        shouldShowEmailInOptions: true,
        openMenuOnClick: openMenuOnClick,
        "aria-labelledby": fieldProps['aria-labelledby']
    });
};
var $657c7bee8e84f91c$export$2e2bcd8739ae039 = $657c7bee8e84f91c$var$ReporterEdit;

});
parcelRegister("1j4Sa", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestions", () => $4c0a03770fcb0e17$export$ebf2f44fe450da2b);

var $khYiH = parcelRequire("khYiH");

var $eusud = parcelRequire("eusud");
const $4c0a03770fcb0e17$export$ebf2f44fe450da2b = async (autoCompleteUrl, query)=>{
    let users = [];
    const url = `${autoCompleteUrl}${query || ''}`;
    const suggestionsResponse = await (0, $eusud.performGetRequest)(url) || [];
    if (Array.isArray(suggestionsResponse)) // user/search returns array
    users = suggestionsResponse.map((userFromApi)=>(0, $khYiH.mapUserObjectToUserOption)(userFromApi, true));
    else if (suggestionsResponse.users) // user/picker returns object
    // @ts-expect-error - TS7006 - Parameter 'userFromApi' implicitly has an 'any' type.
    users = suggestionsResponse.users.map((userFromApi)=>(0, $khYiH.mapUserObjectToUserOption)(userFromApi, true));
    return users;
};

});



parcelRegister("5w5Vs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c879cc6a6a1de63f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bxulX = parcelRequire("bxulX");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $aPEdI = parcelRequire("aPEdI");

const $c879cc6a6a1de63f$var$ResolutionField = (props)=>{
    const { allowedValues: allowedValues, fieldId: fieldId, width: width, error: error, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "inline-resolution-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxulX.AsyncInlineResolutionEdit), {
        ...fieldProps,
        options: (0, $aPEdI.mapAllowedValuesToSelectOptions)(allowedValues),
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: ResolutionOption) => void' is not assignable to type '(option: ResolutionOption) => Promise<undefined> | undefined'.
        onChange: onChange,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        classNamePrefix: `resolution-field-${fieldId}`,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    })));
};
var $c879cc6a6a1de63f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aPEdI.transformDefaultResolutionValue),
    validator: (0, $jGVMX.validateResolutionField)
})($c879cc6a6a1de63f$var$ResolutionField);

});
parcelRegister("bxulX", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineResolutionEdit", () => $4a42014a1b6e02a2$export$af39bdbe1dcb0a1e);

var $kxZPA = parcelRequire("kxZPA");

const $4a42014a1b6e02a2$export$af39bdbe1dcb0a1e = (0, $kxZPA.lazy)(()=>(parcelRequire("cruXu")).then((module)=>module.InlineResolutionEdit), {
    moduleId: "./src/packages/issue/fields/resolution/src/index.tsx"
});

});
parcelRegister("cruXu", function(module, exports) {

let $90f0055d4043b2e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $90f0055d4043b2e4$var$load("5DsWX").then(()=>parcelRequire('llFf1'));

});


parcelRegister("aPEdI", function(module, exports) {

$parcel$export(module.exports, "mapAllowedValuesToSelectOptions", () => $b5ab8485a7a041fe$export$103f56c5c26f12e5);
$parcel$export(module.exports, "transformDefaultResolutionValue", () => $b5ab8485a7a041fe$export$dbeca145fe19aaf1);
$parcel$export(module.exports, "mutateResolutionField", () => $b5ab8485a7a041fe$export$a08b1e842f0a7a26);
const $b5ab8485a7a041fe$export$103f56c5c26f12e5 = (allowedValues)=>allowedValues.map((value)=>({
            value: value.id,
            label: value.name
        }));
const $b5ab8485a7a041fe$export$dbeca145fe19aaf1 = (value)=>({
        value: value.id,
        label: value.name
    });
const $b5ab8485a7a041fe$export$a08b1e842f0a7a26 = (selectedResolution)=>({
        resolution: {
            resolutionId: selectedResolution.value
        }
    });

});


parcelRegister("7gcm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cc39b6f15c02c20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $dQLtU = parcelRequire("dQLtU");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $7Pdzq = parcelRequire("7Pdzq");
const $5cc39b6f15c02c20$var$RespondersField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', placeholder: placeholder = '', isDisabled: isDisabled = false } = props;
    const onFetchSuggestions = async (query)=>{
        let responders = [];
        if (autoCompleteUrl !== undefined) {
            let autoCompleteResponse;
            try {
                autoCompleteResponse = await (0, $eusud.performGetRequest)(`${autoCompleteUrl}/?query=${query || ''}`);
            } catch (err) {
                return [];
            }
            if (autoCompleteResponse.responders) responders = autoCompleteResponse.responders;
        }
        return (0, $7Pdzq.transformDefaultUserValues)(responders);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dQLtU.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        placeholder: placeholder,
        isDisabled: isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true
    }));
};
var $5cc39b6f15c02c20$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateUserPickerField),
    transformDefaultValue: (0, $7Pdzq.transformDefaultUserValues)
})($5cc39b6f15c02c20$var$RespondersField);

});
parcelRegister("7Pdzq", function(module, exports) {

$parcel$export(module.exports, "transformDefaultUserValues", () => $78f37c024ed928fb$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToAris", () => $78f37c024ed928fb$export$80dc4fd89a4c227d);
const $78f37c024ed928fb$var$transformResponderTypeToUserOption = (userData)=>({
        id: userData?.ari || '',
        name: userData?.name || '',
        avatarUrl: userData?.avatarUrl || ''
    });
const $78f37c024ed928fb$var$validateDefaultValue = (responder)=>{
    if (responder === null || responder === undefined) return false;
    if (!responder.ari || !responder.name) return false;
    return true;
};
const $78f37c024ed928fb$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (defaultValue === null || defaultValue === undefined) return [];
    return defaultValue.filter($78f37c024ed928fb$var$validateDefaultValue).map($78f37c024ed928fb$var$transformResponderTypeToUserOption);
};
const $78f37c024ed928fb$var$mapUserOptionToAri = (userData)=>({
        ari: userData.id
    });
const $78f37c024ed928fb$export$80dc4fd89a4c227d = (userData)=>userData.map($78f37c024ed928fb$var$mapUserOptionToAri);

});


parcelRegister("3Z98Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebb6e060acd861c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9EuZf = parcelRequire("9EuZf");

var $5fnvk = parcelRequire("5fnvk");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $d8h6M = parcelRequire("d8h6M");

const $4ebb6e060acd861c$var$SingleGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        autoFocus: autoFocus,
        isMulti: false,
        "aria-labelledby": ariaLabelledBy,
        width: width,
        isInvalid: Boolean(error),
        placeholder: " ",
        ...getExtraProps()
    });
};
var $4ebb6e060acd861c$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateGroupPickerField),
    transformDefaultValue: (0, $d8h6M.transformGroupDefaultValueToUserOption)
})($4ebb6e060acd861c$var$SingleGroupPickerField);

});
parcelRegister("d8h6M", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $dab4f2debb035d9d$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateSingleGroupPickerField", () => $dab4f2debb035d9d$export$daeca2ffaa5d8b62);

var $arYvt = parcelRequire("arYvt");

const $dab4f2debb035d9d$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    return (0, $arYvt.transformGroupToUserOption)(group);
};
const $dab4f2debb035d9d$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
        fieldId: fieldId,
        group: {
            groupName: selectedGroup.name
        },
        mutationGroup: (0, $b977eeb5f24a5299$export$31fd86f8f183952c)
    });

});
const $b977eeb5f24a5299$export$31fd86f8f183952c = 'singleGroupPickerFields';



parcelRegister("k4tyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $108361897c01a8f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d3RWa = parcelRequire("d3RWa");

const $108361897c01a8f5$var$SingleSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3RWa.default), {
        ...props,
        isMulti: false,
        closeMenuOnSelect: true
    });
var $108361897c01a8f5$export$2e2bcd8739ae039 = $108361897c01a8f5$var$SingleSelectField;

});

parcelRegister("6HBPo", function(module, exports) {

$parcel$export(module.exports, "mutateSingleSelectField", () => $6b9da676db8f86c9$export$35684f6945108587);
$parcel$export(module.exports, "mapSelectOptionsToConnectData", () => $6b9da676db8f86c9$export$ed4050ca50f08036);

const $6b9da676db8f86c9$export$35684f6945108587 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $7d67a5d2a03fd88c$export$31fd86f8f183952c),
        option: {
            optionId: value
        }
    });
const $6b9da676db8f86c9$export$ed4050ca50f08036 = (option)=>option.value;

});
const $7d67a5d2a03fd88c$export$31fd86f8f183952c = 'singleSelectFields';


parcelRegister("lfWSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dbbb313a8b6153d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lzCWA = parcelRequire("lzCWA");
const $8dbbb313a8b6153d$var$SingleUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...props,
        isMulti: false,
        context: "CustomUserField"
    });
var $8dbbb313a8b6153d$export$2e2bcd8739ae039 = $8dbbb313a8b6153d$var$SingleUserPickerField;

});

parcelRegister("aQNfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04647b01be2b83f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hTBEr = parcelRequire("hTBEr");

var $dTQPF = parcelRequire("dTQPF");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $jrGSc = parcelRequire("jrGSc");

var $1AaWN = parcelRequire("1AaWN");

const $d04647b01be2b83f$var$SingleVersionField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
    };
    const options = (0, $1AaWN.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTBEr.default), {
            options: options,
            value: value,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: false,
            isDisabled: isDisabled,
            placeholder: isDisabled ? formatMessage((0, $jrGSc.default).none) : '',
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jrGSc.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $d04647b01be2b83f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateSingleVersionField),
    transformDefaultValue: (0, $dTQPF.transformVersionExternalToVersion),
    shouldRenderFieldMessage: false
})($d04647b01be2b83f$var$SingleVersionField);

});
parcelRegister("jrGSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5396ea8e93f1b004$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5396ea8e93f1b004$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.single-version-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.single-version-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("1AaWN", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $79dd8b3734a0e456$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateSingleVersionField", () => $79dd8b3734a0e456$export$57ed62196c76c8b6);

var $dTQPF = parcelRequire("dTQPF");

const $79dd8b3734a0e456$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dTQPF.transformVersionExternalToVersion)(option));
const $79dd8b3734a0e456$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $703505cc37235a2c$export$31fd86f8f183952c),
        version: {
            versionId: value
        }
    });

});
const $703505cc37235a2c$export$31fd86f8f183952c = 'singleVersionPickerFields';



parcelRegister("3pqs3", function(module, exports) {

$parcel$export(module.exports, "SprintField", () => $83fe5b61920278eb$export$617303ef516d5a01);
$parcel$export(module.exports, "default", () => $83fe5b61920278eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $io7kF = parcelRequire("io7kF");

var $3spCR = parcelRequire("3spCR");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $ahEu3 = parcelRequire("ahEu3");

var $aqMtW = parcelRequire("aqMtW");

const $83fe5b61920278eb$export$617303ef516d5a01 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
    const renderSprintEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $io7kF.default), {
            fieldId: fieldId,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            fetchSuggestionsOnMount: false,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false,
            getSuggestions: (0, $aqMtW.getSprintSuggestions),
            ...selectedProject?.projectKey ? {
                projectKey: selectedProject?.projectKey
            } : {},
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, renderSprintEdit()) : renderSprintEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), value && value.state === (0, $3spCR.ACTIVE_SPRINT_STATE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $83fe5b61920278eb$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning",
        testId: "issue-create-commons.ui.sprint-field.required-fields-message"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ahEu3.default).activeSprintSelectionWarningMessageIssueTermRefresh : (0, $ahEu3.default).activeSprintSelectionWarningMessage))) : null);
};
var $83fe5b61920278eb$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aqMtW.transformDefaultSprintValue),
    shouldRenderFieldMessage: false
})($83fe5b61920278eb$export$617303ef516d5a01);
const $83fe5b61920278eb$var$messageContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("io7kF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42898dffd6db898$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");

var $gcvId = parcelRequire("gcvId");

var $5fc53 = parcelRequire("5fc53");

var $249dD = parcelRequire("249dD");

var $bW9R0 = parcelRequire("bW9R0");

var $egtXp = parcelRequire("egtXp");

var $gxJKL = parcelRequire("gxJKL");

var $ckVH2 = parcelRequire("ckVH2");
const $e42898dffd6db898$export$251bdbdbce9550ea = 300;
const $e42898dffd6db898$var$SprintEdit = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $5fc53.SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus, 'aria-labelledby': ariaLabelledBy } = props;
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const [restrictSprints, setRestrictSprint] = (0, $5uXOq.useState)((0, $egtXp.getCheckboxValueFromLocalStorage)((0, $egtXp.EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $bW9R0.useSprintSuggestions)({
        getSuggestions: getSuggestions
    });
    const onCheckboxClick = (0, $5uXOq.useCallback)(()=>{
        setRestrictSprint(!restrictSprints);
        (0, $egtXp.setCheckBoxValueInLocalStorage)((0, $egtXp.EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
    }, [
        restrictSprints
    ]);
    const componentProps = (0, $5uXOq.useMemo)(()=>({
            isChecked: restrictSprints,
            onChange: onCheckboxClick,
            projectKey: projectKey
        }), [
        restrictSprints,
        projectKey,
        onCheckboxClick
    ]);
    const handleSuggestions = (0, $5uXOq.useCallback)((results, query)=>{
        if (lastQuery.current === query) {
            const transformSuggestions = useTransformSuggestions || (0, $249dD.transformSuggestions);
            const response = transformSuggestions(results, formatMessage);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        useTransformSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $ckVH2.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            let response;
            if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
            else response = await getSprintSuggestions(autoCompleteUrl, query);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        autoCompleteUrl,
        restrictSprints,
        projectKey,
        getFailedFetchMessage,
        getSprintSuggestions,
        handleSuggestions
    ]);
    if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fetchSuggestions, $e42898dffd6db898$export$251bdbdbce9550ea), [
        restrictSprints
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $ckVH2.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $ckVH2.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        fetchSuggestions,
        onFocus,
        setIsLoadingSuggestions,
        suggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onValueChange = (0, $5uXOq.useCallback)((newValues)=>{
        // We're passing in suggestions for validation
        // e.g., if selected sprint is active and will affect the issue
        onChange && onChange(newValues, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    // Fetch the suggestions again if user toggles the checkbox
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        restrictSprints,
        debouncedFetchSuggestions,
        setIsLoadingSuggestions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcvId.default), {
        inputId: inputId,
        isRequired: isRequired,
        isClearable: true,
        hideSelectedOptions: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: suggestions,
        value: value,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        componentsProps: projectKey ? componentProps : undefined,
        components: projectKey ? {
            Menu: $gxJKL.default
        } : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $ckVH2.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onValueChange,
        spacing: spacing,
        isLoading: isLoadingSuggestions,
        filterOption: filterOption,
        formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
        validationState: isInvalid === true ? 'error' : null,
        isDisabled: isDisabled,
        openMenuOnFocus: openMenuOnFocus,
        "aria-labelledby": ariaLabelledBy
    });
};
var $e42898dffd6db898$export$2e2bcd8739ae039 = $e42898dffd6db898$var$SprintEdit;

});
parcelRegister("gcvId", function(module, exports) {

$parcel$export(module.exports, "default", () => $2132d0cd1f409256$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $7Jxgt = parcelRequire("7Jxgt");

var $iOwNT = parcelRequire("iOwNT");

var $6RCeq = parcelRequire("6RCeq");

var $koVbs = parcelRequire("koVbs");

var $db8jg = parcelRequire("db8jg");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8z9w3 = parcelRequire("8z9w3");

var $dKKqb = parcelRequire("dKKqb");
const $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $2132d0cd1f409256$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $2132d0cd1f409256$export$53574ab050410077 = (0, $2OMDV.AnalyticsEventToProps)('select', $2132d0cd1f409256$var$analyticsProps)((0, $iOwNT.default));
const $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel = '' } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasSessionStarted = (0, $5uXOq.useRef)(false);
    const sessionId = (0, $5uXOq.useRef)(customSessionId);
    const sessionStartedAt = (0, $5uXOq.useRef)(0);
    const endSessionRef = (0, $5uXOq.useRef)(undefined);
    const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
    const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flatOptions = (0, $5uXOq.useMemo)(()=>(0, $dKKqb.flattenOptions)(options), [
        options
    ]);
    const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? value : [];
        let filteredOptions = (0, $dKKqb.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $dKKqb.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            optionsLength: optionsLength,
            componentName: 'select',
            // TODO: update the lib's version after the bump
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $dKKqb.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $db8jg.memoizedHashString)(query),
            selectedOptions: (0, $dKKqb.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $dKKqb.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading
    ]);
    const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $7Jxgt.v4)();
        sessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $6RCeq.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $5uXOq.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $dKKqb.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $dKKqb.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $dKKqb.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        onChange && onChange(selectedOptionOrOptions, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange
    ]);
    const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange && onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)(()=>!!canCreateNewItem, [
        canCreateNewItem
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSessionStarted.current) {
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            hasSessionStarted.current = true;
        }
    }, [
        createAnalyticsEvent,
        fireInputChangedEvent,
        startSession
    ]);
    (0, $5uXOq.useEffect)(()=>{
        endSessionRef.current = endSession;
    }, [
        endSession
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            endSessionRef.current && endSessionRef.current();
        }, // In order to avoid triggering this cleanup when the endSession callback is updated by adding a dependency to endSession here,
    // we call it via a ref instead
    []);
    const { isRequired: required, ...propsWithoutRequired } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2132d0cd1f409256$export$53574ab050410077, {
        ...propsWithoutRequired,
        required: isRequired,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics,
        isValidNewOption: isValidNewOption,
        label: ariaLabel || formatMessage((0, $8z9w3.default).ariaLabelForSelect)
    });
};
var $2132d0cd1f409256$export$2e2bcd8739ae039 = $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("8z9w3", function(module, exports) {

$parcel$export(module.exports, "default", () => $283d0de21cddfa94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $283d0de21cddfa94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabelForSelect: {
        "id": "issue-field-select-with-analytics.ariaLabel",
        "defaultMessage": "Select Field"
    }
});

});

parcelRegister("dKKqb", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $52dde5a2f186bbcb$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $52dde5a2f186bbcb$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $52dde5a2f186bbcb$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $52dde5a2f186bbcb$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $52dde5a2f186bbcb$export$60d56ed3961c839c);

var $chc6P = parcelRequire("chc6P");

var $db8jg = parcelRequire("db8jg");
const $52dde5a2f186bbcb$export$d05672fd1312a6d = (val)=>(0, $db8jg.memoizedHashString)(val.toString()).toString();
const $52dde5a2f186bbcb$export$fde3d804891b8254 = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$52dde5a2f186bbcb$export$d05672fd1312a6d(value));
};
const $52dde5a2f186bbcb$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
            optionOrGroup
        ]));
const $52dde5a2f186bbcb$export$e2e167245697ed4e = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
};
const $52dde5a2f186bbcb$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("249dD", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $cfadc135289d0d3a$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $cfadc135289d0d3a$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $cfadc135289d0d3a$export$1d0ee4320c26fb60);

var $3spCR = parcelRequire("3spCR");

var $e7pk8 = parcelRequire("e7pk8");
const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
};
const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $3spCR.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $e7pk8.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $e7pk8.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("e7pk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f3d56beb10e0cde$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});


parcelRegister("bW9R0", function(module, exports) {

$parcel$export(module.exports, "useSprintSuggestions", () => $76a69867a9473261$export$16d0ab78a0b529dc);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
    maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
    maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
});
const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
    let queryString;
    if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
    else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
    return (0, $eusud.performGetRequest)(queryString);
};
const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
    const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
        try {
            const response = await getSuggestions(autoCompleteUrl, query, projectKey);
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getSprintSuggestions: getSprintSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getSprintSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;


parcelRegister("egtXp", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", () => $da54a1ad644b3ed6$export$90fd8fcc9388370d);
$parcel$export(module.exports, "getCheckboxValueFromLocalStorage", () => $da54a1ad644b3ed6$export$b6ec857d138d143b);
$parcel$export(module.exports, "setCheckBoxValueInLocalStorage", () => $da54a1ad644b3ed6$export$1750bf12ee05e0ac);

var $ebyGx = parcelRequire("ebyGx");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
// TODO : Add a prefix to identify each app and also make sure you update the same in test
const $da54a1ad644b3ed6$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $da54a1ad644b3ed6$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search).view || '';
const $da54a1ad644b3ed6$export$d5e150c1e3186bd1 = ()=>$da54a1ad644b3ed6$var$getViewMode().includes('planning');
const $da54a1ad644b3ed6$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
const $da54a1ad644b3ed6$export$b6ec857d138d143b = (key)=>{
    let value;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) value = $da54a1ad644b3ed6$var$localStorageProvider.get(key);
    else if (typeof window !== 'undefined') value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : true;
};
const $da54a1ad644b3ed6$export$1750bf12ee05e0ac = (key, value)=>{
    try {
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $da54a1ad644b3ed6$var$localStorageProvider.set(key, value);
        else if (typeof window !== 'undefined') // @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
        window.localStorage.setItem(key, value);
    } catch  {
    // do nothing
    }
};

});

parcelRegister("gxJKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb901ddd959c90f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $ghRU5 = parcelRequire("ghRU5");

var $kacDU = parcelRequire("kacDU");
const $fb901ddd959c90f6$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const projectKey = props.selectProps?.componentsProps?.projectKey || null;
    const label = formatMessage((0, $ghRU5.default).checkboxLabel, {
        projectKey: projectKey
    });
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kacDU.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        label: label,
        testId: "issue-field-sprint.ui.edit.menu.checkbox"
    })), children)));
};
var // @ts-expect-error - TS2352 - Conversion of type '(props: Props) => JSX.Element' to type 'ReactNode' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$fb901ddd959c90f6$export$2e2bcd8739ae039 = $fb901ddd959c90f6$var$Menu;

});
parcelRegister("ghRU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7044cf08eb2bc7be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7044cf08eb2bc7be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-sprint.edit.menu.checkbox-label",
        "defaultMessage": "Only show sprints in this project ({projectKey})"
    }
});

});

parcelRegister("kacDU", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $38a94e57c20f776f$export$eef12940a6696c78);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $38a94e57c20f776f$export$eef12940a6696c78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zludwz _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ckVH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe9503663e56e29$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fe9503663e56e29$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-sprint.edit.placeholder",
        "defaultMessage": "Select sprint"
    },
    empty: {
        "id": "issue-field-sprint.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-sprint.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loading: {
        "id": "issue-field-sprint.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});


parcelRegister("ahEu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77c8f330a49e37f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e77c8f330a49e37f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprintSelectionWarningMessage: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
        "defaultMessage": "Creating this issue will affect the active sprint's scope"
    },
    activeSprintSelectionWarningMessageIssueTermRefresh: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh",
        "defaultMessage": "Creating this work item will affect the active sprint's scope"
    }
});

});

parcelRegister("aqMtW", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSprintValue", () => $02b747729b1ec287$export$94efa001ab93bfd1);
$parcel$export(module.exports, "mutateJiraSprintField", () => $02b747729b1ec287$export$38f8d6ec9f8dd490);
$parcel$export(module.exports, "getSprintSuggestions", () => $02b747729b1ec287$export$a5ccca5b51d5d670);

var $eusud = parcelRequire("eusud");
const $02b747729b1ec287$export$94efa001ab93bfd1 = (selectedSprints)=>{
    const sprint = selectedSprints[0];
    return sprint && {
        label: sprint.name,
        value: sprint.sprintId,
        state: sprint.state
    };
};
const $02b747729b1ec287$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
        sprintsField: {
            fieldId: fieldId,
            sprints: [
                {
                    sprintId: value.toString()
                }
            ]
        }
    });
const $02b747729b1ec287$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
    const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
    return queryString;
};
const $02b747729b1ec287$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, $eusud.performGetRequest)($02b747729b1ec287$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));

});


parcelRegister("7nQJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e43d0c98a72456c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

const $7e43d0c98a72456c$var$TextField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.default), {
        type: "text",
        ...props
    });
var $7e43d0c98a72456c$export$2e2bcd8739ae039 = $7e43d0c98a72456c$var$TextField;

});

parcelRegister("bB4xD", function(module, exports) {

$parcel$export(module.exports, "mutateTextField", () => $6ad03e349a20a50c$export$5dd442db0007fb2d);

const $6ad03e349a20a50c$export$5dd442db0007fb2d = (value, fieldId)=>({
        fieldId: fieldId,
        text: value,
        mutationGroup: (0, $5af824419799ac1a$export$31fd86f8f183952c)
    });

});
const $5af824419799ac1a$export$31fd86f8f183952c = 'singleLineTextFields';


parcelRegister("9cNbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfbc76c8b6a999d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e7njR = parcelRequire("e7njR");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

const $9bfbc76c8b6a999d$var$TextAreaField = (props)=>{
    const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const onTextAreaChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7njR.default), {
        ...fieldProps,
        value: value,
        onChange: onTextAreaChange,
        onBlur: onBlur,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isDisabled: isReadOnly
    }));
};
var $9bfbc76c8b6a999d$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TextAreaFieldConfig, string>, any>'.
$9bfbc76c8b6a999d$var$TextAreaField);

});
parcelRegister("e7njR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac310125020056c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6LCpJ = parcelRequire("6LCpJ");
const $ac310125020056c3$var$TextAreaEdit = (props)=>{
    const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
        ...fieldProps,
        isRequired: isRequired,
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        isInvalid: isInvalid,
        minimumRows: minimumRows,
        isDisabled: isDisabled
    });
};
var $ac310125020056c3$export$2e2bcd8739ae039 = $ac310125020056c3$var$TextAreaEdit;

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});



parcelRegister("7svvp", function(module, exports) {

$parcel$export(module.exports, "mutateTextAreaField", () => $93a5f312149817bd$export$26988cd8ac7fed9b);

const $93a5f312149817bd$export$26988cd8ac7fed9b = (value, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $4119cc28f5aed65e$export$31fd86f8f183952c),
        richText: {
            wikiText: value
        }
    });

});
const $4119cc28f5aed65e$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("b3x8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $097d081b3402af20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

const $097d081b3402af20$var$UrlField = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.default), {
        type: "url",
        width: width,
        ...rest
    });
};
var $097d081b3402af20$export$2e2bcd8739ae039 = $097d081b3402af20$var$UrlField;

});

parcelRegister("d2fRu", function(module, exports) {

$parcel$export(module.exports, "mutateUrlField", () => $4284e73cbca56615$export$68f54af506df5feb);

const $4284e73cbca56615$export$68f54af506df5feb = (url, fieldId)=>{
    const mutatedValue = {
        fieldId: fieldId,
        mutationGroup: (0, $cfa45186c89d86bf$export$31fd86f8f183952c)
    };
    mutatedValue.url = url;
    return mutatedValue;
};

});
const $cfa45186c89d86bf$export$31fd86f8f183952c = 'urlFields';


parcelRegister("em1U0", function(module, exports) {

$parcel$export(module.exports, "transformToServerValue", () => $657085c715b654ca$export$6f0c6eec5b71d787);

var $gJBT6 = parcelRequire("gJBT6");
const $657085c715b654ca$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $657085c715b654ca$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $657085c715b654ca$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $657085c715b654ca$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $657085c715b654ca$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("feVbn", function(module, exports) {

$parcel$export(module.exports, "transformSuggestions", () => $ca52109385ad0f99$export$1d0ee4320c26fb60);
$parcel$export(module.exports, "mapEpicLinkOptionToData", () => $ca52109385ad0f99$export$2d8fd73a87ecc4de);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $heWHN = parcelRequire("heWHN");

var $f1csm = parcelRequire("f1csm");

var $fUop9 = parcelRequire("fUop9");
const $ca52109385ad0f99$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUop9.ColorPatch), {
        color: color
    });
const $ca52109385ad0f99$export$9227063fc962e54 = (epic)=>{
    const color = (0, $heWHN.MAP_FROM_SERVER_COLOR)[epic.issueColor.key];
    return {
        color: color,
        label: epic.summary,
        value: epic.key,
        id: epic.id.toString(),
        description: epic.key,
        elemBefore: $ca52109385ad0f99$export$b00899e73680c477(color),
        filterValues: [
            epic.summary,
            epic.key
        ],
        isDone: epic.done
    };
};
const $ca52109385ad0f99$export$1d0ee4320c26fb60 = (response, formatMessage)=>{
    const epicLists = response.values || [];
    const epicLink = [
        {
            label: formatMessage((0, $f1csm.default).allEpics),
            options: epicLists.map($ca52109385ad0f99$export$9227063fc962e54)
        }
    ];
    return epicLink;
};
const $ca52109385ad0f99$export$2d8fd73a87ecc4de = ({ value: value })=>value;

});
parcelRegister("f1csm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ef5ab582b8f652$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5ef5ab582b8f652$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-epic-link.edit.placeholder",
        "defaultMessage": "Select Epic"
    },
    noOptionsMessage: {
        "id": "issue-field-epic-link.edit.no-options-message",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-epic-link.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loadingMessage: {
        "id": "issue-field-epic-link.edit.loading-message",
        "defaultMessage": "Searching..."
    },
    allEpics: {
        "id": "issue-field-epic-link.edit.all-epics",
        "defaultMessage": "All epics"
    }
});

});

parcelRegister("fUop9", function(module, exports) {

$parcel$export(module.exports, "ColorPatch", () => $8331d8726710f714$export$a3f78762e82c8733);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");

var $heWHN = parcelRequire("heWHN");
const $8331d8726710f714$export$a3f78762e82c8733 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "p05qyv-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $gwIPs.gridSize) * 2.5}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $gwIPs.gridSize) * 2.5}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $gwIPs.gridSize) / 2}px`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $heWHN.MAP_COLORS_TO_VALUE)[props.color]
    }));

});


parcelRegister("UwVOJ", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationOptionsToData", () => $f0a92a32c018d992$export$aa1a3b6fac8d058a);
$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $f0a92a32c018d992$export$bb720a783a78b0f4);
const $f0a92a32c018d992$export$aa1a3b6fac8d058a = (options)=>options.map(({ value: value })=>Number.parseInt(value, 10));
const $f0a92a32c018d992$export$bb720a783a78b0f4 = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: `${id}`
        }));

});

parcelRegister("deSKa", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $19080530e7ffbd37$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $19080530e7ffbd37$export$fc800909123977f3);
const $19080530e7ffbd37$export$4c05e2584b34e4d8 = (issueTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedIssueTypes = {};
    issueTypes.forEach((issueType)=>{
        const { id: id, iconUrl: iconUrl } = issueType;
        transformedIssueTypes[id] = iconUrl;
    });
    return transformedIssueTypes;
};
const $19080530e7ffbd37$export$227473965d2e27db = (projects)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedProjects = {};
    projects.forEach((project)=>{
        const { id: id, key: key } = project;
        transformedProjects[id] = key;
    });
    return transformedProjects;
};
const $19080530e7ffbd37$export$99a866ffa3af7d8b = (response)=>{
    const transformedIssueTypes = $19080530e7ffbd37$export$4c05e2584b34e4d8(response.issueTypes);
    const transformedProjects = $19080530e7ffbd37$export$227473965d2e27db(response.projects);
    const transformedResponse = response.issues.map((issue)=>{
        const { issueKey: issueKey, issueSummary: issueSummary, issueTypeId: issueTypeId, projectId: projectId } = issue;
        const projectKey = transformedProjects[projectId];
        return {
            label: `${projectKey}-${issueKey} ${issueSummary}`,
            value: `${projectKey}-${issueKey}`,
            iconUrl: transformedIssueTypes[String(issueTypeId)]
        };
    });
    return transformedResponse;
};
const $19080530e7ffbd37$export$fc800909123977f3 = (option)=>option.value;

});

parcelRegister("66d24", function(module, exports) {

$parcel$export(module.exports, "mapOptionToResolutionOption", () => $dbc7baed5320bad0$export$f915ce0689a595ca);
$parcel$export(module.exports, "mapResolutionOptionToOption", () => $dbc7baed5320bad0$export$203456290cf27045);
$parcel$export(module.exports, "mapAndFilterResolutionOptions", () => $dbc7baed5320bad0$export$38929c8b23814052);
const $dbc7baed5320bad0$export$f915ce0689a595ca = (option)=>({
        id: option.value,
        name: option.label
    });
const $dbc7baed5320bad0$export$203456290cf27045 = (option)=>({
        value: option.id,
        label: option.name
    });
const $dbc7baed5320bad0$export$2ad0f62ebcc9982d = (options)=>options.map((option)=>$dbc7baed5320bad0$export$203456290cf27045(option));
const $dbc7baed5320bad0$export$38929c8b23814052 = (currentOption, options)=>{
    if (!currentOption) return $dbc7baed5320bad0$export$2ad0f62ebcc9982d(options);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return options.reduce((resolutionOptions, option)=>{
        if (option.id !== currentOption.id) resolutionOptions.push($dbc7baed5320bad0$export$203456290cf27045(option));
        return resolutionOptions;
    }, []);
};

});

parcelRegister("5pYli", function(module, exports) {

$parcel$export(module.exports, "getOptionLabel", () => $5c5f842bdc3f187c$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $5c5f842bdc3f187c$export$40be908210c5a79c);
$parcel$export(module.exports, "convertRolesToCurrentRole", () => $5c5f842bdc3f187c$export$dede06c97eeff392);
$parcel$export(module.exports, "transformRolesToArrayIfNull", () => $5c5f842bdc3f187c$export$394ee8daa9411a86);
$parcel$export(module.exports, "mapRoleToRestrictionValue", () => $5c5f842bdc3f187c$export$3bb7b17fecda53ae);
$parcel$export(module.exports, "isUserRoleIncludedInRestrictedRoles", () => $5c5f842bdc3f187c$export$e3d70e1822e7e331);

var $cYhG6 = parcelRequire("cYhG6");
const $5c5f842bdc3f187c$export$dac6ace3020563ca = (role)=>role.name;
const $5c5f842bdc3f187c$export$40be908210c5a79c = (role)=>role.roleId;
const $5c5f842bdc3f187c$export$dede06c97eeff392 = (selectedRoles, allRoles)=>{
    const transformedCurrentRoles = [];
    selectedRoles.forEach((restriction)=>{
        const matchedRestriction = allRoles.find((role)=>role.roleId === restriction.roleId);
        matchedRestriction && transformedCurrentRoles.push(matchedRestriction);
    });
    return transformedCurrentRoles;
};
const $5c5f842bdc3f187c$export$394ee8daa9411a86 = (roles, onChange)=>onChange(roles || []);
const $5c5f842bdc3f187c$export$3bb7b17fecda53ae = (roles)=>({
        projectrole: roles.map(({ roleId: roleId })=>({
                restrictionValue: roleId
            }))
    });
const $5c5f842bdc3f187c$export$e3d70e1822e7e331 = (selectedRoles, rolesWithCurrentUserRole)=>{
    // no restrictions applied
    if (selectedRoles.length === 0) return true;
    const selectedRoleWithCurrentUserRoles = (0, (/*@__PURE__*/$parcel$interopDefault($cYhG6)))(selectedRoles, rolesWithCurrentUserRole, 'roleId');
    return Boolean(selectedRoleWithCurrentUserRoles.length);
};

});
parcelRegister("cYhG6", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $026fe246c8ca749e$var$intersectionBy = $g7i7g(function(arrays) {
    var iteratee = $hYfgW(arrays), mapped = $1nIHN(arrays, $d9Hx6);
    if (iteratee === $hYfgW(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped, $bxDef(iteratee, 2)) : [];
});
module.exports = $026fe246c8ca749e$var$intersectionBy;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});



parcelRegister("162ej", function(module, exports) {

$parcel$export(module.exports, "IssueCreateOrganizationField", () => $350bd0242f6ced06$export$589d64992e8dd3db);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $7CMCs = parcelRequire("7CMCs");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $93Yeu = parcelRequire("93Yeu");

var $2gCtH = parcelRequire("2gCtH");

var $3Ypxa = parcelRequire("3Ypxa");

var $2o1IU = parcelRequire("2o1IU");

var $aPcig = parcelRequire("aPcig");
const $350bd0242f6ced06$export$8ad431dc6194deae = (props)=>{
    const { width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, searchUrl: searchUrl } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { projectId: projectIdNoIssueKey } = (0, $3Ypxa.useCommonPageContext)();
    const finalProjectId = issueKey ? projectId : projectIdNoIssueKey;
    const autoCompleteUrl = searchUrl || `/rest/servicedesk/1/project/${finalProjectId}/organisations/all/search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "organization-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "organizationFieldGIC",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            organizationFieldViewed: 'GIC'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2o1IU.EditView), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        spacing: "default",
        searchUrl: autoCompleteUrl
    })));
};
const $350bd0242f6ced06$export$c44556a89b9dcda3 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "organizationField",
        packageName: "jiraServicedeskCustomerServiceOrganizationField",
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($350bd0242f6ced06$export$8ad431dc6194deae, props));
};
const $350bd0242f6ced06$export$589d64992e8dd3db = (0, $hpV4g.withFormField)({
    validator: (0, $aPcig.validateOrganizationField)
})($350bd0242f6ced06$export$c44556a89b9dcda3);

});
parcelRegister("3Ypxa", function(module, exports) {

$parcel$export(module.exports, "useCommonPageContext", () => $5d709667e47fb9c6$export$682ebac4d54e1a69);

var $gq0sA = parcelRequire("gq0sA");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");
const $5d709667e47fb9c6$export$682ebac4d54e1a69 = (usePageContext = (0, $gq0sA.usePageContext))=>{
    const [{ data: pageContextData, error: error }] = usePageContext();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified } = projectContext || {};
    const { baseUrl: baseUrl, locale: locale } = tenantContext || {};
    return {
        baseUrl: baseUrl !== undefined ? (0, $g5X3G.toBaseUrl)(baseUrl) : baseUrl,
        error: error,
        locale: locale,
        projectKey: projectKey !== undefined ? (0, $g5X3G.toProjectKey)(projectKey) : projectKey,
        projectName: projectName,
        projectId: projectId != null ? (0, $g5X3G.toProjectId)(projectId.toString()) : projectId,
        projectType: (0, $4R6GH.fg)('jcs_project_type_m3') ? projectType : undefined,
        isProjectSimplified: isProjectSimplified
    };
};

});
parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("cAofY", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $9c517de0cdc23225$export$5eaaf465969a9171);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("2WfJW"));
const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $2M1hQ.createResource)({
    type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $dK8AG.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $9c517de0cdc23225$var$getDataLoader,
    maxAge: Infinity
});

});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("2WfJW", function(module, exports) {

let $223d3531a11189cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $223d3531a11189cf$var$load("iNITq").then(()=>parcelRequire('g4PUK'));

});





parcelRegister("2o1IU", function(module, exports) {

$parcel$export(module.exports, "EditView", () => $1fb140eacad3d61f$export$280eb2fbab4e5389);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $eZJjh = parcelRequire("eZJjh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eusud = parcelRequire("eusud");

var $jcw0u = parcelRequire("jcw0u");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $jbUS9 = parcelRequire("jbUS9");

var $4R6GH = parcelRequire("4R6GH");

var $4KxiI = parcelRequire("4KxiI");

var $1EsRd = parcelRequire("1EsRd");

var $1KkQA = parcelRequire("1KkQA");
const $1fb140eacad3d61f$export$8966118654f4b5f3 = 300;
const $1fb140eacad3d61f$export$8aef825906bb8745 = 2000;
const $1fb140eacad3d61f$var$getNoOptionsMessage = (error, inputValue)=>{
    if (error) return (0, $1EsRd.default).organizationFieldErrorState;
    return inputValue ? (0, $1EsRd.default).organizationFieldNoResults : (0, $1EsRd.default).organizationFieldNoOptions;
};
const $1fb140eacad3d61f$var$LoadingIndicator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        ...props,
        size: "small"
    });
const $1fb140eacad3d61f$var$ValueContainerOld = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $1fb140eacad3d61f$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbUS9.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), children));
const $1fb140eacad3d61f$var$ValueContainer = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $1fb140eacad3d61f$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbUS9.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), children));
const $1fb140eacad3d61f$var$Option = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbUS9.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), children));
const $1fb140eacad3d61f$export$280eb2fbab4e5389 = ({ onChange: onChange, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isInvalid: isInvalid, autoFocus: autoFocus, openMenuOnFocus: openMenuOnFocus, value: value, classNamePrefix: classNamePrefix, onCloseMenuOnScroll: onCloseMenuOnScroll, spacing: spacing = 'compact', searchUrl: searchUrl, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const debouncedFireSearchSuccessEvent = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jcsOrganizationFieldSearch succeeded'), $1fb140eacad3d61f$export$8aef825906bb8745, {
        leading: true,
        trailing: false
    } // fire event on the leading edge of the debounce
    );
    const searchOrganizations = (0, $5uXOq.useCallback)((query = '', callback)=>{
        setHasError(false);
        (0, $eusud.performGetRequest)(`${searchUrl}?query=${encodeURIComponent(query)}`).then((response)=>{
            debouncedFireSearchSuccessEvent();
            callback((0, $1KkQA.mapDataToOrganizationOptions)(response));
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'searchOrganizations',
                    packageName: 'servicedeskCustomerServiceCustomFields',
                    teamName: 'boysenberry'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setHasError(true);
            callback([]);
        });
    }, [
        debouncedFireSearchSuccessEvent,
        searchUrl
    ]);
    const loadOptionsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(searchOrganizations, $1fb140eacad3d61f$export$8966118654f4b5f3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...fieldProps,
        inputId: "organization",
        loadOptions: loadOptionsDebounced,
        value: value,
        cacheOptions: true,
        placeholder: formatMessage((0, $1EsRd.default).organizationFieldPlaceholder),
        autoFocus: autoFocus,
        openMenuOnFocus: openMenuOnFocus,
        spacing: spacing,
        styles: {
            valueContainer: (base)=>({
                    ...base,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }),
            // Makes sure the cursor is directly to the right of the selected text
            singleValue: (base)=>({
                    ...base,
                    marginRight: 0,
                    marginLeft: 0
                }),
            input: (base)=>({
                    ...base,
                    marginLeft: 0
                }),
            container: (base)=>({
                    ...base,
                    minWidth: '200px'
                }),
            menu: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).modal
                })
        },
        components: {
            ValueContainer: (0, $4R6GH.fg)('jcs-issue-view-truncate-reporter') ? $1fb140eacad3d61f$var$ValueContainer : $1fb140eacad3d61f$var$ValueContainerOld,
            Option: $1fb140eacad3d61f$var$Option,
            LoadingIndicator: $1fb140eacad3d61f$var$LoadingIndicator
        },
        noOptionsMessage: ({ inputValue: inputValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage($1fb140eacad3d61f$var$getNoOptionsMessage(hasError, inputValue))),
        onChange: (newValue)=>{
            (0, $4KxiI.editOrganizationFieldIssueViewExperience).start();
            onChange(newValue);
            if (value?.value !== newValue?.value) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'organizationField'
            }), {
                hasValue: !!newValue
            });
        },
        classNamePrefix: classNamePrefix,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isInvalid: isInvalid,
        isClearable: true
    });
};
const $1fb140eacad3d61f$var$iconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.050'
});
const $1fb140eacad3d61f$var$styles = (0, $8CUq3.xcss)({
    width: '100%',
    minWidth: '0px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingInline: 'space.050'
});

});
parcelRegister("jbUS9", function(module, exports) {

$parcel$export(module.exports, "LabelIcon", () => $2a46531b31edbe20$export$6722f2abd5aa752a);

var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $lSrt8 = parcelRequire("lSrt8");

var $bB6uF = parcelRequire("bB6uF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");
const $2a46531b31edbe20$export$6722f2abd5aa752a = ({ size: size, type: type, label: label = '', testId: testId, ...etc })=>{
    const Icon = type === 'ORGANIZATION' ? (0, (/*@__PURE__*/$parcel$interopDefault($lSrt8))) : (0, (/*@__PURE__*/$parcel$interopDefault($bB6uF)));
    const iconSize = size === 'large' ? 'large' : 'small';
    const isLarge = size === 'large';
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2a46531b31edbe20$var$containerStyles,
            size === 'small' && $2a46531b31edbe20$var$smallStyles,
            size === 'xsmall' && $2a46531b31edbe20$var$xsmallStyles
        ],
        testId: testId
    }, isLarge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
        icon: Icon,
        appearance: "gray",
        shape: "square",
        size: "40",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        color: "var(--ds-icon, #44546F)",
        label: label,
        ...etc
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $2a46531b31edbe20$var$containerStyles,
            size === 'large' && $2a46531b31edbe20$var$largeStyles,
            size === 'small' && $2a46531b31edbe20$var$smallStyles,
            size === 'xsmall' && $2a46531b31edbe20$var$xsmallStyles
        ],
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        LEGACY_size: iconSize,
        label: label,
        ...etc
    }));
};
const $2a46531b31edbe20$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral'
});
const $2a46531b31edbe20$var$largeStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.200',
    padding: 'space.050'
});
const $2a46531b31edbe20$var$smallStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.050'
});
const $2a46531b31edbe20$var$xsmallStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.025'
});

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a921419639fe8f6f$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $a921419639fe8f6f$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $a921419639fe8f6f$var$iconTileStyles = {
    name: "1ot07ws",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;font-size:0"
};
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $a921419639fe8f6f$var$iconTileStyles,
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("lSrt8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c9411407c1f042ec99fb06f89567549>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fed3f2dc0bb9ed52$var$_react = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fed3f2dc0bb9ed52$var$_officeBuilding = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("4bTdk")));

var $fed3f2dc0bb9ed52$var$_officeBuildingFilled = $fed3f2dc0bb9ed52$var$_interopRequireDefault((parcelRequire("e8Dhe")));
function $fed3f2dc0bb9ed52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fed3f2dc0bb9ed52$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $fed3f2dc0bb9ed52$var$_react.default.createElement($fed3f2dc0bb9ed52$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $fed3f2dc0bb9ed52$var$_officeBuildingFilled.default
    }, props));
$fed3f2dc0bb9ed52$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $fed3f2dc0bb9ed52$var$_default = module.exports.default = $fed3f2dc0bb9ed52$var$OfficeBuildingIcon;

});
parcelRegister("4bTdk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30d304d6d8375db3$var$_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $30d304d6d8375db3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;

});

parcelRegister("e8Dhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4b0479e3879f3a8$var$_react = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a4b0479e3879f3a8$var$_officeBuilding = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("4bTdk")));
function $a4b0479e3879f3a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $a4b0479e3879f3a8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props, {
        newIcon: $a4b0479e3879f3a8$var$_officeBuilding.default
    }));
$a4b0479e3879f3a8$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $a4b0479e3879f3a8$var$_default = module.exports.default = $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon;

});



parcelRegister("4KxiI", function(module, exports) {

$parcel$export(module.exports, "editOrganizationFieldIssueViewExperience", () => $d27aa39a6f1f0e5f$export$8da05580d9bb4547);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $d27aa39a6f1f0e5f$export$8da05580d9bb4547 = new (0, $duUGa.UFOExperience)('jsm-cs-organization-custom-field-issue-view-edit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("1EsRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0620e0036d8beea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0620e0036d8beea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    organizationFieldPlaceholder: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-placeholder-non-final",
        "defaultMessage": "Select option"
    },
    organizationFieldNoOptions: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-no-options-non-final",
        "defaultMessage": "No options"
    },
    organizationFieldNoResults: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-no-results-non-final",
        "defaultMessage": "No matches"
    },
    organizationFieldErrorState: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-error-state-non-final",
        "defaultMessage": "Failed to fetch options"
    }
});

});

parcelRegister("1KkQA", function(module, exports) {

$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $d318a1dc2fe16030$export$bb720a783a78b0f4);
const $d318a1dc2fe16030$export$bb720a783a78b0f4 = (data)=>data?.results?.results?.map(({ id: id, name: name })=>({
            label: name,
            value: `${id}`
        })) || [];

});


parcelRegister("aPcig", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationOptionToData", () => $f08aaf4476b255ad$export$156d062414dbdd98);
$parcel$export(module.exports, "validateOrganizationField", () => $f08aaf4476b255ad$export$90b32914fc328a85);

var $bGrWH = parcelRequire("bGrWH");
const $f08aaf4476b255ad$export$156d062414dbdd98 = (option)=>Number.parseInt(option.value, 10);
const $f08aaf4476b255ad$export$608983f592de28e3 = (selectedOrganization, fieldId)=>({
        organizationField: {
            fieldId: fieldId,
            organization: {
                organizationId: selectedOrganization.value
            }
        }
    });
const $f08aaf4476b255ad$export$90b32914fc328a85 = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("4nSAG", function(module, exports) {

$parcel$export(module.exports, "IssueCreateEntitlementField", () => $32ade2dcdc4f5704$export$99314741193b044b);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $ce4pa = parcelRequire("ce4pa");
var $dnjeJ = parcelRequire("dnjeJ");

var $kAldV = parcelRequire("kAldV");

var $iSKpR = parcelRequire("iSKpR");

var $57aXd = parcelRequire("57aXd");
const $32ade2dcdc4f5704$export$48549219ad5358dc = (props)=>{
    const { width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated } = props;
    const { getFormState: getFormState } = contextAndValuesOfIssueBeingCreated;
    const formState = getFormState();
    const reporter = formState?.values?.reporter;
    const [currentReporter, setCurrentReporter] = (0, $5uXOq.useState)(reporter);
    (0, $5uXOq.useEffect)(()=>{
        if (reporter?.id !== currentReporter?.id) {
            onChange(null);
            setCurrentReporter(reporter);
        }
    }, [
        reporter,
        currentReporter,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "entitlement-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "entitlementsFieldGIC",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            entitlementsFieldViewed: 'GIC'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAldV.LazyEditView), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        reporterId: reporter?.id,
        spacing: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce4pa.ExperienceSuccess), {
        experience: (0, $iSKpR.entitlementFieldGicMountExperience)
    })));
};
const $32ade2dcdc4f5704$export$f13f32889402194 = (props)=>{
    (0, $dnjeJ.useUFOComponentExperience)((0, $iSKpR.entitlementFieldGicMountExperience));
    const onError = (_, error)=>{
        (0, $iSKpR.entitlementFieldGicMountExperience).failure();
        throw error; // rethrow error to be caught by WithFormField erorr boundary so that the field label doesn't show
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "entitlementField",
        packageName: "jiraServicedeskCustomerServiceEntitlementsField",
        onError: onError,
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32ade2dcdc4f5704$export$48549219ad5358dc, props));
};
const $32ade2dcdc4f5704$export$99314741193b044b = (0, $hpV4g.withFormField)({
    validator: (0, $57aXd.validateEntitlementField)
})($32ade2dcdc4f5704$export$f13f32889402194);

});
parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("kAldV", function(module, exports) {

$parcel$export(module.exports, "LazyEditView", () => $eed6115d0b450999$export$a17259a78f401488);

var $kxZPA = parcelRequire("kxZPA");

const $eed6115d0b450999$export$a17259a78f401488 = (0, $kxZPA.lazy)(()=>(parcelRequire("bxJbm")).then((module)=>module.EditView), {
    moduleId: "./src/packages/servicedesk/customer-service/entitlements-field/src/common/ui/edit-view/index.tsx"
});

});
parcelRegister("bxJbm", function(module, exports) {

let $8675d301ddb46f37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8675d301ddb46f37$var$load("cHlBI").then(()=>parcelRequire('b2rYE'));

});


parcelRegister("iSKpR", function(module, exports) {

$parcel$export(module.exports, "entitlementFieldGicMountExperience", () => $1c7916d9adea851e$export$588fc8ac7a187272);
$parcel$export(module.exports, "entitlementFieldDataFetchExperience", () => $1c7916d9adea851e$export$7f9aebf7c6d536d6);
$parcel$export(module.exports, "entitlementFieldIssueViewMountExperience", () => $1c7916d9adea851e$export$66e03de8aa0e97b8);
$parcel$export(module.exports, "editEntitlementFieldIssueViewExperience", () => $1c7916d9adea851e$export$6889e91b24599276);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $1c7916d9adea851e$export$588fc8ac7a187272 = new (0, $duUGa.UFOExperience)('jsm-cs-entitlement-custom-field-gic-mount', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});
const $1c7916d9adea851e$export$7f9aebf7c6d536d6 = new (0, $duUGa.UFOExperience)('jsm-cs-entitlement-custom-field-data-fetch', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});
const $1c7916d9adea851e$export$66e03de8aa0e97b8 = new (0, $duUGa.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-mount', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $1c7916d9adea851e$export$6889e91b24599276 = new (0, $duUGa.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-edit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("57aXd", function(module, exports) {

$parcel$export(module.exports, "mapEntitlementOptionToData", () => $8355eec375a084ab$export$1c1e5611b1980840);
$parcel$export(module.exports, "validateEntitlementField", () => $8355eec375a084ab$export$3f9370506eb4fa6c);

var $bGrWH = parcelRequire("bGrWH");
const $8355eec375a084ab$export$1c1e5611b1980840 = (option)=>option.value;
const $8355eec375a084ab$export$3b43598c7abb6d70 = (selectedEntitlement, fieldId)=>({
        entitlementField: {
            fieldId: fieldId,
            entitlement: {
                entitlementId: `${selectedEntitlement.value}`
            }
        }
    });
const $8355eec375a084ab$export$3f9370506eb4fa6c = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("7jsR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4610a791cf117fa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $69KT5 = parcelRequire("69KT5");

var $qfj8c = parcelRequire("qfj8c");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $bGrWH = parcelRequire("bGrWH");

var $azL7v = parcelRequire("azL7v");

var $iUFy5 = parcelRequire("iUFy5");

var $cjoqp = parcelRequire("cjoqp");
const $d4610a791cf117fa$export$f10e1476c0ddb959 = ()=>(0, $5uXOq.useState)(false);
const $d4610a791cf117fa$var$AttachmentsField = (props)=>{
    const { view: view } = (0, $iUFy5.useMinimizableModal)();
    const { fieldId: fieldId, fieldName: fieldName, description: description, isRequired: isRequired, additionalData: additionalData, selectedProject: selectedProject, onInProgressChange: onInProgressChange, additionalData: { maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize }, defaultValue: defaultValue, isCollapsed: isCollapsed } = props;
    const { mediaContext: mediaContext } = additionalData;
    const uploadToken = mediaContext?.uploadToken;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [attachmentSizeValidation, onAttachmentSizeValidation] = $d4610a791cf117fa$export$f10e1476c0ddb959();
    let attachmentUploadContext;
    if (uploadToken) attachmentUploadContext = {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        collection: uploadToken.targetCollection,
        token: uploadToken.token
    };
    const dropzoneContainerId = view === 'modal' ? (0, $bGrWH.FORM_DROPZONE_CONTAINER_ID) : (0, $bGrWH.MINIMISED_DROPZONE_CONTAINER_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azL7v.default), {
        fieldId: fieldId,
        fieldName: fieldName,
        description: description,
        isRequired: isRequired,
        mediaUploadContext: attachmentUploadContext,
        projectId: selectedProject?.value || null,
        onInProgressChange: onInProgressChange,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        dropzoneContainerId: dropzoneContainerId,
        shouldScrollIntoViewOnUploadStart: true,
        defaultValue: defaultValue,
        ...(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && {
            isCollapsed: isCollapsed
        }
    }), !attachmentUploadContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $cjoqp.default).missingToken)), attachmentSizeValidation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $cjoqp.default).attachmentSizeLimitCheck), " (", (0, (/*@__PURE__*/$parcel$interopDefault($69KT5)))(maxAllowedTotalAttachmentsSize, {
        unitSeparator: ' '
    }), ")."));
};
var $d4610a791cf117fa$export$2e2bcd8739ae039 = $d4610a791cf117fa$var$AttachmentsField;

});
parcelRegister("69KT5", function(module, exports) {
/*!
 * bytes
 * Copyright(c) 2012-2014 TJ Holowaychuk
 * Copyright(c) 2015 Jed Watson
 * MIT Licensed
 */ 'use strict';
/**
 * Module exports.
 * @public
 */ module.exports = $47b7f435b4828cd6$var$bytes;
module.exports.format = $47b7f435b4828cd6$var$format;
module.exports.parse = $47b7f435b4828cd6$var$parse;
/**
 * Module variables.
 * @private
 */ var $47b7f435b4828cd6$var$formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
var $47b7f435b4828cd6$var$formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;
var $47b7f435b4828cd6$var$map = {
    b: 1,
    kb: 1024,
    mb: 1048576,
    gb: 1073741824,
    tb: Math.pow(1024, 4),
    pb: Math.pow(1024, 5)
};
var $47b7f435b4828cd6$var$parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb|pb)$/i;
/**
 * Convert the given value in bytes into a string or parse to string to an integer in bytes.
 *
 * @param {string|number} value
 * @param {{
 *  case: [string],
 *  decimalPlaces: [number]
 *  fixedDecimals: [boolean]
 *  thousandsSeparator: [string]
 *  unitSeparator: [string]
 *  }} [options] bytes options.
 *
 * @returns {string|number|null}
 */ function $47b7f435b4828cd6$var$bytes(value, options) {
    if (typeof value === 'string') return $47b7f435b4828cd6$var$parse(value);
    if (typeof value === 'number') return $47b7f435b4828cd6$var$format(value, options);
    return null;
}
/**
 * Format the given value in bytes into a string.
 *
 * If the value is negative, it is kept as such. If it is a float,
 * it is rounded.
 *
 * @param {number} value
 * @param {object} [options]
 * @param {number} [options.decimalPlaces=2]
 * @param {number} [options.fixedDecimals=false]
 * @param {string} [options.thousandsSeparator=]
 * @param {string} [options.unit=]
 * @param {string} [options.unitSeparator=]
 *
 * @returns {string|null}
 * @public
 */ function $47b7f435b4828cd6$var$format(value, options) {
    if (!Number.isFinite(value)) return null;
    var mag = Math.abs(value);
    var thousandsSeparator = options && options.thousandsSeparator || '';
    var unitSeparator = options && options.unitSeparator || '';
    var decimalPlaces = options && options.decimalPlaces !== undefined ? options.decimalPlaces : 2;
    var fixedDecimals = Boolean(options && options.fixedDecimals);
    var unit = options && options.unit || '';
    if (!unit || !$47b7f435b4828cd6$var$map[unit.toLowerCase()]) {
        if (mag >= $47b7f435b4828cd6$var$map.pb) unit = 'PB';
        else if (mag >= $47b7f435b4828cd6$var$map.tb) unit = 'TB';
        else if (mag >= $47b7f435b4828cd6$var$map.gb) unit = 'GB';
        else if (mag >= $47b7f435b4828cd6$var$map.mb) unit = 'MB';
        else if (mag >= $47b7f435b4828cd6$var$map.kb) unit = 'KB';
        else unit = 'B';
    }
    var val = value / $47b7f435b4828cd6$var$map[unit.toLowerCase()];
    var str = val.toFixed(decimalPlaces);
    if (!fixedDecimals) str = str.replace($47b7f435b4828cd6$var$formatDecimalsRegExp, '$1');
    if (thousandsSeparator) str = str.split('.').map(function(s, i) {
        return i === 0 ? s.replace($47b7f435b4828cd6$var$formatThousandsRegExp, thousandsSeparator) : s;
    }).join('.');
    return str + unitSeparator + unit;
}
/**
 * Parse the string value into an integer in bytes.
 *
 * If no unit is given, it is assumed the value is in bytes.
 *
 * @param {number|string} val
 *
 * @returns {number|null}
 * @public
 */ function $47b7f435b4828cd6$var$parse(val) {
    if (typeof val === 'number' && !isNaN(val)) return val;
    if (typeof val !== 'string') return null;
    // Test if the string passed is valid
    var results = $47b7f435b4828cd6$var$parseRegExp.exec(val);
    var floatValue;
    var unit = 'b';
    if (!results) {
        // Nothing could be extracted from the given string
        floatValue = parseInt(val, 10);
        unit = 'b';
    } else {
        // Retrieve the value and the unit
        floatValue = parseFloat(results[1]);
        unit = results[4].toLowerCase();
    }
    if (isNaN(floatValue)) return null;
    return Math.floor($47b7f435b4828cd6$var$map[unit] * floatValue);
}

});

parcelRegister("azL7v", function(module, exports) {

$parcel$export(module.exports, "AttachmentsField", () => $e446c7b6c6df08e3$export$f7c49e57ef98664f);
$parcel$export(module.exports, "default", () => $e446c7b6c6df08e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k9tnV = parcelRequire("k9tnV");

var $eCeGD = parcelRequire("eCeGD");

var $hPcwl = parcelRequire("hPcwl");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $bGrWH = parcelRequire("bGrWH");

var $3F8e9 = parcelRequire("3F8e9");

var $lySs6 = parcelRequire("lySs6");

var $6UFK0 = parcelRequire("6UFK0");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

var $hpV4g = parcelRequire("hpV4g");

var $c431P = parcelRequire("c431P");

var $bWtQ8 = parcelRequire("bWtQ8");
const $e446c7b6c6df08e3$export$f7c49e57ef98664f = (props)=>{
    const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, $lySs6.default)({
        mediaUploadContext: mediaUploadContext,
        projectId: projectId,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        attachmentCustomUploadURL: attachmentCustomUploadURL
    });
    const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
    (0, $5uXOq.useEffect)(()=>{
        // setting DefaultValueInitialized only when receiving default Value to guarantee we will set DefaultValue even if it's loaded with some delay.
        if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
            const currentAttachments = [];
            setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                    mediaFile: mediaFile,
                    isUploading: false
                }))));
            setDefaultValueInitialized(true);
        }
    }, [
        setAttachments,
        defaultValue,
        isDefaultValueInitialized,
        setDefaultValueInitialized
    ]);
    if ((0, $4R6GH.fg)('gic-attachment-field-with-react18-concurrent-mode')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    // TBD: create a controlled reusable attachment component
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'shouldClear' does not exist on type 'FieldValue'.
        if (value && value.shouldClear === true) setAttachments([]);
    }, [
        setAttachments,
        value
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onInProgressChange && onInProgressChange(isUploading);
    }, [
        isUploading,
        onInProgressChange
    ]);
    if (!mediaUploadContext) return null;
    const onAttachmentUploadStart = (uploadStartPayload)=>{
        onUploadStart(uploadStartPayload);
        if (shouldScrollIntoViewOnUploadStart) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const fieldElement = document.getElementById((0, $bWtQ8.getFieldDropZoneContainerID)(fieldId));
            if (fieldElement) (0, $k9tnV.default)(fieldElement, (0, $bGrWH.DEFAULT_SCROLL_OPTIONS));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$FieldDropzoneContainer, {
        id: (0, $bWtQ8.getFieldDropZoneContainerID)(fieldId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneAreaText, null, `${formatMessage((0, $c431P.default).dropzone)}`, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UFK0.default), {
        ...fieldProps,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd,
        dropzoneContainer: document.getElementById(dropzoneContainerId || (0, $bWtQ8.getFieldDropZoneContainerID)(fieldId))
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e446c7b6c6df08e3$var$browseButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: ()=>setIsBrowserOpen(true),
            "aria-label": formatMessage((0, $c431P.default).browseAriaLabel)
        }, formatMessage((0, $c431P.default).browse)))))), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e446c7b6c6df08e3$var$mediaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "attachments-filmstrip-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3F8e9.AsyncAttachmentsFilmstripView), {
        mediaClientConfig: mediaClientConfig,
        files: files,
        onRemoveFile: onRemoveFile,
        collectionName: mediaUploadContext.collection
    }))));
};
var $e446c7b6c6df08e3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    validator: (0, $bWtQ8.validateAttachment // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<ComponentProps<AttachmentFieldConfig, FieldValue>, any>'.
    )
})($e446c7b6c6df08e3$export$f7c49e57ef98664f);
const $e446c7b6c6df08e3$var$FieldDropzoneContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqogq9o _1h6dmuej _1e0c1txw _1bah1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz131l",
            __cmplp.className
        ])
    });
});
const $e446c7b6c6df08e3$var$mediaContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});
const $e446c7b6c6df08e3$var$browseButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e446c7b6c6df08e3$var$BrowseDropzoneArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e446c7b6c6df08e3$var$BrowseDropzoneAreaText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hPcwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa0e970215956ee$var$_react = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cfa0e970215956ee$var$_cloudArrowUp = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("ePJ5X")));

var $cfa0e970215956ee$var$_upload = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("aPRJS")));
function $cfa0e970215956ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa0e970215956ee$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $cfa0e970215956ee$var$_react.default.createElement($cfa0e970215956ee$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $cfa0e970215956ee$var$_upload.default
    }, props));
$cfa0e970215956ee$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $cfa0e970215956ee$var$_default = module.exports.default = $cfa0e970215956ee$var$CloudArrowUpIcon;

});
parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});


parcelRegister("3F8e9", function(module, exports) {

$parcel$export(module.exports, "AsyncAttachmentsFilmstripView", () => $eb0c63a29297e8e6$export$85605b8f3b532b83);

var $kxZPA = parcelRequire("kxZPA");

const $eb0c63a29297e8e6$export$85605b8f3b532b83 = (0, $kxZPA.lazy)(()=>(parcelRequire("8bbCy")).then((module)=>module.AttachmentsFilmstripView), {
    moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
});

});
parcelRegister("8bbCy", function(module, exports) {

let $5f485d7d41831fc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f485d7d41831fc8$var$load("kiYwA").then(()=>parcelRequire('4MZE8'));

});


parcelRegister("lySs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25872ff6af438731$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $f4KvR = parcelRequire("f4KvR");
const $25872ff6af438731$var$useAttachments = (attachmentArgs)=>{
    const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
    if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
    const [attachments, setAttachments] = (0, $5uXOq.useState)([]);
    const [files, setFiles] = (0, $5uXOq.useState)([]);
    const [isUploading, setUploading] = (0, $5uXOq.useState)(false);
    const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $5uXOq.useState)(false);
    const stateRef = (0, $5uXOq.useRef)();
    stateRef.current = files;
    (0, $5uXOq.useEffect)(()=>{
        setFiles(attachments.map((attachment)=>attachment.mediaFile));
        setUploading(attachments.some((attachment)=>attachment.isUploading));
    }, [
        attachments
    ]);
    const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
            authProvider: ()=>Promise.resolve({
                    baseUrl: mediaUploadContext.serviceHost,
                    clientId: mediaUploadContext.clientId,
                    token: mediaUploadContext.token
                }),
            useSha256ForUploads: true
        }), [
        mediaUploadContext
    ]);
    const uploadConfig = (0, $5uXOq.useMemo)(()=>({
            uploadParams: {
                collection: mediaUploadContext.collection
            }
        }), [
        mediaUploadContext.collection
    ]);
    const onUploadStart = (0, $5uXOq.useCallback)((uploadStartPayload)=>{
        const currentFiles = stateRef.current ? stateRef.current : [];
        const totalAttachments = [
            ...uploadStartPayload.files,
            ...currentFiles
        ];
        if (maxAllowedTotalAttachmentsSize === undefined || (0, $f4KvR.getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
            setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: true
                    }))));
        } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
    }, [
        onAttachmentSizeValidation,
        maxAllowedTotalAttachmentsSize
    ]);
    const onUploadError = (0, $5uXOq.useCallback)((uploadError)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
    }, []);
    const onUploadEnd = (0, $5uXOq.useCallback)((uploadEndPayload)=>{
        (async ()=>{
            const mediaFile = uploadEndPayload.file;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId)) await (0, $f4KvR.copyToAttachment)({
                id: projectId,
                isProjectId: true,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId)) await (0, $f4KvR.copyToAttachment)({
                id: issueId,
                isProjectId: false,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            setAttachments((currentAttachments)=>{
                const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                    {
                        mediaFile: mediaFile,
                        isUploading: false
                    }
                ]);
                return currentAttachments;
            });
        })();
    }, [
        issueId,
        projectId,
        attachmentCustomUploadURL
    ]);
    const onRemoveFile = (fileToBeRemoved)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
        if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
    };
    return {
        files: files,
        setAttachments: setAttachments,
        onUploadStart: onUploadStart,
        onUploadError: onUploadError,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onRemoveFile: onRemoveFile,
        onUploadEnd: onUploadEnd,
        isUploading: isUploading,
        isDefaultValueInitialized: isDefaultValueInitialized,
        setDefaultValueInitialized: setDefaultValueInitialized
    };
};
var $25872ff6af438731$export$2e2bcd8739ae039 = $25872ff6af438731$var$useAttachments;

});
parcelRegister("f4KvR", function(module, exports) {

$parcel$export(module.exports, "copyToAttachment", () => $ac4c15282d67ab83$export$b9a44fdbc3de4b85);
$parcel$export(module.exports, "getAttachmentsSize", () => $ac4c15282d67ab83$export$ed1597b81cfdb5f6);

var $eusud = parcelRequire("eusud");
const $ac4c15282d67ab83$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
const $ac4c15282d67ab83$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
const $ac4c15282d67ab83$export$b9a44fdbc3de4b85 = async (props)=>{
    const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { attachmentId: attachmentId } = await (0, $eusud.performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $ac4c15282d67ab83$export$a7455b0d8bb5c44e(id) : $ac4c15282d67ab83$export$cf1f2654bf86294f(id)), {
        body: JSON.stringify({
            fileId: mediaFile.id
        })
    });
    return attachmentId;
};
const $ac4c15282d67ab83$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);

});


parcelRegister("6UFK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c958c4e419db9df$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ayrxQ = parcelRequire("ayrxQ");
var $lU1w9 = parcelRequire("lU1w9");

var $495Tz = parcelRequire("495Tz");
const $2c958c4e419db9df$var$AttachmentsUpload = (props)=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $5uXOq.useState)(false);
    const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
    const dropzoneConfig = {
        ...uploadConfig
    };
    const browserConfig = {
        ...uploadConfig,
        multiple: true
    };
    const clipboardConfig = {
        ...uploadConfig
    };
    if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayrxQ.BrowserLoader), {
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onEnd: onUploadEnd,
        onClose: ()=>setIsBrowserOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lU1w9.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $495Tz.Clipboard), {
        mediaClientConfig: mediaClientConfig,
        config: clipboardConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        isolated: false
    }), renderPropFn({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};
var $2c958c4e419db9df$export$2e2bcd8739ae039 = $2c958c4e419db9df$var$AttachmentsUpload;

});
parcelRegister("ayrxQ", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $91b264e5a1a03fda$export$3ce634ac4a869e2c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


class $91b264e5a1a03fda$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("9lemj")),
                (parcelRequire("ebKUZ"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(this.state.Browser, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("9lemj", function(module, exports) {

let $6cd1369e824d2440$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6cd1369e824d2440$var$load("5GwtU").then(()=>parcelRequire('7b5A1'));

});

parcelRegister("ebKUZ", function(module, exports) {

let $a5467cb9dc448bb5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a5467cb9dc448bb5$var$load("cM9em"),
    $a5467cb9dc448bb5$var$load("fr9NE"),
    $a5467cb9dc448bb5$var$load("h2MrD"),
    $a5467cb9dc448bb5$var$load("bYT2S"),
    $a5467cb9dc448bb5$var$load("JoTl6")
]).then(()=>parcelRequire('fr527'));

});


parcelRegister("lU1w9", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $5f5f884766c60e4b$export$66201d263cd6342);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");



class $5f5f884766c60e4b$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("9lemj")),
                (parcelRequire("7aqAg")),
                (parcelRequire("9WYQI"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $5f5f884766c60e4b$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(MediaPickerErrorBoundary, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Dropzone, {
                ...this.props
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("7aqAg", function(module, exports) {

let $537e169701d06ef1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $537e169701d06ef1$var$load("cM9em"),
    $537e169701d06ef1$var$load("fr9NE"),
    $537e169701d06ef1$var$load("h2MrD"),
    $537e169701d06ef1$var$load("bYT2S"),
    $537e169701d06ef1$var$load("aBP1r")
]).then(()=>parcelRequire('cw5oc'));

});

parcelRegister("9WYQI", function(module, exports) {

let $73e8bb36b273a50d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $73e8bb36b273a50d$var$load("hPzOn"),
    $73e8bb36b273a50d$var$load("3j9rr")
]).then(()=>parcelRequire('quJ0B'));

});


parcelRegister("495Tz", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $a204c5b4c1d898fb$export$8b44c43c7d8f0830);

var $5uXOq = parcelRequire("5uXOq");

var $2AN6s = parcelRequire("2AN6s");

var $46dC9 = parcelRequire("46dC9");
const $a204c5b4c1d898fb$export$7b1ba4955557a858 = ()=>null;
const $a204c5b4c1d898fb$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $46dC9.useClipboardContextBoundary)();
    const onPaste = (0, $5uXOq.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a204c5b4c1d898fb$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2AN6s.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("2AN6s", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $943d05c2815ce49d$export$d7936799bf32b554);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


class $943d05c2815ce49d$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("9lemj")),
                (parcelRequire("cabCi"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $943d05c2815ce49d$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(this.state.Clipboard, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("cabCi", function(module, exports) {

let $8daf6e0487d24df6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8daf6e0487d24df6$var$load("axhr4").then(()=>parcelRequire('h0DlA'));

});


parcelRegister("46dC9", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $315b0e877a12fb17$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $315b0e877a12fb17$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $315b0e877a12fb17$export$37046969a30ae0a0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $315b0e877a12fb17$var$ClipboardStore = (0, $iXqE5.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $315b0e877a12fb17$export$c4bc9440a978eec1 = (0, $gg7kZ.createContainer)($315b0e877a12fb17$var$ClipboardStore);
const $315b0e877a12fb17$export$a3e41c5b3d4c30b7 = (0, $3sQ5x.createActionsHook)($315b0e877a12fb17$var$ClipboardStore);
const $315b0e877a12fb17$var$useClipboardContextBoundarySelector = (0, $3sQ5x.createHook)($315b0e877a12fb17$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $315b0e877a12fb17$export$37046969a30ae0a0 = ()=>$315b0e877a12fb17$var$useClipboardContextBoundarySelector()[0];

});



parcelRegister("c431P", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a51dc4ce208a9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $23a51dc4ce208a9a$var$messages = (0, $7VHMR.defineMessages)({
    dropzone: {
        "id": "issue-create-commons.attachments-field.dropzone",
        "defaultMessage": "Drop files to attach or"
    },
    browse: {
        "id": "issue-create-commons.attachments-field.browse",
        "defaultMessage": "Browse"
    },
    browseAriaLabel: {
        "id": "issue-create-commons.attachments-field.browse-aria-label",
        "defaultMessage": "Browse attachment"
    },
    missingToken: {
        "id": "issue-create-commons.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    }
});
var $23a51dc4ce208a9a$export$2e2bcd8739ae039 = $23a51dc4ce208a9a$var$messages;

});


parcelRegister("iUFy5", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalProvider", () => $b1dce28e1d2cfa0c$export$582a26efcd805dfd);
$parcel$export(module.exports, "useMinimizableModal", () => $b1dce28e1d2cfa0c$export$40bb90ec193b1c2f);

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");

var $kNC83 = parcelRequire("kNC83");

var $heCPy = parcelRequire("heCPy");
const $b1dce28e1d2cfa0c$export$a9554de703151814 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    shouldFocusChanger: false,
    view: 'modal',
    previousView: 'modal',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setView: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    unminimizeModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    transitionByKeyboardFrom: null,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTransitionByKeyboardFrom: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldFocusChanger: ()=>{},
    isTransitionInState: ()=>false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTransitionState: ()=>{},
    shouldDisableViewChangerButtons: false,
    customDisabledViewChangerButtonsMessage: '',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldDisableViewChangerButtons: ()=>{},
    isNestedModal: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsNestedModal: ()=>{},
    displayMinimizableButtons: true
});
const $b1dce28e1d2cfa0c$export$582a26efcd805dfd = ({ initialView: initialView = 'modal', view: view, onViewChange: onViewChange, onClose: onClose, children: children, displayMinimizableButtons: displayMinimizableButtons = true })=>{
    /**
	 * When view is passed in as a prop, this modal is controlled
	 * When it is not passed in, _view is used to handle the view changes when the modal is uncontrolled
	 * actualView is the view that we are displaying
	 * previousView is the previously displayed view (so that minimized knows what view to expand to)
	 */ const [_view, _setView] = (0, $5uXOq.useState)(view || initialView);
    const actualView = (0, $5uXOq.useMemo)(()=>view || _view, [
        view,
        _view
    ]);
    const previousView = (0, $heCPy.usePrevious)(actualView, [
        'minimized'
    ]);
    const [modalState, setModalState] = (0, $5uXOq.useState)((0, $kNC83.TransitionState).EXITED);
    const [miniState, setMiniState] = (0, $5uXOq.useState)((0, $kNC83.TransitionState).EXITED);
    const [minimizedState, setMinimizedState] = (0, $5uXOq.useState)((0, $kNC83.TransitionState).EXITED);
    const [fullscreenState, setFullscreenState] = (0, $5uXOq.useState)((0, $kNC83.TransitionState).EXITED);
    const [_shouldDisableViewChangerButtons, _setShouldDisableViewChangerButtons] = (0, $5uXOq.useState)(false);
    const [_customDisabledViewChangerButtonsMessage, _setCustomDisabledViewChangerButtonsMessage] = (0, $5uXOq.useState)('');
    const [isNestedModal, setIsNestedModal] = (0, $5uXOq.useState)(false);
    const transitionByKeyboardFrom = (0, $5uXOq.useRef)(null);
    const shouldFocusChanger = (0, $5uXOq.useRef)(false);
    const currentTransitionState = (0, $5uXOq.useMemo)(()=>({
            modal: modalState,
            mini: miniState,
            minimized: minimizedState,
            fullscreen: fullscreenState
        }), [
        modalState,
        miniState,
        minimizedState,
        fullscreenState
    ]);
    /**
	 * Will always return true if OS reduced motion is turned on since all usages of isTransitionInState
	 * are checking for a transition to be done before doing something
	 * With reduced motion its easiest to assume that the transition is always done since there are no transitions
	 */ const isTransitionInState = (0, $5uXOq.useCallback)((viewsTransitioning, state, fallbackForReducedMotion = true)=>{
        if ((0, $dWt6p.isReducedMotion)()) return fallbackForReducedMotion;
        return viewsTransitioning.every((viewTransitioning)=>currentTransitionState[viewTransitioning] === state);
    }, [
        currentTransitionState
    ]);
    const setTransitionState = (0, $5uXOq.useCallback)((viewTransitioning, state)=>{
        if (viewTransitioning === 'modal') setModalState(state);
        if (viewTransitioning === 'mini') setMiniState(state);
        if (viewTransitioning === 'minimized') setMinimizedState(state);
        if (viewTransitioning === 'fullscreen') setFullscreenState(state);
    }, []);
    const setShouldFocusChanger = (hasTransitioned)=>{
        shouldFocusChanger.current = hasTransitioned;
    };
    const setView = (0, $5uXOq.useCallback)((newView, force = false)=>{
        if (_shouldDisableViewChangerButtons && !force) return;
        if (view) {
            if (onViewChange) onViewChange(newView);
            return;
        }
        _setView(newView);
    }, [
        _shouldDisableViewChangerButtons,
        onViewChange,
        view
    ]);
    const unminimizeModal = (0, $5uXOq.useCallback)((fallbackView)=>{
        // For the case where the user controls the view of the minimizable modal, and starts it as 'minimized'
        if (previousView === 'minimized') {
            setView(fallbackView);
            return;
        }
        setView(previousView);
    }, [
        setView,
        previousView
    ]);
    const setTransitionByKeyboardFrom = (0, $5uXOq.useCallback)((keyPressedFrom)=>{
        transitionByKeyboardFrom.current = keyPressedFrom;
    }, []);
    const setShouldDisableViewChangerButtons = (0, $5uXOq.useCallback)((shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage = '')=>{
        _setShouldDisableViewChangerButtons(shouldDisableViewChangerButtons);
        _setCustomDisabledViewChangerButtonsMessage(customDisabledViewChangerButtonsMessage);
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            shouldFocusChanger: shouldFocusChanger.current,
            view: actualView,
            setView: setView,
            previousView: previousView,
            onClose: onClose,
            unminimizeModal: unminimizeModal,
            transitionByKeyboardFrom: transitionByKeyboardFrom.current,
            setTransitionByKeyboardFrom: setTransitionByKeyboardFrom,
            setShouldFocusChanger: setShouldFocusChanger,
            isTransitionInState: isTransitionInState,
            setTransitionState: setTransitionState,
            shouldDisableViewChangerButtons: _shouldDisableViewChangerButtons,
            customDisabledViewChangerButtonsMessage: _customDisabledViewChangerButtonsMessage,
            setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons,
            isNestedModal: isNestedModal,
            setIsNestedModal: setIsNestedModal,
            displayMinimizableButtons: displayMinimizableButtons
        }), [
        _customDisabledViewChangerButtonsMessage,
        _shouldDisableViewChangerButtons,
        actualView,
        isNestedModal,
        isTransitionInState,
        onClose,
        previousView,
        setShouldDisableViewChangerButtons,
        setTransitionByKeyboardFrom,
        setTransitionState,
        setView,
        unminimizeModal,
        displayMinimizableButtons
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1dce28e1d2cfa0c$export$a9554de703151814.Provider, {
        value: context
    }, children);
};
const $b1dce28e1d2cfa0c$export$40bb90ec193b1c2f = ()=>{
    const context = (0, $5uXOq.useContext)($b1dce28e1d2cfa0c$export$a9554de703151814);
    if (context === undefined) throw new Error('useMinimizableModal must be used within a MinimizableModalProvider');
    return context;
};

});
parcelRegister("kNC83", function(module, exports) {

$parcel$export(module.exports, "TransitionState", () => $08cbc53ad238dde5$export$145c1ed87b1a2216);
const $08cbc53ad238dde5$export$145c1ed87b1a2216 = {
    EXITED: 1,
    ENTERED: 2,
    TRANSITIONING: 3
};

});

parcelRegister("heCPy", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $08906ec90ae413ff$export$5cae361ad82dce8b);

var $5uXOq = parcelRequire("5uXOq");
function $08906ec90ae413ff$export$5cae361ad82dce8b(value, ignoreValues) {
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current !== value && !ignoreValues.includes(value)) ref.current = value;
    }, [
        value,
        ignoreValues
    ]);
    return ref.current;
}

});


parcelRegister("cjoqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeabca6159fd7931$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aeabca6159fd7931$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    missingToken: {
        "id": "issue-create.common.fields.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    },
    attachmentSizeLimitCheck: {
        "id": "issue-create.common.fields.attachments-field.attachment-size-limit-check",
        "defaultMessage": "We couldn\u2019t upload the attachment as you\u2019ve exceeded the limit"
    }
});

});


parcelRegister("4vfKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $facf0e52d6b312e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fr1K2 = parcelRequire("fr1K2");

var $gKZoD = parcelRequire("gKZoD");

var $eYh10 = parcelRequire("eYh10");

var $1wbtX = parcelRequire("1wbtX");

var $gwIPs = parcelRequire("gwIPs");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9ah8z = parcelRequire("9ah8z");

var $5UgCh = parcelRequire("5UgCh");

var $lfTZh = parcelRequire("lfTZh");

var $QTixP = parcelRequire("QTixP");

var $14XJw = parcelRequire("14XJw");

var $g5X3G = parcelRequire("g5X3G");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $diNhq = parcelRequire("diNhq");

var $k5LIG = parcelRequire("k5LIG");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $uaKxS = parcelRequire("uaKxS");

var $koVbs = parcelRequire("koVbs");

var $6gjIc = parcelRequire("6gjIc");

var $h0fZ7 = parcelRequire("h0fZ7");

var $j1zV8 = parcelRequire("j1zV8");

const $facf0e52d6b312e1$var$skeletonHeight = `${(0, $gwIPs.gridSize) * 18.75}px`;
const $facf0e52d6b312e1$var$PRINCIPAL_ID = 'context'; /**
                                 * We use the same DescriptionField component for all fields of "paragraph" type, including custom fields
                                 * This constant is for the default issue description field name
                                 */ 
const $facf0e52d6b312e1$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME = 'Description';
const $facf0e52d6b312e1$var$DESCRIPTION_FIELD_EXPERIENCE = 'GIC';
const $facf0e52d6b312e1$export$336230c809f2ec53 = (props)=>{
    (0, $gKZoD.di)(window);
    const { width: width = '100%', fieldProps: { value: value, onChange: onChange, onBlur: onBlur }, selectedProject: selectedProject, defaultValue: defaultValue, additionalData: additionalData, fieldName: fieldName, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false, selectedIssueType: selectedIssueType, getFormState: getFormState } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const loggedInUserAccountId = (0, $90yGq.useAccountId)();
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { onFocus: onFocusField, onBlur: onBlurField } = isGICPositioningEnabled() ? props : {};
    const { mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig } = additionalData;
    let mediaUploadContext;
    const uploadToken = mediaContext?.uploadToken;
    if (uploadToken) mediaUploadContext = {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        collection: uploadToken.targetCollection,
        token: uploadToken.token
    };
    const [editorApi, setEditorApi] = (0, $5uXOq.useState)();
    const product = (0, $QTixP.getProductForEditorAIPlugin)(selectedProject?.projectType);
    const issueTypeLabel = selectedIssueType?.label?.toLowerCase();
    const allowIssueReformatter = (0, $5uXOq.useMemo)(()=>fieldName === $facf0e52d6b312e1$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME, [
        fieldName
    ]);
    const productConfig = (0, $5uXOq.useMemo)(()=>({
            product: 'jira',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $diNhq.useLinkPickerEditorProps)(undefined, productConfig);
    const descriptionValue = value && typeof value === 'object' && 'type' in value ? value : undefined;
    const extractedLinksRef = (0, $4R6GH.fg)('gravityai-2132-extract-links-issue-reformatter') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $k5LIG.useExtractedLinksRef)(descriptionValue) : undefined;
    const editorPluginAIConfig = (0, $5uXOq.useMemo)(()=>({
            editorPluginAIConfig: {
                product: product,
                isAiOptInEnabled: !!adminRichTextConfig?.aiEnabledByProject,
                allowIssueReformatter: // For more context about allowIssueReformatter option, please refer to this PR: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/91592/overview
                allowIssueReformatter,
                getAdditionalProps: ()=>{
                    const linkedUrls = extractedLinksRef?.current?.(); // Replace if condition with the FF cleanup of gravityai-2132-extract-links-issue-reformatter
                    if (linkedUrls) return {
                        issue_type_label: issueTypeLabel,
                        issue_summary: getFormState?.()?.values.summary || '',
                        linked_urls: linkedUrls
                    };
                    return {
                        issue_type_label: issueTypeLabel,
                        issue_summary: getFormState?.()?.values.summary || ''
                    };
                },
                aiLifeCycleDynamicAttributesGetter: ()=>({
                        issueTypeLabel: issueTypeLabel || ''
                    }),
                linking: linkPicker ? {
                    linkPicker: linkPicker,
                    smartLinks: {
                        provider: Promise.resolve(new (0, $eYh10.EditorCardProvider)())
                    }
                } : undefined,
                getChannelVariables: (purpose)=>{
                    if (purpose === 'rovo-agent') {
                        if (typeof cloudId === 'string' && typeof loggedInUserAccountId === 'string') return {
                            cloudId: cloudId,
                            userId: loggedInUserAccountId,
                            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            contentURL: window.location.origin + window.location.pathname
                        };
                    }
                    return null;
                },
                actionSideEffects: {
                    continueInChat: ()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        const dockButton = document.getElementById('minimizable-modal.ui.modal-container.modal-header.mini-button');
                        dockButton?.click?.();
                    }
                }
            }
        }), [
        product,
        adminRichTextConfig?.aiEnabledByProject,
        allowIssueReformatter,
        linkPicker,
        issueTypeLabel,
        getFormState,
        cloudId,
        loggedInUserAccountId,
        extractedLinksRef
    ]);
    const editorConfig = (0, $QTixP.useEditorConfig)(editorPluginAIConfig);
    const mentionProvider = (0, $5uXOq.useRef)(new (0, $5UgCh.UserTeamProjectMentionProviderWithResolverMentionName)({
        projectKey: (0, $g5X3G.toProjectKey)(`${selectedProject?.projectKey || ''}`),
        projectType: selectedProject?.projectType
    }, {
        userId: $facf0e52d6b312e1$var$PRINCIPAL_ID,
        cloudId: cloudId,
        orgId: orgId
    }));
    const editorKey = (0, $5uXOq.useRef)(Date.now());
    const mediaProvider = {
        viewContext: mediaUploadContext,
        uploadContext: mediaUploadContext
    };
    let actualValue = defaultValue; // We are force resetting the editor using key as we could not achieve using EditorActions.replaceDocument or clear
    // We tried to pass down ref to the DescriptionEdit component and call the replaceDocument from here. Which did not work.
    // If we find a better way to achieve this, this code inside should be replaced.
    (0, $4R6GH.fg)('fix-gic-concurrent-rendering') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'resetRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
        if (value?.resetRequired === true) {
            editorKey.current = Date.now(); // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
            onChange((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(value, 'resetRequired'));
        }
    }, [
        defaultValue,
        onChange,
        value
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'resetRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
        if (value?.resetRequired === true) {
            editorKey.current = Date.now(); // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
            onChange((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(value, 'resetRequired'));
        }
    }, [
        defaultValue,
        onChange,
        value
    ]); // This is a similar hack to the one you see above for the case when we don't want to reset the editor to the
    // initial value but instead override the existing one with new one. It's needed for UI modifications setValue to work.
    // As above: once a better way is found, this code should be replaced.
    // UNBOX-505
    // @ts-expect-error - TS2339 - Property 'overrideRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
    const overrideRequired = value?.overrideRequired || false; // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
    actualValue = overrideRequired ? (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(value, 'overrideRequired') : value ?? defaultValue; // Since this useEffect call is in the feature-flag condition we can ignore eslint complaints
    (0, $4R6GH.fg)('fix-gic-concurrent-rendering') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (overrideRequired === true) {
            editorKey.current = Date.now();
            onChange(actualValue);
        }
    }, [
        overrideRequired,
        onChange,
        actualValue
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (overrideRequired === true) {
            editorKey.current = Date.now();
            onChange(actualValue);
        }
    }, [
        overrideRequired,
        onChange,
        actualValue
    ]);
    const issueSummary = getFormState?.()?.values.summary || '';
    const issueDescription = value && typeof value === 'object' && 'type' in value ? value : undefined;
    const isDescriptionCompleterEnabled = adminRichTextConfig?.aiEnabledByProject && (0, $6s1PB.expVal)('experiment_proactive_desc_completer_issueview', 'isEnabled', false);
    const contentComponents = (0, $5uXOq.useMemo)(()=>isDescriptionCompleterEnabled ? {
            before: [],
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $uaKxS.AsyncAiProactiveDescriptionCompleter), {
                editorApi: editorApi,
                editorExperience: $facf0e52d6b312e1$var$DESCRIPTION_FIELD_EXPERIENCE,
                issueType: issueTypeLabel,
                issueSummary: issueSummary,
                issueDescription: issueDescription
            })
        } : undefined, [
        editorApi,
        isDescriptionCompleterEnabled,
        issueDescription,
        issueSummary,
        issueTypeLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "description-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
            height: $facf0e52d6b312e1$var$skeletonHeight
        })
    }, isGICPositioningEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($facf0e52d6b312e1$var$WrapperDiv, {
        tabIndex: -1,
        onFocus: ()=>{
            if (isGICPositioningEnabled() && onFocusField) onFocusField();
        },
        onBlur: isGICPositioningEnabled() ? onBlurField : undefined,
        "data-testid": isGICPositioningEnabled() ? 'issue-create.common.ui.fields.description-field.wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ah8z.AsyncRichTextEditView), {
        key: editorKey.current,
        onChange: onChange,
        onBlur: onBlur,
        defaultValue: actualValue,
        mentionProvider: mentionProvider.current,
        mediaContext: mediaProvider,
        shouldFocus: autoFocus,
        isDisabled: isReadOnly,
        assistiveLabel: fieldName,
        sharedEditorConfig: editorConfig,
        ...isDescriptionCompleterEnabled ? {
            setEditorApi: setEditorApi,
            contentComponents: contentComponents,
            placeholder: formatMessage((0, $j1zV8.messages).placeholder)
        } : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ah8z.AsyncRichTextEditView), {
        key: editorKey.current,
        onChange: onChange,
        onBlur: onBlur,
        defaultValue: actualValue,
        mentionProvider: mentionProvider.current,
        mediaContext: mediaProvider,
        shouldFocus: autoFocus,
        isDisabled: isReadOnly,
        assistiveLabel: fieldName,
        sharedEditorConfig: editorConfig,
        ...isDescriptionCompleterEnabled ? {
            setEditorApi: setEditorApi,
            contentComponents: contentComponents,
            placeholder: formatMessage((0, $j1zV8.messages).placeholder)
        } : {}
    })));
};
var $facf0e52d6b312e1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
 = (0, $hpV4g.withFormField)({
    validator: (0, $h0fZ7.validateDescriptionField // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DescriptionFieldConfig, FieldValue>, any>'.
    )
})($facf0e52d6b312e1$export$336230c809f2ec53);
const $facf0e52d6b312e1$var$WrapperDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
$facf0e52d6b312e1$var$WrapperDiv.displayName = 'WrapperDiv';

});
parcelRegister("eYh10", function(module, exports) {

$parcel$export(module.exports, "EditorCardProvider", () => $9c198639652e78ad$export$e4635c0135e1a519);
// WARNING!!!
// Editor Card Provider has been moved to the @atlaskit/editor-card-provider package.
// If you are going to make changes here, be aware that this folder and instance
// of Editor Card Provider will be removed.
// For more information see:
// https://hello.atlassian.net/browse/ENGHEALTH-661
// and
// https://product-fabric.atlassian.net/browse/EDM-5755

var $hhZW9 = parcelRequire("hhZW9");

var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $k9B19 = parcelRequire("k9B19");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $38Kxa = parcelRequire("38Kxa");

var $7cFR3 = parcelRequire("7cFR3");
const $9c198639652e78ad$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $9c198639652e78ad$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $9c198639652e78ad$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $9c198639652e78ad$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $9c198639652e78ad$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $9c198639652e78ad$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
class $9c198639652e78ad$export$e4635c0135e1a519 {
    constructor(envKey, baseUrlOverride){
        this.baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $38Kxa.Transformer)();
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $9c198639652e78ad$var$BATCH_WAIT_TIME)
        });
        this.cardClient = new (0, $7cFR3.default)(envKey, baseUrlOverride);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async check(resourceUrl) {
        try {
            const response = await this.cardClient.fetchData(resourceUrl);
            if ((0, $fiKQs.getStatus)(response) !== 'not_found') return true;
        } catch (e) {
            return false;
        }
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $dV0Jy.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.check(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    getHardCodedAppearance(url) {
        if ($9c198639652e78ad$var$isJiraRoadmapOrTimeline(url) || $9c198639652e78ad$var$isPolarisView(url) || $9c198639652e78ad$var$isJwmView(url) || $9c198639652e78ad$var$isGiphyMedia(url) || $9c198639652e78ad$var$isProformaView(url)) return 'embed';
    }
    /**
	 * Make a /resolve call and find out if result has embed capability
	 * @param url
	 * @private
	 */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.cardClient.fetchData(url);
            // Noun entities supported
            if ((0, $VSDnB.fg)('smart_links_noun_support')) {
                if (!details) return false;
                const embed = (0, $dhQ1x.extractSmartLinkEmbed)(details);
                return !!embed;
            }
            const data = details && details.data;
            if (!data) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $fiKQs.getStatus)(details) !== 'resolved') return false;
            const preview = (0, $k9B19.extractPreview)(data, 'web');
            return !!preview;
        } catch (e) {
            return false;
        }
    }
    async resolve(url, appearance, shouldForceAppearance) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            let isSupported = !!matchedProviderPattern || await this.check(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                let preferredAppearance = shouldForceAppearance === undefined ? hardCodedAppearance || appearance : // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira roadmap/timeline, polaris, etc)
                hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                return this.transformer.toAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
}
const $9c198639652e78ad$export$b7c3c9a99f7959f5 = new $9c198639652e78ad$export$e4635c0135e1a519();

});
parcelRegister("38Kxa", function(module, exports) {

$parcel$export(module.exports, "Transformer", () => $964b3a5e1dd4467f$export$f993aef960936087);
class $964b3a5e1dd4467f$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    toAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
}

});


parcelRegister("9ah8z", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextEditView", () => $5d9d583311ca074a$export$ba962c8a1ae57ac);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $30zeq = parcelRequire("30zeq");
const $5d9d583311ca074a$var$EMPTY_OBJECT = {};
const $5d9d583311ca074a$export$ba962c8a1ae57ac = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $30zeq.asyncRichTextEditEntryPoint), // use stable object reference to avoid re-renders
    $5d9d583311ca074a$var$EMPTY_OBJECT);
    if ((0, $4R6GH.fg)('fix-create-another-bug-in-react18-concurrent-mode')) // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    else // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-issue-field-rich-text-edit-async",
        packageName: "jira-issue-field-rich-text",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            height: "150px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("30zeq", function(module, exports) {

$parcel$export(module.exports, "asyncRichTextEditEntryPoint", () => $33d1c4c4e757e553$export$153c0381975152a7);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $33d1c4c4e757e553$export$153c0381975152a7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7u6lI")).then((module)=>module.EntryPointContent), {
        moduleId: "7ade4e9b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7u6lI", function(module, exports) {

let $5730429399f29af7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5730429399f29af7$var$load("dsiAd"),
    $5730429399f29af7$var$load("h2MrD"),
    $5730429399f29af7$var$load("bYT2S"),
    $5730429399f29af7$var$load("cM9em"),
    $5730429399f29af7$var$load("fr9NE"),
    $5730429399f29af7$var$load("gNIa8")
]).then(()=>parcelRequire('dhLv0'));

});



parcelRegister("5UgCh", function(module, exports) {

$parcel$export(module.exports, "UserTeamProjectMentionProviderWithResolverMentionName", () => $19555268e20407e6$export$9bc9aba7518c0a7);

var $cQ10e = parcelRequire("cQ10e");
var $cqJWb = parcelRequire("cqJWb");

var $5GjwW = parcelRequire("5GjwW");

var $97D2J = parcelRequire("97D2J");
class $19555268e20407e6$export$9bc9aba7518c0a7 extends (0, $97D2J.UserTeamProjectMentionProvider) {
    constructor(projectOptions, teamOptions){
        super(projectOptions, teamOptions);
        this.config = {
            mentionNameResolver: new (0, $cQ10e.DefaultMentionNameResolver)(new (0, $5GjwW.default)())
        };
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $cqJWb.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
}

});
parcelRegister("cQ10e", function(module, exports) {

$parcel$export(module.exports, "DefaultMentionNameResolver", () => $1a91bec96e20200d$export$2ae0434dccdcb77e);

var $cqJWb = parcelRequire("cqJWb");

var $4kfbr = parcelRequire("4kfbr");
class $1a91bec96e20200d$export$2ae0434dccdcb77e {
    static{
        this.waitForBatch = 100 // ms
        ;
    }
    static{
        this.waitForResolveAll = 800 // ms
        ;
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.isOnResolvedAllCalled = false;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $1a91bec96e20200d$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $cqJWb.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $cqJWb.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $4kfbr.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $cqJWb.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $1a91bec96e20200d$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $1a91bec96e20200d$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $cqJWb.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
}
function $1a91bec96e20200d$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}

});
parcelRegister("cqJWb", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $90ca79fb430b6e09$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $90ca79fb430b6e09$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $90ca79fb430b6e09$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $90ca79fb430b6e09$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $90ca79fb430b6e09$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $90ca79fb430b6e09$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $90ca79fb430b6e09$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $90ca79fb430b6e09$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $90ca79fb430b6e09$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $90ca79fb430b6e09$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $90ca79fb430b6e09$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $90ca79fb430b6e09$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $90ca79fb430b6e09$export$4369c812aac99591);
var $90ca79fb430b6e09$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $90ca79fb430b6e09$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $90ca79fb430b6e09$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $90ca79fb430b6e09$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $90ca79fb430b6e09$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $90ca79fb430b6e09$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $90ca79fb430b6e09$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
}
function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
}
function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
}
function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
}
function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("4kfbr", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $f8976e2813fe24b2$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $f8976e2813fe24b2$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $f8976e2813fe24b2$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $f8976e2813fe24b2$export$91b2fa6a0fe06408);



var $cqJWb = parcelRequire("cqJWb");
const $f8976e2813fe24b2$var$packageName = "platform-pkg";
const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, $cqJWb.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $cqJWb.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        return event;
    };
const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        attributes: {
            packageName: $f8976e2813fe24b2$var$packageName,
            packageVersion: $f8976e2813fe24b2$var$packageVersion,
            componentName: (0, $cqJWb.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $cqJWb.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("5GjwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $19675cdaadbe090b$export$2e2bcd8739ae039);

var $cqJWb = parcelRequire("cqJWb");
const $19675cdaadbe090b$var$bulkUserPath = '/rest/api/3/user/bulk';
const $19675cdaadbe090b$var$MAX_MENTIONS = 50;
class $19675cdaadbe090b$export$2e2bcd8739ae039 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return $19675cdaadbe090b$var$MAX_MENTIONS;
    }
    async lookupMentionNames(ids) {
        const params = ids.reduce((idParams, id, index)=>`${idParams}${index > 0 ? '&' : ''}accountId=${encodeURIComponent(id)}`, '');
        return fetch(`${$19675cdaadbe090b$var$bulkUserPath}?${params}&maxResults=${$19675cdaadbe090b$var$MAX_MENTIONS}`, {
            credentials: 'same-origin'
        }).then((response)=>response.json()).then((data)=>{
            if (!data || !data.values || !data.values.length) return [];
            return data.values.filter(Boolean).map((user)=>({
                    id: user.accountId,
                    name: user.displayName,
                    status: (0, $cqJWb.MentionNameStatus).OK
                }));
        });
    }
}

});

parcelRegister("97D2J", function(module, exports) {

$parcel$export(module.exports, "UserTeamProjectMentionProvider", () => $d519702ba683d614$export$68d633262339b833);

var $lFKmC = parcelRequire("lFKmC");

var $hGgHi = parcelRequire("hGgHi");

var $92lWB = parcelRequire("92lWB");

var $eqACH = parcelRequire("eqACH");
const $d519702ba683d614$var$MENTION_DEBOUNCE_MS = 150;
class $d519702ba683d614$export$68d633262339b833 extends (0, $92lWB.ProjectMentionProvider) {
    constructor(projectOptions, teamOptions){
        super('', projectOptions.projectKey, projectOptions.projectType), this.debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(async (query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            try {
                const mentionResults = await Promise.all([
                    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                    this.teamMentionProvider.getRecommendedMentions(query, contextIdentifier),
                    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                    this.search(query, contextIdentifier)
                ]);
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) this.lastSearchTime = currentSearchTime;
                return mentionResults.reduce((acc, mentionResult)=>{
                    if (mentionResult) acc.mentions = [
                        ...acc.mentions,
                        ...mentionResult.mentions
                    ];
                    return acc;
                }, {
                    mentions: [],
                    query: query ?? ''
                });
            } catch (e) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(query) && query.length > 0) this.activeSearches.delete(query);
                throw e;
            }
        }, $d519702ba683d614$var$MENTION_DEBOUNCE_MS);
        this.teamMentionProvider = new (0, $eqACH.TeamMentionProvider)({
            cloudId: teamOptions.cloudId,
            userId: teamOptions.userId,
            orgId: teamOptions.orgId
        });
    }
    /**
	 * We override the filter function to search and interpolate the results from both the project and team mention providers.
	 * This is so that we can only show users that have project access.
	 */ async filter(query, contextIdentifier) {
        try {
            const currentSearchTime = Date.now();
            const mentionResults = await this.debouncedSearch(query, contextIdentifier);
            const results = mentionResults ?? {
                mentions: [],
                query: query ?? ''
            };
            this._notifyListeners(results, {
                duration: Date.now() - currentSearchTime
            });
            this._notifyAllResultsListeners(results);
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            this._notifyErrorListeners(e);
        }
    }
}

});
parcelRegister("92lWB", function(module, exports) {

$parcel$export(module.exports, "ProjectMentionProvider", () => $e29d82157b4dfb7f$export$40976f7091c70c78);

var $ebyGx = parcelRequire("ebyGx");

var $gVfsM = parcelRequire("gVfsM");
class $e29d82157b4dfb7f$export$40976f7091c70c78 extends (0, $gVfsM.AbstractMentionProvider) {
    constructor(baseUrl, projectKey, projectType){
        super(baseUrl, projectType), this.getQueryString = (query)=>(0, $ebyGx.stringify)({
                query: query,
                projectKey: this.projectKey,
                maxResults: 10
            }), this.getUrl = (queryString)=>`${this.baseUrl}/rest/api/2/user/viewissue/search?${queryString}`, this.shouldHighlightMention = (mention)=>mention.id === this.projectKey;
        this.projectKey = projectKey;
    }
}

});
parcelRegister("gVfsM", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionProvider", () => $b8e30b1d7a2c4e16$export$1503942bd70a06a4);

var $lFKmC = parcelRequire("lFKmC");

var $hGgHi = parcelRequire("hGgHi");

var $3mm6g = parcelRequire("3mm6g");

var $4Pf62 = parcelRequire("4Pf62");

var $7f4tk = parcelRequire("7f4tk");

var $ecbCU = parcelRequire("ecbCU");

var $4QRz9 = parcelRequire("4QRz9");
const $b8e30b1d7a2c4e16$var$MENTION_DEBOUNCE_MS = 150;
class $b8e30b1d7a2c4e16$export$1503942bd70a06a4 extends (0, $3mm6g.AbstractMentionResource) {
    constructor(baseUrl, projectType, createAnalyticsEvent){
        super(), this.debouncedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            return this.search(query, contextIdentifier).then((mentionResult)=>{
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this._notifyListeners(mentionResult, {
                        duration: Date.now() - currentSearchTime
                    });
                }
                this._notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(query) && query.length > 0) this.activeSearches.delete(query);
                this._notifyErrorListeners(e);
            });
        }, $b8e30b1d7a2c4e16$var$MENTION_DEBOUNCE_MS);
        this.baseUrl = baseUrl;
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
        this.productName = (0, $4QRz9.subProductFromProjectType)(projectType);
        this.userRole = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin ? 'admin' : 'basic';
        this.onInviteItemClick = ()=>{
            (0, $ecbCU.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                inviteFlow: 'mention'
            });
        };
        this.shouldEnableInvite = true;
        this.isEligibleXProductUserInvite = false;
        this.inviteXProductUser = ()=>Promise.resolve();
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    filter(query, contextIdentifier) {
        return this.debouncedFilter(query, contextIdentifier);
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query);
        return this.fetchMentions(url).then((users)=>users.map((user)=>({
                    name: user.displayName,
                    mentionName: user.displayName,
                    nickname: user.displayName,
                    id: user.accountId,
                    avatarUrl: user.avatarUrls['48x48']
                }))).then((mentions)=>({
                query: query,
                mentions: mentions
            }));
    }
    // Allow concrete subclasses to override this method so fetch calls can be instrumented
    fetchMentions(url) {
        return (0, $7f4tk.default)(url);
    }
}

});
parcelRegister("3mm6g", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $9565842f98e50876$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $9565842f98e50876$export$ae1fce5f69858ef3);

var $dS9cn = parcelRequire("dS9cn");

var $cqJWb = parcelRequire("cqJWb");

var $6Ctoj = parcelRequire("6Ctoj");

var $4kfbr = parcelRequire("4kfbr");

var $lFKmC = parcelRequire("lFKmC");
const $9565842f98e50876$var$MAX_QUERY_ITEMS = 100;
const $9565842f98e50876$var$MAX_NOTIFIED_ITEMS = 20;
const $9565842f98e50876$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $9565842f98e50876$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $9565842f98e50876$export$8576ba1ed2760927 extends $9565842f98e50876$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $9565842f98e50876$export$5a4331e3e1c43553 extends $9565842f98e50876$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $6Ctoj.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $cqJWb.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $9565842f98e50876$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $9565842f98e50876$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $cqJWb.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $cqJWb.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $9565842f98e50876$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $9565842f98e50876$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $9565842f98e50876$export$2e2bcd8739ae039 = $9565842f98e50876$export$5a4331e3e1c43553;

});
parcelRegister("6Ctoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e109bd73548e92fc$export$2e2bcd8739ae039);
let $e109bd73548e92fc$var$debugEnabled = false;
let $e109bd73548e92fc$var$stacktracesEnabled = false;
function $e109bd73548e92fc$export$748ada60eaf985cc(enable) {
    $e109bd73548e92fc$var$debugEnabled = enable;
}
function $e109bd73548e92fc$export$4f7017086af31c25(enable) {
    $e109bd73548e92fc$var$stacktracesEnabled = enable;
}
function $e109bd73548e92fc$export$2a858f450a2f66d() {
    if ($e109bd73548e92fc$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e109bd73548e92fc$export$2e2bcd8739ae039(msg, ...args) {
    if ($e109bd73548e92fc$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("4QRz9", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $e6c9433376b7f0e7$export$246e1e2a5c86a633);

var $2vSU6 = parcelRequire("2vSU6");
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e6c9433376b7f0e7$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e6c9433376b7f0e7$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e6c9433376b7f0e7$var$CORE_APPLICATION_ROLE = 'jira-core';
const $e6c9433376b7f0e7$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'Jira Service Management';
        default:
            return 'Jira';
    }
};

});



parcelRegister("eqACH", function(module, exports) {

$parcel$export(module.exports, "TeamMentionProvider", () => $b205363457eed1d3$export$d113415d07aa661c);

var $hb4ta = parcelRequire("hb4ta");
const $b205363457eed1d3$var$BaseSmartMentionConfigOptions = {
    env: 'prod',
    productKey: 'jira',
    includeTeams: true,
    includeUsers: false
};
class $b205363457eed1d3$export$d113415d07aa661c extends (0, $hb4ta.default) {
    constructor({ cloudId: cloudId, orgId: orgId, userId: userId }){
        super({
            ...$b205363457eed1d3$var$BaseSmartMentionConfigOptions,
            siteId: cloudId,
            orgId: orgId,
            principalId: userId ?? undefined
        });
    }
}

});
parcelRegister("hb4ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $78b5826b69e4fa06$export$2e2bcd8739ae039);

var $3mm6g = parcelRequire("3mm6g");
var $cqJWb = parcelRequire("cqJWb");

var $2tzKd = parcelRequire("2tzKd");

var $029gh = parcelRequire("029gh");

var $2amqV = parcelRequire("2amqV");

var $8sKzN = parcelRequire("8sKzN");
const $78b5826b69e4fa06$var$CONTEXT_TYPE = 'Mentions';
const $78b5826b69e4fa06$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $78b5826b69e4fa06$var$SmartMentionResource extends (0, $3mm6g.AbstractMentionResource) {
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = $78b5826b69e4fa06$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $2amqV.DefaultMentionNameResolver)(smartMentionConfig.baseUrl)
        };
        this.lastReturnedSearch = 0;
    }
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $78b5826b69e4fa06$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $029gh.SMART_EVENT_TYPE), 'users', (0, $029gh.Actions).REQUESTED, (0, $029gh.defaultAttributes)(contextIdentifier));
            const users = await (0, $8sKzN.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $029gh.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $029gh.SMART_EVENT_TYPE), 'usersRequest', (0, $029gh.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $029gh.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $029gh.SMART_EVENT_TYPE), 'usersRequest', (0, $029gh.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $029gh.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $2tzKd.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType
            };
        }
        if (type === (0, $2tzKd.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $cqJWb.UserAccessLevel)[(0, $cqJWb.UserAccessLevel).CONTAINER],
                userType: (0, $cqJWb.UserType)[(0, $cqJWb.UserType).TEAM],
                lozenge: (0, $cqJWb.UserType)[(0, $cqJWb.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink
                },
                source: 'smarts'
            };
        }
        if (type === (0, $2tzKd.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $2tzKd.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $2tzKd.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $029gh.SMART_EVENT_TYPE), 'usersRequest', (0, $029gh.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $029gh.defaultAttributes)(this.contextIdentifier)
        });
    }
}
var $78b5826b69e4fa06$export$2e2bcd8739ae039 = $78b5826b69e4fa06$var$SmartMentionResource;

});
parcelRegister("2tzKd", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $9143070c87bffca9$export$8eda7e02f8f033b2);
var $9143070c87bffca9$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});

parcelRegister("029gh", function(module, exports) {

$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $9ae0decad8e7664b$export$c724588856bbfbcf);
$parcel$export(module.exports, "Actions", () => $9ae0decad8e7664b$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "defaultAttributes", () => $9ae0decad8e7664b$export$38cd8db2db178f58);
$parcel$export(module.exports, "getUsersForAnalytics", () => $9ae0decad8e7664b$export$e8be30a842a4b49d);
const $9ae0decad8e7664b$export$c724588856bbfbcf = 'smart';
var $9ae0decad8e7664b$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $9ae0decad8e7664b$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $9ae0decad8e7664b$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};

});

parcelRegister("2amqV", function(module, exports) {

$parcel$export(module.exports, "DefaultMentionNameResolver", () => $d7e94daccd487415$export$2ae0434dccdcb77e);

var $cqJWb = parcelRequire("cqJWb");

var $12kuH = parcelRequire("12kuH");

var $lfBO6 = parcelRequire("lfBO6");
const $d7e94daccd487415$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $d7e94daccd487415$var$makeRequest = async (url, accountIds)=>{
    const query = $d7e94daccd487415$var$buildUsersQuery(accountIds);
    return (0, $lfBO6.graphqlQuery)(url, query);
};
class $d7e94daccd487415$export$2ae0434dccdcb77e {
    constructor(baseUrl){
        this.baseUrl = baseUrl;
        this.cache = new Map();
    }
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $cqJWb.MentionNameStatus).OK
            };
            const url = (0, $12kuH.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $d7e94daccd487415$var$makeRequest(url, [
                id
            ]);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $cqJWb.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $cqJWb.MentionNameStatus).UNKNOWN
            };
        } catch (error) {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $cqJWb.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
}

});
parcelRegister("12kuH", function(module, exports) {

$parcel$export(module.exports, "PRD_CONFIG", () => $e1f33aba6362497a$export$d4fff2dfff3e2bc1);
const $e1f33aba6362497a$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};

});

parcelRegister("lfBO6", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $9b021ceaa75f64e1$export$74eb8d79ae3e02b5);
const $9b021ceaa75f64e1$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $9b021ceaa75f64e1$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $9b021ceaa75f64e1$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("8sKzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $674292251195da91$export$2e2bcd8739ae039);

var $12kuH = parcelRequire("12kuH");
const $674292251195da91$var$getUserRecommendations = (request)=>{
    const url = (0, $12kuH.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $674292251195da91$export$2e2bcd8739ae039 = $674292251195da91$var$getUserRecommendations;

});





parcelRegister("QTixP", function(module, exports) {

$parcel$export(module.exports, "getProductForEditorAIPlugin", () => $ea0224ff44292610$export$ae2611ff27e7ff5);
$parcel$export(module.exports, "useEditorConfig", () => $ea0224ff44292610$export$68f5e61568cc49bc);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $gI3Ag = parcelRequire("gI3Ag");

var $7rITF = parcelRequire("7rITF");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iixvy = parcelRequire("iixvy");

var $5NH95 = parcelRequire("5NH95");

var $f7Fws = parcelRequire("f7Fws");

var $l9wag = parcelRequire("l9wag");
const $ea0224ff44292610$var$FEEDBACK_COLLECTOR_ID = 'fb2a9bff-f1e7-4deb-b396-7bfaae5af671';
const $ea0224ff44292610$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $ea0224ff44292610$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $ea0224ff44292610$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $ea0224ff44292610$var$buildAdditionalFields = (props, hasUserConsent)=>{
    if (!props || !props.getAIExperience) return undefined;
    const { getAIExperience: getAIExperience, sentiment: sentiment, editorAttributes: editorAttributes } = props;
    const aiExperience = getAIExperience?.(hasUserConsent) || {};
    let feedbackMetadataStringified = `sentiment: ${sentiment}\n`;
    Object.entries({
        ...aiExperience,
        ...editorAttributes
    }).forEach((item)=>{
        feedbackMetadataStringified += `${item[0]}: ${item[1]}\n`;
    });
    return [
        {
            id: $ea0224ff44292610$var$FEEDBACK_CONTEXT_ID,
            value: feedbackMetadataStringified
        }
    ];
};
const $ea0224ff44292610$var$CanContactLabel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $f7Fws.default).canContactText,
        values: {
            // this is done exactly as documented here: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
            // @ts-expect-error - https://github.com/formatjs/formatjs/issues/3550 need to updated to v6 intl
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    target: "_blank",
                    href: $ea0224ff44292610$var$LINK_TO_PRIVACY_POLICY
                }, chunks)
        }
    });
const $ea0224ff44292610$var$EnrolLabel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $f7Fws.default).improveAtlassianText,
        values: {
            // this is done exactly as documented here: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
            // @ts-expect-error - https://github.com/formatjs/formatjs/issues/3550 need to updated to v6 intl
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    target: "_blank",
                    href: $ea0224ff44292610$var$LINK_TO_RESEARCH_GROUP
                }, chunks)
        }
    });
const $ea0224ff44292610$export$ae2611ff27e7ff5 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return (0, $l9wag.Product).JWM;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return (0, $l9wag.Product).JSW;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return (0, $l9wag.Product).JSM;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return (0, $l9wag.Product).JPD;
        default:
            return null;
    }
};
const $ea0224ff44292610$export$7543cd52952bad27 = (editorPluginAIConfig)=>{
    const isAIOptedIn = editorPluginAIConfig.isAiOptInEnabled;
    return isAIOptedIn ? 'enabled' : 'disabled';
};
const $ea0224ff44292610$export$ff2962de2b2c930f = (product)=>{
    switch(product){
        case (0, $l9wag.Product).JSW:
            return 'jira-software';
        case (0, $l9wag.Product).JPD:
            return 'jpd';
        case (0, $l9wag.Product).JSM:
            return 'jsm';
        default:
            return 'jira';
    }
};
// Extracting this function as it caused instability between renders, as picked up by Cypress
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $ea0224ff44292610$var$fireEmptyExperimentExposure = ()=>{};
const $ea0224ff44292610$export$68f5e61568cc49bc = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { openFeedbackCollector: openFeedbackCollector, updateCustomRenderComponent: updateCustomRenderComponent, updateAdditionalFields: updateAdditionalFields } = (0, $dseDh.useFeedbackCollectorActions)();
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, $iixvy.useAIOptIn)({
        editorPluginAIConfig: editorPluginAIConfig
    });
    // AI Upsell In Editor Experiment
    const { isEnrolledInExperiment: isAIUpsellInEditorFreeEnrolled, isExperimentEnabled: isAIUpsellInEditorFreeEnabled, fireExperimentExposure: fireAIUpsellInEditorFreeExposure } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, editorPluginAIConfig?.product) : {
        isEnrolledInExperiment: false,
        isExperimentEnabled: false,
        fireExperimentExposure: $ea0224ff44292610$var$fireEmptyExperimentExposure
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isAIUpsellInEditorFreeEnrolled) fireAIUpsellInEditorFreeExposure();
    }, [
        isAIUpsellInEditorFreeEnrolled,
        fireAIUpsellInEditorFreeExposure
    ]);
    const [hasUserConsent, setHasUserConsent] = (0, $5uXOq.useState)(false);
    const [additionalFieldsData, setAdditionalFieldsData] = (0, $5uXOq.useState)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleHasUserConsent = (0, $5uXOq.useCallback)(()=>{
        setHasUserConsent(!hasUserConsent);
        updateAdditionalFields($ea0224ff44292610$var$buildAdditionalFields(additionalFieldsData, !hasUserConsent));
    }, [
        hasUserConsent,
        additionalFieldsData,
        updateAdditionalFields
    ]);
    const renderCustomFeedbackContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
            label: formatMessage((0, $f7Fws.default).userConsentCheckboxLabel),
            onChange: handleHasUserConsent,
            isChecked: hasUserConsent
        }), [
        hasUserConsent,
        formatMessage,
        handleHasUserConsent
    ]);
    const PromptEditor = (0, $5uXOq.useMemo)(()=>(0, $gI3Ag.createPromptEditor)({
            linking: editorPluginAIConfig?.linking,
            featureFlags: {},
            enableLinks: !!editorPluginAIConfig?.linking
        }), [
        editorPluginAIConfig?.linking
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateCustomRenderComponent(renderCustomFeedbackContent);
    }, [
        renderCustomFeedbackContent,
        updateCustomRenderComponent
    ]);
    const AIConfiguration = (0, $5uXOq.useMemo)(()=>{
        if (!editorPluginAIConfig?.product) return undefined;
        return (0, $7rITF.createJiraEditorPluginAIOptions)({
            aiGlobalOptIn: {
                status: optInStatus,
                triggerOptInFlow: triggerOptInFlow
            },
            aiLifeCycleDynamicAttributesGetter: editorPluginAIConfig.aiLifeCycleDynamicAttributesGetter,
            generativeAIApiUrl: '/gateway/api/editor-ai/v1/generative/ai',
            issueId: editorPluginAIConfig?.issueId,
            // issueId will be required only in JSM product
            product: editorPluginAIConfig.product,
            allowIssueReformatter: (0, $4R6GH.fg)('platform_gravityai-1853_issue_reformatter_ga') ? editorPluginAIConfig?.allowIssueReformatter : editorPluginAIConfig.product === (0, $l9wag.Product).JSW && editorPluginAIConfig?.allowIssueReformatter,
            allowSuggestResponse: editorPluginAIConfig.allowSuggestResponse,
            getAdditionalProps: editorPluginAIConfig?.getAdditionalProps,
            handleFeedbackSubmission: async ({ sentiment: sentiment, editorAttributes: editorAttributes, getAIExperience: getAIExperience })=>{
                // @ts-expect-error plugin issue
                const feedbackContextData = {
                    getAIExperience: getAIExperience,
                    sentiment: sentiment,
                    editorAttributes: editorAttributes
                };
                const feedbackCollectorProps = {
                    entrypointId: (0, $7iULw.ENTRY_POINT_ID_GENERATIVE_AI),
                    feedbackTitle: formatMessage((0, $f7Fws.default).feedBackTitle),
                    feedbackCollectorId: $ea0224ff44292610$var$FEEDBACK_COLLECTOR_ID,
                    renderCustomContent: renderCustomFeedbackContent,
                    showTypeField: false,
                    summaryPlaceholder: formatMessage((0, $f7Fws.default).summaryPlaceholder),
                    additionalFields: $ea0224ff44292610$var$buildAdditionalFields(feedbackContextData, hasUserConsent),
                    canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea0224ff44292610$var$CanContactLabel, null),
                    enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea0224ff44292610$var$EnrolLabel, null)
                };
                setAdditionalFieldsData(feedbackContextData);
                try {
                    openFeedbackCollector(feedbackCollectorProps);
                    return {
                        status: 'submitted'
                    };
                } catch (error) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('platforms.utils.shared-editor-config.entry', 'Error sending feedback submission', error instanceof Error ? error : undefined);
                    return {
                        status: 'failed'
                    };
                }
            },
            PromptEditor: PromptEditor,
            AIButtonWrapper: isAIUpsellInEditorFreeEnabled ? (0, $5NH95.AIUpsellButtonWrapper) : undefined,
            getChannelVariables: editorPluginAIConfig?.getChannelVariables,
            actionSideEffects: editorPluginAIConfig?.actionSideEffects,
            actionOverrides: editorPluginAIConfig?.actionOverrides,
            auditLogSettings: editorPluginAIConfig.auditLogEventData ? {
                enabled: true,
                eventData: editorPluginAIConfig.auditLogEventData
            } : {
                enabled: false
            }
        });
    }, [
        hasUserConsent,
        optInStatus,
        triggerOptInFlow,
        editorPluginAIConfig,
        openFeedbackCollector,
        formatMessage,
        renderCustomFeedbackContent,
        PromptEditor,
        isAIUpsellInEditorFreeEnabled
    ]);
    return {
        props: {
            isAIUpsellInEditorFreeEnabled: isAIUpsellInEditorFreeEnabled
        },
        AIConfiguration: AIConfiguration,
        components: {
            AIOptInModal: AIOptInModal
        }
    };
};

});
parcelRegister("gI3Ag", function(module, exports) {

$parcel$export(module.exports, "createPromptEditor", () => $9d86ac563656b71b$export$df4eed2eacb29ddb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $9ao8a = parcelRequire("9ao8a");

var $20Kbb = parcelRequire("20Kbb");

var $kjU5q = parcelRequire("kjU5q");

var $ankW9 = parcelRequire("ankW9");

var $5Xe3v = parcelRequire("5Xe3v");

var $gZGBX = parcelRequire("gZGBX");

var $bUmQV = parcelRequire("bUmQV");

var $fLTqo = parcelRequire("fLTqo");

var $cwKDG = parcelRequire("cwKDG");

var $crtQ3 = parcelRequire("crtQ3");

var $eqXnF = parcelRequire("eqXnF");
const $9d86ac563656b71b$var$EditorWrapper = (props)=>{
    const appearance = 'chromeless';
    const { editorProps: editorProps, options: options } = props;
    const { type: type = 'user-input', onChange: onChange, onInputChange: onInputChange, onADFChange: onADFChange, defaultValue: defaultValue, enableLinks: enableLinks, setFocusHandlers: setFocusHandlers, setClearHandler: setClearHandler, ariaLabel: ariaLabel } = editorProps;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleChange = (0, $5uXOq.useCallback)((editorView)=>{
        const textSerializer = (0, $fLTqo.default).fromSchema(editorView.state.schema);
        const text = textSerializer.serializeFragment(editorView.state.doc.content);
        const adf = (0, $20Kbb.toJSON)(editorView.state.doc);
        onChange?.({
            text: text,
            adf: adf
        });
        onADFChange?.(adf);
        onInputChange?.(text);
    }, [
        onChange,
        onADFChange,
        onInputChange
    ]);
    const onSave = (0, $5uXOq.useCallback)((editorView)=>{
        handleChange(editorView);
    }, [
        handleChange
    ]);
    // We could have created preset outside PromptEditor component,
    //  but currently placeholder prop ComposableEditor is not working.
    // We have to pass placeholder to placeholder plugin.
    // That's why using usePreset, who memoize preset.
    const { preset: preset, editorApi: editorApi } = (0, $5Xe3v.usePreset)(()=>(0, $eqXnF.createAIPromptPreset)({
            ...options,
            placeholder: {
                placeholder: editorProps.placeholder
            },
            onSave: onSave,
            enableLinks: enableLinks
        }), [
        options,
        editorProps.placeholder
    ]);
    const editorViewRef = (0, $5uXOq.useRef)(null);
    const onEditorReady = (0, $5uXOq.useCallback)((editorActions)=>{
        if (setClearHandler) setClearHandler(()=>editorActions.clear());
        const editorView = editorActions._privateGetEditorView();
        if (editorView) {
            editorViewRef.current = editorView;
            if (!editorActions.isDocumentEmpty()) editorView.dispatch(editorView.state.tr.setSelection(new (0, $gZGBX.AllSelection)(editorView.state.doc)));
        }
    }, [
        setClearHandler
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setFocusHandlers) /**
			 * We need to expose clear function through ref because
			 *  changing defaultValue does not clear editor.
			 */ setFocusHandlers(editorApi?.core?.actions.blur, editorApi?.core?.actions.focus);
    }, [
        editorApi,
        setFocusHandlers
    ]);
    // Skip any toolbars that displays in the editor, like Link Picker toolbar
    // Yes, it's ugly, but it's easier way, because we can't have access to the PromptEditor
    // floating toolbar.
    const stopPropagationForFloatingToolbar = (0, $5uXOq.useCallback)((event)=>{
        const eventFloatingToolbar = event.target instanceof HTMLElement ? event.target.closest('[data-testid="editor-floating-toolbar"]') : null;
        // Check that floating toolbar is a child of the current target,
        // i.e. it's a child of current the editor.
        if (eventFloatingToolbar && event.currentTarget.contains(eventFloatingToolbar)) event.stopPropagation();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        onKeyDown: stopPropagationForFloatingToolbar,
        onKeyUp: stopPropagationForFloatingToolbar,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kjU5q.ComposableEditor), {
                    mentionProvider: options.mentionProvider,
                    appearance: appearance,
                    minHeight: 20,
                    maxHeight: 200,
                    preset: preset,
                    assistiveLabel: ariaLabel ?? formatMessage((0, $9ao8a.aiMessages).promptbuilderAriaLabel),
                    shouldFocus: editorProps.autoFocus ?? true,
                    defaultValue: defaultValue,
                    onChange: handleChange,
                    // We will remove use of onEditorReady when editorApi provides a matching "clear()" action.
                    onEditorReady: onEditorReady
                }),
                (type === 'user-input' || type === 'interrogate') && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        options.enableLinks && options.linkPicker && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwKDG.LinkPickerButton), {
                            editorApi: editorApi,
                            promptType: type
                        }),
                        options.mentionProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $crtQ3.MentionButton), {
                            editorApi: editorApi,
                            promptType: type
                        })
                    ]
                })
            ]
        })
    }));
};
function $9d86ac563656b71b$export$df4eed2eacb29ddb(options) {
    return (props)=>{
        const editorProps = {
            editorProps: props,
            options: options
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ankW9.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($9d86ac563656b71b$var$EditorWrapper, {
                ...editorProps
            })
        });
    };
}

});
parcelRegister("9ao8a", function(module, exports) {

$parcel$export(module.exports, "aiMessages", () => $d9df7a0b72d8bfa3$export$480e55f805d7990f);

var $7VHMR = parcelRequire("7VHMR");
const $d9df7a0b72d8bfa3$export$480e55f805d7990f = (0, $7VHMR.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: 'fabric.editor.ai.eventHub.fallbackSuggestedTitle',
        defaultMessage: 'Page title',
        description: 'A fallback suggested title for the suggest title prompt'
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: 'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix',
        defaultMessage: 'Page',
        description: 'A fallback suggested title prefix for the suggest title prompt'
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: 'fabric.editor.ai.toolbar.titleText',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Title for Atlassian Intelligence button in editor selection floating toolbar'
    },
    improveWritingToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.improveWriting.title',
        defaultMessage: 'Improve writing',
        description: 'Title for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.improveWriting.tooltip',
        defaultMessage: 'Tell Atlassian Intelligence to improve the writing of your selection',
        description: 'Tooltip text for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    askAIToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.askAI.title',
        defaultMessage: 'Ask AI',
        description: 'Title for an option to use Atlassian Intellgience'
    },
    askAIToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.tryAI.tooltip',
        defaultMessage: 'Open Atlassian Intelligence',
        description: 'Tooltip text for an option to use Atlassian Intellgience'
    },
    tryAIToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.tryAI.title',
        defaultMessage: 'Try AI',
        description: 'Title for an option to use Atlassian Intellgience'
    },
    tryAIToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.tryAI.tooltip',
        defaultMessage: 'Open Atlassian Intelligence',
        description: 'Tooltip text for an option to use Atlassian Intellgience'
    },
    simplifiedAIToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.simplifiedAI.title',
        defaultMessage: 'AI',
        description: 'Title for Atlassian Intelligence button in editor selection floating toolbar'
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: 'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription',
        defaultMessage: `Generates content to be inserted into the update`,
        description: 'Description for AI Generate content prompt'
    },
    atlasSummarizePageConfigItemDescription: {
        id: 'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription',
        defaultMessage: `Summarizes the content of the update`,
        description: 'Description for AI Summarise content prompt'
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: 'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle',
        defaultMessage: 'Change tone',
        description: 'Title for Atlassian Intelligence "Change Tone" dropdown in editor selection floating toolbar'
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: 'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle',
        defaultMessage: 'Rewrite',
        description: 'Title for Atlassian Intelligence "Rewrite" dropdown in editor selection floating toolbar'
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: 'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle',
        defaultMessage: 'Translate',
        description: 'Title for Atlassian Intelligence "Translate" dropdown in editor selection floating toolbar'
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: 'fabric.editor.ai.ai-panels.actionItemsPageTitle',
        defaultMessage: `Action items panel (Beta)`,
        description: 'Title for AI action items panel'
    },
    actionItemsPageDescription: {
        id: 'fabric.editor.ai.ai-panels.actionItemsPageDescription',
        defaultMessage: `Use Atlassian Intelligence to find action items and display in a panel`,
        description: 'Description for AI action items panel'
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: 'fabric.editor.ai.ai-panels.summarizePageTitle',
        defaultMessage: `Page summary panel (Beta)`,
        description: 'Title for AI summary panel'
    },
    summarisePageDescription: {
        id: 'fabric.editor.ai.ai-panels.summarizePageDescription',
        defaultMessage: `Use Atlassian Intelligence to summarize this page and display in a panel`,
        description: 'Description for AI summary panel'
    },
    // Agent messages
    agentsDropdownTitle: {
        id: 'rovo.agents.dropdown.title',
        defaultMessage: 'Agents',
        description: 'Title for the agents dropdown in the editor toolbar'
    },
    agentsViewAgentsLabel: {
        id: 'rovo.agents.dropdown.viewAgents.label',
        defaultMessage: 'View all agents',
        description: 'Label for the dropdown option that allows a user to View all available Agents'
    },
    // Error messages
    unhandledErrorMessage: {
        id: 'fabric.editor.ai.experience-application.unhandledErrorMessage',
        defaultMessage: "We're having trouble. Close the dialog and try again.",
        description: 'Message to users that displays when an unexpected error happens'
    },
    markdownErrorMessage: {
        id: 'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage',
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again.",
        description: 'Message to users that displays when an error occurs while generating a preview.'
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: 'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel',
        defaultMessage: 'Ask Atlassian Intelligence',
        description: 'Aria label for prompt builder form'
    },
    promptBuilderFromButton: {
        id: 'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit',
        defaultMessage: 'Generate',
        description: 'Label for the Submit button in the command palette'
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: 'fabric.editor.ai.ai-smart-button.context.reference',
        defaultMessage: 'Selected content',
        description: 'When there is selection, show the selected content in the AI dynamic surface panel'
    }
});

});

parcelRegister("20Kbb", function(module, exports) {

$parcel$export(module.exports, "isParagraph", () => $4198c3b63e236a69$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $4198c3b63e236a69$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $4198c3b63e236a69$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "SelectedState", () => $4198c3b63e236a69$export$a6212ae0c82963af);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $4198c3b63e236a69$export$5125f50e751e84db);
$parcel$export(module.exports, "isSupportedInParent", () => $4198c3b63e236a69$export$b6e38334b1fb4d1b);
$parcel$export(module.exports, "isMediaNode", () => $4198c3b63e236a69$export$d6ca4605aefeca32);
$parcel$export(module.exports, "isNodeBeforeMediaNode", () => $4198c3b63e236a69$export$cfaa7840b0c93780);
$parcel$export(module.exports, "toJSON", () => $4198c3b63e236a69$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $4198c3b63e236a69$export$3a858d3babd60825);

var $hYNZx = parcelRequire("hYNZx");

var $5r0mK = parcelRequire("5r0mK");
const $4198c3b63e236a69$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $4198c3b63e236a69$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $4198c3b63e236a69$export$996213f7c272fc6f = (nodes)=>nodes.every($4198c3b63e236a69$export$4c39e41e39b3c449);
const $4198c3b63e236a69$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $4198c3b63e236a69$export$d7ae8c533ae18832 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $4198c3b63e236a69$export$1879817ac5c922b7 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.nodes.text);
const $4198c3b63e236a69$export$5dfeda3a9e6fe056 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.marks.link);
var $4198c3b63e236a69$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $4198c3b63e236a69$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $4198c3b63e236a69$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $4198c3b63e236a69$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $4198c3b63e236a69$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $5r0mK.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $4198c3b63e236a69$var$transformer = new (0, $hYNZx.JSONTransformer)();
function $4198c3b63e236a69$export$54fd2c36b5cc6731(node) {
    return $4198c3b63e236a69$var$transformer.encode(node);
}
function $4198c3b63e236a69$export$3a858d3babd60825(node) {
    return $4198c3b63e236a69$var$transformer.encodeNode(node);
}

});

parcelRegister("kjU5q", function(module, exports) {

$parcel$export(module.exports, "ComposableEditor", () => $95f392e3544e55e0$export$36a7c46ebbddbc5d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7rHtO = parcelRequire("7rHtO");

var $1QYAr = parcelRequire("1QYAr");
function $95f392e3544e55e0$export$36a7c46ebbddbc5d(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $5uXOq.useMemo)(()=>(0, $7rHtO.default)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QYAr.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
}

});
parcelRegister("7rHtO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8b0891f98bd31d$export$2e2bcd8739ae039);

var $6ssPr = parcelRequire("6ssPr");

var $9YhuC = parcelRequire("9YhuC");

var $kuVsL = parcelRequire("kuVsL");
function $4e8b0891f98bd31d$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
            return 0, $kuVsL.FullPageEditor;
        case 'chromeless':
            return 0, $6ssPr.default;
        case 'comment':
            return 0, $9YhuC.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}

});
parcelRegister("6ssPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f2e2c18fdb60a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $awTmI = parcelRequire("awTmI");


var $jZLtJ = parcelRequire("jZLtJ");

var $iK9VQ = parcelRequire("iK9VQ");

var $7s5ol = parcelRequire("7s5ol");
const $74f2e2c18fdb60a5$var$chromelessEditorStyles = /*#__PURE__*/ (0, $f8Sb3.css)("line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4038285048829feb$export$b2380b18b089518f), "max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}");
const $74f2e2c18fdb60a5$var$ContentArea = (0, $jZLtJ.createEditorContentStyle)();
$74f2e2c18fdb60a5$var$ContentArea.displayName = 'ContentArea';
class $74f2e2c18fdb60a5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.displayName = 'ChromelessEditorAppearance';
    }
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($74f2e2c18fdb60a5$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args), this.appearance = 'chromeless', this.containerElement = null, this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(this.props.editorAPI, [
                'editorViewMode'
            ]);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7s5ol.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: [
                    $74f2e2c18fdb60a5$var$chromelessEditorStyles,
                    maxHeight && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $f8Sb3.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        maxHeight: `${maxHeight}px`
                    }),
                    /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $f8Sb3.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        minHeight: `${minHeight}px`
                    })
                ],
                "data-testid": "chromeless-editor",
                ref: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($74f2e2c18fdb60a5$var$ContentArea, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewModeState?.mode
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iK9VQ.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
function $74f2e2c18fdb60a5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const { maxContentSizeState: maxContentSizeState } = (0, $awTmI.useSharedPluginState)(editorAPI, [
        'maxContentSize'
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, renderChrome({
        maxContentSize: maxContentSizeState
    }));
}

});
parcelRegister("awTmI", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginState", () => $c96ea81c1b46425f$export$a4c4fd90e2b72baa);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $c96ea81c1b46425f$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $c96ea81c1b46425f$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>plugins, []);
}
function $c96ea81c1b46425f$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $c96ea81c1b46425f$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $5uXOq.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $c96ea81c1b46425f$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $c96ea81c1b46425f$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $5uXOq.useState)($c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $5uXOq.useRef)({});
    const mounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}

});

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $4038285048829feb$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #2C3E5D)"};
  }
`;

parcelRegister("jZLtJ", function(module, exports) {

$parcel$export(module.exports, "createEditorContentStyle", () => $6a8a55d341510e42$export$91e7c20fa6d6a4b5);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
                                                                                                                                                                                                                                                                                   * @jsxRuntime classic
                                                                                                                                                                                                                                                                                   * @jsx jsx
                                                                                                                                                                                                                                                                                   */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
var $g0wej = parcelRequire("g0wej");

var $gE8f9 = parcelRequire("gE8f9");

var $3I3CN = parcelRequire("3I3CN");

var $kin1Z = parcelRequire("kin1Z");
var $3tpiv = parcelRequire("3tpiv");

var $fRmCC = parcelRequire("fRmCC");

var $aABH4 = parcelRequire("aABH4");

var $eAVGd = parcelRequire("eAVGd");

var $5Lu5s = parcelRequire("5Lu5s");
var $1xqpZ = parcelRequire("1xqpZ");
var $cx4Bg = parcelRequire("cx4Bg");
var $cYeQP = parcelRequire("cYeQP");
var $7Acon = parcelRequire("7Acon");
var $4E5wI = parcelRequire("4E5wI");
var $9zgV3 = parcelRequire("9zgV3");
var $cr1aY = parcelRequire("cr1aY");
var $iJOES = parcelRequire("iJOES");
var $bYYy3 = parcelRequire("bYYy3");
var $5fBxY = parcelRequire("5fBxY");
var $aN7BF = parcelRequire("aN7BF");
var $jlYLw = parcelRequire("jlYLw");
var $jQRg9 = parcelRequire("jQRg9");
var $4jyW9 = parcelRequire("4jyW9");
var $hVv9L = parcelRequire("hVv9L");
var $bv4Ps = parcelRequire("bv4Ps");
var $aSoqv = parcelRequire("aSoqv");
var $kRXi9 = parcelRequire("kRXi9");
var $1bQ0V = parcelRequire("1bQ0V");
var $jRk4M = parcelRequire("jRk4M");
var $ahG4O = parcelRequire("ahG4O");
var $fwxzS = parcelRequire("fwxzS");
parcelRequire("6jI8m");
var $2uCrC = parcelRequire("2uCrC");
parcelRequire("9wwua");
var $RhFwz = parcelRequire("RhFwz");
parcelRequire("3p7sF");
var $6pErt = parcelRequire("6pErt");
parcelRequire("eXo2J");
var $2yMev = parcelRequire("2yMev");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $hxoiH = parcelRequire("hxoiH");

var $fz5RS = parcelRequire("fz5RS");

var $9O4yy = parcelRequire("9O4yy");

var $cEh6Q = parcelRequire("cEh6Q");

var $dv67m = parcelRequire("dv67m");

var $cBEjw = parcelRequire("cBEjw");

var $hucfL = parcelRequire("hucfL");

var $l5gcr = parcelRequire("l5gcr");

var $6UEu0 = parcelRequire("6UEu0");

var $b3RpZ = parcelRequire("b3RpZ");

var $aUTD3 = parcelRequire("aUTD3");

var $5L329 = parcelRequire("5L329");
function $6a8a55d341510e42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6a8a55d341510e42$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $aN7BF.linkSharedStyle)(), ";}");
const $6a8a55d341510e42$var$ruleStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $bv4Ps.ruleSharedStyles)(), ";hr{cursor:pointer;padding:var(--ds-space-050, 4px) 0;margin:var(--ds-space-300, 24px) 0;background-clip:content-box;&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{outline:none;background-color:", `var(--ds-border-selected, ${(0, $iHYdz.akEditorSelectedBorderColor)})`, ";}}}");
const $6a8a55d341510e42$var$vanillaMentionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $6a8a55d341510e42$var$vanillaSelectionStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".danger{.editor-mention-primitive{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";}}.", (0, $iHYdz.akEditorSelectedNodeClassName), ">.editor-mention-primitive,.", (0, $iHYdz.akEditorSelectedNodeClassName), ">.editor-mention-primitive.mention-self,.", (0, $iHYdz.akEditorSelectedNodeClassName), ">.editor-mention-primitive.mention-restricted{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}");
const $6a8a55d341510e42$var$mentionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER, "{&.", (0, $iHYdz.akEditorSelectedNodeClassName), " [data-mention-id]>span{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}}.danger{.", (0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>span>span{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";}.", (0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER, ">span>span>span{background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);}}");
const $6a8a55d341510e42$var$listsStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{li{position:relative;>p:not(:first-child){margin:var(--ds-space-050, 4px) 0 0 0;}>style:first-child+p{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $gE8f9.browser).safari ? (0, $cYeQP.codeBlockInListSafariFix) : '', ";}}");
const $6a8a55d341510e42$var$reactEmojiStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_NODE, "{cursor:pointer;&.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, ">span{display:flex;}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket,
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}");
const $6a8a55d341510e42$var$emojiStyles = /*#__PURE__*/ (0, $f8Sb3.css)("[data-prosemirror-node-view-type='vanilla']{.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;}.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, "{background:no-repeat transparent;display:inline-block;height:", (0, $kin1Z.defaultEmojiHeight), "px;max-height:", (0, $kin1Z.defaultEmojiHeight), "px;cursor:pointer;vertical-align:middle;user-select:all;}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket,
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}");
const $6a8a55d341510e42$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $6a8a55d341510e42$var$placeholderOverflowStyles = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $6a8a55d341510e42$var$placeholderWrapStyles = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};
const $6a8a55d341510e42$var$firstBlockNodeStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{>.", (0, $aABH4.PanelSharedCssClassName).prefix, ",>.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, $cr1aY.expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-of-type{margin-top:0;}}");
const $6a8a55d341510e42$var$firstBlockNodeStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{>.", (0, $aABH4.PanelSharedCssClassName).prefix, ",>.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, $cr1aY.expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-child,>.ProseMirror-widget:first-child+hr{margin-top:0;}}");
const $6a8a55d341510e42$export$42a58e6dfeaffebe = ()=>{
    if ((0, $VSDnB.fg)('platform_editor_element_dnd_nested_fix_patch_6')) return $6a8a55d341510e42$var$firstBlockNodeStylesNew;
    return $6a8a55d341510e42$var$firstBlockNodeStyles;
};
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $6a8a55d341510e42$var$akEditorBreakpointForSmallDevice = `1266px`;
var $6a8a55d341510e42$var$_ref = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};
var $6a8a55d341510e42$var$_ref2 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $6a8a55d341510e42$var$_ref3 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $6a8a55d341510e42$var$_ref4 = {
    name: "u7i8rn",
    styles: ".ProseMirror[contenteditable='false'] .taskItemView-content-wrap{pointer-events:none;opacity:0.7;}"
};
const $6a8a55d341510e42$var$contentStyles = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("--ak-editor--default-gutter-padding:", (0, $iHYdz.akEditorGutterPadding), "px;--ak-editor--large-gutter-padding:", (0, $iHYdz.akEditorGutterPaddingDynamic)(), "px;--ak-editor--default-layout-width:", (0, $iHYdz.akEditorDefaultLayoutWidth), "px;--ak-editor--full-width-layout-width:", (0, $iHYdz.akEditorFullWidthLayoutWidth), "px;--ak-editor--line-length:min(\n\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\tvar(--ak-editor--default-layout-width)\n\t);--ak-editor--breakout-wide-layout-width:", (0, $iHYdz.akEditorCalculatedWideLayoutWidthSmallViewport), "px;--ak-editor--breakout-full-page-guttering-padding:calc(\n\t\tvar(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)\n\t);.fabric-editor--full-width-mode{--ak-editor--line-length:min(\n\t\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\t\tvar(--ak-editor--full-width-layout-width)\n\t\t);}.ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding));}.ProseMirror>div[data-prosemirror-node-block] [data-prosemirror-node-block]{--ak-editor-max-container-width:100%;}@container editor-area (width >= ", $6a8a55d341510e42$var$akEditorBreakpointForSmallDevice, "){.ProseMirror{--ak-editor--breakout-wide-layout-width:", (0, $iHYdz.akEditorCalculatedWideLayoutWidth), "px;}}.ProseMirror{outline:none;font-size:", (0, $iHYdz.editorFontSize)({
        theme: props.theme
    }), "px;", (0, $fwxzS.whitespaceSharedStyles), ";", (0, $4jyW9.paragraphSharedStyles)(props.typographyTheme), ";", (0, $jlYLw.listsSharedStyles), ";", (0, $5fBxY.indentationSharedStyles), ";", (0, $aSoqv.shadowSharedStyle), ";", (0, $fz5RS.InlineNodeViewSharedStyles), ";}", (0, $VSDnB.fg)('editor_request_to_edit_task') ? null : $6a8a55d341510e42$var$_ref4, " .ProseMirror-hideselection *::selection{background:transparent;}.ProseMirror-hideselection *::-moz-selection{background:transparent;}", (0, $VSDnB.fg)('platform_editor_hide_cursor_when_pm_hideselection') ? $6a8a55d341510e42$var$_ref3 : null, (0, $gmhCD.editorExperiment)('platform_editor_advanced_code_blocks', true) ? $6a8a55d341510e42$var$_ref2 : null, " .ProseMirror-selectednode{outline:none;}.ProseMirror-selectednode:empty{outline:2px solid var(--ds-border-focused, #8cf);}.ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}", (0, $2yMev.placeholderTextStyles), " ", $6a8a55d341510e42$export$d3bdc0d52bb6c2c8, " ", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $6a8a55d341510e42$var$placeholderOverflowStyles : null, " ", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_quick_insert_placeholder') ? $6a8a55d341510e42$var$placeholderWrapStyles : null, " ", (0, $cEh6Q.codeBlockStyles)(), " ", (0, $2uCrC.blocktypeStyles)(props.typographyTheme), " ", (0, $7Acon.codeMarkSharedStyles)(), " ", (0, $jRk4M.textColorStyles), " ", (0, $1xqpZ.backgroundColorStyles)(), " ", $6a8a55d341510e42$var$listsStyles, " ", $6a8a55d341510e42$var$ruleStyles(), " ", (0, $6UEu0.mediaStyles)(), " ", (0, $l5gcr.layoutStyles)(props.viewMode), " ", (0, $3I3CN.telepointerStyle), " ", (0, $eAVGd.gapCursorStyles), ";", (0, $b3RpZ.panelStyles)(), " ", $6a8a55d341510e42$var$mentionsStyles, " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $6a8a55d341510e42$var$vanillaMentionsStyles, " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $6a8a55d341510e42$var$vanillaSelectionStyles, " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) ? $6a8a55d341510e42$var$emojiStyles : $6a8a55d341510e42$var$reactEmojiStyles, " ", $6a8a55d341510e42$var$emojiStyles, " ", (0, $1bQ0V.tasksAndDecisionsStyles), " ", (0, $bYYy3.gridStyles), " ", $6a8a55d341510e42$export$4ea5976125a01ffa, " ", (0, $cx4Bg.blockMarksSharedStyles), " ", (0, $4E5wI.dateSharedStyle), " ", (0, $hucfL.extensionStyles), " ", (0, $cBEjw.expandStyles)(), " ", (0, $RhFwz.findReplaceStyles), " ", (0, $6pErt.textHighlightStyle), " ", (0, $5L329.taskDecisionStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $5L329.vanillaTaskItemStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $5L329.vanillaTaskDecisionStyles), (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $5L329.vanillaTaskDecisionIconWithVisualRefresh), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $5L329.vanillaTaskDecisionIconWithoutVisualRefresh), " ", (0, $aUTD3.statusStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $aUTD3.vanillaStatusStyles) : null, " ", (0, $5Lu5s.annotationSharedStyles)(), " ", (0, $kRXi9.smartCardStyles)(), " ", (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? (0, $iJOES.getSmartCardSharedStyles)() : (0, $iJOES.smartCardSharedStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $dv67m.dateVanillaStyles) : null, " ", (0, $dv67m.dateStyles), " ", (0, $9zgV3.embedCardStyles)(), " ", (0, $ahG4O.unsupportedStyles), " ", (0, $hVv9L.resizerStyles), " ", (0, $9O4yy.aiPanelStyles)(props.colorMode), " ", $6a8a55d341510e42$export$42a58e6dfeaffebe(), " .panelView-content-wrap{box-sizing:border-box;}.mediaGroupView-content-wrap ul{padding:0;}div.fabric-editor-block-mark[class^='fabric-editor-align']{clear:none!important;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block,.extension-container,.multiBodiedExtension--container{max-width:100%;}}}.pm-table-header-content-wrap :not(.fabric-editor-alignment),.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark,.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}.hyperlink-floating-toolbar,.", (0, $jQRg9.ClassNames).FLOATING_TOOLBAR_COMPONENT, "{padding:0;}", !(0, $VSDnB.fg)('platform-visual-refresh-icons') ? $6a8a55d341510e42$var$_ref : null, ";");
const $6a8a55d341510e42$export$91e7c20fa6d6a4b5 = (styles)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { className: className, children: children, featureFlags: featureFlags } = props;
        const theme = (0, $g0wej.u)();
        const { colorMode: colorMode, typography: typography } = (0, $hxoiH.default)();
        const memoizedStyle = (0, $5uXOq.useMemo)(()=>$6a8a55d341510e42$var$contentStyles({
                theme: theme,
                colorMode: colorMode,
                featureFlags: featureFlags,
                viewMode: props.viewMode,
                typographyTheme: typography
            }), [
            theme,
            colorMode,
            featureFlags,
            props.viewMode,
            typography
        ]);
        if (props.isScrollable) return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ],
            "data-editor-scroll-container": "true"
        }, children);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ]
        }, children);
    });
};
var $6a8a55d341510e42$export$2e2bcd8739ae039 = $6a8a55d341510e42$export$91e7c20fa6d6a4b5();

});
parcelRegister("3I3CN", function(module, exports) {

$parcel$export(module.exports, "PROVIDER_ERROR_CODE", () => $b29cd5b2ebd43bff$export$54cb529986e2487b);
$parcel$export(module.exports, "DisconnectReason", () => $b29cd5b2ebd43bff$export$258d16488300d83f);
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "telepointerStyle", () => $b29cd5b2ebd43bff$export$c94087d6ea5127ad);
$parcel$export(module.exports, "isDirtyTransaction", () => $b29cd5b2ebd43bff$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $b29cd5b2ebd43bff$export$f25182515d14d793);

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $cSyk1 = parcelRequire("cSyk1");
var $b29cd5b2ebd43bff$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $b29cd5b2ebd43bff$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $b29cd5b2ebd43bff$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $cSyk1.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $b29cd5b2ebd43bff$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $iHYdz.participantColors).map((participantColor, index)=>$b29cd5b2ebd43bff$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge::after{content:attr(data-initial);position:absolute;display:block;top:-14px;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(9), ";padding:var(--ds-space-025, 2px);color:var(--ds-text-inverse, #FFFFFF);left:0px;border-radius:2px 2px 2px 0;line-height:initial;}&.", $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $b29cd5b2ebd43bff$var$tintKey = 'collab:isDirtyTransaction';
const $b29cd5b2ebd43bff$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($b29cd5b2ebd43bff$var$tintKey));
};
const $b29cd5b2ebd43bff$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($b29cd5b2ebd43bff$var$tintKey, true);
};

});

parcelRegister("3tpiv", function(module, exports) {

$parcel$export(module.exports, "EmojiSharedCssClassName", () => $0dd4329718798e0e$export$ee47248f9a998789);

const $0dd4329718798e0e$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $63856011855bb785$export$b06c4aab1d012063),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $63856011855bb785$export$1c10634420a08d8a),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $63856011855bb785$export$da61cef1c8919f7c),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $63856011855bb785$export$c7187bbd1a7a9244)
};

});
const $63856011855bb785$export$8633a0edef8e95dd = 'emoji-common-selected';
const $63856011855bb785$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $63856011855bb785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $63856011855bb785$export$b06c4aab1d012063 = 'emoji-common-node';
const $63856011855bb785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $63856011855bb785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $63856011855bb785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $63856011855bb785$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $63856011855bb785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $63856011855bb785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("fRmCC", function(module, exports) {

$parcel$export(module.exports, "MentionSharedCssClassName", () => $4843d72ed8c773f1$export$e5f60e08987c4e73);
const $4843d72ed8c773f1$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};

});

parcelRegister("aABH4", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $c61dedcc3b2bdafe$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $c61dedcc3b2bdafe$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $c61dedcc3b2bdafe$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStylesWithoutPrefix", () => $c61dedcc3b2bdafe$export$d707b378cb63679a);
$parcel$export(module.exports, "panelSharedStyles", () => $c61dedcc3b2bdafe$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bFtEE = parcelRequire("bFtEE");

var $hAs1r = parcelRequire("hAs1r");

var $iHYdz = parcelRequire("iHYdz");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");
const $c61dedcc3b2bdafe$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $c61dedcc3b2bdafe$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $c61dedcc3b2bdafe$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $iHYdz.akEditorCustomIconSize)) / 2;
const $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment = $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment - 1;
function $c61dedcc3b2bdafe$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$c61dedcc3b2bdafe$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $c61dedcc3b2bdafe$var$prefix = 'ak-editor-panel';
const $c61dedcc3b2bdafe$export$6dd740b6c888e050 = {
    prefix: $c61dedcc3b2bdafe$var$prefix,
    content: `${$c61dedcc3b2bdafe$var$prefix}__content`,
    icon: `${$c61dedcc3b2bdafe$var$prefix}__icon`,
    noIcon: `${$c61dedcc3b2bdafe$var$prefix}__no-icon`
};
const $c61dedcc3b2bdafe$export$b0ee08fae091706a = {
    infoPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).INFO}]`,
    notePanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).NOTE}]`,
    warningPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).WARNING}]`,
    errorPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).ERROR}]`,
    successPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $c61dedcc3b2bdafe$var$getIconStyles = (panelType)=>{
    if ((0, $VSDnB.fg)('platform_editor_lcm_nested_panel_icon_fix')) return `
			.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
				color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};
			}
		`;
    else return `
			.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.icon} {
				color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};
			}
		`;
};
const $c61dedcc3b2bdafe$export$8099afddf1b1be78 = (panelType)=>$c61dedcc3b2bdafe$var$lightPanelColors[panelType] || 'none';
const $c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc = (panelType)=>(0, $hAs1r.hexToEditorBackgroundPaletteColor)($c61dedcc3b2bdafe$var$lightPanelColors[panelType]) || 'none';
const $c61dedcc3b2bdafe$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $c61dedcc3b2bdafe$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).INFO), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $63856011855bb785$export$1c10634420a08d8a), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $63856011855bb785$export$da61cef1c8919f7c), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}&[data-panel-type='", (0, $bFtEE.PanelType).INFO, "']{", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).INFO), ";}&[data-panel-type='", (0, $bFtEE.PanelType).NOTE, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).NOTE), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).NOTE), ";}&[data-panel-type='", (0, $bFtEE.PanelType).TIP, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).TIP), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).TIP), ";}&[data-panel-type='", (0, $bFtEE.PanelType).WARNING, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).WARNING), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).WARNING), ";}&[data-panel-type='", (0, $bFtEE.PanelType).ERROR, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).ERROR), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).ERROR), ";}&[data-panel-type='", (0, $bFtEE.PanelType).SUCCESS, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).SUCCESS), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).SUCCESS), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $c61dedcc3b2bdafe$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.prefix}`]: $c61dedcc3b2bdafe$export$d707b378cb63679a()
    });

});

parcelRegister("eAVGd", function(module, exports) {

$parcel$export(module.exports, "hideCaretModifier", () => $618a810c9ab6b0dd$export$8adc5edbc4a22166);
$parcel$export(module.exports, "gapCursorStyles", () => $618a810c9ab6b0dd$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $618a810c9ab6b0dd$var$gapCursorBlink = (0, $f8Sb3.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $618a810c9ab6b0dd$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $618a810c9ab6b0dd$var$gapCursor = '.ProseMirror-gapcursor';
const $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $618a810c9ab6b0dd$var$wrapLeft = '[layout="wrap-left"]';
const $618a810c9ab6b0dd$var$wrapRight = '[layout="wrap-right"]';
const $618a810c9ab6b0dd$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{&.", $618a810c9ab6b0dd$export$8adc5edbc4a22166, "{caret-color:transparent;}", $618a810c9ab6b0dd$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $618a810c9ab6b0dd$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $618a810c9ab6b0dd$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $618a810c9ab6b0dd$var$gapCursor, "{display:block;border-color:transparent;}}", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span ", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "{clear:none;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "{float:left;}", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+*{margin-top:0;}");

});

parcelRegister("9zgV3", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $4909a7644b753f01$export$5a1f57c6600b90f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $4909a7644b753f01$export$5a1f57c6600b90f1 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout^='wrap-']": {
                maxWidth: '100%',
                position: 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-left']": {
                float: 'left'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right']": {
                float: 'right'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
                clear: 'both'
            }
        }
    });
const $4909a7644b753f01$export$9a900b6b0c1fa45 = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0 ${"var(--ds-space-150, 12px)"}`
});

});

parcelRegister("cr1aY", function(module, exports) {

$parcel$export(module.exports, "expandIconContainerStyle", () => $93aa9de9747de328$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $93aa9de9747de328$export$6ba39aa0ead007b7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $93aa9de9747de328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93aa9de9747de328$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $93aa9de9747de328$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $93aa9de9747de328$var$prefix = 'ak-editor-expand';
const $93aa9de9747de328$export$6ba39aa0ead007b7 = {
    prefix: $93aa9de9747de328$var$prefix,
    expanded: `${$93aa9de9747de328$var$prefix}__expanded`,
    titleContainer: `${$93aa9de9747de328$var$prefix}__title-container`,
    inputContainer: `${$93aa9de9747de328$var$prefix}__input-container`,
    iconContainer: `${$93aa9de9747de328$var$prefix}__icon-container`,
    icon: `${$93aa9de9747de328$var$prefix}__icon`,
    titleInput: `${$93aa9de9747de328$var$prefix}__title-input`,
    content: `${$93aa9de9747de328$var$prefix}__content`,
    type: (type)=>`${$93aa9de9747de328$var$prefix}__type-${type}`
};

});

parcelRegister("bYYy3", function(module, exports) {

$parcel$export(module.exports, "GRID_GUTTER", () => $ef9988a8733147ec$export$108900bf32350a8b);
$parcel$export(module.exports, "gridStyles", () => $ef9988a8733147ec$export$61d0da483c72dda3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $ef9988a8733147ec$export$108900bf32350a8b = 12;
const $ef9988a8733147ec$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + ${$ef9988a8733147ec$export$108900bf32350a8b * 2}px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorGridLineZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("aN7BF", function(module, exports) {

$parcel$export(module.exports, "linkSharedStyle", () => $536782e4b54ab634$export$d835732bf782c240);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $VSDnB = parcelRequire("VSDnB");
function $536782e4b54ab634$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $536782e4b54ab634$var$_ref = {
    name: "bp6sai",
    styles: "a.blockLink{display:block;}"
};
var $536782e4b54ab634$var$_ref2 = {
    name: "13hvbxv",
    styles: "a.blockLink{display:block;}a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $536782e4b54ab634$export$d835732bf782c240 = ()=>{
    return (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $536782e4b54ab634$var$_ref2 : $536782e4b54ab634$var$_ref;
};

});

parcelRegister("jQRg9", function(module, exports) {

$parcel$export(module.exports, "ClassNames", () => $efb57f1d3580a030$export$9b9c0f9d9f3552b8);
const $efb57f1d3580a030$var$prefix = 'pm-alt-text';
const $efb57f1d3580a030$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$efb57f1d3580a030$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};

});

parcelRegister("hVv9L", function(module, exports) {

$parcel$export(module.exports, "resizerItemClassName", () => $fb7b1e8a090d8802$export$a06160db3520e5a2);
$parcel$export(module.exports, "resizerHoverZoneClassName", () => $fb7b1e8a090d8802$export$c42cdcfd48254bda);
$parcel$export(module.exports, "resizerExtendedZone", () => $fb7b1e8a090d8802$export$10b67c6ff1748bd);
$parcel$export(module.exports, "resizerHandleClassName", () => $fb7b1e8a090d8802$export$6afc20f0ff6d041);
$parcel$export(module.exports, "resizerHandleTrackClassName", () => $fb7b1e8a090d8802$export$a5792d7e2a486d41);
$parcel$export(module.exports, "resizerHandleThumbClassName", () => $fb7b1e8a090d8802$export$2201bc1aaee73f36);
$parcel$export(module.exports, "resizerDangerClassName", () => $fb7b1e8a090d8802$export$97a99610b6f0a178);
$parcel$export(module.exports, "handleWrapperClass", () => $fb7b1e8a090d8802$export$b123b2c8a2536d05);
$parcel$export(module.exports, "resizerHandleZIndex", () => $fb7b1e8a090d8802$export$3d867927ebf9bc1f);
$parcel$export(module.exports, "resizerStyles", () => $fb7b1e8a090d8802$export$ce55ec61aa49b942);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $fb7b1e8a090d8802$export$a06160db3520e5a2 = 'resizer-item';
const $fb7b1e8a090d8802$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $fb7b1e8a090d8802$export$10b67c6ff1748bd = 'resizer-is-extended';
const $fb7b1e8a090d8802$export$6afc20f0ff6d041 = 'resizer-handle';
const $fb7b1e8a090d8802$export$a5792d7e2a486d41 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-track`;
const $fb7b1e8a090d8802$export$2201bc1aaee73f36 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-thumb`;
const $fb7b1e8a090d8802$export$97a99610b6f0a178 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-danger`;
// akEditorSelectedNodeClassName from '@atlaskit/editor-shared-styles';
const $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $fb7b1e8a090d8802$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $fb7b1e8a090d8802$export$3d867927ebf9bc1f = 1;
const $fb7b1e8a090d8802$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $fb7b1e8a090d8802$export$a06160db3520e5a2, "{will-change:width;&:hover,&.display-handle{&>.", $fb7b1e8a090d8802$export$b123b2c8a2536d05, ">.", $fb7b1e8a090d8802$export$6afc20f0ff6d041, "{visibility:visible;opacity:1;}}&.is-resizing{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}&.", $fb7b1e8a090d8802$export$97a99610b6f0a178, "{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{transition:none;background:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}}}.", $fb7b1e8a090d8802$export$6afc20f0ff6d041, "{display:flex;visibility:hidden;opacity:0;flex-direction:column;justify-content:center;align-items:center;width:7px;transition:visibility 0.2s,opacity 0.2s;& div[role='presentation']{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:var(--ds-space-negative-200, -16px);white-space:normal;}&.left{align-items:flex-start;}&.right{align-items:flex-end;}&.small{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:43px;}}&.medium{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:64px;}}&.large{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:96px;}}&.clamped{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:clamp(43px, calc(100% - 32px), 96px);}}&.sticky{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}}&:hover{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}& .", $fb7b1e8a090d8802$export$a5792d7e2a486d41, "{visibility:visible;opacity:0.5;}}}.", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{content:' ';display:flex;width:3px;margin:0 var(--ds-space-025, 2px);height:64px;transition:background-color 0.2s;border-radius:6px;border:0;padding:0;z-index:2;outline:none;min-height:24px;background:var(--ds-border, #091E4224);&:hover{cursor:col-resize;}&:focus{background:var(--ds-border-selected, #0C66E4);&::after{content:'';position:absolute;top:var(--ds-space-negative-050, -4px);right:var(--ds-space-negative-050, -4px);bottom:var(--ds-space-negative-050, -4px);left:var(--ds-space-negative-050, -4px);border:2px solid var(--ds-border-focused, #388BFF);border-radius:inherit;z-index:-1;}}}.", $fb7b1e8a090d8802$export$a5792d7e2a486d41, "{visibility:hidden;position:absolute;width:7px;height:calc(100% - 40px);border-radius:4px;opacity:0;transition:background-color 0.2s,visibility 0.2s,opacity 0.2s;&.none{background:none;}&.shadow{background:var(--ds-background-selected, #E9F2FF);}&.full-height{background:var(--ds-background-selected, #E9F2FF);height:100%;min-height:36px;}}.", $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName, "{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}.ak-editor-no-interaction .", $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName, " .", $fb7b1e8a090d8802$export$6afc20f0ff6d041, ":not(:hover) .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border, #091E4224);}.", $fb7b1e8a090d8802$export$c42cdcfd48254bda, "{position:relative;display:inline-block;width:100%;&.", $fb7b1e8a090d8802$export$10b67c6ff1748bd, "{padding:0 var(--ds-space-150, 12px);left:var(--ds-space-negative-150, -12px);}}table .", $fb7b1e8a090d8802$export$c42cdcfd48254bda, ",table .", $fb7b1e8a090d8802$export$c42cdcfd48254bda, ".", $fb7b1e8a090d8802$export$10b67c6ff1748bd, "{padding:unset;left:unset;}");

});

parcelRegister("kRXi9", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $5eabaa6e34ebabc6$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $5eabaa6e34ebabc6$export$863ae87a9d233606);
$parcel$export(module.exports, "smartCardStyles", () => $5eabaa6e34ebabc6$export$b346a5d6d598424c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $iJOES = parcelRequire("iJOES");
const $5eabaa6e34ebabc6$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $5eabaa6e34ebabc6$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $5eabaa6e34ebabc6$export$b346a5d6d598424c = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $iJOES.SmartCardSharedCssClassName).INLINE_CARD_CONTAINER, "{max-width:calc(100% - 20px);vertical-align:top;word-break:break-all;", (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? `.card-with-comment {
          background: ${"var(--ds-background-accent-yellow-subtler, #F8E6A0)"};
          border-bottom: 2px solid ${"var(--ds-border-accent-yellow, #B38600)"};
          box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};
        }` : '', " .card{padding-left:var(--ds-space-025, 2px);padding-right:var(--ds-space-025, 2px);padding-top:0.5em;padding-bottom:0.5em;margin-bottom:-0.5em;.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a:focus{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}}", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? `[data-inlinecard-button-overlay='icon-wrapper-line-height'] span {
				line-height: 0;
			}` : '', " &.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{z-index:1;position:relative;}&.danger{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";z-index:2;}}}.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? 'text' : 'pointer', ";a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), " border-radius:var(--ds-border-radius-200, 8px);}&.danger{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, "!important;}}}.", (0, $iJOES.SmartCardSharedCssClassName).DATASOURCE_CONTAINER, ".", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{max-width:100%;display:flex;justify-content:center;.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{cursor:pointer;background-color:var(--ds-background-neutral-subtle, #00000000);border-radius:var(--ds-border-radius-200, 8px);border:1px solid var(--ds-border, #091E4224);overflow:hidden;}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), " input::selection{background-color:var(--ds-background-selected-hovered, #CCE0FF);}input::-moz-selection{background-color:var(--ds-background-selected-hovered, #CCE0FF);}}}&.danger{.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}}}.", (0, $iJOES.SmartCardSharedCssClassName).EMBED_CARD_CONTAINER, "{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:pointer;a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}&::after{transition:box-shadow 0s;}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div::after{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}&.danger{.media-card-frame::after{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, "!important;background:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}}}.", $5eabaa6e34ebabc6$export$863ae87a9d233606, "{padding:0;}");

});
parcelRegister("5yojI", function(module, exports) {

$parcel$export(module.exports, "getSelectionStyles", () => $e0952f45925e7685$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $e0952f45925e7685$export$a716852a0c5e54d5);

var $iHYdz = parcelRequire("iHYdz");

var $bzmFE = parcelRequire("bzmFE");
const $e0952f45925e7685$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$e0952f45925e7685$var$getSelectionStyle(selectionStyle)).concat($e0952f45925e7685$export$a716852a0c5e54d5).join('\n');
const $e0952f45925e7685$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $e0952f45925e7685$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $bzmFE.SelectionStyle).Border:
            return `
        border: ${0, $iHYdz.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $iHYdz.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $bzmFE.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $iHYdz.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $bzmFE.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $bzmFE.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $iHYdz.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("bzmFE", function(module, exports) {

$parcel$export(module.exports, "SelectionStyle", () => $2bcf46ee398650df$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $2bcf46ee398650df$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});



parcelRegister("ahG4O", function(module, exports) {

$parcel$export(module.exports, "UnsupportedSharedCssClassName", () => $bb6144152e7474e0$export$629043421dcc56e5);
$parcel$export(module.exports, "unsupportedStyles", () => $bb6144152e7474e0$export$637bcb89343f7ef4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
const $bb6144152e7474e0$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $bb6144152e7474e0$var$inlineUnsupportedSelector = `.${$bb6144152e7474e0$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`;
const $bb6144152e7474e0$var$blockUnsupportedSelector = `.${$bb6144152e7474e0$export$629043421dcc56e5.BLOCK_CONTAINER} > div`;
const $bb6144152e7474e0$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $f8Sb3.css)($bb6144152e7474e0$var$blockUnsupportedSelector, ",", $bb6144152e7474e0$var$inlineUnsupportedSelector, "{cursor:pointer;}.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$blockUnsupportedSelector, ",.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$inlineUnsupportedSelector, "{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Background,
    (0, $bzmFE.SelectionStyle).Border
]), ";}.danger{.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$blockUnsupportedSelector, ",.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$inlineUnsupportedSelector, "{border:", (0, $iHYdz.akEditorSelectedBorderSize), "px solid ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";}}");

});

parcelRegister("6jI8m", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => (parcelRequire("2uCrC")).blocktypeStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2uCrC = parcelRequire("2uCrC");

});
parcelRegister("2uCrC", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => $2b2214035a5c6632$export$610a2509037eaf6);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kRRtM = parcelRequire("kRRtM");
var $idytF = parcelRequire("idytF");

var $VSDnB = parcelRequire("VSDnB");
const $2b2214035a5c6632$export$610a2509037eaf6 = (typographyTheme)=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $kRRtM.blockquoteSharedStyles), ";", (0, $idytF.headingsSharedStyles)(typographyTheme), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-250, 20px)"};
	}

	/* Don't want extra padding for inline editor (nested) */
	.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-200, 16px)"};
	}`, ";");

});


parcelRegister("9wwua", function(module, exports) {

$parcel$export(module.exports, "findReplaceStyles", () => (parcelRequire("RhFwz")).findReplaceStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $RhFwz = parcelRequire("RhFwz");

});
parcelRegister("RhFwz", function(module, exports) {

$parcel$export(module.exports, "searchMatchClass", () => $9fcae42923e86302$export$cec6db4af40340f0);
$parcel$export(module.exports, "selectedSearchMatchClass", () => $9fcae42923e86302$export$bf208a338b2a2f1f);
$parcel$export(module.exports, "findReplaceStyles", () => $9fcae42923e86302$export$c5ceb9c726010930);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $9fcae42923e86302$export$cec6db4af40340f0 = 'search-match';
const $9fcae42923e86302$export$bf208a338b2a2f1f = 'selected-search-match';
const $9fcae42923e86302$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${$9fcae42923e86302$export$cec6db4af40340f0}`]: {
        borderRadius: '3px',
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px 0 ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 0 ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})` + ', inset 0 0 0 1px ' + `var(--ds-border-input, ${`${0, $829f609a65d26a98$export$46987b49aab6d1a8}`})`
    },
    [`.${$9fcae42923e86302$export$bf208a338b2a2f1f}`]: {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});

});


parcelRegister("3p7sF", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => (parcelRequire("6pErt")).textHighlightStyle);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6pErt = parcelRequire("6pErt");

});
parcelRegister("6pErt", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => $c96facf2e51cafaa$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $c96facf2e51cafaa$export$b286500adc7d91cd = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $b47580417926a26e$export$78dda1ebb9a1ea84), "{background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:2px solid var(--ds-background-accent-blue-subtler, #cce0ff);}");

});
const $b47580417926a26e$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $b47580417926a26e$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $b47580417926a26e$export$78dda1ebb9a1ea84 = 'text-highlight';
const $b47580417926a26e$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $b47580417926a26e$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $b47580417926a26e$export$220f0307408bc0c = 'akEditor';
const $b47580417926a26e$export$299d35c5583816ad = 'paste-options-testid';
const $b47580417926a26e$export$d1234a98f427930 = 'paste-options$';



parcelRegister("eXo2J", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => (parcelRequire("2yMev")).placeholderTextStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2yMev = parcelRequire("2yMev");

});
parcelRegister("2yMev", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => $7e369052517216e8$export$56bce713f2cb8aa7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

const $7e369052517216e8$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror span[data-placeholder]{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";display:inline;}.ProseMirror span.pm-placeholder{display:inline;color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder__text{display:inline;color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder.", (0, $iHYdz.akEditorSelectedNodeClassName), "{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Background
]), ";}.ProseMirror span.pm-placeholder__text[data-placeholder]::after{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";cursor:text;content:attr(data-placeholder);display:inline;}.ProseMirror{.ProseMirror-fake-text-cursor{display:inline;pointer-events:none;position:relative;}.ProseMirror-fake-text-cursor::after{content:'';display:inline;top:0;position:absolute;border-right:1px solid var(--ds-border, rgba(0, 0, 0, 0.4));}.ProseMirror-fake-text-selection{display:inline;pointer-events:none;position:relative;background-color:", `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`, ";}}");

});


parcelRegister("fz5RS", function(module, exports) {

$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $2404ec09d44bb929$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5BVRS = parcelRequire("5BVRS");

const $2404ec09d44bb929$export$3fc32cdc53f6edeb = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $5BVRS.inlineNodeViewClassname}`]: {
        display: 'inline',
        userSelect: 'all',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > *:not(.zeroWidthSpaceContainer)': {
            whiteSpace: 'pre-wrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .assistive': {
            userSelect: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-safari': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`.${0, $5BVRS.inlineNodeViewClassname}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::selection, *::selection': {
                background: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`&.ua-chrome .${0, $5BVRS.inlineNodeViewClassname} > span`]: {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $5BVRS.inlineNodeViewClassname}AddZeroWidthSpace`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            content: `'${(0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)}'`
        }
    }
});

});
parcelRegister("5BVRS", function(module, exports) {

$parcel$export(module.exports, "inlineNodeViewClassname", () => $376ab61f8223d072$export$dfb58b577a6f1cd9);
$parcel$export(module.exports, "getInlineNodeViewProducer", () => $376ab61f8223d072$export$17a8c3162956317d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gkwXh = parcelRequire("gkwXh");

var $9pOon = parcelRequire("9pOon");

var $4NUlu = parcelRequire("4NUlu");
var $gE8f9 = parcelRequire("gE8f9");
var $WXnhI = parcelRequire("WXnhI");


var $4tEIi = parcelRequire("4tEIi");

var $9xrrM = parcelRequire("9xrrM");
const $376ab61f8223d072$var$isSSR = Boolean(undefined);
const $376ab61f8223d072$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $376ab61f8223d072$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $376ab61f8223d072$var$virtualizedNodeAllowlist = [
    'status',
    'mention',
    'emoji',
    'date',
    'inlineCard'
];
function $376ab61f8223d072$var$checkExperimentExposure() {
    if ((0, $gmhCD.editorExperiment)('platform_editor_inline_node_virtualization', 'off', {
        exposure: true
    })) return false;
    if ((0, $gmhCD.editorExperiment)('platform_editor_inline_node_virtualization', 'fallback-small', {
        exposure: true
    })) return true;
    return false;
}
function $376ab61f8223d072$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4tEIi.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $376ab61f8223d072$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$376ab61f8223d072$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $4NUlu.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($376ab61f8223d072$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $WXnhI.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $WXnhI.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $WXnhI.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $376ab61f8223d072$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $376ab61f8223d072$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4tEIi.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $376ab61f8223d072$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$376ab61f8223d072$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $4NUlu.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($376ab61f8223d072$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$376ab61f8223d072$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $kCV8T.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $9xrrM.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $376ab61f8223d072$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $376ab61f8223d072$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $376ab61f8223d072$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9pOon.ErrorBoundary), {
            component: (0, $gkwXh.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $gkwXh.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)), /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $gE8f9.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $376ab61f8223d072$var$counterPerEditorViewMap = new WeakMap();
function $376ab61f8223d072$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $376ab61f8223d072$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $376ab61f8223d072$var$isSSR) return $376ab61f8223d072$var$createNodeView(parameters);
        if ((0, $VSDnB.fg)('platform_editor_inline_node_virt_threshold_override')) return $376ab61f8223d072$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $376ab61f8223d072$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $376ab61f8223d072$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $376ab61f8223d072$var$createNodeView(parameters);
        if (// Due to the experiment, we need to check experiment exposure
        // when a document has more than 100 (virtulizables) nodes.
        $376ab61f8223d072$var$checkExperimentExposure()) return $376ab61f8223d072$var$createNodeViewVirtualized(parameters);
        return $376ab61f8223d072$var$createNodeView(parameters);
    }
    return nodeViewProducer;
}

});
parcelRegister("9pOon", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $88b42bbe41ec844f$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $1KzE6 = parcelRequire("1KzE6");
class $88b42bbe41ec844f$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("WXnhI", function(module, exports) {

$parcel$export(module.exports, "getPerformanceOptions", () => $c14b3b53100539b7$export$9838b97af1c61be);
$parcel$export(module.exports, "startMeasureReactNodeViewRendered", () => $c14b3b53100539b7$export$2630f5971dfad231);
$parcel$export(module.exports, "stopMeasureReactNodeViewRendered", () => $c14b3b53100539b7$export$dc5a82f0bfc526c3);

var $gkwXh = parcelRequire("gkwXh");

var $iN9lO = parcelRequire("iN9lO");
// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $c14b3b53100539b7$var$nodeViewRenderedEventsCounter = 0;
const $c14b3b53100539b7$var$DEFAULT_SAMPLING_RATE = 100;
const $c14b3b53100539b7$var$DEFAULT_SLOW_THRESHOLD = 7;
function $c14b3b53100539b7$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $c14b3b53100539b7$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $c14b3b53100539b7$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $c14b3b53100539b7$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $iN9lO.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $c14b3b53100539b7$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $iN9lO.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$c14b3b53100539b7$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}

});

const $0f804702eb36dd5e$export$15a09f5ef055bcfa = '\u200b';
const $0f804702eb36dd5e$export$2b4d00c13dcd3c1f = '\u200d';

parcelRegister("4tEIi", function(module, exports) {

$parcel$export(module.exports, "generateUniqueNodeKey", () => $50f69fedc475632c$export$4a323a0542a1e4d1);

var $bXrHm = parcelRequire("bXrHm");
const $50f69fedc475632c$export$4a323a0542a1e4d1 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
};

});

parcelRegister("9xrrM", function(module, exports) {

$parcel$export(module.exports, "getOrCreateOnVisibleObserver", () => $29d167941afc2c06$export$d73c873f0a6a03c3);

var $gJBT6 = parcelRequire("gJBT6");
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $29d167941afc2c06$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $29d167941afc2c06$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $29d167941afc2c06$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($29d167941afc2c06$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$29d167941afc2c06$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});

});



parcelRegister("9O4yy", function(module, exports) {

$parcel$export(module.exports, "aiPanelStyles", () => $1e36f2eb545c5b87$export$cdf1b75966a7ba92);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $1e36f2eb545c5b87$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $1e36f2eb545c5b87$var$rotationAnimation = (0, $f8Sb3.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1e36f2eb545c5b87$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1e36f2eb545c5b87$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $1e36f2eb545c5b87$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $1e36f2eb545c5b87$var$prismBorderAnimationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        animation: `${$1e36f2eb545c5b87$var$rotationAnimation} linear 2s infinite`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1e36f2eb545c5b87$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $1e36f2eb545c5b87$var$prismBorderStyles = (colorMode, hover)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        content: "''",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
        transform: 'translate3d(0, 0, 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...hover ? {
            background: "var(--ds-border-input, #8590A2)"
        } : $1e36f2eb545c5b87$var$isFirefox ? {
            background: `linear-gradient(90deg,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 12%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 24%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 48%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 64%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 80%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`,
            backgroundSize: '200%'
        } : {
            background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`
        }
    });
const $1e36f2eb545c5b87$export$cdf1b75966a7ba92 = (colorMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("@property --panel-gradient-angle{syntax:'<angle>';initial-value:270deg;inherits:false;}div[extensionType='com.atlassian.ai-blocks']{.extension-label{display:none;}.extension-container{position:relative;box-shadow:none;overflow:unset;background-color:var(--ds-surface, #FFFFFF)!important;&::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode), ";}&.with-hover-border{&::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode, true), ";}}& .with-margin-styles{background-color:var(--ds-surface, #FFFFFF)!important;border-radius:var(--ds-border-radius-100, 3px);}}}div[extensionType='com.atlassian.ai-blocks']:has(.streaming){.extension-container{box-shadow:none;overflow:unset;", $1e36f2eb545c5b87$var$prismBorderAnimationStyles, " &::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode), ";}}}div[extensionType='com.atlassian.ai-blocks'].danger{.extension-container{box-shadow:0 0 0 1px var(--ds-border-danger, #E2483D);}}div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension']{div[data-node-type='actionList']{margin:0!important;}}");

});

parcelRegister("cEh6Q", function(module, exports) {

$parcel$export(module.exports, "codeBlockStyles", () => $fae98ce4976198e8$export$4baaed2b257b830);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $cYeQP = parcelRequire("cYeQP");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $cwax5 = parcelRequire("cwax5");
function $fae98ce4976198e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fae98ce4976198e8$var$_ref3 = {
    name: "1dgciks",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, none);}"
};
const $fae98ce4976198e8$var$GutterDangerOverlay = ()=>$fae98ce4976198e8$var$_ref3;
/* When code-block is inside the panel  */ var $fae98ce4976198e8$var$_ref = {
    name: "czrl7q",
    styles: ".ak-editor-panel__content{>.code-block:first-child{margin:0 0 0 0!important;}}"
};
var $fae98ce4976198e8$var$_ref2 = {
    name: "142jt9z",
    styles: ".ak-editor-panel__content{>.code-block:first-child,>.ProseMirror-widget:first-child+.code-block,>.ProseMirror-widget:first-child+.ProseMirror-widget+.code-block{margin:0 0 0 0!important;}}"
};
const $fae98ce4976198e8$var$firstCodeBlockWithNoMargin = (0, $cwax5.functionWithFG)('platform_editor_nested_dnd_styles_changes', ()=>$fae98ce4976198e8$var$_ref2, ()=>$fae98ce4976198e8$var$_ref);
const $fae98ce4976198e8$export$4baaed2b257b830 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $cYeQP.codeBlockSharedStyles)(), ";}.ProseMirror li{>.code-block{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:0;}>div:last-of-type.code-block,>pre:last-of-type.code-block{margin-bottom:", (0, $iHYdz.blockNodesVerticalMargin), ";}}.ProseMirror .code-block.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow,
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";}.ProseMirror .danger.code-block{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, #FFECEB);color:", `var(--ds-text-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";", $fae98ce4976198e8$var$GutterDangerOverlay(), ";}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}}.ProseMirror .danger .code-block{.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, rgba(255, 143, 115, 0.5));color:", `var(--ds-text-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";", $fae98ce4976198e8$var$GutterDangerOverlay(), ";}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:var(--ds-blanket-danger, rgba(255, 189, 173, 0.5));}}", $fae98ce4976198e8$var$firstCodeBlockWithNoMargin(), ";");

});
parcelRegister("cwax5", function(module, exports) {

$parcel$export(module.exports, "functionWithFG", () => $c02fe85c5c1e243f$export$53903226fff06fbb);

var $VSDnB = parcelRequire("VSDnB");

var $eXpHn = parcelRequire("eXpHn");
const $c02fe85c5c1e243f$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $eXpHn.functionWithCondition)(()=>(0, $VSDnB.fg)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("eXpHn", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $abb9266deac9e1cc$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $abb9266deac9e1cc$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $abb9266deac9e1cc$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $abb9266deac9e1cc$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});



parcelRegister("dv67m", function(module, exports) {

$parcel$export(module.exports, "dateVanillaStyles", () => $f64e5f28f7da36f5$export$b89fadc5134d50fa);
$parcel$export(module.exports, "dateStyles", () => $f64e5f28f7da36f5$export$37579fbc35dcc1a9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4E5wI = parcelRequire("4E5wI");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
const $f64e5f28f7da36f5$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span": {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span:hover": {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red": {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red:hover": {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $f64e5f28f7da36f5$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $4E5wI.DateSharedCssClassName).DATE_CONTAINER, "{.", (0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER, "{line-height:initial;cursor:pointer;}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", (0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER, ">span{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}.danger{.", (0, $4E5wI.DateSharedCssClassName).DATE_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER, ">span{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}}");

});

parcelRegister("cBEjw", function(module, exports) {

$parcel$export(module.exports, "expandStyles", () => $ac21c05ea8fc9971$export$4bb28258452e3b9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5HrRs = parcelRequire("5HrRs");
var $cr1aY = parcelRequire("cr1aY");
var $dVbMk = parcelRequire("dVbMk");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");
function $ac21c05ea8fc9971$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0.6))";
var $ac21c05ea8fc9971$var$_ref2 = {
    name: "1t3zvjb",
    styles: "color:var(--ds-icon-subtle, #626F86)"
};
const $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR = ()=>$ac21c05ea8fc9971$var$_ref2;
const $ac21c05ea8fc9971$var$DANGER_STATE_BACKGROUND_COLOR = "var(--ds-background-danger, #FFECEB)";
const $ac21c05ea8fc9971$var$DANGER_STATE_BORDER_COLOR = "var(--ds-border-danger, #E2483D)";
var $ac21c05ea8fc9971$var$_ref = {
    name: "1oz7tqa",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}>div.ak-editor-expand[data-node-type='nestedExpand']{margin-top:var(--ds-space-050, 0.25rem);}"
};
const $ac21c05ea8fc9971$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $ac21c05ea8fc9971$var$_ref : '';
const $ac21c05ea8fc9971$export$4bb28258452e3b9a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $cr1aY.expandClassNames).icon, ">div{display:flex;}.", (0, $cr1aY.expandClassNames).prefix, "{", (0, $dVbMk.sharedExpandStyles).containerStyles({
        expanded: false,
        focused: false
    })(), " cursor:pointer;box-sizing:border-box;td>&{margin-top:0;}.", (0, $cr1aY.expandClassNames).iconContainer, " svg{", $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR(), ";transform:rotate(90deg);}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]) + `border: ${0, $iHYdz.akEditorSelectedBorder};` : (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket,
        (0, $bzmFE.SelectionStyle).Border
    ]), ";}&.danger{background:", $ac21c05ea8fc9971$var$DANGER_STATE_BACKGROUND_COLOR, ";border-color:", $ac21c05ea8fc9971$var$DANGER_STATE_BORDER_COLOR, ";}}.ProseMirror>.", (0, $cr1aY.expandClassNames).type('expand'), ",.", (0, $5HrRs.BreakoutCssClassName).BREAKOUT_MARK_DOM, ">.", (0, $cr1aY.expandClassNames).type('expand'), "{margin-left:-", (0, $iHYdz.akLayoutGutterOffset), "px;margin-right:-", (0, $iHYdz.akLayoutGutterOffset), "px;}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror
		> .${(0, $cr1aY.expandClassNames).type('expand')},
		.${(0, $5HrRs.BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, $cr1aY.expandClassNames).type('expand')} {
		margin-left: -${(0, $iHYdz.akLayoutGutterOffset) + 8}px;
		margin-right: -${(0, $iHYdz.akLayoutGutterOffset) + 8}px;
	}`, " .", (0, $cr1aY.expandClassNames).content, "{", (0, $dVbMk.sharedExpandStyles).contentStyles({
        expanded: false,
        focused: false
    })(), " cursor:text;padding-top:0px;}.", (0, $cr1aY.expandClassNames).titleInput, "{", (0, $dVbMk.sharedExpandStyles).titleInputStyles(), ";}.", (0, $cr1aY.expandClassNames).titleContainer, "{", (0, $dVbMk.sharedExpandStyles).titleContainerStyles(), ";align-items:center;overflow:visible;}.", (0, $cr1aY.expandClassNames).expanded, "{background:", $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND, ";border-color:var(--ds-border, #091E4224);.", (0, $cr1aY.expandClassNames).content, "{padding-top:var(--ds-space-100, 8px);", $ac21c05ea8fc9971$var$firstNodeWithNotMarginTop(), ";}}.", (0, $cr1aY.expandClassNames).inputContainer, "{width:100%;}.", (0, $cr1aY.expandClassNames).prefix, ":(.", (0, $cr1aY.expandClassNames).expanded, "){.expand-content-wrapper{height:auto;}}.", (0, $cr1aY.expandClassNames).prefix, ":not(.", (0, $cr1aY.expandClassNames).expanded, "){.ak-editor-expand__content{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);white-space:nowrap;}.", (0, $cr1aY.expandClassNames).iconContainer, " svg{", $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR(), ";transform:rotate(0deg);}&:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "):not(.danger){background:transparent;border-color:transparent;&:hover{border-color:var(--ds-border, #091E4224);background:", $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND, ";}}}");

});
parcelRegister("5HrRs", function(module, exports) {

$parcel$export(module.exports, "BreakoutCssClassName", () => $96d4c7fd1ee4abdc$export$c21a3b023fccd534);
const $96d4c7fd1ee4abdc$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};

});

parcelRegister("dVbMk", function(module, exports) {

$parcel$export(module.exports, "sharedExpandStyles", () => $78318408d2d2a85d$export$8c0b53d8e8508fed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $78318408d2d2a85d$var$BORDER_RADIUS = "var(--ds-border-radius-100, 4px)";
const $78318408d2d2a85d$var$EXPAND_COLLAPSED_BACKGROUND = "var(--ds-background-neutral-subtle, transparent)";
const $78318408d2d2a85d$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-surface, rgba(255, 255, 255, 0.6))";
const $78318408d2d2a85d$var$EXPAND_FOCUSED_BORDER_COLOR = "var(--ds-border-focused, #388BFF)";
const $78318408d2d2a85d$var$EXPAND_COLLAPSED_BORDER_COLOR = 'transparent';
const $78318408d2d2a85d$var$EXPAND_EXPANDED_BORDER_COLOR = "var(--ds-border, #091E4224)";
const $78318408d2d2a85d$var$containerStyles = (styleProps)=>{
    const { expanded: expanded, focused: focused } = styleProps;
    const marginTop = "var(--ds-space-050, 0.25rem)";
    const marginBottom = 0;
    // Only only these margins if the expand isn't editable
    // and is the root level expand.
    const marginHorizontal = styleProps['data-node-type'] === 'expand' ? `-${0, $iHYdz.akLayoutGutterOffset}px` : 0;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const margin = `${marginTop} ${marginHorizontal} ${marginBottom}`;
    return ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
            borderWidth: '1px',
            borderStyle: 'solid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: focused ? $78318408d2d2a85d$var$EXPAND_FOCUSED_BORDER_COLOR : expanded ? $78318408d2d2a85d$var$EXPAND_EXPANDED_BORDER_COLOR : $78318408d2d2a85d$var$EXPAND_COLLAPSED_BORDER_COLOR,
            borderRadius: $78318408d2d2a85d$var$BORDER_RADIUS,
            minHeight: '25px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: !expanded ? $78318408d2d2a85d$var$EXPAND_COLLAPSED_BACKGROUND : $78318408d2d2a85d$var$EXPAND_SELECTED_BACKGROUND,
            margin: margin,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `background 0.3s ${(0, $iHYdz.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'td > :not(style):first-child, td > style:first-child + *': {
                marginTop: 0
            }
        });
};
const $78318408d2d2a85d$var$contentStyles = (styleProps)=>()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        (0, $f8Sb3.css)("padding-top:", styleProps.expanded ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)", ";padding-right:var(--ds-space-100, 8px);padding-left:var(--ds-space-300, 24px);margin-left:var(--ds-space-050, 4px);display:flow-root;@supports not (display: flow-root){width:100%;box-sizing:border-box;}", !styleProps.expanded ? `
        .expand-content-wrapper, .nestedExpand-content-wrapper {
          /* We visually hide the content here to preserve the content during copy+paste */
          /* Do not add text nowrap here because inline comment navigation depends on the location of the text */
          width: 100%;
          display: block;
          height: 0;
          overflow: hidden;
          clip: rect(1px, 1px, 1px, 1px);
          user-select: none;
        }
      ` : '', ";");
const $78318408d2d2a85d$var$titleInputStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? 1 : (0, $iHYdz.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    });
const $78318408d2d2a85d$var$titleContainerStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        padding: 0,
        display: 'flex',
        alignItems: 'flex-start',
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        overflow: 'hidden',
        cursor: 'pointer',
        '&:focus': {
            outline: 0
        }
    });
const $78318408d2d2a85d$export$8c0b53d8e8508fed = {
    titleInputStyles: $78318408d2d2a85d$var$titleInputStyles,
    titleContainerStyles: $78318408d2d2a85d$var$titleContainerStyles,
    containerStyles: $78318408d2d2a85d$var$containerStyles,
    contentStyles: $78318408d2d2a85d$var$contentStyles
};

});


parcelRegister("hucfL", function(module, exports) {

$parcel$export(module.exports, "extensionStyles", () => $734bc965b81ee341$export$c0c648396dbd86d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $734bc965b81ee341$var$extensionLabelStyles = /*#__PURE__*/ (0, $f8Sb3.css)("&.danger>span>div>.extension-label{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);opacity:1;box-shadow:none;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label{background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4);opacity:1;box-shadow:none;}&.danger>span>div>.extension-label>span{display:inline;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div .extension-label>span{display:inline;}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-danger, #E2483D);}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container>.extension-edit-toggle{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);box-shadow:none;}");
const $734bc965b81ee341$var$dangerOverlayStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0.3,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-danger-hovered, ${(0, $iHYdz.akEditorDeleteBackground)})`
});
const $734bc965b81ee341$export$c0c648396dbd86d3 = /*#__PURE__*/ (0, $f8Sb3.css)(".multiBodiedExtensionView-content-wrap{&.danger>span>.multiBodiedExtension--container{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}", $734bc965b81ee341$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.multiBodiedExtension--overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), "{&>span>.multiBodiedExtension--container{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Blanket
]), ";}}.multiBodiedExtension--container{width:100%;max-width:100%;}}.inlineExtensionView-content-wrap{", $734bc965b81ee341$var$extensionLabelStyles, ";&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}&.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}.bodied-extension-to-dom-label::after{content:attr(data-bodied-extension-label);}.extensionView-content-wrap,.multiBodiedExtensionView-content-wrap,.bodiedExtensionView-content-wrap{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0;&:first-of-type{margin-top:0;}&:last-of-type{margin-bottom:0;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}", $734bc965b81ee341$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&.inline{word-wrap:break-all;}}.extensionView-content-wrap .extension-container{overflow:hidden;&:has(.extension-editable-area){overflow:visible;}}.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container{width:100%;max-width:100%;}[data-mark-type='fragment']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0;}}&:first-child{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}}}&:nth-last-of-type(-n + 2):not(:first-of-type){&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}}}}");

});

parcelRegister("l5gcr", function(module, exports) {

$parcel$export(module.exports, "layoutStyles", () => $d274b53d45a9ace1$export$ac8f5049e4e10701);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $719f3 = parcelRequire("719f3");
var $ejmVg = parcelRequire("ejmVg");
parcelRequire("8OrBn");
var $jecUf = parcelRequire("jecUf");
parcelRequire("eTjGD");
var $1v4Xe = parcelRequire("1v4Xe");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
function $d274b53d45a9ace1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d274b53d45a9ace1$var$_ref = {
    name: "kzeyqg",
    styles: ">:not(style):first-child,>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*{margin-top:0;}"
};
var $d274b53d45a9ace1$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $d274b53d45a9ace1$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $d274b53d45a9ace1$var$_ref2 : $d274b53d45a9ace1$var$_ref;
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO handle responsive
const $d274b53d45a9ace1$var$layoutColumnStyles = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)(">[data-layout-column]{margin:0 ", (0, $ejmVg.LAYOUT_SECTION_MARGIN) / 2, "px;}>[data-layout-column]:first-of-type{margin-left:0;}>[data-layout-column]:last-of-type{margin-right:0;}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin:0;}}>[data-layout-column].", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";::before{width:calc(100% - 8px);left:4px;border-radius:var(--ds-border-radius, 3px);}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("[data-layout-column]+[data-layout-column]{margin-left:", (0, $ejmVg.LAYOUT_SECTION_MARGIN), "px;}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin-left:0;}}");
const $d274b53d45a9ace1$var$layoutSectionStyles = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)((0, $719f3.columnLayoutResponsiveSharedStyle), ";.layout-section-container [data-layout-section]{>.ProseMirror-widget{flex:none;display:contents!important;&[data-blocks-drag-handle-container] div{display:contents!important;}&[data-blocks-drop-target-container]{display:block!important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}&+[data-layout-column]{margin:0;}}>[data-layout-column]{margin:0;}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)((0, $719f3.columnLayoutSharedStyle), ";");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$layoutBorderStyles = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column],&:hover [data-layout-column]{border:", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);}&.selected.danger [data-layout-column]{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";border-color:", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Border,
        (0, $bzmFE.SelectionStyle).Blanket
    ]), " ::after{background-color:transparent;}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$columnSeparatorStyles = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("[data-layout-content]::before{content:'';border-left:", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;height:calc(100% - 24px);margin-left:-25px;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$rowSeparatorStyles = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("[data-layout-content]::before{content:'';border-top:", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;width:calc(100% - 32px);margin-top:-13px;border-left:unset;margin-left:unset;height:unset;}");
const $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles = (breakpoint, viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("&.selected,&:hover,&.selected.danger,&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]:not(:first-of-type){@container editor-area (max-width:", breakpoint, "px){", $d274b53d45a9ace1$var$rowSeparatorStyles(viewMode), ";}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$layoutWithSeparatorBorderStyles = (viewMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return /*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column]:not(:first-of-type),[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),&:hover [data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}&.selected.danger [data-layout-section]{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";border-radius:4px;[data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger) [data-layout-section]{box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);border-radius:4px;background-color:var(--ds-background-selected, #E9F2FF);[data-layout-column]{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]), " border:0px;::before{background-color:transparent;}}[data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}}");
};
const $d274b53d45a9ace1$var$layoutResponsiveStyles = (viewMode)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)(".fabric-editor--full-width-mode .ProseMirror{>.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(724, viewMode), ";[data-layout-section]{@container editor-area (max-width:724px){flex-direction:column;}}}}.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror{>.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(788, viewMode), ";[data-layout-section]{@container editor-area (max-width:788px){flex-direction:column;}}}}.ProseMirror .fabric-editor-breakout-mark{.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(820, viewMode), ";[data-layout-section]{@container editor-area (max-width:820px){flex-direction:column;}}}}");
const $d274b53d45a9ace1$export$ac8f5049e4e10701 = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", $d274b53d45a9ace1$var$layoutSectionStyles(), " [data-layout-section]{margin:var(--ds-space-100, 8px) -", (0, $iHYdz.akLayoutGutterOffset) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0), "px 0;transition:border-color 0.3s ", (0, $iHYdz.akEditorSwoopCubicBezier), ";cursor:", viewMode === 'view' ? 'default' : 'pointer', ";", $d274b53d45a9ace1$var$layoutColumnStyles(), ";[data-layout-column]{flex:1;position:relative;min-width:0;border:", viewMode === 'view' || (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);border-radius:4px;padding:", (0, $ejmVg.LAYOUT_COLUMN_PADDING), "px ", (0, $ejmVg.LAYOUT_COLUMN_PADDING) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0), "px;box-sizing:border-box;>div{", $d274b53d45a9ace1$var$firstNodeWithNotMarginTop(), ">.embedCardView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.mediaSingleView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor.-right:first-child+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor.-right+.mediaSingleView-content-wrap .rich-media-item,>.ProseMirror-gapcursor.-right:first-of-type+.embedCardView-content-wrap .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor+span+.mediaSingleView-content-wrap .rich-media-item{margin-top:0;}>[data-node-type='decisionList']{li:first-of-type [data-decision-wrapper]{margin-top:0;}}}[data-layout-content]{height:100%;cursor:text;.mediaGroupView-content-wrap{clear:both;}}}}[data-layout-section],.layoutSectionView-content-wrap{", (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? $d274b53d45a9ace1$var$layoutWithSeparatorBorderStyles(viewMode) : $d274b53d45a9ace1$var$layoutBorderStyles(viewMode), ";}}", (0, $gmhCD.editorExperiment)('advanced_layouts', true) && $d274b53d45a9ace1$var$layoutResponsiveStyles(viewMode), "[data-blocks-drop-target-container]~[data-layout-column]>[data-layout-content]::before{display:none;}.fabric-editor--full-width-mode .ProseMirror{[data-layout-section]{.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin:0 ", (0, $1v4Xe.tableMarginFullWidthMode), "px;}}}", (0, $gmhCD.editorExperiment)('advanced_layouts', false) && (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $iHYdz.akLayoutGutterOffset) + 8}px 0;
				}`, ";");

});
parcelRegister("8OrBn", function(module, exports) {

$parcel$export(module.exports, "TableCssClassName", () => (parcelRequire("jecUf")).TableCssClassName);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jecUf = parcelRequire("jecUf");

});
parcelRegister("jecUf", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", () => $2e822d78af9e1ad0$export$1a38c7157d718094);
$parcel$export(module.exports, "TableDecorations", () => $2e822d78af9e1ad0$export$fe8f2ca19399400e);
$parcel$export(module.exports, "TableCssClassName", () => $2e822d78af9e1ad0$export$19a8a7a6488b1b9f);
$parcel$export(module.exports, "ShadowEvent", () => $2e822d78af9e1ad0$export$ce63d9b315ac58c9);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9UDEr = parcelRequire("9UDEr");

var $6gEe5 = parcelRequire("6gEe5");
const $2e822d78af9e1ad0$export$1a38c7157d718094 = 30;
var $2e822d78af9e1ad0$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
    return TableDecorations;
}({});
const $2e822d78af9e1ad0$export$19a8a7a6488b1b9f = {
    ...(0, $6gEe5.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $9UDEr.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $9UDEr.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $9UDEr.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $9UDEr.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $9UDEr.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $9UDEr.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $9UDEr.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $9UDEr.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $9UDEr.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $9UDEr.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $9UDEr.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $9UDEr.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $9UDEr.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $9UDEr.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $9UDEr.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $9UDEr.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $9UDEr.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $9UDEr.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $9UDEr.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $9UDEr.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $9UDEr.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $9UDEr.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $9UDEr.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $9UDEr.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $9UDEr.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $9UDEr.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $9UDEr.tableCellSelector),
    TABLE_HEADER_CELL: (0, $9UDEr.tableHeaderSelector),
    TABLE_STICKY: `${(0, $9UDEr.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $9UDEr.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    LAST_ITEM_IN_CELL: `${(0, $9UDEr.tablePrefixSelector)}-last-item-in-cell`,
    WITH_COLUMN_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $9UDEr.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $9UDEr.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-last-row-insert-line__inactive`
};
var $2e822d78af9e1ad0$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});

});


parcelRegister("eTjGD", function(module, exports) {

$parcel$export(module.exports, "tableMarginFullWidthMode", () => (parcelRequire("1v4Xe")).tableMarginFullWidthMode);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1v4Xe = parcelRequire("1v4Xe");

});
parcelRegister("1v4Xe", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundColor", () => $25c191bb2717b458$export$3efa753685336605);
$parcel$export(module.exports, "tableHeaderCellBackgroundColor", () => $25c191bb2717b458$export$95883e661e73a1d1);
$parcel$export(module.exports, "tableTextColor", () => $25c191bb2717b458$export$14da8da34a807702);
$parcel$export(module.exports, "tableBorderColor", () => $25c191bb2717b458$export$60473ec4f7c2b794);
$parcel$export(module.exports, "tableCellSelectedColor", () => $25c191bb2717b458$export$f26d047169b4195d);
$parcel$export(module.exports, "tableToolbarSelectedColor", () => $25c191bb2717b458$export$8c5dd0fc35774ae1);
$parcel$export(module.exports, "tableBorderSelectedColor", () => $25c191bb2717b458$export$9bf0891aaaf2fecb);
$parcel$export(module.exports, "tableCellSelectedDeleteIconColor", () => $25c191bb2717b458$export$a699493d7d7580c3);
$parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", () => $25c191bb2717b458$export$cd5e5900c9fa42dc);
$parcel$export(module.exports, "tableCellDeleteColor", () => $25c191bb2717b458$export$3c2a828febe9d506);
$parcel$export(module.exports, "tableBorderDeleteColor", () => $25c191bb2717b458$export$870d72a5700e711d);
$parcel$export(module.exports, "tableToolbarDeleteColor", () => $25c191bb2717b458$export$e7bba7ffd7bf3c50);
$parcel$export(module.exports, "tableCellHoverDeleteIconColor", () => $25c191bb2717b458$export$6cc2aa96833a5989);
$parcel$export(module.exports, "tableCellHoverDeleteIconBackground", () => $25c191bb2717b458$export$9907ca2ad437ddcc);
$parcel$export(module.exports, "tableBorderRadiusSize", () => $25c191bb2717b458$export$371da7842ff35a5b);
$parcel$export(module.exports, "tablePadding", () => $25c191bb2717b458$export$e5ff276883773ffd);
$parcel$export(module.exports, "tableScrollbarOffset", () => $25c191bb2717b458$export$92421f8864c287b1);
$parcel$export(module.exports, "tableMarginFullWidthMode", () => $25c191bb2717b458$export$cbcfa4314b903419);
$parcel$export(module.exports, "tableInsertColumnButtonSize", () => $25c191bb2717b458$export$6d23b13c5fcb846c);
$parcel$export(module.exports, "tableDeleteButtonSize", () => $25c191bb2717b458$export$cb376ed67c7ae37e);
$parcel$export(module.exports, "tableDeleteButtonOffset", () => $25c191bb2717b458$export$52b432855099b8bd);
$parcel$export(module.exports, "tableToolbarSize", () => $25c191bb2717b458$export$a4d60e31f4f6188b);
$parcel$export(module.exports, "tableControlsSpacing", () => $25c191bb2717b458$export$880976487022eb5);
$parcel$export(module.exports, "tableInsertColumnButtonOffset", () => $25c191bb2717b458$export$73b1242ebdcc73be);
$parcel$export(module.exports, "lineMarkerSize", () => $25c191bb2717b458$export$a3e71c692f2c2213);
$parcel$export(module.exports, "columnControlsDecorationHeight", () => $25c191bb2717b458$export$62374dd2f63076b0);
$parcel$export(module.exports, "columnControlsZIndex", () => $25c191bb2717b458$export$da0ccd381b1a80f);
$parcel$export(module.exports, "columnControlsSelectedZIndex", () => $25c191bb2717b458$export$83da30a15600a83e);
$parcel$export(module.exports, "rowControlsZIndex", () => $25c191bb2717b458$export$45aeeddcedd441ab);
$parcel$export(module.exports, "insertLineWidth", () => $25c191bb2717b458$export$cc7ed656b7dcf729);
$parcel$export(module.exports, "resizeHandlerAreaWidth", () => $25c191bb2717b458$export$72409f838e9c33c7);
$parcel$export(module.exports, "resizeLineWidth", () => $25c191bb2717b458$export$45d9825f76985b4e);
$parcel$export(module.exports, "resizeHandlerZIndex", () => $25c191bb2717b458$export$887c1388be90c08e);
$parcel$export(module.exports, "contextualMenuTriggerSize", () => $25c191bb2717b458$export$3969371f057ce1e5);
$parcel$export(module.exports, "contextualMenuDropdownWidth", () => $25c191bb2717b458$export$a6ed027d1a83416d);
$parcel$export(module.exports, "contextualMenuDropdownWidthDnD", () => $25c191bb2717b458$export$42d9040c5091b076);
$parcel$export(module.exports, "stickyRowZIndex", () => $25c191bb2717b458$export$1279af870a198fea);
$parcel$export(module.exports, "stickyRowOffsetTop", () => $25c191bb2717b458$export$83c60dd0aac17107);
$parcel$export(module.exports, "stickyHeaderBorderBottomWidth", () => $25c191bb2717b458$export$13b0e72269a9a3aa);
$parcel$export(module.exports, "tableOverflowShadowWidth", () => $25c191bb2717b458$export$40311377f05dbfc4);
$parcel$export(module.exports, "tableOverflowShadowWidthWide", () => $25c191bb2717b458$export$1680d391e1ce7b96);
$parcel$export(module.exports, "tablePopupMenuFitHeight", () => $25c191bb2717b458$export$3cdde837cf189e96);
$parcel$export(module.exports, "dropTargetsZIndex", () => $25c191bb2717b458$export$b2015400488f9243);
$parcel$export(module.exports, "TABLE_SNAP_GAP", () => $25c191bb2717b458$export$8f6133b6e2b4291);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", () => $25c191bb2717b458$export$edb1b9caf8ff5b32);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", () => $25c191bb2717b458$export$7af5c65e392a647);
$parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", () => $25c191bb2717b458$export$858d012f03ae70a5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", () => $25c191bb2717b458$export$a13bd817a2eda041);
$parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", () => $25c191bb2717b458$export$e0140c2b978caac5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", () => $25c191bb2717b458$export$c6a9e7014cf7aedc);
$parcel$export(module.exports, "dragMenuDropdownWidth", () => $25c191bb2717b458$export$963fb187132ee7cf);
$parcel$export(module.exports, "dragTableInsertColumnButtonSize", () => $25c191bb2717b458$export$d18320cc8ee69115);
$parcel$export(module.exports, "dropTargetExtendedWidth", () => $25c191bb2717b458$export$6bec1f8a2aa82be8);
$parcel$export(module.exports, "colorPalletteColumns", () => $25c191bb2717b458$export$2c18704a8d793cdb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $jecUf = parcelRequire("jecUf");
const $25c191bb2717b458$export$3efa753685336605 = `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $25c191bb2717b458$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableHeaderCellBackground)})`;
const $25c191bb2717b458$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, $iHYdz.akEditorTableToolbar)})`;
const $25c191bb2717b458$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $25c191bb2717b458$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`;
const $25c191bb2717b458$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $25c191bb2717b458$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, $iHYdz.akEditorTableCellBlanketSelected)})`;
const $25c191bb2717b458$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
const $25c191bb2717b458$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, $iHYdz.akEditorTableBorderSelected)})`;
const $25c191bb2717b458$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`;
const $25c191bb2717b458$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`;
const $25c191bb2717b458$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorTableCellBlanketDeleted)})`;
const $25c191bb2717b458$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
const $25c191bb2717b458$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $829f609a65d26a98$export$b34b069eff244586)})`;
const $25c191bb2717b458$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
const $25c191bb2717b458$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`;
const $25c191bb2717b458$export$371da7842ff35a5b = 3;
const $25c191bb2717b458$export$e5ff276883773ffd = 8;
const $25c191bb2717b458$export$92421f8864c287b1 = 15;
const $25c191bb2717b458$export$cbcfa4314b903419 = 2;
const $25c191bb2717b458$export$6d23b13c5fcb846c = 20;
const $25c191bb2717b458$export$cb376ed67c7ae37e = 16;
const $25c191bb2717b458$export$52b432855099b8bd = 6;
const $25c191bb2717b458$export$a4d60e31f4f6188b = (0, $iHYdz.akEditorTableToolbarSize);
const $25c191bb2717b458$export$880976487022eb5 = (0, $6gEe5.tableMarginTop) + $25c191bb2717b458$export$e5ff276883773ffd - (0, $6gEe5.tableCellBorderWidth);
const $25c191bb2717b458$export$73b1242ebdcc73be = 3;
const $25c191bb2717b458$export$86dfc955b6099b88 = 32;
const $25c191bb2717b458$export$893fc0cfd2a0c40e = 13;
const $25c191bb2717b458$export$a3e71c692f2c2213 = 4;
const $25c191bb2717b458$export$62374dd2f63076b0 = 25;
const $25c191bb2717b458$export$da0ccd381b1a80f = (0, $iHYdz.akEditorUnitZIndex) * 10;
const $25c191bb2717b458$export$83da30a15600a83e = $25c191bb2717b458$export$da0ccd381b1a80f + 1;
const $25c191bb2717b458$export$45aeeddcedd441ab = (0, $iHYdz.akEditorUnitZIndex) * 10;
const $25c191bb2717b458$export$5b53cc051bf05434 = $25c191bb2717b458$export$83da30a15600a83e + 1;
const $25c191bb2717b458$export$cc7ed656b7dcf729 = 3;
const $25c191bb2717b458$export$72409f838e9c33c7 = (0, $jecUf.RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
const $25c191bb2717b458$export$45d9825f76985b4e = 2;
const $25c191bb2717b458$export$887c1388be90c08e = $25c191bb2717b458$export$da0ccd381b1a80f + (0, $iHYdz.akRichMediaResizeZIndex);
const $25c191bb2717b458$export$3969371f057ce1e5 = 16;
const $25c191bb2717b458$export$a6ed027d1a83416d = 180;
const $25c191bb2717b458$export$42d9040c5091b076 = 250;
const $25c191bb2717b458$export$1279af870a198fea = $25c191bb2717b458$export$887c1388be90c08e + 2;
const $25c191bb2717b458$export$83c60dd0aac17107 = 8;
const $25c191bb2717b458$export$13b0e72269a9a3aa = 1;
const $25c191bb2717b458$export$40311377f05dbfc4 = 8;
const $25c191bb2717b458$export$1680d391e1ce7b96 = 32;
const $25c191bb2717b458$export$3cdde837cf189e96 = 188;
const $25c191bb2717b458$export$b2015400488f9243 = 14;
const $25c191bb2717b458$export$8f6133b6e2b4291 = 9;
const $25c191bb2717b458$export$edb1b9caf8ff5b32 = 10;
const $25c191bb2717b458$export$7af5c65e392a647 = 2;
const $25c191bb2717b458$export$11cf30061861ec4a = 5;
const $25c191bb2717b458$export$858d012f03ae70a5 = -68;
const $25c191bb2717b458$export$a13bd817a2eda041 = 92;
const $25c191bb2717b458$export$e0140c2b978caac5 = 4;
const $25c191bb2717b458$export$c6a9e7014cf7aedc = 6;
const $25c191bb2717b458$export$963fb187132ee7cf = 250;
const $25c191bb2717b458$export$d18320cc8ee69115 = 16;
const $25c191bb2717b458$export$6bec1f8a2aa82be8 = 150;
const $25c191bb2717b458$export$2c18704a8d793cdb = 7;
const $25c191bb2717b458$export$150cd2564fec30b7 = 8;

});



parcelRegister("6UEu0", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $0d5dc640686a6518$export$abd2efc27ac7e809);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9R9Rb = parcelRequire("9R9Rb");

var $ceYEW = parcelRequire("ceYEW");

var $iHYdz = parcelRequire("iHYdz");

var $79PaE = parcelRequire("79PaE");
const $0d5dc640686a6518$export$abd2efc27ac7e809 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $ceYEW.mediaSingleSharedStyleNew), " & [layout='full-width'] .", (0, $ceYEW.richMediaClassName), ",& [layout='wide'] .", (0, $ceYEW.richMediaClassName), "{margin-left:50%;transform:translateX(-50%);}.media-extended-resize-experience[layout^='wrap-']{overflow:visible!important;}& [layout^='wrap-']+[layout^='wrap-']{clear:none;&+p,&+div[class^='fabric-editor-align'],&+ul,&+ol,&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{clear:both!important;}& .", (0, $ceYEW.richMediaClassName), "{margin-left:0;margin-right:0;}}", (0, $9R9Rb.mediaInlineImageStyles), " .mediaSingleView-content-wrap[layout^='wrap-']{max-width:100%;clear:inherit;}.mediaSingleView-content-wrap[layout='wrap-left']{float:left;}.mediaSingleView-content-wrap[layout='wrap-right']{float:right;}.mediaSingleView-content-wrap[layout='wrap-right']+.mediaSingleView-content-wrap[layout='wrap-left']{clear:both;}&>.mediaSingleView-content-wrap{.richMedia-resize-handle-right{margin-right:-", (0, $iHYdz.akEditorMediaResizeHandlerPaddingWide), "px;}.richMedia-resize-handle-left{margin-left:-", (0, $iHYdz.akEditorMediaResizeHandlerPaddingWide), "px;}}}.richMedia-resize-handle-right,.richMedia-resize-handle-left{display:flex;flex-direction:column;justify-content:center;}.richMedia-resize-handle-right{align-items:flex-end;padding-right:var(--ds-space-150, 12px);margin-right:-", (0, $iHYdz.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-left{align-items:flex-start;padding-left:var(--ds-space-150, 12px);margin-left:-", (0, $iHYdz.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{content:' ';display:flex;width:3px;height:64px;border-radius:6px;}.", (0, $ceYEW.richMediaClassName), ":hover .richMedia-resize-handle-left::after,.", (0, $ceYEW.richMediaClassName), ":hover .richMedia-resize-handle-right::after{background:var(--ds-border, #091E4224);}.", (0, $iHYdz.akEditorSelectedNodeClassName), " .richMedia-resize-handle-right::after,.", (0, $iHYdz.akEditorSelectedNodeClassName), " .richMedia-resize-handle-left::after,.", (0, $ceYEW.richMediaClassName), " .richMedia-resize-handle-right:hover::after,.", (0, $ceYEW.richMediaClassName), " .richMedia-resize-handle-left:hover::after,.", (0, $ceYEW.richMediaClassName), ".is-resizing .richMedia-resize-handle-right::after,.", (0, $ceYEW.richMediaClassName), ".is-resizing .richMedia-resize-handle-left::after{background:var(--ds-border-focused, #388BFF);}.__resizable_base__{left:unset!important;width:auto!important;height:auto!important;}.danger>div>div>.media-card-frame,.danger>span>a{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";box-shadow:0px 0px 0px ", (0, $iHYdz.akEditorSelectedBorderBoldSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";transition:background-color 0s,box-shadow 0s;}.danger{.", (0, $ceYEW.richMediaClassName), " .", (0, $025bde419ff72534$export$7a6526d4be3b7eb3), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}.", (0, $ceYEW.richMediaClassName), " .", (0, $79PaE.inlinePlayerClassName), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}.", (0, $ceYEW.richMediaClassName), " .", (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}.resizer-handle-thumb{background:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}div div .media-card-frame,.inlineCardView-content-wrap>span>a{background-color:var(--ds-blanket-danger, rgb(255, 189, 173, 0.5));transition:background-color 0s;}div div .media-card-frame::after{box-shadow:none;}}.warning{.", (0, $ceYEW.richMediaClassName), " .", (0, $025bde419ff72534$export$7a6526d4be3b7eb3), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $ceYEW.richMediaClassName), " .", (0, $79PaE.inlinePlayerClassName), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $ceYEW.richMediaClassName), " .", (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px var(--ds-border-warning, #E56910)!important;}.resizer-handle-thumb{background:var(--ds-icon-warning, #E56910)!important;}}.media-filmstrip-list-item{cursor:pointer;}.mediaGroupView-content-wrap.", (0, $iHYdz.akEditorSelectedNodeClassName), " #newFileExperienceWrapper{box-shadow:", (0, $iHYdz.akEditorSelectedBoxShadow), ";}.ak-editor-no-interaction #newFileExperienceWrapper{box-shadow:none;}"); /* `left: unset` above is to work around Chrome bug where rendering a div with
 * that style applied inside a container that has a scroll, causes any svgs on
 * the page, without a border, that are inside a flexbox, to no longer align to
 * the center of their viewbox.
 *
 * for us, this means that all the toolbar icons start jumping around if
 * you make the viewport small
 */ 

});
parcelRegister("79PaE", function(module, exports) {

$parcel$export(module.exports, "inlinePlayerClassName", () => $c63e9575ac7419ed$export$70bc5d30fe886af);
$parcel$export(module.exports, "inlinePlayerWrapperStyles", () => $c63e9575ac7419ed$export$bffd1a8ecf8d5d06);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");

var $lv9SR = parcelRequire("lv9SR");

var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $c63e9575ac7419ed$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $5yojI.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      ${0, $k5uoT.borderRadius}
      ${selected ? (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $c63e9575ac7419ed$export$70bc5d30fe886af = 'media-card-inline-player';
const $c63e9575ac7419ed$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $f8Sb3.css)("width:", (0, $lv9SR.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $lv9SR.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:", (0, $k5uoT.borderRadius)(), "px;position:relative;max-width:100%;max-height:100%;", $c63e9575ac7419ed$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$c63e9575ac7419ed$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';

});
parcelRegister("lv9SR", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $d8ce749d15267dc5$export$36acad525b1fb57b);
const $d8ce749d15267dc5$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});


const $6d9332e5e7a86517$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("b3RpZ", function(module, exports) {

$parcel$export(module.exports, "panelStyles", () => $baaf4c6520958d3a$export$8290cf129669d0cb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aABH4 = parcelRequire("aABH4");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");
const $baaf4c6520958d3a$export$8290cf129669d0cb = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $aABH4.panelSharedStyles)(), ";.", (0, $aABH4.PanelSharedCssClassName).prefix, "{cursor:pointer;&.danger{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, "!important;.", (0, $aABH4.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}}}.", (0, $aABH4.PanelSharedCssClassName).content, "{cursor:text;}.danger .", (0, $aABH4.PanelSharedCssClassName).prefix, "{&[data-panel-type]{background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";.", (0, $aABH4.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}}}}.", (0, $aABH4.PanelSharedCssClassName).prefix, ".", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow,
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror {
		.ak-editor-panel .${(0, $aABH4.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
		}

		.ak-editor-panel.${(0, $aABH4.PanelSharedCssClassName).noIcon} {
			padding-left: ${"var(--ds-space-250, 20px)"};
			padding-right: ${"var(--ds-space-250, 20px)"};
		}
	}`, ";", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area .ak-editor-content-area .ProseMirror {
		.ak-editor-panel .${(0, $aABH4.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-100, 8px)"};
		}
		.ak-editor-panel.${(0, $aABH4.PanelSharedCssClassName).noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}
	}`, ";");

});

parcelRegister("aUTD3", function(module, exports) {

$parcel$export(module.exports, "vanillaStatusStyles", () => $2df8a0e92b077e8e$export$5393c24101671903);
$parcel$export(module.exports, "statusStyles", () => $2df8a0e92b077e8e$export$79c8c9ad308bbe07);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kZxLT = parcelRequire("kZxLT");
var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");
function $2df8a0e92b077e8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $2df8a0e92b077e8e$var$getVisualRefreshStatusStyles = ()=>// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:", (0, $iHYdz.akEditorSelectedBoldBoxShadow), ";}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}");
var $2df8a0e92b077e8e$var$_ref = {
    name: "1qcr8hm",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=neutral] .lozenge-wrapper{background-color:var(--ds-background-neutral, #091E420F);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=neutral] .lozenge-text{color:var(--ds-text-subtle, #44546F);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=purple] .lozenge-wrapper{background-color:var(--ds-background-discovery, #F3F0FF);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=purple] .lozenge-text{color:var(--ds-text-discovery, #5E4DB2);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=blue] .lozenge-wrapper{background-color:var(--ds-background-information, #E9F2FF);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=blue] .lozenge-text{color:var(--ds-text-information, #0055CC);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=yellow] .lozenge-wrapper{background-color:var(--ds-background-warning, #FFF7D6);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=yellow] .lozenge-text{color:var(--ds-text-warning, #A54800);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=red] .lozenge-wrapper{background-color:var(--ds-background-danger, #FFECEB);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=red] .lozenge-text{color:var(--ds-text-danger, #AE2E24);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=green] .lozenge-wrapper{background-color:var(--ds-background-success, #DCFFF1);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=green] .lozenge-text{color:var(--ds-text-success, #216E4E);}"
};
var $2df8a0e92b077e8e$var$_ref2 = {
    name: "lq7sbf",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] .lozenge-text{color:#292A2E;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=neutral] > .lozenge-wrapper{background-color:#DDDEE1;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=purple] > .lozenge-wrapper{background-color:#D8A0F7;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=blue] > .lozenge-wrapper{background-color:#8FB8F6;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=yellow] > .lozenge-wrapper{background-color:#F9C84E;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=red] > .lozenge-wrapper{background-color:#FD9891;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=green] > .lozenge-wrapper{background-color:#B3DF72;}"
};
const $2df8a0e92b077e8e$var$getStatusColors = ()=>(0, $VSDnB.fg)('platform-component-visual-refresh') ? $2df8a0e92b077e8e$var$_ref2 : $2df8a0e92b077e8e$var$_ref;
const $2df8a0e92b077e8e$var$baseVanillaStatusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        borderRadius: '3px',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $2df8a0e92b077e8e$export$5393c24101671903 = /*#__PURE__*/ (0, $f8Sb3.css)($2df8a0e92b077e8e$var$baseVanillaStatusStyles, " ", $2df8a0e92b077e8e$var$getStatusColors(), ";");
const $2df8a0e92b077e8e$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $6gEe5.TableSharedCssClassName).TABLE_CELL_WRAPPER, ",.", (0, $6gEe5.TableSharedCssClassName).TABLE_HEADER_CELL_WRAPPER, ",[data-layout-section]{.", (0, $kZxLT.StatusSharedCssClassName).STATUS_CONTAINER, "{max-width:100%;line-height:0;>span{width:100%;}}}.", (0, $kZxLT.StatusSharedCssClassName).STATUS_CONTAINER, "{", $2df8a0e92b077e8e$var$getVisualRefreshStatusStyles(), ";>span{cursor:pointer;line-height:0;}}.danger{.", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{background-color:", (0, $iHYdz.akEditorDeleteBackgroundWithOpacity), ";}.", (0, $kZxLT.StatusSharedCssClassName).STATUS_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";}}");

});
parcelRegister("kZxLT", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $1b48498df0149da7$export$b18e58a1c082b710);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $1b48498df0149da7$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};

});


parcelRegister("5L329", function(module, exports) {

$parcel$export(module.exports, "taskDecisionStyles", () => $f9553b9bb33991d4$export$6083a263609cde43);
$parcel$export(module.exports, "vanillaTaskDecisionStyles", () => $f9553b9bb33991d4$export$7ac91fa205fa129a);
$parcel$export(module.exports, "vanillaTaskDecisionIconWithVisualRefresh", () => $f9553b9bb33991d4$export$eab9dc0cfe87f6c3);
$parcel$export(module.exports, "vanillaTaskDecisionIconWithoutVisualRefresh", () => $f9553b9bb33991d4$export$ac2a2eaab13bfe49);
$parcel$export(module.exports, "vanillaTaskItemStyles", () => $f9553b9bb33991d4$export$5d2a537111c20a83);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1bQ0V = parcelRequire("1bQ0V");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
function $f9553b9bb33991d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9553b9bb33991d4$export$6083a263609cde43 = /*#__PURE__*/ (0, $f8Sb3.css)("[data-decision-wrapper]{cursor:pointer;}.", (0, $iHYdz.akEditorSelectedNodeClassName), ">[data-decision-wrapper],ol[data-node-type='decisionList'].", (0, $iHYdz.akEditorSelectedNodeClassName), "{border-radius:4px;", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Blanket
]), ";}.danger{.", (0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), ">div{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";&::after{content:none;}}}");
const $f9553b9bb33991d4$export$7ac91fa205fa129a = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #626F86)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #22A06B)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $f9553b9bb33991d4$export$eab9dc0cfe87f6c3 = {
    name: "yu3jaj",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $f9553b9bb33991d4$export$ac2a2eaab13bfe49 = {
    name: "14ovu2b",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $f9553b9bb33991d4$export$5d2a537111c20a83 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]:has([data-empty]):not(:has([data-type-ahead])) [data-component="placeholder"]': {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] .${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});

});


parcelRegister("iK9VQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee089fbaad1c4b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ajpes = parcelRequire("ajpes");

var $gkwXh = parcelRequire("gkwXh");

var $bLuIS = parcelRequire("bLuIS");

var $65Q6Y = parcelRequire("65Q6Y");
function $fee089fbaad1c4b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fee089fbaad1c4b9$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $fee089fbaad1c4b9$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks || !editorView) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bLuIS.ErrorBoundary), {
        component: (0, $gkwXh.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $65Q6Y.MountPluginHooks), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $fee089fbaad1c4b9$var$pluginsComponentsWrapper
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(element, props);
    })));
};
const $fee089fbaad1c4b9$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($fee089fbaad1c4b9$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
$fee089fbaad1c4b9$var$PluginSlotComponent.displayName = 'PluginSlot';
var $fee089fbaad1c4b9$export$2e2bcd8739ae039 = $fee089fbaad1c4b9$var$PluginSlotComponent;

});
parcelRegister("bLuIS", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $d3f657eabcbe16a5$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $1KzE6 = parcelRequire("1KzE6");
class $d3f657eabcbe16a5$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("65Q6Y", function(module, exports) {

$parcel$export(module.exports, "MountPluginHooks", () => $4428e2244acd6367$export$a9224552b63e3fe8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $4428e2244acd6367$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $4428e2244acd6367$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, $2OMIu.jsx)($4428e2244acd6367$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement
            }, key))
    });
}

});


parcelRegister("7s5ol", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92b9f53390f6f70$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
const $a92b9f53390f6f70$var$pulseBackground = (0, $f8Sb3.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $a92b9f53390f6f70$var$pulseBackgroundReverse = (0, $f8Sb3.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $a92b9f53390f6f70$var$flashWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animation: `0.25s ease-in-out ${$a92b9f53390f6f70$var$pulseBackgroundReverse}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $a92b9f53390f6f70$var$flashWrapperAnimated = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$a92b9f53390f6f70$var$flashWrapper} & > div`]: {
        animation: `0.25s ease-in-out ${$a92b9f53390f6f70$var$pulseBackground}`
    }
});
class $a92b9f53390f6f70$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: animate ? $a92b9f53390f6f70$var$flashWrapperAnimated : $a92b9f53390f6f70$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args), this.toggle = false;
    }
}

});


parcelRegister("9YhuC", function(module, exports) {

$parcel$export(module.exports, "CommentEditorWithIntl", () => $1f6a75b9646aed6f$export$7b9f3a51cd0c1967);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ci4W = parcelRequire("9ci4W");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $awTmI = parcelRequire("awTmI");

var $8DYpW = parcelRequire("8DYpW");

var $bYYy3 = parcelRequire("bYYy3");

var $4ceoy = parcelRequire("4ceoy");

var $kdDpx = parcelRequire("kdDpx");
parcelRequire("7uhma");
var $cipm3 = parcelRequire("cipm3");

var $iHYdz = parcelRequire("iHYdz");

var $cex0T = parcelRequire("cex0T");

var $3SvBp = parcelRequire("3SvBp");

var $jZLtJ = parcelRequire("jZLtJ");

var $iK9VQ = parcelRequire("iK9VQ");

var $5093p = parcelRequire("5093p");

var $7s5ol = parcelRequire("7s5ol");

var $fBLMg = parcelRequire("fBLMg");
const $1f6a75b9646aed6f$var$CommentEditorMargin = 14;
const $1f6a75b9646aed6f$var$commentEditorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $1f6a75b9646aed6f$var$ContentArea = (0, $jZLtJ.createEditorContentStyle)(/*#__PURE__*/ (0, $f8Sb3.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$1f6a75b9646aed6f$var$CommentEditorMargin - (0, $bYYy3.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $cipm3.tableCommentEditorStyles)));
$1f6a75b9646aed6f$var$ContentArea.displayName = 'ContentArea';
const $1f6a75b9646aed6f$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $1f6a75b9646aed6f$var$appearance = 'comment';
const $1f6a75b9646aed6f$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { mediaState: mediaState, maxContentSizeState: maxContentSizeState, primaryToolbarState: primaryToolbarState, editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(editorAPI, [
        'media',
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ]);
    const intl = (0, $koVbs.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const maxContentSizeReached = Boolean(maxContentSizeState?.maxContentSizeReached);
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $5uXOq.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $5uXOq.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $5uXOq.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $5uXOq.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $5uXOq.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7s5ol.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $1f6a75b9646aed6f$var$commentEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fBLMg.MainToolbar), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kdDpx.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $1f6a75b9646aed6f$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5093p.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $1f6a75b9646aed6f$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $fBLMg.mainToolbarCustomComponentsSlotStyle)(isTwoLineToolbarEnabled)
    }, customPrimaryToolbarComponents))), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cex0T.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($1f6a75b9646aed6f$var$ContentArea, {
            ref: containerElement,
            css: maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('ak-editor-content-area', {
                'less-margin': width < (0, $iHYdz.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewModeState?.mode
        }, customContentComponents && 'before' in customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(customContentComponents.before) : (0, $3SvBp.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iK9VQ.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $1f6a75b9646aed6f$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1f6a75b9646aed6f$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldJSL.default), null, !!onSave && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eCeGD.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $8DYpW.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $8DYpW.default).cancelButton))), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$1f6a75b9646aed6f$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("9ci4W", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("kdDpx", function(module, exports) {

$parcel$export(module.exports, "KeyDownHandlerContext", () => $78f86f420f59a10b$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $78f86f420f59a10b$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3fEIr = parcelRequire("3fEIr");

var $kXnoC = parcelRequire("kXnoC");

var $3AEXe = parcelRequire("3AEXe");

function $78f86f420f59a10b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $78f86f420f59a10b$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $78f86f420f59a10b$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $78f86f420f59a10b$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const selectedItemIndex = (0, $5uXOq.useRef)(0);
    const incrementIndex = (0, $5uXOq.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $5uXOq.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRight = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowLeft = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTab = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = {
        handleArrowLeft: handleArrowLeft,
        handleArrowRight: handleArrowRight,
        handleTab: handleTab
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $3fEIr.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $3AEXe.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: editorAppearance === 'comment' && $78f86f420f59a10b$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $kXnoC.messages).toolbarLabel),
        "aria-controls": (0, $c7748e834fcd4f22$export$b16ce0826b76e795)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($78f86f420f59a10b$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $78f86f420f59a10b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $78f86f420f59a10b$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $78f86f420f59a10b$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}

});
parcelRegister("3fEIr", function(module, exports) {

$parcel$export(module.exports, "GRID_SIZE", () => $e09bdf0cd98bec8e$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $e09bdf0cd98bec8e$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $e09bdf0cd98bec8e$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $e09bdf0cd98bec8e$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $e09bdf0cd98bec8e$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $e09bdf0cd98bec8e$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $e09bdf0cd98bec8e$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $e09bdf0cd98bec8e$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $e09bdf0cd98bec8e$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $e09bdf0cd98bec8e$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $e09bdf0cd98bec8e$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $e09bdf0cd98bec8e$export$6ee360fa4b93ee8e);
const $e09bdf0cd98bec8e$export$bc90872e265d166e = 8;
const $e09bdf0cd98bec8e$export$1f1798e92fa75806 = {
    small: $e09bdf0cd98bec8e$export$bc90872e265d166e * 40,
    medium: $e09bdf0cd98bec8e$export$bc90872e265d166e * 75,
    large: $e09bdf0cd98bec8e$export$bc90872e265d166e * 128
};
const $e09bdf0cd98bec8e$export$69bde1b03e8b5224 = {
    small: $e09bdf0cd98bec8e$export$bc90872e265d166e * 50,
    medium: $e09bdf0cd98bec8e$export$1f1798e92fa75806.medium,
    large: $e09bdf0cd98bec8e$export$1f1798e92fa75806.large
};
const $e09bdf0cd98bec8e$export$780035d9fe48eb32 = `${$e09bdf0cd98bec8e$export$bc90872e265d166e * 25}px`;
const $e09bdf0cd98bec8e$export$95b62a1773aa5ebe = `${$e09bdf0cd98bec8e$export$bc90872e265d166e * 6}px`;
const $e09bdf0cd98bec8e$export$387950d54d372827 = '12px';
const $e09bdf0cd98bec8e$export$51a2d6b2c009fbfd = '54px';
const $e09bdf0cd98bec8e$export$df8bcac60101d466 = '20px';
const $e09bdf0cd98bec8e$export$9a6bb2acef5e644a = 15;
const $e09bdf0cd98bec8e$export$3b8e93b2c0f295b0 = 2;
const $e09bdf0cd98bec8e$export$6d221f35db1b75aa = 60;
const $e09bdf0cd98bec8e$export$ab53450bc5fd5b7d = 10;
const $e09bdf0cd98bec8e$export$6ee360fa4b93ee8e = 'editor-element-browser';

});

const $c7748e834fcd4f22$export$b16ce0826b76e795 = 'ak-editor-textarea';


parcelRegister("7uhma", function(module, exports) {

$parcel$export(module.exports, "tableFullPageEditorStyles", () => (parcelRequire("cipm3")).tableFullPageEditorStyles);
$parcel$export(module.exports, "tableCommentEditorStyles", () => (parcelRequire("cipm3")).tableCommentEditorStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cipm3 = parcelRequire("cipm3");

});
parcelRegister("cipm3", function(module, exports) {

$parcel$export(module.exports, "insertColumnButtonOffset", () => $ba57a0e7ca2009cd$export$af45328890cf2a82);
$parcel$export(module.exports, "tableStyles", () => $ba57a0e7ca2009cd$export$e938d6f191645a3e);
$parcel$export(module.exports, "tableFullPageEditorStyles", () => $ba57a0e7ca2009cd$export$b0d19c9126eaec7a);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $ba57a0e7ca2009cd$export$61a2da566f69d1df);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $6gEe5 = parcelRequire("6gEe5");


var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");


var $VSDnB = parcelRequire("VSDnB");


var $gmhCD = parcelRequire("gmhCD");


var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $MDErT = parcelRequire("MDErT");
const $ba57a0e7ca2009cd$var$cornerControlHeight = (0, $1v4Xe.tableToolbarSize) + 1;
const $ba57a0e7ca2009cd$export$af45328890cf2a82 = (0, $1v4Xe.tableInsertColumnButtonSize) / 2;
const $ba57a0e7ca2009cd$export$cc4d06b9af7cea87 = 44;
const $ba57a0e7ca2009cd$var$rangeSelectionStyles = `
.${(0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $iHYdz.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket,
    (0, $bzmFE.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $ba57a0e7ca2009cd$var$sentinelStyles = `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $1v4Xe.columnControlsDecorationHeight)}px;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $1v4Xe.tableScrollbarOffset) + (0, $1v4Xe.stickyRowOffsetTop) + (0, $1v4Xe.tablePadding) * 2 + 23}px;
  }
  &.${(0, $jecUf.TableCssClassName).WITH_CONTROLS} {
    > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $1v4Xe.columnControlsDecorationHeight)}px;
    }
  }
}`;
const $ba57a0e7ca2009cd$var$stickyScrollbarSentinelStyles = `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
 > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $1v4Xe.columnControlsDecorationHeight) + $ba57a0e7ca2009cd$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $iHYdz.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $ba57a0e7ca2009cd$var$stickyScrollbarContainerStyles = `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $ba57a0e7ca2009cd$var$stickyScrollbarStyles = `${$ba57a0e7ca2009cd$var$stickyScrollbarContainerStyles} ${$ba57a0e7ca2009cd$var$stickyScrollbarSentinelStyles}`;
const $ba57a0e7ca2009cd$var$shadowSentinelStyles = `
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $ba57a0e7ca2009cd$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(">*:not([data-mark-type='fragment']) .", (0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $ba57a0e7ca2009cd$var$viewModeSortStyles = ()=>{
    return (0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? /*#__PURE__*/ (0, $f8Sb3.css)("th{.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}>.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{&:has(.is-active){.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}>.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ":hover)){>.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}}") : /*#__PURE__*/ (0, $f8Sb3.css)("th{.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}&:has(.is-active){.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}&:hover{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}");
};
const $ba57a0e7ca2009cd$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $1v4Xe.tableBorderDeleteColor}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $ba57a0e7ca2009cd$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $jecUf.TableCssClassName).HOVERED_COLUMN, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $ba57a0e7ca2009cd$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    /*
     This is MAGIC!
     This fixes a bug which occurs in firefox when the first row becomes sticky.
     see https://product-fabric.atlassian.net/browse/ED-19177
   */ if ((0, $gE8f9.browser).gecko) return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $ba57a0e7ca2009cd$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $6gEe5.tableSharedStyle)(), ";", (0, $MDErT.columnControlsLineMarker)(), ";", (0, $MDErT.hoveredDeleteButton)(), ";", (0, $MDErT.hoveredCell)(), ";", (0, $MDErT.hoveredWarningCell), ";", (0, $MDErT.insertLine)(), ";", (0, $MDErT.resizeHandle)(), ";", $ba57a0e7ca2009cd$var$rangeSelectionStyles, ";", $ba57a0e7ca2009cd$var$viewModeSortStyles(), ";.", (0, $jecUf.TableCssClassName).LAST_ITEM_IN_CELL, "{margin-bottom:0;}.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, "{td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $jecUf.TableCssClassName).TABLE_CELL, "{background-color:", (0, $1v4Xe.tableCellBackgroundColor), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";border-bottom:1px solid ", (0, $1v4Xe.tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $MDErT.insertColumnButtonWrapper)(), ";}.", (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $MDErT.insertRowButtonWrapper)(), ";}", (0, $MDErT.dragInsertButtonWrapper)(), " ", (0, $MDErT.dragCornerControlButton)(), (0, $MDErT.DeleteButton)(), (0, $VSDnB.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {` : `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {`}
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.stickyRowOffsetTop) : (0, $1v4Xe.stickyRowOffsetTop) + 2}px;
			width: ${0, $iHYdz.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $iHYdz.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $1v4Xe.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		` : `
    	.${(0, $jecUf.TableCssClassName).TABLE_STICKY} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.stickyRowOffsetTop) : (0, $1v4Xe.stickyRowOffsetTop) + 2}px;
			width: ${0, $iHYdz.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $iHYdz.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $1v4Xe.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		`, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $iHYdz.akEditorSmallZIndex), "!important;background:var(--ds-surface, white);width:", (0, $1v4Xe.tableToolbarSize), "px;height:", (0, $1v4Xe.tableToolbarSize), "px;}.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $1v4Xe.tableToolbarSize), "px;width:", (0, $1v4Xe.tableToolbarSize), "px;}", $ba57a0e7ca2009cd$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $ba57a0e7ca2009cd$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).ROW_CONTROLS, " .", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $1v4Xe.tableToolbarSize), "px solid var(--ds-surface, white);margin-left:-", (0, $1v4Xe.tableToolbarSize), "px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, green);}tr.sticky{padding-top:", (0, $1v4Xe.stickyRowOffsetTop), "px;position:fixed;display:grid;z-index:", (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, white);box-sizing:content-box;box-shadow:0 6px 4px -4px ", `var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, ";margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, ".", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $1v4Xe.tableToolbarSize), "px;}", (0, $VSDnB.fg)('nested_table_control_padding_with_css') ? `
		.tableView-content-wrap:has(.tableView-content-wrap):has(.${(0, $jecUf.TableCssClassName).NESTED_TABLE_WITH_CONTROLS}) {
			padding-left: unset;
		}

		.tableView-content-wrap:has(.${(0, $jecUf.TableCssClassName).NESTED_TABLE_WITH_CONTROLS}) {
			padding-left: 15px;
		}
		` : '', " tr.sticky th{border-bottom:", (0, $1v4Xe.stickyHeaderBorderBottomWidth), "px solid ", (0, $1v4Xe.tableBorderColor), ";margin-right:-1px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $ba57a0e7ca2009cd$export$af45328890cf2a82 + 1, "px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).TABLE_STICKY, "{tr.sticky td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, "{.", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $1v4Xe.resizeHandlerAreaWidth) - (0, $1v4Xe.resizeLineWidth)) / 2 + 1, "px;}}tr.sticky td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",tr.sticky th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $jecUf.TableCssClassName).SELECTED_CELL, "{.", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $1v4Xe.resizeHandlerAreaWidth) - (0, $1v4Xe.resizeLineWidth)) / 2, "px;}}}tr.sticky .", (0, $jecUf.TableCssClassName).HOVERED_CELL, ",tr.sticky .", (0, $jecUf.TableCssClassName).SELECTED_CELL, "{z-index:1;}.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $1v4Xe.tableControlsSpacing), "px;}", (0, $VSDnB.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $jecUf.TableCssClassName).WITH_CONTROLS}.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) : (0, $1v4Xe.tableControlsSpacing) + 2}px;
		}
		` : `
		.${(0, $jecUf.TableCssClassName).WITH_CONTROLS}.${(0, $jecUf.TableCssClassName).TABLE_STICKY}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) : (0, $1v4Xe.tableControlsSpacing) + 2}px;
		}
		`, " .", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky{border-top:", (0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) - (0, $1v4Xe.tableToolbarSize) : (0, $1v4Xe.tableControlsSpacing) - (0, $1v4Xe.tableToolbarSize) + 2, "px solid var(--ds-surface, white);}", $ba57a0e7ca2009cd$var$sentinelStyles, " ", (0, $MDErT.OverflowShadow)(props.featureFlags?.tableDragAndDrop), " ", $ba57a0e7ca2009cd$var$stickyScrollbarStyles, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $1v4Xe.tablePadding), "px;.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $1v4Xe.tablePadding), "px;&::after{right:6px!important;}}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:-4px;}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $1v4Xe.tablePadding), "px;}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) + (0, $1v4Xe.tablePadding) - 1, "px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, "{width:", (0, $1v4Xe.tableOverflowShadowWidth), "px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:8px;}.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:calc(100% - 16px);}}>.", (0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $ba57a0e7ca2009cd$var$breakoutWidthStyling(), " ", (0, $MDErT.columnControlsDecoration)(), ";", (0, $MDErT.rowControlsWrapperDotStyle)(), ";.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, "{width:", (0, $1v4Xe.tableToolbarSize) + 1, "px;height:", $ba57a0e7ca2009cd$var$cornerControlHeight, "px;display:none;.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $MDErT.InsertMarker)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky{.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $1v4Xe.tableToolbarSize) + 1, "px;height:", (0, $1v4Xe.tableToolbarSize) + 1, "px;border:1px solid ", (0, $1v4Xe.tableBorderColor), ";border-radius:0;border-top-left-radius:", (0, $1v4Xe.tableBorderRadiusSize), "px;background:", (0, $1v4Xe.tableHeaderCellBackgroundColor), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background:", (0, $1v4Xe.tableToolbarSelectedColor), ";}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ",.", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{width:", (0, $iHYdz.akEditorTableToolbarSize) + (0, $iHYdz.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS, " .", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background:", (0, $1v4Xe.tableToolbarSelectedColor), ";cursor:pointer;}:not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";background:", (0, $1v4Xe.tableToolbarDeleteColor), ";}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS, "{width:", (0, $1v4Xe.tableToolbarSize), "px;box-sizing:border-box;display:none;position:relative;", (0, $MDErT.InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $MDErT.HeaderButton)(`
        border-bottom: 1px solid ${(0, $1v4Xe.tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $1v4Xe.tableToolbarSize)}px;

        .${(0, $jecUf.TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $jecUf.TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $1v4Xe.tableBorderRadiusSize), "px;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, ":hover{z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $VSDnB.fg)('platform_editor_table_column_selected_state_fix') ? (0, $1v4Xe.rowControlsZIndex) + 4 : (0, $iHYdz.akEditorUnitZIndex), ";.", (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS, "{.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{height:24px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $1v4Xe.resizeHandlerZIndex), ";}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:24px;width:100%;}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid ", `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F4F5F7);}&>g>rect{fill:var(--ds-icon-disabled, #BFDBF847);}}}&:not(.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}g{fill:var(--ds-icon-subtle, #626f86);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #579DFF);}g{fill:var(--ds-icon-inverse, #FFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #2684FF);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #579dff);}g{fill:var(--ds-icon-inverse, #fff);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #F87462);}g{fill:var(--ds-border-inverse, #FFF);}}}}}", (0, $MDErT.floatingColumnControls)(), " :not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).ROW_CONTROLS, "{", (0, $MDErT.HeaderButtonHover)(), " ", (0, $MDErT.HeaderButtonDanger)(), ";}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $iHYdz.akEditorTableToolbarSize), "px;top:", ((0, $VSDnB.fg)('platform_editor_number_column_sticky_header_broken') ? props.isDragAndDropEnabled : props.featureFlags?.tableDragAndDrop) || (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true) ? 0 : (0, $iHYdz.akEditorTableToolbarSize), "px;width:", (0, $iHYdz.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $1v4Xe.tableBorderColor), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:10px 2px;text-align:center;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";background-color:", (0, $1v4Xe.tableHeaderCellBackgroundColor), ";color:", (0, $1v4Xe.tableTextColor), ";border-color:", (0, $1v4Xe.tableBorderColor), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}", (0, $VSDnB.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER} {
				.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {` : `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} {
				.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {`}
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				// the extra pixel is accounting for borders
				top: -34px;
				left: -1px;
			}
		}
		` : `
		.${(0, $jecUf.TableCssClassName).TABLE_STICKY} {
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				// the extra pixel is accounting for borders
				top: -34px;
				left: -1px;
			}
		}
		`, " .", (0, $jecUf.TableCssClassName).WITH_CONTROLS, "{.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ",.", (0, $jecUf.TableCssClassName).ROW_CONTROLS, "{display:block;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{border-bottom:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";}}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}}:not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).WITH_CONTROLS, "{.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{border-bottom:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";border-left:0;color:", `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`, ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}}.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "::after,.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $iHYdz.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "{border:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $1v4Xe.tableCellSelectedColor), ";z-index:", (0, $iHYdz.akEditorSmallZIndex), ";}th.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,td.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}td.", (0, $jecUf.TableCssClassName).HOVERED_CELL, ",td.", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $iHYdz.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ba57a0e7ca2009cd$var$tableBorderStyles(), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}&.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ba57a0e7ca2009cd$var$tableBorderStyles(), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}}}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $6gEe5.tableMarginTop), "px;left:-", (0, $1v4Xe.tableToolbarSize) + 1, "px;", (0, $VSDnB.fg)('platform_editor_table_column_selected_state_fix') ? '' : `z-index: ${(0, $1v4Xe.rowControlsZIndex) + 4}`, ";}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled && (0, $VSDnB.fg)('platform_editor_numbered_column_misalignment') ? `
			margin-top: ${0, $6gEe5.tableMarginTop}px;
			top: 0;
			left: -${(0, $1v4Xe.tableToolbarSize) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $6gEe5.tableMarginTop) - $ba57a0e7ca2009cd$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $1v4Xe.tableToolbarSize}px;
		`, ";}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $6gEe5.tableMarginTop), "px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}", (0, $VSDnB.fg)('platform_editor_nested_table_drag_controls') ? `
		.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
			.${(0, $jecUf.TableCssClassName).TABLE_STICKY} .${(0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
				position: absolute;
				z-index: ${0, $iHYdz.akEditorUnitZIndex};
			}
		}
		` : '', " .", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}");
const $ba57a0e7ca2009cd$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", $ba57a0e7ca2009cd$export$9989b31b7900261c(props), ";}.ProseMirror.", (0, $jecUf.TableCssClassName).IS_RESIZING, "{.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $4038285048829feb$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $jecUf.TableCssClassName).RESIZE_CURSOR, "{cursor:col-resize;}", $ba57a0e7ca2009cd$var$shadowSentinelStyles, ";");
const $ba57a0e7ca2009cd$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror .", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $ba57a0e7ca2009cd$export$61a2da566f69d1df = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror .", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $4038285048829feb$export$b2380b18b089518f), ";}");

});
const $f32dbb5556fcfa26$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $f32dbb5556fcfa26$export$fb5c0ba8f0806db1 = 'is-disabled';
const $f32dbb5556fcfa26$export$665a01df2c44393a = 'data-sort-index';

parcelRegister("MDErT", function(module, exports) {

$parcel$export(module.exports, "InsertMarker", () => $d31b53cc0f00ae8f$export$22ce45ffbca2b768);
$parcel$export(module.exports, "HeaderButton", () => $d31b53cc0f00ae8f$export$c7c73467b57835d);
$parcel$export(module.exports, "HeaderButtonHover", () => $d31b53cc0f00ae8f$export$eb5435fbd56e8d4);
$parcel$export(module.exports, "HeaderButtonDanger", () => $d31b53cc0f00ae8f$export$7f243984d41e6570);
$parcel$export(module.exports, "dragInsertButtonWrapper", () => $d31b53cc0f00ae8f$export$cfa9a9cdd25b9d6e);
$parcel$export(module.exports, "dragCornerControlButton", () => $d31b53cc0f00ae8f$export$6134f9ac8c9f161f);
$parcel$export(module.exports, "insertColumnButtonWrapper", () => $d31b53cc0f00ae8f$export$d9daf73b486785b9);
$parcel$export(module.exports, "insertRowButtonWrapper", () => $d31b53cc0f00ae8f$export$595c9c01d7c39885);
$parcel$export(module.exports, "columnControlsLineMarker", () => $d31b53cc0f00ae8f$export$6114ba9f95ca48dc);
$parcel$export(module.exports, "DeleteButton", () => $d31b53cc0f00ae8f$export$d6f68d0fe29f8050);
$parcel$export(module.exports, "OverflowShadow", () => $d31b53cc0f00ae8f$export$f802e22253ad2b2c);
$parcel$export(module.exports, "floatingColumnControls", () => $d31b53cc0f00ae8f$export$125caa90718a4ea9);
$parcel$export(module.exports, "rowControlsWrapperDotStyle", () => $d31b53cc0f00ae8f$export$a2258906ae78ec82);
$parcel$export(module.exports, "columnControlsDecoration", () => $d31b53cc0f00ae8f$export$8c8180e74f25db6a);
$parcel$export(module.exports, "hoveredDeleteButton", () => $d31b53cc0f00ae8f$export$4d63bf225990ad34);
$parcel$export(module.exports, "hoveredCell", () => $d31b53cc0f00ae8f$export$1c46f5412a5a3ae0);
$parcel$export(module.exports, "hoveredWarningCell", () => $d31b53cc0f00ae8f$export$40edb32b62e4fb85);
$parcel$export(module.exports, "resizeHandle", () => $d31b53cc0f00ae8f$export$8e36b812ea421d73);
$parcel$export(module.exports, "insertLine", () => $d31b53cc0f00ae8f$export$b9932a52fb1c7aad);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
const $d31b53cc0f00ae8f$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE, "{background:", (0, $1v4Xe.tableBorderSelectedColor), ";display:none;position:absolute;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";", cssString, ";}");
const $d31b53cc0f00ae8f$var$Marker = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $1v4Xe.tableBorderColor),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $1v4Xe.lineMarkerSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $1v4Xe.lineMarkerSize)}px`,
        borderRadius: '50%',
        pointerEvents: 'none'
    });
const $d31b53cc0f00ae8f$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_MARKER, "{", $d31b53cc0f00ae8f$var$Marker(), ";", cssString, ";}");
const $d31b53cc0f00ae8f$var$Button = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)("border-radius:var(--ds-border-radius, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $d31b53cc0f00ae8f$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{background:", (0, $1v4Xe.tableHeaderCellBackgroundColor), ";border:1px solid ", (0, $1v4Xe.tableBorderColor), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{color:", `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";}");
const $d31b53cc0f00ae8f$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, ":hover{color:", `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";cursor:pointer;}");
const $d31b53cc0f00ae8f$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}");
const $d31b53cc0f00ae8f$var$InsertButton = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $iHYdz.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON, "{height:", (0, $1v4Xe.tableInsertColumnButtonSize), "px;width:", (0, $1v4Xe.tableInsertColumnButtonSize), "px;}.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};
      color: ${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};
    `), ";}.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE, "{display:flex;}");
const $d31b53cc0f00ae8f$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $d31b53cc0f00ae8f$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $iHYdz.akEditorUnitZIndex) + 10, ";}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, $1v4Xe.dragTableInsertColumnButtonSize)}px;
    width: ${(0, $1v4Xe.dragTableInsertColumnButtonSize)}px;
  `), ";}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";border:1px solid ", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $d31b53cc0f00ae8f$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $iHYdz.akEditorUnitZIndex) * 99, ";&.active .", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #0C66E4);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFF);background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);border-radius:2px;width:5px;height:5px;position:relative;}");
const $d31b53cc0f00ae8f$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $d31b53cc0f00ae8f$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertLine(`
    height: 2px;
    top: -11px;
	${''}
    left: ${(0, $1v4Xe.tableInsertColumnButtonSize) - 1}px;
  `));
const $d31b53cc0f00ae8f$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $d31b53cc0f00ae8f$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON, "{height:", (0, $1v4Xe.tableDeleteButtonSize), "px;width:", (0, $1v4Xe.tableDeleteButtonSize), "px;}.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
        background: ${(0, $1v4Xe.tableCellSelectedDeleteIconBackground)};
        color: ${(0, $1v4Xe.tableCellSelectedDeleteIconColor)};
      `), ";}}.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $1v4Xe.tableCellHoverDeleteIconBackground), ";color:", (0, $1v4Xe.tableCellHoverDeleteIconColor), ";cursor:pointer;}");
const $d31b53cc0f00ae8f$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $6gEe5.tableMarginTop), "px;z-index:", (0, $iHYdz.akEditorShadowZIndex), ";width:", (0, $1v4Xe.tableOverflowShadowWidthWide), "px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto left,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, ").", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto right,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto left,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:calc(100% - ", (0, $1v4Xe.tableOverflowShadowWidthWide), "px);}.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, "{", $d31b53cc0f00ae8f$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}");
const $d31b53cc0f00ae8f$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, $6gEe5.tableMarginTopWithControl), "px);top:", (0, $6gEe5.tableMarginTopWithControl), "px;}");
};
const $d31b53cc0f00ae8f$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $1v4Xe.tableHeaderCellBackgroundColor),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $d31b53cc0f00ae8f$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $1v4Xe.tableToolbarSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $1v4Xe.tableBorderSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $1v4Xe.columnControlsSelectedZIndex)
    });
const $d31b53cc0f00ae8f$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("tr th:last-child .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $1v4Xe.tableBorderColor), ";position:absolute;height:", (0, $1v4Xe.lineMarkerSize), "px;width:", (0, $1v4Xe.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $d31b53cc0f00ae8f$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $d31b53cc0f00ae8f$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("div.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, ">.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, ">.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $1v4Xe.tableBorderColor), ";position:absolute;height:", (0, $1v4Xe.lineMarkerSize), "px;width:", (0, $1v4Xe.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;right:-1px;}");
};
const $d31b53cc0f00ae8f$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $1v4Xe.columnControlsDecorationHeight) + (0, $6gEe5.tableCellBorderWidth), "px;height:", (0, $1v4Xe.columnControlsDecorationHeight), "px;&::before{content:' ';background-color:", (0, $1v4Xe.tableBorderColor), ";position:absolute;height:", (0, $1v4Xe.lineMarkerSize), "px;width:", (0, $1v4Xe.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $d31b53cc0f00ae8f$var$columnHeaderButton(`
        border-right: ${(0, $6gEe5.tableCellBorderWidth)}px solid ${(0, $1v4Xe.tableBorderColor)};
        border-top: ${(0, $6gEe5.tableCellBorderWidth)}px solid ${(0, $1v4Xe.tableBorderColor)};
        border-bottom: ${(0, $6gEe5.tableCellBorderWidth)}px solid ${(0, $1v4Xe.tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, $1v4Xe.tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $1v4Xe.columnControlsDecorationHeight) - (0, $1v4Xe.tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, $1v4Xe.columnControlsZIndex)};
      `), ";}}", $d31b53cc0f00ae8f$var$getFloatingDotOverrides(), " .", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $jecUf.TableCssClassName).HOVERED_TABLE, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}&.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $jecUf.TableCssClassName).HOVERED_COLUMN, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";border-left:", (0, $6gEe5.tableCellBorderWidth), "px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";left:-", (0, $6gEe5.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).HOVERED_COLUMN, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}&.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";border-left:", (0, $6gEe5.tableCellBorderWidth), "px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";left:-", (0, $6gEe5.tableCellBorderWidth), "px;z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}}}.", (0, $jecUf.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",.", (0, $jecUf.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}}");
};
const $d31b53cc0f00ae8f$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON, "{.", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",.", (0, $jecUf.TableCssClassName).HOVERED_CELL, "{border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";}.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";}th.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";}}}");
const $d31b53cc0f00ae8f$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(":not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON, "){.", (0, $jecUf.TableCssClassName).HOVERED_CELL, "{position:relative;border:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";}.", (0, $jecUf.TableCssClassName).HOVERED_CELL, ".", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}");
const $d31b53cc0f00ae8f$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $f8Sb3.css)(":not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON, "){td.", (0, $jecUf.TableCssClassName).HOVERED_CELL_WARNING, "{background-color:", `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`, "!important;border:1px solid ", `var(--ds-border-warning, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)})`, ";}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $d31b53cc0f00ae8f$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("th.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}th.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + ", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;}td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + ", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;}");
};
const $d31b53cc0f00ae8f$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{.", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $1v4Xe.resizeHandlerAreaWidth), "px;height:100%;top:0;right:-", (0, $1v4Xe.resizeHandlerAreaWidth) / 2, "px;cursor:col-resize;z-index:", (0, $1v4Xe.resizeHandlerZIndex), ";}tr th:last-child .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $1v4Xe.resizeHandlerAreaWidth) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $1v4Xe.resizeHandlerZIndex), ";}", $d31b53cc0f00ae8f$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;height:calc(100% + ", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $6gEe5.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $1v4Xe.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $1v4Xe.columnControlsZIndex) * 2
});
const $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $1v4Xe.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $6gEe5.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $1v4Xe.columnControlsZIndex) * 2
});
const $d31b53cc0f00ae8f$var$insertLineActiveColor = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $1v4Xe.tableBorderSelectedColor)
});
const $d31b53cc0f00ae8f$var$insertLineInactiveColor = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`
});
const $d31b53cc0f00ae8f$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{td.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}}");

});



parcelRegister("cex0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $78865ac916ce418a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $a3qhX = parcelRequire("a3qhX");
function $78865ac916ce418a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $78865ac916ce418a$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $78865ac916ce418a$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $a3qhX.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $78865ac916ce418a$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children));
};
var $78865ac916ce418a$export$2e2bcd8739ae039 = $78865ac916ce418a$export$68468c5dbde37b99;

});
parcelRegister("a3qhX", function(module, exports) {

$parcel$export(module.exports, "clickAreaClickHandler", () => $78b1133e759b60f6$export$28b64e3e5a38e8a2);

var $3I3CN = parcelRequire("3I3CN");

var $jNU25 = parcelRequire("jNU25");

var $5Vvw4 = parcelRequire("5Vvw4");

var $eQcNy = parcelRequire("eQcNy");

var $VSDnB = parcelRequire("VSDnB");

var $3SvBp = parcelRequire("3SvBp");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $78b1133e759b60f6$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $78b1133e759b60f6$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $78b1133e759b60f6$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $78b1133e759b60f6$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $78b1133e759b60f6$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $78b1133e759b60f6$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $eQcNy.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $eQcNy.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $eQcNy.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = (0, $VSDnB.fg)('platform_editor_keep_focus_on_content_comp_clicks') ? target?.parentElement?.closest(`[${(0, $3SvBp.ignoreAttribute)}]`) : !!(0, $eQcNy.closestElement)(target, `[${(0, $3SvBp.ignoreAttribute)}]`) || target?.getAttribute((0, $3SvBp.ignoreAttribute)) === 'true';
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $eQcNy.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $eQcNy.closestElement)(target, 'div[offset]'));
    const isButtonClicked = Boolean((0, $eQcNy.closestElement)(event.currentTarget, 'button')) || Boolean((0, $eQcNy.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON';
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $78b1133e759b60f6$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $78b1133e759b60f6$export$c5a7a653c4681bfd(view, event);
};
const $78b1133e759b60f6$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $jNU25.addParagraphAtEnd)(tr);
    }
    (0, $5Vvw4.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $3I3CN.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};

});
parcelRegister("jNU25", function(module, exports) {

$parcel$export(module.exports, "addParagraphAtEnd", () => $2372cedf5b014ac0$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $2372cedf5b014ac0$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $2372cedf5b014ac0$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $2372cedf5b014ac0$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $2372cedf5b014ac0$export$72d6145976985e8c);
$parcel$export(module.exports, "findCutBefore", () => $2372cedf5b014ac0$export$ad1078cb3917e860);

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $93WYh = parcelRequire("93WYh");
function $2372cedf5b014ac0$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $2372cedf5b014ac0$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $2372cedf5b014ac0$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $2372cedf5b014ac0$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $2372cedf5b014ac0$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $2372cedf5b014ac0$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $2372cedf5b014ac0$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $2372cedf5b014ac0$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $hFEwm.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $2372cedf5b014ac0$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $gZGBX.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $2372cedf5b014ac0$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $2372cedf5b014ac0$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $hFEwm.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("93WYh", function(module, exports) {

$parcel$export(module.exports, "insertBlock", () => $0e69bbce5359b325$export$f51280337625031);

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");
const $0e69bbce5359b325$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $5r0mK.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});


parcelRegister("5Vvw4", function(module, exports) {

$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $d7ff16845adf5723$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $d7ff16845adf5723$export$44fdd7840a0a11f2);

var $gZGBX = parcelRequire("gZGBX");

var $hPjvp = parcelRequire("hPjvp");

var $2xQXF = parcelRequire("2xQXF");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $d7ff16845adf5723$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $hPjvp.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT;
            let position;
            if (side === (0, $hPjvp.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $d7ff16845adf5723$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $d7ff16845adf5723$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $hPjvp.Side).LEFT ? (0, $2xQXF.isValidTargetNode)($pos.nodeAfter) : (0, $2xQXF.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $hPjvp.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $hPjvp.GapCursorSelection)) tr.setSelection((0, $gZGBX.Selection).near($pos));
        else tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $gZGBX.Selection).findFrom($pos, cursorCoords.side === (0, $hPjvp.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $d7ff16845adf5723$export$44fdd7840a0a11f2 = (position, side = (0, $hPjvp.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $hPjvp.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});
parcelRegister("hPjvp", function(module, exports) {

$parcel$export(module.exports, "Side", () => $b20495f9cc03905d$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $b20495f9cc03905d$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $b20495f9cc03905d$export$7d98c58ca1423246);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $2xQXF = parcelRequire("2xQXF");
var $b20495f9cc03905d$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $b20495f9cc03905d$export$d9f9f34e18094ffd = 'gapcursor';
class $b20495f9cc03905d$export$7d98c58ca1423246 extends (0, $gZGBX.Selection) {
    /**
	 * Construct a GapCursorSelection
	 * @param {ResolvedPos} $pos resolved position
	 * @param {Side} side side where the gap cursor is drawn
	 */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side, this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $2xQXF.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $2xQXF.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos)) return new $b20495f9cc03905d$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $b20495f9cc03905d$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos, this.side) : (0, $gZGBX.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $b20495f9cc03905d$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $kCV8T.Slice).empty;
    }
    getBookmark() {
        return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $b20495f9cc03905d$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $gZGBX.Selection).jsonID($b20495f9cc03905d$export$d9f9f34e18094ffd, $b20495f9cc03905d$export$7d98c58ca1423246);
class $b20495f9cc03905d$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos) : (0, $gZGBX.Selection).near($pos);
    }
}

});
parcelRegister("2xQXF", function(module, exports) {

$parcel$export(module.exports, "isValidTargetNode", () => $2d159bb5ec0bb7a6$export$b485b49b5e1715ef);

var $3jyjs = parcelRequire("3jyjs");
const $2d159bb5ec0bb7a6$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $3jyjs.isIgnored)(node);
};

});
parcelRegister("3jyjs", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $48a4afee3b713705$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $48a4afee3b713705$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $48a4afee3b713705$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $48a4afee3b713705$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});




parcelRegister("3SvBp", function(module, exports) {

$parcel$export(module.exports, "ignoreAttribute", () => $88975c433721924a$export$72d101e93c081651);
$parcel$export(module.exports, "contentComponentClickWrapper", () => $88975c433721924a$export$57a965c23051130d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $88975c433721924a$export$72d101e93c081651 = 'data-editor-content-component';
const $88975c433721924a$export$57a965c23051130d = (reactComponents)=>{
    if (!(0, $VSDnB.fg)('platform_editor_content_component_ignore_click')) return reactComponents;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};

});



parcelRegister("5093p", function(module, exports) {

$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $c2315883ffd82628$export$6bb21858343ac39d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1v3g5 = parcelRequire("1v3g5");

var $kXC89 = parcelRequire("kXC89");

var $iHYdz = parcelRequire("iHYdz");

var $gJlZe = parcelRequire("gJlZe");

var $5j6KQ = parcelRequire("5j6KQ");

var $9CMqB = parcelRequire("9CMqB");

var $9Bsv7 = parcelRequire("9Bsv7");

var $9Hbxn = parcelRequire("9Hbxn");
const $c2315883ffd82628$var$toolbar = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        gridColumn: '1 / 2',
        gridRow: 2,
        width: 'calc(100% - 30px)',
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $c2315883ffd82628$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(undefined);
    const elementWidth = (0, $9CMqB.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $1v3g5.isSSR)() && (0, $5j6KQ.isFullPage)(props.appearance) ? (0, $kXC89.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $9Hbxn.widthToToolbarSize)(width || elementWidth, props.appearance);
    const toolbarStyle = (0, $5uXOq.useMemo)(()=>{
        const toolbarWidth = (0, $5j6KQ.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $kXC89.ToolbarSize).S : (0, $kXC89.ToolbarSize).M;
        const toolbarMinWidth = (0, $9Hbxn.toolbarSizeToWidth)(toolbarWidth, props.appearance);
        const minWidth = `min-width: ${props.hasMinWidth ? toolbarMinWidth : '254'}px`;
        return [
            $c2315883ffd82628$var$toolbar,
            minWidth
        ];
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: toolbarStyle
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Bsv7.Toolbar), {
        ...props,
        toolbarSize: toolbarSize
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref
    })));
};

});
parcelRegister("5j6KQ", function(module, exports) {

$parcel$export(module.exports, "isFullPage", () => $5d5227b0967d81cf$export$2800a15841f40ad7);
function $5d5227b0967d81cf$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("9CMqB", function(module, exports) {

$parcel$export(module.exports, "useElementWidth", () => $e59cb6bcde959be1$export$1217913212f99c7);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $e59cb6bcde959be1$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!skip && ref.current && !(0, $VSDnB.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("9Bsv7", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $8c0c376ea2e85785$export$4c260019440d418f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kXC89 = parcelRequire("kXC89");

var $6bmop = parcelRequire("6bmop");
const $8c0c376ea2e85785$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6bmop.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $kXC89.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};

});
parcelRegister("6bmop", function(module, exports) {

$parcel$export(module.exports, "ToolbarInner", () => $80b700b8d431b480$export$7c77e89663c6a665);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ajpes = parcelRequire("ajpes");

var $1v3g5 = parcelRequire("1v3g5");

var $iHYdz = parcelRequire("iHYdz");
const $80b700b8d431b480$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $80b700b8d431b480$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $1v3g5.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $80b700b8d431b480$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(element, {
                key: key
            });
        }));
    }
}

});


parcelRegister("9Hbxn", function(module, exports) {

$parcel$export(module.exports, "toolbarSizeToWidth", () => $5ee4a44c812606dd$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $5ee4a44c812606dd$export$886398ab6922a80f);

var $kXC89 = parcelRequire("kXC89");

var $VSDnB = parcelRequire("VSDnB");

var $5j6KQ = parcelRequire("5j6KQ");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $5ee4a44c812606dd$var$toolbarSizesFullPageNext = [
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $5ee4a44c812606dd$var$toolbarSizesFullPage = [
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
const $5ee4a44c812606dd$var$toolbarSizesNext = [
    {
        width: (0, $kXC89.ToolbarWidthsNext).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $5ee4a44c812606dd$var$toolbarSizes = [
    {
        width: (0, $kXC89.ToolbarWidths).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidths).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidths).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidths).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidths).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
const $5ee4a44c812606dd$var$toolbarSizesForAppearance = (appearance)=>(0, $5j6KQ.isFullPage)(appearance) ? (0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes') ? $5ee4a44c812606dd$var$toolbarSizesFullPageNext : $5ee4a44c812606dd$var$toolbarSizesFullPage : (0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes') ? $5ee4a44c812606dd$var$toolbarSizesNext : $5ee4a44c812606dd$var$toolbarSizes;
const $5ee4a44c812606dd$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($5ee4a44c812606dd$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $kXC89.ToolbarWidths).S
    }).width;
};
const $5ee4a44c812606dd$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($5ee4a44c812606dd$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $kXC89.ToolbarSize).XXXS
    }).size;
};

});


parcelRegister("fBLMg", function(module, exports) {

$parcel$export(module.exports, "MainToolbar", () => $1a03e2eb8d62ff43$export$f7e5e5a2fbd99270);
$parcel$export(module.exports, "mainToolbarCustomComponentsSlotStyle", () => $1a03e2eb8d62ff43$export$a9324f11be65944);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
/* eslint-disable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ (0, $f8Sb3.css)("position:relative;align-items:center;padding:var(--ds-space-100, 8px) var(--ds-space-100, 8px) 0;display:flex;height:auto;background-color:var(--ds-surface, white);box-shadow:none;padding-left:var(--ds-space-250, 20px);&>div{", isTwoLineEditorToolbar && `
        @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
          flex-direction: column-reverse;
          align-items: end;
          display: flex;
          justify-content: flex-end;
        }

        //make this more explicit for a toolbar
        > *:nth-child(1) {
          @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
            > div:nth-child(2) {
              justify-content: flex-end;
              display: flex;
            }
          }
        }
    `, ";>:first-child:not(style),>style:first-child+*{margin-left:0;}}.block-type-btn{padding-left:0;}", (0, $VSDnB.fg)('platform-visual-refresh-icons') && 'span svg { max-width: 100%; }', ";");
/* eslint-enable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $1a03e2eb8d62ff43$var$stickyToolbarWrapperStyle = /*#__PURE__*/ (0, $f8Sb3.css)("position:relative;position:sticky;padding-bottom:var(--ds-space-100, 8px);z-index:", (0, $iHYdz.akEditorMenuZIndex), ";transition:box-shadow ease-in-out 0.2s;&.show-keyline{box-shadow:0 ", (0, $iHYdz.akEditorToolbarKeylineHeight), "px 0 0 var(--ds-background-accent-gray-subtlest, #F1F2F4);}");
const $1a03e2eb8d62ff43$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $5uXOq.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $5uXOq.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
            $1a03e2eb8d62ff43$var$stickyToolbarWrapperStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $1a03e2eb8d62ff43$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $1a03e2eb8d62ff43$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $1a03e2eb8d62ff43$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $f8Sb3.jsx)($1a03e2eb8d62ff43$var$StickyToolbar, {
        ...$1a03e2eb8d62ff43$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($1a03e2eb8d62ff43$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
};
const $1a03e2eb8d62ff43$export$a9324f11be65944 = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $f8Sb3.css)("display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);>div{display:flex;flex-shrink:0;}", isTwoLineEditorToolbar && `
    @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
      {
        padding-right: 0;
      }
    }
  `, ";");

});


parcelRegister("kuVsL", function(module, exports) {

$parcel$export(module.exports, "FullPageEditor", () => $4ddf5ad19e1c12c5$export$a15423dd96de66f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $awTmI = parcelRequire("awTmI");

var $DXgOv = parcelRequire("DXgOv");

var $9LY0t = parcelRequire("9LY0t");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $1YV33 = parcelRequire("1YV33");

var $eMbnU = parcelRequire("eMbnU");

var $cOyi5 = parcelRequire("cOyi5");

var $2mrTE = parcelRequire("2mrTE");
function $4ddf5ad19e1c12c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4ddf5ad19e1c12c5$var$useShowKeyline = (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: (0, $gE8f9.browser).safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $4ddf5ad19e1c12c5$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $4ddf5ad19e1c12c5$export$a15423dd96de66f2 = (props)=>{
    const wrapperElementRef = (0, $5uXOq.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $5uXOq.useRef)(null);
    const showKeyline = $4ddf5ad19e1c12c5$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const { editorViewModeState: editorViewModeState, primaryToolbarState: primaryToolbarState, interactionState: interactionState } = (0, $awTmI.useSharedPluginState)(editorAPI, [
        'editorViewMode',
        'primaryToolbar',
        'interaction'
    ]);
    const viewMode = (0, $cOyi5.getEditorViewMode)(editorViewModeState, props.preset);
    let toolbarDocking = (0, $9LY0t.useSharedPluginStateSelector)(editorAPI, 'selectionToolbar.toolbarDocking');
    if (!toolbarDocking && (0, $VSDnB.fg)('platform_editor_controls_toolbar_ssr_fix')) {
        // This is a workaround for the rendering issue with the selection toolbar
        // where using useSharedPluginStateSelector or useSharedPluginState the state are not
        // available when the editor is first loaded. and cause the toolbar to blink.
        const defaultDocking = props.__livePage ? 'none' : 'top';
        toolbarDocking = editorAPI?.selectionToolbar?.sharedState.currentState()?.toolbarDocking ?? defaultDocking;
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = (0, $VSDnB.fg)('platform_editor_sync_editor_view_mode_state') ? viewMode === 'view' : editorViewModeState?.mode === 'view';
    if (props.__livePage && !(0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control')) {
        // the custom toolbar logic should only be applied when the experiment cohort is not control,
        // and the editor is in live page mode.
        if (!editorViewModeState) // when first loading the editor, the toolbar should be hidden for all content modes
        // the editorViewMode plugin state is not able to be relied as it will not be setup when
        // the appearance component is being rendered.
        // In this case we set the toolbar to be hidden by default.
        isEditorToolbarHidden = true;
        else if ((0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'initially-hide-toolbar')) // for the initially-hide-toolbar variant, the toolbar should be hidden based on
        // a separate flag in the editorViewMode plugin state.
        isEditorToolbarHidden = !editorViewModeState._showTopToolbar || false;
    }
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $VSDnB.fg)('platform_editor_controls_toolbar_ssr_fix')) {
            if (toolbarDocking === 'none') {
                primaryToolbarComponents = [];
                if (!$4ddf5ad19e1c12c5$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else {
            if (toolbarDocking !== 'top') primaryToolbarComponents = [];
            if (!primaryToolbarComponents?.length && !$4ddf5ad19e1c12c5$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $DXgOv.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $2mrTE.fullPageEditorWrapper),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, !(0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control') && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $4ddf5ad19e1c12c5$var$hiddenStyle,
        "data-hidden": isEditorToolbarHidden
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eMbnU.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    })), (0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control') && !isEditorToolbarHidden && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eMbnU.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1YV33.FullPageContentArea), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: editorViewModeState?.mode,
        hasHadInteraction: interactionState?.hasHadInteraction
    })));
};
const $4ddf5ad19e1c12c5$var$hiddenStyle = {
    name: "ra1wi3",
    styles: "visibility:visible;opacity:1;transition:200ms opacity, 200ms visibility, 200ms transform;&[data-hidden=\"true\"]{height:0;visibility:hidden;opacity:0;}"
};

});
parcelRegister("DXgOv", function(module, exports) {

$parcel$export(module.exports, "ContextPanelWidthProvider", () => $7236ed0b18c0a994$export$ba19517e2c08f4aa);
$parcel$export(module.exports, "ContextPanelConsumer", () => $7236ed0b18c0a994$export$24734d8d7782a3fc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $7236ed0b18c0a994$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $7236ed0b18c0a994$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.state = {
            width: 0,
            positionedOverEditor: false
        }, this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        }, this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7236ed0b18c0a994$export$e38af27e662e9783, {
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
}
const { Provider: $7236ed0b18c0a994$export$e38af27e662e9783, Consumer: $7236ed0b18c0a994$export$24734d8d7782a3fc } = $7236ed0b18c0a994$export$c174a7dc96b2afb8;

});

parcelRegister("9LY0t", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginStateSelector", () => $3103cc59045a29ce$export$feb16861fe41d066);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $ajpes = parcelRequire("ajpes");

var $lra7E = parcelRequire("lra7E");
function $3103cc59045a29ce$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $5uXOq.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || properties?.length === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(pluginState?.[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $5uXOq.useMemo)(()=>{
        const [pluginName] = plugin.split('.');
        return [
            pluginName
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $5uXOq.useMemo)(()=>{
        if (options.disabled) return;
        const [pluginName] = plugin.split('.');
        return transformer({
            [`${pluginName}State`]: api?.[pluginName]?.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $3103cc59045a29ce$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
function $3103cc59045a29ce$var$useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $5uXOq.useState)(initialState);
    (0, $lra7E.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(transformedValue, selectedPluginState)) setSelectedPluginState(transformedValue);
    }, options);
    return selectedPluginState;
}

});
parcelRegister("lra7E", function(module, exports) {

$parcel$export(module.exports, "usePluginStateEffect", () => $8bf04bed6d22b818$export$85f3fdc261c569b3);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $gmhCD = parcelRequire("gmhCD");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $8bf04bed6d22b818$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $8bf04bed6d22b818$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>plugins, []);
}
function $8bf04bed6d22b818$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $8bf04bed6d22b818$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $5uXOq.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $8bf04bed6d22b818$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $8bf04bed6d22b818$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $5uXOq.useRef)();
    const cleanup = (0, $5uXOq.useRef)();
    const latestEffect = (0, $5uXOq.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled || (0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', false)) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (options.disabled || (0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', true)) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $8bf04bed6d22b818$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}

});


parcelRegister("1YV33", function(module, exports) {

$parcel$export(module.exports, "FullPageContentArea", () => $0c715cb9d6308084$export$7db1e8e055ebd208);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
var $g0wej = parcelRequire("g0wej");

var $9ci4W = parcelRequire("9ci4W");

var $8RXs9 = parcelRequire("8RXs9");

var $kXnoC = parcelRequire("kXnoC");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $cex0T = parcelRequire("cex0T");

var $3SvBp = parcelRequire("3SvBp");

var $hMZun = parcelRequire("hMZun");

var $iK9VQ = parcelRequire("iK9VQ");

var $2mrTE = parcelRequire("2mrTE");
const $0c715cb9d6308084$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $0c715cb9d6308084$export$5c151fe82051a1a7 = 'ak-editor-container';
const $0c715cb9d6308084$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const theme = (0, $g0wej.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const scrollContainerRef = (0, $5uXOq.useRef)(null);
    const contentAreaRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    let interactionClassName;
    if (props.hasHadInteraction !== undefined && (0, $VSDnB.fg)('platform_editor_no_selection_until_interaction')) interactionClassName = props.hasHadInteraction ? 'ak-editor-has-interaction' : 'ak-editor-no-interaction';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $2mrTE.contentArea),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control') && props.isEditorToolbarHidden && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $2mrTE.contentAreaHeightNoToolbar)
        ],
        "data-testid": $0c715cb9d6308084$export$81adcdb8b9fca1f7,
        ref: containerRef,
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: !(0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control') && props.isEditorToolbarHidden ? 'ak-editor-content-area-no-toolbar' : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $2mrTE.contentAreaWrapper),
        "data-testid": $0c715cb9d6308084$export$5c151fe82051a1a7,
        "data-editor-container": 'true'
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2mrTE.ScrollContainer), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cex0T.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            ...(0, $2mrTE.editorContentAreaStyle)({
                fullWidthMode: fullWidthMode,
                layoutMaxWidth: theme.layoutMaxWidth,
                isEditorToolbarHidden: props.isEditorToolbarHidden
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $VSDnB.fg)('platform_editor_lcm_styling_uplift') ? 'ak-editor-content-area-region' : undefined,
        "data-editor-editable-content": true,
        "data-editor-primary-toolbar-hidden": props.isEditorToolbarHidden && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 'true' : undefined,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $kXnoC.messages).editableContentLabel),
        ref: contentAreaRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $2mrTE.editorContentGutterStyle)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $VSDnB.fg)('platform_editor_no_selection_until_interaction') ? (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('ak-editor-content-area', 'appearance-full-page', interactionClassName, {
            'fabric-editor--full-width-mode': fullWidthMode
        }) : [
            'ak-editor-content-area',
            'appearance-full-page',
            fullWidthMode ? 'fabric-editor--full-width-mode' : ''
        ].join(' '),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $3SvBp.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iK9VQ.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(props.customContentComponents.after) : null))))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $2mrTE.sidebarArea)
    }, props.contextPanel || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hMZun.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $0c715cb9d6308084$export$7db1e8e055ebd208 = (0, $8RXs9.default)($0c715cb9d6308084$var$Content, {
    forwardRef: true
});

});
parcelRegister("hMZun", function(module, exports) {

$parcel$export(module.exports, "ContextPanel", () => $38c4a2495ec84d05$export$c174a7dc96b2afb8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ahdj0 = parcelRequire("ahdj0");

var $awTmI = parcelRequire("awTmI");

var $DXgOv = parcelRequire("DXgOv");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
function $38c4a2495ec84d05$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $38c4a2495ec84d05$var$ANIM_SPEED_MS = 500;
const $38c4a2495ec84d05$var$panelHidden = {
    name: "k2uqvh",
    styles: "width:0"
};
const $38c4a2495ec84d05$export$21f42ab9b6679f44 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $iHYdz.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$38c4a2495ec84d05$var$ANIM_SPEED_MS}ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #091E4224)"}`
});
const $38c4a2495ec84d05$var$disablePanelAnimation = {
    name: "1wx2bp",
    styles: "transition:none"
};
const $38c4a2495ec84d05$export$a7db06668cad9adb = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $iHYdz.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
const $38c4a2495ec84d05$var$paddingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`
});
class $38c4a2495ec84d05$export$2aac880ec6fe2608 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $iHYdz.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        const customPanelWidthStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${this.props.customWidth}px`,
            overflowX: 'hidden'
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $DXgOv.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: [
                    $38c4a2495ec84d05$export$21f42ab9b6679f44,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $38c4a2495ec84d05$var$panelHidden,
                    (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') && $38c4a2495ec84d05$var$disablePanelAnimation
                ],
                "data-testid": "context-panel-panel",
                "aria-labelledby": "context-panel-title",
                role: "dialog"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                "data-testid": "context-panel-content",
                css: [
                    $38c4a2495ec84d05$export$a7db06668cad9adb,
                    hasPadding && $38c4a2495ec84d05$var$paddingStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $38c4a2495ec84d05$var$panelHidden,
                    (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') && $38c4a2495ec84d05$var$disablePanelAnimation
                ]
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args), this.state = {
            mounted: false,
            currentPluginContent: undefined
        }, this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        }, this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const animSpeedMs = (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') ? 0 : $38c4a2495ec84d05$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ahdj0.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: ()=>this.unsetPluginContent()
            }, currentPluginContent);
        }, this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            const animSpeedMs = (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') ? 0 : $38c4a2495ec84d05$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ahdj0.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
function $38c4a2495ec84d05$export$c174a7dc96b2afb8(props) {
    const { contextPanelState: contextPanelState } = (0, $awTmI.useSharedPluginState)(props.editorAPI, [
        'contextPanel'
    ]);
    const firstContent = contextPanelState && contextPanelState?.contents?.find(Boolean);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)($38c4a2495ec84d05$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    }));
}

});

parcelRegister("2mrTE", function(module, exports) {

$parcel$export(module.exports, "fullPageEditorWrapper", () => $2ea8babea89be1bc$export$ffbc962f588258d5);
$parcel$export(module.exports, "ScrollContainer", () => $2ea8babea89be1bc$export$2631a3ab3cdd158d);
$parcel$export(module.exports, "contentArea", () => $2ea8babea89be1bc$export$26bdc8f90c1f72f6);
$parcel$export(module.exports, "contentAreaWrapper", () => $2ea8babea89be1bc$export$484266f72d7ebbab);
$parcel$export(module.exports, "contentAreaHeightNoToolbar", () => $2ea8babea89be1bc$export$848a137fb02bc242);
$parcel$export(module.exports, "sidebarArea", () => $2ea8babea89be1bc$export$a838a71bfc839c1d);
$parcel$export(module.exports, "editorContentAreaStyle", () => $2ea8babea89be1bc$export$fc070501506e6d7a);
$parcel$export(module.exports, "editorContentGutterStyle", () => $2ea8babea89be1bc$export$95d13e1170f2991);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8gSD8 = parcelRequire("8gSD8");
var $43mJF = parcelRequire("43mJF");
parcelRequire("7uhma");
var $cipm3 = parcelRequire("cipm3");
parcelRequire("eTjGD");
var $1v4Xe = parcelRequire("1v4Xe");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $jZLtJ = parcelRequire("jZLtJ");
function $2ea8babea89be1bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $2ea8babea89be1bc$var$SWOOP_ANIMATION = `0.5s ${(0, $iHYdz.akEditorSwoopCubicBezier)}`;
const $2ea8babea89be1bc$var$getTotalPadding = ()=>(0, $iHYdz.akEditorGutterPaddingDynamic)() * 2;
const $2ea8babea89be1bc$export$ffbc962f588258d5 = {
    name: "cui2x",
    styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
};
const $2ea8babea89be1bc$var$scrollStyles = /*#__PURE__*/ (0, $f8Sb3.css)("flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4038285048829feb$export$b2380b18b089518f));
const $2ea8babea89be1bc$export$2631a3ab3cdd158d = (0, $jZLtJ.createEditorContentStyle)($2ea8babea89be1bc$var$scrollStyles);
$2ea8babea89be1bc$export$2631a3ab3cdd158d.displayName = 'ScrollContainer';
const $2ea8babea89be1bc$export$26bdc8f90c1f72f6 = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${editorToolbarHeight})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '&.ak-editor-content-area-no-toolbar': {
            // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
            // to match the toolbar height
            height: `calc(100% + 1px)`
        },
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `padding 0ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`
    });
};
const $2ea8babea89be1bc$export$484266f72d7ebbab = {
    name: "znpqtq",
    styles: "width:100%;container-type:inline-size;container-name:editor-area;contain:layout style inline-size"
};
const $2ea8babea89be1bc$export$848a137fb02bc242 = {
    name: "13udsys",
    styles: "height:100%"
};
const $2ea8babea89be1bc$export$a838a71bfc839c1d = {
    name: "18di8tn",
    styles: "height:100%;box-sizing:border-box;align-self:flex-end;.extension-editable-area &{height:auto;position:sticky;top:0;align-self:flex-start;}"
};
const $2ea8babea89be1bc$export$14d7990cf2a76cb6 = {
    name: "1ffp76g",
    styles: ".fabric-editor--full-width-mode{.pm-table-container, .code-block, .extension-container{display:none;}.multiBodiedExtension--container{display:none;}}"
};
/* Prevent horizontal scroll on page in full width mode */ const $2ea8babea89be1bc$var$editorContentAreaContainerStyle = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor--full-width-mode': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.code-block, .extension-container, .multiBodiedExtension--container': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% - ${(0, $1v4Xe.tableMarginFullWidthMode) * 2}px)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container.inline': {
                maxWidth: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            'td .extension-container.inline': {
                maxWidth: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '[data-layout-section]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% + ${(0, $iHYdz.akLayoutGutterOffset) * 2}px)`
            }
        }
    });
const $2ea8babea89be1bc$export$fc070501506e6d7a = ({ layoutMaxWidth: layoutMaxWidth, fullWidthMode: fullWidthMode, isEditorToolbarHidden: isEditorToolbarHidden })=>[
        $2ea8babea89be1bc$var$editorContentArea,
        !fullWidthMode && $2ea8babea89be1bc$var$editorContentAreaWithLayoutWith(layoutMaxWidth),
        $2ea8babea89be1bc$var$editorContentAreaContainerStyle(),
        ...(0, $VSDnB.fg)('platform_editor_controls_no_toolbar_space') ? [] : [
            (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $2ea8babea89be1bc$var$contentAreaReducedHeaderSpace,
            isEditorToolbarHidden && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $2ea8babea89be1bc$var$contentAreaReservedPrimaryToolbarSpace
        ]
    ];
const $2ea8babea89be1bc$var$editorContentAreaWithLayoutWith = (layoutMaxWidth)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // this restricts max width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${layoutMaxWidth + $2ea8babea89be1bc$var$getTotalPadding()}px`
    });
const $2ea8babea89be1bc$var$editorContentArea = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/ui-styling-standard/no-unsafe-values
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + ${(0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)()} + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $iHYdz.akEditorFullWidthLayoutWidth) + $2ea8babea89be1bc$var$getTotalPadding()}px`,
    transition: `max-width ${$2ea8babea89be1bc$var$SWOOP_ANIMATION}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $43mJF.taskListSelector}):not(${0, $8gSD8.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $cipm3.tableFullPageEditorStyles), ".fabric-editor--full-width-mode{.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}");
const $2ea8babea89be1bc$export$95d13e1170f2991 = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $iHYdz.akEditorGutterPaddingDynamic)()}px`
    });
};
// An additional spacing applied at the top of the content area reserving space when the primary toolbar
// is hidden – this avoids layout shift when the toolbar is toggled under the editor controls feature
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2ea8babea89be1bc$var$contentAreaReservedPrimaryToolbarSpace = /*#__PURE__*/ (0, $f8Sb3.css)({
    // extra 1px to account for the bottom border on the toolbar
    marginTop: `calc(${"var(--ds-space-500, 40px)"} + 1px)`
});
// A reduced top spacing applied to the content area to compensate for the reserved space at the top
// of the page when the primary toolbar is hidden under the editor controls feature
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2ea8babea89be1bc$var$contentAreaReducedHeaderSpace = {
    name: "1y04g5d",
    styles: "padding-top:var(--ds-space-400, 32px)"
};

});


parcelRegister("eMbnU", function(module, exports) {

$parcel$export(module.exports, "FullPageToolbar", () => $53d9c5fa01d5f1ad$export$26f3f0e30f9545b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $kXnoC = parcelRequire("kXnoC");

var $DXgOv = parcelRequire("DXgOv");

var $kdDpx = parcelRequire("kdDpx");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $9JEFz = parcelRequire("9JEFz");

var $5093p = parcelRequire("5093p");

var $5k24a = parcelRequire("5k24a");

var $eWGrU = parcelRequire("eWGrU");
const $53d9c5fa01d5f1ad$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $5uXOq.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $9JEFz.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment;
    const popupsMountPoint = hasToolbarPortal && (0, $VSDnB.fg)('platform_editor_lcm_toolbar_portals') ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWGrU.nonCustomToolbarWrapperStyle)
    }, props.beforeIcon && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWGrU.mainToolbarIconBeforeStyle)
    }, props.beforeIcon), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5093p.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWGrU.customToolbarWrapperStyle)
    }, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5k24a.BeforePrimaryToolbarWrapper), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $5uXOq.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $eWGrU.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbar = (event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    };
    const handleEscape = (event)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $DXgOv.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kdDpx.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, (0, $VSDnB.fg)('platform_editor_lcm_toolbar_portals') ? /*#__PURE__*/ (0, $f8Sb3.jsx)(ToolbarPortal, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarStyle)(props.showKeyline || contextPanelWidth > 0, twoLineEditorToolbar),
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarFirstChildStyle)(twoLineEditorToolbar),
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $kXnoC.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarSecondChildStyle)(twoLineEditorToolbar),
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $kXnoC.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9JEFz.ToolbarPortalMountPoint), null))) : /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarStyle)(props.showKeyline || contextPanelWidth > 0, twoLineEditorToolbar),
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarFirstChildStyle)(twoLineEditorToolbar),
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $kXnoC.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarSecondChildStyle)(twoLineEditorToolbar),
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $kXnoC.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar))));
});
const $53d9c5fa01d5f1ad$export$26f3f0e30f9545b4 = (0, $8RXs9.default)($53d9c5fa01d5f1ad$export$477aaffea178bc4e);

});
parcelRegister("9JEFz", function(module, exports) {

$parcel$export(module.exports, "ToolbarPortalContextProvider", () => $fa35fdbbfc9383a9$export$89a0c16b81a39772);
$parcel$export(module.exports, "useToolbarPortal", () => $fa35fdbbfc9383a9$export$9fa9b541c351558);
$parcel$export(module.exports, "ToolbarPortalMountPoint", () => $fa35fdbbfc9383a9$export$ed65ed0e830b18c8);
/* ToolbarPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $fa35fdbbfc9383a9$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $fa35fdbbfc9383a9$export$89a0c16b81a39772 = ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fa35fdbbfc9383a9$var$ToolbarPortalContext.Provider, {
        value: value,
        children: children
    });
};
const $fa35fdbbfc9383a9$export$9fa9b541c351558 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($fa35fdbbfc9383a9$var$ToolbarPortalContext);
};
const $fa35fdbbfc9383a9$var$toolbarPortalStyles = {
    portal: "_1r04ze3t _kqswstnw _fiawglyw"
};
const $fa35fdbbfc9383a9$export$ed65ed0e830b18c8 = ()=>{
    const portal = $fa35fdbbfc9383a9$export$9fa9b541c351558();
    // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $fa35fdbbfc9383a9$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};

});

parcelRegister("5k24a", function(module, exports) {

$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $b5e0689e02fdf117$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $b5e0689e02fdf117$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b5e0689e02fdf117$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "ep0vx",
    styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
};
const $b5e0689e02fdf117$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b5e0689e02fdf117$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});

parcelRegister("eWGrU", function(module, exports) {

$parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", () => $ea400237c23c8b06$export$f71dca5c73c8a7);
$parcel$export(module.exports, "mainToolbarStyle", () => $ea400237c23c8b06$export$149462a46fbcc8c8);
$parcel$export(module.exports, "mainToolbarIconBeforeStyle", () => $ea400237c23c8b06$export$8ae7cf5e67319342);
$parcel$export(module.exports, "mainToolbarFirstChildStyle", () => $ea400237c23c8b06$export$53973a689c603614);
$parcel$export(module.exports, "mainToolbarSecondChildStyle", () => $ea400237c23c8b06$export$b0242e3e235d994c);
$parcel$export(module.exports, "nonCustomToolbarWrapperStyle", () => $ea400237c23c8b06$export$a41238ec40a49ad0);
$parcel$export(module.exports, "customToolbarWrapperStyle", () => $ea400237c23c8b06$export$9c5878561f814452);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
function $ea400237c23c8b06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ea400237c23c8b06$export$f71dca5c73c8a7 = 868;
// box-shadow is overriden by the mainToolbar
const $ea400237c23c8b06$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}`
});
const $ea400237c23c8b06$var$mainToolbarTwoLineStyle = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
            flexWrap: 'wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    });
};
const $ea400237c23c8b06$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
const $ea400237c23c8b06$var$mainToolbar = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        alignItems: 'center',
        boxShadow: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `box-shadow 200ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorFloatingDialogZIndex),
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: editorToolbarHeight,
        flexShrink: 0,
        backgroundColor: "var(--ds-surface, white)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& object': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            height: '0 !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ea400237c23c8b06$var$flexibleIconSize);
};
const $ea400237c23c8b06$export$149462a46fbcc8c8 = (showKeyline, twoLineEditorToolbar)=>[
        $ea400237c23c8b06$var$mainToolbar,
        showKeyline && $ea400237c23c8b06$var$mainToolbarWithKeyline,
        twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarTwoLineStyle
    ];
const $ea400237c23c8b06$export$8ae7cf5e67319342 = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $ea400237c23c8b06$var$mainToolbarFirstChild = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $ea400237c23c8b06$var$mainToolbarFirstChildTowLine = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            justifyContent: 'flex-end',
            minWidth: 'fit-content'
        }
    });
};
const $ea400237c23c8b06$export$53973a689c603614 = (twoLineEditorToolbar)=>[
        $ea400237c23c8b06$var$mainToolbarFirstChild,
        twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarFirstChildTowLine
    ];
const $ea400237c23c8b06$var$mainToolbarSecondChild = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
const $ea400237c23c8b06$var$mainToolbarSecondChildTwoLine = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
            display: 'flex',
            flexGrow: 1,
            flex: '1 1 100%',
            margin: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            minWidth: 0
        }
    });
};
const $ea400237c23c8b06$export$b0242e3e235d994c = (twoLineEditorToolbar)=>[
        $ea400237c23c8b06$var$mainToolbarSecondChild,
        twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarSecondChildTwoLine
    ];
const $ea400237c23c8b06$export$a41238ec40a49ad0 = {
    name: "t6ix9q",
    styles: "align-items:center;display:flex;flex-grow:1"
};
const $ea400237c23c8b06$export$9c5878561f814452 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};

});


parcelRegister("cOyi5", function(module, exports) {

$parcel$export(module.exports, "getEditorViewMode", () => $52954376e8c36f04$export$419814ca23c581e8);

var $VSDnB = parcelRequire("VSDnB");
// Retrieve the initial config value from the editor view plugin preset
const $52954376e8c36f04$var$getViewModeSync = (preset)=>{
    if (!(0, $VSDnB.fg)('platform_editor_sync_editor_view_mode_state')) return undefined;
    // @ts-expect-error - data is a private property
    const editorViewModePlugin = preset.data.find((p)=>{
        if (Array.isArray(p)) {
            const [plugin, config] = p;
            return plugin({
                config: config
            }).name === 'editorViewMode';
        } else return p?.({
            config: undefined
        })?.name === 'editorViewMode';
    });
    // If we have set a default value on the view mode (index 1) then we can return the mode, otherwise we haven't set by default
    return Array.isArray(editorViewModePlugin) ? editorViewModePlugin[1]?.mode : undefined;
};
const $52954376e8c36f04$export$419814ca23c581e8 = (editorViewModeState, preset)=>{
    if (!editorViewModeState?.mode) return $52954376e8c36f04$var$getViewModeSync(preset);
    return editorViewModeState?.mode;
};

});



parcelRegister("1QYAr", function(module, exports) {

$parcel$export(module.exports, "CoreEditor", () => $74a39720d38c82c6$export$be7eaacc86ce4514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ajpes = parcelRequire("ajpes");

var $bXrHm = parcelRequire("bXrHm");

var $1PVpv = parcelRequire("1PVpv");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $iN9lO = parcelRequire("iN9lO");

var $4NUlu = parcelRequire("4NUlu");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $1rAg3 = parcelRequire("1rAg3");

var $ankW9 = parcelRequire("ankW9");

var $fkGS3 = parcelRequire("fkGS3");

var $5cNeT = parcelRequire("5cNeT");

var $8iwfw = parcelRequire("8iwfw");

var $kS1Fz = parcelRequire("kS1Fz");

var $2E1QW = parcelRequire("2E1QW");

var $cjRyP = parcelRequire("cjRyP");

var $dACrN = parcelRequire("dACrN");

var $1d04s = parcelRequire("1d04s");

var $jRRkB = parcelRequire("jRRkB");

var $2JODI = parcelRequire("2JODI");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 */ function $74a39720d38c82c6$var$Editor(passedProps) {
    const propsRef = (0, $5uXOq.useRef)(passedProps);
    const props = (0, $1d04s.default)(passedProps);
    (0, $5uXOq.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $ankW9.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $5uXOq.useMemo)(()=>new (0, $1rAg3.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $5uXOq.useCallback)((data)=>{
        (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $5uXOq.useCallback)(()=>{
        return {
            ...(0, $fkGS3.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $5uXOq.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $iN9lO.startMeasure)((0, $5cNeT.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $iN9lO.stopMeasure)((0, $5cNeT.default).ON_EDITOR_READY_CALLBACK, (0, $2JODI.default)((0, $gkwXh.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $5uXOq.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $dACrN.default)(props, createAnalyticsEvent);
    const providerFactory = (0, $jRRkB.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $5uXOq.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageApperance = Boolean(props.appearance && [
        'full-page',
        'full-width'
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, isFullPageApperance && (0, $VSDnB.fg)('platform_editor_fe--ufo-bridge') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kS1Fz.EditorUFOBridge), null) : null, isFullPageApperance && (0, $VSDnB.fg)('platform_editor_fe--performance_metrics') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kS1Fz.EditorPerformanceMetrics), null) : null, isFullPageApperance && (0, $VSDnB.fg)('platform_editor_fe--inp-metrics') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2E1QW.EditorINPMetrics), null) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cjRyP.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $74a39720d38c82c6$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $5uXOq.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $74a39720d38c82c6$export$be7eaacc86ce4514(props) {
    const editorSessionId = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    const data = (0, $5uXOq.useMemo)(()=>{
        return {
            packageName: (0, $8iwfw.name),
            packageVersion: (0, $8iwfw.version),
            componentName: 'editorCore',
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current,
            ...(0, $gmhCD.editorExperiment)('platform_editor_controls_shadow', 'variant1', {
                exposure: true
            }) ? {
                tmpControlsShadow: true
            } : {}
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $74a39720d38c82c6$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($74a39720d38c82c6$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$74a39720d38c82c6$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $74a39720d38c82c6$export$2e2bcd8739ae039 = $74a39720d38c82c6$export$be7eaacc86ce4514;

});
parcelRegister("ctLRZ", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6);
$parcel$export(module.exports, "fireAnalyticsEvent", () => $c6d39b0cc0e8a4ed$export$c7d191551feb734);

var $dWAZk = parcelRequire("dWAZk");

var $3C0Tq = parcelRequire("3C0Tq");
const $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6 = (0, $dWAZk.FabricChannel).editor;
const $c6d39b0cc0e8a4ed$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $3C0Tq.AnalyticsQueue).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };

});
parcelRegister("3C0Tq", function(module, exports) {

$parcel$export(module.exports, "AnalyticsQueue", () => $db724abd22ea4847$export$b44c4ba8fe19bbc7);

var $8QpSo = parcelRequire("8QpSo");
class $db724abd22ea4847$export$b44c4ba8fe19bbc7 {
    static{
        this.get = (0, $8QpSo.default)(()=>new $db724abd22ea4847$export$b44c4ba8fe19bbc7());
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
}

});


parcelRegister("1rAg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd26123fc5f51a3$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $lY6DM = parcelRequire("lY6DM");

var $agxMF = parcelRequire("agxMF");

var $4NUlu = parcelRequire("4NUlu");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $QWvft = parcelRequire("QWvft");

var $9V8N3 = parcelRequire("9V8N3");

var $b1dHu = parcelRequire("b1dHu");

var $pvAs1 = parcelRequire("pvAs1");

var $lIbnY = parcelRequire("lIbnY");

var $9jeYG = parcelRequire("9jeYG");
// Please, do not copy or use this kind of code below
// @ts-ignore
const $fbd26123fc5f51a3$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $fbd26123fc5f51a3$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $fbd26123fc5f51a3$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
            if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        } else this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated This is deprecated and is no longer maintained.
	 *
	 * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
	 * it has inbuilt throttling and is designed for use with `ComposableEditor`.
	 *
	 * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
	 *
	 * WARNING: this may be called repeatedly, async with care
	 */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $QWvft.getEditorValueWithMedia)(editorView);
        const json = (0, $9jeYG.toJSON)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $kCV8T.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $lIbnY.findNodePosByLocalIds)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $b1dHu.findNodePosByFragmentLocalIds)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
	 * This method will return the currently selected `Node` if the selection is a `Node`.
	 * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
	 */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node;
            return (0, $5r0mK.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $pvAs1.isEmptyDocument)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `replaceDocument` found in the core plugin actions instead
	 * using this will reset your Editor State which could cause some things to break (like emojis)
	 * @example - use the `replaceDocument` from the core plugin actions instead
	 * ```ts
	 * const { editorApi, preset } = usePreset(...);
		// where you need it
		editorApi?.core.actions.replaceDocument(value);
		return <ComposableEditor preset={preset} ... />
	 */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $9V8N3.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $agxMF.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $agxMF.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $5r0mK.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $lY6DM.createDispatch)(this.eventDispatcher);
                dispatch((0, $4NUlu.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
	 * If editor is using new collab service,
	 * we want editor to call the collab provider to
	 * retrieve the final acknowledged state of the
	 * editor. The final acknowledged editor state
	 * refers to the latest state of editor with confirmed
	 * steps.
	 */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $QWvft.getEditorValueWithMedia)(editorView);
            const collabEditState = $fbd26123fc5f51a3$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}

});
parcelRegister("lY6DM", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", () => $468232df5c6ea546$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $468232df5c6ea546$export$f57f9cc7ce57b7d0);
class $468232df5c6ea546$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $468232df5c6ea546$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $468232df5c6ea546$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($468232df5c6ea546$var$getEventFromEventName(eventName), data);
    };
}

});

parcelRegister("agxMF", function(module, exports) {

$parcel$export(module.exports, "processRawValueWithoutValidation", () => $06227a323d5b9cf2$export$cafe23194e65f591);
$parcel$export(module.exports, "processRawValue", () => $06227a323d5b9cf2$export$f1a0a61081c3ed62);
$parcel$export(module.exports, "processRawFragmentValue", () => $06227a323d5b9cf2$export$89b7989c347e6a7b);

var $6pVhb = parcelRequire("6pVhb");
var $jzlPz = parcelRequire("jzlPz");
var $KiRx2 = parcelRequire("KiRx2");
var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");
var $g7mYL = parcelRequire("g7mYL");
var $dADdx = parcelRequire("dADdx");

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $gkwXh = parcelRequire("gkwXh");

var $17TS1 = parcelRequire("17TS1");

var $d54NZ = parcelRequire("d54NZ");

var $4IuOY = parcelRequire("4IuOY");
const $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(node);
        if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $06227a323d5b9cf2$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) {
        // Convert nested-table extensions into nested tables
        const { transformedAdf: transformedAdf } = $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
        return (0, $kCV8T.Node).fromJSON(schema, transformedAdf);
    } else return (0, $kCV8T.Node).fromJSON(schema, node);
}
function $06227a323d5b9cf2$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $kCV8T.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dADdx.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $6pVhb.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $g7mYL.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jzlPz.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $KiRx2.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
        }
        const entity = (0, $4IuOY.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        const newEntity = $06227a323d5b9cf2$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $kCV8T.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $d54NZ.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($06227a323d5b9cf2$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $06227a323d5b9cf2$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$06227a323d5b9cf2$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $kCV8T.Fragment).from(adfEntities);
}
function $06227a323d5b9cf2$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $06227a323d5b9cf2$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $17TS1.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("6pVhb", function(module, exports) {

$parcel$export(module.exports, "transformDedupeMarks", () => $4ff23f41b9c1a5b1$export$af4e387303482581);

var $l1C1k = parcelRequire("l1C1k");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $4ff23f41b9c1a5b1$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $4ff23f41b9c1a5b1$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $4ff23f41b9c1a5b1$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        text: (node)=>{
            if ($4ff23f41b9c1a5b1$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $4ff23f41b9c1a5b1$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("jzlPz", function(module, exports) {

$parcel$export(module.exports, "transformIndentationMarks", () => $8dff8a40c1912f4c$export$c06e4b521519af22);

var $l1C1k = parcelRequire("l1C1k");
const $8dff8a40c1912f4c$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $8dff8a40c1912f4c$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $8dff8a40c1912f4c$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        tableCell: (node)=>{
            if ($8dff8a40c1912f4c$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $8dff8a40c1912f4c$var$removeIndentationFromHeadings(node);
            }
        },
        tableHeader: (node)=>{
            if ($8dff8a40c1912f4c$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $8dff8a40c1912f4c$var$removeIndentationFromHeadings(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("KiRx2", function(module, exports) {

$parcel$export(module.exports, "transformInvalidMediaContent", () => $fc6f50f3ab0dfe3c$export$1c8c16d74c7a63bf);

var $l1C1k = parcelRequire("l1C1k");

var $ebjue = parcelRequire("ebjue");
const $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode, index)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $fc6f50f3ab0dfe3c$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $ebjue.isEmpty)(node));
        //remove other remaining dupicates
        $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $fc6f50f3ab0dfe3c$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $fc6f50f3ab0dfe3c$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("g7mYL", function(module, exports) {

$parcel$export(module.exports, "transformNodesMissingContent", () => $4a8cb4828f326aed$export$652814b83c30d251);

var $l1C1k = parcelRequire("l1C1k");

var $6DeCT = parcelRequire("6DeCT");
var $50sdg = parcelRequire("50sdg");
var $jVGjh = parcelRequire("jVGjh");
var $geBph = parcelRequire("geBph");

var $ebjue = parcelRequire("ebjue");
const $4a8cb4828f326aed$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $4a8cb4828f326aed$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $50sdg.paragraph)()
            ];
        default:
            return [];
    }
};
const $4a8cb4828f326aed$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $ebjue.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $4a8cb4828f326aed$var$createValidEmptyContent(node)
            };
        }
    };
const $4a8cb4828f326aed$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $4a8cb4828f326aed$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $4a8cb4828f326aed$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $ebjue.isEmpty)(childNode)) {
                    const result = (0, $6DeCT.listItem)([
                        (0, $50sdg.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $6DeCT.listItem)([
                    (0, $50sdg.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $6DeCT.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($4a8cb4828f326aed$var$hasNonListItemChildren(node) || $4a8cb4828f326aed$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $4a8cb4828f326aed$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
    };
const $4a8cb4828f326aed$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $4a8cb4828f326aed$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $4a8cb4828f326aed$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $geBph.tableRow)([
                    (0, $jVGjh.tableCell)({})((0, $50sdg.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $jVGjh.tableCell)({})((0, $50sdg.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $geBph.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $ebjue.isEmpty)(childNode)) return (0, $geBph.tableRow)([
                    ...new Array(maxColsCount).fill((0, $jVGjh.tableCell)({})((0, $50sdg.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $4a8cb4828f326aed$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
const $4a8cb4828f326aed$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($4a8cb4828f326aed$var$hasEmptyTableRowChildren(node) || $4a8cb4828f326aed$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $4a8cb4828f326aed$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
    };
const $4a8cb4828f326aed$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $ebjue.isEmpty)(node)) {
            reportTransform();
            return false;
        }
    };
const $4a8cb4828f326aed$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $l1C1k.traverse)(adf, {
        tableCell: $4a8cb4828f326aed$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $l1C1k.traverse)(transformedAdf || adf, {
        mediaSingle: $4a8cb4828f326aed$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $l1C1k.traverse)(transformedAdf || adf, {
        bulletList: $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $4a8cb4828f326aed$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("6DeCT", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $a2cd5bff5444dafb$export$76c7e83ecc9cdf05);
const $a2cd5bff5444dafb$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("jVGjh", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $45a16984030f79a3$export$e1e720e5f4603e6a);
const $45a16984030f79a3$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("geBph", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $3b3a7f8c343ad0af$export$ce666bf02318c957);
const $3b3a7f8c343ad0af$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("dADdx", function(module, exports) {

$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $1d4506554e727afe$export$3d531d2daf0e8a14);

var $l1C1k = parcelRequire("l1C1k");
const $1d4506554e727afe$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $1d4506554e727afe$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $1d4506554e727afe$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        text: (node)=>{
            if ($1d4506554e727afe$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $1d4506554e727afe$var$removeCodeMarks(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("17TS1", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $149b214359f7ee68$export$8a32f625580e0a06);

var $l1C1k = parcelRequire("l1C1k");

var $3mm6g = parcelRequire("3mm6g");
function $149b214359f7ee68$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $3mm6g.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});


parcelRegister("QWvft", function(module, exports) {

$parcel$export(module.exports, "getEditorValueWithMedia", () => $ef540e8b72c50d6c$export$99c45752ffdaa598);
// Please, do not copy or use this kind of code below
// @ts-ignore
const $ef540e8b72c50d6c$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $ef540e8b72c50d6c$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $ef540e8b72c50d6c$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("9V8N3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a285f68f22f6664d$export$2e2bcd8739ae039);
function $a285f68f22f6664d$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $a285f68f22f6664d$export$2e2bcd8739ae039 = $a285f68f22f6664d$var$deprecationWarnings;

});

parcelRegister("b1dHu", function(module, exports) {

$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $d7150c63727d169a$export$1dc8bea8646ac811);
const $d7150c63727d169a$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("pvAs1", function(module, exports) {

$parcel$export(module.exports, "isEmptyDocument", () => $2b33f98e049d60d3$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $2b33f98e049d60d3$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $2b33f98e049d60d3$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $2b33f98e049d60d3$export$b648602b09795358(nodeChild);
}

});

parcelRegister("lIbnY", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $59fd907a3078acac$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $59fd907a3078acac$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("9jeYG", function(module, exports) {

$parcel$export(module.exports, "toJSON", () => $75ea2b648e87890e$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $hYNZx = parcelRequire("hYNZx");
const $75ea2b648e87890e$var$transformer = new (0, $hYNZx.JSONTransformer)();
function $75ea2b648e87890e$export$54fd2c36b5cc6731(node) {
    return $75ea2b648e87890e$var$transformer.encode(node);
}

});


parcelRegister("ankW9", function(module, exports) {

$parcel$export(module.exports, "useEditorContext", () => $0216bf80b2f4530e$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $0216bf80b2f4530e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $8v2ZL = parcelRequire("8v2ZL");

var $VSDnB = parcelRequire("VSDnB");

var $1rAg3 = parcelRequire("1rAg3");
const $0216bf80b2f4530e$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $8v2ZL.EditorContext));
class $0216bf80b2f4530e$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
    }
    render() {
        if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2') || (0, $VSDnB.fg)('platform_editor_react18_phase2_v2_extended')) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($0216bf80b2f4530e$var$LegacyEditorContextNew, {
            ...this.props,
            children: this.props.children
        });
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($0216bf80b2f4530e$export$2e2bcd8739ae039, {
            ...this.props,
            children: this.props.children
        });
    }
}
function $0216bf80b2f4530e$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8v2ZL.EditorContext).Provider, {
        value: {
            editorActions: editorActions ?? new (0, $1rAg3.default)()
        },
        children: children
    });
}
class $0216bf80b2f4530e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.childContextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
        };
    }
    constructor(props){
        super(props);
        this.editorActions = props.editorActions || new (0, $1rAg3.default)();
    }
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8v2ZL.EditorContext).Provider, {
            value: this.getChildContext(),
            children: this.props.children
        });
    }
}

});
parcelRegister("8v2ZL", function(module, exports) {

$parcel$export(module.exports, "EditorContext", () => $1ceb886f8ac7152d$export$27b8dd149e32f6c7);

var $5uXOq = parcelRequire("5uXOq");
const $1ceb886f8ac7152d$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});

});


parcelRegister("fkGS3", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $9cb3176a03e5a295$export$63102b0cbe181144);

var $4zXba = parcelRequire("4zXba");
function $9cb3176a03e5a295$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $9cb3176a03e5a295$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $9cb3176a03e5a295$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $9cb3176a03e5a295$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $9cb3176a03e5a295$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $9cb3176a03e5a295$var$getSpellCheck(featureFlags)
    };
}

});

parcelRegister("5cNeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6d404d928de370$export$2e2bcd8739ae039);
var $7b6d404d928de370$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("8iwfw", function(module, exports) {

$parcel$export(module.exports, "name", () => $060d6f70d3cebea6$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $060d6f70d3cebea6$export$83d89fbfd8236492);
const $060d6f70d3cebea6$export$a8ff84c12d48cfa6 = "platform-pkg";
const $060d6f70d3cebea6$export$83d89fbfd8236492 = "0.0.0-use.local";

});

parcelRegister("kS1Fz", function(module, exports) {

$parcel$export(module.exports, "EditorUFOBridge", () => $f6ffbe9c186cf2c2$export$15bf1cd13e91f6bc);
$parcel$export(module.exports, "EditorPerformanceMetrics", () => $f6ffbe9c186cf2c2$export$f4f1b16d66bd13b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $5X2l1 = parcelRequire("5X2l1");

var $fNobW = parcelRequire("fNobW");
const $f6ffbe9c186cf2c2$export$15bf1cd13e91f6bc = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const [hold, setHold] = (0, $5uXOq.useState)(true);
    const onTTAI = (0, $5uXOq.useCallback)(()=>{
        setHold(false);
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fNobW.default), {
        name: "editor-core",
        hold: hold
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5X2l1.PerformanceMetrics), {
        onTTAI: onTTAI
    }));
});
const $f6ffbe9c186cf2c2$export$f4f1b16d66bd13b4 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [ttai, setTTAI] = (0, $5uXOq.useState)(null);
    const [ttvc, setTTVC] = (0, $5uXOq.useState)(null);
    const [latency, setUserLatency] = (0, $5uXOq.useState)(null);
    const ttvcSentRef = (0, $5uXOq.useRef)(false);
    const latencySentRef = (0, $5uXOq.useRef)(false);
    const handleAnalyticsEvent = (0, $5uXOq.useCallback)((data)=>{
        (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const onTTAI = (0, $5uXOq.useCallback)(({ idleAt: idleAt })=>{
        setTTAI(idleAt);
    }, []);
    const onTTVC = (0, $5uXOq.useCallback)(({ ttvc: ttvc })=>{
        setTTVC(ttvc);
    }, []);
    const onUserLatency = (0, $5uXOq.useCallback)(({ latency: latency })=>{
        setUserLatency(latency);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!ttai || !ttvc || ttvcSentRef.current) return;
        ttvcSentRef.current = true;
        handleAnalyticsEvent({
            payload: {
                // @ts-expect-error Temporary data - let's not extend the public analytics enum
                action: 'ttvc',
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ttvc: ttvc,
                    ttai: ttai
                }
            }
        });
    }, [
        handleAnalyticsEvent,
        ttai,
        ttvc
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!latency || latencySentRef.current) return;
        latencySentRef.current = true;
        handleAnalyticsEvent({
            payload: {
                // @ts-expect-error Temporary data - let's not extend the public analytics enum
                action: 'latency',
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    latency: latency
                }
            }
        });
    }, [
        handleAnalyticsEvent,
        latency
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5X2l1.PerformanceMetrics), {
        onTTAI: onTTAI,
        onTTVC: onTTVC,
        onUserLatency: onUserLatency
    });
});

});
parcelRegister("5X2l1", function(module, exports) {

$parcel$export(module.exports, "PerformanceMetrics", () => $139741dbc43ade80$export$68015ba807c17f26);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $9HClP = parcelRequire("9HClP");

var $2sWkZ = parcelRequire("2sWkZ");
const $139741dbc43ade80$var$useTTVC = ({ observer: observer, onTTVC: onTTVC })=>{
    const mountedAtRef = (0, $5uXOq.useRef)(performance.now());
    (0, $5uXOq.useEffect)(()=>{
        if (!observer || !onTTVC) return;
        const unsub = observer.onceNextIdle(async ({ idleAt: idleAt, timelineBuffer: timelineBuffer })=>{
            const metrics = (0, $9HClP.createCalculator)(timelineBuffer);
            const ttvc = await metrics.calculateVCTargets({
                // Only events that started after the component was created are valid for TTVC calculation
                rangeEventsFilter: {
                    from: mountedAtRef.current,
                    to: 'abort:user-interaction'
                }
            });
            if (!ttvc) return;
            const startedTime = mountedAtRef.current;
            const relativeTTVC = Object.entries(ttvc).reduce((acc, [percentile, value])=>{
                // @ts-ignore
                acc[percentile] = value - startedTime;
                return acc;
            }, {});
            onTTVC({
                ttvc: ttvc,
                relativeTTVC: relativeTTVC
            });
        });
        return ()=>{
            unsub();
        };
    }, [
        observer,
        onTTVC
    ]);
};
const $139741dbc43ade80$var$useLatency = ({ observer: observer, onUserLatency: onUserLatency })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!observer || !onUserLatency) return;
        const unsub = observer.onIdleBuffer(({ idleAt: idleAt, timelineBuffer: timelineBuffer })=>{
            (0, $9HClP.createCalculator)(timelineBuffer).calculateLatencyPercents().then((result)=>{
                if (!result) return;
                onUserLatency({
                    latency: result
                });
            });
        });
        return ()=>{
            unsub();
        };
    }, [
        observer,
        onUserLatency
    ]);
};
const $139741dbc43ade80$var$useTTAI = ({ observer: observer, onTTAI: onTTAI })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!observer || !onTTAI) return;
        const unsub = observer.onceNextIdle(({ idleAt: idleAt, timelineBuffer: timelineBuffer })=>{
            onTTAI({
                idleAt: idleAt
            });
        });
        return ()=>{
            unsub();
        };
    }, [
        observer,
        onTTAI
    ]);
};
const $139741dbc43ade80$export$68015ba807c17f26 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onTTVC: onTTVC, onUserLatency: onUserLatency, onTTAI: onTTAI })=>{
    const observer = (0, $5uXOq.useMemo)(()=>{
        const isSSR = Boolean(undefined);
        if (isSSR) return null;
        const observer = (0, $2sWkZ.getGlobalEditorMetricsObserver)();
        if (observer) observer.start({
            startTime: performance.now()
        });
        return observer;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (!observer) return;
            observer.stop();
        };
    }, [
        observer
    ]);
    $139741dbc43ade80$var$useTTVC({
        observer: observer,
        onTTVC: onTTVC
    });
    $139741dbc43ade80$var$useLatency({
        observer: observer,
        onUserLatency: onUserLatency
    });
    $139741dbc43ade80$var$useTTAI({
        observer: observer,
        onTTAI: onTTAI
    });
    return null;
});
$139741dbc43ade80$export$68015ba807c17f26.displayName = 'PerformanceMetrics';

});
parcelRegister("9HClP", function(module, exports) {

$parcel$export(module.exports, "createCalculator", () => $226983a6bd13af6e$export$4cfd7e0a1eed47bb);

var $4LKas = parcelRequire("4LKas");

var $2JmDC = parcelRequire("2JmDC");

var $jEB6I = parcelRequire("jEB6I");

var $lVlZ1 = parcelRequire("lVlZ1");
const $226983a6bd13af6e$var$latencyCategories = [
    'mouse-movement',
    'mouse-action',
    'keyboard',
    'form',
    'clipboard',
    'drag-and-drop',
    'page-resize',
    'scroll',
    'touch',
    'other'
];
class $226983a6bd13af6e$export$f4f1b16d66bd13b4 {
    constructor(timeline, viewport = (0, $2JmDC.getViewportDimensions)()){
        this.timeline = timeline;
        this.viewport = viewport;
    }
    async calculateLatencyPercents() {
        const promises = $226983a6bd13af6e$var$latencyCategories.map((category)=>{
            const events = this.timeline.getEventsPerType(`user-event:${category}`);
            const task = (0, $4LKas.backgroundTask)(async (taskYield)=>{
                await taskYield();
                const percentiles = (0, $lVlZ1.getLatencyPercentiles)(events);
                if (!percentiles) return null;
                return {
                    [category]: percentiles
                };
            });
            return task.result;
        });
        const allPercentilesProcessed = await Promise.all(promises);
        let isEmpty = true;
        let result = {};
        for (const maybePercentils of allPercentilesProcessed){
            if ((0, $4LKas.isTaskAborted)(maybePercentils) || !maybePercentils) continue;
            result = Object.assign(result, maybePercentils);
            isEmpty = false;
        }
        if (isEmpty) return null;
        return result;
    }
    async calculateLastHeatmap(heatmapSize, rangeEventsFilter) {
        if (!this.viewport) return null;
        const baseheatmap = (0, $jEB6I.createHeatmapWithAspectRatio)({
            viewport: this.viewport,
            heatmapSize: heatmapSize
        });
        if (!rangeEventsFilter) return (0, $jEB6I.createHeatmapFromTimeline)(this.timeline, baseheatmap);
        const timelineEvents = this.timeline.getEvents();
        const startIndex = timelineEvents.findIndex((event)=>{
            if (typeof rangeEventsFilter.from === 'number') return event.startTime >= rangeEventsFilter.from;
            return event.type === rangeEventsFilter.from;
        });
        if (startIndex < 0) return null;
        const endIndex = timelineEvents.slice(startIndex).findIndex((event)=>{
            if (typeof rangeEventsFilter.to === 'number') return event.startTime <= rangeEventsFilter.to;
            return event.type === rangeEventsFilter.to;
        });
        const filteredEventsShallowCopy = endIndex < 0 ? timelineEvents.slice(startIndex) : timelineEvents.slice(startIndex, startIndex + endIndex + 1);
        const filteredEvents = Array.from(filteredEventsShallowCopy);
        const heatmap = await (0, $jEB6I.createHeatmapFromEvents)(filteredEvents, baseheatmap);
        return heatmap;
    }
    async calculateVCPercents(options) {
        const heatmap = await this.calculateLastHeatmap(options.heatmapSize, options.rangeEventsFilter);
        if (!heatmap) return null;
        const VCPercents = (0, $lVlZ1.getVCPercentFromHeatmap)(heatmap, options);
        return VCPercents;
    }
    async calculateVCTargets(options) {
        const defaultOptions = {
            ignoreNodeReplacements: false,
            ignoreLayoutShifts: false,
            ignoreElementMoved: false,
            heatmapSize: 200,
            rangeEventsFilter: null
        };
        const mergedOptions = Object.assign(defaultOptions, options || {});
        const VCPercents = await this.calculateVCPercents(mergedOptions);
        if (!VCPercents) return null;
        const VCTargets = (0, $lVlZ1.getVCPercentileTargets)(VCPercents);
        return VCTargets;
    }
}
function $226983a6bd13af6e$export$4cfd7e0a1eed47bb(timeline, viewport) {
    return new $226983a6bd13af6e$export$f4f1b16d66bd13b4(timeline, viewport);
}

});
parcelRegister("4LKas", function(module, exports) {

$parcel$export(module.exports, "isTaskAborted", () => $0e3623e3d4067733$export$7214944679ce73c5);
$parcel$export(module.exports, "taskYield", () => $0e3623e3d4067733$export$efd4e5e39a497e46);
$parcel$export(module.exports, "backgroundTask", () => $0e3623e3d4067733$export$a2b36e61c823a614);
/* eslint-disable compat/compat */ const $0e3623e3d4067733$export$354c47411e1138b = Symbol('BackgroundTaskAborted');
const $0e3623e3d4067733$export$7214944679ce73c5 = (maybeTaskAbortedResult)=>{
    return maybeTaskAbortedResult === $0e3623e3d4067733$export$354c47411e1138b;
};
const $0e3623e3d4067733$export$efd4e5e39a497e46 = async ()=>{
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    if ('requestIdleCallback' in globalThis || 'requestAnimationFrame' in globalThis) {
        const later = globalThis.requestIdleCallback || globalThis.requestAnimationFrame;
        later(()=>{
            resolve();
        });
    } else setTimeout(resolve, 0);
    await p;
};
const $0e3623e3d4067733$var$defaultOptions = {
    delay: 60
};
const $0e3623e3d4067733$export$a2b36e61c823a614 = (originalTask, givenOptions)=>{
    const options = Object.assign($0e3623e3d4067733$var$defaultOptions, givenOptions || {});
    const taskRef = new WeakRef(originalTask);
    let resolvePromiseResultTask = (arg)=>{};
    let rejectPromiseResultTask = (e)=>{};
    const promiseResult = new Promise((resolve, reject)=>{
        resolvePromiseResultTask = resolve;
        rejectPromiseResultTask = reject;
    });
    const executeTask = async ()=>{
        const ref = taskRef.deref();
        if (!ref) return;
        try {
            const result = await ref($0e3623e3d4067733$export$efd4e5e39a497e46);
            resolvePromiseResultTask(// @ts-expect-error
            result);
        } catch (e) {
            rejectPromiseResultTask(e);
        }
    };
    if ('scheduler' in window) {
        const controller = new AbortController();
        window.scheduler.postTask(executeTask, {
            priority: 'background',
            delay: options.delay,
            signal: controller.signal
        }).catch((e)=>{
            if (e !== 'stop-requested') throw e;
        });
        return {
            abort: ()=>{
                controller.abort('stop-requested');
                resolvePromiseResultTask($0e3623e3d4067733$export$354c47411e1138b);
            },
            result: promiseResult
        };
    }
    if (window.requestIdleCallback) {
        const idleId = window.requestIdleCallback(executeTask, {
            timeout: 10000
        });
        return {
            abort: ()=>{
                cancelIdleCallback(idleId);
                resolvePromiseResultTask($0e3623e3d4067733$export$354c47411e1138b);
            },
            result: promiseResult
        };
    }
    const rafId = window.requestAnimationFrame(executeTask);
    return {
        abort: ()=>{
            cancelAnimationFrame(rafId);
            resolvePromiseResultTask($0e3623e3d4067733$export$354c47411e1138b);
        },
        result: promiseResult
    };
};

});

parcelRegister("2JmDC", function(module, exports) {

$parcel$export(module.exports, "getViewportDimensions", () => $75c44bcfb8d1a78b$export$5699aba8b35d3f39);
$parcel$export(module.exports, "searchAncestors", () => $75c44bcfb8d1a78b$export$49e8b9ba7494e66a);
$parcel$export(module.exports, "getEventCategory", () => $75c44bcfb8d1a78b$export$2b8e483a5e8b4a5a);
function $75c44bcfb8d1a78b$export$5699aba8b35d3f39() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
        w: w,
        h: h
    };
}
function $75c44bcfb8d1a78b$export$49e8b9ba7494e66a(element, validate) {
    if (!element) return false;
    const x = validate(element);
    if (x === 'abort') return false;
    else if (x === 'found') return element;
    return $75c44bcfb8d1a78b$export$49e8b9ba7494e66a(element.parentElement, validate);
}
const $75c44bcfb8d1a78b$var$UserEventsCategoryMap = new Map([
    [
        'mouse-movement',
        [
            'mouseenter',
            'mouseleave',
            'mousemove',
            'mouseover',
            'mouseout'
        ]
    ],
    [
        'mouse-action',
        [
            'click',
            'dblclick',
            'mousedown',
            'mouseup',
            'contextmenu'
        ]
    ],
    [
        'keyboard',
        [
            'keydown',
            'keypress',
            'keyup',
            'input',
            'beforeinput'
        ]
    ],
    [
        'form',
        [
            'focus',
            'blur',
            'change',
            'input',
            'submit',
            'reset',
            'select'
        ]
    ],
    [
        'clipboard',
        [
            'copy',
            'cut',
            'paste'
        ]
    ],
    [
        'drag-and-drop',
        [
            'drag',
            'dragend',
            'dragenter',
            'dragleave',
            'dragover',
            'dragstart',
            'drop'
        ]
    ],
    [
        'page-resize',
        [
            'resize'
        ]
    ],
    [
        'scroll',
        [
            'scroll',
            'wheel'
        ]
    ],
    [
        'touch',
        [
            'touchstart',
            'touchmove',
            'touchend',
            'touchcancel'
        ]
    ]
]);
function $75c44bcfb8d1a78b$export$2b8e483a5e8b4a5a(eventName) {
    for (const [category, events] of $75c44bcfb8d1a78b$var$UserEventsCategoryMap){
        if (events.includes(eventName)) return category;
    }
    return 'other';
}

});

parcelRegister("jEB6I", function(module, exports) {

$parcel$export(module.exports, "createHeatmapWithAspectRatio", () => $5adef62741e0c7be$export$62499c4f7fb4c24f);
$parcel$export(module.exports, "createHeatmapFromEvents", () => $5adef62741e0c7be$export$53a19bb11e2bd4b7);
$parcel$export(module.exports, "createHeatmapFromTimeline", () => $5adef62741e0c7be$export$b68b3626d9a60098);
$parcel$export(module.exports, "isLayoutShift", () => $5adef62741e0c7be$export$7333d9ff71399b05);
$parcel$export(module.exports, "isNodeReplacement", () => $5adef62741e0c7be$export$c0781eb7a01e47ea);
$parcel$export(module.exports, "isElementMoved", () => $5adef62741e0c7be$export$eb4524c11f51ea35);

var $4LKas = parcelRequire("4LKas");
function $5adef62741e0c7be$export$47a6f363cc2030a1() {
    return {
        head: null,
        previousEntries: []
    };
}
function $5adef62741e0c7be$export$31dfdee808c1ae17(entry) {
    if (!entry.head) return {
        head: null,
        previousEntries: [
            ...entry.previousEntries
        ]
    };
    return {
        head: {
            time: entry.head.time,
            elementName: entry.head.elementName,
            wrapperSectionName: entry.head.wrapperSectionName,
            rect: entry.head.rect,
            source: entry.head.source,
            ratio: entry.head.ratio
        },
        previousEntries: [
            ...entry.previousEntries
        ]
    };
}
function $5adef62741e0c7be$export$fb653c219fcc4270(arr) {
    // This is much faster than `structuredClone(arr)`
    return arr.map((a)=>{
        return a.map($5adef62741e0c7be$export$31dfdee808c1ae17);
    });
}
function $5adef62741e0c7be$export$7f3ebb68e036dc06(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}
function $5adef62741e0c7be$export$145a153666a52161({ rect: rect, heatmap: heatmap, transformSource: transformSource, onEmptyRow: onEmptyRow, entry: entry }) {
    const { roundedBottom: roundedBottom, roundedTop: roundedTop, roundedLeft: roundedLeft, roundedRight: roundedRight } = {
        roundedBottom: Math.min(Math.trunc(rect.bottom), heatmap.height),
        roundedTop: Math.trunc(rect.top),
        roundedLeft: Math.trunc(rect.left),
        roundedRight: Math.min(Math.trunc(rect.right), heatmap.width)
    };
    const localHeatmap = heatmap.map;
    for(let row = roundedTop; row < roundedBottom; row++){
        for(let col = roundedLeft; col < roundedRight; col++)if (localHeatmap[row] === undefined || localHeatmap[row][col] === undefined) onEmptyRow({
            entry: entry,
            row: row
        });
        else {
            const previousEntry = localHeatmap[row][col].head;
            // When elements are added at the same time
            // we try to keep the inner element changes as the head
            // This logic is really important to make sure placeholders are properly ignored
            if (previousEntry?.time === entry.time && $5adef62741e0c7be$export$7f3ebb68e036dc06(previousEntry.rect, entry.rect)) {
                localHeatmap[row][col].previousEntries.push({
                    ...entry,
                    source: 'mutation:parent-mounted'
                });
                continue;
            }
            // Check for the same dimensions and elementName
            const isSameDimensions = $5adef62741e0c7be$export$7f3ebb68e036dc06(entry.rect, previousEntry?.rect) && $5adef62741e0c7be$export$7f3ebb68e036dc06(previousEntry?.rect, entry.rect);
            const isSameElementName = entry.elementName === previousEntry?.elementName;
            if (transformSource === 'mutation' && isSameDimensions && isSameElementName) localHeatmap[row][col].head = {
                ...entry,
                source: 'mutation:node-replacement'
            };
            else localHeatmap[row][col].head = {
                ...entry,
                source: transformSource || null
            };
            if (previousEntry !== null) localHeatmap[row][col].previousEntries.push(previousEntry);
        }
    }
}
function $5adef62741e0c7be$var$createDOMRect(x, y, width, height) {
    if (typeof DOMRect !== 'undefined') // DOMRect well supported supported
    // eslint-disable-next-line compat/compat
    return new DOMRect(x, y, width, height);
    else // Fallback for environments without DOMRect
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        get left () {
            return this.x;
        },
        get right () {
            return this.x + this.width;
        },
        get top () {
            return this.y;
        },
        get bottom () {
            return this.y + this.height;
        },
        toJSON () {}
    };
}
function $5adef62741e0c7be$export$9791d5b3dd05db8a(props) {
    const { rect: rect, heatmap: { scaleX: scaleX, scaleY: scaleY } } = props;
    const scaledX = rect.x * scaleX;
    const scaledY = rect.y * scaleY;
    const scaledWidth = rect.width * scaleX;
    const scaledHeight = rect.height * scaleY;
    const n = $5adef62741e0c7be$var$createDOMRect(scaledX, scaledY, scaledWidth, scaledHeight);
    return {
        left: n.left,
        right: n.right,
        top: n.top,
        bottom: n.bottom
    };
}
function $5adef62741e0c7be$export$bcc816815b2ef2b(props) {
    const { right: right, left: left, bottom: bottom, top: top } = props.rect;
    if (props.viewport.w === 0 || props.viewport.h === 0) return 0;
    const ratio = (right - left) * (bottom - top) / (props.viewport.w * props.viewport.h);
    if (ratio > 1) return 1;
    return parseFloat(ratio.toFixed(5));
}
function $5adef62741e0c7be$export$8cb78da97e1e8914(heatmapSize) {
    return Array.from({
        length: heatmapSize
    }).map(()=>Array.from({
            length: heatmapSize
        }).map($5adef62741e0c7be$export$47a6f363cc2030a1));
}
function $5adef62741e0c7be$export$62499c4f7fb4c24f({ viewport: viewport, heatmapSize: heatmapSize }) {
    const maxHeatmapSize = 1000;
    const safeSize = Math.min(heatmapSize, maxHeatmapSize);
    if (viewport.w === 0 || viewport.h === 0) return {
        width: safeSize,
        height: safeSize,
        scaleX: 1,
        scaleY: 1,
        map: $5adef62741e0c7be$export$8cb78da97e1e8914(safeSize)
    };
    const aspectRatio = viewport.w / viewport.h;
    // Calculate heatmap dimensions based on aspect ratio
    let heatmapWidth;
    let heatmapHeight;
    if (aspectRatio > 1) {
        // Landscape orientation
        heatmapWidth = safeSize;
        heatmapHeight = Math.round(safeSize / aspectRatio);
    } else {
        // Portrait orientation
        heatmapHeight = safeSize;
        heatmapWidth = Math.round(safeSize * aspectRatio);
    }
    // Initialize the heatmap with zeros
    const map = Array.from({
        length: heatmapHeight
    }).map(()=>Array.from({
            length: heatmapWidth
        }).map($5adef62741e0c7be$export$47a6f363cc2030a1));
    const scaleX = heatmapWidth / viewport.w;
    const scaleY = heatmapHeight / viewport.h;
    return {
        width: heatmapWidth,
        height: heatmapHeight,
        scaleX: scaleX,
        scaleY: scaleY,
        map: map
    };
}
async function $5adef62741e0c7be$export$53a19bb11e2bd4b7(events, initialHeatmap) {
    const nextHeatmap = {
        ...initialHeatmap,
        map: $5adef62741e0c7be$export$fb653c219fcc4270(initialHeatmap.map)
    };
    for(let i = 0; i < events.length; i++){
        const { type: type, startTime: startTime, data: data } = events[i];
        if (type !== 'element:changed') continue;
        const { elementName: elementName, wrapperSectionName: wrapperSectionName, source: source } = data;
        const heatmapRect = $5adef62741e0c7be$export$9791d5b3dd05db8a({
            rect: data.rect,
            heatmap: nextHeatmap
        });
        const ratio = $5adef62741e0c7be$export$bcc816815b2ef2b({
            rect: heatmapRect,
            viewport: {
                w: nextHeatmap.width,
                h: nextHeatmap.height
            }
        });
        const entry = {
            time: startTime,
            elementName: elementName,
            wrapperSectionName: wrapperSectionName,
            ratio: ratio,
            rect: heatmapRect
        };
        $5adef62741e0c7be$export$145a153666a52161({
            rect: heatmapRect,
            entry: entry,
            heatmap: nextHeatmap,
            transformSource: source,
            onEmptyRow: ({ entry: entry, row: row })=>{}
        });
        // Every 10 events processed
        // we give the browser the power
        // to process any other high priority task
        if (i % 10 === 0) await (0, $4LKas.taskYield)();
    }
    return nextHeatmap;
}
function $5adef62741e0c7be$export$b68b3626d9a60098(timeline, initialHeatmap) {
    const events = timeline.getEvents();
    return $5adef62741e0c7be$export$53a19bb11e2bd4b7(events, initialHeatmap);
}
function $5adef62741e0c7be$export$7333d9ff71399b05(entry) {
    if (!entry || typeof entry.source !== 'string') return false;
    return entry.source === 'layout-shift';
}
function $5adef62741e0c7be$export$c0781eb7a01e47ea(entry) {
    if (!entry || typeof entry.source !== 'string') return false;
    return entry.source === 'mutation:node-replacement';
}
function $5adef62741e0c7be$export$eb4524c11f51ea35(entry) {
    if (!entry || typeof entry.source !== 'string') return false;
    return entry.source === 'layout-shift:element-moved';
}

});

parcelRegister("lVlZ1", function(module, exports) {

$parcel$export(module.exports, "getVCPercentileTargets", () => $15aa5d5d7b95e9e5$export$5318012f06b373b8);
$parcel$export(module.exports, "getVCPercentFromHeatmap", () => $15aa5d5d7b95e9e5$export$acb29c5fe1c4de05);
$parcel$export(module.exports, "getLatencyPercentiles", () => $15aa5d5d7b95e9e5$export$6b4f26c2830d670c);

var $jEB6I = parcelRequire("jEB6I");
const $15aa5d5d7b95e9e5$var$VCTargets = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
function $15aa5d5d7b95e9e5$export$5318012f06b373b8(timestampPercent) {
    // Parse and sort the input percentiles in descending order.
    const descSortedPercentiles = Object.keys(timestampPercent).map((key)=>parseInt(key, 10)).sort((a, b)=>b - a);
    // Initialize the result object with default values.
    const result = {
        '25': -1,
        '50': -1,
        '75': -1,
        '80': -1,
        '85': -1,
        '90': -1,
        '95': -1,
        '98': -1,
        '99': -1
    };
    // Function to find the closest lower or exact percentile.
    function findClosestLowerOrExact(target) {
        let closest = -1;
        for(let i = 0; i < descSortedPercentiles.length; i++){
            const percentile = descSortedPercentiles[i];
            if (percentile >= target) closest = percentile;
        }
        return closest;
    }
    // Map each target percentile to the closest lower or exact match.
    for (const target of $15aa5d5d7b95e9e5$var$VCTargets){
        const closestPercentile = findClosestLowerOrExact(parseInt(target, 10));
        result[target] = timestampPercent[closestPercentile.toString()];
    }
    return result;
}
function $15aa5d5d7b95e9e5$export$7a7da151d4392b63(a, b) {
    if (!a?.rect || !b?.rect) return false;
    return a.rect.left === b.rect.left && a.rect.right === b.rect.right && a.rect.top === b.rect.top && a.rect.bottom === b.rect.bottom;
}
function $15aa5d5d7b95e9e5$export$5af5bbbd334dc62c(a, b) {
    if (!a?.rect || !b?.rect) return false;
    return a.elementName === b.elementName;
}
function $15aa5d5d7b95e9e5$export$ae9df31ad5b40092(head, previousEntries) {
    const lastEntry = previousEntries[previousEntries.length - 1];
    if (head.source === 'mutation' && lastEntry.source === 'mutation' && $15aa5d5d7b95e9e5$export$5af5bbbd334dc62c(head, lastEntry) && $15aa5d5d7b95e9e5$export$7a7da151d4392b63(head, lastEntry)) return Math.round(lastEntry.time);
    return head.time;
}
function $15aa5d5d7b95e9e5$export$a8d3e725cc3ef683(head, previousEntries, options) {
    if (!(0, $jEB6I.isLayoutShift)(head) && !(0, $jEB6I.isNodeReplacement)(head) && !(0, $jEB6I.isElementMoved)(head)) return head;
    if ((0, $jEB6I.isLayoutShift)(head) && !options.ignoreLayoutShifts || (0, $jEB6I.isNodeReplacement)(head) && !options.ignoreNodeReplacements || (0, $jEB6I.isElementMoved)(head) && !options.ignoreElementMoved) return head;
    const entries = previousEntries.reduce((acc, e)=>{
        if ((0, $jEB6I.isNodeReplacement)(e) && options.ignoreNodeReplacements) return acc;
        if ((0, $jEB6I.isLayoutShift)(e) && options.ignoreLayoutShifts) return acc;
        if ((0, $jEB6I.isElementMoved)(e) && options.ignoreElementMoved) return acc;
        acc.push(e);
        return acc;
    }, []);
    return entries[entries.length - 1];
}
function $15aa5d5d7b95e9e5$export$acb29c5fe1c4de05(heatmap, options) {
    const flatHeapmap = heatmap.map.flat().map((entry, index)=>{
        const { head: head, previousEntries: previousEntries } = entry;
        if (!head) return 0;
        const validEntry = $15aa5d5d7b95e9e5$export$a8d3e725cc3ef683(head, previousEntries, options);
        return Math.round(validEntry?.time || 0);
    });
    if (flatHeapmap.length === 0) return {
        '100': 0
    };
    const timestampAmount = flatHeapmap.reduce((acc, value)=>{
        const timestampTrunc = Math.trunc(value);
        const curr = acc[timestampTrunc] || 0;
        acc[timestampTrunc] = curr + 1;
        return acc;
    }, {});
    let accAmount = 0;
    const VCPercent = Object.entries(timestampAmount).sort((a, b)=>{
        return parseInt(a[0], 10) - parseInt(b[0], 10);
    }).reduce((acc, [timestamp, amount])=>{
        const base = (amount + accAmount) / flatHeapmap.length;
        const percent = Math.round(base * 100);
        acc[percent] = parseInt(timestamp, 10);
        accAmount = accAmount + amount;
        return acc;
    }, {});
    return VCPercent;
}
function $15aa5d5d7b95e9e5$export$571bb02bfd45bd56(sortedArr, percentile) {
    const index = percentile / 100 * (sortedArr.length - 1);
    const lower = Math.floor(index);
    const upper = lower + 1;
    const weight = index % 1;
    if (upper >= sortedArr.length) return sortedArr[lower];
    const interpolatedValue = sortedArr[lower] * (1 - weight) + sortedArr[upper] * weight;
    return Math.round(interpolatedValue * 100) / 100;
}
function $15aa5d5d7b95e9e5$export$6b4f26c2830d670c(events) {
    if (events.length === 0) return null;
    const durations = events.map(({ data: data })=>data.duration).sort((a, b)=>a - b);
    const result = {
        p50: $15aa5d5d7b95e9e5$export$571bb02bfd45bd56(durations, 50),
        p85: $15aa5d5d7b95e9e5$export$571bb02bfd45bd56(durations, 85),
        p90: $15aa5d5d7b95e9e5$export$571bb02bfd45bd56(durations, 90),
        p95: $15aa5d5d7b95e9e5$export$571bb02bfd45bd56(durations, 95),
        p99: $15aa5d5d7b95e9e5$export$571bb02bfd45bd56(durations, 99)
    };
    return result;
}

});


parcelRegister("2sWkZ", function(module, exports) {

$parcel$export(module.exports, "getGlobalEditorMetricsObserver", () => $54da4de4e1cee5bc$export$7e8b28c58d095454);

var $ebD7P = parcelRequire("ebD7P");

var $3UX1p = parcelRequire("3UX1p");
const $54da4de4e1cee5bc$export$7e8b28c58d095454 = (options)=>{
    let observer = globalThis.__editor_performance_metrics_observer;
    if (observer) return observer;
    const timeline = new (0, $3UX1p.TimelineController)();
    observer = new (0, $ebD7P.EditorPerformanceObserver)(timeline, options);
    globalThis.__editor_performance_metrics_timeline = timeline;
    globalThis.__editor_performance_metrics_observer = observer;
    return observer;
};

});
parcelRegister("ebD7P", function(module, exports) {

$parcel$export(module.exports, "EditorPerformanceObserver", () => $5edb07845da1d412$export$2d87cc73b8c23acf);
/* eslint-disable compat/compat */ 
var $2JmDC = parcelRequire("2JmDC");

var $glEJc = parcelRequire("glEJc");

var $dsQ2g = parcelRequire("dsQ2g");

var $fl0hT = parcelRequire("fl0hT");

var $bnNJu = parcelRequire("bnNJu");

var $6Tt7F = parcelRequire("6Tt7F");

var $7KwYf = parcelRequire("7KwYf");
const $5edb07845da1d412$var$defaultOptions = {
    timers: {
        setTimeout: {
            maxTimeoutAllowedToTrack: 2000
        }
    }
};
class $5edb07845da1d412$export$2d87cc73b8c23acf {
    constructor(timeline, givenOptions){
        this.startTime = null;
        this.isStarted = false;
        this.observedTargetRef = null;
        this.wrapperApplied = false;
        this.wrapperCleanupFunctions = [];
        this.options = Object.assign($5edb07845da1d412$var$defaultOptions, givenOptions || {});
        this.timeline = timeline;
        this.vcSections = new WeakSet();
        // TODO: ED-26959 - make sure to get it from config
        const selectorConfig = {
            id: false,
            testId: true,
            role: false,
            className: false,
            dataVC: true
        };
        this.userEventsObserver = new (0, $bnNJu.UserEventsObserver)({
            onEventEntries: (entries)=>{
                entries.forEach((event)=>{
                    let elementName = 'not found';
                    const element = event.elementRef.deref();
                    if (element) elementName = (0, $fl0hT.getElementName)(selectorConfig, element);
                    const eventCategory = (0, $2JmDC.getEventCategory)(event.eventName);
                    timeline.markEvent({
                        type: `user-event:${eventCategory}`,
                        startTime: event.startTime,
                        data: {
                            category: eventCategory,
                            eventName: event.eventName,
                            duration: event.duration,
                            elementName: elementName
                        }
                    });
                });
            }
        });
        this.firstInteraction = new (0, $dsQ2g.FirstInteractionObserver)(this.onFirstInteraction.bind(this));
        this.domObservers = new (0, $glEJc.DOMObservers)({
            timeline: this.timeline,
            onChange: ({ startTime: startTime, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, source: source })=>{
                if (!visible) // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: when element is not visible we probably wants to add something
                return;
                const element = elementRef.deref();
                if (!element) return;
                const elementName = (0, $fl0hT.getElementName)(selectorConfig, element);
                const observedTarget = this.observedTargetRef?.deref();
                const wrapperSection = (0, $2JmDC.searchAncestors)(element, (e)=>{
                    const hasSection = this.vcSections.has(e);
                    if (hasSection) return 'found';
                    const isRootElement = e.parentElement === observedTarget;
                    if (isRootElement) return 'abort';
                    return 'continue';
                });
                if (!wrapperSection && element) this.vcSections.add(element);
                const wrapperSectionName = (0, $fl0hT.getElementName)(selectorConfig, wrapperSection || element);
                this.timeline.markEvent({
                    type: 'element:changed',
                    startTime: startTime,
                    data: {
                        wrapperSectionName: wrapperSectionName,
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        source: source
                    }
                });
            },
            onDOMContentChange: ({ targetRef: targetRef })=>{
                const mutationTarget = targetRef.deref();
                if (!mutationTarget) return;
                const observedTarget = this.observedTargetRef?.deref();
                const isRootChange = mutationTarget.parentElement === observedTarget;
                if (!isRootChange) this.vcSections.add(mutationTarget);
            }
        });
        this.timeline.onceAllSubscribersCleaned(()=>{
            this.cleanupWrappers();
        });
    }
    onFirstInteraction({ event: event, time: time }) {
        this.timeline.markEvent({
            type: 'abort:user-interaction',
            startTime: time,
            data: {
                source: event
            }
        });
        this.domObservers.disconnect();
    }
    start({ startTime: startTime }) {
        if (this.isStarted) return;
        const target = document.body;
        this.observedTargetRef = new WeakRef(target);
        this.startTime = startTime;
        this.domObservers.observe(target);
        this.isStarted = true;
    }
    onIdleBuffer(cb) {
        this.applyWrappersOnce();
        return this.timeline.onIdleBufferFlush(cb);
    }
    onceNextIdle(cb) {
        this.applyWrappersOnce();
        return this.timeline.onNextIdle(cb);
    }
    stop() {
        if (!this.isStarted) return;
        this.isStarted = false;
        this.domObservers.disconnect();
        this.firstInteraction.disconnect();
        this.userEventsObserver.disconnect();
        this.cleanupWrappers();
        this.timeline.cleanupSubscribers();
    }
    applyWrappersOnce() {
        if (this.wrapperApplied) return;
        const timersCleanup = (0, $7KwYf.wrapperTimers)({
            globalContext: globalThis || window,
            timelineHoldable: this.timeline,
            maxTimeoutAllowed: this.options.timers.setTimeout.maxTimeoutAllowedToTrack
        });
        const fetchCleanup = (0, $6Tt7F.wrapperFetch)({
            globalContext: globalThis || window,
            timelineHoldable: this.timeline
        });
        this.wrapperCleanupFunctions.push(timersCleanup, fetchCleanup);
        this.wrapperApplied = true;
    }
    cleanupWrappers() {
        this.wrapperCleanupFunctions.forEach((cleanup)=>cleanup());
        this.wrapperCleanupFunctions = [];
        this.wrapperApplied = false;
    }
}

});
parcelRegister("glEJc", function(module, exports) {

$parcel$export(module.exports, "DOMObservers", () => $7434e3571d79cbb2$export$a33745b0b1d6a85);

var $fhbiH = parcelRequire("fhbiH");
function $7434e3571d79cbb2$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $7434e3571d79cbb2$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $7434e3571d79cbb2$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
class $7434e3571d79cbb2$export$a33745b0b1d6a85 {
    constructor({ onDOMContentChange: onDOMContentChange, onChange: onChange, timeline: timeline }){
        this.mapVisibleNodeRects = new WeakMap();
        this.timeline = timeline;
        this.intersection = (0, $fhbiH.createIntersectionObserver)({
            onEntry: ({ target: target, rect: rect, startTime: startTime, taintedTag: taintedTag })=>{
                const visible = $7434e3571d79cbb2$var$isElementVisible(target);
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                this.mapVisibleNodeRects.set(target, rect);
                const source = taintedTag;
                onChange({
                    startTime: startTime,
                    elementRef: new WeakRef(target),
                    visible: visible,
                    rect: rect,
                    previousRect: lastElementRect,
                    source: source
                });
            },
            onObserved: ({ elements: elements, startTime: startTime })=>{
                this.timeline.markEvent({
                    type: 'IntersectionObserver:VisibleNodes',
                    startTime: startTime,
                    data: {
                        visibleElements: elements.length
                    }
                });
            }
        });
        this.mutations = (0, $fhbiH.createMutationObserver)({
            onAttributeMutation: ({ target: target })=>{
                this.intersection?.watchAndTag(target, ({ target: target, rect: rect })=>{
                    const lastElementRect = this.mapVisibleNodeRects.get(target);
                    if (lastElementRect && $7434e3571d79cbb2$var$sameRectSize(rect, lastElementRect)) return 'mutation:attribute:no-layout-shift';
                    return 'mutation:attribute';
                });
            },
            onMutationFinished: ({ targets: targets })=>{
                targets.forEach((target)=>{
                    onDOMContentChange({
                        targetRef: new WeakRef(target)
                    });
                });
            },
            onChildListMutation: ({ addedNodes: addedNodes, removedNodes: removedNodes })=>{
                const removedNodeRects = removedNodes.map((n)=>this.mapVisibleNodeRects.get(n));
                addedNodes.forEach((addedNode)=>{
                    for (const elem of addedNode.querySelectorAll('*'))this.intersection?.watchAndTag(elem, 'mutation:children-element');
                    const sameDeletedNode = removedNodes.find((n)=>n.isEqualNode(addedNode));
                    if (sameDeletedNode) {
                        this.intersection?.watchAndTag(addedNode, 'mutation:re-mounted');
                        return;
                    }
                    this.intersection?.watchAndTag(addedNode, ({ target: target, rect: rect })=>{
                        const wasDeleted = removedNodeRects.some((nr)=>$7434e3571d79cbb2$var$sameRectDimensions(nr, rect));
                        if (wasDeleted) return 'mutation:node-replacement';
                        return 'mutation:root-element';
                    });
                });
                this.timeline.markEvent({
                    type: 'DOMMutation:finished',
                    startTime: performance.now(),
                    data: {
                        addedNodes: addedNodes.length,
                        removedNodes: removedNodes.length
                    }
                });
            }
        });
        this.performance = (0, $fhbiH.createPerformanceObserver)({
            onFirstPaint: (startTime)=>{
                this.timeline.markEvent({
                    type: 'performance:first-paint',
                    startTime: startTime,
                    data: {}
                });
            },
            onFirstContentfulPaint: (startTime)=>{
                this.timeline.markEvent({
                    type: 'performance:first-contentful-paint',
                    startTime: startTime,
                    data: {}
                });
            },
            onLongTask: ({ startTime: startTime, duration: duration })=>{
                this.timeline.markEvent({
                    type: 'performance:long-task',
                    startTime: startTime,
                    data: {
                        duration: duration
                    }
                });
            },
            onLayoutShift: ({ startTime: startTime, changedRects: changedRects })=>{
                this.timeline.markEvent({
                    type: 'performance:layout-shift',
                    startTime: startTime,
                    data: {
                        changedRectsAmount: changedRects.length
                    }
                });
                changedRects.forEach(({ node: node, rect: rect })=>{
                    if (node instanceof HTMLElement) this.intersection?.watchAndTag(node, ({ target: target, rect: rect })=>{
                        const lastElementRect = this.mapVisibleNodeRects.get(target);
                        if (lastElementRect && $7434e3571d79cbb2$var$sameRectSize(rect, lastElementRect)) return 'layout-shift:element-moved';
                        return 'layout-shift';
                    });
                });
            }
        });
    }
    observe(target) {
        this.mutations?.observe(target, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performance?.observe({
            type: 'paint',
            buffered: true
        });
        this.performance?.observe({
            type: 'largest-contentful-paint',
            buffered: true
        });
        this.performance?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore-error
            durationThreshold: 30
        });
        this.performance?.observe({
            type: 'longtask',
            buffered: true
        });
    }
    disconnect() {
        this.mutations?.disconnect();
        this.performance?.disconnect();
        this.intersection?.disconnect();
    }
}

});
parcelRegister("fhbiH", function(module, exports) {

$parcel$export(module.exports, "createMutationObserver", () => $711d8a878b0a5d3e$export$9a3bd9795ab01d07);
$parcel$export(module.exports, "createIntersectionObserver", () => $711d8a878b0a5d3e$export$c3799d33e0ae80a5);
$parcel$export(module.exports, "createPerformanceObserver", () => $711d8a878b0a5d3e$export$6dcebc9ef8cfd999);
const $711d8a878b0a5d3e$var$isBrowserSupported = typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
function $711d8a878b0a5d3e$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $711d8a878b0a5d3e$export$9a3bd9795ab01d07({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!$711d8a878b0a5d3e$var$isBrowserSupported) return null;
    const observer = new MutationObserver((mutations)=>{
        const addedNodes = [];
        const removedNodes = [];
        const targets = [];
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if (mut.type === 'attributes') {
                onAttributeMutation({
                    target: mut.target
                });
                continue;
            } else if (mut.type === 'childList') {
                (mut.addedNodes || []).forEach((node)=>{
                    if (node instanceof HTMLElement) addedNodes.push(node);
                });
                (mut.removedNodes || []).forEach((node)=>{
                    if (node instanceof HTMLElement) removedNodes.push(node);
                });
            }
            targets.push(mut.target);
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished({
            targets: targets
        });
    });
    return observer;
}
function $711d8a878b0a5d3e$export$c3799d33e0ae80a5(props) {
    if (!$711d8a878b0a5d3e$var$isBrowserSupported) return null;
    const callbacksPerElement = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        // Reversing the entries is important because the
        // inner nodes should get be sent first to the observers
        entries.reverse().forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$711d8a878b0a5d3e$var$isValidEntry(entry)) return;
            let customTag = null;
            const doTag = callbacksPerElement.get(entry.target);
            if (typeof doTag === 'function') customTag = doTag({
                target: entry.target,
                rect: entry.intersectionRect
            });
            else if (typeof doTag === 'string') customTag = doTag;
            props.onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                startTime: entry.time,
                taintedTag: customTag || 'mutation'
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        props.onObserved({
            startTime: startTime,
            elements: validEntries
        });
    });
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, cbOrTag)=>{
            callbacksPerElement.set(target, cbOrTag);
            observer.observe(target);
        }
    };
}
function $711d8a878b0a5d3e$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $711d8a878b0a5d3e$export$6dcebc9ef8cfd999(props) {
    if (typeof window.PerformanceObserver !== 'function') return null;
    const observer = new PerformanceObserver((entries)=>{
        for (const entry of entries.getEntries()){
            if (entry.name === 'first-paint') props.onFirstPaint(entry.startTime);
            else if (entry.name === 'first-contentful-paint') props.onFirstContentfulPaint(entry.startTime);
            else if (entry.entryType === 'longtask') props.onLongTask({
                startTime: entry.startTime,
                duration: entry.duration
            });
            else if (entry.entryType === 'layout-shift') {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const changedRects = entry.sources.reduceRight((acc, attr)=>{
                    acc.push({
                        rect: $711d8a878b0a5d3e$export$5e3f54cad8cb65e2(attr.currentRect),
                        previousRect: $711d8a878b0a5d3e$export$5e3f54cad8cb65e2(attr.previousRect),
                        node: attr.node
                    });
                    return acc;
                }, []);
                props.onLayoutShift({
                    startTime: entry.startTime,
                    changedRects: changedRects
                });
            }
        }
    });
    return observer;
}

});


parcelRegister("dsQ2g", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionObserver", () => $28f33b70fe2526b4$export$acb3baebbe1fb8ca);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ function $28f33b70fe2526b4$var$bind(target, event, controller, listener) {
    // Safe check for rare cases where window doesn't exist
    if (!target || typeof target.addEventListener !== 'function') return ()=>{};
    const hasAbortSignal = typeof globalThis.AbortSignal === 'function' && controller.signal instanceof globalThis.AbortSignal;
    const options = {
        capture: true,
        passive: true,
        once: true,
        signal: hasAbortSignal ? controller.signal : undefined
    };
    target.addEventListener(event, listener, options);
    return function unbind() {
        target.removeEventListener(event, listener, options);
    };
}
var $28f33b70fe2526b4$var$AbortEvent = /*#__PURE__*/ function(AbortEvent) {
    AbortEvent["wheel"] = "wheel";
    AbortEvent["keydown"] = "keydown";
    AbortEvent["mousedown"] = "mousedown";
    AbortEvent["pointerdown"] = "pointerdown";
    AbortEvent["pointer"] = "pointerup";
    AbortEvent["touchend"] = "touchend";
    AbortEvent["resize"] = "resize";
    AbortEvent["unknown"] = "unknown";
    AbortEvent["scroll"] = "scroll";
    return AbortEvent;
}($28f33b70fe2526b4$var$AbortEvent || {});
class $28f33b70fe2526b4$export$acb3baebbe1fb8ca {
    constructor(onFirstInteraction){
        this.controller = new AbortController();
        this.unbindCallbacks = new Set();
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "keydown", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "keydown",
                time: performance.now()
            });
        }));
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "wheel", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "wheel",
                time: performance.now()
            });
        }));
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "scroll", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "scroll",
                time: performance.now()
            });
        }));
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "touchend", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "touchend",
                time: performance.now()
            });
        }));
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "pointerdown", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "pointerdown",
                time: performance.now()
            });
        }));
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "mousedown", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "mousedown",
                time: performance.now()
            });
        }));
        this.unbindCallbacks.add($28f33b70fe2526b4$var$bind(window, "resize", this.controller, ()=>{
            this.unbindFirstInteractionEvents();
            onFirstInteraction({
                event: "resize",
                time: performance.now()
            });
        }));
    }
    unbindFirstInteractionEvents() {
        const { controller: controller, unbindCallbacks: unbindCallbacks } = this;
        if (controller) controller.abort();
        unbindCallbacks.forEach((cb)=>{
            cb();
        });
        unbindCallbacks.clear();
    }
    disconnect() {
        this.unbindFirstInteractionEvents();
    }
}

});

parcelRegister("fl0hT", function(module, exports) {

$parcel$export(module.exports, "getElementName", () => $4a3cd38519405a27$export$cb26d1ee6764af05);
const $4a3cd38519405a27$var$nameCache = new WeakMap();
function $4a3cd38519405a27$export$cb26d1ee6764af05(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $4a3cd38519405a27$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $4a3cd38519405a27$export$cb26d1ee6764af05(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $4a3cd38519405a27$var$nameCache.set(element, name);
    return name;
}

});

parcelRegister("bnNJu", function(module, exports) {

$parcel$export(module.exports, "UserEventsObserver", () => $6cbdec9aae1d74f0$export$49cb2a420b7e42b2);

var $4LKas = parcelRequire("4LKas");
const $6cbdec9aae1d74f0$var$ALLOWED_DURATION = 40;
const $6cbdec9aae1d74f0$export$baa2eb4fdd2cceb8 = (entry)=>{
    const { startTime: startTime, processingEnd: // @ts-expect-error
    processingEnd, processingStart: // @ts-expect-error
    processingStart, target: // @ts-expect-error
    target, duration: duration, name: name } = entry;
    if (typeof processingEnd !== 'number' || typeof processingStart !== 'number') return null;
    const timeToProcessEvent = processingEnd - processingStart;
    if (timeToProcessEvent <= 0) return null;
    if (!(target instanceof HTMLElement)) return null;
    const eventProcessingDuration = processingEnd - startTime;
    if (duration <= $6cbdec9aae1d74f0$var$ALLOWED_DURATION || eventProcessingDuration <= $6cbdec9aae1d74f0$var$ALLOWED_DURATION) return null;
    return {
        eventName: name,
        startTime: startTime,
        duration: duration,
        elementRef: new WeakRef(target)
    };
};
const $6cbdec9aae1d74f0$export$6dcebc9ef8cfd999 = (cb)=>{
    return new PerformanceObserver(cb);
};
class $6cbdec9aae1d74f0$export$49cb2a420b7e42b2 {
    constructor({ onEventEntries: onEventEntries }){
        if (typeof globalThis.PerformanceObserver !== 'function') return;
        this.observer = $6cbdec9aae1d74f0$export$6dcebc9ef8cfd999((list)=>{
            (0, $4LKas.backgroundTask)(()=>{
                const mappedEvents = list.getEntries().reduce((acc, value)=>{
                    const transformed = $6cbdec9aae1d74f0$export$baa2eb4fdd2cceb8(value);
                    if (transformed) acc.push(transformed);
                    return acc;
                }, []);
                onEventEntries(mappedEvents);
            });
        });
        this.observer.observe({
            type: 'event',
            buffered: true,
            // @ts-expect-error
            durationThreshold: 16
        });
    }
    disconnect() {
        this.observer?.disconnect();
    }
}

});

parcelRegister("6Tt7F", function(module, exports) {

$parcel$export(module.exports, "wrapperFetch", () => $a9c213fe966c6100$export$4ccf18683d425af4);
const $a9c213fe966c6100$export$4ccf18683d425af4 = ({ globalContext: globalContext, timelineHoldable: timelineHoldable })=>{
    const originalFetch = globalContext.fetch;
    const fetchProxy = new Proxy(globalContext.fetch, {
        apply (target, thisArg, args) {
            const unhold = timelineHoldable.hold({
                source: 'fetch'
            });
            try {
                const promise = target.apply(thisArg, args);
                return promise.finally(()=>{
                    unhold();
                });
            } catch (e) {
                unhold();
                throw e;
            }
        }
    });
    globalContext.fetch = fetchProxy;
    return function cleanup() {
        globalContext.fetch = originalFetch;
    };
};

});

parcelRegister("7KwYf", function(module, exports) {

$parcel$export(module.exports, "wrapperTimers", () => $6981a2857a7638c1$export$a179e8bdccbac58e);
const $6981a2857a7638c1$var$MAX_TIMEOUT_DELAY_ALLOWED_TO_BE_WRAPPED = 2000; // 2 seconds
const $6981a2857a7638c1$var$MAX_NESTED_TIMERS_ALLOWED_TO_BE_WRAPPED = 1;
const $6981a2857a7638c1$export$a179e8bdccbac58e = ({ globalContext: globalContext, timelineHoldable: timelineHoldable, maxTimeoutAllowed: maxTimeoutAllowed, maxNestedTimers: maxNestedTimers })=>{
    const timeoutsUnholdMap = new Map();
    const timeoutAllowed = typeof maxTimeoutAllowed === 'number' ? maxTimeoutAllowed : $6981a2857a7638c1$var$MAX_TIMEOUT_DELAY_ALLOWED_TO_BE_WRAPPED;
    const nestedTimersAllowed = typeof maxNestedTimers === 'number' ? maxNestedTimers : $6981a2857a7638c1$var$MAX_NESTED_TIMERS_ALLOWED_TO_BE_WRAPPED;
    const originalSetTimeout = globalContext.setTimeout;
    const originalClearTimeout = globalContext.clearTimeout;
    /**
	 * This counter is used to prevent recursive wrapping of setTimeout calls.
	 *
	 * Due to JavaScript's lexical scoping, this variable will be shared across
	 * all invocations of the setTimeoutProxy within the same wrapperTimers call.
	 * This allows us to track whether we're currently inside a wrapped callback
	 * and how deeep.
	 *
	 * This prevents excessive hold/unhold calls and potential issues with
	 * nested timeouts, while still allowing the outer timeout to be tracked.
	 *
	 */ let nestedCallsTimerCount = 0;
    const setTimeoutProxy = new Proxy(globalContext.setTimeout, {
        apply (target, thisArg, args) {
            const delayTime = args.length > 1 && typeof args[1] === 'number' ? args[1] : null;
            const isValidDelayTime = typeof delayTime !== 'number' || delayTime === 0 || delayTime > timeoutAllowed;
            if (isValidDelayTime || nestedCallsTimerCount >= nestedTimersAllowed) return target.apply(thisArg, args);
            const localNestedCounter = nestedCallsTimerCount;
            const unhold = timelineHoldable.hold({
                source: 'setTimeout'
            });
            let timerId = null;
            const callbackProxy = new Proxy(args[0], {
                apply (callbackTarget, cbThisArg, cbArgs) {
                    nestedCallsTimerCount = localNestedCounter + 1;
                    try {
                        const result = callbackTarget.apply(cbThisArg, cbArgs);
                        return result;
                    } finally{
                        unhold();
                        if (timerId !== null) timeoutsUnholdMap.delete(timerId);
                    }
                }
            });
            timerId = target.apply(thisArg, [
                callbackProxy,
                // Mistach between the NodeJS type and the Browser implementation
                // @ts-expect-error
                ...args.slice(1)
            ]);
            timeoutsUnholdMap.set(timerId, new WeakRef(unhold));
            return timerId;
        }
    });
    const clearTimeoutProxy = new Proxy(globalContext.clearTimeout, {
        apply (target, thisArg, args) {
            const tm = args[0];
            if (typeof tm !== 'number') return target.apply(thisArg, args);
            const unholdRef = timeoutsUnholdMap.get(tm);
            if (unholdRef) {
                const unhold = unholdRef.deref();
                if (unhold) unhold();
                timeoutsUnholdMap.delete(tm);
            }
            return target.apply(thisArg, args);
        }
    });
    globalContext.setTimeout = setTimeoutProxy;
    globalContext.clearTimeout = clearTimeoutProxy;
    return function cleanup() {
        globalContext.setTimeout = originalSetTimeout;
        globalContext.clearTimeout = originalClearTimeout;
    };
};

});


parcelRegister("3UX1p", function(module, exports) {

$parcel$export(module.exports, "TimelineController", () => $6eebdf3dbc301e5d$export$33d15e092164e5ef);

var $4LKas = parcelRequire("4LKas");
const $6eebdf3dbc301e5d$var$defaultOptions = {
    cleanup: {
        eventsThreshold: 3000
    },
    buffer: {
        eventsThreshold: 200,
        cyclesThreshold: 5
    },
    maxHoldDuration: 5000
};
function $6eebdf3dbc301e5d$var$getRandomId() {
    if (!globalThis.crypto || typeof globalThis.crypto.randomUUID !== 'function') // Not the best fallback, but the crypto.randomUUID is widely available
    return (Math.random() + 1).toString(36).substring(20);
    return globalThis.crypto.randomUUID();
}
class $6eebdf3dbc301e5d$export$33d15e092164e5ef {
    constructor(givenOptions){
        this.idleCycleCount = 0;
        this.lastIdleTime = null;
        this.lastIdleTask = null;
        this.allSubscribersCleanedCallback = null;
        this.holdStartTimes = new Map();
        this.options = Object.assign($6eebdf3dbc301e5d$var$defaultOptions, givenOptions || {});
        this.unorderedEvents = [];
        this.idleCycleCount = 0;
        this.onIdleBufferFlushCallbacks = new Set();
        this.onNextIdleCallbacks = new Set();
        this.eventsPerType = new Map();
        this.idleBuffer = {
            unorderedEvents: [],
            eventsPerType: new Map()
        };
    }
    attemptCleanup() {
        if (this.unorderedEvents.length <= this.options.cleanup.eventsThreshold) return;
        this.lastIdleTime = null;
        if (this.lastIdleTask) this.lastIdleTask.abort();
        this.lastIdleTask = null;
        const lastSize = this.unorderedEvents.length;
        this.eventsPerType.clear();
        this.unorderedEvents = [
            {
                type: 'timeline:clean-up',
                startTime: performance.now(),
                data: {
                    previousAmountOfEvents: lastSize,
                    source: 'manual'
                }
            }
        ];
    }
    hold({ source: source }) {
        const startTime = performance.now();
        const holdId = $6eebdf3dbc301e5d$var$getRandomId();
        this.holdStartTimes.set(holdId, startTime);
        this.markEvent({
            startTime: startTime,
            type: 'hold-idle:start',
            data: {
                source: source,
                uuid: holdId
            }
        });
        return ()=>{
            this.holdStartTimes.delete(holdId);
            const holdEndTime = performance.now();
            this.markEvent({
                startTime: holdEndTime,
                type: 'hold-idle:end',
                data: {
                    source: source,
                    duration: holdEndTime - startTime,
                    uuid: holdId
                }
            });
            if (this.holdStartTimes.size === 0) this.scheduleNextIdle();
        };
    }
    cleanupSubscribers() {
        this.flushIdleBuffer(this.idleBuffer);
        this.onIdleBufferFlushCallbacks.clear();
        this.onNextIdleCallbacks.clear();
        this.checkAllSubscribersCleared();
    }
    addEventInternal(event) {
        this.unorderedEvents.push(event);
        this.updateEventsPerType(event);
        this.addToIdleBuffer(event);
    }
    updateEventsPerType(event) {
        const events = this.eventsPerType.get(event.type) || [];
        // @ts-expect-error
        events.push(event);
        this.eventsPerType.set(event.type, events);
    }
    addToIdleBuffer(event) {
        this.idleBuffer.unorderedEvents.push(event);
        const events = this.idleBuffer.eventsPerType.get(event.type) || [];
        // @ts-expect-error
        events.push(event);
        this.idleBuffer.eventsPerType.set(event.type, events);
    }
    markEvent(event) {
        this.attemptCleanup();
        this.addEventInternal(event);
        this.scheduleNextIdle();
    }
    getEvents() {
        return this.unorderedEvents.sort((a, b)=>{
            if (a.startTime < b.startTime) return -1;
            if (a.startTime > b.startTime) return 1;
            return 0;
        });
    }
    getEventsPerType(type) {
        const r = this.eventsPerType.get(type) || [];
        return r;
    }
    onIdleBufferFlush(cb) {
        this.onIdleBufferFlushCallbacks.add(cb);
        return ()=>{
            this.onIdleBufferFlushCallbacks.delete(cb);
            this.checkAllSubscribersCleared();
        };
    }
    onNextIdle(cb) {
        this.onNextIdleCallbacks.add(cb);
        return ()=>{
            this.onNextIdleCallbacks.delete(cb);
            this.checkAllSubscribersCleared();
        };
    }
    onceAllSubscribersCleaned(callback) {
        this.allSubscribersCleanedCallback = callback;
    }
    checkAllSubscribersCleared() {
        if (this.onIdleBufferFlushCallbacks.size === 0 && this.onNextIdleCallbacks.size === 0 && this.allSubscribersCleanedCallback) this.allSubscribersCleanedCallback();
    }
    checkHoldTimeout() {
        if (this.holdStartTimes.size === 0) return;
        const currentTime = performance.now();
        const iterator = this.holdStartTimes.entries();
        let [holdId, holdStartTime] = iterator.next().value;
        while(typeof holdStartTime === 'number'){
            const lastHoldDelta = currentTime - holdStartTime;
            if (lastHoldDelta < this.options.maxHoldDuration) return;
            this.addEventInternal({
                type: 'hold-idle:timeout',
                startTime: currentTime,
                data: {
                    holdedAt: holdStartTime,
                    uuid: holdId
                }
            });
            this.holdStartTimes.delete(holdId);
            [holdId, holdStartTime] = iterator.next().value || [];
        }
    }
    scheduleNextIdle() {
        this.checkHoldTimeout();
        if (this.holdStartTimes.size > 0) return;
        if (this.lastIdleTask) this.lastIdleTask.abort();
        const startAt = performance.now();
        const handleIdleBinded = this.handleIdle.bind(this, startAt);
        this.lastIdleTask = (0, $4LKas.backgroundTask)(handleIdleBinded, {
            // For Timeline idles, we required at least 200ms of non-busy thread
            delay: 200
        });
    }
    handleIdle(startAt) {
        if (this.holdStartTimes.size > 0) return;
        const idleTimeEvent = {
            type: 'idle-time',
            startTime: performance.now(),
            data: {
                duration: performance.now() - startAt
            }
        };
        this.addEventInternal(idleTimeEvent);
        this.idleCycleCount++;
        this.lastIdleTime = idleTimeEvent;
        const buffer = this.idleBuffer;
        this.attemptFlushIdleBuffer(buffer);
        this.callOnNextIdleCallbacks(buffer);
    }
    callOnNextIdleCallbacks(buffer) {
        const idleAt = performance.now();
        const timelineBuffer = $6eebdf3dbc301e5d$export$d5ea1045eb6a501d(buffer);
        for (const cb of this.onNextIdleCallbacks)(0, $4LKas.backgroundTask)(()=>cb({
                idleAt: idleAt,
                timelineBuffer: timelineBuffer
            }));
        this.onNextIdleCallbacks.clear();
    }
    attemptFlushIdleBuffer(buffer) {
        if (!this.options.buffer) {
            this.flushIdleBuffer(buffer);
            return;
        }
        const { eventsThreshold: eventsThreshold, cyclesThreshold: cyclesThreshold } = this.options.buffer;
        const hasCrossedEventBufferThreshold = this.idleBuffer.unorderedEvents.length > eventsThreshold;
        const hasCrossedCycleCountThreshold = this.idleCycleCount > cyclesThreshold;
        if (hasCrossedEventBufferThreshold || hasCrossedCycleCountThreshold) this.flushIdleBuffer(buffer);
    }
    flushIdleBuffer(buffer) {
        this.clearIdleBuffer();
        const idleAt = performance.now();
        this.idleCycleCount = 0; // Reset cycle count
        const timelineBuffer = $6eebdf3dbc301e5d$export$d5ea1045eb6a501d(buffer);
        for (const cb of this.onIdleBufferFlushCallbacks)(0, $4LKas.backgroundTask)(()=>cb({
                idleAt: idleAt,
                timelineBuffer: timelineBuffer
            }));
    }
    clearIdleBuffer() {
        this.idleBuffer = {
            unorderedEvents: [],
            eventsPerType: new Map()
        };
    }
    serialise() {
        const result = [];
        for (const [key, value] of this.eventsPerType.entries()){
            // TODO: ED-26959 - maybe implement a proper clone?
            const entry = [
                key,
                [
                    ...value
                ]
            ];
            // @ts-ignore
            result.push(entry);
        }
        return result;
    }
}
function $6eebdf3dbc301e5d$export$2d5251d0a20b15ff(obj) {
    const eventsPerType = new Map(obj);
    const allEvents = Array.from(eventsPerType.values()).flat();
    return {
        getEvents () {
            return allEvents.sort((a, b)=>{
                if (a.startTime < b.startTime) return -1;
                if (a.startTime > b.startTime) return 1;
                return 0;
            });
        },
        getEventsPerType (type) {
            const r = eventsPerType.get(type) || [];
            return r;
        }
    };
}
function $6eebdf3dbc301e5d$export$d5ea1045eb6a501d({ unorderedEvents: unorderedEvents, eventsPerType: eventsPerType }) {
    const shallowUnorderedEventsCopy = [
        ...unorderedEvents
    ];
    const copyEventsPerType = new Map(eventsPerType);
    return {
        getEvents () {
            return shallowUnorderedEventsCopy.sort((a, b)=>{
                if (a.startTime < b.startTime) return -1;
                if (a.startTime > b.startTime) return 1;
                return 0;
            });
        },
        getEventsPerType (type) {
            const r = copyEventsPerType.get(type) || [];
            return r;
        }
    };
}

});




parcelRegister("2E1QW", function(module, exports) {

$parcel$export(module.exports, "EditorINPMetrics", () => $50f25bf0d2d29280$export$5942461441325be9);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $4UKRW = parcelRequire("4UKRW");

var $bFU4G = parcelRequire("bFU4G");
const $50f25bf0d2d29280$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $2NMNM.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $5uXOq.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $50f25bf0d2d29280$var$createIdleCallback(()=>{
            cleanupFn = (0, $4UKRW.setupINPTracking)(({ value: value })=>{
                const interaction = (0, $bFU4G.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $50f25bf0d2d29280$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $50f25bf0d2d29280$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $50f25bf0d2d29280$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};

});
parcelRegister("4UKRW", function(module, exports) {

$parcel$export(module.exports, "setupINPTracking", () => $5650593f5a79c4e4$export$56930d9a67e0aae6);

var $64jjv = parcelRequire("64jjv");

var $6cAn5 = parcelRequire("6cAn5");
const $5650593f5a79c4e4$export$56930d9a67e0aae6 = (callback)=>{
    if (!$5650593f5a79c4e4$var$isINPSupported()) return;
    return (0, $64jjv.onINP)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $5650593f5a79c4e4$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $6cAn5 !== 'undefined' && Boolean($6cAn5?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};

});
parcelRegister("64jjv", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $72521b5ed45c791e$export$7df4b36ecaed99e1);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts

var $k7PDJ = parcelRequire("k7PDJ");

var $6R2LH = parcelRequire("6R2LH");

var $gvLIy = parcelRequire("gvLIy");

var $gZE3o = parcelRequire("gZE3o");
const $72521b5ed45c791e$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $k7PDJ.bindReporter)(callback);
    const interactionManager = new (0, $6R2LH.InteractionManager)();
    const handleEntries = (entries)=>{
        (0, $gZE3o.whenIdle)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $72521b5ed45c791e$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $gvLIy.onHidden)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $72521b5ed45c791e$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};

});
parcelRegister("k7PDJ", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $95736c0e24388675$export$17679dccdd551979);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $95736c0e24388675$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};

});

parcelRegister("6R2LH", function(module, exports) {

$parcel$export(module.exports, "InteractionManager", () => $0dce2132e627a665$export$aaa80641d584351c);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts

var $8sEWa = parcelRequire("8sEWa");
class $0dce2132e627a665$export$aaa80641d584351c {
    static{
        this.MAX_INTERACTIONS_TO_CONSIDER = 10;
    }
    constructor(){
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $8sEWa.InteractionCountPolyfill)();
    }
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
	 * Returns the estimated p98 longest interaction based on the stored
	 * interaction candidates and the interaction count for the current page.
	 */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
	 * Takes a performance entry and adds it to the list of worst interactions
	 * if its duration is long enough to make it among the worst. If the
	 * entry is part of an existing interaction, it is merged and the latency
	 * and entries list is updated as needed.
	 */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $0dce2132e627a665$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $0dce2132e627a665$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($0dce2132e627a665$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
}

});
parcelRegister("8sEWa", function(module, exports) {

$parcel$export(module.exports, "InteractionCountPolyfill", () => $8d7ae74f6dbc524a$export$51e52147760fc784);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $8d7ae74f6dbc524a$export$51e52147760fc784 {
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
	 * Returns the `interactionCount` value using the native API (if available)
	 * or the polyfill estimate in this module.
	 */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
}

});


parcelRegister("gvLIy", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $7bab6a12dd8cc283$export$91ec2be6fdd8f1b4);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $7bab6a12dd8cc283$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};

});

parcelRegister("gZE3o", function(module, exports) {

$parcel$export(module.exports, "whenIdle", () => $b819e9ee269a4812$export$4d9952dcbf5b2792);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

var $gvLIy = parcelRequire("gvLIy");
const $b819e9ee269a4812$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $b819e9ee269a4812$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $gvLIy.onHidden)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $b819e9ee269a4812$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});




parcelRegister("cjRyP", function(module, exports) {

$parcel$export(module.exports, "EditorInternal", () => $71ed6365bae516ba$export$2617c0dabe49c335);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gkwXh = parcelRequire("gkwXh");

var $gJcSd = parcelRequire("gJcSd");

var $VSDnB = parcelRequire("VSDnB");

var $ax7J7 = parcelRequire("ax7J7");

var $fbZFm = parcelRequire("fbZFm");

var $ankW9 = parcelRequire("ankW9");

var $fggrl = parcelRequire("fggrl");

var $fkGS3 = parcelRequire("fkGS3");

var $g5Huu = parcelRequire("g5Huu");

var $j0Vvw = parcelRequire("j0Vvw");

var $8pML4 = parcelRequire("8pML4");
function $71ed6365bae516ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $71ed6365bae516ba$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $71ed6365bae516ba$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $5uXOq.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $fkGS3.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = (0, $VSDnB.fg)('platform_editor_legacy_content_macro') ? !(0, $VSDnB.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking : !(0, $VSDnB.fg)('platform_editor_disable_rerender_tracking_jira');
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $gJcSd.usePortalProvider)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $gJcSd.usePortalProvider)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g5Huu.RenderTracking), {
        componentProps: props,
        action: (0, $gkwXh.ACTION).RE_RENDERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ax7J7.default), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $71ed6365bae516ba$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ankW9.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fggrl.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fbZFm.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $j0Vvw.BaseThemeWrapper), {
                baseFontSize: (0, $8pML4.getBaseFontSize)(props.appearance)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeViewPortalRenderer, null)))))));
});

});
parcelRegister("gJcSd", function(module, exports) {

$parcel$export(module.exports, "usePortalProvider", () => $1a1c543e60e2eb98$export$9b00782c24eb3d6b);

var $5uXOq = parcelRequire("5uXOq");

var $fi43S = parcelRequire("fi43S");

var $kPNeK = parcelRequire("kPNeK");
function $1a1c543e60e2eb98$export$9b00782c24eb3d6b() {
    const portalManager = (0, $5uXOq.useMemo)(()=>new (0, $kPNeK.PortalManager)(), []);
    const PortalRenderer = (0, $5uXOq.useMemo)(()=>(0, $fi43S.createPortalRendererComponent)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $5uXOq.useMemo)(()=>(0, $fi43S.getPortalProviderAPI)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("fi43S", function(module, exports) {

$parcel$export(module.exports, "createPortalRendererComponent", () => $1acbd9e60fdf02dd$export$adfaaa25a1ea6e69);
$parcel$export(module.exports, "getPortalProviderAPI", () => $1acbd9e60fdf02dd$export$3a6b5f5c5bba4bde);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fh7Yr = parcelRequire("fh7Yr");
function $1acbd9e60fdf02dd$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $5uXOq.useState)(portalManager.getBuckets());
        (0, $5uXOq.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $5uXOq.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fh7Yr.PortalBucket), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: portalsElements
        });
    };
}
const $1acbd9e60fdf02dd$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: getChildren()
    });
};
const $1acbd9e60fdf02dd$var$PortalRenderWrapper = /*#__PURE__*/ (0, $5uXOq.memo)($1acbd9e60fdf02dd$export$eab0ea19ad3bed77);
$1acbd9e60fdf02dd$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $1acbd9e60fdf02dd$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)($1acbd9e60fdf02dd$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            } else {
                const portal = /*#__PURE__*/ (0, $7nsd3.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};

});
parcelRegister("fh7Yr", function(module, exports) {

$parcel$export(module.exports, "PortalBucket", () => $0dce56c275d3c858$export$828f0f29e8293a07);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $0dce56c275d3c858$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $5uXOq.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $5uXOq.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $5uXOq.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: portalElements
    });
}

});


parcelRegister("kPNeK", function(module, exports) {

$parcel$export(module.exports, "PortalManager", () => $1815e788e0c02d29$export$52c7ef79917c2f38);
const $1815e788e0c02d29$var$DEFAULT_INITIAL_BUCKETS = 50;
const $1815e788e0c02d29$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $1815e788e0c02d29$var$DEFAULT_SCALE_RATIO = 0.5;
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $1815e788e0c02d29$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $1815e788e0c02d29$export$52c7ef79917c2f38 {
    constructor(initialBuckets = $1815e788e0c02d29$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $1815e788e0c02d29$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $1815e788e0c02d29$var$DEFAULT_SCALE_RATIO){
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$1815e788e0c02d29$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
    }
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($1815e788e0c02d29$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
    }
    updateBuckets(id) {
        this.buckets[id].updater?.(()=>{
            // new object is required to trigger react updates
            return {
                ...this.buckets[id].portals
            };
        });
    }
    registerPortal(key, portal) {
        this.createBucket();
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        this.portalToBucketMap.set(key, id);
        if (this.buckets[id].portals[key] !== portal) {
            this.buckets[id].portals[key] = portal;
            this.updateBuckets(id);
        }
        //returns a function to unregister the portal
        return ()=>{
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            this.buckets[id].capacity += 1;
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) this.availableBuckets.add(id);
            this.updateBuckets(id);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
	 * Cleans up resources used by the PortalManager. This includes clearing all portals,
	 * unregistering all buckets, and resetting internal state.
	 */ destroy() {
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
}

});


parcelRegister("ax7J7", function(module, exports) {

$parcel$export(module.exports, "default", () => $60d0c72e469dbfd3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $ifv4n = parcelRequire("ifv4n");

var $fIJEx = parcelRequire("fIJEx");

var $1KzE6 = parcelRequire("1KzE6");

var $1eqsC = parcelRequire("1eqsC");

var $jAZiu = parcelRequire("jAZiu");
class $60d0c72e469dbfd3$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            rethrow: true,
            errorTracking: true
        };
    }
    constructor(props){
        super(props), this.browserExtensions = undefined, this.state = {
            error: undefined
        }, this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $ifv4n.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $1eqsC.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            (0, $1KzE6.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        }, this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        }, this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $ctLRZ.editorAnalyticsChannel));
        };
        this.featureFlags = props.featureFlags;
    }
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fIJEx.IntlErrorBoundary), {
            children: this.props.children
        });
    }
}
var $60d0c72e469dbfd3$export$2e2bcd8739ae039 = (0, $jAZiu.WithEditorView)($60d0c72e469dbfd3$export$d6d3bedcc5fc09c8);

});
parcelRegister("ifv4n", function(module, exports) {

$parcel$export(module.exports, "getDocStructure", () => $a2ddee04b57518c1$export$6451b72139862cbd);
const $a2ddee04b57518c1$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $a2ddee04b57518c1$var$shortHash(type, isMark) {
    const code = $a2ddee04b57518c1$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $a2ddee04b57518c1$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$a2ddee04b57518c1$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$a2ddee04b57518c1$var$compactStringifier(node)).join(',');
    return marks(`${$a2ddee04b57518c1$var$shortHash(node.type, false)}(${content})`);
}
const $a2ddee04b57518c1$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $a2ddee04b57518c1$var$getBlockNode(doc, 0);
        if (options?.compact) return $a2ddee04b57518c1$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $a2ddee04b57518c1$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $a2ddee04b57518c1$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $a2ddee04b57518c1$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $a2ddee04b57518c1$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $a2ddee04b57518c1$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $a2ddee04b57518c1$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $a2ddee04b57518c1$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $a2ddee04b57518c1$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $a2ddee04b57518c1$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("1eqsC", function(module, exports) {

$parcel$export(module.exports, "isOutdatedBrowser", () => $f4d0395ac92d9621$export$12d09524e028927);
const $f4d0395ac92d9621$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const gecko = /gecko\/\d/i.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? // eslint-disable-next-line require-unicode-regexp
    parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};

});

parcelRegister("jAZiu", function(module, exports) {

$parcel$export(module.exports, "WithEditorView", () => $54173e5a1716911b$export$cf381084b490bd31);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ankW9 = parcelRequire("ankW9");
const $54173e5a1716911b$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $ankW9.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};

});


parcelRegister("fbZFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0780699b8986d8d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bXrHm = parcelRequire("bXrHm");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");
var $hETfp = parcelRequire("hETfp");

var $lY6DM = parcelRequire("lY6DM");

var $2cB15 = parcelRequire("2cB15");
var $7Em36 = parcelRequire("7Em36");

var $4zXba = parcelRequire("4zXba");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $3IZIX = parcelRequire("3IZIX");

var $agxMF = parcelRequire("agxMF");

var $12Kqg = parcelRequire("12Kqg");

var $4NUlu = parcelRequire("4NUlu");

var $ggL2v = parcelRequire("ggL2v");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $geOTC = parcelRequire("geOTC");

var $fkGS3 = parcelRequire("fkGS3");

var $az5cZ = parcelRequire("az5cZ");

var $5j6KQ = parcelRequire("5j6KQ");

var $g5Huu = parcelRequire("g5Huu");

var $5cNeT = parcelRequire("5cNeT");


var $9MoyJ = parcelRequire("9MoyJ");

var $gAD8U = parcelRequire("gAD8U");

var $ijurB = parcelRequire("ijurB");

var $h0q50 = parcelRequire("h0q50");

var $7HMhY = parcelRequire("7HMhY");

var $cj93n = parcelRequire("cj93n");

var $jNTUV = parcelRequire("jNTUV");

var $kpgvz = parcelRequire("kpgvz");
const $b0780699b8986d8d$var$EDIT_AREA_ID = 'ak-editor-textarea';
const $b0780699b8986d8d$var$focusElementOutsideEditor = ()=>{
    // TODO: ED-26841 - This is an awful way of selecting this, would love a
    // better way be that a ref or even an id or data attibute.
    const aiButton = document.querySelector('[data-testid="platform-ai-button"]');
    if (aiButton && aiButton instanceof HTMLElement) aiButton.focus();
};
function $b0780699b8986d8d$export$e7d1b1cbca007e16(props) {
    const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const [editorAPI, setEditorAPI] = (0, $5uXOq.useState)(undefined);
    const editorRef = (0, $5uXOq.useRef)(null);
    const viewRef = (0, $5uXOq.useRef)();
    const focusTimeoutId = (0, $5uXOq.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $5uXOq.useRef)(true);
    const editorId = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    const eventDispatcher = (0, $5uXOq.useMemo)(()=>new (0, $lY6DM.EventDispatcher)(), []);
    const config = (0, $5uXOq.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $5uXOq.useRef)(undefined);
    const featureFlags = (0, $5uXOq.useMemo)(()=>(0, $fkGS3.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $5uXOq.useCallback)(()=>viewRef.current?.state, []);
    const getEditorView = (0, $5uXOq.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $5uXOq.useMemo)(()=>(0, $lY6DM.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $5uXOq.useMemo)(()=>(0, $9MoyJ.createErrorReporter)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        (0, $ctLRZ.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        const dispatch = (0, $lY6DM.createDispatch)(eventDispatcher);
        dispatch((0, $4NUlu.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $5uXOq.useRef)(new (0, $3IZIX.EditorPluginInjectionAPI)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent
    }));
    (0, $5uXOq.useLayoutEffect)(()=>{
        setEditorAPI(pluginInjectionAPI.current.api());
    }, []);
    const createEditorState = (0, $5uXOq.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
					 * ReactEditorView currently does NOT handle dynamic schema,
					 * We are reusing the existing schema, and rely on #reconfigureState
					 * to update `this.config`
					 */ schema = viewRef.current.state.schema;
            else {
                /**
					 * There's presently a number of issues with changing the schema of a
					 * editor inflight. A significant issue is that we lose the ability
					 * to keep track of a user's history as the internal plugin state
					 * keeps a list of Steps to undo/redo (which are tied to the schema).
					 * Without a good way to do work around this, we prevent this for now.
					 */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $9MoyJ.processPluginsList)((0, $gAD8U.default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
            schema = (0, $ijurB.createSchema)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $9MoyJ.createPMPlugins)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $VSDnB.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        let doc;
        if (options.doc) {
            // if the collabEdit API is set, skip this validation due to potential pm validation errors
            // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
            if (api?.collabEdit !== undefined && (0, $VSDnB.fg)('editor_load_conf_collab_docs_without_checks') || options.props.editorProps.skipValidation) doc = (0, $agxMF.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
            else doc = (0, $agxMF.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
        }
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $gZGBX.TextSelection)(doc.resolve(0));
                return (0, $gZGBX.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $gZGBX.Selection).atStart(doc) : (0, $gZGBX.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $gZGBX.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $gZGBX.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $5uXOq.useMemo)(()=>createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $5j6KQ.isFullPage)(nextAppearance)
        }), // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $5uXOq.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $5uXOq.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $5uXOq.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local'
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $2cB15.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).STARTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $hETfp.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $4zXba.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        });
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    const reconfigureState = (0, $5uXOq.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $gAD8U.default)(props.preset, props.editorProps, pluginInjectionAPI.current);
        config.current = (0, $9MoyJ.processPluginsList)(editorPlugins);
        const state = viewRef.current.state;
        const plugins = (0, $9MoyJ.createPMPlugins)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $VSDnB.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        return viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $5uXOq.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        if (!(0, $VSDnB.fg)('platform_editor_catch_missing_injection_states')) pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: newEditorState,
            oldEditorState: oldEditorState
        });
        if (!(0, $VSDnB.fg)('platform_editor_migrate_state_updates')) config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $jNTUV.useDispatchTransaction)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $geOTC.useProviders)({
        editorApi: editorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $5uXOq.useCallback)((state)=>{
        return {
            state: state ?? getCurrentEditorState(),
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $5uXOq.useCallback)((node)=>{
        (0, $ap7h6.measureRender)((0, $5cNeT.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $4NUlu.getAnalyticsEventSeverity)(duration, (0, $da8c6c1b49848045$export$646a6982857f2cd5), (0, $da8c6c1b49848045$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodes = (0, $az5cZ.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $kFiBa.getResponseEndTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $etG8M.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $5uXOq.useState)(undefined);
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef((0, $5j6KQ.isFullPage)(props.editorProps.appearance) && (0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start') ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $5j6KQ.isFullPage)(props.editorProps.appearance) && (0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start') && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldFocus && editorView?.props.editable?.(editorView.state) && (0, $VSDnB.fg)('platform_editor_react_18_autofocus_fix')) {
            if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (!mitigateScrollJump) {
                    const liveDocWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(editorView.state.doc);
                    if (liveDocWithContent && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) $b0780699b8986d8d$var$focusElementOutsideEditor();
                    else focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(editorView);
                }
            } else {
                const liveDocWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(editorView.state.doc);
                if (liveDocWithContent && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) $b0780699b8986d8d$var$focusElementOutsideEditor();
                else focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(editorView);
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump
    ]);
    const handleEditorViewRef = (0, $5uXOq.useCallback)((node)=>{
        if (!viewRef.current && node) {
            const view = createEditorView(node);
            if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (mitigateScrollJump) {
                    const scrollElement = document.querySelector('[data-editor-scroll-container]');
                    scrollElement?.scrollTo({
                        top: originalScrollToRestore.current,
                        behavior: 'instant'
                    });
                }
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            if ((0, $VSDnB.fg)('platform_editor_react_18_autofocus_fix')) {
                /**
					 * Defer using startTransition when it is available (in React 18) to fix
					 * autofocus bug where React 18's concurrent rendering mode interferes with
					 * setTimeout used in handleEditorFocus, causing autofocus to break.
					 */ const react18OnlyStartTransition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)))?.startTransition ?? ((fn)=>fn());
                react18OnlyStartTransition(()=>{
                    // Force React to re-render so consumers get a reference to the editor view
                    setEditorView(view);
                });
            } else {
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) {
                    if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                        if (!mitigateScrollJump) {
                            const isLivePageWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(view.state.doc) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init');
                            if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(view);
                        }
                    } else {
                        const isLivePageWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(view.state.doc) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init');
                        if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(view);
                    }
                }
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            }
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        shouldFocus,
        __livePage,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const createEditor = (0, $5uXOq.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7HMhY.getUAPrefix)(),
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || props.intl.formatMessage((0, $h0q50.editorMessages).editorAssistiveLabel),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $b0780699b8986d8d$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current
        }, "ProseMirror");
    }, [
        handleEditorViewRef,
        props.intl
    ]);
    const previousPreset = (0, $7Em36.default)(preset);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $7Em36.default)(disabled);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(viewRef.current.state.doc) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init');
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(viewRef.current);
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $kpgvz.useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
    const editor = (0, $5uXOq.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy
    ]);
    // Render tracking firing too many events for the legacy content macro. We're aware of the re-render issue, but disabling this for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12Kqg.default).Provider, {
        value: {
            editorRef: editorRef,
            editorView: viewRef.current,
            popupsMountPoint: props.editorProps.popupsMountPoint
        },
        children: [
            (0, $VSDnB.fg)('platform_editor_legacy_content_macro') ? renderTrackingEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g5Huu.RenderTracking), {
                componentProps: props,
                action: (0, $gkwXh.ACTION).RE_RENDERED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: handleAnalyticsEvent,
                useShallow: true
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g5Huu.RenderTracking), {
                componentProps: props,
                action: (0, $gkwXh.ACTION).RE_RENDERED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: handleAnalyticsEvent,
                useShallow: true
            }),
            props.render ? props.render?.({
                editor: editor,
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorRef: editorRef,
                editorAPI: editorAPI
            }) ?? editor : editor
        ]
    });
}
var $b0780699b8986d8d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b0780699b8986d8d$export$e7d1b1cbca007e16);

});
parcelRegister("hETfp", function(module, exports) {

$parcel$export(module.exports, "PLATFORMS", () => $64702af428f72834$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $64702af428f72834$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $64702af428f72834$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $64702af428f72834$export$60a219cfaef9722);
var $64702af428f72834$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $64702af428f72834$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $64702af428f72834$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $64702af428f72834$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("2cB15", function(module, exports) {

$parcel$export(module.exports, "default", () => $304fa3f1418bd834$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $304fa3f1418bd834$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $5uXOq.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("7Em36", function(module, exports) {

$parcel$export(module.exports, "default", () => $474014b73fe6d1f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $474014b73fe6d1f7$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $5uXOq.useRef)(initialValue);
    (0, $5uXOq.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("3IZIX", function(module, exports) {

$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $90985e08491cf82f$export$50ccbedb1c6559a0);

var $ajpes = parcelRequire("ajpes");

var $34ck9 = parcelRequire("34ck9");

var $31bJ2 = parcelRequire("31bJ2");
function $90985e08491cf82f$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $90985e08491cf82f$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $90985e08491cf82f$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $90985e08491cf82f$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $90985e08491cf82f$var$hasGetSharedState(plugin));
const $90985e08491cf82f$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$90985e08491cf82f$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $90985e08491cf82f$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $90985e08491cf82f$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $90985e08491cf82f$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $90985e08491cf82f$export$855252f33d470a3f {
}
class $90985e08491cf82f$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$90985e08491cf82f$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $90985e08491cf82f$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$90985e08491cf82f$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $90985e08491cf82f$export$da7528f3fb233b4a {
    constructor({ getEditorState: getEditorState }){
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$90985e08491cf82f$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $90985e08491cf82f$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $90985e08491cf82f$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $90985e08491cf82f$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
}
const $90985e08491cf82f$var$editorAPICache = new WeakMap();
class $90985e08491cf82f$export$50ccbedb1c6559a0 {
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $90985e08491cf82f$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $90985e08491cf82f$var$ActionsAPI();
        this.commandsAPI = new $90985e08491cf82f$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $31bJ2.corePlugin)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent
            }
        }));
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$90985e08491cf82f$var$editorAPICache.get(this)) $90985e08491cf82f$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $90985e08491cf82f$var$editorAPICache.get(this);
    }
}

});
parcelRegister("31bJ2", function(module, exports) {

$parcel$export(module.exports, "corePlugin", () => $bd2341d5492ad0c3$export$71ab138dd170c35);

var $agxMF = parcelRequire("agxMF");

var $31nwk = parcelRequire("31nwk");

var $hcUHh = parcelRequire("hcUHh");
const $bd2341d5492ad0c3$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $hcUHh.createThrottleSchedule)((0, $hcUHh.returnDocumentRequest));
    return {
        name: 'core',
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $31nwk.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $agxMF.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $agxMF.processRawFragmentValue)(schema, replaceValue) : (0, $agxMF.processRawValue)(schema, replaceValue);
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr);
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            }
        }
    };
};

});
parcelRegister("31nwk", function(module, exports) {

$parcel$export(module.exports, "editorCommandToPMCommand", () => $9c736ce93f64dbdf$export$bd352a83a17b2af8);
$parcel$export(module.exports, "PassiveTransaction", () => $9c736ce93f64dbdf$export$95069e054e554fa9);

var $gZGBX = parcelRequire("gZGBX");
function $9c736ce93f64dbdf$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $9c736ce93f64dbdf$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $9c736ce93f64dbdf$export$95069e054e554fa9 extends (0, $gZGBX.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});

parcelRegister("hcUHh", function(module, exports) {

$parcel$export(module.exports, "createThrottleSchedule", () => $fb1316c40c469b7f$export$6a1dd68d75badcc7);
$parcel$export(module.exports, "returnDocumentRequest", () => $fb1316c40c469b7f$export$dce79649e5264171);

var $hYNZx = parcelRequire("hYNZx");

var $kCV8T = parcelRequire("kCV8T");

var $gkwXh = parcelRequire("gkwXh");
const $fb1316c40c469b7f$var$transformer = new (0, $hYNZx.JSONTransformer)();
function $fb1316c40c469b7f$export$54fd2c36b5cc6731(node) {
    return $fb1316c40c469b7f$var$transformer.encode(node);
}
function $fb1316c40c469b7f$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const wrapperFn = (...args)=>{
        lastArgs = args;
        if (frameId) return;
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) callback(...lastArgs);
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $fb1316c40c469b7f$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $fb1316c40c469b7f$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $kCV8T.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}

});



parcelRegister("12Kqg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be525c6bf2dfa69$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $5be525c6bf2dfa69$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
var $5be525c6bf2dfa69$export$2e2bcd8739ae039 = $5be525c6bf2dfa69$var$ReactEditorViewContext;

});

parcelRegister("ggL2v", function(module, exports) {

$parcel$export(module.exports, "getStepRange", () => $c63a5e20023dc0f3$export$c8e611b6ac095e6d);
$parcel$export(module.exports, "hasDocAsParent", () => $c63a5e20023dc0f3$export$f76a7d770092ea11);
$parcel$export(module.exports, "isEmptyDocument", () => $c63a5e20023dc0f3$export$2da47a16c0b6bcb);
$parcel$export(module.exports, "bracketTyped", () => $c63a5e20023dc0f3$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $c63a5e20023dc0f3$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "hasVisibleContent", () => $c63a5e20023dc0f3$export$c9083db5521330d3);
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $c63a5e20023dc0f3$export$435c1d4e61a8723b);
$parcel$export(module.exports, "getChangedNodes", () => $c63a5e20023dc0f3$export$fd9c3e0f31aab835);

var $594Yf = parcelRequire("594Yf");
const $c63a5e20023dc0f3$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $c63a5e20023dc0f3$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $c63a5e20023dc0f3$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $594Yf.isEmptyParagraph)(nodeChild);
}
function $c63a5e20023dc0f3$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $c63a5e20023dc0f3$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $c63a5e20023dc0f3$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $c63a5e20023dc0f3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $c63a5e20023dc0f3$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $c63a5e20023dc0f3$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $c63a5e20023dc0f3$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $c63a5e20023dc0f3$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $c63a5e20023dc0f3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $c63a5e20023dc0f3$export$fd9c3e0f31aab835(tr) {
    return $c63a5e20023dc0f3$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}

});
parcelRegister("594Yf", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $91477cc465a54c49$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $91477cc465a54c49$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $91477cc465a54c49$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $91477cc465a54c49$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $91477cc465a54c49$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $91477cc465a54c49$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $91477cc465a54c49$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $91477cc465a54c49$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $91477cc465a54c49$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $91477cc465a54c49$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $91477cc465a54c49$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $91477cc465a54c49$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $91477cc465a54c49$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $91477cc465a54c49$export$fba8af3b998832b9);

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");

var $eQcNy = parcelRequire("eQcNy");
function $91477cc465a54c49$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $91477cc465a54c49$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $91477cc465a54c49$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$91477cc465a54c49$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $91477cc465a54c49$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $eS2Dn.ReplaceStep)) && !(step instanceof (0, $eS2Dn.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $91477cc465a54c49$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $gZGBX.TextSelection);
const $91477cc465a54c49$export$5588122b9eea7733 = (element)=>{
    if ((0, $VSDnB.fg)('platform_editor_nested_tables_column_drag_fix')) return (0, $eQcNy.closest)(element, 'td, th');
    else return (0, $eQcNy.closest)(element, 'td') || (0, $eQcNy.closest)(element, 'th');
};
const $91477cc465a54c49$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $91477cc465a54c49$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $91477cc465a54c49$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $91477cc465a54c49$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $gZGBX.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $91477cc465a54c49$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $hFEwm.CellSelection).create(state.doc, anchor, head)));
}
function $91477cc465a54c49$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $91477cc465a54c49$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $91477cc465a54c49$export$2de06a6e688827fd = (state)=>{
    return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $91477cc465a54c49$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $91477cc465a54c49$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($91477cc465a54c49$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $91477cc465a54c49$var$not = (fn)=>(arg)=>!fn(arg);

});


parcelRegister("etG8M", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $a8a4766474a1e455$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $a8a4766474a1e455$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $a8a4766474a1e455$export$eece2fccabbb77c5);

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $a8a4766474a1e455$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $a8a4766474a1e455$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $a8a4766474a1e455$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $a8a4766474a1e455$var$textRange = function(node, from, to) {
    let range = $a8a4766474a1e455$var$reusedRange || ($a8a4766474a1e455$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $a8a4766474a1e455$var$clearReusedRange = function() {
    $a8a4766474a1e455$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $a8a4766474a1e455$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, -1) || $a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $a8a4766474a1e455$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $a8a4766474a1e455$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $a8a4766474a1e455$var$hasBlockDesc(node) || $a8a4766474a1e455$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $a8a4766474a1e455$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $a8a4766474a1e455$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $a8a4766474a1e455$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $a8a4766474a1e455$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $a8a4766474a1e455$var$nodeSize(node);
        } else if (node.parentNode && !$a8a4766474a1e455$var$hasBlockDesc(node)) {
            offset = $a8a4766474a1e455$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $a8a4766474a1e455$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$a8a4766474a1e455$var$hasBlockDesc(node)) {
            offset = $a8a4766474a1e455$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $a8a4766474a1e455$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $a8a4766474a1e455$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $a8a4766474a1e455$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $a8a4766474a1e455$var$nodeSize(node);
    }
}
function $a8a4766474a1e455$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $a8a4766474a1e455$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $a8a4766474a1e455$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $a8a4766474a1e455$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $a8a4766474a1e455$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $a8a4766474a1e455$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($a8a4766474a1e455$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($a8a4766474a1e455$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $a8a4766474a1e455$var$nav = typeof navigator != "undefined" ? navigator : null;
const $a8a4766474a1e455$var$doc = typeof document != "undefined" ? document : null;
const $a8a4766474a1e455$var$agent = $a8a4766474a1e455$var$nav && $a8a4766474a1e455$var$nav.userAgent || "";
const $a8a4766474a1e455$var$ie_edge = /Edge\/(\d+)/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$ie_upto10 = /MSIE \d/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$ie = !!($a8a4766474a1e455$var$ie_upto10 || $a8a4766474a1e455$var$ie_11up || $a8a4766474a1e455$var$ie_edge);
const $a8a4766474a1e455$var$ie_version = $a8a4766474a1e455$var$ie_upto10 ? document.documentMode : $a8a4766474a1e455$var$ie_11up ? +$a8a4766474a1e455$var$ie_11up[1] : $a8a4766474a1e455$var$ie_edge ? +$a8a4766474a1e455$var$ie_edge[1] : 0;
const $a8a4766474a1e455$var$gecko = !$a8a4766474a1e455$var$ie && /gecko\/(\d+)/i.test($a8a4766474a1e455$var$agent);
$a8a4766474a1e455$var$gecko && (/Firefox\/(\d+)/.exec($a8a4766474a1e455$var$agent) || [
    0,
    0
])[1];
const $a8a4766474a1e455$var$_chrome = !$a8a4766474a1e455$var$ie && /Chrome\/(\d+)/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$chrome = !!$a8a4766474a1e455$var$_chrome;
const $a8a4766474a1e455$var$chrome_version = $a8a4766474a1e455$var$_chrome ? +$a8a4766474a1e455$var$_chrome[1] : 0;
const $a8a4766474a1e455$var$safari = !$a8a4766474a1e455$var$ie && !!$a8a4766474a1e455$var$nav && /Apple Computer/.test($a8a4766474a1e455$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $a8a4766474a1e455$var$ios = $a8a4766474a1e455$var$safari && (/Mobile\/\w+/.test($a8a4766474a1e455$var$agent) || !!$a8a4766474a1e455$var$nav && $a8a4766474a1e455$var$nav.maxTouchPoints > 2);
const $a8a4766474a1e455$var$mac = $a8a4766474a1e455$var$ios || ($a8a4766474a1e455$var$nav ? /Mac/.test($a8a4766474a1e455$var$nav.platform) : false);
const $a8a4766474a1e455$var$windows = $a8a4766474a1e455$var$nav ? /Win/.test($a8a4766474a1e455$var$nav.platform) : false;
const $a8a4766474a1e455$var$android = /Android \d/.test($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$webkit = !!$a8a4766474a1e455$var$doc && "webkitFontSmoothing" in $a8a4766474a1e455$var$doc.documentElement.style;
const $a8a4766474a1e455$var$webkit_version = $a8a4766474a1e455$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $a8a4766474a1e455$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $a8a4766474a1e455$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $a8a4766474a1e455$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $a8a4766474a1e455$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $a8a4766474a1e455$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $a8a4766474a1e455$var$windowRect(doc) : $a8a4766474a1e455$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $a8a4766474a1e455$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $a8a4766474a1e455$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $a8a4766474a1e455$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $a8a4766474a1e455$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $a8a4766474a1e455$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $a8a4766474a1e455$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $a8a4766474a1e455$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $a8a4766474a1e455$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $a8a4766474a1e455$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $a8a4766474a1e455$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $a8a4766474a1e455$var$scrollStack(view.dom)
    };
}
function $a8a4766474a1e455$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $a8a4766474a1e455$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $a8a4766474a1e455$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $a8a4766474a1e455$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $a8a4766474a1e455$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $a8a4766474a1e455$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $a8a4766474a1e455$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($a8a4766474a1e455$var$preventScrollSupported) return dom.focus($a8a4766474a1e455$var$preventScrollSupported);
    let stored = $a8a4766474a1e455$var$scrollStack(dom);
    dom.focus($a8a4766474a1e455$var$preventScrollSupported == null ? {
        get preventScroll () {
            $a8a4766474a1e455$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$a8a4766474a1e455$var$preventScrollSupported) {
        $a8a4766474a1e455$var$preventScrollSupported = false;
        $a8a4766474a1e455$var$restoreScrollStack(stored, 0);
    }
}
function $a8a4766474a1e455$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $a8a4766474a1e455$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $a8a4766474a1e455$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $a8a4766474a1e455$var$findOffsetInNode(closest, coordsClosest);
}
function $a8a4766474a1e455$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $a8a4766474a1e455$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($a8a4766474a1e455$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $a8a4766474a1e455$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $a8a4766474a1e455$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $a8a4766474a1e455$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $a8a4766474a1e455$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $a8a4766474a1e455$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $a8a4766474a1e455$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($a8a4766474a1e455$var$inRect(coords, rect)) return $a8a4766474a1e455$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $a8a4766474a1e455$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $a8a4766474a1e455$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$a8a4766474a1e455$var$inRect(coords, box)) return null;
        elt = $a8a4766474a1e455$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($a8a4766474a1e455$var$safari) {
        for(let p = elt; node && p; p = $a8a4766474a1e455$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $a8a4766474a1e455$var$targetKludge(elt, coords);
    if (node) {
        if ($a8a4766474a1e455$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($a8a4766474a1e455$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $a8a4766474a1e455$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $a8a4766474a1e455$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $a8a4766474a1e455$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $a8a4766474a1e455$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($a8a4766474a1e455$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $a8a4766474a1e455$var$nonZero) || target.getBoundingClientRect();
}
const $a8a4766474a1e455$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $a8a4766474a1e455$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $a8a4766474a1e455$var$webkit || $a8a4766474a1e455$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($a8a4766474a1e455$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($a8a4766474a1e455$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $a8a4766474a1e455$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $a8a4766474a1e455$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $a8a4766474a1e455$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $a8a4766474a1e455$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $a8a4766474a1e455$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $a8a4766474a1e455$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $a8a4766474a1e455$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $a8a4766474a1e455$var$textRange(before, $a8a4766474a1e455$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $a8a4766474a1e455$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $a8a4766474a1e455$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(node.nodeType == 3 ? $a8a4766474a1e455$var$textRange(node) : node, -side), side >= 0);
}
function $a8a4766474a1e455$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $a8a4766474a1e455$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $a8a4766474a1e455$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $a8a4766474a1e455$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $a8a4766474a1e455$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $a8a4766474a1e455$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $a8a4766474a1e455$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $a8a4766474a1e455$var$maybeRTL = /[\u0590-\u08ac]/;
function $a8a4766474a1e455$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$a8a4766474a1e455$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $a8a4766474a1e455$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $a8a4766474a1e455$var$cachedState = null;
let $a8a4766474a1e455$var$cachedDir = null;
let $a8a4766474a1e455$var$cachedResult = false;
function $a8a4766474a1e455$var$endOfTextblock(view, state, dir) {
    if ($a8a4766474a1e455$var$cachedState == state && $a8a4766474a1e455$var$cachedDir == dir) return $a8a4766474a1e455$var$cachedResult;
    $a8a4766474a1e455$var$cachedState = state;
    $a8a4766474a1e455$var$cachedDir = dir;
    return $a8a4766474a1e455$var$cachedResult = dir == "up" || dir == "down" ? $a8a4766474a1e455$var$endOfTextblockVertical(view, state, dir) : $a8a4766474a1e455$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $a8a4766474a1e455$var$NOT_DIRTY = 0, $a8a4766474a1e455$var$CHILD_DIRTY = 1, $a8a4766474a1e455$var$CONTENT_DIRTY = 2, $a8a4766474a1e455$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $a8a4766474a1e455$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $a8a4766474a1e455$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $a8a4766474a1e455$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $a8a4766474a1e455$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $a8a4766474a1e455$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $a8a4766474a1e455$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $a8a4766474a1e455$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($a8a4766474a1e455$var$gecko || $a8a4766474a1e455$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $a8a4766474a1e455$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($a8a4766474a1e455$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $a8a4766474a1e455$var$safari) && $a8a4766474a1e455$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $a8a4766474a1e455$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $a8a4766474a1e455$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $a8a4766474a1e455$var$WidgetViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $a8a4766474a1e455$var$CompositionViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $a8a4766474a1e455$var$MarkViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $kCV8T.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $a8a4766474a1e455$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $a8a4766474a1e455$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $a8a4766474a1e455$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $a8a4766474a1e455$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $a8a4766474a1e455$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $a8a4766474a1e455$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $a8a4766474a1e455$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $a8a4766474a1e455$var$NodeViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $kCV8T.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $a8a4766474a1e455$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $a8a4766474a1e455$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $a8a4766474a1e455$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $a8a4766474a1e455$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $kCV8T.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && node.eq(this.node) && $a8a4766474a1e455$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $a8a4766474a1e455$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $a8a4766474a1e455$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $kCV8T.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $a8a4766474a1e455$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $a8a4766474a1e455$var$renderDescs(this.contentDOM, this.children, view);
            if ($a8a4766474a1e455$var$ios) $a8a4766474a1e455$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $gZGBX.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $a8a4766474a1e455$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $a8a4766474a1e455$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $a8a4766474a1e455$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($a8a4766474a1e455$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $a8a4766474a1e455$var$patchOuterDeco(this.dom, this.nodeDOM, $a8a4766474a1e455$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $a8a4766474a1e455$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $a8a4766474a1e455$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $a8a4766474a1e455$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $a8a4766474a1e455$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $a8a4766474a1e455$var$TextViewDesc extends $a8a4766474a1e455$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY || this.dirty != $a8a4766474a1e455$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $a8a4766474a1e455$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $a8a4766474a1e455$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $a8a4766474a1e455$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $a8a4766474a1e455$var$TrailingHackViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $a8a4766474a1e455$var$CustomNodeViewDesc extends $a8a4766474a1e455$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $a8a4766474a1e455$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $a8a4766474a1e455$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $a8a4766474a1e455$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $a8a4766474a1e455$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $a8a4766474a1e455$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $a8a4766474a1e455$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$a8a4766474a1e455$var$OuterDecoLevel.prototype = Object.create(null);
const $a8a4766474a1e455$var$noDeco = [
    new $a8a4766474a1e455$var$OuterDecoLevel
];
function $a8a4766474a1e455$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $a8a4766474a1e455$var$noDeco;
    let top = needsWrap ? $a8a4766474a1e455$var$noDeco[0] : new $a8a4766474a1e455$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $a8a4766474a1e455$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $a8a4766474a1e455$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $a8a4766474a1e455$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $a8a4766474a1e455$var$noDeco && curComputed == $a8a4766474a1e455$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $a8a4766474a1e455$var$noDeco[0];
                curDOM = parent;
            }
        }
        $a8a4766474a1e455$var$patchAttributes(curDOM, prev || $a8a4766474a1e455$var$noDeco[0], deco);
    }
    return curDOM;
}
function $a8a4766474a1e455$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $a8a4766474a1e455$var$applyOuterDeco(dom, deco, node) {
    return $a8a4766474a1e455$var$patchOuterDeco(dom, dom, $a8a4766474a1e455$var$noDeco, $a8a4766474a1e455$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $a8a4766474a1e455$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $a8a4766474a1e455$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $a8a4766474a1e455$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $a8a4766474a1e455$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $a8a4766474a1e455$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $a8a4766474a1e455$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $a8a4766474a1e455$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $a8a4766474a1e455$var$NODE_DIRTY && $a8a4766474a1e455$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$a8a4766474a1e455$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $a8a4766474a1e455$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $a8a4766474a1e455$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $a8a4766474a1e455$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $a8a4766474a1e455$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $a8a4766474a1e455$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($a8a4766474a1e455$var$safari || $a8a4766474a1e455$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $a8a4766474a1e455$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $a8a4766474a1e455$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $a8a4766474a1e455$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $a8a4766474a1e455$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $a8a4766474a1e455$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($a8a4766474a1e455$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $a8a4766474a1e455$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $a8a4766474a1e455$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $a8a4766474a1e455$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $a8a4766474a1e455$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($a8a4766474a1e455$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $gZGBX.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $a8a4766474a1e455$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $gZGBX.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $a8a4766474a1e455$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $a8a4766474a1e455$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $a8a4766474a1e455$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $a8a4766474a1e455$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $a8a4766474a1e455$var$syncNodeSelection(view, sel);
    if (!$a8a4766474a1e455$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $a8a4766474a1e455$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $a8a4766474a1e455$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $a8a4766474a1e455$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($a8a4766474a1e455$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $gZGBX.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $a8a4766474a1e455$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $a8a4766474a1e455$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($a8a4766474a1e455$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $a8a4766474a1e455$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $a8a4766474a1e455$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $a8a4766474a1e455$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $a8a4766474a1e455$var$brokenSelectBetweenUneditable = $a8a4766474a1e455$var$safari || $a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$chrome_version < 63;
function $a8a4766474a1e455$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($a8a4766474a1e455$var$safari && after && after.contentEditable == "false") return $a8a4766474a1e455$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $a8a4766474a1e455$var$setEditable(after);
        else if (before) return $a8a4766474a1e455$var$setEditable(before);
    }
}
function $a8a4766474a1e455$var$setEditable(element) {
    element.contentEditable = "true";
    if ($a8a4766474a1e455$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $a8a4766474a1e455$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $a8a4766474a1e455$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$a8a4766474a1e455$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $a8a4766474a1e455$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $a8a4766474a1e455$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $a8a4766474a1e455$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $gZGBX.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $a8a4766474a1e455$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $a8a4766474a1e455$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $a8a4766474a1e455$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $a8a4766474a1e455$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $gZGBX.TextSelection).between($anchor, $head, bias);
}
function $a8a4766474a1e455$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $a8a4766474a1e455$var$hasSelection(view);
}
function $a8a4766474a1e455$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $a8a4766474a1e455$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $a8a4766474a1e455$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $a8a4766474a1e455$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $gZGBX.Selection).findFrom($start, dir);
}
function $a8a4766474a1e455$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $gZGBX.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $gZGBX.NodeSelection)) return $a8a4766474a1e455$var$apply(view, next);
            return false;
        } else if (!($a8a4766474a1e455$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $gZGBX.NodeSelection).isSelectable(node)) return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($a8a4766474a1e455$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $gZGBX.NodeSelection) && sel.node.isInline) return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
        if (next) return $a8a4766474a1e455$var$apply(view, next);
        return false;
    }
}
function $a8a4766474a1e455$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $a8a4766474a1e455$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $a8a4766474a1e455$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $a8a4766474a1e455$var$skipIgnoredNodesBefore(view) : $a8a4766474a1e455$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $a8a4766474a1e455$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($a8a4766474a1e455$var$gecko && node.nodeType == 1 && offset < $a8a4766474a1e455$var$nodeLen(node) && $a8a4766474a1e455$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($a8a4766474a1e455$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($a8a4766474a1e455$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $a8a4766474a1e455$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $a8a4766474a1e455$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $a8a4766474a1e455$var$nodeLen(node);
            }
        }
    }
    if (force) $a8a4766474a1e455$var$setSelFocus(view, node, offset);
    else if (moveNode) $a8a4766474a1e455$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $a8a4766474a1e455$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $a8a4766474a1e455$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($a8a4766474a1e455$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($a8a4766474a1e455$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $a8a4766474a1e455$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $a8a4766474a1e455$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $a8a4766474a1e455$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $a8a4766474a1e455$var$setSelFocus(view, moveNode, moveOffset);
}
function $a8a4766474a1e455$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $a8a4766474a1e455$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$a8a4766474a1e455$var$hasBlockDesc(node)){
        offset = $a8a4766474a1e455$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $a8a4766474a1e455$var$textNodeBefore(node, offset) {
    while(node && !offset && !$a8a4766474a1e455$var$hasBlockDesc(node)){
        offset = $a8a4766474a1e455$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $a8a4766474a1e455$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $a8a4766474a1e455$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $a8a4766474a1e455$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($a8a4766474a1e455$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $a8a4766474a1e455$var$selectionToDOM(view);
    }, 50);
}
function $a8a4766474a1e455$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($a8a4766474a1e455$var$chrome || $a8a4766474a1e455$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $a8a4766474a1e455$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $gZGBX.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($a8a4766474a1e455$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $gZGBX.NodeSelection)) return $a8a4766474a1e455$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $gZGBX.AllSelection) ? (0, $gZGBX.Selection).near(side, dir) : (0, $gZGBX.Selection).findFrom(side, dir);
        return beyond ? $a8a4766474a1e455$var$apply(view, beyond) : false;
    }
    return false;
}
function $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $gZGBX.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $a8a4766474a1e455$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $a8a4766474a1e455$var$safariDownArrowBug(view) {
    if (!$a8a4766474a1e455$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $a8a4766474a1e455$var$switchEditable(view, child, "true");
        setTimeout(()=>$a8a4766474a1e455$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $a8a4766474a1e455$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $a8a4766474a1e455$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $a8a4766474a1e455$var$getMods(event);
    if (code == 8 || $a8a4766474a1e455$var$mac && code == 72 && mods == "c") return $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, -1) || $a8a4766474a1e455$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $a8a4766474a1e455$var$mac && code == 68 && mods == "c") return $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, 1) || $a8a4766474a1e455$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $a8a4766474a1e455$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $a8a4766474a1e455$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $a8a4766474a1e455$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $a8a4766474a1e455$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $a8a4766474a1e455$var$mac && code == 80 && mods == "c") return $a8a4766474a1e455$var$selectVertically(view, -1, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $a8a4766474a1e455$var$mac && code == 78 && mods == "c") return $a8a4766474a1e455$var$safariDownArrowBug(view) || $a8a4766474a1e455$var$selectVertically(view, 1, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, 1);
    else if (mods == ($a8a4766474a1e455$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $a8a4766474a1e455$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $kCV8T.DOMSerializer).fromSchema(view.state.schema);
    let doc = $a8a4766474a1e455$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $a8a4766474a1e455$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $a8a4766474a1e455$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $kCV8T.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $kCV8T.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $a8a4766474a1e455$var$readHTML(html);
        if ($a8a4766474a1e455$var$webkit) $a8a4766474a1e455$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $kCV8T.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$a8a4766474a1e455$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $a8a4766474a1e455$var$addContext($a8a4766474a1e455$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $kCV8T.Slice).maxOpen($a8a4766474a1e455$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $a8a4766474a1e455$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $a8a4766474a1e455$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $a8a4766474a1e455$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $a8a4766474a1e455$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $a8a4766474a1e455$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $kCV8T.Fragment).from(result);
    }
    return fragment;
}
function $a8a4766474a1e455$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $kCV8T.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $kCV8T.Fragment).from($a8a4766474a1e455$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $a8a4766474a1e455$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $a8a4766474a1e455$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $kCV8T.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $a8a4766474a1e455$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $a8a4766474a1e455$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $kCV8T.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $a8a4766474a1e455$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $kCV8T.Slice)($a8a4766474a1e455$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $kCV8T.Slice)($a8a4766474a1e455$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $a8a4766474a1e455$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $a8a4766474a1e455$var$_detachedDoc = null;
function $a8a4766474a1e455$var$detachedDoc() {
    return $a8a4766474a1e455$var$_detachedDoc || ($a8a4766474a1e455$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $a8a4766474a1e455$var$_policy = null;
function $a8a4766474a1e455$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$a8a4766474a1e455$var$_policy) $a8a4766474a1e455$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $a8a4766474a1e455$var$_policy.createHTML(html);
}
function $a8a4766474a1e455$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $a8a4766474a1e455$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $a8a4766474a1e455$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $a8a4766474a1e455$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $a8a4766474a1e455$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($a8a4766474a1e455$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $a8a4766474a1e455$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $kCV8T.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $kCV8T.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $a8a4766474a1e455$var$handlers = {};
const $a8a4766474a1e455$var$editHandlers = {};
const $a8a4766474a1e455$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $a8a4766474a1e455$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $a8a4766474a1e455$var$initInput(view) {
    for(let event in $a8a4766474a1e455$var$handlers){
        let handler = $a8a4766474a1e455$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($a8a4766474a1e455$var$eventBelongsToView(view, event) && !$a8a4766474a1e455$var$runCustomHandler(view, event) && (view.editable || !(event.type in $a8a4766474a1e455$var$editHandlers))) handler(view, event);
        }, $a8a4766474a1e455$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($a8a4766474a1e455$var$safari) view.dom.addEventListener("input", ()=>null);
    $a8a4766474a1e455$var$ensureListeners(view);
}
function $a8a4766474a1e455$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $a8a4766474a1e455$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $a8a4766474a1e455$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$a8a4766474a1e455$var$runCustomHandler(view, event));
    });
}
function $a8a4766474a1e455$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $a8a4766474a1e455$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $a8a4766474a1e455$var$dispatchEvent(view, event) {
    if (!$a8a4766474a1e455$var$runCustomHandler(view, event) && $a8a4766474a1e455$var$handlers[event.type] && (view.editable || !(event.type in $a8a4766474a1e455$var$editHandlers))) $a8a4766474a1e455$var$handlers[event.type](view, event);
}
$a8a4766474a1e455$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($a8a4766474a1e455$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($a8a4766474a1e455$var$android && $a8a4766474a1e455$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($a8a4766474a1e455$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $a8a4766474a1e455$var$captureKeyDown(view, event)) event.preventDefault();
    else $a8a4766474a1e455$var$setSelectionOrigin(view, "key");
};
$a8a4766474a1e455$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$a8a4766474a1e455$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($a8a4766474a1e455$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $a8a4766474a1e455$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $gZGBX.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $a8a4766474a1e455$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $a8a4766474a1e455$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $a8a4766474a1e455$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $a8a4766474a1e455$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $a8a4766474a1e455$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $gZGBX.NodeSelection).isSelectable(node)) {
        $a8a4766474a1e455$var$updateSelection(view, new (0, $gZGBX.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $a8a4766474a1e455$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $gZGBX.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $gZGBX.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $a8a4766474a1e455$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $a8a4766474a1e455$var$selectClickedNode(view, inside) : $a8a4766474a1e455$var$selectClickedLeaf(view, inside));
}
function $a8a4766474a1e455$var$handleDoubleClick(view, pos, inside, event) {
    return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $a8a4766474a1e455$var$handleTripleClick(view, pos, inside, event) {
    return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $a8a4766474a1e455$var$defaultTripleClick(view, inside, event);
}
function $a8a4766474a1e455$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $gZGBX.NodeSelection).isSelectable(node)) $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $a8a4766474a1e455$var$forceDOMFlush(view) {
    return $a8a4766474a1e455$var$endComposition(view);
}
const $a8a4766474a1e455$var$selectNodeModifier = $a8a4766474a1e455$var$mac ? "metaKey" : "ctrlKey";
$a8a4766474a1e455$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $a8a4766474a1e455$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $a8a4766474a1e455$var$isNear(event, view.input.lastClick) && !event[$a8a4766474a1e455$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $a8a4766474a1e455$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $a8a4766474a1e455$var$handleDoubleClick : $a8a4766474a1e455$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
};
class $a8a4766474a1e455$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$a8a4766474a1e455$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $gZGBX.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $a8a4766474a1e455$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$a8a4766474a1e455$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
        else if ($a8a4766474a1e455$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $a8a4766474a1e455$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $a8a4766474a1e455$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $a8a4766474a1e455$var$updateSelection(this.view, (0, $gZGBX.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$a8a4766474a1e455$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $a8a4766474a1e455$var$forceDOMFlush(view);
    $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
};
$a8a4766474a1e455$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
};
$a8a4766474a1e455$var$handlers.contextmenu = (view)=>$a8a4766474a1e455$var$forceDOMFlush(view);
function $a8a4766474a1e455$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($a8a4766474a1e455$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $a8a4766474a1e455$var$timeoutComposition = $a8a4766474a1e455$var$android ? 5000 : -1;
$a8a4766474a1e455$var$editHandlers.compositionstart = $a8a4766474a1e455$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $gZGBX.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $a8a4766474a1e455$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $a8a4766474a1e455$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($a8a4766474a1e455$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $a8a4766474a1e455$var$scheduleComposeEnd(view, $a8a4766474a1e455$var$timeoutComposition);
};
$a8a4766474a1e455$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $a8a4766474a1e455$var$scheduleComposeEnd(view, 20);
    }
};
function $a8a4766474a1e455$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$a8a4766474a1e455$var$endComposition(view), delay);
}
function $a8a4766474a1e455$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $a8a4766474a1e455$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $a8a4766474a1e455$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $a8a4766474a1e455$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $a8a4766474a1e455$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $a8a4766474a1e455$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $a8a4766474a1e455$var$endComposition(view, restarting = false) {
    if ($a8a4766474a1e455$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $a8a4766474a1e455$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $a8a4766474a1e455$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $a8a4766474a1e455$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $a8a4766474a1e455$var$brokenClipboardAPI = $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version < 15 || $a8a4766474a1e455$var$ios && $a8a4766474a1e455$var$webkit_version < 604;
$a8a4766474a1e455$var$handlers.copy = $a8a4766474a1e455$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $a8a4766474a1e455$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $a8a4766474a1e455$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $a8a4766474a1e455$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $a8a4766474a1e455$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $a8a4766474a1e455$var$doPaste(view, target.value, null, plain, event);
        else $a8a4766474a1e455$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $a8a4766474a1e455$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $a8a4766474a1e455$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $kCV8T.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $a8a4766474a1e455$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $a8a4766474a1e455$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$a8a4766474a1e455$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$a8a4766474a1e455$var$android) return;
    let data = $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $a8a4766474a1e455$var$doPaste(view, $a8a4766474a1e455$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $a8a4766474a1e455$var$capturePaste(view, event);
};
class $a8a4766474a1e455$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $a8a4766474a1e455$var$dragCopyModifier = $a8a4766474a1e455$var$mac ? "altKey" : "ctrlKey";
$a8a4766474a1e455$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $gZGBX.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $gZGBX.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $gZGBX.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $a8a4766474a1e455$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$a8a4766474a1e455$var$chrome || $a8a4766474a1e455$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($a8a4766474a1e455$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$a8a4766474a1e455$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $a8a4766474a1e455$var$Dragging(slice, !event[$a8a4766474a1e455$var$dragCopyModifier], node);
};
$a8a4766474a1e455$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$a8a4766474a1e455$var$editHandlers.dragover = $a8a4766474a1e455$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$a8a4766474a1e455$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $a8a4766474a1e455$var$parseFromClipboard(view, $a8a4766474a1e455$var$getText(event.dataTransfer), $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$a8a4766474a1e455$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $kCV8T.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $eS2Dn.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $gZGBX.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $gZGBX.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($a8a4766474a1e455$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$a8a4766474a1e455$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $a8a4766474a1e455$var$selectionToDOM(view);
        }, 20);
    }
};
$a8a4766474a1e455$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$a8a4766474a1e455$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $a8a4766474a1e455$var$editHandlers)$a8a4766474a1e455$var$handlers[prop] = $a8a4766474a1e455$var$editHandlers[prop];
function $a8a4766474a1e455$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $a8a4766474a1e455$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $a8a4766474a1e455$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $a8a4766474a1e455$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $a8a4766474a1e455$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $a8a4766474a1e455$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $a8a4766474a1e455$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $a8a4766474a1e455$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $a8a4766474a1e455$var$InlineType && $a8a4766474a1e455$var$compareObjs(this.attrs, other.attrs) && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $a8a4766474a1e455$var$InlineType;
    }
    destroy() {}
}
class $a8a4766474a1e455$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $a8a4766474a1e455$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $a8a4766474a1e455$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $a8a4766474a1e455$var$NodeType && $a8a4766474a1e455$var$compareObjs(this.attrs, other.attrs) && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $a8a4766474a1e455$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(pos, pos, new $a8a4766474a1e455$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, new $a8a4766474a1e455$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, new $a8a4766474a1e455$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $a8a4766474a1e455$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $a8a4766474a1e455$var$WidgetType;
    }
}
const $a8a4766474a1e455$var$none = [], $a8a4766474a1e455$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $a8a4766474a1e455$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $a8a4766474a1e455$var$none;
        this.children = children.length ? children : $a8a4766474a1e455$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $a8a4766474a1e455$var$buildTree(decorations, doc, 0, $a8a4766474a1e455$var$noSpec) : $a8a4766474a1e455$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $a8a4766474a1e455$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $a8a4766474a1e455$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $a8a4766474a1e455$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $a8a4766474a1e455$export$93bf62eb445cec98(newLocal.sort($a8a4766474a1e455$var$byPos), $a8a4766474a1e455$var$none) : $a8a4766474a1e455$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $a8a4766474a1e455$var$empty) return $a8a4766474a1e455$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $a8a4766474a1e455$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $a8a4766474a1e455$var$buildTree(found, childNode, baseOffset + 1, $a8a4766474a1e455$var$noSpec));
            childIndex += 3;
        });
        let local = $a8a4766474a1e455$var$moveSpans(childIndex ? $a8a4766474a1e455$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $a8a4766474a1e455$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($a8a4766474a1e455$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $a8a4766474a1e455$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $a8a4766474a1e455$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $a8a4766474a1e455$export$93bf62eb445cec98(local, children) : $a8a4766474a1e455$var$empty;
    }
    forChild(offset, node) {
        if (this == $a8a4766474a1e455$var$empty) return this;
        if (node.isLeaf) return $a8a4766474a1e455$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $a8a4766474a1e455$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $a8a4766474a1e455$export$93bf62eb445cec98(local.sort($a8a4766474a1e455$var$byPos), $a8a4766474a1e455$var$none);
            return child ? new $a8a4766474a1e455$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $a8a4766474a1e455$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $a8a4766474a1e455$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $a8a4766474a1e455$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $a8a4766474a1e455$var$empty) return $a8a4766474a1e455$var$none;
        if (node.inlineContent || !this.local.some($a8a4766474a1e455$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $a8a4766474a1e455$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $a8a4766474a1e455$export$93bf62eb445cec98.empty = new $a8a4766474a1e455$export$93bf62eb445cec98([], []);
/**
@internal
*/ $a8a4766474a1e455$export$93bf62eb445cec98.removeOverlap = $a8a4766474a1e455$var$removeOverlap;
const $a8a4766474a1e455$var$empty = $a8a4766474a1e455$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $a8a4766474a1e455$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $a8a4766474a1e455$var$noSpec));
        return $a8a4766474a1e455$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $a8a4766474a1e455$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $a8a4766474a1e455$var$empty) continue;
            if (result instanceof $a8a4766474a1e455$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $a8a4766474a1e455$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $a8a4766474a1e455$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $a8a4766474a1e455$var$removeOverlap(sorted ? result : result.sort($a8a4766474a1e455$var$byPos)) : $a8a4766474a1e455$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $a8a4766474a1e455$var$empty;
            case 1:
                return members[0];
            default:
                return new $a8a4766474a1e455$var$DecorationGroup(members.every((m)=>m instanceof $a8a4766474a1e455$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $a8a4766474a1e455$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $a8a4766474a1e455$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $a8a4766474a1e455$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $a8a4766474a1e455$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $a8a4766474a1e455$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $a8a4766474a1e455$export$93bf62eb445cec98(newLocal.sort($a8a4766474a1e455$var$byPos), children);
}
function $a8a4766474a1e455$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $a8a4766474a1e455$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $a8a4766474a1e455$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $a8a4766474a1e455$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $a8a4766474a1e455$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $a8a4766474a1e455$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $a8a4766474a1e455$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $a8a4766474a1e455$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $a8a4766474a1e455$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $a8a4766474a1e455$var$moveSpans(hasNulls ? $a8a4766474a1e455$var$withoutNulls(spans) : spans, -offset).sort($a8a4766474a1e455$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $a8a4766474a1e455$export$93bf62eb445cec98(locals, children) : $a8a4766474a1e455$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $a8a4766474a1e455$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $a8a4766474a1e455$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $a8a4766474a1e455$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $a8a4766474a1e455$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $a8a4766474a1e455$var$insertAhead(array, i, deco) {
    while(i < array.length && $a8a4766474a1e455$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $a8a4766474a1e455$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $a8a4766474a1e455$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($a8a4766474a1e455$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $a8a4766474a1e455$var$DecorationGroup.from(found);
}
const $a8a4766474a1e455$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $a8a4766474a1e455$var$useCharData = $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11;
class $a8a4766474a1e455$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $a8a4766474a1e455$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $a8a4766474a1e455$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($a8a4766474a1e455$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $a8a4766474a1e455$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$a8a4766474a1e455$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $a8a4766474a1e455$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $a8a4766474a1e455$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $a8a4766474a1e455$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $a8a4766474a1e455$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $a8a4766474a1e455$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($a8a4766474a1e455$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $a8a4766474a1e455$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $a8a4766474a1e455$var$selectionCollapsed(sel) && (readSel = $a8a4766474a1e455$var$selectionFromDOM(view)) && readSel.eq((0, $gZGBX.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $a8a4766474a1e455$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $a8a4766474a1e455$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $a8a4766474a1e455$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $a8a4766474a1e455$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $a8a4766474a1e455$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $a8a4766474a1e455$var$cssChecked = new WeakMap();
let $a8a4766474a1e455$var$cssCheckWarned = false;
function $a8a4766474a1e455$var$checkCSS(view) {
    if ($a8a4766474a1e455$var$cssChecked.has(view)) return;
    $a8a4766474a1e455$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $a8a4766474a1e455$var$gecko;
        if ($a8a4766474a1e455$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $a8a4766474a1e455$var$cssCheckWarned = true;
    }
}
function $a8a4766474a1e455$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($a8a4766474a1e455$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $a8a4766474a1e455$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $a8a4766474a1e455$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $a8a4766474a1e455$var$rangeToSelectionRange(view, found) : null;
}
function $a8a4766474a1e455$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $a8a4766474a1e455$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$a8a4766474a1e455$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($a8a4766474a1e455$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $kCV8T.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $a8a4766474a1e455$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $a8a4766474a1e455$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($a8a4766474a1e455$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $a8a4766474a1e455$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $a8a4766474a1e455$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $a8a4766474a1e455$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $a8a4766474a1e455$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $a8a4766474a1e455$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $a8a4766474a1e455$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($a8a4766474a1e455$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $a8a4766474a1e455$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$a8a4766474a1e455$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $gZGBX.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $a8a4766474a1e455$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $gZGBX.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($a8a4766474a1e455$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $gZGBX.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $a8a4766474a1e455$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(8, "Backspace")))) {
        if ($a8a4766474a1e455$var$android && $a8a4766474a1e455$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($a8a4766474a1e455$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($a8a4766474a1e455$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$a8a4766474a1e455$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $a8a4766474a1e455$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $a8a4766474a1e455$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($a8a4766474a1e455$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $a8a4766474a1e455$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $a8a4766474a1e455$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $a8a4766474a1e455$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $a8a4766474a1e455$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $kCV8T.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $a8a4766474a1e455$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $a8a4766474a1e455$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($a8a4766474a1e455$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $a8a4766474a1e455$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $a8a4766474a1e455$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $a8a4766474a1e455$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $a8a4766474a1e455$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $a8a4766474a1e455$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $a8a4766474a1e455$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $a8a4766474a1e455$export$38b79e3fdcfcfd68 = $a8a4766474a1e455$var$serializeForClipboard;
/**
@internal
*/ const $a8a4766474a1e455$export$5d42ca91c11c9e4d = $a8a4766474a1e455$var$parseFromClipboard;
/**
@internal
*/ const $a8a4766474a1e455$export$76b14d3c719c32fc = $a8a4766474a1e455$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $a8a4766474a1e455$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $a8a4766474a1e455$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($a8a4766474a1e455$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $a8a4766474a1e455$var$getEditable(this);
        $a8a4766474a1e455$var$updateCursorWrapper(this);
        this.nodeViews = $a8a4766474a1e455$var$buildNodeViews(this);
        this.docView = $a8a4766474a1e455$var$docViewDesc(this.state.doc, $a8a4766474a1e455$var$computeDocDeco(this), $a8a4766474a1e455$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $a8a4766474a1e455$var$DOMObserver(this, (from, to, typeOver, added)=>$a8a4766474a1e455$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $a8a4766474a1e455$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $a8a4766474a1e455$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($a8a4766474a1e455$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $a8a4766474a1e455$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $a8a4766474a1e455$var$buildNodeViews(this);
            if ($a8a4766474a1e455$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $a8a4766474a1e455$var$ensureListeners(this);
        this.editable = $a8a4766474a1e455$var$getEditable(this);
        $a8a4766474a1e455$var$updateCursorWrapper(this);
        let innerDeco = $a8a4766474a1e455$var$viewDecorations(this), outerDeco = $a8a4766474a1e455$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $a8a4766474a1e455$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($a8a4766474a1e455$var$ie || $a8a4766474a1e455$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $a8a4766474a1e455$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $a8a4766474a1e455$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $a8a4766474a1e455$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $a8a4766474a1e455$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $a8a4766474a1e455$var$anchorInRightPlace(this))) $a8a4766474a1e455$var$selectionToDOM(this, forceSelUpdate);
            else {
                $a8a4766474a1e455$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $a8a4766474a1e455$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $gZGBX.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $a8a4766474a1e455$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $a8a4766474a1e455$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $a8a4766474a1e455$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $gZGBX.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($a8a4766474a1e455$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $a8a4766474a1e455$var$focusPreventScroll(this.dom);
        $a8a4766474a1e455$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $a8a4766474a1e455$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $a8a4766474a1e455$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $a8a4766474a1e455$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $a8a4766474a1e455$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $a8a4766474a1e455$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $a8a4766474a1e455$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $a8a4766474a1e455$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $a8a4766474a1e455$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $a8a4766474a1e455$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $a8a4766474a1e455$var$safari && this.root.nodeType === 11 && $a8a4766474a1e455$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $a8a4766474a1e455$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $a8a4766474a1e455$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $a8a4766474a1e455$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $a8a4766474a1e455$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $a8a4766474a1e455$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $a8a4766474a1e455$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $a8a4766474a1e455$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $a8a4766474a1e455$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $a8a4766474a1e455$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $a8a4766474a1e455$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("geOTC", function(module, exports) {

$parcel$export(module.exports, "useProviders", () => $4ce81023af8e02ce$export$e4c19534640d7866);

var $5uXOq = parcelRequire("5uXOq");
const $4ce81023af8e02ce$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $5uXOq.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};

});

parcelRegister("az5cZ", function(module, exports) {

$parcel$export(module.exports, "getNodesCount", () => $73bdd5ff554f00ca$export$3674f49b2d541ad);
function $73bdd5ff554f00ca$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}

});

parcelRegister("g5Huu", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $d1e11c1c8b2cc0e9$export$fe16de086fea1f5f);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $gkwXh = parcelRequire("gkwXh");

var $REa58 = parcelRequire("REa58");
function $d1e11c1c8b2cc0e9$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $REa58.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("REa58", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $8eae713cd4396df0$export$ebce6d7d8ca67353);

var $5uXOq = parcelRequire("5uXOq");

var $bXrHm = parcelRequire("bXrHm");

var $cCR0b = parcelRequire("cCR0b");
function $8eae713cd4396df0$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $5uXOq.useRef)();
    const renderCountRef = (0, $5uXOq.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    (0, $5uXOq.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $cCR0b.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $cCR0b.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("cCR0b", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $8e3652061a23f798$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $8e3652061a23f798$export$418b0a935c0a0030);

var $5uXOq = parcelRequire("5uXOq");
const $8e3652061a23f798$export$74743eda5dda3ccf = Object.keys;
const $8e3652061a23f798$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $8e3652061a23f798$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $8e3652061a23f798$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $8e3652061a23f798$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $8e3652061a23f798$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $8e3652061a23f798$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $8e3652061a23f798$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $8e3652061a23f798$export$f4c1dafc9df1f03(value1),
                newValue: $8e3652061a23f798$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $8e3652061a23f798$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $8e3652061a23f798$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



const $da8c6c1b49848045$export$646a6982857f2cd5 = 2000;
const $da8c6c1b49848045$export$79d7eac6cbb6352d = 3000;
const $da8c6c1b49848045$export$7d7bd496a5206996 = 100;

parcelRegister("9MoyJ", function(module, exports) {

$parcel$export(module.exports, "fixExcludes", () => $c0c676c2bd95d8c4$export$ef6c09ff452189fa);
$parcel$export(module.exports, "processPluginsList", () => $c0c676c2bd95d8c4$export$7265233e78178a4);
$parcel$export(module.exports, "createPMPlugins", () => $c0c676c2bd95d8c4$export$169329cb2979ef81);
$parcel$export(module.exports, "createErrorReporter", () => $c0c676c2bd95d8c4$export$e98521bb0cea2db1);

var $fTi1m = parcelRequire("fTi1m");

var $aZPvj = parcelRequire("aZPvj");

var $1AaPO = parcelRequire("1AaPO");
function $c0c676c2bd95d8c4$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $c0c676c2bd95d8c4$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $c0c676c2bd95d8c4$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $c0c676c2bd95d8c4$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $aZPvj.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $1AaPO.createEditorStateNotificationPlugin)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $c0c676c2bd95d8c4$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $fTi1m.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("fTi1m", function(module, exports) {

$parcel$export(module.exports, "ErrorReporter", () => $af8126628ab56549$export$88da0ac32d9c271e);
class $af8126628ab56549$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});

parcelRegister("aZPvj", function(module, exports) {

$parcel$export(module.exports, "sortByOrder", () => $c37ea3a6202d7c12$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $c37ea3a6202d7c12$export$b4ae7ad1c009d0a1);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $c37ea3a6202d7c12$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $c37ea3a6202d7c12$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}

});

parcelRegister("1AaPO", function(module, exports) {

$parcel$export(module.exports, "createEditorStateNotificationPlugin", () => $8fbcfb1366e3adf2$export$e0355cecc74597d);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
const $8fbcfb1366e3adf2$var$key = new (0, $gZGBX.PluginKey)('editorStateNotificationPlugin');
const $8fbcfb1366e3adf2$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    let transactions = [];
    return new (0, $5KWxh.SafePlugin)({
        key: $8fbcfb1366e3adf2$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    const originalTransaction = $8fbcfb1366e3adf2$var$key.getState(view.state)?.latestTransaction;
                    if (originalTransaction && (0, $VSDnB.fg)('platform_editor_migrate_state_updates')) {
                        onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                            entry.callback({
                                originalTransaction: originalTransaction,
                                transactions: transactions,
                                oldEditorState: oldEditorState,
                                newEditorState: view.state
                            });
                        });
                        transactions = [];
                    }
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};

});
parcelRegister("5KWxh", function(module, exports) {

$parcel$export(module.exports, "SafePlugin", () => $11ce3f4f5d2ca62c$export$1d44e2741b8f180d);

var $gZGBX = parcelRequire("gZGBX");

var $2RN5d = parcelRequire("2RN5d");
const $11ce3f4f5d2ca62c$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom })=>{
    const metadata = (0, $2RN5d.createProseMirrorMetadata)(nodeOrMark);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
    });
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $11ce3f4f5d2ca62c$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                        return;
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement) $11ce3f4f5d2ca62c$export$286bb6e3f51916b5({
                        nodeOrMark: node,
                        dom: result.dom
                    });
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $11ce3f4f5d2ca62c$export$1d44e2741b8f180d extends (0, $gZGBX.Plugin) {
    constructor(spec){
        super($11ce3f4f5d2ca62c$var$wrapGetPosExceptions(spec));
    }
}

});
parcelRegister("2RN5d", function(module, exports) {

$parcel$export(module.exports, "createProseMirrorMetadata", () => $d7292b4ed800dccb$export$3d8be158d19aadd1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kCV8T = parcelRequire("kCV8T");
const $d7292b4ed800dccb$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $kCV8T.Node) || Array.isArray(nodeOrMark.marks);
};
const $d7292b4ed800dccb$export$3d8be158d19aadd1 = (nodeOrMark)=>{
    const name = nodeOrMark.type.name;
    const isNode = $d7292b4ed800dccb$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    return commonAttributes;
};

});




parcelRegister("gAD8U", function(module, exports) {

$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $fae66c98e35fd436$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $fae66c98e35fd436$export$2e2bcd8739ae039);

var $fkGS3 = parcelRequire("fkGS3");

var $5j6KQ = parcelRequire("5j6KQ");
const $fae66c98e35fd436$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $fae66c98e35fd436$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $5j6KQ.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $fae66c98e35fd436$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $fkGS3.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $fae66c98e35fd436$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web'
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $fae66c98e35fd436$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$fae66c98e35fd436$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});

parcelRegister("ijurB", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $e23c0e6a9c2302d0$export$5f4ce795563f4211);

var $7P7H6 = parcelRequire("7P7H6");

var $aZPvj = parcelRequire("aZPvj");

var $2RN5d = parcelRequire("2RN5d");

var $kCV8T = parcelRequire("kCV8T");

var $9MoyJ = parcelRequire("9MoyJ");
const $e23c0e6a9c2302d0$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $2RN5d.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $e23c0e6a9c2302d0$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $e23c0e6a9c2302d0$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $e23c0e6a9c2302d0$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $e23c0e6a9c2302d0$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $e23c0e6a9c2302d0$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $9MoyJ.fixExcludes)(editorConfig.marks.sort((0, $aZPvj.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $e23c0e6a9c2302d0$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $7P7H6.sanitizeNodes)(editorConfig.nodes.sort((0, $aZPvj.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $e23c0e6a9c2302d0$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});

parcelRegister("h0q50", function(module, exports) {

$parcel$export(module.exports, "editorMessages", () => $83b423bd4c954bb9$export$3b488057bfc1868f);

var $7VHMR = parcelRequire("7VHMR");
const $83b423bd4c954bb9$export$3b488057bfc1868f = (0, $7VHMR.defineMessages)({
    editorAssistiveLabel: {
        id: 'fabric.editor.editorAssistiveLabel',
        defaultMessage: 'Main content area, start typing to enter text.',
        description: 'Text that is read out by screen reader when the main editor is in focus'
    }
});

});

parcelRegister("7HMhY", function(module, exports) {

$parcel$export(module.exports, "getUAPrefix", () => $6f98ce41d7ee5a01$export$11a24c7b1b4aab81);

var $gE8f9 = parcelRequire("gE8f9");
function $6f98ce41d7ee5a01$export$11a24c7b1b4aab81() {
    if ((0, $gE8f9.browser).chrome) return 'ua-chrome';
    else if ((0, $gE8f9.browser).ie) return 'ua-ie';
    else if ((0, $gE8f9.browser).gecko) return 'ua-firefox';
    else if ((0, $gE8f9.browser).safari) return 'ua-safari';
    return '';
}

});

parcelRegister("cj93n", function(module, exports) {

$parcel$export(module.exports, "handleEditorFocus", () => $86566110343db703$export$ebebb7f5b9271fd7);

var $5uXOq = parcelRequire("5uXOq");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
function $86566110343db703$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    /**
	 * If startTransition is available (in React 18),
	 * don't use setTimeout as startTransition will be used in ReactEditorViewNext.
	 * setTimeout(fn, 0) will not defer the focus reliably in React 18 with
	 * concurrent rendering.
	 */ const react16OnlySetTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)))?.startTransition && (0, $VSDnB.fg)('platform_editor_react_18_autofocus_fix') ? (fn)=>fn() : (fn)=>window.setTimeout(fn, 0);
    return react16OnlySetTimeout(()=>{
        // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
        // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
        // Bail out in that scenario to prevent operating on an unmounted view.
        if ((0, $VSDnB.fg)('platform_editor_posfromdom_null_fix')) {
            if (view?.isDestroyed) return;
        }
        if (view?.hasFocus()) return;
        if (!window.getSelection) {
            view?.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view?.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (view && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
        const head = view?.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor && anchor < 0 || head && head < 0) {
            view?.focus();
            return;
        }
        if (view && anchor) {
            const selection = (0, $gZGBX.TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }
    });
}

});

parcelRegister("jNTUV", function(module, exports) {

$parcel$export(module.exports, "useDispatchTransaction", () => $8e65b5e3b9ae9277$export$b582387940572fe7);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");
var $J5Axj = parcelRequire("J5Axj");

var $ifv4n = parcelRequire("ifv4n");

var $iN9lO = parcelRequire("iN9lO");

var $VSDnB = parcelRequire("VSDnB");

var $4r96J = parcelRequire("4r96J");

var $acfJa = parcelRequire("acfJa");

var $dReYX = parcelRequire("dReYX");

var $96xlM = parcelRequire("96xlM");
const $8e65b5e3b9ae9277$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $5uXOq.useRef)(onChange);
    (0, $5uXOq.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $5uXOq.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $4r96J.findChangedNodesFromTransaction)(unsafeTransaction);
        const changedNodesValid = (0, $96xlM.validateNodes)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $acfJa.freezeUnsafeTransactionProperties)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? (0, $VSDnB.fg)('platform_editor_transaction_skip_validation') && isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                (0, $iN9lO.startMeasure)((0, $dReYX.EVENT_NAME_ON_CHANGE));
                onChangeRef.current(view, {
                    source: source
                });
                (0, $iN9lO.stopMeasure)((0, $dReYX.EVENT_NAME_ON_CHANGE));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $96xlM.validNode)(node)).map((node)=>(0, $ifv4n.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $J5Axj.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    ...(0, $VSDnB.fg)('platform_editor_transaction_skip_validation') ? {
                        isRemoteReplaceDocumentTransaction: isRemoteReplace
                    } : {}
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};

});
parcelRegister("J5Axj", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $6668461c370cf056$export$d9985be1ece4b7ee);

var $8aY84 = parcelRequire("8aY84");
function $6668461c370cf056$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $8aY84.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});
parcelRegister("8aY84", function(module, exports) {

$parcel$export(module.exports, "AnalyticsStep", () => $5f3de64f68283b50$export$cc33374693c7fb23);

var $eHiP8 = parcelRequire("eHiP8");

var $eS2Dn = parcelRequire("eS2Dn");

var $kCV8T = parcelRequire("kCV8T");
const $5f3de64f68283b50$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $5f3de64f68283b50$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $5f3de64f68283b50$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($5f3de64f68283b50$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $5f3de64f68283b50$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $5f3de64f68283b50$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID ? $5f3de64f68283b50$var$HISTORY_ACTIONS.REDID : $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID
        }
    });
function $5f3de64f68283b50$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID || event.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.REDID;
}
class $5f3de64f68283b50$export$cc33374693c7fb23 extends (0, $eS2Dn.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $eHiP8.default)(this, "analyticsEvents", []);
        (0, $eHiP8.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($5f3de64f68283b50$var$isHistoryAnalyticsEvent(analyticsEvent)) return $5f3de64f68283b50$var$toggleEventAction(analyticsEvent);
            else return $5f3de64f68283b50$var$createUndoEvent(analyticsEvent);
        });
        return new $5f3de64f68283b50$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $5f3de64f68283b50$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $eS2Dn.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $eS2Dn.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $5f3de64f68283b50$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $5f3de64f68283b50$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $5f3de64f68283b50$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($5f3de64f68283b50$export$9126078e8b0f76e4, $5f3de64f68283b50$export$cc33374693c7fb23);

});


parcelRegister("4r96J", function(module, exports) {

$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $7155804a07622bac$export$cdc577fd3f583194);

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");
const $7155804a07622bac$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                let nodeToCheck = node;
                if ((0, $VSDnB.fg)('cc_complexit_fe_improve_node_validation')) {
                    const { schema: schema } = tr.selection.$from.doc.type;
                    const parentNode = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(tr.selection);
                    nodeToCheck = parentNode ? parentNode.node : node;
                }
                if (!nodes.find((n)=>n === nodeToCheck)) nodes.push(nodeToCheck);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("acfJa", function(module, exports) {

$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $1bc4cc3d64f3585e$export$668aa008bdae439f);

var $gkwXh = parcelRequire("gkwXh");
const $1bc4cc3d64f3585e$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $1bc4cc3d64f3585e$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $1bc4cc3d64f3585e$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $1bc4cc3d64f3585e$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($1bc4cc3d64f3585e$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($1bc4cc3d64f3585e$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($1bc4cc3d64f3585e$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("dReYX", function(module, exports) {

$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $78f2616dc044c230$export$bb82e7cfb8987f35);

var $b7gJe = parcelRequire("b7gJe");

var $iN9lO = parcelRequire("iN9lO");

var $5dI4U = parcelRequire("5dI4U");
const $78f2616dc044c230$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $78f2616dc044c230$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $78f2616dc044c230$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $78f2616dc044c230$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $78f2616dc044c230$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $78f2616dc044c230$export$735da5ee20c885d5 = false;
const $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE = 100;
const $78f2616dc044c230$var$noop = ()=>{};
class $78f2616dc044c230$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $78f2616dc044c230$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $78f2616dc044c230$var$noop,
                stopMeasure: $78f2616dc044c230$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $iN9lO.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $iN9lO.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $5dI4U.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("5dI4U", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $b84a5fedb7732bc1$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $b84a5fedb7732bc1$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});


parcelRegister("96xlM", function(module, exports) {

$parcel$export(module.exports, "validNode", () => $4488669a13e53cb9$export$4c39e41e39b3c449);
$parcel$export(module.exports, "validateNodes", () => $4488669a13e53cb9$export$996213f7c272fc6f);
const $4488669a13e53cb9$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $4488669a13e53cb9$export$996213f7c272fc6f = (nodes)=>nodes.every($4488669a13e53cb9$export$4c39e41e39b3c449);

});


parcelRegister("kpgvz", function(module, exports) {

$parcel$export(module.exports, "useFireFullWidthEvent", () => $b28a7eb8b5fedc52$export$4998b7b36606f9c3);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $7Em36 = parcelRequire("7Em36");

var $1hwge = parcelRequire("1hwge");
const $b28a7eb8b5fedc52$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $7Em36.default)(appearance);
    (0, $5uXOq.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $1hwge.formatFullWidthAppearance)(previousAppearance),
                    newMode: (0, $1hwge.formatFullWidthAppearance)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};

});
parcelRegister("1hwge", function(module, exports) {

$parcel$export(module.exports, "formatFullWidthAppearance", () => $1e164d4b24e45932$export$47d5b79f3ddf0b92);

var $hETfp = parcelRequire("hETfp");
const $1e164d4b24e45932$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $hETfp.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $hETfp.FULL_WIDTH_MODE).FIXED_WIDTH;
};

});



parcelRegister("fggrl", function(module, exports) {

$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $5641d4a75c12a4ef$export$742fe272b8921eea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");
const $5641d4a75c12a4ef$var$useCheckIntlContext = ()=>(0, $5uXOq.useContext)((0, $8RXs9.Context)) === null;
function $5641d4a75c12a4ef$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $5641d4a75c12a4ef$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: children
    });
    return children;
}

});

parcelRegister("j0Vvw", function(module, exports) {

$parcel$export(module.exports, "BaseThemeWrapper", () => $ec97f93103c51466$export$3de34996b814f0f0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");
// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $ec97f93103c51466$var$defaultFontSize = 14;
function $ec97f93103c51466$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || $ec97f93103c51466$var$defaultFontSize,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}

});

parcelRegister("8pML4", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $5e4d3b841efcfea0$export$8e2864079bc476bd);

var $iHYdz = parcelRequire("iHYdz");
function $5e4d3b841efcfea0$export$8e2864079bc476bd(appearance) {
    if (appearance === undefined) return 0, $iHYdz.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : undefined;
}

});


parcelRegister("dACrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ad4bc9aab4b58d4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $iN9lO = parcelRequire("iN9lO");

var $5cNeT = parcelRequire("5cNeT");

var $2JODI = parcelRequire("2JODI");

var $dCdqM = parcelRequire("dCdqM");
function $9ad4bc9aab4b58d4$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $dCdqM.default)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $iN9lO.stopMeasure)((0, $5cNeT.default).EDITOR_MOUNTED, (0, $2JODI.default)((0, $gkwXh.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $iN9lO.clearMeasure)((0, $5cNeT.default).EDITOR_MOUNTED);
            (0, $iN9lO.clearMeasure)((0, $5cNeT.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("2JODI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b92cee7571d3699$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");
function $2b92cee7571d3699$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}

});

parcelRegister("dCdqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6123a7e35e2a74e1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2cB15 = parcelRequire("2cB15");

var $iN9lO = parcelRequire("iN9lO");

var $5cNeT = parcelRequire("5cNeT");
function $6123a7e35e2a74e1$export$2e2bcd8739ae039() {
    (0, $2cB15.default)(()=>{
        (0, $iN9lO.startMeasure)((0, $5cNeT.default).EDITOR_MOUNTED);
    });
}

});


parcelRegister("1d04s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3dd8adf4b990f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $5e3dd8adf4b990f5$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $5uXOq.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation
    ]);
    return memodProps;
};
var $5e3dd8adf4b990f5$export$2e2bcd8739ae039 = $5e3dd8adf4b990f5$export$d9d7e48a5f16fb4d;

});

parcelRegister("jRRkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5333f04c6da13671$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $3thTj = parcelRequire("3thTj");

var $bntD2 = parcelRequire("bntD2");

var $10FSK = parcelRequire("10FSK");

var $2ncO1 = parcelRequire("2ncO1");
function $5333f04c6da13671$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $5333f04c6da13671$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $3thTj.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $bntD2.default)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $5333f04c6da13671$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $5uXOq.useMemo)(()=>(0, $10FSK.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $5uXOq.useRef)(new (0, $dGzaM.default)());
    const editorRef = $5333f04c6da13671$var$useEditorRef(props.preset);
    const preparedProviders = (0, $5uXOq.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $5333f04c6da13671$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ncO1.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("3thTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8798f349fd39c0ec$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $5WUYC = parcelRequire("5WUYC");
function $8798f349fd39c0ec$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $5WUYC.default)(extensionProviders(editorActions));
    return (0, $5WUYC.default)(extensionProviders);
}
const $8798f349fd39c0ec$var$prepareExtensionProvider = (getEditorActions)=>(0, $8QpSo.default)((extensionProviders)=>$8798f349fd39c0ec$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $8798f349fd39c0ec$export$2e2bcd8739ae039 = $8798f349fd39c0ec$var$prepareExtensionProvider;

});
parcelRegister("5WUYC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d246d6c54b9ec0c3$export$2e2bcd8739ae039);

var $lBEBY = parcelRequire("lBEBY");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $d246d6c54b9ec0c3$export$2e2bcd8739ae039 = (extensionProviders)=>{
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $lBEBY.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("lBEBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c37a15ec98ede43$export$2e2bcd8739ae039);

var $3B8Ug = parcelRequire("3B8Ug");
const $8c37a15ec98ede43$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $8c37a15ec98ede43$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $3B8Ug.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        return (0, $3B8Ug.getOnlyFulfilled)(results);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $3B8Ug.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $3B8Ug.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $3B8Ug.getOnlyFulfilled)(results);
        return $8c37a15ec98ede43$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("3B8Ug", function(module, exports) {

$parcel$export(module.exports, "waitForAllPromises", () => $682d4194c4aac261$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $682d4194c4aac261$export$cb8861b0e3f3dd6f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $682d4194c4aac261$export$b7581cbf0e22e36b);
var $682d4194c4aac261$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $682d4194c4aac261$var$isFullfilled = (result)=>result.status === "fulfilled";
const $682d4194c4aac261$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $682d4194c4aac261$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $682d4194c4aac261$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($682d4194c4aac261$var$markFullfilled).catch($682d4194c4aac261$var$markRejected)));
};
const $682d4194c4aac261$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $682d4194c4aac261$export$b7581cbf0e22e36b = (results)=>results.filter($682d4194c4aac261$var$isFullfilled).map((result)=>result.value);

});




parcelRegister("bntD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ee1a571c17d3b4$export$2e2bcd8739ae039);

var $f1ZF9 = parcelRequire("f1ZF9");
function $37ee1a571c17d3b4$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $f1ZF9.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $f1ZF9.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("f1ZF9", function(module, exports) {

$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $acd9c39774394075$export$6b0bb34c2583056f);
$parcel$export(module.exports, "combineQuickInsertProviders", () => $acd9c39774394075$export$e3759a254d73dcb7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $04ZRC = parcelRequire("04ZRC");
var $izxHQ = parcelRequire("izxHQ");

var $lBEBY = parcelRequire("lBEBY");

var $4NUlu = parcelRequire("4NUlu");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $VSDnB.fg)('platform_nested_nbm_analytics_location') ? (0, $4NUlu.findInsertLocation)(selection) : undefined;
        if (insertLocation && [
            'listItem',
            'blockquote',
            'nestedExpand',
            'panel'
        ].includes(insertLocation)) // No-op editorExperiment evaluation to track usage of nested non-bodied macros
        // these can't be tracked at the point of diversion of the experience because that is a toggle of the
        // ProseMirror schema nodes for listItems, nestedExpand, blockquote, and panel. At that point the customer
        // has not yet been exposed to the experience.
        (0, $gmhCD.editorExperiment)('platform_editor_nested_non_bodied_macros', 'test', {
            exposure: true
        });
        (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $gkwXh.ACTION).INSERTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $gkwXh.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }
        });
    }
}
const $acd9c39774394075$var$showDummyAPIWarning = (location)=>{};
const $acd9c39774394075$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$acd9c39774394075$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$acd9c39774394075$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    doc: {
        insertAfter: ()=>$acd9c39774394075$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$acd9c39774394075$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$acd9c39774394075$var$showDummyAPIWarning('doc:update')
    }
};
async function $acd9c39774394075$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $04ZRC.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    categories: item.categories,
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            if ((0, $VSDnB.fg)('platform_editor_add_extension_api_to_quick_insert')) {
                                const extensionAPI = apiRef?.current?.extension?.actions?.api();
                                // While this should only run when the extension some setups of editor
                                // may not have the extension API
                                if (extensionAPI) (0, $izxHQ.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                    $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                    if (node) editorActions.replaceSelection(node);
                                });
                                else // Originally it was understood we could only use this if we were using the extension plugin
                                // However there are some edge cases where this is not true (ie. in jira)
                                // Since making it optional now would be a breaking change - instead we can just pass a dummy
                                // extension API to consumers that warns them of using the methods.
                                (0, $izxHQ.resolveImport)(item.node($acd9c39774394075$var$dummyExtensionAPI)).then((node)=>{
                                    $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                    if (node) editorActions.replaceSelection(node);
                                });
                            } else // @ts-expect-error No longer supported without extension API - this will be removed once we cleanup the FG.
                            (0, $izxHQ.resolveImport)(item.node()).then((node)=>{
                                $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $acd9c39774394075$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $lBEBY.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}

});
parcelRegister("04ZRC", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $ceac48cd89560646$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $ceac48cd89560646$export$60407594ea5edd1c);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $ceac48cd89560646$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $ceac48cd89560646$export$9d13b95c50a2a6c9);

var $VSDnB = parcelRequire("VSDnB");

var $izxHQ = parcelRequire("izxHQ");
const $ceac48cd89560646$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $ceac48cd89560646$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $izxHQ.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $ceac48cd89560646$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$ceac48cd89560646$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $ceac48cd89560646$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(// Ignored via go/ees005
    // eslint-disable-next-line require-await
    extensions.map(async (manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $ceac48cd89560646$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $ceac48cd89560646$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $ceac48cd89560646$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ceac48cd89560646$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $ceac48cd89560646$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $ceac48cd89560646$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $ceac48cd89560646$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $ceac48cd89560646$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $ceac48cd89560646$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $ceac48cd89560646$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $ceac48cd89560646$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$ceac48cd89560646$var$compareContext(currentContext, context)));
    }
};
const $ceac48cd89560646$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $ceac48cd89560646$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $ceac48cd89560646$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($ceac48cd89560646$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ((0, $VSDnB.fg)('forge-ui-macro-autoconvert')) {
                        if ($ceac48cd89560646$var$isToolbarButton(toolbarItem)) return $ceac48cd89560646$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                        return toolbarItem;
                    } else return $ceac48cd89560646$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $ceac48cd89560646$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $ceac48cd89560646$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}

});



parcelRegister("10FSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc30c3c0fe5f5799$export$2e2bcd8739ae039);
function $bc30c3c0fe5f5799$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("2ncO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e179e49684dee1$export$2e2bcd8739ae039);
function $73e179e49684dee1$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});




parcelRegister("5Xe3v", function(module, exports) {

$parcel$export(module.exports, "usePreset", () => $df819121659b5a33$export$1d81a44583df97d2);

var $5uXOq = parcelRequire("5uXOq");

var $jy0M7 = parcelRequire("jy0M7");
function $df819121659b5a33$export$1d81a44583df97d2(createPreset, dependencies = []) {
    const [editorApi, setAPI] = (0, $5uXOq.useState)(undefined);
    const preset = (0, $5uXOq.useMemo)(()=>createPreset(new (0, $jy0M7.EditorPresetBuilder)()), // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies);
    (0, $5uXOq.useLayoutEffect)(()=>{
        return preset.apiResolver.on((api)=>{
            setAPI(api);
        });
    }, [
        preset.apiResolver
    ]);
    return {
        editorApi: editorApi,
        preset: preset
    };
}

});
parcelRegister("jy0M7", function(module, exports) {

$parcel$export(module.exports, "EditorPresetBuilder", () => $727f0ffe9f739d15$export$dab03ba05a79e5c7);

var $lY6DM = parcelRequire("lY6DM");
class $727f0ffe9f739d15$export$dab03ba05a79e5c7 {
    constructor(...more){
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $727f0ffe9f739d15$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
    add(nextOrTuple) {
        return new $727f0ffe9f739d15$export$dab03ba05a79e5c7(/**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $727f0ffe9f739d15$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $727f0ffe9f739d15$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            this.resolver?.(pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            const plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $727f0ffe9f739d15$var$APIDispatcher {
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $lY6DM.EventDispatcher)();
        this.key = 'api-resolved-event';
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
    /**
	 * Used to observe Editor API events
	 *
	 * @param cb Callback to listen to the editor API.
	 * This will also emit the last event if the stream has already started.
	 * @returns Cleanup function to cleanup the listener
	 */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
}

});


parcelRegister("fLTqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3162b9aa01f33877$export$2e2bcd8739ae039);

var $kOFhM = parcelRequire("kOFhM");

var $e6OIt = parcelRequire("e6OIt");
class $3162b9aa01f33877$export$2e2bcd8739ae039 {
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $e6OIt.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $kOFhM.defaultSchema)) {
        return new $3162b9aa01f33877$export$2e2bcd8739ae039(schema);
    }
}

});
parcelRegister("e6OIt", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $d81fee803f8be80c$export$533b26079ad0b4b);

var $3pmcr = parcelRequire("3pmcr");

var $dFTQc = parcelRequire("dFTQc");

var $gePJb = parcelRequire("gePJb");

var $kDX7I = parcelRequire("kDX7I");

var $imMk3 = parcelRequire("imMk3");

var $440xp = parcelRequire("440xp");

var $lFEBP = parcelRequire("lFEBP");

var $htHCj = parcelRequire("htHCj");

var $khjO4 = parcelRequire("khjO4");

var $6e3uf = parcelRequire("6e3uf");

var $3LUJO = parcelRequire("3LUJO");

var $eAfxp = parcelRequire("eAfxp");

var $aBdRK = parcelRequire("aBdRK");

var $hHZcb = parcelRequire("hHZcb");

var $3uDza = parcelRequire("3uDza");

var $jDcJt = parcelRequire("jDcJt");

var $ca29C = parcelRequire("ca29C");

var $70D85 = parcelRequire("70D85");
const $d81fee803f8be80c$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $d81fee803f8be80c$var$nodeToReducerMapping[node.type.name] || $d81fee803f8be80c$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $d81fee803f8be80c$var$nodeToReducerMapping = {
    blockquote: $3pmcr.default,
    bulletList: $dFTQc.default,
    date: $gePJb.default,
    decisionItem: $kDX7I.default,
    hardBreak: $imMk3.default,
    heading: $440xp.default,
    inlineCard: $lFEBP.default,
    listItem: $htHCj.default,
    mediaGroup: $khjO4.default,
    mention: $6e3uf.default,
    orderedList: $3LUJO.default,
    panel: $eAfxp.default,
    paragraph: $aBdRK.default,
    rule: $hHZcb.default,
    status: $3uDza.default,
    table: $jDcJt.default,
    taskItem: $ca29C.default,
    unknown: $70D85.default
};

});
parcelRegister("3pmcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b783d74f3fa943e7$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $b783d74f3fa943e7$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $b783d74f3fa943e7$export$2e2bcd8739ae039 = $b783d74f3fa943e7$var$blockquote;

});

parcelRegister("dFTQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $749dbd2e6028b2d6$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $749dbd2e6028b2d6$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $e6OIt.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $749dbd2e6028b2d6$export$2e2bcd8739ae039 = $749dbd2e6028b2d6$var$bulletList;

});

parcelRegister("gePJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9583bb4b1b92a2c3$export$2e2bcd8739ae039);

var $cAMv0 = parcelRequire("cAMv0");

var $K5Jsy = parcelRequire("K5Jsy");
const $9583bb4b1b92a2c3$var$date = (node, schema)=>{
    return node.attrs.timestamp ? (0, $cAMv0.timestampToIsoFormat)(node.attrs.timestamp) : (0, $K5Jsy.getText)(node);
};
var $9583bb4b1b92a2c3$export$2e2bcd8739ae039 = $9583bb4b1b92a2c3$var$date;

});
parcelRegister("cAMv0", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $c5b07ac9bae9c35c$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $c5b07ac9bae9c35c$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $c5b07ac9bae9c35c$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $c5b07ac9bae9c35c$export$fbc04a9e57b04a80);

var $SzDmm = parcelRequire("SzDmm");

var $kUxFz = parcelRequire("kUxFz");
var $c5b07ac9bae9c35c$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c5b07ac9bae9c35c$var$FORMATS || {});
const $c5b07ac9bae9c35c$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c5b07ac9bae9c35c$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c5b07ac9bae9c35c$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c5b07ac9bae9c35c$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c5b07ac9bae9c35c$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCDate())}`;
};
const $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $kUxFz.default)(new Date(Number(timestamp)), new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562())));
};
const $c5b07ac9bae9c35c$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $SzDmm.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c5b07ac9bae9c35c$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c5b07ac9bae9c35c$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});


parcelRegister("kDX7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bd72f6ac7c9da28$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $2bd72f6ac7c9da28$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $e6OIt.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $2bd72f6ac7c9da28$export$2e2bcd8739ae039 = $2bd72f6ac7c9da28$var$decisionItem;

});

parcelRegister("imMk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $225150f21995c312$export$2e2bcd8739ae039);
const $225150f21995c312$var$hardBreak = ()=>{
    return '\n';
};
var $225150f21995c312$export$2e2bcd8739ae039 = $225150f21995c312$var$hardBreak;

});

parcelRegister("440xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $138bcacc90088152$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $138bcacc90088152$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('');
};
var $138bcacc90088152$export$2e2bcd8739ae039 = $138bcacc90088152$var$heading;

});

parcelRegister("lFEBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $624c2799ad9d8e95$export$2e2bcd8739ae039);

var $K5Jsy = parcelRequire("K5Jsy");
const $624c2799ad9d8e95$var$inlineCard = (node, schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $K5Jsy.getText)(node);
};
var $624c2799ad9d8e95$export$2e2bcd8739ae039 = $624c2799ad9d8e95$var$inlineCard;

});

parcelRegister("htHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a088bc6174fa44e$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $1a088bc6174fa44e$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('\n');
};
var $1a088bc6174fa44e$export$2e2bcd8739ae039 = $1a088bc6174fa44e$var$listItem;

});

parcelRegister("khjO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e89926131a2312a$export$2e2bcd8739ae039);
const $8e89926131a2312a$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $8e89926131a2312a$export$2e2bcd8739ae039 = $8e89926131a2312a$var$mediaGroup;

});

parcelRegister("6e3uf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2977203c4602e2c5$export$2e2bcd8739ae039);
const $2977203c4602e2c5$var$mention = (node, schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $2977203c4602e2c5$export$2e2bcd8739ae039 = $2977203c4602e2c5$var$mention;

});

parcelRegister("3LUJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f90d7afe39bccffc$export$2e2bcd8739ae039);

var $uTDrM = parcelRequire("uTDrM");

var $e6OIt = parcelRequire("e6OIt");
const $f90d7afe39bccffc$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $uTDrM.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $e6OIt.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $f90d7afe39bccffc$export$2e2bcd8739ae039 = $f90d7afe39bccffc$var$orderedList;

});

parcelRegister("eAfxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8f54e9a672bbbf1$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $e8f54e9a672bbbf1$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('\n');
};
var $e8f54e9a672bbbf1$export$2e2bcd8739ae039 = $e8f54e9a672bbbf1$var$panel;

});

parcelRegister("aBdRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bd298fed1fdb6b4$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $5bd298fed1fdb6b4$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $e6OIt.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $5bd298fed1fdb6b4$export$2e2bcd8739ae039 = $5bd298fed1fdb6b4$var$paragraph;

});

parcelRegister("hHZcb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b47562962a68bb7$export$2e2bcd8739ae039);
const $9b47562962a68bb7$var$rule = ()=>{
    return '';
};
var $9b47562962a68bb7$export$2e2bcd8739ae039 = $9b47562962a68bb7$var$rule;

});

parcelRegister("3uDza", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa78d4ec3c1edae$export$2e2bcd8739ae039);

var $K5Jsy = parcelRequire("K5Jsy");
const $ffa78d4ec3c1edae$var$status = (node, schema)=>{
    return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, $K5Jsy.getText)(node);
};
var $ffa78d4ec3c1edae$export$2e2bcd8739ae039 = $ffa78d4ec3c1edae$var$status;

});

parcelRegister("jDcJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc23c7a13259c83$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $3dc23c7a13259c83$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($3dc23c7a13259c83$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $3dc23c7a13259c83$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($3dc23c7a13259c83$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $3dc23c7a13259c83$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    return result.join('\n');
};
var $3dc23c7a13259c83$export$2e2bcd8739ae039 = $3dc23c7a13259c83$var$table;

});

parcelRegister("ca29C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8366ad5bb1422197$export$2e2bcd8739ae039);

var $e6OIt = parcelRequire("e6OIt");
const $8366ad5bb1422197$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $e6OIt.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $8366ad5bb1422197$export$2e2bcd8739ae039 = $8366ad5bb1422197$var$taskItem;

});

parcelRegister("70D85", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6f7879b7465532$export$2e2bcd8739ae039);

var $K5Jsy = parcelRequire("K5Jsy");

var $e6OIt = parcelRequire("e6OIt");
const $ce6f7879b7465532$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $e6OIt.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $K5Jsy.getText)(node);
};
var $ce6f7879b7465532$export$2e2bcd8739ae039 = $ce6f7879b7465532$var$unknown;

});



parcelRegister("cwKDG", function(module, exports) {

$parcel$export(module.exports, "LinkPickerButton", () => $4bcdebecd3a88332$export$b665e181ecd1797);
/* LinkPickerButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $gkwXh = parcelRequire("gkwXh");

var $awTmI = parcelRequire("awTmI");

var $1f9bV = parcelRequire("1f9bV");

var $3YZpd = parcelRequire("3YZpd");

var $kU0f4 = parcelRequire("kU0f4");
const $4bcdebecd3a88332$export$b665e181ecd1797 = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { hyperlinkState: hyperlinkState } = (0, $awTmI.useSharedPluginState)(editorApi, [
        'hyperlink'
    ]);
    const fireAnalyticsEvent = (0, $3YZpd.useFireAnalyticsEvent)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        if (editorApi) {
            const showLinkToolbarAction = editorApi.hyperlink?.commands.showLinkToolbar((0, $gkwXh.INPUT_METHOD).QUICK_INSERT);
            if (showLinkToolbarAction) editorApi.core.actions.execute(showLinkToolbarAction);
        }
        fireAnalyticsEvent({
            payload: {
                action: (0, $gkwXh.ACTION).CLICKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).AI_PROMPT_LINK_PICKER_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    // The editor can be wrapped in a component that process keyboard events,
    // but we don't need to propagate `Enter`, `Space`, and `Tab` key event to the editor.
    const stopPropagationForActionKeys = (0, $5uXOq.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $kU0f4.default).label),
        testId: "link-picker-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))),
        isSelected: !!hyperlinkState?.activeLinkMark,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};

});
parcelRegister("3YZpd", function(module, exports) {

$parcel$export(module.exports, "useFireAnalyticsEvent", () => $6eb6fa8a40b2bd9c$export$eed8c476984ddfad);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ctLRZ = parcelRequire("ctLRZ");
function $6eb6fa8a40b2bd9c$export$eed8c476984ddfad() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useMemo)(()=>(0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent), [
        createAnalyticsEvent
    ]);
}

});

parcelRegister("kU0f4", function(module, exports) {

$parcel$export(module.exports, "default", () => $19f4c9d589312e2b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19f4c9d589312e2b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        id: 'fabric.editor.ai.screens.prompt.linkPickerButton.label',
        defaultMessage: 'Add link',
        description: 'Link picker button label within the Prompt screen'
    }
});

});


parcelRegister("crtQ3", function(module, exports) {

$parcel$export(module.exports, "MentionButton", () => $deff9788fb5f204e$export$d16f16312388c7e);
/* MentionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $gkwXh = parcelRequire("gkwXh");

var $awTmI = parcelRequire("awTmI");

var $izMdR = parcelRequire("izMdR");

var $3YZpd = parcelRequire("3YZpd");

var $7yF1Z = parcelRequire("7yF1Z");
const $deff9788fb5f204e$export$d16f16312388c7e = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { typeAheadState: typeAheadState, mentionState: mentionState } = (0, $awTmI.useSharedPluginState)(editorApi, [
        'mention',
        'typeAhead'
    ]);
    const fireAnalyticsEvent = (0, $3YZpd.useFireAnalyticsEvent)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        if (editorApi) editorApi.mention?.actions.openTypeAhead((0, $gkwXh.INPUT_METHOD).QUICK_INSERT);
        fireAnalyticsEvent({
            payload: {
                action: (0, $gkwXh.ACTION).CLICKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).AI_PROMPT_MENTION_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    // The editor can be wrapped in a component that process keyboard events,
    // but we don't need to propagate `Enter`, `Space`, and `Tab` key event to the editor.
    const stopPropagationForActionKeys = (0, $5uXOq.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $7yF1Z.default).label),
        testId: "mention-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($izMdR))),
        isSelected: typeAheadState?.currentHandler?.id && mentionState?.typeAheadHandler.id && typeAheadState.currentHandler.id === mentionState.typeAheadHandler.id,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};

});
parcelRegister("izMdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1b019ad514d335985b9dfdb2c8fe134>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d860e6e53b6f4f6d$var$_react = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d860e6e53b6f4f6d$var$_baseNew = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d860e6e53b6f4f6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d860e6e53b6f4f6d$var$MentionIcon = (props)=>/*#__PURE__*/ $d860e6e53b6f4f6d$var$_react.default.createElement($d860e6e53b6f4f6d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$d860e6e53b6f4f6d$var$MentionIcon.displayName = 'MentionIcon';
var $d860e6e53b6f4f6d$var$_default = module.exports.default = $d860e6e53b6f4f6d$var$MentionIcon;

});

parcelRegister("7yF1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3570e95e70a30dfa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3570e95e70a30dfa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        id: 'fabric.editor.ai.screens.prompt.mentionButton.label',
        defaultMessage: 'Mention someone or a team',
        description: 'Mention button label within the Prompt screen'
    }
});

});


parcelRegister("eqXnF", function(module, exports) {

$parcel$export(module.exports, "createAIPromptPreset", () => $a8894c95ce979376$export$cd6e43a807ff0e0d);

var $jy0M7 = parcelRequire("jy0M7");
parcelRequire("g36b0");
var $lsZ2i = parcelRequire("lsZ2i");
parcelRequire("fxvTQ");
var $exvYd = parcelRequire("exvYd");
parcelRequire("at6Ig");
var $kiLfG = parcelRequire("kiLfG");
parcelRequire("aboEQ");
var $2hnN6 = parcelRequire("2hnN6");
parcelRequire("3nspz");
var $a0QQi = parcelRequire("a0QQi");
parcelRequire("cVzPm");
var $9UHJN = parcelRequire("9UHJN");
parcelRequire("oFSWG");
var $kd7KX = parcelRequire("kd7KX");
parcelRequire("ceDVv");
var $izJY1 = parcelRequire("izJY1");
parcelRequire("gmJvQ");
var $jnbcS = parcelRequire("jnbcS");
parcelRequire("3wlyh");
var $IBShN = parcelRequire("IBShN");
parcelRequire("6mXgW");
var $2U5eR = parcelRequire("2U5eR");
parcelRequire("5I6Ej");
var $hcXgl = parcelRequire("hcXgl");
parcelRequire("2fcyF");
var $1bV4T = parcelRequire("1bV4T");
parcelRequire("7bJco");
var $4y8T6 = parcelRequire("4y8T6");
parcelRequire("hrqyH");
var $3Cy5z = parcelRequire("3Cy5z");
parcelRequire("2DIrX");
var $5kxA9 = parcelRequire("5kxA9");
parcelRequire("bM5ai");
var $1NAwD = parcelRequire("1NAwD");
parcelRequire("6hrMZ");
var $3Y1hh = parcelRequire("3Y1hh");
parcelRequire("ewWTS");
var $54Pnl = parcelRequire("54Pnl");
parcelRequire("7o36A");
var $8OUh9 = parcelRequire("8OUh9");
parcelRequire("1jBun");
var $uNoBL = parcelRequire("uNoBL");
parcelRequire("644sF");
var $4R0EL = parcelRequire("4R0EL");
parcelRequire("gXAdO");
var $cKx1R = parcelRequire("cKx1R");
parcelRequire("gYYLA");
var $04dn4 = parcelRequire("04dn4");
parcelRequire("kMiBI");
var $bTGGC = parcelRequire("bTGGC");
function $a8894c95ce979376$export$cd6e43a807ff0e0d(options) {
    const cardPluginData = {
        ...options.linking?.smartLinks,
        linkPicker: options.linking?.linkPicker,
        lpLinkPicker: options.featureFlags?.lpLinkPicker ?? false,
        disableFloatingToolbar: true,
        showUpgradeDiscoverability: false,
        // We don't want to show block cards and embed cards in prompt editor.
        allowBlockCards: false,
        allowEmbeds: false
    };
    const preset = new (0, $jy0M7.EditorPresetBuilder)()// Handles feature flagging in Editor.
    .add([
        (0, $hcXgl.featureFlagsPlugin),
        options.featureFlags
    ])// Most of analytics events in editor are fired by appending
    //  AnalyticsStep in transaction.
    // Without this plugin, none of those events will be fired.
    // If allowAnalyticsGASV3 is truthy, then analytics plugin will be added.
    .maybeAdd([
        (0, $lsZ2i.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent
        }
    ], Boolean(options.allowAnalyticsGASV3))// Dependency of paste plugin
    .add((0, $kiLfG.betterTypeHistoryPlugin))// we need paste plugin to handle paste event.
    .add([
        (0, $54Pnl.pastePlugin),
        {}
    ])// We need clipboard to handle cut and copy and clipboard serialization.
    .add((0, $kd7KX.default))// Handles focus and blur events.
    .add((0, $4y8T6.focusPlugin))// This plugin handles composition events and take care nuances of composition.
    // Need this plugin to have sleek composition support for languages such as Japanese, Chinese
    .add((0, $izJY1.compositionPlugin))// Editor can't function without this plugin.
    // It takes care of doc, paragraph and text nodes, backbone of any document.
    .add([
        (0, $exvYd.default),
        {}
    ])// Dependency of cardPlugin, floatingToolbarPlugin
    .add((0, $IBShN.decorationsPlugin))// Depdency of undoRedoButtons
    .add((0, $cKx1R.typeAheadPlugin))// Depdency of undoRedoButtons
    .maybeAdd((0, $5kxA9.default), true)// We want to support undo/redo through shortcuts.
    .maybeAdd((0, $04dn4.undoRedoPlugin), true)// We should keep this plugin. It will remove all the marks when doc is empty.
    // It's very lightweight plugin.
    .add((0, $9UHJN.clearMarksOnEmptyDocPlugin))// Dependency of cardPlugin
    .maybeAdd([
        (0, $1NAwD.hyperlinkPlugin),
        {
            disableFloatingToolbar: !options.linkPicker,
            linkPicker: options.linkPicker
        }
    ], !!options.enableLinks).maybeAdd([
        (0, $3Y1hh.mentionsPlugin)
    ], !!options.mentionProvider)// Dependency of cardPlugin, gridPlugin
    .add((0, $bTGGC.widthPlugin))// Need placeholder plugin to show placeholder
    .add([
        (0, $8OUh9.placeholderPlugin),
        options.placeholder
    ])// Dependency of floatingToolbarPlugin
    .add((0, $2U5eR.editorDisabledPlugin))// Dependency of floatingToolbarPlugin
    .add((0, $jnbcS.copyButtonPlugin))// Dependency of cardPlugin
    .add((0, $1bV4T.floatingToolbarPlugin))// Need selections plugin to handle selection nuances in editor, support gap cursor and keyboard handling for selection.
    .add([
        (0, $4R0EL.selectionPlugin),
        {}
    ])// Need to have save on enter functionality. Without this plugin, on enter editor will add line break and then prompt is submited.
    .maybeAdd([
        (0, $uNoBL.saveOnEnterPlugin),
        options.onSave
    ], !!options.onSave)// Dependency of cardPlugin
    .maybeAdd([
        (0, $3Cy5z.gridPlugin),
        {}
    ], true)// Need card plugin to show smart links.
    .maybeAdd([
        (0, $a0QQi.cardPlugin),
        cardPluginData
    ], !!options.enableLinks)// Need this plugin for adding new line on `Shift + Enter` keymap
    .add([
        (0, $2hnN6.blockTypePlugin),
        {
            allowBlockType: {
                exclude: [
                    'heading',
                    'blockquote'
                ]
            }
        }
    ]);
    return preset;
}

});
parcelRegister("g36b0", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => (parcelRequire("lsZ2i")).analyticsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $lsZ2i = parcelRequire("lsZ2i");

});
parcelRegister("lsZ2i", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => $38b0cff75c831b25$export$f26023c5d4a5ab44);

var $5uXOq = parcelRequire("5uXOq");

var $8aY84 = parcelRequire("8aY84");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");
var $J5Axj = parcelRequire("J5Axj");

var $b7gJe = parcelRequire("b7gJe");

var $ap7h6 = parcelRequire("ap7h6");

var $5KWxh = parcelRequire("5KWxh");

var $bgfWv = parcelRequire("bgfWv");

var $fLgtE = parcelRequire("fLgtE");

var $8Zx8B = parcelRequire("8Zx8B");

var $78yQH = parcelRequire("78yQH");
function $38b0cff75c831b25$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $b7gJe.isPerformanceAPIAvailable)();
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $8Zx8B.analyticsPluginKey),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $ctLRZ.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $8Zx8B.analyticsPluginKey)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $J5Axj.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $gkwXh.ACTION).INSERTED && payload.action !== (0, $gkwXh.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $ap7h6.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $ctLRZ.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $38b0cff75c831b25$export$a3e5fcfb76b37e49({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $38b0cff75c831b25$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const analyticsEventPropQueue = new Set();
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $8Zx8B.analyticsPluginKey).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $bgfWv.createAttachPayloadIntoTransaction)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $fLgtE.editorAnalyticsChannel))=>(tr)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload,
                            channel: channel
                        });
                        return false;
                    }
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent: (payload, channel = (0, $fLgtE.editorAnalyticsChannel), options)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                if (!createAnalyticsEvent) {
                    analyticsEventPropQueue.add({
                        payload: payload,
                        channel: channel
                    });
                    return;
                }
                (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent, options)({
                    payload: payload,
                    channel: channel
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
            (0, $5uXOq.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $8Zx8B.analyticsPluginKey), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
                // Attach all analytics events to the transaction
                analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                    createAnalyticsEvent(payload)?.fire(channel ?? (0, $fLgtE.editorAnalyticsChannel));
                });
                // Clear the queue
                analyticsEventPropQueue.clear();
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$38b0cff75c831b25$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $8Zx8B.analyticsPluginKey).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const steps = transactions.reduce((acc, tr)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const payloads = tr.steps// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .filter((step)=>step instanceof (0, $8aY84.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $78yQH.generateUndoRedoInputSoucePayload)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $38b0cff75c831b25$export$a3e5fcfb76b37e49({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
    };
}

});
parcelRegister("bgfWv", function(module, exports) {

$parcel$export(module.exports, "createAttachPayloadIntoTransaction", () => $70c38d4fb0ac5a50$export$539ce7f09649e93);

var $8aY84 = parcelRequire("8aY84");

var $gkwXh = parcelRequire("gkwXh");

var $eMmNA = parcelRequire("eMmNA");

var $7D97R = parcelRequire("7D97R");
const $70c38d4fb0ac5a50$var$actionsToIgnore = [
    (0, $gkwXh.ACTION).INVOKED,
    (0, $gkwXh.ACTION).OPENED
];
const $70c38d4fb0ac5a50$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$70c38d4fb0ac5a50$export$dff9776b7883fc5f({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
const $70c38d4fb0ac5a50$export$dff9776b7883fc5f = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $eMmNA.getStateContext)(selection, payload, tr);
    payload = (0, $7D97R.mapActionSubjectIdToAttributes)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $8aY84.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $70c38d4fb0ac5a50$var$actionsToIgnore, pos));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};

});
parcelRegister("eMmNA", function(module, exports) {

$parcel$export(module.exports, "getStateContext", () => $b2e7d92ac50916bf$export$b8d8bec4e31cbd66);

var $gkwXh = parcelRequire("gkwXh");
var $7IaNe = parcelRequire("7IaNe");

var $4NUlu = parcelRequire("4NUlu");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
function $b2e7d92ac50916bf$export$ab5b04535d7a5950(selection) {
    let type;
    let position;
    if (selection?.constructor?.name === 'GapCursorSelection') {
        type = (0, $7IaNe.SELECTION_TYPE).GAP_CURSOR;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position = selection.side;
    } else if (selection instanceof (0, $hFEwm.CellSelection)) type = (0, $7IaNe.SELECTION_TYPE).CELL;
    else if (selection instanceof (0, $gZGBX.NodeSelection)) type = (0, $7IaNe.SELECTION_TYPE).NODE;
    else if (selection.from !== selection.to) type = (0, $7IaNe.SELECTION_TYPE).RANGED;
    else {
        type = (0, $7IaNe.SELECTION_TYPE).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $7IaNe.SELECTION_POSITION).START;
        else if (from === $from.end()) position = (0, $7IaNe.SELECTION_POSITION).END;
        else position = (0, $7IaNe.SELECTION_POSITION).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $b2e7d92ac50916bf$export$46ac691122c4c55e(oldSelection, newSelection) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $hFEwm.CellSelection)) return table.name;
    const insertLocationInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let parentNodePos = newSelection.$from.doc.resolve(insertLocationInfo?.start || 0);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newSelection.$from.doc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $b2e7d92ac50916bf$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $b2e7d92ac50916bf$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = (0, $4NUlu.findInsertLocation)(selection);
    if (payload.action === (0, $gkwXh.ACTION).INSERTED && payload.actionSubject !== (0, $gkwXh.ACTION_SUBJECT).ANNOTATION && payload.actionSubject !== (0, $gkwXh.ACTION_SUBJECT).EDITOR_PLUGIN_AI) payload.attributes.insertedLocation = $b2e7d92ac50916bf$export$46ac691122c4c55e(selection, tr.selection);
    if (payload.action === (0, $gkwXh.ACTION).INSERTED && payload.actionSubject === (0, $gkwXh.ACTION_SUBJECT).DOCUMENT && payload.attributes) payload.attributes.insertLocation = insertLocation;
    else payload.attributes.nodeLocation = insertLocation;
    return payload;
}

});
parcelRegister("7IaNe", function(module, exports) {

$parcel$export(module.exports, "SELECTION_TYPE", () => $4f3bea2b77126b29$export$96527b3d022fe7df);
$parcel$export(module.exports, "SELECTION_POSITION", () => $4f3bea2b77126b29$export$f64a96dc7664cbe5);
var $4f3bea2b77126b29$export$96527b3d022fe7df = /*#__PURE__*/ function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    return SELECTION_TYPE;
}({});
var $4f3bea2b77126b29$export$f64a96dc7664cbe5 = /*#__PURE__*/ function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
    return SELECTION_POSITION;
}({});

});


parcelRegister("7D97R", function(module, exports) {

$parcel$export(module.exports, "mapActionSubjectIdToAttributes", () => $4733c7621036df00$export$dd48e359ffe98e59);

var $gkwXh = parcelRequire("gkwXh");
function $4733c7621036df00$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $gkwXh.ACTION).INSERTED && payload.actionSubject === (0, $gkwXh.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $gkwXh.ACTION).FORMATTED && payload.actionSubject === (0, $gkwXh.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}

});


parcelRegister("fLgtE", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $9fde11f34ce18b49$export$1467dbbb3bb418c6);

var $dWAZk = parcelRequire("dWAZk");
const $9fde11f34ce18b49$export$1467dbbb3bb418c6 = (0, $dWAZk.FabricChannel).editor;

});

parcelRegister("8Zx8B", function(module, exports) {

$parcel$export(module.exports, "analyticsPluginKey", () => $2b7c67819c225dd8$export$c4a4504e8a9a0b2e);

var $gZGBX = parcelRequire("gZGBX");
const $2b7c67819c225dd8$export$c4a4504e8a9a0b2e = new (0, $gZGBX.PluginKey)('analyticsPlugin');

});

parcelRegister("78yQH", function(module, exports) {

$parcel$export(module.exports, "generateUndoRedoInputSoucePayload", () => $bbad6368f6555977$export$67d130a769494b9b);
const $bbad6368f6555977$var$getUndoRedoInputSource = (tr)=>{
    // Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $bbad6368f6555977$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $bbad6368f6555977$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};

});



parcelRegister("fxvTQ", function(module, exports) {

$parcel$export(module.exports, "basePlugin", () => (parcelRequire("exvYd")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $exvYd = parcelRequire("exvYd");

});
parcelRegister("exvYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e879347a52d164e4$export$2e2bcd8739ae039);

var $xjCuM = parcelRequire("xjCuM");
var $abme3 = parcelRequire("abme3");
var $3DR6L = parcelRequire("3DR6L");

var $6cqU9 = parcelRequire("6cqU9");

var $2RHbH = parcelRequire("2RHbH");

var $fZzhT = parcelRequire("fZzhT");

var $gmhCD = parcelRequire("gmhCD");

var $ba7Ek = parcelRequire("ba7Ek");

var $jhGvF = parcelRequire("jhGvF");

var $f6qgr = parcelRequire("f6qgr");

var $hzDkr = parcelRequire("hzDkr");

var $djY8Z = parcelRequire("djY8Z");

var $7Y3BJ = parcelRequire("7Y3BJ");

var $6qtBk = parcelRequire("6qtBk");

var $cpAC0 = parcelRequire("cpAC0");

var $ifnBN = parcelRequire("ifnBN");

var $63wcB = parcelRequire("63wcB");
function $e879347a52d164e4$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $e879347a52d164e4$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $e879347a52d164e4$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($e879347a52d164e4$var$SMART_TO_ASCII).join('')}]`, 'g');
const $e879347a52d164e4$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const callbacks = [];
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($e879347a52d164e4$var$FIND_SMART_CHAR, (match)=>$e879347a52d164e4$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                keyboardHeight: (0, $ifnBN.getKeyboardHeight)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $ba7Ek.setKeyboardHeight,
            resolveMarks: (from, to, tr)=>$e879347a52d164e4$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $f6qgr.default)(dispatchAnalyticsEvent)
                }
            ];
            if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', true, {
                exposure: true
            })) plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $7Y3BJ.createLazyNodeViewDecorationPlugin)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $djY8Z.default)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $6qtBk.default)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return (0, $hzDkr.default)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, $63wcB.inputTracking), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $fZzhT.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $6cqU9.keymap)({
                        ...(0, $2RHbH.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $cpAC0.default)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $jhGvF.default)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $xjCuM.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $abme3.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $3DR6L.text)
                }
            ];
        }
    };
};
var $e879347a52d164e4$export$2e2bcd8739ae039 = $e879347a52d164e4$var$basePlugin;

});
parcelRegister("6cqU9", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $22bfd21edb49568b$export$5043418e2ef368d5);

var $1SLCf = parcelRequire("1SLCf");

var $vWFRY = parcelRequire("vWFRY");

var $5KWxh = parcelRequire("5KWxh");
function $22bfd21edb49568b$export$5043418e2ef368d5(bindings) {
    return new (0, $5KWxh.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $1SLCf.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const isNonLatinKey = name.length === 1 && /[^\u0000-\u007f]/.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    // and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    // a key by event.code.
                    key: (0, $1SLCf.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $vWFRY.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("1SLCf", function(module, exports) {

$parcel$export(module.exports, "base", () => $15efc51ab78bc228$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $15efc51ab78bc228$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $15efc51ab78bc228$export$fb33aafd75404f4c);
var $15efc51ab78bc228$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $15efc51ab78bc228$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $15efc51ab78bc228$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $15efc51ab78bc228$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $15efc51ab78bc228$var$i = 0; $15efc51ab78bc228$var$i < 10; $15efc51ab78bc228$var$i++)$15efc51ab78bc228$export$e2253033e6e1df16[48 + $15efc51ab78bc228$var$i] = $15efc51ab78bc228$export$e2253033e6e1df16[96 + $15efc51ab78bc228$var$i] = String($15efc51ab78bc228$var$i);
// The function keys
for(var $15efc51ab78bc228$var$i = 1; $15efc51ab78bc228$var$i <= 24; $15efc51ab78bc228$var$i++)$15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$i + 111] = "F" + $15efc51ab78bc228$var$i;
// And the alphabetic keys
for(var $15efc51ab78bc228$var$i = 65; $15efc51ab78bc228$var$i <= 90; $15efc51ab78bc228$var$i++){
    $15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$i] = String.fromCharCode($15efc51ab78bc228$var$i + 32);
    $15efc51ab78bc228$export$fba63a578e423eb[$15efc51ab78bc228$var$i] = String.fromCharCode($15efc51ab78bc228$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $15efc51ab78bc228$var$code in $15efc51ab78bc228$export$e2253033e6e1df16)if (!$15efc51ab78bc228$export$fba63a578e423eb.hasOwnProperty($15efc51ab78bc228$var$code)) $15efc51ab78bc228$export$fba63a578e423eb[$15efc51ab78bc228$var$code] = $15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$code];
function $15efc51ab78bc228$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $15efc51ab78bc228$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $15efc51ab78bc228$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $15efc51ab78bc228$export$fba63a578e423eb : $15efc51ab78bc228$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("vWFRY", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $060068dc8add2821$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $060068dc8add2821$export$53f558754f8b9fd1);

var $1SLCf = parcelRequire("1SLCf");

var $gZGBX = parcelRequire("gZGBX");
const $060068dc8add2821$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $060068dc8add2821$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($060068dc8add2821$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $060068dc8add2821$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$060068dc8add2821$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $060068dc8add2821$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $060068dc8add2821$export$5043418e2ef368d5(bindings) {
    return new (0, $gZGBX.Plugin)({
        props: {
            handleKeyDown: $060068dc8add2821$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $060068dc8add2821$export$53f558754f8b9fd1(bindings) {
    let map = $060068dc8add2821$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $1SLCf.keyName)(event), baseName, direct = map[$060068dc8add2821$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$060068dc8add2821$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $1SLCf.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$060068dc8add2821$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});


parcelRegister("2RHbH", function(module, exports) {

$parcel$export(module.exports, "deleteSelection", () => $2162082cf5257878$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $2162082cf5257878$export$52b8a4af68d19794);
$parcel$export(module.exports, "createParagraphNear", () => $2162082cf5257878$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlock", () => $2162082cf5257878$export$e99155638ff4dff0);
$parcel$export(module.exports, "toggleMark", () => $2162082cf5257878$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $2162082cf5257878$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $2162082cf5257878$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $2162082cf5257878$export$4a0c2b85b1f0a889);

var $eS2Dn = parcelRequire("eS2Dn");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");
/**
Delete the selection, if there is one.
*/ const $2162082cf5257878$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $2162082cf5257878$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $2162082cf5257878$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $eS2Dn.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($2162082cf5257878$var$textblockAt(before, "end") || (0, $gZGBX.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $eS2Dn.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $kCV8T.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($2162082cf5257878$var$textblockAt(before, "end") ? (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $gZGBX.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $2162082cf5257878$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutBefore($cursor);
    return $cut ? $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $2162082cf5257878$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutAfter($cursor);
    return $cut ? $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $eS2Dn.replaceStep)(state.doc, beforePos, afterPos, (0, $kCV8T.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $eS2Dn.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $2162082cf5257878$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $2162082cf5257878$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $2162082cf5257878$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $gZGBX.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $2162082cf5257878$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $2162082cf5257878$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $2162082cf5257878$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($2162082cf5257878$var$textblockAt(after, "start") || (0, $gZGBX.NodeSelection).isSelectable(after))) {
        let delStep = (0, $eS2Dn.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $kCV8T.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($2162082cf5257878$var$textblockAt(after, "start") ? (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $gZGBX.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $2162082cf5257878$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $2162082cf5257878$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $gZGBX.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $2162082cf5257878$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $2162082cf5257878$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $gZGBX.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $eS2Dn.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $eS2Dn.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $2162082cf5257878$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $gZGBX.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $eS2Dn.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $eS2Dn.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $2162082cf5257878$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $eS2Dn.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $2162082cf5257878$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $2162082cf5257878$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $2162082cf5257878$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $2162082cf5257878$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $2162082cf5257878$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $gZGBX.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $2162082cf5257878$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $2162082cf5257878$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $eS2Dn.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $eS2Dn.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $2162082cf5257878$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $eS2Dn.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $2162082cf5257878$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $gZGBX.TextSelection) || state.selection instanceof (0, $gZGBX.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $eS2Dn.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $eS2Dn.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $2162082cf5257878$export$e99155638ff4dff0 = $2162082cf5257878$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $2162082cf5257878$export$eeb429476568b72b = (state, dispatch)=>{
    return $2162082cf5257878$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $2162082cf5257878$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $2162082cf5257878$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $gZGBX.AllSelection)(state.doc)));
    return true;
};
function $2162082cf5257878$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $eS2Dn.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $2162082cf5257878$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $kCV8T.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $kCV8T.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $kCV8T.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $eS2Dn.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $kCV8T.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $eS2Dn.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $gZGBX.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $eS2Dn.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $2162082cf5257878$var$textblockAt(after, "start", true) && $2162082cf5257878$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $kCV8T.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $kCV8T.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $eS2Dn.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $kCV8T.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $2162082cf5257878$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $2162082cf5257878$export$c3a64f3c9604a1b1 = $2162082cf5257878$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $2162082cf5257878$export$a66c1876556415e5 = $2162082cf5257878$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $2162082cf5257878$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $eS2Dn.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $2162082cf5257878$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $2162082cf5257878$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $2162082cf5257878$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $gZGBX.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $gZGBX.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $2162082cf5257878$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$2162082cf5257878$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $2162082cf5257878$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $2162082cf5257878$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $eS2Dn.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $2162082cf5257878$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $2162082cf5257878$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $2162082cf5257878$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $2162082cf5257878$var$backspace = $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$e9a518a637d1e641, $2162082cf5257878$export$979097b097459299, $2162082cf5257878$export$52b8a4af68d19794);
let $2162082cf5257878$var$del = $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$e9a518a637d1e641, $2162082cf5257878$export$bf432e340007f9ef, $2162082cf5257878$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $2162082cf5257878$export$eb36e8971b04df36 = {
    "Enter": $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$a5d02b4b65e94f91, $2162082cf5257878$export$d0f80ac1b4510888, $2162082cf5257878$export$a3574cc681852c08, $2162082cf5257878$export$e99155638ff4dff0),
    "Mod-Enter": $2162082cf5257878$export$634b78845598ff5b,
    "Backspace": $2162082cf5257878$var$backspace,
    "Mod-Backspace": $2162082cf5257878$var$backspace,
    "Shift-Backspace": $2162082cf5257878$var$backspace,
    "Delete": $2162082cf5257878$var$del,
    "Mod-Delete": $2162082cf5257878$var$del,
    "Mod-a": $2162082cf5257878$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $2162082cf5257878$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $2162082cf5257878$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $2162082cf5257878$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $2162082cf5257878$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $2162082cf5257878$export$c3a64f3c9604a1b1,
    "Ctrl-e": $2162082cf5257878$export$a66c1876556415e5
};
for(let key in $2162082cf5257878$export$eb36e8971b04df36)$2162082cf5257878$export$f292ad8dbd5063c8[key] = $2162082cf5257878$export$eb36e8971b04df36[key];
const $2162082cf5257878$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $2162082cf5257878$export$4a0c2b85b1f0a889 = $2162082cf5257878$var$mac ? $2162082cf5257878$export$f292ad8dbd5063c8 : $2162082cf5257878$export$eb36e8971b04df36;

});

parcelRegister("fZzhT", function(module, exports) {

$parcel$export(module.exports, "closeHistory", () => $ba47ece1f7bbc51a$export$181a649d919c589e);
$parcel$export(module.exports, "history", () => $ba47ece1f7bbc51a$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $ba47ece1f7bbc51a$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $ba47ece1f7bbc51a$export$1688e416fee0a49e);

var $4h9Gl = parcelRequire("4h9Gl");

var $eS2Dn = parcelRequire("eS2Dn");

var $gZGBX = parcelRequire("gZGBX");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $ba47ece1f7bbc51a$var$max_empty_items = 500;
class $ba47ece1f7bbc51a$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $ba47ece1f7bbc51a$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $ba47ece1f7bbc51a$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $ba47ece1f7bbc51a$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $ba47ece1f7bbc51a$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $ba47ece1f7bbc51a$var$DEPTH_OVERFLOW) {
            oldItems = $ba47ece1f7bbc51a$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $ba47ece1f7bbc51a$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $eS2Dn.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $ba47ece1f7bbc51a$var$Branch(this.items.append(array.map((map)=>new $ba47ece1f7bbc51a$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $ba47ece1f7bbc51a$var$Item(map, step, selection));
            } else rebasedItems.push(new $ba47ece1f7bbc51a$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $ba47ece1f7bbc51a$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $ba47ece1f7bbc51a$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $ba47ece1f7bbc51a$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $ba47ece1f7bbc51a$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $ba47ece1f7bbc51a$var$Branch((0, $4h9Gl.default).from(items.reverse()), events);
    }
}
$ba47ece1f7bbc51a$var$Branch.empty = new $ba47ece1f7bbc51a$var$Branch((0, $4h9Gl.default).empty, 0);
function $ba47ece1f7bbc51a$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $ba47ece1f7bbc51a$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $ba47ece1f7bbc51a$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $ba47ece1f7bbc51a$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $ba47ece1f7bbc51a$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $ba47ece1f7bbc51a$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($ba47ece1f7bbc51a$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($ba47ece1f7bbc51a$var$closeHistoryKey)) history = new $ba47ece1f7bbc51a$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($ba47ece1f7bbc51a$var$historyKey)) {
        if (appended.getMeta($ba47ece1f7bbc51a$var$historyKey).redo) return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addTransform(tr, undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), history.undone, $ba47ece1f7bbc51a$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $ba47ece1f7bbc51a$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$ba47ece1f7bbc51a$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping) : $ba47ece1f7bbc51a$var$rangesFor(tr.mapping.maps);
        return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), $ba47ece1f7bbc51a$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $ba47ece1f7bbc51a$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $ba47ece1f7bbc51a$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $ba47ece1f7bbc51a$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $ba47ece1f7bbc51a$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $ba47ece1f7bbc51a$var$histTransaction(history, state, redo) {
    let preserveItems = $ba47ece1f7bbc51a$var$mustPreserveItems(state);
    let histOptions = $ba47ece1f7bbc51a$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $ba47ece1f7bbc51a$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($ba47ece1f7bbc51a$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $ba47ece1f7bbc51a$var$cachedPreserveItems = false, $ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $ba47ece1f7bbc51a$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins != plugins) {
        $ba47ece1f7bbc51a$var$cachedPreserveItems = false;
        $ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $ba47ece1f7bbc51a$var$cachedPreserveItems = true;
            break;
        }
    }
    return $ba47ece1f7bbc51a$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $ba47ece1f7bbc51a$export$181a649d919c589e(tr) {
    return tr.setMeta($ba47ece1f7bbc51a$var$closeHistoryKey, true);
}
const $ba47ece1f7bbc51a$var$historyKey = new (0, $gZGBX.PluginKey)("history");
const $ba47ece1f7bbc51a$var$closeHistoryKey = new (0, $gZGBX.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $ba47ece1f7bbc51a$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $gZGBX.Plugin)({
        key: $ba47ece1f7bbc51a$var$historyKey,
        state: {
            init () {
                return new $ba47ece1f7bbc51a$var$HistoryState($ba47ece1f7bbc51a$var$Branch.empty, $ba47ece1f7bbc51a$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $ba47ece1f7bbc51a$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $ba47ece1f7bbc51a$export$21f930c44940fd98 : inputType == "historyRedo" ? $ba47ece1f7bbc51a$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $ba47ece1f7bbc51a$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $ba47ece1f7bbc51a$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $ba47ece1f7bbc51a$export$21f930c44940fd98 = $ba47ece1f7bbc51a$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $ba47ece1f7bbc51a$export$1688e416fee0a49e = $ba47ece1f7bbc51a$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $ba47ece1f7bbc51a$export$24b5d280435f3a3f = $ba47ece1f7bbc51a$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $ba47ece1f7bbc51a$export$3774e54bae7be19b = $ba47ece1f7bbc51a$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $ba47ece1f7bbc51a$export$f8a176c2b9a10bdb(state) {
    let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $ba47ece1f7bbc51a$export$3ffe6b288e7d941b(state) {
    let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("4h9Gl", function(module, exports) {

$parcel$export(module.exports, "default", () => $31d0429bb13bd60b$export$2e2bcd8739ae039);
var $31d0429bb13bd60b$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $31d0429bb13bd60b$var$RopeSequence = function RopeSequence() {};
$31d0429bb13bd60b$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $31d0429bb13bd60b$var$RopeSequence.from(other);
    return !this.length && other || other.length < $31d0429bb13bd60b$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $31d0429bb13bd60b$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$31d0429bb13bd60b$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $31d0429bb13bd60b$var$RopeSequence.from(other).append(this);
};
$31d0429bb13bd60b$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $31d0429bb13bd60b$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$31d0429bb13bd60b$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $31d0429bb13bd60b$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$31d0429bb13bd60b$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$31d0429bb13bd60b$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$31d0429bb13bd60b$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$31d0429bb13bd60b$var$RopeSequence.from = function from(values) {
    if (values instanceof $31d0429bb13bd60b$var$RopeSequence) return values;
    return values && values.length ? new $31d0429bb13bd60b$var$Leaf(values) : $31d0429bb13bd60b$var$RopeSequence.empty;
};
var $31d0429bb13bd60b$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $31d0429bb13bd60b$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $31d0429bb13bd60b$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($31d0429bb13bd60b$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$31d0429bb13bd60b$var$RopeSequence.empty = new $31d0429bb13bd60b$var$Leaf([]);
var $31d0429bb13bd60b$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($31d0429bb13bd60b$var$RopeSequence);
var $31d0429bb13bd60b$export$2e2bcd8739ae039 = $31d0429bb13bd60b$var$RopeSequence;

});


parcelRegister("ba7Ek", function(module, exports) {

$parcel$export(module.exports, "setKeyboardHeight", () => $6c7eced9f1689a9a$export$b8c3ea160300668d);

var $6OgMR = parcelRequire("6OgMR");
const $6c7eced9f1689a9a$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $6OgMR.scrollGutterPluginKey), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("6OgMR", function(module, exports) {

$parcel$export(module.exports, "scrollGutterPluginKey", () => $418a73e08450538e$export$54fdd3c2782161ea);
$parcel$export(module.exports, "getScrollGutterPluginState", () => $418a73e08450538e$export$a237783470abe542);

var $gZGBX = parcelRequire("gZGBX");
const $418a73e08450538e$export$54fdd3c2782161ea = new (0, $gZGBX.PluginKey)('scrollGutter');
const $418a73e08450538e$export$a237783470abe542 = (state)=>{
    if (state) return $418a73e08450538e$export$54fdd3c2782161ea.getState(state);
};

});


parcelRegister("jhGvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcaf55d45289964b$export$2e2bcd8739ae039);

var $gE8f9 = parcelRequire("gE8f9");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
function $fcaf55d45289964b$var$getCurrentBrowserAndVersion() {
    switch(true){
        case (0, $gE8f9.browser).chrome === true:
            return {
                browser: 'chrome',
                version: (0, $gE8f9.browser).chrome_version
            };
        case (0, $gE8f9.browser).ie === true:
            return {
                browser: 'ie',
                version: (0, $gE8f9.browser).ie_version
            };
        case (0, $gE8f9.browser).gecko === true:
            return {
                browser: 'gecko',
                version: (0, $gE8f9.browser).gecko_version
            };
        case (0, $gE8f9.browser).safari === true:
            return {
                browser: 'safari',
                version: (0, $gE8f9.browser).safari_version
            };
    }
    return undefined;
}
var $fcaf55d45289964b$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $5KWxh.SafePlugin)({
        key: new (0, $gZGBX.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const userCurrentBrowserAndVersion = $fcaf55d45289964b$var$getCurrentBrowserAndVersion();
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !(0, $gE8f9.browser)[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : (0, $gE8f9.browser)[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });

});

parcelRegister("f6qgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $70f314a94b71d913$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $J5Axj = parcelRequire("J5Axj");

var $5KWxh = parcelRequire("5KWxh");
const $70f314a94b71d913$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $70f314a94b71d913$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $5KWxh.SafePlugin)({
        filterTransaction (transaction) {
            if ($70f314a94b71d913$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $J5Axj.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};

});

parcelRegister("hzDkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf75182aad6c615$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $hETfp = parcelRequire("hETfp");

var $k4HYa = parcelRequire("k4HYa");

var $b7gJe = parcelRequire("b7gJe");

var $5KWxh = parcelRequire("5KWxh");

var $4NUlu = parcelRequire("4NUlu");

var $gZGBX = parcelRequire("gZGBX");

var $cOJEB = parcelRequire("cOJEB");

var $jkVhk = parcelRequire("jkVhk");
const $dcf75182aad6c615$export$70246689264eff75 = new (0, $gZGBX.PluginKey)('frozenEditor');
const $dcf75182aad6c615$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $dcf75182aad6c615$var$DEFAULT_SLOW_THRESHOLD = 300;
const $dcf75182aad6c615$export$c8d5b833abcf8e80 = 600;
const $dcf75182aad6c615$export$47b2879ca9bbf67a = 2000;
const $dcf75182aad6c615$export$1b622068be977101 = 3000;
const $dcf75182aad6c615$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $dcf75182aad6c615$export$5705ac5f923a65e7 = 100;
const $dcf75182aad6c615$export$1c6feb3429832c55 = 500;
const $dcf75182aad6c615$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    };
var $dcf75182aad6c615$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $cOJEB.setInteractionType)((0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $dcf75182aad6c615$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $dcf75182aad6c615$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $dcf75182aad6c615$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $k4HYa.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $dcf75182aad6c615$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $dcf75182aad6c615$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $dcf75182aad6c615$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $5KWxh.SafePlugin)({
            key: $dcf75182aad6c615$export$70246689264eff75,
            props: (0, $b7gJe.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $cOJEB.setInteractionType)((0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $cOJEB.setInteractionType)((0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $b7gJe.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $jkVhk.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $gkwXh.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $gkwXh.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $gkwXh.ACTION).SLOW_INPUT,
                            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $dcf75182aad6c615$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, $4NUlu.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };

});
parcelRegister("k4HYa", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $550dac80d474b87c$export$1daf15cbaf649dad);
function $550dac80d474b87c$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}

});

parcelRegister("cOJEB", function(module, exports) {

$parcel$export(module.exports, "setInteractionType", () => $1385fb4dd77fadaa$export$324d9bc8f4935d84);
/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $1385fb4dd77fadaa$export$324d9bc8f4935d84 = (value)=>value;

});

parcelRegister("jkVhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0f8dc490d52d26f$export$2e2bcd8739ae039);

var $4NUlu = parcelRequire("4NUlu");

var $4TYuJ = parcelRequire("4TYuJ");
class $b0f8dc490d52d26f$export$2e2bcd8739ae039 {
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $4TYuJ.getTimeSince)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $4NUlu.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
}

});
parcelRegister("4TYuJ", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $20eb0060210a6f48$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $20eb0060210a6f48$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("djY8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ccc9e8b26cedb9$export$2e2bcd8739ae039);

var $gE8f9 = parcelRequire("gE8f9");

var $5KWxh = parcelRequire("5KWxh");

var $594Yf = parcelRequire("594Yf");


var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");
const $66ccc9e8b26cedb9$export$8836bfc6be4cb708 = new (0, $gZGBX.PluginKey)('inlineCursorTargetPlugin');
const $66ccc9e8b26cedb9$var$isInlineNodeView = (node)=>{
    /**
	 * If inlineNodeView is a hardbreak we don't want to add decorations
	 * as it breaks soft line breaks for Japanese/Chinese keyboards.
	 */ const isHardBreak = node?.type === node?.type.schema.nodes.hardBreak;
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $66ccc9e8b26cedb9$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $66ccc9e8b26cedb9$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($66ccc9e8b26cedb9$export$8836bfc6be4cb708);
                if (selection && (0, $594Yf.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $etG8M.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                if ($66ccc9e8b26cedb9$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $etG8M.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    if ((0, $gE8f9.browser).safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($66ccc9e8b26cedb9$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $66ccc9e8b26cedb9$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    const tr = view.state.tr;
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    tr.insertText(content);
    view.dispatch(tr);
}

});

parcelRegister("7Y3BJ", function(module, exports) {

$parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", () => $65853fcadaed25d5$export$650082547b31be68);

var $3xRyR = parcelRequire("3xRyR");

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");
const $65853fcadaed25d5$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $65853fcadaed25d5$export$650082547b31be68() {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $3xRyR.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $etG8M.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $3xRyR.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $3xRyR.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $etG8M.Decoration).node(pos, pos + node.nodeSize, {
                            class: $65853fcadaed25d5$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $etG8M.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $etG8M.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $3xRyR.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
					 * After view update can clean up decorations...
					 */ const pluginState = (0, $3xRyR.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $etG8M.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $3xRyR.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}

});
parcelRegister("3xRyR", function(module, exports) {

$parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", () => $b4549f33660d686a$export$325659f41b2239a7);
$parcel$export(module.exports, "withLazyLoading", () => $b4549f33660d686a$export$6b97b121e15a69b7);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gZGBX = parcelRequire("gZGBX");

var $5qeGx = parcelRequire("5qeGx");

var $6J9GW = parcelRequire("6J9GW");

var $7KZr8 = parcelRequire("7KZr8");
const $b4549f33660d686a$export$325659f41b2239a7 = new (0, $gZGBX.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $b4549f33660d686a$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $b4549f33660d686a$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $b4549f33660d686a$var$debounceToEditorViewMap = new WeakMap();
const $b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $b4549f33660d686a$export$6c7e823c919edf69(view) {
    $b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $b4549f33660d686a$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        let requestedNodes = $b4549f33660d686a$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $b4549f33660d686a$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $b4549f33660d686a$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $b4549f33660d686a$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $6J9GW.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $6J9GW.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            $b4549f33660d686a$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
			 * Triggering lazyNodeViewDecoration plugin to apply decorations
			 * to nodes with newly loaded NodeViews.
			 */ const [callbackId, nodeTypes] = $b4549f33660d686a$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $5qeGx.cancelCallback)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $5qeGx.scheduleCallback)(()=>{
                $b4549f33660d686a$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($b4549f33660d686a$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $b4549f33660d686a$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
			 * END triggering LazyNodeViewDecoration plugin
			 */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $6J9GW.LazyNodeView)(node, view, getPos, decorations);
    };
};

});
parcelRegister("5qeGx", function(module, exports) {

$parcel$export(module.exports, "scheduleCallback", () => $76aba5618edd3d60$export$4db3c991f22dbc2d);
$parcel$export(module.exports, "cancelCallback", () => $76aba5618edd3d60$export$b888d8f981c07a46);
const $76aba5618edd3d60$var$hasIdleCallback = 'requestIdleCallback' in window;
const $76aba5618edd3d60$export$4db3c991f22dbc2d = (cb, options)=>{
    return $76aba5618edd3d60$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $76aba5618edd3d60$export$b888d8f981c07a46 = (id)=>{
    return $76aba5618edd3d60$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};

});

parcelRegister("6J9GW", function(module, exports) {

$parcel$export(module.exports, "makeNodePlaceholderId", () => $178c99317a21749f$export$f306d9dd555af398);
$parcel$export(module.exports, "LazyNodeView", () => $178c99317a21749f$export$dccb00b9da782c66);

var $gJBT6 = parcelRequire("gJBT6");

var $kCV8T = parcelRequire("kCV8T");
const $178c99317a21749f$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $178c99317a21749f$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
function $178c99317a21749f$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}
class $178c99317a21749f$export$dccb00b9da782c66 {
    constructor(node, view, _getPos, outerDeco){
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$178c99317a21749f$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = node;
        this.outerDeco = outerDeco;
        if (typeof node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $178c99317a21749f$var$getEditorLineWidth(view)
        };
        const fallback = (0, $kCV8T.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', $178c99317a21749f$export$f306d9dd555af398(node.type.name, pos));
        }
    }
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
}

});

parcelRegister("7KZr8", function(module, exports) {

$parcel$export(module.exports, "convertToInlineCss", () => $383278441dd86b5b$export$7da93c9174ab9340);
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $383278441dd86b5b$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
function $383278441dd86b5b$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $383278441dd86b5b$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}

});



parcelRegister("6qtBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $459ed5956f03f982$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $k24a0 = parcelRequire("k24a0");
var $ggL2v = parcelRequire("ggL2v");

var $vWFRY = parcelRequire("vWFRY");

var $gZGBX = parcelRequire("gZGBX");
const $459ed5956f03f982$export$2f489388b18569dd = new (0, $gZGBX.PluginKey)('newlinePreserveMarksPlugin');
const $459ed5956f03f982$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $459ed5956f03f982$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $459ed5956f03f982$export$2e2bcd8739ae039 = ()=>new (0, $5KWxh.SafePlugin)({
        key: $459ed5956f03f982$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $vWFRY.keydownHandler)({
                Enter: (0, $k24a0.filterCommand)([
                    (0, $ggL2v.isSelectionEndOfParagraph),
                    $459ed5956f03f982$var$isSelectionAligned
                ], $459ed5956f03f982$var$splitBlockPreservingMarks)
            })
        }
    });

});
parcelRegister("k24a0", function(module, exports) {

$parcel$export(module.exports, "walkNextNode", () => $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0);
$parcel$export(module.exports, "walkPrevNode", () => $9c1f67beb7dd4702$export$cab15df6ad89b5a0);
$parcel$export(module.exports, "insertNewLineWithAnalytics", () => $9c1f67beb7dd4702$export$67efd148fa31066c);
$parcel$export(module.exports, "createNewParagraphAbove", () => $9c1f67beb7dd4702$export$fd094c1e3c1540bf);
$parcel$export(module.exports, "createParagraphNear", () => $9c1f67beb7dd4702$export$d0f80ac1b4510888);
$parcel$export(module.exports, "createNewParagraphBelow", () => $9c1f67beb7dd4702$export$d4296e42f66d8dc6);
$parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", () => $9c1f67beb7dd4702$export$a52ade1f964aef2c);
$parcel$export(module.exports, "insertContentDeleteRange", () => $9c1f67beb7dd4702$export$1a87582f65bdc5db);
$parcel$export(module.exports, "isEmptySelectionAtStart", () => $9c1f67beb7dd4702$export$55f1e30b4664ff16);
$parcel$export(module.exports, "isEmptySelectionAtEnd", () => $9c1f67beb7dd4702$export$aedf35c057f77b82);
$parcel$export(module.exports, "filterCommand", () => $9c1f67beb7dd4702$export$3dea766d36a8935f);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $14FOE = parcelRequire("14FOE");

var $hPjvp = parcelRequire("hPjvp");

var $594Yf = parcelRequire("594Yf");

var $20Kbb = parcelRequire("20Kbb");
const $9c1f67beb7dd4702$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
const $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $9c1f67beb7dd4702$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
function $9c1f67beb7dd4702$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $kCV8T.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $gZGBX.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
const $9c1f67beb7dd4702$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $14FOE.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    })($9c1f67beb7dd4702$export$c2d9390f63354627());
const $9c1f67beb7dd4702$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$9c1f67beb7dd4702$var$canMoveUp(state) && $9c1f67beb7dd4702$var$canCreateParagraphNear(state)) {
        $9c1f67beb7dd4702$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $9c1f67beb7dd4702$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$9c1f67beb7dd4702$var$canMoveDown(state) && $9c1f67beb7dd4702$var$canCreateParagraphNear(state)) {
        $9c1f67beb7dd4702$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $9c1f67beb7dd4702$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $gZGBX.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $9c1f67beb7dd4702$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $gZGBX.TextSelection)) {
            if ($9c1f67beb7dd4702$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $9c1f67beb7dd4702$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $9c1f67beb7dd4702$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $9c1f67beb7dd4702$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $9c1f67beb7dd4702$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $gZGBX.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $9c1f67beb7dd4702$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $9c1f67beb7dd4702$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $gZGBX.NodeSelection) && (0, $20Kbb.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $gZGBX.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$9c1f67beb7dd4702$export$e9083e8cbe24bec0(state);
}
function $9c1f67beb7dd4702$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $gZGBX.NodeSelection) && (0, $20Kbb.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $gZGBX.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$9c1f67beb7dd4702$export$4ca816540352da02(state);
}
function $9c1f67beb7dd4702$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $9c1f67beb7dd4702$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
const $9c1f67beb7dd4702$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $594Yf.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $9c1f67beb7dd4702$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $gZGBX.TextSelection)(getSelectionResolvedPos(tr)));
};
const $9c1f67beb7dd4702$export$55f1e30b4664ff16 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $hPjvp.GapCursorSelection));
};
const $9c1f67beb7dd4702$export$aedf35c057f77b82 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $hPjvp.GapCursorSelection));
};

});
parcelRegister("14FOE", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $6ff06cde8c465d99$export$af9baadf0e4f6e13);
function $6ff06cde8c465d99$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}

});



parcelRegister("cpAC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7308593ddbe0677$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $6OgMR = parcelRequire("6OgMR");
const $b7308593ddbe0677$var$GUTTER_SIZE_IN_PX = 120;
const $b7308593ddbe0677$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $b7308593ddbe0677$var$createGutter(gutterSize, parent) {
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $b7308593ddbe0677$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent?.removeChild(gutter);
}
var $b7308593ddbe0677$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $b7308593ddbe0677$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $6OgMR.scrollGutterPluginKey),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $6OgMR.scrollGutterPluginKey))) return tr.getMeta((0, $6OgMR.scrollGutterPluginKey));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = editorElement?.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $b7308593ddbe0677$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};

});

parcelRegister("ifnBN", function(module, exports) {

$parcel$export(module.exports, "getKeyboardHeight", () => $0be4535785a4bbee$export$af5702f0c69bf4d7);

var $6OgMR = parcelRequire("6OgMR");
const $0be4535785a4bbee$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $6OgMR.getScrollGutterPluginState)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};

});

parcelRegister("63wcB", function(module, exports) {

$parcel$export(module.exports, "inputTracking", () => $f59d9be74f9c3dfe$export$30b652f8daa79df4);
const $f59d9be74f9c3dfe$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};

});



parcelRegister("at6Ig", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => (parcelRequire("kiLfG")).betterTypeHistoryPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kiLfG = parcelRequire("kiLfG");

});
parcelRegister("kiLfG", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => $10c9d21a664b94c0$export$5587393ddd97118a);

var $jkD4K = parcelRequire("jkD4K");

var $jsq8Z = parcelRequire("jsq8Z");
/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $10c9d21a664b94c0$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $jsq8Z.pluginKey), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $jkD4K.default)()
                }
            ];
        }
    };
};

});
parcelRegister("jkD4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $f65bcd99d0e862c8$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $594Yf = parcelRequire("594Yf");

var $fZzhT = parcelRequire("fZzhT");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $jsq8Z = parcelRequire("jsq8Z");
const $f65bcd99d0e862c8$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $gZGBX.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $f65bcd99d0e862c8$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $f65bcd99d0e862c8$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $kCV8T.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $f65bcd99d0e862c8$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $jsq8Z.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $jsq8Z.pluginKey)));
            if (hasHandlePasteMeta) return (0, $fZzhT.closeHistory)(newState.tr);
            const enterStep = $f65bcd99d0e862c8$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $594Yf.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($f65bcd99d0e862c8$var$isSliceSplittingBlockNode(slice) || $f65bcd99d0e862c8$var$isSliceAddingNewlineChar(slice, schema))) return (0, $fZzhT.closeHistory)(newState.tr);
        }
    });
};

});
parcelRegister("jsq8Z", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1d2020e42b3f90c2$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $1d2020e42b3f90c2$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('betterTypeHistoryPlugin');

});




parcelRegister("aboEQ", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => (parcelRequire("2hnN6")).blockTypePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2hnN6 = parcelRequire("2hnN6");

});
parcelRegister("2hnN6", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => $968ed2855767f974$export$896c3d927d705025);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $aXBFx = parcelRequire("aXBFx");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");

var $gkwXh = parcelRequire("gkwXh");

var $6cqU9 = parcelRequire("6cqU9");
var $e9qoo = parcelRequire("e9qoo");

var $9NKqk = parcelRequire("9NKqk");

var $I02Nt = parcelRequire("I02Nt");

var $kXC89 = parcelRequire("kXC89");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $iJp6U = parcelRequire("iJp6U");

var $eKy27 = parcelRequire("eKy27");

var $kdso8 = parcelRequire("kdso8");

var $5pNa3 = parcelRequire("5pNa3");

var $6AEe7 = parcelRequire("6AEe7");

var $62ifj = parcelRequire("62ifj");
const $968ed2855767f974$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $9NKqk.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $e9qoo.tooltip)((0, $6cqU9.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $9NKqk.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).FORMATTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $968ed2855767f974$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $9NKqk.messages).blockquote),
            description: formatMessage((0, $9NKqk.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconQuote), {}),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).FORMATTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $968ed2855767f974$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $kXC89.ToolbarSize).XXL : toolbarSize < (0, $kXC89.ToolbarSize).XL;
        if ((0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $kXC89.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $62ifj.PrimaryToolbarComponent), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    return {
        name: 'blockType',
        nodes () {
            const blockquote = (0, $gmhCD.editorExperiment)('platform_editor_nested_non_bodied_macros', 'test', {
                exposure: false
            }) ? (0, $aXBFx.extendedBlockquote) : (0, $aXBFx.blockquoteWithoutNonBodiedMacros);
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $lRTZM.heading)
                },
                {
                    name: 'blockquote',
                    node: blockquote
                },
                {
                    name: 'hardBreak',
                    node: (0, $jnMM2.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $5pNa3.createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph, options?.includeBlockQuoteAsTextstyleOption)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $eKy27.default)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $kdso8.default)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $iJp6U.insertBlockQuoteWithAnalytics)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                return (0, $iJp6U.setBlockTypeWithAnalytics)(level, inputMethod, api?.analytics?.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                return (0, $iJp6U.insertBlockQuoteWithAnalyticsCommand)(inputMethod, api?.analytics?.actions);
            },
            clearFormatting (inputMethod) {
                return (0, $iJp6U.clearFormatting)(inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $5pNa3.pluginKey).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            selectionToolbar: ()=>{
                if (api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking === 'none' && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, _dispatchAnalyticsEvent)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6AEe7.FloatingToolbarComponent), {
                                api: api
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 8
                    };
                } else return undefined;
            },
            ...(0, $gmhCD.editorExperiment)('platform_editor_insertion', 'control') && {
                quickInsert: (intl)=>{
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$968ed2855767f974$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                        ...$968ed2855767f974$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                    ];
                }
            }
        }
    };
};

});
parcelRegister("e9qoo", function(module, exports) {

$parcel$export(module.exports, "addAltText", () => $fd6a91b3693b55d8$export$82527b23b485fa7f);
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $fd6a91b3693b55d8$export$7e6b588cc98b34f1);
$parcel$export(module.exports, "navToEditorToolbar", () => $fd6a91b3693b55d8$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $fd6a91b3693b55d8$export$7be006a99a30f86b);
$parcel$export(module.exports, "toggleBold", () => $fd6a91b3693b55d8$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $fd6a91b3693b55d8$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $fd6a91b3693b55d8$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $fd6a91b3693b55d8$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $fd6a91b3693b55d8$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $fd6a91b3693b55d8$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $fd6a91b3693b55d8$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $fd6a91b3693b55d8$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $fd6a91b3693b55d8$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $fd6a91b3693b55d8$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $fd6a91b3693b55d8$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $fd6a91b3693b55d8$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $fd6a91b3693b55d8$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $fd6a91b3693b55d8$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $fd6a91b3693b55d8$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $fd6a91b3693b55d8$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleOrderedList", () => $fd6a91b3693b55d8$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $fd6a91b3693b55d8$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $fd6a91b3693b55d8$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $fd6a91b3693b55d8$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $fd6a91b3693b55d8$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $fd6a91b3693b55d8$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $fd6a91b3693b55d8$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $fd6a91b3693b55d8$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $fd6a91b3693b55d8$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $fd6a91b3693b55d8$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $fd6a91b3693b55d8$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $fd6a91b3693b55d8$export$959569198ddbbe17);
$parcel$export(module.exports, "redoAlt", () => $fd6a91b3693b55d8$export$c0e41ad67d77f6bb);
$parcel$export(module.exports, "redo", () => $fd6a91b3693b55d8$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $fd6a91b3693b55d8$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $fd6a91b3693b55d8$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $fd6a91b3693b55d8$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "submit", () => $fd6a91b3693b55d8$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $fd6a91b3693b55d8$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $fd6a91b3693b55d8$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $fd6a91b3693b55d8$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $fd6a91b3693b55d8$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $fd6a91b3693b55d8$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $fd6a91b3693b55d8$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $fd6a91b3693b55d8$export$9e41eded5cb7e706);
$parcel$export(module.exports, "escape", () => $fd6a91b3693b55d8$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $fd6a91b3693b55d8$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $fd6a91b3693b55d8$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $fd6a91b3693b55d8$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $fd6a91b3693b55d8$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $fd6a91b3693b55d8$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $fd6a91b3693b55d8$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $fd6a91b3693b55d8$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $fd6a91b3693b55d8$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $fd6a91b3693b55d8$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $fd6a91b3693b55d8$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $fd6a91b3693b55d8$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $fd6a91b3693b55d8$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $fd6a91b3693b55d8$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $fd6a91b3693b55d8$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeft", () => $fd6a91b3693b55d8$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRight", () => $fd6a91b3693b55d8$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDown", () => $fd6a91b3693b55d8$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUp", () => $fd6a91b3693b55d8$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $fd6a91b3693b55d8$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $fd6a91b3693b55d8$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $fd6a91b3693b55d8$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $fd6a91b3693b55d8$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $fd6a91b3693b55d8$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $fd6a91b3693b55d8$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $fd6a91b3693b55d8$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $fd6a91b3693b55d8$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "selectRow", () => $fd6a91b3693b55d8$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $fd6a91b3693b55d8$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $fd6a91b3693b55d8$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $fd6a91b3693b55d8$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $fd6a91b3693b55d8$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $fd6a91b3693b55d8$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $fd6a91b3693b55d8$export$ec123199f2fe4770);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $fd6a91b3693b55d8$export$6b05735f625d1c82);
$parcel$export(module.exports, "continueInRovoChat", () => $fd6a91b3693b55d8$export$54f122e0d55178a9);
$parcel$export(module.exports, "formatShortcut", () => $fd6a91b3693b55d8$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $fd6a91b3693b55d8$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $fd6a91b3693b55d8$export$4096cb8ab9668358);
$parcel$export(module.exports, "findKeymapByDescription", () => $fd6a91b3693b55d8$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $fd6a91b3693b55d8$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $fd6a91b3693b55d8$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $fd6a91b3693b55d8$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $fd6a91b3693b55d8$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $fd6a91b3693b55d8$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $fd6a91b3693b55d8$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $fd6a91b3693b55d8$export$f2da701c7659a26c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1SLCf = parcelRequire("1SLCf");

var $31nwk = parcelRequire("31nwk");

var $gE8f9 = parcelRequire("gE8f9");


var $6cqU9 = parcelRequire("6cqU9");
const $fd6a91b3693b55d8$export$82527b23b485fa7f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $fd6a91b3693b55d8$export$9288bbefb6b7498b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $fd6a91b3693b55d8$export$7be006a99a30f86b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $fd6a91b3693b55d8$export$183fe6d20e9e58ba = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $fd6a91b3693b55d8$export$b03177f345903916 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $fd6a91b3693b55d8$export$6bcc93697958b66d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $fd6a91b3693b55d8$export$6d564ba4eaf138d9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $fd6a91b3693b55d8$export$d26ab98fee0c804 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $fd6a91b3693b55d8$export$4af6b58e12324fd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $fd6a91b3693b55d8$export$70686c6e7e15ed46 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $fd6a91b3693b55d8$export$ab06dc742bb20e03 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $fd6a91b3693b55d8$export$195de5d8e201efd7 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $fd6a91b3693b55d8$export$63c4f0859cc75dc6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $fd6a91b3693b55d8$export$953ab0e6a5d310a9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $fd6a91b3693b55d8$export$192a351cfd6ca247 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $fd6a91b3693b55d8$export$fe382f3f4c871c62 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $fd6a91b3693b55d8$export$4073e08db19e0e31 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $fd6a91b3693b55d8$export$b84e85b2035ddb39 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $fd6a91b3693b55d8$export$86b1ac99fd15509b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $fd6a91b3693b55d8$export$dca848a1b50b6a31 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $fd6a91b3693b55d8$export$17f69a767ce93bb3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $fd6a91b3693b55d8$export$c0e115f47553645e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $fd6a91b3693b55d8$export$34ed0cbd4f7ff88 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $fd6a91b3693b55d8$export$c2d9390f63354627 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $fd6a91b3693b55d8$export$dfd73a1c108b1570 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $fd6a91b3693b55d8$export$9e5a9569a07601f2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $fd6a91b3693b55d8$export$e920ee2eb756d384 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $fd6a91b3693b55d8$export$5f13bbad564673d4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $fd6a91b3693b55d8$export$21f930c44940fd98 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $fd6a91b3693b55d8$export$44935f8a884b57b9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $fd6a91b3693b55d8$export$8eba228b343b3599 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $fd6a91b3693b55d8$export$108f27160c89e515 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $fd6a91b3693b55d8$export$e2c874fbfec7201 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $fd6a91b3693b55d8$export$8066a906978eedb2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $fd6a91b3693b55d8$export$959569198ddbbe17 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $fd6a91b3693b55d8$export$c0e41ad67d77f6bb = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $fd6a91b3693b55d8$export$1688e416fee0a49e = $fd6a91b3693b55d8$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $fd6a91b3693b55d8$export$1e2fd7795238a2d3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $fd6a91b3693b55d8$export$56b88caa6d8a3bff = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $fd6a91b3693b55d8$export$fd78ad47ea0892f4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $fd6a91b3693b55d8$export$853c27de4ce0f746 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $fd6a91b3693b55d8$export$e668df1bcd81e4d2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Enter', 'Enter');
const $fd6a91b3693b55d8$export$9f99fe2ed5bb7a29 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $fd6a91b3693b55d8$export$62d58b1c91e8e902 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Tab', 'Tab');
const $fd6a91b3693b55d8$export$79ebfa808dffa5c6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Indent', 'Tab');
const $fd6a91b3693b55d8$export$25755c0352544598 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $fd6a91b3693b55d8$export$1ea584ca7009bcc1 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $fd6a91b3693b55d8$export$9603e93cdf38d7 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete', 'Delete');
const $fd6a91b3693b55d8$export$9e41eded5cb7e706 = $fd6a91b3693b55d8$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $fd6a91b3693b55d8$export$a941ed4b947d12f8 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Space', 'Space');
const $fd6a91b3693b55d8$export$4e7f196112fea3c5 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Escape', 'Escape');
const $fd6a91b3693b55d8$export$172699367bb25225 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $fd6a91b3693b55d8$export$69838570e03d7193 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $fd6a91b3693b55d8$export$776c0cd47234205a = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $fd6a91b3693b55d8$export$9ad63694f5781e16 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $fd6a91b3693b55d8$export$33b9473b3f67763f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $fd6a91b3693b55d8$export$a57fbe0d9c764ae0 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $fd6a91b3693b55d8$export$2e3087448cf87857 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $fd6a91b3693b55d8$export$fbcf51cabbe4a007 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $fd6a91b3693b55d8$export$bf95f7b7d259c19f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $fd6a91b3693b55d8$export$717d5ccb817cdecc = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $fd6a91b3693b55d8$export$5851c701392d3bfd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $fd6a91b3693b55d8$export$73fa63faf0fd6077 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $fd6a91b3693b55d8$export$875b853996fced8d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $fd6a91b3693b55d8$export$414418ca306c22bd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $fd6a91b3693b55d8$export$f092689a35ce978d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $fd6a91b3693b55d8$export$863ee96d9e15383b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $fd6a91b3693b55d8$export$13c2dd2d968ada2a = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $fd6a91b3693b55d8$export$e6749a6fc243b921 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $fd6a91b3693b55d8$export$f4f2d7d33085c714 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $fd6a91b3693b55d8$export$2ef39e5ffdaff9ed = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $fd6a91b3693b55d8$export$8f58457f1327dd26 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $fd6a91b3693b55d8$export$af2a99f971a346e6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $fd6a91b3693b55d8$export$784d13d8ee351f07 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $fd6a91b3693b55d8$export$9b6706c8686cfc8e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $fd6a91b3693b55d8$export$3c1455b21d3e7aab = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $fd6a91b3693b55d8$export$71aa6c912b956294 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $fd6a91b3693b55d8$export$ca42dd9a1a0eb501 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $fd6a91b3693b55d8$export$f4a51ff076cc9a09 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $fd6a91b3693b55d8$export$faf8793e4a37a5a2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $fd6a91b3693b55d8$export$6f041e7a1d88fa51 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $fd6a91b3693b55d8$export$e247ed8cec4832f4 = $fd6a91b3693b55d8$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $fd6a91b3693b55d8$export$c2e8772deb1607ea = $fd6a91b3693b55d8$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $fd6a91b3693b55d8$export$625c5b9bf13f01a8 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $fd6a91b3693b55d8$export$fdeca4160ac263c5 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $fd6a91b3693b55d8$export$5ec5f857fec297eb = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $fd6a91b3693b55d8$export$36141559a83247ee = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $fd6a91b3693b55d8$export$ec123199f2fe4770 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $fd6a91b3693b55d8$export$6b05735f625d1c82 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $fd6a91b3693b55d8$export$a1bdda43619f945f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $fd6a91b3693b55d8$export$9bf312985dc8137e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $fd6a91b3693b55d8$export$c4f661b85fc92fd1 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $fd6a91b3693b55d8$export$61c867f4a21787f6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $fd6a91b3693b55d8$export$ba34d2a4e6aa10e4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $fd6a91b3693b55d8$export$54f122e0d55178a9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $fd6a91b3693b55d8$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $fd6a91b3693b55d8$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderRadius: '2px',
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $gE8f9.browser).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Cmd/i, '\u2318')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Shift/i, '\u21E7')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Ctrl/i, '\u2303')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Alt/i, '\u2325')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Backspace/i, '\u232B')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Enter/i, '\u23CE');
    else // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $fd6a91b3693b55d8$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $gE8f9.browser).mac ? '' : '+');
}
function $fd6a91b3693b55d8$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $fd6a91b3693b55d8$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $fd6a91b3693b55d8$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $fd6a91b3693b55d8$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, helpDescriptors.map((descriptor, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($fd6a91b3693b55d8$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $f8Sb3.jsx)("br", null))));
});
function $fd6a91b3693b55d8$export$c4e6735ce96cc7b3(description) {
    const matches = $fd6a91b3693b55d8$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $fd6a91b3693b55d8$export$ca66063a345ce3ab(description) {
    const keymap = $fd6a91b3693b55d8$export$c4e6735ce96cc7b3(description);
    if (keymap) return $fd6a91b3693b55d8$export$d69faf3b7bc3451(keymap);
    return;
}
function $fd6a91b3693b55d8$export$d69faf3b7bc3451(keymap) {
    if ((0, $gE8f9.browser).mac) return keymap.mac;
    return keymap.windows;
}
function $fd6a91b3693b55d8$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[(0, $gE8f9.browser).mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $fd6a91b3693b55d8$var$ALL = [
    $fd6a91b3693b55d8$export$dca848a1b50b6a31,
    $fd6a91b3693b55d8$export$c0e115f47553645e,
    $fd6a91b3693b55d8$export$183fe6d20e9e58ba,
    $fd6a91b3693b55d8$export$b03177f345903916,
    $fd6a91b3693b55d8$export$6bcc93697958b66d,
    $fd6a91b3693b55d8$export$6d564ba4eaf138d9,
    $fd6a91b3693b55d8$export$d26ab98fee0c804,
    $fd6a91b3693b55d8$export$4af6b58e12324fd,
    $fd6a91b3693b55d8$export$70686c6e7e15ed46,
    $fd6a91b3693b55d8$export$63c4f0859cc75dc6,
    $fd6a91b3693b55d8$export$953ab0e6a5d310a9,
    $fd6a91b3693b55d8$export$192a351cfd6ca247,
    $fd6a91b3693b55d8$export$fe382f3f4c871c62,
    $fd6a91b3693b55d8$export$4073e08db19e0e31,
    $fd6a91b3693b55d8$export$b84e85b2035ddb39,
    $fd6a91b3693b55d8$export$86b1ac99fd15509b,
    $fd6a91b3693b55d8$export$34ed0cbd4f7ff88,
    $fd6a91b3693b55d8$export$c2d9390f63354627,
    $fd6a91b3693b55d8$export$5f13bbad564673d4,
    $fd6a91b3693b55d8$export$9e5a9569a07601f2,
    $fd6a91b3693b55d8$export$e920ee2eb756d384,
    $fd6a91b3693b55d8$export$1688e416fee0a49e,
    $fd6a91b3693b55d8$export$21f930c44940fd98,
    $fd6a91b3693b55d8$export$71aa6c912b956294,
    $fd6a91b3693b55d8$export$4e7f196112fea3c5,
    $fd6a91b3693b55d8$export$e668df1bcd81e4d2,
    $fd6a91b3693b55d8$export$9f99fe2ed5bb7a29
];
function $fd6a91b3693b55d8$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        windows: windows.replace(/Mod/i, 'Ctrl'),
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $fd6a91b3693b55d8$export$7e6b588cc98b34f1(description, common) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const windows = common.replace(/Mod/i, 'Ctrl');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = common.replace(/Mod/i, 'Cmd');
    return $fd6a91b3693b55d8$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $fd6a91b3693b55d8$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($fd6a91b3693b55d8$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $fd6a91b3693b55d8$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $fd6a91b3693b55d8$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $fd6a91b3693b55d8$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $fd6a91b3693b55d8$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut, (0, $31nwk.editorCommandToPMCommand)(cmd), keymap);
}
function $fd6a91b3693b55d8$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        if ((0, $gE8f9.browser).mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $fd6a91b3693b55d8$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $1SLCf.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /^[A-Z]/.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $1SLCf.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});

parcelRegister("I02Nt", function(module, exports) {

$parcel$export(module.exports, "IconAction", () => $513b94a8224240d6$export$e40fe94b4cff8ec5);
$parcel$export(module.exports, "IconCode", () => $513b94a8224240d6$export$e332a83b9159d69d);
$parcel$export(module.exports, "IconDate", () => $513b94a8224240d6$export$39617668a6028b06);
$parcel$export(module.exports, "IconDecision", () => $513b94a8224240d6$export$6eb71591d1461541);
$parcel$export(module.exports, "IconDivider", () => $513b94a8224240d6$export$f2ab17920c9d243);
$parcel$export(module.exports, "IconEmoji", () => $513b94a8224240d6$export$8bd591d4b34dcafa);
$parcel$export(module.exports, "IconImages", () => $513b94a8224240d6$export$c17cf1164355efc2);
$parcel$export(module.exports, "IconLayout", () => $513b94a8224240d6$export$fba0c846789a9d87);
$parcel$export(module.exports, "IconLink", () => $513b94a8224240d6$export$23da1e9f164f7ea1);
$parcel$export(module.exports, "IconListNumber", () => $513b94a8224240d6$export$32f6affcc5f19c17);
$parcel$export(module.exports, "IconList", () => $513b94a8224240d6$export$527d32aa1785fdd4);
$parcel$export(module.exports, "IconMention", () => $513b94a8224240d6$export$de1d1a07ff53cf53);
$parcel$export(module.exports, "IconPanelError", () => $513b94a8224240d6$export$a1c6b14f5f0a0c20);
$parcel$export(module.exports, "IconPanelNote", () => $513b94a8224240d6$export$4d90d09f9e3039e);
$parcel$export(module.exports, "IconPanelSuccess", () => $513b94a8224240d6$export$cc5c1cc765c068a0);
$parcel$export(module.exports, "IconPanelWarning", () => $513b94a8224240d6$export$e728578e48814100);
$parcel$export(module.exports, "IconPanel", () => $513b94a8224240d6$export$18978208c8652af3);
$parcel$export(module.exports, "IconQuote", () => $513b94a8224240d6$export$2478ed0e296e2752);
$parcel$export(module.exports, "IconStatus", () => $513b94a8224240d6$export$4635bc8225f90ec6);
$parcel$export(module.exports, "IconOneColumnLayout", () => $513b94a8224240d6$export$8f1e9e900568bfce);
$parcel$export(module.exports, "IconTwoColumnLayout", () => $513b94a8224240d6$export$732a7fc4975ab5a4);
$parcel$export(module.exports, "IconThreeColumnLayout", () => $513b94a8224240d6$export$fdfaf73f45072edb);
$parcel$export(module.exports, "IconFourColumnLayout", () => $513b94a8224240d6$export$a1588f873a973762);
$parcel$export(module.exports, "IconFiveColumnLayout", () => $513b94a8224240d6$export$ff1f32987b4c27d9);
$parcel$export(module.exports, "IconHeading", () => $513b94a8224240d6$export$1a33a10ac24d7971);
$parcel$export(module.exports, "IconFeedback", () => $513b94a8224240d6$export$e25449dcffb445e);
$parcel$export(module.exports, "IconExpand", () => $513b94a8224240d6$export$209d03a445a7dc8e);
$parcel$export(module.exports, "IconDatasourceJiraIssue", () => $513b94a8224240d6$export$c9b1dcefa7c9a7aa);
$parcel$export(module.exports, "IconDatasourceAssetsObjects", () => $513b94a8224240d6$export$7d6f860161da0fa6);
$parcel$export(module.exports, "IconDatasourceConfluenceSearch", () => $513b94a8224240d6$export$29a810fd0b8c3f03);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

const $513b94a8224240d6$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("fGvzV")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3gu0e")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5mvP4")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hOMCR")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("CKYvy")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4ksik")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4mVJY")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("klEhj")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("95qb8")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("fQfWo")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jfJlN")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("1HSWv")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("1bVoT")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("ilyN3")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("g1gJ2")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("axHGd")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("ackBz")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jFgB1")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2nfB9")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$8f1e9e900568bfce = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7dzId")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$732a7fc4975ab5a4 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("eZVP6")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$fdfaf73f45072edb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("72721")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$a1588f873a973762 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iKjuX")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$ff1f32987b4c27d9 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("c8h3u")).then((module)=>module.default),
    loading: ()=>null
});






function $513b94a8224240d6$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("7onj1"));
        case 2:
            return (parcelRequire("9ZF9u"));
        case 3:
            return (parcelRequire("BwYJC"));
        case 4:
            return (parcelRequire("gM70c"));
        case 5:
            return (parcelRequire("bpCsY"));
        case 6:
        default:
            return (parcelRequire("jiASd"));
    }
}
const $513b94a8224240d6$export$1a33a10ac24d7971 = ({ level: level, ...props })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>$513b94a8224240d6$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        ...props
    });
};

const $513b94a8224240d6$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7eDnC")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("1wvZf")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jz4Qr")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("54hvw")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5ZhOb")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("ND3fA")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("fGvzV", function(module, exports) {

let $b6b34612608f94c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6b34612608f94c0$var$load("aH7nu").then(()=>parcelRequire('fGUVQ'));

});

parcelRegister("3gu0e", function(module, exports) {

let $260a23a3b3ef8ba9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $260a23a3b3ef8ba9$var$load("aPoaT").then(()=>parcelRequire('7mMCo'));

});

parcelRegister("5mvP4", function(module, exports) {

let $3e77b1241e0e7abc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e77b1241e0e7abc$var$load("6qfEi").then(()=>parcelRequire('hhrZv'));

});

parcelRegister("hOMCR", function(module, exports) {

let $cf8cd33bdfccca66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf8cd33bdfccca66$var$load("j9Ncr").then(()=>parcelRequire('dWg6W'));

});

parcelRegister("CKYvy", function(module, exports) {

let $0747fcf7c9336810$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0747fcf7c9336810$var$load("ahmZW").then(()=>parcelRequire('eAdWP'));

});

parcelRegister("4ksik", function(module, exports) {

let $326efa6bf827a195$var$load = (parcelRequire("28QjX"))(4);
module.exports = $326efa6bf827a195$var$load("cPvmS").then(()=>parcelRequire('i375O'));

});

parcelRegister("4mVJY", function(module, exports) {

let $32e6018ec1601887$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32e6018ec1601887$var$load("3V2y8").then(()=>parcelRequire('e88pi'));

});

parcelRegister("klEhj", function(module, exports) {

let $ed0503370987e815$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed0503370987e815$var$load("cU9ce").then(()=>parcelRequire('7ZWch'));

});

parcelRegister("95qb8", function(module, exports) {

let $69d8e33092c96934$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69d8e33092c96934$var$load("a05Bn").then(()=>parcelRequire('7AaHD'));

});

parcelRegister("fQfWo", function(module, exports) {

let $b88813dae2cd01b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b88813dae2cd01b6$var$load("8oQx9").then(()=>parcelRequire('2TyBm'));

});

parcelRegister("jfJlN", function(module, exports) {

let $e04298b06cbb52cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e04298b06cbb52cc$var$load("49Cyu").then(()=>parcelRequire('ieCqs'));

});

parcelRegister("1HSWv", function(module, exports) {

let $13e46d0a32caba32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $13e46d0a32caba32$var$load("iILx7").then(()=>parcelRequire('aIi75'));

});

parcelRegister("1bVoT", function(module, exports) {

let $0de3580dc62a4271$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0de3580dc62a4271$var$load("iUv8g").then(()=>parcelRequire('6m8b0'));

});

parcelRegister("ilyN3", function(module, exports) {

let $d5b52cbe945e8fe9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5b52cbe945e8fe9$var$load("bzHl5").then(()=>parcelRequire('hpPu5'));

});

parcelRegister("g1gJ2", function(module, exports) {

let $ba99b6a631050bf5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba99b6a631050bf5$var$load("fDTYR").then(()=>parcelRequire('2d5K5'));

});

parcelRegister("axHGd", function(module, exports) {

let $7acede628417b323$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7acede628417b323$var$load("3x7Og").then(()=>parcelRequire('j7B0X'));

});

parcelRegister("ackBz", function(module, exports) {

let $76cb021b585f879b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76cb021b585f879b$var$load("g1IYo").then(()=>parcelRequire('g2ofu'));

});

parcelRegister("jFgB1", function(module, exports) {

let $e50eb84ce90f9c64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e50eb84ce90f9c64$var$load("h2IHo").then(()=>parcelRequire('aWSsM'));

});

parcelRegister("2nfB9", function(module, exports) {

let $1ba9d4379a563900$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ba9d4379a563900$var$load("glTuS").then(()=>parcelRequire('clu4g'));

});

parcelRegister("7dzId", function(module, exports) {

let $541572fedc11ba9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $541572fedc11ba9b$var$load("8mTi8").then(()=>parcelRequire('aKp87'));

});

parcelRegister("eZVP6", function(module, exports) {

let $aeb39dafc892a576$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aeb39dafc892a576$var$load("1ucv3").then(()=>parcelRequire('5a4B6'));

});

parcelRegister("72721", function(module, exports) {

let $51ee2ca4404bd9d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51ee2ca4404bd9d9$var$load("9mxsn").then(()=>parcelRequire('hZOiE'));

});

parcelRegister("iKjuX", function(module, exports) {

let $da5ba5d9aa71b2cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $da5ba5d9aa71b2cf$var$load("htes7").then(()=>parcelRequire('6P7Pf'));

});

parcelRegister("c8h3u", function(module, exports) {

let $8d5376331ca05c94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d5376331ca05c94$var$load("aoGCR").then(()=>parcelRequire('5ytLq'));

});

parcelRegister("7onj1", function(module, exports) {

let $561cda55c0f8d4eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $561cda55c0f8d4eb$var$load("lx17z").then(()=>parcelRequire('dMM4v'));

});

parcelRegister("9ZF9u", function(module, exports) {

let $7469bb7f25e709d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7469bb7f25e709d1$var$load("6eDig").then(()=>parcelRequire('6cKKb'));

});

parcelRegister("BwYJC", function(module, exports) {

let $070d09ad8e796c4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $070d09ad8e796c4e$var$load("cVk2y").then(()=>parcelRequire('9iWN4'));

});

parcelRegister("gM70c", function(module, exports) {

let $c3668f876a86d4d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3668f876a86d4d1$var$load("3wW1N").then(()=>parcelRequire('eKOIc'));

});

parcelRegister("bpCsY", function(module, exports) {

let $84efde18d2d78fae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84efde18d2d78fae$var$load("7OoHt").then(()=>parcelRequire('9OxUo'));

});

parcelRegister("jiASd", function(module, exports) {

let $e0cc4d088e7c133f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0cc4d088e7c133f$var$load("hb1wm").then(()=>parcelRequire('dYSoJ'));

});

parcelRegister("7eDnC", function(module, exports) {

let $5448634264354b0b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5448634264354b0b$var$load("aWjio").then(()=>parcelRequire('65bRZ'));

});

parcelRegister("1wvZf", function(module, exports) {

let $11c19786cb00e8ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11c19786cb00e8ac$var$load("2Qdct").then(()=>parcelRequire('hwHW3'));

});

parcelRegister("jz4Qr", function(module, exports) {

let $e3e50b43c9ca1789$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3e50b43c9ca1789$var$load("di0jw").then(()=>parcelRequire('aoo70'));

});

parcelRegister("54hvw", function(module, exports) {

let $3b0ae811e751a85b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b0ae811e751a85b$var$load("kdjpy").then(()=>parcelRequire('jvVU5'));

});

parcelRegister("5ZhOb", function(module, exports) {

let $45c076a2a2c27402$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45c076a2a2c27402$var$load("at6NW").then(()=>parcelRequire('4H15d'));

});

parcelRegister("ND3fA", function(module, exports) {

let $0952de8499d3666d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0952de8499d3666d$var$load("7dD9P").then(()=>parcelRequire('8Giki'));

});


parcelRegister("iJp6U", function(module, exports) {

$parcel$export(module.exports, "setBlockTypeWithAnalytics", () => $a2f47a40ffbb9304$export$3f9af78ebb95cc20);
$parcel$export(module.exports, "setNormalTextWithAnalytics", () => $a2f47a40ffbb9304$export$283e32d0388e302a);
$parcel$export(module.exports, "setHeadingWithAnalytics", () => $a2f47a40ffbb9304$export$52d74b15bd103d7f);
$parcel$export(module.exports, "clearFormatting", () => $a2f47a40ffbb9304$export$195de5d8e201efd7);
$parcel$export(module.exports, "insertBlockQuoteWithAnalytics", () => $a2f47a40ffbb9304$export$50b4331f407b3ab6);
$parcel$export(module.exports, "insertBlockQuoteWithAnalyticsCommand", () => $a2f47a40ffbb9304$export$f5e16b3b6b62d83);
$parcel$export(module.exports, "cleanUpAtTheStartOfDocument", () => $a2f47a40ffbb9304$export$9c6026f8ac831f44);

var $gkwXh = parcelRequire("gkwXh");

var $14FOE = parcelRequire("14FOE");

var $594Yf = parcelRequire("594Yf");
var $aeKzo = parcelRequire("aeKzo");

var $kCV8T = parcelRequire("kCV8T");

var $hFEwm = parcelRequire("hFEwm");

var $8QX3X = parcelRequire("8QX3X");

var $lP8Yg = parcelRequire("lP8Yg");

var $4k6sj = parcelRequire("4k6sj");
function $a2f47a40ffbb9304$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $8QX3X.NORMAL_TEXT).name && nodes.paragraph) return $a2f47a40ffbb9304$export$63c4f0859cc75dc6()({
            tr: tr
        });
        const headingBlockType = (0, $8QX3X.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $hFEwm.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                const content = $from.node().content;
                const headingNode = schema.nodes.heading.createChecked({
                    level: level
                }, content);
                const slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(headingNode), 0, 0);
                tr.replaceRange(range.start, range.end, slice);
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        return tr;
    };
}
function $a2f47a40ffbb9304$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $a2f47a40ffbb9304$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $8QX3X.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $a2f47a40ffbb9304$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $a2f47a40ffbb9304$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $hFEwm.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                tr.lift(range, 0);
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        return tr;
    };
}
function $a2f47a40ffbb9304$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $lP8Yg.FORMATTING_MARK_TYPES).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $hFEwm.CellSelection)) (0, $lP8Yg.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $lP8Yg.formatTypes)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $lP8Yg.formatTypes)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $lP8Yg.FORMATTING_NODE_TYPES).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $hFEwm.CellSelection)) (0, $lP8Yg.cellSelectionNodesBetween)(tr.selection, tr.doc, (0, $lP8Yg.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $lP8Yg.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $gkwXh.ACTION).FORMATTED,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $a2f47a40ffbb9304$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $594Yf.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $a2f47a40ffbb9304$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $a2f47a40ffbb9304$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $a2f47a40ffbb9304$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $a2f47a40ffbb9304$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $aeKzo.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $a2f47a40ffbb9304$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $14FOE.withAnalytics)(editorAnalyticsApi, {
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($a2f47a40ffbb9304$var$insertBlockQuote());
};
function $a2f47a40ffbb9304$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $4k6sj.wrapSelectionInBlockType)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $a2f47a40ffbb9304$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};

});
parcelRegister("aeKzo", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionIn", () => $e364b1498c53313f$export$f63f505240212912);

var $iXNbm = parcelRequire("iXNbm");
function $e364b1498c53313f$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $iXNbm.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("iXNbm", function(module, exports) {

$parcel$export(module.exports, "createWrapSelectionTransaction", () => $4678f0237e36a927$export$d5c308539c2b2123);

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $594Yf = parcelRequire("594Yf");
function $4678f0237e36a927$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $594Yf.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $4678f0237e36a927$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $5r0mK.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $4678f0237e36a927$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $eS2Dn.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}

});


parcelRegister("8QX3X", function(module, exports) {

$parcel$export(module.exports, "NORMAL_TEXT", () => $3e54611e0bd0552a$export$58d6de174a4025df);
$parcel$export(module.exports, "HEADING_1", () => $3e54611e0bd0552a$export$aca53469ff012f69);
$parcel$export(module.exports, "HEADING_2", () => $3e54611e0bd0552a$export$8af5e2d4f952c9f0);
$parcel$export(module.exports, "HEADING_3", () => $3e54611e0bd0552a$export$4b4c4ef3a93a84d8);
$parcel$export(module.exports, "HEADING_4", () => $3e54611e0bd0552a$export$67379271b4d26982);
$parcel$export(module.exports, "HEADING_5", () => $3e54611e0bd0552a$export$230d7efa1736763e);
$parcel$export(module.exports, "HEADING_6", () => $3e54611e0bd0552a$export$329adfa5d98f30d5);
$parcel$export(module.exports, "BLOCK_QUOTE", () => $3e54611e0bd0552a$export$175cdd8bc7e4b125);
$parcel$export(module.exports, "CODE_BLOCK", () => $3e54611e0bd0552a$export$cf55d1bff75690da);
$parcel$export(module.exports, "PANEL", () => $3e54611e0bd0552a$export$867b449446b85962);
$parcel$export(module.exports, "OTHER", () => $3e54611e0bd0552a$export$d46a05f8561f868a);
$parcel$export(module.exports, "TEXT_BLOCK_TYPES", () => $3e54611e0bd0552a$export$2ec1d6c4f06d927);
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $3e54611e0bd0552a$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $3e54611e0bd0552a$export$73b50f8f13648c71);
$parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", () => $3e54611e0bd0552a$export$c6516682f7569488);
$parcel$export(module.exports, "getBlockTypesInDropdown", () => $3e54611e0bd0552a$export$a1bb601016dd2309);
$parcel$export(module.exports, "HEADINGS_BY_LEVEL", () => $3e54611e0bd0552a$export$110c9c3e05131569);
$parcel$export(module.exports, "HEADINGS_BY_NAME", () => $3e54611e0bd0552a$export$33dfdcd30c23ea87);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9NKqk = parcelRequire("9NKqk");

var $54hRX = parcelRequire("54hRX");

var $7fdtk = parcelRequire("7fdtk");

var $eMtMm = parcelRequire("eMtMm");

var $7LKVc = parcelRequire("7LKVc");

var $3Mh5S = parcelRequire("3Mh5S");

var $f4BiX = parcelRequire("f4BiX");

var $5Hpaz = parcelRequire("5Hpaz");

var $gmhCD = parcelRequire("gmhCD");

var $k8Zwf = parcelRequire("k8Zwf");
const $3e54611e0bd0552a$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $9NKqk.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.Text), {})
};
const $3e54611e0bd0552a$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $9NKqk.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eMtMm))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H1), {})
};
const $3e54611e0bd0552a$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $9NKqk.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4BiX))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H2), {})
};
const $3e54611e0bd0552a$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $9NKqk.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mh5S))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H3), {})
};
const $3e54611e0bd0552a$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $9NKqk.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fdtk))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H4), {})
};
const $3e54611e0bd0552a$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $9NKqk.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($54hRX))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H5), {})
};
const $3e54611e0bd0552a$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $9NKqk.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7LKVc))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H6), {})
};
const $3e54611e0bd0552a$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $9NKqk.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $3e54611e0bd0552a$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $9NKqk.messages).codeblock,
    nodeName: 'codeBlock'
};
const $3e54611e0bd0552a$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $9NKqk.messages).infoPanel,
    nodeName: 'panel'
};
const $3e54611e0bd0552a$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $9NKqk.messages).other,
    nodeName: ''
};
const $3e54611e0bd0552a$export$2ec1d6c4f06d927 = [
    $3e54611e0bd0552a$export$58d6de174a4025df,
    $3e54611e0bd0552a$export$aca53469ff012f69,
    $3e54611e0bd0552a$export$8af5e2d4f952c9f0,
    $3e54611e0bd0552a$export$4b4c4ef3a93a84d8,
    $3e54611e0bd0552a$export$67379271b4d26982,
    $3e54611e0bd0552a$export$230d7efa1736763e,
    $3e54611e0bd0552a$export$329adfa5d98f30d5
];
const $3e54611e0bd0552a$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $3e54611e0bd0552a$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $3e54611e0bd0552a$export$c6516682f7569488 = [
    $3e54611e0bd0552a$export$175cdd8bc7e4b125,
    $3e54611e0bd0552a$export$cf55d1bff75690da,
    $3e54611e0bd0552a$export$867b449446b85962
];
const $3e54611e0bd0552a$export$237f26fa8dbc0d9a = $3e54611e0bd0552a$export$2ec1d6c4f06d927.concat($3e54611e0bd0552a$export$c6516682f7569488);
const $3e54611e0bd0552a$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return (0, $gmhCD.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true, {
        exposure: true
    }) && includeBlockQuoteAsTextstyleOption ? [
        ...$3e54611e0bd0552a$export$2ec1d6c4f06d927,
        $3e54611e0bd0552a$export$175cdd8bc7e4b125
    ] : $3e54611e0bd0552a$export$2ec1d6c4f06d927;
};
const $3e54611e0bd0552a$export$110c9c3e05131569 = $3e54611e0bd0552a$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $3e54611e0bd0552a$export$33dfdcd30c23ea87 = $3e54611e0bd0552a$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});

});
parcelRegister("54hRX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f20174f511024dbb8c8d349f218c646e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b0b2ff65e59d223$var$_react = $3b0b2ff65e59d223$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3b0b2ff65e59d223$var$_baseNew = $3b0b2ff65e59d223$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3b0b2ff65e59d223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b0b2ff65e59d223$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $3b0b2ff65e59d223$var$_react.default.createElement($3b0b2ff65e59d223$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$3b0b2ff65e59d223$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $3b0b2ff65e59d223$var$_default = module.exports.default = $3b0b2ff65e59d223$var$TextHeadingFiveIcon;

});

parcelRegister("7fdtk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e1c911275bbc9f09d8b74402467dc96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546462666800b816$var$_react = $546462666800b816$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $546462666800b816$var$_baseNew = $546462666800b816$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $546462666800b816$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $546462666800b816$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $546462666800b816$var$_react.default.createElement($546462666800b816$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$546462666800b816$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $546462666800b816$var$_default = module.exports.default = $546462666800b816$var$TextHeadingFourIcon;

});

parcelRegister("eMtMm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a96af59b8b25fc6d7b24bf13d8c2c64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac2ca5e0db3b7b68$var$_react = $ac2ca5e0db3b7b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ac2ca5e0db3b7b68$var$_baseNew = $ac2ca5e0db3b7b68$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ac2ca5e0db3b7b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac2ca5e0db3b7b68$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $ac2ca5e0db3b7b68$var$_react.default.createElement($ac2ca5e0db3b7b68$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$ac2ca5e0db3b7b68$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $ac2ca5e0db3b7b68$var$_default = module.exports.default = $ac2ca5e0db3b7b68$var$TextHeadingOneIcon;

});

parcelRegister("7LKVc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd4b564b4f9efff19c6a7ab8cfffa74a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8151d100811dd6$var$_react = $5a8151d100811dd6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a8151d100811dd6$var$_baseNew = $5a8151d100811dd6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5a8151d100811dd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8151d100811dd6$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $5a8151d100811dd6$var$_react.default.createElement($5a8151d100811dd6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$5a8151d100811dd6$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $5a8151d100811dd6$var$_default = module.exports.default = $5a8151d100811dd6$var$TextHeadingSixIcon;

});

parcelRegister("3Mh5S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69eb91f82b309428a7917986dda5ee35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c031d41a72514f9$var$_react = $2c031d41a72514f9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2c031d41a72514f9$var$_baseNew = $2c031d41a72514f9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2c031d41a72514f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c031d41a72514f9$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $2c031d41a72514f9$var$_react.default.createElement($2c031d41a72514f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$2c031d41a72514f9$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $2c031d41a72514f9$var$_default = module.exports.default = $2c031d41a72514f9$var$TextHeadingThreeIcon;

});

parcelRegister("f4BiX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d33290aac1089ceab1f15dfb1bfcf01>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af942ab13fd9e775$var$_react = $af942ab13fd9e775$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af942ab13fd9e775$var$_baseNew = $af942ab13fd9e775$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af942ab13fd9e775$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af942ab13fd9e775$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $af942ab13fd9e775$var$_react.default.createElement($af942ab13fd9e775$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$af942ab13fd9e775$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $af942ab13fd9e775$var$_default = module.exports.default = $af942ab13fd9e775$var$TextHeadingTwoIcon;

});

parcelRegister("5Hpaz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c514376430cef925ef724f6e20a216ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42647e07473269d7$var$_react = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42647e07473269d7$var$_baseNew = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $42647e07473269d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42647e07473269d7$var$TextIcon = (props)=>/*#__PURE__*/ $42647e07473269d7$var$_react.default.createElement($42647e07473269d7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$42647e07473269d7$var$TextIcon.displayName = 'TextIcon';
var $42647e07473269d7$var$_default = module.exports.default = $42647e07473269d7$var$TextIcon;

});

parcelRegister("k8Zwf", function(module, exports) {

$parcel$export(module.exports, "Text", () => $d1689df415d7af0e$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "H1", () => $d1689df415d7af0e$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $d1689df415d7af0e$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $d1689df415d7af0e$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $d1689df415d7af0e$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $d1689df415d7af0e$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $d1689df415d7af0e$export$a559fb8039b06400);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $d1689df415d7af0e$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        children: children
    });
const $d1689df415d7af0e$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("lP8Yg", function(module, exports) {

$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $9840ca256f751a84$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $9840ca256f751a84$export$73b50f8f13648c71);
$parcel$export(module.exports, "formatTypes", () => $9840ca256f751a84$export$ce157a3b6664c924);
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $9840ca256f751a84$export$bd443c1dba3019b8);
$parcel$export(module.exports, "clearNodeFormattingOnSelection", () => $9840ca256f751a84$export$10ed2145ce1a03b1);

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");
const $9840ca256f751a84$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $9840ca256f751a84$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $9840ca256f751a84$export$ce157a3b6664c924 = {
    em: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $9840ca256f751a84$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $9840ca256f751a84$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $eS2Dn.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}

});

parcelRegister("4k6sj", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionInBlockType", () => $77fcbbfe95f30545$export$bb05c9a6c853122f);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
function $77fcbbfe95f30545$export$bb05c9a6c853122f(nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /**Remove alignment and indentation marks from the selection */ const marksToRemove = [
                alignment,
                indentation
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
			 * When you need to toggle the selection
			 * when another type which does not allow alignment is applied
			 */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $eS2Dn.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}

});


parcelRegister("eKy27", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ccb780a6937c50a$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $93WYh = parcelRequire("93WYh");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $inLhu = parcelRequire("inLhu");

var $eWNtX = parcelRequire("eWNtX");
const $3ccb780a6937c50a$var$MAX_HEADING_LEVEL = 6;
function $3ccb780a6937c50a$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $3ccb780a6937c50a$var$headingRule(nodeType, maxLevel) {
    return (0, $eWNtX.createWrappingTextBlockRule)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $3ccb780a6937c50a$var$getHeadingLevel
    });
}
function $3ccb780a6937c50a$var$blockQuoteRule(nodeType) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return (0, $eWNtX.createJoinNodesRule)(/^\s*>\s$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $3ccb780a6937c50a$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $3ccb780a6937c50a$var$headingRule(schema.nodes.heading, $3ccb780a6937c50a$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $2Abpa.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $d19733ae55e58348$export$a96b909f1510512b)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $93WYh.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $2Abpa.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $gkwXh.ACTION).FORMATTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $3ccb780a6937c50a$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $3ccb780a6937c50a$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $3ccb780a6937c50a$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $2Abpa.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $d19733ae55e58348$export$a96b909f1510512b)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $93WYh.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $3ccb780a6937c50a$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$3ccb780a6937c50a$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$3ccb780a6937c50a$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $3ccb780a6937c50a$export$2e2bcd8739ae039 = $3ccb780a6937c50a$var$inputRulePlugin;

});
parcelRegister("2Abpa", function(module, exports) {

$parcel$export(module.exports, "inputRuleWithAnalytics", () => $9aa3f9797dcf58b2$export$333ee6e3f01bb8f9);
$parcel$export(module.exports, "createWrappingJoinRule", () => $9aa3f9797dcf58b2$export$6341edfa2d147bc);
$parcel$export(module.exports, "createRule", () => $9aa3f9797dcf58b2$export$56e87122f905fac0);

var $fZzhT = parcelRequire("fZzhT");

var $eS2Dn = parcelRequire("eS2Dn");

var $57ZlA = parcelRequire("57ZlA");
const $9aa3f9797dcf58b2$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $9aa3f9797dcf58b2$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $eS2Dn.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $eS2Dn.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $57ZlA.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return $9aa3f9797dcf58b2$export$56e87122f905fac0(match, handler);
};
const $9aa3f9797dcf58b2$export$56e87122f905fac0 = (match, handler)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $fZzhT.closeHistory)(tr);
        }
    };
};

});
parcelRegister("57ZlA", function(module, exports) {

$parcel$export(module.exports, "DELETE_DIRECTION", () => $4b9a10a7caaf11e5$export$a9b79b94eb5ffad);
$parcel$export(module.exports, "LIST_TEXT_SCENARIOS", () => $4b9a10a7caaf11e5$export$c3c848735ee9408a);
$parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", () => $4b9a10a7caaf11e5$export$43e6a678b13eb45f);
$parcel$export(module.exports, "OUTDENT_SCENARIOS", () => $4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8);
var $4b9a10a7caaf11e5$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $4b9a10a7caaf11e5$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $4b9a10a7caaf11e5$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});

});


parcelRegister("inLhu", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0178415f004b9eed$export$ae829ec7b2625219);

var $fZzhT = parcelRequire("fZzhT");

var $gZGBX = parcelRequire("gZGBX");

var $2CgsA = parcelRequire("2CgsA");

var $eLc4o = parcelRequire("eLc4o");
const $0178415f004b9eed$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $0178415f004b9eed$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $0178415f004b9eed$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $gZGBX.TextSelection)) && !(0, $2CgsA.isGapCursorSelection)(state.selection) && !isInline || $0178415f004b9eed$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $0178415f004b9eed$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $eLc4o.createInputRulePlugin)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $fZzhT.closeHistory)(tr);
        }
    });
};

});
parcelRegister("2CgsA", function(module, exports) {

$parcel$export(module.exports, "isGapCursorSelection", () => $79c3774b0460e64a$export$b0e17cd4423f50ca);
/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $79c3774b0460e64a$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};

});

parcelRegister("eLc4o", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $301ed6c086d04b75$export$dc83f374e2af640d);

var $gZGBX = parcelRequire("gZGBX");


var $a7z0s = parcelRequire("a7z0s");
function $301ed6c086d04b75$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $gZGBX.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $a7z0s.createInputEventHandler)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $d19733ae55e58348$export$e56dc8305776db1f), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $gZGBX.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // @ts-ignore This is used by prosemirror-view to apply input rules on text input event.
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}

});
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $d19733ae55e58348$export$a96b909f1510512b = '\ufffc';
const $d19733ae55e58348$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $d19733ae55e58348$export$af78bb669dec9658 = 500;

parcelRegister("a7z0s", function(module, exports) {

$parcel$export(module.exports, "createInputEventHandler", () => $df6df97092dea2d9$export$9bcba4b183c6bb83);


var $2CgsA = parcelRequire("2CgsA");
const $df6df97092dea2d9$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $d19733ae55e58348$export$af78bb669dec9658)), $from.parentOffset, undefined, (0, $d19733ae55e58348$export$a96b909f1510512b)) + text;
        const result = $df6df97092dea2d9$var$findMatchOnRules({
            rules: rules,
            textBefore: textBefore,
            from: from,
            to: to,
            state: state
        });
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $d19733ae55e58348$export$e56dc8305776db1f), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $df6df97092dea2d9$var$findMatchOnRules({ rules: rules, textBefore: textBefore, from: from, to: to, state: state }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textBefore` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $2CgsA.isGapCursorSelection)(state.selection) ? textBefore.at(-1) ?? '' : textBefore;
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $d19733ae55e58348$export$af78bb669dec9658));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}

});



parcelRegister("eWNtX", function(module, exports) {

$parcel$export(module.exports, "isNodeAWrappingBlockNode", () => $4c437d0d04103ee6$export$3a2c03e35bc6c7a8);
$parcel$export(module.exports, "createJoinNodesRule", () => $4c437d0d04103ee6$export$1fe8b64ae159a0fa);
$parcel$export(module.exports, "createWrappingTextBlockRule", () => $4c437d0d04103ee6$export$644b98fd2fd87b8b);
$parcel$export(module.exports, "areBlockTypesDisabled", () => $4c437d0d04103ee6$export$52adb8d9a3386cb8);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $4c437d0d04103ee6$export$4b48a1fc423972ea);
$parcel$export(module.exports, "hasBlockQuoteInOptions", () => $4c437d0d04103ee6$export$bce51f4ee2032263);

var $30Enc = parcelRequire("30Enc");

var $2Abpa = parcelRequire("2Abpa");

var $gmhCD = parcelRequire("gmhCD");

var $8QX3X = parcelRequire("8QX3X");
const $4c437d0d04103ee6$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $8QX3X.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $4c437d0d04103ee6$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $2Abpa.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $4c437d0d04103ee6$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $2Abpa.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $4c437d0d04103ee6$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $4c437d0d04103ee6$export$52adb8d9a3386cb8(state) {
    const nodesTypes = $4c437d0d04103ee6$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    if ((0, $gmhCD.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true)) {
        let hasQuote = false;
        let hasNestedListInQuote = false;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.type === blockquote) {
                hasQuote = true;
                node.descendants((child)=>{
                    if (child.type === bulletList || child.type === orderedList) {
                        hasNestedListInQuote = true;
                        return false;
                    }
                    return true;
                });
            }
            return !hasNestedListInQuote;
        });
        return nodesTypes.filter((type)=>type !== panel).length > 0 && (!hasQuote || hasNestedListInQuote);
    }
    return nodesTypes.filter((type)=>type !== panel).length > 0;
}
const $4c437d0d04103ee6$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $8QX3X.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $4c437d0d04103ee6$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $8QX3X.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $30Enc.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $4c437d0d04103ee6$export$4b48a1fc423972ea = (state)=>{
    return $4c437d0d04103ee6$var$marksArePresent(state) || $4c437d0d04103ee6$var$blockStylingIsPresent(state);
};
const $4c437d0d04103ee6$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};

});
parcelRegister("30Enc", function(module, exports) {

$parcel$export(module.exports, "anyMarkActive", () => $5046559148b4fd0d$export$3d7a3b3f27c57f56);
$parcel$export(module.exports, "isMarkAllowedInRange", () => $5046559148b4fd0d$export$22a8bb98a26ef60);
$parcel$export(module.exports, "isMarkExcluded", () => $5046559148b4fd0d$export$87b559fec4a10a1a);

var $hFEwm = parcelRequire("hFEwm");
const $5046559148b4fd0d$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $hFEwm.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
const $5046559148b4fd0d$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};
const $5046559148b4fd0d$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};

});



parcelRegister("kdso8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25680dc6fd050d04$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");
var $6cqU9 = parcelRequire("6cqU9");

var $k24a0 = parcelRequire("k24a0");

var $2RHbH = parcelRequire("2RHbH");

var $fZzhT = parcelRequire("fZzhT");

var $8QX3X = parcelRequire("8QX3X");

var $iJp6U = parcelRequire("iJp6U");

var $jMN7x = parcelRequire("jMN7x");

var $7eSM1 = parcelRequire("7eSM1");

var $eWNtX = parcelRequire("eWNtX");
const $25680dc6fd050d04$var$backspaceCommand = (0, $2RHbH.chainCommands)((0, $iJp6U.cleanUpAtTheStartOfDocument), (0, $7eSM1.deleteBlockContent)((0, $eWNtX.isNodeAWrappingBlockNode)), (0, $jMN7x.deleteAndMoveCursor));
const $25680dc6fd050d04$var$del = (0, $2RHbH.chainCommands)((0, $k24a0.deleteEmptyParagraphAndMoveBlockUp)((0, $eWNtX.isNodeAWrappingBlockNode)), (0, $7eSM1.deleteBlockContent)((0, $eWNtX.isNodeAWrappingBlockNode)), (0, $jMN7x.deleteAndMoveCursor));
function $25680dc6fd050d04$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.insertNewLine).common, (0, $k24a0.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveUp).common, (0, $k24a0.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveDown).common, (0, $k24a0.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.findKeyMapForBrowser)((0, $e9qoo.redo)), (0, $fZzhT.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.undo).common, (0, $fZzhT.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.backspace).common, $25680dc6fd050d04$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.deleteKey).common, $25680dc6fd050d04$var$del, list);
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.forwardDelete).mac, $25680dc6fd050d04$var$del, list);
    if (schema.nodes[$8QX3X.BLOCK_QUOTE.nodeName]) (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.findShortcutByKeymap)((0, $e9qoo.toggleBlockQuote)), (0, $iJp6U.insertBlockQuoteWithAnalytics)((0, $gkwXh.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $6cqU9.keymap)(list);
}

});
parcelRegister("jMN7x", function(module, exports) {

$parcel$export(module.exports, "deleteAndMoveCursor", () => $aab5fb9291da562a$export$6c408f720f6b44a7);

var $gZGBX = parcelRequire("gZGBX");
// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $aab5fb9291da562a$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $aab5fb9291da562a$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $gZGBX.TextSelection))) return false;
    if (!$aab5fb9291da562a$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};

});

parcelRegister("7eSM1", function(module, exports) {

$parcel$export(module.exports, "deleteBlockContent", () => $523f65c5ad5003d8$export$9c1a524875bfb8ec);

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");
// function to check whether the selected node is the sole decision item in the decision list
const $523f65c5ad5003d8$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $5r0mK.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $523f65c5ad5003d8$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $523f65c5ad5003d8$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $5r0mK.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $5r0mK.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $523f65c5ad5003d8$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $523f65c5ad5003d8$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});


parcelRegister("5pNa3", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $eef5dca48c9b3cf7$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $eef5dca48c9b3cf7$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $gE8f9 = parcelRequire("gE8f9");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $8QX3X = parcelRequire("8QX3X");

var $iJp6U = parcelRequire("iJp6U");

var $eTqxy = parcelRequire("eTqxy");

var $eWNtX = parcelRequire("eWNtX");
const $eef5dca48c9b3cf7$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $8QX3X.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.type === schema.nodes.paragraph) return 0, $8QX3X.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $8QX3X.BLOCK_QUOTE;
    return 0, $8QX3X.OTHER;
};
const $eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $8QX3X.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $8QX3X.HEADING_1:
        case 0, $8QX3X.HEADING_2:
        case 0, $8QX3X.HEADING_3:
        case 0, $8QX3X.HEADING_4:
        case 0, $8QX3X.HEADING_5:
        case 0, $8QX3X.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $8QX3X.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $8QX3X.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $8QX3X.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $eef5dca48c9b3cf7$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $8QX3X.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $eef5dca48c9b3cf7$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $8QX3X.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $8QX3X.OTHER);
            return false;
        }
    });
    return blockType || (0, $8QX3X.OTHER);
};
const $eef5dca48c9b3cf7$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $iJp6U.setNormalTextWithAnalytics)((0, $gkwXh.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $iJp6U.setHeadingWithAnalytics)(headingLevel, (0, $gkwXh.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $eef5dca48c9b3cf7$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('blockTypePlugin');
const $eef5dca48c9b3cf7$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $5KWxh.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create()).setMeta('addToHistory', false);
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $8QX3X.TEXT_BLOCK_TYPES).filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $8QX3X.WRAPPER_BLOCK_TYPES).filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $8QX3X.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $eWNtX.hasBlockQuoteInOptions)(availableBlockTypesInDropdown) ? (0, $eWNtX.checkFormattingIsPresent)(state) : undefined;
                return {
                    currentBlockType: $eef5dca48c9b3cf7$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $eWNtX.areBlockTypesDisabled)(state),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $eef5dca48c9b3cf7$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $eWNtX.areBlockTypesDisabled)(newState),
                    formattingIsPresent: (0, $eWNtX.hasBlockQuoteInOptions)(oldPluginState.availableBlockTypesInDropdown) ? (0, $eWNtX.checkFormattingIsPresent)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($eef5dca48c9b3cf7$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $eef5dca48c9b3cf7$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                const headingLevel = (0, $eTqxy.HEADING_KEYS).indexOf(event.keyCode);
                if (headingLevel > -1 && event.altKey) {
                    if ((0, $gE8f9.browser).mac && event.metaKey) return editorAPI?.core?.actions.execute($eef5dca48c9b3cf7$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!(0, $gE8f9.browser).mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($eef5dca48c9b3cf7$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};

});
parcelRegister("eTqxy", function(module, exports) {

$parcel$export(module.exports, "HEADING_KEYS", () => $3efc03d9dac5e81b$export$442e847723cf0569);
const $3efc03d9dac5e81b$var$KEY_0 = 48;
const $3efc03d9dac5e81b$var$KEY_1 = 49;
const $3efc03d9dac5e81b$var$KEY_2 = 50;
const $3efc03d9dac5e81b$var$KEY_3 = 51;
const $3efc03d9dac5e81b$var$KEY_4 = 52;
const $3efc03d9dac5e81b$var$KEY_5 = 53;
const $3efc03d9dac5e81b$var$KEY_6 = 54;
const $3efc03d9dac5e81b$export$442e847723cf0569 = [
    $3efc03d9dac5e81b$var$KEY_0,
    $3efc03d9dac5e81b$var$KEY_1,
    $3efc03d9dac5e81b$var$KEY_2,
    $3efc03d9dac5e81b$var$KEY_3,
    $3efc03d9dac5e81b$var$KEY_4,
    $3efc03d9dac5e81b$var$KEY_5,
    $3efc03d9dac5e81b$var$KEY_6
];

});


parcelRegister("6AEe7", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarComponent", () => $0c9730fe31036e72$export$b15abb95157a91c7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $awTmI = parcelRequire("awTmI");

var $gmhCD = parcelRequire("gmhCD");

var $6Gwcf = parcelRequire("6Gwcf");
const $0c9730fe31036e72$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
function $0c9730fe31036e72$export$b15abb95157a91c7({ api: api }) {
    const { blockTypeState: blockTypeState } = (0, $awTmI.useSharedPluginState)(api, [
        'blockType'
    ]);
    const boundSetBlockType = (0, $5uXOq.useCallback)((name)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $gkwXh.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const wrapBlockQuote = (0, $5uXOq.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $gkwXh.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const clearFormatting = (0, $5uXOq.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $gkwXh.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Gwcf.default), {
        isSmall: $0c9730fe31036e72$var$FloatingToolbarSettings.isSmall,
        isDisabled: $0c9730fe31036e72$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? false : $0c9730fe31036e72$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pluginState: blockTypeState,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $0c9730fe31036e72$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}

});
parcelRegister("6Gwcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $407f1dfb51124f0f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $e9qoo = parcelRequire("e9qoo");

var $eDTMN = parcelRequire("eDTMN");

var $ejItq = parcelRequire("ejItq");

var $2rNvX = parcelRequire("2rNvX");

var $iHYdz = parcelRequire("iHYdz");

var $5Hpaz = parcelRequire("5Hpaz");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gmhCD = parcelRequire("gmhCD");

var $8Zdb4 = parcelRequire("8Zdb4");

var $8QX3X = parcelRequire("8QX3X");

var $ijWlC = parcelRequire("ijWlC");

var $k8Zwf = parcelRequire("k8Zwf");

var $fMJd2 = parcelRequire("fMJd2");
const $407f1dfb51124f0f$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $407f1dfb51124f0f$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        const observer = new (0, $8Zdb4.default)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        this.state.observer?.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, pluginState: { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown }, shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === currentBlockType.name).map((blockType)=>blockType.title);
        const defaultIcon = (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))), {
            label: ""
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k8Zwf.Text), null);
        const currentIcon = (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? currentBlockType?.icon : currentBlockType?.LEGACY_icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ijWlC.BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                css: (0, $gmhCD.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true) ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [
                    (0, $ejItq.wrapperStyle),
                    (0, $fMJd2.floatingToolbarWrapperStyle)
                ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $ejItq.wrapperStyle)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2rNvX.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $iHYdz.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, (0, $VSDnB.fg)('platform_editor_comments_toolbar_responsiveness') ? // extra wrapper added to prevent flex shrinking of the button
            /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $407f1dfb51124f0f$var$buttonWrapperStyles
            }, button) : button), !api?.primaryToolbar && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $ejItq.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $ejItq.wrapperStyle)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ijWlC.BlockTypeButton), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType.name
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $ejItq.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        }, this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        }, this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        }, this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props.pluginState;
            const items = availableBlockTypesInDropdown.map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const keyMap = (0, $e9qoo.findKeymapByDescription)(blockType.title.defaultMessage);
                const icon = (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? blockType?.icon : blockType.LEGACY_icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        css: (0, $fMJd2.blockTypeMenuItemStyle)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $e9qoo.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        css: [
                            (0, $fMJd2.keyboardShortcut),
                            isActive && (0, $fMJd2.keyboardShortcutSelect)
                        ]
                    }, (0, $e9qoo.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if (availableBlockTypesInDropdown.map((blockType)=>blockType.name).includes('blockquote') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("p", null, (0, $eDTMN.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $e9qoo.tooltip)((0, $e9qoo.clearFormatting), (0, $eDTMN.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        css: [
                            (0, $fMJd2.keyboardShortcut)
                        ]
                    }, (0, $e9qoo.tooltip)((0, $e9qoo.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $8QX3X.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        }, this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                const fromBlockQuote = this.props.pluginState.currentBlockType.name === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
var $407f1dfb51124f0f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($407f1dfb51124f0f$var$ToolbarBlockType);

});
parcelRegister("ejItq", function(module, exports) {

$parcel$export(module.exports, "buttonGroupStyleBeforeVisualRefresh", () => $2e37247ce5cb1937$export$7638a34f4ed2b514);
$parcel$export(module.exports, "buttonGroupStyle", () => $2e37247ce5cb1937$export$5897f954e99cc6c0);
$parcel$export(module.exports, "separatorStyles", () => $2e37247ce5cb1937$export$39b9f83b35c7456d);
$parcel$export(module.exports, "wrapperStyle", () => $2e37247ce5cb1937$export$c4d4f06a25de97f);
$parcel$export(module.exports, "triggerWrapperStyles", () => $2e37247ce5cb1937$export$147e2cce6f264c9b);
$parcel$export(module.exports, "triggerWrapperStylesWithPadding", () => $2e37247ce5cb1937$export$f2c6a721c78d3c4a);
$parcel$export(module.exports, "disableBlueBorderStyles", () => $2e37247ce5cb1937$export$cd86615b96818354);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $2e37247ce5cb1937$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e37247ce5cb1937$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $2e37247ce5cb1937$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $2e37247ce5cb1937$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};

});

parcelRegister("2rNvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc30f060f41991fa$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownMenuItem", () => $bc30f060f41991fa$export$ed97964d1871885d);
$parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", () => $bc30f060f41991fa$export$9e0cd5a62a7d99cf);
/* eslint-disable @repo/internal/react/no-class-components */ /**
                                                               * @jsxRuntime classic
                                                               * @jsx jsx
                                                               */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $1aogK = parcelRequire("1aogK");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $gmhCD = parcelRequire("gmhCD");

var $3bDjY = parcelRequire("3bDjY");

var $gKjGW = parcelRequire("gKjGW");

var $kdDpx = parcelRequire("kdDpx");

var $jdyxs = parcelRequire("jdyxs");

var $iraaj = parcelRequire("iraaj");

var $4N9VB = parcelRequire("4N9VB");

var $2WNBA = parcelRequire("2WNBA");

var $8v0FX = parcelRequire("8v0FX");
function $bc30f060f41991fa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bc30f060f41991fa$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $bc30f060f41991fa$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #388BFF)"}`,
    outline: 'none'
});
const $bc30f060f41991fa$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $f8Sb3.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, transparent);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $f8Sb3.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #172B4D);background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, rgb(179, 212, 255))"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #091E424F);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $bc30f060f41991fa$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $jdyxs.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iraaj.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $bc30f060f41991fa$var$DropListWithOutsideListeners = (0, $jdyxs.default)($bc30f060f41991fa$var$DropListWithOutsideClickTargetRef);
class $bc30f060f41991fa$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, allowEnterDefaultBehavior: allowEnterDefaultBehavior, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $8v0FX.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $iHYdz.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2WNBA.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($bc30f060f41991fa$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: (e)=>{
                if (!allowEnterDefaultBehavior) e.preventDefault();
                e.stopPropagation();
            },
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($bc30f060f41991fa$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $bc30f060f41991fa$var$wrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        }, this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        };
    }
}
const $bc30f060f41991fa$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $bc30f060f41991fa$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $gKjGW.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: ()=>$bc30f060f41991fa$var$buttonStyles(item.isActive, submenuActive),
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1aogK.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: ()=>onItemActivated && onItemActivated({
                item: item
            }),
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        component: $bc30f060f41991fa$var$DropdownMenuItemCustomComponent,
        onMouseEnter: ()=>onMouseEnter && onMouseEnter({
                item: item
            }),
        onMouseLeave: ()=>onMouseLeave && onMouseLeave({
                item: item
            }),
        "aria-expanded": item['aria-expanded']
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $bc30f060f41991fa$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $5uXOq.useContext)((0, $kdDpx.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($bc30f060f41991fa$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: {
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        },
        ...props
    });
});

});
parcelRegister("gKjGW", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuSharedCssClassName", () => $493935277ba8bc7b$export$94c0f60c32e7bd13);
const $493935277ba8bc7b$export$15eb942addb87cf6 = 'pm-dropdown';
const $493935277ba8bc7b$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$493935277ba8bc7b$export$15eb942addb87cf6}-submenu`
};

});

parcelRegister("jdyxs", function(module, exports) {

$parcel$export(module.exports, "OutsideClickTargetRefContext", () => $4fed9d772c4caad7$export$798d66d2e25c3c95);
$parcel$export(module.exports, "default", () => $4fed9d772c4caad7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");

var $12Kqg = parcelRequire("12Kqg");
const $4fed9d772c4caad7$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(()=>Object);
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $4fed9d772c4caad7$var$WithOutsideClick extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .addEventListener('keydown', this.handleKeydown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .removeEventListener('keydown', this.handleKeydown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = this.props.outsideClickTargetRef.current?.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
            }
        }, this.handleKeydown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4fed9d772c4caad7$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $4fed9d772c4caad7$export$2e2bcd8739ae039(Component) {
    return ({ handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, closeOnTab: closeOnTab, captureClick: captureClick, ...props })=>{
        const isActiveProp = $4fed9d772c4caad7$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $5uXOq.useState)(false);
        const outsideClickTargetRef = (0, $5uXOq.useRef)(null);
        const setOutsideClickTargetRef = (0, $5uXOq.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12Kqg.default).Consumer, {
            children: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4fed9d772c4caad7$export$798d66d2e25c3c95.Provider, {
                    value: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($4fed9d772c4caad7$var$WithOutsideClick, {
                        editorView: editorView,
                        editorRef: editorRef,
                        targetRef: props.targetRef,
                        outsideClickTargetRef: outsideClickTargetRef,
                        popupsMountPoint: popupsMountPoint,
                        isActiveComponent: isActiveComponent,
                        handleClickOutside: handleClickOutside,
                        handleEnterKeydown: handleEnterKeydown,
                        handleEscapeKeydown: handleEscapeKeydown,
                        closeOnTab: closeOnTab,
                        captureClick: captureClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                            ...props
                        })
                    })
                })
        });
    };
}

});

parcelRegister("iraaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0608b252bfbe5a2a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gB4mS = parcelRequire("gB4mS");

var $994MI = parcelRequire("994MI");

var $cb25w = parcelRequire("cb25w");

var $cUHb0 = parcelRequire("cUHb0");
const $0608b252bfbe5a2a$var$packageName = "platform-pkg";
const $0608b252bfbe5a2a$var$packageVersion = "0.0.0-use.local";
const $0608b252bfbe5a2a$var$halfFocusRing = 1;
const $0608b252bfbe5a2a$var$dropOffset = '0, 8';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $0608b252bfbe5a2a$var$DropList extends (0, $5uXOq.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: this.wrapperStyles,
            ref: this.handleDroplistRef
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cUHb0.default), {
            content: layerContent,
            offset: $0608b252bfbe5a2a$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: this.triggerStyles,
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args), this.wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        }), this.triggerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        }), /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                color: "var(--ds-text-subtle, #44546F)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-border-radius, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        }, /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        }, this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        }, this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        }, this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $0608b252bfbe5a2a$var$halfFocusRing * 2}px`;
        }, this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        }, this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        }, this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        }, this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        }, this.handleDroplistRef = (ref)=>{
            this.props.onDroplistRef?.(ref);
        }, this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $0608b252bfbe5a2a$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
var $0608b252bfbe5a2a$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'droplist',
    packageName: $0608b252bfbe5a2a$var$packageName,
    packageVersion: $0608b252bfbe5a2a$var$packageVersion
})((0, $cb25w.default)({
    onOpenChange: $0608b252bfbe5a2a$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $0608b252bfbe5a2a$var$packageName,
            packageVersion: $0608b252bfbe5a2a$var$packageVersion
        }
    })
})($0608b252bfbe5a2a$var$DropList));

});
parcelRegister("cUHb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde32d597d72978f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fgNYa = parcelRequire("fgNYa");

var $7nRxN = parcelRequire("7nRxN");

var $a488G = parcelRequire("a488G");
const $bde32d597d72978f$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
class $bde32d597d72978f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // working with extract-react-types
        this.defaultProps = {
            boundariesElement: 'viewport',
            children: null,
            content: null,
            offset: '0, 0',
            position: 'right middle',
            zIndex: 400,
            lockScroll: false,
            isAlwaysFixed: false,
            onPositioned: ()=>{}
        };
    }
    constructor(props){
        super(props), this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $bde32d597d72978f$var$defaultState;
        this.extractStyles = (0, $7nRxN.default)(this.extractStyles.bind(this));
    }
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
	 * the bottom of the popper not being viewable.
	 * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
	 */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $a488G.positionPropToPopperPosition)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $fgNYa.default)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: this.targetRef,
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: this.contentRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        top: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        left: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        transform,
                        maxHeight: maxHeight ? maxHeight : 'auto',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...opacity
                    },
                    children: this.props.content
                })
            ]
        });
    }
}

});
parcelRegister("fgNYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1df1c8342df5413$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $b1df1c8342df5413$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $b1df1c8342df5413$var$longerTimeoutBrowsers = [
    'Edge',
    'Trident',
    'Firefox'
];
var $b1df1c8342df5413$var$timeoutDuration = 0;
for(var $b1df1c8342df5413$var$i = 0; $b1df1c8342df5413$var$i < $b1df1c8342df5413$var$longerTimeoutBrowsers.length; $b1df1c8342df5413$var$i += 1)if ($b1df1c8342df5413$var$isBrowser && navigator.userAgent.indexOf($b1df1c8342df5413$var$longerTimeoutBrowsers[$b1df1c8342df5413$var$i]) >= 0) {
    $b1df1c8342df5413$var$timeoutDuration = 1;
    break;
}
function $b1df1c8342df5413$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $b1df1c8342df5413$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $b1df1c8342df5413$var$timeoutDuration);
        }
    };
}
var $b1df1c8342df5413$var$supportsMicroTasks = $b1df1c8342df5413$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $b1df1c8342df5413$var$debounce = $b1df1c8342df5413$var$supportsMicroTasks ? $b1df1c8342df5413$var$microtaskDebounce : $b1df1c8342df5413$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $b1df1c8342df5413$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $b1df1c8342df5413$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $b1df1c8342df5413$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $b1df1c8342df5413$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $b1df1c8342df5413$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $b1df1c8342df5413$var$getScrollParent($b1df1c8342df5413$var$getParentNode(element));
}
var $b1df1c8342df5413$var$isIE11 = $b1df1c8342df5413$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $b1df1c8342df5413$var$isIE10 = $b1df1c8342df5413$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $b1df1c8342df5413$var$isIE(version) {
    if (version === 11) return $b1df1c8342df5413$var$isIE11;
    if (version === 10) return $b1df1c8342df5413$var$isIE10;
    return $b1df1c8342df5413$var$isIE11 || $b1df1c8342df5413$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $b1df1c8342df5413$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $b1df1c8342df5413$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $b1df1c8342df5413$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $b1df1c8342df5413$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $b1df1c8342df5413$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $b1df1c8342df5413$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $b1df1c8342df5413$var$getRoot(node) {
    if (node.parentNode !== null) return $b1df1c8342df5413$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $b1df1c8342df5413$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($b1df1c8342df5413$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $b1df1c8342df5413$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $b1df1c8342df5413$var$getRoot(element1);
    if (element1root.host) return $b1df1c8342df5413$var$findCommonOffsetParent(element1root.host, element2);
    else return $b1df1c8342df5413$var$findCommonOffsetParent(element1, $b1df1c8342df5413$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $b1df1c8342df5413$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $b1df1c8342df5413$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $b1df1c8342df5413$var$getScroll(element, 'top');
    var scrollLeft = $b1df1c8342df5413$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $b1df1c8342df5413$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function $b1df1c8342df5413$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $b1df1c8342df5413$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $b1df1c8342df5413$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $b1df1c8342df5413$var$isIE(10) && getComputedStyle(html);
    return {
        height: $b1df1c8342df5413$var$getSize('Height', body, html, computedStyle),
        width: $b1df1c8342df5413$var$getSize('Width', body, html, computedStyle)
    };
}
var $b1df1c8342df5413$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $b1df1c8342df5413$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $b1df1c8342df5413$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $b1df1c8342df5413$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $b1df1c8342df5413$var$getClientRect(offsets) {
    return $b1df1c8342df5413$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $b1df1c8342df5413$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($b1df1c8342df5413$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $b1df1c8342df5413$var$getScroll(element, 'top');
            var scrollLeft = $b1df1c8342df5413$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $b1df1c8342df5413$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.right - result.left;
    var height = sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $b1df1c8342df5413$var$getStyleComputedProperty(element);
        horizScrollbar -= $b1df1c8342df5413$var$getBordersSize(styles, 'x');
        vertScrollbar -= $b1df1c8342df5413$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $b1df1c8342df5413$var$getClientRect(result);
}
function $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $b1df1c8342df5413$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $b1df1c8342df5413$var$getBoundingClientRect(children);
    var parentRect = $b1df1c8342df5413$var$getBoundingClientRect(parent);
    var scrollParent = $b1df1c8342df5413$var$getScrollParent(children);
    var styles = $b1df1c8342df5413$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $b1df1c8342df5413$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $b1df1c8342df5413$var$includeScroll(offsets, parent);
    return offsets;
}
function $b1df1c8342df5413$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $b1df1c8342df5413$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $b1df1c8342df5413$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $b1df1c8342df5413$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $b1df1c8342df5413$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($b1df1c8342df5413$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $b1df1c8342df5413$var$getParentNode(element);
    if (!parentNode) return false;
    return $b1df1c8342df5413$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $b1df1c8342df5413$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $b1df1c8342df5413$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $b1df1c8342df5413$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $b1df1c8342df5413$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $b1df1c8342df5413$var$getFixedPositionOffsetParent(popper) : $b1df1c8342df5413$var$findCommonOffsetParent(popper, reference);
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $b1df1c8342df5413$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $b1df1c8342df5413$var$getScrollParent($b1df1c8342df5413$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$b1df1c8342df5413$var$isFixed(offsetParent)) {
            var _getWindowSizes = $b1df1c8342df5413$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $b1df1c8342df5413$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $b1df1c8342df5413$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $b1df1c8342df5413$var$_extends({
            key: key
        }, rects[key], {
            area: $b1df1c8342df5413$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $b1df1c8342df5413$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $b1df1c8342df5413$var$getFixedPositionOffsetParent(popper) : $b1df1c8342df5413$var$findCommonOffsetParent(popper, reference);
    return $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $b1df1c8342df5413$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $b1df1c8342df5413$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $b1df1c8342df5413$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $b1df1c8342df5413$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$b1df1c8342df5413$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $b1df1c8342df5413$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $b1df1c8342df5413$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $b1df1c8342df5413$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $b1df1c8342df5413$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $b1df1c8342df5413$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $b1df1c8342df5413$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $b1df1c8342df5413$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $b1df1c8342df5413$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $b1df1c8342df5413$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $b1df1c8342df5413$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $b1df1c8342df5413$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $b1df1c8342df5413$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $b1df1c8342df5413$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $b1df1c8342df5413$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($b1df1c8342df5413$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$b1df1c8342df5413$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $b1df1c8342df5413$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $b1df1c8342df5413$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $b1df1c8342df5413$var$attachToScrollParents($b1df1c8342df5413$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $b1df1c8342df5413$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $b1df1c8342df5413$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $b1df1c8342df5413$var$getScrollParent(reference);
    $b1df1c8342df5413$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $b1df1c8342df5413$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $b1df1c8342df5413$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $b1df1c8342df5413$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $b1df1c8342df5413$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $b1df1c8342df5413$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $b1df1c8342df5413$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $b1df1c8342df5413$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $b1df1c8342df5413$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $b1df1c8342df5413$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $b1df1c8342df5413$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $b1df1c8342df5413$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $b1df1c8342df5413$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $b1df1c8342df5413$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $b1df1c8342df5413$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $b1df1c8342df5413$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $b1df1c8342df5413$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $b1df1c8342df5413$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $b1df1c8342df5413$var$isFirefox = $b1df1c8342df5413$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $b1df1c8342df5413$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $b1df1c8342df5413$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $b1df1c8342df5413$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $b1df1c8342df5413$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$b1df1c8342df5413$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $b1df1c8342df5413$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $b1df1c8342df5413$var$_extends({}, attributes, data.attributes);
    data.styles = $b1df1c8342df5413$var$_extends({}, styles, data.styles);
    data.arrowStyles = $b1df1c8342df5413$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $b1df1c8342df5413$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $b1df1c8342df5413$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$b1df1c8342df5413$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $b1df1c8342df5413$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $b1df1c8342df5413$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $b1df1c8342df5413$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $b1df1c8342df5413$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $b1df1c8342df5413$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $b1df1c8342df5413$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $b1df1c8342df5413$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $b1df1c8342df5413$var$validPlacements = $b1df1c8342df5413$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $b1df1c8342df5413$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $b1df1c8342df5413$var$validPlacements.indexOf(placement);
    var arr = $b1df1c8342df5413$var$validPlacements.slice(index + 1).concat($b1df1c8342df5413$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $b1df1c8342df5413$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($b1df1c8342df5413$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $b1df1c8342df5413$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $b1df1c8342df5413$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $b1df1c8342df5413$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $b1df1c8342df5413$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $b1df1c8342df5413$var$clockwise(placement);
            break;
        case $b1df1c8342df5413$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $b1df1c8342df5413$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $b1df1c8342df5413$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $b1df1c8342df5413$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $b1df1c8342df5413$var$_extends({}, data.offsets.popper, $b1df1c8342df5413$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $b1df1c8342df5413$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $b1df1c8342df5413$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $b1df1c8342df5413$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $b1df1c8342df5413$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($b1df1c8342df5413$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $b1df1c8342df5413$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($b1df1c8342df5413$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($b1df1c8342df5413$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $b1df1c8342df5413$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $b1df1c8342df5413$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $b1df1c8342df5413$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $b1df1c8342df5413$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $b1df1c8342df5413$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $b1df1c8342df5413$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $b1df1c8342df5413$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $b1df1c8342df5413$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $b1df1c8342df5413$var$defineProperty({}, side, reference[side]),
            end: $b1df1c8342df5413$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $b1df1c8342df5413$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$hide(data) {
    if (!$b1df1c8342df5413$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $b1df1c8342df5413$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $b1df1c8342df5413$var$getOppositePlacement(placement);
    data.offsets.popper = $b1df1c8342df5413$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $b1df1c8342df5413$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$applyStyle,
        /** @prop {Function} */ onLoad: $b1df1c8342df5413$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $b1df1c8342df5413$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $b1df1c8342df5413$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $b1df1c8342df5413$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $b1df1c8342df5413$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $b1df1c8342df5413$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $b1df1c8342df5413$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($b1df1c8342df5413$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $b1df1c8342df5413$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $b1df1c8342df5413$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $b1df1c8342df5413$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $b1df1c8342df5413$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $b1df1c8342df5413$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $b1df1c8342df5413$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $b1df1c8342df5413$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $b1df1c8342df5413$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $b1df1c8342df5413$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$b1df1c8342df5413$var$Popper.placements = $b1df1c8342df5413$var$placements;
$b1df1c8342df5413$var$Popper.Defaults = $b1df1c8342df5413$var$Defaults;
var $b1df1c8342df5413$export$2e2bcd8739ae039 = $b1df1c8342df5413$var$Popper;

});

parcelRegister("a488G", function(module, exports) {

$parcel$export(module.exports, "positionPropToPopperPosition", () => $5ea83f05db9130f3$export$9e6a7c92c66a7cdd);
const $5ea83f05db9130f3$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
const $5ea83f05db9130f3$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};
function $5ea83f05db9130f3$var$positionToPopper(position) {
    return position && $5ea83f05db9130f3$var$positionMap[position] ? $5ea83f05db9130f3$var$positionMap[position].position : null;
}
function $5ea83f05db9130f3$export$9e6a7c92c66a7cdd(position) {
    return $5ea83f05db9130f3$var$positionToPopper(position) || $5ea83f05db9130f3$var$positionMap[$5ea83f05db9130f3$export$f6c90e9517ee2ce0.default].position;
}

});



parcelRegister("4N9VB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f05c89a5b988c61$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");

var $7nRxN = parcelRequire("7nRxN");

var $7nsd3 = parcelRequire("7nsd3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $f3dKD = parcelRequire("f3dKD");
class $6f05c89a5b988c61$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            offset: [
                0,
                0
            ],
            allowOutOfBound: false
        };
    }
    /**
	 * Calculates new popup position
	 */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $f3dKD.calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $f3dKD.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $f3dKD.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $7nsd3.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
		 * Check whether:
		 * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
		 * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
		 *
		 * Currently Popup isn't capable of position itself correctly in case 2,
		 * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
		 */ return !target || document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
	 * Popup initialization.
	 * Checks whether it's possible to position popup along given target, and if it's not throws an error.
	 */ initPopup(popup) {
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $f3dKD.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
		 * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
		 * Now, floating toolbar position depends on it's size.
		 * Size of floating toolbar changes, when async component renders.
		 * There is currently, no way to re position floating toolbar or
		 *  better to not show floating toolbar till all the async component are ready to render.
		 * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
		 *  as a prop.
		 * So, calling scheduledUpdatePosition to position popup on next request animation frame,
		 * which is currently working for most of the floating toolbar and other popups.
		 */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
    }
    /**
	 * Cancels the initialisation of the focus trap if it has not yet occured
	 * Deactivates the focus trap if it exists
	 */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
	 * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
	 */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        const { stick: stick } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.scrollParentElement = (0, $f3dKD.findOverflowScrollParent)(this.props.target);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
        if (stick) this.scrollElement = this.scrollParentElement;
        else this.scrollElement = this.props.scrollableElement;
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.addEventListener('scroll', this.onResize);
    }
    componentWillUnmount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
		 * https://a11y.atlassian.net/browse/A11Y-9995
		 * We set aria-label to undefined if it's null, no more 'Popup' fallback.
		 * It is meaningless for screen readers and causes confusion.
		 */ const ariaLabel = (0, $VSDnB.fg)('editor_a11y_aria_label_removal_popup') ? this.props.ariaLabel ?? undefined : this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $iHYdz.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true,
            children: this.props.children
        });
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $7nsd3.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args), this.rafIds = new Set(), this.state = {
            validPosition: true
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.placement = [
            '',
            ''
        ], this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        }, this.scheduledUpdatePosition = (0, $7nRxN.default)((props)=>{
            this.updatePosition(this.props);
        }), this.onResize = ()=>this.scheduledUpdatePosition(this.props), this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined, /**
	 * Raf scheduled so that it also occurs after the initial update position
	 */ this.initFocusTrap = (0, $7nRxN.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(popup, trapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("f3dKD", function(module, exports) {

$parcel$export(module.exports, "calculatePlacement", () => $6f8faaad8d1a72fc$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $6f8faaad8d1a72fc$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $6f8faaad8d1a72fc$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "validatePosition", () => $6f8faaad8d1a72fc$export$ab306cb155a0ca1b);
function $6f8faaad8d1a72fc$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
function $6f8faaad8d1a72fc$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
function $6f8faaad8d1a72fc$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = $6f8faaad8d1a72fc$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $6f8faaad8d1a72fc$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $6f8faaad8d1a72fc$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $6f8faaad8d1a72fc$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $6f8faaad8d1a72fc$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $6f8faaad8d1a72fc$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $6f8faaad8d1a72fc$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
        if (position.right !== undefined) position.right = $6f8faaad8d1a72fc$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
    }
    return position;
};
const $6f8faaad8d1a72fc$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
    // minimum distance the popup can be from the edge of its parent
    const minPopupMargin = 1;
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $6f8faaad8d1a72fc$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position })=>{
    const scrollParent = $6f8faaad8d1a72fc$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $6f8faaad8d1a72fc$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement })=>{
    const scrollParent = $6f8faaad8d1a72fc$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $6f8faaad8d1a72fc$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $6f8faaad8d1a72fc$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent) return position;
    if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = $6f8faaad8d1a72fc$export$540dbd453ede1ce3(popupOffsetParent);
    const verticalPosition = $6f8faaad8d1a72fc$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $6f8faaad8d1a72fc$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $6f8faaad8d1a72fc$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position
    });
    const horizontalPosition = $6f8faaad8d1a72fc$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $6f8faaad8d1a72fc$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
function $6f8faaad8d1a72fc$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}

});


parcelRegister("2WNBA", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationProvider", () => $4c1bb7d1103deeef$export$ee87cc4950b6d6fe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $12Kqg = parcelRequire("12Kqg");

var $7DsHK = parcelRequire("7DsHK");

var $1K0nW = parcelRequire("1K0nW");

var $8v0FX = parcelRequire("8v0FX");
const $4c1bb7d1103deeef$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $8v0FX.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12Kqg.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7DsHK.ColorPaletteArrowKeyNavigationProvider), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12Kqg.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1K0nW.MenuArrowKeyNavigationProvider), {
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
};

});
parcelRegister("7DsHK", function(module, exports) {

$parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", () => $21327cd68207e48b$export$e17115e9cf808589);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $21327cd68207e48b$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const currentSelectedColumnIndex = (0, $5uXOq.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $5uXOq.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $5uXOq.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $21327cd68207e48b$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $21327cd68207e48b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $21327cd68207e48b$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $21327cd68207e48b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    }));
};
function $21327cd68207e48b$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $21327cd68207e48b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("1K0nW", function(module, exports) {

$parcel$export(module.exports, "MenuArrowKeyNavigationProvider", () => $833d4b83be982376$export$e12b037790bf03e3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $833d4b83be982376$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $833d4b83be982376$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $5uXOq.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $5uXOq.useState)(element);
    const incrementIndex = (0, $5uXOq.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const decrementIndex = (0, $5uXOq.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $5uXOq.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $833d4b83be982376$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list[currentIndex];
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            const focusIndex = incrementIndex(list);
            list[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (disableArrowKeyNavigation) return;
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $833d4b83be982376$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($833d4b83be982376$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = incrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($833d4b83be982376$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = decrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    });
};
function $833d4b83be982376$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("8v0FX", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationType", () => $c55b0232d5331d8e$export$26c2c5e2f61f437a);
var $c55b0232d5331d8e$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});

});



parcelRegister("ijWlC", function(module, exports) {

$parcel$export(module.exports, "BlockTypeButton", () => $7a2ae92542401a67$export$60665cf15e769742);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $eDTMN = parcelRequire("eDTMN");

var $cr1aY = parcelRequire("cr1aY");
var $ejItq = parcelRequire("ejItq");

var $1jI4k = parcelRequire("1jI4k");

var $5Hpaz = parcelRequire("5Hpaz");

var $3ti6y = parcelRequire("3ti6y");

var $c8Oei = parcelRequire("c8Oei");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gmhCD = parcelRequire("gmhCD");

var $8QX3X = parcelRequire("8QX3X");

var $fMJd2 = parcelRequire("fMJd2");
const $7a2ae92542401a67$var$buttonContentStyle = (0, $8CUq3.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $7a2ae92542401a67$var$buttonContentReducedSpacingStyle = (0, $8CUq3.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $7a2ae92542401a67$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $eDTMN.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $eDTMN.toolbarMessages).textStylesTooltip);
    const icon = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3ti6y)))
    });
    const chevronIconSpacing = props.isSmall && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? 'spacious' : 'none';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $ejItq.wrapperStyle),
                props.isSmall && (0, $fMJd2.wrapperSmallStyle)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.isSmall && icon, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $cr1aY.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px"
        }))))
    }, !props.isSmall && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: [
            $7a2ae92542401a67$var$buttonContentStyle,
            props.isReducedSpacing && $7a2ae92542401a67$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), props.title || (0, $8QX3X.NORMAL_TEXT).title)));
};

});
parcelRegister("1jI4k", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6db8a02783a4b1f$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWAZk = parcelRequire("dWAZk");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $gfv5d = parcelRequire("gfv5d");
function $f6db8a02783a4b1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6db8a02783a4b1f$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $f6db8a02783a4b1f$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $gkwXh.ACTION).CLICKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            })).fire((0, $dWAZk.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gfv5d.default), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f6db8a02783a4b1f$var$buttonWrapper
    }, button));
});
var $f6db8a02783a4b1f$export$2e2bcd8739ae039 = $f6db8a02783a4b1f$var$ToolbarButton;

});
parcelRegister("gfv5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e74c7dea01c8c4$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
var $15e74c7dea01c8c4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            alignItems: 'center'
        }
    });
});

});


parcelRegister("3ti6y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28721fc49070f49d$var$_react = $28721fc49070f49d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $28721fc49070f49d$var$_textStyle = $28721fc49070f49d$var$_interopRequireDefault((parcelRequire("kauzw")));
function $28721fc49070f49d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $28721fc49070f49d$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $28721fc49070f49d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
    }, props, {
        newIcon: $28721fc49070f49d$var$_textStyle.default
    }));
$28721fc49070f49d$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $28721fc49070f49d$var$_default = module.exports.default = $28721fc49070f49d$var$EditorTextStyleIcon;

});
parcelRegister("kauzw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79f720bc74e9099bd9cc2a24f95932ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaec74c566e8a5e8$var$_react = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eaec74c566e8a5e8$var$_baseNew = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eaec74c566e8a5e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eaec74c566e8a5e8$var$TextStyleIcon = (props)=>/*#__PURE__*/ $eaec74c566e8a5e8$var$_react.default.createElement($eaec74c566e8a5e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$eaec74c566e8a5e8$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $eaec74c566e8a5e8$var$_default = module.exports.default = $eaec74c566e8a5e8$var$TextStyleIcon;

});


parcelRegister("fMJd2", function(module, exports) {

$parcel$export(module.exports, "blockTypeMenuItemStyle", () => $e41ad3cbd8b8f72e$export$2e548ca9c55ac73f);
$parcel$export(module.exports, "keyboardShortcut", () => $e41ad3cbd8b8f72e$export$54ea58af6cf8bf3a);
$parcel$export(module.exports, "keyboardShortcutSelect", () => $e41ad3cbd8b8f72e$export$b09cf4fbc27c2bae);
$parcel$export(module.exports, "wrapperSmallStyle", () => $e41ad3cbd8b8f72e$export$4f9ef2b7bddb4c3a);
$parcel$export(module.exports, "floatingToolbarWrapperStyle", () => $e41ad3cbd8b8f72e$export$a61e5f64ad28e14a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kRRtM = parcelRequire("kRRtM");
var $idytF = parcelRequire("idytF");

var $24JcV = parcelRequire("24JcV");

function $e41ad3cbd8b8f72e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e41ad3cbd8b8f72e$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, white)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $kRRtM.blockquoteSharedStyles) : (0, $idytF.headingsSharedStyles)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $e41ad3cbd8b8f72e$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $f8Sb3.css)((0, $24JcV.shortcutStyle), {
    marginLeft: "var(--ds-space-200, 16px)",
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`
});
const $e41ad3cbd8b8f72e$export$b09cf4fbc27c2bae = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`
});
const $e41ad3cbd8b8f72e$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $e41ad3cbd8b8f72e$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $e41ad3cbd8b8f72e$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};

});
parcelRegister("24JcV", function(module, exports) {

$parcel$export(module.exports, "shortcutStyle", () => $c5630718e5a09f0f$export$297e5814a2c821bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $c5630718e5a09f0f$export$297e5814a2c821bb = /*#__PURE__*/ (0, $f8Sb3.css)("background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);border-radius:var(--ds-border-radius, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $iHYdz.akEditorMobileMaxWidth), "px){display:none;}");

});





parcelRegister("62ifj", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $f4af8af866ff3914$export$94516d5cccf573e3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $awTmI = parcelRequire("awTmI");

var $6Gwcf = parcelRequire("6Gwcf");
function $f4af8af866ff3914$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { blockTypeState: blockTypeState } = (0, $awTmI.useSharedPluginState)(api, [
        'blockType'
    ]);
    const boundSetBlockType = (name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $gkwXh.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    const wrapBlockQuote = ()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $gkwXh.INPUT_METHOD).TOOLBAR));
    const clearFormatting = ()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $gkwXh.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Gwcf.default), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pluginState: blockTypeState,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}

});



parcelRegister("3nspz", function(module, exports) {

$parcel$export(module.exports, "cardPlugin", () => (parcelRequire("a0QQi")).cardPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $a0QQi = parcelRequire("a0QQi");

});
parcelRegister("a0QQi", function(module, exports) {

$parcel$export(module.exports, "cardPlugin", () => $fd20f43ba6407c85$export$2a6748328f902e16);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $80CM7 = parcelRequire("80CM7");

var $I02Nt = parcelRequire("I02Nt");

var $3dBkm = parcelRequire("3dBkm");

var $lX6w0 = parcelRequire("lX6w0");
var $f980L = parcelRequire("f980L");

var $VSDnB = parcelRequire("VSDnB");

var $5PsrF = parcelRequire("5PsrF");

var $6A2Fh = parcelRequire("6A2Fh");

var $fhHat = parcelRequire("fhHat");

var $nYpqR = parcelRequire("nYpqR");

var $jPiXc = parcelRequire("jPiXc");

var $ie3zK = parcelRequire("ie3zK");

var $kfdsX = parcelRequire("kfdsX");

var $lumM0 = parcelRequire("lumM0");

var $jPPkn = parcelRequire("jPPkn");

var $1QWoP = parcelRequire("1QWoP");

var $dUrXD = parcelRequire("dUrXD");

var $eZ5Wl = parcelRequire("eZ5Wl");

var $AYP48 = parcelRequire("AYP48");

var $6caZq = parcelRequire("6caZq");

var $f10aj = parcelRequire("f10aj");
const $fd20f43ba6407c85$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $1QWoP.createEventsQueue)();
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $lumM0.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $fhHat.inlineCardSpecWithFixedToDOM)()
                },
                {
                    name: 'blockCard',
                    node: (0, $5PsrF.blockCardSpecWithFixedToDOM)()
                }
            ];
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $6A2Fh.embedCardSpecWithFixedToDOM)()
            });
            return nodes;
        },
        pmPlugins () {
            const allowBlockCards = options.allowBlockCards ?? true;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $kfdsX.createPlugin)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $ie3zK.cardKeymap)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AYP48.EditorSmartCardEvents), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZ5Wl.EditorLinkingPlatformAnalytics), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6caZq.default), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dUrXD.default), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $nYpqR.setProvider)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $nYpqR.hideLinkToolbar,
            queueCardsFromChangedTr: $jPiXc.queueCardsFromChangedTr,
            getStartingToolbarItems: (0, $f10aj.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $f10aj.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $f10aj.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertArray = [];
                if (!options.allowDatasource) return quickInsertArray;
                quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $80CM7.messages).datasourceJiraIssueIssueTermRefresh : (0, $80CM7.messages).datasourceJiraIssue),
                    description: formatMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $80CM7.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $80CM7.messages).datasourceJiraIssueDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'jira'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconDatasourceJiraIssue), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $nYpqR.showDatasourceModal)('jira')(tr);
                        return tr;
                    }
                });
                if ((0, $3dBkm.canRenderDatasource)((0, $lX6w0.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $80CM7.messages).datasourceAssetsObjectsGeneralAvailability),
                    description: formatMessage((0, $80CM7.messages).datasourceAssetsObjectsDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'assets'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconDatasourceAssetsObjects), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $nYpqR.showDatasourceModal)('assets')(tr);
                        return tr;
                    }
                });
                if ((0, $jPPkn.isDatasourceConfigEditable)((0, $f980L.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $80CM7.messages).datasourceConfluenceSearch),
                    description: formatMessage((0, $80CM7.messages).datasourceConfluenceSearchDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'confluence'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconDatasourceConfluenceSearch), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $nYpqR.showDatasourceModal)('confluence-search')(tr);
                        return tr;
                    }
                });
                return quickInsertArray;
            }
        }
    };
};

});
parcelRegister("3dBkm", function(module, exports) {

$parcel$export(module.exports, "getDatasourceType", () => $690615f85cf46a23$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $690615f85cf46a23$export$1974047c293dd52e);

var $lX6w0 = parcelRequire("lX6w0");
var $f980L = parcelRequire("f980L");
var $7mvwv = parcelRequire("7mvwv");

var $VSDnB = parcelRequire("VSDnB");
const $690615f85cf46a23$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $7mvwv.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $lX6w0.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $f980L.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $690615f85cf46a23$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $690615f85cf46a23$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $VSDnB.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("lX6w0", function(module, exports) {

$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $b26c1258743f5547$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $b26c1258743f5547$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $b26c1258743f5547$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $b26c1258743f5547$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("67UbR")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $b26c1258743f5547$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b26c1258743f5547$var$LazyAssetsConfigModal, props));
};
var $b26c1258743f5547$export$2e2bcd8739ae039 = $b26c1258743f5547$var$AssetsConfigModalWithWrappers;

});
parcelRegister("67UbR", function(module, exports) {

let $475efbbda0d9b48f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $475efbbda0d9b48f$var$load("dsiAd"),
    $475efbbda0d9b48f$var$load("hPzOn"),
    $475efbbda0d9b48f$var$load("cM9em"),
    $475efbbda0d9b48f$var$load("fr9NE"),
    $475efbbda0d9b48f$var$load("h2MrD"),
    $475efbbda0d9b48f$var$load("bYT2S"),
    $475efbbda0d9b48f$var$load("Kr4ci")
]).then(()=>parcelRequire('4QSOw'));

});


parcelRegister("f980L", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $4b1899e250d97ce5$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $4b1899e250d97ce5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4b1899e250d97ce5$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $4b1899e250d97ce5$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("fXKpt")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $4b1899e250d97ce5$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b1899e250d97ce5$var$LazyConfluenceSearchConfigModal, props));
};
var $4b1899e250d97ce5$export$2e2bcd8739ae039 = $4b1899e250d97ce5$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("fXKpt", function(module, exports) {

let $b9f05dc063b956d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b9f05dc063b956d3$var$load("dsiAd"),
    $b9f05dc063b956d3$var$load("hPzOn"),
    $b9f05dc063b956d3$var$load("cM9em"),
    $b9f05dc063b956d3$var$load("fr9NE"),
    $b9f05dc063b956d3$var$load("h2MrD"),
    $b9f05dc063b956d3$var$load("bYT2S"),
    $b9f05dc063b956d3$var$load("21Uj6")
]).then(()=>parcelRequire('ayFsd'));

});


parcelRegister("7mvwv", function(module, exports) {

$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $0edb3309d3119e6e$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $0edb3309d3119e6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0edb3309d3119e6e$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $0edb3309d3119e6e$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("a6sQR")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $0edb3309d3119e6e$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0edb3309d3119e6e$var$LazyJiraIssuesConfigModal, props));
};
var $0edb3309d3119e6e$export$2e2bcd8739ae039 = $0edb3309d3119e6e$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("a6sQR", function(module, exports) {

let $75b0d84594fb92fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $75b0d84594fb92fe$var$load("dsiAd"),
    $75b0d84594fb92fe$var$load("hPzOn"),
    $75b0d84594fb92fe$var$load("cM9em"),
    $75b0d84594fb92fe$var$load("fr9NE"),
    $75b0d84594fb92fe$var$load("h2MrD"),
    $75b0d84594fb92fe$var$load("bYT2S"),
    $75b0d84594fb92fe$var$load("3BfG3")
]).then(()=>parcelRequire('2WQ9j'));

});



parcelRegister("5PsrF", function(module, exports) {

$parcel$export(module.exports, "blockCardSpecWithFixedToDOM", () => $348df76dbd1079dd$export$f664dd11022c8749);

var $21PS7 = parcelRequire("21PS7");

var $7KZr8 = parcelRequire("7KZr8");

const $348df76dbd1079dd$export$f664dd11022c8749 = ()=>{
    return {
        ...(0, $21PS7.blockCard),
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap'
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $7KZr8.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-border-radius-100, 4px)",
                            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};

});

parcelRegister("6A2Fh", function(module, exports) {

$parcel$export(module.exports, "embedCardSpecWithFixedToDOM", () => $eb4ac8df7da5f4c2$export$f8faabd3267a007e);
/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $kshOv = parcelRequire("kshOv");

var $7KZr8 = parcelRequire("7KZr8");

var $iHYdz = parcelRequire("iHYdz");

// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $eb4ac8df7da5f4c2$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $eb4ac8df7da5f4c2$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $eb4ac8df7da5f4c2$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $eb4ac8df7da5f4c2$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $eb4ac8df7da5f4c2$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $eb4ac8df7da5f4c2$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $eb4ac8df7da5f4c2$var$LINE_LENGTH = 760;
const $eb4ac8df7da5f4c2$export$f8faabd3267a007e = ()=>{
    return {
        ...(0, $kshOv.embedCard),
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH) / (0, $iHYdz.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $7KZr8.convertToInlineCss)({
                    margin: $eb4ac8df7da5f4c2$var$calcMargin(layout),
                    width: `${Math.ceil($eb4ac8df7da5f4c2$var$calcPxFromPct(width / 100, $eb4ac8df7da5f4c2$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $eb4ac8df7da5f4c2$var$float(layout)
                })
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $7KZr8.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-border-radius-100, 4px)",
                            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $7KZr8.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};

});

parcelRegister("fhHat", function(module, exports) {

$parcel$export(module.exports, "inlineCardSpecWithFixedToDOM", () => $5df0f1f47c90e7ca$export$290edac762b9f37c);

var $cCBEe = parcelRequire("cCBEe");

var $7KZr8 = parcelRequire("7KZr8");

const $5df0f1f47c90e7ca$export$290edac762b9f37c = ()=>{
    return {
        ...(0, $cCBEe.inlineCard),
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $7KZr8.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                })
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};

});

parcelRegister("nYpqR", function(module, exports) {

$parcel$export(module.exports, "resolveCard", () => $cf821aeeee453783$export$2b7045d36e3e01d4);
$parcel$export(module.exports, "queueCards", () => $cf821aeeee453783$export$5312e3a17c3f6d3);
$parcel$export(module.exports, "registerCard", () => $cf821aeeee453783$export$af5afab36c1f83f6);
$parcel$export(module.exports, "removeCard", () => $cf821aeeee453783$export$3301f76e6efaf85e);
$parcel$export(module.exports, "registerRemoveOverlay", () => $cf821aeeee453783$export$a3d5a5cb818ce9d9);
$parcel$export(module.exports, "registerSmartCardEvents", () => $cf821aeeee453783$export$55288255874724a1);
$parcel$export(module.exports, "setProvider", () => $cf821aeeee453783$export$1572b3eade6662f9);
$parcel$export(module.exports, "setDatasourceTableRef", () => $cf821aeeee453783$export$f9c5be16586d220a);
$parcel$export(module.exports, "setCardLayout", () => $cf821aeeee453783$export$c9a25858ed46807c);
$parcel$export(module.exports, "setCardLayoutAndDatasourceTableRef", () => $cf821aeeee453783$export$dd3435a1df9b2a3f);
$parcel$export(module.exports, "showLinkToolbar", () => $cf821aeeee453783$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $cf821aeeee453783$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "showDatasourceModal", () => $cf821aeeee453783$export$2c79f54b873d04be);
$parcel$export(module.exports, "hideDatasourceModal", () => $cf821aeeee453783$export$e545bc176b552938);
$parcel$export(module.exports, "clearOverlayCandidate", () => $cf821aeeee453783$export$a2922c2e95ff48f7);
$parcel$export(module.exports, "setDatasourceStash", () => $cf821aeeee453783$export$53e36aa41bbce673);
$parcel$export(module.exports, "removeDatasourceStash", () => $cf821aeeee453783$export$4b1fde77584594b5);

var $lumM0 = parcelRequire("lumM0");
const $cf821aeeee453783$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $lumM0.pluginKey), action);
};
const $cf821aeeee453783$export$2b7045d36e3e01d4 = (url)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $cf821aeeee453783$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $cf821aeeee453783$export$af5afab36c1f83f6 = (info)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $cf821aeeee453783$export$3301f76e6efaf85e = (info)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $cf821aeeee453783$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $cf821aeeee453783$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $cf821aeeee453783$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $cf821aeeee453783$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $cf821aeeee453783$export$c9a25858ed46807c = (layout)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $cf821aeeee453783$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $cf821aeeee453783$export$83c364d103479f90 = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $cf821aeeee453783$export$bd1cd60a9b31da5e = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $cf821aeeee453783$export$2c79f54b873d04be = (modalType)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $cf821aeeee453783$export$e545bc176b552938 = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $cf821aeeee453783$export$a2922c2e95ff48f7 = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $cf821aeeee453783$export$53e36aa41bbce673 = (tr, datasourceStash)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $cf821aeeee453783$export$4b1fde77584594b5 = (tr, url)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });

});
parcelRegister("lumM0", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $9679942c324f0355$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $9679942c324f0355$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('cardPlugin');

});


parcelRegister("jPiXc", function(module, exports) {

$parcel$export(module.exports, "replaceQueuedUrlWithCard", () => $2c36f52f15a584d8$export$78f5a0da64579d3e);
$parcel$export(module.exports, "handleFallbackWithAnalytics", () => $2c36f52f15a584d8$export$2bb01cc4a12e0b44);
$parcel$export(module.exports, "queueCardsFromChangedTr", () => $2c36f52f15a584d8$export$f17c48478174211e);
$parcel$export(module.exports, "changeSelectedCardToLink", () => $2c36f52f15a584d8$export$3f14f692ecc2a0d9);
$parcel$export(module.exports, "changeSelectedCardToLinkFallback", () => $2c36f52f15a584d8$export$56a04318a610dc7c);
$parcel$export(module.exports, "updateCard", () => $2c36f52f15a584d8$export$884fcee347ca969b);
$parcel$export(module.exports, "changeSelectedCardToText", () => $2c36f52f15a584d8$export$23c9e012c8c1ce24);
$parcel$export(module.exports, "setSelectedCardAppearance", () => $2c36f52f15a584d8$export$a188ef61ddbb94f);
$parcel$export(module.exports, "updateCardViaDatasource", () => $2c36f52f15a584d8$export$113cdaf1b279f308);
$parcel$export(module.exports, "insertDatasource", () => $2c36f52f15a584d8$export$7f7b236478a618df);

var $ajpes = parcelRequire("ajpes");

var $iZOJ9 = parcelRequire("iZOJ9");

var $gkwXh = parcelRequire("gkwXh");
var $cPN3o = parcelRequire("cPN3o");
var $2iyV6 = parcelRequire("2iyV6");

var $1ZWXY = parcelRequire("1ZWXY");

var $lhLis = parcelRequire("lhLis");

var $h03xs = parcelRequire("h03xs");
var $dPSMN = parcelRequire("dPSMN");
var $ggL2v = parcelRequire("ggL2v");
var $agxMF = parcelRequire("agxMF");

var $fZzhT = parcelRequire("fZzhT");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $nYpqR = parcelRequire("nYpqR");

var $lumM0 = parcelRequire("lumM0");

var $1CO6U = parcelRequire("1CO6U");

var $jPPkn = parcelRequire("jPPkn");
/**
 * Attempt to replace the link into the respective card.
 */ function $2c36f52f15a584d8$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $iZOJ9.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $1CO6U.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    if ((0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) {
        const annotationMarksForPos = (0, $h03xs.getAnnotationMarksForPos)($head);
        if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
            // Add the annotation mark on to the inlineCard node and the trailing space node.
            tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
        });
    }
    return $pos.node($pos.depth - 1).type.name;
}
const $2c36f52f15a584d8$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent)=>(editorState, dispatch)=>{
        const state = (0, $lumM0.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        const cardAdf = (0, $agxMF.processRawValue)(schema, cardData);
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$2c36f52f15a584d8$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $gkwXh.ACTION).INSERTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $dPSMN.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $1ZWXY.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $nYpqR.resolveCard)(url)((0, $fZzhT.closeHistory)(tr)));
        return true;
    };
const $2c36f52f15a584d8$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $lumM0.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $gkwXh.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $dPSMN.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $nYpqR.resolveCard)(request.url)(tr));
        return true;
    };
const $2c36f52f15a584d8$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $ggL2v.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1CO6U.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: appearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    if (analyticsAction) (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $nYpqR.queueCards)(requests)(tr);
};
const $2c36f52f15a584d8$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $ggL2v.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1CO6U.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $nYpqR.queueCards)(requests)(tr);
};
const $2c36f52f15a584d8$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $gkwXh.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_3')) {
        const activeLinkMark = (0, $lhLis.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $1ZWXY.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $gkwXh.ACTION).CHANGED_TYPE
    });
    return (0, $nYpqR.queueCards)(requests)(state.tr);
};
const $2c36f52f15a584d8$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $gZGBX.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos) tr = $2c36f52f15a584d8$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, text, href);
        $2c36f52f15a584d8$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CHANGED_TYPE,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $cPN3o.SMART_LINK_TYPE).URL,
                    previousType: (0, $jPPkn.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $2c36f52f15a584d8$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos) tr = $2c36f52f15a584d8$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $gkwXh.ACTION).ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $2c36f52f15a584d8$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $jPPkn.selectedCardAppearance)(state);
        const tr = $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, href, href);
        $2c36f52f15a584d8$export$717aabd99c4fc685(state, tr, (0, $gkwXh.INPUT_METHOD).MANUAL, (0, $gkwXh.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $2c36f52f15a584d8$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $2c36f52f15a584d8$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
                action: (0, $gkwXh.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $2iyV6.unlinkPayload)((0, $gkwXh.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $2c36f52f15a584d8$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $gZGBX.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $2c36f52f15a584d8$export$c8301558911030d4(state, (0, $gkwXh.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
                    action: (0, $gkwXh.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $jPPkn.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = $2c36f52f15a584d8$export$85bb3e53350e35b8(appearance, selectedNode);
        const { from: from, to: to } = state.selection;
        const nodeType = $2c36f52f15a584d8$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        $2c36f52f15a584d8$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CHANGED_TYPE,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $jPPkn.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
            action: (0, $gkwXh.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $2c36f52f15a584d8$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $2c36f52f15a584d8$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
        action: (0, $gkwXh.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $nYpqR.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $nYpqR.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $2c36f52f15a584d8$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $nYpqR.hideDatasourceModal)(tr);
    (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
        action: (0, $gkwXh.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $2c36f52f15a584d8$export$85bb3e53350e35b8 = (appearance, selectedNode)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center'
    };
    if ((0, $jPPkn.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $2c36f52f15a584d8$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $jPPkn.isDatasourceNode)(selectedNode) && !(0, $jPPkn.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $nYpqR.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};

});
parcelRegister("cPN3o", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_TYPE", () => $576fe822cbc87df1$export$9710eda883ce7be2);
$parcel$export(module.exports, "SMART_LINK_TYPE", () => $576fe822cbc87df1$export$804a928ffc86c02c);
var $576fe822cbc87df1$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $576fe822cbc87df1$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});

});

parcelRegister("2iyV6", function(module, exports) {

$parcel$export(module.exports, "buildEditLinkPayload", () => $d81ce512c6a47a5f$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $d81ce512c6a47a5f$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $d81ce512c6a47a5f$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $d81ce512c6a47a5f$export$aab75a08bdd88be4);

var $gkwXh = parcelRequire("gkwXh");
const $d81ce512c6a47a5f$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $gkwXh.ACTION).CLICKED,
        actionSubject: type === (0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK ? (0, $gkwXh.ACTION_SUBJECT).HYPERLINK : (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $gkwXh.EVENT_TYPE).UI
    };
};
const $d81ce512c6a47a5f$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $gkwXh.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $gkwXh.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $gkwXh.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $d81ce512c6a47a5f$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK ? {
        action: (0, $gkwXh.ACTION).VISITED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    } : {
        action: (0, $gkwXh.ACTION).VISITED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
};
const $d81ce512c6a47a5f$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $gkwXh.ACTION).CLICKED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $gkwXh.INPUT_METHOD).TOOLBAR,
            display: $d81ce512c6a47a5f$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $gkwXh.EVENT_TYPE).UI
    };
};
const $d81ce512c6a47a5f$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $gkwXh.ACTION).UNLINK,
        actionSubject: type === (0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK ? (0, $gkwXh.ACTION_SUBJECT).HYPERLINK : (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
};

});

parcelRegister("1ZWXY", function(module, exports) {

$parcel$export(module.exports, "addLinkMetadata", () => $2c279959aed73c3c$export$e2d4855dca88ecc1);
$parcel$export(module.exports, "getLinkMetadataFromTransaction", () => $2c279959aed73c3c$export$3aba02526a1e2e78);
$parcel$export(module.exports, "commandWithMetadata", () => $2c279959aed73c3c$export$76125a95b70625ac);

var $f5LPn = parcelRequire("f5LPn");
function $2c279959aed73c3c$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $f5LPn.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
function $2c279959aed73c3c$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $f5LPn.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
const $2c279959aed73c3c$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            $2c279959aed73c3c$export$e2d4855dca88ecc1(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};

});
parcelRegister("f5LPn", function(module, exports) {

$parcel$export(module.exports, "LinkMetaStep", () => $afcc6c37d74355ec$export$40e33c9d27895078);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $afcc6c37d74355ec$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $afcc6c37d74355ec$export$2774298c489a128f = 'editor-linking-meta-invert';
class $afcc6c37d74355ec$export$40e33c9d27895078 extends (0, $eS2Dn.Step) {
    constructor(pos, metadata, isInverted = false){
        super();
        this.pos = pos;
        this.metadata = metadata;
        this.isInverted = isInverted;
    }
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $afcc6c37d74355ec$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $afcc6c37d74355ec$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $eS2Dn.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($afcc6c37d74355ec$export$954e3f6aa93d9ba3, $afcc6c37d74355ec$export$40e33c9d27895078);

});


parcelRegister("lhLis", function(module, exports) {

$parcel$export(module.exports, "isTextAtPos", () => $861122be5c19938d$export$8476280b1d47554d);
$parcel$export(module.exports, "getLinkPreferencesURLFromENV", () => $861122be5c19938d$export$e5404273592f5dbd);
$parcel$export(module.exports, "getActiveLinkMark", () => $861122be5c19938d$export$819e108a65d33088);

var $kTK0a = parcelRequire("kTK0a");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

function $861122be5c19938d$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}
function $861122be5c19938d$export$54fac2c1c66c48ae(pos) {
    return (state)=>{
        const node = state.doc.nodeAt(pos);
        return !!node && !!state.schema.marks.link.isInSet(node.marks);
    };
}
const $861122be5c19938d$export$e5404273592f5dbd = ()=>{
    return (0, $kTK0a.getATLContextUrl)('id') + (0, $0a1bd3f769db1d07$export$f0972e90f14682b1);
};
const $861122be5c19938d$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $861122be5c19938d$var$isEmptySelectionBeforeLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeAfter?.marks || []);
};
const $861122be5c19938d$var$isEmptySelectionAfterLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeBefore?.marks || []);
};
const $861122be5c19938d$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $861122be5c19938d$export$819e108a65d33088 = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($861122be5c19938d$var$isSelectionInsideLink(state) || $861122be5c19938d$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    if ($861122be5c19938d$var$isEmptySelectionBeforeLink(state) && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_3')) {
        // if user clicks right before the link, we want to show the toolbar for the link
        // but only if the link is a single character
        const node = state.doc.nodeAt($from.pos);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos
        } : undefined;
    }
    if ($861122be5c19938d$var$isEmptySelectionAfterLink(state) && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_3')) {
        // if user clicks right after the link, we want to show the toolbar for the link
        // but only if the link is a single character
        // and we return the position of the link
        const node = state.doc.nodeAt($from.pos - 1);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos - 1
        } : undefined;
    }
    return undefined;
};

});
const $0a1bd3f769db1d07$export$f0972e90f14682b1 = '/manage-profile/link-preferences';


parcelRegister("dPSMN", function(module, exports) {

$parcel$export(module.exports, "LinkMatcher", () => $c71efdd24f85e7a0$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $c71efdd24f85e7a0$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $c71efdd24f85e7a0$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $c71efdd24f85e7a0$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $c71efdd24f85e7a0$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $c71efdd24f85e7a0$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $c71efdd24f85e7a0$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $c71efdd24f85e7a0$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $c71efdd24f85e7a0$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $iZOJ9 = parcelRequire("iZOJ9");

var $gkwXh = parcelRequire("gkwXh");

var $gOwky = parcelRequire("gOwky");

var $7vpuQ = parcelRequire("7vpuQ");
const $c71efdd24f85e7a0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c71efdd24f85e7a0$export$dabcc234035f6703 = /^(\$|{)/;
class $c71efdd24f85e7a0$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c71efdd24f85e7a0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $iZOJ9.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c71efdd24f85e7a0$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $iZOJ9.isSafeUrl)(url)) return url;
    return (0, $iZOJ9.normalizeUrl)(url);
}
function $c71efdd24f85e7a0$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c71efdd24f85e7a0$var$findLinkMatches(text).filter((0, $gOwky.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c71efdd24f85e7a0$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c71efdd24f85e7a0$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c71efdd24f85e7a0$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c71efdd24f85e7a0$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c71efdd24f85e7a0$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c71efdd24f85e7a0$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $iZOJ9.linkify).match(text) || [];
}
const $c71efdd24f85e7a0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c71efdd24f85e7a0$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c71efdd24f85e7a0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c71efdd24f85e7a0$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c71efdd24f85e7a0$export$238a6141b3685c21(url)
        }
    };
}
const $c71efdd24f85e7a0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link));
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});
parcelRegister("gOwky", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $a8453eeff8b41d2c$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $a8453eeff8b41d2c$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $a8453eeff8b41d2c$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$a8453eeff8b41d2c$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $a8453eeff8b41d2c$export$e19a09e301eaa6bb(match) {
    return $a8453eeff8b41d2c$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("7vpuQ", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $cd200aea723473fd$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $cd200aea723473fd$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $cd200aea723473fd$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $cd200aea723473fd$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $cd200aea723473fd$export$e0baa27f47733a4a);

var $kCV8T = parcelRequire("kCV8T");
function $cd200aea723473fd$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $cd200aea723473fd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($cd200aea723473fd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $kCV8T.Fragment)) children.push(...$cd200aea723473fd$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $kCV8T.Fragment).fromArray(children);
}
function $cd200aea723473fd$export$d8264570c5933bbf(slice, callback) {
    const fragment = $cd200aea723473fd$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $kCV8T.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $cd200aea723473fd$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(fragmentContent);
}
function $cd200aea723473fd$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $kCV8T.Fragment) ? node : node.content));
    return array;
}
const $cd200aea723473fd$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $cd200aea723473fd$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$cd200aea723473fd$var$findNode(predicate)(slice);
    };

});


parcelRegister("1CO6U", function(module, exports) {

$parcel$export(module.exports, "shouldReplaceLink", () => $d30737d2ce17b865$export$f85e921f66e987fa);

var $iZOJ9 = parcelRequire("iZOJ9");

var $1M84d = parcelRequire("1M84d");
function $d30737d2ce17b865$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $iZOJ9.normalizeUrl)((0, $1M84d.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $iZOJ9.normalizeUrl)((0, $1M84d.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $iZOJ9.normalizeUrl)((0, $1M84d.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}

});
parcelRegister("1M84d", function(module, exports) {

$parcel$export(module.exports, "md", () => $76c5a60e1fbb7648$export$f4de1c043ce6927);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $ivSSX = parcelRequire("ivSSX");

var $h4jau = parcelRequire("h4jau");

var $2Suqb = parcelRequire("2Suqb");

var $3KuZM = parcelRequire("3KuZM");

var $igwks = parcelRequire("igwks");
const $76c5a60e1fbb7648$export$f4de1c043ce6927 = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
    html: false
});
$76c5a60e1fbb7648$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $igwks.default));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $2Suqb.default));
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $3KuZM.default));
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $h4jau.default));

});
parcelRegister("ivSSX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7fjdG"));

});
parcelRegister("7fjdG", function(module, exports) {
// Main parser class
'use strict';

var $lKlAe = parcelRequire("lKlAe");

var $1mGdb = parcelRequire("1mGdb");

var $keGIi = parcelRequire("keGIi");

var $aVlnc = parcelRequire("aVlnc");

var $81Ci5 = parcelRequire("81Ci5");

var $58y21 = parcelRequire("58y21");

var $43kHv = parcelRequire("43kHv");

var $aK6mt = parcelRequire("aK6mt");

var $k7qPZ = parcelRequire("k7qPZ");



var $5468d7bb65d238e2$var$config = {
    default: (parcelRequire("gcpUf")),
    zero: (parcelRequire("hbvGf")),
    commonmark: (parcelRequire("8Ubo6"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $5468d7bb65d238e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $5468d7bb65d238e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $5468d7bb65d238e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $5468d7bb65d238e2$var$BAD_PROTO_RE.test(str) ? $5468d7bb65d238e2$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $5468d7bb65d238e2$var$normalizeLink(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $aK6mt.encode($aK6mt.format(parsed));
}
function $5468d7bb65d238e2$var$normalizeLinkText(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $aK6mt.decode($aK6mt.format(parsed), $aK6mt.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $5468d7bb65d238e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $5468d7bb65d238e2$var$MarkdownIt)) return new $5468d7bb65d238e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$lKlAe.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $58y21();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $81Ci5();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $aVlnc();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $keGIi();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $43kHv();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $5468d7bb65d238e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $5468d7bb65d238e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $5468d7bb65d238e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $lKlAe;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $lKlAe.assign({}, $1mGdb);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.set = function(options) {
    $lKlAe.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($lKlAe.isString(presets)) {
        presetName = presets;
        presets = $5468d7bb65d238e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $5468d7bb65d238e2$var$MarkdownIt;

});
parcelRegister("lKlAe", function(module, exports) {

$parcel$export(module.exports, "lib", () => $fd4ea2dc11e83b2a$export$16c08b91f883959a, (v) => $fd4ea2dc11e83b2a$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227, (v) => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $fd4ea2dc11e83b2a$export$844ec244b1367d54, (v) => $fd4ea2dc11e83b2a$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5, (v) => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03, (v) => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c, (v) => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d, (v) => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $fd4ea2dc11e83b2a$export$73bfc63873071f74, (v) => $fd4ea2dc11e83b2a$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8, (v) => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $fd4ea2dc11e83b2a$export$f78478f71955b6bc, (v) => $fd4ea2dc11e83b2a$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926, (v) => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c, (v) => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $fd4ea2dc11e83b2a$export$829a0d33ae4e744, (v) => $fd4ea2dc11e83b2a$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $fd4ea2dc11e83b2a$export$4888a643af800fc1, (v) => $fd4ea2dc11e83b2a$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d, (v) => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $fd4ea2dc11e83b2a$export$20ef46802c8744b, (v) => $fd4ea2dc11e83b2a$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $fd4ea2dc11e83b2a$export$16c08b91f883959a;
var $fd4ea2dc11e83b2a$export$e6e34fd1f2686227;
var $fd4ea2dc11e83b2a$export$844ec244b1367d54;
var $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5;
var $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03;
var $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c;
var $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d;
var $fd4ea2dc11e83b2a$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8;
var $fd4ea2dc11e83b2a$export$f78478f71955b6bc;
var $fd4ea2dc11e83b2a$export$1d5ccafae59b4926;
var $fd4ea2dc11e83b2a$export$3c52dd84024ae72c;
var $fd4ea2dc11e83b2a$export$829a0d33ae4e744;
var $fd4ea2dc11e83b2a$export$4888a643af800fc1;
var $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d;
var $fd4ea2dc11e83b2a$export$20ef46802c8744b;
'use strict';
function $fd4ea2dc11e83b2a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fd4ea2dc11e83b2a$var$isString(obj) {
    return $fd4ea2dc11e83b2a$var$_class(obj) === '[object String]';
}
var $fd4ea2dc11e83b2a$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $fd4ea2dc11e83b2a$var$has(object, key) {
    return $fd4ea2dc11e83b2a$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $fd4ea2dc11e83b2a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $fd4ea2dc11e83b2a$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $fd4ea2dc11e83b2a$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $fd4ea2dc11e83b2a$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE = new RegExp($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE.source + '|' + $fd4ea2dc11e83b2a$var$ENTITY_RE.source, 'gi');
var $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $7MxGI = parcelRequire("7MxGI");
function $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, name) {
    var code;
    if ($fd4ea2dc11e83b2a$var$has($7MxGI, name)) return $7MxGI[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($fd4ea2dc11e83b2a$var$isValidEntityCode(code)) return $fd4ea2dc11e83b2a$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $fd4ea2dc11e83b2a$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE, '$1');
}
function $fd4ea2dc11e83b2a$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $fd4ea2dc11e83b2a$var$replaceUnsafeChar(ch) {
    return $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS[ch];
}
function $fd4ea2dc11e83b2a$var$escapeHtml(str) {
    if ($fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE, $fd4ea2dc11e83b2a$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $fd4ea2dc11e83b2a$var$escapeRE(str) {
    return str.replace($fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $fd4ea2dc11e83b2a$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $9bBmm = parcelRequire("9bBmm");
// Currently without astral characters support.
function $fd4ea2dc11e83b2a$var$isPunctChar(ch) {
    return $9bBmm.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $fd4ea2dc11e83b2a$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $fd4ea2dc11e83b2a$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$fd4ea2dc11e83b2a$export$16c08b91f883959a = {};

$fd4ea2dc11e83b2a$export$16c08b91f883959a.mdurl = (parcelRequire("aK6mt"));

$fd4ea2dc11e83b2a$export$16c08b91f883959a.ucmicro = (parcelRequire("7G9dc"));
$fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = $fd4ea2dc11e83b2a$var$assign;
$fd4ea2dc11e83b2a$export$844ec244b1367d54 = $fd4ea2dc11e83b2a$var$isString;
$fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = $fd4ea2dc11e83b2a$var$has;
$fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = $fd4ea2dc11e83b2a$var$unescapeMd;
$fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = $fd4ea2dc11e83b2a$var$unescapeAll;
$fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = $fd4ea2dc11e83b2a$var$isValidEntityCode;
$fd4ea2dc11e83b2a$export$73bfc63873071f74 = $fd4ea2dc11e83b2a$var$fromCodePoint;
$fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = $fd4ea2dc11e83b2a$var$escapeHtml;
$fd4ea2dc11e83b2a$export$f78478f71955b6bc = $fd4ea2dc11e83b2a$var$arrayReplaceAt;
$fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = $fd4ea2dc11e83b2a$var$isSpace;
$fd4ea2dc11e83b2a$export$3c52dd84024ae72c = $fd4ea2dc11e83b2a$var$isWhiteSpace;
$fd4ea2dc11e83b2a$export$829a0d33ae4e744 = $fd4ea2dc11e83b2a$var$isMdAsciiPunct;
$fd4ea2dc11e83b2a$export$4888a643af800fc1 = $fd4ea2dc11e83b2a$var$isPunctChar;
$fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = $fd4ea2dc11e83b2a$var$escapeRE;
$fd4ea2dc11e83b2a$export$20ef46802c8744b = $fd4ea2dc11e83b2a$var$normalizeReference;

});
parcelRegister("7MxGI", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("9yTii"));

});
parcelRegister("9yTii", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("aK6mt", function(module, exports) {

$parcel$export(module.exports, "encode", () => $7d2322841b1ac049$export$c564cdbbe6da493, (v) => $7d2322841b1ac049$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $7d2322841b1ac049$export$2f872c0f2117be69, (v) => $7d2322841b1ac049$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $7d2322841b1ac049$export$d9468344d3651243, (v) => $7d2322841b1ac049$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $7d2322841b1ac049$export$98e6a39c04603d36, (v) => $7d2322841b1ac049$export$98e6a39c04603d36 = v);
var $7d2322841b1ac049$export$c564cdbbe6da493;
var $7d2322841b1ac049$export$2f872c0f2117be69;
var $7d2322841b1ac049$export$d9468344d3651243;
var $7d2322841b1ac049$export$98e6a39c04603d36;
'use strict';

$7d2322841b1ac049$export$c564cdbbe6da493 = (parcelRequire("6jTHo"));

$7d2322841b1ac049$export$2f872c0f2117be69 = (parcelRequire("qpEB3"));

$7d2322841b1ac049$export$d9468344d3651243 = (parcelRequire("3yKUv"));

$7d2322841b1ac049$export$98e6a39c04603d36 = (parcelRequire("bQztL"));

});
parcelRegister("6jTHo", function(module, exports) {
'use strict';
var $499fb90cb213ebc3$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $499fb90cb213ebc3$var$getEncodeCache(exclude) {
    var i, ch, cache = $499fb90cb213ebc3$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $499fb90cb213ebc3$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $499fb90cb213ebc3$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $499fb90cb213ebc3$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $499fb90cb213ebc3$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$499fb90cb213ebc3$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$499fb90cb213ebc3$var$encode.componentChars = "-_.!~*'()";
module.exports = $499fb90cb213ebc3$var$encode;

});

parcelRegister("qpEB3", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $04f654215177967d$var$decodeCache = {};
function $04f654215177967d$var$getDecodeCache(exclude) {
    var i, ch, cache = $04f654215177967d$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $04f654215177967d$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $04f654215177967d$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $04f654215177967d$var$decode.defaultChars;
    cache = $04f654215177967d$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$04f654215177967d$var$decode.defaultChars = ';/?:@&=+$,#';
$04f654215177967d$var$decode.componentChars = '';
module.exports = $04f654215177967d$var$decode;

});

parcelRegister("3yKUv", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("bQztL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $8a0012734669979b$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $8a0012734669979b$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $8a0012734669979b$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$8a0012734669979b$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$8a0012734669979b$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$8a0012734669979b$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($8a0012734669979b$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$8a0012734669979b$var$autoEscape = [
    '\''
].concat($8a0012734669979b$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$8a0012734669979b$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($8a0012734669979b$var$autoEscape), $8a0012734669979b$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $8a0012734669979b$var$hostnameMaxLen = 255, $8a0012734669979b$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $8a0012734669979b$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$8a0012734669979b$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$8a0012734669979b$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $8a0012734669979b$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $8a0012734669979b$var$Url) return url;
    var u = new $8a0012734669979b$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$8a0012734669979b$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $8a0012734669979b$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $8a0012734669979b$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $8a0012734669979b$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$8a0012734669979b$var$hostlessProtocol[proto] && (slashes || proto && !$8a0012734669979b$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$hostEndingChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$nonHostChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($8a0012734669979b$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($8a0012734669979b$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($8a0012734669979b$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $8a0012734669979b$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($8a0012734669979b$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$8a0012734669979b$var$Url.prototype.parseHost = function(host) {
    var port = $8a0012734669979b$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $8a0012734669979b$var$urlParse;

});


parcelRegister("7G9dc", function(module, exports) {

$parcel$export(module.exports, "Any", () => $597399ee2a9a2974$export$b24b633b1364b94b, (v) => $597399ee2a9a2974$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $597399ee2a9a2974$export$15dafbac7aec8a57, (v) => $597399ee2a9a2974$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $597399ee2a9a2974$export$239cff0cce87eb56, (v) => $597399ee2a9a2974$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $597399ee2a9a2974$export$56c0d5a1e737357d, (v) => $597399ee2a9a2974$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $597399ee2a9a2974$export$dc98b0b04f4c7758, (v) => $597399ee2a9a2974$export$dc98b0b04f4c7758 = v);
var $597399ee2a9a2974$export$b24b633b1364b94b;
var $597399ee2a9a2974$export$15dafbac7aec8a57;
var $597399ee2a9a2974$export$239cff0cce87eb56;
var $597399ee2a9a2974$export$56c0d5a1e737357d;
var $597399ee2a9a2974$export$dc98b0b04f4c7758;
'use strict';

$597399ee2a9a2974$export$b24b633b1364b94b = (parcelRequire("b9ep3"));

$597399ee2a9a2974$export$15dafbac7aec8a57 = (parcelRequire("23ErL"));

$597399ee2a9a2974$export$239cff0cce87eb56 = (parcelRequire("i4n2C"));

$597399ee2a9a2974$export$56c0d5a1e737357d = (parcelRequire("9bBmm"));

$597399ee2a9a2974$export$dc98b0b04f4c7758 = (parcelRequire("oRY4m"));

});
parcelRegister("i4n2C", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("1mGdb", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $0fe896e38fc1beac$export$2a2c8612930e58d0, (v) => $0fe896e38fc1beac$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $0fe896e38fc1beac$export$22bd24080f95f2b3, (v) => $0fe896e38fc1beac$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $0fe896e38fc1beac$export$89650c5477a69db9, (v) => $0fe896e38fc1beac$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $0fe896e38fc1beac$export$2a2c8612930e58d0;
var $0fe896e38fc1beac$export$22bd24080f95f2b3;
var $0fe896e38fc1beac$export$89650c5477a69db9;
'use strict';

$0fe896e38fc1beac$export$2a2c8612930e58d0 = (parcelRequire("8y5kB"));

$0fe896e38fc1beac$export$22bd24080f95f2b3 = (parcelRequire("guwA0"));

$0fe896e38fc1beac$export$89650c5477a69db9 = (parcelRequire("9bSCV"));

});
parcelRegister("8y5kB", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("guwA0", function(module, exports) {
// Parse link destination
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c018b854bcc71549$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("9bSCV", function(module, exports) {
// Parse link title
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $6b0f83e20702a9d5$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $6b0f83e20702a9d5$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("keGIi", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$assign = $lKlAe.assign;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$unescapeAll = $lKlAe.unescapeAll;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$escapeHtml = $lKlAe.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $ebb63f71260e6c54$var$default_rules = {};
$ebb63f71260e6c54$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $ebb63f71260e6c54$require$escapeHtml(token.content) + '</code>';
};
$ebb63f71260e6c54$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $ebb63f71260e6c54$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $ebb63f71260e6c54$require$escapeHtml(token.content);
    else highlighted = $ebb63f71260e6c54$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$ebb63f71260e6c54$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$ebb63f71260e6c54$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$ebb63f71260e6c54$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content);
};
$ebb63f71260e6c54$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$ebb63f71260e6c54$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $ebb63f71260e6c54$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $ebb63f71260e6c54$require$assign({}, $ebb63f71260e6c54$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][0]) + '="' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $ebb63f71260e6c54$var$Renderer;

});

parcelRegister("aVlnc", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");







var $7f3fce7f6016210f$var$_rules = [
    [
        'normalize',
        (parcelRequire("iWx6a"))
    ],
    [
        'block',
        (parcelRequire("iY2Wj"))
    ],
    [
        'inline',
        (parcelRequire("16b9L"))
    ],
    [
        'linkify',
        (parcelRequire("lOz8R"))
    ],
    [
        'replacements',
        (parcelRequire("45Efy"))
    ],
    [
        'smartquotes',
        (parcelRequire("6sbf2"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("jEa7S"))
    ]
];
/**
 * new Core()
 **/ function $7f3fce7f6016210f$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $7f3fce7f6016210f$var$_rules.length; i++)this.ruler.push($7f3fce7f6016210f$var$_rules[i][0], $7f3fce7f6016210f$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $7f3fce7f6016210f$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$7f3fce7f6016210f$var$Core.prototype.State = (parcelRequire("dRBf6"));
module.exports = $7f3fce7f6016210f$var$Core;

});
parcelRegister("3sin6", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $28423cd2f7c52093$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$28423cd2f7c52093$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$28423cd2f7c52093$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $28423cd2f7c52093$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $28423cd2f7c52093$var$Ruler;

});

parcelRegister("iWx6a", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $dca7516ecd2cb0cd$var$NEWLINES_RE = /\r\n?|\n/g;
var $dca7516ecd2cb0cd$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($dca7516ecd2cb0cd$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($dca7516ecd2cb0cd$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("iY2Wj", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("16b9L", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("lOz8R", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $fe1986eb06b8c500$require$arrayReplaceAt = $lKlAe.arrayReplaceAt;
function $fe1986eb06b8c500$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $fe1986eb06b8c500$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($fe1986eb06b8c500$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($fe1986eb06b8c500$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $fe1986eb06b8c500$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("45Efy", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $2fa6d9dae6dddfa0$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $2fa6d9dae6dddfa0$var$replaceFn(match, name) {
    return $2fa6d9dae6dddfa0$var$SCOPED_ABBR[name.toLowerCase()];
}
function $2fa6d9dae6dddfa0$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE, $2fa6d9dae6dddfa0$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $2fa6d9dae6dddfa0$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($2fa6d9dae6dddfa0$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_scoped(state.tokens[blkIdx].children);
        if ($2fa6d9dae6dddfa0$var$RARE_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("6sbf2", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
var $4b2e13ec30356b37$var$QUOTE_TEST_RE = /['"]/;
var $4b2e13ec30356b37$var$QUOTE_RE = /['"]/g;
var $4b2e13ec30356b37$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $4b2e13ec30356b37$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $4b2e13ec30356b37$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $4b2e13ec30356b37$var$QUOTE_RE.lastIndex = pos;
            t = $4b2e13ec30356b37$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(lastChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(nextChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $4b2e13ec30356b37$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$4b2e13ec30356b37$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $4b2e13ec30356b37$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("jEa7S", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("dRBf6", function(module, exports) {
// Core state object
//
'use strict';

var $jwpQf = parcelRequire("jwpQf");
function $a17d1d317b1d68ad$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$a17d1d317b1d68ad$var$StateCore.prototype.Token = $jwpQf;
module.exports = $a17d1d317b1d68ad$var$StateCore;

});
parcelRegister("jwpQf", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $e3650d20fdc1ba98$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $e3650d20fdc1ba98$var$Token;

});



parcelRegister("81Ci5", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");











var $5d7c1e72b0aff81a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("gSwCe")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("dHrHm"))
    ],
    [
        'fence',
        (parcelRequire("1KHgS")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("79uLo")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("a0gIO")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("bFPxW")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("6Cm2K"))
    ],
    [
        'html_block',
        (parcelRequire("3IX6c")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("5VRwl")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("2v0Kv"))
    ],
    [
        'paragraph',
        (parcelRequire("d0isB"))
    ]
];
/**
 * new ParserBlock()
 **/ function $5d7c1e72b0aff81a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $5d7c1e72b0aff81a$var$_rules.length; i++)this.ruler.push($5d7c1e72b0aff81a$var$_rules[i][0], $5d7c1e72b0aff81a$var$_rules[i][1], {
        alt: ($5d7c1e72b0aff81a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$5d7c1e72b0aff81a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $5d7c1e72b0aff81a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$5d7c1e72b0aff81a$var$ParserBlock.prototype.State = (parcelRequire("l865e"));
module.exports = $5d7c1e72b0aff81a$var$ParserBlock;

});
parcelRegister("gSwCe", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c49afd4af32a69df$require$isSpace = $lKlAe.isSpace;
function $c49afd4af32a69df$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $c49afd4af32a69df$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c49afd4af32a69df$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c49afd4af32a69df$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c49afd4af32a69df$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c49afd4af32a69df$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("dHrHm", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("1KHgS", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("79uLo", function(module, exports) {
// Block quotes
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $53513ca36aaad8c7$require$isSpace = $lKlAe.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($53513ca36aaad8c7$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("a0gIO", function(module, exports) {
// Horizontal rule
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $7486e013b11c48f5$require$isSpace = $lKlAe.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$7486e013b11c48f5$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("bFPxW", function(module, exports) {
// Lists
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $87fb82138ea80db7$require$isSpace = $lKlAe.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $87fb82138ea80db7$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $87fb82138ea80db7$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("6Cm2K", function(module, exports) {
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$isSpace = $lKlAe.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$4d1764068d639a24$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$4d1764068d639a24$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $4d1764068d639a24$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("3IX6c", function(module, exports) {
// HTML block
'use strict';

var $9Jgti = parcelRequire("9Jgti");

var $1RRsU = parcelRequire("1RRsU");
var $2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE = $1RRsU.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $2b6352f7d75b50f9$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $9Jgti.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $2b6352f7d75b50f9$var$HTML_SEQUENCES.length; i++){
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $2b6352f7d75b50f9$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $2b6352f7d75b50f9$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("9Jgti", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("1RRsU", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $15c436cb9ae50f13$export$6db61d2c3a16e419, (v) => $15c436cb9ae50f13$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $15c436cb9ae50f13$export$cd48660d06f74639, (v) => $15c436cb9ae50f13$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $15c436cb9ae50f13$export$6db61d2c3a16e419;
var $15c436cb9ae50f13$export$cd48660d06f74639;
'use strict';
var $15c436cb9ae50f13$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $15c436cb9ae50f13$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $15c436cb9ae50f13$var$single_quoted = "'[^']*'";
var $15c436cb9ae50f13$var$double_quoted = '"[^"]*"';
var $15c436cb9ae50f13$var$attr_value = '(?:' + $15c436cb9ae50f13$var$unquoted + '|' + $15c436cb9ae50f13$var$single_quoted + '|' + $15c436cb9ae50f13$var$double_quoted + ')';
var $15c436cb9ae50f13$var$attribute = '(?:\\s+' + $15c436cb9ae50f13$var$attr_name + '(?:\\s*=\\s*' + $15c436cb9ae50f13$var$attr_value + ')?)';
var $15c436cb9ae50f13$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $15c436cb9ae50f13$var$attribute + '*\\s*\\/?>';
var $15c436cb9ae50f13$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $15c436cb9ae50f13$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $15c436cb9ae50f13$var$processing = '<[?][\\s\\S]*?[?]>';
var $15c436cb9ae50f13$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $15c436cb9ae50f13$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $15c436cb9ae50f13$var$HTML_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + '|' + $15c436cb9ae50f13$var$comment + '|' + $15c436cb9ae50f13$var$processing + '|' + $15c436cb9ae50f13$var$declaration + '|' + $15c436cb9ae50f13$var$cdata + ')');
var $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + ')');
$15c436cb9ae50f13$export$6db61d2c3a16e419 = $15c436cb9ae50f13$var$HTML_TAG_RE;
$15c436cb9ae50f13$export$cd48660d06f74639 = $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("5VRwl", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $451bcab957a0998a$require$isSpace = $lKlAe.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$451bcab957a0998a$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $451bcab957a0998a$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("2v0Kv", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("d0isB", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("l865e", function(module, exports) {
// Parser state class
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $f61f10562433da3b$require$isSpace = $lKlAe.isSpace;
function $f61f10562433da3b$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($f61f10562433da3b$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$f61f10562433da3b$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $jwpQf(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$f61f10562433da3b$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$f61f10562433da3b$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$f61f10562433da3b$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$f61f10562433da3b$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$f61f10562433da3b$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$f61f10562433da3b$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$f61f10562433da3b$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$f61f10562433da3b$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$f61f10562433da3b$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($f61f10562433da3b$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$f61f10562433da3b$var$StateBlock.prototype.Token = $jwpQf;
module.exports = $f61f10562433da3b$var$StateBlock;

});


parcelRegister("58y21", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $3bd81911677b8252$var$_rules = [
    [
        'text',
        (parcelRequire("gc14M"))
    ],
    [
        'linkify',
        (parcelRequire("2aNBd"))
    ],
    [
        'newline',
        (parcelRequire("a490I"))
    ],
    [
        'escape',
        (parcelRequire("027TI"))
    ],
    [
        'backticks',
        (parcelRequire("27paT"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).tokenize
    ],
    [
        'link',
        (parcelRequire("frx2x"))
    ],
    [
        'image',
        (parcelRequire("iUeRh"))
    ],
    [
        'autolink',
        (parcelRequire("ktOwv"))
    ],
    [
        'html_inline',
        (parcelRequire("1jFGt"))
    ],
    [
        'entity',
        (parcelRequire("jd9ks"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $3bd81911677b8252$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("ey6sy"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("hrHpd"))
    ]
];
/**
 * new ParserInline()
 **/ function $3bd81911677b8252$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules.length; i++)this.ruler.push($3bd81911677b8252$var$_rules[i][0], $3bd81911677b8252$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules2.length; i++)this.ruler2.push($3bd81911677b8252$var$_rules2[i][0], $3bd81911677b8252$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3bd81911677b8252$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3bd81911677b8252$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3bd81911677b8252$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$3bd81911677b8252$var$ParserInline.prototype.State = (parcelRequire("82i7L"));
module.exports = $3bd81911677b8252$var$ParserInline;

});
parcelRegister("gc14M", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $bc9e9a00ea13b29d$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$bc9e9a00ea13b29d$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("2aNBd", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $1952fd4ef50e3f47$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($1952fd4ef50e3f47$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("a490I", function(module, exports) {
// Proceess '\n'
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $754144646e41a199$require$isSpace = $lKlAe.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $754144646e41a199$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("027TI", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $006650534e77ff18$require$isSpace = $lKlAe.isSpace;
var $006650534e77ff18$var$ESCAPED = [];
for(var $006650534e77ff18$var$i = 0; $006650534e77ff18$var$i < 256; $006650534e77ff18$var$i++)$006650534e77ff18$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $006650534e77ff18$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$006650534e77ff18$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $006650534e77ff18$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("27paT", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("lBrF9", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $fba282ec8c4eab24$export$660b2ee2d4fb4eff, (v) => $fba282ec8c4eab24$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $fba282ec8c4eab24$export$7b804a0e0ce836d9, (v) => $fba282ec8c4eab24$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $fba282ec8c4eab24$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $fba282ec8c4eab24$export$7b804a0e0ce836d9;
'use strict';
$fba282ec8c4eab24$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $fba282ec8c4eab24$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$fba282ec8c4eab24$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $fba282ec8c4eab24$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $fba282ec8c4eab24$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("2MLmq", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $2074cd535103ea35$export$660b2ee2d4fb4eff, (v) => $2074cd535103ea35$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $2074cd535103ea35$export$7b804a0e0ce836d9, (v) => $2074cd535103ea35$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2074cd535103ea35$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2074cd535103ea35$export$7b804a0e0ce836d9;
'use strict';
$2074cd535103ea35$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2074cd535103ea35$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$2074cd535103ea35$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2074cd535103ea35$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2074cd535103ea35$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("frx2x", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$isSpace = $lKlAe.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$b3e301ae0b1788b5$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("iUeRh", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$isSpace = $lKlAe.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$dc38fb80f8b4f166$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("ktOwv", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $ee8db4fa9cfd6224$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $ee8db4fa9cfd6224$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($ee8db4fa9cfd6224$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($ee8db4fa9cfd6224$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("1jFGt", function(module, exports) {
// Process html tags
'use strict';

var $1RRsU = parcelRequire("1RRsU");
var $0f57e66455279f49$require$HTML_TAG_RE = $1RRsU.HTML_TAG_RE;
function $0f57e66455279f49$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0f57e66455279f49$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0f57e66455279f49$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0f57e66455279f49$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($0f57e66455279f49$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($0f57e66455279f49$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0f57e66455279f49$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("jd9ks", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7MxGI = parcelRequire("7MxGI");

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$has = $lKlAe.has;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$isValidEntityCode = $lKlAe.isValidEntityCode;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$fromCodePoint = $lKlAe.fromCodePoint;
var $dfc677c78d4d441f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $dfc677c78d4d441f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $dfc677c78d4d441f$require$isValidEntityCode(code) ? $dfc677c78d4d441f$require$fromCodePoint(code) : $dfc677c78d4d441f$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$NAMED_RE);
        if (match) {
            if ($dfc677c78d4d441f$require$has($7MxGI, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $7MxGI[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("ey6sy", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $a979406325d16795$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a979406325d16795$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a979406325d16795$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("hrHpd", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("82i7L", function(module, exports) {
// Inline parser state
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
function $5d9c91befccde6a7$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$5d9c91befccde6a7$var$StateInline.prototype.pushPending = function() {
    var token = new $jwpQf('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$5d9c91befccde6a7$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $jwpQf(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$5d9c91befccde6a7$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(lastChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(nextChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$5d9c91befccde6a7$var$StateInline.prototype.Token = $jwpQf;
module.exports = $5d9c91befccde6a7$var$StateInline;

});


parcelRegister("43kHv", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $2f377ffd6e81380f$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $2f377ffd6e81380f$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $2f377ffd6e81380f$var$isString(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object String]';
}
function $2f377ffd6e81380f$var$isObject(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Object]';
}
function $2f377ffd6e81380f$var$isRegExp(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object RegExp]';
}
function $2f377ffd6e81380f$var$isFunction(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Function]';
}
function $2f377ffd6e81380f$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $2f377ffd6e81380f$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $2f377ffd6e81380f$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $2f377ffd6e81380f$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $2f377ffd6e81380f$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $2f377ffd6e81380f$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $2f377ffd6e81380f$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $2f377ffd6e81380f$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $2f377ffd6e81380f$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $2f377ffd6e81380f$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $2f377ffd6e81380f$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("5GUip"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($2f377ffd6e81380f$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($2f377ffd6e81380f$var$isObject(val)) {
            if ($2f377ffd6e81380f$var$isRegExp(val.validate)) compiled.validate = $2f377ffd6e81380f$var$createValidator(val.validate);
            else if ($2f377ffd6e81380f$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($2f377ffd6e81380f$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $2f377ffd6e81380f$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($2f377ffd6e81380f$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $2f377ffd6e81380f$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($2f377ffd6e81380f$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $2f377ffd6e81380f$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $2f377ffd6e81380f$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $2f377ffd6e81380f$var$createMatch(self, shift) {
    var match = new $2f377ffd6e81380f$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $2f377ffd6e81380f$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $2f377ffd6e81380f$var$LinkifyIt)) return new $2f377ffd6e81380f$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($2f377ffd6e81380f$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $2f377ffd6e81380f$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $2f377ffd6e81380f$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $2f377ffd6e81380f$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $2f377ffd6e81380f$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $2f377ffd6e81380f$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $2f377ffd6e81380f$var$LinkifyIt;

});
parcelRegister("5GUip", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("k7qPZ", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $ea59477c15f361c2$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $ea59477c15f361c2$var$base = 36;
const $ea59477c15f361c2$var$tMin = 1;
const $ea59477c15f361c2$var$tMax = 26;
const $ea59477c15f361c2$var$skew = 38;
const $ea59477c15f361c2$var$damp = 700;
const $ea59477c15f361c2$var$initialBias = 72;
const $ea59477c15f361c2$var$initialN = 128; // 0x80
const $ea59477c15f361c2$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $ea59477c15f361c2$var$regexPunycode = /^xn--/;
const $ea59477c15f361c2$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $ea59477c15f361c2$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $ea59477c15f361c2$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $ea59477c15f361c2$var$baseMinusTMin = $ea59477c15f361c2$var$base - $ea59477c15f361c2$var$tMin;
const $ea59477c15f361c2$var$floor = Math.floor;
const $ea59477c15f361c2$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $ea59477c15f361c2$var$error(type) {
    throw new RangeError($ea59477c15f361c2$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $ea59477c15f361c2$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $ea59477c15f361c2$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($ea59477c15f361c2$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $ea59477c15f361c2$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $ea59477c15f361c2$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $ea59477c15f361c2$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $ea59477c15f361c2$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $ea59477c15f361c2$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $ea59477c15f361c2$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $ea59477c15f361c2$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$damp) : delta >> 1;
    delta += $ea59477c15f361c2$var$floor(delta / numPoints);
    for(; delta > $ea59477c15f361c2$var$baseMinusTMin * $ea59477c15f361c2$var$tMax >> 1; k += $ea59477c15f361c2$var$base)delta = $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$baseMinusTMin);
    return $ea59477c15f361c2$var$floor(k + ($ea59477c15f361c2$var$baseMinusTMin + 1) * delta / (delta + $ea59477c15f361c2$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $ea59477c15f361c2$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $ea59477c15f361c2$var$initialN;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($ea59477c15f361c2$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $ea59477c15f361c2$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
            if (index >= inputLength) $ea59477c15f361c2$var$error('invalid-input');
            const digit = $ea59477c15f361c2$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $ea59477c15f361c2$var$base) $ea59477c15f361c2$var$error('invalid-input');
            if (digit > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - i) / w)) $ea59477c15f361c2$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $ea59477c15f361c2$var$base - t;
            if (w > $ea59477c15f361c2$var$floor($ea59477c15f361c2$var$maxInt / baseMinusT)) $ea59477c15f361c2$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $ea59477c15f361c2$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($ea59477c15f361c2$var$floor(i / out) > $ea59477c15f361c2$var$maxInt - n) $ea59477c15f361c2$var$error('overflow');
        n += $ea59477c15f361c2$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $ea59477c15f361c2$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $ea59477c15f361c2$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $ea59477c15f361c2$var$initialN;
    let delta = 0;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($ea59477c15f361c2$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($ea59477c15f361c2$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $ea59477c15f361c2$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - delta) / handledCPCountPlusOne)) $ea59477c15f361c2$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $ea59477c15f361c2$var$maxInt) $ea59477c15f361c2$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
                    const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $ea59477c15f361c2$var$base - t;
                    output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $ea59477c15f361c2$var$floor(qMinusT / baseMinusT);
                }
                output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(q, 0)));
                bias = $ea59477c15f361c2$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $ea59477c15f361c2$var$toUnicode = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexPunycode.test(string) ? $ea59477c15f361c2$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $ea59477c15f361c2$var$toASCII = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexNonASCII.test(string) ? 'xn--' + $ea59477c15f361c2$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $ea59477c15f361c2$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $ea59477c15f361c2$var$ucs2decode,
        'encode': $ea59477c15f361c2$var$ucs2encode
    },
    'decode': $ea59477c15f361c2$var$decode,
    'encode': $ea59477c15f361c2$var$encode,
    'toASCII': $ea59477c15f361c2$var$toASCII,
    'toUnicode': $ea59477c15f361c2$var$toUnicode
};
module.exports = $ea59477c15f361c2$var$punycode;

});

parcelRegister("gcpUf", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("hbvGf", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("8Ubo6", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("h4jau", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58a68bc6bfddc85$export$2e2bcd8739ae039);
/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $b58a68bc6bfddc85$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $b58a68bc6bfddc85$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $b58a68bc6bfddc85$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $b58a68bc6bfddc85$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $b58a68bc6bfddc85$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("2Suqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $89029a8bda2c5b4f$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $e2gHg = parcelRequire("e2gHg");

var $iZOJ9 = parcelRequire("iZOJ9");

var $dPSMN = parcelRequire("dPSMN");
var $gOwky = parcelRequire("gOwky");
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89029a8bda2c5b4f$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $89029a8bda2c5b4f$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $89029a8bda2c5b4f$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89029a8bda2c5b4f$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($89029a8bda2c5b4f$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($89029a8bda2c5b4f$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $iZOJ9.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $gOwky.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $dPSMN.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $dPSMN.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $89029a8bda2c5b4f$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$89029a8bda2c5b4f$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $89029a8bda2c5b4f$var$linkify);

});

parcelRegister("3KuZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $abad1ea2bea26d97$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $abad1ea2bea26d97$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$abad1ea2bea26d97$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $abad1ea2bea26d97$var$newline);

});

parcelRegister("igwks", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5de6df8c35efad$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fc5de6df8c35efad$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$fc5de6df8c35efad$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $fc5de6df8c35efad$var$paragraph);

});



parcelRegister("jPPkn", function(module, exports) {

$parcel$export(module.exports, "appearanceForNodeType", () => $1c520dfb9f5395c7$export$71376de76fa352d1);
$parcel$export(module.exports, "selectedCardAppearance", () => $1c520dfb9f5395c7$export$a5ff7aecd33e6813);
$parcel$export(module.exports, "titleUrlPairFromNode", () => $1c520dfb9f5395c7$export$15bc29504ff06986);
$parcel$export(module.exports, "displayInfoForCard", () => $1c520dfb9f5395c7$export$a6fcef6250c64f76);
$parcel$export(module.exports, "findCardInfo", () => $1c520dfb9f5395c7$export$f3f2332ef0853029);
$parcel$export(module.exports, "isEmbedSupportedAtPosition", () => $1c520dfb9f5395c7$export$b31d21baab1bb9f);
$parcel$export(module.exports, "isBlockSupportedAtPosition", () => $1c520dfb9f5395c7$export$290208dc31723a19);
$parcel$export(module.exports, "getResolvedAttributesFromStore", () => $1c520dfb9f5395c7$export$a0e5429851d8d8a9);
$parcel$export(module.exports, "isDatasourceConfigEditable", () => $1c520dfb9f5395c7$export$c677d64dd26b7aa2);
$parcel$export(module.exports, "isDatasourceNode", () => $1c520dfb9f5395c7$export$962cfe99b8da8614);
$parcel$export(module.exports, "focusEditorView", () => $1c520dfb9f5395c7$export$bab6ff782a349bd3);
$parcel$export(module.exports, "getAwarenessProps", () => $1c520dfb9f5395c7$export$ea8b03e32bcc0b2d);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $ffYTp = parcelRequire("ffYTp");

var $lX6w0 = parcelRequire("lX6w0");
var $f980L = parcelRequire("f980L");
var $7mvwv = parcelRequire("7mvwv");

var $lumM0 = parcelRequire("lumM0");
const $1c520dfb9f5395c7$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $1c520dfb9f5395c7$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $gZGBX.NodeSelection)) return $1c520dfb9f5395c7$export$71376de76fa352d1(state.selection.node.type);
};
const $1c520dfb9f5395c7$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $1c520dfb9f5395c7$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $1c520dfb9f5395c7$export$a6fcef6250c64f76 = (node, info)=>$1c520dfb9f5395c7$export$fe497395c317d106($1c520dfb9f5395c7$export$15bc29504ff06986(node), info);
const $1c520dfb9f5395c7$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $lumM0.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $1c520dfb9f5395c7$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $1c520dfb9f5395c7$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$1c520dfb9f5395c7$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $kCV8T.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $1c520dfb9f5395c7$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$1c520dfb9f5395c7$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $kCV8T.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $1c520dfb9f5395c7$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $ffYTp.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $1c520dfb9f5395c7$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $7mvwv.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $lX6w0.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $f980L.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $1c520dfb9f5395c7$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $1c520dfb9f5395c7$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $1c520dfb9f5395c7$export$48ba7bd006cffb5e(node.attrs);
};
const $1c520dfb9f5395c7$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $1c520dfb9f5395c7$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $1c520dfb9f5395c7$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $1c520dfb9f5395c7$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $gZGBX.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");

var $VSDnB = parcelRequire("VSDnB");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});




parcelRegister("ie3zK", function(module, exports) {

$parcel$export(module.exports, "cardKeymap", () => $8139e78644d8ae86$export$fc7a7a088775f35d);

var $gE8f9 = parcelRequire("gE8f9");

var $e9qoo = parcelRequire("e9qoo");

var $vWFRY = parcelRequire("vWFRY");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");
const $8139e78644d8ae86$var$lookupPixel = 10;
const $8139e78644d8ae86$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $5r0mK.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $8139e78644d8ae86$var$lookupPixel : coord.bottom + $8139e78644d8ae86$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $5r0mK.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $8139e78644d8ae86$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $8139e78644d8ae86$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $gZGBX.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $8139e78644d8ae86$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if ((0, $gE8f9.browser).chrome && (0, $gE8f9.browser).chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveUp).common, $8139e78644d8ae86$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveDown).common, $8139e78644d8ae86$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $vWFRY.keymap)(list);
}

});

parcelRegister("kfdsX", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0267f0ce05faa855$export$ae829ec7b2625219);

var $7nRxN = parcelRequire("7nRxN");

var $5BVRS = parcelRequire("5BVRS");

var $5KWxh = parcelRequire("5KWxh");

var $kRXi9 = parcelRequire("kRXi9");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");


var $VSDnB = parcelRequire("VSDnB");

var $2CVDy = parcelRequire("2CVDy");

var $ivF3y = parcelRequire("ivF3y");

var $6YTYp = parcelRequire("6YTYp");

var $N3kru = parcelRequire("N3kru");

var $lPHrh = parcelRequire("lPHrh");

var $h162L = parcelRequire("h162L");

var $6fJce = parcelRequire("6fJce");

var $nYpqR = parcelRequire("nYpqR");

var $lumM0 = parcelRequire("lumM0");

var $bYyIW = parcelRequire("bYyIW");

var $jhHFS = parcelRequire("jhHFS");

var $gBr25 = parcelRequire("gBr25");

var $jPPkn = parcelRequire("jPPkn");
const $0267f0ce05faa855$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
const $0267f0ce05faa855$export$ee666af8a9b19e18 = 'card-plugin-element-allow-events';
const $0267f0ce05faa855$export$7ae4cd3a66c1e050 = (event)=>{
    if (!(0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages')) return false;
    const target = event.target;
    // Stop events from propogating to prose-mirror and selecting the node and/or
    // opening the toolbar, unless a parent of the target has a defined className
    if (target instanceof HTMLElement && target.closest(`.${$0267f0ce05faa855$export$ee666af8a9b19e18}`)) return false;
    return true;
};
const $0267f0ce05faa855$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $gBr25.getPluginState)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $nYpqR.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $0267f0ce05faa855$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, __livePage: // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage, isPageSSRed: isPageSSRed } = options;
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $5BVRS.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $2CVDy.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                __livePage: __livePage,
                isPageSSRed: isPageSSRed
            },
            ...__livePage && (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') && {
                extraNodeViewProps: {
                    stopEvent: $0267f0ce05faa855$export$7ae4cd3a66c1e050
                }
            }
        });
        return new (0, $5KWxh.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $gBr25.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $lumM0.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $lPHrh.eventsFromTransaction)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $gZGBX.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    if (!enableInlineUpgradeFeatures) return (0, $bYyIW.default)(pluginStateWithUpdatedPos, meta);
                    const newState = (0, $bYyIW.default)(pluginStateWithUpdatedPos, meta);
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $6fJce.isLocalStorageKeyDiscovered)($0267f0ce05faa855$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $jPPkn.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $jPPkn.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $jhHFS.handleProvider)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $gBr25.getPluginState)(view.state);
                        const oldState = (0, $gBr25.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $gZGBX.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $5r0mK.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $kRXi9.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $h162L.isDatasourceTableLayout)(node.attrs.layout) ? node.attrs.layout : (0, $44fe84ed19a5b32b$export$60efea3f80310017);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $nYpqR.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $nYpqR.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $gBr25.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $7nRxN.default)(()=>(0, $jhHFS.resolveWithProvider)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $N3kru.lazyInlineCardView)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $ivF3y.lazyBlockCardView)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer
                    }),
                    embedCard: (0, $6YTYp.lazyEmbedCardView)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $0267f0ce05faa855$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $0267f0ce05faa855$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $lumM0.pluginKey)
        });
    };

});
const $44fe84ed19a5b32b$export$85183a312807388d = 'media';
const $44fe84ed19a5b32b$export$60efea3f80310017 = 'wide';

parcelRegister("2CVDy", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $e51ccbda25c2841e$export$aff6291803939b05);
$parcel$export(module.exports, "InlineCardNodeView", () => $e51ccbda25c2841e$export$2626b4e17577ac62);
$parcel$export(module.exports, "inlineCardNodeView", () => $e51ccbda25c2841e$export$ebfb9e1798b8aa0e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");

var $bXrHm = parcelRequire("bXrHm");

var $awTmI = parcelRequire("awTmI");

var $dtBvX = parcelRequire("dtBvX");

var $f3dKD = parcelRequire("f3dKD");
var $9kpKZ = parcelRequire("9kpKZ");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $kVZJG = parcelRequire("kVZJG");

var $0Tx5e = parcelRequire("0Tx5e");

var $gmhCD = parcelRequire("gmhCD");

var $nYpqR = parcelRequire("nYpqR");

var $jPPkn = parcelRequire("jPPkn");

var $5xe9f = parcelRequire("5xe9f");

var $jdDDq = parcelRequire("jdDDq");

var $vNpIX = parcelRequire("vNpIX");
const $e51ccbda25c2841e$export$aff6291803939b05 = /*#__PURE__*/ (0, $5uXOq.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: onClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed })=>{
    const { url: url, data: data } = node.attrs;
    const refId = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    (0, $5uXOq.useEffect)(()=>{
        const id = refId.current;
        return ()=>{
            if ((0, $VSDnB.fg)('platform_editor_fix_card_plugin_state')) {
                const { tr: tr } = view.state;
                (0, $nYpqR.removeCard)({
                    id: id
                })(tr);
                view.dispatch(tr);
            }
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $5uXOq.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $f3dKD.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $5uXOq.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $7nRxN.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $nYpqR.registerCard)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $5uXOq.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const card = (0, $5uXOq.useMemo)(()=>{
        if (isPageSSRed && url && (0, $VSDnB.fg)('platform_ssr_smartlinks_editor')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0Tx5e.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions
        }, url);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kVZJG.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $2OMIu.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});
const $e51ccbda25c2841e$var$WrappedInlineCardWithAwareness = (0, $jdDDq.Card)((0, $vNpIX.InlineCardWithAwareness), (0, $9kpKZ.default));
const $e51ccbda25c2841e$var$WrappedInlineCard = (0, $jdDDq.Card)($e51ccbda25c2841e$export$aff6291803939b05, (0, $9kpKZ.default));
function $e51ccbda25c2841e$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, __livePage: __livePage, isPageSSRed: isPageSSRed } = props;
    const [isOverlayHovered, setIsOverlayHovered] = (0, $5uXOq.useState)(false);
    const { editorViewModeState: editorViewModeState, selectionState: selectionState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ]);
    const floatingToolbarNode = selectionState?.selection instanceof (0, $gZGBX.NodeSelection) && selectionState?.selection.node;
    if (__livePage && (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages')) {
        const showHoverPreview = floatingToolbarNode !== node;
        const livePagesHoverCardFadeInDelay = 800;
        const inlineCard = /*#__PURE__*/ (0, $2OMIu.jsx)($e51ccbda25c2841e$var$WrappedInlineCard, {
            isHovered: isOverlayHovered,
            node: node,
            view: view,
            getPos: getPos,
            actionOptions: actionOptions,
            useAlternativePreloader: useAlternativePreloader,
            onClickCallback: onClickCallback,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: {
                fadeInDelay: livePagesHoverCardFadeInDelay
            },
            isPageSSRed: isPageSSRed
        });
        return editorViewModeState?.mode === 'view' ? inlineCard : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5xe9f.default), {
            targetElementPos: getPos(),
            view: view,
            isHoveredCallback: setIsOverlayHovered,
            onOpenLinkClick: (event)=>{
                (0, $dtBvX.handleNavigation)({
                    fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                    onClickCallback: onClickCallback,
                    url: node.attrs.url,
                    event: event
                });
            },
            children: inlineCard
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e51ccbda25c2841e$var$WrappedInlineCardWithAwareness, {
        node: node,
        view: view,
        getPos: getPos,
        actionOptions: actionOptions,
        useAlternativePreloader: useAlternativePreloader,
        pluginInjectionApi: pluginInjectionApi,
        onClickCallback: onClickCallback,
        isPageSSRed: isPageSSRed,
        appearance: "inline",
        ...enableInlineUpgradeFeatures && (0, $jPPkn.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, !(0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control') ? true : editorViewModeState?.mode === 'view')
    });
}
const $e51ccbda25c2841e$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };

});
parcelRegister("dtBvX", function(module, exports) {

$parcel$export(module.exports, "handleNavigation", () => $e982cde5a43f97c0$export$706ad1af8096e280);

var $gkwXh = parcelRequire("gkwXh");
var $hETfp = parcelRequire("hETfp");
function $e982cde5a43f97c0$export$706ad1af8096e280({ url: url, event: event, onClickCallback: onClickCallback, fireAnalyticsEvent: fireAnalyticsEvent }) {
    if (fireAnalyticsEvent) fireAnalyticsEvent({
        action: (0, $gkwXh.ACTION).VISITED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            platform: (0, $hETfp.PLATFORMS).WEB,
            mode: (0, $hETfp.MODE).EDITOR
        }
    });
    if (url) {
        try {
            onClickCallback?.({
                event: event,
                url: url
            });
        } catch  {}
        /**
		 * Links should navigate by default in live pages if:
		 * - the link is the direct target of the click event
		 * - default handling wasn't prevented with `event.preventDefault()`
		 */ if (!event.defaultPrevented) window.location.href = url;
    }
}

});

parcelRegister("kVZJG", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc8afc0c39cee453$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $fzJZi = parcelRequire("fzJZi");

var $lpxJ1 = parcelRequire("lpxJ1");
class $fc8afc0c39cee453$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lpxJ1.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: content
        });
    }
}
const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, $994MI.default)((0, $fzJZi.context))((0, $cb25w.default)()((0, $8RXs9.default)($fc8afc0c39cee453$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("lpxJ1", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $422a0598dbbdc42a$export$e00a7788e30dc998);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $kxcRq = parcelRequire("kxcRq");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $i41Ob = parcelRequire("i41Ob");

const $422a0598dbbdc42a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $kxcRq.importWithRetry)(()=>(parcelRequire("5HNFf"))));
function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $5vDFA.clearMarks)(id);
            (0, $5vDFA.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined);
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($422a0598dbbdc42a$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $c53851cced73411d$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("6q8Pr"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("55TA3"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("2Bgv8")))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("2Bgv8")))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("bwXIZ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("h7zk4")))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("h7zk4")))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("6SoQO"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("3VL73"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("eogSM"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("gmDdF"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>Promise.resolve((parcelRequire("7BHMh")))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>Promise.resolve((parcelRequire("7BHMh")))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("4WgJk"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("fjtI4"))
    ]
};


























































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("6ftoN"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("a0Blm"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("3vtQf")))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("jJcF3"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("3vtQf")))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("eT6gz"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("gVXQp")))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("9bx9i")))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("3K7kY"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("ckyDP")))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("5mR3i")))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>(parcelRequire("23MsP"))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("4m4MY")),
            large: ()=>(parcelRequire("6jkTx"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("gmDdF")),
            large: ()=>Promise.resolve((parcelRequire("dGYEZ")))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("eogSM")),
            large: ()=>Promise.resolve((parcelRequire("RiK2l")))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("6q8Pr")),
            large: ()=>Promise.resolve((parcelRequire("iBOon")))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("3VL73")),
            large: ()=>Promise.resolve((parcelRequire("jdlqN")))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("bwXIZ")),
            large: ()=>Promise.resolve((parcelRequire("c70Lr")))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("6SoQO")),
            large: ()=>Promise.resolve((parcelRequire("2osAJ")))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8vv4H")),
            large: ()=>Promise.resolve((parcelRequire("7zjHG")))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("TZHl8")),
            large: ()=>Promise.resolve((parcelRequire("cHwqN")))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("e3PhT")),
            large: ()=>Promise.resolve((parcelRequire("2sfBf")))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("55TA3")),
            large: ()=>Promise.resolve((parcelRequire("2tm8x")))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("4WgJk")),
            large: ()=>Promise.resolve((parcelRequire("iABw2")))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("4sBeG"))),
            large: ()=>(parcelRequire("4rggH"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("bPjbr"))),
            large: ()=>(parcelRequire("2nXLN"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("6qWjs"))),
            large: ()=>(parcelRequire("d4Msz"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("ezu4w"))),
            large: ()=>(parcelRequire("4Z42j"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("iAkpb"))),
            large: ()=>(parcelRequire("9LCHw"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("jnURg"))),
            large: ()=>(parcelRequire("tyrb0"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("gAdQO"))),
            large: ()=>(parcelRequire("fwsJh"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("6ClRv"))),
            large: ()=>(parcelRequire("2EQdA"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("1ni2E"))),
            large: ()=>(parcelRequire("7GCAt"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("kQSMP"))),
            large: ()=>(parcelRequire("akYbd"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("kvhCa"))),
            large: ()=>(parcelRequire("fuaYA"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dvo9I"))),
            large: ()=>(parcelRequire("5sJWF"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("ercGv"))),
            large: ()=>(parcelRequire("gQ4Nj"))
        },
        // Confluence icons
        [(0, $8dVIb.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("4Atwu"))),
            large: ()=>Promise.resolve((parcelRequire("8lQ8Y")))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $8dVIb.IconType).Attachment]: {
            default: ()=>(parcelRequire("fkmri"))
        },
        [(0, $8dVIb.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("f5h6d")))
        },
        [(0, $8dVIb.IconType).Component]: {
            default: ()=>(parcelRequire("hYqnc"))
        },
        [(0, $8dVIb.IconType).Comment]: {
            default: ()=>(parcelRequire("jAQ3K"))
        },
        [(0, $8dVIb.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("6N55R")))
        },
        [(0, $8dVIb.IconType).React]: {
            default: ()=>(parcelRequire("7nuvV"))
        },
        [(0, $8dVIb.IconType).Vote]: {
            default: ()=>(parcelRequire("hFsYk"))
        },
        [(0, $8dVIb.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("gMDFI"))
        },
        [(0, $8dVIb.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("4fkVg"))
        },
        [(0, $8dVIb.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("fgN6p"))
        },
        [(0, $8dVIb.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("cV2N9"))
        },
        [(0, $8dVIb.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("eVavM"))
        },
        [(0, $8dVIb.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("56RVo"))
        },
        [(0, $8dVIb.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("ktXnL"))
        },
        [(0, $8dVIb.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("9mM5H"))
        },
        [(0, $8dVIb.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("1O0Re"))
        },
        [(0, $8dVIb.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("lGGho"))
        },
        [(0, $8dVIb.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("2LtoJ"))
        },
        [(0, $8dVIb.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("lE2nX"))
        },
        [(0, $8dVIb.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("4hqZ5")))
        },
        [(0, $8dVIb.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("dWKdk"))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);

});
parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("6q8Pr", function(module, exports) {

let $4acc04fa6828837e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4acc04fa6828837e$var$load("7EgS6").then(()=>parcelRequire('3KifV'));

});

parcelRegister("e3PhT", function(module, exports) {

let $a3c92121ff44871f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3c92121ff44871f$var$load("erQ4S").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("55TA3", function(module, exports) {

let $3b5888855c97ba42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b5888855c97ba42$var$load("d767x").then(()=>parcelRequire('5m93C'));

});

parcelRegister("bwXIZ", function(module, exports) {

let $865102f672a4212f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865102f672a4212f$var$load("izomc").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("8vv4H", function(module, exports) {

let $631952ccff1c149a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $631952ccff1c149a$var$load("5I4RC").then(()=>parcelRequire('eABwY'));

});

parcelRegister("6SoQO", function(module, exports) {

let $501b100cfa76ff8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501b100cfa76ff8e$var$load("jepjM").then(()=>parcelRequire('F35X1'));

});

parcelRegister("TZHl8", function(module, exports) {

let $0a84ff1cb84378c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a84ff1cb84378c5$var$load("3YI2r").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("3VL73", function(module, exports) {

let $2dcb3d9afd9c957a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2dcb3d9afd9c957a$var$load("cwkUf").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("ifmtc", function(module, exports) {

let $d48b0ecc93ef9e55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d48b0ecc93ef9e55$var$load("hVGrh").then(()=>parcelRequire('daL8e'));

});

parcelRegister("eogSM", function(module, exports) {

let $a7a0671937c9e1f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7a0671937c9e1f3$var$load("aAton").then(()=>parcelRequire('96Idm'));

});

parcelRegister("5nV2R", function(module, exports) {

let $3ebb59b9b44ae7f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ebb59b9b44ae7f7$var$load("iDnD4").then(()=>parcelRequire('dOkKo'));

});

parcelRegister("6Y2WT", function(module, exports) {

let $512aa2425db43ab6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $512aa2425db43ab6$var$load("dhQt8").then(()=>parcelRequire('lDRqn'));

});

parcelRegister("4m4MY", function(module, exports) {

let $32bcee7caa856311$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32bcee7caa856311$var$load("7QDLp").then(()=>parcelRequire('8njZH'));

});

parcelRegister("gmDdF", function(module, exports) {

let $be9d1f90638c1db6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be9d1f90638c1db6$var$load("b2yZA").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("coOzc", function(module, exports) {

let $906ef36933b15f5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $906ef36933b15f5b$var$load("5khw4").then(()=>parcelRequire('6cEsd'));

});

parcelRegister("4WgJk", function(module, exports) {

let $39898e76c9d3a3c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39898e76c9d3a3c2$var$load("a5lMy").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("fjtI4", function(module, exports) {

let $b25fad1f7947bb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b25fad1f7947bb8b$var$load("gaqBx").then(()=>parcelRequire('bBHpS'));

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, (/*@__PURE__*/$parcel$interopDefault($duwKf))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props
            })
        });
    };
};

});


parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});



parcelRegister("6ftoN", function(module, exports) {

let $48caf2cb3a2b031c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48caf2cb3a2b031c$var$load("4AlWm").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("a0Blm", function(module, exports) {

let $7496df20f241cc20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7496df20f241cc20$var$load("1oL5z").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("jJcF3", function(module, exports) {

let $e5cc0a8e109344ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e5cc0a8e109344ba$var$load("h2MrD"),
    $e5cc0a8e109344ba$var$load("bYT2S"),
    $e5cc0a8e109344ba$var$load("947Ze")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("eT6gz", function(module, exports) {

let $ad6b101988e539b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad6b101988e539b4$var$load("9Rmva").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("3K7kY", function(module, exports) {

let $2b9b5c0158d75df8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b9b5c0158d75df8$var$load("4OyEJ").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("23MsP", function(module, exports) {

let $180174885bfd768b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $180174885bfd768b$var$load("b4dsH").then(()=>parcelRequire('a8hd9'));

});

parcelRegister("6jkTx", function(module, exports) {

let $4984b9ac5dd985b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4984b9ac5dd985b2$var$load("9HbdP").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("4rggH", function(module, exports) {

let $33b64d92455eac54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33b64d92455eac54$var$load("g985s").then(()=>parcelRequire('l04jD'));

});

parcelRegister("2nXLN", function(module, exports) {

let $1bcc17d3fb7fe2fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bcc17d3fb7fe2fd$var$load("16ic3").then(()=>parcelRequire('52A0r'));

});

parcelRegister("d4Msz", function(module, exports) {

let $98513d3325793783$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98513d3325793783$var$load("gvHhR").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("4Z42j", function(module, exports) {

let $3a0ffd720a4a477e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a0ffd720a4a477e$var$load("1NHTB").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("9LCHw", function(module, exports) {

let $71c6860eabfcf304$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71c6860eabfcf304$var$load("9PpGe").then(()=>parcelRequire('41M8N'));

});

parcelRegister("tyrb0", function(module, exports) {

let $058d6c15a4a2e74c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $058d6c15a4a2e74c$var$load("bSBaJ").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("fwsJh", function(module, exports) {

let $b4d021375f2ba907$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4d021375f2ba907$var$load("3w7tM").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("2EQdA", function(module, exports) {

let $1ef7d29d585441a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ef7d29d585441a3$var$load("hdkrH").then(()=>parcelRequire('529Ow'));

});

parcelRegister("7GCAt", function(module, exports) {

let $598a634b3bebd565$var$load = (parcelRequire("28QjX"))(4);
module.exports = $598a634b3bebd565$var$load("fcEu0").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("akYbd", function(module, exports) {

let $786a741696fc3955$var$load = (parcelRequire("28QjX"))(4);
module.exports = $786a741696fc3955$var$load("2nFSk").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("fuaYA", function(module, exports) {

let $b4622c006adc733a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4622c006adc733a$var$load("cVndS").then(()=>parcelRequire('21nCU'));

});

parcelRegister("5sJWF", function(module, exports) {

let $3fa33507f5ae198f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fa33507f5ae198f$var$load("hYBCI").then(()=>parcelRequire('93zHH'));

});

parcelRegister("gQ4Nj", function(module, exports) {

let $c42538c02c4bc2c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c42538c02c4bc2c7$var$load("bG6hF").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});


parcelRegister("8lQ8Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $40d9c5b900864dd9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $25dv3 = parcelRequire("25dv3");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $40d9c5b900864dd9$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
        label: label,
        testId: testId
    });
};
$40d9c5b900864dd9$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $40d9c5b900864dd9$export$2e2bcd8739ae039 = $40d9c5b900864dd9$var$PageLiveDoc24Icon;

});
parcelRegister("25dv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b5ea63b1e20da2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $23b5ea63b1e20da2$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$23b5ea63b1e20da2$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$23b5ea63b1e20da2$export$2e2bcd8739ae039 = $23b5ea63b1e20da2$var$PageLiveDoc24Icon;

});


parcelRegister("fkmri", function(module, exports) {

let $b28a214429ff684e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b28a214429ff684e$var$load("4JCpI").then(()=>parcelRequire('eZ9Cp'));

});

parcelRegister("hYqnc", function(module, exports) {

let $d15c7f7145939d3d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d15c7f7145939d3d$var$load("945OG").then(()=>parcelRequire('biU84'));

});

parcelRegister("jAQ3K", function(module, exports) {

let $e439c306ecaf2b13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e439c306ecaf2b13$var$load("jfejx").then(()=>parcelRequire('729P0'));

});

parcelRegister("7nuvV", function(module, exports) {

let $55f259d0aa4b0aae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55f259d0aa4b0aae$var$load("5xN5V").then(()=>parcelRequire('3xPiH'));

});

parcelRegister("hFsYk", function(module, exports) {

let $cdccbd4229e64354$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cdccbd4229e64354$var$load("fRQeP").then(()=>parcelRequire('9j532'));

});

parcelRegister("gMDFI", function(module, exports) {

let $c37fe70f109b78ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c37fe70f109b78ee$var$load("2JrEQ").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("4fkVg", function(module, exports) {

let $3178caf18816bb57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3178caf18816bb57$var$load("czPXX").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("fgN6p", function(module, exports) {

let $b1de7052f50bfcad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1de7052f50bfcad$var$load("bW2Ht").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("cV2N9", function(module, exports) {

let $967cf94be8e9a9d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $967cf94be8e9a9d5$var$load("jlDVs").then(()=>parcelRequire('Le10t'));

});

parcelRegister("eVavM", function(module, exports) {

let $adce8af64095102c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adce8af64095102c$var$load("9n8Rc").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("56RVo", function(module, exports) {

let $3b87579a8c1c9c89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b87579a8c1c9c89$var$load("a0ALI").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("ktXnL", function(module, exports) {

let $ee94942a5dcf51e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee94942a5dcf51e4$var$load("kFjg9").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("9mM5H", function(module, exports) {

let $6d1b79007a44e718$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1b79007a44e718$var$load("50gXn").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("1O0Re", function(module, exports) {

let $150b203f6494e0b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $150b203f6494e0b7$var$load("1Bya1").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("lGGho", function(module, exports) {

let $fc9e510f6e16a672$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc9e510f6e16a672$var$load("6xK7c").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("2LtoJ", function(module, exports) {

let $2036c66122d65aa9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2036c66122d65aa9$var$load("h2MrD"),
    $2036c66122d65aa9$var$load("bYT2S"),
    $2036c66122d65aa9$var$load("2ZGIQ")
]).then(()=>parcelRequire('2CRmv'));

});

parcelRegister("lE2nX", function(module, exports) {

let $fc1f2f1d241904fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc1f2f1d241904fb$var$load("kXqCi").then(()=>parcelRequire('2ciBJ'));

});

parcelRegister("dWKdk", function(module, exports) {

let $a2748a45fd722a7d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2748a45fd722a7d$var$load("gPQs2").then(()=>parcelRequire('2lRM4'));

});


parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});


parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $f30ba994fabdf720$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
        ...props,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $b8eaafd3e75b73f4$var$actionGroupStylesOld = null;
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    css: size === (0, $8dVIb.SmartLinkSize).XLarge && $b8eaafd3e75b73f4$var$actionGroupStyles
                } : {
                    css: size === (0, $8dVIb.SmartLinkSize).XLarge && $b8eaafd3e75b73f4$var$actionGroupStylesOld
                },
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;

});
parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("kDhrr")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("9sP91")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $kDhrr = parcelRequire("kDhrr");

var $kp8aU = parcelRequire("kp8aU");

var $9sP91 = parcelRequire("9sP91");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $9sP91 = parcelRequire("9sP91");

var $9tslm = parcelRequire("9tslm");

var $4ZXUA = parcelRequire("4ZXUA");

var $7IZqM = parcelRequire("7IZqM");

var $bWpL0 = parcelRequire("bWpL0");

var $aWyvu = parcelRequire("aWyvu");

var $3dV67 = parcelRequire("3dV67");

var $cJxXG = parcelRequire("cJxXG");

var $77cM6 = parcelRequire("77cM6");

var $k39kU = parcelRequire("k39kU");
const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: {
        component: (0, $9sP91.default),
        props: {
            icon: (0, $8dVIb.IconType).Component
        }
    },
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        }
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        }
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        }
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        }
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        }
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        }
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        }
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $aWyvu.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $77cM6.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        }
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        }
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        }
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $9tslm.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $3dV67.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $3dV67.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        }
    }
};
const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AppliedToComponentsCount:
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return $3c92d860530d8c8b$var$toBadgeProps(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return $3c92d860530d8c8b$var$toTextProps(data);
        case (0, $8dVIb.ElementName).Title:
            return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $3c92d860530d8c8b$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("9sP91", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e693987bf1cd254$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7IZqM = parcelRequire("7IZqM");
const $5e693987bf1cd254$var$AppliedToComponentsCount = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $7zaVw.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7IZqM.default), {
        icon: (0, $8dVIb.IconType).Component,
        label: label,
        ...props
    });
};
var $5e693987bf1cd254$export$2e2bcd8739ae039 = $5e693987bf1cd254$var$AppliedToComponentsCount;

});
parcelRegister("7IZqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9f19acb0d3ec1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
const $aab9f19acb0d3ec1$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $aab9f19acb0d3ec1$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $aab9f19acb0d3ec1$var$badgeStyles = null;
const $aab9f19acb0d3ec1$var$iconStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $aab9f19acb0d3ec1$var$labelStylesOld = null;
const $aab9f19acb0d3ec1$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url }, ref)=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            $aab9f19acb0d3ec1$var$styles.container,
            $aab9f19acb0d3ec1$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                xcss: $aab9f19acb0d3ec1$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $aab9f19acb0d3ec1$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(Badge);
const $aab9f19acb0d3ec1$var$BadgeRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($aab9f19acb0d3ec1$var$BadgeRefreshNew);
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8dcr7 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
const $aab9f19acb0d3ec1$var$Badge = (props)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeRefreshNewWithOverrideCss, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeCompiledNew, {
        ...props
    });
};
var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;

});
parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $duwKf = parcelRequire("duwKf");

var $iRZQl = parcelRequire("iRZQl");

var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");

var $VSDnB = parcelRequire("VSDnB");


var $dVpJZ = parcelRequire("dVpJZ");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");





























































// prettier-ignore
const $1647af7fe5459c6c$var$importIconMapperOld = {
    [(0, $8dVIb.IconType).Archive]: ()=>(parcelRequire("4m4MY")),
    [(0, $8dVIb.IconType).Audio]: ()=>(parcelRequire("5nV2R")),
    [(0, $8dVIb.IconType).Code]: ()=>(parcelRequire("coOzc")),
    [(0, $8dVIb.IconType).Executable]: ()=>(parcelRequire("gmDdF")),
    [(0, $8dVIb.IconType).File]: ()=>Promise.resolve((parcelRequire("7BHMh"))),
    [(0, $8dVIb.IconType).Folder]: ()=>(parcelRequire("fjtI4")),
    [(0, $8dVIb.IconType).Generic]: ()=>Promise.resolve((parcelRequire("7BHMh"))),
    [(0, $8dVIb.IconType).GIF]: ()=>(parcelRequire("eogSM")),
    [(0, $8dVIb.IconType).GoogleDocs]: ()=>(parcelRequire("6q8Pr")),
    [(0, $8dVIb.IconType).GoogleForms]: ()=>(parcelRequire("3VL73")),
    [(0, $8dVIb.IconType).GoogleSheets]: ()=>(parcelRequire("bwXIZ")),
    [(0, $8dVIb.IconType).GoogleSlides]: ()=>(parcelRequire("6SoQO")),
    [(0, $8dVIb.IconType).Image]: ()=>(parcelRequire("ifmtc")),
    [(0, $8dVIb.IconType).MSExcel]: ()=>(parcelRequire("8vv4H")),
    [(0, $8dVIb.IconType).MSPowerpoint]: ()=>(parcelRequire("TZHl8")),
    [(0, $8dVIb.IconType).MSWord]: ()=>(parcelRequire("e3PhT")),
    [(0, $8dVIb.IconType).PDF]: ()=>(parcelRequire("55TA3")),
    [(0, $8dVIb.IconType).Presentation]: ()=>Promise.resolve((parcelRequire("h7zk4"))),
    [(0, $8dVIb.IconType).Sketch]: ()=>(parcelRequire("4WgJk")),
    [(0, $8dVIb.IconType).Spreadsheet]: ()=>Promise.resolve((parcelRequire("2Bgv8"))),
    [(0, $8dVIb.IconType).Template]: ()=>Promise.resolve((parcelRequire("53J27"))),
    [(0, $8dVIb.IconType).Video]: ()=>(parcelRequire("6Y2WT")),
    // Bitbucket icons
    [(0, $8dVIb.IconType).Branch]: ()=>Promise.resolve((parcelRequire("4sBeG"))),
    [(0, $8dVIb.IconType).Commit]: ()=>Promise.resolve((parcelRequire("bPjbr"))),
    [(0, $8dVIb.IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
    [(0, $8dVIb.IconType).PullRequest]: ()=>Promise.resolve((parcelRequire("6qWjs"))),
    [(0, $8dVIb.IconType).Repo]: ()=>Promise.resolve((parcelRequire("ezu4w"))),
    // Jira icons
    [(0, $8dVIb.IconType).Bug]: ()=>Promise.resolve((parcelRequire("iAkpb"))),
    [(0, $8dVIb.IconType).Change]: ()=>Promise.resolve((parcelRequire("jnURg"))),
    [(0, $8dVIb.IconType).Epic]: ()=>Promise.resolve((parcelRequire("gAdQO"))),
    [(0, $8dVIb.IconType).Incident]: ()=>Promise.resolve((parcelRequire("6ClRv"))),
    [(0, $8dVIb.IconType).Problem]: ()=>Promise.resolve((parcelRequire("1ni2E"))),
    [(0, $8dVIb.IconType).ServiceRequest]: ()=>Promise.resolve((parcelRequire("kQSMP"))),
    [(0, $8dVIb.IconType).Story]: ()=>Promise.resolve((parcelRequire("kvhCa"))),
    [(0, $8dVIb.IconType).SubTask]: ()=>Promise.resolve((parcelRequire("dvo9I"))),
    [(0, $8dVIb.IconType).Task]: ()=>Promise.resolve((parcelRequire("ercGv"))),
    // Provider icons
    [(0, $8dVIb.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $8dVIb.IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $8dVIb.IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
    [(0, $8dVIb.IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
    [(0, $8dVIb.IconType).Forbidden]: ()=>Promise.resolve((parcelRequire("gs7PQ"))),
    // Badge
    [(0, $8dVIb.IconType).Attachment]: ()=>(parcelRequire("kbM6l")),
    [(0, $8dVIb.IconType).CheckItem]: ()=>Promise.resolve((parcelRequire("imUQY"))),
    [(0, $8dVIb.IconType).Comment]: ()=>Promise.resolve((parcelRequire("DBbS0"))),
    [(0, $8dVIb.IconType).View]: ()=>Promise.resolve((parcelRequire("bH0nF"))),
    [(0, $8dVIb.IconType).React]: ()=>(parcelRequire("h8l0B")),
    [(0, $8dVIb.IconType).Vote]: ()=>(parcelRequire("4CGRY")),
    [(0, $8dVIb.IconType).PriorityBlocker]: ()=>(parcelRequire("gMDFI")),
    [(0, $8dVIb.IconType).PriorityCritical]: ()=>(parcelRequire("4fkVg")),
    [(0, $8dVIb.IconType).PriorityHigh]: ()=>(parcelRequire("fgN6p")),
    [(0, $8dVIb.IconType).PriorityHighest]: ()=>(parcelRequire("cV2N9")),
    [(0, $8dVIb.IconType).PriorityLow]: ()=>(parcelRequire("eVavM")),
    [(0, $8dVIb.IconType).PriorityLowest]: ()=>(parcelRequire("56RVo")),
    [(0, $8dVIb.IconType).PriorityMajor]: ()=>(parcelRequire("ktXnL")),
    [(0, $8dVIb.IconType).PriorityMedium]: ()=>(parcelRequire("9mM5H")),
    [(0, $8dVIb.IconType).PriorityMinor]: ()=>(parcelRequire("1O0Re")),
    [(0, $8dVIb.IconType).PriorityTrivial]: ()=>(parcelRequire("lGGho")),
    [(0, $8dVIb.IconType).PriorityUndefined]: ()=>Promise.resolve((parcelRequire("7QGmb"))),
    [(0, $8dVIb.IconType).ProgrammingLanguage]: ()=>(parcelRequire("7Hzmn")),
    [(0, $8dVIb.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("h8cgU"))),
    [(0, $8dVIb.IconType).SubTasksProgress]: ()=>(parcelRequire("jZ8wH"))
};
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const item = (0, $kxcRq.getLazyIcons)()[icon];
        if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
        return item?.default;
    }
    return $1647af7fe5459c6c$var$importIconMapperOld[icon];
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    const DocumentIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $94rku.default) : (0, (/*@__PURE__*/$parcel$interopDefault($duwKf)));
    const BlogIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $dVpJZ.default) : (0, $iRZQl.default);
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(DocumentIcon, {
                label: label ?? 'document',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(BlogIcon, {
                label: label ?? 'blog',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $8dVIb.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
                label: label ?? 'live-doc',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
                    size: size,
                    color: "var(--ds-icon-danger, #C9372C)"
                } : {
                    primaryColor: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
parcelRegister("e1vlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3c19aa4679ee0a$export$2e2bcd8739ae039);

var $4Atwu = parcelRequire("4Atwu");

var $8lQ8Y = parcelRequire("8lQ8Y");

var $50H21 = parcelRequire("50H21");
const $df3c19aa4679ee0a$var$LiveDocumentIconWithColor = (0, $50H21.renderIconPerSize)((0, $4Atwu.default), (0, $8lQ8Y.default));
$df3c19aa4679ee0a$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $df3c19aa4679ee0a$export$2e2bcd8739ae039 = $df3c19aa4679ee0a$var$LiveDocumentIconWithColor;

});

parcelRegister("kbM6l", function(module, exports) {

let $eb2a25a65dcb50b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb2a25a65dcb50b4$var$load("gWXGh").then(()=>parcelRequire('j3Vfq'));

});

parcelRegister("h8l0B", function(module, exports) {

let $c7937af0943f4fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7937af0943f4fdc$var$load("cj5mx").then(()=>parcelRequire('kxkv9'));

});

parcelRegister("4CGRY", function(module, exports) {

let $35dbf7027bf16f47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35dbf7027bf16f47$var$load("7SKVs").then(()=>parcelRequire('kAObg'));

});

parcelRegister("7Hzmn", function(module, exports) {

let $59b7fa4a04481570$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59b7fa4a04481570$var$load("iY2wN").then(()=>parcelRequire('c2JK5'));

});

parcelRegister("jZ8wH", function(module, exports) {

let $e8ca53f8b2e599bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8ca53f8b2e599bd$var$load("10dT8").then(()=>parcelRequire('gKopa'));

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                testId: `${testId}-loading`,
                width: width,
                height: height
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: "",
                style: {
                    width: width,
                    height: height
                }
            })
        } : {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                testId: `${testId}-loading`
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: ""
            })
        },
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeletonNew", () => $880176eb12ae8419$export$4c64943f69fac55);
$parcel$export(module.exports, "LoadingSkeletonOld", () => $880176eb12ae8419$export$c2c783ba34989c94);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$4c64943f69fac55 = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};
const $880176eb12ae8419$export$c2c783ba34989c94 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($880176eb12ae8419$export$4c64943f69fac55, {
        ...props,
        width: `${props.width}rem`,
        height: `${props.height}rem`
    });
};

});


parcelRegister("3dubP", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidthNew", () => $3ebf94f205ad0182$export$86b6226ea65a6ddf);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $3ebf94f205ad0182$export$ce56b6021549537 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $3ebf94f205ad0182$export$86b6226ea65a6ddf = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    return (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $3ebf94f205ad0182$export$86b6226ea65a6ddf(size) : $3ebf94f205ad0182$export$ce56b6021549537(size);
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("9tslm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2a1e857857107e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");
const $bf2a1e857857107e$var$badgeStylesOld = null;
const $bf2a1e857857107e$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $bf2a1e857857107e$var$AtlaskitBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
            children: value
        })
    });
};
var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;

});

parcelRegister("4ZXUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e655d051c837701$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $1e655d051c837701$var$MAX_COUNT = 4;
const $1e655d051c837701$var$styles = null;
const $1e655d051c837701$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $1e655d051c837701$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1e655d051c837701$var$stylesMap[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;

});

parcelRegister("bWpL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a4f7878d6976fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66a4f7878d6976fe$var$stylesOld = null;
const $66a4f7878d6976fe$var$styles = null;
const $66a4f7878d6976fe$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $66a4f7878d6976fe$var$DateTime = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: text ? `${text} ${context}` : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        })
    });
};
var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;

});

parcelRegister("aWyvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c193b1fc074556$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
const $d6c193b1fc074556$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $d6c193b1fc074556$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $d6c193b1fc074556$var$iconStylesMapOld = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapOld = {
    xlarge: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4viql _1wybviql _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kviql",
    large: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41k8s _1wyb1k8s _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1k8s",
    medium: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41j6v _1wyb1j6v _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1j6v",
    small: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4oqnp _1wyboqnp _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102koqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapNew = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym"
};
const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $d6c193b1fc074556$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $d6c193b1fc074556$var$styles.container,
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$iconStylesMapOld[size],
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$positionStyleMap[position],
            render && !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapOld[size],
            render && (0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapNew[size],
            className
        ]),
        children: (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $d6c193b1fc074556$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        }) : element
    });
};
var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;

});

parcelRegister("3dV67", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60bb11df77d728a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
const $b60bb11df77d728a$var$containerStyles = null;
const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
    if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
    if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $b60bb11df77d728a$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $b60bb11df77d728a$var$baseAnchorStyle = null;
const $b60bb11df77d728a$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $b60bb11df77d728a$var$anchorConstantsStyles = null;
const $b60bb11df77d728a$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $b60bb11df77d728a$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $b60bb11df77d728a$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $b60bb11df77d728a$var$linkStyleSizeMap[size],
            $b60bb11df77d728a$var$anchorLineClampMap[$b60bb11df77d728a$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $b60bb11df77d728a$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 1 && $b60bb11df77d728a$var$anchorLinkLineHeight1Map[size],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 2 && $b60bb11df77d728a$var$anchorLinkLineHeight2Map[size],
            $b60bb11df77d728a$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId)
    });
};
var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;

});

parcelRegister("cJxXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9c30eaf441ad65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");
const $af9c30eaf441ad65$var$stylesOld = null;
const $af9c30eaf441ad65$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $af9c30eaf441ad65$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
        appearance: appearance,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;

});
parcelRegister("a4DH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ceba18caf6f022$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $cLKee = parcelRequire("cLKee");

var $dMzTJ = parcelRequire("dMzTJ");

var $j6VJk = parcelRequire("j6VJk");

var $1s0lY = parcelRequire("1s0lY");

var $kf01E = parcelRequire("kf01E");

var $4Dg4o = parcelRequire("4Dg4o");
const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $1s0lY.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $1s0lY.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Dg4o.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6VJk.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kf01E.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, $cLKee.default)($27ceba18caf6f022$var$LozengeAction);

});
parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kYwnb = parcelRequire("kYwnb");

var $051X7 = parcelRequire("051X7");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = (0, $VSDnB.fg)('smart_links_noun_support') ? !!(details && details.data || (0, $kYwnb.isEntityPresent)(details)) : !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("cLKee", function(module, exports) {

$parcel$export(module.exports, "default", () => $061d6f2e0c766414$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: props?.appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;

});

parcelRegister("dMzTJ", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$618660b8f2aa87e2);
const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("j6VJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");
const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
const $ee1a9d5bb42f1de9$var$contentStyles = null;
const $ee1a9d5bb42f1de9$var$linkStyles = null;
const $ee1a9d5bb42f1de9$var$textStylesBase = null;
const $ee1a9d5bb42f1de9$var$dropdownItemGroupStyles = null;
const $ee1a9d5bb42f1de9$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("1s0lY", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $47c640bee30204cc$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $47c640bee30204cc$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("kf01E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0af43cfe2e114d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $hgsSZ = parcelRequire("hgsSZ");
const $9a0af43cfe2e114d$var$dropdownItemGroupStyles = null;
const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $hgsSZ.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;

});
parcelRegister("hgsSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $419e60cbfb62c454$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;

});


parcelRegister("4Dg4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa61527cd4f792e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c8Oei = parcelRequire("c8Oei");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $afa61527cd4f792e$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw"
};
const $afa61527cd4f792e$var$triggerLozengeStyles = null;
const $afa61527cd4f792e$var$triggerButtonStyles = null;
const $afa61527cd4f792e$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
            appearance: appearance,
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        as: "span",
                        xcss: $afa61527cd4f792e$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;

});



parcelRegister("77cM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a723b9f793426daa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l5Xsv = parcelRequire("l5Xsv");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $a723b9f793426daa$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $a723b9f793426daa$var$Media = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;

});

parcelRegister("k39kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $af078338fe34f0f5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $af078338fe34f0f5$var$baseStyleOld = null;
const $af078338fe34f0f5$var$baseStyle = null;
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $af078338fe34f0f5$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $fpDmE.getFormattedMessage)(message) || content
    });
};
var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;

});


parcelRegister("kDhrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5972a7cc25546c87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $77cM6 = parcelRequire("77cM6");
const $5972a7cc25546c87$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $77cM6.default), {
        ...rest,
        ...data
    });
};
var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;

});

parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $673e9555bded0d05$var$snippetBaseStyleOld = null;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});


parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66554651c27d9387$var$stylesOld = null;
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Zm9O.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$baseStyleBySizeOld = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyleOld = null;
const $ed56962f49dee3a8$var$baseStyles = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $8dVIb.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySizeOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ]),
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});


parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmall = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $b3ee32ab04698fad$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $b3ee32ab04698fad$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $b3ee32ab04698fad$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $5uXOq.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $krXdA.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($b3ee32ab04698fad$var$ActionButtonRefreshNew);
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $b3ee32ab04698fad$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $VSDnB.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});

parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$stackItemIconStylesOld = null;
const $345d01659b23eb38$var$stackItemIconStylesCompiled = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});

parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $222d00bebc6cbf68$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $222d00bebc6cbf68$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.button, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.content, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});



parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("82OF2")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9yaZS")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("82OF2", function(module, exports) {

let $5db5ced4f0000848$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5db5ced4f0000848$var$load("h2MrD"),
    $5db5ced4f0000848$var$load("bYT2S"),
    $5db5ced4f0000848$var$load("ftS7u")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("9yaZS", function(module, exports) {

let $01cb5a17f25affbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01cb5a17f25affbd$var$load("h2MrD"),
    $01cb5a17f25affbd$var$load("bYT2S"),
    $01cb5a17f25affbd$var$load("3uQsu")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("hWyvy", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $e72cc95d6d37b739$export$be18a6294fd426ec);
const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RbANO.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1r4gF.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $dS3PR = parcelRequire("dS3PR");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("EjrMr")));
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnPiq.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $a203465a8c9e0684$var$styles = null;
const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("EjrMr", function(module, exports) {

let $0792d252ffbcd5aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0792d252ffbcd5aa$var$load("hPzOn"),
    $0792d252ffbcd5aa$var$load("h2MrD"),
    $0792d252ffbcd5aa$var$load("bYT2S"),
    $0792d252ffbcd5aa$var$load("lchYl")
]).then(()=>parcelRequire('1Rjyb'));

});


parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("19m52")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $7zaVw.messages).related_links_view_related_links : (0, $7zaVw.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k98Kd.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hyKRO = parcelRequire("hyKRO");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::460873555b00dc694a7c27133071dd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::359c101bebeaae075dd3e3e9a50caec7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});



parcelRegister("19m52", function(module, exports) {

let $0d67c25d523d11e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d67c25d523d11e2$var$load("dXU8n").then(()=>parcelRequire('14MtF'));

});





parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$BaseBlockStylesOld = null;
const $96a6d91fb5d77548$var$baseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapsStylesOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;

});

parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cElbi.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;

});
parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDhrr.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kp8aU.default), {
            maxLines: snippetMaxLines,
            content: text
        })
    });
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});

parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});

parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e2967317da51f9f7$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulp1b66"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});

parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $045d1b1e49cae759$var$iconStyle = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const iconWidth = (0, $fpDmE.getIconWidthNew)(size);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
            ...blockProps,
            testId: `${testId}-resolving-view`,
            children: [
                !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        width: iconWidth,
                        height: iconWidth
                    },
                    "data-testid": `${testId}-icon`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                        width: iconWidth,
                        height: iconWidth,
                        testId: `${testId}-icon-loading`
                    })
                }),
                title,
                actionGroup
            ]
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-icon`,
                className: (0, $bwpsq.default)([
                    $045d1b1e49cae759$var$iconStyle[size]
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});


parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tgi5.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $VSDnB = parcelRequire("VSDnB");

var $aRS1S = parcelRequire("aRS1S");
const $ea67ef8b17402f34$var$AISummaryCSSStyles = null;
const $ea67ef8b17402f34$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $270fc2c4bbd80c91$var$listStyles = null;
const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});


parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $obtkX.default), {
        ...props,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBKwT.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});





parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $s2ak7 = parcelRequire("s2ak7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b695424587865b74$var$ignoreContainerPaddingStylesOld = null;
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $b695424587865b74$export$1af10e3728e3a644(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $s2ak7.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $aBTst = parcelRequire("aBTst");
const $e384e6334b5a98a7$var$containerStyles = null;
const $e384e6334b5a98a7$var$errorStyles = null;
const $e384e6334b5a98a7$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $e384e6334b5a98a7$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$var$baseWrapperStylesNew = null;
const $7f29852863f1f016$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStylesNew = null;
const $7f29852863f1f016$var$truncateStylesOld = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});



const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("5HNFf", function(module, exports) {

let $42777e3129bc7bce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $42777e3129bc7bce$var$load("h2MrD"),
    $42777e3129bc7bce$var$load("bYT2S"),
    $42777e3129bc7bce$var$load("ij5kv")
]).then(()=>parcelRequire('6Of57'));

});



parcelRegister("0Tx5e", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $e2bd3eca15e522b1$export$7b5e1b7f9a325b6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $daJ0i = parcelRequire("daJ0i");

var $fzJZi = parcelRequire("fzJZi");

var $hBQOn = parcelRequire("hBQOn");

var $i41Ob = parcelRequire("i41Ob");
const $e2bd3eca15e522b1$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $5uXOq.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const cardProps = {
        ...props,
        id: id
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: (0, $fzJZi.context),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            FallbackComponent: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                    ...cardProps
                }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hBQOn.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("hBQOn", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $ad2753aa52acbfd4$export$7598f5d7c597dd32);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $lGoTE = parcelRequire("lGoTE");

var $1VPdD = parcelRequire("1VPdD");

var $fgpl1 = parcelRequire("fgpl1");

var $7HAq8 = parcelRequire("7HAq8");

var $kxcRq = parcelRequire("kxcRq");

var $jCOVt = parcelRequire("jCOVt");

var $g2eZ6 = parcelRequire("g2eZ6");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $8Buf6 = parcelRequire("8Buf6");

var $7RcXv = parcelRequire("7RcXv");

var $9fYWd = parcelRequire("9fYWd");

var $7oGL1 = parcelRequire("7oGL1");
function $ad2753aa52acbfd4$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error } = (0, $lGoTE.useSmartLink)(id, url);
    const definitionId = (0, $fgpl1.getDefinitionId)(state.details);
    const extensionKey = (0, $fgpl1.getExtensionKey)(state.details);
    const resourceType = (0, $fgpl1.getResourceType)(state.details);
    const services = (0, $fgpl1.getServices)(state.details);
    let isFlexibleUi = (0, $5uXOq.useMemo)(()=>(0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined), [
        children,
        ui
    ]);
    const actionOptions = (0, $jCOVt.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $5uXOq.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $kxcRq.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $8dVIb.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $fgpl1.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isModifierKeyPressed` be true.
            const target = isModifierKeyPressed ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        id,
        url,
        state.details,
        appearance,
        definitionId,
        onClick,
        isFlexibleUi,
        createAnalyticsEvent,
        fireEvent
    ]);
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $5uXOq.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $5uXOq.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $5uXOq.useEffect)(()=>{
        $5vDFA.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $5vDFA.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $5vDFA.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fgpl1.isFinalState)(state.status)) {
            (0, $1VPdD.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1VPdD.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $5uXOq.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fYWd.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7oGL1.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'block':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Buf6.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions
            });
        case 'embed':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7RcXv.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus
            });
    }
}
const $ad2753aa52acbfd4$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $91tw3.isFlexibleUiCard)(props.children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? props?.ui : undefined) ? (0, $8dVIb.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HAq8.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5igsJ.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ad2753aa52acbfd4$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("lGoTE", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $7e143fdfadf9b6c5$export$9f4e486b1dc3e700);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $3CATS = parcelRequire("3CATS");

var $eYswX = parcelRequire("eYswX");

var $khbkQ = parcelRequire("khbkQ");

var $hjhAz = parcelRequire("hjhAz");
function $7e143fdfadf9b6c5$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $hjhAz.useSmartCardState)(url);
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const actions = (0, $3CATS.useSmartCardActions)(id, url);
    const config = (0, $eYswX.useSmartLinkConfig)();
    const renderers = (0, $khbkQ.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $5uXOq.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error
    };
}

});
parcelRegister("3CATS", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $36916caf65c178ae$export$f7c340395f31e832);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");

var $fmdet = parcelRequire("fmdet");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $fgpl1 = parcelRequire("fgpl1");

var $iPVbQ = parcelRequire("iPVbQ");

var $f22ja = parcelRequire("f22ja");
const $36916caf65c178ae$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $f22ja.default)();
    const invokeClientAction = (0, $iPVbQ.default)({});
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $5uXOq.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $8dVIb.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $5uXOq.useCallback)((metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $5uXOq.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $5uXOq.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $5uXOq.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $fgpl1.getDefinitionId)(details);
        if (definitionId) (0, $fgpl1.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $5uXOq.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $5uXOq.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $fgpl1.getDefinitionId)(details);
        const extensionKey = (0, $fgpl1.getExtensionKey)(details);
        const services = (0, $fgpl1.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $fmdet.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1VPdD.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1VPdD.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $5uXOq.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("fmdet", function(module, exports) {

$parcel$export(module.exports, "auth", () => $5f3c60ac520535bf$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("fHui9")).AuthError);

var $fHui9 = parcelRequire("fHui9");

var $2sGCH = parcelRequire("2sGCH");
function $5f3c60ac520535bf$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $2sGCH.isOfTypeAuthError)(errorType)) reject(new (0, $fHui9.AuthError)(data.message, errorType));
                    else reject(new (0, $fHui9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $fHui9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("fHui9", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $39436ca0ebc2906b$export$145273558d58e0ac);
class $39436ca0ebc2906b$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("2sGCH", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $4689bea2fc57183c$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $4689bea2fc57183c$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("fgpl1", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $8cbc55b0be5f7abb$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $8cbc55b0be5f7abb$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $8cbc55b0be5f7abb$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $8cbc55b0be5f7abb$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $8cbc55b0be5f7abb$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $8cbc55b0be5f7abb$export$3f9446bb21b945a0);

var $iCv9y = parcelRequire("iCv9y");
const $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $iCv9y.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $8cbc55b0be5f7abb$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $8cbc55b0be5f7abb$export$218d96312e385949 = (details)=>details?.meta?.key;
const $8cbc55b0be5f7abb$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $8cbc55b0be5f7abb$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $8cbc55b0be5f7abb$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $8cbc55b0be5f7abb$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $8cbc55b0be5f7abb$export$ac5d414b1ebfab5a = (details)=>details && $8cbc55b0be5f7abb$export$cd41ae544cfc2a65(details) && $8cbc55b0be5f7abb$export$795910f5f15a9633(details);
const $8cbc55b0be5f7abb$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $8cbc55b0be5f7abb$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $8cbc55b0be5f7abb$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $8cbc55b0be5f7abb$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $8cbc55b0be5f7abb$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $8cbc55b0be5f7abb$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $8cbc55b0be5f7abb$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $8cbc55b0be5f7abb$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("iCv9y", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $28ad1893a5a5e6d3$export$c81497d3681f24f4);
const $28ad1893a5a5e6d3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("eYswX", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $2387d938a9c268b4$export$5d10838c1e539409);

var $051X7 = parcelRequire("051X7");
const $2387d938a9c268b4$export$5d10838c1e539409 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});

parcelRegister("khbkQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $53b108afa53560ee$export$c3514c024fefef57);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $53b108afa53560ee$export$c3514c024fefef57 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $5uXOq.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("jCOVt", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $aaa9fcf770cffa90$export$2ae4cf79c720146a);
const $aaa9fcf770cffa90$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("8Buf6", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $4d626c57887b3576$export$d18ccd25c0d2c6b0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $6TU5j = parcelRequire("6TU5j");

var $7xFN9 = parcelRequire("7xFN9");

var $gfnFT = parcelRequire("gfnFT");

var $bMldO = parcelRequire("bMldO");

var $1ENCM = parcelRequire("1ENCM");

var $kQeqP = parcelRequire("kQeqP");

var $7wrOH = parcelRequire("7wrOH");

var $kc7yu = parcelRequire("kc7yu");

var $1PV7p = parcelRequire("1PV7p");
const $4d626c57887b3576$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $gfnFT.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $6TU5j.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            });
        case 'resolved':
            if ((0, $VSDnB.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $7xFN9.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PV7p.default), {
                    ...blockCardProps,
                    onAuthorize: handleAuthorize
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PV7p.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQeqP.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7wrOH.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ENCM.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("6TU5j", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $f8634558e6ab3b89$export$f93c47f1b2b3f55b);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $f8634558e6ab3b89$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("7xFN9", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $6c86d4fba49dfc79$export$a019611f39785186);
const $6c86d4fba49dfc79$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("gfnFT", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $616acbd6c6da9a6a$export$9759a67e215c4598);
const $616acbd6c6da9a6a$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("1ENCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e31a40ad40a157$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $gtreQ = parcelRequire("gtreQ");

var $VSDnB = parcelRequire("VSDnB");


var $7zaVw = parcelRequire("7zaVw");

var $k39kU = parcelRequire("k39kU");

var $bd45l = parcelRequire("bd45l");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e31a40ad40a157$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $5uXOq.useMemo)(()=>props.onAuthorize ? [
            (0, $bd45l.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19497
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
                label: "errored-warning-icon",
                size: "small",
                primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $7zaVw.messages).could_not_load_link
                }
            })
        ]
    });
};
var $c5e31a40ad40a157$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($c5e31a40ad40a157$var$ErroredView);

});
parcelRegister("bd45l", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $93e1b738cef17b2e$export$c527d977b53f7537);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $93e1b738cef17b2e$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $8dVIb.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("3Mvli", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25c51e88598659e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");
var $5HrTg = parcelRequire("5HrTg");
var $hYQw7 = parcelRequire("hYQw7");
var $buvhv = parcelRequire("buvhv");

var $82kHN = parcelRequire("82kHN");
const $d25c51e88598659e$var$customBlockStylesOld = null;
const $d25c51e88598659e$var$customBlockStyles = null;
const $d25c51e88598659e$var$titleBlockCssOld = null;
const $d25c51e88598659e$var$titleBlockCss = null;
const $d25c51e88598659e$var$footerBlockCssOld = null;
const $d25c51e88598659e$var$footerBlockCss = null;
const $d25c51e88598659e$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $82kHN.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...(0, $82kHN.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                status: cardState.status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9 _2yhz14q2" : "_zulp1f3t _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                status: cardState.status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt" : "_4cvr1y6m"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ...(0, $82kHN.PreviewBlockOptions),
                status: cardState.status
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                status: cardState.status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb" : "_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj"
                ])
            })
        ]
    });
var $d25c51e88598659e$export$2e2bcd8739ae039 = $d25c51e88598659e$var$UnresolvedView;

});
parcelRegister("9fYWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $063c59fdd9d80513$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $anB5s = parcelRequire("anB5s");

var $f22ja = parcelRequire("f22ja");

var $lJP2b = parcelRequire("lJP2b");

var $1Vuck = parcelRequire("1Vuck");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $063c59fdd9d80513$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $anB5s.useAISummaryConfig)();
    const resolve = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $5uXOq.useMemo)(()=>(0, $1Vuck.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        details,
        fireEvent,
        id,
        origin,
        renderers,
        actionOptions,
        resolve,
        status,
        url
    ]);
    const retry = (0, $1Vuck.getRetryOptions)(url, status, details, onAuthorize);
    const { title: title } = context || {};
    (0, $5uXOq.useEffect)(()=>{
        switch(status){
            case (0, $8dVIb.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $8dVIb.SmartLinkStatus).Errored:
            case (0, $8dVIb.SmartLinkStatus).Fallback:
            case (0, $8dVIb.SmartLinkStatus).Forbidden:
            case (0, $8dVIb.SmartLinkStatus).NotFound:
            case (0, $8dVIb.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleUiOptionContext).Provider, {
        value: ui,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleUiContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJP2b.default), {
                testId: testId,
                ...ui,
                onClick: onClick,
                retry: retry,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                status: status,
                children: children
            })
        })
    });
};
var $063c59fdd9d80513$export$2e2bcd8739ae039 = $063c59fdd9d80513$var$FlexibleCard;

});
parcelRegister("lJP2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $399db9c8fe523a70$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $7ZRiH = parcelRequire("7ZRiH");

var $91tw3 = parcelRequire("91tw3");

var $buvhv = parcelRequire("buvhv");

var $jwrXN = parcelRequire("jwrXN");

var $4mRkk = parcelRequire("4mRkk");
const $399db9c8fe523a70$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $7ZRiH.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
            if ((0, $91tw3.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $8dVIb.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $8dVIb.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $399db9c8fe523a70$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick, removeBlockRestriction)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child)) {
            if ((0, $91tw3.isFlexibleUiTitleBlock)(child)) {
                if ((0, $91tw3.isStyleCacheProvider)(child)) return $399db9c8fe523a70$var$updateChildrenTitleBlock(child, {
                    onClick: onClick,
                    retry: retry,
                    containerSize: containerSize,
                    status: status,
                    theme: containerTheme
                });
                else {
                    const { size: blockSize } = child.props;
                    const size = blockSize || containerSize;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        onClick: // @ts-expect-error
                        onClick,
                        retry: retry,
                        size: size,
                        status: status,
                        theme: containerTheme
                    });
                }
            }
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $91tw3.isStyleCacheProvider)(child)) return $399db9c8fe523a70$var$updateChildrenBlock(child, size, status);
            // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                size: size,
                status: status
            });
        }
        if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
            if (removeBlockRestriction) return child;
        }
    });
};
const $399db9c8fe523a70$var$updateChildrenBlock = (node, size, status)=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child)) // @ts-expect-error
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            size: size,
            status: status
        });
        return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
        children: updatedChildren
    });
};
const $399db9c8fe523a70$var$updateChildrenTitleBlock = (node, { containerSize: containerSize, ...props })=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiTitleBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                ...props,
                size: size
            });
        } else return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
        children: updatedChildren
    });
};
const $399db9c8fe523a70$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return undefined;
    if (node.type === (0, $buvhv.default)) return node;
    if ((0, $91tw3.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $399db9c8fe523a70$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $399db9c8fe523a70$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>$399db9c8fe523a70$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(block)) return block.props;
};
const $399db9c8fe523a70$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $399db9c8fe523a70$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mRkk.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
const $399db9c8fe523a70$var$baseStyleCommon = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$backgroundStyleOld = null;
const $399db9c8fe523a70$var$backgroundStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$elevationStylesOld = null;
const $399db9c8fe523a70$var$elevationStyles = null;
const $399db9c8fe523a70$var$clickableContainerStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$gapStyleMapOld = {
    xlarge: "_zulp1jvo",
    large: "_zulph3jc",
    medium: "_zulp1qos",
    small: "_zulpfzsm"
};
const $399db9c8fe523a70$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $399db9c8fe523a70$var$getPadding = (size)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $399db9c8fe523a70$var$getGap = (size)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$previewOnLeftStyleMapOld = {
    xlarge: "_19bv15sf _y5vk1k92",
    large: "_19bvf557 _y5vk1j6v",
    medium: "_19bvqox2 _y5vk1kwk",
    small: "_19bv1ltm _y5vk6mu8"
};
const $399db9c8fe523a70$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$previewOnRightStyleMapOld = {
    xlarge: "_u5f315sf _1yob1k92",
    large: "_u5f3f557 _1yob1j6v",
    medium: "_u5f3qox2 _1yob1kwk",
    small: "_u5f31ltm _1yob6mu8"
};
const $399db9c8fe523a70$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $399db9c8fe523a70$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $8dVIb.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $8dVIb.SmartLinkTheme).Link })=>{
    (0, $gKZoD.di)((0, $jwrXN.default));
    const padding = hidePadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : $399db9c8fe523a70$var$getPadding(size);
    const gap = $399db9c8fe523a70$var$getGap(size);
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $399db9c8fe523a70$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $399db9c8fe523a70$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $399db9c8fe523a70$var$previewOnLeftStyleMap[size],
            previewOnRight && $399db9c8fe523a70$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $lD23V.default)(padding),
            "--_73mooq": (0, $lD23V.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $lD23V.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null,
            $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $399db9c8fe523a70$var$gapStyleMapOld[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $399db9c8fe523a70$var$previewOnLeftStyleMapOld[size],
            previewOnRight && $399db9c8fe523a70$var$previewOnRightStyleMapOld[size],
            !hideElevation && "_19ith6cr _2rkopd34 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $lD23V.default)(padding),
            "--_73mooq": (0, $lD23V.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $lD23V.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null,
            $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jwrXN.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $399db9c8fe523a70$export$2e2bcd8739ae039 = $399db9c8fe523a70$var$Container;

});
parcelRegister("7ZRiH", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $767677c9fc81205d$export$783c1bf8fee63f80);
const $767677c9fc81205d$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("jwrXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $93868de8e0c8126a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $hHEfn = parcelRequire("hHEfn");
const $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $93868de8e0c8126a$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $5uXOq.useState)(true);
    const mouseStopTimer = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $5uXOq.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $8dVIb.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            children: children
        })
    });
};
var $93868de8e0c8126a$export$2e2bcd8739ae039 = $93868de8e0c8126a$var$HoverCardControl;

});
parcelRegister("hHEfn", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $2eeb1383fcc12911$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $2eeb1383fcc12911$export$f1f63acbe6ed8fb0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $cb25w = parcelRequire("cb25w");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $7HAq8 = parcelRequire("7HAq8");

var $5igsJ = parcelRequire("5igsJ");

var $kySOC = parcelRequire("kySOC");
const $2eeb1383fcc12911$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gKZoD.di)((0, $kySOC.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: (0, $8dVIb.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $kySOC.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $5uXOq.useCallback)((error, info)=>{
        (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HAq8.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kySOC.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext = (0, $cb25w.default)()($2eeb1383fcc12911$var$HoverCardWithErrorBoundary);
const $2eeb1383fcc12911$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $2eeb1383fcc12911$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($2eeb1383fcc12911$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("kySOC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $3e0a0fbe111efeba$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $3e0a0fbe111efeba$export$e2173dafa6a751bb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $3CATS = parcelRequire("3CATS");

var $khbkQ = parcelRequire("khbkQ");

var $hjhAz = parcelRequire("hjhAz");

var $5igsJ = parcelRequire("5igsJ");

var $jpjv9 = parcelRequire("jpjv9");

var $fqj3r = parcelRequire("fqj3r");

var $hZqF4 = parcelRequire("hZqF4");
const $3e0a0fbe111efeba$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $3e0a0fbe111efeba$var$FADE_IN_DELAY = 500;
const $3e0a0fbe111efeba$var$FADE_OUT_DELAY = 300;
const $3e0a0fbe111efeba$var$RESOLVE_DELAY = 100;
const $3e0a0fbe111efeba$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $hZqF4.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId, showLabel: showLabel = true })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $3e0a0fbe111efeba$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const fadeOutTimeoutId = (0, $5uXOq.useRef)();
    const fadeInTimeoutId = (0, $5uXOq.useRef)();
    const resolveTimeOutId = (0, $5uXOq.useRef)();
    const mousePos = (0, $5uXOq.useRef)();
    const popupOffset = (0, $5uXOq.useRef)();
    const parentSpan = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderers = (0, $khbkQ.useSmartLinkRenderers)();
    const linkState = (0, $hjhAz.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $3CATS.useSmartCardActions)(id, url);
    const setMousePosition = (0, $5uXOq.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $hZqF4.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $hZqF4.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $5uXOq.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $3e0a0fbe111efeba$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $5uXOq.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $3e0a0fbe111efeba$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $5uXOq.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $5uXOq.useCallback)((actionId)=>{
        if (actionId === (0, $8dVIb.ActionName).PreviewAction || actionId === (0, $8dVIb.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $5uXOq.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5igsJ.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            id: id,
            source: $3e0a0fbe111efeba$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqj3r.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $5uXOq.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": "hover-card-trigger-wrapper",
                "aria-label": showLabel ? formatMessage((0, $7zaVw.messages).more_information_about_this_work_item) : undefined,
                ...(0, $VSDnB.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        formatMessage,
        showLabel
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $jpjv9.default)
    });
};

});
parcelRegister("jpjv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3866955ba7de81$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $0f3866955ba7de81$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $0f3866955ba7de81$export$2e2bcd8739ae039 = $0f3866955ba7de81$var$CustomPopupContainer;

});

parcelRegister("fqj3r", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $d84d865bf5e6c05a$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $d84d865bf5e6c05a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $051X7 = parcelRequire("051X7");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $fgpl1 = parcelRequire("fgpl1");

var $hjhAz = parcelRequire("hjhAz");

var $kxcRq = parcelRequire("kxcRq");

var $cnaAy = parcelRequire("cnaAy");

var $g2eZ6 = parcelRequire("g2eZ6");

var $hZqF4 = parcelRequire("hZqF4");

var $8RJLv = parcelRequire("8RJLv");

var $fF5L8 = parcelRequire("fF5L8");

var $KTqu4 = parcelRequire("KTqu4");

var $6klQO = parcelRequire("6klQO");

var $g3aqq = parcelRequire("g3aqq");

var $f6jZ5 = parcelRequire("f6jZ5");
const $d84d865bf5e6c05a$export$34883cbaea18402d = 'smart-links-hover-preview';
const $d84d865bf5e6c05a$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const extensionKey = (0, $5uXOq.useMemo)(()=>(0, $fgpl1.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $hjhAz.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $5uXOq.useMemo)(()=>(0, $fgpl1.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $cnaAy.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $fgpl1.getServices)(linkState.details);
    const statusRef = (0, $5uXOq.useRef)(linkStatus);
    const fireEventRef = (0, $5uXOq.useRef)(fireEvent);
    const definitionIdRef = (0, $5uXOq.useRef)(definitionId);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $kxcRq.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $8RJLv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $8dVIb.SmartLinkSize).Large,
        position: (0, $8dVIb.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const flexibleCardProps = {
        appearance: (0, $8dVIb.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: (0, $hZqF4.flexibleUiOptions),
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g3aqq.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6jZ5.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KTqu4.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6klQO.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fF5L8.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $d84d865bf5e6c05a$export$2e2bcd8739ae039 = $d84d865bf5e6c05a$var$HoverCardContent;

});
parcelRegister("hZqF4", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $c1c4917a58eea345$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $c1c4917a58eea345$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $c1c4917a58eea345$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $c1c4917a58eea345$export$e7cae8c75d768024);

var $k5uoT = parcelRequire("k5uoT");

var $8dVIb = parcelRequire("8dVIb");
const $c1c4917a58eea345$export$8245b0eaabf3440c = (0, $k5uoT.layers).modal();
const $c1c4917a58eea345$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    size: (0, $8dVIb.SmartLinkSize).Medium,
    zIndex: $c1c4917a58eea345$export$8245b0eaabf3440c + 1
};
const $c1c4917a58eea345$export$a0a37c997fbcd678 = 24;
const $c1c4917a58eea345$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("8RJLv", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $575ef03a4633fd6f$export$8548546c0aa631e6);

var $FcDCF = parcelRequire("FcDCF");

var $8dVIb = parcelRequire("8dVIb");

var $6N2TY = parcelRequire("6N2TY");
const $575ef03a4633fd6f$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $FcDCF.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $8dVIb.ElementName).AuthorGroup,
            (0, $8dVIb.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn,
                    (0, $8dVIb.ElementName).SubscriberCount,
                    (0, $8dVIb.ElementName).State
                ],
                subtitle: [
                    (0, $8dVIb.ElementName).SourceBranch,
                    (0, $8dVIb.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $8dVIb.ElementName).LatestCommit,
                    (0, $8dVIb.ElementName).CollaboratorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $6N2TY.extractOwnedBy)(data) ? (0, $8dVIb.ElementName).OwnedByGroup : (0, $8dVIb.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $8dVIb.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount,
                    (0, $8dVIb.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $8dVIb.ElementName).AssignedToGroup,
                        (0, $8dVIb.ElementName).State,
                        (0, $8dVIb.ElementName).StoryPoints,
                        (0, $8dVIb.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).CollaboratorGroup,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ],
                secondary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount,
                    (0, $8dVIb.ElementName).AttachmentCount,
                    (0, $8dVIb.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $8dVIb.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).SentOn
                ],
                tertiary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix = [
    (0, $8dVIb.ElementName).AssignedToGroup,
    (0, $8dVIb.ElementName).OwnedByGroup,
    (0, $8dVIb.ElementName).AuthorGroup
];
const $575ef03a4633fd6f$var$toElementItem = (name)=>{
    const showNamePrefix = $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $575ef03a4633fd6f$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $8dVIb.ElementName)).map($575ef03a4633fd6f$var$toElementItem);
};
const $575ef03a4633fd6f$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $575ef03a4633fd6f$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $575ef03a4633fd6f$var$toElementItems(metadata.subtitle),
        primary: $575ef03a4633fd6f$var$toElementItems(primary),
        secondary: $575ef03a4633fd6f$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("6N2TY", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $e8afc48bfc3821d9$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $e8afc48bfc3821d9$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $e8afc48bfc3821d9$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $e8afc48bfc3821d9$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $e8afc48bfc3821d9$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $e8afc48bfc3821d9$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $e8afc48bfc3821d9$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $e8afc48bfc3821d9$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $e8afc48bfc3821d9$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $e8afc48bfc3821d9$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $e8afc48bfc3821d9$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $e8afc48bfc3821d9$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $e8afc48bfc3821d9$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $e8afc48bfc3821d9$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $e8afc48bfc3821d9$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $e8afc48bfc3821d9$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $e8afc48bfc3821d9$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $e8afc48bfc3821d9$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $e8afc48bfc3821d9$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $e8afc48bfc3821d9$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $e8afc48bfc3821d9$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $e8afc48bfc3821d9$export$bdcea84d1550eb9d);

var $lnY7t = parcelRequire("lnY7t");
var $4MmCl = parcelRequire("4MmCl");
var $eV8m9 = parcelRequire("eV8m9");
var $g9Blp = parcelRequire("g9Blp");
const $e8afc48bfc3821d9$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $e8afc48bfc3821d9$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $e8afc48bfc3821d9$export$b68822b76d5d51d5 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:commentCount');
const $e8afc48bfc3821d9$export$4356c594f5c138d6 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $e8afc48bfc3821d9$export$ac56bd7a37249b48 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'endTime');
const $e8afc48bfc3821d9$export$e57334ce4738e29d = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:viewCount');
const $e8afc48bfc3821d9$export$44130aa92252501 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:reactCount');
const $e8afc48bfc3821d9$export$c8bef3d5e550a3a = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:voteCount');
const $e8afc48bfc3821d9$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $eV8m9.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $e8afc48bfc3821d9$export$5546969a505305 = (data)=>{
    const person = (0, $lnY7t.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $e8afc48bfc3821d9$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $lnY7t.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $e8afc48bfc3821d9$export$69b10d653f96288b = (data)=>{
    const persons = (0, $4MmCl.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $e8afc48bfc3821d9$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $g9Blp.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $e8afc48bfc3821d9$export$43e54589935a1ff = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:programmingLanguage');
const $e8afc48bfc3821d9$export$949ac6a8325b3fdb = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeSource']);
const $e8afc48bfc3821d9$export$8bd03a7beb5badf1 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subscriberCount');
const $e8afc48bfc3821d9$export$65362ff78a97fd8 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:attachmentCount');
const $e8afc48bfc3821d9$export$29b0ac5d2f9890cf = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeDestination']);
const $e8afc48bfc3821d9$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $e8afc48bfc3821d9$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $e8afc48bfc3821d9$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $e8afc48bfc3821d9$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $e8afc48bfc3821d9$export$cc4028b2878d0675 = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $e8afc48bfc3821d9$export$b592ddecae70b61d = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'dateSent');
};
const $e8afc48bfc3821d9$export$bdcea84d1550eb9d = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("lnY7t", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $0ac42ccaa7f6f983$export$38a0979ebf273662);

var $aj6Xc = parcelRequire("aj6Xc");
const $0ac42ccaa7f6f983$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $aj6Xc.extractPersonFromJsonLd)(assignedTo);
};

});
parcelRegister("aj6Xc", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $39e0e436026dd560$export$c471ae5fddcf1392);

var $cuw1y = parcelRequire("cuw1y");
const $39e0e436026dd560$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});


parcelRegister("4MmCl", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $b5a77ee228b8b40a$export$a66235cba0c9d11a);

var $aj6Xc = parcelRequire("aj6Xc");
const $b5a77ee228b8b40a$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $aj6Xc.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aj6Xc.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("eV8m9", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $2d658438ec8722e8$export$19ee667f3f7a6ec3);

var $aj6Xc = parcelRequire("aj6Xc");
const $2d658438ec8722e8$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $aj6Xc.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aj6Xc.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("g9Blp", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $e35651e7203a8f3a$export$8a2d1ed7e6f336f0);

var $aj6Xc = parcelRequire("aj6Xc");
const $e35651e7203a8f3a$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $aj6Xc.extractPersonFromJsonLd)(updatedBy);
};

});



parcelRegister("fF5L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ba3ed6dc9291b3$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $67sXJ = parcelRequire("67sXJ");

var $fqj3r = parcelRequire("fqj3r");
const $35ba3ed6dc9291b3$var$NEW_CARD_WIDTH_REM = 25;
const $35ba3ed6dc9291b3$var$HoverCardContainerStyle = null;
const $35ba3ed6dc9291b3$var$popupContainerStyles = null;
const $35ba3ed6dc9291b3$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $67sXJ.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    const [showPrism, setShowPrism] = (0, $5uXOq.useState)(status === 'loading');
    (0, $5uXOq.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $fqj3r.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $67sXJ.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $35ba3ed6dc9291b3$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($35ba3ed6dc9291b3$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $35ba3ed6dc9291b3$export$2e2bcd8739ae039 = $35ba3ed6dc9291b3$var$ContentContainer;

});
parcelRegister("67sXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1d831891587499$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");

var $c1bPW = parcelRequire("c1bPW");

var $DuPPR = parcelRequire("DuPPR");
const $8c1d831891587499$var$contentStyles = null;
const $8c1d831891587499$var$contentStylesPrismVisible = null;
const $8c1d831891587499$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $8c1d831891587499$var$popupContainerStyles = null;
const $8c1d831891587499$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c1bPW.default), {
        palette: (0, $DuPPR.AI_BORDER_PALETTE)[colorMode] ?? (0, $DuPPR.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $bwpsq.default)([
            $8c1d831891587499$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $8c1d831891587499$export$2e2bcd8739ae039 = $8c1d831891587499$var$AIPrism;

});
parcelRegister("c1bPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1652d4d52e4f5cc8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iI2az = parcelRequire("iI2az");
const $1652d4d52e4f5cc8$var$borderContainerStyles = null;
const $1652d4d52e4f5cc8$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1652d4d52e4f5cc8$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI2az.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI2az.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1652d4d52e4f5cc8$export$2e2bcd8739ae039 = $1652d4d52e4f5cc8$var$AIGlowingBorder;

});
parcelRegister("iI2az", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f1273dcfb74565$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
let $e2f1273dcfb74565$var$namespaceUUID = 0;
const $e2f1273dcfb74565$var$svgStyles = null;
const $e2f1273dcfb74565$var$blurredStyles = null;
const $e2f1273dcfb74565$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $e2f1273dcfb74565$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $5uXOq.useRef)(null);
    const namespaceId = (0, $5uXOq.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $e2f1273dcfb74565$var$namespaceUUID;
        $e2f1273dcfb74565$var$namespaceUUID += 1;
    }
    (0, $5uXOq.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $e2f1273dcfb74565$export$2e2bcd8739ae039 = $e2f1273dcfb74565$var$AnimatedSvgContainer;

});


parcelRegister("DuPPR", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $82894915d9bf39bf$export$23b7b83c7063ccfe);
const $82894915d9bf39bf$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $82894915d9bf39bf$export$23b7b83c7063ccfe = {
    dark: {
        blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue800,
        teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal500,
        yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue600,
        teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal300,
        yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("KTqu4", function(module, exports) {

$parcel$export(module.exports, "default", () => $73fc988205a4fd73$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $eCNt3 = parcelRequire("eCNt3");

var $7zaVw = parcelRequire("7zaVw");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");
var $hYQw7 = parcelRequire("hYQw7");
const $73fc988205a4fd73$var$titleBlockStylesOld = null;
const $73fc988205a4fd73$var$titleBlockStyles = null;
const $73fc988205a4fd73$var$mainTextStylesOld = null;
const $73fc988205a4fd73$var$mainTextStyles = null;
const $73fc988205a4fd73$var$connectButtonStylesOld = null;
const $73fc988205a4fd73$var$connectButtonStyles = null;
const $73fc988205a4fd73$var$basePreviewStylesOld = null;
const $73fc988205a4fd73$var$basePreviewStyles = null;
const $73fc988205a4fd73$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const data = cardState.details?.data;
    const meta = cardState.details?.meta;
    const product = (0, $f24gj.extractProvider)(data)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
        children: (0, $eCNt3.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $8PVtF.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ignoreContainerPadding: true,
                testId: testId,
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_13lipd34 _qrwqpd34 _otyru2gc" : "_13lipd34 _qrwqpd34 _otyrcxkx"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-title`,
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _k48p1pd9 _19pku2gc" : "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-content`,
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o" : "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _19pku2gc" : "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $73fc988205a4fd73$export$2e2bcd8739ae039 = $73fc988205a4fd73$var$HoverCardForbiddenView;

});
parcelRegister("8PVtF", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $be4c51ebaefcf3e8$export$846c1540a86749e6);

var $7zaVw = parcelRequire("7zaVw");

var $fzJZi = parcelRequire("fzJZi");

var $fKHgZ = parcelRequire("fKHgZ");

var $eCNt3 = parcelRequire("eCNt3");
const $be4c51ebaefcf3e8$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $eCNt3.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $7zaVw.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $7zaVw.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $fKHgZ.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $7zaVw.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $7zaVw.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("fKHgZ", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $d51c8d84b1e7f98f$export$59f8830fb5467e35);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7zaVw = parcelRequire("7zaVw");
const $d51c8d84b1e7f98f$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $7zaVw.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("eCNt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aafc83cfd7b46ae$export$2e2bcd8739ae039);
const $4aafc83cfd7b46ae$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $4aafc83cfd7b46ae$export$2e2bcd8739ae039 = $4aafc83cfd7b46ae$var$extractHostname;

});



parcelRegister("6klQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $338ebad02f36b2c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $9fYWd = parcelRequire("9fYWd");

var $fh9qw = parcelRequire("fh9qw");
var $85ffk = parcelRequire("85ffk");
var $1qDIM = parcelRequire("1qDIM");
var $gg6Qm = parcelRequire("gg6Qm");
var $1JaZ4 = parcelRequire("1JaZ4");
var $buvhv = parcelRequire("buvhv");

var $8RJLv = parcelRequire("8RJLv");

var $k9g4I = parcelRequire("k9g4I");
const $338ebad02f36b2c8$var$hiddenSnippetStyles = null;
const $338ebad02f36b2c8$var$metadataBlockCssOld = null;
/**
 * Moved from HoverCardContent.tsx due to CompiledCSS migration.
 */ const $338ebad02f36b2c8$var$titleBlockStyleOld = null;
const $338ebad02f36b2c8$var$titleBlockStyles = null;
const $338ebad02f36b2c8$var$snippetBlockCss = null;
const $338ebad02f36b2c8$var$actionBlockCss = null;
const $338ebad02f36b2c8$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1VPdD.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1VPdD.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $5uXOq.useMemo)(()=>{
        return (0, $8RJLv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(0);
    const snippetBlockRef = (0, $5uXOq.useRef)(null);
    const onSnippetRender = (0, $5uXOq.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $k9g4I.default)({
        data: data,
        fallbackElementHeight: snippetHeight.current
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {
        status: (0, $8dVIb.SmartLinkStatus).Resolved,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...titleBlockProps,
                metadataPosition: (0, $8dVIb.SmartLinkPosition).Top,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9" : "_zulpu2gc _quenui7n _oebj1txw _x7z0u2gc _1ljqu2gc _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $8dVIb.SmartLinkSize).Medium,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_zulpidpf _2aco1o8v _fmt31ohn _yklxcxkx _w3mucxkx _ia0l11wp _3tmpcxkx"
                ])
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qDIM.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet,
                status: (0, $8dVIb.SmartLinkStatus).Resolved
            }) : snippet,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fh9qw.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $85ffk.default), {})
        ]
    });
};
var $338ebad02f36b2c8$export$2e2bcd8739ae039 = $338ebad02f36b2c8$var$HoverCardResolvedView;

});
parcelRegister("k9g4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0493145b01898e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $jELGn = parcelRequire("jELGn");

var $hYQw7 = parcelRequire("hYQw7");
const $eb0493145b01898e$var$ImagePreview = ({ data: data, fallbackElementHeight: fallbackElementHeight })=>{
    const transitionStarted = (0, $5uXOq.useRef)(false);
    const previewBlockRef = (0, $5uXOq.useRef)(null);
    const [showPreview, setShowPreview] = (0, $5uXOq.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $5uXOq.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "var(--ds-space-100, 8px)" : '0.5rem',
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $5uXOq.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $5uXOq.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && data && (0, $jELGn.default)(data) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $eb0493145b01898e$export$2e2bcd8739ae039 = $eb0493145b01898e$var$ImagePreview;

});
parcelRegister("jELGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b57ea7b1c4bc68$export$2e2bcd8739ae039);

var $5nDnb = parcelRequire("5nDnb");

var $8dVIb = parcelRequire("8dVIb");
const $c3b57ea7b1c4bc68$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $5nDnb.extractImage)(data);
    return url ? {
        type: (0, $8dVIb.MediaType).Image,
        url: url
    } : undefined;
};
var $c3b57ea7b1c4bc68$export$2e2bcd8739ae039 = $c3b57ea7b1c4bc68$var$extractPreview;

});
parcelRegister("5nDnb", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $bf7a10bb5159fbbd$export$4c753a1297cb9805);

var $7OmtM = parcelRequire("7OmtM");
const $bf7a10bb5159fbbd$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("g3aqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9278993db7419c13$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dghu0 = parcelRequire("dghu0");

var $bubxq = parcelRequire("bubxq");

var $gU02S = parcelRequire("gU02S");

var $aWyvu = parcelRequire("aWyvu");

var $hZqF4 = parcelRequire("hZqF4");
const $9278993db7419c13$var$loadingViewContainer = null;
const $9278993db7419c13$var$skeletonContainer = null;
const $9278993db7419c13$var$titleStyle = null;
const $9278993db7419c13$var$titleBlockStyles = null;
const $9278993db7419c13$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $hZqF4.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    const LoadingSkeleton = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $gU02S.LoadingSkeletonNew) : (0, $gU02S.LoadingSkeletonOld);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $bwpsq.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aWyvu.default), {
                            render: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(LoadingSkeleton, {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $bwpsq.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                                height: `${lineHeightRem}rem`
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                                height: lineHeightRem
                            })
                        }),
                        actionGroup
                    ]
                }),
                (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonNew), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                            width: skeletonWidth,
                            height: lineHeightRem
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                            width: skeletonWidth,
                            height: lineHeightRem * 3
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeletonOld), {
                            width: skeletonWidth,
                            height: lineHeightRem
                        })
                    ]
                })
            ]
        })
    });
};
var $9278993db7419c13$export$2e2bcd8739ae039 = $9278993db7419c13$var$HoverCardLoadingView;

});

parcelRegister("f6jZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ebd359d5a8e698$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $3CATS = parcelRequire("3CATS");

var $fgpl1 = parcelRequire("fgpl1");

var $3PAn6 = parcelRequire("3PAn6");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");

var $bubxq = parcelRequire("bubxq");

var $eqoQu = parcelRequire("eqoQu");
const $e7ebd359d5a8e698$var$connectButtonStylesOld = null;
const $e7ebd359d5a8e698$var$connectButtonStyles = null;
const $e7ebd359d5a8e698$var$titleBlockStylesOld = null;
const $e7ebd359d5a8e698$var$titleBlockStyles = null;
const $e7ebd359d5a8e698$var$mainTextStylesOld = null;
const $e7ebd359d5a8e698$var$mainTextStyles = null;
const $e7ebd359d5a8e698$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const data = cardState.details?.data;
    const providerName = (0, $f24gj.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $3CATS.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $8dVIb.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $8dVIb.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
                testId: `${testId}-title`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9" : "_zulp5l1i _bpsp1wq8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-content`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _19pku2gc" : "_11c8dcr7 _19pkcxkx"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-button`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bahesu3 _19pku2gc" : "_1bahesu3 _19pkcxkx"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $e7ebd359d5a8e698$export$2e2bcd8739ae039 = $e7ebd359d5a8e698$var$HoverCardUnauthorisedView;

});
parcelRegister("3PAn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8897e3cb423b2de$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $a8897e3cb423b2de$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $7zaVw.messages).learn_more_about_connecting_account : (0, $7zaVw.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
                href: isProductIntegrationSupported ? (0, $8dVIb.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $8dVIb.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...learnMoreMessage
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: isProductIntegrationSupported ? (0, $8dVIb.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $8dVIb.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                "data-testid": `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    textDecoration: 'underline'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $a8897e3cb423b2de$export$2e2bcd8739ae039 = $a8897e3cb423b2de$var$UnauthorisedViewContent;

});






parcelRegister("4mRkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aaf352da1fa338$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4URMI = parcelRequire("4URMI");
const $22aaf352da1fa338$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $22aaf352da1fa338$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $22aaf352da1fa338$export$2e2bcd8739ae039 = $22aaf352da1fa338$var$LayeredLink;

});


parcelRegister("1Vuck", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $567a4b851e4bc65e$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $567a4b851e4bc65e$export$f3d3482baaff4bf6);

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $2zcFi = parcelRequire("2zcFi");

var $jELGn = parcelRequire("jELGn");

var $dybmx = parcelRequire("dybmx");

var $jq5Nf = parcelRequire("jq5Nf");

var $7zaVw = parcelRequire("7zaVw");

var $kxcRq = parcelRequire("kxcRq");

var $aOsut = parcelRequire("aOsut");
const $567a4b851e4bc65e$export$e68aec76e359e401 = (params)=>{
    const { response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return {
                title: url,
                url: url
            };
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return (0, $2zcFi.default)(params);
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            const preview = (0, $jELGn.default)(response?.data);
            const linkIcon = (0, $dybmx.extractErrorIcon)(response, status);
            const provider = (0, $jq5Nf.default)(response?.data);
            return {
                linkIcon: linkIcon,
                title: url,
                url: url,
                provider: provider,
                preview: preview
            };
    }
};
const $567a4b851e4bc65e$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $567a4b851e4bc65e$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const data = response && response.data || (0, $aOsut.getEmptyJsonLd)();
    const provider = (0, $f24gj.extractProvider)(data);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            const access = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $567a4b851e4bc65e$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $7zaVw.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $kxcRq.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $7zaVw.messages).connect_link_account_card_name,
                onClick: (0, $kxcRq.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $8dVIb.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $7zaVw.messages).cannot_find_link
            };
    }
};

});
parcelRegister("2zcFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $da041debbb7991f6$export$2e2bcd8739ae039);

var $hWyvy = parcelRequire("hWyvy");
var $8Tcl1 = parcelRequire("8Tcl1");
var $ccpJ1 = parcelRequire("ccpJ1");
var $8UXrm = parcelRequire("8UXrm");
var $4MmCl = parcelRequire("4MmCl");
var $eV8m9 = parcelRequire("eV8m9");
var $iPUv2 = parcelRequire("iPUv2");

var $jnrSW = parcelRequire("jnrSW");

var $d4sEp = parcelRequire("d4sEp");

var $9LwFA = parcelRequire("9LwFA");

var $jELGn = parcelRequire("jELGn");

var $bWsp1 = parcelRequire("bWsp1");

var $djFaY = parcelRequire("djFaY");

var $dybmx = parcelRequire("dybmx");

var $jq5Nf = parcelRequire("jq5Nf");

var $iGAv4 = parcelRequire("iGAv4");

var $6N2TY = parcelRequire("6N2TY");
const $da041debbb7991f6$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $8UXrm.extractLink)(data);
    return {
        actions: (0, $d4sEp.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $6N2TY.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $6N2TY.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $6N2TY.extractAttachmentCount)(data),
        authorGroup: (0, $4MmCl.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $eV8m9.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $9LwFA.extractPersonsUpdatedBy)(data),
        commentCount: (0, $6N2TY.extractCommentCount)(data),
        viewCount: (0, $6N2TY.extractViewCount)(data),
        reactCount: (0, $6N2TY.extractReactCount)(data),
        voteCount: (0, $6N2TY.extractVoteCount)(data),
        checklistProgress: (0, $6N2TY.extractChecklistProgress)(data),
        createdBy: (0, $6N2TY.extractCreatedBy)(data),
        ownedBy: (0, $6N2TY.extractOwnedBy)(data),
        assignedTo: (0, $6N2TY.extractAssignedTo)(data),
        createdOn: (0, $8Tcl1.extractDateCreated)(data),
        dueOn: (0, $6N2TY.extractDueOn)(data),
        latestCommit: (0, $iGAv4.extractLatestCommit)(data),
        linkIcon: (0, $dybmx.extractLinkIcon)(response, renderers),
        location: (0, $6N2TY.extractLocation)(data),
        modifiedBy: (0, $6N2TY.extractModifiedBy)(data),
        modifiedOn: (0, $ccpJ1.extractDateUpdated)(data),
        preview: (0, $jELGn.default)(data),
        priority: (0, $bWsp1.default)(data),
        provider: (0, $jq5Nf.default)(data),
        programmingLanguage: (0, $6N2TY.extractProgrammingLanguage)(data),
        readTime: (0, $6N2TY.extractReadTime)(data),
        sentOn: (0, $6N2TY.extractSentOn)(data),
        snippet: (0, $jnrSW.extractSummary)(data) || undefined,
        sourceBranch: (0, $6N2TY.extractSourceBranch)(data),
        state: (0, $djFaY.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $6N2TY.extractSubscriberCount)(data),
        subTasksProgress: (0, $6N2TY.extractSubTasksProgress)(data),
        storyPoints: (0, $6N2TY.extractStoryPoints)(data),
        targetBranch: (0, $6N2TY.extractTargetBranch)(data),
        title: (0, $iPUv2.extractTitle)(data) || url,
        url: url,
        ari: (0, $hWyvy.extractAri)(data)
    };
};
var $da041debbb7991f6$export$2e2bcd8739ae039 = $da041debbb7991f6$var$extractFlexibleUiContext;

});
parcelRegister("8Tcl1", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $ff639713cdfddc0e$export$e1226a5e0bbbf862);
const $ff639713cdfddc0e$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("ccpJ1", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $2985c9016975498b$export$7fc2f5e6f9d22ae7);
const $2985c9016975498b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("jnrSW", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $82a2487542e3dcba$export$db5a8500f6b6286e);
const $82a2487542e3dcba$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("d4sEp", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $c3cafd9d828d6c09$export$abe8d0ca1daa1755);

var $8dVIb = parcelRequire("8dVIb");

var $4ma4m = parcelRequire("4ma4m");

var $f5eJz = parcelRequire("f5eJz");

var $kh3Vl = parcelRequire("kh3Vl");

var $gIJxe = parcelRequire("gIJxe");

var $4DFf8 = parcelRequire("4DFf8");

var $joFPX = parcelRequire("joFPX");

var $ljBcB = parcelRequire("ljBcB");
const $c3cafd9d828d6c09$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $8dVIb.ActionName).CopyLinkAction]: (0, $kh3Vl.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $8dVIb.ActionName).DownloadAction]: (0, $gIJxe.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $8dVIb.ActionName).FollowAction]: (0, $4DFf8.default)(response, actionOptions, id),
        [(0, $8dVIb.ActionName).PreviewAction]: (0, $joFPX.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $8dVIb.ActionName).AutomationAction]: (0, $f5eJz.extractAutomationAction)(response),
        [(0, $8dVIb.InternalActionName).AISummaryAction]: (0, $4ma4m.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $8dVIb.InternalActionName).ViewRelatedLinksAction]: (0, $ljBcB.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4ma4m", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $8cdc7ca64eb62313$export$e7f7a50a8b8932df);

var $evnkj = parcelRequire("evnkj");

var $cnaAy = parcelRequire("cnaAy");

var $dn5wJ = parcelRequire("dn5wJ");
const $8cdc7ca64eb62313$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).AISummaryAction, actionOptions) || !(0, $cnaAy.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("evnkj", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $6626d2f2bee6ec27$export$2487b058456cca75);
const $6626d2f2bee6ec27$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("f5eJz", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $ca59c43d6a564063$export$f913cc6abf3ec084);

var $8dVIb = parcelRequire("8dVIb");
const $ca59c43d6a564063$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $8dVIb.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("kh3Vl", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $156b119eb968da41$export$31ddd5c40039ce53);

var $ewRjE = parcelRequire("ewRjE");
const $156b119eb968da41$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $ewRjE.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ewRjE", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $f95950db90c61c64$export$5ec86886067a062d);

var $8UXrm = parcelRequire("8UXrm");

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");
const $f95950db90c61c64$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $8UXrm.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $8dVIb.ActionName).CopyLinkAction,
        definitionId: (0, $fgpl1.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fgpl1.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fgpl1.getResourceType)(response)
    };
};

});


parcelRegister("gIJxe", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $02d459bef4b0b3b6$export$f6c386869a352b1f);

var $gOP67 = parcelRequire("gOP67");
const $02d459bef4b0b3b6$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $gOP67.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("gOP67", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $8cd6513c4477faeb$export$ea97cd34c2ca86de);

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $kxcRq = parcelRequire("kxcRq");

var $evnkj = parcelRequire("evnkj");

var $5U430 = parcelRequire("5U430");

var $e2ZVS = parcelRequire("e2ZVS");
const $8cd6513c4477faeb$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $5U430.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $e2ZVS.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $kxcRq.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $8dVIb.ActionName).DownloadAction,
            definitionId: (0, $fgpl1.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $fgpl1.getExtensionKey)(response),
            id: id,
            resourceType: (0, $fgpl1.getResourceType)(response)
        };
    }
};

});
parcelRegister("5U430", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $76a260c3f7e7678d$export$8f031784a3a03b23);
const $76a260c3f7e7678d$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("e2ZVS", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $ef91c3db80f281ff$export$9682e3ac9d184e95);
const $ef91c3db80f281ff$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("4DFf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a99662467a25c4e$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");
var $FcDCF = parcelRequire("FcDCF");

var $T540Y = parcelRequire("T540Y");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $dn5wJ = parcelRequire("dn5wJ");

var $j4IjY = parcelRequire("j4IjY");
const $5a99662467a25c4e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $fgpl1.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $j4IjY.default)(data);
    const type = (0, $FcDCF.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $T540Y.SmartLinkActionType).FollowEntityAction || actionName === (0, $T540Y.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $8UXrm.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $T540Y.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $5a99662467a25c4e$export$2e2bcd8739ae039 = $5a99662467a25c4e$var$extractFollowAction;

});
parcelRegister("j4IjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $491a605bed171307$export$2e2bcd8739ae039);
const $491a605bed171307$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $491a605bed171307$export$2e2bcd8739ae039 = $491a605bed171307$var$extractServerAction;

});


parcelRegister("joFPX", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $67a9503b149a9ddf$export$9f0d9100b079448);

var $k1bRY = parcelRequire("k1bRY");
const $67a9503b149a9ddf$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $k1bRY.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("k1bRY", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $ae749ffcba0ba676$export$caf83f49e52ac0bb);

var $8UXrm = parcelRequire("8UXrm");
var $k9B19 = parcelRequire("k9B19");
var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $2Fcti = parcelRequire("2Fcti");

var $hYF5d = parcelRequire("hYF5d");

var $V4gq9 = parcelRequire("V4gq9");

var $dybmx = parcelRequire("dybmx");

var $gOP67 = parcelRequire("gOP67");

var $eBrh9 = parcelRequire("eBrh9");
const $ae749ffcba0ba676$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $k9B19.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $8UXrm.extractLink)(data);
        const extensionKey = (0, $fgpl1.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $2Fcti.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $gOP67.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $eBrh9.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
                    isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
                    linkIcon: (0, $dybmx.extractLinkIcon)(response),
                    providerName: (0, $f24gj.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: src,
                    title: (0, $iPUv2.extractTitle)(data),
                    url: url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $8dVIb.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("2Fcti", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2555d47e7922f4ad$export$7859f96cd8cff034);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");
const $2555d47e7922f4ad$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2555d47e7922f4ad$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("cOEDE"));
    (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).render(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Modal.default, {
            ...props,
            iframeName: $2555d47e7922f4ad$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("cOEDE", function(module, exports) {

let $9549ad82f899be9f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9549ad82f899be9f$var$load("h2MrD"),
    $9549ad82f899be9f$var$load("bYT2S"),
    $9549ad82f899be9f$var$load("9ytm6")
]).then(()=>parcelRequire('amcti'));

});


parcelRegister("hYF5d", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $693566d688a51b19$export$38d755f52cdf4acb);

var $dvNbb = parcelRequire("dvNbb");
const $693566d688a51b19$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $dvNbb.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("dvNbb", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $9b14bed6babdc545$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $9b14bed6babdc545$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $9b14bed6babdc545$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $9b14bed6babdc545$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $9b14bed6babdc545$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $9b14bed6babdc545$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $9b14bed6babdc545$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $9b14bed6babdc545$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $9b14bed6babdc545$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $9b14bed6babdc545$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $9b14bed6babdc545$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $9b14bed6babdc545$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $9b14bed6babdc545$export$fe44ce30fd8d131b);
const $9b14bed6babdc545$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9b14bed6babdc545$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9b14bed6babdc545$export$84a73a0383f58180 = 'JiraTask';
const $9b14bed6babdc545$export$c6c83963a9378a67 = 'JiraSubTask';
const $9b14bed6babdc545$export$58af3c426c111a6d = 'JiraStory';
const $9b14bed6babdc545$export$ac9898a63417219e = 'JiraBug';
const $9b14bed6babdc545$export$54db5e3fb12e39cd = 'JiraEpic';
const $9b14bed6babdc545$export$2f54a5a217202c85 = 'JiraIncident';
const $9b14bed6babdc545$export$d097371052bfc411 = 'JiraServiceRequest';
const $9b14bed6babdc545$export$efd9452ad16c6676 = 'JiraChange';
const $9b14bed6babdc545$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9b14bed6babdc545$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $9b14bed6babdc545$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});


parcelRegister("V4gq9", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $635b28bc2d55c0b7$export$4f3ffbb500daac5a);
const $635b28bc2d55c0b7$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("dybmx", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $d7af83be96aed150$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $d7af83be96aed150$export$bdd29be9b0395931);

var $8dVIb = parcelRequire("8dVIb");

var $9fbCf = parcelRequire("9fbCf");

var $5ZCMp = parcelRequire("5ZCMp");

var $jq5Nf = parcelRequire("jq5Nf");
const $d7af83be96aed150$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $9fbCf.default)(data, renderers);
    return {
        ...(0, $5ZCMp.default)(data),
        render: render
    };
};
const $d7af83be96aed150$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $jq5Nf.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $8dVIb.IconType).Forbidden
            };
        case (0, $8dVIb.SmartLinkStatus).NotFound:
            return {
                icon: (0, $8dVIb.IconType).Error
            };
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $8dVIb.IconType).Default
            };
    }
};

});
parcelRegister("9fbCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc79bd445a96437$export$2e2bcd8739ae039);
const $3cc79bd445a96437$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $3cc79bd445a96437$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $3cc79bd445a96437$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $3cc79bd445a96437$export$2e2bcd8739ae039 = $3cc79bd445a96437$var$extractIconRenderer;

});

parcelRegister("5ZCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f6ae1c2ef653082$export$2e2bcd8739ae039);

var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");

var $3TBiE = parcelRequire("3TBiE");

var $4DoyP = parcelRequire("4DoyP");

var $a4RsY = parcelRequire("a4RsY");

var $dvNbb = parcelRequire("dvNbb");

var $1gwFB = parcelRequire("1gwFB");

var $liAf6 = parcelRequire("liAf6");

var $cKwAC = parcelRequire("cKwAC");

var $jq5Nf = parcelRequire("jq5Nf");

var $iWNKM = parcelRequire("iWNKM");
const $4f6ae1c2ef653082$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $a4RsY.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $4f6ae1c2ef653082$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0] : type;
};
const $4f6ae1c2ef653082$var$isJiraProvider = (provider)=>provider === (0, $dvNbb.JIRA_GENERATOR_ID);
function $4f6ae1c2ef653082$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $liAf6.default)(fileFormat);
    const documentTypeIcon = $4f6ae1c2ef653082$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $1gwFB.default)(type, label, providerId);
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $4f6ae1c2ef653082$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $8dVIb.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $8dVIb.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $8dVIb.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $8dVIb.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $8dVIb.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $8dVIb.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $8dVIb.IconType).Task,
                label: taskLabel
            };
            if ($4f6ae1c2ef653082$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $4f6ae1c2ef653082$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $cKwAC.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $4f6ae1c2ef653082$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $iPUv2.extractTitle)(data);
    const type = $4f6ae1c2ef653082$var$extractType(data);
    const urlIcon = (0, $iWNKM.default)(data.icon, label);
    const providerIcon = (0, $jq5Nf.default)(data);
    return $4f6ae1c2ef653082$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $4f6ae1c2ef653082$export$2e2bcd8739ae039 = $4f6ae1c2ef653082$var$extractJsonldDataIcon;

});
parcelRegister("3TBiE", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $99be71cd5a3b0274$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $99be71cd5a3b0274$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("4DoyP", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4);
const $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("a4RsY", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $81dd8ddf907a1532$export$ed3fd59180514d27);

var $cuw1y = parcelRequire("cuw1y");
const $81dd8ddf907a1532$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("1gwFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8e24b11256d3ae$export$2e2bcd8739ae039);

var $f24gj = parcelRequire("f24gj");

var $8dVIb = parcelRequire("8dVIb");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $2f8e24b11256d3ae$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $8dVIb.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $f24gj.isConfluenceGenerator)(providerId)) return {
                icon: (0, $8dVIb.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $8dVIb.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $8dVIb.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $2f8e24b11256d3ae$export$2e2bcd8739ae039 = $2f8e24b11256d3ae$var$extractDocumentTypeIcon;

});

parcelRegister("cKwAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a727b28b60947e$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $97a727b28b60947e$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $8dVIb.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $8dVIb.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $8dVIb.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $8dVIb.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $8dVIb.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $8dVIb.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $8dVIb.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $8dVIb.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $8dVIb.IconType).Task,
                label: label
            };
    }
};
var $97a727b28b60947e$export$2e2bcd8739ae039 = $97a727b28b60947e$var$extractJiraTaskIcon;

});

parcelRegister("jq5Nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e0775b3750bf70$export$2e2bcd8739ae039);

var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");

var $dvNbb = parcelRequire("dvNbb");

var $iWNKM = parcelRequire("iWNKM");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $87e0775b3750bf70$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $iPUv2.extractTitle)(data);
    if (provider === (0, $dvNbb.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $8dVIb.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $dvNbb.JIRA_GENERATOR_ID)) return {
        icon: (0, $8dVIb.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $iWNKM.default)(icon, label);
};
var $87e0775b3750bf70$export$2e2bcd8739ae039 = $87e0775b3750bf70$var$extractProviderIcon;

});
parcelRegister("iWNKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8418e6f5863288f0$export$2e2bcd8739ae039);

var $cuw1y = parcelRequire("cuw1y");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $8418e6f5863288f0$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $cuw1y.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $8418e6f5863288f0$export$2e2bcd8739ae039 = $8418e6f5863288f0$var$extractUrlIcon;

});




parcelRegister("eBrh9", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $d2874e5e099b8c6e$export$88c5813cfbbe4e4c);

var $8UXrm = parcelRequire("8UXrm");

var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $kxcRq = parcelRequire("kxcRq");

var $evnkj = parcelRequire("evnkj");

var $5U430 = parcelRequire("5U430");
const $d2874e5e099b8c6e$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $8UXrm.extractLink)(data);
    const viewActionExists = (0, $5U430.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $kxcRq.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $fgpl1.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fgpl1.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fgpl1.getResourceType)(response)
    };
};

});



parcelRegister("ljBcB", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $a600a657ec97b3e1$export$debae7424a0231b9);

var $hWyvy = parcelRequire("hWyvy");
const $a600a657ec97b3e1$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hWyvy.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("9LwFA", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $4c9ea88664552b6e$export$216e4f6aa7c169b8);

var $o6TQ1 = parcelRequire("o6TQ1");
var $aj6Xc = parcelRequire("aj6Xc");
const $4c9ea88664552b6e$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $o6TQ1.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $aj6Xc.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("o6TQ1", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $e9d0787cbe8b8bff$export$6281d080d62a0719);

var $aj6Xc = parcelRequire("aj6Xc");
const $e9d0787cbe8b8bff$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $aj6Xc.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $aj6Xc.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("bWsp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $92024e0264c50850$export$2e2bcd8739ae039);

var $cuw1y = parcelRequire("cuw1y");

var $8dVIb = parcelRequire("8dVIb");
const $92024e0264c50850$var$priorityMapper = {
    blocker: (0, $8dVIb.IconType).PriorityBlocker,
    critical: (0, $8dVIb.IconType).PriorityCritical,
    high: (0, $8dVIb.IconType).PriorityHigh,
    highest: (0, $8dVIb.IconType).PriorityHighest,
    low: (0, $8dVIb.IconType).PriorityLow,
    lowest: (0, $8dVIb.IconType).PriorityLowest,
    major: (0, $8dVIb.IconType).PriorityMajor,
    medium: (0, $8dVIb.IconType).PriorityMedium,
    minor: (0, $8dVIb.IconType).PriorityMinor,
    trivial: (0, $8dVIb.IconType).PriorityTrivial,
    undefined: (0, $8dVIb.IconType).PriorityUndefined
};
const $92024e0264c50850$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $92024e0264c50850$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $92024e0264c50850$export$2e2bcd8739ae039 = $92024e0264c50850$var$extractPriority;

});

parcelRegister("djFaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c680025bc04d725$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $dn5wJ = parcelRequire("dn5wJ");

var $k1bRY = parcelRequire("k1bRY");

var $eL1Oa = parcelRequire("eL1Oa");

var $j4IjY = parcelRequire("j4IjY");
const $9c680025bc04d725$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $9c680025bc04d725$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $fgpl1.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $j4IjY.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $8UXrm.extractLink)(data);
    const invokePreviewAction = response ? (0, $k1bRY.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $9c680025bc04d725$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $eL1Oa.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $9c680025bc04d725$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $9c680025bc04d725$export$2e2bcd8739ae039 = $9c680025bc04d725$var$extractState;

});
parcelRegister("eL1Oa", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $00b49e71ec2a1469$export$e5da155556a77bca);

var $FcDCF = parcelRequire("FcDCF");

var $hJJo2 = parcelRequire("hJJo2");

var $8KYrd = parcelRequire("8KYrd");

var $1fxuS = parcelRequire("1fxuS");

var $a4RsY = parcelRequire("a4RsY");
const $00b49e71ec2a1469$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $FcDCF.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $8KYrd.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $1fxuS.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $00b49e71ec2a1469$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $hJJo2.extractState)(jsonLd);
    }
};
const $00b49e71ec2a1469$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $a4RsY.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("hJJo2", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $23353713d30390cb$export$5e4074cbce6574c7);

var $5Sb4A = parcelRequire("5Sb4A");
// Maps accent color short names to their corresponding background and text colors
const $23353713d30390cb$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $23353713d30390cb$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $5Sb4A.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $5Sb4A.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $23353713d30390cb$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("5Sb4A", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $0823e05e6f9f26fe$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $0823e05e6f9f26fe$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $0823e05e6f9f26fe$export$772610da74ddbc07);
const $0823e05e6f9f26fe$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $0823e05e6f9f26fe$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $0823e05e6f9f26fe$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $0823e05e6f9f26fe$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $0823e05e6f9f26fe$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("8KYrd", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $6e0524caff97ae26$export$962a8da34cf78a4f);

var $5Sb4A = parcelRequire("5Sb4A");
const $6e0524caff97ae26$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($6e0524caff97ae26$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $6e0524caff97ae26$var$extractTagItem(tag);
    }
};
const $6e0524caff97ae26$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $5Sb4A.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("1fxuS", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $4b88cdff9f070a4a$export$7698df1946deda72);
const $4b88cdff9f070a4a$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("iGAv4", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $0e72a17e0fb58d4d$export$f222392162cff0d8);
const $0e72a17e0fb58d4d$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("82kHN", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $315bbe8c3c3dac23$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $315bbe8c3c3dac23$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $315bbe8c3c3dac23$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $315bbe8c3c3dac23$export$9671929f11bd4ad8);

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $6N2TY = parcelRequire("6N2TY");

var $fgpl1 = parcelRequire("fgpl1");
const $315bbe8c3c3dac23$var$baseTopMetadata = [
    {
        name: (0, $8dVIb.ElementName).ModifiedOn
    },
    {
        name: (0, $8dVIb.ElementName).AttachmentCount
    },
    {
        name: (0, $8dVIb.ElementName).SubscriberCount
    },
    {
        name: (0, $8dVIb.ElementName).VoteCount
    },
    {
        name: (0, $8dVIb.ElementName).DueOn
    },
    {
        name: (0, $8dVIb.ElementName).ReadTime
    }
];
const $315bbe8c3c3dac23$var$baseBottomMetaData = [
    {
        name: (0, $8dVIb.ElementName).ReactCount
    },
    {
        name: (0, $8dVIb.ElementName).CommentCount
    },
    {
        name: (0, $8dVIb.ElementName).ViewCount
    },
    {
        name: (0, $8dVIb.ElementName).Priority
    },
    {
        name: (0, $8dVIb.ElementName).SubTasksProgress
    },
    {
        name: (0, $8dVIb.ElementName).ChecklistProgress
    }
];
const $315bbe8c3c3dac23$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $fgpl1.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $8dVIb.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $8dVIb.ElementName).AuthorGroup
        },
        {
            name: (0, $8dVIb.ElementName).CreatedBy
        },
        ...$315bbe8c3c3dac23$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $315bbe8c3c3dac23$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $8dVIb.ElementName).LatestCommit
                    },
                    {
                        name: (0, $8dVIb.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            if ((0, $VSDnB.fg)('expandable_smart_links_for_scorecards_v2')) return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $6N2TY.extractOwnedBy)(data) ? [
                    {
                        name: (0, $8dVIb.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).OwnedBy
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).AppliedToComponentsCount
                    },
                    ...$315bbe8c3c3dac23$var$baseBottomMetaData
                ]
            };
            else return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $6N2TY.extractOwnedBy)(data) ? [
                    {
                        name: (0, $8dVIb.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).OwnedBy
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = !!data['atlassian:ownedBy'] ?? false;
            let topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).AuthorGroup
                },
                {
                    name: (0, $8dVIb.ElementName).CreatedBy
                },
                {
                    name: (0, $8dVIb.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).AssignedToGroup
                },
                {
                    name: (0, $8dVIb.ElementName).AssignedTo
                },
                {
                    name: (0, $8dVIb.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan && (0, $VSDnB.fg)('smart_links_for_plans_platform')) topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).OwnedByGroup
                },
                {
                    name: (0, $8dVIb.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).StoryPoints
                    },
                    {
                        name: (0, $8dVIb.ElementName).Priority
                    },
                    {
                        name: (0, $8dVIb.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).ReactCount
                    },
                    {
                        name: (0, $8dVIb.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).CollaboratorGroup
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $315bbe8c3c3dac23$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true
};
const $315bbe8c3c3dac23$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $8dVIb.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $8dVIb.SmartLinkSize).Large
};
const $315bbe8c3c3dac23$export$9671929f11bd4ad8 = {
    placement: (0, $8dVIb.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("1dEUF", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $f3e0678ba71181d8$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f3e0678ba71181d8$var$flexibleBlockCardStyle = null;
const $f3e0678ba71181d8$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("kQeqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ee13c9f8fe006$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $bwyQI = parcelRequire("bwyQI");

var $3G2gB = parcelRequire("3G2gB");

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");


var $8PVtF = parcelRequire("8PVtF");

var $eCNt3 = parcelRequire("eCNt3");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $aOsut = parcelRequire("aOsut");

var $k39kU = parcelRequire("k39kU");

var $jgxl3 = parcelRequire("jgxl3");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $9b3ee13c9f8fe006$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $9b3ee13c9f8fe006$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intl = (0, $koVbs.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
    const provider = (0, $f24gj.extractProvider)(details?.data);
    const providerName = provider?.text || '';
    const messageContext = (0, $5uXOq.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
            children: (0, $eCNt3.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $5uXOq.useMemo)(()=>{
        return (0, $8PVtF.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $5uXOq.useMemo)(()=>{
        const descriptor = (0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $jgxl3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $jgxl3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19497
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))), {
                label: "forbidden-lock-icon",
                size: "small",
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt"
                ])
            })
        ]
    });
};
var $9b3ee13c9f8fe006$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($9b3ee13c9f8fe006$var$ForbiddenView);

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});

parcelRegister("cL21r", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $4b469267e6199ae7$export$d14c2a6dee946f52);

var $7zaVw = parcelRequire("7zaVw");
const $4b469267e6199ae7$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $7zaVw.messages)) return (0, $7zaVw.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("jgxl3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $4f0bf32284a5caf2$export$59f8830fb5467e35);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $4f0bf32284a5caf2$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $8dVIb.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("7wrOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d316574b181170a3$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $bwyQI = parcelRequire("bwyQI");

var $3G2gB = parcelRequire("3G2gB");

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");


var $7zaVw = parcelRequire("7zaVw");

var $k39kU = parcelRequire("k39kU");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $d316574b181170a3$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d316574b181170a3$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $koVbs.default)();
    const { cardState: cardState } = props;
    const product = (0, $5uXOq.useMemo)(()=>{
        const provider = (0, $f24gj.extractProvider)(cardState?.details?.data);
        return provider?.text ?? '';
    }, [
        cardState?.details?.data
    ]);
    const title = (0, $5uXOq.useMemo)(()=>intl.formatMessage((0, $7zaVw.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $5uXOq.useMemo)(()=>({
            descriptor: (0, $7zaVw.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19497
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))), {
                label: "not-found-lock-icon",
                size: "small",
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt"
                ])
            })
        ]
    });
};
var $d316574b181170a3$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($d316574b181170a3$var$NotFoundView);

});

parcelRegister("kc7yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b1742d0d340851$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $9fYWd = parcelRequire("9fYWd");

var $ietxm = parcelRequire("ietxm");
var $gg6Qm = parcelRequire("gg6Qm");
var $hYQw7 = parcelRequire("hYQw7");
var $1JaZ4 = parcelRequire("1JaZ4");
var $buvhv = parcelRequire("buvhv");

var $82kHN = parcelRequire("82kHN");

var $1dEUF = parcelRequire("1dEUF");
const $49b1742d0d340851$var$titleBlockCssOld = null;
const $49b1742d0d340851$var$titleBlockCss = null;
const $49b1742d0d340851$var$footerBlockCssOld = null;
const $49b1742d0d340851$var$footerBlockCss = null;
const $49b1742d0d340851$var$metadataBlockCssOld = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $49b1742d0d340851$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $82kHN.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $8dVIb.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $8dVIb.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $8dVIb.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const status = cardState.status;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: (0, $82kHN.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...(0, $82kHN.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $8dVIb.ElementName).Location
                    }
                ],
                metadataPosition: (0, $8dVIb.SmartLinkPosition).Top,
                status: status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9 _2yhz14q2" : "_zulpcxkx _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: topMetadata,
                maxLines: 1,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_wwyvidpf _1sxbcxkx _i8d01j6v"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: bottomMetadata,
                maxLines: 1,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_wwyvidpf _1sxbcxkx _i8d01j6v"
                ])
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ...(0, $82kHN.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                },
                status: (0, $8dVIb.SmartLinkStatus).Resolved
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ietxm.default), {
                actions: footerActions,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb" : "_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj"
                ])
            })
        ]
    });
};
var $49b1742d0d340851$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($49b1742d0d340851$var$ResolvedView);

});

parcelRegister("1PV7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $163450cca1677688$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $fgpl1 = parcelRequire("fgpl1");

var $3PAn6 = parcelRequire("3PAn6");

var $1CwNu = parcelRequire("1CwNu");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $163450cca1677688$var$contentStylesOld = null;
const $163450cca1677688$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $163450cca1677688$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const data = cardState.details?.data;
    const providerName = (0, $f24gj.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(cardState?.details);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>onAuthorize ? [
            (0, $1CwNu.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $bwpsq.default)([
                (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _syaz1fxt _19pku2gc" : "_11c8dcr7 _syaz131l _19pkcxkx"
            ]),
            children: content
        })
    });
};
var $163450cca1677688$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($163450cca1677688$var$UnauthorisedView);

});
parcelRegister("1CwNu", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $712c9d89e4ab58d6$export$34cef2b72294bd84);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $712c9d89e4ab58d6$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $8dVIb.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("7RcXv", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $ab3d9e42a13cc11c$export$6789d7ecdc77631b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $8PVtF = parcelRequire("8PVtF");

var $lNtMX = parcelRequire("lNtMX");

var $ctwhA = parcelRequire("ctwhA");

var $fgpl1 = parcelRequire("fgpl1");

var $6TU5j = parcelRequire("6TU5j");

var $aOsut = parcelRequire("aOsut");

var $7xFN9 = parcelRequire("7xFN9");

var $kc7yu = parcelRequire("kc7yu");

var $ir8YW = parcelRequire("ir8YW");

var $iJqW5 = parcelRequire("iJqW5");

var $39ESV = parcelRequire("39ESV");

var $5VvNe = parcelRequire("5VvNe");

var $d0weD = parcelRequire("d0weD");

var $4WY3L = parcelRequire("4WY3L");
const $ab3d9e42a13cc11c$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $fgpl1.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $6TU5j.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            });
        case 'resolved':
            const resolvedViewProps = (0, $lNtMX.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $VSDnB.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $7xFN9.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                    const unauthViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WY3L.default), {
                        context: unauthViewProps.context,
                        extensionKey: extensionKey,
                        frameStyle: frameStyle,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        inheritDimensions: inheritDimensions,
                        isSelected: isSelected,
                        onAuthorize: handleAuthorize,
                        onClick: handleFrameClick,
                        testId: testId,
                        url: unauthViewProps.link
                    });
                }
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0weD.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $ctwhA.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ir8YW.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WY3L.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0weD.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39ESV.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5VvNe.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJqW5.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("lNtMX", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $0b9efe0d16e320ac$export$d6cf81ca6e68bcc3);

var $kYwnb = parcelRequire("kYwnb");
var $8UXrm = parcelRequire("8UXrm");
var $k9B19 = parcelRequire("k9B19");
var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $cuw1y = parcelRequire("cuw1y");

var $VSDnB = parcelRequire("VSDnB");

var $aOsut = parcelRequire("aOsut");

var $3TBiE = parcelRequire("3TBiE");

var $hYF5d = parcelRequire("hYF5d");

var $V4gq9 = parcelRequire("V4gq9");
const $0b9efe0d16e320ac$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $k9B19.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
function $0b9efe0d16e320ac$var$generateContext(jsonLd) {
    const provider = (0, $f24gj.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $cuw1y.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $f24gj.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
/**
 * We can migrate this to link extractors once we have deprecated JsonLd
 */ function $0b9efe0d16e320ac$var$extractSmartLinkContext(response) {
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityProvider)(response);
    return $0b9efe0d16e320ac$var$generateContext(response?.data);
}
const $0b9efe0d16e320ac$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $aOsut.getEmptyJsonLd)();
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return {
        link: (0, $dhQ1x.extractSmartLinkUrl)(response) || '',
        title: (0, $dhQ1x.extractSmartLinkTitle)(response),
        context: $0b9efe0d16e320ac$var$extractSmartLinkContext(response),
        preview: (0, $dhQ1x.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
        isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta)
    };
    return {
        link: (0, $8UXrm.extractLink)(jsonLd) || '',
        title: (0, $iPUv2.extractTitle)(jsonLd),
        context: $0b9efe0d16e320ac$var$generateContext(jsonLd),
        preview: $0b9efe0d16e320ac$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
        isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta)
    };
};

});

parcelRegister("ctwhA", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $240edc2fd862d8a6$export$68e1703c529dc7e0);

var $kYwnb = parcelRequire("kYwnb");
var $8UXrm = parcelRequire("8UXrm");
var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");

var $VSDnB = parcelRequire("VSDnB");

var $2Gj5n = parcelRequire("2Gj5n");

var $eL1Oa = parcelRequire("eL1Oa");

var $8Kv84 = parcelRequire("8Kv84");

var $6tk3N = parcelRequire("6tk3N");

var $dvNbb = parcelRequire("dvNbb");
const $240edc2fd862d8a6$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $f24gj.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $dvNbb.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $dvNbb.JIRA_GENERATOR_ID)) return (0, $2Gj5n.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $2Gj5n.extractIcon)(jsonLd, 'provider', showIconLabel);
};
const $240edc2fd862d8a6$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const provider = (0, $kYwnb.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more nouns
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $240edc2fd862d8a6$var$extractInlineIcon(response?.data, showLabel);
};
const $240edc2fd862d8a6$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data;
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return {
        icon: $240edc2fd862d8a6$var$extractSmartLinkInlineIcon(response, showLabel),
        link: (0, $dhQ1x.extractSmartLinkUrl)(response),
        title: (0, $dhQ1x.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        // As we migrate to support more nouns we can incorporate these fields
        lozenge: (0, $eL1Oa.extractLozenge)(jsonLd),
        titleTextColor: (0, $8Kv84.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $6tk3N.extractTitlePrefix)(jsonLd, renderers, 'inline')
    };
    return {
        link: (0, $8UXrm.extractLink)(jsonLd),
        title: (0, $iPUv2.extractTitle)(jsonLd, removeTextHighlightingFromTitle),
        lozenge: (0, $eL1Oa.extractLozenge)(jsonLd),
        icon: $240edc2fd862d8a6$var$extractInlineIcon(jsonLd, showLabel),
        titleTextColor: (0, $8Kv84.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $6tk3N.extractTitlePrefix)(jsonLd, renderers, 'inline')
    };
};

});
parcelRegister("2Gj5n", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $b9f947e5dca4cb3d$export$64bdf1f5e49e8626);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4sBeG = parcelRequire("4sBeG");

var $ezu4w = parcelRequire("ezu4w");

var $bPjbr = parcelRequire("bPjbr");

var $6qWjs = parcelRequire("6qWjs");

var $ercGv = parcelRequire("ercGv");

var $ckyDP = parcelRequire("ckyDP");

var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");
var $cuw1y = parcelRequire("cuw1y");

var $kxcRq = parcelRequire("kxcRq");

var $a4RsY = parcelRequire("a4RsY");

var $6mmu7 = parcelRequire("6mmu7");

var $eeWf5 = parcelRequire("eeWf5");

var $i6XYa = parcelRequire("i6XYa");

var $3TBiE = parcelRequire("3TBiE");

var $4DoyP = parcelRequire("4DoyP");
const $b9f947e5dca4cb3d$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $iPUv2.extractTitle)(jsonLd),
        provider: (0, $f24gj.extractProvider)(jsonLd),
        fileFormat: (0, $6mmu7.extractFileFormat)(jsonLd),
        taskType: (0, $a4RsY.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0];
        return $b9f947e5dca4cb3d$var$extractIconByType(highestPriorityType, opts);
    } else return $b9f947e5dca4cb3d$var$extractIconByType(type, opts);
};
function $b9f947e5dca4cb3d$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bPjbr.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6qWjs.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4sBeG.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ezu4w.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $i6XYa.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $b9f947e5dca4cb3d$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $b9f947e5dca4cb3d$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $kxcRq.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $b9f947e5dca4cb3d$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $eeWf5.extractIconFromDocument)(type, opts);
        default:
            return $b9f947e5dca4cb3d$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("4sBeG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6b6e63637c1c2754$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd5a8d264ca7a1e79e3d50d476094729>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4iPF3 = parcelRequire("4iPF3");

var $VSDnB = parcelRequire("VSDnB");

var $9ORcR = parcelRequire("9ORcR");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6b6e63637c1c2754$var$Branch16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ORcR.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ORcR.default), {
        label: label,
        testId: testId
    });
};
$6b6e63637c1c2754$var$Branch16Icon.displayName = 'Branch16Icon';
var $6b6e63637c1c2754$export$2e2bcd8739ae039 = $6b6e63637c1c2754$var$Branch16Icon;

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9ORcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1801d86c423f8469$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::371b0d35eca629b3ebb5e933140aedc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $1801d86c423f8469$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$1801d86c423f8469$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1801d86c423f8469$export$2e2bcd8739ae039 = $1801d86c423f8469$var$Branch16Icon;

});


parcelRegister("ezu4w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f0dda3514063910b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2e0cf5105bbbaa2e318211c53ac326e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $jSlaY = parcelRequire("jSlaY");

var $VSDnB = parcelRequire("VSDnB");

var $RsLsu = parcelRequire("RsLsu");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f0dda3514063910b$var$Code16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jSlaY))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RsLsu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RsLsu.default), {
        label: label,
        testId: testId
    });
};
$f0dda3514063910b$var$Code16Icon.displayName = 'Code16Icon';
var $f0dda3514063910b$export$2e2bcd8739ae039 = $f0dda3514063910b$var$Code16Icon;

});
parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("RsLsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffae1b83b5704dc$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a17b0b5d454f4262ba3195f959601cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $7ffae1b83b5704dc$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7ffae1b83b5704dc$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ffae1b83b5704dc$export$2e2bcd8739ae039 = $7ffae1b83b5704dc$var$Code16Icon;

});


parcelRegister("bPjbr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f3351ecfbe1e828a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96efea4cb290db7d8f614246fd62e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $bFklq = parcelRequire("bFklq");

var $VSDnB = parcelRequire("VSDnB");

var $a0LEu = parcelRequire("a0LEu");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f3351ecfbe1e828a$var$Commit16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFklq))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a0LEu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a0LEu.default), {
        label: label,
        testId: testId
    });
};
$f3351ecfbe1e828a$var$Commit16Icon.displayName = 'Commit16Icon';
var $f3351ecfbe1e828a$export$2e2bcd8739ae039 = $f3351ecfbe1e828a$var$Commit16Icon;

});
parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("a0LEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $87782212607829d3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50d5a3bab2c708a6de1c7dc72e3a297a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $87782212607829d3$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$87782212607829d3$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$87782212607829d3$export$2e2bcd8739ae039 = $87782212607829d3$var$Commit16Icon;

});


parcelRegister("6qWjs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1636b9971be53c9b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::499dedcb1e659dc62cb0d811acc9f742>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $hXgVM = parcelRequire("hXgVM");

var $VSDnB = parcelRequire("VSDnB");

var $9VouT = parcelRequire("9VouT");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $1636b9971be53c9b$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hXgVM))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VouT.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VouT.default), {
        label: label,
        testId: testId
    });
};
$1636b9971be53c9b$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $1636b9971be53c9b$export$2e2bcd8739ae039 = $1636b9971be53c9b$var$PullRequest16Icon;

});
parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("9VouT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0bea366084931a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f46cc1f5eba58da93be626b062afbd6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $1a0bea366084931a$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$1a0bea366084931a$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1a0bea366084931a$export$2e2bcd8739ae039 = $1a0bea366084931a$var$PullRequest16Icon;

});


parcelRegister("ercGv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95e8963209f4e129$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb120ef54d45ebd04018c195938778f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4xPlE = parcelRequire("4xPlE");

var $VSDnB = parcelRequire("VSDnB");

var $2BNVE = parcelRequire("2BNVE");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95e8963209f4e129$var$Task16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
        label: label,
        testId: testId
    });
};
$95e8963209f4e129$var$Task16Icon.displayName = 'Task16Icon';
var $95e8963209f4e129$export$2e2bcd8739ae039 = $95e8963209f4e129$var$Task16Icon;

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("2BNVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ed5bdbe4530df8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $95ed5bdbe4530df8$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$95ed5bdbe4530df8$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$95ed5bdbe4530df8$export$2e2bcd8739ae039 = $95ed5bdbe4530df8$var$Task16Icon;

});


parcelRegister("6mmu7", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $086b33d374843724$export$f2d65f02f6888b60);
const $086b33d374843724$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("eeWf5", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $43bc73545f7cdfda$export$25c24c7f577936d3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $duwKf = parcelRequire("duwKf");

var $7BHMh = parcelRequire("7BHMh");

var $h7zk4 = parcelRequire("h7zk4");

var $2Bgv8 = parcelRequire("2Bgv8");

var $iRZQl = parcelRequire("iRZQl");

var $5mR3i = parcelRequire("5mR3i");

var $5xHlE = parcelRequire("5xHlE");

var $f24gj = parcelRequire("f24gj");

var $VSDnB = parcelRequire("VSDnB");

var $dVpJZ = parcelRequire("dVpJZ");

var $gVXQp = parcelRequire("gVXQp");

var $3vtQf = parcelRequire("3vtQf");

var $9bx9i = parcelRequire("9bx9i");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $kxcRq = parcelRequire("kxcRq");

var $3TBiE = parcelRequire("3TBiE");
// TODO Delete this and rename BlogIconNew to BlogIcon when cleaning platform-smart-card-icon-migration
const $43bc73545f7cdfda$var$BlogIcon = (props)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVpJZ.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iRZQl.default), {
        ...props
    });
};
// TODO Delete this and rename FileIconNew to FileIcon when cleaning platform-smart-card-icon-migration
const $43bc73545f7cdfda$var$FileIcon = (props)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3vtQf.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7BHMh))), {
        ...props
    });
};
// TODO Delete this and rename DocumentIconNew to DocumentIcon when cleaning platform-smart-card-icon-migration
const $43bc73545f7cdfda$var$DocumentIcon = (props)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($duwKf))), {
        ...props
    });
};
// TODO Delete this and rename PresentationIconNew to PresentationIcon when cleaning platform-smart-card-icon-migration
const $43bc73545f7cdfda$var$PresentationIcon = (props)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVXQp.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h7zk4))), {
        ...props
    });
};
// TODO Delete this and rename SpreadsheetIconNew to SpreadsheetIcon when cleaning platform-smart-card-icon-migration
const $43bc73545f7cdfda$var$SpreadsheetIcon = (props)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9bx9i.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Bgv8))), {
        ...props
    });
};
// TODO Delete this and rename DocumentFilledIconNew to DocumentFilledIcon when cleaning platform-smart-card-icon-migration
const $43bc73545f7cdfda$var$DocumentFilledIcon = (props)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5mR3i))), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5xHlE))), {
        ...props
    });
};
const $43bc73545f7cdfda$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $43bc73545f7cdfda$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $43bc73545f7cdfda$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $43bc73545f7cdfda$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $kxcRq.getIconForFileType)(opts.fileFormat);
};
const $43bc73545f7cdfda$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$BlogIcon, {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $43bc73545f7cdfda$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$DocumentIcon, {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$PresentationIcon, {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$SpreadsheetIcon, {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$DocumentFilledIcon, {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$DocumentIcon, {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $43bc73545f7cdfda$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $f24gj.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($43bc73545f7cdfda$var$FileIcon, {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("7BHMh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $589df26f9969902f$var$_react = $589df26f9969902f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $589df26f9969902f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $589df26f9969902f$var$Generic16Icon = (props)=>/*#__PURE__*/ $589df26f9969902f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$589df26f9969902f$var$Generic16Icon.displayName = 'Generic16Icon';
var $589df26f9969902f$var$_default = module.exports.default = $589df26f9969902f$var$Generic16Icon;

});

parcelRegister("h7zk4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c76e7d7523f812d3$var$_react = $c76e7d7523f812d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c76e7d7523f812d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c76e7d7523f812d3$var$Presentation16Icon = (props)=>/*#__PURE__*/ $c76e7d7523f812d3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$c76e7d7523f812d3$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $c76e7d7523f812d3$var$_default = module.exports.default = $c76e7d7523f812d3$var$Presentation16Icon;

});

parcelRegister("2Bgv8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1e4bd645869fad1d$var$_react = $1e4bd645869fad1d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1e4bd645869fad1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e4bd645869fad1d$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $1e4bd645869fad1d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$1e4bd645869fad1d$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $1e4bd645869fad1d$var$_default = module.exports.default = $1e4bd645869fad1d$var$Spreadsheet16Icon;

});

parcelRegister("5mR3i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e8828e45bde362b$var$_react = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3e8828e45bde362b$var$_file = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("1NlXW")));

var $3e8828e45bde362b$var$_documentFilled = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("53J27")));
function $3e8828e45bde362b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e8828e45bde362b$var$FileIcon = (props)=>/*#__PURE__*/ $3e8828e45bde362b$var$_react.default.createElement($3e8828e45bde362b$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $3e8828e45bde362b$var$_documentFilled.default
    }, props));
$3e8828e45bde362b$var$FileIcon.Name = 'FileIconMigration';
var $3e8828e45bde362b$var$_default = module.exports.default = $3e8828e45bde362b$var$FileIcon;

});
parcelRegister("1NlXW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14eb6801df53e470$var$_react = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $14eb6801df53e470$var$_baseNew = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $14eb6801df53e470$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14eb6801df53e470$var$FileIcon = (props)=>/*#__PURE__*/ $14eb6801df53e470$var$_react.default.createElement($14eb6801df53e470$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$14eb6801df53e470$var$FileIcon.displayName = 'FileIcon';
var $14eb6801df53e470$var$_default = module.exports.default = $14eb6801df53e470$var$FileIcon;

});

parcelRegister("53J27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3af02a3bc9667b59$var$_react = $3af02a3bc9667b59$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3af02a3bc9667b59$var$_file = $3af02a3bc9667b59$var$_interopRequireDefault((parcelRequire("1NlXW")));
function $3af02a3bc9667b59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3af02a3bc9667b59$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $3af02a3bc9667b59$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $3af02a3bc9667b59$var$_file.default
    }));
$3af02a3bc9667b59$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $3af02a3bc9667b59$var$_default = module.exports.default = $3af02a3bc9667b59$var$DocumentFilledIcon;

});


parcelRegister("5xHlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::695a5f892240588eecf06e93cdff9b42>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4091a8d9d3c43865$var$_react = $4091a8d9d3c43865$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4091a8d9d3c43865$var$_page = $4091a8d9d3c43865$var$_interopRequireDefault((parcelRequire("kdfZa")));

var $4091a8d9d3c43865$var$_documentFilled = $4091a8d9d3c43865$var$_interopRequireDefault((parcelRequire("53J27")));
function $4091a8d9d3c43865$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4091a8d9d3c43865$var$PageIcon = (props)=>/*#__PURE__*/ $4091a8d9d3c43865$var$_react.default.createElement($4091a8d9d3c43865$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $4091a8d9d3c43865$var$_documentFilled.default
    }, props));
$4091a8d9d3c43865$var$PageIcon.Name = 'PageIconMigration';
var $4091a8d9d3c43865$var$_default = module.exports.default = $4091a8d9d3c43865$var$PageIcon;

});

parcelRegister("gVXQp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a29a66c0c086b650$export$2e2bcd8739ae039);

var $h7zk4 = parcelRequire("h7zk4");

var $fDskX = parcelRequire("fDskX");

var $50H21 = parcelRequire("50H21");
const $a29a66c0c086b650$var$ChartBarIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($fDskX))), 'purpleBold', (0, (/*@__PURE__*/$parcel$interopDefault($h7zk4))));
$a29a66c0c086b650$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $a29a66c0c086b650$export$2e2bcd8739ae039 = $a29a66c0c086b650$var$ChartBarIconWithColor;

});
parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});


parcelRegister("3vtQf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cb5c4b8517518bd8$export$2e2bcd8739ae039);

var $7BHMh = parcelRequire("7BHMh");

var $1NlXW = parcelRequire("1NlXW");

var $50H21 = parcelRequire("50H21");
const $cb5c4b8517518bd8$var$FileIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1NlXW))), 'grayBold', (0, (/*@__PURE__*/$parcel$interopDefault($7BHMh))));
$cb5c4b8517518bd8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $cb5c4b8517518bd8$export$2e2bcd8739ae039 = $cb5c4b8517518bd8$var$FileIconWithColor;

});

parcelRegister("9bx9i", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dad84149a00c7077$export$2e2bcd8739ae039);

var $2Bgv8 = parcelRequire("2Bgv8");

var $bEjt9 = parcelRequire("bEjt9");

var $50H21 = parcelRequire("50H21");
const $dad84149a00c7077$var$ListBulletedIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), 'greenBold', (0, (/*@__PURE__*/$parcel$interopDefault($2Bgv8))));
$dad84149a00c7077$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $dad84149a00c7077$export$2e2bcd8739ae039 = $dad84149a00c7077$var$ListBulletedIconWithColor;

});


parcelRegister("i6XYa", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4a76bae5211e39a4$export$321256ed044e3100);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iAkpb = parcelRequire("iAkpb");

var $jnURg = parcelRequire("jnURg");

var $gAdQO = parcelRequire("gAdQO");

var $6ClRv = parcelRequire("6ClRv");

var $kQSMP = parcelRequire("kQSMP");

var $1ni2E = parcelRequire("1ni2E");

var $kvhCa = parcelRequire("kvhCa");

var $dvo9I = parcelRequire("dvo9I");

var $ercGv = parcelRequire("ercGv");

var $dvNbb = parcelRequire("dvNbb");
const $4a76bae5211e39a4$var$TaskIcon = (0, $ercGv.default);
const $4a76bae5211e39a4$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)($4a76bae5211e39a4$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $dvNbb.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $dvNbb.JIRA_TASK:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $dvNbb.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dvo9I.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $dvNbb.JIRA_STORY:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kvhCa.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $dvNbb.JIRA_BUG:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iAkpb.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $dvNbb.JIRA_EPIC:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gAdQO.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $dvNbb.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ClRv.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $dvNbb.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQSMP.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $dvNbb.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnURg.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $dvNbb.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ni2E.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $dvNbb.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("iAkpb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95722ca43be940d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f047f6f7bd48e9a2ba7394ee23b095>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $i6z47 = parcelRequire("i6z47");

var $VSDnB = parcelRequire("VSDnB");

var $dTB4u = parcelRequire("dTB4u");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95722ca43be940d9$var$Bug16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i6z47))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
        label: label,
        testId: testId
    });
};
$95722ca43be940d9$var$Bug16Icon.displayName = 'Bug16Icon';
var $95722ca43be940d9$export$2e2bcd8739ae039 = $95722ca43be940d9$var$Bug16Icon;

});
parcelRegister("i6z47", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e3fcca8ec2d82f$var$_react = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d2e3fcca8ec2d82f$var$_baseNew = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d2e3fcca8ec2d82f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e3fcca8ec2d82f$var$BugIcon = (props)=>/*#__PURE__*/ $d2e3fcca8ec2d82f$var$_react.default.createElement($d2e3fcca8ec2d82f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$d2e3fcca8ec2d82f$var$BugIcon.displayName = 'BugIcon';
var $d2e3fcca8ec2d82f$var$_default = module.exports.default = $d2e3fcca8ec2d82f$var$BugIcon;

});

parcelRegister("dTB4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35369c9d3f28a25$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d35369c9d3f28a25$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$d35369c9d3f28a25$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d35369c9d3f28a25$export$2e2bcd8739ae039 = $d35369c9d3f28a25$var$Bug16Icon;

});


parcelRegister("jnURg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3bbc99392e8686bf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee9d05b0e18fef4787b81f1748fa21a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $3Vx3e = parcelRequire("3Vx3e");

var $VSDnB = parcelRequire("VSDnB");

var $8vXv7 = parcelRequire("8vXv7");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $3bbc99392e8686bf$var$Changes16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Vx3e))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vXv7.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vXv7.default), {
        label: label,
        testId: testId
    });
};
$3bbc99392e8686bf$var$Changes16Icon.displayName = 'Changes16Icon';
var $3bbc99392e8686bf$export$2e2bcd8739ae039 = $3bbc99392e8686bf$var$Changes16Icon;

});
parcelRegister("3Vx3e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dc055420c806e0d$var$_react = $2dc055420c806e0d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2dc055420c806e0d$var$_baseNew = $2dc055420c806e0d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2dc055420c806e0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dc055420c806e0d$var$ChangesIcon = (props)=>/*#__PURE__*/ $2dc055420c806e0d$var$_react.default.createElement($2dc055420c806e0d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2dc055420c806e0d$var$ChangesIcon.displayName = 'ChangesIcon';
var $2dc055420c806e0d$var$_default = module.exports.default = $2dc055420c806e0d$var$ChangesIcon;

});

parcelRegister("8vXv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $057d039125c231f1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281636a4b7ecb1d97df53dcc5763d1a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $057d039125c231f1$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$057d039125c231f1$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$057d039125c231f1$export$2e2bcd8739ae039 = $057d039125c231f1$var$Changes16Icon;

});


parcelRegister("gAdQO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45d4358dfe9bfcd5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fec5072b15ea4111438ac6700ce61b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $5AZiN = parcelRequire("5AZiN");

var $VSDnB = parcelRequire("VSDnB");

var $37F19 = parcelRequire("37F19");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $45d4358dfe9bfcd5$var$Epic16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5AZiN))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
        label: label,
        testId: testId
    });
};
$45d4358dfe9bfcd5$var$Epic16Icon.displayName = 'Epic16Icon';
var $45d4358dfe9bfcd5$export$2e2bcd8739ae039 = $45d4358dfe9bfcd5$var$Epic16Icon;

});
parcelRegister("5AZiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $412fddddb485461d$var$_react = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $412fddddb485461d$var$_baseNew = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $412fddddb485461d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $412fddddb485461d$var$EpicIcon = (props)=>/*#__PURE__*/ $412fddddb485461d$var$_react.default.createElement($412fddddb485461d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$412fddddb485461d$var$EpicIcon.displayName = 'EpicIcon';
var $412fddddb485461d$var$_default = module.exports.default = $412fddddb485461d$var$EpicIcon;

});

parcelRegister("37F19", function(module, exports) {

$parcel$export(module.exports, "default", () => $43bfed8f132140c5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $43bfed8f132140c5$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$43bfed8f132140c5$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43bfed8f132140c5$export$2e2bcd8739ae039 = $43bfed8f132140c5$var$Epic16Icon;

});


parcelRegister("6ClRv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $03a4ac4c743fc34a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9beea2179909206f90938b1cce486fe2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $fNZB4 = parcelRequire("fNZB4");

var $VSDnB = parcelRequire("VSDnB");

var $l66Lz = parcelRequire("l66Lz");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $03a4ac4c743fc34a$var$Incident16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fNZB4))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l66Lz.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l66Lz.default), {
        label: label,
        testId: testId
    });
};
$03a4ac4c743fc34a$var$Incident16Icon.displayName = 'Incident16Icon';
var $03a4ac4c743fc34a$export$2e2bcd8739ae039 = $03a4ac4c743fc34a$var$Incident16Icon;

});
parcelRegister("fNZB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b81b36817ee75239$var$_react = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b81b36817ee75239$var$_baseNew = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b81b36817ee75239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b81b36817ee75239$var$IncidentIcon = (props)=>/*#__PURE__*/ $b81b36817ee75239$var$_react.default.createElement($b81b36817ee75239$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b81b36817ee75239$var$IncidentIcon.displayName = 'IncidentIcon';
var $b81b36817ee75239$var$_default = module.exports.default = $b81b36817ee75239$var$IncidentIcon;

});

parcelRegister("l66Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b197eb4db6e194a4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce0ac1582dc2507da5f80cdb2ca3ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $b197eb4db6e194a4$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$b197eb4db6e194a4$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b197eb4db6e194a4$export$2e2bcd8739ae039 = $b197eb4db6e194a4$var$Incident16Icon;

});


parcelRegister("kQSMP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ed36b810abfd088$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6546d4aeab39dc918bda403f727c61ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $lhPtH = parcelRequire("lhPtH");

var $VSDnB = parcelRequire("VSDnB");

var $8oSh9 = parcelRequire("8oSh9");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7ed36b810abfd088$var$Issue16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
        label: label,
        testId: testId
    });
};
$7ed36b810abfd088$var$Issue16Icon.displayName = 'Issue16Icon';
var $7ed36b810abfd088$export$2e2bcd8739ae039 = $7ed36b810abfd088$var$Issue16Icon;

});
parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad24cecf3159849c56dfb3b17e77c4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});

parcelRegister("8oSh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0610242619823e8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d0610242619823e8$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$d0610242619823e8$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0610242619823e8$export$2e2bcd8739ae039 = $d0610242619823e8$var$Issue16Icon;

});


parcelRegister("1ni2E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0df6901e91a4c816$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b69e4602c3c1878109c2ce1bcc3a020>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $v8u7G = parcelRequire("v8u7G");

var $VSDnB = parcelRequire("VSDnB");

var $c6n91 = parcelRequire("c6n91");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0df6901e91a4c816$var$Problem16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($v8u7G))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6n91.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6n91.default), {
        label: label,
        testId: testId
    });
};
$0df6901e91a4c816$var$Problem16Icon.displayName = 'Problem16Icon';
var $0df6901e91a4c816$export$2e2bcd8739ae039 = $0df6901e91a4c816$var$Problem16Icon;

});
parcelRegister("v8u7G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f604a3dba3cc7c23eef555e893d90eb3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d97a47b15d3c35$var$_react = $05d97a47b15d3c35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05d97a47b15d3c35$var$_baseNew = $05d97a47b15d3c35$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $05d97a47b15d3c35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for problem issue priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05d97a47b15d3c35$var$ProblemIcon = (props)=>/*#__PURE__*/ $05d97a47b15d3c35$var$_react.default.createElement($05d97a47b15d3c35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m3.964 2.904 9.132 9.132a6.501 6.501 0 0 0-9.132-9.132m8.072 10.192L2.904 3.964a6.501 6.501 0 0 0 9.132 9.132M2.343 2.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 2.343 2.343" clip-rule="evenodd"/>`
    }, props));
$05d97a47b15d3c35$var$ProblemIcon.displayName = 'ProblemIcon';
var $05d97a47b15d3c35$var$_default = module.exports.default = $05d97a47b15d3c35$var$ProblemIcon;

});

parcelRegister("c6n91", function(module, exports) {

$parcel$export(module.exports, "default", () => $9beef7a5821119de$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $9beef7a5821119de$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$9beef7a5821119de$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9beef7a5821119de$export$2e2bcd8739ae039 = $9beef7a5821119de$var$Problem16Icon;

});


parcelRegister("kvhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $58497e342f0afaee$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dc9560f1e0ba735793d18700483c5f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $7Fct1 = parcelRequire("7Fct1");

var $VSDnB = parcelRequire("VSDnB");

var $fjoZ1 = parcelRequire("fjoZ1");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $58497e342f0afaee$var$Story16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fct1))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
        label: label,
        testId: testId
    });
};
$58497e342f0afaee$var$Story16Icon.displayName = 'Story16Icon';
var $58497e342f0afaee$export$2e2bcd8739ae039 = $58497e342f0afaee$var$Story16Icon;

});
parcelRegister("7Fct1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5b3fc1f8e72ec324efbf9f291463cd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $594608750eb4424e$var$_react = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $594608750eb4424e$var$_baseNew = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $594608750eb4424e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for stories in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $594608750eb4424e$var$StoryIcon = (props)=>/*#__PURE__*/ $594608750eb4424e$var$_react.default.createElement($594608750eb4424e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.983 2.5a.5.5 0 0 0-.5.5v9.806L8 10.333l3.518 2.473V3a.5.5 0 0 0-.5-.5zm-2 .5a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2v11.202a.775.775 0 0 1-1.221.634L8 12.166l-3.797 2.67a.775.775 0 0 1-1.22-.634z" clip-rule="evenodd"/>`
    }, props));
$594608750eb4424e$var$StoryIcon.displayName = 'StoryIcon';
var $594608750eb4424e$var$_default = module.exports.default = $594608750eb4424e$var$StoryIcon;

});

parcelRegister("fjoZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38a9d1e30071735$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d38a9d1e30071735$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$d38a9d1e30071735$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d38a9d1e30071735$export$2e2bcd8739ae039 = $d38a9d1e30071735$var$Story16Icon;

});


parcelRegister("dvo9I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $158d2140cdc19c0f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::169a13a2ae270c089103a5ea3de6fc67>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $iRvAI = parcelRequire("iRvAI");

var $VSDnB = parcelRequire("VSDnB");

var $5WrPu = parcelRequire("5WrPu");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $158d2140cdc19c0f$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRvAI))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WrPu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WrPu.default), {
        label: label,
        testId: testId
    });
};
$158d2140cdc19c0f$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $158d2140cdc19c0f$export$2e2bcd8739ae039 = $158d2140cdc19c0f$var$Subtask16Icon;

});
parcelRegister("iRvAI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e45e5696651ae09c6cd42135bd3e6824>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbb5ae8ec700c853$var$_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for subtasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>/*#__PURE__*/ $dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2v4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2zm6.25 4.25V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5zm1.5 1.5V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V9.25a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;

});

parcelRegister("5WrPu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0252c73d4b8f4e03$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cad22e1176a9874a0c269f62ca4a13d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $0252c73d4b8f4e03$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$0252c73d4b8f4e03$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0252c73d4b8f4e03$export$2e2bcd8739ae039 = $0252c73d4b8f4e03$var$Subtask16Icon;

});




parcelRegister("8Kv84", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $ae5231d890ad8c03$export$a2afc198e9dada1);


var $4DoyP = parcelRequire("4DoyP");
const $ae5231d890ad8c03$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $829f609a65d26a98$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("6tk3N", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c60268a167a69ea9$export$58d9bc37318dfb32);
const $c60268a167a69ea9$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c60268a167a69ea9$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c60268a167a69ea9$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("ir8YW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $e6bd8b33974efcaa$export$6d5912cb4b56390e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $hHEfn = parcelRequire("hHEfn");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");
class $e6bd8b33974efcaa$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                testId: "inline-card-resolved-view-lozenge",
                appearance: appearance,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: lozenge.style,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
                children: lozenge.text
            })
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            showLabel: false,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("6oaVw", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $fce424d2cf27c0bc$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $fce424d2cf27c0bc$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fce424d2cf27c0bc$export$75180efdd3f4d9c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $bmnhy = parcelRequire("bmnhy");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $6P7yN = parcelRequire("6P7yN");

var $1Fo58 = parcelRequire("1Fo58");
const $fce424d2cf27c0bc$var$iconWrapperStyle = null;
const $fce424d2cf27c0bc$var$iconImageStyle = null;
const $fce424d2cf27c0bc$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $fce424d2cf27c0bc$var$NoLinkAppearanceOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _18u01b66",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$var$LinkAppearance = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title' })=>{
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (emoji) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return emoji;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.EmojiWrapperOldVisualRefresh), {
                children: emoji
            });
        }
        if (!icon || typeof icon === 'string') return null;
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return icon;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: icon
        });
    }, [
        emoji,
        icon
    ]);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((errored, testId)=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $bwpsq.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq"
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Shimmer), {
                testId: `${testId}-loading`
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: icon,
            loaded: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Icon), {
                className: "smart-link-icon",
                src: icon,
                "data-testid": `${testId}-image`,
                alt: ""
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((testId)=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return defaultIcon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
        if (defaultIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`,
                color: "currentColor"
            })
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $fce424d2cf27c0bc$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            as: "span",
                            xcss: $fce424d2cf27c0bc$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $bwpsq.default)([
                                "_11c81o8v _2rkoyh40 _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconPositionWrapperOldVisualRefresh), {
                "data-testid": "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconEmptyWrapperOldVisualRefresh), {
                            "data-testid": "icon-empty-wrapper"
                        }),
                        renderIcon(testId)
                    ]
                })
            }),
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                style: {
                    color: titleTextColor
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $1Fo58.TitleWrapperClassNameOldVisualRefresh),
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)($fce424d2cf27c0bc$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $bwpsq.default)([
                        $fce424d2cf27c0bc$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: $fce424d2cf27c0bc$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)($fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh, {
            style: {
                color: titleColor
            },
            "data-testid": testId,
            children: [
                link ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$NoLinkAppearanceOldVisualRefresh, {
                    children: rightSide
                }) : null
            ]
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$c73a53738ef9e3f = (props)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $fce424d2cf27c0bc$var$styles.iconTitleWrapperStyle,
        ...props
    });
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh, {
        ...props
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fce424d2cf27c0bc$var$LozengeWrapperOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$75180efdd3f4d9c2 = (props)=>{
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LozengeWrapperOldVisualRefresh, {
        ...props
    });
};

});
parcelRegister("6P7yN", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $1cc6345298e1009b$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $1cc6345298e1009b$export$a201b065fc2e76a1);
$parcel$export(module.exports, "Shimmer", () => $1cc6345298e1009b$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3oVhZ = parcelRequire("3oVhZ");
const $1cc6345298e1009b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $1cc6345298e1009b$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1i6y",
            __cmplp.className
        ])
    });
});
const $1cc6345298e1009b$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3oVhZ.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("3oVhZ", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $d9c8a8c862f581db$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $d9c8a8c862f581db$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $d9c8a8c862f581db$var$placeholderShimmer = null;
const $d9c8a8c862f581db$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $d9c8a8c862f581db$var$spanSkeletonStyles = null;
const $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $d9c8a8c862f581db$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$d9c8a8c862f581db$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $bwpsq.default)([
            "_y44v198l _uiztglyw _12vemgnk",
            $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $d9c8a8c862f581db$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$d9c8a8c862f581db$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $bwpsq.default)([
            "_y44v198l _uiztglyw _12vemgnk",
            $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $d9c8a8c862f581db$export$2e2bcd8739ae039 = $d9c8a8c862f581db$export$8f31e4c4a37b8e9c;

});


parcelRegister("1Fo58", function(module, exports) {

$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "EmojiWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$d1387355dd734414);
$parcel$export(module.exports, "IconTitleWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$c635ccf8b1286a3a);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $13bc30456c869fbe$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$989c0529a97b612a);
$parcel$export(module.exports, "IconEmptyWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$87c6f228b0cd0750);
$parcel$export(module.exports, "TitleWrapperClassNameOldVisualRefresh", () => $13bc30456c869fbe$export$65af995e438d6ba4);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // Wraps all icons represented in Inline Links. Icons have three sources/types:
// - JSON-LD: from the generator.icon property coming back from ORS.
// - @atlaskit/icon: for lock icons, unauthorized, etc.
// - @atlaskit/icon-object: for object icons, e.g. repository, branch, etc.
// NB: the first set of overrides style icons imported from @atlaskit/icon-object correctly.
// NB: the second set of overrides style icons imported from @atlaskit/icon correctly.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $13bc30456c869fbe$var$IconObjectOverrides = `
  & > span {
    height: 16px;
    width: 16px;
    position: absolute;
    top: 3px;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
// TODO: remove this override behaviour for @atlaskit/icon
const $13bc30456c869fbe$var$IconOverrides = `
  & > * > span {
    height: 16px;
    width: 16px;
    position: absolute;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $13bc30456c869fbe$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uiztglyw _17047vkz _iibf7vkz _lacastnw _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe _1f027vkz _nbgx7vkz _4d7tstnw _o5fv1l7b _3g5ridpf _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$d1387355dd734414 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw _17047vkz _iibf7vkz _lacastnw _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe _1f027vkz _nbgx7vkz _4d7tstnw _o5fv1l7b _3g5ridpf _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$c635ccf8b1286a3a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$8228f3d531b6be20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$91b164375b8037b5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$989c0529a97b612a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$87c6f228b0cd0750 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$65af995e438d6ba4 = 'smart-link-title-wrapper';
const $13bc30456c869fbe$export$3bc08b0c31e5f53e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});

});



parcelRegister("iJqW5", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $223c5d6a864b7795$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");


var $7zaVw = parcelRequire("7zaVw");

var $7TGH2 = parcelRequire("7TGH2");
const $223c5d6a864b7795$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $223c5d6a864b7795$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7TGH2.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $223c5d6a864b7795$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).could_not_load_link
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                testId: "err-view-retry",
                appearance: "link",
                spacing: "none",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("7TGH2", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $07a1a38b3dfd1707$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $07a1a38b3dfd1707$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $2OMIu.jsx)($07a1a38b3dfd1707$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($07a1a38b3dfd1707$export$7b360cd785b6c366, {
        ...props
    });
const $07a1a38b3dfd1707$var$sharedBaseFrameStyles = null;
const $07a1a38b3dfd1707$var$sharedFrameStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameHoverStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameFluidHeightTrueStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameFluidHeightFalseStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameSelectedStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameNotSelectedStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameStyles = null;
const $07a1a38b3dfd1707$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $07a1a38b3dfd1707$var$compactFrameHoverStyles = null;
const $07a1a38b3dfd1707$var$compactFrameInheritDimensionsTrueStyles = null;
const $07a1a38b3dfd1707$var$compactFrameInheritDimensionsFalseStyles = null;
const $07a1a38b3dfd1707$var$compactFrameAlignStyles = null;
const $07a1a38b3dfd1707$var$compactFrameStyles = null;
const $07a1a38b3dfd1707$var$compactFrameNotSelectedStyles = null;
const $07a1a38b3dfd1707$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("39ESV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a1f0d324217dd9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $8m9FN = parcelRequire("8m9FN");

var $4ec1m = parcelRequire("4ec1m");
const $87a1f0d324217dd9$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $5uXOq.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $5uXOq.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $cL21r.toMessage)((0, $7zaVw.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ec1m.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $87a1f0d324217dd9$export$2e2bcd8739ae039 = $87a1f0d324217dd9$var$ForbiddenView;

});
parcelRegister("8m9FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be3576ed5cf1944$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $jOyH3 = parcelRequire("jOyH3");

var $HEA7j = parcelRequire("HEA7j");

var $ckWLp = parcelRequire("ckWLp");
const $6be3576ed5cf1944$var$containerStyles = null;
const $6be3576ed5cf1944$var$contentStyles = null;
const $6be3576ed5cf1944$var$descriptionStyles = null;
const $6be3576ed5cf1944$var$imageStyles = null;
const $6be3576ed5cf1944$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckWLp.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $5uXOq.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $bwpsq.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $bwpsq.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEA7j.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $bwpsq.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $bwpsq.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $6be3576ed5cf1944$export$2e2bcd8739ae039 = $6be3576ed5cf1944$var$UnresolvedView;

});
parcelRegister("HEA7j", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $4aba9fa58e630365$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $4URMI = parcelRequire("4URMI");

var $gfnFT = parcelRequire("gfnFT");

var $f8JAn = parcelRequire("f8JAn");
const $4aba9fa58e630365$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $gfnFT.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const renderHeader = ()=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return frameStyle !== 'hide' && /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                $4aba9fa58e630365$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $4aba9fa58e630365$var$styles.headerIcon
                    ]),
                    children: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $4aba9fa58e630365$var$styles.tooltipWrapper
                    ]),
                    children: !isPlaceholder && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: text,
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                            href: href,
                            onClick: handleClick,
                            onMouseDown: handleMouseDown,
                            className: (0, $bwpsq.default)([
                                $4aba9fa58e630365$var$styles.headerAnchor
                            ]),
                            children: text
                        })
                    })
                })
            ]
        });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.HeaderOldVisualRefresh), {
            className: "embed-header",
            frameStyle: frameStyle,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.IconWrapperOldVisualRefresh), {
                    isPlaceholder: isPlaceholder,
                    children: !isPlaceholder && icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.TooltipWrapperOldVisualRefresh), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: text,
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.TextWrapperOldVisualRefresh), {
                            isPlaceholder: isPlaceholder,
                            children: !isPlaceholder && /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                href: href,
                                onClick: handleClick,
                                onMouseDown: handleMouseDown,
                                children: text
                            })
                        })
                    })
                })
            ]
        }));
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $bwpsq.default)([
                $4aba9fa58e630365$var$styles.contentStyle,
                setOverflow && allowScrollBar && $4aba9fa58e630365$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $4aba9fa58e630365$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.ContentOldVisualRefresh), {
            "data-testid": "embed-content-wrapper",
            allowScrollBar: allowScrollBar,
            removeOverflow: !setOverflow,
            isInteractive: isInteractive(),
            frameStyle: frameStyle,
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: 'false',
            suppressContentEditableWarning: true,
            children: children
        });
    };
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $4aba9fa58e630365$var$styles.linkWrapper,
            inheritDimensions && $4aba9fa58e630365$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $4aba9fa58e630365$var$styles.linkWrapperSelected,
            showBackgroundAlways && $4aba9fa58e630365$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $4aba9fa58e630365$var$styles.linkWrapperInteractiveNotHidden,
            (0, $f8JAn.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
    if (!isPlaceholder && href) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.LinkWrapperOldVisualRefresh), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f8JAn.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        frameStyle: frameStyle,
        minWidth: minWidth,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        inheritDimensions: inheritDimensions,
        children: [
            renderHeader(),
            renderContent()
        ]
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.WrapperOldVisualRefresh), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f8JAn.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        minWidth: minWidth,
        frameStyle: frameStyle,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        "data-wrapper-type": "default",
        "data-is-interactive": isInteractive(),
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $4aba9fa58e630365$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mj1crf _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _4t3igktf _1pbykb7n",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("f8JAn", function(module, exports) {

$parcel$export(module.exports, "className", () => $f426c5b6b9ce91fc$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $f426c5b6b9ce91fc$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "LinkWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$2a480844028e4ec0);
$parcel$export(module.exports, "WrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$3261c38179e5e529);
$parcel$export(module.exports, "HeaderOldVisualRefresh", () => $f426c5b6b9ce91fc$export$b23fd71055f45d1c);
$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "TextWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$6c22c892e48a7e6d);
$parcel$export(module.exports, "TooltipWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$63387b6a2966b8a1);
$parcel$export(module.exports, "ContentOldVisualRefresh", () => $f426c5b6b9ce91fc$export$ddc04b8b166e58de);
$parcel$export(module.exports, "Image", () => $f426c5b6b9ce91fc$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $f426c5b6b9ce91fc$export$2913c0c0b5623090 = 'media-card-frame';
const $f426c5b6b9ce91fc$export$8f5a73ba0d077b01 = 32;
const $f426c5b6b9ce91fc$export$2a480844028e4ec0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $lD23V.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di629zg",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$3261c38179e5e529 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $lD23V.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _19pk19bv _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di629zg",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7",
            __cmplp.frameStyle === 'show' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$b23fd71055f45d1c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564ojwh _4t3izwfg _kqswstnw _1pbykb7n _1bsb1osq _1e0c1txw _4cvr1h6o _syazqjbk _tzy4idpf",
            __cmplp.frameStyle === 'show' && "_vchhusvi",
            __cmplp.frameStyle === 'show' && "_1yt4h8dc",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.isPlaceholder && "_bfhkqrzy",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$6c22c892e48a7e6d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _syaz1rc1 _1bto1l2s _o5721q9c",
            __cmplp.isPlaceholder && "_2rko1sit",
            __cmplp.isPlaceholder && "_1bsb176v",
            __cmplp.isPlaceholder && "_4t3i1crf",
            __cmplp.isPlaceholder && "_bfhkqrzy",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$63387b6a2966b8a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$ddc04b8b166e58de = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeOverflow: removeOverflow, allowScrollBar: allowScrollBar, frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _19ith6cr _v56414ba _bfhkhp5a _kqswstnw _1pbykb7n _hlq8idpf _rd9b1wug _1g4jidpf _jk3p1wug",
            !__cmplp.removeOverflow && (__cmplp.allowScrollBar ? "_1reo1wug _18m91wug" : "_1reo15vq _18m915vq"),
            __cmplp.frameStyle === 'show' ? "_1bsbwgg2" : "_1bsb1osq",
            __cmplp.frameStyle === 'show' && "_18s81xf9",
            __cmplp.frameStyle === 'hide' ? "_4t3i1osq" : "_4t3i1j2a",
            __cmplp.frameStyle !== 'hide' && "_154ixy5q",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $f426c5b6b9ce91fc$export$3e431a229df88919 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $lD23V.default)($f426c5b6b9ce91fc$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ckWLp", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $e061611f1f328974$export$4a122bafaa48b23d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $f8JAn = parcelRequire("f8JAn");
const $e061611f1f328974$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    const LoadedImageComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "smart-link-icon",
        src: src,
        alt: alt,
        size: size,
        title: title
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("4ec1m", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $35d20558628c8f8e$export$f51768a4e7ff128);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $35d20558628c8f8e$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5VvNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f15eaaa942c697a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $8m9FN = parcelRequire("8m9FN");

var $hEH3t = parcelRequire("hEH3t");
const $7f15eaaa942c697a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $5uXOq.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEH3t.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $7f15eaaa942c697a$export$2e2bcd8739ae039 = $7f15eaaa942c697a$var$NotFoundView;

});
parcelRegister("hEH3t", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $23c56cd588a55ebd$export$80542c1714a314c8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23c56cd588a55ebd$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("d0weD", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $6626ad9154fcc56d$export$30f3c6c32b384a8b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jOyH3 = parcelRequire("jOyH3");

var $hxoiH = parcelRequire("hxoiH");

var $kxcRq = parcelRequire("kxcRq");

var $HEA7j = parcelRequire("HEA7j");

var $5yako = parcelRequire("5yako");

var $ckWLp = parcelRequire("ckWLp");
const $6626ad9154fcc56d$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckWLp.ImageIcon), {
            src: src,
            default: linkGlyph
        });
    }, [
        src,
        linkGlyph,
        iconFromContext
    ]);
    const themeState = (0, $hxoiH.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $kxcRq.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEA7j.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yako.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("5yako", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $6ecba5ca7578a7ab$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kxcRq = parcelRequire("kxcRq");

var $6WbQT = parcelRequire("6WbQT");

var $fcrey = parcelRequire("fcrey");
function $6ecba5ca7578a7ab$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $6ecba5ca7578a7ab$var$iframeStyles = null;
const $6ecba5ca7578a7ab$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gKZoD.di)((0, $6WbQT.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $5uXOq.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $5uXOq.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $5uXOq.useState)(true);
    const ref = (0, $5uXOq.useRef)();
    const mergedRef = $6ecba5ca7578a7ab$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $5uXOq.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $5uXOq.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcrey.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6WbQT.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $kxcRq.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $bwpsq.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rko1l7b _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("6WbQT", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $aafa8e6c37921cc3$export$b32b5f1ee4493319);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $aafa8e6c37921cc3$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line jsx-a11y/iframe-has-title,@atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef
    });
};

});

parcelRegister("fcrey", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $891ad2d7961cc85f$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $891ad2d7961cc85f$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $891ad2d7961cc85f$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $5uXOq.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $5uXOq.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $5uXOq.useEffect)(()=>{
        if (dwell.time > 0 && $891ad2d7961cc85f$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $5uXOq.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});



parcelRegister("4WY3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd12e79c2283e2b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $3PAn6 = parcelRequire("3PAn6");

var $8m9FN = parcelRequire("8m9FN");

var $hrgWV = parcelRequire("hrgWV");
const $cbd12e79c2283e2b$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $5uXOq.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrgWV.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $cbd12e79c2283e2b$export$2e2bcd8739ae039 = $cbd12e79c2283e2b$var$UnauthorizedView;

});
parcelRegister("hrgWV", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $629e05cc9b210214$export$6526edaac83a8c90);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $629e05cc9b210214$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("7oGL1", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $d266b2c60f505e83$export$aff6291803939b05);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $4z0Y1 = parcelRequire("4z0Y1");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $ctwhA = parcelRequire("ctwhA");

var $fgpl1 = parcelRequire("fgpl1");

var $aOsut = parcelRequire("aOsut");

var $bMldO = parcelRequire("bMldO");

var $anNwF = parcelRequire("anNwF");

var $4ULLF = parcelRequire("4ULLF");

var $ir8YW = parcelRequire("ir8YW");

var $eVTgG = parcelRequire("eVTgG");

var $2bexk = parcelRequire("2bexk");
const $d266b2c60f505e83$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const cardDetails = details && details.data || (0, $aOsut.getEmptyJsonLd)();
    const extensionKey = (0, $fgpl1.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const showHoverPreviewFlag = (0, $4z0Y1.useFeatureFlag)('showHoverPreview');
    if (showHoverPreview === undefined && showHoverPreviewFlag !== undefined) showHoverPreview = Boolean(showHoverPreviewFlag);
    const resolvedProps = status === (0, $8dVIb.SmartLinkStatus).Resolved ? (0, $ctwhA.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $5uXOq.useEffect)(()=>{
        switch(status){
            case (0, $8dVIb.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $8dVIb.SmartLinkStatus).Errored:
            case (0, $8dVIb.SmartLinkStatus).Fallback:
            case (0, $8dVIb.SmartLinkStatus).Forbidden:
            case (0, $8dVIb.SmartLinkStatus).NotFound:
            case (0, $8dVIb.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eVTgG.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ir8YW.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline
            });
        case 'unauthorized':
            const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2bexk.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ULLF.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $anNwF.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("4z0Y1", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $d7fba629b25b97ad$export$61acb772777ef35d);

var $051X7 = parcelRequire("051X7");
function $d7fba629b25b97ad$export$61acb772777ef35d(featureFlag) {
    const context = (0, $051X7.useSmartLinkContext)();
    return context?.featureFlags && context?.featureFlags?.[featureFlag];
}

});

parcelRegister("anNwF", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $d7fe9dbae4fd2cf4$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6P7yN = parcelRequire("6P7yN");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $d7fe9dbae4fd2cf4$var$styles = {
    iconWrapper: "_2hwx1i6y"
};
const $d7fe9dbae4fd2cf4$var$fallbackIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $d7fe9dbae4fd2cf4$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "error",
            LEGACY_size: "small",
            testId: "errored-view-default-icon"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.AKIconWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
            label: "error",
            LEGACY_size: "small",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
            testId: "errored-view-default-icon"
        })
    });
};
const $d7fe9dbae4fd2cf4$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        return onRetry && ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).try_again
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            spacing: "none",
            component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
            onClick: handleRetry,
            role: "button",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).try_again
            })
        }));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon || $d7fe9dbae4fd2cf4$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon || $d7fe9dbae4fd2cf4$var$fallbackIcon(),
                link: url,
                title: url,
                onClick: onClick,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("7hUjd", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $d9315bd317cf09de$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3Lty3 = parcelRequire("3Lty3");
const $d9315bd317cf09de$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $d9315bd317cf09de$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $d9315bd317cf09de$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $bwpsq.default)([
                $d9315bd317cf09de$var$styles.innerContainer,
                isDisabled ? $d9315bd317cf09de$var$styles.disabled : $d9315bd317cf09de$var$styles.enabled
            ]),
            children: children
        })
    });
});

});

parcelRegister("1czVu", function(module, exports) {

$parcel$export(module.exports, "IconStyledButtonOldVisualRefresh", () => $b39da9ce412dd56b$export$c7df70607ac721c3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // By default buttons will hide overflow and ellipsis content instead of wrapping.
// This basically turns the button back into inline content
// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b39da9ce412dd56b$export$c7df70607ac721c3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_i3j7iti9 _uqpc18uv _1ilx1nu9 _18v918uv _1t1midpf _jinwidpf _1695v77o _1pns12x7 _vktqv77o _1byq12x7 _k1fv1u8q _5x9bqvcn _ju3g18uv _mt1t18uv _12rl18uv _1wge18uv _1nr3zryt _1a8r4jg8 _1xdi1nu9 _1t21zryt _1jjh4jg8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("EvUeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6c302e9fb2d38d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var /**
 * This HOC serves as a temporary workaround for controlling the style of a parent component.
 * We do not want the Frame to have a hover state when hovering over the action button.
 * TODO: When Firefox begins supporting the :has()pseudo-selector (e.g "frame:has(button:hover){...}"),
 * it should be used instead and the code should be cleaned up.
 */ $dd6c302e9fb2d38d$export$2e2bcd8739ae039 = (Button, frameRef)=>(props)=>{
        const setBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.style.borderColor = `${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`;
        };
        const removeBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.removeAttribute('style');
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            ...props,
            onMouseEnter: setBorderStyle,
            onMouseLeave: removeBorderStyle
        });
    };

});


parcelRegister("4ULLF", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $afe1b9ba417d1ecc$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");


var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6P7yN = parcelRequire("6P7yN");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $afe1b9ba417d1ecc$var$styles = {
    iconWrapper: "_2hwx1i6y _1e0cbu77",
    actionButtonLozengeStyle: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
};
const $afe1b9ba417d1ecc$var$fallbackForbiddenIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
    return (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $afe1b9ba417d1ecc$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
            label: "error",
            color: "var(--ds-icon-danger, #C9372C)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
            LEGACY_size: "small",
            testId: "forbidden-view-fallback-icon"
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.AKIconWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))), {
            label: "error",
            size: "small",
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
            testId: "forbidden-view-fallback-icon"
        })
    });
};
const $afe1b9ba417d1ecc$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) {
                const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
                    isDisabled: isDisabled,
                    onClick: handleRetry,
                    testId: "button-connect-other-account",
                    children: renderForbiddenAccessMessage()
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                spacing: "none",
                onClick: handleRetry,
                component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
                testId: "button-connect-other-account",
                role: "button",
                isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                    xcss: $afe1b9ba417d1ecc$var$styles.actionButtonLozengeStyle,
                    onClick: handleRetry,
                    testId: "button-connect-other-account",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                        appearance: "moved",
                        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                })
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                spacing: "none",
                onClick: handleRetry,
                appearance: "subtle-link",
                testId: "button-connect-other-account",
                role: "button",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                        appearance: 'moved',
                        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                })
            });
        }
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon ? icon : $afe1b9ba417d1ecc$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});


parcelRegister("eVTgG", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $0760a9bf886910dc$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1Fo58 = parcelRequire("1Fo58");

var $bIwoX = parcelRequire("bIwoX");
const $0760a9bf886910dc$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $0760a9bf886910dc$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            xcss: $0760a9bf886910dc$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: 14
            })
        }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bIwoX.SpinnerWrapperOldVisualRefresh), {
            className: "inline-resolving-spinner",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6oaVw.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
            icon: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? renderSpinner() : undefined,
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor,
            children: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? undefined : renderSpinner()
        })
    });
};

});
parcelRegister("bIwoX", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapperOldVisualRefresh", () => $0c4a685457e69a72$export$cfcf9ebf54d3fb5c);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Fo58 = parcelRequire("1Fo58");
const $0c4a685457e69a72$export$cfcf9ebf54d3fb5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1Fo58.IconTitleWrapperOldVisualRefresh), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41ndm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2bexk", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $9c6f4165ad8dd9bb$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6P7yN = parcelRequire("6P7yN");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $9c6f4165ad8dd9bb$var$styles = {
    iconWrapper: "_2hwx1i6y"
};
const $9c6f4165ad8dd9bb$var$fallbackUnauthorizedIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
        LEGACY_size: "small"
    });
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $9c6f4165ad8dd9bb$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "error",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
            LEGACY_size: "small"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.AKIconWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))), {
            label: "error",
            size: "small",
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
        })
    });
};
const $9c6f4165ad8dd9bb$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
        return onAuthorise ? /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            spacing: "none",
            component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        }) : undefined;
    }, [
        handleConnectAccount,
        onAuthorise,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon ? icon : $9c6f4165ad8dd9bb$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});




parcelRegister("5xe9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4e75bfbc011e1a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $hH2qd = parcelRequire("hH2qd");
function $1c4e75bfbc011e1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c4e75bfbc011e1a$var$ConfigureOverlayWrapperStyles = {
    name: "1sudr34",
    styles: "position:relative;left:var(--ds-space-025, 2px)"
};
const $1c4e75bfbc011e1a$var$OverlayWrapper = ({ view: view, targetElementPos: targetElementPos, children: children, isHoveredCallback: hoverCallback, onOpenLinkClick: onOpenLinkClick })=>{
    const [showConfigureButton, setShowConfigureButton] = (0, $5uXOq.useState)(false);
    const [dropdownOpen, setDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setDropdownOpen(isOpen);
        if (!isOpen) setShowConfigureButton(false);
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        onMouseEnter: ()=>{
            setShowConfigureButton(true);
            hoverCallback(true);
        },
        onMouseLeave: ()=>{
            if (!dropdownOpen) {
                setShowConfigureButton(false);
                hoverCallback(false);
            }
        },
        "data-testid": "inline-card-overlay-wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1c4e75bfbc011e1a$var$ConfigureOverlayWrapperStyles
    }, showConfigureButton && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hH2qd.OverlayButton), {
        editorView: view,
        targetElementPos: targetElementPos,
        onDropdownChange: onDropdownChange,
        onOpenLinkClick: onOpenLinkClick
    })), children));
};
var $1c4e75bfbc011e1a$export$2e2bcd8739ae039 = $1c4e75bfbc011e1a$var$OverlayWrapper;

});
parcelRegister("hH2qd", function(module, exports) {

$parcel$export(module.exports, "OverlayButton", () => $1133b824092401fc$export$8b82a61f37322af9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $994MI = parcelRequire("994MI");

var $gZGBX = parcelRequire("gZGBX");

var $8jMCF = parcelRequire("8jMCF");

var $3bDjY = parcelRequire("3bDjY");

var $80CM7 = parcelRequire("80CM7");

var $b0e5B = parcelRequire("b0e5B");

var $9Jd68 = parcelRequire("9Jd68");

var $l7Bbo = parcelRequire("l7Bbo");
function $1133b824092401fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1133b824092401fc$var$buttonWrapperStyles = {
    name: "10x6z7s",
    styles: "position:absolute;z-index:100;display:inline-flex;top:50%;transform:translateY(-50%);background:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px)"
};
const $1133b824092401fc$var$showDropdownThresholdPx = 50;
const $1133b824092401fc$export$8b82a61f37322af9 = (0, $994MI.default)()(({ editorView: editorView, testId: testId = 'link-configure-overlay-button', targetElementPos: targetElementPos = 0, onDropdownChange: onDropdownChange, onOpenLinkClick: onOpenLinkClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configureLinkLabel = formatMessage((0, $80CM7.messages).inlineConfigureLink);
    const [showDropdown, setShowDropdown] = (0, $5uXOq.useState)(false);
    const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent } = (0, $l7Bbo.useLinkOverlayAnalyticsEvents)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        let domNode = editorView.nodeDOM(targetElementPos);
        if (domNode?.nodeType === Node.TEXT_NODE) domNode = domNode.parentElement;
        if (domNode instanceof HTMLElement) {
            const { width: width } = domNode.getBoundingClientRect();
            if (width < $1133b824092401fc$var$showDropdownThresholdPx) setShowDropdown(true);
        }
    }, [
        editorView,
        targetElementPos
    ]);
    const docNode = editorView.state.doc.nodeAt(targetElementPos);
    const nodeEnd = targetElementPos + (docNode?.nodeSize ?? 0);
    const isText = docNode?.isText;
    const handleConfigureClick = (0, $5uXOq.useCallback)(()=>{
        const tr = editorView.state.tr;
        if (isText) tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, targetElementPos, Math.min(nodeEnd, tr.doc.nodeSize)));
        else tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, targetElementPos));
        editorView.dispatch(tr);
    }, [
        editorView,
        isText,
        targetElementPos,
        nodeEnd
    ]);
    const handleConfigureClickWithAnalytics = (0, $5uXOq.useCallback)(()=>{
        fireActionClickEvent('configureLink');
        fireLinkClickEvent();
        handleConfigureClick();
    }, [
        fireLinkClickEvent,
        handleConfigureClick,
        fireActionClickEvent
    ]);
    const { from: from, to: to } = editorView.state.selection;
    const isSelected = from === targetElementPos && to === nodeEnd;
    if (!targetElementPos || isSelected) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1133b824092401fc$var$buttonWrapperStyles,
        "data-testid": testId
    }, showDropdown ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b0e5B.default), {
        testId: testId,
        onConfigureClick: handleConfigureClick,
        onOpenLinkClick: onOpenLinkClick,
        onDropdownChange: onDropdownChange,
        editorView: editorView
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: configureLinkLabel,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Jd68.StyledButton), {
        onClick: handleConfigureClickWithAnalytics,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))), {
            label: configureLinkLabel,
            LEGACY_size: "small",
            testId: `${testId}-configure-icon`
        })
    })));
});

});
parcelRegister("8jMCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59e43c1f00fcc95f49aa5b3733f7f372>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e5d086aacc57a4$var$_react = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $60e5d086aacc57a4$var$_customize = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("4QAwn")));

var $60e5d086aacc57a4$var$_preferences = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5KZxU")));
function $60e5d086aacc57a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e5d086aacc57a4$var$CustomizeIcon = (props)=>/*#__PURE__*/ $60e5d086aacc57a4$var$_react.default.createElement($60e5d086aacc57a4$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $60e5d086aacc57a4$var$_preferences.default
    }, props));
$60e5d086aacc57a4$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $60e5d086aacc57a4$var$_default = module.exports.default = $60e5d086aacc57a4$var$CustomizeIcon;

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("5KZxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>/*#__PURE__*/ $4310fd5ff8fcaeb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $4310fd5ff8fcaeb0$var$_customize.default
    }));
$4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;

});


parcelRegister("b0e5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $147d465df1a9fd7a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $994MI = parcelRequire("994MI");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $8jMCF = parcelRequire("8jMCF");

var $7paD5 = parcelRequire("7paD5");

var $c8Oei = parcelRequire("c8Oei");

var $80CM7 = parcelRequire("80CM7");

var $9Jd68 = parcelRequire("9Jd68");

var $l7Bbo = parcelRequire("l7Bbo");
const $147d465df1a9fd7a$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE = 'smallLinkToolbar';
const $147d465df1a9fd7a$var$Dropdown = ({ onConfigureClick: onConfigureClickCallback, onOpenLinkClick: onOpenLinkClickCallback, onDropdownChange: onDropdownChange, editorView: editorView, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configureLinkLabel = formatMessage((0, $80CM7.messages).inlineConfigureLink);
    const goToLinkLabel = formatMessage((0, $80CM7.messages).inlineGoToLink);
    const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent, fireToolbarViewEvent: fireToolbarViewEvent } = (0, $l7Bbo.useLinkOverlayAnalyticsEvents)();
    const focusEditor = (0, $5uXOq.useCallback)(()=>{
        // Fix dropdown giving focus back to the trigger async which is then unmounted and losing focus
        // this is happening deep within atlaskit dropdown as a result of this code: https://github.com/focus-trap/focus-trap/blob/master/index.js#L987
        // use setTimeout to run this async after that call
        setTimeout(()=>editorView.focus(), 0);
    }, [
        editorView
    ]);
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen, event: event })=>{
        onDropdownChange?.(isOpen);
        if (isOpen) fireToolbarViewEvent();
        if (!isOpen && event instanceof KeyboardEvent) focusEditor();
    }, [
        fireToolbarViewEvent,
        focusEditor,
        onDropdownChange
    ]);
    const onGoToLinkClick = (0, $5uXOq.useCallback)((event)=>{
        fireActionClickEvent('goToLink');
        onOpenLinkClickCallback?.(event);
        focusEditor();
    }, [
        fireActionClickEvent,
        focusEditor,
        onOpenLinkClickCallback
    ]);
    const onConfigureClick = (0, $5uXOq.useCallback)(()=>{
        fireActionClickEvent('configureLink');
        onConfigureClickCallback?.();
        focusEditor();
    }, [
        fireActionClickEvent,
        focusEditor,
        onConfigureClickCallback
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
        trigger: ({ onClick: onClick, triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Jd68.StyledButton), {
                innerRef: triggerRef,
                ...props,
                iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: configureLinkLabel,
                    LEGACY_size: "small"
                }),
                onClick: (e)=>{
                    onClick?.(e);
                    fireLinkClickEvent();
                }
            }),
        testId: `${testId}-dropdown`,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
        elemBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            label: goToLinkLabel,
            LEGACY_size: "medium"
        }),
        testId: `${testId}-dropdown-item-open-link`,
        onClick: onGoToLinkClick
    }, goToLinkLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
        elemBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))), {
            label: configureLinkLabel,
            LEGACY_size: "medium"
        }),
        onClick: onConfigureClick,
        testId: `${testId}-dropdown-item-configure`
    }, configureLinkLabel)));
};
var $147d465df1a9fd7a$export$2e2bcd8739ae039 = (0, $994MI.default)({
    source: $147d465df1a9fd7a$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE
})($147d465df1a9fd7a$var$Dropdown);

});
parcelRegister("9Jd68", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $0c0ee27cc7519400$export$2d5d2ba3c7c8c40b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $fVnbM = parcelRequire("fVnbM");
function $0c0ee27cc7519400$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0c0ee27cc7519400$var$buttonStyles = {
    name: "1wbjrso",
    styles: "display:flex;background:var(--ds-background-neutral, #091E420F);color:var(--ds-icon, #44546F);&:hover{background:var(--ds-background-neutral-hovered, #091E4224);}&:active{background:var(--ds-background-neutral-pressed, #091E424F);}width:1.375rem;height:1.25rem"
};
const $0c0ee27cc7519400$export$2d5d2ba3c7c8c40b = ({ innerRef: innerRef, ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        ...props,
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        css: $0c0ee27cc7519400$var$buttonStyles
    });
};

});

parcelRegister("l7Bbo", function(module, exports) {

$parcel$export(module.exports, "useLinkOverlayAnalyticsEvents", () => $302a019b32212873$export$e3984ac3c5c0f603);

var $5uXOq = parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
const $302a019b32212873$export$e3984ac3c5c0f603 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useMemo)(()=>({
            /**
			 * When a user clicks go to link or configure link buttons.
			 *
			 * When a link is "wide" the overlay button is the configure button.
			 * When a link is "narrow" the configure button is inside the dropdown.
			 *
			 * @param linkAction 'goToLink' when somebody clicks on the Go to link button
			 * in the chevron menu; 'configureLink' when somebody clicks on the Configure button (whether it's the overlay or in the dropdown)
			 */ fireActionClickEvent: (linkAction)=>{
                createAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).CLICKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI,
                    attributes: {
                        action: linkAction
                    }
                }).fire((0, $dWAZk.FabricChannel).media);
            },
            /**
			 * When a user clicks on the dropdown for a short link, or when a user clicks on the configure button for a wide link.
			 */ fireLinkClickEvent: ()=>{
                createAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).CLICKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                }).fire((0, $dWAZk.FabricChannel).media);
            },
            fireToolbarViewEvent: ()=>{
                createAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).VIEWED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).INLINE_DIALOG,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).SMART_LINK_TOOLBAR,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI,
                    attributes: {
                        linkType: 'smallLink'
                    }
                }).fire((0, $dWAZk.FabricChannel).media);
            }
        }), [
        createAnalyticsEvent
    ]);
};

});




parcelRegister("jdDDq", function(module, exports) {

$parcel$export(module.exports, "Card", () => $aa1e8f9d9cf2d723$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $daJ0i = parcelRequire("daJ0i");

var $awTmI = parcelRequire("awTmI");

var $4NUlu = parcelRequire("4NUlu");

var $VSDnB = parcelRequire("VSDnB");

var $jPiXc = parcelRequire("jPiXc");

var $gBr25 = parcelRequire("gBr25");

var $jPPkn = parcelRequire("jPPkn");

var $bLdKL = parcelRequire("bLdKL");
const $aa1e8f9d9cf2d723$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children, __livePage: __livePage })=>{
    const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    if ((0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages')) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        /**
		 * @todo: Add a check to determine if we're currently in a live page once ED-23920 and plugin
		 * is complete. The logic for which should allow navigation if we're in a live page and no callback
		 * has been provided. E.g.
		 *
		 * const allowNavigation = isLivePage && !onClickCallback;
		 */ const allowNavigation = __livePage && !onClickCallback;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children({
                onClick: allowNavigation ? undefined : onClick
            })
        });
    }
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = editorViewModeState?.mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $aa1e8f9d9cf2d723$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $jPPkn.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $iZOJ9.isSafeUrl)(url)) return /*#__PURE__*/ (0, $2OMIu.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $2OMIu.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (0, $gBr25.getPluginState)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $4NUlu.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($aa1e8f9d9cf2d723$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    __livePage: this.props.__livePage,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bLdKL.WithCardContext), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $2OMIu.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $jPPkn.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                (0, $jPiXc.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                isError: false
            };
        }
    };
}

});
parcelRegister("gBr25", function(module, exports) {

$parcel$export(module.exports, "getPluginState", () => $3db8d4710cf7a428$export$f05434c51e3762e);
$parcel$export(module.exports, "getPluginStateWithUpdatedPos", () => $3db8d4710cf7a428$export$be237c815d2927d4);
$parcel$export(module.exports, "getNewRequests", () => $3db8d4710cf7a428$export$cd9326e2f6dc42c0);

var $lumM0 = parcelRequire("lumM0");
const $3db8d4710cf7a428$export$f05434c51e3762e = (editorState)=>(0, $lumM0.pluginKey).getState(editorState);
const $3db8d4710cf7a428$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $3db8d4710cf7a428$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$3db8d4710cf7a428$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $3db8d4710cf7a428$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;

});

parcelRegister("bLdKL", function(module, exports) {

$parcel$export(module.exports, "WithCardContext", () => $cae18fae9d513a95$export$722ea04dd4ef208e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cae18fae9d513a95$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $051X7.useSmartCardContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children(cardContext)
    });
};

});


parcelRegister("vNpIX", function(module, exports) {

$parcel$export(module.exports, "InlineCardWithAwareness", () => $6d78043983ce7a13$export$2b341c5236b55a2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $awTmI = parcelRequire("awTmI");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $nYpqR = parcelRequire("nYpqR");

var $lumM0 = parcelRequire("lumM0");

var $jmJ2m = parcelRequire("jmJ2m");

var $bl9xe = parcelRequire("bl9xe");

var $2CVDy = parcelRequire("2CVDy");
const $6d78043983ce7a13$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $5uXOq.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isInserted, setIsInserted] = (0, $5uXOq.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $5uXOq.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const onResolve = (0, $5uXOq.useCallback)((tr, title)=>{
        if ((0, $VSDnB.fg)('platform_editor_fix_card_plugin_state')) {
            const metadata = tr.getMeta((0, $lumM0.pluginKey));
            if (metadata && metadata.type === 'REGISTER') (0, $nYpqR.registerRemoveOverlay)(()=>setIsInserted(false), metadata.info)(tr);
            else (0, $nYpqR.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        } else (0, $nYpqR.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $5uXOq.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $5uXOq.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    const innerCardWithOpenButtonOverlay = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bl9xe.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            editorAppearance: editorAppearance,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2CVDy.InlineCard), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed
            })
        }), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed
    ]);
    const innerCardOriginal = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2CVDy.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed
    ]);
    const shouldShowOpenButtonOverlay = (0, $5uXOq.useMemo)(()=>{
        return (editorViewModeState?.mode === 'edit' || editorAppearance === 'comment' && (0, $VSDnB.fg)('platform_editor_controls_patch_6')) && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1');
    }, [
        editorViewModeState?.mode,
        editorAppearance
    ]);
    const innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jmJ2m.AwarenessWrapper), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});

});
parcelRegister("jmJ2m", function(module, exports) {

$parcel$export(module.exports, "AwarenessWrapper", () => $0a08a9ab7bb0b5ba$export$cc11bcf19366e14b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $daJ0i = parcelRequire("daJ0i");

var $gmhCD = parcelRequire("gmhCD");

var $jPPkn = parcelRequire("jPPkn");

var $fWDzE = parcelRequire("fWDzE");

var $hLWpM = parcelRequire("hLWpM");

var $6fJce = parcelRequire("6fJce");

var $9HVke = parcelRequire("9HVke");
function $0a08a9ab7bb0b5ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $0a08a9ab7bb0b5ba$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $0a08a9ab7bb0b5ba$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const linkPosition = (0, $5uXOq.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $fWDzE.default)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $6fJce.isLocalStorageKeyDiscovered)((0, $6fJce.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $6fJce.markLocalStorageKeyDiscovered)((0, $6fJce.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const handleOverlayChange = (0, $5uXOq.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
        setOverlayHoveredStyles(isHovered);
    }, [
        setOverlayHoveredStyles
    ]);
    const cardWithOverlay = (0, $5uXOq.useMemo)(()=>{
        if (shouldShowLinkOverlay && !(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hLWpM.default), {
            isSelected: isSelected,
            isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
            onMouseEnter: ()=>handleOverlayChange(true),
            onMouseLeave: ()=>handleOverlayChange(false),
            url: url
        }, children);
        return children;
    }, [
        shouldShowLinkOverlay,
        children,
        isSelected,
        isResolvedViewRendered,
        isInserted,
        isHovered,
        url,
        handleOverlayChange
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: shouldShowLinkPulse && $0a08a9ab7bb0b5ba$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
            data: {
                attributes: (0, $jPPkn.getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9HVke.DiscoveryPulse), {
            localStorageKey: (0, $6fJce.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $6fJce.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, cardWithOverlay))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        cardWithOverlay,
        isInline,
        placeholderUniqId
    ]);
};

});
parcelRegister("fWDzE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3344e435488294$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6fJce = parcelRequire("6fJce");
const $6e3344e435488294$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $5uXOq.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $5uXOq.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $5uXOq.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $5uXOq.useMemo)(()=>isPulseEnabled && !(0, $6fJce.isLocalStorageKeyDiscovered)((0, $6fJce.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $6e3344e435488294$export$2e2bcd8739ae039 = $6e3344e435488294$var$useLinkUpgradeDiscoverability;

});
parcelRegister("6fJce", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK", () => $98873664646ce008$export$613f4cbb1d6327d6);
$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR", () => $98873664646ce008$export$b1ab83c904a5352e);
$parcel$export(module.exports, "ONE_DAY_IN_MILLISECONDS", () => $98873664646ce008$export$2cf27d95188f1c13);
$parcel$export(module.exports, "isLocalStorageKeyDiscovered", () => $98873664646ce008$export$f029a1bf9ca298da);
$parcel$export(module.exports, "markLocalStorageKeyDiscovered", () => $98873664646ce008$export$6b9d1ae5ec92c88e);

var $jtD64 = parcelRequire("jtD64");
const $98873664646ce008$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $98873664646ce008$export$4521957a9ae858f5 = 'discovered';
const $98873664646ce008$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $98873664646ce008$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $98873664646ce008$export$2cf27d95188f1c13 = 86400000;
const $98873664646ce008$var$storageClient = new (0, $jtD64.default)($98873664646ce008$export$c0fd7e3ed450d078);
const $98873664646ce008$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $98873664646ce008$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $98873664646ce008$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $98873664646ce008$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $98873664646ce008$var$storageClient.setItemWithExpiry(key, $98873664646ce008$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};

});


parcelRegister("hLWpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $848dd1ae6b0063cd$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lFKmC = parcelRequire("lFKmC");

var $koVbs = parcelRequire("koVbs");

var $80CM7 = parcelRequire("80CM7");


var $8jMCF = parcelRequire("8jMCF");

var $5KZxU = parcelRequire("5KZxU");

var $VSDnB = parcelRequire("VSDnB");


var $ibtRD = parcelRequire("ibtRD");
function $848dd1ae6b0063cd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $848dd1ae6b0063cd$var$DEBOUNCE_IN_MS = 5;
const $848dd1ae6b0063cd$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
const $848dd1ae6b0063cd$var$PADDING_IN_PX = 4;
const $848dd1ae6b0063cd$var$ICON_WIDTH_IN_PX = 14;
const $848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
const $848dd1ae6b0063cd$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
const $848dd1ae6b0063cd$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
const $848dd1ae6b0063cd$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
const $848dd1ae6b0063cd$var$TEXT_NODE_SELECTOR = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].join(',');
const $848dd1ae6b0063cd$var$SMART_LINK_BACKGROUND_COLOR = `var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $848dd1ae6b0063cd$var$SMART_LINK_ACTIVE_COLOR = `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`;
const $848dd1ae6b0063cd$var$getGradientWithColor = (color)=>{
    return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
};
const $848dd1ae6b0063cd$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'normal',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME}`]: {
            background: $848dd1ae6b0063cd$var$SMART_LINK_ACTIVE_COLOR
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$848dd1ae6b0063cd$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: $848dd1ae6b0063cd$var$getGradientWithColor($848dd1ae6b0063cd$var$SMART_LINK_ACTIVE_COLOR)
        }
    }
});
const $848dd1ae6b0063cd$var$overlayStyles = {
    name: "1ckkn26",
    styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
};
const $848dd1ae6b0063cd$var$showOverlayStyles = {
    name: "1st01id",
    styles: "position:relative;visibility:visible"
};
const $848dd1ae6b0063cd$var$iconStyles = {
    name: "ulzjoo",
    styles: "span{display:flex;}"
};
const $848dd1ae6b0063cd$var$labelStyles = {
    name: "cf1bvh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
};
const $848dd1ae6b0063cd$var$iconAndLabelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    // Margin to avoid the background covering the link border
    marginRight: "var(--ds-space-025, 2px)",
    background: $848dd1ae6b0063cd$var$SMART_LINK_BACKGROUND_COLOR,
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
});
const $848dd1ae6b0063cd$var$overflowingContainerStyles = {
    name: "16sud",
    styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
};
const $848dd1ae6b0063cd$var$gradientStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '2.5rem',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: $848dd1ae6b0063cd$var$getGradientWithColor($848dd1ae6b0063cd$var$SMART_LINK_BACKGROUND_COLOR)
});
const $848dd1ae6b0063cd$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
    const [showOverlay, setShowOverlay] = (0, $5uXOq.useState)(false);
    const [showLabel, setShowLabel] = (0, $5uXOq.useState)(true);
    const [availableWidth, setAvailableWidth] = (0, $5uXOq.useState)(undefined);
    const maxOverlayWidth = (0, $5uXOq.useRef)(0);
    const minOverlayWidth = (0, $5uXOq.useRef)($848dd1ae6b0063cd$var$ESTIMATED_MIN_WIDTH_IN_PX);
    const parentWidth = (0, $5uXOq.useRef)(0);
    const iconSize = (0, $5uXOq.useRef)('small');
    const containerRef = (0, $5uXOq.useRef)(null);
    const setVisibility = (0, $5uXOq.useCallback)(()=>{
        if (!containerRef.current || !maxOverlayWidth.current) return;
        const marker = (0, $ibtRD.getChildElement)(containerRef, `.${$848dd1ae6b0063cd$var$OVERLAY_MARKER_CLASSNAME}`);
        if (!marker) return;
        try {
            const oneLine = (0, $ibtRD.isOneLine)(containerRef.current, marker);
            // Get the width of the available space to display overlay.
            // This is the width of the inline link itself. If the inline
            // is wrapped to the next line, this is width of the last line.
            const availableWidth = (0, $ibtRD.getInlineCardAvailableWidth)(containerRef.current, marker) - $848dd1ae6b0063cd$var$PADDING_IN_PX - // Always leave at least the icon visible
            (oneLine ? $848dd1ae6b0063cd$var$ICON_WIDTH_IN_PX + $848dd1ae6b0063cd$var$PADDING_IN_PX : 0);
            setAvailableWidth(availableWidth);
            const canShowLabel = availableWidth > maxOverlayWidth.current;
            setShowLabel(canShowLabel);
            const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
            setShowOverlay(canShowOverlay);
        } catch  {
            // If something goes wrong, hide the overlay all together.
            setShowOverlay(false);
        }
    }, [
        isSelected
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Using useLayoutEffect here.
        // 1) We want all to be able to determine whether to display label before
        //    the overlay becomes visible.
        // 2) We need to wait for the refs to be assigned to be able to do determine
        //    the width of the overlay.
        if (!containerRef.current) return;
        // This should run only once
        if (!maxOverlayWidth.current) {
            const iconAndLabel = (0, $ibtRD.getChildElement)(containerRef, `.${$848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME}`);
            const label = (0, $ibtRD.getChildElement)(containerRef, `.${$848dd1ae6b0063cd$var$OVERLAY_LABEL_CLASSNAME}`);
            if (iconAndLabel && label) {
                // Set overlay max (label + icon) and min (icon only) width.
                const { max: max, min: min } = (0, $ibtRD.getOverlayWidths)(iconAndLabel, label);
                maxOverlayWidth.current = max;
                minOverlayWidth.current = min;
                iconSize.current = (0, $ibtRD.getIconSize)(label);
            }
        }
        if (isVisible) setVisibility();
    }, [
        setVisibility,
        isVisible
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Find the closest block parent to observe size change
        const parent = containerRef?.current?.closest($848dd1ae6b0063cd$var$TEXT_NODE_SELECTOR);
        if (!parent) return;
        const updateOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((entries)=>{
            if (!isVisible) return;
            const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
            if (!size) return;
            if (!parentWidth.current) parentWidth.current = size;
            if (parentWidth.current === size) return;
            parentWidth.current = size;
            setVisibility();
        }, $848dd1ae6b0063cd$var$DEBOUNCE_IN_MS);
        const observer = new ResizeObserver(updateOverlay);
        observer.observe(parent);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isVisible,
        setVisibility
    ]);
    const intl = (0, $koVbs.default)();
    const label = intl.formatMessage((0, $80CM7.messages).inlineOverlay);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...props,
        css: $848dd1ae6b0063cd$var$containerStyles,
        ref: containerRef
    }, children, isVisible && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "aria-hidden": "true",
        className: $848dd1ae6b0063cd$var$OVERLAY_MARKER_CLASSNAME
    }, (0, $0f804702eb36dd5e$export$2b4d00c13dcd3c1f)), /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
        css: [
            $848dd1ae6b0063cd$var$overlayStyles,
            showOverlay && $848dd1ae6b0063cd$var$showOverlayStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: availableWidth && -availableWidth,
            width: availableWidth
        },
        "data-testid": testId,
        href: url,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $848dd1ae6b0063cd$var$overflowingContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $848dd1ae6b0063cd$var$iconAndLabelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $848dd1ae6b0063cd$var$iconStyles
    }, (0, $VSDnB.fg)('platform-editor-plugin-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))), {
        label: label,
        LEGACY_size: iconSize.current,
        testId: `${testId}-icon`
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5KZxU))), {
        label: label,
        size: iconSize.current,
        testId: `${testId}-icon`
    })), showLabel && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $848dd1ae6b0063cd$var$labelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $848dd1ae6b0063cd$var$OVERLAY_LABEL_CLASSNAME,
        "data-testid": `${testId}-label`
    }, label)), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $848dd1ae6b0063cd$var$gradientStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $848dd1ae6b0063cd$var$OVERLAY_GRADIENT_CLASSNAME,
        "data-testid": `${testId}-gradient`
    }))))));
};
var $848dd1ae6b0063cd$export$2e2bcd8739ae039 = $848dd1ae6b0063cd$var$InlineCardOverlay;

});
parcelRegister("ibtRD", function(module, exports) {

$parcel$export(module.exports, "getChildElement", () => $c9eb5f21d754e968$export$a0e2858e1d1976ea);
$parcel$export(module.exports, "getInlineCardAvailableWidth", () => $c9eb5f21d754e968$export$ce3ffcce447cf028);
$parcel$export(module.exports, "isOneLine", () => $c9eb5f21d754e968$export$be02a7fcf666d65d);
$parcel$export(module.exports, "getOverlayWidths", () => $c9eb5f21d754e968$export$bdfd7a9bf7c62c86);
$parcel$export(module.exports, "getIconSize", () => $c9eb5f21d754e968$export$3eb7d6130acfda37);
const $c9eb5f21d754e968$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
const $c9eb5f21d754e968$export$ce3ffcce447cf028 = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().left;
    const end = endEl.getBoundingClientRect().left;
    return end - start;
};
const $c9eb5f21d754e968$export$be02a7fcf666d65d = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().top;
    const end = endEl.getBoundingClientRect().top;
    return start === end;
};
const $c9eb5f21d754e968$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
    const max = overlayEl.getBoundingClientRect().width;
    const min = max - labelEl.getBoundingClientRect().width;
    return {
        max: max,
        min: min
    };
};
const $c9eb5f21d754e968$export$3eb7d6130acfda37 = (labelEl)=>{
    const h2FontSizePx = 20;
    const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
    if (!fontSize || fontSize < h2FontSizePx) return 'small';
    return 'medium';
};

});


parcelRegister("9HVke", function(module, exports) {

$parcel$export(module.exports, "DiscoveryPulse", () => $3481e02f4cd5c154$export$1f5748a1623673d7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $jhYOV = parcelRequire("jhYOV");

var $6fJce = parcelRequire("6fJce");
const $3481e02f4cd5c154$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $6fJce.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $5uXOq.useCallback)(()=>{
        if (!discovered) (0, $6fJce.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhYOV.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};

});
parcelRegister("jhYOV", function(module, exports) {

$parcel$export(module.exports, "Pulse", () => $8800890016d88006$export$927d63e2511364c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $5uXOq = parcelRequire("5uXOq");
const $8800890016d88006$var$pulseKeyframes = null;
const $8800890016d88006$var$pulseStyles = null;
const $8800890016d88006$var$commonStyles = null;
const $8800890016d88006$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $5uXOq.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    if ((0, $VSDnB.fg)('platform_ssr_smartlinks_editor')) return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rko1l7b _y44v3445 _16qs1tze"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rko1l7b _y44v3445 _16qs1tze"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation,
            children: children
        })
    });
};
var $8800890016d88006$export$2e2bcd8739ae039 = $8800890016d88006$export$927d63e2511364c0;

});



parcelRegister("bl9xe", function(module, exports) {

$parcel$export(module.exports, "default", () => $78dfe69efd11b5ff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggICg = parcelRequire("ggICg");

var $VSDnB = parcelRequire("VSDnB");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
function $78dfe69efd11b5ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $78dfe69efd11b5ff$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $78dfe69efd11b5ff$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $78dfe69efd11b5ff$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $78dfe69efd11b5ff$var$linkStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    left: 'space.025',
    top: '-1px',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $78dfe69efd11b5ff$var$linkStylesFix = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap'
});
const $78dfe69efd11b5ff$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $78dfe69efd11b5ff$var$ICON_WIDTH = 16;
const $78dfe69efd11b5ff$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $78dfe69efd11b5ff$var$OpenButtonOverlay = ({ children: children, isVisible: isVisible = false, url: url, editorAppearance: editorAppearance, ...props })=>{
    // TODO: ED-26961 - add translation
    const label = 'Open';
    const containerRef = (0, $5uXOq.useRef)(null);
    const openButtonRef = (0, $5uXOq.useRef)(null);
    const hiddenTextRef = (0, $5uXOq.useRef)(null);
    const [showLabel, setShowLabel] = (0, $5uXOq.useState)(true);
    const [isHovered, setHovered] = (0, $5uXOq.useState)(false);
    const openTextWidthRef = (0, $5uXOq.useRef)($78dfe69efd11b5ff$var$DEFAULT_OPEN_TEXT_WIDTH);
    const handleDoubleClick = ()=>{
        // Double click opens the link in a new tab
        window.open(url, '_blank');
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        const hiddenText = hiddenTextRef.current;
        if (!hiddenText) return;
        // Measure the width of the hidden text
        // Temporarily make the element visible to measure its width
        hiddenText.style.visibility = 'hidden';
        hiddenText.style.display = 'inline';
        openTextWidthRef.current = hiddenText.offsetWidth;
        // Reset the hiddenText's display property
        hiddenText.style.display = 'none';
        hiddenText.style.visibility = 'inherit';
    }, []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = openButtonRef.current?.offsetWidth;
        if (!cardWidth || !openButtonWidth) return;
        let canShowLabel = true;
        if ((0, $VSDnB.fg)('platform_editor_controls_patch_2')) canShowLabel = cardWidth - openTextWidthRef.current > $78dfe69efd11b5ff$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $78dfe69efd11b5ff$var$ICON_WIDTH;
        else canShowLabel = cardWidth - openButtonWidth > $78dfe69efd11b5ff$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY;
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: containerRef,
        css: $78dfe69efd11b5ff$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false)
    }, children, (0, $VSDnB.fg)('platform_editor_controls_patch_2') && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $78dfe69efd11b5ff$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jhmo0.default), {
        ref: openButtonRef,
        xcss: [
            $78dfe69efd11b5ff$var$linkStyles,
            (0, $VSDnB.fg)('platform_editor_controls_patch_5') && $78dfe69efd11b5ff$var$linkStylesFix
        ],
        href: url,
        target: "_blank",
        style: {
            paddingBlock: editorAppearance === 'comment' && (0, $VSDnB.fg)('platform_editor_controls_patch_6') ? '1px' : "var(--ds-space-025, 2px)"
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $78dfe69efd11b5ff$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
        label: ""
    })), showLabel && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, label))));
};
var $78dfe69efd11b5ff$export$2e2bcd8739ae039 = $78dfe69efd11b5ff$var$OpenButtonOverlay;

});



parcelRegister("ivF3y", function(module, exports) {

$parcel$export(module.exports, "lazyBlockCardView", () => $0d69be0d1facc5c2$export$7da1e5b9c509a0c1);

var $3xRyR = parcelRequire("3xRyR");

var $gmhCD = parcelRequire("gmhCD");

var $dFBmr = parcelRequire("dFBmr");

const $0d69be0d1facc5c2$export$7da1e5b9c509a0c1 = (props)=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $dFBmr.blockCardNodeView)(props);
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'blockCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("dFBmr"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                return blockCardNodeView(props);
            });
            return result;
        }
    });
};

});
parcelRegister("dFBmr", function(module, exports) {

$parcel$export(module.exports, "blockCardNodeView", () => $573683d063345568$export$8c11099266e71f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");

var $bXrHm = parcelRequire("bXrHm");

var $j8AmE = parcelRequire("j8AmE");

var $f3dKD = parcelRequire("f3dKD");
var $iiXGq = parcelRequire("iiXGq");

var $gE8f9 = parcelRequire("gE8f9");
var $3dBkm = parcelRequire("3dBkm");

var $VSDnB = parcelRequire("VSDnB");

var $kVZJG = parcelRequire("kVZJG");

var $7Zmza = parcelRequire("7Zmza");

var $nYpqR = parcelRequire("nYpqR");

var $jPPkn = parcelRequire("jPPkn");

var $jdDDq = parcelRequire("jdDDq");
class $573683d063345568$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $7nRxN.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $nYpqR.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        }, this.gapCursorSpan = ()=>{
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if ((0, $gE8f9.browser).ie && (0, $gE8f9.browser).ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                contentEditable: true
            });
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = (0, $f3dKD.findOverflowScrollParent)(props.view.dom) || undefined;
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kVZJG.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $2OMIu.jsx)(cardContext.Provider, {
                value: cardContext.value,
                children: cardInner
            }) : data ? cardInner : null
        });
    }
}
const $573683d063345568$var$WrappedBlockCard = (0, $jdDDq.Card)($573683d063345568$export$780882fb750d3c8d, (0, $iiXGq.default));
class $573683d063345568$export$d18ccd25c0d2c6b0 extends (0, $j8AmE.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        if ((0, $VSDnB.fg)('linking-platform-contenteditable-false-live-view')) {
            this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
            this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        } else domRef.contentEditable = 'true';
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $jPPkn.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $jPPkn.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($573683d063345568$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id
        });
    }
    destroy() {
        this.unsubscribe?.();
        if ((0, $VSDnB.fg)('platform_editor_fix_card_plugin_state')) this.removeCard();
    }
    removeCard() {
        const { tr: tr } = this.view.state;
        (0, $nYpqR.removeCard)({
            id: this.id
        })(tr);
        this.view.dispatch(tr);
    }
    constructor(...args){
        super(...args), this.id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $573683d063345568$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback
        };
        const isDatasource = (0, $jPPkn.isDatasourceNode)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $3dBkm.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $7Zmza.Datasource)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $573683d063345568$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("j8AmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $180f7addf4ccc56b$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $lY6DM = parcelRequire("lY6DM");

var $9pOon = parcelRequire("9pOon");

var $WXnhI = parcelRequire("WXnhI");

var $4NUlu = parcelRequire("4NUlu");

var $4tEIi = parcelRequire("4tEIi");

var $5BVRS = parcelRequire("5BVRS");
class $180f7addf4ccc56b$export$2e2bcd8739ae039 {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate){
        this.decorations = [];
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $lY6DM.createDispatch)(this.eventDispatcher);
                dispatch((0, $4NUlu.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $4tEIi.generateUniqueNodeKey)();
    }
    /**
	 * This method exists to move initialization logic out of the constructor,
	 * so object can be initialized properly before calling render first time.
	 *
	 * Example:
	 * Instance properties get added to an object only after super call in
	 * constructor, which leads to some methods being undefined during the
	 * first render.
	 */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $WXnhI.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $WXnhI.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $WXnhI.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pOon.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $gkwXh.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                children: component()
            });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.portalProviderAPI.render(componentWithErrorBoundary, this.domRef, this.key);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let parentOffset = 0;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            // ... and capture parent offset before DOM change
            if (this.view.state.selection?.ranges.length > 0) parentOffset = this.view.state.selection?.ranges[0].$from?.parentOffset ?? 0;
            node.appendChild(contentDOM);
            requestAnimationFrame(()=>{
                // Reset ignoreMutation after frame ....
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // only trigger selection re-sync if the selection is not at the start of the
                // node, and DOM mutations were ignored
                if (selectionBookmark && mutationsIgnored && parentOffset > 0) // ... and dispatch expected selection state
                this.view.dispatch(this.view.state.tr.setSelection(selectionBookmark.resolve(this.view.state.tr.doc)));
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
	 * Copies the attributes from a ProseMirror Node to a DOM node.
	 * @param node The Prosemirror Node from which to source the attributes
	 */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $180f7addf4ccc56b$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
}

});

parcelRegister("7Zmza", function(module, exports) {

$parcel$export(module.exports, "Datasource", () => $aee3c79d9325466c$export$9dd55813d0ee0514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $j8AmE = parcelRequire("j8AmE");

var $kRXi9 = parcelRequire("kRXi9");
var $iJOES = parcelRequire("iJOES");

var $9kpKZ = parcelRequire("9kpKZ");

var $eOOFp = parcelRequire("eOOFp");

var $em3vl = parcelRequire("em3vl");

var $051X7 = parcelRequire("051X7");


var $gDJbm = parcelRequire("gDJbm");

var $9NQiC = parcelRequire("9NQiC");
const $aee3c79d9325466c$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $aee3c79d9325466c$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.getDatasource = ()=>this.props.node.attrs.datasource, this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        }, this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        }, this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        }, this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $aee3c79d9325466c$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $051X7.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9NQiC.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $051X7.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $em3vl.default), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
}
class $aee3c79d9325466c$export$9dd55813d0ee0514 extends (0, $j8AmE.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $iJOES.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gDJbm.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $9kpKZ.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $kRXi9.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(attrs.layout || (0, $44fe84ed19a5b32b$export$60efea3f80310017), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($aee3c79d9325466c$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
}

});
parcelRegister("em3vl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f593b92d2fb82d5c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $f593b92d2fb82d5c$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("jqFH1")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $f593b92d2fb82d5c$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f593b92d2fb82d5c$var$LazyDatasourceTableView, props));
};
var $f593b92d2fb82d5c$export$2e2bcd8739ae039 = $f593b92d2fb82d5c$var$DatasourceTableViewWithWrappers;

});
parcelRegister("jqFH1", function(module, exports) {

let $e250c95f7ec848e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e250c95f7ec848e6$var$load("hPzOn"),
    $e250c95f7ec848e6$var$load("cM9em"),
    $e250c95f7ec848e6$var$load("fr9NE"),
    $e250c95f7ec848e6$var$load("h2MrD"),
    $e250c95f7ec848e6$var$load("bYT2S"),
    $e250c95f7ec848e6$var$load("4YThm")
]).then(()=>parcelRequire('etPPx'));

});


parcelRegister("gDJbm", function(module, exports) {

$parcel$export(module.exports, "DatasourceErrorBoundary", () => $6d0cfa7d56611696$export$76664c71b9b1a689);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $2LkY3 = parcelRequire("2LkY3");

var $jPiXc = parcelRequire("jPiXc");
class $6d0cfa7d56611696$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $iZOJ9.isSafeUrl)(url)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2LkY3.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $jPiXc.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2LkY3.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            isError: false,
            error: null
        };
    }
}

});
parcelRegister("2LkY3", function(module, exports) {

$parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", () => $6f4d4696225c41fc$export$f386473e8f104bcb);

var $5uXOq = parcelRequire("5uXOq");

const $6f4d4696225c41fc$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("lKxXQ")));
const $6f4d4696225c41fc$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4d4696225c41fc$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));

});
parcelRegister("lKxXQ", function(module, exports) {

let $fd583d760d88ecd6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd583d760d88ecd6$var$load("aR9Mt").then(()=>parcelRequire('lVxZp'));

});



parcelRegister("9NQiC", function(module, exports) {

$parcel$export(module.exports, "EditorAnalyticsContext", () => $6ec8577f5d2df689$export$b49e513cc101a4b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $4NUlu = parcelRequire("4NUlu");

var $gBr25 = parcelRequire("gBr25");
const $6ec8577f5d2df689$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $gBr25.getPluginState)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $4NUlu.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: analyticsData,
        children: children
    });
};

});




parcelRegister("6YTYp", function(module, exports) {

$parcel$export(module.exports, "lazyEmbedCardView", () => $5813e9565cc1232a$export$eb946eb841dd1469);

var $3xRyR = parcelRequire("3xRyR");

var $gmhCD = parcelRequire("gmhCD");

var $4tvWd = parcelRequire("4tvWd");

const $5813e9565cc1232a$export$eb946eb841dd1469 = (props)=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $4tvWd.embedCardNodeView)(props);
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'embedCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("4tvWd"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                return embedCardNodeView(props);
            });
            return result;
        }
    });
};

});
parcelRegister("4tvWd", function(module, exports) {

$parcel$export(module.exports, "embedCardNodeView", () => $ce715b606b6ea894$export$86904605fa83de6c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");

var $bXrHm = parcelRequire("bXrHm");

var $2gIj5 = parcelRequire("2gIj5");

var $awTmI = parcelRequire("awTmI");

var $j8AmE = parcelRequire("j8AmE");

var $f3dKD = parcelRequire("f3dKD");
var $kSK5g = parcelRequire("kSK5g");
var $iiXGq = parcelRequire("iiXGq");

var $cROsB = parcelRequire("cROsB");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $kVZJG = parcelRequire("kVZJG");
var $icXYC = parcelRequire("icXYC");

var $nYpqR = parcelRequire("nYpqR");

var $35fHl = parcelRequire("35fHl");

var $jdDDq = parcelRequire("jdDDq");
const $ce715b606b6ea894$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, eventDispatcher: eventDispatcher, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthState: widthState, editorDisabledState: editorDisabledState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ]);
    const widthStateLineLength = widthState?.lineLength || 0;
    const widthStateWidth = widthState?.width || 0;
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $cROsB.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH) / (0, $iHYdz.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kSK5g.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35fHl.default), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabledState?.editorDisabled,
        children: smartCard
    });
};
class $ce715b606b6ea894$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.state = {
            hasPreview: true
        }, this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch (e) {
            // Can blow up in rare cases, when node has been removed.
            }
        }, this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: aspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $iHYdz.DEFAULT_EMBED_CARD_HEIGHT), (0, $iHYdz.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $7nRxN.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $nYpqR.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch (e) {}
        }, this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        }, this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $cROsB.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $cROsB.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) return domNode.offsetWidth;
            }
            return originalLineLength;
        }, /**
	 * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
	 * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
	 * we will show embed window of appropriate size and avoid unnecessary content jumping.
	 */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $7nRxN.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $2gIj5.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        }, this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = (0, $f3dKD.findOverflowScrollParent)(props.view.dom) || undefined;
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kVZJG.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions
        }, url);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $icXYC.EmbedResizeMessageListener), {
            embedIframeRef: this.embedIframeRef,
            onHeightUpdate: this.onHeightUpdate,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ce715b606b6ea894$var$CardInner, {
                pluginInjectionApi: pluginInjectionApi,
                smartCard: smartCard,
                hasPreview: hasPreview,
                getPosSafely: this.getPosSafely,
                view: view,
                getLineLength: this.getLineLength,
                eventDispatcher: this.props.eventDispatcher,
                updateSize: this.updateSize,
                getPos: getPos,
                aspectRatio: aspectRatio,
                allowResizing: allowResizing,
                heightAlone: heightAlone,
                cardProps: cardProps,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            })
        });
    }
}
const $ce715b606b6ea894$var$WrappedBlockCard = (0, $jdDDq.Card)($ce715b606b6ea894$export$61b2782f78272a37, (0, $iiXGq.default));
class $ce715b606b6ea894$export$6789d7ecdc77631b extends (0, $j8AmE.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        if ((0, $VSDnB.fg)('linking-platform-contenteditable-false-live-view')) {
            this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
            this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        } else domRef.contentEditable = 'true';
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($ce715b606b6ea894$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            eventDispatcher: eventDispatcher,
            getPos: this.getPos,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id
        });
    }
    destroy() {
        this.unsubscribe?.();
        if ((0, $VSDnB.fg)('platform_editor_fix_card_plugin_state')) this.removeCard();
    }
    removeCard() {
        const { tr: tr } = this.view.state;
        (0, $nYpqR.removeCard)({
            id: this.id
        })(tr);
        this.view.dispatch(tr);
    }
    constructor(...args){
        super(...args), this.id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $ce715b606b6ea894$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback
        };
        return new $ce715b606b6ea894$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("2gIj5", function(module, exports) {

$parcel$export(module.exports, "SetAttrsStep", () => $1a6f71c955cd80a7$export$8cfd0a0bfa522949);

var $eS2Dn = parcelRequire("eS2Dn");

var $kCV8T = parcelRequire("kCV8T");
class $1a6f71c955cd80a7$export$8cfd0a0bfa522949 extends (0, $eS2Dn.Step) {
    constructor(pos, attrs){
        super();
        this.pos = pos;
        this.attrs = attrs;
    }
    apply(doc) {
        let target = doc.nodeAt(this.pos);
        if (!target) return (0, $eS2Dn.StepResult).fail('No node at given position');
        if (target.isText) return (0, $eS2Dn.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        let newNode = target.type.create(attrs, (0, $kCV8T.Fragment).empty, target.marks);
        let slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $eS2Dn.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        let target = doc.nodeAt(this.pos);
        return new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        let result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
}
(0, $eS2Dn.Step).jsonID('setAttrs', $1a6f71c955cd80a7$export$8cfd0a0bfa522949);

});

parcelRegister("kSK5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be58b662b429c13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ci4W = parcelRequire("9ci4W");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $intz5 = parcelRequire("intz5");

var $8n44w = parcelRequire("8n44w");

var $cROsB = parcelRequire("cROsB");

var $ipSX1 = parcelRequire("ipSX1");
function $4be58b662b429c13$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $cROsB.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $8n44w.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $iHYdz.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH) - (0, $iHYdz.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $ipSX1.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension
        }),
        ...(0, $VSDnB.fg)('platform_fix_media_image_resizing') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ipSX1.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("intz5", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $7676dd27b358f47a$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $7676dd27b358f47a$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $7676dd27b358f47a$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $7676dd27b358f47a$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $7676dd27b358f47a$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $7676dd27b358f47a$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $7676dd27b358f47a$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $7676dd27b358f47a$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $7676dd27b358f47a$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $7676dd27b358f47a$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $7676dd27b358f47a$export$b4b560efd3c61856);
const $7676dd27b358f47a$export$5937600f4cc784f0 = 24;
const $7676dd27b358f47a$export$71d660e8ca5b8f73 = 320;
const $7676dd27b358f47a$export$cd11d7d46412c89b = 3;
const $7676dd27b358f47a$export$71482734bb54ac3 = 10;
const $7676dd27b358f47a$export$fd2b09475ada41cc = 12;
const $7676dd27b358f47a$export$8c5ac0b0c62a3d21 = 8;
const $7676dd27b358f47a$export$68d0abe4f03863fb = $7676dd27b358f47a$export$fd2b09475ada41cc * 2;
const $7676dd27b358f47a$export$d722b7527b1834a8 = 250;
const $7676dd27b358f47a$export$da894f7669b4e67c = 200;
const $7676dd27b358f47a$export$e13825c38da2ce1 = 100;
var $7676dd27b358f47a$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $7676dd27b358f47a$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7676dd27b358f47a$export$4d41d008e9cd4f34 = 0.5;
const $7676dd27b358f47a$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("8n44w", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $c45fbf05bdb029ba$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $c45fbf05bdb029ba$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $c45fbf05bdb029ba$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $c45fbf05bdb029ba$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $c45fbf05bdb029ba$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $c45fbf05bdb029ba$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $c45fbf05bdb029ba$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $c45fbf05bdb029ba$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $c45fbf05bdb029ba$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $c45fbf05bdb029ba$export$22e4c8c04f58169d);

var $gZGBX = parcelRequire("gZGBX");

var $iHYdz = parcelRequire("iHYdz");

var $cROsB = parcelRequire("cROsB");

var $intz5 = parcelRequire("intz5");
function $c45fbf05bdb029ba$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $c45fbf05bdb029ba$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $c45fbf05bdb029ba$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $c45fbf05bdb029ba$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $intz5.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $c45fbf05bdb029ba$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $c45fbf05bdb029ba$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $iHYdz.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $c45fbf05bdb029ba$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 : (0, $iHYdz.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $iHYdz.akEditorFullWidthLayoutWidth));
};
const $c45fbf05bdb029ba$export$4ab195f543459515 = (origWidth = (0, $intz5.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $iHYdz.akEditorDefaultLayoutWidth), minWidth = (0, $intz5.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $c45fbf05bdb029ba$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $c45fbf05bdb029ba$export$f72673597dacfcfa = (value, interval = (0, $intz5.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $c45fbf05bdb029ba$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $intz5.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $intz5.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $c45fbf05bdb029ba$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $cROsB.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $cROsB.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $c45fbf05bdb029ba$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $c45fbf05bdb029ba$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $c45fbf05bdb029ba$export$7cc71489edfd26f8($pos, view) : $c45fbf05bdb029ba$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $c45fbf05bdb029ba$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $cROsB.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $c45fbf05bdb029ba$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $c45fbf05bdb029ba$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $c45fbf05bdb029ba$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $c45fbf05bdb029ba$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $gZGBX.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});
parcelRegister("cROsB", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $3161276a2e2e68a3$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $3161276a2e2e68a3$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $3161276a2e2e68a3$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $3161276a2e2e68a3$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $3161276a2e2e68a3$export$de65085e667b4bf1);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $kKuJi = parcelRequire("kKuJi");
const $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $kKuJi.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $3161276a2e2e68a3$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $3161276a2e2e68a3$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $3161276a2e2e68a3$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $3161276a2e2e68a3$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $kKuJi.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $kKuJi.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $3161276a2e2e68a3$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $kKuJi.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $kKuJi.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $iHYdz.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("kKuJi", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $96e639534456f333$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $96e639534456f333$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $96e639534456f333$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $96e639534456f333$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $96e639534456f333$export$5e51fc02b9ada5af);

var $iHYdz = parcelRequire("iHYdz");

var $intz5 = parcelRequire("intz5");
const $96e639534456f333$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $96e639534456f333$export$adfc02948d64a4f2 = (layout)=>$96e639534456f333$var$validWidthModes.indexOf(layout) > -1;
function $96e639534456f333$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
}
function $96e639534456f333$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $96e639534456f333$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
}
function $96e639534456f333$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $96e639534456f333$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $96e639534456f333$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($96e639534456f333$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $96e639534456f333$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $iHYdz.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $iHYdz.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($96e639534456f333$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $96e639534456f333$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $96e639534456f333$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $96e639534456f333$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($96e639534456f333$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $96e639534456f333$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});



parcelRegister("ipSX1", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $2f323c2c46d09c5b$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $2f323c2c46d09c5b$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $2f323c2c46d09c5b$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $cROsB = parcelRequire("cROsB");

var $eOOFp = parcelRequire("eOOFp");
function $2f323c2c46d09c5b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $2f323c2c46d09c5b$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $iHYdz.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $iHYdz.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $iHYdz.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $2f323c2c46d09c5b$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $iHYdz.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $iHYdz.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $iHYdz.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $2f323c2c46d09c5b$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $eOOFp.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $eOOFp.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $2f323c2c46d09c5b$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $2f323c2c46d09c5b$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $eOOFp.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(width, containerWidth) : $2f323c2c46d09c5b$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $2f323c2c46d09c5b$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $eOOFp.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $2f323c2c46d09c5b$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $eOOFp.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $2f323c2c46d09c5b$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $2f323c2c46d09c5b$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $2f323c2c46d09c5b$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 */ var $2f323c2c46d09c5b$var$_ref = {
    name: "1ejvwbh",
    styles: "@container view-page-content (min-width: 1px){max-width:100cqw;}"
};
var $2f323c2c46d09c5b$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $2f323c2c46d09c5b$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false })=>{
    const calculatedWidth = $2f323c2c46d09c5b$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $2f323c2c46d09c5b$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $2f323c2c46d09c5b$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $2f323c2c46d09c5b$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $2f323c2c46d09c5b$var$calcMaxWidth(layout, containerWidth));
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $2f323c2c46d09c5b$var$_ref2, " ", isExtendedResizeExperienceOn && (0, $VSDnB.fg)('platform_fix_media_image_resizing') ? $2f323c2c46d09c5b$var$_ref : '', "max-width:", calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $cROsB.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $2f323c2c46d09c5b$var$float(layout), ";margin:", $2f323c2c46d09c5b$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $cROsB.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $2f323c2c46d09c5b$var$isImageAligned(layout), ";");
};
const $2f323c2c46d09c5b$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $f8Sb3.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $2f323c2c46d09c5b$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("position:relative;", $2f323c2c46d09c5b$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $2f323c2c46d09c5b$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f323c2c46d09c5b$export$9e3fd9f6215dd7b6(rest)
    }, children);
$2f323c2c46d09c5b$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $2f323c2c46d09c5b$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});


parcelRegister("icXYC", function(module, exports) {

$parcel$export(module.exports, "EmbedResizeMessageListener", () => $bc7bd21bc3117e37$export$3482036c37e627f4);

var $5uXOq = parcelRequire("5uXOq");

var $f8JAn = parcelRequire("f8JAn");
class $bc7bd21bc3117e37$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        }, this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $f8JAn.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}

});

parcelRegister("35fHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f861fa1747108bf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kKuJi = parcelRequire("kKuJi");
var $h0UFo = parcelRequire("h0UFo");
var $7mf6n = parcelRequire("7mf6n");
var $gZOBO = parcelRequire("gZOBO");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $f8JAn = parcelRequire("f8JAn");
class $4f861fa1747108bf$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            aspectRatio: (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH) / (0, $iHYdz.DEFAULT_EMBED_CARD_HEIGHT)
        };
    }
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $kKuJi.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $kKuJi.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $iHYdz.breakoutWideScaleRatio));
        else return 0, $iHYdz.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $kKuJi.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $kKuJi.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $iHYdz.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $f8JAn.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $iHYdz.akEditorMediaResizeHandlerPadding)
        };
        const enable = {};
        (0, $h0UFo.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $h0UFo.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $gZOBO.wrapperStyle)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7mf6n.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args), this.state = {
            offsetLeft: this.calcOffsetLeft()
        }, this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $kKuJi.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        }, this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        }, this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $kKuJi.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        }, this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $kKuJi.calcMediaPxWidth)({
                origWidth: (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $iHYdz.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        }, this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $h0UFo.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand } = this.props.view.state.schema.nodes;
            if (this.$pos && !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand
            ].filter(Boolean))) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $kKuJi.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}

});
parcelRegister("h0UFo", function(module, exports) {

$parcel$export(module.exports, "snapTo", () => $bd83ac1842fb7d6e$export$ce5a040a76868800);
$parcel$export(module.exports, "handleSides", () => $bd83ac1842fb7d6e$export$8ee741c8b9b43371);
$parcel$export(module.exports, "imageAlignmentMap", () => $bd83ac1842fb7d6e$export$9aaf3d5fbdfcf5c5);
const $bd83ac1842fb7d6e$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
const $bd83ac1842fb7d6e$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
const $bd83ac1842fb7d6e$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};

});

parcelRegister("7mf6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0aa99996e3dd8ef$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $eHaD2 = parcelRequire("eHaD2");

var $iHYdz = parcelRequire("iHYdz");

var $gkwXh = parcelRequire("gkwXh");

var $ceYEW = parcelRequire("ceYEW");

var $j9To4 = parcelRequire("j9To4");

var $h0UFo = parcelRequire("h0UFo");
const $b0aa99996e3dd8ef$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $gkwXh.ACTION_SUBJECT).EMBEDS : (0, $gkwXh.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $gkwXh.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $gkwXh.EVENT_TYPE).UI
    };
};
const $b0aa99996e3dd8ef$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $b0aa99996e3dd8ef$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $h0UFo.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $iHYdz.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $ceYEW.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eHaD2.Resizable), {
            ref: this.resizable,
            size: {
                width: width,
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.state = {
            isResizing: false
        }, this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $j9To4.gridTypeForLayout)(layout), newHighlights);
            });
        }, this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $b0aa99996e3dd8ef$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $j9To4.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        }, this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $b0aa99996e3dd8ef$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $h0UFo.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($b0aa99996e3dd8ef$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $j9To4.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $j9To4.gridTypeForLayout)(layout), []);
            });
        };
    }
}

});
parcelRegister("eHaD2", function(module, exports) {
"use strict";
var $ab2d5372f352af9c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ab2d5372f352af9c$var$__assign = module.exports && module.exports.__assign || function() {
    $ab2d5372f352af9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab2d5372f352af9c$var$__assign.apply(this, arguments);
};
var $ab2d5372f352af9c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $ab2d5372f352af9c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ab2d5372f352af9c$var$React = $ab2d5372f352af9c$var$__importStar((parcelRequire("5uXOq")));

var $f6P3s = parcelRequire("f6P3s");

var $ab2d5372f352af9c$var$fast_memoize_1 = $ab2d5372f352af9c$var$__importDefault((parcelRequire("8mQ2m")));
var $ab2d5372f352af9c$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $ab2d5372f352af9c$var$clamp = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $ab2d5372f352af9c$var$snap = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $ab2d5372f352af9c$var$hasDirection = $ab2d5372f352af9c$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $ab2d5372f352af9c$var$findClosestSnap = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $ab2d5372f352af9c$var$endsWith = $ab2d5372f352af9c$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $ab2d5372f352af9c$var$getStringSize = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'px')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, '%')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vh')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vw')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vmax')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $ab2d5372f352af9c$var$calculateNewMax = $ab2d5372f352af9c$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $ab2d5372f352af9c$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $ab2d5372f352af9c$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $ab2d5372f352af9c$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $ab2d5372f352af9c$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $ab2d5372f352af9c$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $ab2d5372f352af9c$var$baseClassName = '__resizable_base__';
var $ab2d5372f352af9c$var$Resizable = /** @class */ function(_super) {
    $ab2d5372f352af9c$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $ab2d5372f352af9c$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($ab2d5372f352af9c$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $ab2d5372f352af9c$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($ab2d5372f352af9c$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $ab2d5372f352af9c$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $ab2d5372f352af9c$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $ab2d5372f352af9c$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($ab2d5372f352af9c$var$baseClassName);
        else element.className += $ab2d5372f352af9c$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($ab2d5372f352af9c$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($ab2d5372f352af9c$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($ab2d5372f352af9c$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($ab2d5372f352af9c$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $ab2d5372f352af9c$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $ab2d5372f352af9c$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $ab2d5372f352af9c$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $ab2d5372f352af9c$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $ab2d5372f352af9c$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $ab2d5372f352af9c$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $ab2d5372f352af9c$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $ab2d5372f352af9c$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $ab2d5372f352af9c$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($ab2d5372f352af9c$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($ab2d5372f352af9c$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($ab2d5372f352af9c$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($ab2d5372f352af9c$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($ab2d5372f352af9c$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($ab2d5372f352af9c$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $ab2d5372f352af9c$var$React.createElement($f6P3s.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $ab2d5372f352af9c$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($ab2d5372f352af9c$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $ab2d5372f352af9c$var$React.createElement("div", $ab2d5372f352af9c$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $ab2d5372f352af9c$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $ab2d5372f352af9c$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($ab2d5372f352af9c$var$React.PureComponent);
module.exports.Resizable = $ab2d5372f352af9c$var$Resizable;

});
parcelRegister("f6P3s", function(module, exports) {
"use strict";
var $afff04f5d63d71a2$var$__assign = module.exports && module.exports.__assign || function() {
    $afff04f5d63d71a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $afff04f5d63d71a2$var$__assign.apply(this, arguments);
};
var $afff04f5d63d71a2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $afff04f5d63d71a2$var$React = $afff04f5d63d71a2$var$__importStar((parcelRequire("5uXOq")));
var $afff04f5d63d71a2$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $afff04f5d63d71a2$var$Resizer(props) {
    return $afff04f5d63d71a2$var$React.createElement("div", {
        className: props.className || '',
        style: $afff04f5d63d71a2$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $afff04f5d63d71a2$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $afff04f5d63d71a2$var$Resizer;

});

parcelRegister("8mQ2m", function(module, exports) {
//
// Main
//
function $6178be4d98a9a554$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $6178be4d98a9a554$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $6178be4d98a9a554$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $6178be4d98a9a554$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $6178be4d98a9a554$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $6178be4d98a9a554$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $6178be4d98a9a554$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6178be4d98a9a554$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6178be4d98a9a554$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $6178be4d98a9a554$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $6178be4d98a9a554$var$monadic : $6178be4d98a9a554$var$variadic;
    return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $6178be4d98a9a554$var$strategyVariadic(fn, options) {
    var strategy = $6178be4d98a9a554$var$variadic;
    return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $6178be4d98a9a554$var$strategyMonadic(fn, options) {
    var strategy = $6178be4d98a9a554$var$monadic;
    return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $6178be4d98a9a554$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $6178be4d98a9a554$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $6178be4d98a9a554$var$cacheDefault = {
    create: function create() {
        return new $6178be4d98a9a554$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $6178be4d98a9a554$var$memoize;
module.exports.strategies = {
    variadic: $6178be4d98a9a554$var$strategyVariadic,
    monadic: $6178be4d98a9a554$var$strategyMonadic
};

});


parcelRegister("j9To4", function(module, exports) {

$parcel$export(module.exports, "gridTypeForLayout", () => $d114efb4a396db73$export$27813bf9aa3826dc);
const $d114efb4a396db73$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';

});


parcelRegister("gZOBO", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $82b5775f07862174$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ipSX1 = parcelRequire("ipSX1");
const $82b5775f07862174$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("&>div{", (0, $ipSX1.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");

});




parcelRegister("N3kru", function(module, exports) {

$parcel$export(module.exports, "lazyInlineCardView", () => $09e3ee444c4278c8$export$cd3f6a9b84ab8435);

var $3xRyR = parcelRequire("3xRyR");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $2CVDy = parcelRequire("2CVDy");

const $09e3ee444c4278c8$export$cd3f6a9b84ab8435 = (props)=>{
    const isPageSSRed = props.isPageSSRed || false;
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed && (0, $VSDnB.fg)('platform_ssr_smartlinks_editor')) return (0, $2CVDy.inlineCardNodeView)(props);
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'inlineCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("2CVDy"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                return inlineCardNodeView(props);
            });
            return result;
        }
    });
};

});

parcelRegister("lPHrh", function(module, exports) {

$parcel$export(module.exports, "eventsFromTransaction", () => $08a7fbdbfedf9565$export$c985b35883eaea59);

var $f5LPn = parcelRequire("f5LPn");

var $5ZnzP = parcelRequire("5ZnzP");

var $gkwXh = parcelRequire("gkwXh");

var $1ZWXY = parcelRequire("1ZWXY");

var $20Kbb = parcelRequire("20Kbb");
var $77j9j = parcelRequire("77j9j");

var $eS2Dn = parcelRequire("eS2Dn");

var $lumM0 = parcelRequire("lumM0");

var $gBr25 = parcelRequire("gBr25");

var $b2DfX = parcelRequire("b2DfX");

var $1N566 = parcelRequire("1N566");
const $08a7fbdbfedf9565$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $08a7fbdbfedf9565$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $08a7fbdbfedf9565$var$isTransactionResolveReplace(tr);
    // History
    const historyMeta = tr.getMeta((0, $77j9j.pmHistoryPluginKey));
    const isUndo = $08a7fbdbfedf9565$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $08a7fbdbfedf9565$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $08a7fbdbfedf9565$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $eS2Dn.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $20Kbb.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $1N566.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $eS2Dn.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $20Kbb.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $1N566.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $1N566.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $1N566.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $1N566.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $1N566.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $08a7fbdbfedf9565$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet
		 */ if (!isResolveReplace) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $08a7fbdbfedf9565$var$getResolvePositions(tr, state);
        inserted.push(...(0, $1N566.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $1ZWXY.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $1N566.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $08a7fbdbfedf9565$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $1N566.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $1N566.getNodeSubject)(inserted[i].node);
            if ($08a7fbdbfedf9565$var$isDatasourceUpgrade(previousSubject, currentSubject) || $08a7fbdbfedf9565$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $08a7fbdbfedf9565$var$UPDATE_ACTIONS = [
    (0, $gkwXh.ACTION).CHANGED_TYPE,
    (0, $gkwXh.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $08a7fbdbfedf9565$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $f5LPn.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $08a7fbdbfedf9565$var$UPDATE_ACTIONS.includes(action);
    });
};
const $08a7fbdbfedf9565$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $08a7fbdbfedf9565$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $lumM0.pluginKey));
    return $08a7fbdbfedf9565$var$isMetadataQueue(pluginMeta);
};
const $08a7fbdbfedf9565$var$isMetadataQueue = (metaData)=>{
    return $08a7fbdbfedf9565$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $08a7fbdbfedf9565$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $lumM0.pluginKey));
    return $08a7fbdbfedf9565$var$isMetadataResolve(pluginMeta);
};
const $08a7fbdbfedf9565$var$isMetadataResolve = (metaData)=>{
    return $08a7fbdbfedf9565$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $08a7fbdbfedf9565$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $08a7fbdbfedf9565$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $lumM0.pluginKey));
    if (!$08a7fbdbfedf9565$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $08a7fbdbfedf9565$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $gBr25.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $lumM0.pluginKey));
    if (!$08a7fbdbfedf9565$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $08a7fbdbfedf9565$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $gBr25.getPluginState)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $08a7fbdbfedf9565$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $b2DfX.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $b2DfX.EVENT_SUBJECT).LINK;
const $08a7fbdbfedf9565$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $b2DfX.EVENT_SUBJECT).LINK && currentSubject === (0, $b2DfX.EVENT_SUBJECT).DATASOURCE;
function $08a7fbdbfedf9565$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $5ZnzP.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $77j9j.pmHistoryPluginKey));
        const isUndo = $08a7fbdbfedf9565$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $08a7fbdbfedf9565$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $1ZWXY.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $08a7fbdbfedf9565$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $1N566.getNodeSubject)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $1N566.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $b2DfX.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $1N566.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $b2DfX.EVENT).DELETED);
        pushEvents(inserted, (0, $b2DfX.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}

});
parcelRegister("5ZnzP", function(module, exports) {

$parcel$export(module.exports, "TableSortStep", () => $9b15ba5eea984bbe$export$c1b7e6427b2a2113);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");parcelRequire("c3rYx");
var $eS2Dn = parcelRequire("eS2Dn");
const $9b15ba5eea984bbe$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $9b15ba5eea984bbe$export$c1b7e6427b2a2113 extends (0, $eS2Dn.Step) {
    constructor(pos, prev, next){
        super();
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
    invert() {
        return new $9b15ba5eea984bbe$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $eS2Dn.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $9b15ba5eea984bbe$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($9b15ba5eea984bbe$export$3f33e36adb7672cc, $9b15ba5eea984bbe$export$c1b7e6427b2a2113);

});
parcelRegister("c3rYx", function(module, exports) {

$parcel$export(module.exports, "Step", () => (parcelRequire("eS2Dn")).Step);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $8c6b772f0b7d41ed$var$originalFromJSON = (0, $eS2Dn.Step).fromJSON;
(0, $eS2Dn.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $8c6b772f0b7d41ed$var$originalFromJSON(schema, jsonStep);
    // See https://switcheroo.atlassian.com/ui/gates/4e7e1e8c-9126-4dba-a2a3-1c2b86f81c36/key/platform_editor_metadata_steps
    if (!(0, $VSDnB.fg)('platform_editor_metadata_step')) return stepImplementation;
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});


parcelRegister("77j9j", function(module, exports) {

$parcel$export(module.exports, "pmHistoryPluginKey", () => $3eac7c1ce2173d69$export$d4f2631252432abf);
$parcel$export(module.exports, "shallowEqual", () => $3eac7c1ce2173d69$export$d36bdfa510afb180);
$parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", () => $3eac7c1ce2173d69$export$51bf7c6695e13879);
$parcel$export(module.exports, "isInListItem", () => $3eac7c1ce2173d69$export$92d47fcf661e090e);
$parcel$export(module.exports, "findFarthestParentNode", () => $3eac7c1ce2173d69$export$6b982788a5f0ccef);
$parcel$export(module.exports, "insideTableCell", () => $3eac7c1ce2173d69$export$1350ff12653c84d4);
$parcel$export(module.exports, "checkNodeDown", () => $3eac7c1ce2173d69$export$d0951c59cd3dac0f);
$parcel$export(module.exports, "isEmptyNode", () => $3eac7c1ce2173d69$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isNodeEmpty", () => $3eac7c1ce2173d69$export$cd58ff1081f6abe9);
$parcel$export(module.exports, "isInEmptyLine", () => $3eac7c1ce2173d69$export$3b68253250b41118);
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("594Yf")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("ggL2v")).hasDocAsParent);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5r0mK = parcelRequire("5r0mK");

var $ggL2v = parcelRequire("ggL2v");

var $594Yf = parcelRequire("594Yf");

var $gOwky = parcelRequire("gOwky");

var $h03xs = parcelRequire("h03xs");

var $lVKVw = parcelRequire("lVKVw");

var $gE8f9 = parcelRequire("gE8f9");

var $fTi1m = parcelRequire("fTi1m");

var $cAMv0 = parcelRequire("cAMv0");

var $c1exv = parcelRequire("c1exv");

var $eOOFp = parcelRequire("eOOFp");

var $20Kbb = parcelRequire("20Kbb");

var $aOimD = parcelRequire("aOimD");

var $7vpuQ = parcelRequire("7vpuQ");

var $eQcNy = parcelRequire("eQcNy");


var $4NUlu = parcelRequire("4NUlu");

var $2KwKW = parcelRequire("2KwKW");

var $d54NZ = parcelRequire("d54NZ");






var $2vGdQ = parcelRequire("2vGdQ");

var $5or39 = parcelRequire("5or39");

var $5J0oM = parcelRequire("5J0oM");

var $5vnE9 = parcelRequire("5vnE9");

var $lGkyv = parcelRequire("lGkyv");


var $fc6h8 = parcelRequire("fc6h8");


var $WXnhI = parcelRequire("WXnhI");

var $4AgYP = parcelRequire("4AgYP");


var $4IuOY = parcelRequire("4IuOY");




var $2Cwj1 = parcelRequire("2Cwj1");

var $hEIDx = parcelRequire("hEIDx");

var $uTDrM = parcelRequire("uTDrM");

var $dPSMN = parcelRequire("dPSMN");

var $j9To4 = parcelRequire("j9To4");

var $agxMF = parcelRequire("agxMF");

var $cROsB = parcelRequire("cROsB");


var $3dBkm = parcelRequire("3dBkm");

var $k24a0 = parcelRequire("k24a0");




var $2Abpa = parcelRequire("2Abpa");

var $cz9kf = parcelRequire("cz9kf");

var $iXNbm = parcelRequire("iXNbm");

var $aDFRV = parcelRequire("aDFRV");

var $aeKzo = parcelRequire("aeKzo");

var $2C7zq = parcelRequire("2C7zq");

var $biLOy = parcelRequire("biLOy");


const $3eac7c1ce2173d69$export$d4f2631252432abf = 'history$';
function $3eac7c1ce2173d69$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $3eac7c1ce2173d69$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $3eac7c1ce2173d69$export$92d47fcf661e090e = (state)=>{
    return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $3eac7c1ce2173d69$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $3eac7c1ce2173d69$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3eac7c1ce2173d69$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $3eac7c1ce2173d69$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $3eac7c1ce2173d69$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $3eac7c1ce2173d69$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $3eac7c1ce2173d69$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $3eac7c1ce2173d69$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $594Yf.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $594Yf.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $3eac7c1ce2173d69$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $594Yf.isEmptyParagraph)(node) && (0, $ggL2v.hasDocAsParent)($anchor);
}

});
parcelRegister("lVKVw", function(module, exports) {

$parcel$export(module.exports, "getExtensionLozengeData", () => $1938aba83063b4fb$export$4fd8ecadd193bea0);
const $1938aba83063b4fb$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};

});

parcelRegister("c1exv", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $9600f65038d22dcf$export$9b0f795b2e33f057);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $9600f65038d22dcf$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $9600f65038d22dcf$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $9600f65038d22dcf$export$9b0f795b2e33f057 = (Wrapped)=>{
    if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2') || (0, $VSDnB.fg)('platform_editor_react18_phase2_v2_extended')) return $9600f65038d22dcf$var$withImageLoaderNew(Wrapped);
    return $9600f65038d22dcf$export$3a0bcc6ff2e20f36(Wrapped);
};

});

parcelRegister("aOimD", function(module, exports) {

$parcel$export(module.exports, "pluginFactory", () => $b35c4d4356c0af83$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b35c4d4356c0af83$var$isFunction(x) {
    return typeof x === 'function';
}
function $b35c4d4356c0af83$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$b35c4d4356c0af83$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $b35c4d4356c0af83$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("lGkyv", function(module, exports) {

$parcel$export(module.exports, "isTextInput", () => $4ed0bf9464bdda71$export$3e6057b9bf6b0bbb);

var $eS2Dn = parcelRequire("eS2Dn");
const $4ed0bf9464bdda71$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $eS2Dn.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};

});

parcelRegister("4AgYP", function(module, exports) {

$parcel$export(module.exports, "sniffUserBrowserExtensions", () => $5be8a446da622e19$export$4cd1ca2600761f65);
const $5be8a446da622e19$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $5be8a446da622e19$var$RACE_COMPLETE = 'race_complete';
const $5be8a446da622e19$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $5be8a446da622e19$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $5be8a446da622e19$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $5be8a446da622e19$var$registerDetectors(options.extensions, $5be8a446da622e19$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $5be8a446da622e19$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}

});

parcelRegister("2Cwj1", function(module, exports) {

$parcel$export(module.exports, "autoJoinTr", () => $34e191c8f61c54e1$export$c7c1e59168a7f554);

var $eS2Dn = parcelRequire("eS2Dn");
function $34e191c8f61c54e1$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $eS2Dn.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}

});

parcelRegister("hEIDx", function(module, exports) {

$parcel$export(module.exports, "isReferencedSource", () => $0a8d6f5b4b6694a4$export$d35a68bd2e0b55da);
$parcel$export(module.exports, "removeConnectedNodes", () => $0a8d6f5b4b6694a4$export$657e59857351232d);
$parcel$export(module.exports, "getChildrenInfo", () => $0a8d6f5b4b6694a4$export$c98d43680e607ac1);
$parcel$export(module.exports, "getNodeName", () => $0a8d6f5b4b6694a4$export$651544f548703224);
const $0a8d6f5b4b6694a4$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $0a8d6f5b4b6694a4$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $0a8d6f5b4b6694a4$var$getSelectedLocalIds(state, node);
    const allNodes = $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $0a8d6f5b4b6694a4$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $0a8d6f5b4b6694a4$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $0a8d6f5b4b6694a4$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $0a8d6f5b4b6694a4$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$0a8d6f5b4b6694a4$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $0a8d6f5b4b6694a4$var$getNodeNameById(id, allNodes),
        amount: $0a8d6f5b4b6694a4$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $0a8d6f5b4b6694a4$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $0a8d6f5b4b6694a4$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0a8d6f5b4b6694a4$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $0a8d6f5b4b6694a4$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $0a8d6f5b4b6694a4$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
const $0a8d6f5b4b6694a4$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};

});

parcelRegister("cz9kf", function(module, exports) {

$parcel$export(module.exports, "dedupe", () => $b4d75c9e493507f1$export$f3a259b74a77132f);
function $b4d75c9e493507f1$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}

});

parcelRegister("aDFRV", function(module, exports) {

$parcel$export(module.exports, "transformNodeIntoListItem", () => $3e3acfe58aba3a90$export$f4c81471ccea5042);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $uTDrM = parcelRequire("uTDrM");
// Taken from `editor-plugin-content-insertion`
function $3e3acfe58aba3a90$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $kCV8T.Slice).maxOpen((0, $kCV8T.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $gZGBX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $3e3acfe58aba3a90$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $uTDrM.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $5r0mK.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $3e3acfe58aba3a90$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}

});

parcelRegister("2C7zq", function(module, exports) {

$parcel$export(module.exports, "calculateToolbarPositionAboveSelection", () => $5d709aa1b364f0a8$export$5966a251e0deb6ac);
$parcel$export(module.exports, "calculateToolbarPositionTrackHead", () => $5d709aa1b364f0a8$export$4fdfbe77de19eec);
$parcel$export(module.exports, "calculateToolbarPositionOnCellSelection", () => $5d709aa1b364f0a8$export$2d9cc331fb808a87);

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");
const $5d709aa1b364f0a8$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $5d709aa1b364f0a8$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $5d709aa1b364f0a8$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $5d709aa1b364f0a8$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $5d709aa1b364f0a8$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $5d709aa1b364f0a8$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $5d709aa1b364f0a8$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop = 10;
const $5d709aa1b364f0a8$var$scrollbarWidth = 20;
const $5d709aa1b364f0a8$var$offsetTopOnColumnSelection = 4;
const $5d709aa1b364f0a8$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $hFEwm.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $5r0mK.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $5r0mK.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $5d709aa1b364f0a8$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $5d709aa1b364f0a8$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom && (0, $VSDnB.fg)('platform_editor_controls_patch_2')) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };

});

parcelRegister("biLOy", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $f5822fec42041939$export$947fc26275418e36);
const $f5822fec42041939$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});


parcelRegister("b2DfX", function(module, exports) {

$parcel$export(module.exports, "EVENT", () => $9bc21a2560c0033b$export$e39a34cfd532e15);
$parcel$export(module.exports, "EVENT_SUBJECT", () => $9bc21a2560c0033b$export$97c6cb64ce06a88a);
var $9bc21a2560c0033b$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $9bc21a2560c0033b$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});

});

parcelRegister("1N566", function(module, exports) {

$parcel$export(module.exports, "getNodeSubject", () => $b0ebec3108799dca$export$d3d4c2526aede29a);
$parcel$export(module.exports, "appearanceForLink", () => $b0ebec3108799dca$export$599e1b655555ab1d);
$parcel$export(module.exports, "getUrl", () => $b0ebec3108799dca$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getNodeContext", () => $b0ebec3108799dca$export$c63a892fcfc539bc);
$parcel$export(module.exports, "findAtPositions", () => $b0ebec3108799dca$export$7ea2145b3909e5c6);
$parcel$export(module.exports, "findInNodeRange", () => $b0ebec3108799dca$export$dbc52ec0d340ce50);
$parcel$export(module.exports, "areSameNodes", () => $b0ebec3108799dca$export$1f3592a520a7960d);

var $jPPkn = parcelRequire("jPPkn");

var $b2DfX = parcelRequire("b2DfX");
function $b0ebec3108799dca$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $b0ebec3108799dca$export$26ada819291bd8df = (node)=>{
    if ($b0ebec3108799dca$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $jPPkn.appearanceForNodeType)(node.type)) return true;
    return $b0ebec3108799dca$var$hasLinkMark(node);
};
function $b0ebec3108799dca$export$d3d4c2526aede29a(node) {
    if ($b0ebec3108799dca$export$962cfe99b8da8614(node)) return (0, $b2DfX.EVENT_SUBJECT).DATASOURCE;
    if ($b0ebec3108799dca$export$26ada819291bd8df(node)) return (0, $b2DfX.EVENT_SUBJECT).LINK;
    return null;
}
function $b0ebec3108799dca$export$599e1b655555ab1d(node) {
    const appearance = (0, $jPPkn.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $b0ebec3108799dca$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $b0ebec3108799dca$var$hasLinkMark = (node)=>{
    return !!$b0ebec3108799dca$var$getLinkMark(node);
};
function $b0ebec3108799dca$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $b0ebec3108799dca$var$getLinkMark(node)?.attrs?.href;
}
const $b0ebec3108799dca$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $b0ebec3108799dca$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $b0ebec3108799dca$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $b0ebec3108799dca$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $b0ebec3108799dca$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $b0ebec3108799dca$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($b0ebec3108799dca$export$94df0e59ebebf4a7(a.node) !== $b0ebec3108799dca$export$94df0e59ebebf4a7(b.node) || $b0ebec3108799dca$export$599e1b655555ab1d(a.node) !== $b0ebec3108799dca$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};

});


parcelRegister("h162L", function(module, exports) {

$parcel$export(module.exports, "getDatasource", () => $6fb9541cf91063a0$export$32844f9f273856e4);
$parcel$export(module.exports, "isDatasourceTableLayout", () => $6fb9541cf91063a0$export$8467cbb601c13bfc);

var $5r0mK = parcelRequire("5r0mK");

var $jPPkn = parcelRequire("jPPkn");

var $2E94j = parcelRequire("2E94j");
const $6fb9541cf91063a0$export$32844f9f273856e4 = (editorView)=>{
    const { selection: selection, schema: schema } = editorView.state;
    const { blockCard: blockCard } = schema.nodes;
    const findResult = (0, $5r0mK.findSelectedNodeOfType)([
        blockCard
    ])(selection);
    if (findResult && (0, $jPPkn.isDatasourceNode)(findResult.node)) return {
        ...findResult,
        node: findResult.node
    };
    return {
        node: undefined,
        pos: undefined
    };
};
const $6fb9541cf91063a0$export$8467cbb601c13bfc = (layout)=>{
    return (0, $2E94j.DATASOURCE_TABLE_LAYOUTS).some((l)=>l === layout);
};

});
parcelRegister("2E94j", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_TABLE_LAYOUTS", () => $c7ea2dfde8763beb$export$3f155c85880510c8);
const $c7ea2dfde8763beb$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];

});


parcelRegister("bYyIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ce5f187ffffb185$export$2e2bcd8739ae039);
const $0ce5f187ffffb185$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $0ce5f187ffffb185$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $0ce5f187ffffb185$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $0ce5f187ffffb185$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $0ce5f187ffffb185$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $0ce5f187ffffb185$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $0ce5f187ffffb185$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $0ce5f187ffffb185$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $0ce5f187ffffb185$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $0ce5f187ffffb185$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $0ce5f187ffffb185$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $0ce5f187ffffb185$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $0ce5f187ffffb185$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $0ce5f187ffffb185$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $0ce5f187ffffb185$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $0ce5f187ffffb185$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $0ce5f187ffffb185$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $0ce5f187ffffb185$var$queue(state, action);
        case 'SET_PROVIDER':
            return $0ce5f187ffffb185$var$setProvider(state, action);
        case 'RESOLVE':
            return $0ce5f187ffffb185$var$resolve(state, action);
        case 'REGISTER':
            return $0ce5f187ffffb185$var$register(state, action);
        case 'REMOVE_CARD':
            return $0ce5f187ffffb185$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $0ce5f187ffffb185$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $0ce5f187ffffb185$var$setDatasourceTableRef(state, action);
        case 'SET_CARD_LAYOUT':
            return $0ce5f187ffffb185$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $0ce5f187ffffb185$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $0ce5f187ffffb185$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $0ce5f187ffffb185$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $0ce5f187ffffb185$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $0ce5f187ffffb185$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $0ce5f187ffffb185$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $0ce5f187ffffb185$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $0ce5f187ffffb185$var$removeDatasourceStash(state, action);
    }
};

});

parcelRegister("jhHFS", function(module, exports) {

$parcel$export(module.exports, "resolveWithProvider", () => $80f73e55a8a66765$export$2007d0af08977743);
$parcel$export(module.exports, "handleProvider", () => $80f73e55a8a66765$export$96766f42428c9e7f);

var $3dBkm = parcelRequire("3dBkm");parcelRequire("77j9j");
var $ggL2v = parcelRequire("ggL2v");

var $VSDnB = parcelRequire("VSDnB");

var $nYpqR = parcelRequire("nYpqR");

var $jPiXc = parcelRequire("jPiXc");
const $80f73e55a8a66765$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $ggL2v.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $80f73e55a8a66765$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent)=>{
    const isEmbedFriendlyLocation = (0, $VSDnB.fg)('hardcoded-embeds-only-on-new-line') ? $80f73e55a8a66765$var$isFreshlyPastedOnNewLine(view) : true;
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($80f73e55a8a66765$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options), $80f73e55a8a66765$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $80f73e55a8a66765$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $3dBkm.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $80f73e55a8a66765$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options)=>(resolvedCard)=>{
        $80f73e55a8a66765$var$updateCardType(resolvedCard, options);
        (0, $jPiXc.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent)(view.state, view.dispatch);
        return resolvedCard;
    };
const $80f73e55a8a66765$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $jPiXc.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $80f73e55a8a66765$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $nYpqR.setProvider)(cardProvider)(state.tr));
    });
};

});


parcelRegister("1QWoP", function(module, exports) {

$parcel$export(module.exports, "createEventsQueue", () => $e4e48c86b3ce55d0$export$5115a388c364848d);
const $e4e48c86b3ce55d0$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};

});

parcelRegister("dUrXD", function(module, exports) {

$parcel$export(module.exports, "default", () => $56546fd1f6348cd8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $awTmI = parcelRequire("awTmI");

var $lX6w0 = parcelRequire("lX6w0");
var $f980L = parcelRequire("f980L");
var $7mvwv = parcelRequire("7mvwv");

var $051X7 = parcelRequire("051X7");

var $gDJbm = parcelRequire("gDJbm");

var $h44wZ = parcelRequire("h44wZ");
const $56546fd1f6348cd8$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $051X7.useSmartLinkContext)();
    const { cardState: cardState } = (0, $awTmI.useSharedPluginState)(api, [
        'card'
    ]);
    if (!cardState) return null;
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = cardState;
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $56546fd1f6348cd8$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gDJbm.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h44wZ.DatasourceModal), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $56546fd1f6348cd8$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $051X7.EditorSmartCardProviderValueGuard), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($56546fd1f6348cd8$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $56546fd1f6348cd8$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $7mvwv.default),
        datasourceId: (0, $7mvwv.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $f980L.default),
        datasourceId: (0, $f980L.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $lX6w0.default),
        datasourceId: (0, $lX6w0.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $56546fd1f6348cd8$export$2e2bcd8739ae039 = $56546fd1f6348cd8$var$SafeModalWithState;

});
parcelRegister("h44wZ", function(module, exports) {

$parcel$export(module.exports, "DatasourceModal", () => $b5353b37825636a3$export$95702e90d329951a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gZGBX = parcelRequire("gZGBX");

var $nYpqR = parcelRequire("nYpqR");

var $jPiXc = parcelRequire("jPiXc");

var $dYS3B = parcelRequire("dYS3B");
const $b5353b37825636a3$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $b5353b37825636a3$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $nYpqR.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $b5353b37825636a3$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $b5353b37825636a3$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $dYS3B.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $b5353b37825636a3$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $5uXOq.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $jPiXc.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $jPiXc.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $b5353b37825636a3$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $gZGBX.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $b5353b37825636a3$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};

});
parcelRegister("dYS3B", function(module, exports) {

$parcel$export(module.exports, "useFetchDatasourceInfo", () => $2f2c2b9b4d154727$export$d01c44dffc996c80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");
const $2f2c2b9b4d154727$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $5uXOq.useState)(undefined);
    const [parameters, setParameters] = (0, $5uXOq.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $5uXOq.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};

});



parcelRegister("eZ5Wl", function(module, exports) {

$parcel$export(module.exports, "EditorLinkingPlatformAnalytics", () => $bbf9497f600545ea$export$c083a9ed3df8f5ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $9NQiC = parcelRequire("9NQiC");

var $8SiaW = parcelRequire("8SiaW");

var $lq1wM = parcelRequire("lq1wM");
class $bbf9497f600545ea$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $051X7.EditorSmartCardProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $051X7.EditorSmartCardProviderValueGuard), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9NQiC.EditorAnalyticsContext), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lq1wM.LinkEventsBinding), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SiaW.DatasourceEventsBinding), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}

});
parcelRegister("8SiaW", function(module, exports) {

$parcel$export(module.exports, "DatasourceEventsBinding", () => $2ca216cd5db680ff$export$bddcbec746c26287);

var $5uXOq = parcelRequire("5uXOq");

var $1SrMX = parcelRequire("1SrMX");

var $cnkQa = parcelRequire("cnkQa");

var $b2DfX = parcelRequire("b2DfX");

var $igJuy = parcelRequire("igJuy");
function $2ca216cd5db680ff$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $2ca216cd5db680ff$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $2ca216cd5db680ff$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $1SrMX.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $2ca216cd5db680ff$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $igJuy.getMethod)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $1SrMX.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $2ca216cd5db680ff$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $2ca216cd5db680ff$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $2ca216cd5db680ff$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $cnkQa.useDatasourceLifecycleAnalytics)();
    const eventHandlers = (0, $5uXOq.useMemo)(()=>{
        return {
            [(0, $b2DfX.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $b2DfX.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $b2DfX.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
	 * Subscribe to datasource events
	 */ (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $b2DfX.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};

});
parcelRegister("cnkQa", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkLifecycleAnalytics", () => $d2d4d3d1a0acd921$export$612752b1e088a45e);
$parcel$export(module.exports, "useDatasourceLifecycleAnalytics", () => $d2d4d3d1a0acd921$export$c82e48d9fd97c55b);

var $5uXOq = parcelRequire("5uXOq");

var $gB4mS = parcelRequire("gB4mS");
var $2NMNM = parcelRequire("2NMNM");

var $051X7 = parcelRequire("051X7");


var $joONg = parcelRequire("joONg");

var $jTAf7 = parcelRequire("jTAf7");

var $vE5bM = parcelRequire("vE5bM");

const $d2d4d3d1a0acd921$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $jTAf7.runWhenIdle)(()=>{
                        (0, $gB4mS.default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, $joONg.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $jTAf7.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("d42XY"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $gB4mS.default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, $joONg.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $d2d4d3d1a0acd921$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $vE5bM.useDatasourceClientExtension)();
    return (0, $5uXOq.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $jTAf7.runWhenIdle)(()=>{
                        (0, $gB4mS.default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, $joONg.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $jTAf7.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("d42XY"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $gB4mS.default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, $joONg.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};

});
const $4f7d2702bff62e14$export$3f072f06b90c3985 = 'media';

parcelRegister("joONg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87ca182f31c1317$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $f87ca182f31c1317$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $f87ca182f31c1317$export$2e2bcd8739ae039 = $f87ca182f31c1317$var$createEventPayload;

});

parcelRegister("jTAf7", function(module, exports) {

$parcel$export(module.exports, "runWhenIdle", () => $c2cb70bd48315db6$export$51d09170c61ebe04);
/* eslint-disable compat/compat */ const $c2cb70bd48315db6$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);

});

parcelRegister("vE5bM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", () => $68367fd71731b630$export$5e074c0b68e2ce03);
$parcel$export(module.exports, "useDatasourceClientExtension", () => $68367fd71731b630$export$7d812bb756889442);

var $5uXOq = parcelRequire("5uXOq");

var $iwKVT = parcelRequire("iwKVT");

var $051X7 = parcelRequire("051X7");

var $dV0Jy = parcelRequire("dV0Jy");

var $3b94d = parcelRequire("3b94d");
const $68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE = 50;
const $68367fd71731b630$export$f82fcd766a8daa7f = new (0, $iwKVT.LRUMap)($68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE);
const $68367fd71731b630$export$40b1dd31340bd5c2 = new (0, $iwKVT.LRUMap)($68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE);
const $68367fd71731b630$export$15cd58682efec5a5 = new (0, $iwKVT.LRUMap)($68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE);
const $68367fd71731b630$export$5e074c0b68e2ce03 = 20;
const $68367fd71731b630$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $051X7.useSmartLinkContext)();
    const resolverUrl = (0, $3b94d.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
			 * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
			 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $dV0Jy.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $dV0Jy.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $5uXOq.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $68367fd71731b630$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $5uXOq.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $68367fd71731b630$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $5uXOq.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $68367fd71731b630$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $5uXOq.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $5uXOq.useCallback)((ari)=>{
        $68367fd71731b630$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $68367fd71731b630$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};

});

parcelRegister("d42XY", function(module, exports) {

let $982df31f7e9023cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $982df31f7e9023cc$var$load("3g9JX").then(()=>parcelRequire('he8BE'));

});


parcelRegister("igJuy", function(module, exports) {

$parcel$export(module.exports, "getMethod", () => $922800648ad4cfa9$export$8793fab959da70d1);
$parcel$export(module.exports, "getUpdateType", () => $922800648ad4cfa9$export$df2aa842dc5172b0);
$parcel$export(module.exports, "getDeleteType", () => $922800648ad4cfa9$export$1cf3d8365b174bde);
$parcel$export(module.exports, "getSourceEventFromMetadata", () => $922800648ad4cfa9$export$b3b4df0d75d4c011);

var $1SrMX = parcelRequire("1SrMX");

var $gkwXh = parcelRequire("gkwXh");
/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $922800648ad4cfa9$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $922800648ad4cfa9$export$8793fab959da70d1 = $922800648ad4cfa9$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $gkwXh.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $gkwXh.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $gkwXh.INPUT_METHOD).AUTO_DETECT:
        case (0, $gkwXh.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $gkwXh.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $gkwXh.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $gkwXh.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $922800648ad4cfa9$export$df2aa842dc5172b0 = $922800648ad4cfa9$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $gkwXh.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $gkwXh.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $922800648ad4cfa9$export$1cf3d8365b174bde = $922800648ad4cfa9$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $gkwXh.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $922800648ad4cfa9$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $1SrMX.default) ? metadata.sourceEvent : null;
};

});


parcelRegister("lq1wM", function(module, exports) {

$parcel$export(module.exports, "LinkEventsBinding", () => $bcf1c5a5b36814a0$export$aa142efb89c75ed5);

var $5uXOq = parcelRequire("5uXOq");

var $cnkQa = parcelRequire("cnkQa");

var $b2DfX = parcelRequire("b2DfX");

var $1N566 = parcelRequire("1N566");

var $igJuy = parcelRequire("igJuy");
/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $bcf1c5a5b36814a0$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $bcf1c5a5b36814a0$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
	 * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
	 * to defer any heavy operations involving network
	 *
	 * The callbacks themselves should not be deferred, they should be called syncronously the moment
	 * the events take place.
	 */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $cnkQa.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $5uXOq.useMemo)(()=>{
        return {
            [(0, $b2DfX.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $1N566.getUrl)(node);
                if (!url) return;
                const display = (0, $1N566.appearanceForLink)(node);
                const displayCategory = $bcf1c5a5b36814a0$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $igJuy.getSourceEventFromMetadata)(metadata);
                const creationMethod = (0, $igJuy.getMethod)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $b2DfX.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $1N566.getUrl)(node);
                if (!url) return;
                const display = (0, $1N566.appearanceForLink)(node);
                const displayCategory = $bcf1c5a5b36814a0$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $igJuy.getSourceEventFromMetadata)(metadata);
                const updateMethod = (0, $igJuy.getMethod)(metadata);
                const updateType = (0, $igJuy.getUpdateType)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $b2DfX.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $1N566.getUrl)(node);
                if (!url) return;
                const display = (0, $1N566.appearanceForLink)(node);
                const displayCategory = $bcf1c5a5b36814a0$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $igJuy.getSourceEventFromMetadata)(metadata);
                const deleteMethod = (0, $igJuy.getMethod)(metadata);
                const deleteType = (0, $igJuy.getDeleteType)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
	 * Subscribe to link events
	 */ (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $b2DfX.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};

});


parcelRegister("AYP48", function(module, exports) {

$parcel$export(module.exports, "EditorSmartCardEvents", () => $32fdacad52225ffa$export$e7d7ea2bc9a806d9);

var $5uXOq = parcelRequire("5uXOq");

var $k2X7C = parcelRequire("k2X7C");

var $nYpqR = parcelRequire("nYpqR");
const $32fdacad52225ffa$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $k2X7C.useSmartLinkEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!events) return;
        editorView.dispatch((0, $nYpqR.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};

});
parcelRegister("k2X7C", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkEvents", () => $570166268224cbe4$export$ed70996d478e16d3);

var $5uXOq = parcelRequire("5uXOq");

var $fzJZi = parcelRequire("fzJZi");
function $570166268224cbe4$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $5uXOq.useMemo)(()=>new (0, $fzJZi.SmartLinkEvents)(), []);
    return events;
}

});


parcelRegister("6caZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d32e1b0577f55bc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $awTmI = parcelRequire("awTmI");

var $4N9VB = parcelRequire("4N9VB");

var $1jI4k = parcelRequire("1jI4k");

var $eOOFp = parcelRequire("eOOFp");

var $iurLX = parcelRequire("iurLX");

var $fCfvZ = parcelRequire("fCfvZ");

var $8sVBM = parcelRequire("8sVBM");

var $10aQ7 = parcelRequire("10aQ7");


var $VSDnB = parcelRequire("VSDnB");


var $nYpqR = parcelRequire("nYpqR");

var $jPPkn = parcelRequire("jPPkn");

var $h162L = parcelRequire("h162L");
const $d32e1b0577f55bc5$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: `${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`}`,
    color: `${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${`var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, white)"} !important`
    }
});
const $d32e1b0577f55bc5$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $44fe84ed19a5b32b$export$60efea3f80310017), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $eOOFp.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $5uXOq.useMemo)(()=>{
        return formatMessage((0, $eOOFp.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    const collapseIcon = (0, $VSDnB.fg)('platform-editor-plugin-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fCfvZ))), {
        label: title
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8sVBM))), {
        label: title
    });
    const expandIcon = (0, $VSDnB.fg)('platform-editor-plugin-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iurLX))), {
        label: title
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($10aQ7))), {
        label: title
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        testId: testId,
        css: $d32e1b0577f55bc5$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? collapseIcon : expandIcon
    }));
};
const $d32e1b0577f55bc5$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { cardState: cardState } = (0, $awTmI.useSharedPluginState)(api, [
        'card'
    ]);
    const { node: node, pos: pos } = (0, $h162L.getDatasource)(editorView);
    const isDatasource = (0, $jPPkn.isDatasourceNode)(node);
    if (!isDatasource) return null;
    //  If layout doesn't exist in ADF it returns null, we want to change to undefined
    //  which results in default parameter value being used in LayoutButton.
    const { datasourceTableRef: datasourceTableRef, layout: layout = node?.attrs?.layout || undefined } = cardState ?? {};
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $h162L.getDatasource)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $nYpqR.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d32e1b0577f55bc5$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $h162L.isDatasourceTableLayout)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
var $d32e1b0577f55bc5$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d32e1b0577f55bc5$var$LayoutButtonWrapper);

});
parcelRegister("iurLX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f66a5317b716408a42d96f72b3784ae4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d760925e6e626902$var$_react = $d760925e6e626902$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d760925e6e626902$var$_growHorizontal = $d760925e6e626902$var$_interopRequireDefault((parcelRequire("eQVzV")));

var $d760925e6e626902$var$_expand = $d760925e6e626902$var$_interopRequireDefault((parcelRequire("10aQ7")));
function $d760925e6e626902$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowHorizontalIcon.
 * This component is GrowHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorExpandIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d760925e6e626902$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $d760925e6e626902$var$_react.default.createElement($d760925e6e626902$var$_growHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $d760925e6e626902$var$_expand.default
    }, props));
$d760925e6e626902$var$GrowHorizontalIcon.Name = 'GrowHorizontalIconMigration';
var $d760925e6e626902$var$_default = module.exports.default = $d760925e6e626902$var$GrowHorizontalIcon;

});
parcelRegister("eQVzV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da1cd6bc83afe2b3eb4120a294491d29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad0295eaae02a064$var$_react = $ad0295eaae02a064$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ad0295eaae02a064$var$_baseNew = $ad0295eaae02a064$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ad0295eaae02a064$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad0295eaae02a064$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $ad0295eaae02a064$var$_react.default.createElement($ad0295eaae02a064$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$ad0295eaae02a064$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $ad0295eaae02a064$var$_default = module.exports.default = $ad0295eaae02a064$var$GrowHorizontalIcon;

});

parcelRegister("10aQ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bae3314669faf11$var$_react = $0bae3314669faf11$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0bae3314669faf11$var$_growHorizontal = $0bae3314669faf11$var$_interopRequireDefault((parcelRequire("eQVzV")));
function $0bae3314669faf11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bae3314669faf11$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $0bae3314669faf11$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
    }, props, {
        newIcon: $0bae3314669faf11$var$_growHorizontal.default
    }));
$0bae3314669faf11$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $0bae3314669faf11$var$_default = module.exports.default = $0bae3314669faf11$var$EditorExpandIcon;

});


parcelRegister("fCfvZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25091e321a5cc356e731192d00270521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5e67097e9bd6170$var$_react = $b5e67097e9bd6170$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5e67097e9bd6170$var$_shrinkHorizontal = $b5e67097e9bd6170$var$_interopRequireDefault((parcelRequire("hocXQ")));

var $b5e67097e9bd6170$var$_collapse = $b5e67097e9bd6170$var$_interopRequireDefault((parcelRequire("8sVBM")));
function $b5e67097e9bd6170$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkHorizontalIcon.
 * This component is ShrinkHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorCollapseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5e67097e9bd6170$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $b5e67097e9bd6170$var$_react.default.createElement($b5e67097e9bd6170$var$_shrinkHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b5e67097e9bd6170$var$_collapse.default
    }, props));
$b5e67097e9bd6170$var$ShrinkHorizontalIcon.Name = 'ShrinkHorizontalIconMigration';
var $b5e67097e9bd6170$var$_default = module.exports.default = $b5e67097e9bd6170$var$ShrinkHorizontalIcon;

});
parcelRegister("hocXQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a9e4799467251fb8d42dd325d017373>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca8ebbfe28d077b2$var$_react = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ca8ebbfe28d077b2$var$_baseNew = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ca8ebbfe28d077b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $ca8ebbfe28d077b2$var$_react.default.createElement($ca8ebbfe28d077b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ca8ebbfe28d077b2$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $ca8ebbfe28d077b2$var$_default = module.exports.default = $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon;

});

parcelRegister("8sVBM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $629da0128daed98a$var$_react = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $629da0128daed98a$var$_shrinkHorizontal = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("hocXQ")));
function $629da0128daed98a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $629da0128daed98a$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $629da0128daed98a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
    }, props, {
        newIcon: $629da0128daed98a$var$_shrinkHorizontal.default
    }));
$629da0128daed98a$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $629da0128daed98a$var$_default = module.exports.default = $629da0128daed98a$var$EditorCollapseIcon;

});



parcelRegister("f10aj", function(module, exports) {

$parcel$export(module.exports, "floatingToolbar", () => $bd6c17cfa0b64309$export$4850df084251d287);
$parcel$export(module.exports, "shouldRenderToolbarPulse", () => $bd6c17cfa0b64309$export$ddeab6943680f5be);
$parcel$export(module.exports, "getStartingToolbarItems", () => $bd6c17cfa0b64309$export$bb790f15a666b7f0);
$parcel$export(module.exports, "getEndingToolbarItems", () => $bd6c17cfa0b64309$export$d5ca70670b9f6b9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $gkwXh = parcelRequire("gkwXh");
var $2iyV6 = parcelRequire("2iyV6");

var $70Lw2 = parcelRequire("70Lw2");
var $1ZWXY = parcelRequire("1ZWXY");

var $lhLis = parcelRequire("lhLis");

var $8cp3a = parcelRequire("8cp3a");
var $80CM7 = parcelRequire("80CM7");
var $8DYpW = parcelRequire("8DYpW");
var $gSYO9 = parcelRequire("gSYO9");
var $jDuvE = parcelRequire("jDuvE");

var $kRXi9 = parcelRequire("kRXi9");
var $ceYEW = parcelRequire("ceYEW");

var $3dBkm = parcelRequire("3dBkm");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $bFmnZ = parcelRequire("bFmnZ");

var $8w53e = parcelRequire("8w53e");

var $4IrpZ = parcelRequire("4IrpZ");

var $5nRKm = parcelRequire("5nRKm");

var $90mMF = parcelRequire("90mMF");

var $ggICg = parcelRequire("ggICg");

var $epOG5 = parcelRequire("epOG5");

var $DBbS0 = parcelRequire("DBbS0");

var $f5BqX = parcelRequire("f5BqX");

var $ik2d8 = parcelRequire("ik2d8");

var $jdB85 = parcelRequire("jdB85");

var $17Ngn = parcelRequire("17Ngn");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $jPiXc = parcelRequire("jPiXc");

var $lumM0 = parcelRequire("lumM0");

var $jPPkn = parcelRequire("jPPkn");

var $fo6j3 = parcelRequire("fo6j3");

var $A2Kgl = parcelRequire("A2Kgl");

var $9Ox4G = parcelRequire("9Ox4G");

var $6rhck = parcelRequire("6rhck");

var $6Q6dY = parcelRequire("6Q6dY");

var $fjdBk = parcelRequire("fjdBk");

var $8KgOE = parcelRequire("8KgOE");

var $hv7lU = parcelRequire("hv7lU");
const $bd6c17cfa0b64309$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $1ZWXY.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $gZGBX.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $gkwXh.ACTION).DELETED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $gkwXh.INPUT_METHOD).TOOLBAR,
                displayMode: type
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $5r0mK.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $gkwXh.ACTION).DELETED
    });
const $bd6c17cfa0b64309$export$bf806231ea9f086b = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $gZGBX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        const { url: url } = (0, $jPPkn.titleUrlPairFromNode)(state.selection.node);
        // All card links should open in the same tab per https://product-fabric.atlassian.net/browse/MS-1583.
        // We are in edit mode here, open the smart card URL in a new window.
        window.open(url);
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $2iyV6.buildVisitedLinkPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $bd6c17cfa0b64309$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $gZGBX.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $2iyV6.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $bd6c17cfa0b64309$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $lumM0.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $gZGBX.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $jPPkn.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $kRXi9.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $80CM7.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $5r0mK.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return element.querySelector(`.${(0, $ceYEW.richMediaClassName)}`);
                return element;
            },
            items: $bd6c17cfa0b64309$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $A2Kgl.editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled)
        };
    };
};
const $bd6c17cfa0b64309$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $jPPkn.displayInfoForCard)(node, (0, $jPPkn.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $1ZWXY.commandWithMetadata)((0, $jPiXc.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $gkwXh.ACTION).UNLINK
    });
    return ()=>false;
};
const $bd6c17cfa0b64309$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions)=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_6')) return (0, $70Lw2.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    const layoutButtons = (0, $70Lw2.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_6') ? layoutButtons.filter((item)=>item.type !== 'separator') : layoutButtons;
};
const $bd6c17cfa0b64309$var$withToolbarMetadata = (command)=>(0, $1ZWXY.commandWithMetadata)(command, {
        inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
    });
const $bd6c17cfa0b64309$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hv7lU.ToolbarViewedEvent), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $bd6c17cfa0b64309$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $jPPkn.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $iZOJ9.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $jPPkn.displayInfoForCard)(node, (0, $jPPkn.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const currentAppearance = (0, $jPPkn.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $jPPkn.isDatasourceNode)(node);
        const pluginState = (0, $lumM0.pluginKey).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CLICKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $gkwXh.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $gkwXh.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $3dBkm.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $A2Kgl.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $bd6c17cfa0b64309$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ox4G.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $A2Kgl.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $jDuvE.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $A2Kgl.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0))),
                    title: intl.formatMessage((0, $8cp3a.annotationMessages).createComment),
                    showTitle: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode === 'offline'
                },
                {
                    type: 'separator'
                }
            ] : [];
            const toolbarItems = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? [
                ...editItems,
                ...commentItems,
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $gSYO9.linkMessages).openLink),
                    onClick: $bd6c17cfa0b64309$export$bf806231ea9f086b(editorAnalyticsApi)
                },
                {
                    type: 'separator'
                },
                ...$bd6c17cfa0b64309$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $bd6c17cfa0b64309$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($f5BqX))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $8DYpW.default).remove),
                    onClick: $bd6c17cfa0b64309$var$withToolbarMetadata($bd6c17cfa0b64309$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $jDuvE.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $A2Kgl.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                ...(0, $VSDnB.fg)('platform_editor_controls_patch_6') ? [] : [
                    {
                        type: 'separator'
                    }
                ],
                ...$bd6c17cfa0b64309$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $gSYO9.linkMessages).openLink),
                    onClick: $bd6c17cfa0b64309$export$bf806231ea9f086b(editorAnalyticsApi)
                },
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $bd6c17cfa0b64309$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions);
                if (alignmentOptions.length && (!(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') || !(0, $VSDnB.fg)('platform_editor_controls_patch_6'))) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$bd6c17cfa0b64309$var$getToolbarViewedItem(url, currentAppearance), (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjdBk.LinkToolbarAppearance), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability
                        }, "link-appearance")
                } : (0, $8KgOE.getLinkAppearanceDropdown)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $bd6c17cfa0b64309$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource
                }), ...showDatasourceAppearance && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fo6j3.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
                            })
                    }
                ] : [], ...(0, $VSDnB.fg)('platform_editor_controls_patch_6') ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        options: [
                            {
                                title: intl.formatMessage((0, $8DYpW.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                                    pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                                    label: intl.formatMessage((0, $8DYpW.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $iHYdz.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $8DYpW.default).delete),
                                onClick: $bd6c17cfa0b64309$var$withToolbarMetadata($bd6c17cfa0b64309$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))), {
                                    label: intl.formatMessage((0, $8DYpW.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $bd6c17cfa0b64309$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $jDuvE.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($90mMF))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($jdB85))),
            onClick: $bd6c17cfa0b64309$var$withToolbarMetadata($bd6c17cfa0b64309$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...(0, $VSDnB.fg)('platform_editor_controls_patch_6') ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $bd6c17cfa0b64309$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($epOG5))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($ik2d8))),
        title: intl.formatMessage((0, $jDuvE.linkToolbarMessages).settingsLink),
        onClick: $bd6c17cfa0b64309$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $lhLis.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $bd6c17cfa0b64309$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'control')) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjdBk.LinkToolbarAppearance), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fo6j3.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $8KgOE.getLinkAppearanceDropdown)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $bd6c17cfa0b64309$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true
        }), {
            type: 'separator'
        });
    }
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ox4G.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $A2Kgl.getEditLinkCallback)(editorAnalyticsApi, false),
                currentAppearance: "datasource"
            }, "edit-toolbar-item")
    });
    if (node?.attrs?.url) {
        toolbarItems.push({
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $gSYO9.linkMessages).openLink),
            onClick: $bd6c17cfa0b64309$export$bf806231ea9f086b(editorAnalyticsApi)
        });
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'control')) toolbarItems.push({
            type: 'separator'
        });
    }
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'control')) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $bd6c17cfa0b64309$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($f5BqX))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $8DYpW.default).remove),
        onClick: $bd6c17cfa0b64309$var$withToolbarMetadata($bd6c17cfa0b64309$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                options: [
                    {
                        title: intl.formatMessage((0, $8DYpW.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                            pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $iHYdz.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $iHYdz.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $iHYdz.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $iHYdz.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                            label: intl.formatMessage((0, $8DYpW.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $8DYpW.default).delete),
                        onClick: $bd6c17cfa0b64309$var$withToolbarMetadata($bd6c17cfa0b64309$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))), {
                            label: intl.formatMessage((0, $8DYpW.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $bd6c17cfa0b64309$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $bd6c17cfa0b64309$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, state)=>{
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ox4G.EditToolbarButton), {
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url"
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $jDuvE.linkToolbarMessages).editLink),
                showTitle: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) {
            const hyperlinkAppearance = [
                (0, $6Q6dY.getCustomHyperlinkAppearanceDropdown)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $bd6c17cfa0b64309$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hv7lU.ToolbarViewedEvent), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hv7lU.ToolbarViewedEvent), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6rhck.HyperlinkToolbarAppearance), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $bd6c17cfa0b64309$export$d5ca70670b9f6b9 = (options, api)=>(intl, link)=>{
        /**
		 * Require either provider to be supplied (controls link preferences)
		 * Or explicit user preferences config in order to enable button
		 */ if ((options.provider || options.userPreferencesLink) && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control')) return [
            {
                type: 'separator'
            },
            $bd6c17cfa0b64309$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };

});
parcelRegister("70Lw2", function(module, exports) {

$parcel$export(module.exports, "alignmentIcons", () => $c35971a9d6d459fc$export$45400139bf999022);
$parcel$export(module.exports, "wrappingIcons", () => $c35971a9d6d459fc$export$88511ca1ca567d46);
$parcel$export(module.exports, "layoutToMessages", () => $c35971a9d6d459fc$export$b978ceeb25a89f87);
$parcel$export(module.exports, "buildLayoutDropdown", () => $c35971a9d6d459fc$export$31e29507a90f6f72);
$parcel$export(module.exports, "default", () => $c35971a9d6d459fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $2LESl = parcelRequire("2LESl");

var $gvHjN = parcelRequire("gvHjN");

var $4KVK9 = parcelRequire("4KVK9");

var $hpAz0 = parcelRequire("hpAz0");

var $6L0PY = parcelRequire("6L0PY");

var $iyxIm = parcelRequire("iyxIm");

var $bOzuE = parcelRequire("bOzuE");

var $bOrM0 = parcelRequire("bOrM0");

var $cMyiR = parcelRequire("cMyiR");

var $icrVq = parcelRequire("icrVq");

var $5VgMH = parcelRequire("5VgMH");

var $kTcZO = parcelRequire("kTcZO");

var $8io1i = parcelRequire("8io1i");

var $5kpFL = parcelRequire("5kpFL");

var $kRhuK = parcelRequire("kRhuK");

var $gkwXh = parcelRequire("gkwXh");

var $kxM7f = parcelRequire("kxM7f");

var $e9qoo = parcelRequire("e9qoo");

var $8DYpW = parcelRequire("8DYpW");
var $eX53M = parcelRequire("eX53M");

var $hIIdL = parcelRequire("hIIdL");

var $cROsB = parcelRequire("cROsB");
var $594Yf = parcelRequire("594Yf");
const $c35971a9d6d459fc$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gvHjN))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kTcZO)))
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2LESl))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5VgMH)))
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4KVK9))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8io1i)))
            })
    }
];
const $c35971a9d6d459fc$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L0PY))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $e9qoo.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hpAz0))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $e9qoo.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iyxIm))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $e9qoo.alignRight)
    }
];
const $c35971a9d6d459fc$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bOzuE))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5kpFL)))
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bOrM0))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kRhuK)))
            })
    }
];
const $c35971a9d6d459fc$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMyiR)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($icrVq)))
    }
];
const $c35971a9d6d459fc$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $eX53M.toolbarMessages).wrapLeft,
    center: (0, $8DYpW.default).alignImageCenter,
    'wrap-right': (0, $eX53M.toolbarMessages).wrapRight,
    wide: (0, $8DYpW.default).layoutWide,
    'full-width': (0, $8DYpW.default).layoutFullWidth,
    'align-end': (0, $8DYpW.default).alignImageRight,
    'align-start': (0, $8DYpW.default).alignImageLeft
};
const $c35971a9d6d459fc$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $iHYdz.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $c35971a9d6d459fc$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $c35971a9d6d459fc$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? {
            ...node.attrs,
            layout: layout
        } : (0, $cROsB.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $kxM7f.insideTable)(state) || (0, $594Yf.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $c35971a9d6d459fc$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $cROsB.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $c35971a9d6d459fc$var$mapIconsToToolbarItem = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($c35971a9d6d459fc$export$b978ceeb25a89f87[value]),
            selected: $c35971a9d6d459fc$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $c35971a9d6d459fc$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $c35971a9d6d459fc$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($c35971a9d6d459fc$export$b978ceeb25a89f87[value]),
            selected: $c35971a9d6d459fc$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $c35971a9d6d459fc$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hIIdL.Shortcut), {
                    children: (0, $e9qoo.tooltip)(layoutOption.keyboardShortcut)
                })
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $c35971a9d6d459fc$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $5r0mK.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        nodes.expand,
        nodes.nestedExpand,
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $c35971a9d6d459fc$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $gZGBX.NodeSelection)) || !selection.node || !nodeType || $c35971a9d6d459fc$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $c35971a9d6d459fc$var$mapIconsToToolbarItem($c35971a9d6d459fc$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $c35971a9d6d459fc$var$mapIconsToToolbarItem($c35971a9d6d459fc$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $c35971a9d6d459fc$var$mapIconsToToolbarItem($c35971a9d6d459fc$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$c35971a9d6d459fc$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$c35971a9d6d459fc$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $c35971a9d6d459fc$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $gZGBX.NodeSelection)) || !selection.node || !nodeType || $c35971a9d6d459fc$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$c35971a9d6d459fc$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$c35971a9d6d459fc$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$c35971a9d6d459fc$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $c35971a9d6d459fc$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $c35971a9d6d459fc$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($c35971a9d6d459fc$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $c35971a9d6d459fc$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $cROsB.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $c35971a9d6d459fc$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $c35971a9d6d459fc$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var $c35971a9d6d459fc$export$2e2bcd8739ae039 = $c35971a9d6d459fc$var$buildLayoutButtons;

});
parcelRegister("2LESl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c29f4a0259814750cfbaa12b98a0b76b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $203fad917f7870a7$var$_react = $203fad917f7870a7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $203fad917f7870a7$var$_baseNew = $203fad917f7870a7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $203fad917f7870a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $203fad917f7870a7$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $203fad917f7870a7$var$_react.default.createElement($203fad917f7870a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$203fad917f7870a7$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $203fad917f7870a7$var$_default = module.exports.default = $203fad917f7870a7$var$AlignImageCenterIcon;

});

parcelRegister("gvHjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::506bf6a220572205d8f164c0b4e914b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c05124b017ce4e0b$var$_react = $c05124b017ce4e0b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c05124b017ce4e0b$var$_baseNew = $c05124b017ce4e0b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c05124b017ce4e0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c05124b017ce4e0b$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $c05124b017ce4e0b$var$_react.default.createElement($c05124b017ce4e0b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$c05124b017ce4e0b$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $c05124b017ce4e0b$var$_default = module.exports.default = $c05124b017ce4e0b$var$AlignImageLeftIcon;

});

parcelRegister("4KVK9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21fbbdedad020db28712a646625964de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37683ff09303c8f3$var$_react = $37683ff09303c8f3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $37683ff09303c8f3$var$_baseNew = $37683ff09303c8f3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $37683ff09303c8f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37683ff09303c8f3$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $37683ff09303c8f3$var$_react.default.createElement($37683ff09303c8f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$37683ff09303c8f3$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $37683ff09303c8f3$var$_default = module.exports.default = $37683ff09303c8f3$var$AlignImageRightIcon;

});

parcelRegister("hpAz0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0081361c361775d250c8deee2b06f0cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cad1223999c8b575$var$_react = $cad1223999c8b575$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cad1223999c8b575$var$_baseNew = $cad1223999c8b575$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cad1223999c8b575$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cad1223999c8b575$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $cad1223999c8b575$var$_react.default.createElement($cad1223999c8b575$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 3.5H4V2h8zm3 5.25H1v-1.5h14zM12 14H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$cad1223999c8b575$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIcon';
var $cad1223999c8b575$var$_default = module.exports.default = $cad1223999c8b575$var$AlignTextCenterIcon;

});

parcelRegister("iyxIm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e502391cfc4910fd8e80122508c043b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8258df9204d6933$var$_react = $d8258df9204d6933$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d8258df9204d6933$var$_baseNew = $d8258df9204d6933$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d8258df9204d6933$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8258df9204d6933$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $d8258df9204d6933$var$_react.default.createElement($d8258df9204d6933$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H8v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$d8258df9204d6933$var$AlignTextRightIcon.displayName = 'AlignTextRightIcon';
var $d8258df9204d6933$var$_default = module.exports.default = $d8258df9204d6933$var$AlignTextRightIcon;

});

parcelRegister("bOzuE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6da00ec8512e57c3de0efa89726a9f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $899fe57c673eeeda$var$_react = $899fe57c673eeeda$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $899fe57c673eeeda$var$_baseNew = $899fe57c673eeeda$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $899fe57c673eeeda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $899fe57c673eeeda$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $899fe57c673eeeda$var$_react.default.createElement($899fe57c673eeeda$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$899fe57c673eeeda$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $899fe57c673eeeda$var$_default = module.exports.default = $899fe57c673eeeda$var$ContentWrapLeftIcon;

});

parcelRegister("bOrM0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90d4f39c8de9988af1e49ad1b0ebf32f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8999e86528425a2b$var$_react = $8999e86528425a2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8999e86528425a2b$var$_baseNew = $8999e86528425a2b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8999e86528425a2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8999e86528425a2b$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $8999e86528425a2b$var$_react.default.createElement($8999e86528425a2b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M7 6.667H1v-1.5h6zm0 4.166H1v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$8999e86528425a2b$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $8999e86528425a2b$var$_default = module.exports.default = $8999e86528425a2b$var$ContentWrapRightIcon;

});

parcelRegister("cMyiR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2716122b6a537da8b4672ec6f364530a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94e493a1b315748e$var$_react = $94e493a1b315748e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $94e493a1b315748e$var$_contentWidthWide = $94e493a1b315748e$var$_interopRequireDefault((parcelRequire("gbQbY")));

var $94e493a1b315748e$var$_mediaWide = $94e493a1b315748e$var$_interopRequireDefault((parcelRequire("3mjma")));
function $94e493a1b315748e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ContentWidthWideIcon.
 * This component is ContentWidthWideIcon, with `UNSAFE_fallbackIcon` set to "EditorMediaWideIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94e493a1b315748e$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $94e493a1b315748e$var$_react.default.createElement($94e493a1b315748e$var$_contentWidthWide.default, Object.assign({
        LEGACY_fallbackIcon: $94e493a1b315748e$var$_mediaWide.default
    }, props));
$94e493a1b315748e$var$ContentWidthWideIcon.Name = 'ContentWidthWideIconMigration';
var $94e493a1b315748e$var$_default = module.exports.default = $94e493a1b315748e$var$ContentWidthWideIcon;

});
parcelRegister("gbQbY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf280c6bc7e165359296875525b3bf6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc9628ac70864b44$var$_react = $bc9628ac70864b44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc9628ac70864b44$var$_baseNew = $bc9628ac70864b44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bc9628ac70864b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc9628ac70864b44$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $bc9628ac70864b44$var$_react.default.createElement($bc9628ac70864b44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$bc9628ac70864b44$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $bc9628ac70864b44$var$_default = module.exports.default = $bc9628ac70864b44$var$ContentWidthWideIcon;

});

parcelRegister("3mjma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $272270f58cbe6323$var$_react = $272270f58cbe6323$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $272270f58cbe6323$var$_contentWidthWide = $272270f58cbe6323$var$_interopRequireDefault((parcelRequire("gbQbY")));
function $272270f58cbe6323$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $272270f58cbe6323$var$EditorMediaWideIcon = (props)=>/*#__PURE__*/ $272270f58cbe6323$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $272270f58cbe6323$var$_contentWidthWide.default
    }));
$272270f58cbe6323$var$EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
var $272270f58cbe6323$var$_default = module.exports.default = $272270f58cbe6323$var$EditorMediaWideIcon;

});


parcelRegister("icrVq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0b09173036d3d94afd21e9d81369a03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3ff025e67cc3b90$var$_react = $d3ff025e67cc3b90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d3ff025e67cc3b90$var$_expandHorizontal = $d3ff025e67cc3b90$var$_interopRequireDefault((parcelRequire("3J0O7")));

var $d3ff025e67cc3b90$var$_mediaFullWidth = $d3ff025e67cc3b90$var$_interopRequireDefault((parcelRequire("6O6hD")));
function $d3ff025e67cc3b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ExpandHorizontalIcon.
 * This component is ExpandHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMediaFullWidthIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3ff025e67cc3b90$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $d3ff025e67cc3b90$var$_react.default.createElement($d3ff025e67cc3b90$var$_expandHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $d3ff025e67cc3b90$var$_mediaFullWidth.default
    }, props));
$d3ff025e67cc3b90$var$ExpandHorizontalIcon.Name = 'ExpandHorizontalIconMigration';
var $d3ff025e67cc3b90$var$_default = module.exports.default = $d3ff025e67cc3b90$var$ExpandHorizontalIcon;

});
parcelRegister("3J0O7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9fe0fb92f8f001af056b55b163878fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b66336789b54845$var$_react = $2b66336789b54845$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2b66336789b54845$var$_baseNew = $2b66336789b54845$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2b66336789b54845$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b66336789b54845$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $2b66336789b54845$var$_react.default.createElement($2b66336789b54845$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 15V1h1.5v14zm16 0h-1.5V1H16zM3.22 7.47l2.5-2.5 1.06 1.06-1.22 1.22h4.88L9.22 6.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H5.56l1.22 1.22-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$2b66336789b54845$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $2b66336789b54845$var$_default = module.exports.default = $2b66336789b54845$var$ExpandHorizontalIcon;

});

parcelRegister("6O6hD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f4c4952a2b7fd14$var$_react = $4f4c4952a2b7fd14$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f4c4952a2b7fd14$var$_expandHorizontal = $4f4c4952a2b7fd14$var$_interopRequireDefault((parcelRequire("3J0O7")));
function $4f4c4952a2b7fd14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f4c4952a2b7fd14$var$EditorMediaFullWidthIcon = (props)=>/*#__PURE__*/ $4f4c4952a2b7fd14$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $4f4c4952a2b7fd14$var$_expandHorizontal.default
    }));
$4f4c4952a2b7fd14$var$EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
var $4f4c4952a2b7fd14$var$_default = module.exports.default = $4f4c4952a2b7fd14$var$EditorMediaFullWidthIcon;

});


parcelRegister("5VgMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44ff4babc14cbb00$var$_react = $44ff4babc14cbb00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $44ff4babc14cbb00$var$_alignImageCenter = $44ff4babc14cbb00$var$_interopRequireDefault((parcelRequire("2LESl")));
function $44ff4babc14cbb00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $44ff4babc14cbb00$var$EditorAlignImageCenterIcon = (props)=>/*#__PURE__*/ $44ff4babc14cbb00$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $44ff4babc14cbb00$var$_alignImageCenter.default
    }));
$44ff4babc14cbb00$var$EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
var $44ff4babc14cbb00$var$_default = module.exports.default = $44ff4babc14cbb00$var$EditorAlignImageCenterIcon;

});

parcelRegister("kTcZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f353066a4e332113$var$_react = $f353066a4e332113$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f353066a4e332113$var$_alignImageLeft = $f353066a4e332113$var$_interopRequireDefault((parcelRequire("gvHjN")));
function $f353066a4e332113$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f353066a4e332113$var$EditorAlignImageLeftIcon = (props)=>/*#__PURE__*/ $f353066a4e332113$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $f353066a4e332113$var$_alignImageLeft.default
    }));
$f353066a4e332113$var$EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
var $f353066a4e332113$var$_default = module.exports.default = $f353066a4e332113$var$EditorAlignImageLeftIcon;

});

parcelRegister("8io1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60a2a3064f7d899d$var$_react = $60a2a3064f7d899d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $60a2a3064f7d899d$var$_alignImageRight = $60a2a3064f7d899d$var$_interopRequireDefault((parcelRequire("4KVK9")));
function $60a2a3064f7d899d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $60a2a3064f7d899d$var$EditorAlignImageRightIcon = (props)=>/*#__PURE__*/ $60a2a3064f7d899d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $60a2a3064f7d899d$var$_alignImageRight.default
    }));
$60a2a3064f7d899d$var$EditorAlignImageRightIcon.displayName = 'EditorAlignImageRightIcon';
var $60a2a3064f7d899d$var$_default = module.exports.default = $60a2a3064f7d899d$var$EditorAlignImageRightIcon;

});

parcelRegister("5kpFL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e12bc07395882cd$var$_react = $3e12bc07395882cd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e12bc07395882cd$var$_contentWrapLeft = $3e12bc07395882cd$var$_interopRequireDefault((parcelRequire("bOzuE")));
function $3e12bc07395882cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e12bc07395882cd$var$EditorMediaWrapLeftIcon = (props)=>/*#__PURE__*/ $3e12bc07395882cd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2M6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $3e12bc07395882cd$var$_contentWrapLeft.default
    }));
$3e12bc07395882cd$var$EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
var $3e12bc07395882cd$var$_default = module.exports.default = $3e12bc07395882cd$var$EditorMediaWrapLeftIcon;

});

parcelRegister("kRhuK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2f653ff638c33cd$var$_react = $f2f653ff638c33cd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f2f653ff638c33cd$var$_contentWrapRight = $f2f653ff638c33cd$var$_interopRequireDefault((parcelRequire("bOrM0")));
function $f2f653ff638c33cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f2f653ff638c33cd$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $f2f653ff638c33cd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $f2f653ff638c33cd$var$_contentWrapRight.default
    }));
$f2f653ff638c33cd$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $f2f653ff638c33cd$var$_default = module.exports.default = $f2f653ff638c33cd$var$EditorMediaWrapRightIcon;

});

parcelRegister("kxM7f", function(module, exports) {

$parcel$export(module.exports, "insideTable", () => $1ccde135a1d20ec2$export$244bf4b32387ef62);

var $5r0mK = parcelRequire("5r0mK");
const $1ccde135a1d20ec2$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};

});

parcelRegister("hIIdL", function(module, exports) {

$parcel$export(module.exports, "Shortcut", () => $cf09532ea537b34b$export$59451aa6b6270879);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $cf09532ea537b34b$var$shortcutStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $cf09532ea537b34b$var$shortcutStyleUnbounded = null;
function $cf09532ea537b34b$export$59451aa6b6270879({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_2rko1sit _1wpzesu3 _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66 _syaz1gjq _bfhkm7j4 _1ggkglyw",
            "_1wyb1qpa"
        ]),
        children: children
    });
}

});


parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("90mMF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e5c989bea2984f$var$_react = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $68e5c989bea2984f$var$_baseNew = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $68e5c989bea2984f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68e5c989bea2984f$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $68e5c989bea2984f$var$_react.default.createElement($68e5c989bea2984f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$68e5c989bea2984f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $68e5c989bea2984f$var$_default = module.exports.default = $68e5c989bea2984f$var$LinkBrokenIcon;

});

parcelRegister("DBbS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07707de1f3ce8a8c$var$_react = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $07707de1f3ce8a8c$var$_comment = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("bFmnZ")));
function $07707de1f3ce8a8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $07707de1f3ce8a8c$var$CommentIcon = (props)=>/*#__PURE__*/ $07707de1f3ce8a8c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $07707de1f3ce8a8c$var$_comment.default
    }));
$07707de1f3ce8a8c$var$CommentIcon.displayName = 'CommentIcon';
var $07707de1f3ce8a8c$var$_default = module.exports.default = $07707de1f3ce8a8c$var$CommentIcon;

});

parcelRegister("f5BqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afc45c3418436f46$var$_react = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $afc45c3418436f46$var$_delete = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("4IrpZ")));
function $afc45c3418436f46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $afc45c3418436f46$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $afc45c3418436f46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $afc45c3418436f46$var$_delete.default
    }));
$afc45c3418436f46$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $afc45c3418436f46$var$_default = module.exports.default = $afc45c3418436f46$var$EditorRemoveIcon;

});

parcelRegister("ik2d8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d56bcf4208f0775d$var$_react = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d56bcf4208f0775d$var$_settings = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("epOG5")));
function $d56bcf4208f0775d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d56bcf4208f0775d$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $d56bcf4208f0775d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props, {
        newIcon: $d56bcf4208f0775d$var$_settings.default
    }));
$d56bcf4208f0775d$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $d56bcf4208f0775d$var$_default = module.exports.default = $d56bcf4208f0775d$var$EditorSettingsIcon;

});

parcelRegister("jdB85", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfdc085c662fbaf1$var$_react = $dfdc085c662fbaf1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $dfdc085c662fbaf1$var$_linkBroken = $dfdc085c662fbaf1$var$_interopRequireDefault((parcelRequire("90mMF")));
function $dfdc085c662fbaf1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfdc085c662fbaf1$var$EditorUnlinkIcon = (props)=>/*#__PURE__*/ $dfdc085c662fbaf1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M5 10V9h2v1zm4-5h1v2H9zm7.646 12.354.708-.708 2 2-.708.708zM17 15v-1h2v1zm-3 2h1v2h-1zM7.354 6.646l-.708.708-2-2 .708-.708zm3.567 9.037 1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.25 3.25 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.75 1.75 0 0 0 2.474 0m2.658-7.608-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.25 3.25 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.75 1.75 0 0 0-2.474 0"/></svg>`
    }, props, {
        newIcon: $dfdc085c662fbaf1$var$_linkBroken.default
    }));
$dfdc085c662fbaf1$var$EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
var $dfdc085c662fbaf1$var$_default = module.exports.default = $dfdc085c662fbaf1$var$EditorUnlinkIcon;

});

parcelRegister("fo6j3", function(module, exports) {

$parcel$export(module.exports, "DatasourceAppearanceButton", () => $13e08b7c33400098$export$76de8066d79563a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $80CM7 = parcelRequire("80CM7");

var $e3WeH = parcelRequire("e3WeH");

var $3dBkm = parcelRequire("3dBkm");

var $gZGBX = parcelRequire("gZGBX");

var $3WO4v = parcelRequire("3WO4v");

var $051X7 = parcelRequire("051X7");

var $bUmQV = parcelRequire("bUmQV");

var $jPiXc = parcelRequire("jPiXc");

var $lumM0 = parcelRequire("lumM0");

var $lFtel = parcelRequire("lFtel");

var $dYS3B = parcelRequire("dYS3B");
function $13e08b7c33400098$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $13e08b7c33400098$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $13e08b7c33400098$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $dYS3B.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $5uXOq.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $lumM0.pluginKey).getState(editorState);
        const newAdf = (0, $3WO4v.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $gZGBX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $jPiXc.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $3dBkm.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $80CM7.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
        css: $13e08b7c33400098$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lFtel.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button'
    }));
};
const $13e08b7c33400098$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
    const cardContext = (0, $051X7.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($13e08b7c33400098$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod
    });
};

});
parcelRegister("e3WeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b970e46d885591$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $gmhCD = parcelRequire("gmhCD");

var $3bDjY = parcelRequire("3bDjY");

var $bvPiX = parcelRequire("bvPiX");

var $46YIs = parcelRequire("46YIs");

var $5Y3eC = parcelRequire("5Y3eC");
const $07b970e46d885591$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
var $07b970e46d885591$export$2e2bcd8739ae039 = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, spotlightConfig: spotlightConfig })=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $5Y3eC.iconOnlySpacing) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    const ariaChecked = isRadioButton ? isButtonPressed : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    const [spotlightReferenceElement, setSpotlightReferenceElement] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        onMount?.();
        return ()=>onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSpotlightTargetClick = spotlightConfig?.isSpotlightOpen ? spotlightConfig?.onTargetClick : undefined;
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        // fire the spotlight onTargetClick callback if a spotlight is rendered and callback is provided
        onSpotlightTargetClick?.();
        onClick?.(event);
    }, [
        onClick,
        onSpotlightTargetClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                // Only fallback to title for tooltip if title is not shown
                content: tooltipContent || (iconOnly ? title : undefined),
                component: tooltipStyle,
                hideTooltipOnClick: hideTooltipOnClick,
                position: "top",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvPiX.Pulse), {
                        pulse: pulse || spotlightConfig?.pulse,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9yOBd.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                            className: className,
                            ref: (buttonElement)=>setSpotlightReferenceElement(buttonElement),
                            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                            theme: (adgTheme, themeProps)=>{
                                const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                                return {
                                    buttonStyles: {
                                        ...buttonStyles,
                                        ...customSpacing,
                                        ...appearance === 'danger' && (0, $5Y3eC.getButtonStyles)({
                                            appearance: appearance,
                                            state: themeProps.state,
                                            mode: themeProps.mode
                                        }),
                                        ...(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $07b970e46d885591$var$customSizeAndPadding : {}
                                    },
                                    ...rest
                                };
                            },
                            "aria-label": ariaLabel || title,
                            "aria-pressed": ariaPressed,
                            "aria-checked": ariaChecked,
                            role: isRadioButton ? 'radio' : undefined,
                            "aria-expanded": ariaHasPopup ? selected : undefined,
                            "aria-controls": ariaHasPopup ? areaControls : undefined,
                            spacing: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
                            href: href,
                            target: target,
                            appearance: appearance,
                            "aria-haspopup": ariaHasPopup,
                            iconBefore: icon || undefined,
                            iconAfter: iconAfter,
                            onClick: handleOnClick,
                            onKeyDown: onKeyDown,
                            isSelected: selected,
                            isDisabled: disabled,
                            testId: testId,
                            interactionName: interactionName,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            // @ts-ignore
                            // tabIndex set as 0 by default in the design system  ButtonBase component
                            // this is not expected for all buttons, we have to use tabIndex={null} for some cases
                            // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
                            tabIndex: tabIndex,
                            children: children
                        })
                    })
                })
            }),
            spotlightConfig?.isSpotlightOpen && spotlightReferenceElement && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $46YIs.ButtonSpotlightCard), {
                referenceElement: spotlightReferenceElement,
                ...spotlightConfig.spotlightCardOptions
            })
        ]
    });
};

});
parcelRegister("bvPiX", function(module, exports) {

$parcel$export(module.exports, "Pulse", () => $aec212985ae99997$export$927d63e2511364c0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");
function $aec212985ae99997$export$927d63e2511364c0({ pulse: pulse, radius: radius = 3, children: children }) {
    if (pulse) return(// SpotlightPulse shows pulse effect if `pulse` is `undefined`.
    // That's why we need to cast `pulse` to `false` if it's `undefined`.
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k6T4f.Pulse), {
        radius: radius,
        pulse: pulse ?? false,
        children: children
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});

parcelRegister("46YIs", function(module, exports) {

$parcel$export(module.exports, "ButtonSpotlightCard", () => $b3626800b48613e0$export$beb7ede7fcdf145c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5ujeO = parcelRequire("5ujeO");

var $4oNEb = parcelRequire("4oNEb");
const $b3626800b48613e0$export$beb7ede7fcdf145c = (props)=>{
    const { referenceElement: referenceElement, placement: placement = 'top-start', ...spotlightCardProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        referenceElement: referenceElement,
        placement: placement,
        strategy: "absolute",
        children: ({ ref: ref, style: style })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: ref,
                style: style,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ujeO.default), {
                    ...spotlightCardProps
                })
            })
    });
};

});

parcelRegister("5Y3eC", function(module, exports) {

$parcel$export(module.exports, "iconOnlySpacing", () => $44f0337781655622$export$7d8cec9727d4e603);
$parcel$export(module.exports, "getButtonStyles", () => $44f0337781655622$export$f98ea88a275be66c);

var $VSDnB = parcelRequire("VSDnB");
const $44f0337781655622$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};
const $44f0337781655622$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $44f0337781655622$var$background = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        active: {
            light: "var(--ds-background-neutral-pressed, #091E424F)",
            dark: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    }
};
const $44f0337781655622$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FD9891)",
            dark: "var(--ds-background-danger-pressed, #FD9891)"
        }
    }
};
const $44f0337781655622$var$color = {
    danger: {
        default: {
            light: "var(--ds-icon, #44546F)",
            dark: "var(--ds-icon, #44546F)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $44f0337781655622$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #626F86)",
            dark: "var(--ds-icon-subtle, #626F86)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $44f0337781655622$export$f98ea88a275be66c = (props)=>({
        background: $44f0337781655622$var$getStyles(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $44f0337781655622$var$backgroundVisualRefresh : $44f0337781655622$var$background, props),
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        color: $44f0337781655622$var$getStyles((0, $VSDnB.fg)('platform-visual-refresh-icons') ? $44f0337781655622$var$colorVisualRefresh : $44f0337781655622$var$color, props)
    });

});


parcelRegister("3WO4v", function(module, exports) {

$parcel$export(module.exports, "buildDatasourceAdf", () => $a17c774a074a9eb4$export$1de3504963fc32f2);
const $a17c774a074a9eb4$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};

});

parcelRegister("lFtel", function(module, exports) {

$parcel$export(module.exports, "DatasourceIcon", () => $7c0b395422f3053e$export$8819453811a57211);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $VNtxf = parcelRequire("VNtxf");

var $VSDnB = parcelRequire("VSDnB");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $7c0b395422f3053e$var$IconDatasourceGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V13C15 14.1046 14.1046 15 13 15H2C0.89543 15 0 14.1046 0 13V2ZM5 6C5 5.44772 5.44772 5 6 5L12 5C12.5523 5 13 5.44772 13 6C13 6.55229 12.5523 7 12 7L6 7C5.44772 7 5 6.55228 5 6ZM6 8C5.44772 8 5 8.44771 5 9C5 9.55228 5.44772 10 6 10L12 10C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8L6 8ZM5 12C5 11.4477 5.44772 11 6 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L6 13C5.44772 13 5 12.5523 5 12ZM3 7C3.55228 7 4 6.55228 4 6C4 5.44772 3.55228 5 3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7ZM5 3C5 2.44772 5.44772 2 6 2L12 2C12.5523 2 13 2.44772 13 3C13 3.55229 12.5523 4 12 4L6 4C5.44772 4 5 3.55228 5 3ZM3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4ZM4 9C4 9.55229 3.55228 10 3 10C2.44772 10 2 9.55229 2 9C2 8.44771 2.44772 8 3 8C3.55228 8 4 8.44771 4 9ZM3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z",
            fill: 'currentColor'
        })
    });
};
const $7c0b395422f3053e$var$wrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $7c0b395422f3053e$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgoHi.default), {
        xcss: $7c0b395422f3053e$var$wrapperStyles,
        children: (0, $VSDnB.fg)('platform-editor-plugin-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($VNtxf))), {
            LEGACY_fallbackIcon: $7c0b395422f3053e$var$IconDatasourceGlyph,
            label: props?.label
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
            glyph: $7c0b395422f3053e$var$IconDatasourceGlyph,
            ...props
        })
    });
};

});
parcelRegister("VNtxf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0adbb3c3caaa34dd$var$_react = $0adbb3c3caaa34dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0adbb3c3caaa34dd$var$_baseNew = $0adbb3c3caaa34dd$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0adbb3c3caaa34dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0adbb3c3caaa34dd$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $0adbb3c3caaa34dd$var$_react.default.createElement($0adbb3c3caaa34dd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$0adbb3c3caaa34dd$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $0adbb3c3caaa34dd$var$_default = module.exports.default = $0adbb3c3caaa34dd$var$SmartLinkListIcon;

});



parcelRegister("A2Kgl", function(module, exports) {

$parcel$export(module.exports, "getEditLinkCallback", () => $82ac2de8b8cf9d08$export$c389e1daeae312a9);
$parcel$export(module.exports, "buildEditLinkToolbar", () => $82ac2de8b8cf9d08$export$dec3901e38d4e7ff);
$parcel$export(module.exports, "editLinkToolbarConfig", () => $82ac2de8b8cf9d08$export$acaefd190fd8ff4d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");
var $2iyV6 = parcelRequire("2iyV6");

var $1ZWXY = parcelRequire("1ZWXY");

var $e9EHa = parcelRequire("e9EHa");

var $jDuvE = parcelRequire("jDuvE");


var $gZGBX = parcelRequire("gZGBX");

var $nYpqR = parcelRequire("nYpqR");

var $jPiXc = parcelRequire("jPiXc");

var $jPPkn = parcelRequire("jPPkn");
function $82ac2de8b8cf9d08$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9EHa.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $82ac2de8b8cf9d08$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $nYpqR.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($82ac2de8b8cf9d08$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $nYpqR.hideLinkToolbar)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $jDuvE.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $82ac2de8b8cf9d08$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $gZGBX.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $nYpqR.showLinkToolbar)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $2iyV6.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $82ac2de8b8cf9d08$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $jPPkn.displayInfoForCard)(node, (0, $jPPkn.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, $2OMIu.jsx)($82ac2de8b8cf9d08$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $1ZWXY.commandWithMetadata)((0, $jPiXc.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $gkwXh.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $jPiXc.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $82ac2de8b8cf9d08$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker)=>{
    return showLinkingToolbar ? {
        height: lpLinkPicker ? (0, $f96f1f7af2f8d3ca$export$c635b83728f81640) : (0, $f96f1f7af2f8d3ca$export$c04a5ad015d45447),
        width: (0, $f96f1f7af2f8d3ca$export$a62aa932daf22ffe),
        forcePlacement: true
    } : {};
};

});
parcelRegister("e9EHa", function(module, exports) {

$parcel$export(module.exports, "HyperlinkAddToolbar", () => $c59bf023ca553874$export$8be6a38cd66ace65);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $9Egzu = parcelRequire("9Egzu");

var $kaYiD = parcelRequire("kaYiD");

var $deZY5 = parcelRequire("deZY5");
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $c59bf023ca553874$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $gkwXh.INPUT_METHOD).MANUAL : (0, $gkwXh.INPUT_METHOD).TYPEAHEAD, analytic);
    };
function $c59bf023ca553874$export$8be6a38cd66ace65({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'activityProvider',
            'searchProvider'
        ],
        providerFactory: providerFactory,
        renderNode: ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
            // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
            // EditorLinkPicker into the bundle
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kaYiD.EditorLinkPicker), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $c59bf023ca553874$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $deZY5.default), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
}

});
parcelRegister("kaYiD", function(module, exports) {

$parcel$export(module.exports, "EditorLinkPicker", () => $f58dd7c55235c63c$export$da2f76555f5c8d0a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $bYgrr = parcelRequire("bYgrr");

var $4NUlu = parcelRequire("4NUlu");

var $7VeJI = parcelRequire("7VeJI");
const $f58dd7c55235c63c$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
	 * Track onClose handler in a
	 * ref so that we void needing it in the dependency array
	 * below
	 */ const onCloseRef = (0, $5uXOq.useRef)(onClose);
    (0, $5uXOq.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
	 * Call onClose on mount, usefull to provide
	 * a handler for performing an action after the component has been
	 * unmounted (e.g. return focus to the editors)
	 */ (0, $5uXOq.useEffect)(()=>()=>onCloseRef.current?.(), []);
    const onEscape = (0, $5uXOq.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $5uXOq.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onClickAwayCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $7VeJI.useEscapeClickaway)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $4NUlu.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bYgrr.default), {
                ...restProps,
                onCancel: onEscape
            })
        })
    });
};

});
parcelRegister("bYgrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $292e4b24cbca310f$export$2e2bcd8739ae039);

var $kc9vJ = parcelRequire("kc9vJ");

var $1WP7T = parcelRequire("1WP7T");

const $292e4b24cbca310f$var$LazyLinkPickerComponent = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("4iCa2")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$292e4b24cbca310f$export$2e2bcd8739ae039 = (0, $1WP7T.composeLinkPicker)($292e4b24cbca310f$var$LazyLinkPickerComponent);

});
parcelRegister("1WP7T", function(module, exports) {

$parcel$export(module.exports, "composeLinkPicker", () => $4f4b692e16311c64$export$922eb685ceb4a294);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kc9vJ = parcelRequire("kc9vJ");

var $daJ0i = parcelRequire("daJ0i");


var $4tvHl = parcelRequire("4tvHl");

var $6MmH3 = parcelRequire("6MmH3");

var $bs2KT = parcelRequire("bs2KT");

var $1tHfS = parcelRequire("1tHfS");
const $4f4b692e16311c64$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $4f4b692e16311c64$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $27f53d4100568677$export$fc44104665f4d1e5),
    source: (0, $27f53d4100568677$export$fc44104665f4d1e5)
};
const $4f4b692e16311c64$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": $4f4b692e16311c64$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $4f4b692e16311c64$var$fixedWidthContainerStyles = null;
const $4f4b692e16311c64$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1bsb1ubl"
        ])
    });
};
const $4f4b692e16311c64$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $4f4b692e16311c64$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
            data: $4f4b692e16311c64$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tvHl.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tHfS.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $27f53d4100568677$export$bf31a09f182d5584}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($4f4b692e16311c64$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MmH3.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc9vJ.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bs2KT.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $4f4b692e16311c64$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};

});
const $27f53d4100568677$export$85183a312807388d = 'media';
const $27f53d4100568677$export$fc44104665f4d1e5 = 'linkPicker';
const $27f53d4100568677$export$452f1062ecf44be7 = 5;
const $27f53d4100568677$export$bf31a09f182d5584 = 342;
const $27f53d4100568677$export$542fb16962bf430c = '290px';

parcelRegister("4tvHl", function(module, exports) {

$parcel$export(module.exports, "LinkPickerSessionProvider", () => $2694ae59f2d43701$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $2694ae59f2d43701$export$36ecc935abdc3636);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $gmGSi = parcelRequire("gmGSi");
const $2694ae59f2d43701$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $2694ae59f2d43701$export$3285420c698bc605 = /*#__PURE__*/ (0, $5uXOq.createContext)($2694ae59f2d43701$export$c07727f5eddb98f);
const $2694ae59f2d43701$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $2694ae59f2d43701$export$2f19832fd2d620ca = ({ children: children })=>{
    const { current: sessionId } = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    (0, $5uXOq.useEffect)(()=>{
        return ()=>(0, $gmGSi.abortUfoExperience)((0, $gmGSi.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $2694ae59f2d43701$var$useConstructor(()=>(0, $gmGSi.startUfoExperience)((0, $gmGSi.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2694ae59f2d43701$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $2694ae59f2d43701$export$36ecc935abdc3636 = ()=>(0, $5uXOq.useContext)($2694ae59f2d43701$export$3285420c698bc605);

});
parcelRegister("gmGSi", function(module, exports) {

$parcel$export(module.exports, "ufoExperience", () => $0befcde02902b9dd$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $0befcde02902b9dd$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $0befcde02902b9dd$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $0befcde02902b9dd$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $0befcde02902b9dd$export$b1021040eb94cdca);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $0befcde02902b9dd$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $0befcde02902b9dd$var$ufoExperiences = {
    [$0befcde02902b9dd$export$f9c7780c574346a2.mounted]: new (0, $cBycP.ConcurrentExperience)($0befcde02902b9dd$export$f9c7780c574346a2.mounted, {
        type: (0, $7Zbvr.ExperienceTypes).Load,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $0befcde02902b9dd$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $0befcde02902b9dd$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $0befcde02902b9dd$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $0befcde02902b9dd$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("6MmH3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $a31421eb288e6506$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $gmGSi = parcelRequire("gmGSi");


var $eTwyk = parcelRequire("eTwyk");

var $4tvHl = parcelRequire("4tvHl");

var $eOoN4 = parcelRequire("eOoN4");

var $iUFh3 = parcelRequire("iUFh3");
function $a31421eb288e6506$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $4tvHl.useLinkPickerSessionId)();
    const handleError = (0, $5uXOq.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $eTwyk.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $27f53d4100568677$export$85183a312807388d));
        // Fire UFO failed experience
        (0, $gmGSi.failUfoExperience)((0, $gmGSi.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOoN4.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $iUFh3.ErrorBoundaryFallback),
        children: children
    });
}

});
parcelRegister("eTwyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $221eef4bea14ce3e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $221eef4bea14ce3e$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $221eef4bea14ce3e$export$2e2bcd8739ae039 = $221eef4bea14ce3e$var$createEventPayload;

});

parcelRegister("eOoN4", function(module, exports) {

$parcel$export(module.exports, "BaseErrorBoundary", () => $93e98841d934b802$export$688779ac61ee945f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $93e98841d934b802$export$688779ac61ee945f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {});
        return children;
    }
}

});

parcelRegister("iUFh3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryFallback", () => $1632729b10cbec8f$export$8a28b7e38e4685dd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");


var $czNpL = parcelRequire("czNpL");

var $kDdjl = parcelRequire("kDdjl");

var $1aIRG = parcelRequire("1aIRG");

var $7OUbW = parcelRequire("7OUbW");
const $1632729b10cbec8f$var$errorBoundaryFallbackStyles = null;
const $1632729b10cbec8f$var$oldErrorBoundaryFallbackStyles = null;
const $1632729b10cbec8f$var$messages = (0, $7VHMR.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $1632729b10cbec8f$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $koVbs.default)();
    const header = intl.formatMessage($1632729b10cbec8f$var$messages.heading);
    const description = intl.formatMessage($1632729b10cbec8f$var$messages.description);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OUbW.MinHeightContainer), {
        minHeight: (0, $27f53d4100568677$export$542fb16962bf430c),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c81vhk" : "_vwz44jg8"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aIRG.EmptyState), {
            header: header,
            renderImage: (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDdjl.GenericErrorSVGV2), {}) : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $czNpL.GenericErrorSVG), {}),
            description: description
        })
    });
};

});
parcelRegister("czNpL", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $7540c2e2574c2930$export$e54420a1a27457a4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7540c2e2574c2930$var$HEIGHT = 90;
const $7540c2e2574c2930$var$genericErrorStyles = null;
const $7540c2e2574c2930$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $bwpsq.default)([
            "_4t3il1r9 _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
                fill: `url(#${id})`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: ".6",
                d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
                fill: "#C1C7D0"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: ".6",
                d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
                fill: "#B3BAC5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                    id: id,
                    x1: "26.169",
                    y1: "228.621",
                    x2: "138.408",
                    y2: "116.382",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            stopColor: "#C1C7D0"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: ".297",
                            stopColor: "#C6CBD4",
                            stopOpacity: ".881"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: ".63",
                            stopColor: "#D3D7DE",
                            stopOpacity: ".748"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: ".98",
                            stopColor: "#E9EBEF",
                            stopOpacity: ".608"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: "1",
                            stopColor: "#EBECF0",
                            stopOpacity: ".6"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("kDdjl", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVGV2", () => $3f7dddc5723e881c$export$c890415b8eb68ca7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3f7dddc5723e881c$var$SIZE = 96;
const $3f7dddc5723e881c$var$genericErrorStyles = null;
const $3f7dddc5723e881c$export$c890415b8eb68ca7 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $bwpsq.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};

});

parcelRegister("1aIRG", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $07ecb85b552d1f4c$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $bUmQV = parcelRequire("bUmQV");
var $dS3PR = parcelRequire("dS3PR");
const $07ecb85b552d1f4c$var$styles = {
    container: "_1pfhoahv _6rthoahv _y3gn1h6o",
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $07ecb85b552d1f4c$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
        xcss: $07ecb85b552d1f4c$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
        xcss: $07ecb85b552d1f4c$var$styles.container,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7OUbW", function(module, exports) {

$parcel$export(module.exports, "MinHeightContainer", () => $0aea99783ced9613$export$42134e2a251518b3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $0aea99783ced9613$var$minHeightComponentStyles = null;
const $0aea99783ced9613$export$42134e2a251518b3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});



parcelRegister("bs2KT", function(module, exports) {

$parcel$export(module.exports, "LoaderFallback", () => $e4be65be0752e81a$export$d96e921133238c41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $7OUbW = parcelRequire("7OUbW");
const $e4be65be0752e81a$var$styles = null;
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '472px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '550px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '505px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '429px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '218px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '141px';
const $e4be65be0752e81a$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if (plugins?.length === 1) return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $e4be65be0752e81a$export$d96e921133238c41 = (props)=>{
    const minHeight = $e4be65be0752e81a$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OUbW.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $bwpsq.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};

});

parcelRegister("1tHfS", function(module, exports) {

$parcel$export(module.exports, "MessagesProvider", () => $cfc46959224b6657$export$54320b51a950d54a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kAHGP = parcelRequire("kAHGP");
const $cfc46959224b6657$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kAHGP.LazyMessagesProvider), {
        children: children
    });
};

});
parcelRegister("kAHGP", function(module, exports) {

$parcel$export(module.exports, "LazyMessagesProvider", () => $0b8930421407a29b$export$d013d33430f9fb4b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $6JvbH = parcelRequire("6JvbH");

var $9qeGT = parcelRequire("9qeGT");
const $0b8930421407a29b$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $6JvbH.default),
        loaderFn: (0, $9qeGT.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("6JvbH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e60a6ae0bcd067f5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e60a6ae0bcd067f5$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancel',
    'fabric.linkPicker.button.insert': 'Insert',
    'fabric.linkPicker.button.save': 'Save',
    'fabric.linkPicker.clearLink': 'Clear',
    'fabric.linkPicker.clearLinkText': 'Clear text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
    'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Link display helper text',
    'fabric.linkPicker.linkHelperTextLabel': 'Give this link a title or description',
    'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Paste a link',
    'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
    'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Recently Viewed',
    'fabric.linkPicker.listTitle.results': 'Results',
    'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
    'fabric.linkPicker.search.error.retry': 'Refresh',
    'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
    'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
    'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
    'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
    'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
    'fabric.linkPicker.status.submitting': 'Submitting',
    'fabric.linkPicker.time.message.updated': 'Updated {time}',
    'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
    'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
    'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
    foo: 'Default string'
};

});

parcelRegister("9qeGT", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $1b4e714d67ee4b58$export$2b153a2030b0feb2);

var $82GLV = parcelRequire("82GLV");
const $1b4e714d67ee4b58$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $82GLV.locales)) {
            const messages = await (0, $82GLV.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $82GLV.locales)) {
            const messages = await (0, $82GLV.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("82GLV", function(module, exports) {

$parcel$export(module.exports, "locales", () => $4eb6bd651e0fd6dc$export$df1c34db1371eeed);

























const $4eb6bd651e0fd6dc$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("6T7bq")),
    da: ()=>(parcelRequire("9XOk2")),
    de: ()=>(parcelRequire("jalgt")),
    en_GB: ()=>(parcelRequire("6g7SI")),
    en_ZZ: ()=>(parcelRequire("bjLAj")),
    en: ()=>Promise.resolve((parcelRequire("6JvbH"))),
    es: ()=>(parcelRequire("5osno")),
    fi: ()=>(parcelRequire("kmsxn")),
    fr: ()=>(parcelRequire("c6fga")),
    hu: ()=>(parcelRequire("lEmmZ")),
    it: ()=>(parcelRequire("chqqB")),
    ja: ()=>(parcelRequire("es0V1")),
    ko: ()=>(parcelRequire("iKcR6")),
    nb: ()=>(parcelRequire("iXXxO")),
    nl: ()=>(parcelRequire("24YrD")),
    pl: ()=>(parcelRequire("3tMHt")),
    pt_BR: ()=>(parcelRequire("5ya7z")),
    ru: ()=>(parcelRequire("gsk6H")),
    sv: ()=>(parcelRequire("6ihmE")),
    th: ()=>(parcelRequire("1UvOf")),
    tr: ()=>(parcelRequire("h0sLM")),
    uk: ()=>(parcelRequire("33x5j")),
    vi: ()=>(parcelRequire("le8CP")),
    zh_TW: ()=>(parcelRequire("eofHO")),
    zh: ()=>(parcelRequire("fLoqW"))
};

});
parcelRegister("6T7bq", function(module, exports) {

let $503d7399c9456e1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $503d7399c9456e1b$var$load("ktE9k").then(()=>parcelRequire('hxTpR'));

});

parcelRegister("9XOk2", function(module, exports) {

let $01df3c870847b401$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01df3c870847b401$var$load("dNxhW").then(()=>parcelRequire('6zDV7'));

});

parcelRegister("jalgt", function(module, exports) {

let $df3f72367020f1c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $df3f72367020f1c9$var$load("cpXoW").then(()=>parcelRequire('3pHpm'));

});

parcelRegister("6g7SI", function(module, exports) {

let $48ea59cee2913acc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48ea59cee2913acc$var$load("6cfDM").then(()=>parcelRequire('lV04b'));

});

parcelRegister("bjLAj", function(module, exports) {

let $83d66160e28c3c8a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83d66160e28c3c8a$var$load("5ywKM").then(()=>parcelRequire('khAmU'));

});

parcelRegister("5osno", function(module, exports) {

let $3ed53492d26ef29a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ed53492d26ef29a$var$load("1jdJx").then(()=>parcelRequire('8GUOz'));

});

parcelRegister("kmsxn", function(module, exports) {

let $ed2bff9faf0a32e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed2bff9faf0a32e8$var$load("8FJst").then(()=>parcelRequire('4QluW'));

});

parcelRegister("c6fga", function(module, exports) {

let $8cf1e1d35c37b32b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8cf1e1d35c37b32b$var$load("iW8Tl").then(()=>parcelRequire('hLNj0'));

});

parcelRegister("lEmmZ", function(module, exports) {

let $fc2eaf99ee11cafd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc2eaf99ee11cafd$var$load("7bcon").then(()=>parcelRequire('8XZGW'));

});

parcelRegister("chqqB", function(module, exports) {

let $8f0b92a576986f50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f0b92a576986f50$var$load("547YV").then(()=>parcelRequire('ibOo1'));

});

parcelRegister("es0V1", function(module, exports) {

let $a85464a248806534$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a85464a248806534$var$load("lChBR").then(()=>parcelRequire('eHx02'));

});

parcelRegister("iKcR6", function(module, exports) {

let $da567eb75d06b91f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $da567eb75d06b91f$var$load("2cNE1").then(()=>parcelRequire('bjfCW'));

});

parcelRegister("iXXxO", function(module, exports) {

let $dcebecf88b37095e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dcebecf88b37095e$var$load("MvKo8").then(()=>parcelRequire('86hzk'));

});

parcelRegister("24YrD", function(module, exports) {

let $183ad788b451ed66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $183ad788b451ed66$var$load("UE0Lj").then(()=>parcelRequire('bpOU2'));

});

parcelRegister("3tMHt", function(module, exports) {

let $2889db5defe5b802$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2889db5defe5b802$var$load("bxAVQ").then(()=>parcelRequire('9B1xP'));

});

parcelRegister("5ya7z", function(module, exports) {

let $40a7fa8b60b0fe9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40a7fa8b60b0fe9e$var$load("84O3i").then(()=>parcelRequire('iOkVk'));

});

parcelRegister("gsk6H", function(module, exports) {

let $bfaedbb52bab4fe0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfaedbb52bab4fe0$var$load("hb9rK").then(()=>parcelRequire('84wGJ'));

});

parcelRegister("6ihmE", function(module, exports) {

let $4951e4b75995b5e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4951e4b75995b5e0$var$load("e3bmB").then(()=>parcelRequire('9U5fj'));

});

parcelRegister("1UvOf", function(module, exports) {

let $1643b21803dfd2c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1643b21803dfd2c6$var$load("8RFZM").then(()=>parcelRequire('eAdVI'));

});

parcelRegister("h0sLM", function(module, exports) {

let $c618c0cfd4a241ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c618c0cfd4a241ce$var$load("1U6At").then(()=>parcelRequire('gb3Xv'));

});

parcelRegister("33x5j", function(module, exports) {

let $239b50d57443a3c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $239b50d57443a3c4$var$load("93k58").then(()=>parcelRequire('933Ox'));

});

parcelRegister("le8CP", function(module, exports) {

let $f741988ed0a41b8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f741988ed0a41b8b$var$load("kTZs1").then(()=>parcelRequire('hQPuK'));

});

parcelRegister("eofHO", function(module, exports) {

let $a79f7d6964d1e69a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a79f7d6964d1e69a$var$load("9LWeN").then(()=>parcelRequire('9nhwi'));

});

parcelRegister("fLoqW", function(module, exports) {

let $b79e32cc01b5553c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b79e32cc01b5553c$var$load("c3z4T").then(()=>parcelRequire('s579P'));

});






parcelRegister("4iCa2", function(module, exports) {

let $321671d405edd582$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $321671d405edd582$var$load("cM9em"),
    $321671d405edd582$var$load("fr9NE"),
    $321671d405edd582$var$load("h2MrD"),
    $321671d405edd582$var$load("bYT2S"),
    $321671d405edd582$var$load("7Ck1y")
]).then(()=>parcelRequire('5UISO'));

});


parcelRegister("7VeJI", function(module, exports) {

$parcel$export(module.exports, "useEscapeClickaway", () => $5979b99f85d0423a$export$886f2fdec3f419af);

var $5uXOq = parcelRequire("5uXOq");
const $5979b99f85d0423a$export$886f2fdec3f419af = (/** Callback to fire when the user presses the escape key */ onEscape, /** Callback to fire when the user clicks an element not contained by the ref */ onClickAway)=>{
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onEscape();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', handleClickAway);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('mousedown', handleClickAway);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};

});


parcelRegister("deZY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a78ad29594c2c22f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lFKmC = parcelRequire("lFKmC");

var $7nsd3 = parcelRequire("7nsd3");

var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");

var $iZOJ9 = parcelRequire("iZOJ9");

var $cb25w = parcelRequire("cb25w");

var $liajA = parcelRequire("liajA");

var $kxFlx = parcelRequire("kxFlx");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $ldHK3 = parcelRequire("ldHK3");
var $g7oRE = parcelRequire("g7oRE");

var $gE8f9 = parcelRequire("gE8f9");
var $dPSMN = parcelRequire("dPSMN");

var $lnN1k = parcelRequire("lnN1k");

var $iPN39 = parcelRequire("iPN39");

var $kEtKd = parcelRequire("kEtKd");

var $3lb3A = parcelRequire("3lb3A");
function $a78ad29594c2c22f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a78ad29594c2c22f$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $a78ad29594c2c22f$export$452f1062ecf44be7 = 5;
const $a78ad29594c2c22f$var$clearTextButtonStyles = (0, $8CUq3.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $a78ad29594c2c22f$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $a78ad29594c2c22f$var$containerPadding = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $a78ad29594c2c22f$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $a78ad29594c2c22f$var$inputLabel = {
    name: "1ta6p52",
    styles: "color:var(--ds-text-subtlest, #626F86);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $a78ad29594c2c22f$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $a78ad29594c2c22f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    displayText: {
        id: 'fabric.editor.displayText',
        defaultMessage: 'Text to display',
        description: 'Text to display'
    },
    clearText: {
        id: 'fabric.editor.clearLinkText',
        defaultMessage: 'Clear text',
        description: 'Clears text on the link toolbar'
    },
    clearLink: {
        id: 'fabric.editor.clearLink',
        defaultMessage: 'Clear link',
        description: 'Clears link in the link toolbar'
    },
    searchLinkAriaDescription: {
        id: 'fabric.editor.hyperlink.searchLinkAriaDescription',
        defaultMessage: 'Suggestions will appear below as you type into the field',
        description: 'Describes what the search field does for screen reader users.'
    },
    searchLinkResults: {
        id: 'fabric.editor.hyperlink.searchLinkResults',
        defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
        description: 'Announce search results for screen-reader users.'
    },
    linkVisibleLabel: {
        id: 'fabric.editor.hyperlink.linkVisibleLabel',
        defaultMessage: 'Paste or search for link',
        description: 'Visible label for link input in hyperlink floating control'
    },
    textVisibleLabel: {
        id: 'fabric.editor.hyperlink.textVisibleLabel',
        defaultMessage: 'Display text (optional)',
        description: 'Visible label for text input in hyperlink floating control'
    }
});
const $a78ad29594c2c22f$var$defaultIcon = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $liajA.default), {
    label: 'page'
});
const $a78ad29594c2c22f$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $a78ad29594c2c22f$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $3lb3A.mapContentTypeToIcon)[contentType] || $a78ad29594c2c22f$var$defaultIcon,
        prefetch: false
    });
class $a78ad29594c2c22f$export$7acbf008e0847b89 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), /* To prevent double submit */ this.submitted = false, this.urlInputContainer = null, this.displayTextInputContainer = null, this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.quickSearchQueryVersion = 0, this.analyticSource = 'createLinkInlineDialog', this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $gkwXh.ACTION).ENTERED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $3lb3A.sha1)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $3lb3A.wordCount)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $a78ad29594c2c22f$var$limit((0, $3lb3A.filterUniqueItems)([
                    ...items,
                    ...searchProviderResultItems.map($a78ad29594c2c22f$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $gkwXh.ACTION).INVOKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $gkwXh.ACTION).SHOWN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $gkwXh.ACTION).INVOKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
            }
        }, this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $iZOJ9.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $a78ad29594c2c22f$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $a78ad29594c2c22f$export$452f1062ecf44be7);
                }
            }
        }, this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $a78ad29594c2c22f$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        }, this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback?.(state, dispatch);
            }
        }, this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $kEtKd.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
            }
        }, this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
     * When we use ArrowKey to navigate through result items,
     * the URL field will be populated with the content of
     * selected item.
     * This function will check if the URL field is populated
     * with selected item.
     * It can be useful to detect whether we want to insert a
     * smartlink or a hyperlink with customized title
     */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        }, this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $gkwXh.INPUT_METHOD).TYPEAHEAD, 'click');
        }, this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
       * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
       * it's selected from the result list and fire the
       * analytic
       */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $gkwXh.ACTION).SELECTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
            }
        }, this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $a78ad29594c2c22f$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        }, this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $a78ad29594c2c22f$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        }, this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $dPSMN.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $gkwXh.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $dPSMN.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $gkwXh.INPUT_METHOD).MANUAL, 'notselected');
            }
        }, this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $dPSMN.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $gkwXh.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback?.(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $gkwXh.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
            }
        }, this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback?.(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $dPSMN.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $ctLRZ.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $gkwXh.ACTION).VIEWED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $gkwXh.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $7nsd3.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $gkwXh.ACTION).DISMISSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $a78ad29594c2c22f$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($a78ad29594c2c22f$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $gkwXh.ACTION).INVOKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $gkwXh.ACTION).SHOWN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            return items;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $gkwXh.ACTION).INVOKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage }, activityProvider: activityProvider } = this.props;
        const formatClearLinkText = formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = (0, $gE8f9.browser).safari && this.getScreenReaderText();
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "aria-label": "Hyperlink Edit",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $iPN39.container),
                !!activityProvider && (0, $iPN39.containerWithProvider),
                $a78ad29594c2c22f$var$containerPadding
            ],
            ref: this.wrapperRef
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $a78ad29594c2c22f$var$inputLabel
        }, formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.linkVisibleLabel)), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                (0, $iPN39.inputWrapper),
                $a78ad29594c2c22f$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldHK3.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $a78ad29594c2c22f$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.searchLinkAriaDescription)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g7oRE.default), {
            role: "combobox",
            ariaExpanded: true,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $a78ad29594c2c22f$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
            xcss: $a78ad29594c2c22f$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
            label: formatClearLinkText,
            color: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $a78ad29594c2c22f$var$inputLabel,
                $a78ad29594c2c22f$var$textLabelMargin
            ]
        }, formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.textVisibleLabel)), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                (0, $iPN39.inputWrapper),
                $a78ad29594c2c22f$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g7oRE.default), {
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $a78ad29594c2c22f$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            content: formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.clearText)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
            xcss: $a78ad29594c2c22f$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
            label: formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.clearText),
            color: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $a78ad29594c2c22f$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lnN1k.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
    }
}
function $a78ad29594c2c22f$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $a78ad29594c2c22f$var$limit(items) {
    return items.slice(0, $a78ad29594c2c22f$export$452f1062ecf44be7);
}
const $a78ad29594c2c22f$export$527bb787d3e8324e = (0, $8RXs9.default)($a78ad29594c2c22f$export$7acbf008e0847b89);
var $a78ad29594c2c22f$export$2e2bcd8739ae039 = (0, $cb25w.default)()($a78ad29594c2c22f$export$527bb787d3e8324e);

});
parcelRegister("liajA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41b90368f925c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79077d9339ad2083a3901f522ad14f6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $kdfZa = parcelRequire("kdfZa");

var $VSDnB = parcelRequire("VSDnB");

var $kZjZ3 = parcelRequire("kZjZ3");
/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c41b90368f925c6c$var$Page16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
        label: label,
        testId: testId
    });
};
$c41b90368f925c6c$var$Page16Icon.displayName = 'Page16Icon';
var $c41b90368f925c6c$export$2e2bcd8739ae039 = $c41b90368f925c6c$var$Page16Icon;

});
parcelRegister("kZjZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb586f8874bd1e95$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8396146cc2fa60842aed7101fb3015b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $fb586f8874bd1e95$var$Page16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`,
        ...props,
        size: "small"
    });
$fb586f8874bd1e95$var$Page16Icon.displayName = 'Page16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb586f8874bd1e95$export$2e2bcd8739ae039 = $fb586f8874bd1e95$var$Page16Icon;

});


parcelRegister("ldHK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $460cd7001198a7b7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $460cd7001198a7b7$var$timer;
const $460cd7001198a7b7$var$Announcer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        clearTimeout($460cd7001198a7b7$var$timer);
        setContentRendered(false);
        $460cd7001198a7b7$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($460cd7001198a7b7$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            children: text
        })
    });
});
var $460cd7001198a7b7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($460cd7001198a7b7$var$Announcer);

});

parcelRegister("g7oRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41340a73ecd6e84a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $5xibt = parcelRequire("5xibt");
const $41340a73ecd6e84a$var$KeyZCode = 90;
const $41340a73ecd6e84a$var$KeyYCode = 89;
class $41340a73ecd6e84a$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        }, this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        }, this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $5xibt.panelTextInput),
                width !== undefined && (0, $5xibt.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": this.props?.ariaRequired,
            "aria-invalid": this.props?.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isUndoEvent(event) {
        return event.keyCode === $41340a73ecd6e84a$var$KeyZCode && // cmd + z for mac
        ((0, $gE8f9.browser).mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !(0, $gE8f9.browser).mac && event.ctrlKey);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isRedoEvent(event) {
        return(// ctrl + y for non-mac
        !(0, $gE8f9.browser).mac && event.ctrlKey && event.keyCode === $41340a73ecd6e84a$var$KeyYCode || (0, $gE8f9.browser).mac && event.metaKey && event.shiftKey && event.keyCode === $41340a73ecd6e84a$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $41340a73ecd6e84a$var$KeyZCode);
    }
}

});
parcelRegister("5xibt", function(module, exports) {

$parcel$export(module.exports, "panelTextInput", () => $087151c1f25b1933$export$b81ddbf3e2eaad80);
$parcel$export(module.exports, "panelTextInputWithCustomWidth", () => $087151c1f25b1933$export$c9f899b6422903f6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $087151c1f25b1933$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `2px solid ${"var(--ds-border, #091E4224)"}`,
        borderRadius: 0,
        boxSizing: 'content-box',
        color: "var(--ds-text-subtle, #44546F)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $iHYdz.relativeFontSizeToBase16)(13),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '20px',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            borderColor: "var(--ds-border-focused, #388BFF)"
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #626F86)"
        }
    }
});
const $087151c1f25b1933$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });

});


parcelRegister("lnN1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e0d14e44d0b1aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eZJjh = parcelRequire("eZJjh");

var $1DVD8 = parcelRequire("1DVD8");
function $54e0d14e44d0b1aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $54e0d14e44d0b1aa$var$listContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $54e0d14e44d0b1aa$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $54e0d14e44d0b1aa$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
class $54e0d14e44d0b1aa$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id } = this.props;
        let itemsContent;
        let loadingContent;
        if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
            css: $54e0d14e44d0b1aa$export$ca0620a9deb4a3fe,
            id: id,
            role: role,
            "aria-controls": ariaControls
        }, items.map((item, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1DVD8.default), {
                id: `link-search-list-item-${index}`,
                role: role && 'option',
                item: item,
                selected: selectedIndex === index,
                onMouseMove: onMouseMove,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onSelect: onSelect,
                key: item.objectId
            })));
        if (isLoading) loadingContent = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": `${id}-loading`,
            css: $54e0d14e44d0b1aa$var$spinnerContainer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
            size: "medium",
            interactionName: "link-search-spinner"
        }));
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $54e0d14e44d0b1aa$var$listContainer
        }, itemsContent, loadingContent);
    }
}

});
parcelRegister("1DVD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $995428ceb0cf599f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $4jzQi = parcelRequire("4jzQi");

var $kEtKd = parcelRequire("kEtKd");
function $995428ceb0cf599f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $995428ceb0cf599f$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $995428ceb0cf599f$export$624ac72e8eeb8e3d = {
    name: "jjwciq",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
};
const $995428ceb0cf599f$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $995428ceb0cf599f$export$d6a1b4d10134b7d7 = {
    name: "ufq1bc",
    styles: "color:var(--ds-text, #172B4D);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $995428ceb0cf599f$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(11)
});
const $995428ceb0cf599f$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $995428ceb0cf599f$var$LinkSearchListItem extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    renderIcon() {
        const { item: { icon: icon, iconUrl: iconUrl }, intl: intl } = this.props;
        if (icon) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: $995428ceb0cf599f$var$iconStyle
        }, icon);
        if (iconUrl) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: $995428ceb0cf599f$var$iconStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
            src: iconUrl,
            alt: (0, $4jzQi.getCorrectAltByIconUrl)(iconUrl, intl)
        }));
        return null;
    }
    renderTimeStamp() {
        const { item: item, intl: intl } = this.props;
        const date = (0, $kEtKd.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-test-id": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    }
    render() {
        const { item: item, selected: selected, id: id, role: role } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
            css: [
                $995428ceb0cf599f$export$34e0f9847d4c02dd,
                selected && $995428ceb0cf599f$export$624ac72e8eeb8e3d
            ],
            role: role,
            id: id,
            "aria-selected": selected,
            "data-testid": "link-search-list-item",
            onMouseMove: this.handleMouseMove,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onClick: this.handleSelect
        }, this.renderIcon(), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: $995428ceb0cf599f$var$nameWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $995428ceb0cf599f$export$d6a1b4d10134b7d7
        }, item.name), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": "link-search-list-item-container",
            css: $995428ceb0cf599f$export$ff1446d682f75fb9
        }, item.container, this.renderTimeStamp()))));
    }
    constructor(...args){
        super(...args), this.handleSelect = (e)=>{
            e.preventDefault(); // don't let editor lose focus
            const { item: item, onSelect: onSelect } = this.props;
            onSelect(item.url, item.name);
        }, this.handleMouseMove = ()=>{
            const { onMouseMove: onMouseMove, item: item } = this.props;
            onMouseMove && onMouseMove(item.objectId);
        }, this.handleMouseEnter = ()=>{
            const { onMouseEnter: onMouseEnter, item: item } = this.props;
            onMouseEnter && onMouseEnter(item.objectId);
        }, this.handleMouseLeave = ()=>{
            const { onMouseLeave: onMouseLeave, item: item } = this.props;
            onMouseLeave && onMouseLeave(item.objectId);
        };
    }
}
var $995428ceb0cf599f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($995428ceb0cf599f$var$LinkSearchListItem);

});
parcelRegister("4jzQi", function(module, exports) {

$parcel$export(module.exports, "getCorrectAltByIconUrl", () => $e880ccf995c9e5fe$export$ac1fda7301622804);

var $7VHMR = parcelRequire("7VHMR");
const $e880ccf995c9e5fe$var$messages = (0, $7VHMR.defineMessages)({
    story: {
        id: 'fabric.editor.story',
        defaultMessage: 'Story',
        description: 'Alt text for Story'
    },
    epic: {
        id: 'fabric.editor.epic',
        defaultMessage: 'Epic',
        description: 'Alt text for Epic'
    },
    task: {
        id: 'fabric.editor.task',
        defaultMessage: 'Task',
        description: 'Alt text for Task'
    },
    bug: {
        id: 'fabric.editor.bug',
        defaultMessage: 'Bug',
        description: 'Alt text for Bug'
    },
    subTask: {
        id: 'fabric.editor.subTask',
        defaultMessage: 'Sub-task',
        description: 'Alt text for Sub-task'
    },
    improvement: {
        id: 'fabric.editor.improvement',
        defaultMessage: 'Improvement',
        description: 'Alt text for Improvement'
    },
    defaultAltText: {
        id: 'fabric.editor.defaultAltText',
        defaultMessage: 'Document',
        description: 'Default alt text for ListItem image'
    }
});
const $e880ccf995c9e5fe$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.improvement);
    return alt;
};

});

parcelRegister("kEtKd", function(module, exports) {

$parcel$export(module.exports, "transformTimeStamp", () => $bd8482d2c43b4082$export$439b9bb86eb9f500);

var $SzDmm = parcelRequire("SzDmm");

var $k7m40 = parcelRequire("k7m40");

var $2kh23 = parcelRequire("2kh23");

var $8DYpW = parcelRequire("8DYpW");
const $bd8482d2c43b4082$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $8DYpW.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $8DYpW.default).timeViewed);
            break;
    }
    if ((0, $SzDmm.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $k7m40.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $2kh23.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $8DYpW.default).timeAgo)
    };
};
const $bd8482d2c43b4082$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $bd8482d2c43b4082$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $bd8482d2c43b4082$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};

});



parcelRegister("iPN39", function(module, exports) {

$parcel$export(module.exports, "inputWrapper", () => $df68561fe99a6144$export$248a47518f3a0001);
$parcel$export(module.exports, "container", () => $df68561fe99a6144$export$34e0f9847d4c02dd);
$parcel$export(module.exports, "containerWithProvider", () => $df68561fe99a6144$export$8fb2d297355596b4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $df68561fe99a6144$export$248a47518f3a0001 = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $df68561fe99a6144$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $f96f1f7af2f8d3ca$export$92a2501826f554f6)}px`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $df68561fe99a6144$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $f96f1f7af2f8d3ca$export$a62aa932daf22ffe)}px`
});

});
const $f96f1f7af2f8d3ca$export$a62aa932daf22ffe = 420;
const $f96f1f7af2f8d3ca$export$92a2501826f554f6 = 360;
const $f96f1f7af2f8d3ca$export$c04a5ad015d45447 = 360;
const $f96f1f7af2f8d3ca$export$c635b83728f81640 = 570;


parcelRegister("3lb3A", function(module, exports) {

$parcel$export(module.exports, "filterUniqueItems", () => $5722104a46f56bc4$export$8437fc55448c6e05);
$parcel$export(module.exports, "mapContentTypeToIcon", () => $5722104a46f56bc4$export$80e948449ec854a9);
$parcel$export(module.exports, "sha1", () => $5722104a46f56bc4$export$5091bdda49ba90f5);
$parcel$export(module.exports, "wordCount", () => $5722104a46f56bc4$export$24d5ff955141c347);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bdDiz = parcelRequire("bdDiz");

var $iRZQl = parcelRequire("iRZQl");

var $iAkpb = parcelRequire("iAkpb");

var $kQSMP = parcelRequire("kQSMP");

var $liajA = parcelRequire("liajA");

var $kvhCa = parcelRequire("kvhCa");

var $ercGv = parcelRequire("ercGv");

var $VSDnB = parcelRequire("VSDnB");

var $1kHUN = parcelRequire("1kHUN");
function $5722104a46f56bc4$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
const $5722104a46f56bc4$var$Issue16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQSMP.default), {
        label: intl.formatMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $1kHUN.utilMessages).hyperlinkIconIssueLabelIssueTermRefresh : (0, $1kHUN.utilMessages).hyperlinkIconIssueLabel)
    });
};
const $5722104a46f56bc4$var$Bug16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iAkpb.default), {
        label: intl.formatMessage((0, $1kHUN.utilMessages).hyperlinkIconBugLabel)
    });
};
const $5722104a46f56bc4$var$Story16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kvhCa.default), {
        label: intl.formatMessage((0, $1kHUN.utilMessages).hyperlinkIconStoryLabel)
    });
};
const $5722104a46f56bc4$var$Task16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
        label: intl.formatMessage((0, $1kHUN.utilMessages).hyperlinkIconTaskLabel)
    });
};
const $5722104a46f56bc4$var$Page16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $liajA.default), {
        label: intl.formatMessage((0, $1kHUN.utilMessages).hyperlinkIconPageLabel)
    });
};
const $5722104a46f56bc4$var$Blog16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iRZQl.default), {
        label: intl.formatMessage((0, $1kHUN.utilMessages).hyperlinkIconBlogLabel)
    });
};
const $5722104a46f56bc4$var$IntlIssue16Icon = (0, $8RXs9.default)($5722104a46f56bc4$var$Issue16);
const $5722104a46f56bc4$var$IntlBug16Icon = (0, $8RXs9.default)($5722104a46f56bc4$var$Bug16);
const $5722104a46f56bc4$var$IntlStory16Icon = (0, $8RXs9.default)($5722104a46f56bc4$var$Story16);
const $5722104a46f56bc4$var$IntlTask16Icon = (0, $8RXs9.default)($5722104a46f56bc4$var$Task16);
const $5722104a46f56bc4$var$IntlPage16Icon = (0, $8RXs9.default)($5722104a46f56bc4$var$Page16);
const $5722104a46f56bc4$var$IntlBlog16Icon = (0, $8RXs9.default)($5722104a46f56bc4$var$Blog16);
const $5722104a46f56bc4$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, $2OMIu.jsx)($5722104a46f56bc4$var$IntlIssue16Icon, {}),
    'jira.issue.bug': /*#__PURE__*/ (0, $2OMIu.jsx)($5722104a46f56bc4$var$IntlBug16Icon, {}),
    'jira.issue.story': /*#__PURE__*/ (0, $2OMIu.jsx)($5722104a46f56bc4$var$IntlStory16Icon, {}),
    'jira.issue.task': /*#__PURE__*/ (0, $2OMIu.jsx)($5722104a46f56bc4$var$IntlTask16Icon, {}),
    'confluence.page': /*#__PURE__*/ (0, $2OMIu.jsx)($5722104a46f56bc4$var$IntlPage16Icon, {}),
    'confluence.blogpost': /*#__PURE__*/ (0, $2OMIu.jsx)($5722104a46f56bc4$var$IntlBlog16Icon, {})
};
const $5722104a46f56bc4$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bdDiz))).createHash().update(input).digest('hex');
};
const $5722104a46f56bc4$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};

});
parcelRegister("1kHUN", function(module, exports) {

$parcel$export(module.exports, "utilMessages", () => $5c7e67fcef8e13d4$export$ecd9e62648c1046a);

var $7VHMR = parcelRequire("7VHMR");
const $5c7e67fcef8e13d4$export$ecd9e62648c1046a = (0, $7VHMR.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel',
        defaultMessage: 'Issue',
        description: 'icon label for a jira issue'
    },
    hyperlinkIconBugLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBugLabel',
        defaultMessage: 'Bug',
        description: 'icon label for a jira bug'
    },
    hyperlinkIconStoryLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconStoryLabel',
        defaultMessage: 'Story',
        description: 'icon label for a jira story'
    },
    hyperlinkIconTaskLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconTaskLabel',
        defaultMessage: 'Task',
        description: 'icon label for a jira task'
    },
    hyperlinkIconPageLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconPageLabel',
        defaultMessage: 'Page',
        description: 'icon label for a confluence page'
    },
    hyperlinkIconBlogLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBlogLabel',
        defaultMessage: 'Blog',
        description: 'icon label for a confluence blog'
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh',
        defaultMessage: 'Work Item',
        description: 'icon label for a jira issue'
    }
});

});





parcelRegister("9Ox4G", function(module, exports) {

$parcel$export(module.exports, "EditToolbarButton", () => $64141cc208f415cc$export$4f24788e7d04736b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $80CM7 = parcelRequire("80CM7");
var $jDuvE = parcelRequire("jDuvE");

var $e3WeH = parcelRequire("e3WeH");
var $2ENth = parcelRequire("2ENth");

var $8v0FX = parcelRequire("8v0FX");
var $eGiVQ = parcelRequire("eGiVQ");

var $6Ingq = parcelRequire("6Ingq");

var $c8Oei = parcelRequire("c8Oei");

var $051X7 = parcelRequire("051X7");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $bUmQV = parcelRequire("bUmQV");

var $gmhCD = parcelRequire("gmhCD");

var $jPPkn = parcelRequire("jPPkn");

var $e8zuf = parcelRequire("e8zuf");

var $4BLK3 = parcelRequire("4BLK3");

var $dYS3B = parcelRequire("dYS3B");

var $2Athq = parcelRequire("2Athq");
const $64141cc208f415cc$var$dropdownExpandContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $64141cc208f415cc$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const { extensionKey: extensionKey, ...response } = (0, $dYS3B.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const containerRef = (0, $5uXOq.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $5uXOq.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $jPPkn.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $5uXOq.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $jPPkn.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $5uXOq.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $e8zuf.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $jPPkn.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                testId: "edit-link",
                onClick: onEditLink
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $jDuvE.linkToolbarMessages).editLink)), (!(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') || !(0, $VSDnB.fg)('platform_editor_controls_patch_6')) && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), null));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $jDuvE.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $jDuvE.linkToolbarMessages).editDatasourceStandalone)), (!(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') || !(0, $VSDnB.fg)('platform_editor_controls_patch_6')) && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), null));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                        css: $64141cc208f415cc$var$dropdownExpandContainer
                    }, (0, $VSDnB.fg)('platform-editor-plugin-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                        label: intl.formatMessage((0, $80CM7.messages).editDropdownTriggerTitle)
                    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                        label: intl.formatMessage((0, $80CM7.messages).editDropdownTriggerTitle)
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $80CM7.messages).editDropdownTriggerTitle)), (!(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') || !(0, $VSDnB.fg)('platform_editor_controls_patch_6')) && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), null));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eGiVQ.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $8v0FX.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $80CM7.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $80CM7.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $64141cc208f415cc$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $dYS3B.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $5uXOq.useMemo)(()=>{
        if (!datasourceId || !(0, $jPPkn.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Athq.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl
    });
};
const $64141cc208f415cc$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node } = props;
    const fetchData = (0, $5uXOq.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $4BLK3.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $5uXOq.useMemo)(()=>{
        if (!datasourceId || !(0, $jPPkn.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Athq.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl
    });
};
const $64141cc208f415cc$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const cardContext = (0, $051X7.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $f8Sb3.jsx)($64141cc208f415cc$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $f8Sb3.jsx)($64141cc208f415cc$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($64141cc208f415cc$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance
    });
};

});
parcelRegister("2ENth", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6bb55008eb3feca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gmhCD = parcelRequire("gmhCD");
function $f6bb55008eb3feca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6bb55008eb3feca$var$separator = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $f6bb55008eb3feca$var$separatorNew = {
    name: "876g5t",
    styles: "background:var(--ds-border, #091E4224);width:1px;height:20px;align-self:center"
};
const $f6bb55008eb3feca$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $f6bb55008eb3feca$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $f6bb55008eb3feca$var$separatorNew : $f6bb55008eb3feca$var$separator,
            fullHeight && $f6bb55008eb3feca$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator"
    });

});

parcelRegister("eGiVQ", function(module, exports) {

$parcel$export(module.exports, "DropdownContainer", () => $f0ce2cd52ae2d408$export$49166591ec160d97);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8v0FX = parcelRequire("8v0FX");

var $iFvNE = parcelRequire("iFvNE");

var $kdDpx = parcelRequire("kdDpx");
const $f0ce2cd52ae2d408$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $5uXOq.useContext)((0, $kdDpx.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $8v0FX.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iFvNE.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});

});
parcelRegister("iFvNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $504d98097ea5e13b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $jdyxs = parcelRequire("jdyxs");

var $iraaj = parcelRequire("iraaj");

var $4N9VB = parcelRequire("4N9VB");

var $2WNBA = parcelRequire("2WNBA");
class $504d98097ea5e13b$export$931cbfb6bfb85fc extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                setOutsideClickTargetRef(target);
                this.setState({
                    target: target || undefined
                });
            }, this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement, target: targetProp, forcePlacement: forcePlacement, alignX: alignX, alignY: alignY, offset: offset, shouldFitContainer: shouldFitContainer = true } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
            target: targetProp ?? (alignDropdownWithParentElement ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
            target?.closest("[data-testid='editor-floating-toolbar']") : target),
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: forcePlacement ? undefined : this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement,
            alignX: alignX,
            alignY: alignY,
            forcePlacement: forcePlacement,
            offset: offset,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WNBA.ArrowKeyNavigationProvider), {
                ...arrowKeyNavigationProviderOptions,
                closeOnTab: true,
                handleClose: this.handleCloseAndFocus,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: fitWidth || 0
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iraaj.default), {
                        isOpen: true,
                        onOpenChange: onOpenChange,
                        position: popupPlacement.join(' '),
                        shouldFitContainer: (0, $VSDnB.fg)('platform_editor_controls_patch_6') ? shouldFitContainer : true,
                        id: dropdownListId,
                        children: children
                    })
                })
            })
        });
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return trigger ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdyxs.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: this.handleRef(setOutsideClickTargetRef),
                            children: trigger
                        }),
                        isOpen ? this.renderDropdown() : null
                    ]
                })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: isOpen ? this.renderDropdown() : null
        });
    }
}
const $504d98097ea5e13b$var$DropdownWithOuterListeners = (0, $jdyxs.default)($504d98097ea5e13b$export$931cbfb6bfb85fc);
var $504d98097ea5e13b$export$2e2bcd8739ae039 = $504d98097ea5e13b$var$DropdownWithOuterListeners;

});


parcelRegister("e8zuf", function(module, exports) {

$parcel$export(module.exports, "editDatasource", () => $010a3cf1d7bb3474$export$687401cc190b9ec3);

var $gkwXh = parcelRequire("gkwXh");

var $3dBkm = parcelRequire("3dBkm");

var $nYpqR = parcelRequire("nYpqR");
const $010a3cf1d7bb3474$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $3dBkm.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $nYpqR.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CLICKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $gkwXh.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };

});

parcelRegister("4BLK3", function(module, exports) {

$parcel$export(module.exports, "useFetchDatasourceDataInfo", () => $4574e4b53667a1e5$export$25222ec28f4cbba5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $vE5bM = parcelRequire("vE5bM");
const $4574e4b53667a1e5$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $5uXOq.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $vE5bM.useDatasourceClientExtension)();
    (0, $5uXOq.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $vE5bM.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};

});

parcelRegister("2Athq", function(module, exports) {

$parcel$export(module.exports, "default", () => $726711b8d0afaac8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $80CM7 = parcelRequire("80CM7");
var $jDuvE = parcelRequire("jDuvE");

var $e3WeH = parcelRequire("e3WeH");
var $2ENth = parcelRequire("2ENth");

var $8v0FX = parcelRequire("8v0FX");
var $eGiVQ = parcelRequire("eGiVQ");

var $5nRKm = parcelRequire("5nRKm");

var $6Ingq = parcelRequire("6Ingq");

var $c8Oei = parcelRequire("c8Oei");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $bUmQV = parcelRequire("bUmQV");

var $gmhCD = parcelRequire("gmhCD");

var $jPPkn = parcelRequire("jPPkn");

var $e8zuf = parcelRequire("e8zuf");
const $726711b8d0afaac8$var$dropdownExpandContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $726711b8d0afaac8$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const containerRef = (0, $5uXOq.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $5uXOq.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $jPPkn.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $5uXOq.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $e8zuf.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $jPPkn.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
        label: ""
    }) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon
            }, (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $jDuvE.linkToolbarMessages).editLink)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), null));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $jDuvE.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $jDuvE.linkToolbarMessages).editDatasourceStandalone)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), null));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                        css: $726711b8d0afaac8$var$dropdownExpandContainer
                    }, (0, $VSDnB.fg)('platform-editor-plugin-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                        label: intl.formatMessage((0, $80CM7.messages).editDropdownTriggerTitle)
                    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                        label: intl.formatMessage((0, $80CM7.messages).editDropdownTriggerTitle)
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $80CM7.messages).editDropdownTriggerTitle)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), null));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bUmQV.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eGiVQ.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $8v0FX.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $80CM7.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $80CM7.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $726711b8d0afaac8$export$2e2bcd8739ae039 = $726711b8d0afaac8$var$EditToolbarButtonPresentation;

});


parcelRegister("6rhck", function(module, exports) {

$parcel$export(module.exports, "HyperlinkToolbarAppearance", () => $b1bfb113bd22e46e$export$33d351e602b13f5c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $2ENth = parcelRequire("2ENth");

var $bUmQV = parcelRequire("bUmQV");

var $fo6j3 = parcelRequire("fo6j3");

var $fjdBk = parcelRequire("fjdBk");
function $b1bfb113bd22e46e$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $5uXOq.useState)(new Map());
    const cardProvider = (0, $5uXOq.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $5uXOq.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjdBk.LinkToolbarAppearance), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions?.allowEmbeds,
                allowBlockCards: cardOptions?.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi
            }, "link-appearance"),
            cardOptions?.allowDatasource && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fo6j3.DatasourceAppearanceButton), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ENth.default), {})
        ]
    });
}

});
parcelRegister("fjdBk", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarAppearance", () => $b0fc053941b9b8d2$export$2a8c6fb42753b13e);
$parcel$export(module.exports, "getUnavailableMessage", () => $b0fc053941b9b8d2$export$74e77d31eb18de27);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $gkwXh = parcelRequire("gkwXh");

var $1ZWXY = parcelRequire("1ZWXY");
var $67IYF = parcelRequire("67IYF");
var $6uxIG = parcelRequire("6uxIG");

var $80CM7 = parcelRequire("80CM7");
var $8DYpW = parcelRequire("8DYpW");

var $20Kbb = parcelRequire("20Kbb");

var $kCV8T = parcelRequire("kCV8T");

var $jPiXc = parcelRequire("jPiXc");

var $jPPkn = parcelRequire("jPPkn");

var $6fJce = parcelRequire("6fJce");

var $9HVke = parcelRequire("9HVke");

var $f10aj = parcelRequire("f10aj");

var $bLdKL = parcelRequire("bLdKL");
class $b0fc053941b9b8d2$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bLdKL.WithCardContext), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args), this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $20Kbb.isSupportedInParent)(editorState, (0, $kCV8T.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $20Kbb.isSupportedInParent)(editorState, (0, $kCV8T.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $80CM7.messages).embed),
                onClick: (0, $jPiXc.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $b0fc053941b9b8d2$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $80CM7.messages).block),
                onClick: (0, $jPiXc.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $b0fc053941b9b8d2$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $80CM7.messages).url),
                    onClick: (0, $1ZWXY.commandWithMetadata)((0, $jPiXc.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $gkwXh.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $80CM7.messages).inline),
                    onClick: (0, $jPiXc.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6uxIG.LinkToolbarButtonGroup), {
                options: options.map((option)=>(0, $67IYF.getButtonGroupOption)(intl, dispatchCommand, {
                        ...option,
                        onClick: (0, $1ZWXY.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $f10aj.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $jPPkn.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9HVke.DiscoveryPulse), {
                        localStorageKey: (0, $6fJce.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                });
            }
            return LinkToolbarButtons;
        };
    }
}
const $b0fc053941b9b8d2$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $8DYpW.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $80CM7.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        return intl.formatMessage((0, $80CM7.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $8DYpW.default).defaultBlockNode)
        });
    }
};

});
parcelRegister("67IYF", function(module, exports) {

$parcel$export(module.exports, "appearancePropsMap", () => $01e705790f2b3935$export$b5524c7a5a82630a);
$parcel$export(module.exports, "getButtonGroupOption", () => $01e705790f2b3935$export$9de0d67eaa25f178);

var $cGbU6 = parcelRequire("cGbU6");

var $8pZDY = parcelRequire("8pZDY");

var $cRyJJ = parcelRequire("cRyJJ");

var $55fIV = parcelRequire("55fIV");

var $80CM7 = parcelRequire("80CM7");

var $af088 = parcelRequire("af088");

var $alziS = parcelRequire("alziS");

var $b9sDD = parcelRequire("b9sDD");

var $cPNp9 = parcelRequire("cPNp9");
const $01e705790f2b3935$export$b5524c7a5a82630a = {
    url: {
        title: (0, $80CM7.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cGbU6))),
        iconFallback: (0, $cPNp9.IconUrl)
    },
    inline: {
        title: (0, $80CM7.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55fIV))),
        iconFallback: (0, $b9sDD.IconInline)
    },
    block: {
        title: (0, $80CM7.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8pZDY))),
        iconFallback: (0, $af088.IconCard)
    },
    embed: {
        title: (0, $80CM7.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cRyJJ))),
        iconFallback: (0, $alziS.IconEmbed)
    }
};
const $01e705790f2b3935$export$9de0d67eaa25f178 = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon, iconFallback: iconFallback } = $01e705790f2b3935$export$b5524c7a5a82630a[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        iconFallback: iconFallback,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected
    };
};

});
parcelRegister("cGbU6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93b2a42556cf480d$var$_react = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $93b2a42556cf480d$var$_baseNew = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $93b2a42556cf480d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93b2a42556cf480d$var$MinusIcon = (props)=>/*#__PURE__*/ $93b2a42556cf480d$var$_react.default.createElement($93b2a42556cf480d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$93b2a42556cf480d$var$MinusIcon.displayName = 'MinusIcon';
var $93b2a42556cf480d$var$_default = module.exports.default = $93b2a42556cf480d$var$MinusIcon;

});

parcelRegister("8pZDY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c54e3a438f254ab0e6b2d2ef082ee70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $621079ace3fec8f8$var$_react = $621079ace3fec8f8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $621079ace3fec8f8$var$_baseNew = $621079ace3fec8f8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $621079ace3fec8f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkCard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link preview cards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $621079ace3fec8f8$var$SmartLinkCardIcon = (props)=>/*#__PURE__*/ $621079ace3fec8f8$var$_react.default.createElement($621079ace3fec8f8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8v-7zm9.5 0v7H14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5H3V6h5.5zM6 10H3V8.5h3z" clip-rule="evenodd"/>`
    }, props));
$621079ace3fec8f8$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
var $621079ace3fec8f8$var$_default = module.exports.default = $621079ace3fec8f8$var$SmartLinkCardIcon;

});

parcelRegister("cRyJJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65acd7ea793f30a87884e2e95c9c21a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95d5613ff1130c53$var$_react = $95d5613ff1130c53$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $95d5613ff1130c53$var$_baseNew = $95d5613ff1130c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $95d5613ff1130c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95d5613ff1130c53$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $95d5613ff1130c53$var$_react.default.createElement($95d5613ff1130c53$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$95d5613ff1130c53$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $95d5613ff1130c53$var$_default = module.exports.default = $95d5613ff1130c53$var$SmartLinkEmbedIcon;

});

parcelRegister("55fIV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40b4b1c775e02fc4e0dc167cf0c4dadb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b399dc6534ce487$var$_react = $3b399dc6534ce487$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3b399dc6534ce487$var$_baseNew = $3b399dc6534ce487$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3b399dc6534ce487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkInline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing inline Smart link lozenges.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b399dc6534ce487$var$SmartLinkInlineIcon = (props)=>/*#__PURE__*/ $3b399dc6534ce487$var$_react.default.createElement($3b399dc6534ce487$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3zm4 0v3h8a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3b399dc6534ce487$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
var $3b399dc6534ce487$var$_default = module.exports.default = $3b399dc6534ce487$var$SmartLinkInlineIcon;

});

parcelRegister("af088", function(module, exports) {

$parcel$export(module.exports, "IconCard", () => $cb57a73c5e7dd50b$export$f215a85d3e7de2fe);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $cb57a73c5e7dd50b$var$IconCardGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 9c-1.10457 0-2 .89543-2 2v10c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V11c0-1.10457-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Zm-4 3c-.55228 0-1 .4477-1 1s.44772 1 1 1h14c.5523 0 1-.4477 1-1s-.4477-1-1-1H9Zm-1 4c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.55228 0-1-.4477-1-1Z",
            fill: "currentColor"
        })
    });
};
const $cb57a73c5e7dd50b$export$f215a85d3e7de2fe = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $cb57a73c5e7dd50b$var$IconCardGlyph,
        ...props
    });
};

});

parcelRegister("alziS", function(module, exports) {

$parcel$export(module.exports, "IconEmbed", () => $c69d46abe545dc68$export$6e9714fda61b68c1);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $c69d46abe545dc68$var$IconEmbedGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 6c-1.10457 0-2 .89543-2 2v16c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V8c0-1.10457-.8954-2-2-2H8Zm1 2c-.55228 0-1 .44772-1 1v2c0 .5523.44772 1 1 1h2c.5523 0 1-.4477 1-1V9c0-.55228-.4477-1-1-1H9Zm4.5 1.5c-.2761 0-.5.22386-.5.5 0 .2761.2239.5.5.5h10c.2761 0 .5-.2239.5-.5 0-.27614-.2239-.5-.5-.5h-10ZM9 14c-.55228 0-1 .4477-1 1v8c0 .5523.44772 1 1 1h14c.5523 0 1-.4477 1-1v-8c0-.5523-.4477-1-1-1H9Zm6 2.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Zm0 5.5-1-1-2 2h8v-1.8L18 19l-3 3Z",
            fill: "currentColor"
        })
    });
};
const $c69d46abe545dc68$export$6e9714fda61b68c1 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $c69d46abe545dc68$var$IconEmbedGlyph,
        ...props
    });
};

});

parcelRegister("b9sDD", function(module, exports) {

$parcel$export(module.exports, "IconInline", () => $f33b4f797989977d$export$f96c97cd8120c1d7);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $f33b4f797989977d$var$IconInlineGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 12c-1.10457 0-2 .8954-2 2v4c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2v-4c0-1.1046-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Z",
            fill: "currentColor"
        })
    });
};
const $f33b4f797989977d$export$f96c97cd8120c1d7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $f33b4f797989977d$var$IconInlineGlyph,
        ...props
    });
};

});

parcelRegister("cPNp9", function(module, exports) {

$parcel$export(module.exports, "IconUrl", () => $b89b64333706e5c1$export$faea2896e79f2987);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $b89b64333706e5c1$var$IconUrlGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            x: "6",
            y: "15",
            width: "20",
            height: "2",
            rx: "1",
            fill: "currentColor"
        })
    });
};
const $b89b64333706e5c1$export$faea2896e79f2987 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $b89b64333706e5c1$var$IconUrlGlyph,
        ...props
    });
};

});


parcelRegister("6uxIG", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarButtonGroup", () => $6db7d535e0963d77$export$41ba5f90e13b0c51);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ldJSL = parcelRequire("ldJSL");

var $e3WeH = parcelRequire("e3WeH");
function $6db7d535e0963d77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $6db7d535e0963d77$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $6db7d535e0963d77$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $6db7d535e0963d77$var$DisallowedWrapper = ({ disabled: disabled, ...props })=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", props);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $6db7d535e0963d77$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $6db7d535e0963d77$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $6db7d535e0963d77$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldJSL.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, iconFallback: iconFallback })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($6db7d535e0963d77$var$DisallowedWrapper, {
            css: disabled ? $6db7d535e0963d77$var$disallowedWrapperStyle : $6db7d535e0963d77$var$defaultWrapperStyle,
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
            css: disabled ? $6db7d535e0963d77$var$buttonStyleNoneEvent : $6db7d535e0963d77$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $f8Sb3.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: iconFallback
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent
        }));
    }));
};

});



parcelRegister("6Q6dY", function(module, exports) {

$parcel$export(module.exports, "getCustomHyperlinkAppearanceDropdown", () => $74a1169c58a99edb$export$5b48c4cfa5ad82e1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $67IYF = parcelRequire("67IYF");

var $e3WeH = parcelRequire("e3WeH");
var $2ENth = parcelRequire("2ENth");

var $8v0FX = parcelRequire("8v0FX");
var $eGiVQ = parcelRequire("eGiVQ");

var $c8Oei = parcelRequire("c8Oei");

var $bUmQV = parcelRequire("bUmQV");

var $8KgOE = parcelRequire("8KgOE");
const $74a1169c58a99edb$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $5uXOq.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const cardProvider = (0, $5uXOq.useRef)(undefined);
    const containerRef = (0, $5uXOq.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $5uXOq.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $67IYF.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e3WeH.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            label: "",
            spacing: "compact"
        }),
        children: title
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eGiVQ.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                arrowKeyNavigationProviderOptions: {
                    type: (0, $8v0FX.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8KgOE.LinkAppearanceMenu), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions?.allowEmbeds,
                    allowBlockCards: cardOptions?.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ENth.default), {})
        ]
    });
};
const $74a1169c58a99edb$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $2OMIu.jsx)($74a1169c58a99edb$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};

});
parcelRegister("8KgOE", function(module, exports) {

$parcel$export(module.exports, "LinkAppearanceMenu", () => $e9d7f97cc5d2cd82$export$6ce0ca681c51cdfb);
$parcel$export(module.exports, "getLinkAppearanceDropdown", () => $e9d7f97cc5d2cd82$export$1faf5b64d0bbe935);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $67IYF = parcelRequire("67IYF");
var $1ZWXY = parcelRequire("1ZWXY");
var $53SzT = parcelRequire("53SzT");

var $80CM7 = parcelRequire("80CM7");
var $jDuvE = parcelRequire("jDuvE");

var $20Kbb = parcelRequire("20Kbb");

var $kCV8T = parcelRequire("kCV8T");

var $051X7 = parcelRequire("051X7");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $jPiXc = parcelRequire("jPiXc");

var $eemXi = parcelRequire("eemXi");

var $fjdBk = parcelRequire("fjdBk");
const $e9d7f97cc5d2cd82$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $051X7.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $20Kbb.isSupportedInParent)(editorState, (0, $kCV8T.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $20Kbb.isSupportedInParent)(editorState, (0, $kCV8T.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $80CM7.messages).embed),
        onClick: (0, $jPiXc.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $fjdBk.getUnavailableMessage)(editorState, intl)
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $80CM7.messages).block),
        onClick: (0, $jPiXc.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $fjdBk.getUnavailableMessage)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $80CM7.messages).url),
            onClick: (0, $1ZWXY.commandWithMetadata)((0, $jPiXc.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $gkwXh.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $80CM7.messages).inline),
            onClick: (0, $jPiXc.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $53SzT.getDropdownOption)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $1ZWXY.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eZUJu.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
                            iconBefore: option.icon,
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eemXi.DatasourceDropdownOption), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: 'href' in settingsConfig ? settingsConfig.href : undefined,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $jDuvE.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $e9d7f97cc5d2cd82$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)($e9d7f97cc5d2cd82$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $eemXi.datasourceDisplayInformation) : (0, $67IYF.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};

});
parcelRegister("53SzT", function(module, exports) {

$parcel$export(module.exports, "getDropdownOption", () => $be2b867a85f9c047$export$1405b80fcb4301ca);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $67IYF = parcelRequire("67IYF");
const $be2b867a85f9c047$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: Icon } = (0, $67IYF.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? ''
    };
};

});

parcelRegister("eemXi", function(module, exports) {

$parcel$export(module.exports, "datasourceDisplayInformation", () => $e52ff811d8a6f815$export$12f82ee4a2a1a1c9);
$parcel$export(module.exports, "DatasourceDropdownOption", () => $e52ff811d8a6f815$export$b08a863b9d82986d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $80CM7 = parcelRequire("80CM7");

var $gZGBX = parcelRequire("gZGBX");

var $VNtxf = parcelRequire("VNtxf");

var $3WO4v = parcelRequire("3WO4v");

var $051X7 = parcelRequire("051X7");

var $kJpBP = parcelRequire("kJpBP");

var $jPiXc = parcelRequire("jPiXc");

var $lumM0 = parcelRequire("lumM0");

var $dYS3B = parcelRequire("dYS3B");
const $e52ff811d8a6f815$export$12f82ee4a2a1a1c9 = {
    title: (0, $80CM7.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($VNtxf))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($VNtxf)))
};
const $e52ff811d8a6f815$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $051X7.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $dYS3B.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $lumM0.pluginKey).getState(editorState);
        const newAdf = (0, $3WO4v.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $gZGBX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $jPiXc.updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($VNtxf)))({
            label: intl.formatMessage((0, $80CM7.messages).datasourceAppearanceTitle)
        }),
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $80CM7.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $80CM7.messages).datasourceAppearanceTitle));
};

});



parcelRegister("hv7lU", function(module, exports) {

$parcel$export(module.exports, "ToolbarViewedEvent", () => $95d14e1a206e7f9b$export$998ac2a59a1547dd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $051X7 = parcelRequire("051X7");

var $jPPkn = parcelRequire("jPPkn");

var $9NQiC = parcelRequire("9NQiC");
/**
 * Handles firing the toolbar viewed event
 */ const $95d14e1a206e7f9b$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...(0, $jPPkn.getResolvedAttributesFromStore)(url, display, store),
                display: display
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        display,
        url,
        store
    ]);
    return null;
};
const $95d14e1a206e7f9b$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $051X7.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9NQiC.EditorAnalyticsContext), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $2OMIu.jsx)($95d14e1a206e7f9b$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext
        }) : null
    });
};

});




parcelRegister("cVzPm", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => (parcelRequire("9UHJN")).clearMarksOnEmptyDocPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9UHJN = parcelRequire("9UHJN");

});
parcelRegister("9UHJN", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => $909665f51df345d6$export$30b76f1055cbb7e9);

var $5KWxh = parcelRequire("5KWxh");

var $ggL2v = parcelRequire("ggL2v");

var $gZGBX = parcelRequire("gZGBX");
const $909665f51df345d6$var$pluginKey = new (0, $gZGBX.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $909665f51df345d6$var$createPlugin() {
    return new (0, $5KWxh.SafePlugin)({
        key: $909665f51df345d6$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $ggL2v.isEmptyDocument)(oldState.doc) && (0, $ggL2v.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $909665f51df345d6$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $909665f51df345d6$var$createPlugin
                }
            ];
        }
    });

});


parcelRegister("oFSWG", function(module, exports) {

$parcel$export(module.exports, "clipboardPlugin", () => (parcelRequire("kd7KX")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kd7KX = parcelRequire("kd7KX");

});
parcelRegister("kd7KX", function(module, exports) {

$parcel$export(module.exports, "default", () => $281e1faf12170a31$export$2e2bcd8739ae039);

var $9Loj3 = parcelRequire("9Loj3");
const $281e1faf12170a31$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $9Loj3.createPlugin)(options)
                }
            ];
        }
    });
var $281e1faf12170a31$export$2e2bcd8739ae039 = $281e1faf12170a31$var$clipboard;

});
parcelRegister("9Loj3", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $bd4683358ea19f8e$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $cYcwl = parcelRequire("cYcwl");

var $5KWxh = parcelRequire("5KWxh");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $i9Yaa = parcelRequire("i9Yaa");
var $bd4683358ea19f8e$export$304e24f67740de29 = /*#__PURE__*/ function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
    return ClipboardEventType;
}({});
let $bd4683358ea19f8e$var$lastEventType = null;
const $bd4683358ea19f8e$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $i9Yaa.clipboardPluginKey),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $bd4683358ea19f8e$export$47cf4f31f028e0c9("CUT");
                    return $bd4683358ea19f8e$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $gkwXh.ACTION).CUT);
                },
                copy: (view)=>{
                    $bd4683358ea19f8e$export$47cf4f31f028e0c9("COPY");
                    return $bd4683358ea19f8e$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $gkwXh.ACTION).COPIED);
                }
            },
            clipboardSerializer: $bd4683358ea19f8e$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $bd4683358ea19f8e$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $kCV8T.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $kCV8T.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, target)=>{
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                if (content.maybeChild(i)?.type.name === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $5r0mK.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable?.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $kCV8T.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        // and keep existing content nodes from the parent.
        if ($bd4683358ea19f8e$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
            if ((0, $VSDnB.fg)('platform_editor_fix_captions_on_copy')) {
                // Content for media parents can include multiple content nodes (media and captions). We now take that
                // into consideration when we are stripping annotations
                let contentArray = [
                    strippedMediaNode
                ];
                content.forEach((node)=>{
                    if (node.type.name !== 'media') contentArray = [
                        ...contentArray,
                        node
                    ];
                });
                const newContent = (0, $kCV8T.Fragment).fromArray(contentArray);
                // Currently incorrectly typed, see comment above
                //@ts-ignore
                return originalSerializeFragment(newContent, options, target);
            } else {
                const newContent = (0, $kCV8T.Fragment).from(strippedMediaNode);
                // Currently incorrectly typed, see comment above
                //@ts-ignore
                return originalSerializeFragment(newContent, options, target);
            }
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $bd4683358ea19f8e$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $cYcwl.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $bd4683358ea19f8e$export$47cf4f31f028e0c9 = (eventType)=>$bd4683358ea19f8e$var$lastEventType = eventType;

});
parcelRegister("cYcwl", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", () => $e78f458911acd4e2$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $e78f458911acd4e2$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $e78f458911acd4e2$export$97e18ff8b98c7078);
$parcel$export(module.exports, "getAnalyticsPayload", () => $e78f458911acd4e2$export$4feda93c1c6b2d80);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $2x8Ci = parcelRequire("2x8Ci");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $8AlsS = parcelRequire("8AlsS");
const $e78f458911acd4e2$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $e78f458911acd4e2$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $e78f458911acd4e2$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $e78f458911acd4e2$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($e78f458911acd4e2$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($e78f458911acd4e2$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $e78f458911acd4e2$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($e78f458911acd4e2$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $e78f458911acd4e2$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $e78f458911acd4e2$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $2x8Ci.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $2x8Ci.write([
        dt
    ]);
};
const $e78f458911acd4e2$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $8AlsS.getNodeSelectionAnalyticsPayload)(selection) || (0, $8AlsS.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $8AlsS.getAllSelectionAnalyticsPayload)(selection) || (0, $8AlsS.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $gkwXh.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($e78f458911acd4e2$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($e78f458911acd4e2$var$isExtensionNode(node)) return {
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $gZGBX.TextSelection) && selection.$cursor) return {
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};

});
parcelRegister("2x8Ci", function(module, exports) {

$parcel$export(module.exports, "ClipboardItem", () => $1d8558ea290058b8$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $1d8558ea290058b8$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $1d8558ea290058b8$var$TEXT_PLAIN = "text/plain";
var $1d8558ea290058b8$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $1d8558ea290058b8$var$debugLogImpl = (s)=>{};
function $1d8558ea290058b8$var$debugLog(s) {
    $1d8558ea290058b8$var$debugLogImpl(s);
}
function $1d8558ea290058b8$export$e014146e87162c32(logFn) {
    $1d8558ea290058b8$var$debugLogImpl = logFn;
}
var $1d8558ea290058b8$var$showWarnings = true;
function $1d8558ea290058b8$export$ba5c9528becaaf25() {
    $1d8558ea290058b8$var$showWarnings = false;
}
function $1d8558ea290058b8$var$shouldShowWarnings() {
    return $1d8558ea290058b8$var$showWarnings;
}
function $1d8558ea290058b8$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $1d8558ea290058b8$var$warn = $1d8558ea290058b8$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $1d8558ea290058b8$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $1d8558ea290058b8$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $1d8558ea290058b8$var$_a, $1d8558ea290058b8$var$_b, $1d8558ea290058b8$var$_c;
var $1d8558ea290058b8$var$promiseConstructorImpl = ($1d8558ea290058b8$var$_c = ($1d8558ea290058b8$var$_a = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a.Promise) != null ? $1d8558ea290058b8$var$_c : ($1d8558ea290058b8$var$_b = $1d8558ea290058b8$var$originalGlobalThis) == null ? void 0 : $1d8558ea290058b8$var$_b.Promise;
function $1d8558ea290058b8$var$getPromiseConstructor() {
    if (!$1d8558ea290058b8$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $1d8558ea290058b8$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $1d8558ea290058b8$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $1d8558ea290058b8$var$originalNavigatorClipboard = $1d8558ea290058b8$var$originalNavigator == null ? void 0 : $1d8558ea290058b8$var$originalNavigator.clipboard;
var $1d8558ea290058b8$var$_a2;
var $1d8558ea290058b8$var$originalNavigatorClipboardRead = ($1d8558ea290058b8$var$_a2 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.read) == null ? void 0 : $1d8558ea290058b8$var$_a2.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a3;
var $1d8558ea290058b8$var$originalNavigatorClipboardReadText = ($1d8558ea290058b8$var$_a3 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.readText) == null ? void 0 : $1d8558ea290058b8$var$_a3.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a4;
var $1d8558ea290058b8$var$originalNavigatorClipboardWrite = ($1d8558ea290058b8$var$_a4 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.write) == null ? void 0 : $1d8558ea290058b8$var$_a4.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a5;
var $1d8558ea290058b8$var$originalNavigatorClipboardWriteText = ($1d8558ea290058b8$var$_a5 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.writeText) == null ? void 0 : $1d8558ea290058b8$var$_a5.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a6;
var $1d8558ea290058b8$var$originalWindowClipboardItem = ($1d8558ea290058b8$var$_a6 = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a6.ClipboardItem;
var $1d8558ea290058b8$var$promiseConstructor = $1d8558ea290058b8$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $1d8558ea290058b8$var$ieWindow = $1d8558ea290058b8$var$originalWindow;
function $1d8558ea290058b8$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData) !== "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $1d8558ea290058b8$var$writeTextIE(text) {
    if (!$1d8558ea290058b8$var$ieWindow.clipboardData) return false;
    var success = $1d8558ea290058b8$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $1d8558ea290058b8$var$debugLog("writeTextIE worked");
    return success;
}
function $1d8558ea290058b8$var$readTextIE() {
    if (!$1d8558ea290058b8$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $1d8558ea290058b8$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $1d8558ea290058b8$var$copyListener(tracker, data, e) {
    $1d8558ea290058b8$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $1d8558ea290058b8$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $1d8558ea290058b8$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $1d8558ea290058b8$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $1d8558ea290058b8$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $1d8558ea290058b8$var$copyUsingTempSelection(e, data) {
    $1d8558ea290058b8$var$selectionSet(e);
    var success = $1d8558ea290058b8$var$execCopy(data);
    $1d8558ea290058b8$var$selectionClear();
    return success;
}
function $1d8558ea290058b8$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $1d8558ea290058b8$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $1d8558ea290058b8$var$copyTextUsingDOM(str) {
    $1d8558ea290058b8$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $1d8558ea290058b8$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $1d8558ea290058b8$var$selectionSet(span);
    var result = document.execCommand("copy");
    $1d8558ea290058b8$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $1d8558ea290058b8$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $1d8558ea290058b8$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $1d8558ea290058b8$var$writeFallback(stringItem) {
    var hasTextPlain = $1d8558ea290058b8$var$TEXT_PLAIN in stringItem;
    if ($1d8558ea290058b8$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($1d8558ea290058b8$var$writeTextIE(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($1d8558ea290058b8$var$execCopy(stringItem)) {
        $1d8558ea290058b8$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $1d8558ea290058b8$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($1d8558ea290058b8$var$copyUsingTempSelection(document.body, stringItem)) {
        $1d8558ea290058b8$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($1d8558ea290058b8$var$copyUsingTempElem(stringItem)) {
        $1d8558ea290058b8$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($1d8558ea290058b8$var$copyTextUsingDOM(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) {
        $1d8558ea290058b8$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $1d8558ea290058b8$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $1d8558ea290058b8$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $1d8558ea290058b8$var$voidPromise = $1d8558ea290058b8$var$promiseConstructor.resolve();
var $1d8558ea290058b8$var$truePromiseFn = ()=>$1d8558ea290058b8$var$promiseConstructor.resolve(true);
var $1d8558ea290058b8$var$falsePromise = $1d8558ea290058b8$var$promiseConstructor.resolve(false);
function $1d8558ea290058b8$var$rejectThrownErrors(executor) {
    return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $1d8558ea290058b8$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$1d8558ea290058b8$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $1d8558ea290058b8$export$bec150f75a9b8f11(s) {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardWriteText) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardWriteText(s).catch($1d8558ea290058b8$var$writeTextStringFallback);
        }
        return $1d8558ea290058b8$var$promiseConstructor.resolve($1d8558ea290058b8$var$writeTextStringFallback(s));
    });
}
function $1d8558ea290058b8$var$writeTextStringFallback(s) {
    if (!$1d8558ea290058b8$var$writeFallback($1d8558ea290058b8$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $1d8558ea290058b8$export$bee0113684d8879b() {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardReadText) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardReadText();
        }
        if ($1d8558ea290058b8$var$seemToBeInIE()) {
            var result = $1d8558ea290058b8$var$readTextIE();
            return $1d8558ea290058b8$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $1d8558ea290058b8$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $1d8558ea290058b8$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $1d8558ea290058b8$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $1d8558ea290058b8$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $1d8558ea290058b8$export$3b1380c0957dc8fe = $1d8558ea290058b8$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $1d8558ea290058b8$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $1d8558ea290058b8$var$blobToString(blob) {
    return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $1d8558ea290058b8$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($1d8558ea290058b8$var$originalWindowClipboardItem) resolve(new $1d8558ea290058b8$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $1d8558ea290058b8$var$textToClipboardItem(text) {
    var items = {};
    items[$1d8558ea290058b8$var$TEXT_PLAIN] = $1d8558ea290058b8$var$stringToBlob(text, $1d8558ea290058b8$var$TEXT_PLAIN);
    return new $1d8558ea290058b8$export$3b1380c0957dc8fe(items);
}
function $1d8558ea290058b8$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $1d8558ea290058b8$var$blobToString(text);
    });
}
function $1d8558ea290058b8$var$toStringItem(data) {
    return $1d8558ea290058b8$var$promiseRecordMap(data.types, function(type) {
        return $1d8558ea290058b8$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $1d8558ea290058b8$export$68d8715fc104d294(data) {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardWrite && $1d8558ea290058b8$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $1d8558ea290058b8$var$originalNavigatorClipboardWrite;
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.write()`.");
            return $1d8558ea290058b8$var$promiseConstructor.all(data.map($1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($1d8558ea290058b8$var$truePromiseFn).catch((e)=>{
                    if (!$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN) && !$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_HTML)) throw e;
                    return $1d8558ea290058b8$var$falsePromise;
                });
            });
        }
        return $1d8558ea290058b8$var$falsePromise;
    }).then((success)=>{
        if (success) return $1d8558ea290058b8$var$voidPromise;
        var hasTextPlain = $1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN);
        if ($1d8558ea290058b8$var$shouldShowWarnings() && !hasTextPlain) $1d8558ea290058b8$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $1d8558ea290058b8$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$1d8558ea290058b8$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $1d8558ea290058b8$export$aafa59e2e03f2942() {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardRead) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.read()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardRead();
        }
        return $1d8558ea290058b8$export$bee0113684d8879b().then((text)=>{
            return [
                $1d8558ea290058b8$var$textToClipboardItem(text)
            ];
        });
    });
}

});

parcelRegister("8AlsS", function(module, exports) {

$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $09b21fe82b545f9f$export$563f7987ca7936f1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $hHsVB = parcelRequire("hHsVB");

var $gkwXh = parcelRequire("gkwXh");

var $6MkyM = parcelRequire("6MkyM");

var $hPjvp = parcelRequire("hPjvp");

var $5Vvw4 = parcelRequire("5Vvw4");

var $3jyjs = parcelRequire("3jyjs");

var $2xQXF = parcelRequire("2xQXF");

var $fMoO3 = parcelRequire("fMoO3");

var $eAVGd = parcelRequire("eAVGd");

var $k6Y9i = parcelRequire("k6Y9i");
function $09b21fe82b545f9f$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $gZGBX.NodeSelection)) return {
        action: (0, $gkwXh.ACTION).SELECTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $09b21fe82b545f9f$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $gZGBX.AllSelection)) return {
        action: (0, $gkwXh.ACTION).SELECTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
}
function $09b21fe82b545f9f$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $hFEwm.CellSelection)) {
        const rect = (0, $hHsVB.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $09b21fe82b545f9f$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $gZGBX.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $09b21fe82b545f9f$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $gZGBX.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $09b21fe82b545f9f$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $09b21fe82b545f9f$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("hHsVB", function(module, exports) {

$parcel$export(module.exports, "selectedRect", () => $78cade064f4edb3a$export$39ce22e69aa9ed17);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $22PoI = parcelRequire("22PoI");
function $78cade064f4edb3a$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $22PoI.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $hFEwm.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("22PoI", function(module, exports) {

$parcel$export(module.exports, "selectionCell", () => $6e0c68deaeecd60c$export$aad75348c8f2d244);

var $6hQQ3 = parcelRequire("6hQQ3");

var $iGxzn = parcelRequire("iGxzn");
function $6e0c68deaeecd60c$export$aad75348c8f2d244(selection) {
    if ((0, $iGxzn.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $iGxzn.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $6hQQ3.cellAround)(selection.$head) || (0, $6hQQ3.cellNear)(selection.$head);
}

});
parcelRegister("iGxzn", function(module, exports) {

$parcel$export(module.exports, "isSelectionType", () => $a99399272acf3f8b$export$626dcc173023aed7);
function $a99399272acf3f8b$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("6MkyM", function(module, exports) {

$parcel$export(module.exports, "RelativeSelectionPos", () => $1e3782577a66fd65$export$cb9005d223ae8de7);
var $1e3782577a66fd65$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});

});

parcelRegister("fMoO3", function(module, exports) {

$parcel$export(module.exports, "setGapCursorSelection", () => $860240a1613ee906$export$a8946811e8b82dd);

var $hPjvp = parcelRequire("hPjvp");
function $860240a1613ee906$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});

parcelRegister("k6Y9i", function(module, exports) {

$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $2aa2babce658057c$export$2543715425b0bf0b);
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $2aa2babce658057c$export$5762916b8b83bc6d);
$parcel$export(module.exports, "atTheEndOfDoc", () => $2aa2babce658057c$export$4ca816540352da02);
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $2aa2babce658057c$export$e9083e8cbe24bec0);
$parcel$export(module.exports, "atTheEndOfBlock", () => $2aa2babce658057c$export$6f303ca7dac350ae);
$parcel$export(module.exports, "endPositionOfParent", () => $2aa2babce658057c$export$8e09b50c60354750);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $2aa2babce658057c$export$8351d833af62ae68);
$parcel$export(module.exports, "startPositionOfParent", () => $2aa2babce658057c$export$ced77c72038c89cb);

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $hPjvp = parcelRequire("hPjvp");
const $2aa2babce658057c$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
const $2aa2babce658057c$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
function $2aa2babce658057c$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $2aa2babce658057c$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
function $2aa2babce658057c$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return false;
    if (selection instanceof (0, $gZGBX.NodeSelection) && selection.node.isBlock) return true;
    return $2aa2babce658057c$export$8e09b50c60354750($to) === $to.pos + 1;
}
function $2aa2babce658057c$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return false;
    if (selection instanceof (0, $gZGBX.NodeSelection) && selection.node.isBlock) return true;
    return $2aa2babce658057c$export$ced77c72038c89cb($from) === $from.pos;
}
function $2aa2babce658057c$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function $2aa2babce658057c$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
const $2aa2babce658057c$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = fromDepth ? $from.before() : $from.pos;
            selectionEnd = fromDepth ? $to.after(fromDepth) : $to.after(1);
        }
    } else if (toDepth < fromDepth) {
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = toDepth ? $from.before(toDepth) : $from.before(1);
            selectionEnd = toDepth ? $to.after() : $to.pos;
        }
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = $from.before(fromDepth - 1);
            selectionEnd = $to.after(toDepth - 1);
        }
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};

});



parcelRegister("i9Yaa", function(module, exports) {

$parcel$export(module.exports, "clipboardPluginKey", () => $e8931e12a5242325$export$7ff3d0e65871bad3);

var $gZGBX = parcelRequire("gZGBX");
const $e8931e12a5242325$export$7ff3d0e65871bad3 = new (0, $gZGBX.PluginKey)('clipboardPlugin');

});




parcelRegister("ceDVv", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => (parcelRequire("izJY1")).compositionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $izJY1 = parcelRequire("izJY1");

});
parcelRegister("izJY1", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => $fe0d4250ae554ed9$export$afd1652ef5208b);

var $fuDg1 = parcelRequire("fuDg1");

var $4gJQv = parcelRequire("4gJQv");
const $fe0d4250ae554ed9$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $4gJQv.pluginKey).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $fuDg1.default)()
                }
            ];
        }
    };
};

});
parcelRegister("fuDg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e0db51e3a44ecc7$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");


var $4gJQv = parcelRequire("4gJQv");
const $1e0db51e3a44ecc7$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $1e0db51e3a44ecc7$export$2e2bcd8739ae039 = ()=>new (0, $5KWxh.SafePlugin)({
        key: (0, $4gJQv.pluginKey),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $4gJQv.pluginKey));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $4gJQv.pluginKey), true);
                    // only apply for linux and cursor is at start of line
                    if ($1e0db51e3a44ecc7$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $0f804702eb36dd5e$export$15a09f5ef055bcfa));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $4gJQv.pluginKey), false);
                    if ($1e0db51e3a44ecc7$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $4gJQv.pluginKey).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });

});
parcelRegister("4gJQv", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $f06bf058060e8acd$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $f06bf058060e8acd$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('compositionPlugin');

});




parcelRegister("gmJvQ", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => (parcelRequire("jnbcS")).copyButtonPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jnbcS = parcelRequire("jnbcS");

});
parcelRegister("jnbcS", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => $bcfd81dd8839116d$export$ea22bdb37423f02c);

var $9RYlU = parcelRequire("9RYlU");

var $48EvW = parcelRequire("48EvW");
const $bcfd81dd8839116d$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $9RYlU.default)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $48EvW.processCopyButtonItems)(api?.analytics?.actions, api)
        }
    });

});
parcelRegister("9RYlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0493fd9b5d8c1e6b$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");

var $5c8Iv = parcelRequire("5c8Iv");
function $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $0493fd9b5d8c1e6b$export$ea22bdb37423f02c() {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $5c8Iv.copyButtonPluginKey),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $5c8Iv.copyButtonPluginKey));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $etG8M.DecorationSet).empty;
            }
        }
    });
}
var $0493fd9b5d8c1e6b$export$2e2bcd8739ae039 = $0493fd9b5d8c1e6b$export$ea22bdb37423f02c;

});
parcelRegister("5c8Iv", function(module, exports) {

$parcel$export(module.exports, "copyButtonPluginKey", () => $83f9fb1f851039a9$export$e41a18c2cdafffa9);

var $gZGBX = parcelRequire("gZGBX");
const $83f9fb1f851039a9$export$e41a18c2cdafffa9 = new (0, $gZGBX.PluginKey)('copyButtonPlugin');

});


parcelRegister("48EvW", function(module, exports) {

$parcel$export(module.exports, "processCopyButtonItems", () => $79fea903647c241d$export$f61ed03c42ac876f);

var $8DYpW = parcelRequire("8DYpW");

var $3Fq5M = parcelRequire("3Fq5M");

var $40riH = parcelRequire("40riH");

var $5c8Iv = parcelRequire("5c8Iv");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $79fea903647c241d$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $79fea903647c241d$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
function $79fea903647c241d$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $5c8Iv.copyButtonPluginKey).getState(state);
    let buttonActionHandlers;
    if ($79fea903647c241d$var$isNodeOptions(options)) buttonActionHandlers = {
        onClick: (0, $40riH.createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $8DYpW.default).copiedToClipboard)),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseLeave: (0, $40riH.resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
        onBlur: (0, $40riH.resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
    };
    else buttonActionHandlers = {
        onClick: (0, $40riH.createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $40riH.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onFocus: (0, $40riH.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onMouseLeave: (0, $40riH.removeMarkVisualFeedbackForCopyButtonCommand),
        onBlur: (0, $40riH.removeMarkVisualFeedbackForCopyButtonCommand)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        title: formatMessage(copyButtonState?.copied ? (0, $8DYpW.default).copiedToClipboard : (0, $8DYpW.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $79fea903647c241d$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$79fea903647c241d$var$isSeparator(copyButtonItem) ? copyButtonItem : $79fea903647c241d$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };

});
parcelRegister("40riH", function(module, exports) {

$parcel$export(module.exports, "createToolbarCopyCommandForMark", () => $5dfad2b63514853f$export$61f33363e77ed28);
$parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", () => $5dfad2b63514853f$export$5887c7b152626490);
$parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", () => $5dfad2b63514853f$export$e52b1d5c60d367b8);
$parcel$export(module.exports, "createToolbarCopyCommandForNode", () => $5dfad2b63514853f$export$be806b3b778a7682);
$parcel$export(module.exports, "resetCopiedState", () => $5dfad2b63514853f$export$3e0b07341e7576a);

var $gkwXh = parcelRequire("gkwXh");

var $gE8f9 = parcelRequire("gE8f9");

var $cYcwl = parcelRequire("cYcwl");

var $SYwgb = parcelRequire("SYwgb");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $5c8Iv = parcelRequire("5c8Iv");
function $5dfad2b63514853f$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $SYwgb.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $cYcwl.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, $cYcwl.getAnalyticsPayload)(state, (0, $gkwXh.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $gkwXh.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $5dfad2b63514853f$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $5dfad2b63514853f$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
        removeSelection: true
    });
    const copyButtonState = (0, $5c8Iv.copyButtonPluginKey).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $5dfad2b63514853f$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $SYwgb.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
            copied: true
        });
        const analyticsPayload = (0, $cYcwl.getAnalyticsPayload)(state, (0, $gkwXh.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $gkwXh.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $SYwgb.toDOM)(contentNodeWithPos.node, schema);
            if (domNode) {
                const div = document.createElement('div');
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if ((0, $gE8f9.browser).safari && state.selection instanceof (0, $gZGBX.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $cYcwl.copyHTMLToClipboardPolyfill)(div);
                else (0, $cYcwl.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
		 * A11y-10275 This prop api drilled from the plugin all the way down to the usage
		 * because it's the safest way to ensure accessibilityUtils is available and not
		 * undefined.
		 *
		 * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
		 */ if (onClickMessage && (0, $VSDnB.fg)('editor_a11y_aria_announcement_for_copied_status')) api?.accessibilityUtils?.actions.ariaNotify(onClickMessage, {
            priority: 'important'
        });
        return true;
    };
const $5dfad2b63514853f$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $5c8Iv.copyButtonPluginKey).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };

});
parcelRegister("SYwgb", function(module, exports) {

$parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", () => $ca84f4e43934dc04$export$64477bc469482fd0);
$parcel$export(module.exports, "toDOM", () => $ca84f4e43934dc04$export$289411c5a7970646);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");
function $ca84f4e43934dc04$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $5r0mK.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $5r0mK.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $ca84f4e43934dc04$export$289411c5a7970646 = (node, schema)=>{
    return (0, $kCV8T.DOMSerializer).fromSchema(schema).serializeNode(node);
};

});





parcelRegister("3wlyh", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => (parcelRequire("IBShN")).decorationsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $IBShN = parcelRequire("IBShN");

});
parcelRegister("IBShN", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => $06578ce7d2c93dd5$export$1c07ef1814918eb5);

var $lljQA = parcelRequire("lljQA");
const $06578ce7d2c93dd5$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $lljQA.default)()
                }
            ];
        },
        actions: {
            hoverDecoration: $lljQA.hoverDecoration,
            removeDecoration: $lljQA.removeDecoration
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $lljQA.decorationStateKey).getState(editorState);
        }
    });

});
parcelRegister("lljQA", function(module, exports) {

$parcel$export(module.exports, "decorationStateKey", () => $c34271d73c40a7ed$export$385f768f10dabdd5);
$parcel$export(module.exports, "removeDecoration", () => $c34271d73c40a7ed$export$ea377ae2b4b58797);
$parcel$export(module.exports, "hoverDecoration", () => $c34271d73c40a7ed$export$fbf24964a8aac61c);
$parcel$export(module.exports, "default", () => $c34271d73c40a7ed$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");
const $c34271d73c40a7ed$export$385f768f10dabdd5 = new (0, $gZGBX.PluginKey)('decorationPlugin');
var $c34271d73c40a7ed$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $c34271d73c40a7ed$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    if (dispatch) {
        dispatch(tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $c34271d73c40a7ed$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $gZGBX.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $5r0mK.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $etG8M.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $c34271d73c40a7ed$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $c34271d73c40a7ed$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                const meta = tr.getMeta($c34271d73c40a7ed$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data
                        };
                    case 1:
                        return {
                            decoration: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $c34271d73c40a7ed$export$385f768f10dabdd5.getState(state);
                if (decoration) return (0, $etG8M.DecorationSet).create(doc, [
                    decoration
                ]);
                return null;
            }
        }
    });
};

});



parcelRegister("6mXgW", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => (parcelRequire("2U5eR")).editorDisabledPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2U5eR = parcelRequire("2U5eR");

});
parcelRegister("2U5eR", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => $c155798ed80d2453$export$db5fb3a4c4390f03);

var $7nRxN = parcelRequire("7nRxN");

var $5KWxh = parcelRequire("5KWxh");

var $aOimD = parcelRequire("aOimD");

var $gZGBX = parcelRequire("gZGBX");
const $c155798ed80d2453$var$pluginKey = new (0, $gZGBX.PluginKey)('editorDisabledPlugin');
function $c155798ed80d2453$var$reducer(_pluginState, meta) {
    return meta;
}
const { createPluginState: $c155798ed80d2453$var$createPluginState, getPluginState: $c155798ed80d2453$var$getPluginState } = (0, $aOimD.pluginFactory)($c155798ed80d2453$var$pluginKey, $c155798ed80d2453$var$reducer);
const $c155798ed80d2453$var$scheduleEditorDisabledUpdate = (0, $7nRxN.default)((view)=>{
    if ($c155798ed80d2453$var$getPluginState(view.state).editorDisabled !== !view.editable) {
        const tr = view.state.tr.setMeta($c155798ed80d2453$var$pluginKey, {
            editorDisabled: !view.editable
        });
        tr.setMeta('isLocal', true);
        view.dispatch(tr);
    }
});
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $c155798ed80d2453$var$createPlugin(dispatch) {
    return new (0, $5KWxh.SafePlugin)({
        key: $c155798ed80d2453$var$pluginKey,
        state: $c155798ed80d2453$var$createPluginState(dispatch, {
            editorDisabled: false
        }),
        view: ()=>{
            return {
                update (view) {
                    $c155798ed80d2453$var$scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    $c155798ed80d2453$var$scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $c155798ed80d2453$export$db5fb3a4c4390f03 = ()=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $c155798ed80d2453$var$pluginKey.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return pluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$c155798ed80d2453$var$createPlugin(dispatch)
                }
            ]
    });

});


parcelRegister("5I6Ej", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => (parcelRequire("hcXgl")).featureFlagsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hcXgl = parcelRequire("hcXgl");

});
parcelRegister("hcXgl", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => $6a38cf89b91e3e9a$export$79626a094e303f80);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $6a38cf89b91e3e9a$var$pluginKey = new (0, $gZGBX.PluginKey)('featureFlags');
const $6a38cf89b91e3e9a$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $6a38cf89b91e3e9a$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $5KWxh.SafePlugin)({
                            key: $6a38cf89b91e3e9a$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });

});


parcelRegister("2fcyF", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => (parcelRequire("1bV4T")).floatingToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1bV4T = parcelRequire("1bV4T");

});
parcelRegister("1bV4T", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => $e87d40a96b12aa71$export$baed971c987bc0e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $gkwXh = parcelRequire("gkwXh");

var $9pOon = parcelRequire("9pOon");

var $awTmI = parcelRequire("awTmI");

var $9Egzu = parcelRequire("9Egzu");

var $5KWxh = parcelRequire("5KWxh");

var $4N9VB = parcelRequire("4N9VB");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $c2Qhg = parcelRequire("c2Qhg");

var $3FjQE = parcelRequire("3FjQE");

var $bZuB7 = parcelRequire("bZuB7");

var $8gLmf = parcelRequire("8gLmf");

var $9NIbV = parcelRequire("9NIbV");

var $lPuFS = parcelRequire("lPuFS");

var $g0hjU = parcelRequire("g0hjU");

var $lv3rb = parcelRequire("lv3rb");

var $7uxXk = parcelRequire("7uxXk");

var $eFn4q = parcelRequire("eFn4q");
const $e87d40a96b12aa71$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $5r0mK.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $gZGBX.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $lPuFS.findNode)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $e87d40a96b12aa71$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $5r0mK.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).ERRORED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $gkwXh.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $e87d40a96b12aa71$var$filterUndefined(x) {
    return !!x;
}
const $e87d40a96b12aa71$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$e87d40a96b12aa71$export$5c1ec0ef773ca0cc({
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $8gLmf.createPlugin)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $3FjQE.default)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $3FjQE.forceFocusSelector
        },
        commands: {
            copyNode: (nodeType)=>(0, $c2Qhg.copyNode)(nodeType)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const hasHadInteraction = api?.interaction?.sharedState.currentState()?.hasHadInteraction;
            let configWithNodeInfo;
            if ((0, $VSDnB.fg)('platform_editor_no_selection_until_interaction')) configWithNodeInfo = hasHadInteraction !== false ? $e87d40a96b12aa71$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined : undefined;
            else configWithNodeInfo = $e87d40a96b12aa71$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $9NIbV.pluginKey).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)($e87d40a96b12aa71$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $e87d40a96b12aa71$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState, blockControlsState: // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
    blockControlsState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent',
        // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
        'blockControls'
    ]);
    const { configWithNodeInfo: configWithNodeInfo, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    if ((0, $VSDnB.fg)('platform_editor_user_intent_plugin')) {
        if (userIntentState?.currentUserIntent === 'dragging') return null;
    // TODO: ED-27539 - This feature is unreleased and rendering logic needs to be move userIntentState which is not ready yet
    // if (blockControlsState?.isMenuOpen && editorExperiment('platform_editor_controls', 'variant1')) {
    // 	return null;
    // }
    } else {
        if (blockControlsState?.isDragging) return null;
        if (blockControlsState?.isMenuOpen && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) return null;
    }
    const { config: config, node: node } = configWithNodeInfo;
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $e87d40a96b12aa71$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = editorViewModeState?.mode === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : items?.(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) {
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : items?.(node);
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $eFn4q.consolidateOverflowDropdownItems)(overflowDropdownItems);
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(otherItems.at(-1)?.type === 'separator')otherItems.pop();
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    const viewModeToolbarEntry = (0, $gmhCD.unstable_editorExperimentParam)('live_pages_graceful_edit', 'toolbar-entry', {
        defaultValue: 'none',
        typeGuard: (value)=>typeof value === 'string' && [
                'text',
                'nodes'
            ].includes(value)
    });
    if (!(0, $gmhCD.editorExperiment)('live_pages_graceful_edit', 'control') && viewModeToolbarEntry !== 'none') {
        if (editorViewModeState?.contentMode === 'live-edit' && editorViewModeState?.isConsumption) {
            const hasOtherToolbarItems = toolbarItems && toolbarItems.length !== 0;
            const shouldAddToolbarItems = viewModeToolbarEntry === 'expand-existing-only' ? hasOtherToolbarItems : true;
            if (shouldAddToolbarItems) {
                if (toolbarItems && toolbarItems.length > 0) toolbarItems.unshift({
                    type: 'separator'
                });
                toolbarItems?.unshift({
                    type: 'button',
                    title: 'Edit',
                    onClick: ()=>{
                        pluginInjectionApi?.core?.actions?.execute(pluginInjectionApi?.editorViewMode?.commands.updateContentMode({
                            type: 'intent-to-edit'
                        }));
                        return false;
                    },
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lv3rb.ExpandButton), {})
                });
            }
        }
    }
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    const { confirmDialogForItem: confirmDialogForItem } = floatingToolbarData || {};
    const confirmButtonItem = confirmDialogForItem ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    toolbarItems[confirmDialogForItem] : undefined;
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9pOon.ErrorBoundary), {
        component: (0, $gkwXh.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
                ariaLabel: title,
                offset: offset,
                target: targetRef,
                alignY: "bottom",
                forcePlacement: forcePlacement,
                fitHeight: height,
                fitWidth: width,
                absoluteOffset: absoluteOffset,
                alignX: align,
                stick: stick,
                zIndex: zIndex,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onPositionCalculated: customPositionCalculation,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: scrollable ? {
                    maxWidth: '100%'
                } : {},
                focusTrap: focusTrap,
                preventOverflow: preventPopupOverflow,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
                    providerFactory: providerFactory,
                    providers: [
                        'extensionProvider'
                    ],
                    renderNode: (providers)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uxXk.ToolbarLoader), {
                            target: targetRef,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            items: toolbarItems,
                            groupLabel: groupLabel,
                            node: node,
                            dispatchCommand: dispatchCommand,
                            editorView: editorView,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: className,
                            focusEditor: ()=>editorView.focus(),
                            providerFactory: providerFactory,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            extensionsProvider: providers.extensionProvider,
                            scrollable: scrollable,
                            api: pluginInjectionApi,
                            mediaAssistiveMessage: mediaAssistiveMessage
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0hjU.ConfirmationModal), {
                testId: "ak-floating-toolbar-confirmation-modal",
                options: confirmDialogOptions,
                onConfirm: (isChecked = false)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmButtonItem.onClick);
                },
                onClose: ()=>{
                    dispatchCommand((0, $bZuB7.hideConfirmDialog)());
                    // Need to set focus to Editor here,
                    // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
                    // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
                    // instead of the cursor position before the dialog pop up.
                    if (!editorView.hasFocus()) editorView.focus();
                }
            })
        ]
    });
}
const $e87d40a96b12aa71$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $e87d40a96b12aa71$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($e87d40a96b12aa71$var$filterUndefined)
    };
    return config;
}
function $e87d40a96b12aa71$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                if (config.__suppressAllToolbars && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($e87d40a96b12aa71$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $e87d40a96b12aa71$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $5KWxh.SafePlugin)({
        key: $e87d40a96b12aa71$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                // Use this point to preload the UI
                (0, $7uxXk.ToolbarLoader).preload();
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: apply
        }
    });
}

});
parcelRegister("c2Qhg", function(module, exports) {

$parcel$export(module.exports, "copyNode", () => $a08d499b9c4de77f$export$978ef9948557240e);

var $gE8f9 = parcelRequire("gE8f9");

var $cYcwl = parcelRequire("cYcwl");

var $SYwgb = parcelRequire("SYwgb");

var $gZGBX = parcelRequire("gZGBX");
const $a08d499b9c4de77f$export$978ef9948557240e = (nodeType, editorAnalyticsAp)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $SYwgb.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $SYwgb.toDOM)(contentNodeWithPos.node, schema);
        if (domNode) {
            const div = document.createElement('div');
            div.appendChild(domNode);
            // if copying inline content
            if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
            // since we're copying the text inside a paragraph, it will always be 1 1
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '1 1 []');
            else // The "0 0" refers to the start and end depth of the slice
            // since we're copying the block node only, it will always be 0 0
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
            // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
            if ((0, $gE8f9.browser).safari && tr.selection instanceof (0, $gZGBX.NodeSelection) && (tr.selection.node.type === schema.nodes.extension || tr.selection.node.type === schema.nodes.mediaSingle)) (0, $cYcwl.copyHTMLToClipboardPolyfill)(div);
            else (0, $cYcwl.copyHTMLToClipboard)(div);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };

});

parcelRegister("3FjQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $678344aaf110db44$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forceFocusSelector", () => $678344aaf110db44$export$1470545de94762f5);
$parcel$export(module.exports, "checkShouldForceFocusAndApply", () => $678344aaf110db44$export$a2ced8424a9be595);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $678344aaf110db44$export$ded15a80767f6af7 = new (0, $gZGBX.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $678344aaf110db44$export$2e2bcd8739ae039 = ()=>new (0, $5KWxh.SafePlugin)({
        key: $678344aaf110db44$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($678344aaf110db44$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $678344aaf110db44$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($678344aaf110db44$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $678344aaf110db44$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $678344aaf110db44$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($678344aaf110db44$export$1470545de94762f5(null)(tr));
            }
        }
    }
}

});

parcelRegister("bZuB7", function(module, exports) {

$parcel$export(module.exports, "showConfirmDialog", () => $631febdcbf84957f$export$c0076bd4afc29e7a);
$parcel$export(module.exports, "hideConfirmDialog", () => $631febdcbf84957f$export$5a3c1357cfd1045c);

var $6ka1z = parcelRequire("6ka1z");
const $631febdcbf84957f$export$c0076bd4afc29e7a = (buttonIndex)=>(0, $6ka1z.createCommand)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $631febdcbf84957f$export$5a3c1357cfd1045c = ()=>(0, $6ka1z.createCommand)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("6ka1z", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $5a9052fdd4f97f79$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $5a9052fdd4f97f79$export$8d4021544bdece00);

var $aOimD = parcelRequire("aOimD");

var $9NIbV = parcelRequire("9NIbV");

var $iT6WM = parcelRequire("iT6WM");
const { createPluginState: $5a9052fdd4f97f79$export$656c7661095efe2e, createCommand: $5a9052fdd4f97f79$export$8d4021544bdece00, getPluginState: $5a9052fdd4f97f79$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $9NIbV.pluginKey), (0, $iT6WM.reducer));

});
parcelRegister("9NIbV", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $9835a39d0d550488$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $9835a39d0d550488$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('floatingToolbarData');

});

parcelRegister("iT6WM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $ac14a01a9a722e87$export$1650419e431d3ba3);
const $ac14a01a9a722e87$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("8gLmf", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a3032e30bd40b708$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $6ka1z = parcelRequire("6ka1z");

var $9NIbV = parcelRequire("9NIbV");
const $a3032e30bd40b708$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $5KWxh.SafePlugin)({
        state: (0, $6ka1z.createPluginState)(dispatch, {}),
        key: (0, $9NIbV.pluginKey)
    });
};

});

parcelRegister("lPuFS", function(module, exports) {

$parcel$export(module.exports, "findNode", () => $a9058a265ed6ea0d$export$5b92d7a8b5d33ee2);
function $a9058a265ed6ea0d$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}

});

parcelRegister("g0hjU", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $06e379d09049f01c$export$1f33f980da756c46);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $i8Qvm = parcelRequire("i8Qvm");

var $f9HzI = parcelRequire("f9HzI");

var $gKJRF = parcelRequire("gKJRF");
const $06e379d09049f01c$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f9HzI.CheckboxModal), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gKJRF.SimpleModal), {
            ...props
        });
    return options ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: renderModel(options?.isReferentialityDialog)
    }) : null;
};
const $06e379d09049f01c$export$1f33f980da756c46 = (0, $8RXs9.default)($06e379d09049f01c$var$ConfirmationModalImpl);

});
parcelRegister("f9HzI", function(module, exports) {

$parcel$export(module.exports, "CheckboxModal", () => $2670a3f256ccd0e9$export$9c828de50258a892);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $kkJfY = parcelRequire("kkJfY");

var $5K8Ey = parcelRequire("5K8Ey");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dS3PR = parcelRequire("dS3PR");
const $2670a3f256ccd0e9$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $5uXOq.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $5K8Ey.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
            children: nodes.map((node)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $5uXOq.createElement)(ListItem, {
                    ...node,
                    key: node.id
                }))
        });
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
            id: id,
            children: formatMessage((0, $5K8Ey.default).confirmModalListUnit, {
                name: name,
                amount: amount
            })
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        children: options?.message
                    }),
                    !!childrenInfo?.length && /*#__PURE__*/ (0, $2OMIu.jsx)(ListComponent, {
                        nodes: childrenInfo
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkJfY.default), {
                            isChecked: isChecked,
                            onChange: ()=>setCheckbox(!isChecked),
                            label: checkboxlabel,
                            testId: testId ? `${testId}-checkbox` : undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm(isChecked);
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5K8Ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aa315cef11144c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1aa315cef11144c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmModalDefaultHeading: {
        id: 'fabric.editor.floatingToolbar.confirmModalHeading',
        defaultMessage: 'Are you sure?',
        description: 'Default heading of floating toolbar confirmation modal.'
    },
    confirmModalOK: {
        id: 'fabric.editor.floatingToolbar.confirmModalOK',
        defaultMessage: 'OK',
        description: 'OK button for floating toolbar confirmation modal.'
    },
    confirmModalCancel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for floating toolbar confirmation modal.'
    },
    confirmModalListUnit: {
        id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
        defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
        description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    floatingToolbarAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
        defaultMessage: 'Floating Toolbar',
        description: "a floating toolbar's aria label"
    },
    floatingToolbarAnnouncer: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
        defaultMessage: 'Floating toolbar controls have been opened',
        description: 'message that will be announced to screenreaders that the floating toolbar is opened'
    },
    floatingToolbarScrollLeft: {
        id: 'fabric.editor.floatingToolbar.scrollLeft',
        defaultMessage: 'Scroll left',
        description: 'Button to scroll left when the toolbar is in the overflow state'
    },
    floatingToolbarScrollRight: {
        id: 'fabric.editor.floatingToolbar.scrollRight',
        defaultMessage: 'Scroll right',
        description: 'Button to scroll right when the toolbar is in the overflow state'
    }
});

});


parcelRegister("gKJRF", function(module, exports) {

$parcel$export(module.exports, "SimpleModal", () => $09c3f293e9a8351d$export$f96c193e316d2274);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $5K8Ey = parcelRequire("5K8Ey");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dS3PR = parcelRequire("dS3PR");
const $09c3f293e9a8351d$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $5K8Ey.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalCancel);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    as: "p",
                    children: options?.message
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm();
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("lv3rb", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $2f3aaf7d1b991476$export$5663c8f5aeb8c1c4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3dGN0 = parcelRequire("3dGN0");

var $MHKc7 = parcelRequire("MHKc7");
function $2f3aaf7d1b991476$export$5663c8f5aeb8c1c4() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.075",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
            label: 'Edit'
        })
    });
}

});

parcelRegister("7uxXk", function(module, exports) {

$parcel$export(module.exports, "ToolbarLoader", () => $f13a9dac652e34d3$export$8f0e0160298415aa);

var $4qBtX = parcelRequire("4qBtX");

const $f13a9dac652e34d3$export$8f0e0160298415aa = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("9d81d")).then((mod)=>mod.default),
    loading: ()=>null
});

});
parcelRegister("9d81d", function(module, exports) {

let $6b4b8c4c08433194$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6b4b8c4c08433194$var$load("cM9em"),
    $6b4b8c4c08433194$var$load("fr9NE"),
    $6b4b8c4c08433194$var$load("7iFrB")
]).then(()=>parcelRequire('4vSmI'));

});


parcelRegister("eFn4q", function(module, exports) {

$parcel$export(module.exports, "consolidateOverflowDropdownItems", () => $00caf0f0e1fb7061$export$2f5751d7b477f660);
const $00caf0f0e1fb7061$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};

});



parcelRegister("7bJco", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => (parcelRequire("4y8T6")).focusPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4y8T6 = parcelRequire("4y8T6");

});
parcelRegister("4y8T6", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => $3a3c0b11abeb4fe9$export$78540d08bd386fba);

var $6N2wx = parcelRequire("6N2wx");
const $3a3c0b11abeb4fe9$export$78540d08bd386fba = ({ api: api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((0, $6N2wx.key).getState(editorState)?.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $6N2wx.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("6N2wx", function(module, exports) {

$parcel$export(module.exports, "key", () => $e2f10d9885742530$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $e2f10d9885742530$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $e2f10d9885742530$export$df61b30b684217c0 = new (0, $gZGBX.PluginKey)('focusPluginHandler');
const $e2f10d9885742530$export$ae829ec7b2625219 = ()=>new (0, $5KWxh.SafePlugin)({
        key: $e2f10d9885742530$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($e2f10d9885742530$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $e2f10d9885742530$export$df61b30b684217c0.getState(view.state);
                    if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($e2f10d9885742530$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $e2f10d9885742530$export$df61b30b684217c0.getState(view.state);
                    if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($e2f10d9885742530$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });

});



parcelRegister("hrqyH", function(module, exports) {

$parcel$export(module.exports, "gridPlugin", () => (parcelRequire("3Cy5z")).gridPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3Cy5z = parcelRequire("3Cy5z");

});
parcelRegister("3Cy5z", function(module, exports) {

$parcel$export(module.exports, "gridPlugin", () => $b9e802bd96c49e18$export$c090e341e8f725a9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $9ci4W = parcelRequire("9ci4W");

var $awTmI = parcelRequire("awTmI");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $iHYdz = parcelRequire("iHYdz");
const $b9e802bd96c49e18$export$bc90872e265d166e = 12;
const $b9e802bd96c49e18$var$key = new (0, $gZGBX.PluginKey)('gridPlugin');
const $b9e802bd96c49e18$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($b9e802bd96c49e18$var$key, props);
        dispatch(tr);
        return true;
    };
const $b9e802bd96c49e18$var$sides = [
    'left',
    'right'
];
const $b9e802bd96c49e18$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $b9e802bd96c49e18$export$bc90872e265d166e && maxHighlight >= $b9e802bd96c49e18$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $b9e802bd96c49e18$export$bc90872e265d166e + size : true);
};
const $b9e802bd96c49e18$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $iHYdz.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $b9e802bd96c49e18$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('gridLine', $b9e802bd96c49e18$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $iHYdz.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $b9e802bd96c49e18$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $b9e802bd96c49e18$export$bc90872e265d166e;
    for(let i = 0; i <= $b9e802bd96c49e18$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $b9e802bd96c49e18$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $b9e802bd96c49e18$var$Grid = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$b9e802bd96c49e18$var$lineLengthGridLines(highlight),
        ...$b9e802bd96c49e18$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none'
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $b9e802bd96c49e18$var$ThemedGrid = (0, $g0wej.b)($b9e802bd96c49e18$var$Grid);
const $b9e802bd96c49e18$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { widthState: widthState, gridState: gridState } = (0, $awTmI.useSharedPluginState)(api, [
        'width',
        'grid'
    ]);
    if (!gridState) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b9e802bd96c49e18$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: widthState?.width ?? (0, $iHYdz.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: gridState.visible,
        gridType: gridState.gridType ?? 'full',
        highlight: gridState.highlight
    });
};
const $b9e802bd96c49e18$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $b9e802bd96c49e18$var$gridPMPlugin = new (0, $5KWxh.SafePlugin)({
    key: $b9e802bd96c49e18$var$key,
    state: {
        init () {
            return $b9e802bd96c49e18$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($b9e802bd96c49e18$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $b9e802bd96c49e18$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $b9e802bd96c49e18$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $b9e802bd96c49e18$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$b9e802bd96c49e18$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b9e802bd96c49e18$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            })
    };
};

});


parcelRegister("2DIrX", function(module, exports) {

$parcel$export(module.exports, "historyPlugin", () => (parcelRequire("5kxA9")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5kxA9 = parcelRequire("5kxA9");

});
parcelRegister("5kxA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb056ac66a521c1$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $aOimD = parcelRequire("aOimD");

var $7c8yA = parcelRequire("7c8yA");

var $8Hc3a = parcelRequire("8Hc3a");

var $lnSB9 = parcelRequire("lnSB9");

var $fb5I4 = parcelRequire("fb5I4");
const $fbb056ac66a521c1$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $fbb056ac66a521c1$var$createPluginState, getPluginState: $fbb056ac66a521c1$var$getPluginState } = (0, $aOimD.pluginFactory)((0, $fb5I4.historyPluginKey), (0, $8Hc3a.default));
const $fbb056ac66a521c1$var$createPlugin = (dispatch)=>new (0, $5KWxh.SafePlugin)({
        state: $fbb056ac66a521c1$var$createPluginState(dispatch, $fbb056ac66a521c1$var$getInitialState),
        key: (0, $fb5I4.historyPluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false)) {
                const pmHistoryPluginState = (0, $lnSB9.getPmHistoryPluginState)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $fbb056ac66a521c1$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $7c8yA.HistoryActionTypes).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $fb5I4.historyPluginKey), action);
                }
            }
        }
    });
const $fbb056ac66a521c1$var$historyPlugin = ({ api: api })=>({
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$fbb056ac66a521c1$var$createPlugin(dispatch)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const historyPluginState = (0, $fb5I4.historyPluginKey).getState(editorState);
            if (!historyPluginState) return undefined;
            const { done: done, undone: undone } = (0, $lnSB9.getPmHistoryPluginState)(editorState) ?? {};
            return {
                canUndo: historyPluginState.canUndo,
                canRedo: historyPluginState.canRedo,
                done: {
                    eventCount: done?.eventCount ?? 0
                },
                undone: {
                    eventCount: undone?.eventCount ?? 0
                }
            };
        },
        commands: {
            updatePluginState: ({ tr: tr })=>{
                const { done: done, undone: undone } = api?.history.sharedState.currentState() ?? {};
                if (done === undefined || undone === undefined) return tr;
                const canUndo = done.eventCount > 0;
                const canRedo = undone.eventCount > 0;
                const action = {
                    type: (0, $7c8yA.HistoryActionTypes).UPDATE,
                    canUndo: canUndo,
                    canRedo: canRedo
                };
                return tr.setMeta((0, $fb5I4.historyPluginKey), action);
            }
        }
    });
var $fbb056ac66a521c1$export$2e2bcd8739ae039 = $fbb056ac66a521c1$var$historyPlugin;

});
parcelRegister("7c8yA", function(module, exports) {

$parcel$export(module.exports, "HistoryActionTypes", () => $14a9c7d92e1cbfec$export$324bf1d9598f1f30);
var $14a9c7d92e1cbfec$export$324bf1d9598f1f30 = /*#__PURE__*/ function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
    return HistoryActionTypes;
}({});

});

parcelRegister("8Hc3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fe0207d549ed61$export$2e2bcd8739ae039);

var $7c8yA = parcelRequire("7c8yA");
const $89fe0207d549ed61$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $7c8yA.HistoryActionTypes).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $89fe0207d549ed61$export$2e2bcd8739ae039 = $89fe0207d549ed61$var$reducer;

});

parcelRegister("lnSB9", function(module, exports) {

$parcel$export(module.exports, "getPmHistoryPluginState", () => $dea5962b6e26cf49$export$6bcebd7b5d7b9325);

var $77j9j = parcelRequire("77j9j");

var $VSDnB = parcelRequire("VSDnB");
const $dea5962b6e26cf49$export$37e0e4eb94b3734e = (state)=>{
    return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (plugin)=>plugin.key === (0, $77j9j.pmHistoryPluginKey));
};
// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
const $dea5962b6e26cf49$var$fakePluginKey = {
    key: (0, $77j9j.pmHistoryPluginKey),
    getState: (state)=>{
        // The plugin key is used to index state
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state[0, $77j9j.pmHistoryPluginKey];
    },
    get (state) {
        return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (plugin)=>plugin.key === (0, $77j9j.pmHistoryPluginKey));
    }
};
const $dea5962b6e26cf49$export$6bcebd7b5d7b9325 = (state)=>{
    if ((0, $VSDnB.fg)('platform_editor_improve_history_state_performance')) return $dea5962b6e26cf49$var$fakePluginKey.getState(state);
    const pmHistoryPlugin = $dea5962b6e26cf49$export$37e0e4eb94b3734e(state);
    if (!pmHistoryPlugin) return;
    return pmHistoryPlugin.getState(state);
};

});

parcelRegister("fb5I4", function(module, exports) {

$parcel$export(module.exports, "historyPluginKey", () => $2c27a7bd386b5f30$export$8869884044241c3c);

var $gZGBX = parcelRequire("gZGBX");
const $2c27a7bd386b5f30$export$8869884044241c3c = new (0, $gZGBX.PluginKey)('historyPlugin');

});



parcelRegister("bM5ai", function(module, exports) {

$parcel$export(module.exports, "hyperlinkPlugin", () => (parcelRequire("1NAwD")).hyperlinkPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1NAwD = parcelRequire("1NAwD");

});
parcelRegister("1NAwD", function(module, exports) {

$parcel$export(module.exports, "hyperlinkPlugin", () => $3663337f0eb0f475$export$8143923e8601d272);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8XeG6 = parcelRequire("8XeG6");

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $2Y1rH = parcelRequire("2Y1rH");

var $2i4K4 = parcelRequire("2i4K4");

var $31nwk = parcelRequire("31nwk");

var $I02Nt = parcelRequire("I02Nt");

var $dPSMN = parcelRequire("dPSMN");

var $fcZox = parcelRequire("fcZox");

var $gmhCD = parcelRequire("gmhCD");

var $gIYCd = parcelRequire("gIYCd");

var $30OPT = parcelRequire("30OPT");

var $MxEYb = parcelRequire("MxEYb");

var $3F7Mv = parcelRequire("3F7Mv");

var $gHHQB = parcelRequire("gHHQB");

var $k023r = parcelRequire("k023r");

var $8TsWS = parcelRequire("8TsWS");

var $lIUFq = parcelRequire("lIUFq");
const $3663337f0eb0f475$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $3663337f0eb0f475$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
const $3663337f0eb0f475$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    let primaryToolbarComponent;
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        primaryToolbarComponent = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8TsWS.PrimaryToolbarComponent), {
                api: api,
                editorAnalyticsAPI: api?.analytics?.actions
            });
        api?.primaryToolbar?.actions.registerComponent({
            name: 'hyperlink',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $8XeG6.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $gkwXh.INPUT_METHOD).TOOLBAR)=>(0, $gIYCd.showLinkToolbar)(inputMethod, api?.analytics?.actions),
            updateLink: (href, text)=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $3663337f0eb0f475$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $gIYCd.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $3663337f0eb0f475$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $gIYCd.removeLinkEditorCommand)(pos, api?.analytics?.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $gIYCd.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, $gIYCd.insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
            updateLink: (0, $gIYCd.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $gHHQB.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $gHHQB.plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $30OPT.default)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>(0, $MxEYb.createInputRulePlugin)(schema, api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>(0, $3F7Mv.createKeymapPlugin)(api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        const hasCard = !!api?.card?.actions;
                        return (0, $k023r.toolbarButtonsPlugin)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'hyperlink',
                        title: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).link),
                        description: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).linkDescription),
                        keywords: [
                            'hyperlink',
                            'url'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $e9qoo.tooltip)((0, $e9qoo.addLink)),
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconLink), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            tr.setMeta((0, $gHHQB.stateKey), {
                                type: (0, $2Y1rH.LinkAction).SHOW_INSERT_TOOLBAR,
                                inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT
                            });
                            const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $gkwXh.ACTION).INVOKED,
                                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
                                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                attributes: {
                                    inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $gkwXh.EVENT_TYPE).UI
                            })(tr);
                            return analyticsAttached !== false ? tr : false;
                        }
                    }
                ],
            floatingToolbar: (0, $lIUFq.getToolbarConfig)(options, api),
            selectionToolbar: (state, { formatMessage: formatMessage })=>{
                if (api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking === 'none' && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarButton = ()=>{
                        const { from: from, to: to } = state.selection;
                        const isEnabled = (0, $dPSMN.canLinkBeCreatedInRange)(from, to)(state);
                        const title = formatMessage((0, $2i4K4.toolbarInsertBlockMessages).link);
                        return {
                            type: 'button',
                            disabled: !isEnabled,
                            testId: `${$3663337f0eb0f475$var$selectionToolbarLinkButtonTestId}`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fcZox))),
                            title: title,
                            tooltipContent: (0, $e9qoo.tooltip)((0, $e9qoo.addLink), title),
                            showTitle: false,
                            onClick: (state, dispatch)=>{
                                return (0, $31nwk.editorCommandToPMCommand)((0, $gIYCd.showLinkToolbar)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, api?.analytics?.actions))(state, dispatch);
                            }
                        };
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarButton()
                        ],
                        rank: 2
                    };
                } else return undefined;
            },
            primaryToolbarComponent: !api?.primaryToolbar && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: true
            }) ? primaryToolbarComponent : undefined
        }
    };
};

});
parcelRegister("2Y1rH", function(module, exports) {

$parcel$export(module.exports, "LinkAction", () => $e3e45f4a3bdd503a$export$6dcc1033b74c9344);
$parcel$export(module.exports, "InsertStatus", () => $e3e45f4a3bdd503a$export$8dcc3cd59f9a0726);
var $e3e45f4a3bdd503a$export$6dcc1033b74c9344 = /*#__PURE__*/ function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    return LinkAction;
}({});
var $e3e45f4a3bdd503a$export$8dcc3cd59f9a0726 = /*#__PURE__*/ function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    return InsertStatus;
}({});

});

parcelRegister("fcZox", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b12799b511c38ec3$var$_react = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b12799b511c38ec3$var$_link = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $b12799b511c38ec3$var$_link2 = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("7WxSP")));
function $b12799b511c38ec3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b12799b511c38ec3$var$LinkIcon = (props)=>/*#__PURE__*/ $b12799b511c38ec3$var$_react.default.createElement($b12799b511c38ec3$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b12799b511c38ec3$var$_link2.default
    }, props));
$b12799b511c38ec3$var$LinkIcon.Name = 'LinkIconMigration';
var $b12799b511c38ec3$var$_default = module.exports.default = $b12799b511c38ec3$var$LinkIcon;

});
parcelRegister("7WxSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $5c883bb6fff27f31$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $5c883bb6fff27f31$var$_link.default
    }));
$5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;

});


parcelRegister("gIYCd", function(module, exports) {

$parcel$export(module.exports, "updateLinkEditorCommand", () => $6b6f790aba13f7b6$export$1f68f6e2d4509ef7);
$parcel$export(module.exports, "updateLink", () => $6b6f790aba13f7b6$export$468bc07728835ac4);
$parcel$export(module.exports, "insertLinkWithAnalytics", () => $6b6f790aba13f7b6$export$61f4de3ecc2b935b);
$parcel$export(module.exports, "removeLink", () => $6b6f790aba13f7b6$export$91d8072017908bea);
$parcel$export(module.exports, "removeLinkEditorCommand", () => $6b6f790aba13f7b6$export$32e967ed59808fd);
$parcel$export(module.exports, "editInsertedLink", () => $6b6f790aba13f7b6$export$8eb8ea8f98f386b5);
$parcel$export(module.exports, "showLinkToolbar", () => $6b6f790aba13f7b6$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $6b6f790aba13f7b6$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "hideLinkToolbarSetMeta", () => $6b6f790aba13f7b6$export$534add8453a7a184);
$parcel$export(module.exports, "onEscapeCallback", () => $6b6f790aba13f7b6$export$34daa751a305794c);
$parcel$export(module.exports, "onClickAwayCallback", () => $6b6f790aba13f7b6$export$e72685a867c8a4f2);

var $gkwXh = parcelRequire("gkwXh");
var $2iyV6 = parcelRequire("2iyV6");

var $1ZWXY = parcelRequire("1ZWXY");

var $14FOE = parcelRequire("14FOE");

var $lhLis = parcelRequire("lhLis");
var $2Y1rH = parcelRequire("2Y1rH");

var $31nwk = parcelRequire("31nwk");

var $dPSMN = parcelRequire("dPSMN");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $gHHQB = parcelRequire("gHHQB");
function $6b6f790aba13f7b6$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $lhLis.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $dPSMN.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi?.attachAnalyticsEvent((0, $2iyV6.unlinkPayload)((0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $gHHQB.stateKey), {
            type: (0, $2Y1rH.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $6b6f790aba13f7b6$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $31nwk.editorCommandToPMCommand)($6b6f790aba13f7b6$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $6b6f790aba13f7b6$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $dPSMN.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $gHHQB.stateKey), {
                type: (0, $2Y1rH.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $6b6f790aba13f7b6$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $31nwk.editorCommandToPMCommand)($6b6f790aba13f7b6$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $6b6f790aba13f7b6$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            const normalizedUrl = (0, $dPSMN.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (0, $gHHQB.stateKey).getState(state)?.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                if ((0, $VSDnB.fg)('platform_editor_update_insert_link_mark_end_pos')) {
                    // new block created to wrap the link
                    if (tr.mapping.map(from) === from + text.length + 2) // +1 is for the block's opening tag
                    markEnd = from + text.length + 1;
                    else markEnd = from + text.length;
                } else if (!(0, $lhLis.isTextAtPos)(from)(state)) markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                source, (0, $gkwXh.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
                    action: (0, $gkwXh.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
				 * Add link metadata because queue cards would have otherwise handled this for us
				 */ (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
                action: (0, $gkwXh.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $gHHQB.stateKey), {
                type: (0, $2Y1rH.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $gHHQB.stateKey), {
            type: (0, $2Y1rH.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $6b6f790aba13f7b6$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $6b6f790aba13f7b6$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $14FOE.withAnalytics)(editorAnalyticsApi, (0, $dPSMN.getLinkCreationAnalyticsEvent)(inputMethod, href))($6b6f790aba13f7b6$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $6b6f790aba13f7b6$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $1ZWXY.commandWithMetadata)($6b6f790aba13f7b6$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $gkwXh.ACTION).UNLINK
    });
}
function $6b6f790aba13f7b6$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $6b6f790aba13f7b6$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $1ZWXY.addLinkMetadata)(tr.selection, tr, {
            action: (0, $gkwXh.ACTION).UNLINK
        });
        return tr;
    };
}
function $6b6f790aba13f7b6$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $gHHQB.stateKey), {
                type: (0, $2Y1rH.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi?.attachAnalyticsEvent((0, $2iyV6.buildEditLinkPayload)((0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $6b6f790aba13f7b6$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $gHHQB.stateKey), {
            type: (0, $2Y1rH.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVOKED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $6b6f790aba13f7b6$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($6b6f790aba13f7b6$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $6b6f790aba13f7b6$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $gHHQB.stateKey), {
        type: (0, $2Y1rH.LinkAction).HIDE_TOOLBAR
    });
};
const $6b6f790aba13f7b6$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $6b6f790aba13f7b6$export$534add8453a7a184(tr);
        cardActions?.hideLinkToolbar?.(tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $6b6f790aba13f7b6$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $6b6f790aba13f7b6$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};

});
parcelRegister("gHHQB", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $42d177908b58055a$export$77b371d6becc8882);
$parcel$export(module.exports, "plugin", () => $42d177908b58055a$export$ca524d3785e2543);

var $7Jxgt = parcelRequire("7Jxgt");

var $lhLis = parcelRequire("lhLis");
var $dtBvX = parcelRequire("dtBvX");
var $2Y1rH = parcelRequire("2Y1rH");

var $5KWxh = parcelRequire("5KWxh");

var $dPSMN = parcelRequire("dPSMN");
var $77j9j = parcelRequire("77j9j");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $ckc7R = parcelRequire("ckc7R");
const $42d177908b58055a$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $2Y1rH.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $2Y1rH.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $2Y1rH.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $42d177908b58055a$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $2Y1rH.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $dPSMN.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $2Y1rH.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $2Y1rH.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = (0, $lhLis.getActiveLinkMark)(editorState);
            if (link) return {
                ...link,
                type: (0, $2Y1rH.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $2Y1rH.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $2Y1rH.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = (0, $lhLis.getActiveLinkMark)(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $2Y1rH.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $2Y1rH.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $2Y1rH.LinkAction).SELECTION_CHANGE:
            const link1 = (0, $lhLis.getActiveLinkMark)(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $2Y1rH.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $2Y1rH.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $2Y1rH.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $2Y1rH.LinkAction).SELECTION_CHANGE:
        case (0, $2Y1rH.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $42d177908b58055a$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $gZGBX.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $42d177908b58055a$export$77b371d6becc8882 = new (0, $gZGBX.PluginKey)('hyperlinkPlugin');
const $42d177908b58055a$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, pluginInjectionApi, onClickCallback, __livePage)=>new (0, $5KWxh.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $dPSMN.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $42d177908b58055a$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $42d177908b58055a$var$toState(undefined, (0, $2Y1rH.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($42d177908b58055a$export$77b371d6becc8882) && tr.getMeta($42d177908b58055a$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($42d177908b58055a$export$77b371d6becc8882) && tr.getMeta($42d177908b58055a$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $dPSMN.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $42d177908b58055a$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $2Y1rH.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $2Y1rH.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        ...__livePage && (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') && state,
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $42d177908b58055a$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                    if ((0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages')) {
                        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                        if (__livePage && !isViewMode) {
                            if (action === (0, $2Y1rH.LinkAction).SET_CONFIGURE_DROPDOWN_OPEN) {
                                const configureDropdownOpen = tr.getMeta($42d177908b58055a$export$77b371d6becc8882).isOpen;
                                // Hide overlay when the dropdown is closed (state is updated to false)
                                const decorations = configureDropdownOpen ? {} : {
                                    decorations: (0, $etG8M.DecorationSet).empty
                                };
                                state = {
                                    ...state,
                                    ...decorations,
                                    configureDropdownOpen: configureDropdownOpen
                                };
                            }
                            if (action === (0, $2Y1rH.LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS) {
                                const configureButtonTargetPos = tr.getMeta($42d177908b58055a$export$77b371d6becc8882).pos;
                                const targetPosHasChanged = pluginState.configureButtonTargetPos !== configureButtonTargetPos;
                                let decorations = pluginState.decorations;
                                if (targetPosHasChanged && state.configureDropdownOpen !== true) {
                                    if (configureButtonTargetPos === undefined) decorations = (0, $etG8M.DecorationSet).empty;
                                    else {
                                        const decoration = (0, $etG8M.Decoration).widget(configureButtonTargetPos, (view)=>{
                                            return (0, $ckc7R.ButtonWrapper)({
                                                editorView: view,
                                                pos: configureButtonTargetPos,
                                                stateKey: $42d177908b58055a$export$77b371d6becc8882,
                                                intl: intl,
                                                onOpenLinkClick: (event)=>{
                                                    if (configureButtonTargetPos === undefined || typeof configureButtonTargetPos !== 'number') return;
                                                    const node = view.state.tr.doc.nodeAt(configureButtonTargetPos);
                                                    if (node === null) return;
                                                    const url = node.marks.find((mark)=>mark.type.name === 'link')?.attrs.href;
                                                    if (!url) return;
                                                    (0, $dtBvX.handleNavigation)({
                                                        fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                                        onClickCallback: onClickCallback,
                                                        url: url,
                                                        event: event
                                                    });
                                                }
                                            });
                                        });
                                        decorations = (0, $etG8M.DecorationSet).create(newState.doc, [
                                            decoration
                                        ]);
                                    }
                                }
                                state = {
                                    ...state,
                                    configureButtonTargetPos: configureButtonTargetPos,
                                    decorations: decorations
                                };
                            }
                        }
                    }
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $42d177908b58055a$var$getActiveText(newState.selection),
                    canInsertLink: (0, $dPSMN.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $42d177908b58055a$var$toState(state.activeLinkMark, (0, $2Y1rH.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $77j9j.shallowEqual)(state, pluginState)) dispatch($42d177908b58055a$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $42d177908b58055a$export$77b371d6becc8882,
        props: {
            decorations: (state)=>{
                if (__livePage && (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages')) {
                    const { decorations: decorations } = $42d177908b58055a$export$77b371d6becc8882.getState(state) ?? {};
                    return decorations;
                } else return (0, $etG8M.DecorationSet).empty;
            },
            handleDOMEvents: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($42d177908b58055a$var$isLinkDirectTarget(event)) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mousedown: (view, event)=>{
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$42d177908b58055a$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            ...__livePage && (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') && {
                markViews: {
                    link: (mark, view, inline)=>{
                        const toDOM = mark.type.spec.toDOM;
                        if (!toDOM) throw new Error('toDom method missing');
                        const dom = (0, $kCV8T.DOMSerializer).renderSpec(document, toDOM(mark, inline)).dom;
                        if (!(dom instanceof HTMLElement)) throw new Error('Error rendering hyperlink spec to dom');
                        const setTargetElementPos = (val)=>{
                            const tr = view.state.tr;
                            tr.setMeta($42d177908b58055a$export$77b371d6becc8882, {
                                type: (0, $2Y1rH.LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS,
                                pos: val
                            });
                            view.dispatch(tr);
                        };
                        dom.onmouseenter = ()=>{
                            const { activeLinkMark: activeLinkMark, configureButtonTargetPos: configureButtonTargetPos } = $42d177908b58055a$export$77b371d6becc8882.getState(view.state) ?? {};
                            if (!activeLinkMark) {
                                const nodePos = view.posAtDOM(dom, -1);
                                if (nodePos !== configureButtonTargetPos) setTargetElementPos(nodePos);
                            }
                        };
                        dom.onmouseleave = ()=>{
                            const { configureButtonTargetPos: configureButtonTargetPos } = $42d177908b58055a$export$77b371d6becc8882.getState(view.state) ?? {};
                            if (configureButtonTargetPos !== undefined) setTargetElementPos(undefined);
                        };
                        dom.onclick = (event)=>{
                            if ($42d177908b58055a$var$isDirectTarget(event, dom)) {
                                const url = mark.attrs.href;
                                // event is globalThis.MouseEvent, while handleNavigation
                                // (and editor-common OnClickCallback) require React.MouseEvent
                                const reactMouseEvent = event;
                                (0, $dtBvX.handleNavigation)({
                                    fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                    onClickCallback: onClickCallback,
                                    url: url,
                                    event: reactMouseEvent
                                });
                            }
                        };
                        return {
                            dom: dom
                        };
                    }
                }
            }
        }
    });
function $42d177908b58055a$var$isLinkDirectTarget(event) {
    return event?.target instanceof HTMLElement && event.target.tagName === 'A';
}
function $42d177908b58055a$var$isDirectTarget(event, element) {
    return event?.target instanceof HTMLElement && event.target === element;
}

});
parcelRegister("ckc7R", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $d65c35e0885c39da$export$d53c836cccbb0d90);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");

var $2Y1rH = parcelRequire("2Y1rH");
var $hH2qd = parcelRequire("hH2qd");
const $d65c35e0885c39da$export$d53c836cccbb0d90 = ({ editorView: editorView, pos: pos, stateKey: stateKey, intl: intl, onOpenLinkClick: onOpenLinkClick })=>{
    const wrapper = document.createElement('span');
    wrapper.style.position = 'relative';
    const nonBreakingCharacter = '\u2060';
    const onDropdownChange = (isOpen)=>{
        editorView.dispatch(editorView.state.tr.setMeta(stateKey, {
            type: (0, $2Y1rH.LinkAction).SET_CONFIGURE_DROPDOWN_OPEN,
            isOpen: isOpen
        }));
    };
    (0, $7nsd3.render)(/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $i5FdW.default), {
        locale: intl.locale || 'en',
        messages: intl.messages,
        formats: intl.formats,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hH2qd.OverlayButton), {
                targetElementPos: pos,
                editorView: editorView,
                onDropdownChange: onDropdownChange,
                onOpenLinkClick: onOpenLinkClick
            }),
            nonBreakingCharacter
        ]
    }), wrapper);
    return wrapper;
};

});



parcelRegister("30OPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c211d1936d474df9$export$2e2bcd8739ae039);

var $2Y1rH = parcelRequire("2Y1rH");

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");

var $eB4lt = parcelRequire("eB4lt");

var $gHHQB = parcelRequire("gHHQB");
const $c211d1936d474df9$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $etG8M.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $c211d1936d474df9$var$createTextSelection = (from, to)=>(0, $etG8M.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $c211d1936d474df9$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $gHHQB.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $2Y1rH.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $c211d1936d474df9$var$fakeCursorToolbarPlugin = new (0, $5KWxh.SafePlugin)({
    key: (0, $eB4lt.fakeCursorForToolbarPluginKey),
    state: {
        init () {
            return (0, $etG8M.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $c211d1936d474df9$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $c211d1936d474df9$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $etG8M.DecorationSet).create(tr.doc, [
                    from === to ? $c211d1936d474df9$var$createTextCursor(from) : $c211d1936d474df9$var$createTextSelection(from, to)
                ]);
            }
            return (0, $etG8M.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $eB4lt.fakeCursorForToolbarPluginKey).getState(state);
        }
    }
});
var $c211d1936d474df9$export$2e2bcd8739ae039 = $c211d1936d474df9$var$fakeCursorToolbarPlugin;

});
parcelRegister("eB4lt", function(module, exports) {

$parcel$export(module.exports, "fakeCursorForToolbarPluginKey", () => $bc509495f278987a$export$38c00ed3b117ab26);

var $gZGBX = parcelRequire("gZGBX");
const $bc509495f278987a$export$38c00ed3b117ab26 = new (0, $gZGBX.PluginKey)('fakeCursorToolbarPlugin');

});


parcelRegister("MxEYb", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $17eb71eb246aa49f$export$dc83f374e2af640d);

var $gkwXh = parcelRequire("gkwXh");

var $1ZWXY = parcelRequire("1ZWXY");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");
var $dPSMN = parcelRequire("dPSMN");
var $gOwky = parcelRequire("gOwky");

var $inLhu = parcelRequire("inLhu");

var $k023r = parcelRequire("k023r");
function $17eb71eb246aa49f$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $2Abpa.createRule)(regexp, (state, match, start, end)=>{
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $gOwky.shouldAutoLinkifyMatch)(link)) return null;
        const url = (0, $dPSMN.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $dPSMN.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length));
        if ((0, $dPSMN.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $gkwXh.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = (0, $k023r.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $dPSMN.getLinkCreationAnalyticsEvent)((0, $gkwXh.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $17eb71eb246aa49f$export$dc83f374e2af640d(schema, editorAnalyticsApi) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $17eb71eb246aa49f$export$8d0400fab1d2ed11((0, $dPSMN.LinkMatcher).create(), editorAnalyticsApi);
    // [something](link) should convert to a hyperlink
    // eslint-disable-next-line require-unicode-regexp
    const markdownLinkRule = (0, $2Abpa.createRule)(/(^|[^!])\[(.*?)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $dPSMN.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = (0, $k023r.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $dPSMN.getLinkCreationAnalyticsEvent)((0, $gkwXh.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ]));
}
var $17eb71eb246aa49f$export$2e2bcd8739ae039 = $17eb71eb246aa49f$export$dc83f374e2af640d;

});
parcelRegister("k023r", function(module, exports) {

$parcel$export(module.exports, "toolbarKey", () => $689e2a4840f1847f$export$6cbac557ea601778);
$parcel$export(module.exports, "toolbarButtonsPlugin", () => $689e2a4840f1847f$export$faf11097578346af);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $689e2a4840f1847f$export$6cbac557ea601778 = new (0, $gZGBX.PluginKey)('hyperlinkToolbarItems');
const $689e2a4840f1847f$export$faf11097578346af = (initialState)=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $689e2a4840f1847f$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($689e2a4840f1847f$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};

});


parcelRegister("3F7Mv", function(module, exports) {

$parcel$export(module.exports, "createKeymapPlugin", () => $92f3dd553f1620e8$export$1d7b13ce0747fbd);

var $iZOJ9 = parcelRequire("iZOJ9");

var $gkwXh = parcelRequire("gkwXh");

var $1ZWXY = parcelRequire("1ZWXY");

var $e9qoo = parcelRequire("e9qoo");

var $dPSMN = parcelRequire("dPSMN");
var $gOwky = parcelRequire("gOwky");

var $vWFRY = parcelRequire("vWFRY");

var $gIYCd = parcelRequire("gIYCd");

var $gHHQB = parcelRequire("gHHQB");

var $k023r = parcelRequire("k023r");
function $92f3dd553f1620e8$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addLink).common, (0, $gIYCd.showLinkToolbar)((0, $gkwXh.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.enter).common, $92f3dd553f1620e8$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.insertNewLine).common, $92f3dd553f1620e8$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $gHHQB.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $gIYCd.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $vWFRY.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $92f3dd553f1620e8$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        const skipAnalytics = (0, $k023r.toolbarKey).getState(state)?.skipAnalytics ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $iZOJ9.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $gOwky.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $dPSMN.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
            if ((0, $dPSMN.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $1ZWXY.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $gkwXh.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi?.attachAnalyticsEvent((0, $dPSMN.getLinkCreationAnalyticsEvent)((0, $gkwXh.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $92f3dd553f1620e8$export$2e2bcd8739ae039 = $92f3dd553f1620e8$export$1d7b13ce0747fbd;

});

parcelRegister("8TsWS", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $3b289f41b47360e5$export$94516d5cccf573e3);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $2i4K4 = parcelRequire("2i4K4");

var $1jI4k = parcelRequire("1jI4k");

var $1f9bV = parcelRequire("1f9bV");
const $3b289f41b47360e5$var$PrimaryToolbarComponentWithIntl = ({ api: api, intl: // TODO: ED-26959 - Analytics
// editorAnalyticsAPI,
intl })=>{
    const { formatMessage: formatMessage } = intl;
    const content = formatMessage((0, $2i4K4.toolbarInsertBlockMessages).link);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        api?.core?.actions.execute(api?.hyperlink?.commands.showLinkToolbar((0, $gkwXh.INPUT_METHOD).TOOLBAR));
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        onClick: onClick,
        "aria-haspopup": "dialog",
        "aria-keyshortcuts": (0, $e9qoo.getAriaKeyshortcuts)((0, $e9qoo.addLink)),
        "aria-label": content,
        testId: content,
        title: content,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
            label: content,
            color: "currentColor",
            spacing: "spacious"
        })
    });
};
const $3b289f41b47360e5$export$94516d5cccf573e3 = (0, $8RXs9.default)($3b289f41b47360e5$var$PrimaryToolbarComponentWithIntl);

});

parcelRegister("lIUFq", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $eca7994b8382ac87$export$86ce8f8241c20a3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $gkwXh = parcelRequire("gkwXh");
var $2iyV6 = parcelRequire("2iyV6");

var $1ZWXY = parcelRequire("1ZWXY");

var $awTmI = parcelRequire("awTmI");

var $e9EHa = parcelRequire("e9EHa");

var $gSYO9 = parcelRequire("gSYO9");
var $jDuvE = parcelRequire("jDuvE");


var $dPSMN = parcelRequire("dPSMN");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $5nRKm = parcelRequire("5nRKm");

var $bbAXg = parcelRequire("bbAXg");

var $7paD5 = parcelRequire("7paD5");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gIYCd = parcelRequire("gIYCd");

var $gHHQB = parcelRequire("gHHQB");

var $k023r = parcelRequire("k023r");
/* type guard for edit links */ function $eca7994b8382ac87$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $eca7994b8382ac87$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, $gkwXh.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $eca7994b8382ac87$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $eca7994b8382ac87$var$dispatchAnalytics(dispatch, state, (0, $2iyV6.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
function $eca7994b8382ac87$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $dPSMN.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
function $eca7994b8382ac87$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    const { hyperlinkState: hyperlinkState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'hyperlink'
    ]);
    // This is constant rather than dynamic - because if someone's already got a hyperlink toolbar open,
    // we don't want to dynamically change it on them as this would cause data loss if they've already
    // started typing in the fields.
    const isOffline = (0, $5uXOq.useRef)(pluginInjectionApi?.connectivity?.sharedState.currentState()?.mode === 'offline');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9EHa.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: hyperlinkState?.timesViewed,
        inputMethod: hyperlinkState?.inputMethod,
        searchSessionId: hyperlinkState?.searchSessionId,
        isOffline: isOffline.current
    });
}
const $eca7994b8382ac87$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        if (options.disableFloatingToolbar) return;
        const linkState = (0, $gHHQB.stateKey).getState(state);
        const activeLinkMark = linkState?.activeLinkMark;
        // If range selection, we don't show hyperlink floating toolbar.
        // Text Formattting toolbar is shown instaed.
        if (state.selection instanceof (0, $gZGBX.TextSelection) && state.selection.to !== state.selection.from && activeLinkMark?.type === 'EDIT' && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) return;
        const { formatMessage: formatMessage } = intl;
        const editorCardActions = pluginInjectionApi?.card?.actions;
        const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (activeLinkMark) {
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : '',
                // getDomRef by default uses view.state.selection.from to position the toolbar.
                // However, when the user clicks in right after the link the view.state.selection.from references to the dom after the selection.
                // So instead we want to use the activeLinkMark.pos which has been calculated as the position before the click so that would be the link node
                getDomRef: activeLinkMark && (activeLinkMark.type === 'EDIT_INSERTED' || activeLinkMark.type === 'EDIT') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_3') ? (view)=>{
                    const domRef = (0, $5r0mK.findDomRefAtPos)(activeLinkMark.pos, view.domAtPos.bind(view));
                    return domRef instanceof HTMLElement ? domRef : undefined;
                } : undefined
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $iZOJ9.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $gSYO9.linkMessages).openLink : (0, $jDuvE.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 - investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $jDuvE.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $jDuvE.linkToolbarMessages).editLink);
                        const metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const cardActions = pluginInjectionApi?.card?.actions;
                        const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, $gIYCd.editInsertedLink)(editorAnalyticsApi), metadata, (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? state : undefined) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $gIYCd.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                                metadata: metadata,
                                icon: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))) : undefined
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const items = [
                            ...startingToolbarItems,
                            {
                                id: 'editor.link.openLink',
                                testId: 'editor.link.openLink',
                                type: 'button',
                                disabled: !isValidUrl,
                                target: '_blank',
                                href: isValidUrl ? link : undefined,
                                onClick: $eca7994b8382ac87$var$visitHyperlink(editorAnalyticsApi),
                                title: labelOpenLink,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7paD5))),
                                className: 'hyperlink-open-link',
                                metadata: metadata,
                                tabIndex: null
                            },
                            {
                                type: 'separator'
                            },
                            {
                                id: 'editor.link.unlink',
                                testId: 'editor.link.unlink',
                                type: 'button',
                                onClick: (0, $1ZWXY.commandWithMetadata)((0, $gIYCd.removeLink)(pos, editorAnalyticsApi), {
                                    inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
                                }),
                                title: labelUnlink,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bbAXg))),
                                tabIndex: null
                            },
                            {
                                type: 'separator'
                            },
                            {
                                type: 'copy-button',
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...cardActions?.getEndingToolbarItems(intl, link) ?? []
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        let link;
                        if ($eca7994b8382ac87$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $eca7994b8382ac87$var$isEditLink(activeLinkMark) ? $eca7994b8382ac87$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = lpLinkPicker ? (0, $f96f1f7af2f8d3ca$export$c635b83728f81640) : (0, $f96f1f7af2f8d3ca$export$c04a5ad015d45447);
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: (0, $f96f1f7af2f8d3ca$export$a62aa932daf22ffe),
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        return /*#__PURE__*/ (0, $2OMIu.jsx)($eca7994b8382ac87$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            linkPickerOptions: options?.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $gIYCd.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $gIYCd.onClickAwayCallback),
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic)=>{
                                                const isEdit = $eca7994b8382ac87$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $gkwXh.ACTION).UPDATED : (0, $gkwXh.ACTION).INSERTED;
                                                const skipAnalytics = (0, $k023r.toolbarKey).getState(state)?.skipAnalytics ?? false;
                                                const command = isEdit ? (0, $1ZWXY.commandWithMetadata)((0, $gIYCd.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $gIYCd.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        }, idx);
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };

});
parcelRegister("bbAXg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa7911763e47fa2648a3f279f8d5416>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $824d634357b75c18$var$_react = $824d634357b75c18$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $824d634357b75c18$var$_linkBroken = $824d634357b75c18$var$_interopRequireDefault((parcelRequire("90mMF")));

var $824d634357b75c18$var$_unlink = $824d634357b75c18$var$_interopRequireDefault((parcelRequire("jdB85")));
function $824d634357b75c18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "EditorUnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $824d634357b75c18$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $824d634357b75c18$var$_react.default.createElement($824d634357b75c18$var$_linkBroken.default, Object.assign({
        LEGACY_fallbackIcon: $824d634357b75c18$var$_unlink.default
    }, props));
$824d634357b75c18$var$LinkBrokenIcon.Name = 'LinkBrokenIconMigration';
var $824d634357b75c18$var$_default = module.exports.default = $824d634357b75c18$var$LinkBrokenIcon;

});




parcelRegister("6hrMZ", function(module, exports) {

$parcel$export(module.exports, "mentionsPlugin", () => (parcelRequire("3Y1hh")).mentionsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3Y1hh = parcelRequire("3Y1hh");

});
parcelRegister("3Y1hh", function(module, exports) {

$parcel$export(module.exports, "mentionsPlugin", () => $3ca4ef0bfeffe120$export$280dfabe1535ae84);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7Jxgt = parcelRequire("7Jxgt");

var $gkwXh = parcelRequire("gkwXh");

var $7ywdr = parcelRequire("7ywdr");
var $2i4K4 = parcelRequire("2i4K4");

var $9Egzu = parcelRequire("9Egzu");

var $I02Nt = parcelRequire("I02Nt");

var $3mm6g = parcelRequire("3mm6g");

var $cqJWb = parcelRequire("cqJWb");

var $VSDnB = parcelRequire("VSDnB");

var $kdTiD = parcelRequire("kdTiD");

var $kjnx4 = parcelRequire("kjnx4");

var $a7Tos = parcelRequire("a7Tos");

var $cJYsD = parcelRequire("cJYsD");

var $1sH5c = parcelRequire("1sH5c");
const $3ca4ef0bfeffe120$var$processName = (name, intl)=>{
    const unknownLabel = intl.formatMessage((0, $7ywdr.mentionMessages).unknownLabel);
    if (name.status === (0, $cqJWb.MentionNameStatus).OK) return `@${name.name || unknownLabel}`;
    else return `@${unknownLabel}`;
};
/**
 * We will need to clean this up once mentionProvider is
 * put inside mention plugin.
 * See: https://product-fabric.atlassian.net/browse/ED-26011
 */ function $3ca4ef0bfeffe120$var$Component({ mentionProvider: mentionProvider, api: api }) {
    const mentionProviderMemo = (0, $5uXOq.useMemo)(()=>{
        return mentionProvider;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const intl = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        mentionProviderMemo?.then((mentionProviderSync)=>{
            api?.base?.actions?.registerMarks(({ tr: tr, node: node, pos: pos })=>{
                const { doc: doc } = tr;
                const { schema: schema } = doc.type;
                const { mention: mentionNodeType } = schema.nodes;
                const { id: id } = node.attrs;
                if (node.type === mentionNodeType) {
                    if ((0, $3mm6g.isResolvingMentionProvider)(mentionProviderSync)) {
                        const nameDetail = mentionProviderSync?.resolveMentionName(id);
                        let newText;
                        if ((0, $cqJWb.isPromise)(nameDetail)) newText = `@${intl.formatMessage((0, $7ywdr.mentionMessages).unknownLabel)}`;
                        else newText = $3ca4ef0bfeffe120$var$processName(nameDetail, intl);
                        const currentPos = tr.mapping.map(pos);
                        tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
                    }
                }
            });
        });
    }, [
        mentionProviderMemo,
        api,
        intl
    ]);
    return null;
}
const $3ca4ef0bfeffe120$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
    let previousMediaProvider;
    const fireEvent = (payload, channel)=>{
        const fireAnalyticsEvent = api?.analytics?.actions?.fireAnalyticsEvent;
        if (!fireAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        fireAnalyticsEvent(payload, channel);
    };
    const typeAhead = (0, $1sH5c.createTypeAheadConfig)({
        sanitizePrivateContent: options?.sanitizePrivateContent,
        mentionInsertDisplayName: options?.insertDisplayName,
        HighlightComponent: options?.HighlightComponent,
        handleMentionsChanged: options?.handleMentionsChanged,
        fireEvent: fireEvent,
        api: api
    });
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $kdTiD.mentionNodeSpec)()
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $a7Tos.createMentionPlugin)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            fireEvent: fireEvent,
                            options: options,
                            api: api
                        })
                }
            ];
        },
        contentComponent ({ providerFactory: providerFactory }) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
                providers: [
                    'mentionProvider'
                ],
                providerFactory: providerFactory,
                renderNode: ({ mentionProvider: mentionProvider })=>{
                    return /*#__PURE__*/ (0, $2OMIu.jsx)($3ca4ef0bfeffe120$var$Component, {
                        mentionProvider: mentionProvider,
                        api: api
                    });
                }
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJYsD.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        actions: {
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions?.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options?.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            },
            setProvider: async (providerPromise)=>{
                if (!(0, $VSDnB.fg)('platform_editor_mention_provider_via_plugin_config')) return false;
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $kjnx4.mentionPluginKey), {
                        action: (0, $a7Tos.ACTIONS).SET_PROVIDER,
                        params: {
                            provider: provider
                        }
                    })) ?? false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $kjnx4.mentionPluginKey).getState(editorState);
            return {
                ...mentionPluginState,
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconMention), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            const pluginState = (0, $kjnx4.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};

});
parcelRegister("kdTiD", function(module, exports) {

$parcel$export(module.exports, "mentionNodeSpec", () => $253107bee11eff88$export$a9cde69b487c37ac);

var $g7Cky = parcelRequire("g7Cky");

var $7KZr8 = parcelRequire("7KZr8");


var $gmhCD = parcelRequire("gmhCD");
const $253107bee11eff88$var$isSSR = Boolean(undefined);
const $253107bee11eff88$export$a9cde69b487c37ac = ()=>{
    if ($253107bee11eff88$var$isSSR || (0, $gmhCD.editorExperiment)('platform_editor_inline_node_virtualization', 'off')) return 0, $g7Cky.mention;
    return {
        ...(0, $g7Cky.mention),
        toDOM: (node)=>{
            // packages/elements/mention/src/components/Mention/index.tsx
            const mentionAttrs = {
                'aria-busy': 'true',
                contenteditable: 'false',
                'data-access-level': '',
                'data-mention-id': node.attrs.id,
                'data-prosemirror-content-type': 'node',
                'data-prosemirror-node-inline': 'true',
                'data-prosemirror-node-name': 'mention',
                style: (0, $7KZr8.convertToInlineCss)({
                    display: 'inline',
                    border: `1px solid transparent`,
                    background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
                    color: "var(--ds-text-subtle, #44546F)",
                    borderRadius: '20px',
                    cursor: 'pointer',
                    padding: '0 0.3em 2px 0.23em',
                    wordBreak: 'break-word'
                })
            };
            return [
                'span',
                mentionAttrs,
                node.attrs.text
            ];
        }
    };
};

});

parcelRegister("kjnx4", function(module, exports) {

$parcel$export(module.exports, "mentionPluginKey", () => $59ddb4ce0e01f64e$export$617302757e30e37c);

var $gZGBX = parcelRequire("gZGBX");
const $59ddb4ce0e01f64e$export$617302757e30e37c = new (0, $gZGBX.PluginKey)('mentionPlugin');

});

parcelRegister("a7Tos", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $905c501206d9d703$export$92a1a3b7554e9387);
$parcel$export(module.exports, "createMentionPlugin", () => $905c501206d9d703$export$36c073f17660f60f);

var $gkwXh = parcelRequire("gkwXh");

var $5BVRS = parcelRequire("5BVRS");

var $5KWxh = parcelRequire("5KWxh");

var $5r0mK = parcelRequire("5r0mK");

var $4kfbr = parcelRequire("4kfbr");

var $cqJWb = parcelRequire("cqJWb");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $eea9W = parcelRequire("eea9W");

var $h1zDo = parcelRequire("h1zDo");


var $kjnx4 = parcelRequire("kjnx4");

var $3YSIX = parcelRequire("3YSIX");
const $905c501206d9d703$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER'
};
const $905c501206d9d703$var$PACKAGE_NAME = "platform-pkg";
const $905c501206d9d703$var$PACKAGE_VERSION = "0.0.0-use.local";
const $905c501206d9d703$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $kjnx4.mentionPluginKey), {
            action: $905c501206d9d703$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
function $905c501206d9d703$export$36c073f17660f60f({ pmPluginFactoryParams: pmPluginFactoryParams, fireEvent: fireEvent, options: options, api: api }) {
    let mentionProvider;
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $4kfbr.SLI_EVENT_TYPE) || event === (0, $4kfbr.SMART_EVENT_TYPE)) fireEvent({
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                packageName: $905c501206d9d703$var$PACKAGE_NAME,
                packageVersion: $905c501206d9d703$var$PACKAGE_VERSION,
                componentName: (0, $cqJWb.ComponentNames).MENTION,
                ...attributes
            }
        }, 'fabricElements');
    };
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $kjnx4.mentionPluginKey),
        state: {
            init (_, state) {
                const canInsertMention = (0, $3YSIX.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    canInsertMention: canInsertMention
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $kjnx4.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasNewPluginState = false;
                let newPluginState = pluginState;
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: (0, $3YSIX.canMentionBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState)
                    };
                    hasNewPluginState = true;
                }
                switch(action){
                    case $905c501206d9d703$export$92a1a3b7554e9387.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider
                        };
                        hasNewPluginState = true;
                        break;
                }
                if (hasNewPluginState) pmPluginFactoryParams.dispatch((0, $kjnx4.mentionPluginKey), newPluginState);
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (node, view, getPos, decorations, innerDecorations)=>{
                    return (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
                        exposure: true
                    }) ? new (0, $h1zDo.MentionNodeView)(node, {
                        options: options,
                        api: api,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI
                    }) : (0, $5BVRS.getInlineNodeViewProducer)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        Component: (0, $eea9W.MentionNodeView),
                        extraComponentProps: {
                            providerFactory: pmPluginFactoryParams.providerFactory,
                            pluginInjectionApi: api,
                            options: options
                        }
                    })(node, view, getPos, decorations);
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        if (!providerPromise) {
                            fireEvent({
                                action: (0, $gkwXh.ACTION).ERRORED,
                                actionSubject: (0, $gkwXh.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $30b3e1d387967ff3$export$eceeecffdf63fc89)
                                }
                            });
                            return $905c501206d9d703$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $905c501206d9d703$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>{
                            fireEvent({
                                action: (0, $gkwXh.ACTION).ERRORED,
                                actionSubject: (0, $gkwXh.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $30b3e1d387967ff3$export$7d0bcf8324b20190)
                                }
                            });
                            return $905c501206d9d703$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            const providerViaConfig = (0, $VSDnB.fg)('platform_editor_mention_provider_via_plugin_config');
            if (providerViaConfig && options?.mentionProvider) providerHandler('mentionProvider', options?.mentionProvider);
            else pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                },
                update (view, prevState) {
                    const newState = view.state;
                    if (options?.handleMentionsChanged) {
                        const mentionSchema = newState.schema.nodes.mention;
                        const mentionNodesBefore = (0, $5r0mK.findChildrenByType)(prevState.doc, mentionSchema);
                        const mentionLocalIdsAfter = new Set((0, $5r0mK.findChildrenByType)(newState.doc, mentionSchema).map(({ node: node })=>node.attrs.localId));
                        if (mentionNodesBefore.length > mentionLocalIdsAfter.size) {
                            const deletedMentions = mentionNodesBefore.filter(({ node: node })=>!mentionLocalIdsAfter.has(node.attrs.localId)).map(({ node: node })=>({
                                    type: 'deleted',
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                }));
                            if (deletedMentions.length > 0) options.handleMentionsChanged(deletedMentions);
                        }
                    }
                }
            };
        }
    });
}

});
parcelRegister("eea9W", function(module, exports) {

$parcel$export(module.exports, "MentionNodeView", () => $0535ec37c83088cd$export$ed501823ec7e75de);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $awTmI = parcelRequire("awTmI");

var $9Egzu = parcelRequire("9Egzu");

var $cLfQ8 = parcelRequire("cLfQ8");
const $0535ec37c83088cd$export$ed501823ec7e75de = (props)=>{
    const { providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi } = props;
    const { id: id, text: text, accessLevel: accessLevel, localId: localId } = props.node.attrs;
    const { mentionState: mentionState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'mention'
    ]);
    const mentionProvider = mentionState?.mentionProvider;
    const renderAssistiveTextWithProviders = (providers)=>{
        const mentionProviderPromise = mentionProvider ? Promise.resolve(mentionProvider) : providers.mentionProvider;
        const profilecardProvider = props.options?.profilecardProvider;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cLfQ8.Mention), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            mentionProvider: mentionProviderPromise,
            profilecardProvider: profilecardProvider,
            localId: localId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'mentionProvider',
            'profilecardProvider'
        ],
        providerFactory: providerFactory,
        renderNode: renderAssistiveTextWithProviders
    });
};

});
parcelRegister("cLfQ8", function(module, exports) {

$parcel$export(module.exports, "Mention", () => $025b76ba896f03f7$export$e891316fea657d90);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gE8f9 = parcelRequire("gE8f9");

var $b6FQr = parcelRequire("b6FQr");

var $kmW28 = parcelRequire("kmW28");

var $3mm6g = parcelRequire("3mm6g");
var $cqJWb = parcelRequire("cqJWb");

var $cqJWb = parcelRequire("cqJWb");
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $025b76ba896f03f7$var$refreshBrowserSelection = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $025b76ba896f03f7$export$e891316fea657d90 = (props)=>{
    const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderPromise } = props;
    const [profilecardProvider, setProfilecardProvider] = (0, $5uXOq.useState)(undefined);
    const resolvedName = $025b76ba896f03f7$var$useResolvedName(id, text, mentionProvider);
    // Resolve the profilecard provider
    (0, $5uXOq.useEffect)(()=>{
        let isCancelled = false;
        const resolveProfilecardProvider = async ()=>{
            try {
                const profilecardProvider = await profilecardProviderPromise;
                if (!isCancelled) setProfilecardProvider(profilecardProvider);
            } catch (error) {
                if (!isCancelled) setProfilecardProvider(undefined);
            }
        };
        if (profilecardProviderPromise) resolveProfilecardProvider();
        return ()=>{
            isCancelled = true;
        };
    }, [
        profilecardProviderPromise
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Workaround an issue where the selection is not updated immediately after adding
        // a mention when "sanitizePrivateContent" is enabled in the editor on safari.
        // This affects both insertion and paste behaviour it is applied to the component.
        // https://product-fabric.atlassian.net/browse/ED-14859
        if ((0, $gE8f9.browser).safari) setTimeout($025b76ba896f03f7$var$refreshBrowserSelection, 0);
    }, []);
    const actionHandlers = {};
    [
        'onClick',
        'onMouseEnter',
        'onMouseLeave'
    ].forEach((handler)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        actionHandlers[handler] = eventHandlers && eventHandlers[handler] || (()=>{});
    });
    if (profilecardProvider) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b6FQr.default), {
        autoFocus: false,
        id: id,
        text: resolvedName,
        accessLevel: accessLevel,
        mentionProvider: mentionProvider,
        profilecardProvider: profilecardProvider,
        localId: localId,
        ...actionHandlers
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kmW28.default), {
        id: id,
        text: resolvedName,
        accessLevel: accessLevel,
        mentionProvider: mentionProvider,
        localId: localId,
        ...actionHandlers
    });
};
const $025b76ba896f03f7$var$useResolvedName = (id, text, mentionProvider)=>{
    const [resolvedName, setResolvedName] = (0, $5uXOq.useState)(text);
    const processName = (name)=>{
        if (name.status === (0, $cqJWb.MentionNameStatus).OK) return `@${name.name || ''}`;
        else return `@_|unknown|_`;
    };
    (0, $5uXOq.useEffect)(()=>{
        if (mentionProvider) mentionProvider.then(async (provider)=>{
            if (!text && (0, $3mm6g.isResolvingMentionProvider)(provider)) {
                const nameDetail = provider.resolveMentionName(id);
                if ((0, $cqJWb.isPromise)(nameDetail)) return processName(await nameDetail);
                else return processName(nameDetail);
            } else return text;
        }).then((resolvedName)=>{
            setResolvedName(resolvedName);
        });
    }, [
        id,
        text,
        mentionProvider
    ]);
    return resolvedName;
};

});
parcelRegister("b6FQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d478a209170c68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kmW28 = parcelRequire("kmW28");

var $37PA3 = parcelRequire("37PA3");
function $b7d478a209170c68$export$2e2bcd8739ae039({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId }) {
    const { cloudId: cloudId, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $5uXOq.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37PA3.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        ariaLabel: text.replace(/^@/, ''),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kmW28.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        })
    });
}

});
parcelRegister("kmW28", function(module, exports) {

$parcel$export(module.exports, "default", () => $e858e38a821330f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3mm6g = parcelRequire("3mm6g");

var $cqJWb = parcelRequire("cqJWb");

var $8dw1i = parcelRequire("8dw1i");

var $6Ctoj = parcelRequire("6Ctoj");
class $e858e38a821330f3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $3mm6g.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $cqJWb.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $6Ctoj.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $cqJWb.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $cqJWb.MentionNameStatus).SERVICE_ERROR:
            case (0, $cqJWb.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $8dw1i.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8dw1i.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave
        });
    }
}

});
parcelRegister("8dw1i", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $359ac0149aaccbc2$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $359ac0149aaccbc2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $kbF2s = parcelRequire("kbF2s");

var $ab8uA = parcelRequire("ab8uA");

var $k3AGD = parcelRequire("k3AGD");

var $cqJWb = parcelRequire("cqJWb");

var $4kfbr = parcelRequire("4kfbr");

var $cb25w = parcelRequire("cb25w");

var $jZA09 = parcelRequire("jZA09");

var $j6B3T = parcelRequire("j6B3T");

var $bTspB = parcelRequire("bTspB");
const $359ac0149aaccbc2$export$7452d7062a4d0634 = 1000;
const $359ac0149aaccbc2$export$af8124aa496797f2 = '_|unknown|_';
class $359ac0149aaccbc2$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $359ac0149aaccbc2$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $cqJWb.MentionType).SELF;
            if ((0, $cqJWb.isRestricted)(accessLevel)) return (0, $cqJWb.MentionType).RESTRICTED;
            return (0, $cqJWb.MentionType).DEFAULT;
        };
        (0, $bTspB.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $bTspB.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $bTspB.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $jZA09.UFOExperienceState)['STARTED'],
            (0, $jZA09.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6B3T.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$359ac0149aaccbc2$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $cqJWb.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ab8uA.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bTspB.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbF2s.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3AGD.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $359ac0149aaccbc2$var$MentionWithAnalytics = (0, $cb25w.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4kfbr.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4kfbr.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($359ac0149aaccbc2$export$92ab8442e7a15cef);
const $359ac0149aaccbc2$var$Mention = $359ac0149aaccbc2$var$MentionWithAnalytics;
var $359ac0149aaccbc2$export$2e2bcd8739ae039 = $359ac0149aaccbc2$var$Mention;

});
parcelRegister("kbF2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2323b0dd270b712$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $j6B3T = parcelRequire("j6B3T");
const $a2323b0dd270b712$var$EMPTY = {};
const $a2323b0dd270b712$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($a2323b0dd270b712$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($a2323b0dd270b712$var$EMPTY);
        (0, $j6B3T.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $a2323b0dd270b712$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $koVbs.default)();
    const messages = $a2323b0dd270b712$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $a2323b0dd270b712$export$2e2bcd8739ae039 = $a2323b0dd270b712$var$MessagesIntlProvider;

});
parcelRegister("j6B3T", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $2ed9ffbf75c73a6c$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $2ed9ffbf75c73a6c$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $2ed9ffbf75c73a6c$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $2ed9ffbf75c73a6c$export$d0a3169680473b6c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8aQI9 = parcelRequire("8aQI9");
const $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $2ed9ffbf75c73a6c$export$98e06fe7a6174253 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).unknownUserError);
const $2ed9ffbf75c73a6c$export$58bd5a2057b6b855 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).noAccessWarning);
const $2ed9ffbf75c73a6c$export$da9f8ce14593162f = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).noAccessLabel);
const $2ed9ffbf75c73a6c$export$4a258ffee7316766 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).defaultHeadline);
const $2ed9ffbf75c73a6c$export$702321a50d74536e = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).defaultAdvisedAction);
const $2ed9ffbf75c73a6c$export$ed7f16088a93ae9d = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).loginAgain);
const $2ed9ffbf75c73a6c$export$3ab158df56460d1c = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, $8aQI9.messages).differentText);































const $2ed9ffbf75c73a6c$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("fPyR5")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("d8Ulq")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("7WKiB")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("66Hai")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("1Azr6")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("ceUid")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("imiLL")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("fzYxu")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("50SvZ")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4KJ3I")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("9n0S7")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("7MkZ1")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("hPCID")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("7Z7ZI")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("cWcD9")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("bRMAA")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("9N4h9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("dTCxR")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("1vwox")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7zNXb")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dvYlT")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("gwSnb")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("8cruq")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("dzC34")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("jMBvi")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("5qCSb")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("5frdN")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("8NaEX")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("hwknJ")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("jomQG")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2ed9ffbf75c73a6c$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("66Hai")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("8aQI9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6ca607c1e1522de5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6ca607c1e1522de5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("fPyR5", function(module, exports) {

let $b866a7fabe92dfdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b866a7fabe92dfdc$var$load("dsDeQ").then(()=>parcelRequire('dTLgY'));

});

parcelRegister("d8Ulq", function(module, exports) {

let $9917ba989184e699$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9917ba989184e699$var$load("6dIE2").then(()=>parcelRequire('keyh3'));

});

parcelRegister("7WKiB", function(module, exports) {

let $5c91dd3a9f26c791$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5c91dd3a9f26c791$var$load("jYcAq").then(()=>parcelRequire('eL3iu'));

});

parcelRegister("66Hai", function(module, exports) {

let $4724c94feda73ad4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4724c94feda73ad4$var$load("6MuqU").then(()=>parcelRequire('wBhQ2'));

});

parcelRegister("1Azr6", function(module, exports) {

let $1284a4216b08215d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1284a4216b08215d$var$load("l8igA").then(()=>parcelRequire('27EyS'));

});

parcelRegister("ceUid", function(module, exports) {

let $8e9275682a4023a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e9275682a4023a5$var$load("cp1kc").then(()=>parcelRequire('eoxiv'));

});

parcelRegister("imiLL", function(module, exports) {

let $d5d8d7467b96ff2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5d8d7467b96ff2a$var$load("tBMef").then(()=>parcelRequire('6jEIT'));

});

parcelRegister("fzYxu", function(module, exports) {

let $b57915bd849d4c26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b57915bd849d4c26$var$load("e4cqm").then(()=>parcelRequire('dkMw7'));

});

parcelRegister("50SvZ", function(module, exports) {

let $3a673d6432a4e3c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a673d6432a4e3c8$var$load("yHeUA").then(()=>parcelRequire('5NjhV'));

});

parcelRegister("4KJ3I", function(module, exports) {

let $375e69166acd46ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $375e69166acd46ba$var$load("69FtF").then(()=>parcelRequire('bWMX4'));

});

parcelRegister("9n0S7", function(module, exports) {

let $6d26f02f29aa7bc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d26f02f29aa7bc8$var$load("1SwVQ").then(()=>parcelRequire('aPy43'));

});

parcelRegister("7MkZ1", function(module, exports) {

let $5a9d4aedc93beac3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a9d4aedc93beac3$var$load("iMqxw").then(()=>parcelRequire('6FrOe'));

});

parcelRegister("hPCID", function(module, exports) {

let $cfb53bd938dfab46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfb53bd938dfab46$var$load("i9sdu").then(()=>parcelRequire('epfvh'));

});

parcelRegister("7Z7ZI", function(module, exports) {

let $5d046e711e21fea1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d046e711e21fea1$var$load("aydQg").then(()=>parcelRequire('hjvLU'));

});

parcelRegister("cWcD9", function(module, exports) {

let $96b4b2f8299e9753$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96b4b2f8299e9753$var$load("5znUH").then(()=>parcelRequire('dclct'));

});

parcelRegister("bRMAA", function(module, exports) {

let $8a3a55ba62b1ac51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a3a55ba62b1ac51$var$load("1lvxw").then(()=>parcelRequire('56DDk'));

});

parcelRegister("9N4h9", function(module, exports) {

let $720c01b8e2435912$var$load = (parcelRequire("28QjX"))(4);
module.exports = $720c01b8e2435912$var$load("7yQmI").then(()=>parcelRequire('1Vmnr'));

});

parcelRegister("dTCxR", function(module, exports) {

let $a1de4faf5cb6d125$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1de4faf5cb6d125$var$load("6TpZW").then(()=>parcelRequire('lTYFq'));

});

parcelRegister("1vwox", function(module, exports) {

let $1191d09def236a27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1191d09def236a27$var$load("2eSUb").then(()=>parcelRequire('hxNc0'));

});

parcelRegister("7zNXb", function(module, exports) {

let $58428d06a04c9999$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58428d06a04c9999$var$load("fUluO").then(()=>parcelRequire('h7PMN'));

});

parcelRegister("dvYlT", function(module, exports) {

let $9d6cfc4c4f81da5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d6cfc4c4f81da5d$var$load("DchKe").then(()=>parcelRequire('3T3Pt'));

});

parcelRegister("gwSnb", function(module, exports) {

let $c089cfd0d365cdb2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c089cfd0d365cdb2$var$load("eYBMi").then(()=>parcelRequire('jvE81'));

});

parcelRegister("8cruq", function(module, exports) {

let $5f84c4a122f8d1fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f84c4a122f8d1fc$var$load("6q2et").then(()=>parcelRequire('lxjSE'));

});

parcelRegister("dzC34", function(module, exports) {

let $9e1c0ede9f7b180a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e1c0ede9f7b180a$var$load("iINAq").then(()=>parcelRequire('fIX00'));

});

parcelRegister("jMBvi", function(module, exports) {

let $e66f9780892e0422$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e66f9780892e0422$var$load("ibfKG").then(()=>parcelRequire('kbvg1'));

});

parcelRegister("5qCSb", function(module, exports) {

let $3f3d88cbaf674b39$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f3d88cbaf674b39$var$load("80oK6").then(()=>parcelRequire('2eUU2'));

});

parcelRegister("5frdN", function(module, exports) {

let $3d237818f4027a7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3d237818f4027a7b$var$load("9X4yo").then(()=>parcelRequire('kxF7S'));

});

parcelRegister("8NaEX", function(module, exports) {

let $666b2b1ac16e3915$var$load = (parcelRequire("28QjX"))(4);
module.exports = $666b2b1ac16e3915$var$load("hYMIE").then(()=>parcelRequire('aIfZT'));

});

parcelRegister("hwknJ", function(module, exports) {

let $cc153c3a43b299e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc153c3a43b299e0$var$load("cjVNf").then(()=>parcelRequire('lVs4z'));

});

parcelRegister("jomQG", function(module, exports) {

let $e1e1fb78e24836d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1e1fb78e24836d0$var$load("16rPB").then(()=>parcelRequire('bY3rp'));

});



parcelRegister("ab8uA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6273a4608d138fff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $cqJWb = parcelRequire("cqJWb");

var $5uXOq = parcelRequire("5uXOq");
const $6273a4608d138fff$var$mentionStyle = {
    [(0, $cqJWb.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    },
    [(0, $cqJWb.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $cqJWb.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    }
};
const $6273a4608d138fff$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $6273a4608d138fff$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $6273a4608d138fff$var$PrimitiveMention = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)("display:inline;border:1px solid ", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $6273a4608d138fff$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $6273a4608d138fff$export$2e2bcd8739ae039 = $6273a4608d138fff$var$PrimitiveMention;

});

parcelRegister("k3AGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4938be5a70d0163$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $e4938be5a70d0163$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("eEwz1")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $e4938be5a70d0163$export$2e2bcd8739ae039 = $e4938be5a70d0163$var$AsyncNoAccessTooltip;

});
parcelRegister("eEwz1", function(module, exports) {

let $aaae0f9a4fd8ce85$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aaae0f9a4fd8ce85$var$load("8n8M3").then(()=>parcelRequire('4YERU'));

});


parcelRegister("bTspB", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $fb9391c5736559e1$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $fb9391c5736559e1$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $fb9391c5736559e1$export$1d011e4240507c78 = new (0, $cBycP.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
class $fb9391c5736559e1$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $fb9391c5736559e1$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("37PA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0fdc37b33e30ae$export$2e2bcd8739ae039);


var $dYuIx = parcelRequire("dYuIx");

var $264zF = parcelRequire("264zF");
var $1f0fdc37b33e30ae$export$2e2bcd8739ae039 = (0, $264zF.default);

});
parcelRegister("dYuIx", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $78b4a66e55984f2d$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $78b4a66e55984f2d$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9jxN3")));

});
parcelRegister("9jxN3", function(module, exports) {

let $6c80196f700d9a25$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c80196f700d9a25$var$load("h2MrD"),
    $6c80196f700d9a25$var$load("bYT2S"),
    $6c80196f700d9a25$var$load("l3dV9")
]).then(()=>parcelRequire('lrMir'));

});


parcelRegister("264zF", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b3c02273951832$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $adIkV = parcelRequire("adIkV");
var $gH4E9 = parcelRequire("gH4E9");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $4sfdL = parcelRequire("4sfdL");

var $chprS = parcelRequire("chprS");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");


var $kDbj5 = parcelRequire("kDbj5");

var $dYuIx = parcelRequire("dYuIx");

var $ifxzB = parcelRequire("ifxzB");
function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDbj5.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $VSDnB.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $4sfdL.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $k5uoT.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $VSDnB.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adIkV.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $gH4E9.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("adIkV", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $c3877992df568d20$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $c3877992df568d20$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7rsnG")));

});
parcelRegister("7rsnG", function(module, exports) {

let $56b111e3894d3389$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $56b111e3894d3389$var$load("cM9em"),
    $56b111e3894d3389$var$load("fr9NE"),
    $56b111e3894d3389$var$load("h2MrD"),
    $56b111e3894d3389$var$load("bYT2S"),
    $56b111e3894d3389$var$load("HRhLG")
]).then(()=>parcelRequire('iRLc5'));

});


parcelRegister("gH4E9", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $b9e3bff5640b4187$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $b9e3bff5640b4187$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $b9e3bff5640b4187$export$7a1fc1a1b0477464);
var $b9e3bff5640b4187$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $b9e3bff5640b4187$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("4sfdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1251cd76451c32$export$2e2bcd8739ae039);
const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;

});

parcelRegister("chprS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b051cf4c3ebf799$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
        fullName: fullName
    }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
};
const $4b051cf4c3ebf799$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;

});

parcelRegister("jnj6z", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a03faa2abdc74ae6$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $a03faa2abdc74ae6$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $a03faa2abdc74ae6$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $a03faa2abdc74ae6$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $a03faa2abdc74ae6$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $a03faa2abdc74ae6$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $a03faa2abdc74ae6$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $a03faa2abdc74ae6$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $a03faa2abdc74ae6$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $a03faa2abdc74ae6$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $a03faa2abdc74ae6$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $a03faa2abdc74ae6$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $a03faa2abdc74ae6$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $a03faa2abdc74ae6$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $a03faa2abdc74ae6$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $a03faa2abdc74ae6$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $a03faa2abdc74ae6$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");


var $k5uoT = parcelRequire("k5uoT");

var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformationCompiled = null;
const $a03faa2abdc74ae6$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $a03faa2abdc74ae6$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo19"
})("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ProfileImageLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $a03faa2abdc74ae6$export$d395c8d16f1e359d = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, $f8Sb3.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo16"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationLegacy, {});
const $a03faa2abdc74ae6$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {});
const $a03faa2abdc74ae6$export$58517bb1b373a54c = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimationWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo15"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $k5uoT.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $a03faa2abdc74ae6$export$6196a3f52a6944fe = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo14"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $a03faa2abdc74ae6$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionButtonGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo13"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo12"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "1jc6z0y",
    styles: "display:flex;flex-direction:column;min-height:136px"
});
const $a03faa2abdc74ae6$export$35cf684daac137ac = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo10"
})({
    name: "c8pdei",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px"
});
const $a03faa2abdc74ae6$export$2062e7265a95a823 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DisabledInfoLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo9"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$LozengeWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$JobTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AppTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, $k5uoT.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo4"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});
const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContainer, isDisabledUser ? $a03faa2abdc74ae6$var$styles.cardContainerDisabledUser : $a03faa2abdc74ae6$var$styles.cardContainerActiveUser, !withoutElevation && $a03faa2abdc74ae6$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $k5uoT.borderRadius)()}px`, ";overflow:hidden;");
const $a03faa2abdc74ae6$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabel, extraTopSpace && $a03faa2abdc74ae6$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "vjwven",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}"
});
const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dt",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelIconLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dd",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("huHkE", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $61d9a2704bf54ca1$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $61d9a2704bf54ca1$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $61d9a2704bf54ca1$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $61d9a2704bf54ca1$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $61d9a2704bf54ca1$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $61d9a2704bf54ca1$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $61d9a2704bf54ca1$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $61d9a2704bf54ca1$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $61d9a2704bf54ca1$export$be3c814f7ed506ed);

const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;

});


parcelRegister("ivXTE", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $533bc31bb6af10e0$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $533bc31bb6af10e0$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $533bc31bb6af10e0$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $533bc31bb6af10e0$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $533bc31bb6af10e0$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $533bc31bb6af10e0$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $533bc31bb6af10e0$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $533bc31bb6af10e0$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $533bc31bb6af10e0$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $533bc31bb6af10e0$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $533bc31bb6af10e0$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $533bc31bb6af10e0$export$a9f8c9f412cf5664);

var $6TKEY = parcelRequire("6TKEY");
/** Below lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $533bc31bb6af10e0$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $533bc31bb6af10e0$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $6TKEY.getPageTime)())
        }
    });
const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $533bc31bb6af10e0$var$USER_SUBJECT;
        case 'team':
            return $533bc31bb6af10e0$var$TEAM_SUBJECT;
        case 'agent':
            return $533bc31bb6af10e0$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("6TKEY", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $83ec369559ddc36d$export$e9faea7c41053334);
const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
const $83ec369559ddc36d$var$initialPageTime = Date.now();
const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
    if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
    return Date.now() - $83ec369559ddc36d$var$initialPageTime;
};

});


const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;

parcelRegister("kDbj5", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $9f87d208f89c63eb$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ivXTE = parcelRequire("ivXTE");

var $dG58U = parcelRequire("dG58U");

var $cI0Td = parcelRequire("cI0Td");

var $a3FJs = parcelRequire("a3FJs");

var $iwWWV = parcelRequire("iwWWV");
const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3FJs.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("dG58U", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $dd4eeae2be471029$export$3761e66a04602cbd);
const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("cI0Td", function(module, exports) {

$parcel$export(module.exports, "default", () => $f71e8c5b4eb5da96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $hI6SY = parcelRequire("hI6SY");

var $d5Zn3 = parcelRequire("d5Zn3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $2uTKk = parcelRequire("2uTKk");

var $ivXTE = parcelRequire("ivXTE");
const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uTKk.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;

});
parcelRegister("2uTKk", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0619b202cbb0de2c$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0619b202cbb0de2c$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $0619b202cbb0de2c$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
const $0619b202cbb0de2c$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $0619b202cbb0de2c$export$bb27b7e39840238f = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorIconColor)
});
const $0619b202cbb0de2c$export$b065fd053267ec81 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0619b202cbb0de2c$export$90d92ccfb27352c6 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("a3FJs", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $642b3278878bc39a$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $642b3278878bc39a$var$styles = (0, $8CUq3.xcss)({
    width: '360px'
});
const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $642b3278878bc39a$var$styles,
        children: children
    });
};

});

parcelRegister("iwWWV", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $b487397875f853f0$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $b487397875f853f0$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2K454")));

});
parcelRegister("2K454", function(module, exports) {

let $1ff30b051f5792f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1ff30b051f5792f2$var$load("cM9em"),
    $1ff30b051f5792f2$var$load("fr9NE"),
    $1ff30b051f5792f2$var$load("h2MrD"),
    $1ff30b051f5792f2$var$load("bYT2S"),
    $1ff30b051f5792f2$var$load("cLGTI")
]).then(()=>parcelRequire('9gV7o'));

});



parcelRegister("ifxzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $44786ae639641a68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");
const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });
};
var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;

});






parcelRegister("h1zDo", function(module, exports) {

$parcel$export(module.exports, "MentionNodeView", () => $91dec7029a5869f3$export$ed501823ec7e75de);

var $gE8f9 = parcelRequire("gE8f9");


var $kCV8T = parcelRequire("kCV8T");

var $3mm6g = parcelRequire("3mm6g");
var $cqJWb = parcelRequire("cqJWb");

var $cqJWb = parcelRequire("cqJWb");

var $4KmiJ = parcelRequire("4KmiJ");
const $91dec7029a5869f3$var$primitiveClassName = 'editor-mention-primitive';
const $91dec7029a5869f3$var$getAccessibilityLabelFromName = (name)=>name.replace(/^@/u, '');
const $91dec7029a5869f3$var$toDOM = (node)=>{
    // packages/elements/mention/src/components/Mention/index.tsx
    const mentionAttrs = {
        contenteditable: 'false',
        'data-access-level': node.attrs.accessLevel,
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        'data-prosemirror-node-view-type': 'vanilla',
        class: 'mentionView-content-wrap inlineNodeView'
    };
    return [
        'span',
        mentionAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)
            ]
        ],
        [
            'span',
            {
                spellcheck: 'false',
                class: $91dec7029a5869f3$var$primitiveClassName
            },
            node.attrs.text || "@\u2026"
        ],
        (0, $gE8f9.browser).android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contenteditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)
        ]
    ];
};
const $91dec7029a5869f3$var$processName = (name)=>{
    return name.status === (0, $cqJWb.MentionNameStatus).OK ? `@${name.name || ''}` : `@_|unknown|_`;
};
const $91dec7029a5869f3$var$handleProviderName = async (mentionProvider, node)=>{
    if ((0, $3mm6g.isResolvingMentionProvider)(mentionProvider) && node.attrs.id && !node.attrs.text) {
        const nameDetail = mentionProvider?.resolveMentionName(node.attrs.id);
        const resolvedNameDetail = await nameDetail;
        return $91dec7029a5869f3$var$processName(resolvedNameDetail);
    }
};
const $91dec7029a5869f3$var$getNewState = (isHighlighted, isRestricted)=>{
    if (isHighlighted) return 'self';
    if (isRestricted) return 'restricted';
    return 'default';
};
class $91dec7029a5869f3$export$ed501823ec7e75de {
    constructor(node, config){
        this.state = 'default';
        const { options: options, api: api, portalProviderAPI: portalProviderAPI } = config;
        const { dom: dom, contentDOM: contentDOM } = (0, $kCV8T.DOMSerializer).renderSpec(document, $91dec7029a5869f3$var$toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.config = config;
        this.node = node;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        this.mentionPrimitiveElement = this.domElement ? this.domElement.querySelector(`.${$91dec7029a5869f3$var$primitiveClassName}`) ?? undefined : undefined;
        const { mentionProvider: mentionProvider } = api?.mention.sharedState.currentState() ?? {};
        this.updateState(mentionProvider);
        this.cleanup = api?.mention.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateState(nextSharedState?.mentionProvider);
        });
        const { destroyProfileCard: destroyProfileCard, removeProfileCard: removeProfileCard } = (0, $4KmiJ.profileCardRenderer)({
            dom: dom,
            options: options,
            portalProviderAPI: portalProviderAPI,
            node: node,
            api: api
        });
        // Accessibility attributes - based on `packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx`
        if (this.domElement && options?.profilecardProvider) {
            if (node.attrs.text) this.domElement.setAttribute('aria-label', $91dec7029a5869f3$var$getAccessibilityLabelFromName(node.attrs.text));
            this.domElement.setAttribute('aria-expanded', 'false');
            this.domElement.setAttribute('role', 'button');
            this.domElement.setAttribute('tabindex', '0');
            this.domElement.setAttribute('aria-haspopup', 'dialog');
        }
        this.destroyProfileCard = destroyProfileCard;
        this.removeProfileCard = removeProfileCard;
    }
    setClassList(state) {
        this.mentionPrimitiveElement?.classList.toggle('mention-self', state === 'self');
        this.mentionPrimitiveElement?.classList.toggle('mention-restricted', state === 'restricted');
    }
    setTextContent(name) {
        if (name && !this.node.attrs.text && this.mentionPrimitiveElement) this.mentionPrimitiveElement.textContent = name;
    }
    async updateState(mentionProvider) {
        const isHighlighted = mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
        const newState = $91dec7029a5869f3$var$getNewState(isHighlighted, (0, $cqJWb.isRestricted)(this.node.attrs.accessLevel));
        if (newState !== this.state) {
            this.setClassList(newState);
            this.state = newState;
        }
        const name = await $91dec7029a5869f3$var$handleProviderName(mentionProvider, this.node);
        this.setTextContent(name);
        if (name && this.domElement && this.config.options?.profilecardProvider) this.domElement.setAttribute('aria-label', $91dec7029a5869f3$var$getAccessibilityLabelFromName(name));
    }
    nodeIsEqual(nextNode) {
        if (this.config.options?.sanitizePrivateContent) {
            // Compare nodes but ignore the text parameter as it may be sanitized
            const nextNodeAttrs = {
                ...nextNode.attrs,
                text: this.node.attrs.text
            };
            return this.node.hasMarkup(nextNode.type, nextNodeAttrs, nextNode.marks);
        }
        return this.node.sameMarkup(nextNode);
    }
    update(node) {
        if (!this.nodeIsEqual(node)) return false;
        this.node = node;
        return true;
    }
    destroy() {
        this.cleanup?.();
        this.destroyProfileCard?.();
    }
    deselectNode() {
        this.removeProfileCard?.();
    }
}

});
parcelRegister("4KmiJ", function(module, exports) {

$parcel$export(module.exports, "profileCardRenderer", () => $150f369763e144a4$export$6adf928fbc333163);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bXrHm = parcelRequire("bXrHm");

var $gZGBX = parcelRequire("gZGBX");

var $bZqJA = parcelRequire("bZqJA");
const $150f369763e144a4$export$6adf928fbc333163 = ({ dom: dom, options: options, portalProviderAPI: portalProviderAPI, node: node, api: api })=>{
    let renderingProfileCard = false;
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
    let cleanupSelection;
    const removeProfileCard = ()=>{
        if (dom instanceof HTMLElement) dom.setAttribute('aria-expanded', 'false');
        portalProviderAPI.remove(key);
        renderingProfileCard = false;
        cleanupSelection?.();
    };
    const listenerCleanup = (0, $cBeZP.bind)(dom, {
        type: 'click',
        listener: ()=>{
            if (dom instanceof HTMLElement && options?.profilecardProvider && !renderingProfileCard) {
                dom.setAttribute('aria-expanded', 'true');
                renderingProfileCard = true;
                portalProviderAPI.render(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bZqJA.ProfileCardComponent), {
                        activeMention: node,
                        profilecardProvider: options?.profilecardProvider,
                        dom: dom,
                        closeComponent: removeProfileCard
                    }), dom, key);
                // If we change the selection we should also remove the profile card. The "deselectNode"
                // should usually catch this, but it's possible (ie. on triple click) for this not to be called
                // which means the profile card gets stuck open until you click + change selection
                cleanupSelection = api?.selection?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                    const selection = nextSharedState?.selection;
                    if (selection instanceof (0, $gZGBX.NodeSelection) ? selection.node === node : false) return;
                    removeProfileCard?.();
                });
            }
        }
    });
    return {
        destroyProfileCard: ()=>{
            listenerCleanup();
            removeProfileCard?.();
        },
        removeProfileCard: removeProfileCard
    };
};

});
parcelRegister("bZqJA", function(module, exports) {

$parcel$export(module.exports, "ProfileCardComponent", () => $985d8af8f3e20d49$export$cbc1b955d6cce80d);
/* ProfileCardComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $dYuIx = parcelRequire("dYuIx");

var $6IjhW = parcelRequire("6IjhW");
const $985d8af8f3e20d49$var$styles = {
    loadingStyles: "_2rkoglpi _16qs1cd0"
};
const $985d8af8f3e20d49$var$LoadingWrapper = ({ children: children, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $985d8af8f3e20d49$var$styles.loadingStyles
        ]),
        children: children
    }) : children;
const $985d8af8f3e20d49$export$2776629671584a76 = ({ id: id, provider: provider })=>{
    const [data, setData] = (0, $5uXOq.useState)();
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    // From: packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id || !provider) return;
            setIsLoading(true);
            try {
                const [data, reportingLines, shouldGiveKudos, teamCentralBaseUrl] = await Promise.all([
                    provider?.resourceClient.getProfile(provider?.cloudId || '', id, ()=>{}),
                    provider?.resourceClient.getReportingLines(id),
                    provider?.resourceClient.shouldShowGiveKudos(),
                    provider?.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                setData(data);
                setReportingLinesData(reportingLines);
                setShouldShowGiveKudos(shouldGiveKudos ?? false);
                setTeamCentralBaseUrl(teamCentralBaseUrl);
                setHasError(false);
            } catch (e) {
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id,
        provider
    ]);
    return {
        data: data,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isLoading: isLoading,
        hasError: hasError
    };
};
function $985d8af8f3e20d49$export$cbc1b955d6cce80d({ profilecardProvider: profilecardProvider, activeMention: activeMention, dom: dom, closeComponent: closeComponent }) {
    const [provider, setProvider] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        profilecardProvider?.then((p)=>{
            setProvider(p);
        });
    }, [
        profilecardProvider
    ]);
    const { id: id, text: text, accessLevel: accessLevel } = activeMention.attrs ?? {};
    const actions = (0, $5uXOq.useMemo)(()=>provider?.getActions(id, text ?? '', accessLevel), [
        accessLevel,
        id,
        provider,
        text
    ]);
    const { data: data, reportingLinesData: reportingLinesData, shouldShowGiveKudos: shouldShowGiveKudos, teamCentralBaseUrl: teamCentralBaseUrl, isLoading: isLoading, hasError: hasError } = $985d8af8f3e20d49$export$2776629671584a76({
        id: id,
        provider: provider
    });
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') closeComponent();
            }
        });
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6IjhW.Popup), {
        referenceElement: dom,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($985d8af8f3e20d49$var$LoadingWrapper, {
            isLoading: isLoading,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYuIx.ProfileCardLazy), {
                avatarUrl: data?.avatarUrl,
                accountType: data?.accountType,
                status: data?.status,
                statusModifiedDate: data?.statusModifiedDate,
                timestring: data?.timestring,
                isCurrentUser: data?.isCurrentUser,
                isBot: data?.isBot,
                fullName: data?.fullName,
                userId: id,
                cloudId: provider?.cloudId,
                actions: actions,
                isLoading: isLoading,
                location: data?.location,
                companyName: data?.companyName,
                customLozenges: data?.customLozenges,
                nickname: data?.nickname,
                email: data?.email,
                hasError: hasError,
                reportingLines: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            })
        })
    });
}

});
parcelRegister("6IjhW", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $dcbc3a04bc39697a$export$129a32eedafa97c5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4oNEb = parcelRequire("4oNEb");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $dlbQo = parcelRequire("dlbQo");
const $dcbc3a04bc39697a$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        children
    ]);
    return children;
};
function $dcbc3a04bc39697a$export$129a32eedafa97c5({ referenceElement: referenceElement, children: children }) {
    const [targetRef, setPopupRef] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    (0, $dlbQo.useFocusTrap)({
        targetRef: targetRef
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
        zIndex: (0, $k5uoT.layers).modal(),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
            referenceElement: referenceElement,
            offset: [
                0,
                8
            ],
            placement: "bottom-end",
            strategy: "fixed",
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: (node)=>{
                        if (node) {
                            if (typeof ref === 'function') ref(node);
                            else ref.current = node;
                            setPopupRef(node);
                        }
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: style,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($dcbc3a04bc39697a$export$51eddd7655ca235a, {
                        update: update,
                        children: children
                    })
                })
        })
    });
}

});
parcelRegister("dlbQo", function(module, exports) {

$parcel$export(module.exports, "useFocusTrap", () => $8692239a24241ec4$export$5562a1f223a0d314);
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");
const $8692239a24241ec4$export$5562a1f223a0d314 = ({ targetRef: targetRef })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef
    ]);
};

});





const $30b3e1d387967ff3$export$7d0bcf8324b20190 = 'REJECTED';
const $30b3e1d387967ff3$export$eceeecffdf63fc89 = 'UNDEFINED';

parcelRegister("3YSIX", function(module, exports) {

$parcel$export(module.exports, "getMentionPluginState", () => $0aba1155225a8eec$export$1e2b0e72eff65e51);
$parcel$export(module.exports, "canMentionBeCreatedInRange", () => $0aba1155225a8eec$export$bdc4118452fb5868);

var $5r0mK = parcelRequire("5r0mK");

var $kjnx4 = parcelRequire("kjnx4");
function $0aba1155225a8eec$export$1e2b0e72eff65e51(state) {
    return (0, $kjnx4.mentionPluginKey).getState(state);
}
const $0aba1155225a8eec$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $5r0mK.canInsert)($from, mention)) return true;
        return false;
    };

});


parcelRegister("cJYsD", function(module, exports) {

$parcel$export(module.exports, "SecondaryToolbarComponent", () => $07a99b0725dcd506$export$124ea4367cf7d1fc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $awTmI = parcelRequire("awTmI");

var $8jqpR = parcelRequire("8jqpR");
function $07a99b0725dcd506$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    const { mentionState: mentionState } = (0, $awTmI.useSharedPluginState)(api, [
        'mention'
    ]);
    const openMentionTypeAhead = (0, $5uXOq.useCallback)(()=>{
        api?.typeAhead?.actions?.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $gkwXh.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionState?.mentionProvider ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8jqpR.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || api?.typeAhead?.actions.isAllowed(editorView.state)
    });
}

});
parcelRegister("8jqpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b157100671171858$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $7ywdr = parcelRequire("7ywdr");

var $l4tMX = parcelRequire("l4tMX");
var $1jI4k = parcelRequire("1jI4k");

var $kKn0Y = parcelRequire("kKn0Y");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b157100671171858$var$ToolbarMention extends (0, $5uXOq.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $7ywdr.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1jI4k.default), {
            testId: this.props.testId,
            buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kKn0Y))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args), this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
var $b157100671171858$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b157100671171858$var$ToolbarMention);

});
parcelRegister("l4tMX", function(module, exports) {

$parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", () => $1393bb315c311409$export$f90c25d407b3694a);
var $1393bb315c311409$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});

});

parcelRegister("kKn0Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8421189d331f9e049ee797d0467057ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1a9f4c691bc9057$var$_react = $f1a9f4c691bc9057$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f1a9f4c691bc9057$var$_mention = $f1a9f4c691bc9057$var$_interopRequireDefault((parcelRequire("izMdR")));

var $f1a9f4c691bc9057$var$_mention2 = $f1a9f4c691bc9057$var$_interopRequireDefault((parcelRequire("3kXe9")));
function $f1a9f4c691bc9057$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MentionIcon.
 * This component is MentionIcon, with `UNSAFE_fallbackIcon` set to "EditorMentionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1a9f4c691bc9057$var$MentionIcon = (props)=>/*#__PURE__*/ $f1a9f4c691bc9057$var$_react.default.createElement($f1a9f4c691bc9057$var$_mention.default, Object.assign({
        LEGACY_fallbackIcon: $f1a9f4c691bc9057$var$_mention2.default
    }, props));
$f1a9f4c691bc9057$var$MentionIcon.Name = 'MentionIconMigration';
var $f1a9f4c691bc9057$var$_default = module.exports.default = $f1a9f4c691bc9057$var$MentionIcon;

});
parcelRegister("3kXe9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26e12eaafd006aef$var$_react = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $26e12eaafd006aef$var$_mention = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("izMdR")));
function $26e12eaafd006aef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $26e12eaafd006aef$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $26e12eaafd006aef$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $26e12eaafd006aef$var$_mention.default
    }));
$26e12eaafd006aef$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $26e12eaafd006aef$var$_default = module.exports.default = $26e12eaafd006aef$var$EditorMentionIcon;

});




parcelRegister("1sH5c", function(module, exports) {

$parcel$export(module.exports, "createTypeAheadConfig", () => $bcbbbc00187a2c8c$export$90e81ee10e57772b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $3UtTx = parcelRequire("3UtTx");

var $h03xs = parcelRequire("h03xs");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $1avEh = parcelRequire("1avEh");
var $4j0XL = parcelRequire("4j0XL");

var $3mm6g = parcelRequire("3mm6g");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $3YSIX = parcelRequire("3YSIX");

var $eVETA = parcelRequire("eVETA");

var $hbceX = parcelRequire("hbceX");

var $f1PQ3 = parcelRequire("f1PQ3");
const $bcbbbc00187a2c8c$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount })=>({
        title: (0, $eVETA.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eVETA.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            }),
        mention: (0, $eVETA.INVITE_ITEM_DESCRIPTION)
    });
const $bcbbbc00187a2c8c$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount })=>(mentionItems)=>{
        const inviteItem = $bcbbbc00187a2c8c$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount
        });
        const keepInviteItem = (0, $f1PQ3.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $bcbbbc00187a2c8c$export$f476360102d72b2 = (mention)=>{
    return {
        title: mention.id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4j0XL.default), {
                mention: mention,
                selected: isSelected,
                onMouseEnter: onHover,
                onSelection: onClick
            }),
        getCustomComponentHeight: ()=>{
            return 0, $1avEh.MENTION_ITEM_HEIGHT;
        },
        mention: mention
    };
};
function $bcbbbc00187a2c8c$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $bcbbbc00187a2c8c$var$memoizedToItem = $bcbbbc00187a2c8c$export$fc10aeed3a532e2a($bcbbbc00187a2c8c$export$f476360102d72b2);
const $bcbbbc00187a2c8c$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        let xProductMentionsLength = 0;
        if (!(0, $f1PQ3.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
            xProductMentionsLength = mentions.filter((mention)=>mention.isXProductUser).length;
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $f1PQ3.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    includesYou: mention.context.includesYou,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $hbceX.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams, xProductMentionsLength);
        fireEvent(payload, 'fabric-elements');
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $bcbbbc00187a2c8c$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const teamLinkNode = (0, $VSDnB.fg)('team-mention-inline-smartlink') ? schema.nodes.inlineCard.create({
        url: teamLink
    }) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $3mm6g.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $kCV8T.Fragment).fromArray(inlineNodes);
};
const $bcbbbc00187a2c8c$export$90e81ee10e57772b = ({ sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged })=>{
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
    let firstQueryWithoutResults = null;
    const subscriptionKeys = new Set();
    const typeAhead = {
        id: (0, $3UtTx.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)(CustomHighlightComponent, {});
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = (0, $3YSIX.getMentionPluginState)(editorState);
            if (!pluginState?.mentionProvider) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            return new Promise((resolve, reject)=>{
                const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const mentionItems = mentions.map((mention)=>$bcbbbc00187a2c8c$var$memoizedToItem.call(mention));
                    $bcbbbc00187a2c8c$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
                        query: query,
                        mentions: mentions,
                        stats: stats
                    });
                    if (mentions.length === 0 && firstQueryWithoutResults === null) firstQueryWithoutResults = query;
                    if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) resolve(mentionItems);
                    else {
                        const items = $bcbbbc00187a2c8c$var$withInviteItem({
                            mentionProvider: mentionProvider,
                            firstQueryWithoutResults: firstQueryWithoutResults || '',
                            currentQuery: query,
                            onInviteItemMount: ()=>{
                                fireEvent((0, $hbceX.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole));
                            }
                        })(mentionItems);
                        resolve(items);
                    }
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
                    if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) {
                        mentionProvider.unsubscribe(key);
                        subscriptionKeys.delete(key);
                        reject('FETCH_ERROR');
                    }
                });
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            const { schema: schema } = state;
            const pluginState = (0, $3YSIX.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType, isXProductUser: isXProductUser } = item.mention;
            const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
            const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            if (mentionProvider && !(0, $f1PQ3.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $f1PQ3.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    fireEvent((0, $hbceX.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole));
                    if (mentionProvider.onInviteItemClick) mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $5r0mK.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $5r0mK.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            const mentionLocalId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
            if (handleMentionsChanged) {
                if (taskItemId) handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        taskLocalId: taskItemId
                    }
                ]);
                else handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id
                    }
                ]);
            }
            fireEvent((0, $hbceX.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId));
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
            if (mentionProvider && (0, $f1PQ3.isTeamType)(userType)) return insert($bcbbbc00187a2c8c$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
            if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
            // Don't insert into document if document data is sanitized.
            const text = sanitizePrivateContent ? '' : `@${renderName}`;
            if (sanitizePrivateContent && (0, $3mm6g.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
            mentionProvider.cacheMentionName(id, renderName);
            const annotationMarksForPos = (0, $VSDnB.fg)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            'editor_inline_comments_paste_insert_nodes') ? (0, $h03xs.getAnnotationMarksForPos)(state.tr.selection.$head) : undefined;
            const mentionNode = schema.nodes.mention.createChecked({
                text: text,
                id: id,
                accessLevel: accessLevel,
                userType: userType === 'DEFAULT' ? null : userType,
                localId: mentionLocalId
            }, null, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
            const space = schema.text(' ', // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
            return insert((0, $kCV8T.Fragment).from([
                mentionNode,
                space
            ]));
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $hbceX.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''), 'fabric-elements');
            const pluginState = (0, $3YSIX.getMentionPluginState)(editorState);
            if (pluginState?.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (const key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        }
    };
    return typeAhead;
};

});
parcelRegister("3UtTx", function(module, exports) {

$parcel$export(module.exports, "TypeAheadAvailableNodes", () => $a7f24fcc6d3b7633$export$8c4c885c87e5cc07);
$parcel$export(module.exports, "SelectItemMode", () => $a7f24fcc6d3b7633$export$4d7d0343c6d95a0e);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8ptyJ = parcelRequire("8ptyJ");
var $a7f24fcc6d3b7633$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $a7f24fcc6d3b7633$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    SelectItemMode["TAB"] = "tab";
    return SelectItemMode;
}({});

});
parcelRegister("8ptyJ", function(module, exports) {

$parcel$export(module.exports, "typeAheadListMessages", () => $df168ce559caf975$export$940a17143b866527);

var $7VHMR = parcelRequire("7VHMR");
const $df168ce559caf975$export$940a17143b866527 = (0, $7VHMR.defineMessages)({
    typeAheadPopupLabel: {
        id: 'fabric.editor.typeAhead.popupLabel',
        defaultMessage: 'Typeahead results',
        description: 'the result of a typeahead, similar to autocomplete results+'
    },
    quickInsertPopupLabel: {
        id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
        defaultMessage: 'Shortcuts for inserts and formatting',
        description: 'the result of a quick insert typeahead, similar to autocomplete results+'
    },
    quickInsertInputLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputLabel',
        defaultMessage: 'Begin typing to search or filter shortcut options',
        description: 'assisitve text for typeahed input field'
    },
    quickInsertInputPlaceholderLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel',
        defaultMessage: 'Search',
        description: 'placeholder for typeahed input field'
    },
    emojiPopupLabel: {
        id: 'fabric.editor.typeahead.emojiPopupLabel',
        defaultMessage: 'Emoji shortcuts',
        description: 'the result of a emoji typeahead, similar to autocomplete results+'
    },
    emojiInputLabel: {
        id: 'fabric.editor.typeahead.emojiInputLabel',
        defaultMessage: 'Begin typing to search or filter emoji options',
        description: 'assisitve text for typeahed input field'
    },
    mentionPopupLabel: {
        id: 'fabric.editor.typeahead.mentionPopupLabel',
        defaultMessage: 'Users you can tag',
        description: 'the aria label of a mention typeahead popup'
    },
    mentionInputLabel: {
        id: 'fabric.editor.typeahead.mentionInputLabel',
        defaultMessage: 'Begin typing to search for users to tag',
        description: 'assisitve text for typeahed input field'
    },
    metionListItemLabel: {
        id: 'fabric.editor.typeahead.metionListItemLabel',
        defaultMessage: 'User {name} @{shortName}',
        description: 'assistive text for user mention items username and nickname'
    },
    emojiListItemLabel: {
        id: 'fabric.editor.typeahead.emojiListItemLabel',
        defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
        description: 'assistive text for emoji name and shortcut'
    },
    inputQueryAssistiveLabel: {
        id: 'fabric.editor.inputQueryAssistiveTxt',
        defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    searchResultsLabel: {
        id: 'fabric.editor.searchResults',
        defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
        description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
    },
    noSearchResultsLabel: {
        id: 'fabric.editor.noSearchResults',
        defaultMessage: 'No search results',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    descriptionLabel: {
        id: 'fabric.editor.description',
        defaultMessage: 'Description',
        description: 'Description'
    },
    shortcutLabel: {
        id: 'fabric.editor.shortcut',
        defaultMessage: 'Text shortcut',
        description: 'Text shortcut'
    },
    offlineErrorFallbackHeading: {
        id: 'fabric.editor.offlineErrorFallbackHeading',
        defaultMessage: 'Something went wrong!',
        description: 'heading for offline error fallback when mentions are not available'
    },
    offlineErrorFallbackDesc: {
        id: 'fabric.editor.offlineErrorFallbackDescription',
        defaultMessage: 'Try reloading the page.',
        description: 'description for offline error fallback when mentions are not available'
    },
    viewAllInserts: {
        id: 'fablric.editor.viewAllInserts',
        defaultMessage: 'View all inserts',
        description: 'a text on a button that opens a side panel with a list of all insertable editor elements'
    },
    emptySearchResults: {
        id: 'fabric.editor.emptySearchResults',
        defaultMessage: "We couldn't find any results.",
        description: 'a message displayed when there are no search results'
    },
    emptySearchResultsSuggestion: {
        id: 'fabric.editor.emptySearchResultsSuggestion',
        defaultMessage: 'Select {buttonName} to browse inserts.',
        description: 'a prompt to suggest user to click a button to browse inserts when there are no search results'
    }
});

});


parcelRegister("1avEh", function(module, exports) {

$parcel$export(module.exports, "RowStyle", () => $8eadf330eb36b7ea$export$be24b091af3609e7);
$parcel$export(module.exports, "AvatarStyle", () => $8eadf330eb36b7ea$export$141d6bfd196b561);
$parcel$export(module.exports, "NameSectionStyle", () => $8eadf330eb36b7ea$export$159b59de9966d2d3);
$parcel$export(module.exports, "FullNameStyle", () => $8eadf330eb36b7ea$export$d1c198a7fd873fad);
$parcel$export(module.exports, "InfoSectionStyle", () => $8eadf330eb36b7ea$export$50ad5d386685fccb);
$parcel$export(module.exports, "TimeStyle", () => $8eadf330eb36b7ea$export$cf4c6e54e715dfd9);
$parcel$export(module.exports, "MENTION_ITEM_HEIGHT", () => $8eadf330eb36b7ea$export$934cc98367d9ca68);
$parcel$export(module.exports, "MentionItemStyle", () => $8eadf330eb36b7ea$export$cf80dda9d7a88a01);
$parcel$export(module.exports, "AccessSectionStyle", () => $8eadf330eb36b7ea$export$7bf9a8fa7c04527a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $8eadf330eb36b7ea$export$be24b091af3609e7 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b3haxs7"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $8eadf330eb36b7ea$export$141d6bfd196b561 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1b3haxs6"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $8eadf330eb36b7ea$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $8eadf330eb36b7ea$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1b3haxs4"
})({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
});
const $8eadf330eb36b7ea$export$50ad5d386685fccb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            /* Lozenge */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& > span': {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $8eadf330eb36b7ea$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b3haxs2"
})({
    marginLeft: "var(--ds-space-250, 20px)",
    flex: 'none',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $8eadf330eb36b7ea$export$934cc98367d9ca68 = 48;
const $8eadf330eb36b7ea$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        height: `${$8eadf330eb36b7ea$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $8eadf330eb36b7ea$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b3haxs0"
})({
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
});

});

parcelRegister("4j0XL", function(module, exports) {

$parcel$export(module.exports, "default", () => $36bbf555414387dc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $ujWmd = parcelRequire("ujWmd");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");


var $5uXOq = parcelRequire("5uXOq");

var $6tRzQ = parcelRequire("6tRzQ");

var $cqJWb = parcelRequire("cqJWb");

var $j6B3T = parcelRequire("j6B3T");

var $cT2yH = parcelRequire("cT2yH");

var $k3AGD = parcelRequire("k3AGD");

var $aaNA1 = parcelRequire("aaNA1");

var $1avEh = parcelRequire("1avEh");

var $5YZTd = parcelRequire("5YZTd");

var $imL8D = parcelRequire("imL8D");

var $kbF2s = parcelRequire("kbF2s");

var $eFUnm = parcelRequire("eFUnm");
function $36bbf555414387dc$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
        children: lozenge
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
            appearance: appearance,
            children: text
        });
    }
    return null;
}
function $36bbf555414387dc$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1avEh.TimeStyle), {
        children: time
    });
    return null;
}
class $36bbf555414387dc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { mention: mention, selected: selected } = this.props;
        const { id: id, highlight: highlight, avatarUrl: avatarUrl, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        const { status: status, time: time } = presence || {};
        const restricted = (0, $cqJWb.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const borderColor = selected ? `var(--ds-border, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbF2s.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1avEh.MentionItemStyle), {
                selected: selected,
                onMouseDown: this.onMentionSelected,
                onMouseMove: this.onMentionMenuItemMouseMove,
                onMouseEnter: this.onMentionMenuItemMouseEnter,
                "data-mention-item": true,
                "data-testid": `mention-item-${id}`,
                "data-mention-id": id,
                "data-mention-name": mentionName,
                "data-selected": selected,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1avEh.RowStyle), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1avEh.AvatarStyle), {
                            restricted: restricted,
                            children: (0, $VSDnB.fg)('team-avatar-in-mention-picker') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFUnm.MentionAvatar), {
                                selected: selected,
                                mention: mention
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
                                src: avatarUrl,
                                size: "medium",
                                presence: status,
                                borderColor: borderColor
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1avEh.NameSectionStyle), {
                            restricted: restricted,
                            children: [
                                (0, $5YZTd.renderHighlight)((0, $1avEh.FullNameStyle), name, nameHighlights),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $imL8D.default), {
                                    mention: mention
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1avEh.InfoSectionStyle), {
                            restricted: restricted,
                            children: [
                                $36bbf555414387dc$var$renderLozenge(lozenge),
                                $36bbf555414387dc$var$renderTime(time)
                            ]
                        }),
                        restricted ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3AGD.default), {
                                name: name,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1avEh.AccessSectionStyle), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6B3T.NoAccessLabel), {
                                        children: (text)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aaNA1.default), {
                                                label: text
                                            })
                                    })
                                })
                            })
                        }) : null,
                        isXProductUser && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                            color: xProductUserInfoIconColor,
                            label: ''
                        })
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $cT2yH.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        }, this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        }, this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}

});
parcelRegister("cT2yH", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $69adb1ba11965b3c$export$34ebdaf2c517ae75);
function $69adb1ba11965b3c$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $69adb1ba11965b3c$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $69adb1ba11965b3c$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}

});

parcelRegister("aaNA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb9a7b0d097e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $c85eb9a7b0d097e2$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3XjST")).then((module)=>({
            default: module.default
        })));
var $c85eb9a7b0d097e2$export$2e2bcd8739ae039 = $c85eb9a7b0d097e2$var$AsyncLockCircleIcon;

});
parcelRegister("3XjST", function(module, exports) {

let $2e164e67ded687b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2e164e67ded687b3$var$load("KEIyA").then(()=>parcelRequire('cLFIZ'));

});


parcelRegister("5YZTd", function(module, exports) {

$parcel$export(module.exports, "renderHighlight", () => $7c981011e2ee742e$export$2bcf43b01d5314f5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $7c981011e2ee742e$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(ReactComponent, {
        children: [
            prefixText,
            parts.map((part, index)=>{
                if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                    children: part.value
                }, index);
                return part.value;
            })
        ]
    });
}

});

parcelRegister("imL8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a20a417e388d5b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cqJWb = parcelRequire("cqJWb");

var $adztf = parcelRequire("adztf");

var $4kWll = parcelRequire("4kWll");

var $btBND = parcelRequire("btBND");

var $8aQI9 = parcelRequire("8aQI9");
class $39a20a417e388d5b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btBND.DescriptionBylineStyle), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8aQI9.messages).xProductMentionDescription
            })
        });
        switch(userType){
            case (0, $cqJWb.UserType)[(0, $cqJWb.UserType).TEAM]:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4kWll.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adztf.default), {
                    mention: this.props.mention
                });
        }
    }
}

});
parcelRegister("adztf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf33a4d24d685c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5YZTd = parcelRequire("5YZTd");

var $btBND = parcelRequire("btBND");
class $6cf33a4d24d685c9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $5YZTd.renderHighlight)((0, $btBND.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}

});
parcelRegister("btBND", function(module, exports) {

$parcel$export(module.exports, "DescriptionBylineStyle", () => $cf130735fd28d089$export$607100a5f9cc9977);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $cf130735fd28d089$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1bkpfff0"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-025, 2px)",
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("4kWll", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d387bae650c1739$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $btBND = parcelRequire("btBND");

var $8aQI9 = parcelRequire("8aQI9");
class $2d387bae650c1739$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args), this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8aQI9.messages).plus50MembersWithYou
                }));
                return this.getBylineComponent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8aQI9.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8aQI9.messages).plus50MembersWithoutYou
                }));
                return this.getBylineComponent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8aQI9.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        }, this.getBylineComponent = (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $btBND.DescriptionBylineStyle), {
                children: message
            });
    }
}

});


parcelRegister("eFUnm", function(module, exports) {

$parcel$export(module.exports, "MentionAvatar", () => $1ad50a3d072b7e02$export$35f495c0dc0a1015);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $fwSAz = parcelRequire("fwSAz");

var $cqJWb = parcelRequire("cqJWb");
const $1ad50a3d072b7e02$export$35f495c0dc0a1015 = ({ mention: mention, selected: selected })=>{
    const { avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #091E4224)" : undefined;
    const { status: status } = presence || {};
    if ((0, $cqJWb.isTeamMention)(mention)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor
    });
};

});


parcelRegister("eVETA", function(module, exports) {

$parcel$export(module.exports, "INVITE_ITEM_DESCRIPTION", () => $630919f3f674c51a$export$75621ed4176efc9e);
$parcel$export(module.exports, "default", () => $630919f3f674c51a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $7ywdr = parcelRequire("7ywdr");

var $99M5v = parcelRequire("99M5v");

const $630919f3f674c51a$var$mentionItemStyle = null;
const $630919f3f674c51a$var$mentionItemSelectedStyle = null;
const $630919f3f674c51a$var$rowStyle = null;
const $630919f3f674c51a$var$avatarStyle = null;
const $630919f3f674c51a$var$nameSectionStyle = null;
const $630919f3f674c51a$var$capitalizedStyle = null;
const $630919f3f674c51a$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $630919f3f674c51a$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $630919f3f674c51a$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $5uXOq.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if ($630919f3f674c51a$var$leftClick(event) && onSelection) {
            event.preventDefault();
            onSelection($630919f3f674c51a$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $5uXOq.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($630919f3f674c51a$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        onMouseDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        "data-id": $630919f3f674c51a$export$75621ed4176efc9e.id,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _bfhk18uv _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk14ae"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvdlk8 _u5f3dlk8 _1bto1l2s _s7n4nkob"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                        label: intl.formatMessage((0, $7ywdr.mentionMessages).mentionsAddLabel),
                        color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": "name-section",
                    className: (0, $bwpsq.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0dlk8 _syaz1n3s"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7ywdr.mentionMessages).inviteItemTitle,
                        values: {
                            userRole: userRole || 'basic',
                            productName: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                                "data-testid": "capitalized-message",
                                className: (0, $bwpsq.default)([
                                    "_1p1d1dk0"
                                ]),
                                children: productName
                            })
                        }
                    })
                })
            ]
        })
    });
};
var $630919f3f674c51a$export$2e2bcd8739ae039 = (0, $8RXs9.default)($630919f3f674c51a$var$InviteItem);

});

parcelRegister("hbceX", function(module, exports) {

$parcel$export(module.exports, "buildTypeAheadCancelPayload", () => $257d281f11b58df5$export$e1d5d51810b7e165);
$parcel$export(module.exports, "buildTypeAheadInviteItemViewedPayload", () => $257d281f11b58df5$export$c102b710f5c857c4);
$parcel$export(module.exports, "buildTypeAheadInviteItemClickedPayload", () => $257d281f11b58df5$export$e4c4d872dcfe2b15);
$parcel$export(module.exports, "buildTypeAheadInsertedPayload", () => $257d281f11b58df5$export$84030a552533cdf8);
$parcel$export(module.exports, "buildTypeAheadRenderedPayload", () => $257d281f11b58df5$export$901fb6651fc13b0e);

var $gkwXh = parcelRequire("gkwXh");

var $cqJWb = parcelRequire("cqJWb");

var $f1PQ3 = parcelRequire("f1PQ3");
const $257d281f11b58df5$var$componentName = 'mention';
const $257d281f11b58df5$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $257d281f11b58df5$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $257d281f11b58df5$var$emptyQueryResponse;
};
const $257d281f11b58df5$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $257d281f11b58df5$var$extractAttributesFromQuery(query);
    return {
        action: (0, $gkwXh.ACTION).CANCELLED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            componentName: $257d281f11b58df5$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            sessionId: sessionId
        }
    };
};
const $257d281f11b58df5$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $257d281f11b58df5$var$isClicked = (insertType)=>insertType === 'selected';
const $257d281f11b58df5$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: (0, $gkwXh.ACTION).RENDERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            componentName: $257d281f11b58df5$var$componentName,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId
        }
    };
};
const $257d281f11b58df5$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $257d281f11b58df5$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: $257d281f11b58df5$var$isClicked(insertType) ? (0, $gkwXh.ACTION).CLICKED : (0, $gkwXh.ACTION).PRESSED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            componentName: $257d281f11b58df5$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            keyboardKey: $257d281f11b58df5$var$isClicked(insertType) ? undefined : insertType
        }
    };
};
const $257d281f11b58df5$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $257d281f11b58df5$var$extractAttributesFromQuery(query);
    let containerId;
    let objectId;
    let childObjectId;
    if (contextIdentifierProvider) {
        containerId = contextIdentifierProvider.containerId || undefined;
        objectId = contextIdentifierProvider.objectId || undefined;
        childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return {
        action: $257d281f11b58df5$var$isClicked(insertType) ? (0, $gkwXh.ACTION).CLICKED : (0, $gkwXh.ACTION).PRESSED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        attributes: {
            sessionId: sessionId,
            duration: duration,
            position: $257d281f11b58df5$var$getPosition(mentionList, mention),
            keyboardKey: $257d281f11b58df5$var$isClicked(insertType) ? undefined : insertType,
            source: mention.source,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            isSpecial: (0, $cqJWb.isSpecialMention)(mention),
            accessLevel: mention.accessLevel || '',
            userType: mention.userType,
            userId: mention.id,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            memberCount: (0, $f1PQ3.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
            includesYou: (0, $f1PQ3.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
            taskListId: taskListId,
            taskItemId: taskItemId,
            localId: mentionLocalId,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId
        }
    };
};
const $257d281f11b58df5$export$901fb6651fc13b0e = (duration, userIds, query, teams, xProductMentionsLength)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $257d281f11b58df5$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? (0, $gkwXh.ACTION_SUBJECT).MENTION_TYPEAHEAD : (0, $gkwXh.ACTION_SUBJECT).TEAM_MENTION_TYPEAHEAD;
    return {
        action: (0, $gkwXh.ACTION).RENDERED,
        actionSubject: actionSubject,
        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
        attributes: {
            componentName: $257d281f11b58df5$var$componentName,
            duration: duration,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            xProductMentionsLength: xProductMentionsLength
        }
    };
};

});
parcelRegister("f1PQ3", function(module, exports) {

$parcel$export(module.exports, "isTeamType", () => $1f4e32e17099aa3d$export$6ddb6ef001273170);
$parcel$export(module.exports, "isTeamStats", () => $1f4e32e17099aa3d$export$c427182c53a1ba5);
$parcel$export(module.exports, "isInviteItem", () => $1f4e32e17099aa3d$export$f5a334b5a28d1e01);
$parcel$export(module.exports, "shouldKeepInviteItem", () => $1f4e32e17099aa3d$export$16a134d4e1b461dc);

var $eVETA = parcelRequire("eVETA");
const $1f4e32e17099aa3d$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $1f4e32e17099aa3d$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $1f4e32e17099aa3d$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $eVETA.INVITE_ITEM_DESCRIPTION).id;
const $1f4e32e17099aa3d$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    const lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const depletedExtraWords = /\s[^\s]+\s/.test(suffix);
    return !depletedExtraWords;
};

});





parcelRegister("ewWTS", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => (parcelRequire("54Pnl")).pastePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $54Pnl = parcelRequire("54Pnl");

});
parcelRegister("54Pnl", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => $28b8ca4838b99c5f$export$2d7f4bd9c1268cd7);

var $aehLH = parcelRequire("aehLH");

var $2NfYE = parcelRequire("2NfYE");

var $6eO8M = parcelRequire("6eO8M");
const $28b8ca4838b99c5f$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>(0, $aehLH.createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, cardOptions, sanitizePrivateContent, providerFactory)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $2NfYE.createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                lastContentPasted: null
            };
            const pluginState = (0, $6eO8M.pluginKey).getState(editorState);
            return {
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};

});
parcelRegister("aehLH", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $d10e66844f67b307$export$ae829ec7b2625219);

var $7Jxgt = parcelRequire("7Jxgt");

var $gkwXh = parcelRequire("gkwXh");
var $2yLEW = parcelRequire("2yLEW");

var $1ZWXY = parcelRequire("1ZWXY");

var $kxM7f = parcelRequire("kxM7f");

var $04ZRC = parcelRequire("04ZRC");

var $ekofw = parcelRequire("ekofw");
var $1M84d = parcelRequire("1M84d");

var $ap7h6 = parcelRequire("ap7h6");

var $5KWxh = parcelRequire("5KWxh");

var $lKK04 = parcelRequire("lKK04");
var $iYg8V = parcelRequire("iYg8V");
var $8Amfw = parcelRequire("8Amfw");
var $hZCXS = parcelRequire("hZCXS");
var $fH9ql = parcelRequire("fH9ql");

var $h03xs = parcelRequire("h03xs");
var $594Yf = parcelRequire("594Yf");
var $dPSMN = parcelRequire("dPSMN");
var $7vpuQ = parcelRequire("7vpuQ");

var $38KaN = parcelRequire("38KaN");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $hKZR1 = parcelRequire("hKZR1");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $l0B7L = parcelRequire("l0B7L");

var $iMJAN = parcelRequire("iMJAN");

var $sgs63 = parcelRequire("sgs63");

var $hJPkr = parcelRequire("hJPkr");

var $jI1GO = parcelRequire("jI1GO");

var $6eO8M = parcelRequire("6eO8M");

var $bZdX5 = parcelRequire("bZdX5");

var $cOOfv = parcelRequire("cOOfv");

var $hUtHc = parcelRequire("hUtHc");

var $jbxbo = parcelRequire("jbxbo");
const $d10e66844f67b307$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)(blockquote)(state.selection);
};
const $d10e66844f67b307$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $d10e66844f67b307$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, cardOptions, sanitizePrivateContent, providerFactory) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $38KaN.MarkdownTransformer)(schema, (0, $1M84d.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        const textInput = escapeBackslashExceptCodeblock(text);
        const doc = atlassianMarkDownParser.parse((0, $bZdX5.escapeLinks)(textInput));
        if (doc && doc.content) return new (0, $kCV8T.Slice)(doc.content, openStart, openEnd);
        return;
    }
    function escapeBackslashExceptCodeblock(textInput) {
        const codeToken = '```';
        if (!textInput.includes(codeToken)) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return textInput.replace(/\\/g, '\\\\');
        let isInsideCodeblock = false;
        let textSplitByNewLine = textInput.split('\n');
        // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
        textSplitByNewLine = textSplitByNewLine.map((text)=>{
            if (text === codeToken) isInsideCodeblock = !isInsideCodeblock;
            else if (text.startsWith(codeToken) && isInsideCodeblock === false) // if there is some text after the ``` mark , it gets counted as language attribute only at the start of codeblock
            isInsideCodeblock = true;
            if (!isInsideCodeblock) // only escape text which is not inside a codeblock
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            text = text.replace(/\\/g, '\\\\');
            return text;
        });
        textInput = textSplitByNewLine.join('\n');
        return textInput;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $04ZRC.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $6eO8M.pluginKey),
        state: (0, $6eO8M.createPluginState)(dispatch, {
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            clipboardTextSerializer: // For serialising to plain text
            $jI1GO.clipboardTextSerializer,
            handleDOMEvents: {
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    return false;
                }
            },
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
                (0, $VSDnB.fg)('platform_editor_legacy_content_macro') && !(0, $VSDnB.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $fH9ql.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $ekofw.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) /**
						 * Microsoft Office, Number, Pages, etc. adds an image to clipboard
						 * with other mime-types so we don't let the event reach media.
						 * The detection ration here is that if the payload has both `html` and
						 * `files`, then it could be one of above or an image copied from web.
						 * Here, we don't have html, so we return true to allow default event behaviour
						 */ return true;
                    /**
					 * We want to return false for external copied image to allow
					 * it to be uploaded by the client.
					 *
					 * Scenario where we are pasting an external image inside a block quote
					 * is skipped and handled in handleRichText
					 */ if ((0, $bZdX5.htmlContainsSingleFile)(html) && !$d10e66844f67b307$export$eedfdbc6a6bc1442(view.state)) return true;
                    /**
					 * https://product-fabric.atlassian.net/browse/ED-21993
					 * stopImmediatePropagation will run the first event attached to the same element
					 * Which chould have race condition issue
					 */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $hJPkr.getContentNodeTypes)(slice.content);
                const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
                const measureName = `${$d10e66844f67b307$var$PASTE}_${pasteId}`;
                (0, $ap7h6.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $hJPkr.createPasteMeasurePayload)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                });
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $594Yf.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    const isDocChanged = tr.docChanged;
                    (0, $1ZWXY.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $gkwXh.ACTION).PASTED_AS_PLAIN : (0, $gkwXh.ACTION).PASTED,
                        inputMethod: (0, $gkwXh.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pasteStartPos = Math.min(state.selection.anchor, state.selection.head);
                        const pasteEndPos = tr.selection.to;
                        const contentPasted = {
                            pasteStartPos: pasteStartPos,
                            pasteEndPos: pasteEndPos,
                            text: text,
                            isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                            view.shiftKey || view.input?.shiftKey),
                            isPlainText: Boolean(isPlainText),
                            pastedSlice: tr.doc.slice(pasteStartPos, pasteEndPos),
                            pastedAt: Date.now(),
                            pasteSource: (0, $bZdX5.getPasteSource)(event)
                        };
                        tr.setMeta((0, $6eO8M.pluginKey), {
                            type: (0, $l0B7L.PastePluginActionTypes).ON_PASTE,
                            contentPasted: contentPasted
                        });
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $hUtHc.handleParagraphBlockMarks)(state, slice);
                slice = (0, $cOOfv.handleVSCodeBlock)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                const plainTextPasteSlice = (0, $dPSMN.linkifyContent)(state.schema)(slice);
                if ((0, $hJPkr.handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $VSDnB.fg)('platform_editor_fix_captions_on_copy')) {
                    if ((0, $hJPkr.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $2yLEW.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                    // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                    // https://product-fabric.atlassian.net/browse/MEX-1520
                    // Converting caption to plain text needs to be handled before transformSliceForMedia
                    // as createChecked will fail when trying to create a mediaSingle node with a caption
                    // that is not plain text.
                    return true;
                }
                // transform slices based on destination
                slice = (0, $sgs63.transformSliceForMedia)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $hJPkr.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $2yLEW.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $hUtHc.handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $hJPkr.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $2yLEW.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $bZdX5.transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                const edgeCaseNodeTypes = [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $hJPkr.handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $hJPkr.handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $2yLEW.PasteTypes).binary : (0, $2yLEW.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $hJPkr.handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $hJPkr.getContentNodeTypes)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $hKZR1.handlePaste)(view, event, slice, {
                    pasteSource: (0, $bZdX5.getPasteSource)(event)
                })) {
                    (0, $hJPkr.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $2yLEW.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $hJPkr.handleNestedTablePasteWithAnalytics)(editorAnalyticsAPI, (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes'))(view, event, slice)(state, dispatch)) return true;
                if ((0, $hJPkr.handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, $2yLEW.PasteTypes).plain : (0, $2yLEW.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $hJPkr.handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, $2yLEW.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $hJPkr.handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $d10e66844f67b307$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $7vpuQ.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $5r0mK.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $dPSMN.linkifyContent)(state.schema)(slice);
                    if ((0, $hJPkr.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $2yLEW.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $hUtHc.handleMacroAutoConvert)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $hJPkr.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $2yLEW.PasteTypes).richText
                        });
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $hUtHc.handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $h03xs.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    if ((0, $hJPkr.handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, $2yLEW.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc) {
                        const sliceCopy = (0, $kCV8T.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $hJPkr.handleExpandWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $kxM7f.insideTable)(state)) slice = (0, $8Amfw.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if (!(0, $VSDnB.fg)('platform_editor_fix_captions_on_copy')) {
                        if ((0, $hJPkr.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $2yLEW.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                        // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                        // https://product-fabric.atlassian.net/browse/MEX-1520
                        return true;
                    }
                    if ((0, $hJPkr.handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $hJPkr.handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $hJPkr.handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $hUtHc.handleMention)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
				 * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $iYg8V.transformSliceToJoinAdjacentCodeBlocks)(slice);
                slice = (0, $iYg8V.transformSingleLineCodeBlockToCodeMark)(slice, schema);
                slice = (0, $sgs63.transformSliceToCorrectMediaWrapper)(slice, schema);
                slice = (0, $sgs63.transformSliceToMediaSingleWithNewExperience)(slice, schema, pluginInjectionApi);
                slice = (0, $hZCXS.transformSliceToDecisionList)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $iMJAN.splitParagraphs)(slice, schema);
                slice = (0, $iMJAN.upgradeTextToLists)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $kCV8T.Slice)(slice.content, 0, 0);
                if (!(0, $gmhCD.editorExperiment)('single_column_layouts', true)) slice = (0, $lKK04.transformSingleColumnLayout)(slice, schema);
                if ((0, $VSDnB.fg)('platform_editor_macroid_reset_for_ext_on_paste')) slice = (0, $fH9ql.transformSliceToRemoveMacroId)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $jbxbo.isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, $jbxbo.htmlHasIncompleteTable)(html)) {
                    const completeTableHtml = (0, $jbxbo.tryRebuildCompleteTableHtml)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $bZdX5.isPastedFromWord)(html) && !(0, $bZdX5.isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, $sgs63.unwrapNestedMediaElements)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $bZdX5.htmlHasInvalidLinkTags)(html)) html = (0, $bZdX5.removeDuplicateInvalidLinks)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}

});
parcelRegister("2yLEW", function(module, exports) {

$parcel$export(module.exports, "PasteTypes", () => $18ad867e0f3ed9e5$export$2ba12a8680458b1e);
$parcel$export(module.exports, "PasteContents", () => $18ad867e0f3ed9e5$export$a82556f999b47168);
const $18ad867e0f3ed9e5$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $18ad867e0f3ed9e5$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $18ad867e0f3ed9e5$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};

});

parcelRegister("ekofw", function(module, exports) {

$parcel$export(module.exports, "isPastedFile", () => $569ae1fc879ec97d$export$30c8e5e50a78a591);
function $569ae1fc879ec97d$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
function $569ae1fc879ec97d$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return $569ae1fc879ec97d$export$e20225b4cda674a8(clipboardData.types, 'Files');
}

});

parcelRegister("lKK04", function(module, exports) {

$parcel$export(module.exports, "transformSingleColumnLayout", () => $d6d305b7f5ef06a6$export$ca45027befc3fad2);
$parcel$export(module.exports, "transformSliceToRemoveOpenLayoutNodes", () => $d6d305b7f5ef06a6$export$82cc8566682e5cf4);

var $kCV8T = parcelRequire("kCV8T");

var $7vpuQ = parcelRequire("7vpuQ");
const $d6d305b7f5ef06a6$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $d6d305b7f5ef06a6$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $7vpuQ.mapFragment)((0, $kCV8T.Fragment).from(maybeLayoutSection), (node)=>{
        return $d6d305b7f5ef06a6$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $d6d305b7f5ef06a6$export$238984649a055433(node, i) {
    return i === 0 ? $d6d305b7f5ef06a6$export$5fc4db161d3fef1f(node) : node;
}
function $d6d305b7f5ef06a6$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $d6d305b7f5ef06a6$export$5fc4db161d3fef1f(node) : node;
}
const $d6d305b7f5ef06a6$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        if (slice.content.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $kCV8T.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (slice.content.firstChild?.type === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && slice.content.firstChild.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $kCV8T.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};
function $d6d305b7f5ef06a6$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(slice.content, $d6d305b7f5ef06a6$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(slice.content, $d6d305b7f5ef06a6$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(slice.content, $d6d305b7f5ef06a6$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}

});

parcelRegister("iYg8V", function(module, exports) {

$parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", () => $99fc3db05934d60c$export$5a682e48ed34e262);
$parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", () => $99fc3db05934d60c$export$d1dc8019f50dded8);
$parcel$export(module.exports, "findCodeBlock", () => $99fc3db05934d60c$export$8435d1ef36841a34);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $7vpuQ = parcelRequire("7vpuQ");
function $99fc3db05934d60c$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $99fc3db05934d60c$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($99fc3db05934d60c$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $kCV8T.Fragment).from(children);
}
function $99fc3db05934d60c$export$5a682e48ed34e262(slice) {
    slice = (0, $7vpuQ.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($99fc3db05934d60c$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $kCV8T.Slice)($99fc3db05934d60c$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}
const $99fc3db05934d60c$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};
const $99fc3db05934d60c$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $5r0mK.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $5r0mK.findParentNodeOfType)(codeBlock)(selection || state.selection);
};

});

parcelRegister("8Amfw", function(module, exports) {

$parcel$export(module.exports, "findExpand", () => $e9a196c58ca29a43$export$fd7bf9c73fdd6f30);
$parcel$export(module.exports, "transformSliceToRemoveOpenExpand", () => $e9a196c58ca29a43$export$6d57e15bdf5e650f);
$parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", () => $e9a196c58ca29a43$export$74dbe7cb6b933cde);
$parcel$export(module.exports, "transformSliceNestedExpandToExpand", () => $e9a196c58ca29a43$export$fd33fafbf6b5abc7);
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $e9a196c58ca29a43$export$447e90e618548243);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $7vpuQ = parcelRequire("7vpuQ");
const $e9a196c58ca29a43$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $5r0mK.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $5r0mK.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};
const $e9a196c58ca29a43$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $kCV8T.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $e9a196c58ca29a43$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $kCV8T.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $e9a196c58ca29a43$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $7vpuQ.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
const $e9a196c58ca29a43$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $7vpuQ.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("hZCXS", function(module, exports) {

$parcel$export(module.exports, "transformSliceToDecisionList", () => $d713d8936b58e45c$export$65d21b4bef5d424b);

var $kCV8T = parcelRequire("kCV8T");
const $d713d8936b58e45c$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};

});

parcelRegister("fH9ql", function(module, exports) {

$parcel$export(module.exports, "transformSliceToRemoveOpenBodiedExtension", () => $945a5a80467e7c21$export$c50f82e6f2cff97d);
$parcel$export(module.exports, "transformSliceToRemoveOpenMultiBodiedExtension", () => $945a5a80467e7c21$export$d2a1206296dcfa47);
$parcel$export(module.exports, "transformSliceToRemoveLegacyContentMacro", () => $945a5a80467e7c21$export$23ce34395aea8526);
$parcel$export(module.exports, "transformSliceToRemoveMacroId", () => $945a5a80467e7c21$export$c20bd22f1bffad40);

var $9IGaJ = parcelRequire("9IGaJ");

var $kCV8T = parcelRequire("kCV8T");

var $7vpuQ = parcelRequire("7vpuQ");
const $945a5a80467e7c21$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $7vpuQ.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $kCV8T.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $945a5a80467e7c21$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $7vpuQ.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
			 *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
			 */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $9IGaJ.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $kCV8T.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $945a5a80467e7c21$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $945a5a80467e7c21$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type === extension && $945a5a80467e7c21$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};
const $945a5a80467e7c21$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof node.attrs.parameters?.macroMetadata?.macroId?.value !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};

});

parcelRegister("38KaN", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $ca5b579471d13098$export$267fd7ead7cc4561);

var $kOFhM = parcelRequire("kOFhM");

var $ivSSX = parcelRequire("ivSSX");

var $4iMad = parcelRequire("4iMad");

var $6fRr3 = parcelRequire("6fRr3");

var $39HCX = parcelRequire("39HCX");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $ca5b579471d13098$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $ca5b579471d13098$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $ca5b579471d13098$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
    html: false
});
$ca5b579471d13098$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $ca5b579471d13098$export$267fd7ead7cc4561 {
    constructor(schema = (0, $kOFhM.defaultSchema), tokenizer = $ca5b579471d13098$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $ca5b579471d13098$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($ca5b579471d13098$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $4iMad.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $39HCX.markdownItMedia));
        this.markdownParser = new (0, $6fRr3.MarkdownParser)(schema, tokenizer, $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, $ca5b579471d13098$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("4iMad", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $321e3433bbbbd43e$export$26a6b72a65821214);

var $ew5rH = parcelRequire("ew5rH");
var $321e3433bbbbd43e$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($ew5rH))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("ew5rH", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $a9184747dc810078$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $a9184747dc810078$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $a9184747dc810078$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$a9184747dc810078$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $a9184747dc810078$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("6fRr3", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $48dd97f13fd6d562$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $48dd97f13fd6d562$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $48dd97f13fd6d562$export$61055fa707e69319);

var $kCV8T = parcelRequire("kCV8T");

var $ivSSX = parcelRequire("ivSSX");
/**
Document schema for the data model used by CommonMark.
*/ const $48dd97f13fd6d562$export$4902baddc787debb = new (0, $kCV8T.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $48dd97f13fd6d562$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $kCV8T.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $48dd97f13fd6d562$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $kCV8T.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $48dd97f13fd6d562$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $kCV8T.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $48dd97f13fd6d562$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $48dd97f13fd6d562$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $48dd97f13fd6d562$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $48dd97f13fd6d562$var$noOp() {}
function $48dd97f13fd6d562$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = $48dd97f13fd6d562$var$noOp;
            else {
                handlers[type + "_open"] = $48dd97f13fd6d562$var$noOp;
                handlers[type + "_close"] = $48dd97f13fd6d562$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $48dd97f13fd6d562$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $48dd97f13fd6d562$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $48dd97f13fd6d562$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $48dd97f13fd6d562$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $48dd97f13fd6d562$export$7517583227ad0cb8 = new $48dd97f13fd6d562$export$a64f782182dea128($48dd97f13fd6d562$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $48dd97f13fd6d562$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $48dd97f13fd6d562$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $48dd97f13fd6d562$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $48dd97f13fd6d562$export$f996452ca6e9a0ae = new $48dd97f13fd6d562$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $48dd97f13fd6d562$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $48dd97f13fd6d562$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $48dd97f13fd6d562$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $48dd97f13fd6d562$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $48dd97f13fd6d562$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("39HCX", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $288ff3bbed487814$export$c8dcbd316b71f8cf);
function $288ff3bbed487814$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $288ff3bbed487814$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $288ff3bbed487814$var$createRule());
};

});


parcelRegister("hKZR1", function(module, exports) {

$parcel$export(module.exports, "handlePaste", () => $ff49e98b89c214ae$export$5dbcc300324fed87);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $22PoI = parcelRequire("22PoI");

var $3yjNu = parcelRequire("3yjNu");

var $bQFBc = parcelRequire("bQFBc");

var $5i9bT = parcelRequire("5i9bT");
const $ff49e98b89c214ae$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $ff49e98b89c214ae$export$5dbcc300324fed87(view, event, slice, options) {
    if (!(0, $bQFBc.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isNestingAllowed = (0, $gmhCD.editorExperiment)('nested-tables-in-tables', true);
    const isPasteFullTableInsideEmptyCellEnabled = (0, $VSDnB.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && slice.content.firstChild?.type === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $hFEwm.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && isNestingAllowed && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $ff49e98b89c214ae$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $5r0mK.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            const canInsertNestedTable = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)?.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $5i9bT.pastedCells)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $kCV8T.Fragment).from((0, $5i9bT.fitSlice)((0, $3yjNu.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $uOUlv.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $5i9bT.clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $5i9bT.insertCells)(view.state, view.dispatch, start, rect, $ff49e98b89c214ae$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $22PoI.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $uOUlv.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $uOUlv.TableMap).get($cell.node(-1));
        (0, $5i9bT.insertCells)(view.state, view.dispatch, start, rect, $ff49e98b89c214ae$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $ff49e98b89c214ae$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};

});
parcelRegister("3yjNu", function(module, exports) {

$parcel$export(module.exports, "tableNodeTypes", () => $8be71f6754b181de$export$c7782132717464bc);
function $8be71f6754b181de$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}

});

parcelRegister("5i9bT", function(module, exports) {

$parcel$export(module.exports, "pastedCells", () => $6dd11ae486d7c5ad$export$f6d8f52489457fc4);
$parcel$export(module.exports, "fitSlice", () => $6dd11ae486d7c5ad$export$f09c6b3b06d884fb);
$parcel$export(module.exports, "clipCells", () => $6dd11ae486d7c5ad$export$cdcebd68073bc3f);
$parcel$export(module.exports, "insertCells", () => $6dd11ae486d7c5ad$export$e0b94385c1fdc132);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $6e6o8 = parcelRequire("6e6o8");

var $hHsVB = parcelRequire("hHsVB");

var $3yjNu = parcelRequire("3yjNu");

var $eNHnZ = parcelRequire("eNHnZ");
// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $6dd11ae486d7c5ad$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $3yjNu.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $kCV8T.Fragment).from(newCells);
}
function $6dd11ae486d7c5ad$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $6dd11ae486d7c5ad$export$f09c6b3b06d884fb((0, $3yjNu.tableNodeTypes)(schema).row, new (0, $kCV8T.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $6dd11ae486d7c5ad$export$f09c6b3b06d884fb((0, $3yjNu.tableNodeTypes)(schema).row, new (0, $kCV8T.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$6dd11ae486d7c5ad$var$stripHeaderType(schema, row));
    return $6dd11ae486d7c5ad$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $6dd11ae486d7c5ad$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $kCV8T.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $3yjNu.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $kCV8T.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $6dd11ae486d7c5ad$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $eS2Dn.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $6dd11ae486d7c5ad$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $6e6o8.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $kCV8T.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $kCV8T.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $6dd11ae486d7c5ad$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $3yjNu.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $kCV8T.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $6e6o8.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $6e6o8.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $6dd11ae486d7c5ad$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $6dd11ae486d7c5ad$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $hHsVB.selectedRect)(state);
    const types = (0, $3yjNu.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $eNHnZ.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $eNHnZ.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $uOUlv.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $uOUlv.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($6dd11ae486d7c5ad$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $kCV8T.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $6dd11ae486d7c5ad$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $hFEwm.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}

});
parcelRegister("eNHnZ", function(module, exports) {

$parcel$export(module.exports, "isHeaderEnabledByType", () => $9886d955dd3a1a8d$export$96946e3333d0ccc6);
$parcel$export(module.exports, "toggleHeader", () => $9886d955dd3a1a8d$export$dee0ccd8d8f5a56e);

var $uOUlv = parcelRequire("uOUlv");

var $hHsVB = parcelRequire("hHsVB");

var $3yjNu = parcelRequire("3yjNu");

var $bQFBc = parcelRequire("bQFBc");
function $9886d955dd3a1a8d$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $9886d955dd3a1a8d$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $bQFBc.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $3yjNu.tableNodeTypes)(state.schema);
            const rect = (0, $hHsVB.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = $9886d955dd3a1a8d$export$96946e3333d0ccc6('row', rect, types);
            const isHeaderColumnEnabled = $9886d955dd3a1a8d$export$96946e3333d0ccc6('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $uOUlv.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $uOUlv.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}

});



parcelRegister("l0B7L", function(module, exports) {

$parcel$export(module.exports, "PastePluginActionTypes", () => $76e285a47bbc9216$export$ad3c0356f902fd97);
var $76e285a47bbc9216$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    return PastePluginActionTypes;
}({});

});

parcelRegister("iMJAN", function(module, exports) {

$parcel$export(module.exports, "startTrackingPastedMacroPositions", () => $722f1e15dd092c87$export$4a47d257a3fdbe1c);
$parcel$export(module.exports, "stopTrackingPastedMacroPositions", () => $722f1e15dd092c87$export$68f98dcea8e59d59);
$parcel$export(module.exports, "upgradeTextToLists", () => $722f1e15dd092c87$export$df231bdf1595dd19);
$parcel$export(module.exports, "splitParagraphs", () => $722f1e15dd092c87$export$f2dc3112f5c2bd10);

var $uTDrM = parcelRequire("uTDrM");
var $7vpuQ = parcelRequire("7vpuQ");

var $2RHbH = parcelRequire("2RHbH");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $l0B7L = parcelRequire("l0B7L");

var $6eO8M = parcelRequire("6eO8M");
const $722f1e15dd092c87$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $6eO8M.createCommand)(()=>{
        return {
            type: (0, $l0B7L.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $722f1e15dd092c87$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $6eO8M.createCommand)(()=>{
        return {
            type: (0, $l0B7L.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $722f1e15dd092c87$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $722f1e15dd092c87$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $722f1e15dd092c87$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $722f1e15dd092c87$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $722f1e15dd092c87$var$bullets
        },
        {
            node: orderedList,
            matcher: $722f1e15dd092c87$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $722f1e15dd092c87$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $722f1e15dd092c87$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $7vpuQ.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $722f1e15dd092c87$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $722f1e15dd092c87$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $722f1e15dd092c87$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $722f1e15dd092c87$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $kCV8T.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $kCV8T.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $gZGBX.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $2RHbH.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $uTDrM.isListNode)(before) && (0, $uTDrM.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $kCV8T.Fragment).from(result);
    return fragment;
};
const $722f1e15dd092c87$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $722f1e15dd092c87$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $722f1e15dd092c87$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $722f1e15dd092c87$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $kCV8T.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $722f1e15dd092c87$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $722f1e15dd092c87$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $kCV8T.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $kCV8T.Fragment).from(paragraphs.length ? paragraphs : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};

});
parcelRegister("6eO8M", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $79a615e374ca307c$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $79a615e374ca307c$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $79a615e374ca307c$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $79a615e374ca307c$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $gZGBX = parcelRequire("gZGBX");

var $h5cYA = parcelRequire("h5cYA");
const $79a615e374ca307c$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('pastePlugin');
const { createPluginState: $79a615e374ca307c$export$656c7661095efe2e, createCommand: $79a615e374ca307c$export$8d4021544bdece00, getPluginState: $79a615e374ca307c$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)($79a615e374ca307c$export$18d4026d1ea86bb1, (0, $h5cYA.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});

});
parcelRegister("h5cYA", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $a8b889ccc948d24f$export$1650419e431d3ba3);

var $l0B7L = parcelRequire("l0B7L");
const $a8b889ccc948d24f$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $l0B7L.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $l0B7L.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $l0B7L.PastePluginActionTypes).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        default:
            return state;
    }
};

});



parcelRegister("sgs63", function(module, exports) {

$parcel$export(module.exports, "transformSliceForMedia", () => $dd0e5610352b139f$export$5ed9534d355a0a0f);
$parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", () => $dd0e5610352b139f$export$bd95a8dd607682c8);
$parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", () => $dd0e5610352b139f$export$77944619eaa3fcd3);
$parcel$export(module.exports, "unwrapNestedMediaElements", () => $dd0e5610352b139f$export$3b69af3aaae9ee54);

var $intz5 = parcelRequire("intz5");

var $7vpuQ = parcelRequire("7vpuQ");
var $eQcNy = parcelRequire("eQcNy");

var $5r0mK = parcelRequire("5r0mK");

var $27T0s = parcelRequire("27T0s");
function $dd0e5610352b139f$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $5r0mK.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $7vpuQ.mapSlice)(newSlice, (node)=>{
            const mediaState = api?.media?.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState?.mediaOptions?.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $5r0mK.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $5r0mK.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $dd0e5610352b139f$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $dd0e5610352b139f$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($dd0e5610352b139f$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $dd0e5610352b139f$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $7vpuQ.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            const mediaState = api?.media?.sharedState.currentState();
            return mediaState?.mediaOptions?.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $intz5.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $7vpuQ.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $27T0s.getRandomHex)(8);
        if (node.type === media) {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $dd0e5610352b139f$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $dd0e5610352b139f$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $dd0e5610352b139f$var$canContainImage(element) {
    if (!element) return false;
    return $dd0e5610352b139f$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
const $dd0e5610352b139f$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $eQcNy.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($dd0e5610352b139f$var$isElementInvisible(mediaParent) || $dd0e5610352b139f$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($dd0e5610352b139f$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $eQcNy.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $dd0e5610352b139f$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $eQcNy.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};

});

parcelRegister("hJPkr", function(module, exports) {

$parcel$export(module.exports, "sendPasteAnalyticsEvent", () => $da2e92405151db04$export$5ee87eef0a304a1b);
$parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", () => $da2e92405151db04$export$69d6e3902009956e);
$parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", () => $da2e92405151db04$export$e3873690443e0966);
$parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", () => $da2e92405151db04$export$e1d2fb186881c383);
$parcel$export(module.exports, "handleCodeBlockWithAnalytics", () => $da2e92405151db04$export$9fea421173ba6d7d);
$parcel$export(module.exports, "handleMediaSingleWithAnalytics", () => $da2e92405151db04$export$b49fd82cf59cd44e);
$parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", () => $da2e92405151db04$export$ef36b80b79d1d973);
$parcel$export(module.exports, "handleMarkdownWithAnalytics", () => $da2e92405151db04$export$d7489d309972091e);
$parcel$export(module.exports, "handleRichTextWithAnalytics", () => $da2e92405151db04$export$3ef868f9e7157717);
$parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", () => $da2e92405151db04$export$2d195c5439ce2ebc);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", () => $da2e92405151db04$export$bbc9709b7b4a2f6);
$parcel$export(module.exports, "handleExpandWithAnalytics", () => $da2e92405151db04$export$6681e5bfb9c8b704);
$parcel$export(module.exports, "handleNestedTablePasteWithAnalytics", () => $da2e92405151db04$export$7dc8d4c52517a2f7);
$parcel$export(module.exports, "handleSelectedTableWithAnalytics", () => $da2e92405151db04$export$6dbadac5ea22dd7a);
$parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", () => $da2e92405151db04$export$b36a7c9ea20b7bbf);
$parcel$export(module.exports, "createPasteMeasurePayload", () => $da2e92405151db04$export$5dd5834ba1e07721);
$parcel$export(module.exports, "getContentNodeTypes", () => $da2e92405151db04$export$629ff5588e070c83);

var $gkwXh = parcelRequire("gkwXh");
var $2yLEW = parcelRequire("2yLEW");

var $dPSMN = parcelRequire("dPSMN");
var $7vpuQ = parcelRequire("7vpuQ");

var $5r0mK = parcelRequire("5r0mK");

var $bZdX5 = parcelRequire("bZdX5");

var $hUtHc = parcelRequire("hUtHc");
const $da2e92405151db04$var$contentToPasteContent = {
    url: (0, $2yLEW.PasteContents).url,
    paragraph: (0, $2yLEW.PasteContents).text,
    bulletList: (0, $2yLEW.PasteContents).bulletList,
    orderedList: (0, $2yLEW.PasteContents).orderedList,
    heading: (0, $2yLEW.PasteContents).heading,
    blockquote: (0, $2yLEW.PasteContents).blockquote,
    codeBlock: (0, $2yLEW.PasteContents).codeBlock,
    panel: (0, $2yLEW.PasteContents).panel,
    rule: (0, $2yLEW.PasteContents).rule,
    mediaSingle: (0, $2yLEW.PasteContents).mediaSingle,
    mediaCard: (0, $2yLEW.PasteContents).mediaCard,
    mediaGroup: (0, $2yLEW.PasteContents).mediaGroup,
    table: (0, $2yLEW.PasteContents).table,
    tableCells: (0, $2yLEW.PasteContents).tableCells,
    tableHeader: (0, $2yLEW.PasteContents).tableHeader,
    tableRow: (0, $2yLEW.PasteContents).tableRow,
    decisionList: (0, $2yLEW.PasteContents).decisionList,
    decisionItem: (0, $2yLEW.PasteContents).decisionItem,
    taskList: (0, $2yLEW.PasteContents).taskItem,
    extension: (0, $2yLEW.PasteContents).extension,
    bodiedExtension: (0, $2yLEW.PasteContents).bodiedExtension,
    blockCard: (0, $2yLEW.PasteContents).blockCard,
    layoutSection: (0, $2yLEW.PasteContents).layoutSection
};
const $da2e92405151db04$var$nodeToActionSubjectId = {
    blockquote: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $da2e92405151db04$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $2yLEW.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $2yLEW.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    const pasteContent = $da2e92405151db04$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $2yLEW.PasteContents).uncategorized;
}
function $da2e92405151db04$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $da2e92405151db04$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $5r0mK.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $da2e92405151db04$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $da2e92405151db04$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $gkwXh.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $da2e92405151db04$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $gkwXh.ACTION).PASTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $da2e92405151db04$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $da2e92405151db04$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $da2e92405151db04$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $2yLEW.PasteContents).url || content === (0, $2yLEW.PasteContents).mixed) (0, $7vpuQ.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $da2e92405151db04$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $bZdX5.getPasteSource)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        if (pasteContext.type === (0, $2yLEW.PasteTypes).plain) return $da2e92405151db04$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $2yLEW.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        });
        const linkDomains = linkUrls.map((0, $dPSMN.getLinkDomain));
        return $da2e92405151db04$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        }, linkDomains);
    };
}
function $da2e92405151db04$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $da2e92405151db04$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $da2e92405151db04$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $da2e92405151db04$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).plain,
            asPlain: true
        }))((0, $hUtHc.handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
const $da2e92405151db04$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $hUtHc.handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $hUtHc.handlePasteIntoCaption)(slice));
const $da2e92405151db04$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).plain
        }))((0, $hUtHc.handleCodeBlock)(text));
const $da2e92405151db04$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $hUtHc.handleMediaSingle)((0, $gkwXh.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $da2e92405151db04$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $hUtHc.handlePastePreservingMarks)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $2yLEW.PasteTypes).markdown
    }))((0, $hUtHc.handleMarkdown)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $2yLEW.PasteTypes).richText
    }, pluginInjectionApi))((0, $hUtHc.handleRichText)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $da2e92405151db04$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText
        }))((0, $hUtHc.handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
const $da2e92405151db04$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $hUtHc.handlePasteNonNestableBlockNodesIntoList)(slice));
const $da2e92405151db04$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $hUtHc.handleExpandPaste)(slice));
const $da2e92405151db04$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $hUtHc.handleNestedTablePaste)(slice, isNestingTablesSupported));
const $da2e92405151db04$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText
        }))((0, $hUtHc.handleSelectedTable)(editorAnalyticsAPI)(slice));
const $da2e92405151db04$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $hUtHc.handlePasteLinkOnSelectedText)(slice));
const $da2e92405151db04$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $da2e92405151db04$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $gkwXh.ACTION).PASTED_TIMED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $da2e92405151db04$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$da2e92405151db04$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};

});
parcelRegister("bZdX5", function(module, exports) {

$parcel$export(module.exports, "isPastedFromWord", () => $ad2fbb626fc6cd3c$export$6ba9f527e53e4ac1);
$parcel$export(module.exports, "isPastedFromExcel", () => $ad2fbb626fc6cd3c$export$8d0b7622c89b176c);
$parcel$export(module.exports, "htmlContainsSingleFile", () => $ad2fbb626fc6cd3c$export$41d193509f55b76e);
$parcel$export(module.exports, "getPasteSource", () => $ad2fbb626fc6cd3c$export$e45b5b7458bacd81);
$parcel$export(module.exports, "escapeLinks", () => $ad2fbb626fc6cd3c$export$8acd10161c5f8b07);
$parcel$export(module.exports, "hasOnlyNodesOfType", () => $ad2fbb626fc6cd3c$export$a4568554bf9b43cd);
$parcel$export(module.exports, "applyTextMarksToSlice", () => $ad2fbb626fc6cd3c$export$3bf611fd421c1669);
$parcel$export(module.exports, "isEmptyNode", () => $ad2fbb626fc6cd3c$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", () => $ad2fbb626fc6cd3c$export$ee1d3ec5b3695690);
$parcel$export(module.exports, "isSelectionInsidePanel", () => $ad2fbb626fc6cd3c$export$3befc640b7d49184);
$parcel$export(module.exports, "htmlHasInvalidLinkTags", () => $ad2fbb626fc6cd3c$export$3c3a613abe5bb97d);
$parcel$export(module.exports, "removeDuplicateInvalidLinks", () => $ad2fbb626fc6cd3c$export$35ca1bb0581efaf3);
$parcel$export(module.exports, "addReplaceSelectedTableAnalytics", () => $ad2fbb626fc6cd3c$export$4f704994f6a89bd1);
$parcel$export(module.exports, "transformUnsupportedBlockCardToInline", () => $ad2fbb626fc6cd3c$export$9ffea5586131a948);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $aZPvj = parcelRequire("aZPvj");

var $20Kbb = parcelRequire("20Kbb");
var $7vpuQ = parcelRequire("7vpuQ");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $cwe6a = parcelRequire("cwe6a");
var $cK1Lv = parcelRequire("cK1Lv");

var $9KG2L = parcelRequire("9KG2L");

var $VSDnB = parcelRequire("VSDnB");
function $ad2fbb626fc6cd3c$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $ad2fbb626fc6cd3c$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $ad2fbb626fc6cd3c$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $ad2fbb626fc6cd3c$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $ad2fbb626fc6cd3c$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $ad2fbb626fc6cd3c$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $ad2fbb626fc6cd3c$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
const $ad2fbb626fc6cd3c$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $ad2fbb626fc6cd3c$export$41d193509f55b76e(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html.match(/<img .*>/) && !(0, $9KG2L.isMediaBlobUrl)(html);
}
function $ad2fbb626fc6cd3c$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($ad2fbb626fc6cd3c$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($ad2fbb626fc6cd3c$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($ad2fbb626fc6cd3c$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    return 'uncategorized';
}
function $ad2fbb626fc6cd3c$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/) ? `<${str}>` : str;
    });
}
function $ad2fbb626fc6cd3c$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $ad2fbb626fc6cd3c$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $kCV8T.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $aZPvj.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if ((0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) {
                if (node.isInline && [
                    'inlineCard',
                    'emoji',
                    'status',
                    'date',
                    'mention'
                ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    ...node.marks,
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
                ];
            }
            return true;
        });
        return sliceCopy;
    };
}
function $ad2fbb626fc6cd3c$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $kCV8T.Mark).sameSet(emptyNode.marks, node.marks);
}
function $ad2fbb626fc6cd3c$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $gZGBX.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $ad2fbb626fc6cd3c$export$c7c9ca5cba02ff5a(node) {
    return Boolean(node && node.type.name === 'panel');
}
function $ad2fbb626fc6cd3c$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $gZGBX.NodeSelection) && $ad2fbb626fc6cd3c$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
    const panelPosition = (0, $5r0mK.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $ad2fbb626fc6cd3c$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $ad2fbb626fc6cd3c$export$35ca1bb0581efaf3 = (html)=>{
    if ($ad2fbb626fc6cd3c$export$3c3a613abe5bb97d(html)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const htmlArray = html.split(/(?=<a)/);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $ad2fbb626fc6cd3c$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $cK1Lv.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $cwe6a.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $dEzej.TABLE_ACTION).REPLACED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $gkwXh.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $ad2fbb626fc6cd3c$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $7vpuQ.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$ad2fbb626fc6cd3c$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $ad2fbb626fc6cd3c$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $20Kbb.isSupportedInParent)(state, frag);
};

});
parcelRegister("dEzej", function(module, exports) {

$parcel$export(module.exports, "TABLE_ACTION", () => $e52e9249b2889c06$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $e52e9249b2889c06$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $e52e9249b2889c06$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $e52e9249b2889c06$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $e52e9249b2889c06$export$ba2dfc055a59d951);
var $e52e9249b2889c06$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    return TABLE_ACTION;
}({});
var $e52e9249b2889c06$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $e52e9249b2889c06$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $e52e9249b2889c06$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $e52e9249b2889c06$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $e52e9249b2889c06$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});

parcelRegister("cwe6a", function(module, exports) {

$parcel$export(module.exports, "getSelectedTableInfo", () => $042ffe26ab726773$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $042ffe26ab726773$export$277d5394a2608229);

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");

var $b1RTQ = parcelRequire("b1RTQ");
function $042ffe26ab726773$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $28MvW.findTable)(selection);
    if (table) {
        map = (0, $uOUlv.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $042ffe26ab726773$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $042ffe26ab726773$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}

});
parcelRegister("28MvW", function(module, exports) {

$parcel$export(module.exports, "findTable", () => $558e59ba96522ad6$export$1ae6a0a4f7784fc4);
$parcel$export(module.exports, "findTableClosestToPos", () => $558e59ba96522ad6$export$9323c80f9a3e899f);
$parcel$export(module.exports, "findCellClosestToPos", () => $558e59ba96522ad6$export$3ac56532a0bf4018);
$parcel$export(module.exports, "findCellRectClosestToPos", () => $558e59ba96522ad6$export$68680ae223aebfa7);

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");
const $558e59ba96522ad6$export$1ae6a0a4f7784fc4 = (selection)=>(0, $5r0mK.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $558e59ba96522ad6$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $5r0mK.findParentNodeClosestToPos)($pos, predicate);
};
const $558e59ba96522ad6$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $5r0mK.findParentNodeClosestToPos)($pos, predicate);
};
const $558e59ba96522ad6$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $558e59ba96522ad6$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $558e59ba96522ad6$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $uOUlv.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};

});

parcelRegister("b1RTQ", function(module, exports) {

$parcel$export(module.exports, "getSelectionRect", () => $0876234ba373a2bf$export$aa946c0ed562e2ed);

var $uOUlv = parcelRequire("uOUlv");

var $iGxzn = parcelRequire("iGxzn");
const $0876234ba373a2bf$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $iGxzn.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

});


parcelRegister("cK1Lv", function(module, exports) {

$parcel$export(module.exports, "isColumnSelected", () => $65abce04567f614e$export$8db1cdcc0c397a6d);
$parcel$export(module.exports, "isRowSelected", () => $65abce04567f614e$export$710e11cf672b86c);
$parcel$export(module.exports, "isTableSelected", () => $65abce04567f614e$export$5d08de4a0eeb0408);

var $uOUlv = parcelRequire("uOUlv");

var $iGxzn = parcelRequire("iGxzn");
const $65abce04567f614e$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $iGxzn.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $65abce04567f614e$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $iGxzn.isSelectionType)(selection, 'cell')) {
            const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
            return $65abce04567f614e$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $65abce04567f614e$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $iGxzn.isSelectionType)(selection, 'cell')) {
            const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
            return $65abce04567f614e$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $65abce04567f614e$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $iGxzn.isSelectionType)(selection, 'cell')) {
        const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
        return $65abce04567f614e$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};

});


parcelRegister("hUtHc", function(module, exports) {

$parcel$export(module.exports, "handleMention", () => $4c86f6f3d3a46b33$export$7097a0398467de9c);
$parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", () => $4c86f6f3d3a46b33$export$af959912bf89ae42);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", () => $4c86f6f3d3a46b33$export$b8a52be876d0b84f);
$parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", () => $4c86f6f3d3a46b33$export$3fd7f6d89a9d2cac);
$parcel$export(module.exports, "handlePasteLinkOnSelectedText", () => $4c86f6f3d3a46b33$export$5e27b285bdcc71bf);
$parcel$export(module.exports, "handlePasteAsPlainText", () => $4c86f6f3d3a46b33$export$efe55f809fabb910);
$parcel$export(module.exports, "handlePastePreservingMarks", () => $4c86f6f3d3a46b33$export$de618421675f910e);
$parcel$export(module.exports, "handleMacroAutoConvert", () => $4c86f6f3d3a46b33$export$d23738992a74c3a9);
$parcel$export(module.exports, "handleMarkdown", () => $4c86f6f3d3a46b33$export$4b83e18c607f848f);
$parcel$export(module.exports, "handleCodeBlock", () => $4c86f6f3d3a46b33$export$98135102f7ccdef2);
$parcel$export(module.exports, "handleMediaSingle", () => $4c86f6f3d3a46b33$export$5fb647c5a57bac64);
$parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", () => $4c86f6f3d3a46b33$export$36e0fe2cadced224);
$parcel$export(module.exports, "handleNestedTablePaste", () => $4c86f6f3d3a46b33$export$113227139658cc8d);
$parcel$export(module.exports, "handleExpandPaste", () => $4c86f6f3d3a46b33$export$a497757c6eac4530);
$parcel$export(module.exports, "handleParagraphBlockMarks", () => $4c86f6f3d3a46b33$export$feb0d61bf65d9267);
$parcel$export(module.exports, "handleRichText", () => $4c86f6f3d3a46b33$export$f9c7e15c780a77d0);
$parcel$export(module.exports, "handlePasteIntoCaption", () => $4c86f6f3d3a46b33$export$d399a86cc775ad7e);
$parcel$export(module.exports, "handleSelectedTable", () => $4c86f6f3d3a46b33$export$4ce587bb5876886d);

var $bXrHm = parcelRequire("bXrHm");

var $gkwXh = parcelRequire("gkwXh");

var $kxM7f = parcelRequire("kxM7f");

var $30Enc = parcelRequire("30Enc");

var $9O539 = parcelRequire("9O539");

var $hPjvp = parcelRequire("hPjvp");

var $dPSMN = parcelRequire("dPSMN");
var $77j9j = parcelRequire("77j9j");
var $20Kbb = parcelRequire("20Kbb");
var $uTDrM = parcelRequire("uTDrM");
var $7vpuQ = parcelRequire("7vpuQ");

var $fZzhT = parcelRequire("fZzhT");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $4b1iw = parcelRequire("4b1iw");

var $gmhCD = parcelRequire("gmhCD");

var $iMJAN = parcelRequire("iMJAN");

var $6eO8M = parcelRequire("6eO8M");

var $fnWG9 = parcelRequire("fnWG9");

var $7h0c3 = parcelRequire("7h0c3");

var $bZdX5 = parcelRequire("bZdX5");
const $4c86f6f3d3a46b33$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $4c86f6f3d3a46b33$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $4c86f6f3d3a46b33$export$7097a0398467de9c(slice, schema) {
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $4c86f6f3d3a46b33$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $gZGBX.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        const selectionHasValidParentNode = (0, $5r0mK.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $5r0mK.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const panelNode = (0, $bZdX5.isSelectionInsidePanel)(selection);
        const selectionIsPanel = Boolean(panelNode);
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        if (selectionIsPanel && selectionIsCodeBlock) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $5r0mK.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $dPSMN.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $gZGBX.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $bZdX5.hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $30Enc.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $bZdX5.applyTextMarksToSlice)(schema, selection.$head.marks()));
        const transformedSlice = $4c86f6f3d3a46b33$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $fZzhT.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, $bZdX5.isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $7h0c3.insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $77j9j.isInListItem)(state) || (0, $77j9j.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
        if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $kCV8T.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $5r0mK.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $77j9j.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $5r0mK.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $gZGBX.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4c86f6f3d3a46b33$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $uTDrM.isListNode)(sliceContent.firstChild) && (0, $uTDrM.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $5r0mK.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($4c86f6f3d3a46b33$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $5r0mK.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $fnWG9.insertSliceInsideBlockquote)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $4c86f6f3d3a46b33$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $4c86f6f3d3a46b33$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$4c86f6f3d3a46b33$export$c2473d50cf33051b(selection, findRootParentListNode);
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4c86f6f3d3a46b33$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $20Kbb.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $20Kbb.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $20Kbb.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && selection instanceof (0, $gZGBX.TextSelection) && !selection.empty && (0, $dPSMN.canLinkBeCreatedInRange)(from, to)(state)) {
            tr.addMark(from, to, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $fZzhT.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $4b1iw.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bZdX5.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $30Enc.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $5r0mK.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $bZdX5.hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $bZdX5.applyTextMarksToSlice)(schema, selectionMarks)(slice);
            const tr = (0, $fZzhT.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $4c86f6f3d3a46b33$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        view.dispatch((0, $fZzhT.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView());
        return true;
    }
    return false;
}
function $4c86f6f3d3a46b33$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $kCV8T.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $iMJAN.startTrackingPastedMacroPositions)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $4c86f6f3d3a46b33$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $6eO8M.getPluginState)(view.state);
                    if (dispatch) $4c86f6f3d3a46b33$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $6eO8M.getPluginState)(view.state);
                    $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $iMJAN.stopTrackingPastedMacroPositions)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $4c86f6f3d3a46b33$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $5r0mK.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $fZzhT.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $4c86f6f3d3a46b33$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $4c86f6f3d3a46b33$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($4c86f6f3d3a46b33$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $kxM7f.insideTable)(state) && $4c86f6f3d3a46b33$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $hPjvp.GapCursorSelection)(nextPos, (0, $hPjvp.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $4c86f6f3d3a46b33$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $4c86f6f3d3a46b33$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $kxM7f.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $7vpuQ.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $kxM7f.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) {
            if ((0, $gmhCD.editorExperiment)('nested-tables-in-tables', true, {
                exposure: true
            })) /* TEST COHORT */ // if slice has table - if pasting to deeply nested location place paste after top table
            {
                if ((0, $9O539.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                    const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                    let { tr: tr } = state;
                    tr = (0, $5r0mK.safeInsert)(slice.content, positionAfterTopTable)(tr);
                    tr.scrollIntoView();
                    if (dispatch) {
                        dispatch(tr);
                        return true;
                    }
                }
            } else {
                /* CONTROL COHORT */ // if slice has table - place paste after top table
                const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $5r0mK.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$4c86f6f3d3a46b33$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $kxM7f.insideTable)(state) && !isInsideNestableExpand || !$4c86f6f3d3a46b33$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $7vpuQ.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch (e) {
                    tr = (0, $5r0mK.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $kCV8T.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $5r0mK.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $fZzhT.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $gZGBX.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $4c86f6f3d3a46b33$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $4c86f6f3d3a46b33$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $4c86f6f3d3a46b33$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $uTDrM.isListNode)(child) || (0, $uTDrM.isListItemNode)(child) && (0, $uTDrM.isListNode)(child.firstChild)) $4c86f6f3d3a46b33$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $4c86f6f3d3a46b33$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $kxM7f.insideTable)(state) && (0, $uTDrM.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $4c86f6f3d3a46b33$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $4c86f6f3d3a46b33$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
function $4c86f6f3d3a46b33$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: { $from: $from } } = state;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$4c86f6f3d3a46b33$var$sliceHasTopLevelMarks(slice)) return slice;
    // If pasting a single paragraph into pre-existing content, match destination formatting
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $4c86f6f3d3a46b33$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    if (forbiddenMarkTypes.length === 0) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $kCV8T.Slice)(slice.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return schema.nodes.paragraph.createChecked(undefined, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        else if (node.type === schema.nodes.heading) // Preserve heading attributes to keep formatting
        return schema.nodes.heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
}
function $4c86f6f3d3a46b33$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $4c86f6f3d3a46b33$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $kCV8T.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
function $4c86f6f3d3a46b33$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel } = state.schema.nodes;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($4c86f6f3d3a46b33$var$hasInlineCode(state, slice)) $4c86f6f3d3a46b33$var$removePrecedingBackTick(tr);
        if ($4c86f6f3d3a46b33$var$shouldFlattenList(state, slice)) slice = $4c86f6f3d3a46b33$export$79d83373d2946ba6(slice);
        (0, $fZzhT.closeHistory)(tr);
        const isFirstChildListNode = (0, $uTDrM.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $uTDrM.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        const panelParentOverCurrentSelection = (0, $5r0mK.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $fnWG9.insertSliceForLists)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $fnWG9.insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $gZGBX.TextSelection).findFrom($nextPos, -1, true) : new (0, $hPjvp.GapCursorSelection)($nextPos, (0, $hPjvp.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $77j9j.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $hPjvp.GapCursorSelection)(nextPos, (0, $hPjvp.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $77j9j.insideTableCell)(state) && (0, $77j9j.isInListItem)(state) && (0, $5r0mK.canInsert)(selection.$from, slice.content) && (0, $5r0mK.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($4c86f6f3d3a46b33$export$f0f8559835c0f076(state, slice) && !$4c86f6f3d3a46b33$export$67c0f4368bb304c3(state)) (0, $fnWG9.insertSliceForTaskInsideList)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $5r0mK.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($4c86f6f3d3a46b33$export$f0f8559835c0f076(state, slice)) (0, $fnWG9.updateSelectionAfterReplace)({
                    tr: tr
                });
            }
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $gZGBX.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4c86f6f3d3a46b33$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $5r0mK.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $4c86f6f3d3a46b33$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $4b1iw.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bZdX5.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $4c86f6f3d3a46b33$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $77j9j.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}
function $4c86f6f3d3a46b33$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $uTDrM.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}

});
parcelRegister("9O539", function(module, exports) {

$parcel$export(module.exports, "getParentOfTypeCount", () => $d19def70e328a0c5$export$d5cbd8b17958f08b);
$parcel$export(module.exports, "getPositionAfterTopParentNodeOfType", () => $d19def70e328a0c5$export$ae584b8f0be37f04);
$parcel$export(module.exports, "isSelectionTableNestedInTable", () => $d19def70e328a0c5$export$3dd46fa6c35aa514);

var $28MvW = parcelRequire("28MvW");
const $d19def70e328a0c5$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
const $d19def70e328a0c5$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
const $d19def70e328a0c5$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $28MvW.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};

});

parcelRegister("4b1iw", function(module, exports) {

$parcel$export(module.exports, "replaceSelectedTable", () => $567d91c47399f4b9$export$ea73b328547c6ad5);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $28MvW = parcelRequire("28MvW");

var $cK1Lv = parcelRequire("cK1Lv");
const $567d91c47399f4b9$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $cK1Lv.isTableSelected)(state.selection)) {
        const table = (0, $28MvW.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("fnWG9", function(module, exports) {

$parcel$export(module.exports, "insertSliceForLists", () => $f9068438f432e0de$export$9beec16307c108ac);
$parcel$export(module.exports, "insertSliceInsideBlockquote", () => $f9068438f432e0de$export$2dee216d0a70c94e);
$parcel$export(module.exports, "updateSelectionAfterReplace", () => $f9068438f432e0de$export$e57c13697a8b8195);
$parcel$export(module.exports, "insertSliceForTaskInsideList", () => $f9068438f432e0de$export$2982aac953f7c8b6);

var $uTDrM = parcelRequire("uTDrM");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $bZdX5 = parcelRequire("bZdX5");

var $7h0c3 = parcelRequire("7h0c3");
function $f9068438f432e0de$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $bZdX5.isSelectionInsidePanel)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $uTDrM.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $7h0c3.insertSliceIntoRangeSelectionInsideList)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $bZdX5.isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, $7h0c3.insertSliceInsideOfPanelNodeSelected)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $bZdX5.isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, $7h0c3.insertSliceIntoEmptyNode)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $5r0mK.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $uTDrM.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $bZdX5.isCursorSelectionAtTextStartOrEnd)(selection)) return (0, $7h0c3.insertSliceAtNodeEdge)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
function $f9068438f432e0de$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $f9068438f432e0de$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
}
function $f9068438f432e0de$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eS2Dn.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $f9068438f432e0de$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
    const selectionBeforeReplace = tr.selection.from;
    tr.replaceSelection(new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
    const nextSelection = (0, $gZGBX.Selection).near(tr.doc.resolve(selectionBeforeReplace + 1));
    tr.setSelection(nextSelection);
    tr.replaceSelection(slice);
}

});
parcelRegister("7h0c3", function(module, exports) {

$parcel$export(module.exports, "insertSliceIntoEmptyNode", () => $dd1e536a1e22a270$export$d69afd888d46c7c);
$parcel$export(module.exports, "insertSliceAtNodeEdge", () => $dd1e536a1e22a270$export$7b48cb097052829);
$parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", () => $dd1e536a1e22a270$export$eee44e0848f600ea);
$parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", () => $dd1e536a1e22a270$export$778b6ddd10a6aad3);
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");
function $dd1e536a1e22a270$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $dd1e536a1e22a270$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $gZGBX.TextSelection).near(startSlicePosition, direction));
}
function $dd1e536a1e22a270$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $gZGBX.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $dd1e536a1e22a270$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $kCV8T.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema) {
                const mbeParentOfPanel = (0, $5r0mK.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $kCV8T.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $594Yf.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $eS2Dn.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $gZGBX.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}

});




parcelRegister("jI1GO", function(module, exports) {

$parcel$export(module.exports, "clipboardTextSerializer", () => $29f021d097812b5c$export$31d6ecfc7a959697);
function $29f021d097812b5c$export$31d6ecfc7a959697(slice) {
    const blockSeparator = '\n\n';
    return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
        switch(leafNode.type.name){
            case 'hardBreak':
                return '\n';
            case 'text':
                return leafNode.text;
            case 'inlineCard':
                return leafNode.attrs.url;
            case 'blockCard':
                return leafNode.attrs.url;
            // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
            // pasting a mention does not actually work for the in-product Mention implementation.
            // However, this is also true of the previous implementation.
            // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
            case 'mention':
                return leafNode.attrs.text;
            default:
                // Unsupported node
                return leafNode.text ?? '';
        }
    });
}

});

parcelRegister("cOOfv", function(module, exports) {

$parcel$export(module.exports, "handleVSCodeBlock", () => $e3d6290730f0f4f2$export$d920fedcc56c4475);

var $8Y2ZY = parcelRequire("8Y2ZY");

var $7vpuQ = parcelRequire("7vpuQ");
function $e3d6290730f0f4f2$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData?.mode;
    } catch (_e) {}
}
function $e3d6290730f0f4f2$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
    const language = $e3d6290730f0f4f2$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $8Y2ZY.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $7vpuQ.mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.codeBlock?.name) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}

});
parcelRegister("8Y2ZY", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $012a854d92762508$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $012a854d92762508$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("jbxbo", function(module, exports) {

$parcel$export(module.exports, "isPastedFromTinyMCEConfluence", () => $f13fdafc86889fbe$export$4a3cccc9bf9da386);
$parcel$export(module.exports, "htmlHasIncompleteTable", () => $f13fdafc86889fbe$export$120b137b77798e76);
$parcel$export(module.exports, "tryRebuildCompleteTableHtml", () => $f13fdafc86889fbe$export$253f7bda9f1e0696);

var $azYnG = parcelRequire("azYnG");
const $f13fdafc86889fbe$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $f13fdafc86889fbe$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $f13fdafc86889fbe$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $f13fdafc86889fbe$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $f13fdafc86889fbe$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $f13fdafc86889fbe$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($f13fdafc86889fbe$var$exactlyDivisible(thCount, cellCount) || $f13fdafc86889fbe$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $f13fdafc86889fbe$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($azYnG)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $f13fdafc86889fbe$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$f13fdafc86889fbe$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $f13fdafc86889fbe$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $f13fdafc86889fbe$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $f13fdafc86889fbe$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $f13fdafc86889fbe$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($f13fdafc86889fbe$var$exactlyDivisible(thCount, possibleColsInRow) && $f13fdafc86889fbe$var$exactlyDivisible(cellCount, possibleColsInRow)) return $f13fdafc86889fbe$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $f13fdafc86889fbe$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $f13fdafc86889fbe$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $f13fdafc86889fbe$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $f13fdafc86889fbe$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};

});


parcelRegister("2NfYE", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $2be0cbb83c95428b$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $VSDnB = parcelRequire("VSDnB");

var $i7Qmp = parcelRequire("i7Qmp");

var $8rlPn = parcelRequire("8rlPn");

var $5k8Yv = parcelRequire("5k8Yv");

var $9CaqV = parcelRequire("9CaqV");

var $h3AOq = parcelRequire("h3AOq");
const $2be0cbb83c95428b$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $5k8Yv.pluginKey),
        state: (0, $8rlPn.createPluginState)(dispatch, (0, $9CaqV.defaultState)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $8rlPn.getPluginState)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeName || !(0, $h3AOq.isCursorSelectionAtTopLevel)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).MOVED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        // keep nodeName from copied slice
                        nodeType: contentMoved?.nodeName,
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $h3AOq.getParentNodeDepth)(state.selection),
                        nodeTypes: contentMoved?.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved?.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $i7Qmp.resetContentMovedTransform)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                // Note: the following is not the case once `platform_editor_element_drag_and_drop_multiselect` is enabled
                // we now want to track cut events for multiple nodes
                // Content should be just one node, so we added a check for slice.content.childCount === 1;
                // 1. It is possible to select a table by dragging the mouse over the table's rows.
                // As a result, slice will contain rows without tableNode itself and the childCount will be the number of rows.
                // From a user's perspective the whole table is selected and copied and on paste a table will indeed be created.
                // 2. Some block nodes can get selected when a user drags the mouse from the paragraph above the node to
                // the paragraph below the node. Visually only the node in between is selected, in reality, three nodes are
                // in the slice.
                // These cases are ignored and moveContent event won't be counted.
                const isMultiSelectTrackingEnabled = (0, $VSDnB.fg)('platform_editor_track_node_types');
                const nodeName = content.firstChild?.type.name || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if (isMultiSelectTrackingEnabled) {
                        if ((0, $h3AOq.containsExcludedNode)(content)) resetState = true;
                        else {
                            const attributes = (0, $h3AOq.getMultipleSelectionAttributes)(content);
                            nodeTypes = attributes.nodeTypes;
                            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        }
                    } else resetState = true;
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $h3AOq.isExcludedNode)(nodeName)) resetState = true;
                    if (!resetState && !(0, $h3AOq.isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                    if (!resetState && (0, $h3AOq.isInlineNode)(nodeName) && (0, $h3AOq.isNestedInlineNode)(selection)) resetState = true;
                    if (!resetState && (0, $h3AOq.isNestedInTable)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $i7Qmp.resetContentMoved)()(state, dispatch);
                else {
                    let newState = {
                        size: size,
                        nodeName: nodeName,
                        nodeDepth: (0, $h3AOq.getParentNodeDepth)(selection)
                    };
                    if (isMultiSelectTrackingEnabled) newState = {
                        ...newState,
                        nodeTypes: nodeTypes ?? nodeName,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $i7Qmp.updateContentMoved)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};

});
parcelRegister("i7Qmp", function(module, exports) {

$parcel$export(module.exports, "updateContentMoved", () => $798b2c41933df7a4$export$7c2867f48317a29d);
$parcel$export(module.exports, "resetContentMoved", () => $798b2c41933df7a4$export$56834735aa39d3eb);
$parcel$export(module.exports, "resetContentMovedTransform", () => $798b2c41933df7a4$export$47c45651eb91dff0);

var $f6ggO = parcelRequire("f6ggO");

var $8rlPn = parcelRequire("8rlPn");

var $5k8Yv = parcelRequire("5k8Yv");
const $798b2c41933df7a4$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $8rlPn.createCommand)((state)=>{
        const { contentMoved: contentMoved } = (0, $8rlPn.getPluginState)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeName: nextState?.nodeName,
            nodeDepth: nextState?.nodeDepth,
            nodeTypes: nextState?.nodeTypes,
            hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes
        };
        return {
            type: (0, $f6ggO.MoveAnalyticPluginTypes).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $798b2c41933df7a4$export$56834735aa39d3eb = ()=>(0, $8rlPn.createCommand)(()=>{
        return {
            type: (0, $f6ggO.MoveAnalyticPluginTypes).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $798b2c41933df7a4$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $f6ggO.MoveAnalyticPluginTypes).RemoveMovedAction
        };
        return tr.setMeta((0, $5k8Yv.pluginKey), payload);
    };

});
parcelRegister("f6ggO", function(module, exports) {

$parcel$export(module.exports, "MoveAnalyticPluginTypes", () => $7965858ec5e0044d$export$a5fa3822909c7e0);
var $7965858ec5e0044d$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});

});

parcelRegister("8rlPn", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $2081a2e3c7261c3b$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $2081a2e3c7261c3b$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $2081a2e3c7261c3b$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $5k8Yv = parcelRequire("5k8Yv");

var $7Pna1 = parcelRequire("7Pna1");
const { createPluginState: $2081a2e3c7261c3b$export$656c7661095efe2e, createCommand: $2081a2e3c7261c3b$export$8d4021544bdece00, getPluginState: $2081a2e3c7261c3b$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $5k8Yv.pluginKey), (0, $7Pna1.reducer));

});
parcelRegister("5k8Yv", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $9ce9393f2b841371$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $9ce9393f2b841371$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('moveAnalyticsPlugin');

});

parcelRegister("7Pna1", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $b034c2044beda78c$export$1650419e431d3ba3);

var $f6ggO = parcelRequire("f6ggO");

var $9CaqV = parcelRequire("9CaqV");
const $b034c2044beda78c$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $f6ggO.MoveAnalyticPluginTypes).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $f6ggO.MoveAnalyticPluginTypes).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $9CaqV.defaultState).contentMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("9CaqV", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $b1508633d2c50936$export$49d5fc8cba920a0);
// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $b1508633d2c50936$export$49d5fc8cba920a0 = {
    contentMoved: {
        nodeName: undefined,
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};

});




parcelRegister("h3AOq", function(module, exports) {

$parcel$export(module.exports, "isExcludedNode", () => $c3f86eb485557d11$export$75248da1527ddfc1);
$parcel$export(module.exports, "isCursorSelectionAtTopLevel", () => $c3f86eb485557d11$export$14f96cade94e47c);
$parcel$export(module.exports, "isInlineNode", () => $c3f86eb485557d11$export$82ae59a0847ee78b);
$parcel$export(module.exports, "isNestedInlineNode", () => $c3f86eb485557d11$export$8cd6af93b47990b9);
$parcel$export(module.exports, "isNestedInTable", () => $c3f86eb485557d11$export$78b714f3f17d88b0);
$parcel$export(module.exports, "getParentNodeDepth", () => $c3f86eb485557d11$export$568289ef11d607ce);
$parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", () => $c3f86eb485557d11$export$b6cb43348b690a2d);
$parcel$export(module.exports, "containsExcludedNode", () => $c3f86eb485557d11$export$c4a09517c4982d7c);
$parcel$export(module.exports, "getMultipleSelectionAttributes", () => $c3f86eb485557d11$export$f3a535d61fe1eda3);

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");
const $c3f86eb485557d11$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $c3f86eb485557d11$export$75248da1527ddfc1 = (nodeName)=>$c3f86eb485557d11$var$excludedNodes.includes(nodeName);
const $c3f86eb485557d11$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $c3f86eb485557d11$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $c3f86eb485557d11$export$82ae59a0847ee78b = (nodeName)=>{
    return $c3f86eb485557d11$var$inlineNodes.includes(nodeName);
};
const $c3f86eb485557d11$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $c3f86eb485557d11$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $hFEwm.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $c3f86eb485557d11$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $5r0mK.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $c3f86eb485557d11$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $c3f86eb485557d11$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        const nodeName = content.maybeChild(i)?.type.name || '';
        if ($c3f86eb485557d11$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $c3f86eb485557d11$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: (0, $VSDnB.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};

});




parcelRegister("7o36A", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => (parcelRequire("8OUh9")).placeholderPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8OUh9 = parcelRequire("8OUh9");

});
parcelRegister("8OUh9", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => $d98addc52985d2e7$export$ecbe4cfe6671ba88);

var $ixwvf = parcelRequire("ixwvf");

var $5KWxh = parcelRequire("5KWxh");

var $ggL2v = parcelRequire("ggL2v");
var $gE8f9 = parcelRequire("gE8f9");parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $d98addc52985d2e7$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('placeholderPlugin');
function $d98addc52985d2e7$var$getPlaceholderState(editorState) {
    return $d98addc52985d2e7$export$18d4026d1ea86bb1.getState(editorState);
}
const $d98addc52985d2e7$export$53e9a5af7ff64f3e = 'placeholder-test-id';
const $d98addc52985d2e7$var$nodeTypesWithLongPlaceholderText = [
    'expand',
    'panel'
];
const $d98addc52985d2e7$var$nodeTypesWithShortPlaceholderText = [
    'tableCell',
    'tableHeader'
];
function $d98addc52985d2e7$export$980ea07f18fbfea9(editorState, placeholderText, pos = 1) {
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', $d98addc52985d2e7$export$53e9a5af7ff64f3e);
    placeholderDecoration.className = 'placeholder-decoration';
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if ((0, $gE8f9.browser).gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    placeholderNodeWithText.textContent = placeholderText || ' ';
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if ((0, $gE8f9.browser).android && (0, $gE8f9.browser).chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    const isTargetNested = editorState.doc.resolve(pos).depth > 1;
    // only truncate text for nested nodes, otherwise applying 'overflow: hidden;' to top level nodes
    // creates issues with quick insert button
    if (isTargetNested && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) placeholderDecoration.classList.add('placeholder-decoration-hide-overflow');
    return (0, $etG8M.DecorationSet).create(editorState.doc, [
        (0, $etG8M.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: `placeholder ${placeholderText}`
        })
    ]);
}
function $d98addc52985d2e7$var$setPlaceHolderState(placeholderText, pos) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        pos: pos ? pos : 1
    };
}
const $d98addc52985d2e7$var$emptyPlaceholder = (placeholderText)=>({
        hasPlaceholder: false,
        placeholderText: placeholderText
    });
function $d98addc52985d2e7$var$createPlaceHolderStateFrom({ isEditorFocused: isEditorFocused, editorState: editorState, isTypeAheadOpen: isTypeAheadOpen, defaultPlaceholderText: defaultPlaceholderText, intl: intl, bracketPlaceholderText: bracketPlaceholderText, emptyLinePlaceholder: emptyLinePlaceholder }) {
    if (isTypeAheadOpen?.(editorState)) return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
    if (defaultPlaceholderText && (0, $ggL2v.isEmptyDocument)(editorState.doc)) return $d98addc52985d2e7$var$setPlaceHolderState(defaultPlaceholderText);
    if (isEditorFocused && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) {
        const { $from: $from, $to: $to } = editorState.selection;
        if ($from.pos !== $to.pos) return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
        const parentNode = $from.node($from.depth - 1);
        const parentType = parentNode?.type.name;
        if (emptyLinePlaceholder && parentType === 'doc') {
            const isEmptyLine = (0, $594Yf.isEmptyParagraph)($from.parent);
            if (isEmptyLine) return $d98addc52985d2e7$var$setPlaceHolderState(emptyLinePlaceholder, $from.pos);
        }
        const isEmptyNode = parentNode?.childCount === 1 && parentNode.firstChild?.content.size === 0 && parentNode.firstChild?.type.name === 'paragraph';
        if ($d98addc52985d2e7$var$nodeTypesWithShortPlaceholderText.includes(parentType) && isEmptyNode) {
            if (!(0, $VSDnB.fg)('platform_editor_controls_patch_3')) return $d98addc52985d2e7$var$setPlaceHolderState(intl.formatMessage((0, $ixwvf.placeholderTextMessages).shortEmptyNodePlaceholderText), $from.pos);
            const table = (0, $5r0mK.findParentNode)((node)=>node.type === editorState.schema.nodes.table)(editorState.selection);
            if (!table) return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
            const isFirstCell = table?.node.firstChild?.content.firstChild === parentNode;
            if (isFirstCell) return $d98addc52985d2e7$var$setPlaceHolderState(intl.formatMessage((0, $ixwvf.placeholderTextMessages).shortEmptyNodePlaceholderText), $from.pos);
        }
        if ($d98addc52985d2e7$var$nodeTypesWithLongPlaceholderText.includes(parentType) && isEmptyNode) return $d98addc52985d2e7$var$setPlaceHolderState(intl.formatMessage((0, $ixwvf.placeholderTextMessages).longEmptyNodePlaceholderText), $from.pos);
        return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
    }
    if (bracketPlaceholderText && (0, $ggL2v.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $d98addc52985d2e7$var$setPlaceHolderState(bracketHint, $from.pos - 1);
    }
    return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
}
function $d98addc52985d2e7$export$ae829ec7b2625219(intl, defaultPlaceholderText, bracketPlaceholderText, emptyLinePlaceholder, api) {
    if (!defaultPlaceholderText && !bracketPlaceholderText) return;
    return new (0, $5KWxh.SafePlugin)({
        key: $d98addc52985d2e7$export$18d4026d1ea86bb1,
        state: {
            init: (_, state)=>$d98addc52985d2e7$var$createPlaceHolderStateFrom({
                    isEditorFocused: Boolean(api?.focus?.sharedState.currentState()?.hasFocus),
                    editorState: state,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                }),
            apply: (tr, placeholderState, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($d98addc52985d2e7$export$18d4026d1ea86bb1);
                const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                if (meta?.placeholderText !== undefined) return $d98addc52985d2e7$var$createPlaceHolderStateFrom({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: meta.placeholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                });
                return $d98addc52985d2e7$var$createPlaceHolderStateFrom({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: placeholderState?.placeholderText ?? defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                });
            }
        },
        props: {
            decorations (editorState) {
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos } = $d98addc52985d2e7$var$getPlaceholderState(editorState);
                const compositionPluginState = api?.composition?.sharedState.currentState();
                if (hasPlaceholder && placeholderText && pos !== undefined && !compositionPluginState?.isComposing) return $d98addc52985d2e7$export$980ea07f18fbfea9(editorState, placeholderText, pos);
                return;
            }
        }
    });
}
const $d98addc52985d2e7$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>{
    let currentPlaceholder = options?.placeholder;
    return {
        name: 'placeholder',
        commands: {
            setPlaceholder: (placeholderText)=>({ tr: tr })=>{
                    if (currentPlaceholder !== placeholderText) {
                        currentPlaceholder = placeholderText;
                        return tr.setMeta($d98addc52985d2e7$export$18d4026d1ea86bb1, {
                            placeholderText: placeholderText
                        });
                    }
                    return null;
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ({ getIntl: getIntl })=>$d98addc52985d2e7$export$ae829ec7b2625219(getIntl(), options && options.placeholder, options && options.placeholderBracketHint, options && options.emptyLinePlaceholder, api)
                }
            ];
        }
    };
};

});


parcelRegister("1jBun", function(module, exports) {

$parcel$export(module.exports, "saveOnEnterPlugin", () => (parcelRequire("uNoBL")).saveOnEnterPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $uNoBL = parcelRequire("uNoBL");

});
parcelRegister("uNoBL", function(module, exports) {

$parcel$export(module.exports, "saveOnEnterPlugin", () => $c634f6c70c619408$export$8ba1e5775ae443a6);

var $gkwXh = parcelRequire("gkwXh");

var $4NUlu = parcelRequire("4NUlu");

var $vWFRY = parcelRequire("vWFRY");
const $c634f6c70c619408$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $vWFRY.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $c634f6c70c619408$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $4NUlu.analyticsEventKey), $c634f6c70c619408$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $c634f6c70c619408$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$c634f6c70c619408$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$c634f6c70c619408$var$isEmptyAtCursor($cursor);
}
function $c634f6c70c619408$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $c634f6c70c619408$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $gkwXh.ACTION).STOPPED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $gkwXh.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        }
    });
const $c634f6c70c619408$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$c634f6c70c619408$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });

});


parcelRegister("644sF", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => (parcelRequire("4R0EL")).selectionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4R0EL = parcelRequire("4R0EL");

});
parcelRegister("4R0EL", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => $2012f1f68381ef84$export$35a6a08064a865b4);

var $58lL3 = parcelRequire("58lL3");

var $3pRoR = parcelRequire("3pRoR");

var $b3cQK = parcelRequire("b3cQK");

var $9Bpzl = parcelRequire("9Bpzl");

var $9fY37 = parcelRequire("9fY37");

var $M3A11 = parcelRequire("M3A11");

var $2mXvz = parcelRequire("2mXvz");

var $gZRC6 = parcelRequire("gZRC6");

var $lvvLW = parcelRequire("lvvLW");
const $2012f1f68381ef84$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $9fY37.gapCursorPluginKey), {
            displayGapCursor: toggle
        });
    };
const $2012f1f68381ef84$var$clearManualSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $lvvLW.selectionPluginKey));
        return tr.setMeta((0, $lvvLW.selectionPluginKey), {
            ...currMeta,
            manualSelection: {}
        });
    };
const $2012f1f68381ef84$var$setManualSelection = (anchor, head)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $lvvLW.selectionPluginKey));
        return tr.setMeta((0, $lvvLW.selectionPluginKey), {
            ...currMeta,
            manualSelection: {
                anchor: anchor,
                head: head
            }
        });
    };
const $2012f1f68381ef84$export$35a6a08064a865b4 = ({ config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $2012f1f68381ef84$var$displayGapCursor,
            clearManualSelection: $2012f1f68381ef84$var$clearManualSelection,
            setManualSelection: $2012f1f68381ef84$var$setManualSelection
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $3pRoR.selectNearNode)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $lvvLW.selectionPluginKey).getState(editorState);
            return {
                selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                selection: pluginState?.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $gZRC6.createPlugin)(dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $M3A11.default)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $b3cQK.default)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $9Bpzl.default)
                },
                {
                    name: 'markBoundaryCursor',
                    plugin: ()=>(0, $2mXvz.createMarkBoundaryCursorPlugin)()
                },
                {
                    name: 'autoExpandSelectionRangeOnInlineNode',
                    plugin: ()=>(0, $58lL3.createAutoExpandSelectionRangeOnInlineNodePlugin)()
                }
            ];
        }
    });
var $2012f1f68381ef84$export$2e2bcd8739ae039 = $2012f1f68381ef84$export$35a6a08064a865b4;

});
parcelRegister("58lL3", function(module, exports) {

$parcel$export(module.exports, "createAutoExpandSelectionRangeOnInlineNodePlugin", () => $c8a43842f23d520f$export$b5faf98028194323);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $hzdhS = parcelRequire("hzdhS");
const $c8a43842f23d520f$export$b5faf98028194323 = ()=>{
    let mouseDownElement = null;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $hzdhS.autoExpandSelectionRangeOnInlineNodePluginKey),
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    mouseDownElement = event.target;
                },
                mouseup: (view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const mouseUpElement = event.target;
                    if ((0, $VSDnB.fg)('platform_editor_lcm_inline_node_selection_fix')) {
                        // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                        // or mouse down doesn't trigger
                        if (!mouseDownElement || mouseDownElement === mouseUpElement) {
                            mouseDownElement = null;
                            return;
                        }
                        // reset mouse down element after mouse up event
                        // so that we can detect the next mouse down event is triggered right after mouse up event or not
                        mouseDownElement = null;
                    } else {
                        // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                        if (mouseDownElement === mouseUpElement) return;
                    }
                    // terminate early if mouse up event is not fired on inline node
                    if (!$c8a43842f23d520f$var$isMouseUpOnSupportedNode(mouseUpElement)) return;
                    const { dispatch: dispatch, state: state } = view;
                    const { selection: selection } = state;
                    // terminate early if current selection is not a text selection -> e.g. table cell selection
                    if (!(selection instanceof (0, $gZGBX.TextSelection))) return;
                    // find the document position of the mouse up element
                    const elementStartPosition = view.posAtDOM(mouseUpElement, 0);
                    // find out the direction of selection
                    const isAnchorBeforeElement = selection.$anchor.pos <= elementStartPosition;
                    const expandedSelectionHeadPosition = isAnchorBeforeElement ? elementStartPosition + 1 : elementStartPosition;
                    // expand the selection to include the mouse up element
                    const tr = state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, selection.$anchor.pos, expandedSelectionHeadPosition));
                    dispatch(tr);
                }
            }
        }
    });
};
const $c8a43842f23d520f$var$isMouseUpOnSupportedNode = (mouseUpElement)=>{
    const supportedNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const supportedNodeViewContentClassNamesList = supportedNodes.map((nodeType)=>`.${nodeType}View-content-wrap`).join(', ');
    return !!mouseUpElement.closest(supportedNodeViewContentClassNamesList);
};

});
parcelRegister("hzdhS", function(module, exports) {

$parcel$export(module.exports, "autoExpandSelectionRangeOnInlineNodePluginKey", () => $0fc886deea4a0a2d$export$e6805678cce429a4);

var $gZGBX = parcelRequire("gZGBX");
const $0fc886deea4a0a2d$export$e6805678cce429a4 = new (0, $gZGBX.PluginKey)('autoExpandSelectionRangeOnInlineNodePlugin');

});


parcelRegister("3pRoR", function(module, exports) {

$parcel$export(module.exports, "selectNearNode", () => $6cfbef85f365de0a$export$c7d22caae2fd3756);
$parcel$export(module.exports, "arrowRight", () => $6cfbef85f365de0a$export$680a8d7c28b0860);
$parcel$export(module.exports, "arrowLeft", () => $6cfbef85f365de0a$export$3ff8c533d254ed7c);
/* eslint-disable import/no-extraneous-dependencies */ 
var $hPjvp = parcelRequire("hPjvp");
var $3jyjs = parcelRequire("3jyjs");
var $6MkyM = parcelRequire("6MkyM");
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");
var $77j9j = parcelRequire("77j9j");

var $gZGBX = parcelRequire("gZGBX");

var $lvvLW = parcelRequire("lvvLW");

var $2qSlm = parcelRequire("2qSlm");

var $8r1CJ = parcelRequire("8r1CJ");

var $igWuw = parcelRequire("igWuw");
const $6cfbef85f365de0a$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $lvvLW.selectionPluginKey), {
            type: (0, $2qSlm.SelectionActionTypes).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $6cfbef85f365de0a$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $8r1CJ.createCommand)({
        type: (0, $2qSlm.SelectionActionTypes).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $6cfbef85f365de0a$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $6cfbef85f365de0a$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return $6cfbef85f365de0a$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.NodeSelection)) return $6cfbef85f365de0a$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.TextSelection)) return $6cfbef85f365de0a$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $6cfbef85f365de0a$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return $6cfbef85f365de0a$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.NodeSelection)) return $6cfbef85f365de0a$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.TextSelection)) return $6cfbef85f365de0a$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $6cfbef85f365de0a$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $hPjvp.Side).LEFT) {
            const selectableNode = (0, $igWuw.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $hPjvp.Side).RIGHT && (0, $igWuw.isSelectionAtEndOfParentNode)($from, selection)) {
            const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (side === (0, $hPjvp.Side).RIGHT) {
            const selectableNode = (0, $igWuw.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $hPjvp.Side).LEFT && (0, $igWuw.isSelectionAtStartOfParentNode)($from, selection)) {
            if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $igWuw.findSelectableContainerBefore)($parent, state.doc);
                    if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $6cfbef85f365de0a$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
                if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $igWuw.isSelectionAtEndOfParentNode)($to, selection) && (node.isInline || (0, $3jyjs.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $6cfbef85f365de0a$var$findAndSetTextSelection((0, $6MkyM.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $6cfbef85f365de0a$var$setSelectionInsideAtNodeStart((0, $6MkyM.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $3jyjs.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).End)) {
            const selectableNode = (0, $igWuw.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $igWuw.isSelectionAtStartOfParentNode)($from, selection) && (node.isInline || (0, $3jyjs.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $6cfbef85f365de0a$var$findAndSetTextSelection((0, $6MkyM.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $6cfbef85f365de0a$export$7c9ae5d21795cde4((0, $6MkyM.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $6cfbef85f365de0a$var$setSelectionInsideAtNodeStart((0, $6MkyM.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $3jyjs.isIgnored)(node) && selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $igWuw.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $igWuw.isSelectionAtEndOfParentNode)(selection.$to, selection)) {
            const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Before) {
            const selectableNode = (0, $igWuw.findSelectableContainerBefore)(selection.$from, state.doc);
            if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $6cfbef85f365de0a$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $igWuw.isSelectionAtStartOfParentNode)(selection.$from, selection)) {
            const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $gZGBX.Selection).findFrom($pos, dir, true);
        if (sel) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $6cfbef85f365de0a$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $77j9j.isNodeEmpty)(node)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
        const selectableNode = (0, $igWuw.findFirstChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $3jyjs.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
            else if ((0, $594Yf.isEmptyParagraph)(childNode)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
            else if (!(0, $3jyjs.isIgnored)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $hPjvp.Side).LEFT))(state, dispatch);
            else if ((0, $igWuw.isSelectableContainerNode)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $gZGBX.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $77j9j.isNodeEmpty)(node)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
        const selectableNode = (0, $igWuw.findLastChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $3jyjs.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
            else if ((0, $594Yf.isEmptyParagraph)(childNode)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
            else if (!(0, $3jyjs.isIgnored)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $hPjvp.Side).RIGHT))(state, dispatch);
            else if ((0, $igWuw.isSelectableContainerNode)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $gZGBX.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };

});
parcelRegister("lvvLW", function(module, exports) {

$parcel$export(module.exports, "selectionPluginKey", () => $53ae5ee309f6f53a$export$e530ba00b008a680);
$parcel$export(module.exports, "SelectionDirection", () => $53ae5ee309f6f53a$export$5c80dd1df5708938);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json


var $gZGBX = parcelRequire("gZGBX");
const $53ae5ee309f6f53a$export$e530ba00b008a680 = new (0, $gZGBX.PluginKey)('selection');
var $53ae5ee309f6f53a$export$5c80dd1df5708938 = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
    return SelectionDirection;
}({});

});

parcelRegister("2qSlm", function(module, exports) {

$parcel$export(module.exports, "SelectionActionTypes", () => $8aff6390c25c493c$export$ab4e2275d2998c63);
var $8aff6390c25c493c$export$ab4e2275d2998c63 = /*#__PURE__*/ function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    return SelectionActionTypes;
}({});

});

parcelRegister("8r1CJ", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $6203900090a6a225$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $6203900090a6a225$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $6203900090a6a225$export$656c7661095efe2e);

var $aOimD = parcelRequire("aOimD");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");

var $lvvLW = parcelRequire("lvvLW");

var $b8hnO = parcelRequire("b8hnO");

var $igWuw = parcelRequire("igWuw");
const $6203900090a6a225$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $igWuw.getDecorations)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $etG8M.DecorationSet).empty
        };
    }
};
const $6203900090a6a225$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $gZGBX.NodeSelection) && (0, $igWuw.isSelectableContainerNode)(tr.selection.node) || tr.selection instanceof (0, $hFEwm.CellSelection)) && !tr.getMeta((0, $lvvLW.selectionPluginKey))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const { createCommand: $6203900090a6a225$export$8d4021544bdece00, getPluginState: $6203900090a6a225$export$f05434c51e3762e, createPluginState: $6203900090a6a225$export$656c7661095efe2e } = (0, $aOimD.pluginFactory)((0, $lvvLW.selectionPluginKey), (0, $b8hnO.reducer), {
    onDocChanged: $6203900090a6a225$var$handleDocChanged,
    onSelectionChanged: $6203900090a6a225$var$handleSelectionChanged
});

});
parcelRegister("b8hnO", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $3f5779eb4402a550$export$1650419e431d3ba3);

var $2qSlm = parcelRequire("2qSlm");
function $3f5779eb4402a550$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $2qSlm.SelectionActionTypes).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $2qSlm.SelectionActionTypes).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}

});

parcelRegister("igWuw", function(module, exports) {

$parcel$export(module.exports, "getDecorations", () => $ef3f0c960be97cae$export$968abecb43309c32);
$parcel$export(module.exports, "shouldRecalcDecorations", () => $ef3f0c960be97cae$export$8f1ae47b39045ce2);
$parcel$export(module.exports, "isSelectableContainerNode", () => $ef3f0c960be97cae$export$be9646888fa9d884);
$parcel$export(module.exports, "findSelectableContainerParent", () => $ef3f0c960be97cae$export$15e7624ccd1acbba);
$parcel$export(module.exports, "findSelectableContainerBefore", () => $ef3f0c960be97cae$export$5a13616ef7dc6dd);
$parcel$export(module.exports, "findSelectableContainerAfter", () => $ef3f0c960be97cae$export$f64170c1c72ca928);
$parcel$export(module.exports, "findFirstChildNodeToSelect", () => $ef3f0c960be97cae$export$12f3aca2cb5b5ae9);
$parcel$export(module.exports, "findLastChildNodeToSelect", () => $ef3f0c960be97cae$export$b5a7c30cdb2d437f);
$parcel$export(module.exports, "isSelectionAtStartOfParentNode", () => $ef3f0c960be97cae$export$f80a5aec143de6c6);
$parcel$export(module.exports, "isSelectionAtEndOfParentNode", () => $ef3f0c960be97cae$export$1ab0c837d3abb951);

var $3jyjs = parcelRequire("3jyjs");
var $k6Y9i = parcelRequire("k6Y9i");
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $iHYdz = parcelRequire("iHYdz");

var $lvvLW = parcelRequire("lvvLW");
const $ef3f0c960be97cae$export$968abecb43309c32 = (tr, manualSelection)=>{
    let selection = tr.selection;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return (0, $etG8M.DecorationSet).create(tr.doc, [
        (0, $etG8M.Decoration).node(selection.from, selection.to, {
            class: (0, $iHYdz.akEditorSelectedNodeClassName)
        })
    ]);
    if (selection instanceof (0, $gZGBX.TextSelection) || selection instanceof (0, $gZGBX.AllSelection)) {
        if (manualSelection && manualSelection.anchor >= 0 && manualSelection.head >= 0 && manualSelection.anchor <= tr.doc.nodeSize && manualSelection.head <= tr.doc.nodeSize) selection = (0, $gZGBX.TextSelection).create(tr.doc, manualSelection.anchor, manualSelection.head);
        const decorations = $ef3f0c960be97cae$export$299033b282ee8671(selection, tr.doc).map(({ node: node, pos: pos })=>{
            return (0, $etG8M.Decoration).node(pos, pos + node.nodeSize, {
                class: (0, $iHYdz.akEditorSelectedNodeClassName)
            });
        });
        return (0, $etG8M.DecorationSet).create(tr.doc, decorations);
    }
    return (0, $etG8M.DecorationSet).empty;
};
const $ef3f0c960be97cae$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $ef3f0c960be97cae$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const isTopLevelNodeThatHasSelectionStyles = $ef3f0c960be97cae$var$topLevelBlockNodesThatHaveSelectionStyles.includes(node.type.name);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $ef3f0c960be97cae$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $lvvLW.selectionPluginKey).getState(oldEditorState);
    const newPluginState = (0, $lvvLW.selectionPluginKey).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $gZGBX.NodeSelection) && newSelection instanceof (0, $gZGBX.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $gZGBX.TextSelection) && newSelection instanceof (0, $gZGBX.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $ef3f0c960be97cae$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $gZGBX.NodeSelection).isSelectable(node));
const $ef3f0c960be97cae$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $594Yf.isEmptyParagraph)(node) || (0, $gZGBX.NodeSelection).isSelectable(node)));
const $ef3f0c960be97cae$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $5r0mK.findParentNode)((node)=>{
        const isSelectable = $ef3f0c960be97cae$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $3jyjs.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $ef3f0c960be97cae$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $ef3f0c960be97cae$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $gZGBX.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($ef3f0c960be97cae$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $3jyjs.isIgnored)(node)) return;
        }
        /**
		 * Stick to the default left selection behaviour,
		 * useful for mediaSingleWithCaption
		 */ if (selectionBefore instanceof (0, $gZGBX.NodeSelection) && (0, $gZGBX.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $ef3f0c960be97cae$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $gZGBX.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($ef3f0c960be97cae$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $3jyjs.isIgnored)(node)) return;
        }
    }
};
const $ef3f0c960be97cae$export$12f3aca2cb5b5ae9 = (parent)=>(0, $5r0mK.flatten)(parent).find((child)=>$ef3f0c960be97cae$export$e6eb31f83412b327(child.node) || !(0, $3jyjs.isIgnored)(child.node));
const $ef3f0c960be97cae$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($ef3f0c960be97cae$export$e6eb31f83412b327(node) || !(0, $3jyjs.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $ef3f0c960be97cae$export$f80a5aec143de6c6 = ($pos, selection)=>(0, $k6Y9i.isSelectionAtStartOfNode)($pos, $ef3f0c960be97cae$export$15e7624ccd1acbba(selection)?.node);
const $ef3f0c960be97cae$export$1ab0c837d3abb951 = ($pos, selection)=>{
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    if ($pos.depth === 0 || (0, $gZGBX.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};

});



parcelRegister("b3cQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3c042b0e4d7383$export$2e2bcd8739ae039);

var $e9qoo = parcelRequire("e9qoo");

var $hPjvp = parcelRequire("hPjvp");

var $2RHbH = parcelRequire("2RHbH");

var $vWFRY = parcelRequire("vWFRY");

var $ltL9w = parcelRequire("ltL9w");

var $7XWv7 = parcelRequire("7XWv7");
function $1c3c042b0e4d7383$export$2e2bcd8739ae039() {
    const map = {};
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $hPjvp.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $2RHbH.createParagraphNear)(state, dispatch);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.backspace).common, (0, $ltL9w.deleteNode)((0, $7XWv7.Direction).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.deleteKey).common, (0, $ltL9w.deleteNode)((0, $7XWv7.Direction).FORWARD), map);
    return (0, $vWFRY.keymap)(map);
}

});
parcelRegister("ltL9w", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $060fb358ebbf8cd3$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "deleteNode", () => $060fb358ebbf8cd3$export$b05da9e94a08038f);

var $k6Y9i = parcelRequire("k6Y9i");
var $hPjvp = parcelRequire("hPjvp");
var $2xQXF = parcelRequire("2xQXF");

var $20Kbb = parcelRequire("20Kbb");
var $5or39 = parcelRequire("5or39");


var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $9fY37 = parcelRequire("9fY37");

var $7XWv7 = parcelRequire("7XWv7");

var $9z6CR = parcelRequire("9z6CR");
const $060fb358ebbf8cd3$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $7XWv7.Direction).UP:
            if ((0, $k6Y9i.atTheBeginningOfDoc)(state)) return false;
            return (0, $5or39.isPositionNearTableRow)($pos, schema, 'before') || (0, $9z6CR.isTextBlockNearPos)(doc, schema, $pos, -1) || (0, $20Kbb.isNodeBeforeMediaNode)($pos, state);
        case (0, $7XWv7.Direction).DOWN:
            return(// end of a paragraph
            (0, $k6Y9i.atTheEndOfDoc)(state) || (0, $9z6CR.isTextBlockNearPos)(doc, schema, $pos, 1) || (0, $5or39.isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter);
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $060fb358ebbf8cd3$var$shouldHandleMediaGapCursor(dir, state) {
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $hPjvp.GapCursorSelection) && dir === (0, $7XWv7.Direction).UP && selection.$from.nodeBefore && (0, $20Kbb.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $hPjvp.GapCursorSelection) && dir === (0, $7XWv7.Direction).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $060fb358ebbf8cd3$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    const $pos = (0, $7XWv7.isBackward)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $7XWv7.Direction).UP && selection.$from.nodeBefore && (0, $20Kbb.isMediaNode)(selection.$from.nodeBefore)) {
        const nodeBeforePos = (0, $5r0mK.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $hPjvp.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $hPjvp.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $7XWv7.Direction).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $hPjvp.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $hPjvp.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $060fb358ebbf8cd3$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $7XWv7.isBackward)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $gZGBX.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($060fb358ebbf8cd3$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $7XWv7.isBackward)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $gZGBX.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $7XWv7.Direction).UP && !(0, $k6Y9i.atTheBeginningOfDoc)(state) && !(0, $20Kbb.isNodeBeforeMediaNode)($pos, state) || dir === (0, $7XWv7.Direction).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($060fb358ebbf8cd3$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $060fb358ebbf8cd3$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $hPjvp.GapCursorSelection) && // next node allow gap cursor position
        (0, $2xQXF.isValidTargetNode)((0, $7XWv7.isBackward)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $7XWv7.isBackward)(dir) && selection.side === (0, $hPjvp.Side).LEFT || (0, $7XWv7.isForward)(dir) && selection.side === (0, $hPjvp.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, selection.side === (0, $hPjvp.Side).RIGHT ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = (0, $5r0mK.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)) return false;
        }
        const nextSelection = (0, $hPjvp.GapCursorSelection).findFrom($pos, (0, $7XWv7.isBackward)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $2xQXF.isValidTargetNode)((0, $7XWv7.isForward)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $hPjvp.GapCursorSelection)(nextSelection.$from, (0, $7XWv7.isForward)(dir) ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $060fb358ebbf8cd3$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $hPjvp.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $7XWv7.isBackward)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $hPjvp.GapCursorSelection)($anchor, (0, $hPjvp.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $5r0mK.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $060fb358ebbf8cd3$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $hPjvp.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT;
            let position;
            if (side === (0, $hPjvp.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $060fb358ebbf8cd3$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $060fb358ebbf8cd3$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $hPjvp.Side).LEFT ? (0, $2xQXF.isValidTargetNode)($pos.nodeAfter) : (0, $2xQXF.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $hPjvp.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $hPjvp.GapCursorSelection)) tr.setSelection((0, $gZGBX.Selection).near($pos));
        else tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $gZGBX.Selection).findFrom($pos, cursorCoords.side === (0, $hPjvp.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $060fb358ebbf8cd3$export$ddeed8e54d88a7b0 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $060fb358ebbf8cd3$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $060fb358ebbf8cd3$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $9fY37.gapCursorPluginKey).get(state));
};

});
parcelRegister("9fY37", function(module, exports) {

$parcel$export(module.exports, "gapCursorPluginKey", () => $a24c46096a74b6ea$export$21af267ac39e2110);

var $gZGBX = parcelRequire("gZGBX");
const $a24c46096a74b6ea$export$21af267ac39e2110 = new (0, $gZGBX.PluginKey)('gapCursorPlugin');

});

parcelRegister("7XWv7", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $235b6e0569825149$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "isBackward", () => $235b6e0569825149$export$4d894a9a195acd59);
$parcel$export(module.exports, "isForward", () => $235b6e0569825149$export$9439bc4ba99faca1);
var $235b6e0569825149$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
    return Direction;
}({});
function $235b6e0569825149$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $235b6e0569825149$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}

});

parcelRegister("9z6CR", function(module, exports) {

$parcel$export(module.exports, "isLeftCursor", () => $bf065ce7cc738c9f$export$2b745dec73894c8a);
$parcel$export(module.exports, "isTextBlockNearPos", () => $bf065ce7cc738c9f$export$84353379d6171bb9);
$parcel$export(module.exports, "getLayoutModeFromTargetNode", () => $bf065ce7cc738c9f$export$698eab35981fecbc);
$parcel$export(module.exports, "isIgnoredClick", () => $bf065ce7cc738c9f$export$e5da7366668fb130);
$parcel$export(module.exports, "getComputedStyleForLayoutMode", () => $bf065ce7cc738c9f$export$b5b7287d8577df27);

var $intz5 = parcelRequire("intz5");

var $hPjvp = parcelRequire("hPjvp");

var $6gEe5 = parcelRequire("6gEe5");
var $ahG4O = parcelRequire("ahG4O");

var $gmhCD = parcelRequire("gmhCD");
const $bf065ce7cc738c9f$export$2b745dec73894c8a = (side)=>side === (0, $hPjvp.Side).LEFT;
function $bf065ce7cc738c9f$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $bf065ce7cc738c9f$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $bf065ce7cc738c9f$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $bf065ce7cc738c9f$export$e5da7366668fb130 = (elem)=>{
    if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem?.closest(`[data-id="${(0, $intz5.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem?.closest(`.${(0, $ahG4O.UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $bf065ce7cc738c9f$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    if ((0, $gmhCD.editorExperiment)('advanced_layouts', true) && node && node.type.name === 'layoutSection') {
        const layoutSectionContainer = dom.querySelector('.layout-section-container');
        if (layoutSectionContainer) return window.getComputedStyle(layoutSectionContainer);
    }
    return style;
};

});



parcelRegister("9Bpzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b07c7e10d06e629$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $hPjvp = parcelRequire("hPjvp");
var $eAVGd = parcelRequire("eAVGd");
var $5Vvw4 = parcelRequire("5Vvw4");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");

var $9fY37 = parcelRequire("9fY37");

var $ltL9w = parcelRequire("ltL9w");

var $7XWv7 = parcelRequire("7XWv7");

var $9z6CR = parcelRequire("9z6CR");

var $kb0gW = parcelRequire("kb0gW");
const $9b07c7e10d06e629$var$plugin = new (0, $5KWxh.SafePlugin)({
    key: (0, $9fY37.gapCursorPluginKey),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $9fY37.gapCursorPluginKey));
            const selectionIsGapCursor = newState.selection instanceof (0, $hPjvp.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true
            };
        }
    },
    view: (view)=>{
        /**
		 * If the selection is at the beginning of a document and is a NodeSelection,
		 * convert to a GapCursor selection. This is to stop users accidentally replacing
		 * the first node of a document by accident.
		 */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $gZGBX.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)(view.state.doc.resolve(0), (0, $hPjvp.Side).LEFT)));
        });
        return {
            update (view) {
                const { selectionIsGapCursor: selectionIsGapCursor } = (0, $9fY37.gapCursorPluginKey).getState(view.state);
                /**
				 * Starting with prosemirror-view 1.19.4, cursor wrapper that previously was hiding cursor doesn't exist:
				 * https://github.com/ProseMirror/prosemirror-view/commit/4a56bc7b7e61e96ef879d1dae1014ede0fc09e43
				 *
				 * Because it was causing issues with RTL: https://github.com/ProseMirror/prosemirror/issues/948
				 *
				 * This is the work around which uses `caret-color: transparent` in order to hide regular caret,
				 * when gap cursor is visible.
				 *
				 * Browser support is pretty good: https://caniuse.com/#feat=css-caret-color
				 */ view.dom.classList.toggle((0, $eAVGd.hideCaretModifier), selectionIsGapCursor);
            }
        };
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor } = (0, $9fY37.gapCursorPluginKey).getState(editorState);
            if (selection instanceof (0, $hPjvp.GapCursorSelection) && displayGapCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $hPjvp.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $5r0mK.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $9z6CR.getLayoutModeFromTargetNode)(node);
                return (0, $etG8M.DecorationSet).create(doc, [
                    (0, $etG8M.Decoration).widget(position, (0, $kb0gW.toDOM), {
                        key: `${(0, $hPjvp.JSON_ID)}-${side}-${layoutMode}`,
                        side: layoutMode ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $hFEwm.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $hPjvp.GapCursorSelection).valid($head)) return new (0, $hPjvp.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $9z6CR.isIgnoredClick)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $hPjvp.Side).RIGHT : (0, $hPjvp.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if ($pos.parent?.type.name === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $5Vvw4.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside?.isAtom) return false;
            return (0, $5Vvw4.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
			 * Android composition events aren't handled well by Prosemirror
			 * We've added a couple of beforeinput hooks to help PM out when trying to delete
			 * certain nodes. We can remove these when PM has better composition support.
			 * @see https://github.com/ProseMirror/prosemirror/issues/543
			 */ // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $hPjvp.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $ltL9w.deleteNode)((0, $7XWv7.Direction).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $9b07c7e10d06e629$export$2e2bcd8739ae039 = $9b07c7e10d06e629$var$plugin;

});
parcelRegister("kb0gW", function(module, exports) {

$parcel$export(module.exports, "toDOM", () => $529499ca6d3660be$export$289411c5a7970646);

var $hPjvp = parcelRequire("hPjvp");

var $VSDnB = parcelRequire("VSDnB");

var $9z6CR = parcelRequire("9z6CR");
/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $529499ca6d3660be$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $529499ca6d3660be$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($529499ca6d3660be$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $529499ca6d3660be$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $529499ca6d3660be$var$measureHeight = (style)=>{
    return $529499ca6d3660be$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $529499ca6d3660be$var$measureWidth = (style)=>{
    return $529499ca6d3660be$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $529499ca6d3660be$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $529499ca6d3660be$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $9z6CR.isLeftCursor)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
const $529499ca6d3660be$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $hPjvp.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const nodeStart = getPos();
    // @ts-ignore - [unblock prosemirror bump] nodeStart can be undefined
    const dom = view.nodeDOM(nodeStart);
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (dom instanceof HTMLElement && element.firstChild) {
        const style = $529499ca6d3660be$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
        const gapCursor = element.firstChild;
        gapCursor.style.height = `${$529499ca6d3660be$var$measureHeight(style)}px`;
        const layoutMode = node && (0, $9z6CR.getLayoutModeFromTargetNode)(node);
        if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
        // Tables nested inside other elements such as layouts, expands and other tables do not have fixed width
        const isNestedTable = (0, $VSDnB.fg)('platform_editor_nested_tables_gap_cursor') ? node?.type.name === 'table' && selection.$to.depth > 0 : false;
        if (layoutMode && !isNestedTable) {
            gapCursor.setAttribute('layout', layoutMode);
            const breakoutModeStyle = (0, $9z6CR.getComputedStyleForLayoutMode)(dom, node, style);
            gapCursor.style.width = `${$529499ca6d3660be$var$measureWidth(breakoutModeStyle)}px`;
        } else $529499ca6d3660be$var$mutateElementStyle(gapCursor, style, selection.side);
    }
    return element;
};

});


parcelRegister("M3A11", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f270e126345bfd$export$2e2bcd8739ae039);

var $e9qoo = parcelRequire("e9qoo");

var $vWFRY = parcelRequire("vWFRY");

var $3pRoR = parcelRequire("3pRoR");
function $b4f270e126345bfd$var$keymapPlugin() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveRight).common, (0, $3pRoR.arrowRight), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveLeft).common, (0, $3pRoR.arrowLeft), list);
    return (0, $vWFRY.keymap)(list);
}
var $b4f270e126345bfd$export$2e2bcd8739ae039 = $b4f270e126345bfd$var$keymapPlugin;

});

parcelRegister("2mXvz", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorPlugin", () => $d5a435a6cf57495c$export$d3a8cfe12ba42d22);

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");

var $aqqth = parcelRequire("aqqth");

var $cXbKW = parcelRequire("cXbKW");

var $4YNMu = parcelRequire("4YNMu");
const $d5a435a6cf57495c$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $aqqth.markBoundaryCursorPluginKey),
        state: {
            init: ()=>({
                    decorations: (0, $etG8M.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $4YNMu.getActiveMarksSide)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $etG8M.DecorationSet).empty
                };
                return {
                    decorations: (0, $etG8M.DecorationSet).create(doc, [
                        (0, $cXbKW.createMarkBoundaryCursorDecoration)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $aqqth.markBoundaryCursorPluginKey).getState(state)?.decorations;
            }
        }
    });
};

});
parcelRegister("aqqth", function(module, exports) {

$parcel$export(module.exports, "markBoundaryCursorPluginKey", () => $ad9527801014bc00$export$220fecd6a5c51ffb);

var $gZGBX = parcelRequire("gZGBX");
const $ad9527801014bc00$export$220fecd6a5c51ffb = new (0, $gZGBX.PluginKey)('markBoundaryCursorPlugin');

});

parcelRegister("cXbKW", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorDecoration", () => $82ddb9c86885e1fb$export$499e8e2917534a4d);

var $etG8M = parcelRequire("etG8M");
const $82ddb9c86885e1fb$var$containerStyle = `
	position: relative;
`;
const $82ddb9c86885e1fb$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #172B4D)"};
`;
const $82ddb9c86885e1fb$var$toDOM = ()=>{
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $82ddb9c86885e1fb$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $82ddb9c86885e1fb$var$caretStyle);
    caret.animate?.([
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $82ddb9c86885e1fb$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $etG8M.Decoration).widget(pos, $82ddb9c86885e1fb$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};

});

parcelRegister("4YNMu", function(module, exports) {

$parcel$export(module.exports, "getActiveMarksSide", () => $c802ebf86e549a45$export$8f6a177d567e1134);

var $594Yf = parcelRequire("594Yf");

var $kCV8T = parcelRequire("kCV8T");

var $7WjpF = parcelRequire("7WjpF");

var $7EuDu = parcelRequire("7EuDu");
function $c802ebf86e549a45$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $594Yf.isTextSelection)(selection) || !selection.empty) return (0, $7WjpF.MarksSide).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = nodeBefore?.marks ?? [];
    const rightMarks = nodeAfter?.marks ?? [];
    if ((0, $kCV8T.Mark).sameSet(leftMarks, rightMarks)) return (0, $7WjpF.MarksSide).None;
    return (0, $7EuDu.getInlineCodeCursorSide)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}

});
parcelRegister("7WjpF", function(module, exports) {

$parcel$export(module.exports, "MarksSide", () => $f16196199ce0e6d7$export$6705e1762430d43f);
var $f16196199ce0e6d7$export$6705e1762430d43f = /*#__PURE__*/ function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
    return MarksSide;
}({});

});

parcelRegister("7EuDu", function(module, exports) {

$parcel$export(module.exports, "getInlineCodeCursorSide", () => $b24a8fd0105c6c7f$export$325621c34246ee7d);

var $7WjpF = parcelRequire("7WjpF");
function $b24a8fd0105c6c7f$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $7WjpF.MarksSide).Right;
    return (0, $7WjpF.MarksSide).None;
}

});



parcelRegister("gZRC6", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0ac64cffabc4b968$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $gmhCD = parcelRequire("gmhCD");

var $lvvLW = parcelRequire("lvvLW");

var $2qSlm = parcelRequire("2qSlm");

var $kqfPI = parcelRequire("kqfPI");

var $3z3LP = parcelRequire("3z3LP");

var $DmeyI = parcelRequire("DmeyI");

var $8r1CJ = parcelRequire("8r1CJ");

var $igWuw = parcelRequire("igWuw");
const $0ac64cffabc4b968$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $igWuw.getDecorations)(state.tr),
        selection: state.selection
    });
const $0ac64cffabc4b968$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, options = {})=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $lvvLW.selectionPluginKey),
        state: (0, $8r1CJ.createPluginState)(dispatch, $0ac64cffabc4b968$export$53ac33307b5acee9),
        appendTransaction (transactions, oldEditorState, newEditorState) {
            const { tr: tr } = newEditorState;
            let manualSelection;
            if ((0, $gmhCD.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) // Start at most recent transaction, look for manualSelection meta
            for(let i = transactions.length - 1; i >= 0; i--){
                manualSelection = transactions[i].getMeta((0, $lvvLW.selectionPluginKey))?.manualSelection;
                if (manualSelection) break;
            }
            if (!(0, $igWuw.shouldRecalcDecorations)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            }) && !manualSelection) return;
            tr.setMeta((0, $lvvLW.selectionPluginKey), {
                type: (0, $2qSlm.SelectionActionTypes).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $igWuw.getDecorations)(tr, manualSelection)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $gZGBX.NodeSelection) && !tr.getMeta((0, $lvvLW.selectionPluginKey))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $gZGBX.NodeSelection) && tr.selection instanceof (0, $gZGBX.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $kqfPI.onCreateSelectionBetween),
            decorations (state) {
                return (0, $8r1CJ.getPluginState)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $3z3LP.createOnKeydown)({
                    __livePage: options.__livePage
                }),
                // Without this event, it is not possible to click and drag to select the first node in the
                // document if the node is a block with content (e.g. a panel with a paragraph inside).
                mouseout: (0, $DmeyI.onMouseOut)
            }
        }
    });
};

});
parcelRegister("kqfPI", function(module, exports) {

$parcel$export(module.exports, "onCreateSelectionBetween", () => $1b9e3681e85a9d75$export$ba3a236bf89a370d);

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
const $1b9e3681e85a9d75$var$DOC_START_POS = 0;
function $1b9e3681e85a9d75$var$isNodeContentEmpty(maybeNode) {
    return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
}
function $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($1b9e3681e85a9d75$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $1b9e3681e85a9d75$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $1b9e3681e85a9d75$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $1b9e3681e85a9d75$var$isNodeContentEmpty(maybeNode) && (0, $gZGBX.NodeSelection).isSelectable(maybeNode);
};
function $1b9e3681e85a9d75$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    if ((0, $VSDnB.fg)('platform_editor_fix_drag_and_drop_lists')) {
        // prosemirror calls 'createSelectionBetween' for native 'drop' events, it passes $anchor
        // and $head which are based on a transformed document, but only provides the original
        // doc. Need to remap the $head pos to last element in doc to avoid RangeErrors.
        if ($targetHead.pos >= doc.nodeSize) maybeNode = doc.resolve(doc.nodeSize - 2).nodeBefore;
        else if ($targetHead.pos !== $1b9e3681e85a9d75$var$DOC_START_POS) {
            const justBeforeHeadPos = $targetHead.pos - 1;
            const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
            maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
        }
    } else if ($targetHead.pos !== $1b9e3681e85a9d75$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $1b9e3681e85a9d75$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ($head.parent?.isTextblock && !$1b9e3681e85a9d75$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $1b9e3681e85a9d75$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $gZGBX.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};

});

parcelRegister("3z3LP", function(module, exports) {

$parcel$export(module.exports, "createOnKeydown", () => $e5c6bd60f2ded2f2$export$1bff6ff05fed49a5);

var $2Hal9 = parcelRequire("2Hal9");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $e5c6bd60f2ded2f2$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $VSDnB.fg)('platform-editor-single-player-expand')) currentExpandedState = node ? !(0, $2Hal9.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node?.attrs.__expanded;
    else currentExpandedState = !node?.attrs.__expanded;
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $e5c6bd60f2ded2f2$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $e5c6bd60f2ded2f2$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $e5c6bd60f2ded2f2$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $e5c6bd60f2ded2f2$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $e5c6bd60f2ded2f2$var$isBodiedExtension(node) || $e5c6bd60f2ded2f2$var$isTable(node);
};
const $e5c6bd60f2ded2f2$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $e5c6bd60f2ded2f2$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $e5c6bd60f2ded2f2$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $e5c6bd60f2ded2f2$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $e5c6bd60f2ded2f2$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    if (event.shiftKey || event.metaKey) return false;
    const selection = view.state?.selection;
    if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
    return isNavigatingInlineNodeDownward;
};
function $e5c6bd60f2ded2f2$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
		 * This workaround is needed for some specific situations.
		 * - expand collapse
		 * - bodied extension
		 */ if (!(event instanceof KeyboardEvent)) return false;
        // Override the default behaviour to make sure that the selection always extends to
        // the start of the document and not just the first inline position.
        if (event.shiftKey && event.metaKey && event.key === 'ArrowUp') {
            const selection = (0, $gZGBX.TextSelection).create(view.state.doc, view.state.selection.$anchor.pos, 0);
            view.dispatch(view.state.tr.setSelection(selection));
            event.preventDefault();
            return true;
        }
        if ($e5c6bd60f2ded2f2$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($e5c6bd60f2ded2f2$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $e5c6bd60f2ded2f2$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $gZGBX.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}

});
parcelRegister("2Hal9", function(module, exports) {

$parcel$export(module.exports, "expandedState", () => $f0f36d6481cf8dea$export$de2a5eca4f1cacc0);
$parcel$export(module.exports, "isExpandCollapsed", () => $f0f36d6481cf8dea$export$785b8bfd794fa7b6);
const $f0f36d6481cf8dea$export$de2a5eca4f1cacc0 = new WeakMap();
const $f0f36d6481cf8dea$export$785b8bfd794fa7b6 = (node)=>{
    return !$f0f36d6481cf8dea$export$de2a5eca4f1cacc0.get(node) ?? false;
};

});


parcelRegister("DmeyI", function(module, exports) {

$parcel$export(module.exports, "onMouseOut", () => $53286a2ef9e4b5c6$export$65a11040da641544);

var $gZGBX = parcelRequire("gZGBX");
function $53286a2ef9e4b5c6$export$53f3d8e656ab0334(selection) {
    if (selection.empty) return false;
    const { $anchor: $anchor, $head: $head } = selection;
    // Head must be at the start of its parent node's content
    if ($head.parentOffset !== 0) return false;
    // Head must be nested (e.g., in a panel > paragraph, not directly in doc)
    if ($head.depth <= 1) return false;
    // Head must be in the first top-level block (before depth 1 is 0)
    if ($head.before(1) !== 0) return false;
    // Selection must not span within a shared deeper structure
    if ($head.sharedDepth($anchor.pos) !== 0) return false;
    // Head must be in the first block at every level
    let isFirstBlockInTree = true;
    for(let i = $head.depth - 1; i >= 0; i--)if ($head.index(i) !== 0) {
        isFirstBlockInTree = false;
        break;
    }
    if (!isFirstBlockInTree) return false;
    return true;
}
function $53286a2ef9e4b5c6$export$65a11040da641544(view, event) {
    // Only trigger during a mouse drag
    if (event.buttons === 0) return false;
    if (view.state.selection instanceof (0, $gZGBX.TextSelection) && $53286a2ef9e4b5c6$export$53f3d8e656ab0334(view.state.selection)) {
        // Set selection with head at document start (position 0)
        const selection = new (0, $gZGBX.TextSelection)(view.state.doc.resolve(view.state.selection.$anchor.pos), view.state.doc.resolve(0));
        view.dispatch(view.state.tr.setSelection(selection));
        return true;
    }
    return false;
}

});




parcelRegister("gXAdO", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => (parcelRequire("cKx1R")).typeAheadPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cKx1R = parcelRequire("cKx1R");

});
parcelRegister("cKx1R", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => $614ad81eb16a153a$export$a023c922ef32b883);
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dtyqo = parcelRequire("dtyqo");

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $3UtTx = parcelRequire("3UtTx");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $5Vwh8 = parcelRequire("5Vwh8");

var $eF1Qh = parcelRequire("eF1Qh");

var $ctcYc = parcelRequire("ctcYc");

var $8oJYH = parcelRequire("8oJYH");

var $ldgDZ = parcelRequire("ldgDZ");

var $b6IDf = parcelRequire("b6IDf");

var $2RUDH = parcelRequire("2RUDH");

var $2D6mf = parcelRequire("2D6mf");

var $iiwBk = parcelRequire("iiwBk");

var $hgbc1 = parcelRequire("hgbc1");
const $614ad81eb16a153a$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
            (0, $ctcYc.openTypeAheadAtCursor)({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            })({
                tr: tr
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).INVOKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: triggerHandler.id,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            })(tr);
            return true;
        };
const $614ad81eb16a153a$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $614ad81eb16a153a$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $614ad81eb16a153a$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $eF1Qh.insertTypeAheadItem)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $3UtTx.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $614ad81eb16a153a$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $iiwBk.findHandler)(trigger, view.state);
    };
const $614ad81eb16a153a$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $iiwBk.getTypeAheadQuery)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $5Vwh8.closeTypeAhead)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $iiwBk.getTypeAheadHandler)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $614ad81eb16a153a$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $dtyqo.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $2RUDH.createPlugin)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $5KWxh.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $ldgDZ.createPlugin)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $8oJYH.inputRulePlugin)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $etG8M.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $iiwBk.isTypeAheadOpen)(editorState);
            const state = (0, $iiwBk.getPluginState)(editorState);
            return {
                query: (0, $iiwBk.getTypeAheadQuery)(editorState) || '',
                currentHandler: (0, $iiwBk.getTypeAheadHandler)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $etG8M.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                errorInfo: state?.errorInfo ?? null,
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $iiwBk.isTypeAheadOpen),
            isAllowed: (0, $iiwBk.isTypeAheadAllowed),
            open: $614ad81eb16a153a$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
            openAtTransaction: $614ad81eb16a153a$var$createOpenAtTransaction(api?.analytics?.actions),
            findHandlerByTrigger: $614ad81eb16a153a$var$createFindHandlerByTrigger(editorViewRef),
            insert: $614ad81eb16a153a$var$createInsertTypeAheadItem(editorViewRef),
            close: $614ad81eb16a153a$var$createCloseTypeAhead(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hgbc1.ContentComponent), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $iiwBk.getPluginState)(oldEditorState);
            const newPluginState = (0, $iiwBk.getPluginState)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $b6IDf.pluginKey));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $2D6mf.StatsModifier)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) {
                if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                });
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $iiwBk.isTypeAheadOpen)(oldEditorState);
            const newIsOpen = (0, $iiwBk.isTypeAheadOpen)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $gkwXh.INPUT_METHOD).QUICK_INSERT && Object.values((0, $3UtTx.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).INVOKED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
                    actionSubjectId: newTriggerHandler.id || 'not_set',
                    attributes: {
                        inputMethod: newPluginState.inputMethod || (0, $gkwXh.INPUT_METHOD).KEYBOARD
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
            } else if (oldIsOpen && !newIsOpen && (0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        }
    };
};

});
parcelRegister("5Vwh8", function(module, exports) {

$parcel$export(module.exports, "closeTypeAhead", () => $0d2dd1000e07b5a6$export$daba40574d0568e3);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $0d2dd1000e07b5a6$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $b6IDf.pluginKey), {
        action: (0, $7eFnB.ACTIONS).CLOSE_TYPE_AHEAD
    });
};

});
parcelRegister("7eFnB", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $d12f7dcf5833e13e$export$92a1a3b7554e9387);
var $d12f7dcf5833e13e$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    return ACTIONS;
}({});

});

parcelRegister("b6IDf", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $f2e6ba5f517d8a79$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $f2e6ba5f517d8a79$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('typeAheadPlugin');

});


parcelRegister("eF1Qh", function(module, exports) {

$parcel$export(module.exports, "insertTypeAheadItem", () => $ea5e5e0c4f528fae$export$173ade35125a6637);

var $ez3YZ = parcelRequire("ez3YZ");

var $3UtTx = parcelRequire("3UtTx");

var $fZzhT = parcelRequire("fZzhT");

var $kCV8T = parcelRequire("kCV8T");

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");

var $2D6mf = parcelRequire("2D6mf");

var $iiwBk = parcelRequire("iiwBk");

var $5Vwh8 = parcelRequire("5Vwh8");

var $b3yfA = parcelRequire("b3yfA");
const $ea5e5e0c4f528fae$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $kCV8T.Node) || maybeNode instanceof (0, $kCV8T.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $kCV8T.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $ea5e5e0c4f528fae$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $ea5e5e0c4f528fae$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $5Vwh8.closeTypeAhead)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $kCV8T.Node) && node.isBlock ? (0, $b3yfA.insertBlockNode)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $b3yfA.insertInlineNodeOrFragment)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $fZzhT.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $ez3YZ.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $ez3YZ.InsertTypeAheadStep)(config));
        return tr;
    };
const $ea5e5e0c4f528fae$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $fZzhT.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $ez3YZ.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $ez3YZ.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $ea5e5e0c4f528fae$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $iiwBk.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $2D6mf.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $3UtTx.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $3UtTx.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $ea5e5e0c4f528fae$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $fZzhT.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $b6IDf.pluginKey))) (0, $5Vwh8.closeTypeAhead)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).INSERT_RAW_QUERY,
            params: $ea5e5e0c4f528fae$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $fZzhT.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };

});
parcelRegister("ez3YZ", function(module, exports) {

$parcel$export(module.exports, "InsertTypeAheadStages", () => $a9a76c74962f10f8$export$1b2be0bed116d664);
$parcel$export(module.exports, "InsertTypeAheadStep", () => $a9a76c74962f10f8$export$5ca6d15deb246b5d);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $a9a76c74962f10f8$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
let $a9a76c74962f10f8$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $a9a76c74962f10f8$export$5ca6d15deb246b5d extends (0, $eS2Dn.Step) {
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $a9a76c74962f10f8$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $a9a76c74962f10f8$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $eS2Dn.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($a9a76c74962f10f8$export$2f0b0962a5993fe0, $a9a76c74962f10f8$export$5ca6d15deb246b5d);

});

parcelRegister("2D6mf", function(module, exports) {

$parcel$export(module.exports, "StatsModifier", () => $f05a9d8982368ab5$export$630efe5940bb4d41);
class $f05a9d8982368ab5$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}

});

parcelRegister("iiwBk", function(module, exports) {

$parcel$export(module.exports, "isTypeAheadHandler", () => $d20c753282e6c55d$export$be092076596418f1);
$parcel$export(module.exports, "isTypeAheadOpen", () => $d20c753282e6c55d$export$564dcc295d6ce147);
$parcel$export(module.exports, "getPluginState", () => $d20c753282e6c55d$export$f05434c51e3762e);
$parcel$export(module.exports, "getTypeAheadHandler", () => $d20c753282e6c55d$export$c1eba975d6442029);
$parcel$export(module.exports, "getTypeAheadQuery", () => $d20c753282e6c55d$export$7a55deb43cd1340e);
$parcel$export(module.exports, "isTypeAheadAllowed", () => $d20c753282e6c55d$export$74b0f581633f8412);
$parcel$export(module.exports, "findHandler", () => $d20c753282e6c55d$export$2bae95e359577df4);
$parcel$export(module.exports, "skipForwardToSafeItem", () => $d20c753282e6c55d$export$84a03e6192df0237);
$parcel$export(module.exports, "moveSelectedIndex", () => $d20c753282e6c55d$export$f985e98ceae7c8f6);
$parcel$export(module.exports, "getTypeAheadListAriaLabels", () => $d20c753282e6c55d$export$19cacaa810ba988a);

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $gmhCD = parcelRequire("gmhCD");

var $bmkwl = parcelRequire("bmkwl");

var $koD1m = parcelRequire("koD1m");

var $b6IDf = parcelRequire("b6IDf");

var $2D6mf = parcelRequire("2D6mf");
const $d20c753282e6c55d$export$be092076596418f1 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
handler)=>{
    return handler && Object.values((0, $3UtTx.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $d20c753282e6c55d$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $b6IDf.pluginKey)?.getState(editorState)?.decorationSet?.find().length;
};
const $d20c753282e6c55d$export$f05434c51e3762e = (editorState)=>{
    return (0, $b6IDf.pluginKey).getState(editorState);
};
const $d20c753282e6c55d$export$c1eba975d6442029 = (editorState)=>{
    return (0, $b6IDf.pluginKey).getState(editorState)?.triggerHandler;
};
const $d20c753282e6c55d$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $b6IDf.pluginKey).getState(editorState)?.query;
};
const $d20c753282e6c55d$export$74b0f581633f8412 = (state)=>{
    const isOpen = $d20c753282e6c55d$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $d20c753282e6c55d$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $b6IDf.pluginKey).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $d20c753282e6c55d$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $d20c753282e6c55d$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $d20c753282e6c55d$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $b6IDf.pluginKey).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $d20c753282e6c55d$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $d20c753282e6c55d$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $2D6mf.StatsModifier) ? typeAheadState.stats : new (0, $2D6mf.StatsModifier)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $koD1m.itemIsDisabled)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
			 * See: https://product-fabric.atlassian.net/browse/ED-17200
			 * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
			 * and only do so when there is explicit logic to focus into the typeahead
			 * options.
			 *
			 * This check for "set index to 1 when -1"
			 * - is a temporary workaround to get back the previous behaviour without
			 *    entirely reverting the a11y improvements
			 *
			 */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $d20c753282e6c55d$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $d20c753282e6c55d$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $bmkwl.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $d20c753282e6c55d$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).mentionPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).metionListItemLabel, {
                    name: item?.mention?.name || '',
                    shortName: item?.mention?.mentionName || ''
                })
            };
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};

});
parcelRegister("bmkwl", function(module, exports) {

$parcel$export(module.exports, "updateSelectedIndex", () => $2917e7df6f0f82cb$export$9993709486a96a6b);

var $7eFnB = parcelRequire("7eFnB");

var $koD1m = parcelRequire("koD1m");

var $b6IDf = parcelRequire("b6IDf");
const $2917e7df6f0f82cb$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $b6IDf.pluginKey).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $koD1m.itemIsDisabled)(pluginState?.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});
parcelRegister("koD1m", function(module, exports) {

$parcel$export(module.exports, "itemIsDisabled", () => $ea4f5e057c318306$export$1ebf03cc1b973f80);
const $ea4f5e057c318306$export$1ebf03cc1b973f80 = (item, api)=>{
    const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
    return isOffline && item?.isDisabledOffline === true;
};

});



parcelRegister("b3yfA", function(module, exports) {

$parcel$export(module.exports, "insertBlockNode", () => $3d2e2b42ea5fc125$export$faec73a52dd47a2c);
$parcel$export(module.exports, "insertInlineNodeOrFragment", () => $3d2e2b42ea5fc125$export$a6d430434014dc1c);

var $dlzPV = parcelRequire("dlzPV");

var $aDFRV = parcelRequire("aDFRV");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");
function $3d2e2b42ea5fc125$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $3d2e2b42ea5fc125$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $dlzPV.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        if (grandParentNodeType === listItem && !(ggreatGrandParentNodeType === node.type)) return (0, $aDFRV.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $dlzPV.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $kCV8T.Slice).maxOpen((0, $kCV8T.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $3d2e2b42ea5fc125$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $gZGBX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $3d2e2b42ea5fc125$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $kCV8T.Node) ? (0, $kCV8T.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};

});
parcelRegister("dlzPV", function(module, exports) {

$parcel$export(module.exports, "normaliseNestedLayout", () => $3c014faca3b7f131$export$9a3d0d2a50538e52);
$parcel$export(module.exports, "safeInsert", () => $3c014faca3b7f131$export$5fe92db78385e37c);
$parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", () => $3c014faca3b7f131$export$b80431b156693a98);
$parcel$export(module.exports, "insertSelectedItem", () => $3c014faca3b7f131$export$e3c00faab58641c5);
$parcel$export(module.exports, "contentAllowedInCodeBlock", () => $3c014faca3b7f131$export$b6980e4b8ea578a5);
$parcel$export(module.exports, "fragmentContainsNodeType", () => $3c014faca3b7f131$export$2b1594c8921b5b2e);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $hPjvp = parcelRequire("hPjvp");
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");
var $uTDrM = parcelRequire("uTDrM");
var $3c014faca3b7f131$export$cbdce50c60b34c89 = /*#__PURE__*/ function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
    return LookDirection;
}({});
const $3c014faca3b7f131$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $3c014faca3b7f131$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $3c014faca3b7f131$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $3c014faca3b7f131$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $5r0mK.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $3c014faca3b7f131$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $5r0mK.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $3c014faca3b7f131$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $5r0mK.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $uTDrM.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $3c014faca3b7f131$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
	 * This block caters for the first item in a parent with the cursor being at the very start
	 * or the last item with the cursor being at the very end
	 *
	 * e.g.
	 * ul
	 *  li {<>}Scenario one
	 *  li
	 *  li Scenario two{<>}
	 */ if ($3c014faca3b7f131$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $3c014faca3b7f131$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: A more sustainable and configurable way to choose when to split
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3c014faca3b7f131$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $3c014faca3b7f131$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $kCV8T.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $5r0mK.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $5r0mK.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $594Yf.isEmptyParagraph)($insertPos.parent)) {
            if ($3c014faca3b7f131$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($3c014faca3b7f131$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$3c014faca3b7f131$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $3c014faca3b7f131$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $3c014faca3b7f131$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$3c014faca3b7f131$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $5r0mK.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $3c014faca3b7f131$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $594Yf.isEmptyParagraph)($insertPos.parent) && (0, $5r0mK.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $3c014faca3b7f131$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $5r0mK.canInsert)($proposedPosition, content)) return $3c014faca3b7f131$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($3c014faca3b7f131$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $3c014faca3b7f131$var$finaliseInsert($3c014faca3b7f131$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $gZGBX.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $3c014faca3b7f131$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $3c014faca3b7f131$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $eS2Dn.ReplaceStep) || lastStep instanceof (0, $eS2Dn.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $hPjvp.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $hPjvp.Side).RIGHT)).scrollIntoView();
};
const $3c014faca3b7f131$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $kCV8T.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $kCV8T.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $kCV8T.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $kCV8T.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $kCV8T.Node) && node.isBlock) {
            /**
			 *
			 * Rule has unique insertion behaviour
			 * so using this safeInsert function in order to handle specific cases in flat list vs nested list
			 * instead of a generic pmSafeInsert (i.e appending at the end)
			 *
			 */ const selectionInsideAPanel = $3c014faca3b7f131$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $594Yf.isEmptyParagraph)(tr.selection.$from.parent)) tr = $3c014faca3b7f131$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $5r0mK.safeInsert)($3c014faca3b7f131$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
			 *
			 * Replacing a type ahead query mark with an inline node.
			 *
			 */ } else if (node instanceof (0, $kCV8T.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $kCV8T.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $3c014faca3b7f131$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $kCV8T.Fragment).from(content))) return true;
    return false;
};
function $3c014faca3b7f131$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
function $3c014faca3b7f131$export$2b1594c8921b5b2e(fragment, nodeType) {
    let doesContainNodeType = false;
    fragment.descendants((node)=>{
        if (node.type === nodeType) {
            doesContainNodeType = true;
            // Stop looking
            return false;
        }
        return true;
    });
    return doesContainNodeType;
}

});



parcelRegister("ctcYc", function(module, exports) {

$parcel$export(module.exports, "openTypeAheadAtCursor", () => $4b1439ea28428b41$export$e7ce737179b76875);

var $hPjvp = parcelRequire("hPjvp");

var $gZGBX = parcelRequire("gZGBX");

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $4b1439ea28428b41$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $4b1439ea28428b41$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        $4b1439ea28428b41$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $gZGBX.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $gZGBX.TextSelection) || selection instanceof (0, $hPjvp.GapCursorSelection) || selection instanceof (0, $gZGBX.NodeSelection))) return tr;
        if (selection instanceof (0, $hPjvp.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $gZGBX.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger)) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };

});

parcelRegister("8oJYH", function(module, exports) {

$parcel$export(module.exports, "inputRulePlugin", () => $3181220485a0177f$export$568a7ed6897c4817);

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $inLhu = parcelRequire("inLhu");

var $ctcYc = parcelRequire("ctcYc");
function $3181220485a0177f$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $d19733ae55e58348$export$a96b909f1510512b)}])(${trigger})$`);
        acc.push((0, $2Abpa.createRule)(regex, (state, match)=>{
            return (0, $ctcYc.openTypeAheadAtCursor)({
                triggerHandler: typeAhead,
                inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $3181220485a0177f$export$2e2bcd8739ae039 = $3181220485a0177f$export$568a7ed6897c4817;

});

parcelRegister("ldgDZ", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $8bd7a547b078e11d$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $7eFnB = parcelRequire("7eFnB");

var $a6cBt = parcelRequire("a6cBt");
function $8bd7a547b078e11d$export$ae829ec7b2625219() {
    return new (0, $5KWxh.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $a6cBt.isInsertionTransaction)(transactions, (0, $7eFnB.ACTIONS).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}

});
parcelRegister("a6cBt", function(module, exports) {

$parcel$export(module.exports, "isInsertionTransaction", () => $2056d03687a2446d$export$e715282b081c154e);

var $b6IDf = parcelRequire("b6IDf");
const $2056d03687a2446d$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $b6IDf.pluginKey))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $b6IDf.pluginKey))?.params;
};

});


parcelRegister("2RUDH", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $45b1a64a630ececf$export$ae829ec7b2625219);

var $ez3YZ = parcelRequire("ez3YZ");

var $5KWxh = parcelRequire("5KWxh");

var $eQcNy = parcelRequire("eQcNy");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $7eFnB = parcelRequire("7eFnB");

var $8oQ7W = parcelRequire("8oQ7W");

var $ieoPC = parcelRequire("ieoPC");

var $a6cBt = parcelRequire("a6cBt");

var $b6IDf = parcelRequire("b6IDf");

var $dp8V8 = parcelRequire("dp8V8");
const $45b1a64a630ececf$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $ez3YZ.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $45b1a64a630ececf$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $ieoPC.factoryDecorations)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $dp8V8.createReducer)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $b6IDf.pluginKey),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $etG8M.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $45b1a64a630ececf$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $b6IDf.pluginKey), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $a6cBt.isInsertionTransaction)(transactions, (0, $7eFnB.ACTIONS).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $b6IDf.pluginKey).getState(state)?.decorationSet;
            },
            handleDOMEvents: {
                compositionend: (view, event)=>{
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $eQcNy.closest)(target, `[data-type-ahead=${(0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("8oQ7W", function(module, exports) {

$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", () => $6f65c97870929cfc$export$65dc1d975bd3407b);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", () => $6f65c97870929cfc$export$be8a8259777b339f);
$parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", () => $6f65c97870929cfc$export$a5cdf6890cae94d6);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", () => $6f65c97870929cfc$export$a38374e9651d6165);
$parcel$export(module.exports, "CloseSelectionOptions", () => $6f65c97870929cfc$export$fc2dc87cf13c1ab1);
const $6f65c97870929cfc$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $6f65c97870929cfc$export$be8a8259777b339f = 'typeaheadDecoration';
const $6f65c97870929cfc$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $6f65c97870929cfc$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $6f65c97870929cfc$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});

});

parcelRegister("ieoPC", function(module, exports) {

$parcel$export(module.exports, "factoryDecorations", () => $f1ca46bfdfc04632$export$116b677c5744e397);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $7Jxgt = parcelRequire("7Jxgt");

var $1SLCf = parcelRequire("1SLCf");

var $fZzhT = parcelRequire("fZzhT");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");


var $kQKqn = parcelRequire("kQKqn");

var $5Vwh8 = parcelRequire("5Vwh8");

var $8oQ7W = parcelRequire("8oQ7W");

var $2D6mf = parcelRequire("2D6mf");

var $iiwBk = parcelRequire("iiwBk");
const $f1ca46bfdfc04632$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $gZGBX.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $etG8M.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        const decorationId = `decoration_id_${(0, $8oQ7W.TYPE_AHEAD_DECORATION_KEY)}_${(0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $2D6mf.StatsModifier)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $etG8M.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
            typeaheadComponent.style.color = `var(--ds-text-accent-blue, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $iiwBk.getTypeAheadQuery)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $fZzhT.undo) : (0, $fZzhT.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $5Vwh8.closeTypeAhead)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
                    defaultLocale: (0, $VSDnB.fg)('platform_editor_update_type_ahead_locale') ? intl.defaultLocale || 'en-US' : undefined,
                    locale: intl.locale || ((0, $VSDnB.fg)('platform_editor_update_type_ahead_locale') ? 'en-US' : 'en'),
                    messages: intl.messages,
                    formats: intl.formats,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQKqn.WrapperTypeAhead), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery,
                        api: api
                    })
                }), typeaheadComponent, decorationId);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $1SLCf.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $etG8M.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $etG8M.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};

});
parcelRegister("kQKqn", function(module, exports) {

$parcel$export(module.exports, "WrapperTypeAhead", () => $8ef46ca5d5299ac6$export$970faf6afe0d9376);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $3UtTx = parcelRequire("3UtTx");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $6tlgz = parcelRequire("6tlgz");

var $2sbpe = parcelRequire("2sbpe");

var $koD1m = parcelRequire("koD1m");

var $iiwBk = parcelRequire("iiwBk");

var $ihi8h = parcelRequire("ihi8h");

var $kjRsq = parcelRequire("kjRsq");

var $52b7w = parcelRequire("52b7w");

var $kz2Z2 = parcelRequire("kz2Z2");
const $8ef46ca5d5299ac6$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const showViewMore = triggerHandler?.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT && !!openElementBrowserModal && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1');
    const [closed, setClosed] = (0, $5uXOq.useState)(false);
    const [query, setQuery] = (0, $5uXOq.useState)(reopenQuery || '');
    const queryRef = (0, $5uXOq.useRef)(query);
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    const items = (0, $kjRsq.useLoadItems)(triggerHandler, editorView, query, showViewMore);
    (0, $5uXOq.useEffect)(()=>{
        if (!closed && (0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        closed,
        api
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $ihi8h.useItemInsert)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $5uXOq.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) (0, $6tlgz.fireTypeAheadClosedAnalyticsEvent)(api, (0, $gkwXh.ACTION).CANCELLED, !!queryRef.current, (0, $gkwXh.INPUT_METHOD).KEYBOARD);
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        api,
        triggerHandler.trigger,
        onTextInsert
    ]);
    const insertSelectedItem = (0, $5uXOq.useCallback)((mode = (0, $3UtTx.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $iiwBk.getPluginState)(view.state);
        const safeSelectedIndex = (0, $iiwBk.skipForwardToSafeItem)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $koD1m.itemIsDisabled)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) (0, $6tlgz.fireTypeAheadClosedAnalyticsEvent)(api, (0, $gkwXh.ACTION).INSERTED, !!queryRef.current, (0, $gkwXh.INPUT_METHOD).KEYBOARD);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        onItemInsert,
        api,
        items
    ]);
    const showTypeAheadPopupList = (0, $5uXOq.useCallback)(()=>{}, []);
    const closePopup = (0, $5uXOq.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $iiwBk.getPluginState)(view.state);
        if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $2sbpe.updateQuery)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $52b7w.useOnForceSelect)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kz2Z2.InputQuery), {
        triggerQueryPrefix: triggerHandler?.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$8ef46ca5d5299ac6$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';

});
parcelRegister("6tlgz", function(module, exports) {

$parcel$export(module.exports, "fireTypeAheadClosedAnalyticsEvent", () => $3cc55692bf5a5959$export$4a6068dadc2c7771);

var $gkwXh = parcelRequire("gkwXh");
const $3cc55692bf5a5959$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod)=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $gkwXh.ACTION).CLOSED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    });
};

});

parcelRegister("2sbpe", function(module, exports) {

$parcel$export(module.exports, "updateQuery", () => $51fa8a395f333c02$export$4d1bf8b2f67bcb1);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $51fa8a395f333c02$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $b6IDf.pluginKey).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("ihi8h", function(module, exports) {

$parcel$export(module.exports, "useItemInsert", () => $eb595ad3aa140c9b$export$3a3385069392b26f);

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $5Vwh8 = parcelRequire("5Vwh8");

var $eF1Qh = parcelRequire("eF1Qh");

var $ecipM = parcelRequire("ecipM");

var $8oQ7W = parcelRequire("8oQ7W");

var $koD1m = parcelRequire("koD1m");
const $eb595ad3aa140c9b$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $5Vwh8.closeTypeAhead)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, $ecipM.setSelectionBeforeQuery)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $eb595ad3aa140c9b$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    const itemsRef = (0, $5uXOq.useRef)(items);
    const onTextInsert = (0, $5uXOq.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $eb595ad3aa140c9b$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $5uXOq.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $koD1m.itemIsDisabled)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $eF1Qh.insertTypeAheadItem)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $5uXOq.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: mode === (0, $3UtTx.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};

});
parcelRegister("ecipM", function(module, exports) {

$parcel$export(module.exports, "setSelectionBeforeQuery", () => $323bc7045def31d4$export$5af11333ab9d7643);

var $gZGBX = parcelRequire("gZGBX");
const $323bc7045def31d4$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $gZGBX.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };

});


parcelRegister("kjRsq", function(module, exports) {

$parcel$export(module.exports, "useLoadItems", () => $d8a2315e9c730da4$export$36f5628e43bc3fcd);

var $5uXOq = parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");

var $6Tdem = parcelRequire("6Tdem");

var $7lNrQ = parcelRequire("7lNrQ");
const $d8a2315e9c730da4$var$EMPTY_LIST_ITEM = [];
const $d8a2315e9c730da4$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore)=>{
    const [items, setItems] = (0, $5uXOq.useState)($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $5uXOq.useRef)(true);
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    (0, $5uXOq.useEffect)(()=>{
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
            return;
        }
        const options = {
            query: query || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        getItems(options).then((result)=>{
            const list = result.length > 0 ? result : $d8a2315e9c730da4$var$EMPTY_LIST_ITEM;
            if (componentIsMounted.current) setItems(list);
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $7lNrQ.updateListItem)(showViewMore ? list.concat(viewMoreItem) : list)(view.state, view.dispatch);
            });
        }).catch((e)=>{
            if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) {
                if (e) {
                    if (componentIsMounted.current) setItems($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
                    queueMicrotask(()=>{
                        (0, $6Tdem.updateListError)(e)(view.state, view.dispatch);
                    });
                }
            }
        });
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};

});
parcelRegister("6Tdem", function(module, exports) {

$parcel$export(module.exports, "updateListError", () => $92abbbe801e1416a$export$4f4014ebb73e8d41);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $92abbbe801e1416a$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("7lNrQ", function(module, exports) {

$parcel$export(module.exports, "updateListItem", () => $3098d34af4194062$export$e482099e4c227d2);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $3098d34af4194062$export$e482099e4c227d2 = (items)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).UPDATE_LIST_ITEMS,
            params: {
                items: items
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});


parcelRegister("52b7w", function(module, exports) {

$parcel$export(module.exports, "useOnForceSelect", () => $be9bd9cb734881d4$export$4715c10ec9ca9321);

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $eF1Qh = parcelRequire("eF1Qh");
const $be9bd9cb734881d4$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $eF1Qh.insertTypeAheadItem)(view)({
                item: item,
                mode: (0, $3UtTx.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};

});

parcelRegister("kz2Z2", function(module, exports) {

$parcel$export(module.exports, "InputQuery", () => $aac54d4dcb1a378a$export$efc9b80896822e63);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $1SLCf = parcelRequire("1SLCf");

var $gE8f9 = parcelRequire("gE8f9");

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $gFzVq = parcelRequire("gFzVq");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $8oQ7W = parcelRequire("8oQ7W");

var $iiwBk = parcelRequire("iiwBk");
function $aac54d4dcb1a378a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aac54d4dcb1a378a$var$placeholderStyles = {
    name: "1onny3l",
    styles: "&::after{content:attr(data-place-holder);color:var(--ds-text-subtlest, #626F86);position:relative;padding:var(--ds-space-025, 2px);left:var(--ds-space-negative-050, -4px);background-color:var(--ds-background-neutral, #091E420F);border-radius:3px;}"
};
const $aac54d4dcb1a378a$var$queryWithoutPlaceholderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        content: `''`
    }
});
const $aac54d4dcb1a378a$var$querySpanStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $iHYdz.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #0052CC)"
    }
});
const $aac54d4dcb1a378a$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $aac54d4dcb1a378a$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $1SLCf.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $aac54d4dcb1a378a$var$getAriaLabel = (triggerPrefix, intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $8ptyJ.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $8ptyJ.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $8ptyJ.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $8ptyJ.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $aac54d4dcb1a378a$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
    const ref = (0, $5uXOq.useRef)(document.createElement('span'));
    const inputRef = (0, $5uXOq.useRef)(null);
    const [query, setQuery] = (0, $5uXOq.useState)(null);
    const isEditorInsertionEnabled = (0, $gmhCD.editorExperiment)('platform_editor_insertion', 'variant1');
    const isEditorControlsPatch2Enabled = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_2');
    const isSearchPlaceholderEnabled = isEditorInsertionEnabled || (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_quick_insert_placeholder');
    const selection = editorView.state.selection;
    const { table: table } = editorView.state.schema.nodes;
    const [showPlaceholder, setShowPlaceholder] = (0, $5uXOq.useState)(isSearchPlaceholderEnabled && triggerQueryPrefix === '/' && // When triggered in very narrow table column, placeholder becomes ellipsis only
    // hence we disable it for now and revisit this scenario in ED-27480
    !(0, $5r0mK.findParentNodeOfType)(table)(selection));
    const cleanedInputContent = (0, $5uXOq.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $5uXOq.useCallback)((event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const onInput = (0, $5uXOq.useCallback)(()=>{
        if (cleanedInputContent()) setShowPlaceholder(false);
    }, [
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $5uXOq.useState)(false);
    const checkKeyEvent = (0, $5uXOq.useCallback)((event)=>{
        const key = (0, $1SLCf.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $3UtTx.SelectItemMode).SHIFT_ENTER : (0, $3UtTx.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                if (selectedIndex === -1) {
                    /**
           * TODO DTR-1401: (also see ED-17200) There are two options
           * here, either
           * - set the index directly to 1 in WrapperTypeAhead.tsx's
           *   `insertSelectedItem` at the cost of breaking some of the a11y
           *   focus changes,
           * - or do this jank at the cost of some small analytics noise.
           *
           */ selectPreviousItem();
                    selectNextItem();
                }
                // TODO: DTR-1401 - why is this calling select item when hitting tab? fix this in DTR-1401
                onItemSelect((0, $3UtTx.SelectItemMode).TAB);
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $aac54d4dcb1a378a$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($aac54d4dcb1a378a$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onQueryFocus();
        inputRef.current?.focus();
        return false;
    }, [
        onQueryFocus
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        const onFocusIn = (event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $1SLCf.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`)) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if (((0, $gE8f9.browser).ie || (0, $gE8f9.browser).chrome) && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if ((0, $gE8f9.browser).safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if ((0, $gE8f9.browser).safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            if ((0, $gE8f9.browser).safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const classNames = (0, $5uXOq.useMemo)(()=>{
        const classes = [];
        if (showPlaceholder) {
            // to avoid the placeholder wrapped to next line when triggered at the end of the line
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-wrap');
            if (selection.$from.depth > 1) // to hide placeholder overflow as ellipsis
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-hide-overflow');
        }
        return classes.join(' ');
    }, [
        showPlaceholder,
        selection
    ]);
    const assistiveHintID = (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
    const intl = (0, $koVbs.default)();
    /**
      When we migrated to emotion from styled component, we started getting this error.
      jsx-a11y/interactive-supports-focus
      Task added in https://product-fabric.atlassian.net/wiki/spaces/E/pages/3182068181/Potential+improvements#Moderate-changes.
     */ return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $aac54d4dcb1a378a$var$querySpanStyles,
            isSearchPlaceholderEnabled && $aac54d4dcb1a378a$var$queryWithoutPlaceholderStyles,
            showPlaceholder && $aac54d4dcb1a378a$var$placeholderStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        onClick: onClick,
        onInput: isSearchPlaceholderEnabled ? onInput : undefined,
        role: "combobox",
        "aria-controls": (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID),
        "aria-autocomplete": "list",
        "aria-expanded": items.length !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: classNames,
        "data-place-holder": intl.formatMessage((0, $8ptyJ.typeAheadListMessages).quickInsertInputPlaceholderLabel)
    }, query === null ? /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($aac54d4dcb1a378a$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $8ptyJ.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gFzVq.AssistiveText), {
        assistiveText: items.length === 0 ? intl.formatMessage((0, $8ptyJ.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: items.length
        }) : '',
        isInFocus: items.length === 0 || isInFocus,
        id: (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID)
    }));
});
$aac54d4dcb1a378a$export$efc9b80896822e63.displayName = 'InputQuery';

});
parcelRegister("gFzVq", function(module, exports) {

$parcel$export(module.exports, "AssistiveText", () => $fa1c36596b67c458$export$568f929105953699);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lFKmC = parcelRequire("lFKmC");
function $fa1c36596b67c458$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fa1c36596b67c458$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $fa1c36596b67c458$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $5uXOq.useState)(false);
    const [debounced, setDebounced] = (0, $5uXOq.useState)(false);
    const [silenced, setSilenced] = (0, $5uXOq.useState)(false);
    const debounceStatusUpdate = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!debounced) {
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (debounced) {
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $fa1c36596b67c458$var$assitiveTextStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};

});




parcelRegister("dp8V8", function(module, exports) {

$parcel$export(module.exports, "createReducer", () => $e28e7fc4651e6649$export$473eb76d322d0290);

var $ez3YZ = parcelRequire("ez3YZ");

var $gkwXh = parcelRequire("gkwXh");

var $etG8M = parcelRequire("etG8M");

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");

var $iiwBk = parcelRequire("iiwBk");
const $e28e7fc4651e6649$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $ez3YZ.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $e28e7fc4651e6649$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $ez3YZ.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $e28e7fc4651e6649$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $ez3YZ.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $e28e7fc4651e6649$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $e28e7fc4651e6649$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $etG8M.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $b6IDf.pluginKey)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $e28e7fc4651e6649$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($e28e7fc4651e6649$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $7eFnB.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, $iiwBk.isTypeAheadHandler)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $7eFnB.ACTIONS).CLOSE_TYPE_AHEAD,
            (0, $7eFnB.ACTIONS).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $7eFnB.ACTIONS).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $7eFnB.ACTIONS).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $7eFnB.ACTIONS).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $7eFnB.ACTIONS).UPDATE_SELECTED_INDEX;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};

});


parcelRegister("hgbc1", function(module, exports) {

$parcel$export(module.exports, "ContentComponent", () => $d3e8f95cdf408c42$export$2dda1e4a1d1f6a81);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $awTmI = parcelRequire("awTmI");

var $3UtTx = parcelRequire("3UtTx");

var $gmhCD = parcelRequire("gmhCD");

var $gJ2x0 = parcelRequire("gJ2x0");

var $gw7Nh = parcelRequire("gw7Nh");
function $d3e8f95cdf408c42$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { typeAheadState: typeAheadState } = (0, $awTmI.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    if (!typeAheadState) return null;
    if (// TODO: ED-26959 - Also requires a check for editor appearance (needs to be enabled for full-page/full-width editor only ?)
    !(0, $gmhCD.editorExperiment)('platform_editor_insertion', 'control') && typeAheadState.triggerHandler?.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gJ2x0.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: typeAheadState,
        api: api
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gw7Nh.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: typeAheadState,
        api: api
    });
}

});
parcelRegister("gJ2x0", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $48e3b31cf5a335d2$export$b11addef9209139);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $bmkwl = parcelRequire("bmkwl");

var $ihi8h = parcelRequire("ihi8h");

var $lE4zE = parcelRequire("lE4zE");
const $48e3b31cf5a335d2$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert] = (0, $ihi8h.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $bmkwl.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((mode = (0, $3UtTx.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lE4zE.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        // selectedIndex={selectedIndex}
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        query: query,
        cancel: cancel,
        api: api
    });
});

});
parcelRegister("lE4zE", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $70eeadf988d1044d$export$fbc0702507873a7d);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7nRxN = parcelRequire("7nRxN");

var $koVbs = parcelRequire("koVbs");

var $gkwXh = parcelRequire("gkwXh");

var $1IiUD = parcelRequire("1IiUD");

var $f3dKD = parcelRequire("f3dKD");
var $4N9VB = parcelRequire("4N9VB");

var $1iN2Y = parcelRequire("1iN2Y");
var $5NQrW = parcelRequire("5NQrW");

var $iHYdz = parcelRequire("iHYdz");

var $dZbEw = parcelRequire("dZbEw");

var $VSDnB = parcelRequire("VSDnB");


var $8oQ7W = parcelRequire("8oQ7W");

var $cDzXZ = parcelRequire("cDzXZ");
const $70eeadf988d1044d$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 520;
// const DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $70eeadf988d1044d$var$ITEM_PADDING = 12;
const $70eeadf988d1044d$var$INSERT_PANEL_WIDTH = 320;
const $70eeadf988d1044d$var$typeAheadContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '280px',
    maxHeight: '520px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $70eeadf988d1044d$var$OFFSET = [
    0,
    8
];
const $70eeadf988d1044d$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, query: query, setSelectedItem: setSelectedItem } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const defaultMenuHeight = $70eeadf988d1044d$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT;
    const startTime = (0, $5uXOq.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $5uXOq.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).RENDERED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    // useEffect(() => {
    // 	if (!api?.analytics?.actions?.fireAnalyticsEvent) {
    // 		return;
    // 	}
    // 	api?.analytics?.actions?.fireAnalyticsEvent({
    // 		action: ACTION.VIEWED,
    // 		actionSubject: ACTION_SUBJECT.TYPEAHEAD_ITEM,
    // 		eventType: EVENT_TYPE.OPERATIONAL,
    // 		attributes: {
    // 			index: selectedIndex,
    // 			items: items.length,
    // 		},
    // 	});
    // }, [
    // 	items,
    // 	api,
    // 	selectedIndex,
    // 	// In case the current triggerHandler changes
    // 	// e.g: Inserting a mention using the quick insert
    // 	// we need to send the event again
    // 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // 	triggerHandler,
    // ]);
    const [fitHeight, setFitHeight] = (0, $5uXOq.useState)(defaultMenuHeight);
    const getFitHeight = (0, $5uXOq.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $70eeadf988d1044d$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $7nRxN.default)(getFitHeight);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $f3dKD.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji and @ typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            if ((0, $VSDnB.fg)('platform_editor_legacy_content_macro_typeahead_fix')) {
                // Check if new focus point is inside the current editor. If it is not we
                // want to close the typeahead popup regardless of text selection state
                const currentFocus = window.getSelection()?.focusNode; // the focusNode is either TextNode, ElementNode
                // if currentFocus is not HTMLElement, take its parent node as focusNode
                const focusNode = currentFocus instanceof HTMLElement ? currentFocus : currentFocus?.parentNode;
                if (focusNode instanceof HTMLElement) {
                    const innerEditor = focusNode.closest('.extension-editable-area');
                    if (innerEditor) {
                        // When there is no related target, we default to not closing the popup
                        let newFocusInsideCurrentEditor = !relatedTarget;
                        if (relatedTarget instanceof HTMLElement) {
                            if (innerEditor) // check if the new focus is inside inner editor, keep popup opens
                            newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                            else // if the new focus contains current focus node, the popup won't close
                            newFocusInsideCurrentEditor = relatedTarget.contains(focusNode);
                        }
                        if (!isTextSelected && newFocusInsideCurrentEditor) return;
                    } else {
                        // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                        if (!isTextSelected) return;
                    }
                }
            } else {
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $5uXOq.useLayoutEffect)(()=>{
        const escape = (event)=>{
            if (event.key === 'Escape') cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: true
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel
    ]);
    const handleViewAllItemsClick = (0, $5uXOq.useCallback)(()=>{
        const showContextPanel = api?.contextPanel?.actions?.showPanel;
        if (!showContextPanel || !items) return;
        // Opens main editor controls side panel
        showContextPanel({
            id: 'editor-element-insert-sidebar-panel',
            headerComponentElements: {
                headerLabel: (0, $1IiUD.elementInsertSidePanel).title,
                HeaderIcon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: formatMessage((0, $1IiUD.elementInsertSidePanel).title)
                    })
            },
            BodyComponent: ()=>{
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5NQrW.SideInsertPanel), {
                    items: items,
                    onItemInsert: onItemInsert
                });
            }
        }, 'push', $70eeadf988d1044d$var$INSERT_PANEL_WIDTH);
        // Closes typeahead
        cancel({
            addPrefixTrigger: true,
            setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
            forceFocusOnEditor: true
        });
    }, [
        api,
        cancel,
        formatMessage,
        items,
        onItemInsert
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        zIndex: (0, $iHYdz.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 280,
        offset: $70eeadf988d1044d$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $70eeadf988d1044d$var$typeAheadContent
        ],
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cDzXZ.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1iN2Y.QuickInsertPanel), {
        items: items,
        onItemInsert: onItemInsert,
        query: query,
        setSelectedItem: setSelectedItem,
        onViewAllItemsClick: Boolean(api?.contextPanel) ? handleViewAllItemsClick : undefined
    }))));
});
$70eeadf988d1044d$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("1iN2Y", function(module, exports) {

$parcel$export(module.exports, "QuickInsertPanel", () => $a6039491f2a80e46$export$c4b59221ed3995fe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $gIDRO = parcelRequire("gIDRO");

var $74NcZ = parcelRequire("74NcZ");

var $bOqDA = parcelRequire("bOqDA");

var $IV5RJ = parcelRequire("IV5RJ");

var $77Kxe = parcelRequire("77Kxe");
const $a6039491f2a80e46$var$navButtonContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $a6039491f2a80e46$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroupWithHeading), {
                id: suggested.id,
                items: suggested.items.slice(0, 6),
                label: suggested.label,
                onItemSelected: onItemSelected,
                setSelectedItem: setSelectedItem,
                startingIndex: 0
            }),
            (0, $gIDRO.CategoriesStructure).map((category)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                return items.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                    hasSeparator: true,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $a6039491f2a80e46$var$navButtonContainerStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IV5RJ.LinkNavButton), {
                            id: category.id,
                            label: category.title,
                            onClick: onCategorySelected
                        })
                    })
                }, category.id);
            })
        ]
    });
};
const $a6039491f2a80e46$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $gIDRO.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    let startingIndex = categoryLevelItems.length;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $77Kxe.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected,
                    startingIndex: 0
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    if (categoryRegistry[id]) {
                        const list = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroupWithHeading), {
                            id: id,
                            label: title,
                            items: categoryRegistry[id],
                            onItemSelected: onItemSelected,
                            startingIndex: startingIndex
                        });
                        startingIndex += categoryRegistry[id].length;
                        return list;
                    }
                })
            ]
        })
    });
};
const $a6039491f2a80e46$var$SearchView = ({ items: items, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: 0
    });
};
const $a6039491f2a80e46$var$EmptySearchView = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        padding: "space.300",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
            space: "space.0",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    align: "center",
                    as: "p",
                    children: "We couldn't find any results."
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cgL5K.default), {
                    align: "center",
                    as: "p",
                    children: [
                        "Select ",
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                            weight: "medium",
                            children: "View all"
                        }),
                        " to browser inserts."
                    ]
                })
            ]
        })
    });
};
const $a6039491f2a80e46$export$c4b59221ed3995fe = /*#__PURE__*/ (0, $5uXOq.memo)(({ items: items, onItemInsert: onItemInsert, onViewAllItemsClick: onViewAllItemsClick, query: query, setSelectedItem: setSelectedItem })=>{
    const onItemSelect = (0, $5uXOq.useCallback)((index)=>{
        onItemInsert((0, $3UtTx.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { suggested: suggested, categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSelectedCategory: setSelectedCategory } = (0, $gIDRO.useItems)(items, query);
    const showViewAllItems = Boolean(onViewAllItemsClick);
    const view = searchItems ? searchItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect,
        setSelectedItem: setSelectedItem
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$EmptySearchView, {}) : selectedCategory ? /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$DefaultView, {
        suggested: suggested,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        },
        setSelectedItem: setSelectedItem
    });
    if (showViewAllItems) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            view,
            showViewAllItems && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ViewAllButtonItem), {
                isViewAllInserts: true,
                label: 'View all inserts',
                onClick: onViewAllItemsClick ? onViewAllItemsClick : ()=>{}
            })
        ]
    });
    else return view;
});

});
parcelRegister("gIDRO", function(module, exports) {

$parcel$export(module.exports, "CategoriesStructure", () => $74beeb514a2542ee$export$55e347ea2fcfe5fb);
$parcel$export(module.exports, "PredefinedCategories", () => $74beeb514a2542ee$export$55985cbdefca4b42);
$parcel$export(module.exports, "useItems", () => $74beeb514a2542ee$export$7bfdd97581ca93c);

var $5uXOq = parcelRequire("5uXOq");

var $e9qoo = parcelRequire("e9qoo");

var $f38Uc = parcelRequire("f38Uc");

var $8TaEl = parcelRequire("8TaEl");
const $74beeb514a2542ee$var$transformBrowserElementItem = (item)=>{
    return {
        index: item.tempKey,
        title: item.title,
        description: item.description,
        showDescription: Boolean(item?.id) && item.id !== 'datasource' ? false : true,
        keyshortcut: item.keyshortcut ? (0, $e9qoo.makeKeyMapWithCommon)('', item.keyshortcut) : undefined,
        renderIcon: item.icon
    };
};
const $74beeb514a2542ee$export$55e347ea2fcfe5fb = [
    {
        id: 'media',
        title: 'Media',
        subcategories: [],
        // defaultItems and array or native elements' ids or titles of an extensions
        // TODO: ED-26961 - how should we identify extensions in prod?
        // Note: only 'media' or 'media-insert' will be available, so we'll display only 5 default items
        defautltItems: [
            'media',
            'media-insert',
            'emoji',
            'hyperlink',
            'loom',
            'Create whiteboard'
        ]
    },
    {
        id: 'structure',
        title: 'Structure',
        subcategories: [
            {
                id: 'text structure',
                title: 'Text structure'
            },
            {
                id: 'page structure',
                title: 'Page structure'
            },
            {
                id: 'connect pages',
                title: 'Connect pages'
            },
            {
                id: 'navigation',
                title: 'Navigation'
            },
            {
                id: 'search',
                title: 'Search'
            }
        ],
        defautltItems: [
            'date',
            'decision',
            'status',
            'table',
            'Table of contents'
        ]
    },
    {
        id: 'data',
        title: 'Data',
        subcategories: [
            {
                id: 'charts',
                title: 'Charts'
            },
            {
                id: 'gadgets',
                title: 'Gadgets'
            },
            {
                id: 'jira',
                title: 'Jira'
            },
            {
                id: 'labels',
                title: 'Labels'
            },
            {
                id: 'reports',
                title: 'Reports'
            },
            {
                id: 'timelines',
                title: 'Timelines'
            }
        ],
        defautltItems: [
            'Create database',
            'Filter by label',
            'Chart',
            'Create Jira issue',
            'Content Report Table'
        ]
    },
    {
        id: 'collaborate',
        title: 'Collaborate',
        subcategories: [],
        defautltItems: [
            'mention',
            'Contributors',
            'Contributors Summary',
            'User Profile',
            'Spaces List'
        ]
    },
    {
        id: 'ai',
        title: 'Atlassian Intelligence',
        subcategories: [],
        defautltItems: []
    },
    {
        id: 'apps',
        title: 'Apps',
        subcategories: [],
        defautltItems: []
    }
];
const $74beeb514a2542ee$export$55985cbdefca4b42 = new Map();
$74beeb514a2542ee$export$55e347ea2fcfe5fb.forEach((categoryData)=>{
    $74beeb514a2542ee$export$55985cbdefca4b42.set(categoryData.id, categoryData);
    categoryData.subcategories.forEach((subcategoryData)=>{
        $74beeb514a2542ee$export$55985cbdefca4b42.set(subcategoryData.id, subcategoryData);
    });
});
const $74beeb514a2542ee$var$parseCategories = (itemCategories)=>{
    if (!itemCategories) return [
        'apps'
    ];
    const filteredCategories = itemCategories.filter((category)=>{
        return $74beeb514a2542ee$export$55985cbdefca4b42.has(category.toLocaleLowerCase());
    });
    return filteredCategories.length > 0 ? filteredCategories : [
        'apps'
    ];
};
const $74beeb514a2542ee$var$suggestedIds = [
    'table',
    'action',
    'codeblock',
    'infopanel',
    'threecolumnslayout',
    'emoji',
    'rule',
    'expand'
];
const $74beeb514a2542ee$export$7bfdd97581ca93c = (quickInsertPanelItems, query)=>{
    const [searchText, setSearchText] = (0, $5uXOq.useState)(query);
    const [selectedCategory, setSelectedCategory] = (0, $5uXOq.useState)();
    const insertPanelItems = (0, $5uXOq.useMemo)(()=>(0, $f38Uc.getMappedItems)(quickInsertPanelItems), [
        quickInsertPanelItems
    ]);
    const categoryRegistry = {};
    const itemsRegistry = {};
    const suggestedItems = [];
    insertPanelItems.forEach((item)=>{
        const categories = $74beeb514a2542ee$var$parseCategories(item.categories);
        const preparedItem = $74beeb514a2542ee$var$transformBrowserElementItem(item);
        categories.forEach((category)=>{
            category = category.toLocaleLowerCase();
            if (categoryRegistry[category]) categoryRegistry[category].push(preparedItem);
            else categoryRegistry[category] = [
                preparedItem
            ];
        });
        const itemKey = item.id || item.title;
        itemsRegistry[itemKey] = preparedItem;
        for(let i = 0; i < $74beeb514a2542ee$var$suggestedIds.length; i++){
            const realSuggestedItems = suggestedItems.filter((item)=>item);
            if (realSuggestedItems.length < $74beeb514a2542ee$var$suggestedIds.length && itemKey === $74beeb514a2542ee$var$suggestedIds[i]) suggestedItems[i] = preparedItem;
        }
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    const suggested = {
        id: 'suggested',
        label: 'Suggestions',
        items: suggestedItems
    }; // TODO define the id and label as constants
    // when query gets updated from the prop drilling it won't cause a re-render of the hook
    // as it will be treated only as default state, so for now combinbing searchText and query here
    // we need to find a better more performant solution for the search (after the demo)
    const combinedSearchText = (0, $5uXOq.useMemo)(()=>searchText || query, [
        query,
        searchText
    ]);
    const searchItems = (0, $5uXOq.useMemo)(()=>{
        if (!combinedSearchText) return undefined;
        const filteredItems = (0, $8TaEl.find)(combinedSearchText, insertPanelItems);
        return filteredItems.map((item)=>$74beeb514a2542ee$var$transformBrowserElementItem(item));
    }, [
        insertPanelItems,
        combinedSearchText
    ]);
    return {
        suggested: suggested,
        categoryRegistry: categoryRegistry,
        itemsRegistry: itemsRegistry,
        selectedCategory: selectedCategory,
        searchItems: searchItems,
        setSearchText: setSearchText,
        setSelectedCategory: setSelectedCategory
    };
};

});
parcelRegister("f38Uc", function(module, exports) {

$parcel$export(module.exports, "getMappedItems", () => $866f0e1daf5bd577$export$c9a8cf32755faa87);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7Xf9k = parcelRequire("7Xf9k");

var $6TPL7 = parcelRequire("6TPL7");

var $cgRoK = parcelRequire("cgRoK");

var $jSlaY = parcelRequire("jSlaY");

var $3fesp = parcelRequire("3fesp");

var $8HSNL = parcelRequire("8HSNL");

var $cVLny = parcelRequire("cVLny");

var $dgJHC = parcelRequire("dgJHC");

var $fhbwe = parcelRequire("fhbwe");

var $9e98Z = parcelRequire("9e98Z");

var $bh6Q5 = parcelRequire("bh6Q5");

var $1f9bV = parcelRequire("1f9bV");

var $izMdR = parcelRequire("izMdR");

var $2UiHO = parcelRequire("2UiHO");

var $4xPlE = parcelRequire("4xPlE");

var $aiLjp = parcelRequire("aiLjp");
const $866f0e1daf5bd577$var$getItemData = (item, tempKey)=>{
    const itemId = item.id;
    const itemTitle = item.title;
    if (itemId && itemId !== 'datasource') switch(itemId){
        case 'action':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'media-insert':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fhbwe))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'mention':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($izMdR))), {
                        label: ""
                    }),
                categories: [
                    'collaborate'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'emoji':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cVLny))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'expand':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TPL7))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'table':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgJHC))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'codeblock':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSlaY))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'status':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cgRoK))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'infopanel':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9e98Z))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Panel',
                tempKey: tempKey
            };
        case 'date':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
                        label: ""
                    }),
                categories: [
                    'date'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'loom':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aiLjp))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'decision':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8HSNL))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'threecolumnslayout':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6Q5))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Layout',
                tempKey: tempKey
            };
        case 'hyperlink':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'rule':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Xf9k))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'blockquote':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
    }
    else if (itemTitle) switch(itemTitle){
        case 'Assets':
            return {
                ...item,
                categories: [
                    'data'
                ],
                tempKey: tempKey
            };
        case 'Jira Issues':
        case 'Jira Road Map':
            return {
                ...item,
                categories: [
                    'jira'
                ],
                tempKey: tempKey
            };
        case 'Labels List':
        case 'Related Labels':
        case 'Labels Gadget':
        case 'Popular Labels':
            return {
                ...item,
                categories: [
                    'labels'
                ],
                tempKey: tempKey
            };
        case 'Version Report':
        case 'Time to First Response':
        case 'Decision report':
        case 'Two Dimensional Filter Statistics':
        case 'Task report':
        case 'Issue Statistics':
        case 'Page Properties Report':
            return {
                ...item,
                categories: [
                    'reports'
                ],
                tempKey: tempKey
            };
        case 'Opsgenie Incident Timeline EU':
        case 'Opsgenie Incident Timeline':
        case 'Jira timeline':
        case 'JSM Incident Timeline EU':
        case 'JSM Incident Timeline':
        case 'Resolution Time':
            return {
                ...item,
                categories: [
                    'timelines'
                ],
                tempKey: tempKey
            };
        case 'Create database':
        case 'Filter by label':
        case 'Chart':
        case 'Create Jira issue':
        case 'Content Report Table':
            return {
                ...item,
                categories: [
                    'data'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Heat Map':
        case 'Pie Chart':
        case 'Time Since Chart':
        case 'Recently Created Chart':
        case 'Created vs. Resolved Chart':
        case 'Average Age Chart':
            return {
                ...item,
                categories: [
                    'charts'
                ],
                tempKey: tempKey
            };
        case 'Agile Wallboard Gadget':
        case 'Sprint Burndown Gadget':
            return {
                ...item,
                categories: [
                    'gadgets'
                ],
                tempKey: tempKey
            };
        case 'Anchor link':
        case 'Child pages':
        case 'Page Index':
            return {
                ...item,
                categories: [
                    'navigation'
                ],
                tempKey: tempKey
            };
        case 'Table of contents':
            return {
                ...item,
                categories: [
                    'page structure'
                ],
                tempKey: tempKey
            };
        case 'Insert Confluence list':
        case 'Live Search':
        case 'Page Tree Search':
        case 'Page Tree':
            return {
                ...item,
                categories: [
                    'search'
                ],
                tempKey: tempKey
            };
        case 'Excerpt':
        case 'Recently Updated Dashboard':
        case 'Create from Template':
            return {
                ...item,
                categories: [
                    'connect pages'
                ],
                tempKey: tempKey
            };
        case 'Powerpoint':
        case 'Excel':
        case 'Iframe':
        case 'Profile Picture':
        case 'Blog Posts':
        case 'Gallery':
        case 'Word':
        case 'PDF':
        case 'Widget Connector':
            return {
                ...item,
                categories: [
                    'media'
                ],
                tempKey: tempKey
            };
        case 'Create whiteboard':
            return {
                ...item,
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Contributors':
        case 'Contributors Summary':
        case 'User List':
        case 'Voted Issues':
        case 'User Profile':
        case 'Spaces List':
            return {
                ...item,
                categories: [
                    'collaborate'
                ],
                tempKey: tempKey
            };
        case 'Gliffy Diagram':
            return {
                ...item,
                categories: [
                    'apps'
                ],
                tempKey: tempKey
            };
        default:
            return {
                ...item,
                tempKey: tempKey
            };
    }
    return {
        ...item,
        categories: [
            'apps'
        ],
        tempKey: // category: 'apps',
        // subCategory: undefined,
        tempKey
    };
};
const $866f0e1daf5bd577$export$c9a8cf32755faa87 = (items)=>{
    return items.map((item, index)=>$866f0e1daf5bd577$var$getItemData(item, index));
};

});
parcelRegister("7Xf9k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42c245ec8a5b0fa184f110b30fb6ce93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ca9cb73d345844f$var$_react = $5ca9cb73d345844f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5ca9cb73d345844f$var$_baseNew = $5ca9cb73d345844f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5ca9cb73d345844f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DividerElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting divider elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ca9cb73d345844f$var$DividerElementIcon = (props)=>/*#__PURE__*/ $5ca9cb73d345844f$var$_react.default.createElement($5ca9cb73d345844f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 15v-2.5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2V15h1.5v-2.5A.5.5 0 0 1 4 12h8a.5.5 0 0 1 .5.5V15zm2-7.75H0v1.5h16zM2 3.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V1h-1.5v2.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V1H2z" clip-rule="evenodd"/>`
    }, props));
$5ca9cb73d345844f$var$DividerElementIcon.displayName = 'DividerElementIcon';
var $5ca9cb73d345844f$var$_default = module.exports.default = $5ca9cb73d345844f$var$DividerElementIcon;

});

parcelRegister("6TPL7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a282fcec9b1cefd6b5b937a5b07c1f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50600767480aaa35$var$_react = $50600767480aaa35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $50600767480aaa35$var$_baseNew = $50600767480aaa35$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $50600767480aaa35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50600767480aaa35$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $50600767480aaa35$var$_react.default.createElement($50600767480aaa35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$50600767480aaa35$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $50600767480aaa35$var$_default = module.exports.default = $50600767480aaa35$var$ExpandElementIcon;

});

parcelRegister("cgRoK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3dcba78c5e5642b8396cd93a41d6ef1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ef0666e0cb275e1$var$_react = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8ef0666e0cb275e1$var$_baseNew = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8ef0666e0cb275e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ef0666e0cb275e1$var$LozengeIcon = (props)=>/*#__PURE__*/ $8ef0666e0cb275e1$var$_react.default.createElement($8ef0666e0cb275e1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$8ef0666e0cb275e1$var$LozengeIcon.displayName = 'LozengeIcon';
var $8ef0666e0cb275e1$var$_default = module.exports.default = $8ef0666e0cb275e1$var$LozengeIcon;

});

parcelRegister("8HSNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $656cd9546d343d79$var$_react = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $656cd9546d343d79$var$_baseNew = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $656cd9546d343d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $656cd9546d343d79$var$DecisionIcon = (props)=>/*#__PURE__*/ $656cd9546d343d79$var$_react.default.createElement($656cd9546d343d79$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$656cd9546d343d79$var$DecisionIcon.displayName = 'DecisionIcon';
var $656cd9546d343d79$var$_default = module.exports.default = $656cd9546d343d79$var$DecisionIcon;

});

parcelRegister("cVLny", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $969f8f5da972f70f$var$_react = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $969f8f5da972f70f$var$_baseNew = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $969f8f5da972f70f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $969f8f5da972f70f$var$EmojiIcon = (props)=>/*#__PURE__*/ $969f8f5da972f70f$var$_react.default.createElement($969f8f5da972f70f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$969f8f5da972f70f$var$EmojiIcon.displayName = 'EmojiIcon';
var $969f8f5da972f70f$var$_default = module.exports.default = $969f8f5da972f70f$var$EmojiIcon;

});

parcelRegister("dgJHC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7b5804889990b150be57e7707dfe0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a903891a1134335$var$_react = $9a903891a1134335$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a903891a1134335$var$_baseNew = $9a903891a1134335$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9a903891a1134335$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a903891a1134335$var$GridIcon = (props)=>/*#__PURE__*/ $9a903891a1134335$var$_react.default.createElement($9a903891a1134335$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$9a903891a1134335$var$GridIcon.displayName = 'GridIcon';
var $9a903891a1134335$var$_default = module.exports.default = $9a903891a1134335$var$GridIcon;

});

parcelRegister("fhbwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de6761c1e7b45c04cd65fb74ac2d27eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1f160f6235a0c00$var$_react = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b1f160f6235a0c00$var$_baseNew = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b1f160f6235a0c00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1f160f6235a0c00$var$ImageIcon = (props)=>/*#__PURE__*/ $b1f160f6235a0c00$var$_react.default.createElement($b1f160f6235a0c00$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.647l5.775-6.978a.75.75 0 0 1 1.092-.068l2.986 2.81V3a.5.5 0 0 0-.5-.5zm10.5 8.824-3.432-3.23L5.594 13.5H13a.5.5 0 0 0 .5-.5zM4 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0" clip-rule="evenodd"/>`
    }, props));
$b1f160f6235a0c00$var$ImageIcon.displayName = 'ImageIcon';
var $b1f160f6235a0c00$var$_default = module.exports.default = $b1f160f6235a0c00$var$ImageIcon;

});

parcelRegister("9e98Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b7c83a53e38e447$var$_react = $6b7c83a53e38e447$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6b7c83a53e38e447$var$_baseNew = $6b7c83a53e38e447$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6b7c83a53e38e447$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b7c83a53e38e447$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $6b7c83a53e38e447$var$_react.default.createElement($6b7c83a53e38e447$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$6b7c83a53e38e447$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $6b7c83a53e38e447$var$_default = module.exports.default = $6b7c83a53e38e447$var$InformationCircleIcon;

});

parcelRegister("bh6Q5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455753a667f20f1d7529d077b0a47e9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8356965a09dcfb04$var$_react = $8356965a09dcfb04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8356965a09dcfb04$var$_baseNew = $8356965a09dcfb04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8356965a09dcfb04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8356965a09dcfb04$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $8356965a09dcfb04$var$_react.default.createElement($8356965a09dcfb04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$8356965a09dcfb04$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $8356965a09dcfb04$var$_default = module.exports.default = $8356965a09dcfb04$var$LayoutThreeColumnsIcon;

});

parcelRegister("aiLjp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d7f4cbe44d53d27d30976de2191c923>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780049045b006d7f$var$_react = $780049045b006d7f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780049045b006d7f$var$_baseNew = $780049045b006d7f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $780049045b006d7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780049045b006d7f$var$VideoIcon = (props)=>/*#__PURE__*/ $780049045b006d7f$var$_react.default.createElement($780049045b006d7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$780049045b006d7f$var$VideoIcon.displayName = 'VideoIcon';
var $780049045b006d7f$var$_default = module.exports.default = $780049045b006d7f$var$VideoIcon;

});


parcelRegister("8TaEl", function(module, exports) {

$parcel$export(module.exports, "find", () => $f4f493143bf1264b$export$71aa6c912b956294);

var $3W2qa = parcelRequire("3W2qa");
// Copied from platform/packages/editor/editor-common/src/quick-insert/utils.ts
const $f4f493143bf1264b$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'priority',
            weight: 0.3
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
// If an item has an id, it is a native editor element
// for the demo we could also use item.shouldDisplayAtTop (can potentially be
// replaced by item.isEditorExtention or something similar).
// For now, let's test search usring id as it is closer to production implementation.
const $f4f493143bf1264b$var$prioritySortingFn = (items)=>{
    return (a, b)=>{
        if (items[a.idx].id && items[b.idx].id) return a.score - b.score;
        else if (items[a.idx].id) return -1;
        else return 1;
    };
};
function $f4f493143bf1264b$export$71aa6c912b956294(query, items) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$f4f493143bf1264b$var$options,
        sortFn: $f4f493143bf1264b$var$prioritySortingFn(items)
    };
    const fuse = new (0, $3W2qa.default)(items, fuseOptions);
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("3W2qa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd8aaa87a991518$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $2dd8aaa87a991518$var$isArray(value) {
    return !Array.isArray ? $2dd8aaa87a991518$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $2dd8aaa87a991518$var$INFINITY = 1 / 0;
function $2dd8aaa87a991518$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$2dd8aaa87a991518$var$INFINITY ? '-0' : result;
}
function $2dd8aaa87a991518$var$toString(value) {
    return value == null ? '' : $2dd8aaa87a991518$var$baseToString(value);
}
function $2dd8aaa87a991518$var$isString(value) {
    return typeof value === 'string';
}
function $2dd8aaa87a991518$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $2dd8aaa87a991518$var$isBoolean(value) {
    return value === true || value === false || $2dd8aaa87a991518$var$isObjectLike(value) && $2dd8aaa87a991518$var$getTag(value) == '[object Boolean]';
}
function $2dd8aaa87a991518$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $2dd8aaa87a991518$var$isObjectLike(value) {
    return $2dd8aaa87a991518$var$isObject(value) && value !== null;
}
function $2dd8aaa87a991518$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $2dd8aaa87a991518$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $2dd8aaa87a991518$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $2dd8aaa87a991518$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $2dd8aaa87a991518$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $2dd8aaa87a991518$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $2dd8aaa87a991518$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $2dd8aaa87a991518$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $2dd8aaa87a991518$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $2dd8aaa87a991518$var$hasOwn = Object.prototype.hasOwnProperty;
class $2dd8aaa87a991518$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $2dd8aaa87a991518$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $2dd8aaa87a991518$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($2dd8aaa87a991518$var$isString(key) || $2dd8aaa87a991518$var$isArray(key)) {
        src = key;
        path = $2dd8aaa87a991518$var$createKeyPath(key);
        id = $2dd8aaa87a991518$var$createKeyId(key);
    } else {
        if (!$2dd8aaa87a991518$var$hasOwn.call(key, 'name')) throw new Error($2dd8aaa87a991518$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($2dd8aaa87a991518$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($2dd8aaa87a991518$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $2dd8aaa87a991518$var$createKeyPath(name);
        id = $2dd8aaa87a991518$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $2dd8aaa87a991518$var$createKeyPath(key) {
    return $2dd8aaa87a991518$var$isArray(key) ? key : key.split('.');
}
function $2dd8aaa87a991518$var$createKeyId(key) {
    return $2dd8aaa87a991518$var$isArray(key) ? key.join('.') : key;
}
function $2dd8aaa87a991518$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$2dd8aaa87a991518$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$2dd8aaa87a991518$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($2dd8aaa87a991518$var$isString(value) || $2dd8aaa87a991518$var$isNumber(value) || $2dd8aaa87a991518$var$isBoolean(value))) list.push($2dd8aaa87a991518$var$toString(value));
            else if ($2dd8aaa87a991518$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $2dd8aaa87a991518$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $2dd8aaa87a991518$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $2dd8aaa87a991518$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $2dd8aaa87a991518$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $2dd8aaa87a991518$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $2dd8aaa87a991518$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $2dd8aaa87a991518$var$Config = {
    ...$2dd8aaa87a991518$var$BasicOptions,
    ...$2dd8aaa87a991518$var$MatchOptions,
    ...$2dd8aaa87a991518$var$FuzzyOptions,
    ...$2dd8aaa87a991518$var$AdvancedOptions
};
const $2dd8aaa87a991518$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $2dd8aaa87a991518$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($2dd8aaa87a991518$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $2dd8aaa87a991518$var$FuseIndex {
    constructor({ getFn: getFn = $2dd8aaa87a991518$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2dd8aaa87a991518$var$Config.fieldNormWeight } = {}){
        this.norm = $2dd8aaa87a991518$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($2dd8aaa87a991518$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($2dd8aaa87a991518$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$2dd8aaa87a991518$var$isDefined(doc) || $2dd8aaa87a991518$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$2dd8aaa87a991518$var$isDefined(value)) return;
            if ($2dd8aaa87a991518$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$2dd8aaa87a991518$var$isDefined(value)) continue;
                    if ($2dd8aaa87a991518$var$isString(value) && !$2dd8aaa87a991518$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($2dd8aaa87a991518$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($2dd8aaa87a991518$var$isString(value) && !$2dd8aaa87a991518$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $2dd8aaa87a991518$var$createIndex(keys, docs, { getFn: getFn = $2dd8aaa87a991518$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2dd8aaa87a991518$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $2dd8aaa87a991518$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($2dd8aaa87a991518$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $2dd8aaa87a991518$var$parseIndex(data, { getFn: getFn = $2dd8aaa87a991518$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2dd8aaa87a991518$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $2dd8aaa87a991518$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $2dd8aaa87a991518$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $2dd8aaa87a991518$var$Config.distance, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $2dd8aaa87a991518$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $2dd8aaa87a991518$var$MAX_BITS = 32;
function $2dd8aaa87a991518$var$search(text, pattern, patternAlphabet, { location: location = $2dd8aaa87a991518$var$Config.location, distance: distance = $2dd8aaa87a991518$var$Config.distance, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $2dd8aaa87a991518$var$MAX_BITS) throw new Error($2dd8aaa87a991518$var$PATTERN_LENGTH_TOO_LARGE($2dd8aaa87a991518$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $2dd8aaa87a991518$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $2dd8aaa87a991518$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $2dd8aaa87a991518$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $2dd8aaa87a991518$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $2dd8aaa87a991518$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $2dd8aaa87a991518$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $2dd8aaa87a991518$var$BitapSearch {
    constructor(pattern, { location: location = $2dd8aaa87a991518$var$Config.location, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, distance: distance = $2dd8aaa87a991518$var$Config.distance, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2dd8aaa87a991518$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $2dd8aaa87a991518$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $2dd8aaa87a991518$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $2dd8aaa87a991518$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $2dd8aaa87a991518$var$MAX_BITS), i);
                i += $2dd8aaa87a991518$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $2dd8aaa87a991518$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $2dd8aaa87a991518$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $2dd8aaa87a991518$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $2dd8aaa87a991518$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $2dd8aaa87a991518$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $2dd8aaa87a991518$var$ExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $2dd8aaa87a991518$var$InverseExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $2dd8aaa87a991518$var$PrefixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $2dd8aaa87a991518$var$InversePrefixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $2dd8aaa87a991518$var$SuffixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $2dd8aaa87a991518$var$InverseSuffixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $2dd8aaa87a991518$var$FuzzyMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern, { location: location = $2dd8aaa87a991518$var$Config.location, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, distance: distance = $2dd8aaa87a991518$var$Config.distance, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2dd8aaa87a991518$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $2dd8aaa87a991518$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $2dd8aaa87a991518$var$IncludeMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $2dd8aaa87a991518$var$searchers = [
    $2dd8aaa87a991518$var$ExactMatch,
    $2dd8aaa87a991518$var$IncludeMatch,
    $2dd8aaa87a991518$var$PrefixExactMatch,
    $2dd8aaa87a991518$var$InversePrefixExactMatch,
    $2dd8aaa87a991518$var$InverseSuffixExactMatch,
    $2dd8aaa87a991518$var$SuffixExactMatch,
    $2dd8aaa87a991518$var$InverseExactMatch,
    $2dd8aaa87a991518$var$FuzzyMatch
];
const $2dd8aaa87a991518$var$searchersLen = $2dd8aaa87a991518$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $2dd8aaa87a991518$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $2dd8aaa87a991518$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $2dd8aaa87a991518$var$parseQuery(pattern, options = {}) {
    return pattern.split($2dd8aaa87a991518$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($2dd8aaa87a991518$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $2dd8aaa87a991518$var$searchersLen){
                const searcher = $2dd8aaa87a991518$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $2dd8aaa87a991518$var$searchersLen){
                const searcher = $2dd8aaa87a991518$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $2dd8aaa87a991518$var$MultiMatchSet = new Set([
    $2dd8aaa87a991518$var$FuzzyMatch.type,
    $2dd8aaa87a991518$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $2dd8aaa87a991518$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $2dd8aaa87a991518$var$Config.isCaseSensitive, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, location: location = $2dd8aaa87a991518$var$Config.location, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, distance: distance = $2dd8aaa87a991518$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $2dd8aaa87a991518$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($2dd8aaa87a991518$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $2dd8aaa87a991518$var$registeredSearchers = [];
function $2dd8aaa87a991518$var$register(...args) {
    $2dd8aaa87a991518$var$registeredSearchers.push(...args);
}
function $2dd8aaa87a991518$var$createSearcher(pattern, options) {
    for(let i = 0, len = $2dd8aaa87a991518$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $2dd8aaa87a991518$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $2dd8aaa87a991518$var$BitapSearch(pattern, options);
}
const $2dd8aaa87a991518$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $2dd8aaa87a991518$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $2dd8aaa87a991518$var$isExpression = (query)=>!!(query[$2dd8aaa87a991518$var$LogicalOperator.AND] || query[$2dd8aaa87a991518$var$LogicalOperator.OR]);
const $2dd8aaa87a991518$var$isPath = (query)=>!!query[$2dd8aaa87a991518$var$KeyType.PATH];
const $2dd8aaa87a991518$var$isLeaf = (query)=>!$2dd8aaa87a991518$var$isArray(query) && $2dd8aaa87a991518$var$isObject(query) && !$2dd8aaa87a991518$var$isExpression(query);
const $2dd8aaa87a991518$var$convertToExplicit = (query)=>({
        [$2dd8aaa87a991518$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $2dd8aaa87a991518$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $2dd8aaa87a991518$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$2dd8aaa87a991518$var$isExpression(query)) return next($2dd8aaa87a991518$var$convertToExplicit(query));
        if ($2dd8aaa87a991518$var$isLeaf(query)) {
            const key = isQueryPath ? query[$2dd8aaa87a991518$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$2dd8aaa87a991518$var$KeyType.PATTERN] : query[key];
            if (!$2dd8aaa87a991518$var$isString(pattern)) throw new Error($2dd8aaa87a991518$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $2dd8aaa87a991518$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $2dd8aaa87a991518$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($2dd8aaa87a991518$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$2dd8aaa87a991518$var$isExpression(query)) query = $2dd8aaa87a991518$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $2dd8aaa87a991518$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $2dd8aaa87a991518$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $2dd8aaa87a991518$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$2dd8aaa87a991518$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$2dd8aaa87a991518$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $2dd8aaa87a991518$var$transformScore(result, data) {
    data.score = result.score;
}
function $2dd8aaa87a991518$var$format(results, docs, { includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, includeScore: includeScore = $2dd8aaa87a991518$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($2dd8aaa87a991518$var$transformMatches);
    if (includeScore) transformers.push($2dd8aaa87a991518$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $2dd8aaa87a991518$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$2dd8aaa87a991518$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $2dd8aaa87a991518$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $2dd8aaa87a991518$var$FuseIndex)) throw new Error($2dd8aaa87a991518$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $2dd8aaa87a991518$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$2dd8aaa87a991518$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $2dd8aaa87a991518$var$isString(query) ? $2dd8aaa87a991518$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $2dd8aaa87a991518$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($2dd8aaa87a991518$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $2dd8aaa87a991518$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $2dd8aaa87a991518$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2dd8aaa87a991518$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $2dd8aaa87a991518$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $2dd8aaa87a991518$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($2dd8aaa87a991518$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $2dd8aaa87a991518$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$2dd8aaa87a991518$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$2dd8aaa87a991518$var$isDefined(value)) return [];
        let matches = [];
        if ($2dd8aaa87a991518$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2dd8aaa87a991518$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$2dd8aaa87a991518$export$2e2bcd8739ae039.version = '6.6.2';
$2dd8aaa87a991518$export$2e2bcd8739ae039.createIndex = $2dd8aaa87a991518$var$createIndex;
$2dd8aaa87a991518$export$2e2bcd8739ae039.parseIndex = $2dd8aaa87a991518$var$parseIndex;
$2dd8aaa87a991518$export$2e2bcd8739ae039.config = $2dd8aaa87a991518$var$Config;
$2dd8aaa87a991518$export$2e2bcd8739ae039.parseQuery = $2dd8aaa87a991518$var$parse;
$2dd8aaa87a991518$var$register($2dd8aaa87a991518$var$ExtendedSearch);

});



parcelRegister("74NcZ", function(module, exports) {

$parcel$export(module.exports, "ListButtonGroupWithHeading", () => $ab159540455f820a$export$3f355796bb73d7b);
$parcel$export(module.exports, "ListButtonGroup", () => $ab159540455f820a$export$645edeb616ed3f65);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bOqDA = parcelRequire("bOqDA");
const $ab159540455f820a$var$headingContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $ab159540455f820a$var$itemsContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $ab159540455f820a$var$ListButtonGroupBase = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $ab159540455f820a$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $ab159540455f820a$var$itemsContainerStyles
                ],
                children: items.map((item, index)=>{
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ListButtonItem), {
                        index: item.index,
                        isSelected: startingIndex === undefined ? undefined : startingIndex + index === 0,
                        title: item.title,
                        description: item.description,
                        showDescription: item.showDescription,
                        attributes: item.attributes,
                        keyshortcut: item.keyshortcut,
                        renderIcon: item.renderIcon,
                        onItemSelected: (index)=>onItemSelected?.(index, id),
                        setSelectedItem: setSelectedItem
                    }, item.index);
                })
            })
        ]
    });
});
const $ab159540455f820a$export$3f355796bb73d7b = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ab159540455f820a$var$ListButtonGroupBase, {
        id: id,
        label: label,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});
const $ab159540455f820a$export$645edeb616ed3f65 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ab159540455f820a$var$ListButtonGroupBase, {
        id: id,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});

});
parcelRegister("bOqDA", function(module, exports) {

$parcel$export(module.exports, "ListButtonItem", () => $f6e09b587e792d34$export$74006863e39733dc);
$parcel$export(module.exports, "ViewAllButtonItem", () => $f6e09b587e792d34$export$5beeafc8353ee1ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e9qoo = parcelRequire("e9qoo");

var $3dGN0 = parcelRequire("3dGN0");

var $3u0c5 = parcelRequire("3u0c5");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $8Syuu = parcelRequire("8Syuu");
const $f6e09b587e792d34$var$shortcutStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius',
    borderStyle: 'none'
});
const $f6e09b587e792d34$var$selectedColorStyles = (0, $8CUq3.xcss)({
    color: 'color.text.selected'
});
const $f6e09b587e792d34$var$disabledShortcutStyles = (0, $8CUq3.xcss)({
    color: 'color.text.disabled',
    backgroundColor: 'color.background.disabled'
});
const $f6e09b587e792d34$var$viewAllStyles = (0, $8CUq3.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    position: 'sticky',
    bottom: '-4px',
    width: '100%',
    height: '40px',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $f6e09b587e792d34$var$ListButtonItemBase = /*#__PURE__*/ (0, $5uXOq.memo)(({ index: index, title: title, description: description, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, showDescription: showDescription = false, renderContent: renderContent, renderIcon: renderIcon, renderElementAfter: renderElementAfter, onItemSelected: onItemSelected })=>{
    const beforeElement = (0, $5uXOq.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Syuu.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    const afterElement = (0, $5uXOq.useMemo)(()=>renderElementAfter?.(), [
        renderElementAfter
    ]);
    const content = (0, $5uXOq.useMemo)(()=>renderContent?.(), [
        renderContent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
                ...tooltipProps,
                iconBefore: beforeElement,
                iconAfter: afterElement,
                description: showDescription ? description : undefined,
                shouldDescriptionWrap: true,
                isSelected: isSelected,
                isDisabled: isDisabled,
                onClick: ()=>onItemSelected?.(index),
                children: content
            })
    });
});
const $f6e09b587e792d34$export$74006863e39733dc = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, attributes: attributes, title: title, setSelectedItem: setSelectedItem, index: index } = props;
    const shortcutComponent = (0, $5uXOq.useCallback)(()=>{
        const shortcut = keyshortcut && (0, $e9qoo.formatShortcut)(keyshortcut);
        if (!shortcut) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            paddingInline: "space.025",
            paddingBlock: "space.025",
            xcss: [
                $f6e09b587e792d34$var$shortcutStyles,
                isSelected && $f6e09b587e792d34$var$selectedColorStyles,
                isDisabled && $f6e09b587e792d34$var$disabledShortcutStyles
            ],
            children: shortcut
        });
    }, [
        isDisabled,
        isSelected,
        keyshortcut
    ]);
    const contentComponent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    children: title
                }),
                attributes?.new && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                    appearance: "new",
                    children: "New"
                })
            ]
        });
    }, [
        attributes?.new,
        title
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected) setSelectedItem?.({
            index: index
        });
    }, [
        isSelected,
        setSelectedItem,
        index
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f6e09b587e792d34$var$ListButtonItemBase, {
        ...props,
        renderContent: contentComponent,
        renderElementAfter: shortcutComponent
    });
});
const $f6e09b587e792d34$export$5beeafc8353ee1ed = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick, isViewAllInserts: isViewAllInserts = false })=>{
    const contentComponent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: 'color.text.selected',
                    children: label
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    xcss: [
                        $f6e09b587e792d34$var$selectedColorStyles
                    ],
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: label
                    })
                })
            ]
        });
    }, [
        label
    ]);
    return isViewAllInserts ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $f6e09b587e792d34$var$viewAllStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f6e09b587e792d34$var$ListButtonItemBase, {
            index: -1,
            title: label,
            onItemSelected: onClick,
            renderContent: contentComponent,
            isViewAll: true
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($f6e09b587e792d34$var$ListButtonItemBase, {
        index: -1,
        title: label,
        onItemSelected: onClick,
        renderContent: contentComponent
    });
});

});
parcelRegister("8Syuu", function(module, exports) {

$parcel$export(module.exports, "IconRenderer", () => $e575111e40c4d04b$export$32ff197eed95e568);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $e575111e40c4d04b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e575111e40c4d04b$var$iconWrapperStyles = {
    name: "e42xni",
    styles: "max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);div{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}span{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}"
};
const $e575111e40c4d04b$export$32ff197eed95e568 = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $e575111e40c4d04b$var$iconWrapperStyles
        ]
    }, children);
});

});



parcelRegister("IV5RJ", function(module, exports) {

$parcel$export(module.exports, "LinkNavButton", () => $7dca3a901b769ca2$export$98ce6410d0ba022);
$parcel$export(module.exports, "ExpandableNavButton", () => $7dca3a901b769ca2$export$6f3d5e896fa382de);
$parcel$export(module.exports, "BackNavButton", () => $7dca3a901b769ca2$export$b83dc6f7d9624732);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $ctqwA = parcelRequire("ctqwA");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $jj3Gi = parcelRequire("jj3Gi");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");
const $7dca3a901b769ca2$var$buttonStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: 'auto',
    minHeight: 'space.400',
    width: '100%',
    paddingBlock: 'space.075',
    paddingInline: 'space.100',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $7dca3a901b769ca2$var$selectedButtonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $7dca3a901b769ca2$var$disabledButtonStyles = (0, $8CUq3.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $7dca3a901b769ca2$var$headingContainerStyles = (0, $8CUq3.xcss)({
    textAlign: 'left',
    color: 'color.text.accent.orange'
});
const $7dca3a901b769ca2$var$ButtonBase = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, mode: mode, label: label, isSelected: isSelected, isDisabled: isDisabled, isExpanded: isExpanded, attributes: attributes, onClick: onClick })=>{
    const iconComponent = (0, $5uXOq.useMemo)(()=>{
        let Icon;
        let iconLabel;
        switch(mode){
            case 'expandable':
                Icon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jj3Gi))) : (0, (/*@__PURE__*/$parcel$interopDefault($hORKG)));
                iconLabel = isExpanded ? `Collapse ${label} inserts` : `Expand ${label} inserts`;
                break;
            default:
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0)));
                iconLabel = `View all ${label} inserts`;
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: iconLabel
        });
    }, [
        isExpanded,
        label,
        mode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
                ...tooltipProps,
                type: "button",
                isDisabled: isDisabled,
                onClick: ()=>onClick?.(id),
                xcss: [
                    $7dca3a901b769ca2$var$buttonStyles,
                    isSelected && $7dca3a901b769ca2$var$selectedButtonStyles,
                    isDisabled && $7dca3a901b769ca2$var$disabledButtonStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: 'space.100',
                    grow: "fill",
                    shouldWrap: false,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                            alignBlock: "center",
                            space: "space.100",
                            shouldWrap: false,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                    xcss: $7dca3a901b769ca2$var$headingContainerStyles,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                                        size: 'xsmall',
                                        as: "span",
                                        children: label
                                    })
                                }),
                                attributes?.new && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                                        appearance: "new",
                                        children: "New"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                            children: iconComponent
                        })
                    ]
                })
            })
    });
});
const $7dca3a901b769ca2$export$98ce6410d0ba022 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)($7dca3a901b769ca2$var$ButtonBase, {
        mode: "navigation",
        ...props
    }));
const $7dca3a901b769ca2$export$6f3d5e896fa382de = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)($7dca3a901b769ca2$var$ButtonBase, {
        mode: "expandable",
        ...props
    }));
const $7dca3a901b769ca2$export$b83dc6f7d9624732 = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                ...tooltipProps,
                label: label,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctqwA))),
                appearance: "subtle",
                spacing: "compact",
                onClick: onClick
            })
    });
});

});

parcelRegister("77Kxe", function(module, exports) {

$parcel$export(module.exports, "SubPanelWithBackButton", () => $26cc178212916a97$export$bc997d97789f130b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $IV5RJ = parcelRequire("IV5RJ");
const $26cc178212916a97$var$itemContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.025',
    paddingLeft: 'space.250',
    paddingRight: 'space.250'
});
const $26cc178212916a97$export$bc997d97789f130b = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, buttonLabel: buttonLabel, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.0",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                alignBlock: "center",
                alignInline: "start",
                space: 'space.050',
                xcss: $26cc178212916a97$var$itemContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IV5RJ.BackNavButton), {
                        onClick: onClick,
                        label: buttonLabel
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: 'xsmall',
                        as: "span",
                        children: label
                    })
                ]
            }),
            children
        ]
    });
});

});


parcelRegister("5NQrW", function(module, exports) {

$parcel$export(module.exports, "SideInsertPanel", () => $bf681e382b325fc0$export$dfdc13f605e27090);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $414Wj = parcelRequire("414Wj");

var $gIDRO = parcelRequire("gIDRO");

var $dTvsq = parcelRequire("dTvsq");

var $7vV9i = parcelRequire("7vV9i");

var $74NcZ = parcelRequire("74NcZ");

var $5q8nL = parcelRequire("5q8nL");

var $77Kxe = parcelRequire("77Kxe");
const $bf681e382b325fc0$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7vV9i.IconButtonGroup), {
                id: suggested.id,
                items: suggested.items,
                label: suggested.label,
                onItemSelected: onItemSelected
            }),
            (0, $gIDRO.CategoriesStructure).map((category, i)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                const shoudldShowSeparator = i === 0 && !suggested ? false : true;
                return items.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTvsq.ExpandablePanel), {
                    id: category.id,
                    label: category.title,
                    items: items,
                    hasSeparator: shoudldShowSeparator,
                    onItemSelected: onItemSelected,
                    onViewAllSelected: onCategorySelected
                }, category.id);
            })
        ]
    });
};
const $bf681e382b325fc0$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $gIDRO.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $77Kxe.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    return categoryRegistry[id] && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroupWithHeading), {
                        id: id,
                        label: title,
                        items: categoryRegistry[id],
                        onItemSelected: onItemSelected
                    });
                })
            ]
        })
    });
};
const $bf681e382b325fc0$var$SearchView = ({ items: items, onItemSelected: onItemSelected })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected
    });
};
const $bf681e382b325fc0$export$dfdc13f605e27090 = ({ items: items, onItemInsert: onItemInsert })=>{
    const onItemSelect = (0, $5uXOq.useCallback)((index)=>{
        onItemInsert((0, $3UtTx.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSearchText: setSearchText, setSelectedCategory: setSelectedCategory } = (0, $gIDRO.useItems)(items);
    const view = searchItems ? /*#__PURE__*/ (0, $2OMIu.jsx)($bf681e382b325fc0$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect
    }) : selectedCategory ? /*#__PURE__*/ (0, $2OMIu.jsx)($bf681e382b325fc0$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($bf681e382b325fc0$var$DefaultView, {
        suggested: undefined,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5q8nL.SearchPanel), {
                onChange: (event)=>{
                    setSearchText(event.target.value);
                }
            }),
            view
        ]
    });
};

});
parcelRegister("dTvsq", function(module, exports) {

$parcel$export(module.exports, "ExpandablePanel", () => $517071ce1990def3$export$dbf21a0adc6a9ee0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $bOqDA = parcelRequire("bOqDA");

var $IV5RJ = parcelRequire("IV5RJ");
const $517071ce1990def3$var$headingContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $517071ce1990def3$var$itemsContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $517071ce1990def3$export$dbf21a0adc6a9ee0 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, attributes: attributes, onItemSelected: onItemSelected, onViewAllSelected: onViewAllSelected })=>{
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
    // Dirty fix for AI label
    const shortAIlabel = label === 'Atlassian Intelligence';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $517071ce1990def3$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IV5RJ.ExpandableNavButton), {
                    id: id,
                    label: label,
                    isExpanded: isExpanded,
                    attributes: attributes,
                    onClick: ()=>setIsExpanded(!isExpanded)
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                space: "space.025",
                xcss: [
                    $517071ce1990def3$var$itemsContainerStyles
                ],
                children: [
                    items.map((item)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ListButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ViewAllButtonItem), {
                        label: `View all ${shortAIlabel ? 'AI' : label.toLocaleLowerCase()} options`,
                        onClick: ()=>onViewAllSelected?.(id)
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("7vV9i", function(module, exports) {

$parcel$export(module.exports, "IconButtonGroup", () => $d0a08a6eece6fc8b$export$62ad8bbf2c8664a6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $602FZ = parcelRequire("602FZ");
const $d0a08a6eece6fc8b$var$headingContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $d0a08a6eece6fc8b$var$buttonsContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $d0a08a6eece6fc8b$export$62ad8bbf2c8664a6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $d0a08a6eece6fc8b$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $d0a08a6eece6fc8b$var$buttonsContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: "space.050",
                    rowSpace: "space.150",
                    grow: "fill",
                    shouldWrap: true,
                    children: items.map((item)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $602FZ.IconButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    })
                })
            })
        ]
    }));
});

});
parcelRegister("602FZ", function(module, exports) {

$parcel$export(module.exports, "IconButtonItem", () => $08622a063e1a0721$export$b2bea3403fa20e61);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e9qoo = parcelRequire("e9qoo");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $8Syuu = parcelRequire("8Syuu");
const $08622a063e1a0721$var$WIDTH = '60px';
const $08622a063e1a0721$var$largeButtonStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: `${$08622a063e1a0721$var$WIDTH}`,
    width: `${$08622a063e1a0721$var$WIDTH}`,
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    '::after': {
        position: 'absolute',
        inset: 'space.0',
        content: '""',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        borderColor: 'color.border',
        pointerEvents: 'none'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $08622a063e1a0721$var$selectedButtonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $08622a063e1a0721$var$disabledButtonStyles = (0, $8CUq3.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $08622a063e1a0721$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
const $08622a063e1a0721$var$textStyles = (0, $8CUq3.xcss)({
    width: `${$08622a063e1a0721$var$WIDTH}`
});
const $08622a063e1a0721$var$LargeIconButtonWithRef = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ icon: icon, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
        ...rest,
        ref: ref,
        type: "button",
        isDisabled: isDisabled,
        onClick: onClick,
        xcss: [
            $08622a063e1a0721$var$largeButtonStyles,
            isSelected && $08622a063e1a0721$var$selectedButtonStyles,
            isDisabled && $08622a063e1a0721$var$disabledButtonStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            as: "span",
            xcss: $08622a063e1a0721$var$iconStyles,
            children: icon
        })
    });
}));
const $08622a063e1a0721$export$b2bea3403fa20e61 = /*#__PURE__*/ (0, $5uXOq.memo)(({ index: index, title: title, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, renderIcon: renderIcon, onItemSelected: onItemSelected })=>{
    const iconComponent = (0, $5uXOq.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Syuu.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($08622a063e1a0721$var$LargeIconButtonWithRef, {
                        ...tooltipProps,
                        icon: iconComponent,
                        isSelected: isSelected,
                        isDisabled: isDisabled,
                        onClick: ()=>onItemSelected?.(index)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $08622a063e1a0721$var$textStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                            align: "center",
                            maxLines: 1,
                            color: isDisabled ? 'color.text.disabled' : isSelected ? 'color.text.selected' : 'color.text.subtle',
                            size: "small",
                            children: title
                        })
                    })
                ]
            })
    });
});

});


parcelRegister("5q8nL", function(module, exports) {

$parcel$export(module.exports, "SearchPanel", () => $437ff3f6ed62ba4a$export$ea47151d20780fe9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");
const $437ff3f6ed62ba4a$var$searchPanelStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $437ff3f6ed62ba4a$var$searchIconStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0'
});
const $437ff3f6ed62ba4a$export$ea47151d20780fe9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onChange: onChange })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            $437ff3f6ed62ba4a$var$searchPanelStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
            name: "search",
            id: "search-textfield",
            placeholder: "Find or describe...",
            elemBeforeInput: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $437ff3f6ed62ba4a$var$searchIconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
                    label: "search",
                    color: "var(--ds-text-subtlest, #626F86)"
                })
            }),
            onChange: onChange
        })
    });
});

});


parcelRegister("cDzXZ", function(module, exports) {

$parcel$export(module.exports, "TypeAheadErrorFallback", () => $484e2e2b6b626403$export$71ea07f9d4f4ab38);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $8ptyJ = parcelRequire("8ptyJ");

var $km5PY = parcelRequire("km5PY");

var $7KF6U = parcelRequire("7KF6U");
function $484e2e2b6b626403$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $484e2e2b6b626403$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $484e2e2b6b626403$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $koVbs.default)();
    const header = intl.formatMessage((0, $8ptyJ.typeAheadListMessages).offlineErrorFallbackHeading);
    const description = intl.formatMessage((0, $8ptyJ.typeAheadListMessages).offlineErrorFallbackDesc);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": "mentions-typeahead-error-boundary-ui",
        css: $484e2e2b6b626403$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $km5PY.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7KF6U.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("km5PY", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $e721e83561737f1e$export$fddf379e22a74b00);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $e721e83561737f1e$var$containerStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $e721e83561737f1e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        xcss: $e721e83561737f1e$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7KF6U", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $bb53bd6e46954378$export$e54420a1a27457a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $bb53bd6e46954378$var$HEIGHT = 90;
const $bb53bd6e46954378$var$genericErrorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `${$bb53bd6e46954378$var$HEIGHT}px`,
    display: 'block'
});
const $bb53bd6e46954378$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $bb53bd6e46954378$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("defs", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};

});




parcelRegister("gw7Nh", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $cc7eb8bda80979f8$export$b11addef9209139);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $gmhCD = parcelRequire("gmhCD");

var $bmkwl = parcelRequire("bmkwl");

var $ihi8h = parcelRequire("ihi8h");

var $inLlw = parcelRequire("inLlw");
const $cc7eb8bda80979f8$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, selectedIndex: selectedIndex, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $ihi8h.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $bmkwl.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((mode = (0, $3UtTx.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $3UtTx.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const showViewMore = triggerHandler?.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT && !!openElementBrowserModal && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1');
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !showViewMore && items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $inLlw.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showViewMore: showViewMore
    });
});

});
parcelRegister("inLlw", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $8352663f3ec19656$export$fbc0702507873a7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7nRxN = parcelRequire("7nRxN");

var $gkwXh = parcelRequire("gkwXh");

var $awTmI = parcelRequire("awTmI");

var $3UtTx = parcelRequire("3UtTx");

var $f3dKD = parcelRequire("f3dKD");
var $4N9VB = parcelRequire("4N9VB");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");


var $gmhCD = parcelRequire("gmhCD");

var $6tlgz = parcelRequire("6tlgz");

var $5Vwh8 = parcelRequire("5Vwh8");

var $8oQ7W = parcelRequire("8oQ7W");

var $iiwBk = parcelRequire("iiwBk");

var $cDzXZ = parcelRequire("cDzXZ");

var $5tYDm = parcelRequire("5tYDm");
function $8352663f3ec19656$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $8352663f3ec19656$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $8352663f3ec19656$var$ITEM_PADDING = 12;
const $8352663f3ec19656$var$typeAheadContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $8352663f3ec19656$var$typeAheadContentOverride = /*#__PURE__*/ (0, $f8Sb3.css)({
    maxHeight: `${$8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $8352663f3ec19656$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $8352663f3ec19656$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $8352663f3ec19656$var$OFFSET = [
    0,
    8
];
const $8352663f3ec19656$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showViewMore: showViewMore } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const { featureFlagsState: featureFlagsState } = (0, $awTmI.useSharedPluginState)(api, [
        'featureFlags'
    ]);
    const moreElementsInQuickInsertViewEnabled = featureFlagsState?.moreElementsInQuickInsertView && triggerHandler.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsPatch2Enabled = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_2');
    const defaultMenuHeight = (0, $5uXOq.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $5uXOq.useRef)({
        inputMethod: null,
        closeAction: null
    });
    const startTime = (0, $5uXOq.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $5uXOq.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).RENDERED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).VIEWED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $5uXOq.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $5uXOq.useMemo)(()=>{
        if (showViewMore) return fitHeight - $8352663f3ec19656$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showViewMore
    ]);
    const getFitHeight = (0, $5uXOq.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $8352663f3ec19656$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $7nRxN.default)(getFitHeight);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $f3dKD.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            if ((0, $VSDnB.fg)('platform_editor_legacy_content_macro_typeahead_fix')) {
                // Check if new focus point is inside the current editor. If it is not we
                // want to close the typeahead popup regardless of text selection state
                const currentFocus = window.getSelection()?.focusNode; // the focusNode is either TextNode, ElementNode
                // if currentFocus is not HTMLElement, take its parent node as focusNode
                const focusNode = currentFocus instanceof HTMLElement ? currentFocus : currentFocus?.parentNode;
                if (focusNode instanceof HTMLElement) {
                    const innerEditor = focusNode.closest('.extension-editable-area');
                    if (innerEditor) {
                        // When there is no related target, we default to not closing the popup
                        let newFocusInsideCurrentEditor = !relatedTarget;
                        if (relatedTarget instanceof HTMLElement) {
                            if (innerEditor) // check if the new focus is inside inner editor, keep popup opens
                            newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                            else // if the new focus contains current focus node, the popup won't close
                            newFocusInsideCurrentEditor = relatedTarget.contains(focusNode);
                        }
                        if (!isTextSelected && newFocusInsideCurrentEditor) return;
                    } else {
                        // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                        if (!isTextSelected) return;
                    }
                }
            } else {
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') cancel({
                addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: true
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const close = (editorView)=>{
        const { state: { tr: tr } } = editorView;
        (0, $5Vwh8.closeTypeAhead)(tr);
        editorView.dispatch(tr);
    };
    const onViewMoreClick = (0, $5uXOq.useCallback)(()=>{
        close(editorView);
        if (openElementBrowserModal && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) activityStateRef.current = {
            inputMethod: (0, $gkwXh.INPUT_METHOD).MOUSE,
            closeAction: (0, $gkwXh.ACTION).VIEW_MORE
        };
        // TODO: ED-26959 - when clean up, remove config in quick insert plugin
        // platform/packages/editor/editor-plugin-quick-insert/src/quickInsertPlugin.tsx (typeAhead.openElementBrowserModal)
        openElementBrowserModal?.();
    }, [
        editorView,
        openElementBrowserModal
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        zIndex: (0, $iHYdz.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $8352663f3ec19656$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $6tlgz.fireTypeAheadClosedAnalyticsEvent)(api, activityStateRef.current.closeAction, !isEmptyQuery, activityStateRef.current.inputMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $8352663f3ec19656$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $8352663f3ec19656$var$typeAheadContentOverride,
            showViewMore && $8352663f3ec19656$var$typeAheadWrapperWithViewMoreOverride
        ],
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cDzXZ.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($8352663f3ec19656$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5tYDm.TypeAheadList), {
        items: items,
        selectedIndex: selectedIndex,
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $gkwXh.ACTION).INSERTED
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showViewMore: showViewMore,
        onViewMoreClick: onViewMoreClick
    }))));
});
$8352663f3ec19656$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("5tYDm", function(module, exports) {

$parcel$export(module.exports, "TypeAheadList", () => $d72dfd0f40a0ed4b$export$81b66b5b19964713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");
var $koVbs = parcelRequire("koVbs");

var $7Pkjl = parcelRequire("7Pkjl");

var $aLlKO = parcelRequire("aLlKO");

var $gkwXh = parcelRequire("gkwXh");

var $2i4K4 = parcelRequire("2i4K4");

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $gFzVq = parcelRequire("gFzVq");

var $eZUJu = parcelRequire("eZUJu");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $bmkwl = parcelRequire("bmkwl");

var $8oQ7W = parcelRequire("8oQ7W");

var $iiwBk = parcelRequire("iiwBk");

var $96cc5 = parcelRequire("96cc5");

var $gIpUw = parcelRequire("gIpUw");

var $8PLnn = parcelRequire("8PLnn");
const $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $d72dfd0f40a0ed4b$var$LIST_WIDTH = 320;
const $d72dfd0f40a0ed4b$var$list = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
const $d72dfd0f40a0ed4b$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gFzVq.AssistiveText), {
        assistiveText: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
    });
});
const $d72dfd0f40a0ed4b$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ items: items, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showViewMore: showViewMore, onViewMoreClick: onViewMoreClick })=>{
    const listRef = (0, $5uXOq.useRef)();
    const listContainerRef = (0, $5uXOq.useRef)(null);
    const lastVisibleIndexes = (0, $5uXOq.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showViewMore ? items.length - 1 : items.length;
    const estimatedHeight = itemsLength * $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $5uXOq.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $5uXOq.useState)(new (0, $7Pkjl.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const onItemsRendered = (0, $5uXOq.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $5uXOq.useCallback)(()=>{
        //To reset the selected index
        (0, $bmkwl.updateSelectedIndex)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showViewMore && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showViewMore
    ]);
    const onMouseMove = (event, index)=>{
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === index) return;
        (0, $bmkwl.updateSelectedIndex)(index, api)(editorView.state, editorView.dispatch);
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showViewMore && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showViewMore
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setCache(new (0, $7Pkjl.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = showViewMore ? items.slice(0, -1) : items;
        const height = Math.min(itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        items,
        cache,
        fitHeight,
        showViewMore
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) switch(event.key){
                case 'ArrowDown':
                    selectNextItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'ArrowUp':
                    selectPreviousItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                // TODO: DTR-1401 - why is this calling item click when hitting tab? fix this in DTR-1401
                case 'Tab':
                    //Tab key quick inserts the selected item.
                    onItemClick((0, $3UtTx.SelectItemMode).TAB, selectedIndex, (0, $gkwXh.INPUT_METHOD).KEYBOARD);
                    event.preventDefault();
                    break;
                case 'Enter':
                    //Enter key quick inserts the selected item.
                    if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                        onItemClick(event.shiftKey ? (0, $3UtTx.SelectItemMode).SHIFT_ENTER : (0, $3UtTx.SelectItemMode).ENTER, selectedIndex, (0, $gkwXh.INPUT_METHOD).KEYBOARD);
                        event.preventDefault();
                    }
                    break;
                default:
                    event.preventDefault();
            }
            else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $5uXOq.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentItem = items[index];
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7Pkjl.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, (0, $VSDnB.fg)('platform_editor_typeahead_dynamic_height_fix') ? ({ measure: measure, registerChild: registerChild })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $96cc5.ListRow), {
                registerChild: registerChild,
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                onMouseMove: (e)=>onMouseMove(e, index)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gIpUw.TypeAheadListItem), {
                key: items[index].title,
                item: currentItem,
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: index,
                selectedIndex: selectedIndex,
                onItemClick: (mode, index)=>{
                    actions.onItemClick(mode, index, (0, $gkwXh.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $iiwBk.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api
            })) : /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            "data-index": index
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: (e)=>onMouseMove(e, index)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gIpUw.TypeAheadListItem), {
            key: items[index].title,
            item: currentItem,
            firstOnlineSupportedIndex: firstOnlineSupportedRow,
            itemsLength: itemsLength,
            itemIndex: index,
            selectedIndex: selectedIndex,
            onItemClick: (mode, index)=>{
                actions.onItemClick(mode, index, (0, $gkwXh.INPUT_METHOD).MOUSE);
            },
            ariaLabel: (0, $iiwBk.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
            moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
            api: api
        }))));
    };
    const popupAriaLabel = (0, $iiwBk.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID);
    const EmptyResultView = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $MHKc7.default), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emptySearchResultsSuggestion, {
        buttonName: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
            weight: "medium"
        }, intl.formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aLlKO.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: itemsLength,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $d72dfd0f40a0ed4b$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        // We need to make this walkaround to make TS happy, cannot pass undefined otherwise ReactVirualized will make it equal to "grid" which we want to avoid
        // https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/Grid.js#L260
        "aria-label": null,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $d72dfd0f40a0ed4b$var$list
        ]
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, !showViewMore || itemsLength ? ListContent : EmptyResultView, showViewMore && onViewMoreClick && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8PLnn.ViewMore), {
        onClick: onViewMoreClick,
        isFocused: selectedIndex === itemsLength
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($d72dfd0f40a0ed4b$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $d72dfd0f40a0ed4b$export$81b66b5b19964713 = (0, $8RXs9.default)($d72dfd0f40a0ed4b$var$TypeAheadListComponent);
$d72dfd0f40a0ed4b$export$81b66b5b19964713.displayName = 'TypeAheadList';

});
parcelRegister("7Pkjl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CellMeasurerCache = module.exports.CellMeasurer = undefined;

var $39v3u = parcelRequire("39v3u");
var $5b2d0d312f5c1e98$var$_CellMeasurer2 = $5b2d0d312f5c1e98$var$_interopRequireDefault($39v3u);

var $ewGy7 = parcelRequire("ewGy7");
var $5b2d0d312f5c1e98$var$_CellMeasurerCache2 = $5b2d0d312f5c1e98$var$_interopRequireDefault($ewGy7);
function $5b2d0d312f5c1e98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $5b2d0d312f5c1e98$var$_CellMeasurer2.default;
module.exports.CellMeasurer = $5b2d0d312f5c1e98$var$_CellMeasurer2.default;
module.exports.CellMeasurerCache = $5b2d0d312f5c1e98$var$_CellMeasurerCache2.default;

});
parcelRegister("39v3u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $29Ol4 = parcelRequire("29Ol4");
var $24ba4d50b29169e6$var$_getPrototypeOf2 = $24ba4d50b29169e6$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $24ba4d50b29169e6$var$_classCallCheck3 = $24ba4d50b29169e6$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $24ba4d50b29169e6$var$_createClass3 = $24ba4d50b29169e6$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $24ba4d50b29169e6$var$_possibleConstructorReturn3 = $24ba4d50b29169e6$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $24ba4d50b29169e6$var$_inherits3 = $24ba4d50b29169e6$var$_interopRequireDefault($gHLl6);

var $5uXOq = parcelRequire("5uXOq");
var $24ba4d50b29169e6$var$React = $24ba4d50b29169e6$var$_interopRequireWildcard($5uXOq);

var $7nsd3 = parcelRequire("7nsd3");
parcelRequire("bN49P");

var $8rCP3 = parcelRequire("8rCP3");
var $24ba4d50b29169e6$var$_propTypes2 = $24ba4d50b29169e6$var$_interopRequireDefault($8rCP3);
function $24ba4d50b29169e6$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $24ba4d50b29169e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $24ba4d50b29169e6$var$CellMeasurer = function(_React$PureComponent) {
    (0, $24ba4d50b29169e6$var$_inherits3.default)(CellMeasurer, _React$PureComponent);
    function CellMeasurer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $24ba4d50b29169e6$var$_classCallCheck3.default)(this, CellMeasurer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $24ba4d50b29169e6$var$_possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, $24ba4d50b29169e6$var$_getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._measure = function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        }, _temp), (0, $24ba4d50b29169e6$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $24ba4d50b29169e6$var$_createClass3.default)(CellMeasurer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return typeof children === 'function' ? children({
                    measure: this._measure
                }) : children;
            }
        },
        {
            key: '_getCellMeasurements',
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = (0, $7nsd3.findDOMNode)(this);
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: '_maybeMeasureCell',
            value: function _maybeMeasureCell() {
                var _props = this.props, cache = _props.cache, _props$columnIndex = _props.columnIndex, columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex, parent = _props.parent, _props$rowIndex = _props.rowIndex, rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _getCellMeasurements2 = this._getCellMeasurements(), height = _getCellMeasurements2.height, width = _getCellMeasurements2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
    return CellMeasurer;
}($24ba4d50b29169e6$var$React.PureComponent);
// Used for DEV mode warning check
$24ba4d50b29169e6$var$CellMeasurer.__internalCellMeasurerFlag = false;
$24ba4d50b29169e6$var$CellMeasurer.propTypes = null;
module.exports.default = $24ba4d50b29169e6$var$CellMeasurer;

});
parcelRegister("29Ol4", function(module, exports) {

module.exports = {
    "default": (parcelRequire("22VpG")),
    __esModule: true
};

});
parcelRegister("22VpG", function(module, exports) {
parcelRequire("7Invg");

module.exports = (parcelRequire("dv4GG")).Object.getPrototypeOf;

});
parcelRegister("7Invg", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $8tRkg = parcelRequire("8tRkg");

var $97OQk = parcelRequire("97OQk");

(parcelRequire("8iDav"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $97OQk($8tRkg(it));
    };
});

});
parcelRegister("8tRkg", function(module, exports) {
// 7.1.13 ToObject(argument)

var $ie6R6 = parcelRequire("ie6R6");
module.exports = function(it) {
    return Object($ie6R6(it));
};

});
parcelRegister("ie6R6", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("97OQk", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $aMccP = parcelRequire("aMccP");

var $8tRkg = parcelRequire("8tRkg");

var $6a4c34daf431297a$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
var $6a4c34daf431297a$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $8tRkg(O);
    if ($aMccP(O, $6a4c34daf431297a$var$IE_PROTO)) return O[$6a4c34daf431297a$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $6a4c34daf431297a$var$ObjectProto : null;
};

});
parcelRegister("aMccP", function(module, exports) {
var $7d87daef9d4e91b8$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $7d87daef9d4e91b8$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("4BPKE", function(module, exports) {

var $35b2c2e77589c562$var$shared = (parcelRequire("inCOl"))('keys');

var $42V7x = parcelRequire("42V7x");
module.exports = function(key) {
    return $35b2c2e77589c562$var$shared[key] || ($35b2c2e77589c562$var$shared[key] = $42V7x(key));
};

});
parcelRegister("inCOl", function(module, exports) {

var $dv4GG = parcelRequire("dv4GG");

var $pe18r = parcelRequire("pe18r");
var $d6187b0aaf68f232$var$SHARED = '__core-js_shared__';
var $d6187b0aaf68f232$var$store = $pe18r[$d6187b0aaf68f232$var$SHARED] || ($pe18r[$d6187b0aaf68f232$var$SHARED] = {});

(module.exports = function(key, value) {
    return $d6187b0aaf68f232$var$store[key] || ($d6187b0aaf68f232$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $dv4GG.version,
    mode: (parcelRequire("6uq1C")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("dv4GG", function(module, exports) {
var $9d41ce6d167d80d2$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9d41ce6d167d80d2$var$core; // eslint-disable-line no-undef

});

parcelRegister("pe18r", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $04bd3575bb3eed01$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $04bd3575bb3eed01$var$global; // eslint-disable-line no-undef

});

parcelRegister("6uq1C", function(module, exports) {
module.exports = true;

});


parcelRegister("42V7x", function(module, exports) {
var $2f23a8463a1ba411$var$id = 0;
var $2f23a8463a1ba411$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$2f23a8463a1ba411$var$id + $2f23a8463a1ba411$var$px).toString(36));
};

});



parcelRegister("8iDav", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $8EFNH = parcelRequire("8EFNH");

var $dv4GG = parcelRequire("dv4GG");

var $5nD9T = parcelRequire("5nD9T");
module.exports = function(KEY, exec) {
    var fn = ($dv4GG.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $8EFNH($8EFNH.S + $8EFNH.F * $5nD9T(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("8EFNH", function(module, exports) {

var $pe18r = parcelRequire("pe18r");

var $dv4GG = parcelRequire("dv4GG");

var $gnejD = parcelRequire("gnejD");

var $kM6mh = parcelRequire("kM6mh");

var $aMccP = parcelRequire("aMccP");
var $64d27bdec060590e$var$PROTOTYPE = 'prototype';
var $64d27bdec060590e$var$$export = function(type, name, source) {
    var IS_FORCED = type & $64d27bdec060590e$var$$export.F;
    var IS_GLOBAL = type & $64d27bdec060590e$var$$export.G;
    var IS_STATIC = type & $64d27bdec060590e$var$$export.S;
    var IS_PROTO = type & $64d27bdec060590e$var$$export.P;
    var IS_BIND = type & $64d27bdec060590e$var$$export.B;
    var IS_WRAP = type & $64d27bdec060590e$var$$export.W;
    var exports = IS_GLOBAL ? $dv4GG : $dv4GG[name] || ($dv4GG[name] = {});
    var expProto = exports[$64d27bdec060590e$var$PROTOTYPE];
    var target = IS_GLOBAL ? $pe18r : IS_STATIC ? $pe18r[name] : ($pe18r[name] || {})[$64d27bdec060590e$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $aMccP(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $gnejD(out, $pe18r) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$64d27bdec060590e$var$PROTOTYPE] = C[$64d27bdec060590e$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $gnejD(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $64d27bdec060590e$var$$export.R && expProto && !expProto[key]) $kM6mh(expProto, key, out);
        }
    }
};
// type bitmap
$64d27bdec060590e$var$$export.F = 1; // forced
$64d27bdec060590e$var$$export.G = 2; // global
$64d27bdec060590e$var$$export.S = 4; // static
$64d27bdec060590e$var$$export.P = 8; // proto
$64d27bdec060590e$var$$export.B = 16; // bind
$64d27bdec060590e$var$$export.W = 32; // wrap
$64d27bdec060590e$var$$export.U = 64; // safe
$64d27bdec060590e$var$$export.R = 128; // real proto method for `library`
module.exports = $64d27bdec060590e$var$$export;

});
parcelRegister("gnejD", function(module, exports) {
// optional / simple context binding

var $jd5tk = parcelRequire("jd5tk");
module.exports = function(fn, that, length) {
    $jd5tk(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("jd5tk", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("kM6mh", function(module, exports) {

var $30LaA = parcelRequire("30LaA");

var $evesF = parcelRequire("evesF");

module.exports = (parcelRequire("hn2oF")) ? function(object, key, value) {
    return $30LaA.f(object, key, $evesF(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("30LaA", function(module, exports) {

$parcel$export(module.exports, "f", () => $2315f61bd3482fc3$export$2d1720544b23b823, (v) => $2315f61bd3482fc3$export$2d1720544b23b823 = v);
var $2315f61bd3482fc3$export$2d1720544b23b823;

var $6rs9h = parcelRequire("6rs9h");

var $dzU8d = parcelRequire("dzU8d");

var $7Af9t = parcelRequire("7Af9t");
var $2315f61bd3482fc3$var$dP = Object.defineProperty;

$2315f61bd3482fc3$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $6rs9h(O);
    P = $7Af9t(P, true);
    $6rs9h(Attributes);
    if ($dzU8d) try {
        return $2315f61bd3482fc3$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("6rs9h", function(module, exports) {

var $6VwBm = parcelRequire("6VwBm");
module.exports = function(it) {
    if (!$6VwBm(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("6VwBm", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("dzU8d", function(module, exports) {



module.exports = !(parcelRequire("hn2oF")) && !(parcelRequire("5nD9T"))(function() {
    return Object.defineProperty((parcelRequire("iSIdA"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("hn2oF", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("5nD9T"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("5nD9T", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("iSIdA", function(module, exports) {

var $6VwBm = parcelRequire("6VwBm");

var $pe18r = parcelRequire("pe18r");
var $dbef91f2a743dd1e$require$document = $pe18r.document;
// typeof document.createElement is 'object' in old IE
var $dbef91f2a743dd1e$var$is = $6VwBm($dbef91f2a743dd1e$require$document) && $6VwBm($dbef91f2a743dd1e$require$document.createElement);
module.exports = function(it) {
    return $dbef91f2a743dd1e$var$is ? $dbef91f2a743dd1e$require$document.createElement(it) : {};
};

});


parcelRegister("7Af9t", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $6VwBm = parcelRequire("6VwBm");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$6VwBm(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$6VwBm(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("evesF", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("aXTp8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7fba6438b4dbf46b$export$1e511d4a378977f5, (v) => $7fba6438b4dbf46b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7fba6438b4dbf46b$export$2e2bcd8739ae039, (v) => $7fba6438b4dbf46b$export$2e2bcd8739ae039 = v);
var $7fba6438b4dbf46b$export$1e511d4a378977f5;
var $7fba6438b4dbf46b$export$2e2bcd8739ae039;
"use strict";
$7fba6438b4dbf46b$export$1e511d4a378977f5 = true;
$7fba6438b4dbf46b$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("4tLNB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $342ef2b9df8992a7$export$1e511d4a378977f5, (v) => $342ef2b9df8992a7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $342ef2b9df8992a7$export$2e2bcd8739ae039, (v) => $342ef2b9df8992a7$export$2e2bcd8739ae039 = v);
var $342ef2b9df8992a7$export$1e511d4a378977f5;
var $342ef2b9df8992a7$export$2e2bcd8739ae039;
"use strict";
$342ef2b9df8992a7$export$1e511d4a378977f5 = true;

var $aWlLP = parcelRequire("aWlLP");
var $342ef2b9df8992a7$var$_defineProperty2 = $342ef2b9df8992a7$var$_interopRequireDefault($aWlLP);
function $342ef2b9df8992a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$342ef2b9df8992a7$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $342ef2b9df8992a7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("aWlLP", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cEZdw")),
    __esModule: true
};

});
parcelRegister("cEZdw", function(module, exports) {
parcelRequire("7vx5B");

var $dv4GG = parcelRequire("dv4GG");
var $9378b4ec927c6689$require$$Object = $dv4GG.Object;
module.exports = function defineProperty(it, key, desc) {
    return $9378b4ec927c6689$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("7vx5B", function(module, exports) {

var $8EFNH = parcelRequire("8EFNH");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$8EFNH($8EFNH.S + $8EFNH.F * !(parcelRequire("hn2oF")), 'Object', {
    defineProperty: (parcelRequire("30LaA")).f
});

});




parcelRegister("5pMaQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3f14a7e1704920da$export$1e511d4a378977f5, (v) => $3f14a7e1704920da$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3f14a7e1704920da$export$2e2bcd8739ae039, (v) => $3f14a7e1704920da$export$2e2bcd8739ae039 = v);
var $3f14a7e1704920da$export$1e511d4a378977f5;
var $3f14a7e1704920da$export$2e2bcd8739ae039;
"use strict";
$3f14a7e1704920da$export$1e511d4a378977f5 = true;

var $kt6ai = parcelRequire("kt6ai");
var $3f14a7e1704920da$var$_typeof3 = $3f14a7e1704920da$var$_interopRequireDefault($kt6ai);
function $3f14a7e1704920da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3f14a7e1704920da$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $3f14a7e1704920da$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("kt6ai", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ee6b4c58df698443$export$1e511d4a378977f5, (v) => $ee6b4c58df698443$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ee6b4c58df698443$export$2e2bcd8739ae039, (v) => $ee6b4c58df698443$export$2e2bcd8739ae039 = v);
var $ee6b4c58df698443$export$1e511d4a378977f5;
var $ee6b4c58df698443$export$2e2bcd8739ae039;
"use strict";
$ee6b4c58df698443$export$1e511d4a378977f5 = true;

var $5YQKd = parcelRequire("5YQKd");
var $ee6b4c58df698443$var$_iterator2 = $ee6b4c58df698443$var$_interopRequireDefault($5YQKd);

var $V3332 = parcelRequire("V3332");
var $ee6b4c58df698443$var$_symbol2 = $ee6b4c58df698443$var$_interopRequireDefault($V3332);
var $ee6b4c58df698443$var$_typeof = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && typeof $ee6b4c58df698443$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $ee6b4c58df698443$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ee6b4c58df698443$export$2e2bcd8739ae039 = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && $ee6b4c58df698443$var$_typeof($ee6b4c58df698443$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
};

});
parcelRegister("5YQKd", function(module, exports) {

module.exports = {
    "default": (parcelRequire("hpbwm")),
    __esModule: true
};

});
parcelRegister("hpbwm", function(module, exports) {
parcelRequire("ltQ0T");
parcelRequire("fQXw1");

module.exports = (parcelRequire("3iakE")).f('iterator');

});
parcelRegister("ltQ0T", function(module, exports) {
'use strict';

var $fa34a72ca0e00838$var$$at = (parcelRequire("TnwZj"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("bH4Ac"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $fa34a72ca0e00838$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("TnwZj", function(module, exports) {

var $h2TDF = parcelRequire("h2TDF");

var $ie6R6 = parcelRequire("ie6R6");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($ie6R6(that));
        var i = $h2TDF(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("h2TDF", function(module, exports) {
// 7.1.4 ToInteger
var $c68dc842fc575f58$var$ceil = Math.ceil;
var $c68dc842fc575f58$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $c68dc842fc575f58$var$floor : $c68dc842fc575f58$var$ceil)(it);
};

});


parcelRegister("bH4Ac", function(module, exports) {
'use strict';

var $6uq1C = parcelRequire("6uq1C");

var $8EFNH = parcelRequire("8EFNH");

var $3VDKT = parcelRequire("3VDKT");

var $kM6mh = parcelRequire("kM6mh");

var $eu895 = parcelRequire("eu895");

var $jEAut = parcelRequire("jEAut");

var $8nOHH = parcelRequire("8nOHH");

var $97OQk = parcelRequire("97OQk");

var $883743f265dc0269$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
var $883743f265dc0269$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $883743f265dc0269$var$FF_ITERATOR = '@@iterator';
var $883743f265dc0269$var$KEYS = 'keys';
var $883743f265dc0269$var$VALUES = 'values';
var $883743f265dc0269$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $jEAut(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$883743f265dc0269$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $883743f265dc0269$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $883743f265dc0269$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $883743f265dc0269$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$883743f265dc0269$var$ITERATOR] || proto[$883743f265dc0269$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $97OQk($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $8nOHH(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$6uq1C && typeof IteratorPrototype[$883743f265dc0269$var$ITERATOR] != 'function') $kM6mh(IteratorPrototype, $883743f265dc0269$var$ITERATOR, $883743f265dc0269$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $883743f265dc0269$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$6uq1C || FORCED) && ($883743f265dc0269$var$BUGGY || VALUES_BUG || !proto[$883743f265dc0269$var$ITERATOR])) $kM6mh(proto, $883743f265dc0269$var$ITERATOR, $default);
    // Plug for library
    $eu895[NAME] = $default;
    $eu895[TAG] = $883743f265dc0269$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($883743f265dc0269$var$VALUES),
            keys: IS_SET ? $default : getMethod($883743f265dc0269$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $3VDKT(proto, key, methods[key]);
        } else $8EFNH($8EFNH.P + $8EFNH.F * ($883743f265dc0269$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("3VDKT", function(module, exports) {

module.exports = (parcelRequire("kM6mh"));

});

parcelRegister("eu895", function(module, exports) {
module.exports = {};

});

parcelRegister("jEAut", function(module, exports) {
'use strict';

var $l5MPs = parcelRequire("l5MPs");

var $evesF = parcelRequire("evesF");

var $8nOHH = parcelRequire("8nOHH");
var $e4ee0efba5a7f6a9$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("kM6mh"))($e4ee0efba5a7f6a9$var$IteratorPrototype, (parcelRequire("cNfss"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $l5MPs($e4ee0efba5a7f6a9$var$IteratorPrototype, {
        next: $evesF(1, next)
    });
    $8nOHH(Constructor, NAME + ' Iterator');
};

});
parcelRegister("l5MPs", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $6rs9h = parcelRequire("6rs9h");

var $hrzgw = parcelRequire("hrzgw");

var $aIGUN = parcelRequire("aIGUN");

var $f5aff1030646fd55$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
var $f5aff1030646fd55$var$Empty = function() {};
var $f5aff1030646fd55$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f5aff1030646fd55$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("iSIdA"))('iframe');
    var i = $aIGUN.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("fW23X")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f5aff1030646fd55$var$createDict = iframeDocument.F;
    while(i--)delete $f5aff1030646fd55$var$createDict[$f5aff1030646fd55$var$PROTOTYPE][$aIGUN[i]];
    return $f5aff1030646fd55$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = $6rs9h(O);
        result = new $f5aff1030646fd55$var$Empty();
        $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f5aff1030646fd55$var$IE_PROTO] = O;
    } else result = $f5aff1030646fd55$var$createDict();
    return Properties === undefined ? result : $hrzgw(result, Properties);
};

});
parcelRegister("hrzgw", function(module, exports) {

var $30LaA = parcelRequire("30LaA");

var $6rs9h = parcelRequire("6rs9h");

var $8rKxD = parcelRequire("8rKxD");

module.exports = (parcelRequire("hn2oF")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $6rs9h(O);
    var keys = $8rKxD(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$30LaA.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("8rKxD", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $aW8ua = parcelRequire("aW8ua");

var $aIGUN = parcelRequire("aIGUN");
module.exports = Object.keys || function keys(O) {
    return $aW8ua(O, $aIGUN);
};

});
parcelRegister("aW8ua", function(module, exports) {

var $aMccP = parcelRequire("aMccP");

var $59DzK = parcelRequire("59DzK");

var $7f65e7394a9ddf07$var$arrayIndexOf = (parcelRequire("6FnDv"))(false);

var $7f65e7394a9ddf07$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $59DzK(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $7f65e7394a9ddf07$var$IE_PROTO) $aMccP(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($aMccP(O, key = names[i++])) ~$7f65e7394a9ddf07$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("59DzK", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $2A2jr = parcelRequire("2A2jr");

var $ie6R6 = parcelRequire("ie6R6");
module.exports = function(it) {
    return $2A2jr($ie6R6(it));
};

});
parcelRegister("2A2jr", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $eYYzh = parcelRequire("eYYzh");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $eYYzh(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("eYYzh", function(module, exports) {
var $ae85a6d59702a8f0$var$toString = {}.toString;
module.exports = function(it) {
    return $ae85a6d59702a8f0$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("6FnDv", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $59DzK = parcelRequire("59DzK");

var $lpAeO = parcelRequire("lpAeO");

var $7XibQ = parcelRequire("7XibQ");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $59DzK($this);
        var length = $lpAeO(O.length);
        var index = $7XibQ(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("lpAeO", function(module, exports) {
// 7.1.15 ToLength

var $h2TDF = parcelRequire("h2TDF");
var $f9680adf10caefa3$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $f9680adf10caefa3$var$min($h2TDF(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("7XibQ", function(module, exports) {

var $h2TDF = parcelRequire("h2TDF");
var $5cac2746a26f7adf$var$max = Math.max;
var $5cac2746a26f7adf$var$min = Math.min;
module.exports = function(index, length) {
    index = $h2TDF(index);
    return index < 0 ? $5cac2746a26f7adf$var$max(index + length, 0) : $5cac2746a26f7adf$var$min(index, length);
};

});



parcelRegister("aIGUN", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("fW23X", function(module, exports) {

var $pe18r = parcelRequire("pe18r");
var $b99ddf714ab9b2ae$require$document = $pe18r.document;
module.exports = $b99ddf714ab9b2ae$require$document && $b99ddf714ab9b2ae$require$document.documentElement;

});


parcelRegister("8nOHH", function(module, exports) {

var $30LaA = parcelRequire("30LaA");
var $61a7cd74d8b334f9$require$def = $30LaA.f;

var $aMccP = parcelRequire("aMccP");

var $61a7cd74d8b334f9$var$TAG = (parcelRequire("cNfss"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$aMccP(it = stat ? it : it.prototype, $61a7cd74d8b334f9$var$TAG)) $61a7cd74d8b334f9$require$def(it, $61a7cd74d8b334f9$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("cNfss", function(module, exports) {

var $95060d4712c30789$var$store = (parcelRequire("inCOl"))('wks');

var $42V7x = parcelRequire("42V7x");

var $pe18r = parcelRequire("pe18r");
var $95060d4712c30789$require$Symbol = $pe18r.Symbol;
var $95060d4712c30789$var$USE_SYMBOL = typeof $95060d4712c30789$require$Symbol == 'function';
var $95060d4712c30789$var$$exports = module.exports = function(name) {
    return $95060d4712c30789$var$store[name] || ($95060d4712c30789$var$store[name] = $95060d4712c30789$var$USE_SYMBOL && $95060d4712c30789$require$Symbol[name] || ($95060d4712c30789$var$USE_SYMBOL ? $95060d4712c30789$require$Symbol : $42V7x)('Symbol.' + name));
};
$95060d4712c30789$var$$exports.store = $95060d4712c30789$var$store;

});





parcelRegister("fQXw1", function(module, exports) {
parcelRequire("bSOrM");

var $pe18r = parcelRequire("pe18r");

var $kM6mh = parcelRequire("kM6mh");

var $eu895 = parcelRequire("eu895");

var $b8a9e0dc29c7f4f5$var$TO_STRING_TAG = (parcelRequire("cNfss"))('toStringTag');
var $b8a9e0dc29c7f4f5$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $b8a9e0dc29c7f4f5$var$i = 0; $b8a9e0dc29c7f4f5$var$i < $b8a9e0dc29c7f4f5$var$DOMIterables.length; $b8a9e0dc29c7f4f5$var$i++){
    var $b8a9e0dc29c7f4f5$var$NAME = $b8a9e0dc29c7f4f5$var$DOMIterables[$b8a9e0dc29c7f4f5$var$i];
    var $b8a9e0dc29c7f4f5$var$Collection = $pe18r[$b8a9e0dc29c7f4f5$var$NAME];
    var $b8a9e0dc29c7f4f5$var$proto = $b8a9e0dc29c7f4f5$var$Collection && $b8a9e0dc29c7f4f5$var$Collection.prototype;
    if ($b8a9e0dc29c7f4f5$var$proto && !$b8a9e0dc29c7f4f5$var$proto[$b8a9e0dc29c7f4f5$var$TO_STRING_TAG]) $kM6mh($b8a9e0dc29c7f4f5$var$proto, $b8a9e0dc29c7f4f5$var$TO_STRING_TAG, $b8a9e0dc29c7f4f5$var$NAME);
    $eu895[$b8a9e0dc29c7f4f5$var$NAME] = $eu895.Array;
}

});
parcelRegister("bSOrM", function(module, exports) {
'use strict';

var $hvcNK = parcelRequire("hvcNK");

var $2WIr8 = parcelRequire("2WIr8");

var $eu895 = parcelRequire("eu895");

var $59DzK = parcelRequire("59DzK");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("bH4Ac"))(Array, 'Array', function(iterated, kind) {
    this._t = $59DzK(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $2WIr8(1);
    }
    if (kind == 'keys') return $2WIr8(0, index);
    if (kind == 'values') return $2WIr8(0, O[index]);
    return $2WIr8(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$eu895.Arguments = $eu895.Array;
$hvcNK('keys');
$hvcNK('values');
$hvcNK('entries');

});
parcelRegister("hvcNK", function(module, exports) {
module.exports = function() {};

});

parcelRegister("2WIr8", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("3iakE", function(module, exports) {

$parcel$export(module.exports, "f", () => $265b1149da5b805d$export$2d1720544b23b823, (v) => $265b1149da5b805d$export$2d1720544b23b823 = v);
var $265b1149da5b805d$export$2d1720544b23b823;

$265b1149da5b805d$export$2d1720544b23b823 = (parcelRequire("cNfss"));

});



parcelRegister("V3332", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5MRee")),
    __esModule: true
};

});
parcelRegister("5MRee", function(module, exports) {
parcelRequire("dV330");
parcelRequire("55SkS");
parcelRequire("8IAUf");
parcelRequire("fvEHr");

module.exports = (parcelRequire("dv4GG")).Symbol;

});
parcelRegister("dV330", function(module, exports) {
'use strict';

var $pe18r = parcelRequire("pe18r");

var $aMccP = parcelRequire("aMccP");

var $hn2oF = parcelRequire("hn2oF");

var $8EFNH = parcelRequire("8EFNH");

var $3VDKT = parcelRequire("3VDKT");

var $hXWWY = parcelRequire("hXWWY");
var $a222f66347247ddd$require$META = $hXWWY.KEY;

var $5nD9T = parcelRequire("5nD9T");

var $inCOl = parcelRequire("inCOl");

var $8nOHH = parcelRequire("8nOHH");

var $42V7x = parcelRequire("42V7x");

var $cNfss = parcelRequire("cNfss");

var $3iakE = parcelRequire("3iakE");

var $eKGZg = parcelRequire("eKGZg");

var $8yCLj = parcelRequire("8yCLj");

var $imb3o = parcelRequire("imb3o");

var $6rs9h = parcelRequire("6rs9h");

var $6VwBm = parcelRequire("6VwBm");

var $8tRkg = parcelRequire("8tRkg");

var $59DzK = parcelRequire("59DzK");

var $7Af9t = parcelRequire("7Af9t");

var $evesF = parcelRequire("evesF");

var $l5MPs = parcelRequire("l5MPs");

var $2JUNR = parcelRequire("2JUNR");

var $56mOV = parcelRequire("56mOV");

var $1Jjbj = parcelRequire("1Jjbj");

var $30LaA = parcelRequire("30LaA");

var $8rKxD = parcelRequire("8rKxD");
var $a222f66347247ddd$var$gOPD = $56mOV.f;
var $a222f66347247ddd$var$dP = $30LaA.f;
var $a222f66347247ddd$var$gOPN = $2JUNR.f;
var $a222f66347247ddd$var$$Symbol = $pe18r.Symbol;
var $a222f66347247ddd$var$$JSON = $pe18r.JSON;
var $a222f66347247ddd$var$_stringify = $a222f66347247ddd$var$$JSON && $a222f66347247ddd$var$$JSON.stringify;
var $a222f66347247ddd$var$PROTOTYPE = 'prototype';
var $a222f66347247ddd$var$HIDDEN = $cNfss('_hidden');
var $a222f66347247ddd$var$TO_PRIMITIVE = $cNfss('toPrimitive');
var $a222f66347247ddd$var$isEnum = {}.propertyIsEnumerable;
var $a222f66347247ddd$var$SymbolRegistry = $inCOl('symbol-registry');
var $a222f66347247ddd$var$AllSymbols = $inCOl('symbols');
var $a222f66347247ddd$var$OPSymbols = $inCOl('op-symbols');
var $a222f66347247ddd$var$ObjectProto = Object[$a222f66347247ddd$var$PROTOTYPE];
var $a222f66347247ddd$var$USE_NATIVE = typeof $a222f66347247ddd$var$$Symbol == 'function' && !!$1Jjbj.f;
var $a222f66347247ddd$var$QObject = $pe18r.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $a222f66347247ddd$var$setter = !$a222f66347247ddd$var$QObject || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE] || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $a222f66347247ddd$var$setSymbolDesc = $hn2oF && $5nD9T(function() {
    return $l5MPs($a222f66347247ddd$var$dP({}, 'a', {
        get: function() {
            return $a222f66347247ddd$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $a222f66347247ddd$var$gOPD($a222f66347247ddd$var$ObjectProto, key);
    if (protoDesc) delete $a222f66347247ddd$var$ObjectProto[key];
    $a222f66347247ddd$var$dP(it, key, D);
    if (protoDesc && it !== $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$dP($a222f66347247ddd$var$ObjectProto, key, protoDesc);
} : $a222f66347247ddd$var$dP;
var $a222f66347247ddd$var$wrap = function(tag) {
    var sym = $a222f66347247ddd$var$AllSymbols[tag] = $l5MPs($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $a222f66347247ddd$var$isSymbol = $a222f66347247ddd$var$USE_NATIVE && typeof $a222f66347247ddd$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $a222f66347247ddd$var$$Symbol;
};
var $a222f66347247ddd$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$$defineProperty($a222f66347247ddd$var$OPSymbols, key, D);
    $6rs9h(it);
    key = $7Af9t(key, true);
    $6rs9h(D);
    if ($aMccP($a222f66347247ddd$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$aMccP(it, $a222f66347247ddd$var$HIDDEN)) $a222f66347247ddd$var$dP(it, $a222f66347247ddd$var$HIDDEN, $evesF(1, {}));
            it[$a222f66347247ddd$var$HIDDEN][key] = true;
        } else {
            if ($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key]) it[$a222f66347247ddd$var$HIDDEN][key] = false;
            D = $l5MPs(D, {
                enumerable: $evesF(0, false)
            });
        }
        return $a222f66347247ddd$var$setSymbolDesc(it, key, D);
    }
    return $a222f66347247ddd$var$dP(it, key, D);
};
var $a222f66347247ddd$var$$defineProperties = function defineProperties(it, P) {
    $6rs9h(it);
    var keys = $8yCLj(P = $59DzK(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$a222f66347247ddd$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $a222f66347247ddd$var$$create = function create(it, P) {
    return P === undefined ? $l5MPs(it) : $a222f66347247ddd$var$$defineProperties($l5MPs(it), P);
};
var $a222f66347247ddd$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $a222f66347247ddd$var$isEnum.call(this, key = $7Af9t(key, true));
    if (this === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return false;
    return E || !$aMccP(this, key) || !$aMccP($a222f66347247ddd$var$AllSymbols, key) || $aMccP(this, $a222f66347247ddd$var$HIDDEN) && this[$a222f66347247ddd$var$HIDDEN][key] ? E : true;
};
var $a222f66347247ddd$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $59DzK(it);
    key = $7Af9t(key, true);
    if (it === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return;
    var D = $a222f66347247ddd$var$gOPD(it, key);
    if (D && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $a222f66347247ddd$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $a222f66347247ddd$var$gOPN($59DzK(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && key != $a222f66347247ddd$var$HIDDEN && key != $a222f66347247ddd$require$META) result.push(key);
    return result;
};
var $a222f66347247ddd$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $a222f66347247ddd$var$ObjectProto;
    var names = $a222f66347247ddd$var$gOPN(IS_OP ? $a222f66347247ddd$var$OPSymbols : $59DzK(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && (IS_OP ? $aMccP($a222f66347247ddd$var$ObjectProto, key) : true)) result.push($a222f66347247ddd$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$a222f66347247ddd$var$USE_NATIVE) {
    $a222f66347247ddd$var$$Symbol = function Symbol() {
        if (this instanceof $a222f66347247ddd$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $42V7x(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $a222f66347247ddd$var$ObjectProto) $set.call($a222f66347247ddd$var$OPSymbols, value);
            if ($aMccP(this, $a222f66347247ddd$var$HIDDEN) && $aMccP(this[$a222f66347247ddd$var$HIDDEN], tag)) this[$a222f66347247ddd$var$HIDDEN][tag] = false;
            $a222f66347247ddd$var$setSymbolDesc(this, tag, $evesF(1, value));
        };
        if ($hn2oF && $a222f66347247ddd$var$setter) $a222f66347247ddd$var$setSymbolDesc($a222f66347247ddd$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $a222f66347247ddd$var$wrap(tag);
    };
    $3VDKT($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $56mOV.f = $a222f66347247ddd$var$$getOwnPropertyDescriptor;
    $30LaA.f = $a222f66347247ddd$var$$defineProperty;
    (parcelRequire("7X6HN")).f = $2JUNR.f = $a222f66347247ddd$var$$getOwnPropertyNames;
    (parcelRequire("gvEJa")).f = $a222f66347247ddd$var$$propertyIsEnumerable;
    $1Jjbj.f = $a222f66347247ddd$var$$getOwnPropertySymbols;
    if ($hn2oF && !(parcelRequire("6uq1C"))) $3VDKT($a222f66347247ddd$var$ObjectProto, 'propertyIsEnumerable', $a222f66347247ddd$var$$propertyIsEnumerable, true);
    $3iakE.f = function(name) {
        return $a222f66347247ddd$var$wrap($cNfss(name));
    };
}
$8EFNH($8EFNH.G + $8EFNH.W + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, {
    Symbol: $a222f66347247ddd$var$$Symbol
});
for(var $a222f66347247ddd$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $a222f66347247ddd$var$j = 0; $a222f66347247ddd$var$es6Symbols.length > $a222f66347247ddd$var$j;)$cNfss($a222f66347247ddd$var$es6Symbols[$a222f66347247ddd$var$j++]);
for(var $a222f66347247ddd$var$wellKnownSymbols = $8rKxD($cNfss.store), $a222f66347247ddd$var$k = 0; $a222f66347247ddd$var$wellKnownSymbols.length > $a222f66347247ddd$var$k;)$eKGZg($a222f66347247ddd$var$wellKnownSymbols[$a222f66347247ddd$var$k++]);
$8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $aMccP($a222f66347247ddd$var$SymbolRegistry, key += '') ? $a222f66347247ddd$var$SymbolRegistry[key] : $a222f66347247ddd$var$SymbolRegistry[key] = $a222f66347247ddd$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$a222f66347247ddd$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $a222f66347247ddd$var$SymbolRegistry)if ($a222f66347247ddd$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $a222f66347247ddd$var$setter = true;
    },
    useSimple: function() {
        $a222f66347247ddd$var$setter = false;
    }
});
$8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $a222f66347247ddd$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $a222f66347247ddd$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $a222f66347247ddd$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $a222f66347247ddd$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $a222f66347247ddd$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $a222f66347247ddd$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $a222f66347247ddd$var$FAILS_ON_PRIMITIVES = $5nD9T(function() {
    $1Jjbj.f(1);
});
$8EFNH($8EFNH.S + $8EFNH.F * $a222f66347247ddd$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $1Jjbj.f($8tRkg(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$a222f66347247ddd$var$$JSON && $8EFNH($8EFNH.S + $8EFNH.F * (!$a222f66347247ddd$var$USE_NATIVE || $5nD9T(function() {
    var S = $a222f66347247ddd$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $a222f66347247ddd$var$_stringify([
        S
    ]) != '[null]' || $a222f66347247ddd$var$_stringify({
        a: S
    }) != '{}' || $a222f66347247ddd$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$6VwBm(replacer) && it === undefined || $a222f66347247ddd$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$imb3o(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$a222f66347247ddd$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $a222f66347247ddd$var$_stringify.apply($a222f66347247ddd$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE][$a222f66347247ddd$var$TO_PRIMITIVE] || (parcelRequire("kM6mh"))($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], $a222f66347247ddd$var$TO_PRIMITIVE, $a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$8nOHH($a222f66347247ddd$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$8nOHH(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$8nOHH($pe18r.JSON, 'JSON', true);

});
parcelRegister("hXWWY", function(module, exports) {

var $d145aca8ddc395e4$var$META = (parcelRequire("42V7x"))('meta');

var $6VwBm = parcelRequire("6VwBm");

var $aMccP = parcelRequire("aMccP");

var $30LaA = parcelRequire("30LaA");
var $d145aca8ddc395e4$require$setDesc = $30LaA.f;
var $d145aca8ddc395e4$var$id = 0;
var $d145aca8ddc395e4$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $d145aca8ddc395e4$var$FREEZE = !(parcelRequire("5nD9T"))(function() {
    return $d145aca8ddc395e4$var$isExtensible(Object.preventExtensions({}));
});
var $d145aca8ddc395e4$var$setMeta = function(it) {
    $d145aca8ddc395e4$require$setDesc(it, $d145aca8ddc395e4$var$META, {
        value: {
            i: 'O' + ++$d145aca8ddc395e4$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $d145aca8ddc395e4$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$6VwBm(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$d145aca8ddc395e4$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $d145aca8ddc395e4$var$setMeta(it);
    // return object ID
    }
    return it[$d145aca8ddc395e4$var$META].i;
};
var $d145aca8ddc395e4$var$getWeak = function(it, create) {
    if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$d145aca8ddc395e4$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $d145aca8ddc395e4$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$d145aca8ddc395e4$var$META].w;
};
// add metadata on freeze-family methods calling
var $d145aca8ddc395e4$var$onFreeze = function(it) {
    if ($d145aca8ddc395e4$var$FREEZE && $d145aca8ddc395e4$var$meta.NEED && $d145aca8ddc395e4$var$isExtensible(it) && !$aMccP(it, $d145aca8ddc395e4$var$META)) $d145aca8ddc395e4$var$setMeta(it);
    return it;
};
var $d145aca8ddc395e4$var$meta = module.exports = {
    KEY: $d145aca8ddc395e4$var$META,
    NEED: false,
    fastKey: $d145aca8ddc395e4$var$fastKey,
    getWeak: $d145aca8ddc395e4$var$getWeak,
    onFreeze: $d145aca8ddc395e4$var$onFreeze
};

});

parcelRegister("eKGZg", function(module, exports) {

var $pe18r = parcelRequire("pe18r");

var $dv4GG = parcelRequire("dv4GG");

var $6uq1C = parcelRequire("6uq1C");

var $3iakE = parcelRequire("3iakE");

var $30LaA = parcelRequire("30LaA");
var $abd6b4ec55be4dfa$require$defineProperty = $30LaA.f;
module.exports = function(name) {
    var $Symbol = $dv4GG.Symbol || ($dv4GG.Symbol = $6uq1C ? {} : $pe18r.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $abd6b4ec55be4dfa$require$defineProperty($Symbol, name, {
        value: $3iakE.f(name)
    });
};

});

parcelRegister("8yCLj", function(module, exports) {
// all enumerable object keys, includes symbols

var $8rKxD = parcelRequire("8rKxD");

var $1Jjbj = parcelRequire("1Jjbj");

var $gvEJa = parcelRequire("gvEJa");
module.exports = function(it) {
    var result = $8rKxD(it);
    var getSymbols = $1Jjbj.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $gvEJa.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("1Jjbj", function(module, exports) {

$parcel$export(module.exports, "f", () => $1428df70697477af$export$2d1720544b23b823, (v) => $1428df70697477af$export$2d1720544b23b823 = v);
var $1428df70697477af$export$2d1720544b23b823;
$1428df70697477af$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("gvEJa", function(module, exports) {

$parcel$export(module.exports, "f", () => $c04f223f8947297b$export$2d1720544b23b823, (v) => $c04f223f8947297b$export$2d1720544b23b823 = v);
var $c04f223f8947297b$export$2d1720544b23b823;
$c04f223f8947297b$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("imb3o", function(module, exports) {
// 7.2.2 IsArray(argument)

var $eYYzh = parcelRequire("eYYzh");
module.exports = Array.isArray || function isArray(arg) {
    return $eYYzh(arg) == 'Array';
};

});

parcelRegister("2JUNR", function(module, exports) {

$parcel$export(module.exports, "f", () => $1febd8a8d519c7f4$export$2d1720544b23b823, (v) => $1febd8a8d519c7f4$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $1febd8a8d519c7f4$export$2d1720544b23b823;

var $59DzK = parcelRequire("59DzK");

var $7X6HN = parcelRequire("7X6HN");
var $1febd8a8d519c7f4$require$gOPN = $7X6HN.f;
var $1febd8a8d519c7f4$var$toString = {}.toString;
var $1febd8a8d519c7f4$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $1febd8a8d519c7f4$var$getWindowNames = function(it) {
    try {
        return $1febd8a8d519c7f4$require$gOPN(it);
    } catch (e) {
        return $1febd8a8d519c7f4$var$windowNames.slice();
    }
};
$1febd8a8d519c7f4$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $1febd8a8d519c7f4$var$windowNames && $1febd8a8d519c7f4$var$toString.call(it) == '[object Window]' ? $1febd8a8d519c7f4$var$getWindowNames(it) : $1febd8a8d519c7f4$require$gOPN($59DzK(it));
};

});
parcelRegister("7X6HN", function(module, exports) {

$parcel$export(module.exports, "f", () => $5ca33ea82ab61dc4$export$2d1720544b23b823, (v) => $5ca33ea82ab61dc4$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $5ca33ea82ab61dc4$export$2d1720544b23b823;

var $aW8ua = parcelRequire("aW8ua");

var $5ca33ea82ab61dc4$var$hiddenKeys = (parcelRequire("aIGUN")).concat('length', 'prototype');
$5ca33ea82ab61dc4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $aW8ua(O, $5ca33ea82ab61dc4$var$hiddenKeys);
};

});


parcelRegister("56mOV", function(module, exports) {

$parcel$export(module.exports, "f", () => $3b6f36f483e8e31a$export$2d1720544b23b823, (v) => $3b6f36f483e8e31a$export$2d1720544b23b823 = v);
var $3b6f36f483e8e31a$export$2d1720544b23b823;

var $gvEJa = parcelRequire("gvEJa");

var $evesF = parcelRequire("evesF");

var $59DzK = parcelRequire("59DzK");

var $7Af9t = parcelRequire("7Af9t");

var $aMccP = parcelRequire("aMccP");

var $dzU8d = parcelRequire("dzU8d");
var $3b6f36f483e8e31a$var$gOPD = Object.getOwnPropertyDescriptor;

$3b6f36f483e8e31a$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? $3b6f36f483e8e31a$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $59DzK(O);
    P = $7Af9t(P, true);
    if ($dzU8d) try {
        return $3b6f36f483e8e31a$var$gOPD(O, P);
    } catch (e) {}
    if ($aMccP(O, P)) return $evesF(!$gvEJa.f.call(O, P), O[P]);
};

});


parcelRegister("55SkS", function(module, exports) {

});

parcelRegister("8IAUf", function(module, exports) {

(parcelRequire("eKGZg"))('asyncIterator');

});

parcelRegister("fvEHr", function(module, exports) {

(parcelRequire("eKGZg"))('observable');

});





parcelRegister("gHLl6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c295621de530ae6b$export$1e511d4a378977f5, (v) => $c295621de530ae6b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c295621de530ae6b$export$2e2bcd8739ae039, (v) => $c295621de530ae6b$export$2e2bcd8739ae039 = v);
var $c295621de530ae6b$export$1e511d4a378977f5;
var $c295621de530ae6b$export$2e2bcd8739ae039;
"use strict";
$c295621de530ae6b$export$1e511d4a378977f5 = true;

var $2gkZm = parcelRequire("2gkZm");
var $c295621de530ae6b$var$_setPrototypeOf2 = $c295621de530ae6b$var$_interopRequireDefault($2gkZm);

var $gqjuI = parcelRequire("gqjuI");
var $c295621de530ae6b$var$_create2 = $c295621de530ae6b$var$_interopRequireDefault($gqjuI);

var $kt6ai = parcelRequire("kt6ai");
var $c295621de530ae6b$var$_typeof3 = $c295621de530ae6b$var$_interopRequireDefault($kt6ai);
function $c295621de530ae6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c295621de530ae6b$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c295621de530ae6b$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $c295621de530ae6b$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c295621de530ae6b$var$_setPrototypeOf2.default ? (0, $c295621de530ae6b$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("2gkZm", function(module, exports) {

module.exports = {
    "default": (parcelRequire("9Eo5e")),
    __esModule: true
};

});
parcelRegister("9Eo5e", function(module, exports) {
parcelRequire("58apJ");

module.exports = (parcelRequire("dv4GG")).Object.setPrototypeOf;

});
parcelRegister("58apJ", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $8EFNH = parcelRequire("8EFNH");

$8EFNH($8EFNH.S, 'Object', {
    setPrototypeOf: (parcelRequire("kyYcY")).set
});

});
parcelRegister("kyYcY", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $6VwBm = parcelRequire("6VwBm");

var $6rs9h = parcelRequire("6rs9h");
var $ef85afb423a719a5$var$check = function(O, proto) {
    $6rs9h(O);
    if (!$6VwBm(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("gnejD"))(Function.call, (parcelRequire("56mOV")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $ef85afb423a719a5$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $ef85afb423a719a5$var$check
};

});




parcelRegister("gqjuI", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2cRis")),
    __esModule: true
};

});
parcelRegister("2cRis", function(module, exports) {
parcelRequire("8Agfc");

var $dv4GG = parcelRequire("dv4GG");
var $19b60b5f041438df$require$$Object = $dv4GG.Object;
module.exports = function create(P, D) {
    return $19b60b5f041438df$require$$Object.create(P, D);
};

});
parcelRegister("8Agfc", function(module, exports) {

var $8EFNH = parcelRequire("8EFNH");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$8EFNH($8EFNH.S, 'Object', {
    create: (parcelRequire("l5MPs"))
});

});




parcelRegister("bN49P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_CellMeasureCache = undefined;

var $8rCP3 = parcelRequire("8rCP3");
var $89577ee8c01f218b$var$_propTypes2 = $89577ee8c01f218b$var$_interopRequireDefault($8rCP3);
function $89577ee8c01f218b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $89577ee8c01f218b$var$bpfrpt_proptype_CellMeasureCache = null;
module.exports.bpfrpt_proptype_CellMeasureCache = $89577ee8c01f218b$var$bpfrpt_proptype_CellMeasureCache;

});


parcelRegister("ewGy7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = undefined;

var $aXTp8 = parcelRequire("aXTp8");
var $a9350f4628fe309c$var$_classCallCheck3 = $a9350f4628fe309c$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $a9350f4628fe309c$var$_createClass3 = $a9350f4628fe309c$var$_interopRequireDefault($4tLNB);
parcelRequire("bN49P");
function $a9350f4628fe309c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a9350f4628fe309c$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $a9350f4628fe309c$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/**
 * Caches measurements for a given cell.
 */ var $a9350f4628fe309c$var$CellMeasurerCache = function() {
    function CellMeasurerCache() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $a9350f4628fe309c$var$_classCallCheck3.default)(this, CellMeasurerCache);
        this._cellHeightCache = {};
        this._cellWidthCache = {};
        this._columnWidthCache = {};
        this._rowHeightCache = {};
        this._columnCount = 0;
        this._rowCount = 0;
        this.columnWidth = function(_ref) {
            var index = _ref.index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
        };
        this.rowHeight = function(_ref2) {
            var index = _ref2.index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
        };
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $a9350f4628fe309c$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $a9350f4628fe309c$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $a9350f4628fe309c$var$DEFAULT_WIDTH);
    }
    (0, $a9350f4628fe309c$var$_createClass3.default)(CellMeasurerCache, [
        {
            key: 'clear',
            value: function clear(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: 'clearAll',
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: 'hasFixedHeight',
            value: function hasFixedHeight() {
                return this._hasFixedHeight;
            }
        },
        {
            key: 'hasFixedWidth',
            value: function hasFixedWidth() {
                return this._hasFixedWidth;
            }
        },
        {
            key: 'getHeight',
            value: function getHeight(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: 'getWidth',
            value: function getWidth(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: 'has',
            value: function has(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache.hasOwnProperty(key);
            }
        },
        {
            key: 'set',
            value: function set(rowIndex, columnIndex, width, height) {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: '_updateCachedColumnAndRowSizes',
            value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        },
        {
            key: 'defaultHeight',
            get: function get() {
                return this._defaultHeight;
            }
        },
        {
            key: 'defaultWidth',
            get: function get() {
                return this._defaultWidth;
            }
        }
    ]);
    return CellMeasurerCache;
}();
module.exports.default = $a9350f4628fe309c$var$CellMeasurerCache;
function $a9350f4628fe309c$var$defaultKeyMapper(rowIndex, columnIndex) {
    return rowIndex + '-' + columnIndex;
}

});


parcelRegister("aLlKO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_RowRendererParams = module.exports.List = module.exports.default = undefined;

var $eAgCH = parcelRequire("eAgCH");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $7d5f2b12ba6a0316$var$_interopRequireDefault($eAgCH).default;
    }
});
Object.defineProperty(module.exports, 'List', {
    enumerable: true,
    get: function get() {
        return $7d5f2b12ba6a0316$var$_interopRequireDefault($eAgCH).default;
    }
});

var $2AKv3 = parcelRequire("2AKv3");
function $7d5f2b12ba6a0316$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_RowRendererParams = $2AKv3.bpfrpt_proptype_RowRendererParams;

});
parcelRegister("eAgCH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $knQh8 = parcelRequire("knQh8");
var $a9e1528011c3c32e$var$_extends3 = $a9e1528011c3c32e$var$_interopRequireDefault($knQh8);

var $kSGvk = parcelRequire("kSGvk");
var $a9e1528011c3c32e$var$_getOwnPropertyDescriptor2 = $a9e1528011c3c32e$var$_interopRequireDefault($kSGvk);

var $29Ol4 = parcelRequire("29Ol4");
var $a9e1528011c3c32e$var$_getPrototypeOf2 = $a9e1528011c3c32e$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $a9e1528011c3c32e$var$_classCallCheck3 = $a9e1528011c3c32e$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $a9e1528011c3c32e$var$_createClass3 = $a9e1528011c3c32e$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $a9e1528011c3c32e$var$_possibleConstructorReturn3 = $a9e1528011c3c32e$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $a9e1528011c3c32e$var$_inherits3 = $a9e1528011c3c32e$var$_interopRequireDefault($gHLl6);

var $648t0 = parcelRequire("648t0");
var $a9e1528011c3c32e$var$_Grid2 = $a9e1528011c3c32e$var$_interopRequireDefault($648t0);

var $5uXOq = parcelRequire("5uXOq");
var $a9e1528011c3c32e$var$React = $a9e1528011c3c32e$var$_interopRequireWildcard($5uXOq);

var $hazy9 = parcelRequire("hazy9");
var $a9e1528011c3c32e$var$_clsx2 = $a9e1528011c3c32e$var$_interopRequireDefault($hazy9);
parcelRequire("2AKv3");

var $8rCP3 = parcelRequire("8rCP3");
var $a9e1528011c3c32e$var$_propTypes2 = $a9e1528011c3c32e$var$_interopRequireDefault($8rCP3);
function $a9e1528011c3c32e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $a9e1528011c3c32e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ var $a9e1528011c3c32e$var$List = function(_React$PureComponent) {
    (0, $a9e1528011c3c32e$var$_inherits3.default)(List, _React$PureComponent);
    function List() {
        var _ref;
        var _temp, _this, _ret;
        (0, $a9e1528011c3c32e$var$_classCallCheck3.default)(this, List);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $a9e1528011c3c32e$var$_possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, $a9e1528011c3c32e$var$_getPrototypeOf2.default)(List)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._cellRenderer = function(_ref2) {
            var parent = _ref2.parent, rowIndex = _ref2.rowIndex, style = _ref2.style, isScrolling = _ref2.isScrolling, isVisible = _ref2.isVisible, key = _ref2.key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var _Object$getOwnPropert = (0, $a9e1528011c3c32e$var$_getOwnPropertyDescriptor2.default)(style, 'width'), writable = _Object$getOwnPropert.writable;
            if (writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        }, _this._setRef = function(ref) {
            _this.Grid = ref;
        }, _this._onScroll = function(_ref3) {
            var clientHeight = _ref3.clientHeight, scrollHeight = _ref3.scrollHeight, scrollTop = _ref3.scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, _this._onSectionRendered = function(_ref4) {
            var rowOverscanStartIndex = _ref4.rowOverscanStartIndex, rowOverscanStopIndex = _ref4.rowOverscanStopIndex, rowStartIndex = _ref4.rowStartIndex, rowStopIndex = _ref4.rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        }, _temp), (0, $a9e1528011c3c32e$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $a9e1528011c3c32e$var$_createClass3.default)(List, [
        {
            key: 'forceUpdateGrid',
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: 'getOffsetForRow',
            value: function getOffsetForRow(_ref5) {
                var alignment = _ref5.alignment, index = _ref5.index;
                if (this.Grid) {
                    var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), _scrollTop = _Grid$getOffsetForCel.scrollTop;
                    return _scrollTop;
                }
                return 0;
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref6) {
                var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'measureAllRows',
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'recomputeRowHeights',
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: 'scrollToPosition',
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: 'scrollToRow',
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, className = _props.className, noRowsRenderer = _props.noRowsRenderer, scrollToIndex = _props.scrollToIndex, width = _props.width;
                var classNames = (0, $a9e1528011c3c32e$var$_clsx2.default)('ReactVirtualized__List', className);
                return $a9e1528011c3c32e$var$React.createElement($a9e1528011c3c32e$var$_Grid2.default, (0, $a9e1528011c3c32e$var$_extends3.default)({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
    return List;
}($a9e1528011c3c32e$var$React.PureComponent);
$a9e1528011c3c32e$var$List.defaultProps = {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $648t0.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
};
$a9e1528011c3c32e$var$List.propTypes = null;
module.exports.default = $a9e1528011c3c32e$var$List;

});
parcelRegister("knQh8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ed6e817027dc4fd8$export$1e511d4a378977f5, (v) => $ed6e817027dc4fd8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ed6e817027dc4fd8$export$2e2bcd8739ae039, (v) => $ed6e817027dc4fd8$export$2e2bcd8739ae039 = v);
var $ed6e817027dc4fd8$export$1e511d4a378977f5;
var $ed6e817027dc4fd8$export$2e2bcd8739ae039;
"use strict";
$ed6e817027dc4fd8$export$1e511d4a378977f5 = true;

var $cjLx9 = parcelRequire("cjLx9");
var $ed6e817027dc4fd8$var$_assign2 = $ed6e817027dc4fd8$var$_interopRequireDefault($cjLx9);
function $ed6e817027dc4fd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ed6e817027dc4fd8$export$2e2bcd8739ae039 = $ed6e817027dc4fd8$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("cjLx9", function(module, exports) {

module.exports = {
    "default": (parcelRequire("6qqLf")),
    __esModule: true
};

});
parcelRegister("6qqLf", function(module, exports) {
parcelRequire("lsZw3");

module.exports = (parcelRequire("dv4GG")).Object.assign;

});
parcelRegister("lsZw3", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $8EFNH = parcelRequire("8EFNH");

$8EFNH($8EFNH.S + $8EFNH.F, 'Object', {
    assign: (parcelRequire("eCvdn"))
});

});
parcelRegister("eCvdn", function(module, exports) {
'use strict';

var $hn2oF = parcelRequire("hn2oF");

var $8rKxD = parcelRequire("8rKxD");

var $1Jjbj = parcelRequire("1Jjbj");

var $gvEJa = parcelRequire("gvEJa");

var $8tRkg = parcelRequire("8tRkg");

var $2A2jr = parcelRequire("2A2jr");
var $aa4cd3e3ae28fa7e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$aa4cd3e3ae28fa7e$var$$assign || (parcelRequire("5nD9T"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $aa4cd3e3ae28fa7e$var$$assign({}, A)[S] != 7 || Object.keys($aa4cd3e3ae28fa7e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $8tRkg(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $1Jjbj.f;
    var isEnum = $gvEJa.f;
    while(aLen > index){
        var S = $2A2jr(arguments[index++]);
        var keys = getSymbols ? $8rKxD(S).concat(getSymbols(S)) : $8rKxD(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$hn2oF || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $aa4cd3e3ae28fa7e$var$$assign;

});





parcelRegister("kSGvk", function(module, exports) {

module.exports = {
    "default": (parcelRequire("19mDf")),
    __esModule: true
};

});
parcelRegister("19mDf", function(module, exports) {
parcelRequire("lmqud");

var $dv4GG = parcelRequire("dv4GG");
var $0d682ff232370daf$require$$Object = $dv4GG.Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $0d682ff232370daf$require$$Object.getOwnPropertyDescriptor(it, key);
};

});
parcelRegister("lmqud", function(module, exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $59DzK = parcelRequire("59DzK");

var $56mOV = parcelRequire("56mOV");
var $f8d032b594247451$require$$getOwnPropertyDescriptor = $56mOV.f;

(parcelRequire("8iDav"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $f8d032b594247451$require$$getOwnPropertyDescriptor($59DzK(it), key);
    };
});

});



parcelRegister("648t0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellPosition = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.defaultOverscanIndicesGetter = module.exports.defaultCellRangeRenderer = module.exports.accessibilityOverscanIndicesGetter = module.exports.Grid = module.exports.default = undefined;

var $fqRL4 = parcelRequire("fqRL4");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($fqRL4).default;
    }
});
Object.defineProperty(module.exports, 'Grid', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($fqRL4).default;
    }
});

var $eAUMQ = parcelRequire("eAUMQ");
Object.defineProperty(module.exports, 'accessibilityOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($eAUMQ).default;
    }
});

var $4n59m = parcelRequire("4n59m");
Object.defineProperty(module.exports, 'defaultCellRangeRenderer', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($4n59m).default;
    }
});

var $3yG4I = parcelRequire("3yG4I");
Object.defineProperty(module.exports, 'defaultOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($3yG4I).default;
    }
});

var $7G6q0 = parcelRequire("7G6q0");
function $46a9af1c8a4ac81a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_NoContentRenderer = $7G6q0.bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Alignment = $7G6q0.bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_CellPosition = $7G6q0.bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellSize = $7G6q0.bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $7G6q0.bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_RenderedSection = $7G6q0.bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_CellRendererParams = $7G6q0.bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_Scroll = $7G6q0.bpfrpt_proptype_Scroll;

});
parcelRegister("fqRL4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var $cjLx9 = parcelRequire("cjLx9");
var $b3c2fbf6a4e71818$var$_assign2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($cjLx9);

var $knQh8 = parcelRequire("knQh8");
var $b3c2fbf6a4e71818$var$_extends3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($knQh8);

var $29Ol4 = parcelRequire("29Ol4");
var $b3c2fbf6a4e71818$var$_getPrototypeOf2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $b3c2fbf6a4e71818$var$_classCallCheck3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $b3c2fbf6a4e71818$var$_createClass3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $b3c2fbf6a4e71818$var$_possibleConstructorReturn3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $b3c2fbf6a4e71818$var$_inherits3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($gHLl6);

var $5uXOq = parcelRequire("5uXOq");
var $b3c2fbf6a4e71818$var$React = $b3c2fbf6a4e71818$var$_interopRequireWildcard($5uXOq);

var $hazy9 = parcelRequire("hazy9");
var $b3c2fbf6a4e71818$var$_clsx2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($hazy9);

var $5YXtN = parcelRequire("5YXtN");
var $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($5YXtN);

var $7LPqF = parcelRequire("7LPqF");
var $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($7LPqF);

var $18tv5 = parcelRequire("18tv5");
var $b3c2fbf6a4e71818$var$_createCallbackMemoizer2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($18tv5);

var $3yG4I = parcelRequire("3yG4I");
var $b3c2fbf6a4e71818$var$_defaultOverscanIndicesGetter2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($3yG4I);

var $dMJpU = parcelRequire("dMJpU");
var $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($dMJpU);

var $4n59m = parcelRequire("4n59m");
var $b3c2fbf6a4e71818$var$_defaultCellRangeRenderer2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($4n59m);

var $dzPmK = parcelRequire("dzPmK");
var $b3c2fbf6a4e71818$var$_scrollbarSize2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($dzPmK);

var $9mAr6 = parcelRequire("9mAr6");

var $cpGQi = parcelRequire("cpGQi");
parcelRequire("7G6q0");

var $8rCP3 = parcelRequire("8rCP3");
var $b3c2fbf6a4e71818$var$_propTypes2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($8rCP3);
function $b3c2fbf6a4e71818$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $b3c2fbf6a4e71818$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $b3c2fbf6a4e71818$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $b3c2fbf6a4e71818$var$renderNull = function renderNull() {
    return null;
};
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $b3c2fbf6a4e71818$var$Grid = function(_React$PureComponent) {
    (0, $b3c2fbf6a4e71818$var$_inherits3.default)(Grid, _React$PureComponent);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    function Grid(props) {
        (0, $b3c2fbf6a4e71818$var$_classCallCheck3.default)(this, Grid);
        var _this = (0, $b3c2fbf6a4e71818$var$_possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, $b3c2fbf6a4e71818$var$_getPrototypeOf2.default)(Grid)).call(this, props));
        _this._onGridRenderedMemoizer = (0, $b3c2fbf6a4e71818$var$_createCallbackMemoizer2.default)();
        _this._onScrollMemoizer = (0, $b3c2fbf6a4e71818$var$_createCallbackMemoizer2.default)(false);
        _this._deferredInvalidateColumnIndex = null;
        _this._deferredInvalidateRowIndex = null;
        _this._recomputeScrollLeftFlag = false;
        _this._recomputeScrollTopFlag = false;
        _this._horizontalScrollBarSize = 0;
        _this._verticalScrollBarSize = 0;
        _this._scrollbarPresenceChanged = false;
        _this._renderedColumnStartIndex = 0;
        _this._renderedColumnStopIndex = 0;
        _this._renderedRowStartIndex = 0;
        _this._renderedRowStopIndex = 0;
        _this._styleCache = {};
        _this._cellCache = {};
        _this._debounceScrollEndedCallback = function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        };
        _this._invokeOnGridRenderedHelper = function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        };
        _this._setScrollingContainerRef = function(ref) {
            _this._scrollingContainer = ref;
        };
        _this._onScroll = function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
        };
        var columnSizeAndPositionManager = new $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $3yG4I.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $3yG4I.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $b3c2fbf6a4e71818$var$_createClass3.default)(Grid, [
        {
            key: 'getOffsetForCell',
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, this.props, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: 'getTotalRowsHeight',
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'getTotalColumnsWidth',
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'handleScrollEvent',
            value: function handleScrollEvent(_ref2) {
                var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _props = this.props, autoHeight = _props.autoHeight, autoWidth = _props.autoWidth, height = _props.height, width = _props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState = {
                        isScrolling: true,
                        scrollDirectionHorizontal: _scrollDirectionHorizontal,
                        scrollDirectionVertical: _scrollDirectionVertical,
                        scrollPositionChangeReason: $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref3) {
                var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: 'measureAllCells',
            value: function measureAllCells() {
                var _props2 = this.props, columnCount = _props2.columnCount, rowCount = _props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
                var _props3 = this.props, scrollToColumn = _props3.scrollToColumn, scrollToRow = _props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $3yG4I.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $3yG4I.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: 'scrollToCell',
            value: function scrollToCell(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn((0, $b3c2fbf6a4e71818$var$_extends3.default)({}, props, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow((0, $b3c2fbf6a4e71818$var$_extends3.default)({}, props, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props4 = this.props, getScrollbarSize = _props4.getScrollbarSize, height = _props4.height, scrollLeft = _props4.scrollLeft, scrollToColumn = _props4.scrollToColumn, scrollTop = _props4.scrollTop, scrollToRow = _props4.scrollToRow, width = _props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, prevState, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props5 = this.props, autoHeight = _props5.autoHeight, autoWidth = _props5.autoWidth, columnCount = _props5.columnCount, height = _props5.height, rowCount = _props5.rowCount, scrollToAlignment = _props5.scrollToAlignment, scrollToColumn = _props5.scrollToColumn, scrollToRow = _props5.scrollToRow, width = _props5.width;
                var _state = this.state, scrollLeft = _state.scrollLeft, scrollPositionChangeReason = _state.scrollPositionChangeReason, scrollTop = _state.scrollTop, instanceProps = _state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $cpGQi.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props6 = this.props, autoContainerWidth = _props6.autoContainerWidth, autoHeight = _props6.autoHeight, autoWidth = _props6.autoWidth, className = _props6.className, containerProps = _props6.containerProps, containerRole = _props6.containerRole, containerStyle = _props6.containerStyle, height = _props6.height, id = _props6.id, noContentRenderer = _props6.noContentRenderer, role = _props6.role, style = _props6.style, tabIndex = _props6.tabIndex, width = _props6.width;
                var _state2 = this.state, instanceProps = _state2.instanceProps, needToResetStyleCache = _state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return $b3c2fbf6a4e71818$var$React.createElement('div', (0, $b3c2fbf6a4e71818$var$_extends3.default)({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    'aria-label': this.props['aria-label'],
                    'aria-readonly': this.props['aria-readonly'],
                    className: (0, $b3c2fbf6a4e71818$var$_clsx2.default)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, gridStyle, style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && $b3c2fbf6a4e71818$var$React.createElement('div', {
                    className: 'ReactVirtualized__Grid__innerScrollContainer',
                    role: containerRole,
                    style: (0, $b3c2fbf6a4e71818$var$_extends3.default)({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: '_calculateChildrenToRender',
            value: function _calculateChildrenToRender() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: '_debounceScrollEnded',
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $cpGQi.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $cpGQi.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: '_handleInvalidatedGridSize',
            /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: '_invokeOnScrollMemoizer',
            value: function _invokeOnScrollMemoizer(_ref6) {
                var _this3 = this;
                var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _props7 = _this3.props, height = _props7.height, onScroll = _props7.onScroll, width = _props7.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: '_isScrolling',
            value: function _isScrolling() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: '_maybeCallOnScrollbarPresenceChange',
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    _onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: 'scrollToPosition',
            /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ value: function scrollToPosition(_ref8) {
                var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: '_updateScrollLeftForScrollToColumn',
            value: function _updateScrollLeftForScrollToColumn() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: '_resetStyleCache',
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = rowIndex + '-' + columnIndex;
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: '_updateScrollTopForScrollToRow',
            value: function _updateScrollTopForScrollToRow() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) (0, $b3c2fbf6a4e71818$var$_assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) (0, $b3c2fbf6a4e71818$var$_assign2.default)(newState, {
                    isScrolling: false
                });
                var maybeStateA = void 0;
                var maybeStateB = void 0;
                (0, $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, newState, maybeStateA, maybeStateB);
            }
        },
        {
            key: '_getEstimatedColumnSize',
            value: function _getEstimatedColumnSize(props) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: '_getEstimatedRowSize',
            value: function _getEstimatedRowSize(props) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: '_getScrollToPositionStateUpdate',
            /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ value: function _getScrollToPositionStateUpdate(_ref9) {
                var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return null;
            }
        },
        {
            key: '_wrapSizeGetter',
            value: function _wrapSizeGetter(value) {
                return typeof value === 'function' ? value : function() {
                    return value;
                };
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft(nextProps, prevState) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollLeftForScrollToColumnStateUpdate',
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return null;
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop(nextProps, prevState) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollTopForScrollToRowStateUpdate',
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return null;
            }
        }
    ]);
    return Grid;
}($b3c2fbf6a4e71818$var$React.PureComponent);
$b3c2fbf6a4e71818$var$Grid.defaultProps = {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $b3c2fbf6a4e71818$var$_defaultCellRangeRenderer2.default,
    containerRole: 'rowgroup',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $b3c2fbf6a4e71818$var$_scrollbarSize2.default,
    noContentRenderer: $b3c2fbf6a4e71818$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $b3c2fbf6a4e71818$var$_defaultOverscanIndicesGetter2.default,
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $b3c2fbf6a4e71818$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
};
$b3c2fbf6a4e71818$var$Grid.propTypes = null;
(0, $9mAr6.polyfill)($b3c2fbf6a4e71818$var$Grid);
module.exports.default = $b3c2fbf6a4e71818$var$Grid;

});
parcelRegister("hazy9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $c7fef249cf6cf466$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $c7fef249cf6cf466$export$2e2bcd8739ae039);
function $c7fef249cf6cf466$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c7fef249cf6cf466$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c7fef249cf6cf466$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c7fef249cf6cf466$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c7fef249cf6cf466$export$2e2bcd8739ae039 = $c7fef249cf6cf466$export$4f5d2d50c9deca37;

});

parcelRegister("5YXtN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45b0b1bd0c27f2c2$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
function $45b0b1bd0c27f2c2$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
    var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
} /**
 * Helper method that determines when to recalculate row or column metadata.
 */ 

});

parcelRegister("7LPqF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1JRrJ = parcelRequire("1JRrJ");
var $5a84d0ec79150934$var$_objectWithoutProperties3 = $5a84d0ec79150934$var$_interopRequireDefault($1JRrJ);

var $aXTp8 = parcelRequire("aXTp8");
var $5a84d0ec79150934$var$_classCallCheck3 = $5a84d0ec79150934$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $5a84d0ec79150934$var$_createClass3 = $5a84d0ec79150934$var$_interopRequireDefault($4tLNB);

var $iCIeR = parcelRequire("iCIeR");
var $5a84d0ec79150934$var$_CellSizeAndPositionManager2 = $5a84d0ec79150934$var$_interopRequireDefault($iCIeR);

var $iLAay = parcelRequire("iLAay");
parcelRequire("7G6q0");
function $5a84d0ec79150934$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ var $5a84d0ec79150934$var$ScalingCellSizeAndPositionManager = function() {
    function ScalingCellSizeAndPositionManager(_ref) {
        var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === undefined ? (0, $iLAay.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $5a84d0ec79150934$var$_objectWithoutProperties3.default)(_ref, [
            'maxScrollSize'
        ]);
        (0, $5a84d0ec79150934$var$_classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $5a84d0ec79150934$var$_CellSizeAndPositionManager2.default(params);
        this._maxScrollSize = maxScrollSize;
    }
    (0, $5a84d0ec79150934$var$_createClass3.default)(ScalingCellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: 'configure',
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment(_ref2) {
                var containerSize = _ref2.containerSize, offset = _ref2.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(_ref4) {
                var containerSize = _ref4.containerSize, offset = _ref4.offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: '_getOffsetPercentage',
            value: function _getOffsetPercentage(_ref5) {
                var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: '_offsetToSafeOffset',
            value: function _offsetToSafeOffset(_ref6) {
                var containerSize = _ref6.containerSize, offset = _ref6.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: '_safeOffsetToOffset',
            value: function _safeOffsetToOffset(_ref7) {
                var containerSize = _ref7.containerSize, offset = _ref7.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
    return ScalingCellSizeAndPositionManager;
}();
module.exports.default = $5a84d0ec79150934$var$ScalingCellSizeAndPositionManager;

});
parcelRegister("1JRrJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $144373be65000f07$export$1e511d4a378977f5, (v) => $144373be65000f07$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $144373be65000f07$export$2e2bcd8739ae039, (v) => $144373be65000f07$export$2e2bcd8739ae039 = v);
var $144373be65000f07$export$1e511d4a378977f5;
var $144373be65000f07$export$2e2bcd8739ae039;
"use strict";
$144373be65000f07$export$1e511d4a378977f5 = true;
$144373be65000f07$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("iCIeR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aXTp8 = parcelRequire("aXTp8");
var $d8ee1776fff0aaf0$var$_classCallCheck3 = $d8ee1776fff0aaf0$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $d8ee1776fff0aaf0$var$_createClass3 = $d8ee1776fff0aaf0$var$_interopRequireDefault($4tLNB);
parcelRequire("7G6q0");
function $d8ee1776fff0aaf0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $d8ee1776fff0aaf0$var$CellSizeAndPositionManager = function() {
    // Used in deferred mode to track which cells have been queued for measurement.
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    function CellSizeAndPositionManager(_ref) {
        var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
        (0, $d8ee1776fff0aaf0$var$_classCallCheck3.default)(this, CellSizeAndPositionManager);
        this._cellSizeAndPositionData = {};
        this._lastMeasuredIndex = -1;
        this._lastBatchedIndex = -1;
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    (0, $d8ee1776fff0aaf0$var$_createClass3.default)(CellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: 'configure',
            value: function configure(_ref2) {
                var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellCount;
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._estimatedCellSize;
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                if (index < 0 || index >= this._cellCount) throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var _size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (_size === undefined || isNaN(_size)) throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
                        else if (_size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: _size
                            };
                            _offset += _size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset = void 0;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(params) {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: '_binarySearch',
            value: function _binarySearch(high, low, offset) {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (_currentOffset === offset) return middle;
                    else if (_currentOffset < offset) low = middle + 1;
                    else if (_currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: '_exponentialSearch',
            value: function _exponentialSearch(index, offset) {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: '_findNearestCell',
            value: function _findNearestCell(offset) {
                if (isNaN(offset)) throw Error('Invalid offset ' + offset + ' specified');
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
    return CellSizeAndPositionManager;
}();
module.exports.default = $d8ee1776fff0aaf0$var$CellSizeAndPositionManager;

});
parcelRegister("7G6q0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_VisibleCellRange = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_OverscanIndices = module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_ScrollbarPresenceChange = module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellSizeGetter = module.exports.bpfrpt_proptype_CellRangeRenderer = module.exports.bpfrpt_proptype_CellRangeRendererParams = module.exports.bpfrpt_proptype_StyleCache = module.exports.bpfrpt_proptype_CellCache = module.exports.bpfrpt_proptype_CellRenderer = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellPosition = undefined;

var $5uXOq = parcelRequire("5uXOq");
var $59716f33b0e6b532$var$React = $59716f33b0e6b532$var$_interopRequireWildcard($5uXOq);

var $7LPqF = parcelRequire("7LPqF");
var $59716f33b0e6b532$var$_ScalingCellSizeAndPositionManager2 = $59716f33b0e6b532$var$_interopRequireDefault($7LPqF);

var $8rCP3 = parcelRequire("8rCP3");
var $59716f33b0e6b532$var$_propTypes2 = $59716f33b0e6b532$var$_interopRequireDefault($8rCP3);
function $59716f33b0e6b532$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59716f33b0e6b532$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $59716f33b0e6b532$var$bpfrpt_proptype_CellPosition = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRendererParams = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRenderer = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellCache = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_StyleCache = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRendererParams = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRenderer = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellSizeGetter = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellSize = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_NoContentRenderer = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_Scroll = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_ScrollbarPresenceChange = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_RenderedSection = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetterParams = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndices = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetter = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_Alignment = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_VisibleCellRange = null;
module.exports.bpfrpt_proptype_CellPosition = $59716f33b0e6b532$var$bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellRendererParams = $59716f33b0e6b532$var$bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_CellRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_CellRenderer;
module.exports.bpfrpt_proptype_CellCache = $59716f33b0e6b532$var$bpfrpt_proptype_CellCache;
module.exports.bpfrpt_proptype_StyleCache = $59716f33b0e6b532$var$bpfrpt_proptype_StyleCache;
module.exports.bpfrpt_proptype_CellRangeRendererParams = $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRendererParams;
module.exports.bpfrpt_proptype_CellRangeRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRenderer;
module.exports.bpfrpt_proptype_CellSizeGetter = $59716f33b0e6b532$var$bpfrpt_proptype_CellSizeGetter;
module.exports.bpfrpt_proptype_CellSize = $59716f33b0e6b532$var$bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_NoContentRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Scroll = $59716f33b0e6b532$var$bpfrpt_proptype_Scroll;
module.exports.bpfrpt_proptype_ScrollbarPresenceChange = $59716f33b0e6b532$var$bpfrpt_proptype_ScrollbarPresenceChange;
module.exports.bpfrpt_proptype_RenderedSection = $59716f33b0e6b532$var$bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetterParams;
module.exports.bpfrpt_proptype_OverscanIndices = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndices;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_Alignment = $59716f33b0e6b532$var$bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_VisibleCellRange = $59716f33b0e6b532$var$bpfrpt_proptype_VisibleCellRange;

});


parcelRegister("iLAay", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $da98ac3c245269b0$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $da98ac3c245269b0$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $da98ac3c245269b0$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $da98ac3c245269b0$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $da98ac3c245269b0$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() {
    if ($da98ac3c245269b0$var$isBrowser()) {
        if ($da98ac3c245269b0$var$isChrome()) return $da98ac3c245269b0$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $da98ac3c245269b0$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("18tv5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9lQFv = parcelRequire("9lQFv");
var $0d3d6bf35b624a82$var$_keys2 = $0d3d6bf35b624a82$var$_interopRequireDefault($9lQFv);
module.exports.default = $0d3d6bf35b624a82$var$createCallbackMemoizer;
function $0d3d6bf35b624a82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $0d3d6bf35b624a82$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = (0, $0d3d6bf35b624a82$var$_keys2.default)(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== (0, $0d3d6bf35b624a82$var$_keys2.default)(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});
parcelRegister("9lQFv", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gOLKn")),
    __esModule: true
};

});
parcelRegister("gOLKn", function(module, exports) {
parcelRequire("9Swt2");

module.exports = (parcelRequire("dv4GG")).Object.keys;

});
parcelRegister("9Swt2", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $8tRkg = parcelRequire("8tRkg");

var $8rKxD = parcelRequire("8rKxD");

(parcelRequire("8iDav"))('keys', function() {
    return function keys(it) {
        return $8rKxD($8tRkg(it));
    };
});

});




parcelRegister("3yG4I", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $29752f486201a5cb$var$defaultOverscanIndicesGetter;
parcelRequire("7G6q0");
var $29752f486201a5cb$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $29752f486201a5cb$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $29752f486201a5cb$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $29752f486201a5cb$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $29752f486201a5cb$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    if (scrollDirection === $29752f486201a5cb$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("dMJpU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a092fce61c6915f9$var$updateScrollIndexHelper;

var $7LPqF = parcelRequire("7LPqF");
var $a092fce61c6915f9$var$_ScalingCellSizeAndPositionManager2 = $a092fce61c6915f9$var$_interopRequireDefault($7LPqF);
parcelRequire("7G6q0");
function $a092fce61c6915f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ function $a092fce61c6915f9$var$updateScrollIndexHelper(_ref) {
    var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("4n59m", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32ed4e129ee96b29$var$defaultCellRangeRenderer;
parcelRequire("7G6q0");
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $32ed4e129ee96b29$var$defaultCellRangeRenderer(_ref) {
    var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = rowIndex + '-' + columnIndex;
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $32ed4e129ee96b29$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("dzPmK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9e266377030444a5$export$2e2bcd8739ae039);

var $5B5cv = parcelRequire("5B5cv");
var $9e266377030444a5$var$size;
function $9e266377030444a5$export$2e2bcd8739ae039(recalc) {
    if (!$9e266377030444a5$var$size && $9e266377030444a5$var$size !== 0 || recalc) {
        if (0, $5B5cv.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9e266377030444a5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9e266377030444a5$var$size;
}

});
parcelRegister("5B5cv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4134712f1bdfe873$export$2e2bcd8739ae039);
var $4134712f1bdfe873$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("9mAr6", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $6d126e96e4dcb8d7$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $6d126e96e4dcb8d7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $6d126e96e4dcb8d7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $6d126e96e4dcb8d7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$6d126e96e4dcb8d7$var$componentWillMount.__suppressDeprecationWarning = true;
$6d126e96e4dcb8d7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$6d126e96e4dcb8d7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $6d126e96e4dcb8d7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $6d126e96e4dcb8d7$var$componentWillMount;
        prototype.componentWillReceiveProps = $6d126e96e4dcb8d7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $6d126e96e4dcb8d7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("cpGQi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_AnimationTimeoutId = module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = undefined;

var $i67QH = parcelRequire("i67QH");
var $90990d7bb4c83bf1$var$_promise2 = $90990d7bb4c83bf1$var$_interopRequireDefault($i67QH);

var $b81LX = parcelRequire("b81LX");

var $8rCP3 = parcelRequire("8rCP3");
var $90990d7bb4c83bf1$var$_propTypes2 = $90990d7bb4c83bf1$var$_interopRequireDefault($8rCP3);
function $90990d7bb4c83bf1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $90990d7bb4c83bf1$var$bpfrpt_proptype_AnimationTimeoutId = null;
var $90990d7bb4c83bf1$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
    return (0, $b81LX.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $90990d7bb4c83bf1$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
    var start = void 0;
    // wait for end of processing current event handler, because event handler may be long
    $90990d7bb4c83bf1$var$_promise2.default.resolve().then(function() {
        start = Date.now();
    });
    var timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $b81LX.raf)(timeout);
    };
    var frame = {
        id: (0, $b81LX.raf)(timeout)
    };
    return frame;
};
module.exports.bpfrpt_proptype_AnimationTimeoutId = $90990d7bb4c83bf1$var$bpfrpt_proptype_AnimationTimeoutId;

});
parcelRegister("i67QH", function(module, exports) {

module.exports = {
    "default": (parcelRequire("ftBor")),
    __esModule: true
};

});
parcelRegister("ftBor", function(module, exports) {
parcelRequire("55SkS");
parcelRequire("ltQ0T");
parcelRequire("fQXw1");
parcelRequire("8slOX");
parcelRequire("hsmRz");
parcelRequire("6B7zO");

module.exports = (parcelRequire("dv4GG")).Promise;

});
parcelRegister("8slOX", function(module, exports) {
'use strict';

var $6uq1C = parcelRequire("6uq1C");

var $pe18r = parcelRequire("pe18r");

var $gnejD = parcelRequire("gnejD");

var $fdKPE = parcelRequire("fdKPE");

var $8EFNH = parcelRequire("8EFNH");

var $6VwBm = parcelRequire("6VwBm");

var $jd5tk = parcelRequire("jd5tk");

var $igM2P = parcelRequire("igM2P");

var $2TQW8 = parcelRequire("2TQW8");

var $PVFqE = parcelRequire("PVFqE");

var $kA9gG = parcelRequire("kA9gG");
var $6281dd6c370e2cd1$require$task = $kA9gG.set;

var $6281dd6c370e2cd1$var$microtask = (parcelRequire("cKTs5"))();

var $jtCbh = parcelRequire("jtCbh");

var $5kpnZ = parcelRequire("5kpnZ");

var $8JzcF = parcelRequire("8JzcF");

var $7MV4M = parcelRequire("7MV4M");
var $6281dd6c370e2cd1$var$PROMISE = 'Promise';
var $6281dd6c370e2cd1$var$TypeError = $pe18r.TypeError;
var $6281dd6c370e2cd1$var$process = $pe18r.process;
var $6281dd6c370e2cd1$var$versions = $6281dd6c370e2cd1$var$process && $6281dd6c370e2cd1$var$process.versions;
var $6281dd6c370e2cd1$var$v8 = $6281dd6c370e2cd1$var$versions && $6281dd6c370e2cd1$var$versions.v8 || '';
var $6281dd6c370e2cd1$var$$Promise = $pe18r[$6281dd6c370e2cd1$var$PROMISE];
var $6281dd6c370e2cd1$var$isNode = $fdKPE($6281dd6c370e2cd1$var$process) == 'process';
var $6281dd6c370e2cd1$var$empty = function() {};
var $6281dd6c370e2cd1$var$Internal, $6281dd6c370e2cd1$var$newGenericPromiseCapability, $6281dd6c370e2cd1$var$OwnPromiseCapability, $6281dd6c370e2cd1$var$Wrapper;
var $6281dd6c370e2cd1$var$newPromiseCapability = $6281dd6c370e2cd1$var$newGenericPromiseCapability = $jtCbh.f;

var $6281dd6c370e2cd1$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $6281dd6c370e2cd1$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("cNfss"))('species')] = function(exec) {
            exec($6281dd6c370e2cd1$var$empty, $6281dd6c370e2cd1$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($6281dd6c370e2cd1$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($6281dd6c370e2cd1$var$empty) instanceof FakePromise && $6281dd6c370e2cd1$var$v8.indexOf('6.6') !== 0 && $8JzcF.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $6281dd6c370e2cd1$var$isThenable = function(it) {
    var then;
    return $6VwBm(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $6281dd6c370e2cd1$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $6281dd6c370e2cd1$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $6281dd6c370e2cd1$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($6281dd6c370e2cd1$var$TypeError('Promise-chain cycle'));
                    else if (then = $6281dd6c370e2cd1$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $6281dd6c370e2cd1$var$onUnhandled(promise);
    });
};
var $6281dd6c370e2cd1$var$onUnhandled = function(promise) {
    $6281dd6c370e2cd1$require$task.call($pe18r, function() {
        var value = promise._v;
        var unhandled = $6281dd6c370e2cd1$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $5kpnZ(function() {
                if ($6281dd6c370e2cd1$var$isNode) $6281dd6c370e2cd1$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $pe18r.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $pe18r.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $6281dd6c370e2cd1$var$isNode || $6281dd6c370e2cd1$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $6281dd6c370e2cd1$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $6281dd6c370e2cd1$var$onHandleUnhandled = function(promise) {
    $6281dd6c370e2cd1$require$task.call($pe18r, function() {
        var handler;
        if ($6281dd6c370e2cd1$var$isNode) $6281dd6c370e2cd1$var$process.emit('rejectionHandled', promise);
        else if (handler = $pe18r.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $6281dd6c370e2cd1$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $6281dd6c370e2cd1$var$notify(promise, true);
};
var $6281dd6c370e2cd1$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $6281dd6c370e2cd1$var$TypeError("Promise can't be resolved itself");
        if (then = $6281dd6c370e2cd1$var$isThenable(value)) $6281dd6c370e2cd1$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $gnejD($6281dd6c370e2cd1$var$$resolve, wrapper, 1), $gnejD($6281dd6c370e2cd1$var$$reject, wrapper, 1));
            } catch (e) {
                $6281dd6c370e2cd1$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $6281dd6c370e2cd1$var$notify(promise, false);
        }
    } catch (e) {
        $6281dd6c370e2cd1$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$6281dd6c370e2cd1$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $6281dd6c370e2cd1$var$$Promise = function Promise(executor) {
        $igM2P(this, $6281dd6c370e2cd1$var$$Promise, $6281dd6c370e2cd1$var$PROMISE, '_h');
        $jd5tk(executor);
        $6281dd6c370e2cd1$var$Internal.call(this);
        try {
            executor($gnejD($6281dd6c370e2cd1$var$$resolve, this, 1), $gnejD($6281dd6c370e2cd1$var$$reject, this, 1));
        } catch (err) {
            $6281dd6c370e2cd1$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $6281dd6c370e2cd1$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $6281dd6c370e2cd1$var$Internal.prototype = (parcelRequire("5zUXP"))($6281dd6c370e2cd1$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $6281dd6c370e2cd1$var$newPromiseCapability($PVFqE(this, $6281dd6c370e2cd1$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $6281dd6c370e2cd1$var$isNode ? $6281dd6c370e2cd1$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $6281dd6c370e2cd1$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $6281dd6c370e2cd1$var$OwnPromiseCapability = function() {
        var promise = new $6281dd6c370e2cd1$var$Internal();
        this.promise = promise;
        this.resolve = $gnejD($6281dd6c370e2cd1$var$$resolve, promise, 1);
        this.reject = $gnejD($6281dd6c370e2cd1$var$$reject, promise, 1);
    };
    $jtCbh.f = $6281dd6c370e2cd1$var$newPromiseCapability = function(C) {
        return C === $6281dd6c370e2cd1$var$$Promise || C === $6281dd6c370e2cd1$var$Wrapper ? new $6281dd6c370e2cd1$var$OwnPromiseCapability(C) : $6281dd6c370e2cd1$var$newGenericPromiseCapability(C);
    };
}
$8EFNH($8EFNH.G + $8EFNH.W + $8EFNH.F * !$6281dd6c370e2cd1$var$USE_NATIVE, {
    Promise: $6281dd6c370e2cd1$var$$Promise
});

(parcelRequire("8nOHH"))($6281dd6c370e2cd1$var$$Promise, $6281dd6c370e2cd1$var$PROMISE);

(parcelRequire("jamSJ"))($6281dd6c370e2cd1$var$PROMISE);

$6281dd6c370e2cd1$var$Wrapper = (parcelRequire("dv4GG"))[$6281dd6c370e2cd1$var$PROMISE];
// statics
$8EFNH($8EFNH.S + $8EFNH.F * !$6281dd6c370e2cd1$var$USE_NATIVE, $6281dd6c370e2cd1$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $6281dd6c370e2cd1$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$8EFNH($8EFNH.S + $8EFNH.F * ($6uq1C || !$6281dd6c370e2cd1$var$USE_NATIVE), $6281dd6c370e2cd1$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $7MV4M($6uq1C && this === $6281dd6c370e2cd1$var$Wrapper ? $6281dd6c370e2cd1$var$$Promise : this, x);
    }
});

$8EFNH($8EFNH.S + $8EFNH.F * !($6281dd6c370e2cd1$var$USE_NATIVE && (parcelRequire("elGHS"))(function(iter) {
    $6281dd6c370e2cd1$var$$Promise.all(iter)['catch']($6281dd6c370e2cd1$var$empty);
})), $6281dd6c370e2cd1$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $6281dd6c370e2cd1$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $5kpnZ(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $2TQW8(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $6281dd6c370e2cd1$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $5kpnZ(function() {
            $2TQW8(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});

});
parcelRegister("fdKPE", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $eYYzh = parcelRequire("eYYzh");

var $b14c65c3bdb05e47$var$TAG = (parcelRequire("cNfss"))('toStringTag');
// ES3 wrong here
var $b14c65c3bdb05e47$var$ARG = $eYYzh(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $b14c65c3bdb05e47$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $b14c65c3bdb05e47$var$tryGet(O = Object(it), $b14c65c3bdb05e47$var$TAG)) == 'string' ? T : $b14c65c3bdb05e47$var$ARG ? $eYYzh(O) : (B = $eYYzh(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("igM2P", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("2TQW8", function(module, exports) {

var $gnejD = parcelRequire("gnejD");

var $37EOk = parcelRequire("37EOk");

var $k9WWH = parcelRequire("k9WWH");

var $6rs9h = parcelRequire("6rs9h");

var $lpAeO = parcelRequire("lpAeO");

var $d2ywt = parcelRequire("d2ywt");
var $21c9c7ef76660cf1$var$BREAK = {};
var $21c9c7ef76660cf1$var$RETURN = {};
var $21c9c7ef76660cf1$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $d2ywt(iterable);
    var f = $gnejD(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($k9WWH(iterFn)) for(length = $lpAeO(iterable.length); length > index; index++){
        result = entries ? f($6rs9h(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $21c9c7ef76660cf1$var$BREAK || result === $21c9c7ef76660cf1$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $37EOk(iterator, f, step.value, entries);
        if (result === $21c9c7ef76660cf1$var$BREAK || result === $21c9c7ef76660cf1$var$RETURN) return result;
    }
};
$21c9c7ef76660cf1$var$exports.BREAK = $21c9c7ef76660cf1$var$BREAK;
$21c9c7ef76660cf1$var$exports.RETURN = $21c9c7ef76660cf1$var$RETURN;

});
parcelRegister("37EOk", function(module, exports) {
// call something on iterator step with safe closing on error

var $6rs9h = parcelRequire("6rs9h");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($6rs9h(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $6rs9h(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("k9WWH", function(module, exports) {
// check on default Array iterator

var $eu895 = parcelRequire("eu895");

var $ead25f519c61448a$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
var $ead25f519c61448a$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($eu895.Array === it || $ead25f519c61448a$var$ArrayProto[$ead25f519c61448a$var$ITERATOR] === it);
};

});

parcelRegister("d2ywt", function(module, exports) {

var $fdKPE = parcelRequire("fdKPE");

var $97e63dbe95e0d522$var$ITERATOR = (parcelRequire("cNfss"))('iterator');

var $eu895 = parcelRequire("eu895");

module.exports = (parcelRequire("dv4GG")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$97e63dbe95e0d522$var$ITERATOR] || it['@@iterator'] || $eu895[$fdKPE(it)];
};

});


parcelRegister("PVFqE", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $6rs9h = parcelRequire("6rs9h");

var $jd5tk = parcelRequire("jd5tk");

var $09c17f0a7250e5e6$var$SPECIES = (parcelRequire("cNfss"))('species');
module.exports = function(O, D) {
    var C = $6rs9h(O).constructor;
    var S;
    return C === undefined || (S = $6rs9h(C)[$09c17f0a7250e5e6$var$SPECIES]) == undefined ? D : $jd5tk(S);
};

});

parcelRegister("kA9gG", function(module, exports) {

var $gnejD = parcelRequire("gnejD");

var $e1fBW = parcelRequire("e1fBW");

var $fW23X = parcelRequire("fW23X");

var $iSIdA = parcelRequire("iSIdA");

var $pe18r = parcelRequire("pe18r");
var $efbe5bdf019a1027$var$process = $pe18r.process;
var $efbe5bdf019a1027$var$setTask = $pe18r.setImmediate;
var $efbe5bdf019a1027$var$clearTask = $pe18r.clearImmediate;
var $efbe5bdf019a1027$var$MessageChannel = $pe18r.MessageChannel;
var $efbe5bdf019a1027$var$Dispatch = $pe18r.Dispatch;
var $efbe5bdf019a1027$var$counter = 0;
var $efbe5bdf019a1027$var$queue = {};
var $efbe5bdf019a1027$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $efbe5bdf019a1027$var$defer, $efbe5bdf019a1027$var$channel, $efbe5bdf019a1027$var$port;
var $efbe5bdf019a1027$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($efbe5bdf019a1027$var$queue.hasOwnProperty(id)) {
        var fn = $efbe5bdf019a1027$var$queue[id];
        delete $efbe5bdf019a1027$var$queue[id];
        fn();
    }
};
var $efbe5bdf019a1027$var$listener = function(event) {
    $efbe5bdf019a1027$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$efbe5bdf019a1027$var$setTask || !$efbe5bdf019a1027$var$clearTask) {
    $efbe5bdf019a1027$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $efbe5bdf019a1027$var$queue[++$efbe5bdf019a1027$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $e1fBW(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $efbe5bdf019a1027$var$defer($efbe5bdf019a1027$var$counter);
        return $efbe5bdf019a1027$var$counter;
    };
    $efbe5bdf019a1027$var$clearTask = function clearImmediate(id) {
        delete $efbe5bdf019a1027$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("eYYzh"))($efbe5bdf019a1027$var$process) == 'process') $efbe5bdf019a1027$var$defer = function(id) {
        $efbe5bdf019a1027$var$process.nextTick($gnejD($efbe5bdf019a1027$var$run, id, 1));
    };
    else if ($efbe5bdf019a1027$var$Dispatch && $efbe5bdf019a1027$var$Dispatch.now) $efbe5bdf019a1027$var$defer = function(id) {
        $efbe5bdf019a1027$var$Dispatch.now($gnejD($efbe5bdf019a1027$var$run, id, 1));
    };
    else if ($efbe5bdf019a1027$var$MessageChannel) {
        $efbe5bdf019a1027$var$channel = new $efbe5bdf019a1027$var$MessageChannel();
        $efbe5bdf019a1027$var$port = $efbe5bdf019a1027$var$channel.port2;
        $efbe5bdf019a1027$var$channel.port1.onmessage = $efbe5bdf019a1027$var$listener;
        $efbe5bdf019a1027$var$defer = $gnejD($efbe5bdf019a1027$var$port.postMessage, $efbe5bdf019a1027$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($pe18r.addEventListener && typeof postMessage == 'function' && !$pe18r.importScripts) {
        $efbe5bdf019a1027$var$defer = function(id) {
            $pe18r.postMessage(id + '', '*');
        };
        $pe18r.addEventListener('message', $efbe5bdf019a1027$var$listener, false);
    // IE8-
    } else if ($efbe5bdf019a1027$var$ONREADYSTATECHANGE in $iSIdA('script')) $efbe5bdf019a1027$var$defer = function(id) {
        $fW23X.appendChild($iSIdA('script'))[$efbe5bdf019a1027$var$ONREADYSTATECHANGE] = function() {
            $fW23X.removeChild(this);
            $efbe5bdf019a1027$var$run.call(id);
        };
    };
    else $efbe5bdf019a1027$var$defer = function(id) {
        setTimeout($gnejD($efbe5bdf019a1027$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $efbe5bdf019a1027$var$setTask,
    clear: $efbe5bdf019a1027$var$clearTask
};

});
parcelRegister("e1fBW", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("cKTs5", function(module, exports) {

var $pe18r = parcelRequire("pe18r");

var $kA9gG = parcelRequire("kA9gG");
var $9494cb828a53d78d$require$macrotask = $kA9gG.set;
var $9494cb828a53d78d$var$Observer = $pe18r.MutationObserver || $pe18r.WebKitMutationObserver;
var $9494cb828a53d78d$var$process = $pe18r.process;
var $9494cb828a53d78d$var$Promise = $pe18r.Promise;

var $9494cb828a53d78d$var$isNode = (parcelRequire("eYYzh"))($9494cb828a53d78d$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($9494cb828a53d78d$var$isNode && (parent = $9494cb828a53d78d$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($9494cb828a53d78d$var$isNode) notify = function() {
        $9494cb828a53d78d$var$process.nextTick(flush);
    };
    else if ($9494cb828a53d78d$var$Observer && !($pe18r.navigator && $pe18r.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $9494cb828a53d78d$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($9494cb828a53d78d$var$Promise && $9494cb828a53d78d$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $9494cb828a53d78d$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $9494cb828a53d78d$require$macrotask.call($pe18r, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});

parcelRegister("jtCbh", function(module, exports) {

$parcel$export(module.exports, "f", () => $e2de57b30462e7a3$export$2d1720544b23b823, (v) => $e2de57b30462e7a3$export$2d1720544b23b823 = v);
var $e2de57b30462e7a3$export$2d1720544b23b823;
'use strict';

var $jd5tk = parcelRequire("jd5tk");
function $e2de57b30462e7a3$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $jd5tk(resolve);
    this.reject = $jd5tk(reject);
}
$e2de57b30462e7a3$export$2d1720544b23b823 = function(C) {
    return new $e2de57b30462e7a3$var$PromiseCapability(C);
};

});

parcelRegister("5kpnZ", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};

});

parcelRegister("8JzcF", function(module, exports) {

var $pe18r = parcelRequire("pe18r");
var $65bdd555fa77483e$var$navigator = $pe18r.navigator;
module.exports = $65bdd555fa77483e$var$navigator && $65bdd555fa77483e$var$navigator.userAgent || '';

});

parcelRegister("7MV4M", function(module, exports) {

var $6rs9h = parcelRequire("6rs9h");

var $6VwBm = parcelRequire("6VwBm");

var $jtCbh = parcelRequire("jtCbh");
module.exports = function(C, x) {
    $6rs9h(C);
    if ($6VwBm(x) && x.constructor === C) return x;
    var promiseCapability = $jtCbh.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});

parcelRegister("5zUXP", function(module, exports) {

var $kM6mh = parcelRequire("kM6mh");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $kM6mh(target, key, src[key]);
    return target;
};

});

parcelRegister("jamSJ", function(module, exports) {
'use strict';

var $pe18r = parcelRequire("pe18r");

var $dv4GG = parcelRequire("dv4GG");

var $30LaA = parcelRequire("30LaA");

var $hn2oF = parcelRequire("hn2oF");

var $df40b35a3c8f3122$var$SPECIES = (parcelRequire("cNfss"))('species');
module.exports = function(KEY) {
    var C = typeof $dv4GG[KEY] == 'function' ? $dv4GG[KEY] : $pe18r[KEY];
    if ($hn2oF && C && !C[$df40b35a3c8f3122$var$SPECIES]) $30LaA.f(C, $df40b35a3c8f3122$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("elGHS", function(module, exports) {

var $a724277d1d92a3aa$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
var $a724277d1d92a3aa$var$SAFE_CLOSING = false;
try {
    var $a724277d1d92a3aa$var$riter = [
        7
    ][$a724277d1d92a3aa$var$ITERATOR]();
    $a724277d1d92a3aa$var$riter['return'] = function() {
        $a724277d1d92a3aa$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($a724277d1d92a3aa$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$a724277d1d92a3aa$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$a724277d1d92a3aa$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$a724277d1d92a3aa$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});


parcelRegister("hsmRz", function(module, exports) {
// https://github.com/tc39/proposal-promise-finally
'use strict';

var $8EFNH = parcelRequire("8EFNH");

var $dv4GG = parcelRequire("dv4GG");

var $pe18r = parcelRequire("pe18r");

var $PVFqE = parcelRequire("PVFqE");

var $7MV4M = parcelRequire("7MV4M");
$8EFNH($8EFNH.P + $8EFNH.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $PVFqE(this, $dv4GG.Promise || $pe18r.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $7MV4M(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $7MV4M(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});

});

parcelRegister("6B7zO", function(module, exports) {
'use strict';

var $8EFNH = parcelRequire("8EFNH");

var $jtCbh = parcelRequire("jtCbh");

var $5kpnZ = parcelRequire("5kpnZ");
$8EFNH($8EFNH.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $jtCbh.f(this);
        var result = $5kpnZ(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});

});



parcelRegister("b81LX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Properly handle server-side rendering.
var $81a1d1111f5cbdf9$var$win = void 0;
if (typeof window !== 'undefined') $81a1d1111f5cbdf9$var$win = window;
else if (typeof self !== 'undefined') $81a1d1111f5cbdf9$var$win = self;
else $81a1d1111f5cbdf9$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $81a1d1111f5cbdf9$var$request = $81a1d1111f5cbdf9$var$win.requestAnimationFrame || $81a1d1111f5cbdf9$var$win.webkitRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.mozRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.oRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.msRequestAnimationFrame || function(callback) {
    return $81a1d1111f5cbdf9$var$win.setTimeout(callback, 1000 / 60);
};
var $81a1d1111f5cbdf9$var$cancel = $81a1d1111f5cbdf9$var$win.cancelAnimationFrame || $81a1d1111f5cbdf9$var$win.webkitCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.mozCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.oCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.msCancelAnimationFrame || function(id) {
    $81a1d1111f5cbdf9$var$win.clearTimeout(id);
};
var $81a1d1111f5cbdf9$var$raf = module.exports.raf = $81a1d1111f5cbdf9$var$request;
var $81a1d1111f5cbdf9$var$caf = module.exports.caf = $81a1d1111f5cbdf9$var$cancel;

});



parcelRegister("eAUMQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $aa007a26dd1d5a11$var$defaultOverscanIndicesGetter;
parcelRequire("7G6q0");
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $aa007a26dd1d5a11$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $aa007a26dd1d5a11$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});


parcelRegister("2AKv3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_RenderedRows = module.exports.bpfrpt_proptype_RowRenderer = module.exports.bpfrpt_proptype_RowRendererParams = undefined;

var $5uXOq = parcelRequire("5uXOq");
var $1e3303757d69af0d$var$React = $1e3303757d69af0d$var$_interopRequireWildcard($5uXOq);

var $8rCP3 = parcelRequire("8rCP3");
var $1e3303757d69af0d$var$_propTypes2 = $1e3303757d69af0d$var$_interopRequireDefault($8rCP3);
function $1e3303757d69af0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1e3303757d69af0d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $1e3303757d69af0d$var$bpfrpt_proptype_RowRendererParams = null;
var $1e3303757d69af0d$var$bpfrpt_proptype_RowRenderer = null;
var $1e3303757d69af0d$var$bpfrpt_proptype_RenderedRows = null;
var $1e3303757d69af0d$var$bpfrpt_proptype_Scroll = null;
module.exports.bpfrpt_proptype_RowRendererParams = $1e3303757d69af0d$var$bpfrpt_proptype_RowRendererParams;
module.exports.bpfrpt_proptype_RowRenderer = $1e3303757d69af0d$var$bpfrpt_proptype_RowRenderer;
module.exports.bpfrpt_proptype_RenderedRows = $1e3303757d69af0d$var$bpfrpt_proptype_RenderedRows;
module.exports.bpfrpt_proptype_Scroll = $1e3303757d69af0d$var$bpfrpt_proptype_Scroll;

});



parcelRegister("96cc5", function(module, exports) {

$parcel$export(module.exports, "ListRow", () => $2e506314683cadb6$export$c36f87108246a02a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $2e506314683cadb6$export$c36f87108246a02a({ children: children, registerChild: registerChild, measure: measure, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }) {
    const childElementRef = (0, $5uXOq.useRef)(null);
    const setListElementRef = (element)=>{
        registerChild?.(element ?? undefined);
    };
    (0, $5uXOq.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>measure());
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: setListElementRef,
        style: style,
        "data-index": index,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: childElementRef,
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: onMouseMove,
            children: children
        })
    }));
}

});

parcelRegister("gIpUw", function(module, exports) {

$parcel$export(module.exports, "TypeAheadListItem", () => $2ed08364f40e4ff0$export$913373331e95c13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $awTmI = parcelRequire("awTmI");

var $5tY4R = parcelRequire("5tY4R");

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $iHYdz = parcelRequire("iHYdz");

var $24JcV = parcelRequire("24JcV");

var $kJpBP = parcelRequire("kJpBP");

function $2ed08364f40e4ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ed08364f40e4ff0$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `1px solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $2ed08364f40e4ff0$var$itemIconSize = {
    name: "4y81cs",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);svg:first-of-type{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $2ed08364f40e4ff0$var$itemText = /*#__PURE__*/ (0, $f8Sb3.css)({
    whiteSpace: 'initial',
    color: `${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`}`
});
const $2ed08364f40e4ff0$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $2ed08364f40e4ff0$var$itemTitleOverride = {
    name: "1th4nak",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $2ed08364f40e4ff0$var$itemDescription = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $iHYdz.relativeFontSizeToBase16)(12)};`,
    color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $2ed08364f40e4ff0$var$itemDescriptionOverride = {
    name: "7ynmig",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$customRenderItemDivStyle = /*#__PURE__*/ (0, $f8Sb3.css)("overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`, ";outline:none;}");
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $2ed08364f40e4ff0$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`,
        backgroundColor: `${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$selectedStyle = /*#__PURE__*/ (0, $f8Sb3.css)("background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`, ";box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";");
const $2ed08364f40e4ff0$var$disabledStyle = {
    name: "16lzvw8",
    styles: "color:var(--ds-text-disabled, #091E424F)"
};
const $2ed08364f40e4ff0$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ label: label })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5tY4R.default), null);
});
const $2ed08364f40e4ff0$var$noop = ()=>{};
const $2ed08364f40e4ff0$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $5uXOq.useMemo)(()=>{
        return [
            $2ed08364f40e4ff0$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $2ed08364f40e4ff0$var$selectedStyle,
            itemIsDisabled && $2ed08364f40e4ff0$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $2ed08364f40e4ff0$var$noop
    })));
});
const $2ed08364f40e4ff0$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex })=>{
    const { connectivityState: connectivityState } = (0, $awTmI.useSharedPluginState)(api, [
        'connectivity'
    ]);
    const isItemDisabled = (item)=>connectivityState?.mode === 'offline' && (item?.isDisabledOffline ?? false);
    const itemIsDisabled = isItemDisabled(item);
    const isFirstEnabledIndex = connectivityState?.mode === 'offline' && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityState === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $koVbs.default)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $8ptyJ.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $2ed08364f40e4ff0$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemIconSize
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $f8Sb3.jsx)($2ed08364f40e4ff0$var$FallbackIcon, {
            label: title
        }));
    }, [
        icon,
        title,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $5uXOq.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $3UtTx.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex;
    const listItemClasses = (0, $5uXOq.useMemo)(()=>{
        return [
            $2ed08364f40e4ff0$var$selectionFrame,
            isSelected && !itemIsDisabled && $2ed08364f40e4ff0$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) customItemRef?.current?.focus();
    }, [
        customItemRef,
        shouldUpdateFocus
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) buttonItemRef?.current?.focus();
    }, [
        buttonItemRef,
        shouldUpdateFocus
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $f8Sb3.jsx)($2ed08364f40e4ff0$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: listItemClasses
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        // TODO: ED-26959 - aria-description is in draft for ARIA 1.3.
        // For now replace it with aria-describedby.
        // eslint-disable-next-line jsx-a11y/aria-props
        "aria-description": `${descriptionText} ${shortcutText}`,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2ed08364f40e4ff0$var$itemText
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2ed08364f40e4ff0$var$itemBody
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2ed08364f40e4ff0$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemTitleOverride,
            itemIsDisabled && $2ed08364f40e4ff0$var$disabledStyle
        ]
    }, item.title), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2ed08364f40e4ff0$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $24JcV.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2ed08364f40e4ff0$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemDescriptionOverride,
            itemIsDisabled && $2ed08364f40e4ff0$var$disabledStyle
        ]
    }, item.description))))));
});

});
parcelRegister("5tY4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c3a69629e592a00$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6v7Sc = parcelRequire("6v7Sc");
function $8c3a69629e592a00$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $6v7Sc.useIconThemed)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        x1: "-26.046%",
                        y1: "100%",
                        x2: "62.626%",
                        y2: "0%",
                        id: "fallback-a",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#B3BAC5",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#A5ADBA",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        x1: "-12.24%",
                        y1: "100%",
                        x2: "82.44%",
                        y2: "0%",
                        id: "fallback-b",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5A6977",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#454F59",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#FFF',
                            dark: '#161A1D'
                        }),
                        d: "M0 0h40v40H0z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M20 16h12v12H20z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: 'url(#fallback-a)',
                            dark: 'url(#fallback-b)'
                        }),
                        d: "M8 16h12v12H8z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#B3BAC5',
                            dark: '#454F59'
                        }),
                        d: "M17.5 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        }),
                        d: "M10 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M25 13h5v3h-5z"
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("6v7Sc", function(module, exports) {

$parcel$export(module.exports, "useIconThemed", () => $9722d0b207f9c9df$export$a38bb9a8c9e5bc30);

var $hxoiH = parcelRequire("hxoiH");
const $9722d0b207f9c9df$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});



parcelRegister("8PLnn", function(module, exports) {

$parcel$export(module.exports, "ViewMore", () => $2693df730c07ec69$export$d4bcefa42749a40f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $2i4K4 = parcelRequire("2i4K4");

var $fP8bU = parcelRequire("fP8bU");

var $kJpBP = parcelRequire("kJpBP");
var $9UCCQ = parcelRequire("9UCCQ");

const $2693df730c07ec69$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:focus': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        outline: 'none'
    }
});
const $2693df730c07ec69$export$d4bcefa42749a40f = ({ onClick: onClick, isFocused: isFocused })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            } else if (e.key === 'Tab') {
                // TypeaheadList will try to insert selected item on Tab press
                // hence stop propagation to prevent that and treat this as noop
                e.stopPropagation();
                e.preventDefault();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $2693df730c07ec69$var$buttonStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
        ref: ref,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fP8bU))), {
            label: ""
        }),
        "aria-describedby": formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore),
        "data-testid": "quick-insert-view-more-elements-item"
    }, formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore))));
};

});
parcelRegister("fP8bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad5194e08f67bfe24a1828a13f5785c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b851f9035a4ffaf9$var$_react = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b851f9035a4ffaf9$var$_showMoreHorizontal = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $b851f9035a4ffaf9$var$_more = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("6qrUW")));
function $b851f9035a4ffaf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b851f9035a4ffaf9$var$_react.default.createElement($b851f9035a4ffaf9$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b851f9035a4ffaf9$var$_more.default
    }, props));
$b851f9035a4ffaf9$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $b851f9035a4ffaf9$var$_default = module.exports.default = $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon;

});
parcelRegister("6qrUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4adad3971ebc70ba$var$_react = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4adad3971ebc70ba$var$_showMoreHorizontal = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("8U6zd")));
function $4adad3971ebc70ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4adad3971ebc70ba$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $4adad3971ebc70ba$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $4adad3971ebc70ba$var$_showMoreHorizontal.default
    }));
$4adad3971ebc70ba$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $4adad3971ebc70ba$var$_default = module.exports.default = $4adad3971ebc70ba$var$EditorMoreIcon;

});









parcelRegister("gYYLA", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => (parcelRequire("04dn4")).undoRedoPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $04dn4 = parcelRequire("04dn4");

});
parcelRegister("04dn4", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => $3240f30d9d6bf16f$export$dcdc7fc7ecd3098);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5KWxh = parcelRequire("5KWxh");

var $fZzhT = parcelRequire("fZzhT");

var $gmhCD = parcelRequire("gmhCD");

var $eZ1X5 = parcelRequire("eZ1X5");

var $20LLb = parcelRequire("20LLb");

var $30ytK = parcelRequire("30ytK");

var $kVmKj = parcelRequire("kVmKj");

var $345K8 = parcelRequire("345K8");

var $cBhLR = parcelRequire("cBhLR");
const $3240f30d9d6bf16f$export$dcdc7fc7ecd3098 = ({ api: api })=>{
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBhLR.default), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'undoRedoPlugin',
        component: primaryToolbarComponent
    });
    const handleUndo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $345K8.forceFocus)(editorViewRef.current, api)((0, $eZ1X5.attachInputMeta)(inputSource || (0, $20LLb.InputSource).EXTERNAL)((0, $fZzhT.undo)));
    };
    const handleRedo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $345K8.forceFocus)(editorViewRef.current, api)((0, $eZ1X5.attachInputMeta)(inputSource || (0, $20LLb.InputSource).EXTERNAL)((0, $fZzhT.redo)));
    };
    return {
        name: 'undoRedoPlugin',
        actions: {
            undo: handleUndo,
            redo: handleRedo
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $30ytK.keymapPlugin)()
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $kVmKj.createPlugin)(options)
                }
            ];
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'undoRedoGetEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $5KWxh.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("eZ1X5", function(module, exports) {

$parcel$export(module.exports, "attachInputMeta", () => $22e4ba3e2ea54174$export$84d159245233a2bb);

var $5EXQ9 = parcelRequire("5EXQ9");
const $22e4ba3e2ea54174$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $5EXQ9.pluginKey), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };

});
parcelRegister("5EXQ9", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $99719005f73bb72b$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $99719005f73bb72b$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('undoRedoPlugin');

});


parcelRegister("20LLb", function(module, exports) {

$parcel$export(module.exports, "InputSource", () => $a9d033a76b963a3b$export$c3de12c0810a343d);

var $gkwXh = parcelRequire("gkwXh");
var $a9d033a76b963a3b$export$c3de12c0810a343d = /*#__PURE__*/ function(InputSource) {
    InputSource[InputSource["TOOLBAR"] = (0, $gkwXh.INPUT_METHOD).TOOLBAR] = "TOOLBAR";
    InputSource[InputSource["KEYBOARD"] = (0, $gkwXh.INPUT_METHOD).KEYBOARD] = "KEYBOARD";
    InputSource[InputSource["EXTERNAL"] = (0, $gkwXh.INPUT_METHOD).EXTERNAL] = "EXTERNAL";
    return InputSource;
}({});

});

parcelRegister("30ytK", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $249c61699bfcf173$export$e832373cff8dec22);

var $e9qoo = parcelRequire("e9qoo");

var $5KWxh = parcelRequire("5KWxh");

var $vWFRY = parcelRequire("vWFRY");

var $VSDnB = parcelRequire("VSDnB");

var $3WJ7e = parcelRequire("3WJ7e");
function $249c61699bfcf173$export$e832373cff8dec22() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.findKeyMapForBrowser)((0, $e9qoo.redo)), (0, $3WJ7e.redoFromKeyboard), list);
    if ((0, $VSDnB.fg)('platform_editor_cmd_y_mac_redo_shortcut')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.findKeyMapForBrowser)((0, $e9qoo.redoAlt)), (0, $3WJ7e.redoFromKeyboard), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.undo).common, (0, $3WJ7e.undoFromKeyboard), list);
    return new (0, $5KWxh.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $e9qoo.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $vWFRY.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("3WJ7e", function(module, exports) {

$parcel$export(module.exports, "undoFromKeyboard", () => $3d40a00c1f581dab$export$1d1a6834315b2876);
$parcel$export(module.exports, "redoFromKeyboard", () => $3d40a00c1f581dab$export$b51f9da6d7e523d2);
$parcel$export(module.exports, "undoFromToolbar", () => $3d40a00c1f581dab$export$841850d252e034f0);
$parcel$export(module.exports, "redoFromToolbar", () => $3d40a00c1f581dab$export$11ad0a77a5cc0ccf);

var $fZzhT = parcelRequire("fZzhT");

var $eZ1X5 = parcelRequire("eZ1X5");

var $20LLb = parcelRequire("20LLb");
const $3d40a00c1f581dab$export$1d1a6834315b2876 = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).KEYBOARD)((0, $fZzhT.undo));
const $3d40a00c1f581dab$export$b51f9da6d7e523d2 = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).KEYBOARD)((0, $fZzhT.redo));
const $3d40a00c1f581dab$export$841850d252e034f0 = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).TOOLBAR)((0, $fZzhT.undo));
const $3d40a00c1f581dab$export$11ad0a77a5cc0ccf = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).TOOLBAR)((0, $fZzhT.redo));

});


parcelRegister("kVmKj", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $68e14e6d3530e7bb$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $5EXQ9 = parcelRequire("5EXQ9");
const $68e14e6d3530e7bb$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $5EXQ9.pluginKey)
    });
};

});

parcelRegister("345K8", function(module, exports) {

$parcel$export(module.exports, "forceFocus", () => $1196bde9495f2f91$export$4126ecb6f20789f0);
const $1196bde9495f2f91$export$2c9048c8abe91d0d = (editorView, api)=>(command)=>{
        if (!editorView) return false;
        if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
            attachCommand: command,
            insertCurrentQueryAsRawText: false
        });
        else command(editorView.state, editorView.dispatch);
        return true;
    };
const $1196bde9495f2f91$export$4126ecb6f20789f0 = (editorView, api)=>(command)=>{
        const result = $1196bde9495f2f91$export$2c9048c8abe91d0d(editorView, api)(command);
        if (result && !editorView.hasFocus()) editorView.focus();
        return result;
    };

});

parcelRegister("cBhLR", function(module, exports) {

$parcel$export(module.exports, "default", () => $343b86e0a69d2f8f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $awTmI = parcelRequire("awTmI");

var $e9qoo = parcelRequire("e9qoo");

var $7S9ZN = parcelRequire("7S9ZN");

var $ejItq = parcelRequire("ejItq");

var $l4tMX = parcelRequire("l4tMX");
var $1jI4k = parcelRequire("1jI4k");

var $eGW7v = parcelRequire("eGW7v");

var $9H08G = parcelRequire("9H08G");

var $VSDnB = parcelRequire("VSDnB");

var $3WJ7e = parcelRequire("3WJ7e");

var $345K8 = parcelRequire("345K8");
const $343b86e0a69d2f8f$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { historyState: historyState } = (0, $awTmI.useSharedPluginState)(api, [
        'history'
    ]);
    const handleUndo = ()=>{
        (0, $345K8.forceFocus)(editorView, api)((0, $3WJ7e.undoFromToolbar));
    };
    const handleRedo = ()=>{
        (0, $345K8.forceFocus)(editorView, api)((0, $3WJ7e.redoFromToolbar));
    };
    const labelUndo = formatMessage((0, $7S9ZN.messages).undo);
    const labelRedo = formatMessage((0, $7S9ZN.messages).redo);
    const { canUndo: canUndo, canRedo: canRedo } = historyState ?? {};
    const redoKeymap = (0, $VSDnB.fg)('platform_editor_cmd_y_mac_redo_shortcut') ? (0, $e9qoo.redoAlt) : (0, $e9qoo.redo);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyleBeforeVisualRefresh)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $e9qoo.tooltip)((0, $e9qoo.undo), labelUndo),
        "aria-keyshortcuts": (0, $e9qoo.getAriaKeyshortcuts)((0, $e9qoo.undo)),
        title: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $e9qoo.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9H08G))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: labelRedo,
            keymap: redoKeymap
        }),
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGW7v))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $e9qoo.tooltip)(redoKeymap, labelRedo),
        "aria-keyshortcuts": (0, $e9qoo.getAriaKeyshortcuts)(redoKeymap)
    }), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $ejItq.separatorStyles)
    })));
};
var $343b86e0a69d2f8f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($343b86e0a69d2f8f$export$4a0f2fb817767d20);

});
parcelRegister("eGW7v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d059f3ea6105a0395a3e73a1cc411ccd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab22125c947bd831$var$_react = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab22125c947bd831$var$_redo = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("51dEo")));

var $ab22125c947bd831$var$_redo2 = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("5Pf2J")));
function $ab22125c947bd831$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RedoIcon.
 * This component is RedoIcon, with `UNSAFE_fallbackIcon` set to "RedoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab22125c947bd831$var$RedoIcon = (props)=>/*#__PURE__*/ $ab22125c947bd831$var$_react.default.createElement($ab22125c947bd831$var$_redo.default, Object.assign({
        LEGACY_fallbackIcon: $ab22125c947bd831$var$_redo2.default
    }, props));
$ab22125c947bd831$var$RedoIcon.Name = 'RedoIconMigration';
var $ab22125c947bd831$var$_default = module.exports.default = $ab22125c947bd831$var$RedoIcon;

});
parcelRegister("51dEo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f579057b3cb3a0df31aba248715041d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a77a26e43f67a2e$var$_react = $3a77a26e43f67a2e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a77a26e43f67a2e$var$_baseNew = $3a77a26e43f67a2e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3a77a26e43f67a2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a77a26e43f67a2e$var$RedoIcon = (props)=>/*#__PURE__*/ $3a77a26e43f67a2e$var$_react.default.createElement($3a77a26e43f67a2e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 1 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$3a77a26e43f67a2e$var$RedoIcon.displayName = 'RedoIcon';
var $3a77a26e43f67a2e$var$_default = module.exports.default = $3a77a26e43f67a2e$var$RedoIcon;

});

parcelRegister("5Pf2J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01183743c30bdd8e$var$_react = $01183743c30bdd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $01183743c30bdd8e$var$_redo = $01183743c30bdd8e$var$_interopRequireDefault((parcelRequire("51dEo")));
function $01183743c30bdd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01183743c30bdd8e$var$RedoIcon = (props)=>/*#__PURE__*/ $01183743c30bdd8e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 0 0 .386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569"/><path d="M17.497 10v3h-2.995a1 1 0 1 0 0 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 0 0-2.003 0"/></g></svg>`
    }, props, {
        newIcon: $01183743c30bdd8e$var$_redo.default
    }));
$01183743c30bdd8e$var$RedoIcon.displayName = 'RedoIcon';
var $01183743c30bdd8e$var$_default = module.exports.default = $01183743c30bdd8e$var$RedoIcon;

});


parcelRegister("9H08G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2818f986336a4a51aa47fe5286974737>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70e83ccc33b2569d$var$_react = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $70e83ccc33b2569d$var$_undo = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("7sLAO")));

var $70e83ccc33b2569d$var$_undo2 = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("80QYV")));
function $70e83ccc33b2569d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UndoIcon.
 * This component is UndoIcon, with `UNSAFE_fallbackIcon` set to "UndoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70e83ccc33b2569d$var$UndoIcon = (props)=>/*#__PURE__*/ $70e83ccc33b2569d$var$_react.default.createElement($70e83ccc33b2569d$var$_undo.default, Object.assign({
        LEGACY_fallbackIcon: $70e83ccc33b2569d$var$_undo2.default
    }, props));
$70e83ccc33b2569d$var$UndoIcon.Name = 'UndoIconMigration';
var $70e83ccc33b2569d$var$_default = module.exports.default = $70e83ccc33b2569d$var$UndoIcon;

});
parcelRegister("7sLAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2edf8e8e6d811ed80e747695771356e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56f010d97236ea23$var$_react = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $56f010d97236ea23$var$_baseNew = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $56f010d97236ea23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56f010d97236ea23$var$UndoIcon = (props)=>/*#__PURE__*/ $56f010d97236ea23$var$_react.default.createElement($56f010d97236ea23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$56f010d97236ea23$var$UndoIcon.displayName = 'UndoIcon';
var $56f010d97236ea23$var$_default = module.exports.default = $56f010d97236ea23$var$UndoIcon;

});

parcelRegister("80QYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d576be12f027bbc$var$_react = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5d576be12f027bbc$var$_undo = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("7sLAO")));
function $5d576be12f027bbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d576be12f027bbc$var$UndoIcon = (props)=>/*#__PURE__*/ $5d576be12f027bbc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
    }, props, {
        newIcon: $5d576be12f027bbc$var$_undo.default
    }));
$5d576be12f027bbc$var$UndoIcon.displayName = 'UndoIcon';
var $5d576be12f027bbc$var$_default = module.exports.default = $5d576be12f027bbc$var$UndoIcon;

});





parcelRegister("kMiBI", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => (parcelRequire("bTGGC")).widthPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bTGGC = parcelRequire("bTGGC");

});
parcelRegister("bTGGC", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => $270b3b79fc31e80e$export$8cdf857cb01de6dc);

var $5t0XF = parcelRequire("5t0XF");

var $kmA2l = parcelRequire("kmA2l");

var $ggOPR = parcelRequire("ggOPR");
const $270b3b79fc31e80e$export$8cdf857cb01de6dc = ()=>({
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $5t0XF.createPlugin)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $kmA2l.pluginKey).getState(editorState);
        },
        usePluginHook ({ editorView: editorView, containerElement: containerElement }) {
            return (0, $ggOPR.useResizeWidthObserver)({
                editorView: editorView,
                containerElement: containerElement
            });
        }
    });

});
parcelRegister("5t0XF", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $459b9f5d8f6ef73b$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $kmA2l = parcelRequire("kmA2l");
function $459b9f5d8f6ef73b$export$ae829ec7b2625219(dispatch) {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $kmA2l.pluginKey),
        state: {
            init: ()=>({
                    width: document.body.offsetWidth
                }),
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $kmA2l.pluginKey));
                if (!meta) return pluginState;
                const newPluginState = {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $kmA2l.pluginKey), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("kmA2l", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $ff8b08c35ee6f5de$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $ff8b08c35ee6f5de$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('widthPlugin');

});


parcelRegister("ggOPR", function(module, exports) {

$parcel$export(module.exports, "useResizeWidthObserver", () => $d118631b559ea5d3$export$b0f894529c6bfe0a);

var $5uXOq = parcelRequire("5uXOq");

var $kmA2l = parcelRequire("kmA2l");

var $5U0zH = parcelRequire("5U0zH");
const $d118631b559ea5d3$var$setEditorWidth = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $kmA2l.pluginKey), props);
        dispatch(tr);
    };
const $d118631b559ea5d3$export$b0f894529c6bfe0a = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $5U0zH.useRefreshWidthOnTransition)(containerElement);
    (0, $5uXOq.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement?.offsetWidth
        };
        $d118631b559ea5d3$var$setEditorWidth(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $d118631b559ea5d3$var$setEditorWidth({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};

});
parcelRegister("5U0zH", function(module, exports) {

$parcel$export(module.exports, "useRefreshWidthOnTransition", () => $2e70303078c4f6e0$export$b72edfd730e58e7c);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
// List of names for transition end events across browsers
const $2e70303078c4f6e0$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd'
];
const $2e70303078c4f6e0$export$b72edfd730e58e7c = (containerElement)=>{
    const [_, setLastWidthEvent] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!containerElement) return;
        /**
		 * Update the plugin components once the transition
		 * to full width / default mode completes
		 */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setLastWidthEvent(event);
        };
        return (0, $cBeZP.bindAll)(containerElement, $2e70303078c4f6e0$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
};

});






parcelRegister("7rITF", function(module, exports) {

$parcel$export(module.exports, "createJiraEditorPluginAIOptions", () => $19276c9689228901$export$c89a9ef89805e05e);
/**
 * We may eventually need to split the Jira presets out to the various
 * - JSW
 * - JSM
 * - JWM
 * - JPD
 *
 * Variations, however we'll start simple for now.
 */ /**
 * Please reference
 * https://hello.atlassian.net/wiki/spaces/CONF/pages/2714833063/Gen+AI+in+Editor+EAP2+-+Product-specific+requirements
 * Also see: https://hello.atlassian.net/wiki/spaces/EDAI/pages/2731933104/Editor+AI+EAP+Part+2+Dev+Documentation+Prebuilt+Providers+Plugin+Presets
 */ 
var $61Nbw = parcelRequire("61Nbw");

var $e7ttT = parcelRequire("e7ttT");

var $kQzAD = parcelRequire("kQzAD");

var $9ecvG = parcelRequire("9ecvG");

var $9LfEV = parcelRequire("9LfEV");

var $giLDs = parcelRequire("giLDs");

var $d8wQM = parcelRequire("d8wQM");

var $9KiMc = parcelRequire("9KiMc");

var $hLKbT = parcelRequire("hLKbT");

var $dv0ZW = parcelRequire("dv0ZW");

var $3X1aZ = parcelRequire("3X1aZ");
const $19276c9689228901$export$c89a9ef89805e05e = (options)=>{
    // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options?.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    // Suggest response is only enabled for JSM
    const isSuggestResponseEnabled = options.allowSuggestResponse && options.issueId !== undefined && options.product === 'JSM';
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $giLDs.freeGenerate),
        configItemWithOptions: [
            !!options.allowIssueReformatter && (0, $d8wQM.createImproveDescriptionWithOptions)({
                getAdditionalProps: options.getAdditionalProps || (()=>({}))
            }),
            !!isSuggestResponseEnabled && (0, $9ecvG.createDraftReplyWithOptions)(options.issueId),
            (0, $hLKbT.summarizeWritingWithOptions),
            (0, $9LfEV.improveWritingWithOptions),
            (0, $9LfEV.fixSpellingAndGrammarWithOptions),
            !isSuggestResponseEnabled && (0, $e7ttT.brainstormWithOptions),
            (0, $9KiMc.makeShorterWithOptions),
            (0, $kQzAD.changeToneToProfessionalWithOptions),
            (0, $kQzAD.changeToneToEmpatheticWithOptions),
            (0, $kQzAD.changeToneToCasualWithOptions),
            (0, $kQzAD.changeToneToNeutralWithOptions),
            (0, $kQzAD.changeToneToEducationalWithOptions),
            ...(0, $dv0ZW.translationConfigItemWithOptions)
        ].filter((0, $61Nbw.isEditorPluginAIConfigItemWithOptions)),
        disableAISelectionToolbar: true,
        generativeAIApiUrl: options.generativeAIApiUrl,
        product: options.product,
        objectId: options.issueId,
        getFetchCustomHeaders: options?.getFetchCustomHeaders || (0, $3X1aZ._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options?.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        getChannelVariables: options.getChannelVariables,
        actionSideEffects: options.actionSideEffects,
        actionOverrides: options.actionOverrides,
        isRovoEnabled: options.isRovoEnabled ?? true,
        aiLifeCycleDynamicAttributesGetter: options.aiLifeCycleDynamicAttributesGetter,
        auditLogSettings: options.auditLogSettings,
        getAdditionalProps: options.getAdditionalProps
    };
};

});
parcelRegister("61Nbw", function(module, exports) {

$parcel$export(module.exports, "isEditorPluginAIConfigItemWithOptions", () => $574b45a14eec2a86$export$77a7a46521e984a3);
$parcel$export(module.exports, "getEditorPluginAIConfigItemActions", () => $574b45a14eec2a86$export$a64e27216c5d7416);
$parcel$export(module.exports, "getVisibleEditorPluginAIConfigItems", () => $574b45a14eec2a86$export$2dd2807afbd4a532);
$parcel$export(module.exports, "getAllEditorPluginAIConfigItems", () => $574b45a14eec2a86$export$2527a005bbcba079);
$parcel$export(module.exports, "getTranslatedItemTitle", () => $574b45a14eec2a86$export$d97f37f32ae9d000);
$parcel$export(module.exports, "getTranslatedPromptLabel", () => $574b45a14eec2a86$export$4539b8c6808af330);
function $574b45a14eec2a86$export$2c6858d7c847006(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
    return 'selection' in value && typeof value.selection === 'string';
}
function $574b45a14eec2a86$export$77a7a46521e984a3(item) {
    return !!item;
}
function $574b45a14eec2a86$export$475f2e7e3b5c59c4({ editorView: editorView, positions: positions, isEmpty: isEmpty, item: item }) {
    const { triggers: triggers } = item;
    const doc = editorView.state.doc;
    // Size of the doc with a single empty paragraph is 4
    const docSize = doc.nodeSize - 4;
    const selectionSize = positions[1] - positions[0];
    if (triggers.canShow && !triggers.canShow({
        editorView: editorView,
        docSize: docSize,
        selectionSize: selectionSize
    })) return false;
    const emptyOptions = triggers.empty;
    const emptyEnabled = emptyOptions.enabled;
    const docMinSize = emptyOptions.docMinSize ?? 0;
    const docMaxSize = emptyOptions.docMaxSize ?? Number.MAX_SAFE_INTEGER;
    const selectionOptions = triggers.selection;
    const selectionEnabled = selectionOptions.enabled;
    const selectionMinSize = selectionOptions.selectionMinSize ?? 1;
    const selectionMaxSize = selectionOptions.selectionMaxSize ?? Number.MAX_SAFE_INTEGER;
    if (isEmpty) {
        if (!emptyEnabled || docSize < docMinSize || docSize > docMaxSize) return false;
    } else {
        if (!selectionEnabled || selectionSize < selectionMinSize || selectionSize > selectionMaxSize) return false;
    }
    return true;
}
function $574b45a14eec2a86$export$a64e27216c5d7416({ isEmpty: isEmpty, configItem: configItem }) {
    if (!configItem) return [];
    const actions = (isEmpty ? configItem.actions.empty : configItem.actions.selection) ?? [];
    return actions;
}
function $574b45a14eec2a86$export$2dd2807afbd4a532({ configItemWithOptions: configItemWithOptions, editorView: editorView, positions: positions, isEmpty: isEmpty }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        if ($574b45a14eec2a86$export$475f2e7e3b5c59c4({
            editorView: editorView,
            positions: positions,
            isEmpty: isEmpty,
            item: item
        })) arr.push(item.config);
    });
    return arr;
}
function $574b45a14eec2a86$export$2527a005bbcba079({ configItemWithOptions: configItemWithOptions }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        arr.push(item.config);
    });
    return arr;
}
function $574b45a14eec2a86$export$d97f37f32ae9d000(configItem, formatMessage) {
    // for agents return the saved agent name in the same language as it was saved
    if (configItem.agent) {
        const presetTitle = `@${configItem.agent.name}`;
        return presetTitle || formatMessage(configItem.title);
    }
    // adding beta label for the translation prompts
    if (configItem.key.startsWith('Translate to')) return formatMessage(configItem.title);
    // for all other items return the i18n-ed title
    return formatMessage(configItem.title);
}
function $574b45a14eec2a86$export$4539b8c6808af330(configItem, formatMessage) {
    if (configItem.agent) // for agents return the saved agent name in the same language as it was saved
    return `@${configItem.agent.name}`;
    // intentionally fall back to undefined as this value is checked to verify if we need to show the prompt input
    return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
}

});

parcelRegister("e7ttT", function(module, exports) {

$parcel$export(module.exports, "brainstormWithOptions", () => $24054d76086eea7a$export$dddd8d441293ae3);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $VSDnB = parcelRequire("VSDnB");

var $1BQsE = parcelRequire("1BQsE");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $24054d76086eea7a$export$683185be8e4be56f = {
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).BRAINSTORM,
    title: (0, $lspv7.aiConfigItemMessages).brainstormTitle,
    description: (0, $lspv7.aiConfigItemMessages).brainstormDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BQsE.BrainstormIcon), null),
    promptLabel: (0, $lspv7.aiConfigItemMessages).brainstormPromptLabel,
    promptHint: (0, $lspv7.aiConfigItemMessages).brainstormPromptHint,
    doNotHighlightDocWhenSelectionIsEmpty: true,
    agentId: 'editor_agent',
    intentSchemaId: 'brainstorm_intent_schema.json',
    alwaysNoDocAndSelection: true,
    actions: {
        empty: [
            (0, $70sMM.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assistance_service_second')) return 'assistance-service';
        return 'xp-gen-ai';
    }
};
const $24054d76086eea7a$export$dddd8d441293ae3 = {
    config: $24054d76086eea7a$export$683185be8e4be56f,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 0
        },
        selection: {
            enabled: false
        }
    }
};

});
parcelRegister("lspv7", function(module, exports) {

$parcel$export(module.exports, "aiConfigItemMessages", () => $1228edb88e4e5c72$export$e990f5ed7dd48de5);

var $7VHMR = parcelRequire("7VHMR");
const $1228edb88e4e5c72$export$e990f5ed7dd48de5 = (0, $7VHMR.defineMessages)({
    // Agent config messages
    agentConfigTitle: {
        id: 'fabric.editor.ai.config.item.agent.title',
        defaultMessage: 'Atlassian Intelligence Rovo Agent',
        description: 'Title for the menu item of the Atlassian Intelligence agent without a predefined name.'
    },
    agentConfigDescription: {
        id: 'fabric.editor.ai.config.item.range.agent.description',
        defaultMessage: 'No description',
        description: 'Subtitle for the menu item of the Atlassian Intelligence agent without a predefined description.'
    },
    agentConfigPromptHint: {
        id: 'fabric.editor.ai.config.item.range.agent.prompt.hint',
        defaultMessage: 'Tell the Agent to write anything or choose from below',
        description: 'Hint text for the prompt input when interacting with the Atlassian Intelligence'
    },
    // Config action messages
    configActionInsert: {
        id: 'fabric.editor.ai.config.item.action.insert',
        defaultMessage: 'Insert',
        description: 'Inserts the response at the current location'
    },
    configActionInsertAtTop: {
        id: 'fabric.editor.ai.config.item.action.insertAtTop',
        defaultMessage: 'Insert at top',
        description: 'Inserts the response at the start of the content'
    },
    configActionInsertBelow: {
        id: 'fabric.editor.ai.config.item.action.insertBelow',
        defaultMessage: 'Insert below',
        description: 'Inserts the response below the current location'
    },
    configActionReplace: {
        id: 'fabric.editor.ai.config.item.action.replace',
        defaultMessage: 'Replace',
        description: 'Replaces the existing or selected content with the response'
    },
    configActionReplaceTitle: {
        id: 'fabric.editor.ai.config.item.action.replaceTitle',
        defaultMessage: 'Replace title',
        description: 'Replaces the existing Confluence document title with the generated title'
    },
    configActionReplaceTitleTooLongDisabledTooltip: {
        id: 'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip',
        defaultMessage: 'Title cannot exceed {maxLength} characters',
        description: 'Tooltip that appears over disabled action button when disabled because of title being too long'
    },
    configActionContinueInChatLabel: {
        id: 'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel',
        defaultMessage: 'Open in Chat',
        description: 'Tooltip and label for Open in Chat button'
    },
    // Atlas shorten update messages
    atlasShortenUpdatetitle: {
        id: 'fabric.editor.ai.config.item.atlas-shorten-update.title',
        defaultMessage: 'Shorten update',
        description: 'Describes an option to use Atlassian Intelligence to shorten the content currently selected by the user'
    },
    atlasShortenUpdateDescription: {
        id: 'fabric.editor.ai.config.item.atlas-shorten-update.description',
        defaultMessage: 'Shortens the content to make it more concise',
        description: 'Description for the the Atlassian Intelligence "Shorten update".'
    },
    // Brainstorm messages
    brainstormTitle: {
        id: 'fabric.editor.ai.config.item.brainstorm.title',
        defaultMessage: 'Brainstorm',
        description: 'Title for "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    brainstormDescription: {
        id: 'fabric.editor.ai.config.item.brainstorm.description',
        defaultMessage: 'Generates a list of ideas for a topic you provide',
        description: 'Describes the "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    brainstormPromptLabel: {
        id: 'fabric.editor.ai.config.item.brainstorm.promptLabel',
        defaultMessage: 'Brainstorm',
        description: 'Label text in the prompt input.'
    },
    brainstormPromptHint: {
        id: 'fabric.editor.ai.config.item.brainstorm.promptHint',
        defaultMessage: 'Tell me the topic...',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    // Change tone messages
    changeToneNestingParentTitlePostGA: {
        id: 'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA',
        defaultMessage: 'Change tone to ...',
        description: 'Describes a (nested) option to use Atlassian Intelligence to change the tone of content currently selected by the user'
    },
    changeToneNeutralToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.title',
        defaultMessage: 'Change tone to neutral',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneNeutralToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle',
        defaultMessage: 'Neutral',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneNeutralToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.description',
        defaultMessage: 'Changes the tone of the content to neutral',
        description: 'Desciption for the Atlassian Intellgience "Change tone to neutral" option'
    },
    changeToneNeutralToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Neutral',
        description: 'Title for Atlassian Intelligence "Change tone to neutral" in editor selection floating toolbar'
    },
    changeToneProfessionalToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.title',
        defaultMessage: 'Change tone to professional',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneProfessionalToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle',
        defaultMessage: 'Professional',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneProfessionalToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.description',
        defaultMessage: 'Changes the tone of the content to professional',
        description: 'Desciption for the Atlassian Intellgience "Change tone to professional" option'
    },
    changeToneProfessionalToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Professional',
        description: 'Title for Atlassian Intelligence "Change tone to professional" in editor selection floating toolbar'
    },
    changeToneCasualToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.title',
        defaultMessage: 'Change tone to casual',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneCasualToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle',
        defaultMessage: 'Casual',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneCasualToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.description',
        defaultMessage: 'Changes the tone of the content to casual',
        description: 'Desciption for the Atlassian Intellgience "Change tone to casual" option'
    },
    changeToneCasualToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Casual',
        description: 'Title for Atlassian Intelligence "Change tone to casual" in editor selection floating toolbar'
    },
    changeToneEducationalToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.title',
        defaultMessage: 'Change tone to educational',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEducationalToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle',
        defaultMessage: 'Educational',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEducationalToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.description',
        defaultMessage: 'Changes the tone of the content to educational',
        description: 'Desciption for the Atlassian Intellgience "Change tone to educational" option'
    },
    changeToneEducationalToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Educational',
        description: 'Title for Atlassian Intelligence "Change tone to educational" in editor selection floating toolbar'
    },
    changeToneEmpatheticToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.title',
        defaultMessage: 'Change tone to empathetic',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEmpatheticToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle',
        defaultMessage: 'Empathetic',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEmpatheticToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.description',
        defaultMessage: 'Changes the tone of the content to empathetic',
        description: 'Desciption for the Atlassian Intellgience "Change tone to empathetic" option'
    },
    changeToneEmpatheticToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Empathetic',
        description: 'Title for Atlassian Intelligence "Change tone to empathetic" in editor selection floating toolbar'
    },
    // Convert to bullet list messages
    convertToBulletListTitle: {
        id: 'fabric.editor.ai.config.item.convertToBulletList.title',
        defaultMessage: 'Convert to bulleted list',
        description: 'Describes an option to use Atlassian Intelligence to reformat content currently selected by the user to a bulleted list'
    },
    convertToBulletListDescription: {
        id: 'fabric.editor.ai.config.item.convertToBulletList.description',
        defaultMessage: 'Reformats content to a bulleted list',
        description: 'Description for the the Atlassian Intelligence "Convert to bulleted list".'
    },
    // Convert to table messages
    convertToTableTitle: {
        id: 'fabric.editor.ai.config.item.convertToTable.title',
        defaultMessage: 'Convert to table',
        description: 'Describes an option to use Atlassian Intelligence to reformat content currently selected by the user to a table with headings'
    },
    convertToTableDescription: {
        id: 'fabric.editor.ai.config.item.convertToTable.description',
        defaultMessage: 'Reformats content to a table with headings',
        description: 'Description for the the Atlassian Intelligence "Convert to table".'
    },
    // Draft reply messages
    draftReplyTitle: {
        id: 'fabric.editor.ai.config.item.draftReply.title',
        defaultMessage: 'Draft reply',
        description: 'Title for "Draft reply" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    draftReplyDescription: {
        id: 'fabric.editor.ai.config.item.draftReply.description',
        defaultMessage: "Drafts a reply based on issues similar to the one you\u2019re working on",
        description: 'Describes the "Draft reply" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    // Enhance messages
    improveWritingTitle: {
        id: 'fabric.editor.ai.config.item.enhance.improveWriting.title',
        defaultMessage: 'Improve writing',
        description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Improve writing',
        description: 'Title for Atlassian Intelligence "improve writing" in editor selection floating toolbar'
    },
    fixSpellingGrammarTitle: {
        id: 'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title',
        defaultMessage: 'Fix spelling & grammar',
        description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingDescription: {
        id: 'fabric.editor.ai.config.item.enhance.improveWriting.description',
        defaultMessage: 'Enhances clarity, structure, and tone for better engagement and comprehension',
        description: 'Description for the the Atlassian Intelligence "Improve Writing".'
    },
    fixSpellingGrammarDescription: {
        id: 'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description',
        defaultMessage: 'Fixes spelling and grammar mistakes',
        description: 'Description for the the Atlassian Intelligence "Fix Spelling & Grammar".'
    },
    fixSpellingGrammarSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Spelling & grammar',
        description: 'Title for Atlassian Intelligence "fix spelling grammar" in editor selection floating toolbar'
    },
    // Find action items messages
    findActionItemsTitle: {
        id: 'fabric.editor.ai.config.item.findActionItems.title',
        defaultMessage: 'Find action items',
        description: 'Title for "Find Action Items" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    findActionItemsDescription: {
        id: 'fabric.editor.ai.config.item.findActionItems.description',
        defaultMessage: 'Finds action items in the content you provide',
        description: 'Describes the "Find Action Items" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    // Free generate messages
    freeGeneratePromptHint: {
        id: 'fabric.editor.ai.config.item.generateContent.promptHint',
        defaultMessage: 'Write with AI or select from below',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    // Free generate disabled messages
    freeGenerateDisabledPromptHint: {
        id: 'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint',
        defaultMessage: 'Select from below (free generate is disabled in Elevate at this time)',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    // Improve description messages
    reformatWithTemplateDescription: {
        id: 'fabric.editor.ai.config.item.improveDescription.default.description',
        defaultMessage: 'Restructure the issue description based on the issue type',
        description: 'Description for the Atlassian Intelligence "Improve description" feature.'
    },
    improveDescription: {
        id: 'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one',
        defaultMessage: 'Improve description',
        description: 'Describes an option to use Atlassian Intelligence to improve the issue description currently selected by the user.'
    },
    // Make longer messages
    makeLongerTitle: {
        id: 'fabric.editor.ai.config.item.makeLonger.title',
        defaultMessage: 'Make longer',
        description: 'Describes an option to use Atlassian Intelligence to make the content longer currently selected by the user'
    },
    makeLongerDescription: {
        id: 'fabric.editor.ai.config.item.makeLonger.description',
        defaultMessage: 'Expands the content based on the context you provide',
        description: 'Description for the the Atlassian Intelligence "Make longer".'
    },
    // Make shorter messages
    makeShorterTitle: {
        id: 'fabric.editor.ai.config.item.shorten.title',
        defaultMessage: 'Make shorter',
        description: 'Describes an option to use Atlassian Intelligence to shorten the content currently selected by the user'
    },
    makeShorterDescription: {
        id: 'fabric.editor.ai.config.item.shorten.description',
        defaultMessage: 'Shortens the content to make it more concise',
        description: 'Description for the the Atlassian Intelligence "Shorten".'
    },
    makeShorterSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Make shorter',
        description: 'Title for Atlassian Intelligence "Shorten" in editor selection floating toolbar'
    },
    // PR Description messages
    prDescriptionTitle: {
        id: 'fabric.editor.ai.config.item.bb.pr.description.title',
        defaultMessage: 'Create pull request description',
        description: 'Title for "Create pull request description" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    prDescriptionDescription: {
        id: 'fabric.editor.ai.config.item.bb.pr.description.description',
        defaultMessage: 'Creates a pull request description with a summary of changes',
        description: 'Describes the "Create pull request description" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    // Rephrase messages
    rephraseTitle: {
        id: 'fabric.editor.ai.config.item.rephrase.title',
        defaultMessage: 'Rephrase',
        description: 'Describes an option to use Atlassian Intelligence to rephrase the content currently selected by the user'
    },
    rephraseDescription: {
        id: 'fabric.editor.ai.config.item.rephrase.description',
        defaultMessage: 'Creates a suggestion for rewriting your sentences',
        description: 'Description for the the Atlassian Intelligence "Rephrase".'
    },
    // Suggest title messages
    suggestTitleTitle: {
        id: 'fabric.editor.ai.config.item.suggest.title',
        defaultMessage: 'Suggest a title',
        description: 'Describes an option to use Atlassian Intellgience to suggest an appropriate title for the content currently selected by the user'
    },
    suggestTitleDescription: {
        id: 'fabric.editor.ai.config.item.suggest.description',
        defaultMessage: 'Suggests a title for content you provide',
        description: 'Describes "Suggest a Title" Atlassian Intelligence feature to suggest an appropriate title for the content currently selected by the user'
    },
    // Summarize writing messages
    summarizeWritingtitle: {
        id: 'fabric.editor.ai.config.item.summarize.title',
        defaultMessage: 'Summarize writing',
        description: 'Describes an option to use Atlassian Intellgience to summarize the content currently selected by the user'
    },
    summarizeWritingDescription: {
        id: 'fabric.editor.ai.config.item.summarize.description',
        defaultMessage: "Creates a summary of the text you're working on, highlighting key points",
        description: 'Describes "Summarize writing" Atlassian Intelligence feature to summarize the content currently selected by the user'
    },
    summarizeWritingSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.summarize.dropdownItem.title',
        defaultMessage: 'Summarize writing',
        description: 'Title for Atlassian Intelligence "Summarize writing" in editor selection floating toolbar'
    }
});

});

parcelRegister("1BQsE", function(module, exports) {

$parcel$export(module.exports, "BrainstormIcon", () => $3efbd4e3f05782f5$export$ced89349fedce38);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $e78BF = parcelRequire("e78BF");
const $3efbd4e3f05782f5$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.04101 4.052C8.35608 2.73768 10.1392 1.99937 11.9985 1.99937C13.8578 1.99937 15.6409 2.73768 16.956 4.052C17.581 4.67653 18.0768 5.4181 18.415 6.23433C18.7533 7.05056 18.9274 7.92545 18.9274 8.809C18.9274 9.69254 18.7533 10.5674 18.415 11.3837C18.0768 12.1999 17.581 12.9415 16.956 13.566L16.841 13.678L16.724 13.787L15.998 14.446L16 15.83L15.998 15.862V18.001C15.9976 18.7657 15.7051 19.5014 15.1804 20.0577C14.6557 20.6139 13.9384 20.9489 13.175 20.994L12.998 20.999H10.998C10.2333 20.9988 9.49752 20.7066 8.94104 20.1821C8.38455 19.6576 8.04938 18.9404 8.00401 18.177L7.99801 18.001V14.445L7.27301 13.785C6.01548 12.6426 5.23697 11.0665 5.09394 9.37352C4.95091 7.68057 5.45397 5.99622 6.50201 4.659L6.66401 4.46L6.82001 4.283C6.89182 4.20392 6.96551 4.12756 7.04101 4.052ZM13.998 16.83H9.99801V18.002C9.99831 18.2469 10.0885 18.4832 10.2514 18.666C10.4144 18.8489 10.6387 18.9656 10.882 18.994L10.998 19.001H12.998C13.2431 19.0012 13.4798 18.9114 13.663 18.7486C13.8462 18.5858 13.9633 18.3614 13.992 18.118L13.998 18.002V16.83ZM15.54 5.466C15.0613 4.98771 14.4907 4.61131 13.8626 4.3595C13.2345 4.10769 12.5619 3.98567 11.8854 4.00081C11.2089 4.01595 10.5424 4.16792 9.92623 4.44758C9.31003 4.72724 8.75684 5.12878 8.30001 5.628C7.48334 6.52552 7.04311 7.70273 7.07048 8.91589C7.09784 10.129 7.5907 11.2852 8.44701 12.145L8.61701 12.308L9.67001 13.264C9.84765 13.4255 9.96123 13.6456 9.99001 13.884L9.99701 14.004V14.831H13.997V14.004C13.9971 13.7638 14.0838 13.5316 14.241 13.35L14.325 13.264L15.46 12.231L15.54 12.153C15.9793 11.714 16.3277 11.1928 16.5654 10.6191C16.8032 10.0454 16.9255 9.43049 16.9255 8.80949C16.9255 8.1885 16.8032 7.57358 16.5654 6.99989C16.3277 6.4262 15.9793 5.90497 15.54 5.466Z"
    }));
const $3efbd4e3f05782f5$export$ced89349fedce38 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e78BF))), {
        label: "",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $3efbd4e3f05782f5$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});

parcelRegister("70sMM", function(module, exports) {

$parcel$export(module.exports, "createInsertAtTop", () => $53855b8ba2177280$export$9e309baaf0e9d41b);
$parcel$export(module.exports, "createInsertBelow", () => $53855b8ba2177280$export$2a99e23257616a3);
$parcel$export(module.exports, "createInsertAtCurrentPosition", () => $53855b8ba2177280$export$6641dbc1b651cf28);
$parcel$export(module.exports, "createReplace", () => $53855b8ba2177280$export$ab7194c13d7567bc);
$parcel$export(module.exports, "createReplaceExistingConfluenceTitle", () => $53855b8ba2177280$export$bac6a2ed25caf91c);

var $lspv7 = parcelRequire("lspv7");

var $dlzPV = parcelRequire("dlzPV");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $1BdtL = parcelRequire("1BdtL");

var $9Tzox = parcelRequire("9Tzox");

var $6irbE = parcelRequire("6irbE");
const $53855b8ba2177280$export$9e309baaf0e9d41b = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $lspv7.aiConfigItemMessages).configActionInsertAtTop,
        appearance: appearance,
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            const slice = new (0, $kCV8T.Slice)(pmFragment, 0, 0);
            transaction.replace(0, 0, slice);
            (0, $6irbE.beforeDispatchAITransaction)(transaction, state);
            editorView.dispatch(transaction);
        }
    });
const $53855b8ba2177280$export$2a99e23257616a3 = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $lspv7.aiConfigItemMessages).configActionInsertBelow,
        appearance: appearance,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            if ((0, $dlzPV.fragmentContainsNodeType)(pmFragment, state.schema.nodes.table) && (0, $6irbE.shouldInsertAfterTable)({
                selection: state.selection,
                tableSchema: state.schema.nodes.table
            }) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) (0, $6irbE.insertContentAfterTable)({
                pmFragment: pmFragment,
                transaction: transaction
            });
            else if (triggeredFor?.isBlock) {
                const insertPos = positions[1];
                (0, $5r0mK.safeInsert)(pmFragment, insertPos)(transaction);
                (0, $6irbE.beforeDispatchingTransactionForBlocks)(pmFragment, transaction, editorView.state);
            } else {
                let insertPos;
                try {
                    insertPos = state.doc.resolve(positions[1]).after();
                } catch (error) {
                    insertPos = positions[1];
                }
                (0, $5r0mK.safeInsert)(pmFragment, insertPos)(transaction);
            }
            (0, $6irbE.beforeDispatchAITransaction)(transaction, state);
            editorView.dispatch(transaction);
        }
    });
const $53855b8ba2177280$export$6641dbc1b651cf28 = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction })=>({
        type: 'markdown',
        title: (0, $lspv7.aiConfigItemMessages).configActionInsert,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
            const tr = (0, $6irbE.insertAIContentAtCurrentPosition)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment
            });
            if (isRovoAgentAction) (0, $6irbE.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        }
    });
const $53855b8ba2177280$export$ab7194c13d7567bc = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction })=>({
        type: 'markdown',
        title: (0, $lspv7.aiConfigItemMessages).configActionReplace,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
            const tr = triggeredFor?.isBlock ? (0, $6irbE.replaceWithAIContentForBlock)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                triggeredFor: triggeredFor
            }) : (0, $6irbE.replaceWithAIContent)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment
            });
            if (isRovoAgentAction) (0, $6irbE.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        }
    });
const $53855b8ba2177280$export$bac6a2ed25caf91c = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $lspv7.aiConfigItemMessages).configActionReplaceTitle,
        appearance: appearance,
        getDisabledState: ({ markdown: markdown, formatMessage: formatMessage })=>{
            const responseLength = markdown?.length ?? 0;
            // Source: next/packages/editor-title/src/EditorTitle.tsx
            const MAX_TITLE_LENGTH = 255;
            if (responseLength >= MAX_TITLE_LENGTH) return {
                isDisabled: true,
                tooltip: formatMessage((0, $lspv7.aiConfigItemMessages).configActionReplaceTitleTooLongDisabledTooltip, {
                    maxLength: MAX_TITLE_LENGTH
                })
            };
            return {
                isDisabled: false
            };
        },
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const fragmentToInsert = pmFragment;
            let textContent = '';
            fragmentToInsert.forEach((node)=>{
                textContent += node.textContent;
            });
            const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
            if (confluenceTitle) {
                const sourceEditorId = (0, $9Tzox.findEditorIdFromView)(editorView);
                if (sourceEditorId) (0, $1BdtL.eventHub).publishFromEditor({
                    event: 'replace title in confluence',
                    data: {
                        analyticSourceId: 'confluenceTitleToolbar',
                        sourceEditorId: sourceEditorId,
                        title: textContent
                    }
                });
                confluenceTitle.scrollIntoView();
            }
        }
    });

});
parcelRegister("1BdtL", function(module, exports) {

$parcel$export(module.exports, "eventHub", () => $af04d9796e76078a$export$e17a52e5da72c4cb);
class $af04d9796e76078a$var$EventHub {
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
    /**
	 * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
	 *
	 * @param {Object} params - The subscription parameters.
	 * @param {T} params.event - The name of the event to subscribe to.
	 * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
	 * It receives the event data as its parameter.
	 * @returns {Object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
	 *
	 * @example
	 * // Subscribing to an event
	 * const subscription = eventHub.subscribe({
	 *   event: 'start prompt',
	 *   callback: (data) => {
	 *     console.log('Received start prompt event:', data);
	 *   },
	 * });
	 *
	 * // Later, to unsubscribe
	 * subscription.unsubscribe();
	 */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
	 * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
	 *
	 * @param {Object} params - The event parameters.
	 * @param {T} params.event - The name of the event to publish.
	 * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
	 * @returns {void}
	 *
	 * @example
	 * // Publishing an event to the editor
	 * eventHub.publishToEditor({
	 *   event: 'start prompt',
	 *   data: {
	 *     prompt: 'issue reformatter',
	 *     targetEditorId,
	 *     analyticSourceId: 'jiraIssueReformatterExternalButton',
	 *   },
	 * });
	 */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
	 * Publishes an event originating from the editor, invoking all registered subscribers for that event.
	 *
	 * @param {Object} params - The event parameters.
	 * @param {T} params.event - The name of the event to publish.
	 * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
	 * @returns {void}
	 *
	 * @example
	 * // Publishing an event from the editor
	 * eventHub.publishFromEditor({
	 *   event: 'replace title in confluence',
	 *   data: {
	 *     analyticSourceId: 'confluenceTitleToolbar',
	 *     sourceEditorId,
	 *     title: textContent,
	 *   },
	 * });
	 */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
}
const $af04d9796e76078a$export$e17a52e5da72c4cb = new $af04d9796e76078a$var$EventHub();

});

parcelRegister("9Tzox", function(module, exports) {

$parcel$export(module.exports, "findEditorIdFromView", () => $2aa0dbe3ad2516fd$export$700cb401385d6bf2);
const $2aa0dbe3ad2516fd$export$700cb401385d6bf2 = (editorView)=>{
    return editorView.dom?.dataset?.editorId;
};

});

parcelRegister("6irbE", function(module, exports) {

$parcel$export(module.exports, "beforeDispatchAITransaction", () => $d4a6f858745bb160$export$336eb673e6d24058);
$parcel$export(module.exports, "beforeDispatchingTransactionForBlocks", () => $d4a6f858745bb160$export$7b46ef9a312ebccb);
$parcel$export(module.exports, "beforeDispatchAIRovoAgentTransaction", () => $d4a6f858745bb160$export$cfdd8b8691129358);
$parcel$export(module.exports, "shouldInsertAfterTable", () => $d4a6f858745bb160$export$f00c638dfda8b9e2);
$parcel$export(module.exports, "insertContentAfterTable", () => $d4a6f858745bb160$export$a6a8eefd91a14ea5);
$parcel$export(module.exports, "replaceWithAIContentForBlock", () => $d4a6f858745bb160$export$841048b11479358);
$parcel$export(module.exports, "replaceWithAIContent", () => $d4a6f858745bb160$export$60bccdedcf767536);
$parcel$export(module.exports, "insertAIContentAtCurrentPosition", () => $d4a6f858745bb160$export$7dc11dddc9c93a89);

var $gkwXh = parcelRequire("gkwXh");

var $dlzPV = parcelRequire("dlzPV");

var $9O539 = parcelRequire("9O539");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $9A8mD = parcelRequire("9A8mD");

var $2lNOk = parcelRequire("2lNOk");

var $8cX7t = parcelRequire("8cX7t");
function $d4a6f858745bb160$export$336eb673e6d24058(tr, editorState) {
    /**
	 * DO NOT REMOVE isAiContentTransformation from transaction meta.
	 * Proactive AI S+G rely on isAiContentTransformation meta to
	 * 	ignore changes in document made by AI modal.
	 * Why ignore it?
	 * - Response returned from AI does not require Spelling and Grammar check.
	 * - We have assumed that it's already correct from S+G perspective.
	 */ tr.setMeta('isAiContentTransformation', true);
    const firstReplaceStep = (0, $9A8mD.findFirstReplaceStep)(tr.steps);
    if (!firstReplaceStep) {
        // Ideally we should always have replace step for for AI transaction.
        // But in case if there isn't we want to fire analytic event so we can monitor it.
        (0, $8cX7t.addAnalytics)({
            editorState: editorState,
            tr: tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    errorType: 'replaceStepNotFound'
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            }
        });
        return tr;
    }
    const validPositionToSet = (0, $9A8mD.getValidEndTextPosition)({
        step: firstReplaceStep,
        doc: tr.doc
    });
    if (validPositionToSet !== 0) tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, validPositionToSet));
    return tr;
}
function $d4a6f858745bb160$export$7b46ef9a312ebccb(fragment, tr, state) {
    const supportedNodeTypes = (0, $2lNOk.getSupportedNodesForAIModal)(state);
    // Here we are checking if there is text node at first level.
    // Then we will highlight all nodes.
    let areTopLevelBlockElements = true;
    fragment.forEach((node)=>{
        areTopLevelBlockElements = areTopLevelBlockElements && supportedNodeTypes.has(node.type);
    });
    if (areTopLevelBlockElements) tr.setMeta('isAiContentTransformationForBlocks', true);
}
function $d4a6f858745bb160$export$cfdd8b8691129358(tr) {
    /**
	 * DO NOT REMOVE
	 * This is used when distinguishing content generated by a Rovo agent
	 */ tr.setMeta('isAiRovoAgentContentTransformation', true);
    return tr;
}
function $d4a6f858745bb160$var$getLastContentDepth({ pmFragment: pmFragment }) {
    let depth = 0;
    let currentNode = pmFragment;
    while(currentNode.firstChild){
        depth++;
        currentNode = currentNode.firstChild;
    }
    return depth;
}
function $d4a6f858745bb160$var$isSelectionAtParagraphStart($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
}
function $d4a6f858745bb160$var$isFragmentSingleParagraph(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
}
function $d4a6f858745bb160$var$isSelectionInTaskOrDecisionNode($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
}
function $d4a6f858745bb160$export$f00c638dfda8b9e2({ selection: selection, tableSchema: tableSchema }) {
    const isNestedTablesDisabled = (0, $gmhCD.editorExperiment)('nested-tables-in-tables', false, {
        exposure: true
    });
    const parentTableCount = (0, $9O539.getParentOfTypeCount)(tableSchema)(selection.$from);
    const hasParentTable = (0, $5r0mK.hasParentNodeOfType)(tableSchema)(selection);
    return hasParentTable && (isNestedTablesDisabled || parentTableCount > 1);
}
const $d4a6f858745bb160$export$a6a8eefd91a14ea5 = ({ pmFragment: pmFragment, transaction: transaction })=>{
    const tableSchema = transaction.doc.type.schema.nodes.table;
    const fromPos = transaction.selection.$from;
    const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(tableSchema)(fromPos);
    return (0, $5r0mK.safeInsert)(pmFragment, positionAfterTopTable)(transaction);
};
const $d4a6f858745bb160$export$841048b11479358 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor })=>{
    const { state: state } = editorView;
    const transaction = state.tr;
    const slice = new (0, $kCV8T.Slice)(pmFragment, 0, 0);
    try {
        transaction.replaceRange(positions[0], positions[1], slice);
    } catch  {
        // If you can't replace the range, use safeInsert
        (0, $5r0mK.safeInsert)(pmFragment, undefined, true)(transaction);
        const tr = (0, $8cX7t.addAnalytics)({
            editorState: state,
            tr: state.tr,
            payload: {
                action: 'fallback',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'proseMirrorReplace',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {}
            }
        });
        editorView.dispatch(tr);
    }
    $d4a6f858745bb160$export$7b46ef9a312ebccb(pmFragment, transaction, editorView.state);
    $d4a6f858745bb160$export$336eb673e6d24058(transaction, state);
    return transaction;
};
const $d4a6f858745bb160$export$60bccdedcf767536 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, options: options = {
    replaceDocOnEmptySelection: true
} })=>{
    const { state: state } = editorView;
    const transaction = state.tr;
    const endPositionDepth = state.doc.resolve(positions[1]).depth;
    const lastFragmentDepth = $d4a6f858745bb160$var$getLastContentDepth({
        pmFragment: pmFragment
    });
    const sliceOpenEnd = Math.min(endPositionDepth, lastFragmentDepth);
    const slice = new (0, $kCV8T.Slice)(pmFragment, 1, sliceOpenEnd);
    if ((0, $dlzPV.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $d4a6f858745bb160$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return $d4a6f858745bb160$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else {
        // We check if the positions are the same if so we replace the whole document
        // This is a quick spike so real implementation might need to be different
        // You might need to create a new replace action
        if (options.replaceDocOnEmptySelection && positions[0] === positions[1]) transaction.replaceRange(0, state.doc.content.size, slice);
        else try {
            transaction.replaceRange(positions[0], positions[1], slice);
        // If you can't replace the range, use safeInsert
        } catch  {
            (0, $5r0mK.safeInsert)(pmFragment, undefined, true)(transaction);
            const tr = (0, $8cX7t.addAnalytics)({
                editorState: state,
                tr: state.tr,
                payload: {
                    action: 'fallback',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'proseMirrorReplace',
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                    attributes: {}
                }
            });
            editorView.dispatch(tr);
        }
        $d4a6f858745bb160$export$336eb673e6d24058(transaction, state);
        return transaction;
    }
};
const $d4a6f858745bb160$export$7dc11dddc9c93a89 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment })=>{
    const { state: state } = editorView;
    const transaction = state.tr;
    const pos = positions[0];
    const $pos = state.doc.resolve(pos);
    const isParagraphStart = $d4a6f858745bb160$var$isSelectionAtParagraphStart($pos);
    // if selection is at the beginning of paragraph,
    // insert before the cursor so that it inserts without an extra new line
    const insertPos = isParagraphStart ? pos - 1 : pos;
    // if selection is inside decision or task node AND pmFragment is a single paragraph
    // strip the paragraph so it can insert inside the decision/task
    let fragmentToInsert = pmFragment;
    if ($d4a6f858745bb160$var$isSelectionInTaskOrDecisionNode($pos) && $d4a6f858745bb160$var$isFragmentSingleParagraph(pmFragment)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragmentToInsert = pmFragment.firstChild.content;
    if ((0, $dlzPV.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $d4a6f858745bb160$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return $d4a6f858745bb160$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: state.tr
    });
    else {
        transaction.insert(insertPos, fragmentToInsert);
        $d4a6f858745bb160$export$336eb673e6d24058(transaction, state);
        return transaction;
    }
};

});
parcelRegister("9A8mD", function(module, exports) {

$parcel$export(module.exports, "getValidEndTextPosition", () => $031b8beaad916af7$export$a2bf0757549da456);
$parcel$export(module.exports, "findFirstReplaceStep", () => $031b8beaad916af7$export$ec5fde712084a8ed);
$parcel$export(module.exports, "getGeneratedDecorationFromTransaction", () => $031b8beaad916af7$export$9d1e89ce90c0a9a);
$parcel$export(module.exports, "getGeneratedNodeDecorationsFromTransaction", () => $031b8beaad916af7$export$a6a2b5778b599ea1);
/**
 * Figure out what to do with these, possibly export/shift into editor-common
 * during move into editor-core
 */ 
var $eS2Dn = parcelRequire("eS2Dn");

var $3cfam = parcelRequire("3cfam");
function $031b8beaad916af7$var$getClosestValidTextPositionBefore({ pos: pos, doc: doc }) {
    let validPos = pos;
    while(validPos > 0){
        if (doc.resolve(validPos).parent.inlineContent) break;
        validPos--;
    }
    return validPos;
}
function $031b8beaad916af7$var$getClosestValidTextPositionAfter({ pos: pos, doc: doc }) {
    let validPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.resolve(validPos).parent.inlineContent) {
            isValidPos = true;
            break;
        }
        validPos++;
    }
    return validPos;
}
function $031b8beaad916af7$var$findLastChildWithTextContent(content) {
    if (content.childCount <= 0) return null;
    let count = content.childCount - 1;
    const validNode = content.child(count);
    while(count >= 0){
        if (content.child(count).textContent !== '') break;
        count--;
    }
    return validNode;
}
function $031b8beaad916af7$var$getEndPosition({ step: step, doc: doc }) {
    let validPos = step.from + step.slice.size;
    let isValidPos = false;
    // Fragments can contain empty nodes, find the last childNode that has textContent
    const validNode = $031b8beaad916af7$var$findLastChildWithTextContent(step.slice.content);
    // Return start position if there are no valid nodes
    if (!validNode) return step.from;
    // Find textContent of last childNode with textContent
    const textContent = validNode.textContent;
    // Loop through endPos and find position where textBetween start and endPos matches textContent from last childNode in step
    // Check slice created between the positions to ensure no empty child nodes
    while(isValidPos === false && validPos > 0){
        const textBetween = doc.textBetween(step.from, validPos);
        const slice = doc.slice(step.from, validPos);
        if (textBetween.endsWith(textContent) && slice.content.lastChild?.textContent !== '') {
            isValidPos = true;
            break;
        }
        validPos--;
    }
    return validPos;
}
function $031b8beaad916af7$var$getValidStartTextPosition({ pos: pos, doc: doc }) {
    let startPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.nodeAt(startPos)) {
            isValidPos = true;
            break;
        }
        startPos++;
    }
    return $031b8beaad916af7$var$getClosestValidTextPositionAfter({
        pos: startPos,
        doc: doc
    });
}
function $031b8beaad916af7$export$a2bf0757549da456({ step: step, doc: doc }) {
    const endPos = $031b8beaad916af7$var$getEndPosition({
        step: step,
        doc: doc
    });
    return $031b8beaad916af7$var$getClosestValidTextPositionBefore({
        pos: endPos,
        doc: doc
    });
}
function $031b8beaad916af7$export$ec5fde712084a8ed(steps) {
    const step = steps.find((step)=>step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep));
    if (!step) return null;
    return step;
}
function $031b8beaad916af7$export$9d1e89ce90c0a9a(transaction) {
    const step = $031b8beaad916af7$export$ec5fde712084a8ed(transaction.steps);
    if (!step) return null;
    const validStartDecorationPos = $031b8beaad916af7$var$getValidStartTextPosition({
        pos: step.from,
        doc: transaction.doc
    });
    const validEndDecorationPos = $031b8beaad916af7$export$a2bf0757549da456({
        step: step,
        doc: transaction.doc
    });
    return (0, $3cfam.createGeneratedContentDecorations)(validStartDecorationPos, validEndDecorationPos);
}
function $031b8beaad916af7$export$a6a2b5778b599ea1(transaction) {
    const replaceSteps = transaction.steps.filter((step)=>step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep));
    if (replaceSteps.length === 0) return [];
    return replaceSteps.map((step)=>{
        const startPos = step.from;
        const node = transaction.doc.nodeAt(startPos);
        if (node) {
            const endPos = startPos + node.nodeSize;
            return (0, $3cfam.createGeneratedNodeDecorations)(startPos, endPos);
        }
    }).filter((decoration)=>decoration !== undefined);
}

});
parcelRegister("3cfam", function(module, exports) {

$parcel$export(module.exports, "createWidgetDecoration", () => $55de771aac360624$export$6428b9f2a07e29a5);
$parcel$export(module.exports, "createInlineDecoration", () => $55de771aac360624$export$1690e22aee311809);
$parcel$export(module.exports, "createGeneratedContentDecorations", () => $55de771aac360624$export$ee67e3280dab453d);
$parcel$export(module.exports, "createGeneratedNodeDecorations", () => $55de771aac360624$export$21c5d318062e995c);
$parcel$export(module.exports, "createOpenAIModalCommand", () => $55de771aac360624$export$2c80ad35b3530be1);
$parcel$export(module.exports, "createEndAIExperienceCommand", () => $55de771aac360624$export$d547a4e9ddb6b51);

var $gkwXh = parcelRequire("gkwXh");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $aIZdc = parcelRequire("aIZdc");

var $f3wRU = parcelRequire("f3wRU");

var $2lNOk = parcelRequire("2lNOk");

var $2Fgji = parcelRequire("2Fgji");

var $8cX7t = parcelRequire("8cX7t");

var $jSlH9 = parcelRequire("jSlH9");
const $55de771aac360624$export$6428b9f2a07e29a5 = (pos, type, key)=>{
    const widgetSpanElement = document.createElement('span');
    // Firefox needs content inside the span in order to add height to the element.
    // Otherwise, the height is set to 0 which prevents the start and
    // end widgets from rendering correctly and produces incorrect measurements
    // when we need to determine where to place the modal under the content.
    // Zero width spaces have been known to introduce some strange selection
    // behaviour in the Editor, however this approach works for our use case
    // in the ai-plugin where we do not expect users to be making selections
    // over ai-highlighted content in the same way they select regular content
    // in the Editor, this is also not intended to be a permanent fix post EAP.
    widgetSpanElement.appendChild(document.createTextNode('\u200b'));
    widgetSpanElement.setAttribute('data-testid', `ai-modal-${type}-widget`);
    widgetSpanElement.className = `ai-modal-${type}-widget`;
    widgetSpanElement.contentEditable = 'false';
    return (0, $etG8M.Decoration).widget(pos, widgetSpanElement, {
        side: type === 'start' ? 0 : -1,
        key: key ?? `${type}WidgetDecoration`
    });
};
const $55de771aac360624$export$1690e22aee311809 = (from, to)=>{
    return (0, $etG8M.Decoration).inline(from, to, {
        class: 'ai-selection-highlight',
        'data-testid': 'ai-selection-highlight'
    }, {
        key: 'inlineDecoration'
    });
};
const $55de771aac360624$export$ee67e3280dab453d = (from, to)=>{
    const startWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(from, 'start', 'generatedStartWidget');
    const highlightInlineDecoration = (0, $etG8M.Decoration).inline(from, to, {
        class: 'ai-generated-content-highlight',
        'data-testid': 'ai-generated-content-highlight'
    }, {
        key: 'generatedInlineDecoration'
    });
    const endWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(to, 'end', 'generatedEndWidget');
    return [
        startWidgetDecoration,
        highlightInlineDecoration,
        endWidgetDecoration
    ];
};
const $55de771aac360624$export$50894b1f0083184 = (from, to)=>{
    return (0, $etG8M.Decoration).node(from, to, {
        class: 'ai-selection-node',
        'data-testid': 'ai-selection-node'
    }, {
        key: 'ai-nodeDecoration'
    });
};
const $55de771aac360624$export$21c5d318062e995c = (from, to)=>{
    return (0, $etG8M.Decoration).node(from, to, {
        class: 'ai-generated-node-highlight',
        'data-testid': 'ai-generated-node-highlight'
    }, {
        key: 'generatedNodeDecoration'
    });
};
function $55de771aac360624$var$getInitialPositions(selection) {
    switch(true){
        case selection instanceof (0, $gZGBX.AllSelection):
            return {
                startPos: selection.from + 1,
                endPos: selection.to - 1
            };
        default:
            return {
                startPos: selection.from,
                endPos: selection.to
            };
    }
}
const $55de771aac360624$export$4379c9f48a526c4d = ({ state: state, positions: positions })=>{
    const { selection: selection } = state;
    let from, to;
    if (selection instanceof (0, $gZGBX.NodeSelection)) {
        from = selection.from;
        to = selection.to;
    } else if ((0, $2lNOk.isCellSelection)(state)) {
        const findResult = (0, $5r0mK.findParentNodeOfType)(state.schema.nodes.table)(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    } else {
        const { selection: selection } = state;
        const supportedNodes = (0, $2lNOk.getSupportedNodesForAIModal)(state);
        const findResult = (0, $5r0mK.findParentNode)((node)=>supportedNodes.has(node.type))(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    }
    if (from !== undefined && to !== undefined) return [
        $55de771aac360624$export$50894b1f0083184(from, to)
    ];
    return [];
};
const $55de771aac360624$export$8b0c0139da7bc378 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, positions: positions, initialPositions: initialPositions })=>{
    if ((0, $VSDnB.fg)('platform_editor_ai_update_decorations_n_positions')) {
        /**
		 * We add selection highlight decoration based on the current selection state of the document and the config item in the command palette
		 * If the selection is empty and the document is not empty -> we decorate the entire document unless the config item specifies otherwise
		 */ let useCurrentSelectionForHighlight = true;
        // when clicking `browse agents` then selecting an agent, the state.selection is already cleared
        // so we need to use initialPositions to check if the selection is empty
        if (initialPositions[0] === initialPositions[1] && state.doc.content.size !== 0) useCurrentSelectionForHighlight = !!configItem.doNotHighlightDocWhenSelectionIsEmpty;
        /**
		 * EXPERIMENTAL: For experimental flow where 'Suggest title' in
		 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
		 * Forces whole document selection, even if an existing selection exists.
		 */ if ((0, $f3wRU.isConfluenceTitleToolbarSuggestTitle)({
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom
        })) useCurrentSelectionForHighlight = false;
        const { startPos: startPos, endPos: endPos } = useCurrentSelectionForHighlight ? {
            startPos: initialPositions[0],
            endPos: initialPositions[1]
        } : $55de771aac360624$var$getInitialPositions(new (0, $gZGBX.AllSelection)(state.doc));
        const highlightInlineDecoration = $55de771aac360624$export$1690e22aee311809(startPos, endPos);
        const startWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(initialPositions[0], 'start');
        const endWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(initialPositions[1], 'end');
        const widgetDecorations = initialPositions[0] === initialPositions[1] ? [
            endWidgetDecoration
        ] : [
            startWidgetDecoration,
            endWidgetDecoration
        ];
        return [
            ...widgetDecorations,
            highlightInlineDecoration
        ];
    } else {
        /**
		 * We add decoration based on the current selection
		 * state of the document and the config item in the command palette
		 * 2 scenarios
		 * 1. If the selection is empty and the document is not empty -> we decorate the entire document
		 * 2. If the selection is empty and the current config type is 'empty config' -> we decorate based on selection preview plugin
		 */ let useCurrentSelection = true;
        if (state.selection.empty && state.doc.content.size !== 0) useCurrentSelection = !!configItem.doNotHighlightDocWhenSelectionIsEmpty;
        /**
		 * EXPERIMENTAL: For experimental flow where 'Suggest title' in
		 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
		 * Forces whole document selection, even if an existing selection exists.
		 */ if ((0, $f3wRU.isConfluenceTitleToolbarSuggestTitle)({
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom
        })) useCurrentSelection = false;
        const { startPos: startPos, endPos: endPos } = positions || $55de771aac360624$var$getInitialPositions(useCurrentSelection ? state.selection : new (0, $gZGBX.AllSelection)(state.doc));
        // Then create the decorations and add them to a decoration set
        const startWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(startPos, 'start');
        const endWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(endPos, 'end');
        const highlightInlineDecoration = $55de771aac360624$export$1690e22aee311809(startPos, endPos);
        const widgetDecorations = startPos === endPos ? [
            endWidgetDecoration
        ] : [
            startWidgetDecoration,
            endWidgetDecoration
        ];
        return [
            ...widgetDecorations,
            highlightInlineDecoration
        ];
    }
};
const $55de771aac360624$export$2c80ad35b3530be1 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, triggerMethod: triggerMethod, aiGlobalOptIn: aiGlobalOptIn, initialPrompt: initialPrompt, positions: positions, triggeredFor: triggeredFor, adjustSelection: adjustSelection, nudgeMetrics: /**
	 * Nudge metrics will be used passed in analytics events.
	 * It includes detailed metrics for improve writing nudge.
	 * It is currently only set when "Improve writing" is triggered from the
	 * "Improve writing" nudge.
	 */ nudgeMetrics })=>{
    /**
	 * WARNING: Do not remove the isFedRamp check.
	 * This is to ensure that AI functionality is not enabled in FedRamp environments.
	 */ if (aiGlobalOptIn.status === 'disabled' || (0, $aIZdc.isFedRamp)()) /**
		 * If the user has opted out of AI, or if user is in FedRamp environment,
		 * do not show the modal it's unclear how this function would be triggered as
		 * all entry points should be removed already
		 */ return ()=>false;
    if (aiGlobalOptIn.status === 'disabled-opt-in') {
        aiGlobalOptIn.triggerOptInFlow();
        return (0, $jSlH9.createCommand)({}, (tr)=>{
            (0, $8cX7t.addAnalytics)({
                editorState: state,
                tr: tr,
                payload: {
                    action: 'triggerOptInFlow',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiGlobalOptIn',
                    attributes: {
                        experienceType: (0, $2Fgji.convertExperienceName)(configItem.key),
                        lastTriggeredFrom: lastTriggeredFrom,
                        selectionType: state.selection.empty ? 'empty' : 'range'
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                }
            });
            return tr;
        });
    }
    const { from: from, to: to } = state.selection;
    const aiDecorationExperiencePluginState = (0, $jSlH9.getPluginState)(state);
    const initialPositions = aiDecorationExperiencePluginState.initialPositions || [
        from,
        to
    ];
    let modalDecorationSet = (0, $etG8M.DecorationSet).empty;
    if (triggeredFor?.isBlock) {
        // First get the positions that the decorations will be added to the document at
        const decorations = $55de771aac360624$export$4379c9f48a526c4d({
            state: state,
            // positions is unused in function getModalDecorationsForNodeSelection
            positions: (0, $VSDnB.fg)('platform_editor_ai_update_decorations_n_positions') ? undefined : positions
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    } else {
        const decorations = $55de771aac360624$export$8b0c0139da7bc378({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom,
            positions: (0, $VSDnB.fg)('platform_editor_ai_update_decorations_n_positions') ? undefined : positions,
            initialPositions: initialPositions
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    }
    // This "command" is later picked up by a state reducer
    const action = {
        type: 'SHOW_MODAL',
        data: {
            lastTriggeredFrom: lastTriggeredFrom,
            triggerMethod: triggerMethod,
            modalDecorationSet: modalDecorationSet,
            configItem: configItem,
            modalMountedTimeStamp: Date.now(),
            initialPrompt: initialPrompt,
            triggeredFor: triggeredFor,
            initialPositions: (0, $VSDnB.fg)('platform_editor_ai_update_decorations_n_positions') ? initialPositions : [
                from,
                to
            ],
            nudgeMetrics: nudgeMetrics
        }
    };
    // Clear the selection after opening the modal to hide annotation toolbar
    return (0, $jSlH9.createCommand)(action, (tr)=>{
        const selection = tr.selection;
        const { to: to, from: from } = selection;
        if (!triggeredFor?.isBlock && to !== from) tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, to));
        return tr;
    });
};
const $55de771aac360624$export$d547a4e9ddb6b51 = (modalDecorationSet, preserveEditorSelectionOnComplete)=>{
    const action = {
        type: 'END_EXPERIENCE',
        data: modalDecorationSet && !preserveEditorSelectionOnComplete ? {
            modalDecorationSet: modalDecorationSet
        } : {}
    };
    return (0, $jSlH9.createCommand)(action, (tr)=>{
        if (preserveEditorSelectionOnComplete) {
            const inlineDeco = modalDecorationSet?.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration')?.[0];
            if (inlineDeco) tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, inlineDeco.from, Math.min(inlineDeco.to, tr.doc.content.size)));
        }
        return tr;
    });
};

});
parcelRegister("f3wRU", function(module, exports) {

$parcel$export(module.exports, "isConfluenceTitleToolbarSuggestTitle", () => $dd9166d8fbebefb3$export$fc21f0ec31fe4ec0);

var $dw3LE = parcelRequire("dw3LE");
const $dd9166d8fbebefb3$export$fc21f0ec31fe4ec0 = ({ configItem: configItem, lastTriggeredFrom: lastTriggeredFrom })=>{
    if (!configItem || !lastTriggeredFrom) return false;
    return configItem.key === (0, $dw3LE.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && lastTriggeredFrom === 'confluenceTitleToolbar';
};

});
parcelRegister("dw3LE", function(module, exports) {

$parcel$export(module.exports, "CONFIG_ITEM_KEYS", () => $999f0586314ae254$export$a48b28ab7ec6401c);

var $ac3U1 = parcelRequire("ac3U1");
var $999f0586314ae254$export$a48b28ab7ec6401c = /*#__PURE__*/ function(CONFIG_ITEM_KEYS) {
    CONFIG_ITEM_KEYS["ADD_STRUCTURE"] = "Add structure";
    CONFIG_ITEM_KEYS["BRAINSTORM"] = "Brainstorm";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_CASUAL"] = "Change tone to casual";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EDUCATIONAL"] = "Change tone to educational";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EMPATHETIC"] = "Change tone to empathetic";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_NEUTRAL"] = "Change tone to neutral";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_PROFESSIONAL"] = "Change tone to professional";
    CONFIG_ITEM_KEYS["CREATE_PULL_REQUEST_DESCRIPTION"] = "Create pull request description";
    CONFIG_ITEM_KEYS["DESCRIBE_YOUR_PULL_REQUEST"] = "Describe your pull request";
    CONFIG_ITEM_KEYS["FIND_ACTION_ITEMS"] = "Find action items";
    CONFIG_ITEM_KEYS["FIX_SPELLING_AND_GRAMMAR"] = "Fix spelling & grammar";
    CONFIG_ITEM_KEYS["FREE_GENERATE"] = "AI (Atlassian Intelligence)";
    CONFIG_ITEM_KEYS["IMPROVE_WRITING"] = "Improve writing";
    CONFIG_ITEM_KEYS["MAKE_SHORTER"] = "Make shorter";
    CONFIG_ITEM_KEYS["ROVO_AGENT"] = "Rovo agent";
    CONFIG_ITEM_KEYS["SHORTEN_UPDATE"] = "Shorten update";
    CONFIG_ITEM_KEYS["SUGGEST_A_TITLE"] = "Suggest a title";
    CONFIG_ITEM_KEYS["SUGGEST_REPONSE"] = "Suggest a response";
    CONFIG_ITEM_KEYS["SUMMARISE_WRITING"] = "Summarize writing";
    CONFIG_ITEM_KEYS["MAKE_LONGER"] = "Make longer";
    CONFIG_ITEM_KEYS["REPHRASE"] = "Rephrase";
    CONFIG_ITEM_KEYS["ADD_INTRODUCTION"] = "Add introduction";
    CONFIG_ITEM_KEYS["ADD_CONCLUSION"] = "Add conclusion";
    CONFIG_ITEM_KEYS["CONVERT_TO_BULLETED_LIST"] = "Convert to bulleted list";
    CONFIG_ITEM_KEYS["CONVERT_TO_TABLE"] = "Convert to table";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_SIMPLIFIED"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).ChineseSimplified}`] = "TRANSLATE_TO_CHINESE_SIMPLIFIED";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_TRADITIONAL"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).ChineseTraditional}`] = "TRANSLATE_TO_CHINESE_TRADITIONAL";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CZECH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Czech}`] = "TRANSLATE_TO_CZECH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DANISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Danish}`] = "TRANSLATE_TO_DANISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DUTCH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Dutch}`] = "TRANSLATE_TO_DUTCH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ENGLISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).English}`] = "TRANSLATE_TO_ENGLISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FINNISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Finnish}`] = "TRANSLATE_TO_FINNISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FRENCH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).French}`] = "TRANSLATE_TO_FRENCH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_GERMAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).German}`] = "TRANSLATE_TO_GERMAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_HUNGARIAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Hungarian}`] = "TRANSLATE_TO_HUNGARIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ITALIAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Italian}`] = "TRANSLATE_TO_ITALIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_JAPANESE"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Japanese}`] = "TRANSLATE_TO_JAPANESE";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_KOREAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Korean}`] = "TRANSLATE_TO_KOREAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_NORWEGIAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Norwegian}`] = "TRANSLATE_TO_NORWEGIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_POLISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Polish}`] = "TRANSLATE_TO_POLISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_PORTUGUESE_BRAZILIAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).PortugueseBrazilian}`] = "TRANSLATE_TO_PORTUGUESE_BRAZILIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_RUSSIAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Russian}`] = "TRANSLATE_TO_RUSSIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SPANISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Spanish}`] = "TRANSLATE_TO_SPANISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SWEDISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Swedish}`] = "TRANSLATE_TO_SWEDISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_TURKISH"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Turkish}`] = "TRANSLATE_TO_TURKISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_THAI"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Thai}`] = "TRANSLATE_TO_THAI";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_UKRAINIAN"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Ukrainian}`] = "TRANSLATE_TO_UKRAINIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_VIETNAMESE"] = `Translate to ${(0, $ac3U1.SupportedTranslationLanguages).Vietnamese}`] = "TRANSLATE_TO_VIETNAMESE";
    CONFIG_ITEM_KEYS["EXPERIMENTAL_PROMPT_PLACEHOLDER"] = "Experimental prompt placeholder";
    return CONFIG_ITEM_KEYS;
}({});

});
parcelRegister("ac3U1", function(module, exports) {

$parcel$export(module.exports, "SupportedTranslationLanguages", () => $e2a5c8e3de7418c6$export$c5e4fced70735903);
$parcel$export(module.exports, "supportedTranslationLanguagesPopularOrder", () => $e2a5c8e3de7418c6$export$20cfed69f1ef38ea);
$parcel$export(module.exports, "refinementSupportedTranslationLanguages", () => $e2a5c8e3de7418c6$export$9e88c4e080b12be6);
var $e2a5c8e3de7418c6$export$c5e4fced70735903 = /*#__PURE__*/ function(SupportedTranslationLanguages) {
    SupportedTranslationLanguages["ChineseSimplified"] = "chineseSimplified";
    SupportedTranslationLanguages["ChineseTraditional"] = "chineseTraditional";
    SupportedTranslationLanguages["Czech"] = "czech";
    SupportedTranslationLanguages["Danish"] = "danish";
    SupportedTranslationLanguages["Dutch"] = "dutch";
    SupportedTranslationLanguages["English"] = "english";
    SupportedTranslationLanguages["Finnish"] = "finnish";
    SupportedTranslationLanguages["French"] = "french";
    SupportedTranslationLanguages["German"] = "german";
    SupportedTranslationLanguages["Hungarian"] = "hungarian";
    SupportedTranslationLanguages["Italian"] = "italian";
    SupportedTranslationLanguages["Japanese"] = "japanese";
    SupportedTranslationLanguages["Korean"] = "korean";
    SupportedTranslationLanguages["Norwegian"] = "norwegian";
    SupportedTranslationLanguages["Polish"] = "polish";
    SupportedTranslationLanguages["PortugueseBrazilian"] = "portugueseBrazilian";
    SupportedTranslationLanguages["Russian"] = "russian";
    SupportedTranslationLanguages["Spanish"] = "spanish";
    SupportedTranslationLanguages["Swedish"] = "swedish";
    SupportedTranslationLanguages["Turkish"] = "turkish";
    SupportedTranslationLanguages["Thai"] = "thai";
    SupportedTranslationLanguages["Ukrainian"] = "ukrainian";
    SupportedTranslationLanguages["Vietnamese"] = "vietnamese";
    return SupportedTranslationLanguages;
}({});
const $e2a5c8e3de7418c6$export$20cfed69f1ef38ea = [
    "english",
    "german",
    "japanese",
    "french",
    "korean",
    "spanish",
    "portugueseBrazilian",
    "russian",
    "dutch",
    "chineseSimplified",
    "polish",
    "italian",
    "chineseTraditional",
    "norwegian",
    "swedish",
    "czech",
    "finnish",
    "danish",
    "hungarian",
    "turkish",
    "thai",
    "ukrainian",
    "vietnamese"
];
const $e2a5c8e3de7418c6$export$9e88c4e080b12be6 = [
    "english",
    "german",
    "french",
    "spanish",
    "japanese",
    "portugueseBrazilian",
    "chineseSimplified",
    "korean"
];

});



parcelRegister("2lNOk", function(module, exports) {

$parcel$export(module.exports, "getSupportedNodesForAIModal", () => $23b2e9aa3808e386$export$74e7028cbce2b0e1);
$parcel$export(module.exports, "isCellSelection", () => $23b2e9aa3808e386$export$73f561bc8b894934);
const $23b2e9aa3808e386$export$74e7028cbce2b0e1 = ({ schema: { nodes: nodes } })=>new Set([
        nodes.table
    ]);
const $23b2e9aa3808e386$export$73f561bc8b894934 = (state, selection)=>{
    const { tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = state.schema.nodes;
    const { $from: $from } = selection || state.selection;
    const parent = $from.parent;
    return [
        tableHeader,
        tableCell,
        tabeRow,
        table
    ].includes(parent.type);
};

});

parcelRegister("2Fgji", function(module, exports) {

$parcel$export(module.exports, "convertExperienceName", () => $9c653f78d59b18d9$export$42373263ca9a5144);
$parcel$export(module.exports, "createAnalyticsFlow", () => $9c653f78d59b18d9$export$7e715b9b9acf423a);

var $bXrHm = parcelRequire("bXrHm");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $iEN9D = parcelRequire("iEN9D");

var $kqjFe = parcelRequire("kqjFe");

var $dw3LE = parcelRequire("dw3LE");

var $8cX7t = parcelRequire("8cX7t");
function $9c653f78d59b18d9$export$42373263ca9a5144(experienceName, invokedFrom) {
    // The Proactive Description Completer are using the shared config item key with issue reformatter
    // Need to get the correct experience name from invokedFrom
    // This is temp solution to distinguish two experience
    // We are planning to add a new config item key for Proactive Description Completer
    if (invokedFrom === 'jiraProactiveDescriptionCompleterFooterButton' && experienceName === (0, $dw3LE.CONFIG_ITEM_KEYS).ADD_STRUCTURE) return 'proactiveDescriptionCompleter';
    if (experienceName === (0, $dw3LE.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER) {
        /**
		 * We only check for experiment value here as the config item would not exist
		 * if the experiment is not enabled / is misconfigured.
		 */ const getExperimentValue = (0, $iEN9D.default).getExperimentValue;
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        return analyticsExperienceName || experienceName;
    }
    return experienceName;
}
function $9c653f78d59b18d9$export$7e715b9b9acf423a({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, invokeAttributes: invokeAttributes }) {
    const startTime = performance.now();
    const stepTracker = {};
    const aiSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
    let prevStepEnd = performance.now();
    let prevStepName;
    let experienceName;
    let adhocAttributes = {};
    let commonAttributes = {};
    let dynamicAttributes = {};
    let aiLifeCycleDynamicAttributesGetter;
    let finished = false;
    let contentCopiedSometime = false;
    const sawAupViolation = false;
    let interactionsCounter = 0;
    let lastAiInteractionID;
    let queuedStepArgs = {
        stepName: 'invoke',
        attributes: invokeAttributes
    };
    /**
	 * A util function to get dynamic attributes for the AI lifecyle
	 * The previously registered getter is invoked when the lifecyle begins
	 * The resolved attributes are then used until the lifecycle ends
	 */ const getAiLifeCycleDynamicAttributes = ({ init: init })=>{
        if (init && aiLifeCycleDynamicAttributesGetter) dynamicAttributes = aiLifeCycleDynamicAttributesGetter();
        return dynamicAttributes;
    };
    const getAgentAttributes = ()=>{
        return {
            agentName: commonAttributes.agentName,
            agentId: commonAttributes.agentId,
            agentCreatorType: commonAttributes.agentCreatorType,
            agentExternalConfigReference: commonAttributes.agentExternalConfigReference,
            agentIsDefault: commonAttributes.agentIsDefault
        };
    };
    const analyticsFlow = {
        aiSessionId: aiSessionId,
        /**
		 * Add a step to the queue to be fired on next screen.
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * analyticsFlow.enqueueStep({ stepName, attributes });
		 * ```
		 */ enqueueStep: (stepArgs)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($9c653f78d59b18d9$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            if (stepArgs.stepName === 'loading') {
                lastAiInteractionID = `${aiSessionId}-${++interactionsCounter}`;
                fireAIAnalyticsEvent({
                    payload: (0, $kqjFe.createUnifiedAnalyticsPayload)({
                        action: (0, $gkwXh.ACTION).INITIATED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $9c653f78d59b18d9$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: true
                            }),
                            ...getAgentAttributes()
                        }
                    })
                });
            }
            if (stepArgs.stepName === 'complete') {
                const attributes = stepArgs?.attributes ?? {};
                const actionTaken = 'actionTaken' in attributes ? attributes.actionTaken : undefined;
                const promptType = 'promptType' in attributes ? attributes.promptType : undefined;
                const refinementCount = 'refinementCount' in attributes ? attributes.refinementCount : undefined;
                fireAIAnalyticsEvent({
                    payload: (0, $kqjFe.createUnifiedAnalyticsPayload)({
                        action: (0, $gkwXh.ACTION).ACTIONED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $9c653f78d59b18d9$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: false
                            }),
                            ...getAgentAttributes(),
                            promptType: promptType,
                            refinementCount: refinementCount,
                            aiResultAction: actionTaken?.toLowerCase()
                        },
                        traceIds: commonAttributes.traceIds
                    })
                });
            }
            // If there is already a queued step, we fire an operational error and return
            if (queuedStepArgs !== undefined) {
                fireAIAnalyticsEvent($9c653f78d59b18d9$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'cannotEnqueueMoreThanOneEvent',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            queuedStepArgs = stepArgs;
        },
        fireQueuedStep: (target)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($9c653f78d59b18d9$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        target: target,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            // If there is no queued step, we fire an operational error and return
            if (!queuedStepArgs) {
                fireAIAnalyticsEvent($9c653f78d59b18d9$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'noEventExistsToBeFired',
                    errorProperties: {
                        target: target
                    }
                }));
                return;
            }
            queuedStepArgs.attributes = {
                ...queuedStepArgs.attributes,
                ...adhocAttributes,
                ...commonAttributes,
                invokedFrom: invokeAttributes.invokedFrom,
                nudgeMetrics: commonAttributes.nudgeMetrics,
                invokedFor: invokeAttributes.invokedFor,
                triggerMethod: invokeAttributes.triggerMethod,
                target: target
            };
            if (target === 'failed' || target === 'apiError') fireAIAnalyticsEvent({
                payload: (0, $kqjFe.createUnifiedAnalyticsPayload)({
                    action: (0, $gkwXh.ACTION).ERROR,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $9c653f78d59b18d9$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes(),
                        aiErrorMessage: (0, $8cX7t.isErrorStepAttributes)(queuedStepArgs?.attributes) ? queuedStepArgs?.attributes?.errorKey ?? queuedStepArgs?.attributes?.errorType : 'Unknown error',
                        aiErrorCode: (0, $8cX7t.isErrorStepAttributes)(queuedStepArgs.attributes) ? queuedStepArgs.attributes?.statusCode ?? 500 : 500
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            if (target === 'preview') fireAIAnalyticsEvent({
                payload: (0, $kqjFe.createUnifiedAnalyticsPayload)({
                    action: (0, $gkwXh.ACTION).VIEWED,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $9c653f78d59b18d9$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes()
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            // Add target to attributes and fire the event
            fireUserFlowStep(queuedStepArgs);
            // Remove the queued event
            queuedStepArgs = undefined;
        },
        /**
		 * This is useful when you want to add attributes to the current step
		 * but you don't know them at the time of enqueuing the step.
		 *
		 * It's safe to fire this on dismount -- because the step is enqueued in the dismount
		 * of a parent component (where AnalyticsFlowContextProvider is setup).
		 *
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * React.useEffect(() => {
		 *  return () => {
		 *    // add attribute on dismount
		 *    analyticsFlow.addAttributes({ loadingTime })
		 *  }
		 * })
		 * ```
		 */ addAttributes: (attributes)=>{
            // The user copying the content is being treated as a potential success indicator
            // This is a weak signal as we don't know if the user actually used the copied content
            // and might expect the user to copy the content in cases where the generation failed.
            if ('contentCopied' in attributes && attributes.contentCopied) contentCopiedSometime = true;
            adhocAttributes = {
                ...adhocAttributes,
                ...attributes
            };
        },
        getAiLifeCycleDynamicAttributes: getAiLifeCycleDynamicAttributes,
        /**
		 * Editor-AI can be invoked in various contexts.
		 * In some of those scenarios, we want to register additional attributes to understand how the respective feature is performing.
		 *
		 * For example, when the Issue Reformatter is used, we want to understand analytics such as
		 *  - The issue-type of the issue where the issue reformatter was invoked
		 *  - Whether the feature was used from Issue-View or GIC
		 *  - Product type such as JWM and JSW
		 *
		 * This method registers a attribute getter function.
		 * The function will be invoked when the feature is first run (i.e. along with `aiInteraction Initiated`)
		 * The resolved values will then be unchanged until the AI lifecyle is completed
		 * i.e. The same values will be used for all events such as `aiResult Viewed` and `aiResult dismissed`
		 *
		 * In the current version, this method accepts one getter function, and assumes that there aren't multiple functions.
		 * In future, this can be tweaked to allow multiple getters.
		 * Such improvements need to be done carefully so that the getters are also unregistered accordingly
		 */ registerAiLifeCycleDynamicAttributesGetter: (getter)=>{
            aiLifeCycleDynamicAttributesGetter = getter;
        },
        /**
		 * Common attributes will be retained for the rest of the analytics flow
		 * until it is updated again
		 *
		 * Example uses: keeping track of which backendModel has been selected
		 */ updateCommonAttributes: (attributes)=>{
            commonAttributes = {
                ...commonAttributes,
                ...attributes
            };
        },
        getLastAiInteractionId: ()=>lastAiInteractionID,
        getUserFlowCommonAttributes: (configItem)=>{
            return {
                agentName: configItem.agent?.creatorType === 'SYSTEM' ? configItem.agent?.name : undefined,
                agentId: configItem.agent?.id,
                agentCreatorType: configItem.agent?.creatorType,
                agentExternalConfigReference: configItem.agent?.externalConfigReference,
                agentIsDefault: configItem.agent?.isDefault
            };
        }
    };
    return analyticsFlow;
    function fireUserFlowStep({ stepName: stepName, attributes: attributes = {} }) {
        if (!stepTracker[stepName]) stepTracker[stepName] = 1;
        else stepTracker[stepName] = stepTracker[stepName] + 1;
        if (attributes.experienceName) experienceName = $9c653f78d59b18d9$export$42373263ca9a5144(attributes.experienceName, invokeAttributes.invokedFrom);
        const stepAttributes = {
            ...commonAttributes,
            // the duration is currently being overriden in the complete step
            duration: Math.round(performance.now() - prevStepEnd),
            ...attributes,
            aiSessionId: aiSessionId,
            experienceName: experienceName,
            source: prevStepName,
            invokedFrom: attributes.invokedFrom,
            nudgeMetrics: attributes.nudgeMetrics,
            triggerMethod: attributes.triggerMethod,
            isInvokedFromEmptyPage: attributes.isInvokedFromEmptyPage,
            stepOccurrence: String(stepTracker[stepName]),
            sawAupViolation: sawAupViolation,
            includeKnowledgeFromCurrentPage: attributes.includeKnowledgeFromCurrentPage
        };
        // add totalDuration only to the final step
        // and set the experience as finished
        if (!attributes.target) {
            stepAttributes.totalDuration = Math.round(performance.now() - startTime);
            stepAttributes.contentCopiedSometime = contentCopiedSometime;
            finished = true;
        }
        // adding interaction ID to the events coming after the loading step, + final complete step
        if (stepAttributes.source === 'loading' || stepName === 'complete') stepAttributes.aiInteractionID = lastAiInteractionID;
        const payload = {
            action: stepName,
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: stepAttributes,
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        };
        //each step is a starting point for measuring duration for next step
        prevStepEnd = performance.now();
        //reset previous step name and custom attributes
        prevStepName = stepName;
        adhocAttributes = {};
        fireAIAnalyticsEvent({
            payload: payload
        });
        if (finished) fireAIAnalyticsEvent({
            payload: {
                ...payload,
                action: 'finished',
                attributes: {
                    ...payload.attributes,
                    // override source to be the previous last step in the flow
                    source: stepName
                }
            }
        });
    }
}
/**
 * Creates an operational error payload
 */ function $9c653f78d59b18d9$var$createErrorPayload({ errorSubType: errorSubType, errorProperties: errorProperties }) {
    return {
        payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
                errorType: 'userFlowAnalyticsError',
                errorSubType: errorSubType,
                ...errorProperties
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        },
        channel: (0, $dWAZk.FabricChannel).editor
    };
}

});
parcelRegister("kqjFe", function(module, exports) {

$parcel$export(module.exports, "createUnifiedAnalyticsPayload", () => $f299334a2e8cca3e$export$b0cd7b0ace1e359d);

var $gkwXh = parcelRequire("gkwXh");
function $f299334a2e8cca3e$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics) {
    return {
        singleInstrumentationID: interactionID ?? '',
        aiInteractionID: interactionID ?? '',
        aiFeatureName: 'Editor AI',
        aiExperienceName: experienceName ?? 'unknown',
        isAIFeature: 1,
        proactiveAIGenerated: !!isProactive ? 1 : 0,
        userGeneratedAI: !isProactive ? 1 : 0,
        traceIds: traceIds,
        invokedFrom: invokedFrom,
        nudgeMetrics: nudgeMetrics
    };
}
function $f299334a2e8cca3e$export$b0cd7b0ace1e359d({ action: action, interactionID: interactionID, attributes: attributes, experienceName: experienceName, isProactive: isProactive, invokedFrom: invokedFrom, traceIds: traceIds, nudgeMetrics: nudgeMetrics }) {
    const unifiedAnalyticsAttributes = $f299334a2e8cca3e$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics);
    switch(action){
        case (0, $gkwXh.ACTION).ACTIONED:
            return {
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    aiResultAction: 'unknown',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $gkwXh.ACTION).VIEWED:
        case (0, $gkwXh.ACTION).ERROR:
            return {
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $gkwXh.ACTION).INITIATED:
        case (0, $gkwXh.ACTION).DISMISSED:
            return {
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).AI_INTERACTION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $gkwXh.ACTION).SUBMITTED:
            return {
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).AI_FEEDBACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    // If feedback result is not explicitly set then we should assume negative, since people are more likely to
                    // report negative experiences than they are positive ones.
                    aiFeedbackResult: 'down',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
    }
}

});

parcelRegister("8cX7t", function(module, exports) {

$parcel$export(module.exports, "addAnalytics", () => $5e0fe1a56c6575b1$export$5bef18c22bfe95d);
$parcel$export(module.exports, "useFireAIAnalyticsEvent", () => $5e0fe1a56c6575b1$export$5098b64908ee530);
$parcel$export(module.exports, "isErrorStepAttributes", () => $5e0fe1a56c6575b1$export$1256d4293be5e625);

var $5uXOq = parcelRequire("5uXOq");

var $8aY84 = parcelRequire("8aY84");

var $dWAZk = parcelRequire("dWAZk");

var $2NMNM = parcelRequire("2NMNM");

var $2U6Vm = parcelRequire("2U6Vm");
function $5e0fe1a56c6575b1$export$e65dc2451c080d01(payload) {
    const packageInfo = (0, $2U6Vm.getPackageInfo)();
    const attributes = payload.attributes || {};
    return {
        ...payload,
        attributes: {
            ...attributes,
            aiPluginPackageName: packageInfo.packageName,
            aiPluginPackageVersion: packageInfo.packageVersion
        }
    };
}
// This utils is referenced from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
// Note: this adds extra step to a transaction which effectively marks it as docChanged and can cause editor onchange to fire on dispatch
function $5e0fe1a56c6575b1$var$attachPayloadIntoTransaction({ editorState: editorState, payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor }) {
    return (tr)=>{
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(editorState.selection.$from.pos, -1);
        tr.step(new (0, $8aY84.AnalyticsStep)([
            {
                payload: $5e0fe1a56c6575b1$export$e65dc2451c080d01(payload),
                channel: channel
            }
        ], [], // We don't understand now why we need position in AnalyticsStep.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // We need to create the step based on a position, this prevent split history for relative changes.
        pos));
        // We don't understand now why we need to store marks again in transaction.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // When you add a new step all the storedMarks are removed it
        if (storedMarks) tr.setStoredMarks(storedMarks);
        return true;
    };
}
function $5e0fe1a56c6575b1$export$5bef18c22bfe95d({ editorState: editorState, tr: tr, payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor, addToHistory: addToHistory = true }) {
    $5e0fe1a56c6575b1$var$attachPayloadIntoTransaction({
        editorState: editorState,
        payload: payload,
        channel: channel
    })(tr);
    if (!addToHistory) tr.setMeta('addToHistory', false);
    return tr;
}
function $5e0fe1a56c6575b1$export$af9baadf0e4f6e13({ payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor }) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) dispatch($5e0fe1a56c6575b1$export$5bef18c22bfe95d({
                            editorState: state,
                            tr: tr,
                            payload: dynamicPayload,
                            channel: channel
                        }));
                    } else dispatch($5e0fe1a56c6575b1$export$5bef18c22bfe95d({
                        editorState: state,
                        tr: tr,
                        payload: payload,
                        channel: channel
                    }));
                }
            }, view);
}
function $5e0fe1a56c6575b1$export$12ef4e1e68d53406(createAnalyticsEvent) {
    return ({ payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor })=>{
        if (!createAnalyticsEvent) return;
        const fireEvent = ()=>createAnalyticsEvent($5e0fe1a56c6575b1$export$e65dc2451c080d01(payload))?.fire(channel);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fireEvent);
        else if (window.requestAnimationFrame) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestAnimationFrame(fireEvent);
        else setTimeout(fireEvent, 0);
    };
}
function $5e0fe1a56c6575b1$export$5098b64908ee530() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAIAnalyticsEvent = (0, $5uXOq.useCallback)((args)=>$5e0fe1a56c6575b1$export$12ef4e1e68d53406(createAnalyticsEvent)(args), [
        createAnalyticsEvent
    ]);
    return fireAIAnalyticsEvent;
}
function $5e0fe1a56c6575b1$export$511854ca6705eca5(channelId, lastAiInteractionID) {
    return channelId ?? lastAiInteractionID ?? '';
}
function $5e0fe1a56c6575b1$export$1256d4293be5e625(step) {
    if (!step) return false;
    return 'errorKey' in step || 'errorType' in step || 'statusCode' in step;
}

});
parcelRegister("2U6Vm", function(module, exports) {

$parcel$export(module.exports, "getPackageInfo", () => $d801d81d4c2642cf$export$cd17d76da7967240);
const $d801d81d4c2642cf$var$packageName = "platform-pkg";
const $d801d81d4c2642cf$var$packageVersion = "0.0.0-use.local";
function $d801d81d4c2642cf$export$cd17d76da7967240() {
    return {
        packageName: $d801d81d4c2642cf$var$packageName,
        packageVersion: $d801d81d4c2642cf$var$packageVersion
    };
}

});



parcelRegister("jSlH9", function(module, exports) {

$parcel$export(module.exports, "createInitialState", () => $58ecf901089c14db$export$de5e90bd767c5d82);
$parcel$export(module.exports, "createPluginState", () => $58ecf901089c14db$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $58ecf901089c14db$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $58ecf901089c14db$export$f05434c51e3762e);

var $gkwXh = parcelRequire("gkwXh");

var $aOimD = parcelRequire("aOimD");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $iybVv = parcelRequire("iybVv");

var $3cfam = parcelRequire("3cfam");

var $kXXDl = parcelRequire("kXXDl");

var $7I8vO = parcelRequire("7I8vO");

var $b8ZqO = parcelRequire("b8ZqO");

var $9A8mD = parcelRequire("9A8mD");
/**
 * This creates a function which is called inside the prosemirror plugin state apply method via the
 * pluginFactory.
 *
 * The docChanged is called for every transaction where the docChanged property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * It takes a dispatchAnalyticsEvent in order to track whether the mapping we use to build a new PluginState
 * is throwing any errors.  This is a temporary measure to track whether we are hitting any edge cases
 * where the mapping is throwing errors. If we find that this is happening, we will revisit the approach
 * to building a new PluginState.
 *
 * The state being built here is used to  from the document used to;
 * - both apply and remove decorations to display the AI modal,
 * - apply decorations following the insertion of AI generated content, to highlight the inserted content (these are removed in the selectionChanged below).
 *
 * In future the intention is to seperate these concerns into seperate plugins.
 */ function $58ecf901089c14db$var$onDocChanged(tr, pluginState) {
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
    // In some collab edge cases mapping decorations could throw an error
    // The ProseMirror .mapping approach has a “dangerous” axiom:
    // Besides the initial state, a document will always “change” through a Transaction
    // However, in some conditions we may reconfigure the EditorState, and a new document
    // will be created without a transaction.
    // This try/catch intends to track cases of this happening and see if it impacts users
    try {
        // Check if transaction is from inserting AI generated content for blocks
        const isAiContentTransformationForBlocks = tr.getMeta('isAiContentTransformationForBlocks');
        // Return with generated content decoration for blocks
        if (isAiContentTransformationForBlocks) {
            const newDecorations = (0, $9A8mD.getGeneratedNodeDecorationsFromTransaction)(tr);
            if (newDecorations.length) return {
                ...pluginState,
                modalDecorationSet: (0, $etG8M.DecorationSet).create(tr.doc, newDecorations)
            };
        }
        // Check if transaction is from inserting AI generated content
        const generatedContentMeta = tr.getMeta('isAiContentTransformation');
        // Return with generated content decoration
        if (generatedContentMeta) {
            const newDecoration = (0, $9A8mD.getGeneratedDecorationFromTransaction)(tr);
            if (!newDecoration) throw new Error('Did not expect not to find new content in a `isAiContentTransformation` transaction?');
            return {
                ...pluginState,
                modalDecorationSet: (0, $etG8M.DecorationSet).create(tr.doc, newDecoration)
            };
        }
        // If there is no existing modal decoration -- exit early
        if (pluginState.modalDecorationSet === (0, $etG8M.DecorationSet).empty) return pluginState;
        // Check if generated AI decorations already exist
        const hasGeneratedContentDecoration = (0, $b8ZqO.hasGeneratedContentDecorations)(pluginState);
        const isRemote = tr.getMeta('isRemote') ?? false;
        /**
		 * Make sure it isn't a selection change from an appendTransaction
		 */ const selectionWasSet = tr.selectionSet && tr.getMeta('appendedTransaction') === undefined;
        /**
		 * Remove decorations if
		 * - current user interacts with doc
		 *   - and it is not an appendedTransaction
		 */ if (hasGeneratedContentDecoration && !isRemote && selectionWasSet) return {
            ...pluginState,
            modalDecorationSet: (0, $etG8M.DecorationSet).empty
        };
        // Map the modal decorationSet against the transaction
        const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
        // return mapped decoration set for case where other users in collab are making changes to doc
        if (hasGeneratedContentDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        // Find the start/inline/end decoration
        const decorations = mappedModalDecorationSet.find();
        let inlineDecoration = decorations.find((d)=>d.spec.key === 'inlineDecoration');
        let startDecoration = decorations.find((d)=>d.spec.key === 'startWidgetDecoration');
        let endDecoration = decorations.find((d)=>d.spec.key === 'endWidgetDecoration');
        const nodeDecoration = decorations.find((d)=>d.spec.key === 'ai-nodeDecoration');
        // AI experience was triggered by quick insert, no start widget or inline decoration
        if (nodeDecoration || endDecoration && !startDecoration && !inlineDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        /**
		 * If document change, causes inline positions to collapsed to same position,
		 * 	then don't need so AI model as all content between position has been deleted.
		 */ const initialPositions = pluginState.initialPositions;
        const inlineDecorationHasContent = !!inlineDecoration && initialPositions && initialPositions[0] !== initialPositions[1];
        // Return with no decorations if inline decoration does not exist
        // Handles edge case where the inline decoration can't be deleted at the start
        // of a doc even when it has no content
        // OR if it has no content (eg. selection is just empty paragraphs)
        if (!inlineDecoration || !inlineDecorationHasContent) return {
            ...pluginState,
            modalDecorationSet: (0, $etG8M.DecorationSet).empty
        };
        // Handle the case where doc changes move inlineDecoration to position 0
        // We cannot add text before inline decoration if from position is 0
        // Remove and recreate inline decoration starting at position 1
        if (inlineDecoration.from === 0) inlineDecoration = (0, $3cfam.createInlineDecoration)(inlineDecoration.from || 1, inlineDecoration.to || 1);
        // Create and add start widget into DecorationSet if it's been deleted
        if (!startDecoration) startDecoration = (0, $3cfam.createWidgetDecoration)(inlineDecoration.from, 'start');
        // Create and add end widget into DecorationSet if it doesn't exist
        if (!endDecoration) endDecoration = (0, $3cfam.createWidgetDecoration)(inlineDecoration.to, 'end');
        return {
            ...pluginState,
            modalDecorationSet: (0, $etG8M.DecorationSet).create(tr.doc, [
                startDecoration,
                inlineDecoration,
                endDecoration
            ])
        };
    } catch (error) {
        const analyticsPayload = {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'decorationPluginFactory',
            attributes: {
                errorType: 'handleDocChangedError',
                errorMessage: (0, $iybVv.ErrorUtils).extractErrorMessage(error)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        };
        dispatchAnalyticsEvent(analyticsPayload);
        return {
            ...pluginState,
            modalDecorationSet: (0, $etG8M.DecorationSet).empty
        };
    }
}
/**
 * This function is called inside the prosemirror plugin state apply method via the pluginFactory.
 *
 * The docChanged is called for every transaction where the selectionSet property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * The state transformation here is being used to remove the decorations that are added when the AI experience has inserted content.
 *
 * These are added inside docChanged above.
 *
 * In future the intention is to seperate this concerns into seperate plugin (currently the majority of this file is dealing
 * with decorations related to the presentation of a modal for the AI experience).
 */ function $58ecf901089c14db$var$onSelectionChanged(_tr, pluginState) {
    if (pluginState.modalDecorationSet === (0, $etG8M.DecorationSet).empty || pluginState.configItem) return pluginState;
    if ((0, $b8ZqO.hasGeneratedContentDecorations)(pluginState)) return {
        ...pluginState,
        modalDecorationSet: (0, $etG8M.DecorationSet).empty
    };
    return pluginState;
}
// if in the future we need to map other state, we can rename this to mappingInitialPositions
// and add another mapping function for the other state
// this is to avoid having a single function that does too many things
function $58ecf901089c14db$var$mapping(tr, pluginState) {
    if ((0, $VSDnB.fg)('platform_editor_ai_update_decorations_n_positions')) {
        const { initialPositions: initialPositions } = pluginState;
        if (!initialPositions) return pluginState;
        const mappedInitialPositions = [
            tr.mapping.map(initialPositions[0]),
            tr.mapping.map(initialPositions[1])
        ];
        if (mappedInitialPositions[0] === initialPositions[0] && mappedInitialPositions[1] === initialPositions[1]) return pluginState;
        return {
            ...pluginState,
            initialPositions: mappedInitialPositions
        };
    } else return pluginState;
}
const $58ecf901089c14db$export$de5e90bd767c5d82 = (dispatchAnalyticsEvent)=>(state)=>{
        return {
            /**
			 * Longer term it would be good to expand the decorationset to include
			 * the entire selection, as well as the 'valid inline position' to place
			 * an inline widget visualising start+end of valid selections
			 */ modalDecorationSet: (0, $etG8M.DecorationSet).empty,
            dispatchAnalyticsEvent: /**
			 * This takes a dispatchAnalyticsEvent in order to support firing analytics events in case
			 * mapping logic used in the onDocChanged passed to the pluginFactory throws an error.
			 */ dispatchAnalyticsEvent
        };
    };
const { createPluginState: $58ecf901089c14db$export$656c7661095efe2e, createCommand: $58ecf901089c14db$export$8d4021544bdece00, getPluginState: $58ecf901089c14db$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $kXXDl.aiExperienceDecorationPluginKey), (0, $7I8vO.reducer), {
    mapping: $58ecf901089c14db$var$mapping,
    onDocChanged: $58ecf901089c14db$var$onDocChanged,
    onSelectionChanged: $58ecf901089c14db$var$onSelectionChanged
});

});
parcelRegister("iybVv", function(module, exports) {

$parcel$export(module.exports, "ErrorUtils", () => $b32c24460e260b93$export$7edca8cfa9634e37);
class $b32c24460e260b93$export$7edca8cfa9634e37 {
    static{
        this.redactSensitiveInfo = (str)=>{
            const redacted = str// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
            return redacted;
        };
    }
    static extractErrorMessage(error) {
        if (error instanceof Error) return $b32c24460e260b93$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $b32c24460e260b93$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}

});

parcelRegister("kXXDl", function(module, exports) {

$parcel$export(module.exports, "aiExperienceDecorationPluginKey", () => $e9951b5e4e696425$export$32db9543f41e636c);

var $gZGBX = parcelRequire("gZGBX");
const $e9951b5e4e696425$export$32db9543f41e636c = new (0, $gZGBX.PluginKey)('aiExperienceDecoration');

});

parcelRegister("7I8vO", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $d9a915ae7423da62$export$1650419e431d3ba3);

var $etG8M = parcelRequire("etG8M");
function $d9a915ae7423da62$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case 'END_EXPERIENCE':
            // When the experience ends the plugin state needs to reset everything back to the initial plugin state
            return {
                modalDecorationSet: (0, $etG8M.DecorationSet).empty,
                dispatchAnalyticsEvent: state.dispatchAnalyticsEvent,
                initialPositions: undefined,
                ...action.data
            };
        case 'SHOW_MODAL':
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
}

});

parcelRegister("b8ZqO", function(module, exports) {

$parcel$export(module.exports, "hasGeneratedContentDecorations", () => $c39ac67c93fec15a$export$4306d8811b2d2e31);
const $c39ac67c93fec15a$export$4306d8811b2d2e31 = (state)=>state.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedInlineDecoration' || spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget').length > 0;

});







parcelRegister("kQzAD", function(module, exports) {

$parcel$export(module.exports, "changeToneToNeutralWithOptions", () => $81e01731ea3b1e1c$export$13defcd58be14c80);
$parcel$export(module.exports, "changeToneToProfessionalWithOptions", () => $81e01731ea3b1e1c$export$12bb87036588b312);
$parcel$export(module.exports, "changeToneToCasualWithOptions", () => $81e01731ea3b1e1c$export$124661226d751077);
$parcel$export(module.exports, "changeToneToEducationalWithOptions", () => $81e01731ea3b1e1c$export$bc06489e9b94a1b8);
$parcel$export(module.exports, "changeToneToEmpatheticWithOptions", () => $81e01731ea3b1e1c$export$6c0e9fb8d5e538d3);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $biGkW = parcelRequire("biGkW");

var $VSDnB = parcelRequire("VSDnB");

var $hGqnp = parcelRequire("hGqnp");

var $eMI2C = parcelRequire("eMI2C");

var $3GR4z = parcelRequire("3GR4z");

var $c2jCP = parcelRequire("c2jCP");

var $kBpOx = parcelRequire("kBpOx");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
function $81e01731ea3b1e1c$var$createChangeToneOption({ key: key, title: title, description: description, intentSchemaId: intentSchemaId, icon: icon, shortTitle: shortTitle }) {
    return {
        key: key,
        title: title,
        description: description,
        icon: icon,
        showInRefineDropdown: true,
        intentSchemaId: intentSchemaId,
        nestingConfig: {
            id: 'change-tone-to',
            parentTestId: 'change-tone-to',
            parentTitle: (0, $lspv7.aiConfigItemMessages).changeToneNestingParentTitlePostGA,
            shortTitle: shortTitle,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($biGkW))), {
                    label: "",
                    spacing: "spacious"
                })
        },
        actions: {
            empty: [
                (0, $70sMM.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $70sMM.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $70sMM.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $70sMM.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assistance_service_second')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    };
}
const $81e01731ea3b1e1c$export$6f5f338379adfef = $81e01731ea3b1e1c$var$createChangeToneOption({
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL,
    title: (0, $lspv7.aiConfigItemMessages).changeToneNeutralToneTitle,
    shortTitle: (0, $lspv7.aiConfigItemMessages).changeToneNeutralToneShortTitle,
    description: (0, $lspv7.aiConfigItemMessages).changeToneNeutralToneDescription,
    intentSchemaId: 'change_tone_neutral_intent_schema.json',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2jCP.ToneNeutralIcon), null)
});
const $81e01731ea3b1e1c$export$13defcd58be14c80 = {
    config: $81e01731ea3b1e1c$export$6f5f338379adfef,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $81e01731ea3b1e1c$export$9db9bd2fafdb3554 = $81e01731ea3b1e1c$var$createChangeToneOption({
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL,
    title: (0, $lspv7.aiConfigItemMessages).changeToneProfessionalToneTitle,
    shortTitle: (0, $lspv7.aiConfigItemMessages).changeToneProfessionalToneShortTitle,
    description: (0, $lspv7.aiConfigItemMessages).changeToneProfessionalToneDescription,
    intentSchemaId: 'change_tone_professional_intent_schema.json',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kBpOx.ToneProfessionalIcon), null)
});
const $81e01731ea3b1e1c$export$12bb87036588b312 = {
    config: $81e01731ea3b1e1c$export$9db9bd2fafdb3554,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $81e01731ea3b1e1c$export$86a519e0af50dd89 = $81e01731ea3b1e1c$var$createChangeToneOption({
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL,
    title: (0, $lspv7.aiConfigItemMessages).changeToneCasualToneTitle,
    shortTitle: (0, $lspv7.aiConfigItemMessages).changeToneCasualToneShortTitle,
    description: (0, $lspv7.aiConfigItemMessages).changeToneCasualToneDescription,
    intentSchemaId: 'change_tone_business_casual_intent_schema.json',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGqnp.ToneCasualIcon), null)
});
const $81e01731ea3b1e1c$export$124661226d751077 = {
    config: $81e01731ea3b1e1c$export$86a519e0af50dd89,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $81e01731ea3b1e1c$export$693b6bda4adcfa2a = $81e01731ea3b1e1c$var$createChangeToneOption({
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL,
    title: (0, $lspv7.aiConfigItemMessages).changeToneEducationalToneTitle,
    shortTitle: (0, $lspv7.aiConfigItemMessages).changeToneEducationalToneShortTitle,
    description: (0, $lspv7.aiConfigItemMessages).changeToneEducationalToneDescription,
    intentSchemaId: 'change_tone_educational_intent_schema.json',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMI2C.ToneEducationalIcon), null)
});
const $81e01731ea3b1e1c$export$bc06489e9b94a1b8 = {
    config: $81e01731ea3b1e1c$export$693b6bda4adcfa2a,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $81e01731ea3b1e1c$export$a20a30955e450d41 = $81e01731ea3b1e1c$var$createChangeToneOption({
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC,
    title: (0, $lspv7.aiConfigItemMessages).changeToneEmpatheticToneTitle,
    shortTitle: (0, $lspv7.aiConfigItemMessages).changeToneEmpatheticToneShortTitle,
    description: (0, $lspv7.aiConfigItemMessages).changeToneEmpatheticToneDescription,
    intentSchemaId: 'change_tone_empathetic_intent_schema.json',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3GR4z.ToneEmpatheticIcon), null)
});
const $81e01731ea3b1e1c$export$6c0e9fb8d5e538d3 = {
    config: $81e01731ea3b1e1c$export$a20a30955e450d41,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};

});
parcelRegister("biGkW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7122854feb0d3dc40d41eb59fb3bbcf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83a2375dd81757e8$var$_react = $83a2375dd81757e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83a2375dd81757e8$var$_baseNew = $83a2375dd81757e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83a2375dd81757e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Microphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: record sounds in Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83a2375dd81757e8$var$MicrophoneIcon = (props)=>/*#__PURE__*/ $83a2375dd81757e8$var$_react.default.createElement($83a2375dd81757e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A1.5 1.5 0 0 0 6.5 3v4a1.5 1.5 0 1 0 3 0V3A1.5 1.5 0 0 0 8 1.5M5 3a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zM3.5 7a4.5 4.5 0 0 0 9 0H14c0 3.06-2.29 5.585-5.25 5.954V14.5H12V16H4v-1.5h3.25v-1.546A6 6 0 0 1 2 7z" clip-rule="evenodd"/>`
    }, props));
$83a2375dd81757e8$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
var $83a2375dd81757e8$var$_default = module.exports.default = $83a2375dd81757e8$var$MicrophoneIcon;

});

parcelRegister("hGqnp", function(module, exports) {

$parcel$export(module.exports, "ToneCasualIcon", () => $295e7fb90ccf7a6f$export$8b4784439604ca83);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $bM08q = parcelRequire("bM08q");
const $295e7fb90ccf7a6f$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_11_3586)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21ZM12 19C13.3843 18.9996 14.7375 18.5889 15.8884 17.8196C17.0393 17.0504 17.9364 15.9572 18.4661 14.6782C18.9959 13.3993 19.1346 11.992 18.8648 10.6342C18.5949 9.27645 17.9286 8.02916 16.95 7.05C16.136 6.23608 15.1338 5.63546 14.0323 5.30135C12.9307 4.96723 11.7637 4.90994 10.6347 5.13453C9.50574 5.35913 8.44955 5.85868 7.55973 6.58895C6.6699 7.31922 5.9739 8.25766 5.53338 9.32115C5.09285 10.3846 4.92139 11.5404 5.03419 12.6859C5.14699 13.8315 5.54057 14.9316 6.18006 15.8888C6.81955 16.8459 7.68521 17.6306 8.70038 18.1733C9.71554 18.716 10.8489 18.9999 12 19ZM8.05 14.197C7.883 13.72 8.152 13.206 8.651 13.047C9.151 12.888 9.69 13.146 9.856 13.622C9.916 13.796 10.081 14.109 10.351 14.418C10.777 14.906 11.307 15.182 12 15.182C12.693 15.182 13.223 14.906 13.65 14.418C13.92 14.108 14.083 13.796 14.144 13.622C14.31 13.146 14.85 12.888 15.349 13.047C15.848 13.206 16.117 13.72 15.951 14.197C15.76 14.707 15.475 15.177 15.112 15.582C14.348 16.458 13.306 17 12 17C10.694 17 9.652 16.458 8.888 15.582C8.5247 15.1765 8.24017 14.7068 8.049 14.197H8.05ZM9.5 11C9.10218 11 8.72064 10.842 8.43934 10.5607C8.15804 10.2794 8 9.89782 8 9.5C8 9.10218 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10218 8 9.5 8C9.89782 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.10218 11 9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11ZM14.5 11C14.1022 11 13.7206 10.842 13.4393 10.5607C13.158 10.2794 13 9.89782 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5C16 9.89782 15.842 10.2794 15.5607 10.5607C15.2794 10.842 14.8978 11 14.5 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.503 8.957C5.503 8.55917 5.66103 8.17764 5.94234 7.89634C6.22364 7.61503 6.60517 7.457 7.003 7.457H9.826C10.0367 7.45714 10.2451 7.50168 10.4374 7.58772C10.6298 7.67377 10.8019 7.79938 10.9425 7.95637C11.083 8.11337 11.189 8.29822 11.2533 8.49888C11.3177 8.69955 11.339 8.91153 11.316 9.121L11.147 10.664C11.1066 11.0312 10.9321 11.3706 10.657 11.6171C10.3819 11.8637 10.0254 12 9.656 12H7.003C6.60517 12 6.22364 11.842 5.94234 11.5607C5.66103 11.2794 5.503 10.8978 5.503 10.5V8.957ZM12.678 9.013C12.6556 8.80375 12.6774 8.59213 12.7421 8.39188C12.8068 8.19163 12.9129 8.00723 13.0535 7.85066C13.1941 7.6941 13.3661 7.56888 13.5583 7.48314C13.7505 7.3974 13.9586 7.35306 14.169 7.353H16.979C17.3768 7.353 17.7584 7.51103 18.0397 7.79234C18.321 8.07364 18.479 8.45517 18.479 8.853V10.5C18.479 10.8978 18.321 11.2794 18.0397 11.5607C17.7584 11.842 17.3768 12 16.979 12H14.346C13.976 11.9999 13.619 11.863 13.3438 11.6156C13.0686 11.3683 12.8945 11.0279 12.855 10.66L12.678 9.013Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.5 8H13.5V9.5H10.5V8Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_11_3586"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $295e7fb90ccf7a6f$export$8b4784439604ca83 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bM08q))), {
        color: "currentColor",
        label: "",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $295e7fb90ccf7a6f$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("bM08q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3744a0898e07a67d450ee84c82a52a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8924482dc69ed05c$var$_react = $8924482dc69ed05c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8924482dc69ed05c$var$_baseNew = $8924482dc69ed05c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8924482dc69ed05c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8924482dc69ed05c$var$EmojiCasualIcon = (props)=>/*#__PURE__*/ $8924482dc69ed05c$var$_react.default.createElement($8924482dc69ed05c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.776 6.119.279 1.3A2 2 0 0 0 4.01 9h1.054a2.625 2.625 0 0 0 2.61-2.345L7.8 5.5h.4l.124 1.155A2.625 2.625 0 0 0 10.935 9h1.054a2 2 0 0 0 1.956-1.58l.279-1.301a6.5 6.5 0 1 1-12.448 0M13.124 4A6.49 6.49 0 0 0 8 1.5c-2.08 0-3.934.977-5.124 2.5zm-.302 1.5H9.71l.106.995A1.125 1.125 0 0 0 10.935 7.5h1.054a.5.5 0 0 0 .49-.395zm-6.532 0H3.178l.344 1.605a.5.5 0 0 0 .489.395h1.054c.575 0 1.058-.433 1.119-1.005zM.847 4.413A8 8 0 0 1 8 0a8 8 0 1 1 0 16A8 8 0 0 1 .847 4.413m5.238 6.12c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .69-.675l.031-.04.005-.006-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513m4.556-.721" clip-rule="evenodd"/>`
    }, props));
$8924482dc69ed05c$var$EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var $8924482dc69ed05c$var$_default = module.exports.default = $8924482dc69ed05c$var$EmojiCasualIcon;

});


parcelRegister("eMI2C", function(module, exports) {

$parcel$export(module.exports, "ToneEducationalIcon", () => $369fc29c2aabe338$export$61c3f03f8b900938);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $jGjYk = parcelRequire("jGjYk");
const $369fc29c2aabe338$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18.636 15H7C6.46957 15 5.96086 15.2107 5.58579 15.5858C5.21071 15.9609 5 16.4696 5 17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H19",
        stroke: "currentColor",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 15V5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V17",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 19C18.4696 19 17.9609 18.7893 17.5858 18.4142C17.2107 18.0391 17 17.5304 17 17C17 16.4696 17.2107 15.9609 17.5858 15.5858C17.9609 15.2107 18.4696 15 19 15",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }));
const $369fc29c2aabe338$export$61c3f03f8b900938 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGjYk))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $369fc29c2aabe338$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "none"
    });

});
parcelRegister("jGjYk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f078cf7ed8db2e1f9409b35a601c2b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5416e95455591c2$var$_react = $e5416e95455591c2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e5416e95455591c2$var$_baseNew = $e5416e95455591c2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e5416e95455591c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5416e95455591c2$var$GlassesIcon = (props)=>/*#__PURE__*/ $e5416e95455591c2$var$_react.default.createElement($e5416e95455591c2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.81 2.433-1.804.82c-.353.16-.599.491-.65.875l-.433 3.246A3.5 3.5 0 0 1 3.5 7c1.184 0 2.23.587 2.863 1.486A3 3 0 0 1 8 8c.604 0 1.167.179 1.637.486A3.5 3.5 0 0 1 12.5 7c.567 0 1.103.135 1.577.374l-.433-3.246a1.13 1.13 0 0 0-.65-.875l-1.804-.82.62-1.366 1.805.82A2.63 2.63 0 0 1 15.13 3.93l.76 5.697A3.505 3.505 0 0 1 12.5 14a3.5 3.5 0 0 1-3.453-4.074A1.5 1.5 0 0 0 8 9.5a1.5 1.5 0 0 0-1.047.426q.046.281.047.574a3.5 3.5 0 1 1-6.89-.873L.87 3.93a2.63 2.63 0 0 1 1.515-2.043l1.805-.82zM1.5 10.546a2 2 0 1 0 .083-.618zm12.917-.618.082.618a2 2 0 1 1-.082-.618" clip-rule="evenodd"/>`
    }, props));
$e5416e95455591c2$var$GlassesIcon.displayName = 'GlassesIcon';
var $e5416e95455591c2$var$_default = module.exports.default = $e5416e95455591c2$var$GlassesIcon;

});


parcelRegister("3GR4z", function(module, exports) {

$parcel$export(module.exports, "ToneEmpatheticIcon", () => $233a67b5532df331$export$e378d926184098e);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $6w2oK = parcelRequire("6w2oK");
const $233a67b5532df331$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.121 5.385L11.278 5.535L11.985 6.242L12.692 5.536C13.6168 4.61388 14.8658 4.09021 16.1717 4.07699C17.4777 4.06378 18.7369 4.56205 19.6803 5.46527C20.6236 6.36848 21.1761 7.60494 21.2195 8.91022C21.263 10.2155 20.7941 11.486 19.913 12.45L19.763 12.607L18.352 14.018L12.71 19.704C12.5359 19.8796 12.3028 19.9845 12.0559 19.9983C11.809 20.0122 11.5657 19.934 11.373 19.779L11.292 19.706L5.62 14.02L4.207 12.607C3.27965 11.6833 2.75151 10.4327 2.73597 9.12391C2.72044 7.81509 3.21875 6.55236 4.12391 5.60688C5.02907 4.6614 6.26889 4.10856 7.57714 4.06707C8.8854 4.02559 10.1578 4.49877 11.121 5.385ZM18.349 11.192C18.8975 10.6395 19.2097 9.89545 19.2197 9.11701C19.2297 8.33857 18.9367 7.58673 18.4026 7.02032C17.8686 6.45391 17.1352 6.1173 16.3575 6.0816C15.5798 6.0459 14.8187 6.31391 14.235 6.829L14.107 6.949L12.692 8.364C12.5592 8.49619 12.3921 8.58855 12.2095 8.63062C12.0269 8.67268 11.8362 8.66277 11.659 8.602C11.5158 8.55271 11.3858 8.47129 11.279 8.364L9.863 6.95C9.31051 6.40153 8.56645 6.08931 7.78801 6.0793C7.00958 6.0693 6.25773 6.36228 5.69132 6.89637C5.12492 7.43045 4.7883 8.1638 4.7526 8.94148C4.7169 9.71916 4.98491 10.4803 5.5 11.064L5.621 11.192L7.036 12.607L11.998 17.582L16.932 12.609L18.349 11.192Z"
    }));
const $233a67b5532df331$export$e378d926184098e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6w2oK))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $233a67b5532df331$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("6w2oK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1393486c01906de1ea3b52391dc4070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4be79778c543f14f$var$_react = $4be79778c543f14f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4be79778c543f14f$var$_baseNew = $4be79778c543f14f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $4be79778c543f14f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4be79778c543f14f$var$HeartIcon = (props)=>/*#__PURE__*/ $4be79778c543f14f$var$_react.default.createElement($4be79778c543f14f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.036 2.75a2.86 2.86 0 0 0-2.144.913 3.3 3.3 0 0 0-.656 1.064A3.9 3.9 0 0 0 2 6.112c0 .83.216 1.666.672 2.518.468.862 1.14 1.722 2.033 2.577q1.344 1.283 3.206 2.475a1 1 0 0 0 .09.047 1 1 0 0 0 .095-.047q1.862-1.193 3.199-2.474c.893-.856 1.563-1.716 2.026-2.578.46-.852.679-1.688.679-2.517 0-.522-.084-.98-.241-1.382l-.003-.007a3.2 3.2 0 0 0-.648-1.06l-.003-.003a2.8 2.8 0 0 0-.95-.672l-.002-.001a2.9 2.9 0 0 0-1.19-.237c-.525 0-.958.133-1.326.382l-.004.002a3 3 0 0 0-.975 1.085l-.66 1.205-.657-1.207a3 3 0 0 0-.971-1.085c-.367-.249-.802-.382-1.334-.382M3.248 1.612a4.4 4.4 0 0 1 1.788-.362c.801 0 1.535.207 2.174.64q.439.296.791.682.356-.388.797-.684c.638-.43 1.37-.638 2.166-.638.63 0 1.229.118 1.787.362q.836.361 1.454 1.028c.414.442.73.962.953 1.549a5.3 5.3 0 0 1 .342 1.923c0 1.105-.294 2.184-.858 3.23-.552 1.025-1.327 2.007-2.31 2.949Q10.87 13.69 8.9 14.948l-.006.004a2 2 0 0 1-.362.18A1.3 1.3 0 0 1 8 15.25c-.205 0-.389-.058-.532-.118a2.3 2.3 0 0 1-.355-.18l-.006-.004q-1.97-1.258-3.438-2.656l-.001-.001c-.983-.941-1.76-1.923-2.316-2.948l-.002-.004C.79 8.294.5 7.216.5 6.112c0-.683.108-1.326.335-1.921l.001-.004a4.8 4.8 0 0 1 .961-1.55 4.4 4.4 0 0 1 1.45-1.025" clip-rule="evenodd"/>`
    }, props));
$4be79778c543f14f$var$HeartIcon.displayName = 'HeartIcon';
var $4be79778c543f14f$var$_default = module.exports.default = $4be79778c543f14f$var$HeartIcon;

});


parcelRegister("c2jCP", function(module, exports) {

$parcel$export(module.exports, "ToneNeutralIcon", () => $7d0036c5a39b6a45$export$53c14326c671fdf0);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $dRzvr = parcelRequire("dRzvr");
const $7d0036c5a39b6a45$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z",
        stroke: "currentColor",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15 13.5H9C8.44772 13.5 8 13.9477 8 14.5C8 15.0523 8.44772 15.5 9 15.5H15C15.5523 15.5 16 15.0523 16 14.5C16 13.9477 15.5523 13.5 15 13.5Z",
        fill: "currentColor"
    }));
const $7d0036c5a39b6a45$export$53c14326c671fdf0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dRzvr))), {
        color: "currentColor",
        label: "",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $7d0036c5a39b6a45$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("dRzvr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccaa4ed6916e7a1d68590f7443a48f02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a17bc45df47a132b$var$_react = $a17bc45df47a132b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a17bc45df47a132b$var$_baseNew = $a17bc45df47a132b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a17bc45df47a132b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiNeutral".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a neutral tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a17bc45df47a132b$var$EmojiNeutralIcon = (props)=>/*#__PURE__*/ $a17bc45df47a132b$var$_react.default.createElement($a17bc45df47a132b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m2.25 3.25V11h-6.5V9.5z" clip-rule="evenodd"/>`
    }, props));
$a17bc45df47a132b$var$EmojiNeutralIcon.displayName = 'EmojiNeutralIcon';
var $a17bc45df47a132b$var$_default = module.exports.default = $a17bc45df47a132b$var$EmojiNeutralIcon;

});


parcelRegister("kBpOx", function(module, exports) {

$parcel$export(module.exports, "ToneProfessionalIcon", () => $e2df41365c09729e$export$d11b06b5c6e28f63);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $kaa7g = parcelRequire("kaa7g");
const $e2df41365c09729e$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 20C5.49542 20.0002 5.00943 19.8096 4.63945 19.4665C4.26947 19.1234 4.04284 18.6532 4.005 18.15L4 18V10C3.99984 9.49542 4.19041 9.00943 4.5335 8.63945C4.87659 8.26947 5.34684 8.04284 5.85 8.005L6 8H8V6C7.99984 5.49542 8.19041 5.00943 8.5335 4.63945C8.87659 4.26947 9.34685 4.04284 9.85 4.005L10 4H14C14.5046 3.99984 14.9906 4.19041 15.3605 4.5335C15.7305 4.87659 15.9572 5.34684 15.995 5.85L16 6V8H18C18.5044 8.00009 18.9901 8.19077 19.3599 8.53384C19.7297 8.8769 19.9562 9.34702 19.994 9.85L20 10V18C19.9999 18.5044 19.8092 18.9901 19.4662 19.3599C19.1231 19.7297 18.653 19.9562 18.15 19.994L18 20H6ZM8 10H6V18H7.999L8 10ZM14 10H10L9.999 18H14V10ZM18 10H16V18H18V10ZM14 6H10V8H14V6Z"
    }));
const $e2df41365c09729e$export$d11b06b5c6e28f63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kaa7g))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $e2df41365c09729e$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("kaa7g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eadc96b253df8830$var$_react = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eadc96b253df8830$var$_baseNew = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eadc96b253df8830$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eadc96b253df8830$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $eadc96b253df8830$var$_react.default.createElement($eadc96b253df8830$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$eadc96b253df8830$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $eadc96b253df8830$var$_default = module.exports.default = $eadc96b253df8830$var$BriefcaseIcon;

});



parcelRegister("9ecvG", function(module, exports) {

$parcel$export(module.exports, "createDraftReplyWithOptions", () => $4f9df036301ff7d9$export$a01b8dc4d6dfd2c6);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $VSDnB = parcelRequire("VSDnB");

var $1BQsE = parcelRequire("1BQsE");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $4f9df036301ff7d9$export$e9e009236e196c6e = (issueId)=>({
        key: (0, $dw3LE.CONFIG_ITEM_KEYS).SUGGEST_REPONSE,
        title: (0, $lspv7.aiConfigItemMessages).draftReplyTitle,
        description: (0, $lspv7.aiConfigItemMessages).draftReplyDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BQsE.BrainstormIcon), null),
        endpoint: `/gateway/api/firebolt/1/agent-response/issues/${issueId}/stream`,
        intentSchemaId: 'brainstorm_intent_schema.json',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $70sMM.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $70sMM.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        statusLozengeType: (0, $VSDnB.fg)('platform_remove_jsm_beta_tags') ? undefined : 'beta'
    });
const $4f9df036301ff7d9$export$a01b8dc4d6dfd2c6 = (issueId)=>({
        config: $4f9df036301ff7d9$export$e9e009236e196c6e(issueId),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });

});

parcelRegister("9LfEV", function(module, exports) {

$parcel$export(module.exports, "improveWriting", () => $d1b19e74b698b651$export$144a75c8acc1ab6b);
$parcel$export(module.exports, "improveWritingWithOptions", () => $d1b19e74b698b651$export$d332380ea195650);
$parcel$export(module.exports, "fixSpellingAndGrammarWithOptions", () => $d1b19e74b698b651$export$76de7c1ccbf13f30);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $VSDnB = parcelRequire("VSDnB");

var $1uL4o = parcelRequire("1uL4o");

var $4cwU4 = parcelRequire("4cwU4");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $d1b19e74b698b651$export$144a75c8acc1ab6b = {
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).IMPROVE_WRITING,
    title: (0, $lspv7.aiConfigItemMessages).improveWritingTitle,
    description: (0, $lspv7.aiConfigItemMessages).improveWritingDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4cwU4.ImproveWritingIcon), null),
    intentSchemaId: 'improve_quality_intent_schema.json',
    actions: {
        empty: [
            (0, $70sMM.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $70sMM.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assistance_service_second')) return 'assistance-service';
        return 'xp-gen-ai';
    },
    canToggleDiffPreview: true
};
const $d1b19e74b698b651$export$d332380ea195650 = {
    config: $d1b19e74b698b651$export$144a75c8acc1ab6b,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $d1b19e74b698b651$export$f6fbbd65001c33d0 = {
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR,
    title: (0, $lspv7.aiConfigItemMessages).fixSpellingGrammarTitle,
    description: (0, $lspv7.aiConfigItemMessages).fixSpellingGrammarDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1uL4o.FixSpellingIcon), null),
    intentSchemaId: 'grammar_spelling_intent_schema.json',
    actions: {
        empty: [
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assistance_service_second')) return 'assistance-service';
        return 'xp-gen-ai';
    }
};
const $d1b19e74b698b651$export$76de7c1ccbf13f30 = {
    config: $d1b19e74b698b651$export$f6fbbd65001c33d0,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};

});
parcelRegister("1uL4o", function(module, exports) {

$parcel$export(module.exports, "FixSpellingIcon", () => $d8f0b07fabe9bfe3$export$34a519f008c9006c);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $doTgN = parcelRequire("doTgN");
const $d8f0b07fabe9bfe3$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4C12.676 4 13.284 4.399 13.556 5.008L13.609 5.142L16.944 14.67C17.0283 14.9108 17.0173 15.1748 16.9134 15.4078C16.8094 15.6408 16.6203 15.8252 16.3848 15.9234C16.1493 16.0215 15.8851 16.0259 15.6465 15.9357C15.4078 15.8455 15.2127 15.6674 15.101 15.438L15.056 15.33L14.232 12.973L14.117 12.993L14 13H10C9.92255 12.9999 9.84536 12.9909 9.77 12.973L8.944 15.33C8.86313 15.5614 8.70011 15.755 8.4859 15.8741C8.27169 15.9932 8.0212 16.0294 7.782 15.976L7.67 15.944C7.43863 15.8631 7.24502 15.7001 7.12593 15.4859C7.00684 15.2717 6.97057 15.0212 7.024 14.782L7.056 14.67L10.391 5.142C10.5078 4.80818 10.7255 4.51893 11.0139 4.31432C11.3024 4.10971 11.6473 3.99987 12.001 4H12ZM12 6.598L10.46 11H13.542L12.002 6.598H12Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 17L16 19L20 15",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $d8f0b07fabe9bfe3$export$34a519f008c9006c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($doTgN))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $d8f0b07fabe9bfe3$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("doTgN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::312d12f517ad523b2b40c676e4ea46df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c1863b37b05edde$var$_react = $9c1863b37b05edde$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c1863b37b05edde$var$_baseNew = $9c1863b37b05edde$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c1863b37b05edde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSpellcheck".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spellchecking.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c1863b37b05edde$var$TextSpellcheckIcon = (props)=>/*#__PURE__*/ $9c1863b37b05edde$var$_react.default.createElement($9c1863b37b05edde$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.67.494A.75.75 0 0 1 5.375 0h.75a.75.75 0 0 1 .705.494l3.625 10a.8.8 0 0 1 .045.256V11H9.06l-.015.006L9.043 11H9v-.118L7.955 8h-4.41L2.5 10.882V11h-.043l-.002.006L2.44 11H1v-.25a.8.8 0 0 1 .045-.256zM4.088 6.5h3.324L5.75 1.916z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m13.928 9.265 1.144.97-4.667 5.5a.75.75 0 0 1-1.144 0l-2.333-2.75 1.144-.97 1.761 2.076z" clip-rule="evenodd"/>`
    }, props));
$9c1863b37b05edde$var$TextSpellcheckIcon.displayName = 'TextSpellcheckIcon';
var $9c1863b37b05edde$var$_default = module.exports.default = $9c1863b37b05edde$var$TextSpellcheckIcon;

});


parcelRegister("4cwU4", function(module, exports) {

$parcel$export(module.exports, "ImproveWritingIcon", () => $11c9c3a80ea3652e$export$1be00499caf729a1);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $9Ufjg = parcelRequire("9Ufjg");
const $11c9c3a80ea3652e$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.45366 7.76225L6.37618 5.68477C6.16881 5.4774 5.8326 5.4774 5.62524 5.68477L5.62453 5.68548C5.41716 5.89284 5.41716 6.22906 5.62453 6.43642L7.70201 8.5139C7.90938 8.72127 8.24559 8.72127 8.45296 8.5139L8.45366 8.5132C8.66103 8.30583 8.66103 7.96962 8.45366 7.76225Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17.6911 5.69892L15.5853 7.80468C15.3858 8.00424 15.3858 8.32779 15.5853 8.52735C15.7849 8.7269 16.1084 8.7269 16.308 8.52735L18.4138 6.42158C18.6133 6.22203 18.6133 5.89848 18.4138 5.69892C18.2142 5.49936 17.8907 5.49936 17.6911 5.69892Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.64164 15.6144L5.58538 17.6706C5.37215 17.8838 5.37215 18.2296 5.58538 18.4428L5.58608 18.4435C5.79931 18.6567 6.14502 18.6567 6.35824 18.4435L8.41451 16.3872C8.62774 16.174 8.62774 15.8283 8.41451 15.6151L8.4138 15.6144C8.20058 15.4011 7.85487 15.4011 7.64164 15.6144Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.5 11.5H3.5C3.22386 11.5 3 11.7239 3 12C3 12.2761 3.22386 12.5 3.5 12.5H6.5C6.77614 12.5 7 12.2761 7 12C7 11.7239 6.77614 11.5 6.5 11.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20.5 11.5H17.5C17.2239 11.5 17 11.7239 17 12C17 12.2761 17.2239 12.5 17.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.5 6.5V3.5C12.5 3.22386 12.2761 3 12 3C11.7239 3 11.5 3.22386 11.5 3.5V6.5C11.5 6.77614 11.7239 7 12 7C12.2761 7 12.5 6.77614 12.5 6.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.5 20.5V17.5C12.5 17.2239 12.2761 17 12 17C11.7239 17 11.5 17.2239 11.5 17.5V20.5C11.5 20.7761 11.7239 21 12 21C12.2761 21 12.5 20.7761 12.5 20.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.62 12.913L11.854 11.146C11.7602 11.0521 11.633 10.9993 11.5004 10.9992C11.3677 10.9991 11.2404 11.0517 11.1465 11.1455C11.0526 11.2392 10.9998 11.3665 10.9997 11.4991C10.9996 11.6318 11.0522 11.7591 11.146 11.853L12.913 13.62L13.62 12.913ZM12.56 10.439C12.277 10.1659 11.898 10.0149 11.5047 10.0185C11.1114 10.0221 10.7353 10.18 10.4573 10.4582C10.1793 10.7365 10.0217 11.1128 10.0185 11.5061C10.0153 11.8994 10.1666 12.2782 10.44 12.561L17.51 19.631C17.6483 19.7743 17.8138 19.8887 17.9967 19.9674C18.1797 20.0461 18.3765 20.0875 18.5757 20.0894C18.7748 20.0912 18.9724 20.0533 19.1568 19.978C19.3411 19.9027 19.5087 19.7914 19.6496 19.6506C19.7905 19.5098 19.9019 19.3424 19.9774 19.1581C20.053 18.9738 20.091 18.7763 20.0894 18.5771C20.0877 18.3779 20.0464 18.1811 19.9679 17.998C19.8894 17.815 19.7752 17.6494 19.632 17.511L12.56 10.439Z"
    }));
const $11c9c3a80ea3652e$export$1be00499caf729a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ufjg))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $11c9c3a80ea3652e$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("9Ufjg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e674ae8e4bcaa3ce828d44ac8144dec4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7365382f8b17701f$var$_react = $7365382f8b17701f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7365382f8b17701f$var$_baseNew = $7365382f8b17701f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7365382f8b17701f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7365382f8b17701f$var$MagicWandIcon = (props)=>/*#__PURE__*/ $7365382f8b17701f$var$_react.default.createElement($7365382f8b17701f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10 2V0h1.5v2zM7.922 3.482 6.507 2.068l1.061-1.06 1.414 1.414zm7.07-1.414-1.414 1.414-1.06-1.06 1.414-1.415zM8.779 4.162a1.375 1.375 0 0 1 1.944 0l1.116 1.116a1.375 1.375 0 0 1 0 1.944l-8.116 8.116a1.375 1.375 0 0 1-1.944 0L.662 14.222a1.375 1.375 0 0 1 0-1.944zM9.75 5.31 8.31 6.75l.94.94 1.44-1.44zM8.19 8.75l-.94-.94-5.44 5.44.94.94zM16 6h-2V4.5h2zm-2.068 3.493-1.414-1.415 1.06-1.06 1.415 1.414z" clip-rule="evenodd"/>`
    }, props));
$7365382f8b17701f$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $7365382f8b17701f$var$_default = module.exports.default = $7365382f8b17701f$var$MagicWandIcon;

});



parcelRegister("giLDs", function(module, exports) {

$parcel$export(module.exports, "freeGenerate", () => $096c6847e1ed3676$export$647e613dda1ecf45);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $jps85 = parcelRequire("jps85");

var $VSDnB = parcelRequire("VSDnB");

var $1uyji = parcelRequire("1uyji");

var $kjtjo = parcelRequire("kjtjo");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $096c6847e1ed3676$export$647e613dda1ecf45 = {
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).FREE_GENERATE,
    title: (0, $kjtjo.default).aiButtonTitle,
    description: (0, $kjtjo.default).aiUniversalLongCallToAction,
    promptHint: (0, $lspv7.aiConfigItemMessages).freeGeneratePromptHint,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            label: "",
            spacing: "spacious"
        }),
    doNotHighlightDocWhenSelectionIsEmpty: true,
    agentId: 'editor_agent',
    canTogglePageKnowledge: true,
    quickInsertPriority: Number.NEGATIVE_INFINITY,
    intentSchemaId: ({ latestPromptResponse: latestPromptResponse })=>{
        return latestPromptResponse ? 'custom_with_interrogation_intent_schema.json' : 'custom_free_generate_intent_schema.json';
    },
    actions: {
        empty: [
            (0, $70sMM.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $70sMM.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: (isInterrogate)=>{
        if (isInterrogate && (0, $VSDnB.fg)('platform_editor_ai_interrogate_with_convo_ai')) return 'assistance-service';
        if (!isInterrogate && (0, $1uyji.checkAssistanceServiceFreeGenerateFg)()) return 'assistance-service';
        // If we're not interrogating, we use xp-gen-ai
        return 'xp-gen-ai';
    }
};

});
parcelRegister("1uyji", function(module, exports) {

$parcel$export(module.exports, "checkAssistanceServiceFreeGenerateFg", () => $c17c4d81be2be799$export$8eb46457ce8f0f94);

var $VSDnB = parcelRequire("VSDnB");
const $c17c4d81be2be799$export$8eb46457ce8f0f94 = ()=>{
    if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assist_srv_jira_fr_gen')) return true;
    return false;
};

});

parcelRegister("kjtjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $98476217fc724136$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98476217fc724136$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    aiUniversalLongCallToAction: {
        id: 'fabric.editor.ai.shared.aiUniversalLongCallToAction',
        defaultMessage: 'Let Atlassian Intelligence assist your writing',
        description: 'Call-to-action text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
    },
    aiUniversalShortCallToAction: {
        id: 'fabric.editor.ai.shared.aiUniversalShortCallToAction',
        defaultMessage: 'Write',
        description: 'Call-to-action text for activating the AI, used universally across UI elements like buttons and menu entries'
    },
    aiProactiveButtonLabel: {
        id: 'fabric.editor.ai.shared.aiProactiveButtonLabel',
        defaultMessage: 'Suggestions',
        description: 'Call-to-action text for activating Proactive AI for inline AI suggestions.'
    },
    aiProactiveDescriptor: {
        id: 'fabric.editor.ai.shared.aiProactiveDescriptor.non-final',
        defaultMessage: '{count, plural, =0 {Open suggested edits} =1 {New suggested edit} =2 {Two new suggested edits} =3 {Three new suggested edits} =4 {Four new suggested edits} other {More than four new suggested edits}}',
        description: 'Tooltip text for Proactive AI button to activate the inline writing suggestions'
    },
    aiProactiveCloseDescriptor: {
        id: 'fabric.editor.ai.shared.aiProactiveDescriptorClose.non-final',
        defaultMessage: 'Close suggested edits',
        description: 'Tooltip text for Proactive AI button to close the inline writing suggestions'
    },
    aiUniversalDescriptor: {
        id: 'fabric.editor.ai.shared.aiUniversalDescriptor',
        defaultMessage: 'Writing assistant',
        description: 'Descriptive text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
    },
    aiButtonTitle: {
        id: 'fabric.editor.ai.shared.generateContent.aiButtonTitle',
        defaultMessage: 'AI (Atlassian Intelligence)',
        description: 'Title for Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    betaLabel: {
        id: 'fabric.editor.ai.shared.betaLabel',
        defaultMessage: 'Beta',
        description: 'The label describing the beta status of an Atlassian Intelligence prompt'
    }
});

});


parcelRegister("d8wQM", function(module, exports) {

$parcel$export(module.exports, "createImproveDescriptionWithOptions", () => $acbabfec77521c8e$export$b8d167b10029e62f);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $VSDnB = parcelRequire("VSDnB");

var $j4mKR = parcelRequire("j4mKR");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $acbabfec77521c8e$export$74b0275d64d18c50 = (options)=>({
        key: (0, $dw3LE.CONFIG_ITEM_KEYS).ADD_STRUCTURE,
        title: (0, $lspv7.aiConfigItemMessages).improveDescription,
        description: (0, $lspv7.aiConfigItemMessages).reformatWithTemplateDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j4mKR.IssueReformatterIcon), null),
        experienceId: 'issue-reformatter',
        intentSchemaId: 'issue_reformatter_intent_schema.json',
        alwaysNeedDoc: true,
        ...(0, $VSDnB.fg)('platform_gravityai-1853_issue_reformatter_ga') ? {} : {
            statusLozengeType: 'beta'
        },
        getRequestPayload: ({ locale: locale, doc: doc })=>{
            return {
                recipient_agent_named_id: 'jira_issue_reformatter_agent',
                agent_input_context: {
                    locale: locale,
                    issue_description: doc,
                    ...options.getAdditionalProps?.()
                }
            };
        },
        ...(0, $VSDnB.fg)('migrate_editor_issue_reformatter_to_convo-ai') ? {
            endpoint: '/gateway/api/assist/api/ai/v2/ai-feature/jira/issue/reformatter',
            getRequestPayload: ({ locale: locale, doc: doc })=>({
                    ai_feature_input: {
                        locale: locale,
                        issue_description: doc,
                        ...options.getAdditionalProps?.()
                    }
                })
        } : {},
        actions: {
            empty: [
                (0, $70sMM.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $70sMM.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $70sMM.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $70sMM.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>'assistance-service'
    });
const $acbabfec77521c8e$export$b8d167b10029e62f = (options)=>({
        config: $acbabfec77521c8e$export$74b0275d64d18c50(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });

});
parcelRegister("j4mKR", function(module, exports) {

$parcel$export(module.exports, "IssueReformatterIcon", () => $fcd6c02049188599$export$80f4f0d1d6bfe69e);

var $5uXOq = parcelRequire("5uXOq");
const $fcd6c02049188599$export$80f4f0d1d6bfe69e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15 6H9C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15 9H9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 4V20H17V4H7ZM5 3.99C5 2.892 5.897 2 7.006 2H16.994C18.102 2 19 2.898 19 3.99V20.01C19 21.109 18.103 22 16.994 22H7.006C6.4765 22.0008 5.96822 21.7919 5.59231 21.419C5.21639 21.0461 5.00344 20.5395 5 20.01V3.99Z"
    }));
};

});


parcelRegister("9KiMc", function(module, exports) {

$parcel$export(module.exports, "makeShorterWithOptions", () => $d6e6366f48360c5a$export$cf8706c71bd8ab7d);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");

var $VSDnB = parcelRequire("VSDnB");

var $2Hi0O = parcelRequire("2Hi0O");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $d6e6366f48360c5a$export$1792ed3292533f02 = {
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).MAKE_SHORTER,
    title: (0, $lspv7.aiConfigItemMessages).makeShorterTitle,
    description: (0, $lspv7.aiConfigItemMessages).makeShorterDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Hi0O.MakeShorterIcon), null),
    showInRefineDropdown: true,
    intentSchemaId: 'shorten_intent_schema.json',
    actions: {
        empty: [
            (0, $70sMM.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $70sMM.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assistance_service_second')) return 'assistance-service';
        return 'xp-gen-ai';
    }
};
const $d6e6366f48360c5a$export$cf8706c71bd8ab7d = {
    config: $d6e6366f48360c5a$export$1792ed3292533f02,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};

});
parcelRegister("2Hi0O", function(module, exports) {

$parcel$export(module.exports, "MakeShorterIcon", () => $d04751df71efbb01$export$bd44f97e799f79a6);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $7y8WE = parcelRequire("7y8WE");
const $d04751df71efbb01$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17 9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9Z"
    }));
const $d04751df71efbb01$export$bd44f97e799f79a6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7y8WE))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $d04751df71efbb01$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("7y8WE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05be2231dbaf9aa0d7dffd1684187c72>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57f2a5a60cdc1d20$var$_react = $57f2a5a60cdc1d20$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $57f2a5a60cdc1d20$var$_baseNew = $57f2a5a60cdc1d20$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $57f2a5a60cdc1d20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextShorten".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for shortening text content with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57f2a5a60cdc1d20$var$TextShortenIcon = (props)=>/*#__PURE__*/ $57f2a5a60cdc1d20$var$_react.default.createElement($57f2a5a60cdc1d20$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zM8 11H1V9.5h7z" clip-rule="evenodd"/>`
    }, props));
$57f2a5a60cdc1d20$var$TextShortenIcon.displayName = 'TextShortenIcon';
var $57f2a5a60cdc1d20$var$_default = module.exports.default = $57f2a5a60cdc1d20$var$TextShortenIcon;

});



parcelRegister("hLKbT", function(module, exports) {

$parcel$export(module.exports, "summarizeWritingWithOptions", () => $4e7a5a7ca667037c$export$a0bf62522ec7a604);

var $5uXOq = parcelRequire("5uXOq");

var $lspv7 = parcelRequire("lspv7");
var $9ao8a = parcelRequire("9ao8a");

var $VSDnB = parcelRequire("VSDnB");

var $4W1JB = parcelRequire("4W1JB");

var $70sMM = parcelRequire("70sMM");

var $dw3LE = parcelRequire("dw3LE");
const $4e7a5a7ca667037c$export$5dae1cd728cdd936 = {
    key: (0, $dw3LE.CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
    title: (0, $lspv7.aiConfigItemMessages).summarizeWritingtitle,
    description: (0, $lspv7.aiConfigItemMessages).summarizeWritingDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4W1JB.SummarizeIcon), null),
    showInRefineDropdown: true,
    intentSchemaId: 'summarize_intent_schema.json',
    actions: {
        empty: [
            (0, $70sMM.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $70sMM.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $70sMM.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        if ((0, $VSDnB.fg)('platform_editor_ai_assistance_service') || (0, $VSDnB.fg)('platform_editor_ai_assistance_service_second')) return 'assistance-service';
        return 'xp-gen-ai';
    }
};
const $4e7a5a7ca667037c$export$a0bf62522ec7a604 = {
    config: $4e7a5a7ca667037c$export$5dae1cd728cdd936,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $4e7a5a7ca667037c$export$afe1e087747ab29 = {
    config: {
        ...$4e7a5a7ca667037c$export$5dae1cd728cdd936,
        description: (0, $9ao8a.aiMessages).atlasSummarizePageConfigItemDescription
    },
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: false
        }
    }
};

});
parcelRegister("4W1JB", function(module, exports) {

$parcel$export(module.exports, "SummarizeIcon", () => $423badf7757d325a$export$71f01d1a809741f7);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $e85rp = parcelRequire("e85rp");
const $423badf7757d325a$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 16.5H6C5.44772 16.5 5 16.9477 5 17.5C5 18.0523 5.44772 18.5 6 18.5H18C18.5523 18.5 19 18.0523 19 17.5C19 16.9477 18.5523 16.5 18 16.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 6.5H14C13.4477 6.5 13 6.94772 13 7.5C13 8.05228 13.4477 8.5 14 8.5H18C18.5523 8.5 19 8.05228 19 7.5C19 6.94772 18.5523 6.5 18 6.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 11.5H6C5.44772 11.5 5 11.9477 5 12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5C19 11.9477 18.5523 11.5 18 11.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.375 7.661C5.375 8.14424 5.76675 8.536 6.25 8.536C6.73325 8.536 7.125 8.14424 7.125 7.661C7.125 7.17775 6.73325 6.786 6.25 6.786C5.76675 6.786 5.375 7.17775 5.375 7.661Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "1.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.375 7.661C9.375 8.14424 9.76675 8.536 10.25 8.536C10.7332 8.536 11.125 8.14424 11.125 7.661C11.125 7.17775 10.7332 6.786 10.25 6.786C9.76675 6.786 9.375 7.17775 9.375 7.661Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "1.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.07 7.989C4.682 6.493 5.481 5.164 6.77 4.955M9.07 7.989C8.682 6.493 9.481 5.164 10.77 4.955",
        fill: "currentColor",
        strokeLinecap: "round"
    }));
const $423badf7757d325a$export$71f01d1a809741f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e85rp))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                glyph: $423badf7757d325a$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("e85rp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a03db518592dd1f81c21f51aa111feb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4960885fb311613$var$_react = $a4960885fb311613$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a4960885fb311613$var$_baseNew = $a4960885fb311613$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a4960885fb311613$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Summarize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4960885fb311613$var$SummarizeIcon = (props)=>/*#__PURE__*/ $a4960885fb311613$var$_react.default.createElement($a4960885fb311613$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$a4960885fb311613$var$SummarizeIcon.displayName = 'SummarizeIcon';
var $a4960885fb311613$var$_default = module.exports.default = $a4960885fb311613$var$SummarizeIcon;

});



parcelRegister("dv0ZW", function(module, exports) {

$parcel$export(module.exports, "translationConfigItemWithOptions", () => $7052a0168dd956c9$export$f79e42233d7b78a9);

var $5uXOq = parcelRequire("5uXOq");

var $3XQ9L = parcelRequire("3XQ9L");

var $c1CQi = parcelRequire("c1CQi");

var $70sMM = parcelRequire("70sMM");

var $8j6jh = parcelRequire("8j6jh");
const $7052a0168dd956c9$var$supportedTranslationLanguages = (0, $8j6jh.getSortedSupportedTranslationLanguages)();
const $7052a0168dd956c9$var$translationConfigItemsArr = $7052a0168dd956c9$var$supportedTranslationLanguages.map((language)=>{
    const lang = (0, $3XQ9L.aiLanguageMessages)[language];
    if (!lang) return false;
    const configItem = {
        key: `Translate to ${language}`,
        title: (0, $3XQ9L.aiLanguageMessages)[`${language}Title`],
        description: (0, $3XQ9L.aiLanguageMessages)[`${language}Description`],
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1CQi.TranslateIcon), null),
        showInRefineDropdown: (0, $8j6jh.isRefinementSupport)(language),
        nestingConfig: {
            id: 'translate-to',
            parentTestId: 'translate-to',
            parentTitle: (0, $3XQ9L.aiLanguageMessages).nestingParentTitlePostGA,
            shortTitle: lang,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1CQi.TranslateIcon), null)
        },
        intentSchemaId: 'translate_intent_schema.json',
        lang: lang.defaultMessage,
        actions: {
            empty: [
                (0, $70sMM.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $70sMM.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $70sMM.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $70sMM.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    };
    return [
        language,
        configItem
    ];
}).filter(Boolean);
const $7052a0168dd956c9$export$92a3f158c5aa8500 = Object.fromEntries($7052a0168dd956c9$var$translationConfigItemsArr.filter(Boolean));
const $7052a0168dd956c9$export$c9f99cf066285ff1 = Object.values($7052a0168dd956c9$export$92a3f158c5aa8500);
const $7052a0168dd956c9$export$f79e42233d7b78a9 = $7052a0168dd956c9$export$c9f99cf066285ff1.map((config)=>({
        config: config,
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    }));
const $7052a0168dd956c9$export$58be4f46859bb368 = $7052a0168dd956c9$export$c9f99cf066285ff1.map((config)=>({
        config: config,
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    }));

});
parcelRegister("3XQ9L", function(module, exports) {

$parcel$export(module.exports, "aiLanguageMessages", () => $6c128225d95f01de$export$b71056f6af7927e9);
// eslint-disable-next-line no-restricted-imports

var $7VHMR = parcelRequire("7VHMR");
const $6c128225d95f01de$export$b71056f6af7927e9 = (0, $7VHMR.defineMessages)({
    // Language Messages
    nestingParentTitle: {
        id: 'fabric.editor.ai.config.item.translate.nestingParentTitle.ga',
        defaultMessage: 'Translate',
        description: 'The nested title which shows in the generative-ai-modal'
    },
    nestingParentTitlePostGA: {
        id: 'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA',
        defaultMessage: 'Translate to ...',
        description: 'The nested title which shows in the generative-ai-modal'
    },
    chineseSimplified: {
        id: 'fabric.editor.ai.config.item.translate.chineseSimplified',
        defaultMessage: 'Chinese (Simplified)',
        description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Simplified)'
    },
    chineseTraditional: {
        id: 'fabric.editor.ai.config.item.translate.chineseTraditional',
        defaultMessage: 'Chinese (Traditional)',
        description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Traditional)'
    },
    czech: {
        id: 'fabric.editor.ai.config.item.translate.czech',
        defaultMessage: 'Czech',
        description: 'Language string referenced in UIs involving the translation AI prompt for Czech'
    },
    danish: {
        id: 'fabric.editor.ai.config.item.translate.danish',
        defaultMessage: 'Danish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Danish'
    },
    dutch: {
        id: 'fabric.editor.ai.config.item.translate.dutch',
        defaultMessage: 'Dutch',
        description: 'Language string referenced in UIs involving the translation AI prompt for Dutch'
    },
    english: {
        id: 'fabric.editor.ai.config.item.translate.english',
        defaultMessage: 'English',
        description: 'Language string referenced in UIs involving the translation AI prompt for English'
    },
    finnish: {
        id: 'fabric.editor.ai.config.item.translate.finnish',
        defaultMessage: 'Finnish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Finnish'
    },
    french: {
        id: 'fabric.editor.ai.config.item.translate.french',
        defaultMessage: 'French',
        description: 'Language string referenced in UIs involving the translation AI prompt for French'
    },
    german: {
        id: 'fabric.editor.ai.config.item.translate.german',
        defaultMessage: 'German',
        description: 'Language string referenced in UIs involving the translation AI prompt for German'
    },
    hungarian: {
        id: 'fabric.editor.ai.config.item.translate.hungarian',
        defaultMessage: 'Hungarian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Hungarian'
    },
    italian: {
        id: 'fabric.editor.ai.config.item.translate.italian',
        defaultMessage: 'Italian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Italian'
    },
    japanese: {
        id: 'fabric.editor.ai.config.item.translate.japanese',
        defaultMessage: 'Japanese',
        description: 'Language string referenced in UIs involving the translation AI prompt for Japanese'
    },
    korean: {
        id: 'fabric.editor.ai.config.item.translate.korean',
        defaultMessage: 'Korean',
        description: 'Language string referenced in UIs involving the translation AI prompt for Korean'
    },
    norwegian: {
        id: 'fabric.editor.ai.config.item.translate.norwegian',
        defaultMessage: 'Norwegian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Norwegian'
    },
    polish: {
        id: 'fabric.editor.ai.config.item.translate.polish',
        defaultMessage: 'Polish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Polish'
    },
    portugueseBrazilian: {
        id: 'fabric.editor.ai.config.item.translate.portugueseBrazilian',
        defaultMessage: 'Portuguese (Brazilian)',
        description: 'Language string referenced in UIs involving the translation AI prompt for Portuguese (Brazilian)'
    },
    russian: {
        id: 'fabric.editor.ai.config.item.translate.russian',
        defaultMessage: 'Russian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Russian'
    },
    spanish: {
        id: 'fabric.editor.ai.config.item.translate.spanish',
        defaultMessage: 'Spanish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Spanish'
    },
    swedish: {
        id: 'fabric.editor.ai.config.item.translate.swedish',
        defaultMessage: 'Swedish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Swedish'
    },
    turkish: {
        id: 'fabric.editor.ai.config.item.translate.turkish',
        defaultMessage: 'Turkish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Turkish'
    },
    thai: {
        id: 'fabric.editor.ai.config.item.translate.thai',
        defaultMessage: 'Thai',
        description: 'Language string referenced in UIs involving the translation AI prompt for Thai'
    },
    ukrainian: {
        id: 'fabric.editor.ai.config.item.translate.ukrainian',
        defaultMessage: 'Ukrainian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Ukrainian'
    },
    vietnamese: {
        id: 'fabric.editor.ai.config.item.translate.vietnamese',
        defaultMessage: 'Vietnamese',
        description: 'Language string referenced in UIs involving the translation AI prompt for Vietnamese'
    },
    // Translate to messages
    chineseSimplifiedTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.title',
        defaultMessage: 'Translate to Chinese (Simplified)',
        description: 'Title of a prompt that translates the selected content into Chinese (Simplified)'
    },
    chineseSimplifiedDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.description',
        defaultMessage: "Translates the text you're working on to Chinese (Simplified)",
        description: 'Description for prompt that translates selected content into Chinese (Simplified)'
    },
    chineseTraditionalTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.title',
        defaultMessage: 'Translate to Chinese (Traditional)',
        description: 'Title of a prompt that translates the selected content into Chinese (Traditional)'
    },
    chineseTraditionalDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.description',
        defaultMessage: "Translates the text you're working on to Chinese (Traditional)",
        description: 'Description for prompt that translates selected content into Chinese (Traditional)'
    },
    czechTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.czech.title',
        defaultMessage: 'Translate to Czech',
        description: 'Title of a prompt that translates the selected content into Czech'
    },
    czechDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.czech.description',
        defaultMessage: "Translates the text you're working on to Czech",
        description: 'Description for prompt that translates selected content into Czech'
    },
    danishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.danish.title',
        defaultMessage: 'Translate to Danish',
        description: 'Title of a prompt that translates the selected content into Danish'
    },
    danishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.danish.description',
        defaultMessage: "Translates the text you're working on to Danish",
        description: 'Description for prompt that translates selected content into Danish'
    },
    dutchTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.dutch.title',
        defaultMessage: 'Translate to Dutch',
        description: 'Title of a prompt that translates the selected content into Dutch'
    },
    dutchDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.dutch.description',
        defaultMessage: "Translates the text you're working on to Dutch",
        description: 'Description for prompt that translates selected content into Dutch'
    },
    englishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.english.title',
        defaultMessage: 'Translate to English',
        description: 'Title of a prompt that translates the selected content into English'
    },
    englishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.english.description',
        defaultMessage: "Translates the text you're working on to English",
        description: 'Description for prompt that translates selected content into English'
    },
    finnishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.finnish.title',
        defaultMessage: 'Translate to Finnish',
        description: 'Title of a prompt that translates the selected content into Finnish'
    },
    finnishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.finnish.description',
        defaultMessage: "Translates the text you're working on to Finnish",
        description: 'Description for prompt that translates selected content into Finnish'
    },
    frenchTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.french.title',
        defaultMessage: 'Translate to French',
        description: 'Title of a prompt that translates the selected content into French'
    },
    frenchDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.french.description',
        defaultMessage: "Translates the text you're working on to French",
        description: 'Description for prompt that translates selected content into French'
    },
    germanTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.german.title',
        defaultMessage: 'Translate to German',
        description: 'Title of a prompt that translates the selected content into German'
    },
    germanDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.german.description',
        defaultMessage: "Translates the text you're working on to German",
        description: 'Description for prompt that translates selected content into German'
    },
    hungarianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.hungarian.title',
        defaultMessage: 'Translate to Hungarian',
        description: 'Title of a prompt that translates the selected content into Hungarian'
    },
    hungarianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.hungarian.description',
        defaultMessage: "Translates the text you're working on to Hungarian",
        description: 'Description for prompt that translates selected content into Hungarian'
    },
    italianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.italian.title',
        defaultMessage: 'Translate to Italian',
        description: 'Title of a prompt that translates the selected content into Italian'
    },
    italianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.italian.description',
        defaultMessage: "Translates the text you're working on to Italian",
        description: 'Description for prompt that translates selected content into Italian'
    },
    japaneseTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.japanese.title',
        defaultMessage: 'Translate to Japanese',
        description: 'Title of a prompt that translates the selected content into Japanese'
    },
    japaneseDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.japanese.description',
        defaultMessage: "Translates the text you're working on to Japanese",
        description: 'Description for prompt that translates selected content into Japanese'
    },
    koreanTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.korean.title',
        defaultMessage: 'Translate to Korean',
        description: 'Title of a prompt that translates the selected content into Korean'
    },
    koreanDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.korean.description',
        defaultMessage: "Translates the text you're working on to Korean",
        description: 'Description for prompt that translates selected content into Korean'
    },
    norwegianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.norwegian.title',
        defaultMessage: 'Translate to Norwegian',
        description: 'Title of a prompt that translates the selected content into Norwegian'
    },
    norwegianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.norwegian.description',
        defaultMessage: "Translates the text you're working on to Norwegian",
        description: 'Description for prompt that translates selected content into Norwegian'
    },
    polishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.polish.title',
        defaultMessage: 'Translate to Polish',
        description: 'Title of a prompt that translates the selected content into Polish'
    },
    polishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.polish.description',
        defaultMessage: "Translates the text you're working on to Polish",
        description: 'Description for prompt that translates selected content into Polish'
    },
    portugueseBrazilianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title',
        defaultMessage: 'Translate to Portuguese (Brazilian)',
        description: 'Title of a prompt that translates the selected content into Portuguese (Brazilian)'
    },
    portugueseBrazilianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description',
        defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)",
        description: 'Description for prompt that translates selected content into Portuguese (Brazilian)'
    },
    russianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.russian.title',
        defaultMessage: 'Translate to Russian',
        description: 'Title of a prompt that translates the selected content into Russian'
    },
    russianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.russian.description',
        defaultMessage: "Translates the text you're working on to Russian",
        description: 'Description for prompt that translates selected content into Russian'
    },
    spanishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.spanish.title',
        defaultMessage: 'Translate to Spanish',
        description: 'Title of a prompt that translates the selected content into Spanish'
    },
    spanishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.spanish.description',
        defaultMessage: "Translates the text you're working on to Spanish",
        description: 'Description for prompt that translates selected content into Spanish'
    },
    swedishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.swedish.title',
        defaultMessage: 'Translate to Swedish',
        description: 'Title of a prompt that translates the selected content into Swedish'
    },
    swedishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.swedish.description',
        defaultMessage: "Translates the text you're working on to Swedish",
        description: 'Description for prompt that translates selected content into Swedish'
    },
    turkishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.turkish.title',
        defaultMessage: 'Translate to Turkish',
        description: 'Title of a prompt that translates the selected content into Turkish'
    },
    turkishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.turkish.description',
        defaultMessage: "Translates the text you're working on to Turkish",
        description: 'Description for prompt that translates selected content into Turkish'
    },
    thaiTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.thai.title',
        defaultMessage: 'Translate to Thai',
        description: 'Title of a prompt that translates the selected content into Thai'
    },
    thaiDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.thai.description',
        defaultMessage: "Translates the text you're working on to Thai",
        description: 'Description for prompt that translates selected content into Thai'
    },
    ukrainianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.ukrainian.title',
        defaultMessage: 'Translate to Ukrainian',
        description: 'Title of a prompt that translates the selected content into Ukrainian'
    },
    ukrainianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.ukrainian.description',
        defaultMessage: "Translates the text you're working on to Ukrainian",
        description: 'Description for prompt that translates selected content into Ukrainian'
    },
    vietnameseTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.vietnamese.title',
        defaultMessage: 'Translate to Vietnamese',
        description: 'Title of a prompt that translates the selected content into Vietnamese'
    },
    vietnameseDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.vietnamese.description',
        defaultMessage: "Translates the text you're working on to Vietnamese",
        description: 'Description for prompt that translates selected content into Vietnamese'
    }
});

});

parcelRegister("c1CQi", function(module, exports) {

$parcel$export(module.exports, "TranslateIcon", () => $0365202625136298$export$d1fe1d52e2885c4e);

var $5uXOq = parcelRequire("5uXOq");

var $9x5pH = parcelRequire("9x5pH");

var $ltXTD = parcelRequire("ltXTD");
const $0365202625136298$export$d1fe1d52e2885c4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltXTD))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        LEGACY_fallbackIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9x5pH))), {
                label: "",
                spacing: "spacious"
            })
    });

});
parcelRegister("ltXTD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e225d3a586abb6eec4725e9317596327>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa3ac495a92a0a43$var$_react = $fa3ac495a92a0a43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fa3ac495a92a0a43$var$_baseNew = $fa3ac495a92a0a43$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fa3ac495a92a0a43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Translate".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing language translations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa3ac495a92a0a43$var$TranslateIcon = (props)=>/*#__PURE__*/ $fa3ac495a92a0a43$var$_react.default.createElement($fa3ac495a92a0a43$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.395 4.5H0V3h4V1h1.5v2h4v1.5H6.911c-.252 1.771-.704 3.325-1.338 4.685.471.522.973.973 1.479 1.323l-.854 1.234a10 10 0 0 1-1.377-1.17 12.2 12.2 0 0 1-2.991 3.275l-.91-1.194a10.7 10.7 0 0 0 2.867-3.276 12.5 12.5 0 0 1-1.74-3.114l1.405-.526c.265.706.633 1.418 1.073 2.087.385-.982.68-2.085.87-3.324m5.17 1.945A.75.75 0 0 1 11.25 6h.5a.75.75 0 0 1 .685.445l3.5 7.875a.75.75 0 0 1 .065.305V15h-1.5v-.216L13.707 13H9.293L8.5 14.784V15H7v-.375a.75.75 0 0 1 .065-.305zM9.96 11.5h3.08L11.5 8.034z" clip-rule="evenodd"/>`
    }, props));
$fa3ac495a92a0a43$var$TranslateIcon.displayName = 'TranslateIcon';
var $fa3ac495a92a0a43$var$_default = module.exports.default = $fa3ac495a92a0a43$var$TranslateIcon;

});


parcelRegister("8j6jh", function(module, exports) {

$parcel$export(module.exports, "getSortedSupportedTranslationLanguages", () => $b58acb84c492144e$export$a288aff1b8104a05);
$parcel$export(module.exports, "isRefinementSupport", () => $b58acb84c492144e$export$9429b43310621fcf);

var $ac3U1 = parcelRequire("ac3U1");
const $b58acb84c492144e$export$a288aff1b8104a05 = ()=>{
    return 0, $ac3U1.supportedTranslationLanguagesPopularOrder;
};
const $b58acb84c492144e$export$f54f1bab33a30a3f = (latestPrompt)=>typeof latestPrompt?.presetTitle?.title?.defaultMessage === 'string' && latestPrompt?.presetTitle?.title?.defaultMessage?.includes('Translate to');
const $b58acb84c492144e$export$9429b43310621fcf = (language)=>(0, $ac3U1.refinementSupportedTranslationLanguages).includes(language);

});


parcelRegister("3X1aZ", function(module, exports) {

$parcel$export(module.exports, "_getFetchCustomHeaders", () => $e4ae1f37b9a3db04$export$bd1a8b310b130c9d);
$parcel$export(module.exports, "convoAIStatelessApiURL", () => $e4ae1f37b9a3db04$export$4388fb67ca0987b2);
$parcel$export(module.exports, "convoAIStatefulApiURL", () => $e4ae1f37b9a3db04$export$4d6359d758c27a3e);
$parcel$export(module.exports, "convoAIRovoApiURL", () => $e4ae1f37b9a3db04$export$90e6b91c68d8e307);
$parcel$export(module.exports, "convoAIAuditLogApiURL", () => $e4ae1f37b9a3db04$export$603c96e42632fe6);
$parcel$export(module.exports, "deriveProactiveAIApiUrl", () => $e4ae1f37b9a3db04$export$2f9e5a704d3d0517);
// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
function $e4ae1f37b9a3db04$export$bd1a8b310b130c9d() {
    const currentHost = window.location.origin;
    switch(true){
        case currentHost === 'https://statlas.prod.atl-paas.net':
            // Update this to add custom headers when run in atlaskit branch deploys
            // ie.
            // {
            //   'X-CloudID': 'Magic string'
            // }
            return {};
        default:
            return {};
    }
}
function $e4ae1f37b9a3db04$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
function $e4ae1f37b9a3db04$export$fb4af722000bf4fd() {
    return `${$e4ae1f37b9a3db04$export$9167f99f9be83b24()}/gateway/api/editor-ai/v1/generative/ai`;
}
const $e4ae1f37b9a3db04$export$4388fb67ca0987b2 = `${$e4ae1f37b9a3db04$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
const $e4ae1f37b9a3db04$export$4d6359d758c27a3e = `${$e4ae1f37b9a3db04$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/channel`; // + `/${channelID}/message/stream` at the end;
const $e4ae1f37b9a3db04$export$90e6b91c68d8e307 = `${$e4ae1f37b9a3db04$export$9167f99f9be83b24()}/gateway/api/assist/rovo/v1/editor/conversation`; // + `/${channelID}/message/stream` at the end;
const $e4ae1f37b9a3db04$export$603c96e42632fe6 = `${$e4ae1f37b9a3db04$export$9167f99f9be83b24()}/gateway/api/ai/v2/ai-feature/audit-logs`;
function $e4ae1f37b9a3db04$export$2f9e5a704d3d0517() {
    return `${$e4ae1f37b9a3db04$export$9167f99f9be83b24()}/gateway/api/assist/ai/v2/ai-feature/proactive`;
}

});


parcelRegister("f7Fws", function(module, exports) {

$parcel$export(module.exports, "default", () => $d77d16c3a132204b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d77d16c3a132204b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedBackTitle: {
        "id": "platform-utils-shared-editor-config.feed-back-title",
        "defaultMessage": "Help us make Atlassian Intelligence even better"
    },
    summaryPlaceholder: {
        "id": "platform-utils-shared-editor-config.summary-placeholder",
        "defaultMessage": "Let us know what you were trying to do and how it could be better"
    },
    userConsentCheckboxLabel: {
        "id": "platform-utils-shared-editor-config.user-consent-checkbox-label",
        "defaultMessage": "Include my last prompt and response in the feedback."
    },
    canContactText: {
        "id": "platform-utils-shared-editor-config.can-contact-text",
        "defaultMessage": "Atlassian can contact me about this feedback. See our <a>privacy policy</a>."
    },
    improveAtlassianText: {
        "id": "platform-utils-shared-editor-config.improve-atlassian-text",
        "defaultMessage": "I\u2019d like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>."
    }
});

});

parcelRegister("l9wag", function(module, exports) {

$parcel$export(module.exports, "Product", () => $7630c3795fbbcaa6$export$264ad599d7cef668);
// TODO: go/restrict-enums
var $7630c3795fbbcaa6$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JSW"] = "JSW";
    Product["JWM"] = "JWM";
    Product["JSM"] = "JSM";
    Product["JPD"] = "JPD";
    return Product;
}({});

});


parcelRegister("diNhq", function(module, exports) {

$parcel$export(module.exports, "useLinkPickerEditorProps", () => $70a53c38cce7e6e5$export$5057fa778edd8de9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kc9vJ = parcelRequire("kc9vJ");

const $70a53c38cce7e6e5$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("1iHrq")));
const $70a53c38cce7e6e5$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $70a53c38cce7e6e5$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $70a53c38cce7e6e5$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $70a53c38cce7e6e5$export$5057fa778edd8de9 = (/**
	 * Baseline set of props to provide to the link picker
	 */ props, /**
	 * The configuration used to control what plugins/tabs are available
	 * MUST be known on the first render as it is used to dynamically create the plugins and
	 * Editor is not yet reactive to changes in the resulting plugins
	 */ config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const WrapperComponent = (0, $5uXOq.useMemo)(()=>(props)=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)($70a53c38cce7e6e5$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props,
                config: config
            });
        }, [
        config
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        return {
            ...props ?? {},
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: $70a53c38cce7e6e5$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props
    ]);
};

});
parcelRegister("1iHrq", function(module, exports) {

let $0f292b689e4faf00$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0f292b689e4faf00$var$load("hPzOn"),
    $0f292b689e4faf00$var$load("d9wbp")
]).then(()=>parcelRequire('zjy0N'));

});


parcelRegister("k5LIG", function(module, exports) {

$parcel$export(module.exports, "useExtractedLinksRef", () => $5be255b55f7a57ce$export$1f0d7afe7a287b86);

var $5uXOq = parcelRequire("5uXOq");
function $5be255b55f7a57ce$export$ec4773b7113b75c1(adf) {
    const linksSet = new Set();
    function traverse(content) {
        if (Array.isArray(content)) for (const item of content){
            if (!item) continue;
            switch(item.type){
                case 'link':
                    if (item.attrs?.href) linksSet.add(item.attrs.href);
                    break;
                case 'blockCard':
                case 'inlineCard':
                case 'embedCard':
                    if (item.attrs?.url) linksSet.add(item.attrs.url);
                    break;
                default:
                    // If the item has a 'content' property, recursively traverse it
                    if (item.content) traverse(item.content);
                    // If the item has a 'marks' property, recursively traverse it
                    if (item.marks) traverse(item.marks);
            }
        }
    }
    if (adf.content) traverse(adf.content);
    return Array.from(linksSet);
}
function $5be255b55f7a57ce$export$1f0d7afe7a287b86(content) {
    const ref = (0, $5uXOq.useRef)(()=>[]);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof content === 'object') ref.current = ()=>$5be255b55f7a57ce$export$ec4773b7113b75c1(content);
    }, [
        content
    ]);
    return ref;
}

});

parcelRegister("uaKxS", function(module, exports) {

$parcel$export(module.exports, "AsyncAiProactiveDescriptionCompleter", () => $db174980224c1147$export$f6d606145e3602e);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $eHyLP = parcelRequire("eHyLP");
const $db174980224c1147$var$entrypointParams = {};
const $db174980224c1147$export$f6d606145e3602e = (props)=>{
    const { editorApi: editorApi, editorExperience: editorExperience, projectType: projectType, issueType: issueType, issueSummary: issueSummary, issueDescription: issueDescription } = props;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $eHyLP.aiProactiveDescriptionCompleterEntryPoint), $db174980224c1147$var$entrypointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            editorApi: editorApi,
            editorExperience: editorExperience,
            projectType: projectType,
            issueType: issueType,
            issueSummary: issueSummary,
            issueDescription: issueDescription
        }), [
        editorApi,
        editorExperience,
        issueDescription,
        issueSummary,
        issueType,
        projectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraAiProactiveDescriptionCompleterEntryPoint",
        packageName: "jira-ai-proactive-description-completer",
        teamName: "crocs",
        fallback: null,
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("eHyLP", function(module, exports) {

$parcel$export(module.exports, "aiProactiveDescriptionCompleterEntryPoint", () => $aaa5ff217daab0bf$export$1c09555363edf305);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $aaa5ff217daab0bf$export$1c09555363edf305 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eeuoZ")).then((module)=>module.AiProactiveDescriptionCompleterEntryPointComponent), {
        moduleId: "64fe74ed"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eeuoZ", function(module, exports) {

let $a5c9f4afdc3a3b08$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5c9f4afdc3a3b08$var$load("fpTAr").then(()=>parcelRequire('2lmAK'));

});



parcelRegister("h0fZ7", function(module, exports) {

$parcel$export(module.exports, "sanitizeADFField", () => $e0781922eb7ae616$export$28941b736a01da7b);
$parcel$export(module.exports, "mutateADFField", () => $e0781922eb7ae616$export$82a40b3982cf31c4);
$parcel$export(module.exports, "validateDescriptionField", () => $e0781922eb7ae616$export$78b1417f15a51a4f);

var $fr1K2 = parcelRequire("fr1K2");

var $kz2lw = parcelRequire("kz2lw");

var $6paOF = parcelRequire("6paOF");

var $bGrWH = parcelRequire("bGrWH");

const $e0781922eb7ae616$var$emptyADFString = JSON.stringify((0, $kz2lw.getEmptyADF)());
const $e0781922eb7ae616$export$28941b736a01da7b = (adfValue)=>{
    // @ts-expect-error extra properties are not a part of ADF
    if (adfValue?.overrideRequired || adfValue?.resetRequired) (0, $6paOF.fireIssueCreateErrorAnalytics)({
        meta: {
            id: 'adfObjectTypeErrorIssueCreate',
            packageName: 'jiraIssueCreateModal',
            teamName: 'gryffindor'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sanitizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(adfValue, [
        'overrideRequired',
        'resetRequired'
    ]);
    return sanitizedValue;
};
const $e0781922eb7ae616$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
    // stringify to compare with emptyADF
    const adfValueString = JSON.stringify(adfValue);
    // emptyADF is special case where input retention should not happen
    return $e0781922eb7ae616$var$emptyADFString === adfValueString ? null : {
        fieldId: fieldId,
        mutationGroup: (0, $6aa4505c49fca768$export$31fd86f8f183952c),
        richText: {
            adfValue: adfValue
        }
    };
};
const $e0781922eb7ae616$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
    if (!isRequired) return undefined;
    const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, $kz2lw.getEmptyADF)());
    if (isAdfEmptyOrUndefined) return 0, $bGrWH.REQUIRED;
    const hardBreakNodeType = 'hardBreak';
    // Users can bypass the required field validation for the description field by pressing shift + enter. shift + enter creates a 'hardBreak' block inside the value. If only hardBreaks exist then treat the description field as empty
    let isAnythingThereApartFromHardBreaks = false;
    if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
        const block = adfValue.content[i];
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'BlockContent | LayoutSectionDefinition | CodeBlockWithMarksDefinition | ExpandWithBreakoutDefinition | ParagraphWithIndentationDefinition'.
        const blockContent = block.content;
        isAnythingThereApartFromHardBreaks = blockContent?.some(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (blockItem)=>blockItem.type !== hardBreakNodeType);
        if (isAnythingThereApartFromHardBreaks) break;
    }
    if (isAnythingThereApartFromHardBreaks) return undefined;
    return 0, $bGrWH.REQUIRED;
};

});
const $6aa4505c49fca768$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("j1zV8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4a0d488a99104902$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4a0d488a99104902$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-create.common.fields.description-field.placeholder",
        "defaultMessage": "Paste a Confluence link here, and we can help generate the description from the page\u2019s contents."
    }
});

});


parcelRegister("qzRgG", function(module, exports) {

$parcel$export(module.exports, "EpicLinkField", () => $6673eab62a43357a$export$7929a33274a9f9f);

var $5uXOq = parcelRequire("5uXOq");

var $7YTXY = parcelRequire("7YTXY");
const $6673eab62a43357a$export$7929a33274a9f9f = (props)=>{
    const { useFormContext: useFormContext, ...commonEpicLinkFieldProps } = props;
    const [, { setIsEpicLinkSelected: setIsEpicLinkSelected }] = useFormContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YTXY.default), {
        ...commonEpicLinkFieldProps,
        setIsEpicLinkSelected: setIsEpicLinkSelected
    });
};

});
parcelRegister("7YTXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39b09761bdc1cbf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $TzSzf = parcelRequire("TzSzf");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $kRBrp = parcelRequire("kRBrp");

const $c39b09761bdc1cbf$export$7929a33274a9f9f = (props)=>{
    const { width: width } = props;
    // We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
    // use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TzSzf.DisabledEpicLinkParentLinkField), null));
};
var $c39b09761bdc1cbf$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $kRBrp.transformDefaultEpicValue)
})($c39b09761bdc1cbf$export$7929a33274a9f9f);

});
parcelRegister("TzSzf", function(module, exports) {

$parcel$export(module.exports, "DisabledEpicLinkParentLinkField", () => $f0e1c154af4baef4$export$eb9d1bb510274e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");

var $3I4sb = parcelRequire("3I4sb");
const $f0e1c154af4baef4$export$eb9d1bb510274e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0e1c154af4baef4$var$DisabledEpicLinkParentLinkFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $3I4sb.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunks)
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0e1c154af4baef4$var$DisabledEpicLinkParentLinkFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3I4sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a23e699a16d942$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b5a23e699a16d942$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});




parcelRegister("aeHT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4aa51bc46928ec2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $19MNr = parcelRequire("19MNr");

var $2T8zR = parcelRequire("2T8zR");
const $e4aa51bc46928ec2$var$IssueRestrictionField = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, selectedProject: selectedProject, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, description: description, fieldName: fieldName, width: width, ariaLabelledBy: ariaLabelledBy } = props;
    const [shouldShowAccessWarning, setAccessWarningDisplay] = (0, $5uXOq.useState)(false);
    const convertToFieldType = (roles)=>{
        onChange(roles.map(({ roleId: roleId })=>({
                roleId: roleId
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $19MNr.RolePickerEdit), {
        ...fieldProps,
        selectedProjectId: selectedProject?.value || '',
        selectedRoles: value,
        onChange: convertToFieldType,
        autoFocus: autoFocus,
        isDisabled: false,
        classNamePrefix: "issue-restriction-select",
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        setAccessWarningDisplay: setAccessWarningDisplay,
        "aria-labelledby": ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), shouldShowAccessWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e4aa51bc46928ec2$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2T8zR.default).noAccessOnIssueCreatedWarningIssueTermRefresh : (0, $2T8zR.default).noAccessOnIssueCreatedWarning))) : null);
};
var $e4aa51bc46928ec2$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    shouldRenderFieldMessage: false
})($e4aa51bc46928ec2$var$IssueRestrictionField);
const $e4aa51bc46928ec2$var$messageContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("19MNr", function(module, exports) {

$parcel$export(module.exports, "RolePickerEdit", () => $10d599f8d0053bff$export$61efdb1b7765b92e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $bq7UN = parcelRequire("bq7UN");

var $1FoWu = parcelRequire("1FoWu");

var $5pYli = parcelRequire("5pYli");
const $10d599f8d0053bff$export$ab4a55465dcdd21b = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { currentUserRole: currentUserRole } = props;
    return currentUserRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$CurrentUserRole, null, formatMessage((0, $1FoWu.default).currentUserRole))) : null;
};
// @ts-expect-error - TS7031 - Binding element 'context' implicitly has an 'any' type.
const $10d599f8d0053bff$var$formatOptionLabel = (option, { context: context })=>{
    if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$FlexBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$RoleName, null, option.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$SelectDescription, null, option.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$export$ab4a55465dcdd21b, {
        currentUserRole: !!option.currentUserRole
    }));
    return option.name;
};
const $10d599f8d0053bff$export$61efdb1b7765b92e = (props)=>{
    const { classNamePrefix: classNamePrefix, selectedRoles: selectedRoles, selectedProjectId: selectedProjectId, onChange: onChange, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, setAccessWarningDisplay: setAccessWarningDisplay, ariaLabel: ariaLabel, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: allRoles } = (0, $bq7UN.default)(selectedProjectId);
    const rolesWithCurrentUserAccess = (0, $5uXOq.useMemo)(()=>allRoles.filter(({ currentUserRole: currentUserRole })=>currentUserRole === true), [
        allRoles
    ]);
    const shouldShowIssueAccessWarning = (0, $5uXOq.useMemo)(()=>!(0, $5pYli.isUserRoleIncludedInRestrictedRoles)(selectedRoles, rolesWithCurrentUserAccess), [
        rolesWithCurrentUserAccess,
        selectedRoles
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setAccessWarningDisplay) setAccessWarningDisplay(shouldShowIssueAccessWarning);
    }, [
        setAccessWarningDisplay,
        shouldShowIssueAccessWarning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...fieldProps,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type 'Data' is not assignable to type 'readonly (SingleSelectItem | GroupBase<SingleSelectItem>)[]'.
        options: allRoles,
        isMulti: true,
        onBlur: onBlur,
        onFocus: onFocus,
        formatOptionLabel: $10d599f8d0053bff$var$formatOptionLabel,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        isSearchable: false,
        placeholder: formatMessage((0, $1FoWu.default).placeholder),
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type '(role: TransformedRole) => string' is not assignable to type 'GetOptionValue<SingleSelectItem>'.
        getOptionValue: (0, $5pYli.getOptionValue),
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type '(role: TransformedRole) => string' is not assignable to type 'GetOptionLabel<SingleSelectItem>'.
        getOptionLabel: (0, $5pYli.getOptionLabel),
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type 'TransformedRole[]' is not assignable to type 'PropsValue<SingleSelectItem> | undefined'.
        value: (0, $5pYli.convertRolesToCurrentRole)(selectedRoles, allRoles),
        onChange: (roles)=>(0, $5pYli.transformRolesToArrayIfNull)(roles, onChange),
        isDisabled: isDisabled,
        autoFocus: autoFocus,
        validationState: isInvalid === true ? 'error' : null,
        closeMenuOnScroll: onCloseMenuOnScroll,
        "aria-label": ariaLabel,
        "aria-labelledby": fieldProps['aria-labelledby']
    });
};
var $10d599f8d0053bff$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $10d599f8d0053bff$export$61efdb1b7765b92e;
const $10d599f8d0053bff$var$SelectDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _o5724jg8 _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10d599f8d0053bff$var$FlexBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10d599f8d0053bff$var$FlexColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10d599f8d0053bff$var$RoleName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10d599f8d0053bff$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19bvv47k",
            __cmplp.className
        ])
    });
});
const $10d599f8d0053bff$var$CurrentUserRole = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zg8l1m30",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bq7UN", function(module, exports) {

$parcel$export(module.exports, "default", () => $168dc29b7a79b736$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $kVfCM = parcelRequire("kVfCM");
const $168dc29b7a79b736$var$useFetchRoles = (projectKeyOrId)=>{
    const [data, setData] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            setLoading(true);
            try {
                const response = await (0, $eusud.performGetRequest)((0, $kVfCM.getFetchRolesURL)(projectKeyOrId));
                setLoading(false);
                setData((0, $kVfCM.transformRoleIdToString)(response));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (httpError) {
                setLoading(false);
                setError(httpError.message);
            }
        })();
    }, [
        projectKeyOrId
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};
var $168dc29b7a79b736$export$2e2bcd8739ae039 = $168dc29b7a79b736$var$useFetchRoles;

});
parcelRegister("kVfCM", function(module, exports) {

$parcel$export(module.exports, "getFetchRolesURL", () => $282c4354f0c6926d$export$e39189e7b2114aa1);
$parcel$export(module.exports, "transformRoleIdToString", () => $282c4354f0c6926d$export$25aa9a2b001fbb5e);
const $282c4354f0c6926d$export$e39189e7b2114aa1 = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/internal/roledetails?excludeConnectAddons=true`;
const $282c4354f0c6926d$export$25aa9a2b001fbb5e = (roles)=>roles.map(({ id: id, ...role })=>({
            roleId: id.toString(),
            ...role
        }));

});


parcelRegister("1FoWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdf80a4db07c2fe3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bdf80a4db07c2fe3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    currentUserRole: {
        "id": "issue-field-role-picker.edit.current-user-role",
        "defaultMessage": "You"
    },
    placeholder: {
        "id": "issue-field-role-picker.edit.placeholder",
        "defaultMessage": "Select Roles"
    }
});

});


parcelRegister("2T8zR", function(module, exports) {

$parcel$export(module.exports, "default", () => $14cff774b2f5c082$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14cff774b2f5c082$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noAccessOnIssueCreatedWarning: {
        "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning",
        "defaultMessage": "Select the roles that you're a part of to avoid losing access to this issue."
    },
    noAccessOnIssueCreatedWarningIssueTermRefresh: {
        "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning-issue-term-refresh",
        "defaultMessage": "Select the roles that you're a part of to avoid losing access to this work item."
    }
});

});


parcelRegister("hPJET", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ff602fee162bb4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bGrWH = parcelRequire("bGrWH");

var $hDSkY = parcelRequire("hDSkY");

var $45Cy1 = parcelRequire("45Cy1");
const $20ff602fee162bb4$var$LogWorkField = ({ additionalData: additionalData, ...props })=>{
    const { mediaContext: mediaContext, timeTrackingSettings: timeTrackingSettings } = additionalData;
    const [mediaUploadContext, setMediaUploadContext] = (0, $5uXOq.useState)(null);
    const [viewContext, setViewContext] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const uploadToken = mediaContext?.uploadToken;
        if (uploadToken) {
            const { clientId: clientId, endpointUrl: endpointUrl, targetCollection: targetCollection, token: token, tokenDurationInMin: tokenDurationInMin } = uploadToken;
            const tokenIssueTimestamp = Date.now();
            const tokenLifespanInMs = tokenDurationInMin * 60000;
            setMediaUploadContext({
                clientId: clientId,
                serviceHost: endpointUrl,
                collection: targetCollection,
                tokenLifespanInMs: tokenLifespanInMs,
                token: token,
                tokenIssueTimestamp: tokenIssueTimestamp
            });
            setViewContext({
                clientId: clientId,
                serviceHost: endpointUrl,
                token: token,
                tokenLifespanInMs: tokenLifespanInMs,
                areTokenPermissionsUpToDate: true,
                collection: targetCollection,
                tokenIssueTimestamp: tokenIssueTimestamp
            });
        }
    }, [
        mediaContext?.uploadToken
    ]);
    const mediaProvider = {
        userAuth: null,
        viewContext: viewContext,
        uploadContext: mediaUploadContext
    };
    const [{ timeTrackingValue: timeTrackingValue, meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $45Cy1.useFormContext)();
    const getLogWorkFieldErrors = (0, $5uXOq.useCallback)(()=>{
        if (submitFieldwiseErrors) {
            const logWorkFieldWiseErrors = {};
            [
                (0, $bGrWH.LOG_WORK_DATE_ERROR_KEY),
                (0, $bGrWH.LOG_WORK_DESCRIPTION_ERROR_KEY),
                (0, $bGrWH.LOG_WORK_TIME_REMAINING_ERROR_KEY),
                (0, $bGrWH.LOG_WORK_TIME_SPENT_ERROR_KEY)
            ].forEach((errorKey)=>{
                if (submitFieldwiseErrors[errorKey]) logWorkFieldWiseErrors[errorKey] = submitFieldwiseErrors[errorKey];
            });
            const logWorkOtherErrors = [];
            (0, $bGrWH.COMMON_LOG_WORK_ERROR_KEYS).forEach((key)=>{
                if (submitFieldwiseErrors[key]) logWorkOtherErrors.push(submitFieldwiseErrors[key]);
            });
            return {
                ...logWorkFieldWiseErrors,
                logWorkOtherErrors: logWorkOtherErrors
            };
        }
        return undefined;
    }, [
        submitFieldwiseErrors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDSkY.default), {
        ...props,
        additionalData: {
            timeTrackingSettings: timeTrackingSettings
        },
        mediaContext: mediaProvider,
        timeTrackingValue: timeTrackingValue,
        errors: getLogWorkFieldErrors()
    });
};
var $20ff602fee162bb4$export$2e2bcd8739ae039 = $20ff602fee162bb4$var$LogWorkField;

});
parcelRegister("hDSkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a647ee1c161b598f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jj52j = parcelRequire("jj52j");

var $fVnbM = parcelRequire("fVnbM");

var $htnpT = parcelRequire("htnpT");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $6s76W = parcelRequire("6s76W");

var $6Tj4n = parcelRequire("6Tj4n");

var $1wbtX = parcelRequire("1wbtX");

var $8C78M = parcelRequire("8C78M");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $bGrWH = parcelRequire("bGrWH");

var $9ah8z = parcelRequire("9ah8z");

var $9idvE = parcelRequire("9idvE");

var $lfTZh = parcelRequire("lfTZh");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");


var $k4Xhy = parcelRequire("k4Xhy");

var $9sq52 = parcelRequire("9sq52");
const $a647ee1c161b598f$var$skeletonHeight = `${(0, $gwIPs.gridSize) * 18.75}px`;
const $a647ee1c161b598f$export$c128706c0bbc8993 = (props)=>{
    const currentDateTime = (0, $5uXOq.useMemo)(()=>(0, $jj52j.default)(new Date()), []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [timeFieldInFocus, setTimeFieldInFocus] = (0, $5uXOq.useState)('');
    const isDefaultValueSetInFormStateForDateField = (0, $5uXOq.useRef)(false);
    const [areLogWorkFieldsVisible, showLogWorkFields] = (0, $5uXOq.useState)(false);
    const [estimateExceededWarning, setEstimateExceededWarning] = (0, $5uXOq.useState)('');
    const { width: width = 350, fieldProps: { value: value = {
        timeRemaining: '',
        timeSpent: '',
        dateValue: '',
        description: undefined
    }, onChange: onChange }, timeTrackingValue: timeTrackingValue = '', mediaContext: mediaContext, autoFocus: autoFocus = false, additionalData: additionalData, isRequired: isRequired, errors: errors, fieldName: fieldName } = props;
    const { description: description, timeRemaining: timeRemaining, timeSpent: timeSpent, dateValue: dateValue } = value;
    const { timeTrackingSettings: config } = additionalData;
    const locale = (0, $DVljb.useLocale)();
    const onChangeFieldValue = (0, $5uXOq.useCallback)((partialFieldValue)=>{
        onChange({
            ...value,
            ...partialFieldValue
        });
    }, [
        onChange,
        value
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (timeTrackingValue) {
            const isTimeEstimateExceeded = (0, $9sq52.getIsTimeEstimateExceeded)({
                config: config,
                timeRemaining: timeRemaining,
                timeSpent: timeSpent,
                timeTrackingValue: timeTrackingValue
            });
            setEstimateExceededWarning(isTimeEstimateExceeded ? formatMessage((0, $k4Xhy.default).originalEstimateExceededNonFinal) : '');
        } else if (estimateExceededWarning) setEstimateExceededWarning('');
    }, [
        timeRemaining,
        timeSpent,
        timeTrackingValue,
        config,
        formatMessage,
        estimateExceededWarning
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isDefaultValueSetInFormStateForDateField.current && !dateValue && areLogWorkFieldsVisible) {
            isDefaultValueSetInFormStateForDateField.current = true;
            onChangeFieldValue({
                dateValue: currentDateTime
            });
        }
    }, [
        dateValue,
        currentDateTime,
        onChangeFieldValue,
        areLogWorkFieldsVisible
    ]);
    const onChangeTimeSpent = (0, $5uXOq.useCallback)((newTimeSpent)=>{
        let newTimeRemaining = timeRemaining;
        if (timeTrackingValue) {
            const calculatedTimeRemainingIfAny = (0, $9sq52.getCalculatedTimeRemainingIfAny)({
                timeSpent: newTimeSpent,
                timeTrackingValue: timeTrackingValue,
                config: config
            });
            if (calculatedTimeRemainingIfAny !== null) newTimeRemaining = calculatedTimeRemainingIfAny;
        }
        setTimeFieldInFocus((0, $967029f3aa14c1ce$export$81fee17d19007357));
        onChangeFieldValue({
            timeSpent: newTimeSpent,
            timeRemaining: newTimeRemaining
        });
    }, [
        config,
        onChangeFieldValue,
        timeRemaining,
        timeTrackingValue
    ]);
    const onChangeTimeRemaining = (0, $5uXOq.useCallback)((newTimeRemaining)=>{
        setTimeFieldInFocus((0, $967029f3aa14c1ce$export$d7ed3a061805d786));
        onChangeFieldValue({
            timeRemaining: newTimeRemaining
        });
    }, [
        onChangeFieldValue
    ]);
    const onToggleLogWorkFieldsVisibility = (0, $5uXOq.useCallback)(()=>{
        showLogWorkFields((current)=>!current);
    }, []);
    const onChangeDatePicker = (0, $5uXOq.useCallback)((newDateValue)=>{
        onChangeFieldValue({
            dateValue: newDateValue
        });
    }, [
        onChangeFieldValue
    ]);
    const onChangeEditorValue = (0, $5uXOq.useCallback)((newEditorValue)=>{
        onChangeFieldValue({
            description: newEditorValue
        });
    }, [
        onChangeFieldValue
    ]);
    const isEstimateExceeded = estimateExceededWarning !== '';
    const weekStartDay = (0, $1p96B.getLocale)(locale)?.options?.weekStartsOn;
    const buttonLabel = formatMessage((0, $k4Xhy.default).logWorkLabel);
    const dateTimeLabel = formatMessage((0, $k4Xhy.default).dateStarted);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a647ee1c161b598f$var$LogWorkHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: areLogWorkFieldsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Tj4n))), {
            spacing: "spacious",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6s76W))), {
            spacing: "spacious",
            label: ""
        }),
        appearance: "subtle",
        spacing: "none",
        onClick: onToggleLogWorkFieldsVisibility,
        testId: "issue-create-commons.ui.log-work-field.next-button",
        "aria-label": buttonLabel,
        "aria-expanded": areLogWorkFieldsVisible
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, buttonLabel, " ", isRequired === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a647ee1c161b598f$var$RequiredDot, null, "*") : '')), areLogWorkFieldsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: (0, $967029f3aa14c1ce$export$81fee17d19007357),
        label: formatMessage((0, $k4Xhy.default).timeSpent),
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9idvE.TimeEstimate), {
            ...fieldProps,
            autoFocus: autoFocus,
            value: timeSpent,
            onChange: onChangeTimeSpent,
            shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $967029f3aa14c1ce$export$81fee17d19007357),
            config: config
        }), errors && errors[0, $bGrWH.LOG_WORK_TIME_SPENT_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, errors[0, $bGrWH.LOG_WORK_TIME_SPENT_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: (0, $967029f3aa14c1ce$export$d7ed3a061805d786),
        label: formatMessage((0, $k4Xhy.default).timeRemaining)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9idvE.TimeEstimate), {
            ...fieldProps,
            value: timeRemaining,
            onChange: onChangeTimeRemaining,
            shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $967029f3aa14c1ce$export$d7ed3a061805d786),
            config: config
        }), errors && errors[0, $bGrWH.LOG_WORK_TIME_REMAINING_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, errors[0, $bGrWH.LOG_WORK_TIME_REMAINING_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: (0, $967029f3aa14c1ce$export$ade7f171d00a976f),
        label: dateTimeLabel,
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
            onChange: onChangeDatePicker,
            value: dateValue,
            locale: locale,
            isClearable: !isRequired,
            datePickerProps: {
                weekStartDay: weekStartDay,
                label: dateTimeLabel,
                id: fieldProps.id,
                shouldShowCalendarButton: true
            },
            timePickerProps: {
                times: (0, $8C78M.default)
            }
        }), errors && errors[0, $bGrWH.LOG_WORK_DATE_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, errors[0, $bGrWH.LOG_WORK_DATE_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: (0, $967029f3aa14c1ce$export$caca24db5cb49b68),
        label: formatMessage((0, $k4Xhy.default).description)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "rich-text-edit-view",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
                height: $a647ee1c161b598f$var$skeletonHeight
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ah8z.AsyncRichTextEditView), {
            onChange: onChangeEditorValue,
            defaultValue: description,
            mediaContext: mediaContext,
            // @ts-expect-error - TS2739 - Type '{ unsubscribe: () => void; }' is missing the following properties from type 'MentionProvider': filter, recordMentionSelection, shouldHighlightMention, isFiltering, subscribe
            mentionProvider: {
                // was throwing a console error on unmouting so added this
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                unsubscribe: ()=>{}
            },
            assistiveLabel: fieldName
        })), errors && errors[0, $bGrWH.LOG_WORK_DESCRIPTION_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, errors[0, $bGrWH.LOG_WORK_DESCRIPTION_ERROR_KEY]) : null)), errors && errors.logWorkOtherErrors?.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
            key: `logwork-${index}-common-error`
        }, error))));
};
var $a647ee1c161b598f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    shouldHideLabel: true // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<LogWorkFieldConfig, FieldValue>, any>'.
})($a647ee1c161b598f$export$c128706c0bbc8993);
const $a647ee1c161b598f$var$RequiredDot = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1tmw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a647ee1c161b598f$var$LogWorkHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("htnpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2698ee0cdd579e$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $9Lqvx = parcelRequire("9Lqvx");

var $hB1kl = parcelRequire("hB1kl");
const $fa2698ee0cdd579e$var$DateTimePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-time-picker-use-functional-component'), (0, $hB1kl.default), (0, $9Lqvx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;

});
parcelRegister("9Lqvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $597f1543018f8252$export$2e2bcd8739ae039);
/* date-time-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $597f1543018f8252$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $597f1543018f8252$var$packageName = "platform-pkg";
const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
const $597f1543018f8252$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_19itglyw _v564vrg3 _1e0c1txw _4cvr1h6o _i0dl1kw7 _bfhk1kw7 _syaz131l _6rthe4h9 _1pfhe4h9 _12l2e4h9 _ahbqe4h9 _85i512x7 _1q5112x7 _y4tiu2gc _bozg1b66 _30l31gjq"
}; // react-select overrides (via @atlaskit/select).
const $597f1543018f8252$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $597f1543018f8252$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time'; // eslint-disable-next-line @repo/internal/react/no-class-components
class $597f1543018f8252$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
        }; // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8JNJx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.datePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($597f1543018f8252$var$DatePicker, {
                        appearance: appearance,
                        "aria-describedby": datePickerAriaDescribedBy,
                        autoFocus: datePickerProps.autoFocus || autoFocus,
                        dateFormat: datePickerProps.dateFormat,
                        defaultIsOpen: datePickerProps.defaultIsOpen,
                        defaultValue: datePickerProps.defaultValue,
                        disabled: datePickerProps.disabled,
                        disabledDateFilter: datePickerProps.disabledDateFilter,
                        formatDisplayLabel: datePickerProps.formatDisplayLabel,
                        hideIcon: datePickerProps.hideIcon || true,
                        icon: datePickerProps.icon,
                        id: datePickerProps.id || id,
                        innerProps: datePickerProps.innerProps,
                        isDisabled: datePickerProps.isDisabled || isDisabled,
                        isInvalid: datePickerProps.isInvalid || isInvalid,
                        isRequired: datePickerProps.isRequired || isRequired,
                        isOpen: datePickerProps.isOpen,
                        label: datePickerLabel,
                        locale: datePickerProps.locale || locale,
                        maxDate: datePickerProps.maxDate,
                        minDate: datePickerProps.minDate,
                        name: datePickerProps.name,
                        nextMonthLabel: datePickerProps.nextMonthLabel,
                        onBlur: this.onDateBlur,
                        onChange: this.onDateChange,
                        onFocus: this.onDateFocus,
                        parseInputValue: datePickerProps.parseInputValue,
                        placeholder: datePickerProps.placeholder,
                        previousMonthLabel: datePickerProps.previousMonthLabel,
                        selectProps: mergedDatePickerSelectProps,
                        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                        spacing: datePickerProps.spacing || spacing,
                        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                        value: dateValue,
                        weekStartDay: datePickerProps.weekStartDay
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.timePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdTq6.default), {
                        appearance: timePickerProps.appearance || appearance,
                        "aria-describedby": timePickerAriaDescribedBy,
                        autoFocus: timePickerProps.autoFocus,
                        defaultIsOpen: timePickerProps.defaultIsOpen,
                        defaultValue: timePickerProps.defaultValue,
                        formatDisplayLabel: timePickerProps.formatDisplayLabel,
                        hideIcon: timePickerProps.hideIcon || true,
                        id: timePickerProps.id,
                        innerProps: timePickerProps.innerProps,
                        isDisabled: timePickerProps.isDisabled || isDisabled,
                        isInvalid: timePickerProps.isInvalid || isInvalid,
                        isOpen: timePickerProps.isOpen,
                        isRequired: timePickerProps.isRequired || isRequired,
                        label: timePickerLabel,
                        locale: timePickerProps.locale || locale,
                        name: timePickerProps.name,
                        onBlur: this.onTimeBlur,
                        onChange: this.onTimeChange,
                        onFocus: this.onTimeFocus,
                        parseInputValue: timePickerProps.parseInputValue,
                        placeholder: timePickerProps.placeholder,
                        selectProps: mergedTimePickerSelectProps,
                        spacing: timePickerProps.spacing || spacing,
                        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                        timeFormat: timePickerProps.timeFormat,
                        timeIsEditable: timePickerProps.timeIsEditable,
                        times: timePickerProps.times,
                        value: timeValue
                    })
                }),
                isClearable && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
                    onClick: this.onClear,
                    "data-testid": testId && `${testId}--icon--container`,
                    tabIndex: -1,
                    type: "button",
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.iconContainerStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                            LEGACY_size: "small",
                            color: "currentColor",
                            label: clearControlLabel
                        }),
                        ' '
                    ]
                }) : null
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        } // All state needs to be accessed via this function so that the state is mapped from props
        , // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
const $597f1543018f8252$var$DateTimePicker = (0, $994MI.default)({
    componentName: 'dateTimePicker',
    packageName: $597f1543018f8252$var$packageName,
    packageVersion: $597f1543018f8252$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $597f1543018f8252$var$packageName,
            packageVersion: $597f1543018f8252$var$packageVersion
        }
    })
})($597f1543018f8252$export$732a1726f0a3523b));
var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;

});
parcelRegister("8JNJx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $346cb403038f00ec$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $346cb403038f00ec$var$isInvalidBorderStyles = null;
const $346cb403038f00ec$var$isFocusedBorderStyles = null;
const $346cb403038f00ec$var$isFocusedStyles = null;
const $346cb403038f00ec$var$subtleBgStyles = null;
const $346cb403038f00ec$var$subtleFocusedBgStyles = null;
const $346cb403038f00ec$var$noBgStyles = null;
const $346cb403038f00ec$var$hoverStyles = null;
const $346cb403038f00ec$var$isInvalidHoverStyles = null;
const $346cb403038f00ec$var$isDisabledStyles = null;
const $346cb403038f00ec$var$newBorderStyles = null;
const $346cb403038f00ec$var$baseContainerStyles = null;
const $346cb403038f00ec$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _v564r5cv _1e0c1txw _bfhk1j9a _d0altlke",
            "_19it1k9g",
            isDisabled && "_1h6d13gt _bfhksyzs _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d3acm _bfhkxbh0",
            appearance === 'subtle' && !isFocused && "_1h6d3acm _bfhk18uv",
            isFocused && "_1h6d1p6i _16qsq049",
            isInvalid && "_1h6d1bqt",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr31d5g",
            notFocusedOrIsDisabled && !isInvalid && "_4cvx1elr _irr31d5g",
            appearance === 'none' && "_1h6d3acm _bfhk18uv _4cvx3acm _irr318uv"
        ]),
        children: children
    });
});

});

parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$var$formatSemi24(timeArray[0].trim());
    const hour = $b5e493719c30ce57$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$var$assignToDate(time2);
}

});



parcelRegister("hB1kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24b25c52c40a49$export$2e2bcd8739ae039);
/* date-time-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $9d24b25c52c40a49$var$DatePicker = (0, $cKsfY.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $9d24b25c52c40a49$var$packageName = "platform-pkg";
const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
const $9d24b25c52c40a49$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $9d24b25c52c40a49$var$packageName,
    packageVersion: $9d24b25c52c40a49$var$packageVersion
};
const $9d24b25c52c40a49$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
}; // react-select overrides (via @atlaskit/select).
const $9d24b25c52c40a49$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time'; /**
                                                   * __Date time picker__
                                                   *
                                                   * A date time picker allows the user to select an associated date and time.
                                                   *
                                                   * - [Examples](https://atlassian.design/components/datetime-picker/examples)
                                                   * - [Code](https://atlassian.design/components/datetime-picker/code)
                                                   * - [Usage](https://atlassian.design/components/datetime-picker/usage)
                                                   */ 
const $9d24b25c52c40a49$var$DateTimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$9d24b25c52c40a49$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
    }; // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8JNJx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($9d24b25c52c40a49$var$DatePicker, {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdTq6.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: timeValue
                })
            }),
            isClearable && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #626F86)",
                            LEGACY_size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("8C78M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8375c0a150abd1f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $f8375c0a150abd1f$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("9idvE", function(module, exports) {

$parcel$export(module.exports, "TimeEstimate", () => $367e992cb04c0b28$export$ad441edf1beb0bda);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $bU3PY = parcelRequire("bU3PY");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $axdWJ = parcelRequire("axdWJ");

var $jDrwg = parcelRequire("jDrwg");

var $cISwW = parcelRequire("cISwW");

var $gg0BN = parcelRequire("gg0BN");
const $367e992cb04c0b28$export$ad441edf1beb0bda = (props)=>{
    const { value: value, placeholder: placeholder = '2w 1d 5h 4m', onChange: onChange, config: config, shouldShowWarning: shouldShowWarning, fieldId: fieldId, ...fieldProps } = props;
    const [isIncorrectTimeFormat, setIsIncorrectTimeFormat] = (0, $5uXOq.useState)(false);
    const [debouncedIsValidTimeString] = (0, $jDrwg.default)((inputValue)=>setIsIncorrectTimeFormat(!(0, $axdWJ.isValidTimeString)(config)(inputValue)), 500);
    (0, $5uXOq.useEffect)(()=>{
        debouncedIsValidTimeString(value);
    }, [
        value,
        debouncedIsValidTimeString
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onValueChange = (e)=>{
        const { value: inputValue } = e.target;
        onChange(inputValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...fieldProps,
        testId: (0, $gg0BN.DATA_TEST_IDS).TEXT_FIELD,
        ...fieldId && {
            'aria-describedby': `${fieldId}-field-message`
        },
        type: "text",
        value: value,
        placeholder: placeholder,
        onChange: onValueChange,
        isInvalid: isIncorrectTimeFormat,
        "aria-label": formatMessage((0, $cISwW.default).ariaLabel),
        elemAfterInput: shouldShowWarning === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $cISwW.default).timeLoggedExceeded),
            testId: (0, $gg0BN.DATA_TEST_IDS).TOOLTIP
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $cISwW.default).warning),
            color: "var(--ds-icon-warning, #E56910)",
            testId: (0, $gg0BN.DATA_TEST_IDS).WARNING_ICON
        })) : null
    }), isIncorrectTimeFormat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
        testId: (0, $gg0BN.DATA_TEST_IDS).ERROR_MESSAGE
    }, formatMessage((0, $cISwW.default).invalidDateFormat)));
};

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("cISwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $31dfa38353da6fe4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31dfa38353da6fe4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    invalidDateFormat: {
        "id": "issue-time-estimate.edit.invalid-date-format",
        "defaultMessage": "Please enter date in the correct format"
    },
    warning: {
        "id": "issue-time-estimate.edit.warning",
        "defaultMessage": "warning"
    },
    timeLoggedExceeded: {
        "id": "issue-time-estimate.edit.time-logged-exceeded",
        "defaultMessage": "Time logged has exceeded the limit"
    },
    ariaLabel: {
        "id": "issue-time-estimate.edit.aria-label",
        "defaultMessage": "Enter the estimated time"
    }
});

});

parcelRegister("gg0BN", function(module, exports) {

$parcel$export(module.exports, "DATA_TEST_IDS", () => $63843dd83dcdc657$export$3e5d0cbd910e9c20);

const $63843dd83dcdc657$var$getItemDataTestId = (itemId)=>`${0, $4b81b655080e9ffd$export$7c86105e5fb6a1ce}${itemId}`;
const $63843dd83dcdc657$export$96f42c00fe93c7cb = (itemDataTestId)=>`[data-testid="${itemDataTestId}"]`;
const $63843dd83dcdc657$export$3e5d0cbd910e9c20 = {
    TEXT_FIELD: $63843dd83dcdc657$var$getItemDataTestId('text-field'),
    TOOLTIP: $63843dd83dcdc657$var$getItemDataTestId('tooltip'),
    WARNING_ICON: $63843dd83dcdc657$var$getItemDataTestId('warning_icon'),
    ERROR_MESSAGE: $63843dd83dcdc657$var$getItemDataTestId('error-message')
};

});
const $4b81b655080e9ffd$export$94514aa565518249 = '1w 1m';
const $4b81b655080e9ffd$export$38009905af1d42b = 'Invalid data';
const $4b81b655080e9ffd$export$7c86105e5fb6a1ce = 'issue-time-estimate.ui.edit.';



const $967029f3aa14c1ce$export$d7ed3a061805d786 = 'log-work-time-remaining';
const $967029f3aa14c1ce$export$81fee17d19007357 = 'log-work-time-spent';
const $967029f3aa14c1ce$export$ade7f171d00a976f = 'log-work-date-field';
const $967029f3aa14c1ce$export$caca24db5cb49b68 = 'log-work-description';

parcelRegister("k4Xhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef64d5d80c7a7ad$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6ef64d5d80c7a7ad$var$messages = (0, $7VHMR.defineMessages)({
    timeSpent: {
        "id": "issue-create-commons.log-work-field.time-spent",
        "defaultMessage": "Time Spent"
    },
    timeRemaining: {
        "id": "issue-create-commons.log-work-field.time-remaining",
        "defaultMessage": "Time Remaining"
    },
    dateStarted: {
        "id": "issue-create-commons.log-work-field.date-started",
        "defaultMessage": "Date Started"
    },
    description: {
        "id": "issue-create-commons.log-work-field.description",
        "defaultMessage": "Work Description"
    },
    originalEstimateExceededNonFinal: {
        "id": "issue-create-commons.log-work-field.original-estimate-exceeded-non-final",
        "defaultMessage": "Time logged has exceeded the original estimate"
    },
    logWorkLabel: {
        "id": "issue-create-commons.log-work-field.log-work-label",
        "defaultMessage": "Log Work"
    }
});
var $6ef64d5d80c7a7ad$export$2e2bcd8739ae039 = $6ef64d5d80c7a7ad$var$messages;

});



parcelRegister("3gK8l", function(module, exports) {

$parcel$export(module.exports, "ParentLinkField", () => $57dcc644784339f9$export$79fe3354f3cc0f9b);

var $5uXOq = parcelRequire("5uXOq");

var $6XTA9 = parcelRequire("6XTA9");
const $57dcc644784339f9$export$79fe3354f3cc0f9b = ({ useFormContext: useFormContext, ...commonParentLinkFieldProps })=>{
    const [{ isEpicLinkSelected: isEpicLinkSelected, selectedIssueType: selectedIssueType, requestBackedIssueType: requestBackedIssueType }] = useFormContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XTA9.default), {
        ...commonParentLinkFieldProps,
        isEpicLinkSelected: isEpicLinkSelected,
        selectedIssueTypeLabel: requestBackedIssueType?.label ?? selectedIssueType?.label ?? '',
        selectedIssueTypeId: requestBackedIssueType?.value ?? selectedIssueType?.value ?? ''
    });
};

});
parcelRegister("6XTA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5853e32e3198f692$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $TzSzf = parcelRequire("TzSzf");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $2QUn6 = parcelRequire("2QUn6");
const $5853e32e3198f692$var$ParentLinkField = (props)=>{
    const { width: width } = props;
    // We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
    // use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TzSzf.DisabledEpicLinkParentLinkField), null));
};
var $5853e32e3198f692$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $2QUn6.validateParentLinkField)
})($5853e32e3198f692$var$ParentLinkField);

});
parcelRegister("2QUn6", function(module, exports) {

$parcel$export(module.exports, "validateParentLinkField", () => $28e5f4df5488b2e7$export$7c8f88cf8f7b8100);

var $bGrWH = parcelRequire("bGrWH");
const $28e5f4df5488b2e7$export$7c8f88cf8f7b8100 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});



parcelRegister("kpa4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77adb5d87fa1f45$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");

var $8cxH7 = parcelRequire("8cxH7");

var $f1o4d = parcelRequire("f1o4d");

const $a77adb5d87fa1f45$var$SecurityLevelField = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fieldId: fieldId, fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, inputId: inputId } = props;
    const option = (0, $f1o4d.mapOptionsToData)(allowedValues);
    const isInvalid = Boolean(error);
    const getSecurityLevelField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            inputId: inputId,
            ...fieldProps,
            options: option,
            // @ts-expect-error - TS2322 - Type '(value: SecurityLevelOption) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, $8cxH7.default).securityLevelFieldPlaceHolder),
            isClearable: true,
            formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            styles: (0, $lElIo.defaultSelectStyles),
            hideSelectedOptions: false,
            isMulti: false,
            autoFocus: autoFocus,
            // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
            validationState: isInvalid === true ? 'error' : null,
            classNamePrefix: `select-${fieldId}`,
            // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type 'boolean | EventListener | undefined'.
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getSecurityLevelField()) : getSecurityLevelField());
};
var $a77adb5d87fa1f45$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $f1o4d.mapOptionToData)
})($a77adb5d87fa1f45$var$SecurityLevelField);

});
parcelRegister("8cxH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee29cf370f60177f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee29cf370f60177f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    securityLevelFieldPlaceHolder: {
        "id": "issue-create.common.fields.security-level-field.security-level-field-place-holder",
        "defaultMessage": "Select Security Level"
    }
});

});

parcelRegister("f1o4d", function(module, exports) {

$parcel$export(module.exports, "transformOnSubmit", () => $1b7192e6539d55d1$export$33ec7c3df92f1cc6);
$parcel$export(module.exports, "mapOptionsToData", () => $1b7192e6539d55d1$export$ffef3a401aef987b);
$parcel$export(module.exports, "mapOptionToData", () => $1b7192e6539d55d1$export$fc800909123977f3);
$parcel$export(module.exports, "mutateSecurityLevelField", () => $1b7192e6539d55d1$export$f62a060ad7017e66);
const $1b7192e6539d55d1$export$33ec7c3df92f1cc6 = (option)=>{
    const { label: label, value: value } = option;
    return {
        name: label,
        id: value
    };
};
const $1b7192e6539d55d1$export$ffef3a401aef987b = (options)=>options.map(({ name: name, id: id, description: description })=>({
            label: name,
            value: id,
            description: description
        }));
const $1b7192e6539d55d1$export$fc800909123977f3 = (option)=>{
    if (option) {
        const { name: name, id: id, description: description } = option;
        return {
            label: name,
            value: id,
            description: description
        };
    }
    return null;
};
const $1b7192e6539d55d1$export$f62a060ad7017e66 = (selectedSecurityLevel)=>({
        security: {
            securityLevelId: selectedSecurityLevel.value
        }
    });

});


parcelRegister("cf9Hx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e441c577a1f6260$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7C5S0 = parcelRequire("7C5S0");

var $knJGc = parcelRequire("knJGc");

var $45Cy1 = parcelRequire("45Cy1");

var $khZ39 = parcelRequire("khZ39");

var $hwq1S = parcelRequire("hwq1S");
const $7e441c577a1f6260$var$TimeTrackingField = (props)=>{
    // the reason we are transforming the default value here instead of options object in the with form field wrapper is because time tracking settings also need to be passed to transform the default value. Right now, there is no way to pass props to the generic transformDefaultValue invocation in with form field
    const [transformedDefaultValue, setTransformedDefaultValue] = (0, $5uXOq.useState)(undefined);
    const { defaultValue: defaultValue, additionalData: { timeTrackingSettings: timeTrackingSettings }, width: width = 350, isMini: isMini, isFieldResponsive: isFieldResponsive } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (typeof defaultValue === 'string') setTransformedDefaultValue(defaultValue.trim());
        else if (defaultValue?.timeInSeconds) setTransformedDefaultValue((0, $khZ39.default)(timeTrackingSettings.daysPerWeek, timeTrackingSettings.hoursPerDay)(defaultValue.timeInSeconds));
    }, [
        defaultValue,
        timeTrackingSettings.hoursPerDay,
        timeTrackingSettings.daysPerWeek
    ]);
    const [, { setTimeTrackingValue: setTimeTrackingValue }] = (0, $45Cy1.useFormContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const shouldSetWidth = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: shouldSetWidth ? '100%' : width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $knJGc.default), {
        ...props,
        fieldName: formatMessage((0, $hwq1S.default).timeTrackingFieldName),
        defaultValue: transformedDefaultValue,
        setValueExternal: setTimeTrackingValue
    }));
};
var $7e441c577a1f6260$export$2e2bcd8739ae039 = $7e441c577a1f6260$var$TimeTrackingField;

});
parcelRegister("knJGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c238289d2bd5fab1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9idvE = parcelRequire("9idvE");

var $hpV4g = parcelRequire("hpV4g");

var $2B6IQ = parcelRequire("2B6IQ");
const $c238289d2bd5fab1$export$1c882bff9d1eb3f8 = (props)=>{
    const { fieldProps: { value: value = '', onChange: onChange, ...fieldProps }, setValueExternal: setValueExternal, additionalData: { timeTrackingSettings: config }, fieldId: fieldId } = props;
    const onTimeEstimateChange = (timeEstimateValue)=>{
        onChange(timeEstimateValue);
        setValueExternal(timeEstimateValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9idvE.TimeEstimate), {
        ...fieldProps,
        fieldId: fieldId,
        value: value,
        onChange: onTimeEstimateChange,
        config: config
    });
};
var $c238289d2bd5fab1$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $2B6IQ.validateTimeTrackingField)
})($c238289d2bd5fab1$export$1c882bff9d1eb3f8);

});
parcelRegister("2B6IQ", function(module, exports) {

$parcel$export(module.exports, "validateTimeTrackingField", () => $9f226362a3a37271$export$8efa03d1ab1ed811);

var $bGrWH = parcelRequire("bGrWH");
const $9f226362a3a37271$export$8efa03d1ab1ed811 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (value === '' || value === undefined) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("hwq1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $876e840344975e9d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $876e840344975e9d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeTrackingFieldName: {
        "id": "issue-create.common.fields.time-tracking-field.time-tracking-field-name",
        "defaultMessage": "Original Estimate"
    }
});

});


parcelRegister("gsevN", function(module, exports) {

$parcel$export(module.exports, "transformTimeTrackingValueToSubmitFormat", () => $0f6af5d619112742$export$d089c9dd815e4fcf);
$parcel$export(module.exports, "mutateTimeTrackingField", () => $0f6af5d619112742$export$9b1f0b2fd734a97);
const $0f6af5d619112742$export$d089c9dd815e4fcf = (value)=>({
        originalEstimate: value
    });
const $0f6af5d619112742$export$9b1f0b2fd734a97 = (estimate)=>({
        timeTrackingField: {
            originalEstimate: estimate
        }
    });

});


parcelRegister("do1Fc", function(module, exports) {

$parcel$export(module.exports, "transformProjects", () => $b3dc6133fb5a05ec$export$227473965d2e27db);
$parcel$export(module.exports, "transformProjectField", () => $b3dc6133fb5a05ec$export$1fd74e5690ffdae3);
$parcel$export(module.exports, "transformIssueTypeField", () => $b3dc6133fb5a05ec$export$ab55267390bbb31a);
$parcel$export(module.exports, "transformRequestTypeField", () => $b3dc6133fb5a05ec$export$fdb2672a21ca2149);

var $9XE6b = parcelRequire("9XE6b");


var $3M1CO = parcelRequire("3M1CO");
const $b3dc6133fb5a05ec$export$b4c0e0af0a6f8454 = ({ id: id, name: name, avatar: avatar, projectType: projectType, simplified: simplified, key: key, classificationTags: classificationTags = [] })=>({
        label: `${name} (${key})`,
        value: id,
        iconUrl: avatar.large,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProjectType'.
        projectType: projectType && projectType.toLowerCase(),
        projectKey: key,
        isSimplified: simplified,
        classificationTags: classificationTags
    });
const $b3dc6133fb5a05ec$export$227473965d2e27db = (projects)=>projects.map((project)=>$b3dc6133fb5a05ec$export$b4c0e0af0a6f8454(project));
const $b3dc6133fb5a05ec$export$1fd74e5690ffdae3 = (projectResponse)=>{
    const { project: project, ...rest } = projectResponse;
    return {
        ...rest,
        selectedProject: project ? $b3dc6133fb5a05ec$export$b4c0e0af0a6f8454(project) : null
    };
};
const $b3dc6133fb5a05ec$export$b1a9eea64f6538d1 = ({ id: id, name: name, avatar: avatar })=>({
        label: name,
        value: id,
        iconUrl: avatar.large,
        type: (0, $4cff3ad70ea80f75$export$ebb48b08205007c5)
    });
const $b3dc6133fb5a05ec$export$4c05e2584b34e4d8 = (issueTypes)=>issueTypes.map((issueType)=>$b3dc6133fb5a05ec$export$b1a9eea64f6538d1(issueType));
const $b3dc6133fb5a05ec$export$ab55267390bbb31a = (issueTypeResponse)=>{
    const { issueType: issueType, ...rest } = issueTypeResponse;
    const issueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(issueTypeResponse, 'issueTypes.nodes', []);
    return {
        ...rest,
        selectedIssueType: issueType ? $b3dc6133fb5a05ec$export$b1a9eea64f6538d1(issueType) : null,
        issueTypes: $b3dc6133fb5a05ec$export$4c05e2584b34e4d8(issueTypes)
    };
};
const $b3dc6133fb5a05ec$export$566fd29819ab2bab = ({ requestTypeId: requestTypeId, name: name, description: description, helpText: helpText, key: key, avatar: avatar, issueType: { issueTypeId: issueTypeId, issueTypeName: issueTypeName }, practices: practices }, hasPractice)=>({
        label: name,
        description: description || '',
        helpText: helpText || '',
        value: `${issueTypeId}-${requestTypeId}`,
        iconUrl: (0, $3M1CO.transformStargateUrl)(avatar.large || ''),
        requestTypeKey: key,
        issueTypeId: issueTypeId,
        issueTypeName: issueTypeName,
        practice: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(practices, '0.key', hasPractice ? (0, $4cff3ad70ea80f75$export$c835df30ebbd529d) : (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)),
        type: (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)
    });
const $b3dc6133fb5a05ec$export$d3b8217e83b5a13c = (requestTypes)=>{
    const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
    // sort request types alphabetically
    return requestTypes.map((requestType)=>$b3dc6133fb5a05ec$export$566fd29819ab2bab(requestType, hasPractice)).sort((a, b)=>a.label.localeCompare(b.label));
};
const $b3dc6133fb5a05ec$export$fdb2672a21ca2149 = (requestTypeResponse)=>{
    const { requestType: requestType, ...rest } = requestTypeResponse;
    const requestTypes = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(requestTypeResponse, 'requestTypes.nodes', []);
    const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
    return {
        ...rest,
        selectedRequestType: requestType ? $b3dc6133fb5a05ec$export$566fd29819ab2bab(requestType, hasPractice) : null,
        requestTypes: $b3dc6133fb5a05ec$export$d3b8217e83b5a13c(requestTypes)
    };
};

});

parcelRegister("cpg5L", function(module, exports) {

$parcel$export(module.exports, "getGqlUnsupportedFields", () => $19bae1be00f46942$export$3e4be29f4f96b2d7);
$parcel$export(module.exports, "getQueryErrorMessage", () => $19bae1be00f46942$export$778f621df988f2dc);

var $9XE6b = parcelRequire("9XE6b");

const $19bae1be00f46942$export$3e4be29f4f96b2d7 = (errors)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unsupportedFields = {};
    let isRequiredFieldTypeSupported = true;
    errors.forEach(({ identifier: identifier, extensions: extensions })=>{
        const { __typename: gqlType } = extensions[0] || {};
        if (gqlType === (0, $4cff3ad70ea80f75$export$b171488d52070cb3) && // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].fieldName === 'string' && // @ts-expect-error - TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].isRequiredField === 'boolean' && // @ts-expect-error - TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].fieldType === 'string') {
            // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
            const { fieldName: fieldName, fieldType: fieldType, isRequiredField: isRequiredField } = extensions[0];
            unsupportedFields[identifier] = {
                gqlType: gqlType,
                fieldId: identifier,
                fieldName: fieldName,
                fieldType: fieldType,
                isRequired: isRequiredField
            };
            if (isRequiredField) isRequiredFieldTypeSupported = false;
        }
    });
    return {
        unsupportedFields: unsupportedFields,
        isRequiredFieldTypeSupported: isRequiredFieldTypeSupported
    };
};
const $19bae1be00f46942$export$778f621df988f2dc = (data)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const gqlIssueCreateFieldsType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.__typename', '');
    const queryErrorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.message', '');
    if (gqlIssueCreateFieldsType === (0, $4cff3ad70ea80f75$export$6c8cb487d6ffc522) && Boolean(queryErrorMessage)) return queryErrorMessage;
    const gqlIssueCreateLayoutType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateLayout.__typename', '');
    const issueCreateFieldsQueryErrorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.errors[0].extensions[0].message', '');
    if (gqlIssueCreateLayoutType === (0, $4cff3ad70ea80f75$export$6c8cb487d6ffc522) && Boolean(issueCreateFieldsQueryErrorMessage)) return issueCreateFieldsQueryErrorMessage;
    return '';
};

});

parcelRegister("ckBKW", function(module, exports) {

$parcel$export(module.exports, "overrideGqlTypes", () => $51706f093bf2a328$export$f03f31ea9e8359e8);

var $5fc53 = parcelRequire("5fc53");

const $51706f093bf2a328$export$f03f31ea9e8359e8 = (fieldData)=>{
    const { type: type, __typename: gqlType, renderer: renderer } = fieldData || {};
    if (gqlType === (0, $962656cd6986cb06$export$3849bb04b4eee607) && type === (0, $5fc53.ASSIGNEE_TYPE)) return 0, $962656cd6986cb06$export$f7a08bf17a7ac661;
    if (gqlType === (0, $962656cd6986cb06$export$3849bb04b4eee607) && type === (0, $5fc53.REPORTER_TYPE)) return 0, $962656cd6986cb06$export$d64150fd9c66969c;
    if (gqlType === (0, $962656cd6986cb06$export$1070aada56fcaec9) && type === (0, $5fc53.EPIC_COLOR_TYPE)) return 0, $962656cd6986cb06$export$f57941b9c1949a82;
    if (gqlType === (0, $962656cd6986cb06$export$31a6c27df1f927b2) && type === (0, $5fc53.MESSAGE_EDIT_CF_TYPE)) return 0, $962656cd6986cb06$export$a138d5648dda03f0;
    if (gqlType === (0, $962656cd6986cb06$export$31a6c27df1f927b2) || gqlType === (0, $962656cd6986cb06$export$7a583e2ae9052377)) return renderer === 'atlassian-wiki-renderer' ? (0, $962656cd6986cb06$export$31a6c27df1f927b2) : (0, $962656cd6986cb06$export$95433ac963f4aebe);
    // we want to keep "JiraParentIssueField" jql name for PARENT_FIELD long term when PARENT_LINK_FIELD is depricated hence this override
    if (gqlType === (0, $962656cd6986cb06$export$670384150af5f49e) && type === (0, $5fc53.PARENT_FIELD_TYPE)) return 0, $962656cd6986cb06$export$bf9df74e065af482;
    return gqlType;
};

});


parcelRegister("iT5Ia", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigQuery", () => $02ee6d5854baf467$export$6aa2f285b19806a5);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
const $02ee6d5854baf467$var$skipTernaryForIssueLinksRefinementFragment = (isInContext, isCreateLinkedIssueFromIssueViewFGOn)=>{
    if ((0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create')) return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined' : '...IssueLinksFieldFragmentRefined';
    return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment';
};
const $02ee6d5854baf467$var$skipTernaryForIssueLinksRefinementGira = (isInContext, isCreateLinkedIssueFromIssueViewFGOn)=>{
    if ((0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create')) return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED) : (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_REFINED);
    return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT);
};
const $02ee6d5854baf467$export$6aa2f285b19806a5 = ({ isInContext: isInContext, withML: withML, isCreateLinkedIssue: isCreateLinkedIssue, isCreateLinkedIssueFromIssueViewFGOn: isCreateLinkedIssueFromIssueViewFGOn, isJsmRespondersFieldEnabled: isJsmRespondersFieldEnabled })=>(0, $5cllN.default)`
    query ${isInContext ? `JiraGlobalIssueCreateInContext${isCreateLinkedIssue && isCreateLinkedIssueFromIssueViewFGOn ? 'WithCLI' : ''}` : 'JiraGlobalIssueCreateModalLoad'}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        ${isInContext ? '' : '$issueTypes: String'}
        ${isInContext ? '' : '$requestTypes: String'}
        ${isInContext ? '$additionalContext: JiraIssueCreateContextInput!' : ''}
        ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        jiraIssueCreateLayout${isInContext ? 'InContext' : ''}${withML ? 'WithML' : ''}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            ${!isInContext ? '' : 'requestType: $requestType'}
            ${isInContext ? 'additionalContext: $additionalContext' : ''}
            ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields${isInContext ? 'InContext' : ''}(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            ${isInContext ? 'additionalContext: $additionalContext' : ''}
            requestType: $requestType
            defaultValues: $defaultValues
            ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ${isInContext ? '...IssueTypeFieldFragment' : '...IssueTypeFieldSearchFragment'}
                        ${isInContext ? '...RequestTypeFieldFragment' : '...RequestTypeFieldSearchFragment'}
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${$02ee6d5854baf467$var$skipTernaryForIssueLinksRefinementFragment(isInContext, isCreateLinkedIssueFromIssueViewFGOn)}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${isInContext ? '' : '...DataClassificationFieldFragment'}
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${isJsmRespondersFieldEnabled ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $7pXhQ.LAYOUT_FRAGMENT_WITH_ML) : (0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${0, $7pXhQ.BASE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${isInContext ? (0, $7pXhQ.ISSUE_TYPE_FIELD_FRAGMENT) : (0, $7pXhQ.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${isInContext ? (0, $7pXhQ.REQUEST_TYPE_FIELD_FRAGMENT) : (0, $7pXhQ.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${0, $7pXhQ.TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.PRIORITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.SPRINT_FIELD_FRAGMENT}
    ${0, $7pXhQ.LABEL_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.SECURITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.COLOR_FIELD_FRAGMENT}
    ${0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.URL_FIELD_FRAGMENT}
    ${0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT}
    ${$02ee6d5854baf467$var$skipTernaryForIssueLinksRefinementGira(isInContext, isCreateLinkedIssueFromIssueViewFGOn)}
    ${0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $7pXhQ.CMDB_FIELD_FRAGMENT}
    ${0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ASSET_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROFORMA_CONFIG_FRAGMENT}
    ${0, $7pXhQ.STATUS_FIELD_FRAGMENT}
    ${isJsmRespondersFieldEnabled ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT}
    ${0, $7pXhQ.DATA_CLASSIFICATION_FIELD_FRAGMENT}
`;

});
parcelRegister("7pXhQ", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_FRAGMENT", () => $d7de7ad4c8d18b70$export$f625f330d228b694);
$parcel$export(module.exports, "LAYOUT_FRAGMENT_WITH_ML", () => $d7de7ad4c8d18b70$export$c62f67b4f409a5c6);
$parcel$export(module.exports, "BASE_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$e61b49f54d551a76);
$parcel$export(module.exports, "PROJECT_WITHOUT_CLASSIFICATION", () => $d7de7ad4c8d18b70$export$c697769cce672aaf);
$parcel$export(module.exports, "PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION", () => $d7de7ad4c8d18b70$export$9594a6b1142bdd10);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$5b50a50ed83e9899);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $d7de7ad4c8d18b70$export$410d36690ebc2ef6);
$parcel$export(module.exports, "TEXT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$636915305cba61ee);
$parcel$export(module.exports, "CONNECT_TEXT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$3cd5b2049171ec4c);
$parcel$export(module.exports, "FORGE_STRING_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$ebc024aa691e4d85);
$parcel$export(module.exports, "RICH_TEXT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$5b0963f21dba94f8);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$7f0a2ff1b7c9ca01);
$parcel$export(module.exports, "FORGE_OBJECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$689ca997bd170b37);
$parcel$export(module.exports, "COMPONENTS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$ab0555e54f8994f9);
$parcel$export(module.exports, "SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$28f68e0bae1ee7f3);
$parcel$export(module.exports, "FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$1f16b392b8d9b666);
$parcel$export(module.exports, "MULTI_USER_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$b2adb4bd3df183ed);
$parcel$export(module.exports, "JSM_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$fffb689cf69ab0a2);
$parcel$export(module.exports, "FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$c43dfb9e201b83a2);
$parcel$export(module.exports, "PEOPLE_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$2b791aa6cca603ee);
$parcel$export(module.exports, "JSM_PEOPLE_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$b043dc06c0d2d4f8);
$parcel$export(module.exports, "NUMBER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$874202730a4f96be);
$parcel$export(module.exports, "CONNECT_NUMBER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$82ff38b10f06144a);
$parcel$export(module.exports, "FORGE_NUMBER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$87f4b71855b27f75);
$parcel$export(module.exports, "DATE_TIME_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$bbf5ba5f74471361);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS", () => $d7de7ad4c8d18b70$export$9ef617a537d543ae);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED", () => $d7de7ad4c8d18b70$export$34262a4d713ee65e);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$dd6b1aecfb7f1473);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_REFINED", () => $d7de7ad4c8d18b70$export$94d9188aeb6b5618);
$parcel$export(module.exports, "FORGE_DATETIME_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$7009d41cc723dac);
$parcel$export(module.exports, "DATE_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$bb1ac816b515a7c);
$parcel$export(module.exports, "EPIC_LINK_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$47036e8bdf2c9326);
$parcel$export(module.exports, "LABEL_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$85cf307e24504b19);
$parcel$export(module.exports, "FORGE_STRINGS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$9255ce322dbd4481);
$parcel$export(module.exports, "VERSION_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$37deee440fbd3c5);
$parcel$export(module.exports, "MULTI_VERSION_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$ffdfaa2ab8110c87);
$parcel$export(module.exports, "PRIORITY_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$63d6d00b6349a8fd);
$parcel$export(module.exports, "ATTACHMENTS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$8ca944b20979f689);
$parcel$export(module.exports, "SECURITY_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$e0034adc460157a3);
$parcel$export(module.exports, "ISSUE_RESTRICTION_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$a4e0bff5a9855a6a);
$parcel$export(module.exports, "URL_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$55232ce79978fe60);
$parcel$export(module.exports, "CHECKBOX_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$2a0a6d36d97ce992);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$2bba3db49a112c62);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$f63043138eca54b8);
$parcel$export(module.exports, "MULTI_SELECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$494028c0baaef0a5);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$a5740cd9553dc3be);
$parcel$export(module.exports, "RADIO_SELECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$8a8492487a98fdaa);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$c525f571cbe1dcbb);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$1507bfa8951ee68d);
$parcel$export(module.exports, "FORGE_GROUP_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$51d039d4ec21f704);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$4c4a76b99fc5f54e);
$parcel$export(module.exports, "FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$ae231dc96d2638ab);
$parcel$export(module.exports, "SPRINT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$aba335b21420357f);
$parcel$export(module.exports, "COLOR_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$585571cdf68c55a1);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$201be0ff29129622);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $d7de7ad4c8d18b70$export$589a6183e9780424);
$parcel$export(module.exports, "RESOLUTION_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$31c88001934c2e15);
$parcel$export(module.exports, "CASCADING_SELECT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$2f9cfac026740bd3);
$parcel$export(module.exports, "TEAM_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$cb70b12f3de3f41c);
$parcel$export(module.exports, "ATLASSIAN_TEAM_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$1173888d99fd7ae6);
$parcel$export(module.exports, "ASSET_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$97cdf1e4b8832240);
$parcel$export(module.exports, "AFFECTED_SERVICES_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$3480d890dca64b9e);
$parcel$export(module.exports, "CMDB_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$c1864cedbeda248a);
$parcel$export(module.exports, "ORGANIZATIONS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$e0f3793fd890e0);
$parcel$export(module.exports, "TIME_TRACKING_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$f9e6189fd786f6);
$parcel$export(module.exports, "WORK_LOG_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$c6c1a1f3d6f49ea4);
$parcel$export(module.exports, "PARENT_LINK_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$fa778835050523e6);
$parcel$export(module.exports, "PARENT_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$f75050611ceb9d35);
$parcel$export(module.exports, "STATUS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$f89396a6b77b653f);
$parcel$export(module.exports, "RESPONDERS_FIELD_FRAGMENT", () => $d7de7ad4c8d18b70$export$335dcd5b86a25a15);
$parcel$export(module.exports, "PROFORMA_CONFIG_FRAGMENT", () => $d7de7ad4c8d18b70$export$5f06542accc83cb5);
$parcel$export(module.exports, "WATCHERS_CONFIG_FRAGMENT", () => $d7de7ad4c8d18b70$export$eda8fbd7533aaac1);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");
const $d7de7ad4c8d18b70$export$f625f330d228b694 = (0, $5cllN.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$c62f67b4f409a5c6 = (0, $5cllN.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					collapsedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$e61b49f54d551a76 = (0, $5cllN.default)`
	fragment BaseFieldFragment on JiraIssueField {
		fieldId
		name
		type
		description
		... on JiraIssueFieldConfiguration {
			fieldConfig {
				isRequired
				isEditable
				nonEditableReason {
					message
				}
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$c697769cce672aaf = (0, $5cllN.default)`
	fragment Project on JiraProject {
		id: projectId
		name
		avatar {
			large
		}
		projectType
		simplified
		key
	}
`;
const $d7de7ad4c8d18b70$export$9594a6b1142bdd10 = (0, $5cllN.default)`
	fragment ProjectFieldFragmentWithoutClassification on JiraProjectField {
		project {
			...Project
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$c697769cce672aaf}
`;
/* issuetype field */ const $d7de7ad4c8d18b70$var$ISSUE_TYPE = (0, $5cllN.default)`
	fragment IssueType on JiraIssueType {
		id: issueTypeId
		name
		avatar {
			large
		}
	}
`;
const $d7de7ad4c8d18b70$export$5b50a50ed83e9899 = (0, $5cllN.default)`
	fragment IssueTypeFieldFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes {
			nodes {
				...IssueType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$ISSUE_TYPE}
`;
const $d7de7ad4c8d18b70$export$410d36690ebc2ef6 = (0, $5cllN.default)`
	fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes(searchBy: $issueTypes) {
			nodes {
				...IssueType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$ISSUE_TYPE}
`;
const $d7de7ad4c8d18b70$export$636915305cba61ee = (0, $5cllN.default)`
	fragment TextFieldFragment on JiraSingleLineTextField {
		text
	}
`;
const $d7de7ad4c8d18b70$export$3cd5b2049171ec4c = (0, $5cllN.default)`
	fragment ConnectTextFieldFragment on JiraConnectTextField {
		text
	}
`;
const $d7de7ad4c8d18b70$export$ebc024aa691e4d85 = (0, $5cllN.default)`
	fragment ForgeStringFieldFragment on JiraForgeStringField {
		text
	}
`;
const $d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT = (0, $5cllN.default)`
	fragment JiraMediaContextFragment on JiraMediaContext {
		uploadToken {
			... on JiraMediaUploadToken {
				endpointUrl
				clientId
				targetCollection
				token
				tokenDurationInMin
			}
			... on QueryError {
				message
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$b9abb6c941d637fd = (0, $5cllN.default)`
	fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
		adminRichTextConfig {
			aiEnabledByProject
		}
	}
`;
const $d7de7ad4c8d18b70$export$5b0963f21dba94f8 = (0, $5cllN.default)`
	fragment RichTextFieldFragment on JiraRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
		...JiraAdminRichTextFieldConfigFragment
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
	${$d7de7ad4c8d18b70$export$b9abb6c941d637fd}
`;
const $d7de7ad4c8d18b70$export$7f0a2ff1b7c9ca01 = (0, $5cllN.default)`
	fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $d7de7ad4c8d18b70$export$689ca997bd170b37 = (0, $5cllN.default)`
	fragment ForgeObjectFieldFragment on JiraForgeObjectField {
		object
	}
`;
/* components field */ const $d7de7ad4c8d18b70$var$COMPONENT = (0, $5cllN.default)`
	fragment Component on JiraComponent {
		id: componentId
		name
	}
`;
const $d7de7ad4c8d18b70$export$ab0555e54f8994f9 = (0, $5cllN.default)`
	fragment ComponentsFieldFragment on JiraComponentsField {
		selectedComponents {
			...Component
		}
		components {
			nodes {
				...Component
			}
		}
	}
	${$d7de7ad4c8d18b70$var$COMPONENT}
`;
const $d7de7ad4c8d18b70$export$ff09b90989b21a8 = (0, $5cllN.default)`
	fragment UserFragment on User {
		accountId
		name
		picture
	}
`;
const $d7de7ad4c8d18b70$export$28f68e0bae1ee7f3 = (0, $5cllN.default)`
	fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$1f16b392b8d9b666 = (0, $5cllN.default)`
	fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$b2adb4bd3df183ed = (0, $5cllN.default)`
	fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$fffb689cf69ab0a2 = (0, $5cllN.default)`
	fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$c43dfb9e201b83a2 = (0, $5cllN.default)`
	fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$2b791aa6cca603ee = (0, $5cllN.default)`
	fragment PeopleFieldFragment on JiraPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$b043dc06c0d2d4f8 = (0, $5cllN.default)`
	fragment JsmPeopleFieldFragment on JsmPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
const $d7de7ad4c8d18b70$export$874202730a4f96be = (0, $5cllN.default)`
	fragment NumberFieldFragment on JiraNumberField {
		number
	}
`;
const $d7de7ad4c8d18b70$export$82ff38b10f06144a = (0, $5cllN.default)`
	fragment ConnectNumberFieldFragment on JiraConnectNumberField {
		number
	}
`;
const $d7de7ad4c8d18b70$export$87f4b71855b27f75 = (0, $5cllN.default)`
	fragment ForgeNumberFieldFragment on JiraForgeNumberField {
		number
	}
`;
const $d7de7ad4c8d18b70$export$bbf5ba5f74471361 = (0, $5cllN.default)`
	fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
		dateTime
	}
`;
const $d7de7ad4c8d18b70$export$9ef617a537d543ae = (0, $5cllN.default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachments on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
const $d7de7ad4c8d18b70$export$34262a4d713ee65e = (0, $5cllN.default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
const $d7de7ad4c8d18b70$export$dd6b1aecfb7f1473 = (0, $5cllN.default)`
	fragment IssueLinksFieldFragment on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$94d9188aeb6b5618 = (0, $5cllN.default)`
	fragment IssueLinksFieldFragmentRefined on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$7009d41cc723dac = (0, $5cllN.default)`
	fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
		dateTime
	}
`;
const $d7de7ad4c8d18b70$export$bb1ac816b515a7c = (0, $5cllN.default)`
	fragment DatePickerFieldFragment on JiraDatePickerField {
		date
	}
`;
const $d7de7ad4c8d18b70$export$3cb4a99a332e4186 = (0, $5cllN.default)`
	fragment Epic on JiraEpic {
		name
		key
		summary
	}
`;
const $d7de7ad4c8d18b70$export$47036e8bdf2c9326 = (0, $5cllN.default)`
	fragment EpicLinkFieldFragment on JiraEpicLinkField {
		epic {
			...Epic
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$3cb4a99a332e4186}
`;
const $d7de7ad4c8d18b70$export$37aee82a3cb1e8f7 = (0, $5cllN.default)`
	fragment Label on JiraLabel {
		id: labelId
		name
	}
`;
const $d7de7ad4c8d18b70$export$85cf307e24504b19 = (0, $5cllN.default)`
	fragment LabelFieldFragment on JiraLabelsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$37aee82a3cb1e8f7}
`;
const $d7de7ad4c8d18b70$export$9255ce322dbd4481 = (0, $5cllN.default)`
	fragment ForgeStringsFieldFragment on JiraForgeStringsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$37aee82a3cb1e8f7}
`;
/* versions field */ const $d7de7ad4c8d18b70$var$VERSION = (0, $5cllN.default)`
	fragment Version on JiraVersion {
		id: versionId
		name
		status
	}
`;
const $d7de7ad4c8d18b70$export$37deee440fbd3c5 = (0, $5cllN.default)`
	fragment VersionFieldFragment on JiraSingleVersionPickerField {
		version {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$d7de7ad4c8d18b70$var$VERSION}
`;
const $d7de7ad4c8d18b70$export$ffdfaa2ab8110c87 = (0, $5cllN.default)`
	fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
		selectedVersions {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$d7de7ad4c8d18b70$var$VERSION}
`;
/* priority field */ const $d7de7ad4c8d18b70$var$PRIORITY = (0, $5cllN.default)`
	fragment Priority on JiraPriority {
		name
		id: priorityId
		iconUrl
	}
`;
const $d7de7ad4c8d18b70$export$63d6d00b6349a8fd = (0, $5cllN.default)`
	fragment PriorityFieldFragment on JiraPriorityField {
		priority {
			...Priority
		}
		priorities {
			nodes {
				...Priority
			}
		}
	}
	${$d7de7ad4c8d18b70$var$PRIORITY}
`;
/* issue link field */ // schema needs to be updated
/* security field */ const $d7de7ad4c8d18b70$var$SECURITY_LEVEL = (0, $5cllN.default)`
	fragment SecurityLevel on JiraSecurityLevel {
		id: securityId
		name
		description
	}
`;
const $d7de7ad4c8d18b70$export$8ca944b20979f689 = (0, $5cllN.default)`
	fragment AttachmentsFieldFragment on JiraAttachmentsField {
		maxAllowedTotalAttachmentsSize
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $d7de7ad4c8d18b70$export$e0034adc460157a3 = (0, $5cllN.default)`
	fragment SecurityFieldFragment on JiraSecurityLevelField {
		securityLevel {
			...SecurityLevel
		}
		securityLevels {
			nodes {
				...SecurityLevel
			}
		}
	}
	${$d7de7ad4c8d18b70$var$SECURITY_LEVEL}
`;
/* issue restriction field */ const $d7de7ad4c8d18b70$var$USER_ROLES = (0, $5cllN.default)`
	fragment UserRoles on JiraRole {
		roleId
	}
`;
const $d7de7ad4c8d18b70$export$a4e0bff5a9855a6a = (0, $5cllN.default)`
	fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
		selectedRoles {
			...UserRoles
		}
	}
	${$d7de7ad4c8d18b70$var$USER_ROLES}
`;
const $d7de7ad4c8d18b70$export$55232ce79978fe60 = (0, $5cllN.default)`
	fragment UrlFieldFragment on JiraUrlField {
		url
	}
`;
/* checkbox field */ const $d7de7ad4c8d18b70$var$OPTION = (0, $5cllN.default)`
	fragment Option on JiraOption {
		id: optionId
		value
	}
`;
const $d7de7ad4c8d18b70$export$2a0a6d36d97ce992 = (0, $5cllN.default)`
	fragment CheckboxFieldFragment on JiraCheckboxesField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
const $d7de7ad4c8d18b70$export$2bba3db49a112c62 = (0, $5cllN.default)`
	fragment SingleSelectFieldFragment on JiraSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
const $d7de7ad4c8d18b70$export$f63043138eca54b8 = (0, $5cllN.default)`
	fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
const $d7de7ad4c8d18b70$export$494028c0baaef0a5 = (0, $5cllN.default)`
	fragment MultiSelectFieldFragment on JiraMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
const $d7de7ad4c8d18b70$export$a5740cd9553dc3be = (0, $5cllN.default)`
	fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
const $d7de7ad4c8d18b70$export$8a8492487a98fdaa = (0, $5cllN.default)`
	fragment RadioSelectFieldFragment on JiraRadioSelectField {
		selectedOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
/* data classification field */ const $d7de7ad4c8d18b70$var$CLASSIFICATION_OPTION = (0, $5cllN.default)`
	fragment ClassificationLevel on JiraClassificationLevel {
		id
		name
		color {
			colorKey
		}
		definition
		status
	}
`;
const $d7de7ad4c8d18b70$export$c525f571cbe1dcbb = (0, $5cllN.default)`
	fragment DataClassificationFieldFragment on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
	}
	${$d7de7ad4c8d18b70$var$CLASSIFICATION_OPTION}
`;
/* group picker field fragment */ const $d7de7ad4c8d18b70$var$GROUP = (0, $5cllN.default)`
	fragment Group on JiraGroup {
		groupId
		name
	}
`;
const $d7de7ad4c8d18b70$export$1507bfa8951ee68d = (0, $5cllN.default)`
	fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
const $d7de7ad4c8d18b70$export$51d039d4ec21f704 = (0, $5cllN.default)`
	fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
const $d7de7ad4c8d18b70$export$4c4a76b99fc5f54e = (0, $5cllN.default)`
	fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
const $d7de7ad4c8d18b70$export$ae231dc96d2638ab = (0, $5cllN.default)`
	fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
const $d7de7ad4c8d18b70$export$d9b12eb20c31129b = (0, $5cllN.default)`
	fragment MultiLineTextFieldFragment on JiraMultiLineTextField {
		text
	}
`;
/* sprint field */ const $d7de7ad4c8d18b70$var$SPRINT = (0, $5cllN.default)`
	fragment Sprint on JiraSprint {
		sprintId
		name
		state
	}
`;
const $d7de7ad4c8d18b70$export$aba335b21420357f = (0, $5cllN.default)`
	fragment SprintFieldFragment on JiraSprintField {
		selectedSprints {
			...Sprint
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$SPRINT}
`;
const $d7de7ad4c8d18b70$export$585571cdf68c55a1 = (0, $5cllN.default)`
	fragment ColorFieldFragment on JiraColorField {
		color {
			colorKey
		}
	}
`;
/* request type field */ const $d7de7ad4c8d18b70$var$REQUEST_TYPE = (0, $5cllN.default)`
	fragment RequestType on JsmRequestType {
		requestTypeId
		name
		description
		helpText
		key
		issueType {
			issueTypeId
		}
		avatar {
			large
		}
		practices {
			key
		}
	}
`;
const $d7de7ad4c8d18b70$export$201be0ff29129622 = (0, $5cllN.default)`
	fragment RequestTypeFieldFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes {
			nodes {
				...RequestType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$REQUEST_TYPE}
`;
const $d7de7ad4c8d18b70$export$589a6183e9780424 = (0, $5cllN.default)`
	fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes(searchBy: $requestTypes) {
			nodes {
				...RequestType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$REQUEST_TYPE}
`;
/* resolution field */ const $d7de7ad4c8d18b70$var$RESOLUTION = (0, $5cllN.default)`
	fragment Resolution on JiraResolution {
		name
		id: resolutionId
	}
`;
const $d7de7ad4c8d18b70$export$31c88001934c2e15 = (0, $5cllN.default)`
	fragment ResolutionFieldFragment on JiraResolutionField {
		resolution {
			...Resolution
		}
		resolutions {
			nodes {
				...Resolution
			}
		}
	}
	${$d7de7ad4c8d18b70$var$RESOLUTION}
`;
const $d7de7ad4c8d18b70$export$2f9cfac026740bd3 = (0, $5cllN.default)`
	fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
		cascadingOption {
			parentOptionValue {
				...Option
			}
			childOptionValue {
				...Option
			}
		}
		cascadingOptions {
			nodes {
				parentOptionValue {
					...Option
				}
				childOptionValues {
					...Option
				}
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
/* team field */ const $d7de7ad4c8d18b70$var$TEAM = (0, $5cllN.default)`
	fragment Team on JiraTeam {
		name
		teamId
	}
`;
const $d7de7ad4c8d18b70$export$cb70b12f3de3f41c = (0, $5cllN.default)`
	fragment TeamFieldFragment on JiraTeamField {
		selectedTeam {
			...Team
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$TEAM}
`;
/* Atlassian Team field */ const $d7de7ad4c8d18b70$var$ATLASSIAN_TEAM = (0, $5cllN.default)`
	fragment AtlassianTeam on JiraAtlassianTeam {
		name
		teamId
		avatar {
			small
		}
	}
`;
const $d7de7ad4c8d18b70$export$1173888d99fd7ae6 = (0, $5cllN.default)`
	fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
		JiraAtlassianTeamField: selectedTeam {
			...AtlassianTeam
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$ATLASSIAN_TEAM}
`;
/* affected services field */ const $d7de7ad4c8d18b70$var$AFFECTED_SERVICE = (0, $5cllN.default)`
	fragment AffectedService on JiraAffectedService {
		serviceId
	}
`;
const $d7de7ad4c8d18b70$var$ASSET = (0, $5cllN.default)`
	fragment Asset on JiraAsset {
		serializedOrigin
		appKey
		originId
		value
	}
`;
const $d7de7ad4c8d18b70$export$97cdf1e4b8832240 = (0, $5cllN.default)`
	fragment AssetFieldFragment on JiraAssetField {
		selectedAssets {
			...Asset
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$ASSET}
`;
const $d7de7ad4c8d18b70$export$3480d890dca64b9e = (0, $5cllN.default)`
	fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
		selectedAffectedServices {
			...AffectedService
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$AFFECTED_SERVICE}
`;
const $d7de7ad4c8d18b70$export$c1864cedbeda248a = (0, $5cllN.default)`
	fragment CMDBFieldFragment on JiraCMDBField {
		searchUrl
		isMulti
		attributesIncludedInAutoCompleteSearch
		selectedCmdbObjects {
			id
			objectId
			workspaceId
			label
		}
	}
`;
/* organizations field */ const $d7de7ad4c8d18b70$var$ORGANIZATION = (0, $5cllN.default)`
	fragment Organization on JsmOrganization {
		organizationId
		organizationName
		domain
		__typename
	}
`;
const $d7de7ad4c8d18b70$export$e0f3793fd890e0 = (0, $5cllN.default)`
	fragment OrganizationsFieldFragment on JsmOrganizationField {
		selectedOrganizations {
			...Organization
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$ORGANIZATION}
`;
const $d7de7ad4c8d18b70$export$f9e6189fd786f6 = (0, $5cllN.default)`
	fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		originalEstimate {
			timeInSeconds
		}
	}
`;
const $d7de7ad4c8d18b70$export$c6c1a1f3d6f49ea4 = (0, $5cllN.default)`
	fragment WorkLogFieldFragment on JiraWorkLogField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $d7de7ad4c8d18b70$export$825c869f7cd85da3 = (0, $5cllN.default)`
	fragment Issue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
	}
`;
const $d7de7ad4c8d18b70$export$fa778835050523e6 = (0, $5cllN.default)`
	fragment ParentLinkFieldFragment on JiraParentIssueField {
		searchUrl
		parentIssue {
			...Issue
		}
	}
	${$d7de7ad4c8d18b70$export$825c869f7cd85da3}
`;
const $d7de7ad4c8d18b70$export$4561a4960baf1b2b = (0, $5cllN.default)`
	fragment ParentIssue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
		issueColorField {
			color {
				colorKey
			}
		}
		fieldsById(ids: ["summary", "issuetype"]) {
			edges {
				node {
					... on JiraSingleLineTextField {
						text
					}
					... on JiraIssueTypeField {
						issueType {
							name
							avatar {
								xsmall
							}
						}
					}
				}
			}
		}
	}
`;
const $d7de7ad4c8d18b70$export$f75050611ceb9d35 = (0, $5cllN.default)`
	fragment ParentFieldFragment on JiraParentIssueField {
		parentIssue {
			...ParentIssue
		}
	}
	${$d7de7ad4c8d18b70$export$4561a4960baf1b2b}
`;
const $d7de7ad4c8d18b70$export$f89396a6b77b653f = (0, $5cllN.default)`
	fragment StatusFieldFragment on JiraStatusField {
		name
		description
		aliasFieldId
		__typename
	}
`;
const $d7de7ad4c8d18b70$export$335dcd5b86a25a15 = (0, $5cllN.default)`
	fragment JiraServiceManagementRespondersFieldFragment on JiraServiceManagementRespondersField {
		searchUrl
	}
`;
const $d7de7ad4c8d18b70$export$5f06542accc83cb5 = (0, $5cllN.default)`
	fragment ProformaConfigFragment on JiraIssueCreateProformaConfiguration {
		serviceId
		proforma {
			portalLink
			hasProformaForm
		}
	}
`;
const $d7de7ad4c8d18b70$export$eda8fbd7533aaac1 = (0, $5cllN.default)`
	fragment WatchersConfigFragment on JiraIssueCreateWatchersConfiguration {
		serviceId
		permissions {
			canManageWatchers
			canViewWatchers
			isAutoWatchEnabled
			isWatchersEnabled
		}
		__typename
	}
`;

});


parcelRegister("aHg9F", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQueryInContextCLI", () => $d7a55dae84178193$export$ccc20b3e0875172f);
// TODO Delete this file when cleaning migrate_gic_smart_fields_jira_labs
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $d7a55dae84178193$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $d7a55dae84178193$export$ccc20b3e0875172f = (isCreateLinkedIssue)=>(0, $5cllN.default)`
    query JiraGlobalIssueCreateInContext${isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? 'WithCLI' : ''}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        $issueCreateType: IssueCreateTypeFilter
    ) {
        jiraIssueCreateLayoutInContext(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            issueCreateType: $issueCreateType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            issueCreateType: $issueCreateType
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragmentWithCopyLinksAndAttachments
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$d7a55dae84178193$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${0, $7pXhQ.LAYOUT_FRAGMENT}
    ${0, $7pXhQ.BASE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $7pXhQ.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $7pXhQ.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.PRIORITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.SPRINT_FIELD_FRAGMENT}
    ${0, $7pXhQ.LABEL_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.SECURITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.COLOR_FIELD_FRAGMENT}
    ${0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.URL_FIELD_FRAGMENT}
    ${0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT}
    ${0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS}
    ${0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $7pXhQ.CMDB_FIELD_FRAGMENT}
    ${0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ASSET_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROFORMA_CONFIG_FRAGMENT}
    ${0, $7pXhQ.STATUS_FIELD_FRAGMENT}
    ${$d7a55dae84178193$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT}
`;

});

parcelRegister("aK8En", function(module, exports) {

$parcel$export(module.exports, "CREATE_CONFIG_USER_PREFERRED_QUERY_IN_CONTEXT", () => $71173e975c8225f1$export$e53f901243688733);
// TODO Delete this file when cleaning migrate_gic_smart_fields_jira_labs
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $71173e975c8225f1$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $71173e975c8225f1$export$e53f901243688733 = (0, $5cllN.default)`
    query JiraGlobalIssueCreateInContext(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
    ) {
        jiraIssueCreateLayoutInContext(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$71173e975c8225f1$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${(0, $7pXhQ.BASE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${(0, $7pXhQ.ISSUE_TYPE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.REQUEST_TYPE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.VERSION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PRIORITY_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SPRINT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.LABEL_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SECURITY_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.COLOR_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.URL_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.DATE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PEOPLE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TEAM_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CMDB_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ASSET_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PARENT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PROFORMA_CONFIG_FRAGMENT)}
    ${(0, $7pXhQ.STATUS_FIELD_FRAGMENT)}
    ${$71173e975c8225f1$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT)}
`;

});

parcelRegister("3MuWj", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQueryInContext", () => $506479a34d707e7f$export$edf18d1585c23939);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $506479a34d707e7f$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $506479a34d707e7f$var$skipTernaryForIssueLinksRefinementFragment = ()=>{
    if ((0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create')) return (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined' : '...IssueLinksFieldFragmentRefined';
    return (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment';
};
const $506479a34d707e7f$var$skipTernaryForIssueLinksRefinementGira = ()=>{
    if ((0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create')) return (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED) : (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_REFINED);
    return (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT);
};
const $506479a34d707e7f$export$edf18d1585c23939 = (withML, isCreateLinkedIssue)=>(0, $5cllN.default)`
    query JiraGlobalIssueCreateInContext${isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? 'WithCLI' : ''}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        ${(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        ${withML ? 'jiraIssueCreateLayoutInContextWithML' : 'jiraIssueCreateLayoutInContext'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            ${(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            ${(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${$506479a34d707e7f$var$skipTernaryForIssueLinksRefinementFragment()}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$506479a34d707e7f$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $7pXhQ.LAYOUT_FRAGMENT_WITH_ML) : (0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${0, $7pXhQ.BASE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $7pXhQ.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $7pXhQ.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.PRIORITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.SPRINT_FIELD_FRAGMENT}
    ${0, $7pXhQ.LABEL_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.SECURITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.COLOR_FIELD_FRAGMENT}
    ${0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.URL_FIELD_FRAGMENT}
    ${0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT}
    ${$506479a34d707e7f$var$skipTernaryForIssueLinksRefinementGira()}
    ${0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $7pXhQ.CMDB_FIELD_FRAGMENT}
    ${0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ASSET_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROFORMA_CONFIG_FRAGMENT}
    ${0, $7pXhQ.STATUS_FIELD_FRAGMENT}
    ${$506479a34d707e7f$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT}
`;

});


parcelRegister("fWhMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dabcfad40d4d353b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $4R6GH = parcelRequire("4R6GH");

var $8j2Ud = parcelRequire("8j2Ud");

var $h1X40 = parcelRequire("h1X40");

var $fcZ0a = parcelRequire("fcZ0a");

var $lr952 = parcelRequire("lr952");

var $iT5Ia = parcelRequire("iT5Ia");

var $8nJa2 = parcelRequire("8nJa2");

var $ct3KO = parcelRequire("ct3KO");
const $dabcfad40d4d353b$var$useFetchCreateConfigQuery = (props = {})=>{
    const { fireErrorAnalyticsEvent: fireErrorAnalyticsEvent } = (0, $h1X40.useIssueCreateErrorAnalyticsEvent)();
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false } = props;
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [fetchError, setFetchError] = (0, $5uXOq.useState)(null);
    const apiStartTime = (0, $5uXOq.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $5uXOq.useState)(0);
    const [data, setData] = (0, $5uXOq.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $lr952.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const createConfigQuery = (0, $4R6GH.fg)('new-issue-create-fetch-config-query') ? (0, $iT5Ia.getCreateConfigQuery)({
        isInContext: false,
        withML: withMachineLearning,
        isJsmRespondersFieldEnabled: (0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui')
    }) : (0, $ct3KO.getCreateConfigUserPreferredQuery)(withMachineLearning);
    const [fetchConfig] = (0, $5tTFS.useLazyQuery)((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? createConfigQuery : (0, $8nJa2.CREATE_CONFIG_USER_PREFERRED_QUERY), {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) setData((0, $fcZ0a.transformQueryResults)((0, $fcZ0a.transformQueryData)(queryData), displayOnlyRequiredFields));
            else setData((0, $fcZ0a.transformQueryResults)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            queryData, displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            fireErrorAnalyticsEvent({
                meta: {
                    id: 'useFetchCreateConfigQuery',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                // TODO: remove this from here and ensure this is moving in attibutes
                errorType: (0, $8j2Ud.handleApolloError)(error)
            });
        }
    });
    const handleFetch = (0, $5uXOq.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchConfig(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $dabcfad40d4d353b$export$2e2bcd8739ae039 = $dabcfad40d4d353b$var$useFetchCreateConfigQuery;

});
parcelRegister("h1X40", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateErrorAnalyticsEvent", () => $5541f612a719bcc7$export$a57802f0a2053450);

var $5uXOq = parcelRequire("5uXOq");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $45Cy1 = parcelRequire("45Cy1");

var $5rzqz = parcelRequire("5rzqz");

var $jJZqs = parcelRequire("jJZqs");

var $3bmti = parcelRequire("3bmti");

var $lr952 = parcelRequire("lr952");

var $6gjIc = parcelRequire("6gjIc");
const $5541f612a719bcc7$export$a57802f0a2053450 = ()=>{
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    const issueCreateMeta = (0, $3bmti.getAdditionalAttributes)();
    const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, triggerPointKey: triggerPointKey, swimlaneMode: swimlaneMode, product: product, actionSource: actionSource }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [{ selectedProject: selectedProject, canCreateAnotherIssue: canCreateAnotherIssue }] = (0, $45Cy1.useFormContext)();
    const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? (0, $5rzqz.useTriggerIssueCreateModal)() : [
        {
            minimizableModalView: undefined
        }
    ];
    const { withMachineLearning: withMachineLearning } = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $lr952.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const fireErrorAnalyticsEvent = (0, $5uXOq.useCallback)((props)=>{
        const { meta: meta, error: error, statusCode: statusCode, errorType: errorType } = props;
        (0, $6paOF.fireIssueCreateErrorAnalytics)({
            meta: meta,
            error: error,
            attributes: {
                statusCode: statusCode,
                errorType: errorType,
                isNewGIC: true,
                isCreatingAnotherIssue: canCreateAnotherIssue,
                isSubtask: isSubTaskCreationOpen,
                triggerPointKey: triggerPointKey,
                projectType: selectedProject?.projectType,
                ...selectedProject ? {
                    nextGenProject: selectedProject.isSimplified
                } : {},
                ...isGICPositioningEnabled() ? {
                    gicViewState: minimizableModalView
                } : {},
                ...(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                    isCreateLinkedIssue: isCreateLinkedIssue
                } : {},
                smartFieldsEnabled: withMachineLearning,
                swimlaneMode: swimlaneMode,
                ...product ? {
                    product: product
                } : {},
                ...actionSource ? {
                    actionSource: actionSource
                } : {},
                isValidationError: (0, $jJZqs.isValidationError)(error),
                ...(0, $4R6GH.fg)('refactor_error_analytics_for_issue_create') ? issueCreateMeta : {}
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        actionSource,
        canCreateAnotherIssue,
        isCreateLinkedIssue,
        isGICPositioningEnabled,
        isSubTaskCreationOpen,
        issueCreateMeta,
        minimizableModalView,
        product,
        selectedProject,
        swimlaneMode,
        triggerPointKey,
        withMachineLearning
    ]);
    return {
        fireErrorAnalyticsEvent: fireErrorAnalyticsEvent
    };
};

});

parcelRegister("8nJa2", function(module, exports) {

$parcel$export(module.exports, "CREATE_CONFIG_USER_PREFERRED_QUERY", () => $1b8944214c90e766$export$61c4e8e4bb09225e);
// TODO Delete this file when cleaning migrate_gic_smart_fields_jira_labs
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $1b8944214c90e766$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $1b8944214c90e766$export$61c4e8e4bb09225e = (0, $5cllN.default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        jiraIssueCreateLayout(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...DataClassificationFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$1b8944214c90e766$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${(0, $7pXhQ.BASE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${(0, $7pXhQ.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${(0, $7pXhQ.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${(0, $7pXhQ.TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.VERSION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PRIORITY_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SPRINT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.LABEL_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SECURITY_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.COLOR_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.URL_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.DATE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PEOPLE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TEAM_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CMDB_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ASSET_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PARENT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PROFORMA_CONFIG_FRAGMENT)}
    ${(0, $7pXhQ.STATUS_FIELD_FRAGMENT)}
    ${$1b8944214c90e766$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT)}
    ${(0, $7pXhQ.DATA_CLASSIFICATION_FIELD_FRAGMENT)}
`;

});

parcelRegister("ct3KO", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQuery", () => $2a8040b682b6a067$export$5181d52929b93430);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $2a8040b682b6a067$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $2a8040b682b6a067$export$5181d52929b93430 = (withML)=>(0, $5cllN.default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        ${withML ? 'jiraIssueCreateLayoutWithML' : 'jiraIssueCreateLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${(0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create') ? '...IssueLinksFieldFragmentRefined' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...DataClassificationFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$2a8040b682b6a067$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $7pXhQ.LAYOUT_FRAGMENT_WITH_ML) : (0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${0, $7pXhQ.BASE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $7pXhQ.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, $7pXhQ.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, $7pXhQ.TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.PRIORITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.SPRINT_FIELD_FRAGMENT}
    ${0, $7pXhQ.LABEL_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.SECURITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.COLOR_FIELD_FRAGMENT}
    ${0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.URL_FIELD_FRAGMENT}
    ${0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT}
    ${(0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create') ? (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_REFINED) : (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $7pXhQ.CMDB_FIELD_FRAGMENT}
    ${0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ASSET_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROFORMA_CONFIG_FRAGMENT}
    ${0, $7pXhQ.STATUS_FIELD_FRAGMENT}
    ${$2a8040b682b6a067$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT}
    ${0, $7pXhQ.DATA_CLASSIFICATION_FIELD_FRAGMENT}
`;

});


parcelRegister("gdlF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6346916455bfd3c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $8j2Ud = parcelRequire("8j2Ud");

var $fcZ0a = parcelRequire("fcZ0a");

var $lr952 = parcelRequire("lr952");

var $hnVR9 = parcelRequire("hnVR9");

var $kepJv = parcelRequire("kepJv");
const $c6346916455bfd3c$var$useFetchSubtaskCreateConfigQuery = (props = {})=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [fetchError, setFetchError] = (0, $5uXOq.useState)(null);
    const apiStartTime = (0, $5uXOq.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $5uXOq.useState)(0);
    const [data, setData] = (0, $5uXOq.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $lr952.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const [fetchSubtaskConfig] = (0, $5tTFS.useLazyQuery)((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $kepJv.getCreateSubtaskConfigUserPreferredQuery)(withMachineLearning) : (0, $hnVR9.CREATE_SUBTASK_CONFIG_USER_PREFERRED_QUERY), {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $fcZ0a.transformQueryResults)((0, $fcZ0a.tranformSubtaskData)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchSubtaskCreateConfigQuery',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    // TODO: clean up after rollout of FG issue-create-fire-error-analytics-refactor
                    errorType: (0, $8j2Ud.handleApolloError)(error),
                    triggerPointKey: // TODO: look to get this into common hook and populate it everywhere.
                    triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const handleFetch = (0, $5uXOq.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchSubtaskConfig(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $c6346916455bfd3c$export$2e2bcd8739ae039 = $c6346916455bfd3c$var$useFetchSubtaskCreateConfigQuery;

});
parcelRegister("hnVR9", function(module, exports) {

$parcel$export(module.exports, "CREATE_SUBTASK_CONFIG_USER_PREFERRED_QUERY", () => $275f5c27807eebfc$export$2eaff1450330d724);
// TODO Delete this file when cleaning migrate_gic_smart_fields_jira_labs
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $275f5c27807eebfc$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $275f5c27807eebfc$export$2eaff1450330d724 = (0, $5cllN.default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        jiraSubtaskCreationLayout(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$275f5c27807eebfc$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${(0, $7pXhQ.BASE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${(0, $7pXhQ.ISSUE_TYPE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.REQUEST_TYPE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.VERSION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PRIORITY_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SPRINT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.LABEL_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SECURITY_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.COLOR_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.URL_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.DATE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PEOPLE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TEAM_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CMDB_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.ASSET_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.PARENT_FIELD_FRAGMENT)}
    ${(0, $7pXhQ.STATUS_FIELD_FRAGMENT)}
    ${$275f5c27807eebfc$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT)}
`;

});

parcelRegister("kepJv", function(module, exports) {

$parcel$export(module.exports, "getCreateSubtaskConfigUserPreferredQuery", () => $2b2560572f933275$export$466926765053d2bb);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $7pXhQ = parcelRequire("7pXhQ");
// eslint-disable-next-line jira/ff/inline-usage
const $2b2560572f933275$var$isJsmRespondersFieldEnabled = ()=>(0, $4R6GH.fg)('jsm-responders-field-in-gicx-ui');
const $2b2560572f933275$export$466926765053d2bb = (withML)=>(0, $5cllN.default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        ${withML ? 'jiraSubtaskCreationLayoutWithML' : 'jiraSubtaskCreationLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${(0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create') ? '...IssueLinksFieldFragmentRefined' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$2b2560572f933275$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $7pXhQ.LAYOUT_FRAGMENT_WITH_ML) : (0, $7pXhQ.LAYOUT_FRAGMENT)}
    ${0, $7pXhQ.BASE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $7pXhQ.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $7pXhQ.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.COMPONENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $7pXhQ.PRIORITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.SPRINT_FIELD_FRAGMENT}
    ${0, $7pXhQ.LABEL_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.SECURITY_FIELD_FRAGMENT}
    ${0, $7pXhQ.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.COLOR_FIELD_FRAGMENT}
    ${0, $7pXhQ.RESOLUTION_FIELD_FRAGMENT}
    ${0, $7pXhQ.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.URL_FIELD_FRAGMENT}
    ${0, $7pXhQ.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_FIELD_FRAGMENT}
    ${0, $7pXhQ.DATE_TIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CHECKBOX_FIELD_FRAGMENT}
    ${(0, $4R6GH.fg)('remove_issue_links_id_query_from_issue_create') ? (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT_REFINED) : (0, $7pXhQ.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, $7pXhQ.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $7pXhQ.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $7pXhQ.CMDB_FIELD_FRAGMENT}
    ${0, $7pXhQ.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $7pXhQ.ASSET_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $7pXhQ.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $7pXhQ.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $7pXhQ.WORK_LOG_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $7pXhQ.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $7pXhQ.PARENT_FIELD_FRAGMENT}
    ${0, $7pXhQ.STATUS_FIELD_FRAGMENT}
    ${$2b2560572f933275$var$isJsmRespondersFieldEnabled() ? (0, $7pXhQ.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $7pXhQ.WATCHERS_CONFIG_FRAGMENT}
`;

});


parcelRegister("bVBVj", function(module, exports) {

$parcel$export(module.exports, "usePrefillCustomFields", () => $cd3118a2ccd39072$export$6437b2075d22652f);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $5rzqz = parcelRequire("5rzqz");

var $etnpM = parcelRequire("etnpM");

var $6G308 = parcelRequire("6G308");
const $cd3118a2ccd39072$export$6437b2075d22652f = (modalFieldConfig)=>{
    const [{ prefilledCustomFields: prefilledCustomFields }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [data, setData] = (0, $5uXOq.useState)(modalFieldConfig);
    (0, $5uXOq.useEffect)(()=>{
        if (!prefilledCustomFields || Object.keys(prefilledCustomFields).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(modalFieldConfig)) {
            setData(modalFieldConfig);
            return;
        }
        const cascadingSelectFieldParentOptions = {};
        const cascadingSelectFieldChildOptions = {};
        const nextData = {
            ...modalFieldConfig
        };
        Object.keys(prefilledCustomFields).forEach((key)=>{
            if (key in modalFieldConfig) {
                const prefilledDefaultValue = (0, $6G308.prefillCustomFieldMap)({
                    gqlType: modalFieldConfig[key].gqlType,
                    defaultValue: prefilledCustomFields[key],
                    allowedValues: modalFieldConfig[key]?.allowedValues
                });
                if (!(prefilledDefaultValue === null || prefilledDefaultValue === undefined)) nextData[key] = {
                    ...nextData[key],
                    defaultValue: prefilledDefaultValue
                };
                if (modalFieldConfig[key].gqlType === 'JiraCascadingSelectField') cascadingSelectFieldParentOptions[key] = prefilledCustomFields[key];
            } else if (key.slice(-2) === ':1') {
                const fieldId = key.slice(0, -2);
                cascadingSelectFieldChildOptions[fieldId] = prefilledCustomFields[key];
            } else if (nextData?.worklog && (0, $6G308.workLogSubFieldTypes).includes(key)) {
                const objectReturned = (0, $6G308.getWorkLogFieldValues)(key, prefilledCustomFields[key]);
                if (objectReturned === Object(objectReturned)) {
                    if (nextData.worklog?.defaultValue) nextData.worklog.defaultValue = {
                        ...nextData.worklog.defaultValue,
                        ...objectReturned
                    };
                    else nextData.worklog.defaultValue = objectReturned;
                }
            }
        });
        Object.keys(cascadingSelectFieldParentOptions).forEach((key)=>{
            const parentOptionId = cascadingSelectFieldParentOptions[key];
            const childOptionId = cascadingSelectFieldChildOptions[key];
            const prefilledDefaultValue = (0, $etnpM.getCascadingSelectFieldValue)({
                parentOptionId: parentOptionId,
                childOptionId: childOptionId,
                allowedValues: modalFieldConfig[key]?.allowedValues
            });
            nextData[key] = {
                ...nextData[key],
                defaultValue: prefilledDefaultValue || modalFieldConfig[key].defaultValue
            };
        });
        setData(nextData);
    }, [
        modalFieldConfig,
        prefilledCustomFields
    ]);
    return data;
};

});
parcelRegister("etnpM", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectFieldValue", () => $1ec545d0d50bcd1d$export$d59f0dcb07ca0790);
const $1ec545d0d50bcd1d$var$getExpectedParentOption = (parentOptionId)=>{
    if (typeof parentOptionId === 'string') return parentOptionId;
    if (typeof parentOptionId === 'number') return parentOptionId.toString();
    if (Array.isArray(parentOptionId) && parentOptionId.length > 0) return parentOptionId[0].toString();
    return null;
};
const $1ec545d0d50bcd1d$var$getExpectedParentAndChildOption = (parentOptionId, childOptionId)=>{
    const expectedParentOptionId = $1ec545d0d50bcd1d$var$getExpectedParentOption(parentOptionId);
    if (!expectedParentOptionId) return null;
    if (typeof childOptionId === 'string') return {
        parentOptionId: expectedParentOptionId,
        childOptionId: childOptionId
    };
    if (typeof childOptionId === 'number') return {
        parentOptionId: expectedParentOptionId,
        childOptionId: childOptionId.toString()
    };
    if (Array.isArray(childOptionId) && childOptionId.length > 0) return {
        parentOptionId: expectedParentOptionId,
        childOptionId: childOptionId[0].toString()
    };
    return {
        parentOptionId: expectedParentOptionId,
        childOptionId: null
    };
};
const $1ec545d0d50bcd1d$export$d59f0dcb07ca0790 = ({ parentOptionId: parentOptionId, childOptionId: childOptionId, allowedValues: allowedValues })=>{
    if (!Array.isArray(allowedValues)) return null;
    const expectedFieldValue = $1ec545d0d50bcd1d$var$getExpectedParentAndChildOption(parentOptionId, childOptionId);
    if (!expectedFieldValue) return null;
    const defaultValue = {
        parentOptionValue: null,
        childOptionValue: null,
        __typename: 'JiraCascadingOption'
    };
    for (const parentValue of allowedValues)if (parentValue.parentOptionValue.id === expectedFieldValue.parentOptionId) {
        defaultValue.parentOptionValue = parentValue.parentOptionValue;
        for (const childValue of parentValue.childOptionValues)if (childValue.id === expectedFieldValue.childOptionId) {
            defaultValue.childOptionValue = childValue;
            return defaultValue;
        }
        return defaultValue;
    }
    return null;
};

});

parcelRegister("6G308", function(module, exports) {

$parcel$export(module.exports, "prefillCustomFieldMap", () => $cbb243738764b010$export$a0ff4688b4bd0aa);
$parcel$export(module.exports, "getWorkLogFieldValues", () => $cbb243738764b010$export$910fc0c56ee210a6);
$parcel$export(module.exports, "workLogSubFieldTypes", () => $cbb243738764b010$export$b94f52a1c0256fc7);

var $7dn0D = parcelRequire("7dn0D");

var $6NTrh = parcelRequire("6NTrh");

var $2qFSV = parcelRequire("2qFSV");

var $3BxDG = parcelRequire("3BxDG");

var $91uU6 = parcelRequire("91uU6");

var $98zU9 = parcelRequire("98zU9");

var $dCkLU = parcelRequire("dCkLU");

var $5rDnT = parcelRequire("5rDnT");

var $fgZVN = parcelRequire("fgZVN");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cbb243738764b010$var$fieldMap = {
    JiraDateTimePickerField: (0, $7dn0D.getDateTimePickerFieldValue),
    JiraSingleVersionPickerField: (0, $5rDnT.getSingleVersionPickerValue),
    JiraRichTextField: (0, $98zU9.getRichTextFieldValue),
    JiraConnectRichTextField: (0, $98zU9.getRichTextFieldValue),
    JiraUrlField: (0, $fgZVN.getStringFieldValue),
    JiraSingleLineTextField: (0, $fgZVN.getStringFieldValue),
    JiraConnectTextField: (0, $fgZVN.getStringFieldValue),
    JiraNumberField: (0, $91uU6.getNumberFieldValue),
    JiraConnectNumberField: (0, $91uU6.getNumberFieldValue),
    JiraSingleSelectField: (0, $dCkLU.getSingleSelectFieldValue),
    JiraRadioSelectField: (0, $dCkLU.getSingleSelectFieldValue),
    JiraConnectSingleSelectField: (0, $dCkLU.getSingleSelectFieldValue),
    JiraCheckboxesField: (0, $2qFSV.getMultipleSelectFieldValue),
    JiraMultipleVersionPickerField: (0, $3BxDG.getMultipleVersionPickerFieldValue),
    JiraMultipleSelectField: (0, $2qFSV.getMultipleSelectFieldValue),
    JiraConnectMultipleSelectField: (0, $2qFSV.getMultipleSelectFieldValue),
    JiraLabelsField: (0, $6NTrh.getLabelsFieldValue),
    JiraDatePickerField: (0, $7dn0D.getDatePickerFieldValue),
    JiraTextAreaField: (0, $fgZVN.getStringFieldValue),
    JiraForgeNumberField: (0, $91uU6.getNumberFieldValue),
    JiraForgeDatetimeField: (0, $7dn0D.getDateTimePickerFieldValue),
    JiraForgeDateField: (0, $7dn0D.getDatePickerFieldValue),
    JiraForgeStringsField: (0, $6NTrh.getLabelsFieldValue),
    JiraForgeStringField: (0, $fgZVN.getStringFieldValue),
    JiraForgeObjectField: (0, $fgZVN.getForgeObjectFieldValue)
};
const $cbb243738764b010$export$a0ff4688b4bd0aa = ({ gqlType: gqlType, defaultValue: defaultValue, allowedValues: allowedValues })=>{
    if (typeof $cbb243738764b010$var$fieldMap[gqlType] !== 'function') return null;
    if (allowedValues) return $cbb243738764b010$var$fieldMap[gqlType]({
        defaultValue: defaultValue,
        allowedValues: allowedValues
    });
    return $cbb243738764b010$var$fieldMap[gqlType](defaultValue);
};
const $cbb243738764b010$export$910fc0c56ee210a6 = (key, input)=>{
    if (key === 'worklog_timeLogged') return {
        timeSpent: (0, $fgZVN.getStringFieldValue)(input)
    };
    if (key === 'worklog_startDate') return {
        dateValue: (0, $7dn0D.getDateTimePickerFieldValue)(input)
    };
    if (key === 'worklog_comment') return {
        description: (0, $98zU9.getRichTextFieldValue)(input)
    };
    if (key === 'timetracking_remainingestimate') return {
        timeRemaining: (0, $fgZVN.getStringFieldValue)(input)
    };
};
const $cbb243738764b010$export$b94f52a1c0256fc7 = [
    'worklog_timeLogged',
    'worklog_startDate',
    'worklog_comment',
    'timetracking_remainingestimate'
];

});
parcelRegister("7dn0D", function(module, exports) {

$parcel$export(module.exports, "getDatePickerFieldValue", () => $72f3a68263fb2f4a$export$ef420f815233cde0);
$parcel$export(module.exports, "getDateTimePickerFieldValue", () => $72f3a68263fb2f4a$export$ec8ca4015b404669);

var $as8uy = parcelRequire("as8uy");
const $72f3a68263fb2f4a$export$ef420f815233cde0 = (defaultValue)=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0 && typeof defaultValue[0] === 'string') {
        if ((0, $as8uy.findADate)(defaultValue[0])) return (0, $as8uy.findADate)(defaultValue[0])?.slice(0, 10);
    }
    if ((0, $as8uy.findADate)(defaultValue)) return (0, $as8uy.findADate)(defaultValue)?.slice(0, 10);
    return null;
};
const $72f3a68263fb2f4a$export$ec8ca4015b404669 = (defaultValue)=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0 && typeof defaultValue[0] === 'string') {
        if ((0, $as8uy.findADate)(defaultValue[0])) return (0, $as8uy.findADate)(defaultValue[0]);
    }
    return (0, $as8uy.findADate)(defaultValue);
};

});
parcelRegister("as8uy", function(module, exports) {

$parcel$export(module.exports, "findADate", () => $38d6693e4dc85ce3$export$3ce9cccf56f196eb);
const $38d6693e4dc85ce3$var$monthMap = {
    Jan: '01',
    January: '01',
    Feb: '02',
    February: '02',
    Mar: '03',
    March: '03',
    Apr: '04',
    April: '04',
    May: '05',
    Jun: '06',
    June: '06',
    Jul: '07',
    July: '07',
    Aug: '08',
    August: '08',
    Sep: '09',
    September: '09',
    Oct: '10',
    October: '10',
    Nov: '11',
    November: '11',
    Dec: '12',
    December: '12'
};
const $38d6693e4dc85ce3$var$formatDay = (day)=>{
    if (day.length === 1) return `0${day}`;
    return day;
};
const $38d6693e4dc85ce3$var$formatMonth = (month)=>{
    if ($38d6693e4dc85ce3$var$monthMap[month]) return $38d6693e4dc85ce3$var$monthMap[month];
    if (month.length === 1) return `0${month}`;
    return month;
};
const $38d6693e4dc85ce3$var$formatYear = (year)=>{
    const yearAsNumber = Number(year);
    if (yearAsNumber < 100) return yearAsNumber + 2000;
    return yearAsNumber;
};
const $38d6693e4dc85ce3$var$constructISOTime = (time)=>{
    const timeStr = time.trim();
    const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
    const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
    const match24Hour = timeStr.match(time24HourPattern);
    if (match24Hour) {
        // eslint-disable-next-line prefer-const
        let [, hours, minutes, seconds] = match24Hour;
        seconds = seconds || '00';
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    const match12Hour = timeStr.match(time12HourPattern);
    if (match12Hour) {
        let hours;
        let minutes;
        let ampm;
        [, hours, minutes, ampm] = match12Hour;
        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);
        if (ampm) {
            ampm = ampm.toLowerCase();
            if (ampm === 'pm' && hours !== 12) hours += 12;
            else if (ampm === 'am' && hours === 12) hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }
    return '00:00:00';
};
const $38d6693e4dc85ce3$var$constructISODateTime = (date)=>{
    const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
    const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
    const matchForDay = date.match(regexForDay);
    const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
    if (matchForDay) {
        const [, day, month, year, time] = matchForDay;
        let formattedDay = $38d6693e4dc85ce3$var$formatDay(day);
        let formattedMonth = $38d6693e4dc85ce3$var$formatMonth(month);
        const formattedYear = $38d6693e4dc85ce3$var$formatYear(year);
        let skipMatchingDay = false;
        if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
            formattedMonth,
            formattedDay
        ];
        else if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else skipMatchingDay = true;
        }
        if (!skipMatchingDay) {
            const isoTime = $38d6693e4dc85ce3$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
    }
    if (matchForDayWithYYYYFirst) {
        const [, year, month, day, time] = matchForDayWithYYYYFirst;
        let formattedDay = $38d6693e4dc85ce3$var$formatDay(day);
        let formattedMonth = $38d6693e4dc85ce3$var$formatMonth(month);
        const formattedYear = $38d6693e4dc85ce3$var$formatYear(year);
        if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else return null;
        }
        const isoTime = $38d6693e4dc85ce3$var$constructISOTime(time);
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
    }
    return null;
};
function $38d6693e4dc85ce3$var$convertUnixToISO(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    if (!date.getTime()) return null;
    return date.toISOString().slice(0, 19);
}
const $38d6693e4dc85ce3$export$3ce9cccf56f196eb = (defaultValue)=>{
    if (typeof defaultValue === 'number') return $38d6693e4dc85ce3$var$convertUnixToISO(defaultValue);
    if (typeof defaultValue === 'string') {
        if (Number(defaultValue)) return $38d6693e4dc85ce3$var$convertUnixToISO(Number(defaultValue));
        return $38d6693e4dc85ce3$var$constructISODateTime(defaultValue);
    }
    return null;
};

});


parcelRegister("6NTrh", function(module, exports) {

$parcel$export(module.exports, "getLabelsFieldValue", () => $5d5843626d4b267f$export$dc7bb12ca069dc65);

var $gccSB = parcelRequire("gccSB");
const $5d5843626d4b267f$export$dc7bb12ca069dc65 = (defaultValue)=>{
    if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return [
        {
            id: null,
            name: defaultValue.toString()
        }
    ];
    const constructedLabels = [];
    if (Array.isArray(defaultValue)) {
        for (const value of defaultValue)if (typeof value === 'string' || typeof value === 'number') constructedLabels.push({
            name: value.toString(),
            id: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(constructedLabels) ? null : constructedLabels;
    }
    return null;
};

});

parcelRegister("2qFSV", function(module, exports) {

$parcel$export(module.exports, "getMultipleSelectFieldValue", () => $e57cd9a9f1f7b289$export$e9f00fd2d2b5131c);

var $gccSB = parcelRequire("gccSB");
const $e57cd9a9f1f7b289$var$constructValuesArray = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    const values = [];
    for (const defaultValues of defaultValue){
        for (const isValue of allowedValues)if (isValue.id === defaultValues?.toString()) values.push({
            value: isValue.value,
            id: isValue.id
        });
    }
    return values;
};
const $e57cd9a9f1f7b289$export$e9f00fd2d2b5131c = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    let values = [];
    if (Array.isArray(allowedValues)) {
        if (Array.isArray(defaultValue)) values = $e57cd9a9f1f7b289$var$constructValuesArray({
            defaultValue: defaultValue,
            allowedValues: allowedValues
        });
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') values = $e57cd9a9f1f7b289$var$constructValuesArray({
            defaultValue: [
                defaultValue
            ],
            allowedValues: allowedValues
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(values) ? null : values;
    }
    return null;
};

});

parcelRegister("3BxDG", function(module, exports) {

$parcel$export(module.exports, "getMultipleVersionPickerFieldValue", () => $eda1ab700ba52b8e$export$949962cffa318724);

var $gccSB = parcelRequire("gccSB");
const $eda1ab700ba52b8e$var$constructValuesArray = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    const values = [];
    for (const defaultValues of defaultValue){
        for (const isValue of allowedValues)if (isValue.id === defaultValues.toString()) values.push({
            name: isValue.name,
            id: isValue.id,
            status: isValue.status
        });
    }
    return values;
};
const $eda1ab700ba52b8e$export$949962cffa318724 = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    let values = [];
    if (Array.isArray(allowedValues)) {
        if (Array.isArray(defaultValue)) values = $eda1ab700ba52b8e$var$constructValuesArray({
            defaultValue: defaultValue,
            allowedValues: allowedValues
        });
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') values = $eda1ab700ba52b8e$var$constructValuesArray({
            defaultValue: [
                defaultValue
            ],
            allowedValues: allowedValues
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(values) ? null : values;
    }
    return null;
};

});

parcelRegister("91uU6", function(module, exports) {

$parcel$export(module.exports, "getNumberFieldValue", () => $3d1926021ed90b50$export$f01b59e00fd68f64);
const $3d1926021ed90b50$export$f01b59e00fd68f64 = (value)=>{
    if (Array.isArray(value) && value.length >= 1) return Number(value[0]);
    if (typeof value === 'number' || typeof value === 'string') return Number(value);
    return null;
};

});

parcelRegister("98zU9", function(module, exports) {

$parcel$export(module.exports, "getRichTextFieldValue", () => $fc860e2fd7b544b6$export$24f9d0bf92885ed9);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");

var $dN5CS = parcelRequire("dN5CS");
const $fc860e2fd7b544b6$export$c442cd75d72477d0 = (wiki)=>{
    if (wiki === undefined) return {
        version: 1,
        type: 'doc',
        content: []
    };
    const adfTransformer = new (0, $hYNZx.JSONTransformer)();
    const wikiMarkupTransformer = new (0, $dN5CS.WikiMarkupTransformer)((0, $kOFhM.defaultSchema));
    const pmNode = wikiMarkupTransformer.parse(wiki);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return adfTransformer.encode(pmNode);
};
const $fc860e2fd7b544b6$export$9acea0de85f3957 = (field)=>{
    return field && field.type === 'doc' && Array.isArray(field.content);
};
const $fc860e2fd7b544b6$export$24f9d0bf92885ed9 = (defaultValue)=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0) {
        if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number') return $fc860e2fd7b544b6$export$c442cd75d72477d0(defaultValue[0].toString());
        if ($fc860e2fd7b544b6$export$9acea0de85f3957(defaultValue[0])) return defaultValue[0];
    }
    if (typeof defaultValue === 'string' || typeof defaultValue === 'number') // for connect we expect a simple string to be passed
    return $fc860e2fd7b544b6$export$c442cd75d72477d0(defaultValue.toString());
    if ($fc860e2fd7b544b6$export$9acea0de85f3957(defaultValue)) return defaultValue;
    return null;
};

});

parcelRegister("dCkLU", function(module, exports) {

$parcel$export(module.exports, "getSingleSelectFieldValue", () => $1c5295294666c2cc$export$6847a775f22c9956);
const $1c5295294666c2cc$var$findValueInAllowedValues = (value, allowedValues)=>{
    if (!Array.isArray(allowedValues)) return null;
    for (const isValue of allowedValues){
        if (isValue.id === value.toString()) return {
            value: isValue.value,
            id: isValue.id
        };
    }
    return null;
};
const $1c5295294666c2cc$export$6847a775f22c9956 = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0) {
        if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number') return $1c5295294666c2cc$var$findValueInAllowedValues(defaultValue[0], allowedValues);
    }
    if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return $1c5295294666c2cc$var$findValueInAllowedValues(defaultValue, allowedValues);
    return null;
};

});

parcelRegister("5rDnT", function(module, exports) {

$parcel$export(module.exports, "getSingleVersionPickerValue", () => $cc6a5291d10a9d3e$export$829c840f2c90595c);
const $cc6a5291d10a9d3e$var$getExpectedFieldValue = (defaultValue)=>{
    if (typeof defaultValue === 'string') return defaultValue;
    if (typeof defaultValue === 'number') return defaultValue.toString();
    if (Array.isArray(defaultValue) && defaultValue.length > 0) return defaultValue[0].toString();
    return null;
};
const $cc6a5291d10a9d3e$export$829c840f2c90595c = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    if (!Array.isArray(allowedValues)) return null;
    const expectedFieldValue = $cc6a5291d10a9d3e$var$getExpectedFieldValue(defaultValue);
    if (!expectedFieldValue) return null;
    for (const value of allowedValues){
        if (expectedFieldValue === value.id) return {
            id: value.id,
            status: value.status,
            name: value.name
        };
    }
    return null;
};

});

parcelRegister("fgZVN", function(module, exports) {

$parcel$export(module.exports, "getStringFieldValue", () => $31d3650d04cafb78$export$62ea57a19c685649);
$parcel$export(module.exports, "getForgeObjectFieldValue", () => $31d3650d04cafb78$export$aef33e0e296607e6);
const $31d3650d04cafb78$export$62ea57a19c685649 = (value)=>{
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return value.toString();
    if (Array.isArray(value)) return value[0].toString();
    return null;
};
const $31d3650d04cafb78$export$aef33e0e296607e6 = (value)=>{
    return JSON.stringify(value);
};

});




parcelRegister("hFu8Z", function(module, exports) {

$parcel$export(module.exports, "createIssueDismissModalEntryPoint", () => $45748b8e63ef067d$export$b59b81279190875a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $45748b8e63ef067d$export$b59b81279190875a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lgxDs")), {
        moduleId: "f800056e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lgxDs", function(module, exports) {

let $f7b52ee3fa0c5548$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7b52ee3fa0c5548$var$load("4rWe1").then(()=>parcelRequire('fT41A'));

});


parcelRegister("jagDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $92ca13d1242468b8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $k9tnV = parcelRequire("k9tnV");

var $efXp3 = parcelRequire("efXp3");
var $kxqHl = parcelRequire("kxqHl");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2P6J2 = parcelRequire("2P6J2");

var $2vSU6 = parcelRequire("2vSU6");

var $dMnMc = parcelRequire("dMnMc");

var $89LOV = parcelRequire("89LOV");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $9J85a = parcelRequire("9J85a");


var $6ikhl = parcelRequire("6ikhl");

var $gifeQ = parcelRequire("gifeQ");

var $koVbs = parcelRequire("koVbs");

var $d6dC5 = parcelRequire("d6dC5");
var $iigfj = parcelRequire("iigfj");


var $bGrWH = parcelRequire("bGrWH");

var $7C5S0 = parcelRequire("7C5S0");

var $iblgc = parcelRequire("iblgc");

var $2p4Te = parcelRequire("2p4Te");

var $2ntXc = parcelRequire("2ntXc");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $45Cy1 = parcelRequire("45Cy1");

var $kxNzI = parcelRequire("kxNzI");

var $9QJ7Z = parcelRequire("9QJ7Z");

var $63H4W = parcelRequire("63H4W");

var $hoVpn = parcelRequire("hoVpn");

var $hULKg = parcelRequire("hULKg");

var $cKWWX = parcelRequire("cKWWX");

var $5rzqz = parcelRequire("5rzqz");

var $1n4jA = parcelRequire("1n4jA");

var $cYlk7 = parcelRequire("cYlk7");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
var $2NMNM = parcelRequire("2NMNM");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $5knXz = parcelRequire("5knXz");

var $k9JTq = parcelRequire("k9JTq");

var $dCm1o = parcelRequire("dCm1o");


var $6gjIc = parcelRequire("6gjIc");

var $jhPH1 = parcelRequire("jhPH1");

var $2tPtq = parcelRequire("2tPtq");

var $jE4bA = parcelRequire("jE4bA");

var $02X4k = parcelRequire("02X4k");

var $f2cnb = parcelRequire("f2cnb");

var $fp4bR = parcelRequire("fp4bR");

var $7kEHt = parcelRequire("7kEHt");

var $cS2PJ = parcelRequire("cS2PJ");

var $13Rnw = parcelRequire("13Rnw");

var $eMaIO = parcelRequire("eMaIO");

var $iSAdX = parcelRequire("iSAdX");

var $hx2H6 = parcelRequire("hx2H6");

var $gB2JP = parcelRequire("gB2JP");

var $9TbCg = parcelRequire("9TbCg");

var $64HID = parcelRequire("64HID");

var $aPuaG = parcelRequire("aPuaG");

var $br2XI = parcelRequire("br2XI");
function $92ca13d1242468b8$var$isChildIssueTriggerPoint(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return (0, $hULKg.LIST_OF_CHILD_ISSUES_TRIGGER_POINTS).includes(key);
}
const $92ca13d1242468b8$var$CreateFormBase = (props)=>{
    const [{ sectionMessage: sectionMessage, payload: triggerIssueCreatePayload, alertsToBeLinked: alertsToBeLinked, isSubTaskCreationOpen: isSubTaskCreationOpen, disableProjectDropdown: disableProjectDropdown, disableIssueTypeDropdown: disableIssueTypeDropdown, displayHeaderActionContainer: displayHeaderActionContainer, displaySitePicker: displaySitePicker, context: context, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue, isModalLoadInContext: isModalLoadInContext, wasStateRestored: wasStateRestored, minimizableModalView: minimizableModalView, submitErrorMessage: presetSubmitErrorMessage, overrideUseRequestTypeFieldsToggleState: overrideUseRequestTypeFieldsToggleState, isMiniDesignEnabled: isMiniDesignEnabled, sessionId: sessionId, ExternalControls: ExternalControls, optOutSmartFieldIds: optOutSmartFieldIds }, { clearSectionMessage: clearSectionMessage, removeAlertFromAlertsToBeLinked: removeAlertFromAlertsToBeLinked }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { onIssueCreateSuccess: onIssueCreateSuccess, canCreateAnotherIssue: canCreateAnotherIssue = false, isLoading: isLoading, fieldConfig: fieldConfig, fieldTabs: fieldTabs, contextFields: contextFields, filteredOutModules: filteredOutModules, meta: meta, error: error, apiLatency: apiLatency, onFetchConfig: fetchConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, getFormState: getFormState, onFormFieldsReset: onFormFieldsReset, statusFieldProps: statusFieldProps, classificationFieldProps: classificationFieldProps, proformaConfiguration: proformaConfiguration, watchersConfigurations: watchersConfigurations, onResetApolloCache: onResetApolloCache, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, onSiteSelection: onSiteSelection, onProjectSelection: onProjectSelection } = props;
    const isEmbedded = (0, $1n4jA.useIsEmbedded)();
    const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)(); // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const { data: { user: currentUser } } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
    const { interactedFields: interactedFields } = (0, $jhPH1.useInteractedFields)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const [{ watchers: watchers, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } }, isSmartFieldsToggled: isSmartFieldsToggled }, { setIsForgeFieldsDetected: setIsForgeFieldsDetected, resetExpandedCollapsedArea: resetExpandedCollapsedArea, setIsSmartFieldsToggled: setIsSmartFieldsToggled }] = (0, $45Cy1.useFormContext)();
    const uiModificationsStatus = (0, $iigfj.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: formMeta, areConfiguredFieldsModified: areConfiguredFieldsModified }, { setSelectedProject: setSelectedProject, setSelectedIssueType: setSelectedIssueType, setRequestBackedIssueType: setRequestBackedIssueType, setIsEpicLinkSelected: setIsEpicLinkSelected, setSubmitting: setSubmitting, setMeta: setMeta, setSubmitErrorMessage: setSubmitErrorMessage, setSubmitFieldwiseErrors: setSubmitFieldwiseErrors, setDataFetchError: setDataFetchError, setInlineErrorMessage: setInlineErrorMessage, setIsFormDirty: setIsFormDirty, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setResetFormAction: setResetFormAction, setShouldAutoFocus: setShouldAutoFocus }] = (0, $45Cy1.useCreateFormState)();
    const [{ selectedCloudId: selectedCloudId }] = (0, $cKWWX.useSitePickerContext)();
    const [createIssue] = (0, $jE4bA.default)(selectedCloudId);
    const [fields, { dispatchFormSubmits: dispatchFormSubmits, resetState: resetState }] = (0, $6ikhl.useInlineFields)(); // This useRef needs to be first in order for shouldUseRequestTypeDefault tests to work
    const shouldUseRequestTypeDefault = (0, $5uXOq.useRef)(true);
    const retainedFieldsData = (0, $5uXOq.useRef)([]);
    const [forgeFieldBlockStatus, setForgeFieldBlockStatus] = (0, $5uXOq.useState)((0, $3e5c7761c2e3cf02$export$f86e250f1a7b07c8));
    const { formatMessage: formatMessage, formatList: formatList } = (0, $koVbs.default)();
    const [hasCreatedAnotherIssue, setHasCreatedAnotherIssue] = (0, $5uXOq.useState)(false);
    const { initialClassification: initialClassification } = classificationFieldProps || {};
    const [selectedClassification, setSelectedClassification, onClassificationOptionChange] = (0, $2ntXc.useClassificationState)(initialClassification);
    const createFormScrollRef = (0, $5uXOq.useCallback)((node)=>{
        if (!node) return;
        if (formMeta?.submitErrorMessage || hasCreatedAnotherIssue) (0, $k9tnV.default)(node, (0, $bGrWH.DEFAULT_SCROLL_OPTIONS));
    }, [
        formMeta?.submitErrorMessage,
        hasCreatedAnotherIssue
    ]);
    const resetSummary = (0, $5uXOq.useRef)(null);
    const formRef = (0, $5uXOq.useRef)();
    const previousForgeFieldsState = (0, $5uXOq.useRef)(null);
    const isRestoring = (0, $5uXOq.useRef)(wasStateRestored);
    const [selectedTransition, setSelectedTransition] = (0, $5uXOq.useState)(null);
    const onChangeSelectedTransition = (t)=>{
        const analyticsEvent = createAnalyticsEvent({});
        setSelectedTransition(t);
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'statusInGic changed');
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, {
            selectedTransition: t
        });
    };
    const formSetFieldValue = (0, $5uXOq.useRef)();
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $5knXz.useStorageEnforcement)();
    const shouldShowStatus = (0, $5uXOq.useMemo)(()=>(0, $br2XI.shouldShowStatusField)(selectedProject?.projectType, fieldConfig), [
        selectedProject,
        fieldConfig
    ]);
    const shouldShowLinkedAlerts = (0, $5uXOq.useMemo)(()=>(0, $br2XI.shouldShowLinkedAlertsField)(selectedProject?.projectType, selectedIssueType, alertsToBeLinked), [
        selectedProject?.projectType,
        selectedIssueType,
        alertsToBeLinked
    ]); // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    const shouldShowWatchers = selectedProject?.projectType !== (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT);
    const isCurrentUserAdminOfProject = (0, $4R6GH.fg)('jira_gic_inline_config_experiments_prechecks') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $br2XI.useIsCurrentUserAdminOfProject)({
        projectKey: selectedProject?.projectKey
    }) ?? false : false;
    const canConfigureIssueTypes = (0, $4R6GH.fg)('jira_gic_inline_config_experiments_prechecks') ? (0, $63H4W.canConfigureIssueTypeForProject)({
        project: selectedProject,
        isProjectAdmin: isCurrentUserAdminOfProject
    }) : false;
    const canConfigureStatuses = (0, $4R6GH.fg)('jira_gic_inline_config_experiments_prechecks') ? (0, $hoVpn.canConfigureStatusForProject)({
        project: selectedProject,
        isProjectAdmin: isCurrentUserAdminOfProject
    }) : false;
    const reloadForm = (0, $5uXOq.useCallback)((project, issueType, includeIssueTypesAndRequestTypes)=>{
        const userInputForRetentionParams = {
            formState: getFormState.current(),
            fieldConfig: fieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            retainedFieldsData: retainedFieldsData,
            initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
            selectedClassification: selectedClassification
        };
        const issueCreateTypeFilter = ()=>{
            const { issuelinks: issuelinks } = getFormState.current()?.values || {};
            return isModalLoadInContext && isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                issueCreateType: isCreateLinkedIssue ? (0, $bGrWH.ISSUE_CREATE_TYPE).linkedIssue : (0, $bGrWH.ISSUE_CREATE_TYPE).standard,
                additionalContext: {
                    linkedIssue: {
                        sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                        includeLinks: issuelinks?.includeLinks,
                        includeAttachments: issuelinks?.includeAttachments
                    }
                }
            } : {};
        };
        fetchConfig({
            variables: {
                ...(0, $br2XI.getQueryVariables)(project, issueType, (0, $br2XI.getUserInputForRetention)(userInputForRetentionParams)),
                ...includeIssueTypesAndRequestTypes ? {
                    issueTypes: triggerIssueCreatePayload?.issueTypes,
                    requestTypes: triggerIssueCreatePayload?.requestTypes
                } : {},
                ...isModalLoadInContext && {
                    additionalContext: triggerIssueCreatePayload?.additionalContext
                },
                parentId: triggerIssueCreatePayload?.parentId,
                ...issueCreateTypeFilter()
            }
        });
    }, [
        getFormState,
        fieldConfig,
        dirtyFieldsCurrentSession,
        fetchConfig,
        triggerIssueCreatePayload?.issueTypes,
        triggerIssueCreatePayload?.requestTypes,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.defaultValues,
        isModalLoadInContext,
        isCreateLinkedIssue,
        selectedClassification
    ]);
    const onProjectChange = (0, $5uXOq.useCallback)((project)=>{
        setSubmitErrorMessage('');
        setSubmitFieldwiseErrors({});
        setSelectedProject(project);
        setSelectedIssueType(null);
        setSelectedTransition(null);
        setRequestBackedIssueType(null);
        setInlineErrorMessage(null);
        setShouldAutoFocus(false);
        if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) resetExpandedCollapsedArea(); // when issue-type and request-type is null always honor request type
        shouldUseRequestTypeDefault.current = true;
        const userInputForRetentionParams = {
            formState: getFormState.current(),
            fieldConfig: fieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            retainedFieldsData: retainedFieldsData,
            initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
            selectedClassification: selectedClassification
        };
        const issueCreateTypeFilter = ()=>{
            const { issuelinks: issuelinks } = getFormState.current()?.values || {};
            return isModalLoadInContext && isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                issueCreateType: isCreateLinkedIssue ? (0, $bGrWH.ISSUE_CREATE_TYPE).linkedIssue : (0, $bGrWH.ISSUE_CREATE_TYPE).standard,
                additionalContext: {
                    linkedIssue: {
                        sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                        includeLinks: issuelinks?.includeLinks,
                        includeAttachments: issuelinks?.includeAttachments
                    }
                }
            } : {};
        };
        fetchConfig({
            variables: {
                ...(0, $br2XI.getQueryVariables)(project, null, (0, $br2XI.getUserInputForRetention)(userInputForRetentionParams)),
                parentId: triggerIssueCreatePayload?.parentId,
                ...isModalLoadInContext && {
                    additionalContext: triggerIssueCreatePayload?.additionalContext
                },
                ...issueCreateTypeFilter()
            }
        });
        setIsEpicLinkSelected(false); // Reevaulate if forge fields are detected
        setIsForgeFieldsDetected(false);
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, {
            project: project
        });
    }, [
        dirtyFieldsCurrentSession,
        fetchConfig,
        fieldConfig,
        getFormState,
        isCreateLinkedIssue,
        isModalLoadInContext,
        publish,
        setInlineErrorMessage,
        setIsEpicLinkSelected,
        setIsForgeFieldsDetected,
        setRequestBackedIssueType,
        setSelectedIssueType,
        setSelectedProject,
        setSubmitErrorMessage,
        setSubmitFieldwiseErrors,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.defaultValues,
        setShouldAutoFocus,
        resetExpandedCollapsedArea,
        selectedClassification
    ]);
    const onIssueTypeSelected = (0, $5uXOq.useCallback)((issueType)=>{
        if (selectedProject && issueType) {
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            setShouldAutoFocus(false);
            setRequestBackedIssueType(null);
            setInlineErrorMessage(null);
            if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) resetExpandedCollapsedArea(); // when issue-type is non-null always honor issue type
            shouldUseRequestTypeDefault.current = issueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44);
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const payloadDefaultValues = ()=>{
                const { projectType: projectType } = selectedProject || {};
                if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(getFormState.current()?.dirtyFields) ? {
                    defaultValues: triggerIssueCreatePayload?.defaultValues || {}
                } : {};
                return {};
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return isModalLoadInContext && isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                    issueCreateType: isCreateLinkedIssue ? (0, $bGrWH.ISSUE_CREATE_TYPE).linkedIssue : (0, $bGrWH.ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    },
                    ...payloadDefaultValues()
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, $br2XI.getQueryVariables)(selectedProject, issueType, (0, $br2XI.getUserInputForRetention)(userInputForRetentionParams)),
                    issueTypes: triggerIssueCreatePayload?.issueTypes,
                    requestTypes: triggerIssueCreatePayload?.requestTypes,
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false); // Reevaulate if forge fields are detected
            setIsForgeFieldsDetected(false);
            publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, {
                issueType: issueType
            });
        }
    }, [
        selectedProject,
        setSubmitErrorMessage,
        setSubmitFieldwiseErrors,
        setRequestBackedIssueType,
        setInlineErrorMessage,
        getFormState,
        fieldConfig,
        dirtyFieldsCurrentSession,
        fetchConfig,
        triggerIssueCreatePayload?.issueTypes,
        triggerIssueCreatePayload?.requestTypes,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.defaultValues,
        isModalLoadInContext,
        setIsEpicLinkSelected,
        setIsForgeFieldsDetected,
        publish,
        isCreateLinkedIssue,
        setShouldAutoFocus,
        resetExpandedCollapsedArea,
        selectedClassification
    ]);
    const project = contextFields.project?.selectedProject;
    const issueType = contextFields.issuetype?.selectedIssueType;
    const requestType = contextFields.requestType?.selectedRequestType;
    const inlineError = (0, $5uXOq.useMemo)(()=>(0, $br2XI.transformInlineErrorMessage)(sectionMessage), [
        sectionMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, {
            fieldConfig: fieldConfig
        });
    }, [
        publish,
        fieldConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (areConfiguredFieldsModified && selectedProject && selectedIssueType) {
            setAreConfiguredFieldsModified(false);
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return isModalLoadInContext && isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? {
                    issueCreateType: isCreateLinkedIssue ? (0, $bGrWH.ISSUE_CREATE_TYPE).linkedIssue : (0, $bGrWH.ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    }
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, $br2XI.getQueryVariables)(selectedProject, selectedIssueType, (0, $br2XI.getUserInputForRetention)(userInputForRetentionParams)),
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false);
        }
    }, [
        isModalLoadInContext,
        fetchConfig,
        fieldConfig,
        selectedProject,
        selectedIssueType,
        areConfiguredFieldsModified,
        setAreConfiguredFieldsModified,
        dirtyFieldsCurrentSession,
        retainedFieldsData,
        setIsEpicLinkSelected,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.defaultValues,
        getFormState,
        isCreateLinkedIssue,
        selectedClassification
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isRestoring.current) {
            /**
       * Wait for the field config to load before setting isRestoring to false
       * otherwise we will set it false before the project field config loads,
       * so once the field config loads we dont skip sine isRestoring would be false
       */ if (project || issueType) isRestoring.current = false;
            return;
        }
        if (project) setSelectedProject(project);
        if (issueType) {
            setSelectedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? requestType : issueType);
            setRequestBackedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? issueType : null);
        }
    }, [
        issueType,
        project,
        requestType,
        setSelectedIssueType,
        setSelectedProject,
        setRequestBackedIssueType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const newMeta = {
            ...formMeta,
            ...meta
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(formMeta, newMeta)) setMeta(newMeta);
    }, [
        formMeta,
        meta,
        setMeta
    ]);
    const { initialTransition: initialTransition, preselectedTransition: preselectedTransition } = statusFieldProps || {};
    (0, $5uXOq.useEffect)(()=>{
        setSelectedTransition(preselectedTransition || initialTransition || null);
    }, [
        initialTransition,
        preselectedTransition,
        setSelectedTransition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setSelectedClassification(initialClassification || undefined);
    }, [
        initialClassification,
        setSelectedClassification
    ]); // for error handling we need to set dataFetchError in formContext
    (0, $5uXOq.useEffect)(()=>{
        setDataFetchError(error);
    }, [
        error,
        setDataFetchError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setInlineErrorMessage(inlineError);
    }, [
        inlineError,
        setInlineErrorMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (presetSubmitErrorMessage) setSubmitErrorMessage(presetSubmitErrorMessage);
    }, [
        presetSubmitErrorMessage,
        setSubmitErrorMessage
    ]);
    (0, $02X4k.useDescriptionAnalytics)();
    const currentUIModificationsConsentState = (0, $d6dC5.useUIModificationsConsentStatus)();
    const onUIModificationsConsentRequiredMount = (analyticsEvent)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, 'jiraUiModificationsObligatoryConsent gicHidden');
    const areForgeInlineFieldsStoredOrIdle = (0, $5uXOq.useCallback)(()=>Object.values(fields).every((fieldData)=>fieldData.status === (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4) || fieldData.status === (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)), [
        fields
    ]);
    const isForgeInlineFieldsError = (0, $5uXOq.useCallback)(()=>Object.values(fields).some((fieldData)=>fieldData.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)), [
        fields
    ]);
    const showInvitePrompt = (0, $2tPtq.useInvitePrompt)(selectedProject?.projectKey);
    const sendCrossJoinThirdPartyNudge = (0, $89LOV.useCrossJoinThirdPartyNudgeExperiment)();
    const onCreateSuccess = ({ issueCreateResponse: issueCreateResponse, issueCreateFieldsUsed: issueCreateFieldsUsed, issueCreateContextUsed: issueCreateContextUsed, telemetryAttributes: telemetryAttributes = {}, collapsedFieldsLength: collapsedFieldsLength, issueType: issueTypeName })=>{
        const { key: issueKey, id: issueId, watchers: watchersResponse } = issueCreateResponse;
        onIssueCreateSuccess({
            issueKey: issueKey,
            issueId: Number(issueId),
            issueType: issueTypeName
        }, shouldShowWatchers ? watchersResponse : undefined);
        if ((0, $4R6GH.fg)('cross-join-3p-nudges')) sendCrossJoinThirdPartyNudge();
        showInvitePrompt(getFormState.current()?.values?.description);
        setSubmitting(false); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const boardId = (0, $dMnMc.getBoardId)(window.location.href);
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            sessionId: sessionId,
            issueCreateFieldsUsed: issueCreateFieldsUsed,
            issueCreateContextUsed: issueCreateContextUsed,
            boardId: boardId !== null ? Number(boardId) : undefined,
            projectType: selectedProject?.projectType,
            issueType: (0, $br2XI.getAnalyticsIssueType)(selectedIssueType),
            ...!!selectedIssueType?.value && {
                issueTypeId: selectedIssueType?.value
            },
            ...selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? {
                hasRequestType: true,
                requestTypeKey: selectedIssueType?.requestTypeKey
            } : {
                hasRequestType: false
            },
            triggerPointKey: triggerPointKey,
            ...shouldShowWatchers && {
                watchers: {
                    count: watchers?.length,
                    used: (0, $br2XI.isWatchersUsed)({
                        watchers: watchers,
                        isAutoWatchEnabled: watchersConfigurations?.isAutoWatchEnabled,
                        currentUserAccountId: currentUser.accountId
                    }),
                    ...watchersConfigurations
                }
            },
            ...shouldShowLinkedAlerts && {
                linkedAlerts: alertsToBeLinked
            },
            edition: selectedProject?.projectType && (0, $ldyPw.getEditionForProject)(selectedProject.projectType, appEditions),
            collapsedFieldsLength: collapsedFieldsLength,
            ...(0, $4R6GH.fg)('default_assignee_to_issue_creator') ? {
                assignee: {
                    assigneeDefault: (0, $br2XI.getAssigneeType)(fieldConfig?.assignee?.defaultValue?.accountId, currentUser),
                    assigneeCreated: (0, $br2XI.getAssigneeType)(getFormState.current()?.values?.assignee?.accountId, currentUser)
                }
            } : {}
        };
        if (shouldShowStatus) {
            attributes.statusInGicEnabled = true;
            if (selectedTransition && !selectedTransition.isInitial) attributes.userChangedStatusTo = selectedTransition.to?.statusCategory?.name;
        }
        if ($92ca13d1242468b8$var$isChildIssueTriggerPoint(triggerPointKey)) {
            const { parent: parent } = getFormState.current()?.values || {};
            attributes.parentId = parent?.key;
        }
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issue created', attributes);
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskSuccess', {
            task: 'createIssue',
            isNewGIC: true,
            isCreated: true,
            triggerPointKey: triggerPointKey,
            edition: selectedProject?.projectType && (0, $ldyPw.getEditionForProject)(selectedProject.projectType, appEditions),
            application: selectedProject?.projectType && (0, $efvDm.getApplicationForProject)(selectedProject.projectType),
            ...telemetryAttributes
        });
    };
    const findFirstTabIndexWithErrors = (0, $5uXOq.useCallback)((errors = {})=>{
        const index = fieldTabs.findIndex((tab)=>tab.items.find((item)=>errors && item === Object.keys(errors)[0]));
        return index > -1 ? index : 0;
    }, [
        fieldTabs
    ]);
    const onCreateFailure = ({ issueCreateError: err, telemetryAttributes: telemetryAttributes, issueType: issueTypeLabel })=>{
        setSubmitting(false); // on 4xx
        if ((0, $jJZqs.isValidationError)(err)) {
            const { message: message } = err;
            if (message && message.length) setSubmitErrorMessage(message.split('; ').join('\r\n'));
            const errors = 'errors' in err ? (0, $br2XI.transformValidationErrors)(err.errors) : undefined;
            setSubmitFieldwiseErrors(errors);
            setCurrentActiveTabIndex(findFirstTabIndexWithErrors(errors));
            const customFieldError = (0, $br2XI.isDisplayConditionCFCausingError)('errors' in err ? err.errors : [], fieldConfig, filteredOutModules);
            const issueTypeName = issueTypeLabel?.label;
            const getSingleFieldErrorMsg = ()=>{
                if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $cS2PJ.default).singleRequiredCustomFieldIssueCreationBlockIssueTerminologyRefreshM4;
                return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh : (0, $cS2PJ.default).singleRequiredCustomFieldIssueCreationBlock;
            };
            const getMultipleFieldErrorMsg = ()=>{
                if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $cS2PJ.default).multipleRequiredCustomFieldsIssueCreationBlockIssueTerminologyRefreshM4;
                return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh : (0, $cS2PJ.default).multipleRequiredCustomFieldsIssueCreationBlock;
            };
            if (customFieldError) {
                const errorMessage = customFieldError.length > 1 ? formatMessage(getMultipleFieldErrorMsg(), {
                    fieldsName: formatList(customFieldError, {
                        style: 'long',
                        type: 'conjunction'
                    }),
                    issueType: issueTypeName
                }) : formatMessage(getSingleFieldErrorMsg(), {
                    fieldName: formatList(customFieldError, {
                        style: 'short',
                        type: 'conjunction'
                    }),
                    issueType: issueTypeName
                });
                setSubmitErrorMessage(String(errorMessage));
            }
            return errors;
        } // on 5xx
        let description;
        if (isEmbedded) description = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).embeddedCreateErrorFlagDescriptionIssueTermRefresh : (0, $cS2PJ.default).embeddedCreateErrorFlagDescription;
        else description = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).createErrorFlagDescriptionIssueTermRefresh : (0, $cS2PJ.default).createErrorFlagDescription;
        showFlag({
            type: 'error',
            title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).createErrorFlagTitleIssueTermRefresh : (0, $cS2PJ.default).createErrorFlagTitle,
            description: description,
            testId: 'jira-issue-create.modal.create-form.error-flag',
            messageId: 'issue-create.ui.modal.create-form.show-flag.error',
            messageType: 'transactional'
        });
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskFail', {
            task: 'createIssue',
            isNewGIC: true,
            isCreated: true,
            triggerPointKey: triggerPointKey,
            edition: selectedProject?.projectType && (0, $ldyPw.getEditionForProject)(selectedProject.projectType, appEditions),
            application: selectedProject?.projectType && (0, $efvDm.getApplicationForProject)(selectedProject.projectType),
            ...telemetryAttributes
        });
        return undefined;
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (formData, formApi)=>{
        if (selectedProject && selectedIssueType) {
            setSubmitting(true);
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            const telemetryAttributes = {
                wasIssueCreatedWithCreateAnotherIssue: hasCreatedAnotherIssue,
                view: minimizableModalView
            };
            if (isForgeInlineFieldsError()) {
                const forgeInlineError = new (0, $jJZqs.ValidationError)('', Object.keys(fields).map((key)=>({
                        field: key,
                        error: formatMessage((0, $cS2PJ.default).createErrorForgeInlineField)
                    })));
                return onCreateFailure({
                    issueCreateError: forgeInlineError,
                    telemetryAttributes: telemetryAttributes,
                    issueType: selectedIssueType
                });
            }
            const isForgeFieldFocused = Object.values(fields).some((field)=>field.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487));
            const isForgeIframe = (el)=>el.dataset?.forgeIframe === 'true'; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const activeElement = window.document?.activeElement;
            const isForgeIframeActive = activeElement instanceof HTMLElement && isForgeIframe(activeElement); // When the user is focused on a Forge field when clicking on "submit" button in GIC
            // we need to manually trigger focus event on form button and block the form submission
            // because the fields rely on blur events to submit the value. For the UI kit fields
            // we rely on isForgeFieldFocused value, however for the custom ui fields we don't change
            // the fields state on focus events so we need to check it with isForgeIframeActive
            const shouldFocusFormButton = isForgeFieldFocused || isForgeIframeActive;
            if (shouldFocusFormButton || !areForgeInlineFieldsStoredOrIdle() && forgeFieldBlockStatus !== (0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5)) {
                if (shouldFocusFormButton) {
                    previousForgeFieldsState.current = fields;
                    (0, $gifeQ.focusFormButton)((0, $c758c3cb80bbdb5a$export$2d077da71c26c1c5));
                }
                setForgeFieldBlockStatus((0, $3e5c7761c2e3cf02$export$30daef8830f2505d));
                const timeout = setTimeout(()=>{
                    setForgeFieldBlockStatus((0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5));
                    clearTimeout(timeout);
                }, (0, $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15));
                return undefined;
            }
            try {
                const payload = {
                    formData: {
                        ...(0, $br2XI.getContextFieldsForSubmit)(selectedProject, selectedIssueType, contextFields.requestType?.fieldId),
                        ...(0, $br2XI.getParentIdForSubmit)(triggerIssueCreatePayload?.parentId),
                        ...formData
                    },
                    onSuccess: (issueCreateSuccessProps)=>onCreateSuccess({
                            ...issueCreateSuccessProps,
                            telemetryAttributes: telemetryAttributes,
                            issueType: selectedIssueType?.label
                        }),
                    fieldConfig: fieldConfig,
                    ...(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && {
                        fieldTabs: fieldTabs,
                        hasIssueAdjustmentModules: uiModificationsStatus === 'enabled'
                    },
                    ...(0, $br2XI.canSetContextForSubmit)(selectedProject, context) && {
                        context: context
                    },
                    ...(0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') && {
                        createLinkedIssuePayload: {
                            isCreateLinkedIssue: isCreateLinkedIssue,
                            sourceIssueKey: isCreateLinkedIssue ? triggerIssueCreatePayload?.defaultValues?.issueLinks?.linkedIssueKeys[0] : null
                        }
                    },
                    isSubTaskCreationOpen: isSubTaskCreationOpen,
                    triggerPointKey: triggerPointKey,
                    sessionId: sessionId,
                    interactedFields: interactedFields,
                    shouldShowStatus: shouldShowStatus
                };
                try {
                    if (selectedClassification) payload.formData.dataclassification = {
                        id: selectedClassification?.id ? (0, $2P6J2.PlatformClassificationTagAri).parse(selectedClassification.id)?.tagId : null
                    };
                } catch (e) {}
                if (shouldShowStatus && selectedTransition && !selectedTransition.isInitial) payload.transition = {
                    id: selectedTransition.id
                };
                if (shouldShowWatchers && watchersConfigurations?.canManageWatchers) {
                    payload.watchers = watchers?.map((watcher)=>watcher.accountId);
                    payload.skipAutoWatch = true;
                }
                await createIssue(payload);
                setHasCreatedAnotherIssue(false);
                const issueTypeName = selectedIssueType.label;
                if (forgeFieldBlockStatus === (0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5)) {
                    const timedoutCFS = [];
                    Object.entries(fields).forEach(([key, value])=>{
                        if (value.status === (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)) timedoutCFS.push(fieldConfig[key].fieldName);
                    });
                    const getTitle = ()=>{
                        if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $cS2PJ.default).timeoutForgeInlineFieldTitleIssueTerminologyRefreshM4;
                        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).timeoutForgeInlineFieldTitleIssueTermRefresh : (0, $cS2PJ.default).timeoutForgeInlineFieldTitle;
                    };
                    const getDesc = ()=>{
                        if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $cS2PJ.default).timeoutForgeInlineFieldDescriptionIssueTerminologyRefreshM4;
                        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cS2PJ.default).timeoutForgeInlineFieldDescriptionIssueTermRefresh : (0, $cS2PJ.default).timeoutForgeInlineFieldDescription;
                    };
                    if (timedoutCFS.length) showFlag({
                        type: 'warning',
                        title: [
                            getTitle(),
                            {
                                issueType: issueTypeName
                            }
                        ],
                        description: [
                            getDesc(),
                            {
                                fields: timedoutCFS.join(', '),
                                bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, str),
                                issueType: issueTypeName
                            }
                        ],
                        testId: 'jira-issue-create.modal.create-form.forge-timeout-flag',
                        messageId: 'issue-create.ui.modal.create-form.show-flag.warning',
                        messageType: 'transactional'
                    });
                }
                if (canCreateAnotherIssue) {
                    setShouldAutoFocus(true);
                    sectionMessage && clearSectionMessage();
                    setTimeout(()=>{
                        // reset is used instead of setFieldValue because we want to reset the summary field to it's pristine state. setFieldValue only sets the value and the fields remains dirty causing a validation error when create another issue option is checked
                        // resetSummary.current({
                        //     ...formData,
                        //     summary: '',
                        // });
                        const fieldsReset = (0, $br2XI.resetFormFieldsForCreateAnother)(formData, fieldConfig, formApi.reset);
                        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, {
                            fieldsReset: fieldsReset ?? {}
                        });
                        setSelectedTransition(statusFieldProps?.initialTransition || null);
                        setSelectedClassification(classificationFieldProps?.initialClassification || undefined);
                        onFormFieldsReset?.();
                        setHasCreatedAnotherIssue(true);
                    }, 0);
                } // Show enforcement if created JSW issue and it was a success
                const isSoftwareProjectSelected = selectedProject.projectType === 'software';
                if (isSoftwareProjectSelected) showEnforcementIfStorageIsFull({
                    delayShow: minimizableModalView === 'modal' && canCreateAnotherIssue,
                    // We only care if the issue was created for a JSW project or not
                    // rather than if the user is currently viewing a JSW project
                    shouldOnlyShowInJSWContext: false,
                    touchpoint: 'global-issue-create'
                });
                 // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                return onCreateFailure({
                    issueCreateError: err,
                    telemetryAttributes: telemetryAttributes,
                    issueType: selectedIssueType
                });
            }
        }
        resetState();
        return undefined;
    };
    (0, $5uXOq.useEffect)(()=>{
        if (forgeFieldBlockStatus !== (0, $3e5c7761c2e3cf02$export$f86e250f1a7b07c8)) {
            const isTimeout = forgeFieldBlockStatus === (0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5); // for CustomUI inline edit we need to compare fieldState in case of forced blur effect
            const customUIFieldStateCheck = previousForgeFieldsState.current !== fields;
            if (areForgeInlineFieldsStoredOrIdle() && customUIFieldStateCheck || isTimeout) {
                previousForgeFieldsState.current = fields;
                setForgeFieldBlockStatus((0, $3e5c7761c2e3cf02$export$f86e250f1a7b07c8));
                (0, $9J85a.submitForgeFormField)(formRef);
            } else dispatchFormSubmits();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        areForgeInlineFieldsStoredOrIdle,
        getFormState,
        forgeFieldBlockStatus,
        selectedTransition
    ]);
    if ((0, $4R6GH.fg)('smart_fields_gic_toggle_fg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isSmartFieldsToggled === true) {
            selectedProject && reloadForm(selectedProject, selectedIssueType, false);
            setIsSmartFieldsToggled(false);
        }
    }, [
        isSmartFieldsToggled,
        reloadForm,
        selectedIssueType,
        selectedProject,
        setIsSmartFieldsToggled
    ]);
    const onIssueCreateFormMount = (analyticsEvent)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, 'IssueCreateForm rendered');
    const handleFormDirty = (dirty)=>{
        let isDirty = dirty;
        if (dirtyFieldsCurrentSession && dirtyFieldsCurrentSession.current && Object.keys(dirtyFieldsCurrentSession.current).length) isDirty = true;
        setIsFormDirty(isDirty);
    };
    const getForm = ()=>{
        if (currentUIModificationsConsentState === (0, $0659eefb602f8f84$export$d67d63332ce3ce38)) {
            resetSummary.current = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
                onMount: onUIModificationsConsentRequiredMount
            });
        }
        if (!isLoading && meta.queryErrorMessage) {
            resetSummary.current = null;
            return null;
        }
        if (isLoading || !(selectedProject && selectedIssueType)) {
            resetSummary.current = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iblgc.default), {
                skeletonCount: 6
            });
        }
        if (fieldConfig && !meta.queryErrorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
            key: `${selectedProject.value}-${selectedIssueType.value}`,
            onSubmit: onSubmit,
            isDisabled: !meta.areRequiredFieldsSupported
        }, ({ formProps: formProps, getState: getState, dirty: dirty, reset: reset, setFieldValue: setFieldValue })=>{
            getFormState.current = getState;
            formSetFieldValue.current = setFieldValue; /**
                                                        * isFormDirty is the actual value we should use to tell if the form
                                                        * is dirty. isFormDirty comes from form-context, and is updated
                                                        * in handleFormDirty.
                                                        *
                                                        * We pass the AKForm's dirty so that handleFormDirty can use both
                                                        * AKForm's dirty and dirtyFieldsCurrentSession (from props) to set
                                                        * isFormDirty correctly by taking both into account.
                                                        *
                                                        * Note - we are using this isFormDirty in issue-create-restore to block nav there
                                                        * src/packages/issue-create/issue-create-restore/src/controllers/should-show-browser-warning/index.tsx
                                                        */ 
            handleFormDirty(dirty);
            if (!resetSummary.current) {
                resetSummary.current = reset;
                setResetFormAction(reset);
            }
            const getLayoutRenderer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7kEHt.default), {
                    fieldConfig: fieldConfig,
                    fieldTabs: fieldTabs,
                    setFieldValue: setFieldValue,
                    getFormState: getState,
                    apiLatency: apiLatency,
                    fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined,
                    optOutSmartFieldIds: optOutSmartFieldIds && (0, $4R6GH.fg)('opt_out_smart_fields_in_gic') ? optOutSmartFieldIds : undefined
                });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$WrapperDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
                ...formProps,
                id: "issue-create.ui.modal.create-form",
                ref: (ref)=>{
                    // @ts-expect-error - TS2322 - Type 'HTMLFormElement | null' is not assignable to type 'HTMLFormElement | undefined'.
                    formRef.current = ref;
                },
                noValidate: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9QJ7Z.FormApiProvider), {
                getFormState: getState,
                setFieldValue: setFieldValue
            }, getLayoutRenderer()))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
            onMount: onIssueCreateFormMount
        }));
        return null;
    };
    const onIssueTypeCreatedOrUpdated = ()=>{
        if (selectedProject) reloadForm(selectedProject, selectedIssueType, true);
    };
    const getRequestTypeFieldsLayoutPreference = ()=>// if we have request types (JSM CMP only) then we want to show the toggle
        contextFields.requestType?.requestTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iSAdX.RequestTypeFieldsLayoutPreference), {
            isRequestTypeSelected: selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44),
            onChange: ()=>selectedProject && reloadForm(selectedProject, selectedIssueType, false),
            overrideIsEnabled: overrideUseRequestTypeFieldsToggleState
        });
    const getProformaBanner = ()=>!isLoading && proformaConfiguration?.hasProformaForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13Rnw.ProformaBanner), {
            portalLink: proformaConfiguration.portalLink
        });
    const getClassificationField = ()=>classificationFieldProps?.availableClassifications?.length && classificationFieldProps.availableClassifications.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2p4Te.default), {
            allowedValues: classificationFieldProps?.availableClassifications || [],
            value: selectedClassification,
            onChange: onClassificationOptionChange,
            width: isMini ? '100%' : undefined,
            nonEditableReason: classificationFieldProps.nonEditableMessage,
            ...classificationFieldProps,
            errorMessage: formMeta?.submitFieldwiseErrors?.dataclassification
        }) : null; // memoise the issueTypes value so that a new `[]` is not passed into TypePicker per render
    const issueTypes = contextFields.issuetype?.issueTypes;
    const issueTypesMemoised = (0, $5uXOq.useMemo)(()=>issueTypes || [], [
        issueTypes
    ]);
    const projectPickerIsDisabled = isSubTaskCreationOpen || disableProjectDropdown;
    const projectProps = (0, $5uXOq.useMemo)(()=>({
            projectKey: selectedProject?.projectKey ?? '',
            projectId: selectedProject?.value ?? '',
            projectType: selectedProject?.projectType ?? null
        }), [
        selectedProject
    ]);
    const inlineConfigStatusProps = (0, $5uXOq.useMemo)(()=>({
            ...projectProps,
            issueTypeId: selectedIssueType?.value,
            canConfigureStatuses: canConfigureStatuses,
            onStatusCreatedOrUpdated: onStatusCreatedOrUpdated
        }), [
        canConfigureStatuses,
        onStatusCreatedOrUpdated,
        projectProps,
        selectedIssueType?.value
    ]);
    const oldContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMaIO.default), {
        onChange: onProjectChange,
        value: selectedProject,
        renderOptionsLimit: 25,
        skipFetchProjects: !!meta.queryErrorMessage,
        disableFetchProject: projectPickerIsDisabled,
        isDisabled: projectPickerIsDisabled,
        width: isMini ? '100%' : undefined,
        onProjectSelection: onProjectSelection
    }), isMini && selectedProject?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$MiniIssueTypeStatusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPuaG.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...projectProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64HID.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: true,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPuaG.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...projectProps,
        isMini: isMini
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.Divider), null), shouldShowStatus && statusFieldProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64HID.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: false,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxNzI.LinkedAlertsField), {
        value: alertsToBeLinked || [],
        onRemoveButtonClick: removeAlertFromAlertsToBeLinked
    }), getProformaBanner(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fp4bR.ExternalControlsRenderer), {
        externalControls: ExternalControls,
        setFieldValue: formSetFieldValue.current,
        getFormState: getFormState.current
    }), getForm());
    const hasCollapsedFields = (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>fieldTabs.some((tab)=>!!tab.collapsedItems?.length), [
        fieldTabs
    ]) : undefined; // Move this into the return statement when cleaning up gic.positioning
    const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$RelativeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$FlexWrapper, null, !isMini && (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        size: "medium",
        color: "color.text.subtlest",
        "aria-hidden": "true"
    }, formatMessage((0, $cS2PJ.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxqHl.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$RequiredMessage, {
        "aria-hidden": "true",
        isMini: !!isMini
    }, formatMessage((0, $cS2PJ.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxqHl.default), null)), displayHeaderActionContainer && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2cnb.ActionsContainer), {
        watchersConfigurations: watchersConfigurations,
        fieldConfig: fieldConfig
    })), displaySitePicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gB2JP.default), {
        onChange: onResetApolloCache,
        width: isMini ? '100%' : undefined,
        onSiteSelection: onSiteSelection
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMaIO.default), {
        onChange: onProjectChange,
        value: selectedProject,
        renderOptionsLimit: 25,
        skipFetchProjects: !!meta.queryErrorMessage,
        disableFetchProject: projectPickerIsDisabled,
        isDisabled: projectPickerIsDisabled,
        width: isMini ? '100%' : undefined,
        onProjectSelection: onProjectSelection
    }), minimizableModalView === 'mini' && selectedProject?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$MiniIssueTypeStatusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPuaG.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...projectProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64HID.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: true,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })), uiModificationsStatus !== 'enabled' && hasCollapsedFields && (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $92ca13d1242468b8$var$smartFieldMessageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TbCg.SmartFieldMessage), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPuaG.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...projectProps,
        isMini: isMini
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.Divider), null), uiModificationsStatus !== 'enabled' && hasCollapsedFields && (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TbCg.SmartFieldMessage), null), shouldShowStatus && statusFieldProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64HID.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: false,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxNzI.LinkedAlertsField), {
        value: alertsToBeLinked || [],
        onRemoveButtonClick: removeAlertFromAlertsToBeLinked
    }), getProformaBanner(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fp4bR.ExternalControlsRenderer), {
        externalControls: ExternalControls,
        setFieldValue: formSetFieldValue.current,
        getFormState: getFormState.current
    }), getForm());
    (0, $5uXOq.useEffect)(()=>{
        let forgeCustomFieldDetected = false;
        Object.values(fieldConfig).forEach((field)=>{
            if ((0, $gifeQ.isForgeCustomField)(field.fieldType)) forgeCustomFieldDetected = true;
        });
        setIsForgeFieldsDetected(forgeCustomFieldDetected);
    }, [
        fieldConfig,
        setIsForgeFieldsDetected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: createFormScrollRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: (0, $bGrWH.FORM_DROPZONE_CONTAINER_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hx2H6.default), null), isGICPositioningEnabled() ? newContent : oldContent));
};
const $92ca13d1242468b8$var$CreateForm = /*#__PURE__*/ (0, $5uXOq.memo)($92ca13d1242468b8$var$CreateFormBase);
var $92ca13d1242468b8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $92ca13d1242468b8$var$CreateForm;
const $92ca13d1242468b8$var$WrapperDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_35md1bgi _z6i1glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92ca13d1242468b8$var$RelativeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92ca13d1242468b8$var$MiniIssueTypeStatusWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _jw0lu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92ca13d1242468b8$var$RequiredMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq",
            __cmplp.isMini ? "_11c8dcr7" : "_11c82smr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92ca13d1242468b8$var$FlexWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $92ca13d1242468b8$var$smartFieldMessageWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("2P6J2", function(module, exports) {

$parcel$export(module.exports, "PlatformClassificationTagAri", () => $20e58fb74fb2b59e$export$1810bec01081467);

var $eGyuJ = parcelRequire("eGyuJ");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/platform/classification-tag/manifest.ts
var $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $eGyuJ.PlatformClassificationTagAriResourceOwner),
    resourceType: (0, $eGyuJ.PlatformClassificationTagAriResourceType),
    resourceIdSlug: "{tagId}",
    resourceIdSegmentFormats: {
        tagId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/platform/classification-tag/index.ts
var $20e58fb74fb2b59e$export$1810bec01081467 = class _PlatformClassificationTagAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._tagId = opts.resourceIdSegmentValues.tagId;
    }
    get tagId() {
        return this._tagId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.qualifier,
            platformQualifier: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.resourceOwner,
            resourceType: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.resourceType,
            resourceId: `${opts.tagId}`,
            resourceIdSegmentValues: {
                tagId: opts.tagId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts);
        return new _PlatformClassificationTagAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts);
        return new _PlatformClassificationTagAri(opts);
    }
    getVariables() {
        return {
            tagId: this.tagId
        };
    }
};

});
parcelRegister("eGyuJ", function(module, exports) {

$parcel$export(module.exports, "PlatformClassificationTagAriResourceOwner", () => $ab0fbee1183049a6$export$ee6dbd2071d3ea9f);
$parcel$export(module.exports, "PlatformClassificationTagAriResourceType", () => $ab0fbee1183049a6$export$8a038be1370dff6c);
// src/platform/classification-tag/types.ts
var $ab0fbee1183049a6$export$ee6dbd2071d3ea9f = "platform", $ab0fbee1183049a6$export$8a038be1370dff6c = "classification-tag";

});


parcelRegister("dMnMc", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fe24052863a91d57$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fe24052863a91d57$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");

var $95bh0 = parcelRequire("95bh0");

var $556I0 = parcelRequire("556I0");

var $5PyNy = parcelRequire("5PyNy");

var $79s9E = parcelRequire("79s9E");
const $fe24052863a91d57$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fe24052863a91d57$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $556I0.default).some((regex)=>regex.test(url)) || (0, $5PyNy.default).some((regex)=>regex.test(url));
const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $79s9E.default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
    if ($fe24052863a91d57$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fe24052863a91d57$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fe24052863a91d57$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $95bh0.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("556I0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("5PyNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d489e15712c5e17$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});

parcelRegister("79s9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe7a2022eaf0f59$export$2e2bcd8739ae039);

var $5PyNy = parcelRequire("5PyNy");
const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
    ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $5PyNy.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});


parcelRegister("89LOV", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinThirdPartyNudgeExperiment", () => $adfb76a030addf9e$export$5baa0011155415c5);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $hqBSi = parcelRequire("hqBSi");

var $16v4H = parcelRequire("16v4H");

var $luWgk = parcelRequire("luWgk");

var $hZeR6 = parcelRequire("hZeR6");

var $sHeNd = parcelRequire("sHeNd");

var $7xwuu = parcelRequire("7xwuu");

var $jr1Jg = parcelRequire("jr1Jg");

var $f2wzw = parcelRequire("f2wzw");

var $9t8y9 = parcelRequire("9t8y9");

var $jxW1i = parcelRequire("jxW1i");
const $adfb76a030addf9e$var$MAX_FEATURE_VISIT_COUNT = 50;
const $adfb76a030addf9e$export$5baa0011155415c5 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fireEligibilityChecked = (0, $hZeR6.useEligibilityChecked)();
    const getRequestCapabilities = (0, $f2wzw.useConfluenceRequestCapabilities)(cloudId);
    const isSite7DaysOlder = (0, $jxW1i.useSiteEligibilityCheck)(cloudId);
    const getCollaborators = (0, $sHeNd.useUsersFromCollaborationGraph)(cloudId);
    const sendThirdPartyNudge = (0, $9t8y9.usePostThirdPartyNudge)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const subProduct = (0, $16v4H.useSubProduct)();
    return (0, $5uXOq.useCallback)(()=>{
        const runExperiment = async ()=>{
            try {
                if (!licensedProducts.confluence) {
                    fireEligibilityChecked('NO_CONFLUENCE_LICENSE');
                    return;
                }
                if ((0, $luWgk.isFeatureVisited)()) return;
                if (await (0, $jr1Jg.hasConfluenceAccess)(cloudId)) {
                    fireEligibilityChecked('ALREADY_HAVE_ACCESS');
                    return;
                }
                const requestCapability = await getRequestCapabilities();
                if (!(requestCapability === 'DIRECT_ACCESS' || requestCapability === 'REQUEST_ACCESS')) {
                    fireEligibilityChecked('NOT_ELIGIBLE_FOR_REQUEST_ACCESS');
                    return;
                }
                if (!await isSite7DaysOlder()) {
                    fireEligibilityChecked('NEW_SITE_LESS_THAN_7_DAYS_OLD');
                    return;
                }
                const collaborators = await getCollaborators();
                const confluenceUsers = await (0, $7xwuu.getConfluenceUsers)(collaborators, cloudId);
                if (confluenceUsers.length === 0) {
                    fireEligibilityChecked('COLLABORATORS_HAVE_NO_ACCESS');
                    return;
                }
                const featureVisitedCount = await (0, $luWgk.getFeatureVisitedCount)(userId);
                if (featureVisitedCount >= $adfb76a030addf9e$var$MAX_FEATURE_VISIT_COUNT) return;
                // fire manual exposure as it passed all common eligibility checks
                fireEligibilityChecked('ELIGIBLE');
                // send nudge to Pi Gateway service
                sendThirdPartyNudge(featureVisitedCount, subProduct, confluenceUsers, requestCapability);
                (0, $luWgk.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinThirdPartyNudgesConfluence succeeded');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useCrossJoinThirdPartyNudgesExperiment',
                        packageName: 'jiraCrossJoinThirdPartyNudges'
                    },
                    attributes: {
                        cloudId: cloudId
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        runExperiment();
    }, [
        cloudId,
        createAnalyticsEvent,
        fireEligibilityChecked,
        getCollaborators,
        sendThirdPartyNudge,
        getRequestCapabilities,
        isSite7DaysOlder,
        userId,
        licensedProducts.confluence,
        subProduct
    ]);
};

});
parcelRegister("luWgk", function(module, exports) {

$parcel$export(module.exports, "isFeatureVisited", () => $c2791e92bdf3c748$export$262c003deb93a450);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $c2791e92bdf3c748$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $c2791e92bdf3c748$export$41554dcbb74e65ef);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");

var $iAaHO = parcelRequire("iAaHO");
const $c2791e92bdf3c748$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY = 'cross.join.third.party.nudges.jira.visited';
const $c2791e92bdf3c748$var$SNOOZE_DAYS_FOR_7_DAYS = 7;
const $c2791e92bdf3c748$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $c2791e92bdf3c748$var$crossJoinThirdPartyNudgeVisitedCache = (0, $bSSG7.createLocalStorageProvider)('cross-join-third-party-nudges-visited');
const $c2791e92bdf3c748$var$VISITED_COUNT_KEY = 'CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_COUNT';
const $c2791e92bdf3c748$export$262c003deb93a450 = ()=>{
    try {
        if ($c2791e92bdf3c748$var$getFeatureVisited()) return true;
        $c2791e92bdf3c748$export$7a91674e4b755c4b();
        if (!$c2791e92bdf3c748$var$getFeatureVisited()) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossThirdPartyJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $c2791e92bdf3c748$var$getFeatureVisited = (key = $c2791e92bdf3c748$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY)=>{
    const snoozeUntilTimestampString = $c2791e92bdf3c748$var$crossJoinThirdPartyNudgeVisitedCache.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $c2791e92bdf3c748$var$setFeatureVisited = (numOfDaysSnoozed, key = $c2791e92bdf3c748$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY)=>{
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $c2791e92bdf3c748$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $c2791e92bdf3c748$var$crossJoinThirdPartyNudgeVisitedCache.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $c2791e92bdf3c748$export$7a91674e4b755c4b = (key = $c2791e92bdf3c748$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY)=>{
    $c2791e92bdf3c748$var$setFeatureVisited($c2791e92bdf3c748$var$SNOOZE_DAYS_FOR_7_DAYS, key);
};
const $c2791e92bdf3c748$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $c2791e92bdf3c748$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $iAaHO.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $c2791e92bdf3c748$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $c2791e92bdf3c748$var$VISITED_COUNT_KEY)=>{
    await (0, $iAaHO.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};

});
parcelRegister("iAaHO", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $5b136eb73bcf42a1$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $5b136eb73bcf42a1$export$ba821ce5e177c7ef);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $5b136eb73bcf42a1$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $5b136eb73bcf42a1$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $5b136eb73bcf42a1$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $5b136eb73bcf42a1$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $5b136eb73bcf42a1$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinThirdPartyNudges'
            },
            error: error
        });
    }
};

});


parcelRegister("hZeR6", function(module, exports) {

$parcel$export(module.exports, "useEligibilityChecked", () => $d2fc73c54a7f326c$export$a751f0afaa9baa4);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $d2fc73c54a7f326c$export$a751f0afaa9baa4 = ()=>{
    const flagKey = 'cross-join-third-party-nudges';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((ineligibilityReason)=>{
        try {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
                flagKey: flagKey,
                ineligibilityReason: ineligibilityReason,
                source: 'jira-cross-join-third-party-nudges'
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useFeatureExposed',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        flagKey
    ]);
};

});

parcelRegister("sHeNd", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $865890851ea8b41c$export$b05786e1a14be004);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $90yGq = parcelRequire("90yGq");
const $865890851ea8b41c$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $865890851ea8b41c$export$b05786e1a14be004 = (cloudId)=>{
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinThirdPartyNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $865890851ea8b41c$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $eusud.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined).map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};

});

parcelRegister("7xwuu", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $85fbe192d8722db1$export$71bcfe5bb11155f7);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $85fbe192d8722db1$var$URL = '/gateway/api/growth/cross-join-third-party-nudges/get-permitted-users';
const $85fbe192d8722db1$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $7f4tk.default)($85fbe192d8722db1$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds,
                product: 'confluence'
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinThirdPartyNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $85fbe192d8722db1$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $85fbe192d8722db1$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};

});

parcelRegister("jr1Jg", function(module, exports) {

$parcel$export(module.exports, "hasConfluenceAccess", () => $e3be6f96ee20f594$export$cf2bb135927e1e46);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $e3be6f96ee20f594$var$URL = '/gateway/api/permissions/permitted';
const $e3be6f96ee20f594$export$cf2bb135927e1e46 = async (cloudId)=>{
    try {
        return $e3be6f96ee20f594$var$fetchConfluenceAccess(cloudId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'hasConfluenceAccess',
                packageName: 'jiraCrossJoinThirdPartyNudges'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Confluence permission check error');
    }
};
const $e3be6f96ee20f594$var$fetchConfluenceAccess = async (cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:confluence::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($e3be6f96ee20f594$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};

});

parcelRegister("f2wzw", function(module, exports) {

$parcel$export(module.exports, "useConfluenceRequestCapabilities", () => $514c8af6f80f74b0$export$e36a00c72925e95e);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $514c8af6f80f74b0$export$e36a00c72925e95e = (cloudId)=>{
    const resource = `ari:cloud:confluence::site/${cloudId}`;
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            return $514c8af6f80f74b0$var$fetchConfluenceRACapability(resource);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useConfluenceRequestCapabilitiesCheck',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get request capabilities error');
        }
    }, [
        resource
    ]);
};
const $514c8af6f80f74b0$var$fetchConfluenceRACapability = async (resource)=>{
    const URL = $514c8af6f80f74b0$var$getConfluenceRequestCapabilitiesUrl(resource);
    const response = await (0, $7f4tk.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities;
};
const $514c8af6f80f74b0$var$getConfluenceRequestCapabilitiesUrl = (resource)=>{
    const params = new URLSearchParams({
        resource: resource
    });
    return `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
};

});

parcelRegister("9t8y9", function(module, exports) {

$parcel$export(module.exports, "usePostThirdPartyNudge", () => $664e52f982d27623$export$f06f6b49b8907feb);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $664e52f982d27623$export$f06f6b49b8907feb = ()=>{
    return (0, $5uXOq.useCallback)(async (featureVisitedCount, subProduct, collaboratorsWithConfluenceAccess, accessCapability)=>{
        try {
            const options = {
                body: JSON.stringify({
                    featureVisitedCount: featureVisitedCount,
                    subProduct: subProduct,
                    collaborators: collaboratorsWithConfluenceAccess.map((c)=>c.id),
                    accessCapability: accessCapability
                })
            };
            return (0, $eusud.performPostRequest)('/gateway/api/pi-gateway/webhooks/frontend/jira/cross-join-third-party-nudge', options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'usePostThirdPartyNudge',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Post third party nudge error');
        }
    }, []);
};

});

parcelRegister("jxW1i", function(module, exports) {

$parcel$export(module.exports, "useSiteEligibilityCheck", () => $b1d357cabc587515$export$6d7dfd5017341421);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $jX0pr = parcelRequire("jX0pr");
const $b1d357cabc587515$export$79555f8f9058b0b6 = 'confluence.ondemand.activationDate';
const $b1d357cabc587515$export$6d7dfd5017341421 = (cloudId)=>(0, $5uXOq.useCallback)(async ()=>{
        try {
            const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
                cloudId: cloudId
            });
            return $b1d357cabc587515$var$isSite7DaysOlder(siteTraits);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useSiteEligibilityCheck',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                attributes: {
                    cloudId: cloudId,
                    errorResponse: JSON.stringify(error)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Site eligibility check error');
        }
    }, [
        cloudId
    ]);
const $b1d357cabc587515$var$isSite7DaysOlder = (traits)=>{
    const confluenceActivation = traits.find((trait)=>trait.name === $b1d357cabc587515$export$79555f8f9058b0b6);
    if (confluenceActivation?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(confluenceActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});


parcelRegister("iigfj", function(module, exports) {

$parcel$export(module.exports, "useHasFinishedLoading", () => $3730e511a9bc8ce2$export$282f17c8d715e155);
$parcel$export(module.exports, "useUiModificationsEnabledStatus", () => $3730e511a9bc8ce2$export$408eb757ebd7e139);

var $gKZoD = parcelRequire("gKZoD");

var $3sQ5x = parcelRequire("3sQ5x");

var $jrwZp = parcelRequire("jrwZp");
const $3730e511a9bc8ce2$export$282f17c8d715e155 = (0, $3sQ5x.createStateHook)((0, $jrwZp.store), {
    selector: (state)=>state.hasFinishedLoading
});
const $3730e511a9bc8ce2$export$10b49abde6eddf71 = (0, $3sQ5x.createStateHook)((0, $jrwZp.store), {
    selector: (state)=>state.shouldUiModificationsLoad
});
const $3730e511a9bc8ce2$export$408eb757ebd7e139 = (hasForgeFinishedLoading)=>{
    (0, $gKZoD.di)($3730e511a9bc8ce2$export$10b49abde6eddf71, $3730e511a9bc8ce2$export$282f17c8d715e155, (0, $jrwZp.useAdjustmentsEnabled));
    const shouldUiModificationsLoad = $3730e511a9bc8ce2$export$10b49abde6eddf71();
    const hasFinishedLoading = $3730e511a9bc8ce2$export$282f17c8d715e155();
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const uimIsEnabled = hasForgeFinishedLoading && shouldUiModificationsLoad === 'yes' && hasFinishedLoading && adjustmentsAreEnabled;
    const uimIsDisabled = hasForgeFinishedLoading && (shouldUiModificationsLoad === 'no' || hasFinishedLoading && !adjustmentsAreEnabled);
    if (uimIsEnabled) return 'enabled';
    if (uimIsDisabled) return 'disabled';
    return 'unknown';
};

});

parcelRegister("kxNzI", function(module, exports) {

$parcel$export(module.exports, "LinkedAlertsField", () => $dcd299a9344f27f3$export$9fb52de2628d6fe0);

var $5uXOq = parcelRequire("5uXOq");

var $eoC0M = parcelRequire("eoC0M");

var $b71gk = parcelRequire("b71gk");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $lfTZh = parcelRequire("lfTZh");

var $8bgG7 = parcelRequire("8bgG7");
const $dcd299a9344f27f3$export$9fb52de2628d6fe0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue.fields.linked-alerts",
        packageName: "AsyncLinkedAlertsField"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eoC0M.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        "data-testid": "issue-field-linked-alerts.field-container",
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "linked-alerts-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bgG7.AsyncLinkedAlertsField), props)))));

});
parcelRegister("eoC0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $7feb9746acf3ea52$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $2tKfK = parcelRequire("2tKfK");

var $hEySk = parcelRequire("hEySk");
/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */ const $7feb9746acf3ea52$var$ResponderNamesWrapper = ({ scope: scope, isGlobal: isGlobal = true, children: children })=>{
    const flagApi = (0, $2tKfK.default)();
    const intl = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    if (scope) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEySk.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        scope: scope,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper",
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEySk.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        isGlobal: isGlobal,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper",
        children: children
    });
};
var $7feb9746acf3ea52$export$2e2bcd8739ae039 = $7feb9746acf3ea52$var$ResponderNamesWrapper;

});
parcelRegister("2VYEV", function(module, exports) {

$parcel$export(module.exports, "useDefaultCatch", () => $06138e726543d489$export$3ab31fcc1d7c2589);

var $5uXOq = parcelRequire("5uXOq");

var $kmpOn = parcelRequire("kmpOn");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
function $06138e726543d489$export$3ab31fcc1d7c2589() {
    const reportError = (0, $cQDa6.useReportError)();
    const [error, setError] = (0, $5uXOq.useState)();
    if (error) throw error;
    return (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kmpOn)))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
            if (!(0, $aI12f.isNetworkError)(error)) return setError(new (0, $8tpNZ.EocError)(id, error));
            if (customReporter !== null) {
                const reporter = customReporter ?? reportError;
                reporter(id, error, attributes);
            }
            try {
                return httpErrorHandler?.(error);
            } catch (handlerError) {
                if (!(0, $aI12f.isNetworkError)(handlerError)) setError(new (0, $8tpNZ.EocError)(id, handlerError));
                throw handlerError;
            }
        }), [
        reportError
    ]);
}

});
parcelRegister("kmpOn", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $g7JQw = parcelRequire("g7JQw");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $ed29e25cf476d3b2$var$curry = /*#__PURE__*/ $6CA7f(function curry(fn) {
    return $g7JQw(fn.length, fn);
});
module.exports = $ed29e25cf476d3b2$var$curry;

});
parcelRegister("6CA7f", function(module, exports) {

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $4d224e922cc0a345$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $dtL0L(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $4d224e922cc0a345$var$_curry1;

});
parcelRegister("dtL0L", function(module, exports) {
function $9d027343e6afec73$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $9d027343e6afec73$var$_isPlaceholder;

});


parcelRegister("g7JQw", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $6CA7f = parcelRequire("6CA7f");

var $18myW = parcelRequire("18myW");

var $90GZI = parcelRequire("90GZI");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $bbd0dce5f5e12876$var$curryN = /*#__PURE__*/ $18myW(function curryN(length, fn) {
    if (length === 1) return $6CA7f(fn);
    return $dxgtl(length, $90GZI(length, [], fn));
});
module.exports = $bbd0dce5f5e12876$var$curryN;

});
parcelRegister("dxgtl", function(module, exports) {
function $9dab227b64b88e13$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $9dab227b64b88e13$var$_arity;

});

parcelRegister("18myW", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $0d380a4094fa43af$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $dtL0L(a) ? f2 : $6CA7f(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $dtL0L(a) && $dtL0L(b) ? f2 : $dtL0L(a) ? $6CA7f(function(_a) {
                    return fn(_a, b);
                }) : $dtL0L(b) ? $6CA7f(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $0d380a4094fa43af$var$_curry2;

});

parcelRegister("90GZI", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $01b160e2e45af68a$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$dtL0L(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$dtL0L(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $dxgtl(left, $01b160e2e45af68a$var$_curryN(length, combined, fn));
    };
}
module.exports = $01b160e2e45af68a$var$_curryN;

});



parcelRegister("8tpNZ", function(module, exports) {

$parcel$export(module.exports, "EocError", () => $d534eb2e187b068b$export$e76fc0e0bc06f4df);
function $d534eb2e187b068b$var$hasMessage(cause) {
    return typeof cause === 'object' && cause !== null && 'message' in cause;
}
class $d534eb2e187b068b$export$e76fc0e0bc06f4df extends Error {
    constructor(id, cause){
        super(`[${id}] ${$d534eb2e187b068b$var$hasMessage(cause) ? cause.message : cause}`), this.id = id, this.cause = cause;
        this.name = 'EocError';
    }
}

});

parcelRegister("cQDa6", function(module, exports) {

$parcel$export(module.exports, "useReportError", () => $c58a665a3c6a26b3$export$5a5695b638d078e7);

var $5uXOq = parcelRequire("5uXOq");

var $aI12f = parcelRequire("aI12f");

var $74BDp = parcelRequire("74BDp");
function $c58a665a3c6a26b3$export$cad78388f408899e(error) {
    if (!(0, $aI12f.isNetworkError)(error)) return true;
    return !(0, $aI12f.isHTTPError)(error);
}
const $c58a665a3c6a26b3$export$5a5695b638d078e7 = ()=>{
    const { reporterAction: reporterAction } = (0, $74BDp.useGlobalContextActions)();
    return (0, $5uXOq.useMemo)(()=>(id, error, attributes)=>{
            if (!$c58a665a3c6a26b3$export$cad78388f408899e(error)) return;
            reporterAction({
                id: id,
                error: error,
                attributes: attributes
            });
        }, [
        reporterAction
    ]);
};

});
parcelRegister("74BDp", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $aca7a4d9aea0d818$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $aca7a4d9aea0d818$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useSendMessage", () => $aca7a4d9aea0d818$export$fe8707b58c509543);
$parcel$export(module.exports, "useGlobalContextActions", () => $aca7a4d9aea0d818$export$8a9eff51cb8da29e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $bMb9B = parcelRequire("bMb9B");
const $aca7a4d9aea0d818$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $bMb9B
});
const $aca7a4d9aea0d818$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($aca7a4d9aea0d818$var$OriginalGlobalContextContainer, {
        config: config,
        reporter: reporter,
        isGlobal: true,
        flagService: flagService,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: locale,
            messages: messages && messages[locale],
            children: children
        })
    });
};
const $aca7a4d9aea0d818$var$OriginalGlobalContextContainer = (0, $gg7kZ.createContainer)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        },
    onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        }
});
const $aca7a4d9aea0d818$export$2041a7a7b51b1fce = (0, $51nlc.createSubscriber)($aca7a4d9aea0d818$export$390f32400eaf98c9);
const $aca7a4d9aea0d818$export$6b9ad8a324c94098 = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $aca7a4d9aea0d818$export$fe8707b58c509543 = (handlerClass)=>{
    const [{ handler: handler, context: context }] = $aca7a4d9aea0d818$var$useSendMessageInternal(handlerClass);
    return (params)=>{
        return handler(params, context);
    };
};
const $aca7a4d9aea0d818$var$useSendMessageInternal = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state, arg)=>{
        if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
            handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
            context: state.config.context
        };
        throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
    }
});
const $aca7a4d9aea0d818$export$8a9eff51cb8da29e = (0, $3sQ5x.createActionsHook)($aca7a4d9aea0d818$export$390f32400eaf98c9);

});
parcelRegister("bMb9B", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $3a0e18e647f4c498$export$f3910000817a36c2);
$parcel$export(module.exports, "getHorizontalNav", () => $3a0e18e647f4c498$export$7c79a3553de2e8e7);
const $3a0e18e647f4c498$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };
const $3a0e18e647f4c498$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
        return config?.isNewNavigation || false;
    };

});




parcelRegister("2tKfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c357df09fe3f96fe$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");
var $bKCvK = parcelRequire("bKCvK");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $74BDp = parcelRequire("74BDp");
const $c357df09fe3f96fe$var$useFlags = ()=>{
    const [flagService] = (0, $74BDp.useExternalFlagService)();
    const serviceRef = (0, $5uXOq.useRef)(flagService);
    (0, $hmVmJ.assert)(!serviceRef.current || !!flagService, new (0, $dH6Pi.AssertionError)('GlobalContext', 'flagService was destroyed.'));
    return serviceRef.current !== undefined ? {
        showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
            const Component = ({ id: id, onDismissed: onDismissed })=>{
                if (isAutoDismiss) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epfFv.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
            };
            const id = (0, $7Jxgt.v4)();
            Component.id = id;
            serviceRef.current.showFlag(Component);
            return ()=>{
                serviceRef.current.dismissFlag({
                    id: id,
                    command: 'DISMISS'
                });
            };
        }
    } : //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bKCvK.useFlags)();
};
var $c357df09fe3f96fe$export$2e2bcd8739ae039 = $c357df09fe3f96fe$var$useFlags;

});

parcelRegister("hEySk", function(module, exports) {

$parcel$export(module.exports, "ResponderNamesContainer", () => $6d57183bc999b4da$export$ae46960d51ae2b7);
$parcel$export(module.exports, "useResponderNamesStore", () => $6d57183bc999b4da$export$d2c212d52c0e4d25);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $eIMZo = parcelRequire("eIMZo");

var $jF6Os = parcelRequire("jF6Os");
const $6d57183bc999b4da$export$cd391a137954b857 = (0, $iXqE5.createStore)({
    initialState: (0, $jF6Os.initialState),
    actions: $eIMZo.actions,
    name: 'ResponderNamesStore'
});
const $6d57183bc999b4da$export$ae46960d51ae2b7 = (0, $gg7kZ.createContainer)($6d57183bc999b4da$export$cd391a137954b857);
const $6d57183bc999b4da$export$d2c212d52c0e4d25 = (0, $3sQ5x.createHook)($6d57183bc999b4da$export$cd391a137954b857);

});
parcelRegister("eIMZo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $00dbd40d3cd5db38$export$e324594224ef24da);

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $c3dSt = parcelRequire("c3dSt");

var $6DiJG = parcelRequire("6DiJG");

var $c8qzg = parcelRequire("c8qzg");
const $00dbd40d3cd5db38$var$fetchResponders = (missingResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        const { responders: responders } = getState();
        if (!Object.keys(missingResponders).length) return Promise.resolve();
        const errorItems = (0, $c3dSt.mapErrorForResponder)(missingResponders);
        setState({
            responders: {
                ...responders,
                ...missingResponders
            }
        });
        //TODO: How to handle if BE returns [], what will be the behaviour?
        return (0, $6DiJG.getResponderNames)(Object.values(missingResponders).map(({ id: id, type: type })=>({
                id: id,
                type: type
            }))).then((response)=>{
            const responseMap = response.values.map((r)=>({
                    isError: false,
                    isLoading: false,
                    acknowledged: true,
                    ...r
                })).reduce((acc, r)=>{
                acc[r.id] = r;
                return acc;
            }, {});
            const responderItemMap = Object.keys(missingResponders).reduce((acc, key)=>{
                const itemByEmail = Object.values(responseMap).find((res)=>res.email === key);
                if (itemByEmail) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByEmail
                    };
                    return acc;
                }
                const itemByAtlassianIdentifier = Object.values(responseMap).find((res)=>res.atlassianIdentifier === key);
                if (itemByAtlassianIdentifier) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByAtlassianIdentifier
                    };
                    return acc;
                }
                acc[key] = {
                    ...errorItems[key],
                    ...responseMap[key]
                };
                return acc;
            }, {});
            setState({
                responders: {
                    ...getState().responders,
                    ...responderItemMap
                }
            });
        }).catch(defaultCatch({
            id: 'fetchResponders',
            httpErrorHandler: ()=>{
                //Retry will be shown on the toast message
                const dismiss = flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    title: intlApi.formatMessage((0, $c8qzg.messages).fetchError),
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: intlApi.formatMessage((0, $c8qzg.messages).retry),
                            onClick: ()=>{
                                dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
                                dismiss();
                            }
                        }
                    ]
                });
                const responders = Object.assign({}, getState().responders, errorItems);
                setState({
                    responders: responders
                });
            }
        }));
    };
/**
 * It takes missingResponders and updates the store with additional parameters
 * when it is called on the useResponderNames() hook.
 * It sets isLoading to true for every responder item.
 * This function is implemented to batch requests coming from different components.
 */ const $00dbd40d3cd5db38$var$batchResponders = (requestedResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { displayName: displayName })=>{
        (0, $hmVmJ.assert)(displayName === 'ResponderNamesWrapper', new (0, $dH6Pi.AssertionError)('useResponderNames', 'Unable to find ResponderNamesWrapper'));
        const missingResponders = requestedResponders.filter((responder)=>!getState().responders[responder.id]);
        if (!missingResponders.length) return;
        const requestedRespondersMap = requestedResponders.reduce((acc, r)=>{
            acc[r.id] = {
                id: r.id,
                type: r.type,
                acknowledged: false,
                isError: false,
                isLoading: true
            };
            return acc;
        }, {});
        const existingResponders = getState().responders;
        const allResponderIds = [
            ...Object.keys(existingResponders),
            ...Object.keys(requestedRespondersMap)
        ];
        const allResponders = allResponderIds.reduce((acc, key)=>{
            acc[key] = {
                ...requestedRespondersMap[key],
                ...existingResponders[key]
            };
            return acc;
        }, {});
        setState({
            responders: allResponders
        });
        const timeoutState = getState().timeout;
        if (timeoutState !== undefined) clearTimeout(timeoutState);
        //It debounces the requested responders(batching)
        const timeout = setTimeout(()=>{
            const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value])=>(0, $c3dSt.isNotLoaded)(value)).map(([key, value])=>[
                    key,
                    {
                        ...value,
                        acknowledged: true
                    }
                ]));
            if (Object.keys(missingResponders).length) dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
        }, 10);
        setState({
            timeout: timeout
        });
    };
const $00dbd40d3cd5db38$export$e324594224ef24da = {
    fetchResponders: $00dbd40d3cd5db38$var$fetchResponders,
    batchResponders: $00dbd40d3cd5db38$var$batchResponders
};

});
parcelRegister("8eCQi", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $06a51a880a3faae2$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $06a51a880a3faae2$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $06a51a880a3faae2$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $06a51a880a3faae2$export$b56198a940066d8f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

var $VSDnB = parcelRequire("VSDnB");


var $2bUsm = parcelRequire("2bUsm");
const $06a51a880a3faae2$var$ErrorWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).error),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$var$WarningWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).warning),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$var$InfoWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).info),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$var$SuccessWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).success),
        spacing: (0, $VSDnB.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $06a51a880a3faae2$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$WarningWithIntl, {}),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$InfoWithIntl, {}),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)($06a51a880a3faae2$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
parcelRegister("2bUsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7145ce6f0cfaef60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7145ce6f0cfaef60$var$messages = (0, $7VHMR.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $7145ce6f0cfaef60$export$2e2bcd8739ae039 = $7145ce6f0cfaef60$var$messages;

});


parcelRegister("c3dSt", function(module, exports) {

$parcel$export(module.exports, "mapErrorForResponder", () => $f99f931354012934$export$245cebe8a9527ff0);
$parcel$export(module.exports, "isNotLoaded", () => $f99f931354012934$export$ea78f980ad0c92fe);
const $f99f931354012934$export$245cebe8a9527ff0 = (requestedResponders)=>Object.entries(requestedResponders).reduce((acc, [key, value])=>{
        acc[key] = {
            id: value.id,
            type: value.type,
            isError: true,
            acknowledged: true,
            isLoading: false
        };
        return acc;
    }, {});
const $f99f931354012934$export$ea78f980ad0c92fe = (responder)=>!Boolean(responder?.isError) && !Boolean(responder?.acknowledged);

});

parcelRegister("6DiJG", function(module, exports) {

$parcel$export(module.exports, "getResponderNames", () => $721598a63b2bde28$export$7345ec3bad54e226);

var $j74qU = parcelRequire("j74qU");
const $721598a63b2bde28$export$7345ec3bad54e226 = (requestedResponders)=>{
    const responders = requestedResponders.reduce((acc, curr)=>{
        // any is intentional here we don't want to add
        // unknown to the ResponderType because we don't want it to be public
        if (curr.type === 'unknown') return [
            ...acc,
            {
                id: curr.id,
                type: 'schedule'
            },
            {
                id: curr.id,
                type: 'user'
            },
            {
                id: curr.id,
                type: 'team'
            },
            {
                id: curr.id,
                type: 'escalation'
            }
        ];
        return [
            ...acc,
            curr
        ];
    }, []);
    return (0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: responders
        }
    });
};

});

parcelRegister("c8qzg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $43634ee9e12c5e07$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $43634ee9e12c5e07$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fetchError: {
        id: `eoc.responder-names-fetch-error`,
        defaultMessage: "We couldn't fetch the responder names.",
        description: 'The text will be displayed when there is error'
    },
    retry: {
        id: `eoc.responder-names-retry`,
        defaultMessage: 'Retry',
        description: 'The title for retry as a single word.'
    }
});

});


parcelRegister("jF6Os", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f657b42bad68e54a$export$d4c72bab9d6cc13a);
const $f657b42bad68e54a$export$d4c72bab9d6cc13a = {
    responders: {}
};

});



parcelRegister("8bgG7", function(module, exports) {

$parcel$export(module.exports, "AsyncLinkedAlertsField", () => $b77823321567a7bb$export$5dd38ea4ae79439a);

var $kxZPA = parcelRequire("kxZPA");

const $b77823321567a7bb$export$5dd38ea4ae79439a = (0, $kxZPA.lazy)(()=>(parcelRequire("6TZI8")).then((module)=>module.LinkedAlertsField), {
    moduleId: "./src/packages/issue/fields/linked-alerts/src/ui/index.tsx"
});

});
parcelRegister("6TZI8", function(module, exports) {

let $5067bf9b4337e7f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5067bf9b4337e7f4$var$load("h2MrD"),
    $5067bf9b4337e7f4$var$load("bYT2S"),
    $5067bf9b4337e7f4$var$load("jZ42S")
]).then(()=>parcelRequire('jDraT'));

});



parcelRegister("63H4W", function(module, exports) {

$parcel$export(module.exports, "useCanConfigureIssueType", () => $76abb154e4f05bb7$export$11eed85a03639c1c);
$parcel$export(module.exports, "shouldShowConfigureIssueTypeOption", () => $76abb154e4f05bb7$export$319ba838aee47b08);
$parcel$export(module.exports, "canConfigureIssueTypeForProject", () => $76abb154e4f05bb7$export$a88e153648f54474);

var $gJBT6 = parcelRequire("gJBT6");

var $2vSU6 = parcelRequire("2vSU6");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");
const $76abb154e4f05bb7$export$11eed85a03639c1c = (projectKey)=>{
    const isTeamManaged = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const hasAdminPermissions = (0, $17Gip.useCanConfigureIssue)(projectKey);
    return isTeamManaged && hasAdminPermissions;
};
const $76abb154e4f05bb7$export$319ba838aee47b08 = (projectType)=>{
    return projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT);
};
const $76abb154e4f05bb7$export$a88e153648f54474 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(({ project: project, isProjectAdmin: isProjectAdmin })=>{
    return isProjectAdmin && (project?.isSimplified ?? false) && $76abb154e4f05bb7$export$319ba838aee47b08(project?.projectType ?? null);
});

});
parcelRegister("17Gip", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $0b32a3d32d712870$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $0b32a3d32d712870$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $0b32a3d32d712870$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $0b32a3d32d712870$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $0b32a3d32d712870$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $0b32a3d32d712870$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $0b32a3d32d712870$export$86c656cdb87052cd);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $khL17 = parcelRequire("khL17");
const $0b32a3d32d712870$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $0b32a3d32d712870$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $0b32a3d32d712870$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $0b32a3d32d712870$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $0b32a3d32d712870$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $0b32a3d32d712870$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $0b32a3d32d712870$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $0b32a3d32d712870$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $khL17.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $0b32a3d32d712870$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $khL17.useProjectPermissionsStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("khL17", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $472e428a487a401f$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $472e428a487a401f$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $472e428a487a401f$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $l5qXF = parcelRequire("l5qXF");
const $472e428a487a401f$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $472e428a487a401f$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $l5qXF
});
const $472e428a487a401f$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $472e428a487a401f$export$ccfee65526b322ca;
const $472e428a487a401f$export$4919fa09a3d81224 = (0, $3sQ5x.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
    selector: $472e428a487a401f$var$getProjectPermissionSelector
});
const $472e428a487a401f$export$e8436ef485b33bdb = (0, $3sQ5x.createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("l5qXF", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $f3418fe5fb58759f$export$53f5cc27627e5fe3);
const $f3418fe5fb58759f$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("hoVpn", function(module, exports) {

$parcel$export(module.exports, "useCanConfigureStatus", () => $6faf33157bc1d7aa$export$c330622bbe9077c2);
$parcel$export(module.exports, "shouldShowConfigureStatusOption", () => $6faf33157bc1d7aa$export$33aa2c7a0150a75c);
$parcel$export(module.exports, "canConfigureStatusForProject", () => $6faf33157bc1d7aa$export$bbae6b0cfa2349b8);

var $gJBT6 = parcelRequire("gJBT6");

var $2vSU6 = parcelRequire("2vSU6");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $4R6GH = parcelRequire("4R6GH");
const $6faf33157bc1d7aa$export$c330622bbe9077c2 = (projectKey)=>{
    const isProjectAdmin = (0, $17Gip.useCanAdministerProject)(projectKey);
    const isTeamManaged = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const canConfigureIssue = (0, $17Gip.useCanConfigureIssue)(projectKey);
    const hasAdminPermissions = (0, $4R6GH.fg)('jira_site_admin_permissions_for_inline_config') ? canConfigureIssue : isProjectAdmin;
    return isTeamManaged && hasAdminPermissions;
};
const $6faf33157bc1d7aa$export$33aa2c7a0150a75c = (projectType)=>{
    return projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT);
};
const $6faf33157bc1d7aa$export$bbae6b0cfa2349b8 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(({ project: project, isProjectAdmin: isProjectAdmin })=>{
    return isProjectAdmin && (project?.isSimplified ?? false) && $6faf33157bc1d7aa$export$33aa2c7a0150a75c(project?.projectType ?? null);
});

});

const $c758c3cb80bbdb5a$export$e5ea02c7e88c47a3 = 'issue-create.common.ui.footer.create-button';
const $c758c3cb80bbdb5a$export$2bb7a43aba04c7df = 'issue-create.common.ui.footer.cancel-button';
const $c758c3cb80bbdb5a$export$822eda80d997eca0 = 'issue-create.common.ui.footer.created-issue-link';
const $c758c3cb80bbdb5a$export$9184b2de35f96256 = 'issue-create.ui.modal.header.import-issues-button';
const $c758c3cb80bbdb5a$export$2d077da71c26c1c5 = 'issue-create.ui.modal.create-form';
const $c758c3cb80bbdb5a$export$108d230a18c70c1b = 'issue-create.ui.modal.create-form.section-messages.required-fields-message';
const $c758c3cb80bbdb5a$export$f0c65883f24e857a = 'issue-create.ui.modal.create-form.section-messages.query-error-message';
const $c758c3cb80bbdb5a$export$d72a09102cf8602a = 'issue-create.ui.modal.create-form.section-messages.submit-error-message';
const $c758c3cb80bbdb5a$export$8cdb63e5b4deba55 = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message';
const $c758c3cb80bbdb5a$export$59cdc95a37abd627 = 'issue-create.common.ui.incompatible-fields-actions.learn-more';
const $c758c3cb80bbdb5a$export$1ec63f57bc2aa892 = 'issue-create.ui.modal.create-form.section-messages.inline-create-errors';
const $c758c3cb80bbdb5a$export$e80c59cc84dd232e = 'issue-create.common.ui.incompatible-fields-actions.switch-old-experience';
const $c758c3cb80bbdb5a$export$565ca47ee76ce81a = 'issue-create.ui.modal.confirm-dismiss-modal.discard-issue-button';
const $c758c3cb80bbdb5a$export$832901d9b0ce6620 = 'issue-create.ui.modal.cancel-dismiss-modal.discard-issue-button';
const $c758c3cb80bbdb5a$export$43794d009bc9b43b = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message';

parcelRegister("jhPH1", function(module, exports) {

$parcel$export(module.exports, "useInteractedFields", () => $d68972f47b0a2a6a$export$d5ae3b2773429294);

var $5uXOq = parcelRequire("5uXOq");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $45Cy1 = parcelRequire("45Cy1");
const $d68972f47b0a2a6a$export$d5ae3b2773429294 = ()=>{
    const [interactedFields, { setInteractedWithField: setInteractedWithField }] = (0, $45Cy1.useFormContextInteractedFields)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, ({ fieldId: fieldId })=>{
            setInteractedWithField(fieldId);
        }), [
        setInteractedWithField,
        subscribe
    ]);
    return {
        interactedFields: interactedFields
    };
};

});

parcelRegister("2tPtq", function(module, exports) {

$parcel$export(module.exports, "useInvitePrompt", () => $886f597cf99c20e0$export$2d68d3093301b7c3);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $1EwOz = parcelRequire("1EwOz");

var $9Bexu = parcelRequire("9Bexu");

var $jqts8 = parcelRequire("jqts8");

var $koeKL = parcelRequire("koeKL");

var $9OXo1 = parcelRequire("9OXo1");
const $886f597cf99c20e0$export$2d68d3093301b7c3 = (projectKey)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { cloudName: cloudName } = (0, $9OXo1.useTenantContext)();
    const triggerInviteExperiment = (0, $9Bexu.useInvitePrompt)(projectKey);
    const { store: store } = (0, $5uXOq.useContext)((0, $051X7.SmartCardContext)) || {};
    return (0, $5uXOq.useCallback)(async (description)=>{
        if (description && store && projectKey) {
            const links = (0, $jqts8.getAllProductLinks)(description, store, cloudId, cloudName);
            for (const [link, data] of Object.entries(links)){
                // https://eslint.org/docs/latest/rules/no-await-in-loop#when-not-to-use-it
                /* eslint-disable no-await-in-loop */ if (await triggerInviteExperiment(link, data, (0, $1EwOz.SOURCE).CREATE_ISSUE)) return;
            }
        }
    }, [
        cloudId,
        cloudName,
        projectKey,
        store,
        triggerInviteExperiment
    ]);
};

});
parcelRegister("1EwOz", function(module, exports) {

$parcel$export(module.exports, "SOURCE", () => $a7e3e8d343b53bb7$export$83c8d7110915321e);
const $a7e3e8d343b53bb7$export$83c8d7110915321e = {
    ISSUE_VIEW: 'issue-view',
    CREATE_ISSUE: 'create-issue',
    CREATE_LINK: 'create-link'
};

});

parcelRegister("9Bexu", function(module, exports) {

$parcel$export(module.exports, "useInvitePrompt", () => $d9e060d187f9c4a4$export$2d68d3093301b7c3);
$parcel$export(module.exports, "useInviteOnCreateLink", () => $d9e060d187f9c4a4$export$90eafb1d75365ab4);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");


var $koeKL = parcelRequire("koeKL");

var $1zGR5 = parcelRequire("1zGR5");

var $6s1PB = parcelRequire("6s1PB");

var $1EwOz = parcelRequire("1EwOz");

var $19mQY = parcelRequire("19mQY");

var $dRLAK = parcelRequire("dRLAK");

var $mnb3H = parcelRequire("mnb3H");

var $8CNqK = parcelRequire("8CNqK");

var $jILEq = parcelRequire("jILEq");

var $jqts8 = parcelRequire("jqts8");

var $8CLly = parcelRequire("8CLly");

var $edMTV = parcelRequire("edMTV");

var $junz0 = parcelRequire("junz0");

var $hln6E = parcelRequire("hln6E");
const $d9e060d187f9c4a4$export$2d68d3093301b7c3 = (createIssueProjectKey)=>{
    const canInvite = (0, $mnb3H.useCanInvite)();
    const getInvitees = (0, $19mQY.useInvitees)(createIssueProjectKey);
    const showInvitePromptFlag = (0, $junz0.useInvitePromptFlag)();
    const showSuccessFlag = (0, $hln6E.useInviteSuccessFlag)();
    const showErrorFlag = (0, $edMTV.useInviteErrorFlag)();
    const inviteUsers = (0, $8CNqK.useInviteUsers)();
    const { getOptOutStatus: getOptOutStatus, setOptOutStatus: setOptOutStatus, incrementViewCount: incrementViewCount, shouldShowOptOutOption: shouldShowOptOutOption } = (0, $jILEq.useOptOut)();
    return (0, $5uXOq.useCallback)(async (continueUrl, data, source = (0, $1EwOz.SOURCE).ISSUE_VIEW)=>{
        try {
            // eslint-disable-next-line jira/ff/unsafe-no-exposure
            const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('persistent_invite_on_link_insert');
            if (config.get('cohort', 'not-enrolled') === 'variation') return;
            (0, $8CLly.invitePromptOnLinkInsertExperience).start();
            const { tenantId: tenantId, product: product, name: name } = data;
            const hasOptedOut = await getOptOutStatus();
            if (hasOptedOut) return;
            const canInviteToProduct = await canInvite(tenantId, product);
            if (!canInviteToProduct) return;
            const users = await getInvitees(tenantId, product, 10);
            if (users.length === 0) return;
            const targetPageLabel = name || await (0, $dRLAK.getPageTitle)(continueUrl);
            const integration = 'invitePromptOnLink';
            showInvitePromptFlag({
                users: users,
                product: product,
                source: source,
                targetPageLabel: targetPageLabel,
                allowOptOut: await shouldShowOptOutOption(),
                onSubmit: async ()=>{
                    try {
                        const response = await inviteUsers({
                            continueUrl: continueUrl,
                            userIds: users.map(({ id: id })=>id),
                            tenantId: tenantId,
                            product: product,
                            integration: integration
                        });
                        showSuccessFlag({
                            userIds: users.map(({ id: id })=>id),
                            product: product,
                            requireAdminApproval: response.accessRequested.length > 0
                        });
                    } catch  {
                        showErrorFlag();
                    }
                },
                onDismiss: incrementViewCount,
                onOptOut: setOptOutStatus
            });
            (0, $8CLly.invitePromptOnLinkInsertExperience).success();
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useInvitePromptExperiment',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            (0, $8CLly.invitePromptOnLinkInsertExperience).failure();
        }
    }, [
        canInvite,
        getInvitees,
        getOptOutStatus,
        incrementViewCount,
        inviteUsers,
        setOptOutStatus,
        shouldShowOptOutOption,
        showErrorFlag,
        showInvitePromptFlag,
        showSuccessFlag
    ]);
};
const $d9e060d187f9c4a4$export$90eafb1d75365ab4 = (link)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const cloudName = (0, $1zGR5.useCloudName)();
    const triggerInviteExperiment = $d9e060d187f9c4a4$export$2d68d3093301b7c3();
    return (0, $5uXOq.useCallback)(()=>{
        if ((0, $jqts8.isConfluenceLink)(link, cloudName)) triggerInviteExperiment(link, {
            tenantId: cloudId,
            product: (0, $c06e1abca7c13910$export$c811f21c9ad05dc2)
        }, (0, $1EwOz.SOURCE).CREATE_LINK);
    }, [
        cloudId,
        cloudName,
        link,
        triggerInviteExperiment
    ]);
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("1zGR5", function(module, exports) {

$parcel$export(module.exports, "useCloudName", () => $ad30617e06682b7f$export$4dd2f8d207dc8dbf);

var $9OXo1 = parcelRequire("9OXo1");
const $ad30617e06682b7f$export$4dd2f8d207dc8dbf = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudName;
};

});

parcelRegister("19mQY", function(module, exports) {

$parcel$export(module.exports, "useInvitees", () => $002670f5df23816b$export$e2a3b21407d97a53);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $koeKL = parcelRequire("koeKL");

var $jqts8 = parcelRequire("jqts8");

var $l3yfW = parcelRequire("l3yfW");

var $juFR2 = parcelRequire("juFR2");
const $002670f5df23816b$export$e2a3b21407d97a53 = (createIssueProjectKey)=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const currentProjectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectKey = createIssueProjectKey || currentProjectKey;
    const currentProduct = (0, $jqts8.useCurrentProduct)();
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)((tenantId, destinationProduct, inviteesLimit = 10)=>$002670f5df23816b$export$31f1797930c2d46c(tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit), [
        cloudId,
        currentProduct,
        projectKey
    ]);
};
const $002670f5df23816b$export$31f1797930c2d46c = async (tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit = 10)=>{
    const isInvitingToCurrentProduct = tenantId === cloudId && destinationProduct === currentProduct;
    if (isInvitingToCurrentProduct) return [];
    const projectAssignees = await (0, $l3yfW.getProjectAssignees)(projectKey);
    if (projectAssignees.length === 0) return [];
    const accountIds = projectAssignees.map(({ id: id })=>id);
    const [usersWithoutAccessToCurrentProduct, usersWithoutAccessToDestinationProduct] = await Promise.all([
        (0, $juFR2.getUsersWithoutProductAccess)(cloudId, currentProduct, accountIds),
        (0, $juFR2.getUsersWithoutProductAccess)(tenantId, destinationProduct, accountIds)
    ]);
    const invitees = projectAssignees.filter(({ id: id })=>!usersWithoutAccessToCurrentProduct.includes(id)).filter(({ id: id })=>usersWithoutAccessToDestinationProduct.includes(id));
    return invitees.slice(0, inviteesLimit);
};

});
parcelRegister("jqts8", function(module, exports) {

$parcel$export(module.exports, "isConfluenceLink", () => $f0146e170e490984$export$313baaa1c3261c49);
$parcel$export(module.exports, "getAllLinks", () => $f0146e170e490984$export$776644da31ab517e);
$parcel$export(module.exports, "getAllProductLinks", () => $f0146e170e490984$export$577f918d7821fd77);
$parcel$export(module.exports, "generateId", () => $f0146e170e490984$export$567fc7097e064344);
$parcel$export(module.exports, "clampString", () => $f0146e170e490984$export$96ce25bdd1856c70);
$parcel$export(module.exports, "getProductDisplayName", () => $f0146e170e490984$export$44fea6589b7ddc92);
$parcel$export(module.exports, "getSiteAri", () => $f0146e170e490984$export$792aeacb7990bc6);
$parcel$export(module.exports, "useCurrentProduct", () => $f0146e170e490984$export$495654df2a5da4a0);

var $l1C1k = parcelRequire("l1C1k");


var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");
const $f0146e170e490984$export$69caceff42c0da80 = {
    [(0, $c06e1abca7c13910$export$c811f21c9ad05dc2)]: 'Confluence'
};
const $f0146e170e490984$export$fadb677f87088e11 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 'service_desk':
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 'business':
            return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        case 'product_discovery':
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $f0146e170e490984$var$getProductFromSubproduct = (subproduct)=>{
    switch(subproduct){
        case 'software':
        case 'jira_software':
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 'servicedesk':
        case 'jira_service_management':
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 'core':
        case 'jira_work_management':
            return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        case 'polaris':
        case 'jira_product_discovery':
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $f0146e170e490984$export$313baaa1c3261c49 = (url, cloudName)=>{
    if (!url || !cloudName) return false;
    const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki(?!/external)`);
    return regex.test(url);
};
const $f0146e170e490984$export$776644da31ab517e = (doc)=>{
    const links = new Set();
    const handleLink = (link)=>{
        link && links.add(link);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>handleLink(node.attrs?.url);
    (0, $l1C1k.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
const $f0146e170e490984$var$getSmartLinkData = (cloudId, details)=>{
    if (!details) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { name: name } = details.data;
    const { tenantId: tenantId, subproduct: subproduct } = details.meta;
    let { product: product } = details.meta;
    if (tenantId !== cloudId) return;
    product = product === 'jira' ? $f0146e170e490984$var$getProductFromSubproduct(subproduct) : product;
    if (!Object.keys($f0146e170e490984$export$69caceff42c0da80).includes(product)) return;
    return {
        name: name,
        tenantId: tenantId,
        product: product
    };
};
const $f0146e170e490984$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
    const links = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>{
        // Check URL is on the ADF node
        const { url: url } = node?.attrs;
        if (!url) return;
        // Check URL is in the Smart Links Store
        const details = store.getState()[url]?.details;
        const data = $f0146e170e490984$var$getSmartLinkData(cloudId, details);
        if (data) links[url] = data;
    };
    const handleRawConfluenceLink = (url)=>{
        if ($f0146e170e490984$export$313baaa1c3261c49(url, cloudName)) links[url] = {
            tenantId: cloudId,
            product: (0, $c06e1abca7c13910$export$c811f21c9ad05dc2)
        };
    };
    (0, $l1C1k.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
let $f0146e170e490984$var$id = 0;
const $f0146e170e490984$export$567fc7097e064344 = ()=>{
    $f0146e170e490984$var$id += 1;
    return String($f0146e170e490984$var$id);
};
const $f0146e170e490984$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
    return string;
};
const $f0146e170e490984$export$44fea6589b7ddc92 = (product)=>$f0146e170e490984$export$69caceff42c0da80[product];
const $f0146e170e490984$export$792aeacb7990bc6 = (tenantId, product)=>(0, $dXq4S.createAri)({
        resourceOwner: product,
        resourceType: 'site',
        resourceId: tenantId
    }).toString();
const $f0146e170e490984$export$495654df2a5da4a0 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return $f0146e170e490984$export$fadb677f87088e11(data?.projectType) || (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
};

});

parcelRegister("l3yfW", function(module, exports) {

$parcel$export(module.exports, "getProjectAssignees", () => $ca2b43e33d9b739b$export$b49ddf91eddfcea9);

var $7f4tk = parcelRequire("7f4tk");
const $ca2b43e33d9b739b$var$getAssigneesUrl = (projectKey)=>`/rest/api/3/user/search/query?query=is assignee of ${projectKey}&maxResults=50`;
const $ca2b43e33d9b739b$export$b49ddf91eddfcea9 = async (projectKey)=>{
    const users = await (0, $7f4tk.default)($ca2b43e33d9b739b$var$getAssigneesUrl(projectKey));
    return users.values.filter(({ active: active })=>active).map(({ accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: avatarUrls })=>({
            id: accountId,
            email: emailAddress,
            name: displayName || '',
            avatar: avatarUrls['48x48'] || avatarUrls['32x32'] || avatarUrls['24x24'] || Object.values(avatarUrls).pop() || ''
        }));
};

});

parcelRegister("juFR2", function(module, exports) {

$parcel$export(module.exports, "getUsersWithoutProductAccess", () => $d23da2540de8ce66$export$7121af075bd652a4);

var $7f4tk = parcelRequire("7f4tk");
const $d23da2540de8ce66$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $d23da2540de8ce66$export$7121af075bd652a4 = (cloudId, product, accountIds)=>(0, $7f4tk.default)($d23da2540de8ce66$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });

});


parcelRegister("dRLAK", function(module, exports) {

$parcel$export(module.exports, "getPageTitle", () => $2319c2f0426c18c6$export$23286240952da4c9);

var $7f4tk = parcelRequire("7f4tk");
const $2319c2f0426c18c6$var$resolverUrl = '/gateway/api/object-resolver/resolve';
const $2319c2f0426c18c6$export$23286240952da4c9 = async (resourceUrl)=>{
    try {
        const response = await (0, $7f4tk.default)($2319c2f0426c18c6$var$resolverUrl, {
            method: 'POST',
            body: JSON.stringify({
                resourceUrl: resourceUrl
            })
        });
        return response.data?.name;
    } catch  {
        return undefined;
    }
};

});

parcelRegister("mnb3H", function(module, exports) {

$parcel$export(module.exports, "useCanInvite", () => $82d755cbdc58f1c2$export$4fa512abf5d2ba5e);
$parcel$export(module.exports, "useInviteCapability", () => $82d755cbdc58f1c2$export$171021d8e67014af);

var $5uXOq = parcelRequire("5uXOq");

var $7f4tk = parcelRequire("7f4tk");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");


var $FabRL = parcelRequire("FabRL");
const $82d755cbdc58f1c2$export$8a4a12ca67f0b223 = (cloudId)=>`/gateway/api/v3/invitations/capabilities?resource=ari:cloud:platform::site/${cloudId}`;
const $82d755cbdc58f1c2$export$4fa512abf5d2ba5e = ()=>(0, $5uXOq.useCallback)((cloudId, product)=>$82d755cbdc58f1c2$export$39ebdf2aa7e6d740(cloudId, product), []);
const $82d755cbdc58f1c2$export$39ebdf2aa7e6d740 = async (cloudId, product)=>{
    const capabilities = await (0, $7f4tk.default)($82d755cbdc58f1c2$export$8a4a12ca67f0b223(cloudId));
    const capability = capabilities.find((cap)=>{
        const ari = (0, $dXq4S.getAriConfig)(cap.resourceARI);
        return ari.resourceOwner === product;
    });
    if (!capability) return false;
    return capability.directInvite?.mode === 'ANYONE' || capability.invitePendingApproval?.mode === 'ANYONE';
};
const $82d755cbdc58f1c2$export$171021d8e67014af = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)(async ()=>{
        const capabilities = await (0, $7f4tk.default)($82d755cbdc58f1c2$export$8a4a12ca67f0b223(cloudId));
        const capability = capabilities.find((cap)=>{
            const ari = (0, $dXq4S.getAriConfig)(cap.resourceARI);
            return ari.resourceOwner === (0, $c06e1abca7c13910$export$c811f21c9ad05dc2);
        });
        if (capability?.directInvite.mode === 'ANYONE') return (0, $FabRL.InviteCapabilities).DIRECT_INVITE;
        if (capability?.invitePendingApproval.mode === 'ANYONE') return (0, $FabRL.InviteCapabilities).INVITE_PENDING_APPROVAL;
        return (0, $FabRL.InviteCapabilities).NONE;
    }, [
        cloudId
    ]);
};

});
parcelRegister("FabRL", function(module, exports) {

$parcel$export(module.exports, "InviteCapabilities", () => $07a130644d047102$export$631a5cf24b1fd5a1);
const $07a130644d047102$export$631a5cf24b1fd5a1 = {
    DIRECT_INVITE: 'directInvite',
    INVITE_PENDING_APPROVAL: 'invitePendingApproval',
    NONE: 'none'
};

});


parcelRegister("8CNqK", function(module, exports) {

$parcel$export(module.exports, "useInviteUsers", () => $4c3052c658744a85$export$6162654a9c7a7b9a);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jqts8 = parcelRequire("jqts8");

var $bNM9H = parcelRequire("bNM9H");

var $cs9Zr = parcelRequire("cs9Zr");
const $4c3052c658744a85$export$6162654a9c7a7b9a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(async ({ userIds: userIds, continueUrl: continueUrl, tenantId: tenantId, product: product, integration: integration })=>{
        try {
            const origin = new (0, $2gQ83.default)({
                product: (0, $cs9Zr.getOriginProduct)(product)
            });
            const continueUrlWithOrigin = origin.addToUrl(continueUrl);
            const originAttributes = origin.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            const inviteApiResponse = await (0, $bNM9H.inviteWithinOrg)({
                userIds: userIds,
                continueUrl: continueUrlWithOrigin,
                tenantId: tenantId,
                product: product
            });
            const response = (0, $cs9Zr.handleInviteUsersSuccessResponse)(inviteApiResponse);
            [
                ...response.invited,
                ...response.accessRequested
            ].forEach((invited)=>{
                const resourceAri = (0, $jqts8.getSiteAri)(tenantId, product);
                const result = invited.results[resourceAri];
                const userId = invited.id;
                const analyticsAttributes = {
                    ...originAttributes,
                    userId: userId,
                    products: [
                        product
                    ],
                    inviteResult: [
                        {
                            resourceAri: resourceAri,
                            status: result
                        }
                    ],
                    integration: integration,
                    isInviteWithinOrg: true
                };
                if (result === 'INVITED') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', userId, analyticsAttributes);
                else if (result === 'INVITED_PENDING_APPROVAL') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promptOnLinkInvite succeeded', {
                invited: response.invited.length,
                requested: response.accessRequested.length,
                errored: response.error.length,
                integration: integration
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useInviteUsers',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error,
                attributes: {
                    integration: integration
                }
            });
            throw error;
        }
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("bNM9H", function(module, exports) {

$parcel$export(module.exports, "inviteWithinOrg", () => $fa07c4267ef179ba$export$a106ce8e40b3d224);

var $eusud = parcelRequire("eusud");

var $jqts8 = parcelRequire("jqts8");

const $fa07c4267ef179ba$export$a106ce8e40b3d224 = async ({ userIds: userIds, continueUrl: continueUrl, tenantId: tenantId, product: product })=>{
    const resources = [
        (0, $jqts8.getSiteAri)(tenantId, product)
    ];
    const response = await (0, $eusud.performPostRequest)((0, $ab037afc3711e52a$export$f87741d20d2a10fb), {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            continueUrl: continueUrl,
            resources: resources,
            userIds: userIds,
            cloudId: tenantId,
            experience: 'invite-on-link-insert'
        })
    });
    return response;
};

});
const $ab037afc3711e52a$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';
const $ab037afc3711e52a$export$f87741d20d2a10fb = '/gateway/api/growth/groot-invite-within-org/invite';


parcelRegister("cs9Zr", function(module, exports) {

$parcel$export(module.exports, "handleInviteUsersSuccessResponse", () => $d19e810a3471b533$export$bf7ed6f1f1b884e);
$parcel$export(module.exports, "getOriginProduct", () => $d19e810a3471b533$export$e4853a500db4c6bf);

const $d19e810a3471b533$export$f6c02f8ff560b96f = (environment)=>{
    switch(environment){
        case 'prod':
            return 0, $f46589b0085bcc39$export$2c2f58a9d84da733;
        case 'staging':
            return 0, $f46589b0085bcc39$export$cd719d3567d9b31d;
        default:
            return 0, $f46589b0085bcc39$export$34c3413ecdf1b634;
    }
};
const $d19e810a3471b533$export$bf7ed6f1f1b884e = (response)=>response.reduce((accumulator, userResponse)=>{
        const user = {
            id: userResponse.id,
            email: userResponse.email
        };
        Object.keys(userResponse.results).forEach((resource)=>{
            switch(userResponse.results[resource]){
                case 'INVITED':
                case 'USER_EXISTS':
                    accumulator.invited.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'INVITED_PENDING_APPROVAL':
                case 'PENDING_INVITE_EXISTS':
                    accumulator.accessRequested.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'NOT_INVITED':
                case 'ERROR':
                    accumulator.error.push({
                        ...user,
                        error: userResponse.errorReasons[resource]
                    });
                    break;
                default:
                    throw new Error('Unexpected return type from invite user response');
            }
        });
        return accumulator;
    }, {
        invited: [],
        accessRequested: [],
        error: []
    });
const $d19e810a3471b533$export$e4853a500db4c6bf = (product)=>{
    product;
    return product;
};

});
const $f46589b0085bcc39$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $f46589b0085bcc39$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $f46589b0085bcc39$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';



parcelRegister("jILEq", function(module, exports) {

$parcel$export(module.exports, "useOptOut", () => $6f9b71165d35a2e4$export$7f94797c6e99faf3);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $3Wvty = parcelRequire("3Wvty");
const $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW = 'invite-prompt-on-link-insert-view';
const $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT = 'invite-prompt-on-link-insert-opt-out';
const $6f9b71165d35a2e4$var$MAX_VIEW_COUNT = 2;
const $6f9b71165d35a2e4$var$shouldShowOptOutOption = async (accountId)=>{
    if (!accountId) return false;
    const viewCount = await $6f9b71165d35a2e4$var$getViewCount(accountId);
    return viewCount >= $6f9b71165d35a2e4$var$MAX_VIEW_COUNT;
};
const $6f9b71165d35a2e4$var$incrementViewCount = async (accountId)=>{
    if (!accountId) return;
    const viewCount = await $6f9b71165d35a2e4$var$getViewCount(accountId);
    if (viewCount < $6f9b71165d35a2e4$var$MAX_VIEW_COUNT) try {
        await (0, $3Wvty.setUserProperty)({
            accountId: accountId,
            propertyKey: $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
            propertyValue: viewCount + 1
        });
    // TODO: shall we fire an event here to record the user has viewed the flag?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'incrementViewCount',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $6f9b71165d35a2e4$var$getViewCount = async (accountId)=>(await (0, $3Wvty.getUserProperty)({
        accountId: accountId,
        propertyKey: $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
        defaultValue: 0
    })).value;
const $6f9b71165d35a2e4$var$getOptOutInvitePrompt = async (accountId, propertyKey)=>{
    if (!accountId) return false;
    return (await (0, $3Wvty.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: false
    })).value;
};
const $6f9b71165d35a2e4$var$setOptOutInvitePrompt = async (accountId, propertyKey)=>{
    if (!accountId) return;
    try {
        await (0, $3Wvty.setUserProperty)({
            accountId: accountId,
            propertyKey: propertyKey,
            propertyValue: true
        });
    // TODO: shall we fire an event here to record the user has opted out?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'setOptOutInvitePrompt',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $6f9b71165d35a2e4$export$7f94797c6e99faf3 = (propertyKey = $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT)=>{
    const accountId = (0, $90yGq.useAccountId)();
    return (0, $5uXOq.useMemo)(()=>({
            shouldShowOptOutOption: ()=>$6f9b71165d35a2e4$var$shouldShowOptOutOption(accountId),
            incrementViewCount: ()=>$6f9b71165d35a2e4$var$incrementViewCount(accountId),
            getOptOutStatus: ()=>$6f9b71165d35a2e4$var$getOptOutInvitePrompt(accountId, propertyKey),
            setOptOutStatus: ()=>$6f9b71165d35a2e4$var$setOptOutInvitePrompt(accountId, propertyKey)
        }), [
        accountId,
        propertyKey
    ]);
};

});
parcelRegister("3Wvty", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $6f8b8e5b8e68f1c5$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $6f8b8e5b8e68f1c5$export$b3126db2ef6e34ed);

var $eusud = parcelRequire("eusud");
const $6f8b8e5b8e68f1c5$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $6f8b8e5b8e68f1c5$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $6f8b8e5b8e68f1c5$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Saving ${propertyKey} user property failed. Error: ${error}`);
    }
};
const $6f8b8e5b8e68f1c5$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $6f8b8e5b8e68f1c5$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("8CLly", function(module, exports) {

$parcel$export(module.exports, "invitePromptOnLinkInsertExperience", () => $0c2a3336267cda18$export$adb25c37e478fcbe);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $0c2a3336267cda18$export$adb25c37e478fcbe = new (0, $duUGa.UFOExperience)('invite-prompt-on-link-insert', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("edMTV", function(module, exports) {

$parcel$export(module.exports, "useInviteErrorFlag", () => $dd8e8c3c0cb6f6ea$export$e6d35b1c4e81af0e);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
var $3KRpp = parcelRequire("3KRpp");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $jqts8 = parcelRequire("jqts8");

var $dsKIR = parcelRequire("dsKIR");
const $dd8e8c3c0cb6f6ea$export$e6d35b1c4e81af0e = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)(()=>{
        const id = `error-${(0, $jqts8.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd8e8c3c0cb6f6ea$export$92c0939d1a977673, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $dd8e8c3c0cb6f6ea$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $dd8e8c3c0cb6f6ea$export$92c0939d1a977673 = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $dsKIR.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $dsKIR.messages).description))),
        messageId: `invite-prompt-on-link-insert.ui.invite-error-flag.error-flag.${props.id}`,
        messageType: "transactional",
        actions: [
            {
                content: formatMessage((0, $dsKIR.messages).action),
                href: $dd8e8c3c0cb6f6ea$var$JIRA_SUPPORT_LINK,
                target: '_blank'
            }
        ]
    });
};

});
parcelRegister("dsKIR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $41b86c034044336a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $41b86c034044336a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.description",
        "defaultMessage": "Try inviting your teammates again. If the problem persists, contact support."
    },
    action: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.action",
        "defaultMessage": "Contact support"
    }
});

});


parcelRegister("junz0", function(module, exports) {

$parcel$export(module.exports, "useInvitePromptFlag", () => $eea5750da39a418b$export$ce7c2ea6d33a7cf4);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $d4xRU = parcelRequire("d4xRU");
var $fHfPB = parcelRequire("fHfPB");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1vvOR = parcelRequire("1vvOR");

var $jqts8 = parcelRequire("jqts8");

var $dL5Pi = parcelRequire("dL5Pi");
const $eea5750da39a418b$export$ce7c2ea6d33a7cf4 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(({ targetPageLabel: targetPageLabel, product: product, source: source, users: users, allowOptOut: allowOptOut, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut })=>{
        const id = `invite-${(0, $jqts8.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        const attributes = {
            invitees: users.length,
            renderedPageTitle: !!targetPageLabel,
            allowOptOut: allowOptOut,
            inviteeIds: users.map((user)=>user.id),
            source: source,
            product: product
        };
        const submit = async ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addPeopleButtonInviteOnLinkInsert', attributes);
            await onSubmit();
            dismissTheFlag();
        };
        const optOut = ()=>{
            dismissTheFlag();
            onOptOut();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'optOutButtonInviteOnLinkInsert', attributes);
        };
        const dismiss = ()=>{
            dismissTheFlag();
            onDismiss();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'inviteOnLinkInsert', attributes);
        };
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag shown', 'inviteOnLinkInsert', attributes);
        showFlag({
            id: id,
            isLowPriority: true,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5750da39a418b$export$d6bef3efd7271258, {
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSubmit: submit,
                    onOptOut: allowOptOut ? optOut : undefined,
                    product: product,
                    targetPageLabel: targetPageLabel
                })
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
const $eea5750da39a418b$export$d6bef3efd7271258 = ({ id: id, onDismiss: onDismiss, onSubmit: onSubmit, onOptOut: onOptOut, users: users, product: product, targetPageLabel: targetPageLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const productDisplayName = (0, $jqts8.getProductDisplayName)(product);
    const maxLength = 40;
    const clampedTargetPageLabel = (0, $jqts8.clampString)(targetPageLabel || '', maxLength);
    const actions = (0, $5uXOq.useMemo)(()=>{
        const allActions = [
            {
                content: formatMessage((0, $dL5Pi.messages).addPeopleButton, {
                    inviteeCount: users.length,
                    displayName: users[0].name.split(' ')[0]
                }),
                onClick: onSubmit
            },
            {
                content: formatMessage((0, $dL5Pi.messages).dismiss, {}),
                onClick: onOptOut
            }
        ];
        return onOptOut ? allActions : allActions.slice(0, 1);
    }, [
        users,
        onSubmit,
        onOptOut,
        formatMessage
    ]);
    const description = targetPageLabel ? formatMessage((0, $dL5Pi.messages).descriptionWithPageTitleGeneric, {
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, chunks.join('')),
        inviteeCount: users.length,
        title: clampedTargetPageLabel,
        productDisplayName: productDisplayName,
        displayName: users[0].name.split(' ')[0]
    }) : formatMessage((0, $dL5Pi.messages).descriptionWithoutPageTitleGeneric, {
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, chunks.join('')),
        inviteeCount: users.length,
        productDisplayName: productDisplayName,
        displayName: users[0].name.split(' ')[0]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: id,
        onDismissed: onDismiss,
        title: formatMessage((0, $dL5Pi.messages).titleGeneric, {
            inviteeCount: users.length,
            displayName: users[0].name
        }),
        description: description,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vvOR.FlagCompatibleAvatarGroup), {
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar
                })),
            boundariesElement: "scrollParent",
            useSmallAvatars: true
        }),
        actions: actions,
        messageType: "marketing",
        messageId: "invite-prompt-on-link-insert.ui.invite-prompt-flag.ak-flag.info-flag.invite-prompt-flag"
    });
};

});
parcelRegister("1vvOR", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $9673fbe34231f4e4$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cEPfF = parcelRequire("cEPfF");

var $jnhNB = parcelRequire("jnhNB");
const $9673fbe34231f4e4$var$MAX_AVATARS_FEATURED = 5;
const $9673fbe34231f4e4$var$MAX_SMALL_AVATARS_FEATURED = 2;
const $9673fbe34231f4e4$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $9673fbe34231f4e4$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $9673fbe34231f4e4$export$29beada2d5f93289 = ({ data: data, useSmallAvatars: useSmallAvatars, ...props })=>{
    const maxAvatarCount = useSmallAvatars ? $9673fbe34231f4e4$var$MAX_SMALL_AVATARS_FEATURED : $9673fbe34231f4e4$var$MAX_AVATARS_FEATURED;
    const { data: customData, overrides: customOverrides } = (0, $5uXOq.useMemo)(()=>$9673fbe34231f4e4$export$bc55c1ff86d63c4d({
            data: data,
            useSmallAvatars: useSmallAvatars
        }), [
        data,
        useSmallAvatars
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        size: useSmallAvatars ? 'small' : 'medium',
        ...props
    });
    return avatarGroup;
};
const $9673fbe34231f4e4$export$bc55c1ff86d63c4d = ({ data: users, useSmallAvatars: useSmallAvatars })=>{
    const maxAvatarCount = useSmallAvatars ? $9673fbe34231f4e4$var$MAX_SMALL_AVATARS_FEATURED : $9673fbe34231f4e4$var$MAX_AVATARS_FEATURED;
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $9673fbe34231f4e4$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $9673fbe34231f4e4$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length, useSmallAvatars);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $9673fbe34231f4e4$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $9673fbe34231f4e4$var$OVERFLOW_USER_MARKER
    });
const $9673fbe34231f4e4$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount, useSmallAvatars)=>{
    const Container = useSmallAvatars ? $9673fbe34231f4e4$var$SmallAvatarOverflowCountContainer : $9673fbe34231f4e4$var$AvatarOverflowCountContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEPfF.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, null, `+${Math.min(overflowCount, $9673fbe34231f4e4$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $9673fbe34231f4e4$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $9673fbe34231f4e4$var$SmallAvatarOverflowCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $9673fbe34231f4e4$var$AvatarOverflowCountContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dL5Pi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2b136a60fe0ab8a3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2b136a60fe0ab8a3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addPeopleButton: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.add-people-button",
        "defaultMessage": "{inviteeCount, plural, one {Add {displayName}} other {Add # people}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.dismiss",
        "defaultMessage": "Don't show again"
    },
    titleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.title-generic",
        "defaultMessage": "{inviteeCount, plural, one {{displayName} may need access} other {Your team may need access}}"
    },
    descriptionWithoutPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to <strong>{productDisplayName}</strong>.} other {# project assignees need access to <strong>{productDisplayName}</strong>.}}"
    },
    descriptionWithPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to {productDisplayName} to view <strong>{title}</strong>.} other {# project assignees need access to {productDisplayName} to view <strong>{title}</strong>.}}"
    }
});

});


parcelRegister("hln6E", function(module, exports) {

$parcel$export(module.exports, "useInviteSuccessFlag", () => $659770b6de3b09e5$export$c323779e5ddf45d0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $fHfPB = parcelRequire("fHfPB");
var $3KRpp = parcelRequire("3KRpp");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $jqts8 = parcelRequire("jqts8");

var $6KSw8 = parcelRequire("6KSw8");
const $659770b6de3b09e5$export$c323779e5ddf45d0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)(({ userIds: userIds, product: product, requireAdminApproval: requireAdminApproval })=>{
        const id = `success-${(0, $jqts8.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($659770b6de3b09e5$export$6c436beee6e5593, {
                    ...props,
                    id: id,
                    userIds: userIds,
                    onDismiss: dismiss,
                    product: product,
                    requireAdminApproval: requireAdminApproval
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $659770b6de3b09e5$export$6c436beee6e5593 = ({ userIds: userIds, onDismiss: onDismiss, product: product, requireAdminApproval: requireAdminApproval, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const productDisplayName = (0, $jqts8.getProductDisplayName)(product);
    const customFlagFooterProps = (0, $5uXOq.useMemo)(()=>({
            actions: [
                {
                    content: '',
                    // Replace with lodash/noop
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: ()=>{}
                }
            ],
            linkComponent: ()=>requireAdminApproval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($659770b6de3b09e5$var$FooterParagraph, null, formatMessage((0, $6KSw8.messages).additionalInfoGeneric, {
                    strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                            as: "strong"
                        }, chunks.join('')),
                    productDisplayName: productDisplayName
                }))
        }), [
        formatMessage,
        requireAdminApproval,
        productDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: formatMessage((0, $6KSw8.messages).title, {
            inviteeCount: userIds.length
        }),
        description: // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6KSw8.messages).descriptionGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeCount: userIds.length,
            productDisplayName: productDisplayName
        }))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $659770b6de3b09e5$var$FooterParagraph = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _t9ec1gty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6KSw8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $503d6782010ac6ce$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $503d6782010ac6ce$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.title",
        "defaultMessage": "{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.dismiss",
        "defaultMessage": "Ok, got it"
    },
    descriptionGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.description-generic",
        "defaultMessage": "{inviteeCount, plural, one {<strong># project assignee</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.} other {<strong># project assignees</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.}}"
    },
    additionalInfoGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.additional-info-generic",
        "defaultMessage": "Admin may need to approve some assignees before they can join <strong>{productDisplayName}</strong>."
    }
});

});




parcelRegister("jE4bA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f965259f40571ce$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $1Nspv = parcelRequire("1Nspv");

var $3M1CO = parcelRequire("3M1CO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cplCs = parcelRequire("cplCs");

var $h1X40 = parcelRequire("h1X40");

var $daCGe = parcelRequire("daCGe");

var $bEouw = parcelRequire("bEouw");
const $6f965259f40571ce$var$useCreateIssueService = (selectedCloudId = '')=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireErrorAnalyticsEvent: fireErrorAnalyticsEvent } = (0, $h1X40.useIssueCreateErrorAnalyticsEvent)();
    const createIssue = ({ onSuccess: onSuccess, formData: formData, transition: inputTransition, watchers: watchers, skipAutoWatch: skipAutoWatch, fieldConfig: fieldConfig, fieldTabs: fieldTabs, hasIssueAdjustmentModules: hasIssueAdjustmentModules, context: context, createLinkedIssuePayload: createLinkedIssuePayload, interactedFields: interactedFields = {}, shouldShowStatus: shouldShowStatus = false })=>{
        let transformedData = (0, $bEouw.transformData)(formData, fieldConfig);
        const additionalFields = context?.submitApiData?.additionalFields || {};
        const issueList = context?.submitApiData?.issueList || null;
        const transition = inputTransition ?? context?.submitApiData?.transition;
        const { isCreateLinkedIssue: isCreateLinkedIssue, sourceIssueKey: sourceIssueKey } = createLinkedIssuePayload || {};
        // add copy links and attachments data to issuelinks and attachment field submit payload
        if (isCreateLinkedIssue && sourceIssueKey && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view')) transformedData = (0, $bEouw.handleCopyLinksAndAttachments)({
            transformedData: transformedData,
            formData: formData,
            sourceIssueKey: sourceIssueKey
        });
        const updateFields = (0, $bEouw.getUpdateFields)(isCreateLinkedIssue && Boolean(sourceIssueKey) && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view'));
        const payload = {
            fields: {
                ...additionalFields,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(transformedData, updateFields)
            },
            update: (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(transformedData, updateFields),
            ...!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueList) && {
                issueList: issueList
            },
            transition: undefined,
            watchers: watchers,
            externalToken: (0, $cplCs.default)().toString()
        };
        // @ts-expect-error - TS2322 - Type '{ id: string; }' is not assignable to type 'undefined'.
        if (transition) payload.transition = transition;
        (0, $1Nspv.GlobalIssueCreateModalSubmitUFOExperience).start();
        const getCollapsedFields = ()=>!hasIssueAdjustmentModules && fieldTabs ? fieldTabs.flatMap((tab)=>tab.collapsedItems || []) : [];
        const MAX_RETRIES = 1;
        const performPostRequestRetry = (retryCount)=>{
            const analyticsEvent = createAnalyticsEvent({});
            return (0, $daCGe.performPost)((0, $3M1CO.transformCreateIssueUrl)({
                issueUrl: (0, $bEouw.getCreateIssueUrl)({
                    isCreateLinkedIssue: isCreateLinkedIssue || false,
                    skipAutoWatch: skipAutoWatch
                }),
                selectedCloudId: selectedCloudId
            }), {
                body: JSON.stringify(payload)
            }).then((issueCreateResponse)=>{
                let issueCreateFieldsUsed; // TODO Delete this and create const when cleaning migrate_gic_smart_fields_jira_labs
                const statusWasSet = issueCreateResponse && issueCreateResponse.transition !== undefined;
                const collapsedFields = getCollapsedFields();
                let modifiedFieldConfig = fieldConfig;
                let modifiedFormData = formData;
                let modifiedInteractedFields = interactedFields;
                // If the form has a status field provided, the formConfig and formData
                // will be modified on `transformDataToIssueCreateFieldsUsed` to have the
                // hasDefaultValue and isPopulated attributes set to true for status. If the user
                // has modified the status field, the response of the API will return a transition props
                // which is used to modify the interactedFields to set hasInteractedWith to true for status.
                if (shouldShowStatus) {
                    modifiedFieldConfig = {
                        ...fieldConfig,
                        status: {
                            ...fieldConfig.status,
                            defaultValue: true
                        }
                    };
                    modifiedFormData = {
                        ...formData,
                        status: true
                    };
                    if (statusWasSet) modifiedInteractedFields = {
                        ...interactedFields,
                        status: true
                    };
                }
                if ((0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) issueCreateFieldsUsed = (0, $bEouw.transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields, collapsedFields);
                else issueCreateFieldsUsed = (0, $bEouw.transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields);
                const issueCreateContextUsed = (0, $bEouw.transformContextDataUsedForCreate)(context);
                (0, $1Nspv.CreateIssueUFOExperience).success();
                (0, $1Nspv.GlobalIssueCreateModalSubmitUFOExperience).success();
                if (issueCreateResponse?.transition?.status && issueCreateResponse.transition.status !== 200) (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'transitionIssue',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        status: issueCreateResponse.transition.status,
                        message: (issueCreateResponse.transition.errorCollection?.errorMessages || []).join('\n')
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const collapsedFieldsLength = collapsedFields.length;
                onSuccess({
                    issueCreateResponse: issueCreateResponse,
                    issueCreateFieldsUsed: issueCreateFieldsUsed,
                    issueCreateContextUsed: issueCreateContextUsed,
                    collapsedFieldsLength: collapsedFieldsLength
                });
                const attributes = {
                    isRetry: retryCount < MAX_RETRIES,
                    statusCode: '2xx'
                };
                (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
            }).catch((error)=>{
                if (String(error.statusCode).startsWith('5')) {
                    if (retryCount < MAX_RETRIES) {
                        const attributes = {
                            isRetry: true,
                            statusCode: '5xx'
                        };
                        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
                    }
                    if (retryCount > 0) return performPostRequestRetry(retryCount - 1);
                }
                let statusCode;
                if (error instanceof (0, $jJZqs.default)) statusCode = error?.statusCode;
                fireErrorAnalyticsEvent({
                    meta: {
                        id: 'useCreateIssueService',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    statusCode: statusCode
                });
                (0, $1Nspv.CreateIssueUFOExperience).failure();
                (0, $1Nspv.GlobalIssueCreateModalSubmitUFOExperience).failure();
                throw error;
            });
        };
        return performPostRequestRetry(MAX_RETRIES);
    };
    return [
        createIssue
    ];
};
var $6f965259f40571ce$export$2e2bcd8739ae039 = $6f965259f40571ce$var$useCreateIssueService;

});
parcelRegister("cplCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93bae87fe11db2e$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Alternative implementation of random numbers for the browser.
const $d93bae87fe11db2e$var$MAX_UINT32 = 4294967296;
function $d93bae87fe11db2e$export$2e2bcd8739ae039() {
    try {
        const buf = new Uint32Array(1);
        // buf now has a random uint32 value
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.crypto.getRandomValues(buf);
        // Turn it back into a value in [0,1)
        return buf[0] / $d93bae87fe11db2e$var$MAX_UINT32;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Math.random();
    }
}

});

parcelRegister("daCGe", function(module, exports) {

$parcel$export(module.exports, "performPost", () => $d96b0a5921fffd0a$export$8fc3e0df78e1e7f5);


var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $eusud = parcelRequire("eusud");

var $iwPwz = parcelRequire("iwPwz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d96b0a5921fffd0a$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d96b0a5921fffd0a$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $d96b0a5921fffd0a$var$handleErrors = async (response)=>{
    const clone = response.clone();
    const res = await response.json();
    const traceId = (0, $iwPwz.getTraceId)(response);
    // handle CONFLICT and TOO_MANY_REQUESTS using validation error handlers.
    if ([
        (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
        (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f),
        (0, $3cd8a0ece36fbae5$export$6763168a631449a2),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07),
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$a447d0a965e16776)
    ].find((i)=>i === response.status)) throw (0, $eusud.transformValidationErrorFromServer)(res, response.status, traceId);
    if (res?.errorMessages) throw res.errorMessages.join('\n');
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
    }
    return clone;
};
const $d96b0a5921fffd0a$export$8fc3e0df78e1e7f5 = (url, options = {})=>{
    const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
    const mergedOpts = {
        ...defaultOptions,
        ...options,
        method: 'POST',
        headers: {
            ...defaultOptions.headers,
            ...options.headers
        }
    };
    return fetch(url, mergedOpts).then($d96b0a5921fffd0a$var$handleErrors).then($d96b0a5921fffd0a$var$processResponseFromServer).catch($d96b0a5921fffd0a$var$handleNetworkErrors);
};

});

parcelRegister("bEouw", function(module, exports) {

$parcel$export(module.exports, "getCreateIssueUrl", () => $08caf312abbfcdbb$export$a92012cc19d68266);
$parcel$export(module.exports, "transformData", () => $08caf312abbfcdbb$export$3ceb62baab058c6b);
$parcel$export(module.exports, "transformDataToIssueCreateFieldsUsed", () => $08caf312abbfcdbb$export$cd0a7e468fa77da3);
$parcel$export(module.exports, "transformContextDataUsedForCreate", () => $08caf312abbfcdbb$export$59dd9eec92eadfdd);
$parcel$export(module.exports, "handleCopyLinksAndAttachments", () => $08caf312abbfcdbb$export$16a7d356b78628b0);
$parcel$export(module.exports, "getUpdateFields", () => $08caf312abbfcdbb$export$3312ec73143db50);

var $gccSB = parcelRequire("gccSB");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $gItVn = parcelRequire("gItVn");
const $08caf312abbfcdbb$export$a92012cc19d68266 = ({ isCreateLinkedIssue: isCreateLinkedIssue = false, skipAutoWatch: skipAutoWatch = false })=>{
    const urlSearchParams = new URLSearchParams('updateHistory=true&applyDefaultValues=false');
    if (isCreateLinkedIssue && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view')) urlSearchParams.append('fromCreateLinkedIssueScreen', 'true');
    if (skipAutoWatch) urlSearchParams.append('skipAutoWatch', 'true');
    return `/rest/api/3/issue?${urlSearchParams.toString()}`;
};
const $08caf312abbfcdbb$export$3ceb62baab058c6b = (formData, fieldConfig)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(formData).reduce((acc, fieldId)=>{
        // context fields are not part of field config
        const fieldData = fieldConfig[fieldId];
        if (fieldData) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
            const transformFunction = (0, $gItVn.getGqlFieldMap)()[fieldData.gqlType]?.submitTransform;
            const transformedData = transformFunction && formData[fieldId] !== null && formData[fieldId] !== undefined ? transformFunction(formData[fieldId]) : formData[fieldId];
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return {
                ...acc,
                [fieldId]: transformedData
            };
        }
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return {
            ...acc,
            [fieldId]: formData[fieldId]
        };
    }, {});
const $08caf312abbfcdbb$export$95572daab36eec17 = (fieldValue)=>{
    if (typeof fieldValue === 'object' && fieldValue !== null) {
        // check for linked issue field
        if ('issues' in fieldValue) return fieldValue.issues.length > 0;
        // check for rich text field
        if ('content' in fieldValue && 'version' in fieldValue && 'type' in fieldValue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return !(0, $fCo6Y.isOnlyWhitespaceAdf)(fieldValue);
    }
    return typeof fieldValue === 'number' || typeof fieldValue === 'boolean' || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(fieldValue);
};
const $08caf312abbfcdbb$export$cd0a7e468fa77da3 = (formData, fieldConfig, interactedFields, collapsedFields)=>{
    const issueCreateFieldsUsed = [];
    Object.keys(fieldConfig).forEach((fieldId)=>{
        const fieldValue = formData[fieldId];
        issueCreateFieldsUsed.push({
            issueFieldId: fieldId,
            issueFieldType: fieldConfig[fieldId].fieldType,
            gqlType: fieldConfig[fieldId].gqlType,
            isPopulated: $08caf312abbfcdbb$export$95572daab36eec17(fieldValue),
            isRequired: !!fieldConfig[fieldId].isRequired,
            hasDefaultValue: !!fieldConfig[fieldId].defaultValue,
            wasInteractedWith: !!interactedFields?.[fieldId],
            // eslint-disable-next-line jira/ff/no-preconditioning
            ...(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && collapsedFields && collapsedFields.length > 0 && {
                wasCollapsed: collapsedFields.includes(fieldId)
            }
        });
    });
    // @ts-expect-error - TS7005 - Variable 'issueCreateFieldsUsed' implicitly has an 'any[]' type.
    return issueCreateFieldsUsed;
};
const $08caf312abbfcdbb$export$59dd9eec92eadfdd = (context)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(context)) return {};
    return {
        wereAdditionalFieldsProvided: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(context?.submitApiData?.additionalFields),
        isIssueListProvided: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(context?.submitApiData?.issueList?.addTo)
    };
};
const $08caf312abbfcdbb$export$4c4230f34434cbdf = ({ attachments: attachments, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
        ...attachments ? [
            {
                set: attachments
            }
        ] : [],
        ...issueLinksValue?.includeAttachments ? [
            {
                copy: {
                    sourceIssues: [
                        {
                            key: sourceIssueKey
                        }
                    ]
                }
            }
        ] : []
    ];
const $08caf312abbfcdbb$export$8310c11186fc8627 = ({ issueLinksTransformedData: issueLinksTransformedData, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
        ...issueLinksTransformedData || [],
        ...issueLinksValue?.includeLinks ? [
            {
                copy: {
                    sourceIssues: [
                        {
                            key: sourceIssueKey
                        }
                    ]
                }
            }
        ] : []
    ];
const $08caf312abbfcdbb$export$16a7d356b78628b0 = ({ transformedData: transformedData, formData: formData, sourceIssueKey: sourceIssueKey })=>{
    const issueLinksValue = formData[0, $5fc53.ISSUE_LINKS_TYPE];
    return {
        ...transformedData,
        [(0, $5fc53.ATTACHMENT_TYPE)]: $08caf312abbfcdbb$export$4c4230f34434cbdf({
            attachments: transformedData[0, $5fc53.ATTACHMENT_TYPE],
            issueLinksValue: issueLinksValue,
            sourceIssueKey: sourceIssueKey
        }),
        [(0, $5fc53.ISSUE_LINKS_TYPE)]: $08caf312abbfcdbb$export$8310c11186fc8627({
            issueLinksTransformedData: transformedData[0, $5fc53.ISSUE_LINKS_TYPE],
            issueLinksValue: issueLinksValue,
            sourceIssueKey: sourceIssueKey
        })
    };
};
const $08caf312abbfcdbb$export$3312ec73143db50 = (isCreateLinkedIssue = false)=>isCreateLinkedIssue ? (0, $gItVn.UPDATE_FIELDS_CREATE_LINKED_ISSUE) : (0, $gItVn.UPDATE_FIELDS);

});
parcelRegister("fCo6Y", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $79bd166f69131b05$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $79bd166f69131b05$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $79bd166f69131b05$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $79bd166f69131b05$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $79bd166f69131b05$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $79bd166f69131b05$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $79bd166f69131b05$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $79bd166f69131b05$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $79bd166f69131b05$export$80a6e90c7b29d88c);

var $lmhF9 = parcelRequire("lmhF9");
var $l1C1k = parcelRequire("l1C1k");

var $2YZCu = parcelRequire("2YZCu");
const $79bd166f69131b05$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
    };
    return adf;
};
const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $79bd166f69131b05$export$9e9311e676291037(adf);
};
const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $l1C1k.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $l1C1k.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $l1C1k.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $lmhF9.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("kOFhM")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await Promise.resolve((parcelRequire("dN5CS")));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("hYNZx")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("lmhF9", function(module, exports) {

$parcel$export(module.exports, "filter", () => $cb7d90be6f5f5975$export$3dea766d36a8935f);

var $l1C1k = parcelRequire("l1C1k");
function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});




parcelRegister("02X4k", function(module, exports) {

$parcel$export(module.exports, "useDescriptionAnalytics", () => $49a4907630c8c548$export$df0e1df705c71ad);

var $5uXOq = parcelRequire("5uXOq");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $49a4907630c8c548$export$df0e1df705c71ad = ()=>{
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const [hasSent, setHasSent] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribeFromChange = subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, (data)=>{
            if (!hasSent && data.fieldId === 'description') {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'description',
                    action: 'editStarted'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssueDescriptionTouched');
                setHasSent(true);
            }
        });
        const unsubscribeFromBlur = subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_BLUR, (data)=>{
            if (data.fieldId === 'description') setHasSent(false);
        });
        return ()=>{
            unsubscribeFromChange();
            unsubscribeFromBlur();
        };
    }, [
        createAnalyticsEvent,
        subscribe,
        hasSent,
        setHasSent
    ]);
};

});

parcelRegister("f2cnb", function(module, exports) {

$parcel$export(module.exports, "ActionsContainer", () => $57267ca2380c8d3c$export$48377ae1c677702b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $45Cy1 = parcelRequire("45Cy1");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");

var $c0dQj = parcelRequire("c0dQj");

var $akFPq = parcelRequire("akFPq");

var $cWvpX = parcelRequire("cWvpX");
const $57267ca2380c8d3c$export$48377ae1c677702b = (props)=>{
    const hasWatchersInitialized = (0, $5uXOq.useRef)(false);
    const [{ dataFetchError: dataFetchError, selectedProject: selectedProject }] = (0, $45Cy1.useFormContext)();
    const { view: view, isTransitionInState: isTransitionInState } = (0, $iUFy5.useMinimizableModal)();
    const shouldDisableActions = dataFetchError !== null;
    const shouldDisableHeaderDropdown = Boolean(shouldDisableActions || selectedProject === null);
    const shouldRenderActionsContainer = view === 'modal' && isTransitionInState([
        'mini'
    ], (0, $kNC83.TransitionState).EXITED) && !(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    if (!shouldRenderActionsContainer) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57267ca2380c8d3c$var$ActionsContainerWrapper, {
        "data-testid": "issue-create.ui.modal.create-form.actions-container.actions-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWvpX.default), {
        configs: props.watchersConfigurations,
        hasWatchersInitialized: hasWatchersInitialized
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $57267ca2380c8d3c$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akFPq.HeaderDropdown), {
        isDisabled: shouldDisableHeaderDropdown,
        fieldConfig: props.fieldConfig
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57267ca2380c8d3c$var$ActionsContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $57267ca2380c8d3c$var$dropdownContainerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("akFPq", function(module, exports) {

$parcel$export(module.exports, "HeaderDropdown", () => $fbfaa47783d19306$export$e93b0271171ef3a);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hYRTO = parcelRequire("hYRTO");

var $c0edv = parcelRequire("c0edv");

var $hyOJh = parcelRequire("hyOJh");

var $kErdU = parcelRequire("kErdU");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $c7ZNt = parcelRequire("c7ZNt");

var $45Cy1 = parcelRequire("45Cy1");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9JXcu = parcelRequire("9JXcu");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $dCm1o = parcelRequire("dCm1o");

var $cWvpX = parcelRequire("cWvpX");

var $axOs5 = parcelRequire("axOs5");

var $b6VJj = parcelRequire("b6VJj");
const $fbfaa47783d19306$var$testId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.dropdown-menu';
const $fbfaa47783d19306$var$buttonTestId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.button';
// TODO: Integrate placeholder back into the dropdown component when cleaning up smart_fields_gic_toggle_fg
const $fbfaa47783d19306$var$LoadingPlaceholder = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "header-dropdown-smart-fields-gic-toggle",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $fbfaa47783d19306$var$loadingPlaceholderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
            width: "100%",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
            width: "100%",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
            width: "100%",
            isShimmering: true
        }))
    }, children);
const $fbfaa47783d19306$export$e93b0271171ef3a = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { isDisabled: isDisabled = false, watchersConfigurations: watchersConfigurations } = props;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, $45Cy1.useFormContext)();
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $9JXcu.default));
    const showConfigureFieldsModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleConfigureFieldsModalVisibility(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'configureFields', {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleFindFieldsModalVisibility(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'findYourField', {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
    const loadSmartFieldsAdminToggleQuery = (0, $5uXOq.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery
    ]);
    // @ts-expect-error - TS7006 - Parameter 'attributes' implicitly has an 'any' type.
    const onOpenChange = (attributes)=>{
        if (attributes.isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'meatballMenu');
            if ((0, $4R6GH.fg)('smart_fields_gic_toggle_fg')) loadSmartFieldsAdminToggleQuery();
        }
    };
    const disableDropdown = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? isDisabled && !watchersConfigurations?.canManageWatchers && !watchersConfigurations?.isWatchersEnabled : isDisabled;
    const shouldShowDropdownActions = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? !isDisabled : true;
    const Wrapper = (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? $fbfaa47783d19306$var$LoadingPlaceholder : (0, $5uXOq.Fragment);
    const fieldIcon = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c0edv))), {
        label: ""
    }) : null;
    const findFieldsIcon = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
        label: ""
    }) : null;
    const attributes = (0, $5uXOq.useMemo)(()=>({
            shouldShowDropdownActions: shouldShowDropdownActions,
            disableDropdown: disableDropdown,
            isDisabled: isDisabled,
            isAdmin: isAdmin
        }), [
        disableDropdown,
        isAdmin,
        isDisabled,
        shouldShowDropdownActions
    ]);
    const getAriaLabel = ()=>{
        if (selectedIssueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $axOs5.default).moreActionsIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $axOs5.default).moreActionsIssueTermRefresh;
        return (0, $axOs5.default).moreActions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...dropdownProps,
                testId: $fbfaa47783d19306$var$buttonTestId,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    spacing: "spacious",
                    label: ""
                }),
                appearance: "subtle",
                isDisabled: disableDropdown,
                ref: triggerRef,
                "aria-label": formatMessage(getAriaLabel(), {
                    issueType: selectedIssueType?.label
                })
            }),
        onOpenChange: onOpenChange,
        testId: $fbfaa47783d19306$var$testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, shouldShowDropdownActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: fieldIcon,
        onClick: showConfigureFieldsModal
    }, (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? formatMessage((0, $axOs5.default).configureFields) : formatMessage((0, $axOs5.default).showFields)), queryReference && (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "smartFieldsGicToggleDropdownItem",
        packageName: "jiraIssueCreate",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true,
        ...(0, $4R6GH.fg)('jira-issue-create-error-boundary-enabled') ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6VJj.SmartFieldsDropdownItem), {
        queryReference: queryReference
    })) : null, showFindFieldOption() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: findFieldsIcon,
        onClick: showFindFieldModal
    }, formatMessage((0, $axOs5.default).findField))), (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWvpX.default), {
        configs: watchersConfigurations,
        shouldRenderInDropdown: true
    }))));
};
const $fbfaa47783d19306$var$loadingPlaceholderStyles = (0, $8CUq3.xcss)({
    width: '204px'
});

});
parcelRegister("c0edv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1e5a4eb83a5a00b95d06a6a3097fd6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bd0834c72dd821c$var$_react = $8bd0834c72dd821c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bd0834c72dd821c$var$_baseNew = $8bd0834c72dd821c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8bd0834c72dd821c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Field".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bd0834c72dd821c$var$FieldIcon = (props)=>/*#__PURE__*/ $8bd0834c72dd821c$var$_react.default.createElement($8bd0834c72dd821c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 3.5H0V2h6zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$8bd0834c72dd821c$var$FieldIcon.displayName = 'FieldIcon';
var $8bd0834c72dd821c$var$_default = module.exports.default = $8bd0834c72dd821c$var$FieldIcon;

});

parcelRegister("9JXcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aa88ec833f9083b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72906e81947dc5d47c9f5429e734d838>>
 * @relayHash 9e85dcc1f5052b15ad984ce04355a81b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68
const $5aa88ec833f9083b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "jira.create.smart.fields.is-enabled"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "smartfieldsDropdownItemAdminToggleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "smartfieldsDropdownItemAdminToggleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68",
            "metadata": {},
            "name": "smartfieldsDropdownItemAdminToggleQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5aa88ec833f9083b$var$node.hash = "dd574875cb62c2e1fc5d67c9f05f7bcf";
var $5aa88ec833f9083b$export$2e2bcd8739ae039 = $5aa88ec833f9083b$var$node;

});

parcelRegister("cWvpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $723322a375d88c13$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eh4UB = parcelRequire("eh4UB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$723322a375d88c13$export$2e2bcd8739ae039 = (props)=>{
    if (!props.configs?.canManageWatchers) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eh4UB.default), props);
};

});
parcelRegister("eh4UB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d774e6d7fcd5fe2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9fuVs = parcelRequire("9fuVs");

var $2vSU6 = parcelRequire("2vSU6");

var $45Cy1 = parcelRequire("45Cy1");

var $bq3cD = parcelRequire("bq3cD");

var $g84D6 = parcelRequire("g84D6");

var $cYlk7 = parcelRequire("cYlk7");
const $4d774e6d7fcd5fe2$var$Watchers = ({ configs: configs, shouldRenderInDropdown: shouldRenderInDropdown, hasWatchersInitialized: hasWatchersInitializedForNewModal })=>{
    const hasWatchersInitializedForOldModal = (0, $5uXOq.useRef)(false);
    /**
	 * For new modal, the modal can be minimized due to 3-stage-create, and if it is minimized the component
	 * is completely unmounted. un-minimizing the modal would lead to the default users being added again if
	 * they have remove themselves earlier. Which means keeping track of that only within this component is
	 * impossible, so that we have to declare the ref one level up which would not be unmounted on `modal-view-change`.
	 *
	 * For old modal tho, the `hasWatchersInitializedForNewModal` would be `undefined` because the old modal is rendered from
	 * a complete different place. And for old modal, having a ref within this component is more than enough.
	 */ const hasWatchersInitialized = hasWatchersInitializedForNewModal || hasWatchersInitializedForOldModal;
    const { isAutoWatchEnabled: isAutoWatchEnabled, isWatchersEnabled: isWatchersEnabled } = configs || {};
    const { data: { user: currentUser }, loading: loading, error: error } = (0, $cYlk7.useCurrentUser)(); // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const [{ watchers: watchers, selectedProject: selectedProject }, { setWatchers: setWatchers }] = (0, $45Cy1.useFormContext)();
    const shouldShowWatchers = selectedProject && configs && !currentUser.isAnonymous && !loading && !error && // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    selectedProject.projectType !== (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT);
    const isWatching = watchers.some((watcher)=>watcher.accountId === currentUser.accountId);
    /**
	 * The current user is the default user in the list because isAutoWatchEnabled is turned on
	 * so the current user would be added to the list on init.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (isAutoWatchEnabled && shouldShowWatchers && currentUser && !hasWatchersInitialized.current && !isWatching) {
            setWatchers([
                ...watchers,
                currentUser
            ]);
            hasWatchersInitialized.current = true;
        }
    }, [
        currentUser,
        shouldShowWatchers,
        isAutoWatchEnabled,
        setWatchers,
        watchers,
        isWatching,
        hasWatchersInitialized
    ]);
    if (!shouldShowWatchers || !isWatchersEnabled && shouldRenderInDropdown) return null;
    if (!isWatchersEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g84D6.default), {
        isDisabled: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bq3cD.default), {
        watchers: watchers,
        projectKey: selectedProject.projectKey,
        setWatchers: setWatchers,
        isWatching: isWatching,
        currentUser: currentUser,
        shouldRenderInDropdown: shouldRenderInDropdown,
        ...configs
    }));
};
var $4d774e6d7fcd5fe2$export$2e2bcd8739ae039 = $4d774e6d7fcd5fe2$var$Watchers;

});
parcelRegister("bq3cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2ab776e90af69e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a2ab776e90af69e0$var$AsyncWatchers = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("fJrMH")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-watchers/src/ui/main.tsx"
});
const $a2ab776e90af69e0$var$Watchers = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-issue-create-watchers",
        packageName: "jiraIssueCreateWatchers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-create-watchers-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2ab776e90af69e0$var$AsyncWatchers, props)));
var $a2ab776e90af69e0$export$2e2bcd8739ae039 = $a2ab776e90af69e0$var$Watchers;

});
parcelRegister("fJrMH", function(module, exports) {

let $b7409c622cbef94d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7409c622cbef94d$var$load("a4p3d").then(()=>parcelRequire('jgRch'));

});


parcelRegister("g84D6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd8a4c925632328$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $6N55R = parcelRequire("6N55R");
const $5dd8a4c925632328$var$BaseButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dd8a4c925632328$var$Container, {
        "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "subtle",
        spacing: "default",
        ref: ref
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dd8a4c925632328$var$ButtonContent, {
        "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.watch-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5dd8a4c925632328$var$ButtonIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6N55R))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }))))));
var $5dd8a4c925632328$export$2e2bcd8739ae039 = $5dd8a4c925632328$var$BaseButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5dd8a4c925632328$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _2hwxu2gc _i1wwidpf _8ax31b66 _ake1idpf _1gqw1b66 _a7a01txw _18iz1h6o",
            __cmplp.className
        ])
    });
});
const $5dd8a4c925632328$var$ButtonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5dd8a4c925632328$var$ButtonIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6N55R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a052784e02c39e1ef8b9f184efeeb6e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f1b452bc077b279$var$_react = $4f1b452bc077b279$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4f1b452bc077b279$var$_eyeOpen = $4f1b452bc077b279$var$_interopRequireDefault((parcelRequire("7eUVi")));

var $4f1b452bc077b279$var$_watch = $4f1b452bc077b279$var$_interopRequireDefault((parcelRequire("bH0nF")));
function $4f1b452bc077b279$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EyeOpenIcon.
 * This component is EyeOpenIcon, with `UNSAFE_fallbackIcon` set to "WatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f1b452bc077b279$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $4f1b452bc077b279$var$_react.default.createElement($4f1b452bc077b279$var$_eyeOpen.default, Object.assign({
        LEGACY_fallbackIcon: $4f1b452bc077b279$var$_watch.default
    }, props));
$4f1b452bc077b279$var$EyeOpenIcon.Name = 'EyeOpenIconMigration';
var $4f1b452bc077b279$var$_default = module.exports.default = $4f1b452bc077b279$var$EyeOpenIcon;

});
parcelRegister("7eUVi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5455fef624dfcc70$var$_react = $5455fef624dfcc70$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5455fef624dfcc70$var$_baseNew = $5455fef624dfcc70$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5455fef624dfcc70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5455fef624dfcc70$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $5455fef624dfcc70$var$_react.default.createElement($5455fef624dfcc70$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$5455fef624dfcc70$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $5455fef624dfcc70$var$_default = module.exports.default = $5455fef624dfcc70$var$EyeOpenIcon;

});

parcelRegister("bH0nF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8834017b673aa7e1$var$_react = $8834017b673aa7e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8834017b673aa7e1$var$_eyeOpen = $8834017b673aa7e1$var$_interopRequireDefault((parcelRequire("7eUVi")));
function $8834017b673aa7e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8834017b673aa7e1$var$WatchIcon = (props)=>/*#__PURE__*/ $8834017b673aa7e1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $8834017b673aa7e1$var$_eyeOpen.default
    }));
$8834017b673aa7e1$var$WatchIcon.displayName = 'WatchIcon';
var $8834017b673aa7e1$var$_default = module.exports.default = $8834017b673aa7e1$var$WatchIcon;

});





parcelRegister("axOs5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce4ca280af153f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ce4ca280af153f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // TODO: Remove when cleaning up smart_fields_gic_toggle_fg
    showFields: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.show-fields",
        "defaultMessage": "Show fields"
    },
    configureFields: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.configure-fields",
        "defaultMessage": "Configure fields"
    },
    findField: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.find-field",
        "defaultMessage": "Find your field"
    },
    moreActions: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions",
        "defaultMessage": "More actions for this issue"
    },
    moreActionsIssueTermRefresh: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-term-refresh",
        "defaultMessage": "More actions for this work item"
    },
    moreActionsIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-terminology-refresh-m4",
        "defaultMessage": "More actions for this {issueType}"
    }
});

});

parcelRegister("b6VJj", function(module, exports) {

$parcel$export(module.exports, "SmartFieldsDropdownItem", () => $156daf98187ae82d$export$7e458a2926172360);

var $9JXcu = parcelRequire("9JXcu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6B7KL = parcelRequire("6B7KL");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $6C81H = parcelRequire("6C81H");

var $6paOF = parcelRequire("6paOF");

var $koVbs = parcelRequire("koVbs");

var $45Cy1 = parcelRequire("45Cy1");


var $gEEzS = parcelRequire("gEEzS");

var $8zOmE = parcelRequire("8zOmE");

var $aA974 = parcelRequire("aA974");

var $2YP9W = parcelRequire("2YP9W");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $1r5Yg = parcelRequire("1r5Yg");
const $156daf98187ae82d$var$CustomToggleButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isChecked: isChecked, onChange: onChange, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.100",
        xcss: $156daf98187ae82d$var$customButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: "toggle-smart-fields"
    }, formatMessage((0, $1r5Yg.default).smartFieldsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        ...props,
        id: "toggle-smart-fields",
        isChecked: isChecked,
        onChange: onChange,
        ref: ref
    }));
});
const $156daf98187ae82d$var$VisuallyRefreshedCustomToggleButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isChecked: isChecked, onChange: onChange, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $156daf98187ae82d$var$customButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6C81H))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: "toggle-smart-fields"
    }, formatMessage((0, $1r5Yg.default).smartFieldsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        ...props,
        id: "toggle-smart-fields",
        isChecked: isChecked,
        onChange: onChange,
        ref: ref
    })));
});
const $156daf98187ae82d$var$CustomToggleButtonComponent = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6'), $156daf98187ae82d$var$VisuallyRefreshedCustomToggleButton, $156daf98187ae82d$var$CustomToggleButton);
const $156daf98187ae82d$export$f66e1f764818b2e = ()=>(0, $2YP9W.useResource)((0, $aA974.gicSmartFieldsFeatureResource));
const $156daf98187ae82d$export$7e458a2926172360 = ({ queryReference: queryReference })=>{
    const { loading: loading, data: data, update: updateResource } = $156daf98187ae82d$export$f66e1f764818b2e();
    const { updatePreferences: updatePreferences } = (0, $gEEzS.useSmartFieldsUpdateUserPreference)();
    const { setIsSmartFieldsToggled: setIsSmartFieldsToggled } = (0, $45Cy1.useFormContextActions)();
    const adminToggleStateData = (0, $8Uumt.usePreloadedQuery)((0, $9JXcu.default), queryReference);
    const hasUserOptedOut = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserOptedOut === 'boolean' ? data.hasUserOptedOut : false, [
        data
    ]);
    const hasUserDismissedReadMore = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false, [
        data
    ]);
    const hasUserDismissedGicOnboarding = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false, [
        data
    ]);
    const handleHideUnusedFieldsChange = async (_, analyticsEventUI)=>{
        const value = !hasUserOptedOut;
        updateResource(()=>({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleGicSmartFields', {
            isSmartFieldsOptOut: value
        });
        try {
            await updatePreferences({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            });
            setIsSmartFieldsToggled(true);
        } catch (err) {
            updateResource(()=>({
                    hasUserOptedOut: hasUserOptedOut,
                    hasUserDismissedReadMore: hasUserDismissedReadMore,
                    hasUserDismissedGicOnboarding: hasUserDismissedGicOnboarding
                }));
            const error = err instanceof Error ? err : new Error('GIC Smart Fields: Unknown error while toggling user preference');
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'toggleGicSmartFields',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                }
            });
        }
    };
    const hasAdminDisabledSmartFields = (0, $5uXOq.useMemo)(()=>adminToggleStateData?.jira?.applicationPropertiesByKey?.filter((item)=>item.key === (0, $a11a54266737e598$export$5781c9f38e6a61fe))[0]?.value === 'false', [
        adminToggleStateData
    ]);
    if (loading || hasAdminDisabledSmartFields) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        // @ts-expect-error - TS2322 - Dynamic component typing is broken in the platform package
        component: $156daf98187ae82d$var$CustomToggleButtonComponent,
        isChecked: !hasUserOptedOut,
        onChange: handleHideUnusedFieldsChange
    });
};
const $156daf98187ae82d$var$customButtonStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.200',
    paddingBlock: 'space.100'
});

});
parcelRegister("6C81H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c90f995a462686dc43276b76786a54f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $013e232b862e20a6$var$_react = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $013e232b862e20a6$var$_baseNew = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $013e232b862e20a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $013e232b862e20a6$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $013e232b862e20a6$var$_react.default.createElement($013e232b862e20a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$013e232b862e20a6$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $013e232b862e20a6$var$_default = module.exports.default = $013e232b862e20a6$var$EyeOpenStrikethroughIcon;

});

parcelRegister("1r5Yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $58666566a51e36c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58666566a51e36c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    smartFieldsLabel: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.smartfields-dropdown-item.smart-fields-label",
        "defaultMessage": "Hide unused fields"
    }
});

});




parcelRegister("fp4bR", function(module, exports) {

$parcel$export(module.exports, "ExternalControlsRenderer", () => $054cbdd0c0a5e4b2$export$1f4f83075c603162);

var $5uXOq = parcelRequire("5uXOq");

var $kErdU = parcelRequire("kErdU");

var $hULKg = parcelRequire("hULKg");

var $gt8ej = parcelRequire("gt8ej");
const $054cbdd0c0a5e4b2$var$Controls = ({ externalControls: externalControls, getFormState: getFormState, setFieldValue: setFieldValue })=>{
    const formAPI = (0, $5uXOq.useMemo)(()=>({
            getFormState: getFormState,
            setFieldValue: setFieldValue
        }), [
        getFormState,
        setFieldValue
    ]);
    const { fieldAPI: fieldAPI, getFormFieldValue: getFormFieldValue } = (0, $gt8ej.useExternalControlsAPI)(formAPI);
    const { Component: Component } = externalControls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        fieldAPI: fieldAPI,
        getFormFieldValue: getFormFieldValue
    });
};
const $054cbdd0c0a5e4b2$export$1f4f83075c603162 = ({ externalControls: externalControls, getFormState: getFormState, setFieldValue: setFieldValue })=>{
    if (externalControls && getFormState && setFieldValue && (0, $hULKg.ALLOWED_EXTERNAL_CONTROLS).TRIGGER_POINTS.includes(externalControls.triggerPoint)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "externalControlsRenderer",
        packageName: "jiraIssueCreate",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($054cbdd0c0a5e4b2$var$Controls, {
        externalControls: externalControls,
        getFormState: getFormState,
        setFieldValue: setFieldValue
    }));
    return null;
};

});
parcelRegister("gt8ej", function(module, exports) {

$parcel$export(module.exports, "useExternalControlsAPI", () => $d0f9c9622d0b480c$export$b6e86f46675e84e5);

var $5uXOq = parcelRequire("5uXOq");

var $hULKg = parcelRequire("hULKg");
const $d0f9c9622d0b480c$export$b6e86f46675e84e5 = ({ getFormState: getFormState, setFieldValue: setFieldValue })=>{
    const getFormFieldValue = (0, $5uXOq.useCallback)((fieldId)=>getFormState()?.values[fieldId], [
        getFormState
    ]);
    const fieldAPI = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const allowedFieldAPI = {};
        (0, $hULKg.ALLOWED_EXTERNAL_CONTROLS).FIELD_IDS.forEach((fieldId)=>{
            allowedFieldAPI[fieldId] = {
                getValue: ()=>getFormFieldValue(fieldId),
                setValue: (value)=>setFieldValue(fieldId, value)
            };
        });
        return allowedFieldAPI;
    }, [
        setFieldValue,
        getFormFieldValue
    ]);
    return {
        fieldAPI: fieldAPI,
        getFormFieldValue: getFormFieldValue
    };
};

});


parcelRegister("7kEHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6b4c30e66dfce2e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");

var $4R6GH = parcelRequire("4R6GH");

var $jOoNW = parcelRequire("jOoNW");

var $hfG3v = parcelRequire("hfG3v");

var $45Cy1 = parcelRequire("45Cy1");

var $6gjIc = parcelRequire("6gjIc");

var $fGCY8 = parcelRequire("fGCY8");

var $cu7BW = parcelRequire("cu7BW");
const $a6b4c30e66dfce2e$export$1547cfa441087995 = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded -- magnetic-di does not work automatically with ternary components. it needs to have the `di`
    (0, $gKZoD.di)((0, $fGCY8.default), (0, $cu7BW.FieldsContainer));
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig, getFormState: getFormState, setFieldValue: setFieldValue, apiLatency: apiLatency, optOutSmartFieldIds: optOutSmartFieldIds } = props;
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ currentActiveTabIndex: currentActiveTabIndex }, { setCurrentActiveTabIndex: setCurrentActiveTabIndex }] = (0, $45Cy1.useFormContext)();
    const tabs = (0, $5uXOq.useMemo)(()=>fieldTabs.map(({ id: id, tabId: tabId, name: name, items: items, collapsedItems: collapsedItems })=>({
                id: tabId || id,
                name: name,
                content: null,
                testId: id,
                items: items,
                collapsedItems: collapsedItems
            })), [
        fieldTabs
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSelect = (_, selectedIndex)=>{
        setCurrentActiveTabIndex(selectedIndex);
    };
    const handleChange = (index)=>{
        onSelect(null, index);
    };
    const { hasValidationErrors: hasValidationErrors, submitFailed: submitFailed } = getFormState();
    const { controlledTabs: controlledTabs, controlledSelected: controlledSelected, controlledOnChange: controlledOnChange } = (0, $jOoNW.useScreenTabs)({
        tabs: tabs,
        viewProps: {
            shouldDisableScreenTabsControl: hasValidationErrors && submitFailed
        },
        selected: currentActiveTabIndex,
        onChange: handleChange
    });
    if (!fieldTabs.length) return null;
    // TODO When cleaning migrate_gic_smart_fields_jira_labs, move FieldsContainer to inline instead of using ComponentToRender
    const ComponentToRender = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? (0, $cu7BW.FieldsContainer) : (0, $fGCY8.default);
    if (fieldTabs.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
        fieldConfig: fieldConfig,
        fields: fieldTabs[0].items,
        ...(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && {
            collapsedFields: fieldTabs[0].collapsedItems,
            FieldRenderer: $fGCY8.default,
            tabIndex: 0
        },
        optOutSmartFieldIds: optOutSmartFieldIds,
        apiLatency: apiLatency,
        getFormState: getFormState,
        setFieldValue: setFieldValue,
        fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
    });
    const getTabsList = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
            testId: "issue-create.ui.modal.create-form.layout-renderer.layout-rerender-tabs",
            selected: controlledSelected,
            onChange: controlledOnChange,
            id: "issue-create-modal-tabs",
            shouldUnmountTabPanelOnChange: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, controlledTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfG3v.ConditionallyVisibleDiv), {
                key: tab.id,
                isVisible: tab.isVisible
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
                testId: tab.testId,
                key: tab.id
            }, tab.name))))), controlledTabs.map(({ id: id, items: items, collapsedItems: collapsedItems, testId: testId }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfG3v.ConditionallyVisibleDiv), {
                id: `issue-create-modal-tabs-${index}-tab`,
                role: "tabpanel",
                key: id,
                isVisible: index === controlledSelected,
                testId: `tab-content-${testId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                fieldConfig: fieldConfig,
                fields: items,
                ...(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && {
                    collapsedFields: collapsedItems,
                    FieldRenderer: $fGCY8.default,
                    tabIndex: index
                },
                optOutSmartFieldIds: optOutSmartFieldIds,
                getFormState: getFormState,
                setFieldValue: setFieldValue,
                apiLatency: apiLatency,
                fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
            }))));
    return (0, $4R6GH.fg)('show-all-tabs-in-create-and-transition-screen') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6b4c30e66dfce2e$var$TabsWrapper, null, getTabsList()) : getTabsList();
};
var $a6b4c30e66dfce2e$export$2e2bcd8739ae039 = $a6b4c30e66dfce2e$export$1547cfa441087995;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a6b4c30e66dfce2e$var$TabsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1jwa1g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $dS3PR = parcelRequire("dS3PR");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "medium",
                color: "inherit",
                maxLines: 1,
                children: children
            })
        })
    });
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("jOoNW", function(module, exports) {

$parcel$export(module.exports, "useScreenTabs", () => $e2e01ed6261167ee$export$64c8d02894d27e32);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $2NMNM = parcelRequire("2NMNM");

var $jrwZp = parcelRequire("jrwZp");

var $2jmyj = parcelRequire("2jmyj");

var $7mgyX = parcelRequire("7mgyX");

var $1YewZ = parcelRequire("1YewZ");

var $PVYFb = parcelRequire("PVYFb");
const $e2e01ed6261167ee$export$64c8d02894d27e32 = ({ tabs: tabs, viewProps: viewProps, selected: selected, onChange: onChange })=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $7mgyX.useViewType), (0, $1YewZ.useAdjustedScreenTabs), (0, $2jmyj.useTriggerFieldInitialization));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const viewType = (0, $7mgyX.useViewType)();
    const [adjustedScreenTabs, { initializeNoScreenTab: initializeNoScreenTab, initializeScreenTabs: initializeScreenTabs, updateActiveScreenTab: updateActiveScreenTab }] = (0, $1YewZ.useAdjustedScreenTabs)();
    const memoizedTabs = (0, $PVYFb.useMemoizedTabs)(tabs);
    const [triggerFieldInitializationKey] = (0, $2jmyj.useTriggerFieldInitialization)();
    const selectedRef = (0, $5uXOq.useRef)(selected);
    // Always refreshes `selectedRef` value using their props value
    selectedRef.current = selected;
    // Initialize screen tabs once in UIM store
    (0, $5uXOq.useEffect)(()=>{
        if (!adjustmentsAreEnabled) return;
        // receiving an empty tab array and no selected need to be initialized in store
        if (!memoizedTabs.length && !selectedRef.current) {
            initializeNoScreenTab();
            return;
        }
        // receiving single tab means there's no screen tab visible on view
        if (memoizedTabs.length === 1) {
            initializeScreenTabs({
                tabs: [],
                selected: 0
            });
            return;
        }
        // receiving multiple tabs
        initializeScreenTabs({
            tabs: memoizedTabs,
            selected: selectedRef.current
        });
    /**
		 * `triggerFieldInitializationKey` changes upon subsequent view re-renderings.
		 * Typical usage is inside GIC having "Create new Issue" checkbox ticked.
		 * When this happens, we want to re-run initializeScreenTabs.
		 */ }, [
        adjustmentsAreEnabled,
        viewType,
        memoizedTabs,
        initializeNoScreenTab,
        initializeScreenTabs,
        createAnalyticsEvent,
        triggerFieldInitializationKey
    ]);
    // Controlled tabs are synced with UIM store
    const controlledTabs = (0, $5uXOq.useMemo)(()=>{
        if (adjustmentsAreEnabled && Array.isArray(adjustedScreenTabs)) {
            const adjustedVisibilityMap = {};
            for (const adjustedScreenTab of adjustedScreenTabs)adjustedVisibilityMap[adjustedScreenTab.id] = adjustedScreenTab.isVisible;
            return tabs.map((inputTab)=>({
                    ...inputTab,
                    // isVisible is determined by the UIM store, but if not, default to true
                    isVisible: adjustedVisibilityMap[inputTab.id] ?? true
                }));
        }
        // default all tabs to be visible
        return tabs.map((inputTab)=>({
                ...inputTab,
                isVisible: true
            }));
    }, [
        adjustmentsAreEnabled,
        tabs,
        adjustedScreenTabs
    ]);
    // Controlled selected is synced with UIM store unless initialization hasn't happened or activeAdjustedTab is empty
    const controlledSelected = (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled || !Array.isArray(adjustedScreenTabs) || !adjustedScreenTabs.length || viewProps?.shouldDisableScreenTabsControl) return selected;
        const activeAdjustedTab = adjustedScreenTabs.find((tab)=>tab.isActive);
        if (activeAdjustedTab) return memoizedTabs.findIndex((tab)=>tab.id === activeAdjustedTab.id);
        return selected;
    }, [
        adjustmentsAreEnabled,
        adjustedScreenTabs,
        viewProps?.shouldDisableScreenTabsControl,
        memoizedTabs,
        selected
    ]);
    // Controlled onChange is propagating user changing tabs to the UIM store
    const controlledOnChange = (0, $5uXOq.useCallback)((...args)=>{
        const [userNewSelected] = args;
        if (adjustmentsAreEnabled) updateActiveScreenTab({
            selected: userNewSelected
        });
        onChange?.(...args);
    }, [
        adjustmentsAreEnabled,
        onChange,
        updateActiveScreenTab
    ]);
    // Call onChange() once when controlledSelected focuses a different tab than the initially selected
    (0, $5uXOq.useEffect)(()=>{
        if (memoizedTabs.length > 0 && typeof controlledSelected === 'number' && controlledSelected !== selected) onChange?.(controlledSelected, createAnalyticsEvent({}));
    }, [
        controlledSelected,
        memoizedTabs,
        selected,
        onChange,
        createAnalyticsEvent
    ]);
    return {
        controlledTabs: controlledTabs,
        controlledSelected: controlledSelected,
        controlledOnChange: controlledOnChange
    };
};

});
parcelRegister("2jmyj", function(module, exports) {

$parcel$export(module.exports, "useTriggerFieldInitialization", () => $49d7b2327dd10b63$export$1c69013aaf9112f0);

var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $49d7b2327dd10b63$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $49d7b2327dd10b63$export$1c69013aaf9112f0 = (0, $3sQ5x.createHook)((0, $1YewZ.store), {
    selector: $49d7b2327dd10b63$var$selectTriggerFieldInitializationKey
});

});

parcelRegister("7mgyX", function(module, exports) {

$parcel$export(module.exports, "useViewType", () => $5d58056d6e5d5e2d$export$1568c16ff8af07a3);

var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $5d58056d6e5d5e2d$export$1568c16ff8af07a3 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    selector: (state)=>state.viewType
});

});

parcelRegister("PVYFb", function(module, exports) {

$parcel$export(module.exports, "useMemoizedTabs", () => $c16a3999ee62d3de$export$df1fb9a4d15ebe6a);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
const $c16a3999ee62d3de$var$mapTabKnownProps = (tabs)=>tabs.map(({ id: id })=>({
            id: id
        }));
function $c16a3999ee62d3de$export$df1fb9a4d15ebe6a(tabs) {
    const memoizedTabsRef = (0, $5uXOq.useRef)(tabs);
    return (0, $5uXOq.useMemo)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))($c16a3999ee62d3de$var$mapTabKnownProps(memoizedTabsRef.current), $c16a3999ee62d3de$var$mapTabKnownProps(tabs))) {
            memoizedTabsRef.current = tabs;
            return tabs;
        }
        return memoizedTabsRef.current;
    }, [
        tabs
    ]);
}

});


parcelRegister("hfG3v", function(module, exports) {

$parcel$export(module.exports, "ConditionallyVisibleDiv", () => $8dd4020b5c86e079$export$f154ce6a32df6563);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $8dd4020b5c86e079$var$conditionallyVisibleStyles = {
    visible: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
function $8dd4020b5c86e079$export$f154ce6a32df6563({ isVisible: isVisible = true, children: children, testId: testId, id: id, role: role }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: id,
        role: role,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $8dd4020b5c86e079$var$conditionallyVisibleStyles[isVisible ? 'visible' : 'hidden']
        ]),
        children: children
    });
}

});

parcelRegister("fGCY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9f7b5ef8416e3ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9XE6b = parcelRequire("9XE6b");

var $7Jxgt = parcelRequire("7Jxgt");

var $gSA3s = parcelRequire("gSA3s");

var $kErdU = parcelRequire("kErdU");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $bPtOr = parcelRequire("bPtOr");

var $dIjAl = parcelRequire("dIjAl");

var $gEaAu = parcelRequire("gEaAu");

var $45Cy1 = parcelRequire("45Cy1");

var $5rzqz = parcelRequire("5rzqz");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $huY3x = parcelRequire("huY3x");


var $lsFXb = parcelRequire("lsFXb");

var $gItVn = parcelRequire("gItVn");


var $8XY8j = parcelRequire("8XY8j");

var $kHA0a = parcelRequire("kHA0a");

var $6gjIc = parcelRequire("6gjIc");

var $4UG9N = parcelRequire("4UG9N");

var $3uUt4 = parcelRequire("3uUt4");
/**
 * This hook memoizes getFormState function when it has a valid value
 * If we don't do this, the fields to which we pass getFormState will rerender everytime any other field changes (even for every keyboard stroke)
 */ const $e9f7b5ef8416e3ce$var$useMemoizedGetFormState = (getFormState)=>{
    const ref = (0, $5uXOq.useRef)(getFormState); // Initialise with getFormState
    (0, $5uXOq.useMemo)(()=>{
        // If there's a valid value already, we keep using it. We can assume that getFormState doesn't get stale since it is a function which returns state
        if (ref.current) return;
        // Use new value if previous ref.current is not valid
        ref.current = getFormState;
    }, [
        getFormState
    ]);
    return ref.current;
};
const $e9f7b5ef8416e3ce$export$90edc2cad754ca2e = (props)=>{
    const { onFieldMount: onFieldMount, onKeyDown: onKeyDown, fieldId: fieldId, componentProps: componentProps, Component: Component, apiLatency: apiLatency, isSubsequentLoad: isSubsequentLoad, issueAdjustmentModules: issueAdjustmentModules, wasStateRestored: wasStateRestored } = props;
    const [, { setIsFormLoaded: setIsFormLoaded }] = (0, $45Cy1.useFormContext)();
    const isMountEventFired = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isMountEventFired.current === false) {
            isMountEventFired.current = true;
            if ('requestIdleCallback' in window) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.requestIdleCallback(()=>onFieldMount(fieldId), {
                timeout: 50
            });
            else setTimeout(()=>{
                onFieldMount(fieldId);
            }, 50);
        }
    }, [
        onFieldMount,
        fieldId
    ]);
    const onLayoutDone = (0, $5uXOq.useCallback)(()=>{
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $gEaAu.globalIssueCreateModalLoadSubsequent) : (0, $gEaAu.globalIssueCreateModalLoad);
        // @ts-expect-error - TS2445 - Property 'state' is protected and only accessible within class 'BaseMetric' and its subclasses.
        if (globalIssueCreateModalLoadMetric.state === 'started') {
            const stopTime = Math.floor(performance.now());
            const customData = {
                apiLatency: apiLatency,
                featureFlags: Object.fromEntries((0, $gSA3s.allFeatureFlagsAccessed)),
                // TODO: Need to understand & update logic code to fix this issue, e.g. checking null and return a default value
                // @ts-expect-error - TS2531 - Object is possibly 'null'. | TS2445 - Property 'startTime' is protected and only accessible within class 'BaseMetric' and its subclasses.
                tti: Math.floor(stopTime - globalIssueCreateModalLoadMetric.startTime),
                isFirstTime: !isSubsequentLoad,
                wasStateRestored: wasStateRestored
            };
            globalIssueCreateModalLoadMetric.stop({
                customData: // @ts-expect-error - TS2322 - Type '{ apiLatency: number | null; tti: number; isFirstTime: boolean; }' is not assignable to type 'CustomValues'.
                customData
            });
            (0, $huY3x.markGicTti)();
        }
        setIsFormLoaded(true);
    }, [
        apiLatency,
        isSubsequentLoad,
        setIsFormLoaded,
        wasStateRestored
    ]);
    const extendedComponentProps = {
        ...componentProps,
        onLayoutDone: onLayoutDone
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9f7b5ef8416e3ce$var$FieldContainer, {
        onKeyDown: onKeyDown,
        key: fieldId,
        id: `${fieldId}-container`,
        "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
    }, issueAdjustmentModules.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "globalIssueCreateIssueAdjustmentsAdapter",
        packageName: "issueCreateModal",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, extendedComponentProps)),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $bPtOr.getErrorType)(error),
                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                fieldType: extendedComponentProps.fieldType,
                fieldId: fieldId
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsFXb.FieldDecoratorAsync), {
        Component: Component,
        componentProps: extendedComponentProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, extendedComponentProps));
};
const $e9f7b5ef8416e3ce$var$FieldRendererBase = (props)=>{
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue, isSubsequentLoad: isSubsequentLoad, minimizableModalView: minimizableModalView, wasStateRestored: wasStateRestored, isMiniDesignEnabled: isMiniDesignEnabled, FieldWrapperComponent: FieldWrapperComponent, isModalOpen: isModalOpen }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { fieldConfig: fieldConfig, getFormState: getFormState, apiLatency: apiLatency, setFieldValue: setFieldValue, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive } = props;
    /**
   * hiding "epic link" and "parent link fields by filtering them based on their type.
   * Note that this is a temporary frontend solution until we remove these fields in the backend,
   * which is scheduled to be done in FY25 Q3.
   */ const fields = props.fields.filter((fieldId)=>{
        // @ts-expect-error - TS2339 - Property 'gqlType' does not exist on type '(BaseField & FieldConfigValueWithoutBaseField) | {}'.
        const { gqlType: gqlType } = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, fieldId, {});
        return gqlType !== (0, $962656cd6986cb06$export$8723b724f0b3ac65) && gqlType !== (0, $962656cd6986cb06$export$670384150af5f49e);
    });
    // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, shouldAutoFocus: shouldAutoFocus, ecosystem: { forge: { customFields: customFields, filteredOutModules: filteredOutModules, issueAdjustmentModules: issueAdjustmentModules, hasFinishedLoading: hasFinishedLoading } }, currentActiveTabIndex: currentActiveTabIndex }, { setIsOperationInProgress: setIsOperationInProgress }] = (0, $45Cy1.useFormContext)();
    const renderAllFieldsInTabStartTime = (0, $5uXOq.useRef)(0);
    // Start by rendering the first field alone to give the user some visual feedback quickly
    // should be increased to a full "batch" of ~10 fields when field rendering performance is improved
    const [fieldsToRenderCount, setFieldsToRenderCount] = (0, $5uXOq.useState)(1);
    const fieldsMountedCount = (0, $5uXOq.useRef)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
    const renderedAllFields = (0, $5uXOq.useRef)(false);
    const getFormStateMemoized = $e9f7b5ef8416e3ce$var$useMemoizedGetFormState(getFormState);
    (0, $5uXOq.useEffect)(()=>{
        renderAllFieldsInTabStartTime.current = performance.now();
        setIsOperationInProgress(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderAllFieldsInTabStart', {});
        renderedAllFields.current = false;
    }, [
        setIsOperationInProgress,
        createAnalyticsEvent
    ]);
    const fieldsLength = fields.length;
    const fieldsRendererSessionId = (0, $5uXOq.useRef)('');
    const fieldsAlreadyFullyLoaded = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!isModalOpen) return;
        fieldsRendererSessionId.current = (0, $7Jxgt.v4)();
        fieldsAlreadyFullyLoaded.current = false;
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsToRenderTab', {
            fieldsLength: fieldsLength,
            fieldsRendererSessionId: fieldsRendererSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fieldsLength,
        isModalOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isModalOpen || fieldsToRenderCount < fieldsLength || fieldsAlreadyFullyLoaded.current) return;
        fieldsAlreadyFullyLoaded.current = true;
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsFullyRenderedTab', {
            fieldsLength: fieldsLength,
            fieldsRendererSessionId: fieldsRendererSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fieldsLength,
        fieldsToRenderCount,
        isModalOpen
    ]);
    const onFieldMount = ()=>{
        fieldsMountedCount.current += 1;
        if (fieldsMountedCount.current >= fieldsToRenderCount) setFieldsToRenderCount((currentCount)=>currentCount + (0, $3uUt4.getFieldsToRenderInOneBatch)(fields.length));
        if (fieldsMountedCount.current >= fields.length && !renderedAllFields.current) {
            setIsOperationInProgress(false);
            // send event to monitor in different browsers that the fields rendered successfully
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                timeToRenderAllFieldsInTabMs: Math.floor(performance.now() - renderAllFieldsInTabStartTime.current),
                fields: fields
            };
            (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderedAllFieldsInTab', attributes);
            renderedAllFields.current = true;
        }
        // The last call to `mark` is the time used in the final metric
        // We use this fact to obtain when the final field was mounted
        (0, $huY3x.globalIssueCreateTTIWithAdjustments).mark('gic-all-fields-loaded');
    };
    const fieldsToRender = fields.slice(0, fieldsToRenderCount).map((fieldId, index)=>{
        let content = null;
        // @ts-expect-error - TS2339 - Property 'gqlType' does not exist on type '(BaseField & FieldConfigValueWithoutBaseField) | {}'.
        const { gqlType: gqlType, ...rest } = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, fieldId, {});
        // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'description' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'isRequired' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'.
        const { fieldName: fieldName, description: description, isRequired: isRequired, fieldType: fieldType } = rest;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
        const FieldDetails = (0, $gItVn.getGqlFieldMap)()[gqlType];
        const commonAttributesInfo = {
            autoFocus: index === 0 && currentActiveTabIndex === 0 && (0, $4UG9N.FIELDS_WITHOUT_DROPDOWN_MENU).includes(gqlType) && shouldAutoFocus,
            isSubTaskCreationOpen: isSubTaskCreationOpen,
            isDropdownMenuFixedAndLayered: true,
            componentKey: (0, $4UG9N.FORCE_RENDER_ON_TAB_CHANGE).includes(gqlType) ? `${fieldId}-${currentActiveTabIndex}` : undefined,
            isCreateLinkedIssue: (0, $4UG9N.FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO).includes(gqlType) && (0, $4R6GH.fg)('create_linked_issues_trigger_point_issue_view') ? isCreateLinkedIssue : false,
            isMini: isMini,
            ...(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && {
                isCollapsed: isCollapsed,
                isFieldResponsive: isFieldResponsive
            }
        };
        const extraProps = {
            ...commonAttributesInfo,
            selectedProject: (0, $4UG9N.FIELDS_WITH_SELECTED_PROJECT).includes(gqlType) ? selectedProject : undefined,
            selectedIssueType: (0, $4UG9N.FIELDS_WITH_SELECTED_ISSUE_TYPE).includes(gqlType) ? selectedIssueType : undefined,
            // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly setCurrentActiveTabIndex: (tabIndex: number) => Action<State, void, void | Promise<void>>; readonly setSelectedProject: (project: Project) => Action<...>; ... 20 more ...; readonly setSummaryValue: (summary: string) => Action<...>; }>, void> | undefined' is not assignable to type 'HookFunction<State, { readonly setCurrentActiveTabIndex: (tabIndex: number) => Action<State, void, void | Promise<void>>; readonly setSelectedProject: (project: Project) => Action<...>; ... 20 more ...; readonly setSummaryValue: (summary: string) => Action<...>; }, undefined> | undefined'.
            useFormContext: (0, $4UG9N.FIELDS_NEEDING_FORM_CONTEXT).includes(gqlType) ? (0, $45Cy1.useFormContext) : undefined,
            contextAndValuesOfIssueBeingCreated: (0, $4UG9N.FIELDS_NEEDING_COMPLETE_FORM_STATE).includes(gqlType) ? {
                getFormState: getFormState,
                selectedIssueType: selectedIssueType,
                fieldConfig: fieldConfig
            } : undefined,
            getFormState: (0, $4UG9N.FIELDS_NEEDING_GET_FORM_STATE).includes(gqlType) ? getFormStateMemoized : undefined,
            onInProgressChange: (0, $4UG9N.FIELDS_WITH_ON_INPROGRESS_CHANGE).includes(gqlType) ? setIsOperationInProgress : undefined,
            forge: fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) ? {
                selectedProject: selectedProject,
                selectedIssueType: selectedIssueType,
                modules: customFields,
                filteredOutModules: filteredOutModules,
                hasFinishedLoading: hasFinishedLoading
            } : undefined,
            fieldHelpTextUrl: (0, $3uUt4.getHelpTextUrl)(gqlType),
            onLinkClickEvent: (0, $3uUt4.getOnLinkClickEvent)(gqlType)
        };
        if (isGICPositioningEnabled() && fieldPropsExtensions?.[fieldType] && (0, $4UG9N.FIELDS_WITH_EXTENSION_PROPS).includes(gqlType)) Object.assign(extraProps, fieldPropsExtensions[fieldType]);
        if (FieldDetails) {
            const { Component: Component, defaultValueKey: defaultValueKey } = FieldDetails;
            const fieldContainerWrapperProps = {
                ...defaultValueKey === 'parentIssue' ? {} : {
                    onKeyDown: (0, $kHA0a.preventEscKeyPropagationKeyPressHandler)
                },
                fieldId: fieldId,
                componentProps: {
                    ...rest,
                    ...extraProps,
                    fieldName: fieldName,
                    description: description,
                    gqlType: gqlType,
                    fieldWrapperElement: FieldWrapperComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapperComponent, {
                        fieldId: fieldId,
                        field: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, fieldId),
                        setFieldValue: setFieldValue
                    }) : null
                },
                Component: Component,
                onFieldMount: onFieldMount,
                apiLatency: apiLatency,
                isSubsequentLoad: isSubsequentLoad,
                issueAdjustmentModules: issueAdjustmentModules,
                setFieldValue: setFieldValue,
                wasStateRestored: wasStateRestored
            };
            // @ts-expect-error - TS2322 - Type '{ onKeyDown: (e: KeyboardEvent<Element> | KeyboardEvent<EventTarget>) => void; fieldId: string; componentProps: { fieldName: any; ... 24 more ...; onLayoutDone?: (() => void) | undefined; }; ... 7 more ...; key: string; }' is not assignable to type 'FieldContainerWrapperProps'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9f7b5ef8416e3ce$export$90edc2cad754ca2e, {
                key: fieldId,
                ...fieldContainerWrapperProps
            });
        } else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9f7b5ef8416e3ce$var$FieldContainer, {
            key: fieldId,
            "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XY8j.default), {
            fieldId: fieldId,
            fieldName: fieldName,
            isRequired: isRequired,
            description: description,
            projectType: selectedProject?.projectType,
            gqlType: gqlType,
            fieldType: fieldType,
            onFieldMount: onFieldMount,
            isMini: isMini
        }));
        const errorAttributes = {
            ...commonAttributesInfo,
            isProjectSelected: (0, $4UG9N.FIELDS_WITH_SELECTED_PROJECT).includes(gqlType),
            selectedIssueType: (0, $4UG9N.FIELDS_WITH_SELECTED_ISSUE_TYPE).includes(gqlType),
            isFormContextProvided: (0, $4UG9N.FIELDS_NEEDING_FORM_CONTEXT).includes(gqlType),
            IscontextAndValuesOfIssueBeingCreatedProvided: !!(0, $4UG9N.FIELDS_NEEDING_COMPLETE_FORM_STATE).includes(gqlType),
            isGetFormStateProvided: (0, $4UG9N.FIELDS_NEEDING_GET_FORM_STATE).includes(gqlType),
            isOnInProgressChangeProvided: (0, $4UG9N.FIELDS_WITH_ON_INPROGRESS_CHANGE).includes(gqlType),
            isForgeField: fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType),
            isFieldHelpTextUrlProvided: !!(0, $3uUt4.getHelpTextUrl)(gqlType),
            isOnLinkClickEventProvided: !!(0, $3uUt4.getOnLinkClickEvent)(gqlType),
            gqlType: gqlType,
            fieldType: fieldType
        };
        if ((0, $4R6GH.fg)('refactor-gic-field-error-boundary')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
            id: "globalIssueCreateIssue-field-renderer",
            key: `field-renderer-${fieldId}`,
            packageName: "jiraIssueCreateModal",
            fallback: "unmount",
            onError: ()=>{
                onFieldMount();
            },
            attributes: errorAttributes,
            sendToPrivacyUnsafeSplunk: true
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
            id: `globalIssueCreateIssue-field-renderer-${fieldId}`,
            key: `field-renderer-${fieldId}`,
            packageName: "jiraIssueCreateModal",
            fallback: "unmount",
            onError: ()=>{
                onFieldMount();
            },
            sendToPrivacyUnsafeSplunk: true
        }, content);
    });
    return fieldsToRender;
};
const $e9f7b5ef8416e3ce$var$FieldRenderer = /*#__PURE__*/ (0, $5uXOq.memo)($e9f7b5ef8416e3ce$var$FieldRendererBase);
var $e9f7b5ef8416e3ce$export$2e2bcd8739ae039 = $e9f7b5ef8416e3ce$var$FieldRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9f7b5ef8416e3ce$var$FieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv47k _1ryssyzs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lsFXb", function(module, exports) {

$parcel$export(module.exports, "FieldDecoratorAsync", () => $d064e2dcd7969aea$export$7bf1fdc8d847e1ea);

var $5uXOq = parcelRequire("5uXOq");

var $gL80q = parcelRequire("gL80q");
var $jrwZp = parcelRequire("jrwZp");


var $c4xpz = parcelRequire("c4xpz");
const $d064e2dcd7969aea$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, componentProps);
    // Render FieldDecorator only when field type is supported
    // and adjustments are enabled
    if ((0, $gL80q.isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), componentProps.fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4xpz.EnabledFieldDecorator), {
        // @ts-expect-error - TS2322 - Type 'ComponentType<T>' is not assignable to type 'ComponentType<DecoratedField>'.
        Component: Component,
        componentProps: componentProps
    });
    return undecoratedComponent;
};
const $d064e2dcd7969aea$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $5uXOq.memo)($d064e2dcd7969aea$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("c4xpz", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldDecorator", () => $bfbc6dd25b19b3d5$export$a39682472306ffd4);

var $5uXOq = parcelRequire("5uXOq");

var $1YewZ = parcelRequire("1YewZ");
var $4jshT = parcelRequire("4jshT");
var $2jmyj = parcelRequire("2jmyj");

var $9QJ7Z = parcelRequire("9QJ7Z");

var $3WUWf = parcelRequire("3WUWf");

var $50yDw = parcelRequire("50yDw");
const $bfbc6dd25b19b3d5$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { fieldId: fieldId, fieldName: fieldName, description: description, fieldType: fieldType, isRequired: isRequired = false, gqlType: fieldRenderer, allowedValues: allowedValues } = componentProps;
    const { setFieldValue: setFieldValue, getFieldValue: getFieldValue } = (0, $9QJ7Z.useFormApi)();
    const [state, { initializeField: initializeField, clearAppliedValue: clearAppliedValue }] = (0, $1YewZ.useAdjustedField)(fieldId);
    const [triggerFieldInitializationKey] = (0, $2jmyj.useTriggerFieldInitialization)();
    const isBusy = (0, $4jshT.useFieldIsBusy)(fieldId);
    const isVisible = state.isVisible ?? true;
    const isReadOnly = state.isReadOnly ?? false;
    const isRequiredFromUIM = state.isRequired ?? false;
    (0, $5uXOq.useEffect)(()=>{
        const field = {
            fieldName: fieldName,
            fieldId: fieldId,
            description: description,
            isVisible: isVisible,
            fieldType: fieldType,
            isReadOnly: isReadOnly,
            isRequired: isRequired,
            allowedValues: allowedValues,
            value: getFieldValue(fieldId)
        };
        initializeField({
            field: field,
            metadata: {
                fieldRenderer: fieldRenderer
            }
        });
    /**
		 * Because of how the GIC works between subsequent modal openings, UI modifications state is persisted.
		 * That's why want to run initializeField only when triggerFieldInitializationKey change and mounting.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerFieldInitializationKey,
        getFieldValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (state.value !== undefined) {
            setFieldValue(fieldId, state.value);
            // Once we have applied the value, we clear it from the state, so we don't apply it again
            // in the future and overwrite whatever the user has changed between now and then
            clearAppliedValue(fieldId);
        }
    }, [
        state.value,
        clearAppliedValue,
        fieldId,
        setFieldValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WUWf.ConditionallyVisibleDiv), {
        key: fieldId,
        isVisible: isVisible,
        "data-testid": `ui-modifications-view-gic.ui.field-decorator.enabled-field-decorator.visibility-wrapper.${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        ...componentProps,
        ...(0, $50yDw.pickPropertiesToOverwrite)(state),
        ...isBusy ? {
            isReadOnly: true
        } : {},
        areUiModificationsBusy: isBusy,
        isRequiredFromUIM: isRequiredFromUIM
    }));
};
const $bfbc6dd25b19b3d5$export$a39682472306ffd4 = /*#__PURE__*/ (0, $5uXOq.memo)($bfbc6dd25b19b3d5$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("4jshT", function(module, exports) {

$parcel$export(module.exports, "useFieldIsBusy", () => $74ff35ddf47c30fc$export$b4ae28da91c35ed4);

var $gKZoD = parcelRequire("gKZoD");

var $d6dC5 = parcelRequire("d6dC5");


var $2b7ER = parcelRequire("2b7ER");
const $74ff35ddf47c30fc$export$b4ae28da91c35ed4 = (fieldId)=>{
    (0, $gKZoD.di)((0, $2b7ER.useFieldIsProcessing));
    const [isBusyData] = (0, $2b7ER.useFieldIsProcessing)(fieldId);
    const uimConsentMap = (0, $d6dC5.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $0659eefb602f8f84$export$d67d63332ce3ce38));
};

});
parcelRegister("2b7ER", function(module, exports) {

$parcel$export(module.exports, "useFieldIsProcessing", () => $cd18f2d1c4b9c85e$export$7fa63f8479e2806a);

var $hGgHi = parcelRequire("hGgHi");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");

var $1YewZ = parcelRequire("1YewZ");
const $cd18f2d1c4b9c85e$export$9076a5ac331011bb = (0, $6dDSs.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $cd18f2d1c4b9c85e$export$7fa63f8479e2806a = (0, $3sQ5x.createHook)((0, $1YewZ.store), {
    selector: $cd18f2d1c4b9c85e$export$9076a5ac331011bb
});

});


parcelRegister("3WUWf", function(module, exports) {

$parcel$export(module.exports, "ConditionallyVisibleDiv", () => $3a0420afd8037073$export$f154ce6a32df6563);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3a0420afd8037073$export$f154ce6a32df6563 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isVisible ? "_1e0c1bgi" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("50yDw", function(module, exports) {

$parcel$export(module.exports, "pickPropertiesToOverwrite", () => $aa8f37246cd10ceb$export$7aa61edf4d7c035e);
const $aa8f37246cd10ceb$export$7aa61edf4d7c035e = (field)=>{
    const overwriteProperties = [
        'fieldName',
        'description',
        'isReadOnly',
        'isRequired',
        'allowedValues'
    ];
    return overwriteProperties.reduce((acc, propertyName)=>{
        const propertyValue = field[propertyName];
        if (propertyValue !== undefined) acc[propertyName] = propertyValue;
        return acc;
    }, {});
};

});



parcelRegister("8XY8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ed78b611d1872f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7O4UO = parcelRequire("7O4UO");

var $dD7Zc = parcelRequire("dD7Zc");

var $kY99m = parcelRequire("kY99m");

var $eHJxW = parcelRequire("eHJxW");

var $ousew = parcelRequire("ousew");

var $45JN1 = parcelRequire("45JN1");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lf13e = parcelRequire("lf13e");

var $hLxXk = parcelRequire("hLxXk");
const $43ed78b611d1872f$var$IncompatibleField = (props)=>{
    const isMountEventFired = (0, $5uXOq.useRef)(false);
    const [isInfoMessageOpen, setInfoMessageOpen] = (0, $5uXOq.useState)(false);
    const { fieldId: fieldId, fieldName: fieldName, isRequired: isRequired = false, description: description, projectType: projectType, gqlType: gqlType, fieldType: fieldType, onFieldMount: onFieldMount, isMini: isMini } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (isMountEventFired.current === false) {
            isMountEventFired.current = true;
            onFieldMount(fieldId);
        }
    }, [
        onFieldMount,
        fieldId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const closeInfoMessage = ()=>{
        setInfoMessageOpen(false);
    };
    const toggleInfoMessageVisibility = ()=>{
        if (isInfoMessageOpen === true) {
            closeInfoMessage();
            return;
        }
        setInfoMessageOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'inlineDialog',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'globalIssueCreateFieldUnsupported');
    };
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'unsupported newGicField', {
            gqlType: gqlType,
            projectType: projectType,
            fieldType: fieldType
        });
    }, [
        createAnalyticsEvent,
        projectType,
        gqlType,
        fieldType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        id: fieldId,
        label: fieldName,
        isRequired: isRequired,
        name: fieldId
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43ed78b611d1872f$var$InlineMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43ed78b611d1872f$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            isDisabled: true,
            "aria-labelledby": fieldProps['aria-labelledby']
        })), !(0, $lf13e.UNSUPPORTED_FIELD_TYPES).includes(fieldType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
            sourceName: "globalIssueCreateFieldUnsupported"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43ed78b611d1872f$var$MessageContainer, {
                "data-testid": (0, $lf13e.MESSAGE_CONTAINER_TEST_ID)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $hLxXk.default).incompatibleFieldMessageNoOptionToSwitchToOldModal,
                values: {
                    fieldName: fieldName,
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            })),
            isOpen: isInfoMessageOpen,
            onClose: closeInfoMessage,
            messageId: "issue-create.common.ui.fields.incompatible-field.inline-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "subtle",
            onClick: toggleInfoMessageVisibility,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                label: "incompatible-field-info",
                LEGACY_size: "medium",
                spacing: "spacious",
                color: "var(--ds-icon-subtle, #626F86)"
            }),
            testId: (0, $lf13e.ERROR_ICON_TEST_ID)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
            description: description,
            fieldName: fieldName,
            isMini: isMini
        })));
};
var $43ed78b611d1872f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $43ed78b611d1872f$var$IncompatibleField;
const $43ed78b611d1872f$var$InlineMessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $43ed78b611d1872f$var$FieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1edt _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $43ed78b611d1872f$var$MessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1sum",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("lf13e", function(module, exports) {

$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES", () => $c748dea82b133b5e$export$50417837a224cc14);
$parcel$export(module.exports, "ERROR_ICON_TEST_ID", () => $c748dea82b133b5e$export$373c21cf926631ed);
$parcel$export(module.exports, "MESSAGE_CONTAINER_TEST_ID", () => $c748dea82b133b5e$export$b8c8ab4bbeae7cb);
// These fields are not supported in the old issue create modal
const $c748dea82b133b5e$export$50417837a224cc14 = [
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype'
];
const $c748dea82b133b5e$export$373c21cf926631ed = 'issue-create.common.ui.fields.incompatible-field.error-button';
const $c748dea82b133b5e$export$b8c8ab4bbeae7cb = 'issue-create.common.ui.fields.incompatible-field.message-container';

});

parcelRegister("hLxXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e7e40b90384429$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02e7e40b90384429$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    incompatibleFieldMessageNoOptionToSwitchToOldModal: {
        "id": "issue-create.common.fields.incompatible-field.incompatible-field-message-no-option-to-switch-to-old-modal",
        "defaultMessage": "The <b>{fieldName}</b> field is not supported on this screen."
    }
});

});


parcelRegister("4UG9N", function(module, exports) {

$parcel$export(module.exports, "FIELDS_WITH_SELECTED_PROJECT", () => $fd6752bfd5158bba$export$dd0837d091307e0f);
$parcel$export(module.exports, "FIELDS_WITH_SELECTED_ISSUE_TYPE", () => $fd6752bfd5158bba$export$389f9f87389af956);
$parcel$export(module.exports, "FIELDS_NEEDING_FORM_CONTEXT", () => $fd6752bfd5158bba$export$f6b349b9a22679bc);
$parcel$export(module.exports, "FIELDS_WITH_ON_INPROGRESS_CHANGE", () => $fd6752bfd5158bba$export$f014d1ea91bf0c23);
$parcel$export(module.exports, "FORCE_RENDER_ON_TAB_CHANGE", () => $fd6752bfd5158bba$export$27466286b235cb0f);
$parcel$export(module.exports, "FIELDS_NEEDING_COMPLETE_FORM_STATE", () => $fd6752bfd5158bba$export$9af9321e2bc27e84);
$parcel$export(module.exports, "FIELDS_NEEDING_GET_FORM_STATE", () => $fd6752bfd5158bba$export$249f6ad3f1dce1f);
$parcel$export(module.exports, "RENDER_BATCH_SIZE_DENOMINATOR", () => $fd6752bfd5158bba$export$397fe8aa4d206ed5);
$parcel$export(module.exports, "FIELDS_WITH_EXTENSION_PROPS", () => $fd6752bfd5158bba$export$88f0fb0471bfaaff);
$parcel$export(module.exports, "FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO", () => $fd6752bfd5158bba$export$9ff19636928638c9);
$parcel$export(module.exports, "FIELDS_WITHOUT_DROPDOWN_MENU", () => $fd6752bfd5158bba$export$bd64b3c9a1b1c867);

const $fd6752bfd5158bba$export$dd0837d091307e0f = [
    (0, $962656cd6986cb06$export$8723b724f0b3ac65),
    (0, $962656cd6986cb06$export$31a6c27df1f927b2),
    (0, $962656cd6986cb06$export$30b2c2de5e3007a4),
    (0, $962656cd6986cb06$export$76d811609080a7aa),
    (0, $962656cd6986cb06$export$a9b3195cbef5c5ad),
    (0, $962656cd6986cb06$export$597fa240de2bfd92),
    (0, $962656cd6986cb06$export$3e8dded8d83b5d95),
    (0, $962656cd6986cb06$export$670384150af5f49e),
    (0, $962656cd6986cb06$export$bf9df74e065af482),
    (0, $962656cd6986cb06$export$d64150fd9c66969c),
    (0, $962656cd6986cb06$export$64238d76a1dc0703),
    (0, $962656cd6986cb06$export$eca94ae30cb92d8),
    (0, $962656cd6986cb06$export$3849bb04b4eee607),
    (0, $962656cd6986cb06$export$2bb9d057bad89bfa),
    (0, $962656cd6986cb06$export$ede7166f44cc4bd6)
];
const $fd6752bfd5158bba$export$389f9f87389af956 = [
    (0, $962656cd6986cb06$export$3e8dded8d83b5d95),
    (0, $962656cd6986cb06$export$bf9df74e065af482),
    (0, $962656cd6986cb06$export$31a6c27df1f927b2)
];
const $fd6752bfd5158bba$export$f6b349b9a22679bc = [
    (0, $962656cd6986cb06$export$670384150af5f49e),
    (0, $962656cd6986cb06$export$8723b724f0b3ac65)
];
const $fd6752bfd5158bba$export$f014d1ea91bf0c23 = [
    (0, $962656cd6986cb06$export$a9b3195cbef5c5ad)
];
const $fd6752bfd5158bba$export$27466286b235cb0f = [
    (0, $962656cd6986cb06$export$64c7789e86344de5),
    (0, $962656cd6986cb06$export$5bb498d4f2f54799),
    (0, $962656cd6986cb06$export$d10237d945259f96),
    (0, $962656cd6986cb06$export$2055419ff013de79),
    (0, $962656cd6986cb06$export$3a1ae3e0f2d9b1b9),
    (0, $962656cd6986cb06$export$eca94ae30cb92d8),
    (0, $962656cd6986cb06$export$30b2c2de5e3007a4),
    (0, $962656cd6986cb06$export$76d811609080a7aa)
];
const $fd6752bfd5158bba$export$9af9321e2bc27e84 = [
    (0, $962656cd6986cb06$export$597fa240de2bfd92),
    (0, $962656cd6986cb06$export$fc69de49ba08ae77)
];
const $fd6752bfd5158bba$export$249f6ad3f1dce1f = [
    (0, $962656cd6986cb06$export$31a6c27df1f927b2)
];
const $fd6752bfd5158bba$export$397fe8aa4d206ed5 = 10;
const $fd6752bfd5158bba$export$88f0fb0471bfaaff = [
    (0, $962656cd6986cb06$export$31a6c27df1f927b2)
];
const $fd6752bfd5158bba$export$9ff19636928638c9 = [
    (0, $962656cd6986cb06$export$47af4d6f62c134cf)
];
const $fd6752bfd5158bba$export$bd64b3c9a1b1c867 = [
    (0, $962656cd6986cb06$export$23ca38ad884e35f1),
    (0, $962656cd6986cb06$export$7e5590c7c7a403c0),
    (0, $962656cd6986cb06$export$8643f0b9cefed538),
    (0, $962656cd6986cb06$export$31a6c27df1f927b2),
    (0, $962656cd6986cb06$export$e4d5e04bc56680dc),
    (0, $962656cd6986cb06$export$d854193d90dc547d),
    (0, $962656cd6986cb06$export$e0ece81bd398c799),
    (0, $962656cd6986cb06$export$95433ac963f4aebe),
    (0, $962656cd6986cb06$export$a138d5648dda03f0),
    (0, $962656cd6986cb06$export$aecc734a7c3591d7)
];

});

parcelRegister("3uUt4", function(module, exports) {

$parcel$export(module.exports, "getHelpTextUrl", () => $9329503d8e8dcd8f$export$6d35186636f2563a);
$parcel$export(module.exports, "getOnLinkClickEvent", () => $9329503d8e8dcd8f$export$ac33bccf00c7d438);
$parcel$export(module.exports, "getFieldsToRenderInOneBatch", () => $9329503d8e8dcd8f$export$e76bcc0cbf9cc086);

var $aSoqm = parcelRequire("aSoqm");

var $dNpFP = parcelRequire("dNpFP");

var $4UG9N = parcelRequire("4UG9N");
const $9329503d8e8dcd8f$var$isFieldWithLearnMoreLink = (gqlType)=>Object.keys((0, $aSoqm.FIELDS_LEARN_MORE_LINKS)).includes(gqlType);
const $9329503d8e8dcd8f$export$6d35186636f2563a = (gqlType)=>{
    if ($9329503d8e8dcd8f$var$isFieldWithLearnMoreLink(gqlType)) return (0, $aSoqm.FIELDS_LEARN_MORE_LINKS)[gqlType];
    return undefined;
};
const $9329503d8e8dcd8f$export$ac33bccf00c7d438 = (gqlType)=>{
    if ($9329503d8e8dcd8f$var$isFieldWithLearnMoreLink(gqlType)) return 0, $dNpFP.openInNewTabLinkClickEventHandler;
    return undefined;
};
const $9329503d8e8dcd8f$export$e76bcc0cbf9cc086 = (totalFields)=>Math.max(Math.floor(totalFields / (0, $4UG9N.RENDER_BATCH_SIZE_DENOMINATOR)), 10);

});
parcelRegister("dNpFP", function(module, exports) {

$parcel$export(module.exports, "openInNewTabLinkClickEventHandler", () => $7a8e9940c4106313$export$90d78a8969dab02);
const $7a8e9940c4106313$export$90d78a8969dab02 = (event)=>{
    const eventTarget = event.target;
    if (eventTarget instanceof HTMLAnchorElement) eventTarget.target = '_blank';
};

});



parcelRegister("cu7BW", function(module, exports) {

$parcel$export(module.exports, "FieldsContainer", () => $36c96cecf539181f$export$8cdf7afbd261e53d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $iigfj = parcelRequire("iigfj");

var $45Cy1 = parcelRequire("45Cy1");

var $iUFy5 = parcelRequire("iUFy5");

var $8zOmE = parcelRequire("8zOmE");

var $2m0b6 = parcelRequire("2m0b6");

var $6DnvJ = parcelRequire("6DnvJ");

var $EePad = parcelRequire("EePad");
const $36c96cecf539181f$export$2fe52feffe568f84 = '3svLIYAFXrcqQlJXtqEc6G';
const $36c96cecf539181f$var$DEFAULT_USE_MINIMIZABLE_MODAL_RESULT = {
    view: 'modal',
    setView: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setShouldFocusChanger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $36c96cecf539181f$export$8cdf7afbd261e53d = (props)=>{
    const { fields: propFields, collapsedFields: propsCollapsedFields = [], optOutSmartFieldIds: optOutSmartFieldIds, FieldRenderer: FieldRenderer, tabIndex: tabIndex = 0, // TODO Remove "= 0" when cleaning migrate_gic_smart_fields_jira_labs
    ...rest } = props;
    const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $45Cy1.useFormContext)();
    const uiModificationsStatus = (0, $iigfj.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { collapsedFields: collapsedFields, fields: fields } = (0, $5uXOq.useMemo)(()=>{
        let collapsedFieldsFound = uiModificationsStatus !== 'enabled' ? propsCollapsedFields : [];
        if (optOutSmartFieldIds && (0, $4R6GH.fg)('opt_out_smart_fields_in_gic')) collapsedFieldsFound = collapsedFieldsFound.filter((field)=>!optOutSmartFieldIds.includes(field));
        let fieldsFound = propFields.filter((field)=>!collapsedFieldsFound.includes(field));
        if (!fieldsFound.length && collapsedFieldsFound.length) {
            fieldsFound = collapsedFieldsFound;
            collapsedFieldsFound = [];
        }
        return {
            collapsedFields: collapsedFieldsFound,
            fields: fieldsFound
        };
    }, [
        propFields,
        propsCollapsedFields,
        uiModificationsStatus,
        optOutSmartFieldIds
    ]);
    const [isExpanded, { setExpandedCollapsedArea: setExpandedCollapsedArea }] = (0, $45Cy1.useIsCollapsedAreaExpanded)(tabIndex); // isCollapsed is only true once. When it's false, it should never get back to true
    const isCollapsed = (0, $5uXOq.useRef)(!isExpanded);
    const { view: view, setView: setView, setShouldFocusChanger: setShouldFocusChanger } = (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iUFy5.useMinimizableModal)() : $36c96cecf539181f$var$DEFAULT_USE_MINIMIZABLE_MODAL_RESULT;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const openInProductHelp = (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? (0, $5Zxxp.useHelpPanelLink)() : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const handleOnReadMoreClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        if (view === 'modal') {
            // TODO Remove optional ?. when cleaning smart_fields_gic_toggle_fg
            setShouldFocusChanger?.(true);
            setView?.('mini');
        }
        openInProductHelp?.($36c96cecf539181f$export$2fe52feffe568f84);
    }, [
        view,
        openInProductHelp,
        setShouldFocusChanger,
        setView
    ]);
    // TODO Remove this condition when cleaning migrate_gic_smart_fields_jira_labs
    if (!FieldRenderer) return null;
    const handleOnClick = (_, analyticsEvent)=>{
        isCollapsed.current = false;
        const isExpandedNewValue = !isExpanded;
        setExpandedCollapsedArea(tabIndex, isExpandedNewValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moreFields', {
            isExpanded: isExpandedNewValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $36c96cecf539181f$var$fieldsContainerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldRenderer, {
        ...rest,
        fields: fields
    }), !!collapsedFields.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c96cecf539181f$var$CollapsibleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DnvJ.CollapsibleAreaHeader), {
        totalFields: collapsedFields.length,
        isExpanded: isExpanded,
        onClick: handleOnClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c96cecf539181f$var$CollapsibleArea, {
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $EePad.default).smartFieldsReadMoreIssueTermRefresh : (0, $EePad.default).smartFieldsReadMore, {
        link: (chunks)=>(0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://support.atlassian.com",
                appearance: "default",
                onClick: handleOnReadMoreClick
            }, chunks) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: "/jira/settings/personal/general#smart-fields-preference",
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks)
    })), isCollapsed.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldRenderer, {
        ...rest,
        fields: collapsedFields,
        isCollapsed: isCollapsed.current
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c96cecf539181f$export$b533c285325ee313, {
        ...rest,
        FieldRenderer: FieldRenderer,
        fields: collapsedFields
    }))));
};
const $36c96cecf539181f$export$b533c285325ee313 = ({ FieldRenderer: FieldRenderer, ...rest })=>{
    const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
    const [isFieldResponsive, setIsFieldResponsive] = (0, $5uXOq.useState)(false);
    const collapsibleAreaRef = (0, $5uXOq.useRef)(null);
    (0, $2m0b6.useResizeObserver)({
        ref: collapsibleAreaRef,
        onResize () {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setIsFieldResponsive(window.innerWidth < 560);
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        setLoaded(true);
    }, []);
    if (!loaded) return null;
    if (!FieldRenderer) return null; // TODO Delete this condition when cleaning migrate_gic_smart_fields_jira_lab
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: collapsibleAreaRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldRenderer, {
        ...rest,
        isFieldResponsive: isFieldResponsive
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c96cecf539181f$var$CollapsibleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _189et94y _1dqonqa1 _1h6dmuej _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $36c96cecf539181f$var$CollapsibleArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isExpanded ? "_1e0cglyw" : "_1yt4u2gc _18u01f4h _otyrpxbi _u5f3pxbi _ca0qidpf",
            __cmplp.className
        ])
    });
});
const $36c96cecf539181f$var$fieldsContainerWrapperStyles = (0, $8CUq3.xcss)({
    paddingBottom: 'space.200'
});

});
parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("6DnvJ", function(module, exports) {

$parcel$export(module.exports, "CollapsibleAreaHeader", () => $27079f86692b96b1$export$8761b26214731920);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $9PMVi = parcelRequire("9PMVi");

var $daO0u = parcelRequire("daO0u");
const $27079f86692b96b1$export$875f349363bf5c2a = 'issue-create.ui.modal.create-form.layout-renderer.fields-container.collapsible-area-header.collapsible-area-header';
const $27079f86692b96b1$export$8761b26214731920 = ({ totalFields: totalFields, isExpanded: isExpanded, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const buttonAlt = isExpanded ? (0, $9PMVi.messages).hideMoreFields : (0, $9PMVi.messages).showMoreFields;
    const { isSmartFieldsNew: isSmartFieldsNew } = (0, $daO0u.useSyncNewLozenge)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $27079f86692b96b1$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27079f86692b96b1$var$HeaderButton, {
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            color: "currentColor",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            color: "currentColor",
            label: ""
        }),
        appearance: "subtle-link",
        title: formatMessage(buttonAlt, {
            totalFields: totalFields
        }),
        onClick: onClick,
        testId: $27079f86692b96b1$export$875f349363bf5c2a,
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27079f86692b96b1$var$HeaderButtonContent, null, formatMessage((0, $9PMVi.messages).moreFields, {
        totalFields: totalFields
    }), isSmartFieldsNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $9PMVi.messages).newLozenge))))));
};
const $27079f86692b96b1$var$buttonHeight = '40px';
const $27079f86692b96b1$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    // Button ring outline displays outside collapsible area. This padding is used to make them the same position
    padding: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $27079f86692b96b1$var$HeaderButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $27079f86692b96b1$var$HeaderButtonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz41ylp _18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9PMVi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4623e88dd25a0a65$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4623e88dd25a0a65$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    moreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.more-fields",
        "defaultMessage": "More fields ({totalFields})"
    },
    showMoreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.show-more-fields",
        "defaultMessage": "{totalFields, plural, one {Show one more field} other {Show # more fields}}"
    },
    hideMoreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.hide-more-fields",
        "defaultMessage": "{totalFields, plural, one {Hide one more field} other {Hide # more fields}}"
    },
    newLozenge: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.new-lozenge",
        "defaultMessage": "New"
    }
});

});

parcelRegister("daO0u", function(module, exports) {

$parcel$export(module.exports, "useSyncNewLozenge", () => $24f215d4e587d689$export$2eb02503266aeaa2);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $45Cy1 = parcelRequire("45Cy1");

var $gEEzS = parcelRequire("gEEzS");

var $aA974 = parcelRequire("aA974");
const $24f215d4e587d689$export$2eb02503266aeaa2 = ()=>{
    const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, dismissReadMore: dismissReadMore, isSmartFieldsGicOnboardingDismissed: isSmartFieldsGicOnboardingDismissed } = (0, $aA974.useIsSmartFieldsOptIn)();
    const { updatePreferences: updatePreferences } = (0, $gEEzS.useSmartFieldsUpdateUserPreference)();
    const dismissLozenge = (0, $5uXOq.useCallback)(async ()=>{
        dismissReadMore();
        await updatePreferences({
            hasUserOptedOut: !isSmartFieldsOptIn,
            hasUserDismissedReadMore: true,
            hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? !!isSmartFieldsGicOnboardingDismissed : undefined
        });
    }, [
        dismissReadMore,
        isSmartFieldsOptIn,
        updatePreferences,
        isSmartFieldsGicOnboardingDismissed
    ]);
    const [isSmartFieldsNew, { setIsSmartFieldsNew: setIsSmartFieldsNew }] = (0, $45Cy1.useIsSmartFieldsNew)();
    (0, $5uXOq.useEffect)(()=>{
        if (isSmartFieldsNew === undefined && !isSmartFieldDismissedReadMore) {
            setIsSmartFieldsNew(true);
            dismissLozenge();
        }
    }, [
        isSmartFieldsNew,
        isSmartFieldDismissedReadMore,
        setIsSmartFieldsNew,
        dismissLozenge
    ]);
    return {
        isSmartFieldsNew: isSmartFieldsNew
    };
};

});


parcelRegister("EePad", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4800c69563af667$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b4800c69563af667$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    smartFieldsReadMore: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more",
        "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating issues</link>"
    },
    smartFieldsReadMoreIssueTermRefresh: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more-issue-term-refresh",
        "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating work items</link>"
    }
});

});



parcelRegister("cS2PJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e14ad889979328$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $48e14ad889979328$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectFieldLabel: {
        "id": "issue-create.modal.create-form.project-field-label",
        "defaultMessage": "Projects"
    },
    createSuccessFlagTitle: {
        "id": "issue-create.modal.create-form.create-success-flag-title",
        "defaultMessage": "Issue created"
    },
    createSuccessFlagDescription: {
        "id": "issue-create.modal.create-form.create-success-flag-description",
        "defaultMessage": "Issue \"{issueKey}\" has been successfully created."
    },
    createSuccessFlagCta: {
        "id": "issue-create.modal.create-form.create-success-flag-cta",
        "defaultMessage": "View issue"
    },
    createErrorFlagTitle: {
        "id": "issue-create.modal.create-form.create-error-flag-title",
        "defaultMessage": "Couldn't create the issue"
    },
    createErrorFlagDescription: {
        "id": "issue-create.modal.create-form.create-error-flag-description",
        "defaultMessage": "We're having some trouble creating the issue. Refresh the page and try again."
    },
    embeddedCreateErrorFlagDescription: {
        "id": "issue-create.modal.create-form.embedded-create-error-flag-description",
        "defaultMessage": "We weren't able to save your issue. Please try again."
    },
    embeddedCreateErrorFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.embedded-create-error-flag-description-issue-term-refresh",
        "defaultMessage": "We weren't able to save your work item. Please try again."
    },
    createErrorForgeInlineField: {
        "id": "issue-create.modal.create-form.create-error-forge-inline-field",
        "defaultMessage": "Unable to save the value for this custom field."
    },
    timeoutForgeInlineFieldTitle: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title",
        "defaultMessage": "Issue created with exceptions"
    },
    timeoutForgeInlineFieldDescription: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description",
        "defaultMessage": "We created your issue but couldn't save the value of <bold>{fields}</bold>. If this happens again, contact your Jira admin"
    },
    requiredFieldsSummary: {
        "id": "issue-create.modal.create-form.required-fields-summary",
        "defaultMessage": "Required fields are marked with an asterisk"
    },
    singleRequiredCustomFieldIssueCreationBlock: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block",
        "defaultMessage": "You can\u2019t create this issue because the required field {fieldName} is hidden. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlock: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block",
        "defaultMessage": "You can\u2019t create this issue because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work item created"
    },
    createSuccessFlagCtaIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-success-flag-cta-issue-term-refresh",
        "defaultMessage": "View"
    },
    createErrorFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-error-flag-title-issue-term-refresh",
        "defaultMessage": "Couldn't create the work item"
    },
    createErrorFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't create {issueType}"
    },
    createErrorFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-error-flag-description-issue-term-refresh",
        "defaultMessage": "We're having some trouble creating the work item. Refresh the page and try again."
    },
    createErrorFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-error-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh the page and try again."
    },
    timeoutForgeInlineFieldTitleIssueTermRefresh: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title-issue-term-refresh",
        "defaultMessage": "Work item created with exceptions"
    },
    timeoutForgeInlineFieldTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {issueType} with exceptions"
    },
    timeoutForgeInlineFieldDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description-issue-term-refresh",
        "defaultMessage": "We created your work item but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin"
    },
    timeoutForgeInlineFieldDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description-issue-terminology-refresh-m4",
        "defaultMessage": "We created your {issueType} but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin"
    },
    singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-term-refresh",
        "defaultMessage": "You can\u2019t create this work item because the {fieldName} field is required but hidden. Contact your admin to fix this."
    },
    singleRequiredCustomFieldIssueCreationBlockIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-terminology-refresh-m4",
        "defaultMessage": "You can\u2019t create this {issueType} because the {fieldName} field is required but hidden. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-term-refresh",
        "defaultMessage": "You can\u2019t create this work item because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlockIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-terminology-refresh-m4",
        "defaultMessage": "You can\u2019t create this {issueType} because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    },
    createSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-success-flag-description-issue-term-refresh",
        "defaultMessage": "Work item \"{issueKey}\" has been successfully created."
    }
});

});

parcelRegister("13Rnw", function(module, exports) {

$parcel$export(module.exports, "ProformaBanner", () => $e07d4af127fdfe6e$export$d53a0bf1f2b6e7a6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $h6zwy = parcelRequire("h6zwy");
const $e07d4af127fdfe6e$export$d53a0bf1f2b6e7a6 = ({ portalLink: portalLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpenPortalLinkClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicProformaBannerOpenPortalButton clicked');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "gicProforma",
        sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e07d4af127fdfe6e$export$f316edcbf748c37b, {
        "data-testid": "issue-create.ui.modal.create-form.proforma-banner.banner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "information",
        title: formatMessage((0, $h6zwy.default).title),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: "openPortalLink"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                href: portalLink,
                target: "_blank",
                spacing: "none",
                onClick: onOpenPortalLinkClick,
                onAuxClick: onOpenPortalLinkClick,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e07d4af127fdfe6e$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                    label: formatMessage((0, $h6zwy.default).newTabIconDescription),
                    LEGACY_size: "small"
                }))
            }, formatMessage((0, $h6zwy.default).openPortal)))
        ]
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $h6zwy.default).textIssueTermRefresh : (0, $h6zwy.default).text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e07d4af127fdfe6e$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e07d4af127fdfe6e$export$f316edcbf748c37b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h6zwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $963642523b3eb7cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $963642523b3eb7cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-create.modal.create-form.proforma-banner.title",
        "defaultMessage": "This request type includes a form that can\u2019t be seen in this view"
    },
    text: {
        "id": "issue-create.modal.create-form.proforma-banner.text",
        "defaultMessage": "Create an issue using all fields on this request type and its form in the portal."
    },
    openPortal: {
        "id": "issue-create.modal.create-form.proforma-banner.open-portal",
        "defaultMessage": "Open portal"
    },
    newTabIconDescription: {
        "id": "issue-create.modal.create-form.proforma-banner.new-tab-icon-description",
        "defaultMessage": "This link will be opened in a new tab"
    },
    textIssueTermRefresh: {
        "id": "issue-create.modal.create-form.proforma-banner.text-issue-term-refresh",
        "defaultMessage": "Create a work item using all fields on this request type and its form in the portal."
    }
});

});


parcelRegister("eMaIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eab9b20db31fe6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $5tTFS = parcelRequire("5tTFS");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $7C5S0 = parcelRequire("7C5S0");

var $3M1CO = parcelRequire("3M1CO");

var $45Cy1 = parcelRequire("45Cy1");

var $9UhzQ = parcelRequire("9UhzQ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $do1Fc = parcelRequire("do1Fc");

var $kHA0a = parcelRequire("kHA0a");


var $tr82Y = parcelRequire("tr82Y");

var $7V7Wy = parcelRequire("7V7Wy");

var $8fYVB = parcelRequire("8fYVB");
const $9eab9b20db31fe6e$var$ProjectPicker = (props)=>{
    const { onChange: onChange, value: selectedProjectValue, renderOptionsLimit: renderOptionsLimit, skipFetchProjects: skipFetchProjects = false, isDisabled: isDisabled = false, disableFetchProject: disableFetchProject = false, width: width, onProjectSelection: onProjectSelection } = props;
    const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $45Cy1.useFormContext)();
    const [recentProjects, setRecentProjects] = (0, $5uXOq.useState)([]);
    const [filterQuery, setFilterQuery] = (0, $5uXOq.useState)('');
    const [allProjects, setAllProjects] = (0, $5uXOq.useState)([]);
    const [isLoading, setLoading] = (0, $5uXOq.useState)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const shouldFetchProjects = (0, $5uXOq.useRef)(true);
    const [fetchProjects] = (0, $5tTFS.useLazyQuery)((0, $tr82Y.PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION), {
        fetchPolicy: 'no-cache',
        onCompleted: (data)=>{
            setRecentProjects((0, $do1Fc.transformProjects)((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'recentProjects.nodes', [])));
            setAllProjects((0, $do1Fc.transformProjects)((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'allProjects.nodes', [])));
            setLoading(false);
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onProjectPickerInputChange = (query)=>{
        setFilterQuery(query);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (selectedProjectValue && shouldFetchProjects.current || skipFetchProjects) {
            shouldFetchProjects.current = false;
            disableFetchProject ? setLoading(false) : fetchProjects();
        }
        if (selectedProjectValue) onProjectSelection?.(selectedProjectValue);
    }, [
        fetchProjects,
        selectedProjectValue,
        skipFetchProjects,
        disableFetchProject,
        onProjectSelection
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (submitFieldwiseErrors?.project) (0, $kHA0a.scrollToElement)((0, $431713d0f28262cd$export$e2b449031137335a));
    }, [
        submitFieldwiseErrors?.project
    ]);
    const onOptionSelect = (project)=>{
        if (project?.value === projectValue?.value) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'project');
        onChange(project);
    };
    const filteredOptions = (0, $5uXOq.useMemo)(()=>{
        const { filteredAllProjects: filteredAllProjects, filteredRecentProjects: filteredRecentProjects } = (0, $8fYVB.getFilteredOptions)({
            recentProjects: recentProjects,
            allProjects: allProjects,
            filterQuery: filterQuery,
            renderOptionsLimit: renderOptionsLimit
        });
        return [
            {
                label: formatMessage((0, $7V7Wy.default).recentProjects),
                options: filteredRecentProjects
            },
            {
                label: formatMessage((0, $7V7Wy.default).allProjects),
                options: filteredAllProjects
            }
        ];
    }, [
        recentProjects,
        allProjects,
        filterQuery,
        formatMessage,
        renderOptionsLimit
    ]);
    const projectValue = (0, $5uXOq.useMemo)(()=>selectedProjectValue && {
            ...selectedProjectValue,
            iconUrl: (0, $3M1CO.transformStargateUrl)(selectedProjectValue?.iconUrl || '')
        }, [
        selectedProjectValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "project",
        label: formatMessage((0, $7V7Wy.default).projectFieldLabel),
        isRequired: true
    }, ({ fieldProps: { id: id, isRequired: isRequired } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            inputId: id,
            required: isRequired,
            options: filteredOptions,
            onInputChange: onProjectPickerInputChange,
            filterOption: null,
            // @ts-expect-error - TS2322 - Type '(project: Project) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: onOptionSelect,
            value: projectValue,
            isClearable: false,
            formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
            hideSelectedOptions: false,
            placeholder: "",
            isLoading: isLoading,
            isDisabled: isDisabled,
            id: (0, $431713d0f28262cd$export$e2b449031137335a),
            onKeyDown: (0, $kHA0a.preventEscKeyPropagationKeyPressHandler)
        }), submitFieldwiseErrors?.project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, submitFieldwiseErrors.project))));
};
var $9eab9b20db31fe6e$export$2e2bcd8739ae039 = $9eab9b20db31fe6e$var$ProjectPicker;

});
const $431713d0f28262cd$export$e2b449031137335a = 'issue-create.ui.modal.create-form.project-picker.project-select';

parcelRegister("tr82Y", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION", () => $ed11748ca47a586d$export$19f5ac56520dbc94);
// eslint-disable-next-line jira/restricted/graphql-tag

var $5cllN = parcelRequire("5cllN");

var $7pXhQ = parcelRequire("7pXhQ");
const $ed11748ca47a586d$export$19f5ac56520dbc94 = (0, $5cllN.default)`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${(0, $7pXhQ.PROJECT_WITHOUT_CLASSIFICATION)}
`;

});

parcelRegister("7V7Wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $36682c1aa36e1a71$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $36682c1aa36e1a71$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectFieldLabel: {
        "id": "issue-create.modal.create-form.project-picker.project-field-label",
        "defaultMessage": "Project"
    },
    recentProjects: {
        "id": "issue-create.modal.create-form.project-picker.recent-projects",
        "defaultMessage": "Recent Projects"
    },
    allProjects: {
        "id": "issue-create.modal.create-form.project-picker.all-projects",
        "defaultMessage": "All Projects"
    }
});

});

parcelRegister("8fYVB", function(module, exports) {

$parcel$export(module.exports, "getFilteredOptions", () => $581839d7453c2f44$export$25a7cbafb6ed84cb);
const $581839d7453c2f44$export$25a7cbafb6ed84cb = ({ recentProjects: recentProjects, allProjects: allProjects, filterQuery: filterQuery, renderOptionsLimit: renderOptionsLimit })=>{
    const filteredRecentProjects = recentProjects.filter((project)=>project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase()));
    const filteredAllProjects = allProjects.filter((project, index)=>{
        // if query string is there, don't limit options by limit
        if (filterQuery) return project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase());
        return index < renderOptionsLimit;
    });
    return {
        filteredRecentProjects: filteredRecentProjects,
        filteredAllProjects: filteredAllProjects
    };
};

});


parcelRegister("iSAdX", function(module, exports) {

$parcel$export(module.exports, "RequestTypeFieldsLayoutPreference", () => $22b674860ebcc4b4$export$c35a954354cf6eee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $6tRzQ = parcelRequire("6tRzQ");

var $cgL5K = parcelRequire("cgL5K");

var $dTlW6 = parcelRequire("dTlW6");

var $jgJNO = parcelRequire("jgJNO");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $hH1l8 = parcelRequire("hH1l8");

var $7CGHP = parcelRequire("7CGHP");
const $22b674860ebcc4b4$export$c35a954354cf6eee = ({ isRequestTypeSelected: isRequestTypeSelected, overrideIsEnabled: overrideIsEnabled, onChange: onChangeCallback })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const [{ data: isEnabled, isLoading: isLoading }, { setPreference: setPreference }] = (0, $hH1l8.useRequestTypeFieldsLayoutPreference)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [toggleWasClicked, setToggleWasClicked] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isChecked = !toggleWasClicked && overrideIsEnabled !== undefined ? !!overrideIsEnabled : isEnabled;
    const onToggleChanged = (0, $5uXOq.useCallback)(()=>{
        const newValue = !isChecked;
        setToggleWasClicked(true);
        atlassianAccountId && setPreference(atlassianAccountId, newValue, createAnalyticsEvent, onChangeCallback);
    }, [
        atlassianAccountId,
        createAnalyticsEvent,
        isChecked,
        onChangeCallback,
        setPreference
    ]);
    const togglePopup = (0, $5uXOq.useCallback)(()=>{
        if (!isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeToggleLabelButton clicked');
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        const popupTextRequestTypeSelected = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CGHP.default).createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh : (0, $7CGHP.default).createFormPopupTextWhenRequestTypeSelected;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22b674860ebcc4b4$export$cca08eed9de89ba9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            size: "UNSAFE_small"
        }, formatMessage(isRequestTypeSelected ? popupTextRequestTypeSelected : (0, $7CGHP.default).createFormPopupTextWhenNoRequestTypeSelected)));
    }, [
        formatMessage,
        isRequestTypeSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        isDisabled: isLoading || !isRequestTypeSelected,
        onChange: onToggleChanged,
        isChecked: isChecked,
        id: "use-request-type-fields-toggle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        htmlFor: "use-request-type-fields-toggle",
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l"
        ])
    }, formatMessage((0, $7CGHP.default).toggleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "issue-create.ui.modal.create-form.request-type-fields-layout-preference.popup.jira-popup",
        messageType: "engagement",
        placement: "right",
        shouldUseCaptureOnOutsideClick: true,
        isOpen: isOpen,
        onClose: togglePopup,
        content: popupContent,
        zIndex: (0, $gwIPs.layers).tooltip,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $bwpsq.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _19bv1b66 _1sc11o8v"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                appearance: "subtle-link",
                spacing: "none",
                onClick: togglePopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $bwpsq.default)([
                    "_x5v916ni _1b3i16ni _syaz149c _30l31kum"
                ]),
                style: {
                    "--_qswcdb": (0, $lD23V.default)(isOpen ? 'var(--icon-accent-color)' : 'var(--icon-color)')
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                label: "info",
                LEGACY_size: "small"
            }))))
    }));
};
const $22b674860ebcc4b4$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1178 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CGHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d78d733a6cf9cd8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2d78d733a6cf9cd8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleLabel: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label",
        "defaultMessage": "Use request type fields"
    },
    createFormPopupTextWhenRequestTypeSelected: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected",
        "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see issue type fields instead."
    },
    createFormPopupTextWhenNoRequestTypeSelected: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-no-request-type-selected",
        "defaultMessage": "Select a request type to enable this feature."
    },
    createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected-issue-term-refresh",
        "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see work type fields instead."
    }
});

});


parcelRegister("hx2H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ae7601e56546c0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $92Z2l = parcelRequire("92Z2l");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");

var $45Cy1 = parcelRequire("45Cy1");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $2CSJW = parcelRequire("2CSJW");

var $lXZTi = parcelRequire("lXZTi");

var $i4fCB = parcelRequire("i4fCB");

var $eHwnM = parcelRequire("eHwnM");
const $47ae7601e56546c0$var$SectionMessages = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ meta: meta }] = (0, $45Cy1.useFormContext)();
    const [issueAdjustmentError] = (0, $2CSJW.useUiModificationsErrors)();
    const [uiModificationsNotification] = (0, $lXZTi.useUiModificationsNotifications)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!meta.areRequiredFieldsSupported) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'banner',
                action: 'viewed'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'globalIssueCreateMandatoryFieldsUnsupported');
        }
    }, [
        createAnalyticsEvent,
        meta.areRequiredFieldsSupported
    ]);
    if (meta.queryErrorMessage !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.query-error-message"
    }, meta.queryErrorMessage);
    if (meta.submitErrorMessage !== undefined && meta.submitErrorMessage !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.submit-error-message"
    }, (0, $eHwnM.getDisplayErrorString)(meta.submitErrorMessage).map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47ae7601e56546c0$var$MessageWrapper, {
            key: index
        }, error)));
    let infoMessage;
    if (isSiteAdmin) infoMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $i4fCB.default).requiredFieldsUnsupportedForAdminIssueTermRefresh : (0, $i4fCB.default).requiredFieldsUnsupportedForAdmin;
    else infoMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $i4fCB.default).requiredFieldsUnsupportedForUserIssueTermRefresh : (0, $i4fCB.default).requiredFieldsUnsupportedForUser;
    if (!meta.areRequiredFieldsSupported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "globalIssueCreateMandatoryFieldsUnsupported",
        sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.required-fields-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...infoMessage,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: "/jira/contact-administrator"
                }, chunks),
            button: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    label: "incompatible-field-error",
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #626F86)"
                })
        }
    })));
    if (meta.inlineCreateError && meta.inlineCreateError?.errors.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.inline-create-errors",
        title: meta.inlineCreateError.title || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, meta.inlineCreateError.errors.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: `inline-error-${index}`
        }, error))));
    if (issueAdjustmentError !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
    }, issueAdjustmentError.message);
    if (uiModificationsNotification !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: uiModificationsNotification.type,
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message"
    }, uiModificationsNotification.message);
    return null;
};
var $47ae7601e56546c0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $47ae7601e56546c0$var$SectionMessages;
const $47ae7601e56546c0$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81kw7 _o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2CSJW", function(module, exports) {

$parcel$export(module.exports, "useUiModificationsErrors", () => $58fca68b47c6ed0a$export$72f28c8f041a8bab);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $hWR4i = parcelRequire("hWR4i");

var $Eg5r3 = parcelRequire("Eg5r3");
const $58fca68b47c6ed0a$export$72f28c8f041a8bab = ()=>{
    const error = (0, $hWR4i.useError)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!error) setErrorMessage(null);
        else {
            const message = (0, $Eg5r3.errorCodeToErrorMessageMap)[error.errorCode];
            const formattedMessage = formatMessage(message);
            setErrorMessage(formattedMessage);
        }
    }, [
        error,
        formatMessage
    ]);
    return errorMessage ? [
        {
            message: errorMessage
        }
    ] : [
        null
    ];
};

});
parcelRegister("hWR4i", function(module, exports) {

$parcel$export(module.exports, "useError", () => $f8113830da212eb6$export$5027865de34f9ec6);

var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $f8113830da212eb6$export$5027865de34f9ec6 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: (state)=>state.error
});

});

parcelRegister("Eg5r3", function(module, exports) {

$parcel$export(module.exports, "errorCodeToErrorMessageMap", () => $64a1e22d648f2213$export$c36ca6969b1c2a38);

var $7ze1Z = parcelRequire("7ze1Z");
const $64a1e22d648f2213$export$c36ca6969b1c2a38 = {
    ON_BRIDGE_ERROR_ERROR_CODE: (0, $7ze1Z.default).applyingUimFailed,
    USE_REGISTER_FIELDS_ERROR_CODE: (0, $7ze1Z.default).applyingUimFailed,
    USE_SUBMIT_ERROR_CODE: (0, $7ze1Z.default).applyingUimFailed,
    PER_FIELD_HOOK_ERROR_CODE: (0, $7ze1Z.default).applyingUimFailed,
    SCOPES_MISSING_ERROR_CODE: (0, $7ze1Z.default).appDoesNotHaveRequiredScopes,
    ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, $7ze1Z.default).applyingUimFailed,
    ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, $7ze1Z.default).loadingUimFailed
};

});
parcelRegister("7ze1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9acf1903b7e802fb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9acf1903b7e802fb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingUimFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-failed",
        "defaultMessage": "We couldn't load the UI modifications for this form."
    },
    loadingUimDataFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-data-failed",
        "defaultMessage": "We couldn't load the UI modifications configuration for this form."
    },
    applyingUimFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.applying-uim-failed",
        "defaultMessage": "We encountered an error while applying UI modifications to this form."
    },
    appDoesNotHaveRequiredScopes: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.app-does-not-have-required-scopes",
        "defaultMessage": "We couldn\u2019t load some of the UI modifications apps for this page, because they don\u2019t have required scopes."
    }
});

});



parcelRegister("lXZTi", function(module, exports) {

$parcel$export(module.exports, "useUiModificationsNotifications", () => $b29798151379c10c$export$3a867504a28cd936);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3XATr = parcelRequire("3XATr");

var $3EZBv = parcelRequire("3EZBv");
const $b29798151379c10c$export$3a867504a28cd936 = ()=>{
    const notification = (0, $3XATr.useNotification)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [notificationProperties, setNotificationProperties] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!notification) setNotificationProperties(null);
        else {
            const properties = (0, $3EZBv.notificationTypeToNotificationProperties)[notification.type];
            const formattedMessage = formatMessage(properties.message);
            setNotificationProperties({
                message: formattedMessage,
                type: properties.type
            });
        }
    }, [
        notification,
        formatMessage
    ]);
    return notificationProperties ? [
        notificationProperties
    ] : [
        null
    ];
};

});
parcelRegister("3XATr", function(module, exports) {

$parcel$export(module.exports, "useNotification", () => $c0fe6e393d570570$export$9949bd9c713ba425);

var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $c0fe6e393d570570$export$9949bd9c713ba425 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: (state)=>state.notification
});

});

parcelRegister("3EZBv", function(module, exports) {

$parcel$export(module.exports, "notificationTypeToNotificationProperties", () => $c2ee6057cddfff25$export$3dd11dfb655fc1de);

var $asCOJ = parcelRequire("asCOJ");
const $c2ee6057cddfff25$export$3dd11dfb655fc1de = {
    MULTIPLE_APPS_CONFLICTS: {
        message: (0, $asCOJ.default).multipleAppsConflicted,
        type: 'warning'
    }
};

});
parcelRegister("asCOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e908fb1914785e5d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e908fb1914785e5d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    multipleAppsConflicted: {
        "id": "ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted",
        "defaultMessage": "Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin."
    }
});

});



parcelRegister("i4fCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dda28a4aa21d82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $65dda28a4aa21d82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requiredFieldsUnsupportedForAdmin: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForUser: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, <a>reach out to your Jira admin</a> to make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForAdminIssueTermRefresh: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin-issue-term-refresh",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating work items, make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForUserIssueTermRefresh: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user-issue-term-refresh",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating work items, <a>reach out to your admin</a> to make the field(s) optional and remove the field(s) from this screen."
    }
});

});

parcelRegister("eHwnM", function(module, exports) {

$parcel$export(module.exports, "getDisplayErrorString", () => $2ca4b4c6fd5f260b$export$3455fb62ca5e4ef7);
const $2ca4b4c6fd5f260b$export$3455fb62ca5e4ef7 = (submitErrorMessage)=>{
    try {
        // Error in json:
        // "{\"errorMessages\":[],\"errors\":{\"assignee\":\"The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.\",\"othererror\":\"xxxx.\"}}";
        const errsObj = JSON.parse(submitErrorMessage);
        if (errsObj.errors) {
            const values = Object.values(errsObj.errors).filter((value)=>typeof value === 'string');
            if (values.length > 0) return values;
        }
    } catch (error) {
    /* empty */ }
    return [
        submitErrorMessage
    ];
};

});


parcelRegister("gB2JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d956e7182da22b4d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $koVbs = parcelRequire("koVbs");

var $7C5S0 = parcelRequire("7C5S0");

var $cKWWX = parcelRequire("cKWWX");

var $7wE6m = parcelRequire("7wE6m");

var $hOPPE = parcelRequire("hOPPE");
const $d956e7182da22b4d$var$SitePicker = (props)=>{
    const { classNamePrefix: classNamePrefix, onChange: onChange, onSiteSelection: onSiteSelection, width: width = 350 } = props;
    const [{ selectedCloudId: selectedCloudId }, { setSitePickerState: setSitePickerState }] = (0, $cKWWX.useSitePickerContext)();
    const { sites: sites, error: error, isLoading: isLoading } = (0, $7wE6m.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useEffect)(()=>{
        if (!sites) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const currentSite = window.location.hostname.split('.')[0];
        const prefilledValue = sites?.filter((site)=>site.label === currentSite)?.[0] || {};
        // if there's a cloudId that doesn't match host site, change selectedValue
        if (selectedCloudId && selectedCloudId !== prefilledValue?.value) {
            const selectedSite = sites?.filter((site)=>site.value === selectedCloudId)?.[0] || {};
            // if no site is found in the list for any reason, default to host domain
            const initialValue = selectedSite || prefilledValue;
            setSelectedValue(initialValue);
            onSiteSelection?.(initialValue.value);
            return;
        }
        onSiteSelection?.(prefilledValue.value || '');
        setSitePickerState({
            siteDomain: prefilledValue.url || ''
        });
        setSelectedValue(prefilledValue);
    }, [
        onChange,
        selectedCloudId,
        onSiteSelection,
        setSitePickerState,
        sites
    ]);
    const _onChange = (0, $5uXOq.useCallback)((option)=>{
        setSitePickerState({
            siteDomain: option?.url || '',
            selectedCloudId: option?.value || ''
        });
        onChange?.();
        setSelectedValue(option || {});
        onSiteSelection?.(option?.value || '');
    }, [
        setSitePickerState,
        onChange,
        onSiteSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        packageName: "jiraIssueCreate",
        id: "JiraSitePickerSelect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "site",
        label: formatMessage((0, $hOPPE.default).sitePickerFieldLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            inputId: fieldProps?.id,
            value: selectedValue,
            options: $d956e7182da22b4d$export$4dda509356982425(sites),
            // @ts-expect-error - TS2322 - Type '(option: SelectOption | null) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: _onChange,
            classNamePrefix: classNamePrefix,
            isLoading: isLoading
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $hOPPE.default).sitePickerError)))))));
};
const $d956e7182da22b4d$export$4dda509356982425 = (siteOptions)=>{
    return siteOptions.sort((siteA, siteB)=>{
        return siteA?.label.localeCompare(siteB?.label);
    });
};
var $d956e7182da22b4d$export$2e2bcd8739ae039 = $d956e7182da22b4d$var$SitePicker;

});
parcelRegister("7wE6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cfbc54228e85991$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $1cfbc54228e85991$var$AVAILABLE_SITES_ENDPOINT = '/gateway/api/available-sites';
const $1cfbc54228e85991$export$8f93d3ef836534e6 = ()=>[
        'jira-product-discovery'
    ];
const $1cfbc54228e85991$var$fetchJiraAppLink = async ()=>(0, $eusud.performPostRequest)($1cfbc54228e85991$var$AVAILABLE_SITES_ENDPOINT, {
        body: JSON.stringify({
            products: [
                'jira-software.ondemand',
                'jira-core.ondemand',
                'jira-servicedesk.ondemand',
                ...$1cfbc54228e85991$export$8f93d3ef836534e6()
            ]
        })
    });
const $1cfbc54228e85991$export$9d182d381b792de6 = (item)=>({
        label: item.displayName,
        value: item.cloudId,
        url: item.url
    });
const $1cfbc54228e85991$export$905fc72a68d660cf = (sites)=>sites.map($1cfbc54228e85991$export$9d182d381b792de6);
const $1cfbc54228e85991$var$useFetchJiraAvailableSites = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)($1cfbc54228e85991$var$fetchJiraAppLink);
    (0, $5uXOq.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    const sites = (0, $5uXOq.useMemo)(()=>{
        if (data && data.sites && data.sites.length) return $1cfbc54228e85991$export$905fc72a68d660cf(data.sites);
        return [];
    }, [
        data
    ]);
    return {
        isLoading: loading,
        error: error,
        sites: sites
    };
};
var $1cfbc54228e85991$export$2e2bcd8739ae039 = $1cfbc54228e85991$var$useFetchJiraAvailableSites;

});

parcelRegister("hOPPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $de12e9afe29525fe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de12e9afe29525fe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sitePickerFieldLabel: {
        "id": "issue-create.modal.create-form.site-picker.site-picker-field-label",
        "defaultMessage": "Site"
    },
    sitePickerError: {
        "id": "issue-create.modal.create-form.site-picker.site-picker-error",
        "defaultMessage": "Error in fetching the site options"
    }
});

});


parcelRegister("9TbCg", function(module, exports) {

$parcel$export(module.exports, "SmartFieldMessage", () => $674b03d1566318d3$export$ef68b7820636cd13);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $2jwCH = parcelRequire("2jwCH");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $iUFy5 = parcelRequire("iUFy5");

var $gEEzS = parcelRequire("gEEzS");

var $aA974 = parcelRequire("aA974");

var $erRWO = parcelRequire("erRWO");
const $674b03d1566318d3$export$ef68b7820636cd13 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, isSmartFieldsGicOnboardingDismissed: isSmartFieldsGicOnboardingDismissed, dismissGicOnboarding: dismissGicOnboarding } = (0, $aA974.useIsSmartFieldsOptIn)();
    const { updatePreferences: updatePreferences } = (0, $gEEzS.useSmartFieldsUpdateUserPreference)();
    const handleDismissMessage = (0, $5uXOq.useCallback)(()=>{
        dismissGicOnboarding();
        updatePreferences({
            hasUserOptedOut: !isSmartFieldsOptIn,
            hasUserDismissedGicOnboarding: true,
            hasUserDismissedReadMore: !!isSmartFieldDismissedReadMore
        });
    }, [
        dismissGicOnboarding,
        isSmartFieldDismissedReadMore,
        isSmartFieldsOptIn,
        updatePreferences
    ]);
    const { view: view, setView: setView, setShouldFocusChanger: setShouldFocusChanger } = (0, $iUFy5.useMinimizableModal)();
    const handleOnReadMoreClick = (0, $5uXOq.useCallback)(()=>{
        if (view === 'modal') {
            setShouldFocusChanger(true);
            setView('mini');
        }
    }, [
        view,
        setShouldFocusChanger,
        setView
    ]);
    return isSmartFieldsOptIn && isSmartFieldsGicOnboardingDismissed !== true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        backgroundColor: "color.background.discovery",
        padding: "space.100",
        xcss: $674b03d1566318d3$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $674b03d1566318d3$var$helpTextStyles
    }, formatMessage((0, $erRWO.default).readMore, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                articleId: "3svLIYAFXrcqQlJXtqEc6G",
                appearance: "link",
                spacing: "none",
                fallbackComponent: null,
                onClick: handleOnReadMoreClick
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))),
        label: formatMessage((0, $erRWO.default).dismissButtonLabel),
        onClick: handleDismissMessage,
        spacing: "compact"
    }))) : null;
};
const $674b03d1566318d3$var$boxStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius'
});
const $674b03d1566318d3$var$helpTextStyles = (0, $8CUq3.xcss)({
    alignSelf: 'center'
});

});
parcelRegister("erRWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70b90ddadbe55f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a70b90ddadbe55f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    readMore: {
        "id": "issue-create.modal.create-form.smart-field-message.read-more",
        "defaultMessage": "We\u2019ve surfaced the fields you use often, and hidden the ones you don\u2019t. <link>More about this change</link>"
    },
    dismissButtonLabel: {
        "id": "issue-create.modal.create-form.smart-field-message.dismiss-button-label",
        "defaultMessage": "Dismiss this message"
    }
});

});


parcelRegister("64HID", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ac611cd00dc10b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $qfj8c = parcelRequire("qfj8c");
var $2x3Cb = parcelRequire("2x3Cb");

var $bU3PY = parcelRequire("bU3PY");

var $1wbtX = parcelRequire("1wbtX");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7C5S0 = parcelRequire("7C5S0");

var $hmK1M = parcelRequire("hmK1M");

var $02Psx = parcelRequire("02Psx");


var $1xqgn = parcelRequire("1xqgn");

var $45Cy1 = parcelRequire("45Cy1");


var $c8Fpj = parcelRequire("c8Fpj");

var $7UXKz = parcelRequire("7UXKz");

var $8umLM = parcelRequire("8umLM");
const $19ac611cd00dc10b$var$statusFieldMargin = (0, $gwIPs.gridSize) * 2.25;
const $19ac611cd00dc10b$var$StatusField = ({ onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [hasCreatedStatus, setHasCreatedStatus] = (0, $5uXOq.useState)(false);
    const onStatusCreatedOrUpdatedCallback = (0, $5uXOq.useCallback)(async ()=>{
        await onStatusCreatedOrUpdated?.();
        setHasCreatedStatus(true);
    }, [
        onStatusCreatedOrUpdated
    ]);
    const defaultProps = {
        isLoading: false,
        footer: undefined,
        fieldId: 'gic-status-field'
    };
    const [inlineStatusConfigExp] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusConfigEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(props.canConfigureStatuses);
    const isConfigureStatusAvailable = (isInlineStatusConfigEnabled || combinedInlineConfigurationExperiment.isEnabled) && props.canConfigureStatuses;
    const isManageWorkflowAvailable = isConfigureStatusAvailable && props.projectType && props.issueTypeId;
    const getEnabledTransitions = (transitions)=>transitions.filter((transition)=>transition.isDisabled === false);
    const nextgenWorkflowUrl = props.projectType && props.issueTypeId && (0, $02Psx.getNextgenSettingsWorkflowUrl)(props.projectType, props.projectKey, props.issueTypeId) || '';
    const openManageWorkflow = (0, $c8Fpj.useOpenManageFieldTab)({
        source: (0, $16b9f6b2f8c4a675$export$c9f0eab6c600e941),
        url: nextgenWorkflowUrl
    });
    const onOpenManageWorkflow = isConfigureStatusAvailable ? openManageWorkflow : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))); // used as footer with popup select component
    const manageWorkFlowButton = (0, $7UXKz.ManageFieldButton)({
        url: nextgenWorkflowUrl,
        label: formatMessage((0, $8umLM.default).manageWorkflowFooter),
        source: (0, $16b9f6b2f8c4a675$export$c9f0eab6c600e941)
    });
    const getFieldContent = ()=>{
        if (props.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$FieldSkeleton, {
            isMini: props.isMini,
            "aria-busy": true
        });
        if (!props.value?.to) // error state
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$FieldErrorSkeleton, {
            isMini: props.isMini
        });
        if (props.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$FieldErrorSkeleton, {
            isMini: props.isMini
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hmK1M.StatusView), {
            ...defaultProps,
            appearance: "button",
            value: props.value?.to,
            selectedTransition: props.value,
            transitions: getEnabledTransitions(props.transitions),
            forceNoLabels: true,
            isDefaultSelect: props.isMini,
            onChange: props.onChange,
            customNoOptionsMessage: formatMessage((0, $8umLM.default).noEnabledTransitionsMessage),
            shouldFitContainer: false,
            showConfigureStatusButtons: props.canConfigureStatuses && (0, $6s1PB.expVal)('inline_status_add_and_rename_in_gic', 'isInlineStatusConfigEnabled', false),
            projectId: props.projectId,
            issueTypeId: props.issueTypeId,
            projectKey: props.projectKey,
            projectType: props.projectType,
            onStatusCreatedOrUpdated: onStatusCreatedOrUpdatedCallback,
            footer: isManageWorkflowAvailable ? manageWorkFlowButton : null,
            onOpenManageWorkflow: onOpenManageWorkflow,
            configureStatusSource: (0, $77f8834f432b7338$export$66397ed56abea4ca),
            autofocus: hasCreatedStatus,
            configureStatusButtonsEnabled: props.canConfigureStatuses
        });
    };
    const [selectedIssueType] = (0, $45Cy1.useIssueType)();
    const issueType = selectedIssueType?.label;
    const getMessage = ()=>{
        if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $8umLM.default).warningMessageIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8umLM.default).warningMessageIssueTermRefresh : (0, $8umLM.default).warningMessage;
    };
    const getHelpOrWarningText = ()=>{
        if (props.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-warning, #E56910)",
            label: formatMessage((0, $8umLM.default).warningIconLabel)
        }), formatMessage(getMessage(), {
            issueType: issueType
        }));
        if (props.isMini) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$HelperText, null, formatMessage((0, $8umLM.default).helperText));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        marginTop: $19ac611cd00dc10b$var$statusFieldMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: defaultProps.fieldId,
        id: "gic-status-field-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$LabelFlex, null, formatMessage((0, $8umLM.default).statusFieldLabel))), getFieldContent(), getHelpOrWarningText());
};
var $19ac611cd00dc10b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $19ac611cd00dc10b$var$StatusField;
const $19ac611cd00dc10b$var$HelperText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l _19pk12x7 _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19ac611cd00dc10b$var$FieldSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyri2wt",
            __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19ac611cd00dc10b$var$FieldErrorSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr12x7 _bfhkn82g",
            __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19ac611cd00dc10b$var$LabelFlex = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hmK1M", function(module, exports) {

$parcel$export(module.exports, "StatusView", () => $f4607509f8535f3b$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $f4607509f8535f3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $8Rkzz = parcelRequire("8Rkzz");

var $eTXmK = parcelRequire("eTXmK");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");
var $b9dFI = parcelRequire("b9dFI");

var $6sO8n = parcelRequire("6sO8n");

var $i0vxP = parcelRequire("i0vxP");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $N7jPX = parcelRequire("N7jPX");

var $gyeeU = parcelRequire("gyeeU");

var $9qzmO = parcelRequire("9qzmO");

var $fJ83Q = parcelRequire("fJ83Q");


var $17mYr = parcelRequire("17mYr");

var $44VbI = parcelRequire("44VbI");

var $kTnV4 = parcelRequire("kTnV4");

var $2NP8E = parcelRequire("2NP8E");

var $k9YKz = parcelRequire("k9YKz");

var $k92cH = parcelRequire("k92cH");

var $coyc6 = parcelRequire("coyc6");

var $rNSQs = parcelRequire("rNSQs");

var $1khYv = parcelRequire("1khYv");

var $1xqgn = parcelRequire("1xqgn");

var $hOOVM = parcelRequire("hOOVM");

var $02biC = parcelRequire("02biC");

var $4hdrg = parcelRequire("4hdrg");

var $5uNOo = parcelRequire("5uNOo");
const $f4607509f8535f3b$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $f4607509f8535f3b$var$isOptionDisabled = (option)=>('transition' in option && option.transition.isDisabled) ?? false;
const $f4607509f8535f3b$var$isTransitionOption = (option)=>'transition' in option;
const $f4607509f8535f3b$var$isFooterOption = (option)=>'type' in option;
const $f4607509f8535f3b$export$a11134e1462e763 = ({ forceNoLabels: forceNoLabels = false, isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, error: error, value: value, transitions: transitions, appearance: appearance, footer: footer, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onFetch: onFetch, fieldId: fieldId, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, defaultOpen: // for testing
defaultOpen = false, shouldFitContainer: shouldFitContainer = true, onUpdateStatusMutation: onUpdateStatusMutation, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, onOpenManageWorkflow: onOpenManageWorkflow, configureStatusSource: configureStatusSource, autofocus: autofocus = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const lastKey = (0, $5uXOq.useRef)(null);
    const childWrapperRef = (0, $5uXOq.useRef)(null);
    const selectRef = (0, $5uXOq.useRef)(null);
    const wasChanged = (0, $5uXOq.useRef)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const previousIsSaving = (0, $1XJ20.usePrevious)(isSaving);
    const previousTransitions = (0, $1XJ20.usePrevious)(transitions);
    const previousIsOpen = (0, $1XJ20.usePrevious)(isOpen);
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $44VbI.getFilteredOrderedTransitions)(transitions, value.id);
    const isGlobalOnly = (0, $44VbI.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    const [inlineStatusConfigExp] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const isConfigureStatusAvailable = isInlineStatusExperimentEnabled && showConfigureStatusButtons && projectType && projectKey;
    const createStatusButtonRef = (0, $5uXOq.useRef)(null);
    const editStatusButtonRef = (0, $5uXOq.useRef)(null);
    const menuListRef = (0, $5uXOq.useRef)(null);
    const [isConfigureStatusModalOpen, setIsConfigureStatusModalOpen] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (autofocus && (0, $4R6GH.fg)('focus_status_select_after_status_creation_gic')) selectRef.current?.focus?.();
    }, [
        autofocus
    ]);
    const formatTransitionOptionLabel = (0, $5uXOq.useCallback)((option)=>{
        if (!(0, $4R6GH.fg)('inline_config_a11y_improvements') && (showConfigureStatusButtons || combinedInlineConfigurationExperiment.isEnabled) && projectId && projectKey) {
            const status = {
                id: option.transition.to.id,
                statusName: option.transition.to.name,
                statusCategory: (0, $gULOk.statusCategoryForId)(option.transition.to.statusCategory.id)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
                transition: option.transition,
                hasLabel: showLabel,
                contentAfter: // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
                !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && option.transition.id !== selectedTransition?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9YKz.EditStatusButtonOld), {
                    status: status,
                    projectId: projectId,
                    // temporary empty string will trigger a loading state within the edit status modal
                    issueTypeId: issueTypeId ?? '',
                    projectKey: projectKey,
                    statusNames: transitions?.map((transition)=>transition.to.name),
                    onClick: ()=>setIsConfigureStatusModalOpen?.(true),
                    onClose: ()=>setIsConfigureStatusModalOpen?.(false),
                    onStatusUpdated: onStatusCreatedOrUpdated,
                    source: configureStatusSource
                }),
                testId: "issue-field-status.ui.status-view.transition"
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            testId: "issue-field-status.ui.status-view.transition"
        });
    }, [
        projectId,
        projectKey,
        combinedInlineConfigurationExperiment.isEnabled,
        showConfigureStatusButtons,
        showLabel,
        selectedTransition?.id,
        issueTypeId,
        transitions,
        onStatusCreatedOrUpdated,
        configureStatusSource
    ]);
    const formatTransitionOptionLabelForCommandPalette = (0, $5uXOq.useCallback)((option, transitionProps)=>{
        if (!(0, $4R6GH.fg)('inline_config_a11y_improvements') && (showConfigureStatusButtons || combinedInlineConfigurationExperiment.isEnabled) && projectId && projectKey) {
            const status = {
                id: option.transition.to.id,
                statusName: option.transition.to.name,
                statusCategory: (0, $gULOk.statusCategoryForId)(option.transition.to.statusCategory.id)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
                transition: option.transition,
                hasLabel: showLabel,
                addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
                contentAfter: // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
                !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && option.transition.id !== selectedTransition?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9YKz.EditStatusButtonOld), {
                    status: status,
                    projectId: projectId,
                    // temporary empty string will trigger a loading state within the edit status modal
                    issueTypeId: issueTypeId ?? '',
                    projectKey: projectKey,
                    statusNames: transitions?.map((transition)=>transition.to.name),
                    onClick: ()=>setIsConfigureStatusModalOpen?.(true),
                    onClose: ()=>setIsConfigureStatusModalOpen?.(false),
                    onStatusUpdated: onStatusCreatedOrUpdated,
                    source: configureStatusSource
                }),
                testId: "issue-field-status.ui.status-view.transition"
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
            testId: "issue-field-status.ui.status-view.transition"
        });
    }, [
        projectId,
        projectKey,
        combinedInlineConfigurationExperiment.isEnabled,
        showConfigureStatusButtons,
        showLabel,
        selectedTransition?.id,
        issueTypeId,
        transitions,
        onStatusCreatedOrUpdated,
        configureStatusSource
    ]);
    const formatTransitionOptionLabelWithCreateStatus = (0, $5uXOq.useCallback)((option)=>{
        if ((isConfigureStatusAvailable || combinedInlineConfigurationExperiment.isEnabled) && projectKey && projectType && projectId && issueTypeId && 'value' in option) switch(option.value){
            case 0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3:
                return (0, $4R6GH.fg)('inline_config_a11y_improvements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02biC.CreateStatusOption), {
                    projectId: projectId,
                    projectKey: projectKey,
                    projectType: projectType,
                    issueTypeId: issueTypeId,
                    statusNames: transitions?.map((transition)=>transition?.to?.name),
                    onClick: ()=>setIsConfigureStatusModalOpen(true),
                    onClose: ()=>setIsConfigureStatusModalOpen(false),
                    onStatusCreated: onStatusCreatedOrUpdated,
                    buttonRef: createStatusButtonRef,
                    source: configureStatusSource
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NP8E.CreateStatusButton), {
                    projectId: projectId,
                    projectKey: projectKey,
                    projectType: projectType,
                    issueTypeId: issueTypeId,
                    statusNames: transitions?.map((transition)=>transition?.to?.name),
                    onClick: ()=>setIsConfigureStatusModalOpen(true),
                    onClose: ()=>setIsConfigureStatusModalOpen(false),
                    onStatusCreated: onStatusCreatedOrUpdated,
                    isPressable: true,
                    buttonRef: createStatusButtonRef,
                    source: configureStatusSource
                });
            case 0, $4ffa16dc12cfa934$export$bc1622166baa0162:
                return transitions && value && (0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hdrg.EditStatusOption), {
                    status: (0, $9qzmO.transformServerRestStatusToStatus)(value),
                    statuses: transitions.map((transition)=>(0, $9qzmO.transformServerRestStatusToStatus)(transition?.to)),
                    projectId: projectId,
                    projectKey: projectKey,
                    issueTypeId: issueTypeId,
                    statusNames: transitions?.map((transition)=>transition?.to?.name),
                    onClick: ()=>setIsConfigureStatusModalOpen(true),
                    onClose: ()=>setIsConfigureStatusModalOpen(false),
                    onStatusUpdated: onStatusCreatedOrUpdated,
                    source: configureStatusSource,
                    buttonRef: editStatusButtonRef
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
            case 0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b:
                return (0, $4R6GH.fg)('inline_config_a11y_improvements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f4607509f8535f3b$var$manageWorkflowStyles
                }, option.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                    xcss: $f4607509f8535f3b$var$manageWorkflowStyles
                }, option.label);
            default:
                break;
        }
        return $f4607509f8535f3b$var$isTransitionOption(option) && formatTransitionOptionLabel(option);
    }, [
        isConfigureStatusAvailable,
        projectId,
        issueTypeId,
        formatTransitionOptionLabel,
        projectKey,
        projectType,
        transitions,
        onStatusCreatedOrUpdated,
        configureStatusSource,
        combinedInlineConfigurationExperiment.isEnabled,
        value
    ]); // specifically for screen readers
    const getTransitionOptionLabel = (option)=>{
        if ($f4607509f8535f3b$var$isTransitionOption(option)) return option.transition.isGlobal ? formatMessage((0, $k92cH.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
        return option.label;
    };
    const mergedPopperProps = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))($f4607509f8535f3b$var$defaultPopperProps, popperProps), [
        popperProps
    ]); // componentWillUpdate
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isOpen,
        isSaving,
        previousIsOpen,
        previousIsSaving,
        previousTransitions,
        transitions
    ]);
    const handleChangeStatus = (0, $5uXOq.useCallback)((transition)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        const analyticsEvent = createAnalyticsEvent({
            action: 'transitionSelected',
            actionSubject: 'statusField'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        if ((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition')) (0, $eTXmK.default)('issue.fields.status.popup.submit');
        onChange?.(transition, analyticsEvent);
    }, [
        onChange,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $5uXOq.useCallback)((option)=>{
        if ((combinedInlineConfigurationExperiment.isEnabled || isConfigureStatusAvailable) && option?.value && [
            (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
            (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b),
            (0, $4ffa16dc12cfa934$export$bc1622166baa0162)
        ].includes(option.value)) {
            switch(option?.value){
                case 0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3:
                    createStatusButtonRef?.current?.click();
                    setIsConfigureStatusModalOpen(true);
                    break;
                case 0, $4ffa16dc12cfa934$export$bc1622166baa0162:
                    if ((0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config')) {
                        editStatusButtonRef?.current?.click();
                        setIsConfigureStatusModalOpen(true);
                    }
                    break;
                case 0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b:
                    onOpenManageWorkflow && onOpenManageWorkflow();
                    break;
                default:
                    break;
            }
            return;
        }
        if (!(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements')) setIsMenuOpen(false);
        if (option && $f4607509f8535f3b$var$isTransitionOption(option)) handleChangeStatus(option.transition);
    }, [
        handleChangeStatus,
        isConfigureStatusAvailable,
        onOpenManageWorkflow,
        combinedInlineConfigurationExperiment.isEnabled
    ]);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'openDropdown',
            actionSubject: 'statusField'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
        combinedInlineConfigurationExperiment.fireExposure();
    }, [
        onOpen,
        combinedInlineConfigurationExperiment,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
    }, [
        onClose
    ]);
    const handleKeyDownForSelect = (0, $5uXOq.useCallback)((e)=>{
        lastKey.current = e.key;
    }, [
        lastKey
    ]);
    const handleCloseforSelect = (0, $5uXOq.useCallback)(()=>{
        // Prevents closing the menu when tabbing to edit status buttons
        // Preserves ability for Esc key to close menu
        if (lastKey.current !== 'Tab') setIsMenuOpen(false);
    }, [
        lastKey,
        setIsMenuOpen
    ]);
    const renderLozenge = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef, contentRef: contentRef })=>{
        if (saving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sO8n.default), {
            border: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
            targetRef: targetRef,
            status: value,
            error: error,
            contentRef: contentRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
            ariaLabel: `${value.name} - ${formatMessage((0, $k92cH.default).changeStatus)}`,
            error: err,
            hasHoverState: true,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef,
            contentRef: contentRef
        });
    }, [
        error,
        formatMessage,
        isOpen,
        value
    ]);
    const renderButton = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, targetRef: targetRef })=>{
        const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $rNSQs.StatusButton), {
            ariaLabel: `${value.name} - ${formatMessage((0, $k92cH.default).changeStatus)}`,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef,
            statusButtonRef: statusButtonRef,
            shouldFitContainer: shouldFitContainer
        });
        return saving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sO8n.default), null, statusButton) : statusButton;
    }, [
        formatMessage,
        isOpen,
        shouldFitContainer,
        statusButtonRef,
        value
    ]);
    const renderCommandPalette = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTnV4.CommandPaletteStatusView), {
            transitions: filteredAndOrderedTransitions,
            currentStatus: value,
            onSuccess: onSuccess,
            wasFetchSuccessful: wasFetchSuccessful,
            renderTransition: formatTransitionOptionLabelForCommandPalette,
            onFetch: onFetch,
            isLoading: isLoading,
            onUpdateStatusMutation: onUpdateStatusMutation
        }), [
        filteredAndOrderedTransitions,
        value,
        onSuccess,
        wasFetchSuccessful,
        formatTransitionOptionLabelForCommandPalette,
        onFetch,
        isLoading,
        onUpdateStatusMutation
    ]);
    const renderWithFocusWrapper = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: childWrapperRef
        }, children), []);
    const renderTarget = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (value) {
            if (appearance === 'lozenge') return renderWithFocusWrapper(renderLozenge({
                isEditable: editable,
                isSaving: saving,
                error: err,
                targetRef: targetRef,
                contentRef: statusButtonRef
            }));
            if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderWithFocusWrapper(renderButton({
                isEditable: editable,
                isSaving: saving,
                targetRef: targetRef
            })), registerInCommandPalette && renderCommandPalette());
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
    }, [
        appearance,
        registerInCommandPalette,
        renderButton,
        renderCommandPalette,
        renderLozenge,
        renderWithFocusWrapper,
        statusButtonRef,
        value
    ]);
    const isStatusInlineFooterEnabled = (0, $5uXOq.useMemo)(()=>combinedInlineConfigurationExperiment.isEnabled || isInlineStatusExperimentEnabled && showConfigureStatusButtons, [
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusExperimentEnabled,
        showConfigureStatusButtons
    ]);
    const transformedOptions = (0, $5uXOq.useMemo)(()=>(0, $44VbI.transformOptions)(filteredAndOrderedTransitions || []), [
        filteredAndOrderedTransitions
    ]);
    const selectOptions = (0, $1xqgn.useSelectOptions)(transformedOptions, isStatusInlineFooterEnabled);
    const renderOptionWithButtonForSelect = (0, $5uXOq.useCallback)(({ children: children, ...optionProps })=>{
        if ($f4607509f8535f3b$var$isFooterOption(optionProps.data) && [
            (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
            (0, $4ffa16dc12cfa934$export$bc1622166baa0162),
            (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b)
        ].includes(optionProps.data.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), {
            ...optionProps,
            innerProps: {
                ...optionProps.innerProps,
                role: 'button'
            }
        }, children);
         // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
        if (projectId && projectKey && optionProps.data && $f4607509f8535f3b$var$isTransitionOption(optionProps.data) && !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOOVM.OptionWithInlineConfigButtons), {
            showEditButton: combinedInlineConfigurationExperiment.isEnabled || Boolean(showConfigureStatusButtons),
            projectId: projectId,
            projectKey: projectKey,
            // temporary empty string will trigger a loading state within the edit status modal
            issueTypeId: issueTypeId ?? '',
            statusNames: transitions?.map((transition)=>transition.to.name) ?? [],
            menuListRef: menuListRef,
            onStatusUpdated: onStatusCreatedOrUpdated,
            source: configureStatusSource,
            onOpenEditModal: ()=>setIsConfigureStatusModalOpen(true),
            onCloseEditModal: ()=>setIsConfigureStatusModalOpen(false),
            ...optionProps
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xqgn.OptionComponent), optionProps, children);
    }, [
        showConfigureStatusButtons,
        projectId,
        projectKey,
        issueTypeId,
        transitions,
        menuListRef,
        onStatusCreatedOrUpdated,
        configureStatusSource,
        setIsConfigureStatusModalOpen,
        combinedInlineConfigurationExperiment.isEnabled
    ]);
    const renderOptionWithButtonForPopupSelect = (0, $5uXOq.useCallback)(({ children: children, ...optionProps })=>{
        // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
        if (projectId && projectKey && optionProps.data && $f4607509f8535f3b$var$isTransitionOption(optionProps.data) && !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOOVM.OptionWithInlineConfigButtons), {
            showEditButton: combinedInlineConfigurationExperiment.isEnabled || Boolean(showConfigureStatusButtons),
            projectId: projectId,
            projectKey: projectKey,
            // temporary empty string will trigger a loading state within the edit status modal
            issueTypeId: issueTypeId ?? '',
            statusNames: transitions?.map((transition)=>transition.to.name) ?? [],
            menuListRef: menuListRef,
            onStatusUpdated: onStatusCreatedOrUpdated,
            source: configureStatusSource,
            onOpenEditModal: ()=>setIsConfigureStatusModalOpen(true),
            onCloseEditModal: ()=>setIsConfigureStatusModalOpen(false),
            ...optionProps
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, optionProps, children);
    }, [
        showConfigureStatusButtons,
        projectId,
        projectKey,
        issueTypeId,
        transitions,
        menuListRef,
        onStatusCreatedOrUpdated,
        configureStatusSource,
        setIsConfigureStatusModalOpen,
        combinedInlineConfigurationExperiment.isEnabled
    ]);
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        const noPermissionMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $k92cH.default).noPermissionIssueTermRefresh : (0, $k92cH.default).noPermission;
        return formatMessage(wasFetchSuccessful ? noPermissionMessage : (0, $k92cH.default).cannotLoadTransitions);
    };
    const renderFooter = (0, $5uXOq.useCallback)(()=>{
        const showCreateStatusButton = (combinedInlineConfigurationExperiment.isEnabled || showConfigureStatusButtons) && projectKey && projectType && projectId;
        const showEditStatusButton = showCreateStatusButton && value && transitions && (0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config');
        return footer || showCreateStatusButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            direction: "column",
            xcss: $f4607509f8535f3b$var$statusViewFooterStyles
        }, showCreateStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NP8E.CreateStatusButton), {
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            // temporary empty string will trigger a loading state within the create status modal
            issueTypeId: issueTypeId ?? '',
            statusNames: transitions?.map((transition)=>transition.to.name),
            onClick: ()=>setIsConfigureStatusModalOpen(true),
            onClose: ()=>setIsConfigureStatusModalOpen(false),
            onStatusCreated: onStatusCreatedOrUpdated,
            source: configureStatusSource
        }), showEditStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uNOo.EditStatusButton), {
            status: (0, $9qzmO.transformServerRestStatusToStatus)(value),
            statuses: transitions.map((transition)=>(0, $9qzmO.transformServerRestStatusToStatus)(transition?.to)),
            projectId: projectId,
            projectKey: projectKey,
            // temporary empty string will trigger a loading state within the edit status modal
            issueTypeId: issueTypeId ?? '',
            statusNames: transitions?.map((transition)=>transition?.to?.name),
            onClick: ()=>setIsConfigureStatusModalOpen(true),
            onClose: ()=>setIsConfigureStatusModalOpen(false),
            onStatusUpdated: onStatusCreatedOrUpdated,
            source: configureStatusSource
        }), footer) : null;
    }, [
        footer,
        projectId,
        projectKey,
        projectType,
        showConfigureStatusButtons,
        configureStatusSource,
        issueTypeId,
        transitions,
        combinedInlineConfigurationExperiment.isEnabled,
        onStatusCreatedOrUpdated,
        value
    ]);
    const SelectWrapper = !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? (0, $gyeeU.AtlaskitSelectInlineTabActivator) : (0, $5uXOq.Fragment);
    const selectWrapperProps = !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? {
        setIsMenuOpen: setIsMenuOpen,
        isMenuOpen: isMenuOpen
    } : // Temporary until inline_config_a11y_improvements is cleaned up
    // Needed for VR tests to pass as props cannot be added to Fragment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {};
    const statusPopup = isDefaultSelect && selectedTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectWrapper, selectWrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        label: formatMessage((0, $k92cH.default).selectStatus),
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabelWithCreateStatus,
        getOptionLabel: getTransitionOptionLabel,
        options: selectOptions,
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
        onChange: handleChange,
        value: (0, $44VbI.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        ...(0, $4R6GH.fg)('jira_status_view_ts_improvements') ? {
            onMenuOpen: handleOpen
        } : {},
        closeMenuOnSelect: true,
        ...!(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? {
            onKeyDown: handleKeyDownForSelect,
            onMenuClose: handleCloseforSelect
        } : {},
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coyc6.LoadingSpinner), null),
            ...isStatusInlineFooterEnabled && {
                Group: (0, $N7jPX.GroupComponentWithStickyFooter),
                Option: !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? (props)=>renderOptionWithButtonForSelect(props) : (0, $1xqgn.OptionComponent)
            },
            ...(0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                MenuList: ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, {
                        ...props,
                        innerRef: menuListRef
                    }, children)
            }
        },
        menuIsOpen: // Remove eslint-disable-next-line when inline_config_a11y_improvements is cleaned up
        // eslint-disable-next-line no-nested-ternary
        isConfigureStatusModalOpen ? false : !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? isMenuOpen : undefined,
        popperProps: mergedPopperProps,
        ref: selectRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $44VbI.transformOptions)(filteredAndOrderedTransitions || []),
        target: ({ ref: ref })=>renderTarget({
                isEditable: isEditable,
                isSaving: isSaving,
                error: error,
                targetRef: ref
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        handleClick: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coyc6.LoadingSpinner), null),
            ...(combinedInlineConfigurationExperiment.isEnabled || showConfigureStatusButtons) && (0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                Option: (props)=>renderOptionWithButtonForPopupSelect(props)
            },
            ...(0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                MenuList: ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, {
                        ...props,
                        innerRef: menuListRef
                    }, children)
            }
        },
        isOpen: isConfigureStatusModalOpen ? false : undefined,
        popperProps: mergedPopperProps,
        footer: renderFooter(),
        defaultIsOpen: defaultOpen,
        label: formatMessage((0, $k92cH.default).selectStatus),
        shouldCloseMenuOnTab: false
    }); /* This prevents the dropdown from being accessible while saving/not editable,
                                                                                                                                                                                                                                * because for the underlying PopupSelect, the `isDisabled` prop only prevents
                                                                                                                                                                                                                                * the actual dropdown items from being selectable - the dropdown itself still
                                                                                                                                                                                                                                * pops up/down.
                                                                                                                                                                                                                                */ 
    if (isSaving || !isEditable) return renderTarget({
        isSaving: isSaving,
        isEditable: isEditable,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, statusPopup);
};
const $f4607509f8535f3b$var$statusViewFooterStyles = (0, $8CUq3.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`
});
const $f4607509f8535f3b$var$manageWorkflowStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});
var $f4607509f8535f3b$export$2e2bcd8739ae039 = $f4607509f8535f3b$export$a11134e1462e763;

});
parcelRegister("6sO8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d332aa7c19a695ac$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $d332aa7c19a695ac$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)));
}
$d332aa7c19a695ac$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d332aa7c19a695ac$var$BlanketContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$BackgroundContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$Background = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk11bn",
            __cmplp.border ? "_19it1x87" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$ComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _tzy4sxj9",
            __cmplp.className
        ])
    });
});

});

parcelRegister("N7jPX", function(module, exports) {

$parcel$export(module.exports, "GroupComponentWithStickyFooter", () => $20e766b49ec0b86c$export$a4fcc8b2698425e6);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

const $20e766b49ec0b86c$export$a4fcc8b2698425e6 = ({ children: children, ...groupProps })=>{
    const containStickyFooterGroup = (0, $5uXOq.useMemo)(()=>{
        return groupProps.data.options.find((option)=>option.groupType === (0, $8109ad51236d2441$export$e13d614fc55c6ce9));
    }, [
        groupProps.data.options
    ]);
    if (containStickyFooterGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20e766b49ec0b86c$var$stickyFooterGroupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, {
        ...groupProps,
        innerProps: {
            ...groupProps.innerProps ?? {},
            style: {
                ...groupProps.innerProps?.style ?? {},
                paddingTop: 0
            },
            className: (0, $8109ad51236d2441$export$1ae91d219a8713ac)
        }
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, groupProps, children);
};
const $20e766b49ec0b86c$var$stickyFooterGroupWrapper = (0, $8CUq3.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.overlay',
    borderBottomLeftRadius: 'border.radius.200',
    borderBottomRightRadius: 'border.radius.200',
    position: 'sticky',
    bottom: 'space.negative.100',
    marginBottom: 'space.negative.100',
    paddingTop: 'space.050'
});

});

parcelRegister("gyeeU", function(module, exports) {

$parcel$export(module.exports, "AtlaskitSelectInlineTabActivator", () => $77cb954647054621$export$db135681be6e3fdb);

var $5uXOq = parcelRequire("5uXOq");

var $ku1fk = parcelRequire("ku1fk");

var $dC5iT = parcelRequire("dC5iT");

var $4R6GH = parcelRequire("4R6GH");
const $77cb954647054621$export$db135681be6e3fdb = ({ setInputValue: setInputValue, setIsMenuOpen: setIsMenuOpen, inputValue: inputValue, isMenuOpen: isMenuOpen, children: children })=>{
    const selectWrapperRef = (0, $5uXOq.useRef)(null);
    const handleBlur = (0, $5uXOq.useCallback)((e)=>{
        // Always close the menu on outside focus and mouse events
        if (selectWrapperRef.current && e.target instanceof Node && // This is to make sure we only blur when focusing outside of the select
        // This is required to allow interacting with inline buttons inside the select dropdown
        !selectWrapperRef.current.contains(e.target)) {
            setInputValue?.('');
            setIsMenuOpen(false);
            return;
        }
        // Always toggle the menu open/closed on internal mousedown events
        if (e.type === 'mousedown') {
            // Reset the input value when closing the menu
            if (isMenuOpen) setInputValue?.('');
            setIsMenuOpen(!isMenuOpen);
        }
    }, [
        isMenuOpen,
        setInputValue,
        setIsMenuOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Listen to focus and mousedown events to close the select dropdown when clicking or focusing outside of it
        globalThis?.document?.addEventListener('focusin', handleBlur);
        globalThis?.document?.addEventListener('mousedown', handleBlur);
        return ()=>{
            globalThis?.document?.removeEventListener('focusin', handleBlur);
            globalThis?.document?.removeEventListener('mousedown', handleBlur);
        };
    }, [
        handleBlur
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Open the menu when the input value changes
        if (!isMenuOpen && inputValue) setIsMenuOpen(true);
    }, [
        inputValue,
        isMenuOpen,
        setIsMenuOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "inline-config-buttons-for-select.atlaskit-select-inline-tab-activator",
        ref: selectWrapperRef,
        onKeyDown: (e)=>{
            const openMenuKeys = [
                'ArrowDown',
                'ArrowUp',
                'Enter',
                ' '
            ];
            // Only override keydown events when the menu is open or to open the menu
            if (!isMenuOpen && !openMenuKeys.includes(e.key)) return;
            switch(e.key){
                // This is to handle closing the Select menu when pressing Escape
                case 'Escape':
                    setIsMenuOpen(false);
                    setInputValue?.('');
                    break;
                // This is to allow tabbing inside the Select menu
                // if the current focus one is last tabbable element, focus the first tabbable element
                // to prevent tabbing out of the Select menu
                case 'Tab':
                    {
                        (0, $4R6GH.fg)('inline_config_a11y_improvements') && e.stopPropagation();
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ku1fk)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        const isLastTabbable = tabbableEls[tabbableEls.length - 1] === globalThis?.document?.activeElement;
                        if (isLastTabbable) {
                            e.preventDefault();
                            tabbableEls[0].focus();
                        }
                        break;
                    }
                // This is to allow navigating inside the Select menu using Arrow keys after focusing on inline buttons
                // Because users can only continue navigating using Arrow keys if the focus is on the text input of select
                case 'ArrowDown':
                case 'ArrowUp':
                    {
                        if (!isMenuOpen) {
                            setIsMenuOpen(true);
                            return;
                        }
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ku1fk)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        tabbableEls[0].focus();
                        break;
                    }
                case 'Enter':
                case ' ':
                    if (!isMenuOpen) setIsMenuOpen(true);
                    break;
                default:
                    break;
            }
        }
    }, children);
};

});

parcelRegister("9qzmO", function(module, exports) {

$parcel$export(module.exports, "transformServerRestStatusToStatus", () => $2f20d3e5dd7a7bf3$export$f8064e1f9ab3c1e0);

var $gULOk = parcelRequire("gULOk");
const $2f20d3e5dd7a7bf3$export$f8064e1f9ab3c1e0 = (serverResStatus)=>{
    return {
        id: serverResStatus?.id ?? '',
        statusName: serverResStatus?.name ?? '',
        statusCategory: (0, $gULOk.statusCategoryForId)(serverResStatus?.statusCategory?.id)
    };
};

});

parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $9yOBd = parcelRequire("9yOBd");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    })));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $390c5e7bc7d9c77b$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);
const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});


parcelRegister("44VbI", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $d665573e03a66c7e$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $d665573e03a66c7e$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $d665573e03a66c7e$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $d665573e03a66c7e$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $d665573e03a66c7e$export$e2dafe47b17b2cfc);

var $8QpSo = parcelRequire("8QpSo");

var $gULOk = parcelRequire("gULOk");
const $d665573e03a66c7e$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $d665573e03a66c7e$var$filterLoopedTransitionsToSelf = (0, $8QpSo.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$d665573e03a66c7e$var$isGlobalSelfTransition(transition, currentStatusId) && !$d665573e03a66c7e$var$isInitialSelfTransition(transition, currentStatusId)));
const $d665573e03a66c7e$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $d665573e03a66c7e$export$707115549202b9e4 = (transitions, currentStatusId)=>$d665573e03a66c7e$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $d665573e03a66c7e$export$38146914a8d06579 = (0, $8QpSo.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $d665573e03a66c7e$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $d665573e03a66c7e$var$memoizedTranformOptions = (0, $8QpSo.default)($d665573e03a66c7e$var$formatOptions);
const $d665573e03a66c7e$export$8f4ed8ef83bcbf04 = (options)=>$d665573e03a66c7e$var$memoizedTranformOptions(options);
const $d665573e03a66c7e$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $gULOk.StatusCategoryIds)[category] || (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("kTnV4", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteStatusView", () => $95d268cd8622d793$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $f5h6d = parcelRequire("f5h6d");

var $3u0c5 = parcelRequire("3u0c5");

var $5p1kJ = parcelRequire("5p1kJ");

var $7C5Su = parcelRequire("7C5Su");

var $e34gT = parcelRequire("e34gT");

var $eG9rp = parcelRequire("eG9rp");

var $6NI23 = parcelRequire("6NI23");

var $1Kt4o = parcelRequire("1Kt4o");

var $fVMIs = parcelRequire("fVMIs");

var $jh7L9 = parcelRequire("jh7L9");

var $d8lE2 = parcelRequire("d8lE2");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $2gCtH = parcelRequire("2gCtH");

var $c6XT1 = parcelRequire("c6XT1");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $dXq4S = parcelRequire("dXq4S");


var $iokLh = parcelRequire("iokLh");

var $99Vn3 = parcelRequire("99Vn3");

var $fBoWB = parcelRequire("fBoWB");
const $95d268cd8622d793$export$d907a4132fe8618c = ({ onFetch: onFetch, wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const subscribeCommands = (0, $fVMIs.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }, { setChildCommands: setChildCommands }] = (0, $d8lE2.useCommandPaletteExpandedCommand)();
    const renderHeader = (0, $5uXOq.useCallback)((base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NI23.CommandFieldHeader), {
            ...base,
            issueKey: issueKey
        }), [
        issueKey
    ]);
    const issueAri = (0, $c6XT1.useIssueAri)();
    const { saveStatusField: saveStatusField } = (0, $99Vn3.useSaveStatusField)(issueKey, issueAri, onUpdateStatusMutation);
    const expandedCommandId = expandedCommand?.id;
    const issueId = issueAri && (0, $dXq4S.isAri)(issueAri) && (0, $4R6GH.fg)('one_event_improvements_1') ? (0, $dXq4S.getAriConfig)(issueAri).resourceId : undefined;
    const loadTransitions = (0, $5uXOq.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        })),
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5h6d))), {
                            spacing: "spacious",
                            label: ""
                        }) : undefined
                },
                keywords: (0, $fBoWB.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $jh7L9.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.STATUS_TYPE), {
                            analytics: createAnalyticsEvent({}),
                            attributes: {
                                isCommandPaletteEditing: true,
                                fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                                    issueId: issueId
                                }
                            }
                        });
                        else if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.STATUS_TYPE), {
                            isCommandPaletteEditing: true,
                            fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $5p1kJ.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const currentCommand = expandedCommandId ? [
            {
                id: `${(0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5h6d))), {
                            spacing: "spacious",
                            label: formatMessage((0, $iokLh.messages).editStatus)
                        }) : undefined,
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$CurrentStatusContainer, null, formatMessage((0, $iokLh.messages).current)))
                },
                primaryAction: {
                    type: (0, $jh7L9.CommandActionType).PERFORM,
                    perform: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
                }
            }
        ] : [];
        const commands = [
            ...currentCommand,
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        wasFetchSuccessful,
        transitions,
        expandedCommandId,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        renderTransition,
        createAnalyticsEvent,
        saveStatusField,
        issueId,
        onSuccess,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { commands: commands } = loadTransitions();
        const statusCommand = {
            id: (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774),
            name: formatMessage((0, $iokLh.messages).editStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $iokLh.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $e34gT.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $7C5Su.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5h6d))), {
                        spacing: "spacious",
                        label: ""
                    })
            },
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $iokLh.messages).fallbackNoResults)
                    }
                },
                components: {
                    Header: renderHeader
                },
                commands: commands,
                onClick: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? ()=>{
                    (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $5fc53.STATUS_TYPE), {
                        analytics: createAnalyticsEvent({}),
                        attributes: {
                            fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                            isCommandPaletteEditing: true
                        }
                    });
                } : undefined
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        loadTransitions,
        renderHeader,
        subscribeCommands,
        expandedCommand?.id,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && onFetch) onFetch(createAnalyticsEvent({}));
    }, [
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)) setChildCommands(loadTransitions());
    }, [
        expandedCommandId,
        isOpen,
        loadTransitions,
        setChildCommands
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d268cd8622d793$var$TransitionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d268cd8622d793$var$SelectedStatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d268cd8622d793$var$CurrentStatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f5h6d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6235186728ffd6d81eb5818a45d0cd77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afb49639195a4f18$var$_react = $afb49639195a4f18$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $afb49639195a4f18$var$_task = $afb49639195a4f18$var$_interopRequireDefault((parcelRequire("4xPlE")));

var $afb49639195a4f18$var$_task2 = $afb49639195a4f18$var$_interopRequireDefault((parcelRequire("imUQY")));
function $afb49639195a4f18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TaskIcon.
 * This component is TaskIcon, with `UNSAFE_fallbackIcon` set to "TaskIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afb49639195a4f18$var$TaskIcon = (props)=>/*#__PURE__*/ $afb49639195a4f18$var$_react.default.createElement($afb49639195a4f18$var$_task.default, Object.assign({
        LEGACY_fallbackIcon: $afb49639195a4f18$var$_task2.default
    }, props));
$afb49639195a4f18$var$TaskIcon.Name = 'TaskIconMigration';
var $afb49639195a4f18$var$_default = module.exports.default = $afb49639195a4f18$var$TaskIcon;

});
parcelRegister("imUQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5f661f66d7a7026$var$_react = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d5f661f66d7a7026$var$_task = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("4xPlE")));
function $d5f661f66d7a7026$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5f661f66d7a7026$var$TaskIcon = (props)=>/*#__PURE__*/ $d5f661f66d7a7026$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d5f661f66d7a7026$var$_task.default
    }));
$d5f661f66d7a7026$var$TaskIcon.displayName = 'TaskIcon';
var $d5f661f66d7a7026$var$_default = module.exports.default = $d5f661f66d7a7026$var$TaskIcon;

});


parcelRegister("7C5Su", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $235d212bb3595e05$export$5164bb42fa883371);
const $235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $235d212bb3595e05$export$5164bb42fa883371 = (key)=>$235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("e34gT", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $4ea99408c4a58cd0$export$cd9931655a8cfb04);

var $5p1kJ = parcelRequire("5p1kJ");
const $4ea99408c4a58cd0$export$cd9931655a8cfb04 = (issueKey)=>`${0, $5p1kJ.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});

parcelRegister("6NI23", function(module, exports) {

$parcel$export(module.exports, "CommandFieldHeader", () => $aaa7a329c29139ae$export$c6444eb1c6f44b2d);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");

var $jiSaf = parcelRequire("jiSaf");

var $2w83X = parcelRequire("2w83X");
const $aaa7a329c29139ae$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2w83X.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("jiSaf", function(module, exports) {

$parcel$export(module.exports, "components", () => $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);

var $5uXOq = parcelRequire("5uXOq");

var $dOktC = parcelRequire("dOktC");

var $haBRL = parcelRequire("haBRL");

var $dE25F = parcelRequire("dE25F");

var $d4iCz = parcelRequire("d4iCz");
const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
    CommandRow: $haBRL.CommandRow,
    Name: $44cb4d9bf5d8b8a6$var$NameComponent,
    LeftIcon: (0, $5uXOq.Fragment),
    Wrapper: (0, $5uXOq.Fragment),
    Footer: $dE25F.Footer,
    Body: (0, $dOktC.CommandPaletteBody),
    Header: $d4iCz.Header
};

});
parcelRegister("dOktC", function(module, exports) {

$parcel$export(module.exports, "NoResultsContainer", () => $2bc4c9970ded9a96$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $2bc4c9970ded9a96$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $2NMNM = parcelRequire("2NMNM");

var $d8lE2 = parcelRequire("d8lE2");

var $gM5ou = parcelRequire("gM5ou");

var $bYCTm = parcelRequire("bYCTm");

var $38IFv = parcelRequire("38IFv");

var $cLshs = parcelRequire("cLshs");

var $4nfzy = parcelRequire("4nfzy");

var $eKTyH = parcelRequire("eKTyH");

var $5aF2z = parcelRequire("5aF2z");

var $64ZBB = parcelRequire("64ZBB");
const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $d8lE2.useCommandPalette)();
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $gM5ou.getAnalyticsAttributesFromResult)(result),
                ...(0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $gM5ou.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const localResultRefs = resultsRefs.current;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
        "data-testid": (0, $5aF2z.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYCTm.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
            "data-testid": (0, $5aF2z.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nfzy.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38IFv.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKTyH.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $d8lE2.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
    const resultsRefs = (0, $5uXOq.useRef)([]);
    const modalBodyRef = (0, $5uXOq.useRef)(null);
    const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $5aF2z.SCROLL_DIRECTION).END : (0, $5aF2z.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $64ZBB.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $64ZBB.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $64ZBB.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cLshs.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bc4c9970ded9a96$var$GroupContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $lD23V.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bYCTm", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $85a6ab23a77e1ea6$export$591c26128e5fd757);

var $5uXOq = parcelRequire("5uXOq");

const $85a6ab23a77e1ea6$export$591c26128e5fd757 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("38IFv", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $9082b0edc4f10018$export$1f8fa9d1eef77b32);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");


var $9gNeg = parcelRequire("9gNeg");
const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        "aria-current": active,
        role: "menuitem",
        id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
        ...(0, $4R6GH.fg)('a11y_enghealth_fixes_deliveroo') && {
            'aria-label': formatMessage((0, $9gNeg.messages).resultListItemAriaLabel)
        },
        ...rest
    });
});

});
parcelRegister("9gNeg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37963fcec28f3d0a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $37963fcec28f3d0a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("cLshs", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $42c35fc284860d36$export$95554f6fb39a83c2);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");


var $zfug2 = parcelRequire("zfug2");

var $6LGvc = parcelRequire("6LGvc");
const $42c35fc284860d36$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const resizerRef = (0, $5uXOq.useRef)(null);
    const height = (0, $6LGvc.useSmoothExpand)(resizerRef);
    (0, $5uXOq.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $42c35fc284860d36$var$wrapperStyles,
        testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
        id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : 'menu',
        ref: ref,
        "aria-label": formatMessage((0, $zfug2.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $42c35fc284860d36$var$wrapperStyles = (0, $8CUq3.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("zfug2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2745ea1cb0c1a200$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("6LGvc", function(module, exports) {

$parcel$export(module.exports, "useSmoothExpand", () => $38452c6bcba6455a$export$674ba8b02d2bfe86);

var $5uXOq = parcelRequire("5uXOq");
const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
    const callback = (0, $5uXOq.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("4nfzy", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $53a0c321a39d3b85$export$223f3c3c93a14a83);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("eKTyH", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $9e51067b4d29f53f$export$3ef5d254c3c573e3);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $haBRL = parcelRequire("haBRL");
const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $gM5ou.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haBRL.CommandRow), rowProps);
};

});
parcelRegister("haBRL", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $04586313afa284d7$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $dzeHJ = parcelRequire("dzeHJ");


var $3m7XM = parcelRequire("3m7XM");

var $3sBlN = parcelRequire("3sBlN");
const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
        "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
        "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $04586313afa284d7$var$iconStyles,
            isActive && $04586313afa284d7$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
        "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.OutlinedLozenge), {
        "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3m7XM.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sBlN.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainerInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandIconsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$iconStyles = (0, $8CUq3.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $04586313afa284d7$var$iconActiveStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("3m7XM", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $c1bc24527d77cdc3$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hWZau = parcelRequire("hWZau");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $gGkxR = parcelRequire("gGkxR");

const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $5uXOq.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGkxR.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            justifyContent: "center",
            xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            color: "currentColor",
            label: "separator"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            color: "currentColor",
            label: "separator"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1bc24527d77cdc3$var$CommandNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16eko3h": (0, $lD23V.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !!__cmplp.isParent && "_syazeu41",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("gGkxR", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $e999625ec19f201d$export$4495aca3d261add0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k5uoT = parcelRequire("k5uoT");

var $jgJNO = parcelRequire("jgJNO");

var $jgArx = parcelRequire("jgArx");


var $k7xca = parcelRequire("k7xca");
const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $jgArx.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $k5uoT.layers).tooltip()
    });
const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $k7xca.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: containerRef,
        xcss: [
            $e999625ec19f201d$var$tooltipContainerStyles,
            !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $e999625ec19f201d$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $e999625ec19f201d$var$truncateTooltipStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("jgArx", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $3c6ba86682bb18eb$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $3c6ba86682bb18eb$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $3c6ba86682bb18eb$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $3c6ba86682bb18eb$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $3c6ba86682bb18eb$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $3c6ba86682bb18eb$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $6nFD4 = parcelRequire("6nFD4");
const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $3c6ba86682bb18eb$export$534fc570264a52a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $6nFD4.messages).tooltipTriggerAriaLabel)
    });
});
const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $btzsC.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8cae238d61c8405a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6nFD4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87d1d47436abe24f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87d1d47436abe24f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;

parcelRegister("k7xca", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $ad951546dfa9fa2c$export$94b118b3187f12c);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");
const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $gM5ou.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $5uXOq.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("3sBlN", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $a83ca30f957fd273$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s76W = parcelRequire("6s76W");

var $koVbs = parcelRequire("koVbs");

var $gM5ou = parcelRequire("gM5ou");


var $iLhkq = parcelRequire("iLhkq");

var $dSJBv = parcelRequire("dSJBv");

var $kbnU6 = parcelRequire("kbnU6");

var $lHtdH = parcelRequire("lHtdH");
const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const transitionStep = (0, $lHtdH.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, $gM5ou.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
        "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6s76W))), {
        spacing: "spacious",
        label: formatMessage((0, $iLhkq.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
        "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSJBv.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $a83ca30f957fd273$var$animationFadeIn = null;
const $a83ca30f957fd273$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$RightContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("iLhkq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf35cee6e1d1204b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("dSJBv", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $57e6d30b2626ce39$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $bcTvL = parcelRequire("bcTvL");

var $gM5ou = parcelRequire("gM5ou");

var $dzeHJ = parcelRequire("dzeHJ");


var $esPgL = parcelRequire("esPgL");
const $57e6d30b2626ce39$var$KeyElementNew = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297),
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.lozenge,
            isLongText && $57e6d30b2626ce39$var$styles.longLozenge
        ])
    }, shortcut));
};
const $57e6d30b2626ce39$var$KeyElementOld = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.FilledLozenge), {
        "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297)
    }, shortcut));
const $57e6d30b2626ce39$var$KeyElement = (0, $cSD7y.componentWithFG)('command-palette-display-shift-modifier-shortcut', $57e6d30b2626ce39$var$KeyElementNew, $57e6d30b2626ce39$var$KeyElementOld);
const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
        "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
    }, divisor);
const $57e6d30b2626ce39$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $57e6d30b2626ce39$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $57e6d30b2626ce39$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        (0, $4R6GH.fg)('command-palette-display-shift-modifier-shortcut') ? $57e6d30b2626ce39$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        }) : (acc.push({
            type: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        }), types.push((0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY));
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, $koVbs.default)();
const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, $gM5ou.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $esPgL.messages).shortcutThen;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR) return (0, $esPgL.messages).shortcutOr;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $esPgL.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
        switch(type){
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $esPgL.messages).divisorThen);
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $esPgL.messages).divisorOr);
            default:
                return formatMessage((0, $esPgL.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
        "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $57e6d30b2626ce39$export$cde89099db64abe3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $57e6d30b2626ce39$var$styles = {
    lozenge: "_2rkoglpi _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx3glpi _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("esPgL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f430d579edd6c91$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f430d579edd6c91$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("kbnU6", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $d865f5b0afeb3acd$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;

});

parcelRegister("lHtdH", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $9c0e762a7fdf0cdc$export$eefd045a02bab4c6);

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");

var $jcw0u = parcelRequire("jcw0u");

var $gM5ou = parcelRequire("gM5ou");

var $kbnU6 = parcelRequire("kbnU6");
const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, $kbnU6.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $5uXOq.useRef)(null);
    const isReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    const commandHasChildren = (0, $gM5ou.hasChildren)(command);
    (0, $5uXOq.useEffect)(()=>{
        setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
        switch(transitionStep){
            case (0, $kbnU6.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $kbnU6.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).FINISHED, (0, $kbnU6.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).INITIAL, (0, $kbnU6.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $jcw0u.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("5aF2z", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $7ecce3582144481d$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $7ecce3582144481d$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $7ecce3582144481d$export$a6d65a8fb7b912d6);
const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $7ecce3582144481d$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("64ZBB", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $6b9215d3fa38a855$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $6b9215d3fa38a855$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $6b9215d3fa38a855$export$6be8a7238febd54f);

var $gM5ou = parcelRequire("gM5ou");

var $5aF2z = parcelRequire("5aF2z");
const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $5aF2z.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("dE25F", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $842574a5e4b1a419$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
        "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $842574a5e4b1a419$var$ModalFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("d4iCz", function(module, exports) {

$parcel$export(module.exports, "Header", () => $82822f3e363fec07$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $82822f3e363fec07$var$headerStyles,
        testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
    }, children);
const $82822f3e363fec07$var$headerStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("2w83X", function(module, exports) {

$parcel$export(module.exports, "IssueTag", () => $2ba2b027b9044740$export$a342a0ad2c552031);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $eMpK2 = parcelRequire("eMpK2");

var $jIHzq = parcelRequire("jIHzq");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $7wNl6 = parcelRequire("7wNl6");

var $80wkc = parcelRequire("80wkc");
const $2ba2b027b9044740$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issueId = (0, $4R6GH.fg)('relay-migration-issue-fields-summary') ? (0, $2gCtH.useIssueId)() : undefined;
    const [{ value: summary }] = (0, $80wkc.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const [{ value: issueType }] = (0, $7wNl6.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $2ba2b027b9044740$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $2ba2b027b9044740$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMpK2.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jIHzq.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $2ba2b027b9044740$var$issueTagContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    minWidth: '0'
});
const $2ba2b027b9044740$var$issueTagStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1
});

});
parcelRegister("eMpK2", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $f381ae85157eafc9$export$b1b562672a76ad84);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dXXlv = parcelRequire("dXXlv");
const $f381ae85157eafc9$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXXlv.messages).issueIconAltTextIssueTermRefresh : (0, $dXXlv.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("dXXlv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $91c46772185cf0df$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $91c46772185cf0df$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    },
    issueIconAltTextIssueTermRefresh: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh",
        "defaultMessage": "Icon for the work type {issueTypeName}"
    }
});

});


parcelRegister("jIHzq", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $386c5138d16516b4$export$b2323503daaefa);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $jgArx = parcelRequire("jgArx");


var $k7xca = parcelRequire("k7xca");
const $386c5138d16516b4$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
const $386c5138d16516b4$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $386c5138d16516b4$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $k7xca.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $jgArx.TooltipComponent),
        position: "bottom-end",
        delay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("7wNl6", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeField", () => $6016ffb039edefae$export$3da96c4009e089ca);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $6016ffb039edefae$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, $5fc53.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lQE94", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $c31e2d123e024ddc$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $c31e2d123e024ddc$export$343e962d356c0af1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3BIWb = parcelRequire("3BIWb");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $2gCtH = parcelRequire("2gCtH");

var $afs7f = parcelRequire("afs7f");

var $15WDX = parcelRequire("15WDX");

var $biQrn = parcelRequire("biQrn");

var $8zOmE = parcelRequire("8zOmE");

var $3fAi8 = parcelRequire("3fAi8");

var $99cgx = parcelRequire("99cgx");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, $99cgx.defaultSaveField), saveFieldById: saveFieldById = (0, $99cgx.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $99cgx.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $99cgx.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $biQrn.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $d6AeP.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
            if (!isValidationError) (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
            });
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $2gCtH.useIssueId)();
    const contextualIssueKey = (0, $2gCtH.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, (0, $d6AeP.getIsEditFromIssueView)(event)) : meta);
        if (!shouldPreventIssueViewSoftRefresh && !(0, $d6AeP.getIsEditFromIssueView)(event)) try {
            const reason = (0, $afs7f.Reason).SoftRefresh;
            await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("3BIWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65e83eb4ced9ce9$export$2e2bcd8739ae039);
const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
    removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
    refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
};

});

parcelRegister("d6AeP", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $843704b157f0fa59$export$8846558eb0b5fa3);

var $hBuqR = parcelRequire("hBuqR");

var $lhVtI = parcelRequire("lhVtI");
const $843704b157f0fa59$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $lhVtI.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hBuqR.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("afs7f", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $90b3aba4b3cc23bb$export$fe867595c4640fb1);
const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("15WDX", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $947bdf396d8056bc$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $947bdf396d8056bc$export$f9eb49cc2f0e28ce);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5YMLs = parcelRequire("5YMLs");

var $3z81P = parcelRequire("3z81P");
const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $947bdf396d8056bc$var$actions = {
    fieldChanged: $947bdf396d8056bc$var$fieldChanged,
    fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
    fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
    registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
};
// this is a global state
const $947bdf396d8056bc$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $947bdf396d8056bc$var$actions
});
const $947bdf396d8056bc$export$444af741f6d8f512 = (0, $3sQ5x.createHook)($947bdf396d8056bc$var$store, {
    selector: null
});
const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, $gg7kZ.createContainer)($947bdf396d8056bc$var$store);

});
parcelRegister("5YMLs", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $1da8cbd2b672325c$export$d951e3c38e10736d);

var $bMD69 = parcelRequire("bMD69");

var $5fc53 = parcelRequire("5fc53");

var $1pF6B = parcelRequire("1pF6B");

var $lTnWS = parcelRequire("lTnWS");
const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $5fc53.RADIO_GQL_FIELD:
        case 0, $5fc53.TEAM_VIEW_GQL_FIELD:
        case 0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PEOPLE_GQL_FIELD:
        case 0, $5fc53.SECURITY_GQL_FIELD:
        case 0, $5fc53.NUMBER_GQL_FIELD:
        case 0, $5fc53.TEXT_GQL_FIELD:
        case 0, $5fc53.USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PRIORITY_GQL_FIELD:
        case 0, $5fc53.URL_GQL_FIELD:
        case 0, $5fc53.DATE_PICKER_GQL_FIELD:
        case 0, $5fc53.PROJECT_GQL_FIELD:
        case 0, $5fc53.DATE_TIME_GQL_FIELD:
        case 0, $5fc53.COLOR_GQL_FIELD:
        case 0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $5fc53.ISSUE_TYPE_GQL_FIELD:
        case 0, $5fc53.VOTES_GQL_FIELD:
        case 0, $5fc53.WATCHES_GQL_FIELD:
        case 0, $5fc53.RESOLUTION_GQL_FIELD:
        case 0, $5fc53.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $5fc53.RICH_TEXT_GQL_FIELD:
            return (0, $lTnWS.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $5fc53.PARENT_GQL_FIELD:
            return (0, $1pF6B.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $5fc53.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $5fc53.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $5fc53.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $5fc53.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                components: fieldValue.components,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $5fc53.TEXT_GQL_FIELD)]: 'text',
        [(0, $5fc53.NUMBER_GQL_FIELD)]: 'number',
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $5fc53.PROJECT_GQL_FIELD)]: 'project',
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.URL_GQL_FIELD)]: 'uri',
        [(0, $5fc53.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $5fc53.VOTES_GQL_FIELD)]: 'vote',
        [(0, $5fc53.COLOR_GQL_FIELD)]: 'color',
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $5fc53.STATUS_GQL_FIELD)]: 'status',
        [(0, $5fc53.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("bMD69", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $af5e8bab0defb9c8$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $af5e8bab0defb9c8$export$ba106ff8c087e6b1);

var $8QpSo = parcelRequire("8QpSo");

var $5fc53 = parcelRequire("5fc53");

var $9bgym = parcelRequire("9bgym");

var $6iJEF = parcelRequire("6iJEF");

var $9UrtF = parcelRequire("9UrtF");

var $hsEaK = parcelRequire("hsEaK");

var $2qu1N = parcelRequire("2qu1N");

var $16Zia = parcelRequire("16Zia");

var $iv8Rf = parcelRequire("iv8Rf");

var $hDlc2 = parcelRequire("hDlc2");

var $c3LW9 = parcelRequire("c3LW9");

var $h92P3 = parcelRequire("h92P3");

var $aeO9V = parcelRequire("aeO9V");

var $6Tnq8 = parcelRequire("6Tnq8");

var $6mbsj = parcelRequire("6mbsj");

var $d3nG3 = parcelRequire("d3nG3");

var $1xW6n = parcelRequire("1xW6n");

var $fW9XR = parcelRequire("fW9XR");

var $bKMMB = parcelRequire("bKMMB");

var $7JL37 = parcelRequire("7JL37");

var $dulCG = parcelRequire("dulCG");

var $6vno6 = parcelRequire("6vno6");

var $as0vY = parcelRequire("as0vY");

var $6dPLd = parcelRequire("6dPLd");

var $gKccZ = parcelRequire("gKccZ");

var $jnUrZ = parcelRequire("jnUrZ");

var $iJtmd = parcelRequire("iJtmd");

var $iPyq0 = parcelRequire("iPyq0");

var $384lj = parcelRequire("384lj");

var $axTS6 = parcelRequire("axTS6");

var $lfJ6H = parcelRequire("lfJ6H");

var $9UXU7 = parcelRequire("9UXU7");

var $b6BoU = parcelRequire("b6BoU");

var $gak3n = parcelRequire("gak3n");

var $i47fO = parcelRequire("i47fO");

var $gvljZ = parcelRequire("gvljZ");

var $6XFn2 = parcelRequire("6XFn2");

var $6e1Ya = parcelRequire("6e1Ya");

var $640u2 = parcelRequire("640u2");

var $hBEiJ = parcelRequire("hBEiJ");

var $1XNj2 = parcelRequire("1XNj2");

var $f6zXW = parcelRequire("f6zXW");

var $fB4wX = parcelRequire("fB4wX");

var $cXBkk = parcelRequire("cXBkk");

var $iDKu3 = parcelRequire("iDKu3");

var $aGv90 = parcelRequire("aGv90");

var $19DRh = parcelRequire("19DRh");

var $lkW3a = parcelRequire("lkW3a");

var $lQAwK = parcelRequire("lQAwK");

var $8qOI6 = parcelRequire("8qOI6");

var $cbd7V = parcelRequire("cbd7V");

var $6hj44 = parcelRequire("6hj44");

var $4nh4C = parcelRequire("4nh4C");

var $hA3EZ = parcelRequire("hA3EZ");

var $2z4xE = parcelRequire("2z4xE");

var $cO2KQ = parcelRequire("cO2KQ");

var $5sETx = parcelRequire("5sETx");

var $f454b = parcelRequire("f454b");

var $aafIf = parcelRequire("aafIf");

var $2yWre = parcelRequire("2yWre");

var $lUeQj = parcelRequire("lUeQj");

var $6SWOK = parcelRequire("6SWOK");

var $cMc7B = parcelRequire("cMc7B");

var $38GNL = parcelRequire("38GNL");

var $avV20 = parcelRequire("avV20");

var $cbXvu = parcelRequire("cbXvu");

var $aSXJi = parcelRequire("aSXJi");

var $8uxcU = parcelRequire("8uxcU");

var $arKlm = parcelRequire("arKlm");

var $hCKV6 = parcelRequire("hCKV6");

var $d8wC0 = parcelRequire("d8wC0");
// We're memoising this just in case we FF another field
const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
        [(0, $5fc53.AFFECTED_SERVICES_GQL_FIELD)]: (0, $9bgym.transformAggAffectedServicesToLegacyField),
        [(0, $5fc53.BOOLEAN_GQL_FIELD)]: (0, $9UrtF.transformAggBooleanToLegacyField),
        [(0, $5fc53.CASCADING_SELECT_GQL_FIELD)]: (0, $hsEaK.transformAggCascadingSelectToLegacyField),
        [(0, $5fc53.CHECKBOX_GQL_FIELD)]: (0, $2qu1N.transformAggCheckboxToLegacyField),
        [(0, $5fc53.CMDB_GQL_FIELD)]: (0, $16Zia.transformAggCMDBToLegacyField),
        [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (0, $19DRh.transformAggMultipleSelectToLegacyField),
        [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (0, $hDlc2.transformAggComponentsToLegacyField),
        [(0, $5fc53.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $c3LW9.transformAggConnectDateTimeToLegacyField),
        [(0, $5fc53.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $h92P3.transformAggConnectMultipleSelectToLegacyField),
        [(0, $5fc53.CONNECT_NUMBER_GQL_FIELD)]: (0, $aeO9V.transformAggConnectNumberToLegacyField),
        [(0, $5fc53.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $6Tnq8.transformAggConnectRichTextToLegacyField),
        [(0, $5fc53.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $6mbsj.transformAggConnectSingleSelectToLegacyField),
        [(0, $5fc53.CONNECT_TEXT_GQL_FIELD)]: (0, $d3nG3.transformAggConnectTextToLegacyField),
        [(0, $5fc53.COLOR_GQL_FIELD)]: (0, $iv8Rf.transformAggColorToLegacyField),
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (0, $fW9XR.transformAggDatePickerToLegacyField),
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (0, $bKMMB.transformAggDateTimePickerToLegacyField),
        [(0, $5fc53.EPIC_LINK_GQL_FIELD)]: (0, $7JL37.transformAggEpicLinkToLegacyField),
        [(0, $5fc53.FLAG_GQL_FIELD)]: (0, $dulCG.transformAggFlagToLegacyField),
        [(0, $5fc53.FORGE_DATETIME_GQL_FIELD)]: (0, $as0vY.transformAggForgeDateTimeToLegacyField),
        [(0, $5fc53.FORGE_DATE_GQL_FIELD)]: (0, $6vno6.transformAggForgeDateToLegacyField),
        [(0, $5fc53.FORGE_GROUP_GQL_FIELD)]: (0, $6dPLd.transformAggForgeGroupToLegacyField),
        [(0, $5fc53.FORGE_GROUPS_GQL_FIELD)]: (0, $gKccZ.transformAggForgeGroupsToLegacyField),
        [(0, $5fc53.FORGE_NUMBER_GQL_FIELD)]: (0, $jnUrZ.transformAggForgeNumberToLegacyField),
        [(0, $5fc53.FORGE_OBJECT_GQL_FIELD)]: (0, $iJtmd.transformAggForgeObjectToLegacyField),
        [(0, $5fc53.FORGE_STRING_GQL_FIELD)]: (0, $iPyq0.transformAggForgeStringToLegacyField),
        [(0, $5fc53.FORGE_STRINGS_GQL_FIELD)]: (0, $384lj.transformAggForgeStringsToLegacyField),
        [(0, $5fc53.FORGE_USER_GQL_FIELD)]: (0, $axTS6.transformAggForgeUserToLegacyField),
        [(0, $5fc53.FORGE_USERS_GQL_FIELD)]: (0, $lfJ6H.transformAggForgeUsersToLegacyField),
        [(0, $5fc53.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $b6BoU.transformAggIssueRestrictionToLegacyField),
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (0, $gak3n.transformAggIssueTypeToLegacyField),
        [(0, $5fc53.JSM_APPROVAL_GQL_FIELD)]: (0, $i47fO.transformAggJSMApprovalsToLegacyField),
        [(0, $5fc53.JSM_ASSETS_GQL_FIELD)]: (0, $6iJEF.transformAggAssetToLegacyField),
        [(0, $5fc53.JSM_MAJOR_INCIDENT_FIELD)]: (0, $6XFn2.transformAggJSMMajorIncidentToLegacyField),
        [(0, $5fc53.JSM_ORGANIZATION_GQL_FIELD)]: (0, $6e1Ya.transformAggJSMOrganizationToLegacyField),
        [(0, $5fc53.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $gvljZ.transformAggJSMEntitlementsToLegacyField),
        [(0, $5fc53.JSM_SENTIMENT_GQL_FIELD)]: (0, $cXBkk.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.JSM_PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $hBEiJ.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $5fc53.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $1XNj2.transformAggJSMRequestLanguageToLegacyField),
        [(0, $5fc53.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $f6zXW.transformAggJSMRequestTypeToLegacyField),
        [(0, $5fc53.JSM_RESPONDERS_GQL_FIELD)]: (0, $fB4wX.transformAggJSMRespondersToLegacyField),
        [(0, $5fc53.LABEL_GQL_FIELD)]: (0, $iDKu3.transformAggLabelsNodeToLegacyField),
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: (0, $6hj44.transformAggPriorityToLegacyField),
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $aGv90.transformAggMultiGroupPickerToLegacyField),
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.NUMBER_GQL_FIELD)]: (0, $8qOI6.transformAggNumberToLegacyField),
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $cbd7V.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.PROFORMA_FORMS_GQL_FIELD)]: (0, $4nh4C.transformAggProformaFormsToLegacyField),
        [(0, $5fc53.PROJECT_GQL_FIELD)]: (0, $hA3EZ.transformAggProjectToLegacyField),
        [(0, $5fc53.MULTI_VERSION_GQL_FIELD)]: (0, $lQAwK.transformAggMultipleVersionPickerToLegacyField),
        [(0, $5fc53.RADIO_GQL_FIELD)]: (0, $2z4xE.transformAggRadioSelectToLegacyField),
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: (0, $5sETx.transformAggRichTextToLegacyField),
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: (0, $cO2KQ.transformAggResolutionToLegacyField),
        [(0, $5fc53.SECURITY_GQL_FIELD)]: (0, $f454b.transformAggSecurityLevelToLegacyField),
        [(0, $5fc53.SPRINT_GQL_FIELD)]: (0, $38GNL.transformAggSprintToLegacyField),
        [(0, $5fc53.STATUS_GQL_FIELD)]: (0, $avV20.transformAggStatusToLegacyField),
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $aafIf.transformAggSingleGroupPickerToLegacyField),
        [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (0, $lUeQj.transformAggSingleSelectToLegacyField),
        [(0, $5fc53.TEAM_GQL_FIELD)]: (0, $cbXvu.transformAggTeamToLegacyField),
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: (0, $aSXJi.transformAggTeamViewToLegacyField),
        [(0, $5fc53.TEXT_GQL_FIELD)]: (0, $2yWre.transformAggSingleLineTextToLegacyField),
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: (0, $8uxcU.transformAggTimeTrackingToLegacyField),
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (0, $6SWOK.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $5fc53.URL_GQL_FIELD)]: (0, $arKlm.transformAggUrlToLegacyField),
        [(0, $5fc53.VERSION_GQL_FIELD)]: (0, $cMc7B.transformAggSingleVersionPickerToLegacyField),
        [(0, $5fc53.VOTES_GQL_FIELD)]: (0, $hCKV6.transformAggVotesToLegacyField),
        [(0, $5fc53.WATCHES_GQL_FIELD)]: (0, $d8wC0.transformAggWatchesToLegacyField),
        [(0, $5fc53.DATA_CLASSIFICATION_FIELD)]: (0, $1xW6n.transformAggDataClassificationToLegacyField),
        [(0, $5fc53.GOALS_GQL_FIELD)]: (0, $9UXU7.transformAggGoalsToLegacyField),
        [(0, $5fc53.JCS_ORGANIZATION_GQL_FIELD)]: (0, $640u2.transformAggJCSOrganizationToLegacyField)
    });
const $af5e8bab0defb9c8$var$getTransformers = (0, $8QpSo.default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, projectContext)=>{
    const typename = node.__typename;
    const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const projectContext = projectField != null ? projectField : (0, $hA3EZ.getProjectField)(fields)?.project;
            const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("9bgym", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $0bce5d1c363f27e8$export$231e0419515441d4);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("o7K5u", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $cfa10031dfb7ad46$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $cfa10031dfb7ad46$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $cfa10031dfb7ad46$export$b5de5f3d2de73afc);
const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("6iJEF", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b9f6b8590a60f3b3$export$2136dcd78a2ef18f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $5fc53.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("9UrtF", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $474331244347ccdb$export$4bd89b95f0d10de9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hsEaK", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $afb6a8576bf8d731$export$a8778af5ceb1017c);


var $o7K5u = parcelRequire("o7K5u");
const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2qu1N", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $3efe07b8b545ea99$export$baa5afdbd8fd12d3);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $o7K5u.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("16Zia", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $4d2c21f2e394ef74$export$93506453d9bb56ae);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $o7K5u.transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $o7K5u.transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $5fc53.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $5fc53.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iv8Rf", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $b83a62ddd17b4586$export$587c178f1b45e5e9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $5fc53.EPIC_COLOR_TYPE:
        case 0, $5fc53.COLOR_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hDlc2", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $315456e18e2330f5$export$97a9275777684b77);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $5fc53.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.components, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    const value = (0, $o7K5u.transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $5fc53.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("c3LW9", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $e80217ec1ee321d5$export$e6d015aa746cbdaf);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("h92P3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $1bb7cdf99e93ff64$export$edf5c98d20696686);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (0, $o7K5u.toLegacyConnectOption));
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("aeO9V", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $b8a5823753f7873f$export$4638a5dd3285d8f2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("6Tnq8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $f9558299012f1c2e$export$11063e1f9210f191);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f9558299012f1c2e$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $f9558299012f1c2e$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $5fc53.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("dMYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fed9edf4c76e19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");
const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;

});


parcelRegister("6mbsj", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $ceb0872dd5eafe49$export$e44db7cf61369a28);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $o7K5u.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d3nG3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $145b645a3d2e801e$export$dd05277f5aa90657);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("1xW6n", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $1a8d4561538d1d2b$export$b5edfdc89a7a2932);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $5fc53.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("fW9XR", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $c44a652aaa9bff90$export$3d6e51d37c0454a9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.DUE_DATE_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $5fc53.DATE_CF_TYPE:
        case 0, $5fc53.BASELINE_START_CF_TYPE:
        case 0, $5fc53.BASELINE_END_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("bKMMB", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $fb29b1af2f1467e0$export$3de22f1277f0c239);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $fb29b1af2f1467e0$var$defaultSchema = {
    type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.RESOLUTION_DATE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
        case 0, $5fc53.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $5fc53.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7JL37", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3279d658ea1a4982$export$1311f30c94840aa2);

var $7SCny = parcelRequire("7SCny");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $7SCny.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $5fc53.EPIC_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $5fc53.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dulCG", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $f31e97d89b497c1c$export$31555b6ea19f4c2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $5fc53.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6vno6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $f5e60b2709763004$export$30fccfce22948120);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("as0vY", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $3520698819975afe$export$61b1f0cbd04c7b9c);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("6dPLd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $ce6b58a5b1f45912$export$60b03d63015cbb9f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("gKccZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $256d8054300c3cdf$export$2dfa4944fba5d1f5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("jnUrZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $c68528ed0dfd109c$export$5dab8986dc45db07);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("iJtmd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $c814454c00552e79$export$fbdabdbae2a203b9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iPyq0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $29f719811f573640$export$3a581fb4b3e578bd);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("384lj", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $0d30cb879c19e1ba$export$418a06cb5dc6aba5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("axTS6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0669940239efeaff$export$bc73c7a747f907e5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("iob0v", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $42550039db1edc00$export$d7b231260a016eaf);

const $42550039db1edc00$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $145004f7a92e2423$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $145004f7a92e2423$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
        default:
            return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
    }
};
const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $42550039db1edc00$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lfJ6H", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9UXU7", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $a8d444f432651533$export$158301a02ae4cbe7);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $5fc53.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $5fc53.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("b6BoU", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $d0a0e03637cc83cd$export$62db794d5816e28e);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $5fc53.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $o7K5u.transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("gak3n", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $4f9b530de681b60e$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $4f9b530de681b60e$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $4f9b530de681b60e$export$de2eb3b47c7c887b);


var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4f9b530de681b60e$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $5fc53.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $5fc53.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $5fc53.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)} with ${(0, $5fc53.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
        ...$4f9b530de681b60e$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $imYFg.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $5fc53.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $5fc53.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.ISSUE_TYPE),
            type: (0, $5fc53.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("imYFg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $ccb1a8095461a82a$export$2fe6880f0073407c);

var $g4tDr = parcelRequire("g4tDr");
const $ccb1a8095461a82a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("i47fO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $448e6754d8bf50d1$export$b14d30f2a9e4c343);

var $9ar3z = parcelRequire("9ar3z");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $5fc53.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $g5X3G.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $5fc53.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $9ar3z.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $9ar3z.APPROVER_APPROVED:
            return 0, $9ar3z.APPROVER_APPROVED;
        case 0, $9ar3z.APPROVER_DECLINED:
            return 0, $9ar3z.APPROVER_DECLINED;
        case 0, $9ar3z.APPROVER_PENDING:
        default:
            return 0, $9ar3z.APPROVER_PENDING;
    }
};
const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $iob0v.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $o7K5u.transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $o7K5u.transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
        configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $o7K5u.transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
        excludedApprovers: (0, $o7K5u.transformAggConnection)(activeApproval.excludedApprovers, (0, $iob0v.transformJiraUserToLegacyServerUser)),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
    };
};
const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
        approvers: (0, $o7K5u.transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
    };
};
const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $o7K5u.transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("9ar3z", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $4a7fc5eda3865b0e$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $4a7fc5eda3865b0e$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $4a7fc5eda3865b0e$export$2e6187b6a4348938);
const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("gvljZ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $b281bef34e07e20f$export$850fadda8a5e6f27);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $5fc53.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ENTITLEMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6XFn2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $926c732f6621d9fd$export$d4e0b2288fb31144);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("6e1Ya", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $0e4eebb31cef7087$export$7bd14951253a7c5f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("640u2", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $84b085b51db539b3$export$81bfe5b16f9be413);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $84b085b51db539b3$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("hBEiJ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $841fa8e5b9308ced$export$c52c6988b335096);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("1XNj2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $1edf1c9b37cdb462$export$6a53240e225f742);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("f6zXW", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $8030de3237296d5c$export$5ffaab1383177efa);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $5fc53.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("fB4wX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $0ea07ade045943f7$export$5171c4d1ae5bcde5);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $5fc53.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $5fc53.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $5fc53.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $o7K5u.transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $5fc53.RESPONDERS_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("cXBkk", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $5dcf9f49c6a1536d$export$702d3754a4c7d90a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $5fc53.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SENTIMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iDKu3", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $5345161012c71e28$export$98e4f56e2e6c44fe);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5345161012c71e28$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $5fc53.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("aGv90", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $ee565846dd4aef42$export$f968da580693597d);


var $o7K5u = parcelRequire("o7K5u");
const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("19DRh", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $d83d25c034b1d99f$export$869fb8fbcb97e0ee);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lkW3a", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $9b1f1d40e628c968$export$cdd9991119eb040e);

var $2vSU6 = parcelRequire("2vSU6");


var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");

var $iob0v = parcelRequire("iob0v");
const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD) && (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg')) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $hA3EZ.getProjectType)(projectContext?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $5fc53.PARTICIPANTS_CF_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $5fc53.APPROVERS_LIST_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("hA3EZ", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $e3d5807b112803bd$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $e3d5807b112803bd$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $e3d5807b112803bd$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $e3d5807b112803bd$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $e3d5807b112803bd$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $e3d5807b112803bd$export$30c14b802399f417);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");



var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");
const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
    }
};
const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $2vSU6.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $e3d5807b112803bd$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $5fc53.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $5fc53.PROJECT_TYPE))?.node;
};
const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $e3d5807b112803bd$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $g5X3G.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $e3d5807b112803bd$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
    const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
    return $e3d5807b112803bd$export$77162d1422f22f47(project);
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.PROJECT_TYPE),
            custom: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        title: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $5fc53.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $5fc53.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $5fc53.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
    if ((0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("lQAwK", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $dc0acfee4cadcdcd$export$6207ea60703068d8);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $dc0acfee4cadcdcd$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && node.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $5fc53.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $o7K5u.transformAggConnection)(node.selectedVersionsConnection, (0, $149sa.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    custom: (0, $5fc53.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $5fc53.AFFECTS_VERSIONS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("149sa", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $4617842fe98d5759$export$becef8d087e8b62b);

var $jPhQo = parcelRequire("jPhQo");
const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $jPhQo.VersionStatus).ARCHIVED,
        released: version.status === (0, $jPhQo.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("jPhQo", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("8qOI6", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $b542e2b397d83c88$export$d754a24ed0096d2f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $5fc53.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.STORY_POINTS_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cbd7V", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $47597066e94f8347$export$f08d02fdc74f920e);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("6hj44", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $47c25f6616be0140$export$9e966ce605f800d2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $5fc53.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $5fc53.PRIORITY_TYPE),
            custom: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("4nh4C", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $27d464e5749e1114$export$fdcdbf17b0d4e36f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $5fc53.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $5fc53.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $5fc53.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("2z4xE", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $b545e68fef1c7c25$export$f147f1eb3a15ccfc);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("cO2KQ", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $b13d1a2c3ca9d3cb$export$179f600c7e1d0230);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $5fc53.RESOLUTION_TYPE)) return undefined;
    const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.RESOLUTION_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5sETx", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $181b5722dae42ee4$export$e65ff2ce94be106e);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $181b5722dae42ee4$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $5fc53.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $5fc53.DESCRIPTION_TYPE:
        case 0, $5fc53.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $5fc53.DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $181b5722dae42ee4$var$getPlainTextValue(node),
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $fCo6Y.removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
        value: null,
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
};

});

parcelRegister("f454b", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $811c3c0495fb451c$export$45e25e2a6750ea5a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $o7K5u.transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $5fc53.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("aafIf", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $950a9b8297396bb3$export$e6697ec5bdac9ec0);


var $o7K5u = parcelRequire("o7K5u");
const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2yWre", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $f5309f9bc8791ddf$export$31f32b3fd9e5ab6);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f5309f9bc8791ddf$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $5fc53.EPIC_NAME_TYPE:
        case 0, $5fc53.MESSAGE_EDIT_CF_TYPE:
        case 0, $5fc53.MESSAGE_VIEW_CF_TYPE:
        case 0, $5fc53.READ_ONLY_CF_TYPE:
        case 0, $5fc53.TEXT_CF_TYPE:
        case 0, $5fc53.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $5fc53.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $5fc53.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("lUeQj", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $9513f3f43c691d67$export$4e113f935e09d226);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $9513f3f43c691d67$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $5fc53.EPIC_STATUS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
            return $9513f3f43c691d67$var$getField(node);
        case 0, $5fc53.CATEGORY_TYPE:
            return $9513f3f43c691d67$var$getField(node, (0, $5fc53.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("6SWOK", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $7348765074cf60a5$export$7bf73fc06c6d71be);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cMc7B", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $1c34fc6a70d0e0b4$export$d03f622577260442);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $5fc53.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.singlePickerVersions, (0, $149sa.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $149sa.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $5fc53.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("38GNL", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $05e0b9d6b707c3a6$export$9b5bb05d50970021);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $5fc53.SPRINT_TYPE)) return undefined;
    const sprints = (0, $o7K5u.transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("avV20", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $e8b60f3bf3251c5a$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $e8b60f3bf3251c5a$export$c80e5acb1c882c48);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $5fc53.STATUS_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.STATUS_TYPE),
            custom: null,
            system: (0, $5fc53.STATUS_TYPE)
        }
    };
};

});

parcelRegister("cbXvu", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $2c8c4053c45e92fb$export$fb1b80497e96456f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $5fc53.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("aSXJi", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $b1861ddba2f2c1e6$export$6f6aaafb49bd4769);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("8uxcU", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $63b0d60fa2cc1a3e$export$874d9bd14269ec6f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $5fc53.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.TIME_TRACKING_TYPE),
            type: (0, $5fc53.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("arKlm", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $86ba2c1106803d01$export$6e950e0ec9801f6c);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $5fc53.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $5fc53.URL_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("hCKV6", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $78b4a5963398330d$export$8966614b8594736);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $5fc53.VOTES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.VOTES_TYPE),
            type: (0, $5fc53.VOTES_TYPE)
        }
    };
};

});

parcelRegister("d8wC0", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $a83bab4858993b2f$export$6730cb17d10d6156);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $5fc53.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.WATCHES_TYPE),
            type: (0, $5fc53.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("1pF6B", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $f8196a61a82995ed$export$d8a5feb2bb0425b4);
const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("lTnWS", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $51ceecc021979aad$export$b3a2c3992977726e);

var $kz2lw = parcelRequire("kz2lw");


var $fCo6Y = parcelRequire("fCo6Y");
const $51ceecc021979aad$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $fCo6Y.removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
};

});


parcelRegister("3z81P", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $c6ffe75554a4bac3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $c6ffe75554a4bac3$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGED]: $c6ffe75554a4bac3$var$FIELD_CHANGED
};

});


parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("99cgx", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $2a246664763defba$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $2a246664763defba$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $2a246664763defba$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $2a246664763defba$export$33b78476f5d734b3);

var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = (0, $4R6GH.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");

const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $gSA3s = parcelRequire("gSA3s");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $gSA3s.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $iXqE5.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $3sQ5x.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});



parcelRegister("80wkc", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $3937341f26b89a45$export$a01f0885983ceff0);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $lcPD8 = parcelRequire("lcPD8");
const $3937341f26b89a45$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
    const saveField = (0, $4R6GH.fg)('relay-migration-issue-fields-summary') ? (0, $lcPD8.useSaveSummaryField)(issueId) : undefined;
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        ...(0, $4R6GH.fg)('relay-migration-issue-fields-summary') && {
            saveField: saveField
        },
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lcPD8", function(module, exports) {

$parcel$export(module.exports, "useSaveSummaryField", () => $296ba0222c720503$export$2429979662d1fc23);

var $883fO = parcelRequire("883fO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lBwHJ = parcelRequire("lBwHJ");

var $jJZqs = parcelRequire("jJZqs");

var $koeKL = parcelRequire("koeKL");
const $296ba0222c720503$export$2429979662d1fc23 = (issueId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $883fO.default));
    return (0, $5uXOq.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: (0, $lBwHJ.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueId || '',
                            fieldId: fieldId
                        }).toString(),
                        operation: {
                            operation: 'SET',
                            text: newValue
                        }
                    }
                },
                onCompleted (response) {
                    if (response.jira?.updateSingleLineTextField) {
                        const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $jJZqs.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                    } else reject(new Error('Unknown error when mutating summary'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("883fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80cb93aeec4c927$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<502aa471f5d0893ece5715d9f8b2453a>>
 * @relayHash 96311ac8cd1b2e15ed7072740a91fd80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808
const $d80cb93aeec4c927$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditableInIssueView"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "text"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isRequired"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808",
            "metadata": {},
            "name": "useSaveSummaryFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d80cb93aeec4c927$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
var $d80cb93aeec4c927$export$2e2bcd8739ae039 = $d80cb93aeec4c927$var$node;

});

parcelRegister("lBwHJ", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $fba66c0f0a21639a$export$828c4931ae562af7);

var $gB07r = parcelRequire("gB07r");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issuefieldvalue/manifest.ts
var $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gB07r.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $gB07r.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $fba66c0f0a21639a$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("gB07r", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $c15031ac9edfd973$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $c15031ac9edfd973$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";

});






parcelRegister("fVMIs", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $05800ad334e2646e$export$c13b008422be19c7);

var $fIZf0 = parcelRequire("fIZf0");
const $05800ad334e2646e$export$c13b008422be19c7 = (0, $fIZf0.useSubscribeCommandsWithRegistry);

});

parcelRegister("c6XT1", function(module, exports) {

$parcel$export(module.exports, "useIssueAri", () => $be8be2fff6370f04$export$f56776f1b409b56d);

var $2gCtH = parcelRequire("2gCtH");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");
const $be8be2fff6370f04$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const issueId = (0, $2gCtH.useIssueId)();
    return (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

const $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("iokLh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7312d5cd39eb83d5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7312d5cd39eb83d5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    current: {
        "id": "issue-field-status.status-view.command-palette.current",
        "defaultMessage": "Current"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("99Vn3", function(module, exports) {

$parcel$export(module.exports, "useSaveStatusField", () => $6b5b0ceb4c7d618c$export$c6a3d42f97df89c9);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $jpZIw = parcelRequire("jpZIw");

var $dTUtq = parcelRequire("dTUtq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $luzUm = parcelRequire("luzUm");
const $6b5b0ceb4c7d618c$export$c6a3d42f97df89c9 = (issueKey, issueId, onUpdateStatusMutation)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $d8lE2.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $5uXOq.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $e9be48d6d2c01760$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        !(0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $luzUm.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                teamName: 'deliveroo'
            }
        });
        showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $luzUm.messages).errorFlagTitle),
            description: formatMessage((0, $luzUm.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $dTUtq.useShowFlag)();
    const saveStatusField = (0, $5uXOq.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>{
                    (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                    return onSaveSuccessfully(transition, callback);
                };
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                if (onUpdateStatusMutation && (0, $4R6GH.fg)('relay-migration-issue-fields-status')) await onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: transition.to
                });
                else await (0, $eusud.performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                onSaveSuccessfully(transition, callback);
                (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        onUpdateStatusMutation,
        openIssueTransitionModal,
        showIssueTransitionSuccessFlag
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
parcelRegister("dTUtq", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $4e3d7d0cd8105532$export$46b5557ad4264ef7);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $6OtcO = parcelRequire("6OtcO");
const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
        try {
            showFlag((0, $6OtcO.getTransitionSuccessFlag)(issueKey, status, formatMessage));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'showSuccessFlag',
                    packageName: 'jiraIssueTransitionUseShowFlag',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        formatMessage,
        showFlag
    ]);
    const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey, traceId)=>showFlag((0, $6OtcO.getTransitionFailureFlag)(issueKey, formatMessage, traceId)), [
        formatMessage,
        showFlag
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("6OtcO", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $12ec3642dfb43880$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $12ec3642dfb43880$export$d9438db72c9548f1);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");

var $4O0IR = parcelRequire("4O0IR");
const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    if (showLinkToIssue) return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $4O0IR.default).issueTransitionSuccessfulFlagDescription,
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessfulWithIssueKeyAndStatus`,
        messageType: 'transactional'
    };
    return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4O0IR.default).issueTransitionSuccessfulIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessful),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessful`,
        messageType: 'transactional'
    };
};
const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage, traceId)=>({
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionFailureWithKeyIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4O0IR.default).issueTransitionFailureIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailure),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID}.error`,
        messageType: 'transactional',
        ...traceId && (0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? {
            traceId: traceId,
            error: new Error('TransitionFailureFlag')
        } : {}
    });

});
parcelRegister("4O0IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d201576bd998790a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d201576bd998790a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Work item has been updated."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Work item could not be updated."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View"
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    }
});

});



const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';

parcelRegister("luzUm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd890bb183837c1d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bd890bb183837c1d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We're unable to edit status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("fBoWB", function(module, exports) {

$parcel$export(module.exports, "getTransitionKeywords", () => $b56280b3569df29a$export$258538e0d3d46460);
const $b56280b3569df29a$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("2NP8E", function(module, exports) {

$parcel$export(module.exports, "CreateStatusButton", () => $003c9066e5f3dd12$export$d2e0b4f33d77a2b8);
/* CreateStatusButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $gKECL = parcelRequire("gKECL");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $5BSCo = parcelRequire("5BSCo");

var $1xqgn = parcelRequire("1xqgn");

var $4zzYB = parcelRequire("4zzYB");
const $003c9066e5f3dd12$export$d2e0b4f33d77a2b8 = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], isPressable: isPressable = false, onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef = null, source: source })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)();
    const [inlineStatusConfigExp] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const handleClick = (0, $5uXOq.useCallback)((_e, analyticsEvent)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createStatusButton'); // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        (combinedInlineConfigurationExperiment.isEnabled || isInlineStatusExperimentEnabled) && _e.stopPropagation();
    }, [
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusExperimentEnabled,
        onClick
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    };
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $5BSCo.createStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated
    ]);
    const getClickElement = (ref)=>isPressable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            xcss: $003c9066e5f3dd12$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            ,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $4zzYB.messages).createStatus)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $003c9066e5f3dd12$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($003c9066e5f3dd12$var$StyledButton, {
            appearance: "subtle",
            shouldFitContainer: true,
            interactionName: "issue.fields.status.create-status.popup.open",
            onClick: handleClick,
            ref: ref
        }, formatMessage((0, $4zzYB.messages).createStatus)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>getClickElement(ref));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $003c9066e5f3dd12$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _y3gn1e5h _syaz1fxt _ca0q19bv _u5f3utpp _n3td19bv _19bvutpp _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $003c9066e5f3dd12$var$flexContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $003c9066e5f3dd12$var$pressableStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("gKECL", function(module, exports) {

$parcel$export(module.exports, "asyncInlineCreateStatusModal", () => $7044591110f97598$export$64a761d25b20910a);

var $8p8PB = parcelRequire("8p8PB");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7044591110f97598$export$64a761d25b20910a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eyXdl")), {
        moduleId: "4ce02bb0"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                inlineCreateStatusModal: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8p8PB.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        })
});

});
parcelRegister("8p8PB", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f21baf6b88fc48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1c9f0ca0f32a1a7d832e77365f43e75>>
 * @relayHash 0df4748cd7c393765978be5843c7a913
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b
const $32f21baf6b88fc48$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
        "metadata": {},
        "name": "srcAsyncInlineCreateStatusQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32f21baf6b88fc48$export$2e2bcd8739ae039 = $32f21baf6b88fc48$var$node;

});

parcelRegister("eyXdl", function(module, exports) {

let $a9a22c6136aaad9d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9a22c6136aaad9d$var$load("lG1hy").then(()=>parcelRequire('e1e78'));

});


parcelRegister("eSc2f", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $b84f9512c4920c38$export$14c11acc66fd51b3);
const $b84f9512c4920c38$export$14c11acc66fd51b3 = {
    width: 'small'
};

});

const $77f8834f432b7338$export$c766acff4513a976 = 'summaryView';
const $77f8834f432b7338$export$4edb790587638895 = 'listView';
const $77f8834f432b7338$export$7e2d75b13279a710 = 'listViewNoResults';
const $77f8834f432b7338$export$5e4b47163db377f = 'listViewGroupByStatus';
const $77f8834f432b7338$export$cafb161c2b21b455 = 'issueView';
const $77f8834f432b7338$export$66397ed56abea4ca = 'gicView';
const $77f8834f432b7338$export$46d07e67f98555aa = 'editStatusButton';
const $77f8834f432b7338$export$415149578ef78676 = 'deleteStatusButton';

parcelRegister("5BSCo", function(module, exports) {

$parcel$export(module.exports, "createStatusExperience", () => $eb41bcd877362d81$export$750cfa63c61c5008);
$parcel$export(module.exports, "editStatusExperience", () => $eb41bcd877362d81$export$1c3aa89ea6d8c93d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $eb41bcd877362d81$export$750cfa63c61c5008 = new (0, $duUGa.UFOExperience)('issue-view.create-status', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $eb41bcd877362d81$export$1c3aa89ea6d8c93d = new (0, $duUGa.UFOExperience)('issue-view.edit-status', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("4zzYB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $229b8164a902ee55$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $229b8164a902ee55$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    statusNameButtonLabel: {
        "id": "issue-field-status.status-view.transition.configure-status.status-name-button-label",
        "defaultMessage": "Edit {statusName} status"
    },
    editStatusTooltip: {
        "id": "issue-field-status.status-view.transition.configure-status.edit-status-tooltip",
        "defaultMessage": "Edit status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.configure-status.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.configure-status.edit-status",
        "defaultMessage": "Edit status"
    }
});

});


parcelRegister("k9YKz", function(module, exports) {

$parcel$export(module.exports, "EditStatusButtonOld", () => $857bcc21cac789c2$export$618af92aa265aa26);

var $5uXOq = parcelRequire("5uXOq");

var $4ChK1 = parcelRequire("4ChK1");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $857bcc21cac789c2$export$618af92aa265aa26 = ({ status: status, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onButtonClick = (event)=>{
        onClick();
        event.stopPropagation(); // prevents transition from being selected
    };
    const onCloseModal = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditStatusModal',
            action: 'closed'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onClickFireAnalytics = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton');
    };
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onCloseModal,
            status: status,
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            editStatusExperience: $5BSCo.editStatusExperience,
            statusNames: statusNames,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated
        }), [
        onCloseModal,
        status,
        issueTypeId,
        projectId,
        projectKey,
        statusNames,
        source,
        onStatusUpdated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            tabIndex: 0,
            xcss: $857bcc21cac789c2$var$iconButtonStyles,
            onClick: onButtonClick,
            "aria-label": formatMessage((0, $4zzYB.messages).statusNameButtonLabel, {
                statusName: status.statusName
            }),
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button",
            "data-show-on-hover": true,
            // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onKeyDown: (event)=>{
                event.stopPropagation();
                // Fire analytics when the button is accessed via keyboard
                if (event.code === 'Enter' || event.code === 'Space') onClickFireAnalytics();
            },
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onClickFireAnalytics();
            },
            onTouchStart: ()=>{
                // Touch interaction
                onClickFireAnalytics();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4zzYB.messages).editStatusTooltip),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-icon, #44546F)"
        }))));
};
const $857bcc21cac789c2$var$iconButtonStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    outlineOffset: 'space.0',
    padding: 'space.025',
    marginInline: 'space.100',
    opacity: 0,
    transition: 'opacity 0.3s ease',
    ':focus': {
        boxShadow: 'elevation.shadow.overflow',
        opacity: 1
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        opacity: 1
    }
});

});
parcelRegister("i7SlO", function(module, exports) {

$parcel$export(module.exports, "asyncInlineEditStatusModal", () => $bc5734c540f0c454$export$c3f451c40832a786);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $bc5734c540f0c454$export$c3f451c40832a786 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fiZgQ")).then((module)=>module.AsyncInlineEditStatusModal), {
        moduleId: "177d76fa",
        moduleName: "AsyncInlineEditStatusModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fiZgQ", function(module, exports) {

let $b248108548e4ae61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b248108548e4ae61$var$load("4rk4Z").then(()=>parcelRequire('5zJw9'));

});



parcelRegister("coyc6", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $75fbb15d605c0a9c$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $75fbb15d605c0a9c$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75fbb15d605c0a9c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        interactionName: "issue.fields.status.options.loading"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75fbb15d605c0a9c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("rNSQs", function(module, exports) {

$parcel$export(module.exports, "StatusButton", () => $acb4d573ba7a4450$export$517b7ecb2da8e76d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $9wjvq = parcelRequire("9wjvq");

var $2Z7Z6 = parcelRequire("2Z7Z6");
const $acb4d573ba7a4450$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return $acb4d573ba7a4450$var$ToDoButton;
        case 3:
            return 0, $2Z7Z6.DoneButton;
        case 4:
            return $acb4d573ba7a4450$var$InProgressButton;
        default:
            return $acb4d573ba7a4450$var$DefaultButton;
    }
};
const $acb4d573ba7a4450$var$buttonStyle = null;
const $acb4d573ba7a4450$var$buttonStyleRefresh = null;
const $acb4d573ba7a4450$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true } = props;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const Button = $acb4d573ba7a4450$var$getButton(status.statusCategory.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: targetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wjvq.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            label: ""
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // When the popup is open we don't want to track the click on this button as it solely closes
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        className: (0, $bwpsq.default)([
            "_12r21pd9",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_19bv12x7 _1n8wglyw _12r21wq8"
        ])
    }, status.name))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $acb4d573ba7a4450$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $acb4d573ba7a4450$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $acb4d573ba7a4450$var$InProgressButton = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $acb4d573ba7a4450$var$InProgressComponentVisualRefresh, $acb4d573ba7a4450$var$InProgressComponentCurrent);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $acb4d573ba7a4450$var$ToDoButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $acb4d573ba7a4450$var$DefaultButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9wjvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1216c2da1b38029$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");
// TODO consolidate status id's
const $b1216c2da1b38029$var$DONE_ID = 3;
class $b1216c2da1b38029$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $b1216c2da1b38029$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1216c2da1b38029$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            shouldShow: false
        };
    }
}
const $b1216c2da1b38029$var$PulseAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b1216c2da1b38029$var$PulseContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $lD23V.default)($b1216c2da1b38029$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _1bsb1osq _16qs1pcf",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2Z7Z6", function(module, exports) {

$parcel$export(module.exports, "DoneButton", () => $bb0c7ad61f4c3610$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $bb0c7ad61f4c3610$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$8c94aeefd701630d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh, $bb0c7ad61f4c3610$var$InProgressComponentCurrent);
const $bb0c7ad61f4c3610$export$5392037c0e6ad119 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1jjx _11a41jjx _dntb16l4 _cp4g16l4 _5xmd1jjx _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$5445f55445c67248 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1rwo _11a41rwo _dntb1gfe _cp4g1gfe _5xmd14kv _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$e6559310cd173125 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $bb0c7ad61f4c3610$export$5392037c0e6ad119, $bb0c7ad61f4c3610$export$5445f55445c67248);

});


parcelRegister("1khYv", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $548d8ec8e7bf977f$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5f2o3 = parcelRequire("5f2o3");

var $cPJPi = parcelRequire("cPJPi");
const $548d8ec8e7bf977f$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing, contentAfter: contentAfter, testId: testId })=>{
    if (transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$DisabledTransition, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPJPi.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        label: "",
        color: "var(--ds-text-disabled, #091E424F)",
        spacing: "spacious",
        testId: "issue-field-status.ui.status-view.transition.information-icon"
    }))));
    const transitionComponent = hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5f2o3.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPJPi.TransitionWithoutLabel), {
        transition: transition
    });
    return contentAfter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _wjvokb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $548d8ec8e7bf977f$var$transitionComponentStyles
    }, transitionComponent), contentAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId
    }, transitionComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $548d8ec8e7bf977f$var$DisabledTransition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $548d8ec8e7bf977f$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl _4t3io7ao _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $548d8ec8e7bf977f$export$7ed12d2a5241e393 = {
    IconWrapper: $548d8ec8e7bf977f$var$IconWrapper
};
const $548d8ec8e7bf977f$var$transitionWrapperStyles = null;
const $548d8ec8e7bf977f$var$transitionComponentStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("5f2o3", function(module, exports) {

$parcel$export(module.exports, "TransitionWithLabel", () => $ce0d296e0359021c$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGdV2 = parcelRequire("eGdV2");

var $kgoHi = parcelRequire("kgoHi");

var $aWse0 = parcelRequire("aWse0");

var $dCm1o = parcelRequire("dCm1o");

var $17mYr = parcelRequire("17mYr");

var $cnQeu = parcelRequire("cnQeu");
const $ce0d296e0359021c$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $cnQeu.default).globalTransition);
    }
    return transition.name;
};
const $ce0d296e0359021c$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $aWse0.useIntlV2)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$147422f7450ccfac, null, $ce0d296e0359021c$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$da4545fe0ca096cf, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
        label: "",
        LEGACY_size: "small",
        testId: "issue-field-status.ui.status-view.transition.with-label.arrow-right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$Wrapper, null, content);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce0d296e0359021c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ce0d296e0359021c$export$147422f7450ccfac = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $ce0d296e0359021c$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.visualRefresh && "_zulpu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ce0d296e0359021c$var$VerticalCenter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


parcelRegister("cnQeu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c9e2137350f319$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1c9e2137350f319$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});

});


parcelRegister("cPJPi", function(module, exports) {

$parcel$export(module.exports, "TransitionWithoutLabel", () => $35e7b9f215fedcad$export$4cf2c7e5a408120e);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $35e7b9f215fedcad$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});


parcelRegister("hOOVM", function(module, exports) {

$parcel$export(module.exports, "OptionWithInlineConfigButtons", () => $9d20033b25473294$export$eac5bb25b4a7c273);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4Gswu = parcelRequire("4Gswu");

var $85H79 = parcelRequire("85H79");

var $gULOk = parcelRequire("gULOk");

var $2KAtx = parcelRequire("2KAtx");

var $i7SlO = parcelRequire("i7SlO");


var $eSc2f = parcelRequire("eSc2f");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $9d20033b25473294$export$33a04d713b28e79b = ({ children: children, queryParams: queryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { status: status, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames, source: source, onClose: onClose, onStatusUpdated: onStatusUpdated } = queryParams;
    const onCloseEditModal = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditStatusModal',
            action: 'closed'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onCloseEditModal,
            status: {
                id: status.id,
                statusName: status.statusName,
                statusCategory: status.statusCategory
            },
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            editStatusExperience: $5BSCo.editStatusExperience,
            statusNames: statusNames,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated
        }), [
        onCloseEditModal,
        status.id,
        status.statusName,
        status.statusCategory,
        issueTypeId,
        projectId,
        projectKey,
        statusNames,
        source,
        onStatusUpdated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $9d20033b25473294$var$inlineButtonStyles,
            ref: ref,
            "aria-label": formatMessage((0, $4zzYB.messages).statusNameButtonLabel, {
                statusName: status.statusName
            }),
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button"
        }, children));
};
const $9d20033b25473294$export$eac5bb25b4a7c273 = ({ children: children, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames, showEditButton: showEditButton, menuListRef: menuListRef, source: source, onOpenEditModal: onOpenEditModal, onCloseEditModal: onCloseEditModal, onStatusUpdated: onStatusUpdated, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectOption = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Gswu.OptionWithAutoKeyboardScroll), {
        ...props,
        containerRef: menuListRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85H79.InlineConfigButtons), {
        editActionSubjectId: "editStatusButton",
        editLabelText: formatMessage((0, $4zzYB.messages).editStatusTooltip),
        isFocused: props.isFocused,
        showEditButton: Boolean(selectOption.transition && showEditButton),
        shouldStopPropagationOnClick: true,
        queryParams: {
            status: {
                id: selectOption.transition?.to?.id ?? '',
                statusName: selectOption.transition?.to?.name ?? '',
                statusCategory: (0, $gULOk.statusCategoryForId)(selectOption.transition?.to?.statusCategory?.id) ?? ''
            },
            projectId: projectId,
            projectKey: projectKey,
            issueTypeId: issueTypeId,
            statusNames: statusNames,
            source: source,
            onClose: onCloseEditModal,
            onStatusUpdated: onStatusUpdated
        },
        EditButtonWrapper: $9d20033b25473294$export$33a04d713b28e79b,
        onEditButtonClick: ()=>{
            onOpenEditModal();
        }
    }, children));
};
const $9d20033b25473294$var$inlineButtonStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.negative.025'
});

});
parcelRegister("85H79", function(module, exports) {

$parcel$export(module.exports, "InlineConfigButtons", () => $fbf710a2c1daee3e$export$8b527b0415fd6611);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $4IrpZ = parcelRequire("4IrpZ");

var $5nRKm = parcelRequire("5nRKm");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hnvSc = parcelRequire("hnvSc");
const $fbf710a2c1daee3e$export$8b527b0415fd6611 = ({ children: children, source: source, editActionSubjectId: editActionSubjectId, deleteActionSubjectId: deleteActionSubjectId, showEditButton: showEditButton, showDeleteButton: showDeleteButton, isFocused: isFocused, EditButtonWrapper: EditButtonWrapper, DeleteButtonWrapper: DeleteButtonWrapper, queryParams: queryParams, editLabelText: editLabelText, deleteLabelText: deleteLabelText, onEditButtonClick: onEditButtonClick, onDeleteButtonClick: onDeleteButtonClick, shouldStopPropagationOnClick: shouldStopPropagationOnClick = false, buttonRef: buttonRef = null })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onFireRequiredAnalyticsForEditButtonClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), editActionSubjectId ?? '', {
            source: source
        });
    };
    const onFireRequiredAnalyticsForDeleteButtonClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), deleteActionSubjectId ?? '', {
            source: source
        });
    };
    const handleOnEditButtonMouseDown = (e)=>{
        // fire event on left click only
        if (e.button === 0) onFireRequiredAnalyticsForEditButtonClick();
    };
    const handleOnDeleteButtonMouseDown = (e)=>{
        // fire event on left click only
        if (e.button === 0) onFireRequiredAnalyticsForDeleteButtonClick();
    };
    const handleOnEditButtonKeyDown = (e)=>{
        if (e.code === 'Enter' || e.code === 'Space') {
            // Always stop propagation when cleaning up inline_config_a11y_improvements
            shouldStopPropagationOnClick && e.stopPropagation();
            // Remove this line when cleaning up inline_config_a11y_improvements
            buttonRef?.current?.click();
            onFireRequiredAnalyticsForEditButtonClick();
        }
    };
    const handleOnDeleteButtonKeyDown = (e)=>{
        if (e.code === 'Enter' || e.code === 'Space') {
            shouldStopPropagationOnClick && e.stopPropagation();
            onFireRequiredAnalyticsForDeleteButtonClick();
        }
    };
    const handleOnEditButtonClick = (e)=>{
        shouldStopPropagationOnClick && e.stopPropagation();
        onEditButtonClick?.(e);
    };
    const handleOnDeleteButtonClick = (e)=>{
        shouldStopPropagationOnClick && e.stopPropagation();
        onDeleteButtonClick?.(e);
    };
    const renderEditButton = ()=>{
        const iconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            tabIndex: isFocused ? 0 : -1,
            isDisabled: !isFocused,
            appearance: "subtle",
            onClick: handleOnEditButtonClick,
            // onClick is not working well with Select component and ModalEntryPointPressableTrigger
            // Therefore, we need to handle event analytics using mouseDown, touchEnd and keyDown
            onMouseDown: handleOnEditButtonMouseDown,
            onTouchEnd: onFireRequiredAnalyticsForEditButtonClick,
            onKeyDown: handleOnEditButtonKeyDown,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
            label: editLabelText ?? formatMessage((0, $hnvSc.default).editButtonText),
            spacing: "compact"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $fbf710a2c1daee3e$var$additionalMarginStyles
        }, iconButton);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        columnGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $fbf710a2c1daee3e$var$leftColumnStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: isFocused ? $fbf710a2c1daee3e$var$rightColumnStyleVisible : $fbf710a2c1daee3e$var$rightColumnStyleHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        columnGap: "space.050"
    }, showEditButton && EditButtonWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditButtonWrapper, {
        queryParams: queryParams
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: editLabelText ?? formatMessage((0, $hnvSc.default).editButtonText)
    }, renderEditButton())), showDeleteButton && DeleteButtonWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DeleteButtonWrapper, {
        queryParams: queryParams
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: deleteLabelText ?? formatMessage((0, $hnvSc.default).deleteButtonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isDisabled: !isFocused,
        tabIndex: isFocused ? 0 : -1,
        appearance: "subtle",
        onClick: handleOnDeleteButtonClick,
        // onClick is not working well with Select component and ModalEntryPointPressableTrigger
        // Therefore, we need to handle event analytics using mouseDown, touchEnd and keyDown
        onMouseDown: handleOnDeleteButtonMouseDown,
        onTouchEnd: onFireRequiredAnalyticsForDeleteButtonClick,
        onKeyDown: handleOnDeleteButtonKeyDown,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
        label: deleteLabelText ?? formatMessage((0, $hnvSc.default).deleteButtonText)
    }))))));
};
const $fbf710a2c1daee3e$var$leftColumnStyle = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    flex: 1,
    alignItems: 'center'
});
const $fbf710a2c1daee3e$var$rightColumnStyleVisible = (0, $8CUq3.xcss)({
    width: 'auto',
    height: 'auto'
});
const $fbf710a2c1daee3e$var$rightColumnStyleHidden = (0, $8CUq3.xcss)({
    width: 'auto',
    height: 'auto',
    opacity: 0
});
const $fbf710a2c1daee3e$var$additionalMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.050'
});

});
parcelRegister("hnvSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ce9f37a75c1baa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35ce9f37a75c1baa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editButtonText: {
        "id": "inline-status-and-issue-types.inline-config-buttons-for-select.edit-button-text",
        "defaultMessage": "Edit"
    },
    deleteButtonText: {
        "id": "inline-status-and-issue-types.inline-config-buttons-for-select.delete-button-text",
        "defaultMessage": "Delete"
    }
});

});



parcelRegister("02biC", function(module, exports) {

$parcel$export(module.exports, "CreateStatusOption", () => $bf8aca9d99b3cd67$export$be2add8d223902cf);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gKECL = parcelRequire("gKECL");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $bf8aca9d99b3cd67$export$be2add8d223902cf = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef, source: source })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const handleClick = (0, $5uXOq.useCallback)((_e)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    };
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $5BSCo.createStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $bf8aca9d99b3cd67$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $4zzYB.messages).createStatus)));
};
const $bf8aca9d99b3cd67$var$optionStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});

parcelRegister("4hdrg", function(module, exports) {

$parcel$export(module.exports, "EditStatusOption", () => $012e5cd697234d7f$export$9550e3e17c5a4a3a);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $012e5cd697234d7f$export$9550e3e17c5a4a3a = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated, buttonRef: buttonRef, source: source })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((_e)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton');
    };
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $5BSCo.editStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $012e5cd697234d7f$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $4zzYB.messages).editStatus)));
};
const $012e5cd697234d7f$var$optionStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});

parcelRegister("5uNOo", function(module, exports) {

$parcel$export(module.exports, "EditStatusButton", () => $4d1ec0a4b4de57d9$export$bc1c056aa3d67f87);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $4d1ec0a4b4de57d9$export$bc1c056aa3d67f87 = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated, buttonRef: buttonRef, source: source })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((_e)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $5BSCo.editStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $4d1ec0a4b4de57d9$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button",
            xcss: $4d1ec0a4b4de57d9$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4d1ec0a4b4de57d9$var$textWrapperStyle
        }, formatMessage((0, $4zzYB.messages).editStatus)))));
};
const $4d1ec0a4b4de57d9$var$flexContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $4d1ec0a4b4de57d9$var$pressableStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    paddingInline: 'space.150',
    fontWeight: 'font.weight.medium',
    ':hover': {
        backgroundColor: 'color.background.neutral'
    },
    ':focus-visible': {
        borderRadius: 'border.radius'
    }
});
const $4d1ec0a4b4de57d9$var$textWrapperStyle = (0, $8CUq3.xcss)({
    marginInline: 'space.025'
});

});


const $16b9f6b2f8c4a675$export$c9f0eab6c600e941 = 'manageWorkflowButton';
const $16b9f6b2f8c4a675$export$74ba9d5182d4cdae = 'manageIssueTypesButton';

parcelRegister("c8Fpj", function(module, exports) {

$parcel$export(module.exports, "useOpenManageFieldTab", () => $b0c807adad42e405$export$98ede961f3b934c0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5rzqz = parcelRequire("5rzqz");

var $4fT7I = parcelRequire("4fT7I");
const $b0c807adad42e405$export$98ede961f3b934c0 = ({ source: source, url: url })=>{
    const [{ inProgressIssueID: inProgressIssueID }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { onModalClosed: onModalClosed } = (0, $4fT7I.useInProgressIssueActions)();
    const openManageWorkTypesTab = (0, $5uXOq.useCallback)(()=>{
        if (inProgressIssueID) {
            // This will help prevent GIC modal from triggering in new tab
            onModalClosed({
                inProgressIssueID: inProgressIssueID
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), source);
            globalThis.window?.open(url, '_blank');
        }
    }, [
        createAnalyticsEvent,
        inProgressIssueID,
        onModalClosed,
        source,
        url
    ]);
    return openManageWorkTypesTab;
};

});

parcelRegister("7UXKz", function(module, exports) {

$parcel$export(module.exports, "ManageFieldButton", () => $bdfd1b8a184f4bbf$export$6bde45967ca110d);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $c8Fpj = parcelRequire("c8Fpj");
const $bdfd1b8a184f4bbf$export$6bde45967ca110d = ({ url: url, label: label, source: source, isFooterOption: isFooterOption })=>{
    const openManageFieldTab = (0, $c8Fpj.useOpenManageFieldTab)({
        source: source,
        url: url
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: isFooterOption ? $bdfd1b8a184f4bbf$var$footerOptionStyles : $bdfd1b8a184f4bbf$var$buttonStyles,
        onClick: openManageFieldTab
    }, label);
    return isFooterOption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $bdfd1b8a184f4bbf$var$flexContainerStyles
    }, button);
};
const $bdfd1b8a184f4bbf$var$buttonStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium',
    padding: 'space.150',
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    }
});
const $bdfd1b8a184f4bbf$var$footerOptionStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium',
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle'
});
const $bdfd1b8a184f4bbf$var$flexContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});

});

parcelRegister("8umLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c153c4d673a3bed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8c153c4d673a3bed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statusFieldLabel: {
        "id": "issue-create.modal.create-form.status-field.status-field-label",
        "defaultMessage": "Status"
    },
    unavailableStatusText: {
        "id": "issue-create.modal.create-form.status-field.unavailable-status-text",
        "defaultMessage": "Your workflow doesn't allow issues to be created in this status"
    },
    helperText: {
        "id": "issue-create.modal.create-form.status-field.helper-text",
        "defaultMessage": "This is the initial status upon creation"
    },
    noEnabledTransitionsMessage: {
        "id": "issue-create.modal.create-form.status-field.no-enabled-transitions-message",
        "defaultMessage": "There are no statuses available for you to use"
    },
    warningIconLabel: {
        "id": "issue-create.modal.create-form.status-field.warning-icon-label",
        "defaultMessage": "Warning"
    },
    warningMessage: {
        "id": "issue-create.modal.create-form.status-field.warning-message",
        "defaultMessage": "This field isn\u2019t working right now. You can still create your issue and update the status later."
    },
    unavailableStatusTextIssueTermRefresh: {
        "id": "issue-create.modal.create-form.status-field.unavailable-status-text-issue-term-refresh",
        "defaultMessage": "Your workflow doesn't allow work items to be created in this status"
    },
    warningMessageIssueTermRefresh: {
        "id": "issue-create.modal.create-form.status-field.warning-message-issue-term-refresh",
        "defaultMessage": "This field isn\u2019t working right now. You can still create your work item and update the status later."
    },
    warningMessageIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.status-field.warning-message-issue-terminology-refresh-m4",
        "defaultMessage": "This field isn\u2019t working right now. You can still create the {issueType} and update the status later."
    },
    manageWorkflowFooter: {
        "id": "issue-create.modal.create-form.status-field.manage-workflow",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("aPuaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $80155aca30b752b4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $2vSU6 = parcelRequire("2vSU6");

var $gwIPs = parcelRequire("gwIPs");

var $kErdU = parcelRequire("kErdU");

var $gyeeU = parcelRequire("gyeeU");

var $5rzqz = parcelRequire("5rzqz");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bPtOr = parcelRequire("bPtOr");

var $koVbs = parcelRequire("koVbs");

var $7536w = parcelRequire("7536w");

var $bCATC = parcelRequire("bCATC");
var $bv5he = parcelRequire("bv5he");
var $dIjAl = parcelRequire("dIjAl");


var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $45Cy1 = parcelRequire("45Cy1");

var $9UhzQ = parcelRequire("9UhzQ");

var $9QJ7Z = parcelRequire("9QJ7Z");

var $5fc53 = parcelRequire("5fc53");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $lsFXb = parcelRequire("lsFXb");

var $2eeg1 = parcelRequire("2eeg1");

var $inLvb = parcelRequire("inLvb");


var $1Nspv = parcelRequire("1Nspv");

var $kHA0a = parcelRequire("kHA0a");

var $dNpFP = parcelRequire("dNpFP");

var $c8Fpj = parcelRequire("c8Fpj");



var $30fo0 = parcelRequire("30fo0");

var $5FQop = parcelRequire("5FQop");

var $iwPB7 = parcelRequire("iwPB7");

var $fjTud = parcelRequire("fjTud");

var $f1j0c = parcelRequire("f1j0c");
const $80155aca30b752b4$var$typePickerMargin = (0, $gwIPs.gridSize) * 2.25;
const $80155aca30b752b4$var$TypePicker = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onChange: onChange, onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated, issueTypes: issueTypes, requestTypes: requestTypes, value: selectedRequestOrIssueType, isDisabled: isDisabled = false, isMini: isMini, projectType: projectType = null, projectId: projectId, projectKey: projectKey, canConfigureIssueTypes: canConfigureIssueTypes = false } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const previousSelectedRequestOrIssueType = (0, $1XJ20.usePrevious)(selectedRequestOrIssueType);
    const selectRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // if the default selection has request type of "none"
        // then we will change it to select the first matching request type
        if (// we have request type data
        requestTypes && // previously data was loading
        previousSelectedRequestOrIssueType === null && // an issue type is selected
        // i.e. this is the default selection
        // and it has a "none" request type
        selectedRequestOrIssueType && selectedRequestOrIssueType.type === (0, $4cff3ad70ea80f75$export$ebb48b08205007c5)) {
            const firstMatchingRequestType = (0, $5FQop.getFirstMatchingRequestType)({
                issueType: selectedRequestOrIssueType,
                allRequestTypes: requestTypes
            });
            if (firstMatchingRequestType) {
                onChange(firstMatchingRequestType);
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect forceDefaultNotNone');
            }
        }
    }, [
        createAnalyticsEvent,
        onChange,
        previousSelectedRequestOrIssueType,
        requestTypes,
        selectedRequestOrIssueType
    ]);
    const getIssueTypeHelpText = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
            fieldHelpTextUrl: (0, $9f7a9355e2f380ff$export$4435027827ccff2d),
            fieldName: "Issue Type",
            onLinkClickEvent: (0, $dNpFP.openInNewTabLinkClickEventHandler),
            isMini: isMini
        }), [
        isMini
    ]); // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineIssueTypeConfigExp, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_create_issue_type_in_gic_view'); // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineCombinedImpactConfigExp, fireCombinedImpactExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment');
    const createIssueTypeModalRef = (0, $5uXOq.useRef)(null);
    const onPreloadCreateIssueTypeModal = ()=>{
        createIssueTypeModalRef.current?.preload();
    };
    const onLoadCreateIssueTypeModal = ()=>{
        createIssueTypeModalRef.current?.load();
    };
    const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $45Cy1.useFormContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (submitFieldwiseErrors?.issuetype) (0, $kHA0a.scrollToElement)((0, $9f7a9355e2f380ff$export$f1623876ce3d4391));
    }, [
        submitFieldwiseErrors?.issuetype
    ]);
    const isInlineIssueTypeConfigEnabled = inlineIssueTypeConfigExp.get('isInlineIssueTypeConfigEnabled', false);
    const isInlineCombinedImpactConfigEnabled = inlineCombinedImpactConfigExp.get('isEnabled', false);
    const refocusSelectField = isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FQop.useRefocusSelectField)(selectRef) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const openManageWorkTypesTab = isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $c8Fpj.useOpenManageFieldTab)({
        source: (0, $16b9f6b2f8c4a675$export$74ba9d5182d4cdae),
        url: (0, $7536w.getProjectSettingsIssueTypesUrl)({
            projectKey: projectKey,
            projectType: projectType ?? ''
        })
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const [, { closeIssueCreateModal: closeIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const fields = (0, $5uXOq.useMemo)(()=>{
        let fieldsNode;
        const projectTypeCheck = (0, $4R6GH.fg)('jcs_master_flag') ? projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) : projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        if (projectTypeCheck && requestTypes !== undefined) {
            // get the options for the 2 select fields
            const { issueTypeOptions: issueTypeOptions, requestTypeOptions: requestTypeOptions } = (0, $5FQop.getRequestAndIssueTypeOptionsGroup)(issueTypes, requestTypes, formatMessage); // extract the selected option for the 2 select fields from the aggregated value
            const { issueType: selectedIssueType, requestType: selectedRequestType } = (0, $5FQop.getIssueTypeAndRequestType)({
                allIssueTypes: issueTypeOptions,
                requestOrIssueType: selectedRequestOrIssueType,
                formatMessage: formatMessage
            }); // fire UI events when the selects are opened
            const onIssueTypeSelectOpen = ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect open');
            const onRequestTypeSelectOpen = ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect open'); // on issue type selection we want to pre-select a matching request type
            const onIssueTypeChange = (issueType)=>{
                if (issueType.value === selectedIssueType?.value) return;
                const firstMatchingRequestType = (0, $5FQop.getFirstMatchingRequestType)({
                    issueType: issueType,
                    allRequestTypes: requestTypes
                });
                onChange(firstMatchingRequestType || issueType);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect selected');
            }; // on request type selection we want to select the chosen request type,
            // or if 'none' is selected, we select the issue type
            const onRequestTypeChange = (requestTypeOrNone)=>{
                if (requestTypeOrNone.value === selectedRequestType?.value) return;
                let isNoneSelected = true;
                if (requestTypeOrNone.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)) {
                    onChange(requestTypeOrNone);
                    isNoneSelected = false;
                } else if (selectedIssueType !== null) onChange(selectedIssueType);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect selected', {
                    isNoneSelected: isNoneSelected
                });
            };
            const requestTypeHelpText = selectedRequestType && selectedRequestType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedRequestType.helpText : '';
            fieldsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
                width: isMini ? '100%' : undefined,
                marginTop: $80155aca30b752b4$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                name: "issue-type-picker",
                label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $30fo0.default).issueTypeFieldLabelIssueTermRefresh : (0, $30fo0.default).issueTypeFieldLabel),
                isRequired: true
            }, ({ fieldProps: { id: id, isRequired: isRequired } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                    inputId: id,
                    required: isRequired,
                    options: issueTypeOptions,
                    value: selectedIssueType,
                    onChange: onIssueTypeChange,
                    onMenuOpen: onIssueTypeSelectOpen,
                    isClearable: false,
                    formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
                    placeholder: "",
                    id: (0, $9f7a9355e2f380ff$export$f1623876ce3d4391),
                    isDisabled: isDisabled,
                    onKeyDown: (0, $kHA0a.preventEscKeyPropagationKeyPressHandler)
                }), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, submitFieldwiseErrors.issuetype)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
                width: "100%",
                marginTop: $80155aca30b752b4$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80155aca30b752b4$var$RequestTypeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                name: "request-type-picker",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80155aca30b752b4$var$RequestTypeFieldLabelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $30fo0.default).requestTypeFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80155aca30b752b4$var$RequiredIndicator, null, "*")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwPB7.WhatsThis), null))
            }, ({ fieldProps: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f1j0c.RequestTypeSelect), {
                    inputId: id,
                    options: requestTypeOptions,
                    value: selectedRequestType,
                    onChange: onRequestTypeChange,
                    onMenuOpen: onRequestTypeSelectOpen,
                    id: "issue-create.ui.modal.create-form.type-picker.request-type-select"
                }))), requestTypeHelpText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjTud.RequestTypeHelpText), {
                helpText: requestTypeHelpText
            })));
        } else {
            // there is no request type data, just show issue type select
            const label = (0, $5FQop.getFieldLabel)(Boolean(requestTypes?.length), formatMessage);
            const onIssueTypeChange = (selectedIssueType)=>{
                if (!selectedIssueType) return; // Button Manage issue type
                if ((isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled) && selectedIssueType.value === (0, $9f7a9355e2f380ff$export$108c7e65ed44598b)) {
                    openManageWorkTypesTab();
                    return;
                } // Button Create issue type
                const isCreateIssueTypeAction = selectedIssueType.type === (0, $9f7a9355e2f380ff$export$4b72a3b40a1adf13);
                if (createIssueTypeModalRef.current && isCreateIssueTypeAction) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button'
                    });
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssueTypeButton');
                    createIssueTypeModalRef.current.load();
                    return;
                }
                if (selectedIssueType.value === selectedRequestOrIssueType?.value || selectedIssueType.type === (0, $9f7a9355e2f380ff$export$4b72a3b40a1adf13)) return;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'option'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'issueType');
                onChange(selectedIssueType);
            };
            const Component = ({ areUiModificationsBusy: areUiModificationsBusy, allowedValues: allowedValues, isReadOnly: isReadOnly })=>{
                const { options: options, components: components, noOptionWrapperRef: noOptionWrapperRef } = isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
                (0, $5FQop.useCustomOptionsAndComponentsForInlineIssueTypes)({
                    options: allowedValues ?? [],
                    canConfigureIssueTypes: canConfigureIssueTypes,
                    projectId: projectId,
                    projectKey: projectKey,
                    onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal,
                    onLoadCreateIssueTypeModal: onLoadCreateIssueTypeModal,
                    onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
                    onEditModalClose: refocusSelectField
                }) : {
                    options: allowedValues,
                    components: undefined,
                    noOptionWrapperRef: undefined
                };
                const isFixingA11yForInlineButtons = (isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled) && (0, $4R6GH.fg)('inline_config_a11y_improvements');
                const SelectWrapper = isFixingA11yForInlineButtons ? (0, $gyeeU.AtlaskitSelectInlineTabActivator) : (0, $5uXOq.Fragment);
                const [inputValue, setInputValue] = (0, $5uXOq.useState)('');
                const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
                const handleIssueTypesDropdownOpen = ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect open');
                    if (canConfigureIssueTypes) {
                        fireExposure(); // NOTE: same FG in front of the following experiments, new activated tenants pass 100% for combined_adoption_configuration_experiment and fail 100% on the other...
                        fireCombinedImpactExposure();
                        (0, $6s1PB.expVal)('combined_adoption_configuration_experiment_aa', 'isEnabled', false);
                    }
                }; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const fieldId = document.activeElement?.id;
                (0, $5uXOq.useEffect)(()=>{
                    if (fieldId?.includes('type-picker') && (0, $4R6GH.fg)('fix-gryf-a11y-issues')) selectRef?.current?.focus();
                }, [
                    fieldId
                ]);
                const attributes = (0, $5uXOq.useMemo)(()=>({
                        projectId: projectId,
                        isMenuOpen: isMenuOpen,
                        fieldId: fieldId
                    }), [
                    fieldId,
                    isMenuOpen
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                    id: "withFormField",
                    packageName: "jiraIssueCreateModal",
                    sendToPrivacyUnsafeSplunk: true,
                    ...(0, $4R6GH.fg)('jira-issue-create-error-boundary-enabled') ? {
                        attributes: attributes
                    } : {}
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                    name: "type-picker",
                    label: label,
                    isRequired: true,
                    elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv5he.FieldBusyIndicator), {
                        fieldId: (0, $5fc53.ISSUE_TYPE)
                    }) : undefined
                }, ({ fieldProps: fieldProps })=>{
                    const renderFieldContent = ({ id: id, isRequired: isRequired // eslint-disable-next-line @typescript-eslint/no-explicit-any
                     })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectWrapper, {
                            setInputValue: setInputValue,
                            setIsMenuOpen: setIsMenuOpen,
                            inputValue: inputValue,
                            isMenuOpen: isMenuOpen
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                            ref: selectRef,
                            inputId: id,
                            menuIsOpen: isFixingA11yForInlineButtons ? isMenuOpen : undefined,
                            inputValue: isFixingA11yForInlineButtons ? inputValue : undefined,
                            required: isRequired,
                            options: options,
                            components: components,
                            onChange: onIssueTypeChange,
                            onMenuOpen: handleIssueTypesDropdownOpen,
                            value: selectedRequestOrIssueType,
                            isClearable: false,
                            formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
                            placeholder: "",
                            id: (0, $9f7a9355e2f380ff$export$f1623876ce3d4391),
                            isDisabled: !!(isDisabled || isReadOnly),
                            onKeyDown: (e)=>{
                                (0, $kHA0a.preventEscKeyPropagationKeyPressHandler)(e);
                            },
                            onInputChange: (value, { action: action })=>{
                                if (isFixingA11yForInlineButtons && // This is to prevent the search value to be cleared when tabbing to the Create Issue Type button in Empty no results state
                                (action !== 'input-blur' && action !== 'menu-close' || !noOptionWrapperRef?.current)) setInputValue(value);
                            }
                        })), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, submitFieldwiseErrors.issuetype));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                        id: "issueAdjustmentsFieldValueDecorator",
                        packageName: "jiraIssueCreateModal",
                        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null), renderFieldContent(fieldProps)),
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: (error)=>({
                                errorType: (0, $bPtOr.getErrorType)(error),
                                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                                fieldId: (0, $5fc53.ISSUE_TYPE),
                                fieldType: (0, $5fc53.ISSUE_TYPE)
                            })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eeg1.FieldValueDecoratorAsync), {
                        fieldId: (0, $5fc53.ISSUE_TYPE),
                        fieldType: (0, $5fc53.ISSUE_TYPE),
                        fieldProps: {
                            ...fieldProps,
                            value: selectedRequestOrIssueType
                        }
                    }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassInput), null, renderFieldContent(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        interceptedFieldProps)))));
                }), (isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled) && projectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inLvb.CreateIssueTypeModal), {
                    onIssueTypeCreated: onIssueTypeCreatedOrUpdated,
                    onOpenManageTypes: closeIssueCreateModal,
                    ufoExperience: (0, $1Nspv.CreateIssueTypeUFOExperience),
                    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    onClose: refocusSelectField,
                    ref: createIssueTypeModalRef,
                    source: (0, $f1340a435190eeda$export$66397ed56abea4ca),
                    projectKey: projectKey,
                    shouldFetchProjectData: true
                }));
            };
            const typePickerComponentProps = {
                fieldId: (0, $5fc53.ISSUE_TYPE),
                fieldName: label,
                fieldType: (0, $5fc53.ISSUE_TYPE),
                isRequired: true,
                gqlType: '',
                allowedValues: issueTypes
            };
            const setFieldValue = (_, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onIssueTypeChange(value);
            const getFormState = ()=>({
                    values: {
                        [typePickerComponentProps.fieldId]: selectedRequestOrIssueType
                    }
                });
            fieldsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9QJ7Z.FormApiProvider), {
                setFieldValue: setFieldValue,
                getFormState: getFormState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
                width: isMini ? '100%' : undefined,
                marginTop: $80155aca30b752b4$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                id: "globalIssueCreateIssueAdjustmentsAdapter",
                packageName: "issueCreateModal",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, typePickerComponentProps)),
                sendToPrivacyUnsafeSplunk: true,
                attributes: (error)=>({
                        errorType: (0, $bPtOr.getErrorType)(error),
                        viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                        fieldId: typePickerComponentProps.fieldId,
                        fieldType: typePickerComponentProps.fieldType
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lsFXb.FieldDecoratorAsync), {
                Component: Component,
                componentProps: typePickerComponentProps
            }))));
        }
        return fieldsNode;
    }, [
        projectType,
        requestTypes,
        issueTypes,
        formatMessage,
        selectedRequestOrIssueType,
        isMini,
        createAnalyticsEvent,
        onChange,
        isDisabled,
        getIssueTypeHelpText,
        submitFieldwiseErrors?.issuetype,
        isInlineIssueTypeConfigEnabled,
        isInlineCombinedImpactConfigEnabled,
        openManageWorkTypesTab,
        canConfigureIssueTypes,
        projectId,
        projectKey,
        onIssueTypeCreatedOrUpdated,
        refocusSelectField,
        closeIssueCreateModal,
        fireExposure,
        fireCombinedImpactExposure
    ]);
    return fields;
};
var $80155aca30b752b4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $80155aca30b752b4$var$TypePicker;
const $80155aca30b752b4$var$RequestTypeFieldWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "cz2iu2-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> label': {
            width: '100%'
        }
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80155aca30b752b4$var$RequiredIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80155aca30b752b4$var$RequestTypeFieldLabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _1bah1yb4 _1bsb1osq _4t3i1osq _19pk12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7536w", function(module, exports) {

$parcel$export(module.exports, "getProjectSettingsIssueTypesUrl", () => $8b25c8da4c79b9dd$export$e2e29d5bcfe97104);
const $8b25c8da4c79b9dd$export$e2e29d5bcfe97104 = ({ projectKey: projectKey, projectType: projectType })=>{
    switch(projectType?.toLowerCase()){
        case 'customer_service':
        case 'service_desk':
            return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/issuetypes`;
        default:
            return `/jira/software/projects/${projectKey}/settings/issuetypes`;
    }
};

});

parcelRegister("inLvb", function(module, exports) {

$parcel$export(module.exports, "CreateIssueTypeModal", () => $36cd0d4f72c9c140$export$dc9171633ab334ab);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2awBM = parcelRequire("2awBM");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");
const $36cd0d4f72c9c140$export$dc9171633ab334ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onIssueTypeCreated: onIssueTypeCreated = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpenManageTypes: onOpenManageTypes = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpen: onOpen, onClose: onClose, source: source, shouldFetchProjectData: shouldFetchProjectData = false, projectKey: projectKey, ufoExperience: ufoExperience }, ref)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2awBM.asyncCreateIssueTypeModalEntryPoint), {
        projectKey: projectKey,
        cloudId: cloudId,
        shouldFetchProjectData: shouldFetchProjectData
    });
    (0, $5uXOq.useImperativeHandle)(ref, ()=>({
            load: entryPointActions.load,
            preload: entryPointActions.preload
        }));
    const onCloseCreateIssueTypeModal = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineCreateIssueTypeModal',
            action: 'closed'
        }));
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onIssueTypeCreated: onIssueTypeCreated,
            issueTypesCountLimit: 30,
            onClose: onCloseCreateIssueTypeModal,
            onOpen: onOpen,
            onOpenManageTypes: onOpenManageTypes,
            source: source,
            ufoExperience: ufoExperience
        }), [
        onIssueTypeCreated,
        onCloseCreateIssueTypeModal,
        onOpen,
        onOpenManageTypes,
        source,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        runtimeProps: entryPointProps,
        id: "create-issue-type-modal"
    });
});

});
parcelRegister("2awBM", function(module, exports) {

$parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", () => $5d94d7bcabd38106$export$7f9428aac5b01dff);

var $ekCoo = parcelRequire("ekCoo");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5d94d7bcabd38106$export$7f9428aac5b01dff = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bFz6r")), {
        moduleId: "0ca2b96c"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, shouldFetchProjectData: shouldFetchProjectData })=>({
            queries: {
                createIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ekCoo.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        shouldFetchProjectData: shouldFetchProjectData
                    }
                }
            }
        })
});

});
parcelRegister("ekCoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1115b945d8dda421$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36277921a8012e0702a65f1227cbbd1b>>
 * @relayHash 4a7b622560b3b3e20bb696680e8560ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76
const $1115b945d8dda421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "shouldFetchProjectData"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_createIssueTypeFragmentRef"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        },
                                        {
                                            "condition": "shouldFetchProjectData",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_projectDataFragmentRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldFetchProjectData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "medium"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76",
            "metadata": {},
            "name": "srcAsyncCreateIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1115b945d8dda421$var$node.hash = "b50515a18d5488758aa762560868c40c";
var $1115b945d8dda421$export$2e2bcd8739ae039 = $1115b945d8dda421$var$node;

});

parcelRegister("bFz6r", function(module, exports) {

let $87eec0be4a0819f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $87eec0be4a0819f8$var$load("cM9em"),
    $87eec0be4a0819f8$var$load("fr9NE"),
    $87eec0be4a0819f8$var$load("hPzOn"),
    $87eec0be4a0819f8$var$load("h2MrD"),
    $87eec0be4a0819f8$var$load("bYT2S"),
    $87eec0be4a0819f8$var$load("4Apxb")
]).then(()=>parcelRequire('djJpq'));

});



const $f1340a435190eeda$export$c766acff4513a976 = 'summaryView';
const $f1340a435190eeda$export$4edb790587638895 = 'listView';
const $f1340a435190eeda$export$cafb161c2b21b455 = 'issueView';
const $f1340a435190eeda$export$66397ed56abea4ca = 'gicView';
const $f1340a435190eeda$export$a1077f863a923e94 = 'gicViewNoResults';
const $f1340a435190eeda$export$7f04bd1df3763938 = 'jswBoard';
const $f1340a435190eeda$export$bd8f63529bb9357f = 'jswBacklog';
const $f1340a435190eeda$export$57eacdfdee901d4c = 'jswTimeline';
const $f1340a435190eeda$export$8f4fd516b77f8d43 = 'unknown';
const $f1340a435190eeda$export$334975a13cb19c35 = 'editIssueTypeButton';
const $f1340a435190eeda$export$e970abb363c8ec67 = 'deleteIssueTypeButton';

const $9f7a9355e2f380ff$export$4435027827ccff2d = '/secure/ShowConstantsHelp.jspa?decorator=popup#IssueTypes';
const $9f7a9355e2f380ff$export$f1623876ce3d4391 = 'issue-create.ui.modal.create-form.type-picker.issue-type-select';
const $9f7a9355e2f380ff$export$4b72a3b40a1adf13 = 'CREATE_ISSUE_TYPE';
const $9f7a9355e2f380ff$export$108c7e65ed44598b = 'MANAGE_ISSUE_TYPE';
const $9f7a9355e2f380ff$export$34934e4a629b9612 = 500;

parcelRegister("30fo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b43b84b88f3b1f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $53b43b84b88f3b1f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTypeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    requestTypeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-field-label",
        "defaultMessage": "Request type"
    },
    typeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.type-field-label",
        "defaultMessage": "Type"
    },
    issueTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-group-label",
        "defaultMessage": "Issue types"
    },
    requestTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-group-label",
        "defaultMessage": "Request types"
    },
    unassignedRequestTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.unassigned-request-type-group-label",
        "defaultMessage": "Unassigned"
    },
    serviceRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.service-request-group-label",
        "defaultMessage": "Service requests"
    },
    incidentRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.incident-request-group-label",
        "defaultMessage": "Incidents"
    },
    postIncidentReviewRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.post-incident-review-request-group-label",
        "defaultMessage": "Post-incident reviews"
    },
    developerEscalationRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.developer-escalation-request-group-label",
        "defaultMessage": "Developer escalations"
    },
    problemRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.problem-request-group-label",
        "defaultMessage": "Problems"
    },
    changeRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.change-request-group-label",
        "defaultMessage": "Changes"
    },
    noRequestTypeLabel: {
        "id": "issue-create.modal.create-form.type-picker.no-request-type-label",
        "defaultMessage": "No request type"
    },
    issueTypeHelpText: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-help-text",
        "defaultMessage": "Learn more"
    },
    issueTypeFieldLabelIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-field-label-issue-term-refresh",
        "defaultMessage": "Work type"
    },
    issueTypeGroupLabelIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-group-label-issue-term-refresh",
        "defaultMessage": "Work types"
    },
    createIssueTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.create-issue-type-button-text",
        "defaultMessage": "Create issue type"
    },
    createWorkTypeButtonTextIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.create-issue-type-button-text-issue-term-refresh",
        "defaultMessage": "Create work type"
    },
    editWorkTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.edit-work-type-button-text",
        "defaultMessage": "Edit type"
    },
    manageWorkTypesButtonText: {
        "id": "issue-create.modal.create-form.type-picker.manage-work-types-button-text",
        "defaultMessage": "Manage"
    },
    noSearchResultsOldTerm: {
        "id": "issue-create.modal.create-form.type-picker.no-search-results-old-term",
        "defaultMessage": "It looks like we can't find any issue types that match. <button>Create issue type</button>"
    },
    noSearchResultsIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.no-search-results",
        "defaultMessage": "It looks like we can't find any work types that match. <button>Create work type</button>"
    }
});

});

parcelRegister("5FQop", function(module, exports) {

$parcel$export(module.exports, "getFieldLabel", () => $d340f5cdbd034415$export$da6819d9a95804cf);
$parcel$export(module.exports, "getRequestAndIssueTypeOptionsGroup", () => $d340f5cdbd034415$export$37e41f5d9a3e8f14);
$parcel$export(module.exports, "getIssueTypeAndRequestType", () => $d340f5cdbd034415$export$2f84784d8e92f69c);
$parcel$export(module.exports, "getFirstMatchingRequestType", () => $d340f5cdbd034415$export$f0a2ba1b9d3328b);
$parcel$export(module.exports, "useCustomOptionsAndComponentsForInlineIssueTypes", () => $d340f5cdbd034415$export$c46e96f371a21b8);
$parcel$export(module.exports, "useRefocusSelectField", () => $d340f5cdbd034415$export$edd8a0e9715caecc);

var $5uXOq = parcelRequire("5uXOq");

var $fn8B5 = parcelRequire("fn8B5");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");


var $4R6GH = parcelRequire("4R6GH");

var $1Nspv = parcelRequire("1Nspv");

var $85H79 = parcelRequire("85H79");

var $N7jPX = parcelRequire("N7jPX");


var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $3LKEA = parcelRequire("3LKEA");

var $fJ83Q = parcelRequire("fJ83Q");

var $4Gswu = parcelRequire("4Gswu");

var $k37tx = parcelRequire("k37tx");


var $30fo0 = parcelRequire("30fo0");

var $koEf8 = parcelRequire("koEf8");
const $d340f5cdbd034415$export$da6819d9a95804cf = (hasRequestTypes, formatMessage)=>hasRequestTypes ? formatMessage((0, $30fo0.default).typeFieldLabel) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $30fo0.default).issueTypeFieldLabelIssueTermRefresh : (0, $30fo0.default).issueTypeFieldLabel);
const $d340f5cdbd034415$export$8e45723e9c86b276 = (practice, formatMessage)=>{
    if (practice === (0, $4cff3ad70ea80f75$export$b92ccb6dc3cdb548)) return formatMessage((0, $30fo0.default).changeRequestGroupLabel);
    if (practice === (0, $4cff3ad70ea80f75$export$48c144830383423)) return formatMessage((0, $30fo0.default).incidentRequestGroupLabel);
    if (practice === (0, $4cff3ad70ea80f75$export$1ea6ead7bcee4494)) return formatMessage((0, $30fo0.default).problemRequestGroupLabel);
    if (practice === (0, $4cff3ad70ea80f75$export$3d1cda9bd50505e8)) return formatMessage((0, $30fo0.default).serviceRequestGroupLabel);
    if (practice === (0, $4cff3ad70ea80f75$export$a4a741b969f6509c)) return formatMessage((0, $30fo0.default).postIncidentReviewRequestGroupLabel);
    if (practice === (0, $4cff3ad70ea80f75$export$81e62964cc725098)) return formatMessage((0, $30fo0.default).developerEscalationRequestGroupLabel);
    if (practice === (0, $4cff3ad70ea80f75$export$c835df30ebbd529d)) return formatMessage((0, $30fo0.default).unassignedRequestTypeGroupLabel);
    return formatMessage((0, $30fo0.default).requestTypeGroupLabel);
};
const $d340f5cdbd034415$var$reorderRequestTypeGroups = (requestTypeGroupKeys)=>{
    // This is the order we have them for queues, request types and feature page
    const allPractices = [
        (0, $4cff3ad70ea80f75$export$3d1cda9bd50505e8),
        (0, $4cff3ad70ea80f75$export$48c144830383423),
        (0, $4cff3ad70ea80f75$export$1ea6ead7bcee4494),
        (0, $4cff3ad70ea80f75$export$b92ccb6dc3cdb548),
        (0, $4cff3ad70ea80f75$export$a4a741b969f6509c),
        (0, $4cff3ad70ea80f75$export$81e62964cc725098),
        (0, $4cff3ad70ea80f75$export$c835df30ebbd529d),
        (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)
    ];
    const groupKeySet = new Set(requestTypeGroupKeys);
    return allPractices.filter((practice)=>groupKeySet.has(practice));
};
const $d340f5cdbd034415$var$createNoneOption = (formatMessage)=>({
        label: formatMessage((0, $30fo0.default).noRequestTypeLabel),
        value: 'none',
        type: 'NONE'
    });
const $d340f5cdbd034415$export$37e41f5d9a3e8f14 = (issueTypes, requestTypes, formatMessage)=>{
    // @ts-expect-error(PARTIAL_RECORD) TS2322 | TS2322 - Type 'Dictionary<RequestType[]>' is not assignable to type 'Record<RequestTypePractices, RequestType[]>'. | Type 'Dictionary<RequestType[]>' is not assignable to type 'Record<RequestTypePractices, RequestType[]>'.
    const groupedRequestTypes = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(requestTypes, (o)=>o.practice);
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'RequestTypePractices[]'.
    const groupKeys = $d340f5cdbd034415$var$reorderRequestTypeGroups(Object.keys(groupedRequestTypes));
    const requestTypesOptions = groupKeys.map((practice)=>({
            label: $d340f5cdbd034415$export$8e45723e9c86b276(practice, formatMessage),
            options: groupedRequestTypes[practice]
        }));
    return {
        issueTypeOptions: issueTypes,
        requestTypeOptions: [
            $d340f5cdbd034415$var$createNoneOption(formatMessage),
            ...requestTypesOptions
        ]
    };
};
const $d340f5cdbd034415$export$2f84784d8e92f69c = ({ requestOrIssueType: requestOrIssueType, allIssueTypes: allIssueTypes, formatMessage: formatMessage })=>{
    const noneOption = $d340f5cdbd034415$var$createNoneOption(formatMessage);
    let issueType = null;
    let requestType = null;
    if (requestOrIssueType !== null) switch(requestOrIssueType.type){
        case 0, $4cff3ad70ea80f75$export$ebb48b08205007c5:
            issueType = requestOrIssueType;
            requestType = noneOption;
            break;
        case 0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44:
            issueType = allIssueTypes.find(({ value: value })=>value === requestOrIssueType.issueTypeId) || null;
            requestType = requestOrIssueType;
            break;
        default:
    }
    return {
        issueType: issueType,
        requestType: requestType
    };
};
const $d340f5cdbd034415$export$f0a2ba1b9d3328b = ({ issueType: issueType, allRequestTypes: allRequestTypes })=>allRequestTypes.find(({ issueTypeId: issueTypeId })=>issueTypeId === issueType.value);
const $d340f5cdbd034415$export$b5c5ad2ef493d247 = (targetOptions)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createIssueOrWorkTypeMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $30fo0.default).createWorkTypeButtonTextIssueTermRefresh : (0, $30fo0.default).createIssueTypeButtonText;
    const footerOptions = (0, $5uXOq.useMemo)(()=>{
        return [
            {
                label: formatMessage(createIssueOrWorkTypeMessage),
                type: (0, $9f7a9355e2f380ff$export$4b72a3b40a1adf13),
                value: (0, $9f7a9355e2f380ff$export$4b72a3b40a1adf13)
            },
            {
                label: formatMessage((0, $30fo0.default).manageWorkTypesButtonText),
                type: (0, $9f7a9355e2f380ff$export$108c7e65ed44598b),
                value: (0, $9f7a9355e2f380ff$export$108c7e65ed44598b)
            }
        ];
    }, [
        formatMessage,
        createIssueOrWorkTypeMessage
    ]);
    return (0, $3LKEA.useAppendStickyFooterOptions)(targetOptions, footerOptions);
};
const $d340f5cdbd034415$export$3a85617ea18fdeb4 = ({ onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), ...queryParams })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useMemo)(()=>{
        const CustomOptionWithInlineConfigButtons = ({ children: children, ...props })=>{
            if ((0, $9f7a9355e2f380ff$export$4b72a3b40a1adf13) === props.data.type || (0, $9f7a9355e2f380ff$export$108c7e65ed44598b) === props.data.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), {
                testId: `issue-create.ui.modal.create-form.type-picker.option-with-button-${props.data.type}`,
                onHover: onPreloadCreateIssueTypeModal,
                ...props,
                innerProps: {
                    ...props.innerProps,
                    role: 'button'
                }
            }, children);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Gswu.OptionWithAutoKeyboardScroll), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85H79.InlineConfigButtons), {
                editActionSubjectId: (0, $f1340a435190eeda$export$334975a13cb19c35),
                editLabelText: formatMessage((0, $30fo0.default).editWorkTypeButtonText),
                isFocused: props.isFocused,
                showEditButton: true,
                shouldStopPropagationOnClick: (0, $4R6GH.fg)('inline_config_a11y_improvements'),
                queryParams: {
                    ...queryParams,
                    issueTypeId: String(props.data.value)
                },
                EditButtonWrapper: (0, $k37tx.EditIssueTypeModalEntrypointTrigger)
            }, children));
        };
        return CustomOptionWithInlineConfigButtons;
    }, [
        formatMessage,
        onPreloadCreateIssueTypeModal,
        queryParams
    ]);
};
const $d340f5cdbd034415$export$c46e96f371a21b8 = ({ options: options, projectId: projectId, projectKey: projectKey, canConfigureIssueTypes: canConfigureIssueTypes, onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onLoadCreateIssueTypeModal: onLoadCreateIssueTypeModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onEditModalClose: onEditModalClose })=>{
    const noOptionWrapperRef = (0, $5uXOq.useRef)(null);
    const CustomOptionWithInlineConfig = $d340f5cdbd034415$export$3a85617ea18fdeb4({
        projectId: Number(projectId),
        ufoExperience: (0, $1Nspv.EditIssueTypeUFOExperience),
        onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeCreatedOrUpdated,
        calledFrom: (0, $f1340a435190eeda$export$66397ed56abea4ca),
        onEditModalClose: onEditModalClose,
        projectKey: projectKey,
        onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal
    });
    const optionsWithActions = $d340f5cdbd034415$export$b5c5ad2ef493d247(options ?? []);
    if (!canConfigureIssueTypes) return {
        options: options,
        components: undefined
    };
    const NoOptionsMessage = ()=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            ref: noOptionWrapperRef,
            paddingInline: "space.150",
            paddingBlock: "space.050"
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $30fo0.default).noSearchResultsIssueTermRefresh : (0, $30fo0.default).noSearchResultsOldTerm, {
            button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koEf8.CreateWorkTypeButton), {
                    onClick: onLoadCreateIssueTypeModal,
                    onMouseEnter: onPreloadCreateIssueTypeModal
                }, chunks)
        }));
    };
    return {
        options: optionsWithActions,
        components: {
            Group: (0, $N7jPX.GroupComponentWithStickyFooter),
            Option: CustomOptionWithInlineConfig,
            NoOptionsMessage: NoOptionsMessage
        },
        noOptionWrapperRef: noOptionWrapperRef
    };
};
const $d340f5cdbd034415$export$edd8a0e9715caecc = (selectRef)=>{
    return ()=>{
        // When Create issue type or Edit issue type modal is closed, the modal will automatically return focus to the issue type field
        // The returned focus is returning fine and works well for keyboard users, however, @atlaskit/select caused some weird bug which
        // made issue type field not clickable for mouse users until it gets a refocus after a while, if we refocus immediately it also won't work
        // We tried to refocus with requestIdleCallback and requestAnimationFrame to delay the focus point based on CPU Idle and frame Idle
        // but none of that works so we need to use setTimeout temporarily before ADS team fix this issue
        setTimeout(()=>{
            // Refocusing to make issue type field clickable after focus is returned from closing modal
            selectRef.current?.blur();
            selectRef.current?.focus();
        }, (0, $9f7a9355e2f380ff$export$34934e4a629b9612));
    };
};

});
parcelRegister("k37tx", function(module, exports) {

$parcel$export(module.exports, "EditIssueTypeModalEntrypointTrigger", () => $2933d1814afcca1f$export$b43eeeacec0e2920);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $havAj = parcelRequire("havAj");

var $2Sffl = parcelRequire("2Sffl");

var $4R6GH = parcelRequire("4R6GH");
const $2933d1814afcca1f$export$b43eeeacec0e2920 = ({ children: children, queryParams: queryParams, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { projectKey: projectKey, onEditModalClose: onEditModalClose, buttonRef: buttonRef, ...props } = queryParams;
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            projectKey: projectKey,
            cloudId: cloudId
        }), [
        cloudId,
        projectKey
    ]);
    const onCloseEditIssueTypeModal = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditIssueTypeModal',
            action: 'closed'
        }), {
            calledFrom: props.calledFrom
        });
        onEditModalClose();
    }, [
        createAnalyticsEvent,
        onEditModalClose,
        props.calledFrom
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props,
            onClose: onCloseEditIssueTypeModal
        }), [
        props,
        onCloseEditIssueTypeModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $2Sffl.asyncEditIssueTypeModalEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        interactionName: "edit-issue-type-modal",
        useInternalModal: true,
        modalProps: (0, $havAj.defaultModalProps),
        forwardedRef: !(0, $4R6GH.fg)('inline_config_a11y_improvements') ? buttonRef : undefined
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            ref: ref,
            onClick: !(0, $4R6GH.fg)('inline_config_a11y_improvements') ? onClick : undefined
        }, children));
};

});
parcelRegister("havAj", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $15c81a62c11e20dc$export$14c11acc66fd51b3);
const $15c81a62c11e20dc$export$14c11acc66fd51b3 = {
    width: 'small'
};

});

parcelRegister("2Sffl", function(module, exports) {

$parcel$export(module.exports, "asyncEditIssueTypeModalEntrypoint", () => $e11cd54209640643$export$77154afa25455a57);

var $1YLRE = parcelRequire("1YLRE");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e11cd54209640643$export$77154afa25455a57 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3bp3Z")).then((module)=>module.AsyncEditIssueTypeModal), {
        moduleId: "22548b83"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>({
            queries: {
                editIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1YLRE.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("1YLRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7227964287505d9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1192085c48690de29428a79c9d6d1b6>>
 * @relayHash e7bd81102c1dee96dbca11245e366952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696
const $7227964287505d9d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v2 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.description"
                                                                            },
                                                                            v5 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraProjectByKey.issueTypes.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.issueTypes.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696",
            "metadata": {},
            "name": "srcAsyncEditIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7227964287505d9d$var$node.hash = "95da41f0960685e3830143828659ecad";
var $7227964287505d9d$export$2e2bcd8739ae039 = $7227964287505d9d$var$node;

});

parcelRegister("3bp3Z", function(module, exports) {

let $2515d73c069f4027$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2515d73c069f4027$var$load("h2MrD"),
    $2515d73c069f4027$var$load("bYT2S"),
    $2515d73c069f4027$var$load("3dpbG")
]).then(()=>parcelRequire('jKeZU'));

});



parcelRegister("koEf8", function(module, exports) {

$parcel$export(module.exports, "CreateWorkTypeButton", () => $fa3ebb0923ac3a31$export$8d68a7afe8d814ec);

var $5uXOq = parcelRequire("5uXOq");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

const $fa3ebb0923ac3a31$export$8d68a7afe8d814ec = ({ children: children, onClick: onClick, onMouseEnter: onMouseEnter })=>{
    const handleClick = (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssueTypeButton', {
            calledFrom: (0, $f1340a435190eeda$export$a1077f863a923e94)
        });
        onClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        xcss: $fa3ebb0923ac3a31$var$createWorkTypeInlineNoResultStyles
    }, children);
};
const $fa3ebb0923ac3a31$var$createWorkTypeInlineNoResultStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.0',
    paddingInline: 'space.0',
    marginTop: 'space.100',
    borderRadius: "var(--ds-space-025, 2px)",
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    display: 'block',
    fontWeight: 'font.weight.bold'
});

});


parcelRegister("iwPB7", function(module, exports) {

$parcel$export(module.exports, "WhatsThis", () => $0d98e1ee11ab43db$export$9fb74911aca1203);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $cgL5K = parcelRequire("cgL5K");

var $eHJxW = parcelRequire("eHJxW");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $dWeb7 = parcelRequire("dWeb7");
const $0d98e1ee11ab43db$export$9fb74911aca1203 = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        if (!isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeHelpDialogButton clicked');
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const dialogContent = (0, $5uXOq.useMemo)(()=>{
        const onClickLearnMoreLink = ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeLearnMoreLink clicked');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d98e1ee11ab43db$var$DialogContainer, {
            "data-testid": "issue-create.ui.modal.create-form.type-picker.request-type-changeboarding.dialog-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dWeb7.default).whatsThisDialogBodyIssueTermRefresh : (0, $dWeb7.default).whatsThisDialogBody,
            values: {
                learnMoreAboutRequestTypesLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: (0, $c741ce656e4e30c0$export$2e27f6d0b2889d14),
                    target: "_blank",
                    onClick: onClickLearnMoreLink,
                    onAuxClick: onClickLearnMoreLink
                }, formatMessage((0, $dWeb7.default).learnMoreAboutRequestTypesLink))
            }
        })));
    }, [
        createAnalyticsEvent,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "issue-create.ui.modal.create-form.type-picker.request-type-changeboarding.inline-dialog.jira-inline-dialog",
        messageType: "engagement",
        content: dialogContent,
        isOpen: isOpen,
        placement: "bottom-end",
        onClose: toggleDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d98e1ee11ab43db$var$WhatsThisButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        spacing: "none",
        onClick: toggleDialog
    }, formatMessage((0, $dWeb7.default).whatsThisDialogTrigger))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0d98e1ee11ab43db$var$WhatsThisButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0d98e1ee11ab43db$var$DialogContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1178",
            __cmplp.className
        ])
    });
});

});
const $c741ce656e4e30c0$export$2e27f6d0b2889d14 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-request-types/';

parcelRegister("dWeb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e267979802c002e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e267979802c002e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    whatsThisDialogTrigger: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-trigger",
        "defaultMessage": "What\u2019s this?"
    },
    whatsThisDialogBody: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body",
        "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the issue view, and access work categories. {learnMoreAboutRequestTypesLink}."
    },
    learnMoreAboutRequestTypesLink: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.learn-more-about-request-types-link",
        "defaultMessage": "Learn more about request types"
    },
    whatsThisDialogBodyIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body-issue-term-refresh",
        "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the detailed view of the work item, and access work categories. {learnMoreAboutRequestTypesLink}."
    }
});

});


parcelRegister("fjTud", function(module, exports) {

$parcel$export(module.exports, "RequestTypeHelpText", () => $aa6f2d8eff006264$export$f97ad894319e2545);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $hrR5y = parcelRequire("hrR5y");

var $kjgMT = parcelRequire("kjgMT");
const $aa6f2d8eff006264$export$6167fae6d6ed332c = (element)=>// https://stackoverflow.com/a/52650163
    // check if the element is being line clamped
    element ? element.scrollHeight !== element.offsetHeight : false;
const $aa6f2d8eff006264$export$f97ad894319e2545 = ({ helpText: helpText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // this property sets whether or not the show more button will be visible
    const [shouldCollapse, setShouldCollapse] = (0, $5uXOq.useState)(false);
    // this property sets whether the text is expanded or collapsed
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleIsOpen = ()=>setIsOpen(!isOpen);
    const helpTextRef = (0, $5uXOq.useRef)(undefined);
    const [windowWidth, windowHeight] = (0, $hrR5y.useWindowSize)();
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | undefined'.
        const newShouldCollapse = $aa6f2d8eff006264$export$6167fae6d6ed332c(helpTextRef.current);
        setShouldCollapse(newShouldCollapse);
        if (!newShouldCollapse) setIsOpen(false);
    }, [
        shouldCollapse,
        helpText,
        windowWidth,
        windowHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6f2d8eff006264$var$Collapser, {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6f2d8eff006264$var$HelpText, {
        isOpen: isOpen,
        innerRef: helpTextRef
    }, helpText)), shouldCollapse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa6f2d8eff006264$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: toggleIsOpen
    }, formatMessage(isOpen ? (0, $kjgMT.default).showLess : (0, $kjgMT.default).showMore))));
};
/*
    The webkit styles enable multi-line text-overflow ellipsis.
    See https://stackoverflow.com/a/13924997
    It's a bit of a hack but it works in most browsers -
    worst case, it will fall back to not having the ellipsis.
*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6f2d8eff006264$var$HelpText = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "jy4tmi-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-subtle, #44546F)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isOpen: isOpen })=>!isOpen ? `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    ` : '');
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6f2d8eff006264$var$Collapser = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "jy4tmi-1"
})((props)=>({
        marginTop: "var(--ds-space-100, 8px)",
        overflow: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: props.isOpen ? 'fit-content' : '32px'
    }));
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6f2d8eff006264$var$ButtonWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "jy4tmi-2"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtlest, #626F86)"};padding:0;margin:0;margin-top:${"var(--ds-space-075, 6px)"};button{padding:0;margin:0;border:0;}`;

});
parcelRegister("hrR5y", function(module, exports) {

$parcel$export(module.exports, "useWindowSize", () => $2ff720dc5374fa2c$export$42c02f33970a2afa);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
const $2ff720dc5374fa2c$export$42c02f33970a2afa = ()=>{
    const isClient = !false;
    const getSize = ()=>({
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            width: isClient ? window.innerWidth : undefined,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            height: isClient ? window.innerHeight : undefined
        });
    const [windowSize, setWindowSize] = (0, $5uXOq.useState)(getSize());
    const onResize = ()=>{
        setWindowSize(getSize());
    };
    const onResizeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onResize, 100, {
        leading: true,
        trailing: true
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isClient) return undefined;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResizeDebounced);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResizeDebounced);
        };
    }, [
        onResizeDebounced,
        isClient
    ]);
    return [
        windowSize.width,
        windowSize.height
    ];
};

});

parcelRegister("kjgMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde34240bd1e2f2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bde34240bd1e2f2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMore: {
        "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-more",
        "defaultMessage": "Show more\u2026"
    },
    showLess: {
        "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-less",
        "defaultMessage": "Show less\u2026"
    }
});

});


parcelRegister("f1j0c", function(module, exports) {

$parcel$export(module.exports, "RequestTypeSelect", () => $933e94b9786a21b2$export$3b6e21307c2d4f74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $7K5PP = parcelRequire("7K5PP");

var $6s1PB = parcelRequire("6s1PB");

var $7mok3 = parcelRequire("7mok3");

var $koVbs = parcelRequire("koVbs");

var $kHA0a = parcelRequire("kHA0a");

var $52O4s = parcelRequire("52O4s");
const $933e94b9786a21b2$var$selectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    control: (supplied)=>({
            ...supplied,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    valueContainer: (supplied)=>({
            ...supplied,
            padding: '0',
            paddingLeft: "var(--ds-space-150, 12px)",
            height: '42px' // specify a static height for the container, because the text container is absolutely positioned
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    menuList: (supplied)=>({
            ...supplied,
            padding: 0
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    group: (supplied)=>({
            ...supplied,
            padding: 0
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    groupHeading: (supplied)=>({
            ...supplied,
            margin: 0,
            paddingTop: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            color: "var(--ds-text, #172B4D)",
            textTransform: 'none' // default is uppercase
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    singleValue: (supplied)=>({
            ...supplied,
            top: 0,
            left: "var(--ds-space-150, 12px)",
            textOverflow: 'ellipsis',
            transform: 'none',
            // default is -50% y
            whiteSpace: 'nowrap',
            width: '100%',
            paddingRight: "var(--ds-space-400, 32px)"
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    option: (supplied)=>({
            ...supplied,
            cursor: 'pointer',
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            margin: 0
        })
};
const $933e94b9786a21b2$export$3b6e21307c2d4f74 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
        const description = option.type === 'NONE' ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $52O4s.default).noRequestTypeOptionDescriptionIssueTermRefresh : (0, $52O4s.default).noRequestTypeOptionDescription) : option.description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$IconWrapper, null, option.type === 'NONE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mok3.default), {
            label: ""
        }) : Boolean(option.iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$Icon, {
            src: option.iconUrl,
            alt: option.label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$FlexColumn, {
            isMenu: context === 'menu'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$Label, {
            "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.label",
            isMenu: context === 'menu'
        }, option.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$Description, {
            "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.description",
            isMenu: context === 'menu'
        }, description)));
    }, [
        formatMessage
    ]);
    return(// @ts-expect-error - TS2322 - Type '{ isClearable: false; formatOptionLabel: (option: NoneOption | RequestType, { context }: FormatOptionLabelMeta<NoneOption | RequestType>) => Element; ... 10 more ...;
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...props,
        isClearable: false,
        formatOptionLabel: formatOptionLabel,
        hideSelectedOptions: false,
        placeholder: "",
        maxMenuHeight: 256,
        styles: $933e94b9786a21b2$var$selectStyles,
        onKeyDown: (0, $kHA0a.preventEscKeyPropagationKeyPressHandler),
        "aria-label": formatMessage((0, $52O4s.default).ariaLabel)
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $933e94b9786a21b2$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $933e94b9786a21b2$var$FlexColumn = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1l270fi-0"
})((props)=>({
        flexDirection: 'column',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% - ${props.isMenu ? 40 : 14}px)`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $933e94b9786a21b2$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $933e94b9786a21b2$var$Label = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-1l270fi-1"
})`font:${"var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-200, 16px)"};height:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $933e94b9786a21b2$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $933e94b9786a21b2$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _4t3igktf _syaz1gjq _19pkidpf _ca0q1b66 _o5721q9c _1bto1l2s _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7mok3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd79b0e9c517f00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $1dd79b0e9c517f00$var$PresenceUnavailableSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12ZM6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12Z",
        fill: "#42526E"
    }));
const $1dd79b0e9c517f00$var$PresenceUnavailableIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $1dd79b0e9c517f00$var$PresenceUnavailableSVG
    });
var $1dd79b0e9c517f00$export$2e2bcd8739ae039 = $1dd79b0e9c517f00$var$PresenceUnavailableIcon;

});

parcelRegister("52O4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1436307c5a3f8ddc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1436307c5a3f8ddc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noRequestTypeOptionDescription: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description",
        "defaultMessage": "Issues can\u2019t be shared with customers, and may not work as expected."
    },
    ariaLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.aria-label",
        "defaultMessage": "Select request type"
    },
    noRequestTypeOptionDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description-issue-term-refresh",
        "defaultMessage": "Work items can\u2019t be shared with customers, and may not work as expected."
    }
});

});



parcelRegister("br2XI", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrors", () => $884976b576d5c059$export$8726164bd96601cc);
$parcel$export(module.exports, "getQueryVariables", () => $884976b576d5c059$export$8c3d6ce16880e58e);
$parcel$export(module.exports, "getContextFieldsForSubmit", () => $884976b576d5c059$export$2975feebfec7def8);
$parcel$export(module.exports, "getParentIdForSubmit", () => $884976b576d5c059$export$b208d5bc9f5e315f);
$parcel$export(module.exports, "resetFormFieldsForCreateAnother", () => $884976b576d5c059$export$d8f1f19cbcdc5ccf);
$parcel$export(module.exports, "getUserInputForRetention", () => $884976b576d5c059$export$ffde08d8190479bd);
$parcel$export(module.exports, "transformInlineErrorMessage", () => $884976b576d5c059$export$cc6683ccc73b073);
$parcel$export(module.exports, "getIssueCreateProjectForMount", () => $884976b576d5c059$export$ce9d0b4bb614f329);
$parcel$export(module.exports, "canSetContextForSubmit", () => $884976b576d5c059$export$fbc6cb29c318fa3a);
$parcel$export(module.exports, "shouldShowStatusField", () => $884976b576d5c059$export$3a332740e4aa9440);
$parcel$export(module.exports, "shouldShowLinkedAlertsField", () => $884976b576d5c059$export$d89be2967c4b3fcf);
$parcel$export(module.exports, "isWatchersUsed", () => $884976b576d5c059$export$8625e37c02bbfb71);
$parcel$export(module.exports, "getAnalyticsIssueType", () => $884976b576d5c059$export$385bf01e57223a7c);
$parcel$export(module.exports, "isDisplayConditionCFCausingError", () => $884976b576d5c059$export$cbe00e1e05a1451f);
$parcel$export(module.exports, "useIsCurrentUserAdminOfProject", () => $884976b576d5c059$export$d6fca3362baceda8);
$parcel$export(module.exports, "getAssigneeType", () => $884976b576d5c059$export$8e1d3c5195ccd2e3);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $2vSU6 = parcelRequire("2vSU6");

var $6paOF = parcelRequire("6paOF");


var $5fc53 = parcelRequire("5fc53");

var $bTWdn = parcelRequire("bTWdn");

var $1XJ20 = parcelRequire("1XJ20");

var $gItVn = parcelRequire("gItVn");

var $1lvym = parcelRequire("1lvym");
const $884976b576d5c059$export$8726164bd96601cc = (errors)=>{
    let validationErrors;
    if (errors.length) {
        validationErrors = {};
        errors.forEach(({ field: field, error: error })=>{
            validationErrors = {
                ...validationErrors,
                [field]: error
            };
        });
    }
    return validationErrors;
};
const $884976b576d5c059$export$8c3d6ce16880e58e = (selectedProject, selectedIssueType, defaultValues)=>{
    const projectId = selectedProject?.value || null;
    let issueTypeId = null;
    let requestTypeKey = null;
    if (selectedIssueType) {
        issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        requestTypeKey = // @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
        selectedIssueType.requestTypeKey !== undefined ? selectedIssueType.requestTypeKey : null;
    }
    return {
        project: projectId ? {
            projectId: projectId
        } : null,
        issueType: issueTypeId !== null ? {
            issueTypeId: issueTypeId
        } : null,
        requestType: requestTypeKey !== null ? {
            key: requestTypeKey
        } : null,
        defaultValues: defaultValues || null
    };
};
const $884976b576d5c059$export$2975feebfec7def8 = (selectedProject, selectedIssueType, requestTypeId)=>{
    const projectId = selectedProject.value;
    let issueTypeId;
    let requestTypeKey;
    if (selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)) {
        issueTypeId = selectedIssueType.issueTypeId;
        requestTypeKey = selectedIssueType.requestTypeKey;
    } else issueTypeId = selectedIssueType.value;
    const requestTypePayload = requestTypeId !== undefined ? {
        [requestTypeId]: requestTypeKey
    } : {};
    return {
        project: {
            id: projectId
        },
        issuetype: {
            id: issueTypeId
        },
        ...requestTypePayload
    };
};
const $884976b576d5c059$export$b208d5bc9f5e315f = (parentId)=>parentId && parentId.parentId ? {
        parent: {
            id: parentId.parentId
        }
    } : {};
const $884976b576d5c059$export$d8f1f19cbcdc5ccf = (formData, fieldConfig, resetForm)=>{
    const resetFormData = {
        ...formData
    };
    (0, $1lvym.NON_RETAINED_FIELDS_CREATE_ANOTHER).forEach((field)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(formData[field.fieldId])) resetFormData[field.fieldId] = field.getClearedDefaultValue(fieldConfig);
    });
    const resetObject = {
        ...resetFormData,
        [(0, $5fc53.SUMMARY_TYPE)]: ''
    };
    resetForm(resetObject);
    return resetObject;
};
const $884976b576d5c059$export$77b34f1a71743196 = (fieldConfig, fieldValues)=>{
    const dirtyCheckboxFieldIds = {};
    Object.keys(fieldValues).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        const { gqlType: gqlType } = fieldData || {};
        if ((0, $1lvym.FIELDS_TO_RETAIN_FIELD_VALUE).includes(gqlType) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(fieldValues[fieldId])) dirtyCheckboxFieldIds[fieldId] = true;
    });
    return dirtyCheckboxFieldIds;
};
const $884976b576d5c059$export$ffde08d8190479bd = ({ formState: formState, fieldConfig: fieldConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, retainedFieldsData: retainedFieldsData, initialDefaultValues: initialDefaultValues = {}, selectedClassification: selectedClassification })=>{
    let classificationRetainValue = {};
    if (selectedClassification?.id) classificationRetainValue = {
        dataClassification: {
            dataClassificationId: selectedClassification.id
        }
    };
    if (!formState) return initialDefaultValues;
    if (!retainedFieldsData || !retainedFieldsData.current) return initialDefaultValues;
    const { dirtyFields: dirtyFields, values: values } = formState;
    /*
        This is a hacky solution for solving field value retention issue for Checkboxes field.

        As fieldIds of the checkboxes fields are not present in the dirtyFileds (getting from formState) even if field values are updated,
        we're fetching all the fieldIds of the Checkboxes field, which has some field values, from formState values and storing those in a variable.
        After that we are appending that data (dirtyCheckboxFields) in dirtyFieldsCurrentSession.
    */ const dirtyCheckboxFieldIds = $884976b576d5c059$export$77b34f1a71743196(fieldConfig, values);
    // eslint-disable-next-line no-param-reassign
    dirtyFieldsCurrentSession.current = {
        ...dirtyFieldsCurrentSession.current,
        ...dirtyFields,
        ...dirtyCheckboxFieldIds
    };
    Object.keys(dirtyFieldsCurrentSession.current).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        // below condition fixes a issue where uncaught exception was throwing when fieldId was not part of fieldConfig
        if (fieldData) {
            const retainUserInputTransform = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
            (0, $gItVn.getGqlFieldMap)()[fieldData.gqlType]?.retainUserInputTransform || null;
            const userInput = values[fieldId];
            if (retainUserInputTransform && userInput) // consumers that want additional checks on data before deciding whether it should be retained can return null in case they don't want to retain it
            try {
                const userInputToBeRetained = retainUserInputTransform(userInput, fieldId);
                if (userInputToBeRetained) {
                    const arrWithoutStaleValues = retainedFieldsData.current.filter((itr)=>{
                        if (itr && itr.fieldId && itr.fieldId === fieldId) return false; // removing stale value
                        return true;
                    });
                    // eslint-disable-next-line no-param-reassign
                    retainedFieldsData.current = [
                        ...arrWithoutStaleValues,
                        userInputToBeRetained
                    ];
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $6paOF.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'getUserInputForRetention',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const retVal = {};
    retainedFieldsData.current.forEach((fieldData)=>{
        const { mutationGroup: mutationGroup, ...rest } = fieldData;
        if (mutationGroup) {
            if (!retVal[mutationGroup]) retVal[mutationGroup] = [];
            retVal[mutationGroup].push(rest);
        } else Object.keys(rest).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ fieldId: string; }'.
            retVal[key] = rest[key];
        });
    });
    return {
        ...classificationRetainValue,
        ...initialDefaultValues,
        ...retVal
    };
};
const $884976b576d5c059$export$cc6683ccc73b073 = (sectionMessage)=>{
    if (sectionMessage && sectionMessage.type === 'error') {
        const { title: title, displayList: errors } = sectionMessage;
        return {
            title: title,
            errors: errors
        };
    }
    return null;
};
const $884976b576d5c059$export$ce9d0b4bb614f329 = (projectContext)=>{
    if (projectContext?.projectId) return {
        label: projectContext.projectName,
        value: projectContext.projectId.toString(),
        iconUrl: '',
        projectKey: projectContext.projectKey,
        projectType: projectContext.projectType,
        isSimplified: projectContext.simplified
    };
    return null;
};
const $884976b576d5c059$export$fbc6cb29c318fa3a = (selectedProject, context)=>context?.projectId === selectedProject.value;
const $884976b576d5c059$export$3a332740e4aa9440 = (projectType, fieldConfig)=>{
    if (projectType !== (0, $2vSU6.SOFTWARE_PROJECT) && projectType !== (0, $2vSU6.CORE_PROJECT)) return false;
    return !!fieldConfig.status;
};
const $884976b576d5c059$export$d89be2967c4b3fcf = (projectType, selectedIssueType, alertsToBeLinked)=>{
    if (!alertsToBeLinked) return false;
    if (!projectType || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return false;
    if (selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$ebb48b08205007c5)) return false;
    return selectedIssueType?.practice === (0, $4cff3ad70ea80f75$export$48c144830383423);
};
const $884976b576d5c059$export$8625e37c02bbfb71 = ({ currentUserAccountId: currentUserAccountId, isAutoWatchEnabled: isAutoWatchEnabled = false, watchers: watchers = [] })=>{
    if (isAutoWatchEnabled) {
        if (watchers.length !== 1) return true;
        return watchers.every((watcher)=>watcher.accountId !== currentUserAccountId);
    }
    return watchers.length > 0;
};
const $884976b576d5c059$export$385bf01e57223a7c = (selectedIssueType)=>{
    const allowedIssueTypeValues = [
        'bug',
        'story',
        'task',
        'subtask',
        'epic'
    ];
    const issueTypeLabel = selectedIssueType?.label.toLowerCase();
    if (issueTypeLabel) return allowedIssueTypeValues.includes(issueTypeLabel) ? issueTypeLabel : 'custom';
    return undefined;
};
const $884976b576d5c059$export$cbe00e1e05a1451f = (errors, fieldConfig, filteredOutModules)=>{
    const customFieldsWithError = [];
    try {
        for (const error of errors){
            const fieldData = fieldConfig[error.field];
            if (fieldData) {
                const { isRequired: isRequired, fieldType: fieldType } = fieldData;
                if (isRequired) filteredOutModules.forEach((customField)=>{
                    if (customField.properties.displayConditions !== undefined && customField.id === fieldType) customFieldsWithError.push(fieldData.fieldName);
                });
            }
        }
        return customFieldsWithError.length !== 0 ? customFieldsWithError : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6paOF.fireIssueCreateErrorAnalytics)({
            meta: {
                id: 'isDisplayConditionCFCausingError',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $884976b576d5c059$export$d6fca3362baceda8 = ({ projectKey: projectKey })=>{
    const [isCurrentUserProjectAdminOfSelectedProject, setIsCurrentUserProjectAdminOfSelectedProject] = (0, $5uXOq.useState)(null);
    const previousProjectKey = (0, $1XJ20.usePrevious)(projectKey);
    const validateIsCurrentUserProjectAdminOfSelectedProject = (0, $5uXOq.useCallback)(async ()=>{
        if (!projectKey) {
            setIsCurrentUserProjectAdminOfSelectedProject(false);
            return;
        }
        setIsCurrentUserProjectAdminOfSelectedProject(null);
        const result = await (0, $bTWdn.isCurrentUserProjectAdmin)(projectKey);
        setIsCurrentUserProjectAdminOfSelectedProject(result);
    }, [
        projectKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousProjectKey !== projectKey) validateIsCurrentUserProjectAdminOfSelectedProject();
    }, [
        projectKey,
        previousProjectKey,
        validateIsCurrentUserProjectAdminOfSelectedProject
    ]);
    return isCurrentUserProjectAdminOfSelectedProject;
};
const $884976b576d5c059$export$8e1d3c5195ccd2e3 = (accountId, currentUser)=>{
    if (!accountId) return 'unassigned';
    if (accountId === '-1') return 'automatic';
    if (accountId === currentUser?.accountId) return 'current_user';
    return 'other';
};

});
parcelRegister("bTWdn", function(module, exports) {

$parcel$export(module.exports, "isCurrentUserProjectAdmin", () => $50bf0bcdf8ba40ed$export$146b7031c6ad53af);

var $icGZu = parcelRequire("icGZu");

var $bFU4G = parcelRequire("bFU4G");

var $eusud = parcelRequire("eusud");
const $50bf0bcdf8ba40ed$var$ADMINISTER_PROJECTS_PERMISSION = 'ADMINISTER_PROJECTS';
const $50bf0bcdf8ba40ed$var$getMyPermissionsGraphQLQuery = (projectKeyOrId)=>`query myPermissionsDataQuery {
        mypermissions(${Number.isNaN(+projectKeyOrId) ? `projectKey: "${projectKeyOrId}"` : `projectId: "${projectKeyOrId}"`}
        permissions: "${$50bf0bcdf8ba40ed$var$ADMINISTER_PROJECTS_PERMISSION}") {
            key
            havePermission
        }
    }`;
const $50bf0bcdf8ba40ed$var$fetchMyPermissions = (projectKeyOrId)=>(0, $eusud.performPostRequest)('/rest/graphql/1/?', {
        method: 'POST',
        body: JSON.stringify({
            query: $50bf0bcdf8ba40ed$var$getMyPermissionsGraphQLQuery(projectKeyOrId)
        })
    });
const $50bf0bcdf8ba40ed$export$146b7031c6ad53af = async (projectArg)=>{
    const fetchStartTime = performance.now();
    const { data: data, errors: errors } = await $50bf0bcdf8ba40ed$var$fetchMyPermissions(projectArg);
    (0, $bFU4G.addSpanToAll)('fetch', 'fetchMyPermissions', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    const hasError = errors && errors.length > 0;
    if (hasError || !data?.mypermissions) {
        const error = new Error(`Project admin permission check failed: ${hasError ? errors[0].message : 'no data'}`);
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        error.statusCode = hasError ? errors[0].statusCode : 500;
        // @ts-expect-error - TS2339 - Property 'skipSentry' does not exist on type 'Error'.
        error.skipSentry = hasError ? errors[0].statusCode === 404 : false;
        // We want to provide a degraded user experience if we get 4xx error and can't determine if the user is a project admin.
        if (hasError && errors[0].statusCode >= 400 && errors[0].statusCode <= 499) return false;
        throw error;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(data.mypermissions, {
        key: $50bf0bcdf8ba40ed$var$ADMINISTER_PROJECTS_PERMISSION,
        havePermission: true
    });
};

});

parcelRegister("1lvym", function(module, exports) {

$parcel$export(module.exports, "FIELDS_TO_RETAIN_FIELD_VALUE", () => $10b548a577ae91ad$export$992fccb91ee5793d);
$parcel$export(module.exports, "NON_RETAINED_FIELDS_CREATE_ANOTHER", () => $10b548a577ae91ad$export$d36a2604491a5bc6);

var $h2h4F = parcelRequire("h2h4F");

var $1K3Xb = parcelRequire("1K3Xb");

var $5fc53 = parcelRequire("5fc53");

const $10b548a577ae91ad$export$992fccb91ee5793d = [
    (0, $962656cd6986cb06$export$d10237d945259f96)
];
const $10b548a577ae91ad$export$d36a2604491a5bc6 = [
    {
        fieldId: (0, $5fc53.DESCRIPTION_TYPE),
        getClearedDefaultValue: (fieldConfig)=>{
            if (fieldConfig) {
                const descriptionFieldData = fieldConfig[0, $5fc53.DESCRIPTION_TYPE];
                return descriptionFieldData.gqlType === (0, $962656cd6986cb06$export$31a6c27df1f927b2) ? {
                    resetRequired: true,
                    ...(0, $1K3Xb.convertTextToAdf)('')
                } : descriptionFieldData.defaultValue;
            }
            return undefined;
        }
    },
    {
        fieldId: (0, $5fc53.ATTACHMENT_TYPE),
        getClearedDefaultValue: ()=>({
                shouldClear: true
            })
    },
    {
        fieldId: (0, $5fc53.ISSUE_LINKS_TYPE),
        getClearedDefaultValue: (fieldConfig)=>{
            if (fieldConfig) {
                const { defaultValue: defaultValue } = fieldConfig[0, $5fc53.ISSUE_LINKS_TYPE];
                if (Array.isArray(defaultValue)) {
                    const issueLinks = [];
                    defaultValue.forEach((issueLink)=>{
                        if (issueLink !== undefined && issueLink !== null && (typeof issueLink.id === 'string' || issueLink.id === null) && issueLink.relatedBy !== null && typeof issueLink.relatedBy === 'object' && typeof issueLink.relatedBy.linkTypeName === 'string' && typeof issueLink.relatedBy.relationName === 'string' && typeof issueLink.relatedBy.linkTypeId === 'string' && (issueLink.relatedBy.direction === 'INWARD' || issueLink.relatedBy.direction === 'OUTWARD') && typeof issueLink.issue === 'object' && issueLink.issue !== null && typeof issueLink.issue.avatar === 'object' && issueLink.issue.avatar !== null && typeof issueLink.issue.avatar.small === 'string' && typeof issueLink.issue.avatar.medium === 'string' && typeof issueLink.issue.id === 'string' && typeof issueLink.issue.issueId === 'string' && typeof issueLink.issue.key === 'string') {
                            // for type refinement, cannot pass iterable 'issueLink' directly to transformDefaultIssueLinksValue
                            const issueLinkExact = {
                                id: issueLink.id,
                                relatedBy: {
                                    linkTypeName: issueLink.relatedBy.linkTypeName,
                                    relationName: issueLink.relatedBy.relationName,
                                    linkTypeId: issueLink.relatedBy.linkTypeId,
                                    direction: issueLink.relatedBy.direction
                                },
                                issue: {
                                    avatar: {
                                        medium: issueLink.issue.avatar.medium,
                                        small: issueLink.issue.avatar.small
                                    },
                                    id: issueLink.issue.id,
                                    issueId: issueLink.issue.issueId,
                                    key: issueLink.issue.key
                                }
                            };
                            issueLinks.push(issueLinkExact);
                        }
                    });
                    return (0, $h2h4F.transformDefaultIssueLinksValue)(issueLinks);
                }
            }
            return undefined;
        }
    }
];
const $10b548a577ae91ad$export$3a6f576adb7c8374 = 'status-field';
const $10b548a577ae91ad$export$9584b50151d0c388 = 'issueType-field';

});



parcelRegister("7qfv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6285d5bf788f097d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hTEpF = parcelRequire("hTEpF");

var $bTyOW = parcelRequire("bTyOW");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $e3PDz = parcelRequire("e3PDz");
const $6285d5bf788f097d$var$MAX_IMAGE_WIDTH_PX = 188;
const $6285d5bf788f097d$var$MAX_IMAGE_HEIGHT_PX = 250;
const $6285d5bf788f097d$var$IMAGE_WIDTH_PX = 188;
const $6285d5bf788f097d$var$renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default))({
        imageWidth: $6285d5bf788f097d$var$IMAGE_WIDTH_PX,
        maxImageWidth: $6285d5bf788f097d$var$MAX_IMAGE_WIDTH_PX,
        maxImageHeight: $6285d5bf788f097d$var$MAX_IMAGE_HEIGHT_PX
    });
const $6285d5bf788f097d$var$ErrorState = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6285d5bf788f097d$export$412bc65ea3f44cf1, {
        "data-test-id": "issue-create.ui.modal.error-state.fetch-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: $6285d5bf788f097d$var$renderImage,
        header: formatMessage((0, $e3PDz.default).header),
        description: formatMessage((0, $e3PDz.default).description),
        width: "narrow"
    }));
});
var $6285d5bf788f097d$export$2e2bcd8739ae039 // to be wrapped only for components where test-id can't be added on some components
 = $6285d5bf788f097d$var$ErrorState;
const $6285d5bf788f097d$export$412bc65ea3f44cf1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("iVgQf", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $7affac5c7e698fc8$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4Bpvs = parcelRequire("4Bpvs");
function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, $4Bpvs.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $lD23V.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $lD23V.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3uP2Y")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kbo4z")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $kbo4z = parcelRequire("kbo4z");

var $3uP2Y = parcelRequire("3uP2Y");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3uP2Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kbo4z))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("kbo4z", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("3uP2Y", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("e3PDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a65e16b060ca91c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a65e16b060ca91c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "issue-create.modal.error-state.header",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "issue-create.modal.error-state.description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
    }
});

});


parcelRegister("lFNHi", function(module, exports) {

$parcel$export(module.exports, "ExistingGICWarning", () => $21854fdf8fa5d9c7$export$e0cf9a7a2f315b80);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $c7ZNt = parcelRequire("c7ZNt");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $45Cy1 = parcelRequire("45Cy1");

var $7NYq5 = parcelRequire("7NYq5");

var $5rzqz = parcelRequire("5rzqz");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $8exBF = parcelRequire("8exBF");
const $21854fdf8fa5d9c7$export$e0cf9a7a2f315b80 = ()=>{
    const [{ wasModalRetriggered: wasModalRetriggered }, { resetWasModalRetriggered: resetWasModalRetriggered }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [{ resetFormAction: resetFormAction, selectedProject: selectedProject, isFormDirty: isCreateFormDirty }] = (0, $45Cy1.useFormContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectId = selectedProject && selectedProject.value;
    const projectType = selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : '';
    const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
    // Re-initialise context values when create button is clicked and the form is clean
    (0, $5uXOq.useEffect)(()=>{
        if (wasModalRetriggered && !isCreateFormDirty) resetWasModalRetriggered(true);
    }, [
        wasModalRetriggered,
        isCreateFormDirty,
        resetWasModalRetriggered
    ]);
    const onClickDiscardButton = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'discardExistingGicWarning', {
            projectType: projectType
        });
        resetWasModalRetriggered(true);
        resetFormAction && resetFormAction();
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, {});
    }, [
        publish,
        projectType,
        resetWasModalRetriggered,
        resetFormAction
    ]);
    const onClickKeepEditingButton = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keepEditingExistingGicWarning', {
            projectType: projectType
        });
        resetWasModalRetriggered();
        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, {});
    }, [
        projectType,
        publish,
        resetWasModalRetriggered
    ]);
    if (!wasModalRetriggered || !isCreateFormDirty || !selectedProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "existingGicWarning",
        containerType: "project",
        containerId: projectId || '',
        attributes: {
            projectType: projectType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: ()=>resetWasModalRetriggered(),
        width: "medium",
        testId: "issue-create.ui.modal.existing-gic-warning.modal-dialog",
        messageId: "issue-create.ui.modal.existing-gic-warning.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8exBF.default).headingIssueTermRefresh : (0, $8exBF.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8exBF.default).descriptionIssueTermRefresh : (0, $8exBF.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClickDiscardButton,
        appearance: "subtle",
        testId: "issue-create.ui.modal.existing-gic-warning.discard-button"
    }, formatMessage((0, $8exBF.default).discardButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClickKeepEditingButton,
        appearance: "warning",
        testId: "issue-create.ui.modal.existing-gic-warning.keep-editing"
    }, formatMessage((0, $8exBF.default).keepEditingButton))))));
};

});
parcelRegister("8exBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75da2af9c7bc608$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c75da2af9c7bc608$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "issue-create.modal.existing-gic-warning.heading",
        "defaultMessage": "Draft issue in progress"
    },
    description: {
        "id": "issue-create.modal.existing-gic-warning.description",
        "defaultMessage": "It looks like you\u2019re already creating an issue. Creating a new issue will discard your draft and any changes you\u2019ve made won\u2019t be saved."
    },
    discardButton: {
        "id": "issue-create.modal.existing-gic-warning.discard-button",
        "defaultMessage": "Discard draft"
    },
    keepEditingButton: {
        "id": "issue-create.modal.existing-gic-warning.keep-editing-button",
        "defaultMessage": "Keep editing"
    },
    headingIssueTermRefresh: {
        "id": "issue-create.modal.existing-gic-warning.heading-issue-term-refresh",
        "defaultMessage": "Draft work item in progress"
    },
    descriptionIssueTermRefresh: {
        "id": "issue-create.modal.existing-gic-warning.description-issue-term-refresh",
        "defaultMessage": "It looks like you\u2019re already creating a work item. Creating a new one will discard your draft and any changes you\u2019ve made won\u2019t be saved."
    }
});

});


parcelRegister("hXutx", function(module, exports) {

$parcel$export(module.exports, "JsmRequestTypeFieldsChangeboarding", () => $c86210bec9ac1847$export$3c3f6e745ff8955);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $cgL5K = parcelRequire("cgL5K");

var $92Z2l = parcelRequire("92Z2l");

var $6s1PB = parcelRequire("6s1PB");

var $aWse0 = parcelRequire("aWse0");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
var $2NMNM = parcelRequire("2NMNM");

var $hH1l8 = parcelRequire("hH1l8");

var $31Qad = parcelRequire("31Qad");
const $c86210bec9ac1847$var$learnMoreLink = 'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';
const $c86210bec9ac1847$export$3c3f6e745ff8955 = ()=>{
    const [{ data: isRequestTypeFieldsLayoutEnabled }] = (0, $hH1l8.useRequestTypeFieldsLayoutPreference)();
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClickLearnMoreLink = ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'jsmRequestTypeFieldsChangeboardingLearnMoreLink clicked');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
        sourceName: "jsmRequestTypeFieldsChangeboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "discovery",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            spacing: "none",
            onClick: onClickLearnMoreLink,
            onAuxClick: onClickLearnMoreLink,
            href: $c86210bec9ac1847$var$learnMoreLink,
            target: "_blank"
        }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $31Qad.default).sectionMessageLearnMoreWhenToggleOffIssueTermRefresh : (0, $31Qad.default).sectionMessageLearnMoreWhenToggleOff) : formatMessage((0, $31Qad.default).sectionMessageLearnMore))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $31Qad.default).sectionMessageBodyWhenToggleOffIssueTermRefresh : (0, $31Qad.default).sectionMessageBodyWhenToggleOff, {
        bold: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, message)
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $31Qad.default).sectionMessageBodyIssueTermRefresh : (0, $31Qad.default).sectionMessageBody))));
};

});
parcelRegister("31Qad", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e2d2fad6134821$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28e2d2fad6134821$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sectionMessageBody: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body",
        "defaultMessage": "Since a request type has been selected for this issue, these fields can\u2019t be edited here."
    },
    sectionMessageBodyWhenToggleOff: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off",
        "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating issues."
    },
    sectionMessageLearnMore: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more",
        "defaultMessage": "Learn more about editing the fields of a request type"
    },
    sectionMessageLearnMoreWhenToggleOff: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off",
        "defaultMessage": "Learn more about using request type fields while creating issues"
    },
    sectionMessageBodyIssueTermRefresh: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-issue-term-refresh",
        "defaultMessage": "Since a request type has been selected for this work item, these fields can\u2019t be edited here."
    },
    sectionMessageBodyWhenToggleOffIssueTermRefresh: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off-issue-term-refresh",
        "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating work items."
    },
    sectionMessageLearnMoreWhenToggleOffIssueTermRefresh: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off-issue-term-refresh",
        "defaultMessage": "Learn more about using request type fields while creating work items"
    }
});

});


parcelRegister("eF4iR", function(module, exports) {

$parcel$export(module.exports, "ModalWrapper", () => $29af1391730b0075$export$858bfd02c3f2fba5);

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");

var $anKMC = parcelRequire("anKMC");

var $9fuVs = parcelRequire("9fuVs");

var $kErdU = parcelRequire("kErdU");

var $6ikhl = parcelRequire("6ikhl");

var $bPtOr = parcelRequire("bPtOr");

var $gLdtQ = parcelRequire("gLdtQ");

var $45Cy1 = parcelRequire("45Cy1");

var $iUFy5 = parcelRequire("iUFy5");

var $h1cYs = parcelRequire("h1cYs");

var $boiMK = parcelRequire("boiMK");

var $eHMxp = parcelRequire("eHMxp");

var $573IZ = parcelRequire("573IZ");

var $1JVJe = parcelRequire("1JVJe");

var $7NYq5 = parcelRequire("7NYq5");

var $5rzqz = parcelRequire("5rzqz");

var $l8ruj = parcelRequire("l8ruj");

var $8LWdH = parcelRequire("8LWdH");

var $PpuOf = parcelRequire("PpuOf");

var $6gjIc = parcelRequire("6gjIc");

var $bMoTh = parcelRequire("bMoTh");

var $jWbdK = parcelRequire("jWbdK");

var $dDDBO = parcelRequire("dDDBO");

var $l2y6R = parcelRequire("l2y6R");

var $31ArW = parcelRequire("31ArW");

var $2NKLM = parcelRequire("2NKLM");

var $7qb4M = parcelRequire("7qb4M");

var $6mZXS = parcelRequire("6mZXS");
const $29af1391730b0075$var$ModalBodyNext = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: (0, $gLdtQ.ISSUE_CREATE_MODAL_BODY_SELECTOR),
        ref: ref,
        ...props
    })));
const $29af1391730b0075$var$OldModal = ({ children: children, onModalCloseWithConfirm: onModalCloseWithConfirm, shouldDisableActions: shouldDisableActions, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, watchersConfigurations: watchersConfigurations, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        width: "large",
        height: "100vh",
        autoFocus: false,
        // @ts-expect-error - TS2322 - Type '(_: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'OnCloseHandler'.
        onClose: onModalCloseWithConfirm('issueCreateModalEscapeClick'),
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: false,
        testId: "issue-create.ui.modal.modal-wrapper.modal",
        messageId: "issue-create.ui.modal.modal-wrapper.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ArW.default), {
        shouldDisableActions: shouldDisableActions,
        watchersConfigurations: watchersConfigurations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29af1391730b0075$var$ModalBodyNext, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LWdH.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showIssuesCreated: showIssuesCreated,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    })));
const $29af1391730b0075$var$MinimizableModalContainer = ({ children: children })=>{
    const { initialSummaryValue: initialSummaryValue } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    const { view: view } = (0, $iUFy5.useMinimizableModal)();
    const summaryValue = (0, $7qb4M.useSetSummary)(initialSummaryValue);
    (0, $6mZXS.useViewChangerDisabler)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JVJe.ModalTransition), {
        renderCondition: view === 'modal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NKLM.MinimizableModalModal), {
        "data-testid": "issue-create.ui.modal.modal-wrapper.modal"
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHMxp.MiniTransition), {
        renderCondition: view === 'mini'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dDDBO.MinimizableModalMini), {
            ...transitionProps,
            summaryValue: summaryValue
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $boiMK.FullscreenTransition), {
        renderCondition: view === 'fullscreen'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWbdK.MinimizableFullscreen), transitionProps, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $573IZ.MinimizedTransition), {
        renderCondition: view === 'minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2y6R.MinimizableModalMinimized), {
            ...transitionProps,
            summaryValue: summaryValue
        })));
};
const $29af1391730b0075$var$OldModalWrapper = (props)=>{
    const [{ disableGICPositioning: disableGICPositioning }, { setDisableGICPositioning: setDisableGICPositioning }] = (0, $PpuOf.useGICPositioningEnabledController)();
    (0, $5uXOq.useEffect)(()=>{
        if (!disableGICPositioning) setDisableGICPositioning(true);
    }, [
        disableGICPositioning,
        setDisableGICPositioning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29af1391730b0075$var$OldModal, props);
};
const $29af1391730b0075$export$858bfd02c3f2fba5 = ({ children: children, ...rest })=>{
    const [{ minimizableModalView: minimizableModalView, displayMinimizableButtons: displayMinimizableButtons }, { setMinimizableModalView: setMinimizableModalView }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    const [, { dispatchFormSubmits: dispatchForgeInlineFormSubmits }] = (0, $6ikhl.useInlineFields)();
    const [{ isFormLoaded: isFormLoaded }] = (0, $45Cy1.useFormContext)();
    const renderOldModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29af1391730b0075$var$OldModalWrapper, rest, children);
    const onViewChange = (0, $5uXOq.useCallback)((newView)=>{
        setMinimizableModalView(newView);
        dispatchForgeInlineFormSubmits();
    }, [
        setMinimizableModalView,
        dispatchForgeInlineFormSubmits
    ]);
    if (isGICPositioningEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-create-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: isFormLoaded ? 'issue-create-app-loaded' : 'issue-create-app',
        packageName: "jiraIssueCreateModal",
        fallback: renderOldModal,
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $bPtOr.getErrorType)(error)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMoTh.MinimizableModalWrapperPropsProvider), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1cYs.MinimizableModal), {
        view: minimizableModalView,
        onViewChange: onViewChange,
        Container: $29af1391730b0075$var$MinimizableModalContainer,
        // @ts-expect-error - TS2322 - Type '(_: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'OnCloseHandler'.
        onClose: rest.onModalCloseWithConfirm('cancel'),
        displayMinimizableButtons: displayMinimizableButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $anKMC.ClipboardContextBoundaryContainer), null, children)))));
    return renderOldModal();
};

});
parcelRegister("anKMC", function(module, exports) {

$parcel$export(module.exports, "ClipboardContextBoundaryContainer", () => $870f392021d774f7$export$fd0a7836bfa6a893);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $46dC9 = parcelRequire("46dC9");
const $870f392021d774f7$var$invisibleDivStyles = null;
const $870f392021d774f7$var$ClipboardContextBoundaryProvider = ({ children: children })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $46dC9.useClipboardContextActions)();
    const setRef = (0, $5uXOq.useCallback)((node)=>{
        setClipBoardContext(node);
    }, [
        setClipBoardContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: setRef,
        "data-testid": "clipboard.controllers.boundary.clipboard-boundary",
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _4t3i1kw7 _1bsb1kw7"
        ])
    }, children);
};
const $870f392021d774f7$export$fd0a7836bfa6a893 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46dC9.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($870f392021d774f7$var$ClipboardContextBoundaryProvider, null, children));
const $870f392021d774f7$var$ClipboardContainerSetEffector = ({ container: container })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $46dC9.useClipboardContextActions)();
    (0, $5uXOq.useEffect)(()=>setClipBoardContext(container), [
        setClipBoardContext,
        container
    ]);
    return null;
};
const $870f392021d774f7$export$99c5c2d165547316 = ({ children: children, container: container, intent: intent })=>{
    const currentContainer = (0, $46dC9.useClipboardContextBoundary)();
    if (!container || currentContainer && intent === 'support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46dC9.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($870f392021d774f7$var$ClipboardContainerSetEffector, {
        container: container
    }), children);
};

});

parcelRegister("h1cYs", function(module, exports) {

$parcel$export(module.exports, "MinimizableModal", () => $4c8c59050f25d92e$export$fe110805c6d6ede4);

var $5uXOq = parcelRequire("5uXOq");

var $9MHPe = parcelRequire("9MHPe");

var $iUFy5 = parcelRequire("iUFy5");

var $isEfy = parcelRequire("isEfy");

var $4Ads7 = parcelRequire("4Ads7");
const $4c8c59050f25d92e$export$fe110805c6d6ede4 = ({ children: children, Container: Container = (0, $isEfy.ModalContainer), initialView: initialView, onClose: onClose, view: view, onViewChange: onViewChange, displayMinimizableButtons: displayMinimizableButtons })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MHPe.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUFy5.MinimizableModalProvider), {
        initialView: initialView,
        onClose: onClose,
        view: view,
        onViewChange: onViewChange,
        displayMinimizableButtons: displayMinimizableButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Ads7.ReParenter), {
        Parent: Container
    }, children)));

});
parcelRegister("isEfy", function(module, exports) {

$parcel$export(module.exports, "ModalContainer", () => $de64b73b456d385d$export$c9554889b3e706cd);

var $5uXOq = parcelRequire("5uXOq");

var $iUFy5 = parcelRequire("iUFy5");

var $boiMK = parcelRequire("boiMK");

var $fVPqx = parcelRequire("fVPqx");

var $eHMxp = parcelRequire("eHMxp");

var $dVZve = parcelRequire("dVZve");

var $573IZ = parcelRequire("573IZ");

var $4TqWb = parcelRequire("4TqWb");

var $bSvOl = parcelRequire("bSvOl");

var $1JVJe = parcelRequire("1JVJe");

var $6BEt4 = parcelRequire("6BEt4");
const $de64b73b456d385d$var$DefaultHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSvOl.ModalHeader), props);
const $de64b73b456d385d$var$DefaultMiniHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSvOl.MiniHeader), props);
const $de64b73b456d385d$export$c9554889b3e706cd = ({ children: children, components: components })=>{
    const { view: view } = (0, $iUFy5.useMinimizableModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JVJe.ModalTransition), {
        renderCondition: view === 'modal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6BEt4.Modal), {
        components: components || {
            Header: $de64b73b456d385d$var$DefaultHeader
        }
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHMxp.MiniTransition), {
        renderCondition: view === 'mini'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVZve.Mini), {
            ...transitionProps,
            components: components || {
                Header: $de64b73b456d385d$var$DefaultMiniHeader
            }
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $boiMK.FullscreenTransition), {
        renderCondition: view === 'fullscreen'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVPqx.Fullscreen), {
            ...transitionProps,
            components: components || {
                Header: $de64b73b456d385d$var$DefaultMiniHeader
            }
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $573IZ.MinimizedTransition), {
        renderCondition: view === 'minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4TqWb.Minimized), transitionProps)));
};

});
parcelRegister("boiMK", function(module, exports) {

$parcel$export(module.exports, "FullscreenTransition", () => $0927d7c7ed49ea45$export$d6c32f25d5187e12);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");
var $dWt6p = parcelRequire("dWt6p");

var $kUthR = parcelRequire("kUthR");
const $0927d7c7ed49ea45$export$d6c32f25d5187e12 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $kUthR.useTransitionView)('fullscreen', renderCondition);
    if ((0, $dWt6p.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uxPN.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: "medium",
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});
parcelRegister("kUthR", function(module, exports) {

$parcel$export(module.exports, "useTransitionView", () => $9176435670b8d931$export$4ebb8b85ce67f755);

var $5uXOq = parcelRequire("5uXOq");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");
const $9176435670b8d931$export$4ebb8b85ce67f755 = (view, renderCondition)=>{
    const { setTransitionState: setTransitionState, isTransitionInState: isTransitionInState } = (0, $iUFy5.useMinimizableModal)();
    const shouldRenderView = (0, $5uXOq.useMemo)(()=>{
        if (view === 'modal') return renderCondition && isTransitionInState([
            'mini',
            'minimized'
        ], (0, $kNC83.TransitionState).EXITED);
        if (view === 'mini') return renderCondition && isTransitionInState([
            'modal',
            'minimized'
        ], (0, $kNC83.TransitionState).EXITED);
        if (view === 'minimized') return renderCondition && isTransitionInState([
            'mini',
            'modal'
        ], (0, $kNC83.TransitionState).EXITED);
        if (view === 'fullscreen') return renderCondition && isTransitionInState([], (0, $kNC83.TransitionState).EXITED);
        return false;
    }, [
        renderCondition,
        isTransitionInState,
        view
    ]);
    // SlideIn onFinish prop is sometimes called before the useEffect
    // isAnimationComplete is used to control that
    const isAnimationComplete = (0, $5uXOq.useRef)(false);
    const isInitialised = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialised.current) isAnimationComplete.current = false;
    }, [
        shouldRenderView
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderView && !isAnimationComplete.current) {
            isInitialised.current = true;
            setTransitionState(view, (0, $kNC83.TransitionState).TRANSITIONING);
        } else if (!shouldRenderView && !isAnimationComplete.current && isInitialised.current) setTransitionState(view, (0, $kNC83.TransitionState).TRANSITIONING);
    }, [
        shouldRenderView,
        setTransitionState,
        view
    ]);
    const onFinishAnimation = (0, $5uXOq.useCallback)((state)=>{
        isAnimationComplete.current = true;
        if (state === 'entering') setTransitionState(view, (0, $kNC83.TransitionState).ENTERED);
        if (state === 'exiting') setTransitionState(view, (0, $kNC83.TransitionState).EXITED);
    }, [
        setTransitionState,
        view
    ]);
    return {
        onFinishAnimation: onFinishAnimation,
        shouldRenderView: shouldRenderView
    };
};

});


parcelRegister("fVPqx", function(module, exports) {

$parcel$export(module.exports, "FullscreenBody", () => $9109127f603187a0$export$cf81465aa48f28a8);
$parcel$export(module.exports, "Fullscreen", () => $9109127f603187a0$export$159cd03be7087f39);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");

var $8TEtS = parcelRequire("8TEtS");
const $9109127f603187a0$export$cf81465aa48f28a8 = ({ children: children, containerStyle: containerStyle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TEtS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$var$FullscreenBodyWrapper, {
        "data-testid": "minimizable-modal.ui.modal-container.fullscreen.fullscreen-body-wrapper",
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: containerStyle
    }, children));
const $9109127f603187a0$export$159cd03be7087f39 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, components: components, containerStyle: containerStyle }, ref)=>{
    const { Header: Header = (0, $5uXOq.Fragment), Footer: Footer = (0, $5uXOq.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $iUFy5.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'fullscreen'
    ], (0, $kNC83.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$export$a07082e2094b8119, {
        ref: ref,
        transitionClass: className,
        "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.fullscreen'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$export$cf81465aa48f28a8, {
        containerStyle: containerStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
});
const $9109127f603187a0$export$a07082e2094b8119 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$var$FullscreenWrapperExperimentStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.transitionClass,
        ...props
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9109127f603187a0$var$FullscreenBodyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k",
            __cmplp.className
        ])
    });
});
const $9109127f603187a0$var$FullscreenWrapperExperimentStyles = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _kqsw1n9t _154iidpf _1ltvidpf _bfhk1bhr _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8TEtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a414aafbb3e82fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $8AVUY = parcelRequire("8AVUY");

var $4DoYe = parcelRequire("4DoYe");

var $iOmTz = parcelRequire("iOmTz");


var $dbCdn = parcelRequire("dbCdn");
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $2a414aafbb3e82fd$var$ScrollContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $iOmTz.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const setLazySiblings = (0, $4DoYe.default)(setSiblings);
    const setLazyContentFocus = (0, $4DoYe.default)((0, $dbCdn.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $4DoYe.default)((0, $dbCdn.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $d8212265224e9df6$export$4c317248f944c2a9));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $d8212265224e9df6$export$4c317248f944c2a9));
        }
    }));
    (0, $5uXOq.useEffect)(()=>{
        const target = scrollableRef.current;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a414aafbb3e82fd$var$ScrollContainerWrapper, {
        tabIndex: showContentFocus ? 0 : undefined,
        "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
        ref: (0, $8AVUY.default)([
            ref,
            scrollableRef
        ]),
        showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
        showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
    }, children));
});
$2a414aafbb3e82fd$var$ScrollContainer.displayName = 'ScrollContainer';
var $2a414aafbb3e82fd$export$2e2bcd8739ae039 = $2a414aafbb3e82fd$var$ScrollContainer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a414aafbb3e82fd$var$ScrollContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dv6fab": (0, $lD23V.default)((0, $d8212265224e9df6$export$d901150a4cc83165))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _1reo15vq _18m91wug _1d2sn7od _1utt1wug",
            __cmplp.showTopKeyline ? "_x3do9gv1" : "_x3doglyw",
            __cmplp.showBottomKeyline ? "_n7zl9gv1" : "_n7zlglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8AVUY", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e4e6541c9abeb4$export$2e2bcd8739ae039);
function $69e4e6541c9abeb4$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            ref.current = value;
        });
    };
}

});

parcelRegister("4DoYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab16856141d7038e$export$2e2bcd8739ae039);

var $beBSN = parcelRequire("beBSN");
function $ab16856141d7038e$export$2e2bcd8739ae039(callback) {
    const ref = (0, $beBSN.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("beBSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab05653bdb7a660$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $cab05653bdb7a660$var$uniqueReferencedValue = {};
function $cab05653bdb7a660$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $5uXOq.useRef)($cab05653bdb7a660$var$uniqueReferencedValue);
    if (ref.current === $cab05653bdb7a660$var$uniqueReferencedValue) ref.current = initializer();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref;
}

});


parcelRegister("iOmTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6530274a8996f773$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $6530274a8996f773$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $5uXOq.useState)(initialState);
    const valueRef = (0, $5uXOq.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

const $d8212265224e9df6$export$4c317248f944c2a9 = 2;
const $d8212265224e9df6$export$d901150a4cc83165 = "var(--ds-border, #091E4224)";

parcelRegister("dbCdn", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $15f8df8d72ae6633$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $15f8df8d72ae6633$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("eHMxp", function(module, exports) {

$parcel$export(module.exports, "MiniTransition", () => $f884f60e67b8d25c$export$1f36cb33f56bd06e);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");
var $dWt6p = parcelRequire("dWt6p");

var $kUthR = parcelRequire("kUthR");
const $f884f60e67b8d25c$export$1f36cb33f56bd06e = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $kUthR.useTransitionView)('mini', renderCondition);
    if ((0, $dWt6p.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uxPN.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: "medium",
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("dVZve", function(module, exports) {

$parcel$export(module.exports, "MiniBody", () => $3240aef3134a48d2$export$b7d0c8df4a39a4c7);
$parcel$export(module.exports, "Mini", () => $3240aef3134a48d2$export$87d5d88f89bf43b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9fuVs = parcelRequire("9fuVs");

var $ACELo = parcelRequire("ACELo");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");

var $lfEUW = parcelRequire("lfEUW");
const $3240aef3134a48d2$export$b7d0c8df4a39a4c7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfEUW.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3240aef3134a48d2$var$MiniBodyWrapper, null, children));
const $3240aef3134a48d2$export$87d5d88f89bf43b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, components: components }, ref)=>{
    const { Header: Header = (0, $5uXOq.Fragment), Footer: Footer = (0, $5uXOq.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $iUFy5.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'mini'
    ], (0, $kNC83.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-mini-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3240aef3134a48d2$var$MiniWrapper, {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.mini',
        ...(0, $4R6GH.fg)('jfp_a11y_team_mini_issue_create_dialog_identify') ? {
            role: 'dialog',
            'aria-modal': 'false',
            'aria-labelledby': 'minimizable-modal.modal-container.modal-header.title'
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3240aef3134a48d2$export$b7d0c8df4a39a4c7, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3240aef3134a48d2$var$MiniWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rkoftgi _1bsb12hx _4t3i1diq _bfhk1bhr _1e0c1txw _2lx21bp4 _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $3240aef3134a48d2$var$MiniBodyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f31ejb _n3tdu2gc _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lfEUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b97525d65936cd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $jhVLw = parcelRequire("jhVLw");

var $4R6GH = parcelRequire("4R6GH");

var $8AVUY = parcelRequire("8AVUY");

var $4DoYe = parcelRequire("4DoYe");

var $iOmTz = parcelRequire("iOmTz");


var $6UCIg = parcelRequire("6UCIg");
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $0b97525d65936cd1$var$ScrollContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $iOmTz.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const setLazySiblings = (0, $4DoYe.default)(setSiblings);
    const setLazyContentFocus = (0, $4DoYe.default)((0, $6UCIg.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $4DoYe.default)((0, $6UCIg.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $7b14f915cb039103$export$4c317248f944c2a9));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $7b14f915cb039103$export$4c317248f944c2a9));
        }
    }));
    (0, $5uXOq.useEffect)(()=>{
        const target = scrollableRef.current;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b97525d65936cd1$var$ScrollContainerWrapper, {
        // eslint-disable-next-line styled-components-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
        innerRef: (0, $8AVUY.default)([
            ref,
            scrollableRef
        ]),
        showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
        showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
    }, children));
});
$0b97525d65936cd1$var$ScrollContainer.displayName = 'ScrollContainer';
var $0b97525d65936cd1$export$2e2bcd8739ae039 = $0b97525d65936cd1$var$ScrollContainer;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b97525d65936cd1$var$ScrollContainerWrapper = /*#__PURE__*/ (0, $47bDC.default).div.attrs({
    // This is a false positive: https://product-fabric.atlassian.net/browse/USS-49
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
    style: ({ showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline })=>({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderTop: `${showTopKeyline ? `${0, $7b14f915cb039103$export$4c317248f944c2a9}px solid ${0, $7b14f915cb039103$export$d901150a4cc83165}` : 'none'}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderBottom: `${showBottomKeyline ? `${0, $7b14f915cb039103$export$4c317248f944c2a9}px solid ${0, $7b14f915cb039103$export$d901150a4cc83165}` : 'none'}`
        })
}).withConfig({
    componentId: "sc-12dk2la-0"
})`display:inherit;margin:0;flex:inherit;flex-direction:inherit;${()=>(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') && 'flex-grow: 1;'} overflow-x:hidden;overflow-y:auto;@media (min-width:480px){height:unset;overflow-y:auto;}`;

});
const $7b14f915cb039103$export$4c317248f944c2a9 = 2;
const $7b14f915cb039103$export$d901150a4cc83165 = "var(--ds-border, #091E4224)";

parcelRegister("6UCIg", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $e7fa10d9d0d08428$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $e7fa10d9d0d08428$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("573IZ", function(module, exports) {

$parcel$export(module.exports, "MinimizedTransition", () => $8e63bbc9eb829a67$export$a483cc235b11f289);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");
var $dWt6p = parcelRequire("dWt6p");

var $kUthR = parcelRequire("kUthR");
const $8e63bbc9eb829a67$export$a483cc235b11f289 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $kUthR.useTransitionView)('minimized', renderCondition);
    if ((0, $dWt6p.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uxPN.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: "medium",
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("4TqWb", function(module, exports) {

$parcel$export(module.exports, "Minimized", () => $1500855dbb649f82$export$b41d27d203c8df67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jhVLw = parcelRequire("jhVLw");

var $koVbs = parcelRequire("koVbs");

var $bGrWH = parcelRequire("bGrWH");

var $ACELo = parcelRequire("ACELo");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
var $2NMNM = parcelRequire("2NMNM");

var $2hqdj = parcelRequire("2hqdj");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");

var $g61N0 = parcelRequire("g61N0");
const $1500855dbb649f82$export$b41d27d203c8df67 = ({ children: children, className: className })=>{
    const { unminimizeModal: unminimizeModal, previousView: previousView, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger } = (0, $iUFy5.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { minimizedButtonRef: minimizedButtonRef, onKeyDown: onKeyDown, wrapperRef: wrapperRef } = (0, $2hqdj.useEnterFocusState)();
    const isViewEntered = isTransitionInState([
        'minimized'
    ], (0, $kNC83.TransitionState).ENTERED);
    const unminimize = ()=>{
        if (!isViewEntered) return;
        setShouldFocusChanger(true);
        unminimizeModal('modal');
        const analyticsEvent = createAnalyticsEvent({
            action: 'container clicked',
            actionSubject: 'minimized'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: previousView
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-minimised-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1500855dbb649f82$var$MinimizedOuterWrapper, {
        id: (0, $bGrWH.MINIMISED_DROPZONE_CONTAINER_ID),
        tabIndex: -1,
        ref: wrapperRef,
        "data-testid": // testid should only be available when view is not transitioning
        // otherwise CY tries to click the view before its last position
        isViewEntered ? 'minimizable-modal.ui.modal-container.minimized-outer-wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (0, $8zOmE.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1500855dbb649f82$var$MinimizedWrapper, {
        ref: minimizedButtonRef,
        "data-testid": isViewEntered ? 'minimizable-modal.ui.modal-container.minimized' : undefined,
        onKeyDown: onKeyDown,
        onClick: unminimize,
        className: className,
        "aria-label": formatMessage((0, $g61N0.default).ariaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1500855dbb649f82$var$MinimizedText, null, children)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1500855dbb649f82$var$MinimizedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _2rkoftgi _v5649dqc _vchhusvi _bfhkhp5a _4t3ickbl _1bsb1mjv _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3pxbi _n3tdidpf _19bvpxbi _80omtlke _16qs1cd0 _ymio1r31 _ypr0glyw _zcxs1o36 _1spjglyw _1dit1r31 _ksodglyw _4hz81o36 _irr3108i _1q5t1r31 _1ohyglyw _1r9x1o36 _1di6108i",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1500855dbb649f82$var$MinimizedText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8nbxd _1bto1l2s _o5721q9c _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1500855dbb649f82$var$MinimizedOuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2hqdj", function(module, exports) {

$parcel$export(module.exports, "useEnterFocusState", () => $7836e0c3ac104eed$export$cda941d4347e19b6);

var $5uXOq = parcelRequire("5uXOq");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");
const $7836e0c3ac104eed$export$cda941d4347e19b6 = ()=>{
    const { view: view, setTransitionByKeyboardFrom: setTransitionByKeyboardFrom, transitionByKeyboardFrom: transitionByKeyboardFrom, isTransitionInState: isTransitionInState, shouldFocusChanger: shouldFocusChanger, setShouldFocusChanger: setShouldFocusChanger } = (0, $iUFy5.useMinimizableModal)();
    // Keep refs in this order in order not to affect the unit tests
    const minimizedButtonRef = (0, $5uXOq.useRef)(null);
    const modalButtonRef = (0, $5uXOq.useRef)(null);
    const miniButtonRef = (0, $5uXOq.useRef)(null);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const [init, setInit] = (0, $5uXOq.useState)(false);
    const isViewEntered = isTransitionInState([
        view
    ], (0, $kNC83.TransitionState).ENTERED);
    const onKeyDown = (0, $5uXOq.useCallback)((ev)=>{
        if (!isViewEntered) return;
        // 13: Enter Key; 32: Space Key
        setTransitionByKeyboardFrom([
            13,
            32
        ].includes(ev.keyCode) ? view : null);
    }, [
        setTransitionByKeyboardFrom,
        isViewEntered,
        view
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!init && isViewEntered && shouldFocusChanger) {
            setInit(true);
            setShouldFocusChanger(false);
            const buttonRef = {
                modal: modalButtonRef.current,
                mini: miniButtonRef.current,
                minimized: minimizedButtonRef.current,
                fullscreen: null
            };
            requestAnimationFrame(()=>{
                const buttonToFocus = transitionByKeyboardFrom !== null && view === 'minimized' ? 'minimized' : transitionByKeyboardFrom;
                if (buttonToFocus && buttonRef[buttonToFocus]) {
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    buttonRef[buttonToFocus].focus();
                    setTransitionByKeyboardFrom(null);
                } else if (wrapperRef.current) wrapperRef.current.focus();
            });
        }
    }, [
        transitionByKeyboardFrom,
        setTransitionByKeyboardFrom,
        init,
        view,
        isViewEntered,
        shouldFocusChanger,
        setShouldFocusChanger
    ]);
    return {
        onKeyDown: onKeyDown,
        minimizedButtonRef: minimizedButtonRef,
        modalButtonRef: modalButtonRef,
        miniButtonRef: miniButtonRef,
        wrapperRef: wrapperRef
    };
};

});

parcelRegister("g61N0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26e4d368b5bfad7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c26e4d368b5bfad7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "minimizable-modal.modal-container.minimized.messaged.aria-label",
        "defaultMessage": "Minimized modal"
    }
});

});


parcelRegister("bSvOl", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $58cf9d8ffbd68381$export$f50a68e3694789ee);
$parcel$export(module.exports, "ModalTitle", () => $58cf9d8ffbd68381$export$b26fae16ba5468aa);
$parcel$export(module.exports, "MiniHeader", () => $58cf9d8ffbd68381$export$1d38987b2afcba7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $i28qQ = parcelRequire("i28qQ");

var $l14Zy = parcelRequire("l14Zy");

var $joXrw = parcelRequire("joXrw");

var $8KRBa = parcelRequire("8KRBa");

var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8XUAb = parcelRequire("8XUAb");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $2hqdj = parcelRequire("2hqdj");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");

var $3b05o = parcelRequire("3b05o");

var $iezXC = parcelRequire("iezXC");
const $58cf9d8ffbd68381$export$b89ab188a65746a6 = ({ isMini: isMini = false, ViewChangerContainer: ViewChangerContainer, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, meatBallMenu: meatBallMenu })=>{
    const { view: view, setView: setView, onClose: onClose, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger, displayMinimizableButtons: displayMinimizableButtons } = (0, $iUFy5.useMinimizableModal)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { minimizedButtonRef: minimizedButtonRef, modalButtonRef: modalButtonRef, miniButtonRef: miniButtonRef, wrapperRef: wrapperRef, onKeyDown: onKeyDown } = (0, $2hqdj.useEnterFocusState)();
    const onUpdateView = (0, $5uXOq.useCallback)((newView)=>{
        if (!isTransitionInState([
            view
        ], (0, $kNC83.TransitionState).ENTERED)) return;
        setShouldFocusChanger(true);
        setView(newView);
        const analyticsEvent = createAnalyticsEvent({
            action: 'button clicked',
            actionSubject: newView
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: view
        });
    }, [
        isTransitionInState,
        view,
        setShouldFocusChanger,
        setView,
        createAnalyticsEvent
    ]);
    const onViewChangeToMinimized = (0, $5uXOq.useCallback)(()=>onUpdateView('minimized'), [
        onUpdateView
    ]);
    const onViewChangeToMini = (0, $5uXOq.useCallback)(()=>onUpdateView('mini'), [
        onUpdateView
    ]);
    const onViewChangeToModal = (0, $5uXOq.useCallback)(()=>onUpdateView('modal'), [
        onUpdateView
    ]);
    const { shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage: customDisabledViewChangerButtonsMessage } = (0, $iUFy5.useMinimizableModal)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldDisableViewChangerButtons) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'disabled',
            actionSubject: 'view changer buttons'
        }));
    }, [
        createAnalyticsEvent,
        customDisabledViewChangerButtonsMessage,
        shouldDisableViewChangerButtons
    ]);
    (0, $3b05o.useNestedModalDetector)();
    const Wrapper = ViewChangerContainer || (0, $5uXOq.Fragment);
    const expandMessage = (0, $iezXC.default).fullScreen;
    const dockMessage = (0, $iezXC.default).fullScreenExit;
    const dockDisabledMessage = (0, $iezXC.default).fullScreenExitDisabled;
    const tooltipOptions = {
        position: 'top',
        hideTooltipOnClick: true
    };
    let closeBtn;
    if (dismissModalEntryPointWrapper) {
        const DismissModalEntryPointWrapper = dismissModalEntryPointWrapper;
        closeBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DismissModalEntryPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            isTooltipDisabled: false,
            tooltip: tooltipOptions,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
            label: formatMessage((0, $iezXC.default).close),
            onClick: onClose,
            testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
            appearance: isMini && (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle'
        }));
    } else closeBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
        label: formatMessage((0, $iezXC.default).close),
        onClick: onClose,
        testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
        appearance: isMini && (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ViewChangerWrapper, {
        tabIndex: -1,
        ref: wrapperRef,
        isMini: isMini,
        "data-testid": "minimizable-modal.ui.modal-container.modal-header.view-changer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        as: "ul",
        xcss: $58cf9d8ffbd68381$var$headerButtonsListStyles
    }, !displayMinimizableButtons ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $58cf9d8ffbd68381$var$lineItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($joXrw))),
        label: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage((0, $iezXC.default).minimizeDisabled) : formatMessage((0, $iezXC.default).minimize),
        onClick: onViewChangeToMinimized,
        testId: "minimizable-modal.ui.modal-container.modal-header.minimized-button",
        appearance: isMini && (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onKeyDown: onKeyDown,
        isDisabled: shouldDisableViewChangerButtons,
        ref: minimizedButtonRef
    })), !isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $58cf9d8ffbd68381$var$lineItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8KRBa))),
        label: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage(dockDisabledMessage) : formatMessage(dockMessage),
        onClick: onViewChangeToMini,
        testId: "minimizable-modal.ui.modal-container.modal-header.mini-button",
        appearance: isMini && (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onKeyDown: onKeyDown,
        isDisabled: shouldDisableViewChangerButtons,
        ref: miniButtonRef
    })), isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $58cf9d8ffbd68381$var$lineItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l14Zy))),
        label: formatMessage(expandMessage),
        onClick: onViewChangeToModal,
        testId: "minimizable-modal.ui.modal-container.modal-header.modal-button",
        appearance: isMini && (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onKeyDown: onKeyDown,
        ref: modalButtonRef
    })), meatBallMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $58cf9d8ffbd68381$var$lineItemStyles
    }, meatBallMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $58cf9d8ffbd68381$var$lineItemStyles
    }, closeBtn)))));
};
const $58cf9d8ffbd68381$export$f50a68e3694789ee = ({ children: children, ViewChangerContainer: ViewChangerContainer, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, meatBallMenu: meatBallMenu, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), rest, (0, $6s1PB.expVal)('jira_in_product_video_pilot_v1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XUAb.CreateWorkVideoEducationModalTriggerButton), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$export$b89ab188a65746a6, {
        ViewChangerContainer: ViewChangerContainer,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper,
        meatBallMenu: meatBallMenu
    })));
const $58cf9d8ffbd68381$export$b26fae16ba5468aa = (props)=>{
    const { view: view } = (0, $iUFy5.useMinimizableModal)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, testId: testId } = props;
    if (view === 'mini' || view === 'minimized') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h2",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $58cf9d8ffbd68381$var$headerStyleswithVR : $58cf9d8ffbd68381$var$headerStyles,
        testId: testId,
        ...(0, $4R6GH.fg)('jfp_a11y_team_mini_issue_create_dialog_identify') ? {
            id: 'minimizable-modal.modal-container.modal-header.title'
        } : {}
    }, (0, $4R6GH.fg)('jfp_a11y_team_mini_issue_create_dialog_identify') ? children || formatMessage((0, $iezXC.default).headerFallbackTitle) : children);
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "medium",
        color: "color.text"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", props);
};
const $58cf9d8ffbd68381$export$1d38987b2afcba7e = ({ children: children, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$MiniHeaderWrapper, rest, (0, $4R6GH.fg)('jfp_a11y_team_mini_issue_create_dialog_identify') ? children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$export$b26fae16ba5468aa, null) : children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$export$b89ab188a65746a6, {
        isMini: true,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58cf9d8ffbd68381$var$ViewChangerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1o9zidpf _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.isMini && "_u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58cf9d8ffbd68381$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otcopxbi _17ugpxbi _1eompxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58cf9d8ffbd68381$var$MiniHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl1pfj _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahesu3 _syaz1fxt _16qs1bc2 _19pkidpf _2hwxutpp _otyridpf _18u0utpp _ca0qv47k _u5f3u2gc _n3tdv47k _19bvu2gc",
            __cmplp.className
        ])
    });
}); // Atlaskit does not have a solution for using tooltips for disabled buttons.
const $58cf9d8ffbd68381$var$headerButtonsListStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    listStyleType: 'none',
    borderRadius: 'borderRadius.25'
});
const $58cf9d8ffbd68381$var$lineItemStyles = (0, $8CUq3.xcss)({
    margin: 'auto'
});
const $58cf9d8ffbd68381$var$headerStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexShrink: 1,
    flexGrow: 1,
    overflow: 'hidden',
    marginTop: '0'
});
const $58cf9d8ffbd68381$var$headerStyleswithVR = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingRight: 'space.100',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexShrink: 1,
    flexGrow: 1,
    overflow: 'hidden',
    marginTop: '0'
});

});
parcelRegister("joXrw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4184f921700e882128556324b8090399>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1fe5e54707cbb64$var$_react = $e1fe5e54707cbb64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e1fe5e54707cbb64$var$_baseNew = $e1fe5e54707cbb64$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e1fe5e54707cbb64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1fe5e54707cbb64$var$MinimizeIcon = (props)=>/*#__PURE__*/ $e1fe5e54707cbb64$var$_react.default.createElement($e1fe5e54707cbb64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$e1fe5e54707cbb64$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $e1fe5e54707cbb64$var$_default = module.exports.default = $e1fe5e54707cbb64$var$MinimizeIcon;

});

parcelRegister("8XUAb", function(module, exports) {

$parcel$export(module.exports, "CreateWorkVideoEducationModalTriggerButton", () => $b73dd2419d038610$export$b309d9141239e6d2);

var $5uXOq = parcelRequire("5uXOq");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $bzvT1 = parcelRequire("bzvT1");

var $ccNZn = parcelRequire("ccNZn");

var $8zOmE = parcelRequire("8zOmE");

var $2NMNM = parcelRequire("2NMNM");

var $kWkcx = parcelRequire("kWkcx");
const $b73dd2419d038610$export$b309d9141239e6d2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $kWkcx.default).tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccNZn.ModalEntryPointButtonTrigger), {
        appearance: "subtle",
        entryPoint: (0, $bzvT1.createWorkVideoEducationModalEntryPoint),
        entryPointProps: {},
        interactionName: "create-work-video-education-modal",
        useInternalModal: true,
        modalProps: {
            width: 'x-large',
            onOpenComplete: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'open',
                    actionSubject: 'modalDialog'
                }), 'createWorkVideoEducationModal');
            },
            onCloseComplete: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'close',
                    actionSubject: 'modalDialog'
                }), 'createWorkVideoEducationModal');
            }
        },
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'openCreateWorkVideoEducationModal');
        },
        testId: "issue-create-commons.ui.create-work-video-education-modal-trigger-button.create-work-video-education-modal-trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: formatMessage((0, $kWkcx.default).tooltip),
        LEGACY_size: "small"
    })));
};

});
parcelRegister("bzvT1", function(module, exports) {

$parcel$export(module.exports, "createWorkVideoEducationModalEntryPoint", () => $4380941be41d6895$export$e5d252b17c45f31d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4380941be41d6895$export$e5d252b17c45f31d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4MSWl")), {
        moduleId: "066770b8",
        moduleName: "CreateWorkVideoEducationModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4MSWl", function(module, exports) {

let $37c6430af4d3ab23$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37c6430af4d3ab23$var$load("1cgn8").then(()=>parcelRequire('3CfKB'));

});


parcelRegister("ccNZn", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointButtonTrigger", () => $eadd31beb792ab12$export$a0d6030c4f504341);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $2KAtx = parcelRequire("2KAtx");
function $eadd31beb792ab12$export$a0d6030c4f504341({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ref: ref,
            ...buttonProps
        }, children));
}

});

parcelRegister("kWkcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f423bc5fc74daf7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2f423bc5fc74daf7$var$messages = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "issue-create-commons.create-work-video-education-modal-trigger-button.tooltip",
        "defaultMessage": "Watch a tutorial on how to create work"
    }
});
var $2f423bc5fc74daf7$export$2e2bcd8739ae039 = $2f423bc5fc74daf7$var$messages;

});


parcelRegister("3b05o", function(module, exports) {

$parcel$export(module.exports, "useNestedModalDetector", () => $e5437dd22c0b7edd$export$d9e46b281508f5e9);

var $5uXOq = parcelRequire("5uXOq");

var $iUFy5 = parcelRequire("iUFy5");
const $e5437dd22c0b7edd$export$d9e46b281508f5e9 = ()=>{
    const { setIsNestedModal: setIsNestedModal } = (0, $iUFy5.useMinimizableModal)();
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const modalElements = document.querySelectorAll('div.atlaskit-portal [aria-modal="true"]');
        if (modalElements.length > 1) setIsNestedModal(true);
    }, [
        setIsNestedModal
    ]);
};

});

parcelRegister("iezXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a612173ce9fd1b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6a612173ce9fd1b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    minimize: {
        "id": "minimizable-modal.modal-container.modal-header.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.minimize-disabled",
        "defaultMessage": "Can't minimize this view"
    },
    dock: {
        "id": "minimizable-modal.modal-container.modal-header.dock",
        "defaultMessage": "Dock to bottom"
    },
    dockDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.dock-disabled",
        "defaultMessage": "Can't dock this view"
    },
    fullScreenExit: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen-exit",
        "defaultMessage": "Exit full screen"
    },
    fullScreenExitDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen-exit-disabled",
        "defaultMessage": "Can't exit full screen"
    },
    expand: {
        "id": "minimizable-modal.modal-container.modal-header.expand",
        "defaultMessage": "Expand"
    },
    fullScreen: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen",
        "defaultMessage": "Go full screen"
    },
    close: {
        "id": "minimizable-modal.modal-container.modal-header.close",
        "defaultMessage": "Close"
    },
    onboardingSpotlightTitle: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-title",
        "defaultMessage": "Welcome to the new issue create experience"
    },
    onboardingSpotlightActionGotIt: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-got-it",
        "defaultMessage": "Got it"
    },
    onboardingSpotlightActionLearnMore: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-learn-more",
        "defaultMessage": "Learn more"
    },
    onboardingSpotlightDescription: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-description",
        "defaultMessage": "A consistent, fast, and optimized way to capture work in your project."
    },
    onboardingSpotlightTitleIssueTermRefresh: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-title-issue-term-refresh",
        "defaultMessage": "Welcome to the new create experience"
    },
    headerFallbackTitle: {
        "id": "minimizable-modal.modal-container.modal-header.title",
        "defaultMessage": "Create New Work Item"
    }
});

});


parcelRegister("1JVJe", function(module, exports) {

$parcel$export(module.exports, "ModalTransition", () => $3591ee95e2cbe3ad$export$f0a3ab1cc2e7e9a6);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $dWt6p = parcelRequire("dWt6p");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");
const $3591ee95e2cbe3ad$export$f0a3ab1cc2e7e9a6 = ({ children: children, renderCondition: renderCondition })=>{
    const { isTransitionInState: isTransitionInState } = (0, $iUFy5.useMinimizableModal)();
    if ((0, $dWt6p.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
        return null;
    }
    const shouldRenderModalView = renderCondition && isTransitionInState([
        'mini',
        'minimized'
    ], (0, $kNC83.TransitionState).EXITED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, shouldRenderModalView && children);
};

});

parcelRegister("6BEt4", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $b8d0d70af0708712$export$2b77a92f1a5ad772);

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");

var $dWt6p = parcelRequire("dWt6p");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $7NYq5 = parcelRequire("7NYq5");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $iUFy5 = parcelRequire("iUFy5");

var $kNC83 = parcelRequire("kNC83");

var $kUthR = parcelRequire("kUthR");
const $b8d0d70af0708712$export$2b77a92f1a5ad772 = ({ children: children, components: components, onClose: onCloseFromProps, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, 'data-testid': dataTestId, ...rest })=>{
    const { onClose: onClose, isTransitionInState: isTransitionInState } = (0, $iUFy5.useMinimizableModal)();
    const { onFinishAnimation: onFinishAnimation } = (0, $kUthR.useTransitionView)('modal', true);
    const onOpenComplete = ()=>{
        onFinishAnimation('entering');
    };
    const onCloseComplete = ()=>{
        onFinishAnimation('exiting');
    };
    const isViewEntered = isTransitionInState([
        'modal'
    ], (0, $kNC83.TransitionState).ENTERED);
    const { Header: Header = (0, $5uXOq.Fragment), Body: Body = (0, $7QSqG.default), Footer: Footer = (0, $5uXOq.Fragment) } = components || {};
    const onMount = (0, $5uXOq.useCallback)((event)=>{
        (0, $8zOmE.fireScreenAnalyticsDeferred)(event, {
            isReducedMotion: (0, $dWt6p.isReducedMotion)()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        width: "large",
        height: (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? undefined : '100vh',
        autoFocus: false,
        onClose: onCloseFromProps || onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        testId: isViewEntered ? dataTestId || 'minimizable-modal.ui.modal-container.modal' : undefined,
        messageId: "minimizable-modal.ui.modal-container.modal.modal-dialog",
        messageType: "transactional",
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Body, null, children === undefined ? null : children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, null)));
};

});


parcelRegister("4Ads7", function(module, exports) {

$parcel$export(module.exports, "ReParenter", () => $ffd89c5b1c439476$export$c74b59dc6ffb3f46);

var $5uXOq = parcelRequire("5uXOq");

var $botCU = parcelRequire("botCU");

var $9MHPe = parcelRequire("9MHPe");
const $ffd89c5b1c439476$export$c74b59dc6ffb3f46 = ({ children: children, Parent: Parent })=>{
    const portalNode = (0, $5uXOq.useMemo)(()=>(0, $botCU.createHtmlPortalNode)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $botCU.InPortal), {
        node: portalNode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MHPe.Layering), {
        isDisabled: false
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Parent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $botCU.OutPortal), {
        node: portalNode
    })));
};

});
parcelRegister("botCU", function(module, exports) {

$parcel$export(module.exports, "InPortal", () => $84b8ead67181cdc9$export$82590d10982cb172);
$parcel$export(module.exports, "OutPortal", () => $84b8ead67181cdc9$export$6677f336551ad316);
$parcel$export(module.exports, "createHtmlPortalNode", () => $84b8ead67181cdc9$export$c08cb61f0c65e152);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
var $84b8ead67181cdc9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// Internally, the portalNode must be for either HTML or SVG elements
var $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML = 'html';
var $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG = 'svg';
// ReactDOM can handle several different namespaces, but they're not exported publicly
// https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/DOMNamespaces.js#L8-L10
var $84b8ead67181cdc9$var$SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var $84b8ead67181cdc9$var$validateElementType = function(domElement, elementType) {
    if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML) return domElement instanceof HTMLElement;
    if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG) return domElement instanceof SVGElement;
    throw new Error("Unrecognized element type \"" + elementType + "\" for validateElementType.");
};
// This is the internal implementation: the public entry points set elementType to an appropriate value
var $84b8ead67181cdc9$var$createPortalNode = function(elementType, options) {
    var initialProps = {};
    var parent;
    var lastPlaceholder;
    var element;
    if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML) element = document.createElement('div');
    else if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG) element = document.createElementNS($84b8ead67181cdc9$var$SVG_NAMESPACE, 'g');
    else throw new Error("Invalid element type \"" + elementType + "\" for createPortalNode: must be \"html\" or \"svg\".");
    if (options && typeof options === "object") for(var _i = 0, _a = Object.entries(options.attributes); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        element.setAttribute(key, value);
    }
    var portalNode = {
        element: element,
        elementType: elementType,
        setPortalProps: function(props) {
            initialProps = props;
        },
        getInitialPortalProps: function() {
            return initialProps;
        },
        mount: function(newParent, newPlaceholder) {
            if (newPlaceholder === lastPlaceholder) // Already mounted - noop.
            return;
            portalNode.unmount();
            // To support SVG and other non-html elements, the portalNode's elementType needs to match
            // the elementType it's being rendered into
            if (newParent !== parent) {
                if (!$84b8ead67181cdc9$var$validateElementType(newParent, elementType)) throw new Error("Invalid element type for portal: \"" + elementType + "\" portalNodes must be used with " + elementType + " elements, but OutPortal is within <" + newParent.tagName + ">.");
            }
            newParent.replaceChild(portalNode.element, newPlaceholder);
            parent = newParent;
            lastPlaceholder = newPlaceholder;
        },
        unmount: function(expectedPlaceholder) {
            if (expectedPlaceholder && expectedPlaceholder !== lastPlaceholder) // Skip unmounts for placeholders that aren't currently mounted
            // They will have been automatically unmounted already by a subsequent mount()
            return;
            if (parent && lastPlaceholder) {
                parent.replaceChild(lastPlaceholder, portalNode.element);
                parent = undefined;
                lastPlaceholder = undefined;
            }
        }
    };
    return portalNode;
};
var $84b8ead67181cdc9$export$82590d10982cb172 = /** @class */ function(_super) {
    $84b8ead67181cdc9$var$__extends(InPortal, _super);
    function InPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.addPropsChannel = function() {
            Object.assign(_this.props.node, {
                setPortalProps: function(props) {
                    // Rerender the child node here if/when the out portal props change
                    _this.setState({
                        nodeProps: props
                    });
                }
            });
        };
        _this.state = {
            nodeProps: _this.props.node.getInitialPortalProps()
        };
        return _this;
    }
    InPortal.prototype.componentDidMount = function() {
        this.addPropsChannel();
    };
    InPortal.prototype.componentDidUpdate = function() {
        this.addPropsChannel();
    };
    InPortal.prototype.render = function() {
        var _this = this;
        var _a = this.props, children = _a.children, node = _a.node;
        return $7nsd3.createPortal($5uXOq.Children.map(children, function(child) {
            if (!$5uXOq.isValidElement(child)) return child;
            return $5uXOq.cloneElement(child, _this.state.nodeProps);
        }), node.element);
    };
    return InPortal;
}($5uXOq.PureComponent);
var $84b8ead67181cdc9$export$6677f336551ad316 = /** @class */ function(_super) {
    $84b8ead67181cdc9$var$__extends(OutPortal, _super);
    function OutPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.placeholderNode = $5uXOq.createRef();
        _this.passPropsThroughPortal();
        return _this;
    }
    OutPortal.prototype.passPropsThroughPortal = function() {
        var propsForTarget = Object.assign({}, this.props, {
            node: undefined
        });
        this.props.node.setPortalProps(propsForTarget);
    };
    OutPortal.prototype.componentDidMount = function() {
        var node = this.props.node;
        this.currentPortalNode = node;
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentDidUpdate = function() {
        // We re-mount on update, just in case we were unmounted (e.g. by
        // a second OutPortal, which has now been removed)
        var node = this.props.node;
        // If we're switching portal nodes, we need to clean up the current one first.
        if (this.currentPortalNode && node !== this.currentPortalNode) {
            this.currentPortalNode.unmount(this.placeholderNode.current);
            this.currentPortalNode = node;
        }
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentWillUnmount = function() {
        var node = this.props.node;
        node.unmount(this.placeholderNode.current);
    };
    OutPortal.prototype.render = function() {
        // Render a placeholder to the DOM, so we can get a reference into
        // our location in the DOM, and swap it out for the portaled node.
        // A <div> placeholder works fine even for SVG.
        return $5uXOq.createElement("div", {
            ref: this.placeholderNode
        });
    };
    return OutPortal;
}($5uXOq.PureComponent);
var $84b8ead67181cdc9$export$c08cb61f0c65e152 = $84b8ead67181cdc9$var$createPortalNode.bind(null, $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML);
var $84b8ead67181cdc9$export$6ac597db63d00ad3 = $84b8ead67181cdc9$var$createPortalNode.bind(null, $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG);

});



parcelRegister("8LWdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d3d9c5f6f4d0480$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $kkJfY = parcelRequire("kkJfY");

var $a9R4o = parcelRequire("a9R4o");

var $juxqI = parcelRequire("juxqI");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5rzqz = parcelRequire("5rzqz");

var $8zOmE = parcelRequire("8zOmE");

var $6gjIc = parcelRequire("6gjIc");


var $2K6wP = parcelRequire("2K6wP");

var $fya6v = parcelRequire("fya6v");

var $eGLQ7 = parcelRequire("eGLQ7");

const $1d3d9c5f6f4d0480$var$PassThroughWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $1d3d9c5f6f4d0480$var$ModalFooter = (props)=>{
    const { isMiniVariant: isMiniVariant, children: children } = props;
    if (isMiniVariant) /**
     * We need to use our own footer and not the atlaskit one since the atlaskit one
     * needs to be within ModalDialog to get context or else it crashes
     */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1d3d9c5f6f4d0480$var$miniFooterStyles,
        testId: "issue-create.common.ui.footer.footer-mini"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, children);
};
const $1d3d9c5f6f4d0480$export$a06f1c675e846f6f = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onClose: onClose, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress = false, onCreateAnotherChange: onCreateAnotherChange, canCreateAnotherIssue: canCreateAnotherIssue, shouldDisableSubmit: shouldDisableSubmit = false, createdIssues: createdIssues, variant: variant = (0, $fya6v.GIC_VARIANTS).DEFAULT, displayCreateAnotherIssueToggle: newDisplayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, showCancelButton: showCancelButton } = props;
    const numberOfIssuesCreated = createdIssues.length;
    let displayCreateAnotherIssueToggle = newDisplayCreateAnotherIssueToggle;
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    const isMiniVariant = isGICPositioningEnabled() && variant === (0, $fya6v.GIC_VARIANTS).MINI;
    if (!isGICPositioningEnabled()) {
        const [{ displayCreateAnotherIssueToggle: oldDisplayCreateAnotherIssueToggle }] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5rzqz.useTriggerIssueCreateModal)();
        displayCreateAnotherIssueToggle = oldDisplayCreateAnotherIssueToggle;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onViewIssuesLinkClicked = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewIssue');
    };
    const getPrimaryButtonCopy = ()=>{
        if (isMiniVariant) return (0, $eGLQ7.default).createButtonInMiniView;
        return (0, $eGLQ7.default).createButton;
    };
    const IssuesCreatedTooltip = isMiniVariant ? (0, $3bDjY.default) : $1d3d9c5f6f4d0480$var$PassThroughWrapper;
    const showIssueCreatedTooltip = Boolean(numberOfIssuesCreated) && Boolean(showIssuesCreated);
    const cancelBtn = props?.dismissModalEntryPointWrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.dismissModalEntryPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onClose,
        isDisabled: isSubmitting,
        testId: "issue-create.common.ui.footer.cancel-button",
        interactionName: "global-issue.create-modal.cancel"
    }, formatMessage((0, $eGLQ7.default).cancelButton))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onClose,
        isDisabled: isSubmitting,
        testId: "issue-create.common.ui.footer.cancel-button",
        interactionName: "global-issue.create-modal.cancel"
    }, formatMessage((0, $eGLQ7.default).cancelButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$var$ModalFooter, {
        isMiniVariant: isMiniVariant
    }, displayCreateAnotherIssueToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onChange: onCreateAnotherChange,
        label: formatMessage((0, $eGLQ7.default).createAnother),
        isChecked: canCreateAnotherIssue,
        isDisabled: shouldDisableSubmit,
        testId: "issue-create.common.ui.footer.checkbox"
    }), showIssueCreatedTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssuesCreatedTooltip, {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eGLQ7.default).issuesCreatedLinkIssueTermRefresh : (0, $eGLQ7.default).issuesCreatedLink, {
            issueCount: numberOfIssuesCreated
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$var$IssueLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9R4o))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-icon-success, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        spacing: "none",
        href: (0, $2K6wP.getIssueDiscoveryUrl)(createdIssues),
        target: "_blank",
        onClick: onViewIssuesLinkClicked,
        testId: "issue-create.common.ui.footer.created-issue-link",
        interactionName: "global-issue.create-modal.created-issue-link"
    }, isMiniVariant ? numberOfIssuesCreated : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eGLQ7.default).issuesCreatedLinkIssueTermRefresh : (0, $eGLQ7.default).issuesCreatedLink, {
        issueCount: numberOfIssuesCreated
    })))), (!isMiniVariant || showCancelButton) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$var$CloseButtonContainer, null, cancelBtn), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "primary",
        onClick: onSubmit,
        isLoading: isSubmitting || isOperationInProgress,
        isDisabled: isSubmitting || shouldDisableSubmit,
        type: "submit",
        form: (0, $c758c3cb80bbdb5a$export$2d077da71c26c1c5),
        testId: "issue-create.common.ui.footer.create-button",
        interactionName: "global-issue.create-modal.submit"
    }, isGICPositioningEnabled() ? formatMessage(getPrimaryButtonCopy()) : formatMessage((0, $eGLQ7.default).createButton)));
};
var $1d3d9c5f6f4d0480$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
 = $1d3d9c5f6f4d0480$export$a06f1c675e846f6f;
const $1d3d9c5f6f4d0480$var$CloseButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d3d9c5f6f4d0480$var$IssueLinkContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _18u0pxbi _2hwx1wug",
            __cmplp.className
        ])
    });
});
const $1d3d9c5f6f4d0480$var$miniFooterStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.050',
    flex: '0 0 auto',
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.150',
    marginRight: 'space.150',
    paddingTop: 'space.250',
    paddingBottom: 'space.250',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderTop: `0.5px solid ${"var(--ds-border, #091E4224)"}`,
    boxShadow: 'elevation.shadow.overflow.spread'
});

});
parcelRegister("a9R4o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a025c623e0bb09a5c37bf2eb484e3711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7653e93bf7da1948$var$_react = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7653e93bf7da1948$var$_success = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $7653e93bf7da1948$var$_success2 = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("kJ541")));
function $7653e93bf7da1948$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7653e93bf7da1948$var$SuccessIcon = (props)=>/*#__PURE__*/ $7653e93bf7da1948$var$_react.default.createElement($7653e93bf7da1948$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $7653e93bf7da1948$var$_success2.default
    }, props));
$7653e93bf7da1948$var$SuccessIcon.Name = 'SuccessIconMigration';
var $7653e93bf7da1948$var$_default = module.exports.default = $7653e93bf7da1948$var$SuccessIcon;

});

parcelRegister("fya6v", function(module, exports) {

$parcel$export(module.exports, "GIC_VARIANTS", () => $778d15254cf65a27$export$409069fd677aa1c3);
const $778d15254cf65a27$export$409069fd677aa1c3 = {
    DEFAULT: 'default',
    MINI: 'mini'
};

});

parcelRegister("eGLQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d36addc4343e3e14$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d36addc4343e3e14$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButton: {
        "id": "issue-create.common.footer.create-button",
        "defaultMessage": "Create"
    },
    createButtonInMiniView: {
        "id": "issue-create.common.footer.create-button-in-mini-view",
        "defaultMessage": "Create"
    },
    cancelButton: {
        "id": "issue-create.common.footer.cancel-button",
        "defaultMessage": "Cancel"
    },
    createAnother: {
        "id": "issue-create.common.footer.create-another-fade",
        "defaultMessage": "Create another"
    },
    copyToNextIssue: {
        "id": "issue-create.common.footer.copy-to-next-issue",
        "defaultMessage": "Copy to next issue"
    },
    copyToNextIssueIssueTermRefresh: {
        "id": "issue-create.common.footer.copy-to-next-issue-issue-term-refresh",
        "defaultMessage": "Copy to next work item"
    },
    issuesCreatedLink: {
        "id": "issue-create.common.footer.issues-created-link",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} created"
    },
    issuesCreatedLinkIssueTermRefresh: {
        "id": "issue-create.common.footer.issues-created-link-issue-term-refresh",
        "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}} created"
    },
    createDropdownOptionCreateAnother: {
        "id": "issue-create.common.footer.create-dropdown-option-create-another",
        "defaultMessage": "Create and start another"
    },
    createDropdownOptionCopy: {
        "id": "issue-create.common.footer.create-dropdown-option-copy",
        "defaultMessage": "Create and copy"
    },
    toggleOnTooltip: {
        "id": "issue-create.common.footer.toggle-on-tooltip",
        "defaultMessage": "Toggle off to finish creating issues."
    },
    toggleOnTooltipIssueTermRefresh: {
        "id": "issue-create.common.footer.toggle-on-tooltip-issue-term-refresh",
        "defaultMessage": "Toggle off to finish"
    },
    toggleOffTooltip: {
        "id": "issue-create.common.footer.toggle-off-tooltip",
        "defaultMessage": "After selecting {createButton}, immediately start a new issue with these details and fields."
    },
    toggleOffTooltipIssueTermRefresh: {
        "id": "issue-create.common.footer.toggle-off-tooltip-issue-term-refresh",
        "defaultMessage": "After selecting {createButton}, immediately start a new work item with these details and fields."
    }
});

});


parcelRegister("bMoTh", function(module, exports) {

$parcel$export(module.exports, "useMinimizableModalWrapperProps", () => $841dc183f56b8336$export$48c73e38324bf86b);
$parcel$export(module.exports, "MinimizableModalWrapperPropsProvider", () => $841dc183f56b8336$export$a81052d98ff4e3f6);

var $5uXOq = parcelRequire("5uXOq");
// Need to use this context to prevent re-render flashes in the modal wrapper
const $841dc183f56b8336$var$MinimizableModalWrapperPropsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $841dc183f56b8336$export$48c73e38324bf86b = ()=>{
    const context = (0, $5uXOq.useContext)($841dc183f56b8336$var$MinimizableModalWrapperPropsContext);
    if (context === undefined || context === null) throw new Error('No provider for useMinimizableModalWrapperProps');
    return context;
};
const $841dc183f56b8336$export$a81052d98ff4e3f6 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($841dc183f56b8336$var$MinimizableModalWrapperPropsContext.Provider, {
        value: rest
    }, children);

});

parcelRegister("jWbdK", function(module, exports) {

$parcel$export(module.exports, "MinimizableFullscreen", () => $c959effeaa72bfea$export$b31191b6904db55b);

var $5uXOq = parcelRequire("5uXOq");

var $fVPqx = parcelRequire("fVPqx");

var $5rzqz = parcelRequire("5rzqz");

var $fya6v = parcelRequire("fya6v");

var $8LWdH = parcelRequire("8LWdH");

var $bMoTh = parcelRequire("bMoTh");
const $c959effeaa72bfea$export$b31191b6904db55b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    const [{ containerStyle: containerStyle }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVPqx.Fullscreen), {
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVPqx.FullscreenBody), {
        containerStyle: containerStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LWdH.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fya6v.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        containerStyle: containerStyle,
        showCancelButton: true,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    })));
});

});

parcelRegister("dDDBO", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalMini", () => $fed0bfa878c145d1$export$c752bd88450266e0);

var $5uXOq = parcelRequire("5uXOq");

var $ixNeq = parcelRequire("ixNeq");

var $2vSU6 = parcelRequire("2vSU6");

var $6paOF = parcelRequire("6paOF");

var $dVZve = parcelRequire("dVZve");

var $5rzqz = parcelRequire("5rzqz");

var $6k7U1 = parcelRequire("6k7U1");

var $dAfqg = parcelRequire("dAfqg");

var $cn7wb = parcelRequire("cn7wb");

var $fya6v = parcelRequire("fya6v");

var $8LWdH = parcelRequire("8LWdH");

var $hifTJ = parcelRequire("hifTJ");

var $fjI6w = parcelRequire("fjI6w");

var $bMoTh = parcelRequire("bMoTh");

var $d3Crn = parcelRequire("d3Crn");
const $fed0bfa878c145d1$export$c752bd88450266e0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, summaryValue: summaryValue, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, selectedIssueType: selectedIssueType, projectType: projectType, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    const issueTypeRef = (0, $5uXOq.useRef)(selectedIssueType);
    const { parseSummaryValue: parseSummaryValue } = (0, $fjI6w.useParseSummaryValue)();
    const [shouldRenderMiniModalSpotlight, setShouldRenderMiniModalSpotlight] = (0, $5uXOq.useState)(false);
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight, triggerPointKey: triggerPointKey }, { dismissModalSpotlight: dismissModalSpotlight }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $ixNeq.useUserTraits)();
    const fetchUserTraits = (0, $ixNeq.useFetchUserTraitsOld)();
    const setUserTraitsIfNotAvailable = (0, $5uXOq.useCallback)(async ()=>{
        const newTraits = await fetchUserTraits();
        // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
        if (newTraits !== false) setUserTraits(newTraits);
    }, [
        fetchUserTraits,
        setUserTraits
    ]);
    const { updateIsDiscoPushComplete: updateIsDiscoPushComplete } = (0, $cn7wb.usePersistentIssueCreateModalViewResource)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const markMiniModalAsSeen = (0, $5uXOq.useCallback)(()=>{
        try {
            const shouldDismiss = (0, $6k7U1.isPartOfDiscoverabilityTriggers)(triggerPointKey) && projectContext?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
            if (shouldDismiss) {
                updateIsDiscoPushComplete(true);
                dismissModalSpotlight();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'setMiniModalSpotlightPreference',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        dismissModalSpotlight,
        triggerPointKey,
        updateIsDiscoPushComplete,
        projectContext?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            markMiniModalAsSeen();
        }, [
        markMiniModalAsSeen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssueType) issueTypeRef.current = selectedIssueType;
    }, [
        selectedIssueType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) setUserTraitsIfNotAvailable();
        else {
            const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
            const aWeekAgo = new Date(Date.now() - 604800000);
            let isNewUser = false;
            if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
            setShouldRenderMiniModalSpotlight(!!shouldShowMiniModalSpotlight && !isNewUser);
        }
    }, [
        userTraits,
        shouldShowMiniModalSpotlight,
        setUserTraitsIfNotAvailable
    ]);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVZve.Mini), {
        ref: ref,
        ...rest
    }, shouldRenderMiniModalSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3Crn.SpotlightContainer), {
        shouldShowSpotlight: shouldRenderMiniModalSpotlight,
        onCloseSpotlight: markMiniModalAsSeen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hifTJ.MiniHeader), {
        title: parseSummaryValue(summaryValue, issueTypeRef.current?.label),
        isItalic: !summaryValue,
        iconUrl: issueTypeRef.current?.iconUrl,
        showHeaderIcon: projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT),
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVZve.MiniBody), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LWdH.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fya6v.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle
    })));
});

});
parcelRegister("hifTJ", function(module, exports) {

$parcel$export(module.exports, "MiniHeader", () => $725c03a0b529e1ca$export$1d38987b2afcba7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jjlQu = parcelRequire("jjlQu");

var $8XUAb = parcelRequire("8XUAb");

var $bSvOl = parcelRequire("bSvOl");

var $dCm1o = parcelRequire("dCm1o");

var $6s1PB = parcelRequire("6s1PB");
const $725c03a0b529e1ca$var$renderIcon = (iconUrl)=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "issue-create.common.ui.minimizable-modal-mini-header.icon-container",
        xcss: $725c03a0b529e1ca$var$containerStylesWithVR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        width: 16,
        url: iconUrl
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($725c03a0b529e1ca$var$IconContainer, {
        "data-testid": "issue-create.common.ui.minimizable-modal-mini-header.icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        width: 16,
        url: iconUrl
    }));
};
const $725c03a0b529e1ca$export$1d38987b2afcba7e = ({ title: title, iconUrl: iconUrl, isItalic: isItalic, showHeaderIcon: showHeaderIcon, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSvOl.MiniHeader), {
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    }, showHeaderIcon && iconUrl && $725c03a0b529e1ca$var$renderIcon(iconUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($725c03a0b529e1ca$var$MinimizableModalTitle, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "minimizable-modal.ui.modal-container-mini-header.mini-header",
        // @ts-expect-error - TS2322 - Type '{ children: string; "data-testid": string; isItalic: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<WithOptionalTheme<{ children?: ReactNode; }, any>, any>, any, any>> & Readonly<...>'.
        isItalic: isItalic
    }, (0, $6s1PB.expVal)('jira_in_product_video_pilot_v1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XUAb.CreateWorkVideoEducationModalTriggerButton), null)) : title));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $725c03a0b529e1ca$var$MinimizableModalTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $bSvOl.ModalTitle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _ca0qidpf _u5f3ftgi _n3tdidpf _19bvftgi _1reo15vq _18m915vq _1e0ccj1k _syaz1fxt _1yyjcs5v _sudp1e54 _o5724jg8 _1bto4jg8",
            __cmplp.className
        ])
    });
});
const $725c03a0b529e1ca$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $725c03a0b529e1ca$var$containerStylesWithVR = (0, $8CUq3.xcss)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: 'space.050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            /**
       * Disabling dragging so drags happen on the parent instead of this icon.
       */ draggable: false,
            "data-vc": "common-components-async-icon"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isBroken: false
        }, this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        }, this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
});
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fjI6w", function(module, exports) {

$parcel$export(module.exports, "useParseSummaryValue", () => $8e71caad01a577e6$export$f753c33a187faf7c);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4Ju2T = parcelRequire("4Ju2T");
const $8e71caad01a577e6$export$f753c33a187faf7c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // TODO: remove undefined prop type when cleaning up restore-mini-view-summary_y0gl1
    const parseSummaryValue = (summaryValue, issueType)=>{
        if (summaryValue === null) return issueType ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4Ju2T.default).noSummaryWithIssueTypeIssueTermRefresh : (0, $4Ju2T.default).noSummaryWithIssueType, {
            issueType: issueType
        }) : '';
        if (summaryValue) return summaryValue;
        return issueType ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4Ju2T.default).noSummaryWithIssueTypeIssueTermRefresh : (0, $4Ju2T.default).noSummaryWithIssueType, {
            issueType: issueType
        }) : formatMessage((0, $4Ju2T.default).noSummary);
    };
    return {
        parseSummaryValue: parseSummaryValue
    };
};

});

parcelRegister("d3Crn", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $f05b3fdf39d8df72$export$d0f55839b708c0a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5ujeO = parcelRequire("5ujeO");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4Ju2T = parcelRequire("4Ju2T");
const $f05b3fdf39d8df72$export$d0f55839b708c0a0 = ({ shouldShowSpotlight: shouldShowSpotlight, onCloseSpotlight: onCloseSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f05b3fdf39d8df72$var$SpotlightPopoverWrapper, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-mini.modal-spotlight.wrapper"
    }, shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        heading: formatMessage((0, $4Ju2T.default).miniModalSpotlightHeading),
        width: 290,
        actions: [
            {
                onClick: onCloseSpotlight,
                text: formatMessage((0, $4Ju2T.default).miniModalSpotlightActionMessage)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $4Ju2T.default).miniModalSpotlightMessage,
        values: {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null))
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f05b3fdf39d8df72$var$SpotlightPopoverWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltv1vvt",
            __cmplp.className
        ])
    });
});

});


parcelRegister("l2y6R", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalMinimized", () => $495c812cfd89d501$export$72c64a34c513900);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $jjlQu = parcelRequire("jjlQu");

var $2vSU6 = parcelRequire("2vSU6");

var $4TqWb = parcelRequire("4TqWb");

var $fjI6w = parcelRequire("fjI6w");

var $bMoTh = parcelRequire("bMoTh");
const $495c812cfd89d501$export$72c64a34c513900 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, summaryValue: summaryValue }, ref)=>{
    const { parseSummaryValue: parseSummaryValue } = (0, $fjI6w.useParseSummaryValue)();
    const { selectedIssueType: selectedIssueType, projectType: projectType } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    return(// @ts-expect-error - TS2322 - Type '((instance: MinimizableModalMinimizedProps | null) => void) | MutableRefObject<MinimizableModalMinimizedProps | null> | null' is not assignable to type '((string | ((instance: Component<ThemedOuterStyledProps<DiffBetween<{ className: any; }, Omit<HTMLElement & RefAttributes<MinimizedContainerProps>, "theme"> & { ...; }>, any>, any, any> | null) => void) | RefObject<...>) & (((instance: MinimizedContainerProps | null) => void) | RefObject<...>)) | null | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($495c812cfd89d501$var$StyledMinimized, {
        ref: ref,
        isItalic: !summaryValue,
        transitionClass: className
    }, selectedIssueType?.iconUrl && projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($495c812cfd89d501$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($495c812cfd89d501$var$IconContainer, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-minimized.issue-type-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        width: 16,
        url: selectedIssueType?.iconUrl
    })), parseSummaryValue(summaryValue, selectedIssueType?.label)) : parseSummaryValue(summaryValue, selectedIssueType?.label)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $495c812cfd89d501$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi _1e0c116y",
            __cmplp.className
        ])
    });
});
const $495c812cfd89d501$var$TitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $495c812cfd89d501$var$StyledMinimized = /*#__PURE__*/ (0, $47bDC.default)((0, $4TqWb.Minimized)).attrs({
    // @ts-expect-error - TS2339 - Property 'transitionClass' does not exist on type 'ThemedStyledProps<HTMLElement & RefAttributes<MinimizedContainerProps>, any>'.
    className: (props)=>props.transitionClass
}).withConfig({
    componentId: "sc-1pohfgc-0"
})``;

});

parcelRegister("31ArW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1b47c4e9711ac8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $45Cy1 = parcelRequire("45Cy1");

var $bSvOl = parcelRequire("bSvOl");

var $5rzqz = parcelRequire("5rzqz");

var $c0dQj = parcelRequire("c0dQj");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $6gjIc = parcelRequire("6gjIc");

var $cWvpX = parcelRequire("cWvpX");

var $akFPq = parcelRequire("akFPq");

var $gYiXv = parcelRequire("gYiXv");

var $1B7A8 = parcelRequire("1B7A8");

var $6NEf0 = parcelRequire("6NEf0");
const $bd1b47c4e9711ac8$export$a9dbcd01d58b1c3b = ({ shouldShowChangerSpotlight: shouldShowChangerSpotlight, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, watchersConfigurations: watchersConfigurations })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [{ dataFetchError: dataFetchError, selectedProject: selectedProject, selectedIssueType: selectedIssueType }] = (0, $45Cy1.useFormContext)();
    const issueType = selectedIssueType?.label;
    let titleMsg = issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $1B7A8.default).titleIssueTerminologyRefreshM4 : (0, $1B7A8.default).title;
    if (isSubTaskCreationOpen) titleMsg = (0, $1B7A8.default).subtaskTitle;
    else if (isCreateLinkedIssue) titleMsg = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1B7A8.default).createLinkedIssueDialogTitleIssueTermRefresh : (0, $1B7A8.default).createLinkedIssueDialogTitle;
    const shouldShowChangerSpotlightBoolean = !!shouldShowChangerSpotlight;
    const ViewChangerContainer = shouldShowChangerSpotlightBoolean ? (0, $6NEf0.SpotlightContainer) : undefined;
    const shouldDisableMeatBallActions = dataFetchError !== null || selectedProject === null;
    const meatBallMenu = !(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akFPq.HeaderDropdown), {
        isDisabled: shouldDisableMeatBallActions,
        watchersConfigurations: watchersConfigurations
    }) : null;
    return(// eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSvOl.ModalHeader), {
        ViewChangerContainer: ViewChangerContainer,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper,
        meatBallMenu: meatBallMenu
    }, title !== null && title !== '' ? title : formatMessage(titleMsg, {
        issueType: issueType
    }))));
};
const $bd1b47c4e9711ac8$var$OldHeader = ({ shouldDisableActions: shouldDisableActions, watchersConfigurations: watchersConfigurations })=>{
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }] = (0, $45Cy1.useFormContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const issueType = selectedIssueType?.label;
    let titleMsg = issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $1B7A8.default).titleIssueTerminologyRefreshM4 : (0, $1B7A8.default).title;
    const shouldDisableHeaderDropdown = ()=>Boolean(shouldDisableActions || selectedProject === null);
    if (isSubTaskCreationOpen) titleMsg = (0, $1B7A8.default).subtaskTitle;
    else if (isCreateLinkedIssue) titleMsg = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1B7A8.default).createLinkedIssueDialogTitleIssueTermRefresh : (0, $1B7A8.default).createLinkedIssueDialogTitle;
    return(// eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, title !== null && title !== '' ? title : formatMessage(titleMsg, {
        issueType: issueType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd1b47c4e9711ac8$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWvpX.default), {
        configs: watchersConfigurations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bd1b47c4e9711ac8$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYiXv.default), {
        isDisabled: shouldDisableHeaderDropdown()
    }))))));
};
const $bd1b47c4e9711ac8$export$8b251419efc915eb = (props)=>{
    const isGICPositioningEnabled = (0, $6gjIc.useIsGICPositioningEnabled)();
    if (isGICPositioningEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd1b47c4e9711ac8$export$a9dbcd01d58b1c3b, {
        shouldShowChangerSpotlight: props.shouldShowChangerSpotlight,
        dismissModalEntryPointWrapper: props.dismissModalEntryPointWrapper,
        watchersConfigurations: props.watchersConfigurations
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd1b47c4e9711ac8$var$OldHeader, props);
};
var $bd1b47c4e9711ac8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bd1b47c4e9711ac8$export$8b251419efc915eb;
const $bd1b47c4e9711ac8$var$ActionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd1b47c4e9711ac8$var$dropdownContainerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("gYiXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f50c13c24c254b34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $koVbs = parcelRequire("koVbs");

var $c7ZNt = parcelRequire("c7ZNt");

var $45Cy1 = parcelRequire("45Cy1");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $fOw0O = parcelRequire("fOw0O");
const $f50c13c24c254b34$var$HeaderDropdown = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { isDisabled: isDisabled = false } = props;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, $45Cy1.useFormContext)();
    const showConfigureFieldsModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleConfigureFieldsModalVisibility(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'configureFields', {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleFindFieldsModalVisibility(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'findYourField', {
            projectType: selectedProject ? (0, $c7ZNt.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
    // @ts-expect-error - TS7006 - Parameter 'attributes' implicitly has an 'any' type.
    const onOpenChange = (attributes)=>{
        if (attributes.isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'meatballMenu');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...dropdownProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    spacing: "spacious",
                    label: "more"
                }),
                appearance: "subtle",
                ref: triggerRef,
                isDisabled: isDisabled
            }),
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: showConfigureFieldsModal
    }, formatMessage((0, $fOw0O.default).showFields)), showFindFieldOption() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: showFindFieldModal
    }, formatMessage((0, $fOw0O.default).findField))));
};
var $f50c13c24c254b34$export$2e2bcd8739ae039 = $f50c13c24c254b34$var$HeaderDropdown;

});
parcelRegister("fOw0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9830fe1e229697$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c9830fe1e229697$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showFields: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.show-fields",
        "defaultMessage": "Show fields"
    },
    findField: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.find-field",
        "defaultMessage": "Find your field"
    }
});

});


parcelRegister("1B7A8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6269d8953ea86b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6269d8953ea86b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title",
        "defaultMessage": "Create"
    },
    titleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title-issue-terminology-refresh-m4",
        "defaultMessage": "Create {issueType}"
    },
    subtaskTitle: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.subtask-title",
        "defaultMessage": "Create subtask"
    },
    createLinkedIssueDialogTitle: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title",
        "defaultMessage": "Create linked issue"
    },
    changerButtonsDisabledForgeFields: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields",
        "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
    },
    createLinkedIssueDialogTitleIssueTermRefresh: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title-issue-term-refresh",
        "defaultMessage": "Create linked work item"
    },
    changerButtonsDisabledForgeFieldsIssueTermRefresh: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields-issue-term-refresh",
        "defaultMessage": "Some fields in this project and work type don\u2019t allow resizing or minimizing"
    }
});

});

parcelRegister("6NEf0", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $94f1f60818fb1297$export$d0f55839b708c0a0);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $5ujeO = parcelRequire("5ujeO");
var $k6T4f = parcelRequire("k6T4f");

var $k5uoT = parcelRequire("k5uoT");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4Ju2T = parcelRequire("4Ju2T");
const $94f1f60818fb1297$export$d0f55839b708c0a0 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    /**
   * Atlaskit Popup was not used due to technical limitations of the component in this particular use case.
   * onClose is triggered when the popup is controlled by focussing, which causes the popup to immediately close.
   */ return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94f1f60818fb1297$var$SpotlightContainerWrapper, {
        "data-testid": "issue-create.ui.modal.header.spotlight-container.wrapper"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94f1f60818fb1297$var$SpotlightPopoverWrapper, {
        zIndex: (0, $k5uoT.layers).spotlight()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        width: 275
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4Ju2T.default).resizeSpotlightMessageIssueTermRefresh : (0, $4Ju2T.default).resizeSpotlightMessage)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94f1f60818fb1297$var$SpotlightPopoverWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ovmtxf-0"
})({
    position: 'absolute',
    top: 'calc(100% + 5px)',
    // Size of the border of the SpotlightPulse + 3px from design
    right: "var(--ds-space-negative-025, -2px)" // Size of the border of the SpotlightPulse
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ zIndex: zIndex })=>zIndex && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        zIndex: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex
    }));
// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94f1f60818fb1297$var$SpotlightContainerWrapper = /*#__PURE__*/ (0, $47bDC.default)((0, $k6T4f.Pulse)).withConfig({
    componentId: "ovmtxf-1"
})({
    position: 'relative'
});

});


parcelRegister("2NKLM", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalModal", () => $325627811178cea7$export$8b041304f822d4d4);

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");

var $iigfj = parcelRequire("iigfj");

var $gLdtQ = parcelRequire("gLdtQ");

var $45Cy1 = parcelRequire("45Cy1");

var $iUFy5 = parcelRequire("iUFy5");

var $6BEt4 = parcelRequire("6BEt4");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8LWdH = parcelRequire("8LWdH");

var $bMoTh = parcelRequire("bMoTh");

var $31ArW = parcelRequire("31ArW");
const $325627811178cea7$var$HeaderComponent = ()=>{
    const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, watchersConfigurations: watchersConfigurations } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ArW.default), {
        shouldDisableActions: false,
        shouldShowChangerSpotlight: shouldShowChangerSpotlight,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper,
        watchersConfigurations: watchersConfigurations
    });
};
const $325627811178cea7$var$ModalBodyNext = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: (0, $gLdtQ.ISSUE_CREATE_MODAL_BODY_SELECTOR),
        ref: ref,
        ...props
    })));
const $325627811178cea7$var$FooterComponent = ()=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    const shouldDisableSubmit = getShouldDisableSubmit();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LWdH.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: shouldDisableSubmit,
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showIssuesCreated: showIssuesCreated,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    });
};
const $325627811178cea7$export$8b041304f822d4d4 = ({ 'data-testid': dataTestId, children: children })=>{
    const [{ isFormDirty: isFormDirty, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $45Cy1.useFormContext)();
    const uiModificationsStatus = (0, $iigfj.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { setView: setView, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, onClose: onClose } = (0, $iUFy5.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onModalCloseOverride = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const isEscapePress = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.key === 'Escape' || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.key === 'Esc' || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.keyCode === 27;
        const isBlanketClick = !isEscapePress; // Assume it is a blanket click if it isn't an esc event
        if (isBlanketClick && (!hasFinishedLoading || uiModificationsStatus !== 'disabled')) return;
        if (isBlanketClick || isFormDirty) {
            setView('mini');
            const dockAnalyticsEvent = createAnalyticsEvent({
                action: 'docked',
                actionSubject: 'modalDialog'
            });
            (0, $8zOmE.fireUIAnalytics)(dockAnalyticsEvent, 'modalDialog docked', {
                isBlanketClick: isBlanketClick
            });
        } else onClose?.(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        hasFinishedLoading,
        isFormDirty,
        onClose,
        setView,
        uiModificationsStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6BEt4.Modal), {
        "data-testid": dataTestId,
        components: {
            Header: $325627811178cea7$var$HeaderComponent,
            Footer: $325627811178cea7$var$FooterComponent,
            // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<ModalBodyProps> | undefined'.
            Body: $325627811178cea7$var$ModalBodyNext
        },
        onClose: !shouldDisableViewChangerButtons ? onModalCloseOverride : undefined,
        shouldCloseOnOverlayClick: !shouldDisableViewChangerButtons
    }, children);
};

});

parcelRegister("7qb4M", function(module, exports) {

$parcel$export(module.exports, "useSetSummary", () => $3ce05a20d11d1674$export$2e036b125a865e82);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");
const $3ce05a20d11d1674$export$2e036b125a865e82 = (initialSummaryValue)=>{
    const [summaryValue, setSummary] = (0, $5uXOq.useState)(initialSummaryValue || initialSummaryValue === null ? initialSummaryValue : '');
    const hasSetInitialValue = (0, $5uXOq.useRef)(false);
    if (!hasSetInitialValue.current && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(initialSummaryValue)) {
        hasSetInitialValue.current = true;
        setSummary(initialSummaryValue);
    }
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    (0, $5uXOq.useEffect)(()=>{
        subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, async (data)=>{
            if (data.fieldId === 'summary') setSummary(data.value.toString());
        });
        subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, async ()=>{
            setSummary('');
        });
    }, [
        subscribe,
        setSummary
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async ()=>{
            setSummary('');
        }), [
        subscribe,
        setSummary
    ]);
    return summaryValue;
};

});

parcelRegister("6mZXS", function(module, exports) {

$parcel$export(module.exports, "useViewChangerDisabler", () => $9363df13396c3799$export$db29ac8670837568);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $jrwZp = parcelRequire("jrwZp");
var $iigfj = parcelRequire("iigfj");

var $45Cy1 = parcelRequire("45Cy1");

var $iUFy5 = parcelRequire("iUFy5");

var $5rzqz = parcelRequire("5rzqz");

var $bMoTh = parcelRequire("bMoTh");

var $f5aZe = parcelRequire("f5aZe");
const $9363df13396c3799$export$db29ac8670837568 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Global opt-out of minimizable modal
    const [{ disableMinimizableModal: disableMinimizableModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { isNestedModal: isNestedModal, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons, setView: setView, view: view } = (0, $iUFy5.useMinimizableModal)();
    const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $45Cy1.useFormContext)();
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const uiModificationsStatus = (0, $iigfj.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { setShouldRestore: setShouldRestore } = (0, $bMoTh.useMinimizableModalWrapperProps)();
    const disableViewChangerButtonsHandler = (0, $5uXOq.useCallback)((disableViewChangerButtons, customDisabledViewChangerButtonsMessage)=>{
        setShouldDisableViewChangerButtons(disableViewChangerButtons, customDisabledViewChangerButtonsMessage);
        setShouldRestore?.(!disableViewChangerButtons);
    }, [
        setShouldDisableViewChangerButtons,
        setShouldRestore
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (disableMinimizableModal || isNestedModal) disableViewChangerButtonsHandler(true);
        else if (uiModificationsStatus === 'enabled' || adjustmentsAreEnabled) disableViewChangerButtonsHandler(true, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $f5aZe.default).changerButtonsDisabledForgeFieldsIssueTermRefresh : (0, $f5aZe.default).changerButtonsDisabledForgeFields));
        else disableViewChangerButtonsHandler(false);
    }, [
        adjustmentsAreEnabled,
        disableMinimizableModal,
        disableViewChangerButtonsHandler,
        formatMessage,
        isNestedModal,
        setShouldDisableViewChangerButtons,
        uiModificationsStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /*
              force setView to modal view is disabled for the full screen since there will be no transitions allowed from the view.
              this will help us enable the UIM flow in the full screen view as well.
          */ if (view === 'fullscreen') return;
        if (shouldDisableViewChangerButtons) setView('modal', true);
    }, [
        setView,
        view,
        shouldDisableViewChangerButtons
    ]);
};

});
parcelRegister("f5aZe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f219cb02032feb7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f219cb02032feb7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changerButtonsDisabledForgeFields: {
        "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields",
        "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
    },
    changerButtonsDisabledForgeFieldsIssueTermRefresh: {
        "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields-issue-term-refresh",
        "defaultMessage": "Some fields in this project and work type don\u2019t allow resizing or minimizing"
    }
});

});



parcelRegister("7beZ9", function(module, exports) {

$parcel$export(module.exports, "NavigateWithoutRestorePrompt", () => $c308ab93c9dea3af$export$f92d4f53cfa676ca);

var $5uXOq = parcelRequire("5uXOq");

var $45Cy1 = parcelRequire("45Cy1");

var $lVJAU = parcelRequire("lVJAU");

var $9AReS = parcelRequire("9AReS");

var $9U8fV = parcelRequire("9U8fV");
const $c308ab93c9dea3af$export$f92d4f53cfa676ca = ({ setShouldRestore: setShouldRestore, isNavigationDiscardFeatureEnabled: isNavigationDiscardFeatureEnabled = false })=>{
    const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, $9U8fV.useNavigationDiscardChanges)();
    const [{ isFormDirty: isFormDirty }] = (0, $45Cy1.useFormContext)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onConfirmHandler = (0, $5uXOq.useCallback)(()=>{
        setShouldRestore && setShouldRestore(false);
    }, [
        setShouldRestore
    ]);
    const onCancelHandler = (0, $5uXOq.useCallback)(()=>{
        setDeferredNavigationLink('');
    }, [
        setDeferredNavigationLink
    ]);
    // If the form is then we navigate immediately without showing the prompt
    (0, $5uXOq.useEffect)(()=>{
        if (deferredNavigationLink && !isFormDirty) {
            setShouldRestore && setShouldRestore(false);
            push(deferredNavigationLink);
            setDeferredNavigationLink('');
        }
    }, [
        deferredNavigationLink,
        isFormDirty,
        push,
        setDeferredNavigationLink,
        setShouldRestore
    ]);
    if (!isNavigationDiscardFeatureEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AReS.NavigationDiscardChangesPrompt), {
        navigateLink: isFormDirty ? deferredNavigationLink : '',
        onConfirm: onConfirmHandler,
        onCancel: onCancelHandler
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});

parcelRegister("42ZoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0ad2d4a2f759b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2i4s = parcelRequire("c2i4s");


var $6s1PB = parcelRequire("6s1PB");

var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $bnNZI = parcelRequire("bnNZI");

var $9WKj5 = parcelRequire("9WKj5");


var $isrQ5 = parcelRequire("isrQ5");
const $2c0ad2d4a2f759b7$export$93bd4963a1d00fd5 = (props)=>{
    const { flagKey: flagKey, id: id, issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, successFlagParams: successFlagParams } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const issueType = issueList[0].issueType;
    const getDynamicFlagType = ()=>{
        if (successFlagParams) {
            const { isRankable: isRankable, isWorkMode: isWorkMode, canManageSprints: canManageSprints, boardType: boardType } = successFlagParams;
            if (isRankable && isWorkMode) {
                if (boardType === (0, $976eff6d67d3515b$export$4498412e32a31fb6) && canManageSprints) return 0, $797f94a2e49d6094$export$407f3b8bfd90ad8d;
                if (boardType === (0, $976eff6d67d3515b$export$b4e9cdb19cfa0abb)) return 0, $797f94a2e49d6094$export$256b368007db542a;
            }
        }
        return 0, $797f94a2e49d6094$export$858ff9c1b12e1d84;
    };
    const getDefaultFlagTitle = ()=>{
        const areMultipleIssuesCreated = issueList.length > 1;
        const successTitle = ()=>{
            if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $isrQ5.default).createSuccessFlagTitleIssueTerminologyRefreshM4;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).createSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).createSuccessFlagTitle;
        };
        return areMultipleIssuesCreated ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueList.length
        }) : formatMessage(successTitle(), {
            issueKey: issueList[0].issueKey,
            issueType: issueType
        });
    };
    const FlagConfigs = {
        Default: ()=>({
                flagTitle: getDefaultFlagTitle(),
                flagDescription: '',
                flagActions: (0, $9WKj5.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        IssuesNotInSprint: (issuesWithNoSprint, issuesExcludingEpics, sprints)=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $9WKj5.getNewScrumIssuesWithNoSprintsActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    issuesWithNoSprint: issuesWithNoSprint,
                    sprints: sprints
                })
            }),
        IssuesNotInSprintMoreThanTwoActiveSprints: (issuesWithNoSprint, issuesExcludingEpics)=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $9WKj5.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeNoSprint: ()=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription),
                flagActions: (0, $9WKj5.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenScrumIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).scrumCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $9WKj5.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            }),
        IssuesInBacklog: (issues)=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).issueCreatedInBacklogSuccessFlagDescription, {
                    issueKey: issues[0].issueKey,
                    issueCount: issues.length
                }),
                flagActions: (0, $9WKj5.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeInBacklog: ()=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription),
                flagActions: (0, $9WKj5.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenKanbanIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, $isrQ5.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $isrQ5.default).kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, $isrQ5.default).kanbanCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $9WKj5.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            })
    };
    const getFlagContent = ()=>{
        if (successFlagParams) {
            if (getDynamicFlagType() === (0, $797f94a2e49d6094$export$407f3b8bfd90ad8d)) {
                const { issues: issues, isFiltered: isFiltered, invalidIssuesKeys: invalidIssuesKeys, issuesWithNoSprint: issuesWithNoSprint, issuesExcludingEpics: issuesExcludingEpics, sprints: sprints } = successFlagParams;
                if (issuesWithNoSprint.length > 0) {
                    if (issuesWithNoSprint.length === issuesExcludingEpics.length) {
                        if (sprints.length > 2) return FlagConfigs.IssuesNotInSprintMoreThanTwoActiveSprints(issuesWithNoSprint, issuesExcludingEpics);
                        return FlagConfigs.IssuesNotInSprint(issuesWithNoSprint, issuesExcludingEpics, sprints);
                    }
                    return FlagConfigs.MultipleIssuesSomeNoSprint();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenScrumIssues(issues, isFiltered);
            } else if (getDynamicFlagType() === (0, $797f94a2e49d6094$export$256b368007db542a)) {
                const { kanbanIssuesInBacklog: kanbanIssuesInBacklog, invalidIssuesKeys: invalidIssuesKeys, issues: issues, isFiltered: isFiltered } = successFlagParams;
                if (kanbanIssuesInBacklog.length > 0) {
                    if (kanbanIssuesInBacklog.length === issues.length) return FlagConfigs.IssuesInBacklog(issues);
                    return FlagConfigs.MultipleIssuesSomeInBacklog();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenKanbanIssues(issues, isFiltered);
            }
        }
        return FlagConfigs.Default();
    };
    const { flagTitle: flagTitle, flagDescription: flagDescription, flagActions: flagActions } = getFlagContent();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-issue-key": issueList.map((issue)=>issue.issueKey).join(','),
        "data-testid": (0, $797f94a2e49d6094$export$2e4c8b336846b593)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #22A06B)",
            label: "Success"
        }),
        id: (0, $7HGHK.fromFlagId)(id),
        key: flagKey,
        title: flagTitle,
        description: flagDescription,
        actions: flagActions,
        onDismissed: ()=>{
            dismissFlag(id);
        },
        messageId: `issue-create.ui.modal.success-flag.ak-flag.${id}`,
        messageType: "transactional"
    }));
};
const $2c0ad2d4a2f759b7$var$SuccessFlagWithContext = (props)=>{
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bnNZI.AddToSprintActionStatesContainer), {
        scope: id.valueOf(),
        key: id.valueOf()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c0ad2d4a2f759b7$export$93bd4963a1d00fd5, props));
};
var $2c0ad2d4a2f759b7$export$2e2bcd8739ae039 = $2c0ad2d4a2f759b7$var$SuccessFlagWithContext;

});
// Backend types
const $976eff6d67d3515b$export$9a958daafd9a03ed = 'agility-board';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $976eff6d67d3515b$var$CORE_BOARD = 'core-board';
const $976eff6d67d3515b$export$b4e9cdb19cfa0abb = 'kanban';
const $976eff6d67d3515b$export$4498412e32a31fb6 = 'scrum';

parcelRegister("bnNZI", function(module, exports) {

$parcel$export(module.exports, "AddToSprintActionStatesContainer", () => $69e54ec8a90ab75a$export$4ae31d89b87a513);
$parcel$export(module.exports, "useAddToSprintFlagActionStateController", () => $69e54ec8a90ab75a$export$dc7fffa2c4559368);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $69e54ec8a90ab75a$var$initialState = {
    addToSprintCTAsEnabled: true
};
const $69e54ec8a90ab75a$var$actions = {
    disableOtherAddToSprintCTAs: ()=>({ setState: setState })=>{
            setState({
                addToSprintCTAsEnabled: false
            });
        }
};
const $69e54ec8a90ab75a$var$Store = (0, $iXqE5.createStore)({
    initialState: $69e54ec8a90ab75a$var$initialState,
    actions: $69e54ec8a90ab75a$var$actions,
    name: 'SuccessFlagAddToSprintActionStateController'
});
const $69e54ec8a90ab75a$export$4ae31d89b87a513 = (0, $gg7kZ.createContainer)($69e54ec8a90ab75a$var$Store);
const $69e54ec8a90ab75a$export$dc7fffa2c4559368 = (0, $3sQ5x.createHook)($69e54ec8a90ab75a$var$Store);

});

parcelRegister("9WKj5", function(module, exports) {

$parcel$export(module.exports, "getDefaultFlagActions", () => $dbbf75d458151c43$export$6de10317e135f24);
$parcel$export(module.exports, "getNewScrumIssuesWithNoSprintsActions", () => $dbbf75d458151c43$export$882355824d3fc905);
$parcel$export(module.exports, "getHiddenIssuesActions", () => $dbbf75d458151c43$export$f5c2849658ba2a03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6paOF = parcelRequire("6paOF");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $gEaAu = parcelRequire("gEaAu");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bnNZI = parcelRequire("bnNZI");


var $fHXGa = parcelRequire("fHXGa");
const $dbbf75d458151c43$export$f2011725fe81878a = (issueList, issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireViewIssueAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$71ce489a3b20fc93), {
            isNewGIC: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const issueType = issueList[0].issueType;
    const getContent = ()=>{
        if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $fHXGa.default).viewIssueCtaIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fHXGa.default).viewIssueCtaIssueTermRefresh : (0, $fHXGa.default).viewIssueCta;
    };
    return {
        content: formatMessage(getContent(), {
            issueCount: issueList.length,
            issueType: issueType
        }),
        href: issueDiscoveryUrl,
        onClick: fireViewIssueAnalyticsEvent
    };
};
const $dbbf75d458151c43$var$CopyLinkCta = (issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) await globalThis.navigator.clipboard.writeText(`${globalThis.location.origin}${issueDiscoveryUrl}`);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            await navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
            setCopied(true);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$3a43d61edae693a9)); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        issueDiscoveryUrl
    ]);
    return {
        content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbbf75d458151c43$var$ActionSuccess, null, formatMessage((0, $fHXGa.default).linkCopied)) : formatMessage((0, $fHXGa.default).copyLinkCta),
        onClick: copyToClipboard
    };
};
const $dbbf75d458151c43$var$ClearFiltersCta = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $5uXOq.useState)(false);
    const clearFiltersAction = (0, $5uXOq.useCallback)(()=>{
        (0, $gEaAu.successFlagClearFiltersAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        setIsLoading(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$bc715896f18417a3), {
            isNewGIC: true
        });
        GH.WorkController.clearFilters().done(()=>{
            (0, $gEaAu.successFlagClearFiltersAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $gEaAu.successFlagClearFiltersAction).stop();
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'clearFilters',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    if (isLoading) return {
        content: formatMessage((0, $fHXGa.default).clearFiltersCtaLoading)
    };
    if (isCompleted) return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbbf75d458151c43$var$ActionSuccess, null, formatMessage((0, $fHXGa.default).clearFiltersCtaCompleted))
    };
    return {
        content: formatMessage((0, $fHXGa.default).clearFiltersCta),
        onClick: clearFiltersAction
    };
};
const $dbbf75d458151c43$export$54ce82bbc60a8f6e = (issuesWithNoSprint, totalCreatedIssuesCount, sprint)=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ addToSprintCTAsEnabled: addToSprintCTAsEnabled }, { disableOtherAddToSprintCTAs: disableOtherAddToSprintCTAs }] = (0, $bnNZI.useAddToSprintFlagActionStateController)();
    const addToSprintAction = (0, $5uXOq.useCallback)(()=>{
        (0, $gEaAu.successFlagAddToSprintAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        disableOtherAddToSprintCTAs();
        setIsLoading(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$31bef7c6ffa89efa), {
            isNewGIC: true
        });
        GH.WorkController.addNewIssuesToSprintFromJFE(sprint, issuesWithNoSprint).done(()=>{
            (0, $gEaAu.successFlagAddToSprintAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $gEaAu.successFlagAddToSprintAction).stop();
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'addToSprint',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent,
        sprint,
        issuesWithNoSprint,
        disableOtherAddToSprintCTAs
    ]);
    if (isLoading) return [
        {
            content: formatMessage((0, $fHXGa.default).addIssuesToSprintCtaLoading)
        }
    ];
    if (isCompleted) return [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbbf75d458151c43$var$ActionSuccess, null, formatMessage((0, $fHXGa.default).addIssuesToSprintCtaCompleted))
        }
    ];
    if (addToSprintCTAsEnabled) return [
        {
            content: formatMessage((0, $fHXGa.default).addAllIssuesToSprintCta, {
                sprintName: sprint.name
            }),
            onClick: addToSprintAction
        }
    ];
    return [];
};
const $dbbf75d458151c43$var$getAddToSprintsCtas = (issuesWithNoSprint, issueList, sprints)=>{
    const editableSprints = sprints.filter((sprint)=>sprint.canUpdateSprint);
    const totalCreatedIssuesCount = issueList.length;
    let ctaList = [];
    editableSprints.forEach((sprint)=>{
        ctaList = ctaList.concat($dbbf75d458151c43$export$54ce82bbc60a8f6e(issuesWithNoSprint, totalCreatedIssuesCount, sprint));
    });
    return ctaList;
};
const $dbbf75d458151c43$export$6de10317e135f24 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl })=>[
        $dbbf75d458151c43$export$f2011725fe81878a(issueList, issueDiscoveryUrl),
        $dbbf75d458151c43$var$CopyLinkCta(issueDiscoveryUrl)
    ];
const $dbbf75d458151c43$export$882355824d3fc905 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, issuesWithNoSprint: issuesWithNoSprint, sprints: sprints })=>{
    const ctaList = $dbbf75d458151c43$var$getAddToSprintsCtas(issuesWithNoSprint, issueList, sprints);
    ctaList.push($dbbf75d458151c43$export$f2011725fe81878a(issueList, issueDiscoveryUrl));
    return ctaList;
};
const $dbbf75d458151c43$export$f5c2849658ba2a03 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, isFiltered: isFiltered })=>{
    const ctaList = [
        $dbbf75d458151c43$export$f2011725fe81878a(issueList, issueDiscoveryUrl)
    ];
    if (isFiltered) ctaList.push($dbbf75d458151c43$var$ClearFiltersCta());
    return ctaList;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbbf75d458151c43$var$ActionSuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazy73q",
            __cmplp.className
        ])
    });
});

});
const $2144e1d48c8e9f2b$export$71ce489a3b20fc93 = 'viewIssues';
const $2144e1d48c8e9f2b$export$3a43d61edae693a9 = 'copyLink';
const $2144e1d48c8e9f2b$export$31bef7c6ffa89efa = 'addToSprint';
const $2144e1d48c8e9f2b$export$bc715896f18417a3 = 'clearFilters';

parcelRegister("fHXGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1205559fab8abcd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1205559fab8abcd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewIssueCta: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta",
        "defaultMessage": "View {issueCount, plural, one {issue} other {issues}}"
    },
    copyLinkCta: {
        "id": "issue-create.modal.success-flag.actions.copy-link-cta",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "issue-create.modal.success-flag.actions.link-copied",
        "defaultMessage": "Copied"
    },
    addAllIssuesToSprintCta: {
        "id": "issue-create.modal.success-flag.actions.add-all-issues-to-sprint-cta",
        "defaultMessage": "Add to {sprintName}"
    },
    clearFiltersCta: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta",
        "defaultMessage": "Clear filters"
    },
    clearFiltersCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-loading",
        "defaultMessage": "Clearing..."
    },
    clearFiltersCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-completed",
        "defaultMessage": "Filters cleared"
    },
    addIssuesToSprintCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-loading",
        "defaultMessage": "Adding..."
    },
    addIssuesToSprintCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-completed",
        "defaultMessage": "Added to sprint"
    },
    viewIssueCtaIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-term-refresh",
        "defaultMessage": "View{issueCount, plural, one {} other { work items}}"
    },
    viewIssueCtaIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-terminology-refresh-m4",
        "defaultMessage": "View{issueCount, plural, one { {issueType}} other { work items}}"
    }
});

});


const $797f94a2e49d6094$export$2e4c8b336846b593 = 'jira-issue-create.modal.create-form.success-flag';
const $797f94a2e49d6094$export$407f3b8bfd90ad8d = 'cmp-scrum-flag';
const $797f94a2e49d6094$export$256b368007db542a = 'cmp-kanban-flag';
const $797f94a2e49d6094$export$858ff9c1b12e1d84 = 'default-success-flag';

parcelRegister("isrQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $60639d580c79b6fe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $60639d580c79b6fe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has} other {Your issues have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title",
        "defaultMessage": "Issues added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description",
        "defaultMessage": "Some of your issues weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue was added to a different sprint, it may not be visible} other {If the board has active filters, or the issues were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has been created, but isn't on the board} other {Your issues have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title",
        "defaultMessage": "Issues added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description",
        "defaultMessage": "Your issues have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue wasn't added to the board, it may not be visible} other {If the board has active filters, or the issues weren't added to the board, they may not be visible}}."
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" work item"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# work items}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has} other {Your work items have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description-issue-term-refresh",
        "defaultMessage": "Some of your work items weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item was added to a different sprint, it may not be visible} other {If the board has active filters, or the work items were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has been created, but isn't on the board} other {Your work items have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description-issue-term-refresh",
        "defaultMessage": "Your work items have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item wasn't added to the board, it may not be visible} other {If the board has active filters, or the work items weren't added to the board, they may not be visible}}."
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {issueType} {issueKey}"
    }
});

});


parcelRegister("dXTIs", function(module, exports) {

$parcel$export(module.exports, "getFirstFieldIdWithError", () => $7823f1c3d8b410e7$export$f15841b83bf0d927);
$parcel$export(module.exports, "publishCreatedIssues", () => $7823f1c3d8b410e7$export$d46eb3aee2ce61a5);
$parcel$export(module.exports, "getTabIndexWithError", () => $7823f1c3d8b410e7$export$1d81ee131c803e88);
$parcel$export(module.exports, "getWatchersFlagConfigFromResponse", () => $7823f1c3d8b410e7$export$47ea475ac70a5697);

var $gccSB = parcelRequire("gccSB");

var $4Xk2W = parcelRequire("4Xk2W");

var $dvqhI = parcelRequire("dvqhI");

var $6paOF = parcelRequire("6paOF");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");

var $bGrWH = parcelRequire("bGrWH");

var $5eGnF = parcelRequire("5eGnF");

var $l12V4 = parcelRequire("l12V4");

var $a1SNr = parcelRequire("a1SNr");
const $7823f1c3d8b410e7$export$8d7a103b266a4496 = '/rest/api/3/search';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $7823f1c3d8b410e7$var$issueDataTillNow = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $7823f1c3d8b410e7$var$activePromises = {};
const $7823f1c3d8b410e7$export$f15841b83bf0d927 = ({ fields: fields, emptyRequiredFields: emptyRequiredFields })=>{
    if (emptyRequiredFields) return fields.find((fieldId)=>{
        if (emptyRequiredFields.includes(fieldId)) return true;
        // handling multi input field errors separately because it contains different error keys
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
        if ((0, $bGrWH.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId]) return emptyRequiredFields.some((key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
            (0, $bGrWH.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId].includes(key));
        return false;
    });
    return undefined;
};
const $7823f1c3d8b410e7$var$fetchIssueListPromise = (jql, fieldsToAddInPublishedData, fetchAllFields)=>{
    if ($7823f1c3d8b410e7$var$activePromises[jql] === undefined) {
        if (fetchAllFields) $7823f1c3d8b410e7$var$activePromises[jql] = (0, $eusud.performPostRequest)($7823f1c3d8b410e7$export$8d7a103b266a4496, {
            body: JSON.stringify({
                jql: jql,
                fields: [
                    ...new Set([
                        '*all'
                    ])
                ]
            })
        });
        else $7823f1c3d8b410e7$var$activePromises[jql] = (0, $eusud.performPostRequest)($7823f1c3d8b410e7$export$8d7a103b266a4496, {
            body: JSON.stringify({
                jql: jql,
                fields: [
                    ...new Set([
                        'summary',
                        'status',
                        'assignee',
                        'duedate',
                        'project',
                        'issuetype',
                        'priority',
                        'issuelinks',
                        ...fieldsToAddInPublishedData
                    ])
                ]
            })
        });
    }
    return $7823f1c3d8b410e7$var$activePromises[jql];
};
const $7823f1c3d8b410e7$var$getIssueList = async (createdIssues, fieldsToAddInPublishedData, fetchAllFields)=>{
    // Get list of issues that have not been fetched before
    const issuesToFetch = createdIssues.filter(({ issueKey: issueKey })=>!$7823f1c3d8b410e7$var$issueDataTillNow[issueKey]);
    let newIssueDetails = {
        issues: []
    };
    if (issuesToFetch.length) {
        // API call is made only if there are issues that needs to be fetched
        const jql = issuesToFetch.reduce((jqlQuery, { issueKey: issueKey }, index)=>`${jqlQuery}issuekey=${issueKey}${index !== issuesToFetch.length - 1 ? ' OR ' : ''}`, '');
        try {
            newIssueDetails = await $7823f1c3d8b410e7$var$fetchIssueListPromise(jql, fieldsToAddInPublishedData, fetchAllFields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'getIssueList',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            $7823f1c3d8b410e7$var$activePromises[jql] = undefined;
        }
    }
    const prefetchedIssueDetails = createdIssues.filter(({ issueKey: issueKey })=>$7823f1c3d8b410e7$var$issueDataTillNow[issueKey]).map(({ issueKey: issueKey })=>$7823f1c3d8b410e7$var$issueDataTillNow[issueKey].createdIssueDetails);
    return {
        issues: [
            ...prefetchedIssueDetails,
            ...newIssueDetails.issues
        ]
    };
};
const $7823f1c3d8b410e7$var$merge = (obj, obj2)=>({
        ...obj,
        ...obj2
    });
const $7823f1c3d8b410e7$export$d46eb3aee2ce61a5 = async ({ createdIssues: createdIssues, globalEventNamespaces: globalEventNamespaces = [
    (0, $bGrWH.GLOBAL_EVENT_NAMESPACE)
], fieldsToAddInPublishedData: fieldsToAddInPublishedData = [], alertsToBeLinked: alertsToBeLinked = [], isSessionComplete: isSessionComplete = false, onIssueCreate: onIssueCreate, siteDomain: siteDomain, selectedCloudId: selectedCloudId, onClose: onClose, triggerPointKey: triggerPointKey, publishGICLifecycle: publishGICLifecycle, isIssueCreateSuccess: isIssueCreateSuccess, callbackPayload: callbackPayload, jqlSwimlaneId: jqlSwimlaneId, ecosystemCallback: ecosystemCallback }, fireErrorAnalytics = (0, $6paOF.fireIssueCreateErrorAnalytics))=>{
    let fetchAllFields = false;
    if (ecosystemCallback && ecosystemCallback.callbackFunction) fetchAllFields = true;
    if (createdIssues.length) {
        /**
		 * We need to unregister the SPA global issue create event handlers so that new issue create can use its
		 * default ones which render the success and error flag in a different place
		 */ let oldFlagUnbindSuccess = false;
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.require('jira/common/header').unbind();
            oldFlagUnbindSuccess = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            oldFlagUnbindSuccess = false;
        }
        try {
            const issueSearchRequest = $7823f1c3d8b410e7$var$getIssueList(createdIssues, fieldsToAddInPublishedData, fetchAllFields);
            const [issueList, Events] = await Promise.all([
                issueSearchRequest,
                (0, $dvqhI.apiReady)()
            ]);
            const issueData = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issueList.issues, 'key');
            const createdIssuesWithIssueData = createdIssues.map((createdIssue)=>{
                const createdIssueDetails = issueData[createdIssue.issueKey];
                const summary = createdIssueDetails?.fields?.summary;
                return {
                    ...createdIssue,
                    summary: summary,
                    createdIssueDetails: createdIssueDetails,
                    selectedCloudId: selectedCloudId,
                    jqlSwimlaneId: jqlSwimlaneId
                };
            });
            $7823f1c3d8b410e7$var$issueDataTillNow = $7823f1c3d8b410e7$var$merge($7823f1c3d8b410e7$var$issueDataTillNow, (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(createdIssuesWithIssueData, 'issueKey'));
            if (isIssueCreateSuccess) // ideally createdIssuesWithIssueData will contain a single element
            createdIssuesWithIssueData.forEach((createdIssue)=>{
                onIssueCreate?.(siteDomain ? {
                    ...createdIssue,
                    siteDomain: siteDomain
                } : createdIssue, alertsToBeLinked);
                publishGICLifecycle?.((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, {
                    createdIssueData: createdIssue,
                    callbackPayload: callbackPayload
                });
            });
            if (isSessionComplete) {
                if (fetchAllFields) (0, $l12V4.executeEcosystemAPICallback)(ecosystemCallback, createdIssuesWithIssueData);
                globalEventNamespaces.forEach((namespace)=>{
                    if (triggerPointKey !== undefined) Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData,
                        triggerPointKey
                    ]);
                    else Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData
                    ]);
                });
                onClose?.(createdIssuesWithIssueData);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireErrorAnalytics({
                meta: {
                    id: 'publishCreatedIssues',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (isSessionComplete) {
            $7823f1c3d8b410e7$var$issueDataTillNow = {};
            $7823f1c3d8b410e7$var$activePromises = {};
        }
        /**
		 * On cleanup we need to re-register the legacy issue create event handlers which will override the
		 * allow non-migrated triggers to show flag
		 */ if (oldFlagUnbindSuccess && isSessionComplete) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.require('jira/common/header').initialize();
    } else if (isSessionComplete) {
        if (fetchAllFields) (0, $l12V4.executeEcosystemAPICallback)(ecosystemCallback, []);
        onClose && onClose([]);
    }
};
const $7823f1c3d8b410e7$export$1d81ee131c803e88 = (fieldTabs, fieldValues, requiredFieldsData)=>{
    if (!fieldValues) return -1;
    const emptyRequiredField = Object.keys(fieldValues)?.find((id)=>requiredFieldsData[id] && Boolean(requiredFieldsData[id].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(fieldValues[id]));
    const tabIndex = fieldTabs?.findIndex((tab)=>tab.items.find((item)=>item === emptyRequiredField));
    return tabIndex > -1 ? tabIndex : -1;
};
const $7823f1c3d8b410e7$export$47ea475ac70a5697 = (response, issueKey, issueType)=>{
    if (response?.errorCollection && response.errorCollection.errorMessages[0]) return {
        type: 'error',
        title: (0, $a1SNr.default).watchersErrorFlagTitle,
        description: response.errorCollection.errorMessages[0],
        messageId: 'issue-create.ui.modal.flag.error.error.watchers-error',
        messageType: 'transactional'
    };
    const getTitle = ()=>{
        if (issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $a1SNr.default).watchersWarningFlagTitleIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $a1SNr.default).watchersWarningFlagTitleIssueTermRefresh;
        return (0, $a1SNr.default).watchersWarningFlagTitle;
    };
    if (response?.warningCollection && response?.warningCollection.warnings[0]) return {
        type: 'warning',
        title: [
            getTitle(),
            {
                issueKey: issueKey,
                issueType: issueType
            }
        ],
        description: response.warningCollection.warnings[0],
        messageId: 'issue-create.ui.modal.flag.warning.warning.watchers-warning',
        messageType: 'transactional'
    };
    return undefined;
};

});
parcelRegister("l12V4", function(module, exports) {

$parcel$export(module.exports, "executeEcosystemAPICallback", () => $82c70d8098d8adb3$export$352b0ab2ba913578);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $bU57W = parcelRequire("bU57W");
const $82c70d8098d8adb3$var$sanitizeIssues = (issuesData)=>{
    const sanitizedIssues = [];
    for (const issueData of issuesData){
        const sanitizedIssue = {
            id: '',
            key: '',
            self: '',
            fields: {}
        };
        const issue = issueData.createdIssueDetails;
        sanitizedIssue.id = issue.id;
        sanitizedIssue.key = issue.key;
        sanitizedIssue.self = issue.self;
        // Convert ADF to Text for all rich text fields
        sanitizedIssue.fields = issue.fields;
        for(const field in sanitizedIssue.fields)if ((0, $bU57W.isAdfObject)(sanitizedIssue.fields[field])) sanitizedIssue.fields[field] = (0, $bU57W.convertAdfToWiki)(sanitizedIssue.fields[field]);
        sanitizedIssues.push(sanitizedIssue);
    }
    return sanitizedIssues;
};
const $82c70d8098d8adb3$export$352b0ab2ba913578 = (ecosystemCallback, issuesData)=>{
    if (ecosystemCallback && ecosystemCallback.callbackFunction) {
        const sanitizedIssues = $82c70d8098d8adb3$var$sanitizeIssues(issuesData);
        ecosystemCallback.callbackFunction.call({}, sanitizedIssues);
    }
};

});
parcelRegister("bU57W", function(module, exports) {

$parcel$export(module.exports, "convertAdfToWiki", () => $cfb4ed7bbd624bae$export$4aa84bff5b13655f);
$parcel$export(module.exports, "isAdfObject", () => $cfb4ed7bbd624bae$export$9acea0de85f3957);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");

var $dN5CS = parcelRequire("dN5CS");
const $cfb4ed7bbd624bae$export$4aa84bff5b13655f = (document)=>{
    try {
        const jsonTransformer = new (0, $hYNZx.JSONTransformer)();
        const wikiMarkupTransformer = new (0, $dN5CS.WikiMarkupTransformer)((0, $kOFhM.defaultSchema));
        if (document === null || document === undefined) return '';
        return wikiMarkupTransformer.encode(jsonTransformer.parse(document));
    } catch (error) {
        // We handle this state by disabling the option to export to markdown.
        return '';
    }
};
const $cfb4ed7bbd624bae$export$9acea0de85f3957 = (field)=>{
    return field && field.type === 'doc' && Array.isArray(field.content);
};

});


parcelRegister("a1SNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffcb1a584fb62af3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ffcb1a584fb62af3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    watchersWarningFlagTitle: {
        "id": "issue-create.modal.watchers-warning-flag-title",
        "defaultMessage": "Watchers not added to your issue"
    },
    watchersErrorFlagTitle: {
        "id": "issue-create.modal.watchers-error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    watchersWarningFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.watchers-warning-flag-title-issue-term-refresh",
        "defaultMessage": "Watchers not added to your work item"
    },
    watchersWarningFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.watchers-warning-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Watchers not added to the {issueType} {issueKey}"
    }
});

});





//# sourceMappingURL=async-jira-issue-create.be65ccb7.js.map
